// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../../node_modules/react-scripts/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./shepherd.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../../node_modules/react-scripts/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./mermaid.min.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/materialdesignicons-webfont.eot?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/materialdesignicons-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/materialdesignicons-webfont.woff2?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/materialdesignicons-webfont.woff?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/materialdesignicons-webfont.ttf?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/boxicons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/boxicons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/boxicons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/boxicons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/boxicons.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/la-brands-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/la-brands-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/la-brands-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/la-brands-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/la-brands-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/la-regular-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/la-regular-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/la-regular-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/la-regular-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/la-regular-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/la-solid-900.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/la-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/la-solid-900.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/la-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/la-solid-900.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/remixicon.eot?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../fonts/remixicon.woff2?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../fonts/remixicon.woff?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../fonts/remixicon.ttf?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../fonts/remixicon.svg?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23363d48%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23ced4da%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28135, 138, 153, 0.55%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2313c56b%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23ed5e5e%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23ed5e5e%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27var%28--vz-body-color%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27var%28--vz-primary-text-emphasis%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23c3d9f3%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("../fonts/hkgrotesk-light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("../fonts/hkgrotesk-light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("../fonts/hkgrotesk-regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("../fonts/hkgrotesk-regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("../fonts/hkgrotesk-medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("../fonts/hkgrotesk-medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("../fonts/hkgrotesk-semibold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("../fonts/hkgrotesk-semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("../fonts/hkgrotesk-bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("../images/sidebar/img-1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("../images/sidebar/img-2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("../images/sidebar/img-3.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("../images/sidebar/img-4.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("../images/modal-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 version=%271.1%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 xmlns:svgjs=%27http://svgjs.com/svgjs%27 width=%271440%27 height=%27560%27 preserveAspectRatio=%27none%27 viewBox=%270 0 1440 560%27%3e%3cg mask=%27url%28%26quot%3b%23SvgjsMask1016%26quot%3b%29%27 fill=%27none%27%3e%3crect width=%271440%27 height=%27560%27 x=%270%27 y=%270%27 fill=%27rgba%2864%2c 81%2c 137%2c 1%29%27%3e%3c/rect%3e%3cpath d=%27M0%2c650.704C122.328%2c648.746%2c159.175%2c473.043%2c255.674%2c397.837C339.724%2c332.333%2c461.529%2c324.924%2c526.449%2c240.421C598.428%2c146.73%2c655.546%2c24.847%2c631.015%2c-90.726C606.666%2c-205.444%2c482.926%2c-263.497%2c401.565%2c-347.958C325.215%2c-427.217%2c275.543%2c-549.012%2c167.826%2c-571.563C60.344%2c-594.065%2c-27.703%2c-482.932%2c-135.163%2c-460.325C-256.336%2c-434.833%2c-401.929%2c-509.651%2c-497.972%2c-431.495C-592.807%2c-354.321%2c-579.865%2c-206.886%2c-595.603%2c-85.635C-611.133%2c34.016%2c-656.761%2c169.183%2c-588.884%2c268.934C-520.854%2c368.909%2c-362.458%2c340.324%2c-260.989%2c406.106C-158.875%2c472.306%2c-121.679%2c652.651%2c0%2c650.704%27 fill=%27%2333416e%27%3e%3c/path%3e%3cpath d=%27M1440 995.672C1519.728 984.741 1563.12 899.779 1626.466 850.1469999999999 1682.6390000000001 806.135 1756.261 782.602 1791.2939999999999 720.431 1827.571 656.052 1835.537 577.6610000000001 1820.814 505.247 1806.518 434.933 1753.2640000000001 383.16999999999996 1710.941 325.228 1664.475 261.614 1634.992 175.16000000000003 1560.657 149.07999999999998 1485.96 122.87299999999999 1402.146 155.543 1332.03 192.289 1269.541 225.038 1232.754 287.251 1189.969 343.347 1149.925 395.849 1115.781 448.9 1089.96 509.672 1056 589.599 988.9680000000001 671.1659999999999 1015.557 753.837 1041.91 835.774 1142.714 863.61 1217.498 906.22 1288.388 946.611 1359.167 1006.755 1440 995.672%27 fill=%27%234d61a4%27%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id=%27SvgjsMask1016%27%3e%3crect width=%271440%27 height=%27560%27 fill=%27white%27%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("../images/flags/us.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_66___ = new URL("../images/avensys-header.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_67___ = new URL("../images/cover-pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_68___ = new URL("../images/nft/marketplace.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_69___ = new URL("../images/chat-bg-pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_70___ = new URL("../images/file.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_71___ = new URL("../images/landing/bg-pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_72___ = new URL("../images/nft/bg-home.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_73___ = new URL("../images/new.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Rubik:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Rubik:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "?#iefix&v=6.5.95" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "?#boxicons" });
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#lineawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#lineawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___, { hash: "#lineawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___, { hash: "#remixicon" });
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_66___);
var ___CSS_LOADER_URL_REPLACEMENT_71___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_67___);
var ___CSS_LOADER_URL_REPLACEMENT_72___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_68___);
var ___CSS_LOADER_URL_REPLACEMENT_73___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_69___);
var ___CSS_LOADER_URL_REPLACEMENT_74___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_70___);
var ___CSS_LOADER_URL_REPLACEMENT_75___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_71___);
var ___CSS_LOADER_URL_REPLACEMENT_76___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_72___);
var ___CSS_LOADER_URL_REPLACEMENT_77___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_73___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
Template Name: Velzon - Admin & Dashboard Template
Author: Themesbrand
Version: 3.0.0
Website: https://Themesbrand.com/
Contact: Themesbrand@gmail.com
File: Icons Css File
*/
/* MaterialDesignIcons.com */
@font-face {
  font-family: "Material Design Icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
.mdi:before,
.mdi-set {
  display: inline-block;
  font: normal normal normal 24px/1 "Material Design Icons";
  font-size: inherit;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.mdi-ab-testing::before {
  content: "󰇉";
}

.mdi-abacus::before {
  content: "󱛠";
}

.mdi-abjad-arabic::before {
  content: "󱌨";
}

.mdi-abjad-hebrew::before {
  content: "󱌩";
}

.mdi-abugida-devanagari::before {
  content: "󱌪";
}

.mdi-abugida-thai::before {
  content: "󱌫";
}

.mdi-access-point::before {
  content: "󰀃";
}

.mdi-access-point-check::before {
  content: "󱔸";
}

.mdi-access-point-minus::before {
  content: "󱔹";
}

.mdi-access-point-network::before {
  content: "󰀂";
}

.mdi-access-point-network-off::before {
  content: "󰯡";
}

.mdi-access-point-off::before {
  content: "󱔑";
}

.mdi-access-point-plus::before {
  content: "󱔺";
}

.mdi-access-point-remove::before {
  content: "󱔻";
}

.mdi-account::before {
  content: "󰀄";
}

.mdi-account-alert::before {
  content: "󰀅";
}

.mdi-account-alert-outline::before {
  content: "󰭐";
}

.mdi-account-arrow-down::before {
  content: "󱡨";
}

.mdi-account-arrow-down-outline::before {
  content: "󱡩";
}

.mdi-account-arrow-left::before {
  content: "󰭑";
}

.mdi-account-arrow-left-outline::before {
  content: "󰭒";
}

.mdi-account-arrow-right::before {
  content: "󰭓";
}

.mdi-account-arrow-right-outline::before {
  content: "󰭔";
}

.mdi-account-arrow-up::before {
  content: "󱡧";
}

.mdi-account-arrow-up-outline::before {
  content: "󱡪";
}

.mdi-account-box::before {
  content: "󰀆";
}

.mdi-account-box-multiple::before {
  content: "󰤴";
}

.mdi-account-box-multiple-outline::before {
  content: "󱀊";
}

.mdi-account-box-outline::before {
  content: "󰀇";
}

.mdi-account-cancel::before {
  content: "󱋟";
}

.mdi-account-cancel-outline::before {
  content: "󱋠";
}

.mdi-account-cash::before {
  content: "󱂗";
}

.mdi-account-cash-outline::before {
  content: "󱂘";
}

.mdi-account-check::before {
  content: "󰀈";
}

.mdi-account-check-outline::before {
  content: "󰯢";
}

.mdi-account-child::before {
  content: "󰪉";
}

.mdi-account-child-circle::before {
  content: "󰪊";
}

.mdi-account-child-outline::before {
  content: "󱃈";
}

.mdi-account-circle::before {
  content: "󰀉";
}

.mdi-account-circle-outline::before {
  content: "󰭕";
}

.mdi-account-clock::before {
  content: "󰭖";
}

.mdi-account-clock-outline::before {
  content: "󰭗";
}

.mdi-account-cog::before {
  content: "󱍰";
}

.mdi-account-cog-outline::before {
  content: "󱍱";
}

.mdi-account-convert::before {
  content: "󰀊";
}

.mdi-account-convert-outline::before {
  content: "󱌁";
}

.mdi-account-cowboy-hat::before {
  content: "󰺛";
}

.mdi-account-cowboy-hat-outline::before {
  content: "󱟳";
}

.mdi-account-details::before {
  content: "󰘱";
}

.mdi-account-details-outline::before {
  content: "󱍲";
}

.mdi-account-edit::before {
  content: "󰚼";
}

.mdi-account-edit-outline::before {
  content: "󰿻";
}

.mdi-account-eye::before {
  content: "󰐠";
}

.mdi-account-eye-outline::before {
  content: "󱉻";
}

.mdi-account-filter::before {
  content: "󰤶";
}

.mdi-account-filter-outline::before {
  content: "󰾝";
}

.mdi-account-group::before {
  content: "󰡉";
}

.mdi-account-group-outline::before {
  content: "󰭘";
}

.mdi-account-hard-hat::before {
  content: "󰖵";
}

.mdi-account-heart::before {
  content: "󰢙";
}

.mdi-account-heart-outline::before {
  content: "󰯣";
}

.mdi-account-injury::before {
  content: "󱠕";
}

.mdi-account-injury-outline::before {
  content: "󱠖";
}

.mdi-account-key::before {
  content: "󰀋";
}

.mdi-account-key-outline::before {
  content: "󰯤";
}

.mdi-account-lock::before {
  content: "󱅞";
}

.mdi-account-lock-open::before {
  content: "󱥠";
}

.mdi-account-lock-open-outline::before {
  content: "󱥡";
}

.mdi-account-lock-outline::before {
  content: "󱅟";
}

.mdi-account-minus::before {
  content: "󰀍";
}

.mdi-account-minus-outline::before {
  content: "󰫬";
}

.mdi-account-multiple::before {
  content: "󰀎";
}

.mdi-account-multiple-check::before {
  content: "󰣅";
}

.mdi-account-multiple-check-outline::before {
  content: "󱇾";
}

.mdi-account-multiple-minus::before {
  content: "󰗓";
}

.mdi-account-multiple-minus-outline::before {
  content: "󰯥";
}

.mdi-account-multiple-outline::before {
  content: "󰀏";
}

.mdi-account-multiple-plus::before {
  content: "󰀐";
}

.mdi-account-multiple-plus-outline::before {
  content: "󰠀";
}

.mdi-account-multiple-remove::before {
  content: "󱈊";
}

.mdi-account-multiple-remove-outline::before {
  content: "󱈋";
}

.mdi-account-music::before {
  content: "󰠃";
}

.mdi-account-music-outline::before {
  content: "󰳩";
}

.mdi-account-network::before {
  content: "󰀑";
}

.mdi-account-network-outline::before {
  content: "󰯦";
}

.mdi-account-off::before {
  content: "󰀒";
}

.mdi-account-off-outline::before {
  content: "󰯧";
}

.mdi-account-outline::before {
  content: "󰀓";
}

.mdi-account-plus::before {
  content: "󰀔";
}

.mdi-account-plus-outline::before {
  content: "󰠁";
}

.mdi-account-question::before {
  content: "󰭙";
}

.mdi-account-question-outline::before {
  content: "󰭚";
}

.mdi-account-reactivate::before {
  content: "󱔫";
}

.mdi-account-reactivate-outline::before {
  content: "󱔬";
}

.mdi-account-remove::before {
  content: "󰀕";
}

.mdi-account-remove-outline::before {
  content: "󰫭";
}

.mdi-account-search::before {
  content: "󰀖";
}

.mdi-account-search-outline::before {
  content: "󰤵";
}

.mdi-account-settings::before {
  content: "󰘰";
}

.mdi-account-settings-outline::before {
  content: "󱃉";
}

.mdi-account-star::before {
  content: "󰀗";
}

.mdi-account-star-outline::before {
  content: "󰯨";
}

.mdi-account-supervisor::before {
  content: "󰪋";
}

.mdi-account-supervisor-circle::before {
  content: "󰪌";
}

.mdi-account-supervisor-circle-outline::before {
  content: "󱓬";
}

.mdi-account-supervisor-outline::before {
  content: "󱄭";
}

.mdi-account-switch::before {
  content: "󰀙";
}

.mdi-account-switch-outline::before {
  content: "󰓋";
}

.mdi-account-sync::before {
  content: "󱤛";
}

.mdi-account-sync-outline::before {
  content: "󱤜";
}

.mdi-account-tie::before {
  content: "󰳣";
}

.mdi-account-tie-hat::before {
  content: "󱢘";
}

.mdi-account-tie-hat-outline::before {
  content: "󱢙";
}

.mdi-account-tie-outline::before {
  content: "󱃊";
}

.mdi-account-tie-voice::before {
  content: "󱌈";
}

.mdi-account-tie-voice-off::before {
  content: "󱌊";
}

.mdi-account-tie-voice-off-outline::before {
  content: "󱌋";
}

.mdi-account-tie-voice-outline::before {
  content: "󱌉";
}

.mdi-account-voice::before {
  content: "󰗋";
}

.mdi-account-voice-off::before {
  content: "󰻔";
}

.mdi-account-wrench::before {
  content: "󱢚";
}

.mdi-account-wrench-outline::before {
  content: "󱢛";
}

.mdi-adjust::before {
  content: "󰀚";
}

.mdi-advertisements::before {
  content: "󱤪";
}

.mdi-advertisements-off::before {
  content: "󱤫";
}

.mdi-air-conditioner::before {
  content: "󰀛";
}

.mdi-air-filter::before {
  content: "󰵃";
}

.mdi-air-horn::before {
  content: "󰶬";
}

.mdi-air-humidifier::before {
  content: "󱂙";
}

.mdi-air-humidifier-off::before {
  content: "󱑦";
}

.mdi-air-purifier::before {
  content: "󰵄";
}

.mdi-airbag::before {
  content: "󰯩";
}

.mdi-airballoon::before {
  content: "󰀜";
}

.mdi-airballoon-outline::before {
  content: "󱀋";
}

.mdi-airplane::before {
  content: "󰀝";
}

.mdi-airplane-alert::before {
  content: "󱡺";
}

.mdi-airplane-check::before {
  content: "󱡻";
}

.mdi-airplane-clock::before {
  content: "󱡼";
}

.mdi-airplane-cog::before {
  content: "󱡽";
}

.mdi-airplane-edit::before {
  content: "󱡾";
}

.mdi-airplane-landing::before {
  content: "󰗔";
}

.mdi-airplane-marker::before {
  content: "󱡿";
}

.mdi-airplane-minus::before {
  content: "󱢀";
}

.mdi-airplane-off::before {
  content: "󰀞";
}

.mdi-airplane-plus::before {
  content: "󱢁";
}

.mdi-airplane-remove::before {
  content: "󱢂";
}

.mdi-airplane-search::before {
  content: "󱢃";
}

.mdi-airplane-settings::before {
  content: "󱢄";
}

.mdi-airplane-takeoff::before {
  content: "󰗕";
}

.mdi-airport::before {
  content: "󰡋";
}

.mdi-alarm::before {
  content: "󰀠";
}

.mdi-alarm-bell::before {
  content: "󰞎";
}

.mdi-alarm-check::before {
  content: "󰀡";
}

.mdi-alarm-light::before {
  content: "󰞏";
}

.mdi-alarm-light-off::before {
  content: "󱜞";
}

.mdi-alarm-light-off-outline::before {
  content: "󱜟";
}

.mdi-alarm-light-outline::before {
  content: "󰯪";
}

.mdi-alarm-multiple::before {
  content: "󰀢";
}

.mdi-alarm-note::before {
  content: "󰹱";
}

.mdi-alarm-note-off::before {
  content: "󰹲";
}

.mdi-alarm-off::before {
  content: "󰀣";
}

.mdi-alarm-panel::before {
  content: "󱗄";
}

.mdi-alarm-panel-outline::before {
  content: "󱗅";
}

.mdi-alarm-plus::before {
  content: "󰀤";
}

.mdi-alarm-snooze::before {
  content: "󰚎";
}

.mdi-album::before {
  content: "󰀥";
}

.mdi-alert::before {
  content: "󰀦";
}

.mdi-alert-box::before {
  content: "󰀧";
}

.mdi-alert-box-outline::before {
  content: "󰳤";
}

.mdi-alert-circle::before {
  content: "󰀨";
}

.mdi-alert-circle-check::before {
  content: "󱇭";
}

.mdi-alert-circle-check-outline::before {
  content: "󱇮";
}

.mdi-alert-circle-outline::before {
  content: "󰗖";
}

.mdi-alert-decagram::before {
  content: "󰚽";
}

.mdi-alert-decagram-outline::before {
  content: "󰳥";
}

.mdi-alert-minus::before {
  content: "󱒻";
}

.mdi-alert-minus-outline::before {
  content: "󱒾";
}

.mdi-alert-octagon::before {
  content: "󰀩";
}

.mdi-alert-octagon-outline::before {
  content: "󰳦";
}

.mdi-alert-octagram::before {
  content: "󰝧";
}

.mdi-alert-octagram-outline::before {
  content: "󰳧";
}

.mdi-alert-outline::before {
  content: "󰀪";
}

.mdi-alert-plus::before {
  content: "󱒺";
}

.mdi-alert-plus-outline::before {
  content: "󱒽";
}

.mdi-alert-remove::before {
  content: "󱒼";
}

.mdi-alert-remove-outline::before {
  content: "󱒿";
}

.mdi-alert-rhombus::before {
  content: "󱇎";
}

.mdi-alert-rhombus-outline::before {
  content: "󱇏";
}

.mdi-alien::before {
  content: "󰢚";
}

.mdi-alien-outline::before {
  content: "󱃋";
}

.mdi-align-horizontal-center::before {
  content: "󱇃";
}

.mdi-align-horizontal-distribute::before {
  content: "󱥢";
}

.mdi-align-horizontal-left::before {
  content: "󱇂";
}

.mdi-align-horizontal-right::before {
  content: "󱇄";
}

.mdi-align-vertical-bottom::before {
  content: "󱇅";
}

.mdi-align-vertical-center::before {
  content: "󱇆";
}

.mdi-align-vertical-distribute::before {
  content: "󱥣";
}

.mdi-align-vertical-top::before {
  content: "󱇇";
}

.mdi-all-inclusive::before {
  content: "󰚾";
}

.mdi-all-inclusive-box::before {
  content: "󱢍";
}

.mdi-all-inclusive-box-outline::before {
  content: "󱢎";
}

.mdi-allergy::before {
  content: "󱉘";
}

.mdi-alpha::before {
  content: "󰀫";
}

.mdi-alpha-a::before {
  content: "󰫮";
}

.mdi-alpha-a-box::before {
  content: "󰬈";
}

.mdi-alpha-a-box-outline::before {
  content: "󰯫";
}

.mdi-alpha-a-circle::before {
  content: "󰯬";
}

.mdi-alpha-a-circle-outline::before {
  content: "󰯭";
}

.mdi-alpha-b::before {
  content: "󰫯";
}

.mdi-alpha-b-box::before {
  content: "󰬉";
}

.mdi-alpha-b-box-outline::before {
  content: "󰯮";
}

.mdi-alpha-b-circle::before {
  content: "󰯯";
}

.mdi-alpha-b-circle-outline::before {
  content: "󰯰";
}

.mdi-alpha-c::before {
  content: "󰫰";
}

.mdi-alpha-c-box::before {
  content: "󰬊";
}

.mdi-alpha-c-box-outline::before {
  content: "󰯱";
}

.mdi-alpha-c-circle::before {
  content: "󰯲";
}

.mdi-alpha-c-circle-outline::before {
  content: "󰯳";
}

.mdi-alpha-d::before {
  content: "󰫱";
}

.mdi-alpha-d-box::before {
  content: "󰬋";
}

.mdi-alpha-d-box-outline::before {
  content: "󰯴";
}

.mdi-alpha-d-circle::before {
  content: "󰯵";
}

.mdi-alpha-d-circle-outline::before {
  content: "󰯶";
}

.mdi-alpha-e::before {
  content: "󰫲";
}

.mdi-alpha-e-box::before {
  content: "󰬌";
}

.mdi-alpha-e-box-outline::before {
  content: "󰯷";
}

.mdi-alpha-e-circle::before {
  content: "󰯸";
}

.mdi-alpha-e-circle-outline::before {
  content: "󰯹";
}

.mdi-alpha-f::before {
  content: "󰫳";
}

.mdi-alpha-f-box::before {
  content: "󰬍";
}

.mdi-alpha-f-box-outline::before {
  content: "󰯺";
}

.mdi-alpha-f-circle::before {
  content: "󰯻";
}

.mdi-alpha-f-circle-outline::before {
  content: "󰯼";
}

.mdi-alpha-g::before {
  content: "󰫴";
}

.mdi-alpha-g-box::before {
  content: "󰬎";
}

.mdi-alpha-g-box-outline::before {
  content: "󰯽";
}

.mdi-alpha-g-circle::before {
  content: "󰯾";
}

.mdi-alpha-g-circle-outline::before {
  content: "󰯿";
}

.mdi-alpha-h::before {
  content: "󰫵";
}

.mdi-alpha-h-box::before {
  content: "󰬏";
}

.mdi-alpha-h-box-outline::before {
  content: "󰰀";
}

.mdi-alpha-h-circle::before {
  content: "󰰁";
}

.mdi-alpha-h-circle-outline::before {
  content: "󰰂";
}

.mdi-alpha-i::before {
  content: "󰫶";
}

.mdi-alpha-i-box::before {
  content: "󰬐";
}

.mdi-alpha-i-box-outline::before {
  content: "󰰃";
}

.mdi-alpha-i-circle::before {
  content: "󰰄";
}

.mdi-alpha-i-circle-outline::before {
  content: "󰰅";
}

.mdi-alpha-j::before {
  content: "󰫷";
}

.mdi-alpha-j-box::before {
  content: "󰬑";
}

.mdi-alpha-j-box-outline::before {
  content: "󰰆";
}

.mdi-alpha-j-circle::before {
  content: "󰰇";
}

.mdi-alpha-j-circle-outline::before {
  content: "󰰈";
}

.mdi-alpha-k::before {
  content: "󰫸";
}

.mdi-alpha-k-box::before {
  content: "󰬒";
}

.mdi-alpha-k-box-outline::before {
  content: "󰰉";
}

.mdi-alpha-k-circle::before {
  content: "󰰊";
}

.mdi-alpha-k-circle-outline::before {
  content: "󰰋";
}

.mdi-alpha-l::before {
  content: "󰫹";
}

.mdi-alpha-l-box::before {
  content: "󰬓";
}

.mdi-alpha-l-box-outline::before {
  content: "󰰌";
}

.mdi-alpha-l-circle::before {
  content: "󰰍";
}

.mdi-alpha-l-circle-outline::before {
  content: "󰰎";
}

.mdi-alpha-m::before {
  content: "󰫺";
}

.mdi-alpha-m-box::before {
  content: "󰬔";
}

.mdi-alpha-m-box-outline::before {
  content: "󰰏";
}

.mdi-alpha-m-circle::before {
  content: "󰰐";
}

.mdi-alpha-m-circle-outline::before {
  content: "󰰑";
}

.mdi-alpha-n::before {
  content: "󰫻";
}

.mdi-alpha-n-box::before {
  content: "󰬕";
}

.mdi-alpha-n-box-outline::before {
  content: "󰰒";
}

.mdi-alpha-n-circle::before {
  content: "󰰓";
}

.mdi-alpha-n-circle-outline::before {
  content: "󰰔";
}

.mdi-alpha-o::before {
  content: "󰫼";
}

.mdi-alpha-o-box::before {
  content: "󰬖";
}

.mdi-alpha-o-box-outline::before {
  content: "󰰕";
}

.mdi-alpha-o-circle::before {
  content: "󰰖";
}

.mdi-alpha-o-circle-outline::before {
  content: "󰰗";
}

.mdi-alpha-p::before {
  content: "󰫽";
}

.mdi-alpha-p-box::before {
  content: "󰬗";
}

.mdi-alpha-p-box-outline::before {
  content: "󰰘";
}

.mdi-alpha-p-circle::before {
  content: "󰰙";
}

.mdi-alpha-p-circle-outline::before {
  content: "󰰚";
}

.mdi-alpha-q::before {
  content: "󰫾";
}

.mdi-alpha-q-box::before {
  content: "󰬘";
}

.mdi-alpha-q-box-outline::before {
  content: "󰰛";
}

.mdi-alpha-q-circle::before {
  content: "󰰜";
}

.mdi-alpha-q-circle-outline::before {
  content: "󰰝";
}

.mdi-alpha-r::before {
  content: "󰫿";
}

.mdi-alpha-r-box::before {
  content: "󰬙";
}

.mdi-alpha-r-box-outline::before {
  content: "󰰞";
}

.mdi-alpha-r-circle::before {
  content: "󰰟";
}

.mdi-alpha-r-circle-outline::before {
  content: "󰰠";
}

.mdi-alpha-s::before {
  content: "󰬀";
}

.mdi-alpha-s-box::before {
  content: "󰬚";
}

.mdi-alpha-s-box-outline::before {
  content: "󰰡";
}

.mdi-alpha-s-circle::before {
  content: "󰰢";
}

.mdi-alpha-s-circle-outline::before {
  content: "󰰣";
}

.mdi-alpha-t::before {
  content: "󰬁";
}

.mdi-alpha-t-box::before {
  content: "󰬛";
}

.mdi-alpha-t-box-outline::before {
  content: "󰰤";
}

.mdi-alpha-t-circle::before {
  content: "󰰥";
}

.mdi-alpha-t-circle-outline::before {
  content: "󰰦";
}

.mdi-alpha-u::before {
  content: "󰬂";
}

.mdi-alpha-u-box::before {
  content: "󰬜";
}

.mdi-alpha-u-box-outline::before {
  content: "󰰧";
}

.mdi-alpha-u-circle::before {
  content: "󰰨";
}

.mdi-alpha-u-circle-outline::before {
  content: "󰰩";
}

.mdi-alpha-v::before {
  content: "󰬃";
}

.mdi-alpha-v-box::before {
  content: "󰬝";
}

.mdi-alpha-v-box-outline::before {
  content: "󰰪";
}

.mdi-alpha-v-circle::before {
  content: "󰰫";
}

.mdi-alpha-v-circle-outline::before {
  content: "󰰬";
}

.mdi-alpha-w::before {
  content: "󰬄";
}

.mdi-alpha-w-box::before {
  content: "󰬞";
}

.mdi-alpha-w-box-outline::before {
  content: "󰰭";
}

.mdi-alpha-w-circle::before {
  content: "󰰮";
}

.mdi-alpha-w-circle-outline::before {
  content: "󰰯";
}

.mdi-alpha-x::before {
  content: "󰬅";
}

.mdi-alpha-x-box::before {
  content: "󰬟";
}

.mdi-alpha-x-box-outline::before {
  content: "󰰰";
}

.mdi-alpha-x-circle::before {
  content: "󰰱";
}

.mdi-alpha-x-circle-outline::before {
  content: "󰰲";
}

.mdi-alpha-y::before {
  content: "󰬆";
}

.mdi-alpha-y-box::before {
  content: "󰬠";
}

.mdi-alpha-y-box-outline::before {
  content: "󰰳";
}

.mdi-alpha-y-circle::before {
  content: "󰰴";
}

.mdi-alpha-y-circle-outline::before {
  content: "󰰵";
}

.mdi-alpha-z::before {
  content: "󰬇";
}

.mdi-alpha-z-box::before {
  content: "󰬡";
}

.mdi-alpha-z-box-outline::before {
  content: "󰰶";
}

.mdi-alpha-z-circle::before {
  content: "󰰷";
}

.mdi-alpha-z-circle-outline::before {
  content: "󰰸";
}

.mdi-alphabet-aurebesh::before {
  content: "󱌬";
}

.mdi-alphabet-cyrillic::before {
  content: "󱌭";
}

.mdi-alphabet-greek::before {
  content: "󱌮";
}

.mdi-alphabet-latin::before {
  content: "󱌯";
}

.mdi-alphabet-piqad::before {
  content: "󱌰";
}

.mdi-alphabet-tengwar::before {
  content: "󱌷";
}

.mdi-alphabetical::before {
  content: "󰀬";
}

.mdi-alphabetical-off::before {
  content: "󱀌";
}

.mdi-alphabetical-variant::before {
  content: "󱀍";
}

.mdi-alphabetical-variant-off::before {
  content: "󱀎";
}

.mdi-altimeter::before {
  content: "󰗗";
}

.mdi-ambulance::before {
  content: "󰀯";
}

.mdi-ammunition::before {
  content: "󰳨";
}

.mdi-ampersand::before {
  content: "󰪍";
}

.mdi-amplifier::before {
  content: "󰀰";
}

.mdi-amplifier-off::before {
  content: "󱆵";
}

.mdi-anchor::before {
  content: "󰀱";
}

.mdi-android::before {
  content: "󰀲";
}

.mdi-android-messages::before {
  content: "󰵅";
}

.mdi-android-studio::before {
  content: "󰀴";
}

.mdi-angle-acute::before {
  content: "󰤷";
}

.mdi-angle-obtuse::before {
  content: "󰤸";
}

.mdi-angle-right::before {
  content: "󰤹";
}

.mdi-angular::before {
  content: "󰚲";
}

.mdi-angularjs::before {
  content: "󰚿";
}

.mdi-animation::before {
  content: "󰗘";
}

.mdi-animation-outline::before {
  content: "󰪏";
}

.mdi-animation-play::before {
  content: "󰤺";
}

.mdi-animation-play-outline::before {
  content: "󰪐";
}

.mdi-ansible::before {
  content: "󱂚";
}

.mdi-antenna::before {
  content: "󱄙";
}

.mdi-anvil::before {
  content: "󰢛";
}

.mdi-apache-kafka::before {
  content: "󱀏";
}

.mdi-api::before {
  content: "󱂛";
}

.mdi-api-off::before {
  content: "󱉗";
}

.mdi-apple::before {
  content: "󰀵";
}

.mdi-apple-finder::before {
  content: "󰀶";
}

.mdi-apple-icloud::before {
  content: "󰀸";
}

.mdi-apple-ios::before {
  content: "󰀷";
}

.mdi-apple-keyboard-caps::before {
  content: "󰘲";
}

.mdi-apple-keyboard-command::before {
  content: "󰘳";
}

.mdi-apple-keyboard-control::before {
  content: "󰘴";
}

.mdi-apple-keyboard-option::before {
  content: "󰘵";
}

.mdi-apple-keyboard-shift::before {
  content: "󰘶";
}

.mdi-apple-safari::before {
  content: "󰀹";
}

.mdi-application::before {
  content: "󰣆";
}

.mdi-application-array::before {
  content: "󱃵";
}

.mdi-application-array-outline::before {
  content: "󱃶";
}

.mdi-application-braces::before {
  content: "󱃷";
}

.mdi-application-braces-outline::before {
  content: "󱃸";
}

.mdi-application-brackets::before {
  content: "󰲋";
}

.mdi-application-brackets-outline::before {
  content: "󰲌";
}

.mdi-application-cog::before {
  content: "󰙵";
}

.mdi-application-cog-outline::before {
  content: "󱕷";
}

.mdi-application-edit::before {
  content: "󰂮";
}

.mdi-application-edit-outline::before {
  content: "󰘙";
}

.mdi-application-export::before {
  content: "󰶭";
}

.mdi-application-import::before {
  content: "󰶮";
}

.mdi-application-outline::before {
  content: "󰘔";
}

.mdi-application-parentheses::before {
  content: "󱃹";
}

.mdi-application-parentheses-outline::before {
  content: "󱃺";
}

.mdi-application-settings::before {
  content: "󰭠";
}

.mdi-application-settings-outline::before {
  content: "󱕕";
}

.mdi-application-variable::before {
  content: "󱃻";
}

.mdi-application-variable-outline::before {
  content: "󱃼";
}

.mdi-approximately-equal::before {
  content: "󰾞";
}

.mdi-approximately-equal-box::before {
  content: "󰾟";
}

.mdi-apps::before {
  content: "󰀻";
}

.mdi-apps-box::before {
  content: "󰵆";
}

.mdi-arch::before {
  content: "󰣇";
}

.mdi-archive::before {
  content: "󰀼";
}

.mdi-archive-alert::before {
  content: "󱓽";
}

.mdi-archive-alert-outline::before {
  content: "󱓾";
}

.mdi-archive-arrow-down::before {
  content: "󱉙";
}

.mdi-archive-arrow-down-outline::before {
  content: "󱉚";
}

.mdi-archive-arrow-up::before {
  content: "󱉛";
}

.mdi-archive-arrow-up-outline::before {
  content: "󱉜";
}

.mdi-archive-cancel::before {
  content: "󱝋";
}

.mdi-archive-cancel-outline::before {
  content: "󱝌";
}

.mdi-archive-check::before {
  content: "󱝍";
}

.mdi-archive-check-outline::before {
  content: "󱝎";
}

.mdi-archive-clock::before {
  content: "󱝏";
}

.mdi-archive-clock-outline::before {
  content: "󱝐";
}

.mdi-archive-cog::before {
  content: "󱝑";
}

.mdi-archive-cog-outline::before {
  content: "󱝒";
}

.mdi-archive-edit::before {
  content: "󱝓";
}

.mdi-archive-edit-outline::before {
  content: "󱝔";
}

.mdi-archive-eye::before {
  content: "󱝕";
}

.mdi-archive-eye-outline::before {
  content: "󱝖";
}

.mdi-archive-lock::before {
  content: "󱝗";
}

.mdi-archive-lock-open::before {
  content: "󱝘";
}

.mdi-archive-lock-open-outline::before {
  content: "󱝙";
}

.mdi-archive-lock-outline::before {
  content: "󱝚";
}

.mdi-archive-marker::before {
  content: "󱝛";
}

.mdi-archive-marker-outline::before {
  content: "󱝜";
}

.mdi-archive-minus::before {
  content: "󱝝";
}

.mdi-archive-minus-outline::before {
  content: "󱝞";
}

.mdi-archive-music::before {
  content: "󱝟";
}

.mdi-archive-music-outline::before {
  content: "󱝠";
}

.mdi-archive-off::before {
  content: "󱝡";
}

.mdi-archive-off-outline::before {
  content: "󱝢";
}

.mdi-archive-outline::before {
  content: "󱈎";
}

.mdi-archive-plus::before {
  content: "󱝣";
}

.mdi-archive-plus-outline::before {
  content: "󱝤";
}

.mdi-archive-refresh::before {
  content: "󱝥";
}

.mdi-archive-refresh-outline::before {
  content: "󱝦";
}

.mdi-archive-remove::before {
  content: "󱝧";
}

.mdi-archive-remove-outline::before {
  content: "󱝨";
}

.mdi-archive-search::before {
  content: "󱝩";
}

.mdi-archive-search-outline::before {
  content: "󱝪";
}

.mdi-archive-settings::before {
  content: "󱝫";
}

.mdi-archive-settings-outline::before {
  content: "󱝬";
}

.mdi-archive-star::before {
  content: "󱝭";
}

.mdi-archive-star-outline::before {
  content: "󱝮";
}

.mdi-archive-sync::before {
  content: "󱝯";
}

.mdi-archive-sync-outline::before {
  content: "󱝰";
}

.mdi-arm-flex::before {
  content: "󰿗";
}

.mdi-arm-flex-outline::before {
  content: "󰿖";
}

.mdi-arrange-bring-forward::before {
  content: "󰀽";
}

.mdi-arrange-bring-to-front::before {
  content: "󰀾";
}

.mdi-arrange-send-backward::before {
  content: "󰀿";
}

.mdi-arrange-send-to-back::before {
  content: "󰁀";
}

.mdi-arrow-all::before {
  content: "󰁁";
}

.mdi-arrow-bottom-left::before {
  content: "󰁂";
}

.mdi-arrow-bottom-left-bold-box::before {
  content: "󱥤";
}

.mdi-arrow-bottom-left-bold-box-outline::before {
  content: "󱥥";
}

.mdi-arrow-bottom-left-bold-outline::before {
  content: "󰦷";
}

.mdi-arrow-bottom-left-thick::before {
  content: "󰦸";
}

.mdi-arrow-bottom-left-thin::before {
  content: "󱦶";
}

.mdi-arrow-bottom-left-thin-circle-outline::before {
  content: "󱖖";
}

.mdi-arrow-bottom-right::before {
  content: "󰁃";
}

.mdi-arrow-bottom-right-bold-box::before {
  content: "󱥦";
}

.mdi-arrow-bottom-right-bold-box-outline::before {
  content: "󱥧";
}

.mdi-arrow-bottom-right-bold-outline::before {
  content: "󰦹";
}

.mdi-arrow-bottom-right-thick::before {
  content: "󰦺";
}

.mdi-arrow-bottom-right-thin::before {
  content: "󱦷";
}

.mdi-arrow-bottom-right-thin-circle-outline::before {
  content: "󱖕";
}

.mdi-arrow-collapse::before {
  content: "󰘕";
}

.mdi-arrow-collapse-all::before {
  content: "󰁄";
}

.mdi-arrow-collapse-down::before {
  content: "󰞒";
}

.mdi-arrow-collapse-horizontal::before {
  content: "󰡌";
}

.mdi-arrow-collapse-left::before {
  content: "󰞓";
}

.mdi-arrow-collapse-right::before {
  content: "󰞔";
}

.mdi-arrow-collapse-up::before {
  content: "󰞕";
}

.mdi-arrow-collapse-vertical::before {
  content: "󰡍";
}

.mdi-arrow-decision::before {
  content: "󰦻";
}

.mdi-arrow-decision-auto::before {
  content: "󰦼";
}

.mdi-arrow-decision-auto-outline::before {
  content: "󰦽";
}

.mdi-arrow-decision-outline::before {
  content: "󰦾";
}

.mdi-arrow-down::before {
  content: "󰁅";
}

.mdi-arrow-down-bold::before {
  content: "󰜮";
}

.mdi-arrow-down-bold-box::before {
  content: "󰜯";
}

.mdi-arrow-down-bold-box-outline::before {
  content: "󰜰";
}

.mdi-arrow-down-bold-circle::before {
  content: "󰁇";
}

.mdi-arrow-down-bold-circle-outline::before {
  content: "󰁈";
}

.mdi-arrow-down-bold-hexagon-outline::before {
  content: "󰁉";
}

.mdi-arrow-down-bold-outline::before {
  content: "󰦿";
}

.mdi-arrow-down-box::before {
  content: "󰛀";
}

.mdi-arrow-down-circle::before {
  content: "󰳛";
}

.mdi-arrow-down-circle-outline::before {
  content: "󰳜";
}

.mdi-arrow-down-drop-circle::before {
  content: "󰁊";
}

.mdi-arrow-down-drop-circle-outline::before {
  content: "󰁋";
}

.mdi-arrow-down-left::before {
  content: "󱞡";
}

.mdi-arrow-down-left-bold::before {
  content: "󱞢";
}

.mdi-arrow-down-right::before {
  content: "󱞣";
}

.mdi-arrow-down-right-bold::before {
  content: "󱞤";
}

.mdi-arrow-down-thick::before {
  content: "󰁆";
}

.mdi-arrow-down-thin::before {
  content: "󱦳";
}

.mdi-arrow-down-thin-circle-outline::before {
  content: "󱖙";
}

.mdi-arrow-expand::before {
  content: "󰘖";
}

.mdi-arrow-expand-all::before {
  content: "󰁌";
}

.mdi-arrow-expand-down::before {
  content: "󰞖";
}

.mdi-arrow-expand-horizontal::before {
  content: "󰡎";
}

.mdi-arrow-expand-left::before {
  content: "󰞗";
}

.mdi-arrow-expand-right::before {
  content: "󰞘";
}

.mdi-arrow-expand-up::before {
  content: "󰞙";
}

.mdi-arrow-expand-vertical::before {
  content: "󰡏";
}

.mdi-arrow-horizontal-lock::before {
  content: "󱅛";
}

.mdi-arrow-left::before {
  content: "󰁍";
}

.mdi-arrow-left-bold::before {
  content: "󰜱";
}

.mdi-arrow-left-bold-box::before {
  content: "󰜲";
}

.mdi-arrow-left-bold-box-outline::before {
  content: "󰜳";
}

.mdi-arrow-left-bold-circle::before {
  content: "󰁏";
}

.mdi-arrow-left-bold-circle-outline::before {
  content: "󰁐";
}

.mdi-arrow-left-bold-hexagon-outline::before {
  content: "󰁑";
}

.mdi-arrow-left-bold-outline::before {
  content: "󰧀";
}

.mdi-arrow-left-bottom::before {
  content: "󱞥";
}

.mdi-arrow-left-bottom-bold::before {
  content: "󱞦";
}

.mdi-arrow-left-box::before {
  content: "󰛁";
}

.mdi-arrow-left-circle::before {
  content: "󰳝";
}

.mdi-arrow-left-circle-outline::before {
  content: "󰳞";
}

.mdi-arrow-left-drop-circle::before {
  content: "󰁒";
}

.mdi-arrow-left-drop-circle-outline::before {
  content: "󰁓";
}

.mdi-arrow-left-right::before {
  content: "󰹳";
}

.mdi-arrow-left-right-bold::before {
  content: "󰹴";
}

.mdi-arrow-left-right-bold-outline::before {
  content: "󰧁";
}

.mdi-arrow-left-thick::before {
  content: "󰁎";
}

.mdi-arrow-left-thin::before {
  content: "󱦱";
}

.mdi-arrow-left-thin-circle-outline::before {
  content: "󱖚";
}

.mdi-arrow-left-top::before {
  content: "󱞧";
}

.mdi-arrow-left-top-bold::before {
  content: "󱞨";
}

.mdi-arrow-projectile::before {
  content: "󱡀";
}

.mdi-arrow-projectile-multiple::before {
  content: "󱠿";
}

.mdi-arrow-right::before {
  content: "󰁔";
}

.mdi-arrow-right-bold::before {
  content: "󰜴";
}

.mdi-arrow-right-bold-box::before {
  content: "󰜵";
}

.mdi-arrow-right-bold-box-outline::before {
  content: "󰜶";
}

.mdi-arrow-right-bold-circle::before {
  content: "󰁖";
}

.mdi-arrow-right-bold-circle-outline::before {
  content: "󰁗";
}

.mdi-arrow-right-bold-hexagon-outline::before {
  content: "󰁘";
}

.mdi-arrow-right-bold-outline::before {
  content: "󰧂";
}

.mdi-arrow-right-bottom::before {
  content: "󱞩";
}

.mdi-arrow-right-bottom-bold::before {
  content: "󱞪";
}

.mdi-arrow-right-box::before {
  content: "󰛂";
}

.mdi-arrow-right-circle::before {
  content: "󰳟";
}

.mdi-arrow-right-circle-outline::before {
  content: "󰳠";
}

.mdi-arrow-right-drop-circle::before {
  content: "󰁙";
}

.mdi-arrow-right-drop-circle-outline::before {
  content: "󰁚";
}

.mdi-arrow-right-thick::before {
  content: "󰁕";
}

.mdi-arrow-right-thin::before {
  content: "󱦰";
}

.mdi-arrow-right-thin-circle-outline::before {
  content: "󱖘";
}

.mdi-arrow-right-top::before {
  content: "󱞫";
}

.mdi-arrow-right-top-bold::before {
  content: "󱞬";
}

.mdi-arrow-split-horizontal::before {
  content: "󰤻";
}

.mdi-arrow-split-vertical::before {
  content: "󰤼";
}

.mdi-arrow-top-left::before {
  content: "󰁛";
}

.mdi-arrow-top-left-bold-box::before {
  content: "󱥨";
}

.mdi-arrow-top-left-bold-box-outline::before {
  content: "󱥩";
}

.mdi-arrow-top-left-bold-outline::before {
  content: "󰧃";
}

.mdi-arrow-top-left-bottom-right::before {
  content: "󰹵";
}

.mdi-arrow-top-left-bottom-right-bold::before {
  content: "󰹶";
}

.mdi-arrow-top-left-thick::before {
  content: "󰧄";
}

.mdi-arrow-top-left-thin::before {
  content: "󱦵";
}

.mdi-arrow-top-left-thin-circle-outline::before {
  content: "󱖓";
}

.mdi-arrow-top-right::before {
  content: "󰁜";
}

.mdi-arrow-top-right-bold-box::before {
  content: "󱥪";
}

.mdi-arrow-top-right-bold-box-outline::before {
  content: "󱥫";
}

.mdi-arrow-top-right-bold-outline::before {
  content: "󰧅";
}

.mdi-arrow-top-right-bottom-left::before {
  content: "󰹷";
}

.mdi-arrow-top-right-bottom-left-bold::before {
  content: "󰹸";
}

.mdi-arrow-top-right-thick::before {
  content: "󰧆";
}

.mdi-arrow-top-right-thin::before {
  content: "󱦴";
}

.mdi-arrow-top-right-thin-circle-outline::before {
  content: "󱖔";
}

.mdi-arrow-u-down-left::before {
  content: "󱞭";
}

.mdi-arrow-u-down-left-bold::before {
  content: "󱞮";
}

.mdi-arrow-u-down-right::before {
  content: "󱞯";
}

.mdi-arrow-u-down-right-bold::before {
  content: "󱞰";
}

.mdi-arrow-u-left-bottom::before {
  content: "󱞱";
}

.mdi-arrow-u-left-bottom-bold::before {
  content: "󱞲";
}

.mdi-arrow-u-left-top::before {
  content: "󱞳";
}

.mdi-arrow-u-left-top-bold::before {
  content: "󱞴";
}

.mdi-arrow-u-right-bottom::before {
  content: "󱞵";
}

.mdi-arrow-u-right-bottom-bold::before {
  content: "󱞶";
}

.mdi-arrow-u-right-top::before {
  content: "󱞷";
}

.mdi-arrow-u-right-top-bold::before {
  content: "󱞸";
}

.mdi-arrow-u-up-left::before {
  content: "󱞹";
}

.mdi-arrow-u-up-left-bold::before {
  content: "󱞺";
}

.mdi-arrow-u-up-right::before {
  content: "󱞻";
}

.mdi-arrow-u-up-right-bold::before {
  content: "󱞼";
}

.mdi-arrow-up::before {
  content: "󰁝";
}

.mdi-arrow-up-bold::before {
  content: "󰜷";
}

.mdi-arrow-up-bold-box::before {
  content: "󰜸";
}

.mdi-arrow-up-bold-box-outline::before {
  content: "󰜹";
}

.mdi-arrow-up-bold-circle::before {
  content: "󰁟";
}

.mdi-arrow-up-bold-circle-outline::before {
  content: "󰁠";
}

.mdi-arrow-up-bold-hexagon-outline::before {
  content: "󰁡";
}

.mdi-arrow-up-bold-outline::before {
  content: "󰧇";
}

.mdi-arrow-up-box::before {
  content: "󰛃";
}

.mdi-arrow-up-circle::before {
  content: "󰳡";
}

.mdi-arrow-up-circle-outline::before {
  content: "󰳢";
}

.mdi-arrow-up-down::before {
  content: "󰹹";
}

.mdi-arrow-up-down-bold::before {
  content: "󰹺";
}

.mdi-arrow-up-down-bold-outline::before {
  content: "󰧈";
}

.mdi-arrow-up-drop-circle::before {
  content: "󰁢";
}

.mdi-arrow-up-drop-circle-outline::before {
  content: "󰁣";
}

.mdi-arrow-up-left::before {
  content: "󱞽";
}

.mdi-arrow-up-left-bold::before {
  content: "󱞾";
}

.mdi-arrow-up-right::before {
  content: "󱞿";
}

.mdi-arrow-up-right-bold::before {
  content: "󱟀";
}

.mdi-arrow-up-thick::before {
  content: "󰁞";
}

.mdi-arrow-up-thin::before {
  content: "󱦲";
}

.mdi-arrow-up-thin-circle-outline::before {
  content: "󱖗";
}

.mdi-arrow-vertical-lock::before {
  content: "󱅜";
}

.mdi-artstation::before {
  content: "󰭛";
}

.mdi-aspect-ratio::before {
  content: "󰨤";
}

.mdi-assistant::before {
  content: "󰁤";
}

.mdi-asterisk::before {
  content: "󰛄";
}

.mdi-at::before {
  content: "󰁥";
}

.mdi-atlassian::before {
  content: "󰠄";
}

.mdi-atm::before {
  content: "󰵇";
}

.mdi-atom::before {
  content: "󰝨";
}

.mdi-atom-variant::before {
  content: "󰹻";
}

.mdi-attachment::before {
  content: "󰁦";
}

.mdi-audio-input-rca::before {
  content: "󱡫";
}

.mdi-audio-input-stereo-minijack::before {
  content: "󱡬";
}

.mdi-audio-input-xlr::before {
  content: "󱡭";
}

.mdi-audio-video::before {
  content: "󰤽";
}

.mdi-audio-video-off::before {
  content: "󱆶";
}

.mdi-augmented-reality::before {
  content: "󰡐";
}

.mdi-auto-download::before {
  content: "󱍾";
}

.mdi-auto-fix::before {
  content: "󰁨";
}

.mdi-auto-upload::before {
  content: "󰁩";
}

.mdi-autorenew::before {
  content: "󰁪";
}

.mdi-av-timer::before {
  content: "󰁫";
}

.mdi-aws::before {
  content: "󰸏";
}

.mdi-axe::before {
  content: "󰣈";
}

.mdi-axe-battle::before {
  content: "󱡂";
}

.mdi-axis::before {
  content: "󰵈";
}

.mdi-axis-arrow::before {
  content: "󰵉";
}

.mdi-axis-arrow-info::before {
  content: "󱐎";
}

.mdi-axis-arrow-lock::before {
  content: "󰵊";
}

.mdi-axis-lock::before {
  content: "󰵋";
}

.mdi-axis-x-arrow::before {
  content: "󰵌";
}

.mdi-axis-x-arrow-lock::before {
  content: "󰵍";
}

.mdi-axis-x-rotate-clockwise::before {
  content: "󰵎";
}

.mdi-axis-x-rotate-counterclockwise::before {
  content: "󰵏";
}

.mdi-axis-x-y-arrow-lock::before {
  content: "󰵐";
}

.mdi-axis-y-arrow::before {
  content: "󰵑";
}

.mdi-axis-y-arrow-lock::before {
  content: "󰵒";
}

.mdi-axis-y-rotate-clockwise::before {
  content: "󰵓";
}

.mdi-axis-y-rotate-counterclockwise::before {
  content: "󰵔";
}

.mdi-axis-z-arrow::before {
  content: "󰵕";
}

.mdi-axis-z-arrow-lock::before {
  content: "󰵖";
}

.mdi-axis-z-rotate-clockwise::before {
  content: "󰵗";
}

.mdi-axis-z-rotate-counterclockwise::before {
  content: "󰵘";
}

.mdi-babel::before {
  content: "󰨥";
}

.mdi-baby::before {
  content: "󰁬";
}

.mdi-baby-bottle::before {
  content: "󰼹";
}

.mdi-baby-bottle-outline::before {
  content: "󰼺";
}

.mdi-baby-buggy::before {
  content: "󱏠";
}

.mdi-baby-carriage::before {
  content: "󰚏";
}

.mdi-baby-carriage-off::before {
  content: "󰾠";
}

.mdi-baby-face::before {
  content: "󰹼";
}

.mdi-baby-face-outline::before {
  content: "󰹽";
}

.mdi-backburger::before {
  content: "󰁭";
}

.mdi-backspace::before {
  content: "󰁮";
}

.mdi-backspace-outline::before {
  content: "󰭜";
}

.mdi-backspace-reverse::before {
  content: "󰹾";
}

.mdi-backspace-reverse-outline::before {
  content: "󰹿";
}

.mdi-backup-restore::before {
  content: "󰁯";
}

.mdi-bacteria::before {
  content: "󰻕";
}

.mdi-bacteria-outline::before {
  content: "󰻖";
}

.mdi-badge-account::before {
  content: "󰶧";
}

.mdi-badge-account-alert::before {
  content: "󰶨";
}

.mdi-badge-account-alert-outline::before {
  content: "󰶩";
}

.mdi-badge-account-horizontal::before {
  content: "󰸍";
}

.mdi-badge-account-horizontal-outline::before {
  content: "󰸎";
}

.mdi-badge-account-outline::before {
  content: "󰶪";
}

.mdi-badminton::before {
  content: "󰡑";
}

.mdi-bag-carry-on::before {
  content: "󰼻";
}

.mdi-bag-carry-on-check::before {
  content: "󰵥";
}

.mdi-bag-carry-on-off::before {
  content: "󰼼";
}

.mdi-bag-checked::before {
  content: "󰼽";
}

.mdi-bag-personal::before {
  content: "󰸐";
}

.mdi-bag-personal-off::before {
  content: "󰸑";
}

.mdi-bag-personal-off-outline::before {
  content: "󰸒";
}

.mdi-bag-personal-outline::before {
  content: "󰸓";
}

.mdi-bag-suitcase::before {
  content: "󱖋";
}

.mdi-bag-suitcase-off::before {
  content: "󱖍";
}

.mdi-bag-suitcase-off-outline::before {
  content: "󱖎";
}

.mdi-bag-suitcase-outline::before {
  content: "󱖌";
}

.mdi-baguette::before {
  content: "󰼾";
}

.mdi-balcony::before {
  content: "󱠗";
}

.mdi-balloon::before {
  content: "󰨦";
}

.mdi-ballot::before {
  content: "󰧉";
}

.mdi-ballot-outline::before {
  content: "󰧊";
}

.mdi-ballot-recount::before {
  content: "󰰹";
}

.mdi-ballot-recount-outline::before {
  content: "󰰺";
}

.mdi-bandage::before {
  content: "󰶯";
}

.mdi-bank::before {
  content: "󰁰";
}

.mdi-bank-check::before {
  content: "󱙕";
}

.mdi-bank-minus::before {
  content: "󰶰";
}

.mdi-bank-off::before {
  content: "󱙖";
}

.mdi-bank-off-outline::before {
  content: "󱙗";
}

.mdi-bank-outline::before {
  content: "󰺀";
}

.mdi-bank-plus::before {
  content: "󰶱";
}

.mdi-bank-remove::before {
  content: "󰶲";
}

.mdi-bank-transfer::before {
  content: "󰨧";
}

.mdi-bank-transfer-in::before {
  content: "󰨨";
}

.mdi-bank-transfer-out::before {
  content: "󰨩";
}

.mdi-barcode::before {
  content: "󰁱";
}

.mdi-barcode-off::before {
  content: "󱈶";
}

.mdi-barcode-scan::before {
  content: "󰁲";
}

.mdi-barley::before {
  content: "󰁳";
}

.mdi-barley-off::before {
  content: "󰭝";
}

.mdi-barn::before {
  content: "󰭞";
}

.mdi-barrel::before {
  content: "󰁴";
}

.mdi-baseball::before {
  content: "󰡒";
}

.mdi-baseball-bat::before {
  content: "󰡓";
}

.mdi-baseball-diamond::before {
  content: "󱗬";
}

.mdi-baseball-diamond-outline::before {
  content: "󱗭";
}

.mdi-bash::before {
  content: "󱆃";
}

.mdi-basket::before {
  content: "󰁶";
}

.mdi-basket-check::before {
  content: "󱣥";
}

.mdi-basket-check-outline::before {
  content: "󱣦";
}

.mdi-basket-fill::before {
  content: "󰁷";
}

.mdi-basket-minus::before {
  content: "󱔣";
}

.mdi-basket-minus-outline::before {
  content: "󱔤";
}

.mdi-basket-off::before {
  content: "󱔥";
}

.mdi-basket-off-outline::before {
  content: "󱔦";
}

.mdi-basket-outline::before {
  content: "󱆁";
}

.mdi-basket-plus::before {
  content: "󱔧";
}

.mdi-basket-plus-outline::before {
  content: "󱔨";
}

.mdi-basket-remove::before {
  content: "󱔩";
}

.mdi-basket-remove-outline::before {
  content: "󱔪";
}

.mdi-basket-unfill::before {
  content: "󰁸";
}

.mdi-basketball::before {
  content: "󰠆";
}

.mdi-basketball-hoop::before {
  content: "󰰻";
}

.mdi-basketball-hoop-outline::before {
  content: "󰰼";
}

.mdi-bat::before {
  content: "󰭟";
}

.mdi-bathtub::before {
  content: "󱠘";
}

.mdi-bathtub-outline::before {
  content: "󱠙";
}

.mdi-battery::before {
  content: "󰁹";
}

.mdi-battery-10::before {
  content: "󰁺";
}

.mdi-battery-10-bluetooth::before {
  content: "󰤾";
}

.mdi-battery-20::before {
  content: "󰁻";
}

.mdi-battery-20-bluetooth::before {
  content: "󰤿";
}

.mdi-battery-30::before {
  content: "󰁼";
}

.mdi-battery-30-bluetooth::before {
  content: "󰥀";
}

.mdi-battery-40::before {
  content: "󰁽";
}

.mdi-battery-40-bluetooth::before {
  content: "󰥁";
}

.mdi-battery-50::before {
  content: "󰁾";
}

.mdi-battery-50-bluetooth::before {
  content: "󰥂";
}

.mdi-battery-60::before {
  content: "󰁿";
}

.mdi-battery-60-bluetooth::before {
  content: "󰥃";
}

.mdi-battery-70::before {
  content: "󰂀";
}

.mdi-battery-70-bluetooth::before {
  content: "󰥄";
}

.mdi-battery-80::before {
  content: "󰂁";
}

.mdi-battery-80-bluetooth::before {
  content: "󰥅";
}

.mdi-battery-90::before {
  content: "󰂂";
}

.mdi-battery-90-bluetooth::before {
  content: "󰥆";
}

.mdi-battery-alert::before {
  content: "󰂃";
}

.mdi-battery-alert-bluetooth::before {
  content: "󰥇";
}

.mdi-battery-alert-variant::before {
  content: "󱃌";
}

.mdi-battery-alert-variant-outline::before {
  content: "󱃍";
}

.mdi-battery-arrow-down::before {
  content: "󱟞";
}

.mdi-battery-arrow-down-outline::before {
  content: "󱟟";
}

.mdi-battery-arrow-up::before {
  content: "󱟠";
}

.mdi-battery-arrow-up-outline::before {
  content: "󱟡";
}

.mdi-battery-bluetooth::before {
  content: "󰥈";
}

.mdi-battery-bluetooth-variant::before {
  content: "󰥉";
}

.mdi-battery-charging::before {
  content: "󰂄";
}

.mdi-battery-charging-10::before {
  content: "󰢜";
}

.mdi-battery-charging-100::before {
  content: "󰂅";
}

.mdi-battery-charging-20::before {
  content: "󰂆";
}

.mdi-battery-charging-30::before {
  content: "󰂇";
}

.mdi-battery-charging-40::before {
  content: "󰂈";
}

.mdi-battery-charging-50::before {
  content: "󰢝";
}

.mdi-battery-charging-60::before {
  content: "󰂉";
}

.mdi-battery-charging-70::before {
  content: "󰢞";
}

.mdi-battery-charging-80::before {
  content: "󰂊";
}

.mdi-battery-charging-90::before {
  content: "󰂋";
}

.mdi-battery-charging-high::before {
  content: "󱊦";
}

.mdi-battery-charging-low::before {
  content: "󱊤";
}

.mdi-battery-charging-medium::before {
  content: "󱊥";
}

.mdi-battery-charging-outline::before {
  content: "󰢟";
}

.mdi-battery-charging-wireless::before {
  content: "󰠇";
}

.mdi-battery-charging-wireless-10::before {
  content: "󰠈";
}

.mdi-battery-charging-wireless-20::before {
  content: "󰠉";
}

.mdi-battery-charging-wireless-30::before {
  content: "󰠊";
}

.mdi-battery-charging-wireless-40::before {
  content: "󰠋";
}

.mdi-battery-charging-wireless-50::before {
  content: "󰠌";
}

.mdi-battery-charging-wireless-60::before {
  content: "󰠍";
}

.mdi-battery-charging-wireless-70::before {
  content: "󰠎";
}

.mdi-battery-charging-wireless-80::before {
  content: "󰠏";
}

.mdi-battery-charging-wireless-90::before {
  content: "󰠐";
}

.mdi-battery-charging-wireless-alert::before {
  content: "󰠑";
}

.mdi-battery-charging-wireless-outline::before {
  content: "󰠒";
}

.mdi-battery-check::before {
  content: "󱟢";
}

.mdi-battery-check-outline::before {
  content: "󱟣";
}

.mdi-battery-heart::before {
  content: "󱈏";
}

.mdi-battery-heart-outline::before {
  content: "󱈐";
}

.mdi-battery-heart-variant::before {
  content: "󱈑";
}

.mdi-battery-high::before {
  content: "󱊣";
}

.mdi-battery-lock::before {
  content: "󱞜";
}

.mdi-battery-lock-open::before {
  content: "󱞝";
}

.mdi-battery-low::before {
  content: "󱊡";
}

.mdi-battery-medium::before {
  content: "󱊢";
}

.mdi-battery-minus::before {
  content: "󱟤";
}

.mdi-battery-minus-outline::before {
  content: "󱟥";
}

.mdi-battery-minus-variant::before {
  content: "󰂌";
}

.mdi-battery-negative::before {
  content: "󰂍";
}

.mdi-battery-off::before {
  content: "󱉝";
}

.mdi-battery-off-outline::before {
  content: "󱉞";
}

.mdi-battery-outline::before {
  content: "󰂎";
}

.mdi-battery-plus::before {
  content: "󱟦";
}

.mdi-battery-plus-outline::before {
  content: "󱟧";
}

.mdi-battery-plus-variant::before {
  content: "󰂏";
}

.mdi-battery-positive::before {
  content: "󰂐";
}

.mdi-battery-remove::before {
  content: "󱟨";
}

.mdi-battery-remove-outline::before {
  content: "󱟩";
}

.mdi-battery-sync::before {
  content: "󱠴";
}

.mdi-battery-sync-outline::before {
  content: "󱠵";
}

.mdi-battery-unknown::before {
  content: "󰂑";
}

.mdi-battery-unknown-bluetooth::before {
  content: "󰥊";
}

.mdi-beach::before {
  content: "󰂒";
}

.mdi-beaker::before {
  content: "󰳪";
}

.mdi-beaker-alert::before {
  content: "󱈩";
}

.mdi-beaker-alert-outline::before {
  content: "󱈪";
}

.mdi-beaker-check::before {
  content: "󱈫";
}

.mdi-beaker-check-outline::before {
  content: "󱈬";
}

.mdi-beaker-minus::before {
  content: "󱈭";
}

.mdi-beaker-minus-outline::before {
  content: "󱈮";
}

.mdi-beaker-outline::before {
  content: "󰚐";
}

.mdi-beaker-plus::before {
  content: "󱈯";
}

.mdi-beaker-plus-outline::before {
  content: "󱈰";
}

.mdi-beaker-question::before {
  content: "󱈱";
}

.mdi-beaker-question-outline::before {
  content: "󱈲";
}

.mdi-beaker-remove::before {
  content: "󱈳";
}

.mdi-beaker-remove-outline::before {
  content: "󱈴";
}

.mdi-bed::before {
  content: "󰋣";
}

.mdi-bed-double::before {
  content: "󰿔";
}

.mdi-bed-double-outline::before {
  content: "󰿓";
}

.mdi-bed-empty::before {
  content: "󰢠";
}

.mdi-bed-king::before {
  content: "󰿒";
}

.mdi-bed-king-outline::before {
  content: "󰿑";
}

.mdi-bed-outline::before {
  content: "󰂙";
}

.mdi-bed-queen::before {
  content: "󰿐";
}

.mdi-bed-queen-outline::before {
  content: "󰿛";
}

.mdi-bed-single::before {
  content: "󱁭";
}

.mdi-bed-single-outline::before {
  content: "󱁮";
}

.mdi-bee::before {
  content: "󰾡";
}

.mdi-bee-flower::before {
  content: "󰾢";
}

.mdi-beehive-off-outline::before {
  content: "󱏭";
}

.mdi-beehive-outline::before {
  content: "󱃎";
}

.mdi-beekeeper::before {
  content: "󱓢";
}

.mdi-beer::before {
  content: "󰂘";
}

.mdi-beer-outline::before {
  content: "󱌌";
}

.mdi-bell::before {
  content: "󰂚";
}

.mdi-bell-alert::before {
  content: "󰵙";
}

.mdi-bell-alert-outline::before {
  content: "󰺁";
}

.mdi-bell-badge::before {
  content: "󱅫";
}

.mdi-bell-badge-outline::before {
  content: "󰅸";
}

.mdi-bell-cancel::before {
  content: "󱏧";
}

.mdi-bell-cancel-outline::before {
  content: "󱏨";
}

.mdi-bell-check::before {
  content: "󱇥";
}

.mdi-bell-check-outline::before {
  content: "󱇦";
}

.mdi-bell-circle::before {
  content: "󰵚";
}

.mdi-bell-circle-outline::before {
  content: "󰵛";
}

.mdi-bell-minus::before {
  content: "󱏩";
}

.mdi-bell-minus-outline::before {
  content: "󱏪";
}

.mdi-bell-off::before {
  content: "󰂛";
}

.mdi-bell-off-outline::before {
  content: "󰪑";
}

.mdi-bell-outline::before {
  content: "󰂜";
}

.mdi-bell-plus::before {
  content: "󰂝";
}

.mdi-bell-plus-outline::before {
  content: "󰪒";
}

.mdi-bell-remove::before {
  content: "󱏫";
}

.mdi-bell-remove-outline::before {
  content: "󱏬";
}

.mdi-bell-ring::before {
  content: "󰂞";
}

.mdi-bell-ring-outline::before {
  content: "󰂟";
}

.mdi-bell-sleep::before {
  content: "󰂠";
}

.mdi-bell-sleep-outline::before {
  content: "󰪓";
}

.mdi-beta::before {
  content: "󰂡";
}

.mdi-betamax::before {
  content: "󰧋";
}

.mdi-biathlon::before {
  content: "󰸔";
}

.mdi-bicycle::before {
  content: "󱂜";
}

.mdi-bicycle-basket::before {
  content: "󱈵";
}

.mdi-bicycle-cargo::before {
  content: "󱢜";
}

.mdi-bicycle-electric::before {
  content: "󱖴";
}

.mdi-bicycle-penny-farthing::before {
  content: "󱗩";
}

.mdi-bike::before {
  content: "󰂣";
}

.mdi-bike-fast::before {
  content: "󱄟";
}

.mdi-billboard::before {
  content: "󱀐";
}

.mdi-billiards::before {
  content: "󰭡";
}

.mdi-billiards-rack::before {
  content: "󰭢";
}

.mdi-binoculars::before {
  content: "󰂥";
}

.mdi-bio::before {
  content: "󰂦";
}

.mdi-biohazard::before {
  content: "󰂧";
}

.mdi-bird::before {
  content: "󱗆";
}

.mdi-bitbucket::before {
  content: "󰂨";
}

.mdi-bitcoin::before {
  content: "󰠓";
}

.mdi-black-mesa::before {
  content: "󰂩";
}

.mdi-blender::before {
  content: "󰳫";
}

.mdi-blender-outline::before {
  content: "󱠚";
}

.mdi-blender-software::before {
  content: "󰂫";
}

.mdi-blinds::before {
  content: "󰂬";
}

.mdi-blinds-open::before {
  content: "󱀑";
}

.mdi-block-helper::before {
  content: "󰂭";
}

.mdi-blood-bag::before {
  content: "󰳬";
}

.mdi-bluetooth::before {
  content: "󰂯";
}

.mdi-bluetooth-audio::before {
  content: "󰂰";
}

.mdi-bluetooth-connect::before {
  content: "󰂱";
}

.mdi-bluetooth-off::before {
  content: "󰂲";
}

.mdi-bluetooth-settings::before {
  content: "󰂳";
}

.mdi-bluetooth-transfer::before {
  content: "󰂴";
}

.mdi-blur::before {
  content: "󰂵";
}

.mdi-blur-linear::before {
  content: "󰂶";
}

.mdi-blur-off::before {
  content: "󰂷";
}

.mdi-blur-radial::before {
  content: "󰂸";
}

.mdi-bolt::before {
  content: "󰶳";
}

.mdi-bomb::before {
  content: "󰚑";
}

.mdi-bomb-off::before {
  content: "󰛅";
}

.mdi-bone::before {
  content: "󰂹";
}

.mdi-book::before {
  content: "󰂺";
}

.mdi-book-account::before {
  content: "󱎭";
}

.mdi-book-account-outline::before {
  content: "󱎮";
}

.mdi-book-alert::before {
  content: "󱙼";
}

.mdi-book-alert-outline::before {
  content: "󱙽";
}

.mdi-book-alphabet::before {
  content: "󰘝";
}

.mdi-book-arrow-down::before {
  content: "󱙾";
}

.mdi-book-arrow-down-outline::before {
  content: "󱙿";
}

.mdi-book-arrow-left::before {
  content: "󱚀";
}

.mdi-book-arrow-left-outline::before {
  content: "󱚁";
}

.mdi-book-arrow-right::before {
  content: "󱚂";
}

.mdi-book-arrow-right-outline::before {
  content: "󱚃";
}

.mdi-book-arrow-up::before {
  content: "󱚄";
}

.mdi-book-arrow-up-outline::before {
  content: "󱚅";
}

.mdi-book-cancel::before {
  content: "󱚆";
}

.mdi-book-cancel-outline::before {
  content: "󱚇";
}

.mdi-book-check::before {
  content: "󱓳";
}

.mdi-book-check-outline::before {
  content: "󱓴";
}

.mdi-book-clock::before {
  content: "󱚈";
}

.mdi-book-clock-outline::before {
  content: "󱚉";
}

.mdi-book-cog::before {
  content: "󱚊";
}

.mdi-book-cog-outline::before {
  content: "󱚋";
}

.mdi-book-cross::before {
  content: "󰂢";
}

.mdi-book-edit::before {
  content: "󱚌";
}

.mdi-book-edit-outline::before {
  content: "󱚍";
}

.mdi-book-education::before {
  content: "󱛉";
}

.mdi-book-education-outline::before {
  content: "󱛊";
}

.mdi-book-information-variant::before {
  content: "󱁯";
}

.mdi-book-lock::before {
  content: "󰞚";
}

.mdi-book-lock-open::before {
  content: "󰞛";
}

.mdi-book-lock-open-outline::before {
  content: "󱚎";
}

.mdi-book-lock-outline::before {
  content: "󱚏";
}

.mdi-book-marker::before {
  content: "󱚐";
}

.mdi-book-marker-outline::before {
  content: "󱚑";
}

.mdi-book-minus::before {
  content: "󰗙";
}

.mdi-book-minus-multiple::before {
  content: "󰪔";
}

.mdi-book-minus-multiple-outline::before {
  content: "󰤋";
}

.mdi-book-minus-outline::before {
  content: "󱚒";
}

.mdi-book-multiple::before {
  content: "󰂻";
}

.mdi-book-multiple-outline::before {
  content: "󰐶";
}

.mdi-book-music::before {
  content: "󰁧";
}

.mdi-book-music-outline::before {
  content: "󱚓";
}

.mdi-book-off::before {
  content: "󱚔";
}

.mdi-book-off-outline::before {
  content: "󱚕";
}

.mdi-book-open::before {
  content: "󰂽";
}

.mdi-book-open-blank-variant::before {
  content: "󰂾";
}

.mdi-book-open-outline::before {
  content: "󰭣";
}

.mdi-book-open-page-variant::before {
  content: "󰗚";
}

.mdi-book-open-page-variant-outline::before {
  content: "󱗖";
}

.mdi-book-open-variant::before {
  content: "󱓷";
}

.mdi-book-outline::before {
  content: "󰭤";
}

.mdi-book-play::before {
  content: "󰺂";
}

.mdi-book-play-outline::before {
  content: "󰺃";
}

.mdi-book-plus::before {
  content: "󰗛";
}

.mdi-book-plus-multiple::before {
  content: "󰪕";
}

.mdi-book-plus-multiple-outline::before {
  content: "󰫞";
}

.mdi-book-plus-outline::before {
  content: "󱚖";
}

.mdi-book-refresh::before {
  content: "󱚗";
}

.mdi-book-refresh-outline::before {
  content: "󱚘";
}

.mdi-book-remove::before {
  content: "󰪗";
}

.mdi-book-remove-multiple::before {
  content: "󰪖";
}

.mdi-book-remove-multiple-outline::before {
  content: "󰓊";
}

.mdi-book-remove-outline::before {
  content: "󱚙";
}

.mdi-book-search::before {
  content: "󰺄";
}

.mdi-book-search-outline::before {
  content: "󰺅";
}

.mdi-book-settings::before {
  content: "󱚚";
}

.mdi-book-settings-outline::before {
  content: "󱚛";
}

.mdi-book-sync::before {
  content: "󱚜";
}

.mdi-book-sync-outline::before {
  content: "󱛈";
}

.mdi-book-variant::before {
  content: "󰂿";
}

.mdi-book-variant-multiple::before {
  content: "󰂼";
}

.mdi-bookmark::before {
  content: "󰃀";
}

.mdi-bookmark-box-multiple::before {
  content: "󱥬";
}

.mdi-bookmark-box-multiple-outline::before {
  content: "󱥭";
}

.mdi-bookmark-check::before {
  content: "󰃁";
}

.mdi-bookmark-check-outline::before {
  content: "󱍻";
}

.mdi-bookmark-minus::before {
  content: "󰧌";
}

.mdi-bookmark-minus-outline::before {
  content: "󰧍";
}

.mdi-bookmark-multiple::before {
  content: "󰸕";
}

.mdi-bookmark-multiple-outline::before {
  content: "󰸖";
}

.mdi-bookmark-music::before {
  content: "󰃂";
}

.mdi-bookmark-music-outline::before {
  content: "󱍹";
}

.mdi-bookmark-off::before {
  content: "󰧎";
}

.mdi-bookmark-off-outline::before {
  content: "󰧏";
}

.mdi-bookmark-outline::before {
  content: "󰃃";
}

.mdi-bookmark-plus::before {
  content: "󰃅";
}

.mdi-bookmark-plus-outline::before {
  content: "󰃄";
}

.mdi-bookmark-remove::before {
  content: "󰃆";
}

.mdi-bookmark-remove-outline::before {
  content: "󱍺";
}

.mdi-bookshelf::before {
  content: "󱉟";
}

.mdi-boom-gate::before {
  content: "󰺆";
}

.mdi-boom-gate-alert::before {
  content: "󰺇";
}

.mdi-boom-gate-alert-outline::before {
  content: "󰺈";
}

.mdi-boom-gate-arrow-down::before {
  content: "󰺉";
}

.mdi-boom-gate-arrow-down-outline::before {
  content: "󰺊";
}

.mdi-boom-gate-arrow-up::before {
  content: "󰺌";
}

.mdi-boom-gate-arrow-up-outline::before {
  content: "󰺍";
}

.mdi-boom-gate-outline::before {
  content: "󰺋";
}

.mdi-boom-gate-up::before {
  content: "󱟹";
}

.mdi-boom-gate-up-outline::before {
  content: "󱟺";
}

.mdi-boombox::before {
  content: "󰗜";
}

.mdi-boomerang::before {
  content: "󱃏";
}

.mdi-bootstrap::before {
  content: "󰛆";
}

.mdi-border-all::before {
  content: "󰃇";
}

.mdi-border-all-variant::before {
  content: "󰢡";
}

.mdi-border-bottom::before {
  content: "󰃈";
}

.mdi-border-bottom-variant::before {
  content: "󰢢";
}

.mdi-border-color::before {
  content: "󰃉";
}

.mdi-border-horizontal::before {
  content: "󰃊";
}

.mdi-border-inside::before {
  content: "󰃋";
}

.mdi-border-left::before {
  content: "󰃌";
}

.mdi-border-left-variant::before {
  content: "󰢣";
}

.mdi-border-none::before {
  content: "󰃍";
}

.mdi-border-none-variant::before {
  content: "󰢤";
}

.mdi-border-outside::before {
  content: "󰃎";
}

.mdi-border-right::before {
  content: "󰃏";
}

.mdi-border-right-variant::before {
  content: "󰢥";
}

.mdi-border-style::before {
  content: "󰃐";
}

.mdi-border-top::before {
  content: "󰃑";
}

.mdi-border-top-variant::before {
  content: "󰢦";
}

.mdi-border-vertical::before {
  content: "󰃒";
}

.mdi-bottle-soda::before {
  content: "󱁰";
}

.mdi-bottle-soda-classic::before {
  content: "󱁱";
}

.mdi-bottle-soda-classic-outline::before {
  content: "󱍣";
}

.mdi-bottle-soda-outline::before {
  content: "󱁲";
}

.mdi-bottle-tonic::before {
  content: "󱄮";
}

.mdi-bottle-tonic-outline::before {
  content: "󱄯";
}

.mdi-bottle-tonic-plus::before {
  content: "󱄰";
}

.mdi-bottle-tonic-plus-outline::before {
  content: "󱄱";
}

.mdi-bottle-tonic-skull::before {
  content: "󱄲";
}

.mdi-bottle-tonic-skull-outline::before {
  content: "󱄳";
}

.mdi-bottle-wine::before {
  content: "󰡔";
}

.mdi-bottle-wine-outline::before {
  content: "󱌐";
}

.mdi-bow-arrow::before {
  content: "󱡁";
}

.mdi-bow-tie::before {
  content: "󰙸";
}

.mdi-bowl::before {
  content: "󰊎";
}

.mdi-bowl-mix::before {
  content: "󰘗";
}

.mdi-bowl-mix-outline::before {
  content: "󰋤";
}

.mdi-bowl-outline::before {
  content: "󰊩";
}

.mdi-bowling::before {
  content: "󰃓";
}

.mdi-box::before {
  content: "󰃔";
}

.mdi-box-cutter::before {
  content: "󰃕";
}

.mdi-box-cutter-off::before {
  content: "󰭊";
}

.mdi-box-shadow::before {
  content: "󰘷";
}

.mdi-boxing-glove::before {
  content: "󰭥";
}

.mdi-braille::before {
  content: "󰧐";
}

.mdi-brain::before {
  content: "󰧑";
}

.mdi-bread-slice::before {
  content: "󰳮";
}

.mdi-bread-slice-outline::before {
  content: "󰳯";
}

.mdi-bridge::before {
  content: "󰘘";
}

.mdi-briefcase::before {
  content: "󰃖";
}

.mdi-briefcase-account::before {
  content: "󰳰";
}

.mdi-briefcase-account-outline::before {
  content: "󰳱";
}

.mdi-briefcase-check::before {
  content: "󰃗";
}

.mdi-briefcase-check-outline::before {
  content: "󱌞";
}

.mdi-briefcase-clock::before {
  content: "󱃐";
}

.mdi-briefcase-clock-outline::before {
  content: "󱃑";
}

.mdi-briefcase-download::before {
  content: "󰃘";
}

.mdi-briefcase-download-outline::before {
  content: "󰰽";
}

.mdi-briefcase-edit::before {
  content: "󰪘";
}

.mdi-briefcase-edit-outline::before {
  content: "󰰾";
}

.mdi-briefcase-eye::before {
  content: "󱟙";
}

.mdi-briefcase-eye-outline::before {
  content: "󱟚";
}

.mdi-briefcase-minus::before {
  content: "󰨪";
}

.mdi-briefcase-minus-outline::before {
  content: "󰰿";
}

.mdi-briefcase-off::before {
  content: "󱙘";
}

.mdi-briefcase-off-outline::before {
  content: "󱙙";
}

.mdi-briefcase-outline::before {
  content: "󰠔";
}

.mdi-briefcase-plus::before {
  content: "󰨫";
}

.mdi-briefcase-plus-outline::before {
  content: "󰱀";
}

.mdi-briefcase-remove::before {
  content: "󰨬";
}

.mdi-briefcase-remove-outline::before {
  content: "󰱁";
}

.mdi-briefcase-search::before {
  content: "󰨭";
}

.mdi-briefcase-search-outline::before {
  content: "󰱂";
}

.mdi-briefcase-upload::before {
  content: "󰃙";
}

.mdi-briefcase-upload-outline::before {
  content: "󰱃";
}

.mdi-briefcase-variant::before {
  content: "󱒔";
}

.mdi-briefcase-variant-off::before {
  content: "󱙚";
}

.mdi-briefcase-variant-off-outline::before {
  content: "󱙛";
}

.mdi-briefcase-variant-outline::before {
  content: "󱒕";
}

.mdi-brightness-1::before {
  content: "󰃚";
}

.mdi-brightness-2::before {
  content: "󰃛";
}

.mdi-brightness-3::before {
  content: "󰃜";
}

.mdi-brightness-4::before {
  content: "󰃝";
}

.mdi-brightness-5::before {
  content: "󰃞";
}

.mdi-brightness-6::before {
  content: "󰃟";
}

.mdi-brightness-7::before {
  content: "󰃠";
}

.mdi-brightness-auto::before {
  content: "󰃡";
}

.mdi-brightness-percent::before {
  content: "󰳲";
}

.mdi-broadcast::before {
  content: "󱜠";
}

.mdi-broadcast-off::before {
  content: "󱜡";
}

.mdi-broom::before {
  content: "󰃢";
}

.mdi-brush::before {
  content: "󰃣";
}

.mdi-brush-off::before {
  content: "󱝱";
}

.mdi-brush-variant::before {
  content: "󱠓";
}

.mdi-bucket::before {
  content: "󱐕";
}

.mdi-bucket-outline::before {
  content: "󱐖";
}

.mdi-buffet::before {
  content: "󰕸";
}

.mdi-bug::before {
  content: "󰃤";
}

.mdi-bug-check::before {
  content: "󰨮";
}

.mdi-bug-check-outline::before {
  content: "󰨯";
}

.mdi-bug-outline::before {
  content: "󰨰";
}

.mdi-bugle::before {
  content: "󰶴";
}

.mdi-bulldozer::before {
  content: "󰬢";
}

.mdi-bullet::before {
  content: "󰳳";
}

.mdi-bulletin-board::before {
  content: "󰃥";
}

.mdi-bullhorn::before {
  content: "󰃦";
}

.mdi-bullhorn-outline::before {
  content: "󰬣";
}

.mdi-bullhorn-variant::before {
  content: "󱥮";
}

.mdi-bullhorn-variant-outline::before {
  content: "󱥯";
}

.mdi-bullseye::before {
  content: "󰗝";
}

.mdi-bullseye-arrow::before {
  content: "󰣉";
}

.mdi-bulma::before {
  content: "󱋧";
}

.mdi-bunk-bed::before {
  content: "󱌂";
}

.mdi-bunk-bed-outline::before {
  content: "󰂗";
}

.mdi-bus::before {
  content: "󰃧";
}

.mdi-bus-alert::before {
  content: "󰪙";
}

.mdi-bus-articulated-end::before {
  content: "󰞜";
}

.mdi-bus-articulated-front::before {
  content: "󰞝";
}

.mdi-bus-clock::before {
  content: "󰣊";
}

.mdi-bus-double-decker::before {
  content: "󰞞";
}

.mdi-bus-electric::before {
  content: "󱤝";
}

.mdi-bus-marker::before {
  content: "󱈒";
}

.mdi-bus-multiple::before {
  content: "󰼿";
}

.mdi-bus-school::before {
  content: "󰞟";
}

.mdi-bus-side::before {
  content: "󰞠";
}

.mdi-bus-stop::before {
  content: "󱀒";
}

.mdi-bus-stop-covered::before {
  content: "󱀓";
}

.mdi-bus-stop-uncovered::before {
  content: "󱀔";
}

.mdi-butterfly::before {
  content: "󱖉";
}

.mdi-butterfly-outline::before {
  content: "󱖊";
}

.mdi-cabin-a-frame::before {
  content: "󱢌";
}

.mdi-cable-data::before {
  content: "󱎔";
}

.mdi-cached::before {
  content: "󰃨";
}

.mdi-cactus::before {
  content: "󰶵";
}

.mdi-cake::before {
  content: "󰃩";
}

.mdi-cake-layered::before {
  content: "󰃪";
}

.mdi-cake-variant::before {
  content: "󰃫";
}

.mdi-cake-variant-outline::before {
  content: "󱟰";
}

.mdi-calculator::before {
  content: "󰃬";
}

.mdi-calculator-variant::before {
  content: "󰪚";
}

.mdi-calculator-variant-outline::before {
  content: "󱖦";
}

.mdi-calendar::before {
  content: "󰃭";
}

.mdi-calendar-account::before {
  content: "󰻗";
}

.mdi-calendar-account-outline::before {
  content: "󰻘";
}

.mdi-calendar-alert::before {
  content: "󰨱";
}

.mdi-calendar-arrow-left::before {
  content: "󱄴";
}

.mdi-calendar-arrow-right::before {
  content: "󱄵";
}

.mdi-calendar-blank::before {
  content: "󰃮";
}

.mdi-calendar-blank-multiple::before {
  content: "󱁳";
}

.mdi-calendar-blank-outline::before {
  content: "󰭦";
}

.mdi-calendar-check::before {
  content: "󰃯";
}

.mdi-calendar-check-outline::before {
  content: "󰱄";
}

.mdi-calendar-clock::before {
  content: "󰃰";
}

.mdi-calendar-clock-outline::before {
  content: "󱛡";
}

.mdi-calendar-collapse-horizontal::before {
  content: "󱢝";
}

.mdi-calendar-cursor::before {
  content: "󱕻";
}

.mdi-calendar-edit::before {
  content: "󰢧";
}

.mdi-calendar-end::before {
  content: "󱙬";
}

.mdi-calendar-expand-horizontal::before {
  content: "󱢞";
}

.mdi-calendar-export::before {
  content: "󰬤";
}

.mdi-calendar-heart::before {
  content: "󰧒";
}

.mdi-calendar-import::before {
  content: "󰬥";
}

.mdi-calendar-lock::before {
  content: "󱙁";
}

.mdi-calendar-lock-outline::before {
  content: "󱙂";
}

.mdi-calendar-minus::before {
  content: "󰵜";
}

.mdi-calendar-month::before {
  content: "󰸗";
}

.mdi-calendar-month-outline::before {
  content: "󰸘";
}

.mdi-calendar-multiple::before {
  content: "󰃱";
}

.mdi-calendar-multiple-check::before {
  content: "󰃲";
}

.mdi-calendar-multiselect::before {
  content: "󰨲";
}

.mdi-calendar-outline::before {
  content: "󰭧";
}

.mdi-calendar-plus::before {
  content: "󰃳";
}

.mdi-calendar-question::before {
  content: "󰚒";
}

.mdi-calendar-range::before {
  content: "󰙹";
}

.mdi-calendar-range-outline::before {
  content: "󰭨";
}

.mdi-calendar-refresh::before {
  content: "󰇡";
}

.mdi-calendar-refresh-outline::before {
  content: "󰈃";
}

.mdi-calendar-remove::before {
  content: "󰃴";
}

.mdi-calendar-remove-outline::before {
  content: "󰱅";
}

.mdi-calendar-search::before {
  content: "󰥌";
}

.mdi-calendar-star::before {
  content: "󰧓";
}

.mdi-calendar-start::before {
  content: "󱙭";
}

.mdi-calendar-sync::before {
  content: "󰺎";
}

.mdi-calendar-sync-outline::before {
  content: "󰺏";
}

.mdi-calendar-text::before {
  content: "󰃵";
}

.mdi-calendar-text-outline::before {
  content: "󰱆";
}

.mdi-calendar-today::before {
  content: "󰃶";
}

.mdi-calendar-week::before {
  content: "󰨳";
}

.mdi-calendar-week-begin::before {
  content: "󰨴";
}

.mdi-calendar-weekend::before {
  content: "󰻙";
}

.mdi-calendar-weekend-outline::before {
  content: "󰻚";
}

.mdi-call-made::before {
  content: "󰃷";
}

.mdi-call-merge::before {
  content: "󰃸";
}

.mdi-call-missed::before {
  content: "󰃹";
}

.mdi-call-received::before {
  content: "󰃺";
}

.mdi-call-split::before {
  content: "󰃻";
}

.mdi-camcorder::before {
  content: "󰃼";
}

.mdi-camcorder-off::before {
  content: "󰃿";
}

.mdi-camera::before {
  content: "󰄀";
}

.mdi-camera-account::before {
  content: "󰣋";
}

.mdi-camera-burst::before {
  content: "󰚓";
}

.mdi-camera-control::before {
  content: "󰭩";
}

.mdi-camera-document::before {
  content: "󱡱";
}

.mdi-camera-document-off::before {
  content: "󱡲";
}

.mdi-camera-enhance::before {
  content: "󰄁";
}

.mdi-camera-enhance-outline::before {
  content: "󰭪";
}

.mdi-camera-flip::before {
  content: "󱗙";
}

.mdi-camera-flip-outline::before {
  content: "󱗚";
}

.mdi-camera-front::before {
  content: "󰄂";
}

.mdi-camera-front-variant::before {
  content: "󰄃";
}

.mdi-camera-gopro::before {
  content: "󰞡";
}

.mdi-camera-image::before {
  content: "󰣌";
}

.mdi-camera-iris::before {
  content: "󰄄";
}

.mdi-camera-marker::before {
  content: "󱦧";
}

.mdi-camera-marker-outline::before {
  content: "󱦨";
}

.mdi-camera-metering-center::before {
  content: "󰞢";
}

.mdi-camera-metering-matrix::before {
  content: "󰞣";
}

.mdi-camera-metering-partial::before {
  content: "󰞤";
}

.mdi-camera-metering-spot::before {
  content: "󰞥";
}

.mdi-camera-off::before {
  content: "󰗟";
}

.mdi-camera-off-outline::before {
  content: "󱦿";
}

.mdi-camera-outline::before {
  content: "󰵝";
}

.mdi-camera-party-mode::before {
  content: "󰄅";
}

.mdi-camera-plus::before {
  content: "󰻛";
}

.mdi-camera-plus-outline::before {
  content: "󰻜";
}

.mdi-camera-rear::before {
  content: "󰄆";
}

.mdi-camera-rear-variant::before {
  content: "󰄇";
}

.mdi-camera-retake::before {
  content: "󰸙";
}

.mdi-camera-retake-outline::before {
  content: "󰸚";
}

.mdi-camera-switch::before {
  content: "󰄈";
}

.mdi-camera-switch-outline::before {
  content: "󰡊";
}

.mdi-camera-timer::before {
  content: "󰄉";
}

.mdi-camera-wireless::before {
  content: "󰶶";
}

.mdi-camera-wireless-outline::before {
  content: "󰶷";
}

.mdi-campfire::before {
  content: "󰻝";
}

.mdi-cancel::before {
  content: "󰜺";
}

.mdi-candelabra::before {
  content: "󱟒";
}

.mdi-candelabra-fire::before {
  content: "󱟓";
}

.mdi-candle::before {
  content: "󰗢";
}

.mdi-candy::before {
  content: "󱥰";
}

.mdi-candy-off::before {
  content: "󱥱";
}

.mdi-candy-off-outline::before {
  content: "󱥲";
}

.mdi-candy-outline::before {
  content: "󱥳";
}

.mdi-candycane::before {
  content: "󰄊";
}

.mdi-cannabis::before {
  content: "󰞦";
}

.mdi-cannabis-off::before {
  content: "󱙮";
}

.mdi-caps-lock::before {
  content: "󰪛";
}

.mdi-car::before {
  content: "󰄋";
}

.mdi-car-2-plus::before {
  content: "󱀕";
}

.mdi-car-3-plus::before {
  content: "󱀖";
}

.mdi-car-arrow-left::before {
  content: "󱎲";
}

.mdi-car-arrow-right::before {
  content: "󱎳";
}

.mdi-car-back::before {
  content: "󰸛";
}

.mdi-car-battery::before {
  content: "󰄌";
}

.mdi-car-brake-abs::before {
  content: "󰱇";
}

.mdi-car-brake-alert::before {
  content: "󰱈";
}

.mdi-car-brake-fluid-level::before {
  content: "󱤉";
}

.mdi-car-brake-hold::before {
  content: "󰵞";
}

.mdi-car-brake-low-pressure::before {
  content: "󱤊";
}

.mdi-car-brake-parking::before {
  content: "󰵟";
}

.mdi-car-brake-retarder::before {
  content: "󱀗";
}

.mdi-car-brake-temperature::before {
  content: "󱤋";
}

.mdi-car-brake-worn-linings::before {
  content: "󱤌";
}

.mdi-car-child-seat::before {
  content: "󰾣";
}

.mdi-car-clock::before {
  content: "󱥴";
}

.mdi-car-clutch::before {
  content: "󱀘";
}

.mdi-car-cog::before {
  content: "󱏌";
}

.mdi-car-connected::before {
  content: "󰄍";
}

.mdi-car-convertible::before {
  content: "󰞧";
}

.mdi-car-coolant-level::before {
  content: "󱀙";
}

.mdi-car-cruise-control::before {
  content: "󰵠";
}

.mdi-car-defrost-front::before {
  content: "󰵡";
}

.mdi-car-defrost-rear::before {
  content: "󰵢";
}

.mdi-car-door::before {
  content: "󰭫";
}

.mdi-car-door-lock::before {
  content: "󱂝";
}

.mdi-car-electric::before {
  content: "󰭬";
}

.mdi-car-electric-outline::before {
  content: "󱖵";
}

.mdi-car-emergency::before {
  content: "󱘏";
}

.mdi-car-esp::before {
  content: "󰱉";
}

.mdi-car-estate::before {
  content: "󰞨";
}

.mdi-car-hatchback::before {
  content: "󰞩";
}

.mdi-car-info::before {
  content: "󱆾";
}

.mdi-car-key::before {
  content: "󰭭";
}

.mdi-car-lifted-pickup::before {
  content: "󱔭";
}

.mdi-car-light-alert::before {
  content: "󱤍";
}

.mdi-car-light-dimmed::before {
  content: "󰱊";
}

.mdi-car-light-fog::before {
  content: "󰱋";
}

.mdi-car-light-high::before {
  content: "󰱌";
}

.mdi-car-limousine::before {
  content: "󰣍";
}

.mdi-car-multiple::before {
  content: "󰭮";
}

.mdi-car-off::before {
  content: "󰸜";
}

.mdi-car-outline::before {
  content: "󱓭";
}

.mdi-car-parking-lights::before {
  content: "󰵣";
}

.mdi-car-pickup::before {
  content: "󰞪";
}

.mdi-car-seat::before {
  content: "󰾤";
}

.mdi-car-seat-cooler::before {
  content: "󰾥";
}

.mdi-car-seat-heater::before {
  content: "󰾦";
}

.mdi-car-select::before {
  content: "󱡹";
}

.mdi-car-settings::before {
  content: "󱏍";
}

.mdi-car-shift-pattern::before {
  content: "󰽀";
}

.mdi-car-side::before {
  content: "󰞫";
}

.mdi-car-speed-limiter::before {
  content: "󱤎";
}

.mdi-car-sports::before {
  content: "󰞬";
}

.mdi-car-tire-alert::before {
  content: "󰱍";
}

.mdi-car-traction-control::before {
  content: "󰵤";
}

.mdi-car-turbocharger::before {
  content: "󱀚";
}

.mdi-car-wash::before {
  content: "󰄎";
}

.mdi-car-windshield::before {
  content: "󱀛";
}

.mdi-car-windshield-outline::before {
  content: "󱀜";
}

.mdi-car-wireless::before {
  content: "󱡸";
}

.mdi-car-wrench::before {
  content: "󱠔";
}

.mdi-carabiner::before {
  content: "󱓀";
}

.mdi-caravan::before {
  content: "󰞭";
}

.mdi-card::before {
  content: "󰭯";
}

.mdi-card-account-details::before {
  content: "󰗒";
}

.mdi-card-account-details-outline::before {
  content: "󰶫";
}

.mdi-card-account-details-star::before {
  content: "󰊣";
}

.mdi-card-account-details-star-outline::before {
  content: "󰛛";
}

.mdi-card-account-mail::before {
  content: "󰆎";
}

.mdi-card-account-mail-outline::before {
  content: "󰺘";
}

.mdi-card-account-phone::before {
  content: "󰺙";
}

.mdi-card-account-phone-outline::before {
  content: "󰺚";
}

.mdi-card-bulleted::before {
  content: "󰭰";
}

.mdi-card-bulleted-off::before {
  content: "󰭱";
}

.mdi-card-bulleted-off-outline::before {
  content: "󰭲";
}

.mdi-card-bulleted-outline::before {
  content: "󰭳";
}

.mdi-card-bulleted-settings::before {
  content: "󰭴";
}

.mdi-card-bulleted-settings-outline::before {
  content: "󰭵";
}

.mdi-card-minus::before {
  content: "󱘀";
}

.mdi-card-minus-outline::before {
  content: "󱘁";
}

.mdi-card-multiple::before {
  content: "󱟱";
}

.mdi-card-multiple-outline::before {
  content: "󱟲";
}

.mdi-card-off::before {
  content: "󱘂";
}

.mdi-card-off-outline::before {
  content: "󱘃";
}

.mdi-card-outline::before {
  content: "󰭶";
}

.mdi-card-plus::before {
  content: "󱇿";
}

.mdi-card-plus-outline::before {
  content: "󱈀";
}

.mdi-card-remove::before {
  content: "󱘄";
}

.mdi-card-remove-outline::before {
  content: "󱘅";
}

.mdi-card-search::before {
  content: "󱁴";
}

.mdi-card-search-outline::before {
  content: "󱁵";
}

.mdi-card-text::before {
  content: "󰭷";
}

.mdi-card-text-outline::before {
  content: "󰭸";
}

.mdi-cards::before {
  content: "󰘸";
}

.mdi-cards-club::before {
  content: "󰣎";
}

.mdi-cards-club-outline::before {
  content: "󱢟";
}

.mdi-cards-diamond::before {
  content: "󰣏";
}

.mdi-cards-diamond-outline::before {
  content: "󱀝";
}

.mdi-cards-heart::before {
  content: "󰣐";
}

.mdi-cards-heart-outline::before {
  content: "󱢠";
}

.mdi-cards-outline::before {
  content: "󰘹";
}

.mdi-cards-playing::before {
  content: "󱢡";
}

.mdi-cards-playing-club::before {
  content: "󱢢";
}

.mdi-cards-playing-club-multiple::before {
  content: "󱢣";
}

.mdi-cards-playing-club-multiple-outline::before {
  content: "󱢤";
}

.mdi-cards-playing-club-outline::before {
  content: "󱢥";
}

.mdi-cards-playing-diamond::before {
  content: "󱢦";
}

.mdi-cards-playing-diamond-multiple::before {
  content: "󱢧";
}

.mdi-cards-playing-diamond-multiple-outline::before {
  content: "󱢨";
}

.mdi-cards-playing-diamond-outline::before {
  content: "󱢩";
}

.mdi-cards-playing-heart::before {
  content: "󱢪";
}

.mdi-cards-playing-heart-multiple::before {
  content: "󱢫";
}

.mdi-cards-playing-heart-multiple-outline::before {
  content: "󱢬";
}

.mdi-cards-playing-heart-outline::before {
  content: "󱢭";
}

.mdi-cards-playing-outline::before {
  content: "󰘺";
}

.mdi-cards-playing-spade::before {
  content: "󱢮";
}

.mdi-cards-playing-spade-multiple::before {
  content: "󱢯";
}

.mdi-cards-playing-spade-multiple-outline::before {
  content: "󱢰";
}

.mdi-cards-playing-spade-outline::before {
  content: "󱢱";
}

.mdi-cards-spade::before {
  content: "󰣑";
}

.mdi-cards-spade-outline::before {
  content: "󱢲";
}

.mdi-cards-variant::before {
  content: "󰛇";
}

.mdi-carrot::before {
  content: "󰄏";
}

.mdi-cart::before {
  content: "󰄐";
}

.mdi-cart-arrow-down::before {
  content: "󰵦";
}

.mdi-cart-arrow-right::before {
  content: "󰱎";
}

.mdi-cart-arrow-up::before {
  content: "󰵧";
}

.mdi-cart-check::before {
  content: "󱗪";
}

.mdi-cart-heart::before {
  content: "󱣠";
}

.mdi-cart-minus::before {
  content: "󰵨";
}

.mdi-cart-off::before {
  content: "󰙫";
}

.mdi-cart-outline::before {
  content: "󰄑";
}

.mdi-cart-plus::before {
  content: "󰄒";
}

.mdi-cart-remove::before {
  content: "󰵩";
}

.mdi-cart-variant::before {
  content: "󱗫";
}

.mdi-case-sensitive-alt::before {
  content: "󰄓";
}

.mdi-cash::before {
  content: "󰄔";
}

.mdi-cash-100::before {
  content: "󰄕";
}

.mdi-cash-check::before {
  content: "󱓮";
}

.mdi-cash-fast::before {
  content: "󱡜";
}

.mdi-cash-lock::before {
  content: "󱓪";
}

.mdi-cash-lock-open::before {
  content: "󱓫";
}

.mdi-cash-marker::before {
  content: "󰶸";
}

.mdi-cash-minus::before {
  content: "󱉠";
}

.mdi-cash-multiple::before {
  content: "󰄖";
}

.mdi-cash-plus::before {
  content: "󱉡";
}

.mdi-cash-refund::before {
  content: "󰪜";
}

.mdi-cash-register::before {
  content: "󰳴";
}

.mdi-cash-remove::before {
  content: "󱉢";
}

.mdi-cassette::before {
  content: "󰧔";
}

.mdi-cast::before {
  content: "󰄘";
}

.mdi-cast-audio::before {
  content: "󱀞";
}

.mdi-cast-audio-variant::before {
  content: "󱝉";
}

.mdi-cast-connected::before {
  content: "󰄙";
}

.mdi-cast-education::before {
  content: "󰸝";
}

.mdi-cast-off::before {
  content: "󰞊";
}

.mdi-cast-variant::before {
  content: "󰀟";
}

.mdi-castle::before {
  content: "󰄚";
}

.mdi-cat::before {
  content: "󰄛";
}

.mdi-cctv::before {
  content: "󰞮";
}

.mdi-cctv-off::before {
  content: "󱡟";
}

.mdi-ceiling-fan::before {
  content: "󱞗";
}

.mdi-ceiling-fan-light::before {
  content: "󱞘";
}

.mdi-ceiling-light::before {
  content: "󰝩";
}

.mdi-ceiling-light-multiple::before {
  content: "󱣝";
}

.mdi-ceiling-light-multiple-outline::before {
  content: "󱣞";
}

.mdi-ceiling-light-outline::before {
  content: "󱟇";
}

.mdi-cellphone::before {
  content: "󰄜";
}

.mdi-cellphone-arrow-down::before {
  content: "󰧕";
}

.mdi-cellphone-basic::before {
  content: "󰄞";
}

.mdi-cellphone-charging::before {
  content: "󱎗";
}

.mdi-cellphone-check::before {
  content: "󱟽";
}

.mdi-cellphone-cog::before {
  content: "󰥑";
}

.mdi-cellphone-dock::before {
  content: "󰄟";
}

.mdi-cellphone-information::before {
  content: "󰽁";
}

.mdi-cellphone-key::before {
  content: "󰥎";
}

.mdi-cellphone-link::before {
  content: "󰄡";
}

.mdi-cellphone-link-off::before {
  content: "󰄢";
}

.mdi-cellphone-lock::before {
  content: "󰥏";
}

.mdi-cellphone-marker::before {
  content: "󱠺";
}

.mdi-cellphone-message::before {
  content: "󰣓";
}

.mdi-cellphone-message-off::before {
  content: "󱃒";
}

.mdi-cellphone-nfc::before {
  content: "󰺐";
}

.mdi-cellphone-nfc-off::before {
  content: "󱋘";
}

.mdi-cellphone-off::before {
  content: "󰥐";
}

.mdi-cellphone-play::before {
  content: "󱀟";
}

.mdi-cellphone-remove::before {
  content: "󰥍";
}

.mdi-cellphone-screenshot::before {
  content: "󰨵";
}

.mdi-cellphone-settings::before {
  content: "󰄣";
}

.mdi-cellphone-sound::before {
  content: "󰥒";
}

.mdi-cellphone-text::before {
  content: "󰣒";
}

.mdi-cellphone-wireless::before {
  content: "󰠕";
}

.mdi-centos::before {
  content: "󱄚";
}

.mdi-certificate::before {
  content: "󰄤";
}

.mdi-certificate-outline::before {
  content: "󱆈";
}

.mdi-chair-rolling::before {
  content: "󰽈";
}

.mdi-chair-school::before {
  content: "󰄥";
}

.mdi-chandelier::before {
  content: "󱞓";
}

.mdi-charity::before {
  content: "󰱏";
}

.mdi-chart-arc::before {
  content: "󰄦";
}

.mdi-chart-areaspline::before {
  content: "󰄧";
}

.mdi-chart-areaspline-variant::before {
  content: "󰺑";
}

.mdi-chart-bar::before {
  content: "󰄨";
}

.mdi-chart-bar-stacked::before {
  content: "󰝪";
}

.mdi-chart-bell-curve::before {
  content: "󰱐";
}

.mdi-chart-bell-curve-cumulative::before {
  content: "󰾧";
}

.mdi-chart-box::before {
  content: "󱕍";
}

.mdi-chart-box-outline::before {
  content: "󱕎";
}

.mdi-chart-box-plus-outline::before {
  content: "󱕏";
}

.mdi-chart-bubble::before {
  content: "󰗣";
}

.mdi-chart-donut::before {
  content: "󰞯";
}

.mdi-chart-donut-variant::before {
  content: "󰞰";
}

.mdi-chart-gantt::before {
  content: "󰙬";
}

.mdi-chart-histogram::before {
  content: "󰄩";
}

.mdi-chart-line::before {
  content: "󰄪";
}

.mdi-chart-line-stacked::before {
  content: "󰝫";
}

.mdi-chart-line-variant::before {
  content: "󰞱";
}

.mdi-chart-multiline::before {
  content: "󰣔";
}

.mdi-chart-multiple::before {
  content: "󱈓";
}

.mdi-chart-pie::before {
  content: "󰄫";
}

.mdi-chart-ppf::before {
  content: "󱎀";
}

.mdi-chart-sankey::before {
  content: "󱇟";
}

.mdi-chart-sankey-variant::before {
  content: "󱇠";
}

.mdi-chart-scatter-plot::before {
  content: "󰺒";
}

.mdi-chart-scatter-plot-hexbin::before {
  content: "󰙭";
}

.mdi-chart-timeline::before {
  content: "󰙮";
}

.mdi-chart-timeline-variant::before {
  content: "󰺓";
}

.mdi-chart-timeline-variant-shimmer::before {
  content: "󱖶";
}

.mdi-chart-tree::before {
  content: "󰺔";
}

.mdi-chart-waterfall::before {
  content: "󱤘";
}

.mdi-chat::before {
  content: "󰭹";
}

.mdi-chat-alert::before {
  content: "󰭺";
}

.mdi-chat-alert-outline::before {
  content: "󱋉";
}

.mdi-chat-minus::before {
  content: "󱐐";
}

.mdi-chat-minus-outline::before {
  content: "󱐓";
}

.mdi-chat-outline::before {
  content: "󰻞";
}

.mdi-chat-plus::before {
  content: "󱐏";
}

.mdi-chat-plus-outline::before {
  content: "󱐒";
}

.mdi-chat-processing::before {
  content: "󰭻";
}

.mdi-chat-processing-outline::before {
  content: "󱋊";
}

.mdi-chat-question::before {
  content: "󱜸";
}

.mdi-chat-question-outline::before {
  content: "󱜹";
}

.mdi-chat-remove::before {
  content: "󱐑";
}

.mdi-chat-remove-outline::before {
  content: "󱐔";
}

.mdi-chat-sleep::before {
  content: "󱋑";
}

.mdi-chat-sleep-outline::before {
  content: "󱋒";
}

.mdi-check::before {
  content: "󰄬";
}

.mdi-check-all::before {
  content: "󰄭";
}

.mdi-check-bold::before {
  content: "󰸞";
}

.mdi-check-circle::before {
  content: "󰗠";
}

.mdi-check-circle-outline::before {
  content: "󰗡";
}

.mdi-check-decagram::before {
  content: "󰞑";
}

.mdi-check-decagram-outline::before {
  content: "󱝀";
}

.mdi-check-network::before {
  content: "󰱓";
}

.mdi-check-network-outline::before {
  content: "󰱔";
}

.mdi-check-outline::before {
  content: "󰡕";
}

.mdi-check-underline::before {
  content: "󰸟";
}

.mdi-check-underline-circle::before {
  content: "󰸠";
}

.mdi-check-underline-circle-outline::before {
  content: "󰸡";
}

.mdi-checkbook::before {
  content: "󰪝";
}

.mdi-checkbox-blank::before {
  content: "󰄮";
}

.mdi-checkbox-blank-badge::before {
  content: "󱅶";
}

.mdi-checkbox-blank-badge-outline::before {
  content: "󰄗";
}

.mdi-checkbox-blank-circle::before {
  content: "󰄯";
}

.mdi-checkbox-blank-circle-outline::before {
  content: "󰄰";
}

.mdi-checkbox-blank-off::before {
  content: "󱋬";
}

.mdi-checkbox-blank-off-outline::before {
  content: "󱋭";
}

.mdi-checkbox-blank-outline::before {
  content: "󰄱";
}

.mdi-checkbox-intermediate::before {
  content: "󰡖";
}

.mdi-checkbox-marked::before {
  content: "󰄲";
}

.mdi-checkbox-marked-circle::before {
  content: "󰄳";
}

.mdi-checkbox-marked-circle-outline::before {
  content: "󰄴";
}

.mdi-checkbox-marked-circle-plus-outline::before {
  content: "󱤧";
}

.mdi-checkbox-marked-outline::before {
  content: "󰄵";
}

.mdi-checkbox-multiple-blank::before {
  content: "󰄶";
}

.mdi-checkbox-multiple-blank-circle::before {
  content: "󰘻";
}

.mdi-checkbox-multiple-blank-circle-outline::before {
  content: "󰘼";
}

.mdi-checkbox-multiple-blank-outline::before {
  content: "󰄷";
}

.mdi-checkbox-multiple-marked::before {
  content: "󰄸";
}

.mdi-checkbox-multiple-marked-circle::before {
  content: "󰘽";
}

.mdi-checkbox-multiple-marked-circle-outline::before {
  content: "󰘾";
}

.mdi-checkbox-multiple-marked-outline::before {
  content: "󰄹";
}

.mdi-checkbox-multiple-outline::before {
  content: "󰱑";
}

.mdi-checkbox-outline::before {
  content: "󰱒";
}

.mdi-checkerboard::before {
  content: "󰄺";
}

.mdi-checkerboard-minus::before {
  content: "󱈂";
}

.mdi-checkerboard-plus::before {
  content: "󱈁";
}

.mdi-checkerboard-remove::before {
  content: "󱈃";
}

.mdi-cheese::before {
  content: "󱊹";
}

.mdi-cheese-off::before {
  content: "󱏮";
}

.mdi-chef-hat::before {
  content: "󰭼";
}

.mdi-chemical-weapon::before {
  content: "󰄻";
}

.mdi-chess-bishop::before {
  content: "󰡜";
}

.mdi-chess-king::before {
  content: "󰡗";
}

.mdi-chess-knight::before {
  content: "󰡘";
}

.mdi-chess-pawn::before {
  content: "󰡙";
}

.mdi-chess-queen::before {
  content: "󰡚";
}

.mdi-chess-rook::before {
  content: "󰡛";
}

.mdi-chevron-double-down::before {
  content: "󰄼";
}

.mdi-chevron-double-left::before {
  content: "󰄽";
}

.mdi-chevron-double-right::before {
  content: "󰄾";
}

.mdi-chevron-double-up::before {
  content: "󰄿";
}

.mdi-chevron-down::before {
  content: "󰅀";
}

.mdi-chevron-down-box::before {
  content: "󰧖";
}

.mdi-chevron-down-box-outline::before {
  content: "󰧗";
}

.mdi-chevron-down-circle::before {
  content: "󰬦";
}

.mdi-chevron-down-circle-outline::before {
  content: "󰬧";
}

.mdi-chevron-left::before {
  content: "󰅁";
}

.mdi-chevron-left-box::before {
  content: "󰧘";
}

.mdi-chevron-left-box-outline::before {
  content: "󰧙";
}

.mdi-chevron-left-circle::before {
  content: "󰬨";
}

.mdi-chevron-left-circle-outline::before {
  content: "󰬩";
}

.mdi-chevron-right::before {
  content: "󰅂";
}

.mdi-chevron-right-box::before {
  content: "󰧚";
}

.mdi-chevron-right-box-outline::before {
  content: "󰧛";
}

.mdi-chevron-right-circle::before {
  content: "󰬪";
}

.mdi-chevron-right-circle-outline::before {
  content: "󰬫";
}

.mdi-chevron-triple-down::before {
  content: "󰶹";
}

.mdi-chevron-triple-left::before {
  content: "󰶺";
}

.mdi-chevron-triple-right::before {
  content: "󰶻";
}

.mdi-chevron-triple-up::before {
  content: "󰶼";
}

.mdi-chevron-up::before {
  content: "󰅃";
}

.mdi-chevron-up-box::before {
  content: "󰧜";
}

.mdi-chevron-up-box-outline::before {
  content: "󰧝";
}

.mdi-chevron-up-circle::before {
  content: "󰬬";
}

.mdi-chevron-up-circle-outline::before {
  content: "󰬭";
}

.mdi-chili-alert::before {
  content: "󱟪";
}

.mdi-chili-alert-outline::before {
  content: "󱟫";
}

.mdi-chili-hot::before {
  content: "󰞲";
}

.mdi-chili-hot-outline::before {
  content: "󱟬";
}

.mdi-chili-medium::before {
  content: "󰞳";
}

.mdi-chili-medium-outline::before {
  content: "󱟭";
}

.mdi-chili-mild::before {
  content: "󰞴";
}

.mdi-chili-mild-outline::before {
  content: "󱟮";
}

.mdi-chili-off::before {
  content: "󱑧";
}

.mdi-chili-off-outline::before {
  content: "󱟯";
}

.mdi-chip::before {
  content: "󰘚";
}

.mdi-church::before {
  content: "󰅄";
}

.mdi-cigar::before {
  content: "󱆉";
}

.mdi-cigar-off::before {
  content: "󱐛";
}

.mdi-circle::before {
  content: "󰝥";
}

.mdi-circle-box::before {
  content: "󱗜";
}

.mdi-circle-box-outline::before {
  content: "󱗝";
}

.mdi-circle-double::before {
  content: "󰺕";
}

.mdi-circle-edit-outline::before {
  content: "󰣕";
}

.mdi-circle-expand::before {
  content: "󰺖";
}

.mdi-circle-half::before {
  content: "󱎕";
}

.mdi-circle-half-full::before {
  content: "󱎖";
}

.mdi-circle-medium::before {
  content: "󰧞";
}

.mdi-circle-multiple::before {
  content: "󰬸";
}

.mdi-circle-multiple-outline::before {
  content: "󰚕";
}

.mdi-circle-off-outline::before {
  content: "󱃓";
}

.mdi-circle-opacity::before {
  content: "󱡓";
}

.mdi-circle-outline::before {
  content: "󰝦";
}

.mdi-circle-slice-1::before {
  content: "󰪞";
}

.mdi-circle-slice-2::before {
  content: "󰪟";
}

.mdi-circle-slice-3::before {
  content: "󰪠";
}

.mdi-circle-slice-4::before {
  content: "󰪡";
}

.mdi-circle-slice-5::before {
  content: "󰪢";
}

.mdi-circle-slice-6::before {
  content: "󰪣";
}

.mdi-circle-slice-7::before {
  content: "󰪤";
}

.mdi-circle-slice-8::before {
  content: "󰪥";
}

.mdi-circle-small::before {
  content: "󰧟";
}

.mdi-circular-saw::before {
  content: "󰸢";
}

.mdi-city::before {
  content: "󰅆";
}

.mdi-city-variant::before {
  content: "󰨶";
}

.mdi-city-variant-outline::before {
  content: "󰨷";
}

.mdi-clipboard::before {
  content: "󰅇";
}

.mdi-clipboard-account::before {
  content: "󰅈";
}

.mdi-clipboard-account-outline::before {
  content: "󰱕";
}

.mdi-clipboard-alert::before {
  content: "󰅉";
}

.mdi-clipboard-alert-outline::before {
  content: "󰳷";
}

.mdi-clipboard-arrow-down::before {
  content: "󰅊";
}

.mdi-clipboard-arrow-down-outline::before {
  content: "󰱖";
}

.mdi-clipboard-arrow-left::before {
  content: "󰅋";
}

.mdi-clipboard-arrow-left-outline::before {
  content: "󰳸";
}

.mdi-clipboard-arrow-right::before {
  content: "󰳹";
}

.mdi-clipboard-arrow-right-outline::before {
  content: "󰳺";
}

.mdi-clipboard-arrow-up::before {
  content: "󰱗";
}

.mdi-clipboard-arrow-up-outline::before {
  content: "󰱘";
}

.mdi-clipboard-check::before {
  content: "󰅎";
}

.mdi-clipboard-check-multiple::before {
  content: "󱉣";
}

.mdi-clipboard-check-multiple-outline::before {
  content: "󱉤";
}

.mdi-clipboard-check-outline::before {
  content: "󰢨";
}

.mdi-clipboard-clock::before {
  content: "󱛢";
}

.mdi-clipboard-clock-outline::before {
  content: "󱛣";
}

.mdi-clipboard-edit::before {
  content: "󱓥";
}

.mdi-clipboard-edit-outline::before {
  content: "󱓦";
}

.mdi-clipboard-file::before {
  content: "󱉥";
}

.mdi-clipboard-file-outline::before {
  content: "󱉦";
}

.mdi-clipboard-flow::before {
  content: "󰛈";
}

.mdi-clipboard-flow-outline::before {
  content: "󱄗";
}

.mdi-clipboard-list::before {
  content: "󱃔";
}

.mdi-clipboard-list-outline::before {
  content: "󱃕";
}

.mdi-clipboard-minus::before {
  content: "󱘘";
}

.mdi-clipboard-minus-outline::before {
  content: "󱘙";
}

.mdi-clipboard-multiple::before {
  content: "󱉧";
}

.mdi-clipboard-multiple-outline::before {
  content: "󱉨";
}

.mdi-clipboard-off::before {
  content: "󱘚";
}

.mdi-clipboard-off-outline::before {
  content: "󱘛";
}

.mdi-clipboard-outline::before {
  content: "󰅌";
}

.mdi-clipboard-play::before {
  content: "󰱙";
}

.mdi-clipboard-play-multiple::before {
  content: "󱉩";
}

.mdi-clipboard-play-multiple-outline::before {
  content: "󱉪";
}

.mdi-clipboard-play-outline::before {
  content: "󰱚";
}

.mdi-clipboard-plus::before {
  content: "󰝑";
}

.mdi-clipboard-plus-outline::before {
  content: "󱌟";
}

.mdi-clipboard-pulse::before {
  content: "󰡝";
}

.mdi-clipboard-pulse-outline::before {
  content: "󰡞";
}

.mdi-clipboard-remove::before {
  content: "󱘜";
}

.mdi-clipboard-remove-outline::before {
  content: "󱘝";
}

.mdi-clipboard-search::before {
  content: "󱘞";
}

.mdi-clipboard-search-outline::before {
  content: "󱘟";
}

.mdi-clipboard-text::before {
  content: "󰅍";
}

.mdi-clipboard-text-clock::before {
  content: "󱣹";
}

.mdi-clipboard-text-clock-outline::before {
  content: "󱣺";
}

.mdi-clipboard-text-multiple::before {
  content: "󱉫";
}

.mdi-clipboard-text-multiple-outline::before {
  content: "󱉬";
}

.mdi-clipboard-text-off::before {
  content: "󱘠";
}

.mdi-clipboard-text-off-outline::before {
  content: "󱘡";
}

.mdi-clipboard-text-outline::before {
  content: "󰨸";
}

.mdi-clipboard-text-play::before {
  content: "󰱛";
}

.mdi-clipboard-text-play-outline::before {
  content: "󰱜";
}

.mdi-clipboard-text-search::before {
  content: "󱘢";
}

.mdi-clipboard-text-search-outline::before {
  content: "󱘣";
}

.mdi-clippy::before {
  content: "󰅏";
}

.mdi-clock::before {
  content: "󰥔";
}

.mdi-clock-alert::before {
  content: "󰥕";
}

.mdi-clock-alert-outline::before {
  content: "󰗎";
}

.mdi-clock-check::before {
  content: "󰾨";
}

.mdi-clock-check-outline::before {
  content: "󰾩";
}

.mdi-clock-digital::before {
  content: "󰺗";
}

.mdi-clock-edit::before {
  content: "󱦺";
}

.mdi-clock-edit-outline::before {
  content: "󱦻";
}

.mdi-clock-end::before {
  content: "󰅑";
}

.mdi-clock-fast::before {
  content: "󰅒";
}

.mdi-clock-in::before {
  content: "󰅓";
}

.mdi-clock-minus::before {
  content: "󱡣";
}

.mdi-clock-minus-outline::before {
  content: "󱡤";
}

.mdi-clock-out::before {
  content: "󰅔";
}

.mdi-clock-outline::before {
  content: "󰅐";
}

.mdi-clock-plus::before {
  content: "󱡡";
}

.mdi-clock-plus-outline::before {
  content: "󱡢";
}

.mdi-clock-remove::before {
  content: "󱡥";
}

.mdi-clock-remove-outline::before {
  content: "󱡦";
}

.mdi-clock-start::before {
  content: "󰅕";
}

.mdi-clock-time-eight::before {
  content: "󱑆";
}

.mdi-clock-time-eight-outline::before {
  content: "󱑒";
}

.mdi-clock-time-eleven::before {
  content: "󱑉";
}

.mdi-clock-time-eleven-outline::before {
  content: "󱑕";
}

.mdi-clock-time-five::before {
  content: "󱑃";
}

.mdi-clock-time-five-outline::before {
  content: "󱑏";
}

.mdi-clock-time-four::before {
  content: "󱑂";
}

.mdi-clock-time-four-outline::before {
  content: "󱑎";
}

.mdi-clock-time-nine::before {
  content: "󱑇";
}

.mdi-clock-time-nine-outline::before {
  content: "󱑓";
}

.mdi-clock-time-one::before {
  content: "󱐿";
}

.mdi-clock-time-one-outline::before {
  content: "󱑋";
}

.mdi-clock-time-seven::before {
  content: "󱑅";
}

.mdi-clock-time-seven-outline::before {
  content: "󱑑";
}

.mdi-clock-time-six::before {
  content: "󱑄";
}

.mdi-clock-time-six-outline::before {
  content: "󱑐";
}

.mdi-clock-time-ten::before {
  content: "󱑈";
}

.mdi-clock-time-ten-outline::before {
  content: "󱑔";
}

.mdi-clock-time-three::before {
  content: "󱑁";
}

.mdi-clock-time-three-outline::before {
  content: "󱑍";
}

.mdi-clock-time-twelve::before {
  content: "󱑊";
}

.mdi-clock-time-twelve-outline::before {
  content: "󱑖";
}

.mdi-clock-time-two::before {
  content: "󱑀";
}

.mdi-clock-time-two-outline::before {
  content: "󱑌";
}

.mdi-close::before {
  content: "󰅖";
}

.mdi-close-box::before {
  content: "󰅗";
}

.mdi-close-box-multiple::before {
  content: "󰱝";
}

.mdi-close-box-multiple-outline::before {
  content: "󰱞";
}

.mdi-close-box-outline::before {
  content: "󰅘";
}

.mdi-close-circle::before {
  content: "󰅙";
}

.mdi-close-circle-multiple::before {
  content: "󰘪";
}

.mdi-close-circle-multiple-outline::before {
  content: "󰢃";
}

.mdi-close-circle-outline::before {
  content: "󰅚";
}

.mdi-close-network::before {
  content: "󰅛";
}

.mdi-close-network-outline::before {
  content: "󰱟";
}

.mdi-close-octagon::before {
  content: "󰅜";
}

.mdi-close-octagon-outline::before {
  content: "󰅝";
}

.mdi-close-outline::before {
  content: "󰛉";
}

.mdi-close-thick::before {
  content: "󱎘";
}

.mdi-closed-caption::before {
  content: "󰅞";
}

.mdi-closed-caption-outline::before {
  content: "󰶽";
}

.mdi-cloud::before {
  content: "󰅟";
}

.mdi-cloud-alert::before {
  content: "󰧠";
}

.mdi-cloud-braces::before {
  content: "󰞵";
}

.mdi-cloud-check::before {
  content: "󰅠";
}

.mdi-cloud-check-outline::before {
  content: "󱋌";
}

.mdi-cloud-circle::before {
  content: "󰅡";
}

.mdi-cloud-download::before {
  content: "󰅢";
}

.mdi-cloud-download-outline::before {
  content: "󰭽";
}

.mdi-cloud-lock::before {
  content: "󱇱";
}

.mdi-cloud-lock-outline::before {
  content: "󱇲";
}

.mdi-cloud-off-outline::before {
  content: "󰅤";
}

.mdi-cloud-outline::before {
  content: "󰅣";
}

.mdi-cloud-print::before {
  content: "󰅥";
}

.mdi-cloud-print-outline::before {
  content: "󰅦";
}

.mdi-cloud-question::before {
  content: "󰨹";
}

.mdi-cloud-refresh::before {
  content: "󰔪";
}

.mdi-cloud-search::before {
  content: "󰥖";
}

.mdi-cloud-search-outline::before {
  content: "󰥗";
}

.mdi-cloud-sync::before {
  content: "󰘿";
}

.mdi-cloud-sync-outline::before {
  content: "󱋖";
}

.mdi-cloud-tags::before {
  content: "󰞶";
}

.mdi-cloud-upload::before {
  content: "󰅧";
}

.mdi-cloud-upload-outline::before {
  content: "󰭾";
}

.mdi-clover::before {
  content: "󰠖";
}

.mdi-coach-lamp::before {
  content: "󱀠";
}

.mdi-coat-rack::before {
  content: "󱂞";
}

.mdi-code-array::before {
  content: "󰅨";
}

.mdi-code-braces::before {
  content: "󰅩";
}

.mdi-code-braces-box::before {
  content: "󱃖";
}

.mdi-code-brackets::before {
  content: "󰅪";
}

.mdi-code-equal::before {
  content: "󰅫";
}

.mdi-code-greater-than::before {
  content: "󰅬";
}

.mdi-code-greater-than-or-equal::before {
  content: "󰅭";
}

.mdi-code-json::before {
  content: "󰘦";
}

.mdi-code-less-than::before {
  content: "󰅮";
}

.mdi-code-less-than-or-equal::before {
  content: "󰅯";
}

.mdi-code-not-equal::before {
  content: "󰅰";
}

.mdi-code-not-equal-variant::before {
  content: "󰅱";
}

.mdi-code-parentheses::before {
  content: "󰅲";
}

.mdi-code-parentheses-box::before {
  content: "󱃗";
}

.mdi-code-string::before {
  content: "󰅳";
}

.mdi-code-tags::before {
  content: "󰅴";
}

.mdi-code-tags-check::before {
  content: "󰚔";
}

.mdi-codepen::before {
  content: "󰅵";
}

.mdi-coffee::before {
  content: "󰅶";
}

.mdi-coffee-maker::before {
  content: "󱂟";
}

.mdi-coffee-maker-check::before {
  content: "󱤱";
}

.mdi-coffee-maker-check-outline::before {
  content: "󱤲";
}

.mdi-coffee-maker-outline::before {
  content: "󱠛";
}

.mdi-coffee-off::before {
  content: "󰾪";
}

.mdi-coffee-off-outline::before {
  content: "󰾫";
}

.mdi-coffee-outline::before {
  content: "󰛊";
}

.mdi-coffee-to-go::before {
  content: "󰅷";
}

.mdi-coffee-to-go-outline::before {
  content: "󱌎";
}

.mdi-coffin::before {
  content: "󰭿";
}

.mdi-cog::before {
  content: "󰒓";
}

.mdi-cog-box::before {
  content: "󰒔";
}

.mdi-cog-clockwise::before {
  content: "󱇝";
}

.mdi-cog-counterclockwise::before {
  content: "󱇞";
}

.mdi-cog-off::before {
  content: "󱏎";
}

.mdi-cog-off-outline::before {
  content: "󱏏";
}

.mdi-cog-outline::before {
  content: "󰢻";
}

.mdi-cog-pause::before {
  content: "󱤳";
}

.mdi-cog-pause-outline::before {
  content: "󱤴";
}

.mdi-cog-play::before {
  content: "󱤵";
}

.mdi-cog-play-outline::before {
  content: "󱤶";
}

.mdi-cog-refresh::before {
  content: "󱑞";
}

.mdi-cog-refresh-outline::before {
  content: "󱑟";
}

.mdi-cog-stop::before {
  content: "󱤷";
}

.mdi-cog-stop-outline::before {
  content: "󱤸";
}

.mdi-cog-sync::before {
  content: "󱑠";
}

.mdi-cog-sync-outline::before {
  content: "󱑡";
}

.mdi-cog-transfer::before {
  content: "󱁛";
}

.mdi-cog-transfer-outline::before {
  content: "󱁜";
}

.mdi-cogs::before {
  content: "󰣖";
}

.mdi-collage::before {
  content: "󰙀";
}

.mdi-collapse-all::before {
  content: "󰪦";
}

.mdi-collapse-all-outline::before {
  content: "󰪧";
}

.mdi-color-helper::before {
  content: "󰅹";
}

.mdi-comma::before {
  content: "󰸣";
}

.mdi-comma-box::before {
  content: "󰸫";
}

.mdi-comma-box-outline::before {
  content: "󰸤";
}

.mdi-comma-circle::before {
  content: "󰸥";
}

.mdi-comma-circle-outline::before {
  content: "󰸦";
}

.mdi-comment::before {
  content: "󰅺";
}

.mdi-comment-account::before {
  content: "󰅻";
}

.mdi-comment-account-outline::before {
  content: "󰅼";
}

.mdi-comment-alert::before {
  content: "󰅽";
}

.mdi-comment-alert-outline::before {
  content: "󰅾";
}

.mdi-comment-arrow-left::before {
  content: "󰧡";
}

.mdi-comment-arrow-left-outline::before {
  content: "󰧢";
}

.mdi-comment-arrow-right::before {
  content: "󰧣";
}

.mdi-comment-arrow-right-outline::before {
  content: "󰧤";
}

.mdi-comment-bookmark::before {
  content: "󱖮";
}

.mdi-comment-bookmark-outline::before {
  content: "󱖯";
}

.mdi-comment-check::before {
  content: "󰅿";
}

.mdi-comment-check-outline::before {
  content: "󰆀";
}

.mdi-comment-edit::before {
  content: "󱆿";
}

.mdi-comment-edit-outline::before {
  content: "󱋄";
}

.mdi-comment-eye::before {
  content: "󰨺";
}

.mdi-comment-eye-outline::before {
  content: "󰨻";
}

.mdi-comment-flash::before {
  content: "󱖰";
}

.mdi-comment-flash-outline::before {
  content: "󱖱";
}

.mdi-comment-minus::before {
  content: "󱗟";
}

.mdi-comment-minus-outline::before {
  content: "󱗠";
}

.mdi-comment-multiple::before {
  content: "󰡟";
}

.mdi-comment-multiple-outline::before {
  content: "󰆁";
}

.mdi-comment-off::before {
  content: "󱗡";
}

.mdi-comment-off-outline::before {
  content: "󱗢";
}

.mdi-comment-outline::before {
  content: "󰆂";
}

.mdi-comment-plus::before {
  content: "󰧥";
}

.mdi-comment-plus-outline::before {
  content: "󰆃";
}

.mdi-comment-processing::before {
  content: "󰆄";
}

.mdi-comment-processing-outline::before {
  content: "󰆅";
}

.mdi-comment-question::before {
  content: "󰠗";
}

.mdi-comment-question-outline::before {
  content: "󰆆";
}

.mdi-comment-quote::before {
  content: "󱀡";
}

.mdi-comment-quote-outline::before {
  content: "󱀢";
}

.mdi-comment-remove::before {
  content: "󰗞";
}

.mdi-comment-remove-outline::before {
  content: "󰆇";
}

.mdi-comment-search::before {
  content: "󰨼";
}

.mdi-comment-search-outline::before {
  content: "󰨽";
}

.mdi-comment-text::before {
  content: "󰆈";
}

.mdi-comment-text-multiple::before {
  content: "󰡠";
}

.mdi-comment-text-multiple-outline::before {
  content: "󰡡";
}

.mdi-comment-text-outline::before {
  content: "󰆉";
}

.mdi-compare::before {
  content: "󰆊";
}

.mdi-compare-horizontal::before {
  content: "󱒒";
}

.mdi-compare-remove::before {
  content: "󱢳";
}

.mdi-compare-vertical::before {
  content: "󱒓";
}

.mdi-compass::before {
  content: "󰆋";
}

.mdi-compass-off::before {
  content: "󰮀";
}

.mdi-compass-off-outline::before {
  content: "󰮁";
}

.mdi-compass-outline::before {
  content: "󰆌";
}

.mdi-compass-rose::before {
  content: "󱎂";
}

.mdi-cone::before {
  content: "󱥌";
}

.mdi-cone-off::before {
  content: "󱥍";
}

.mdi-connection::before {
  content: "󱘖";
}

.mdi-console::before {
  content: "󰆍";
}

.mdi-console-line::before {
  content: "󰞷";
}

.mdi-console-network::before {
  content: "󰢩";
}

.mdi-console-network-outline::before {
  content: "󰱠";
}

.mdi-consolidate::before {
  content: "󱃘";
}

.mdi-contactless-payment::before {
  content: "󰵪";
}

.mdi-contactless-payment-circle::before {
  content: "󰌡";
}

.mdi-contactless-payment-circle-outline::before {
  content: "󰐈";
}

.mdi-contacts::before {
  content: "󰛋";
}

.mdi-contacts-outline::before {
  content: "󰖸";
}

.mdi-contain::before {
  content: "󰨾";
}

.mdi-contain-end::before {
  content: "󰨿";
}

.mdi-contain-start::before {
  content: "󰩀";
}

.mdi-content-copy::before {
  content: "󰆏";
}

.mdi-content-cut::before {
  content: "󰆐";
}

.mdi-content-duplicate::before {
  content: "󰆑";
}

.mdi-content-paste::before {
  content: "󰆒";
}

.mdi-content-save::before {
  content: "󰆓";
}

.mdi-content-save-alert::before {
  content: "󰽂";
}

.mdi-content-save-alert-outline::before {
  content: "󰽃";
}

.mdi-content-save-all::before {
  content: "󰆔";
}

.mdi-content-save-all-outline::before {
  content: "󰽄";
}

.mdi-content-save-check::before {
  content: "󱣪";
}

.mdi-content-save-check-outline::before {
  content: "󱣫";
}

.mdi-content-save-cog::before {
  content: "󱑛";
}

.mdi-content-save-cog-outline::before {
  content: "󱑜";
}

.mdi-content-save-edit::before {
  content: "󰳻";
}

.mdi-content-save-edit-outline::before {
  content: "󰳼";
}

.mdi-content-save-move::before {
  content: "󰸧";
}

.mdi-content-save-move-outline::before {
  content: "󰸨";
}

.mdi-content-save-off::before {
  content: "󱙃";
}

.mdi-content-save-off-outline::before {
  content: "󱙄";
}

.mdi-content-save-outline::before {
  content: "󰠘";
}

.mdi-content-save-settings::before {
  content: "󰘛";
}

.mdi-content-save-settings-outline::before {
  content: "󰬮";
}

.mdi-contrast::before {
  content: "󰆕";
}

.mdi-contrast-box::before {
  content: "󰆖";
}

.mdi-contrast-circle::before {
  content: "󰆗";
}

.mdi-controller-classic::before {
  content: "󰮂";
}

.mdi-controller-classic-outline::before {
  content: "󰮃";
}

.mdi-cookie::before {
  content: "󰆘";
}

.mdi-cookie-alert::before {
  content: "󱛐";
}

.mdi-cookie-alert-outline::before {
  content: "󱛑";
}

.mdi-cookie-check::before {
  content: "󱛒";
}

.mdi-cookie-check-outline::before {
  content: "󱛓";
}

.mdi-cookie-clock::before {
  content: "󱛤";
}

.mdi-cookie-clock-outline::before {
  content: "󱛥";
}

.mdi-cookie-cog::before {
  content: "󱛔";
}

.mdi-cookie-cog-outline::before {
  content: "󱛕";
}

.mdi-cookie-edit::before {
  content: "󱛦";
}

.mdi-cookie-edit-outline::before {
  content: "󱛧";
}

.mdi-cookie-lock::before {
  content: "󱛨";
}

.mdi-cookie-lock-outline::before {
  content: "󱛩";
}

.mdi-cookie-minus::before {
  content: "󱛚";
}

.mdi-cookie-minus-outline::before {
  content: "󱛛";
}

.mdi-cookie-off::before {
  content: "󱛪";
}

.mdi-cookie-off-outline::before {
  content: "󱛫";
}

.mdi-cookie-outline::before {
  content: "󱛞";
}

.mdi-cookie-plus::before {
  content: "󱛖";
}

.mdi-cookie-plus-outline::before {
  content: "󱛗";
}

.mdi-cookie-refresh::before {
  content: "󱛬";
}

.mdi-cookie-refresh-outline::before {
  content: "󱛭";
}

.mdi-cookie-remove::before {
  content: "󱛘";
}

.mdi-cookie-remove-outline::before {
  content: "󱛙";
}

.mdi-cookie-settings::before {
  content: "󱛜";
}

.mdi-cookie-settings-outline::before {
  content: "󱛝";
}

.mdi-coolant-temperature::before {
  content: "󰏈";
}

.mdi-copyleft::before {
  content: "󱤹";
}

.mdi-copyright::before {
  content: "󰗦";
}

.mdi-cordova::before {
  content: "󰥘";
}

.mdi-corn::before {
  content: "󰞸";
}

.mdi-corn-off::before {
  content: "󱏯";
}

.mdi-cosine-wave::before {
  content: "󱑹";
}

.mdi-counter::before {
  content: "󰆙";
}

.mdi-countertop::before {
  content: "󱠜";
}

.mdi-countertop-outline::before {
  content: "󱠝";
}

.mdi-cow::before {
  content: "󰆚";
}

.mdi-cow-off::before {
  content: "󱣼";
}

.mdi-cpu-32-bit::before {
  content: "󰻟";
}

.mdi-cpu-64-bit::before {
  content: "󰻠";
}

.mdi-cradle::before {
  content: "󱦋";
}

.mdi-cradle-outline::before {
  content: "󱦑";
}

.mdi-crane::before {
  content: "󰡢";
}

.mdi-creation::before {
  content: "󰙴";
}

.mdi-creative-commons::before {
  content: "󰵫";
}

.mdi-credit-card::before {
  content: "󰿯";
}

.mdi-credit-card-check::before {
  content: "󱏐";
}

.mdi-credit-card-check-outline::before {
  content: "󱏑";
}

.mdi-credit-card-chip::before {
  content: "󱤏";
}

.mdi-credit-card-chip-outline::before {
  content: "󱤐";
}

.mdi-credit-card-clock::before {
  content: "󰻡";
}

.mdi-credit-card-clock-outline::before {
  content: "󰻢";
}

.mdi-credit-card-edit::before {
  content: "󱟗";
}

.mdi-credit-card-edit-outline::before {
  content: "󱟘";
}

.mdi-credit-card-fast::before {
  content: "󱤑";
}

.mdi-credit-card-fast-outline::before {
  content: "󱤒";
}

.mdi-credit-card-lock::before {
  content: "󱣧";
}

.mdi-credit-card-lock-outline::before {
  content: "󱣨";
}

.mdi-credit-card-marker::before {
  content: "󰚨";
}

.mdi-credit-card-marker-outline::before {
  content: "󰶾";
}

.mdi-credit-card-minus::before {
  content: "󰾬";
}

.mdi-credit-card-minus-outline::before {
  content: "󰾭";
}

.mdi-credit-card-multiple::before {
  content: "󰿰";
}

.mdi-credit-card-multiple-outline::before {
  content: "󰆜";
}

.mdi-credit-card-off::before {
  content: "󰿱";
}

.mdi-credit-card-off-outline::before {
  content: "󰗤";
}

.mdi-credit-card-outline::before {
  content: "󰆛";
}

.mdi-credit-card-plus::before {
  content: "󰿲";
}

.mdi-credit-card-plus-outline::before {
  content: "󰙶";
}

.mdi-credit-card-refresh::before {
  content: "󱙅";
}

.mdi-credit-card-refresh-outline::before {
  content: "󱙆";
}

.mdi-credit-card-refund::before {
  content: "󰿳";
}

.mdi-credit-card-refund-outline::before {
  content: "󰪨";
}

.mdi-credit-card-remove::before {
  content: "󰾮";
}

.mdi-credit-card-remove-outline::before {
  content: "󰾯";
}

.mdi-credit-card-scan::before {
  content: "󰿴";
}

.mdi-credit-card-scan-outline::before {
  content: "󰆝";
}

.mdi-credit-card-search::before {
  content: "󱙇";
}

.mdi-credit-card-search-outline::before {
  content: "󱙈";
}

.mdi-credit-card-settings::before {
  content: "󰿵";
}

.mdi-credit-card-settings-outline::before {
  content: "󰣗";
}

.mdi-credit-card-sync::before {
  content: "󱙉";
}

.mdi-credit-card-sync-outline::before {
  content: "󱙊";
}

.mdi-credit-card-wireless::before {
  content: "󰠂";
}

.mdi-credit-card-wireless-off::before {
  content: "󰕺";
}

.mdi-credit-card-wireless-off-outline::before {
  content: "󰕻";
}

.mdi-credit-card-wireless-outline::before {
  content: "󰵬";
}

.mdi-cricket::before {
  content: "󰵭";
}

.mdi-crop::before {
  content: "󰆞";
}

.mdi-crop-free::before {
  content: "󰆟";
}

.mdi-crop-landscape::before {
  content: "󰆠";
}

.mdi-crop-portrait::before {
  content: "󰆡";
}

.mdi-crop-rotate::before {
  content: "󰚖";
}

.mdi-crop-square::before {
  content: "󰆢";
}

.mdi-cross::before {
  content: "󰥓";
}

.mdi-cross-bolnisi::before {
  content: "󰳭";
}

.mdi-cross-celtic::before {
  content: "󰳵";
}

.mdi-cross-outline::before {
  content: "󰳶";
}

.mdi-crosshairs::before {
  content: "󰆣";
}

.mdi-crosshairs-gps::before {
  content: "󰆤";
}

.mdi-crosshairs-off::before {
  content: "󰽅";
}

.mdi-crosshairs-question::before {
  content: "󱄶";
}

.mdi-crowd::before {
  content: "󱥵";
}

.mdi-crown::before {
  content: "󰆥";
}

.mdi-crown-circle::before {
  content: "󱟜";
}

.mdi-crown-circle-outline::before {
  content: "󱟝";
}

.mdi-crown-outline::before {
  content: "󱇐";
}

.mdi-cryengine::before {
  content: "󰥙";
}

.mdi-crystal-ball::before {
  content: "󰬯";
}

.mdi-cube::before {
  content: "󰆦";
}

.mdi-cube-off::before {
  content: "󱐜";
}

.mdi-cube-off-outline::before {
  content: "󱐝";
}

.mdi-cube-outline::before {
  content: "󰆧";
}

.mdi-cube-scan::before {
  content: "󰮄";
}

.mdi-cube-send::before {
  content: "󰆨";
}

.mdi-cube-unfolded::before {
  content: "󰆩";
}

.mdi-cup::before {
  content: "󰆪";
}

.mdi-cup-off::before {
  content: "󰗥";
}

.mdi-cup-off-outline::before {
  content: "󱍽";
}

.mdi-cup-outline::before {
  content: "󱌏";
}

.mdi-cup-water::before {
  content: "󰆫";
}

.mdi-cupboard::before {
  content: "󰽆";
}

.mdi-cupboard-outline::before {
  content: "󰽇";
}

.mdi-cupcake::before {
  content: "󰥚";
}

.mdi-curling::before {
  content: "󰡣";
}

.mdi-currency-bdt::before {
  content: "󰡤";
}

.mdi-currency-brl::before {
  content: "󰮅";
}

.mdi-currency-btc::before {
  content: "󰆬";
}

.mdi-currency-cny::before {
  content: "󰞺";
}

.mdi-currency-eth::before {
  content: "󰞻";
}

.mdi-currency-eur::before {
  content: "󰆭";
}

.mdi-currency-eur-off::before {
  content: "󱌕";
}

.mdi-currency-gbp::before {
  content: "󰆮";
}

.mdi-currency-ils::before {
  content: "󰱡";
}

.mdi-currency-inr::before {
  content: "󰆯";
}

.mdi-currency-jpy::before {
  content: "󰞼";
}

.mdi-currency-krw::before {
  content: "󰞽";
}

.mdi-currency-kzt::before {
  content: "󰡥";
}

.mdi-currency-mnt::before {
  content: "󱔒";
}

.mdi-currency-ngn::before {
  content: "󰆰";
}

.mdi-currency-php::before {
  content: "󰧦";
}

.mdi-currency-rial::before {
  content: "󰺜";
}

.mdi-currency-rub::before {
  content: "󰆱";
}

.mdi-currency-rupee::before {
  content: "󱥶";
}

.mdi-currency-sign::before {
  content: "󰞾";
}

.mdi-currency-try::before {
  content: "󰆲";
}

.mdi-currency-twd::before {
  content: "󰞿";
}

.mdi-currency-usd::before {
  content: "󰇁";
}

.mdi-currency-usd-off::before {
  content: "󰙺";
}

.mdi-current-ac::before {
  content: "󱒀";
}

.mdi-current-dc::before {
  content: "󰥜";
}

.mdi-cursor-default::before {
  content: "󰇀";
}

.mdi-cursor-default-click::before {
  content: "󰳽";
}

.mdi-cursor-default-click-outline::before {
  content: "󰳾";
}

.mdi-cursor-default-gesture::before {
  content: "󱄧";
}

.mdi-cursor-default-gesture-outline::before {
  content: "󱄨";
}

.mdi-cursor-default-outline::before {
  content: "󰆿";
}

.mdi-cursor-move::before {
  content: "󰆾";
}

.mdi-cursor-pointer::before {
  content: "󰆽";
}

.mdi-cursor-text::before {
  content: "󰗧";
}

.mdi-curtains::before {
  content: "󱡆";
}

.mdi-curtains-closed::before {
  content: "󱡇";
}

.mdi-cylinder::before {
  content: "󱥎";
}

.mdi-cylinder-off::before {
  content: "󱥏";
}

.mdi-dance-ballroom::before {
  content: "󱗻";
}

.mdi-dance-pole::before {
  content: "󱕸";
}

.mdi-data-matrix::before {
  content: "󱔼";
}

.mdi-data-matrix-edit::before {
  content: "󱔽";
}

.mdi-data-matrix-minus::before {
  content: "󱔾";
}

.mdi-data-matrix-plus::before {
  content: "󱔿";
}

.mdi-data-matrix-remove::before {
  content: "󱕀";
}

.mdi-data-matrix-scan::before {
  content: "󱕁";
}

.mdi-database::before {
  content: "󰆼";
}

.mdi-database-alert::before {
  content: "󱘺";
}

.mdi-database-alert-outline::before {
  content: "󱘤";
}

.mdi-database-arrow-down::before {
  content: "󱘻";
}

.mdi-database-arrow-down-outline::before {
  content: "󱘥";
}

.mdi-database-arrow-left::before {
  content: "󱘼";
}

.mdi-database-arrow-left-outline::before {
  content: "󱘦";
}

.mdi-database-arrow-right::before {
  content: "󱘽";
}

.mdi-database-arrow-right-outline::before {
  content: "󱘧";
}

.mdi-database-arrow-up::before {
  content: "󱘾";
}

.mdi-database-arrow-up-outline::before {
  content: "󱘨";
}

.mdi-database-check::before {
  content: "󰪩";
}

.mdi-database-check-outline::before {
  content: "󱘩";
}

.mdi-database-clock::before {
  content: "󱘿";
}

.mdi-database-clock-outline::before {
  content: "󱘪";
}

.mdi-database-cog::before {
  content: "󱙋";
}

.mdi-database-cog-outline::before {
  content: "󱙌";
}

.mdi-database-edit::before {
  content: "󰮆";
}

.mdi-database-edit-outline::before {
  content: "󱘫";
}

.mdi-database-export::before {
  content: "󰥞";
}

.mdi-database-export-outline::before {
  content: "󱘬";
}

.mdi-database-eye::before {
  content: "󱤟";
}

.mdi-database-eye-off::before {
  content: "󱤠";
}

.mdi-database-eye-off-outline::before {
  content: "󱤡";
}

.mdi-database-eye-outline::before {
  content: "󱤢";
}

.mdi-database-import::before {
  content: "󰥝";
}

.mdi-database-import-outline::before {
  content: "󱘭";
}

.mdi-database-lock::before {
  content: "󰪪";
}

.mdi-database-lock-outline::before {
  content: "󱘮";
}

.mdi-database-marker::before {
  content: "󱋶";
}

.mdi-database-marker-outline::before {
  content: "󱘯";
}

.mdi-database-minus::before {
  content: "󰆻";
}

.mdi-database-minus-outline::before {
  content: "󱘰";
}

.mdi-database-off::before {
  content: "󱙀";
}

.mdi-database-off-outline::before {
  content: "󱘱";
}

.mdi-database-outline::before {
  content: "󱘲";
}

.mdi-database-plus::before {
  content: "󰆺";
}

.mdi-database-plus-outline::before {
  content: "󱘳";
}

.mdi-database-refresh::before {
  content: "󰗂";
}

.mdi-database-refresh-outline::before {
  content: "󱘴";
}

.mdi-database-remove::before {
  content: "󰴀";
}

.mdi-database-remove-outline::before {
  content: "󱘵";
}

.mdi-database-search::before {
  content: "󰡦";
}

.mdi-database-search-outline::before {
  content: "󱘶";
}

.mdi-database-settings::before {
  content: "󰴁";
}

.mdi-database-settings-outline::before {
  content: "󱘷";
}

.mdi-database-sync::before {
  content: "󰳿";
}

.mdi-database-sync-outline::before {
  content: "󱘸";
}

.mdi-death-star::before {
  content: "󰣘";
}

.mdi-death-star-variant::before {
  content: "󰣙";
}

.mdi-deathly-hallows::before {
  content: "󰮇";
}

.mdi-debian::before {
  content: "󰣚";
}

.mdi-debug-step-into::before {
  content: "󰆹";
}

.mdi-debug-step-out::before {
  content: "󰆸";
}

.mdi-debug-step-over::before {
  content: "󰆷";
}

.mdi-decagram::before {
  content: "󰝬";
}

.mdi-decagram-outline::before {
  content: "󰝭";
}

.mdi-decimal::before {
  content: "󱂡";
}

.mdi-decimal-comma::before {
  content: "󱂢";
}

.mdi-decimal-comma-decrease::before {
  content: "󱂣";
}

.mdi-decimal-comma-increase::before {
  content: "󱂤";
}

.mdi-decimal-decrease::before {
  content: "󰆶";
}

.mdi-decimal-increase::before {
  content: "󰆵";
}

.mdi-delete::before {
  content: "󰆴";
}

.mdi-delete-alert::before {
  content: "󱂥";
}

.mdi-delete-alert-outline::before {
  content: "󱂦";
}

.mdi-delete-circle::before {
  content: "󰚃";
}

.mdi-delete-circle-outline::before {
  content: "󰮈";
}

.mdi-delete-clock::before {
  content: "󱕖";
}

.mdi-delete-clock-outline::before {
  content: "󱕗";
}

.mdi-delete-empty::before {
  content: "󰛌";
}

.mdi-delete-empty-outline::before {
  content: "󰺝";
}

.mdi-delete-forever::before {
  content: "󰗨";
}

.mdi-delete-forever-outline::before {
  content: "󰮉";
}

.mdi-delete-off::before {
  content: "󱂧";
}

.mdi-delete-off-outline::before {
  content: "󱂨";
}

.mdi-delete-outline::before {
  content: "󰧧";
}

.mdi-delete-restore::before {
  content: "󰠙";
}

.mdi-delete-sweep::before {
  content: "󰗩";
}

.mdi-delete-sweep-outline::before {
  content: "󰱢";
}

.mdi-delete-variant::before {
  content: "󰆳";
}

.mdi-delta::before {
  content: "󰇂";
}

.mdi-desk::before {
  content: "󱈹";
}

.mdi-desk-lamp::before {
  content: "󰥟";
}

.mdi-deskphone::before {
  content: "󰇃";
}

.mdi-desktop-classic::before {
  content: "󰟀";
}

.mdi-desktop-mac::before {
  content: "󰇄";
}

.mdi-desktop-mac-dashboard::before {
  content: "󰧨";
}

.mdi-desktop-tower::before {
  content: "󰇅";
}

.mdi-desktop-tower-monitor::before {
  content: "󰪫";
}

.mdi-details::before {
  content: "󰇆";
}

.mdi-dev-to::before {
  content: "󰵮";
}

.mdi-developer-board::before {
  content: "󰚗";
}

.mdi-deviantart::before {
  content: "󰇇";
}

.mdi-devices::before {
  content: "󰾰";
}

.mdi-dharmachakra::before {
  content: "󰥋";
}

.mdi-diabetes::before {
  content: "󱄦";
}

.mdi-dialpad::before {
  content: "󰘜";
}

.mdi-diameter::before {
  content: "󰱣";
}

.mdi-diameter-outline::before {
  content: "󰱤";
}

.mdi-diameter-variant::before {
  content: "󰱥";
}

.mdi-diamond::before {
  content: "󰮊";
}

.mdi-diamond-outline::before {
  content: "󰮋";
}

.mdi-diamond-stone::before {
  content: "󰇈";
}

.mdi-dice-1::before {
  content: "󰇊";
}

.mdi-dice-1-outline::before {
  content: "󱅊";
}

.mdi-dice-2::before {
  content: "󰇋";
}

.mdi-dice-2-outline::before {
  content: "󱅋";
}

.mdi-dice-3::before {
  content: "󰇌";
}

.mdi-dice-3-outline::before {
  content: "󱅌";
}

.mdi-dice-4::before {
  content: "󰇍";
}

.mdi-dice-4-outline::before {
  content: "󱅍";
}

.mdi-dice-5::before {
  content: "󰇎";
}

.mdi-dice-5-outline::before {
  content: "󱅎";
}

.mdi-dice-6::before {
  content: "󰇏";
}

.mdi-dice-6-outline::before {
  content: "󱅏";
}

.mdi-dice-d10::before {
  content: "󱅓";
}

.mdi-dice-d10-outline::before {
  content: "󰝯";
}

.mdi-dice-d12::before {
  content: "󱅔";
}

.mdi-dice-d12-outline::before {
  content: "󰡧";
}

.mdi-dice-d20::before {
  content: "󱅕";
}

.mdi-dice-d20-outline::before {
  content: "󰗪";
}

.mdi-dice-d4::before {
  content: "󱅐";
}

.mdi-dice-d4-outline::before {
  content: "󰗫";
}

.mdi-dice-d6::before {
  content: "󱅑";
}

.mdi-dice-d6-outline::before {
  content: "󰗭";
}

.mdi-dice-d8::before {
  content: "󱅒";
}

.mdi-dice-d8-outline::before {
  content: "󰗬";
}

.mdi-dice-multiple::before {
  content: "󰝮";
}

.mdi-dice-multiple-outline::before {
  content: "󱅖";
}

.mdi-digital-ocean::before {
  content: "󱈷";
}

.mdi-dip-switch::before {
  content: "󰟁";
}

.mdi-directions::before {
  content: "󰇐";
}

.mdi-directions-fork::before {
  content: "󰙁";
}

.mdi-disc::before {
  content: "󰗮";
}

.mdi-disc-alert::before {
  content: "󰇑";
}

.mdi-disc-player::before {
  content: "󰥠";
}

.mdi-discord::before {
  content: "󰙯";
}

.mdi-dishwasher::before {
  content: "󰪬";
}

.mdi-dishwasher-alert::before {
  content: "󱆸";
}

.mdi-dishwasher-off::before {
  content: "󱆹";
}

.mdi-disqus::before {
  content: "󰇒";
}

.mdi-distribute-horizontal-center::before {
  content: "󱇉";
}

.mdi-distribute-horizontal-left::before {
  content: "󱇈";
}

.mdi-distribute-horizontal-right::before {
  content: "󱇊";
}

.mdi-distribute-vertical-bottom::before {
  content: "󱇋";
}

.mdi-distribute-vertical-center::before {
  content: "󱇌";
}

.mdi-distribute-vertical-top::before {
  content: "󱇍";
}

.mdi-diversify::before {
  content: "󱡷";
}

.mdi-diving::before {
  content: "󱥷";
}

.mdi-diving-flippers::before {
  content: "󰶿";
}

.mdi-diving-helmet::before {
  content: "󰷀";
}

.mdi-diving-scuba::before {
  content: "󰷁";
}

.mdi-diving-scuba-flag::before {
  content: "󰷂";
}

.mdi-diving-scuba-tank::before {
  content: "󰷃";
}

.mdi-diving-scuba-tank-multiple::before {
  content: "󰷄";
}

.mdi-diving-snorkel::before {
  content: "󰷅";
}

.mdi-division::before {
  content: "󰇔";
}

.mdi-division-box::before {
  content: "󰇕";
}

.mdi-dlna::before {
  content: "󰩁";
}

.mdi-dna::before {
  content: "󰚄";
}

.mdi-dns::before {
  content: "󰇖";
}

.mdi-dns-outline::before {
  content: "󰮌";
}

.mdi-dock-bottom::before {
  content: "󱂩";
}

.mdi-dock-left::before {
  content: "󱂪";
}

.mdi-dock-right::before {
  content: "󱂫";
}

.mdi-dock-top::before {
  content: "󱔓";
}

.mdi-dock-window::before {
  content: "󱂬";
}

.mdi-docker::before {
  content: "󰡨";
}

.mdi-doctor::before {
  content: "󰩂";
}

.mdi-dog::before {
  content: "󰩃";
}

.mdi-dog-service::before {
  content: "󰪭";
}

.mdi-dog-side::before {
  content: "󰩄";
}

.mdi-dog-side-off::before {
  content: "󱛮";
}

.mdi-dolby::before {
  content: "󰚳";
}

.mdi-dolly::before {
  content: "󰺞";
}

.mdi-dolphin::before {
  content: "󱢴";
}

.mdi-domain::before {
  content: "󰇗";
}

.mdi-domain-off::before {
  content: "󰵯";
}

.mdi-domain-plus::before {
  content: "󱂭";
}

.mdi-domain-remove::before {
  content: "󱂮";
}

.mdi-dome-light::before {
  content: "󱐞";
}

.mdi-domino-mask::before {
  content: "󱀣";
}

.mdi-donkey::before {
  content: "󰟂";
}

.mdi-door::before {
  content: "󰠚";
}

.mdi-door-closed::before {
  content: "󰠛";
}

.mdi-door-closed-lock::before {
  content: "󱂯";
}

.mdi-door-open::before {
  content: "󰠜";
}

.mdi-door-sliding::before {
  content: "󱠞";
}

.mdi-door-sliding-lock::before {
  content: "󱠟";
}

.mdi-door-sliding-open::before {
  content: "󱠠";
}

.mdi-doorbell::before {
  content: "󱋦";
}

.mdi-doorbell-video::before {
  content: "󰡩";
}

.mdi-dot-net::before {
  content: "󰪮";
}

.mdi-dots-circle::before {
  content: "󱥸";
}

.mdi-dots-grid::before {
  content: "󱗼";
}

.mdi-dots-hexagon::before {
  content: "󱗿";
}

.mdi-dots-horizontal::before {
  content: "󰇘";
}

.mdi-dots-horizontal-circle::before {
  content: "󰟃";
}

.mdi-dots-horizontal-circle-outline::before {
  content: "󰮍";
}

.mdi-dots-square::before {
  content: "󱗽";
}

.mdi-dots-triangle::before {
  content: "󱗾";
}

.mdi-dots-vertical::before {
  content: "󰇙";
}

.mdi-dots-vertical-circle::before {
  content: "󰟄";
}

.mdi-dots-vertical-circle-outline::before {
  content: "󰮎";
}

.mdi-download::before {
  content: "󰇚";
}

.mdi-download-box::before {
  content: "󱑢";
}

.mdi-download-box-outline::before {
  content: "󱑣";
}

.mdi-download-circle::before {
  content: "󱑤";
}

.mdi-download-circle-outline::before {
  content: "󱑥";
}

.mdi-download-lock::before {
  content: "󱌠";
}

.mdi-download-lock-outline::before {
  content: "󱌡";
}

.mdi-download-multiple::before {
  content: "󰧩";
}

.mdi-download-network::before {
  content: "󰛴";
}

.mdi-download-network-outline::before {
  content: "󰱦";
}

.mdi-download-off::before {
  content: "󱂰";
}

.mdi-download-off-outline::before {
  content: "󱂱";
}

.mdi-download-outline::before {
  content: "󰮏";
}

.mdi-drag::before {
  content: "󰇛";
}

.mdi-drag-horizontal::before {
  content: "󰇜";
}

.mdi-drag-horizontal-variant::before {
  content: "󱋰";
}

.mdi-drag-variant::before {
  content: "󰮐";
}

.mdi-drag-vertical::before {
  content: "󰇝";
}

.mdi-drag-vertical-variant::before {
  content: "󱋱";
}

.mdi-drama-masks::before {
  content: "󰴂";
}

.mdi-draw::before {
  content: "󰽉";
}

.mdi-draw-pen::before {
  content: "󱦹";
}

.mdi-drawing::before {
  content: "󰇞";
}

.mdi-drawing-box::before {
  content: "󰇟";
}

.mdi-dresser::before {
  content: "󰽊";
}

.mdi-dresser-outline::before {
  content: "󰽋";
}

.mdi-drone::before {
  content: "󰇢";
}

.mdi-dropbox::before {
  content: "󰇣";
}

.mdi-drupal::before {
  content: "󰇤";
}

.mdi-duck::before {
  content: "󰇥";
}

.mdi-dumbbell::before {
  content: "󰇦";
}

.mdi-dump-truck::before {
  content: "󰱧";
}

.mdi-ear-hearing::before {
  content: "󰟅";
}

.mdi-ear-hearing-off::before {
  content: "󰩅";
}

.mdi-earbuds::before {
  content: "󱡏";
}

.mdi-earbuds-off::before {
  content: "󱡐";
}

.mdi-earbuds-off-outline::before {
  content: "󱡑";
}

.mdi-earbuds-outline::before {
  content: "󱡒";
}

.mdi-earth::before {
  content: "󰇧";
}

.mdi-earth-arrow-right::before {
  content: "󱌑";
}

.mdi-earth-box::before {
  content: "󰛍";
}

.mdi-earth-box-minus::before {
  content: "󱐇";
}

.mdi-earth-box-off::before {
  content: "󰛎";
}

.mdi-earth-box-plus::before {
  content: "󱐆";
}

.mdi-earth-box-remove::before {
  content: "󱐈";
}

.mdi-earth-minus::before {
  content: "󱐄";
}

.mdi-earth-off::before {
  content: "󰇨";
}

.mdi-earth-plus::before {
  content: "󱐃";
}

.mdi-earth-remove::before {
  content: "󱐅";
}

.mdi-egg::before {
  content: "󰪯";
}

.mdi-egg-easter::before {
  content: "󰪰";
}

.mdi-egg-fried::before {
  content: "󱡊";
}

.mdi-egg-off::before {
  content: "󱏰";
}

.mdi-egg-off-outline::before {
  content: "󱏱";
}

.mdi-egg-outline::before {
  content: "󱏲";
}

.mdi-eiffel-tower::before {
  content: "󱕫";
}

.mdi-eight-track::before {
  content: "󰧪";
}

.mdi-eject::before {
  content: "󰇪";
}

.mdi-eject-outline::before {
  content: "󰮑";
}

.mdi-electric-switch::before {
  content: "󰺟";
}

.mdi-electric-switch-closed::before {
  content: "󱃙";
}

.mdi-electron-framework::before {
  content: "󱀤";
}

.mdi-elephant::before {
  content: "󰟆";
}

.mdi-elevation-decline::before {
  content: "󰇫";
}

.mdi-elevation-rise::before {
  content: "󰇬";
}

.mdi-elevator::before {
  content: "󰇭";
}

.mdi-elevator-down::before {
  content: "󱋂";
}

.mdi-elevator-passenger::before {
  content: "󱎁";
}

.mdi-elevator-passenger-off::before {
  content: "󱥹";
}

.mdi-elevator-passenger-off-outline::before {
  content: "󱥺";
}

.mdi-elevator-passenger-outline::before {
  content: "󱥻";
}

.mdi-elevator-up::before {
  content: "󱋁";
}

.mdi-ellipse::before {
  content: "󰺠";
}

.mdi-ellipse-outline::before {
  content: "󰺡";
}

.mdi-email::before {
  content: "󰇮";
}

.mdi-email-alert::before {
  content: "󰛏";
}

.mdi-email-alert-outline::before {
  content: "󰵂";
}

.mdi-email-box::before {
  content: "󰴃";
}

.mdi-email-check::before {
  content: "󰪱";
}

.mdi-email-check-outline::before {
  content: "󰪲";
}

.mdi-email-edit::before {
  content: "󰻣";
}

.mdi-email-edit-outline::before {
  content: "󰻤";
}

.mdi-email-fast::before {
  content: "󱡯";
}

.mdi-email-fast-outline::before {
  content: "󱡰";
}

.mdi-email-lock::before {
  content: "󰇱";
}

.mdi-email-mark-as-unread::before {
  content: "󰮒";
}

.mdi-email-minus::before {
  content: "󰻥";
}

.mdi-email-minus-outline::before {
  content: "󰻦";
}

.mdi-email-multiple::before {
  content: "󰻧";
}

.mdi-email-multiple-outline::before {
  content: "󰻨";
}

.mdi-email-newsletter::before {
  content: "󰾱";
}

.mdi-email-off::before {
  content: "󱏣";
}

.mdi-email-off-outline::before {
  content: "󱏤";
}

.mdi-email-open::before {
  content: "󰇯";
}

.mdi-email-open-multiple::before {
  content: "󰻩";
}

.mdi-email-open-multiple-outline::before {
  content: "󰻪";
}

.mdi-email-open-outline::before {
  content: "󰗯";
}

.mdi-email-outline::before {
  content: "󰇰";
}

.mdi-email-plus::before {
  content: "󰧫";
}

.mdi-email-plus-outline::before {
  content: "󰧬";
}

.mdi-email-receive::before {
  content: "󱃚";
}

.mdi-email-receive-outline::before {
  content: "󱃛";
}

.mdi-email-remove::before {
  content: "󱙡";
}

.mdi-email-remove-outline::before {
  content: "󱙢";
}

.mdi-email-seal::before {
  content: "󱥛";
}

.mdi-email-seal-outline::before {
  content: "󱥜";
}

.mdi-email-search::before {
  content: "󰥡";
}

.mdi-email-search-outline::before {
  content: "󰥢";
}

.mdi-email-send::before {
  content: "󱃜";
}

.mdi-email-send-outline::before {
  content: "󱃝";
}

.mdi-email-sync::before {
  content: "󱋇";
}

.mdi-email-sync-outline::before {
  content: "󱋈";
}

.mdi-email-variant::before {
  content: "󰗰";
}

.mdi-ember::before {
  content: "󰬰";
}

.mdi-emby::before {
  content: "󰚴";
}

.mdi-emoticon::before {
  content: "󰱨";
}

.mdi-emoticon-angry::before {
  content: "󰱩";
}

.mdi-emoticon-angry-outline::before {
  content: "󰱪";
}

.mdi-emoticon-confused::before {
  content: "󱃞";
}

.mdi-emoticon-confused-outline::before {
  content: "󱃟";
}

.mdi-emoticon-cool::before {
  content: "󰱫";
}

.mdi-emoticon-cool-outline::before {
  content: "󰇳";
}

.mdi-emoticon-cry::before {
  content: "󰱬";
}

.mdi-emoticon-cry-outline::before {
  content: "󰱭";
}

.mdi-emoticon-dead::before {
  content: "󰱮";
}

.mdi-emoticon-dead-outline::before {
  content: "󰚛";
}

.mdi-emoticon-devil::before {
  content: "󰱯";
}

.mdi-emoticon-devil-outline::before {
  content: "󰇴";
}

.mdi-emoticon-excited::before {
  content: "󰱰";
}

.mdi-emoticon-excited-outline::before {
  content: "󰚜";
}

.mdi-emoticon-frown::before {
  content: "󰽌";
}

.mdi-emoticon-frown-outline::before {
  content: "󰽍";
}

.mdi-emoticon-happy::before {
  content: "󰱱";
}

.mdi-emoticon-happy-outline::before {
  content: "󰇵";
}

.mdi-emoticon-kiss::before {
  content: "󰱲";
}

.mdi-emoticon-kiss-outline::before {
  content: "󰱳";
}

.mdi-emoticon-lol::before {
  content: "󱈔";
}

.mdi-emoticon-lol-outline::before {
  content: "󱈕";
}

.mdi-emoticon-neutral::before {
  content: "󰱴";
}

.mdi-emoticon-neutral-outline::before {
  content: "󰇶";
}

.mdi-emoticon-outline::before {
  content: "󰇲";
}

.mdi-emoticon-poop::before {
  content: "󰇷";
}

.mdi-emoticon-poop-outline::before {
  content: "󰱵";
}

.mdi-emoticon-sad::before {
  content: "󰱶";
}

.mdi-emoticon-sad-outline::before {
  content: "󰇸";
}

.mdi-emoticon-sick::before {
  content: "󱕼";
}

.mdi-emoticon-sick-outline::before {
  content: "󱕽";
}

.mdi-emoticon-tongue::before {
  content: "󰇹";
}

.mdi-emoticon-tongue-outline::before {
  content: "󰱷";
}

.mdi-emoticon-wink::before {
  content: "󰱸";
}

.mdi-emoticon-wink-outline::before {
  content: "󰱹";
}

.mdi-engine::before {
  content: "󰇺";
}

.mdi-engine-off::before {
  content: "󰩆";
}

.mdi-engine-off-outline::before {
  content: "󰩇";
}

.mdi-engine-outline::before {
  content: "󰇻";
}

.mdi-epsilon::before {
  content: "󱃠";
}

.mdi-equal::before {
  content: "󰇼";
}

.mdi-equal-box::before {
  content: "󰇽";
}

.mdi-equalizer::before {
  content: "󰺢";
}

.mdi-equalizer-outline::before {
  content: "󰺣";
}

.mdi-eraser::before {
  content: "󰇾";
}

.mdi-eraser-variant::before {
  content: "󰙂";
}

.mdi-escalator::before {
  content: "󰇿";
}

.mdi-escalator-box::before {
  content: "󱎙";
}

.mdi-escalator-down::before {
  content: "󱋀";
}

.mdi-escalator-up::before {
  content: "󱊿";
}

.mdi-eslint::before {
  content: "󰱺";
}

.mdi-et::before {
  content: "󰪳";
}

.mdi-ethereum::before {
  content: "󰡪";
}

.mdi-ethernet::before {
  content: "󰈀";
}

.mdi-ethernet-cable::before {
  content: "󰈁";
}

.mdi-ethernet-cable-off::before {
  content: "󰈂";
}

.mdi-ev-plug-ccs1::before {
  content: "󱔙";
}

.mdi-ev-plug-ccs2::before {
  content: "󱔚";
}

.mdi-ev-plug-chademo::before {
  content: "󱔛";
}

.mdi-ev-plug-tesla::before {
  content: "󱔜";
}

.mdi-ev-plug-type1::before {
  content: "󱔝";
}

.mdi-ev-plug-type2::before {
  content: "󱔞";
}

.mdi-ev-station::before {
  content: "󰗱";
}

.mdi-evernote::before {
  content: "󰈄";
}

.mdi-excavator::before {
  content: "󱀥";
}

.mdi-exclamation::before {
  content: "󰈅";
}

.mdi-exclamation-thick::before {
  content: "󱈸";
}

.mdi-exit-run::before {
  content: "󰩈";
}

.mdi-exit-to-app::before {
  content: "󰈆";
}

.mdi-expand-all::before {
  content: "󰪴";
}

.mdi-expand-all-outline::before {
  content: "󰪵";
}

.mdi-expansion-card::before {
  content: "󰢮";
}

.mdi-expansion-card-variant::before {
  content: "󰾲";
}

.mdi-exponent::before {
  content: "󰥣";
}

.mdi-exponent-box::before {
  content: "󰥤";
}

.mdi-export::before {
  content: "󰈇";
}

.mdi-export-variant::before {
  content: "󰮓";
}

.mdi-eye::before {
  content: "󰈈";
}

.mdi-eye-arrow-left::before {
  content: "󱣽";
}

.mdi-eye-arrow-left-outline::before {
  content: "󱣾";
}

.mdi-eye-arrow-right::before {
  content: "󱣿";
}

.mdi-eye-arrow-right-outline::before {
  content: "󱤀";
}

.mdi-eye-check::before {
  content: "󰴄";
}

.mdi-eye-check-outline::before {
  content: "󰴅";
}

.mdi-eye-circle::before {
  content: "󰮔";
}

.mdi-eye-circle-outline::before {
  content: "󰮕";
}

.mdi-eye-minus::before {
  content: "󱀦";
}

.mdi-eye-minus-outline::before {
  content: "󱀧";
}

.mdi-eye-off::before {
  content: "󰈉";
}

.mdi-eye-off-outline::before {
  content: "󰛑";
}

.mdi-eye-outline::before {
  content: "󰛐";
}

.mdi-eye-plus::before {
  content: "󰡫";
}

.mdi-eye-plus-outline::before {
  content: "󰡬";
}

.mdi-eye-refresh::before {
  content: "󱥼";
}

.mdi-eye-refresh-outline::before {
  content: "󱥽";
}

.mdi-eye-remove::before {
  content: "󱗣";
}

.mdi-eye-remove-outline::before {
  content: "󱗤";
}

.mdi-eye-settings::before {
  content: "󰡭";
}

.mdi-eye-settings-outline::before {
  content: "󰡮";
}

.mdi-eyedropper::before {
  content: "󰈊";
}

.mdi-eyedropper-minus::before {
  content: "󱏝";
}

.mdi-eyedropper-off::before {
  content: "󱏟";
}

.mdi-eyedropper-plus::before {
  content: "󱏜";
}

.mdi-eyedropper-remove::before {
  content: "󱏞";
}

.mdi-eyedropper-variant::before {
  content: "󰈋";
}

.mdi-face-agent::before {
  content: "󰵰";
}

.mdi-face-man::before {
  content: "󰙃";
}

.mdi-face-man-outline::before {
  content: "󰮖";
}

.mdi-face-man-profile::before {
  content: "󰙄";
}

.mdi-face-man-shimmer::before {
  content: "󱗌";
}

.mdi-face-man-shimmer-outline::before {
  content: "󱗍";
}

.mdi-face-mask::before {
  content: "󱖆";
}

.mdi-face-mask-outline::before {
  content: "󱖇";
}

.mdi-face-recognition::before {
  content: "󰱻";
}

.mdi-face-woman::before {
  content: "󱁷";
}

.mdi-face-woman-outline::before {
  content: "󱁸";
}

.mdi-face-woman-profile::before {
  content: "󱁶";
}

.mdi-face-woman-shimmer::before {
  content: "󱗎";
}

.mdi-face-woman-shimmer-outline::before {
  content: "󱗏";
}

.mdi-facebook::before {
  content: "󰈌";
}

.mdi-facebook-gaming::before {
  content: "󰟝";
}

.mdi-facebook-messenger::before {
  content: "󰈎";
}

.mdi-facebook-workplace::before {
  content: "󰬱";
}

.mdi-factory::before {
  content: "󰈏";
}

.mdi-family-tree::before {
  content: "󱘎";
}

.mdi-fan::before {
  content: "󰈐";
}

.mdi-fan-alert::before {
  content: "󱑬";
}

.mdi-fan-auto::before {
  content: "󱜝";
}

.mdi-fan-chevron-down::before {
  content: "󱑭";
}

.mdi-fan-chevron-up::before {
  content: "󱑮";
}

.mdi-fan-minus::before {
  content: "󱑰";
}

.mdi-fan-off::before {
  content: "󰠝";
}

.mdi-fan-plus::before {
  content: "󱑯";
}

.mdi-fan-remove::before {
  content: "󱑱";
}

.mdi-fan-speed-1::before {
  content: "󱑲";
}

.mdi-fan-speed-2::before {
  content: "󱑳";
}

.mdi-fan-speed-3::before {
  content: "󱑴";
}

.mdi-fast-forward::before {
  content: "󰈑";
}

.mdi-fast-forward-10::before {
  content: "󰵱";
}

.mdi-fast-forward-15::before {
  content: "󱤺";
}

.mdi-fast-forward-30::before {
  content: "󰴆";
}

.mdi-fast-forward-5::before {
  content: "󱇸";
}

.mdi-fast-forward-60::before {
  content: "󱘋";
}

.mdi-fast-forward-outline::before {
  content: "󰛒";
}

.mdi-fax::before {
  content: "󰈒";
}

.mdi-feather::before {
  content: "󰛓";
}

.mdi-feature-search::before {
  content: "󰩉";
}

.mdi-feature-search-outline::before {
  content: "󰩊";
}

.mdi-fedora::before {
  content: "󰣛";
}

.mdi-fence::before {
  content: "󱞚";
}

.mdi-fence-electric::before {
  content: "󱟶";
}

.mdi-fencing::before {
  content: "󱓁";
}

.mdi-ferris-wheel::before {
  content: "󰺤";
}

.mdi-ferry::before {
  content: "󰈓";
}

.mdi-file::before {
  content: "󰈔";
}

.mdi-file-account::before {
  content: "󰜻";
}

.mdi-file-account-outline::before {
  content: "󱀨";
}

.mdi-file-alert::before {
  content: "󰩋";
}

.mdi-file-alert-outline::before {
  content: "󰩌";
}

.mdi-file-cabinet::before {
  content: "󰪶";
}

.mdi-file-cad::before {
  content: "󰻫";
}

.mdi-file-cad-box::before {
  content: "󰻬";
}

.mdi-file-cancel::before {
  content: "󰷆";
}

.mdi-file-cancel-outline::before {
  content: "󰷇";
}

.mdi-file-certificate::before {
  content: "󱆆";
}

.mdi-file-certificate-outline::before {
  content: "󱆇";
}

.mdi-file-chart::before {
  content: "󰈕";
}

.mdi-file-chart-outline::before {
  content: "󱀩";
}

.mdi-file-check::before {
  content: "󰈖";
}

.mdi-file-check-outline::before {
  content: "󰸩";
}

.mdi-file-clock::before {
  content: "󱋡";
}

.mdi-file-clock-outline::before {
  content: "󱋢";
}

.mdi-file-cloud::before {
  content: "󰈗";
}

.mdi-file-cloud-outline::before {
  content: "󱀪";
}

.mdi-file-code::before {
  content: "󰈮";
}

.mdi-file-code-outline::before {
  content: "󱀫";
}

.mdi-file-cog::before {
  content: "󱁻";
}

.mdi-file-cog-outline::before {
  content: "󱁼";
}

.mdi-file-compare::before {
  content: "󰢪";
}

.mdi-file-delimited::before {
  content: "󰈘";
}

.mdi-file-delimited-outline::before {
  content: "󰺥";
}

.mdi-file-document::before {
  content: "󰈙";
}

.mdi-file-document-edit::before {
  content: "󰷈";
}

.mdi-file-document-edit-outline::before {
  content: "󰷉";
}

.mdi-file-document-multiple::before {
  content: "󱔗";
}

.mdi-file-document-multiple-outline::before {
  content: "󱔘";
}

.mdi-file-document-outline::before {
  content: "󰧮";
}

.mdi-file-download::before {
  content: "󰥥";
}

.mdi-file-download-outline::before {
  content: "󰥦";
}

.mdi-file-edit::before {
  content: "󱇧";
}

.mdi-file-edit-outline::before {
  content: "󱇨";
}

.mdi-file-excel::before {
  content: "󰈛";
}

.mdi-file-excel-box::before {
  content: "󰈜";
}

.mdi-file-excel-box-outline::before {
  content: "󱀬";
}

.mdi-file-excel-outline::before {
  content: "󱀭";
}

.mdi-file-export::before {
  content: "󰈝";
}

.mdi-file-export-outline::before {
  content: "󱀮";
}

.mdi-file-eye::before {
  content: "󰷊";
}

.mdi-file-eye-outline::before {
  content: "󰷋";
}

.mdi-file-find::before {
  content: "󰈞";
}

.mdi-file-find-outline::before {
  content: "󰮗";
}

.mdi-file-gif-box::before {
  content: "󰵸";
}

.mdi-file-hidden::before {
  content: "󰘓";
}

.mdi-file-image::before {
  content: "󰈟";
}

.mdi-file-image-marker::before {
  content: "󱝲";
}

.mdi-file-image-marker-outline::before {
  content: "󱝳";
}

.mdi-file-image-minus::before {
  content: "󱤻";
}

.mdi-file-image-minus-outline::before {
  content: "󱤼";
}

.mdi-file-image-outline::before {
  content: "󰺰";
}

.mdi-file-image-plus::before {
  content: "󱤽";
}

.mdi-file-image-plus-outline::before {
  content: "󱤾";
}

.mdi-file-image-remove::before {
  content: "󱤿";
}

.mdi-file-image-remove-outline::before {
  content: "󱥀";
}

.mdi-file-import::before {
  content: "󰈠";
}

.mdi-file-import-outline::before {
  content: "󱀯";
}

.mdi-file-jpg-box::before {
  content: "󰈥";
}

.mdi-file-key::before {
  content: "󱆄";
}

.mdi-file-key-outline::before {
  content: "󱆅";
}

.mdi-file-link::before {
  content: "󱅷";
}

.mdi-file-link-outline::before {
  content: "󱅸";
}

.mdi-file-lock::before {
  content: "󰈡";
}

.mdi-file-lock-outline::before {
  content: "󱀰";
}

.mdi-file-marker::before {
  content: "󱝴";
}

.mdi-file-marker-outline::before {
  content: "󱝵";
}

.mdi-file-move::before {
  content: "󰪹";
}

.mdi-file-move-outline::before {
  content: "󱀱";
}

.mdi-file-multiple::before {
  content: "󰈢";
}

.mdi-file-multiple-outline::before {
  content: "󱀲";
}

.mdi-file-music::before {
  content: "󰈣";
}

.mdi-file-music-outline::before {
  content: "󰸪";
}

.mdi-file-outline::before {
  content: "󰈤";
}

.mdi-file-pdf-box::before {
  content: "󰈦";
}

.mdi-file-percent::before {
  content: "󰠞";
}

.mdi-file-percent-outline::before {
  content: "󱀳";
}

.mdi-file-phone::before {
  content: "󱅹";
}

.mdi-file-phone-outline::before {
  content: "󱅺";
}

.mdi-file-plus::before {
  content: "󰝒";
}

.mdi-file-plus-outline::before {
  content: "󰻭";
}

.mdi-file-png-box::before {
  content: "󰸭";
}

.mdi-file-powerpoint::before {
  content: "󰈧";
}

.mdi-file-powerpoint-box::before {
  content: "󰈨";
}

.mdi-file-powerpoint-box-outline::before {
  content: "󱀴";
}

.mdi-file-powerpoint-outline::before {
  content: "󱀵";
}

.mdi-file-presentation-box::before {
  content: "󰈩";
}

.mdi-file-question::before {
  content: "󰡯";
}

.mdi-file-question-outline::before {
  content: "󱀶";
}

.mdi-file-refresh::before {
  content: "󰤘";
}

.mdi-file-refresh-outline::before {
  content: "󰕁";
}

.mdi-file-remove::before {
  content: "󰮘";
}

.mdi-file-remove-outline::before {
  content: "󱀷";
}

.mdi-file-replace::before {
  content: "󰬲";
}

.mdi-file-replace-outline::before {
  content: "󰬳";
}

.mdi-file-restore::before {
  content: "󰙰";
}

.mdi-file-restore-outline::before {
  content: "󱀸";
}

.mdi-file-search::before {
  content: "󰱼";
}

.mdi-file-search-outline::before {
  content: "󰱽";
}

.mdi-file-send::before {
  content: "󰈪";
}

.mdi-file-send-outline::before {
  content: "󱀹";
}

.mdi-file-settings::before {
  content: "󱁹";
}

.mdi-file-settings-outline::before {
  content: "󱁺";
}

.mdi-file-sign::before {
  content: "󱧃";
}

.mdi-file-star::before {
  content: "󱀺";
}

.mdi-file-star-outline::before {
  content: "󱀻";
}

.mdi-file-swap::before {
  content: "󰾴";
}

.mdi-file-swap-outline::before {
  content: "󰾵";
}

.mdi-file-sync::before {
  content: "󱈖";
}

.mdi-file-sync-outline::before {
  content: "󱈗";
}

.mdi-file-table::before {
  content: "󰱾";
}

.mdi-file-table-box::before {
  content: "󱃡";
}

.mdi-file-table-box-multiple::before {
  content: "󱃢";
}

.mdi-file-table-box-multiple-outline::before {
  content: "󱃣";
}

.mdi-file-table-box-outline::before {
  content: "󱃤";
}

.mdi-file-table-outline::before {
  content: "󰱿";
}

.mdi-file-tree::before {
  content: "󰙅";
}

.mdi-file-tree-outline::before {
  content: "󱏒";
}

.mdi-file-undo::before {
  content: "󰣜";
}

.mdi-file-undo-outline::before {
  content: "󱀼";
}

.mdi-file-upload::before {
  content: "󰩍";
}

.mdi-file-upload-outline::before {
  content: "󰩎";
}

.mdi-file-video::before {
  content: "󰈫";
}

.mdi-file-video-outline::before {
  content: "󰸬";
}

.mdi-file-word::before {
  content: "󰈬";
}

.mdi-file-word-box::before {
  content: "󰈭";
}

.mdi-file-word-box-outline::before {
  content: "󱀽";
}

.mdi-file-word-outline::before {
  content: "󱀾";
}

.mdi-film::before {
  content: "󰈯";
}

.mdi-filmstrip::before {
  content: "󰈰";
}

.mdi-filmstrip-box::before {
  content: "󰌲";
}

.mdi-filmstrip-box-multiple::before {
  content: "󰴘";
}

.mdi-filmstrip-off::before {
  content: "󰈱";
}

.mdi-filter::before {
  content: "󰈲";
}

.mdi-filter-check::before {
  content: "󱣬";
}

.mdi-filter-check-outline::before {
  content: "󱣭";
}

.mdi-filter-menu::before {
  content: "󱃥";
}

.mdi-filter-menu-outline::before {
  content: "󱃦";
}

.mdi-filter-minus::before {
  content: "󰻮";
}

.mdi-filter-minus-outline::before {
  content: "󰻯";
}

.mdi-filter-off::before {
  content: "󱓯";
}

.mdi-filter-off-outline::before {
  content: "󱓰";
}

.mdi-filter-outline::before {
  content: "󰈳";
}

.mdi-filter-plus::before {
  content: "󰻰";
}

.mdi-filter-plus-outline::before {
  content: "󰻱";
}

.mdi-filter-remove::before {
  content: "󰈴";
}

.mdi-filter-remove-outline::before {
  content: "󰈵";
}

.mdi-filter-variant::before {
  content: "󰈶";
}

.mdi-filter-variant-minus::before {
  content: "󱄒";
}

.mdi-filter-variant-plus::before {
  content: "󱄓";
}

.mdi-filter-variant-remove::before {
  content: "󱀿";
}

.mdi-finance::before {
  content: "󰠟";
}

.mdi-find-replace::before {
  content: "󰛔";
}

.mdi-fingerprint::before {
  content: "󰈷";
}

.mdi-fingerprint-off::before {
  content: "󰺱";
}

.mdi-fire::before {
  content: "󰈸";
}

.mdi-fire-alert::before {
  content: "󱗗";
}

.mdi-fire-circle::before {
  content: "󱠇";
}

.mdi-fire-extinguisher::before {
  content: "󰻲";
}

.mdi-fire-hydrant::before {
  content: "󱄷";
}

.mdi-fire-hydrant-alert::before {
  content: "󱄸";
}

.mdi-fire-hydrant-off::before {
  content: "󱄹";
}

.mdi-fire-off::before {
  content: "󱜢";
}

.mdi-fire-truck::before {
  content: "󰢫";
}

.mdi-firebase::before {
  content: "󰥧";
}

.mdi-firefox::before {
  content: "󰈹";
}

.mdi-fireplace::before {
  content: "󰸮";
}

.mdi-fireplace-off::before {
  content: "󰸯";
}

.mdi-firewire::before {
  content: "󰖾";
}

.mdi-firework::before {
  content: "󰸰";
}

.mdi-firework-off::before {
  content: "󱜣";
}

.mdi-fish::before {
  content: "󰈺";
}

.mdi-fish-off::before {
  content: "󱏳";
}

.mdi-fishbowl::before {
  content: "󰻳";
}

.mdi-fishbowl-outline::before {
  content: "󰻴";
}

.mdi-fit-to-page::before {
  content: "󰻵";
}

.mdi-fit-to-page-outline::before {
  content: "󰻶";
}

.mdi-fit-to-screen::before {
  content: "󱣴";
}

.mdi-fit-to-screen-outline::before {
  content: "󱣵";
}

.mdi-flag::before {
  content: "󰈻";
}

.mdi-flag-checkered::before {
  content: "󰈼";
}

.mdi-flag-minus::before {
  content: "󰮙";
}

.mdi-flag-minus-outline::before {
  content: "󱂲";
}

.mdi-flag-off::before {
  content: "󱣮";
}

.mdi-flag-off-outline::before {
  content: "󱣯";
}

.mdi-flag-outline::before {
  content: "󰈽";
}

.mdi-flag-plus::before {
  content: "󰮚";
}

.mdi-flag-plus-outline::before {
  content: "󱂳";
}

.mdi-flag-remove::before {
  content: "󰮛";
}

.mdi-flag-remove-outline::before {
  content: "󱂴";
}

.mdi-flag-triangle::before {
  content: "󰈿";
}

.mdi-flag-variant::before {
  content: "󰉀";
}

.mdi-flag-variant-outline::before {
  content: "󰈾";
}

.mdi-flare::before {
  content: "󰵲";
}

.mdi-flash::before {
  content: "󰉁";
}

.mdi-flash-alert::before {
  content: "󰻷";
}

.mdi-flash-alert-outline::before {
  content: "󰻸";
}

.mdi-flash-auto::before {
  content: "󰉂";
}

.mdi-flash-off::before {
  content: "󰉃";
}

.mdi-flash-outline::before {
  content: "󰛕";
}

.mdi-flash-red-eye::before {
  content: "󰙻";
}

.mdi-flashlight::before {
  content: "󰉄";
}

.mdi-flashlight-off::before {
  content: "󰉅";
}

.mdi-flask::before {
  content: "󰂓";
}

.mdi-flask-empty::before {
  content: "󰂔";
}

.mdi-flask-empty-minus::before {
  content: "󱈺";
}

.mdi-flask-empty-minus-outline::before {
  content: "󱈻";
}

.mdi-flask-empty-off::before {
  content: "󱏴";
}

.mdi-flask-empty-off-outline::before {
  content: "󱏵";
}

.mdi-flask-empty-outline::before {
  content: "󰂕";
}

.mdi-flask-empty-plus::before {
  content: "󱈼";
}

.mdi-flask-empty-plus-outline::before {
  content: "󱈽";
}

.mdi-flask-empty-remove::before {
  content: "󱈾";
}

.mdi-flask-empty-remove-outline::before {
  content: "󱈿";
}

.mdi-flask-minus::before {
  content: "󱉀";
}

.mdi-flask-minus-outline::before {
  content: "󱉁";
}

.mdi-flask-off::before {
  content: "󱏶";
}

.mdi-flask-off-outline::before {
  content: "󱏷";
}

.mdi-flask-outline::before {
  content: "󰂖";
}

.mdi-flask-plus::before {
  content: "󱉂";
}

.mdi-flask-plus-outline::before {
  content: "󱉃";
}

.mdi-flask-remove::before {
  content: "󱉄";
}

.mdi-flask-remove-outline::before {
  content: "󱉅";
}

.mdi-flask-round-bottom::before {
  content: "󱉋";
}

.mdi-flask-round-bottom-empty::before {
  content: "󱉌";
}

.mdi-flask-round-bottom-empty-outline::before {
  content: "󱉍";
}

.mdi-flask-round-bottom-outline::before {
  content: "󱉎";
}

.mdi-fleur-de-lis::before {
  content: "󱌃";
}

.mdi-flip-horizontal::before {
  content: "󱃧";
}

.mdi-flip-to-back::before {
  content: "󰉇";
}

.mdi-flip-to-front::before {
  content: "󰉈";
}

.mdi-flip-vertical::before {
  content: "󱃨";
}

.mdi-floor-lamp::before {
  content: "󰣝";
}

.mdi-floor-lamp-dual::before {
  content: "󱁀";
}

.mdi-floor-lamp-dual-outline::before {
  content: "󱟎";
}

.mdi-floor-lamp-outline::before {
  content: "󱟈";
}

.mdi-floor-lamp-torchiere::before {
  content: "󱝇";
}

.mdi-floor-lamp-torchiere-outline::before {
  content: "󱟖";
}

.mdi-floor-lamp-torchiere-variant::before {
  content: "󱁁";
}

.mdi-floor-lamp-torchiere-variant-outline::before {
  content: "󱟏";
}

.mdi-floor-plan::before {
  content: "󰠡";
}

.mdi-floppy::before {
  content: "󰉉";
}

.mdi-floppy-variant::before {
  content: "󰧯";
}

.mdi-flower::before {
  content: "󰉊";
}

.mdi-flower-outline::before {
  content: "󰧰";
}

.mdi-flower-pollen::before {
  content: "󱢅";
}

.mdi-flower-pollen-outline::before {
  content: "󱢆";
}

.mdi-flower-poppy::before {
  content: "󰴈";
}

.mdi-flower-tulip::before {
  content: "󰧱";
}

.mdi-flower-tulip-outline::before {
  content: "󰧲";
}

.mdi-focus-auto::before {
  content: "󰽎";
}

.mdi-focus-field::before {
  content: "󰽏";
}

.mdi-focus-field-horizontal::before {
  content: "󰽐";
}

.mdi-focus-field-vertical::before {
  content: "󰽑";
}

.mdi-folder::before {
  content: "󰉋";
}

.mdi-folder-account::before {
  content: "󰉌";
}

.mdi-folder-account-outline::before {
  content: "󰮜";
}

.mdi-folder-alert::before {
  content: "󰷌";
}

.mdi-folder-alert-outline::before {
  content: "󰷍";
}

.mdi-folder-check::before {
  content: "󱥾";
}

.mdi-folder-check-outline::before {
  content: "󱥿";
}

.mdi-folder-clock::before {
  content: "󰪺";
}

.mdi-folder-clock-outline::before {
  content: "󰪻";
}

.mdi-folder-cog::before {
  content: "󱁿";
}

.mdi-folder-cog-outline::before {
  content: "󱂀";
}

.mdi-folder-download::before {
  content: "󰉍";
}

.mdi-folder-download-outline::before {
  content: "󱃩";
}

.mdi-folder-edit::before {
  content: "󰣞";
}

.mdi-folder-edit-outline::before {
  content: "󰷎";
}

.mdi-folder-eye::before {
  content: "󱞊";
}

.mdi-folder-eye-outline::before {
  content: "󱞋";
}

.mdi-folder-google-drive::before {
  content: "󰉎";
}

.mdi-folder-heart::before {
  content: "󱃪";
}

.mdi-folder-heart-outline::before {
  content: "󱃫";
}

.mdi-folder-hidden::before {
  content: "󱞞";
}

.mdi-folder-home::before {
  content: "󱂵";
}

.mdi-folder-home-outline::before {
  content: "󱂶";
}

.mdi-folder-image::before {
  content: "󰉏";
}

.mdi-folder-information::before {
  content: "󱂷";
}

.mdi-folder-information-outline::before {
  content: "󱂸";
}

.mdi-folder-key::before {
  content: "󰢬";
}

.mdi-folder-key-network::before {
  content: "󰢭";
}

.mdi-folder-key-network-outline::before {
  content: "󰲀";
}

.mdi-folder-key-outline::before {
  content: "󱃬";
}

.mdi-folder-lock::before {
  content: "󰉐";
}

.mdi-folder-lock-open::before {
  content: "󰉑";
}

.mdi-folder-marker::before {
  content: "󱉭";
}

.mdi-folder-marker-outline::before {
  content: "󱉮";
}

.mdi-folder-move::before {
  content: "󰉒";
}

.mdi-folder-move-outline::before {
  content: "󱉆";
}

.mdi-folder-multiple::before {
  content: "󰉓";
}

.mdi-folder-multiple-image::before {
  content: "󰉔";
}

.mdi-folder-multiple-outline::before {
  content: "󰉕";
}

.mdi-folder-multiple-plus::before {
  content: "󱑾";
}

.mdi-folder-multiple-plus-outline::before {
  content: "󱑿";
}

.mdi-folder-music::before {
  content: "󱍙";
}

.mdi-folder-music-outline::before {
  content: "󱍚";
}

.mdi-folder-network::before {
  content: "󰡰";
}

.mdi-folder-network-outline::before {
  content: "󰲁";
}

.mdi-folder-open::before {
  content: "󰝰";
}

.mdi-folder-open-outline::before {
  content: "󰷏";
}

.mdi-folder-outline::before {
  content: "󰉖";
}

.mdi-folder-plus::before {
  content: "󰉗";
}

.mdi-folder-plus-outline::before {
  content: "󰮝";
}

.mdi-folder-pound::before {
  content: "󰴉";
}

.mdi-folder-pound-outline::before {
  content: "󰴊";
}

.mdi-folder-refresh::before {
  content: "󰝉";
}

.mdi-folder-refresh-outline::before {
  content: "󰕂";
}

.mdi-folder-remove::before {
  content: "󰉘";
}

.mdi-folder-remove-outline::before {
  content: "󰮞";
}

.mdi-folder-search::before {
  content: "󰥨";
}

.mdi-folder-search-outline::before {
  content: "󰥩";
}

.mdi-folder-settings::before {
  content: "󱁽";
}

.mdi-folder-settings-outline::before {
  content: "󱁾";
}

.mdi-folder-star::before {
  content: "󰚝";
}

.mdi-folder-star-multiple::before {
  content: "󱏓";
}

.mdi-folder-star-multiple-outline::before {
  content: "󱏔";
}

.mdi-folder-star-outline::before {
  content: "󰮟";
}

.mdi-folder-swap::before {
  content: "󰾶";
}

.mdi-folder-swap-outline::before {
  content: "󰾷";
}

.mdi-folder-sync::before {
  content: "󰴋";
}

.mdi-folder-sync-outline::before {
  content: "󰴌";
}

.mdi-folder-table::before {
  content: "󱋣";
}

.mdi-folder-table-outline::before {
  content: "󱋤";
}

.mdi-folder-text::before {
  content: "󰲂";
}

.mdi-folder-text-outline::before {
  content: "󰲃";
}

.mdi-folder-upload::before {
  content: "󰉙";
}

.mdi-folder-upload-outline::before {
  content: "󱃭";
}

.mdi-folder-zip::before {
  content: "󰛫";
}

.mdi-folder-zip-outline::before {
  content: "󰞹";
}

.mdi-font-awesome::before {
  content: "󰀺";
}

.mdi-food::before {
  content: "󰉚";
}

.mdi-food-apple::before {
  content: "󰉛";
}

.mdi-food-apple-outline::before {
  content: "󰲄";
}

.mdi-food-croissant::before {
  content: "󰟈";
}

.mdi-food-drumstick::before {
  content: "󱐟";
}

.mdi-food-drumstick-off::before {
  content: "󱑨";
}

.mdi-food-drumstick-off-outline::before {
  content: "󱑩";
}

.mdi-food-drumstick-outline::before {
  content: "󱐠";
}

.mdi-food-fork-drink::before {
  content: "󰗲";
}

.mdi-food-halal::before {
  content: "󱕲";
}

.mdi-food-hot-dog::before {
  content: "󱡋";
}

.mdi-food-kosher::before {
  content: "󱕳";
}

.mdi-food-off::before {
  content: "󰗳";
}

.mdi-food-off-outline::before {
  content: "󱤕";
}

.mdi-food-outline::before {
  content: "󱤖";
}

.mdi-food-steak::before {
  content: "󱑪";
}

.mdi-food-steak-off::before {
  content: "󱑫";
}

.mdi-food-takeout-box::before {
  content: "󱠶";
}

.mdi-food-takeout-box-outline::before {
  content: "󱠷";
}

.mdi-food-turkey::before {
  content: "󱜜";
}

.mdi-food-variant::before {
  content: "󰉜";
}

.mdi-food-variant-off::before {
  content: "󱏥";
}

.mdi-foot-print::before {
  content: "󰽒";
}

.mdi-football::before {
  content: "󰉝";
}

.mdi-football-australian::before {
  content: "󰉞";
}

.mdi-football-helmet::before {
  content: "󰉟";
}

.mdi-forest::before {
  content: "󱢗";
}

.mdi-forklift::before {
  content: "󰟉";
}

.mdi-form-dropdown::before {
  content: "󱐀";
}

.mdi-form-select::before {
  content: "󱐁";
}

.mdi-form-textarea::before {
  content: "󱂕";
}

.mdi-form-textbox::before {
  content: "󰘎";
}

.mdi-form-textbox-lock::before {
  content: "󱍝";
}

.mdi-form-textbox-password::before {
  content: "󰟵";
}

.mdi-format-align-bottom::before {
  content: "󰝓";
}

.mdi-format-align-center::before {
  content: "󰉠";
}

.mdi-format-align-justify::before {
  content: "󰉡";
}

.mdi-format-align-left::before {
  content: "󰉢";
}

.mdi-format-align-middle::before {
  content: "󰝔";
}

.mdi-format-align-right::before {
  content: "󰉣";
}

.mdi-format-align-top::before {
  content: "󰝕";
}

.mdi-format-annotation-minus::before {
  content: "󰪼";
}

.mdi-format-annotation-plus::before {
  content: "󰙆";
}

.mdi-format-bold::before {
  content: "󰉤";
}

.mdi-format-clear::before {
  content: "󰉥";
}

.mdi-format-color-fill::before {
  content: "󰉦";
}

.mdi-format-color-highlight::before {
  content: "󰸱";
}

.mdi-format-color-marker-cancel::before {
  content: "󱌓";
}

.mdi-format-color-text::before {
  content: "󰚞";
}

.mdi-format-columns::before {
  content: "󰣟";
}

.mdi-format-float-center::before {
  content: "󰉧";
}

.mdi-format-float-left::before {
  content: "󰉨";
}

.mdi-format-float-none::before {
  content: "󰉩";
}

.mdi-format-float-right::before {
  content: "󰉪";
}

.mdi-format-font::before {
  content: "󰛖";
}

.mdi-format-font-size-decrease::before {
  content: "󰧳";
}

.mdi-format-font-size-increase::before {
  content: "󰧴";
}

.mdi-format-header-1::before {
  content: "󰉫";
}

.mdi-format-header-2::before {
  content: "󰉬";
}

.mdi-format-header-3::before {
  content: "󰉭";
}

.mdi-format-header-4::before {
  content: "󰉮";
}

.mdi-format-header-5::before {
  content: "󰉯";
}

.mdi-format-header-6::before {
  content: "󰉰";
}

.mdi-format-header-decrease::before {
  content: "󰉱";
}

.mdi-format-header-equal::before {
  content: "󰉲";
}

.mdi-format-header-increase::before {
  content: "󰉳";
}

.mdi-format-header-pound::before {
  content: "󰉴";
}

.mdi-format-horizontal-align-center::before {
  content: "󰘞";
}

.mdi-format-horizontal-align-left::before {
  content: "󰘟";
}

.mdi-format-horizontal-align-right::before {
  content: "󰘠";
}

.mdi-format-indent-decrease::before {
  content: "󰉵";
}

.mdi-format-indent-increase::before {
  content: "󰉶";
}

.mdi-format-italic::before {
  content: "󰉷";
}

.mdi-format-letter-case::before {
  content: "󰬴";
}

.mdi-format-letter-case-lower::before {
  content: "󰬵";
}

.mdi-format-letter-case-upper::before {
  content: "󰬶";
}

.mdi-format-letter-ends-with::before {
  content: "󰾸";
}

.mdi-format-letter-matches::before {
  content: "󰾹";
}

.mdi-format-letter-spacing::before {
  content: "󱥖";
}

.mdi-format-letter-starts-with::before {
  content: "󰾺";
}

.mdi-format-line-spacing::before {
  content: "󰉸";
}

.mdi-format-line-style::before {
  content: "󰗈";
}

.mdi-format-line-weight::before {
  content: "󰗉";
}

.mdi-format-list-bulleted::before {
  content: "󰉹";
}

.mdi-format-list-bulleted-square::before {
  content: "󰷐";
}

.mdi-format-list-bulleted-triangle::before {
  content: "󰺲";
}

.mdi-format-list-bulleted-type::before {
  content: "󰉺";
}

.mdi-format-list-checkbox::before {
  content: "󰥪";
}

.mdi-format-list-checks::before {
  content: "󰝖";
}

.mdi-format-list-group::before {
  content: "󱡠";
}

.mdi-format-list-numbered::before {
  content: "󰉻";
}

.mdi-format-list-numbered-rtl::before {
  content: "󰴍";
}

.mdi-format-list-text::before {
  content: "󱉯";
}

.mdi-format-overline::before {
  content: "󰺳";
}

.mdi-format-page-break::before {
  content: "󰛗";
}

.mdi-format-page-split::before {
  content: "󱤗";
}

.mdi-format-paint::before {
  content: "󰉼";
}

.mdi-format-paragraph::before {
  content: "󰉽";
}

.mdi-format-pilcrow::before {
  content: "󰛘";
}

.mdi-format-quote-close::before {
  content: "󰉾";
}

.mdi-format-quote-close-outline::before {
  content: "󱆨";
}

.mdi-format-quote-open::before {
  content: "󰝗";
}

.mdi-format-quote-open-outline::before {
  content: "󱆧";
}

.mdi-format-rotate-90::before {
  content: "󰚪";
}

.mdi-format-section::before {
  content: "󰚟";
}

.mdi-format-size::before {
  content: "󰉿";
}

.mdi-format-strikethrough::before {
  content: "󰊀";
}

.mdi-format-strikethrough-variant::before {
  content: "󰊁";
}

.mdi-format-subscript::before {
  content: "󰊂";
}

.mdi-format-superscript::before {
  content: "󰊃";
}

.mdi-format-text::before {
  content: "󰊄";
}

.mdi-format-text-rotation-angle-down::before {
  content: "󰾻";
}

.mdi-format-text-rotation-angle-up::before {
  content: "󰾼";
}

.mdi-format-text-rotation-down::before {
  content: "󰵳";
}

.mdi-format-text-rotation-down-vertical::before {
  content: "󰾽";
}

.mdi-format-text-rotation-none::before {
  content: "󰵴";
}

.mdi-format-text-rotation-up::before {
  content: "󰾾";
}

.mdi-format-text-rotation-vertical::before {
  content: "󰾿";
}

.mdi-format-text-variant::before {
  content: "󰸲";
}

.mdi-format-text-variant-outline::before {
  content: "󱔏";
}

.mdi-format-text-wrapping-clip::before {
  content: "󰴎";
}

.mdi-format-text-wrapping-overflow::before {
  content: "󰴏";
}

.mdi-format-text-wrapping-wrap::before {
  content: "󰴐";
}

.mdi-format-textbox::before {
  content: "󰴑";
}

.mdi-format-textdirection-l-to-r::before {
  content: "󰊅";
}

.mdi-format-textdirection-r-to-l::before {
  content: "󰊆";
}

.mdi-format-title::before {
  content: "󰗴";
}

.mdi-format-underline::before {
  content: "󰊇";
}

.mdi-format-underline-wavy::before {
  content: "󱣩";
}

.mdi-format-vertical-align-bottom::before {
  content: "󰘡";
}

.mdi-format-vertical-align-center::before {
  content: "󰘢";
}

.mdi-format-vertical-align-top::before {
  content: "󰘣";
}

.mdi-format-wrap-inline::before {
  content: "󰊈";
}

.mdi-format-wrap-square::before {
  content: "󰊉";
}

.mdi-format-wrap-tight::before {
  content: "󰊊";
}

.mdi-format-wrap-top-bottom::before {
  content: "󰊋";
}

.mdi-forum::before {
  content: "󰊌";
}

.mdi-forum-outline::before {
  content: "󰠢";
}

.mdi-forward::before {
  content: "󰊍";
}

.mdi-forwardburger::before {
  content: "󰵵";
}

.mdi-fountain::before {
  content: "󰥫";
}

.mdi-fountain-pen::before {
  content: "󰴒";
}

.mdi-fountain-pen-tip::before {
  content: "󰴓";
}

.mdi-fraction-one-half::before {
  content: "󱦒";
}

.mdi-freebsd::before {
  content: "󰣠";
}

.mdi-french-fries::before {
  content: "󱥗";
}

.mdi-frequently-asked-questions::before {
  content: "󰺴";
}

.mdi-fridge::before {
  content: "󰊐";
}

.mdi-fridge-alert::before {
  content: "󱆱";
}

.mdi-fridge-alert-outline::before {
  content: "󱆲";
}

.mdi-fridge-bottom::before {
  content: "󰊒";
}

.mdi-fridge-industrial::before {
  content: "󱗮";
}

.mdi-fridge-industrial-alert::before {
  content: "󱗯";
}

.mdi-fridge-industrial-alert-outline::before {
  content: "󱗰";
}

.mdi-fridge-industrial-off::before {
  content: "󱗱";
}

.mdi-fridge-industrial-off-outline::before {
  content: "󱗲";
}

.mdi-fridge-industrial-outline::before {
  content: "󱗳";
}

.mdi-fridge-off::before {
  content: "󱆯";
}

.mdi-fridge-off-outline::before {
  content: "󱆰";
}

.mdi-fridge-outline::before {
  content: "󰊏";
}

.mdi-fridge-top::before {
  content: "󰊑";
}

.mdi-fridge-variant::before {
  content: "󱗴";
}

.mdi-fridge-variant-alert::before {
  content: "󱗵";
}

.mdi-fridge-variant-alert-outline::before {
  content: "󱗶";
}

.mdi-fridge-variant-off::before {
  content: "󱗷";
}

.mdi-fridge-variant-off-outline::before {
  content: "󱗸";
}

.mdi-fridge-variant-outline::before {
  content: "󱗹";
}

.mdi-fruit-cherries::before {
  content: "󱁂";
}

.mdi-fruit-cherries-off::before {
  content: "󱏸";
}

.mdi-fruit-citrus::before {
  content: "󱁃";
}

.mdi-fruit-citrus-off::before {
  content: "󱏹";
}

.mdi-fruit-grapes::before {
  content: "󱁄";
}

.mdi-fruit-grapes-outline::before {
  content: "󱁅";
}

.mdi-fruit-pineapple::before {
  content: "󱁆";
}

.mdi-fruit-watermelon::before {
  content: "󱁇";
}

.mdi-fuel::before {
  content: "󰟊";
}

.mdi-fuel-cell::before {
  content: "󱢵";
}

.mdi-fullscreen::before {
  content: "󰊓";
}

.mdi-fullscreen-exit::before {
  content: "󰊔";
}

.mdi-function::before {
  content: "󰊕";
}

.mdi-function-variant::before {
  content: "󰡱";
}

.mdi-furigana-horizontal::before {
  content: "󱂁";
}

.mdi-furigana-vertical::before {
  content: "󱂂";
}

.mdi-fuse::before {
  content: "󰲅";
}

.mdi-fuse-alert::before {
  content: "󱐭";
}

.mdi-fuse-blade::before {
  content: "󰲆";
}

.mdi-fuse-off::before {
  content: "󱐬";
}

.mdi-gamepad::before {
  content: "󰊖";
}

.mdi-gamepad-circle::before {
  content: "󰸳";
}

.mdi-gamepad-circle-down::before {
  content: "󰸴";
}

.mdi-gamepad-circle-left::before {
  content: "󰸵";
}

.mdi-gamepad-circle-outline::before {
  content: "󰸶";
}

.mdi-gamepad-circle-right::before {
  content: "󰸷";
}

.mdi-gamepad-circle-up::before {
  content: "󰸸";
}

.mdi-gamepad-down::before {
  content: "󰸹";
}

.mdi-gamepad-left::before {
  content: "󰸺";
}

.mdi-gamepad-outline::before {
  content: "󱤙";
}

.mdi-gamepad-right::before {
  content: "󰸻";
}

.mdi-gamepad-round::before {
  content: "󰸼";
}

.mdi-gamepad-round-down::before {
  content: "󰸽";
}

.mdi-gamepad-round-left::before {
  content: "󰸾";
}

.mdi-gamepad-round-outline::before {
  content: "󰸿";
}

.mdi-gamepad-round-right::before {
  content: "󰹀";
}

.mdi-gamepad-round-up::before {
  content: "󰹁";
}

.mdi-gamepad-square::before {
  content: "󰺵";
}

.mdi-gamepad-square-outline::before {
  content: "󰺶";
}

.mdi-gamepad-up::before {
  content: "󰹂";
}

.mdi-gamepad-variant::before {
  content: "󰊗";
}

.mdi-gamepad-variant-outline::before {
  content: "󰺷";
}

.mdi-gamma::before {
  content: "󱃮";
}

.mdi-gantry-crane::before {
  content: "󰷑";
}

.mdi-garage::before {
  content: "󰛙";
}

.mdi-garage-alert::before {
  content: "󰡲";
}

.mdi-garage-alert-variant::before {
  content: "󱋕";
}

.mdi-garage-lock::before {
  content: "󱟻";
}

.mdi-garage-open::before {
  content: "󰛚";
}

.mdi-garage-open-variant::before {
  content: "󱋔";
}

.mdi-garage-variant::before {
  content: "󱋓";
}

.mdi-garage-variant-lock::before {
  content: "󱟼";
}

.mdi-gas-cylinder::before {
  content: "󰙇";
}

.mdi-gas-station::before {
  content: "󰊘";
}

.mdi-gas-station-off::before {
  content: "󱐉";
}

.mdi-gas-station-off-outline::before {
  content: "󱐊";
}

.mdi-gas-station-outline::before {
  content: "󰺸";
}

.mdi-gate::before {
  content: "󰊙";
}

.mdi-gate-alert::before {
  content: "󱟸";
}

.mdi-gate-and::before {
  content: "󰣡";
}

.mdi-gate-arrow-left::before {
  content: "󱟷";
}

.mdi-gate-arrow-right::before {
  content: "󱅩";
}

.mdi-gate-nand::before {
  content: "󰣢";
}

.mdi-gate-nor::before {
  content: "󰣣";
}

.mdi-gate-not::before {
  content: "󰣤";
}

.mdi-gate-open::before {
  content: "󱅪";
}

.mdi-gate-or::before {
  content: "󰣥";
}

.mdi-gate-xnor::before {
  content: "󰣦";
}

.mdi-gate-xor::before {
  content: "󰣧";
}

.mdi-gatsby::before {
  content: "󰹃";
}

.mdi-gauge::before {
  content: "󰊚";
}

.mdi-gauge-empty::before {
  content: "󰡳";
}

.mdi-gauge-full::before {
  content: "󰡴";
}

.mdi-gauge-low::before {
  content: "󰡵";
}

.mdi-gavel::before {
  content: "󰊛";
}

.mdi-gender-female::before {
  content: "󰊜";
}

.mdi-gender-male::before {
  content: "󰊝";
}

.mdi-gender-male-female::before {
  content: "󰊞";
}

.mdi-gender-male-female-variant::before {
  content: "󱄿";
}

.mdi-gender-non-binary::before {
  content: "󱅀";
}

.mdi-gender-transgender::before {
  content: "󰊟";
}

.mdi-gentoo::before {
  content: "󰣨";
}

.mdi-gesture::before {
  content: "󰟋";
}

.mdi-gesture-double-tap::before {
  content: "󰜼";
}

.mdi-gesture-pinch::before {
  content: "󰪽";
}

.mdi-gesture-spread::before {
  content: "󰪾";
}

.mdi-gesture-swipe::before {
  content: "󰵶";
}

.mdi-gesture-swipe-down::before {
  content: "󰜽";
}

.mdi-gesture-swipe-horizontal::before {
  content: "󰪿";
}

.mdi-gesture-swipe-left::before {
  content: "󰜾";
}

.mdi-gesture-swipe-right::before {
  content: "󰜿";
}

.mdi-gesture-swipe-up::before {
  content: "󰝀";
}

.mdi-gesture-swipe-vertical::before {
  content: "󰫀";
}

.mdi-gesture-tap::before {
  content: "󰝁";
}

.mdi-gesture-tap-box::before {
  content: "󱊩";
}

.mdi-gesture-tap-button::before {
  content: "󱊨";
}

.mdi-gesture-tap-hold::before {
  content: "󰵷";
}

.mdi-gesture-two-double-tap::before {
  content: "󰝂";
}

.mdi-gesture-two-tap::before {
  content: "󰝃";
}

.mdi-ghost::before {
  content: "󰊠";
}

.mdi-ghost-off::before {
  content: "󰧵";
}

.mdi-ghost-off-outline::before {
  content: "󱙜";
}

.mdi-ghost-outline::before {
  content: "󱙝";
}

.mdi-gift::before {
  content: "󰹄";
}

.mdi-gift-off::before {
  content: "󱛯";
}

.mdi-gift-off-outline::before {
  content: "󱛰";
}

.mdi-gift-open::before {
  content: "󱛱";
}

.mdi-gift-open-outline::before {
  content: "󱛲";
}

.mdi-gift-outline::before {
  content: "󰊡";
}

.mdi-git::before {
  content: "󰊢";
}

.mdi-github::before {
  content: "󰊤";
}

.mdi-gitlab::before {
  content: "󰮠";
}

.mdi-glass-cocktail::before {
  content: "󰍖";
}

.mdi-glass-cocktail-off::before {
  content: "󱗦";
}

.mdi-glass-flute::before {
  content: "󰊥";
}

.mdi-glass-fragile::before {
  content: "󱡳";
}

.mdi-glass-mug::before {
  content: "󰊦";
}

.mdi-glass-mug-off::before {
  content: "󱗧";
}

.mdi-glass-mug-variant::before {
  content: "󱄖";
}

.mdi-glass-mug-variant-off::before {
  content: "󱗨";
}

.mdi-glass-pint-outline::before {
  content: "󱌍";
}

.mdi-glass-stange::before {
  content: "󰊧";
}

.mdi-glass-tulip::before {
  content: "󰊨";
}

.mdi-glass-wine::before {
  content: "󰡶";
}

.mdi-glasses::before {
  content: "󰊪";
}

.mdi-globe-light::before {
  content: "󱋗";
}

.mdi-globe-model::before {
  content: "󰣩";
}

.mdi-gmail::before {
  content: "󰊫";
}

.mdi-gnome::before {
  content: "󰊬";
}

.mdi-go-kart::before {
  content: "󰵹";
}

.mdi-go-kart-track::before {
  content: "󰵺";
}

.mdi-gog::before {
  content: "󰮡";
}

.mdi-gold::before {
  content: "󱉏";
}

.mdi-golf::before {
  content: "󰠣";
}

.mdi-golf-cart::before {
  content: "󱆤";
}

.mdi-golf-tee::before {
  content: "󱂃";
}

.mdi-gondola::before {
  content: "󰚆";
}

.mdi-goodreads::before {
  content: "󰵻";
}

.mdi-google::before {
  content: "󰊭";
}

.mdi-google-ads::before {
  content: "󰲇";
}

.mdi-google-analytics::before {
  content: "󰟌";
}

.mdi-google-assistant::before {
  content: "󰟍";
}

.mdi-google-cardboard::before {
  content: "󰊮";
}

.mdi-google-chrome::before {
  content: "󰊯";
}

.mdi-google-circles::before {
  content: "󰊰";
}

.mdi-google-circles-communities::before {
  content: "󰊱";
}

.mdi-google-circles-extended::before {
  content: "󰊲";
}

.mdi-google-circles-group::before {
  content: "󰊳";
}

.mdi-google-classroom::before {
  content: "󰋀";
}

.mdi-google-cloud::before {
  content: "󱇶";
}

.mdi-google-controller::before {
  content: "󰊴";
}

.mdi-google-controller-off::before {
  content: "󰊵";
}

.mdi-google-downasaur::before {
  content: "󱍢";
}

.mdi-google-drive::before {
  content: "󰊶";
}

.mdi-google-earth::before {
  content: "󰊷";
}

.mdi-google-fit::before {
  content: "󰥬";
}

.mdi-google-glass::before {
  content: "󰊸";
}

.mdi-google-hangouts::before {
  content: "󰋉";
}

.mdi-google-home::before {
  content: "󰠤";
}

.mdi-google-keep::before {
  content: "󰛜";
}

.mdi-google-lens::before {
  content: "󰧶";
}

.mdi-google-maps::before {
  content: "󰗵";
}

.mdi-google-my-business::before {
  content: "󱁈";
}

.mdi-google-nearby::before {
  content: "󰊹";
}

.mdi-google-play::before {
  content: "󰊼";
}

.mdi-google-plus::before {
  content: "󰊽";
}

.mdi-google-podcast::before {
  content: "󰺹";
}

.mdi-google-spreadsheet::before {
  content: "󰧷";
}

.mdi-google-street-view::before {
  content: "󰲈";
}

.mdi-google-translate::before {
  content: "󰊿";
}

.mdi-gradient-horizontal::before {
  content: "󱝊";
}

.mdi-gradient-vertical::before {
  content: "󰚠";
}

.mdi-grain::before {
  content: "󰵼";
}

.mdi-graph::before {
  content: "󱁉";
}

.mdi-graph-outline::before {
  content: "󱁊";
}

.mdi-graphql::before {
  content: "󰡷";
}

.mdi-grass::before {
  content: "󱔐";
}

.mdi-grave-stone::before {
  content: "󰮢";
}

.mdi-grease-pencil::before {
  content: "󰙈";
}

.mdi-greater-than::before {
  content: "󰥭";
}

.mdi-greater-than-or-equal::before {
  content: "󰥮";
}

.mdi-greenhouse::before {
  content: "󰀭";
}

.mdi-grid::before {
  content: "󰋁";
}

.mdi-grid-large::before {
  content: "󰝘";
}

.mdi-grid-off::before {
  content: "󰋂";
}

.mdi-grill::before {
  content: "󰹅";
}

.mdi-grill-outline::before {
  content: "󱆊";
}

.mdi-group::before {
  content: "󰋃";
}

.mdi-guitar-acoustic::before {
  content: "󰝱";
}

.mdi-guitar-electric::before {
  content: "󰋄";
}

.mdi-guitar-pick::before {
  content: "󰋅";
}

.mdi-guitar-pick-outline::before {
  content: "󰋆";
}

.mdi-guy-fawkes-mask::before {
  content: "󰠥";
}

.mdi-hail::before {
  content: "󰫁";
}

.mdi-hair-dryer::before {
  content: "󱃯";
}

.mdi-hair-dryer-outline::before {
  content: "󱃰";
}

.mdi-halloween::before {
  content: "󰮣";
}

.mdi-hamburger::before {
  content: "󰚅";
}

.mdi-hamburger-check::before {
  content: "󱝶";
}

.mdi-hamburger-minus::before {
  content: "󱝷";
}

.mdi-hamburger-off::before {
  content: "󱝸";
}

.mdi-hamburger-plus::before {
  content: "󱝹";
}

.mdi-hamburger-remove::before {
  content: "󱝺";
}

.mdi-hammer::before {
  content: "󰣪";
}

.mdi-hammer-screwdriver::before {
  content: "󱌢";
}

.mdi-hammer-sickle::before {
  content: "󱢇";
}

.mdi-hammer-wrench::before {
  content: "󱌣";
}

.mdi-hand-back-left::before {
  content: "󰹆";
}

.mdi-hand-back-left-off::before {
  content: "󱠰";
}

.mdi-hand-back-left-off-outline::before {
  content: "󱠲";
}

.mdi-hand-back-left-outline::before {
  content: "󱠬";
}

.mdi-hand-back-right::before {
  content: "󰹇";
}

.mdi-hand-back-right-off::before {
  content: "󱠱";
}

.mdi-hand-back-right-off-outline::before {
  content: "󱠳";
}

.mdi-hand-back-right-outline::before {
  content: "󱠭";
}

.mdi-hand-clap::before {
  content: "󱥋";
}

.mdi-hand-coin::before {
  content: "󱢏";
}

.mdi-hand-coin-outline::before {
  content: "󱢐";
}

.mdi-hand-extended::before {
  content: "󱢶";
}

.mdi-hand-extended-outline::before {
  content: "󱢷";
}

.mdi-hand-front-left::before {
  content: "󱠫";
}

.mdi-hand-front-left-outline::before {
  content: "󱠮";
}

.mdi-hand-front-right::before {
  content: "󰩏";
}

.mdi-hand-front-right-outline::before {
  content: "󱠯";
}

.mdi-hand-heart::before {
  content: "󱃱";
}

.mdi-hand-heart-outline::before {
  content: "󱕾";
}

.mdi-hand-okay::before {
  content: "󰩐";
}

.mdi-hand-peace::before {
  content: "󰩑";
}

.mdi-hand-peace-variant::before {
  content: "󰩒";
}

.mdi-hand-pointing-down::before {
  content: "󰩓";
}

.mdi-hand-pointing-left::before {
  content: "󰩔";
}

.mdi-hand-pointing-right::before {
  content: "󰋇";
}

.mdi-hand-pointing-up::before {
  content: "󰩕";
}

.mdi-hand-saw::before {
  content: "󰹈";
}

.mdi-hand-wash::before {
  content: "󱕿";
}

.mdi-hand-wash-outline::before {
  content: "󱖀";
}

.mdi-hand-water::before {
  content: "󱎟";
}

.mdi-hand-wave::before {
  content: "󱠡";
}

.mdi-hand-wave-outline::before {
  content: "󱠢";
}

.mdi-handball::before {
  content: "󰽓";
}

.mdi-handcuffs::before {
  content: "󱄾";
}

.mdi-hands-pray::before {
  content: "󰕹";
}

.mdi-handshake::before {
  content: "󱈘";
}

.mdi-handshake-outline::before {
  content: "󱖡";
}

.mdi-hanger::before {
  content: "󰋈";
}

.mdi-hard-hat::before {
  content: "󰥯";
}

.mdi-harddisk::before {
  content: "󰋊";
}

.mdi-harddisk-plus::before {
  content: "󱁋";
}

.mdi-harddisk-remove::before {
  content: "󱁌";
}

.mdi-hat-fedora::before {
  content: "󰮤";
}

.mdi-hazard-lights::before {
  content: "󰲉";
}

.mdi-hdr::before {
  content: "󰵽";
}

.mdi-hdr-off::before {
  content: "󰵾";
}

.mdi-head::before {
  content: "󱍞";
}

.mdi-head-alert::before {
  content: "󱌸";
}

.mdi-head-alert-outline::before {
  content: "󱌹";
}

.mdi-head-check::before {
  content: "󱌺";
}

.mdi-head-check-outline::before {
  content: "󱌻";
}

.mdi-head-cog::before {
  content: "󱌼";
}

.mdi-head-cog-outline::before {
  content: "󱌽";
}

.mdi-head-dots-horizontal::before {
  content: "󱌾";
}

.mdi-head-dots-horizontal-outline::before {
  content: "󱌿";
}

.mdi-head-flash::before {
  content: "󱍀";
}

.mdi-head-flash-outline::before {
  content: "󱍁";
}

.mdi-head-heart::before {
  content: "󱍂";
}

.mdi-head-heart-outline::before {
  content: "󱍃";
}

.mdi-head-lightbulb::before {
  content: "󱍄";
}

.mdi-head-lightbulb-outline::before {
  content: "󱍅";
}

.mdi-head-minus::before {
  content: "󱍆";
}

.mdi-head-minus-outline::before {
  content: "󱍇";
}

.mdi-head-outline::before {
  content: "󱍟";
}

.mdi-head-plus::before {
  content: "󱍈";
}

.mdi-head-plus-outline::before {
  content: "󱍉";
}

.mdi-head-question::before {
  content: "󱍊";
}

.mdi-head-question-outline::before {
  content: "󱍋";
}

.mdi-head-remove::before {
  content: "󱍌";
}

.mdi-head-remove-outline::before {
  content: "󱍍";
}

.mdi-head-snowflake::before {
  content: "󱍎";
}

.mdi-head-snowflake-outline::before {
  content: "󱍏";
}

.mdi-head-sync::before {
  content: "󱍐";
}

.mdi-head-sync-outline::before {
  content: "󱍑";
}

.mdi-headphones::before {
  content: "󰋋";
}

.mdi-headphones-bluetooth::before {
  content: "󰥰";
}

.mdi-headphones-box::before {
  content: "󰋌";
}

.mdi-headphones-off::before {
  content: "󰟎";
}

.mdi-headphones-settings::before {
  content: "󰋍";
}

.mdi-headset::before {
  content: "󰋎";
}

.mdi-headset-dock::before {
  content: "󰋏";
}

.mdi-headset-off::before {
  content: "󰋐";
}

.mdi-heart::before {
  content: "󰋑";
}

.mdi-heart-box::before {
  content: "󰋒";
}

.mdi-heart-box-outline::before {
  content: "󰋓";
}

.mdi-heart-broken::before {
  content: "󰋔";
}

.mdi-heart-broken-outline::before {
  content: "󰴔";
}

.mdi-heart-circle::before {
  content: "󰥱";
}

.mdi-heart-circle-outline::before {
  content: "󰥲";
}

.mdi-heart-cog::before {
  content: "󱙣";
}

.mdi-heart-cog-outline::before {
  content: "󱙤";
}

.mdi-heart-flash::before {
  content: "󰻹";
}

.mdi-heart-half::before {
  content: "󰛟";
}

.mdi-heart-half-full::before {
  content: "󰛞";
}

.mdi-heart-half-outline::before {
  content: "󰛠";
}

.mdi-heart-minus::before {
  content: "󱐯";
}

.mdi-heart-minus-outline::before {
  content: "󱐲";
}

.mdi-heart-multiple::before {
  content: "󰩖";
}

.mdi-heart-multiple-outline::before {
  content: "󰩗";
}

.mdi-heart-off::before {
  content: "󰝙";
}

.mdi-heart-off-outline::before {
  content: "󱐴";
}

.mdi-heart-outline::before {
  content: "󰋕";
}

.mdi-heart-plus::before {
  content: "󱐮";
}

.mdi-heart-plus-outline::before {
  content: "󱐱";
}

.mdi-heart-pulse::before {
  content: "󰗶";
}

.mdi-heart-remove::before {
  content: "󱐰";
}

.mdi-heart-remove-outline::before {
  content: "󱐳";
}

.mdi-heart-settings::before {
  content: "󱙥";
}

.mdi-heart-settings-outline::before {
  content: "󱙦";
}

.mdi-helicopter::before {
  content: "󰫂";
}

.mdi-help::before {
  content: "󰋖";
}

.mdi-help-box::before {
  content: "󰞋";
}

.mdi-help-circle::before {
  content: "󰋗";
}

.mdi-help-circle-outline::before {
  content: "󰘥";
}

.mdi-help-network::before {
  content: "󰛵";
}

.mdi-help-network-outline::before {
  content: "󰲊";
}

.mdi-help-rhombus::before {
  content: "󰮥";
}

.mdi-help-rhombus-outline::before {
  content: "󰮦";
}

.mdi-hexadecimal::before {
  content: "󱊧";
}

.mdi-hexagon::before {
  content: "󰋘";
}

.mdi-hexagon-multiple::before {
  content: "󰛡";
}

.mdi-hexagon-multiple-outline::before {
  content: "󱃲";
}

.mdi-hexagon-outline::before {
  content: "󰋙";
}

.mdi-hexagon-slice-1::before {
  content: "󰫃";
}

.mdi-hexagon-slice-2::before {
  content: "󰫄";
}

.mdi-hexagon-slice-3::before {
  content: "󰫅";
}

.mdi-hexagon-slice-4::before {
  content: "󰫆";
}

.mdi-hexagon-slice-5::before {
  content: "󰫇";
}

.mdi-hexagon-slice-6::before {
  content: "󰫈";
}

.mdi-hexagram::before {
  content: "󰫉";
}

.mdi-hexagram-outline::before {
  content: "󰫊";
}

.mdi-high-definition::before {
  content: "󰟏";
}

.mdi-high-definition-box::before {
  content: "󰡸";
}

.mdi-highway::before {
  content: "󰗷";
}

.mdi-hiking::before {
  content: "󰵿";
}

.mdi-history::before {
  content: "󰋚";
}

.mdi-hockey-puck::before {
  content: "󰡹";
}

.mdi-hockey-sticks::before {
  content: "󰡺";
}

.mdi-hololens::before {
  content: "󰋛";
}

.mdi-home::before {
  content: "󰋜";
}

.mdi-home-account::before {
  content: "󰠦";
}

.mdi-home-alert::before {
  content: "󰡻";
}

.mdi-home-alert-outline::before {
  content: "󱗐";
}

.mdi-home-analytics::before {
  content: "󰺺";
}

.mdi-home-assistant::before {
  content: "󰟐";
}

.mdi-home-automation::before {
  content: "󰟑";
}

.mdi-home-battery::before {
  content: "󱤁";
}

.mdi-home-battery-outline::before {
  content: "󱤂";
}

.mdi-home-circle::before {
  content: "󰟒";
}

.mdi-home-circle-outline::before {
  content: "󱁍";
}

.mdi-home-city::before {
  content: "󰴕";
}

.mdi-home-city-outline::before {
  content: "󰴖";
}

.mdi-home-edit::before {
  content: "󱅙";
}

.mdi-home-edit-outline::before {
  content: "󱅚";
}

.mdi-home-export-outline::before {
  content: "󰾛";
}

.mdi-home-flood::before {
  content: "󰻺";
}

.mdi-home-floor-0::before {
  content: "󰷒";
}

.mdi-home-floor-1::before {
  content: "󰶀";
}

.mdi-home-floor-2::before {
  content: "󰶁";
}

.mdi-home-floor-3::before {
  content: "󰶂";
}

.mdi-home-floor-a::before {
  content: "󰶃";
}

.mdi-home-floor-b::before {
  content: "󰶄";
}

.mdi-home-floor-g::before {
  content: "󰶅";
}

.mdi-home-floor-l::before {
  content: "󰶆";
}

.mdi-home-floor-negative-1::before {
  content: "󰷓";
}

.mdi-home-group::before {
  content: "󰷔";
}

.mdi-home-group-minus::before {
  content: "󱧁";
}

.mdi-home-group-plus::before {
  content: "󱧀";
}

.mdi-home-group-remove::before {
  content: "󱧂";
}

.mdi-home-heart::before {
  content: "󰠧";
}

.mdi-home-import-outline::before {
  content: "󰾜";
}

.mdi-home-lightbulb::before {
  content: "󱉑";
}

.mdi-home-lightbulb-outline::before {
  content: "󱉒";
}

.mdi-home-lightning-bolt::before {
  content: "󱤃";
}

.mdi-home-lightning-bolt-outline::before {
  content: "󱤄";
}

.mdi-home-lock::before {
  content: "󰣫";
}

.mdi-home-lock-open::before {
  content: "󰣬";
}

.mdi-home-map-marker::before {
  content: "󰗸";
}

.mdi-home-minus::before {
  content: "󰥴";
}

.mdi-home-minus-outline::before {
  content: "󱏕";
}

.mdi-home-modern::before {
  content: "󰋝";
}

.mdi-home-outline::before {
  content: "󰚡";
}

.mdi-home-plus::before {
  content: "󰥵";
}

.mdi-home-plus-outline::before {
  content: "󱏖";
}

.mdi-home-remove::before {
  content: "󱉇";
}

.mdi-home-remove-outline::before {
  content: "󱏗";
}

.mdi-home-roof::before {
  content: "󱄫";
}

.mdi-home-search::before {
  content: "󱎰";
}

.mdi-home-search-outline::before {
  content: "󱎱";
}

.mdi-home-switch::before {
  content: "󱞔";
}

.mdi-home-switch-outline::before {
  content: "󱞕";
}

.mdi-home-thermometer::before {
  content: "󰽔";
}

.mdi-home-thermometer-outline::before {
  content: "󰽕";
}

.mdi-home-variant::before {
  content: "󰋞";
}

.mdi-home-variant-outline::before {
  content: "󰮧";
}

.mdi-hook::before {
  content: "󰛢";
}

.mdi-hook-off::before {
  content: "󰛣";
}

.mdi-hoop-house::before {
  content: "󰹖";
}

.mdi-hops::before {
  content: "󰋟";
}

.mdi-horizontal-rotate-clockwise::before {
  content: "󱃳";
}

.mdi-horizontal-rotate-counterclockwise::before {
  content: "󱃴";
}

.mdi-horse::before {
  content: "󱖿";
}

.mdi-horse-human::before {
  content: "󱗀";
}

.mdi-horse-variant::before {
  content: "󱗁";
}

.mdi-horse-variant-fast::before {
  content: "󱡮";
}

.mdi-horseshoe::before {
  content: "󰩘";
}

.mdi-hospital::before {
  content: "󰿶";
}

.mdi-hospital-box::before {
  content: "󰋠";
}

.mdi-hospital-box-outline::before {
  content: "󰿷";
}

.mdi-hospital-building::before {
  content: "󰋡";
}

.mdi-hospital-marker::before {
  content: "󰋢";
}

.mdi-hot-tub::before {
  content: "󰠨";
}

.mdi-hours-24::before {
  content: "󱑸";
}

.mdi-hubspot::before {
  content: "󰴗";
}

.mdi-hulu::before {
  content: "󰠩";
}

.mdi-human::before {
  content: "󰋦";
}

.mdi-human-baby-changing-table::before {
  content: "󱎋";
}

.mdi-human-cane::before {
  content: "󱖁";
}

.mdi-human-capacity-decrease::before {
  content: "󱖛";
}

.mdi-human-capacity-increase::before {
  content: "󱖜";
}

.mdi-human-child::before {
  content: "󰋧";
}

.mdi-human-dolly::before {
  content: "󱦀";
}

.mdi-human-edit::before {
  content: "󱓨";
}

.mdi-human-female::before {
  content: "󰙉";
}

.mdi-human-female-boy::before {
  content: "󰩙";
}

.mdi-human-female-dance::before {
  content: "󱗉";
}

.mdi-human-female-female::before {
  content: "󰩚";
}

.mdi-human-female-girl::before {
  content: "󰩛";
}

.mdi-human-greeting::before {
  content: "󱟄";
}

.mdi-human-greeting-proximity::before {
  content: "󱖝";
}

.mdi-human-greeting-variant::before {
  content: "󰙊";
}

.mdi-human-handsdown::before {
  content: "󰙋";
}

.mdi-human-handsup::before {
  content: "󰙌";
}

.mdi-human-male::before {
  content: "󰙍";
}

.mdi-human-male-board::before {
  content: "󰢐";
}

.mdi-human-male-board-poll::before {
  content: "󰡆";
}

.mdi-human-male-boy::before {
  content: "󰩜";
}

.mdi-human-male-child::before {
  content: "󱎌";
}

.mdi-human-male-female::before {
  content: "󰋨";
}

.mdi-human-male-female-child::before {
  content: "󱠣";
}

.mdi-human-male-girl::before {
  content: "󰩝";
}

.mdi-human-male-height::before {
  content: "󰻻";
}

.mdi-human-male-height-variant::before {
  content: "󰻼";
}

.mdi-human-male-male::before {
  content: "󰩞";
}

.mdi-human-non-binary::before {
  content: "󱡈";
}

.mdi-human-pregnant::before {
  content: "󰗏";
}

.mdi-human-queue::before {
  content: "󱕱";
}

.mdi-human-scooter::before {
  content: "󱇩";
}

.mdi-human-wheelchair::before {
  content: "󱎍";
}

.mdi-human-white-cane::before {
  content: "󱦁";
}

.mdi-humble-bundle::before {
  content: "󰝄";
}

.mdi-hvac::before {
  content: "󱍒";
}

.mdi-hvac-off::before {
  content: "󱖞";
}

.mdi-hydraulic-oil-level::before {
  content: "󱌤";
}

.mdi-hydraulic-oil-temperature::before {
  content: "󱌥";
}

.mdi-hydro-power::before {
  content: "󱋥";
}

.mdi-hydrogen-station::before {
  content: "󱢔";
}

.mdi-ice-cream::before {
  content: "󰠪";
}

.mdi-ice-cream-off::before {
  content: "󰹒";
}

.mdi-ice-pop::before {
  content: "󰻽";
}

.mdi-id-card::before {
  content: "󰿀";
}

.mdi-identifier::before {
  content: "󰻾";
}

.mdi-ideogram-cjk::before {
  content: "󱌱";
}

.mdi-ideogram-cjk-variant::before {
  content: "󱌲";
}

.mdi-image::before {
  content: "󰋩";
}

.mdi-image-album::before {
  content: "󰋪";
}

.mdi-image-area::before {
  content: "󰋫";
}

.mdi-image-area-close::before {
  content: "󰋬";
}

.mdi-image-auto-adjust::before {
  content: "󰿁";
}

.mdi-image-broken::before {
  content: "󰋭";
}

.mdi-image-broken-variant::before {
  content: "󰋮";
}

.mdi-image-edit::before {
  content: "󱇣";
}

.mdi-image-edit-outline::before {
  content: "󱇤";
}

.mdi-image-filter-black-white::before {
  content: "󰋰";
}

.mdi-image-filter-center-focus::before {
  content: "󰋱";
}

.mdi-image-filter-center-focus-strong::before {
  content: "󰻿";
}

.mdi-image-filter-center-focus-strong-outline::before {
  content: "󰼀";
}

.mdi-image-filter-center-focus-weak::before {
  content: "󰋲";
}

.mdi-image-filter-drama::before {
  content: "󰋳";
}

.mdi-image-filter-frames::before {
  content: "󰋴";
}

.mdi-image-filter-hdr::before {
  content: "󰋵";
}

.mdi-image-filter-none::before {
  content: "󰋶";
}

.mdi-image-filter-tilt-shift::before {
  content: "󰋷";
}

.mdi-image-filter-vintage::before {
  content: "󰋸";
}

.mdi-image-frame::before {
  content: "󰹉";
}

.mdi-image-marker::before {
  content: "󱝻";
}

.mdi-image-marker-outline::before {
  content: "󱝼";
}

.mdi-image-minus::before {
  content: "󱐙";
}

.mdi-image-move::before {
  content: "󰧸";
}

.mdi-image-multiple::before {
  content: "󰋹";
}

.mdi-image-multiple-outline::before {
  content: "󰋯";
}

.mdi-image-off::before {
  content: "󰠫";
}

.mdi-image-off-outline::before {
  content: "󱇑";
}

.mdi-image-outline::before {
  content: "󰥶";
}

.mdi-image-plus::before {
  content: "󰡼";
}

.mdi-image-remove::before {
  content: "󱐘";
}

.mdi-image-search::before {
  content: "󰥷";
}

.mdi-image-search-outline::before {
  content: "󰥸";
}

.mdi-image-size-select-actual::before {
  content: "󰲍";
}

.mdi-image-size-select-large::before {
  content: "󰲎";
}

.mdi-image-size-select-small::before {
  content: "󰲏";
}

.mdi-image-text::before {
  content: "󱘍";
}

.mdi-import::before {
  content: "󰋺";
}

.mdi-inbox::before {
  content: "󰚇";
}

.mdi-inbox-arrow-down::before {
  content: "󰋻";
}

.mdi-inbox-arrow-down-outline::before {
  content: "󱉰";
}

.mdi-inbox-arrow-up::before {
  content: "󰏑";
}

.mdi-inbox-arrow-up-outline::before {
  content: "󱉱";
}

.mdi-inbox-full::before {
  content: "󱉲";
}

.mdi-inbox-full-outline::before {
  content: "󱉳";
}

.mdi-inbox-multiple::before {
  content: "󰢰";
}

.mdi-inbox-multiple-outline::before {
  content: "󰮨";
}

.mdi-inbox-outline::before {
  content: "󱉴";
}

.mdi-inbox-remove::before {
  content: "󱖟";
}

.mdi-inbox-remove-outline::before {
  content: "󱖠";
}

.mdi-incognito::before {
  content: "󰗹";
}

.mdi-incognito-circle::before {
  content: "󱐡";
}

.mdi-incognito-circle-off::before {
  content: "󱐢";
}

.mdi-incognito-off::before {
  content: "󰁵";
}

.mdi-induction::before {
  content: "󱡌";
}

.mdi-infinity::before {
  content: "󰛤";
}

.mdi-information::before {
  content: "󰋼";
}

.mdi-information-off::before {
  content: "󱞌";
}

.mdi-information-off-outline::before {
  content: "󱞍";
}

.mdi-information-outline::before {
  content: "󰋽";
}

.mdi-information-variant::before {
  content: "󰙎";
}

.mdi-instagram::before {
  content: "󰋾";
}

.mdi-instrument-triangle::before {
  content: "󱁎";
}

.mdi-integrated-circuit-chip::before {
  content: "󱤓";
}

.mdi-invert-colors::before {
  content: "󰌁";
}

.mdi-invert-colors-off::before {
  content: "󰹊";
}

.mdi-iobroker::before {
  content: "󱋨";
}

.mdi-ip::before {
  content: "󰩟";
}

.mdi-ip-network::before {
  content: "󰩠";
}

.mdi-ip-network-outline::before {
  content: "󰲐";
}

.mdi-ip-outline::before {
  content: "󱦂";
}

.mdi-ipod::before {
  content: "󰲑";
}

.mdi-iron::before {
  content: "󱠤";
}

.mdi-iron-board::before {
  content: "󱠸";
}

.mdi-iron-outline::before {
  content: "󱠥";
}

.mdi-island::before {
  content: "󱁏";
}

.mdi-iv-bag::before {
  content: "󱂹";
}

.mdi-jabber::before {
  content: "󰷕";
}

.mdi-jeepney::before {
  content: "󰌂";
}

.mdi-jellyfish::before {
  content: "󰼁";
}

.mdi-jellyfish-outline::before {
  content: "󰼂";
}

.mdi-jira::before {
  content: "󰌃";
}

.mdi-jquery::before {
  content: "󰡽";
}

.mdi-jsfiddle::before {
  content: "󰌄";
}

.mdi-jump-rope::before {
  content: "󱋿";
}

.mdi-kabaddi::before {
  content: "󰶇";
}

.mdi-kangaroo::before {
  content: "󱕘";
}

.mdi-karate::before {
  content: "󰠬";
}

.mdi-kayaking::before {
  content: "󰢯";
}

.mdi-keg::before {
  content: "󰌅";
}

.mdi-kettle::before {
  content: "󰗺";
}

.mdi-kettle-alert::before {
  content: "󱌗";
}

.mdi-kettle-alert-outline::before {
  content: "󱌘";
}

.mdi-kettle-off::before {
  content: "󱌛";
}

.mdi-kettle-off-outline::before {
  content: "󱌜";
}

.mdi-kettle-outline::before {
  content: "󰽖";
}

.mdi-kettle-pour-over::before {
  content: "󱜼";
}

.mdi-kettle-steam::before {
  content: "󱌙";
}

.mdi-kettle-steam-outline::before {
  content: "󱌚";
}

.mdi-kettlebell::before {
  content: "󱌀";
}

.mdi-key::before {
  content: "󰌆";
}

.mdi-key-alert::before {
  content: "󱦃";
}

.mdi-key-alert-outline::before {
  content: "󱦄";
}

.mdi-key-arrow-right::before {
  content: "󱌒";
}

.mdi-key-chain::before {
  content: "󱕴";
}

.mdi-key-chain-variant::before {
  content: "󱕵";
}

.mdi-key-change::before {
  content: "󰌇";
}

.mdi-key-link::before {
  content: "󱆟";
}

.mdi-key-minus::before {
  content: "󰌈";
}

.mdi-key-outline::before {
  content: "󰷖";
}

.mdi-key-plus::before {
  content: "󰌉";
}

.mdi-key-remove::before {
  content: "󰌊";
}

.mdi-key-star::before {
  content: "󱆞";
}

.mdi-key-variant::before {
  content: "󰌋";
}

.mdi-key-wireless::before {
  content: "󰿂";
}

.mdi-keyboard::before {
  content: "󰌌";
}

.mdi-keyboard-backspace::before {
  content: "󰌍";
}

.mdi-keyboard-caps::before {
  content: "󰌎";
}

.mdi-keyboard-close::before {
  content: "󰌏";
}

.mdi-keyboard-esc::before {
  content: "󱊷";
}

.mdi-keyboard-f1::before {
  content: "󱊫";
}

.mdi-keyboard-f10::before {
  content: "󱊴";
}

.mdi-keyboard-f11::before {
  content: "󱊵";
}

.mdi-keyboard-f12::before {
  content: "󱊶";
}

.mdi-keyboard-f2::before {
  content: "󱊬";
}

.mdi-keyboard-f3::before {
  content: "󱊭";
}

.mdi-keyboard-f4::before {
  content: "󱊮";
}

.mdi-keyboard-f5::before {
  content: "󱊯";
}

.mdi-keyboard-f6::before {
  content: "󱊰";
}

.mdi-keyboard-f7::before {
  content: "󱊱";
}

.mdi-keyboard-f8::before {
  content: "󱊲";
}

.mdi-keyboard-f9::before {
  content: "󱊳";
}

.mdi-keyboard-off::before {
  content: "󰌐";
}

.mdi-keyboard-off-outline::before {
  content: "󰹋";
}

.mdi-keyboard-outline::before {
  content: "󰥻";
}

.mdi-keyboard-return::before {
  content: "󰌑";
}

.mdi-keyboard-settings::before {
  content: "󰧹";
}

.mdi-keyboard-settings-outline::before {
  content: "󰧺";
}

.mdi-keyboard-space::before {
  content: "󱁐";
}

.mdi-keyboard-tab::before {
  content: "󰌒";
}

.mdi-keyboard-tab-reverse::before {
  content: "󰌥";
}

.mdi-keyboard-variant::before {
  content: "󰌓";
}

.mdi-khanda::before {
  content: "󱃽";
}

.mdi-kickstarter::before {
  content: "󰝅";
}

.mdi-kite::before {
  content: "󱦅";
}

.mdi-kite-outline::before {
  content: "󱦆";
}

.mdi-kitesurfing::before {
  content: "󱝄";
}

.mdi-klingon::before {
  content: "󱍛";
}

.mdi-knife::before {
  content: "󰧻";
}

.mdi-knife-military::before {
  content: "󰧼";
}

.mdi-koala::before {
  content: "󱜿";
}

.mdi-kodi::before {
  content: "󰌔";
}

.mdi-kubernetes::before {
  content: "󱃾";
}

.mdi-label::before {
  content: "󰌕";
}

.mdi-label-multiple::before {
  content: "󱍵";
}

.mdi-label-multiple-outline::before {
  content: "󱍶";
}

.mdi-label-off::before {
  content: "󰫋";
}

.mdi-label-off-outline::before {
  content: "󰫌";
}

.mdi-label-outline::before {
  content: "󰌖";
}

.mdi-label-percent::before {
  content: "󱋪";
}

.mdi-label-percent-outline::before {
  content: "󱋫";
}

.mdi-label-variant::before {
  content: "󰫍";
}

.mdi-label-variant-outline::before {
  content: "󰫎";
}

.mdi-ladder::before {
  content: "󱖢";
}

.mdi-ladybug::before {
  content: "󰠭";
}

.mdi-lambda::before {
  content: "󰘧";
}

.mdi-lamp::before {
  content: "󰚵";
}

.mdi-lamp-outline::before {
  content: "󱟐";
}

.mdi-lamps::before {
  content: "󱕶";
}

.mdi-lamps-outline::before {
  content: "󱟑";
}

.mdi-lan::before {
  content: "󰌗";
}

.mdi-lan-check::before {
  content: "󱊪";
}

.mdi-lan-connect::before {
  content: "󰌘";
}

.mdi-lan-disconnect::before {
  content: "󰌙";
}

.mdi-lan-pending::before {
  content: "󰌚";
}

.mdi-language-c::before {
  content: "󰙱";
}

.mdi-language-cpp::before {
  content: "󰙲";
}

.mdi-language-csharp::before {
  content: "󰌛";
}

.mdi-language-css3::before {
  content: "󰌜";
}

.mdi-language-fortran::before {
  content: "󱈚";
}

.mdi-language-go::before {
  content: "󰟓";
}

.mdi-language-haskell::before {
  content: "󰲒";
}

.mdi-language-html5::before {
  content: "󰌝";
}

.mdi-language-java::before {
  content: "󰬷";
}

.mdi-language-javascript::before {
  content: "󰌞";
}

.mdi-language-kotlin::before {
  content: "󱈙";
}

.mdi-language-lua::before {
  content: "󰢱";
}

.mdi-language-markdown::before {
  content: "󰍔";
}

.mdi-language-markdown-outline::before {
  content: "󰽛";
}

.mdi-language-php::before {
  content: "󰌟";
}

.mdi-language-python::before {
  content: "󰌠";
}

.mdi-language-r::before {
  content: "󰟔";
}

.mdi-language-ruby::before {
  content: "󰴭";
}

.mdi-language-ruby-on-rails::before {
  content: "󰫏";
}

.mdi-language-rust::before {
  content: "󱘗";
}

.mdi-language-swift::before {
  content: "󰛥";
}

.mdi-language-typescript::before {
  content: "󰛦";
}

.mdi-language-xaml::before {
  content: "󰙳";
}

.mdi-laptop::before {
  content: "󰌢";
}

.mdi-laptop-off::before {
  content: "󰛧";
}

.mdi-laravel::before {
  content: "󰫐";
}

.mdi-laser-pointer::before {
  content: "󱒄";
}

.mdi-lasso::before {
  content: "󰼃";
}

.mdi-lastpass::before {
  content: "󰑆";
}

.mdi-latitude::before {
  content: "󰽗";
}

.mdi-launch::before {
  content: "󰌧";
}

.mdi-lava-lamp::before {
  content: "󰟕";
}

.mdi-layers::before {
  content: "󰌨";
}

.mdi-layers-edit::before {
  content: "󱢒";
}

.mdi-layers-minus::before {
  content: "󰹌";
}

.mdi-layers-off::before {
  content: "󰌩";
}

.mdi-layers-off-outline::before {
  content: "󰧽";
}

.mdi-layers-outline::before {
  content: "󰧾";
}

.mdi-layers-plus::before {
  content: "󰹍";
}

.mdi-layers-remove::before {
  content: "󰹎";
}

.mdi-layers-search::before {
  content: "󱈆";
}

.mdi-layers-search-outline::before {
  content: "󱈇";
}

.mdi-layers-triple::before {
  content: "󰽘";
}

.mdi-layers-triple-outline::before {
  content: "󰽙";
}

.mdi-lead-pencil::before {
  content: "󰙏";
}

.mdi-leaf::before {
  content: "󰌪";
}

.mdi-leaf-circle::before {
  content: "󱤅";
}

.mdi-leaf-circle-outline::before {
  content: "󱤆";
}

.mdi-leaf-maple::before {
  content: "󰲓";
}

.mdi-leaf-maple-off::before {
  content: "󱋚";
}

.mdi-leaf-off::before {
  content: "󱋙";
}

.mdi-leak::before {
  content: "󰷗";
}

.mdi-leak-off::before {
  content: "󰷘";
}

.mdi-led-off::before {
  content: "󰌫";
}

.mdi-led-on::before {
  content: "󰌬";
}

.mdi-led-outline::before {
  content: "󰌭";
}

.mdi-led-strip::before {
  content: "󰟖";
}

.mdi-led-strip-variant::before {
  content: "󱁑";
}

.mdi-led-variant-off::before {
  content: "󰌮";
}

.mdi-led-variant-on::before {
  content: "󰌯";
}

.mdi-led-variant-outline::before {
  content: "󰌰";
}

.mdi-leek::before {
  content: "󱅽";
}

.mdi-less-than::before {
  content: "󰥼";
}

.mdi-less-than-or-equal::before {
  content: "󰥽";
}

.mdi-library::before {
  content: "󰌱";
}

.mdi-library-shelves::before {
  content: "󰮩";
}

.mdi-license::before {
  content: "󰿃";
}

.mdi-lifebuoy::before {
  content: "󰡾";
}

.mdi-light-flood-down::before {
  content: "󱦇";
}

.mdi-light-flood-up::before {
  content: "󱦈";
}

.mdi-light-recessed::before {
  content: "󱞛";
}

.mdi-light-switch::before {
  content: "󰥾";
}

.mdi-lightbulb::before {
  content: "󰌵";
}

.mdi-lightbulb-auto::before {
  content: "󱠀";
}

.mdi-lightbulb-auto-outline::before {
  content: "󱠁";
}

.mdi-lightbulb-cfl::before {
  content: "󱈈";
}

.mdi-lightbulb-cfl-off::before {
  content: "󱈉";
}

.mdi-lightbulb-cfl-spiral::before {
  content: "󱉵";
}

.mdi-lightbulb-cfl-spiral-off::before {
  content: "󱋃";
}

.mdi-lightbulb-fluorescent-tube::before {
  content: "󱠄";
}

.mdi-lightbulb-fluorescent-tube-outline::before {
  content: "󱠅";
}

.mdi-lightbulb-group::before {
  content: "󱉓";
}

.mdi-lightbulb-group-off::before {
  content: "󱋍";
}

.mdi-lightbulb-group-off-outline::before {
  content: "󱋎";
}

.mdi-lightbulb-group-outline::before {
  content: "󱉔";
}

.mdi-lightbulb-multiple::before {
  content: "󱉕";
}

.mdi-lightbulb-multiple-off::before {
  content: "󱋏";
}

.mdi-lightbulb-multiple-off-outline::before {
  content: "󱋐";
}

.mdi-lightbulb-multiple-outline::before {
  content: "󱉖";
}

.mdi-lightbulb-off::before {
  content: "󰹏";
}

.mdi-lightbulb-off-outline::before {
  content: "󰹐";
}

.mdi-lightbulb-on::before {
  content: "󰛨";
}

.mdi-lightbulb-on-outline::before {
  content: "󰛩";
}

.mdi-lightbulb-outline::before {
  content: "󰌶";
}

.mdi-lightbulb-spot::before {
  content: "󱟴";
}

.mdi-lightbulb-spot-off::before {
  content: "󱟵";
}

.mdi-lightbulb-variant::before {
  content: "󱠂";
}

.mdi-lightbulb-variant-outline::before {
  content: "󱠃";
}

.mdi-lighthouse::before {
  content: "󰧿";
}

.mdi-lighthouse-on::before {
  content: "󰨀";
}

.mdi-lightning-bolt::before {
  content: "󱐋";
}

.mdi-lightning-bolt-circle::before {
  content: "󰠠";
}

.mdi-lightning-bolt-outline::before {
  content: "󱐌";
}

.mdi-line-scan::before {
  content: "󰘤";
}

.mdi-lingerie::before {
  content: "󱑶";
}

.mdi-link::before {
  content: "󰌷";
}

.mdi-link-box::before {
  content: "󰴚";
}

.mdi-link-box-outline::before {
  content: "󰴛";
}

.mdi-link-box-variant::before {
  content: "󰴜";
}

.mdi-link-box-variant-outline::before {
  content: "󰴝";
}

.mdi-link-lock::before {
  content: "󱂺";
}

.mdi-link-off::before {
  content: "󰌸";
}

.mdi-link-plus::before {
  content: "󰲔";
}

.mdi-link-variant::before {
  content: "󰌹";
}

.mdi-link-variant-minus::before {
  content: "󱃿";
}

.mdi-link-variant-off::before {
  content: "󰌺";
}

.mdi-link-variant-plus::before {
  content: "󱄀";
}

.mdi-link-variant-remove::before {
  content: "󱄁";
}

.mdi-linkedin::before {
  content: "󰌻";
}

.mdi-linux::before {
  content: "󰌽";
}

.mdi-linux-mint::before {
  content: "󰣭";
}

.mdi-lipstick::before {
  content: "󱎵";
}

.mdi-liquid-spot::before {
  content: "󱠦";
}

.mdi-liquor::before {
  content: "󱤞";
}

.mdi-list-status::before {
  content: "󱖫";
}

.mdi-litecoin::before {
  content: "󰩡";
}

.mdi-loading::before {
  content: "󰝲";
}

.mdi-location-enter::before {
  content: "󰿄";
}

.mdi-location-exit::before {
  content: "󰿅";
}

.mdi-lock::before {
  content: "󰌾";
}

.mdi-lock-alert::before {
  content: "󰣮";
}

.mdi-lock-alert-outline::before {
  content: "󱗑";
}

.mdi-lock-check::before {
  content: "󱎚";
}

.mdi-lock-check-outline::before {
  content: "󱚨";
}

.mdi-lock-clock::before {
  content: "󰥿";
}

.mdi-lock-minus::before {
  content: "󱚩";
}

.mdi-lock-minus-outline::before {
  content: "󱚪";
}

.mdi-lock-off::before {
  content: "󱙱";
}

.mdi-lock-off-outline::before {
  content: "󱙲";
}

.mdi-lock-open::before {
  content: "󰌿";
}

.mdi-lock-open-alert::before {
  content: "󱎛";
}

.mdi-lock-open-alert-outline::before {
  content: "󱗒";
}

.mdi-lock-open-check::before {
  content: "󱎜";
}

.mdi-lock-open-check-outline::before {
  content: "󱚫";
}

.mdi-lock-open-minus::before {
  content: "󱚬";
}

.mdi-lock-open-minus-outline::before {
  content: "󱚭";
}

.mdi-lock-open-outline::before {
  content: "󰍀";
}

.mdi-lock-open-plus::before {
  content: "󱚮";
}

.mdi-lock-open-plus-outline::before {
  content: "󱚯";
}

.mdi-lock-open-remove::before {
  content: "󱚰";
}

.mdi-lock-open-remove-outline::before {
  content: "󱚱";
}

.mdi-lock-open-variant::before {
  content: "󰿆";
}

.mdi-lock-open-variant-outline::before {
  content: "󰿇";
}

.mdi-lock-outline::before {
  content: "󰍁";
}

.mdi-lock-pattern::before {
  content: "󰛪";
}

.mdi-lock-plus::before {
  content: "󰗻";
}

.mdi-lock-plus-outline::before {
  content: "󱚲";
}

.mdi-lock-question::before {
  content: "󰣯";
}

.mdi-lock-remove::before {
  content: "󱚳";
}

.mdi-lock-remove-outline::before {
  content: "󱚴";
}

.mdi-lock-reset::before {
  content: "󰝳";
}

.mdi-lock-smart::before {
  content: "󰢲";
}

.mdi-locker::before {
  content: "󰟗";
}

.mdi-locker-multiple::before {
  content: "󰟘";
}

.mdi-login::before {
  content: "󰍂";
}

.mdi-login-variant::before {
  content: "󰗼";
}

.mdi-logout::before {
  content: "󰍃";
}

.mdi-logout-variant::before {
  content: "󰗽";
}

.mdi-longitude::before {
  content: "󰽚";
}

.mdi-looks::before {
  content: "󰍄";
}

.mdi-lotion::before {
  content: "󱖂";
}

.mdi-lotion-outline::before {
  content: "󱖃";
}

.mdi-lotion-plus::before {
  content: "󱖄";
}

.mdi-lotion-plus-outline::before {
  content: "󱖅";
}

.mdi-loupe::before {
  content: "󰍅";
}

.mdi-lumx::before {
  content: "󰍆";
}

.mdi-lungs::before {
  content: "󱂄";
}

.mdi-mace::before {
  content: "󱡃";
}

.mdi-magazine-pistol::before {
  content: "󰌤";
}

.mdi-magazine-rifle::before {
  content: "󰌣";
}

.mdi-magic-staff::before {
  content: "󱡄";
}

.mdi-magnet::before {
  content: "󰍇";
}

.mdi-magnet-on::before {
  content: "󰍈";
}

.mdi-magnify::before {
  content: "󰍉";
}

.mdi-magnify-close::before {
  content: "󰦀";
}

.mdi-magnify-expand::before {
  content: "󱡴";
}

.mdi-magnify-minus::before {
  content: "󰍊";
}

.mdi-magnify-minus-cursor::before {
  content: "󰩢";
}

.mdi-magnify-minus-outline::before {
  content: "󰛬";
}

.mdi-magnify-plus::before {
  content: "󰍋";
}

.mdi-magnify-plus-cursor::before {
  content: "󰩣";
}

.mdi-magnify-plus-outline::before {
  content: "󰛭";
}

.mdi-magnify-remove-cursor::before {
  content: "󱈌";
}

.mdi-magnify-remove-outline::before {
  content: "󱈍";
}

.mdi-magnify-scan::before {
  content: "󱉶";
}

.mdi-mail::before {
  content: "󰺻";
}

.mdi-mailbox::before {
  content: "󰛮";
}

.mdi-mailbox-open::before {
  content: "󰶈";
}

.mdi-mailbox-open-outline::before {
  content: "󰶉";
}

.mdi-mailbox-open-up::before {
  content: "󰶊";
}

.mdi-mailbox-open-up-outline::before {
  content: "󰶋";
}

.mdi-mailbox-outline::before {
  content: "󰶌";
}

.mdi-mailbox-up::before {
  content: "󰶍";
}

.mdi-mailbox-up-outline::before {
  content: "󰶎";
}

.mdi-manjaro::before {
  content: "󱘊";
}

.mdi-map::before {
  content: "󰍍";
}

.mdi-map-check::before {
  content: "󰺼";
}

.mdi-map-check-outline::before {
  content: "󰺽";
}

.mdi-map-clock::before {
  content: "󰴞";
}

.mdi-map-clock-outline::before {
  content: "󰴟";
}

.mdi-map-legend::before {
  content: "󰨁";
}

.mdi-map-marker::before {
  content: "󰍎";
}

.mdi-map-marker-account::before {
  content: "󱣣";
}

.mdi-map-marker-account-outline::before {
  content: "󱣤";
}

.mdi-map-marker-alert::before {
  content: "󰼅";
}

.mdi-map-marker-alert-outline::before {
  content: "󰼆";
}

.mdi-map-marker-check::before {
  content: "󰲕";
}

.mdi-map-marker-check-outline::before {
  content: "󱋻";
}

.mdi-map-marker-circle::before {
  content: "󰍏";
}

.mdi-map-marker-distance::before {
  content: "󰣰";
}

.mdi-map-marker-down::before {
  content: "󱄂";
}

.mdi-map-marker-left::before {
  content: "󱋛";
}

.mdi-map-marker-left-outline::before {
  content: "󱋝";
}

.mdi-map-marker-minus::before {
  content: "󰙐";
}

.mdi-map-marker-minus-outline::before {
  content: "󱋹";
}

.mdi-map-marker-multiple::before {
  content: "󰍐";
}

.mdi-map-marker-multiple-outline::before {
  content: "󱉷";
}

.mdi-map-marker-off::before {
  content: "󰍑";
}

.mdi-map-marker-off-outline::before {
  content: "󱋽";
}

.mdi-map-marker-outline::before {
  content: "󰟙";
}

.mdi-map-marker-path::before {
  content: "󰴠";
}

.mdi-map-marker-plus::before {
  content: "󰙑";
}

.mdi-map-marker-plus-outline::before {
  content: "󱋸";
}

.mdi-map-marker-question::before {
  content: "󰼇";
}

.mdi-map-marker-question-outline::before {
  content: "󰼈";
}

.mdi-map-marker-radius::before {
  content: "󰍒";
}

.mdi-map-marker-radius-outline::before {
  content: "󱋼";
}

.mdi-map-marker-remove::before {
  content: "󰼉";
}

.mdi-map-marker-remove-outline::before {
  content: "󱋺";
}

.mdi-map-marker-remove-variant::before {
  content: "󰼊";
}

.mdi-map-marker-right::before {
  content: "󱋜";
}

.mdi-map-marker-right-outline::before {
  content: "󱋞";
}

.mdi-map-marker-star::before {
  content: "󱘈";
}

.mdi-map-marker-star-outline::before {
  content: "󱘉";
}

.mdi-map-marker-up::before {
  content: "󱄃";
}

.mdi-map-minus::before {
  content: "󰦁";
}

.mdi-map-outline::before {
  content: "󰦂";
}

.mdi-map-plus::before {
  content: "󰦃";
}

.mdi-map-search::before {
  content: "󰦄";
}

.mdi-map-search-outline::before {
  content: "󰦅";
}

.mdi-mapbox::before {
  content: "󰮪";
}

.mdi-margin::before {
  content: "󰍓";
}

.mdi-marker::before {
  content: "󰙒";
}

.mdi-marker-cancel::before {
  content: "󰷙";
}

.mdi-marker-check::before {
  content: "󰍕";
}

.mdi-mastodon::before {
  content: "󰫑";
}

.mdi-material-design::before {
  content: "󰦆";
}

.mdi-material-ui::before {
  content: "󰍗";
}

.mdi-math-compass::before {
  content: "󰍘";
}

.mdi-math-cos::before {
  content: "󰲖";
}

.mdi-math-integral::before {
  content: "󰿈";
}

.mdi-math-integral-box::before {
  content: "󰿉";
}

.mdi-math-log::before {
  content: "󱂅";
}

.mdi-math-norm::before {
  content: "󰿊";
}

.mdi-math-norm-box::before {
  content: "󰿋";
}

.mdi-math-sin::before {
  content: "󰲗";
}

.mdi-math-tan::before {
  content: "󰲘";
}

.mdi-matrix::before {
  content: "󰘨";
}

.mdi-medal::before {
  content: "󰦇";
}

.mdi-medal-outline::before {
  content: "󱌦";
}

.mdi-medical-bag::before {
  content: "󰛯";
}

.mdi-meditation::before {
  content: "󱅻";
}

.mdi-memory::before {
  content: "󰍛";
}

.mdi-menorah::before {
  content: "󱟔";
}

.mdi-menorah-fire::before {
  content: "󱟕";
}

.mdi-menu::before {
  content: "󰍜";
}

.mdi-menu-down::before {
  content: "󰍝";
}

.mdi-menu-down-outline::before {
  content: "󰚶";
}

.mdi-menu-left::before {
  content: "󰍞";
}

.mdi-menu-left-outline::before {
  content: "󰨂";
}

.mdi-menu-open::before {
  content: "󰮫";
}

.mdi-menu-right::before {
  content: "󰍟";
}

.mdi-menu-right-outline::before {
  content: "󰨃";
}

.mdi-menu-swap::before {
  content: "󰩤";
}

.mdi-menu-swap-outline::before {
  content: "󰩥";
}

.mdi-menu-up::before {
  content: "󰍠";
}

.mdi-menu-up-outline::before {
  content: "󰚷";
}

.mdi-merge::before {
  content: "󰽜";
}

.mdi-message::before {
  content: "󰍡";
}

.mdi-message-alert::before {
  content: "󰍢";
}

.mdi-message-alert-outline::before {
  content: "󰨄";
}

.mdi-message-arrow-left::before {
  content: "󱋲";
}

.mdi-message-arrow-left-outline::before {
  content: "󱋳";
}

.mdi-message-arrow-right::before {
  content: "󱋴";
}

.mdi-message-arrow-right-outline::before {
  content: "󱋵";
}

.mdi-message-badge::before {
  content: "󱥁";
}

.mdi-message-badge-outline::before {
  content: "󱥂";
}

.mdi-message-bookmark::before {
  content: "󱖬";
}

.mdi-message-bookmark-outline::before {
  content: "󱖭";
}

.mdi-message-bulleted::before {
  content: "󰚢";
}

.mdi-message-bulleted-off::before {
  content: "󰚣";
}

.mdi-message-cog::before {
  content: "󰛱";
}

.mdi-message-cog-outline::before {
  content: "󱅲";
}

.mdi-message-draw::before {
  content: "󰍣";
}

.mdi-message-flash::before {
  content: "󱖩";
}

.mdi-message-flash-outline::before {
  content: "󱖪";
}

.mdi-message-image::before {
  content: "󰍤";
}

.mdi-message-image-outline::before {
  content: "󱅬";
}

.mdi-message-lock::before {
  content: "󰿌";
}

.mdi-message-lock-outline::before {
  content: "󱅭";
}

.mdi-message-minus::before {
  content: "󱅮";
}

.mdi-message-minus-outline::before {
  content: "󱅯";
}

.mdi-message-off::before {
  content: "󱙍";
}

.mdi-message-off-outline::before {
  content: "󱙎";
}

.mdi-message-outline::before {
  content: "󰍥";
}

.mdi-message-plus::before {
  content: "󰙓";
}

.mdi-message-plus-outline::before {
  content: "󱂻";
}

.mdi-message-processing::before {
  content: "󰍦";
}

.mdi-message-processing-outline::before {
  content: "󱅰";
}

.mdi-message-question::before {
  content: "󱜺";
}

.mdi-message-question-outline::before {
  content: "󱜻";
}

.mdi-message-reply::before {
  content: "󰍧";
}

.mdi-message-reply-outline::before {
  content: "󱜽";
}

.mdi-message-reply-text::before {
  content: "󰍨";
}

.mdi-message-reply-text-outline::before {
  content: "󱜾";
}

.mdi-message-settings::before {
  content: "󰛰";
}

.mdi-message-settings-outline::before {
  content: "󱅱";
}

.mdi-message-star::before {
  content: "󰚚";
}

.mdi-message-star-outline::before {
  content: "󱉐";
}

.mdi-message-text::before {
  content: "󰍩";
}

.mdi-message-text-clock::before {
  content: "󱅳";
}

.mdi-message-text-clock-outline::before {
  content: "󱅴";
}

.mdi-message-text-lock::before {
  content: "󰿍";
}

.mdi-message-text-lock-outline::before {
  content: "󱅵";
}

.mdi-message-text-outline::before {
  content: "󰍪";
}

.mdi-message-video::before {
  content: "󰍫";
}

.mdi-meteor::before {
  content: "󰘩";
}

.mdi-metronome::before {
  content: "󰟚";
}

.mdi-metronome-tick::before {
  content: "󰟛";
}

.mdi-micro-sd::before {
  content: "󰟜";
}

.mdi-microphone::before {
  content: "󰍬";
}

.mdi-microphone-minus::before {
  content: "󰢳";
}

.mdi-microphone-off::before {
  content: "󰍭";
}

.mdi-microphone-outline::before {
  content: "󰍮";
}

.mdi-microphone-plus::before {
  content: "󰢴";
}

.mdi-microphone-question::before {
  content: "󱦉";
}

.mdi-microphone-question-outline::before {
  content: "󱦊";
}

.mdi-microphone-settings::before {
  content: "󰍯";
}

.mdi-microphone-variant::before {
  content: "󰍰";
}

.mdi-microphone-variant-off::before {
  content: "󰍱";
}

.mdi-microscope::before {
  content: "󰙔";
}

.mdi-microsoft::before {
  content: "󰍲";
}

.mdi-microsoft-access::before {
  content: "󱎎";
}

.mdi-microsoft-azure::before {
  content: "󰠅";
}

.mdi-microsoft-azure-devops::before {
  content: "󰿕";
}

.mdi-microsoft-bing::before {
  content: "󰂤";
}

.mdi-microsoft-dynamics-365::before {
  content: "󰦈";
}

.mdi-microsoft-edge::before {
  content: "󰇩";
}

.mdi-microsoft-excel::before {
  content: "󱎏";
}

.mdi-microsoft-internet-explorer::before {
  content: "󰌀";
}

.mdi-microsoft-office::before {
  content: "󰏆";
}

.mdi-microsoft-onedrive::before {
  content: "󰏊";
}

.mdi-microsoft-onenote::before {
  content: "󰝇";
}

.mdi-microsoft-outlook::before {
  content: "󰴢";
}

.mdi-microsoft-powerpoint::before {
  content: "󱎐";
}

.mdi-microsoft-sharepoint::before {
  content: "󱎑";
}

.mdi-microsoft-teams::before {
  content: "󰊻";
}

.mdi-microsoft-visual-studio::before {
  content: "󰘐";
}

.mdi-microsoft-visual-studio-code::before {
  content: "󰨞";
}

.mdi-microsoft-windows::before {
  content: "󰖳";
}

.mdi-microsoft-windows-classic::before {
  content: "󰨡";
}

.mdi-microsoft-word::before {
  content: "󱎒";
}

.mdi-microsoft-xbox::before {
  content: "󰖹";
}

.mdi-microsoft-xbox-controller::before {
  content: "󰖺";
}

.mdi-microsoft-xbox-controller-battery-alert::before {
  content: "󰝋";
}

.mdi-microsoft-xbox-controller-battery-charging::before {
  content: "󰨢";
}

.mdi-microsoft-xbox-controller-battery-empty::before {
  content: "󰝌";
}

.mdi-microsoft-xbox-controller-battery-full::before {
  content: "󰝍";
}

.mdi-microsoft-xbox-controller-battery-low::before {
  content: "󰝎";
}

.mdi-microsoft-xbox-controller-battery-medium::before {
  content: "󰝏";
}

.mdi-microsoft-xbox-controller-battery-unknown::before {
  content: "󰝐";
}

.mdi-microsoft-xbox-controller-menu::before {
  content: "󰹯";
}

.mdi-microsoft-xbox-controller-off::before {
  content: "󰖻";
}

.mdi-microsoft-xbox-controller-view::before {
  content: "󰹰";
}

.mdi-microwave::before {
  content: "󰲙";
}

.mdi-microwave-off::before {
  content: "󱐣";
}

.mdi-middleware::before {
  content: "󰽝";
}

.mdi-middleware-outline::before {
  content: "󰽞";
}

.mdi-midi::before {
  content: "󰣱";
}

.mdi-midi-port::before {
  content: "󰣲";
}

.mdi-mine::before {
  content: "󰷚";
}

.mdi-minecraft::before {
  content: "󰍳";
}

.mdi-mini-sd::before {
  content: "󰨅";
}

.mdi-minidisc::before {
  content: "󰨆";
}

.mdi-minus::before {
  content: "󰍴";
}

.mdi-minus-box::before {
  content: "󰍵";
}

.mdi-minus-box-multiple::before {
  content: "󱅁";
}

.mdi-minus-box-multiple-outline::before {
  content: "󱅂";
}

.mdi-minus-box-outline::before {
  content: "󰛲";
}

.mdi-minus-circle::before {
  content: "󰍶";
}

.mdi-minus-circle-multiple::before {
  content: "󰍚";
}

.mdi-minus-circle-multiple-outline::before {
  content: "󰫓";
}

.mdi-minus-circle-off::before {
  content: "󱑙";
}

.mdi-minus-circle-off-outline::before {
  content: "󱑚";
}

.mdi-minus-circle-outline::before {
  content: "󰍷";
}

.mdi-minus-network::before {
  content: "󰍸";
}

.mdi-minus-network-outline::before {
  content: "󰲚";
}

.mdi-minus-thick::before {
  content: "󱘹";
}

.mdi-mirror::before {
  content: "󱇽";
}

.mdi-mirror-rectangle::before {
  content: "󱞟";
}

.mdi-mirror-variant::before {
  content: "󱞠";
}

.mdi-mixed-martial-arts::before {
  content: "󰶏";
}

.mdi-mixed-reality::before {
  content: "󰡿";
}

.mdi-molecule::before {
  content: "󰮬";
}

.mdi-molecule-co::before {
  content: "󱋾";
}

.mdi-molecule-co2::before {
  content: "󰟤";
}

.mdi-monitor::before {
  content: "󰍹";
}

.mdi-monitor-cellphone::before {
  content: "󰦉";
}

.mdi-monitor-cellphone-star::before {
  content: "󰦊";
}

.mdi-monitor-dashboard::before {
  content: "󰨇";
}

.mdi-monitor-edit::before {
  content: "󱋆";
}

.mdi-monitor-eye::before {
  content: "󱎴";
}

.mdi-monitor-lock::before {
  content: "󰷛";
}

.mdi-monitor-multiple::before {
  content: "󰍺";
}

.mdi-monitor-off::before {
  content: "󰶐";
}

.mdi-monitor-screenshot::before {
  content: "󰹑";
}

.mdi-monitor-share::before {
  content: "󱒃";
}

.mdi-monitor-shimmer::before {
  content: "󱄄";
}

.mdi-monitor-small::before {
  content: "󱡶";
}

.mdi-monitor-speaker::before {
  content: "󰽟";
}

.mdi-monitor-speaker-off::before {
  content: "󰽠";
}

.mdi-monitor-star::before {
  content: "󰷜";
}

.mdi-moon-first-quarter::before {
  content: "󰽡";
}

.mdi-moon-full::before {
  content: "󰽢";
}

.mdi-moon-last-quarter::before {
  content: "󰽣";
}

.mdi-moon-new::before {
  content: "󰽤";
}

.mdi-moon-waning-crescent::before {
  content: "󰽥";
}

.mdi-moon-waning-gibbous::before {
  content: "󰽦";
}

.mdi-moon-waxing-crescent::before {
  content: "󰽧";
}

.mdi-moon-waxing-gibbous::before {
  content: "󰽨";
}

.mdi-moped::before {
  content: "󱂆";
}

.mdi-moped-electric::before {
  content: "󱖷";
}

.mdi-moped-electric-outline::before {
  content: "󱖸";
}

.mdi-moped-outline::before {
  content: "󱖹";
}

.mdi-more::before {
  content: "󰍻";
}

.mdi-mortar-pestle::before {
  content: "󱝈";
}

.mdi-mortar-pestle-plus::before {
  content: "󰏱";
}

.mdi-mosque::before {
  content: "󱠧";
}

.mdi-mother-heart::before {
  content: "󱌔";
}

.mdi-mother-nurse::before {
  content: "󰴡";
}

.mdi-motion::before {
  content: "󱖲";
}

.mdi-motion-outline::before {
  content: "󱖳";
}

.mdi-motion-pause::before {
  content: "󱖐";
}

.mdi-motion-pause-outline::before {
  content: "󱖒";
}

.mdi-motion-play::before {
  content: "󱖏";
}

.mdi-motion-play-outline::before {
  content: "󱖑";
}

.mdi-motion-sensor::before {
  content: "󰶑";
}

.mdi-motion-sensor-off::before {
  content: "󱐵";
}

.mdi-motorbike::before {
  content: "󰍼";
}

.mdi-motorbike-electric::before {
  content: "󱖺";
}

.mdi-mouse::before {
  content: "󰍽";
}

.mdi-mouse-bluetooth::before {
  content: "󰦋";
}

.mdi-mouse-move-down::before {
  content: "󱕐";
}

.mdi-mouse-move-up::before {
  content: "󱕑";
}

.mdi-mouse-move-vertical::before {
  content: "󱕒";
}

.mdi-mouse-off::before {
  content: "󰍾";
}

.mdi-mouse-variant::before {
  content: "󰍿";
}

.mdi-mouse-variant-off::before {
  content: "󰎀";
}

.mdi-move-resize::before {
  content: "󰙕";
}

.mdi-move-resize-variant::before {
  content: "󰙖";
}

.mdi-movie::before {
  content: "󰎁";
}

.mdi-movie-check::before {
  content: "󱛳";
}

.mdi-movie-check-outline::before {
  content: "󱛴";
}

.mdi-movie-cog::before {
  content: "󱛵";
}

.mdi-movie-cog-outline::before {
  content: "󱛶";
}

.mdi-movie-edit::before {
  content: "󱄢";
}

.mdi-movie-edit-outline::before {
  content: "󱄣";
}

.mdi-movie-filter::before {
  content: "󱄤";
}

.mdi-movie-filter-outline::before {
  content: "󱄥";
}

.mdi-movie-minus::before {
  content: "󱛷";
}

.mdi-movie-minus-outline::before {
  content: "󱛸";
}

.mdi-movie-off::before {
  content: "󱛹";
}

.mdi-movie-off-outline::before {
  content: "󱛺";
}

.mdi-movie-open::before {
  content: "󰿎";
}

.mdi-movie-open-check::before {
  content: "󱛻";
}

.mdi-movie-open-check-outline::before {
  content: "󱛼";
}

.mdi-movie-open-cog::before {
  content: "󱛽";
}

.mdi-movie-open-cog-outline::before {
  content: "󱛾";
}

.mdi-movie-open-edit::before {
  content: "󱛿";
}

.mdi-movie-open-edit-outline::before {
  content: "󱜀";
}

.mdi-movie-open-minus::before {
  content: "󱜁";
}

.mdi-movie-open-minus-outline::before {
  content: "󱜂";
}

.mdi-movie-open-off::before {
  content: "󱜃";
}

.mdi-movie-open-off-outline::before {
  content: "󱜄";
}

.mdi-movie-open-outline::before {
  content: "󰿏";
}

.mdi-movie-open-play::before {
  content: "󱜅";
}

.mdi-movie-open-play-outline::before {
  content: "󱜆";
}

.mdi-movie-open-plus::before {
  content: "󱜇";
}

.mdi-movie-open-plus-outline::before {
  content: "󱜈";
}

.mdi-movie-open-remove::before {
  content: "󱜉";
}

.mdi-movie-open-remove-outline::before {
  content: "󱜊";
}

.mdi-movie-open-settings::before {
  content: "󱜋";
}

.mdi-movie-open-settings-outline::before {
  content: "󱜌";
}

.mdi-movie-open-star::before {
  content: "󱜍";
}

.mdi-movie-open-star-outline::before {
  content: "󱜎";
}

.mdi-movie-outline::before {
  content: "󰷝";
}

.mdi-movie-play::before {
  content: "󱜏";
}

.mdi-movie-play-outline::before {
  content: "󱜐";
}

.mdi-movie-plus::before {
  content: "󱜑";
}

.mdi-movie-plus-outline::before {
  content: "󱜒";
}

.mdi-movie-remove::before {
  content: "󱜓";
}

.mdi-movie-remove-outline::before {
  content: "󱜔";
}

.mdi-movie-roll::before {
  content: "󰟞";
}

.mdi-movie-search::before {
  content: "󱇒";
}

.mdi-movie-search-outline::before {
  content: "󱇓";
}

.mdi-movie-settings::before {
  content: "󱜕";
}

.mdi-movie-settings-outline::before {
  content: "󱜖";
}

.mdi-movie-star::before {
  content: "󱜗";
}

.mdi-movie-star-outline::before {
  content: "󱜘";
}

.mdi-mower::before {
  content: "󱙯";
}

.mdi-mower-bag::before {
  content: "󱙰";
}

.mdi-muffin::before {
  content: "󰦌";
}

.mdi-multicast::before {
  content: "󱢓";
}

.mdi-multiplication::before {
  content: "󰎂";
}

.mdi-multiplication-box::before {
  content: "󰎃";
}

.mdi-mushroom::before {
  content: "󰟟";
}

.mdi-mushroom-off::before {
  content: "󱏺";
}

.mdi-mushroom-off-outline::before {
  content: "󱏻";
}

.mdi-mushroom-outline::before {
  content: "󰟠";
}

.mdi-music::before {
  content: "󰝚";
}

.mdi-music-accidental-double-flat::before {
  content: "󰽩";
}

.mdi-music-accidental-double-sharp::before {
  content: "󰽪";
}

.mdi-music-accidental-flat::before {
  content: "󰽫";
}

.mdi-music-accidental-natural::before {
  content: "󰽬";
}

.mdi-music-accidental-sharp::before {
  content: "󰽭";
}

.mdi-music-box::before {
  content: "󰎄";
}

.mdi-music-box-multiple::before {
  content: "󰌳";
}

.mdi-music-box-multiple-outline::before {
  content: "󰼄";
}

.mdi-music-box-outline::before {
  content: "󰎅";
}

.mdi-music-circle::before {
  content: "󰎆";
}

.mdi-music-circle-outline::before {
  content: "󰫔";
}

.mdi-music-clef-alto::before {
  content: "󰽮";
}

.mdi-music-clef-bass::before {
  content: "󰽯";
}

.mdi-music-clef-treble::before {
  content: "󰽰";
}

.mdi-music-note::before {
  content: "󰎇";
}

.mdi-music-note-bluetooth::before {
  content: "󰗾";
}

.mdi-music-note-bluetooth-off::before {
  content: "󰗿";
}

.mdi-music-note-eighth::before {
  content: "󰎈";
}

.mdi-music-note-eighth-dotted::before {
  content: "󰽱";
}

.mdi-music-note-half::before {
  content: "󰎉";
}

.mdi-music-note-half-dotted::before {
  content: "󰽲";
}

.mdi-music-note-off::before {
  content: "󰎊";
}

.mdi-music-note-off-outline::before {
  content: "󰽳";
}

.mdi-music-note-outline::before {
  content: "󰽴";
}

.mdi-music-note-plus::before {
  content: "󰷞";
}

.mdi-music-note-quarter::before {
  content: "󰎋";
}

.mdi-music-note-quarter-dotted::before {
  content: "󰽵";
}

.mdi-music-note-sixteenth::before {
  content: "󰎌";
}

.mdi-music-note-sixteenth-dotted::before {
  content: "󰽶";
}

.mdi-music-note-whole::before {
  content: "󰎍";
}

.mdi-music-note-whole-dotted::before {
  content: "󰽷";
}

.mdi-music-off::before {
  content: "󰝛";
}

.mdi-music-rest-eighth::before {
  content: "󰽸";
}

.mdi-music-rest-half::before {
  content: "󰽹";
}

.mdi-music-rest-quarter::before {
  content: "󰽺";
}

.mdi-music-rest-sixteenth::before {
  content: "󰽻";
}

.mdi-music-rest-whole::before {
  content: "󰽼";
}

.mdi-mustache::before {
  content: "󱗞";
}

.mdi-nail::before {
  content: "󰷟";
}

.mdi-nas::before {
  content: "󰣳";
}

.mdi-nativescript::before {
  content: "󰢀";
}

.mdi-nature::before {
  content: "󰎎";
}

.mdi-nature-people::before {
  content: "󰎏";
}

.mdi-navigation::before {
  content: "󰎐";
}

.mdi-navigation-outline::before {
  content: "󱘇";
}

.mdi-navigation-variant::before {
  content: "󱣰";
}

.mdi-navigation-variant-outline::before {
  content: "󱣱";
}

.mdi-near-me::before {
  content: "󰗍";
}

.mdi-necklace::before {
  content: "󰼋";
}

.mdi-needle::before {
  content: "󰎑";
}

.mdi-netflix::before {
  content: "󰝆";
}

.mdi-network::before {
  content: "󰛳";
}

.mdi-network-off::before {
  content: "󰲛";
}

.mdi-network-off-outline::before {
  content: "󰲜";
}

.mdi-network-outline::before {
  content: "󰲝";
}

.mdi-network-strength-1::before {
  content: "󰣴";
}

.mdi-network-strength-1-alert::before {
  content: "󰣵";
}

.mdi-network-strength-2::before {
  content: "󰣶";
}

.mdi-network-strength-2-alert::before {
  content: "󰣷";
}

.mdi-network-strength-3::before {
  content: "󰣸";
}

.mdi-network-strength-3-alert::before {
  content: "󰣹";
}

.mdi-network-strength-4::before {
  content: "󰣺";
}

.mdi-network-strength-4-alert::before {
  content: "󰣻";
}

.mdi-network-strength-4-cog::before {
  content: "󱤚";
}

.mdi-network-strength-off::before {
  content: "󰣼";
}

.mdi-network-strength-off-outline::before {
  content: "󰣽";
}

.mdi-network-strength-outline::before {
  content: "󰣾";
}

.mdi-new-box::before {
  content: "󰎔";
}

.mdi-newspaper::before {
  content: "󰎕";
}

.mdi-newspaper-check::before {
  content: "󱥃";
}

.mdi-newspaper-minus::before {
  content: "󰼌";
}

.mdi-newspaper-plus::before {
  content: "󰼍";
}

.mdi-newspaper-remove::before {
  content: "󱥄";
}

.mdi-newspaper-variant::before {
  content: "󱀁";
}

.mdi-newspaper-variant-multiple::before {
  content: "󱀂";
}

.mdi-newspaper-variant-multiple-outline::before {
  content: "󱀃";
}

.mdi-newspaper-variant-outline::before {
  content: "󱀄";
}

.mdi-nfc::before {
  content: "󰎖";
}

.mdi-nfc-search-variant::before {
  content: "󰹓";
}

.mdi-nfc-tap::before {
  content: "󰎗";
}

.mdi-nfc-variant::before {
  content: "󰎘";
}

.mdi-nfc-variant-off::before {
  content: "󰹔";
}

.mdi-ninja::before {
  content: "󰝴";
}

.mdi-nintendo-game-boy::before {
  content: "󱎓";
}

.mdi-nintendo-switch::before {
  content: "󰟡";
}

.mdi-nintendo-wii::before {
  content: "󰖫";
}

.mdi-nintendo-wiiu::before {
  content: "󰜭";
}

.mdi-nix::before {
  content: "󱄅";
}

.mdi-nodejs::before {
  content: "󰎙";
}

.mdi-noodles::before {
  content: "󱅾";
}

.mdi-not-equal::before {
  content: "󰦍";
}

.mdi-not-equal-variant::before {
  content: "󰦎";
}

.mdi-note::before {
  content: "󰎚";
}

.mdi-note-alert::before {
  content: "󱝽";
}

.mdi-note-alert-outline::before {
  content: "󱝾";
}

.mdi-note-check::before {
  content: "󱝿";
}

.mdi-note-check-outline::before {
  content: "󱞀";
}

.mdi-note-edit::before {
  content: "󱞁";
}

.mdi-note-edit-outline::before {
  content: "󱞂";
}

.mdi-note-minus::before {
  content: "󱙏";
}

.mdi-note-minus-outline::before {
  content: "󱙐";
}

.mdi-note-multiple::before {
  content: "󰚸";
}

.mdi-note-multiple-outline::before {
  content: "󰚹";
}

.mdi-note-off::before {
  content: "󱞃";
}

.mdi-note-off-outline::before {
  content: "󱞄";
}

.mdi-note-outline::before {
  content: "󰎛";
}

.mdi-note-plus::before {
  content: "󰎜";
}

.mdi-note-plus-outline::before {
  content: "󰎝";
}

.mdi-note-remove::before {
  content: "󱙑";
}

.mdi-note-remove-outline::before {
  content: "󱙒";
}

.mdi-note-search::before {
  content: "󱙓";
}

.mdi-note-search-outline::before {
  content: "󱙔";
}

.mdi-note-text::before {
  content: "󰎞";
}

.mdi-note-text-outline::before {
  content: "󱇗";
}

.mdi-notebook::before {
  content: "󰠮";
}

.mdi-notebook-check::before {
  content: "󱓵";
}

.mdi-notebook-check-outline::before {
  content: "󱓶";
}

.mdi-notebook-edit::before {
  content: "󱓧";
}

.mdi-notebook-edit-outline::before {
  content: "󱓩";
}

.mdi-notebook-minus::before {
  content: "󱘐";
}

.mdi-notebook-minus-outline::before {
  content: "󱘑";
}

.mdi-notebook-multiple::before {
  content: "󰹕";
}

.mdi-notebook-outline::before {
  content: "󰺿";
}

.mdi-notebook-plus::before {
  content: "󱘒";
}

.mdi-notebook-plus-outline::before {
  content: "󱘓";
}

.mdi-notebook-remove::before {
  content: "󱘔";
}

.mdi-notebook-remove-outline::before {
  content: "󱘕";
}

.mdi-notification-clear-all::before {
  content: "󰎟";
}

.mdi-npm::before {
  content: "󰛷";
}

.mdi-nuke::before {
  content: "󰚤";
}

.mdi-null::before {
  content: "󰟢";
}

.mdi-numeric::before {
  content: "󰎠";
}

.mdi-numeric-0::before {
  content: "󰬹";
}

.mdi-numeric-0-box::before {
  content: "󰎡";
}

.mdi-numeric-0-box-multiple::before {
  content: "󰼎";
}

.mdi-numeric-0-box-multiple-outline::before {
  content: "󰎢";
}

.mdi-numeric-0-box-outline::before {
  content: "󰎣";
}

.mdi-numeric-0-circle::before {
  content: "󰲞";
}

.mdi-numeric-0-circle-outline::before {
  content: "󰲟";
}

.mdi-numeric-1::before {
  content: "󰬺";
}

.mdi-numeric-1-box::before {
  content: "󰎤";
}

.mdi-numeric-1-box-multiple::before {
  content: "󰼏";
}

.mdi-numeric-1-box-multiple-outline::before {
  content: "󰎥";
}

.mdi-numeric-1-box-outline::before {
  content: "󰎦";
}

.mdi-numeric-1-circle::before {
  content: "󰲠";
}

.mdi-numeric-1-circle-outline::before {
  content: "󰲡";
}

.mdi-numeric-10::before {
  content: "󰿩";
}

.mdi-numeric-10-box::before {
  content: "󰽽";
}

.mdi-numeric-10-box-multiple::before {
  content: "󰿪";
}

.mdi-numeric-10-box-multiple-outline::before {
  content: "󰿫";
}

.mdi-numeric-10-box-outline::before {
  content: "󰽾";
}

.mdi-numeric-10-circle::before {
  content: "󰿬";
}

.mdi-numeric-10-circle-outline::before {
  content: "󰿭";
}

.mdi-numeric-2::before {
  content: "󰬻";
}

.mdi-numeric-2-box::before {
  content: "󰎧";
}

.mdi-numeric-2-box-multiple::before {
  content: "󰼐";
}

.mdi-numeric-2-box-multiple-outline::before {
  content: "󰎨";
}

.mdi-numeric-2-box-outline::before {
  content: "󰎩";
}

.mdi-numeric-2-circle::before {
  content: "󰲢";
}

.mdi-numeric-2-circle-outline::before {
  content: "󰲣";
}

.mdi-numeric-3::before {
  content: "󰬼";
}

.mdi-numeric-3-box::before {
  content: "󰎪";
}

.mdi-numeric-3-box-multiple::before {
  content: "󰼑";
}

.mdi-numeric-3-box-multiple-outline::before {
  content: "󰎫";
}

.mdi-numeric-3-box-outline::before {
  content: "󰎬";
}

.mdi-numeric-3-circle::before {
  content: "󰲤";
}

.mdi-numeric-3-circle-outline::before {
  content: "󰲥";
}

.mdi-numeric-4::before {
  content: "󰬽";
}

.mdi-numeric-4-box::before {
  content: "󰎭";
}

.mdi-numeric-4-box-multiple::before {
  content: "󰼒";
}

.mdi-numeric-4-box-multiple-outline::before {
  content: "󰎲";
}

.mdi-numeric-4-box-outline::before {
  content: "󰎮";
}

.mdi-numeric-4-circle::before {
  content: "󰲦";
}

.mdi-numeric-4-circle-outline::before {
  content: "󰲧";
}

.mdi-numeric-5::before {
  content: "󰬾";
}

.mdi-numeric-5-box::before {
  content: "󰎱";
}

.mdi-numeric-5-box-multiple::before {
  content: "󰼓";
}

.mdi-numeric-5-box-multiple-outline::before {
  content: "󰎯";
}

.mdi-numeric-5-box-outline::before {
  content: "󰎰";
}

.mdi-numeric-5-circle::before {
  content: "󰲨";
}

.mdi-numeric-5-circle-outline::before {
  content: "󰲩";
}

.mdi-numeric-6::before {
  content: "󰬿";
}

.mdi-numeric-6-box::before {
  content: "󰎳";
}

.mdi-numeric-6-box-multiple::before {
  content: "󰼔";
}

.mdi-numeric-6-box-multiple-outline::before {
  content: "󰎴";
}

.mdi-numeric-6-box-outline::before {
  content: "󰎵";
}

.mdi-numeric-6-circle::before {
  content: "󰲪";
}

.mdi-numeric-6-circle-outline::before {
  content: "󰲫";
}

.mdi-numeric-7::before {
  content: "󰭀";
}

.mdi-numeric-7-box::before {
  content: "󰎶";
}

.mdi-numeric-7-box-multiple::before {
  content: "󰼕";
}

.mdi-numeric-7-box-multiple-outline::before {
  content: "󰎷";
}

.mdi-numeric-7-box-outline::before {
  content: "󰎸";
}

.mdi-numeric-7-circle::before {
  content: "󰲬";
}

.mdi-numeric-7-circle-outline::before {
  content: "󰲭";
}

.mdi-numeric-8::before {
  content: "󰭁";
}

.mdi-numeric-8-box::before {
  content: "󰎹";
}

.mdi-numeric-8-box-multiple::before {
  content: "󰼖";
}

.mdi-numeric-8-box-multiple-outline::before {
  content: "󰎺";
}

.mdi-numeric-8-box-outline::before {
  content: "󰎻";
}

.mdi-numeric-8-circle::before {
  content: "󰲮";
}

.mdi-numeric-8-circle-outline::before {
  content: "󰲯";
}

.mdi-numeric-9::before {
  content: "󰭂";
}

.mdi-numeric-9-box::before {
  content: "󰎼";
}

.mdi-numeric-9-box-multiple::before {
  content: "󰼗";
}

.mdi-numeric-9-box-multiple-outline::before {
  content: "󰎽";
}

.mdi-numeric-9-box-outline::before {
  content: "󰎾";
}

.mdi-numeric-9-circle::before {
  content: "󰲰";
}

.mdi-numeric-9-circle-outline::before {
  content: "󰲱";
}

.mdi-numeric-9-plus::before {
  content: "󰿮";
}

.mdi-numeric-9-plus-box::before {
  content: "󰎿";
}

.mdi-numeric-9-plus-box-multiple::before {
  content: "󰼘";
}

.mdi-numeric-9-plus-box-multiple-outline::before {
  content: "󰏀";
}

.mdi-numeric-9-plus-box-outline::before {
  content: "󰏁";
}

.mdi-numeric-9-plus-circle::before {
  content: "󰲲";
}

.mdi-numeric-9-plus-circle-outline::before {
  content: "󰲳";
}

.mdi-numeric-negative-1::before {
  content: "󱁒";
}

.mdi-numeric-positive-1::before {
  content: "󱗋";
}

.mdi-nut::before {
  content: "󰛸";
}

.mdi-nutrition::before {
  content: "󰏂";
}

.mdi-nuxt::before {
  content: "󱄆";
}

.mdi-oar::before {
  content: "󰙼";
}

.mdi-ocarina::before {
  content: "󰷠";
}

.mdi-oci::before {
  content: "󱋩";
}

.mdi-ocr::before {
  content: "󱄺";
}

.mdi-octagon::before {
  content: "󰏃";
}

.mdi-octagon-outline::before {
  content: "󰏄";
}

.mdi-octagram::before {
  content: "󰛹";
}

.mdi-octagram-outline::before {
  content: "󰝵";
}

.mdi-octahedron::before {
  content: "󱥐";
}

.mdi-octahedron-off::before {
  content: "󱥑";
}

.mdi-odnoklassniki::before {
  content: "󰏅";
}

.mdi-offer::before {
  content: "󱈛";
}

.mdi-office-building::before {
  content: "󰦑";
}

.mdi-office-building-cog::before {
  content: "󱥉";
}

.mdi-office-building-cog-outline::before {
  content: "󱥊";
}

.mdi-office-building-marker::before {
  content: "󱔠";
}

.mdi-office-building-marker-outline::before {
  content: "󱔡";
}

.mdi-office-building-outline::before {
  content: "󱔟";
}

.mdi-oil::before {
  content: "󰏇";
}

.mdi-oil-lamp::before {
  content: "󰼙";
}

.mdi-oil-level::before {
  content: "󱁓";
}

.mdi-oil-temperature::before {
  content: "󰿸";
}

.mdi-om::before {
  content: "󰥳";
}

.mdi-omega::before {
  content: "󰏉";
}

.mdi-one-up::before {
  content: "󰮭";
}

.mdi-onepassword::before {
  content: "󰢁";
}

.mdi-opacity::before {
  content: "󰗌";
}

.mdi-open-in-app::before {
  content: "󰏋";
}

.mdi-open-in-new::before {
  content: "󰏌";
}

.mdi-open-source-initiative::before {
  content: "󰮮";
}

.mdi-openid::before {
  content: "󰏍";
}

.mdi-opera::before {
  content: "󰏎";
}

.mdi-orbit::before {
  content: "󰀘";
}

.mdi-orbit-variant::before {
  content: "󱗛";
}

.mdi-order-alphabetical-ascending::before {
  content: "󰈍";
}

.mdi-order-alphabetical-descending::before {
  content: "󰴇";
}

.mdi-order-bool-ascending::before {
  content: "󰊾";
}

.mdi-order-bool-ascending-variant::before {
  content: "󰦏";
}

.mdi-order-bool-descending::before {
  content: "󱎄";
}

.mdi-order-bool-descending-variant::before {
  content: "󰦐";
}

.mdi-order-numeric-ascending::before {
  content: "󰕅";
}

.mdi-order-numeric-descending::before {
  content: "󰕆";
}

.mdi-origin::before {
  content: "󰭃";
}

.mdi-ornament::before {
  content: "󰏏";
}

.mdi-ornament-variant::before {
  content: "󰏐";
}

.mdi-outdoor-lamp::before {
  content: "󱁔";
}

.mdi-overscan::before {
  content: "󱀅";
}

.mdi-owl::before {
  content: "󰏒";
}

.mdi-pac-man::before {
  content: "󰮯";
}

.mdi-package::before {
  content: "󰏓";
}

.mdi-package-down::before {
  content: "󰏔";
}

.mdi-package-up::before {
  content: "󰏕";
}

.mdi-package-variant::before {
  content: "󰏖";
}

.mdi-package-variant-closed::before {
  content: "󰏗";
}

.mdi-page-first::before {
  content: "󰘀";
}

.mdi-page-last::before {
  content: "󰘁";
}

.mdi-page-layout-body::before {
  content: "󰛺";
}

.mdi-page-layout-footer::before {
  content: "󰛻";
}

.mdi-page-layout-header::before {
  content: "󰛼";
}

.mdi-page-layout-header-footer::before {
  content: "󰽿";
}

.mdi-page-layout-sidebar-left::before {
  content: "󰛽";
}

.mdi-page-layout-sidebar-right::before {
  content: "󰛾";
}

.mdi-page-next::before {
  content: "󰮰";
}

.mdi-page-next-outline::before {
  content: "󰮱";
}

.mdi-page-previous::before {
  content: "󰮲";
}

.mdi-page-previous-outline::before {
  content: "󰮳";
}

.mdi-pail::before {
  content: "󱐗";
}

.mdi-pail-minus::before {
  content: "󱐷";
}

.mdi-pail-minus-outline::before {
  content: "󱐼";
}

.mdi-pail-off::before {
  content: "󱐹";
}

.mdi-pail-off-outline::before {
  content: "󱐾";
}

.mdi-pail-outline::before {
  content: "󱐺";
}

.mdi-pail-plus::before {
  content: "󱐶";
}

.mdi-pail-plus-outline::before {
  content: "󱐻";
}

.mdi-pail-remove::before {
  content: "󱐸";
}

.mdi-pail-remove-outline::before {
  content: "󱐽";
}

.mdi-palette::before {
  content: "󰏘";
}

.mdi-palette-advanced::before {
  content: "󰏙";
}

.mdi-palette-outline::before {
  content: "󰸌";
}

.mdi-palette-swatch::before {
  content: "󰢵";
}

.mdi-palette-swatch-outline::before {
  content: "󱍜";
}

.mdi-palette-swatch-variant::before {
  content: "󱥚";
}

.mdi-palm-tree::before {
  content: "󱁕";
}

.mdi-pan::before {
  content: "󰮴";
}

.mdi-pan-bottom-left::before {
  content: "󰮵";
}

.mdi-pan-bottom-right::before {
  content: "󰮶";
}

.mdi-pan-down::before {
  content: "󰮷";
}

.mdi-pan-horizontal::before {
  content: "󰮸";
}

.mdi-pan-left::before {
  content: "󰮹";
}

.mdi-pan-right::before {
  content: "󰮺";
}

.mdi-pan-top-left::before {
  content: "󰮻";
}

.mdi-pan-top-right::before {
  content: "󰮼";
}

.mdi-pan-up::before {
  content: "󰮽";
}

.mdi-pan-vertical::before {
  content: "󰮾";
}

.mdi-panda::before {
  content: "󰏚";
}

.mdi-pandora::before {
  content: "󰏛";
}

.mdi-panorama::before {
  content: "󰏜";
}

.mdi-panorama-fisheye::before {
  content: "󰏝";
}

.mdi-panorama-horizontal::before {
  content: "󱤨";
}

.mdi-panorama-horizontal-outline::before {
  content: "󰏞";
}

.mdi-panorama-outline::before {
  content: "󱦌";
}

.mdi-panorama-sphere::before {
  content: "󱦍";
}

.mdi-panorama-sphere-outline::before {
  content: "󱦎";
}

.mdi-panorama-variant::before {
  content: "󱦏";
}

.mdi-panorama-variant-outline::before {
  content: "󱦐";
}

.mdi-panorama-vertical::before {
  content: "󱤩";
}

.mdi-panorama-vertical-outline::before {
  content: "󰏟";
}

.mdi-panorama-wide-angle::before {
  content: "󱥟";
}

.mdi-panorama-wide-angle-outline::before {
  content: "󰏠";
}

.mdi-paper-cut-vertical::before {
  content: "󰏡";
}

.mdi-paper-roll::before {
  content: "󱅗";
}

.mdi-paper-roll-outline::before {
  content: "󱅘";
}

.mdi-paperclip::before {
  content: "󰏢";
}

.mdi-parachute::before {
  content: "󰲴";
}

.mdi-parachute-outline::before {
  content: "󰲵";
}

.mdi-paragliding::before {
  content: "󱝅";
}

.mdi-parking::before {
  content: "󰏣";
}

.mdi-party-popper::before {
  content: "󱁖";
}

.mdi-passport::before {
  content: "󰟣";
}

.mdi-passport-biometric::before {
  content: "󰷡";
}

.mdi-pasta::before {
  content: "󱅠";
}

.mdi-patio-heater::before {
  content: "󰾀";
}

.mdi-patreon::before {
  content: "󰢂";
}

.mdi-pause::before {
  content: "󰏤";
}

.mdi-pause-circle::before {
  content: "󰏥";
}

.mdi-pause-circle-outline::before {
  content: "󰏦";
}

.mdi-pause-octagon::before {
  content: "󰏧";
}

.mdi-pause-octagon-outline::before {
  content: "󰏨";
}

.mdi-paw::before {
  content: "󰏩";
}

.mdi-paw-off::before {
  content: "󰙗";
}

.mdi-paw-off-outline::before {
  content: "󱙶";
}

.mdi-paw-outline::before {
  content: "󱙵";
}

.mdi-peace::before {
  content: "󰢄";
}

.mdi-peanut::before {
  content: "󰿼";
}

.mdi-peanut-off::before {
  content: "󰿽";
}

.mdi-peanut-off-outline::before {
  content: "󰿿";
}

.mdi-peanut-outline::before {
  content: "󰿾";
}

.mdi-pen::before {
  content: "󰏪";
}

.mdi-pen-lock::before {
  content: "󰷢";
}

.mdi-pen-minus::before {
  content: "󰷣";
}

.mdi-pen-off::before {
  content: "󰷤";
}

.mdi-pen-plus::before {
  content: "󰷥";
}

.mdi-pen-remove::before {
  content: "󰷦";
}

.mdi-pencil::before {
  content: "󰏫";
}

.mdi-pencil-box::before {
  content: "󰏬";
}

.mdi-pencil-box-multiple::before {
  content: "󱅄";
}

.mdi-pencil-box-multiple-outline::before {
  content: "󱅅";
}

.mdi-pencil-box-outline::before {
  content: "󰏭";
}

.mdi-pencil-circle::before {
  content: "󰛿";
}

.mdi-pencil-circle-outline::before {
  content: "󰝶";
}

.mdi-pencil-lock::before {
  content: "󰏮";
}

.mdi-pencil-lock-outline::before {
  content: "󰷧";
}

.mdi-pencil-minus::before {
  content: "󰷨";
}

.mdi-pencil-minus-outline::before {
  content: "󰷩";
}

.mdi-pencil-off::before {
  content: "󰏯";
}

.mdi-pencil-off-outline::before {
  content: "󰷪";
}

.mdi-pencil-outline::before {
  content: "󰲶";
}

.mdi-pencil-plus::before {
  content: "󰷫";
}

.mdi-pencil-plus-outline::before {
  content: "󰷬";
}

.mdi-pencil-remove::before {
  content: "󰷭";
}

.mdi-pencil-remove-outline::before {
  content: "󰷮";
}

.mdi-pencil-ruler::before {
  content: "󱍓";
}

.mdi-penguin::before {
  content: "󰻀";
}

.mdi-pentagon::before {
  content: "󰜁";
}

.mdi-pentagon-outline::before {
  content: "󰜀";
}

.mdi-pentagram::before {
  content: "󱙧";
}

.mdi-percent::before {
  content: "󰏰";
}

.mdi-percent-outline::before {
  content: "󱉸";
}

.mdi-periodic-table::before {
  content: "󰢶";
}

.mdi-perspective-less::before {
  content: "󰴣";
}

.mdi-perspective-more::before {
  content: "󰴤";
}

.mdi-ph::before {
  content: "󱟅";
}

.mdi-phone::before {
  content: "󰏲";
}

.mdi-phone-alert::before {
  content: "󰼚";
}

.mdi-phone-alert-outline::before {
  content: "󱆎";
}

.mdi-phone-bluetooth::before {
  content: "󰏳";
}

.mdi-phone-bluetooth-outline::before {
  content: "󱆏";
}

.mdi-phone-cancel::before {
  content: "󱂼";
}

.mdi-phone-cancel-outline::before {
  content: "󱆐";
}

.mdi-phone-check::before {
  content: "󱆩";
}

.mdi-phone-check-outline::before {
  content: "󱆪";
}

.mdi-phone-classic::before {
  content: "󰘂";
}

.mdi-phone-classic-off::before {
  content: "󱉹";
}

.mdi-phone-dial::before {
  content: "󱕙";
}

.mdi-phone-dial-outline::before {
  content: "󱕚";
}

.mdi-phone-forward::before {
  content: "󰏴";
}

.mdi-phone-forward-outline::before {
  content: "󱆑";
}

.mdi-phone-hangup::before {
  content: "󰏵";
}

.mdi-phone-hangup-outline::before {
  content: "󱆒";
}

.mdi-phone-in-talk::before {
  content: "󰏶";
}

.mdi-phone-in-talk-outline::before {
  content: "󱆂";
}

.mdi-phone-incoming::before {
  content: "󰏷";
}

.mdi-phone-incoming-outline::before {
  content: "󱆓";
}

.mdi-phone-lock::before {
  content: "󰏸";
}

.mdi-phone-lock-outline::before {
  content: "󱆔";
}

.mdi-phone-log::before {
  content: "󰏹";
}

.mdi-phone-log-outline::before {
  content: "󱆕";
}

.mdi-phone-message::before {
  content: "󱆖";
}

.mdi-phone-message-outline::before {
  content: "󱆗";
}

.mdi-phone-minus::before {
  content: "󰙘";
}

.mdi-phone-minus-outline::before {
  content: "󱆘";
}

.mdi-phone-missed::before {
  content: "󰏺";
}

.mdi-phone-missed-outline::before {
  content: "󱆥";
}

.mdi-phone-off::before {
  content: "󰷯";
}

.mdi-phone-off-outline::before {
  content: "󱆦";
}

.mdi-phone-outgoing::before {
  content: "󰏻";
}

.mdi-phone-outgoing-outline::before {
  content: "󱆙";
}

.mdi-phone-outline::before {
  content: "󰷰";
}

.mdi-phone-paused::before {
  content: "󰏼";
}

.mdi-phone-paused-outline::before {
  content: "󱆚";
}

.mdi-phone-plus::before {
  content: "󰙙";
}

.mdi-phone-plus-outline::before {
  content: "󱆛";
}

.mdi-phone-refresh::before {
  content: "󱦓";
}

.mdi-phone-refresh-outline::before {
  content: "󱦔";
}

.mdi-phone-remove::before {
  content: "󱔯";
}

.mdi-phone-remove-outline::before {
  content: "󱔰";
}

.mdi-phone-return::before {
  content: "󰠯";
}

.mdi-phone-return-outline::before {
  content: "󱆜";
}

.mdi-phone-ring::before {
  content: "󱆫";
}

.mdi-phone-ring-outline::before {
  content: "󱆬";
}

.mdi-phone-rotate-landscape::before {
  content: "󰢅";
}

.mdi-phone-rotate-portrait::before {
  content: "󰢆";
}

.mdi-phone-settings::before {
  content: "󰏽";
}

.mdi-phone-settings-outline::before {
  content: "󱆝";
}

.mdi-phone-sync::before {
  content: "󱦕";
}

.mdi-phone-sync-outline::before {
  content: "󱦖";
}

.mdi-phone-voip::before {
  content: "󰏾";
}

.mdi-pi::before {
  content: "󰏿";
}

.mdi-pi-box::before {
  content: "󰐀";
}

.mdi-pi-hole::before {
  content: "󰷱";
}

.mdi-piano::before {
  content: "󰙽";
}

.mdi-piano-off::before {
  content: "󰚘";
}

.mdi-pickaxe::before {
  content: "󰢷";
}

.mdi-picture-in-picture-bottom-right::before {
  content: "󰹗";
}

.mdi-picture-in-picture-bottom-right-outline::before {
  content: "󰹘";
}

.mdi-picture-in-picture-top-right::before {
  content: "󰹙";
}

.mdi-picture-in-picture-top-right-outline::before {
  content: "󰹚";
}

.mdi-pier::before {
  content: "󰢇";
}

.mdi-pier-crane::before {
  content: "󰢈";
}

.mdi-pig::before {
  content: "󰐁";
}

.mdi-pig-variant::before {
  content: "󱀆";
}

.mdi-pig-variant-outline::before {
  content: "󱙸";
}

.mdi-piggy-bank::before {
  content: "󱀇";
}

.mdi-piggy-bank-outline::before {
  content: "󱙹";
}

.mdi-pill::before {
  content: "󰐂";
}

.mdi-pillar::before {
  content: "󰜂";
}

.mdi-pin::before {
  content: "󰐃";
}

.mdi-pin-off::before {
  content: "󰐄";
}

.mdi-pin-off-outline::before {
  content: "󰤰";
}

.mdi-pin-outline::before {
  content: "󰤱";
}

.mdi-pine-tree::before {
  content: "󰐅";
}

.mdi-pine-tree-box::before {
  content: "󰐆";
}

.mdi-pine-tree-fire::before {
  content: "󱐚";
}

.mdi-pinterest::before {
  content: "󰐇";
}

.mdi-pinwheel::before {
  content: "󰫕";
}

.mdi-pinwheel-outline::before {
  content: "󰫖";
}

.mdi-pipe::before {
  content: "󰟥";
}

.mdi-pipe-disconnected::before {
  content: "󰟦";
}

.mdi-pipe-leak::before {
  content: "󰢉";
}

.mdi-pipe-valve::before {
  content: "󱡍";
}

.mdi-pipe-wrench::before {
  content: "󱍔";
}

.mdi-pirate::before {
  content: "󰨈";
}

.mdi-pistol::before {
  content: "󰜃";
}

.mdi-piston::before {
  content: "󰢊";
}

.mdi-pitchfork::before {
  content: "󱕓";
}

.mdi-pizza::before {
  content: "󰐉";
}

.mdi-play::before {
  content: "󰐊";
}

.mdi-play-box::before {
  content: "󱉺";
}

.mdi-play-box-multiple::before {
  content: "󰴙";
}

.mdi-play-box-multiple-outline::before {
  content: "󱏦";
}

.mdi-play-box-outline::before {
  content: "󰐋";
}

.mdi-play-circle::before {
  content: "󰐌";
}

.mdi-play-circle-outline::before {
  content: "󰐍";
}

.mdi-play-network::before {
  content: "󰢋";
}

.mdi-play-network-outline::before {
  content: "󰲷";
}

.mdi-play-outline::before {
  content: "󰼛";
}

.mdi-play-pause::before {
  content: "󰐎";
}

.mdi-play-protected-content::before {
  content: "󰐏";
}

.mdi-play-speed::before {
  content: "󰣿";
}

.mdi-playlist-check::before {
  content: "󰗇";
}

.mdi-playlist-edit::before {
  content: "󰤀";
}

.mdi-playlist-minus::before {
  content: "󰐐";
}

.mdi-playlist-music::before {
  content: "󰲸";
}

.mdi-playlist-music-outline::before {
  content: "󰲹";
}

.mdi-playlist-play::before {
  content: "󰐑";
}

.mdi-playlist-plus::before {
  content: "󰐒";
}

.mdi-playlist-remove::before {
  content: "󰐓";
}

.mdi-playlist-star::before {
  content: "󰷲";
}

.mdi-plex::before {
  content: "󰚺";
}

.mdi-pliers::before {
  content: "󱦤";
}

.mdi-plus::before {
  content: "󰐕";
}

.mdi-plus-box::before {
  content: "󰐖";
}

.mdi-plus-box-multiple::before {
  content: "󰌴";
}

.mdi-plus-box-multiple-outline::before {
  content: "󱅃";
}

.mdi-plus-box-outline::before {
  content: "󰜄";
}

.mdi-plus-circle::before {
  content: "󰐗";
}

.mdi-plus-circle-multiple::before {
  content: "󰍌";
}

.mdi-plus-circle-multiple-outline::before {
  content: "󰐘";
}

.mdi-plus-circle-outline::before {
  content: "󰐙";
}

.mdi-plus-minus::before {
  content: "󰦒";
}

.mdi-plus-minus-box::before {
  content: "󰦓";
}

.mdi-plus-minus-variant::before {
  content: "󱓉";
}

.mdi-plus-network::before {
  content: "󰐚";
}

.mdi-plus-network-outline::before {
  content: "󰲺";
}

.mdi-plus-outline::before {
  content: "󰜅";
}

.mdi-plus-thick::before {
  content: "󱇬";
}

.mdi-podcast::before {
  content: "󰦔";
}

.mdi-podium::before {
  content: "󰴥";
}

.mdi-podium-bronze::before {
  content: "󰴦";
}

.mdi-podium-gold::before {
  content: "󰴧";
}

.mdi-podium-silver::before {
  content: "󰴨";
}

.mdi-point-of-sale::before {
  content: "󰶒";
}

.mdi-pokeball::before {
  content: "󰐝";
}

.mdi-pokemon-go::before {
  content: "󰨉";
}

.mdi-poker-chip::before {
  content: "󰠰";
}

.mdi-polaroid::before {
  content: "󰐞";
}

.mdi-police-badge::before {
  content: "󱅧";
}

.mdi-police-badge-outline::before {
  content: "󱅨";
}

.mdi-police-station::before {
  content: "󱠹";
}

.mdi-poll::before {
  content: "󰐟";
}

.mdi-polo::before {
  content: "󱓃";
}

.mdi-polymer::before {
  content: "󰐡";
}

.mdi-pool::before {
  content: "󰘆";
}

.mdi-popcorn::before {
  content: "󰐢";
}

.mdi-post::before {
  content: "󱀈";
}

.mdi-post-outline::before {
  content: "󱀉";
}

.mdi-postage-stamp::before {
  content: "󰲻";
}

.mdi-pot::before {
  content: "󰋥";
}

.mdi-pot-mix::before {
  content: "󰙛";
}

.mdi-pot-mix-outline::before {
  content: "󰙷";
}

.mdi-pot-outline::before {
  content: "󰋿";
}

.mdi-pot-steam::before {
  content: "󰙚";
}

.mdi-pot-steam-outline::before {
  content: "󰌦";
}

.mdi-pound::before {
  content: "󰐣";
}

.mdi-pound-box::before {
  content: "󰐤";
}

.mdi-pound-box-outline::before {
  content: "󱅿";
}

.mdi-power::before {
  content: "󰐥";
}

.mdi-power-cycle::before {
  content: "󰤁";
}

.mdi-power-off::before {
  content: "󰤂";
}

.mdi-power-on::before {
  content: "󰤃";
}

.mdi-power-plug::before {
  content: "󰚥";
}

.mdi-power-plug-off::before {
  content: "󰚦";
}

.mdi-power-plug-off-outline::before {
  content: "󱐤";
}

.mdi-power-plug-outline::before {
  content: "󱐥";
}

.mdi-power-settings::before {
  content: "󰐦";
}

.mdi-power-sleep::before {
  content: "󰤄";
}

.mdi-power-socket::before {
  content: "󰐧";
}

.mdi-power-socket-au::before {
  content: "󰤅";
}

.mdi-power-socket-ch::before {
  content: "󰾳";
}

.mdi-power-socket-de::before {
  content: "󱄇";
}

.mdi-power-socket-eu::before {
  content: "󰟧";
}

.mdi-power-socket-fr::before {
  content: "󱄈";
}

.mdi-power-socket-it::before {
  content: "󱓿";
}

.mdi-power-socket-jp::before {
  content: "󱄉";
}

.mdi-power-socket-uk::before {
  content: "󰟨";
}

.mdi-power-socket-us::before {
  content: "󰟩";
}

.mdi-power-standby::before {
  content: "󰤆";
}

.mdi-powershell::before {
  content: "󰨊";
}

.mdi-prescription::before {
  content: "󰜆";
}

.mdi-presentation::before {
  content: "󰐨";
}

.mdi-presentation-play::before {
  content: "󰐩";
}

.mdi-pretzel::before {
  content: "󱕢";
}

.mdi-printer::before {
  content: "󰐪";
}

.mdi-printer-3d::before {
  content: "󰐫";
}

.mdi-printer-3d-nozzle::before {
  content: "󰹛";
}

.mdi-printer-3d-nozzle-alert::before {
  content: "󱇀";
}

.mdi-printer-3d-nozzle-alert-outline::before {
  content: "󱇁";
}

.mdi-printer-3d-nozzle-heat::before {
  content: "󱢸";
}

.mdi-printer-3d-nozzle-heat-outline::before {
  content: "󱢹";
}

.mdi-printer-3d-nozzle-outline::before {
  content: "󰹜";
}

.mdi-printer-alert::before {
  content: "󰐬";
}

.mdi-printer-check::before {
  content: "󱅆";
}

.mdi-printer-eye::before {
  content: "󱑘";
}

.mdi-printer-off::before {
  content: "󰹝";
}

.mdi-printer-off-outline::before {
  content: "󱞅";
}

.mdi-printer-outline::before {
  content: "󱞆";
}

.mdi-printer-pos::before {
  content: "󱁗";
}

.mdi-printer-search::before {
  content: "󱑗";
}

.mdi-printer-settings::before {
  content: "󰜇";
}

.mdi-printer-wireless::before {
  content: "󰨋";
}

.mdi-priority-high::before {
  content: "󰘃";
}

.mdi-priority-low::before {
  content: "󰘄";
}

.mdi-professional-hexagon::before {
  content: "󰐭";
}

.mdi-progress-alert::before {
  content: "󰲼";
}

.mdi-progress-check::before {
  content: "󰦕";
}

.mdi-progress-clock::before {
  content: "󰦖";
}

.mdi-progress-close::before {
  content: "󱄊";
}

.mdi-progress-download::before {
  content: "󰦗";
}

.mdi-progress-pencil::before {
  content: "󱞇";
}

.mdi-progress-question::before {
  content: "󱔢";
}

.mdi-progress-star::before {
  content: "󱞈";
}

.mdi-progress-upload::before {
  content: "󰦘";
}

.mdi-progress-wrench::before {
  content: "󰲽";
}

.mdi-projector::before {
  content: "󰐮";
}

.mdi-projector-screen::before {
  content: "󰐯";
}

.mdi-projector-screen-off::before {
  content: "󱠍";
}

.mdi-projector-screen-off-outline::before {
  content: "󱠎";
}

.mdi-projector-screen-outline::before {
  content: "󱜤";
}

.mdi-projector-screen-variant::before {
  content: "󱠏";
}

.mdi-projector-screen-variant-off::before {
  content: "󱠐";
}

.mdi-projector-screen-variant-off-outline::before {
  content: "󱠑";
}

.mdi-projector-screen-variant-outline::before {
  content: "󱠒";
}

.mdi-propane-tank::before {
  content: "󱍗";
}

.mdi-propane-tank-outline::before {
  content: "󱍘";
}

.mdi-protocol::before {
  content: "󰿘";
}

.mdi-publish::before {
  content: "󰚧";
}

.mdi-publish-off::before {
  content: "󱥅";
}

.mdi-pulse::before {
  content: "󰐰";
}

.mdi-pump::before {
  content: "󱐂";
}

.mdi-pumpkin::before {
  content: "󰮿";
}

.mdi-purse::before {
  content: "󰼜";
}

.mdi-purse-outline::before {
  content: "󰼝";
}

.mdi-puzzle::before {
  content: "󰐱";
}

.mdi-puzzle-check::before {
  content: "󱐦";
}

.mdi-puzzle-check-outline::before {
  content: "󱐧";
}

.mdi-puzzle-edit::before {
  content: "󱓓";
}

.mdi-puzzle-edit-outline::before {
  content: "󱓙";
}

.mdi-puzzle-heart::before {
  content: "󱓔";
}

.mdi-puzzle-heart-outline::before {
  content: "󱓚";
}

.mdi-puzzle-minus::before {
  content: "󱓑";
}

.mdi-puzzle-minus-outline::before {
  content: "󱓗";
}

.mdi-puzzle-outline::before {
  content: "󰩦";
}

.mdi-puzzle-plus::before {
  content: "󱓐";
}

.mdi-puzzle-plus-outline::before {
  content: "󱓖";
}

.mdi-puzzle-remove::before {
  content: "󱓒";
}

.mdi-puzzle-remove-outline::before {
  content: "󱓘";
}

.mdi-puzzle-star::before {
  content: "󱓕";
}

.mdi-puzzle-star-outline::before {
  content: "󱓛";
}

.mdi-pyramid::before {
  content: "󱥒";
}

.mdi-pyramid-off::before {
  content: "󱥓";
}

.mdi-qi::before {
  content: "󰦙";
}

.mdi-qqchat::before {
  content: "󰘅";
}

.mdi-qrcode::before {
  content: "󰐲";
}

.mdi-qrcode-edit::before {
  content: "󰢸";
}

.mdi-qrcode-minus::before {
  content: "󱆌";
}

.mdi-qrcode-plus::before {
  content: "󱆋";
}

.mdi-qrcode-remove::before {
  content: "󱆍";
}

.mdi-qrcode-scan::before {
  content: "󰐳";
}

.mdi-quadcopter::before {
  content: "󰐴";
}

.mdi-quality-high::before {
  content: "󰐵";
}

.mdi-quality-low::before {
  content: "󰨌";
}

.mdi-quality-medium::before {
  content: "󰨍";
}

.mdi-quora::before {
  content: "󰴩";
}

.mdi-rabbit::before {
  content: "󰤇";
}

.mdi-racing-helmet::before {
  content: "󰶓";
}

.mdi-racquetball::before {
  content: "󰶔";
}

.mdi-radar::before {
  content: "󰐷";
}

.mdi-radiator::before {
  content: "󰐸";
}

.mdi-radiator-disabled::before {
  content: "󰫗";
}

.mdi-radiator-off::before {
  content: "󰫘";
}

.mdi-radio::before {
  content: "󰐹";
}

.mdi-radio-am::before {
  content: "󰲾";
}

.mdi-radio-fm::before {
  content: "󰲿";
}

.mdi-radio-handheld::before {
  content: "󰐺";
}

.mdi-radio-off::before {
  content: "󱈜";
}

.mdi-radio-tower::before {
  content: "󰐻";
}

.mdi-radioactive::before {
  content: "󰐼";
}

.mdi-radioactive-circle::before {
  content: "󱡝";
}

.mdi-radioactive-circle-outline::before {
  content: "󱡞";
}

.mdi-radioactive-off::before {
  content: "󰻁";
}

.mdi-radiobox-blank::before {
  content: "󰐽";
}

.mdi-radiobox-marked::before {
  content: "󰐾";
}

.mdi-radiology-box::before {
  content: "󱓅";
}

.mdi-radiology-box-outline::before {
  content: "󱓆";
}

.mdi-radius::before {
  content: "󰳀";
}

.mdi-radius-outline::before {
  content: "󰳁";
}

.mdi-railroad-light::before {
  content: "󰼞";
}

.mdi-rake::before {
  content: "󱕄";
}

.mdi-raspberry-pi::before {
  content: "󰐿";
}

.mdi-ray-end::before {
  content: "󰑀";
}

.mdi-ray-end-arrow::before {
  content: "󰑁";
}

.mdi-ray-start::before {
  content: "󰑂";
}

.mdi-ray-start-arrow::before {
  content: "󰑃";
}

.mdi-ray-start-end::before {
  content: "󰑄";
}

.mdi-ray-start-vertex-end::before {
  content: "󱗘";
}

.mdi-ray-vertex::before {
  content: "󰑅";
}

.mdi-razor-double-edge::before {
  content: "󱦗";
}

.mdi-razor-single-edge::before {
  content: "󱦘";
}

.mdi-react::before {
  content: "󰜈";
}

.mdi-read::before {
  content: "󰑇";
}

.mdi-receipt::before {
  content: "󰑉";
}

.mdi-record::before {
  content: "󰑊";
}

.mdi-record-circle::before {
  content: "󰻂";
}

.mdi-record-circle-outline::before {
  content: "󰻃";
}

.mdi-record-player::before {
  content: "󰦚";
}

.mdi-record-rec::before {
  content: "󰑋";
}

.mdi-rectangle::before {
  content: "󰹞";
}

.mdi-rectangle-outline::before {
  content: "󰹟";
}

.mdi-recycle::before {
  content: "󰑌";
}

.mdi-recycle-variant::before {
  content: "󱎝";
}

.mdi-reddit::before {
  content: "󰑍";
}

.mdi-redhat::before {
  content: "󱄛";
}

.mdi-redo::before {
  content: "󰑎";
}

.mdi-redo-variant::before {
  content: "󰑏";
}

.mdi-reflect-horizontal::before {
  content: "󰨎";
}

.mdi-reflect-vertical::before {
  content: "󰨏";
}

.mdi-refresh::before {
  content: "󰑐";
}

.mdi-refresh-auto::before {
  content: "󱣲";
}

.mdi-refresh-circle::before {
  content: "󱍷";
}

.mdi-regex::before {
  content: "󰑑";
}

.mdi-registered-trademark::before {
  content: "󰩧";
}

.mdi-reiterate::before {
  content: "󱖈";
}

.mdi-relation-many-to-many::before {
  content: "󱒖";
}

.mdi-relation-many-to-one::before {
  content: "󱒗";
}

.mdi-relation-many-to-one-or-many::before {
  content: "󱒘";
}

.mdi-relation-many-to-only-one::before {
  content: "󱒙";
}

.mdi-relation-many-to-zero-or-many::before {
  content: "󱒚";
}

.mdi-relation-many-to-zero-or-one::before {
  content: "󱒛";
}

.mdi-relation-one-or-many-to-many::before {
  content: "󱒜";
}

.mdi-relation-one-or-many-to-one::before {
  content: "󱒝";
}

.mdi-relation-one-or-many-to-one-or-many::before {
  content: "󱒞";
}

.mdi-relation-one-or-many-to-only-one::before {
  content: "󱒟";
}

.mdi-relation-one-or-many-to-zero-or-many::before {
  content: "󱒠";
}

.mdi-relation-one-or-many-to-zero-or-one::before {
  content: "󱒡";
}

.mdi-relation-one-to-many::before {
  content: "󱒢";
}

.mdi-relation-one-to-one::before {
  content: "󱒣";
}

.mdi-relation-one-to-one-or-many::before {
  content: "󱒤";
}

.mdi-relation-one-to-only-one::before {
  content: "󱒥";
}

.mdi-relation-one-to-zero-or-many::before {
  content: "󱒦";
}

.mdi-relation-one-to-zero-or-one::before {
  content: "󱒧";
}

.mdi-relation-only-one-to-many::before {
  content: "󱒨";
}

.mdi-relation-only-one-to-one::before {
  content: "󱒩";
}

.mdi-relation-only-one-to-one-or-many::before {
  content: "󱒪";
}

.mdi-relation-only-one-to-only-one::before {
  content: "󱒫";
}

.mdi-relation-only-one-to-zero-or-many::before {
  content: "󱒬";
}

.mdi-relation-only-one-to-zero-or-one::before {
  content: "󱒭";
}

.mdi-relation-zero-or-many-to-many::before {
  content: "󱒮";
}

.mdi-relation-zero-or-many-to-one::before {
  content: "󱒯";
}

.mdi-relation-zero-or-many-to-one-or-many::before {
  content: "󱒰";
}

.mdi-relation-zero-or-many-to-only-one::before {
  content: "󱒱";
}

.mdi-relation-zero-or-many-to-zero-or-many::before {
  content: "󱒲";
}

.mdi-relation-zero-or-many-to-zero-or-one::before {
  content: "󱒳";
}

.mdi-relation-zero-or-one-to-many::before {
  content: "󱒴";
}

.mdi-relation-zero-or-one-to-one::before {
  content: "󱒵";
}

.mdi-relation-zero-or-one-to-one-or-many::before {
  content: "󱒶";
}

.mdi-relation-zero-or-one-to-only-one::before {
  content: "󱒷";
}

.mdi-relation-zero-or-one-to-zero-or-many::before {
  content: "󱒸";
}

.mdi-relation-zero-or-one-to-zero-or-one::before {
  content: "󱒹";
}

.mdi-relative-scale::before {
  content: "󰑒";
}

.mdi-reload::before {
  content: "󰑓";
}

.mdi-reload-alert::before {
  content: "󱄋";
}

.mdi-reminder::before {
  content: "󰢌";
}

.mdi-remote::before {
  content: "󰑔";
}

.mdi-remote-desktop::before {
  content: "󰢹";
}

.mdi-remote-off::before {
  content: "󰻄";
}

.mdi-remote-tv::before {
  content: "󰻅";
}

.mdi-remote-tv-off::before {
  content: "󰻆";
}

.mdi-rename-box::before {
  content: "󰑕";
}

.mdi-reorder-horizontal::before {
  content: "󰚈";
}

.mdi-reorder-vertical::before {
  content: "󰚉";
}

.mdi-repeat::before {
  content: "󰑖";
}

.mdi-repeat-off::before {
  content: "󰑗";
}

.mdi-repeat-once::before {
  content: "󰑘";
}

.mdi-repeat-variant::before {
  content: "󰕇";
}

.mdi-replay::before {
  content: "󰑙";
}

.mdi-reply::before {
  content: "󰑚";
}

.mdi-reply-all::before {
  content: "󰑛";
}

.mdi-reply-all-outline::before {
  content: "󰼟";
}

.mdi-reply-circle::before {
  content: "󱆮";
}

.mdi-reply-outline::before {
  content: "󰼠";
}

.mdi-reproduction::before {
  content: "󰑜";
}

.mdi-resistor::before {
  content: "󰭄";
}

.mdi-resistor-nodes::before {
  content: "󰭅";
}

.mdi-resize::before {
  content: "󰩨";
}

.mdi-resize-bottom-right::before {
  content: "󰑝";
}

.mdi-responsive::before {
  content: "󰑞";
}

.mdi-restart::before {
  content: "󰜉";
}

.mdi-restart-alert::before {
  content: "󱄌";
}

.mdi-restart-off::before {
  content: "󰶕";
}

.mdi-restore::before {
  content: "󰦛";
}

.mdi-restore-alert::before {
  content: "󱄍";
}

.mdi-rewind::before {
  content: "󰑟";
}

.mdi-rewind-10::before {
  content: "󰴪";
}

.mdi-rewind-15::before {
  content: "󱥆";
}

.mdi-rewind-30::before {
  content: "󰶖";
}

.mdi-rewind-5::before {
  content: "󱇹";
}

.mdi-rewind-60::before {
  content: "󱘌";
}

.mdi-rewind-outline::before {
  content: "󰜊";
}

.mdi-rhombus::before {
  content: "󰜋";
}

.mdi-rhombus-medium::before {
  content: "󰨐";
}

.mdi-rhombus-medium-outline::before {
  content: "󱓜";
}

.mdi-rhombus-outline::before {
  content: "󰜌";
}

.mdi-rhombus-split::before {
  content: "󰨑";
}

.mdi-rhombus-split-outline::before {
  content: "󱓝";
}

.mdi-ribbon::before {
  content: "󰑠";
}

.mdi-rice::before {
  content: "󰟪";
}

.mdi-rickshaw::before {
  content: "󱖻";
}

.mdi-rickshaw-electric::before {
  content: "󱖼";
}

.mdi-ring::before {
  content: "󰟫";
}

.mdi-rivet::before {
  content: "󰹠";
}

.mdi-road::before {
  content: "󰑡";
}

.mdi-road-variant::before {
  content: "󰑢";
}

.mdi-robber::before {
  content: "󱁘";
}

.mdi-robot::before {
  content: "󰚩";
}

.mdi-robot-angry::before {
  content: "󱚝";
}

.mdi-robot-angry-outline::before {
  content: "󱚞";
}

.mdi-robot-confused::before {
  content: "󱚟";
}

.mdi-robot-confused-outline::before {
  content: "󱚠";
}

.mdi-robot-dead::before {
  content: "󱚡";
}

.mdi-robot-dead-outline::before {
  content: "󱚢";
}

.mdi-robot-excited::before {
  content: "󱚣";
}

.mdi-robot-excited-outline::before {
  content: "󱚤";
}

.mdi-robot-happy::before {
  content: "󱜙";
}

.mdi-robot-happy-outline::before {
  content: "󱜚";
}

.mdi-robot-industrial::before {
  content: "󰭆";
}

.mdi-robot-love::before {
  content: "󱚥";
}

.mdi-robot-love-outline::before {
  content: "󱚦";
}

.mdi-robot-mower::before {
  content: "󱇷";
}

.mdi-robot-mower-outline::before {
  content: "󱇳";
}

.mdi-robot-off::before {
  content: "󱚧";
}

.mdi-robot-off-outline::before {
  content: "󱙻";
}

.mdi-robot-outline::before {
  content: "󱙺";
}

.mdi-robot-vacuum::before {
  content: "󰜍";
}

.mdi-robot-vacuum-variant::before {
  content: "󰤈";
}

.mdi-rocket::before {
  content: "󰑣";
}

.mdi-rocket-launch::before {
  content: "󱓞";
}

.mdi-rocket-launch-outline::before {
  content: "󱓟";
}

.mdi-rocket-outline::before {
  content: "󱎯";
}

.mdi-rodent::before {
  content: "󱌧";
}

.mdi-roller-skate::before {
  content: "󰴫";
}

.mdi-roller-skate-off::before {
  content: "󰅅";
}

.mdi-rollerblade::before {
  content: "󰴬";
}

.mdi-rollerblade-off::before {
  content: "󰀮";
}

.mdi-rollupjs::before {
  content: "󰯀";
}

.mdi-roman-numeral-1::before {
  content: "󱂈";
}

.mdi-roman-numeral-10::before {
  content: "󱂑";
}

.mdi-roman-numeral-2::before {
  content: "󱂉";
}

.mdi-roman-numeral-3::before {
  content: "󱂊";
}

.mdi-roman-numeral-4::before {
  content: "󱂋";
}

.mdi-roman-numeral-5::before {
  content: "󱂌";
}

.mdi-roman-numeral-6::before {
  content: "󱂍";
}

.mdi-roman-numeral-7::before {
  content: "󱂎";
}

.mdi-roman-numeral-8::before {
  content: "󱂏";
}

.mdi-roman-numeral-9::before {
  content: "󱂐";
}

.mdi-room-service::before {
  content: "󰢍";
}

.mdi-room-service-outline::before {
  content: "󰶗";
}

.mdi-rotate-360::before {
  content: "󱦙";
}

.mdi-rotate-3d::before {
  content: "󰻇";
}

.mdi-rotate-3d-variant::before {
  content: "󰑤";
}

.mdi-rotate-left::before {
  content: "󰑥";
}

.mdi-rotate-left-variant::before {
  content: "󰑦";
}

.mdi-rotate-orbit::before {
  content: "󰶘";
}

.mdi-rotate-right::before {
  content: "󰑧";
}

.mdi-rotate-right-variant::before {
  content: "󰑨";
}

.mdi-rounded-corner::before {
  content: "󰘇";
}

.mdi-router::before {
  content: "󱇢";
}

.mdi-router-network::before {
  content: "󱂇";
}

.mdi-router-wireless::before {
  content: "󰑩";
}

.mdi-router-wireless-off::before {
  content: "󱖣";
}

.mdi-router-wireless-settings::before {
  content: "󰩩";
}

.mdi-routes::before {
  content: "󰑪";
}

.mdi-routes-clock::before {
  content: "󱁙";
}

.mdi-rowing::before {
  content: "󰘈";
}

.mdi-rss::before {
  content: "󰑫";
}

.mdi-rss-box::before {
  content: "󰑬";
}

.mdi-rss-off::before {
  content: "󰼡";
}

.mdi-rug::before {
  content: "󱑵";
}

.mdi-rugby::before {
  content: "󰶙";
}

.mdi-ruler::before {
  content: "󰑭";
}

.mdi-ruler-square::before {
  content: "󰳂";
}

.mdi-ruler-square-compass::before {
  content: "󰺾";
}

.mdi-run::before {
  content: "󰜎";
}

.mdi-run-fast::before {
  content: "󰑮";
}

.mdi-rv-truck::before {
  content: "󱇔";
}

.mdi-sack::before {
  content: "󰴮";
}

.mdi-sack-percent::before {
  content: "󰴯";
}

.mdi-safe::before {
  content: "󰩪";
}

.mdi-safe-square::before {
  content: "󱉼";
}

.mdi-safe-square-outline::before {
  content: "󱉽";
}

.mdi-safety-goggles::before {
  content: "󰴰";
}

.mdi-sail-boat::before {
  content: "󰻈";
}

.mdi-sale::before {
  content: "󰑯";
}

.mdi-salesforce::before {
  content: "󰢎";
}

.mdi-sass::before {
  content: "󰟬";
}

.mdi-satellite::before {
  content: "󰑰";
}

.mdi-satellite-uplink::before {
  content: "󰤉";
}

.mdi-satellite-variant::before {
  content: "󰑱";
}

.mdi-sausage::before {
  content: "󰢺";
}

.mdi-sausage-off::before {
  content: "󱞉";
}

.mdi-saw-blade::before {
  content: "󰹡";
}

.mdi-sawtooth-wave::before {
  content: "󱑺";
}

.mdi-saxophone::before {
  content: "󰘉";
}

.mdi-scale::before {
  content: "󰑲";
}

.mdi-scale-balance::before {
  content: "󰗑";
}

.mdi-scale-bathroom::before {
  content: "󰑳";
}

.mdi-scale-off::before {
  content: "󱁚";
}

.mdi-scale-unbalanced::before {
  content: "󱦸";
}

.mdi-scan-helper::before {
  content: "󱏘";
}

.mdi-scanner::before {
  content: "󰚫";
}

.mdi-scanner-off::before {
  content: "󰤊";
}

.mdi-scatter-plot::before {
  content: "󰻉";
}

.mdi-scatter-plot-outline::before {
  content: "󰻊";
}

.mdi-scent::before {
  content: "󱥘";
}

.mdi-scent-off::before {
  content: "󱥙";
}

.mdi-school::before {
  content: "󰑴";
}

.mdi-school-outline::before {
  content: "󱆀";
}

.mdi-scissors-cutting::before {
  content: "󰩫";
}

.mdi-scooter::before {
  content: "󱖽";
}

.mdi-scooter-electric::before {
  content: "󱖾";
}

.mdi-scoreboard::before {
  content: "󱉾";
}

.mdi-scoreboard-outline::before {
  content: "󱉿";
}

.mdi-screen-rotation::before {
  content: "󰑵";
}

.mdi-screen-rotation-lock::before {
  content: "󰑸";
}

.mdi-screw-flat-top::before {
  content: "󰷳";
}

.mdi-screw-lag::before {
  content: "󰷴";
}

.mdi-screw-machine-flat-top::before {
  content: "󰷵";
}

.mdi-screw-machine-round-top::before {
  content: "󰷶";
}

.mdi-screw-round-top::before {
  content: "󰷷";
}

.mdi-screwdriver::before {
  content: "󰑶";
}

.mdi-script::before {
  content: "󰯁";
}

.mdi-script-outline::before {
  content: "󰑷";
}

.mdi-script-text::before {
  content: "󰯂";
}

.mdi-script-text-key::before {
  content: "󱜥";
}

.mdi-script-text-key-outline::before {
  content: "󱜦";
}

.mdi-script-text-outline::before {
  content: "󰯃";
}

.mdi-script-text-play::before {
  content: "󱜧";
}

.mdi-script-text-play-outline::before {
  content: "󱜨";
}

.mdi-sd::before {
  content: "󰑹";
}

.mdi-seal::before {
  content: "󰑺";
}

.mdi-seal-variant::before {
  content: "󰿙";
}

.mdi-search-web::before {
  content: "󰜏";
}

.mdi-seat::before {
  content: "󰳃";
}

.mdi-seat-flat::before {
  content: "󰑻";
}

.mdi-seat-flat-angled::before {
  content: "󰑼";
}

.mdi-seat-individual-suite::before {
  content: "󰑽";
}

.mdi-seat-legroom-extra::before {
  content: "󰑾";
}

.mdi-seat-legroom-normal::before {
  content: "󰑿";
}

.mdi-seat-legroom-reduced::before {
  content: "󰒀";
}

.mdi-seat-outline::before {
  content: "󰳄";
}

.mdi-seat-passenger::before {
  content: "󱉉";
}

.mdi-seat-recline-extra::before {
  content: "󰒁";
}

.mdi-seat-recline-normal::before {
  content: "󰒂";
}

.mdi-seatbelt::before {
  content: "󰳅";
}

.mdi-security::before {
  content: "󰒃";
}

.mdi-security-network::before {
  content: "󰒄";
}

.mdi-seed::before {
  content: "󰹢";
}

.mdi-seed-off::before {
  content: "󱏽";
}

.mdi-seed-off-outline::before {
  content: "󱏾";
}

.mdi-seed-outline::before {
  content: "󰹣";
}

.mdi-seesaw::before {
  content: "󱖤";
}

.mdi-segment::before {
  content: "󰻋";
}

.mdi-select::before {
  content: "󰒅";
}

.mdi-select-all::before {
  content: "󰒆";
}

.mdi-select-color::before {
  content: "󰴱";
}

.mdi-select-compare::before {
  content: "󰫙";
}

.mdi-select-drag::before {
  content: "󰩬";
}

.mdi-select-group::before {
  content: "󰾂";
}

.mdi-select-inverse::before {
  content: "󰒇";
}

.mdi-select-marker::before {
  content: "󱊀";
}

.mdi-select-multiple::before {
  content: "󱊁";
}

.mdi-select-multiple-marker::before {
  content: "󱊂";
}

.mdi-select-off::before {
  content: "󰒈";
}

.mdi-select-place::before {
  content: "󰿚";
}

.mdi-select-remove::before {
  content: "󱟁";
}

.mdi-select-search::before {
  content: "󱈄";
}

.mdi-selection::before {
  content: "󰒉";
}

.mdi-selection-drag::before {
  content: "󰩭";
}

.mdi-selection-ellipse::before {
  content: "󰴲";
}

.mdi-selection-ellipse-arrow-inside::before {
  content: "󰼢";
}

.mdi-selection-ellipse-remove::before {
  content: "󱟂";
}

.mdi-selection-marker::before {
  content: "󱊃";
}

.mdi-selection-multiple::before {
  content: "󱊅";
}

.mdi-selection-multiple-marker::before {
  content: "󱊄";
}

.mdi-selection-off::before {
  content: "󰝷";
}

.mdi-selection-remove::before {
  content: "󱟃";
}

.mdi-selection-search::before {
  content: "󱈅";
}

.mdi-semantic-web::before {
  content: "󱌖";
}

.mdi-send::before {
  content: "󰒊";
}

.mdi-send-check::before {
  content: "󱅡";
}

.mdi-send-check-outline::before {
  content: "󱅢";
}

.mdi-send-circle::before {
  content: "󰷸";
}

.mdi-send-circle-outline::before {
  content: "󰷹";
}

.mdi-send-clock::before {
  content: "󱅣";
}

.mdi-send-clock-outline::before {
  content: "󱅤";
}

.mdi-send-lock::before {
  content: "󰟭";
}

.mdi-send-lock-outline::before {
  content: "󱅦";
}

.mdi-send-outline::before {
  content: "󱅥";
}

.mdi-serial-port::before {
  content: "󰙜";
}

.mdi-server::before {
  content: "󰒋";
}

.mdi-server-minus::before {
  content: "󰒌";
}

.mdi-server-network::before {
  content: "󰒍";
}

.mdi-server-network-off::before {
  content: "󰒎";
}

.mdi-server-off::before {
  content: "󰒏";
}

.mdi-server-plus::before {
  content: "󰒐";
}

.mdi-server-remove::before {
  content: "󰒑";
}

.mdi-server-security::before {
  content: "󰒒";
}

.mdi-set-all::before {
  content: "󰝸";
}

.mdi-set-center::before {
  content: "󰝹";
}

.mdi-set-center-right::before {
  content: "󰝺";
}

.mdi-set-left::before {
  content: "󰝻";
}

.mdi-set-left-center::before {
  content: "󰝼";
}

.mdi-set-left-right::before {
  content: "󰝽";
}

.mdi-set-merge::before {
  content: "󱓠";
}

.mdi-set-none::before {
  content: "󰝾";
}

.mdi-set-right::before {
  content: "󰝿";
}

.mdi-set-split::before {
  content: "󱓡";
}

.mdi-set-square::before {
  content: "󱑝";
}

.mdi-set-top-box::before {
  content: "󰦟";
}

.mdi-settings-helper::before {
  content: "󰩮";
}

.mdi-shaker::before {
  content: "󱄎";
}

.mdi-shaker-outline::before {
  content: "󱄏";
}

.mdi-shape::before {
  content: "󰠱";
}

.mdi-shape-circle-plus::before {
  content: "󰙝";
}

.mdi-shape-outline::before {
  content: "󰠲";
}

.mdi-shape-oval-plus::before {
  content: "󱇺";
}

.mdi-shape-plus::before {
  content: "󰒕";
}

.mdi-shape-polygon-plus::before {
  content: "󰙞";
}

.mdi-shape-rectangle-plus::before {
  content: "󰙟";
}

.mdi-shape-square-plus::before {
  content: "󰙠";
}

.mdi-shape-square-rounded-plus::before {
  content: "󱓺";
}

.mdi-share::before {
  content: "󰒖";
}

.mdi-share-all::before {
  content: "󱇴";
}

.mdi-share-all-outline::before {
  content: "󱇵";
}

.mdi-share-circle::before {
  content: "󱆭";
}

.mdi-share-off::before {
  content: "󰼣";
}

.mdi-share-off-outline::before {
  content: "󰼤";
}

.mdi-share-outline::before {
  content: "󰤲";
}

.mdi-share-variant::before {
  content: "󰒗";
}

.mdi-share-variant-outline::before {
  content: "󱔔";
}

.mdi-shark::before {
  content: "󱢺";
}

.mdi-shark-fin::before {
  content: "󱙳";
}

.mdi-shark-fin-outline::before {
  content: "󱙴";
}

.mdi-shark-off::before {
  content: "󱢻";
}

.mdi-sheep::before {
  content: "󰳆";
}

.mdi-shield::before {
  content: "󰒘";
}

.mdi-shield-account::before {
  content: "󰢏";
}

.mdi-shield-account-outline::before {
  content: "󰨒";
}

.mdi-shield-account-variant::before {
  content: "󱖧";
}

.mdi-shield-account-variant-outline::before {
  content: "󱖨";
}

.mdi-shield-airplane::before {
  content: "󰚻";
}

.mdi-shield-airplane-outline::before {
  content: "󰳇";
}

.mdi-shield-alert::before {
  content: "󰻌";
}

.mdi-shield-alert-outline::before {
  content: "󰻍";
}

.mdi-shield-bug::before {
  content: "󱏚";
}

.mdi-shield-bug-outline::before {
  content: "󱏛";
}

.mdi-shield-car::before {
  content: "󰾃";
}

.mdi-shield-check::before {
  content: "󰕥";
}

.mdi-shield-check-outline::before {
  content: "󰳈";
}

.mdi-shield-cross::before {
  content: "󰳉";
}

.mdi-shield-cross-outline::before {
  content: "󰳊";
}

.mdi-shield-crown::before {
  content: "󱢼";
}

.mdi-shield-crown-outline::before {
  content: "󱢽";
}

.mdi-shield-edit::before {
  content: "󱆠";
}

.mdi-shield-edit-outline::before {
  content: "󱆡";
}

.mdi-shield-half::before {
  content: "󱍠";
}

.mdi-shield-half-full::before {
  content: "󰞀";
}

.mdi-shield-home::before {
  content: "󰚊";
}

.mdi-shield-home-outline::before {
  content: "󰳋";
}

.mdi-shield-key::before {
  content: "󰯄";
}

.mdi-shield-key-outline::before {
  content: "󰯅";
}

.mdi-shield-link-variant::before {
  content: "󰴳";
}

.mdi-shield-link-variant-outline::before {
  content: "󰴴";
}

.mdi-shield-lock::before {
  content: "󰦝";
}

.mdi-shield-lock-open::before {
  content: "󱦚";
}

.mdi-shield-lock-open-outline::before {
  content: "󱦛";
}

.mdi-shield-lock-outline::before {
  content: "󰳌";
}

.mdi-shield-moon::before {
  content: "󱠨";
}

.mdi-shield-moon-outline::before {
  content: "󱠩";
}

.mdi-shield-off::before {
  content: "󰦞";
}

.mdi-shield-off-outline::before {
  content: "󰦜";
}

.mdi-shield-outline::before {
  content: "󰒙";
}

.mdi-shield-plus::before {
  content: "󰫚";
}

.mdi-shield-plus-outline::before {
  content: "󰫛";
}

.mdi-shield-refresh::before {
  content: "󰂪";
}

.mdi-shield-refresh-outline::before {
  content: "󰇠";
}

.mdi-shield-remove::before {
  content: "󰫜";
}

.mdi-shield-remove-outline::before {
  content: "󰫝";
}

.mdi-shield-search::before {
  content: "󰶚";
}

.mdi-shield-star::before {
  content: "󱄻";
}

.mdi-shield-star-outline::before {
  content: "󱄼";
}

.mdi-shield-sun::before {
  content: "󱁝";
}

.mdi-shield-sun-outline::before {
  content: "󱁞";
}

.mdi-shield-sword::before {
  content: "󱢾";
}

.mdi-shield-sword-outline::before {
  content: "󱢿";
}

.mdi-shield-sync::before {
  content: "󱆢";
}

.mdi-shield-sync-outline::before {
  content: "󱆣";
}

.mdi-shimmer::before {
  content: "󱕅";
}

.mdi-ship-wheel::before {
  content: "󰠳";
}

.mdi-shipping-pallet::before {
  content: "󱡎";
}

.mdi-shoe-ballet::before {
  content: "󱗊";
}

.mdi-shoe-cleat::before {
  content: "󱗇";
}

.mdi-shoe-formal::before {
  content: "󰭇";
}

.mdi-shoe-heel::before {
  content: "󰭈";
}

.mdi-shoe-print::before {
  content: "󰷺";
}

.mdi-shoe-sneaker::before {
  content: "󱗈";
}

.mdi-shopping::before {
  content: "󰒚";
}

.mdi-shopping-music::before {
  content: "󰒛";
}

.mdi-shopping-outline::before {
  content: "󱇕";
}

.mdi-shopping-search::before {
  content: "󰾄";
}

.mdi-shore::before {
  content: "󱓹";
}

.mdi-shovel::before {
  content: "󰜐";
}

.mdi-shovel-off::before {
  content: "󰜑";
}

.mdi-shower::before {
  content: "󰦠";
}

.mdi-shower-head::before {
  content: "󰦡";
}

.mdi-shredder::before {
  content: "󰒜";
}

.mdi-shuffle::before {
  content: "󰒝";
}

.mdi-shuffle-disabled::before {
  content: "󰒞";
}

.mdi-shuffle-variant::before {
  content: "󰒟";
}

.mdi-shuriken::before {
  content: "󱍿";
}

.mdi-sickle::before {
  content: "󱣀";
}

.mdi-sigma::before {
  content: "󰒠";
}

.mdi-sigma-lower::before {
  content: "󰘫";
}

.mdi-sign-caution::before {
  content: "󰒡";
}

.mdi-sign-direction::before {
  content: "󰞁";
}

.mdi-sign-direction-minus::before {
  content: "󱀀";
}

.mdi-sign-direction-plus::before {
  content: "󰿜";
}

.mdi-sign-direction-remove::before {
  content: "󰿝";
}

.mdi-sign-pole::before {
  content: "󱓸";
}

.mdi-sign-real-estate::before {
  content: "󱄘";
}

.mdi-sign-text::before {
  content: "󰞂";
}

.mdi-signal::before {
  content: "󰒢";
}

.mdi-signal-2g::before {
  content: "󰜒";
}

.mdi-signal-3g::before {
  content: "󰜓";
}

.mdi-signal-4g::before {
  content: "󰜔";
}

.mdi-signal-5g::before {
  content: "󰩯";
}

.mdi-signal-cellular-1::before {
  content: "󰢼";
}

.mdi-signal-cellular-2::before {
  content: "󰢽";
}

.mdi-signal-cellular-3::before {
  content: "󰢾";
}

.mdi-signal-cellular-outline::before {
  content: "󰢿";
}

.mdi-signal-distance-variant::before {
  content: "󰹤";
}

.mdi-signal-hspa::before {
  content: "󰜕";
}

.mdi-signal-hspa-plus::before {
  content: "󰜖";
}

.mdi-signal-off::before {
  content: "󰞃";
}

.mdi-signal-variant::before {
  content: "󰘊";
}

.mdi-signature::before {
  content: "󰷻";
}

.mdi-signature-freehand::before {
  content: "󰷼";
}

.mdi-signature-image::before {
  content: "󰷽";
}

.mdi-signature-text::before {
  content: "󰷾";
}

.mdi-silo::before {
  content: "󰭉";
}

.mdi-silverware::before {
  content: "󰒣";
}

.mdi-silverware-clean::before {
  content: "󰿞";
}

.mdi-silverware-fork::before {
  content: "󰒤";
}

.mdi-silverware-fork-knife::before {
  content: "󰩰";
}

.mdi-silverware-spoon::before {
  content: "󰒥";
}

.mdi-silverware-variant::before {
  content: "󰒦";
}

.mdi-sim::before {
  content: "󰒧";
}

.mdi-sim-alert::before {
  content: "󰒨";
}

.mdi-sim-alert-outline::before {
  content: "󱗓";
}

.mdi-sim-off::before {
  content: "󰒩";
}

.mdi-sim-off-outline::before {
  content: "󱗔";
}

.mdi-sim-outline::before {
  content: "󱗕";
}

.mdi-simple-icons::before {
  content: "󱌝";
}

.mdi-sina-weibo::before {
  content: "󰫟";
}

.mdi-sine-wave::before {
  content: "󰥛";
}

.mdi-sitemap::before {
  content: "󰒪";
}

.mdi-sitemap-outline::before {
  content: "󱦜";
}

.mdi-size-l::before {
  content: "󱎦";
}

.mdi-size-m::before {
  content: "󱎥";
}

.mdi-size-s::before {
  content: "󱎤";
}

.mdi-size-xl::before {
  content: "󱎧";
}

.mdi-size-xs::before {
  content: "󱎣";
}

.mdi-size-xxl::before {
  content: "󱎨";
}

.mdi-size-xxs::before {
  content: "󱎢";
}

.mdi-size-xxxl::before {
  content: "󱎩";
}

.mdi-skate::before {
  content: "󰴵";
}

.mdi-skate-off::before {
  content: "󰚙";
}

.mdi-skateboard::before {
  content: "󱓂";
}

.mdi-skateboarding::before {
  content: "󰔁";
}

.mdi-skew-less::before {
  content: "󰴶";
}

.mdi-skew-more::before {
  content: "󰴷";
}

.mdi-ski::before {
  content: "󱌄";
}

.mdi-ski-cross-country::before {
  content: "󱌅";
}

.mdi-ski-water::before {
  content: "󱌆";
}

.mdi-skip-backward::before {
  content: "󰒫";
}

.mdi-skip-backward-outline::before {
  content: "󰼥";
}

.mdi-skip-forward::before {
  content: "󰒬";
}

.mdi-skip-forward-outline::before {
  content: "󰼦";
}

.mdi-skip-next::before {
  content: "󰒭";
}

.mdi-skip-next-circle::before {
  content: "󰙡";
}

.mdi-skip-next-circle-outline::before {
  content: "󰙢";
}

.mdi-skip-next-outline::before {
  content: "󰼧";
}

.mdi-skip-previous::before {
  content: "󰒮";
}

.mdi-skip-previous-circle::before {
  content: "󰙣";
}

.mdi-skip-previous-circle-outline::before {
  content: "󰙤";
}

.mdi-skip-previous-outline::before {
  content: "󰼨";
}

.mdi-skull::before {
  content: "󰚌";
}

.mdi-skull-crossbones::before {
  content: "󰯆";
}

.mdi-skull-crossbones-outline::before {
  content: "󰯇";
}

.mdi-skull-outline::before {
  content: "󰯈";
}

.mdi-skull-scan::before {
  content: "󱓇";
}

.mdi-skull-scan-outline::before {
  content: "󱓈";
}

.mdi-skype::before {
  content: "󰒯";
}

.mdi-skype-business::before {
  content: "󰒰";
}

.mdi-slack::before {
  content: "󰒱";
}

.mdi-slash-forward::before {
  content: "󰿟";
}

.mdi-slash-forward-box::before {
  content: "󰿠";
}

.mdi-sledding::before {
  content: "󰐛";
}

.mdi-sleep::before {
  content: "󰒲";
}

.mdi-sleep-off::before {
  content: "󰒳";
}

.mdi-slide::before {
  content: "󱖥";
}

.mdi-slope-downhill::before {
  content: "󰷿";
}

.mdi-slope-uphill::before {
  content: "󰸀";
}

.mdi-slot-machine::before {
  content: "󱄔";
}

.mdi-slot-machine-outline::before {
  content: "󱄕";
}

.mdi-smart-card::before {
  content: "󱂽";
}

.mdi-smart-card-off::before {
  content: "󱣷";
}

.mdi-smart-card-off-outline::before {
  content: "󱣸";
}

.mdi-smart-card-outline::before {
  content: "󱂾";
}

.mdi-smart-card-reader::before {
  content: "󱂿";
}

.mdi-smart-card-reader-outline::before {
  content: "󱃀";
}

.mdi-smog::before {
  content: "󰩱";
}

.mdi-smoke::before {
  content: "󱞙";
}

.mdi-smoke-detector::before {
  content: "󰎒";
}

.mdi-smoke-detector-alert::before {
  content: "󱤮";
}

.mdi-smoke-detector-alert-outline::before {
  content: "󱤯";
}

.mdi-smoke-detector-off::before {
  content: "󱠉";
}

.mdi-smoke-detector-off-outline::before {
  content: "󱠊";
}

.mdi-smoke-detector-outline::before {
  content: "󱠈";
}

.mdi-smoke-detector-variant::before {
  content: "󱠋";
}

.mdi-smoke-detector-variant-alert::before {
  content: "󱤰";
}

.mdi-smoke-detector-variant-off::before {
  content: "󱠌";
}

.mdi-smoking::before {
  content: "󰒴";
}

.mdi-smoking-off::before {
  content: "󰒵";
}

.mdi-smoking-pipe::before {
  content: "󱐍";
}

.mdi-smoking-pipe-off::before {
  content: "󱐨";
}

.mdi-snail::before {
  content: "󱙷";
}

.mdi-snake::before {
  content: "󱔎";
}

.mdi-snapchat::before {
  content: "󰒶";
}

.mdi-snowboard::before {
  content: "󱌇";
}

.mdi-snowflake::before {
  content: "󰜗";
}

.mdi-snowflake-alert::before {
  content: "󰼩";
}

.mdi-snowflake-melt::before {
  content: "󱋋";
}

.mdi-snowflake-off::before {
  content: "󱓣";
}

.mdi-snowflake-variant::before {
  content: "󰼪";
}

.mdi-snowman::before {
  content: "󰒷";
}

.mdi-snowmobile::before {
  content: "󰛝";
}

.mdi-soccer::before {
  content: "󰒸";
}

.mdi-soccer-field::before {
  content: "󰠴";
}

.mdi-social-distance-2-meters::before {
  content: "󱕹";
}

.mdi-social-distance-6-feet::before {
  content: "󱕺";
}

.mdi-sofa::before {
  content: "󰒹";
}

.mdi-sofa-outline::before {
  content: "󱕭";
}

.mdi-sofa-single::before {
  content: "󱕮";
}

.mdi-sofa-single-outline::before {
  content: "󱕯";
}

.mdi-solar-panel::before {
  content: "󰶛";
}

.mdi-solar-panel-large::before {
  content: "󰶜";
}

.mdi-solar-power::before {
  content: "󰩲";
}

.mdi-soldering-iron::before {
  content: "󱂒";
}

.mdi-solid::before {
  content: "󰚍";
}

.mdi-sony-playstation::before {
  content: "󰐔";
}

.mdi-sort::before {
  content: "󰒺";
}

.mdi-sort-alphabetical-ascending::before {
  content: "󰖽";
}

.mdi-sort-alphabetical-ascending-variant::before {
  content: "󱅈";
}

.mdi-sort-alphabetical-descending::before {
  content: "󰖿";
}

.mdi-sort-alphabetical-descending-variant::before {
  content: "󱅉";
}

.mdi-sort-alphabetical-variant::before {
  content: "󰒻";
}

.mdi-sort-ascending::before {
  content: "󰒼";
}

.mdi-sort-bool-ascending::before {
  content: "󱎅";
}

.mdi-sort-bool-ascending-variant::before {
  content: "󱎆";
}

.mdi-sort-bool-descending::before {
  content: "󱎇";
}

.mdi-sort-bool-descending-variant::before {
  content: "󱎈";
}

.mdi-sort-calendar-ascending::before {
  content: "󱕇";
}

.mdi-sort-calendar-descending::before {
  content: "󱕈";
}

.mdi-sort-clock-ascending::before {
  content: "󱕉";
}

.mdi-sort-clock-ascending-outline::before {
  content: "󱕊";
}

.mdi-sort-clock-descending::before {
  content: "󱕋";
}

.mdi-sort-clock-descending-outline::before {
  content: "󱕌";
}

.mdi-sort-descending::before {
  content: "󰒽";
}

.mdi-sort-numeric-ascending::before {
  content: "󱎉";
}

.mdi-sort-numeric-ascending-variant::before {
  content: "󰤍";
}

.mdi-sort-numeric-descending::before {
  content: "󱎊";
}

.mdi-sort-numeric-descending-variant::before {
  content: "󰫒";
}

.mdi-sort-numeric-variant::before {
  content: "󰒾";
}

.mdi-sort-reverse-variant::before {
  content: "󰌼";
}

.mdi-sort-variant::before {
  content: "󰒿";
}

.mdi-sort-variant-lock::before {
  content: "󰳍";
}

.mdi-sort-variant-lock-open::before {
  content: "󰳎";
}

.mdi-sort-variant-remove::before {
  content: "󱅇";
}

.mdi-soundbar::before {
  content: "󱟛";
}

.mdi-soundcloud::before {
  content: "󰓀";
}

.mdi-source-branch::before {
  content: "󰘬";
}

.mdi-source-branch-check::before {
  content: "󱓏";
}

.mdi-source-branch-minus::before {
  content: "󱓋";
}

.mdi-source-branch-plus::before {
  content: "󱓊";
}

.mdi-source-branch-refresh::before {
  content: "󱓍";
}

.mdi-source-branch-remove::before {
  content: "󱓌";
}

.mdi-source-branch-sync::before {
  content: "󱓎";
}

.mdi-source-commit::before {
  content: "󰜘";
}

.mdi-source-commit-end::before {
  content: "󰜙";
}

.mdi-source-commit-end-local::before {
  content: "󰜚";
}

.mdi-source-commit-local::before {
  content: "󰜛";
}

.mdi-source-commit-next-local::before {
  content: "󰜜";
}

.mdi-source-commit-start::before {
  content: "󰜝";
}

.mdi-source-commit-start-next-local::before {
  content: "󰜞";
}

.mdi-source-fork::before {
  content: "󰓁";
}

.mdi-source-merge::before {
  content: "󰘭";
}

.mdi-source-pull::before {
  content: "󰓂";
}

.mdi-source-repository::before {
  content: "󰳏";
}

.mdi-source-repository-multiple::before {
  content: "󰳐";
}

.mdi-soy-sauce::before {
  content: "󰟮";
}

.mdi-soy-sauce-off::before {
  content: "󱏼";
}

.mdi-spa::before {
  content: "󰳑";
}

.mdi-spa-outline::before {
  content: "󰳒";
}

.mdi-space-invaders::before {
  content: "󰯉";
}

.mdi-space-station::before {
  content: "󱎃";
}

.mdi-spade::before {
  content: "󰹥";
}

.mdi-speaker::before {
  content: "󰓃";
}

.mdi-speaker-bluetooth::before {
  content: "󰦢";
}

.mdi-speaker-multiple::before {
  content: "󰴸";
}

.mdi-speaker-off::before {
  content: "󰓄";
}

.mdi-speaker-wireless::before {
  content: "󰜟";
}

.mdi-spear::before {
  content: "󱡅";
}

.mdi-speedometer::before {
  content: "󰓅";
}

.mdi-speedometer-medium::before {
  content: "󰾅";
}

.mdi-speedometer-slow::before {
  content: "󰾆";
}

.mdi-spellcheck::before {
  content: "󰓆";
}

.mdi-sphere::before {
  content: "󱥔";
}

.mdi-sphere-off::before {
  content: "󱥕";
}

.mdi-spider::before {
  content: "󱇪";
}

.mdi-spider-thread::before {
  content: "󱇫";
}

.mdi-spider-web::before {
  content: "󰯊";
}

.mdi-spirit-level::before {
  content: "󱓱";
}

.mdi-spoon-sugar::before {
  content: "󱐩";
}

.mdi-spotify::before {
  content: "󰓇";
}

.mdi-spotlight::before {
  content: "󰓈";
}

.mdi-spotlight-beam::before {
  content: "󰓉";
}

.mdi-spray::before {
  content: "󰙥";
}

.mdi-spray-bottle::before {
  content: "󰫠";
}

.mdi-sprinkler::before {
  content: "󱁟";
}

.mdi-sprinkler-fire::before {
  content: "󱦝";
}

.mdi-sprinkler-variant::before {
  content: "󱁠";
}

.mdi-sprout::before {
  content: "󰹦";
}

.mdi-sprout-outline::before {
  content: "󰹧";
}

.mdi-square::before {
  content: "󰝤";
}

.mdi-square-circle::before {
  content: "󱔀";
}

.mdi-square-edit-outline::before {
  content: "󰤌";
}

.mdi-square-medium::before {
  content: "󰨓";
}

.mdi-square-medium-outline::before {
  content: "󰨔";
}

.mdi-square-off::before {
  content: "󱋮";
}

.mdi-square-off-outline::before {
  content: "󱋯";
}

.mdi-square-opacity::before {
  content: "󱡔";
}

.mdi-square-outline::before {
  content: "󰝣";
}

.mdi-square-root::before {
  content: "󰞄";
}

.mdi-square-root-box::before {
  content: "󰦣";
}

.mdi-square-rounded::before {
  content: "󱓻";
}

.mdi-square-rounded-outline::before {
  content: "󱓼";
}

.mdi-square-small::before {
  content: "󰨕";
}

.mdi-square-wave::before {
  content: "󱑻";
}

.mdi-squeegee::before {
  content: "󰫡";
}

.mdi-ssh::before {
  content: "󰣀";
}

.mdi-stack-exchange::before {
  content: "󰘋";
}

.mdi-stack-overflow::before {
  content: "󰓌";
}

.mdi-stackpath::before {
  content: "󰍙";
}

.mdi-stadium::before {
  content: "󰿹";
}

.mdi-stadium-variant::before {
  content: "󰜠";
}

.mdi-stairs::before {
  content: "󰓍";
}

.mdi-stairs-box::before {
  content: "󱎞";
}

.mdi-stairs-down::before {
  content: "󱊾";
}

.mdi-stairs-up::before {
  content: "󱊽";
}

.mdi-stamper::before {
  content: "󰴹";
}

.mdi-standard-definition::before {
  content: "󰟯";
}

.mdi-star::before {
  content: "󰓎";
}

.mdi-star-box::before {
  content: "󰩳";
}

.mdi-star-box-multiple::before {
  content: "󱊆";
}

.mdi-star-box-multiple-outline::before {
  content: "󱊇";
}

.mdi-star-box-outline::before {
  content: "󰩴";
}

.mdi-star-check::before {
  content: "󱕦";
}

.mdi-star-check-outline::before {
  content: "󱕪";
}

.mdi-star-circle::before {
  content: "󰓏";
}

.mdi-star-circle-outline::before {
  content: "󰦤";
}

.mdi-star-cog::before {
  content: "󱙨";
}

.mdi-star-cog-outline::before {
  content: "󱙩";
}

.mdi-star-crescent::before {
  content: "󰥹";
}

.mdi-star-david::before {
  content: "󰥺";
}

.mdi-star-face::before {
  content: "󰦥";
}

.mdi-star-four-points::before {
  content: "󰫢";
}

.mdi-star-four-points-outline::before {
  content: "󰫣";
}

.mdi-star-half::before {
  content: "󰉆";
}

.mdi-star-half-full::before {
  content: "󰓐";
}

.mdi-star-minus::before {
  content: "󱕤";
}

.mdi-star-minus-outline::before {
  content: "󱕨";
}

.mdi-star-off::before {
  content: "󰓑";
}

.mdi-star-off-outline::before {
  content: "󱕛";
}

.mdi-star-outline::before {
  content: "󰓒";
}

.mdi-star-plus::before {
  content: "󱕣";
}

.mdi-star-plus-outline::before {
  content: "󱕧";
}

.mdi-star-remove::before {
  content: "󱕥";
}

.mdi-star-remove-outline::before {
  content: "󱕩";
}

.mdi-star-settings::before {
  content: "󱙪";
}

.mdi-star-settings-outline::before {
  content: "󱙫";
}

.mdi-star-shooting::before {
  content: "󱝁";
}

.mdi-star-shooting-outline::before {
  content: "󱝂";
}

.mdi-star-three-points::before {
  content: "󰫤";
}

.mdi-star-three-points-outline::before {
  content: "󰫥";
}

.mdi-state-machine::before {
  content: "󱇯";
}

.mdi-steam::before {
  content: "󰓓";
}

.mdi-steering::before {
  content: "󰓔";
}

.mdi-steering-off::before {
  content: "󰤎";
}

.mdi-step-backward::before {
  content: "󰓕";
}

.mdi-step-backward-2::before {
  content: "󰓖";
}

.mdi-step-forward::before {
  content: "󰓗";
}

.mdi-step-forward-2::before {
  content: "󰓘";
}

.mdi-stethoscope::before {
  content: "󰓙";
}

.mdi-sticker::before {
  content: "󱍤";
}

.mdi-sticker-alert::before {
  content: "󱍥";
}

.mdi-sticker-alert-outline::before {
  content: "󱍦";
}

.mdi-sticker-check::before {
  content: "󱍧";
}

.mdi-sticker-check-outline::before {
  content: "󱍨";
}

.mdi-sticker-circle-outline::before {
  content: "󰗐";
}

.mdi-sticker-emoji::before {
  content: "󰞅";
}

.mdi-sticker-minus::before {
  content: "󱍩";
}

.mdi-sticker-minus-outline::before {
  content: "󱍪";
}

.mdi-sticker-outline::before {
  content: "󱍫";
}

.mdi-sticker-plus::before {
  content: "󱍬";
}

.mdi-sticker-plus-outline::before {
  content: "󱍭";
}

.mdi-sticker-remove::before {
  content: "󱍮";
}

.mdi-sticker-remove-outline::before {
  content: "󱍯";
}

.mdi-sticker-text::before {
  content: "󱞎";
}

.mdi-sticker-text-outline::before {
  content: "󱞏";
}

.mdi-stocking::before {
  content: "󰓚";
}

.mdi-stomach::before {
  content: "󱂓";
}

.mdi-stool::before {
  content: "󱥝";
}

.mdi-stool-outline::before {
  content: "󱥞";
}

.mdi-stop::before {
  content: "󰓛";
}

.mdi-stop-circle::before {
  content: "󰙦";
}

.mdi-stop-circle-outline::before {
  content: "󰙧";
}

.mdi-store::before {
  content: "󰓜";
}

.mdi-store-24-hour::before {
  content: "󰓝";
}

.mdi-store-alert::before {
  content: "󱣁";
}

.mdi-store-alert-outline::before {
  content: "󱣂";
}

.mdi-store-check::before {
  content: "󱣃";
}

.mdi-store-check-outline::before {
  content: "󱣄";
}

.mdi-store-clock::before {
  content: "󱣅";
}

.mdi-store-clock-outline::before {
  content: "󱣆";
}

.mdi-store-cog::before {
  content: "󱣇";
}

.mdi-store-cog-outline::before {
  content: "󱣈";
}

.mdi-store-edit::before {
  content: "󱣉";
}

.mdi-store-edit-outline::before {
  content: "󱣊";
}

.mdi-store-marker::before {
  content: "󱣋";
}

.mdi-store-marker-outline::before {
  content: "󱣌";
}

.mdi-store-minus::before {
  content: "󱙞";
}

.mdi-store-minus-outline::before {
  content: "󱣍";
}

.mdi-store-off::before {
  content: "󱣎";
}

.mdi-store-off-outline::before {
  content: "󱣏";
}

.mdi-store-outline::before {
  content: "󱍡";
}

.mdi-store-plus::before {
  content: "󱙟";
}

.mdi-store-plus-outline::before {
  content: "󱣐";
}

.mdi-store-remove::before {
  content: "󱙠";
}

.mdi-store-remove-outline::before {
  content: "󱣑";
}

.mdi-store-search::before {
  content: "󱣒";
}

.mdi-store-search-outline::before {
  content: "󱣓";
}

.mdi-store-settings::before {
  content: "󱣔";
}

.mdi-store-settings-outline::before {
  content: "󱣕";
}

.mdi-storefront::before {
  content: "󰟇";
}

.mdi-storefront-outline::before {
  content: "󱃁";
}

.mdi-stove::before {
  content: "󰓞";
}

.mdi-strategy::before {
  content: "󱇖";
}

.mdi-stretch-to-page::before {
  content: "󰼫";
}

.mdi-stretch-to-page-outline::before {
  content: "󰼬";
}

.mdi-string-lights::before {
  content: "󱊺";
}

.mdi-string-lights-off::before {
  content: "󱊻";
}

.mdi-subdirectory-arrow-left::before {
  content: "󰘌";
}

.mdi-subdirectory-arrow-right::before {
  content: "󰘍";
}

.mdi-submarine::before {
  content: "󱕬";
}

.mdi-subtitles::before {
  content: "󰨖";
}

.mdi-subtitles-outline::before {
  content: "󰨗";
}

.mdi-subway::before {
  content: "󰚬";
}

.mdi-subway-alert-variant::before {
  content: "󰶝";
}

.mdi-subway-variant::before {
  content: "󰓟";
}

.mdi-summit::before {
  content: "󰞆";
}

.mdi-sun-compass::before {
  content: "󱦥";
}

.mdi-sun-snowflake::before {
  content: "󱞖";
}

.mdi-sun-thermometer::before {
  content: "󱣖";
}

.mdi-sun-thermometer-outline::before {
  content: "󱣗";
}

.mdi-sun-wireless::before {
  content: "󱟾";
}

.mdi-sun-wireless-outline::before {
  content: "󱟿";
}

.mdi-sunglasses::before {
  content: "󰓠";
}

.mdi-surfing::before {
  content: "󱝆";
}

.mdi-surround-sound::before {
  content: "󰗅";
}

.mdi-surround-sound-2-0::before {
  content: "󰟰";
}

.mdi-surround-sound-2-1::before {
  content: "󱜩";
}

.mdi-surround-sound-3-1::before {
  content: "󰟱";
}

.mdi-surround-sound-5-1::before {
  content: "󰟲";
}

.mdi-surround-sound-5-1-2::before {
  content: "󱜪";
}

.mdi-surround-sound-7-1::before {
  content: "󰟳";
}

.mdi-svg::before {
  content: "󰜡";
}

.mdi-swap-horizontal::before {
  content: "󰓡";
}

.mdi-swap-horizontal-bold::before {
  content: "󰯍";
}

.mdi-swap-horizontal-circle::before {
  content: "󰿡";
}

.mdi-swap-horizontal-circle-outline::before {
  content: "󰿢";
}

.mdi-swap-horizontal-variant::before {
  content: "󰣁";
}

.mdi-swap-vertical::before {
  content: "󰓢";
}

.mdi-swap-vertical-bold::before {
  content: "󰯎";
}

.mdi-swap-vertical-circle::before {
  content: "󰿣";
}

.mdi-swap-vertical-circle-outline::before {
  content: "󰿤";
}

.mdi-swap-vertical-variant::before {
  content: "󰣂";
}

.mdi-swim::before {
  content: "󰓣";
}

.mdi-switch::before {
  content: "󰓤";
}

.mdi-sword::before {
  content: "󰓥";
}

.mdi-sword-cross::before {
  content: "󰞇";
}

.mdi-syllabary-hangul::before {
  content: "󱌳";
}

.mdi-syllabary-hiragana::before {
  content: "󱌴";
}

.mdi-syllabary-katakana::before {
  content: "󱌵";
}

.mdi-syllabary-katakana-halfwidth::before {
  content: "󱌶";
}

.mdi-symbol::before {
  content: "󱔁";
}

.mdi-symfony::before {
  content: "󰫦";
}

.mdi-sync::before {
  content: "󰓦";
}

.mdi-sync-alert::before {
  content: "󰓧";
}

.mdi-sync-circle::before {
  content: "󱍸";
}

.mdi-sync-off::before {
  content: "󰓨";
}

.mdi-tab::before {
  content: "󰓩";
}

.mdi-tab-minus::before {
  content: "󰭋";
}

.mdi-tab-plus::before {
  content: "󰝜";
}

.mdi-tab-remove::before {
  content: "󰭌";
}

.mdi-tab-search::before {
  content: "󱦞";
}

.mdi-tab-unselected::before {
  content: "󰓪";
}

.mdi-table::before {
  content: "󰓫";
}

.mdi-table-account::before {
  content: "󱎹";
}

.mdi-table-alert::before {
  content: "󱎺";
}

.mdi-table-arrow-down::before {
  content: "󱎻";
}

.mdi-table-arrow-left::before {
  content: "󱎼";
}

.mdi-table-arrow-right::before {
  content: "󱎽";
}

.mdi-table-arrow-up::before {
  content: "󱎾";
}

.mdi-table-border::before {
  content: "󰨘";
}

.mdi-table-cancel::before {
  content: "󱎿";
}

.mdi-table-chair::before {
  content: "󱁡";
}

.mdi-table-check::before {
  content: "󱏀";
}

.mdi-table-clock::before {
  content: "󱏁";
}

.mdi-table-cog::before {
  content: "󱏂";
}

.mdi-table-column::before {
  content: "󰠵";
}

.mdi-table-column-plus-after::before {
  content: "󰓬";
}

.mdi-table-column-plus-before::before {
  content: "󰓭";
}

.mdi-table-column-remove::before {
  content: "󰓮";
}

.mdi-table-column-width::before {
  content: "󰓯";
}

.mdi-table-edit::before {
  content: "󰓰";
}

.mdi-table-eye::before {
  content: "󱂔";
}

.mdi-table-eye-off::before {
  content: "󱏃";
}

.mdi-table-furniture::before {
  content: "󰖼";
}

.mdi-table-headers-eye::before {
  content: "󱈝";
}

.mdi-table-headers-eye-off::before {
  content: "󱈞";
}

.mdi-table-heart::before {
  content: "󱏄";
}

.mdi-table-key::before {
  content: "󱏅";
}

.mdi-table-large::before {
  content: "󰓱";
}

.mdi-table-large-plus::before {
  content: "󰾇";
}

.mdi-table-large-remove::before {
  content: "󰾈";
}

.mdi-table-lock::before {
  content: "󱏆";
}

.mdi-table-merge-cells::before {
  content: "󰦦";
}

.mdi-table-minus::before {
  content: "󱏇";
}

.mdi-table-multiple::before {
  content: "󱏈";
}

.mdi-table-network::before {
  content: "󱏉";
}

.mdi-table-of-contents::before {
  content: "󰠶";
}

.mdi-table-off::before {
  content: "󱏊";
}

.mdi-table-picnic::before {
  content: "󱝃";
}

.mdi-table-pivot::before {
  content: "󱠼";
}

.mdi-table-plus::before {
  content: "󰩵";
}

.mdi-table-refresh::before {
  content: "󱎠";
}

.mdi-table-remove::before {
  content: "󰩶";
}

.mdi-table-row::before {
  content: "󰠷";
}

.mdi-table-row-height::before {
  content: "󰓲";
}

.mdi-table-row-plus-after::before {
  content: "󰓳";
}

.mdi-table-row-plus-before::before {
  content: "󰓴";
}

.mdi-table-row-remove::before {
  content: "󰓵";
}

.mdi-table-search::before {
  content: "󰤏";
}

.mdi-table-settings::before {
  content: "󰠸";
}

.mdi-table-split-cell::before {
  content: "󱐪";
}

.mdi-table-star::before {
  content: "󱏋";
}

.mdi-table-sync::before {
  content: "󱎡";
}

.mdi-table-tennis::before {
  content: "󰹨";
}

.mdi-tablet::before {
  content: "󰓶";
}

.mdi-tablet-android::before {
  content: "󰓷";
}

.mdi-tablet-cellphone::before {
  content: "󰦧";
}

.mdi-tablet-dashboard::before {
  content: "󰻎";
}

.mdi-taco::before {
  content: "󰝢";
}

.mdi-tag::before {
  content: "󰓹";
}

.mdi-tag-arrow-down::before {
  content: "󱜫";
}

.mdi-tag-arrow-down-outline::before {
  content: "󱜬";
}

.mdi-tag-arrow-left::before {
  content: "󱜭";
}

.mdi-tag-arrow-left-outline::before {
  content: "󱜮";
}

.mdi-tag-arrow-right::before {
  content: "󱜯";
}

.mdi-tag-arrow-right-outline::before {
  content: "󱜰";
}

.mdi-tag-arrow-up::before {
  content: "󱜱";
}

.mdi-tag-arrow-up-outline::before {
  content: "󱜲";
}

.mdi-tag-faces::before {
  content: "󰓺";
}

.mdi-tag-heart::before {
  content: "󰚋";
}

.mdi-tag-heart-outline::before {
  content: "󰯏";
}

.mdi-tag-minus::before {
  content: "󰤐";
}

.mdi-tag-minus-outline::before {
  content: "󱈟";
}

.mdi-tag-multiple::before {
  content: "󰓻";
}

.mdi-tag-multiple-outline::before {
  content: "󱋷";
}

.mdi-tag-off::before {
  content: "󱈠";
}

.mdi-tag-off-outline::before {
  content: "󱈡";
}

.mdi-tag-outline::before {
  content: "󰓼";
}

.mdi-tag-plus::before {
  content: "󰜢";
}

.mdi-tag-plus-outline::before {
  content: "󱈢";
}

.mdi-tag-remove::before {
  content: "󰜣";
}

.mdi-tag-remove-outline::before {
  content: "󱈣";
}

.mdi-tag-search::before {
  content: "󱤇";
}

.mdi-tag-search-outline::before {
  content: "󱤈";
}

.mdi-tag-text::before {
  content: "󱈤";
}

.mdi-tag-text-outline::before {
  content: "󰓽";
}

.mdi-tailwind::before {
  content: "󱏿";
}

.mdi-tangram::before {
  content: "󰓸";
}

.mdi-tank::before {
  content: "󰴺";
}

.mdi-tanker-truck::before {
  content: "󰿥";
}

.mdi-tape-drive::before {
  content: "󱛟";
}

.mdi-tape-measure::before {
  content: "󰭍";
}

.mdi-target::before {
  content: "󰓾";
}

.mdi-target-account::before {
  content: "󰯐";
}

.mdi-target-variant::before {
  content: "󰩷";
}

.mdi-taxi::before {
  content: "󰓿";
}

.mdi-tea::before {
  content: "󰶞";
}

.mdi-tea-outline::before {
  content: "󰶟";
}

.mdi-teamviewer::before {
  content: "󰔀";
}

.mdi-teddy-bear::before {
  content: "󱣻";
}

.mdi-telescope::before {
  content: "󰭎";
}

.mdi-television::before {
  content: "󰔂";
}

.mdi-television-ambient-light::before {
  content: "󱍖";
}

.mdi-television-box::before {
  content: "󰠹";
}

.mdi-television-classic::before {
  content: "󰟴";
}

.mdi-television-classic-off::before {
  content: "󰠺";
}

.mdi-television-guide::before {
  content: "󰔃";
}

.mdi-television-off::before {
  content: "󰠻";
}

.mdi-television-pause::before {
  content: "󰾉";
}

.mdi-television-play::before {
  content: "󰻏";
}

.mdi-television-shimmer::before {
  content: "󱄐";
}

.mdi-television-stop::before {
  content: "󰾊";
}

.mdi-temperature-celsius::before {
  content: "󰔄";
}

.mdi-temperature-fahrenheit::before {
  content: "󰔅";
}

.mdi-temperature-kelvin::before {
  content: "󰔆";
}

.mdi-tennis::before {
  content: "󰶠";
}

.mdi-tennis-ball::before {
  content: "󰔇";
}

.mdi-tent::before {
  content: "󰔈";
}

.mdi-terraform::before {
  content: "󱁢";
}

.mdi-terrain::before {
  content: "󰔉";
}

.mdi-test-tube::before {
  content: "󰙨";
}

.mdi-test-tube-empty::before {
  content: "󰤑";
}

.mdi-test-tube-off::before {
  content: "󰤒";
}

.mdi-text::before {
  content: "󰦨";
}

.mdi-text-account::before {
  content: "󱕰";
}

.mdi-text-box::before {
  content: "󰈚";
}

.mdi-text-box-check::before {
  content: "󰺦";
}

.mdi-text-box-check-outline::before {
  content: "󰺧";
}

.mdi-text-box-minus::before {
  content: "󰺨";
}

.mdi-text-box-minus-outline::before {
  content: "󰺩";
}

.mdi-text-box-multiple::before {
  content: "󰪷";
}

.mdi-text-box-multiple-outline::before {
  content: "󰪸";
}

.mdi-text-box-outline::before {
  content: "󰧭";
}

.mdi-text-box-plus::before {
  content: "󰺪";
}

.mdi-text-box-plus-outline::before {
  content: "󰺫";
}

.mdi-text-box-remove::before {
  content: "󰺬";
}

.mdi-text-box-remove-outline::before {
  content: "󰺭";
}

.mdi-text-box-search::before {
  content: "󰺮";
}

.mdi-text-box-search-outline::before {
  content: "󰺯";
}

.mdi-text-long::before {
  content: "󰦪";
}

.mdi-text-recognition::before {
  content: "󱄽";
}

.mdi-text-search::before {
  content: "󱎸";
}

.mdi-text-shadow::before {
  content: "󰙩";
}

.mdi-text-short::before {
  content: "󰦩";
}

.mdi-text-to-speech::before {
  content: "󰔊";
}

.mdi-text-to-speech-off::before {
  content: "󰔋";
}

.mdi-texture::before {
  content: "󰔌";
}

.mdi-texture-box::before {
  content: "󰿦";
}

.mdi-theater::before {
  content: "󰔍";
}

.mdi-theme-light-dark::before {
  content: "󰔎";
}

.mdi-thermometer::before {
  content: "󰔏";
}

.mdi-thermometer-alert::before {
  content: "󰸁";
}

.mdi-thermometer-bluetooth::before {
  content: "󱢕";
}

.mdi-thermometer-chevron-down::before {
  content: "󰸂";
}

.mdi-thermometer-chevron-up::before {
  content: "󰸃";
}

.mdi-thermometer-high::before {
  content: "󱃂";
}

.mdi-thermometer-lines::before {
  content: "󰔐";
}

.mdi-thermometer-low::before {
  content: "󱃃";
}

.mdi-thermometer-minus::before {
  content: "󰸄";
}

.mdi-thermometer-off::before {
  content: "󱔱";
}

.mdi-thermometer-plus::before {
  content: "󰸅";
}

.mdi-thermostat::before {
  content: "󰎓";
}

.mdi-thermostat-box::before {
  content: "󰢑";
}

.mdi-thought-bubble::before {
  content: "󰟶";
}

.mdi-thought-bubble-outline::before {
  content: "󰟷";
}

.mdi-thumb-down::before {
  content: "󰔑";
}

.mdi-thumb-down-outline::before {
  content: "󰔒";
}

.mdi-thumb-up::before {
  content: "󰔓";
}

.mdi-thumb-up-outline::before {
  content: "󰔔";
}

.mdi-thumbs-up-down::before {
  content: "󰔕";
}

.mdi-thumbs-up-down-outline::before {
  content: "󱤔";
}

.mdi-ticket::before {
  content: "󰔖";
}

.mdi-ticket-account::before {
  content: "󰔗";
}

.mdi-ticket-confirmation::before {
  content: "󰔘";
}

.mdi-ticket-confirmation-outline::before {
  content: "󱎪";
}

.mdi-ticket-outline::before {
  content: "󰤓";
}

.mdi-ticket-percent::before {
  content: "󰜤";
}

.mdi-ticket-percent-outline::before {
  content: "󱐫";
}

.mdi-tie::before {
  content: "󰔙";
}

.mdi-tilde::before {
  content: "󰜥";
}

.mdi-tilde-off::before {
  content: "󱣳";
}

.mdi-timelapse::before {
  content: "󰔚";
}

.mdi-timeline::before {
  content: "󰯑";
}

.mdi-timeline-alert::before {
  content: "󰾕";
}

.mdi-timeline-alert-outline::before {
  content: "󰾘";
}

.mdi-timeline-check::before {
  content: "󱔲";
}

.mdi-timeline-check-outline::before {
  content: "󱔳";
}

.mdi-timeline-clock::before {
  content: "󱇻";
}

.mdi-timeline-clock-outline::before {
  content: "󱇼";
}

.mdi-timeline-help::before {
  content: "󰾙";
}

.mdi-timeline-help-outline::before {
  content: "󰾚";
}

.mdi-timeline-minus::before {
  content: "󱔴";
}

.mdi-timeline-minus-outline::before {
  content: "󱔵";
}

.mdi-timeline-outline::before {
  content: "󰯒";
}

.mdi-timeline-plus::before {
  content: "󰾖";
}

.mdi-timeline-plus-outline::before {
  content: "󰾗";
}

.mdi-timeline-remove::before {
  content: "󱔶";
}

.mdi-timeline-remove-outline::before {
  content: "󱔷";
}

.mdi-timeline-text::before {
  content: "󰯓";
}

.mdi-timeline-text-outline::before {
  content: "󰯔";
}

.mdi-timer::before {
  content: "󱎫";
}

.mdi-timer-10::before {
  content: "󰔜";
}

.mdi-timer-3::before {
  content: "󰔝";
}

.mdi-timer-cog::before {
  content: "󱤥";
}

.mdi-timer-cog-outline::before {
  content: "󱤦";
}

.mdi-timer-off::before {
  content: "󱎬";
}

.mdi-timer-off-outline::before {
  content: "󰔞";
}

.mdi-timer-outline::before {
  content: "󰔛";
}

.mdi-timer-sand::before {
  content: "󰔟";
}

.mdi-timer-sand-complete::before {
  content: "󱦟";
}

.mdi-timer-sand-empty::before {
  content: "󰚭";
}

.mdi-timer-sand-full::before {
  content: "󰞌";
}

.mdi-timer-sand-paused::before {
  content: "󱦠";
}

.mdi-timer-settings::before {
  content: "󱤣";
}

.mdi-timer-settings-outline::before {
  content: "󱤤";
}

.mdi-timetable::before {
  content: "󰔠";
}

.mdi-tire::before {
  content: "󱢖";
}

.mdi-toaster::before {
  content: "󱁣";
}

.mdi-toaster-off::before {
  content: "󱆷";
}

.mdi-toaster-oven::before {
  content: "󰳓";
}

.mdi-toggle-switch::before {
  content: "󰔡";
}

.mdi-toggle-switch-off::before {
  content: "󰔢";
}

.mdi-toggle-switch-off-outline::before {
  content: "󰨙";
}

.mdi-toggle-switch-outline::before {
  content: "󰨚";
}

.mdi-toilet::before {
  content: "󰦫";
}

.mdi-toolbox::before {
  content: "󰦬";
}

.mdi-toolbox-outline::before {
  content: "󰦭";
}

.mdi-tools::before {
  content: "󱁤";
}

.mdi-tooltip::before {
  content: "󰔣";
}

.mdi-tooltip-account::before {
  content: "󰀌";
}

.mdi-tooltip-cellphone::before {
  content: "󱠻";
}

.mdi-tooltip-check::before {
  content: "󱕜";
}

.mdi-tooltip-check-outline::before {
  content: "󱕝";
}

.mdi-tooltip-edit::before {
  content: "󰔤";
}

.mdi-tooltip-edit-outline::before {
  content: "󱋅";
}

.mdi-tooltip-image::before {
  content: "󰔥";
}

.mdi-tooltip-image-outline::before {
  content: "󰯕";
}

.mdi-tooltip-minus::before {
  content: "󱕞";
}

.mdi-tooltip-minus-outline::before {
  content: "󱕟";
}

.mdi-tooltip-outline::before {
  content: "󰔦";
}

.mdi-tooltip-plus::before {
  content: "󰯖";
}

.mdi-tooltip-plus-outline::before {
  content: "󰔧";
}

.mdi-tooltip-remove::before {
  content: "󱕠";
}

.mdi-tooltip-remove-outline::before {
  content: "󱕡";
}

.mdi-tooltip-text::before {
  content: "󰔨";
}

.mdi-tooltip-text-outline::before {
  content: "󰯗";
}

.mdi-tooth::before {
  content: "󰣃";
}

.mdi-tooth-outline::before {
  content: "󰔩";
}

.mdi-toothbrush::before {
  content: "󱄩";
}

.mdi-toothbrush-electric::before {
  content: "󱄬";
}

.mdi-toothbrush-paste::before {
  content: "󱄪";
}

.mdi-torch::before {
  content: "󱘆";
}

.mdi-tortoise::before {
  content: "󰴻";
}

.mdi-toslink::before {
  content: "󱊸";
}

.mdi-tournament::before {
  content: "󰦮";
}

.mdi-tow-truck::before {
  content: "󰠼";
}

.mdi-tower-beach::before {
  content: "󰚁";
}

.mdi-tower-fire::before {
  content: "󰚂";
}

.mdi-town-hall::before {
  content: "󱡵";
}

.mdi-toy-brick::before {
  content: "󱊈";
}

.mdi-toy-brick-marker::before {
  content: "󱊉";
}

.mdi-toy-brick-marker-outline::before {
  content: "󱊊";
}

.mdi-toy-brick-minus::before {
  content: "󱊋";
}

.mdi-toy-brick-minus-outline::before {
  content: "󱊌";
}

.mdi-toy-brick-outline::before {
  content: "󱊍";
}

.mdi-toy-brick-plus::before {
  content: "󱊎";
}

.mdi-toy-brick-plus-outline::before {
  content: "󱊏";
}

.mdi-toy-brick-remove::before {
  content: "󱊐";
}

.mdi-toy-brick-remove-outline::before {
  content: "󱊑";
}

.mdi-toy-brick-search::before {
  content: "󱊒";
}

.mdi-toy-brick-search-outline::before {
  content: "󱊓";
}

.mdi-track-light::before {
  content: "󰤔";
}

.mdi-trackpad::before {
  content: "󰟸";
}

.mdi-trackpad-lock::before {
  content: "󰤳";
}

.mdi-tractor::before {
  content: "󰢒";
}

.mdi-tractor-variant::before {
  content: "󱓄";
}

.mdi-trademark::before {
  content: "󰩸";
}

.mdi-traffic-cone::before {
  content: "󱍼";
}

.mdi-traffic-light::before {
  content: "󰔫";
}

.mdi-traffic-light-outline::before {
  content: "󱠪";
}

.mdi-train::before {
  content: "󰔬";
}

.mdi-train-car::before {
  content: "󰯘";
}

.mdi-train-car-passenger::before {
  content: "󱜳";
}

.mdi-train-car-passenger-door::before {
  content: "󱜴";
}

.mdi-train-car-passenger-door-open::before {
  content: "󱜵";
}

.mdi-train-car-passenger-variant::before {
  content: "󱜶";
}

.mdi-train-variant::before {
  content: "󰣄";
}

.mdi-tram::before {
  content: "󰔭";
}

.mdi-tram-side::before {
  content: "󰿧";
}

.mdi-transcribe::before {
  content: "󰔮";
}

.mdi-transcribe-close::before {
  content: "󰔯";
}

.mdi-transfer::before {
  content: "󱁥";
}

.mdi-transfer-down::before {
  content: "󰶡";
}

.mdi-transfer-left::before {
  content: "󰶢";
}

.mdi-transfer-right::before {
  content: "󰔰";
}

.mdi-transfer-up::before {
  content: "󰶣";
}

.mdi-transit-connection::before {
  content: "󰴼";
}

.mdi-transit-connection-horizontal::before {
  content: "󱕆";
}

.mdi-transit-connection-variant::before {
  content: "󰴽";
}

.mdi-transit-detour::before {
  content: "󰾋";
}

.mdi-transit-skip::before {
  content: "󱔕";
}

.mdi-transit-transfer::before {
  content: "󰚮";
}

.mdi-transition::before {
  content: "󰤕";
}

.mdi-transition-masked::before {
  content: "󰤖";
}

.mdi-translate::before {
  content: "󰗊";
}

.mdi-translate-off::before {
  content: "󰸆";
}

.mdi-transmission-tower::before {
  content: "󰴾";
}

.mdi-transmission-tower-export::before {
  content: "󱤬";
}

.mdi-transmission-tower-import::before {
  content: "󱤭";
}

.mdi-trash-can::before {
  content: "󰩹";
}

.mdi-trash-can-outline::before {
  content: "󰩺";
}

.mdi-tray::before {
  content: "󱊔";
}

.mdi-tray-alert::before {
  content: "󱊕";
}

.mdi-tray-arrow-down::before {
  content: "󰄠";
}

.mdi-tray-arrow-up::before {
  content: "󰄝";
}

.mdi-tray-full::before {
  content: "󱊖";
}

.mdi-tray-minus::before {
  content: "󱊗";
}

.mdi-tray-plus::before {
  content: "󱊘";
}

.mdi-tray-remove::before {
  content: "󱊙";
}

.mdi-treasure-chest::before {
  content: "󰜦";
}

.mdi-tree::before {
  content: "󰔱";
}

.mdi-tree-outline::before {
  content: "󰹩";
}

.mdi-trello::before {
  content: "󰔲";
}

.mdi-trending-down::before {
  content: "󰔳";
}

.mdi-trending-neutral::before {
  content: "󰔴";
}

.mdi-trending-up::before {
  content: "󰔵";
}

.mdi-triangle::before {
  content: "󰔶";
}

.mdi-triangle-outline::before {
  content: "󰔷";
}

.mdi-triangle-wave::before {
  content: "󱑼";
}

.mdi-triforce::before {
  content: "󰯙";
}

.mdi-trophy::before {
  content: "󰔸";
}

.mdi-trophy-award::before {
  content: "󰔹";
}

.mdi-trophy-broken::before {
  content: "󰶤";
}

.mdi-trophy-outline::before {
  content: "󰔺";
}

.mdi-trophy-variant::before {
  content: "󰔻";
}

.mdi-trophy-variant-outline::before {
  content: "󰔼";
}

.mdi-truck::before {
  content: "󰔽";
}

.mdi-truck-cargo-container::before {
  content: "󱣘";
}

.mdi-truck-check::before {
  content: "󰳔";
}

.mdi-truck-check-outline::before {
  content: "󱊚";
}

.mdi-truck-delivery::before {
  content: "󰔾";
}

.mdi-truck-delivery-outline::before {
  content: "󱊛";
}

.mdi-truck-fast::before {
  content: "󰞈";
}

.mdi-truck-fast-outline::before {
  content: "󱊜";
}

.mdi-truck-flatbed::before {
  content: "󱢑";
}

.mdi-truck-minus::before {
  content: "󱦮";
}

.mdi-truck-minus-outline::before {
  content: "󱦽";
}

.mdi-truck-outline::before {
  content: "󱊝";
}

.mdi-truck-plus::before {
  content: "󱦭";
}

.mdi-truck-plus-outline::before {
  content: "󱦼";
}

.mdi-truck-remove::before {
  content: "󱦯";
}

.mdi-truck-remove-outline::before {
  content: "󱦾";
}

.mdi-truck-snowflake::before {
  content: "󱦦";
}

.mdi-truck-trailer::before {
  content: "󰜧";
}

.mdi-trumpet::before {
  content: "󱂖";
}

.mdi-tshirt-crew::before {
  content: "󰩻";
}

.mdi-tshirt-crew-outline::before {
  content: "󰔿";
}

.mdi-tshirt-v::before {
  content: "󰩼";
}

.mdi-tshirt-v-outline::before {
  content: "󰕀";
}

.mdi-tumble-dryer::before {
  content: "󰤗";
}

.mdi-tumble-dryer-alert::before {
  content: "󱆺";
}

.mdi-tumble-dryer-off::before {
  content: "󱆻";
}

.mdi-tune::before {
  content: "󰘮";
}

.mdi-tune-variant::before {
  content: "󱕂";
}

.mdi-tune-vertical::before {
  content: "󰙪";
}

.mdi-tune-vertical-variant::before {
  content: "󱕃";
}

.mdi-tunnel::before {
  content: "󱠽";
}

.mdi-tunnel-outline::before {
  content: "󱠾";
}

.mdi-turkey::before {
  content: "󱜛";
}

.mdi-turnstile::before {
  content: "󰳕";
}

.mdi-turnstile-outline::before {
  content: "󰳖";
}

.mdi-turtle::before {
  content: "󰳗";
}

.mdi-twitch::before {
  content: "󰕃";
}

.mdi-twitter::before {
  content: "󰕄";
}

.mdi-two-factor-authentication::before {
  content: "󰦯";
}

.mdi-typewriter::before {
  content: "󰼭";
}

.mdi-ubisoft::before {
  content: "󰯚";
}

.mdi-ubuntu::before {
  content: "󰕈";
}

.mdi-ufo::before {
  content: "󱃄";
}

.mdi-ufo-outline::before {
  content: "󱃅";
}

.mdi-ultra-high-definition::before {
  content: "󰟹";
}

.mdi-umbraco::before {
  content: "󰕉";
}

.mdi-umbrella::before {
  content: "󰕊";
}

.mdi-umbrella-beach::before {
  content: "󱢊";
}

.mdi-umbrella-beach-outline::before {
  content: "󱢋";
}

.mdi-umbrella-closed::before {
  content: "󰦰";
}

.mdi-umbrella-closed-outline::before {
  content: "󱏢";
}

.mdi-umbrella-closed-variant::before {
  content: "󱏡";
}

.mdi-umbrella-outline::before {
  content: "󰕋";
}

.mdi-undo::before {
  content: "󰕌";
}

.mdi-undo-variant::before {
  content: "󰕍";
}

.mdi-unfold-less-horizontal::before {
  content: "󰕎";
}

.mdi-unfold-less-vertical::before {
  content: "󰝠";
}

.mdi-unfold-more-horizontal::before {
  content: "󰕏";
}

.mdi-unfold-more-vertical::before {
  content: "󰝡";
}

.mdi-ungroup::before {
  content: "󰕐";
}

.mdi-unicode::before {
  content: "󰻐";
}

.mdi-unicorn::before {
  content: "󱗂";
}

.mdi-unicorn-variant::before {
  content: "󱗃";
}

.mdi-unicycle::before {
  content: "󱗥";
}

.mdi-unity::before {
  content: "󰚯";
}

.mdi-unreal::before {
  content: "󰦱";
}

.mdi-update::before {
  content: "󰚰";
}

.mdi-upload::before {
  content: "󰕒";
}

.mdi-upload-lock::before {
  content: "󱍳";
}

.mdi-upload-lock-outline::before {
  content: "󱍴";
}

.mdi-upload-multiple::before {
  content: "󰠽";
}

.mdi-upload-network::before {
  content: "󰛶";
}

.mdi-upload-network-outline::before {
  content: "󰳘";
}

.mdi-upload-off::before {
  content: "󱃆";
}

.mdi-upload-off-outline::before {
  content: "󱃇";
}

.mdi-upload-outline::before {
  content: "󰸇";
}

.mdi-usb::before {
  content: "󰕓";
}

.mdi-usb-flash-drive::before {
  content: "󱊞";
}

.mdi-usb-flash-drive-outline::before {
  content: "󱊟";
}

.mdi-usb-port::before {
  content: "󱇰";
}

.mdi-vacuum::before {
  content: "󱦡";
}

.mdi-vacuum-outline::before {
  content: "󱦢";
}

.mdi-valve::before {
  content: "󱁦";
}

.mdi-valve-closed::before {
  content: "󱁧";
}

.mdi-valve-open::before {
  content: "󱁨";
}

.mdi-van-passenger::before {
  content: "󰟺";
}

.mdi-van-utility::before {
  content: "󰟻";
}

.mdi-vanish::before {
  content: "󰟼";
}

.mdi-vanish-quarter::before {
  content: "󱕔";
}

.mdi-vanity-light::before {
  content: "󱇡";
}

.mdi-variable::before {
  content: "󰫧";
}

.mdi-variable-box::before {
  content: "󱄑";
}

.mdi-vector-arrange-above::before {
  content: "󰕔";
}

.mdi-vector-arrange-below::before {
  content: "󰕕";
}

.mdi-vector-bezier::before {
  content: "󰫨";
}

.mdi-vector-circle::before {
  content: "󰕖";
}

.mdi-vector-circle-variant::before {
  content: "󰕗";
}

.mdi-vector-combine::before {
  content: "󰕘";
}

.mdi-vector-curve::before {
  content: "󰕙";
}

.mdi-vector-difference::before {
  content: "󰕚";
}

.mdi-vector-difference-ab::before {
  content: "󰕛";
}

.mdi-vector-difference-ba::before {
  content: "󰕜";
}

.mdi-vector-ellipse::before {
  content: "󰢓";
}

.mdi-vector-intersection::before {
  content: "󰕝";
}

.mdi-vector-line::before {
  content: "󰕞";
}

.mdi-vector-link::before {
  content: "󰿨";
}

.mdi-vector-point::before {
  content: "󰕟";
}

.mdi-vector-polygon::before {
  content: "󰕠";
}

.mdi-vector-polygon-variant::before {
  content: "󱡖";
}

.mdi-vector-polyline::before {
  content: "󰕡";
}

.mdi-vector-polyline-edit::before {
  content: "󱈥";
}

.mdi-vector-polyline-minus::before {
  content: "󱈦";
}

.mdi-vector-polyline-plus::before {
  content: "󱈧";
}

.mdi-vector-polyline-remove::before {
  content: "󱈨";
}

.mdi-vector-radius::before {
  content: "󰝊";
}

.mdi-vector-rectangle::before {
  content: "󰗆";
}

.mdi-vector-selection::before {
  content: "󰕢";
}

.mdi-vector-square::before {
  content: "󰀁";
}

.mdi-vector-square-close::before {
  content: "󱡗";
}

.mdi-vector-square-edit::before {
  content: "󱣙";
}

.mdi-vector-square-minus::before {
  content: "󱣚";
}

.mdi-vector-square-open::before {
  content: "󱡘";
}

.mdi-vector-square-plus::before {
  content: "󱣛";
}

.mdi-vector-square-remove::before {
  content: "󱣜";
}

.mdi-vector-triangle::before {
  content: "󰕣";
}

.mdi-vector-union::before {
  content: "󰕤";
}

.mdi-vhs::before {
  content: "󰨛";
}

.mdi-vibrate::before {
  content: "󰕦";
}

.mdi-vibrate-off::before {
  content: "󰳙";
}

.mdi-video::before {
  content: "󰕧";
}

.mdi-video-3d::before {
  content: "󰟽";
}

.mdi-video-3d-off::before {
  content: "󱏙";
}

.mdi-video-3d-variant::before {
  content: "󰻑";
}

.mdi-video-4k-box::before {
  content: "󰠾";
}

.mdi-video-account::before {
  content: "󰤙";
}

.mdi-video-box::before {
  content: "󰃽";
}

.mdi-video-box-off::before {
  content: "󰃾";
}

.mdi-video-check::before {
  content: "󱁩";
}

.mdi-video-check-outline::before {
  content: "󱁪";
}

.mdi-video-high-definition::before {
  content: "󱔮";
}

.mdi-video-image::before {
  content: "󰤚";
}

.mdi-video-input-antenna::before {
  content: "󰠿";
}

.mdi-video-input-component::before {
  content: "󰡀";
}

.mdi-video-input-hdmi::before {
  content: "󰡁";
}

.mdi-video-input-scart::before {
  content: "󰾌";
}

.mdi-video-input-svideo::before {
  content: "󰡂";
}

.mdi-video-marker::before {
  content: "󱦩";
}

.mdi-video-marker-outline::before {
  content: "󱦪";
}

.mdi-video-minus::before {
  content: "󰦲";
}

.mdi-video-minus-outline::before {
  content: "󰊺";
}

.mdi-video-off::before {
  content: "󰕨";
}

.mdi-video-off-outline::before {
  content: "󰯛";
}

.mdi-video-outline::before {
  content: "󰯜";
}

.mdi-video-plus::before {
  content: "󰦳";
}

.mdi-video-plus-outline::before {
  content: "󰇓";
}

.mdi-video-stabilization::before {
  content: "󰤛";
}

.mdi-video-switch::before {
  content: "󰕩";
}

.mdi-video-switch-outline::before {
  content: "󰞐";
}

.mdi-video-vintage::before {
  content: "󰨜";
}

.mdi-video-wireless::before {
  content: "󰻒";
}

.mdi-video-wireless-outline::before {
  content: "󰻓";
}

.mdi-view-agenda::before {
  content: "󰕪";
}

.mdi-view-agenda-outline::before {
  content: "󱇘";
}

.mdi-view-array::before {
  content: "󰕫";
}

.mdi-view-array-outline::before {
  content: "󱒅";
}

.mdi-view-carousel::before {
  content: "󰕬";
}

.mdi-view-carousel-outline::before {
  content: "󱒆";
}

.mdi-view-column::before {
  content: "󰕭";
}

.mdi-view-column-outline::before {
  content: "󱒇";
}

.mdi-view-comfy::before {
  content: "󰹪";
}

.mdi-view-comfy-outline::before {
  content: "󱒈";
}

.mdi-view-compact::before {
  content: "󰹫";
}

.mdi-view-compact-outline::before {
  content: "󰹬";
}

.mdi-view-dashboard::before {
  content: "󰕮";
}

.mdi-view-dashboard-edit::before {
  content: "󱥇";
}

.mdi-view-dashboard-edit-outline::before {
  content: "󱥈";
}

.mdi-view-dashboard-outline::before {
  content: "󰨝";
}

.mdi-view-dashboard-variant::before {
  content: "󰡃";
}

.mdi-view-dashboard-variant-outline::before {
  content: "󱒉";
}

.mdi-view-day::before {
  content: "󰕯";
}

.mdi-view-day-outline::before {
  content: "󱒊";
}

.mdi-view-gallery::before {
  content: "󱢈";
}

.mdi-view-gallery-outline::before {
  content: "󱢉";
}

.mdi-view-grid::before {
  content: "󰕰";
}

.mdi-view-grid-outline::before {
  content: "󱇙";
}

.mdi-view-grid-plus::before {
  content: "󰾍";
}

.mdi-view-grid-plus-outline::before {
  content: "󱇚";
}

.mdi-view-headline::before {
  content: "󰕱";
}

.mdi-view-list::before {
  content: "󰕲";
}

.mdi-view-list-outline::before {
  content: "󱒋";
}

.mdi-view-module::before {
  content: "󰕳";
}

.mdi-view-module-outline::before {
  content: "󱒌";
}

.mdi-view-parallel::before {
  content: "󰜨";
}

.mdi-view-parallel-outline::before {
  content: "󱒍";
}

.mdi-view-quilt::before {
  content: "󰕴";
}

.mdi-view-quilt-outline::before {
  content: "󱒎";
}

.mdi-view-sequential::before {
  content: "󰜩";
}

.mdi-view-sequential-outline::before {
  content: "󱒏";
}

.mdi-view-split-horizontal::before {
  content: "󰯋";
}

.mdi-view-split-vertical::before {
  content: "󰯌";
}

.mdi-view-stream::before {
  content: "󰕵";
}

.mdi-view-stream-outline::before {
  content: "󱒐";
}

.mdi-view-week::before {
  content: "󰕶";
}

.mdi-view-week-outline::before {
  content: "󱒑";
}

.mdi-vimeo::before {
  content: "󰕷";
}

.mdi-violin::before {
  content: "󰘏";
}

.mdi-virtual-reality::before {
  content: "󰢔";
}

.mdi-virus::before {
  content: "󱎶";
}

.mdi-virus-off::before {
  content: "󱣡";
}

.mdi-virus-off-outline::before {
  content: "󱣢";
}

.mdi-virus-outline::before {
  content: "󱎷";
}

.mdi-vlc::before {
  content: "󰕼";
}

.mdi-voicemail::before {
  content: "󰕽";
}

.mdi-volleyball::before {
  content: "󰦴";
}

.mdi-volume-high::before {
  content: "󰕾";
}

.mdi-volume-low::before {
  content: "󰕿";
}

.mdi-volume-medium::before {
  content: "󰖀";
}

.mdi-volume-minus::before {
  content: "󰝞";
}

.mdi-volume-mute::before {
  content: "󰝟";
}

.mdi-volume-off::before {
  content: "󰖁";
}

.mdi-volume-plus::before {
  content: "󰝝";
}

.mdi-volume-source::before {
  content: "󱄠";
}

.mdi-volume-variant-off::before {
  content: "󰸈";
}

.mdi-volume-vibrate::before {
  content: "󱄡";
}

.mdi-vote::before {
  content: "󰨟";
}

.mdi-vote-outline::before {
  content: "󰨠";
}

.mdi-vpn::before {
  content: "󰖂";
}

.mdi-vuejs::before {
  content: "󰡄";
}

.mdi-vuetify::before {
  content: "󰹭";
}

.mdi-walk::before {
  content: "󰖃";
}

.mdi-wall::before {
  content: "󰟾";
}

.mdi-wall-sconce::before {
  content: "󰤜";
}

.mdi-wall-sconce-flat::before {
  content: "󰤝";
}

.mdi-wall-sconce-flat-outline::before {
  content: "󱟉";
}

.mdi-wall-sconce-flat-variant::before {
  content: "󰐜";
}

.mdi-wall-sconce-flat-variant-outline::before {
  content: "󱟊";
}

.mdi-wall-sconce-outline::before {
  content: "󱟋";
}

.mdi-wall-sconce-round::before {
  content: "󰝈";
}

.mdi-wall-sconce-round-outline::before {
  content: "󱟌";
}

.mdi-wall-sconce-round-variant::before {
  content: "󰤞";
}

.mdi-wall-sconce-round-variant-outline::before {
  content: "󱟍";
}

.mdi-wallet::before {
  content: "󰖄";
}

.mdi-wallet-giftcard::before {
  content: "󰖅";
}

.mdi-wallet-membership::before {
  content: "󰖆";
}

.mdi-wallet-outline::before {
  content: "󰯝";
}

.mdi-wallet-plus::before {
  content: "󰾎";
}

.mdi-wallet-plus-outline::before {
  content: "󰾏";
}

.mdi-wallet-travel::before {
  content: "󰖇";
}

.mdi-wallpaper::before {
  content: "󰸉";
}

.mdi-wan::before {
  content: "󰖈";
}

.mdi-wardrobe::before {
  content: "󰾐";
}

.mdi-wardrobe-outline::before {
  content: "󰾑";
}

.mdi-warehouse::before {
  content: "󰾁";
}

.mdi-washing-machine::before {
  content: "󰜪";
}

.mdi-washing-machine-alert::before {
  content: "󱆼";
}

.mdi-washing-machine-off::before {
  content: "󱆽";
}

.mdi-watch::before {
  content: "󰖉";
}

.mdi-watch-export::before {
  content: "󰖊";
}

.mdi-watch-export-variant::before {
  content: "󰢕";
}

.mdi-watch-import::before {
  content: "󰖋";
}

.mdi-watch-import-variant::before {
  content: "󰢖";
}

.mdi-watch-variant::before {
  content: "󰢗";
}

.mdi-watch-vibrate::before {
  content: "󰚱";
}

.mdi-watch-vibrate-off::before {
  content: "󰳚";
}

.mdi-water::before {
  content: "󰖌";
}

.mdi-water-alert::before {
  content: "󱔂";
}

.mdi-water-alert-outline::before {
  content: "󱔃";
}

.mdi-water-boiler::before {
  content: "󰾒";
}

.mdi-water-boiler-alert::before {
  content: "󱆳";
}

.mdi-water-boiler-off::before {
  content: "󱆴";
}

.mdi-water-check::before {
  content: "󱔄";
}

.mdi-water-check-outline::before {
  content: "󱔅";
}

.mdi-water-circle::before {
  content: "󱠆";
}

.mdi-water-minus::before {
  content: "󱔆";
}

.mdi-water-minus-outline::before {
  content: "󱔇";
}

.mdi-water-off::before {
  content: "󰖍";
}

.mdi-water-off-outline::before {
  content: "󱔈";
}

.mdi-water-opacity::before {
  content: "󱡕";
}

.mdi-water-outline::before {
  content: "󰸊";
}

.mdi-water-percent::before {
  content: "󰖎";
}

.mdi-water-percent-alert::before {
  content: "󱔉";
}

.mdi-water-plus::before {
  content: "󱔊";
}

.mdi-water-plus-outline::before {
  content: "󱔋";
}

.mdi-water-polo::before {
  content: "󱊠";
}

.mdi-water-pump::before {
  content: "󰖏";
}

.mdi-water-pump-off::before {
  content: "󰾓";
}

.mdi-water-remove::before {
  content: "󱔌";
}

.mdi-water-remove-outline::before {
  content: "󱔍";
}

.mdi-water-sync::before {
  content: "󱟆";
}

.mdi-water-well::before {
  content: "󱁫";
}

.mdi-water-well-outline::before {
  content: "󱁬";
}

.mdi-waterfall::before {
  content: "󱡉";
}

.mdi-watering-can::before {
  content: "󱒁";
}

.mdi-watering-can-outline::before {
  content: "󱒂";
}

.mdi-watermark::before {
  content: "󰘒";
}

.mdi-wave::before {
  content: "󰼮";
}

.mdi-waveform::before {
  content: "󱑽";
}

.mdi-waves::before {
  content: "󰞍";
}

.mdi-waves-arrow-left::before {
  content: "󱡙";
}

.mdi-waves-arrow-right::before {
  content: "󱡚";
}

.mdi-waves-arrow-up::before {
  content: "󱡛";
}

.mdi-waze::before {
  content: "󰯞";
}

.mdi-weather-cloudy::before {
  content: "󰖐";
}

.mdi-weather-cloudy-alert::before {
  content: "󰼯";
}

.mdi-weather-cloudy-arrow-right::before {
  content: "󰹮";
}

.mdi-weather-cloudy-clock::before {
  content: "󱣶";
}

.mdi-weather-fog::before {
  content: "󰖑";
}

.mdi-weather-hail::before {
  content: "󰖒";
}

.mdi-weather-hazy::before {
  content: "󰼰";
}

.mdi-weather-hurricane::before {
  content: "󰢘";
}

.mdi-weather-lightning::before {
  content: "󰖓";
}

.mdi-weather-lightning-rainy::before {
  content: "󰙾";
}

.mdi-weather-night::before {
  content: "󰖔";
}

.mdi-weather-night-partly-cloudy::before {
  content: "󰼱";
}

.mdi-weather-partly-cloudy::before {
  content: "󰖕";
}

.mdi-weather-partly-lightning::before {
  content: "󰼲";
}

.mdi-weather-partly-rainy::before {
  content: "󰼳";
}

.mdi-weather-partly-snowy::before {
  content: "󰼴";
}

.mdi-weather-partly-snowy-rainy::before {
  content: "󰼵";
}

.mdi-weather-pouring::before {
  content: "󰖖";
}

.mdi-weather-rainy::before {
  content: "󰖗";
}

.mdi-weather-snowy::before {
  content: "󰖘";
}

.mdi-weather-snowy-heavy::before {
  content: "󰼶";
}

.mdi-weather-snowy-rainy::before {
  content: "󰙿";
}

.mdi-weather-sunny::before {
  content: "󰖙";
}

.mdi-weather-sunny-alert::before {
  content: "󰼷";
}

.mdi-weather-sunny-off::before {
  content: "󱓤";
}

.mdi-weather-sunset::before {
  content: "󰖚";
}

.mdi-weather-sunset-down::before {
  content: "󰖛";
}

.mdi-weather-sunset-up::before {
  content: "󰖜";
}

.mdi-weather-tornado::before {
  content: "󰼸";
}

.mdi-weather-windy::before {
  content: "󰖝";
}

.mdi-weather-windy-variant::before {
  content: "󰖞";
}

.mdi-web::before {
  content: "󰖟";
}

.mdi-web-box::before {
  content: "󰾔";
}

.mdi-web-cancel::before {
  content: "󱞐";
}

.mdi-web-check::before {
  content: "󰞉";
}

.mdi-web-clock::before {
  content: "󱉊";
}

.mdi-web-minus::before {
  content: "󱂠";
}

.mdi-web-off::before {
  content: "󰪎";
}

.mdi-web-plus::before {
  content: "󰀳";
}

.mdi-web-refresh::before {
  content: "󱞑";
}

.mdi-web-remove::before {
  content: "󰕑";
}

.mdi-web-sync::before {
  content: "󱞒";
}

.mdi-webcam::before {
  content: "󰖠";
}

.mdi-webcam-off::before {
  content: "󱜷";
}

.mdi-webhook::before {
  content: "󰘯";
}

.mdi-webpack::before {
  content: "󰜫";
}

.mdi-webrtc::before {
  content: "󱉈";
}

.mdi-wechat::before {
  content: "󰘑";
}

.mdi-weight::before {
  content: "󰖡";
}

.mdi-weight-gram::before {
  content: "󰴿";
}

.mdi-weight-kilogram::before {
  content: "󰖢";
}

.mdi-weight-lifter::before {
  content: "󱅝";
}

.mdi-weight-pound::before {
  content: "󰦵";
}

.mdi-whatsapp::before {
  content: "󰖣";
}

.mdi-wheel-barrow::before {
  content: "󱓲";
}

.mdi-wheelchair-accessibility::before {
  content: "󰖤";
}

.mdi-whistle::before {
  content: "󰦶";
}

.mdi-whistle-outline::before {
  content: "󱊼";
}

.mdi-white-balance-auto::before {
  content: "󰖥";
}

.mdi-white-balance-incandescent::before {
  content: "󰖦";
}

.mdi-white-balance-iridescent::before {
  content: "󰖧";
}

.mdi-white-balance-sunny::before {
  content: "󰖨";
}

.mdi-widgets::before {
  content: "󰜬";
}

.mdi-widgets-outline::before {
  content: "󱍕";
}

.mdi-wifi::before {
  content: "󰖩";
}

.mdi-wifi-alert::before {
  content: "󱚵";
}

.mdi-wifi-arrow-down::before {
  content: "󱚶";
}

.mdi-wifi-arrow-left::before {
  content: "󱚷";
}

.mdi-wifi-arrow-left-right::before {
  content: "󱚸";
}

.mdi-wifi-arrow-right::before {
  content: "󱚹";
}

.mdi-wifi-arrow-up::before {
  content: "󱚺";
}

.mdi-wifi-arrow-up-down::before {
  content: "󱚻";
}

.mdi-wifi-cancel::before {
  content: "󱚼";
}

.mdi-wifi-check::before {
  content: "󱚽";
}

.mdi-wifi-cog::before {
  content: "󱚾";
}

.mdi-wifi-lock::before {
  content: "󱚿";
}

.mdi-wifi-lock-open::before {
  content: "󱛀";
}

.mdi-wifi-marker::before {
  content: "󱛁";
}

.mdi-wifi-minus::before {
  content: "󱛂";
}

.mdi-wifi-off::before {
  content: "󰖪";
}

.mdi-wifi-plus::before {
  content: "󱛃";
}

.mdi-wifi-refresh::before {
  content: "󱛄";
}

.mdi-wifi-remove::before {
  content: "󱛅";
}

.mdi-wifi-settings::before {
  content: "󱛆";
}

.mdi-wifi-star::before {
  content: "󰸋";
}

.mdi-wifi-strength-1::before {
  content: "󰤟";
}

.mdi-wifi-strength-1-alert::before {
  content: "󰤠";
}

.mdi-wifi-strength-1-lock::before {
  content: "󰤡";
}

.mdi-wifi-strength-1-lock-open::before {
  content: "󱛋";
}

.mdi-wifi-strength-2::before {
  content: "󰤢";
}

.mdi-wifi-strength-2-alert::before {
  content: "󰤣";
}

.mdi-wifi-strength-2-lock::before {
  content: "󰤤";
}

.mdi-wifi-strength-2-lock-open::before {
  content: "󱛌";
}

.mdi-wifi-strength-3::before {
  content: "󰤥";
}

.mdi-wifi-strength-3-alert::before {
  content: "󰤦";
}

.mdi-wifi-strength-3-lock::before {
  content: "󰤧";
}

.mdi-wifi-strength-3-lock-open::before {
  content: "󱛍";
}

.mdi-wifi-strength-4::before {
  content: "󰤨";
}

.mdi-wifi-strength-4-alert::before {
  content: "󰤩";
}

.mdi-wifi-strength-4-lock::before {
  content: "󰤪";
}

.mdi-wifi-strength-4-lock-open::before {
  content: "󱛎";
}

.mdi-wifi-strength-alert-outline::before {
  content: "󰤫";
}

.mdi-wifi-strength-lock-open-outline::before {
  content: "󱛏";
}

.mdi-wifi-strength-lock-outline::before {
  content: "󰤬";
}

.mdi-wifi-strength-off::before {
  content: "󰤭";
}

.mdi-wifi-strength-off-outline::before {
  content: "󰤮";
}

.mdi-wifi-strength-outline::before {
  content: "󰤯";
}

.mdi-wifi-sync::before {
  content: "󱛇";
}

.mdi-wikipedia::before {
  content: "󰖬";
}

.mdi-wind-turbine::before {
  content: "󰶥";
}

.mdi-wind-turbine-alert::before {
  content: "󱦫";
}

.mdi-wind-turbine-check::before {
  content: "󱦬";
}

.mdi-window-close::before {
  content: "󰖭";
}

.mdi-window-closed::before {
  content: "󰖮";
}

.mdi-window-closed-variant::before {
  content: "󱇛";
}

.mdi-window-maximize::before {
  content: "󰖯";
}

.mdi-window-minimize::before {
  content: "󰖰";
}

.mdi-window-open::before {
  content: "󰖱";
}

.mdi-window-open-variant::before {
  content: "󱇜";
}

.mdi-window-restore::before {
  content: "󰖲";
}

.mdi-window-shutter::before {
  content: "󱄜";
}

.mdi-window-shutter-alert::before {
  content: "󱄝";
}

.mdi-window-shutter-open::before {
  content: "󱄞";
}

.mdi-windsock::before {
  content: "󱗺";
}

.mdi-wiper::before {
  content: "󰫩";
}

.mdi-wiper-wash::before {
  content: "󰶦";
}

.mdi-wiper-wash-alert::before {
  content: "󱣟";
}

.mdi-wizard-hat::before {
  content: "󱑷";
}

.mdi-wordpress::before {
  content: "󰖴";
}

.mdi-wrap::before {
  content: "󰖶";
}

.mdi-wrap-disabled::before {
  content: "󰯟";
}

.mdi-wrench::before {
  content: "󰖷";
}

.mdi-wrench-clock::before {
  content: "󱦣";
}

.mdi-wrench-outline::before {
  content: "󰯠";
}

.mdi-xamarin::before {
  content: "󰡅";
}

.mdi-xml::before {
  content: "󰗀";
}

.mdi-xmpp::before {
  content: "󰟿";
}

.mdi-yahoo::before {
  content: "󰭏";
}

.mdi-yeast::before {
  content: "󰗁";
}

.mdi-yin-yang::before {
  content: "󰚀";
}

.mdi-yoga::before {
  content: "󱅼";
}

.mdi-youtube::before {
  content: "󰗃";
}

.mdi-youtube-gaming::before {
  content: "󰡈";
}

.mdi-youtube-studio::before {
  content: "󰡇";
}

.mdi-youtube-subscription::before {
  content: "󰵀";
}

.mdi-youtube-tv::before {
  content: "󰑈";
}

.mdi-yurt::before {
  content: "󱔖";
}

.mdi-z-wave::before {
  content: "󰫪";
}

.mdi-zend::before {
  content: "󰫫";
}

.mdi-zigbee::before {
  content: "󰵁";
}

.mdi-zip-box::before {
  content: "󰗄";
}

.mdi-zip-box-outline::before {
  content: "󰿺";
}

.mdi-zip-disk::before {
  content: "󰨣";
}

.mdi-zodiac-aquarius::before {
  content: "󰩽";
}

.mdi-zodiac-aries::before {
  content: "󰩾";
}

.mdi-zodiac-cancer::before {
  content: "󰩿";
}

.mdi-zodiac-capricorn::before {
  content: "󰪀";
}

.mdi-zodiac-gemini::before {
  content: "󰪁";
}

.mdi-zodiac-leo::before {
  content: "󰪂";
}

.mdi-zodiac-libra::before {
  content: "󰪃";
}

.mdi-zodiac-pisces::before {
  content: "󰪄";
}

.mdi-zodiac-sagittarius::before {
  content: "󰪅";
}

.mdi-zodiac-scorpio::before {
  content: "󰪆";
}

.mdi-zodiac-taurus::before {
  content: "󰪇";
}

.mdi-zodiac-virgo::before {
  content: "󰪈";
}

.mdi-blank::before {
  content: "";
  visibility: hidden;
}

.mdi-18px.mdi-set, .mdi-18px.mdi:before {
  font-size: 18px;
}

.mdi-24px.mdi-set, .mdi-24px.mdi:before {
  font-size: 24px;
}

.mdi-36px.mdi-set, .mdi-36px.mdi:before {
  font-size: 36px;
}

.mdi-48px.mdi-set, .mdi-48px.mdi:before {
  font-size: 48px;
}

.mdi-dark:before {
  color: rgba(0, 0, 0, 0.54);
}

.mdi-dark.mdi-inactive:before {
  color: rgba(0, 0, 0, 0.26);
}

.mdi-light:before {
  color: white;
}

.mdi-light.mdi-inactive:before {
  color: rgba(255, 255, 255, 0.3);
}

.mdi-rotate-45 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(45deg);
            transform: scaleX(-1) rotate(45deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: scaleY(-1) rotate(45deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-45:before {
  transform: rotate(45deg);
}

.mdi-rotate-90 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(90deg);
            transform: scaleX(-1) rotate(90deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(90deg);
            -ms-transform: rotate(90deg);
            transform: scaleY(-1) rotate(90deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-90:before {
  transform: rotate(90deg);
}

.mdi-rotate-135 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(135deg);
            transform: scaleX(-1) rotate(135deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(135deg);
            -ms-transform: rotate(135deg);
            transform: scaleY(-1) rotate(135deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-135:before {
  transform: rotate(135deg);
}

.mdi-rotate-180 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(180deg);
            transform: scaleX(-1) rotate(180deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(180deg);
            -ms-transform: rotate(180deg);
            transform: scaleY(-1) rotate(180deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-180:before {
  transform: rotate(180deg);
}

.mdi-rotate-225 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(225deg);
            transform: scaleX(-1) rotate(225deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(225deg);
            -ms-transform: rotate(225deg);
            transform: scaleY(-1) rotate(225deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-225:before {
  transform: rotate(225deg);
}

.mdi-rotate-270 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(270deg);
            transform: scaleX(-1) rotate(270deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(270deg);
            -ms-transform: rotate(270deg);
            transform: scaleY(-1) rotate(270deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-270:before {
  transform: rotate(270deg);
}

.mdi-rotate-315 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(315deg);
            transform: scaleX(-1) rotate(315deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(315deg);
            -ms-transform: rotate(315deg);
            transform: scaleY(-1) rotate(315deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-315:before {
  transform: rotate(315deg);
}

.mdi-flip-h:before {
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH";
}

.mdi-flip-v:before {
  transform: scaleY(-1);
  filter: FlipV;
  -ms-filter: "FlipV";
}

.mdi-spin:before {
  animation: mdi-spin 2s infinite linear;
}
@keyframes mdi-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
/*# sourceMappingURL=materialdesignicons.css.map */
@font-face {
  font-family: "boxicons";
  font-weight: normal;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("svg");
}
.bx {
  font-family: "boxicons" !important;
  font-weight: normal;
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
  display: inline-block;
  text-transform: none;
  speak: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.bx-ul {
  margin-left: 2em;
  padding-left: 0;
  list-style: none;
}

.bx-ul > li {
  position: relative;
}

.bx-ul .bx {
  font-size: inherit;
  line-height: inherit;
  position: absolute;
  left: -2em;
  width: 2em;
  text-align: center;
}
@keyframes spin {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(359deg);
  }
}
@keyframes burst {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  90% {
    transform: scale(1.5);
    opacity: 0;
  }
}
@keyframes flashing {
  0% {
    opacity: 1;
  }
  45% {
    opacity: 0;
  }
  90% {
    opacity: 1;
  }
}
@keyframes fade-left {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  75% {
    transform: translateX(-20px);
    opacity: 0;
  }
}
@keyframes fade-right {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  75% {
    transform: translateX(20px);
    opacity: 0;
  }
}
@keyframes fade-up {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  75% {
    transform: translateY(-20px);
    opacity: 0;
  }
}
@keyframes fade-down {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  75% {
    transform: translateY(20px);
    opacity: 0;
  }
}
@keyframes tada {
  from {
    transform: scale3d(1, 1, 1);
  }
  10%, 20% {
    transform: scale3d(0.95, 0.95, 0.95) rotate3d(0, 0, 1, -10deg);
  }
  30%, 50%, 70%, 90% {
    transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);
  }
  40%, 60%, 80% {
    transform: rotate3d(0, 0, 1, -10deg);
  }
  to {
    transform: scale3d(1, 1, 1);
  }
}
.bx-spin {
  animation: spin 2s linear infinite;
}

.bx-spin-hover:hover {
  animation: spin 2s linear infinite;
}

.bx-tada {
  animation: tada 1.5s ease infinite;
}

.bx-tada-hover:hover {
  animation: tada 1.5s ease infinite;
}

.bx-flashing {
  animation: flashing 1.5s infinite linear;
}

.bx-flashing-hover:hover {
  animation: flashing 1.5s infinite linear;
}

.bx-burst {
  animation: burst 1.5s infinite linear;
}

.bx-burst-hover:hover {
  animation: burst 1.5s infinite linear;
}

.bx-fade-up {
  animation: fade-up 1.5s infinite linear;
}

.bx-fade-up-hover:hover {
  animation: fade-up 1.5s infinite linear;
}

.bx-fade-down {
  animation: fade-down 1.5s infinite linear;
}

.bx-fade-down-hover:hover {
  animation: fade-down 1.5s infinite linear;
}

.bx-fade-left {
  animation: fade-left 1.5s infinite linear;
}

.bx-fade-left-hover:hover {
  animation: fade-left 1.5s infinite linear;
}

.bx-fade-right {
  animation: fade-right 1.5s infinite linear;
}

.bx-fade-right-hover:hover {
  animation: fade-right 1.5s infinite linear;
}

.bx-xs {
  font-size: 1rem !important;
}

.bx-sm {
  font-size: 1.55rem !important;
}

.bx-md {
  font-size: 2.25rem !important;
}

.bx-lg {
  font-size: 3rem !important;
}

.bx-fw {
  font-size: 1.2857142857em;
  line-height: 0.8em;
  width: 1.2857142857em;
  height: 0.8em;
  margin-top: -0.2em !important;
  vertical-align: middle;
}

.bx-pull-left {
  float: left;
  margin-right: 0.3em !important;
}

.bx-pull-right {
  float: right;
  margin-left: 0.3em !important;
}

.bx-rotate-90 {
  transform: rotate(90deg);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
}

.bx-rotate-180 {
  transform: rotate(180deg);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
}

.bx-rotate-270 {
  transform: rotate(270deg);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
}

.bx-flip-horizontal {
  transform: scaleX(-1);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
}

.bx-flip-vertical {
  transform: scaleY(-1);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
}

.bx-border {
  padding: 0.25em;
  border: 0.07em solid rgba(0, 0, 0, 0.1);
  border-radius: 0.25em;
}

.bx-border-circle {
  padding: 0.25em;
  border: 0.07em solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
}

.bxl-meta:before {
  content: "";
}

.bx-lemon:before {
  content: "";
}

.bxs-lemon:before {
  content: "";
}

.bx-cricket-ball:before {
  content: "";
}

.bx-baguette:before {
  content: "";
}

.bx-bowl-hot:before {
  content: "";
}

.bx-bowl-rice:before {
  content: "";
}

.bx-cable-car:before {
  content: "";
}

.bx-candles:before {
  content: "";
}

.bx-circle-half:before {
  content: "";
}

.bx-circle-quarter:before {
  content: "";
}

.bx-circle-three-quarter:before {
  content: "";
}

.bx-cross:before {
  content: "";
}

.bx-fork:before {
  content: "";
}

.bx-knife:before {
  content: "";
}

.bx-money-withdraw:before {
  content: "";
}

.bx-popsicle:before {
  content: "";
}

.bx-scatter-chart:before {
  content: "";
}

.bxs-baguette:before {
  content: "";
}

.bxs-bowl-hot:before {
  content: "";
}

.bxs-bowl-rice:before {
  content: "";
}

.bxs-cable-car:before {
  content: "";
}

.bxs-circle-half:before {
  content: "";
}

.bxs-circle-quarter:before {
  content: "";
}

.bxs-circle-three-quarter:before {
  content: "";
}

.bxs-cricket-ball:before {
  content: "";
}

.bxs-invader:before {
  content: "";
}

.bx-male-female:before {
  content: "";
}

.bxs-popsicle:before {
  content: "";
}

.bxs-tree-alt:before {
  content: "";
}

.bxl-venmo:before {
  content: "";
}

.bxl-upwork:before {
  content: "";
}

.bxl-netlify:before {
  content: "";
}

.bxl-java:before {
  content: "";
}

.bxl-heroku:before {
  content: "";
}

.bxl-go-lang:before {
  content: "";
}

.bxl-gmail:before {
  content: "";
}

.bxl-flask:before {
  content: "";
}

.bxl-99designs:before {
  content: "";
}

.bxl-500px:before {
  content: "";
}

.bxl-adobe:before {
  content: "";
}

.bxl-airbnb:before {
  content: "";
}

.bxl-algolia:before {
  content: "";
}

.bxl-amazon:before {
  content: "";
}

.bxl-android:before {
  content: "";
}

.bxl-angular:before {
  content: "";
}

.bxl-apple:before {
  content: "";
}

.bxl-audible:before {
  content: "";
}

.bxl-aws:before {
  content: "";
}

.bxl-baidu:before {
  content: "";
}

.bxl-behance:before {
  content: "";
}

.bxl-bing:before {
  content: "";
}

.bxl-bitcoin:before {
  content: "";
}

.bxl-blender:before {
  content: "";
}

.bxl-blogger:before {
  content: "";
}

.bxl-bootstrap:before {
  content: "";
}

.bxl-chrome:before {
  content: "";
}

.bxl-codepen:before {
  content: "";
}

.bxl-c-plus-plus:before {
  content: "";
}

.bxl-creative-commons:before {
  content: "";
}

.bxl-css3:before {
  content: "";
}

.bxl-dailymotion:before {
  content: "";
}

.bxl-deviantart:before {
  content: "";
}

.bxl-dev-to:before {
  content: "";
}

.bxl-digg:before {
  content: "";
}

.bxl-digitalocean:before {
  content: "";
}

.bxl-discord:before {
  content: "";
}

.bxl-discord-alt:before {
  content: "";
}

.bxl-discourse:before {
  content: "";
}

.bxl-django:before {
  content: "";
}

.bxl-docker:before {
  content: "";
}

.bxl-dribbble:before {
  content: "";
}

.bxl-dropbox:before {
  content: "";
}

.bxl-drupal:before {
  content: "";
}

.bxl-ebay:before {
  content: "";
}

.bxl-edge:before {
  content: "";
}

.bxl-etsy:before {
  content: "";
}

.bxl-facebook:before {
  content: "";
}

.bxl-facebook-circle:before {
  content: "";
}

.bxl-facebook-square:before {
  content: "";
}

.bxl-figma:before {
  content: "";
}

.bxl-firebase:before {
  content: "";
}

.bxl-firefox:before {
  content: "";
}

.bxl-flickr:before {
  content: "";
}

.bxl-flickr-square:before {
  content: "";
}

.bxl-flutter:before {
  content: "";
}

.bxl-foursquare:before {
  content: "";
}

.bxl-git:before {
  content: "";
}

.bxl-github:before {
  content: "";
}

.bxl-gitlab:before {
  content: "";
}

.bxl-google:before {
  content: "";
}

.bxl-google-cloud:before {
  content: "";
}

.bxl-google-plus:before {
  content: "";
}

.bxl-google-plus-circle:before {
  content: "";
}

.bxl-html5:before {
  content: "";
}

.bxl-imdb:before {
  content: "";
}

.bxl-instagram:before {
  content: "";
}

.bxl-instagram-alt:before {
  content: "";
}

.bxl-internet-explorer:before {
  content: "";
}

.bxl-invision:before {
  content: "";
}

.bxl-javascript:before {
  content: "";
}

.bxl-joomla:before {
  content: "";
}

.bxl-jquery:before {
  content: "";
}

.bxl-jsfiddle:before {
  content: "";
}

.bxl-kickstarter:before {
  content: "";
}

.bxl-kubernetes:before {
  content: "";
}

.bxl-less:before {
  content: "";
}

.bxl-linkedin:before {
  content: "";
}

.bxl-linkedin-square:before {
  content: "";
}

.bxl-magento:before {
  content: "";
}

.bxl-mailchimp:before {
  content: "";
}

.bxl-markdown:before {
  content: "";
}

.bxl-mastercard:before {
  content: "";
}

.bxl-mastodon:before {
  content: "";
}

.bxl-medium:before {
  content: "";
}

.bxl-medium-old:before {
  content: "";
}

.bxl-medium-square:before {
  content: "";
}

.bxl-messenger:before {
  content: "";
}

.bxl-microsoft:before {
  content: "";
}

.bxl-microsoft-teams:before {
  content: "";
}

.bxl-nodejs:before {
  content: "";
}

.bxl-ok-ru:before {
  content: "";
}

.bxl-opera:before {
  content: "";
}

.bxl-patreon:before {
  content: "";
}

.bxl-paypal:before {
  content: "";
}

.bxl-periscope:before {
  content: "";
}

.bxl-php:before {
  content: "";
}

.bxl-pinterest:before {
  content: "";
}

.bxl-pinterest-alt:before {
  content: "";
}

.bxl-play-store:before {
  content: "";
}

.bxl-pocket:before {
  content: "";
}

.bxl-product-hunt:before {
  content: "";
}

.bxl-python:before {
  content: "";
}

.bxl-quora:before {
  content: "";
}

.bxl-react:before {
  content: "";
}

.bxl-redbubble:before {
  content: "";
}

.bxl-reddit:before {
  content: "";
}

.bxl-redux:before {
  content: "";
}

.bxl-sass:before {
  content: "";
}

.bxl-shopify:before {
  content: "";
}

.bxl-sketch:before {
  content: "";
}

.bxl-skype:before {
  content: "";
}

.bxl-slack:before {
  content: "";
}

.bxl-slack-old:before {
  content: "";
}

.bxl-snapchat:before {
  content: "";
}

.bxl-soundcloud:before {
  content: "";
}

.bxl-spotify:before {
  content: "";
}

.bxl-spring-boot:before {
  content: "";
}

.bxl-squarespace:before {
  content: "";
}

.bxl-stack-overflow:before {
  content: "";
}

.bxl-steam:before {
  content: "";
}

.bxl-stripe:before {
  content: "";
}

.bxl-tailwind-css:before {
  content: "";
}

.bxl-telegram:before {
  content: "";
}

.bxl-tiktok:before {
  content: "";
}

.bxl-trello:before {
  content: "";
}

.bxl-trip-advisor:before {
  content: "";
}

.bxl-tumblr:before {
  content: "";
}

.bxl-tux:before {
  content: "";
}

.bxl-twitch:before {
  content: "";
}

.bxl-twitter:before {
  content: "";
}

.bxl-unity:before {
  content: "";
}

.bxl-unsplash:before {
  content: "";
}

.bxl-vimeo:before {
  content: "";
}

.bxl-visa:before {
  content: "";
}

.bxl-visual-studio:before {
  content: "";
}

.bxl-vk:before {
  content: "";
}

.bxl-vuejs:before {
  content: "";
}

.bxl-whatsapp:before {
  content: "";
}

.bxl-whatsapp-square:before {
  content: "";
}

.bxl-wikipedia:before {
  content: "";
}

.bxl-windows:before {
  content: "";
}

.bxl-wix:before {
  content: "";
}

.bxl-wordpress:before {
  content: "";
}

.bxl-yahoo:before {
  content: "";
}

.bxl-yelp:before {
  content: "";
}

.bxl-youtube:before {
  content: "";
}

.bxl-zoom:before {
  content: "";
}

.bx-collapse-alt:before {
  content: "";
}

.bx-collapse-horizontal:before {
  content: "";
}

.bx-collapse-vertical:before {
  content: "";
}

.bx-expand-horizontal:before {
  content: "";
}

.bx-expand-vertical:before {
  content: "";
}

.bx-injection:before {
  content: "";
}

.bx-leaf:before {
  content: "";
}

.bx-math:before {
  content: "";
}

.bx-party:before {
  content: "";
}

.bx-abacus:before {
  content: "";
}

.bx-accessibility:before {
  content: "";
}

.bx-add-to-queue:before {
  content: "";
}

.bx-adjust:before {
  content: "";
}

.bx-alarm:before {
  content: "";
}

.bx-alarm-add:before {
  content: "";
}

.bx-alarm-exclamation:before {
  content: "";
}

.bx-alarm-off:before {
  content: "";
}

.bx-alarm-snooze:before {
  content: "";
}

.bx-album:before {
  content: "";
}

.bx-align-justify:before {
  content: "";
}

.bx-align-left:before {
  content: "";
}

.bx-align-middle:before {
  content: "";
}

.bx-align-right:before {
  content: "";
}

.bx-analyse:before {
  content: "";
}

.bx-anchor:before {
  content: "";
}

.bx-angry:before {
  content: "";
}

.bx-aperture:before {
  content: "";
}

.bx-arch:before {
  content: "";
}

.bx-archive:before {
  content: "";
}

.bx-archive-in:before {
  content: "";
}

.bx-archive-out:before {
  content: "";
}

.bx-area:before {
  content: "";
}

.bx-arrow-back:before {
  content: "";
}

.bx-arrow-from-bottom:before {
  content: "";
}

.bx-arrow-from-left:before {
  content: "";
}

.bx-arrow-from-right:before {
  content: "";
}

.bx-arrow-from-top:before {
  content: "";
}

.bx-arrow-to-bottom:before {
  content: "";
}

.bx-arrow-to-left:before {
  content: "";
}

.bx-arrow-to-right:before {
  content: "";
}

.bx-arrow-to-top:before {
  content: "";
}

.bx-at:before {
  content: "";
}

.bx-atom:before {
  content: "";
}

.bx-award:before {
  content: "";
}

.bx-badge:before {
  content: "";
}

.bx-badge-check:before {
  content: "";
}

.bx-ball:before {
  content: "";
}

.bx-band-aid:before {
  content: "";
}

.bx-bar-chart:before {
  content: "";
}

.bx-bar-chart-alt:before {
  content: "";
}

.bx-bar-chart-alt-2:before {
  content: "";
}

.bx-bar-chart-square:before {
  content: "";
}

.bx-barcode:before {
  content: "";
}

.bx-barcode-reader:before {
  content: "";
}

.bx-baseball:before {
  content: "";
}

.bx-basket:before {
  content: "";
}

.bx-basketball:before {
  content: "";
}

.bx-bath:before {
  content: "";
}

.bx-battery:before {
  content: "";
}

.bx-bed:before {
  content: "";
}

.bx-been-here:before {
  content: "";
}

.bx-beer:before {
  content: "";
}

.bx-bell:before {
  content: "";
}

.bx-bell-minus:before {
  content: "";
}

.bx-bell-off:before {
  content: "";
}

.bx-bell-plus:before {
  content: "";
}

.bx-bible:before {
  content: "";
}

.bx-bitcoin:before {
  content: "";
}

.bx-blanket:before {
  content: "";
}

.bx-block:before {
  content: "";
}

.bx-bluetooth:before {
  content: "";
}

.bx-body:before {
  content: "";
}

.bx-bold:before {
  content: "";
}

.bx-bolt-circle:before {
  content: "";
}

.bx-bomb:before {
  content: "";
}

.bx-bone:before {
  content: "";
}

.bx-bong:before {
  content: "";
}

.bx-book:before {
  content: "";
}

.bx-book-add:before {
  content: "";
}

.bx-book-alt:before {
  content: "";
}

.bx-book-bookmark:before {
  content: "";
}

.bx-book-content:before {
  content: "";
}

.bx-book-heart:before {
  content: "";
}

.bx-bookmark:before {
  content: "";
}

.bx-bookmark-alt:before {
  content: "";
}

.bx-bookmark-alt-minus:before {
  content: "";
}

.bx-bookmark-alt-plus:before {
  content: "";
}

.bx-bookmark-heart:before {
  content: "";
}

.bx-bookmark-minus:before {
  content: "";
}

.bx-bookmark-plus:before {
  content: "";
}

.bx-bookmarks:before {
  content: "";
}

.bx-book-open:before {
  content: "";
}

.bx-book-reader:before {
  content: "";
}

.bx-border-all:before {
  content: "";
}

.bx-border-bottom:before {
  content: "";
}

.bx-border-inner:before {
  content: "";
}

.bx-border-left:before {
  content: "";
}

.bx-border-none:before {
  content: "";
}

.bx-border-outer:before {
  content: "";
}

.bx-border-radius:before {
  content: "";
}

.bx-border-right:before {
  content: "";
}

.bx-border-top:before {
  content: "";
}

.bx-bot:before {
  content: "";
}

.bx-bowling-ball:before {
  content: "";
}

.bx-box:before {
  content: "";
}

.bx-bracket:before {
  content: "";
}

.bx-braille:before {
  content: "";
}

.bx-brain:before {
  content: "";
}

.bx-briefcase:before {
  content: "";
}

.bx-briefcase-alt:before {
  content: "";
}

.bx-briefcase-alt-2:before {
  content: "";
}

.bx-brightness:before {
  content: "";
}

.bx-brightness-half:before {
  content: "";
}

.bx-broadcast:before {
  content: "";
}

.bx-brush:before {
  content: "";
}

.bx-brush-alt:before {
  content: "";
}

.bx-bug:before {
  content: "";
}

.bx-bug-alt:before {
  content: "";
}

.bx-building:before {
  content: "";
}

.bx-building-house:before {
  content: "";
}

.bx-buildings:before {
  content: "";
}

.bx-bulb:before {
  content: "";
}

.bx-bullseye:before {
  content: "";
}

.bx-buoy:before {
  content: "";
}

.bx-bus:before {
  content: "";
}

.bx-bus-school:before {
  content: "";
}

.bx-cabinet:before {
  content: "";
}

.bx-cake:before {
  content: "";
}

.bx-calculator:before {
  content: "";
}

.bx-calendar:before {
  content: "";
}

.bx-calendar-alt:before {
  content: "";
}

.bx-calendar-check:before {
  content: "";
}

.bx-calendar-edit:before {
  content: "";
}

.bx-calendar-event:before {
  content: "";
}

.bx-calendar-exclamation:before {
  content: "";
}

.bx-calendar-heart:before {
  content: "";
}

.bx-calendar-minus:before {
  content: "";
}

.bx-calendar-plus:before {
  content: "";
}

.bx-calendar-star:before {
  content: "";
}

.bx-calendar-week:before {
  content: "";
}

.bx-calendar-x:before {
  content: "";
}

.bx-camera:before {
  content: "";
}

.bx-camera-home:before {
  content: "";
}

.bx-camera-movie:before {
  content: "";
}

.bx-camera-off:before {
  content: "";
}

.bx-capsule:before {
  content: "";
}

.bx-captions:before {
  content: "";
}

.bx-car:before {
  content: "";
}

.bx-card:before {
  content: "";
}

.bx-caret-down:before {
  content: "";
}

.bx-caret-down-circle:before {
  content: "";
}

.bx-caret-down-square:before {
  content: "";
}

.bx-caret-left:before {
  content: "";
}

.bx-caret-left-circle:before {
  content: "";
}

.bx-caret-left-square:before {
  content: "";
}

.bx-caret-right:before {
  content: "";
}

.bx-caret-right-circle:before {
  content: "";
}

.bx-caret-right-square:before {
  content: "";
}

.bx-caret-up:before {
  content: "";
}

.bx-caret-up-circle:before {
  content: "";
}

.bx-caret-up-square:before {
  content: "";
}

.bx-carousel:before {
  content: "";
}

.bx-cart:before {
  content: "";
}

.bx-cart-alt:before {
  content: "";
}

.bx-cast:before {
  content: "";
}

.bx-category:before {
  content: "";
}

.bx-category-alt:before {
  content: "";
}

.bx-cctv:before {
  content: "";
}

.bx-certification:before {
  content: "";
}

.bx-chair:before {
  content: "";
}

.bx-chalkboard:before {
  content: "";
}

.bx-chart:before {
  content: "";
}

.bx-chat:before {
  content: "";
}

.bx-check:before {
  content: "";
}

.bx-checkbox:before {
  content: "";
}

.bx-checkbox-checked:before {
  content: "";
}

.bx-checkbox-minus:before {
  content: "";
}

.bx-checkbox-square:before {
  content: "";
}

.bx-check-circle:before {
  content: "";
}

.bx-check-double:before {
  content: "";
}

.bx-check-shield:before {
  content: "";
}

.bx-check-square:before {
  content: "";
}

.bx-chevron-down:before {
  content: "";
}

.bx-chevron-down-circle:before {
  content: "";
}

.bx-chevron-down-square:before {
  content: "";
}

.bx-chevron-left:before {
  content: "";
}

.bx-chevron-left-circle:before {
  content: "";
}

.bx-chevron-left-square:before {
  content: "";
}

.bx-chevron-right:before {
  content: "";
}

.bx-chevron-right-circle:before {
  content: "";
}

.bx-chevron-right-square:before {
  content: "";
}

.bx-chevrons-down:before {
  content: "";
}

.bx-chevrons-left:before {
  content: "";
}

.bx-chevrons-right:before {
  content: "";
}

.bx-chevrons-up:before {
  content: "";
}

.bx-chevron-up:before {
  content: "";
}

.bx-chevron-up-circle:before {
  content: "";
}

.bx-chevron-up-square:before {
  content: "";
}

.bx-chip:before {
  content: "";
}

.bx-church:before {
  content: "";
}

.bx-circle:before {
  content: "";
}

.bx-clinic:before {
  content: "";
}

.bx-clipboard:before {
  content: "";
}

.bx-closet:before {
  content: "";
}

.bx-cloud:before {
  content: "";
}

.bx-cloud-download:before {
  content: "";
}

.bx-cloud-drizzle:before {
  content: "";
}

.bx-cloud-lightning:before {
  content: "";
}

.bx-cloud-light-rain:before {
  content: "";
}

.bx-cloud-rain:before {
  content: "";
}

.bx-cloud-snow:before {
  content: "";
}

.bx-cloud-upload:before {
  content: "";
}

.bx-code:before {
  content: "";
}

.bx-code-alt:before {
  content: "";
}

.bx-code-block:before {
  content: "";
}

.bx-code-curly:before {
  content: "";
}

.bx-coffee:before {
  content: "";
}

.bx-coffee-togo:before {
  content: "";
}

.bx-cog:before {
  content: "";
}

.bx-coin:before {
  content: "";
}

.bx-coin-stack:before {
  content: "";
}

.bx-collapse:before {
  content: "";
}

.bx-collection:before {
  content: "";
}

.bx-color-fill:before {
  content: "";
}

.bx-columns:before {
  content: "";
}

.bx-command:before {
  content: "";
}

.bx-comment:before {
  content: "";
}

.bx-comment-add:before {
  content: "";
}

.bx-comment-check:before {
  content: "";
}

.bx-comment-detail:before {
  content: "";
}

.bx-comment-dots:before {
  content: "";
}

.bx-comment-edit:before {
  content: "";
}

.bx-comment-error:before {
  content: "";
}

.bx-comment-minus:before {
  content: "";
}

.bx-comment-x:before {
  content: "";
}

.bx-compass:before {
  content: "";
}

.bx-confused:before {
  content: "";
}

.bx-conversation:before {
  content: "";
}

.bx-cookie:before {
  content: "";
}

.bx-cool:before {
  content: "";
}

.bx-copy:before {
  content: "";
}

.bx-copy-alt:before {
  content: "";
}

.bx-copyright:before {
  content: "";
}

.bx-credit-card:before {
  content: "";
}

.bx-credit-card-alt:before {
  content: "";
}

.bx-credit-card-front:before {
  content: "";
}

.bx-crop:before {
  content: "";
}

.bx-crosshair:before {
  content: "";
}

.bx-crown:before {
  content: "";
}

.bx-cube:before {
  content: "";
}

.bx-cube-alt:before {
  content: "";
}

.bx-cuboid:before {
  content: "";
}

.bx-current-location:before {
  content: "";
}

.bx-customize:before {
  content: "";
}

.bx-cut:before {
  content: "";
}

.bx-cycling:before {
  content: "";
}

.bx-cylinder:before {
  content: "";
}

.bx-data:before {
  content: "";
}

.bx-desktop:before {
  content: "";
}

.bx-detail:before {
  content: "";
}

.bx-devices:before {
  content: "";
}

.bx-dialpad:before {
  content: "";
}

.bx-dialpad-alt:before {
  content: "";
}

.bx-diamond:before {
  content: "";
}

.bx-dice-1:before {
  content: "";
}

.bx-dice-2:before {
  content: "";
}

.bx-dice-3:before {
  content: "";
}

.bx-dice-4:before {
  content: "";
}

.bx-dice-5:before {
  content: "";
}

.bx-dice-6:before {
  content: "";
}

.bx-directions:before {
  content: "";
}

.bx-disc:before {
  content: "";
}

.bx-dish:before {
  content: "";
}

.bx-dislike:before {
  content: "";
}

.bx-dizzy:before {
  content: "";
}

.bx-dna:before {
  content: "";
}

.bx-dock-bottom:before {
  content: "";
}

.bx-dock-left:before {
  content: "";
}

.bx-dock-right:before {
  content: "";
}

.bx-dock-top:before {
  content: "";
}

.bx-dollar:before {
  content: "";
}

.bx-dollar-circle:before {
  content: "";
}

.bx-donate-blood:before {
  content: "";
}

.bx-donate-heart:before {
  content: "";
}

.bx-door-open:before {
  content: "";
}

.bx-dots-horizontal:before {
  content: "";
}

.bx-dots-horizontal-rounded:before {
  content: "";
}

.bx-dots-vertical:before {
  content: "";
}

.bx-dots-vertical-rounded:before {
  content: "";
}

.bx-doughnut-chart:before {
  content: "";
}

.bx-down-arrow:before {
  content: "";
}

.bx-down-arrow-alt:before {
  content: "";
}

.bx-down-arrow-circle:before {
  content: "";
}

.bx-download:before {
  content: "";
}

.bx-downvote:before {
  content: "";
}

.bx-drink:before {
  content: "";
}

.bx-droplet:before {
  content: "";
}

.bx-dumbbell:before {
  content: "";
}

.bx-duplicate:before {
  content: "";
}

.bx-edit:before {
  content: "";
}

.bx-edit-alt:before {
  content: "";
}

.bx-envelope:before {
  content: "";
}

.bx-envelope-open:before {
  content: "";
}

.bx-equalizer:before {
  content: "";
}

.bx-eraser:before {
  content: "";
}

.bx-error:before {
  content: "";
}

.bx-error-alt:before {
  content: "";
}

.bx-error-circle:before {
  content: "";
}

.bx-euro:before {
  content: "";
}

.bx-exclude:before {
  content: "";
}

.bx-exit:before {
  content: "";
}

.bx-exit-fullscreen:before {
  content: "";
}

.bx-expand:before {
  content: "";
}

.bx-expand-alt:before {
  content: "";
}

.bx-export:before {
  content: "";
}

.bx-extension:before {
  content: "";
}

.bx-face:before {
  content: "";
}

.bx-fast-forward:before {
  content: "";
}

.bx-fast-forward-circle:before {
  content: "";
}

.bx-female:before {
  content: "";
}

.bx-female-sign:before {
  content: "";
}

.bx-file:before {
  content: "";
}

.bx-file-blank:before {
  content: "";
}

.bx-file-find:before {
  content: "";
}

.bx-film:before {
  content: "";
}

.bx-filter:before {
  content: "";
}

.bx-filter-alt:before {
  content: "";
}

.bx-fingerprint:before {
  content: "";
}

.bx-first-aid:before {
  content: "";
}

.bx-first-page:before {
  content: "";
}

.bx-flag:before {
  content: "";
}

.bx-folder:before {
  content: "";
}

.bx-folder-minus:before {
  content: "";
}

.bx-folder-open:before {
  content: "";
}

.bx-folder-plus:before {
  content: "";
}

.bx-font:before {
  content: "";
}

.bx-font-color:before {
  content: "";
}

.bx-font-family:before {
  content: "";
}

.bx-font-size:before {
  content: "";
}

.bx-food-menu:before {
  content: "";
}

.bx-food-tag:before {
  content: "";
}

.bx-football:before {
  content: "";
}

.bx-fridge:before {
  content: "";
}

.bx-fullscreen:before {
  content: "";
}

.bx-game:before {
  content: "";
}

.bx-gas-pump:before {
  content: "";
}

.bx-ghost:before {
  content: "";
}

.bx-gift:before {
  content: "";
}

.bx-git-branch:before {
  content: "";
}

.bx-git-commit:before {
  content: "";
}

.bx-git-compare:before {
  content: "";
}

.bx-git-merge:before {
  content: "";
}

.bx-git-pull-request:before {
  content: "";
}

.bx-git-repo-forked:before {
  content: "";
}

.bx-glasses:before {
  content: "";
}

.bx-glasses-alt:before {
  content: "";
}

.bx-globe:before {
  content: "";
}

.bx-globe-alt:before {
  content: "";
}

.bx-grid:before {
  content: "";
}

.bx-grid-alt:before {
  content: "";
}

.bx-grid-horizontal:before {
  content: "";
}

.bx-grid-small:before {
  content: "";
}

.bx-grid-vertical:before {
  content: "";
}

.bx-group:before {
  content: "";
}

.bx-handicap:before {
  content: "";
}

.bx-happy:before {
  content: "";
}

.bx-happy-alt:before {
  content: "";
}

.bx-happy-beaming:before {
  content: "";
}

.bx-happy-heart-eyes:before {
  content: "";
}

.bx-hash:before {
  content: "";
}

.bx-hdd:before {
  content: "";
}

.bx-heading:before {
  content: "";
}

.bx-headphone:before {
  content: "";
}

.bx-health:before {
  content: "";
}

.bx-heart:before {
  content: "";
}

.bx-heart-circle:before {
  content: "";
}

.bx-heart-square:before {
  content: "";
}

.bx-help-circle:before {
  content: "";
}

.bx-hide:before {
  content: "";
}

.bx-highlight:before {
  content: "";
}

.bx-history:before {
  content: "";
}

.bx-hive:before {
  content: "";
}

.bx-home:before {
  content: "";
}

.bx-home-alt:before {
  content: "";
}

.bx-home-circle:before {
  content: "";
}

.bx-home-heart:before {
  content: "";
}

.bx-home-smile:before {
  content: "";
}

.bx-horizontal-center:before {
  content: "";
}

.bx-hotel:before {
  content: "";
}

.bx-hourglass:before {
  content: "";
}

.bx-id-card:before {
  content: "";
}

.bx-image:before {
  content: "";
}

.bx-image-add:before {
  content: "";
}

.bx-image-alt:before {
  content: "";
}

.bx-images:before {
  content: "";
}

.bx-import:before {
  content: "";
}

.bx-infinite:before {
  content: "";
}

.bx-info-circle:before {
  content: "";
}

.bx-info-square:before {
  content: "";
}

.bx-intersect:before {
  content: "";
}

.bx-italic:before {
  content: "";
}

.bx-joystick:before {
  content: "";
}

.bx-joystick-alt:before {
  content: "";
}

.bx-joystick-button:before {
  content: "";
}

.bx-key:before {
  content: "";
}

.bx-label:before {
  content: "";
}

.bx-landscape:before {
  content: "";
}

.bx-laptop:before {
  content: "";
}

.bx-last-page:before {
  content: "";
}

.bx-laugh:before {
  content: "";
}

.bx-layer:before {
  content: "";
}

.bx-layer-minus:before {
  content: "";
}

.bx-layer-plus:before {
  content: "";
}

.bx-layout:before {
  content: "";
}

.bx-left-arrow:before {
  content: "";
}

.bx-left-arrow-alt:before {
  content: "";
}

.bx-left-arrow-circle:before {
  content: "";
}

.bx-left-down-arrow-circle:before {
  content: "";
}

.bx-left-indent:before {
  content: "";
}

.bx-left-top-arrow-circle:before {
  content: "";
}

.bx-library:before {
  content: "";
}

.bx-like:before {
  content: "";
}

.bx-line-chart:before {
  content: "";
}

.bx-line-chart-down:before {
  content: "";
}

.bx-link:before {
  content: "";
}

.bx-link-alt:before {
  content: "";
}

.bx-link-external:before {
  content: "";
}

.bx-lira:before {
  content: "";
}

.bx-list-check:before {
  content: "";
}

.bx-list-minus:before {
  content: "";
}

.bx-list-ol:before {
  content: "";
}

.bx-list-plus:before {
  content: "";
}

.bx-list-ul:before {
  content: "";
}

.bx-loader:before {
  content: "";
}

.bx-loader-alt:before {
  content: "";
}

.bx-loader-circle:before {
  content: "";
}

.bx-location-plus:before {
  content: "";
}

.bx-lock:before {
  content: "";
}

.bx-lock-alt:before {
  content: "";
}

.bx-lock-open:before {
  content: "";
}

.bx-lock-open-alt:before {
  content: "";
}

.bx-log-in:before {
  content: "";
}

.bx-log-in-circle:before {
  content: "";
}

.bx-log-out:before {
  content: "";
}

.bx-log-out-circle:before {
  content: "";
}

.bx-low-vision:before {
  content: "";
}

.bx-magnet:before {
  content: "";
}

.bx-mail-send:before {
  content: "";
}

.bx-male:before {
  content: "";
}

.bx-male-sign:before {
  content: "";
}

.bx-map:before {
  content: "";
}

.bx-map-alt:before {
  content: "";
}

.bx-map-pin:before {
  content: "";
}

.bx-mask:before {
  content: "";
}

.bx-medal:before {
  content: "";
}

.bx-meh:before {
  content: "";
}

.bx-meh-alt:before {
  content: "";
}

.bx-meh-blank:before {
  content: "";
}

.bx-memory-card:before {
  content: "";
}

.bx-menu:before {
  content: "";
}

.bx-menu-alt-left:before {
  content: "";
}

.bx-menu-alt-right:before {
  content: "";
}

.bx-merge:before {
  content: "";
}

.bx-message:before {
  content: "";
}

.bx-message-add:before {
  content: "";
}

.bx-message-alt:before {
  content: "";
}

.bx-message-alt-add:before {
  content: "";
}

.bx-message-alt-check:before {
  content: "";
}

.bx-message-alt-detail:before {
  content: "";
}

.bx-message-alt-dots:before {
  content: "";
}

.bx-message-alt-edit:before {
  content: "";
}

.bx-message-alt-error:before {
  content: "";
}

.bx-message-alt-minus:before {
  content: "";
}

.bx-message-alt-x:before {
  content: "";
}

.bx-message-check:before {
  content: "";
}

.bx-message-detail:before {
  content: "";
}

.bx-message-dots:before {
  content: "";
}

.bx-message-edit:before {
  content: "";
}

.bx-message-error:before {
  content: "";
}

.bx-message-minus:before {
  content: "";
}

.bx-message-rounded:before {
  content: "";
}

.bx-message-rounded-add:before {
  content: "";
}

.bx-message-rounded-check:before {
  content: "";
}

.bx-message-rounded-detail:before {
  content: "";
}

.bx-message-rounded-dots:before {
  content: "";
}

.bx-message-rounded-edit:before {
  content: "";
}

.bx-message-rounded-error:before {
  content: "";
}

.bx-message-rounded-minus:before {
  content: "";
}

.bx-message-rounded-x:before {
  content: "";
}

.bx-message-square:before {
  content: "";
}

.bx-message-square-add:before {
  content: "";
}

.bx-message-square-check:before {
  content: "";
}

.bx-message-square-detail:before {
  content: "";
}

.bx-message-square-dots:before {
  content: "";
}

.bx-message-square-edit:before {
  content: "";
}

.bx-message-square-error:before {
  content: "";
}

.bx-message-square-minus:before {
  content: "";
}

.bx-message-square-x:before {
  content: "";
}

.bx-message-x:before {
  content: "";
}

.bx-meteor:before {
  content: "";
}

.bx-microchip:before {
  content: "";
}

.bx-microphone:before {
  content: "";
}

.bx-microphone-off:before {
  content: "";
}

.bx-minus:before {
  content: "";
}

.bx-minus-back:before {
  content: "";
}

.bx-minus-circle:before {
  content: "";
}

.bx-minus-front:before {
  content: "";
}

.bx-mobile:before {
  content: "";
}

.bx-mobile-alt:before {
  content: "";
}

.bx-mobile-landscape:before {
  content: "";
}

.bx-mobile-vibration:before {
  content: "";
}

.bx-money:before {
  content: "";
}

.bx-moon:before {
  content: "";
}

.bx-mouse:before {
  content: "";
}

.bx-mouse-alt:before {
  content: "";
}

.bx-move:before {
  content: "";
}

.bx-move-horizontal:before {
  content: "";
}

.bx-move-vertical:before {
  content: "";
}

.bx-movie:before {
  content: "";
}

.bx-movie-play:before {
  content: "";
}

.bx-music:before {
  content: "";
}

.bx-navigation:before {
  content: "";
}

.bx-network-chart:before {
  content: "";
}

.bx-news:before {
  content: "";
}

.bx-no-entry:before {
  content: "";
}

.bx-note:before {
  content: "";
}

.bx-notepad:before {
  content: "";
}

.bx-notification:before {
  content: "";
}

.bx-notification-off:before {
  content: "";
}

.bx-outline:before {
  content: "";
}

.bx-package:before {
  content: "";
}

.bx-paint:before {
  content: "";
}

.bx-paint-roll:before {
  content: "";
}

.bx-palette:before {
  content: "";
}

.bx-paperclip:before {
  content: "";
}

.bx-paper-plane:before {
  content: "";
}

.bx-paragraph:before {
  content: "";
}

.bx-paste:before {
  content: "";
}

.bx-pause:before {
  content: "";
}

.bx-pause-circle:before {
  content: "";
}

.bx-pen:before {
  content: "";
}

.bx-pencil:before {
  content: "";
}

.bx-phone:before {
  content: "";
}

.bx-phone-call:before {
  content: "";
}

.bx-phone-incoming:before {
  content: "";
}

.bx-phone-off:before {
  content: "";
}

.bx-phone-outgoing:before {
  content: "";
}

.bx-photo-album:before {
  content: "";
}

.bx-pie-chart:before {
  content: "";
}

.bx-pie-chart-alt:before {
  content: "";
}

.bx-pie-chart-alt-2:before {
  content: "";
}

.bx-pin:before {
  content: "";
}

.bx-planet:before {
  content: "";
}

.bx-play:before {
  content: "";
}

.bx-play-circle:before {
  content: "";
}

.bx-plug:before {
  content: "";
}

.bx-plus:before {
  content: "";
}

.bx-plus-circle:before {
  content: "";
}

.bx-plus-medical:before {
  content: "";
}

.bx-podcast:before {
  content: "";
}

.bx-pointer:before {
  content: "";
}

.bx-poll:before {
  content: "";
}

.bx-polygon:before {
  content: "";
}

.bx-pound:before {
  content: "";
}

.bx-power-off:before {
  content: "";
}

.bx-printer:before {
  content: "";
}

.bx-pulse:before {
  content: "";
}

.bx-purchase-tag:before {
  content: "";
}

.bx-purchase-tag-alt:before {
  content: "";
}

.bx-pyramid:before {
  content: "";
}

.bx-qr:before {
  content: "";
}

.bx-qr-scan:before {
  content: "";
}

.bx-question-mark:before {
  content: "";
}

.bx-radar:before {
  content: "";
}

.bx-radio:before {
  content: "";
}

.bx-radio-circle:before {
  content: "";
}

.bx-radio-circle-marked:before {
  content: "";
}

.bx-receipt:before {
  content: "";
}

.bx-rectangle:before {
  content: "";
}

.bx-recycle:before {
  content: "";
}

.bx-redo:before {
  content: "";
}

.bx-refresh:before {
  content: "";
}

.bx-registered:before {
  content: "";
}

.bx-rename:before {
  content: "";
}

.bx-repeat:before {
  content: "";
}

.bx-reply:before {
  content: "";
}

.bx-reply-all:before {
  content: "";
}

.bx-repost:before {
  content: "";
}

.bx-reset:before {
  content: "";
}

.bx-restaurant:before {
  content: "";
}

.bx-revision:before {
  content: "";
}

.bx-rewind:before {
  content: "";
}

.bx-rewind-circle:before {
  content: "";
}

.bx-right-arrow:before {
  content: "";
}

.bx-right-arrow-alt:before {
  content: "";
}

.bx-right-arrow-circle:before {
  content: "";
}

.bx-right-down-arrow-circle:before {
  content: "";
}

.bx-right-indent:before {
  content: "";
}

.bx-right-top-arrow-circle:before {
  content: "";
}

.bx-rocket:before {
  content: "";
}

.bx-rotate-left:before {
  content: "";
}

.bx-rotate-right:before {
  content: "";
}

.bx-rss:before {
  content: "";
}

.bx-ruble:before {
  content: "";
}

.bx-ruler:before {
  content: "";
}

.bx-run:before {
  content: "";
}

.bx-rupee:before {
  content: "";
}

.bx-sad:before {
  content: "";
}

.bx-save:before {
  content: "";
}

.bx-scan:before {
  content: "";
}

.bx-screenshot:before {
  content: "";
}

.bx-search:before {
  content: "";
}

.bx-search-alt:before {
  content: "";
}

.bx-search-alt-2:before {
  content: "";
}

.bx-selection:before {
  content: "";
}

.bx-select-multiple:before {
  content: "";
}

.bx-send:before {
  content: "";
}

.bx-server:before {
  content: "";
}

.bx-shape-circle:before {
  content: "";
}

.bx-shape-polygon:before {
  content: "";
}

.bx-shape-square:before {
  content: "";
}

.bx-shape-triangle:before {
  content: "";
}

.bx-share:before {
  content: "";
}

.bx-share-alt:before {
  content: "";
}

.bx-shekel:before {
  content: "";
}

.bx-shield:before {
  content: "";
}

.bx-shield-alt:before {
  content: "";
}

.bx-shield-alt-2:before {
  content: "";
}

.bx-shield-quarter:before {
  content: "";
}

.bx-shield-x:before {
  content: "";
}

.bx-shocked:before {
  content: "";
}

.bx-shopping-bag:before {
  content: "";
}

.bx-show:before {
  content: "";
}

.bx-show-alt:before {
  content: "";
}

.bx-shuffle:before {
  content: "";
}

.bx-sidebar:before {
  content: "";
}

.bx-sitemap:before {
  content: "";
}

.bx-skip-next:before {
  content: "";
}

.bx-skip-next-circle:before {
  content: "";
}

.bx-skip-previous:before {
  content: "";
}

.bx-skip-previous-circle:before {
  content: "";
}

.bx-sleepy:before {
  content: "";
}

.bx-slider:before {
  content: "";
}

.bx-slider-alt:before {
  content: "";
}

.bx-slideshow:before {
  content: "";
}

.bx-smile:before {
  content: "";
}

.bx-sort:before {
  content: "";
}

.bx-sort-alt-2:before {
  content: "";
}

.bx-sort-a-z:before {
  content: "";
}

.bx-sort-down:before {
  content: "";
}

.bx-sort-up:before {
  content: "";
}

.bx-sort-z-a:before {
  content: "";
}

.bx-spa:before {
  content: "";
}

.bx-space-bar:before {
  content: "";
}

.bx-speaker:before {
  content: "";
}

.bx-spray-can:before {
  content: "";
}

.bx-spreadsheet:before {
  content: "";
}

.bx-square:before {
  content: "";
}

.bx-square-rounded:before {
  content: "";
}

.bx-star:before {
  content: "";
}

.bx-station:before {
  content: "";
}

.bx-stats:before {
  content: "";
}

.bx-sticker:before {
  content: "";
}

.bx-stop:before {
  content: "";
}

.bx-stop-circle:before {
  content: "";
}

.bx-stopwatch:before {
  content: "";
}

.bx-store:before {
  content: "";
}

.bx-store-alt:before {
  content: "";
}

.bx-street-view:before {
  content: "";
}

.bx-strikethrough:before {
  content: "";
}

.bx-subdirectory-left:before {
  content: "";
}

.bx-subdirectory-right:before {
  content: "";
}

.bx-sun:before {
  content: "";
}

.bx-support:before {
  content: "";
}

.bx-swim:before {
  content: "";
}

.bx-sync:before {
  content: "";
}

.bx-tab:before {
  content: "";
}

.bx-table:before {
  content: "";
}

.bx-tachometer:before {
  content: "";
}

.bx-tag:before {
  content: "";
}

.bx-tag-alt:before {
  content: "";
}

.bx-target-lock:before {
  content: "";
}

.bx-task:before {
  content: "";
}

.bx-task-x:before {
  content: "";
}

.bx-taxi:before {
  content: "";
}

.bx-tennis-ball:before {
  content: "";
}

.bx-terminal:before {
  content: "";
}

.bx-test-tube:before {
  content: "";
}

.bx-text:before {
  content: "";
}

.bx-time:before {
  content: "";
}

.bx-time-five:before {
  content: "";
}

.bx-timer:before {
  content: "";
}

.bx-tired:before {
  content: "";
}

.bx-toggle-left:before {
  content: "";
}

.bx-toggle-right:before {
  content: "";
}

.bx-tone:before {
  content: "";
}

.bx-traffic-cone:before {
  content: "";
}

.bx-train:before {
  content: "";
}

.bx-transfer:before {
  content: "";
}

.bx-transfer-alt:before {
  content: "";
}

.bx-trash:before {
  content: "";
}

.bx-trash-alt:before {
  content: "";
}

.bx-trending-down:before {
  content: "";
}

.bx-trending-up:before {
  content: "";
}

.bx-trim:before {
  content: "";
}

.bx-trip:before {
  content: "";
}

.bx-trophy:before {
  content: "";
}

.bx-tv:before {
  content: "";
}

.bx-underline:before {
  content: "";
}

.bx-undo:before {
  content: "";
}

.bx-unite:before {
  content: "";
}

.bx-unlink:before {
  content: "";
}

.bx-up-arrow:before {
  content: "";
}

.bx-up-arrow-alt:before {
  content: "";
}

.bx-up-arrow-circle:before {
  content: "";
}

.bx-upload:before {
  content: "";
}

.bx-upside-down:before {
  content: "";
}

.bx-upvote:before {
  content: "";
}

.bx-usb:before {
  content: "";
}

.bx-user:before {
  content: "";
}

.bx-user-check:before {
  content: "";
}

.bx-user-circle:before {
  content: "";
}

.bx-user-minus:before {
  content: "";
}

.bx-user-pin:before {
  content: "";
}

.bx-user-plus:before {
  content: "";
}

.bx-user-voice:before {
  content: "";
}

.bx-user-x:before {
  content: "";
}

.bx-vector:before {
  content: "";
}

.bx-vertical-center:before {
  content: "";
}

.bx-vial:before {
  content: "";
}

.bx-video:before {
  content: "";
}

.bx-video-off:before {
  content: "";
}

.bx-video-plus:before {
  content: "";
}

.bx-video-recording:before {
  content: "";
}

.bx-voicemail:before {
  content: "";
}

.bx-volume:before {
  content: "";
}

.bx-volume-full:before {
  content: "";
}

.bx-volume-low:before {
  content: "";
}

.bx-volume-mute:before {
  content: "";
}

.bx-walk:before {
  content: "";
}

.bx-wallet:before {
  content: "";
}

.bx-wallet-alt:before {
  content: "";
}

.bx-water:before {
  content: "";
}

.bx-webcam:before {
  content: "";
}

.bx-wifi:before {
  content: "";
}

.bx-wifi-0:before {
  content: "";
}

.bx-wifi-1:before {
  content: "";
}

.bx-wifi-2:before {
  content: "";
}

.bx-wifi-off:before {
  content: "";
}

.bx-wind:before {
  content: "";
}

.bx-window:before {
  content: "";
}

.bx-window-alt:before {
  content: "";
}

.bx-window-close:before {
  content: "";
}

.bx-window-open:before {
  content: "";
}

.bx-windows:before {
  content: "";
}

.bx-wine:before {
  content: "";
}

.bx-wink-smile:before {
  content: "";
}

.bx-wink-tongue:before {
  content: "";
}

.bx-won:before {
  content: "";
}

.bx-world:before {
  content: "";
}

.bx-wrench:before {
  content: "";
}

.bx-x:before {
  content: "";
}

.bx-x-circle:before {
  content: "";
}

.bx-yen:before {
  content: "";
}

.bx-zoom-in:before {
  content: "";
}

.bx-zoom-out:before {
  content: "";
}

.bxs-party:before {
  content: "";
}

.bxs-hot:before {
  content: "";
}

.bxs-droplet:before {
  content: "";
}

.bxs-cat:before {
  content: "";
}

.bxs-dog:before {
  content: "";
}

.bxs-injection:before {
  content: "";
}

.bxs-leaf:before {
  content: "";
}

.bxs-add-to-queue:before {
  content: "";
}

.bxs-adjust:before {
  content: "";
}

.bxs-adjust-alt:before {
  content: "";
}

.bxs-alarm:before {
  content: "";
}

.bxs-alarm-add:before {
  content: "";
}

.bxs-alarm-exclamation:before {
  content: "";
}

.bxs-alarm-off:before {
  content: "";
}

.bxs-alarm-snooze:before {
  content: "";
}

.bxs-album:before {
  content: "";
}

.bxs-ambulance:before {
  content: "";
}

.bxs-analyse:before {
  content: "";
}

.bxs-angry:before {
  content: "";
}

.bxs-arch:before {
  content: "";
}

.bxs-archive:before {
  content: "";
}

.bxs-archive-in:before {
  content: "";
}

.bxs-archive-out:before {
  content: "";
}

.bxs-area:before {
  content: "";
}

.bxs-arrow-from-bottom:before {
  content: "";
}

.bxs-arrow-from-left:before {
  content: "";
}

.bxs-arrow-from-right:before {
  content: "";
}

.bxs-arrow-from-top:before {
  content: "";
}

.bxs-arrow-to-bottom:before {
  content: "";
}

.bxs-arrow-to-left:before {
  content: "";
}

.bxs-arrow-to-right:before {
  content: "";
}

.bxs-arrow-to-top:before {
  content: "";
}

.bxs-award:before {
  content: "";
}

.bxs-baby-carriage:before {
  content: "";
}

.bxs-backpack:before {
  content: "";
}

.bxs-badge:before {
  content: "";
}

.bxs-badge-check:before {
  content: "";
}

.bxs-badge-dollar:before {
  content: "";
}

.bxs-ball:before {
  content: "";
}

.bxs-band-aid:before {
  content: "";
}

.bxs-bank:before {
  content: "";
}

.bxs-bar-chart-alt-2:before {
  content: "";
}

.bxs-bar-chart-square:before {
  content: "";
}

.bxs-barcode:before {
  content: "";
}

.bxs-baseball:before {
  content: "";
}

.bxs-basket:before {
  content: "";
}

.bxs-basketball:before {
  content: "";
}

.bxs-bath:before {
  content: "";
}

.bxs-battery:before {
  content: "";
}

.bxs-battery-charging:before {
  content: "";
}

.bxs-battery-full:before {
  content: "";
}

.bxs-battery-low:before {
  content: "";
}

.bxs-bed:before {
  content: "";
}

.bxs-been-here:before {
  content: "";
}

.bxs-beer:before {
  content: "";
}

.bxs-bell:before {
  content: "";
}

.bxs-bell-minus:before {
  content: "";
}

.bxs-bell-off:before {
  content: "";
}

.bxs-bell-plus:before {
  content: "";
}

.bxs-bell-ring:before {
  content: "";
}

.bxs-bible:before {
  content: "";
}

.bxs-binoculars:before {
  content: "";
}

.bxs-blanket:before {
  content: "";
}

.bxs-bolt:before {
  content: "";
}

.bxs-bolt-circle:before {
  content: "";
}

.bxs-bomb:before {
  content: "";
}

.bxs-bone:before {
  content: "";
}

.bxs-bong:before {
  content: "";
}

.bxs-book:before {
  content: "";
}

.bxs-book-add:before {
  content: "";
}

.bxs-book-alt:before {
  content: "";
}

.bxs-book-bookmark:before {
  content: "";
}

.bxs-book-content:before {
  content: "";
}

.bxs-book-heart:before {
  content: "";
}

.bxs-bookmark:before {
  content: "";
}

.bxs-bookmark-alt:before {
  content: "";
}

.bxs-bookmark-alt-minus:before {
  content: "";
}

.bxs-bookmark-alt-plus:before {
  content: "";
}

.bxs-bookmark-heart:before {
  content: "";
}

.bxs-bookmark-minus:before {
  content: "";
}

.bxs-bookmark-plus:before {
  content: "";
}

.bxs-bookmarks:before {
  content: "";
}

.bxs-bookmark-star:before {
  content: "";
}

.bxs-book-open:before {
  content: "";
}

.bxs-book-reader:before {
  content: "";
}

.bxs-bot:before {
  content: "";
}

.bxs-bowling-ball:before {
  content: "";
}

.bxs-box:before {
  content: "";
}

.bxs-brain:before {
  content: "";
}

.bxs-briefcase:before {
  content: "";
}

.bxs-briefcase-alt:before {
  content: "";
}

.bxs-briefcase-alt-2:before {
  content: "";
}

.bxs-brightness:before {
  content: "";
}

.bxs-brightness-half:before {
  content: "";
}

.bxs-brush:before {
  content: "";
}

.bxs-brush-alt:before {
  content: "";
}

.bxs-bug:before {
  content: "";
}

.bxs-bug-alt:before {
  content: "";
}

.bxs-building:before {
  content: "";
}

.bxs-building-house:before {
  content: "";
}

.bxs-buildings:before {
  content: "";
}

.bxs-bulb:before {
  content: "";
}

.bxs-bullseye:before {
  content: "";
}

.bxs-buoy:before {
  content: "";
}

.bxs-bus:before {
  content: "";
}

.bxs-business:before {
  content: "";
}

.bxs-bus-school:before {
  content: "";
}

.bxs-cabinet:before {
  content: "";
}

.bxs-cake:before {
  content: "";
}

.bxs-calculator:before {
  content: "";
}

.bxs-calendar:before {
  content: "";
}

.bxs-calendar-alt:before {
  content: "";
}

.bxs-calendar-check:before {
  content: "";
}

.bxs-calendar-edit:before {
  content: "";
}

.bxs-calendar-event:before {
  content: "";
}

.bxs-calendar-exclamation:before {
  content: "";
}

.bxs-calendar-heart:before {
  content: "";
}

.bxs-calendar-minus:before {
  content: "";
}

.bxs-calendar-plus:before {
  content: "";
}

.bxs-calendar-star:before {
  content: "";
}

.bxs-calendar-week:before {
  content: "";
}

.bxs-calendar-x:before {
  content: "";
}

.bxs-camera:before {
  content: "";
}

.bxs-camera-home:before {
  content: "";
}

.bxs-camera-movie:before {
  content: "";
}

.bxs-camera-off:before {
  content: "";
}

.bxs-camera-plus:before {
  content: "";
}

.bxs-capsule:before {
  content: "";
}

.bxs-captions:before {
  content: "";
}

.bxs-car:before {
  content: "";
}

.bxs-car-battery:before {
  content: "";
}

.bxs-car-crash:before {
  content: "";
}

.bxs-card:before {
  content: "";
}

.bxs-caret-down-circle:before {
  content: "";
}

.bxs-caret-down-square:before {
  content: "";
}

.bxs-caret-left-circle:before {
  content: "";
}

.bxs-caret-left-square:before {
  content: "";
}

.bxs-caret-right-circle:before {
  content: "";
}

.bxs-caret-right-square:before {
  content: "";
}

.bxs-caret-up-circle:before {
  content: "";
}

.bxs-caret-up-square:before {
  content: "";
}

.bxs-car-garage:before {
  content: "";
}

.bxs-car-mechanic:before {
  content: "";
}

.bxs-carousel:before {
  content: "";
}

.bxs-cart:before {
  content: "";
}

.bxs-cart-add:before {
  content: "";
}

.bxs-cart-alt:before {
  content: "";
}

.bxs-cart-download:before {
  content: "";
}

.bxs-car-wash:before {
  content: "";
}

.bxs-category:before {
  content: "";
}

.bxs-category-alt:before {
  content: "";
}

.bxs-cctv:before {
  content: "";
}

.bxs-certification:before {
  content: "";
}

.bxs-chalkboard:before {
  content: "";
}

.bxs-chart:before {
  content: "";
}

.bxs-chat:before {
  content: "";
}

.bxs-checkbox:before {
  content: "";
}

.bxs-checkbox-checked:before {
  content: "";
}

.bxs-checkbox-minus:before {
  content: "";
}

.bxs-check-circle:before {
  content: "";
}

.bxs-check-shield:before {
  content: "";
}

.bxs-check-square:before {
  content: "";
}

.bxs-chess:before {
  content: "";
}

.bxs-chevron-down:before {
  content: "";
}

.bxs-chevron-down-circle:before {
  content: "";
}

.bxs-chevron-down-square:before {
  content: "";
}

.bxs-chevron-left:before {
  content: "";
}

.bxs-chevron-left-circle:before {
  content: "";
}

.bxs-chevron-left-square:before {
  content: "";
}

.bxs-chevron-right:before {
  content: "";
}

.bxs-chevron-right-circle:before {
  content: "";
}

.bxs-chevron-right-square:before {
  content: "";
}

.bxs-chevrons-down:before {
  content: "";
}

.bxs-chevrons-left:before {
  content: "";
}

.bxs-chevrons-right:before {
  content: "";
}

.bxs-chevrons-up:before {
  content: "";
}

.bxs-chevron-up:before {
  content: "";
}

.bxs-chevron-up-circle:before {
  content: "";
}

.bxs-chevron-up-square:before {
  content: "";
}

.bxs-chip:before {
  content: "";
}

.bxs-church:before {
  content: "";
}

.bxs-circle:before {
  content: "";
}

.bxs-city:before {
  content: "";
}

.bxs-clinic:before {
  content: "";
}

.bxs-cloud:before {
  content: "";
}

.bxs-cloud-download:before {
  content: "";
}

.bxs-cloud-lightning:before {
  content: "";
}

.bxs-cloud-rain:before {
  content: "";
}

.bxs-cloud-upload:before {
  content: "";
}

.bxs-coffee:before {
  content: "";
}

.bxs-coffee-alt:before {
  content: "";
}

.bxs-coffee-togo:before {
  content: "";
}

.bxs-cog:before {
  content: "";
}

.bxs-coin:before {
  content: "";
}

.bxs-coin-stack:before {
  content: "";
}

.bxs-collection:before {
  content: "";
}

.bxs-color-fill:before {
  content: "";
}

.bxs-comment:before {
  content: "";
}

.bxs-comment-add:before {
  content: "";
}

.bxs-comment-check:before {
  content: "";
}

.bxs-comment-detail:before {
  content: "";
}

.bxs-comment-dots:before {
  content: "";
}

.bxs-comment-edit:before {
  content: "";
}

.bxs-comment-error:before {
  content: "";
}

.bxs-comment-minus:before {
  content: "";
}

.bxs-comment-x:before {
  content: "";
}

.bxs-compass:before {
  content: "";
}

.bxs-component:before {
  content: "";
}

.bxs-confused:before {
  content: "";
}

.bxs-contact:before {
  content: "";
}

.bxs-conversation:before {
  content: "";
}

.bxs-cookie:before {
  content: "";
}

.bxs-cool:before {
  content: "";
}

.bxs-copy:before {
  content: "";
}

.bxs-copy-alt:before {
  content: "";
}

.bxs-copyright:before {
  content: "";
}

.bxs-coupon:before {
  content: "";
}

.bxs-credit-card:before {
  content: "";
}

.bxs-credit-card-alt:before {
  content: "";
}

.bxs-credit-card-front:before {
  content: "";
}

.bxs-crop:before {
  content: "";
}

.bxs-crown:before {
  content: "";
}

.bxs-cube:before {
  content: "";
}

.bxs-cube-alt:before {
  content: "";
}

.bxs-cuboid:before {
  content: "";
}

.bxs-customize:before {
  content: "";
}

.bxs-cylinder:before {
  content: "";
}

.bxs-dashboard:before {
  content: "";
}

.bxs-data:before {
  content: "";
}

.bxs-detail:before {
  content: "";
}

.bxs-devices:before {
  content: "";
}

.bxs-diamond:before {
  content: "";
}

.bxs-dice-1:before {
  content: "";
}

.bxs-dice-2:before {
  content: "";
}

.bxs-dice-3:before {
  content: "";
}

.bxs-dice-4:before {
  content: "";
}

.bxs-dice-5:before {
  content: "";
}

.bxs-dice-6:before {
  content: "";
}

.bxs-direction-left:before {
  content: "";
}

.bxs-direction-right:before {
  content: "";
}

.bxs-directions:before {
  content: "";
}

.bxs-disc:before {
  content: "";
}

.bxs-discount:before {
  content: "";
}

.bxs-dish:before {
  content: "";
}

.bxs-dislike:before {
  content: "";
}

.bxs-dizzy:before {
  content: "";
}

.bxs-dock-bottom:before {
  content: "";
}

.bxs-dock-left:before {
  content: "";
}

.bxs-dock-right:before {
  content: "";
}

.bxs-dock-top:before {
  content: "";
}

.bxs-dollar-circle:before {
  content: "";
}

.bxs-donate-blood:before {
  content: "";
}

.bxs-donate-heart:before {
  content: "";
}

.bxs-door-open:before {
  content: "";
}

.bxs-doughnut-chart:before {
  content: "";
}

.bxs-down-arrow:before {
  content: "";
}

.bxs-down-arrow-alt:before {
  content: "";
}

.bxs-down-arrow-circle:before {
  content: "";
}

.bxs-down-arrow-square:before {
  content: "";
}

.bxs-download:before {
  content: "";
}

.bxs-downvote:before {
  content: "";
}

.bxs-drink:before {
  content: "";
}

.bxs-droplet-half:before {
  content: "";
}

.bxs-dryer:before {
  content: "";
}

.bxs-duplicate:before {
  content: "";
}

.bxs-edit:before {
  content: "";
}

.bxs-edit-alt:before {
  content: "";
}

.bxs-edit-location:before {
  content: "";
}

.bxs-eject:before {
  content: "";
}

.bxs-envelope:before {
  content: "";
}

.bxs-envelope-open:before {
  content: "";
}

.bxs-eraser:before {
  content: "";
}

.bxs-error:before {
  content: "";
}

.bxs-error-alt:before {
  content: "";
}

.bxs-error-circle:before {
  content: "";
}

.bxs-ev-station:before {
  content: "";
}

.bxs-exit:before {
  content: "";
}

.bxs-extension:before {
  content: "";
}

.bxs-eyedropper:before {
  content: "";
}

.bxs-face:before {
  content: "";
}

.bxs-face-mask:before {
  content: "";
}

.bxs-factory:before {
  content: "";
}

.bxs-fast-forward-circle:before {
  content: "";
}

.bxs-file:before {
  content: "";
}

.bxs-file-archive:before {
  content: "";
}

.bxs-file-blank:before {
  content: "";
}

.bxs-file-css:before {
  content: "";
}

.bxs-file-doc:before {
  content: "";
}

.bxs-file-export:before {
  content: "";
}

.bxs-file-find:before {
  content: "";
}

.bxs-file-gif:before {
  content: "";
}

.bxs-file-html:before {
  content: "";
}

.bxs-file-image:before {
  content: "";
}

.bxs-file-import:before {
  content: "";
}

.bxs-file-jpg:before {
  content: "";
}

.bxs-file-js:before {
  content: "";
}

.bxs-file-json:before {
  content: "";
}

.bxs-file-md:before {
  content: "";
}

.bxs-file-pdf:before {
  content: "";
}

.bxs-file-plus:before {
  content: "";
}

.bxs-file-png:before {
  content: "";
}

.bxs-file-txt:before {
  content: "";
}

.bxs-film:before {
  content: "";
}

.bxs-filter-alt:before {
  content: "";
}

.bxs-first-aid:before {
  content: "";
}

.bxs-flag:before {
  content: "";
}

.bxs-flag-alt:before {
  content: "";
}

.bxs-flag-checkered:before {
  content: "";
}

.bxs-flame:before {
  content: "";
}

.bxs-flask:before {
  content: "";
}

.bxs-florist:before {
  content: "";
}

.bxs-folder:before {
  content: "";
}

.bxs-folder-minus:before {
  content: "";
}

.bxs-folder-open:before {
  content: "";
}

.bxs-folder-plus:before {
  content: "";
}

.bxs-food-menu:before {
  content: "";
}

.bxs-fridge:before {
  content: "";
}

.bxs-game:before {
  content: "";
}

.bxs-gas-pump:before {
  content: "";
}

.bxs-ghost:before {
  content: "";
}

.bxs-gift:before {
  content: "";
}

.bxs-graduation:before {
  content: "";
}

.bxs-grid:before {
  content: "";
}

.bxs-grid-alt:before {
  content: "";
}

.bxs-group:before {
  content: "";
}

.bxs-guitar-amp:before {
  content: "";
}

.bxs-hand:before {
  content: "";
}

.bxs-hand-down:before {
  content: "";
}

.bxs-hand-left:before {
  content: "";
}

.bxs-hand-right:before {
  content: "";
}

.bxs-hand-up:before {
  content: "";
}

.bxs-happy:before {
  content: "";
}

.bxs-happy-alt:before {
  content: "";
}

.bxs-happy-beaming:before {
  content: "";
}

.bxs-happy-heart-eyes:before {
  content: "";
}

.bxs-hdd:before {
  content: "";
}

.bxs-heart:before {
  content: "";
}

.bxs-heart-circle:before {
  content: "";
}

.bxs-heart-square:before {
  content: "";
}

.bxs-help-circle:before {
  content: "";
}

.bxs-hide:before {
  content: "";
}

.bxs-home:before {
  content: "";
}

.bxs-home-circle:before {
  content: "";
}

.bxs-home-heart:before {
  content: "";
}

.bxs-home-smile:before {
  content: "";
}

.bxs-hotel:before {
  content: "";
}

.bxs-hourglass:before {
  content: "";
}

.bxs-hourglass-bottom:before {
  content: "";
}

.bxs-hourglass-top:before {
  content: "";
}

.bxs-id-card:before {
  content: "";
}

.bxs-image:before {
  content: "";
}

.bxs-image-add:before {
  content: "";
}

.bxs-image-alt:before {
  content: "";
}

.bxs-inbox:before {
  content: "";
}

.bxs-info-circle:before {
  content: "";
}

.bxs-info-square:before {
  content: "";
}

.bxs-institution:before {
  content: "";
}

.bxs-joystick:before {
  content: "";
}

.bxs-joystick-alt:before {
  content: "";
}

.bxs-joystick-button:before {
  content: "";
}

.bxs-key:before {
  content: "";
}

.bxs-keyboard:before {
  content: "";
}

.bxs-label:before {
  content: "";
}

.bxs-landmark:before {
  content: "";
}

.bxs-landscape:before {
  content: "";
}

.bxs-laugh:before {
  content: "";
}

.bxs-layer:before {
  content: "";
}

.bxs-layer-minus:before {
  content: "";
}

.bxs-layer-plus:before {
  content: "";
}

.bxs-layout:before {
  content: "";
}

.bxs-left-arrow:before {
  content: "";
}

.bxs-left-arrow-alt:before {
  content: "";
}

.bxs-left-arrow-circle:before {
  content: "";
}

.bxs-left-arrow-square:before {
  content: "";
}

.bxs-left-down-arrow-circle:before {
  content: "";
}

.bxs-left-top-arrow-circle:before {
  content: "";
}

.bxs-like:before {
  content: "";
}

.bxs-location-plus:before {
  content: "";
}

.bxs-lock:before {
  content: "";
}

.bxs-lock-alt:before {
  content: "";
}

.bxs-lock-open:before {
  content: "";
}

.bxs-lock-open-alt:before {
  content: "";
}

.bxs-log-in:before {
  content: "";
}

.bxs-log-in-circle:before {
  content: "";
}

.bxs-log-out:before {
  content: "";
}

.bxs-log-out-circle:before {
  content: "";
}

.bxs-low-vision:before {
  content: "";
}

.bxs-magic-wand:before {
  content: "";
}

.bxs-magnet:before {
  content: "";
}

.bxs-map:before {
  content: "";
}

.bxs-map-alt:before {
  content: "";
}

.bxs-map-pin:before {
  content: "";
}

.bxs-mask:before {
  content: "";
}

.bxs-medal:before {
  content: "";
}

.bxs-megaphone:before {
  content: "";
}

.bxs-meh:before {
  content: "";
}

.bxs-meh-alt:before {
  content: "";
}

.bxs-meh-blank:before {
  content: "";
}

.bxs-memory-card:before {
  content: "";
}

.bxs-message:before {
  content: "";
}

.bxs-message-add:before {
  content: "";
}

.bxs-message-alt:before {
  content: "";
}

.bxs-message-alt-add:before {
  content: "";
}

.bxs-message-alt-check:before {
  content: "";
}

.bxs-message-alt-detail:before {
  content: "";
}

.bxs-message-alt-dots:before {
  content: "";
}

.bxs-message-alt-edit:before {
  content: "";
}

.bxs-message-alt-error:before {
  content: "";
}

.bxs-message-alt-minus:before {
  content: "";
}

.bxs-message-alt-x:before {
  content: "";
}

.bxs-message-check:before {
  content: "";
}

.bxs-message-detail:before {
  content: "";
}

.bxs-message-dots:before {
  content: "";
}

.bxs-message-edit:before {
  content: "";
}

.bxs-message-error:before {
  content: "";
}

.bxs-message-minus:before {
  content: "";
}

.bxs-message-rounded:before {
  content: "";
}

.bxs-message-rounded-add:before {
  content: "";
}

.bxs-message-rounded-check:before {
  content: "";
}

.bxs-message-rounded-detail:before {
  content: "";
}

.bxs-message-rounded-dots:before {
  content: "";
}

.bxs-message-rounded-edit:before {
  content: "";
}

.bxs-message-rounded-error:before {
  content: "";
}

.bxs-message-rounded-minus:before {
  content: "";
}

.bxs-message-rounded-x:before {
  content: "";
}

.bxs-message-square:before {
  content: "";
}

.bxs-message-square-add:before {
  content: "";
}

.bxs-message-square-check:before {
  content: "";
}

.bxs-message-square-detail:before {
  content: "";
}

.bxs-message-square-dots:before {
  content: "";
}

.bxs-message-square-edit:before {
  content: "";
}

.bxs-message-square-error:before {
  content: "";
}

.bxs-message-square-minus:before {
  content: "";
}

.bxs-message-square-x:before {
  content: "";
}

.bxs-message-x:before {
  content: "";
}

.bxs-meteor:before {
  content: "";
}

.bxs-microchip:before {
  content: "";
}

.bxs-microphone:before {
  content: "";
}

.bxs-microphone-alt:before {
  content: "";
}

.bxs-microphone-off:before {
  content: "";
}

.bxs-minus-circle:before {
  content: "";
}

.bxs-minus-square:before {
  content: "";
}

.bxs-mobile:before {
  content: "";
}

.bxs-mobile-vibration:before {
  content: "";
}

.bxs-moon:before {
  content: "";
}

.bxs-mouse:before {
  content: "";
}

.bxs-mouse-alt:before {
  content: "";
}

.bxs-movie:before {
  content: "";
}

.bxs-movie-play:before {
  content: "";
}

.bxs-music:before {
  content: "";
}

.bxs-navigation:before {
  content: "";
}

.bxs-network-chart:before {
  content: "";
}

.bxs-news:before {
  content: "";
}

.bxs-no-entry:before {
  content: "";
}

.bxs-note:before {
  content: "";
}

.bxs-notepad:before {
  content: "";
}

.bxs-notification:before {
  content: "";
}

.bxs-notification-off:before {
  content: "";
}

.bxs-offer:before {
  content: "";
}

.bxs-package:before {
  content: "";
}

.bxs-paint:before {
  content: "";
}

.bxs-paint-roll:before {
  content: "";
}

.bxs-palette:before {
  content: "";
}

.bxs-paper-plane:before {
  content: "";
}

.bxs-parking:before {
  content: "";
}

.bxs-paste:before {
  content: "";
}

.bxs-pen:before {
  content: "";
}

.bxs-pencil:before {
  content: "";
}

.bxs-phone:before {
  content: "";
}

.bxs-phone-call:before {
  content: "";
}

.bxs-phone-incoming:before {
  content: "";
}

.bxs-phone-off:before {
  content: "";
}

.bxs-phone-outgoing:before {
  content: "";
}

.bxs-photo-album:before {
  content: "";
}

.bxs-piano:before {
  content: "";
}

.bxs-pie-chart:before {
  content: "";
}

.bxs-pie-chart-alt:before {
  content: "";
}

.bxs-pie-chart-alt-2:before {
  content: "";
}

.bxs-pin:before {
  content: "";
}

.bxs-pizza:before {
  content: "";
}

.bxs-plane:before {
  content: "";
}

.bxs-plane-alt:before {
  content: "";
}

.bxs-plane-land:before {
  content: "";
}

.bxs-planet:before {
  content: "";
}

.bxs-plane-take-off:before {
  content: "";
}

.bxs-playlist:before {
  content: "";
}

.bxs-plug:before {
  content: "";
}

.bxs-plus-circle:before {
  content: "";
}

.bxs-plus-square:before {
  content: "";
}

.bxs-pointer:before {
  content: "";
}

.bxs-polygon:before {
  content: "";
}

.bxs-printer:before {
  content: "";
}

.bxs-purchase-tag:before {
  content: "";
}

.bxs-purchase-tag-alt:before {
  content: "";
}

.bxs-pyramid:before {
  content: "";
}

.bxs-quote-alt-left:before {
  content: "";
}

.bxs-quote-alt-right:before {
  content: "";
}

.bxs-quote-left:before {
  content: "";
}

.bxs-quote-right:before {
  content: "";
}

.bxs-quote-single-left:before {
  content: "";
}

.bxs-quote-single-right:before {
  content: "";
}

.bxs-radiation:before {
  content: "";
}

.bxs-radio:before {
  content: "";
}

.bxs-receipt:before {
  content: "";
}

.bxs-rectangle:before {
  content: "";
}

.bxs-registered:before {
  content: "";
}

.bxs-rename:before {
  content: "";
}

.bxs-report:before {
  content: "";
}

.bxs-rewind-circle:before {
  content: "";
}

.bxs-right-arrow:before {
  content: "";
}

.bxs-right-arrow-alt:before {
  content: "";
}

.bxs-right-arrow-circle:before {
  content: "";
}

.bxs-right-arrow-square:before {
  content: "";
}

.bxs-right-down-arrow-circle:before {
  content: "";
}

.bxs-right-top-arrow-circle:before {
  content: "";
}

.bxs-rocket:before {
  content: "";
}

.bxs-ruler:before {
  content: "";
}

.bxs-sad:before {
  content: "";
}

.bxs-save:before {
  content: "";
}

.bxs-school:before {
  content: "";
}

.bxs-search:before {
  content: "";
}

.bxs-search-alt-2:before {
  content: "";
}

.bxs-select-multiple:before {
  content: "";
}

.bxs-send:before {
  content: "";
}

.bxs-server:before {
  content: "";
}

.bxs-shapes:before {
  content: "";
}

.bxs-share:before {
  content: "";
}

.bxs-share-alt:before {
  content: "";
}

.bxs-shield:before {
  content: "";
}

.bxs-shield-alt-2:before {
  content: "";
}

.bxs-shield-x:before {
  content: "";
}

.bxs-ship:before {
  content: "";
}

.bxs-shocked:before {
  content: "";
}

.bxs-shopping-bag:before {
  content: "";
}

.bxs-shopping-bag-alt:before {
  content: "";
}

.bxs-shopping-bags:before {
  content: "";
}

.bxs-show:before {
  content: "";
}

.bxs-skip-next-circle:before {
  content: "";
}

.bxs-skip-previous-circle:before {
  content: "";
}

.bxs-skull:before {
  content: "";
}

.bxs-sleepy:before {
  content: "";
}

.bxs-slideshow:before {
  content: "";
}

.bxs-smile:before {
  content: "";
}

.bxs-sort-alt:before {
  content: "";
}

.bxs-spa:before {
  content: "";
}

.bxs-speaker:before {
  content: "";
}

.bxs-spray-can:before {
  content: "";
}

.bxs-spreadsheet:before {
  content: "";
}

.bxs-square:before {
  content: "";
}

.bxs-square-rounded:before {
  content: "";
}

.bxs-star:before {
  content: "";
}

.bxs-star-half:before {
  content: "";
}

.bxs-sticker:before {
  content: "";
}

.bxs-stopwatch:before {
  content: "";
}

.bxs-store:before {
  content: "";
}

.bxs-store-alt:before {
  content: "";
}

.bxs-sun:before {
  content: "";
}

.bxs-tachometer:before {
  content: "";
}

.bxs-tag:before {
  content: "";
}

.bxs-tag-alt:before {
  content: "";
}

.bxs-tag-x:before {
  content: "";
}

.bxs-taxi:before {
  content: "";
}

.bxs-tennis-ball:before {
  content: "";
}

.bxs-terminal:before {
  content: "";
}

.bxs-thermometer:before {
  content: "";
}

.bxs-time:before {
  content: "";
}

.bxs-time-five:before {
  content: "";
}

.bxs-timer:before {
  content: "";
}

.bxs-tired:before {
  content: "";
}

.bxs-toggle-left:before {
  content: "";
}

.bxs-toggle-right:before {
  content: "";
}

.bxs-tone:before {
  content: "";
}

.bxs-torch:before {
  content: "";
}

.bxs-to-top:before {
  content: "";
}

.bxs-traffic:before {
  content: "";
}

.bxs-traffic-barrier:before {
  content: "";
}

.bxs-traffic-cone:before {
  content: "";
}

.bxs-train:before {
  content: "";
}

.bxs-trash:before {
  content: "";
}

.bxs-trash-alt:before {
  content: "";
}

.bxs-tree:before {
  content: "";
}

.bxs-trophy:before {
  content: "";
}

.bxs-truck:before {
  content: "";
}

.bxs-t-shirt:before {
  content: "";
}

.bxs-tv:before {
  content: "";
}

.bxs-up-arrow:before {
  content: "";
}

.bxs-up-arrow-alt:before {
  content: "";
}

.bxs-up-arrow-circle:before {
  content: "";
}

.bxs-up-arrow-square:before {
  content: "";
}

.bxs-upside-down:before {
  content: "";
}

.bxs-upvote:before {
  content: "";
}

.bxs-user:before {
  content: "";
}

.bxs-user-account:before {
  content: "";
}

.bxs-user-badge:before {
  content: "";
}

.bxs-user-check:before {
  content: "";
}

.bxs-user-circle:before {
  content: "";
}

.bxs-user-detail:before {
  content: "";
}

.bxs-user-minus:before {
  content: "";
}

.bxs-user-pin:before {
  content: "";
}

.bxs-user-plus:before {
  content: "";
}

.bxs-user-rectangle:before {
  content: "";
}

.bxs-user-voice:before {
  content: "";
}

.bxs-user-x:before {
  content: "";
}

.bxs-vector:before {
  content: "";
}

.bxs-vial:before {
  content: "";
}

.bxs-video:before {
  content: "";
}

.bxs-video-off:before {
  content: "";
}

.bxs-video-plus:before {
  content: "";
}

.bxs-video-recording:before {
  content: "";
}

.bxs-videos:before {
  content: "";
}

.bxs-virus:before {
  content: "";
}

.bxs-virus-block:before {
  content: "";
}

.bxs-volume:before {
  content: "";
}

.bxs-volume-full:before {
  content: "";
}

.bxs-volume-low:before {
  content: "";
}

.bxs-volume-mute:before {
  content: "";
}

.bxs-wallet:before {
  content: "";
}

.bxs-wallet-alt:before {
  content: "";
}

.bxs-washer:before {
  content: "";
}

.bxs-watch:before {
  content: "";
}

.bxs-watch-alt:before {
  content: "";
}

.bxs-webcam:before {
  content: "";
}

.bxs-widget:before {
  content: "";
}

.bxs-window-alt:before {
  content: "";
}

.bxs-wine:before {
  content: "";
}

.bxs-wink-smile:before {
  content: "";
}

.bxs-wink-tongue:before {
  content: "";
}

.bxs-wrench:before {
  content: "";
}

.bxs-x-circle:before {
  content: "";
}

.bxs-x-square:before {
  content: "";
}

.bxs-yin-yang:before {
  content: "";
}

.bxs-zap:before {
  content: "";
}

.bxs-zoom-in:before {
  content: "";
}

.bxs-zoom-out:before {
  content: "";
}

.la,
.las,
.lar,
.lal,
.lad,
.lab {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}

.la-lg {
  font-size: 1.33333em;
  line-height: 0.75em;
  vertical-align: -0.0667em;
}

.la-xs {
  font-size: 0.75em;
}

.la-sm {
  font-size: 0.875em;
}

.la-1x {
  font-size: 1em;
}

.la-2x {
  font-size: 2em;
}

.la-3x {
  font-size: 3em;
}

.la-4x {
  font-size: 4em;
}

.la-5x {
  font-size: 5em;
}

.la-6x {
  font-size: 6em;
}

.la-7x {
  font-size: 7em;
}

.la-8x {
  font-size: 8em;
}

.la-9x {
  font-size: 9em;
}

.la-10x {
  font-size: 10em;
}

.la-fw {
  text-align: center;
  width: 1.25em;
}

.la-ul {
  list-style-type: none;
  margin-left: 2.5em;
  padding-left: 0;
}

.la-ul > li {
  position: relative;
}

.la-li {
  left: -2em;
  position: absolute;
  text-align: center;
  width: 2em;
  line-height: inherit;
}

.la-border {
  border: solid 0.08em #eee;
  border-radius: 0.1em;
  padding: 0.2em 0.25em 0.15em;
}

.la-pull-left {
  float: left;
}

.la-pull-right {
  float: right;
}

.la.la-pull-left,
.las.la-pull-left,
.lar.la-pull-left,
.lal.la-pull-left,
.lab.la-pull-left {
  margin-right: 0.3em;
}

.la.la-pull-right,
.las.la-pull-right,
.lar.la-pull-right,
.lal.la-pull-right,
.lab.la-pull-right {
  margin-left: 0.3em;
}

.la-spin {
  animation: la-spin 2s infinite linear;
}

.la-pulse {
  animation: la-spin 1s infinite steps(8);
}
@keyframes la-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.la-rotate-90 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
  transform: rotate(90deg);
}

.la-rotate-180 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
  transform: rotate(180deg);
}

.la-rotate-270 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
  transform: rotate(270deg);
}

.la-flip-horizontal {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
  transform: scale(-1, 1);
}

.la-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(1, -1);
}

.la-flip-both, .la-flip-horizontal.la-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(-1, -1);
}

:root .la-rotate-90,
:root .la-rotate-180,
:root .la-rotate-270,
:root .la-flip-horizontal,
:root .la-flip-vertical,
:root .la-flip-both {
  filter: none;
}

.la-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em;
}

.la-stack-1x,
.la-stack-2x {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%;
}

.la-stack-1x {
  line-height: inherit;
}

.la-stack-2x {
  font-size: 2em;
}

.la-inverse {
  color: #fff;
}

/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
readers do not read off random characters that represent icons */
.la-500px:before {
  content: "";
}

.la-accessible-icon:before {
  content: "";
}

.la-accusoft:before {
  content: "";
}

.la-acquisitions-incorporated:before {
  content: "";
}

.la-ad:before {
  content: "";
}

.la-address-book:before {
  content: "";
}

.la-address-card:before {
  content: "";
}

.la-adjust:before {
  content: "";
}

.la-adn:before {
  content: "";
}

.la-adobe:before {
  content: "";
}

.la-adversal:before {
  content: "";
}

.la-affiliatetheme:before {
  content: "";
}

.la-air-freshener:before {
  content: "";
}

.la-airbnb:before {
  content: "";
}

.la-algolia:before {
  content: "";
}

.la-align-center:before {
  content: "";
}

.la-align-justify:before {
  content: "";
}

.la-align-left:before {
  content: "";
}

.la-align-right:before {
  content: "";
}

.la-alipay:before {
  content: "";
}

.la-allergies:before {
  content: "";
}

.la-amazon:before {
  content: "";
}

.la-amazon-pay:before {
  content: "";
}

.la-ambulance:before {
  content: "";
}

.la-american-sign-language-interpreting:before {
  content: "";
}

.la-amilia:before {
  content: "";
}

.la-anchor:before {
  content: "";
}

.la-android:before {
  content: "";
}

.la-angellist:before {
  content: "";
}

.la-angle-double-down:before {
  content: "";
}

.la-angle-double-left:before {
  content: "";
}

.la-angle-double-right:before {
  content: "";
}

.la-angle-double-up:before {
  content: "";
}

.la-angle-down:before {
  content: "";
}

.la-angle-left:before {
  content: "";
}

.la-angle-right:before {
  content: "";
}

.la-angle-up:before {
  content: "";
}

.la-angry:before {
  content: "";
}

.la-angrycreative:before {
  content: "";
}

.la-angular:before {
  content: "";
}

.la-ankh:before {
  content: "";
}

.la-app-store:before {
  content: "";
}

.la-app-store-ios:before {
  content: "";
}

.la-apper:before {
  content: "";
}

.la-apple:before {
  content: "";
}

.la-apple-alt:before {
  content: "";
}

.la-apple-pay:before {
  content: "";
}

.la-archive:before {
  content: "";
}

.la-archway:before {
  content: "";
}

.la-arrow-alt-circle-down:before {
  content: "";
}

.la-arrow-alt-circle-left:before {
  content: "";
}

.la-arrow-alt-circle-right:before {
  content: "";
}

.la-arrow-alt-circle-up:before {
  content: "";
}

.la-arrow-circle-down:before {
  content: "";
}

.la-arrow-circle-left:before {
  content: "";
}

.la-arrow-circle-right:before {
  content: "";
}

.la-arrow-circle-up:before {
  content: "";
}

.la-arrow-down:before {
  content: "";
}

.la-arrow-left:before {
  content: "";
}

.la-arrow-right:before {
  content: "";
}

.la-arrow-up:before {
  content: "";
}

.la-arrows-alt:before {
  content: "";
}

.la-arrows-alt-h:before {
  content: "";
}

.la-arrows-alt-v:before {
  content: "";
}

.la-artstation:before {
  content: "";
}

.la-assistive-listening-systems:before {
  content: "";
}

.la-asterisk:before {
  content: "";
}

.la-asymmetrik:before {
  content: "";
}

.la-at:before {
  content: "";
}

.la-atlas:before {
  content: "";
}

.la-atlassian:before {
  content: "";
}

.la-atom:before {
  content: "";
}

.la-audible:before {
  content: "";
}

.la-audio-description:before {
  content: "";
}

.la-autoprefixer:before {
  content: "";
}

.la-avianex:before {
  content: "";
}

.la-aviato:before {
  content: "";
}

.la-award:before {
  content: "";
}

.la-aws:before {
  content: "";
}

.la-baby:before {
  content: "";
}

.la-baby-carriage:before {
  content: "";
}

.la-backspace:before {
  content: "";
}

.la-backward:before {
  content: "";
}

.la-bacon:before {
  content: "";
}

.la-balance-scale:before {
  content: "";
}

.la-balance-scale-left:before {
  content: "";
}

.la-balance-scale-right:before {
  content: "";
}

.la-ban:before {
  content: "";
}

.la-band-aid:before {
  content: "";
}

.la-bandcamp:before {
  content: "";
}

.la-barcode:before {
  content: "";
}

.la-bars:before {
  content: "";
}

.la-baseball-ball:before {
  content: "";
}

.la-basketball-ball:before {
  content: "";
}

.la-bath:before {
  content: "";
}

.la-battery-empty:before {
  content: "";
}

.la-battery-full:before {
  content: "";
}

.la-battery-half:before {
  content: "";
}

.la-battery-quarter:before {
  content: "";
}

.la-battery-three-quarters:before {
  content: "";
}

.la-battle-net:before {
  content: "";
}

.la-bed:before {
  content: "";
}

.la-beer:before {
  content: "";
}

.la-behance:before {
  content: "";
}

.la-behance-square:before {
  content: "";
}

.la-bell:before {
  content: "";
}

.la-bell-slash:before {
  content: "";
}

.la-bezier-curve:before {
  content: "";
}

.la-bible:before {
  content: "";
}

.la-bicycle:before {
  content: "";
}

.la-biking:before {
  content: "";
}

.la-bimobject:before {
  content: "";
}

.la-binoculars:before {
  content: "";
}

.la-biohazard:before {
  content: "";
}

.la-birthday-cake:before {
  content: "";
}

.la-bitbucket:before {
  content: "";
}

.la-bitcoin:before {
  content: "";
}

.la-bity:before {
  content: "";
}

.la-black-tie:before {
  content: "";
}

.la-blackberry:before {
  content: "";
}

.la-blender:before {
  content: "";
}

.la-blender-phone:before {
  content: "";
}

.la-blind:before {
  content: "";
}

.la-blog:before {
  content: "";
}

.la-blogger:before {
  content: "";
}

.la-blogger-b:before {
  content: "";
}

.la-bluetooth:before {
  content: "";
}

.la-bluetooth-b:before {
  content: "";
}

.la-bold:before {
  content: "";
}

.la-bolt:before {
  content: "";
}

.la-bomb:before {
  content: "";
}

.la-bone:before {
  content: "";
}

.la-bong:before {
  content: "";
}

.la-book:before {
  content: "";
}

.la-book-dead:before {
  content: "";
}

.la-book-medical:before {
  content: "";
}

.la-book-open:before {
  content: "";
}

.la-book-reader:before {
  content: "";
}

.la-bookmark:before {
  content: "";
}

.la-bootstrap:before {
  content: "";
}

.la-border-all:before {
  content: "";
}

.la-border-none:before {
  content: "";
}

.la-border-style:before {
  content: "";
}

.la-bowling-ball:before {
  content: "";
}

.la-box:before {
  content: "";
}

.la-box-open:before {
  content: "";
}

.la-boxes:before {
  content: "";
}

.la-braille:before {
  content: "";
}

.la-brain:before {
  content: "";
}

.la-bread-slice:before {
  content: "";
}

.la-briefcase:before {
  content: "";
}

.la-briefcase-medical:before {
  content: "";
}

.la-broadcast-tower:before {
  content: "";
}

.la-broom:before {
  content: "";
}

.la-brush:before {
  content: "";
}

.la-btc:before {
  content: "";
}

.la-buffer:before {
  content: "";
}

.la-bug:before {
  content: "";
}

.la-building:before {
  content: "";
}

.la-bullhorn:before {
  content: "";
}

.la-bullseye:before {
  content: "";
}

.la-burn:before {
  content: "";
}

.la-buromobelexperte:before {
  content: "";
}

.la-bus:before {
  content: "";
}

.la-bus-alt:before {
  content: "";
}

.la-business-time:before {
  content: "";
}

.la-buy-n-large:before {
  content: "";
}

.la-buysellads:before {
  content: "";
}

.la-calculator:before {
  content: "";
}

.la-calendar:before {
  content: "";
}

.la-calendar-alt:before {
  content: "";
}

.la-calendar-check:before {
  content: "";
}

.la-calendar-day:before {
  content: "";
}

.la-calendar-minus:before {
  content: "";
}

.la-calendar-plus:before {
  content: "";
}

.la-calendar-times:before {
  content: "";
}

.la-calendar-week:before {
  content: "";
}

.la-camera:before {
  content: "";
}

.la-camera-retro:before {
  content: "";
}

.la-campground:before {
  content: "";
}

.la-canadian-maple-leaf:before {
  content: "";
}

.la-candy-cane:before {
  content: "";
}

.la-cannabis:before {
  content: "";
}

.la-capsules:before {
  content: "";
}

.la-car:before {
  content: "";
}

.la-car-alt:before {
  content: "";
}

.la-car-battery:before {
  content: "";
}

.la-car-crash:before {
  content: "";
}

.la-car-side:before {
  content: "";
}

.la-caret-down:before {
  content: "";
}

.la-caret-left:before {
  content: "";
}

.la-caret-right:before {
  content: "";
}

.la-caret-square-down:before {
  content: "";
}

.la-caret-square-left:before {
  content: "";
}

.la-caret-square-right:before {
  content: "";
}

.la-caret-square-up:before {
  content: "";
}

.la-caret-up:before {
  content: "";
}

.la-carrot:before {
  content: "";
}

.la-cart-arrow-down:before {
  content: "";
}

.la-cart-plus:before {
  content: "";
}

.la-cash-register:before {
  content: "";
}

.la-cat:before {
  content: "";
}

.la-cc-amazon-pay:before {
  content: "";
}

.la-cc-amex:before {
  content: "";
}

.la-cc-apple-pay:before {
  content: "";
}

.la-cc-diners-club:before {
  content: "";
}

.la-cc-discover:before {
  content: "";
}

.la-cc-jcb:before {
  content: "";
}

.la-cc-mastercard:before {
  content: "";
}

.la-cc-paypal:before {
  content: "";
}

.la-cc-stripe:before {
  content: "";
}

.la-cc-visa:before {
  content: "";
}

.la-centercode:before {
  content: "";
}

.la-centos:before {
  content: "";
}

.la-certificate:before {
  content: "";
}

.la-chair:before {
  content: "";
}

.la-chalkboard:before {
  content: "";
}

.la-chalkboard-teacher:before {
  content: "";
}

.la-charging-station:before {
  content: "";
}

.la-chart-area:before {
  content: "";
}

.la-chart-bar:before {
  content: "";
}

.la-chart-line:before {
  content: "";
}

.la-chart-pie:before {
  content: "";
}

.la-check:before {
  content: "";
}

.la-check-circle:before {
  content: "";
}

.la-check-double:before {
  content: "";
}

.la-check-square:before {
  content: "";
}

.la-cheese:before {
  content: "";
}

.la-chess:before {
  content: "";
}

.la-chess-bishop:before {
  content: "";
}

.la-chess-board:before {
  content: "";
}

.la-chess-king:before {
  content: "";
}

.la-chess-knight:before {
  content: "";
}

.la-chess-pawn:before {
  content: "";
}

.la-chess-queen:before {
  content: "";
}

.la-chess-rook:before {
  content: "";
}

.la-chevron-circle-down:before {
  content: "";
}

.la-chevron-circle-left:before {
  content: "";
}

.la-chevron-circle-right:before {
  content: "";
}

.la-chevron-circle-up:before {
  content: "";
}

.la-chevron-down:before {
  content: "";
}

.la-chevron-left:before {
  content: "";
}

.la-chevron-right:before {
  content: "";
}

.la-chevron-up:before {
  content: "";
}

.la-child:before {
  content: "";
}

.la-chrome:before {
  content: "";
}

.la-chromecast:before {
  content: "";
}

.la-church:before {
  content: "";
}

.la-circle:before {
  content: "";
}

.la-circle-notch:before {
  content: "";
}

.la-city:before {
  content: "";
}

.la-clinic-medical:before {
  content: "";
}

.la-clipboard:before {
  content: "";
}

.la-clipboard-check:before {
  content: "";
}

.la-clipboard-list:before {
  content: "";
}

.la-clock:before {
  content: "";
}

.la-clone:before {
  content: "";
}

.la-closed-captioning:before {
  content: "";
}

.la-cloud:before {
  content: "";
}

.la-cloud-download-alt:before {
  content: "";
}

.la-cloud-meatball:before {
  content: "";
}

.la-cloud-moon:before {
  content: "";
}

.la-cloud-moon-rain:before {
  content: "";
}

.la-cloud-rain:before {
  content: "";
}

.la-cloud-showers-heavy:before {
  content: "";
}

.la-cloud-sun:before {
  content: "";
}

.la-cloud-sun-rain:before {
  content: "";
}

.la-cloud-upload-alt:before {
  content: "";
}

.la-cloudscale:before {
  content: "";
}

.la-cloudsmith:before {
  content: "";
}

.la-cloudversify:before {
  content: "";
}

.la-cocktail:before {
  content: "";
}

.la-code:before {
  content: "";
}

.la-code-branch:before {
  content: "";
}

.la-codepen:before {
  content: "";
}

.la-codiepie:before {
  content: "";
}

.la-coffee:before {
  content: "";
}

.la-cog:before {
  content: "";
}

.la-cogs:before {
  content: "";
}

.la-coins:before {
  content: "";
}

.la-columns:before {
  content: "";
}

.la-comment:before {
  content: "";
}

.la-comment-alt:before {
  content: "";
}

.la-comment-dollar:before {
  content: "";
}

.la-comment-dots:before {
  content: "";
}

.la-comment-medical:before {
  content: "";
}

.la-comment-slash:before {
  content: "";
}

.la-comments:before {
  content: "";
}

.la-comments-dollar:before {
  content: "";
}

.la-compact-disc:before {
  content: "";
}

.la-compass:before {
  content: "";
}

.la-compress:before {
  content: "";
}

.la-compress-arrows-alt:before {
  content: "";
}

.la-concierge-bell:before {
  content: "";
}

.la-confluence:before {
  content: "";
}

.la-connectdevelop:before {
  content: "";
}

.la-contao:before {
  content: "";
}

.la-cookie:before {
  content: "";
}

.la-cookie-bite:before {
  content: "";
}

.la-copy:before {
  content: "";
}

.la-copyright:before {
  content: "";
}

.la-cotton-bureau:before {
  content: "";
}

.la-couch:before {
  content: "";
}

.la-cpanel:before {
  content: "";
}

.la-creative-commons:before {
  content: "";
}

.la-creative-commons-by:before {
  content: "";
}

.la-creative-commons-nc:before {
  content: "";
}

.la-creative-commons-nc-eu:before {
  content: "";
}

.la-creative-commons-nc-jp:before {
  content: "";
}

.la-creative-commons-nd:before {
  content: "";
}

.la-creative-commons-pd:before {
  content: "";
}

.la-creative-commons-pd-alt:before {
  content: "";
}

.la-creative-commons-remix:before {
  content: "";
}

.la-creative-commons-sa:before {
  content: "";
}

.la-creative-commons-sampling:before {
  content: "";
}

.la-creative-commons-sampling-plus:before {
  content: "";
}

.la-creative-commons-share:before {
  content: "";
}

.la-creative-commons-zero:before {
  content: "";
}

.la-credit-card:before {
  content: "";
}

.la-critical-role:before {
  content: "";
}

.la-crop:before {
  content: "";
}

.la-crop-alt:before {
  content: "";
}

.la-cross:before {
  content: "";
}

.la-crosshairs:before {
  content: "";
}

.la-crow:before {
  content: "";
}

.la-crown:before {
  content: "";
}

.la-crutch:before {
  content: "";
}

.la-css3:before {
  content: "";
}

.la-css3-alt:before {
  content: "";
}

.la-cube:before {
  content: "";
}

.la-cubes:before {
  content: "";
}

.la-cut:before {
  content: "";
}

.la-cuttlefish:before {
  content: "";
}

.la-d-and-d:before {
  content: "";
}

.la-d-and-d-beyond:before {
  content: "";
}

.la-dashcube:before {
  content: "";
}

.la-database:before {
  content: "";
}

.la-deaf:before {
  content: "";
}

.la-delicious:before {
  content: "";
}

.la-democrat:before {
  content: "";
}

.la-deploydog:before {
  content: "";
}

.la-deskpro:before {
  content: "";
}

.la-desktop:before {
  content: "";
}

.la-dev:before {
  content: "";
}

.la-deviantart:before {
  content: "";
}

.la-dharmachakra:before {
  content: "";
}

.la-dhl:before {
  content: "";
}

.la-diagnoses:before {
  content: "";
}

.la-diaspora:before {
  content: "";
}

.la-dice:before {
  content: "";
}

.la-dice-d20:before {
  content: "";
}

.la-dice-d6:before {
  content: "";
}

.la-dice-five:before {
  content: "";
}

.la-dice-four:before {
  content: "";
}

.la-dice-one:before {
  content: "";
}

.la-dice-six:before {
  content: "";
}

.la-dice-three:before {
  content: "";
}

.la-dice-two:before {
  content: "";
}

.la-digg:before {
  content: "";
}

.la-digital-ocean:before {
  content: "";
}

.la-digital-tachograph:before {
  content: "";
}

.la-directions:before {
  content: "";
}

.la-discord:before {
  content: "";
}

.la-discourse:before {
  content: "";
}

.la-divide:before {
  content: "";
}

.la-dizzy:before {
  content: "";
}

.la-dna:before {
  content: "";
}

.la-dochub:before {
  content: "";
}

.la-docker:before {
  content: "";
}

.la-dog:before {
  content: "";
}

.la-dollar-sign:before {
  content: "";
}

.la-dolly:before {
  content: "";
}

.la-dolly-flatbed:before {
  content: "";
}

.la-donate:before {
  content: "";
}

.la-door-closed:before {
  content: "";
}

.la-door-open:before {
  content: "";
}

.la-dot-circle:before {
  content: "";
}

.la-dove:before {
  content: "";
}

.la-download:before {
  content: "";
}

.la-draft2digital:before {
  content: "";
}

.la-drafting-compass:before {
  content: "";
}

.la-dragon:before {
  content: "";
}

.la-draw-polygon:before {
  content: "";
}

.la-dribbble:before {
  content: "";
}

.la-dribbble-square:before {
  content: "";
}

.la-dropbox:before {
  content: "";
}

.la-drum:before {
  content: "";
}

.la-drum-steelpan:before {
  content: "";
}

.la-drumstick-bite:before {
  content: "";
}

.la-drupal:before {
  content: "";
}

.la-dumbbell:before {
  content: "";
}

.la-dumpster:before {
  content: "";
}

.la-dumpster-fire:before {
  content: "";
}

.la-dungeon:before {
  content: "";
}

.la-dyalog:before {
  content: "";
}

.la-earlybirds:before {
  content: "";
}

.la-ebay:before {
  content: "";
}

.la-edge:before {
  content: "";
}

.la-edit:before {
  content: "";
}

.la-egg:before {
  content: "";
}

.la-eject:before {
  content: "";
}

.la-elementor:before {
  content: "";
}

.la-ellipsis-h:before {
  content: "";
}

.la-ellipsis-v:before {
  content: "";
}

.la-ello:before {
  content: "";
}

.la-ember:before {
  content: "";
}

.la-empire:before {
  content: "";
}

.la-envelope:before {
  content: "";
}

.la-envelope-open:before {
  content: "";
}

.la-envelope-open-text:before {
  content: "";
}

.la-envelope-square:before {
  content: "";
}

.la-envira:before {
  content: "";
}

.la-equals:before {
  content: "";
}

.la-eraser:before {
  content: "";
}

.la-erlang:before {
  content: "";
}

.la-ethereum:before {
  content: "";
}

.la-ethernet:before {
  content: "";
}

.la-etsy:before {
  content: "";
}

.la-euro-sign:before {
  content: "";
}

.la-evernote:before {
  content: "";
}

.la-exchange-alt:before {
  content: "";
}

.la-exclamation:before {
  content: "";
}

.la-exclamation-circle:before {
  content: "";
}

.la-exclamation-triangle:before {
  content: "";
}

.la-expand:before {
  content: "";
}

.la-expand-arrows-alt:before {
  content: "";
}

.la-expeditedssl:before {
  content: "";
}

.la-external-link-alt:before {
  content: "";
}

.la-external-link-square-alt:before {
  content: "";
}

.la-eye:before {
  content: "";
}

.la-eye-dropper:before {
  content: "";
}

.la-eye-slash:before {
  content: "";
}

.la-facebook:before {
  content: "";
}

.la-facebook-f:before {
  content: "";
}

.la-facebook-messenger:before {
  content: "";
}

.la-facebook-square:before {
  content: "";
}

.la-fan:before {
  content: "";
}

.la-fantasy-flight-games:before {
  content: "";
}

.la-fast-backward:before {
  content: "";
}

.la-fast-forward:before {
  content: "";
}

.la-fax:before {
  content: "";
}

.la-feather:before {
  content: "";
}

.la-feather-alt:before {
  content: "";
}

.la-fedex:before {
  content: "";
}

.la-fedora:before {
  content: "";
}

.la-female:before {
  content: "";
}

.la-fighter-jet:before {
  content: "";
}

.la-figma:before {
  content: "";
}

.la-file:before {
  content: "";
}

.la-file-alt:before {
  content: "";
}

.la-file-archive:before {
  content: "";
}

.la-file-audio:before {
  content: "";
}

.la-file-code:before {
  content: "";
}

.la-file-contract:before {
  content: "";
}

.la-file-csv:before {
  content: "";
}

.la-file-download:before {
  content: "";
}

.la-file-excel:before {
  content: "";
}

.la-file-export:before {
  content: "";
}

.la-file-image:before {
  content: "";
}

.la-file-import:before {
  content: "";
}

.la-file-invoice:before {
  content: "";
}

.la-file-invoice-dollar:before {
  content: "";
}

.la-file-medical:before {
  content: "";
}

.la-file-medical-alt:before {
  content: "";
}

.la-file-pdf:before {
  content: "";
}

.la-file-powerpoint:before {
  content: "";
}

.la-file-prescription:before {
  content: "";
}

.la-file-signature:before {
  content: "";
}

.la-file-upload:before {
  content: "";
}

.la-file-video:before {
  content: "";
}

.la-file-word:before {
  content: "";
}

.la-fill:before {
  content: "";
}

.la-fill-drip:before {
  content: "";
}

.la-film:before {
  content: "";
}

.la-filter:before {
  content: "";
}

.la-fingerprint:before {
  content: "";
}

.la-fire:before {
  content: "";
}

.la-fire-alt:before {
  content: "";
}

.la-fire-extinguisher:before {
  content: "";
}

.la-firefox:before {
  content: "";
}

.la-first-aid:before {
  content: "";
}

.la-first-order:before {
  content: "";
}

.la-first-order-alt:before {
  content: "";
}

.la-firstdraft:before {
  content: "";
}

.la-fish:before {
  content: "";
}

.la-fist-raised:before {
  content: "";
}

.la-flag:before {
  content: "";
}

.la-flag-checkered:before {
  content: "";
}

.la-flag-usa:before {
  content: "";
}

.la-flask:before {
  content: "";
}

.la-flickr:before {
  content: "";
}

.la-flipboard:before {
  content: "";
}

.la-flushed:before {
  content: "";
}

.la-fly:before {
  content: "";
}

.la-folder:before {
  content: "";
}

.la-folder-minus:before {
  content: "";
}

.la-folder-open:before {
  content: "";
}

.la-folder-plus:before {
  content: "";
}

.la-font:before {
  content: "";
}

.la-font-awesome:before {
  content: "";
}

.la-font-awesome-alt:before {
  content: "";
}

.la-font-awesome-flag:before {
  content: "";
}

.la-font-awesome-logo-full:before {
  content: "";
}

.la-fonticons:before {
  content: "";
}

.la-fonticons-fi:before {
  content: "";
}

.la-football-ball:before {
  content: "";
}

.la-fort-awesome:before {
  content: "";
}

.la-fort-awesome-alt:before {
  content: "";
}

.la-forumbee:before {
  content: "";
}

.la-forward:before {
  content: "";
}

.la-foursquare:before {
  content: "";
}

.la-free-code-camp:before {
  content: "";
}

.la-freebsd:before {
  content: "";
}

.la-frog:before {
  content: "";
}

.la-frown:before {
  content: "";
}

.la-frown-open:before {
  content: "";
}

.la-fulcrum:before {
  content: "";
}

.la-funnel-dollar:before {
  content: "";
}

.la-futbol:before {
  content: "";
}

.la-galactic-republic:before {
  content: "";
}

.la-galactic-senate:before {
  content: "";
}

.la-gamepad:before {
  content: "";
}

.la-gas-pump:before {
  content: "";
}

.la-gavel:before {
  content: "";
}

.la-gem:before {
  content: "";
}

.la-genderless:before {
  content: "";
}

.la-get-pocket:before {
  content: "";
}

.la-gg:before {
  content: "";
}

.la-gg-circle:before {
  content: "";
}

.la-ghost:before {
  content: "";
}

.la-gift:before {
  content: "";
}

.la-gifts:before {
  content: "";
}

.la-git:before {
  content: "";
}

.la-git-alt:before {
  content: "";
}

.la-git-square:before {
  content: "";
}

.la-github:before {
  content: "";
}

.la-github-alt:before {
  content: "";
}

.la-github-square:before {
  content: "";
}

.la-gitkraken:before {
  content: "";
}

.la-gitlab:before {
  content: "";
}

.la-gitter:before {
  content: "";
}

.la-glass-cheers:before {
  content: "";
}

.la-glass-martini:before {
  content: "";
}

.la-glass-martini-alt:before {
  content: "";
}

.la-glass-whiskey:before {
  content: "";
}

.la-glasses:before {
  content: "";
}

.la-glide:before {
  content: "";
}

.la-glide-g:before {
  content: "";
}

.la-globe:before {
  content: "";
}

.la-globe-africa:before {
  content: "";
}

.la-globe-americas:before {
  content: "";
}

.la-globe-asia:before {
  content: "";
}

.la-globe-europe:before {
  content: "";
}

.la-gofore:before {
  content: "";
}

.la-golf-ball:before {
  content: "";
}

.la-goodreads:before {
  content: "";
}

.la-goodreads-g:before {
  content: "";
}

.la-google:before {
  content: "";
}

.la-google-drive:before {
  content: "";
}

.la-google-play:before {
  content: "";
}

.la-google-plus:before {
  content: "";
}

.la-google-plus-g:before {
  content: "";
}

.la-google-plus-square:before {
  content: "";
}

.la-google-wallet:before {
  content: "";
}

.la-gopuram:before {
  content: "";
}

.la-graduation-cap:before {
  content: "";
}

.la-gratipay:before {
  content: "";
}

.la-grav:before {
  content: "";
}

.la-greater-than:before {
  content: "";
}

.la-greater-than-equal:before {
  content: "";
}

.la-grimace:before {
  content: "";
}

.la-grin:before {
  content: "";
}

.la-grin-alt:before {
  content: "";
}

.la-grin-beam:before {
  content: "";
}

.la-grin-beam-sweat:before {
  content: "";
}

.la-grin-hearts:before {
  content: "";
}

.la-grin-squint:before {
  content: "";
}

.la-grin-squint-tears:before {
  content: "";
}

.la-grin-stars:before {
  content: "";
}

.la-grin-tears:before {
  content: "";
}

.la-grin-tongue:before {
  content: "";
}

.la-grin-tongue-squint:before {
  content: "";
}

.la-grin-tongue-wink:before {
  content: "";
}

.la-grin-wink:before {
  content: "";
}

.la-grip-horizontal:before {
  content: "";
}

.la-grip-lines:before {
  content: "";
}

.la-grip-lines-vertical:before {
  content: "";
}

.la-grip-vertical:before {
  content: "";
}

.la-gripfire:before {
  content: "";
}

.la-grunt:before {
  content: "";
}

.la-guitar:before {
  content: "";
}

.la-gulp:before {
  content: "";
}

.la-h-square:before {
  content: "";
}

.la-hacker-news:before {
  content: "";
}

.la-hacker-news-square:before {
  content: "";
}

.la-hackerrank:before {
  content: "";
}

.la-hamburger:before {
  content: "";
}

.la-hammer:before {
  content: "";
}

.la-hamsa:before {
  content: "";
}

.la-hand-holding:before {
  content: "";
}

.la-hand-holding-heart:before {
  content: "";
}

.la-hand-holding-usd:before {
  content: "";
}

.la-hand-lizard:before {
  content: "";
}

.la-hand-middle-finger:before {
  content: "";
}

.la-hand-paper:before {
  content: "";
}

.la-hand-peace:before {
  content: "";
}

.la-hand-point-down:before {
  content: "";
}

.la-hand-point-left:before {
  content: "";
}

.la-hand-point-right:before {
  content: "";
}

.la-hand-point-up:before {
  content: "";
}

.la-hand-pointer:before {
  content: "";
}

.la-hand-rock:before {
  content: "";
}

.la-hand-scissors:before {
  content: "";
}

.la-hand-spock:before {
  content: "";
}

.la-hands:before {
  content: "";
}

.la-hands-helping:before {
  content: "";
}

.la-handshake:before {
  content: "";
}

.la-hanukiah:before {
  content: "";
}

.la-hard-hat:before {
  content: "";
}

.la-hashtag:before {
  content: "";
}

.la-hat-cowboy:before {
  content: "";
}

.la-hat-cowboy-side:before {
  content: "";
}

.la-hat-wizard:before {
  content: "";
}

.la-haykal:before {
  content: "";
}

.la-hdd:before {
  content: "";
}

.la-heading:before {
  content: "";
}

.la-headphones:before {
  content: "";
}

.la-headphones-alt:before {
  content: "";
}

.la-headset:before {
  content: "";
}

.la-heart:before {
  content: "";
}

.la-heart-broken:before {
  content: "";
}

.la-heartbeat:before {
  content: "";
}

.la-helicopter:before {
  content: "";
}

.la-highlighter:before {
  content: "";
}

.la-hiking:before {
  content: "";
}

.la-hippo:before {
  content: "";
}

.la-hips:before {
  content: "";
}

.la-hire-a-helper:before {
  content: "";
}

.la-history:before {
  content: "";
}

.la-hockey-puck:before {
  content: "";
}

.la-holly-berry:before {
  content: "";
}

.la-home:before {
  content: "";
}

.la-hooli:before {
  content: "";
}

.la-hornbill:before {
  content: "";
}

.la-horse:before {
  content: "";
}

.la-horse-head:before {
  content: "";
}

.la-hospital:before {
  content: "";
}

.la-hospital-alt:before {
  content: "";
}

.la-hospital-symbol:before {
  content: "";
}

.la-hot-tub:before {
  content: "";
}

.la-hotdog:before {
  content: "";
}

.la-hotel:before {
  content: "";
}

.la-hotjar:before {
  content: "";
}

.la-hourglass:before {
  content: "";
}

.la-hourglass-end:before {
  content: "";
}

.la-hourglass-half:before {
  content: "";
}

.la-hourglass-start:before {
  content: "";
}

.la-house-damage:before {
  content: "";
}

.la-houzz:before {
  content: "";
}

.la-hryvnia:before {
  content: "";
}

.la-html5:before {
  content: "";
}

.la-hubspot:before {
  content: "";
}

.la-i-cursor:before {
  content: "";
}

.la-ice-cream:before {
  content: "";
}

.la-icicles:before {
  content: "";
}

.la-icons:before {
  content: "";
}

.la-id-badge:before {
  content: "";
}

.la-id-card:before {
  content: "";
}

.la-id-card-alt:before {
  content: "";
}

.la-igloo:before {
  content: "";
}

.la-image:before {
  content: "";
}

.la-images:before {
  content: "";
}

.la-imdb:before {
  content: "";
}

.la-inbox:before {
  content: "";
}

.la-indent:before {
  content: "";
}

.la-industry:before {
  content: "";
}

.la-infinity:before {
  content: "";
}

.la-info:before {
  content: "";
}

.la-info-circle:before {
  content: "";
}

.la-instagram:before {
  content: "";
}

.la-intercom:before {
  content: "";
}

.la-internet-explorer:before {
  content: "";
}

.la-invision:before {
  content: "";
}

.la-ioxhost:before {
  content: "";
}

.la-italic:before {
  content: "";
}

.la-itch-io:before {
  content: "";
}

.la-itunes:before {
  content: "";
}

.la-itunes-note:before {
  content: "";
}

.la-java:before {
  content: "";
}

.la-jedi:before {
  content: "";
}

.la-jedi-order:before {
  content: "";
}

.la-jenkins:before {
  content: "";
}

.la-jira:before {
  content: "";
}

.la-joget:before {
  content: "";
}

.la-joint:before {
  content: "";
}

.la-joomla:before {
  content: "";
}

.la-journal-whills:before {
  content: "";
}

.la-js:before {
  content: "";
}

.la-js-square:before {
  content: "";
}

.la-jsfiddle:before {
  content: "";
}

.la-kaaba:before {
  content: "";
}

.la-kaggle:before {
  content: "";
}

.la-key:before {
  content: "";
}

.la-keybase:before {
  content: "";
}

.la-keyboard:before {
  content: "";
}

.la-keycdn:before {
  content: "";
}

.la-khanda:before {
  content: "";
}

.la-kickstarter:before {
  content: "";
}

.la-kickstarter-k:before {
  content: "";
}

.la-kiss:before {
  content: "";
}

.la-kiss-beam:before {
  content: "";
}

.la-kiss-wink-heart:before {
  content: "";
}

.la-kiwi-bird:before {
  content: "";
}

.la-korvue:before {
  content: "";
}

.la-landmark:before {
  content: "";
}

.la-language:before {
  content: "";
}

.la-laptop:before {
  content: "";
}

.la-laptop-code:before {
  content: "";
}

.la-laptop-medical:before {
  content: "";
}

.la-laravel:before {
  content: "";
}

.la-lastfm:before {
  content: "";
}

.la-lastfm-square:before {
  content: "";
}

.la-laugh:before {
  content: "";
}

.la-laugh-beam:before {
  content: "";
}

.la-laugh-squint:before {
  content: "";
}

.la-laugh-wink:before {
  content: "";
}

.la-layer-group:before {
  content: "";
}

.la-leaf:before {
  content: "";
}

.la-leanpub:before {
  content: "";
}

.la-lemon:before {
  content: "";
}

.la-less:before {
  content: "";
}

.la-less-than:before {
  content: "";
}

.la-less-than-equal:before {
  content: "";
}

.la-level-down-alt:before {
  content: "";
}

.la-level-up-alt:before {
  content: "";
}

.la-life-ring:before {
  content: "";
}

.la-lightbulb:before {
  content: "";
}

.la-line:before {
  content: "";
}

.la-link:before {
  content: "";
}

.la-linkedin:before {
  content: "";
}

.la-linkedin-in:before {
  content: "";
}

.la-linode:before {
  content: "";
}

.la-linux:before {
  content: "";
}

.la-lira-sign:before {
  content: "";
}

.la-list:before {
  content: "";
}

.la-list-alt:before {
  content: "";
}

.la-list-ol:before {
  content: "";
}

.la-list-ul:before {
  content: "";
}

.la-location-arrow:before {
  content: "";
}

.la-lock:before {
  content: "";
}

.la-lock-open:before {
  content: "";
}

.la-long-arrow-alt-down:before {
  content: "";
}

.la-long-arrow-alt-left:before {
  content: "";
}

.la-long-arrow-alt-right:before {
  content: "";
}

.la-long-arrow-alt-up:before {
  content: "";
}

.la-low-vision:before {
  content: "";
}

.la-luggage-cart:before {
  content: "";
}

.la-lyft:before {
  content: "";
}

.la-magento:before {
  content: "";
}

.la-magic:before {
  content: "";
}

.la-magnet:before {
  content: "";
}

.la-mail-bulk:before {
  content: "";
}

.la-mailchimp:before {
  content: "";
}

.la-male:before {
  content: "";
}

.la-mandalorian:before {
  content: "";
}

.la-map:before {
  content: "";
}

.la-map-marked:before {
  content: "";
}

.la-map-marked-alt:before {
  content: "";
}

.la-map-marker:before {
  content: "";
}

.la-map-marker-alt:before {
  content: "";
}

.la-map-pin:before {
  content: "";
}

.la-map-signs:before {
  content: "";
}

.la-markdown:before {
  content: "";
}

.la-marker:before {
  content: "";
}

.la-mars:before {
  content: "";
}

.la-mars-double:before {
  content: "";
}

.la-mars-stroke:before {
  content: "";
}

.la-mars-stroke-h:before {
  content: "";
}

.la-mars-stroke-v:before {
  content: "";
}

.la-mask:before {
  content: "";
}

.la-mastodon:before {
  content: "";
}

.la-maxcdn:before {
  content: "";
}

.la-mdb:before {
  content: "";
}

.la-medal:before {
  content: "";
}

.la-medapps:before {
  content: "";
}

.la-medium:before {
  content: "";
}

.la-medium-m:before {
  content: "";
}

.la-medkit:before {
  content: "";
}

.la-medrt:before {
  content: "";
}

.la-meetup:before {
  content: "";
}

.la-megaport:before {
  content: "";
}

.la-meh:before {
  content: "";
}

.la-meh-blank:before {
  content: "";
}

.la-meh-rolling-eyes:before {
  content: "";
}

.la-memory:before {
  content: "";
}

.la-mendeley:before {
  content: "";
}

.la-menorah:before {
  content: "";
}

.la-mercury:before {
  content: "";
}

.la-meteor:before {
  content: "";
}

.la-microchip:before {
  content: "";
}

.la-microphone:before {
  content: "";
}

.la-microphone-alt:before {
  content: "";
}

.la-microphone-alt-slash:before {
  content: "";
}

.la-microphone-slash:before {
  content: "";
}

.la-microscope:before {
  content: "";
}

.la-microsoft:before {
  content: "";
}

.la-minus:before {
  content: "";
}

.la-minus-circle:before {
  content: "";
}

.la-minus-square:before {
  content: "";
}

.la-mitten:before {
  content: "";
}

.la-mix:before {
  content: "";
}

.la-mixcloud:before {
  content: "";
}

.la-mizuni:before {
  content: "";
}

.la-mobile:before {
  content: "";
}

.la-mobile-alt:before {
  content: "";
}

.la-modx:before {
  content: "";
}

.la-monero:before {
  content: "";
}

.la-money-bill:before {
  content: "";
}

.la-money-bill-alt:before {
  content: "";
}

.la-money-bill-wave:before {
  content: "";
}

.la-money-bill-wave-alt:before {
  content: "";
}

.la-money-check:before {
  content: "";
}

.la-money-check-alt:before {
  content: "";
}

.la-monument:before {
  content: "";
}

.la-moon:before {
  content: "";
}

.la-mortar-pestle:before {
  content: "";
}

.la-mosque:before {
  content: "";
}

.la-motorcycle:before {
  content: "";
}

.la-mountain:before {
  content: "";
}

.la-mouse:before {
  content: "";
}

.la-mouse-pointer:before {
  content: "";
}

.la-mug-hot:before {
  content: "";
}

.la-music:before {
  content: "";
}

.la-napster:before {
  content: "";
}

.la-neos:before {
  content: "";
}

.la-network-wired:before {
  content: "";
}

.la-neuter:before {
  content: "";
}

.la-newspaper:before {
  content: "";
}

.la-nimblr:before {
  content: "";
}

.la-node:before {
  content: "";
}

.la-node-js:before {
  content: "";
}

.la-not-equal:before {
  content: "";
}

.la-notes-medical:before {
  content: "";
}

.la-npm:before {
  content: "";
}

.la-ns8:before {
  content: "";
}

.la-nutritionix:before {
  content: "";
}

.la-object-group:before {
  content: "";
}

.la-object-ungroup:before {
  content: "";
}

.la-odnoklassniki:before {
  content: "";
}

.la-odnoklassniki-square:before {
  content: "";
}

.la-oil-can:before {
  content: "";
}

.la-old-republic:before {
  content: "";
}

.la-om:before {
  content: "";
}

.la-opencart:before {
  content: "";
}

.la-openid:before {
  content: "";
}

.la-opera:before {
  content: "";
}

.la-optin-monster:before {
  content: "";
}

.la-orcid:before {
  content: "";
}

.la-osi:before {
  content: "";
}

.la-otter:before {
  content: "";
}

.la-outdent:before {
  content: "";
}

.la-page4:before {
  content: "";
}

.la-pagelines:before {
  content: "";
}

.la-pager:before {
  content: "";
}

.la-paint-brush:before {
  content: "";
}

.la-paint-roller:before {
  content: "";
}

.la-palette:before {
  content: "";
}

.la-palfed:before {
  content: "";
}

.la-pallet:before {
  content: "";
}

.la-paper-plane:before {
  content: "";
}

.la-paperclip:before {
  content: "";
}

.la-parachute-box:before {
  content: "";
}

.la-paragraph:before {
  content: "";
}

.la-parking:before {
  content: "";
}

.la-passport:before {
  content: "";
}

.la-pastafarianism:before {
  content: "";
}

.la-paste:before {
  content: "";
}

.la-patreon:before {
  content: "";
}

.la-pause:before {
  content: "";
}

.la-pause-circle:before {
  content: "";
}

.la-paw:before {
  content: "";
}

.la-paypal:before {
  content: "";
}

.la-peace:before {
  content: "";
}

.la-pen:before {
  content: "";
}

.la-pen-alt:before {
  content: "";
}

.la-pen-fancy:before {
  content: "";
}

.la-pen-nib:before {
  content: "";
}

.la-pen-square:before {
  content: "";
}

.la-pencil-alt:before {
  content: "";
}

.la-pencil-ruler:before {
  content: "";
}

.la-penny-arcade:before {
  content: "";
}

.la-people-carry:before {
  content: "";
}

.la-pepper-hot:before {
  content: "";
}

.la-percent:before {
  content: "";
}

.la-percentage:before {
  content: "";
}

.la-periscope:before {
  content: "";
}

.la-person-booth:before {
  content: "";
}

.la-phabricator:before {
  content: "";
}

.la-phoenix-framework:before {
  content: "";
}

.la-phoenix-squadron:before {
  content: "";
}

.la-phone:before {
  content: "";
}

.la-phone-alt:before {
  content: "";
}

.la-phone-slash:before {
  content: "";
}

.la-phone-square:before {
  content: "";
}

.la-phone-square-alt:before {
  content: "";
}

.la-phone-volume:before {
  content: "";
}

.la-photo-video:before {
  content: "";
}

.la-php:before {
  content: "";
}

.la-pied-piper:before {
  content: "";
}

.la-pied-piper-alt:before {
  content: "";
}

.la-pied-piper-hat:before {
  content: "";
}

.la-pied-piper-pp:before {
  content: "";
}

.la-piggy-bank:before {
  content: "";
}

.la-pills:before {
  content: "";
}

.la-pinterest:before {
  content: "";
}

.la-pinterest-p:before {
  content: "";
}

.la-pinterest-square:before {
  content: "";
}

.la-pizza-slice:before {
  content: "";
}

.la-place-of-worship:before {
  content: "";
}

.la-plane:before {
  content: "";
}

.la-plane-arrival:before {
  content: "";
}

.la-plane-departure:before {
  content: "";
}

.la-play:before {
  content: "";
}

.la-play-circle:before {
  content: "";
}

.la-playstation:before {
  content: "";
}

.la-plug:before {
  content: "";
}

.la-plus:before {
  content: "";
}

.la-plus-circle:before {
  content: "";
}

.la-plus-square:before {
  content: "";
}

.la-podcast:before {
  content: "";
}

.la-poll:before {
  content: "";
}

.la-poll-h:before {
  content: "";
}

.la-poo:before {
  content: "";
}

.la-poo-storm:before {
  content: "";
}

.la-poop:before {
  content: "";
}

.la-portrait:before {
  content: "";
}

.la-pound-sign:before {
  content: "";
}

.la-power-off:before {
  content: "";
}

.la-pray:before {
  content: "";
}

.la-praying-hands:before {
  content: "";
}

.la-prescription:before {
  content: "";
}

.la-prescription-bottle:before {
  content: "";
}

.la-prescription-bottle-alt:before {
  content: "";
}

.la-print:before {
  content: "";
}

.la-procedures:before {
  content: "";
}

.la-product-hunt:before {
  content: "";
}

.la-project-diagram:before {
  content: "";
}

.la-pushed:before {
  content: "";
}

.la-puzzle-piece:before {
  content: "";
}

.la-python:before {
  content: "";
}

.la-qq:before {
  content: "";
}

.la-qrcode:before {
  content: "";
}

.la-question:before {
  content: "";
}

.la-question-circle:before {
  content: "";
}

.la-quidditch:before {
  content: "";
}

.la-quinscape:before {
  content: "";
}

.la-quora:before {
  content: "";
}

.la-quote-left:before {
  content: "";
}

.la-quote-right:before {
  content: "";
}

.la-quran:before {
  content: "";
}

.la-r-project:before {
  content: "";
}

.la-radiation:before {
  content: "";
}

.la-radiation-alt:before {
  content: "";
}

.la-rainbow:before {
  content: "";
}

.la-random:before {
  content: "";
}

.la-raspberry-pi:before {
  content: "";
}

.la-ravelry:before {
  content: "";
}

.la-react:before {
  content: "";
}

.la-reacteurope:before {
  content: "";
}

.la-readme:before {
  content: "";
}

.la-rebel:before {
  content: "";
}

.la-receipt:before {
  content: "";
}

.la-record-vinyl:before {
  content: "";
}

.la-recycle:before {
  content: "";
}

.la-red-river:before {
  content: "";
}

.la-reddit:before {
  content: "";
}

.la-reddit-alien:before {
  content: "";
}

.la-reddit-square:before {
  content: "";
}

.la-redhat:before {
  content: "";
}

.la-redo:before {
  content: "";
}

.la-redo-alt:before {
  content: "";
}

.la-registered:before {
  content: "";
}

.la-remove-format:before {
  content: "";
}

.la-renren:before {
  content: "";
}

.la-reply:before {
  content: "";
}

.la-reply-all:before {
  content: "";
}

.la-replyd:before {
  content: "";
}

.la-republican:before {
  content: "";
}

.la-researchgate:before {
  content: "";
}

.la-resolving:before {
  content: "";
}

.la-restroom:before {
  content: "";
}

.la-retweet:before {
  content: "";
}

.la-rev:before {
  content: "";
}

.la-ribbon:before {
  content: "";
}

.la-ring:before {
  content: "";
}

.la-road:before {
  content: "";
}

.la-robot:before {
  content: "";
}

.la-rocket:before {
  content: "";
}

.la-rocketchat:before {
  content: "";
}

.la-rockrms:before {
  content: "";
}

.la-route:before {
  content: "";
}

.la-rss:before {
  content: "";
}

.la-rss-square:before {
  content: "";
}

.la-ruble-sign:before {
  content: "";
}

.la-ruler:before {
  content: "";
}

.la-ruler-combined:before {
  content: "";
}

.la-ruler-horizontal:before {
  content: "";
}

.la-ruler-vertical:before {
  content: "";
}

.la-running:before {
  content: "";
}

.la-rupee-sign:before {
  content: "";
}

.la-sad-cry:before {
  content: "";
}

.la-sad-tear:before {
  content: "";
}

.la-safari:before {
  content: "";
}

.la-salesforce:before {
  content: "";
}

.la-sass:before {
  content: "";
}

.la-satellite:before {
  content: "";
}

.la-satellite-dish:before {
  content: "";
}

.la-save:before {
  content: "";
}

.la-schlix:before {
  content: "";
}

.la-school:before {
  content: "";
}

.la-screwdriver:before {
  content: "";
}

.la-scribd:before {
  content: "";
}

.la-scroll:before {
  content: "";
}

.la-sd-card:before {
  content: "";
}

.la-search:before {
  content: "";
}

.la-search-dollar:before {
  content: "";
}

.la-search-location:before {
  content: "";
}

.la-search-minus:before {
  content: "";
}

.la-search-plus:before {
  content: "";
}

.la-searchengin:before {
  content: "";
}

.la-seedling:before {
  content: "";
}

.la-sellcast:before {
  content: "";
}

.la-sellsy:before {
  content: "";
}

.la-server:before {
  content: "";
}

.la-servicestack:before {
  content: "";
}

.la-shapes:before {
  content: "";
}

.la-share:before {
  content: "";
}

.la-share-alt:before {
  content: "";
}

.la-share-alt-square:before {
  content: "";
}

.la-share-square:before {
  content: "";
}

.la-shekel-sign:before {
  content: "";
}

.la-shield-alt:before {
  content: "";
}

.la-ship:before {
  content: "";
}

.la-shipping-fast:before {
  content: "";
}

.la-shirtsinbulk:before {
  content: "";
}

.la-shoe-prints:before {
  content: "";
}

.la-shopping-bag:before {
  content: "";
}

.la-shopping-basket:before {
  content: "";
}

.la-shopping-cart:before {
  content: "";
}

.la-shopware:before {
  content: "";
}

.la-shower:before {
  content: "";
}

.la-shuttle-van:before {
  content: "";
}

.la-sign:before {
  content: "";
}

.la-sign-in-alt:before {
  content: "";
}

.la-sign-language:before {
  content: "";
}

.la-sign-out-alt:before {
  content: "";
}

.la-signal:before {
  content: "";
}

.la-signature:before {
  content: "";
}

.la-sim-card:before {
  content: "";
}

.la-simplybuilt:before {
  content: "";
}

.la-sistrix:before {
  content: "";
}

.la-sitemap:before {
  content: "";
}

.la-sith:before {
  content: "";
}

.la-skating:before {
  content: "";
}

.la-sketch:before {
  content: "";
}

.la-skiing:before {
  content: "";
}

.la-skiing-nordic:before {
  content: "";
}

.la-skull:before {
  content: "";
}

.la-skull-crossbones:before {
  content: "";
}

.la-skyatlas:before {
  content: "";
}

.la-skype:before {
  content: "";
}

.la-slack:before {
  content: "";
}

.la-slack-hash:before {
  content: "";
}

.la-slash:before {
  content: "";
}

.la-sleigh:before {
  content: "";
}

.la-sliders-h:before {
  content: "";
}

.la-slideshare:before {
  content: "";
}

.la-smile:before {
  content: "";
}

.la-smile-beam:before {
  content: "";
}

.la-smile-wink:before {
  content: "";
}

.la-smog:before {
  content: "";
}

.la-smoking:before {
  content: "";
}

.la-smoking-ban:before {
  content: "";
}

.la-sms:before {
  content: "";
}

.la-snapchat:before {
  content: "";
}

.la-snapchat-ghost:before {
  content: "";
}

.la-snapchat-square:before {
  content: "";
}

.la-snowboarding:before {
  content: "";
}

.la-snowflake:before {
  content: "";
}

.la-snowman:before {
  content: "";
}

.la-snowplow:before {
  content: "";
}

.la-socks:before {
  content: "";
}

.la-solar-panel:before {
  content: "";
}

.la-sort:before {
  content: "";
}

.la-sort-alpha-down:before {
  content: "";
}

.la-sort-alpha-down-alt:before {
  content: "";
}

.la-sort-alpha-up:before {
  content: "";
}

.la-sort-alpha-up-alt:before {
  content: "";
}

.la-sort-amount-down:before {
  content: "";
}

.la-sort-amount-down-alt:before {
  content: "";
}

.la-sort-amount-up:before {
  content: "";
}

.la-sort-amount-up-alt:before {
  content: "";
}

.la-sort-down:before {
  content: "";
}

.la-sort-numeric-down:before {
  content: "";
}

.la-sort-numeric-down-alt:before {
  content: "";
}

.la-sort-numeric-up:before {
  content: "";
}

.la-sort-numeric-up-alt:before {
  content: "";
}

.la-sort-up:before {
  content: "";
}

.la-soundcloud:before {
  content: "";
}

.la-sourcetree:before {
  content: "";
}

.la-spa:before {
  content: "";
}

.la-space-shuttle:before {
  content: "";
}

.la-speakap:before {
  content: "";
}

.la-speaker-deck:before {
  content: "";
}

.la-spell-check:before {
  content: "";
}

.la-spider:before {
  content: "";
}

.la-spinner:before {
  content: "";
}

.la-splotch:before {
  content: "";
}

.la-spotify:before {
  content: "";
}

.la-spray-can:before {
  content: "";
}

.la-square:before {
  content: "";
}

.la-square-full:before {
  content: "";
}

.la-square-root-alt:before {
  content: "";
}

.la-squarespace:before {
  content: "";
}

.la-stack-exchange:before {
  content: "";
}

.la-stack-overflow:before {
  content: "";
}

.la-stackpath:before {
  content: "";
}

.la-stamp:before {
  content: "";
}

.la-star:before {
  content: "";
}

.la-star-and-crescent:before {
  content: "";
}

.la-star-half:before {
  content: "";
}

.la-star-half-alt:before {
  content: "";
}

.la-star-of-david:before {
  content: "";
}

.la-star-of-life:before {
  content: "";
}

.la-staylinked:before {
  content: "";
}

.la-steam:before {
  content: "";
}

.la-steam-square:before {
  content: "";
}

.la-steam-symbol:before {
  content: "";
}

.la-step-backward:before {
  content: "";
}

.la-step-forward:before {
  content: "";
}

.la-stethoscope:before {
  content: "";
}

.la-sticker-mule:before {
  content: "";
}

.la-sticky-note:before {
  content: "";
}

.la-stop:before {
  content: "";
}

.la-stop-circle:before {
  content: "";
}

.la-stopwatch:before {
  content: "";
}

.la-store:before {
  content: "";
}

.la-store-alt:before {
  content: "";
}

.la-strava:before {
  content: "";
}

.la-stream:before {
  content: "";
}

.la-street-view:before {
  content: "";
}

.la-strikethrough:before {
  content: "";
}

.la-stripe:before {
  content: "";
}

.la-stripe-s:before {
  content: "";
}

.la-stroopwafel:before {
  content: "";
}

.la-studiovinari:before {
  content: "";
}

.la-stumbleupon:before {
  content: "";
}

.la-stumbleupon-circle:before {
  content: "";
}

.la-subscript:before {
  content: "";
}

.la-subway:before {
  content: "";
}

.la-suitcase:before {
  content: "";
}

.la-suitcase-rolling:before {
  content: "";
}

.la-sun:before {
  content: "";
}

.la-superpowers:before {
  content: "";
}

.la-superscript:before {
  content: "";
}

.la-supple:before {
  content: "";
}

.la-surprise:before {
  content: "";
}

.la-suse:before {
  content: "";
}

.la-swatchbook:before {
  content: "";
}

.la-swift:before {
  content: "";
}

.la-swimmer:before {
  content: "";
}

.la-swimming-pool:before {
  content: "";
}

.la-symfony:before {
  content: "";
}

.la-synagogue:before {
  content: "";
}

.la-sync:before {
  content: "";
}

.la-sync-alt:before {
  content: "";
}

.la-syringe:before {
  content: "";
}

.la-table:before {
  content: "";
}

.la-table-tennis:before {
  content: "";
}

.la-tablet:before {
  content: "";
}

.la-tablet-alt:before {
  content: "";
}

.la-tablets:before {
  content: "";
}

.la-tachometer-alt:before {
  content: "";
}

.la-tag:before {
  content: "";
}

.la-tags:before {
  content: "";
}

.la-tape:before {
  content: "";
}

.la-tasks:before {
  content: "";
}

.la-taxi:before {
  content: "";
}

.la-teamspeak:before {
  content: "";
}

.la-teeth:before {
  content: "";
}

.la-teeth-open:before {
  content: "";
}

.la-telegram:before {
  content: "";
}

.la-telegram-plane:before {
  content: "";
}

.la-temperature-high:before {
  content: "";
}

.la-temperature-low:before {
  content: "";
}

.la-tencent-weibo:before {
  content: "";
}

.la-tenge:before {
  content: "";
}

.la-terminal:before {
  content: "";
}

.la-text-height:before {
  content: "";
}

.la-text-width:before {
  content: "";
}

.la-th:before {
  content: "";
}

.la-th-large:before {
  content: "";
}

.la-th-list:before {
  content: "";
}

.la-the-red-yeti:before {
  content: "";
}

.la-theater-masks:before {
  content: "";
}

.la-themeco:before {
  content: "";
}

.la-themeisle:before {
  content: "";
}

.la-thermometer:before {
  content: "";
}

.la-thermometer-empty:before {
  content: "";
}

.la-thermometer-full:before {
  content: "";
}

.la-thermometer-half:before {
  content: "";
}

.la-thermometer-quarter:before {
  content: "";
}

.la-thermometer-three-quarters:before {
  content: "";
}

.la-think-peaks:before {
  content: "";
}

.la-thumbs-down:before {
  content: "";
}

.la-thumbs-up:before {
  content: "";
}

.la-thumbtack:before {
  content: "";
}

.la-ticket-alt:before {
  content: "";
}

.la-times:before {
  content: "";
}

.la-times-circle:before {
  content: "";
}

.la-tint:before {
  content: "";
}

.la-tint-slash:before {
  content: "";
}

.la-tired:before {
  content: "";
}

.la-toggle-off:before {
  content: "";
}

.la-toggle-on:before {
  content: "";
}

.la-toilet:before {
  content: "";
}

.la-toilet-paper:before {
  content: "";
}

.la-toolbox:before {
  content: "";
}

.la-tools:before {
  content: "";
}

.la-tooth:before {
  content: "";
}

.la-torah:before {
  content: "";
}

.la-torii-gate:before {
  content: "";
}

.la-tractor:before {
  content: "";
}

.la-trade-federation:before {
  content: "";
}

.la-trademark:before {
  content: "";
}

.la-traffic-light:before {
  content: "";
}

.la-train:before {
  content: "";
}

.la-tram:before {
  content: "";
}

.la-transgender:before {
  content: "";
}

.la-transgender-alt:before {
  content: "";
}

.la-trash:before {
  content: "";
}

.la-trash-alt:before {
  content: "";
}

.la-trash-restore:before {
  content: "";
}

.la-trash-restore-alt:before {
  content: "";
}

.la-tree:before {
  content: "";
}

.la-trello:before {
  content: "";
}

.la-tripadvisor:before {
  content: "";
}

.la-trophy:before {
  content: "";
}

.la-truck:before {
  content: "";
}

.la-truck-loading:before {
  content: "";
}

.la-truck-monster:before {
  content: "";
}

.la-truck-moving:before {
  content: "";
}

.la-truck-pickup:before {
  content: "";
}

.la-tshirt:before {
  content: "";
}

.la-tty:before {
  content: "";
}

.la-tumblr:before {
  content: "";
}

.la-tumblr-square:before {
  content: "";
}

.la-tv:before {
  content: "";
}

.la-twitch:before {
  content: "";
}

.la-twitter:before {
  content: "";
}

.la-twitter-square:before {
  content: "";
}

.la-typo3:before {
  content: "";
}

.la-uber:before {
  content: "";
}

.la-ubuntu:before {
  content: "";
}

.la-uikit:before {
  content: "";
}

.la-umbraco:before {
  content: "";
}

.la-umbrella:before {
  content: "";
}

.la-umbrella-beach:before {
  content: "";
}

.la-underline:before {
  content: "";
}

.la-undo:before {
  content: "";
}

.la-undo-alt:before {
  content: "";
}

.la-uniregistry:before {
  content: "";
}

.la-universal-access:before {
  content: "";
}

.la-university:before {
  content: "";
}

.la-unlink:before {
  content: "";
}

.la-unlock:before {
  content: "";
}

.la-unlock-alt:before {
  content: "";
}

.la-untappd:before {
  content: "";
}

.la-upload:before {
  content: "";
}

.la-ups:before {
  content: "";
}

.la-usb:before {
  content: "";
}

.la-user:before {
  content: "";
}

.la-user-alt:before {
  content: "";
}

.la-user-alt-slash:before {
  content: "";
}

.la-user-astronaut:before {
  content: "";
}

.la-user-check:before {
  content: "";
}

.la-user-circle:before {
  content: "";
}

.la-user-clock:before {
  content: "";
}

.la-user-cog:before {
  content: "";
}

.la-user-edit:before {
  content: "";
}

.la-user-friends:before {
  content: "";
}

.la-user-graduate:before {
  content: "";
}

.la-user-injured:before {
  content: "";
}

.la-user-lock:before {
  content: "";
}

.la-user-md:before {
  content: "";
}

.la-user-minus:before {
  content: "";
}

.la-user-ninja:before {
  content: "";
}

.la-user-nurse:before {
  content: "";
}

.la-user-plus:before {
  content: "";
}

.la-user-secret:before {
  content: "";
}

.la-user-shield:before {
  content: "";
}

.la-user-slash:before {
  content: "";
}

.la-user-tag:before {
  content: "";
}

.la-user-tie:before {
  content: "";
}

.la-user-times:before {
  content: "";
}

.la-users:before {
  content: "";
}

.la-users-cog:before {
  content: "";
}

.la-usps:before {
  content: "";
}

.la-ussunnah:before {
  content: "";
}

.la-utensil-spoon:before {
  content: "";
}

.la-utensils:before {
  content: "";
}

.la-vaadin:before {
  content: "";
}

.la-vector-square:before {
  content: "";
}

.la-venus:before {
  content: "";
}

.la-venus-double:before {
  content: "";
}

.la-venus-mars:before {
  content: "";
}

.la-viacoin:before {
  content: "";
}

.la-viadeo:before {
  content: "";
}

.la-viadeo-square:before {
  content: "";
}

.la-vial:before {
  content: "";
}

.la-vials:before {
  content: "";
}

.la-viber:before {
  content: "";
}

.la-video:before {
  content: "";
}

.la-video-slash:before {
  content: "";
}

.la-vihara:before {
  content: "";
}

.la-vimeo:before {
  content: "";
}

.la-vimeo-square:before {
  content: "";
}

.la-vimeo-v:before {
  content: "";
}

.la-vine:before {
  content: "";
}

.la-vk:before {
  content: "";
}

.la-vnv:before {
  content: "";
}

.la-voicemail:before {
  content: "";
}

.la-volleyball-ball:before {
  content: "";
}

.la-volume-down:before {
  content: "";
}

.la-volume-mute:before {
  content: "";
}

.la-volume-off:before {
  content: "";
}

.la-volume-up:before {
  content: "";
}

.la-vote-yea:before {
  content: "";
}

.la-vr-cardboard:before {
  content: "";
}

.la-vuejs:before {
  content: "";
}

.la-walking:before {
  content: "";
}

.la-wallet:before {
  content: "";
}

.la-warehouse:before {
  content: "";
}

.la-water:before {
  content: "";
}

.la-wave-square:before {
  content: "";
}

.la-waze:before {
  content: "";
}

.la-weebly:before {
  content: "";
}

.la-weibo:before {
  content: "";
}

.la-weight:before {
  content: "";
}

.la-weight-hanging:before {
  content: "";
}

.la-weixin:before {
  content: "";
}

.la-whatsapp:before {
  content: "";
}

.la-whatsapp-square:before {
  content: "";
}

.la-wheelchair:before {
  content: "";
}

.la-whmcs:before {
  content: "";
}

.la-wifi:before {
  content: "";
}

.la-wikipedia-w:before {
  content: "";
}

.la-wind:before {
  content: "";
}

.la-window-close:before {
  content: "";
}

.la-window-maximize:before {
  content: "";
}

.la-window-minimize:before {
  content: "";
}

.la-window-restore:before {
  content: "";
}

.la-windows:before {
  content: "";
}

.la-wine-bottle:before {
  content: "";
}

.la-wine-glass:before {
  content: "";
}

.la-wine-glass-alt:before {
  content: "";
}

.la-wix:before {
  content: "";
}

.la-wizards-of-the-coast:before {
  content: "";
}

.la-wolf-pack-battalion:before {
  content: "";
}

.la-won-sign:before {
  content: "";
}

.la-wordpress:before {
  content: "";
}

.la-wordpress-simple:before {
  content: "";
}

.la-wpbeginner:before {
  content: "";
}

.la-wpexplorer:before {
  content: "";
}

.la-wpforms:before {
  content: "";
}

.la-wpressr:before {
  content: "";
}

.la-wrench:before {
  content: "";
}

.la-x-ray:before {
  content: "";
}

.la-xbox:before {
  content: "";
}

.la-xing:before {
  content: "";
}

.la-xing-square:before {
  content: "";
}

.la-y-combinator:before {
  content: "";
}

.la-yahoo:before {
  content: "";
}

.la-yammer:before {
  content: "";
}

.la-yandex:before {
  content: "";
}

.la-yandex-international:before {
  content: "";
}

.la-yarn:before {
  content: "";
}

.la-yelp:before {
  content: "";
}

.la-yen-sign:before {
  content: "";
}

.la-yin-yang:before {
  content: "";
}

.la-yoast:before {
  content: "";
}

.la-youtube:before {
  content: "";
}

.la-youtube-square:before {
  content: "";
}

.la-zhihu:before {
  content: "";
}

.sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  width: auto;
}

@font-face {
  font-family: "Line Awesome Brands";
  font-style: normal;
  font-weight: normal;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("svg");
}
.lab {
  font-family: "Line Awesome Brands";
}

@font-face {
  font-family: "Line Awesome Free";
  font-style: normal;
  font-weight: 400;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("svg");
}
.lar {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

@font-face {
  font-family: "Line Awesome Free";
  font-style: normal;
  font-weight: 900;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("svg");
}
.la,
.las {
  font-family: "Line Awesome Free";
  font-weight: 900;
}

.la.la-glass:before {
  content: "";
}

.la.la-meetup {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-star-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-star-o:before {
  content: "";
}

.la.la-remove:before {
  content: "";
}

.la.la-close:before {
  content: "";
}

.la.la-gear:before {
  content: "";
}

.la.la-trash-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-trash-o:before {
  content: "";
}

.la.la-file-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-o:before {
  content: "";
}

.la.la-clock-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-clock-o:before {
  content: "";
}

.la.la-arrow-circle-o-down {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-arrow-circle-o-down:before {
  content: "";
}

.la.la-arrow-circle-o-up {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-arrow-circle-o-up:before {
  content: "";
}

.la.la-play-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-play-circle-o:before {
  content: "";
}

.la.la-repeat:before {
  content: "";
}

.la.la-rotate-right:before {
  content: "";
}

.la.la-refresh:before {
  content: "";
}

.la.la-list-alt {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-dedent:before {
  content: "";
}

.la.la-video-camera:before {
  content: "";
}

.la.la-picture-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-picture-o:before {
  content: "";
}

.la.la-photo {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-photo:before {
  content: "";
}

.la.la-image {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-image:before {
  content: "";
}

.la.la-pencil:before {
  content: "";
}

.la.la-map-marker:before {
  content: "";
}

.la.la-pencil-square-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-pencil-square-o:before {
  content: "";
}

.la.la-share-square-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-share-square-o:before {
  content: "";
}

.la.la-check-square-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-check-square-o:before {
  content: "";
}

.la.la-arrows:before {
  content: "";
}

.la.la-times-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-times-circle-o:before {
  content: "";
}

.la.la-check-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-check-circle-o:before {
  content: "";
}

.la.la-mail-forward:before {
  content: "";
}

.la.la-eye {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-eye-slash {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-warning:before {
  content: "";
}

.la.la-calendar:before {
  content: "";
}

.la.la-arrows-v:before {
  content: "";
}

.la.la-arrows-h:before {
  content: "";
}

.la.la-bar-chart {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-bar-chart:before {
  content: "";
}

.la.la-bar-chart-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-bar-chart-o:before {
  content: "";
}

.la.la-twitter-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-facebook-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-gears:before {
  content: "";
}

.la.la-thumbs-o-up {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-thumbs-o-up:before {
  content: "";
}

.la.la-thumbs-o-down {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-thumbs-o-down:before {
  content: "";
}

.la.la-heart-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-heart-o:before {
  content: "";
}

.la.la-sign-out:before {
  content: "";
}

.la.la-linkedin-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-linkedin-square:before {
  content: "";
}

.la.la-thumb-tack:before {
  content: "";
}

.la.la-external-link:before {
  content: "";
}

.la.la-sign-in:before {
  content: "";
}

.la.la-github-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-lemon-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-lemon-o:before {
  content: "";
}

.la.la-square-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-square-o:before {
  content: "";
}

.la.la-bookmark-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-bookmark-o:before {
  content: "";
}

.la.la-twitter {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-facebook {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-facebook:before {
  content: "";
}

.la.la-facebook-f {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-facebook-f:before {
  content: "";
}

.la.la-github {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-credit-card {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-feed:before {
  content: "";
}

.la.la-hdd-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hdd-o:before {
  content: "";
}

.la.la-hand-o-right {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-o-right:before {
  content: "";
}

.la.la-hand-o-left {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-o-left:before {
  content: "";
}

.la.la-hand-o-up {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-o-up:before {
  content: "";
}

.la.la-hand-o-down {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-o-down:before {
  content: "";
}

.la.la-arrows-alt:before {
  content: "";
}

.la.la-group:before {
  content: "";
}

.la.la-chain:before {
  content: "";
}

.la.la-scissors:before {
  content: "";
}

.la.la-files-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-files-o:before {
  content: "";
}

.la.la-floppy-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-floppy-o:before {
  content: "";
}

.la.la-navicon:before {
  content: "";
}

.la.la-reorder:before {
  content: "";
}

.la.la-pinterest {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-pinterest-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google-plus-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google-plus {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google-plus:before {
  content: "";
}

.la.la-money {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-money:before {
  content: "";
}

.la.la-unsorted:before {
  content: "";
}

.la.la-sort-desc:before {
  content: "";
}

.la.la-sort-asc:before {
  content: "";
}

.la.la-linkedin {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-linkedin:before {
  content: "";
}

.la.la-rotate-left:before {
  content: "";
}

.la.la-legal:before {
  content: "";
}

.la.la-tachometer:before {
  content: "";
}

.la.la-dashboard:before {
  content: "";
}

.la.la-comment-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-comment-o:before {
  content: "";
}

.la.la-comments-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-comments-o:before {
  content: "";
}

.la.la-flash:before {
  content: "";
}

.la.la-clipboard {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-paste {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-paste:before {
  content: "";
}

.la.la-lightbulb-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-lightbulb-o:before {
  content: "";
}

.la.la-exchange:before {
  content: "";
}

.la.la-cloud-download:before {
  content: "";
}

.la.la-cloud-upload:before {
  content: "";
}

.la.la-bell-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-bell-o:before {
  content: "";
}

.la.la-cutlery:before {
  content: "";
}

.la.la-file-text-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-text-o:before {
  content: "";
}

.la.la-building-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-building-o:before {
  content: "";
}

.la.la-hospital-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hospital-o:before {
  content: "";
}

.la.la-tablet:before {
  content: "";
}

.la.la-mobile:before {
  content: "";
}

.la.la-mobile-phone:before {
  content: "";
}

.la.la-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-circle-o:before {
  content: "";
}

.la.la-mail-reply:before {
  content: "";
}

.la.la-github-alt {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-folder-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-folder-o:before {
  content: "";
}

.la.la-folder-open-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-folder-open-o:before {
  content: "";
}

.la.la-smile-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-smile-o:before {
  content: "";
}

.la.la-frown-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-frown-o:before {
  content: "";
}

.la.la-meh-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-meh-o:before {
  content: "";
}

.la.la-keyboard-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-keyboard-o:before {
  content: "";
}

.la.la-flag-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-flag-o:before {
  content: "";
}

.la.la-mail-reply-all:before {
  content: "";
}

.la.la-star-half-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-star-half-o:before {
  content: "";
}

.la.la-star-half-empty {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-star-half-empty:before {
  content: "";
}

.la.la-star-half-full {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-star-half-full:before {
  content: "";
}

.la.la-code-fork:before {
  content: "";
}

.la.la-chain-broken:before {
  content: "";
}

.la.la-shield:before {
  content: "";
}

.la.la-calendar-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-calendar-o:before {
  content: "";
}

.la.la-maxcdn {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-html5 {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-css3 {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-ticket:before {
  content: "";
}

.la.la-minus-square-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-minus-square-o:before {
  content: "";
}

.la.la-level-up:before {
  content: "";
}

.la.la-level-down:before {
  content: "";
}

.la.la-pencil-square:before {
  content: "";
}

.la.la-external-link-square:before {
  content: "";
}

.la.la-compass {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-caret-square-o-down {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-caret-square-o-down:before {
  content: "";
}

.la.la-toggle-down {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-toggle-down:before {
  content: "";
}

.la.la-caret-square-o-up {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-caret-square-o-up:before {
  content: "";
}

.la.la-toggle-up {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-toggle-up:before {
  content: "";
}

.la.la-caret-square-o-right {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-caret-square-o-right:before {
  content: "";
}

.la.la-toggle-right {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-toggle-right:before {
  content: "";
}

.la.la-eur:before {
  content: "";
}

.la.la-euro:before {
  content: "";
}

.la.la-gbp:before {
  content: "";
}

.la.la-usd:before {
  content: "";
}

.la.la-dollar:before {
  content: "";
}

.la.la-inr:before {
  content: "";
}

.la.la-rupee:before {
  content: "";
}

.la.la-jpy:before {
  content: "";
}

.la.la-cny:before {
  content: "";
}

.la.la-rmb:before {
  content: "";
}

.la.la-yen:before {
  content: "";
}

.la.la-rub:before {
  content: "";
}

.la.la-ruble:before {
  content: "";
}

.la.la-rouble:before {
  content: "";
}

.la.la-krw:before {
  content: "";
}

.la.la-won:before {
  content: "";
}

.la.la-btc {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-bitcoin {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-bitcoin:before {
  content: "";
}

.la.la-file-text:before {
  content: "";
}

.la.la-sort-alpha-asc:before {
  content: "";
}

.la.la-sort-alpha-desc:before {
  content: "";
}

.la.la-sort-amount-asc:before {
  content: "";
}

.la.la-sort-amount-desc:before {
  content: "";
}

.la.la-sort-numeric-asc:before {
  content: "";
}

.la.la-sort-numeric-desc:before {
  content: "";
}

.la.la-youtube-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-youtube {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-xing {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-xing-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-youtube-play {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-youtube-play:before {
  content: "";
}

.la.la-dropbox {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-stack-overflow {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-instagram {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-flickr {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-adn {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-bitbucket {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-bitbucket-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-bitbucket-square:before {
  content: "";
}

.la.la-tumblr {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-tumblr-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-long-arrow-down:before {
  content: "";
}

.la.la-long-arrow-up:before {
  content: "";
}

.la.la-long-arrow-left:before {
  content: "";
}

.la.la-long-arrow-right:before {
  content: "";
}

.la.la-apple {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-windows {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-android {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-linux {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-dribbble {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-skype {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-foursquare {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-trello {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-gratipay {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-gittip {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-gittip:before {
  content: "";
}

.la.la-sun-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-sun-o:before {
  content: "";
}

.la.la-moon-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-moon-o:before {
  content: "";
}

.la.la-vk {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-weibo {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-renren {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-pagelines {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-stack-exchange {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-arrow-circle-o-right {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-arrow-circle-o-right:before {
  content: "";
}

.la.la-arrow-circle-o-left {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-arrow-circle-o-left:before {
  content: "";
}

.la.la-caret-square-o-left {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-caret-square-o-left:before {
  content: "";
}

.la.la-toggle-left {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-toggle-left:before {
  content: "";
}

.la.la-dot-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-dot-circle-o:before {
  content: "";
}

.la.la-vimeo-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-try:before {
  content: "";
}

.la.la-turkish-lira:before {
  content: "";
}

.la.la-plus-square-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-plus-square-o:before {
  content: "";
}

.la.la-slack {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wordpress {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-openid {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-institution:before {
  content: "";
}

.la.la-bank:before {
  content: "";
}

.la.la-mortar-board:before {
  content: "";
}

.la.la-yahoo {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-reddit {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-reddit-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-stumbleupon-circle {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-stumbleupon {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-delicious {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-digg {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-pied-piper-pp {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-pied-piper-alt {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-drupal {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-joomla {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-spoon:before {
  content: "";
}

.la.la-behance {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-behance-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-steam {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-steam-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-automobile:before {
  content: "";
}

.la.la-cab:before {
  content: "";
}

.la.la-envelope-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-envelope-o:before {
  content: "";
}

.la.la-deviantart {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-soundcloud {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-file-pdf-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-pdf-o:before {
  content: "";
}

.la.la-file-word-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-word-o:before {
  content: "";
}

.la.la-file-excel-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-excel-o:before {
  content: "";
}

.la.la-file-powerpoint-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-powerpoint-o:before {
  content: "";
}

.la.la-file-image-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-image-o:before {
  content: "";
}

.la.la-file-photo-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-photo-o:before {
  content: "";
}

.la.la-file-picture-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-picture-o:before {
  content: "";
}

.la.la-file-archive-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-archive-o:before {
  content: "";
}

.la.la-file-zip-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-zip-o:before {
  content: "";
}

.la.la-file-audio-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-audio-o:before {
  content: "";
}

.la.la-file-sound-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-sound-o:before {
  content: "";
}

.la.la-file-video-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-video-o:before {
  content: "";
}

.la.la-file-movie-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-movie-o:before {
  content: "";
}

.la.la-file-code-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-code-o:before {
  content: "";
}

.la.la-vine {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-codepen {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-jsfiddle {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-life-ring {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-life-bouy {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-life-bouy:before {
  content: "";
}

.la.la-life-buoy {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-life-buoy:before {
  content: "";
}

.la.la-life-saver {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-life-saver:before {
  content: "";
}

.la.la-support {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-support:before {
  content: "";
}

.la.la-circle-o-notch:before {
  content: "";
}

.la.la-rebel {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-ra {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-ra:before {
  content: "";
}

.la.la-resistance {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-resistance:before {
  content: "";
}

.la.la-empire {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-ge {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-ge:before {
  content: "";
}

.la.la-git-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-git {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-hacker-news {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-y-combinator-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-y-combinator-square:before {
  content: "";
}

.la.la-yc-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-yc-square:before {
  content: "";
}

.la.la-tencent-weibo {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-qq {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-weixin {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wechat {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wechat:before {
  content: "";
}

.la.la-send:before {
  content: "";
}

.la.la-paper-plane-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-paper-plane-o:before {
  content: "";
}

.la.la-send-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-send-o:before {
  content: "";
}

.la.la-circle-thin {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-circle-thin:before {
  content: "";
}

.la.la-header:before {
  content: "";
}

.la.la-sliders:before {
  content: "";
}

.la.la-futbol-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-futbol-o:before {
  content: "";
}

.la.la-soccer-ball-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-soccer-ball-o:before {
  content: "";
}

.la.la-slideshare {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-twitch {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-yelp {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-newspaper-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-newspaper-o:before {
  content: "";
}

.la.la-paypal {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google-wallet {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc-visa {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc-mastercard {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc-discover {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc-amex {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc-paypal {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc-stripe {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-bell-slash-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-bell-slash-o:before {
  content: "";
}

.la.la-trash:before {
  content: "";
}

.la.la-copyright {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-eyedropper:before {
  content: "";
}

.la.la-area-chart:before {
  content: "";
}

.la.la-pie-chart:before {
  content: "";
}

.la.la-line-chart:before {
  content: "";
}

.la.la-lastfm {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-lastfm-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-ioxhost {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-angellist {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-cc:before {
  content: "";
}

.la.la-ils:before {
  content: "";
}

.la.la-shekel:before {
  content: "";
}

.la.la-sheqel:before {
  content: "";
}

.la.la-meanpath {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-meanpath:before {
  content: "";
}

.la.la-buysellads {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-connectdevelop {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-dashcube {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-forumbee {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-leanpub {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-sellsy {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-shirtsinbulk {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-simplybuilt {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-skyatlas {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-diamond {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-diamond:before {
  content: "";
}

.la.la-intersex:before {
  content: "";
}

.la.la-facebook-official {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-facebook-official:before {
  content: "";
}

.la.la-pinterest-p {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-whatsapp {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-hotel:before {
  content: "";
}

.la.la-viacoin {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-medium {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-y-combinator {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-yc {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-yc:before {
  content: "";
}

.la.la-optin-monster {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-opencart {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-expeditedssl {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-battery-4:before {
  content: "";
}

.la.la-battery:before {
  content: "";
}

.la.la-battery-3:before {
  content: "";
}

.la.la-battery-2:before {
  content: "";
}

.la.la-battery-1:before {
  content: "";
}

.la.la-battery-0:before {
  content: "";
}

.la.la-object-group {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-object-ungroup {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-sticky-note-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-sticky-note-o:before {
  content: "";
}

.la.la-cc-jcb {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc-diners-club {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-clone {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hourglass-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hourglass-o:before {
  content: "";
}

.la.la-hourglass-1:before {
  content: "";
}

.la.la-hourglass-2:before {
  content: "";
}

.la.la-hourglass-3:before {
  content: "";
}

.la.la-hand-rock-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-rock-o:before {
  content: "";
}

.la.la-hand-grab-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-grab-o:before {
  content: "";
}

.la.la-hand-paper-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-paper-o:before {
  content: "";
}

.la.la-hand-stop-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-stop-o:before {
  content: "";
}

.la.la-hand-scissors-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-scissors-o:before {
  content: "";
}

.la.la-hand-lizard-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-lizard-o:before {
  content: "";
}

.la.la-hand-spock-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-spock-o:before {
  content: "";
}

.la.la-hand-pointer-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-pointer-o:before {
  content: "";
}

.la.la-hand-peace-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-peace-o:before {
  content: "";
}

.la.la-registered {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-creative-commons {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-gg {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-gg-circle {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-tripadvisor {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-odnoklassniki {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-odnoklassniki-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-get-pocket {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wikipedia-w {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-safari {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-chrome {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-firefox {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-opera {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-internet-explorer {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-television:before {
  content: "";
}

.la.la-contao {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-500px {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-amazon {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-calendar-plus-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-calendar-plus-o:before {
  content: "";
}

.la.la-calendar-minus-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-calendar-minus-o:before {
  content: "";
}

.la.la-calendar-times-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-calendar-times-o:before {
  content: "";
}

.la.la-calendar-check-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-calendar-check-o:before {
  content: "";
}

.la.la-map-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-map-o:before {
  content: "";
}

.la.la-commenting:before {
  content: "";
}

.la.la-commenting-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-commenting-o:before {
  content: "";
}

.la.la-houzz {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-vimeo {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-vimeo:before {
  content: "";
}

.la.la-black-tie {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-fonticons {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-reddit-alien {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-edge {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-credit-card-alt:before {
  content: "";
}

.la.la-codiepie {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-modx {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-fort-awesome {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-usb {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-product-hunt {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-mixcloud {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-scribd {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-pause-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-pause-circle-o:before {
  content: "";
}

.la.la-stop-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-stop-circle-o:before {
  content: "";
}

.la.la-bluetooth {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-bluetooth-b {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-gitlab {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wpbeginner {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wpforms {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-envira {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wheelchair-alt {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wheelchair-alt:before {
  content: "";
}

.la.la-question-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-question-circle-o:before {
  content: "";
}

.la.la-volume-control-phone:before {
  content: "";
}

.la.la-asl-interpreting:before {
  content: "";
}

.la.la-deafness:before {
  content: "";
}

.la.la-hard-of-hearing:before {
  content: "";
}

.la.la-glide {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-glide-g {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-signing:before {
  content: "";
}

.la.la-viadeo {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-viadeo-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-snapchat {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-snapchat-ghost {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-snapchat-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-pied-piper {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-first-order {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-yoast {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-themeisle {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google-plus-official {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google-plus-official:before {
  content: "";
}

.la.la-google-plus-circle {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google-plus-circle:before {
  content: "";
}

.la.la-font-awesome {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-fa {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-fa:before {
  content: "";
}

.la.la-handshake-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-handshake-o:before {
  content: "";
}

.la.la-envelope-open-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-envelope-open-o:before {
  content: "";
}

.la.la-linode {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-address-book-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-address-book-o:before {
  content: "";
}

.la.la-vcard:before {
  content: "";
}

.la.la-address-card-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-address-card-o:before {
  content: "";
}

.la.la-vcard-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-vcard-o:before {
  content: "";
}

.la.la-user-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-user-circle-o:before {
  content: "";
}

.la.la-user-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-user-o:before {
  content: "";
}

.la.la-id-badge {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-drivers-license:before {
  content: "";
}

.la.la-id-card-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-id-card-o:before {
  content: "";
}

.la.la-drivers-license-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-drivers-license-o:before {
  content: "";
}

.la.la-quora {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-free-code-camp {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-telegram {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-thermometer-4:before {
  content: "";
}

.la.la-thermometer:before {
  content: "";
}

.la.la-thermometer-3:before {
  content: "";
}

.la.la-thermometer-2:before {
  content: "";
}

.la.la-thermometer-1:before {
  content: "";
}

.la.la-thermometer-0:before {
  content: "";
}

.la.la-bathtub:before {
  content: "";
}

.la.la-s15:before {
  content: "";
}

.la.la-window-maximize {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-window-restore {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-times-rectangle:before {
  content: "";
}

.la.la-window-close-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-window-close-o:before {
  content: "";
}

.la.la-times-rectangle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-times-rectangle-o:before {
  content: "";
}

.la.la-bandcamp {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-grav {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-etsy {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-imdb {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-ravelry {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-eercast {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-eercast:before {
  content: "";
}

.la.la-snowflake-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-snowflake-o:before {
  content: "";
}

.la.la-superpowers {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wpexplorer {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-spotify {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

/*
* Remix Icon v2.5.0
* https://remixicon.com
* https://github.com/Remix-Design/RemixIcon
*
* Copyright RemixIcon.com
* Released under the Apache License Version 2.0
*
* Date: 2020-05-23
*/
@font-face {
  font-family: "remixicon";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  /* IE9*/
  src: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("svg");
  /* iOS 4.1- */
  font-display: swap;
}
[class^=ri-], [class*=" ri-"] {
  font-family: "remixicon" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.ri-lg {
  font-size: 1.3333em;
  line-height: 0.75em;
  vertical-align: -0.0667em;
}

.ri-xl {
  font-size: 1.5em;
  line-height: 0.6666em;
  vertical-align: -0.075em;
}

.ri-xxs {
  font-size: 0.5em;
}

.ri-xs {
  font-size: 0.75em;
}

.ri-sm {
  font-size: 0.875em;
}

.ri-1x {
  font-size: 1em;
}

.ri-2x {
  font-size: 2em;
}

.ri-3x {
  font-size: 3em;
}

.ri-4x {
  font-size: 4em;
}

.ri-5x {
  font-size: 5em;
}

.ri-6x {
  font-size: 6em;
}

.ri-7x {
  font-size: 7em;
}

.ri-8x {
  font-size: 8em;
}

.ri-9x {
  font-size: 9em;
}

.ri-10x {
  font-size: 10em;
}

.ri-fw {
  text-align: center;
  width: 1.25em;
}

.ri-24-hours-fill:before {
  content: "";
}

.ri-24-hours-line:before {
  content: "";
}

.ri-4k-fill:before {
  content: "";
}

.ri-4k-line:before {
  content: "";
}

.ri-a-b:before {
  content: "";
}

.ri-account-box-fill:before {
  content: "";
}

.ri-account-box-line:before {
  content: "";
}

.ri-account-circle-fill:before {
  content: "";
}

.ri-account-circle-line:before {
  content: "";
}

.ri-account-pin-box-fill:before {
  content: "";
}

.ri-account-pin-box-line:before {
  content: "";
}

.ri-account-pin-circle-fill:before {
  content: "";
}

.ri-account-pin-circle-line:before {
  content: "";
}

.ri-add-box-fill:before {
  content: "";
}

.ri-add-box-line:before {
  content: "";
}

.ri-add-circle-fill:before {
  content: "";
}

.ri-add-circle-line:before {
  content: "";
}

.ri-add-fill:before {
  content: "";
}

.ri-add-line:before {
  content: "";
}

.ri-admin-fill:before {
  content: "";
}

.ri-admin-line:before {
  content: "";
}

.ri-advertisement-fill:before {
  content: "";
}

.ri-advertisement-line:before {
  content: "";
}

.ri-airplay-fill:before {
  content: "";
}

.ri-airplay-line:before {
  content: "";
}

.ri-alarm-fill:before {
  content: "";
}

.ri-alarm-line:before {
  content: "";
}

.ri-alarm-warning-fill:before {
  content: "";
}

.ri-alarm-warning-line:before {
  content: "";
}

.ri-album-fill:before {
  content: "";
}

.ri-album-line:before {
  content: "";
}

.ri-alert-fill:before {
  content: "";
}

.ri-alert-line:before {
  content: "";
}

.ri-aliens-fill:before {
  content: "";
}

.ri-aliens-line:before {
  content: "";
}

.ri-align-bottom:before {
  content: "";
}

.ri-align-center:before {
  content: "";
}

.ri-align-justify:before {
  content: "";
}

.ri-align-left:before {
  content: "";
}

.ri-align-right:before {
  content: "";
}

.ri-align-top:before {
  content: "";
}

.ri-align-vertically:before {
  content: "";
}

.ri-alipay-fill:before {
  content: "";
}

.ri-alipay-line:before {
  content: "";
}

.ri-amazon-fill:before {
  content: "";
}

.ri-amazon-line:before {
  content: "";
}

.ri-anchor-fill:before {
  content: "";
}

.ri-anchor-line:before {
  content: "";
}

.ri-ancient-gate-fill:before {
  content: "";
}

.ri-ancient-gate-line:before {
  content: "";
}

.ri-ancient-pavilion-fill:before {
  content: "";
}

.ri-ancient-pavilion-line:before {
  content: "";
}

.ri-android-fill:before {
  content: "";
}

.ri-android-line:before {
  content: "";
}

.ri-angularjs-fill:before {
  content: "";
}

.ri-angularjs-line:before {
  content: "";
}

.ri-anticlockwise-2-fill:before {
  content: "";
}

.ri-anticlockwise-2-line:before {
  content: "";
}

.ri-anticlockwise-fill:before {
  content: "";
}

.ri-anticlockwise-line:before {
  content: "";
}

.ri-app-store-fill:before {
  content: "";
}

.ri-app-store-line:before {
  content: "";
}

.ri-apple-fill:before {
  content: "";
}

.ri-apple-line:before {
  content: "";
}

.ri-apps-2-fill:before {
  content: "";
}

.ri-apps-2-line:before {
  content: "";
}

.ri-apps-fill:before {
  content: "";
}

.ri-apps-line:before {
  content: "";
}

.ri-archive-drawer-fill:before {
  content: "";
}

.ri-archive-drawer-line:before {
  content: "";
}

.ri-archive-fill:before {
  content: "";
}

.ri-archive-line:before {
  content: "";
}

.ri-arrow-down-circle-fill:before {
  content: "";
}

.ri-arrow-down-circle-line:before {
  content: "";
}

.ri-arrow-down-fill:before {
  content: "";
}

.ri-arrow-down-line:before {
  content: "";
}

.ri-arrow-down-s-fill:before {
  content: "";
}

.ri-arrow-down-s-line:before {
  content: "";
}

.ri-arrow-drop-down-fill:before {
  content: "";
}

.ri-arrow-drop-down-line:before {
  content: "";
}

.ri-arrow-drop-left-fill:before {
  content: "";
}

.ri-arrow-drop-left-line:before {
  content: "";
}

.ri-arrow-drop-right-fill:before {
  content: "";
}

.ri-arrow-drop-right-line:before {
  content: "";
}

.ri-arrow-drop-up-fill:before {
  content: "";
}

.ri-arrow-drop-up-line:before {
  content: "";
}

.ri-arrow-go-back-fill:before {
  content: "";
}

.ri-arrow-go-back-line:before {
  content: "";
}

.ri-arrow-go-forward-fill:before {
  content: "";
}

.ri-arrow-go-forward-line:before {
  content: "";
}

.ri-arrow-left-circle-fill:before {
  content: "";
}

.ri-arrow-left-circle-line:before {
  content: "";
}

.ri-arrow-left-down-fill:before {
  content: "";
}

.ri-arrow-left-down-line:before {
  content: "";
}

.ri-arrow-left-fill:before {
  content: "";
}

.ri-arrow-left-line:before {
  content: "";
}

.ri-arrow-left-right-fill:before {
  content: "";
}

.ri-arrow-left-right-line:before {
  content: "";
}

.ri-arrow-left-s-fill:before {
  content: "";
}

.ri-arrow-left-s-line:before {
  content: "";
}

.ri-arrow-left-up-fill:before {
  content: "";
}

.ri-arrow-left-up-line:before {
  content: "";
}

.ri-arrow-right-circle-fill:before {
  content: "";
}

.ri-arrow-right-circle-line:before {
  content: "";
}

.ri-arrow-right-down-fill:before {
  content: "";
}

.ri-arrow-right-down-line:before {
  content: "";
}

.ri-arrow-right-fill:before {
  content: "";
}

.ri-arrow-right-line:before {
  content: "";
}

.ri-arrow-right-s-fill:before {
  content: "";
}

.ri-arrow-right-s-line:before {
  content: "";
}

.ri-arrow-right-up-fill:before {
  content: "";
}

.ri-arrow-right-up-line:before {
  content: "";
}

.ri-arrow-up-circle-fill:before {
  content: "";
}

.ri-arrow-up-circle-line:before {
  content: "";
}

.ri-arrow-up-down-fill:before {
  content: "";
}

.ri-arrow-up-down-line:before {
  content: "";
}

.ri-arrow-up-fill:before {
  content: "";
}

.ri-arrow-up-line:before {
  content: "";
}

.ri-arrow-up-s-fill:before {
  content: "";
}

.ri-arrow-up-s-line:before {
  content: "";
}

.ri-artboard-2-fill:before {
  content: "";
}

.ri-artboard-2-line:before {
  content: "";
}

.ri-artboard-fill:before {
  content: "";
}

.ri-artboard-line:before {
  content: "";
}

.ri-article-fill:before {
  content: "";
}

.ri-article-line:before {
  content: "";
}

.ri-aspect-ratio-fill:before {
  content: "";
}

.ri-aspect-ratio-line:before {
  content: "";
}

.ri-asterisk:before {
  content: "";
}

.ri-at-fill:before {
  content: "";
}

.ri-at-line:before {
  content: "";
}

.ri-attachment-2:before {
  content: "";
}

.ri-attachment-fill:before {
  content: "";
}

.ri-attachment-line:before {
  content: "";
}

.ri-auction-fill:before {
  content: "";
}

.ri-auction-line:before {
  content: "";
}

.ri-award-fill:before {
  content: "";
}

.ri-award-line:before {
  content: "";
}

.ri-baidu-fill:before {
  content: "";
}

.ri-baidu-line:before {
  content: "";
}

.ri-ball-pen-fill:before {
  content: "";
}

.ri-ball-pen-line:before {
  content: "";
}

.ri-bank-card-2-fill:before {
  content: "";
}

.ri-bank-card-2-line:before {
  content: "";
}

.ri-bank-card-fill:before {
  content: "";
}

.ri-bank-card-line:before {
  content: "";
}

.ri-bank-fill:before {
  content: "";
}

.ri-bank-line:before {
  content: "";
}

.ri-bar-chart-2-fill:before {
  content: "";
}

.ri-bar-chart-2-line:before {
  content: "";
}

.ri-bar-chart-box-fill:before {
  content: "";
}

.ri-bar-chart-box-line:before {
  content: "";
}

.ri-bar-chart-fill:before {
  content: "";
}

.ri-bar-chart-grouped-fill:before {
  content: "";
}

.ri-bar-chart-grouped-line:before {
  content: "";
}

.ri-bar-chart-horizontal-fill:before {
  content: "";
}

.ri-bar-chart-horizontal-line:before {
  content: "";
}

.ri-bar-chart-line:before {
  content: "";
}

.ri-barcode-box-fill:before {
  content: "";
}

.ri-barcode-box-line:before {
  content: "";
}

.ri-barcode-fill:before {
  content: "";
}

.ri-barcode-line:before {
  content: "";
}

.ri-barricade-fill:before {
  content: "";
}

.ri-barricade-line:before {
  content: "";
}

.ri-base-station-fill:before {
  content: "";
}

.ri-base-station-line:before {
  content: "";
}

.ri-basketball-fill:before {
  content: "";
}

.ri-basketball-line:before {
  content: "";
}

.ri-battery-2-charge-fill:before {
  content: "";
}

.ri-battery-2-charge-line:before {
  content: "";
}

.ri-battery-2-fill:before {
  content: "";
}

.ri-battery-2-line:before {
  content: "";
}

.ri-battery-charge-fill:before {
  content: "";
}

.ri-battery-charge-line:before {
  content: "";
}

.ri-battery-fill:before {
  content: "";
}

.ri-battery-line:before {
  content: "";
}

.ri-battery-low-fill:before {
  content: "";
}

.ri-battery-low-line:before {
  content: "";
}

.ri-battery-saver-fill:before {
  content: "";
}

.ri-battery-saver-line:before {
  content: "";
}

.ri-battery-share-fill:before {
  content: "";
}

.ri-battery-share-line:before {
  content: "";
}

.ri-bear-smile-fill:before {
  content: "";
}

.ri-bear-smile-line:before {
  content: "";
}

.ri-behance-fill:before {
  content: "";
}

.ri-behance-line:before {
  content: "";
}

.ri-bell-fill:before {
  content: "";
}

.ri-bell-line:before {
  content: "";
}

.ri-bike-fill:before {
  content: "";
}

.ri-bike-line:before {
  content: "";
}

.ri-bilibili-fill:before {
  content: "";
}

.ri-bilibili-line:before {
  content: "";
}

.ri-bill-fill:before {
  content: "";
}

.ri-bill-line:before {
  content: "";
}

.ri-billiards-fill:before {
  content: "";
}

.ri-billiards-line:before {
  content: "";
}

.ri-bit-coin-fill:before {
  content: "";
}

.ri-bit-coin-line:before {
  content: "";
}

.ri-blaze-fill:before {
  content: "";
}

.ri-blaze-line:before {
  content: "";
}

.ri-bluetooth-connect-fill:before {
  content: "";
}

.ri-bluetooth-connect-line:before {
  content: "";
}

.ri-bluetooth-fill:before {
  content: "";
}

.ri-bluetooth-line:before {
  content: "";
}

.ri-blur-off-fill:before {
  content: "";
}

.ri-blur-off-line:before {
  content: "";
}

.ri-body-scan-fill:before {
  content: "";
}

.ri-body-scan-line:before {
  content: "";
}

.ri-bold:before {
  content: "";
}

.ri-book-2-fill:before {
  content: "";
}

.ri-book-2-line:before {
  content: "";
}

.ri-book-3-fill:before {
  content: "";
}

.ri-book-3-line:before {
  content: "";
}

.ri-book-fill:before {
  content: "";
}

.ri-book-line:before {
  content: "";
}

.ri-book-mark-fill:before {
  content: "";
}

.ri-book-mark-line:before {
  content: "";
}

.ri-book-open-fill:before {
  content: "";
}

.ri-book-open-line:before {
  content: "";
}

.ri-book-read-fill:before {
  content: "";
}

.ri-book-read-line:before {
  content: "";
}

.ri-booklet-fill:before {
  content: "";
}

.ri-booklet-line:before {
  content: "";
}

.ri-bookmark-2-fill:before {
  content: "";
}

.ri-bookmark-2-line:before {
  content: "";
}

.ri-bookmark-3-fill:before {
  content: "";
}

.ri-bookmark-3-line:before {
  content: "";
}

.ri-bookmark-fill:before {
  content: "";
}

.ri-bookmark-line:before {
  content: "";
}

.ri-boxing-fill:before {
  content: "";
}

.ri-boxing-line:before {
  content: "";
}

.ri-braces-fill:before {
  content: "";
}

.ri-braces-line:before {
  content: "";
}

.ri-brackets-fill:before {
  content: "";
}

.ri-brackets-line:before {
  content: "";
}

.ri-briefcase-2-fill:before {
  content: "";
}

.ri-briefcase-2-line:before {
  content: "";
}

.ri-briefcase-3-fill:before {
  content: "";
}

.ri-briefcase-3-line:before {
  content: "";
}

.ri-briefcase-4-fill:before {
  content: "";
}

.ri-briefcase-4-line:before {
  content: "";
}

.ri-briefcase-5-fill:before {
  content: "";
}

.ri-briefcase-5-line:before {
  content: "";
}

.ri-briefcase-fill:before {
  content: "";
}

.ri-briefcase-line:before {
  content: "";
}

.ri-bring-forward:before {
  content: "";
}

.ri-bring-to-front:before {
  content: "";
}

.ri-broadcast-fill:before {
  content: "";
}

.ri-broadcast-line:before {
  content: "";
}

.ri-brush-2-fill:before {
  content: "";
}

.ri-brush-2-line:before {
  content: "";
}

.ri-brush-3-fill:before {
  content: "";
}

.ri-brush-3-line:before {
  content: "";
}

.ri-brush-4-fill:before {
  content: "";
}

.ri-brush-4-line:before {
  content: "";
}

.ri-brush-fill:before {
  content: "";
}

.ri-brush-line:before {
  content: "";
}

.ri-bubble-chart-fill:before {
  content: "";
}

.ri-bubble-chart-line:before {
  content: "";
}

.ri-bug-2-fill:before {
  content: "";
}

.ri-bug-2-line:before {
  content: "";
}

.ri-bug-fill:before {
  content: "";
}

.ri-bug-line:before {
  content: "";
}

.ri-building-2-fill:before {
  content: "";
}

.ri-building-2-line:before {
  content: "";
}

.ri-building-3-fill:before {
  content: "";
}

.ri-building-3-line:before {
  content: "";
}

.ri-building-4-fill:before {
  content: "";
}

.ri-building-4-line:before {
  content: "";
}

.ri-building-fill:before {
  content: "";
}

.ri-building-line:before {
  content: "";
}

.ri-bus-2-fill:before {
  content: "";
}

.ri-bus-2-line:before {
  content: "";
}

.ri-bus-fill:before {
  content: "";
}

.ri-bus-line:before {
  content: "";
}

.ri-bus-wifi-fill:before {
  content: "";
}

.ri-bus-wifi-line:before {
  content: "";
}

.ri-cactus-fill:before {
  content: "";
}

.ri-cactus-line:before {
  content: "";
}

.ri-cake-2-fill:before {
  content: "";
}

.ri-cake-2-line:before {
  content: "";
}

.ri-cake-3-fill:before {
  content: "";
}

.ri-cake-3-line:before {
  content: "";
}

.ri-cake-fill:before {
  content: "";
}

.ri-cake-line:before {
  content: "";
}

.ri-calculator-fill:before {
  content: "";
}

.ri-calculator-line:before {
  content: "";
}

.ri-calendar-2-fill:before {
  content: "";
}

.ri-calendar-2-line:before {
  content: "";
}

.ri-calendar-check-fill:before {
  content: "";
}

.ri-calendar-check-line:before {
  content: "";
}

.ri-calendar-event-fill:before {
  content: "";
}

.ri-calendar-event-line:before {
  content: "";
}

.ri-calendar-fill:before {
  content: "";
}

.ri-calendar-line:before {
  content: "";
}

.ri-calendar-todo-fill:before {
  content: "";
}

.ri-calendar-todo-line:before {
  content: "";
}

.ri-camera-2-fill:before {
  content: "";
}

.ri-camera-2-line:before {
  content: "";
}

.ri-camera-3-fill:before {
  content: "";
}

.ri-camera-3-line:before {
  content: "";
}

.ri-camera-fill:before {
  content: "";
}

.ri-camera-lens-fill:before {
  content: "";
}

.ri-camera-lens-line:before {
  content: "";
}

.ri-camera-line:before {
  content: "";
}

.ri-camera-off-fill:before {
  content: "";
}

.ri-camera-off-line:before {
  content: "";
}

.ri-camera-switch-fill:before {
  content: "";
}

.ri-camera-switch-line:before {
  content: "";
}

.ri-capsule-fill:before {
  content: "";
}

.ri-capsule-line:before {
  content: "";
}

.ri-car-fill:before {
  content: "";
}

.ri-car-line:before {
  content: "";
}

.ri-car-washing-fill:before {
  content: "";
}

.ri-car-washing-line:before {
  content: "";
}

.ri-caravan-fill:before {
  content: "";
}

.ri-caravan-line:before {
  content: "";
}

.ri-cast-fill:before {
  content: "";
}

.ri-cast-line:before {
  content: "";
}

.ri-cellphone-fill:before {
  content: "";
}

.ri-cellphone-line:before {
  content: "";
}

.ri-celsius-fill:before {
  content: "";
}

.ri-celsius-line:before {
  content: "";
}

.ri-centos-fill:before {
  content: "";
}

.ri-centos-line:before {
  content: "";
}

.ri-character-recognition-fill:before {
  content: "";
}

.ri-character-recognition-line:before {
  content: "";
}

.ri-charging-pile-2-fill:before {
  content: "";
}

.ri-charging-pile-2-line:before {
  content: "";
}

.ri-charging-pile-fill:before {
  content: "";
}

.ri-charging-pile-line:before {
  content: "";
}

.ri-chat-1-fill:before {
  content: "";
}

.ri-chat-1-line:before {
  content: "";
}

.ri-chat-2-fill:before {
  content: "";
}

.ri-chat-2-line:before {
  content: "";
}

.ri-chat-3-fill:before {
  content: "";
}

.ri-chat-3-line:before {
  content: "";
}

.ri-chat-4-fill:before {
  content: "";
}

.ri-chat-4-line:before {
  content: "";
}

.ri-chat-check-fill:before {
  content: "";
}

.ri-chat-check-line:before {
  content: "";
}

.ri-chat-delete-fill:before {
  content: "";
}

.ri-chat-delete-line:before {
  content: "";
}

.ri-chat-download-fill:before {
  content: "";
}

.ri-chat-download-line:before {
  content: "";
}

.ri-chat-follow-up-fill:before {
  content: "";
}

.ri-chat-follow-up-line:before {
  content: "";
}

.ri-chat-forward-fill:before {
  content: "";
}

.ri-chat-forward-line:before {
  content: "";
}

.ri-chat-heart-fill:before {
  content: "";
}

.ri-chat-heart-line:before {
  content: "";
}

.ri-chat-history-fill:before {
  content: "";
}

.ri-chat-history-line:before {
  content: "";
}

.ri-chat-new-fill:before {
  content: "";
}

.ri-chat-new-line:before {
  content: "";
}

.ri-chat-off-fill:before {
  content: "";
}

.ri-chat-off-line:before {
  content: "";
}

.ri-chat-poll-fill:before {
  content: "";
}

.ri-chat-poll-line:before {
  content: "";
}

.ri-chat-private-fill:before {
  content: "";
}

.ri-chat-private-line:before {
  content: "";
}

.ri-chat-quote-fill:before {
  content: "";
}

.ri-chat-quote-line:before {
  content: "";
}

.ri-chat-settings-fill:before {
  content: "";
}

.ri-chat-settings-line:before {
  content: "";
}

.ri-chat-smile-2-fill:before {
  content: "";
}

.ri-chat-smile-2-line:before {
  content: "";
}

.ri-chat-smile-3-fill:before {
  content: "";
}

.ri-chat-smile-3-line:before {
  content: "";
}

.ri-chat-smile-fill:before {
  content: "";
}

.ri-chat-smile-line:before {
  content: "";
}

.ri-chat-upload-fill:before {
  content: "";
}

.ri-chat-upload-line:before {
  content: "";
}

.ri-chat-voice-fill:before {
  content: "";
}

.ri-chat-voice-line:before {
  content: "";
}

.ri-check-double-fill:before {
  content: "";
}

.ri-check-double-line:before {
  content: "";
}

.ri-check-fill:before {
  content: "";
}

.ri-check-line:before {
  content: "";
}

.ri-checkbox-blank-circle-fill:before {
  content: "";
}

.ri-checkbox-blank-circle-line:before {
  content: "";
}

.ri-checkbox-blank-fill:before {
  content: "";
}

.ri-checkbox-blank-line:before {
  content: "";
}

.ri-checkbox-circle-fill:before {
  content: "";
}

.ri-checkbox-circle-line:before {
  content: "";
}

.ri-checkbox-fill:before {
  content: "";
}

.ri-checkbox-indeterminate-fill:before {
  content: "";
}

.ri-checkbox-indeterminate-line:before {
  content: "";
}

.ri-checkbox-line:before {
  content: "";
}

.ri-checkbox-multiple-blank-fill:before {
  content: "";
}

.ri-checkbox-multiple-blank-line:before {
  content: "";
}

.ri-checkbox-multiple-fill:before {
  content: "";
}

.ri-checkbox-multiple-line:before {
  content: "";
}

.ri-china-railway-fill:before {
  content: "";
}

.ri-china-railway-line:before {
  content: "";
}

.ri-chrome-fill:before {
  content: "";
}

.ri-chrome-line:before {
  content: "";
}

.ri-clapperboard-fill:before {
  content: "";
}

.ri-clapperboard-line:before {
  content: "";
}

.ri-clipboard-fill:before {
  content: "";
}

.ri-clipboard-line:before {
  content: "";
}

.ri-clockwise-2-fill:before {
  content: "";
}

.ri-clockwise-2-line:before {
  content: "";
}

.ri-clockwise-fill:before {
  content: "";
}

.ri-clockwise-line:before {
  content: "";
}

.ri-close-circle-fill:before {
  content: "";
}

.ri-close-circle-line:before {
  content: "";
}

.ri-close-fill:before {
  content: "";
}

.ri-close-line:before {
  content: "";
}

.ri-closed-captioning-fill:before {
  content: "";
}

.ri-closed-captioning-line:before {
  content: "";
}

.ri-cloud-fill:before {
  content: "";
}

.ri-cloud-line:before {
  content: "";
}

.ri-cloud-off-fill:before {
  content: "";
}

.ri-cloud-off-line:before {
  content: "";
}

.ri-cloud-windy-fill:before {
  content: "";
}

.ri-cloud-windy-line:before {
  content: "";
}

.ri-cloudy-2-fill:before {
  content: "";
}

.ri-cloudy-2-line:before {
  content: "";
}

.ri-cloudy-fill:before {
  content: "";
}

.ri-cloudy-line:before {
  content: "";
}

.ri-code-box-fill:before {
  content: "";
}

.ri-code-box-line:before {
  content: "";
}

.ri-code-fill:before {
  content: "";
}

.ri-code-line:before {
  content: "";
}

.ri-code-s-fill:before {
  content: "";
}

.ri-code-s-line:before {
  content: "";
}

.ri-code-s-slash-fill:before {
  content: "";
}

.ri-code-s-slash-line:before {
  content: "";
}

.ri-code-view:before {
  content: "";
}

.ri-codepen-fill:before {
  content: "";
}

.ri-codepen-line:before {
  content: "";
}

.ri-coin-fill:before {
  content: "";
}

.ri-coin-line:before {
  content: "";
}

.ri-coins-fill:before {
  content: "";
}

.ri-coins-line:before {
  content: "";
}

.ri-collage-fill:before {
  content: "";
}

.ri-collage-line:before {
  content: "";
}

.ri-command-fill:before {
  content: "";
}

.ri-command-line:before {
  content: "";
}

.ri-community-fill:before {
  content: "";
}

.ri-community-line:before {
  content: "";
}

.ri-compass-2-fill:before {
  content: "";
}

.ri-compass-2-line:before {
  content: "";
}

.ri-compass-3-fill:before {
  content: "";
}

.ri-compass-3-line:before {
  content: "";
}

.ri-compass-4-fill:before {
  content: "";
}

.ri-compass-4-line:before {
  content: "";
}

.ri-compass-discover-fill:before {
  content: "";
}

.ri-compass-discover-line:before {
  content: "";
}

.ri-compass-fill:before {
  content: "";
}

.ri-compass-line:before {
  content: "";
}

.ri-compasses-2-fill:before {
  content: "";
}

.ri-compasses-2-line:before {
  content: "";
}

.ri-compasses-fill:before {
  content: "";
}

.ri-compasses-line:before {
  content: "";
}

.ri-computer-fill:before {
  content: "";
}

.ri-computer-line:before {
  content: "";
}

.ri-contacts-book-2-fill:before {
  content: "";
}

.ri-contacts-book-2-line:before {
  content: "";
}

.ri-contacts-book-fill:before {
  content: "";
}

.ri-contacts-book-line:before {
  content: "";
}

.ri-contacts-book-upload-fill:before {
  content: "";
}

.ri-contacts-book-upload-line:before {
  content: "";
}

.ri-contacts-fill:before {
  content: "";
}

.ri-contacts-line:before {
  content: "";
}

.ri-contrast-2-fill:before {
  content: "";
}

.ri-contrast-2-line:before {
  content: "";
}

.ri-contrast-drop-2-fill:before {
  content: "";
}

.ri-contrast-drop-2-line:before {
  content: "";
}

.ri-contrast-drop-fill:before {
  content: "";
}

.ri-contrast-drop-line:before {
  content: "";
}

.ri-contrast-fill:before {
  content: "";
}

.ri-contrast-line:before {
  content: "";
}

.ri-copper-coin-fill:before {
  content: "";
}

.ri-copper-coin-line:before {
  content: "";
}

.ri-copper-diamond-fill:before {
  content: "";
}

.ri-copper-diamond-line:before {
  content: "";
}

.ri-copyleft-fill:before {
  content: "";
}

.ri-copyleft-line:before {
  content: "";
}

.ri-copyright-fill:before {
  content: "";
}

.ri-copyright-line:before {
  content: "";
}

.ri-coreos-fill:before {
  content: "";
}

.ri-coreos-line:before {
  content: "";
}

.ri-coupon-2-fill:before {
  content: "";
}

.ri-coupon-2-line:before {
  content: "";
}

.ri-coupon-3-fill:before {
  content: "";
}

.ri-coupon-3-line:before {
  content: "";
}

.ri-coupon-4-fill:before {
  content: "";
}

.ri-coupon-4-line:before {
  content: "";
}

.ri-coupon-5-fill:before {
  content: "";
}

.ri-coupon-5-line:before {
  content: "";
}

.ri-coupon-fill:before {
  content: "";
}

.ri-coupon-line:before {
  content: "";
}

.ri-cpu-fill:before {
  content: "";
}

.ri-cpu-line:before {
  content: "";
}

.ri-creative-commons-by-fill:before {
  content: "";
}

.ri-creative-commons-by-line:before {
  content: "";
}

.ri-creative-commons-fill:before {
  content: "";
}

.ri-creative-commons-line:before {
  content: "";
}

.ri-creative-commons-nc-fill:before {
  content: "";
}

.ri-creative-commons-nc-line:before {
  content: "";
}

.ri-creative-commons-nd-fill:before {
  content: "";
}

.ri-creative-commons-nd-line:before {
  content: "";
}

.ri-creative-commons-sa-fill:before {
  content: "";
}

.ri-creative-commons-sa-line:before {
  content: "";
}

.ri-creative-commons-zero-fill:before {
  content: "";
}

.ri-creative-commons-zero-line:before {
  content: "";
}

.ri-criminal-fill:before {
  content: "";
}

.ri-criminal-line:before {
  content: "";
}

.ri-crop-2-fill:before {
  content: "";
}

.ri-crop-2-line:before {
  content: "";
}

.ri-crop-fill:before {
  content: "";
}

.ri-crop-line:before {
  content: "";
}

.ri-css3-fill:before {
  content: "";
}

.ri-css3-line:before {
  content: "";
}

.ri-cup-fill:before {
  content: "";
}

.ri-cup-line:before {
  content: "";
}

.ri-currency-fill:before {
  content: "";
}

.ri-currency-line:before {
  content: "";
}

.ri-cursor-fill:before {
  content: "";
}

.ri-cursor-line:before {
  content: "";
}

.ri-customer-service-2-fill:before {
  content: "";
}

.ri-customer-service-2-line:before {
  content: "";
}

.ri-customer-service-fill:before {
  content: "";
}

.ri-customer-service-line:before {
  content: "";
}

.ri-dashboard-2-fill:before {
  content: "";
}

.ri-dashboard-2-line:before {
  content: "";
}

.ri-dashboard-3-fill:before {
  content: "";
}

.ri-dashboard-3-line:before {
  content: "";
}

.ri-dashboard-fill:before {
  content: "";
}

.ri-dashboard-line:before {
  content: "";
}

.ri-database-2-fill:before {
  content: "";
}

.ri-database-2-line:before {
  content: "";
}

.ri-database-fill:before {
  content: "";
}

.ri-database-line:before {
  content: "";
}

.ri-delete-back-2-fill:before {
  content: "";
}

.ri-delete-back-2-line:before {
  content: "";
}

.ri-delete-back-fill:before {
  content: "";
}

.ri-delete-back-line:before {
  content: "";
}

.ri-delete-bin-2-fill:before {
  content: "";
}

.ri-delete-bin-2-line:before {
  content: "";
}

.ri-delete-bin-3-fill:before {
  content: "";
}

.ri-delete-bin-3-line:before {
  content: "";
}

.ri-delete-bin-4-fill:before {
  content: "";
}

.ri-delete-bin-4-line:before {
  content: "";
}

.ri-delete-bin-5-fill:before {
  content: "";
}

.ri-delete-bin-5-line:before {
  content: "";
}

.ri-delete-bin-6-fill:before {
  content: "";
}

.ri-delete-bin-6-line:before {
  content: "";
}

.ri-delete-bin-7-fill:before {
  content: "";
}

.ri-delete-bin-7-line:before {
  content: "";
}

.ri-delete-bin-fill:before {
  content: "";
}

.ri-delete-bin-line:before {
  content: "";
}

.ri-delete-column:before {
  content: "";
}

.ri-delete-row:before {
  content: "";
}

.ri-device-fill:before {
  content: "";
}

.ri-device-line:before {
  content: "";
}

.ri-device-recover-fill:before {
  content: "";
}

.ri-device-recover-line:before {
  content: "";
}

.ri-dingding-fill:before {
  content: "";
}

.ri-dingding-line:before {
  content: "";
}

.ri-direction-fill:before {
  content: "";
}

.ri-direction-line:before {
  content: "";
}

.ri-disc-fill:before {
  content: "";
}

.ri-disc-line:before {
  content: "";
}

.ri-discord-fill:before {
  content: "";
}

.ri-discord-line:before {
  content: "";
}

.ri-discuss-fill:before {
  content: "";
}

.ri-discuss-line:before {
  content: "";
}

.ri-dislike-fill:before {
  content: "";
}

.ri-dislike-line:before {
  content: "";
}

.ri-disqus-fill:before {
  content: "";
}

.ri-disqus-line:before {
  content: "";
}

.ri-divide-fill:before {
  content: "";
}

.ri-divide-line:before {
  content: "";
}

.ri-donut-chart-fill:before {
  content: "";
}

.ri-donut-chart-line:before {
  content: "";
}

.ri-door-closed-fill:before {
  content: "";
}

.ri-door-closed-line:before {
  content: "";
}

.ri-door-fill:before {
  content: "";
}

.ri-door-line:before {
  content: "";
}

.ri-door-lock-box-fill:before {
  content: "";
}

.ri-door-lock-box-line:before {
  content: "";
}

.ri-door-lock-fill:before {
  content: "";
}

.ri-door-lock-line:before {
  content: "";
}

.ri-door-open-fill:before {
  content: "";
}

.ri-door-open-line:before {
  content: "";
}

.ri-dossier-fill:before {
  content: "";
}

.ri-dossier-line:before {
  content: "";
}

.ri-douban-fill:before {
  content: "";
}

.ri-douban-line:before {
  content: "";
}

.ri-double-quotes-l:before {
  content: "";
}

.ri-double-quotes-r:before {
  content: "";
}

.ri-download-2-fill:before {
  content: "";
}

.ri-download-2-line:before {
  content: "";
}

.ri-download-cloud-2-fill:before {
  content: "";
}

.ri-download-cloud-2-line:before {
  content: "";
}

.ri-download-cloud-fill:before {
  content: "";
}

.ri-download-cloud-line:before {
  content: "";
}

.ri-download-fill:before {
  content: "";
}

.ri-download-line:before {
  content: "";
}

.ri-draft-fill:before {
  content: "";
}

.ri-draft-line:before {
  content: "";
}

.ri-drag-drop-fill:before {
  content: "";
}

.ri-drag-drop-line:before {
  content: "";
}

.ri-drag-move-2-fill:before {
  content: "";
}

.ri-drag-move-2-line:before {
  content: "";
}

.ri-drag-move-fill:before {
  content: "";
}

.ri-drag-move-line:before {
  content: "";
}

.ri-dribbble-fill:before {
  content: "";
}

.ri-dribbble-line:before {
  content: "";
}

.ri-drive-fill:before {
  content: "";
}

.ri-drive-line:before {
  content: "";
}

.ri-drizzle-fill:before {
  content: "";
}

.ri-drizzle-line:before {
  content: "";
}

.ri-drop-fill:before {
  content: "";
}

.ri-drop-line:before {
  content: "";
}

.ri-dropbox-fill:before {
  content: "";
}

.ri-dropbox-line:before {
  content: "";
}

.ri-dual-sim-1-fill:before {
  content: "";
}

.ri-dual-sim-1-line:before {
  content: "";
}

.ri-dual-sim-2-fill:before {
  content: "";
}

.ri-dual-sim-2-line:before {
  content: "";
}

.ri-dv-fill:before {
  content: "";
}

.ri-dv-line:before {
  content: "";
}

.ri-dvd-fill:before {
  content: "";
}

.ri-dvd-line:before {
  content: "";
}

.ri-e-bike-2-fill:before {
  content: "";
}

.ri-e-bike-2-line:before {
  content: "";
}

.ri-e-bike-fill:before {
  content: "";
}

.ri-e-bike-line:before {
  content: "";
}

.ri-earth-fill:before {
  content: "";
}

.ri-earth-line:before {
  content: "";
}

.ri-earthquake-fill:before {
  content: "";
}

.ri-earthquake-line:before {
  content: "";
}

.ri-edge-fill:before {
  content: "";
}

.ri-edge-line:before {
  content: "";
}

.ri-edit-2-fill:before {
  content: "";
}

.ri-edit-2-line:before {
  content: "";
}

.ri-edit-box-fill:before {
  content: "";
}

.ri-edit-box-line:before {
  content: "";
}

.ri-edit-circle-fill:before {
  content: "";
}

.ri-edit-circle-line:before {
  content: "";
}

.ri-edit-fill:before {
  content: "";
}

.ri-edit-line:before {
  content: "";
}

.ri-eject-fill:before {
  content: "";
}

.ri-eject-line:before {
  content: "";
}

.ri-emotion-2-fill:before {
  content: "";
}

.ri-emotion-2-line:before {
  content: "";
}

.ri-emotion-fill:before {
  content: "";
}

.ri-emotion-happy-fill:before {
  content: "";
}

.ri-emotion-happy-line:before {
  content: "";
}

.ri-emotion-laugh-fill:before {
  content: "";
}

.ri-emotion-laugh-line:before {
  content: "";
}

.ri-emotion-line:before {
  content: "";
}

.ri-emotion-normal-fill:before {
  content: "";
}

.ri-emotion-normal-line:before {
  content: "";
}

.ri-emotion-sad-fill:before {
  content: "";
}

.ri-emotion-sad-line:before {
  content: "";
}

.ri-emotion-unhappy-fill:before {
  content: "";
}

.ri-emotion-unhappy-line:before {
  content: "";
}

.ri-empathize-fill:before {
  content: "";
}

.ri-empathize-line:before {
  content: "";
}

.ri-emphasis-cn:before {
  content: "";
}

.ri-emphasis:before {
  content: "";
}

.ri-english-input:before {
  content: "";
}

.ri-equalizer-fill:before {
  content: "";
}

.ri-equalizer-line:before {
  content: "";
}

.ri-eraser-fill:before {
  content: "";
}

.ri-eraser-line:before {
  content: "";
}

.ri-error-warning-fill:before {
  content: "";
}

.ri-error-warning-line:before {
  content: "";
}

.ri-evernote-fill:before {
  content: "";
}

.ri-evernote-line:before {
  content: "";
}

.ri-exchange-box-fill:before {
  content: "";
}

.ri-exchange-box-line:before {
  content: "";
}

.ri-exchange-cny-fill:before {
  content: "";
}

.ri-exchange-cny-line:before {
  content: "";
}

.ri-exchange-dollar-fill:before {
  content: "";
}

.ri-exchange-dollar-line:before {
  content: "";
}

.ri-exchange-fill:before {
  content: "";
}

.ri-exchange-funds-fill:before {
  content: "";
}

.ri-exchange-funds-line:before {
  content: "";
}

.ri-exchange-line:before {
  content: "";
}

.ri-external-link-fill:before {
  content: "";
}

.ri-external-link-line:before {
  content: "";
}

.ri-eye-2-fill:before {
  content: "";
}

.ri-eye-2-line:before {
  content: "";
}

.ri-eye-close-fill:before {
  content: "";
}

.ri-eye-close-line:before {
  content: "";
}

.ri-eye-fill:before {
  content: "";
}

.ri-eye-line:before {
  content: "";
}

.ri-eye-off-fill:before {
  content: "";
}

.ri-eye-off-line:before {
  content: "";
}

.ri-facebook-box-fill:before {
  content: "";
}

.ri-facebook-box-line:before {
  content: "";
}

.ri-facebook-circle-fill:before {
  content: "";
}

.ri-facebook-circle-line:before {
  content: "";
}

.ri-facebook-fill:before {
  content: "";
}

.ri-facebook-line:before {
  content: "";
}

.ri-fahrenheit-fill:before {
  content: "";
}

.ri-fahrenheit-line:before {
  content: "";
}

.ri-feedback-fill:before {
  content: "";
}

.ri-feedback-line:before {
  content: "";
}

.ri-file-2-fill:before {
  content: "";
}

.ri-file-2-line:before {
  content: "";
}

.ri-file-3-fill:before {
  content: "";
}

.ri-file-3-line:before {
  content: "";
}

.ri-file-4-fill:before {
  content: "";
}

.ri-file-4-line:before {
  content: "";
}

.ri-file-add-fill:before {
  content: "";
}

.ri-file-add-line:before {
  content: "";
}

.ri-file-chart-2-fill:before {
  content: "";
}

.ri-file-chart-2-line:before {
  content: "";
}

.ri-file-chart-fill:before {
  content: "";
}

.ri-file-chart-line:before {
  content: "";
}

.ri-file-cloud-fill:before {
  content: "";
}

.ri-file-cloud-line:before {
  content: "";
}

.ri-file-code-fill:before {
  content: "";
}

.ri-file-code-line:before {
  content: "";
}

.ri-file-copy-2-fill:before {
  content: "";
}

.ri-file-copy-2-line:before {
  content: "";
}

.ri-file-copy-fill:before {
  content: "";
}

.ri-file-copy-line:before {
  content: "";
}

.ri-file-damage-fill:before {
  content: "";
}

.ri-file-damage-line:before {
  content: "";
}

.ri-file-download-fill:before {
  content: "";
}

.ri-file-download-line:before {
  content: "";
}

.ri-file-edit-fill:before {
  content: "";
}

.ri-file-edit-line:before {
  content: "";
}

.ri-file-excel-2-fill:before {
  content: "";
}

.ri-file-excel-2-line:before {
  content: "";
}

.ri-file-excel-fill:before {
  content: "";
}

.ri-file-excel-line:before {
  content: "";
}

.ri-file-fill:before {
  content: "";
}

.ri-file-forbid-fill:before {
  content: "";
}

.ri-file-forbid-line:before {
  content: "";
}

.ri-file-gif-fill:before {
  content: "";
}

.ri-file-gif-line:before {
  content: "";
}

.ri-file-history-fill:before {
  content: "";
}

.ri-file-history-line:before {
  content: "";
}

.ri-file-hwp-fill:before {
  content: "";
}

.ri-file-hwp-line:before {
  content: "";
}

.ri-file-info-fill:before {
  content: "";
}

.ri-file-info-line:before {
  content: "";
}

.ri-file-line:before {
  content: "";
}

.ri-file-list-2-fill:before {
  content: "";
}

.ri-file-list-2-line:before {
  content: "";
}

.ri-file-list-3-fill:before {
  content: "";
}

.ri-file-list-3-line:before {
  content: "";
}

.ri-file-list-fill:before {
  content: "";
}

.ri-file-list-line:before {
  content: "";
}

.ri-file-lock-fill:before {
  content: "";
}

.ri-file-lock-line:before {
  content: "";
}

.ri-file-mark-fill:before {
  content: "";
}

.ri-file-mark-line:before {
  content: "";
}

.ri-file-music-fill:before {
  content: "";
}

.ri-file-music-line:before {
  content: "";
}

.ri-file-paper-2-fill:before {
  content: "";
}

.ri-file-paper-2-line:before {
  content: "";
}

.ri-file-paper-fill:before {
  content: "";
}

.ri-file-paper-line:before {
  content: "";
}

.ri-file-pdf-fill:before {
  content: "";
}

.ri-file-pdf-line:before {
  content: "";
}

.ri-file-ppt-2-fill:before {
  content: "";
}

.ri-file-ppt-2-line:before {
  content: "";
}

.ri-file-ppt-fill:before {
  content: "";
}

.ri-file-ppt-line:before {
  content: "";
}

.ri-file-reduce-fill:before {
  content: "";
}

.ri-file-reduce-line:before {
  content: "";
}

.ri-file-search-fill:before {
  content: "";
}

.ri-file-search-line:before {
  content: "";
}

.ri-file-settings-fill:before {
  content: "";
}

.ri-file-settings-line:before {
  content: "";
}

.ri-file-shield-2-fill:before {
  content: "";
}

.ri-file-shield-2-line:before {
  content: "";
}

.ri-file-shield-fill:before {
  content: "";
}

.ri-file-shield-line:before {
  content: "";
}

.ri-file-shred-fill:before {
  content: "";
}

.ri-file-shred-line:before {
  content: "";
}

.ri-file-text-fill:before {
  content: "";
}

.ri-file-text-line:before {
  content: "";
}

.ri-file-transfer-fill:before {
  content: "";
}

.ri-file-transfer-line:before {
  content: "";
}

.ri-file-unknow-fill:before {
  content: "";
}

.ri-file-unknow-line:before {
  content: "";
}

.ri-file-upload-fill:before {
  content: "";
}

.ri-file-upload-line:before {
  content: "";
}

.ri-file-user-fill:before {
  content: "";
}

.ri-file-user-line:before {
  content: "";
}

.ri-file-warning-fill:before {
  content: "";
}

.ri-file-warning-line:before {
  content: "";
}

.ri-file-word-2-fill:before {
  content: "";
}

.ri-file-word-2-line:before {
  content: "";
}

.ri-file-word-fill:before {
  content: "";
}

.ri-file-word-line:before {
  content: "";
}

.ri-file-zip-fill:before {
  content: "";
}

.ri-file-zip-line:before {
  content: "";
}

.ri-film-fill:before {
  content: "";
}

.ri-film-line:before {
  content: "";
}

.ri-filter-2-fill:before {
  content: "";
}

.ri-filter-2-line:before {
  content: "";
}

.ri-filter-3-fill:before {
  content: "";
}

.ri-filter-3-line:before {
  content: "";
}

.ri-filter-fill:before {
  content: "";
}

.ri-filter-line:before {
  content: "";
}

.ri-filter-off-fill:before {
  content: "";
}

.ri-filter-off-line:before {
  content: "";
}

.ri-find-replace-fill:before {
  content: "";
}

.ri-find-replace-line:before {
  content: "";
}

.ri-finder-fill:before {
  content: "";
}

.ri-finder-line:before {
  content: "";
}

.ri-fingerprint-2-fill:before {
  content: "";
}

.ri-fingerprint-2-line:before {
  content: "";
}

.ri-fingerprint-fill:before {
  content: "";
}

.ri-fingerprint-line:before {
  content: "";
}

.ri-fire-fill:before {
  content: "";
}

.ri-fire-line:before {
  content: "";
}

.ri-firefox-fill:before {
  content: "";
}

.ri-firefox-line:before {
  content: "";
}

.ri-first-aid-kit-fill:before {
  content: "";
}

.ri-first-aid-kit-line:before {
  content: "";
}

.ri-flag-2-fill:before {
  content: "";
}

.ri-flag-2-line:before {
  content: "";
}

.ri-flag-fill:before {
  content: "";
}

.ri-flag-line:before {
  content: "";
}

.ri-flashlight-fill:before {
  content: "";
}

.ri-flashlight-line:before {
  content: "";
}

.ri-flask-fill:before {
  content: "";
}

.ri-flask-line:before {
  content: "";
}

.ri-flight-land-fill:before {
  content: "";
}

.ri-flight-land-line:before {
  content: "";
}

.ri-flight-takeoff-fill:before {
  content: "";
}

.ri-flight-takeoff-line:before {
  content: "";
}

.ri-flood-fill:before {
  content: "";
}

.ri-flood-line:before {
  content: "";
}

.ri-flow-chart:before {
  content: "";
}

.ri-flutter-fill:before {
  content: "";
}

.ri-flutter-line:before {
  content: "";
}

.ri-focus-2-fill:before {
  content: "";
}

.ri-focus-2-line:before {
  content: "";
}

.ri-focus-3-fill:before {
  content: "";
}

.ri-focus-3-line:before {
  content: "";
}

.ri-focus-fill:before {
  content: "";
}

.ri-focus-line:before {
  content: "";
}

.ri-foggy-fill:before {
  content: "";
}

.ri-foggy-line:before {
  content: "";
}

.ri-folder-2-fill:before {
  content: "";
}

.ri-folder-2-line:before {
  content: "";
}

.ri-folder-3-fill:before {
  content: "";
}

.ri-folder-3-line:before {
  content: "";
}

.ri-folder-4-fill:before {
  content: "";
}

.ri-folder-4-line:before {
  content: "";
}

.ri-folder-5-fill:before {
  content: "";
}

.ri-folder-5-line:before {
  content: "";
}

.ri-folder-add-fill:before {
  content: "";
}

.ri-folder-add-line:before {
  content: "";
}

.ri-folder-chart-2-fill:before {
  content: "";
}

.ri-folder-chart-2-line:before {
  content: "";
}

.ri-folder-chart-fill:before {
  content: "";
}

.ri-folder-chart-line:before {
  content: "";
}

.ri-folder-download-fill:before {
  content: "";
}

.ri-folder-download-line:before {
  content: "";
}

.ri-folder-fill:before {
  content: "";
}

.ri-folder-forbid-fill:before {
  content: "";
}

.ri-folder-forbid-line:before {
  content: "";
}

.ri-folder-history-fill:before {
  content: "";
}

.ri-folder-history-line:before {
  content: "";
}

.ri-folder-info-fill:before {
  content: "";
}

.ri-folder-info-line:before {
  content: "";
}

.ri-folder-keyhole-fill:before {
  content: "";
}

.ri-folder-keyhole-line:before {
  content: "";
}

.ri-folder-line:before {
  content: "";
}

.ri-folder-lock-fill:before {
  content: "";
}

.ri-folder-lock-line:before {
  content: "";
}

.ri-folder-music-fill:before {
  content: "";
}

.ri-folder-music-line:before {
  content: "";
}

.ri-folder-open-fill:before {
  content: "";
}

.ri-folder-open-line:before {
  content: "";
}

.ri-folder-received-fill:before {
  content: "";
}

.ri-folder-received-line:before {
  content: "";
}

.ri-folder-reduce-fill:before {
  content: "";
}

.ri-folder-reduce-line:before {
  content: "";
}

.ri-folder-settings-fill:before {
  content: "";
}

.ri-folder-settings-line:before {
  content: "";
}

.ri-folder-shared-fill:before {
  content: "";
}

.ri-folder-shared-line:before {
  content: "";
}

.ri-folder-shield-2-fill:before {
  content: "";
}

.ri-folder-shield-2-line:before {
  content: "";
}

.ri-folder-shield-fill:before {
  content: "";
}

.ri-folder-shield-line:before {
  content: "";
}

.ri-folder-transfer-fill:before {
  content: "";
}

.ri-folder-transfer-line:before {
  content: "";
}

.ri-folder-unknow-fill:before {
  content: "";
}

.ri-folder-unknow-line:before {
  content: "";
}

.ri-folder-upload-fill:before {
  content: "";
}

.ri-folder-upload-line:before {
  content: "";
}

.ri-folder-user-fill:before {
  content: "";
}

.ri-folder-user-line:before {
  content: "";
}

.ri-folder-warning-fill:before {
  content: "";
}

.ri-folder-warning-line:before {
  content: "";
}

.ri-folder-zip-fill:before {
  content: "";
}

.ri-folder-zip-line:before {
  content: "";
}

.ri-folders-fill:before {
  content: "";
}

.ri-folders-line:before {
  content: "";
}

.ri-font-color:before {
  content: "";
}

.ri-font-size-2:before {
  content: "";
}

.ri-font-size:before {
  content: "";
}

.ri-football-fill:before {
  content: "";
}

.ri-football-line:before {
  content: "";
}

.ri-footprint-fill:before {
  content: "";
}

.ri-footprint-line:before {
  content: "";
}

.ri-forbid-2-fill:before {
  content: "";
}

.ri-forbid-2-line:before {
  content: "";
}

.ri-forbid-fill:before {
  content: "";
}

.ri-forbid-line:before {
  content: "";
}

.ri-format-clear:before {
  content: "";
}

.ri-fridge-fill:before {
  content: "";
}

.ri-fridge-line:before {
  content: "";
}

.ri-fullscreen-exit-fill:before {
  content: "";
}

.ri-fullscreen-exit-line:before {
  content: "";
}

.ri-fullscreen-fill:before {
  content: "";
}

.ri-fullscreen-line:before {
  content: "";
}

.ri-function-fill:before {
  content: "";
}

.ri-function-line:before {
  content: "";
}

.ri-functions:before {
  content: "";
}

.ri-funds-box-fill:before {
  content: "";
}

.ri-funds-box-line:before {
  content: "";
}

.ri-funds-fill:before {
  content: "";
}

.ri-funds-line:before {
  content: "";
}

.ri-gallery-fill:before {
  content: "";
}

.ri-gallery-line:before {
  content: "";
}

.ri-gallery-upload-fill:before {
  content: "";
}

.ri-gallery-upload-line:before {
  content: "";
}

.ri-game-fill:before {
  content: "";
}

.ri-game-line:before {
  content: "";
}

.ri-gamepad-fill:before {
  content: "";
}

.ri-gamepad-line:before {
  content: "";
}

.ri-gas-station-fill:before {
  content: "";
}

.ri-gas-station-line:before {
  content: "";
}

.ri-gatsby-fill:before {
  content: "";
}

.ri-gatsby-line:before {
  content: "";
}

.ri-genderless-fill:before {
  content: "";
}

.ri-genderless-line:before {
  content: "";
}

.ri-ghost-2-fill:before {
  content: "";
}

.ri-ghost-2-line:before {
  content: "";
}

.ri-ghost-fill:before {
  content: "";
}

.ri-ghost-line:before {
  content: "";
}

.ri-ghost-smile-fill:before {
  content: "";
}

.ri-ghost-smile-line:before {
  content: "";
}

.ri-gift-2-fill:before {
  content: "";
}

.ri-gift-2-line:before {
  content: "";
}

.ri-gift-fill:before {
  content: "";
}

.ri-gift-line:before {
  content: "";
}

.ri-git-branch-fill:before {
  content: "";
}

.ri-git-branch-line:before {
  content: "";
}

.ri-git-commit-fill:before {
  content: "";
}

.ri-git-commit-line:before {
  content: "";
}

.ri-git-merge-fill:before {
  content: "";
}

.ri-git-merge-line:before {
  content: "";
}

.ri-git-pull-request-fill:before {
  content: "";
}

.ri-git-pull-request-line:before {
  content: "";
}

.ri-git-repository-commits-fill:before {
  content: "";
}

.ri-git-repository-commits-line:before {
  content: "";
}

.ri-git-repository-fill:before {
  content: "";
}

.ri-git-repository-line:before {
  content: "";
}

.ri-git-repository-private-fill:before {
  content: "";
}

.ri-git-repository-private-line:before {
  content: "";
}

.ri-github-fill:before {
  content: "";
}

.ri-github-line:before {
  content: "";
}

.ri-gitlab-fill:before {
  content: "";
}

.ri-gitlab-line:before {
  content: "";
}

.ri-global-fill:before {
  content: "";
}

.ri-global-line:before {
  content: "";
}

.ri-globe-fill:before {
  content: "";
}

.ri-globe-line:before {
  content: "";
}

.ri-goblet-fill:before {
  content: "";
}

.ri-goblet-line:before {
  content: "";
}

.ri-google-fill:before {
  content: "";
}

.ri-google-line:before {
  content: "";
}

.ri-google-play-fill:before {
  content: "";
}

.ri-google-play-line:before {
  content: "";
}

.ri-government-fill:before {
  content: "";
}

.ri-government-line:before {
  content: "";
}

.ri-gps-fill:before {
  content: "";
}

.ri-gps-line:before {
  content: "";
}

.ri-gradienter-fill:before {
  content: "";
}

.ri-gradienter-line:before {
  content: "";
}

.ri-grid-fill:before {
  content: "";
}

.ri-grid-line:before {
  content: "";
}

.ri-group-2-fill:before {
  content: "";
}

.ri-group-2-line:before {
  content: "";
}

.ri-group-fill:before {
  content: "";
}

.ri-group-line:before {
  content: "";
}

.ri-guide-fill:before {
  content: "";
}

.ri-guide-line:before {
  content: "";
}

.ri-h-1:before {
  content: "";
}

.ri-h-2:before {
  content: "";
}

.ri-h-3:before {
  content: "";
}

.ri-h-4:before {
  content: "";
}

.ri-h-5:before {
  content: "";
}

.ri-h-6:before {
  content: "";
}

.ri-hail-fill:before {
  content: "";
}

.ri-hail-line:before {
  content: "";
}

.ri-hammer-fill:before {
  content: "";
}

.ri-hammer-line:before {
  content: "";
}

.ri-hand-coin-fill:before {
  content: "";
}

.ri-hand-coin-line:before {
  content: "";
}

.ri-hand-heart-fill:before {
  content: "";
}

.ri-hand-heart-line:before {
  content: "";
}

.ri-hand-sanitizer-fill:before {
  content: "";
}

.ri-hand-sanitizer-line:before {
  content: "";
}

.ri-handbag-fill:before {
  content: "";
}

.ri-handbag-line:before {
  content: "";
}

.ri-hard-drive-2-fill:before {
  content: "";
}

.ri-hard-drive-2-line:before {
  content: "";
}

.ri-hard-drive-fill:before {
  content: "";
}

.ri-hard-drive-line:before {
  content: "";
}

.ri-hashtag:before {
  content: "";
}

.ri-haze-2-fill:before {
  content: "";
}

.ri-haze-2-line:before {
  content: "";
}

.ri-haze-fill:before {
  content: "";
}

.ri-haze-line:before {
  content: "";
}

.ri-hd-fill:before {
  content: "";
}

.ri-hd-line:before {
  content: "";
}

.ri-heading:before {
  content: "";
}

.ri-headphone-fill:before {
  content: "";
}

.ri-headphone-line:before {
  content: "";
}

.ri-health-book-fill:before {
  content: "";
}

.ri-health-book-line:before {
  content: "";
}

.ri-heart-2-fill:before {
  content: "";
}

.ri-heart-2-line:before {
  content: "";
}

.ri-heart-3-fill:before {
  content: "";
}

.ri-heart-3-line:before {
  content: "";
}

.ri-heart-add-fill:before {
  content: "";
}

.ri-heart-add-line:before {
  content: "";
}

.ri-heart-fill:before {
  content: "";
}

.ri-heart-line:before {
  content: "";
}

.ri-heart-pulse-fill:before {
  content: "";
}

.ri-heart-pulse-line:before {
  content: "";
}

.ri-hearts-fill:before {
  content: "";
}

.ri-hearts-line:before {
  content: "";
}

.ri-heavy-showers-fill:before {
  content: "";
}

.ri-heavy-showers-line:before {
  content: "";
}

.ri-history-fill:before {
  content: "";
}

.ri-history-line:before {
  content: "";
}

.ri-home-2-fill:before {
  content: "";
}

.ri-home-2-line:before {
  content: "";
}

.ri-home-3-fill:before {
  content: "";
}

.ri-home-3-line:before {
  content: "";
}

.ri-home-4-fill:before {
  content: "";
}

.ri-home-4-line:before {
  content: "";
}

.ri-home-5-fill:before {
  content: "";
}

.ri-home-5-line:before {
  content: "";
}

.ri-home-6-fill:before {
  content: "";
}

.ri-home-6-line:before {
  content: "";
}

.ri-home-7-fill:before {
  content: "";
}

.ri-home-7-line:before {
  content: "";
}

.ri-home-8-fill:before {
  content: "";
}

.ri-home-8-line:before {
  content: "";
}

.ri-home-fill:before {
  content: "";
}

.ri-home-gear-fill:before {
  content: "";
}

.ri-home-gear-line:before {
  content: "";
}

.ri-home-heart-fill:before {
  content: "";
}

.ri-home-heart-line:before {
  content: "";
}

.ri-home-line:before {
  content: "";
}

.ri-home-smile-2-fill:before {
  content: "";
}

.ri-home-smile-2-line:before {
  content: "";
}

.ri-home-smile-fill:before {
  content: "";
}

.ri-home-smile-line:before {
  content: "";
}

.ri-home-wifi-fill:before {
  content: "";
}

.ri-home-wifi-line:before {
  content: "";
}

.ri-honor-of-kings-fill:before {
  content: "";
}

.ri-honor-of-kings-line:before {
  content: "";
}

.ri-honour-fill:before {
  content: "";
}

.ri-honour-line:before {
  content: "";
}

.ri-hospital-fill:before {
  content: "";
}

.ri-hospital-line:before {
  content: "";
}

.ri-hotel-bed-fill:before {
  content: "";
}

.ri-hotel-bed-line:before {
  content: "";
}

.ri-hotel-fill:before {
  content: "";
}

.ri-hotel-line:before {
  content: "";
}

.ri-hotspot-fill:before {
  content: "";
}

.ri-hotspot-line:before {
  content: "";
}

.ri-hq-fill:before {
  content: "";
}

.ri-hq-line:before {
  content: "";
}

.ri-html5-fill:before {
  content: "";
}

.ri-html5-line:before {
  content: "";
}

.ri-ie-fill:before {
  content: "";
}

.ri-ie-line:before {
  content: "";
}

.ri-image-2-fill:before {
  content: "";
}

.ri-image-2-line:before {
  content: "";
}

.ri-image-add-fill:before {
  content: "";
}

.ri-image-add-line:before {
  content: "";
}

.ri-image-edit-fill:before {
  content: "";
}

.ri-image-edit-line:before {
  content: "";
}

.ri-image-fill:before {
  content: "";
}

.ri-image-line:before {
  content: "";
}

.ri-inbox-archive-fill:before {
  content: "";
}

.ri-inbox-archive-line:before {
  content: "";
}

.ri-inbox-fill:before {
  content: "";
}

.ri-inbox-line:before {
  content: "";
}

.ri-inbox-unarchive-fill:before {
  content: "";
}

.ri-inbox-unarchive-line:before {
  content: "";
}

.ri-increase-decrease-fill:before {
  content: "";
}

.ri-increase-decrease-line:before {
  content: "";
}

.ri-indent-decrease:before {
  content: "";
}

.ri-indent-increase:before {
  content: "";
}

.ri-indeterminate-circle-fill:before {
  content: "";
}

.ri-indeterminate-circle-line:before {
  content: "";
}

.ri-information-fill:before {
  content: "";
}

.ri-information-line:before {
  content: "";
}

.ri-infrared-thermometer-fill:before {
  content: "";
}

.ri-infrared-thermometer-line:before {
  content: "";
}

.ri-ink-bottle-fill:before {
  content: "";
}

.ri-ink-bottle-line:before {
  content: "";
}

.ri-input-cursor-move:before {
  content: "";
}

.ri-input-method-fill:before {
  content: "";
}

.ri-input-method-line:before {
  content: "";
}

.ri-insert-column-left:before {
  content: "";
}

.ri-insert-column-right:before {
  content: "";
}

.ri-insert-row-bottom:before {
  content: "";
}

.ri-insert-row-top:before {
  content: "";
}

.ri-instagram-fill:before {
  content: "";
}

.ri-instagram-line:before {
  content: "";
}

.ri-install-fill:before {
  content: "";
}

.ri-install-line:before {
  content: "";
}

.ri-invision-fill:before {
  content: "";
}

.ri-invision-line:before {
  content: "";
}

.ri-italic:before {
  content: "";
}

.ri-kakao-talk-fill:before {
  content: "";
}

.ri-kakao-talk-line:before {
  content: "";
}

.ri-key-2-fill:before {
  content: "";
}

.ri-key-2-line:before {
  content: "";
}

.ri-key-fill:before {
  content: "";
}

.ri-key-line:before {
  content: "";
}

.ri-keyboard-box-fill:before {
  content: "";
}

.ri-keyboard-box-line:before {
  content: "";
}

.ri-keyboard-fill:before {
  content: "";
}

.ri-keyboard-line:before {
  content: "";
}

.ri-keynote-fill:before {
  content: "";
}

.ri-keynote-line:before {
  content: "";
}

.ri-knife-blood-fill:before {
  content: "";
}

.ri-knife-blood-line:before {
  content: "";
}

.ri-knife-fill:before {
  content: "";
}

.ri-knife-line:before {
  content: "";
}

.ri-landscape-fill:before {
  content: "";
}

.ri-landscape-line:before {
  content: "";
}

.ri-layout-2-fill:before {
  content: "";
}

.ri-layout-2-line:before {
  content: "";
}

.ri-layout-3-fill:before {
  content: "";
}

.ri-layout-3-line:before {
  content: "";
}

.ri-layout-4-fill:before {
  content: "";
}

.ri-layout-4-line:before {
  content: "";
}

.ri-layout-5-fill:before {
  content: "";
}

.ri-layout-5-line:before {
  content: "";
}

.ri-layout-6-fill:before {
  content: "";
}

.ri-layout-6-line:before {
  content: "";
}

.ri-layout-bottom-2-fill:before {
  content: "";
}

.ri-layout-bottom-2-line:before {
  content: "";
}

.ri-layout-bottom-fill:before {
  content: "";
}

.ri-layout-bottom-line:before {
  content: "";
}

.ri-layout-column-fill:before {
  content: "";
}

.ri-layout-column-line:before {
  content: "";
}

.ri-layout-fill:before {
  content: "";
}

.ri-layout-grid-fill:before {
  content: "";
}

.ri-layout-grid-line:before {
  content: "";
}

.ri-layout-left-2-fill:before {
  content: "";
}

.ri-layout-left-2-line:before {
  content: "";
}

.ri-layout-left-fill:before {
  content: "";
}

.ri-layout-left-line:before {
  content: "";
}

.ri-layout-line:before {
  content: "";
}

.ri-layout-masonry-fill:before {
  content: "";
}

.ri-layout-masonry-line:before {
  content: "";
}

.ri-layout-right-2-fill:before {
  content: "";
}

.ri-layout-right-2-line:before {
  content: "";
}

.ri-layout-right-fill:before {
  content: "";
}

.ri-layout-right-line:before {
  content: "";
}

.ri-layout-row-fill:before {
  content: "";
}

.ri-layout-row-line:before {
  content: "";
}

.ri-layout-top-2-fill:before {
  content: "";
}

.ri-layout-top-2-line:before {
  content: "";
}

.ri-layout-top-fill:before {
  content: "";
}

.ri-layout-top-line:before {
  content: "";
}

.ri-leaf-fill:before {
  content: "";
}

.ri-leaf-line:before {
  content: "";
}

.ri-lifebuoy-fill:before {
  content: "";
}

.ri-lifebuoy-line:before {
  content: "";
}

.ri-lightbulb-fill:before {
  content: "";
}

.ri-lightbulb-flash-fill:before {
  content: "";
}

.ri-lightbulb-flash-line:before {
  content: "";
}

.ri-lightbulb-line:before {
  content: "";
}

.ri-line-chart-fill:before {
  content: "";
}

.ri-line-chart-line:before {
  content: "";
}

.ri-line-fill:before {
  content: "";
}

.ri-line-height:before {
  content: "";
}

.ri-line-line:before {
  content: "";
}

.ri-link-m:before {
  content: "";
}

.ri-link-unlink-m:before {
  content: "";
}

.ri-link-unlink:before {
  content: "";
}

.ri-link:before {
  content: "";
}

.ri-linkedin-box-fill:before {
  content: "";
}

.ri-linkedin-box-line:before {
  content: "";
}

.ri-linkedin-fill:before {
  content: "";
}

.ri-linkedin-line:before {
  content: "";
}

.ri-links-fill:before {
  content: "";
}

.ri-links-line:before {
  content: "";
}

.ri-list-check-2:before {
  content: "";
}

.ri-list-check:before {
  content: "";
}

.ri-list-ordered:before {
  content: "";
}

.ri-list-settings-fill:before {
  content: "";
}

.ri-list-settings-line:before {
  content: "";
}

.ri-list-unordered:before {
  content: "";
}

.ri-live-fill:before {
  content: "";
}

.ri-live-line:before {
  content: "";
}

.ri-loader-2-fill:before {
  content: "";
}

.ri-loader-2-line:before {
  content: "";
}

.ri-loader-3-fill:before {
  content: "";
}

.ri-loader-3-line:before {
  content: "";
}

.ri-loader-4-fill:before {
  content: "";
}

.ri-loader-4-line:before {
  content: "";
}

.ri-loader-5-fill:before {
  content: "";
}

.ri-loader-5-line:before {
  content: "";
}

.ri-loader-fill:before {
  content: "";
}

.ri-loader-line:before {
  content: "";
}

.ri-lock-2-fill:before {
  content: "";
}

.ri-lock-2-line:before {
  content: "";
}

.ri-lock-fill:before {
  content: "";
}

.ri-lock-line:before {
  content: "";
}

.ri-lock-password-fill:before {
  content: "";
}

.ri-lock-password-line:before {
  content: "";
}

.ri-lock-unlock-fill:before {
  content: "";
}

.ri-lock-unlock-line:before {
  content: "";
}

.ri-login-box-fill:before {
  content: "";
}

.ri-login-box-line:before {
  content: "";
}

.ri-login-circle-fill:before {
  content: "";
}

.ri-login-circle-line:before {
  content: "";
}

.ri-logout-box-fill:before {
  content: "";
}

.ri-logout-box-line:before {
  content: "";
}

.ri-logout-box-r-fill:before {
  content: "";
}

.ri-logout-box-r-line:before {
  content: "";
}

.ri-logout-circle-fill:before {
  content: "";
}

.ri-logout-circle-line:before {
  content: "";
}

.ri-logout-circle-r-fill:before {
  content: "";
}

.ri-logout-circle-r-line:before {
  content: "";
}

.ri-luggage-cart-fill:before {
  content: "";
}

.ri-luggage-cart-line:before {
  content: "";
}

.ri-luggage-deposit-fill:before {
  content: "";
}

.ri-luggage-deposit-line:before {
  content: "";
}

.ri-lungs-fill:before {
  content: "";
}

.ri-lungs-line:before {
  content: "";
}

.ri-mac-fill:before {
  content: "";
}

.ri-mac-line:before {
  content: "";
}

.ri-macbook-fill:before {
  content: "";
}

.ri-macbook-line:before {
  content: "";
}

.ri-magic-fill:before {
  content: "";
}

.ri-magic-line:before {
  content: "";
}

.ri-mail-add-fill:before {
  content: "";
}

.ri-mail-add-line:before {
  content: "";
}

.ri-mail-check-fill:before {
  content: "";
}

.ri-mail-check-line:before {
  content: "";
}

.ri-mail-close-fill:before {
  content: "";
}

.ri-mail-close-line:before {
  content: "";
}

.ri-mail-download-fill:before {
  content: "";
}

.ri-mail-download-line:before {
  content: "";
}

.ri-mail-fill:before {
  content: "";
}

.ri-mail-forbid-fill:before {
  content: "";
}

.ri-mail-forbid-line:before {
  content: "";
}

.ri-mail-line:before {
  content: "";
}

.ri-mail-lock-fill:before {
  content: "";
}

.ri-mail-lock-line:before {
  content: "";
}

.ri-mail-open-fill:before {
  content: "";
}

.ri-mail-open-line:before {
  content: "";
}

.ri-mail-send-fill:before {
  content: "";
}

.ri-mail-send-line:before {
  content: "";
}

.ri-mail-settings-fill:before {
  content: "";
}

.ri-mail-settings-line:before {
  content: "";
}

.ri-mail-star-fill:before {
  content: "";
}

.ri-mail-star-line:before {
  content: "";
}

.ri-mail-unread-fill:before {
  content: "";
}

.ri-mail-unread-line:before {
  content: "";
}

.ri-mail-volume-fill:before {
  content: "";
}

.ri-mail-volume-line:before {
  content: "";
}

.ri-map-2-fill:before {
  content: "";
}

.ri-map-2-line:before {
  content: "";
}

.ri-map-fill:before {
  content: "";
}

.ri-map-line:before {
  content: "";
}

.ri-map-pin-2-fill:before {
  content: "";
}

.ri-map-pin-2-line:before {
  content: "";
}

.ri-map-pin-3-fill:before {
  content: "";
}

.ri-map-pin-3-line:before {
  content: "";
}

.ri-map-pin-4-fill:before {
  content: "";
}

.ri-map-pin-4-line:before {
  content: "";
}

.ri-map-pin-5-fill:before {
  content: "";
}

.ri-map-pin-5-line:before {
  content: "";
}

.ri-map-pin-add-fill:before {
  content: "";
}

.ri-map-pin-add-line:before {
  content: "";
}

.ri-map-pin-fill:before {
  content: "";
}

.ri-map-pin-line:before {
  content: "";
}

.ri-map-pin-range-fill:before {
  content: "";
}

.ri-map-pin-range-line:before {
  content: "";
}

.ri-map-pin-time-fill:before {
  content: "";
}

.ri-map-pin-time-line:before {
  content: "";
}

.ri-map-pin-user-fill:before {
  content: "";
}

.ri-map-pin-user-line:before {
  content: "";
}

.ri-mark-pen-fill:before {
  content: "";
}

.ri-mark-pen-line:before {
  content: "";
}

.ri-markdown-fill:before {
  content: "";
}

.ri-markdown-line:before {
  content: "";
}

.ri-markup-fill:before {
  content: "";
}

.ri-markup-line:before {
  content: "";
}

.ri-mastercard-fill:before {
  content: "";
}

.ri-mastercard-line:before {
  content: "";
}

.ri-mastodon-fill:before {
  content: "";
}

.ri-mastodon-line:before {
  content: "";
}

.ri-medal-2-fill:before {
  content: "";
}

.ri-medal-2-line:before {
  content: "";
}

.ri-medal-fill:before {
  content: "";
}

.ri-medal-line:before {
  content: "";
}

.ri-medicine-bottle-fill:before {
  content: "";
}

.ri-medicine-bottle-line:before {
  content: "";
}

.ri-medium-fill:before {
  content: "";
}

.ri-medium-line:before {
  content: "";
}

.ri-men-fill:before {
  content: "";
}

.ri-men-line:before {
  content: "";
}

.ri-mental-health-fill:before {
  content: "";
}

.ri-mental-health-line:before {
  content: "";
}

.ri-menu-2-fill:before {
  content: "";
}

.ri-menu-2-line:before {
  content: "";
}

.ri-menu-3-fill:before {
  content: "";
}

.ri-menu-3-line:before {
  content: "";
}

.ri-menu-4-fill:before {
  content: "";
}

.ri-menu-4-line:before {
  content: "";
}

.ri-menu-5-fill:before {
  content: "";
}

.ri-menu-5-line:before {
  content: "";
}

.ri-menu-add-fill:before {
  content: "";
}

.ri-menu-add-line:before {
  content: "";
}

.ri-menu-fill:before {
  content: "";
}

.ri-menu-fold-fill:before {
  content: "";
}

.ri-menu-fold-line:before {
  content: "";
}

.ri-menu-line:before {
  content: "";
}

.ri-menu-unfold-fill:before {
  content: "";
}

.ri-menu-unfold-line:before {
  content: "";
}

.ri-merge-cells-horizontal:before {
  content: "";
}

.ri-merge-cells-vertical:before {
  content: "";
}

.ri-message-2-fill:before {
  content: "";
}

.ri-message-2-line:before {
  content: "";
}

.ri-message-3-fill:before {
  content: "";
}

.ri-message-3-line:before {
  content: "";
}

.ri-message-fill:before {
  content: "";
}

.ri-message-line:before {
  content: "";
}

.ri-messenger-fill:before {
  content: "";
}

.ri-messenger-line:before {
  content: "";
}

.ri-meteor-fill:before {
  content: "";
}

.ri-meteor-line:before {
  content: "";
}

.ri-mic-2-fill:before {
  content: "";
}

.ri-mic-2-line:before {
  content: "";
}

.ri-mic-fill:before {
  content: "";
}

.ri-mic-line:before {
  content: "";
}

.ri-mic-off-fill:before {
  content: "";
}

.ri-mic-off-line:before {
  content: "";
}

.ri-mickey-fill:before {
  content: "";
}

.ri-mickey-line:before {
  content: "";
}

.ri-microscope-fill:before {
  content: "";
}

.ri-microscope-line:before {
  content: "";
}

.ri-microsoft-fill:before {
  content: "";
}

.ri-microsoft-line:before {
  content: "";
}

.ri-mind-map:before {
  content: "";
}

.ri-mini-program-fill:before {
  content: "";
}

.ri-mini-program-line:before {
  content: "";
}

.ri-mist-fill:before {
  content: "";
}

.ri-mist-line:before {
  content: "";
}

.ri-money-cny-box-fill:before {
  content: "";
}

.ri-money-cny-box-line:before {
  content: "";
}

.ri-money-cny-circle-fill:before {
  content: "";
}

.ri-money-cny-circle-line:before {
  content: "";
}

.ri-money-dollar-box-fill:before {
  content: "";
}

.ri-money-dollar-box-line:before {
  content: "";
}

.ri-money-dollar-circle-fill:before {
  content: "";
}

.ri-money-dollar-circle-line:before {
  content: "";
}

.ri-money-euro-box-fill:before {
  content: "";
}

.ri-money-euro-box-line:before {
  content: "";
}

.ri-money-euro-circle-fill:before {
  content: "";
}

.ri-money-euro-circle-line:before {
  content: "";
}

.ri-money-pound-box-fill:before {
  content: "";
}

.ri-money-pound-box-line:before {
  content: "";
}

.ri-money-pound-circle-fill:before {
  content: "";
}

.ri-money-pound-circle-line:before {
  content: "";
}

.ri-moon-clear-fill:before {
  content: "";
}

.ri-moon-clear-line:before {
  content: "";
}

.ri-moon-cloudy-fill:before {
  content: "";
}

.ri-moon-cloudy-line:before {
  content: "";
}

.ri-moon-fill:before {
  content: "";
}

.ri-moon-foggy-fill:before {
  content: "";
}

.ri-moon-foggy-line:before {
  content: "";
}

.ri-moon-line:before {
  content: "";
}

.ri-more-2-fill:before {
  content: "";
}

.ri-more-2-line:before {
  content: "";
}

.ri-more-fill:before {
  content: "";
}

.ri-more-line:before {
  content: "";
}

.ri-motorbike-fill:before {
  content: "";
}

.ri-motorbike-line:before {
  content: "";
}

.ri-mouse-fill:before {
  content: "";
}

.ri-mouse-line:before {
  content: "";
}

.ri-movie-2-fill:before {
  content: "";
}

.ri-movie-2-line:before {
  content: "";
}

.ri-movie-fill:before {
  content: "";
}

.ri-movie-line:before {
  content: "";
}

.ri-music-2-fill:before {
  content: "";
}

.ri-music-2-line:before {
  content: "";
}

.ri-music-fill:before {
  content: "";
}

.ri-music-line:before {
  content: "";
}

.ri-mv-fill:before {
  content: "";
}

.ri-mv-line:before {
  content: "";
}

.ri-navigation-fill:before {
  content: "";
}

.ri-navigation-line:before {
  content: "";
}

.ri-netease-cloud-music-fill:before {
  content: "";
}

.ri-netease-cloud-music-line:before {
  content: "";
}

.ri-netflix-fill:before {
  content: "";
}

.ri-netflix-line:before {
  content: "";
}

.ri-newspaper-fill:before {
  content: "";
}

.ri-newspaper-line:before {
  content: "";
}

.ri-node-tree:before {
  content: "";
}

.ri-notification-2-fill:before {
  content: "";
}

.ri-notification-2-line:before {
  content: "";
}

.ri-notification-3-fill:before {
  content: "";
}

.ri-notification-3-line:before {
  content: "";
}

.ri-notification-4-fill:before {
  content: "";
}

.ri-notification-4-line:before {
  content: "";
}

.ri-notification-badge-fill:before {
  content: "";
}

.ri-notification-badge-line:before {
  content: "";
}

.ri-notification-fill:before {
  content: "";
}

.ri-notification-line:before {
  content: "";
}

.ri-notification-off-fill:before {
  content: "";
}

.ri-notification-off-line:before {
  content: "";
}

.ri-npmjs-fill:before {
  content: "";
}

.ri-npmjs-line:before {
  content: "";
}

.ri-number-0:before {
  content: "";
}

.ri-number-1:before {
  content: "";
}

.ri-number-2:before {
  content: "";
}

.ri-number-3:before {
  content: "";
}

.ri-number-4:before {
  content: "";
}

.ri-number-5:before {
  content: "";
}

.ri-number-6:before {
  content: "";
}

.ri-number-7:before {
  content: "";
}

.ri-number-8:before {
  content: "";
}

.ri-number-9:before {
  content: "";
}

.ri-numbers-fill:before {
  content: "";
}

.ri-numbers-line:before {
  content: "";
}

.ri-nurse-fill:before {
  content: "";
}

.ri-nurse-line:before {
  content: "";
}

.ri-oil-fill:before {
  content: "";
}

.ri-oil-line:before {
  content: "";
}

.ri-omega:before {
  content: "";
}

.ri-open-arm-fill:before {
  content: "";
}

.ri-open-arm-line:before {
  content: "";
}

.ri-open-source-fill:before {
  content: "";
}

.ri-open-source-line:before {
  content: "";
}

.ri-opera-fill:before {
  content: "";
}

.ri-opera-line:before {
  content: "";
}

.ri-order-play-fill:before {
  content: "";
}

.ri-order-play-line:before {
  content: "";
}

.ri-organization-chart:before {
  content: "";
}

.ri-outlet-2-fill:before {
  content: "";
}

.ri-outlet-2-line:before {
  content: "";
}

.ri-outlet-fill:before {
  content: "";
}

.ri-outlet-line:before {
  content: "";
}

.ri-page-separator:before {
  content: "";
}

.ri-pages-fill:before {
  content: "";
}

.ri-pages-line:before {
  content: "";
}

.ri-paint-brush-fill:before {
  content: "";
}

.ri-paint-brush-line:before {
  content: "";
}

.ri-paint-fill:before {
  content: "";
}

.ri-paint-line:before {
  content: "";
}

.ri-palette-fill:before {
  content: "";
}

.ri-palette-line:before {
  content: "";
}

.ri-pantone-fill:before {
  content: "";
}

.ri-pantone-line:before {
  content: "";
}

.ri-paragraph:before {
  content: "";
}

.ri-parent-fill:before {
  content: "";
}

.ri-parent-line:before {
  content: "";
}

.ri-parentheses-fill:before {
  content: "";
}

.ri-parentheses-line:before {
  content: "";
}

.ri-parking-box-fill:before {
  content: "";
}

.ri-parking-box-line:before {
  content: "";
}

.ri-parking-fill:before {
  content: "";
}

.ri-parking-line:before {
  content: "";
}

.ri-passport-fill:before {
  content: "";
}

.ri-passport-line:before {
  content: "";
}

.ri-patreon-fill:before {
  content: "";
}

.ri-patreon-line:before {
  content: "";
}

.ri-pause-circle-fill:before {
  content: "";
}

.ri-pause-circle-line:before {
  content: "";
}

.ri-pause-fill:before {
  content: "";
}

.ri-pause-line:before {
  content: "";
}

.ri-pause-mini-fill:before {
  content: "";
}

.ri-pause-mini-line:before {
  content: "";
}

.ri-paypal-fill:before {
  content: "";
}

.ri-paypal-line:before {
  content: "";
}

.ri-pen-nib-fill:before {
  content: "";
}

.ri-pen-nib-line:before {
  content: "";
}

.ri-pencil-fill:before {
  content: "";
}

.ri-pencil-line:before {
  content: "";
}

.ri-pencil-ruler-2-fill:before {
  content: "";
}

.ri-pencil-ruler-2-line:before {
  content: "";
}

.ri-pencil-ruler-fill:before {
  content: "";
}

.ri-pencil-ruler-line:before {
  content: "";
}

.ri-percent-fill:before {
  content: "";
}

.ri-percent-line:before {
  content: "";
}

.ri-phone-camera-fill:before {
  content: "";
}

.ri-phone-camera-line:before {
  content: "";
}

.ri-phone-fill:before {
  content: "";
}

.ri-phone-find-fill:before {
  content: "";
}

.ri-phone-find-line:before {
  content: "";
}

.ri-phone-line:before {
  content: "";
}

.ri-phone-lock-fill:before {
  content: "";
}

.ri-phone-lock-line:before {
  content: "";
}

.ri-picture-in-picture-2-fill:before {
  content: "";
}

.ri-picture-in-picture-2-line:before {
  content: "";
}

.ri-picture-in-picture-exit-fill:before {
  content: "";
}

.ri-picture-in-picture-exit-line:before {
  content: "";
}

.ri-picture-in-picture-fill:before {
  content: "";
}

.ri-picture-in-picture-line:before {
  content: "";
}

.ri-pie-chart-2-fill:before {
  content: "";
}

.ri-pie-chart-2-line:before {
  content: "";
}

.ri-pie-chart-box-fill:before {
  content: "";
}

.ri-pie-chart-box-line:before {
  content: "";
}

.ri-pie-chart-fill:before {
  content: "";
}

.ri-pie-chart-line:before {
  content: "";
}

.ri-pin-distance-fill:before {
  content: "";
}

.ri-pin-distance-line:before {
  content: "";
}

.ri-ping-pong-fill:before {
  content: "";
}

.ri-ping-pong-line:before {
  content: "";
}

.ri-pinterest-fill:before {
  content: "";
}

.ri-pinterest-line:before {
  content: "";
}

.ri-pinyin-input:before {
  content: "";
}

.ri-pixelfed-fill:before {
  content: "";
}

.ri-pixelfed-line:before {
  content: "";
}

.ri-plane-fill:before {
  content: "";
}

.ri-plane-line:before {
  content: "";
}

.ri-plant-fill:before {
  content: "";
}

.ri-plant-line:before {
  content: "";
}

.ri-play-circle-fill:before {
  content: "";
}

.ri-play-circle-line:before {
  content: "";
}

.ri-play-fill:before {
  content: "";
}

.ri-play-line:before {
  content: "";
}

.ri-play-list-2-fill:before {
  content: "";
}

.ri-play-list-2-line:before {
  content: "";
}

.ri-play-list-add-fill:before {
  content: "";
}

.ri-play-list-add-line:before {
  content: "";
}

.ri-play-list-fill:before {
  content: "";
}

.ri-play-list-line:before {
  content: "";
}

.ri-play-mini-fill:before {
  content: "";
}

.ri-play-mini-line:before {
  content: "";
}

.ri-playstation-fill:before {
  content: "";
}

.ri-playstation-line:before {
  content: "";
}

.ri-plug-2-fill:before {
  content: "";
}

.ri-plug-2-line:before {
  content: "";
}

.ri-plug-fill:before {
  content: "";
}

.ri-plug-line:before {
  content: "";
}

.ri-polaroid-2-fill:before {
  content: "";
}

.ri-polaroid-2-line:before {
  content: "";
}

.ri-polaroid-fill:before {
  content: "";
}

.ri-polaroid-line:before {
  content: "";
}

.ri-police-car-fill:before {
  content: "";
}

.ri-police-car-line:before {
  content: "";
}

.ri-price-tag-2-fill:before {
  content: "";
}

.ri-price-tag-2-line:before {
  content: "";
}

.ri-price-tag-3-fill:before {
  content: "";
}

.ri-price-tag-3-line:before {
  content: "";
}

.ri-price-tag-fill:before {
  content: "";
}

.ri-price-tag-line:before {
  content: "";
}

.ri-printer-cloud-fill:before {
  content: "";
}

.ri-printer-cloud-line:before {
  content: "";
}

.ri-printer-fill:before {
  content: "";
}

.ri-printer-line:before {
  content: "";
}

.ri-product-hunt-fill:before {
  content: "";
}

.ri-product-hunt-line:before {
  content: "";
}

.ri-profile-fill:before {
  content: "";
}

.ri-profile-line:before {
  content: "";
}

.ri-projector-2-fill:before {
  content: "";
}

.ri-projector-2-line:before {
  content: "";
}

.ri-projector-fill:before {
  content: "";
}

.ri-projector-line:before {
  content: "";
}

.ri-psychotherapy-fill:before {
  content: "";
}

.ri-psychotherapy-line:before {
  content: "";
}

.ri-pulse-fill:before {
  content: "";
}

.ri-pulse-line:before {
  content: "";
}

.ri-pushpin-2-fill:before {
  content: "";
}

.ri-pushpin-2-line:before {
  content: "";
}

.ri-pushpin-fill:before {
  content: "";
}

.ri-pushpin-line:before {
  content: "";
}

.ri-qq-fill:before {
  content: "";
}

.ri-qq-line:before {
  content: "";
}

.ri-qr-code-fill:before {
  content: "";
}

.ri-qr-code-line:before {
  content: "";
}

.ri-qr-scan-2-fill:before {
  content: "";
}

.ri-qr-scan-2-line:before {
  content: "";
}

.ri-qr-scan-fill:before {
  content: "";
}

.ri-qr-scan-line:before {
  content: "";
}

.ri-question-answer-fill:before {
  content: "";
}

.ri-question-answer-line:before {
  content: "";
}

.ri-question-fill:before {
  content: "";
}

.ri-question-line:before {
  content: "";
}

.ri-question-mark:before {
  content: "";
}

.ri-questionnaire-fill:before {
  content: "";
}

.ri-questionnaire-line:before {
  content: "";
}

.ri-quill-pen-fill:before {
  content: "";
}

.ri-quill-pen-line:before {
  content: "";
}

.ri-radar-fill:before {
  content: "";
}

.ri-radar-line:before {
  content: "";
}

.ri-radio-2-fill:before {
  content: "";
}

.ri-radio-2-line:before {
  content: "";
}

.ri-radio-button-fill:before {
  content: "";
}

.ri-radio-button-line:before {
  content: "";
}

.ri-radio-fill:before {
  content: "";
}

.ri-radio-line:before {
  content: "";
}

.ri-rainbow-fill:before {
  content: "";
}

.ri-rainbow-line:before {
  content: "";
}

.ri-rainy-fill:before {
  content: "";
}

.ri-rainy-line:before {
  content: "";
}

.ri-reactjs-fill:before {
  content: "";
}

.ri-reactjs-line:before {
  content: "";
}

.ri-record-circle-fill:before {
  content: "";
}

.ri-record-circle-line:before {
  content: "";
}

.ri-record-mail-fill:before {
  content: "";
}

.ri-record-mail-line:before {
  content: "";
}

.ri-recycle-fill:before {
  content: "";
}

.ri-recycle-line:before {
  content: "";
}

.ri-red-packet-fill:before {
  content: "";
}

.ri-red-packet-line:before {
  content: "";
}

.ri-reddit-fill:before {
  content: "";
}

.ri-reddit-line:before {
  content: "";
}

.ri-refresh-fill:before {
  content: "";
}

.ri-refresh-line:before {
  content: "";
}

.ri-refund-2-fill:before {
  content: "";
}

.ri-refund-2-line:before {
  content: "";
}

.ri-refund-fill:before {
  content: "";
}

.ri-refund-line:before {
  content: "";
}

.ri-registered-fill:before {
  content: "";
}

.ri-registered-line:before {
  content: "";
}

.ri-remixicon-fill:before {
  content: "";
}

.ri-remixicon-line:before {
  content: "";
}

.ri-remote-control-2-fill:before {
  content: "";
}

.ri-remote-control-2-line:before {
  content: "";
}

.ri-remote-control-fill:before {
  content: "";
}

.ri-remote-control-line:before {
  content: "";
}

.ri-repeat-2-fill:before {
  content: "";
}

.ri-repeat-2-line:before {
  content: "";
}

.ri-repeat-fill:before {
  content: "";
}

.ri-repeat-line:before {
  content: "";
}

.ri-repeat-one-fill:before {
  content: "";
}

.ri-repeat-one-line:before {
  content: "";
}

.ri-reply-all-fill:before {
  content: "";
}

.ri-reply-all-line:before {
  content: "";
}

.ri-reply-fill:before {
  content: "";
}

.ri-reply-line:before {
  content: "";
}

.ri-reserved-fill:before {
  content: "";
}

.ri-reserved-line:before {
  content: "";
}

.ri-rest-time-fill:before {
  content: "";
}

.ri-rest-time-line:before {
  content: "";
}

.ri-restart-fill:before {
  content: "";
}

.ri-restart-line:before {
  content: "";
}

.ri-restaurant-2-fill:before {
  content: "";
}

.ri-restaurant-2-line:before {
  content: "";
}

.ri-restaurant-fill:before {
  content: "";
}

.ri-restaurant-line:before {
  content: "";
}

.ri-rewind-fill:before {
  content: "";
}

.ri-rewind-line:before {
  content: "";
}

.ri-rewind-mini-fill:before {
  content: "";
}

.ri-rewind-mini-line:before {
  content: "";
}

.ri-rhythm-fill:before {
  content: "";
}

.ri-rhythm-line:before {
  content: "";
}

.ri-riding-fill:before {
  content: "";
}

.ri-riding-line:before {
  content: "";
}

.ri-road-map-fill:before {
  content: "";
}

.ri-road-map-line:before {
  content: "";
}

.ri-roadster-fill:before {
  content: "";
}

.ri-roadster-line:before {
  content: "";
}

.ri-robot-fill:before {
  content: "";
}

.ri-robot-line:before {
  content: "";
}

.ri-rocket-2-fill:before {
  content: "";
}

.ri-rocket-2-line:before {
  content: "";
}

.ri-rocket-fill:before {
  content: "";
}

.ri-rocket-line:before {
  content: "";
}

.ri-rotate-lock-fill:before {
  content: "";
}

.ri-rotate-lock-line:before {
  content: "";
}

.ri-rounded-corner:before {
  content: "";
}

.ri-route-fill:before {
  content: "";
}

.ri-route-line:before {
  content: "";
}

.ri-router-fill:before {
  content: "";
}

.ri-router-line:before {
  content: "";
}

.ri-rss-fill:before {
  content: "";
}

.ri-rss-line:before {
  content: "";
}

.ri-ruler-2-fill:before {
  content: "";
}

.ri-ruler-2-line:before {
  content: "";
}

.ri-ruler-fill:before {
  content: "";
}

.ri-ruler-line:before {
  content: "";
}

.ri-run-fill:before {
  content: "";
}

.ri-run-line:before {
  content: "";
}

.ri-safari-fill:before {
  content: "";
}

.ri-safari-line:before {
  content: "";
}

.ri-safe-2-fill:before {
  content: "";
}

.ri-safe-2-line:before {
  content: "";
}

.ri-safe-fill:before {
  content: "";
}

.ri-safe-line:before {
  content: "";
}

.ri-sailboat-fill:before {
  content: "";
}

.ri-sailboat-line:before {
  content: "";
}

.ri-save-2-fill:before {
  content: "";
}

.ri-save-2-line:before {
  content: "";
}

.ri-save-3-fill:before {
  content: "";
}

.ri-save-3-line:before {
  content: "";
}

.ri-save-fill:before {
  content: "";
}

.ri-save-line:before {
  content: "";
}

.ri-scales-2-fill:before {
  content: "";
}

.ri-scales-2-line:before {
  content: "";
}

.ri-scales-3-fill:before {
  content: "";
}

.ri-scales-3-line:before {
  content: "";
}

.ri-scales-fill:before {
  content: "";
}

.ri-scales-line:before {
  content: "";
}

.ri-scan-2-fill:before {
  content: "";
}

.ri-scan-2-line:before {
  content: "";
}

.ri-scan-fill:before {
  content: "";
}

.ri-scan-line:before {
  content: "";
}

.ri-scissors-2-fill:before {
  content: "";
}

.ri-scissors-2-line:before {
  content: "";
}

.ri-scissors-cut-fill:before {
  content: "";
}

.ri-scissors-cut-line:before {
  content: "";
}

.ri-scissors-fill:before {
  content: "";
}

.ri-scissors-line:before {
  content: "";
}

.ri-screenshot-2-fill:before {
  content: "";
}

.ri-screenshot-2-line:before {
  content: "";
}

.ri-screenshot-fill:before {
  content: "";
}

.ri-screenshot-line:before {
  content: "";
}

.ri-sd-card-fill:before {
  content: "";
}

.ri-sd-card-line:before {
  content: "";
}

.ri-sd-card-mini-fill:before {
  content: "";
}

.ri-sd-card-mini-line:before {
  content: "";
}

.ri-search-2-fill:before {
  content: "";
}

.ri-search-2-line:before {
  content: "";
}

.ri-search-eye-fill:before {
  content: "";
}

.ri-search-eye-line:before {
  content: "";
}

.ri-search-fill:before {
  content: "";
}

.ri-search-line:before {
  content: "";
}

.ri-secure-payment-fill:before {
  content: "";
}

.ri-secure-payment-line:before {
  content: "";
}

.ri-seedling-fill:before {
  content: "";
}

.ri-seedling-line:before {
  content: "";
}

.ri-send-backward:before {
  content: "";
}

.ri-send-plane-2-fill:before {
  content: "";
}

.ri-send-plane-2-line:before {
  content: "";
}

.ri-send-plane-fill:before {
  content: "";
}

.ri-send-plane-line:before {
  content: "";
}

.ri-send-to-back:before {
  content: "";
}

.ri-sensor-fill:before {
  content: "";
}

.ri-sensor-line:before {
  content: "";
}

.ri-separator:before {
  content: "";
}

.ri-server-fill:before {
  content: "";
}

.ri-server-line:before {
  content: "";
}

.ri-service-fill:before {
  content: "";
}

.ri-service-line:before {
  content: "";
}

.ri-settings-2-fill:before {
  content: "";
}

.ri-settings-2-line:before {
  content: "";
}

.ri-settings-3-fill:before {
  content: "";
}

.ri-settings-3-line:before {
  content: "";
}

.ri-settings-4-fill:before {
  content: "";
}

.ri-settings-4-line:before {
  content: "";
}

.ri-settings-5-fill:before {
  content: "";
}

.ri-settings-5-line:before {
  content: "";
}

.ri-settings-6-fill:before {
  content: "";
}

.ri-settings-6-line:before {
  content: "";
}

.ri-settings-fill:before {
  content: "";
}

.ri-settings-line:before {
  content: "";
}

.ri-shape-2-fill:before {
  content: "";
}

.ri-shape-2-line:before {
  content: "";
}

.ri-shape-fill:before {
  content: "";
}

.ri-shape-line:before {
  content: "";
}

.ri-share-box-fill:before {
  content: "";
}

.ri-share-box-line:before {
  content: "";
}

.ri-share-circle-fill:before {
  content: "";
}

.ri-share-circle-line:before {
  content: "";
}

.ri-share-fill:before {
  content: "";
}

.ri-share-forward-2-fill:before {
  content: "";
}

.ri-share-forward-2-line:before {
  content: "";
}

.ri-share-forward-box-fill:before {
  content: "";
}

.ri-share-forward-box-line:before {
  content: "";
}

.ri-share-forward-fill:before {
  content: "";
}

.ri-share-forward-line:before {
  content: "";
}

.ri-share-line:before {
  content: "";
}

.ri-shield-check-fill:before {
  content: "";
}

.ri-shield-check-line:before {
  content: "";
}

.ri-shield-cross-fill:before {
  content: "";
}

.ri-shield-cross-line:before {
  content: "";
}

.ri-shield-fill:before {
  content: "";
}

.ri-shield-flash-fill:before {
  content: "";
}

.ri-shield-flash-line:before {
  content: "";
}

.ri-shield-keyhole-fill:before {
  content: "";
}

.ri-shield-keyhole-line:before {
  content: "";
}

.ri-shield-line:before {
  content: "";
}

.ri-shield-star-fill:before {
  content: "";
}

.ri-shield-star-line:before {
  content: "";
}

.ri-shield-user-fill:before {
  content: "";
}

.ri-shield-user-line:before {
  content: "";
}

.ri-ship-2-fill:before {
  content: "";
}

.ri-ship-2-line:before {
  content: "";
}

.ri-ship-fill:before {
  content: "";
}

.ri-ship-line:before {
  content: "";
}

.ri-shirt-fill:before {
  content: "";
}

.ri-shirt-line:before {
  content: "";
}

.ri-shopping-bag-2-fill:before {
  content: "";
}

.ri-shopping-bag-2-line:before {
  content: "";
}

.ri-shopping-bag-3-fill:before {
  content: "";
}

.ri-shopping-bag-3-line:before {
  content: "";
}

.ri-shopping-bag-fill:before {
  content: "";
}

.ri-shopping-bag-line:before {
  content: "";
}

.ri-shopping-basket-2-fill:before {
  content: "";
}

.ri-shopping-basket-2-line:before {
  content: "";
}

.ri-shopping-basket-fill:before {
  content: "";
}

.ri-shopping-basket-line:before {
  content: "";
}

.ri-shopping-cart-2-fill:before {
  content: "";
}

.ri-shopping-cart-2-line:before {
  content: "";
}

.ri-shopping-cart-fill:before {
  content: "";
}

.ri-shopping-cart-line:before {
  content: "";
}

.ri-showers-fill:before {
  content: "";
}

.ri-showers-line:before {
  content: "";
}

.ri-shuffle-fill:before {
  content: "";
}

.ri-shuffle-line:before {
  content: "";
}

.ri-shut-down-fill:before {
  content: "";
}

.ri-shut-down-line:before {
  content: "";
}

.ri-side-bar-fill:before {
  content: "";
}

.ri-side-bar-line:before {
  content: "";
}

.ri-signal-tower-fill:before {
  content: "";
}

.ri-signal-tower-line:before {
  content: "";
}

.ri-signal-wifi-1-fill:before {
  content: "";
}

.ri-signal-wifi-1-line:before {
  content: "";
}

.ri-signal-wifi-2-fill:before {
  content: "";
}

.ri-signal-wifi-2-line:before {
  content: "";
}

.ri-signal-wifi-3-fill:before {
  content: "";
}

.ri-signal-wifi-3-line:before {
  content: "";
}

.ri-signal-wifi-error-fill:before {
  content: "";
}

.ri-signal-wifi-error-line:before {
  content: "";
}

.ri-signal-wifi-fill:before {
  content: "";
}

.ri-signal-wifi-line:before {
  content: "";
}

.ri-signal-wifi-off-fill:before {
  content: "";
}

.ri-signal-wifi-off-line:before {
  content: "";
}

.ri-sim-card-2-fill:before {
  content: "";
}

.ri-sim-card-2-line:before {
  content: "";
}

.ri-sim-card-fill:before {
  content: "";
}

.ri-sim-card-line:before {
  content: "";
}

.ri-single-quotes-l:before {
  content: "";
}

.ri-single-quotes-r:before {
  content: "";
}

.ri-sip-fill:before {
  content: "";
}

.ri-sip-line:before {
  content: "";
}

.ri-skip-back-fill:before {
  content: "";
}

.ri-skip-back-line:before {
  content: "";
}

.ri-skip-back-mini-fill:before {
  content: "";
}

.ri-skip-back-mini-line:before {
  content: "";
}

.ri-skip-forward-fill:before {
  content: "";
}

.ri-skip-forward-line:before {
  content: "";
}

.ri-skip-forward-mini-fill:before {
  content: "";
}

.ri-skip-forward-mini-line:before {
  content: "";
}

.ri-skull-2-fill:before {
  content: "";
}

.ri-skull-2-line:before {
  content: "";
}

.ri-skull-fill:before {
  content: "";
}

.ri-skull-line:before {
  content: "";
}

.ri-skype-fill:before {
  content: "";
}

.ri-skype-line:before {
  content: "";
}

.ri-slack-fill:before {
  content: "";
}

.ri-slack-line:before {
  content: "";
}

.ri-slice-fill:before {
  content: "";
}

.ri-slice-line:before {
  content: "";
}

.ri-slideshow-2-fill:before {
  content: "";
}

.ri-slideshow-2-line:before {
  content: "";
}

.ri-slideshow-3-fill:before {
  content: "";
}

.ri-slideshow-3-line:before {
  content: "";
}

.ri-slideshow-4-fill:before {
  content: "";
}

.ri-slideshow-4-line:before {
  content: "";
}

.ri-slideshow-fill:before {
  content: "";
}

.ri-slideshow-line:before {
  content: "";
}

.ri-smartphone-fill:before {
  content: "";
}

.ri-smartphone-line:before {
  content: "";
}

.ri-snapchat-fill:before {
  content: "";
}

.ri-snapchat-line:before {
  content: "";
}

.ri-snowy-fill:before {
  content: "";
}

.ri-snowy-line:before {
  content: "";
}

.ri-sort-asc:before {
  content: "";
}

.ri-sort-desc:before {
  content: "";
}

.ri-sound-module-fill:before {
  content: "";
}

.ri-sound-module-line:before {
  content: "";
}

.ri-soundcloud-fill:before {
  content: "";
}

.ri-soundcloud-line:before {
  content: "";
}

.ri-space-ship-fill:before {
  content: "";
}

.ri-space-ship-line:before {
  content: "";
}

.ri-space:before {
  content: "";
}

.ri-spam-2-fill:before {
  content: "";
}

.ri-spam-2-line:before {
  content: "";
}

.ri-spam-3-fill:before {
  content: "";
}

.ri-spam-3-line:before {
  content: "";
}

.ri-spam-fill:before {
  content: "";
}

.ri-spam-line:before {
  content: "";
}

.ri-speaker-2-fill:before {
  content: "";
}

.ri-speaker-2-line:before {
  content: "";
}

.ri-speaker-3-fill:before {
  content: "";
}

.ri-speaker-3-line:before {
  content: "";
}

.ri-speaker-fill:before {
  content: "";
}

.ri-speaker-line:before {
  content: "";
}

.ri-spectrum-fill:before {
  content: "";
}

.ri-spectrum-line:before {
  content: "";
}

.ri-speed-fill:before {
  content: "";
}

.ri-speed-line:before {
  content: "";
}

.ri-speed-mini-fill:before {
  content: "";
}

.ri-speed-mini-line:before {
  content: "";
}

.ri-split-cells-horizontal:before {
  content: "";
}

.ri-split-cells-vertical:before {
  content: "";
}

.ri-spotify-fill:before {
  content: "";
}

.ri-spotify-line:before {
  content: "";
}

.ri-spy-fill:before {
  content: "";
}

.ri-spy-line:before {
  content: "";
}

.ri-stack-fill:before {
  content: "";
}

.ri-stack-line:before {
  content: "";
}

.ri-stack-overflow-fill:before {
  content: "";
}

.ri-stack-overflow-line:before {
  content: "";
}

.ri-stackshare-fill:before {
  content: "";
}

.ri-stackshare-line:before {
  content: "";
}

.ri-star-fill:before {
  content: "";
}

.ri-star-half-fill:before {
  content: "";
}

.ri-star-half-line:before {
  content: "";
}

.ri-star-half-s-fill:before {
  content: "";
}

.ri-star-half-s-line:before {
  content: "";
}

.ri-star-line:before {
  content: "";
}

.ri-star-s-fill:before {
  content: "";
}

.ri-star-s-line:before {
  content: "";
}

.ri-star-smile-fill:before {
  content: "";
}

.ri-star-smile-line:before {
  content: "";
}

.ri-steam-fill:before {
  content: "";
}

.ri-steam-line:before {
  content: "";
}

.ri-steering-2-fill:before {
  content: "";
}

.ri-steering-2-line:before {
  content: "";
}

.ri-steering-fill:before {
  content: "";
}

.ri-steering-line:before {
  content: "";
}

.ri-stethoscope-fill:before {
  content: "";
}

.ri-stethoscope-line:before {
  content: "";
}

.ri-sticky-note-2-fill:before {
  content: "";
}

.ri-sticky-note-2-line:before {
  content: "";
}

.ri-sticky-note-fill:before {
  content: "";
}

.ri-sticky-note-line:before {
  content: "";
}

.ri-stock-fill:before {
  content: "";
}

.ri-stock-line:before {
  content: "";
}

.ri-stop-circle-fill:before {
  content: "";
}

.ri-stop-circle-line:before {
  content: "";
}

.ri-stop-fill:before {
  content: "";
}

.ri-stop-line:before {
  content: "";
}

.ri-stop-mini-fill:before {
  content: "";
}

.ri-stop-mini-line:before {
  content: "";
}

.ri-store-2-fill:before {
  content: "";
}

.ri-store-2-line:before {
  content: "";
}

.ri-store-3-fill:before {
  content: "";
}

.ri-store-3-line:before {
  content: "";
}

.ri-store-fill:before {
  content: "";
}

.ri-store-line:before {
  content: "";
}

.ri-strikethrough-2:before {
  content: "";
}

.ri-strikethrough:before {
  content: "";
}

.ri-subscript-2:before {
  content: "";
}

.ri-subscript:before {
  content: "";
}

.ri-subtract-fill:before {
  content: "";
}

.ri-subtract-line:before {
  content: "";
}

.ri-subway-fill:before {
  content: "";
}

.ri-subway-line:before {
  content: "";
}

.ri-subway-wifi-fill:before {
  content: "";
}

.ri-subway-wifi-line:before {
  content: "";
}

.ri-suitcase-2-fill:before {
  content: "";
}

.ri-suitcase-2-line:before {
  content: "";
}

.ri-suitcase-3-fill:before {
  content: "";
}

.ri-suitcase-3-line:before {
  content: "";
}

.ri-suitcase-fill:before {
  content: "";
}

.ri-suitcase-line:before {
  content: "";
}

.ri-sun-cloudy-fill:before {
  content: "";
}

.ri-sun-cloudy-line:before {
  content: "";
}

.ri-sun-fill:before {
  content: "";
}

.ri-sun-foggy-fill:before {
  content: "";
}

.ri-sun-foggy-line:before {
  content: "";
}

.ri-sun-line:before {
  content: "";
}

.ri-superscript-2:before {
  content: "";
}

.ri-superscript:before {
  content: "";
}

.ri-surgical-mask-fill:before {
  content: "";
}

.ri-surgical-mask-line:before {
  content: "";
}

.ri-surround-sound-fill:before {
  content: "";
}

.ri-surround-sound-line:before {
  content: "";
}

.ri-survey-fill:before {
  content: "";
}

.ri-survey-line:before {
  content: "";
}

.ri-swap-box-fill:before {
  content: "";
}

.ri-swap-box-line:before {
  content: "";
}

.ri-swap-fill:before {
  content: "";
}

.ri-swap-line:before {
  content: "";
}

.ri-switch-fill:before {
  content: "";
}

.ri-switch-line:before {
  content: "";
}

.ri-sword-fill:before {
  content: "";
}

.ri-sword-line:before {
  content: "";
}

.ri-syringe-fill:before {
  content: "";
}

.ri-syringe-line:before {
  content: "";
}

.ri-t-box-fill:before {
  content: "";
}

.ri-t-box-line:before {
  content: "";
}

.ri-t-shirt-2-fill:before {
  content: "";
}

.ri-t-shirt-2-line:before {
  content: "";
}

.ri-t-shirt-air-fill:before {
  content: "";
}

.ri-t-shirt-air-line:before {
  content: "";
}

.ri-t-shirt-fill:before {
  content: "";
}

.ri-t-shirt-line:before {
  content: "";
}

.ri-table-2:before {
  content: "";
}

.ri-table-alt-fill:before {
  content: "";
}

.ri-table-alt-line:before {
  content: "";
}

.ri-table-fill:before {
  content: "";
}

.ri-table-line:before {
  content: "";
}

.ri-tablet-fill:before {
  content: "";
}

.ri-tablet-line:before {
  content: "";
}

.ri-takeaway-fill:before {
  content: "";
}

.ri-takeaway-line:before {
  content: "";
}

.ri-taobao-fill:before {
  content: "";
}

.ri-taobao-line:before {
  content: "";
}

.ri-tape-fill:before {
  content: "";
}

.ri-tape-line:before {
  content: "";
}

.ri-task-fill:before {
  content: "";
}

.ri-task-line:before {
  content: "";
}

.ri-taxi-fill:before {
  content: "";
}

.ri-taxi-line:before {
  content: "";
}

.ri-taxi-wifi-fill:before {
  content: "";
}

.ri-taxi-wifi-line:before {
  content: "";
}

.ri-team-fill:before {
  content: "";
}

.ri-team-line:before {
  content: "";
}

.ri-telegram-fill:before {
  content: "";
}

.ri-telegram-line:before {
  content: "";
}

.ri-temp-cold-fill:before {
  content: "";
}

.ri-temp-cold-line:before {
  content: "";
}

.ri-temp-hot-fill:before {
  content: "";
}

.ri-temp-hot-line:before {
  content: "";
}

.ri-terminal-box-fill:before {
  content: "";
}

.ri-terminal-box-line:before {
  content: "";
}

.ri-terminal-fill:before {
  content: "";
}

.ri-terminal-line:before {
  content: "";
}

.ri-terminal-window-fill:before {
  content: "";
}

.ri-terminal-window-line:before {
  content: "";
}

.ri-test-tube-fill:before {
  content: "";
}

.ri-test-tube-line:before {
  content: "";
}

.ri-text-direction-l:before {
  content: "";
}

.ri-text-direction-r:before {
  content: "";
}

.ri-text-spacing:before {
  content: "";
}

.ri-text-wrap:before {
  content: "";
}

.ri-text:before {
  content: "";
}

.ri-thermometer-fill:before {
  content: "";
}

.ri-thermometer-line:before {
  content: "";
}

.ri-thumb-down-fill:before {
  content: "";
}

.ri-thumb-down-line:before {
  content: "";
}

.ri-thumb-up-fill:before {
  content: "";
}

.ri-thumb-up-line:before {
  content: "";
}

.ri-thunderstorms-fill:before {
  content: "";
}

.ri-thunderstorms-line:before {
  content: "";
}

.ri-ticket-2-fill:before {
  content: "";
}

.ri-ticket-2-line:before {
  content: "";
}

.ri-ticket-fill:before {
  content: "";
}

.ri-ticket-line:before {
  content: "";
}

.ri-time-fill:before {
  content: "";
}

.ri-time-line:before {
  content: "";
}

.ri-timer-2-fill:before {
  content: "";
}

.ri-timer-2-line:before {
  content: "";
}

.ri-timer-fill:before {
  content: "";
}

.ri-timer-flash-fill:before {
  content: "";
}

.ri-timer-flash-line:before {
  content: "";
}

.ri-timer-line:before {
  content: "";
}

.ri-todo-fill:before {
  content: "";
}

.ri-todo-line:before {
  content: "";
}

.ri-toggle-fill:before {
  content: "";
}

.ri-toggle-line:before {
  content: "";
}

.ri-tools-fill:before {
  content: "";
}

.ri-tools-line:before {
  content: "";
}

.ri-tornado-fill:before {
  content: "";
}

.ri-tornado-line:before {
  content: "";
}

.ri-trademark-fill:before {
  content: "";
}

.ri-trademark-line:before {
  content: "";
}

.ri-traffic-light-fill:before {
  content: "";
}

.ri-traffic-light-line:before {
  content: "";
}

.ri-train-fill:before {
  content: "";
}

.ri-train-line:before {
  content: "";
}

.ri-train-wifi-fill:before {
  content: "";
}

.ri-train-wifi-line:before {
  content: "";
}

.ri-translate-2:before {
  content: "";
}

.ri-translate:before {
  content: "";
}

.ri-travesti-fill:before {
  content: "";
}

.ri-travesti-line:before {
  content: "";
}

.ri-treasure-map-fill:before {
  content: "";
}

.ri-treasure-map-line:before {
  content: "";
}

.ri-trello-fill:before {
  content: "";
}

.ri-trello-line:before {
  content: "";
}

.ri-trophy-fill:before {
  content: "";
}

.ri-trophy-line:before {
  content: "";
}

.ri-truck-fill:before {
  content: "";
}

.ri-truck-line:before {
  content: "";
}

.ri-tumblr-fill:before {
  content: "";
}

.ri-tumblr-line:before {
  content: "";
}

.ri-tv-2-fill:before {
  content: "";
}

.ri-tv-2-line:before {
  content: "";
}

.ri-tv-fill:before {
  content: "";
}

.ri-tv-line:before {
  content: "";
}

.ri-twitch-fill:before {
  content: "";
}

.ri-twitch-line:before {
  content: "";
}

.ri-twitter-fill:before {
  content: "";
}

.ri-twitter-line:before {
  content: "";
}

.ri-typhoon-fill:before {
  content: "";
}

.ri-typhoon-line:before {
  content: "";
}

.ri-u-disk-fill:before {
  content: "";
}

.ri-u-disk-line:before {
  content: "";
}

.ri-ubuntu-fill:before {
  content: "";
}

.ri-ubuntu-line:before {
  content: "";
}

.ri-umbrella-fill:before {
  content: "";
}

.ri-umbrella-line:before {
  content: "";
}

.ri-underline:before {
  content: "";
}

.ri-uninstall-fill:before {
  content: "";
}

.ri-uninstall-line:before {
  content: "";
}

.ri-unsplash-fill:before {
  content: "";
}

.ri-unsplash-line:before {
  content: "";
}

.ri-upload-2-fill:before {
  content: "";
}

.ri-upload-2-line:before {
  content: "";
}

.ri-upload-cloud-2-fill:before {
  content: "";
}

.ri-upload-cloud-2-line:before {
  content: "";
}

.ri-upload-cloud-fill:before {
  content: "";
}

.ri-upload-cloud-line:before {
  content: "";
}

.ri-upload-fill:before {
  content: "";
}

.ri-upload-line:before {
  content: "";
}

.ri-usb-fill:before {
  content: "";
}

.ri-usb-line:before {
  content: "";
}

.ri-user-2-fill:before {
  content: "";
}

.ri-user-2-line:before {
  content: "";
}

.ri-user-3-fill:before {
  content: "";
}

.ri-user-3-line:before {
  content: "";
}

.ri-user-4-fill:before {
  content: "";
}

.ri-user-4-line:before {
  content: "";
}

.ri-user-5-fill:before {
  content: "";
}

.ri-user-5-line:before {
  content: "";
}

.ri-user-6-fill:before {
  content: "";
}

.ri-user-6-line:before {
  content: "";
}

.ri-user-add-fill:before {
  content: "";
}

.ri-user-add-line:before {
  content: "";
}

.ri-user-fill:before {
  content: "";
}

.ri-user-follow-fill:before {
  content: "";
}

.ri-user-follow-line:before {
  content: "";
}

.ri-user-heart-fill:before {
  content: "";
}

.ri-user-heart-line:before {
  content: "";
}

.ri-user-line:before {
  content: "";
}

.ri-user-location-fill:before {
  content: "";
}

.ri-user-location-line:before {
  content: "";
}

.ri-user-received-2-fill:before {
  content: "";
}

.ri-user-received-2-line:before {
  content: "";
}

.ri-user-received-fill:before {
  content: "";
}

.ri-user-received-line:before {
  content: "";
}

.ri-user-search-fill:before {
  content: "";
}

.ri-user-search-line:before {
  content: "";
}

.ri-user-settings-fill:before {
  content: "";
}

.ri-user-settings-line:before {
  content: "";
}

.ri-user-shared-2-fill:before {
  content: "";
}

.ri-user-shared-2-line:before {
  content: "";
}

.ri-user-shared-fill:before {
  content: "";
}

.ri-user-shared-line:before {
  content: "";
}

.ri-user-smile-fill:before {
  content: "";
}

.ri-user-smile-line:before {
  content: "";
}

.ri-user-star-fill:before {
  content: "";
}

.ri-user-star-line:before {
  content: "";
}

.ri-user-unfollow-fill:before {
  content: "";
}

.ri-user-unfollow-line:before {
  content: "";
}

.ri-user-voice-fill:before {
  content: "";
}

.ri-user-voice-line:before {
  content: "";
}

.ri-video-add-fill:before {
  content: "";
}

.ri-video-add-line:before {
  content: "";
}

.ri-video-chat-fill:before {
  content: "";
}

.ri-video-chat-line:before {
  content: "";
}

.ri-video-download-fill:before {
  content: "";
}

.ri-video-download-line:before {
  content: "";
}

.ri-video-fill:before {
  content: "";
}

.ri-video-line:before {
  content: "";
}

.ri-video-upload-fill:before {
  content: "";
}

.ri-video-upload-line:before {
  content: "";
}

.ri-vidicon-2-fill:before {
  content: "";
}

.ri-vidicon-2-line:before {
  content: "";
}

.ri-vidicon-fill:before {
  content: "";
}

.ri-vidicon-line:before {
  content: "";
}

.ri-vimeo-fill:before {
  content: "";
}

.ri-vimeo-line:before {
  content: "";
}

.ri-vip-crown-2-fill:before {
  content: "";
}

.ri-vip-crown-2-line:before {
  content: "";
}

.ri-vip-crown-fill:before {
  content: "";
}

.ri-vip-crown-line:before {
  content: "";
}

.ri-vip-diamond-fill:before {
  content: "";
}

.ri-vip-diamond-line:before {
  content: "";
}

.ri-vip-fill:before {
  content: "";
}

.ri-vip-line:before {
  content: "";
}

.ri-virus-fill:before {
  content: "";
}

.ri-virus-line:before {
  content: "";
}

.ri-visa-fill:before {
  content: "";
}

.ri-visa-line:before {
  content: "";
}

.ri-voice-recognition-fill:before {
  content: "";
}

.ri-voice-recognition-line:before {
  content: "";
}

.ri-voiceprint-fill:before {
  content: "";
}

.ri-voiceprint-line:before {
  content: "";
}

.ri-volume-down-fill:before {
  content: "";
}

.ri-volume-down-line:before {
  content: "";
}

.ri-volume-mute-fill:before {
  content: "";
}

.ri-volume-mute-line:before {
  content: "";
}

.ri-volume-off-vibrate-fill:before {
  content: "";
}

.ri-volume-off-vibrate-line:before {
  content: "";
}

.ri-volume-up-fill:before {
  content: "";
}

.ri-volume-up-line:before {
  content: "";
}

.ri-volume-vibrate-fill:before {
  content: "";
}

.ri-volume-vibrate-line:before {
  content: "";
}

.ri-vuejs-fill:before {
  content: "";
}

.ri-vuejs-line:before {
  content: "";
}

.ri-walk-fill:before {
  content: "";
}

.ri-walk-line:before {
  content: "";
}

.ri-wallet-2-fill:before {
  content: "";
}

.ri-wallet-2-line:before {
  content: "";
}

.ri-wallet-3-fill:before {
  content: "";
}

.ri-wallet-3-line:before {
  content: "";
}

.ri-wallet-fill:before {
  content: "";
}

.ri-wallet-line:before {
  content: "";
}

.ri-water-flash-fill:before {
  content: "";
}

.ri-water-flash-line:before {
  content: "";
}

.ri-webcam-fill:before {
  content: "";
}

.ri-webcam-line:before {
  content: "";
}

.ri-wechat-2-fill:before {
  content: "";
}

.ri-wechat-2-line:before {
  content: "";
}

.ri-wechat-fill:before {
  content: "";
}

.ri-wechat-line:before {
  content: "";
}

.ri-wechat-pay-fill:before {
  content: "";
}

.ri-wechat-pay-line:before {
  content: "";
}

.ri-weibo-fill:before {
  content: "";
}

.ri-weibo-line:before {
  content: "";
}

.ri-whatsapp-fill:before {
  content: "";
}

.ri-whatsapp-line:before {
  content: "";
}

.ri-wheelchair-fill:before {
  content: "";
}

.ri-wheelchair-line:before {
  content: "";
}

.ri-wifi-fill:before {
  content: "";
}

.ri-wifi-line:before {
  content: "";
}

.ri-wifi-off-fill:before {
  content: "";
}

.ri-wifi-off-line:before {
  content: "";
}

.ri-window-2-fill:before {
  content: "";
}

.ri-window-2-line:before {
  content: "";
}

.ri-window-fill:before {
  content: "";
}

.ri-window-line:before {
  content: "";
}

.ri-windows-fill:before {
  content: "";
}

.ri-windows-line:before {
  content: "";
}

.ri-windy-fill:before {
  content: "";
}

.ri-windy-line:before {
  content: "";
}

.ri-wireless-charging-fill:before {
  content: "";
}

.ri-wireless-charging-line:before {
  content: "";
}

.ri-women-fill:before {
  content: "";
}

.ri-women-line:before {
  content: "";
}

.ri-wubi-input:before {
  content: "";
}

.ri-xbox-fill:before {
  content: "";
}

.ri-xbox-line:before {
  content: "";
}

.ri-xing-fill:before {
  content: "";
}

.ri-xing-line:before {
  content: "";
}

.ri-youtube-fill:before {
  content: "";
}

.ri-youtube-line:before {
  content: "";
}

.ri-zcool-fill:before {
  content: "";
}

.ri-zcool-line:before {
  content: "";
}

.ri-zhihu-fill:before {
  content: "";
}

.ri-zhihu-line:before {
  content: "";
}

.ri-zoom-in-fill:before {
  content: "";
}

.ri-zoom-in-line:before {
  content: "";
}

.ri-zoom-out-fill:before {
  content: "";
}

.ri-zoom-out-line:before {
  content: "";
}

.ri-zzz-fill:before {
  content: "";
}

.ri-zzz-line:before {
  content: "";
}

/*
Template Name: Velzon - Admin & Dashboard Template
Author: Themesbrand
Version: 3.0.0
Website: https://Themesbrand.com/
Contact: Themesbrand@gmail.com
File: Custom Bootstrap Css File
*/
.rounded-custom-1 {
  border-radius: 12px;
}

/*********************variables-custom dark Mode***************************/
/*!
 * Bootstrap  v5.3.3 (https://getbootstrap.com/)
 * Copyright 2011-2024 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --vz-blue: #6691e7;
  --vz-indigo: #405189;
  --vz-purple: #865ce2;
  --vz-pink: #f672a7;
  --vz-red: #ed5e5e;
  --vz-orange: #f1963b;
  --vz-yellow: #e8bc52;
  --vz-green: #13c56b;
  --vz-teal: #02a8b5;
  --vz-cyan: #50c3e6;
  --vz-white: #fff;
  --vz-gray: #878a99;
  --vz-gray-dark: #363d48;
  --vz-gray-100: #f3f6f9;
  --vz-gray-200: #eff2f7;
  --vz-gray-300: #e9ebec;
  --vz-gray-400: #ced4da;
  --vz-gray-500: #adb5bd;
  --vz-gray-600: #878a99;
  --vz-gray-700: #495057;
  --vz-gray-800: #363d48;
  --vz-gray-900: #212529;
  --vz-primary: #b4d0f0;
  --vz-secondary: #daecfb;
  --vz-success: #13c56b;
  --vz-info: #50c3e6;
  --vz-warning: #e8bc52;
  --vz-danger: #ed5e5e;
  --vz-light: #f3f6f9;
  --vz-dark: #363d48;
  --vz-custom-primary: #7eabe7;
  --vz-custom-primary-hover: #bcd4f8;
  --vz-new-primary: #0A56AE;
  --vz-header: #bdd6fb;
  --vz-next-button: #83a9e2;
  --vz-next-button-border: #5d87c7;
  --vz-next-button-hover: #bdd6fa;
  --vz-white: #fff;
  --vz-light-grey: #ced4da;
  --vz-primary-rgb: 180, 208, 240;
  --vz-secondary-rgb: 218, 236, 251;
  --vz-success-rgb: 19, 197, 107;
  --vz-info-rgb: 80, 195, 230;
  --vz-warning-rgb: 232, 188, 82;
  --vz-danger-rgb: 237, 94, 94;
  --vz-light-rgb: 243, 246, 249;
  --vz-dark-rgb: 54, 61, 72;
  --vz-custom-primary-rgb: 126, 171, 231;
  --vz-custom-primary-hover-rgb: 188, 212, 248;
  --vz-new-primary-rgb: 10, 86, 174;
  --vz-header-rgb: 189, 214, 251;
  --vz-next-button-rgb: 131, 169, 226;
  --vz-next-button-border-rgb: 93, 135, 199;
  --vz-next-button-hover-rgb: 189, 214, 250;
  --vz-white-rgb: 255, 255, 255;
  --vz-light-grey-rgb: 206, 212, 218;
  --vz-primary-text-emphasis: #99b1cc;
  --vz-secondary-text-emphasis: #b9c9d5;
  --vz-success-text-emphasis: #10a75b;
  --vz-info-text-emphasis: #44a6c4;
  --vz-warning-text-emphasis: #c5a046;
  --vz-danger-text-emphasis: #c95050;
  --vz-light-text-emphasis: #ced4da;
  --vz-dark-text-emphasis: #363d48;
  --vz-primary-bg-subtle: #f4f8fd;
  --vz-secondary-bg-subtle: #f9fcfe;
  --vz-success-bg-subtle: #dcf6e9;
  --vz-info-bg-subtle: #e5f6fb;
  --vz-warning-bg-subtle: #fcf5e5;
  --vz-danger-bg-subtle: #fce7e7;
  --vz-light-bg-subtle: #f9fbfc;
  --vz-dark-bg-subtle: #e9ebec;
  --vz-primary-border-subtle: #e1ecf9;
  --vz-secondary-border-subtle: #f0f7fd;
  --vz-success-border-subtle: #a1e8c4;
  --vz-info-border-subtle: #b9e7f5;
  --vz-warning-border-subtle: #f6e4ba;
  --vz-danger-border-subtle: #f8bfbf;
  --vz-light-border-subtle: #eff2f7;
  --vz-dark-border-subtle: #adb5bd;
  --vz-white-rgb: 255, 255, 255;
  --vz-black-rgb: 0, 0, 0;
  --vz-font-sans-serif: "Rubik", sans-serif;
  --vz-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --vz-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --vz-body-font-family: var(--vz-font-sans-serif);
  --vz-body-font-size: 0.825rem;
  --vz-body-font-weight: 400;
  --vz-body-line-height: 1.5;
  --vz-body-color: #212529;
  --vz-body-color-rgb: 33, 37, 41;
  --vz-body-bg: #f3f6f9;
  --vz-body-bg-rgb: 243, 246, 249;
  --vz-emphasis-color: #212529;
  --vz-emphasis-color-rgb: 33, 37, 41;
  --vz-secondary-color: #878a99;
  --vz-secondary-color-rgb: 135, 138, 153;
  --vz-secondary-bg: #fff;
  --vz-secondary-bg-rgb: 255, 255, 255;
  --vz-tertiary-color: rgba(33, 37, 41, 0.5);
  --vz-tertiary-color-rgb: 33, 37, 41;
  --vz-tertiary-bg: #eff2f7;
  --vz-tertiary-bg-rgb: 239, 242, 247;
  --vz-heading-color: #495057;
  --vz-link-color: #b4d0f0;
  --vz-link-color-rgb: 180, 208, 240;
  --vz-link-decoration: none;
  --vz-link-hover-color: #b4d0f0;
  --vz-link-hover-color-rgb: 180, 208, 240;
  --vz-code-color: #f672a7;
  --vz-highlight-color: #212529;
  --vz-highlight-bg: #fcf8e3;
  --vz-border-width: 1px;
  --vz-border-style: solid;
  --vz-border-color: #b4d0f0;
  --vz-border-color-translucent: #8aaed6;
  --vz-border-radius: 0.25rem;
  --vz-border-radius-sm: 0.2rem;
  --vz-border-radius-lg: 0.3rem;
  --vz-border-radius-xl: 1rem;
  --vz-border-radius-xxl: 2rem;
  --vz-border-radius-2xl: var(--vz-border-radius-xxl);
  --vz-border-radius-pill: 50rem;
  --vz-box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  --vz-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --vz-box-shadow-lg: 0 5px 10px rgba(30, 32, 37, 0.12);
  --vz-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --vz-focus-ring-width: 0.25rem;
  --vz-focus-ring-opacity: 0.25;
  --vz-focus-ring-color: rgba(var(--vz-primary-rgb), 0.25);
  --vz-form-valid-color: #13c56b;
  --vz-form-valid-border-color: #13c56b;
  --vz-form-invalid-color: #ed5e5e;
  --vz-form-invalid-border-color: #ed5e5e;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --vz-body-color: #ced4da;
  --vz-body-color-rgb: 206, 212, 218;
  --vz-body-bg: #1a1d21;
  --vz-body-bg-rgb: 26, 29, 33;
  --vz-emphasis-color: #fff;
  --vz-emphasis-color-rgb: 255, 255, 255;
  --vz-secondary-color: #878a99;
  --vz-secondary-color-rgb: 135, 138, 153;
  --vz-secondary-bg: #212529;
  --vz-secondary-bg-rgb: 33, 37, 41;
  --vz-tertiary-color: rgba(206, 212, 218, 0.75);
  --vz-tertiary-color-rgb: 206, 212, 218;
  --vz-tertiary-bg: #2a2d31;
  --vz-tertiary-bg-rgb: 42, 45, 49;
  --vz-primary-text-emphasis: #c3d9f3;
  --vz-secondary-text-emphasis: #e1f0fc;
  --vz-success-text-emphasis: #42d189;
  --vz-info-text-emphasis: #73cfeb;
  --vz-warning-text-emphasis: #edc975;
  --vz-danger-text-emphasis: #f17e7e;
  --vz-light-text-emphasis: #535659;
  --vz-dark-text-emphasis: #5f6164;
  --vz-primary-bg-subtle: rgba(180, 208, 240, 0.15);
  --vz-secondary-bg-subtle: rgba(218, 236, 251, 0.15);
  --vz-success-bg-subtle: rgba(19, 197, 107, 0.15);
  --vz-info-bg-subtle: rgba(80, 195, 230, 0.15);
  --vz-warning-bg-subtle: rgba(232, 188, 82, 0.15);
  --vz-danger-bg-subtle: rgba(237, 94, 94, 0.15);
  --vz-light-bg-subtle: #25282c;
  --vz-dark-bg-subtle: #313437;
  --vz-primary-border-subtle: #75879c;
  --vz-secondary-border-subtle: #6d767e;
  --vz-success-border-subtle: #0a6336;
  --vz-info-border-subtle: #286273;
  --vz-warning-border-subtle: #745e29;
  --vz-danger-border-subtle: #772f2f;
  --vz-light-border-subtle: #35383c;
  --vz-dark-border-subtle: #3c3f42;
  --vz-heading-color: #ced4da;
  --vz-link-color: #f0f6fc;
  --vz-link-hover-color: #f3f8fd;
  --vz-link-color-rgb: 240, 246, 252;
  --vz-link-hover-color-rgb: 243, 248, 253;
  --vz-code-color: #f672a7;
  --vz-highlight-color: #dee2e6;
  --vz-highlight-bg: #664d03;
  --vz-border-color: #32383e;
  --vz-border-color-translucent: #32383e;
  --vz-form-valid-color: #42d189;
  --vz-form-valid-border-color: #42d189;
  --vz-form-invalid-color: #f17e7e;
  --vz-form-invalid-border-color: #f17e7e;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--vz-body-font-family);
  font-size: var(--vz-body-font-size);
  font-weight: var(--vz-body-font-weight);
  line-height: var(--vz-body-line-height);
  color: var(--vz-body-color);
  text-align: var(--vz-body-text-align);
  background-color: var(--vz-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--vz-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  line-height: 1.2;
  color: var(--vz-heading-color);
}

h1, .h1 {
  font-size: calc(1.33125rem + 0.975vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.0625rem;
  }
}

h2, .h2 {
  font-size: calc(1.29rem + 0.48vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.65rem;
  }
}

h3, .h3 {
  font-size: calc(1.269375rem + 0.2325vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.44375rem;
  }
}

h4, .h4 {
  font-size: 1.2375rem;
}

h5, .h5 {
  font-size: 1.03125rem;
}

h6, .h6 {
  font-size: 0.825rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 500;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.2em;
  color: var(--vz-highlight-color);
  background-color: var(--vz-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--vz-link-color-rgb), var(--vz-link-opacity, 1));
  text-decoration: none;
}
a:hover {
  --vz-link-color-rgb: var(--vz-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--vz-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--vz-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 0.875em;
  color: var(--vz-body-bg);
  background-color: var(--vz-body-color);
  border-radius: 0.2rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: var(--vz-secondary-color);
  text-align: left;
}

th {
  font-weight: 500;
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.03125rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 0.9075rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #878a99;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--vz-body-bg);
  border: var(--vz-border-width) solid var(--vz-border-color);
  border-radius: var(--vz-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--vz-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --vz-gutter-x: 1.5rem;
  --vz-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--vz-gutter-x) * .5);
  padding-left: calc(var(--vz-gutter-x) * .5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --vz-breakpoint-xs: 0;
  --vz-breakpoint-sm: 576px;
  --vz-breakpoint-md: 768px;
  --vz-breakpoint-lg: 992px;
  --vz-breakpoint-xl: 1200px;
  --vz-breakpoint-xxl: 1400px;
}

.row {
  --vz-gutter-x: 1.5rem;
  --vz-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--vz-gutter-y));
  margin-right: calc(-.5 * var(--vz-gutter-x));
  margin-left: calc(-.5 * var(--vz-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--vz-gutter-x) * .5);
  padding-left: calc(var(--vz-gutter-x) * .5);
  margin-top: var(--vz-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --vz-gutter-x: 0;
}

.g-0,
.gy-0 {
  --vz-gutter-y: 0;
}

.g-1,
.gx-1 {
  --vz-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --vz-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --vz-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --vz-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --vz-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --vz-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --vz-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --vz-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --vz-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --vz-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }

  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-sm-0 {
    margin-left: 0;
  }

  .offset-sm-1 {
    margin-left: 8.33333333%;
  }

  .offset-sm-2 {
    margin-left: 16.66666667%;
  }

  .offset-sm-3 {
    margin-left: 25%;
  }

  .offset-sm-4 {
    margin-left: 33.33333333%;
  }

  .offset-sm-5 {
    margin-left: 41.66666667%;
  }

  .offset-sm-6 {
    margin-left: 50%;
  }

  .offset-sm-7 {
    margin-left: 58.33333333%;
  }

  .offset-sm-8 {
    margin-left: 66.66666667%;
  }

  .offset-sm-9 {
    margin-left: 75%;
  }

  .offset-sm-10 {
    margin-left: 83.33333333%;
  }

  .offset-sm-11 {
    margin-left: 91.66666667%;
  }

  .g-sm-0,
.gx-sm-0 {
    --vz-gutter-x: 0;
  }

  .g-sm-0,
.gy-sm-0 {
    --vz-gutter-y: 0;
  }

  .g-sm-1,
.gx-sm-1 {
    --vz-gutter-x: 0.25rem;
  }

  .g-sm-1,
.gy-sm-1 {
    --vz-gutter-y: 0.25rem;
  }

  .g-sm-2,
.gx-sm-2 {
    --vz-gutter-x: 0.5rem;
  }

  .g-sm-2,
.gy-sm-2 {
    --vz-gutter-y: 0.5rem;
  }

  .g-sm-3,
.gx-sm-3 {
    --vz-gutter-x: 1rem;
  }

  .g-sm-3,
.gy-sm-3 {
    --vz-gutter-y: 1rem;
  }

  .g-sm-4,
.gx-sm-4 {
    --vz-gutter-x: 1.5rem;
  }

  .g-sm-4,
.gy-sm-4 {
    --vz-gutter-y: 1.5rem;
  }

  .g-sm-5,
.gx-sm-5 {
    --vz-gutter-x: 3rem;
  }

  .g-sm-5,
.gy-sm-5 {
    --vz-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }

  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-md-0 {
    margin-left: 0;
  }

  .offset-md-1 {
    margin-left: 8.33333333%;
  }

  .offset-md-2 {
    margin-left: 16.66666667%;
  }

  .offset-md-3 {
    margin-left: 25%;
  }

  .offset-md-4 {
    margin-left: 33.33333333%;
  }

  .offset-md-5 {
    margin-left: 41.66666667%;
  }

  .offset-md-6 {
    margin-left: 50%;
  }

  .offset-md-7 {
    margin-left: 58.33333333%;
  }

  .offset-md-8 {
    margin-left: 66.66666667%;
  }

  .offset-md-9 {
    margin-left: 75%;
  }

  .offset-md-10 {
    margin-left: 83.33333333%;
  }

  .offset-md-11 {
    margin-left: 91.66666667%;
  }

  .g-md-0,
.gx-md-0 {
    --vz-gutter-x: 0;
  }

  .g-md-0,
.gy-md-0 {
    --vz-gutter-y: 0;
  }

  .g-md-1,
.gx-md-1 {
    --vz-gutter-x: 0.25rem;
  }

  .g-md-1,
.gy-md-1 {
    --vz-gutter-y: 0.25rem;
  }

  .g-md-2,
.gx-md-2 {
    --vz-gutter-x: 0.5rem;
  }

  .g-md-2,
.gy-md-2 {
    --vz-gutter-y: 0.5rem;
  }

  .g-md-3,
.gx-md-3 {
    --vz-gutter-x: 1rem;
  }

  .g-md-3,
.gy-md-3 {
    --vz-gutter-y: 1rem;
  }

  .g-md-4,
.gx-md-4 {
    --vz-gutter-x: 1.5rem;
  }

  .g-md-4,
.gy-md-4 {
    --vz-gutter-y: 1.5rem;
  }

  .g-md-5,
.gx-md-5 {
    --vz-gutter-x: 3rem;
  }

  .g-md-5,
.gy-md-5 {
    --vz-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }

  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-lg-0 {
    margin-left: 0;
  }

  .offset-lg-1 {
    margin-left: 8.33333333%;
  }

  .offset-lg-2 {
    margin-left: 16.66666667%;
  }

  .offset-lg-3 {
    margin-left: 25%;
  }

  .offset-lg-4 {
    margin-left: 33.33333333%;
  }

  .offset-lg-5 {
    margin-left: 41.66666667%;
  }

  .offset-lg-6 {
    margin-left: 50%;
  }

  .offset-lg-7 {
    margin-left: 58.33333333%;
  }

  .offset-lg-8 {
    margin-left: 66.66666667%;
  }

  .offset-lg-9 {
    margin-left: 75%;
  }

  .offset-lg-10 {
    margin-left: 83.33333333%;
  }

  .offset-lg-11 {
    margin-left: 91.66666667%;
  }

  .g-lg-0,
.gx-lg-0 {
    --vz-gutter-x: 0;
  }

  .g-lg-0,
.gy-lg-0 {
    --vz-gutter-y: 0;
  }

  .g-lg-1,
.gx-lg-1 {
    --vz-gutter-x: 0.25rem;
  }

  .g-lg-1,
.gy-lg-1 {
    --vz-gutter-y: 0.25rem;
  }

  .g-lg-2,
.gx-lg-2 {
    --vz-gutter-x: 0.5rem;
  }

  .g-lg-2,
.gy-lg-2 {
    --vz-gutter-y: 0.5rem;
  }

  .g-lg-3,
.gx-lg-3 {
    --vz-gutter-x: 1rem;
  }

  .g-lg-3,
.gy-lg-3 {
    --vz-gutter-y: 1rem;
  }

  .g-lg-4,
.gx-lg-4 {
    --vz-gutter-x: 1.5rem;
  }

  .g-lg-4,
.gy-lg-4 {
    --vz-gutter-y: 1.5rem;
  }

  .g-lg-5,
.gx-lg-5 {
    --vz-gutter-x: 3rem;
  }

  .g-lg-5,
.gy-lg-5 {
    --vz-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }

  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-xl-0 {
    margin-left: 0;
  }

  .offset-xl-1 {
    margin-left: 8.33333333%;
  }

  .offset-xl-2 {
    margin-left: 16.66666667%;
  }

  .offset-xl-3 {
    margin-left: 25%;
  }

  .offset-xl-4 {
    margin-left: 33.33333333%;
  }

  .offset-xl-5 {
    margin-left: 41.66666667%;
  }

  .offset-xl-6 {
    margin-left: 50%;
  }

  .offset-xl-7 {
    margin-left: 58.33333333%;
  }

  .offset-xl-8 {
    margin-left: 66.66666667%;
  }

  .offset-xl-9 {
    margin-left: 75%;
  }

  .offset-xl-10 {
    margin-left: 83.33333333%;
  }

  .offset-xl-11 {
    margin-left: 91.66666667%;
  }

  .g-xl-0,
.gx-xl-0 {
    --vz-gutter-x: 0;
  }

  .g-xl-0,
.gy-xl-0 {
    --vz-gutter-y: 0;
  }

  .g-xl-1,
.gx-xl-1 {
    --vz-gutter-x: 0.25rem;
  }

  .g-xl-1,
.gy-xl-1 {
    --vz-gutter-y: 0.25rem;
  }

  .g-xl-2,
.gx-xl-2 {
    --vz-gutter-x: 0.5rem;
  }

  .g-xl-2,
.gy-xl-2 {
    --vz-gutter-y: 0.5rem;
  }

  .g-xl-3,
.gx-xl-3 {
    --vz-gutter-x: 1rem;
  }

  .g-xl-3,
.gy-xl-3 {
    --vz-gutter-y: 1rem;
  }

  .g-xl-4,
.gx-xl-4 {
    --vz-gutter-x: 1.5rem;
  }

  .g-xl-4,
.gy-xl-4 {
    --vz-gutter-y: 1.5rem;
  }

  .g-xl-5,
.gx-xl-5 {
    --vz-gutter-x: 3rem;
  }

  .g-xl-5,
.gy-xl-5 {
    --vz-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }

  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-xxl-0 {
    margin-left: 0;
  }

  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }

  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }

  .offset-xxl-3 {
    margin-left: 25%;
  }

  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }

  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }

  .offset-xxl-6 {
    margin-left: 50%;
  }

  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }

  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }

  .offset-xxl-9 {
    margin-left: 75%;
  }

  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }

  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }

  .g-xxl-0,
.gx-xxl-0 {
    --vz-gutter-x: 0;
  }

  .g-xxl-0,
.gy-xxl-0 {
    --vz-gutter-y: 0;
  }

  .g-xxl-1,
.gx-xxl-1 {
    --vz-gutter-x: 0.25rem;
  }

  .g-xxl-1,
.gy-xxl-1 {
    --vz-gutter-y: 0.25rem;
  }

  .g-xxl-2,
.gx-xxl-2 {
    --vz-gutter-x: 0.5rem;
  }

  .g-xxl-2,
.gy-xxl-2 {
    --vz-gutter-y: 0.5rem;
  }

  .g-xxl-3,
.gx-xxl-3 {
    --vz-gutter-x: 1rem;
  }

  .g-xxl-3,
.gy-xxl-3 {
    --vz-gutter-y: 1rem;
  }

  .g-xxl-4,
.gx-xxl-4 {
    --vz-gutter-x: 1.5rem;
  }

  .g-xxl-4,
.gy-xxl-4 {
    --vz-gutter-y: 1.5rem;
  }

  .g-xxl-5,
.gx-xxl-5 {
    --vz-gutter-x: 3rem;
  }

  .g-xxl-5,
.gy-xxl-5 {
    --vz-gutter-y: 3rem;
  }
}
.table {
  --vz-table-color-type: initial;
  --vz-table-bg-type: initial;
  --vz-table-color-state: initial;
  --vz-table-bg-state: initial;
  --vz-table-color: var(--vz-body-color);
  --vz-table-bg: transparent;
  --vz-table-border-color: var(--vz-border-color);
  --vz-table-accent-bg: transparent;
  --vz-table-striped-color: var(--vz-body-color);
  --vz-table-striped-bg: rgba(var(--vz-body-color-rgb), 0.02);
  --vz-table-active-color: var(--vz-body-color);
  --vz-table-active-bg: rgba(var(--vz-body-color-rgb), 0.04);
  --vz-table-hover-color: var(--vz-body-color);
  --vz-table-hover-bg: rgba(var(--vz-body-color-rgb), 0.04);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--vz-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.75rem 0.6rem;
  color: var(--vz-table-color-state, var(--vz-table-color-type, var(--vz-table-color)));
  background-color: var(--vz-table-bg);
  border-bottom-width: var(--vz-border-width);
  box-shadow: inset 0 0 0 9999px var(--vz-table-bg-state, var(--vz-table-bg-type, var(--vz-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--vz-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.3rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--vz-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--vz-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --vz-table-color-type: var(--vz-table-striped-color);
  --vz-table-bg-type: var(--vz-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --vz-table-color-type: var(--vz-table-striped-color);
  --vz-table-bg-type: var(--vz-table-striped-bg);
}

.table-active {
  --vz-table-color-state: var(--vz-table-active-color);
  --vz-table-bg-state: var(--vz-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --vz-table-color-state: var(--vz-table-hover-color);
  --vz-table-bg-state: var(--vz-table-hover-bg);
}

.table-primary {
  --vz-table-color: #000;
  --vz-table-bg: #f0f6fc;
  --vz-table-border-color: #d8dde3;
  --vz-table-striped-bg: #ebf1f7;
  --vz-table-striped-color: #000;
  --vz-table-active-bg: #e6ecf2;
  --vz-table-active-color: #000;
  --vz-table-hover-bg: #e6ecf2;
  --vz-table-hover-color: #000;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-secondary {
  --vz-table-color: #000;
  --vz-table-bg: #f8fbfe;
  --vz-table-border-color: #dfe2e5;
  --vz-table-striped-bg: #f3f6f9;
  --vz-table-striped-color: #000;
  --vz-table-active-bg: #eef1f4;
  --vz-table-active-color: #000;
  --vz-table-hover-bg: #eef1f4;
  --vz-table-hover-color: #000;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-success {
  --vz-table-color: #000;
  --vz-table-bg: #d0f3e1;
  --vz-table-border-color: #bbdbcb;
  --vz-table-striped-bg: #cceedd;
  --vz-table-striped-color: #000;
  --vz-table-active-bg: #c8e9d8;
  --vz-table-active-color: #000;
  --vz-table-hover-bg: #c8e9d8;
  --vz-table-hover-color: #000;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-info {
  --vz-table-color: #000;
  --vz-table-bg: #dcf3fa;
  --vz-table-border-color: #c6dbe1;
  --vz-table-striped-bg: #d8eef5;
  --vz-table-striped-color: #000;
  --vz-table-active-bg: #d3e9f0;
  --vz-table-active-color: #000;
  --vz-table-hover-bg: #d3e9f0;
  --vz-table-hover-color: #000;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-warning {
  --vz-table-color: #000;
  --vz-table-bg: #faf2dc;
  --vz-table-border-color: #e1dac6;
  --vz-table-striped-bg: #f5edd8;
  --vz-table-striped-color: #000;
  --vz-table-active-bg: #f0e8d3;
  --vz-table-active-color: #000;
  --vz-table-hover-bg: #f0e8d3;
  --vz-table-hover-color: #000;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-danger {
  --vz-table-color: #000;
  --vz-table-bg: #fbdfdf;
  --vz-table-border-color: #e2c9c9;
  --vz-table-striped-bg: #f6dbdb;
  --vz-table-striped-color: #000;
  --vz-table-active-bg: #f1d6d6;
  --vz-table-active-color: #000;
  --vz-table-hover-bg: #f1d6d6;
  --vz-table-hover-color: #000;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-light {
  --vz-table-color: #000;
  --vz-table-bg: #f3f6f9;
  --vz-table-border-color: #dbdde0;
  --vz-table-striped-bg: #eef1f4;
  --vz-table-striped-color: #000;
  --vz-table-active-bg: #e9ecef;
  --vz-table-active-color: #000;
  --vz-table-hover-bg: #e9ecef;
  --vz-table-hover-color: #000;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-dark {
  --vz-table-color: #fff;
  --vz-table-bg: #363d48;
  --vz-table-border-color: #4a505a;
  --vz-table-striped-bg: #3a414c;
  --vz-table-striped-color: #fff;
  --vz-table-active-bg: #3e454f;
  --vz-table-active-color: #fff;
  --vz-table-hover-bg: #3e454f;
  --vz-table-hover-color: #fff;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.5rem + var(--vz-border-width));
  padding-bottom: calc(0.5rem + var(--vz-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.7rem + var(--vz-border-width));
  padding-bottom: calc(0.7rem + var(--vz-border-width));
  font-size: 1.03125rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--vz-border-width));
  padding-bottom: calc(0.25rem + var(--vz-border-width));
  font-size: 0.721875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--vz-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem;
  font-size: 0.825rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  appearance: none;
  background-color: var(--vz-input-bg-custom);
  background-clip: padding-box;
  border: var(--vz-border-width) solid var(--vz-input-border-custom);
  border-radius: var(--vz-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--vz-body-color);
  background-color: var(--vz-input-bg-custom);
  border-color: var(--vz-primary-border-subtle);
  outline: 0;
  box-shadow: 0 0 1 0.25rem rgba(var(--vz-primary-rgb), 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--vz-secondary-color);
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--vz-tertiary-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.5rem 0.9rem;
  margin: -0.5rem -0.9rem;
  margin-inline-end: 0.9rem;
  color: var(--vz-body-color);
  background-color: #b4d0f0;
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--vz-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--vz-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.5rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--vz-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--vz-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc( var(--vz-border-width) * 2 ));
  padding: 0.25rem 0.5rem;
  font-size: 0.721875rem;
  border-radius: var(--vz-border-radius-sm);
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1.4rem + calc( var(--vz-border-width) * 2 ));
  padding: 0.7rem 1.2rem;
  font-size: 1.03125rem;
  border-radius: var(--vz-border-radius-lg);
}
.form-control-lg::file-selector-button {
  padding: 0.7rem 1.2rem;
  margin: -0.7rem -1.2rem;
  margin-inline-end: 1.2rem;
}

textarea.form-control {
  min-height: calc(1.5em + 1rem + calc( var(--vz-border-width) * 2 ));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc( var(--vz-border-width) * 2 ));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1.4rem + calc( var(--vz-border-width) * 2 ));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 1rem + calc( var(--vz-border-width) * 2 ));
  padding: 0.5rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--vz-border-radius);
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--vz-border-radius);
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc( var(--vz-border-width) * 2 ));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1.4rem + calc( var(--vz-border-width) * 2 ));
}

.form-select {
  --vz-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  display: block;
  width: 100%;
  padding: 0.5rem 2.25rem 0.5rem 0.9rem;
  font-size: 0.825rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  appearance: none;
  background-color: var(--vz-input-bg-custom);
  background-image: var(--vz-form-select-bg-img), var(--vz-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.9rem center;
  background-size: 16px 12px;
  border: var(--vz-border-width) solid var(--vz-input-border-custom);
  border-radius: var(--vz-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: var(--vz-primary-border-subtle);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(var(--vz-primary-rgb), 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.9rem;
  background-image: none;
}
.form-select:disabled {
  background-color: var(--vz-tertiary-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--vz-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.721875rem;
  border-radius: var(--vz-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
  padding-left: 1.2rem;
  font-size: 1.03125rem;
  border-radius: var(--vz-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --vz-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}

.form-check {
  display: block;
  min-height: 1.2375rem;
  padding-left: 1.6em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.6em;
}

.form-check-reverse {
  padding-right: 1.6em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.6em;
  margin-left: 0;
}

.form-check-input {
  --vz-form-check-bg: var(--vz-input-bg-custom);
  flex-shrink: 0;
  width: 1.1em;
  height: 1.1em;
  margin-top: 0.2em;
  vertical-align: top;
  appearance: none;
  background-color: var(--vz-form-check-bg);
  background-image: var(--vz-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--vz-border-width) solid var(--vz-border-color-translucent);
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: var(--vz-primary-border-subtle);
  outline: 0;
  box-shadow: 0 0 1 0.25rem rgba(var(--vz-primary-rgb), 0.25);
}
.form-check-input:checked {
  background-color: #8aaed6;
  border-color: #8aaed6;
}
.form-check-input:checked[type=checkbox] {
  --vz-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
}
.form-check-input:checked[type=radio] {
  --vz-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #8aaed6;
  border-color: #8aaed6;
  --vz-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --vz-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--vz-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --vz-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --vz-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --vz-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f3f6f9, 0 0 1 0.25rem rgba(var(--vz-primary-rgb), 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f3f6f9, 0 0 1 0.25rem rgba(var(--vz-primary-rgb), 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #8aaed6;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: #dce7f3;
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--vz-tertiary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #8aaed6;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: #dce7f3;
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--vz-tertiary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--vz-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--vz-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc( var(--vz-border-width) * 2 ));
  min-height: calc(3.5rem + calc( var(--vz-border-width) * 2 ));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.9rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--vz-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.9rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--vz-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.45rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--vz-input-bg-custom);
  border-radius: var(--vz-border-radius);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--vz-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--vz-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: var(--vz-secondary-color);
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: var(--vz-tertiary-bg);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.9rem;
  font-size: 0.825rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--vz-tertiary-bg);
  border: var(--vz-border-width) solid var(--vz-input-border-custom);
  border-radius: var(--vz-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.7rem 1.2rem;
  font-size: 1.03125rem;
  border-radius: var(--vz-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.721875rem;
  border-radius: var(--vz-border-radius-sm);
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3.15rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--vz-border-width) * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--vz-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.7rem;
  margin-top: 0.1rem;
  font-size: 0.721875rem;
  color: #fff;
  background-color: var(--vz-success);
  border-radius: var(--vz-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--vz-form-valid-border-color);
  padding-right: calc(1.5em + 1rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.25rem) center;
  background-size: calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--vz-form-valid-border-color);
  box-shadow: 0 0 1 0.25rem rgba(var(--vz-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 1rem);
  background-position: top calc(0.375em + 0.25rem) right calc(0.375em + 0.25rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--vz-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --vz-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  padding-right: 4.125rem;
  background-position: right 0.9rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--vz-form-valid-border-color);
  box-shadow: 0 0 1 0.25rem rgba(var(--vz-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 1rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--vz-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--vz-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 1 0.25rem rgba(var(--vz-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--vz-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--vz-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.7rem;
  margin-top: 0.1rem;
  font-size: 0.721875rem;
  color: #fff;
  background-color: var(--vz-danger);
  border-radius: var(--vz-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--vz-form-invalid-border-color);
  padding-right: calc(1.5em + 1rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.25rem) center;
  background-size: calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--vz-form-invalid-border-color);
  box-shadow: 0 0 1 0.25rem rgba(var(--vz-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 1rem);
  background-position: top calc(0.375em + 0.25rem) right calc(0.375em + 0.25rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--vz-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --vz-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  padding-right: 4.125rem;
  background-position: right 0.9rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--vz-form-invalid-border-color);
  box-shadow: 0 0 1 0.25rem rgba(var(--vz-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 1rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--vz-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--vz-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 1 0.25rem rgba(var(--vz-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--vz-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --vz-btn-padding-x: 0.9rem;
  --vz-btn-padding-y: 0.5rem;
  --vz-btn-font-family: ;
  --vz-btn-font-size: 0.825rem;
  --vz-btn-font-weight: 400;
  --vz-btn-line-height: 1.5;
  --vz-btn-color: var(--vz-body-color);
  --vz-btn-bg: transparent;
  --vz-btn-border-width: var(--vz-border-width);
  --vz-btn-border-color: transparent;
  --vz-btn-border-radius: var(--vz-border-radius);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --vz-btn-disabled-opacity: 0.65;
  --vz-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--vz-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--vz-btn-padding-y) var(--vz-btn-padding-x);
  font-family: var(--vz-btn-font-family);
  font-size: var(--vz-btn-font-size);
  font-weight: var(--vz-btn-font-weight);
  line-height: var(--vz-btn-line-height);
  color: var(--vz-btn-color);
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--vz-btn-border-width) solid var(--vz-btn-border-color);
  border-radius: var(--vz-btn-border-radius);
  background-color: var(--vz-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--vz-btn-hover-color);
  background-color: var(--vz-btn-hover-bg);
  border-color: var(--vz-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--vz-btn-color);
  background-color: var(--vz-btn-bg);
  border-color: var(--vz-btn-border-color);
}
.btn:focus-visible {
  color: var(--vz-btn-hover-color);
  background-color: var(--vz-btn-hover-bg);
  border-color: var(--vz-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--vz-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--vz-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--vz-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--vz-btn-active-color);
  background-color: var(--vz-btn-active-bg);
  border-color: var(--vz-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--vz-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--vz-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--vz-btn-disabled-color);
  pointer-events: none;
  background-color: var(--vz-btn-disabled-bg);
  border-color: var(--vz-btn-disabled-border-color);
  opacity: var(--vz-btn-disabled-opacity);
}

.btn-primary {
  --vz-btn-color: #000;
  --vz-btn-bg: #b4d0f0;
  --vz-btn-border-color: #b4d0f0;
  --vz-btn-hover-color: #000;
  --vz-btn-hover-bg: #bfd7f2;
  --vz-btn-hover-border-color: #bcd5f2;
  --vz-btn-focus-shadow-rgb: 153, 177, 204;
  --vz-btn-active-color: #000;
  --vz-btn-active-bg: #c3d9f3;
  --vz-btn-active-border-color: #bcd5f2;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #000;
  --vz-btn-disabled-bg: #b4d0f0;
  --vz-btn-disabled-border-color: #b4d0f0;
}

.btn-secondary {
  --vz-btn-color: #000;
  --vz-btn-bg: #daecfb;
  --vz-btn-border-color: #daecfb;
  --vz-btn-hover-color: #000;
  --vz-btn-hover-bg: #e0effc;
  --vz-btn-hover-border-color: #deeefb;
  --vz-btn-focus-shadow-rgb: 185, 201, 213;
  --vz-btn-active-color: #000;
  --vz-btn-active-bg: #e1f0fc;
  --vz-btn-active-border-color: #deeefb;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #000;
  --vz-btn-disabled-bg: #daecfb;
  --vz-btn-disabled-border-color: #daecfb;
}

.btn-success {
  --vz-btn-color: #fff;
  --vz-btn-bg: #13c56b;
  --vz-btn-border-color: #13c56b;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #10a75b;
  --vz-btn-hover-border-color: #0f9e56;
  --vz-btn-focus-shadow-rgb: 54, 206, 129;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #0f9e56;
  --vz-btn-active-border-color: #0e9450;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #13c56b;
  --vz-btn-disabled-border-color: #13c56b;
}

.btn-info {
  --vz-btn-color: #fff;
  --vz-btn-bg: #50c3e6;
  --vz-btn-border-color: #50c3e6;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #44a6c4;
  --vz-btn-hover-border-color: #409cb8;
  --vz-btn-focus-shadow-rgb: 106, 204, 234;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #409cb8;
  --vz-btn-active-border-color: #3c92ad;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #50c3e6;
  --vz-btn-disabled-border-color: #50c3e6;
}

.btn-warning {
  --vz-btn-color: #fff;
  --vz-btn-bg: #e8bc52;
  --vz-btn-border-color: #e8bc52;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #c5a046;
  --vz-btn-hover-border-color: #ba9642;
  --vz-btn-focus-shadow-rgb: 235, 198, 108;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #ba9642;
  --vz-btn-active-border-color: #ae8d3e;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #e8bc52;
  --vz-btn-disabled-border-color: #e8bc52;
}

.btn-danger {
  --vz-btn-color: #fff;
  --vz-btn-bg: #ed5e5e;
  --vz-btn-border-color: #ed5e5e;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #c95050;
  --vz-btn-hover-border-color: #be4b4b;
  --vz-btn-focus-shadow-rgb: 240, 118, 118;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #be4b4b;
  --vz-btn-active-border-color: #b24747;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #ed5e5e;
  --vz-btn-disabled-border-color: #ed5e5e;
}

.btn-light {
  --vz-btn-color: #000;
  --vz-btn-bg: #f3f6f9;
  --vz-btn-border-color: #f3f6f9;
  --vz-btn-hover-color: #000;
  --vz-btn-hover-bg: #cfd1d4;
  --vz-btn-hover-border-color: #c2c5c7;
  --vz-btn-focus-shadow-rgb: 207, 209, 212;
  --vz-btn-active-color: #000;
  --vz-btn-active-bg: #c2c5c7;
  --vz-btn-active-border-color: #b6b9bb;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #000;
  --vz-btn-disabled-bg: #f3f6f9;
  --vz-btn-disabled-border-color: #f3f6f9;
}

.btn-dark {
  --vz-btn-color: #fff;
  --vz-btn-bg: #363d48;
  --vz-btn-border-color: #363d48;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #545a63;
  --vz-btn-hover-border-color: #4a505a;
  --vz-btn-focus-shadow-rgb: 84, 90, 99;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #5e646d;
  --vz-btn-active-border-color: #4a505a;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #363d48;
  --vz-btn-disabled-border-color: #363d48;
}

.btn-custom-primary {
  --vz-btn-color: #fff;
  --vz-btn-bg: #7eabe7;
  --vz-btn-border-color: #7eabe7;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #6b91c4;
  --vz-btn-hover-border-color: #6589b9;
  --vz-btn-focus-shadow-rgb: 145, 184, 235;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #6589b9;
  --vz-btn-active-border-color: #5f80ad;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #7eabe7;
  --vz-btn-disabled-border-color: #7eabe7;
}

.btn-custom-primary-hover {
  --vz-btn-color: #000;
  --vz-btn-bg: #bcd4f8;
  --vz-btn-border-color: #bcd4f8;
  --vz-btn-hover-color: #000;
  --vz-btn-hover-bg: #c6daf9;
  --vz-btn-hover-border-color: #c3d8f9;
  --vz-btn-focus-shadow-rgb: 160, 180, 211;
  --vz-btn-active-color: #000;
  --vz-btn-active-bg: #c9ddf9;
  --vz-btn-active-border-color: #c3d8f9;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #000;
  --vz-btn-disabled-bg: #bcd4f8;
  --vz-btn-disabled-border-color: #bcd4f8;
}

.btn-new-primary {
  --vz-btn-color: #fff;
  --vz-btn-bg: #0A56AE;
  --vz-btn-border-color: #0A56AE;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #094994;
  --vz-btn-hover-border-color: #08458b;
  --vz-btn-focus-shadow-rgb: 47, 111, 186;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #08458b;
  --vz-btn-active-border-color: #084183;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #0A56AE;
  --vz-btn-disabled-border-color: #0A56AE;
}

.btn-header {
  --vz-btn-color: #000;
  --vz-btn-bg: #bdd6fb;
  --vz-btn-border-color: #bdd6fb;
  --vz-btn-hover-color: #000;
  --vz-btn-hover-bg: #c7dcfc;
  --vz-btn-hover-border-color: #c4dafb;
  --vz-btn-focus-shadow-rgb: 161, 182, 213;
  --vz-btn-active-color: #000;
  --vz-btn-active-bg: #cadefc;
  --vz-btn-active-border-color: #c4dafb;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #000;
  --vz-btn-disabled-bg: #bdd6fb;
  --vz-btn-disabled-border-color: #bdd6fb;
}

.btn-next-button {
  --vz-btn-color: #fff;
  --vz-btn-bg: #83a9e2;
  --vz-btn-border-color: #83a9e2;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #6f90c0;
  --vz-btn-hover-border-color: #6987b5;
  --vz-btn-focus-shadow-rgb: 150, 182, 230;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #6987b5;
  --vz-btn-active-border-color: #627faa;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #83a9e2;
  --vz-btn-disabled-border-color: #83a9e2;
}

.btn-next-button-border {
  --vz-btn-color: #fff;
  --vz-btn-bg: #5d87c7;
  --vz-btn-border-color: #5d87c7;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #4f73a9;
  --vz-btn-hover-border-color: #4a6c9f;
  --vz-btn-focus-shadow-rgb: 117, 153, 207;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #4a6c9f;
  --vz-btn-active-border-color: #466595;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #5d87c7;
  --vz-btn-disabled-border-color: #5d87c7;
}

.btn-next-button-hover {
  --vz-btn-color: #000;
  --vz-btn-bg: #bdd6fa;
  --vz-btn-border-color: #bdd6fa;
  --vz-btn-hover-color: #000;
  --vz-btn-hover-bg: #c7dcfb;
  --vz-btn-hover-border-color: #c4dafb;
  --vz-btn-focus-shadow-rgb: 161, 182, 213;
  --vz-btn-active-color: #000;
  --vz-btn-active-bg: #cadefb;
  --vz-btn-active-border-color: #c4dafb;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #000;
  --vz-btn-disabled-bg: #bdd6fa;
  --vz-btn-disabled-border-color: #bdd6fa;
}

.btn-white {
  --vz-btn-color: #000;
  --vz-btn-bg: #fff;
  --vz-btn-border-color: #fff;
  --vz-btn-hover-color: #000;
  --vz-btn-hover-bg: white;
  --vz-btn-hover-border-color: white;
  --vz-btn-focus-shadow-rgb: 217, 217, 217;
  --vz-btn-active-color: #000;
  --vz-btn-active-bg: white;
  --vz-btn-active-border-color: white;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #000;
  --vz-btn-disabled-bg: #fff;
  --vz-btn-disabled-border-color: #fff;
}

.btn-light-grey {
  --vz-btn-color: #000;
  --vz-btn-bg: #ced4da;
  --vz-btn-border-color: #ced4da;
  --vz-btn-hover-color: #000;
  --vz-btn-hover-bg: #d5dae0;
  --vz-btn-hover-border-color: #d3d8de;
  --vz-btn-focus-shadow-rgb: 175, 180, 185;
  --vz-btn-active-color: #000;
  --vz-btn-active-bg: #d8dde1;
  --vz-btn-active-border-color: #d3d8de;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #000;
  --vz-btn-disabled-bg: #ced4da;
  --vz-btn-disabled-border-color: #ced4da;
}

.btn-outline-primary {
  --vz-btn-color: #b4d0f0;
  --vz-btn-border-color: #b4d0f0;
  --vz-btn-hover-color: #000;
  --vz-btn-hover-bg: #b4d0f0;
  --vz-btn-hover-border-color: #b4d0f0;
  --vz-btn-focus-shadow-rgb: 180, 208, 240;
  --vz-btn-active-color: #000;
  --vz-btn-active-bg: #b4d0f0;
  --vz-btn-active-border-color: #b4d0f0;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #b4d0f0;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #b4d0f0;
  --vz-gradient: none;
}

.btn-outline-secondary {
  --vz-btn-color: #daecfb;
  --vz-btn-border-color: #daecfb;
  --vz-btn-hover-color: #000;
  --vz-btn-hover-bg: #daecfb;
  --vz-btn-hover-border-color: #daecfb;
  --vz-btn-focus-shadow-rgb: 218, 236, 251;
  --vz-btn-active-color: #000;
  --vz-btn-active-bg: #daecfb;
  --vz-btn-active-border-color: #daecfb;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #daecfb;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #daecfb;
  --vz-gradient: none;
}

.btn-outline-success {
  --vz-btn-color: #13c56b;
  --vz-btn-border-color: #13c56b;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #13c56b;
  --vz-btn-hover-border-color: #13c56b;
  --vz-btn-focus-shadow-rgb: 19, 197, 107;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #13c56b;
  --vz-btn-active-border-color: #13c56b;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #13c56b;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #13c56b;
  --vz-gradient: none;
}

.btn-outline-info {
  --vz-btn-color: #50c3e6;
  --vz-btn-border-color: #50c3e6;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #50c3e6;
  --vz-btn-hover-border-color: #50c3e6;
  --vz-btn-focus-shadow-rgb: 80, 195, 230;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #50c3e6;
  --vz-btn-active-border-color: #50c3e6;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #50c3e6;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #50c3e6;
  --vz-gradient: none;
}

.btn-outline-warning {
  --vz-btn-color: #e8bc52;
  --vz-btn-border-color: #e8bc52;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #e8bc52;
  --vz-btn-hover-border-color: #e8bc52;
  --vz-btn-focus-shadow-rgb: 232, 188, 82;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #e8bc52;
  --vz-btn-active-border-color: #e8bc52;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #e8bc52;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #e8bc52;
  --vz-gradient: none;
}

.btn-outline-danger {
  --vz-btn-color: #ed5e5e;
  --vz-btn-border-color: #ed5e5e;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #ed5e5e;
  --vz-btn-hover-border-color: #ed5e5e;
  --vz-btn-focus-shadow-rgb: 237, 94, 94;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #ed5e5e;
  --vz-btn-active-border-color: #ed5e5e;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #ed5e5e;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #ed5e5e;
  --vz-gradient: none;
}

.btn-outline-light {
  --vz-btn-color: #f3f6f9;
  --vz-btn-border-color: #f3f6f9;
  --vz-btn-hover-color: #000;
  --vz-btn-hover-bg: #f3f6f9;
  --vz-btn-hover-border-color: #f3f6f9;
  --vz-btn-focus-shadow-rgb: 243, 246, 249;
  --vz-btn-active-color: #000;
  --vz-btn-active-bg: #f3f6f9;
  --vz-btn-active-border-color: #f3f6f9;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #f3f6f9;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #f3f6f9;
  --vz-gradient: none;
}

.btn-outline-dark {
  --vz-btn-color: #363d48;
  --vz-btn-border-color: #363d48;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #363d48;
  --vz-btn-hover-border-color: #363d48;
  --vz-btn-focus-shadow-rgb: 54, 61, 72;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #363d48;
  --vz-btn-active-border-color: #363d48;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #363d48;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #363d48;
  --vz-gradient: none;
}

.btn-outline-custom-primary {
  --vz-btn-color: #7eabe7;
  --vz-btn-border-color: #7eabe7;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #7eabe7;
  --vz-btn-hover-border-color: #7eabe7;
  --vz-btn-focus-shadow-rgb: 126, 171, 231;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #7eabe7;
  --vz-btn-active-border-color: #7eabe7;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #7eabe7;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #7eabe7;
  --vz-gradient: none;
}

.btn-outline-custom-primary-hover {
  --vz-btn-color: #bcd4f8;
  --vz-btn-border-color: #bcd4f8;
  --vz-btn-hover-color: #000;
  --vz-btn-hover-bg: #bcd4f8;
  --vz-btn-hover-border-color: #bcd4f8;
  --vz-btn-focus-shadow-rgb: 188, 212, 248;
  --vz-btn-active-color: #000;
  --vz-btn-active-bg: #bcd4f8;
  --vz-btn-active-border-color: #bcd4f8;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #bcd4f8;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #bcd4f8;
  --vz-gradient: none;
}

.btn-outline-new-primary {
  --vz-btn-color: #0A56AE;
  --vz-btn-border-color: #0A56AE;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #0A56AE;
  --vz-btn-hover-border-color: #0A56AE;
  --vz-btn-focus-shadow-rgb: 10, 86, 174;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #0A56AE;
  --vz-btn-active-border-color: #0A56AE;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #0A56AE;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #0A56AE;
  --vz-gradient: none;
}

.btn-outline-header {
  --vz-btn-color: #bdd6fb;
  --vz-btn-border-color: #bdd6fb;
  --vz-btn-hover-color: #000;
  --vz-btn-hover-bg: #bdd6fb;
  --vz-btn-hover-border-color: #bdd6fb;
  --vz-btn-focus-shadow-rgb: 189, 214, 251;
  --vz-btn-active-color: #000;
  --vz-btn-active-bg: #bdd6fb;
  --vz-btn-active-border-color: #bdd6fb;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #bdd6fb;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #bdd6fb;
  --vz-gradient: none;
}

.btn-outline-next-button {
  --vz-btn-color: #83a9e2;
  --vz-btn-border-color: #83a9e2;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #83a9e2;
  --vz-btn-hover-border-color: #83a9e2;
  --vz-btn-focus-shadow-rgb: 131, 169, 226;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #83a9e2;
  --vz-btn-active-border-color: #83a9e2;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #83a9e2;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #83a9e2;
  --vz-gradient: none;
}

.btn-outline-next-button-border {
  --vz-btn-color: #5d87c7;
  --vz-btn-border-color: #5d87c7;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #5d87c7;
  --vz-btn-hover-border-color: #5d87c7;
  --vz-btn-focus-shadow-rgb: 93, 135, 199;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #5d87c7;
  --vz-btn-active-border-color: #5d87c7;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #5d87c7;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #5d87c7;
  --vz-gradient: none;
}

.btn-outline-next-button-hover {
  --vz-btn-color: #bdd6fa;
  --vz-btn-border-color: #bdd6fa;
  --vz-btn-hover-color: #000;
  --vz-btn-hover-bg: #bdd6fa;
  --vz-btn-hover-border-color: #bdd6fa;
  --vz-btn-focus-shadow-rgb: 189, 214, 250;
  --vz-btn-active-color: #000;
  --vz-btn-active-bg: #bdd6fa;
  --vz-btn-active-border-color: #bdd6fa;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #bdd6fa;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #bdd6fa;
  --vz-gradient: none;
}

.btn-outline-white {
  --vz-btn-color: #fff;
  --vz-btn-border-color: #fff;
  --vz-btn-hover-color: #000;
  --vz-btn-hover-bg: #fff;
  --vz-btn-hover-border-color: #fff;
  --vz-btn-focus-shadow-rgb: 255, 255, 255;
  --vz-btn-active-color: #000;
  --vz-btn-active-bg: #fff;
  --vz-btn-active-border-color: #fff;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #fff;
  --vz-gradient: none;
}

.btn-outline-light-grey {
  --vz-btn-color: #ced4da;
  --vz-btn-border-color: #ced4da;
  --vz-btn-hover-color: #000;
  --vz-btn-hover-bg: #ced4da;
  --vz-btn-hover-border-color: #ced4da;
  --vz-btn-focus-shadow-rgb: 206, 212, 218;
  --vz-btn-active-color: #000;
  --vz-btn-active-bg: #ced4da;
  --vz-btn-active-border-color: #ced4da;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #ced4da;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #ced4da;
  --vz-gradient: none;
}

.btn-link {
  --vz-btn-font-weight: 400;
  --vz-btn-color: var(--vz-link-color);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: var(--vz-link-hover-color);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-active-color: var(--vz-link-hover-color);
  --vz-btn-active-border-color: transparent;
  --vz-btn-disabled-color: #878a99;
  --vz-btn-disabled-border-color: transparent;
  --vz-btn-box-shadow: 0 0 0 #000;
  --vz-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: none;
}
.btn-link:focus-visible {
  color: var(--vz-btn-color);
}
.btn-link:hover {
  color: var(--vz-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --vz-btn-padding-y: 0.7rem;
  --vz-btn-padding-x: 1.2rem;
  --vz-btn-font-size: 1.03125rem;
  --vz-btn-border-radius: var(--vz-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --vz-btn-padding-y: 0.25rem;
  --vz-btn-padding-x: 0.5rem;
  --vz-btn-font-size: 0.721875rem;
  --vz-btn-border-radius: var(--vz-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-menu {
  --vz-dropdown-zindex: 1000;
  --vz-dropdown-min-width: 10rem;
  --vz-dropdown-padding-x: 0;
  --vz-dropdown-padding-y: 0.5rem;
  --vz-dropdown-spacer: 0.125rem;
  --vz-dropdown-font-size: 0.825rem;
  --vz-dropdown-color: var(--vz-body-color);
  --vz-dropdown-bg: var(--vz-secondary-bg);
  --vz-dropdown-border-color: var(--vz-border-color);
  --vz-dropdown-border-radius: var(--vz-border-radius-lg);
  --vz-dropdown-border-width: 0;
  --vz-dropdown-inner-border-radius: calc(
    var(--vz-border-radius-lg) - 0
  );
  --vz-dropdown-divider-bg: var(--vz-border-color);
  --vz-dropdown-divider-margin-y: 0.5rem;
  --vz-dropdown-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  --vz-dropdown-link-color: var(--vz-body-color);
  --vz-dropdown-link-hover-color: var(--vz-body-color);
  --vz-dropdown-link-hover-bg: var(--vz-tertiary-bg);
  --vz-dropdown-link-active-color: var(--vz-body-color);
  --vz-dropdown-link-active-bg: var(--vz-tertiary-bg);
  --vz-dropdown-link-disabled-color: var(--vz-tertiary-color);
  --vz-dropdown-item-padding-x: 1.2rem;
  --vz-dropdown-item-padding-y: 0.35rem;
  --vz-dropdown-header-color: #878a99;
  --vz-dropdown-header-padding-x: 1.2rem;
  --vz-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--vz-dropdown-zindex);
  display: none;
  min-width: var(--vz-dropdown-min-width);
  padding: var(--vz-dropdown-padding-y) var(--vz-dropdown-padding-x);
  margin: 0;
  font-size: var(--vz-dropdown-font-size);
  color: var(--vz-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--vz-dropdown-bg);
  background-clip: padding-box;
  border: var(--vz-dropdown-border-width) solid var(--vz-dropdown-border-color);
  border-radius: var(--vz-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--vz-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--vz-dropdown-spacer);
}
.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--vz-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--vz-dropdown-spacer);
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--vz-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--vz-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--vz-dropdown-item-padding-y) var(--vz-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--vz-dropdown-link-color);
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--vz-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--vz-dropdown-link-hover-color);
  background-color: var(--vz-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--vz-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--vz-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--vz-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--vz-dropdown-header-padding-y) var(--vz-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.721875rem;
  color: var(--vz-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--vz-dropdown-item-padding-y) var(--vz-dropdown-item-padding-x);
  color: var(--vz-dropdown-link-color);
}

.dropdown-menu-dark {
  --vz-dropdown-color: #e9ebec;
  --vz-dropdown-bg: #363d48;
  --vz-dropdown-border-color: var(--vz-border-color);
  --vz-dropdown-box-shadow: ;
  --vz-dropdown-link-color: #e9ebec;
  --vz-dropdown-link-hover-color: #fff;
  --vz-dropdown-divider-bg: var(--vz-border-color);
  --vz-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --vz-dropdown-link-active-color: var(--vz-body-color);
  --vz-dropdown-link-active-bg: var(--vz-tertiary-bg);
  --vz-dropdown-link-disabled-color: #adb5bd;
  --vz-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--vz-border-radius);
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--vz-border-width) * -1);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.675rem;
  padding-left: 0.675rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.9rem;
  padding-left: 0.9rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--vz-border-width) * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --vz-nav-link-padding-x: 1rem;
  --vz-nav-link-padding-y: 0.5rem;
  --vz-nav-link-font-weight: ;
  --vz-nav-link-color: var(--vz-dark);
  --vz-nav-link-hover-color: var(--vz-new-primary);
  --vz-nav-link-disabled-color: var(--vz-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--vz-nav-link-padding-y) var(--vz-nav-link-padding-x);
  font-size: var(--vz-nav-link-font-size);
  font-weight: var(--vz-nav-link-font-weight);
  color: var(--vz-nav-link-color);
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--vz-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 1 0.25rem rgba(var(--vz-primary-rgb), 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--vz-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --vz-nav-tabs-border-width: var(--vz-border-width);
  --vz-nav-tabs-border-color: var(--vz-new-primary);
  --vz-nav-tabs-border-radius: var(--vz-border-radius);
  --vz-nav-tabs-link-hover-border-color: var(--vz-light) var(--vz-secondary-bg) var(--vz-new-primary);
  --vz-nav-tabs-link-active-color: var(--vz-light);
  --vz-nav-tabs-link-active-bg: var(--vz-new-primary);
  --vz-nav-tabs-link-active-border-color: var(--vz-new-primary) var(--vz-border-color) var(--vz-new-primary);
  border-bottom: var(--vz-nav-tabs-border-width) solid var(--vz-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--vz-nav-tabs-border-width));
  border: var(--vz-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--vz-nav-tabs-border-radius);
  border-top-right-radius: var(--vz-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--vz-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--vz-nav-tabs-link-active-color);
  background-color: var(--vz-nav-tabs-link-active-bg);
  border-color: var(--vz-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--vz-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --vz-nav-pills-border-radius: var(--vz-border-radius);
  --vz-nav-pills-link-active-color: var(--vz-light);
  --vz-nav-pills-link-active-bg: var(--vz-custom-primary);
}
.nav-pills .nav-link {
  border-radius: var(--vz-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--vz-nav-pills-link-active-color);
  background-color: var(--vz-nav-pills-link-active-bg);
}

.nav-underline {
  --vz-nav-underline-gap: 1rem;
  --vz-nav-underline-border-width: 0.125rem;
  --vz-nav-underline-link-active-color: var(--vz-emphasis-color);
  gap: var(--vz-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--vz-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--vz-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --vz-navbar-padding-x: 0;
  --vz-navbar-padding-y: 0.5rem;
  --vz-navbar-color: rgba(var(--vz-emphasis-color-rgb), 0.65);
  --vz-navbar-hover-color: rgba(var(--vz-emphasis-color-rgb), 0.8);
  --vz-navbar-disabled-color: rgba(var(--vz-emphasis-color-rgb), 0.3);
  --vz-navbar-active-color: rgba(var(--vz-emphasis-color-rgb), 1);
  --vz-navbar-brand-padding-y: 0.3453125rem;
  --vz-navbar-brand-margin-end: 1rem;
  --vz-navbar-brand-font-size: 1.03125rem;
  --vz-navbar-brand-color: rgba(var(--vz-emphasis-color-rgb), 1);
  --vz-navbar-brand-hover-color: rgba(var(--vz-emphasis-color-rgb), 1);
  --vz-navbar-nav-link-padding-x: 0.5rem;
  --vz-navbar-toggler-padding-y: 0.25rem;
  --vz-navbar-toggler-padding-x: 0.75rem;
  --vz-navbar-toggler-font-size: 1.03125rem;
  --vz-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  --vz-navbar-toggler-border-color: rgba(var(--vz-emphasis-color-rgb), 0.15);
  --vz-navbar-toggler-border-radius: var(--vz-border-radius);
  --vz-navbar-toggler-focus-width: 0.25rem;
  --vz-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--vz-navbar-padding-y) var(--vz-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--vz-navbar-brand-padding-y);
  padding-bottom: var(--vz-navbar-brand-padding-y);
  margin-right: var(--vz-navbar-brand-margin-end);
  font-size: var(--vz-navbar-brand-font-size);
  color: var(--vz-navbar-brand-color);
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--vz-navbar-brand-hover-color);
}

.navbar-nav {
  --vz-nav-link-padding-x: 0;
  --vz-nav-link-padding-y: 0.5rem;
  --vz-nav-link-font-weight: ;
  --vz-nav-link-color: var(--vz-navbar-color);
  --vz-nav-link-hover-color: var(--vz-navbar-hover-color);
  --vz-nav-link-disabled-color: var(--vz-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--vz-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--vz-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--vz-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--vz-navbar-toggler-padding-y) var(--vz-navbar-toggler-padding-x);
  font-size: var(--vz-navbar-toggler-font-size);
  line-height: 1;
  color: var(--vz-navbar-color);
  background-color: transparent;
  border: var(--vz-border-width) solid var(--vz-navbar-toggler-border-color);
  border-radius: var(--vz-navbar-toggler-border-radius);
  transition: var(--vz-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--vz-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--vz-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--vz-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--vz-navbar-nav-link-padding-x);
    padding-left: var(--vz-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--vz-navbar-nav-link-padding-x);
    padding-left: var(--vz-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--vz-navbar-nav-link-padding-x);
    padding-left: var(--vz-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--vz-navbar-nav-link-padding-x);
    padding-left: var(--vz-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--vz-navbar-nav-link-padding-x);
    padding-left: var(--vz-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--vz-navbar-nav-link-padding-x);
  padding-left: var(--vz-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --vz-navbar-color: rgba(255, 255, 255, 0.55);
  --vz-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --vz-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --vz-navbar-active-color: #fff;
  --vz-navbar-brand-color: #fff;
  --vz-navbar-brand-hover-color: #fff;
  --vz-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --vz-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --vz-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
}

.card {
  --vz-card-spacer-y: 1rem;
  --vz-card-spacer-x: 1rem;
  --vz-card-title-spacer-y: 0.5rem;
  --vz-card-title-color: var(--vz-heading-color);
  --vz-card-subtitle-color: ;
  --vz-card-border-width: 0;
  --vz-card-border-color: var(--vz-border-color);
  --vz-card-border-radius: var(--vz-border-radius);
  --vz-card-box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  --vz-card-inner-border-radius: var(--vz-border-radius);
  --vz-card-cap-padding-y: 1rem;
  --vz-card-cap-padding-x: 1rem;
  --vz-card-cap-bg: var(--vz-secondary-bg);
  --vz-card-cap-color: ;
  --vz-card-height: ;
  --vz-card-color: ;
  --vz-card-bg: var(--vz-secondary-bg);
  --vz-card-img-overlay-padding: 1rem;
  --vz-card-group-margin: calc(1.5rem * 0.5);
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--vz-card-height);
  color: var(--vz-body-color);
  word-wrap: break-word;
  background-color: var(--vz-card-bg);
  background-clip: border-box;
  border: var(--vz-card-border-width) solid var(--vz-card-border-color);
  border-radius: var(--vz-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--vz-card-inner-border-radius);
  border-top-right-radius: var(--vz-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--vz-card-inner-border-radius);
  border-bottom-left-radius: var(--vz-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--vz-card-spacer-y) var(--vz-card-spacer-x);
  color: var(--vz-card-color);
}

.card-title {
  margin-bottom: var(--vz-card-title-spacer-y);
  color: var(--vz-card-title-color);
}

.card-subtitle {
  margin-top: calc(-.5 * var(--vz-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--vz-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--vz-card-spacer-x);
}

.card-header {
  padding: var(--vz-card-cap-padding-y) var(--vz-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--vz-card-cap-color);
  background-color: var(--vz-card-cap-bg);
  border-bottom: var(--vz-card-border-width) solid var(--vz-card-border-color);
}
.card-header:first-child {
  border-radius: var(--vz-card-inner-border-radius) var(--vz-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--vz-card-cap-padding-y) var(--vz-card-cap-padding-x);
  color: var(--vz-card-cap-color);
  background-color: var(--vz-card-cap-bg);
  border-top: var(--vz-card-border-width) solid var(--vz-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--vz-card-inner-border-radius) var(--vz-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-.5 * var(--vz-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--vz-card-cap-padding-y));
  margin-left: calc(-.5 * var(--vz-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--vz-card-bg);
  border-bottom-color: var(--vz-card-bg);
}

.card-header-pills {
  margin-right: calc(-.5 * var(--vz-card-cap-padding-x));
  margin-left: calc(-.5 * var(--vz-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--vz-card-img-overlay-padding);
  border-radius: var(--vz-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--vz-card-inner-border-radius);
  border-top-right-radius: var(--vz-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--vz-card-inner-border-radius);
  border-bottom-left-radius: var(--vz-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--vz-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
.card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
.card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
.card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
.card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --vz-accordion-color: var(--vz-body-color);
  --vz-accordion-bg: var(--vz-secondary-bg);
  --vz-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --vz-accordion-border-color: var(--vz-border-color);
  --vz-accordion-border-width: var(--vz-border-width);
  --vz-accordion-border-radius: var(--vz-border-radius);
  --vz-accordion-inner-border-radius: calc(var(--vz-border-radius) - (var(--vz-border-width)));
  --vz-accordion-btn-padding-x: 1.25rem;
  --vz-accordion-btn-padding-y: 1rem;
  --vz-accordion-btn-color: var(--vz-body-color);
  --vz-accordion-btn-bg: var(--vz-accordion-bg);
  --vz-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
  --vz-accordion-btn-icon-width: 0.75rem;
  --vz-accordion-btn-icon-transform: rotate(-180deg);
  --vz-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --vz-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
  --vz-accordion-btn-focus-box-shadow: 0 0 1 0.25rem rgba(var(--vz-primary-rgb), 0.25);
  --vz-accordion-body-padding-x: 1.25rem;
  --vz-accordion-body-padding-y: 1rem;
  --vz-accordion-active-color: var(--vz-primary-text-emphasis);
  --vz-accordion-active-bg: rgba(var(--vz-primary-rgb), 0.05);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--vz-accordion-btn-padding-y) var(--vz-accordion-btn-padding-x);
  font-size: 0.825rem;
  color: var(--vz-accordion-btn-color);
  text-align: left;
  background-color: var(--vz-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--vz-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--vz-accordion-active-color);
  background-color: var(--vz-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--vz-accordion-border-width)) 0 var(--vz-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--vz-accordion-btn-active-icon);
  transform: var(--vz-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--vz-accordion-btn-icon-width);
  height: var(--vz-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--vz-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--vz-accordion-btn-icon-width);
  transition: var(--vz-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--vz-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--vz-accordion-color);
  background-color: var(--vz-accordion-bg);
  border: var(--vz-accordion-border-width) solid var(--vz-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--vz-accordion-border-radius);
  border-top-right-radius: var(--vz-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--vz-accordion-inner-border-radius);
  border-top-right-radius: var(--vz-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--vz-accordion-border-radius);
  border-bottom-left-radius: var(--vz-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--vz-accordion-inner-border-radius);
  border-bottom-left-radius: var(--vz-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--vz-accordion-border-radius);
  border-bottom-left-radius: var(--vz-accordion-border-radius);
}

.accordion-body {
  padding: var(--vz-accordion-body-padding-y) var(--vz-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-header .accordion-button, .accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --vz-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
  --vz-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
}

.breadcrumb {
  --vz-breadcrumb-padding-x: 0;
  --vz-breadcrumb-padding-y: 0;
  --vz-breadcrumb-margin-bottom: 1rem;
  --vz-breadcrumb-bg: ;
  --vz-breadcrumb-border-radius: ;
  --vz-breadcrumb-divider-color: var(--vz-secondary-color);
  --vz-breadcrumb-item-padding-x: 0.5rem;
  --vz-breadcrumb-item-active-color: var(--vz-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--vz-breadcrumb-padding-y) var(--vz-breadcrumb-padding-x);
  margin-bottom: var(--vz-breadcrumb-margin-bottom);
  font-size: var(--vz-breadcrumb-font-size);
  list-style: none;
  background-color: var(--vz-breadcrumb-bg);
  border-radius: var(--vz-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--vz-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--vz-breadcrumb-item-padding-x);
  color: var(--vz-breadcrumb-divider-color);
  content: var(--vz-breadcrumb-divider, "󰅂") /* rtl: var(--vz-breadcrumb-divider, "󰅂") */;
}
.breadcrumb-item.active {
  color: var(--vz-breadcrumb-item-active-color);
}

.pagination {
  --vz-pagination-padding-x: 0.75rem;
  --vz-pagination-padding-y: 0.375rem;
  --vz-pagination-font-size: 0.825rem;
  --vz-pagination-color: var(--vz-link-color);
  --vz-pagination-bg: var(--vz-secondary-bg);
  --vz-pagination-border-width: var(--vz-border-width);
  --vz-pagination-border-color: var(--vz-border-color);
  --vz-pagination-border-radius: var(--vz-border-radius);
  --vz-pagination-hover-color: var(--vz-link-hover-color);
  --vz-pagination-hover-bg: var(--vz-tertiary-bg);
  --vz-pagination-hover-border-color: var(--vz-border-color);
  --vz-pagination-focus-color: var(--vz-link-hover-color);
  --vz-pagination-focus-bg: var(--vz-tertiary-bg);
  --vz-pagination-focus-box-shadow: 0 0 1 0.25rem rgba(var(--vz-primary-rgb), 0.25);
  --vz-pagination-active-color: #fff;
  --vz-pagination-active-bg: #8aaed6;
  --vz-pagination-active-border-color: #8aaed6;
  --vz-pagination-disabled-color: var(--vz-secondary-color);
  --vz-pagination-disabled-bg: var(--vz-secondary-bg);
  --vz-pagination-disabled-border-color: var(--vz-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--vz-pagination-padding-y) var(--vz-pagination-padding-x);
  font-size: var(--vz-pagination-font-size);
  color: var(--vz-pagination-color);
  background-color: var(--vz-pagination-bg);
  border: var(--vz-pagination-border-width) solid var(--vz-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--vz-pagination-hover-color);
  background-color: var(--vz-pagination-hover-bg);
  border-color: var(--vz-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--vz-pagination-focus-color);
  background-color: var(--vz-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--vz-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--vz-pagination-active-color);
  background-color: var(--vz-pagination-active-bg);
  border-color: var(--vz-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--vz-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--vz-pagination-disabled-bg);
  border-color: var(--vz-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc( var(--vz-border-width) * -1 );
}
.page-item .page-link {
  border-radius: var(--vz-pagination-border-radius);
}

.pagination-lg {
  --vz-pagination-padding-x: 1.2rem;
  --vz-pagination-padding-y: 0.6rem;
  --vz-pagination-font-size: 1.03125rem;
  --vz-pagination-border-radius: var(--vz-border-radius-lg);
}

.pagination-sm {
  --vz-pagination-padding-x: 0.5rem;
  --vz-pagination-padding-y: 0.25rem;
  --vz-pagination-font-size: 0.721875rem;
  --vz-pagination-border-radius: var(--vz-border-radius-sm);
}

.badge {
  --vz-badge-padding-x: 0.65em;
  --vz-badge-padding-y: 0.35em;
  --vz-badge-font-size: 0.75em;
  --vz-badge-font-weight: 500;
  --vz-badge-color: #fff;
  --vz-badge-border-radius: 0.25rem;
  display: inline-block;
  padding: var(--vz-badge-padding-y) var(--vz-badge-padding-x);
  font-size: var(--vz-badge-font-size);
  font-weight: var(--vz-badge-font-weight);
  line-height: 1;
  color: var(--vz-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--vz-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --vz-alert-bg: transparent;
  --vz-alert-padding-x: 1rem;
  --vz-alert-padding-y: 0.8rem;
  --vz-alert-margin-bottom: 1rem;
  --vz-alert-color: inherit;
  --vz-alert-border-color: transparent;
  --vz-alert-border: var(--vz-border-width) solid var(--vz-alert-border-color);
  --vz-alert-border-radius: var(--vz-border-radius);
  --vz-alert-link-color: inherit;
  position: relative;
  padding: var(--vz-alert-padding-y) var(--vz-alert-padding-x);
  margin-bottom: var(--vz-alert-margin-bottom);
  color: var(--vz-alert-color);
  background-color: var(--vz-alert-bg);
  border: var(--vz-alert-border);
  border-radius: var(--vz-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 500;
  color: var(--vz-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1rem 1rem;
}

.alert-primary {
  --vz-alert-color: var(--vz-primary-text-emphasis);
  --vz-alert-bg: var(--vz-primary-bg-subtle);
  --vz-alert-border-color: var(--vz-primary-border-subtle);
  --vz-alert-link-color: var(--vz-primary-text-emphasis);
}

.alert-secondary {
  --vz-alert-color: var(--vz-secondary-text-emphasis);
  --vz-alert-bg: var(--vz-secondary-bg-subtle);
  --vz-alert-border-color: var(--vz-secondary-border-subtle);
  --vz-alert-link-color: var(--vz-secondary-text-emphasis);
}

.alert-success {
  --vz-alert-color: var(--vz-success-text-emphasis);
  --vz-alert-bg: var(--vz-success-bg-subtle);
  --vz-alert-border-color: var(--vz-success-border-subtle);
  --vz-alert-link-color: var(--vz-success-text-emphasis);
}

.alert-info {
  --vz-alert-color: var(--vz-info-text-emphasis);
  --vz-alert-bg: var(--vz-info-bg-subtle);
  --vz-alert-border-color: var(--vz-info-border-subtle);
  --vz-alert-link-color: var(--vz-info-text-emphasis);
}

.alert-warning {
  --vz-alert-color: var(--vz-warning-text-emphasis);
  --vz-alert-bg: var(--vz-warning-bg-subtle);
  --vz-alert-border-color: var(--vz-warning-border-subtle);
  --vz-alert-link-color: var(--vz-warning-text-emphasis);
}

.alert-danger {
  --vz-alert-color: var(--vz-danger-text-emphasis);
  --vz-alert-bg: var(--vz-danger-bg-subtle);
  --vz-alert-border-color: var(--vz-danger-border-subtle);
  --vz-alert-link-color: var(--vz-danger-text-emphasis);
}

.alert-light {
  --vz-alert-color: var(--vz-light-text-emphasis);
  --vz-alert-bg: var(--vz-light-bg-subtle);
  --vz-alert-border-color: var(--vz-light-border-subtle);
  --vz-alert-link-color: var(--vz-light-text-emphasis);
}

.alert-dark {
  --vz-alert-color: var(--vz-dark-text-emphasis);
  --vz-alert-bg: var(--vz-dark-bg-subtle);
  --vz-alert-border-color: var(--vz-dark-border-subtle);
  --vz-alert-link-color: var(--vz-dark-text-emphasis);
}

.alert-custom-primary {
  --vz-alert-color: var(--vz-custom-primary-text-emphasis);
  --vz-alert-bg: var(--vz-custom-primary-bg-subtle);
  --vz-alert-border-color: var(--vz-custom-primary-border-subtle);
  --vz-alert-link-color: var(--vz-custom-primary-text-emphasis);
}

.alert-custom-primary-hover {
  --vz-alert-color: var(--vz-custom-primary-hover-text-emphasis);
  --vz-alert-bg: var(--vz-custom-primary-hover-bg-subtle);
  --vz-alert-border-color: var(--vz-custom-primary-hover-border-subtle);
  --vz-alert-link-color: var(--vz-custom-primary-hover-text-emphasis);
}

.alert-new-primary {
  --vz-alert-color: var(--vz-new-primary-text-emphasis);
  --vz-alert-bg: var(--vz-new-primary-bg-subtle);
  --vz-alert-border-color: var(--vz-new-primary-border-subtle);
  --vz-alert-link-color: var(--vz-new-primary-text-emphasis);
}

.alert-header {
  --vz-alert-color: var(--vz-header-text-emphasis);
  --vz-alert-bg: var(--vz-header-bg-subtle);
  --vz-alert-border-color: var(--vz-header-border-subtle);
  --vz-alert-link-color: var(--vz-header-text-emphasis);
}

.alert-next-button {
  --vz-alert-color: var(--vz-next-button-text-emphasis);
  --vz-alert-bg: var(--vz-next-button-bg-subtle);
  --vz-alert-border-color: var(--vz-next-button-border-subtle);
  --vz-alert-link-color: var(--vz-next-button-text-emphasis);
}

.alert-next-button-border {
  --vz-alert-color: var(--vz-next-button-border-text-emphasis);
  --vz-alert-bg: var(--vz-next-button-border-bg-subtle);
  --vz-alert-border-color: var(--vz-next-button-border-border-subtle);
  --vz-alert-link-color: var(--vz-next-button-border-text-emphasis);
}

.alert-next-button-hover {
  --vz-alert-color: var(--vz-next-button-hover-text-emphasis);
  --vz-alert-bg: var(--vz-next-button-hover-bg-subtle);
  --vz-alert-border-color: var(--vz-next-button-hover-border-subtle);
  --vz-alert-link-color: var(--vz-next-button-hover-text-emphasis);
}

.alert-white {
  --vz-alert-color: var(--vz-white-text-emphasis);
  --vz-alert-bg: var(--vz-white-bg-subtle);
  --vz-alert-border-color: var(--vz-white-border-subtle);
  --vz-alert-link-color: var(--vz-white-text-emphasis);
}

.alert-light-grey {
  --vz-alert-color: var(--vz-light-grey-text-emphasis);
  --vz-alert-bg: var(--vz-light-grey-bg-subtle);
  --vz-alert-border-color: var(--vz-light-grey-border-subtle);
  --vz-alert-link-color: var(--vz-light-grey-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 0.625rem;
  }
}
.progress,
.progress-stacked {
  --vz-progress-height: 0.625rem;
  --vz-progress-font-size: 0.61875rem;
  --vz-progress-bg: var(--vz-tertiary-bg);
  --vz-progress-border-radius: var(--vz-border-radius);
  --vz-progress-box-shadow: var(--vz-box-shadow-inset);
  --vz-progress-bar-color: #fff;
  --vz-progress-bar-bg: var(--vz-primary);
  --vz-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--vz-progress-height);
  overflow: hidden;
  font-size: var(--vz-progress-font-size);
  background-color: var(--vz-progress-bg);
  border-radius: var(--vz-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--vz-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--vz-progress-bar-bg);
  transition: var(--vz-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--vz-progress-height) var(--vz-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --vz-list-group-color: var(--vz-body-color);
  --vz-list-group-bg: var(--vz-secondary-bg);
  --vz-list-group-border-color: var(--vz-border-color);
  --vz-list-group-border-width: var(--vz-border-width);
  --vz-list-group-border-radius: var(--vz-border-radius);
  --vz-list-group-item-padding-x: 1rem;
  --vz-list-group-item-padding-y: 0.7rem;
  --vz-list-group-action-color: var(--vz-secondary-color);
  --vz-list-group-action-hover-color: var(--vz-emphasis-color);
  --vz-list-group-action-hover-bg: var(--vz-tertiary-bg);
  --vz-list-group-action-active-color: var(--vz-body-color);
  --vz-list-group-action-active-bg: var(--vz-secondary-bg);
  --vz-list-group-disabled-color: var(--vz-secondary-color);
  --vz-list-group-disabled-bg: var(--vz-secondary-bg);
  --vz-list-group-active-color: #fff;
  --vz-list-group-active-bg: #8aaed6;
  --vz-list-group-active-border-color: #8aaed6;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--vz-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--vz-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--vz-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--vz-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--vz-list-group-action-active-color);
  background-color: var(--vz-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--vz-list-group-item-padding-y) var(--vz-list-group-item-padding-x);
  color: var(--vz-list-group-color);
  background-color: var(--vz-list-group-bg);
  border: var(--vz-list-group-border-width) solid var(--vz-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--vz-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--vz-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--vz-list-group-active-color);
  background-color: var(--vz-list-group-active-bg);
  border-color: var(--vz-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--vz-list-group-border-width));
  border-top-width: var(--vz-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--vz-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--vz-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--vz-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--vz-list-group-border-width));
  border-left-width: var(--vz-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--vz-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--vz-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--vz-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--vz-list-group-border-width));
    border-left-width: var(--vz-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--vz-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--vz-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--vz-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--vz-list-group-border-width));
    border-left-width: var(--vz-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--vz-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--vz-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--vz-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--vz-list-group-border-width));
    border-left-width: var(--vz-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--vz-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--vz-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--vz-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--vz-list-group-border-width));
    border-left-width: var(--vz-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--vz-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--vz-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--vz-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--vz-list-group-border-width));
    border-left-width: var(--vz-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--vz-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --vz-list-group-color: var(--vz-primary-text-emphasis);
  --vz-list-group-bg: var(--vz-primary-bg-subtle);
  --vz-list-group-border-color: var(--vz-primary-border-subtle);
  --vz-list-group-action-hover-color: var(--vz-emphasis-color);
  --vz-list-group-action-hover-bg: var(--vz-primary-border-subtle);
  --vz-list-group-action-active-color: var(--vz-emphasis-color);
  --vz-list-group-action-active-bg: var(--vz-primary-border-subtle);
  --vz-list-group-active-color: var(--vz-primary-bg-subtle);
  --vz-list-group-active-bg: var(--vz-primary-text-emphasis);
  --vz-list-group-active-border-color: var(--vz-primary-text-emphasis);
}

.list-group-item-secondary {
  --vz-list-group-color: var(--vz-secondary-text-emphasis);
  --vz-list-group-bg: var(--vz-secondary-bg-subtle);
  --vz-list-group-border-color: var(--vz-secondary-border-subtle);
  --vz-list-group-action-hover-color: var(--vz-emphasis-color);
  --vz-list-group-action-hover-bg: var(--vz-secondary-border-subtle);
  --vz-list-group-action-active-color: var(--vz-emphasis-color);
  --vz-list-group-action-active-bg: var(--vz-secondary-border-subtle);
  --vz-list-group-active-color: var(--vz-secondary-bg-subtle);
  --vz-list-group-active-bg: var(--vz-secondary-text-emphasis);
  --vz-list-group-active-border-color: var(--vz-secondary-text-emphasis);
}

.list-group-item-success {
  --vz-list-group-color: var(--vz-success-text-emphasis);
  --vz-list-group-bg: var(--vz-success-bg-subtle);
  --vz-list-group-border-color: var(--vz-success-border-subtle);
  --vz-list-group-action-hover-color: var(--vz-emphasis-color);
  --vz-list-group-action-hover-bg: var(--vz-success-border-subtle);
  --vz-list-group-action-active-color: var(--vz-emphasis-color);
  --vz-list-group-action-active-bg: var(--vz-success-border-subtle);
  --vz-list-group-active-color: var(--vz-success-bg-subtle);
  --vz-list-group-active-bg: var(--vz-success-text-emphasis);
  --vz-list-group-active-border-color: var(--vz-success-text-emphasis);
}

.list-group-item-info {
  --vz-list-group-color: var(--vz-info-text-emphasis);
  --vz-list-group-bg: var(--vz-info-bg-subtle);
  --vz-list-group-border-color: var(--vz-info-border-subtle);
  --vz-list-group-action-hover-color: var(--vz-emphasis-color);
  --vz-list-group-action-hover-bg: var(--vz-info-border-subtle);
  --vz-list-group-action-active-color: var(--vz-emphasis-color);
  --vz-list-group-action-active-bg: var(--vz-info-border-subtle);
  --vz-list-group-active-color: var(--vz-info-bg-subtle);
  --vz-list-group-active-bg: var(--vz-info-text-emphasis);
  --vz-list-group-active-border-color: var(--vz-info-text-emphasis);
}

.list-group-item-warning {
  --vz-list-group-color: var(--vz-warning-text-emphasis);
  --vz-list-group-bg: var(--vz-warning-bg-subtle);
  --vz-list-group-border-color: var(--vz-warning-border-subtle);
  --vz-list-group-action-hover-color: var(--vz-emphasis-color);
  --vz-list-group-action-hover-bg: var(--vz-warning-border-subtle);
  --vz-list-group-action-active-color: var(--vz-emphasis-color);
  --vz-list-group-action-active-bg: var(--vz-warning-border-subtle);
  --vz-list-group-active-color: var(--vz-warning-bg-subtle);
  --vz-list-group-active-bg: var(--vz-warning-text-emphasis);
  --vz-list-group-active-border-color: var(--vz-warning-text-emphasis);
}

.list-group-item-danger {
  --vz-list-group-color: var(--vz-danger-text-emphasis);
  --vz-list-group-bg: var(--vz-danger-bg-subtle);
  --vz-list-group-border-color: var(--vz-danger-border-subtle);
  --vz-list-group-action-hover-color: var(--vz-emphasis-color);
  --vz-list-group-action-hover-bg: var(--vz-danger-border-subtle);
  --vz-list-group-action-active-color: var(--vz-emphasis-color);
  --vz-list-group-action-active-bg: var(--vz-danger-border-subtle);
  --vz-list-group-active-color: var(--vz-danger-bg-subtle);
  --vz-list-group-active-bg: var(--vz-danger-text-emphasis);
  --vz-list-group-active-border-color: var(--vz-danger-text-emphasis);
}

.list-group-item-light {
  --vz-list-group-color: var(--vz-light-text-emphasis);
  --vz-list-group-bg: var(--vz-light-bg-subtle);
  --vz-list-group-border-color: var(--vz-light-border-subtle);
  --vz-list-group-action-hover-color: var(--vz-emphasis-color);
  --vz-list-group-action-hover-bg: var(--vz-light-border-subtle);
  --vz-list-group-action-active-color: var(--vz-emphasis-color);
  --vz-list-group-action-active-bg: var(--vz-light-border-subtle);
  --vz-list-group-active-color: var(--vz-light-bg-subtle);
  --vz-list-group-active-bg: var(--vz-light-text-emphasis);
  --vz-list-group-active-border-color: var(--vz-light-text-emphasis);
}

.list-group-item-dark {
  --vz-list-group-color: var(--vz-dark-text-emphasis);
  --vz-list-group-bg: var(--vz-dark-bg-subtle);
  --vz-list-group-border-color: var(--vz-dark-border-subtle);
  --vz-list-group-action-hover-color: var(--vz-emphasis-color);
  --vz-list-group-action-hover-bg: var(--vz-dark-border-subtle);
  --vz-list-group-action-active-color: var(--vz-emphasis-color);
  --vz-list-group-action-active-bg: var(--vz-dark-border-subtle);
  --vz-list-group-active-color: var(--vz-dark-bg-subtle);
  --vz-list-group-active-bg: var(--vz-dark-text-emphasis);
  --vz-list-group-active-border-color: var(--vz-dark-text-emphasis);
}

.list-group-item-custom-primary {
  --vz-list-group-color: var(--vz-custom-primary-text-emphasis);
  --vz-list-group-bg: var(--vz-custom-primary-bg-subtle);
  --vz-list-group-border-color: var(--vz-custom-primary-border-subtle);
  --vz-list-group-action-hover-color: var(--vz-emphasis-color);
  --vz-list-group-action-hover-bg: var(--vz-custom-primary-border-subtle);
  --vz-list-group-action-active-color: var(--vz-emphasis-color);
  --vz-list-group-action-active-bg: var(--vz-custom-primary-border-subtle);
  --vz-list-group-active-color: var(--vz-custom-primary-bg-subtle);
  --vz-list-group-active-bg: var(--vz-custom-primary-text-emphasis);
  --vz-list-group-active-border-color: var(--vz-custom-primary-text-emphasis);
}

.list-group-item-custom-primary-hover {
  --vz-list-group-color: var(--vz-custom-primary-hover-text-emphasis);
  --vz-list-group-bg: var(--vz-custom-primary-hover-bg-subtle);
  --vz-list-group-border-color: var(--vz-custom-primary-hover-border-subtle);
  --vz-list-group-action-hover-color: var(--vz-emphasis-color);
  --vz-list-group-action-hover-bg: var(--vz-custom-primary-hover-border-subtle);
  --vz-list-group-action-active-color: var(--vz-emphasis-color);
  --vz-list-group-action-active-bg: var(--vz-custom-primary-hover-border-subtle);
  --vz-list-group-active-color: var(--vz-custom-primary-hover-bg-subtle);
  --vz-list-group-active-bg: var(--vz-custom-primary-hover-text-emphasis);
  --vz-list-group-active-border-color: var(--vz-custom-primary-hover-text-emphasis);
}

.list-group-item-new-primary {
  --vz-list-group-color: var(--vz-new-primary-text-emphasis);
  --vz-list-group-bg: var(--vz-new-primary-bg-subtle);
  --vz-list-group-border-color: var(--vz-new-primary-border-subtle);
  --vz-list-group-action-hover-color: var(--vz-emphasis-color);
  --vz-list-group-action-hover-bg: var(--vz-new-primary-border-subtle);
  --vz-list-group-action-active-color: var(--vz-emphasis-color);
  --vz-list-group-action-active-bg: var(--vz-new-primary-border-subtle);
  --vz-list-group-active-color: var(--vz-new-primary-bg-subtle);
  --vz-list-group-active-bg: var(--vz-new-primary-text-emphasis);
  --vz-list-group-active-border-color: var(--vz-new-primary-text-emphasis);
}

.list-group-item-header {
  --vz-list-group-color: var(--vz-header-text-emphasis);
  --vz-list-group-bg: var(--vz-header-bg-subtle);
  --vz-list-group-border-color: var(--vz-header-border-subtle);
  --vz-list-group-action-hover-color: var(--vz-emphasis-color);
  --vz-list-group-action-hover-bg: var(--vz-header-border-subtle);
  --vz-list-group-action-active-color: var(--vz-emphasis-color);
  --vz-list-group-action-active-bg: var(--vz-header-border-subtle);
  --vz-list-group-active-color: var(--vz-header-bg-subtle);
  --vz-list-group-active-bg: var(--vz-header-text-emphasis);
  --vz-list-group-active-border-color: var(--vz-header-text-emphasis);
}

.list-group-item-next-button {
  --vz-list-group-color: var(--vz-next-button-text-emphasis);
  --vz-list-group-bg: var(--vz-next-button-bg-subtle);
  --vz-list-group-border-color: var(--vz-next-button-border-subtle);
  --vz-list-group-action-hover-color: var(--vz-emphasis-color);
  --vz-list-group-action-hover-bg: var(--vz-next-button-border-subtle);
  --vz-list-group-action-active-color: var(--vz-emphasis-color);
  --vz-list-group-action-active-bg: var(--vz-next-button-border-subtle);
  --vz-list-group-active-color: var(--vz-next-button-bg-subtle);
  --vz-list-group-active-bg: var(--vz-next-button-text-emphasis);
  --vz-list-group-active-border-color: var(--vz-next-button-text-emphasis);
}

.list-group-item-next-button-border {
  --vz-list-group-color: var(--vz-next-button-border-text-emphasis);
  --vz-list-group-bg: var(--vz-next-button-border-bg-subtle);
  --vz-list-group-border-color: var(--vz-next-button-border-border-subtle);
  --vz-list-group-action-hover-color: var(--vz-emphasis-color);
  --vz-list-group-action-hover-bg: var(--vz-next-button-border-border-subtle);
  --vz-list-group-action-active-color: var(--vz-emphasis-color);
  --vz-list-group-action-active-bg: var(--vz-next-button-border-border-subtle);
  --vz-list-group-active-color: var(--vz-next-button-border-bg-subtle);
  --vz-list-group-active-bg: var(--vz-next-button-border-text-emphasis);
  --vz-list-group-active-border-color: var(--vz-next-button-border-text-emphasis);
}

.list-group-item-next-button-hover {
  --vz-list-group-color: var(--vz-next-button-hover-text-emphasis);
  --vz-list-group-bg: var(--vz-next-button-hover-bg-subtle);
  --vz-list-group-border-color: var(--vz-next-button-hover-border-subtle);
  --vz-list-group-action-hover-color: var(--vz-emphasis-color);
  --vz-list-group-action-hover-bg: var(--vz-next-button-hover-border-subtle);
  --vz-list-group-action-active-color: var(--vz-emphasis-color);
  --vz-list-group-action-active-bg: var(--vz-next-button-hover-border-subtle);
  --vz-list-group-active-color: var(--vz-next-button-hover-bg-subtle);
  --vz-list-group-active-bg: var(--vz-next-button-hover-text-emphasis);
  --vz-list-group-active-border-color: var(--vz-next-button-hover-text-emphasis);
}

.list-group-item-white {
  --vz-list-group-color: var(--vz-white-text-emphasis);
  --vz-list-group-bg: var(--vz-white-bg-subtle);
  --vz-list-group-border-color: var(--vz-white-border-subtle);
  --vz-list-group-action-hover-color: var(--vz-emphasis-color);
  --vz-list-group-action-hover-bg: var(--vz-white-border-subtle);
  --vz-list-group-action-active-color: var(--vz-emphasis-color);
  --vz-list-group-action-active-bg: var(--vz-white-border-subtle);
  --vz-list-group-active-color: var(--vz-white-bg-subtle);
  --vz-list-group-active-bg: var(--vz-white-text-emphasis);
  --vz-list-group-active-border-color: var(--vz-white-text-emphasis);
}

.list-group-item-light-grey {
  --vz-list-group-color: var(--vz-light-grey-text-emphasis);
  --vz-list-group-bg: var(--vz-light-grey-bg-subtle);
  --vz-list-group-border-color: var(--vz-light-grey-border-subtle);
  --vz-list-group-action-hover-color: var(--vz-emphasis-color);
  --vz-list-group-action-hover-bg: var(--vz-light-grey-border-subtle);
  --vz-list-group-action-active-color: var(--vz-emphasis-color);
  --vz-list-group-action-active-bg: var(--vz-light-grey-border-subtle);
  --vz-list-group-active-color: var(--vz-light-grey-bg-subtle);
  --vz-list-group-active-bg: var(--vz-light-grey-text-emphasis);
  --vz-list-group-active-border-color: var(--vz-light-grey-text-emphasis);
}

.btn-close {
  --vz-btn-close-color: #000;
  --vz-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
  --vz-btn-close-opacity: 0.5;
  --vz-btn-close-hover-opacity: 0.75;
  --vz-btn-close-focus-shadow: 0 0 1 0.25rem rgba(var(--vz-primary-rgb), 0.25);
  --vz-btn-close-focus-opacity: 1;
  --vz-btn-close-disabled-opacity: 0.25;
  --vz-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--vz-btn-close-color);
  background: transparent var(--vz-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: var(--vz-btn-close-opacity);
}
.btn-close:hover {
  color: var(--vz-btn-close-color);
  text-decoration: none;
  opacity: var(--vz-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--vz-btn-close-focus-shadow);
  opacity: var(--vz-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--vz-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--vz-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--vz-btn-close-white-filter);
}

.toast {
  --vz-toast-zindex: 1090;
  --vz-toast-padding-x: 0.75rem;
  --vz-toast-padding-y: 0.5rem;
  --vz-toast-spacing: 1.5rem;
  --vz-toast-max-width: 350px;
  --vz-toast-font-size: 0.875rem;
  --vz-toast-color: ;
  --vz-toast-bg: var(--vz-secondary-bg);
  --vz-toast-border-width: var(--vz-border-width);
  --vz-toast-border-color: var(--vz-border-color);
  --vz-toast-border-radius: var(--vz-border-radius);
  --vz-toast-box-shadow: var(--vz-box-shadow);
  --vz-toast-header-color: var(--vz-secondary-color);
  --vz-toast-header-bg: var(--vz-secondary-bg);
  --vz-toast-header-border-color: var(--vz-border-color);
  width: var(--vz-toast-max-width);
  max-width: 100%;
  font-size: var(--vz-toast-font-size);
  color: var(--vz-toast-color);
  pointer-events: auto;
  background-color: var(--vz-toast-bg);
  background-clip: padding-box;
  border: var(--vz-toast-border-width) solid var(--vz-toast-border-color);
  box-shadow: var(--vz-toast-box-shadow);
  border-radius: var(--vz-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --vz-toast-zindex: 1090;
  position: absolute;
  z-index: var(--vz-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--vz-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--vz-toast-padding-y) var(--vz-toast-padding-x);
  color: var(--vz-toast-header-color);
  background-color: var(--vz-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--vz-toast-border-width) solid var(--vz-toast-header-border-color);
  border-top-left-radius: calc(var(--vz-toast-border-radius) - var(--vz-toast-border-width));
  border-top-right-radius: calc(var(--vz-toast-border-radius) - var(--vz-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-.5 * var(--vz-toast-padding-x));
  margin-left: var(--vz-toast-padding-x);
}

.toast-body {
  padding: var(--vz-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --vz-modal-zindex: 1055;
  --vz-modal-width: 500px;
  --vz-modal-padding: 1.25rem;
  --vz-modal-margin: 0.5rem;
  --vz-modal-color: ;
  --vz-modal-bg: var(--vz-secondary-bg);
  --vz-modal-border-color: var(--vz-border-color);
  --vz-modal-border-width: var(--vz-border-width);
  --vz-modal-border-radius: var(--vz-border-radius-lg);
  --vz-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --vz-modal-inner-border-radius: calc(var(--vz-border-radius-lg) - (var(--vz-border-width)));
  --vz-modal-header-padding-x: 1.25rem;
  --vz-modal-header-padding-y: 1.25rem;
  --vz-modal-header-padding: 1.25rem 1.25rem;
  --vz-modal-header-border-color: var(--vz-border-color);
  --vz-modal-header-border-width: 0;
  --vz-modal-title-line-height: 1.5;
  --vz-modal-footer-gap: 0.5rem;
  --vz-modal-footer-bg: ;
  --vz-modal-footer-border-color: var(--vz-border-color);
  --vz-modal-footer-border-width: 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--vz-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--vz-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--vz-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--vz-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--vz-modal-color);
  pointer-events: auto;
  background-color: var(--vz-modal-bg);
  background-clip: padding-box;
  border: var(--vz-modal-border-width) solid var(--vz-modal-border-color);
  border-radius: var(--vz-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --vz-backdrop-zindex: 1050;
  --vz-backdrop-bg: #000;
  --vz-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--vz-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--vz-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--vz-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--vz-modal-header-padding);
  border-bottom: var(--vz-modal-header-border-width) solid var(--vz-modal-header-border-color);
  border-top-left-radius: var(--vz-modal-inner-border-radius);
  border-top-right-radius: var(--vz-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--vz-modal-header-padding-y) * .5) calc(var(--vz-modal-header-padding-x) * .5);
  margin: calc(-.5 * var(--vz-modal-header-padding-y)) calc(-.5 * var(--vz-modal-header-padding-x)) calc(-.5 * var(--vz-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--vz-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--vz-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--vz-modal-padding) - var(--vz-modal-footer-gap) * .5);
  background-color: var(--vz-modal-footer-bg);
  border-top: var(--vz-modal-footer-border-width) solid var(--vz-modal-footer-border-color);
  border-bottom-right-radius: var(--vz-modal-inner-border-radius);
  border-bottom-left-radius: var(--vz-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--vz-modal-footer-gap) * .5);
}

@media (min-width: 576px) {
  .modal {
    --vz-modal-margin: 1.75rem;
    --vz-modal-box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  }

  .modal-dialog {
    max-width: var(--vz-modal-width);
    margin-right: auto;
    margin-left: auto;
  }

  .modal-sm {
    --vz-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
.modal-xl {
    --vz-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --vz-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
.modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
.modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
.modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
.modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
.modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --vz-tooltip-zindex: 1080;
  --vz-tooltip-max-width: 200px;
  --vz-tooltip-padding-x: 0.7rem;
  --vz-tooltip-padding-y: 0.4rem;
  --vz-tooltip-margin: ;
  --vz-tooltip-font-size: 0.721875rem;
  --vz-tooltip-color: var(--vz-body-bg);
  --vz-tooltip-bg: var(--vz-emphasis-color);
  --vz-tooltip-border-radius: var(--vz-border-radius);
  --vz-tooltip-opacity: 0.9;
  --vz-tooltip-arrow-width: 0.8rem;
  --vz-tooltip-arrow-height: 0.4rem;
  z-index: var(--vz-tooltip-zindex);
  display: block;
  margin: var(--vz-tooltip-margin);
  font-family: var(--vz-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--vz-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--vz-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--vz-tooltip-arrow-width);
  height: var(--vz-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--vz-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--vz-tooltip-arrow-height) calc(var(--vz-tooltip-arrow-width) * .5) 0;
  border-top-color: var(--vz-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--vz-tooltip-arrow-height));
  width: var(--vz-tooltip-arrow-height);
  height: var(--vz-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--vz-tooltip-arrow-width) * .5) var(--vz-tooltip-arrow-height) calc(var(--vz-tooltip-arrow-width) * .5) 0;
  border-right-color: var(--vz-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--vz-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--vz-tooltip-arrow-width) * .5) var(--vz-tooltip-arrow-height);
  border-bottom-color: var(--vz-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--vz-tooltip-arrow-height));
  width: var(--vz-tooltip-arrow-height);
  height: var(--vz-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--vz-tooltip-arrow-width) * .5) 0 calc(var(--vz-tooltip-arrow-width) * .5) var(--vz-tooltip-arrow-height);
  border-left-color: var(--vz-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--vz-tooltip-max-width);
  padding: var(--vz-tooltip-padding-y) var(--vz-tooltip-padding-x);
  color: var(--vz-tooltip-color);
  text-align: center;
  background-color: var(--vz-tooltip-bg);
  border-radius: var(--vz-tooltip-border-radius);
}

.popover {
  --vz-popover-zindex: 1070;
  --vz-popover-max-width: 276px;
  --vz-popover-font-size: 0.825rem;
  --vz-popover-bg: var(--vz-secondary-bg);
  --vz-popover-border-width: var(--vz-border-width);
  --vz-popover-border-color: var(--vz-border-color);
  --vz-popover-border-radius: var(--vz-border-radius);
  --vz-popover-inner-border-radius: calc(
    var(--vz-border-radius) - var(--vz-border-width)
  );
  --vz-popover-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  --vz-popover-header-padding-x: 1rem;
  --vz-popover-header-padding-y: 0.7rem;
  --vz-popover-header-font-size: 0.825rem;
  --vz-popover-header-color: var(--vz-body-color);
  --vz-popover-header-bg: var(--vz-secondary-bg);
  --vz-popover-body-padding-x: 1rem;
  --vz-popover-body-padding-y: 1rem;
  --vz-popover-body-color: var(--vz-body-color);
  --vz-popover-arrow-width: 1rem;
  --vz-popover-arrow-height: 0.5rem;
  --vz-popover-arrow-border: var(--vz-popover-border-color);
  z-index: var(--vz-popover-zindex);
  display: block;
  max-width: var(--vz-popover-max-width);
  font-family: var(--vz-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--vz-popover-font-size);
  word-wrap: break-word;
  background-color: var(--vz-popover-bg);
  background-clip: padding-box;
  border: var(--vz-popover-border-width) solid var(--vz-popover-border-color);
  border-radius: var(--vz-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--vz-popover-arrow-width);
  height: var(--vz-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--vz-popover-arrow-height)) - var(--vz-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--vz-popover-arrow-height) calc(var(--vz-popover-arrow-width) * .5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--vz-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--vz-popover-border-width);
  border-top-color: var(--vz-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--vz-popover-arrow-height)) - var(--vz-popover-border-width));
  width: var(--vz-popover-arrow-height);
  height: var(--vz-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--vz-popover-arrow-width) * .5) var(--vz-popover-arrow-height) calc(var(--vz-popover-arrow-width) * .5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--vz-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--vz-popover-border-width);
  border-right-color: var(--vz-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--vz-popover-arrow-height)) - var(--vz-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--vz-popover-arrow-width) * .5) var(--vz-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--vz-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--vz-popover-border-width);
  border-bottom-color: var(--vz-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--vz-popover-arrow-width);
  margin-left: calc(-.5 * var(--vz-popover-arrow-width));
  content: "";
  border-bottom: var(--vz-popover-border-width) solid var(--vz-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--vz-popover-arrow-height)) - var(--vz-popover-border-width));
  width: var(--vz-popover-arrow-height);
  height: var(--vz-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--vz-popover-arrow-width) * .5) 0 calc(var(--vz-popover-arrow-width) * .5) var(--vz-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--vz-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--vz-popover-border-width);
  border-left-color: var(--vz-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--vz-popover-header-padding-y) var(--vz-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--vz-popover-header-font-size);
  color: var(--vz-popover-header-color);
  background-color: var(--vz-popover-header-bg);
  border-bottom: var(--vz-popover-border-width) solid var(--vz-popover-border-color);
  border-top-left-radius: var(--vz-popover-inner-border-radius);
  border-top-right-radius: var(--vz-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--vz-popover-body-padding-y) var(--vz-popover-body-padding-x);
  color: var(--vz-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
.carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_51___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}
.carousel-dark .carousel-caption {
  color: #000;
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,
[data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #000;
}
[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {
  color: #000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--vz-spinner-width);
  height: var(--vz-spinner-height);
  vertical-align: var(--vz-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--vz-spinner-animation-speed) linear infinite var(--vz-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --vz-spinner-width: 2rem;
  --vz-spinner-height: 2rem;
  --vz-spinner-vertical-align: -0.125em;
  --vz-spinner-border-width: 0.25em;
  --vz-spinner-animation-speed: 0.75s;
  --vz-spinner-animation-name: spinner-border;
  border: var(--vz-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --vz-spinner-width: 1rem;
  --vz-spinner-height: 1rem;
  --vz-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --vz-spinner-width: 2rem;
  --vz-spinner-height: 2rem;
  --vz-spinner-vertical-align: -0.125em;
  --vz-spinner-animation-speed: 0.75s;
  --vz-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --vz-spinner-width: 1rem;
  --vz-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
.spinner-grow {
    --vz-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --vz-offcanvas-zindex: 1045;
  --vz-offcanvas-width: 400px;
  --vz-offcanvas-height: 30vh;
  --vz-offcanvas-padding-x: 1.25rem;
  --vz-offcanvas-padding-y: 1.25rem;
  --vz-offcanvas-color: var(--vz-body-color);
  --vz-offcanvas-bg: var(--vz-secondary-bg);
  --vz-offcanvas-border-width: var(--vz-border-width);
  --vz-offcanvas-border-color: var(--vz-border-color);
  --vz-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --vz-offcanvas-transition: transform 0.3s ease-in-out;
  --vz-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--vz-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--vz-offcanvas-color);
    visibility: hidden;
    background-color: var(--vz-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--vz-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--vz-offcanvas-width);
    border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(-100%);
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--vz-offcanvas-width);
    border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(100%);
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(-100%);
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(100%);
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --vz-offcanvas-height: auto;
    --vz-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--vz-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--vz-offcanvas-color);
    visibility: hidden;
    background-color: var(--vz-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--vz-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--vz-offcanvas-width);
    border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(-100%);
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--vz-offcanvas-width);
    border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(100%);
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(-100%);
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(100%);
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --vz-offcanvas-height: auto;
    --vz-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--vz-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--vz-offcanvas-color);
    visibility: hidden;
    background-color: var(--vz-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--vz-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--vz-offcanvas-width);
    border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(-100%);
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--vz-offcanvas-width);
    border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(100%);
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(-100%);
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(100%);
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --vz-offcanvas-height: auto;
    --vz-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--vz-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--vz-offcanvas-color);
    visibility: hidden;
    background-color: var(--vz-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--vz-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--vz-offcanvas-width);
    border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(-100%);
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--vz-offcanvas-width);
    border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(100%);
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(-100%);
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(100%);
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --vz-offcanvas-height: auto;
    --vz-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--vz-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--vz-offcanvas-color);
    visibility: hidden;
    background-color: var(--vz-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--vz-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--vz-offcanvas-width);
    border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(-100%);
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--vz-offcanvas-width);
    border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(100%);
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(-100%);
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(100%);
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --vz-offcanvas-height: auto;
    --vz-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--vz-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--vz-offcanvas-color);
  visibility: hidden;
  background-color: var(--vz-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--vz-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--vz-offcanvas-width);
  border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--vz-offcanvas-width);
  border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--vz-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--vz-offcanvas-height);
  max-height: 100%;
  border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--vz-offcanvas-padding-y) var(--vz-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--vz-offcanvas-padding-y) * .5) calc(var(--vz-offcanvas-padding-x) * .5);
  margin: calc(-.5 * var(--vz-offcanvas-padding-y)) calc(-.5 * var(--vz-offcanvas-padding-x)) calc(-.5 * var(--vz-offcanvas-padding-y)) auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--vz-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--vz-offcanvas-padding-y) var(--vz-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #000 !important;
  background-color: RGBA(var(--vz-primary-rgb), var(--vz-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #000 !important;
  background-color: RGBA(var(--vz-secondary-rgb), var(--vz-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--vz-success-rgb), var(--vz-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #fff !important;
  background-color: RGBA(var(--vz-info-rgb), var(--vz-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #fff !important;
  background-color: RGBA(var(--vz-warning-rgb), var(--vz-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--vz-danger-rgb), var(--vz-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--vz-light-rgb), var(--vz-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--vz-dark-rgb), var(--vz-bg-opacity, 1)) !important;
}

.text-bg-custom-primary {
  color: #fff !important;
  background-color: RGBA(var(--vz-custom-primary-rgb), var(--vz-bg-opacity, 1)) !important;
}

.text-bg-custom-primary-hover {
  color: #000 !important;
  background-color: RGBA(var(--vz-custom-primary-hover-rgb), var(--vz-bg-opacity, 1)) !important;
}

.text-bg-new-primary {
  color: #fff !important;
  background-color: RGBA(var(--vz-new-primary-rgb), var(--vz-bg-opacity, 1)) !important;
}

.text-bg-header {
  color: #000 !important;
  background-color: RGBA(var(--vz-header-rgb), var(--vz-bg-opacity, 1)) !important;
}

.text-bg-next-button {
  color: #fff !important;
  background-color: RGBA(var(--vz-next-button-rgb), var(--vz-bg-opacity, 1)) !important;
}

.text-bg-next-button-border {
  color: #fff !important;
  background-color: RGBA(var(--vz-next-button-border-rgb), var(--vz-bg-opacity, 1)) !important;
}

.text-bg-next-button-hover {
  color: #000 !important;
  background-color: RGBA(var(--vz-next-button-hover-rgb), var(--vz-bg-opacity, 1)) !important;
}

.text-bg-white {
  color: #000 !important;
  background-color: RGBA(var(--vz-white-rgb), var(--vz-bg-opacity, 1)) !important;
}

.text-bg-light-grey {
  color: #000 !important;
  background-color: RGBA(var(--vz-light-grey-rgb), var(--vz-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--vz-primary-rgb), var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--vz-primary-rgb), var(--vz-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(195, 217, 243, var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(195, 217, 243, var(--vz-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--vz-secondary-rgb), var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--vz-secondary-rgb), var(--vz-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(225, 240, 252, var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(225, 240, 252, var(--vz-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--vz-success-rgb), var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--vz-success-rgb), var(--vz-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(15, 158, 86, var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(15, 158, 86, var(--vz-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--vz-info-rgb), var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--vz-info-rgb), var(--vz-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(64, 156, 184, var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(64, 156, 184, var(--vz-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--vz-warning-rgb), var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--vz-warning-rgb), var(--vz-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(186, 150, 66, var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(186, 150, 66, var(--vz-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--vz-danger-rgb), var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--vz-danger-rgb), var(--vz-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(190, 75, 75, var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(190, 75, 75, var(--vz-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--vz-light-rgb), var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--vz-light-rgb), var(--vz-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(245, 248, 250, var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(245, 248, 250, var(--vz-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--vz-dark-rgb), var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--vz-dark-rgb), var(--vz-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(43, 49, 58, var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(43, 49, 58, var(--vz-link-underline-opacity, 1)) !important;
}

.link-custom-primary {
  color: RGBA(var(--vz-custom-primary-rgb), var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--vz-custom-primary-rgb), var(--vz-link-underline-opacity, 1)) !important;
}
.link-custom-primary:hover, .link-custom-primary:focus {
  color: RGBA(101, 137, 185, var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(101, 137, 185, var(--vz-link-underline-opacity, 1)) !important;
}

.link-custom-primary-hover {
  color: RGBA(var(--vz-custom-primary-hover-rgb), var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--vz-custom-primary-hover-rgb), var(--vz-link-underline-opacity, 1)) !important;
}
.link-custom-primary-hover:hover, .link-custom-primary-hover:focus {
  color: RGBA(201, 221, 249, var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(201, 221, 249, var(--vz-link-underline-opacity, 1)) !important;
}

.link-new-primary {
  color: RGBA(var(--vz-new-primary-rgb), var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--vz-new-primary-rgb), var(--vz-link-underline-opacity, 1)) !important;
}
.link-new-primary:hover, .link-new-primary:focus {
  color: RGBA(8, 69, 139, var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(8, 69, 139, var(--vz-link-underline-opacity, 1)) !important;
}

.link-header {
  color: RGBA(var(--vz-header-rgb), var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--vz-header-rgb), var(--vz-link-underline-opacity, 1)) !important;
}
.link-header:hover, .link-header:focus {
  color: RGBA(202, 222, 252, var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(202, 222, 252, var(--vz-link-underline-opacity, 1)) !important;
}

.link-next-button {
  color: RGBA(var(--vz-next-button-rgb), var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--vz-next-button-rgb), var(--vz-link-underline-opacity, 1)) !important;
}
.link-next-button:hover, .link-next-button:focus {
  color: RGBA(105, 135, 181, var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(105, 135, 181, var(--vz-link-underline-opacity, 1)) !important;
}

.link-next-button-border {
  color: RGBA(var(--vz-next-button-border-rgb), var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--vz-next-button-border-rgb), var(--vz-link-underline-opacity, 1)) !important;
}
.link-next-button-border:hover, .link-next-button-border:focus {
  color: RGBA(74, 108, 159, var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(74, 108, 159, var(--vz-link-underline-opacity, 1)) !important;
}

.link-next-button-hover {
  color: RGBA(var(--vz-next-button-hover-rgb), var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--vz-next-button-hover-rgb), var(--vz-link-underline-opacity, 1)) !important;
}
.link-next-button-hover:hover, .link-next-button-hover:focus {
  color: RGBA(202, 222, 251, var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(202, 222, 251, var(--vz-link-underline-opacity, 1)) !important;
}

.link-white {
  color: RGBA(var(--vz-white-rgb), var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--vz-white-rgb), var(--vz-link-underline-opacity, 1)) !important;
}
.link-white:hover, .link-white:focus {
  color: RGBA(255, 255, 255, var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 255, 255, var(--vz-link-underline-opacity, 1)) !important;
}

.link-light-grey {
  color: RGBA(var(--vz-light-grey-rgb), var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--vz-light-grey-rgb), var(--vz-link-underline-opacity, 1)) !important;
}
.link-light-grey:hover, .link-light-grey:focus {
  color: RGBA(216, 221, 225, var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(216, 221, 225, var(--vz-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--vz-emphasis-color-rgb), var(--vz-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--vz-emphasis-color-rgb), var(--vz-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--vz-emphasis-color-rgb), var(--vz-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--vz-emphasis-color-rgb), var(--vz-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--vz-focus-ring-x, 0) var(--vz-focus-ring-y, 0) var(--vz-focus-ring-blur, 0) var(--vz-focus-ring-width) var(--vz-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--vz-link-color-rgb), var(--vz-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--vz-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--vz-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --vz-aspect-ratio: 100%;
}

.ratio-4x3 {
  --vz-aspect-ratio: calc(3 / 4 * 100%);
}

.ratio-16x9 {
  --vz-aspect-ratio: calc(9 / 16 * 100%);
}

.ratio-21x9 {
  --vz-aspect-ratio: calc(9 / 21 * 100%);
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--vz-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--vz-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--vz-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --vz-focus-ring-color: rgba(var(--vz-primary-rgb), var(--vz-focus-ring-opacity));
}

.focus-ring-secondary {
  --vz-focus-ring-color: rgba(var(--vz-secondary-rgb), var(--vz-focus-ring-opacity));
}

.focus-ring-success {
  --vz-focus-ring-color: rgba(var(--vz-success-rgb), var(--vz-focus-ring-opacity));
}

.focus-ring-info {
  --vz-focus-ring-color: rgba(var(--vz-info-rgb), var(--vz-focus-ring-opacity));
}

.focus-ring-warning {
  --vz-focus-ring-color: rgba(var(--vz-warning-rgb), var(--vz-focus-ring-opacity));
}

.focus-ring-danger {
  --vz-focus-ring-color: rgba(var(--vz-danger-rgb), var(--vz-focus-ring-opacity));
}

.focus-ring-light {
  --vz-focus-ring-color: rgba(var(--vz-light-rgb), var(--vz-focus-ring-opacity));
}

.focus-ring-dark {
  --vz-focus-ring-color: rgba(var(--vz-dark-rgb), var(--vz-focus-ring-opacity));
}

.focus-ring-custom-primary {
  --vz-focus-ring-color: rgba(var(--vz-custom-primary-rgb), var(--vz-focus-ring-opacity));
}

.focus-ring-custom-primary-hover {
  --vz-focus-ring-color: rgba(var(--vz-custom-primary-hover-rgb), var(--vz-focus-ring-opacity));
}

.focus-ring-new-primary {
  --vz-focus-ring-color: rgba(var(--vz-new-primary-rgb), var(--vz-focus-ring-opacity));
}

.focus-ring-header {
  --vz-focus-ring-color: rgba(var(--vz-header-rgb), var(--vz-focus-ring-opacity));
}

.focus-ring-next-button {
  --vz-focus-ring-color: rgba(var(--vz-next-button-rgb), var(--vz-focus-ring-opacity));
}

.focus-ring-next-button-border {
  --vz-focus-ring-color: rgba(var(--vz-next-button-border-rgb), var(--vz-focus-ring-opacity));
}

.focus-ring-next-button-hover {
  --vz-focus-ring-color: rgba(var(--vz-next-button-hover-rgb), var(--vz-focus-ring-opacity));
}

.focus-ring-white {
  --vz-focus-ring-color: rgba(var(--vz-white-rgb), var(--vz-focus-ring-opacity));
}

.focus-ring-light-grey {
  --vz-focus-ring-color: rgba(var(--vz-light-grey-rgb), var(--vz-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--vz-border-width) var(--vz-border-style) var(--vz-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--vz-border-width) var(--vz-border-style) var(--vz-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--vz-border-width) var(--vz-border-style) var(--vz-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--vz-border-width) var(--vz-border-style) var(--vz-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--vz-border-width) var(--vz-border-style) var(--vz-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-primary-rgb), var(--vz-border-opacity)) !important;
}

.border-secondary {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-secondary-rgb), var(--vz-border-opacity)) !important;
}

.border-success {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-success-rgb), var(--vz-border-opacity)) !important;
}

.border-info {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-info-rgb), var(--vz-border-opacity)) !important;
}

.border-warning {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-warning-rgb), var(--vz-border-opacity)) !important;
}

.border-danger {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-danger-rgb), var(--vz-border-opacity)) !important;
}

.border-light {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-light-rgb), var(--vz-border-opacity)) !important;
}

.border-dark {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-dark-rgb), var(--vz-border-opacity)) !important;
}

.border-custom-primary {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-custom-primary-rgb), var(--vz-border-opacity)) !important;
}

.border-custom-primary-hover {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-custom-primary-hover-rgb), var(--vz-border-opacity)) !important;
}

.border-new-primary {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-new-primary-rgb), var(--vz-border-opacity)) !important;
}

.border-header {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-header-rgb), var(--vz-border-opacity)) !important;
}

.border-next-button {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-next-button-rgb), var(--vz-border-opacity)) !important;
}

.border-next-button-border {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-next-button-border-rgb), var(--vz-border-opacity)) !important;
}

.border-next-button-hover {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-next-button-hover-rgb), var(--vz-border-opacity)) !important;
}

.border-white {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-white-rgb), var(--vz-border-opacity)) !important;
}

.border-light-grey {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-light-grey-rgb), var(--vz-border-opacity)) !important;
}

.border-black {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-black-rgb), var(--vz-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--vz-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--vz-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--vz-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--vz-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--vz-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--vz-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--vz-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--vz-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --vz-border-opacity: 0.1;
}

.border-opacity-25 {
  --vz-border-opacity: 0.25;
}

.border-opacity-50 {
  --vz-border-opacity: 0.5;
}

.border-opacity-75 {
  --vz-border-opacity: 0.75;
}

.border-opacity-100 {
  --vz-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important;
}

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important;
}

.mx-n3 {
  margin-right: -1rem !important;
  margin-left: -1rem !important;
}

.mx-n4 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important;
}

.mx-n5 {
  margin-right: -3rem !important;
  margin-left: -3rem !important;
}

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}

.my-n3 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}

.my-n4 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}

.my-n5 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important;
}

.mt-n1 {
  margin-top: -0.25rem !important;
}

.mt-n2 {
  margin-top: -0.5rem !important;
}

.mt-n3 {
  margin-top: -1rem !important;
}

.mt-n4 {
  margin-top: -1.5rem !important;
}

.mt-n5 {
  margin-top: -3rem !important;
}

.me-n1 {
  margin-right: -0.25rem !important;
}

.me-n2 {
  margin-right: -0.5rem !important;
}

.me-n3 {
  margin-right: -1rem !important;
}

.me-n4 {
  margin-right: -1.5rem !important;
}

.me-n5 {
  margin-right: -3rem !important;
}

.mb-n1 {
  margin-bottom: -0.25rem !important;
}

.mb-n2 {
  margin-bottom: -0.5rem !important;
}

.mb-n3 {
  margin-bottom: -1rem !important;
}

.mb-n4 {
  margin-bottom: -1.5rem !important;
}

.mb-n5 {
  margin-bottom: -3rem !important;
}

.ms-n1 {
  margin-left: -0.25rem !important;
}

.ms-n2 {
  margin-left: -0.5rem !important;
}

.ms-n3 {
  margin-left: -1rem !important;
}

.ms-n4 {
  margin-left: -1.5rem !important;
}

.ms-n5 {
  margin-left: -3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--vz-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.33125rem + 0.975vw) !important;
}

.fs-2 {
  font-size: calc(1.29rem + 0.48vw) !important;
}

.fs-3 {
  font-size: calc(1.269375rem + 0.2325vw) !important;
}

.fs-4 {
  font-size: 1.2375rem !important;
}

.fs-5 {
  font-size: 1.03125rem !important;
}

.fs-6 {
  font-size: 0.825rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 400 !important;
}

.fw-semibold {
  font-weight: 500 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-primary-rgb), var(--vz-text-opacity)) !important;
}

.text-secondary {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-secondary-rgb), var(--vz-text-opacity)) !important;
}

.text-success {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-success-rgb), var(--vz-text-opacity)) !important;
}

.text-info {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-info-rgb), var(--vz-text-opacity)) !important;
}

.text-warning {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-warning-rgb), var(--vz-text-opacity)) !important;
}

.text-danger {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-danger-rgb), var(--vz-text-opacity)) !important;
}

.text-light {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-light-rgb), var(--vz-text-opacity)) !important;
}

.text-dark {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-dark-rgb), var(--vz-text-opacity)) !important;
}

.text-custom-primary {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-custom-primary-rgb), var(--vz-text-opacity)) !important;
}

.text-custom-primary-hover {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-custom-primary-hover-rgb), var(--vz-text-opacity)) !important;
}

.text-new-primary {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-new-primary-rgb), var(--vz-text-opacity)) !important;
}

.text-header {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-header-rgb), var(--vz-text-opacity)) !important;
}

.text-next-button {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-next-button-rgb), var(--vz-text-opacity)) !important;
}

.text-next-button-border {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-next-button-border-rgb), var(--vz-text-opacity)) !important;
}

.text-next-button-hover {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-next-button-hover-rgb), var(--vz-text-opacity)) !important;
}

.text-white {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-white-rgb), var(--vz-text-opacity)) !important;
}

.text-light-grey {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-light-grey-rgb), var(--vz-text-opacity)) !important;
}

.text-black {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-black-rgb), var(--vz-text-opacity)) !important;
}

.text-body {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-body-color-rgb), var(--vz-text-opacity)) !important;
}

.text-muted {
  --vz-text-opacity: 1;
  color: var(--vz-secondary-color) !important;
}

.text-black-50 {
  --vz-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --vz-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --vz-text-opacity: 1;
  color: var(--vz-secondary-color) !important;
}

.text-body-tertiary {
  --vz-text-opacity: 1;
  color: var(--vz-tertiary-color) !important;
}

.text-body-emphasis {
  --vz-text-opacity: 1;
  color: var(--vz-emphasis-color) !important;
}

.text-reset {
  --vz-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --vz-text-opacity: 0.25;
}

.text-opacity-50 {
  --vz-text-opacity: 0.5;
}

.text-opacity-75 {
  --vz-text-opacity: 0.75;
}

.text-opacity-100 {
  --vz-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--vz-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--vz-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--vz-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--vz-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--vz-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--vz-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--vz-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--vz-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --vz-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --vz-link-opacity: 0.1;
}

.link-opacity-25 {
  --vz-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --vz-link-opacity: 0.25;
}

.link-opacity-50 {
  --vz-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --vz-link-opacity: 0.5;
}

.link-opacity-75 {
  --vz-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --vz-link-opacity: 0.75;
}

.link-opacity-100 {
  --vz-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --vz-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --vz-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--vz-primary-rgb), var(--vz-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --vz-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--vz-secondary-rgb), var(--vz-link-underline-opacity)) !important;
}

.link-underline-success {
  --vz-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--vz-success-rgb), var(--vz-link-underline-opacity)) !important;
}

.link-underline-info {
  --vz-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--vz-info-rgb), var(--vz-link-underline-opacity)) !important;
}

.link-underline-warning {
  --vz-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--vz-warning-rgb), var(--vz-link-underline-opacity)) !important;
}

.link-underline-danger {
  --vz-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--vz-danger-rgb), var(--vz-link-underline-opacity)) !important;
}

.link-underline-light {
  --vz-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--vz-light-rgb), var(--vz-link-underline-opacity)) !important;
}

.link-underline-dark {
  --vz-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--vz-dark-rgb), var(--vz-link-underline-opacity)) !important;
}

.link-underline-custom-primary {
  --vz-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--vz-custom-primary-rgb), var(--vz-link-underline-opacity)) !important;
}

.link-underline-custom-primary-hover {
  --vz-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--vz-custom-primary-hover-rgb), var(--vz-link-underline-opacity)) !important;
}

.link-underline-new-primary {
  --vz-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--vz-new-primary-rgb), var(--vz-link-underline-opacity)) !important;
}

.link-underline-header {
  --vz-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--vz-header-rgb), var(--vz-link-underline-opacity)) !important;
}

.link-underline-next-button {
  --vz-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--vz-next-button-rgb), var(--vz-link-underline-opacity)) !important;
}

.link-underline-next-button-border {
  --vz-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--vz-next-button-border-rgb), var(--vz-link-underline-opacity)) !important;
}

.link-underline-next-button-hover {
  --vz-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--vz-next-button-hover-rgb), var(--vz-link-underline-opacity)) !important;
}

.link-underline-white {
  --vz-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--vz-white-rgb), var(--vz-link-underline-opacity)) !important;
}

.link-underline-light-grey {
  --vz-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--vz-light-grey-rgb), var(--vz-link-underline-opacity)) !important;
}

.link-underline {
  --vz-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--vz-link-color-rgb), var(--vz-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --vz-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --vz-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --vz-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --vz-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --vz-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --vz-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --vz-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --vz-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --vz-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --vz-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --vz-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --vz-link-underline-opacity: 1;
}

.bg-primary {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-primary-rgb), var(--vz-bg-opacity)) !important;
}

.bg-secondary {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-secondary-rgb), var(--vz-bg-opacity)) !important;
}

.bg-success {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-success-rgb), var(--vz-bg-opacity)) !important;
}

.bg-info {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-info-rgb), var(--vz-bg-opacity)) !important;
}

.bg-warning {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-warning-rgb), var(--vz-bg-opacity)) !important;
}

.bg-danger {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-danger-rgb), var(--vz-bg-opacity)) !important;
}

.bg-light {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-light-rgb), var(--vz-bg-opacity)) !important;
}

.bg-dark {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-dark-rgb), var(--vz-bg-opacity)) !important;
}

.bg-custom-primary {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-custom-primary-rgb), var(--vz-bg-opacity)) !important;
}

.bg-custom-primary-hover {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-custom-primary-hover-rgb), var(--vz-bg-opacity)) !important;
}

.bg-new-primary {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-new-primary-rgb), var(--vz-bg-opacity)) !important;
}

.bg-header {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-header-rgb), var(--vz-bg-opacity)) !important;
}

.bg-next-button {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-next-button-rgb), var(--vz-bg-opacity)) !important;
}

.bg-next-button-border {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-next-button-border-rgb), var(--vz-bg-opacity)) !important;
}

.bg-next-button-hover {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-next-button-hover-rgb), var(--vz-bg-opacity)) !important;
}

.bg-white {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-white-rgb), var(--vz-bg-opacity)) !important;
}

.bg-light-grey {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-light-grey-rgb), var(--vz-bg-opacity)) !important;
}

.bg-black {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-black-rgb), var(--vz-bg-opacity)) !important;
}

.bg-body {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-body-bg-rgb), var(--vz-bg-opacity)) !important;
}

.bg-transparent {
  --vz-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-secondary-bg-rgb), var(--vz-bg-opacity)) !important;
}

.bg-body-tertiary {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-tertiary-bg-rgb), var(--vz-bg-opacity)) !important;
}

.bg-opacity-10 {
  --vz-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --vz-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --vz-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --vz-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --vz-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--vz-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--vz-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--vz-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--vz-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--vz-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--vz-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--vz-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--vz-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--vz-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--vz-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--vz-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--vz-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--vz-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--vz-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--vz-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--vz-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--vz-border-radius) !important;
  border-top-right-radius: var(--vz-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--vz-border-radius-sm) !important;
  border-top-right-radius: var(--vz-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--vz-border-radius) !important;
  border-top-right-radius: var(--vz-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--vz-border-radius-lg) !important;
  border-top-right-radius: var(--vz-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--vz-border-radius-xl) !important;
  border-top-right-radius: var(--vz-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--vz-border-radius-xxl) !important;
  border-top-right-radius: var(--vz-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--vz-border-radius-pill) !important;
  border-top-right-radius: var(--vz-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--vz-border-radius) !important;
  border-bottom-right-radius: var(--vz-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--vz-border-radius-sm) !important;
  border-bottom-right-radius: var(--vz-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--vz-border-radius) !important;
  border-bottom-right-radius: var(--vz-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--vz-border-radius-lg) !important;
  border-bottom-right-radius: var(--vz-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--vz-border-radius-xl) !important;
  border-bottom-right-radius: var(--vz-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--vz-border-radius-xxl) !important;
  border-bottom-right-radius: var(--vz-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--vz-border-radius-pill) !important;
  border-bottom-right-radius: var(--vz-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--vz-border-radius) !important;
  border-bottom-left-radius: var(--vz-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--vz-border-radius-sm) !important;
  border-bottom-left-radius: var(--vz-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--vz-border-radius) !important;
  border-bottom-left-radius: var(--vz-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--vz-border-radius-lg) !important;
  border-bottom-left-radius: var(--vz-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--vz-border-radius-xl) !important;
  border-bottom-left-radius: var(--vz-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--vz-border-radius-xxl) !important;
  border-bottom-left-radius: var(--vz-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--vz-border-radius-pill) !important;
  border-bottom-left-radius: var(--vz-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--vz-border-radius) !important;
  border-top-left-radius: var(--vz-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--vz-border-radius-sm) !important;
  border-top-left-radius: var(--vz-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--vz-border-radius) !important;
  border-top-left-radius: var(--vz-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--vz-border-radius-lg) !important;
  border-top-left-radius: var(--vz-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--vz-border-radius-xl) !important;
  border-top-left-radius: var(--vz-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--vz-border-radius-xxl) !important;
  border-top-left-radius: var(--vz-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--vz-border-radius-pill) !important;
  border-top-left-radius: var(--vz-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

.fs-10 {
  font-size: 10px !important;
}

.fs-11 {
  font-size: 11px !important;
}

.fs-12 {
  font-size: 12px !important;
}

.fs-13 {
  font-size: 13px !important;
}

.fs-14 {
  font-size: 14px !important;
}

.fs-15 {
  font-size: 15px !important;
}

.fs-16 {
  font-size: 16px !important;
}

.fs-17 {
  font-size: 17px !important;
}

.fs-18 {
  font-size: 18px !important;
}

.fs-19 {
  font-size: 19px !important;
}

.fs-20 {
  font-size: 20px !important;
}

.fs-21 {
  font-size: 21px !important;
}

.fs-22 {
  font-size: 22px !important;
}

.fs-23 {
  font-size: 23px !important;
}

.fs-24 {
  font-size: 24px !important;
}

.fs-36 {
  font-size: 36px !important;
}

.fs-48 {
  font-size: 48px !important;
}

.cursor-auto {
  cursor: auto !important;
}

.cursor-pointer {
  cursor: pointer !important;
}

.cursor-grab {
  cursor: grab !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }

  .float-sm-end {
    float: right !important;
  }

  .float-sm-none {
    float: none !important;
  }

  .object-fit-sm-contain {
    object-fit: contain !important;
  }

  .object-fit-sm-cover {
    object-fit: cover !important;
  }

  .object-fit-sm-fill {
    object-fit: fill !important;
  }

  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }

  .object-fit-sm-none {
    object-fit: none !important;
  }

  .d-sm-inline {
    display: inline !important;
  }

  .d-sm-inline-block {
    display: inline-block !important;
  }

  .d-sm-block {
    display: block !important;
  }

  .d-sm-grid {
    display: grid !important;
  }

  .d-sm-inline-grid {
    display: inline-grid !important;
  }

  .d-sm-table {
    display: table !important;
  }

  .d-sm-table-row {
    display: table-row !important;
  }

  .d-sm-table-cell {
    display: table-cell !important;
  }

  .d-sm-flex {
    display: flex !important;
  }

  .d-sm-inline-flex {
    display: inline-flex !important;
  }

  .d-sm-none {
    display: none !important;
  }

  .flex-sm-fill {
    flex: 1 1 auto !important;
  }

  .flex-sm-row {
    flex-direction: row !important;
  }

  .flex-sm-column {
    flex-direction: column !important;
  }

  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }

  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-sm-start {
    justify-content: flex-start !important;
  }

  .justify-content-sm-end {
    justify-content: flex-end !important;
  }

  .justify-content-sm-center {
    justify-content: center !important;
  }

  .justify-content-sm-between {
    justify-content: space-between !important;
  }

  .justify-content-sm-around {
    justify-content: space-around !important;
  }

  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-sm-start {
    align-items: flex-start !important;
  }

  .align-items-sm-end {
    align-items: flex-end !important;
  }

  .align-items-sm-center {
    align-items: center !important;
  }

  .align-items-sm-baseline {
    align-items: baseline !important;
  }

  .align-items-sm-stretch {
    align-items: stretch !important;
  }

  .align-content-sm-start {
    align-content: flex-start !important;
  }

  .align-content-sm-end {
    align-content: flex-end !important;
  }

  .align-content-sm-center {
    align-content: center !important;
  }

  .align-content-sm-between {
    align-content: space-between !important;
  }

  .align-content-sm-around {
    align-content: space-around !important;
  }

  .align-content-sm-stretch {
    align-content: stretch !important;
  }

  .align-self-sm-auto {
    align-self: auto !important;
  }

  .align-self-sm-start {
    align-self: flex-start !important;
  }

  .align-self-sm-end {
    align-self: flex-end !important;
  }

  .align-self-sm-center {
    align-self: center !important;
  }

  .align-self-sm-baseline {
    align-self: baseline !important;
  }

  .align-self-sm-stretch {
    align-self: stretch !important;
  }

  .order-sm-first {
    order: -1 !important;
  }

  .order-sm-0 {
    order: 0 !important;
  }

  .order-sm-1 {
    order: 1 !important;
  }

  .order-sm-2 {
    order: 2 !important;
  }

  .order-sm-3 {
    order: 3 !important;
  }

  .order-sm-4 {
    order: 4 !important;
  }

  .order-sm-5 {
    order: 5 !important;
  }

  .order-sm-last {
    order: 6 !important;
  }

  .m-sm-0 {
    margin: 0 !important;
  }

  .m-sm-1 {
    margin: 0.25rem !important;
  }

  .m-sm-2 {
    margin: 0.5rem !important;
  }

  .m-sm-3 {
    margin: 1rem !important;
  }

  .m-sm-4 {
    margin: 1.5rem !important;
  }

  .m-sm-5 {
    margin: 3rem !important;
  }

  .m-sm-auto {
    margin: auto !important;
  }

  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-sm-0 {
    margin-top: 0 !important;
  }

  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }

  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }

  .mt-sm-3 {
    margin-top: 1rem !important;
  }

  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }

  .mt-sm-5 {
    margin-top: 3rem !important;
  }

  .mt-sm-auto {
    margin-top: auto !important;
  }

  .me-sm-0 {
    margin-right: 0 !important;
  }

  .me-sm-1 {
    margin-right: 0.25rem !important;
  }

  .me-sm-2 {
    margin-right: 0.5rem !important;
  }

  .me-sm-3 {
    margin-right: 1rem !important;
  }

  .me-sm-4 {
    margin-right: 1.5rem !important;
  }

  .me-sm-5 {
    margin-right: 3rem !important;
  }

  .me-sm-auto {
    margin-right: auto !important;
  }

  .mb-sm-0 {
    margin-bottom: 0 !important;
  }

  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }

  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }

  .mb-sm-auto {
    margin-bottom: auto !important;
  }

  .ms-sm-0 {
    margin-left: 0 !important;
  }

  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }

  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }

  .ms-sm-3 {
    margin-left: 1rem !important;
  }

  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }

  .ms-sm-5 {
    margin-left: 3rem !important;
  }

  .ms-sm-auto {
    margin-left: auto !important;
  }

  .m-sm-n1 {
    margin: -0.25rem !important;
  }

  .m-sm-n2 {
    margin: -0.5rem !important;
  }

  .m-sm-n3 {
    margin: -1rem !important;
  }

  .m-sm-n4 {
    margin: -1.5rem !important;
  }

  .m-sm-n5 {
    margin: -3rem !important;
  }

  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-sm-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-sm-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-sm-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-sm-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-sm-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-sm-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .mt-sm-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-sm-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-sm-n3 {
    margin-top: -1rem !important;
  }

  .mt-sm-n4 {
    margin-top: -1.5rem !important;
  }

  .mt-sm-n5 {
    margin-top: -3rem !important;
  }

  .me-sm-n1 {
    margin-right: -0.25rem !important;
  }

  .me-sm-n2 {
    margin-right: -0.5rem !important;
  }

  .me-sm-n3 {
    margin-right: -1rem !important;
  }

  .me-sm-n4 {
    margin-right: -1.5rem !important;
  }

  .me-sm-n5 {
    margin-right: -3rem !important;
  }

  .mb-sm-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-sm-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-sm-n3 {
    margin-bottom: -1rem !important;
  }

  .mb-sm-n4 {
    margin-bottom: -1.5rem !important;
  }

  .mb-sm-n5 {
    margin-bottom: -3rem !important;
  }

  .ms-sm-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-sm-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-sm-n3 {
    margin-left: -1rem !important;
  }

  .ms-sm-n4 {
    margin-left: -1.5rem !important;
  }

  .ms-sm-n5 {
    margin-left: -3rem !important;
  }

  .p-sm-0 {
    padding: 0 !important;
  }

  .p-sm-1 {
    padding: 0.25rem !important;
  }

  .p-sm-2 {
    padding: 0.5rem !important;
  }

  .p-sm-3 {
    padding: 1rem !important;
  }

  .p-sm-4 {
    padding: 1.5rem !important;
  }

  .p-sm-5 {
    padding: 3rem !important;
  }

  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .pt-sm-0 {
    padding-top: 0 !important;
  }

  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }

  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }

  .pt-sm-3 {
    padding-top: 1rem !important;
  }

  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }

  .pt-sm-5 {
    padding-top: 3rem !important;
  }

  .pe-sm-0 {
    padding-right: 0 !important;
  }

  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }

  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }

  .pe-sm-3 {
    padding-right: 1rem !important;
  }

  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }

  .pe-sm-5 {
    padding-right: 3rem !important;
  }

  .pb-sm-0 {
    padding-bottom: 0 !important;
  }

  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }

  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }

  .ps-sm-0 {
    padding-left: 0 !important;
  }

  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }

  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }

  .ps-sm-3 {
    padding-left: 1rem !important;
  }

  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }

  .ps-sm-5 {
    padding-left: 3rem !important;
  }

  .gap-sm-0 {
    gap: 0 !important;
  }

  .gap-sm-1 {
    gap: 0.25rem !important;
  }

  .gap-sm-2 {
    gap: 0.5rem !important;
  }

  .gap-sm-3 {
    gap: 1rem !important;
  }

  .gap-sm-4 {
    gap: 1.5rem !important;
  }

  .gap-sm-5 {
    gap: 3rem !important;
  }

  .row-gap-sm-0 {
    row-gap: 0 !important;
  }

  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }

  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }

  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }

  .column-gap-sm-0 {
    column-gap: 0 !important;
  }

  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }

  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }

  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }

  .text-sm-start {
    text-align: left !important;
  }

  .text-sm-end {
    text-align: right !important;
  }

  .text-sm-center {
    text-align: center !important;
  }

  .cursor-sm-auto {
    cursor: auto !important;
  }

  .cursor-sm-pointer {
    cursor: pointer !important;
  }

  .cursor-sm-grab {
    cursor: grab !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }

  .float-md-end {
    float: right !important;
  }

  .float-md-none {
    float: none !important;
  }

  .object-fit-md-contain {
    object-fit: contain !important;
  }

  .object-fit-md-cover {
    object-fit: cover !important;
  }

  .object-fit-md-fill {
    object-fit: fill !important;
  }

  .object-fit-md-scale {
    object-fit: scale-down !important;
  }

  .object-fit-md-none {
    object-fit: none !important;
  }

  .d-md-inline {
    display: inline !important;
  }

  .d-md-inline-block {
    display: inline-block !important;
  }

  .d-md-block {
    display: block !important;
  }

  .d-md-grid {
    display: grid !important;
  }

  .d-md-inline-grid {
    display: inline-grid !important;
  }

  .d-md-table {
    display: table !important;
  }

  .d-md-table-row {
    display: table-row !important;
  }

  .d-md-table-cell {
    display: table-cell !important;
  }

  .d-md-flex {
    display: flex !important;
  }

  .d-md-inline-flex {
    display: inline-flex !important;
  }

  .d-md-none {
    display: none !important;
  }

  .flex-md-fill {
    flex: 1 1 auto !important;
  }

  .flex-md-row {
    flex-direction: row !important;
  }

  .flex-md-column {
    flex-direction: column !important;
  }

  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-md-wrap {
    flex-wrap: wrap !important;
  }

  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-md-start {
    justify-content: flex-start !important;
  }

  .justify-content-md-end {
    justify-content: flex-end !important;
  }

  .justify-content-md-center {
    justify-content: center !important;
  }

  .justify-content-md-between {
    justify-content: space-between !important;
  }

  .justify-content-md-around {
    justify-content: space-around !important;
  }

  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-md-start {
    align-items: flex-start !important;
  }

  .align-items-md-end {
    align-items: flex-end !important;
  }

  .align-items-md-center {
    align-items: center !important;
  }

  .align-items-md-baseline {
    align-items: baseline !important;
  }

  .align-items-md-stretch {
    align-items: stretch !important;
  }

  .align-content-md-start {
    align-content: flex-start !important;
  }

  .align-content-md-end {
    align-content: flex-end !important;
  }

  .align-content-md-center {
    align-content: center !important;
  }

  .align-content-md-between {
    align-content: space-between !important;
  }

  .align-content-md-around {
    align-content: space-around !important;
  }

  .align-content-md-stretch {
    align-content: stretch !important;
  }

  .align-self-md-auto {
    align-self: auto !important;
  }

  .align-self-md-start {
    align-self: flex-start !important;
  }

  .align-self-md-end {
    align-self: flex-end !important;
  }

  .align-self-md-center {
    align-self: center !important;
  }

  .align-self-md-baseline {
    align-self: baseline !important;
  }

  .align-self-md-stretch {
    align-self: stretch !important;
  }

  .order-md-first {
    order: -1 !important;
  }

  .order-md-0 {
    order: 0 !important;
  }

  .order-md-1 {
    order: 1 !important;
  }

  .order-md-2 {
    order: 2 !important;
  }

  .order-md-3 {
    order: 3 !important;
  }

  .order-md-4 {
    order: 4 !important;
  }

  .order-md-5 {
    order: 5 !important;
  }

  .order-md-last {
    order: 6 !important;
  }

  .m-md-0 {
    margin: 0 !important;
  }

  .m-md-1 {
    margin: 0.25rem !important;
  }

  .m-md-2 {
    margin: 0.5rem !important;
  }

  .m-md-3 {
    margin: 1rem !important;
  }

  .m-md-4 {
    margin: 1.5rem !important;
  }

  .m-md-5 {
    margin: 3rem !important;
  }

  .m-md-auto {
    margin: auto !important;
  }

  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-md-0 {
    margin-top: 0 !important;
  }

  .mt-md-1 {
    margin-top: 0.25rem !important;
  }

  .mt-md-2 {
    margin-top: 0.5rem !important;
  }

  .mt-md-3 {
    margin-top: 1rem !important;
  }

  .mt-md-4 {
    margin-top: 1.5rem !important;
  }

  .mt-md-5 {
    margin-top: 3rem !important;
  }

  .mt-md-auto {
    margin-top: auto !important;
  }

  .me-md-0 {
    margin-right: 0 !important;
  }

  .me-md-1 {
    margin-right: 0.25rem !important;
  }

  .me-md-2 {
    margin-right: 0.5rem !important;
  }

  .me-md-3 {
    margin-right: 1rem !important;
  }

  .me-md-4 {
    margin-right: 1.5rem !important;
  }

  .me-md-5 {
    margin-right: 3rem !important;
  }

  .me-md-auto {
    margin-right: auto !important;
  }

  .mb-md-0 {
    margin-bottom: 0 !important;
  }

  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-md-3 {
    margin-bottom: 1rem !important;
  }

  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-md-5 {
    margin-bottom: 3rem !important;
  }

  .mb-md-auto {
    margin-bottom: auto !important;
  }

  .ms-md-0 {
    margin-left: 0 !important;
  }

  .ms-md-1 {
    margin-left: 0.25rem !important;
  }

  .ms-md-2 {
    margin-left: 0.5rem !important;
  }

  .ms-md-3 {
    margin-left: 1rem !important;
  }

  .ms-md-4 {
    margin-left: 1.5rem !important;
  }

  .ms-md-5 {
    margin-left: 3rem !important;
  }

  .ms-md-auto {
    margin-left: auto !important;
  }

  .m-md-n1 {
    margin: -0.25rem !important;
  }

  .m-md-n2 {
    margin: -0.5rem !important;
  }

  .m-md-n3 {
    margin: -1rem !important;
  }

  .m-md-n4 {
    margin: -1.5rem !important;
  }

  .m-md-n5 {
    margin: -3rem !important;
  }

  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-md-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-md-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-md-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-md-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-md-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-md-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .mt-md-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-md-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-md-n3 {
    margin-top: -1rem !important;
  }

  .mt-md-n4 {
    margin-top: -1.5rem !important;
  }

  .mt-md-n5 {
    margin-top: -3rem !important;
  }

  .me-md-n1 {
    margin-right: -0.25rem !important;
  }

  .me-md-n2 {
    margin-right: -0.5rem !important;
  }

  .me-md-n3 {
    margin-right: -1rem !important;
  }

  .me-md-n4 {
    margin-right: -1.5rem !important;
  }

  .me-md-n5 {
    margin-right: -3rem !important;
  }

  .mb-md-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-md-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-md-n3 {
    margin-bottom: -1rem !important;
  }

  .mb-md-n4 {
    margin-bottom: -1.5rem !important;
  }

  .mb-md-n5 {
    margin-bottom: -3rem !important;
  }

  .ms-md-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-md-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-md-n3 {
    margin-left: -1rem !important;
  }

  .ms-md-n4 {
    margin-left: -1.5rem !important;
  }

  .ms-md-n5 {
    margin-left: -3rem !important;
  }

  .p-md-0 {
    padding: 0 !important;
  }

  .p-md-1 {
    padding: 0.25rem !important;
  }

  .p-md-2 {
    padding: 0.5rem !important;
  }

  .p-md-3 {
    padding: 1rem !important;
  }

  .p-md-4 {
    padding: 1.5rem !important;
  }

  .p-md-5 {
    padding: 3rem !important;
  }

  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .pt-md-0 {
    padding-top: 0 !important;
  }

  .pt-md-1 {
    padding-top: 0.25rem !important;
  }

  .pt-md-2 {
    padding-top: 0.5rem !important;
  }

  .pt-md-3 {
    padding-top: 1rem !important;
  }

  .pt-md-4 {
    padding-top: 1.5rem !important;
  }

  .pt-md-5 {
    padding-top: 3rem !important;
  }

  .pe-md-0 {
    padding-right: 0 !important;
  }

  .pe-md-1 {
    padding-right: 0.25rem !important;
  }

  .pe-md-2 {
    padding-right: 0.5rem !important;
  }

  .pe-md-3 {
    padding-right: 1rem !important;
  }

  .pe-md-4 {
    padding-right: 1.5rem !important;
  }

  .pe-md-5 {
    padding-right: 3rem !important;
  }

  .pb-md-0 {
    padding-bottom: 0 !important;
  }

  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-md-3 {
    padding-bottom: 1rem !important;
  }

  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-md-5 {
    padding-bottom: 3rem !important;
  }

  .ps-md-0 {
    padding-left: 0 !important;
  }

  .ps-md-1 {
    padding-left: 0.25rem !important;
  }

  .ps-md-2 {
    padding-left: 0.5rem !important;
  }

  .ps-md-3 {
    padding-left: 1rem !important;
  }

  .ps-md-4 {
    padding-left: 1.5rem !important;
  }

  .ps-md-5 {
    padding-left: 3rem !important;
  }

  .gap-md-0 {
    gap: 0 !important;
  }

  .gap-md-1 {
    gap: 0.25rem !important;
  }

  .gap-md-2 {
    gap: 0.5rem !important;
  }

  .gap-md-3 {
    gap: 1rem !important;
  }

  .gap-md-4 {
    gap: 1.5rem !important;
  }

  .gap-md-5 {
    gap: 3rem !important;
  }

  .row-gap-md-0 {
    row-gap: 0 !important;
  }

  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-md-3 {
    row-gap: 1rem !important;
  }

  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }

  .row-gap-md-5 {
    row-gap: 3rem !important;
  }

  .column-gap-md-0 {
    column-gap: 0 !important;
  }

  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-md-3 {
    column-gap: 1rem !important;
  }

  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }

  .column-gap-md-5 {
    column-gap: 3rem !important;
  }

  .text-md-start {
    text-align: left !important;
  }

  .text-md-end {
    text-align: right !important;
  }

  .text-md-center {
    text-align: center !important;
  }

  .cursor-md-auto {
    cursor: auto !important;
  }

  .cursor-md-pointer {
    cursor: pointer !important;
  }

  .cursor-md-grab {
    cursor: grab !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }

  .float-lg-end {
    float: right !important;
  }

  .float-lg-none {
    float: none !important;
  }

  .object-fit-lg-contain {
    object-fit: contain !important;
  }

  .object-fit-lg-cover {
    object-fit: cover !important;
  }

  .object-fit-lg-fill {
    object-fit: fill !important;
  }

  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }

  .object-fit-lg-none {
    object-fit: none !important;
  }

  .d-lg-inline {
    display: inline !important;
  }

  .d-lg-inline-block {
    display: inline-block !important;
  }

  .d-lg-block {
    display: block !important;
  }

  .d-lg-grid {
    display: grid !important;
  }

  .d-lg-inline-grid {
    display: inline-grid !important;
  }

  .d-lg-table {
    display: table !important;
  }

  .d-lg-table-row {
    display: table-row !important;
  }

  .d-lg-table-cell {
    display: table-cell !important;
  }

  .d-lg-flex {
    display: flex !important;
  }

  .d-lg-inline-flex {
    display: inline-flex !important;
  }

  .d-lg-none {
    display: none !important;
  }

  .flex-lg-fill {
    flex: 1 1 auto !important;
  }

  .flex-lg-row {
    flex-direction: row !important;
  }

  .flex-lg-column {
    flex-direction: column !important;
  }

  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }

  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-lg-start {
    justify-content: flex-start !important;
  }

  .justify-content-lg-end {
    justify-content: flex-end !important;
  }

  .justify-content-lg-center {
    justify-content: center !important;
  }

  .justify-content-lg-between {
    justify-content: space-between !important;
  }

  .justify-content-lg-around {
    justify-content: space-around !important;
  }

  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-lg-start {
    align-items: flex-start !important;
  }

  .align-items-lg-end {
    align-items: flex-end !important;
  }

  .align-items-lg-center {
    align-items: center !important;
  }

  .align-items-lg-baseline {
    align-items: baseline !important;
  }

  .align-items-lg-stretch {
    align-items: stretch !important;
  }

  .align-content-lg-start {
    align-content: flex-start !important;
  }

  .align-content-lg-end {
    align-content: flex-end !important;
  }

  .align-content-lg-center {
    align-content: center !important;
  }

  .align-content-lg-between {
    align-content: space-between !important;
  }

  .align-content-lg-around {
    align-content: space-around !important;
  }

  .align-content-lg-stretch {
    align-content: stretch !important;
  }

  .align-self-lg-auto {
    align-self: auto !important;
  }

  .align-self-lg-start {
    align-self: flex-start !important;
  }

  .align-self-lg-end {
    align-self: flex-end !important;
  }

  .align-self-lg-center {
    align-self: center !important;
  }

  .align-self-lg-baseline {
    align-self: baseline !important;
  }

  .align-self-lg-stretch {
    align-self: stretch !important;
  }

  .order-lg-first {
    order: -1 !important;
  }

  .order-lg-0 {
    order: 0 !important;
  }

  .order-lg-1 {
    order: 1 !important;
  }

  .order-lg-2 {
    order: 2 !important;
  }

  .order-lg-3 {
    order: 3 !important;
  }

  .order-lg-4 {
    order: 4 !important;
  }

  .order-lg-5 {
    order: 5 !important;
  }

  .order-lg-last {
    order: 6 !important;
  }

  .m-lg-0 {
    margin: 0 !important;
  }

  .m-lg-1 {
    margin: 0.25rem !important;
  }

  .m-lg-2 {
    margin: 0.5rem !important;
  }

  .m-lg-3 {
    margin: 1rem !important;
  }

  .m-lg-4 {
    margin: 1.5rem !important;
  }

  .m-lg-5 {
    margin: 3rem !important;
  }

  .m-lg-auto {
    margin: auto !important;
  }

  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-lg-0 {
    margin-top: 0 !important;
  }

  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }

  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }

  .mt-lg-3 {
    margin-top: 1rem !important;
  }

  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }

  .mt-lg-5 {
    margin-top: 3rem !important;
  }

  .mt-lg-auto {
    margin-top: auto !important;
  }

  .me-lg-0 {
    margin-right: 0 !important;
  }

  .me-lg-1 {
    margin-right: 0.25rem !important;
  }

  .me-lg-2 {
    margin-right: 0.5rem !important;
  }

  .me-lg-3 {
    margin-right: 1rem !important;
  }

  .me-lg-4 {
    margin-right: 1.5rem !important;
  }

  .me-lg-5 {
    margin-right: 3rem !important;
  }

  .me-lg-auto {
    margin-right: auto !important;
  }

  .mb-lg-0 {
    margin-bottom: 0 !important;
  }

  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }

  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }

  .mb-lg-auto {
    margin-bottom: auto !important;
  }

  .ms-lg-0 {
    margin-left: 0 !important;
  }

  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }

  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }

  .ms-lg-3 {
    margin-left: 1rem !important;
  }

  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }

  .ms-lg-5 {
    margin-left: 3rem !important;
  }

  .ms-lg-auto {
    margin-left: auto !important;
  }

  .m-lg-n1 {
    margin: -0.25rem !important;
  }

  .m-lg-n2 {
    margin: -0.5rem !important;
  }

  .m-lg-n3 {
    margin: -1rem !important;
  }

  .m-lg-n4 {
    margin: -1.5rem !important;
  }

  .m-lg-n5 {
    margin: -3rem !important;
  }

  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-lg-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-lg-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-lg-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-lg-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-lg-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-lg-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .mt-lg-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-lg-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-lg-n3 {
    margin-top: -1rem !important;
  }

  .mt-lg-n4 {
    margin-top: -1.5rem !important;
  }

  .mt-lg-n5 {
    margin-top: -3rem !important;
  }

  .me-lg-n1 {
    margin-right: -0.25rem !important;
  }

  .me-lg-n2 {
    margin-right: -0.5rem !important;
  }

  .me-lg-n3 {
    margin-right: -1rem !important;
  }

  .me-lg-n4 {
    margin-right: -1.5rem !important;
  }

  .me-lg-n5 {
    margin-right: -3rem !important;
  }

  .mb-lg-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-lg-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-lg-n3 {
    margin-bottom: -1rem !important;
  }

  .mb-lg-n4 {
    margin-bottom: -1.5rem !important;
  }

  .mb-lg-n5 {
    margin-bottom: -3rem !important;
  }

  .ms-lg-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-lg-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-lg-n3 {
    margin-left: -1rem !important;
  }

  .ms-lg-n4 {
    margin-left: -1.5rem !important;
  }

  .ms-lg-n5 {
    margin-left: -3rem !important;
  }

  .p-lg-0 {
    padding: 0 !important;
  }

  .p-lg-1 {
    padding: 0.25rem !important;
  }

  .p-lg-2 {
    padding: 0.5rem !important;
  }

  .p-lg-3 {
    padding: 1rem !important;
  }

  .p-lg-4 {
    padding: 1.5rem !important;
  }

  .p-lg-5 {
    padding: 3rem !important;
  }

  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .pt-lg-0 {
    padding-top: 0 !important;
  }

  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }

  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }

  .pt-lg-3 {
    padding-top: 1rem !important;
  }

  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }

  .pt-lg-5 {
    padding-top: 3rem !important;
  }

  .pe-lg-0 {
    padding-right: 0 !important;
  }

  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }

  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }

  .pe-lg-3 {
    padding-right: 1rem !important;
  }

  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }

  .pe-lg-5 {
    padding-right: 3rem !important;
  }

  .pb-lg-0 {
    padding-bottom: 0 !important;
  }

  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }

  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }

  .ps-lg-0 {
    padding-left: 0 !important;
  }

  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }

  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }

  .ps-lg-3 {
    padding-left: 1rem !important;
  }

  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }

  .ps-lg-5 {
    padding-left: 3rem !important;
  }

  .gap-lg-0 {
    gap: 0 !important;
  }

  .gap-lg-1 {
    gap: 0.25rem !important;
  }

  .gap-lg-2 {
    gap: 0.5rem !important;
  }

  .gap-lg-3 {
    gap: 1rem !important;
  }

  .gap-lg-4 {
    gap: 1.5rem !important;
  }

  .gap-lg-5 {
    gap: 3rem !important;
  }

  .row-gap-lg-0 {
    row-gap: 0 !important;
  }

  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }

  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }

  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }

  .column-gap-lg-0 {
    column-gap: 0 !important;
  }

  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }

  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }

  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }

  .text-lg-start {
    text-align: left !important;
  }

  .text-lg-end {
    text-align: right !important;
  }

  .text-lg-center {
    text-align: center !important;
  }

  .cursor-lg-auto {
    cursor: auto !important;
  }

  .cursor-lg-pointer {
    cursor: pointer !important;
  }

  .cursor-lg-grab {
    cursor: grab !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }

  .float-xl-end {
    float: right !important;
  }

  .float-xl-none {
    float: none !important;
  }

  .object-fit-xl-contain {
    object-fit: contain !important;
  }

  .object-fit-xl-cover {
    object-fit: cover !important;
  }

  .object-fit-xl-fill {
    object-fit: fill !important;
  }

  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }

  .object-fit-xl-none {
    object-fit: none !important;
  }

  .d-xl-inline {
    display: inline !important;
  }

  .d-xl-inline-block {
    display: inline-block !important;
  }

  .d-xl-block {
    display: block !important;
  }

  .d-xl-grid {
    display: grid !important;
  }

  .d-xl-inline-grid {
    display: inline-grid !important;
  }

  .d-xl-table {
    display: table !important;
  }

  .d-xl-table-row {
    display: table-row !important;
  }

  .d-xl-table-cell {
    display: table-cell !important;
  }

  .d-xl-flex {
    display: flex !important;
  }

  .d-xl-inline-flex {
    display: inline-flex !important;
  }

  .d-xl-none {
    display: none !important;
  }

  .flex-xl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xl-row {
    flex-direction: row !important;
  }

  .flex-xl-column {
    flex-direction: column !important;
  }

  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-xl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xl-center {
    justify-content: center !important;
  }

  .justify-content-xl-between {
    justify-content: space-between !important;
  }

  .justify-content-xl-around {
    justify-content: space-around !important;
  }

  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-xl-start {
    align-items: flex-start !important;
  }

  .align-items-xl-end {
    align-items: flex-end !important;
  }

  .align-items-xl-center {
    align-items: center !important;
  }

  .align-items-xl-baseline {
    align-items: baseline !important;
  }

  .align-items-xl-stretch {
    align-items: stretch !important;
  }

  .align-content-xl-start {
    align-content: flex-start !important;
  }

  .align-content-xl-end {
    align-content: flex-end !important;
  }

  .align-content-xl-center {
    align-content: center !important;
  }

  .align-content-xl-between {
    align-content: space-between !important;
  }

  .align-content-xl-around {
    align-content: space-around !important;
  }

  .align-content-xl-stretch {
    align-content: stretch !important;
  }

  .align-self-xl-auto {
    align-self: auto !important;
  }

  .align-self-xl-start {
    align-self: flex-start !important;
  }

  .align-self-xl-end {
    align-self: flex-end !important;
  }

  .align-self-xl-center {
    align-self: center !important;
  }

  .align-self-xl-baseline {
    align-self: baseline !important;
  }

  .align-self-xl-stretch {
    align-self: stretch !important;
  }

  .order-xl-first {
    order: -1 !important;
  }

  .order-xl-0 {
    order: 0 !important;
  }

  .order-xl-1 {
    order: 1 !important;
  }

  .order-xl-2 {
    order: 2 !important;
  }

  .order-xl-3 {
    order: 3 !important;
  }

  .order-xl-4 {
    order: 4 !important;
  }

  .order-xl-5 {
    order: 5 !important;
  }

  .order-xl-last {
    order: 6 !important;
  }

  .m-xl-0 {
    margin: 0 !important;
  }

  .m-xl-1 {
    margin: 0.25rem !important;
  }

  .m-xl-2 {
    margin: 0.5rem !important;
  }

  .m-xl-3 {
    margin: 1rem !important;
  }

  .m-xl-4 {
    margin: 1.5rem !important;
  }

  .m-xl-5 {
    margin: 3rem !important;
  }

  .m-xl-auto {
    margin: auto !important;
  }

  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-xl-0 {
    margin-top: 0 !important;
  }

  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }

  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }

  .mt-xl-3 {
    margin-top: 1rem !important;
  }

  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }

  .mt-xl-5 {
    margin-top: 3rem !important;
  }

  .mt-xl-auto {
    margin-top: auto !important;
  }

  .me-xl-0 {
    margin-right: 0 !important;
  }

  .me-xl-1 {
    margin-right: 0.25rem !important;
  }

  .me-xl-2 {
    margin-right: 0.5rem !important;
  }

  .me-xl-3 {
    margin-right: 1rem !important;
  }

  .me-xl-4 {
    margin-right: 1.5rem !important;
  }

  .me-xl-5 {
    margin-right: 3rem !important;
  }

  .me-xl-auto {
    margin-right: auto !important;
  }

  .mb-xl-0 {
    margin-bottom: 0 !important;
  }

  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }

  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }

  .mb-xl-auto {
    margin-bottom: auto !important;
  }

  .ms-xl-0 {
    margin-left: 0 !important;
  }

  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }

  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }

  .ms-xl-3 {
    margin-left: 1rem !important;
  }

  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }

  .ms-xl-5 {
    margin-left: 3rem !important;
  }

  .ms-xl-auto {
    margin-left: auto !important;
  }

  .m-xl-n1 {
    margin: -0.25rem !important;
  }

  .m-xl-n2 {
    margin: -0.5rem !important;
  }

  .m-xl-n3 {
    margin: -1rem !important;
  }

  .m-xl-n4 {
    margin: -1.5rem !important;
  }

  .m-xl-n5 {
    margin: -3rem !important;
  }

  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-xl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-xl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-xl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-xl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-xl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-xl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .mt-xl-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-xl-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-xl-n3 {
    margin-top: -1rem !important;
  }

  .mt-xl-n4 {
    margin-top: -1.5rem !important;
  }

  .mt-xl-n5 {
    margin-top: -3rem !important;
  }

  .me-xl-n1 {
    margin-right: -0.25rem !important;
  }

  .me-xl-n2 {
    margin-right: -0.5rem !important;
  }

  .me-xl-n3 {
    margin-right: -1rem !important;
  }

  .me-xl-n4 {
    margin-right: -1.5rem !important;
  }

  .me-xl-n5 {
    margin-right: -3rem !important;
  }

  .mb-xl-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-xl-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-xl-n3 {
    margin-bottom: -1rem !important;
  }

  .mb-xl-n4 {
    margin-bottom: -1.5rem !important;
  }

  .mb-xl-n5 {
    margin-bottom: -3rem !important;
  }

  .ms-xl-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-xl-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-xl-n3 {
    margin-left: -1rem !important;
  }

  .ms-xl-n4 {
    margin-left: -1.5rem !important;
  }

  .ms-xl-n5 {
    margin-left: -3rem !important;
  }

  .p-xl-0 {
    padding: 0 !important;
  }

  .p-xl-1 {
    padding: 0.25rem !important;
  }

  .p-xl-2 {
    padding: 0.5rem !important;
  }

  .p-xl-3 {
    padding: 1rem !important;
  }

  .p-xl-4 {
    padding: 1.5rem !important;
  }

  .p-xl-5 {
    padding: 3rem !important;
  }

  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .pt-xl-0 {
    padding-top: 0 !important;
  }

  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }

  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }

  .pt-xl-3 {
    padding-top: 1rem !important;
  }

  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }

  .pt-xl-5 {
    padding-top: 3rem !important;
  }

  .pe-xl-0 {
    padding-right: 0 !important;
  }

  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }

  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }

  .pe-xl-3 {
    padding-right: 1rem !important;
  }

  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }

  .pe-xl-5 {
    padding-right: 3rem !important;
  }

  .pb-xl-0 {
    padding-bottom: 0 !important;
  }

  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }

  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }

  .ps-xl-0 {
    padding-left: 0 !important;
  }

  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }

  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }

  .ps-xl-3 {
    padding-left: 1rem !important;
  }

  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }

  .ps-xl-5 {
    padding-left: 3rem !important;
  }

  .gap-xl-0 {
    gap: 0 !important;
  }

  .gap-xl-1 {
    gap: 0.25rem !important;
  }

  .gap-xl-2 {
    gap: 0.5rem !important;
  }

  .gap-xl-3 {
    gap: 1rem !important;
  }

  .gap-xl-4 {
    gap: 1.5rem !important;
  }

  .gap-xl-5 {
    gap: 3rem !important;
  }

  .row-gap-xl-0 {
    row-gap: 0 !important;
  }

  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }

  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }

  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }

  .column-gap-xl-0 {
    column-gap: 0 !important;
  }

  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }

  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }

  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }

  .text-xl-start {
    text-align: left !important;
  }

  .text-xl-end {
    text-align: right !important;
  }

  .text-xl-center {
    text-align: center !important;
  }

  .cursor-xl-auto {
    cursor: auto !important;
  }

  .cursor-xl-pointer {
    cursor: pointer !important;
  }

  .cursor-xl-grab {
    cursor: grab !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }

  .float-xxl-end {
    float: right !important;
  }

  .float-xxl-none {
    float: none !important;
  }

  .object-fit-xxl-contain {
    object-fit: contain !important;
  }

  .object-fit-xxl-cover {
    object-fit: cover !important;
  }

  .object-fit-xxl-fill {
    object-fit: fill !important;
  }

  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }

  .object-fit-xxl-none {
    object-fit: none !important;
  }

  .d-xxl-inline {
    display: inline !important;
  }

  .d-xxl-inline-block {
    display: inline-block !important;
  }

  .d-xxl-block {
    display: block !important;
  }

  .d-xxl-grid {
    display: grid !important;
  }

  .d-xxl-inline-grid {
    display: inline-grid !important;
  }

  .d-xxl-table {
    display: table !important;
  }

  .d-xxl-table-row {
    display: table-row !important;
  }

  .d-xxl-table-cell {
    display: table-cell !important;
  }

  .d-xxl-flex {
    display: flex !important;
  }

  .d-xxl-inline-flex {
    display: inline-flex !important;
  }

  .d-xxl-none {
    display: none !important;
  }

  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xxl-row {
    flex-direction: row !important;
  }

  .flex-xxl-column {
    flex-direction: column !important;
  }

  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xxl-center {
    justify-content: center !important;
  }

  .justify-content-xxl-between {
    justify-content: space-between !important;
  }

  .justify-content-xxl-around {
    justify-content: space-around !important;
  }

  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-xxl-start {
    align-items: flex-start !important;
  }

  .align-items-xxl-end {
    align-items: flex-end !important;
  }

  .align-items-xxl-center {
    align-items: center !important;
  }

  .align-items-xxl-baseline {
    align-items: baseline !important;
  }

  .align-items-xxl-stretch {
    align-items: stretch !important;
  }

  .align-content-xxl-start {
    align-content: flex-start !important;
  }

  .align-content-xxl-end {
    align-content: flex-end !important;
  }

  .align-content-xxl-center {
    align-content: center !important;
  }

  .align-content-xxl-between {
    align-content: space-between !important;
  }

  .align-content-xxl-around {
    align-content: space-around !important;
  }

  .align-content-xxl-stretch {
    align-content: stretch !important;
  }

  .align-self-xxl-auto {
    align-self: auto !important;
  }

  .align-self-xxl-start {
    align-self: flex-start !important;
  }

  .align-self-xxl-end {
    align-self: flex-end !important;
  }

  .align-self-xxl-center {
    align-self: center !important;
  }

  .align-self-xxl-baseline {
    align-self: baseline !important;
  }

  .align-self-xxl-stretch {
    align-self: stretch !important;
  }

  .order-xxl-first {
    order: -1 !important;
  }

  .order-xxl-0 {
    order: 0 !important;
  }

  .order-xxl-1 {
    order: 1 !important;
  }

  .order-xxl-2 {
    order: 2 !important;
  }

  .order-xxl-3 {
    order: 3 !important;
  }

  .order-xxl-4 {
    order: 4 !important;
  }

  .order-xxl-5 {
    order: 5 !important;
  }

  .order-xxl-last {
    order: 6 !important;
  }

  .m-xxl-0 {
    margin: 0 !important;
  }

  .m-xxl-1 {
    margin: 0.25rem !important;
  }

  .m-xxl-2 {
    margin: 0.5rem !important;
  }

  .m-xxl-3 {
    margin: 1rem !important;
  }

  .m-xxl-4 {
    margin: 1.5rem !important;
  }

  .m-xxl-5 {
    margin: 3rem !important;
  }

  .m-xxl-auto {
    margin: auto !important;
  }

  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-xxl-0 {
    margin-top: 0 !important;
  }

  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }

  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }

  .mt-xxl-3 {
    margin-top: 1rem !important;
  }

  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }

  .mt-xxl-5 {
    margin-top: 3rem !important;
  }

  .mt-xxl-auto {
    margin-top: auto !important;
  }

  .me-xxl-0 {
    margin-right: 0 !important;
  }

  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }

  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }

  .me-xxl-3 {
    margin-right: 1rem !important;
  }

  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }

  .me-xxl-5 {
    margin-right: 3rem !important;
  }

  .me-xxl-auto {
    margin-right: auto !important;
  }

  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }

  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }

  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }

  .mb-xxl-auto {
    margin-bottom: auto !important;
  }

  .ms-xxl-0 {
    margin-left: 0 !important;
  }

  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }

  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }

  .ms-xxl-3 {
    margin-left: 1rem !important;
  }

  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }

  .ms-xxl-5 {
    margin-left: 3rem !important;
  }

  .ms-xxl-auto {
    margin-left: auto !important;
  }

  .m-xxl-n1 {
    margin: -0.25rem !important;
  }

  .m-xxl-n2 {
    margin: -0.5rem !important;
  }

  .m-xxl-n3 {
    margin: -1rem !important;
  }

  .m-xxl-n4 {
    margin: -1.5rem !important;
  }

  .m-xxl-n5 {
    margin: -3rem !important;
  }

  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-xxl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-xxl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-xxl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-xxl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-xxl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-xxl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .mt-xxl-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-xxl-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-xxl-n3 {
    margin-top: -1rem !important;
  }

  .mt-xxl-n4 {
    margin-top: -1.5rem !important;
  }

  .mt-xxl-n5 {
    margin-top: -3rem !important;
  }

  .me-xxl-n1 {
    margin-right: -0.25rem !important;
  }

  .me-xxl-n2 {
    margin-right: -0.5rem !important;
  }

  .me-xxl-n3 {
    margin-right: -1rem !important;
  }

  .me-xxl-n4 {
    margin-right: -1.5rem !important;
  }

  .me-xxl-n5 {
    margin-right: -3rem !important;
  }

  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-xxl-n3 {
    margin-bottom: -1rem !important;
  }

  .mb-xxl-n4 {
    margin-bottom: -1.5rem !important;
  }

  .mb-xxl-n5 {
    margin-bottom: -3rem !important;
  }

  .ms-xxl-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-xxl-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-xxl-n3 {
    margin-left: -1rem !important;
  }

  .ms-xxl-n4 {
    margin-left: -1.5rem !important;
  }

  .ms-xxl-n5 {
    margin-left: -3rem !important;
  }

  .p-xxl-0 {
    padding: 0 !important;
  }

  .p-xxl-1 {
    padding: 0.25rem !important;
  }

  .p-xxl-2 {
    padding: 0.5rem !important;
  }

  .p-xxl-3 {
    padding: 1rem !important;
  }

  .p-xxl-4 {
    padding: 1.5rem !important;
  }

  .p-xxl-5 {
    padding: 3rem !important;
  }

  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .pt-xxl-0 {
    padding-top: 0 !important;
  }

  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }

  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }

  .pt-xxl-3 {
    padding-top: 1rem !important;
  }

  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }

  .pt-xxl-5 {
    padding-top: 3rem !important;
  }

  .pe-xxl-0 {
    padding-right: 0 !important;
  }

  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }

  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }

  .pe-xxl-3 {
    padding-right: 1rem !important;
  }

  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }

  .pe-xxl-5 {
    padding-right: 3rem !important;
  }

  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }

  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }

  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }

  .ps-xxl-0 {
    padding-left: 0 !important;
  }

  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }

  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }

  .ps-xxl-3 {
    padding-left: 1rem !important;
  }

  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }

  .ps-xxl-5 {
    padding-left: 3rem !important;
  }

  .gap-xxl-0 {
    gap: 0 !important;
  }

  .gap-xxl-1 {
    gap: 0.25rem !important;
  }

  .gap-xxl-2 {
    gap: 0.5rem !important;
  }

  .gap-xxl-3 {
    gap: 1rem !important;
  }

  .gap-xxl-4 {
    gap: 1.5rem !important;
  }

  .gap-xxl-5 {
    gap: 3rem !important;
  }

  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }

  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }

  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }

  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }

  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }

  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }

  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }

  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }

  .text-xxl-start {
    text-align: left !important;
  }

  .text-xxl-end {
    text-align: right !important;
  }

  .text-xxl-center {
    text-align: center !important;
  }

  .cursor-xxl-auto {
    cursor: auto !important;
  }

  .cursor-xxl-pointer {
    cursor: pointer !important;
  }

  .cursor-xxl-grab {
    cursor: grab !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.0625rem !important;
  }

  .fs-2 {
    font-size: 1.65rem !important;
  }

  .fs-3 {
    font-size: 1.44375rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }

  .d-print-inline-block {
    display: inline-block !important;
  }

  .d-print-block {
    display: block !important;
  }

  .d-print-grid {
    display: grid !important;
  }

  .d-print-inline-grid {
    display: inline-grid !important;
  }

  .d-print-table {
    display: table !important;
  }

  .d-print-table-row {
    display: table-row !important;
  }

  .d-print-table-cell {
    display: table-cell !important;
  }

  .d-print-flex {
    display: flex !important;
  }

  .d-print-inline-flex {
    display: inline-flex !important;
  }

  .d-print-none {
    display: none !important;
  }
}
/*
Template Name: Velzon - Admin & Dashboard Template
Author: Themesbrand
Version: 3.0.0
Website: https://themesbrand.com/
Contact: support@themesbrand.com
File: Main Css File
*/
@font-face {
  font-family: "hkgrotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
  src: local("hkgrotesk light"), url(${___CSS_LOADER_URL_REPLACEMENT_53___}) format("woff");
  font-weight: 300;
}
@font-face {
  font-family: "hkgrotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
  src: local("hkgrotesk regular"), url(${___CSS_LOADER_URL_REPLACEMENT_55___}) format("woff");
  font-weight: 400;
}
@font-face {
  font-family: "hkgrotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
  src: local("hkgrotesk medium"), url(${___CSS_LOADER_URL_REPLACEMENT_57___}) format("woff");
  font-weight: 500;
}
@font-face {
  font-family: "hkgrotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
  src: local("hkgrotesk semibold"), url(${___CSS_LOADER_URL_REPLACEMENT_59___}) format("woff");
  font-weight: 600;
}
@font-face {
  font-family: "hkgrotesk";
  src: local("hkgrotesk bold"), url(${___CSS_LOADER_URL_REPLACEMENT_60___}) format("woff");
  font-weight: 700;
}
.rounded-custom-1 {
  border-radius: 12px;
}

/*********************variables-custom dark Mode***************************/
/*
Template Name: Velzon - Admin & Dashboard Template
Author: Themesbrand
Website: https://themesbrand.com/
Contact: support@themesbrand.com
File: Custom Css File
*/
#page-topbar {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1002;
  background-color: var(--vz-header-bg);
  transition: all 0.1s ease-out;
  border-bottom: 1px solid var(--vz-header-border);
}
#page-topbar.topbar-shadow {
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
}
@media (min-width: 768px) {
  #page-topbar {
    left: var(--vz-vertical-menu-width);
  }
}

.navbar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  height: 70px;
  padding: 0 1.5rem 0 calc(1.5rem * 0.5);
}
@media (max-width: 767.98px) {
  .navbar-header {
    padding: 0 calc(1.5rem * 0.5) 0 calc(1.5rem * 0.5);
  }
}
.navbar-header .topbar-head-dropdown .dropdown-menu.show {
  top: 13px !important;
}
.navbar-header .topbar-head-dropdown .notification-actions {
  display: none;
  position: absolute;
  background-color: var(--vz-secondary-bg);
  left: 0;
  right: 0;
  bottom: 0;
  padding: 7px;
  border-top: 1px solid var(--vz-border-color);
}
.navbar-header .btn-topbar {
  height: 42px;
  width: 42px;
  color: var(--vz-header-item-sub-color);
  transition: all 0.5s ease;
}
.navbar-header .btn-topbar:hover, .navbar-header .btn-topbar:focus, .navbar-header .btn-topbar:active, .navbar-header .btn-topbar.active {
  background-color: var(--vz-header-item-bg);
}
@media (max-width: 360px) {
  .navbar-header .btn-topbar {
    height: 36px;
    width: 36px;
  }
}
.navbar-header .user-name-sub-text {
  color: var(--vz-header-item-sub-color);
}
.navbar-header .user-name-text {
  color: var(--vz-header-item-color);
}

/* Search */
.app-search {
  padding: calc(32px * 0.5) 0;
}
.app-search .form-control {
  border: none;
  height: 38px;
  padding-left: 40px;
  padding-right: 30px;
  background-color: var(--vz-topbar-search-bg);
  color: var(--vz-topbar-search-color);
  box-shadow: none;
}
.app-search span.search-widget-icon {
  position: absolute;
  z-index: 10;
  font-size: 18px;
  line-height: 38px;
  left: 13px;
  top: 0;
  color: var(--vz-header-item-sub-color);
}
.app-search .search-widget-icon-close {
  right: 7px;
  left: auto !important;
}
@media (max-width: 1023.99px) {
  .app-search {
    padding-left: calc(1.5rem * 0.5);
  }
}
.app-search ::placeholder {
  color: var(--vz-header-item-sub-color);
}

.megamenu-list li {
  position: relative;
  padding: 5px 0px;
}
.megamenu-list li a {
  color: var(--vz-body-color);
}

@media (max-width: 767.98px) {
  .logo span.logo-lg {
    display: none;
  }
  .logo span.logo-sm {
    display: inline-block;
  }
}
.header-item {
  height: 70px;
  display: flex;
  align-items: center;
}

.header-profile-user {
  height: 32px;
  width: 32px;
}

.topbar-badge-sm {
  right: 0;
  top: 7px !important;
}

.topbar-badge {
  right: -9px;
  top: 4px !important;
}

@media (min-width: 768px) {
  .topbar-user {
    background-color: var(--vz-topbar-user-bg);
  }
}
.topbar-user .dropdown-menu {
  top: 6px !important;
}

.notification-item {
  padding: 0.75rem 1rem;
  white-space: inherit;
  position: relative;
}
.notification-item .form-check-input {
  position: relative;
  z-index: 2;
}

.dropdown-icon-item {
  display: block;
  border-radius: 3px;
  line-height: 34px;
  text-align: center;
  padding: 15px 0 9px;
  border: 1px solid transparent;
  color: var(--vz-dropdown-link-color);
}
.dropdown-icon-item img {
  height: 24px;
}
.dropdown-icon-item span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dropdown-icon-item:hover {
  background-color: var(--vz-dropdown-link-hover-bg);
}

.fullscreen-enable [data-toggle=fullscreen] .bx-fullscreen::before {
  content: "";
}

[data-bs-theme=dark] .light-dark-mode .bx-moon::before {
  content: "";
}

[data-topbar=dark] .logo-dark {
  display: none;
}
[data-topbar=dark] .logo-light {
  display: inline-block;
}

[data-bs-theme=dark][data-topbar=light] .logo-dark {
  display: none;
}
[data-bs-theme=dark][data-topbar=light] .logo-light {
  display: inline-block;
}

@media (max-width: 600px) {
  .navbar-header .dropdown {
    position: static;
  }
  .navbar-header .dropdown .dropdown-menu {
    width: 100%;
  }
}
@media (max-width: 767.98px) {
  #search-dropdown-reponsive {
    top: 54px !important;
  }
}
@media (min-width: 1024.1px) {
  [data-layout=vertical][data-layout-style=detached] #page-topbar {
    left: 0 !important;
    box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  }
  [data-layout=vertical][data-layout-style=detached] .horizontal-logo {
    display: inline-block;
    padding-left: 0;
  }
  [data-layout=vertical][data-layout-style=detached] .topnav-hamburger {
    visibility: hidden;
  }
  [data-layout=vertical][data-layout-style=detached] .layout-width {
    max-width: 95%;
    margin: 0 auto;
  }
  [data-layout=vertical][data-layout-style=detached]:is([data-sidebar-size="sm"], [data-sidebar-size="sm-hover"]) .navbar-brand-box {
    background-color: transparent !important;
    position: relative;
    width: auto;
    text-align: left;
  }
  [data-layout=vertical][data-layout-style=detached]:is([data-sidebar-size="sm"], [data-sidebar-size="sm-hover"]) .navbar-brand-box .logo-sm {
    display: none;
  }
  [data-layout=vertical][data-layout-style=detached]:is([data-sidebar-size="sm"], [data-sidebar-size="sm-hover"]) .navbar-brand-box .logo-lg {
    display: block;
  }
}
[data-layout=vertical][data-layout-style=detached][data-topbar=dark] .horizontal-logo .logo-dark {
  display: none;
}
[data-layout=vertical][data-layout-style=detached][data-topbar=dark] .horizontal-logo .logo-light {
  display: block;
}

[data-layout=horizontal] #page-topbar {
  left: 0;
  border-bottom: 1px solid var(--vz-header-border);
}
@media (min-width: 1024.1px) {
  [data-layout=horizontal] #page-topbar.topbar-shadow {
    box-shadow: none;
  }
}
[data-layout=horizontal] .page-content {
  padding: calc(45px + 1.5rem) calc(1.5rem * 0.5) 60px calc(1.5rem * 0.5);
}
@media (min-width: 1024.1px) {
  [data-layout=horizontal] .page-content {
    margin-top: 70px;
  }
}
@media (max-width: 1024.1px) {
  [data-layout=horizontal] .page-content {
    padding: calc(45px + 1.5rem * 1.8) calc(1.5rem * 0.5) 60px calc(1.5rem * 0.5);
  }
}
@media (min-width: 1024.1px) {
  [data-layout=horizontal][data-layout-width=boxed] .page-content {
    min-height: calc(100vh - 130px);
  }
}

@media (min-width: 768px) {
  [data-layout=vertical]:is([data-sidebar-size="sm"], [data-sidebar-size="sm-hover"]) #page-topbar {
    left: var(--vz-vertical-menu-width-sm);
  }
}
@media (min-width: 768px) {
  [data-layout=vertical][data-sidebar-size=md] #page-topbar {
    left: var(--vz-vertical-menu-width-md);
  }
}

@media (min-width: 768px) {
  [data-layout=twocolumn] #page-topbar {
    left: calc(70px + 220px);
  }
}
[data-layout=twocolumn] .horizontal-logo {
  display: none;
}

.page-title-box {
  padding: 10px 1.5rem;
  background-color: var(--vz-secondary-bg);
  box-shadow: var(--vz-page-title-box-shadow);
  border-bottom: 1px solid var(--vz-page-title-border);
  margin: -23px -1.5rem 1.5rem -1.5rem;
}
.page-title-box .breadcrumb {
  background-color: transparent;
  padding: 0;
}
.page-title-box h4, .page-title-box .h4 {
  font-weight: 700;
  font-size: 15px !important;
  text-transform: uppercase;
}

[data-layout=horizontal] .page-title-box {
  padding: 1.2rem 0;
  background-color: transparent !important;
  border-bottom: none;
  border-top: none;
  box-shadow: none;
  margin: 0;
}
@media (min-width: 1024.1px) {
  [data-layout=horizontal] .page-title-box {
    margin: -19px 0 0 0;
  }
}

[data-layout=vertical][data-layout-style=detached] .page-title-box {
  padding: 1.2rem 0;
  background-color: transparent !important;
  border-bottom: none;
  border-top: none;
  box-shadow: none;
  margin: 0;
}
@media (min-width: 1024.1px) {
  [data-layout=vertical][data-layout-style=detached] .page-title-box {
    margin: -19px 0 0 0;
  }
}

.footer {
  bottom: 0;
  padding: 20px calc(1.5rem * 0.5);
  position: absolute;
  right: 0;
  color: var(--vz-footer-color);
  left: var(--vz-vertical-menu-width);
  height: 60px;
  background-color: var(--vz-footer-bg);
}
@media (max-width: 991.98px) {
  .footer {
    left: 0;
  }
}

[data-layout=vertical]:is([data-sidebar-size="sm"], [data-sidebar-size="sm-hover"]) .footer {
  left: var(--vz-vertical-menu-width-sm);
}
@media (max-width: 767.98px) {
  [data-layout=vertical]:is([data-sidebar-size="sm"], [data-sidebar-size="sm-hover"]) .footer {
    left: 0;
  }
}
[data-layout=vertical][data-sidebar-size=md] .footer {
  left: var(--vz-vertical-menu-width-md);
}
@media (max-width: 991.98px) {
  [data-layout=vertical][data-sidebar-size=md] .footer {
    left: 0;
  }
}

[data-layout=horizontal] .footer {
  left: 0 !important;
}

@media (min-width: 1024.1px) {
  [data-layout=vertical][data-layout-style=detached] .footer {
    left: 0 !important;
    background-color: transparent;
  }
}

@media (min-width: 768.1px) {
  [data-layout=twocolumn] .footer {
    left: calc(70px + 220px);
  }
}

.app-content {
  margin-left: var(--vz-vertical-menu-width);
  overflow: hidden;
}
.app-content .content {
  padding: 0 15px 10px 15px;
  margin-top: 70px;
}

.main-content {
  transition: all 0.1s ease-out;
  /* Customize the scrollbar */
}
@media (min-width: 768px) {
  .main-content {
    margin-left: var(--vz-vertical-menu-width);
  }
}
.main-content::-webkit-scrollbar {
  width: 12px;
  /* Set the width of the scrollbar */
}
.main-content::-webkit-scrollbar-thumb {
  background-color: #5b78da;
  /* Set the color of the thumb */
  border-radius: 6px;
  /* Optional: Set the border radius of the thumb */
}
.main-content::-webkit-scrollbar-track {
  background-color: grey;
  /* Set the color of the track */
}

.page-content {
  padding: calc(70px + 1.5rem) calc(1.5rem * 0.5) 60px calc(1.5rem * 0.5);
}

.navbar-menu {
  width: var(--vz-vertical-menu-width);
  z-index: 1002;
  background: var(--vz-vertical-menu-bg);
  border-right: 1px solid var(--vz-vertical-menu-border);
  bottom: 0;
  margin-top: 0;
  position: fixed;
  top: 0;
  box-shadow: var(--vz-vertical-menu-box-shadow);
  padding: 0 0 calc(70px + 25px) 0;
  transition: all 0.1s ease-out;
}
.navbar-menu .navbar-nav .nav-link {
  display: flex;
  align-items: center;
  padding: 0.625rem 1.5rem;
  color: var(--vz-vertical-menu-item-color);
  font-size: 0.925rem;
  font-family: "Rubik", sans-serif;
}
.navbar-menu .navbar-nav .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color);
}
.navbar-menu .navbar-nav .nav-link:hover {
  color: var(--vz-vertical-menu-item-hover-color);
}
.navbar-menu .navbar-nav .nav-link i {
  display: inline-block;
  min-width: 1.75rem;
  font-size: 18px;
  line-height: inherit;
}
.navbar-menu .navbar-nav .nav-link svg {
  width: 18px;
  margin-right: 0.665rem;
  color: var(--vz-vertical-menu-item-color);
}
.navbar-menu .navbar-nav .nav-link .badge {
  margin-left: auto;
  margin-right: -2px;
  z-index: 1;
}
.navbar-menu .navbar-nav .nav-link:hover {
  color: var(--vz-vertical-menu-item-hover-color);
}
.navbar-menu .navbar-nav .nav-link:hover .icon-dual {
  color: var(--vz-vertical-menu-item-hover-color);
  fill: rgba(180, 208, 240, 0.16);
}
.navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse]:after {
  display: block;
  content: "󰅂";
  font-family: "Material Design Icons";
  margin-left: auto;
  transition: transform 0.2s;
  font-size: 1.05rem;
  position: absolute;
  right: 18px;
  color: inherit;
}
.navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] {
  color: var(--vz-vertical-menu-item-active-color);
}
.navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] .icon-dual {
  color: var(--vz-vertical-menu-item-hover-color);
  fill: rgba(180, 208, 240, 0.16);
}
.navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:after {
  transform: rotate(90deg);
  color: var(--vz-vertical-menu-item-active-color);
}
.navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:before {
  opacity: 1;
  background-color: var(--vz-vertical-menu-item-active-color);
}
.navbar-menu .navbar-nav .nav-link.collapsed.active::after {
  transform: rotate(90deg);
}
.navbar-menu .navbar-nav .nav-sm {
  padding-left: 1.75rem;
}
.navbar-menu .navbar-nav .nav-sm .nav-link {
  padding: 0.55rem 1.5rem !important;
  color: var(--vz-vertical-menu-sub-item-color);
  white-space: none;
  position: relative;
  font-size: 0.875rem;
  font-family: "Rubik", sans-serif;
}
.navbar-menu .navbar-nav .nav-sm .nav-link:before {
  content: "";
  width: 6px;
  height: 1.5px;
  background-color: var(--vz-vertical-menu-sub-item-color);
  position: absolute;
  left: 2px;
  top: 16.5px;
  transition: all 0.4s ease-in-out;
  opacity: 0.5;
}
.navbar-menu .navbar-nav .nav-sm .nav-link:hover {
  color: var(--vz-vertical-menu-sub-item-hover-color);
}
.navbar-menu .navbar-nav .nav-sm .nav-link:hover:before {
  background-color: var(--vz-vertical-menu-sub-item-hover-color) !important;
  opacity: 1;
}
.navbar-menu .navbar-nav .nav-sm .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color);
}
.navbar-menu .navbar-nav .nav-sm .nav-link.active:before {
  background-color: var(--vz-vertical-menu-item-active-color);
}
.navbar-menu .navbar-nav .nav-sm .nav-sm {
  padding-left: 15px;
}
.navbar-menu .navbar-nav .nav-sm .nav-sm .nav-link:before {
  height: 5px;
  width: 5px;
  left: 5px;
  border-radius: 50%;
  background-color: transparent;
  border: 1px solid;
  top: 16px;
}
.navbar-menu .btn-vertical-sm-hover {
  color: var(--vz-secondary-color);
  display: none;
}

.navbar-brand-box {
  padding: 0 1.3rem;
  text-align: center;
  transition: all 0.1s ease-out;
}
@media (max-width: 767.98px) {
  .navbar-brand-box {
    display: none;
  }
}

.hamburger-icon {
  width: 20px;
  height: 14px;
  position: relative;
  cursor: pointer;
  display: inline-block;
}
.hamburger-icon span {
  background-color: var(--vz-header-item-sub-color);
  position: absolute;
  border-radius: 2px;
  transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);
  width: 100%;
  height: 2px;
  display: block;
  left: 0px;
}
.hamburger-icon span:nth-child(1) {
  top: 0;
  width: 80%;
}
.hamburger-icon span:nth-child(2) {
  top: 6px;
}
.hamburger-icon span:nth-child(3) {
  bottom: 0;
  width: 60%;
}
.vertical-menu-btn:hover .hamburger-icon:not(.open) span:nth-child(1) {
  top: -1px;
}
.vertical-menu-btn:hover .hamburger-icon:not(.open) span:nth-child(3) {
  bottom: -1px;
}
.hamburger-icon.open {
  transform: rotate(-90deg);
}
.hamburger-icon.open span:nth-child(1) {
  left: 1px;
  top: 5px;
  width: 20px;
  transform: rotate(90deg);
  transition-delay: 150ms;
}
.hamburger-icon.open span:nth-child(2) {
  left: 3px;
  top: 13px;
  width: 10px;
  transform: rotate(45deg);
  transition-delay: 50ms;
}
.hamburger-icon.open span:nth-child(3) {
  left: 9px;
  top: 13px;
  width: 10px;
  transform: rotate(-45deg);
  transition-delay: 100ms;
}

.logo {
  line-height: 70px;
}
.logo .logo-sm {
  display: none;
}

.logo-light {
  display: none;
}

:is([data-layout="vertical"], [data-layout="semibox"]) .app-menu .row {
  margin: 0;
}
:is([data-layout="vertical"], [data-layout="semibox"]) .app-menu .row > * {
  width: 100%;
  padding: 0;
}
@media (max-width: 767.98px) {
  :is([data-layout="vertical"], [data-layout="semibox"]) .app-menu {
    margin-left: -100%;
    padding: 10px 0 20px 0;
  }
}
:is([data-layout="vertical"], [data-layout="semibox"]) .navbar-menu .container-fluid, :is([data-layout="vertical"], [data-layout="semibox"]) .navbar-menu .container-sm, :is([data-layout="vertical"], [data-layout="semibox"]) .navbar-menu .container-md, :is([data-layout="vertical"], [data-layout="semibox"]) .navbar-menu .container-lg, :is([data-layout="vertical"], [data-layout="semibox"]) .navbar-menu .container-xl, :is([data-layout="vertical"], [data-layout="semibox"]) .navbar-menu .container-xxl {
  padding: 0;
}
@media (max-width: 767.98px) {
  :is([data-layout="vertical"], [data-layout="semibox"]) .navbar-brand-box {
    display: none;
  }
}
:is([data-layout="vertical"], [data-layout="semibox"]) .horizontal-logo {
  display: none;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .main-content {
  margin-left: var(--vz-vertical-menu-width-sm);
}
@media (max-width: 767.98px) {
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .main-content {
    margin-left: 0;
  }
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .logo span.logo-lg {
  display: none;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .logo span.logo-sm {
  display: inline-block;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .btn-vertical-sm-hover {
  display: inline-block;
}
@media (min-width: 768px) {
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .topnav-hamburger {
    display: none;
  }
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu {
  width: var(--vz-vertical-menu-width-sm);
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu .btn-vertical-sm-hover {
  display: none;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu .btn-vertical-sm-hover i.ri-record-circle-line:before {
  content: "";
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .badge {
  display: none;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .menu-title {
  text-align: center;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .menu-title span {
  display: none;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .menu-title i {
  color: var(--vz-vertical-menu-item-color);
  display: block;
  line-height: 36px;
  font-size: 1rem;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link span {
  display: none;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link i {
  font-size: 22px;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link i.las, :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link i.lar, :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link i.lab {
  font-size: 24px;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link svg {
  margin-right: 0px;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link:after, :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link:before {
  display: none;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .menu-dropdown {
  display: none;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu:hover {
  width: var(--vz-vertical-menu-width) !important;
}
@media (min-width: 1024.99px) {
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu:hover .btn-vertical-sm-hover {
    display: inline-block;
  }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu:hover .navbar-brand-box {
    text-align: left;
  }
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu:hover .navbar-nav .menu-dropdown.show {
  display: block;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link i {
  font-size: 18px;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link i.las, :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link i.lar, :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link i.lab {
  font-size: 20px;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link svg {
  margin-right: 0.665rem;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link span, :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link:after, :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link:before {
  display: inline-block;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu:hover .logo span.logo-lg {
  display: inline-block;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu:hover .logo span.logo-sm {
  display: none;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu:hover .menu-title {
  text-align: left;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu:hover .menu-title span {
  display: inline-block;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover] .navbar-menu:hover .menu-title i {
  display: none;
}
@media (min-width: 1025px) {
  :is([data-layout="vertical"], [data-layout="semibox"]):is([data-sidebar-size="sm-hover"], [data-sidebar-size="sm-hover-active"]) .navbar-header {
    padding-left: 1.5rem;
  }
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover-active] .navbar-brand-box {
  text-align: left;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover-active] .topnav-hamburger {
  display: none;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm-hover-active] .btn-vertical-sm-hover {
  display: inline-block;
}
@media (min-width: 768px) {
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] {
    min-height: 585px;
  }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .main-content {
    margin-left: var(--vz-vertical-menu-width-sm);
  }
}
@media (min-width: 1366px) {
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] {
    min-height: 945px;
  }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .main-content {
    margin-left: var(--vz-vertical-menu-width-sm);
  }
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] #page-topbar {
  z-index: calc(1002 + 1);
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-brand-box {
  position: fixed;
  padding: 0;
  width: var(--vz-vertical-menu-width-sm);
  z-index: 1;
  top: 0;
  background-color: var(--vz-vertical-menu-bg);
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .logo span.logo-lg {
  display: none;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .logo span.logo-sm {
  display: inline-block;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu {
  position: fixed;
  width: var(--vz-vertical-menu-width-sm) !important;
  padding-top: 70px;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .simplebar-mask,
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .simplebar-content-wrapper {
  overflow: visible !important;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .simplebar-scrollbar,
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .vertical-menu-btn {
  display: none !important;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .simplebar-offset {
  bottom: 0 !important;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .navbar-nav .badge {
  display: none !important;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .navbar-nav .menu-title {
  text-align: center;
  font-size: 1rem;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .navbar-nav .menu-title span {
  display: none;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .navbar-nav .menu-title i {
  display: block;
  line-height: 36px;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-link span {
  display: none;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-link i {
  font-size: 22px;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-link svg {
  margin-right: 0px;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-link:after, :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-link:before {
  display: none;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .navbar-nav .menu-dropdown {
  display: none;
  height: auto !important;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item {
  position: relative;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link {
  position: relative;
  width: calc(200px + var(--vz-vertical-menu-width-sm));
  transition: none;
  background: var(--vz-vertical-menu-bg);
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link .icon-dual {
  fill: rgba(255, 255, 255, 0.16);
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link span {
  display: inline-block;
  padding-left: 25px;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link:after {
  display: block;
  transform: rotate(90deg);
  color: #fff;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover .nav-link span {
  display: inline-block;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover > .menu-dropdown {
  display: block;
  left: var(--vz-vertical-menu-width-sm);
  position: absolute;
  width: 200px;
  background: var(--vz-vertical-menu-bg);
  height: auto !important;
  padding: 0.5rem 0;
  border-radius: 0 0 3px 3px;
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm {
  padding: 0;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link {
  color: var(--vz-vertical-menu-item-hover-color);
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link:after {
  color: inherit;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-link:after {
  display: block !important;
  transform: rotate(0deg) !important;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .menu-dropdown {
  left: 100% !important;
  top: 0;
  border-radius: 3px !important;
}
@media (min-width: 768px) {
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=md] .main-content {
    margin-left: var(--vz-vertical-menu-width-md);
  }
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=md] .navbar-brand-box {
  width: var(--vz-vertical-menu-width-md);
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=md] .navbar-menu {
  width: var(--vz-vertical-menu-width-md) !important;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=md] .navbar-menu .navbar-nav .nav-link {
  display: block;
  text-align: center;
  padding: 0.55rem 0.525rem;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=md] .navbar-menu .navbar-nav .nav-link i {
  display: block;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=md] .navbar-menu .navbar-nav .nav-link svg {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=md] .navbar-menu .navbar-nav .nav-link:before {
  display: none !important;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=md] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse]:after {
  position: relative;
  display: inline-block;
  right: 0;
  top: 3px;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=md] .navbar-menu .navbar-nav .nav-link.menu-link[data-bs-toggle=collapse]:after {
  display: none;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=md] .navbar-menu .navbar-nav .badge {
  display: none !important;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=md] .navbar-menu .navbar-nav .nav-sm {
  padding-left: 0;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=md] .navbar-menu .menu-title {
  text-align: center;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size=md] .navbar-menu .menu-title span {
  text-decoration: underline;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar=dark] .logo-dark {
  display: none;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar=dark] .logo-light {
  display: inline-block;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar=light] .logo-dark {
  display: inline-block;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar=light] .logo-light {
  display: none;
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style=detached] #layout-wrapper,
:is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style=detached] .main-content {
  min-height: 100vh;
}
@media (min-width: 1024.1px) {
  :is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style=detached] .main-content {
    position: relative;
  }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style=detached] #layout-wrapper {
    max-width: 95%;
    margin: 0 auto;
    padding-left: 1.5rem;
  }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style=detached] .navbar-header {
    padding-left: 1.5rem;
  }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style=detached] .navbar-menu {
    top: calc(70px + 1.5rem);
    bottom: 1.5rem;
    padding: 0;
    border-right: var(--vz-vertical-menu-bg);
    border-radius: 5px;
    padding: 10px 0;
    z-index: 1;
  }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style=detached] .navbar-menu .navbar-brand-box {
    display: none;
  }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style=detached]:is([data-sidebar="dark"],
          [data-sidebar="gradient"],
          [data-sidebar="gradient-2"],
          [data-sidebar="gradient-3"],
          [data-sidebar="gradient-4"]) .logo-dark {
    display: inline-block;
  }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style=detached]:is([data-sidebar="dark"],
          [data-sidebar="gradient"],
          [data-sidebar="gradient-2"],
          [data-sidebar="gradient-3"],
          [data-sidebar="gradient-4"]) .logo-light {
    display: none;
  }
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style=detached] .footer {
  border-top: 1px dashed var(--vz-border-color);
}
:is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style=detached] .auth-page-wrapper .footer {
  border-top: none;
}
@media (min-width: 768px) {
  :is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style=detached][data-sidebar-size=sm] #layout-wrapper,
:is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style=detached][data-sidebar-size=sm] .main-content {
    min-height: 1400px;
  }
}
:is([data-layout="vertical"], [data-layout="semibox"]):is([data-sidebar="gradient"],
        [data-sidebar="gradient-2"],
        [data-sidebar="gradient-3"],
        [data-sidebar="gradient-4"]) .logo-dark {
  display: none;
}
:is([data-layout="vertical"], [data-layout="semibox"]):is([data-sidebar="gradient"],
        [data-sidebar="gradient-2"],
        [data-sidebar="gradient-3"],
        [data-sidebar="gradient-4"]) .logo-light {
  display: inline-block;
}

@media (min-width: 1024.1px) {
  [data-layout=vertical][data-bs-theme=dark][data-layout-style=detached]:is([data-sidebar="light"],
          [data-sidebar="dark"],
          [data-sidebar="gradient"],
          [data-sidebar="gradient-2"],
          [data-sidebar="gradient-3"],
          [data-sidebar="gradient-4"]) .logo-dark {
    display: none;
  }
  [data-layout=vertical][data-bs-theme=dark][data-layout-style=detached]:is([data-sidebar="light"],
          [data-sidebar="dark"],
          [data-sidebar="gradient"],
          [data-sidebar="gradient-2"],
          [data-sidebar="gradient-3"],
          [data-sidebar="gradient-4"]) .logo-light {
    display: inline-block;
  }
}

.menu-title {
  letter-spacing: 0.05em;
  cursor: default;
  font-size: 11px;
  text-transform: uppercase;
  color: var(--vz-vertical-menu-title-color);
  font-weight: 500;
}
.menu-title span {
  padding: 12px 20px;
  display: inline-block;
}
.menu-title i {
  display: none;
}

.vertical-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(54, 61, 72, 0.35);
  z-index: 1003;
  display: none;
}

.vertical-sidebar-enable .vertical-overlay {
  display: block;
}
.vertical-sidebar-enable .app-menu {
  margin-left: 0 !important;
  z-index: 1004;
}

[dir=rtl] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse]:after {
  transform: rotate(180deg);
}
[dir=rtl] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:after {
  transform: rotate(270deg);
}

.bg-vertical-gradient {
  background: linear-gradient(to right, var(--vz-primary), var(--vz-success));
}

.bg-vertical-gradient-2 {
  background: linear-gradient(to right, var(--vz-info), var(--vz-secondary));
}

.bg-vertical-gradient-3 {
  background: linear-gradient(to right, var(--vz-info), var(--vz-success));
}

.bg-vertical-gradient-4 {
  background: linear-gradient(to right, #1a1d21, var(--vz-primary));
}

.sidebar-background {
  position: absolute;
  z-index: -1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: 50%;
  opacity: 0.07;
}

[data-sidebar-image=img-1] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
}

[data-sidebar-image=img-2] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___});
}

[data-sidebar-image=img-3] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
}

[data-sidebar-image=img-4] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
}

[data-layout=semibox] .page-title-box {
  padding: 10px 0;
  background-color: transparent;
  box-shadow: none;
  margin: -15px 0 1.5rem 0;
}
@media (min-width: 768px) {
  [data-layout=semibox][data-sidebar-size=sm] .main-content, [data-layout=semibox][data-sidebar-size=sm-hover] .main-content {
    margin-left: var(--vz-vertical-menu-width-sm);
  }
  [data-layout=semibox][data-sidebar-size=sm] #page-topbar, [data-layout=semibox][data-sidebar-size=sm-hover] #page-topbar {
    left: var(--vz-vertical-menu-width-sm);
  }
  [data-layout=semibox][data-sidebar-size=sm] .footer, [data-layout=semibox][data-sidebar-size=sm-hover] .footer {
    left: var(--vz-vertical-menu-width-sm);
  }
  [data-layout=semibox][data-sidebar-size=md] #page-topbar {
    left: var(--vz-vertical-menu-width-md);
  }
  [data-layout=semibox][data-sidebar-size=md] .footer {
    left: var(--vz-vertical-menu-width-md);
  }
}
@media (min-width: 1440px) {
  [data-layout=semibox] .page-content {
    padding: calc(70px + 1.5rem * 2) calc(1.5rem * 0.5) 60px calc(1.5rem * 0.5);
  }
  [data-layout=semibox] .navbar-menu {
    margin: 25px;
    border-radius: var(--vz-border-radius);
  }
  [data-layout=semibox] .main-content {
    margin-left: calc(var(--vz-vertical-menu-width) + 25px);
    padding: 0 var(--vz-semibox-width);
  }
  [data-layout=semibox] .footer {
    left: calc( var(--vz-vertical-menu-width) + var(--vz-semibox-width) + 1.5rem + 25px );
    right: calc(var(--vz-semibox-width) + 1.5rem);
  }
  [data-layout=semibox] #page-topbar {
    left: calc( var(--vz-vertical-menu-width) + var(--vz-semibox-width) + 1.5rem + 25px );
    right: calc(var(--vz-semibox-width) + 1.5rem);
    top: 25px;
    border-radius: 0.25rem;
    transition: all 0.5s ease;
    border: 1px solid var(--vz-header-border);
  }
  [data-layout=semibox] #page-topbar.topbar-shadow {
    top: 0px;
  }
  [data-layout=semibox][data-sidebar-size=md] .main-content {
    margin-left: calc(var(--vz-vertical-menu-width-md) + 25px);
  }
  [data-layout=semibox][data-sidebar-size=md] #page-topbar {
    left: calc( var(--vz-vertical-menu-width-md) + var(--vz-semibox-width) + 1.5rem + 25px );
  }
  [data-layout=semibox][data-sidebar-size=md] .footer {
    left: calc( var(--vz-vertical-menu-width-md) + var(--vz-semibox-width) + 1.5rem + 25px );
  }
  [data-layout=semibox][data-sidebar-size=sm] .main-content {
    margin-left: calc(var(--vz-vertical-menu-width-sm) + 25px);
  }
  [data-layout=semibox][data-sidebar-size=sm] .navbar-brand-box {
    top: 25px;
  }
  [data-layout=semibox][data-sidebar-size=sm] #page-topbar {
    left: calc( var(--vz-vertical-menu-width-sm) + var(--vz-semibox-width) + 1.5rem + 25px );
  }
  [data-layout=semibox][data-sidebar-size=sm] .footer {
    left: calc( var(--vz-vertical-menu-width-sm) + var(--vz-semibox-width) + 1.5rem + 25px );
  }
  [data-layout=semibox][data-sidebar-size=sm-hover] .main-content {
    margin-left: calc(var(--vz-vertical-menu-width-sm) + 25px);
  }
  [data-layout=semibox][data-sidebar-size=sm-hover] #page-topbar {
    left: calc( var(--vz-vertical-menu-width-sm) + var(--vz-semibox-width) + 1.5rem + 25px );
  }
  [data-layout=semibox][data-sidebar-size=sm-hover] .footer {
    left: calc( var(--vz-vertical-menu-width-sm) + var(--vz-semibox-width) + 1.5rem + 25px );
  }
}
[data-layout=semibox] .mx-n4 {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
[data-layout=semibox] .mx-n4.p-1 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

[data-layout=horizontal] .main-content {
  margin-left: 0;
}
@media (min-width: 1024.1px) {
  [data-layout=horizontal] .layout-width,
[data-layout=horizontal] .container-fluid,
[data-layout=horizontal] .container-sm,
[data-layout=horizontal] .container-md,
[data-layout=horizontal] .container-lg,
[data-layout=horizontal] .container-xl,
[data-layout=horizontal] .container-xxl {
    max-width: 90%;
    margin: 0 auto;
  }
  [data-layout=horizontal] .topnav-hamburger {
    visibility: hidden;
  }
}
[data-layout=horizontal] .horizontal-logo {
  padding-left: calc(1.5rem * 0.5);
}
@media (max-width: 1024.98px) {
  [data-layout=horizontal] .horizontal-logo {
    padding-left: 1.5rem;
  }
}
[data-layout=horizontal] .navbar-menu {
  background: var(--vz-topnav-bg);
  border-right-color: transparent;
  padding: 0 calc(1.5rem * 0.5);
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  margin-top: 70px;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 100;
  width: 100%;
  bottom: auto;
}
@media (max-width: 575.98px) {
  [data-layout=horizontal] .navbar-menu .container-fluid, [data-layout=horizontal] .navbar-menu .container-sm, [data-layout=horizontal] .navbar-menu .container-md, [data-layout=horizontal] .navbar-menu .container-lg, [data-layout=horizontal] .navbar-menu .container-xl, [data-layout=horizontal] .navbar-menu .container-xxl {
    padding: 0;
  }
}
[data-layout=horizontal] .navbar-menu .navbar-nav {
  flex-direction: row;
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-sm {
  padding-left: 0;
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-sm .nav-link:before {
  opacity: 0 !important;
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-sm .nav-link:hover, [data-layout=horizontal] .navbar-menu .navbar-nav .nav-sm .nav-link.active {
  color: var(--vz-topnav-item-active-color);
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link {
  color: var(--vz-topnav-item-color);
  padding: 0.75rem 1.5rem;
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link i {
  line-height: 1;
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link.active {
  color: var(--vz-topnav-item-active-color);
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link.active:after {
  color: var(--vz-topnav-item-active-color);
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link.active .icon-dual {
  color: var(--vz-topnav-item-active-color);
  fill: rgba(180, 208, 240, 0.1);
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] {
  color: var(--vz-topnav-item-active-color);
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] .icon-dual {
  color: var(--vz-topnav-item-active-color);
  fill: rgba(180, 208, 240, 0.1);
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:after {
  color: var(--vz-topnav-item-active-color);
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link:hover .icon-dual {
  color: var(--vz-topnav-item-active-color);
  fill: rgba(180, 208, 240, 0.1);
}
[data-layout=horizontal] .navbar-menu .navbar-nav > .nav-item > .nav-link[data-bs-toggle=collapse]:after {
  right: 0px;
  transform: rotate(90deg) !important;
}
[data-layout=horizontal] .navbar-menu .navbar-nav > li:nth-of-type(2) > .nav-link.menu-link {
  padding-left: 0;
}
[data-layout=horizontal] .navbar-menu .navbar-brand-box {
  display: none;
}
[data-layout=horizontal] .navbar-nav .nav-item {
  position: relative;
}
[data-layout=horizontal] .navbar-nav .nav-item .nav-link[data-bs-toggle=collapse]:after {
  right: 10px;
  transform: rotate(0deg) !important;
}
[data-layout=horizontal] .navbar-nav .nav-item > .nav-link > .badge {
  display: none;
}
[data-layout=horizontal] .navbar-nav .nav-item:hover > .nav-link {
  color: var(--vz-topnav-item-active-color);
}
[data-layout=horizontal] .navbar-nav .nav-item:hover > .nav-link .icon-dual {
  color: var(--vz-topnav-item-active-color);
  fill: rgba(180, 208, 240, 0.1);
}
[data-layout=horizontal] .navbar-nav .nav-item:hover > .nav-link:after {
  color: var(--vz-topnav-item-active-color);
}
@media (min-width: 1024.1px) {
  [data-layout=horizontal] .navbar-nav .nav-item:hover > .menu-dropdown {
    display: block;
    height: auto !important;
  }
}
[data-layout=horizontal] .navbar-nav .nav-item.active {
  color: var(--vz-topnav-item-active-color);
}
[data-layout=horizontal] .menu-dropdown {
  position: absolute;
  min-width: 12rem;
  padding: 0.5rem 0;
  box-shadow: 0 0px 5px rgba(15, 34, 58, 0.15);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  margin: 0;
  z-index: 1000;
  background-color: var(--vz-topnav-bg);
  background-clip: padding-box;
  border: 0 solid var(--vz-border-color);
  border-radius: var(--vz-border-radius-lg);
  display: none;
}
[data-layout=horizontal] .menu-dropdown .menu-dropdown {
  top: 0;
  left: 100%;
}
[data-layout=horizontal] .mega-dropdown-menu {
  width: 40rem;
}
[data-layout=horizontal] .menu-title {
  display: none;
}
[data-layout=horizontal] .dropdown-custom-right {
  left: -100% !important;
  right: 100%;
}
@media (max-width: 1024px) {
  [data-layout=horizontal] .navbar-menu {
    display: none;
  }
}

@media (max-width: 1024px) {
  [data-layout=horizontal] .menu .navbar-menu {
    display: block;
    max-height: 360px;
    overflow-y: auto;
    padding-left: 0;
  }
  [data-layout=horizontal] .menu .navbar-menu .navbar-nav {
    flex-direction: column;
  }
  [data-layout=horizontal] .menu .navbar-menu .navbar-nav > li:nth-of-type(2) > .nav-link.menu-link {
    padding-left: 1.5rem;
  }
  [data-layout=horizontal] .menu .navbar-menu .navbar-nav .nav-sm .nav-link:before {
    opacity: 1 !important;
  }
  [data-layout=horizontal] .menu .menu-dropdown {
    position: relative;
    min-width: 100%;
    box-shadow: none;
    padding-left: 28px;
    left: 0;
    animation: none;
    padding-top: 0;
  }
  [data-layout=horizontal] .menu .menu-dropdown.show {
    display: block;
  }
  [data-layout=horizontal] .menu .dropdown-custom-right {
    left: 0 !important;
  }
  [data-layout=horizontal] .menu .nav-item .nav-link[data-bs-toggle=collapse]:after {
    right: 0px;
  }
  [data-layout=horizontal] .menu .mega-dropdown-menu {
    width: 100%;
  }
}

[dir=rtl][data-layout=horizontal] .navbar-menu .navbar-nav > .nav-item > .nav-link[data-bs-toggle=collapse]:after {
  transform: rotate(-90deg) !important;
}
[dir=rtl][data-layout=horizontal] .navbar-nav .nav-item .nav-link[data-bs-toggle=collapse]:after {
  transform: rotate(-180deg) !important;
}

[data-layout=twocolumn] .app-menu {
  padding-bottom: 0;
  width: 220px;
  left: 70px;
}
[data-layout=twocolumn] .app-menu .menu-link {
  letter-spacing: 0.05em;
  cursor: default;
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 500;
}
[data-layout=twocolumn] .app-menu .menu-link:after {
  display: none !important;
}
[data-layout=twocolumn] .app-menu .menu-link i {
  display: none;
}
[data-layout=twocolumn] .app-menu .navbar-nav {
  height: calc(100vh - 70px);
}
@media (max-width: 767.98px) {
  [data-layout=twocolumn] .app-menu .navbar-nav {
    padding-top: 16px;
  }
}
[data-layout=twocolumn] .app-menu .navbar-nav > li:not(.twocolumn-item-show) {
  display: none;
}
[data-layout=twocolumn] .app-menu .navbar-nav .twocolumn-item-show > div {
  display: block !important;
  height: auto !important;
}
[data-layout=twocolumn] .app-menu .navbar-nav > .nav-item > .menu-dropdown {
  display: block !important;
  height: auto !important;
}
[data-layout=twocolumn] .app-menu .navbar-nav .nav-item .menu-dropdown .row {
  margin: 0;
}
[data-layout=twocolumn] .app-menu .navbar-nav .nav-item .menu-dropdown .row .col-lg-4 {
  width: 100%;
  padding: 0;
}
[data-layout=twocolumn] .app-menu .container-fluid, [data-layout=twocolumn] .app-menu .container-sm, [data-layout=twocolumn] .app-menu .container-md, [data-layout=twocolumn] .app-menu .container-lg, [data-layout=twocolumn] .app-menu .container-xl, [data-layout=twocolumn] .app-menu .container-xxl {
  padding: 0;
}
[data-layout=twocolumn] .main-content {
  margin-left: calc(220px + 70px);
}
@media (max-width: 767.98px) {
  [data-layout=twocolumn] .main-content {
    margin-left: 70px;
  }
}
[data-layout=twocolumn]:is([data-sidebar="dark"], [data-sidebar="gradient"], [data-sidebar="gradient-2"], [data-sidebar="gradient-3"], [data-sidebar="gradient-4"]) .app-menu .navbar-brand-box .logo-light {
  display: block;
}
[data-layout=twocolumn]:is([data-sidebar="dark"], [data-sidebar="gradient"], [data-sidebar="gradient-2"], [data-sidebar="gradient-3"], [data-sidebar="gradient-4"]) .app-menu .navbar-brand-box .logo-dark {
  display: none;
}
[data-layout=twocolumn] .twocolumn-iconview {
  width: 70px;
  background-color: var(--vz-twocolumn-menu-iconview-bg);
  height: 100%;
  left: -70px;
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  top: 0;
  position: absolute;
  padding: 0;
  text-align: center;
}
[data-layout=twocolumn] .twocolumn-iconview li {
  position: relative;
  list-style: none;
}
[data-layout=twocolumn] .twocolumn-iconview li .nav-icon::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
[data-layout=twocolumn] .twocolumn-iconview .nav-icon {
  width: 42px;
  height: 42px;
  color: var(--vz-vertical-menu-item-color);
  line-height: 42px;
  z-index: 1;
  font-size: 22px;
  text-align: center;
  border-radius: 3px;
  margin: 5px 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
[data-layout=twocolumn] .twocolumn-iconview .nav-icon .icon-dual {
  width: 18px;
  color: var(--vz-vertical-menu-item-color);
  fill: var(--vz-vertical-menu-item-bg);
}
[data-layout=twocolumn] .twocolumn-iconview .nav-icon.active {
  background-color: var(--vz-vertical-menu-item-active-bg);
  color: var(--vz-vertical-menu-item-active-color);
}
[data-layout=twocolumn] .twocolumn-iconview .nav-icon.active .icon-dual {
  color: var(--vz-vertical-menu-item-active-color);
  fill: var(--vz-vertical-menu-item-active-bg);
}
[data-layout=twocolumn] .menu-title {
  display: none;
}
@media (max-width: 991.98px) {
  [data-layout=twocolumn] .logo span.logo-lg {
    display: block;
  }
  [data-layout=twocolumn] .logo span.logo-sm {
    display: none;
  }
}
[data-layout=twocolumn][data-sidebar=light] .app-menu .navbar-brand-box .logo-light {
  display: none;
}
[data-layout=twocolumn][data-sidebar=light] .app-menu .navbar-brand-box .logo-dark {
  display: block;
}
[data-layout=twocolumn][data-sidebar=dark] .app-menu .navbar-brand-box .logo-light {
  display: block;
}
[data-layout=twocolumn][data-sidebar=dark] .app-menu .navbar-brand-box .logo-dark {
  display: none;
}
[data-layout=twocolumn] .twocolumn-panel .app-menu {
  width: 0;
  border-right: 0;
}
@media (max-width: 575.98px) {
  [data-layout=twocolumn] .twocolumn-panel .app-menu {
    display: none;
  }
}
[data-layout=twocolumn] .twocolumn-panel .navbar-brand-box,
[data-layout=twocolumn] .twocolumn-panel .navbar-nav {
  display: none;
}
[data-layout=twocolumn] .twocolumn-panel .main-content {
  margin-left: 70px;
}
[data-layout=twocolumn] .twocolumn-panel #page-topbar,
[data-layout=twocolumn] .twocolumn-panel .footer {
  left: 70px;
}
@media (max-width: 575.98px) {
  [data-layout=twocolumn] .twocolumn-panel .main-content {
    margin-left: 0;
  }
  [data-layout=twocolumn] .twocolumn-panel #page-topbar,
[data-layout=twocolumn] .twocolumn-panel .footer {
    left: 0;
  }
}
@media (max-width: 767.98px) {
  [data-layout=twocolumn] #page-topbar,
[data-layout=twocolumn] .footer {
    left: 70px;
  }
}
@media (max-width: 575.98px) {
  [data-layout=twocolumn] .main-content {
    margin-left: 0;
  }
  [data-layout=twocolumn] #page-topbar,
[data-layout=twocolumn] .footer {
    left: 0;
  }
}

@media (max-width: 767.98px) {
  [data-layout=twocolumn] .app-menu {
    left: 0;
    margin-left: 100%;
  }
  [data-layout=twocolumn] .main-content {
    margin-left: 0 !important;
  }
  [data-layout=twocolumn] #page-topbar,
[data-layout=twocolumn] .footer {
    left: 0 !important;
  }
}

[data-layout-width=boxed] body {
  background-color: var(--vz-boxed-body-bg);
}
[data-layout-width=boxed] #layout-wrapper {
  max-width: var(--vz-boxed-layout-width);
  margin: 0 auto;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  background-color: var(--vz-body-bg);
}
[data-layout-width=boxed][data-layout=vertical] #layout-wrapper {
  min-height: 100vh;
}
[data-layout-width=boxed] #page-topbar,
[data-layout-width=boxed] .footer {
  max-width: var(--vz-boxed-layout-width);
  margin: 0 auto;
  left: 0 !important;
}
@media (min-width: 768px) {
  [data-layout-width=boxed][data-sidebar-size=sm-hover][data-layout=vertical] #layout-wrapper, [data-layout-width=boxed][data-sidebar-size=sm][data-layout=vertical] #layout-wrapper {
    min-height: 1400px;
  }
}
@media (max-width: 767.98px) {
  [data-layout-width=boxed][data-sidebar-size=sm-hover][data-layout=vertical] .main-content, [data-layout-width=boxed][data-sidebar-size=sm][data-layout=vertical] .main-content {
    margin-left: 0;
  }
}
[data-layout-width=boxed][data-sidebar-size=sm-hover] #page-topbar,
[data-layout-width=boxed][data-sidebar-size=sm-hover] .footer, [data-layout-width=boxed][data-sidebar-size=sm] #page-topbar,
[data-layout-width=boxed][data-sidebar-size=sm] .footer {
  left: 0 !important;
  max-width: calc(var(--vz-boxed-layout-width) - var(--vz-vertical-menu-width-sm));
}
@media (min-width: 768px) {
  [data-layout-width=boxed][data-sidebar-size=sm-hover] #page-topbar,
[data-layout-width=boxed][data-sidebar-size=sm-hover] .footer, [data-layout-width=boxed][data-sidebar-size=sm] #page-topbar,
[data-layout-width=boxed][data-sidebar-size=sm] .footer {
    left: var(--vz-vertical-menu-width-sm) !important;
  }
}
[data-layout-width=boxed][data-sidebar-size=sm-hover-active] #page-topbar,
[data-layout-width=boxed][data-sidebar-size=sm-hover-active] .footer, [data-layout-width=boxed][data-sidebar-size=lg] #page-topbar,
[data-layout-width=boxed][data-sidebar-size=lg] .footer {
  max-width: calc(var(--vz-boxed-layout-width) - var(--vz-vertical-menu-width));
}
@media (min-width: 768px) {
  [data-layout-width=boxed][data-sidebar-size=sm-hover-active] #page-topbar,
[data-layout-width=boxed][data-sidebar-size=sm-hover-active] .footer, [data-layout-width=boxed][data-sidebar-size=lg] #page-topbar,
[data-layout-width=boxed][data-sidebar-size=lg] .footer {
    left: var(--vz-vertical-menu-width) !important;
  }
}
[data-layout-width=boxed][data-sidebar-size=md] #page-topbar,
[data-layout-width=boxed][data-sidebar-size=md] .footer {
  max-width: calc(var(--vz-boxed-layout-width) - var(--vz-vertical-menu-width-md));
}
@media (min-width: 768px) {
  [data-layout-width=boxed][data-sidebar-size=md] #page-topbar,
[data-layout-width=boxed][data-sidebar-size=md] .footer {
    left: var(--vz-vertical-menu-width-md) !important;
  }
}
[data-layout-width=boxed][data-layout=vertical][data-layout-style=detached] body {
  background-color: var(--vz-body-bg);
}
@media (min-width: 1024.1px) {
  [data-layout-width=boxed][data-layout=vertical][data-layout-style=detached] #layout-wrapper {
    max-width: 1300px;
    box-shadow: none;
  }
  [data-layout-width=boxed][data-layout=vertical][data-layout-style=detached] .layout-width {
    max-width: 1300px;
  }
}
[data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=sm-hover] #page-topbar,
[data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=sm-hover] .footer, [data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=sm] #page-topbar,
[data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=sm] .footer, [data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=md] #page-topbar,
[data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=md] .footer, [data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=lg] #page-topbar,
[data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=lg] .footer {
  max-width: 100%;
  left: 0 !important;
}

[data-layout=horizontal][data-layout-width=boxed] #page-topbar,
[data-layout=horizontal][data-layout-width=boxed] #layout-wrapper,
[data-layout=horizontal][data-layout-width=boxed] .footer {
  max-width: 100%;
}
[data-layout=horizontal][data-layout-width=boxed] .container-fluid, [data-layout=horizontal][data-layout-width=boxed] .container-sm, [data-layout=horizontal][data-layout-width=boxed] .container-md, [data-layout=horizontal][data-layout-width=boxed] .container-lg, [data-layout=horizontal][data-layout-width=boxed] .container-xl, [data-layout=horizontal][data-layout-width=boxed] .container-xxl,
[data-layout=horizontal][data-layout-width=boxed] .navbar-header {
  max-width: var(--vz-boxed-layout-width);
}
[data-layout=horizontal][data-layout-width=boxed] .navbar-header {
  padding: 0 calc(1.5rem * 0.5) 0 0;
}
[data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=sm-hover] #page-topbar,
[data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=sm-hover] .footer, [data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=sm] [data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=sm-hover-active] #page-topbar,
[data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=sm] [data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=sm-hover-active] .footer, [data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=lg] #page-topbar,
[data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=lg] .footer {
  left: 0 !important;
}

@media (min-width: 992px) {
  [data-layout-position=scrollable] #page-topbar,
[data-layout-position=scrollable] .navbar-menu {
    position: absolute;
  }
}
@media (min-width: 992px) {
  [data-layout-position=scrollable][data-layout=horizontal] #page-topbar,
[data-layout-position=scrollable][data-layout=horizontal] .topnav {
    position: absolute;
  }
}

@media (min-width: 768px) {
  [data-layout=semibox][data-sidebar-visibility=hidden] .navbar-menu {
    display: none;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden] .horizontal-logo {
    display: inline-block;
    width: auto;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden] .footer {
    left: 0;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden] #page-topbar {
    left: 0;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden] .main-content {
    margin-left: 0px;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm] .navbar-brand-box, [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm-hover] .navbar-brand-box {
    position: static;
    padding: 0 1.3rem;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm] .logo span.logo-lg, [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm-hover] .logo span.logo-lg {
    display: inline-block;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm] .logo span.logo-sm, [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm-hover] .logo span.logo-sm {
    display: none;
  }
}
[data-layout=semibox][data-sidebar-visibility=hidden]:is([data-sidebar="dark"], [data-sidebar="gradient"], [data-sidebar="gradient-2"], [data-sidebar="gradient-3"], [data-sidebar="gradient-4"]) .logo-dark {
  display: none;
}
[data-layout=semibox][data-sidebar-visibility=hidden]:is([data-sidebar="dark"], [data-sidebar="gradient"], [data-sidebar="gradient-2"], [data-sidebar="gradient-3"], [data-sidebar="gradient-4"]) .logo-light {
  display: inline-block;
}
@media (min-width: 1440px) {
  [data-layout=semibox][data-sidebar-visibility=hidden] .navbar-menu {
    display: none;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden] .horizontal-logo {
    display: inline-block;
    width: auto;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden] .footer {
    left: calc(var(--vz-semibox-width) + 1.5rem);
  }
  [data-layout=semibox][data-sidebar-visibility=hidden] #page-topbar {
    left: calc(var(--vz-semibox-width) + 1.5rem);
  }
  [data-layout=semibox][data-sidebar-visibility=hidden] .main-content {
    margin-left: 0px;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm] .navbar-brand-box, [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm-hover] .navbar-brand-box {
    position: static;
    padding: 0 1.3rem;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm] .logo span.logo-lg, [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm-hover] .logo span.logo-lg {
    display: inline-block;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm] .logo span.logo-sm, [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm-hover] .logo span.logo-sm {
    display: none;
  }
}

/*!
 * Waves v0.7.6
 * http://fian.my.id/Waves 
 * 
 * Copyright 2014-2018 Alfiana E. Sibuea and other contributors 
 * Released under the MIT license 
 * https://github.com/fians/Waves/blob/master/LICENSE */
.waves-effect {
  position: relative;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  -webkit-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.waves-effect .waves-ripple {
  position: absolute;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin-top: -50px;
  margin-left: -50px;
  opacity: 0;
  background: rgba(0, 0, 0, 0.2);
  background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
  transition: all 0.5s ease-out;
  transition-property: transform, opacity;
  transform: scale(0) translate(0, 0);
  pointer-events: none;
}

.waves-effect.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
  background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
}

.waves-effect.waves-classic .waves-ripple {
  background: rgba(0, 0, 0, 0.2);
}

.waves-effect.waves-classic.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
}

.waves-notransition {
  transition: none !important;
}

.waves-button,
.waves-circle {
  transform: translateZ(0);
  -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);
}

.waves-button,
.waves-button:hover,
.waves-button:visited,
.waves-button-input {
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  border: none;
  outline: none;
  color: inherit;
  background-color: rgba(0, 0, 0, 0);
  font-size: 1em;
  line-height: 1em;
  text-align: center;
  text-decoration: none;
  z-index: 1;
}

.waves-button {
  padding: 0.85em 1.1em;
  border-radius: 0.2em;
}

.waves-button-input {
  margin: 0;
  padding: 0.85em 1.1em;
}

.waves-input-wrapper {
  border-radius: 0.2em;
  vertical-align: bottom;
}

.waves-input-wrapper.waves-button {
  padding: 0;
}

.waves-input-wrapper .waves-button-input {
  position: relative;
  top: 0;
  left: 0;
  z-index: 1;
}

.waves-circle {
  text-align: center;
  width: 2.5em;
  height: 2.5em;
  line-height: 2.5em;
  border-radius: 50%;
}

.waves-float {
  -webkit-mask-image: none;
  box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);
  transition: all 300ms;
}

.waves-float:active {
  box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);
}

.waves-block {
  display: block;
}

.waves-effect.waves-light .waves-ripple {
  background-color: rgba(255, 255, 255, 0.4);
}

.waves-effect.waves-primary .waves-ripple {
  background-color: rgba(180, 208, 240, 0.4);
}

.waves-effect.waves-success .waves-ripple {
  background-color: rgba(19, 197, 107, 0.4);
}

.waves-effect.waves-info .waves-ripple {
  background-color: rgba(80, 195, 230, 0.4);
}

.waves-effect.waves-warning .waves-ripple {
  background-color: rgba(232, 188, 82, 0.4);
}

.waves-effect.waves-danger .waves-ripple {
  background-color: rgba(237, 94, 94, 0.4);
}

.avatar-xxs {
  height: 1.5rem;
  width: 1.5rem;
}

.avatar-xs {
  height: 2rem;
  width: 2rem;
}

.avatar-sm {
  height: 3rem;
  width: 3rem;
}

.avatar-md {
  height: 4.5rem;
  width: 4.5rem;
}

.avatar-lg {
  height: 6rem;
  width: 6rem;
}

.avatar-xl {
  height: 7.5rem;
  width: 7.5rem;
}

.avatar-title {
  align-items: center;
  background-color: #b4d0f0;
  color: #fff;
  display: flex;
  font-weight: 400;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.avatar-group {
  padding-left: 12px;
  display: flex;
  flex-wrap: wrap;
}
.avatar-group .avatar-group-item {
  margin-left: -12px;
  border: 2px solid var(--vz-secondary-bg);
  border-radius: 50%;
  transition: all 0.2s;
}
.avatar-group .avatar-group-item:hover {
  position: relative;
  transform: translateY(-2px);
  z-index: 1;
}

.accordion .accordion-button {
  font-weight: 400;
}
.accordion .accordion-body {
  color: var(--vz-secondary-color);
}
.accordion.accordion-icon-none .accordion-button::after {
  content: "";
  background-image: none !important;
}
.accordion.accordion-icon-none .accordion-button:not(.collapsed)::after {
  content: "";
}

.custom-accordionwithicon .accordion-button::after {
  background-image: none !important;
  font-family: "Material Design Icons";
  content: "󰅂";
  font-size: 1.1rem;
  vertical-align: middle;
  line-height: 0.8;
}
.custom-accordionwithicon .accordion-button:not(.collapsed)::after {
  background-image: none !important;
  content: "󰅀";
  margin-right: -3px;
}

.custom-accordionwithicon-plus .accordion-button::after {
  background-image: none !important;
  font-family: "Material Design Icons";
  content: "󰐕";
  font-size: 1.1rem;
  vertical-align: middle;
  line-height: 0.8;
}
.custom-accordionwithicon-plus .accordion-button:not(.collapsed)::after {
  background-image: none !important;
  content: "󰍴";
  margin-right: -3px;
}

.lefticon-accordion .accordion-button {
  padding-left: 2.75rem;
}
.lefticon-accordion .accordion-button::after {
  position: absolute;
  left: 1.25rem;
  top: 14px;
}
.lefticon-accordion .accordion-button:not(.collapsed)::after {
  top: 20px;
}

.accordion-border-box .accordion-item {
  border-top: var(--vz-border-width) solid var(--vz-border-color);
  border-radius: var(--vz-border-radius);
}
.accordion-border-box .accordion-item:not(:first-of-type) {
  margin-top: 8px;
}
.accordion-border-box .accordion-item .accordion-button {
  border-radius: var(--vz-border-radius);
}
.accordion-border-box .accordion-item .accordion-button:not(.collapsed) {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.custom-accordion-border .accordion-item {
  border-left: 3px solid var(--vz-border-color);
}

.accordion-primary .accordion-item {
  border-color: rgba(180, 208, 240, 0.6);
}
.accordion-primary .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-primary .accordion-item .accordion-button:not(.collapsed) {
  color: #b4d0f0;
  background-color: rgba(180, 208, 240, 0.1) !important;
}
.accordion-primary .accordion-item .accordion-button::after {
  color: #b4d0f0;
}

.accordion-fill-primary .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-primary .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #b4d0f0 !important;
}

.accordion-secondary .accordion-item {
  border-color: rgba(218, 236, 251, 0.6);
}
.accordion-secondary .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-secondary .accordion-item .accordion-button:not(.collapsed) {
  color: #daecfb;
  background-color: rgba(218, 236, 251, 0.1) !important;
}
.accordion-secondary .accordion-item .accordion-button::after {
  color: #daecfb;
}

.accordion-fill-secondary .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-secondary .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #daecfb !important;
}

.accordion-success .accordion-item {
  border-color: rgba(19, 197, 107, 0.6);
}
.accordion-success .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-success .accordion-item .accordion-button:not(.collapsed) {
  color: #13c56b;
  background-color: rgba(19, 197, 107, 0.1) !important;
}
.accordion-success .accordion-item .accordion-button::after {
  color: #13c56b;
}

.accordion-fill-success .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-success .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #13c56b !important;
}

.accordion-info .accordion-item {
  border-color: rgba(80, 195, 230, 0.6);
}
.accordion-info .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-info .accordion-item .accordion-button:not(.collapsed) {
  color: #50c3e6;
  background-color: rgba(80, 195, 230, 0.1) !important;
}
.accordion-info .accordion-item .accordion-button::after {
  color: #50c3e6;
}

.accordion-fill-info .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-info .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #50c3e6 !important;
}

.accordion-warning .accordion-item {
  border-color: rgba(232, 188, 82, 0.6);
}
.accordion-warning .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-warning .accordion-item .accordion-button:not(.collapsed) {
  color: #e8bc52;
  background-color: rgba(232, 188, 82, 0.1) !important;
}
.accordion-warning .accordion-item .accordion-button::after {
  color: #e8bc52;
}

.accordion-fill-warning .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-warning .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #e8bc52 !important;
}

.accordion-danger .accordion-item {
  border-color: rgba(237, 94, 94, 0.6);
}
.accordion-danger .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-danger .accordion-item .accordion-button:not(.collapsed) {
  color: #ed5e5e;
  background-color: rgba(237, 94, 94, 0.1) !important;
}
.accordion-danger .accordion-item .accordion-button::after {
  color: #ed5e5e;
}

.accordion-fill-danger .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-danger .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #ed5e5e !important;
}

.accordion-light .accordion-item {
  border-color: rgba(243, 246, 249, 0.6);
}
.accordion-light .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-light .accordion-item .accordion-button:not(.collapsed) {
  color: #f3f6f9;
  background-color: rgba(243, 246, 249, 0.1) !important;
}
.accordion-light .accordion-item .accordion-button::after {
  color: #f3f6f9;
}

.accordion-fill-light .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-light .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #f3f6f9 !important;
}

.accordion-dark .accordion-item {
  border-color: rgba(54, 61, 72, 0.6);
}
.accordion-dark .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-dark .accordion-item .accordion-button:not(.collapsed) {
  color: #363d48;
  background-color: rgba(54, 61, 72, 0.1) !important;
}
.accordion-dark .accordion-item .accordion-button::after {
  color: #363d48;
}

.accordion-fill-dark .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-dark .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #363d48 !important;
}

.accordion-custom-primary .accordion-item {
  border-color: rgba(126, 171, 231, 0.6);
}
.accordion-custom-primary .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-custom-primary .accordion-item .accordion-button:not(.collapsed) {
  color: #7eabe7;
  background-color: rgba(126, 171, 231, 0.1) !important;
}
.accordion-custom-primary .accordion-item .accordion-button::after {
  color: #7eabe7;
}

.accordion-fill-custom-primary .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-custom-primary .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #7eabe7 !important;
}

.accordion-custom-primary-hover .accordion-item {
  border-color: rgba(188, 212, 248, 0.6);
}
.accordion-custom-primary-hover .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-custom-primary-hover .accordion-item .accordion-button:not(.collapsed) {
  color: #bcd4f8;
  background-color: rgba(188, 212, 248, 0.1) !important;
}
.accordion-custom-primary-hover .accordion-item .accordion-button::after {
  color: #bcd4f8;
}

.accordion-fill-custom-primary-hover .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-custom-primary-hover .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #bcd4f8 !important;
}

.accordion-new-primary .accordion-item {
  border-color: rgba(10, 86, 174, 0.6);
}
.accordion-new-primary .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-new-primary .accordion-item .accordion-button:not(.collapsed) {
  color: #0A56AE;
  background-color: rgba(10, 86, 174, 0.1) !important;
}
.accordion-new-primary .accordion-item .accordion-button::after {
  color: #0A56AE;
}

.accordion-fill-new-primary .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-new-primary .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #0A56AE !important;
}

.accordion-header .accordion-item {
  border-color: rgba(189, 214, 251, 0.6);
}
.accordion-header .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-header .accordion-item .accordion-button:not(.collapsed) {
  color: #bdd6fb;
  background-color: rgba(189, 214, 251, 0.1) !important;
}
.accordion-header .accordion-item .accordion-button::after {
  color: #bdd6fb;
}

.accordion-fill-header .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-header .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #bdd6fb !important;
}

.accordion-next-button .accordion-item {
  border-color: rgba(131, 169, 226, 0.6);
}
.accordion-next-button .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-next-button .accordion-item .accordion-button:not(.collapsed) {
  color: #83a9e2;
  background-color: rgba(131, 169, 226, 0.1) !important;
}
.accordion-next-button .accordion-item .accordion-button::after {
  color: #83a9e2;
}

.accordion-fill-next-button .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-next-button .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #83a9e2 !important;
}

.accordion-next-button-border .accordion-item {
  border-color: rgba(93, 135, 199, 0.6);
}
.accordion-next-button-border .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-next-button-border .accordion-item .accordion-button:not(.collapsed) {
  color: #5d87c7;
  background-color: rgba(93, 135, 199, 0.1) !important;
}
.accordion-next-button-border .accordion-item .accordion-button::after {
  color: #5d87c7;
}

.accordion-fill-next-button-border .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-next-button-border .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #5d87c7 !important;
}

.accordion-next-button-hover .accordion-item {
  border-color: rgba(189, 214, 250, 0.6);
}
.accordion-next-button-hover .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-next-button-hover .accordion-item .accordion-button:not(.collapsed) {
  color: #bdd6fa;
  background-color: rgba(189, 214, 250, 0.1) !important;
}
.accordion-next-button-hover .accordion-item .accordion-button::after {
  color: #bdd6fa;
}

.accordion-fill-next-button-hover .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-next-button-hover .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #bdd6fa !important;
}

.accordion-white .accordion-item {
  border-color: rgba(255, 255, 255, 0.6);
}
.accordion-white .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-white .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.1) !important;
}
.accordion-white .accordion-item .accordion-button::after {
  color: #fff;
}

.accordion-fill-white .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-white .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #fff !important;
}

.accordion-light-grey .accordion-item {
  border-color: rgba(206, 212, 218, 0.6);
}
.accordion-light-grey .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-light-grey .accordion-item .accordion-button:not(.collapsed) {
  color: #ced4da;
  background-color: rgba(206, 212, 218, 0.1) !important;
}
.accordion-light-grey .accordion-item .accordion-button::after {
  color: #ced4da;
}

.accordion-fill-light-grey .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-light-grey .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #ced4da !important;
}

[dir=rtl] .custom-accordionwithicon .accordion-button::after {
  transform: rotate(180deg);
}

.border-double {
  border-style: double !important;
}

.border-top-double {
  border-top-style: double !important;
}

.border-bottom-double {
  border-bottom-style: double !important;
}

.border-end-double {
  border-right-style: double !important;
}

.border-start-double {
  border-left-style: double !important;
}

.list-group-flush.border-double {
  border: none !important;
}
.list-group-flush.border-double .list-group-item {
  border-style: double !important;
}

.border-dashed {
  border-style: dashed !important;
}

.border-top-dashed {
  border-top-style: dashed !important;
}

.border-bottom-dashed {
  border-bottom-style: dashed !important;
}

.border-end-dashed {
  border-right-style: dashed !important;
}

.border-start-dashed {
  border-left-style: dashed !important;
}

.list-group-flush.border-dashed {
  border: none !important;
}
.list-group-flush.border-dashed .list-group-item {
  border-style: dashed !important;
}

.border-groove {
  border-style: groove !important;
}

.border-top-groove {
  border-top-style: groove !important;
}

.border-bottom-groove {
  border-bottom-style: groove !important;
}

.border-end-groove {
  border-right-style: groove !important;
}

.border-start-groove {
  border-left-style: groove !important;
}

.list-group-flush.border-groove {
  border: none !important;
}
.list-group-flush.border-groove .list-group-item {
  border-style: groove !important;
}

.border-outset {
  border-style: outset !important;
}

.border-top-outset {
  border-top-style: outset !important;
}

.border-bottom-outset {
  border-bottom-style: outset !important;
}

.border-end-outset {
  border-right-style: outset !important;
}

.border-start-outset {
  border-left-style: outset !important;
}

.list-group-flush.border-outset {
  border: none !important;
}
.list-group-flush.border-outset .list-group-item {
  border-style: outset !important;
}

.border-ridge {
  border-style: ridge !important;
}

.border-top-ridge {
  border-top-style: ridge !important;
}

.border-bottom-ridge {
  border-bottom-style: ridge !important;
}

.border-end-ridge {
  border-right-style: ridge !important;
}

.border-start-ridge {
  border-left-style: ridge !important;
}

.list-group-flush.border-ridge {
  border: none !important;
}
.list-group-flush.border-ridge .list-group-item {
  border-style: ridge !important;
}

.border-dotted {
  border-style: dotted !important;
}

.border-top-dotted {
  border-top-style: dotted !important;
}

.border-bottom-dotted {
  border-bottom-style: dotted !important;
}

.border-end-dotted {
  border-right-style: dotted !important;
}

.border-start-dotted {
  border-left-style: dotted !important;
}

.list-group-flush.border-dotted {
  border: none !important;
}
.list-group-flush.border-dotted .list-group-item {
  border-style: dotted !important;
}

.border-inset {
  border-style: inset !important;
}

.border-top-inset {
  border-top-style: inset !important;
}

.border-bottom-inset {
  border-bottom-style: inset !important;
}

.border-end-inset {
  border-right-style: inset !important;
}

.border-start-inset {
  border-left-style: inset !important;
}

.list-group-flush.border-inset {
  border: none !important;
}
.list-group-flush.border-inset .list-group-item {
  border-style: inset !important;
}

.ff-base {
  font-family: var(--vz-font-sans-serif);
}

.ff-secondary {
  font-family: "Montserrat", sans-serif;
}

.bg-pattern {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_65___}) var(--vz-secondary-bg);
}

.w-xs {
  min-width: 80px;
}

.w-sm {
  min-width: 95px;
}

.w-md {
  min-width: 110px;
}

.w-lg {
  min-width: 140px;
}

.w-xl {
  min-width: 160px;
}

.icon-xs {
  height: 16px;
  width: 16px;
}

.icon-sm {
  height: 18px;
  width: 18px;
}

.icon-md {
  height: 22px;
  width: 22px;
}

.icon-lg {
  height: 24px;
  width: 24px;
}

.icon-xl {
  height: 28px;
  width: 28px;
}

.icon-xxl {
  height: 32px;
  width: 32px;
}

.icon-dual {
  color: #adb5bd;
  fill: rgba(173, 181, 189, 0.16);
}

.icon-dual-primary {
  color: #b4d0f0;
  fill: rgba(180, 208, 240, 0.16);
}

.icon-dual-secondary {
  color: #daecfb;
  fill: rgba(218, 236, 251, 0.16);
}

.icon-dual-success {
  color: #13c56b;
  fill: rgba(19, 197, 107, 0.16);
}

.icon-dual-info {
  color: #50c3e6;
  fill: rgba(80, 195, 230, 0.16);
}

.icon-dual-warning {
  color: #e8bc52;
  fill: rgba(232, 188, 82, 0.16);
}

.icon-dual-danger {
  color: #ed5e5e;
  fill: rgba(237, 94, 94, 0.16);
}

.icon-dual-light {
  color: #f3f6f9;
  fill: rgba(243, 246, 249, 0.16);
}

.icon-dual-dark {
  color: #363d48;
  fill: rgba(54, 61, 72, 0.16);
}

.icon-dual-custom-primary {
  color: #7eabe7;
  fill: rgba(126, 171, 231, 0.16);
}

.icon-dual-custom-primary-hover {
  color: #bcd4f8;
  fill: rgba(188, 212, 248, 0.16);
}

.icon-dual-new-primary {
  color: #0A56AE;
  fill: rgba(10, 86, 174, 0.16);
}

.icon-dual-header {
  color: #bdd6fb;
  fill: rgba(189, 214, 251, 0.16);
}

.icon-dual-next-button {
  color: #83a9e2;
  fill: rgba(131, 169, 226, 0.16);
}

.icon-dual-next-button-border {
  color: #5d87c7;
  fill: rgba(93, 135, 199, 0.16);
}

.icon-dual-next-button-hover {
  color: #bdd6fa;
  fill: rgba(189, 214, 250, 0.16);
}

.icon-dual-white {
  color: #fff;
  fill: rgba(255, 255, 255, 0.16);
}

.icon-dual-light-grey {
  color: #ced4da;
  fill: rgba(206, 212, 218, 0.16);
}

.search-box {
  position: relative;
}
.search-box .form-control {
  padding-left: 40px;
}
.search-box .search-icon {
  font-size: 14px;
  position: absolute;
  left: 13px;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  color: var(--vz-secondary-color);
}

.bg-overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
  opacity: 0.7;
  background-color: #000;
}

.customizer-setting {
  position: fixed;
  bottom: 40px;
  right: 20px;
  z-index: 1000;
}

code {
  -webkit-user-select: all;
          user-select: all;
}

.layout-rightside {
  width: 280px;
  margin-right: calc(1.5rem * -1);
  margin-top: calc(1px - 1.5rem * 1.1);
  height: calc(100% + 1.5rem * 1.1);
}

@media (max-width: 1699.98px) {
  .layout-rightside-col {
    display: none;
    position: fixed !important;
    height: 100vh;
    right: 0px;
    top: 0px;
    bottom: 0px;
    z-index: 1004;
  }
  .layout-rightside-col .overlay {
    position: fixed;
    top: 0;
    right: 0px;
    bottom: 0px;
    left: 0px;
    background-color: rgba(54, 61, 72, 0.2);
  }
  .layout-rightside-col .layout-rightside {
    margin-top: 0px;
    height: 100%;
    margin-left: auto;
  }
  .layout-rightside-col .card-body {
    overflow-y: auto;
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 1700px) {
  :is([data-layout="horizontal"], [data-layout-style=detached]) .layout-rightside {
    margin-top: calc(28px - 1.5rem);
    margin-right: 0;
    height: calc(100% - calc(1.5rem * 0.5));
  }
}

[data-layout=semibox] .layout-rightside {
  margin-right: 0px;
}

.text-truncate-two-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  white-space: normal;
}

.favourite-btn {
  border-color: transparent;
}
.favourite-btn .ri-star-fill {
  color: var(--vz-secondary-color);
}
.favourite-btn.active {
  border-color: transparent;
}
.favourite-btn.active .ri-star-fill {
  color: #e8bc52;
}
.favourite-btn.active .ri-star-fill:before {
  content: "";
}

.card-logo-light {
  display: var(--vz-card-logo-light);
}

.card-logo-dark {
  display: var(--vz-card-logo-dark);
}

#back-to-top {
  position: fixed;
  bottom: 100px;
  right: 28px;
  transition: all 0.5s ease;
  display: none;
  z-index: 1000;
}
#back-to-top:hover {
  animation: fade-up 1.5s infinite linear;
}

@keyframes fade-up {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  75% {
    transform: translateY(-20px);
    opacity: 0;
  }
}
#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--vz-secondary-bg);
  z-index: 9999;
}

[data-preloader=disable] #preloader {
  opacity: 0;
  visibility: hidden;
}

#status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}

:is([type="tel"], [type="url"], [type="email"], [type="number"])::placeholder {
  text-align: left;
}

.main-chart .chart-border-left {
  border-left: 1.4px solid var(--vz-border-color);
  padding: 2px 20px;
}
.main-chart .chart-border-left:last-child {
  margin-right: 0px;
}

/* Activity */
.activity-feed {
  list-style: none;
}
.activity-feed .feed-item {
  position: relative;
  padding-bottom: 27px;
  padding-left: 16px;
  border-left: 2px solid var(--vz-border-color);
}
.activity-feed .feed-item:after {
  content: "";
  display: block;
  position: absolute;
  top: 4px;
  left: -6px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid #b4d0f0;
  background-color: var(--vz-secondary-bg);
}
.activity-feed .feed-item:last-child {
  border-color: transparent;
}

.mini-stats-wid {
  position: relative;
}
.mini-stats-wid .mini-stat-icon {
  overflow: hidden;
  position: relative;
}
.mini-stats-wid .mini-stat-icon:before, .mini-stats-wid .mini-stat-icon:after {
  content: "";
  position: absolute;
  width: 8px;
  height: 69px;
  background-color: rgba(19, 197, 107, 0.1);
  left: 3px;
  transform: rotate(32deg);
  top: -8px;
  transition: all 0.4s;
}
.mini-stats-wid .mini-stat-icon::after {
  left: 27px;
  width: 8px;
  transition: all 0.2s;
}
.mini-stats-wid:hover .mini-stat-icon::after {
  left: 60px;
}
.mini-stats-wid:hover .mini-stat-icon::before {
  left: 50px;
}

.card-wrapper .jp-card .jp-card-back, .card-wrapper .jp-card .jp-card-front {
  background-color: #13c56b;
}

.notification-elem {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: var(--vz-secondary-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: hidden;
  opacity: 0;
}

.clothes-size li input[type=radio] {
  display: none;
}
.clothes-size li label {
  display: inline-block;
  font-size: 14px;
  border-radius: 5px;
  border: 1px solid var(--vz-border-color);
  text-transform: none;
  letter-spacing: 0;
  color: #b4d0f0;
}
.clothes-size li input[type=radio]:checked + label {
  background-color: #b4d0f0;
  border-color: #b4d0f0;
  color: #fff;
}

.bs-example-modal {
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  z-index: 1;
  display: block;
}

[dir=rtl] .modal-open {
  padding-left: 0px !important;
}

.icon-demo-content {
  color: var(--vz-gray-500);
}
.icon-demo-content i {
  font-size: 24px;
  margin-right: 10px;
  color: var(--vz-gray-600);
  transition: all 0.4s;
  vertical-align: middle;
}
.icon-demo-content svg {
  margin-right: 10px;
  transition: all 0.4s;
  height: 20px;
}
.icon-demo-content .col-lg-4 {
  margin-top: 24px;
}
.icon-demo-content .col-lg-4:hover i, .icon-demo-content .col-lg-4:hover svg {
  color: #b4d0f0;
  transform: scale(1.5);
}

.img-switch .card-radio .form-check-input {
  display: none;
}
.img-switch .card-radio .form-check-input:checked + .form-check-label::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(180, 208, 240, 0.5);
}
.img-switch .card-radio .form-check-input:checked + .form-check-label::after {
  content: "";
  font-family: "remixicon";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  font-size: 18px;
  color: #fff;
}

[data-bs-target="#collapseBgGradient"].active {
  border-color: #b4d0f0 !important;
}
[data-bs-target="#collapseBgGradient"].active::before {
  content: "";
  font-family: remixicon;
  position: absolute;
  top: 2px;
  right: 6px;
  font-size: 16px;
  color: #b4d0f0;
}

@media print {
  .vertical-menu,
.right-bar,
.page-title-box,
.navbar-header,
.app-menu,
.footer,
#back-to-top {
    display: none !important;
  }

  .card-body,
.main-content,
.right-bar,
.page-content,
body {
    padding: 0;
    margin: 0;
  }

  .card {
    border: 0;
    box-shadow: none !important;
  }

  .invoice-details .d-sm-flex {
    display: flex !important;
  }

  .address.col-sm-6 {
    flex: 0 0 auto !important;
    width: 50% !important;
    max-width: 100% !important;
  }
}
.ribbon-box {
  position: relative;
  /* Ribbon two */
}
.ribbon-box .ribbon {
  padding: 5px 12px;
  box-shadow: 2px 5px 10px rgba(54, 61, 72, 0.15);
  color: #fff;
  font-size: 0.825rem;
  font-weight: 500;
  position: absolute;
  left: -1px;
  top: 5px;
}
.ribbon-box .ribbon.round-shape {
  border-radius: 0 30px 30px 0;
}
.ribbon-box .ribbon.ribbon-shape {
  display: inline-block;
}
.ribbon-box .ribbon.ribbon-shape::before {
  content: "";
  position: absolute;
  right: -17px;
  top: 0;
  border: 14px solid transparent;
}
.ribbon-box .ribbon.ribbon-shape::after {
  content: "";
  position: absolute;
  right: -17px;
  bottom: 0;
  border: 14px solid transparent;
}
.ribbon-box.ribbon-circle .ribbon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 20px;
  top: 20px;
}
.ribbon-box.ribbon-fill {
  overflow: hidden;
}
.ribbon-box.ribbon-fill .ribbon {
  transform: rotate(-45deg);
  width: 93px;
  height: 52px;
  left: -36px;
  top: -16px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.ribbon-box.ribbon-fill.ribbon-sm .ribbon {
  padding: 2px 12px;
  width: 78px;
  height: 42px;
  font-size: 12px;
  box-shadow: none;
}
.ribbon-box.right .ribbon {
  position: absolute;
  left: auto;
  right: 0;
}
.ribbon-box.right .ribbon.round-shape {
  border-radius: 30px 0 0 30px;
}
.ribbon-box.right .ribbon.ribbon-shape {
  text-align: right;
}
.ribbon-box.right .ribbon.ribbon-shape::before, .ribbon-box.right .ribbon.ribbon-shape::after {
  right: auto;
  left: -17px;
  border-left-color: transparent;
}
.ribbon-box.right.ribbon-circle .ribbon {
  left: auto;
  right: 20px;
}
.ribbon-box.right .icon-ribbon {
  right: 24px;
  left: auto;
}
.ribbon-box.right.ribbon-fill .ribbon {
  transform: rotate(45deg);
  right: -38px;
  left: auto;
}
.ribbon-box.right.ribbon-box .ribbon-two {
  left: auto;
  right: -5px;
}
.ribbon-box.right.ribbon-box .ribbon-two span {
  left: auto;
  right: -21px;
  transform: rotate(45deg);
}
.ribbon-box .ribbon-content {
  clear: both;
}
.ribbon-box .ribbon-primary {
  background: #b4d0f0;
}
.ribbon-box .ribbon-primary:before {
  border-color: #8ab5e8 transparent transparent;
}
.ribbon-box .ribbon-primary.ribbon-shape::before {
  border-left-color: #b4d0f0;
  border-top-color: #b4d0f0;
}
.ribbon-box .ribbon-primary.ribbon-shape::after {
  border-left-color: #b4d0f0;
  border-bottom-color: #b4d0f0;
}
.ribbon-box.right .ribbon-primary {
  background: #b4d0f0;
}
.ribbon-box.right .ribbon-primary.ribbon-shape::before {
  border-right-color: #b4d0f0;
  border-top-color: #b4d0f0;
}
.ribbon-box.right .ribbon-primary.ribbon-shape::after {
  border-right-color: #b4d0f0;
  border-bottom-color: #b4d0f0;
}
.ribbon-box .ribbon-secondary {
  background: #daecfb;
}
.ribbon-box .ribbon-secondary:before {
  border-color: #acd4f6 transparent transparent;
}
.ribbon-box .ribbon-secondary.ribbon-shape::before {
  border-left-color: #daecfb;
  border-top-color: #daecfb;
}
.ribbon-box .ribbon-secondary.ribbon-shape::after {
  border-left-color: #daecfb;
  border-bottom-color: #daecfb;
}
.ribbon-box.right .ribbon-secondary {
  background: #daecfb;
}
.ribbon-box.right .ribbon-secondary.ribbon-shape::before {
  border-right-color: #daecfb;
  border-top-color: #daecfb;
}
.ribbon-box.right .ribbon-secondary.ribbon-shape::after {
  border-right-color: #daecfb;
  border-bottom-color: #daecfb;
}
.ribbon-box .ribbon-success {
  background: #13c56b;
}
.ribbon-box .ribbon-success:before {
  border-color: #0f9652 transparent transparent;
}
.ribbon-box .ribbon-success.ribbon-shape::before {
  border-left-color: #13c56b;
  border-top-color: #13c56b;
}
.ribbon-box .ribbon-success.ribbon-shape::after {
  border-left-color: #13c56b;
  border-bottom-color: #13c56b;
}
.ribbon-box.right .ribbon-success {
  background: #13c56b;
}
.ribbon-box.right .ribbon-success.ribbon-shape::before {
  border-right-color: #13c56b;
  border-top-color: #13c56b;
}
.ribbon-box.right .ribbon-success.ribbon-shape::after {
  border-right-color: #13c56b;
  border-bottom-color: #13c56b;
}
.ribbon-box .ribbon-info {
  background: #50c3e6;
}
.ribbon-box .ribbon-info:before {
  border-color: #23b4e0 transparent transparent;
}
.ribbon-box .ribbon-info.ribbon-shape::before {
  border-left-color: #50c3e6;
  border-top-color: #50c3e6;
}
.ribbon-box .ribbon-info.ribbon-shape::after {
  border-left-color: #50c3e6;
  border-bottom-color: #50c3e6;
}
.ribbon-box.right .ribbon-info {
  background: #50c3e6;
}
.ribbon-box.right .ribbon-info.ribbon-shape::before {
  border-right-color: #50c3e6;
  border-top-color: #50c3e6;
}
.ribbon-box.right .ribbon-info.ribbon-shape::after {
  border-right-color: #50c3e6;
  border-bottom-color: #50c3e6;
}
.ribbon-box .ribbon-warning {
  background: #e8bc52;
}
.ribbon-box .ribbon-warning:before {
  border-color: #e2ab25 transparent transparent;
}
.ribbon-box .ribbon-warning.ribbon-shape::before {
  border-left-color: #e8bc52;
  border-top-color: #e8bc52;
}
.ribbon-box .ribbon-warning.ribbon-shape::after {
  border-left-color: #e8bc52;
  border-bottom-color: #e8bc52;
}
.ribbon-box.right .ribbon-warning {
  background: #e8bc52;
}
.ribbon-box.right .ribbon-warning.ribbon-shape::before {
  border-right-color: #e8bc52;
  border-top-color: #e8bc52;
}
.ribbon-box.right .ribbon-warning.ribbon-shape::after {
  border-right-color: #e8bc52;
  border-bottom-color: #e8bc52;
}
.ribbon-box .ribbon-danger {
  background: #ed5e5e;
}
.ribbon-box .ribbon-danger:before {
  border-color: #e83030 transparent transparent;
}
.ribbon-box .ribbon-danger.ribbon-shape::before {
  border-left-color: #ed5e5e;
  border-top-color: #ed5e5e;
}
.ribbon-box .ribbon-danger.ribbon-shape::after {
  border-left-color: #ed5e5e;
  border-bottom-color: #ed5e5e;
}
.ribbon-box.right .ribbon-danger {
  background: #ed5e5e;
}
.ribbon-box.right .ribbon-danger.ribbon-shape::before {
  border-right-color: #ed5e5e;
  border-top-color: #ed5e5e;
}
.ribbon-box.right .ribbon-danger.ribbon-shape::after {
  border-right-color: #ed5e5e;
  border-bottom-color: #ed5e5e;
}
.ribbon-box .ribbon-light {
  background: #f3f6f9;
}
.ribbon-box .ribbon-light:before {
  border-color: #d1dde8 transparent transparent;
}
.ribbon-box .ribbon-light.ribbon-shape::before {
  border-left-color: #f3f6f9;
  border-top-color: #f3f6f9;
}
.ribbon-box .ribbon-light.ribbon-shape::after {
  border-left-color: #f3f6f9;
  border-bottom-color: #f3f6f9;
}
.ribbon-box.right .ribbon-light {
  background: #f3f6f9;
}
.ribbon-box.right .ribbon-light.ribbon-shape::before {
  border-right-color: #f3f6f9;
  border-top-color: #f3f6f9;
}
.ribbon-box.right .ribbon-light.ribbon-shape::after {
  border-right-color: #f3f6f9;
  border-bottom-color: #f3f6f9;
}
.ribbon-box .ribbon-dark {
  background: #363d48;
}
.ribbon-box .ribbon-dark:before {
  border-color: #20242b transparent transparent;
}
.ribbon-box .ribbon-dark.ribbon-shape::before {
  border-left-color: #363d48;
  border-top-color: #363d48;
}
.ribbon-box .ribbon-dark.ribbon-shape::after {
  border-left-color: #363d48;
  border-bottom-color: #363d48;
}
.ribbon-box.right .ribbon-dark {
  background: #363d48;
}
.ribbon-box.right .ribbon-dark.ribbon-shape::before {
  border-right-color: #363d48;
  border-top-color: #363d48;
}
.ribbon-box.right .ribbon-dark.ribbon-shape::after {
  border-right-color: #363d48;
  border-bottom-color: #363d48;
}
.ribbon-box .ribbon-custom-primary {
  background: #7eabe7;
}
.ribbon-box .ribbon-custom-primary:before {
  border-color: #538fdf transparent transparent;
}
.ribbon-box .ribbon-custom-primary.ribbon-shape::before {
  border-left-color: #7eabe7;
  border-top-color: #7eabe7;
}
.ribbon-box .ribbon-custom-primary.ribbon-shape::after {
  border-left-color: #7eabe7;
  border-bottom-color: #7eabe7;
}
.ribbon-box.right .ribbon-custom-primary {
  background: #7eabe7;
}
.ribbon-box.right .ribbon-custom-primary.ribbon-shape::before {
  border-right-color: #7eabe7;
  border-top-color: #7eabe7;
}
.ribbon-box.right .ribbon-custom-primary.ribbon-shape::after {
  border-right-color: #7eabe7;
  border-bottom-color: #7eabe7;
}
.ribbon-box .ribbon-custom-primary-hover {
  background: #bcd4f8;
}
.ribbon-box .ribbon-custom-primary-hover:before {
  border-color: #8eb6f3 transparent transparent;
}
.ribbon-box .ribbon-custom-primary-hover.ribbon-shape::before {
  border-left-color: #bcd4f8;
  border-top-color: #bcd4f8;
}
.ribbon-box .ribbon-custom-primary-hover.ribbon-shape::after {
  border-left-color: #bcd4f8;
  border-bottom-color: #bcd4f8;
}
.ribbon-box.right .ribbon-custom-primary-hover {
  background: #bcd4f8;
}
.ribbon-box.right .ribbon-custom-primary-hover.ribbon-shape::before {
  border-right-color: #bcd4f8;
  border-top-color: #bcd4f8;
}
.ribbon-box.right .ribbon-custom-primary-hover.ribbon-shape::after {
  border-right-color: #bcd4f8;
  border-bottom-color: #bcd4f8;
}
.ribbon-box .ribbon-new-primary {
  background: #0A56AE;
}
.ribbon-box .ribbon-new-primary:before {
  border-color: #073e7e transparent transparent;
}
.ribbon-box .ribbon-new-primary.ribbon-shape::before {
  border-left-color: #0A56AE;
  border-top-color: #0A56AE;
}
.ribbon-box .ribbon-new-primary.ribbon-shape::after {
  border-left-color: #0A56AE;
  border-bottom-color: #0A56AE;
}
.ribbon-box.right .ribbon-new-primary {
  background: #0A56AE;
}
.ribbon-box.right .ribbon-new-primary.ribbon-shape::before {
  border-right-color: #0A56AE;
  border-top-color: #0A56AE;
}
.ribbon-box.right .ribbon-new-primary.ribbon-shape::after {
  border-right-color: #0A56AE;
  border-bottom-color: #0A56AE;
}
.ribbon-box .ribbon-header {
  background: #bdd6fb;
}
.ribbon-box .ribbon-header:before {
  border-color: #8db8f8 transparent transparent;
}
.ribbon-box .ribbon-header.ribbon-shape::before {
  border-left-color: #bdd6fb;
  border-top-color: #bdd6fb;
}
.ribbon-box .ribbon-header.ribbon-shape::after {
  border-left-color: #bdd6fb;
  border-bottom-color: #bdd6fb;
}
.ribbon-box.right .ribbon-header {
  background: #bdd6fb;
}
.ribbon-box.right .ribbon-header.ribbon-shape::before {
  border-right-color: #bdd6fb;
  border-top-color: #bdd6fb;
}
.ribbon-box.right .ribbon-header.ribbon-shape::after {
  border-right-color: #bdd6fb;
  border-bottom-color: #bdd6fb;
}
.ribbon-box .ribbon-next-button {
  background: #83a9e2;
}
.ribbon-box .ribbon-next-button:before {
  border-color: #5a8cd8 transparent transparent;
}
.ribbon-box .ribbon-next-button.ribbon-shape::before {
  border-left-color: #83a9e2;
  border-top-color: #83a9e2;
}
.ribbon-box .ribbon-next-button.ribbon-shape::after {
  border-left-color: #83a9e2;
  border-bottom-color: #83a9e2;
}
.ribbon-box.right .ribbon-next-button {
  background: #83a9e2;
}
.ribbon-box.right .ribbon-next-button.ribbon-shape::before {
  border-right-color: #83a9e2;
  border-top-color: #83a9e2;
}
.ribbon-box.right .ribbon-next-button.ribbon-shape::after {
  border-right-color: #83a9e2;
  border-bottom-color: #83a9e2;
}
.ribbon-box .ribbon-next-button-border {
  background: #5d87c7;
}
.ribbon-box .ribbon-next-button-border:before {
  border-color: #3e6cb3 transparent transparent;
}
.ribbon-box .ribbon-next-button-border.ribbon-shape::before {
  border-left-color: #5d87c7;
  border-top-color: #5d87c7;
}
.ribbon-box .ribbon-next-button-border.ribbon-shape::after {
  border-left-color: #5d87c7;
  border-bottom-color: #5d87c7;
}
.ribbon-box.right .ribbon-next-button-border {
  background: #5d87c7;
}
.ribbon-box.right .ribbon-next-button-border.ribbon-shape::before {
  border-right-color: #5d87c7;
  border-top-color: #5d87c7;
}
.ribbon-box.right .ribbon-next-button-border.ribbon-shape::after {
  border-right-color: #5d87c7;
  border-bottom-color: #5d87c7;
}
.ribbon-box .ribbon-next-button-hover {
  background: #bdd6fa;
}
.ribbon-box .ribbon-next-button-hover:before {
  border-color: #8eb9f6 transparent transparent;
}
.ribbon-box .ribbon-next-button-hover.ribbon-shape::before {
  border-left-color: #bdd6fa;
  border-top-color: #bdd6fa;
}
.ribbon-box .ribbon-next-button-hover.ribbon-shape::after {
  border-left-color: #bdd6fa;
  border-bottom-color: #bdd6fa;
}
.ribbon-box.right .ribbon-next-button-hover {
  background: #bdd6fa;
}
.ribbon-box.right .ribbon-next-button-hover.ribbon-shape::before {
  border-right-color: #bdd6fa;
  border-top-color: #bdd6fa;
}
.ribbon-box.right .ribbon-next-button-hover.ribbon-shape::after {
  border-right-color: #bdd6fa;
  border-bottom-color: #bdd6fa;
}
.ribbon-box .ribbon-white {
  background: #fff;
}
.ribbon-box .ribbon-white:before {
  border-color: #e6e6e6 transparent transparent;
}
.ribbon-box .ribbon-white.ribbon-shape::before {
  border-left-color: #fff;
  border-top-color: #fff;
}
.ribbon-box .ribbon-white.ribbon-shape::after {
  border-left-color: #fff;
  border-bottom-color: #fff;
}
.ribbon-box.right .ribbon-white {
  background: #fff;
}
.ribbon-box.right .ribbon-white.ribbon-shape::before {
  border-right-color: #fff;
  border-top-color: #fff;
}
.ribbon-box.right .ribbon-white.ribbon-shape::after {
  border-right-color: #fff;
  border-bottom-color: #fff;
}
.ribbon-box .ribbon-light-grey {
  background: #ced4da;
}
.ribbon-box .ribbon-light-grey:before {
  border-color: #b1bbc4 transparent transparent;
}
.ribbon-box .ribbon-light-grey.ribbon-shape::before {
  border-left-color: #ced4da;
  border-top-color: #ced4da;
}
.ribbon-box .ribbon-light-grey.ribbon-shape::after {
  border-left-color: #ced4da;
  border-bottom-color: #ced4da;
}
.ribbon-box.right .ribbon-light-grey {
  background: #ced4da;
}
.ribbon-box.right .ribbon-light-grey.ribbon-shape::before {
  border-right-color: #ced4da;
  border-top-color: #ced4da;
}
.ribbon-box.right .ribbon-light-grey.ribbon-shape::after {
  border-right-color: #ced4da;
  border-bottom-color: #ced4da;
}
.ribbon-box .icon-ribbon {
  box-shadow: none;
  left: 24px;
  top: -12px;
  font-size: 40px;
  padding: 0;
}
.ribbon-box .ribbon-two {
  position: absolute;
  left: -5px;
  top: -5px;
  z-index: 1;
  overflow: hidden;
  width: 75px;
  height: 75px;
  text-align: right;
}
.ribbon-box .ribbon-two span {
  font-size: 13px;
  color: #fff;
  text-align: center;
  line-height: 20px;
  transform: rotate(-45deg);
  width: 100px;
  display: block;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);
  position: absolute;
  top: 19px;
  left: -21px;
  font-weight: 500;
}
.ribbon-box .ribbon-two span:before {
  content: "";
  position: absolute;
  left: 0;
  top: 100%;
  z-index: -1;
  border-right: 3px solid transparent;
  border-bottom: 3px solid transparent;
}
.ribbon-box .ribbon-two span:after {
  content: "";
  position: absolute;
  right: 0;
  top: 100%;
  z-index: -1;
  border-left: 3px solid transparent;
  border-bottom: 3px solid transparent;
}
.ribbon-box .ribbon-two-primary span {
  background: #b4d0f0;
}
.ribbon-box .ribbon-two-primary span:before {
  border-left: 3px solid #74a8e3;
  border-top: 3px solid #74a8e3;
}
.ribbon-box .ribbon-two-primary span:after {
  border-right: 3px solid #74a8e3;
  border-top: 3px solid #74a8e3;
}
.ribbon-box .ribbon-two-secondary span {
  background: #daecfb;
}
.ribbon-box .ribbon-two-secondary span:before {
  border-left: 3px solid #95c9f4;
  border-top: 3px solid #95c9f4;
}
.ribbon-box .ribbon-two-secondary span:after {
  border-right: 3px solid #95c9f4;
  border-top: 3px solid #95c9f4;
}
.ribbon-box .ribbon-two-success span {
  background: #13c56b;
}
.ribbon-box .ribbon-two-success span:before {
  border-left: 3px solid #0c7f45;
  border-top: 3px solid #0c7f45;
}
.ribbon-box .ribbon-two-success span:after {
  border-right: 3px solid #0c7f45;
  border-top: 3px solid #0c7f45;
}
.ribbon-box .ribbon-two-info span {
  background: #50c3e6;
}
.ribbon-box .ribbon-two-info span:before {
  border-left: 3px solid #1da3cc;
  border-top: 3px solid #1da3cc;
}
.ribbon-box .ribbon-two-info span:after {
  border-right: 3px solid #1da3cc;
  border-top: 3px solid #1da3cc;
}
.ribbon-box .ribbon-two-warning span {
  background: #e8bc52;
}
.ribbon-box .ribbon-two-warning span:before {
  border-left: 3px solid #d29c1c;
  border-top: 3px solid #d29c1c;
}
.ribbon-box .ribbon-two-warning span:after {
  border-right: 3px solid #d29c1c;
  border-top: 3px solid #d29c1c;
}
.ribbon-box .ribbon-two-danger span {
  background: #ed5e5e;
}
.ribbon-box .ribbon-two-danger span:before {
  border-left: 3px solid #e51a1a;
  border-top: 3px solid #e51a1a;
}
.ribbon-box .ribbon-two-danger span:after {
  border-right: 3px solid #e51a1a;
  border-top: 3px solid #e51a1a;
}
.ribbon-box .ribbon-two-light span {
  background: #f3f6f9;
}
.ribbon-box .ribbon-two-light span:before {
  border-left: 3px solid #c0d0e0;
  border-top: 3px solid #c0d0e0;
}
.ribbon-box .ribbon-two-light span:after {
  border-right: 3px solid #c0d0e0;
  border-top: 3px solid #c0d0e0;
}
.ribbon-box .ribbon-two-dark span {
  background: #363d48;
}
.ribbon-box .ribbon-two-dark span:before {
  border-left: 3px solid #15181c;
  border-top: 3px solid #15181c;
}
.ribbon-box .ribbon-two-dark span:after {
  border-right: 3px solid #15181c;
  border-top: 3px solid #15181c;
}
.ribbon-box .ribbon-two-custom-primary span {
  background: #7eabe7;
}
.ribbon-box .ribbon-two-custom-primary span:before {
  border-left: 3px solid #3e81db;
  border-top: 3px solid #3e81db;
}
.ribbon-box .ribbon-two-custom-primary span:after {
  border-right: 3px solid #3e81db;
  border-top: 3px solid #3e81db;
}
.ribbon-box .ribbon-two-custom-primary-hover span {
  background: #bcd4f8;
}
.ribbon-box .ribbon-two-custom-primary-hover span:before {
  border-left: 3px solid #77a8f1;
  border-top: 3px solid #77a8f1;
}
.ribbon-box .ribbon-two-custom-primary-hover span:after {
  border-right: 3px solid #77a8f1;
  border-top: 3px solid #77a8f1;
}
.ribbon-box .ribbon-two-new-primary span {
  background: #0A56AE;
}
.ribbon-box .ribbon-two-new-primary span:before {
  border-left: 3px solid #063266;
  border-top: 3px solid #063266;
}
.ribbon-box .ribbon-two-new-primary span:after {
  border-right: 3px solid #063266;
  border-top: 3px solid #063266;
}
.ribbon-box .ribbon-two-header span {
  background: #bdd6fb;
}
.ribbon-box .ribbon-two-header span:before {
  border-left: 3px solid #75a9f7;
  border-top: 3px solid #75a9f7;
}
.ribbon-box .ribbon-two-header span:after {
  border-right: 3px solid #75a9f7;
  border-top: 3px solid #75a9f7;
}
.ribbon-box .ribbon-two-next-button span {
  background: #83a9e2;
}
.ribbon-box .ribbon-two-next-button span:before {
  border-left: 3px solid #457ed4;
  border-top: 3px solid #457ed4;
}
.ribbon-box .ribbon-two-next-button span:after {
  border-right: 3px solid #457ed4;
  border-top: 3px solid #457ed4;
}
.ribbon-box .ribbon-two-next-button-border span {
  background: #5d87c7;
}
.ribbon-box .ribbon-two-next-button-border span:before {
  border-left: 3px solid #3761a0;
  border-top: 3px solid #3761a0;
}
.ribbon-box .ribbon-two-next-button-border span:after {
  border-right: 3px solid #3761a0;
  border-top: 3px solid #3761a0;
}
.ribbon-box .ribbon-two-next-button-hover span {
  background: #bdd6fa;
}
.ribbon-box .ribbon-two-next-button-hover span:before {
  border-left: 3px solid #76aaf5;
  border-top: 3px solid #76aaf5;
}
.ribbon-box .ribbon-two-next-button-hover span:after {
  border-right: 3px solid #76aaf5;
  border-top: 3px solid #76aaf5;
}
.ribbon-box .ribbon-two-white span {
  background: #fff;
}
.ribbon-box .ribbon-two-white span:before {
  border-left: 3px solid #d9d9d9;
  border-top: 3px solid #d9d9d9;
}
.ribbon-box .ribbon-two-white span:after {
  border-right: 3px solid #d9d9d9;
  border-top: 3px solid #d9d9d9;
}
.ribbon-box .ribbon-two-light-grey span {
  background: #ced4da;
}
.ribbon-box .ribbon-two-light-grey span:before {
  border-left: 3px solid #a2aeb9;
  border-top: 3px solid #a2aeb9;
}
.ribbon-box .ribbon-two-light-grey span:after {
  border-right: 3px solid #a2aeb9;
  border-top: 3px solid #a2aeb9;
}

.ribbon-box.right .ribbon-three {
  position: absolute;
  top: -6.1px;
  right: 10px;
  left: auto;
}

.ribbon-three {
  position: absolute;
  top: -6.1px;
  left: 10px;
}
.ribbon-three span {
  position: relative;
  display: block;
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 1;
  padding: 12px 8px 10px;
  border-top-right-radius: 8px;
  width: 90px;
}
.ribbon-three span::after, .ribbon-three span::before {
  position: absolute;
  content: "";
}
.ribbon-three span::before {
  height: 6px;
  width: 6px;
  left: -6px;
  top: 0;
}
.ribbon-three span::after {
  height: 6px;
  width: 8px;
  left: -8px;
  top: 0;
  border-radius: 8px 8px 0 0;
}
.ribbon-three::after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-left: 44px solid transparent;
  border-right: 44px solid transparent;
  border-top: 10px solid;
}

.ribbon-three-primary span {
  background: #b4d0f0;
}
.ribbon-three-primary span:before {
  background: #b4d0f0;
}
.ribbon-three-primary span:after {
  background: #8ab5e8;
}
.ribbon-three-primary::after {
  border-top-color: #b4d0f0;
}

.ribbon-three-secondary span {
  background: #daecfb;
}
.ribbon-three-secondary span:before {
  background: #daecfb;
}
.ribbon-three-secondary span:after {
  background: #acd4f6;
}
.ribbon-three-secondary::after {
  border-top-color: #daecfb;
}

.ribbon-three-success span {
  background: #13c56b;
}
.ribbon-three-success span:before {
  background: #13c56b;
}
.ribbon-three-success span:after {
  background: #0f9652;
}
.ribbon-three-success::after {
  border-top-color: #13c56b;
}

.ribbon-three-info span {
  background: #50c3e6;
}
.ribbon-three-info span:before {
  background: #50c3e6;
}
.ribbon-three-info span:after {
  background: #23b4e0;
}
.ribbon-three-info::after {
  border-top-color: #50c3e6;
}

.ribbon-three-warning span {
  background: #e8bc52;
}
.ribbon-three-warning span:before {
  background: #e8bc52;
}
.ribbon-three-warning span:after {
  background: #e2ab25;
}
.ribbon-three-warning::after {
  border-top-color: #e8bc52;
}

.ribbon-three-danger span {
  background: #ed5e5e;
}
.ribbon-three-danger span:before {
  background: #ed5e5e;
}
.ribbon-three-danger span:after {
  background: #e83030;
}
.ribbon-three-danger::after {
  border-top-color: #ed5e5e;
}

.ribbon-three-light span {
  background: #f3f6f9;
}
.ribbon-three-light span:before {
  background: #f3f6f9;
}
.ribbon-three-light span:after {
  background: #d1dde8;
}
.ribbon-three-light::after {
  border-top-color: #f3f6f9;
}

.ribbon-three-dark span {
  background: #363d48;
}
.ribbon-three-dark span:before {
  background: #363d48;
}
.ribbon-three-dark span:after {
  background: #20242b;
}
.ribbon-three-dark::after {
  border-top-color: #363d48;
}

.ribbon-three-custom-primary span {
  background: #7eabe7;
}
.ribbon-three-custom-primary span:before {
  background: #7eabe7;
}
.ribbon-three-custom-primary span:after {
  background: #538fdf;
}
.ribbon-three-custom-primary::after {
  border-top-color: #7eabe7;
}

.ribbon-three-custom-primary-hover span {
  background: #bcd4f8;
}
.ribbon-three-custom-primary-hover span:before {
  background: #bcd4f8;
}
.ribbon-three-custom-primary-hover span:after {
  background: #8eb6f3;
}
.ribbon-three-custom-primary-hover::after {
  border-top-color: #bcd4f8;
}

.ribbon-three-new-primary span {
  background: #0A56AE;
}
.ribbon-three-new-primary span:before {
  background: #0A56AE;
}
.ribbon-three-new-primary span:after {
  background: #073e7e;
}
.ribbon-three-new-primary::after {
  border-top-color: #0A56AE;
}

.ribbon-three-header span {
  background: #bdd6fb;
}
.ribbon-three-header span:before {
  background: #bdd6fb;
}
.ribbon-three-header span:after {
  background: #8db8f8;
}
.ribbon-three-header::after {
  border-top-color: #bdd6fb;
}

.ribbon-three-next-button span {
  background: #83a9e2;
}
.ribbon-three-next-button span:before {
  background: #83a9e2;
}
.ribbon-three-next-button span:after {
  background: #5a8cd8;
}
.ribbon-three-next-button::after {
  border-top-color: #83a9e2;
}

.ribbon-three-next-button-border span {
  background: #5d87c7;
}
.ribbon-three-next-button-border span:before {
  background: #5d87c7;
}
.ribbon-three-next-button-border span:after {
  background: #3e6cb3;
}
.ribbon-three-next-button-border::after {
  border-top-color: #5d87c7;
}

.ribbon-three-next-button-hover span {
  background: #bdd6fa;
}
.ribbon-three-next-button-hover span:before {
  background: #bdd6fa;
}
.ribbon-three-next-button-hover span:after {
  background: #8eb9f6;
}
.ribbon-three-next-button-hover::after {
  border-top-color: #bdd6fa;
}

.ribbon-three-white span {
  background: #fff;
}
.ribbon-three-white span:before {
  background: #fff;
}
.ribbon-three-white span:after {
  background: #e6e6e6;
}
.ribbon-three-white::after {
  border-top-color: #fff;
}

.ribbon-three-light-grey span {
  background: #ced4da;
}
.ribbon-three-light-grey span:before {
  background: #ced4da;
}
.ribbon-three-light-grey span:after {
  background: #b1bbc4;
}
.ribbon-three-light-grey::after {
  border-top-color: #ced4da;
}

.ribbon-box .trending-ribbon {
  transform: translateX(-50px);
  transition: all 0.5s ease;
}
.ribbon-box .trending-ribbon .trending-ribbon-text {
  transition: all 0.5s ease;
  opacity: 0;
}
.ribbon-box:hover .trending-ribbon {
  transform: translateX(0);
}
.ribbon-box:hover .trending-ribbon .trending-ribbon-text {
  opacity: 1;
}
.ribbon-box.right .trending-ribbon {
  transform: translateX(50px);
  transition: all 0.5s ease;
}
.ribbon-box.right .trending-ribbon .trending-ribbon-text {
  transition: all 0.5s ease;
  opacity: 0;
}
.ribbon-box.right:hover .trending-ribbon {
  transform: translateX(0);
}
.ribbon-box.right:hover .trending-ribbon .trending-ribbon-text {
  opacity: 1;
}

.toast:not(:last-child) {
  margin-bottom: 0.75rem;
}

.toast-border-primary .toast-body {
  color: #b4d0f0;
  border-bottom: 3px solid #b4d0f0;
}

.toast-border-secondary .toast-body {
  color: #daecfb;
  border-bottom: 3px solid #daecfb;
}

.toast-border-success .toast-body {
  color: #13c56b;
  border-bottom: 3px solid #13c56b;
}

.toast-border-info .toast-body {
  color: #50c3e6;
  border-bottom: 3px solid #50c3e6;
}

.toast-border-warning .toast-body {
  color: #e8bc52;
  border-bottom: 3px solid #e8bc52;
}

.toast-border-danger .toast-body {
  color: #ed5e5e;
  border-bottom: 3px solid #ed5e5e;
}

.toast-border-light .toast-body {
  color: #f3f6f9;
  border-bottom: 3px solid #f3f6f9;
}

.toast-border-dark .toast-body {
  color: #363d48;
  border-bottom: 3px solid #363d48;
}

.toast-border-custom-primary .toast-body {
  color: #7eabe7;
  border-bottom: 3px solid #7eabe7;
}

.toast-border-custom-primary-hover .toast-body {
  color: #bcd4f8;
  border-bottom: 3px solid #bcd4f8;
}

.toast-border-new-primary .toast-body {
  color: #0A56AE;
  border-bottom: 3px solid #0A56AE;
}

.toast-border-header .toast-body {
  color: #bdd6fb;
  border-bottom: 3px solid #bdd6fb;
}

.toast-border-next-button .toast-body {
  color: #83a9e2;
  border-bottom: 3px solid #83a9e2;
}

.toast-border-next-button-border .toast-body {
  color: #5d87c7;
  border-bottom: 3px solid #5d87c7;
}

.toast-border-next-button-hover .toast-body {
  color: #bdd6fa;
  border-bottom: 3px solid #bdd6fa;
}

.toast-border-white .toast-body {
  color: #fff;
  border-bottom: 3px solid #fff;
}

.toast-border-light-grey .toast-body {
  color: #ced4da;
  border-bottom: 3px solid #ced4da;
}

.scrollspy-example {
  position: relative;
  height: 200px;
  margin-top: 0.5rem;
  overflow: auto;
}

.scrollspy-example-2 {
  position: relative;
  height: 370px;
  overflow: auto;
}

:root {
  --vz-card-logo-dark: block;
  --vz-card-logo-light: none;
  --vz-vertical-menu-width: 250px;
  --vz-vertical-menu-width-md: 180px;
  --vz-vertical-menu-width-sm: 70px;
  --vz-header-bg: #fff;
  --vz-header-border: #b4d0f0;
  --vz-header-item-color: #495057;
  --vz-header-item-bg: rgba(218, 236, 251, 0.12);
  --vz-header-item-sub-color: #878a99;
  --vz-topbar-search-bg: #f3f3f9;
  --vz-topbar-search-color: #495057;
  --vz-topbar-user-bg: #f3f3f9;
  --vz-page-title-box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  --vz-page-title-border: transparent;
  --vz-topnav-bg: #fff;
  --vz-topnav-item-color: #6d7080;
  --vz-topnav-item-active-color: #b4d0f0;
  --vz-twocolumn-menu-iconview-bg: #fff;
  --vz-twocolumn-menu-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  --vz-boxed-layout-width: 1300px;
  --vz-boxed-body-bg: #e5ecf2;
  --vz-semibox-width: 110px;
  --vz-footer-bg: #fff;
  --vz-footer-color: #98a6ad;
  --vz-input-bg-custom: #fff;
  --vz-input-border-custom: #8aaed6;
}
:root[data-topbar=dark] {
  --vz-header-bg: #405189;
  --vz-header-item-color: rgba(255, 255, 255, 0.85);
  --vz-header-item-bg: #495c99;
  --vz-header-item-sub-color: #b0c4d9;
  --vz-topbar-user-bg: #52639c;
  --vz-topbar-search-bg: rgba(255, 255, 255, 0.05);
  --vz-topbar-search-color: #fff;
  --vz-header-border: #405189;
}

:root {
  --vz-vertical-menu-bg: #fff;
  --vz-vertical-menu-border: #fff;
  --vz-vertical-menu-item-color: #6d7080;
  --vz-vertical-menu-item-bg: rgba(180, 208, 240, 0.15);
  --vz-vertical-menu-item-hover-color: #b4d0f0;
  --vz-vertical-menu-item-active-color: #b4d0f0;
  --vz-vertical-menu-item-active-bg: rgba(180, 208, 240, 0.15);
  --vz-vertical-menu-sub-item-color: #7c7f90;
  --vz-vertical-menu-sub-item-hover-color: #b4d0f0;
  --vz-vertical-menu-sub-item-active-color: #b4d0f0;
  --vz-vertical-menu-title-color: #919da9;
  --vz-vertical-menu-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  --vz-vertical-menu-dropdown-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
}
:root[data-sidebar=dark] {
  --vz-vertical-menu-bg: #405189;
  --vz-vertical-menu-border: #405189;
  --vz-vertical-menu-item-color: #abb9e8;
  --vz-vertical-menu-item-bg: rgba(255, 255, 255, 0.15);
  --vz-vertical-menu-item-hover-color: #fff;
  --vz-vertical-menu-item-active-color: #fff;
  --vz-vertical-menu-item-active-bg: rgba(255, 255, 255, 0.15);
  --vz-vertical-menu-sub-item-color: #abb9e8;
  --vz-vertical-menu-sub-item-hover-color: #fff;
  --vz-vertical-menu-sub-item-active-color: #fff;
  --vz-vertical-menu-title-color: #838fb9;
  --vz-twocolumn-menu-iconview-bg: #435590;
  --vz-vertical-menu-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  --vz-vertical-menu-dropdown-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
}

:root:is([data-sidebar="gradient"], [data-sidebar="gradient-2"], [data-sidebar="gradient-3"], [data-sidebar="gradient-4"]) {
  --vz-vertical-menu-item-color: rgba(255, 255, 255, 0.5);
  --vz-vertical-menu-item-bg: rgba(255, 255, 255, 0.15);
  --vz-vertical-menu-item-hover-color: #fff;
  --vz-vertical-menu-item-active-color: #fff;
  --vz-vertical-menu-item-active-bg: rgba(255, 255, 255, 0.15);
  --vz-vertical-menu-sub-item-color: rgba(255, 255, 255, 0.5);
  --vz-vertical-menu-sub-item-hover-color: #fff;
  --vz-vertical-menu-sub-item-active-color: #fff;
  --vz-vertical-menu-title-color: rgba(255, 255, 255, 0.5);
  --vz-vertical-menu-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  --vz-vertical-menu-dropdown-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
}
:root[data-sidebar=gradient] {
  --vz-vertical-menu-bg: linear-gradient(to right, var(--vz-primary), var(--vz-success));
  --vz-vertical-menu-border: var(--vz-success);
  --vz-twocolumn-menu-iconview-bg: var(--vz-primary);
}
:root[data-sidebar=gradient-2] {
  --vz-vertical-menu-bg: linear-gradient(to right, var(--vz-info), var(--vz-secondary));
  --vz-vertical-menu-border: var(--vz-secondary);
  --vz-twocolumn-menu-iconview-bg: var(--vz-info);
}
:root[data-sidebar=gradient-3] {
  --vz-vertical-menu-bg: linear-gradient(to right, var(--vz-info), var(--vz-success));
  --vz-vertical-menu-border: var(--vz-success);
  --vz-twocolumn-menu-iconview-bg: var(--vz-info);
}
:root[data-sidebar=gradient-4] {
  --vz-vertical-menu-bg: linear-gradient(to right, #1a1d21, var(--vz-primary));
  --vz-vertical-menu-border: var(--vz-primary);
  --vz-twocolumn-menu-iconview-bg: #1a1d21;
}

[data-bs-theme=dark] {
  --vz-light: #282b2e;
  --vz-light-rgb: 40, 43, 46;
  --vz-light-text-emphasis: #535659;
  --vz-light-bg-subtle: #25282c;
  --vz-light-border-subtle: #35383c;
  --vz-dark: #313437;
  --vz-dark-rgb: 49, 52, 55;
  --vz-dark-text-emphasis: #5f6164;
  --vz-dark-bg-subtle: #313437;
  --vz-dark-border-subtle: #3c3f42;
  --vz-card-logo-dark: none;
  --vz-card-logo-light: block;
  --vz-footer-bg: #212529;
  --vz-footer-color: #878a99;
  --vz-topnav-bg: #272b30;
  --vz-topnav-item-color: #878a99;
  --vz-topnav-item-active-color: #fff;
  --vz-page-title-box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  --vz-page-title-border: none;
  --vz-twocolumn-menu-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  --vz-boxed-body-bg: #111316;
  --vz-input-bg-custom: #262a2f;
  --vz-input-border-custom: #2a2f34;
}
[data-bs-theme=dark] .table-light {
  --vz-table-color: white;
  --vz-table-bg: var(--vz-light);
  --vz-table-border-color: var(--vz-border-color);
  --vz-table-striped-bg: var(--vz-light);
  --vz-table-striped-color: white;
  --vz-table-active-bg: var(--vz-light);
  --vz-table-active-color: white;
  --vz-table-hover-bg: var(--vz-light);
  --vz-table-hover-color: white;
}
[data-bs-theme=dark] .btn-light,
[data-bs-theme=dark] .btn-outline-light {
  --vz-btn-color: #8d8e90;
  --vz-btn-active-color: #fff;
  --vz-btn-hover-color: #fff;
}
[data-bs-theme=dark] .btn-outline-dark,
[data-bs-theme=dark] .btn-soft-dark, [data-bs-theme=dark] .btn-ghost-dark {
  --vz-btn-color: #fff;
}
[data-bs-theme=dark] .btn-ghost-dark {
  --vz-btn-active-color: #fff;
  --vz-btn-hover-color: #fff;
}
[data-bs-theme=dark] .dropdown-menu {
  --vz-dropdown-bg: #292e33;
  --vz-dropdown-link-color: #adb5bd;
  --vz-dropdown-link-hover-color: #b9bfc4;
  --vz-dropdown-link-hover-bg: #2f343a;
  --vz-dropdown-border-width: 1px;
  --vz-dropdown-link-active-color: #adb5bd;
  --vz-dropdown-link-active-bg: #2f343a;
}

[data-bs-theme=dark] {
  --vz-header-bg: #292e32;
  --vz-header-border: #2e3438;
  --vz-header-item-color: #e9ecef;
  --vz-header-item-bg: #31363c;
  --vz-header-item-sub-color: #878a99;
  --vz-topbar-user-bg: #31373c;
  --vz-topbar-search-bg: #202328;
  --vz-topbar-search-color: #fff;
}
[data-bs-theme=dark][data-topbar=dark] {
  --vz-header-bg: #405189;
  --vz-header-border: #405189;
  --vz-header-item-color: rgba(255, 255, 255, 0.85);
  --vz-header-item-bg: #7399e5;
  --vz-header-item-sub-color: rgba(255, 255, 255, 0.6);
  --vz-topbar-user-bg: #455793;
  --vz-topbar-search-bg: rgba(255, 255, 255, 0.05);
  --vz-topbar-search-color: #fff;
}

[data-bs-theme=dark] {
  --vz-vertical-menu-bg: #fff;
  --vz-vertical-menu-border: #fff;
  --vz-vertical-menu-item-color: #6d7080;
  --vz-vertical-menu-item-bg: rgba(180, 208, 240, 0.15);
  --vz-vertical-menu-item-hover-color: #b4d0f0;
  --vz-vertical-menu-item-active-color: #b4d0f0;
  --vz-vertical-menu-item-active-bg: rgba(180, 208, 240, 0.15);
  --vz-vertical-menu-sub-item-color: #7c7f90;
  --vz-vertical-menu-sub-item-hover-color: #b4d0f0;
  --vz-vertical-menu-sub-item-active-color: #b4d0f0;
  --vz-vertical-menu-title-color: #919da9;
}
[data-bs-theme=dark][data-sidebar=dark] {
  --vz-vertical-menu-bg: #212529;
  --vz-vertical-menu-border: #212529;
  --vz-vertical-menu-item-color: #878a99;
  --vz-vertical-menu-item-bg: rgba(255, 255, 255, 0.15);
  --vz-vertical-menu-item-hover-color: #fff;
  --vz-vertical-menu-item-active-color: #fff;
  --vz-vertical-menu-item-active-bg: rgba(255, 255, 255, 0.15);
  --vz-vertical-menu-sub-item-color: #7c7f90;
  --vz-vertical-menu-sub-item-hover-color: #fff;
  --vz-vertical-menu-sub-item-active-color: #fff;
  --vz-vertical-menu-title-color: #5f6270;
  --vz-twocolumn-menu-iconview-bg: #292e32;
}

html {
  position: relative;
  min-height: 100%;
}

:is(.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6) {
  font-family: "Montserrat", sans-serif;
}

label {
  font-weight: 400;
  margin-bottom: 0.5rem;
}

b,
strong {
  font-weight: 500;
}

.blockquote {
  padding: 10px 20px;
  border-left: 4px solid var(--vz-border-color);
}

.blockquote-reverse {
  border-left: 0;
  border-right: 4px solid var(--vz-border-color);
  text-align: right;
}

@media (min-width: 1200px) {
  :is(.container,
.container-lg,
.container-md,
.container-sm,
.container-xl,
.container-xxl) {
    max-width: 1140px;
  }
}

.row > * {
  position: relative;
}

.alert-label-icon {
  position: relative;
  padding-left: 60px;
  border: 0;
}
.alert-label-icon .label-icon {
  position: absolute;
  width: 45px;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(255, 255, 255, 0.15);
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.alert-label-icon.label-arrow {
  overflow: hidden;
}
.alert-label-icon.label-arrow .label-icon:after {
  content: "";
  position: absolute;
  border: 6px solid transparent;
  border-left-color: #b4d0f0;
  right: -12px;
}

.alert-border-left {
  border-left: 3px solid;
}

.alert-top-border {
  background-color: var(--vz-secondary-bg);
  border-color: var(--vz-border-color);
  border-top: 2px solid;
  color: var(--vz-body-color);
}

.alert-additional {
  padding: 0;
}
.alert-additional .alert-body {
  padding: 0.8rem 1rem;
}
.alert-additional .alert-content {
  padding: 0.8rem 1rem;
  border-bottom-left-radius: var(--vz-border-radius);
  border-bottom-right-radius: var(--vz-border-radius);
  margin: 0 -var(--vz-border-width) -var(--vz-border-width) -var(--vz-border-width);
}

.rounded-label .label-icon {
  width: 45px;
  height: 26px;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 0 30px 30px 0;
}

.alert-border-left.alert-primary {
  border-left-color: var(--vz-primary);
}

.alert-top-border.alert-primary {
  border-top-color: var(--vz-primary);
}

.rounded-label.alert-primary .label-icon {
  background-color: var(--vz-primary);
  color: #000;
}

.label-arrow.alert-primary .label-icon {
  color: #000;
  background-color: var(--vz-primary);
}
.label-arrow.alert-primary .label-icon:after {
  border-left-color: var(--vz-primary) !important;
}

.alert.alert-primary .btn-close::after {
  color: var(--vz-primary);
}

.alert-additional.alert-primary .alert-content {
  background-color: var(--vz-primary);
  color: #000;
}

.alert-border-left.alert-secondary {
  border-left-color: var(--vz-secondary);
}

.alert-top-border.alert-secondary {
  border-top-color: var(--vz-secondary);
}

.rounded-label.alert-secondary .label-icon {
  background-color: var(--vz-secondary);
  color: #000;
}

.label-arrow.alert-secondary .label-icon {
  color: #000;
  background-color: var(--vz-secondary);
}
.label-arrow.alert-secondary .label-icon:after {
  border-left-color: var(--vz-secondary) !important;
}

.alert.alert-secondary .btn-close::after {
  color: var(--vz-secondary);
}

.alert-additional.alert-secondary .alert-content {
  background-color: var(--vz-secondary);
  color: #000;
}

.alert-border-left.alert-success {
  border-left-color: var(--vz-success);
}

.alert-top-border.alert-success {
  border-top-color: var(--vz-success);
}

.rounded-label.alert-success .label-icon {
  background-color: var(--vz-success);
  color: #fff;
}

.label-arrow.alert-success .label-icon {
  color: #fff;
  background-color: var(--vz-success);
}
.label-arrow.alert-success .label-icon:after {
  border-left-color: var(--vz-success) !important;
}

.alert.alert-success .btn-close::after {
  color: var(--vz-success);
}

.alert-additional.alert-success .alert-content {
  background-color: var(--vz-success);
  color: #fff;
}

.alert-border-left.alert-info {
  border-left-color: var(--vz-info);
}

.alert-top-border.alert-info {
  border-top-color: var(--vz-info);
}

.rounded-label.alert-info .label-icon {
  background-color: var(--vz-info);
  color: #fff;
}

.label-arrow.alert-info .label-icon {
  color: #fff;
  background-color: var(--vz-info);
}
.label-arrow.alert-info .label-icon:after {
  border-left-color: var(--vz-info) !important;
}

.alert.alert-info .btn-close::after {
  color: var(--vz-info);
}

.alert-additional.alert-info .alert-content {
  background-color: var(--vz-info);
  color: #fff;
}

.alert-border-left.alert-warning {
  border-left-color: var(--vz-warning);
}

.alert-top-border.alert-warning {
  border-top-color: var(--vz-warning);
}

.rounded-label.alert-warning .label-icon {
  background-color: var(--vz-warning);
  color: #fff;
}

.label-arrow.alert-warning .label-icon {
  color: #fff;
  background-color: var(--vz-warning);
}
.label-arrow.alert-warning .label-icon:after {
  border-left-color: var(--vz-warning) !important;
}

.alert.alert-warning .btn-close::after {
  color: var(--vz-warning);
}

.alert-additional.alert-warning .alert-content {
  background-color: var(--vz-warning);
  color: #fff;
}

.alert-border-left.alert-danger {
  border-left-color: var(--vz-danger);
}

.alert-top-border.alert-danger {
  border-top-color: var(--vz-danger);
}

.rounded-label.alert-danger .label-icon {
  background-color: var(--vz-danger);
  color: #fff;
}

.label-arrow.alert-danger .label-icon {
  color: #fff;
  background-color: var(--vz-danger);
}
.label-arrow.alert-danger .label-icon:after {
  border-left-color: var(--vz-danger) !important;
}

.alert.alert-danger .btn-close::after {
  color: var(--vz-danger);
}

.alert-additional.alert-danger .alert-content {
  background-color: var(--vz-danger);
  color: #fff;
}

.alert-border-left.alert-light {
  border-left-color: var(--vz-light);
}

.alert-top-border.alert-light {
  border-top-color: var(--vz-light);
}

.rounded-label.alert-light .label-icon {
  background-color: var(--vz-light);
  color: #000;
}

.label-arrow.alert-light .label-icon {
  color: #000;
  background-color: var(--vz-light);
}
.label-arrow.alert-light .label-icon:after {
  border-left-color: var(--vz-light) !important;
}

.alert.alert-light .btn-close::after {
  color: var(--vz-light);
}

.alert-additional.alert-light .alert-content {
  background-color: var(--vz-light);
  color: #000;
}

.alert-border-left.alert-dark {
  border-left-color: var(--vz-dark);
}

.alert-top-border.alert-dark {
  border-top-color: var(--vz-dark);
}

.rounded-label.alert-dark .label-icon {
  background-color: var(--vz-dark);
  color: #fff;
}

.label-arrow.alert-dark .label-icon {
  color: #fff;
  background-color: var(--vz-dark);
}
.label-arrow.alert-dark .label-icon:after {
  border-left-color: var(--vz-dark) !important;
}

.alert.alert-dark .btn-close::after {
  color: var(--vz-dark);
}

.alert-additional.alert-dark .alert-content {
  background-color: var(--vz-dark);
  color: #fff;
}

.alert-border-left.alert-custom-primary {
  border-left-color: var(--vz-custom-primary);
}

.alert-top-border.alert-custom-primary {
  border-top-color: var(--vz-custom-primary);
}

.rounded-label.alert-custom-primary .label-icon {
  background-color: var(--vz-custom-primary);
  color: #fff;
}

.label-arrow.alert-custom-primary .label-icon {
  color: #fff;
  background-color: var(--vz-custom-primary);
}
.label-arrow.alert-custom-primary .label-icon:after {
  border-left-color: var(--vz-custom-primary) !important;
}

.alert.alert-custom-primary .btn-close::after {
  color: var(--vz-custom-primary);
}

.alert-additional.alert-custom-primary .alert-content {
  background-color: var(--vz-custom-primary);
  color: #fff;
}

.alert-border-left.alert-custom-primary-hover {
  border-left-color: var(--vz-custom-primary-hover);
}

.alert-top-border.alert-custom-primary-hover {
  border-top-color: var(--vz-custom-primary-hover);
}

.rounded-label.alert-custom-primary-hover .label-icon {
  background-color: var(--vz-custom-primary-hover);
  color: #000;
}

.label-arrow.alert-custom-primary-hover .label-icon {
  color: #000;
  background-color: var(--vz-custom-primary-hover);
}
.label-arrow.alert-custom-primary-hover .label-icon:after {
  border-left-color: var(--vz-custom-primary-hover) !important;
}

.alert.alert-custom-primary-hover .btn-close::after {
  color: var(--vz-custom-primary-hover);
}

.alert-additional.alert-custom-primary-hover .alert-content {
  background-color: var(--vz-custom-primary-hover);
  color: #000;
}

.alert-border-left.alert-new-primary {
  border-left-color: var(--vz-new-primary);
}

.alert-top-border.alert-new-primary {
  border-top-color: var(--vz-new-primary);
}

.rounded-label.alert-new-primary .label-icon {
  background-color: var(--vz-new-primary);
  color: #fff;
}

.label-arrow.alert-new-primary .label-icon {
  color: #fff;
  background-color: var(--vz-new-primary);
}
.label-arrow.alert-new-primary .label-icon:after {
  border-left-color: var(--vz-new-primary) !important;
}

.alert.alert-new-primary .btn-close::after {
  color: var(--vz-new-primary);
}

.alert-additional.alert-new-primary .alert-content {
  background-color: var(--vz-new-primary);
  color: #fff;
}

.alert-border-left.alert-header {
  border-left-color: var(--vz-header);
}

.alert-top-border.alert-header {
  border-top-color: var(--vz-header);
}

.rounded-label.alert-header .label-icon {
  background-color: var(--vz-header);
  color: #000;
}

.label-arrow.alert-header .label-icon {
  color: #000;
  background-color: var(--vz-header);
}
.label-arrow.alert-header .label-icon:after {
  border-left-color: var(--vz-header) !important;
}

.alert.alert-header .btn-close::after {
  color: var(--vz-header);
}

.alert-additional.alert-header .alert-content {
  background-color: var(--vz-header);
  color: #000;
}

.alert-border-left.alert-next-button {
  border-left-color: var(--vz-next-button);
}

.alert-top-border.alert-next-button {
  border-top-color: var(--vz-next-button);
}

.rounded-label.alert-next-button .label-icon {
  background-color: var(--vz-next-button);
  color: #fff;
}

.label-arrow.alert-next-button .label-icon {
  color: #fff;
  background-color: var(--vz-next-button);
}
.label-arrow.alert-next-button .label-icon:after {
  border-left-color: var(--vz-next-button) !important;
}

.alert.alert-next-button .btn-close::after {
  color: var(--vz-next-button);
}

.alert-additional.alert-next-button .alert-content {
  background-color: var(--vz-next-button);
  color: #fff;
}

.alert-border-left.alert-next-button-border {
  border-left-color: var(--vz-next-button-border);
}

.alert-top-border.alert-next-button-border {
  border-top-color: var(--vz-next-button-border);
}

.rounded-label.alert-next-button-border .label-icon {
  background-color: var(--vz-next-button-border);
  color: #fff;
}

.label-arrow.alert-next-button-border .label-icon {
  color: #fff;
  background-color: var(--vz-next-button-border);
}
.label-arrow.alert-next-button-border .label-icon:after {
  border-left-color: var(--vz-next-button-border) !important;
}

.alert.alert-next-button-border .btn-close::after {
  color: var(--vz-next-button-border);
}

.alert-additional.alert-next-button-border .alert-content {
  background-color: var(--vz-next-button-border);
  color: #fff;
}

.alert-border-left.alert-next-button-hover {
  border-left-color: var(--vz-next-button-hover);
}

.alert-top-border.alert-next-button-hover {
  border-top-color: var(--vz-next-button-hover);
}

.rounded-label.alert-next-button-hover .label-icon {
  background-color: var(--vz-next-button-hover);
  color: #000;
}

.label-arrow.alert-next-button-hover .label-icon {
  color: #000;
  background-color: var(--vz-next-button-hover);
}
.label-arrow.alert-next-button-hover .label-icon:after {
  border-left-color: var(--vz-next-button-hover) !important;
}

.alert.alert-next-button-hover .btn-close::after {
  color: var(--vz-next-button-hover);
}

.alert-additional.alert-next-button-hover .alert-content {
  background-color: var(--vz-next-button-hover);
  color: #000;
}

.alert-border-left.alert-white {
  border-left-color: var(--vz-white);
}

.alert-top-border.alert-white {
  border-top-color: var(--vz-white);
}

.rounded-label.alert-white .label-icon {
  background-color: var(--vz-white);
  color: #000;
}

.label-arrow.alert-white .label-icon {
  color: #000;
  background-color: var(--vz-white);
}
.label-arrow.alert-white .label-icon:after {
  border-left-color: var(--vz-white) !important;
}

.alert.alert-white .btn-close::after {
  color: var(--vz-white);
}

.alert-additional.alert-white .alert-content {
  background-color: var(--vz-white);
  color: #000;
}

.alert-border-left.alert-light-grey {
  border-left-color: var(--vz-light-grey);
}

.alert-top-border.alert-light-grey {
  border-top-color: var(--vz-light-grey);
}

.rounded-label.alert-light-grey .label-icon {
  background-color: var(--vz-light-grey);
  color: #000;
}

.label-arrow.alert-light-grey .label-icon {
  color: #000;
  background-color: var(--vz-light-grey);
}
.label-arrow.alert-light-grey .label-icon:after {
  border-left-color: var(--vz-light-grey) !important;
}

.alert.alert-light-grey .btn-close::after {
  color: var(--vz-light-grey);
}

.alert-additional.alert-light-grey .alert-content {
  background-color: var(--vz-light-grey);
  color: #000;
}

.alert-dismissible .btn-close {
  background: transparent !important;
}
.alert-dismissible .btn-close::after {
  background: transparent !important;
  content: "󰅖" !important;
  font-size: 18px;
  line-height: 15px;
  font-family: "Material Design Icons" !important;
}

.badge {
  line-height: 0.95;
}

.badge-label.bg-primary:before {
  border-right-color: #b4d0f0;
}

.badge-label.bg-secondary:before {
  border-right-color: #daecfb;
}

.badge-label.bg-success:before {
  border-right-color: #13c56b;
}

.badge-label.bg-info:before {
  border-right-color: #50c3e6;
}

.badge-label.bg-warning:before {
  border-right-color: #e8bc52;
}

.badge-label.bg-danger:before {
  border-right-color: #ed5e5e;
}

.badge-label.bg-light:before {
  border-right-color: #f3f6f9;
}

.badge-label.bg-dark:before {
  border-right-color: #363d48;
}

.badge-label.bg-custom-primary:before {
  border-right-color: #7eabe7;
}

.badge-label.bg-custom-primary-hover:before {
  border-right-color: #bcd4f8;
}

.badge-label.bg-new-primary:before {
  border-right-color: #0A56AE;
}

.badge-label.bg-header:before {
  border-right-color: #bdd6fb;
}

.badge-label.bg-next-button:before {
  border-right-color: #83a9e2;
}

.badge-label.bg-next-button-border:before {
  border-right-color: #5d87c7;
}

.badge-label.bg-next-button-hover:before {
  border-right-color: #bdd6fa;
}

.badge-label.bg-white:before {
  border-right-color: #fff;
}

.badge-label.bg-light-grey:before {
  border-right-color: #ced4da;
}

.badge-border {
  border-left: 2px solid;
}

.badge-label {
  margin-left: 8px;
  position: relative;
}
.badge-label:before {
  content: "";
  position: absolute;
  border: 8px solid transparent;
  border-right-color: #b4d0f0;
  left: -14px;
  top: 0;
}

.badge-gradient-primary {
  background: linear-gradient(135deg, #b4d0f0 0%, #13c56b 100%);
}

.badge-gradient-secondary {
  background: linear-gradient(135deg, #daecfb 0%, #50c3e6 100%);
}

.badge-gradient-success {
  background: linear-gradient(135deg, #13c56b 0%, #e8bc52 100%);
}

.badge-gradient-danger {
  background: linear-gradient(135deg, #ed5e5e 0%, #daecfb 100%);
}

.badge-gradient-warning {
  background: linear-gradient(135deg, #e8bc52 0%, #d29c1c 100%);
}

.badge-gradient-info {
  background: linear-gradient(135deg, #50c3e6 0%, #13c56b 100%);
}

.badge-gradient-dark {
  background: linear-gradient(135deg, #363d48 0%, #b4d0f0 100%);
}

button,
a {
  outline: none !important;
  position: relative;
}

.btn {
  box-shadow: none;
}

:is(.btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active) {
  border-color: transparent;
}

.btn-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: calc(1rem + 1.5em + 2px);
  width: calc(1rem + 1.5em + 2px);
  padding: 0;
}
.btn-icon :is(i, svg, img) {
  vertical-align: middle;
}
.btn-icon.btn-sm, .btn-group-sm > .btn-icon.btn {
  height: calc(0.5rem + 1.5em + 2px);
  width: calc(0.5rem + 1.5em + 2px);
}
.btn-icon.btn-lg, .btn-group-lg > .btn-icon.btn {
  height: calc(1.4rem + 1.5em + 2px);
  width: calc(1.4rem + 1.5em + 2px);
}

.btn-primary {
  --vz-btn-bg: var(--vz-primary);
  --vz-btn-border-color: var(--vz-primary);
  --vz-btn-hover-bg: var(--vz-primary-text-emphasis);
  --vz-btn-hover-border-color: var(--vz-primary-text-emphasis);
  --vz-btn-focus-shadow-rgb: var(--vz-primary-rgb);
  --vz-btn-active-bg: var(--vz-primary-text-emphasis);
  --vz-btn-active-border-color: var(--vz-primary-text-emphasis);
}

.btn-outline-primary {
  --vz-btn-color: var(--vz-primary);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: var(--vz-primary);
  --vz-btn-hover-bg: var(--vz-primary);
  --vz-btn-hover-border-color: var(--vz-primary);
  --vz-btn-focus-shadow-rgb: var(--vz-primary-rgb);
  --vz-btn-active-bg: var(--vz-primary);
  --vz-btn-active-border-color: var(--vz-primary);
}

.btn-soft-primary {
  --vz-btn-color: var(--vz-primary);
  --vz-btn-bg: var(--vz-primary-bg-subtle);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-bg: var(--vz-primary);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-primary-rgb);
  --vz-btn-active-bg: var(--vz-primary);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-primary {
  --vz-btn-color: var(--vz-primary);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: var(--vz-primary);
  --vz-btn-hover-bg: var(--vz-primary-bg-subtle);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-primary-rgb);
  --vz-btn-active-color: var(--vz-primary);
  --vz-btn-active-bg: var(--vz-primary-bg-subtle);
  --vz-btn-active-border-color: transparent;
}

.btn-secondary {
  --vz-btn-bg: var(--vz-secondary);
  --vz-btn-border-color: var(--vz-secondary);
  --vz-btn-hover-bg: var(--vz-secondary-text-emphasis);
  --vz-btn-hover-border-color: var(--vz-secondary-text-emphasis);
  --vz-btn-focus-shadow-rgb: var(--vz-secondary-rgb);
  --vz-btn-active-bg: var(--vz-secondary-text-emphasis);
  --vz-btn-active-border-color: var(--vz-secondary-text-emphasis);
}

.btn-outline-secondary {
  --vz-btn-color: var(--vz-secondary);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: var(--vz-secondary);
  --vz-btn-hover-bg: var(--vz-secondary);
  --vz-btn-hover-border-color: var(--vz-secondary);
  --vz-btn-focus-shadow-rgb: var(--vz-secondary-rgb);
  --vz-btn-active-bg: var(--vz-secondary);
  --vz-btn-active-border-color: var(--vz-secondary);
}

.btn-soft-secondary {
  --vz-btn-color: var(--vz-secondary);
  --vz-btn-bg: var(--vz-secondary-bg-subtle);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-bg: var(--vz-secondary);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-secondary-rgb);
  --vz-btn-active-bg: var(--vz-secondary);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-secondary {
  --vz-btn-color: var(--vz-secondary);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: var(--vz-secondary);
  --vz-btn-hover-bg: var(--vz-secondary-bg-subtle);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-secondary-rgb);
  --vz-btn-active-color: var(--vz-secondary);
  --vz-btn-active-bg: var(--vz-secondary-bg-subtle);
  --vz-btn-active-border-color: transparent;
}

.btn-success {
  --vz-btn-bg: var(--vz-success);
  --vz-btn-border-color: var(--vz-success);
  --vz-btn-hover-bg: var(--vz-success-text-emphasis);
  --vz-btn-hover-border-color: var(--vz-success-text-emphasis);
  --vz-btn-focus-shadow-rgb: var(--vz-success-rgb);
  --vz-btn-active-bg: var(--vz-success-text-emphasis);
  --vz-btn-active-border-color: var(--vz-success-text-emphasis);
}

.btn-outline-success {
  --vz-btn-color: var(--vz-success);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: var(--vz-success);
  --vz-btn-hover-bg: var(--vz-success);
  --vz-btn-hover-border-color: var(--vz-success);
  --vz-btn-focus-shadow-rgb: var(--vz-success-rgb);
  --vz-btn-active-bg: var(--vz-success);
  --vz-btn-active-border-color: var(--vz-success);
}

.btn-soft-success {
  --vz-btn-color: var(--vz-success);
  --vz-btn-bg: var(--vz-success-bg-subtle);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-bg: var(--vz-success);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-success-rgb);
  --vz-btn-active-bg: var(--vz-success);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-success {
  --vz-btn-color: var(--vz-success);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: var(--vz-success);
  --vz-btn-hover-bg: var(--vz-success-bg-subtle);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-success-rgb);
  --vz-btn-active-color: var(--vz-success);
  --vz-btn-active-bg: var(--vz-success-bg-subtle);
  --vz-btn-active-border-color: transparent;
}

.btn-info {
  --vz-btn-bg: var(--vz-info);
  --vz-btn-border-color: var(--vz-info);
  --vz-btn-hover-bg: var(--vz-info-text-emphasis);
  --vz-btn-hover-border-color: var(--vz-info-text-emphasis);
  --vz-btn-focus-shadow-rgb: var(--vz-info-rgb);
  --vz-btn-active-bg: var(--vz-info-text-emphasis);
  --vz-btn-active-border-color: var(--vz-info-text-emphasis);
}

.btn-outline-info {
  --vz-btn-color: var(--vz-info);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: var(--vz-info);
  --vz-btn-hover-bg: var(--vz-info);
  --vz-btn-hover-border-color: var(--vz-info);
  --vz-btn-focus-shadow-rgb: var(--vz-info-rgb);
  --vz-btn-active-bg: var(--vz-info);
  --vz-btn-active-border-color: var(--vz-info);
}

.btn-soft-info {
  --vz-btn-color: var(--vz-info);
  --vz-btn-bg: var(--vz-info-bg-subtle);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-bg: var(--vz-info);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-info-rgb);
  --vz-btn-active-bg: var(--vz-info);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-info {
  --vz-btn-color: var(--vz-info);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: var(--vz-info);
  --vz-btn-hover-bg: var(--vz-info-bg-subtle);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-info-rgb);
  --vz-btn-active-color: var(--vz-info);
  --vz-btn-active-bg: var(--vz-info-bg-subtle);
  --vz-btn-active-border-color: transparent;
}

.btn-warning {
  --vz-btn-bg: var(--vz-warning);
  --vz-btn-border-color: var(--vz-warning);
  --vz-btn-hover-bg: var(--vz-warning-text-emphasis);
  --vz-btn-hover-border-color: var(--vz-warning-text-emphasis);
  --vz-btn-focus-shadow-rgb: var(--vz-warning-rgb);
  --vz-btn-active-bg: var(--vz-warning-text-emphasis);
  --vz-btn-active-border-color: var(--vz-warning-text-emphasis);
}

.btn-outline-warning {
  --vz-btn-color: var(--vz-warning);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: var(--vz-warning);
  --vz-btn-hover-bg: var(--vz-warning);
  --vz-btn-hover-border-color: var(--vz-warning);
  --vz-btn-focus-shadow-rgb: var(--vz-warning-rgb);
  --vz-btn-active-bg: var(--vz-warning);
  --vz-btn-active-border-color: var(--vz-warning);
}

.btn-soft-warning {
  --vz-btn-color: var(--vz-warning);
  --vz-btn-bg: var(--vz-warning-bg-subtle);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-bg: var(--vz-warning);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-warning-rgb);
  --vz-btn-active-bg: var(--vz-warning);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-warning {
  --vz-btn-color: var(--vz-warning);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: var(--vz-warning);
  --vz-btn-hover-bg: var(--vz-warning-bg-subtle);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-warning-rgb);
  --vz-btn-active-color: var(--vz-warning);
  --vz-btn-active-bg: var(--vz-warning-bg-subtle);
  --vz-btn-active-border-color: transparent;
}

.btn-danger {
  --vz-btn-bg: var(--vz-danger);
  --vz-btn-border-color: var(--vz-danger);
  --vz-btn-hover-bg: var(--vz-danger-text-emphasis);
  --vz-btn-hover-border-color: var(--vz-danger-text-emphasis);
  --vz-btn-focus-shadow-rgb: var(--vz-danger-rgb);
  --vz-btn-active-bg: var(--vz-danger-text-emphasis);
  --vz-btn-active-border-color: var(--vz-danger-text-emphasis);
}

.btn-outline-danger {
  --vz-btn-color: var(--vz-danger);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: var(--vz-danger);
  --vz-btn-hover-bg: var(--vz-danger);
  --vz-btn-hover-border-color: var(--vz-danger);
  --vz-btn-focus-shadow-rgb: var(--vz-danger-rgb);
  --vz-btn-active-bg: var(--vz-danger);
  --vz-btn-active-border-color: var(--vz-danger);
}

.btn-soft-danger {
  --vz-btn-color: var(--vz-danger);
  --vz-btn-bg: var(--vz-danger-bg-subtle);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-bg: var(--vz-danger);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-danger-rgb);
  --vz-btn-active-bg: var(--vz-danger);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-danger {
  --vz-btn-color: var(--vz-danger);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: var(--vz-danger);
  --vz-btn-hover-bg: var(--vz-danger-bg-subtle);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-danger-rgb);
  --vz-btn-active-color: var(--vz-danger);
  --vz-btn-active-bg: var(--vz-danger-bg-subtle);
  --vz-btn-active-border-color: transparent;
}

.btn-light {
  --vz-btn-bg: var(--vz-light);
  --vz-btn-border-color: var(--vz-light);
  --vz-btn-hover-bg: var(--vz-light-text-emphasis);
  --vz-btn-hover-border-color: var(--vz-light-text-emphasis);
  --vz-btn-focus-shadow-rgb: var(--vz-light-rgb);
  --vz-btn-active-bg: var(--vz-light-text-emphasis);
  --vz-btn-active-border-color: var(--vz-light-text-emphasis);
}

.btn-outline-light {
  --vz-btn-color: var(--vz-light);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: var(--vz-light);
  --vz-btn-hover-bg: var(--vz-light);
  --vz-btn-hover-border-color: var(--vz-light);
  --vz-btn-focus-shadow-rgb: var(--vz-light-rgb);
  --vz-btn-active-bg: var(--vz-light);
  --vz-btn-active-border-color: var(--vz-light);
}

.btn-soft-light {
  --vz-btn-color: var(--vz-light);
  --vz-btn-bg: var(--vz-light-bg-subtle);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-bg: var(--vz-light);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-light-rgb);
  --vz-btn-active-bg: var(--vz-light);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-light {
  --vz-btn-color: var(--vz-light);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: var(--vz-light);
  --vz-btn-hover-bg: var(--vz-light-bg-subtle);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-light-rgb);
  --vz-btn-active-color: var(--vz-light);
  --vz-btn-active-bg: var(--vz-light-bg-subtle);
  --vz-btn-active-border-color: transparent;
}

.btn-dark {
  --vz-btn-bg: var(--vz-dark);
  --vz-btn-border-color: var(--vz-dark);
  --vz-btn-hover-bg: var(--vz-dark-text-emphasis);
  --vz-btn-hover-border-color: var(--vz-dark-text-emphasis);
  --vz-btn-focus-shadow-rgb: var(--vz-dark-rgb);
  --vz-btn-active-bg: var(--vz-dark-text-emphasis);
  --vz-btn-active-border-color: var(--vz-dark-text-emphasis);
}

.btn-outline-dark {
  --vz-btn-color: var(--vz-dark);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: var(--vz-dark);
  --vz-btn-hover-bg: var(--vz-dark);
  --vz-btn-hover-border-color: var(--vz-dark);
  --vz-btn-focus-shadow-rgb: var(--vz-dark-rgb);
  --vz-btn-active-bg: var(--vz-dark);
  --vz-btn-active-border-color: var(--vz-dark);
}

.btn-soft-dark {
  --vz-btn-color: var(--vz-dark);
  --vz-btn-bg: var(--vz-dark-bg-subtle);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-bg: var(--vz-dark);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-dark-rgb);
  --vz-btn-active-bg: var(--vz-dark);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-dark {
  --vz-btn-color: var(--vz-dark);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: var(--vz-dark);
  --vz-btn-hover-bg: var(--vz-dark-bg-subtle);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-dark-rgb);
  --vz-btn-active-color: var(--vz-dark);
  --vz-btn-active-bg: var(--vz-dark-bg-subtle);
  --vz-btn-active-border-color: transparent;
}

.btn-custom-primary {
  --vz-btn-bg: var(--vz-custom-primary);
  --vz-btn-border-color: var(--vz-custom-primary);
  --vz-btn-hover-bg: var(--vz-custom-primary-text-emphasis);
  --vz-btn-hover-border-color: var(--vz-custom-primary-text-emphasis);
  --vz-btn-focus-shadow-rgb: var(--vz-custom-primary-rgb);
  --vz-btn-active-bg: var(--vz-custom-primary-text-emphasis);
  --vz-btn-active-border-color: var(--vz-custom-primary-text-emphasis);
}

.btn-custom-primary {
  --vz-btn-hover-bg: var(--vz-custom-primary-hover);
  --vz-btn-hover-border-color: var(--vz-custom-primary-hover);
  --vz-btn-hover-color: var(--vz-dark);
  --vz-btn-active-bg: var(--vz-custom-primary-hover);
  --vz-btn-active-border-color: var(--vz-custom-primary);
}

.btn-outline-custom-primary {
  --vz-btn-color: var(--vz-custom-primary);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: var(--vz-custom-primary);
  --vz-btn-hover-bg: var(--vz-custom-primary);
  --vz-btn-hover-border-color: var(--vz-custom-primary);
  --vz-btn-focus-shadow-rgb: var(--vz-custom-primary-rgb);
  --vz-btn-active-bg: var(--vz-custom-primary);
  --vz-btn-active-border-color: var(--vz-custom-primary);
}

.btn-soft-custom-primary {
  --vz-btn-color: var(--vz-custom-primary);
  --vz-btn-bg: var(--vz-custom-primary-bg-subtle);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-bg: var(--vz-custom-primary);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-custom-primary-rgb);
  --vz-btn-active-bg: var(--vz-custom-primary);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-custom-primary {
  --vz-btn-color: var(--vz-custom-primary);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: var(--vz-custom-primary);
  --vz-btn-hover-bg: var(--vz-custom-primary-bg-subtle);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-custom-primary-rgb);
  --vz-btn-active-color: var(--vz-custom-primary);
  --vz-btn-active-bg: var(--vz-custom-primary-bg-subtle);
  --vz-btn-active-border-color: transparent;
}

.btn-custom-primary-hover {
  --vz-btn-bg: var(--vz-custom-primary-hover);
  --vz-btn-border-color: var(--vz-custom-primary-hover);
  --vz-btn-hover-bg: var(--vz-custom-primary-hover-text-emphasis);
  --vz-btn-hover-border-color: var(--vz-custom-primary-hover-text-emphasis);
  --vz-btn-focus-shadow-rgb: var(--vz-custom-primary-hover-rgb);
  --vz-btn-active-bg: var(--vz-custom-primary-hover-text-emphasis);
  --vz-btn-active-border-color: var(--vz-custom-primary-hover-text-emphasis);
}

.btn-outline-custom-primary-hover {
  --vz-btn-color: var(--vz-custom-primary-hover);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: var(--vz-custom-primary-hover);
  --vz-btn-hover-bg: var(--vz-custom-primary-hover);
  --vz-btn-hover-border-color: var(--vz-custom-primary-hover);
  --vz-btn-focus-shadow-rgb: var(--vz-custom-primary-hover-rgb);
  --vz-btn-active-bg: var(--vz-custom-primary-hover);
  --vz-btn-active-border-color: var(--vz-custom-primary-hover);
}

.btn-soft-custom-primary-hover {
  --vz-btn-color: var(--vz-custom-primary-hover);
  --vz-btn-bg: var(--vz-custom-primary-hover-bg-subtle);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-bg: var(--vz-custom-primary-hover);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-custom-primary-hover-rgb);
  --vz-btn-active-bg: var(--vz-custom-primary-hover);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-custom-primary-hover {
  --vz-btn-color: var(--vz-custom-primary-hover);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: var(--vz-custom-primary-hover);
  --vz-btn-hover-bg: var(--vz-custom-primary-hover-bg-subtle);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-custom-primary-hover-rgb);
  --vz-btn-active-color: var(--vz-custom-primary-hover);
  --vz-btn-active-bg: var(--vz-custom-primary-hover-bg-subtle);
  --vz-btn-active-border-color: transparent;
}

.btn-new-primary {
  --vz-btn-bg: var(--vz-new-primary);
  --vz-btn-border-color: var(--vz-new-primary);
  --vz-btn-hover-bg: var(--vz-new-primary-text-emphasis);
  --vz-btn-hover-border-color: var(--vz-new-primary-text-emphasis);
  --vz-btn-focus-shadow-rgb: var(--vz-new-primary-rgb);
  --vz-btn-active-bg: var(--vz-new-primary-text-emphasis);
  --vz-btn-active-border-color: var(--vz-new-primary-text-emphasis);
}

.btn-outline-new-primary {
  --vz-btn-color: var(--vz-new-primary);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: var(--vz-new-primary);
  --vz-btn-hover-bg: var(--vz-new-primary);
  --vz-btn-hover-border-color: var(--vz-new-primary);
  --vz-btn-focus-shadow-rgb: var(--vz-new-primary-rgb);
  --vz-btn-active-bg: var(--vz-new-primary);
  --vz-btn-active-border-color: var(--vz-new-primary);
}

.btn-soft-new-primary {
  --vz-btn-color: var(--vz-new-primary);
  --vz-btn-bg: var(--vz-new-primary-bg-subtle);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-bg: var(--vz-new-primary);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-new-primary-rgb);
  --vz-btn-active-bg: var(--vz-new-primary);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-new-primary {
  --vz-btn-color: var(--vz-new-primary);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: var(--vz-new-primary);
  --vz-btn-hover-bg: var(--vz-new-primary-bg-subtle);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-new-primary-rgb);
  --vz-btn-active-color: var(--vz-new-primary);
  --vz-btn-active-bg: var(--vz-new-primary-bg-subtle);
  --vz-btn-active-border-color: transparent;
}

.btn-header {
  --vz-btn-bg: var(--vz-header);
  --vz-btn-border-color: var(--vz-header);
  --vz-btn-hover-bg: var(--vz-header-text-emphasis);
  --vz-btn-hover-border-color: var(--vz-header-text-emphasis);
  --vz-btn-focus-shadow-rgb: var(--vz-header-rgb);
  --vz-btn-active-bg: var(--vz-header-text-emphasis);
  --vz-btn-active-border-color: var(--vz-header-text-emphasis);
}

.btn-outline-header {
  --vz-btn-color: var(--vz-header);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: var(--vz-header);
  --vz-btn-hover-bg: var(--vz-header);
  --vz-btn-hover-border-color: var(--vz-header);
  --vz-btn-focus-shadow-rgb: var(--vz-header-rgb);
  --vz-btn-active-bg: var(--vz-header);
  --vz-btn-active-border-color: var(--vz-header);
}

.btn-soft-header {
  --vz-btn-color: var(--vz-header);
  --vz-btn-bg: var(--vz-header-bg-subtle);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-bg: var(--vz-header);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-header-rgb);
  --vz-btn-active-bg: var(--vz-header);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-header {
  --vz-btn-color: var(--vz-header);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: var(--vz-header);
  --vz-btn-hover-bg: var(--vz-header-bg-subtle);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-header-rgb);
  --vz-btn-active-color: var(--vz-header);
  --vz-btn-active-bg: var(--vz-header-bg-subtle);
  --vz-btn-active-border-color: transparent;
}

.btn-next-button {
  --vz-btn-bg: var(--vz-next-button);
  --vz-btn-border-color: var(--vz-next-button);
  --vz-btn-hover-bg: var(--vz-next-button-text-emphasis);
  --vz-btn-hover-border-color: var(--vz-next-button-text-emphasis);
  --vz-btn-focus-shadow-rgb: var(--vz-next-button-rgb);
  --vz-btn-active-bg: var(--vz-next-button-text-emphasis);
  --vz-btn-active-border-color: var(--vz-next-button-text-emphasis);
}

.btn-next-button {
  --vz-btn-hover-bg: var(--vz-next-button-hover);
  --vz-btn-hover-border-color: var(--vz-cnext-button-border);
  --vz-btn-hover-color: var(--vz-dark);
}

.btn-outline-next-button {
  --vz-btn-color: var(--vz-next-button);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: var(--vz-next-button);
  --vz-btn-hover-bg: var(--vz-next-button);
  --vz-btn-hover-border-color: var(--vz-next-button);
  --vz-btn-focus-shadow-rgb: var(--vz-next-button-rgb);
  --vz-btn-active-bg: var(--vz-next-button);
  --vz-btn-active-border-color: var(--vz-next-button);
}

.btn-soft-next-button {
  --vz-btn-color: var(--vz-next-button);
  --vz-btn-bg: var(--vz-next-button-bg-subtle);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-bg: var(--vz-next-button);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-next-button-rgb);
  --vz-btn-active-bg: var(--vz-next-button);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-next-button {
  --vz-btn-color: var(--vz-next-button);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: var(--vz-next-button);
  --vz-btn-hover-bg: var(--vz-next-button-bg-subtle);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-next-button-rgb);
  --vz-btn-active-color: var(--vz-next-button);
  --vz-btn-active-bg: var(--vz-next-button-bg-subtle);
  --vz-btn-active-border-color: transparent;
}

.btn-next-button-border {
  --vz-btn-bg: var(--vz-next-button-border);
  --vz-btn-border-color: var(--vz-next-button-border);
  --vz-btn-hover-bg: var(--vz-next-button-border-text-emphasis);
  --vz-btn-hover-border-color: var(--vz-next-button-border-text-emphasis);
  --vz-btn-focus-shadow-rgb: var(--vz-next-button-border-rgb);
  --vz-btn-active-bg: var(--vz-next-button-border-text-emphasis);
  --vz-btn-active-border-color: var(--vz-next-button-border-text-emphasis);
}

.btn-outline-next-button-border {
  --vz-btn-color: var(--vz-next-button-border);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: var(--vz-next-button-border);
  --vz-btn-hover-bg: var(--vz-next-button-border);
  --vz-btn-hover-border-color: var(--vz-next-button-border);
  --vz-btn-focus-shadow-rgb: var(--vz-next-button-border-rgb);
  --vz-btn-active-bg: var(--vz-next-button-border);
  --vz-btn-active-border-color: var(--vz-next-button-border);
}

.btn-soft-next-button-border {
  --vz-btn-color: var(--vz-next-button-border);
  --vz-btn-bg: var(--vz-next-button-border-bg-subtle);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-bg: var(--vz-next-button-border);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-next-button-border-rgb);
  --vz-btn-active-bg: var(--vz-next-button-border);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-next-button-border {
  --vz-btn-color: var(--vz-next-button-border);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: var(--vz-next-button-border);
  --vz-btn-hover-bg: var(--vz-next-button-border-bg-subtle);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-next-button-border-rgb);
  --vz-btn-active-color: var(--vz-next-button-border);
  --vz-btn-active-bg: var(--vz-next-button-border-bg-subtle);
  --vz-btn-active-border-color: transparent;
}

.btn-next-button-hover {
  --vz-btn-bg: var(--vz-next-button-hover);
  --vz-btn-border-color: var(--vz-next-button-hover);
  --vz-btn-hover-bg: var(--vz-next-button-hover-text-emphasis);
  --vz-btn-hover-border-color: var(--vz-next-button-hover-text-emphasis);
  --vz-btn-focus-shadow-rgb: var(--vz-next-button-hover-rgb);
  --vz-btn-active-bg: var(--vz-next-button-hover-text-emphasis);
  --vz-btn-active-border-color: var(--vz-next-button-hover-text-emphasis);
}

.btn-outline-next-button-hover {
  --vz-btn-color: var(--vz-next-button-hover);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: var(--vz-next-button-hover);
  --vz-btn-hover-bg: var(--vz-next-button-hover);
  --vz-btn-hover-border-color: var(--vz-next-button-hover);
  --vz-btn-focus-shadow-rgb: var(--vz-next-button-hover-rgb);
  --vz-btn-active-bg: var(--vz-next-button-hover);
  --vz-btn-active-border-color: var(--vz-next-button-hover);
}

.btn-soft-next-button-hover {
  --vz-btn-color: var(--vz-next-button-hover);
  --vz-btn-bg: var(--vz-next-button-hover-bg-subtle);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-bg: var(--vz-next-button-hover);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-next-button-hover-rgb);
  --vz-btn-active-bg: var(--vz-next-button-hover);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-next-button-hover {
  --vz-btn-color: var(--vz-next-button-hover);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: var(--vz-next-button-hover);
  --vz-btn-hover-bg: var(--vz-next-button-hover-bg-subtle);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-next-button-hover-rgb);
  --vz-btn-active-color: var(--vz-next-button-hover);
  --vz-btn-active-bg: var(--vz-next-button-hover-bg-subtle);
  --vz-btn-active-border-color: transparent;
}

.btn-white {
  --vz-btn-bg: var(--vz-white);
  --vz-btn-border-color: var(--vz-white);
  --vz-btn-hover-bg: var(--vz-white-text-emphasis);
  --vz-btn-hover-border-color: var(--vz-white-text-emphasis);
  --vz-btn-focus-shadow-rgb: var(--vz-white-rgb);
  --vz-btn-active-bg: var(--vz-white-text-emphasis);
  --vz-btn-active-border-color: var(--vz-white-text-emphasis);
}

.btn-outline-white {
  --vz-btn-color: var(--vz-white);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: var(--vz-white);
  --vz-btn-hover-bg: var(--vz-white);
  --vz-btn-hover-border-color: var(--vz-white);
  --vz-btn-focus-shadow-rgb: var(--vz-white-rgb);
  --vz-btn-active-bg: var(--vz-white);
  --vz-btn-active-border-color: var(--vz-white);
}

.btn-soft-white {
  --vz-btn-color: var(--vz-white);
  --vz-btn-bg: var(--vz-white-bg-subtle);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-bg: var(--vz-white);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-white-rgb);
  --vz-btn-active-bg: var(--vz-white);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-white {
  --vz-btn-color: var(--vz-white);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: var(--vz-white);
  --vz-btn-hover-bg: var(--vz-white-bg-subtle);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-white-rgb);
  --vz-btn-active-color: var(--vz-white);
  --vz-btn-active-bg: var(--vz-white-bg-subtle);
  --vz-btn-active-border-color: transparent;
}

.btn-light-grey {
  --vz-btn-bg: var(--vz-light-grey);
  --vz-btn-border-color: var(--vz-light-grey);
  --vz-btn-hover-bg: var(--vz-light-grey-text-emphasis);
  --vz-btn-hover-border-color: var(--vz-light-grey-text-emphasis);
  --vz-btn-focus-shadow-rgb: var(--vz-light-grey-rgb);
  --vz-btn-active-bg: var(--vz-light-grey-text-emphasis);
  --vz-btn-active-border-color: var(--vz-light-grey-text-emphasis);
}

.btn-outline-light-grey {
  --vz-btn-color: var(--vz-light-grey);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: var(--vz-light-grey);
  --vz-btn-hover-bg: var(--vz-light-grey);
  --vz-btn-hover-border-color: var(--vz-light-grey);
  --vz-btn-focus-shadow-rgb: var(--vz-light-grey-rgb);
  --vz-btn-active-bg: var(--vz-light-grey);
  --vz-btn-active-border-color: var(--vz-light-grey);
}

.btn-soft-light-grey {
  --vz-btn-color: var(--vz-light-grey);
  --vz-btn-bg: var(--vz-light-grey-bg-subtle);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-bg: var(--vz-light-grey);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-light-grey-rgb);
  --vz-btn-active-bg: var(--vz-light-grey);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-light-grey {
  --vz-btn-color: var(--vz-light-grey);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: var(--vz-light-grey);
  --vz-btn-hover-bg: var(--vz-light-grey-bg-subtle);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: var(--vz-light-grey-rgb);
  --vz-btn-active-color: var(--vz-light-grey);
  --vz-btn-active-bg: var(--vz-light-grey-bg-subtle);
  --vz-btn-active-border-color: transparent;
}

.btn-label {
  position: relative;
  padding-left: 44px;
}
.btn-label .label-icon {
  position: absolute;
  width: 35.5px;
  left: calc(var(--vz-border-width) * -1);
  top: calc(var(--vz-border-width) * -1);
  bottom: calc(var(--vz-border-width) * -1);
  background-color: rgba(255, 255, 255, 0.1);
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-label.btn-light .label-icon {
  background-color: rgba(54, 61, 72, 0.05);
}
.btn-label.right {
  padding-left: 0.9rem;
  padding-right: 44px;
}
.btn-label.right .label-icon {
  right: calc(var(--vz-border-width) * -1);
  left: auto;
}

.btn-animation {
  overflow: hidden;
  transition: border-color 0.3s, background-color 0.3s;
  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);
}
.btn-animation::after {
  content: attr(data-text);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  transform: translate3d(0, 25%, 0);
  padding: 0.5rem 0.9rem;
  transition: transform 0.3s, opacity 0.3s;
  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);
}
.btn-animation > span {
  display: block;
  transition: transform 0.3s, opacity 0.3s;
  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);
}
.btn-animation:hover::after {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}
.btn-animation:hover > span {
  opacity: 0;
  transform: translate3d(0, -25%, 0);
}

.btn-primary.btn-animation {
  background-color: #b4d0f0;
  border-color: #b4d0f0 !important;
}
.btn-primary.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #b4d0f0;
  background-color: rgba(180, 208, 240, 0.1);
}

.btn-secondary.btn-animation {
  background-color: #daecfb;
  border-color: #daecfb !important;
}
.btn-secondary.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #daecfb;
  background-color: rgba(218, 236, 251, 0.1);
}

.btn-success.btn-animation {
  background-color: #13c56b;
  border-color: #13c56b !important;
}
.btn-success.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #13c56b;
  background-color: rgba(19, 197, 107, 0.1);
}

.btn-info.btn-animation {
  background-color: #50c3e6;
  border-color: #50c3e6 !important;
}
.btn-info.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #50c3e6;
  background-color: rgba(80, 195, 230, 0.1);
}

.btn-warning.btn-animation {
  background-color: #e8bc52;
  border-color: #e8bc52 !important;
}
.btn-warning.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #e8bc52;
  background-color: rgba(232, 188, 82, 0.1);
}

.btn-danger.btn-animation {
  background-color: #ed5e5e;
  border-color: #ed5e5e !important;
}
.btn-danger.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #ed5e5e;
  background-color: rgba(237, 94, 94, 0.1);
}

.btn-light.btn-animation {
  background-color: #f3f6f9;
  border-color: #f3f6f9 !important;
}
.btn-light.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #f3f6f9;
  background-color: rgba(243, 246, 249, 0.1);
}

.btn-dark.btn-animation {
  background-color: #363d48;
  border-color: #363d48 !important;
}
.btn-dark.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #363d48;
  background-color: rgba(54, 61, 72, 0.1);
}

.btn-custom-primary.btn-animation {
  background-color: #7eabe7;
  border-color: #7eabe7 !important;
}
.btn-custom-primary.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #7eabe7;
  background-color: rgba(126, 171, 231, 0.1);
}

.btn-custom-primary-hover.btn-animation {
  background-color: #bcd4f8;
  border-color: #bcd4f8 !important;
}
.btn-custom-primary-hover.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #bcd4f8;
  background-color: rgba(188, 212, 248, 0.1);
}

.btn-new-primary.btn-animation {
  background-color: #0A56AE;
  border-color: #0A56AE !important;
}
.btn-new-primary.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #0A56AE;
  background-color: rgba(10, 86, 174, 0.1);
}

.btn-header.btn-animation {
  background-color: #bdd6fb;
  border-color: #bdd6fb !important;
}
.btn-header.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #bdd6fb;
  background-color: rgba(189, 214, 251, 0.1);
}

.btn-next-button.btn-animation {
  background-color: #83a9e2;
  border-color: #83a9e2 !important;
}
.btn-next-button.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #83a9e2;
  background-color: rgba(131, 169, 226, 0.1);
}

.btn-next-button-border.btn-animation {
  background-color: #5d87c7;
  border-color: #5d87c7 !important;
}
.btn-next-button-border.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #5d87c7;
  background-color: rgba(93, 135, 199, 0.1);
}

.btn-next-button-hover.btn-animation {
  background-color: #bdd6fa;
  border-color: #bdd6fa !important;
}
.btn-next-button-hover.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #bdd6fa;
  background-color: rgba(189, 214, 250, 0.1);
}

.btn-white.btn-animation {
  background-color: #fff;
  border-color: #fff !important;
}
.btn-white.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
}

.btn-light-grey.btn-animation {
  background-color: #ced4da;
  border-color: #ced4da !important;
}
.btn-light-grey.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #ced4da;
  background-color: rgba(206, 212, 218, 0.1);
}

.btn-group-vertical label {
  margin-bottom: 0;
}

.btn-group.radio .btn {
  border: none;
}
.btn-group.radio .btn-check:active + .btn-light,
.btn-group.radio .btn-check:checked + .btn-light,
.btn-group.radio .btn-light.active,
.btn-group.radio .btn-light.dropdown-toggle.show,
.btn-group.radio .btn-light:active {
  background-color: rgba(80, 195, 230, 0.2);
  color: #50c3e6;
}

.btn-load .spinner-border,
.btn-load .spinner-grow {
  height: 19px;
  width: 19px;
}

:is(.btn-primary, .btn-outline-primary, .btn-soft-primary).btn-border {
  border-bottom: 2px solid #92bbe9;
}

:is(.btn-soft-primary, .btn-outline-primary) {
  --vz-btn-active-color: #000;
  --vz-btn-hover-color: #000;
}

:is(.btn-secondary, .btn-outline-secondary, .btn-soft-secondary).btn-border {
  border-bottom: 2px solid #b5d9f7;
}

:is(.btn-soft-secondary, .btn-outline-secondary) {
  --vz-btn-active-color: #000;
  --vz-btn-hover-color: #000;
}

:is(.btn-success, .btn-outline-success, .btn-soft-success).btn-border {
  border-bottom: 2px solid #0fa057;
}

:is(.btn-soft-success, .btn-outline-success) {
  --vz-btn-active-color: #fff;
  --vz-btn-hover-color: #fff;
}

:is(.btn-info, .btn-outline-info, .btn-soft-info).btn-border {
  border-bottom: 2px solid #2cb7e1;
}

:is(.btn-soft-info, .btn-outline-info) {
  --vz-btn-active-color: #fff;
  --vz-btn-hover-color: #fff;
}

:is(.btn-warning, .btn-outline-warning, .btn-soft-warning).btn-border {
  border-bottom: 2px solid #e3ae2e;
}

:is(.btn-soft-warning, .btn-outline-warning) {
  --vz-btn-active-color: #fff;
  --vz-btn-hover-color: #fff;
}

:is(.btn-danger, .btn-outline-danger, .btn-soft-danger).btn-border {
  border-bottom: 2px solid #e93939;
}

:is(.btn-soft-danger, .btn-outline-danger) {
  --vz-btn-active-color: #fff;
  --vz-btn-hover-color: #fff;
}

:is(.btn-light, .btn-outline-light, .btn-soft-light).btn-border {
  border-bottom: 2px solid #d8e2eb;
}

:is(.btn-soft-light, .btn-outline-light) {
  --vz-btn-active-color: #000;
  --vz-btn-hover-color: #000;
}

:is(.btn-dark, .btn-outline-dark, .btn-soft-dark).btn-border {
  border-bottom: 2px solid #252931;
}

:is(.btn-soft-dark, .btn-outline-dark) {
  --vz-btn-active-color: #fff;
  --vz-btn-hover-color: #fff;
}

:is(.btn-custom-primary, .btn-outline-custom-primary, .btn-soft-custom-primary).btn-border {
  border-bottom: 2px solid #5c95e1;
}

:is(.btn-soft-custom-primary, .btn-outline-custom-primary) {
  --vz-btn-active-color: #fff;
  --vz-btn-hover-color: #fff;
}

:is(.btn-custom-primary-hover, .btn-outline-custom-primary-hover, .btn-soft-custom-primary-hover).btn-border {
  border-bottom: 2px solid #97bcf4;
}

:is(.btn-soft-custom-primary-hover, .btn-outline-custom-primary-hover) {
  --vz-btn-active-color: #000;
  --vz-btn-hover-color: #000;
}

:is(.btn-new-primary, .btn-outline-new-primary, .btn-soft-new-primary).btn-border {
  border-bottom: 2px solid #084387;
}

:is(.btn-soft-new-primary, .btn-outline-new-primary) {
  --vz-btn-active-color: #fff;
  --vz-btn-hover-color: #fff;
}

:is(.btn-header, .btn-outline-header, .btn-soft-header).btn-border {
  border-bottom: 2px solid #97bef9;
}

:is(.btn-soft-header, .btn-outline-header) {
  --vz-btn-active-color: #000;
  --vz-btn-hover-color: #000;
}

:is(.btn-next-button, .btn-outline-next-button, .btn-soft-next-button).btn-border {
  border-bottom: 2px solid #6292da;
}

:is(.btn-soft-next-button, .btn-outline-next-button) {
  --vz-btn-active-color: #fff;
  --vz-btn-hover-color: #fff;
}

:is(.btn-next-button-border, .btn-outline-next-button-border, .btn-soft-next-button-border).btn-border {
  border-bottom: 2px solid #4171bb;
}

:is(.btn-soft-next-button-border, .btn-outline-next-button-border) {
  --vz-btn-active-color: #fff;
  --vz-btn-hover-color: #fff;
}

:is(.btn-next-button-hover, .btn-outline-next-button-hover, .btn-soft-next-button-hover).btn-border {
  border-bottom: 2px solid #97bef7;
}

:is(.btn-soft-next-button-hover, .btn-outline-next-button-hover) {
  --vz-btn-active-color: #000;
  --vz-btn-hover-color: #000;
}

:is(.btn-white, .btn-outline-white, .btn-soft-white).btn-border {
  border-bottom: 2px solid #ebebeb;
}

:is(.btn-soft-white, .btn-outline-white) {
  --vz-btn-active-color: #000;
  --vz-btn-hover-color: #000;
}

:is(.btn-light-grey, .btn-outline-light-grey, .btn-soft-light-grey).btn-border {
  border-bottom: 2px solid #b7c0c8;
}

:is(.btn-soft-light-grey, .btn-outline-light-grey) {
  --vz-btn-active-color: #000;
  --vz-btn-hover-color: #000;
}

.custom-toggle .icon-off {
  display: none;
}
.custom-toggle.active .icon-on {
  display: none;
}
.custom-toggle.active .icon-off {
  display: block;
}

.breadcrumb-item > a {
  color: var(--vz-body-color);
}
.breadcrumb-item + .breadcrumb-item::before {
  font-family: "Material Design Icons";
  font-size: 15px;
  line-height: 20px;
}

.card {
  margin-bottom: 1.5rem;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
}

.card-header {
  border-bottom: 1px solid var(--vz-border-color);
}

.card-header-dropdown .dropdown-btn {
  padding: 1rem 0;
}

.card-footer {
  border-top: 1px solid var(--vz-border-color);
}

.card-title {
  font-size: 16px;
  margin: 0 0 7px 0;
}

.card-height-100 {
  height: calc(100% - 1.5rem);
}

.card-animate {
  transition: all 0.4s;
}
.card-animate:hover {
  transform: translateY(calc(-1.5rem / 5));
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
}

.card-primary {
  background-color: #b4d0f0;
  color: #000;
}
.card-primary .card-header, .card-primary .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #000;
  border-color: transparent;
}
.card-primary .card-title {
  color: #000;
}

.card-secondary {
  background-color: #daecfb;
  color: #000;
}
.card-secondary .card-header, .card-secondary .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #000;
  border-color: transparent;
}
.card-secondary .card-title {
  color: #000;
}

.card-success {
  background-color: #13c56b;
  color: #fff;
}
.card-success .card-header, .card-success .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-success .card-title {
  color: #fff;
}

.card-info {
  background-color: #50c3e6;
  color: #fff;
}
.card-info .card-header, .card-info .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-info .card-title {
  color: #fff;
}

.card-warning {
  background-color: #e8bc52;
  color: #fff;
}
.card-warning .card-header, .card-warning .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-warning .card-title {
  color: #fff;
}

.card-danger {
  background-color: #ed5e5e;
  color: #fff;
}
.card-danger .card-header, .card-danger .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-danger .card-title {
  color: #fff;
}

.card-light {
  background-color: #f3f6f9;
  color: #000;
}
.card-light .card-header, .card-light .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #000;
  border-color: transparent;
}
.card-light .card-title {
  color: #000;
}

.card-dark {
  background-color: #363d48;
  color: #fff;
}
.card-dark .card-header, .card-dark .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-dark .card-title {
  color: #fff;
}

.card-custom-primary {
  background-color: #7eabe7;
  color: #fff;
}
.card-custom-primary .card-header, .card-custom-primary .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-custom-primary .card-title {
  color: #fff;
}

.card-custom-primary-hover {
  background-color: #bcd4f8;
  color: #000;
}
.card-custom-primary-hover .card-header, .card-custom-primary-hover .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #000;
  border-color: transparent;
}
.card-custom-primary-hover .card-title {
  color: #000;
}

.card-new-primary {
  background-color: #0A56AE;
  color: #fff;
}
.card-new-primary .card-header, .card-new-primary .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-new-primary .card-title {
  color: #fff;
}

.card-header {
  background-color: #bdd6fb;
  color: #000;
}
.card-header .card-header, .card-header .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #000;
  border-color: transparent;
}
.card-header .card-title {
  color: #000;
}

.card-next-button {
  background-color: #83a9e2;
  color: #fff;
}
.card-next-button .card-header, .card-next-button .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-next-button .card-title {
  color: #fff;
}

.card-next-button-border {
  background-color: #5d87c7;
  color: #fff;
}
.card-next-button-border .card-header, .card-next-button-border .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-next-button-border .card-title {
  color: #fff;
}

.card-next-button-hover {
  background-color: #bdd6fa;
  color: #000;
}
.card-next-button-hover .card-header, .card-next-button-hover .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #000;
  border-color: transparent;
}
.card-next-button-hover .card-title {
  color: #000;
}

.card-white {
  background-color: #fff;
  color: #000;
}
.card-white .card-header, .card-white .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #000;
  border-color: transparent;
}
.card-white .card-title {
  color: #000;
}

.card-light-grey {
  background-color: #ced4da;
  color: #000;
}
.card-light-grey .card-header, .card-light-grey .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #000;
  border-color: transparent;
}
.card-light-grey .card-title {
  color: #000;
}

.card-border-primary {
  border-color: #b4d0f0 !important;
}
.card-border-primary .card-header, .card-border-primary .card-footer {
  border-color: #b4d0f0;
}

.card-border-secondary {
  border-color: #daecfb !important;
}
.card-border-secondary .card-header, .card-border-secondary .card-footer {
  border-color: #daecfb;
}

.card-border-success {
  border-color: #13c56b !important;
}
.card-border-success .card-header, .card-border-success .card-footer {
  border-color: #13c56b;
}

.card-border-info {
  border-color: #50c3e6 !important;
}
.card-border-info .card-header, .card-border-info .card-footer {
  border-color: #50c3e6;
}

.card-border-warning {
  border-color: #e8bc52 !important;
}
.card-border-warning .card-header, .card-border-warning .card-footer {
  border-color: #e8bc52;
}

.card-border-danger {
  border-color: #ed5e5e !important;
}
.card-border-danger .card-header, .card-border-danger .card-footer {
  border-color: #ed5e5e;
}

.card-border-light {
  border-color: #f3f6f9 !important;
}
.card-border-light .card-header, .card-border-light .card-footer {
  border-color: #f3f6f9;
}

.card-border-dark {
  border-color: #363d48 !important;
}
.card-border-dark .card-header, .card-border-dark .card-footer {
  border-color: #363d48;
}

.card-border-custom-primary {
  border-color: #7eabe7 !important;
}
.card-border-custom-primary .card-header, .card-border-custom-primary .card-footer {
  border-color: #7eabe7;
}

.card-border-custom-primary-hover {
  border-color: #bcd4f8 !important;
}
.card-border-custom-primary-hover .card-header, .card-border-custom-primary-hover .card-footer {
  border-color: #bcd4f8;
}

.card-border-new-primary {
  border-color: #0A56AE !important;
}
.card-border-new-primary .card-header, .card-border-new-primary .card-footer {
  border-color: #0A56AE;
}

.card-border-header {
  border-color: #bdd6fb !important;
}
.card-border-header .card-header, .card-border-header .card-footer {
  border-color: #bdd6fb;
}

.card-border-next-button {
  border-color: #83a9e2 !important;
}
.card-border-next-button .card-header, .card-border-next-button .card-footer {
  border-color: #83a9e2;
}

.card-border-next-button-border {
  border-color: #5d87c7 !important;
}
.card-border-next-button-border .card-header, .card-border-next-button-border .card-footer {
  border-color: #5d87c7;
}

.card-border-next-button-hover {
  border-color: #bdd6fa !important;
}
.card-border-next-button-hover .card-header, .card-border-next-button-hover .card-footer {
  border-color: #bdd6fa;
}

.card-border-white {
  border-color: #fff !important;
}
.card-border-white .card-header, .card-border-white .card-footer {
  border-color: #fff;
}

.card-border-light-grey {
  border-color: #ced4da !important;
}
.card-border-light-grey .card-header, .card-border-light-grey .card-footer {
  border-color: #ced4da;
}

.card-light {
  background-color: var(--vz-light);
}
.card-light .card-header, .card-light .card-footer {
  color: var(--vz-body-color) !important;
  background-color: rgba(var(--vz-dark-rgb), 0.1);
}
.card-light .card-title, .card-light .card-text {
  color: var(--vz-body-color) !important;
}

.card-preloader {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(var(--vz-light-rgb), 0.6);
  z-index: 9999;
}

.card-status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) !important;
}

.custom-loader {
  animation: spin 2s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.card-overlay {
  position: relative;
  overflow: hidden;
}
.card-overlay:before {
  content: "";
  background-color: rgba(180, 208, 240, 0.2);
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
.card-overlay :is(.card-header, .card-footer) {
  border-color: rgba(255, 255, 255, 0.15) !important;
}

.card-toolbar-menu {
  line-height: 0.8;
}
.card-toolbar-menu a {
  font-size: 17px;
}
.card-toolbar-menu .minimize-card .plus {
  display: none;
}
.card-toolbar-menu .minimize-card .minus {
  display: block;
}
.card-toolbar-menu .minimize-card.collapsed .plus {
  display: block;
}
.card-toolbar-menu .minimize-card.collapsed .minus {
  display: none;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  font-size: 15px;
  line-height: 15px;
  content: "󰅀";
  font-family: "Material Design Icons";
}

.dropdown-menu {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  position: absolute;
  z-index: 1000;
}
.dropdown-menu.dropdown-megamenu {
  padding: 20px;
  left: 0 !important;
  right: 0 !important;
}
.dropdown-menu[data-popper-placement=top-start] {
  animation-name: DropDownSlideDown;
}

@keyframes DropDownSlide {
  100% {
    margin-top: -1px;
  }
  0% {
    margin-top: 8px;
  }
}
@keyframes DropDownSlideDown {
  100% {
    margin-bottom: 0;
  }
  0% {
    margin-bottom: 8px;
  }
}
@media (min-width: 600px) {
  .dropdown-menu-xl {
    width: 420px;
  }

  .dropdown-menu-lg {
    width: 320px;
  }

  .dropdown-menu-md {
    width: 240px;
  }
}
.dropdown-toggle-split {
  border-left: none;
}
.dropdown-toggle-split::after {
  margin-left: 0px;
}
.dropdown-toggle-split:before {
  content: "";
  position: absolute;
  background-color: rgba(255, 255, 255, 0.12);
  top: calc(var(--vz-border-width) * -1);
  bottom: calc(var(--vz-border-width) * -1);
  right: calc(var(--vz-border-width) * -1);
  left: 0;
  border-radius: 0 var(--vz-border-radius) var(--vz-border-radius) 0;
}

.dropdown-mega {
  position: static !important;
}

.dropdown-mega-menu-xl {
  width: 38rem;
}

.dropdown-mega-menu-lg {
  width: 26rem;
}

[dir=ltr] .dropdown-menu-start {
  --vz-position: end;
}
[dir=ltr] .dropdown-menu-end {
  --vz-position: start;
}

.dropdown-head .nav-tabs-custom {
  border: 0;
}
.dropdown-head .nav-tabs-custom .nav-link {
  color: rgba(255, 255, 255, 0.6);
}
.dropdown-head .nav-tabs-custom .nav-link.active {
  background-color: var(--vz-dropdown-bg);
}
.dropdown-head .nav-tabs-custom .nav-link:hover {
  color: #fff;
}

.dropdownmenu-primary .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(180, 208, 240, 0.07);
  color: #b4d0f0;
}

.dropdownmenu-secondary .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(218, 236, 251, 0.07);
  color: #daecfb;
}

.dropdownmenu-success .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(19, 197, 107, 0.07);
  color: #13c56b;
}

.dropdownmenu-info .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(80, 195, 230, 0.07);
  color: #50c3e6;
}

.dropdownmenu-warning .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(232, 188, 82, 0.07);
  color: #e8bc52;
}

.dropdownmenu-danger .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(237, 94, 94, 0.07);
  color: #ed5e5e;
}

.dropdownmenu-light .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(243, 246, 249, 0.07);
  color: #f3f6f9;
}

.dropdownmenu-dark .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(54, 61, 72, 0.07);
  color: #363d48;
}

.dropdownmenu-custom-primary .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(126, 171, 231, 0.07);
  color: #7eabe7;
}

.dropdownmenu-custom-primary-hover .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(188, 212, 248, 0.07);
  color: #bcd4f8;
}

.dropdownmenu-new-primary .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(10, 86, 174, 0.07);
  color: #0A56AE;
}

.dropdownmenu-header .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(189, 214, 251, 0.07);
  color: #bdd6fb;
}

.dropdownmenu-next-button .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(131, 169, 226, 0.07);
  color: #83a9e2;
}

.dropdownmenu-next-button-border .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(93, 135, 199, 0.07);
  color: #5d87c7;
}

.dropdownmenu-next-button-hover .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(189, 214, 250, 0.07);
  color: #bdd6fa;
}

.dropdownmenu-white .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(255, 255, 255, 0.07);
  color: #fff;
}

.dropdownmenu-light-grey .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(206, 212, 218, 0.07);
  color: #ced4da;
}

:is(.nav-tabs, .nav-pills) > li > a {
  color: var(--vz-body-color);
  font-weight: 400;
}

.nav-pills > a {
  color: var(--vz-body-color);
  font-weight: 400;
}

.nav-pills :is(.nav-link.active, .show>.nav-link) {
  box-shadow: none;
}

.nav-tabs-custom {
  border-bottom: 1px solid var(--vz-border-color);
}
.nav-tabs-custom .nav-item {
  position: relative;
}
.nav-tabs-custom .nav-item .nav-link {
  border: none;
  font-weight: 400;
}
.nav-tabs-custom .nav-item .nav-link::after {
  content: "";
  background: #b4d0f0;
  height: 1px;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  transition: all 250ms ease 0s;
  transform: scale(0);
}
.nav-tabs-custom .nav-item .nav-link.active {
  color: #b4d0f0;
}
.nav-tabs-custom .nav-item .nav-link.active:after {
  transform: scale(1);
}
.nav-tabs-custom.card-header-tabs {
  margin-top: -1rem;
}
.nav-tabs-custom.card-header-tabs .nav-link {
  padding: 1rem 1rem;
}

.vertical-nav .nav .nav-link {
  padding: 24px 16px;
  text-align: center;
  margin-bottom: 8px;
}
.vertical-nav .nav .nav-link .nav-icon {
  font-size: 24px;
}

.navtab-bg li > a {
  background-color: #e9ebec;
  margin: 0 5px;
}

.arrow-navtabs .nav-item .nav-link {
  position: relative;
  text-align: center;
}
.arrow-navtabs .nav-item .nav-link:before {
  content: "";
  position: absolute;
  border: 6px solid transparent;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .arrow-navtabs .nav-item .nav-link:before {
    transition: none;
  }
}
.arrow-navtabs .nav-item .nav-link.active:before {
  border-top-color: #b4d0f0;
}

.custom-hover-nav-tabs .nav-item {
  text-align: center;
  overflow: hidden;
}
.custom-hover-nav-tabs .nav-item .nav-link {
  width: 120px;
  height: 45px;
  position: relative;
  border-radius: 0px;
}
.custom-hover-nav-tabs .nav-item .nav-link .nav-icon {
  font-size: 22px;
}
.custom-hover-nav-tabs .nav-item .nav-link .nav-titl {
  font-size: 14px;
}
.custom-hover-nav-tabs .nav-item .nav-link.active .nav-tab-position {
  color: #fff;
}
.custom-hover-nav-tabs .nav-item .nav-link .nav-tab-position {
  position: absolute;
  left: 0;
  right: 0;
  transition: all 0.4s;
}
.custom-hover-nav-tabs .nav-item .nav-link .nav-tab-position.nav-icon {
  top: 50%;
  transform: translateY(-50%);
}
.custom-hover-nav-tabs .nav-item .nav-link .nav-tab-position.nav-titl {
  bottom: -20px;
}
.custom-hover-nav-tabs .nav-item .nav-link:hover .nav-titl {
  bottom: 50%;
  transform: translateY(50%);
}
.custom-hover-nav-tabs .nav-item .nav-link:hover .nav-icon {
  top: -20px;
}

.custom-verti-nav-pills .nav-link {
  background-color: var(--vz-light);
  margin-top: 7px;
  position: relative;
}
@media (min-width: 992px) {
  .custom-verti-nav-pills .nav-link::before {
    content: "";
    position: absolute;
    right: -20px;
    top: 50%;
    transform: translateY(-50%);
    border: 12px solid transparent;
    border-left-color: transparent;
    transition: border-left-color 0.04 ease;
  }
  .custom-verti-nav-pills .nav-link.active::before {
    border-left-color: #b4d0f0;
  }
}

.animation-nav li {
  position: relative;
}
.animation-nav li a {
  color: var(--vz-body-color);
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  transition: all 0.4s;
  z-index: 1;
}
.animation-nav li a span {
  position: relative;
}
.animation-nav li a::before {
  content: "";
  position: absolute;
  top: 0;
  width: 0;
  right: 0;
  height: 100%;
  transition: width 0.4s cubic-bezier(0.51, 0.18, 0, 0.88) 0.1s;
  background-color: #b4d0f0;
  z-index: -1;
}
.animation-nav li a:hover, .animation-nav li a.active {
  color: #fff;
  background-color: transparent !important;
}
.animation-nav li a:hover::before, .animation-nav li a.active::before {
  width: 100%;
  left: 0;
}

.nav-border-top .nav-link {
  border-top: 3px solid transparent;
}
.nav-border-top .nav-link.active {
  border-top-color: #b4d0f0;
}

.nav-border-top-primary .nav-link.active {
  color: #b4d0f0;
  border-top-color: #b4d0f0;
}

.nav-border-top-secondary .nav-link.active {
  color: #daecfb;
  border-top-color: #daecfb;
}

.nav-border-top-success .nav-link.active {
  color: #13c56b;
  border-top-color: #13c56b;
}

.nav-border-top-info .nav-link.active {
  color: #50c3e6;
  border-top-color: #50c3e6;
}

.nav-border-top-warning .nav-link.active {
  color: #e8bc52;
  border-top-color: #e8bc52;
}

.nav-border-top-danger .nav-link.active {
  color: #ed5e5e;
  border-top-color: #ed5e5e;
}

.nav-border-top-light .nav-link.active {
  color: #f3f6f9;
  border-top-color: #f3f6f9;
}

.nav-border-top-dark .nav-link.active {
  color: #363d48;
  border-top-color: #363d48;
}

.nav-border-top-custom-primary .nav-link.active {
  color: #7eabe7;
  border-top-color: #7eabe7;
}

.nav-border-top-custom-primary-hover .nav-link.active {
  color: #bcd4f8;
  border-top-color: #bcd4f8;
}

.nav-border-top-new-primary .nav-link.active {
  color: #0A56AE;
  border-top-color: #0A56AE;
}

.nav-border-top-header .nav-link.active {
  color: #bdd6fb;
  border-top-color: #bdd6fb;
}

.nav-border-top-next-button .nav-link.active {
  color: #83a9e2;
  border-top-color: #83a9e2;
}

.nav-border-top-next-button-border .nav-link.active {
  color: #5d87c7;
  border-top-color: #5d87c7;
}

.nav-border-top-next-button-hover .nav-link.active {
  color: #bdd6fa;
  border-top-color: #bdd6fa;
}

.nav-border-top-white .nav-link.active {
  color: #fff;
  border-top-color: #fff;
}

.nav-border-top-light-grey .nav-link.active {
  color: #ced4da;
  border-top-color: #ced4da;
}

.nav-custom {
  background-color: #b4d0f0;
  border-radius: var(--vz-border-radius);
}
.nav-custom .nav-item .nav-link {
  color: rgba(255, 255, 255, 0.75);
}
.nav-custom .nav-item .nav-link.active {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
}
.nav-custom.nav-custom-light .nav-item .nav-link {
  color: rgba(var(--vz-body-rgb), 0.75);
}
.nav-custom.nav-custom-light .nav-item .nav-link.active {
  color: #f3f6f9;
  background-color: #b4d0f0;
}

.nav-custom-primary {
  background-color: #b4d0f0;
}

.nav-custom-secondary {
  background-color: #daecfb;
}

.nav-custom-success {
  background-color: #13c56b;
}

.nav-custom-info {
  background-color: #50c3e6;
}

.nav-custom-warning {
  background-color: #e8bc52;
}

.nav-custom-danger {
  background-color: #ed5e5e;
}

.nav-custom-light {
  background-color: #f3f6f9;
}

.nav-custom-dark {
  background-color: #363d48;
}

.nav-custom-custom-primary {
  background-color: #7eabe7;
}

.nav-custom-custom-primary-hover {
  background-color: #bcd4f8;
}

.nav-custom-new-primary {
  background-color: #0A56AE;
}

.nav-custom-header {
  background-color: #bdd6fb;
}

.nav-custom-next-button {
  background-color: #83a9e2;
}

.nav-custom-next-button-border {
  background-color: #5d87c7;
}

.nav-custom-next-button-hover {
  background-color: #bdd6fa;
}

.nav-custom-white {
  background-color: #fff;
}

.nav-custom-light-grey {
  background-color: #ced4da;
}

.nav-custom-light {
  background-color: var(--vz-light);
}

.nav-primary .nav-link.active {
  color: #fff;
  background-color: #b4d0f0;
}
.nav-primary.nav-tabs .nav-link.active {
  color: #b4d0f0;
  background-color: var(--vz-secondary-bg);
}
.nav-primary.nav-tabs-custom .nav-link.active {
  color: #b4d0f0;
  background-color: var(--vz-secondary-bg);
}
.nav-primary.nav-tabs-custom .nav-link.active::after {
  background-color: #b4d0f0;
}
.nav-primary.arrow-navtabs .nav-link.active::before {
  border-top-color: #b4d0f0;
}
.nav-primary.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #b4d0f0;
}

.nav-secondary .nav-link.active {
  color: #fff;
  background-color: #daecfb;
}
.nav-secondary.nav-tabs .nav-link.active {
  color: #daecfb;
  background-color: var(--vz-secondary-bg);
}
.nav-secondary.nav-tabs-custom .nav-link.active {
  color: #daecfb;
  background-color: var(--vz-secondary-bg);
}
.nav-secondary.nav-tabs-custom .nav-link.active::after {
  background-color: #daecfb;
}
.nav-secondary.arrow-navtabs .nav-link.active::before {
  border-top-color: #daecfb;
}
.nav-secondary.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #daecfb;
}

.nav-success .nav-link.active {
  color: #fff;
  background-color: #13c56b;
}
.nav-success.nav-tabs .nav-link.active {
  color: #13c56b;
  background-color: var(--vz-secondary-bg);
}
.nav-success.nav-tabs-custom .nav-link.active {
  color: #13c56b;
  background-color: var(--vz-secondary-bg);
}
.nav-success.nav-tabs-custom .nav-link.active::after {
  background-color: #13c56b;
}
.nav-success.arrow-navtabs .nav-link.active::before {
  border-top-color: #13c56b;
}
.nav-success.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #13c56b;
}

.nav-info .nav-link.active {
  color: #fff;
  background-color: #50c3e6;
}
.nav-info.nav-tabs .nav-link.active {
  color: #50c3e6;
  background-color: var(--vz-secondary-bg);
}
.nav-info.nav-tabs-custom .nav-link.active {
  color: #50c3e6;
  background-color: var(--vz-secondary-bg);
}
.nav-info.nav-tabs-custom .nav-link.active::after {
  background-color: #50c3e6;
}
.nav-info.arrow-navtabs .nav-link.active::before {
  border-top-color: #50c3e6;
}
.nav-info.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #50c3e6;
}

.nav-warning .nav-link.active {
  color: #fff;
  background-color: #e8bc52;
}
.nav-warning.nav-tabs .nav-link.active {
  color: #e8bc52;
  background-color: var(--vz-secondary-bg);
}
.nav-warning.nav-tabs-custom .nav-link.active {
  color: #e8bc52;
  background-color: var(--vz-secondary-bg);
}
.nav-warning.nav-tabs-custom .nav-link.active::after {
  background-color: #e8bc52;
}
.nav-warning.arrow-navtabs .nav-link.active::before {
  border-top-color: #e8bc52;
}
.nav-warning.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #e8bc52;
}

.nav-danger .nav-link.active {
  color: #fff;
  background-color: #ed5e5e;
}
.nav-danger.nav-tabs .nav-link.active {
  color: #ed5e5e;
  background-color: var(--vz-secondary-bg);
}
.nav-danger.nav-tabs-custom .nav-link.active {
  color: #ed5e5e;
  background-color: var(--vz-secondary-bg);
}
.nav-danger.nav-tabs-custom .nav-link.active::after {
  background-color: #ed5e5e;
}
.nav-danger.arrow-navtabs .nav-link.active::before {
  border-top-color: #ed5e5e;
}
.nav-danger.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #ed5e5e;
}

.nav-light .nav-link.active {
  color: #fff;
  background-color: #f3f6f9;
}
.nav-light.nav-tabs .nav-link.active {
  color: #f3f6f9;
  background-color: var(--vz-secondary-bg);
}
.nav-light.nav-tabs-custom .nav-link.active {
  color: #f3f6f9;
  background-color: var(--vz-secondary-bg);
}
.nav-light.nav-tabs-custom .nav-link.active::after {
  background-color: #f3f6f9;
}
.nav-light.arrow-navtabs .nav-link.active::before {
  border-top-color: #f3f6f9;
}
.nav-light.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #f3f6f9;
}

.nav-dark .nav-link.active {
  color: #fff;
  background-color: #363d48;
}
.nav-dark.nav-tabs .nav-link.active {
  color: #363d48;
  background-color: var(--vz-secondary-bg);
}
.nav-dark.nav-tabs-custom .nav-link.active {
  color: #363d48;
  background-color: var(--vz-secondary-bg);
}
.nav-dark.nav-tabs-custom .nav-link.active::after {
  background-color: #363d48;
}
.nav-dark.arrow-navtabs .nav-link.active::before {
  border-top-color: #363d48;
}
.nav-dark.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #363d48;
}

.nav-custom-primary .nav-link.active {
  color: #fff;
  background-color: #7eabe7;
}
.nav-custom-primary.nav-tabs .nav-link.active {
  color: #7eabe7;
  background-color: var(--vz-secondary-bg);
}
.nav-custom-primary.nav-tabs-custom .nav-link.active {
  color: #7eabe7;
  background-color: var(--vz-secondary-bg);
}
.nav-custom-primary.nav-tabs-custom .nav-link.active::after {
  background-color: #7eabe7;
}
.nav-custom-primary.arrow-navtabs .nav-link.active::before {
  border-top-color: #7eabe7;
}
.nav-custom-primary.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #7eabe7;
}

.nav-custom-primary-hover .nav-link.active {
  color: #fff;
  background-color: #bcd4f8;
}
.nav-custom-primary-hover.nav-tabs .nav-link.active {
  color: #bcd4f8;
  background-color: var(--vz-secondary-bg);
}
.nav-custom-primary-hover.nav-tabs-custom .nav-link.active {
  color: #bcd4f8;
  background-color: var(--vz-secondary-bg);
}
.nav-custom-primary-hover.nav-tabs-custom .nav-link.active::after {
  background-color: #bcd4f8;
}
.nav-custom-primary-hover.arrow-navtabs .nav-link.active::before {
  border-top-color: #bcd4f8;
}
.nav-custom-primary-hover.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #bcd4f8;
}

.nav-new-primary .nav-link.active {
  color: #fff;
  background-color: #0A56AE;
}
.nav-new-primary.nav-tabs .nav-link.active {
  color: #0A56AE;
  background-color: var(--vz-secondary-bg);
}
.nav-new-primary.nav-tabs-custom .nav-link.active {
  color: #0A56AE;
  background-color: var(--vz-secondary-bg);
}
.nav-new-primary.nav-tabs-custom .nav-link.active::after {
  background-color: #0A56AE;
}
.nav-new-primary.arrow-navtabs .nav-link.active::before {
  border-top-color: #0A56AE;
}
.nav-new-primary.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #0A56AE;
}

.nav-header .nav-link.active {
  color: #fff;
  background-color: #bdd6fb;
}
.nav-header.nav-tabs .nav-link.active {
  color: #bdd6fb;
  background-color: var(--vz-secondary-bg);
}
.nav-header.nav-tabs-custom .nav-link.active {
  color: #bdd6fb;
  background-color: var(--vz-secondary-bg);
}
.nav-header.nav-tabs-custom .nav-link.active::after {
  background-color: #bdd6fb;
}
.nav-header.arrow-navtabs .nav-link.active::before {
  border-top-color: #bdd6fb;
}
.nav-header.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #bdd6fb;
}

.nav-next-button .nav-link.active {
  color: #fff;
  background-color: #83a9e2;
}
.nav-next-button.nav-tabs .nav-link.active {
  color: #83a9e2;
  background-color: var(--vz-secondary-bg);
}
.nav-next-button.nav-tabs-custom .nav-link.active {
  color: #83a9e2;
  background-color: var(--vz-secondary-bg);
}
.nav-next-button.nav-tabs-custom .nav-link.active::after {
  background-color: #83a9e2;
}
.nav-next-button.arrow-navtabs .nav-link.active::before {
  border-top-color: #83a9e2;
}
.nav-next-button.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #83a9e2;
}

.nav-next-button-border .nav-link.active {
  color: #fff;
  background-color: #5d87c7;
}
.nav-next-button-border.nav-tabs .nav-link.active {
  color: #5d87c7;
  background-color: var(--vz-secondary-bg);
}
.nav-next-button-border.nav-tabs-custom .nav-link.active {
  color: #5d87c7;
  background-color: var(--vz-secondary-bg);
}
.nav-next-button-border.nav-tabs-custom .nav-link.active::after {
  background-color: #5d87c7;
}
.nav-next-button-border.arrow-navtabs .nav-link.active::before {
  border-top-color: #5d87c7;
}
.nav-next-button-border.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #5d87c7;
}

.nav-next-button-hover .nav-link.active {
  color: #fff;
  background-color: #bdd6fa;
}
.nav-next-button-hover.nav-tabs .nav-link.active {
  color: #bdd6fa;
  background-color: var(--vz-secondary-bg);
}
.nav-next-button-hover.nav-tabs-custom .nav-link.active {
  color: #bdd6fa;
  background-color: var(--vz-secondary-bg);
}
.nav-next-button-hover.nav-tabs-custom .nav-link.active::after {
  background-color: #bdd6fa;
}
.nav-next-button-hover.arrow-navtabs .nav-link.active::before {
  border-top-color: #bdd6fa;
}
.nav-next-button-hover.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #bdd6fa;
}

.nav-white .nav-link.active {
  color: #fff;
  background-color: #fff;
}
.nav-white.nav-tabs .nav-link.active {
  color: #fff;
  background-color: var(--vz-secondary-bg);
}
.nav-white.nav-tabs-custom .nav-link.active {
  color: #fff;
  background-color: var(--vz-secondary-bg);
}
.nav-white.nav-tabs-custom .nav-link.active::after {
  background-color: #fff;
}
.nav-white.arrow-navtabs .nav-link.active::before {
  border-top-color: #fff;
}
.nav-white.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #fff;
}

.nav-light-grey .nav-link.active {
  color: #fff;
  background-color: #ced4da;
}
.nav-light-grey.nav-tabs .nav-link.active {
  color: #ced4da;
  background-color: var(--vz-secondary-bg);
}
.nav-light-grey.nav-tabs-custom .nav-link.active {
  color: #ced4da;
  background-color: var(--vz-secondary-bg);
}
.nav-light-grey.nav-tabs-custom .nav-link.active::after {
  background-color: #ced4da;
}
.nav-light-grey.arrow-navtabs .nav-link.active::before {
  border-top-color: #ced4da;
}
.nav-light-grey.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #ced4da;
}

.progress-nav {
  position: relative;
  margin-right: 1rem;
  margin-left: 1rem;
}
.progress-nav .progress {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
}
.progress-nav .nav {
  margin-right: -1rem;
  margin-left: -1rem;
  justify-content: space-between;
}
.progress-nav .nav .nav-link {
  width: 2rem;
  height: 2rem;
  background-color: var(--vz-light);
  padding: 0;
  color: var(--vz-body-color);
  font-weight: 400;
}
.progress-nav .nav .nav-link.active, .progress-nav .nav .nav-link.done {
  background-color: #b4d0f0;
  color: #fff;
}

.step-arrow-nav .nav {
  background-color: var(--vz-light);
}
.step-arrow-nav .nav .nav-link {
  border-radius: 0;
  position: relative;
  font-weight: 400;
  color: var(--vz-body-color);
}
.step-arrow-nav .nav .nav-link::before {
  content: "";
  position: absolute;
  border: 7px solid transparent;
  right: -14px;
  top: 50%;
  transform: translateY(-50%);
}
.step-arrow-nav .nav .nav-link.done {
  background-color: rgba(180, 208, 240, 0.05);
  color: #b4d0f0;
}
.step-arrow-nav .nav .nav-link.done::before {
  border-left-color: transparent;
}
.step-arrow-nav .nav .nav-link.active {
  background-color: rgba(180, 208, 240, 0.1);
  color: #b4d0f0;
  box-shadow: none;
}
.step-arrow-nav .nav .nav-link.active::before {
  border-left-color: rgba(180, 208, 240, 0.1);
}
.step-arrow-nav .nav .nav-item:last-child .nav-link:before {
  display: none;
}

.vertical-navs-step .nav {
  gap: 16px;
}
.vertical-navs-step .nav .nav-link {
  text-align: left;
  background-color: rgba(var(--vz-light-rgb), 0.4);
  border: 1px solid var(--vz-border-color);
  color: var(--vz-body-color);
}
.vertical-navs-step .nav .nav-link .step-title {
  font-weight: 500;
}
.vertical-navs-step .nav .nav-link .step-icon {
  color: #ed5e5e;
  vertical-align: middle;
  font-weight: 400;
  float: left;
}
.vertical-navs-step .nav .nav-link.active .step-icon, .vertical-navs-step .nav .nav-link.done .step-icon {
  color: #13c56b;
}
.vertical-navs-step .nav .nav-link.active .step-icon:before, .vertical-navs-step .nav .nav-link.done .step-icon:before {
  content: "";
}
.vertical-navs-step .nav .nav-link.active {
  border-color: #b4d0f0;
}
.vertical-navs-step .nav .nav-link.done {
  border-color: #13c56b;
}

.nav-custom-outline.nav .nav-link {
  border: 1px solid transparent;
  border-bottom: 2px solid transparent;
}
.nav-custom-outline.nav .nav-link.active {
  border-color: #b4d0f0;
  background-color: transparent;
  color: #b4d0f0;
}

.nav-primary.nav-custom-outline .nav-link.active {
  color: #b4d0f0;
  border-color: #b4d0f0;
}

.nav-secondary.nav-custom-outline .nav-link.active {
  color: #daecfb;
  border-color: #daecfb;
}

.nav-success.nav-custom-outline .nav-link.active {
  color: #13c56b;
  border-color: #13c56b;
}

.nav-info.nav-custom-outline .nav-link.active {
  color: #50c3e6;
  border-color: #50c3e6;
}

.nav-warning.nav-custom-outline .nav-link.active {
  color: #e8bc52;
  border-color: #e8bc52;
}

.nav-danger.nav-custom-outline .nav-link.active {
  color: #ed5e5e;
  border-color: #ed5e5e;
}

.nav-light.nav-custom-outline .nav-link.active {
  color: #f3f6f9;
  border-color: #f3f6f9;
}

.nav-dark.nav-custom-outline .nav-link.active {
  color: #363d48;
  border-color: #363d48;
}

.nav-custom-primary.nav-custom-outline .nav-link.active {
  color: #7eabe7;
  border-color: #7eabe7;
}

.nav-custom-primary-hover.nav-custom-outline .nav-link.active {
  color: #bcd4f8;
  border-color: #bcd4f8;
}

.nav-new-primary.nav-custom-outline .nav-link.active {
  color: #0A56AE;
  border-color: #0A56AE;
}

.nav-header.nav-custom-outline .nav-link.active {
  color: #bdd6fb;
  border-color: #bdd6fb;
}

.nav-next-button.nav-custom-outline .nav-link.active {
  color: #83a9e2;
  border-color: #83a9e2;
}

.nav-next-button-border.nav-custom-outline .nav-link.active {
  color: #5d87c7;
  border-color: #5d87c7;
}

.nav-next-button-hover.nav-custom-outline .nav-link.active {
  color: #bdd6fa;
  border-color: #bdd6fa;
}

.nav-white.nav-custom-outline .nav-link.active {
  color: #fff;
  border-color: #fff;
}

.nav-light-grey.nav-custom-outline .nav-link.active {
  color: #ced4da;
  border-color: #ced4da;
}

.nav-customs.nav {
  padding-left: 34px;
  overflow: hidden;
}
.nav-customs.nav .nav-link {
  position: relative;
  display: block;
  float: right;
  background-color: var(--vz-tertiary-bg);
  margin-right: 46px;
  transition: all 0.5s ease;
}
.nav-customs.nav .nav-link::before, .nav-customs.nav .nav-link::after {
  display: block;
  content: " ";
  position: absolute;
  top: -1px;
  bottom: -1px;
  width: 37px;
  background-color: var(--vz-tertiary-bg);
  transition: all 0.5s ease;
}
.nav-customs.nav .nav-link::before {
  border-radius: 0 8px 0 0;
  right: -24px;
  transform: skew(30deg, 0deg);
}
.nav-customs.nav .nav-link::after {
  border-radius: 8px 0 0 0;
  left: -24px;
  transform: skew(-30deg, 0deg);
}
.nav-customs.nav .nav-link.active, .nav-customs.nav .nav-link.active:before, .nav-customs.nav .nav-link.active:after {
  background-color: #b4d0f0;
  color: #fff;
}
.nav-customs.nav .nav-link.active {
  z-index: 1;
}

.table > thead {
  border-color: var(--vz-border-color);
}
.table > :not(:first-child) {
  border-top-width: var(--vz-border-width);
}

.table-nowrap th,
.table-nowrap td {
  white-space: normal;
}

.table-card {
  margin: -1rem -1rem;
}
.table-card th:first-child,
.table-card td:first-child {
  padding-left: 16px;
}
.table-card th:last-child,
.table-card td:last-child {
  padding-right: 16px;
}
.table-card .table > :not(:first-child) {
  border-top-width: var(--vz-border-width);
}

.border-primary.table > thead {
  border-color: #b4d0f0 !important;
}

.table-primary.table > thead {
  border-bottom-color: #dfebf9 !important;
}

.border-secondary.table > thead {
  border-color: #daecfb !important;
}

.table-secondary.table > thead {
  border-bottom-color: white !important;
}

.border-success.table > thead {
  border-color: #13c56b !important;
}

.table-success.table > thead {
  border-bottom-color: #21ea84 !important;
}

.border-info.table > thead {
  border-color: #50c3e6 !important;
}

.table-info.table > thead {
  border-bottom-color: #7dd2ec !important;
}

.border-warning.table > thead {
  border-color: #e8bc52 !important;
}

.table-warning.table > thead {
  border-bottom-color: #eecd7f !important;
}

.border-danger.table > thead {
  border-color: #ed5e5e !important;
}

.table-danger.table > thead {
  border-bottom-color: #f28c8c !important;
}

.border-light.table > thead {
  border-color: #f3f6f9 !important;
}

.table-light.table > thead {
  border-bottom-color: white !important;
}

.border-dark.table > thead {
  border-color: #363d48 !important;
}

.table-dark.table > thead {
  border-bottom-color: #4c5665 !important;
}

.border-custom-primary.table > thead {
  border-color: #7eabe7 !important;
}

.table-custom-primary.table > thead {
  border-bottom-color: #a9c7ef !important;
}

.border-custom-primary-hover.table > thead {
  border-color: #bcd4f8 !important;
}

.table-custom-primary-hover.table > thead {
  border-bottom-color: #eaf2fd !important;
}

.border-new-primary.table > thead {
  border-color: #0A56AE !important;
}

.table-new-primary.table > thead {
  border-bottom-color: #0d6ede !important;
}

.border-header.table > thead {
  border-color: #bdd6fb !important;
}

.table-header.table > thead {
  border-bottom-color: #edf4fe !important;
}

.border-next-button.table > thead {
  border-color: #83a9e2 !important;
}

.table-next-button.table > thead {
  border-bottom-color: #acc6ec !important;
}

.border-next-button-border.table > thead {
  border-color: #5d87c7 !important;
}

.table-next-button-border.table > thead {
  border-bottom-color: #83a3d4 !important;
}

.border-next-button-hover.table > thead {
  border-color: #bdd6fa !important;
}

.table-next-button-hover.table > thead {
  border-bottom-color: #ecf3fe !important;
}

.border-white.table > thead {
  border-color: #fff !important;
}

.table-white.table > thead {
  border-bottom-color: white !important;
}

.border-light-grey.table > thead {
  border-color: #ced4da !important;
}

.table-light-grey.table > thead {
  border-bottom-color: #ebeef0 !important;
}

.table > :not(caption) > * > * {
  color: var(--vz-table-color-state), var(--vz-table-color-type, var(--vz-table-color));
}

.table .form-check {
  padding-left: 0px;
  margin-bottom: 0px;
}
.table .form-check .form-check-input {
  margin-left: 0px;
  margin-top: 0px;
  float: none;
  vertical-align: middle;
}
.table .sort {
  position: relative;
}
.table .sort::before {
  content: "󰍝";
  position: absolute;
  right: 0.5rem;
  top: 18px;
  font-size: 0.8rem;
  font-family: "Material Design Icons";
}
.table .sort::after {
  position: absolute;
  right: 0.5rem;
  content: "󰍠";
  font-family: "Material Design Icons";
  font-size: 0.8rem;
  top: 12px;
}

.modal-title {
  font-weight: 500;
}

.modal-dialog:not(.modal-dialog-scrollable) .modal-header {
  padding-bottom: 0;
}
.modal-dialog:not(.modal-dialog-scrollable) .modal-header .btn-close {
  margin-top: -1.25rem 1.25rem;
}
.modal-dialog:not(.modal-dialog-scrollable) .modal-footer {
  padding-top: 0;
}

.modal.fadeInRight .modal-dialog {
  opacity: 0;
  transform: translateX(20%);
  transition: all 0.3s ease-in-out;
}
.modal.fadeInRight.show .modal-dialog {
  opacity: 1;
  transform: translateX(0);
}
.modal.fadeInLeft .modal-dialog {
  animation: fadeInLeft 0.3s ease-in-out;
  transform: translate(-50%, 0);
}
.modal.fadeInLeft.show .modal-dialog {
  transform: none;
}
.modal.fadeInUp .modal-dialog {
  animation: fadeInUp 0.3s ease-in-out;
  transform: translate(0, 30%);
}
.modal.fadeInUp.show .modal-dialog {
  transform: none;
}
.modal.flip {
  perspective: 1300px;
}
.modal.flip .modal-dialog {
  opacity: 0;
  transform: rotateY(-70deg);
  transition: all 0.3s;
}
.modal.flip.show .modal-dialog {
  opacity: 1;
  transform: rotateY(0deg);
}
.modal.zoomIn .modal-dialog {
  opacity: 0;
  transform: scale(0.7);
  transition: all 0.3s ease;
}
.modal.zoomIn.show .modal-dialog {
  opacity: 1;
  transform: scale(1);
}

.modal-dialog-right {
  margin-right: 1.75rem;
}

.modal-dialog-bottom {
  display: flex;
  align-items: flex-end;
  min-height: calc(100% - 1.75rem);
}
@media (min-width: 576px) {
  .modal-dialog-bottom {
    min-height: calc(100% - 3.5rem);
  }
}

.modal-dialog-bottom-right {
  display: flex;
  align-items: flex-end;
  min-height: calc(100% - 1.75rem);
  margin-right: 1.75rem;
}
@media (min-width: 576px) {
  .modal-dialog-bottom-right {
    min-height: calc(100% - 3.5rem);
  }
}

@keyframes fadeInLeft {
  0% {
    opacity: 0;
    transform: translate3d(-30%, 0, 0);
  }
  to {
    opacity: 1;
    transform: translateZ(0);
  }
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translate3d(0, 30%, 0);
  }
  to {
    opacity: 1;
    transform: translateZ(0);
  }
}
@keyframes zoomIn {
  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
.login-modal {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
  background-size: cover;
  background-position: center;
}

.pagination-separated .page-item .page-link {
  margin-left: 0.35rem;
  border-radius: var(--vz-border-radius);
}

.page-link {
  color: #ffffff;
  background-color: var(--vz-custom-primary);
  border: var(--vz-pagination-border-width) solid var(--vz-custom-primary-hover);
}

.pagination {
  --vz-pagination-color: #ffffff;
  --vz-pagination-bg: var(--vz-custom-primary);
  --vz-pagination-border-width: var(--vz-border-width);
  --vz-pagination-border-color: var(--vz-custom-primary);
  --vz-pagination-border-radius: var(--vz-border-radius);
  --vz-pagination-hover-color: var(--vz-dark);
  --vz-pagination-hover-bg: var(--vz-custom-primary-hover);
  --vz-pagination-hover-border-color: var(--vz-custom-primary-hover);
  --vz-pagination-focus-color: var(--vz-dark);
  --vz-pagination-focus-bg: var(--vz-custom-primary-hover);
  --vz-pagination-focus-box-shadow: 0 0 1 0.25rem rgba(var(--vz-primary-rgb), 0.25);
  --vz-pagination-active-color: #fff;
  --vz-pagination-active-bg: var(--vz-custom-primary-hover);
  --vz-pagination-active-border-color: var(--vz-custom-primary);
  --vz-pagination-disabled-color: \$gray-600;
  --vz-pagination-disabled-bg: var(--vz-tertiary-bg);
  --vz-pagination-disabled-border-color: var(--vz-tertiary-bg);
}

.pagination-rounded .page-link {
  border-radius: 30px !important;
  margin: 0 3px !important;
  border: none;
  min-width: 32px;
  min-height: 32px;
  text-align: center;
}
.pagination-rounded.pagination-sm .page-link {
  min-width: 25px;
  min-height: 25px;
}

.page-item.active .page-link {
  box-shadow: none;
}

.progress-sm {
  height: 5px;
}

.progress-lg {
  height: 12px;
}

.progress-xl {
  height: 16px;
}

.custom-progess {
  position: relative;
}
.custom-progess .progress-icon {
  position: absolute;
  top: -12px;
}
.custom-progess .progress-icon .avatar-title {
  background: var(--vz-secondary-bg);
}

.animated-progress {
  position: relative;
}
.animated-progress .progress-bar {
  position: relative;
  border-radius: 6px;
  animation: animate-positive 2s;
}

@keyframes animate-positive {
  0% {
    width: 0;
  }
}
.custom-progress {
  height: 15px;
  padding: 4px;
  border-radius: 30px;
}
.custom-progress .progress-bar {
  position: relative;
  border-radius: 30px;
}
.custom-progress .progress-bar::before {
  content: "";
  position: absolute;
  width: 4px;
  height: 4px;
  background-color: #fff;
  border-radius: 7px;
  right: 2px;
  top: 50%;
  transform: translateY(-50%);
}

.progress-label {
  overflow: visible;
}
.progress-label .progress-bar {
  position: relative;
  overflow: visible;
}
.progress-label .progress-bar .label {
  position: absolute;
  top: -25px;
  right: -9px;
  background-color: #b4d0f0;
  color: #fff;
  display: inline-block;
  line-height: 18px;
  padding: 0 4px;
  border-radius: 4px;
}
.progress-label .progress-bar .label:after {
  content: "";
  position: absolute;
  border: 4px solid transparent;
  border-top-color: #b4d0f0;
  bottom: -7px;
  left: 50%;
  transform: translateX(-50%);
}

.progress-step-arrow {
  height: 3.25rem;
}
.progress-step-arrow .progress-bar {
  position: relative;
  overflow: initial;
  font-size: 0.875rem;
  color: #fff;
}
.progress-step-arrow .progress-bar::after {
  content: "";
  position: absolute;
  border: 10px solid transparent;
  bottom: 15px;
  right: -20px;
  z-index: 1;
}

.progress-primary .progress-bar {
  background-color: #b4d0f0;
}
.progress-primary .progress-bar::after {
  border-left-color: #b4d0f0;
}
.progress-primary .progress-bar:nth-child(2) {
  background-color: rgba(180, 208, 240, 0.1) !important;
  color: #b4d0f0 !important;
}
.progress-primary .progress-bar:nth-child(2)::after {
  border-left-color: rgba(180, 208, 240, 0.1);
}

.progress-secondary .progress-bar {
  background-color: #daecfb;
}
.progress-secondary .progress-bar::after {
  border-left-color: #daecfb;
}
.progress-secondary .progress-bar:nth-child(2) {
  background-color: rgba(218, 236, 251, 0.1) !important;
  color: #daecfb !important;
}
.progress-secondary .progress-bar:nth-child(2)::after {
  border-left-color: rgba(218, 236, 251, 0.1);
}

.progress-success .progress-bar {
  background-color: #13c56b;
}
.progress-success .progress-bar::after {
  border-left-color: #13c56b;
}
.progress-success .progress-bar:nth-child(2) {
  background-color: rgba(19, 197, 107, 0.1) !important;
  color: #13c56b !important;
}
.progress-success .progress-bar:nth-child(2)::after {
  border-left-color: rgba(19, 197, 107, 0.1);
}

.progress-info .progress-bar {
  background-color: #50c3e6;
}
.progress-info .progress-bar::after {
  border-left-color: #50c3e6;
}
.progress-info .progress-bar:nth-child(2) {
  background-color: rgba(80, 195, 230, 0.1) !important;
  color: #50c3e6 !important;
}
.progress-info .progress-bar:nth-child(2)::after {
  border-left-color: rgba(80, 195, 230, 0.1);
}

.progress-warning .progress-bar {
  background-color: #e8bc52;
}
.progress-warning .progress-bar::after {
  border-left-color: #e8bc52;
}
.progress-warning .progress-bar:nth-child(2) {
  background-color: rgba(232, 188, 82, 0.1) !important;
  color: #e8bc52 !important;
}
.progress-warning .progress-bar:nth-child(2)::after {
  border-left-color: rgba(232, 188, 82, 0.1);
}

.progress-danger .progress-bar {
  background-color: #ed5e5e;
}
.progress-danger .progress-bar::after {
  border-left-color: #ed5e5e;
}
.progress-danger .progress-bar:nth-child(2) {
  background-color: rgba(237, 94, 94, 0.1) !important;
  color: #ed5e5e !important;
}
.progress-danger .progress-bar:nth-child(2)::after {
  border-left-color: rgba(237, 94, 94, 0.1);
}

.progress-light .progress-bar {
  background-color: #f3f6f9;
}
.progress-light .progress-bar::after {
  border-left-color: #f3f6f9;
}
.progress-light .progress-bar:nth-child(2) {
  background-color: rgba(243, 246, 249, 0.1) !important;
  color: #f3f6f9 !important;
}
.progress-light .progress-bar:nth-child(2)::after {
  border-left-color: rgba(243, 246, 249, 0.1);
}

.progress-dark .progress-bar {
  background-color: #363d48;
}
.progress-dark .progress-bar::after {
  border-left-color: #363d48;
}
.progress-dark .progress-bar:nth-child(2) {
  background-color: rgba(54, 61, 72, 0.1) !important;
  color: #363d48 !important;
}
.progress-dark .progress-bar:nth-child(2)::after {
  border-left-color: rgba(54, 61, 72, 0.1);
}

.progress-custom-primary .progress-bar {
  background-color: #7eabe7;
}
.progress-custom-primary .progress-bar::after {
  border-left-color: #7eabe7;
}
.progress-custom-primary .progress-bar:nth-child(2) {
  background-color: rgba(126, 171, 231, 0.1) !important;
  color: #7eabe7 !important;
}
.progress-custom-primary .progress-bar:nth-child(2)::after {
  border-left-color: rgba(126, 171, 231, 0.1);
}

.progress-custom-primary-hover .progress-bar {
  background-color: #bcd4f8;
}
.progress-custom-primary-hover .progress-bar::after {
  border-left-color: #bcd4f8;
}
.progress-custom-primary-hover .progress-bar:nth-child(2) {
  background-color: rgba(188, 212, 248, 0.1) !important;
  color: #bcd4f8 !important;
}
.progress-custom-primary-hover .progress-bar:nth-child(2)::after {
  border-left-color: rgba(188, 212, 248, 0.1);
}

.progress-new-primary .progress-bar {
  background-color: #0A56AE;
}
.progress-new-primary .progress-bar::after {
  border-left-color: #0A56AE;
}
.progress-new-primary .progress-bar:nth-child(2) {
  background-color: rgba(10, 86, 174, 0.1) !important;
  color: #0A56AE !important;
}
.progress-new-primary .progress-bar:nth-child(2)::after {
  border-left-color: rgba(10, 86, 174, 0.1);
}

.progress-header .progress-bar {
  background-color: #bdd6fb;
}
.progress-header .progress-bar::after {
  border-left-color: #bdd6fb;
}
.progress-header .progress-bar:nth-child(2) {
  background-color: rgba(189, 214, 251, 0.1) !important;
  color: #bdd6fb !important;
}
.progress-header .progress-bar:nth-child(2)::after {
  border-left-color: rgba(189, 214, 251, 0.1);
}

.progress-next-button .progress-bar {
  background-color: #83a9e2;
}
.progress-next-button .progress-bar::after {
  border-left-color: #83a9e2;
}
.progress-next-button .progress-bar:nth-child(2) {
  background-color: rgba(131, 169, 226, 0.1) !important;
  color: #83a9e2 !important;
}
.progress-next-button .progress-bar:nth-child(2)::after {
  border-left-color: rgba(131, 169, 226, 0.1);
}

.progress-next-button-border .progress-bar {
  background-color: #5d87c7;
}
.progress-next-button-border .progress-bar::after {
  border-left-color: #5d87c7;
}
.progress-next-button-border .progress-bar:nth-child(2) {
  background-color: rgba(93, 135, 199, 0.1) !important;
  color: #5d87c7 !important;
}
.progress-next-button-border .progress-bar:nth-child(2)::after {
  border-left-color: rgba(93, 135, 199, 0.1);
}

.progress-next-button-hover .progress-bar {
  background-color: #bdd6fa;
}
.progress-next-button-hover .progress-bar::after {
  border-left-color: #bdd6fa;
}
.progress-next-button-hover .progress-bar:nth-child(2) {
  background-color: rgba(189, 214, 250, 0.1) !important;
  color: #bdd6fa !important;
}
.progress-next-button-hover .progress-bar:nth-child(2)::after {
  border-left-color: rgba(189, 214, 250, 0.1);
}

.progress-white .progress-bar {
  background-color: #fff;
}
.progress-white .progress-bar::after {
  border-left-color: #fff;
}
.progress-white .progress-bar:nth-child(2) {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #fff !important;
}
.progress-white .progress-bar:nth-child(2)::after {
  border-left-color: rgba(255, 255, 255, 0.1);
}

.progress-light-grey .progress-bar {
  background-color: #ced4da;
}
.progress-light-grey .progress-bar::after {
  border-left-color: #ced4da;
}
.progress-light-grey .progress-bar:nth-child(2) {
  background-color: rgba(206, 212, 218, 0.1) !important;
  color: #ced4da !important;
}
.progress-light-grey .progress-bar:nth-child(2)::after {
  border-left-color: rgba(206, 212, 218, 0.1);
}

.popover {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
}

.custom-blockquote.blockquote {
  padding: 16px;
  border-left: 3px solid;
}
.custom-blockquote.blockquote.blockquote-outline {
  background-color: var(--vz-secondary-bg) !important;
  border: 1px solid;
  border-left: 3px solid;
}

.custom-blockquote.blockquote.blockquote-primary {
  border-color: var(--vz-primary);
  background-color: var(--vz-primary-bg-subtle);
}
.custom-blockquote.blockquote.blockquote-primary .blockquote-footer {
  color: var(--vz-primary-text-emphasis);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-primary {
  border-color: var(--vz-primary);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-primary .blockquote-footer {
  color: var(--vz-primary-text-emphasis);
}

.custom-blockquote.blockquote.blockquote-secondary {
  border-color: var(--vz-secondary);
  background-color: var(--vz-secondary-bg-subtle);
}
.custom-blockquote.blockquote.blockquote-secondary .blockquote-footer {
  color: var(--vz-secondary-text-emphasis);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-secondary {
  border-color: var(--vz-secondary);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-secondary .blockquote-footer {
  color: var(--vz-secondary-text-emphasis);
}

.custom-blockquote.blockquote.blockquote-success {
  border-color: var(--vz-success);
  background-color: var(--vz-success-bg-subtle);
}
.custom-blockquote.blockquote.blockquote-success .blockquote-footer {
  color: var(--vz-success-text-emphasis);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-success {
  border-color: var(--vz-success);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-success .blockquote-footer {
  color: var(--vz-success-text-emphasis);
}

.custom-blockquote.blockquote.blockquote-info {
  border-color: var(--vz-info);
  background-color: var(--vz-info-bg-subtle);
}
.custom-blockquote.blockquote.blockquote-info .blockquote-footer {
  color: var(--vz-info-text-emphasis);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-info {
  border-color: var(--vz-info);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-info .blockquote-footer {
  color: var(--vz-info-text-emphasis);
}

.custom-blockquote.blockquote.blockquote-warning {
  border-color: var(--vz-warning);
  background-color: var(--vz-warning-bg-subtle);
}
.custom-blockquote.blockquote.blockquote-warning .blockquote-footer {
  color: var(--vz-warning-text-emphasis);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-warning {
  border-color: var(--vz-warning);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-warning .blockquote-footer {
  color: var(--vz-warning-text-emphasis);
}

.custom-blockquote.blockquote.blockquote-danger {
  border-color: var(--vz-danger);
  background-color: var(--vz-danger-bg-subtle);
}
.custom-blockquote.blockquote.blockquote-danger .blockquote-footer {
  color: var(--vz-danger-text-emphasis);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-danger {
  border-color: var(--vz-danger);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-danger .blockquote-footer {
  color: var(--vz-danger-text-emphasis);
}

.custom-blockquote.blockquote.blockquote-light {
  border-color: var(--vz-light);
  background-color: var(--vz-light-bg-subtle);
}
.custom-blockquote.blockquote.blockquote-light .blockquote-footer {
  color: var(--vz-light-text-emphasis);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-light {
  border-color: var(--vz-light);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-light .blockquote-footer {
  color: var(--vz-light-text-emphasis);
}

.custom-blockquote.blockquote.blockquote-dark {
  border-color: var(--vz-dark);
  background-color: var(--vz-dark-bg-subtle);
}
.custom-blockquote.blockquote.blockquote-dark .blockquote-footer {
  color: var(--vz-dark-text-emphasis);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-dark {
  border-color: var(--vz-dark);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-dark .blockquote-footer {
  color: var(--vz-dark-text-emphasis);
}

.custom-blockquote.blockquote.blockquote-custom-primary {
  border-color: var(--vz-custom-primary);
  background-color: var(--vz-custom-primary-bg-subtle);
}
.custom-blockquote.blockquote.blockquote-custom-primary .blockquote-footer {
  color: var(--vz-custom-primary-text-emphasis);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-custom-primary {
  border-color: var(--vz-custom-primary);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-custom-primary .blockquote-footer {
  color: var(--vz-custom-primary-text-emphasis);
}

.custom-blockquote.blockquote.blockquote-custom-primary-hover {
  border-color: var(--vz-custom-primary-hover);
  background-color: var(--vz-custom-primary-hover-bg-subtle);
}
.custom-blockquote.blockquote.blockquote-custom-primary-hover .blockquote-footer {
  color: var(--vz-custom-primary-hover-text-emphasis);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-custom-primary-hover {
  border-color: var(--vz-custom-primary-hover);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-custom-primary-hover .blockquote-footer {
  color: var(--vz-custom-primary-hover-text-emphasis);
}

.custom-blockquote.blockquote.blockquote-new-primary {
  border-color: var(--vz-new-primary);
  background-color: var(--vz-new-primary-bg-subtle);
}
.custom-blockquote.blockquote.blockquote-new-primary .blockquote-footer {
  color: var(--vz-new-primary-text-emphasis);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-new-primary {
  border-color: var(--vz-new-primary);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-new-primary .blockquote-footer {
  color: var(--vz-new-primary-text-emphasis);
}

.custom-blockquote.blockquote.blockquote-header {
  border-color: var(--vz-header);
  background-color: var(--vz-header-bg-subtle);
}
.custom-blockquote.blockquote.blockquote-header .blockquote-footer {
  color: var(--vz-header-text-emphasis);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-header {
  border-color: var(--vz-header);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-header .blockquote-footer {
  color: var(--vz-header-text-emphasis);
}

.custom-blockquote.blockquote.blockquote-next-button {
  border-color: var(--vz-next-button);
  background-color: var(--vz-next-button-bg-subtle);
}
.custom-blockquote.blockquote.blockquote-next-button .blockquote-footer {
  color: var(--vz-next-button-text-emphasis);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-next-button {
  border-color: var(--vz-next-button);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-next-button .blockquote-footer {
  color: var(--vz-next-button-text-emphasis);
}

.custom-blockquote.blockquote.blockquote-next-button-border {
  border-color: var(--vz-next-button-border);
  background-color: var(--vz-next-button-border-bg-subtle);
}
.custom-blockquote.blockquote.blockquote-next-button-border .blockquote-footer {
  color: var(--vz-next-button-border-text-emphasis);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-next-button-border {
  border-color: var(--vz-next-button-border);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-next-button-border .blockquote-footer {
  color: var(--vz-next-button-border-text-emphasis);
}

.custom-blockquote.blockquote.blockquote-next-button-hover {
  border-color: var(--vz-next-button-hover);
  background-color: var(--vz-next-button-hover-bg-subtle);
}
.custom-blockquote.blockquote.blockquote-next-button-hover .blockquote-footer {
  color: var(--vz-next-button-hover-text-emphasis);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-next-button-hover {
  border-color: var(--vz-next-button-hover);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-next-button-hover .blockquote-footer {
  color: var(--vz-next-button-hover-text-emphasis);
}

.custom-blockquote.blockquote.blockquote-white {
  border-color: var(--vz-white);
  background-color: var(--vz-white-bg-subtle);
}
.custom-blockquote.blockquote.blockquote-white .blockquote-footer {
  color: var(--vz-white-text-emphasis);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-white {
  border-color: var(--vz-white);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-white .blockquote-footer {
  color: var(--vz-white-text-emphasis);
}

.custom-blockquote.blockquote.blockquote-light-grey {
  border-color: var(--vz-light-grey);
  background-color: var(--vz-light-grey-bg-subtle);
}
.custom-blockquote.blockquote.blockquote-light-grey .blockquote-footer {
  color: var(--vz-light-grey-text-emphasis);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-light-grey {
  border-color: var(--vz-light-grey);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-light-grey .blockquote-footer {
  color: var(--vz-light-grey-text-emphasis);
}

.form-check {
  position: relative;
  text-align: left;
}
.form-check .form-check-input {
  cursor: pointer;
}
.form-check label {
  cursor: pointer;
}

.form-check-primary .form-check-input:checked {
  background-color: #b4d0f0;
  border-color: #b4d0f0;
}

.form-radio-primary .form-check-input:checked {
  border-color: #b4d0f0;
  background-color: #b4d0f0;
}
.form-radio-primary .form-check-input:checked:after {
  background-color: #b4d0f0;
}

.form-check-secondary .form-check-input:checked {
  background-color: #daecfb;
  border-color: #daecfb;
}

.form-radio-secondary .form-check-input:checked {
  border-color: #daecfb;
  background-color: #daecfb;
}
.form-radio-secondary .form-check-input:checked:after {
  background-color: #daecfb;
}

.form-check-success .form-check-input:checked {
  background-color: #13c56b;
  border-color: #13c56b;
}

.form-radio-success .form-check-input:checked {
  border-color: #13c56b;
  background-color: #13c56b;
}
.form-radio-success .form-check-input:checked:after {
  background-color: #13c56b;
}

.form-check-info .form-check-input:checked {
  background-color: #50c3e6;
  border-color: #50c3e6;
}

.form-radio-info .form-check-input:checked {
  border-color: #50c3e6;
  background-color: #50c3e6;
}
.form-radio-info .form-check-input:checked:after {
  background-color: #50c3e6;
}

.form-check-warning .form-check-input:checked {
  background-color: #e8bc52;
  border-color: #e8bc52;
}

.form-radio-warning .form-check-input:checked {
  border-color: #e8bc52;
  background-color: #e8bc52;
}
.form-radio-warning .form-check-input:checked:after {
  background-color: #e8bc52;
}

.form-check-danger .form-check-input:checked {
  background-color: #ed5e5e;
  border-color: #ed5e5e;
}

.form-radio-danger .form-check-input:checked {
  border-color: #ed5e5e;
  background-color: #ed5e5e;
}
.form-radio-danger .form-check-input:checked:after {
  background-color: #ed5e5e;
}

.form-check-light .form-check-input:checked {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
}

.form-radio-light .form-check-input:checked {
  border-color: #f3f6f9;
  background-color: #f3f6f9;
}
.form-radio-light .form-check-input:checked:after {
  background-color: #f3f6f9;
}

.form-check-dark .form-check-input:checked {
  background-color: #363d48;
  border-color: #363d48;
}

.form-radio-dark .form-check-input:checked {
  border-color: #363d48;
  background-color: #363d48;
}
.form-radio-dark .form-check-input:checked:after {
  background-color: #363d48;
}

.form-check-custom-primary .form-check-input:checked {
  background-color: #7eabe7;
  border-color: #7eabe7;
}

.form-radio-custom-primary .form-check-input:checked {
  border-color: #7eabe7;
  background-color: #7eabe7;
}
.form-radio-custom-primary .form-check-input:checked:after {
  background-color: #7eabe7;
}

.form-check-custom-primary-hover .form-check-input:checked {
  background-color: #bcd4f8;
  border-color: #bcd4f8;
}

.form-radio-custom-primary-hover .form-check-input:checked {
  border-color: #bcd4f8;
  background-color: #bcd4f8;
}
.form-radio-custom-primary-hover .form-check-input:checked:after {
  background-color: #bcd4f8;
}

.form-check-new-primary .form-check-input:checked {
  background-color: #0A56AE;
  border-color: #0A56AE;
}

.form-radio-new-primary .form-check-input:checked {
  border-color: #0A56AE;
  background-color: #0A56AE;
}
.form-radio-new-primary .form-check-input:checked:after {
  background-color: #0A56AE;
}

.form-check-header .form-check-input:checked {
  background-color: #bdd6fb;
  border-color: #bdd6fb;
}

.form-radio-header .form-check-input:checked {
  border-color: #bdd6fb;
  background-color: #bdd6fb;
}
.form-radio-header .form-check-input:checked:after {
  background-color: #bdd6fb;
}

.form-check-next-button .form-check-input:checked {
  background-color: #83a9e2;
  border-color: #83a9e2;
}

.form-radio-next-button .form-check-input:checked {
  border-color: #83a9e2;
  background-color: #83a9e2;
}
.form-radio-next-button .form-check-input:checked:after {
  background-color: #83a9e2;
}

.form-check-next-button-border .form-check-input:checked {
  background-color: #5d87c7;
  border-color: #5d87c7;
}

.form-radio-next-button-border .form-check-input:checked {
  border-color: #5d87c7;
  background-color: #5d87c7;
}
.form-radio-next-button-border .form-check-input:checked:after {
  background-color: #5d87c7;
}

.form-check-next-button-hover .form-check-input:checked {
  background-color: #bdd6fa;
  border-color: #bdd6fa;
}

.form-radio-next-button-hover .form-check-input:checked {
  border-color: #bdd6fa;
  background-color: #bdd6fa;
}
.form-radio-next-button-hover .form-check-input:checked:after {
  background-color: #bdd6fa;
}

.form-check-white .form-check-input:checked {
  background-color: #fff;
  border-color: #fff;
}

.form-radio-white .form-check-input:checked {
  border-color: #fff;
  background-color: #fff;
}
.form-radio-white .form-check-input:checked:after {
  background-color: #fff;
}

.form-check-light-grey .form-check-input:checked {
  background-color: #ced4da;
  border-color: #ced4da;
}

.form-radio-light-grey .form-check-input:checked {
  border-color: #ced4da;
  background-color: #ced4da;
}
.form-radio-light-grey .form-check-input:checked:after {
  background-color: #ced4da;
}

.form-check-label {
  cursor: pointer;
  margin-bottom: 0;
}

.form-check-right {
  padding-left: 0;
  display: inline-block;
}
.form-check-right .form-check-input {
  float: right;
  margin-left: 0;
  margin-right: calc(1.6em * -1);
}
.form-check-right .form-check-label {
  display: block;
}
.form-check-right.form-switch .form-check-input {
  margin-right: calc(1.6em * -1.6);
}

.form-check-outline.form-check-primary .form-check-input:checked[type=checkbox] {
  color: #b4d0f0;
  background-color: transparent;
  border-color: #b4d0f0;
}

.form-check-outline.form-check-secondary .form-check-input:checked[type=checkbox] {
  color: #daecfb;
  background-color: transparent;
  border-color: #daecfb;
}

.form-check-outline.form-check-success .form-check-input:checked[type=checkbox] {
  color: #13c56b;
  background-color: transparent;
  border-color: #13c56b;
}

.form-check-outline.form-check-info .form-check-input:checked[type=checkbox] {
  color: #50c3e6;
  background-color: transparent;
  border-color: #50c3e6;
}

.form-check-outline.form-check-warning .form-check-input:checked[type=checkbox] {
  color: #e8bc52;
  background-color: transparent;
  border-color: #e8bc52;
}

.form-check-outline.form-check-danger .form-check-input:checked[type=checkbox] {
  color: #ed5e5e;
  background-color: transparent;
  border-color: #ed5e5e;
}

.form-check-outline.form-check-light .form-check-input:checked[type=checkbox] {
  color: #f3f6f9;
  background-color: transparent;
  border-color: #f3f6f9;
}

.form-check-outline.form-check-dark .form-check-input:checked[type=checkbox] {
  color: #363d48;
  background-color: transparent;
  border-color: #363d48;
}

.form-check-outline.form-check-custom-primary .form-check-input:checked[type=checkbox] {
  color: #7eabe7;
  background-color: transparent;
  border-color: #7eabe7;
}

.form-check-outline.form-check-custom-primary-hover .form-check-input:checked[type=checkbox] {
  color: #bcd4f8;
  background-color: transparent;
  border-color: #bcd4f8;
}

.form-check-outline.form-check-new-primary .form-check-input:checked[type=checkbox] {
  color: #0A56AE;
  background-color: transparent;
  border-color: #0A56AE;
}

.form-check-outline.form-check-header .form-check-input:checked[type=checkbox] {
  color: #bdd6fb;
  background-color: transparent;
  border-color: #bdd6fb;
}

.form-check-outline.form-check-next-button .form-check-input:checked[type=checkbox] {
  color: #83a9e2;
  background-color: transparent;
  border-color: #83a9e2;
}

.form-check-outline.form-check-next-button-border .form-check-input:checked[type=checkbox] {
  color: #5d87c7;
  background-color: transparent;
  border-color: #5d87c7;
}

.form-check-outline.form-check-next-button-hover .form-check-input:checked[type=checkbox] {
  color: #bdd6fa;
  background-color: transparent;
  border-color: #bdd6fa;
}

.form-check-outline.form-check-white .form-check-input:checked[type=checkbox] {
  color: #fff;
  background-color: transparent;
  border-color: #fff;
}

.form-check-outline.form-check-light-grey .form-check-input:checked[type=checkbox] {
  color: #ced4da;
  background-color: transparent;
  border-color: #ced4da;
}

.form-check-outline .form-check-input {
  position: relative;
}
.form-check-outline .form-check-input:checked[type=checkbox] {
  background-image: none;
}
.form-check-outline .form-check-input:checked[type=checkbox]::before {
  content: "󰄬";
  font-family: "Material Design Icons";
  top: -2px;
  position: absolute;
  font-weight: 700;
  font-size: 11px;
  left: 1px;
}

.form-radio-outline.form-radio-primary .form-check-input:checked[type=radio] {
  color: #b4d0f0;
  background-color: transparent;
  border-color: #b4d0f0;
}

.form-radio-outline.form-radio-secondary .form-check-input:checked[type=radio] {
  color: #daecfb;
  background-color: transparent;
  border-color: #daecfb;
}

.form-radio-outline.form-radio-success .form-check-input:checked[type=radio] {
  color: #13c56b;
  background-color: transparent;
  border-color: #13c56b;
}

.form-radio-outline.form-radio-info .form-check-input:checked[type=radio] {
  color: #50c3e6;
  background-color: transparent;
  border-color: #50c3e6;
}

.form-radio-outline.form-radio-warning .form-check-input:checked[type=radio] {
  color: #e8bc52;
  background-color: transparent;
  border-color: #e8bc52;
}

.form-radio-outline.form-radio-danger .form-check-input:checked[type=radio] {
  color: #ed5e5e;
  background-color: transparent;
  border-color: #ed5e5e;
}

.form-radio-outline.form-radio-light .form-check-input:checked[type=radio] {
  color: #f3f6f9;
  background-color: transparent;
  border-color: #f3f6f9;
}

.form-radio-outline.form-radio-dark .form-check-input:checked[type=radio] {
  color: #363d48;
  background-color: transparent;
  border-color: #363d48;
}

.form-radio-outline.form-radio-custom-primary .form-check-input:checked[type=radio] {
  color: #7eabe7;
  background-color: transparent;
  border-color: #7eabe7;
}

.form-radio-outline.form-radio-custom-primary-hover .form-check-input:checked[type=radio] {
  color: #bcd4f8;
  background-color: transparent;
  border-color: #bcd4f8;
}

.form-radio-outline.form-radio-new-primary .form-check-input:checked[type=radio] {
  color: #0A56AE;
  background-color: transparent;
  border-color: #0A56AE;
}

.form-radio-outline.form-radio-header .form-check-input:checked[type=radio] {
  color: #bdd6fb;
  background-color: transparent;
  border-color: #bdd6fb;
}

.form-radio-outline.form-radio-next-button .form-check-input:checked[type=radio] {
  color: #83a9e2;
  background-color: transparent;
  border-color: #83a9e2;
}

.form-radio-outline.form-radio-next-button-border .form-check-input:checked[type=radio] {
  color: #5d87c7;
  background-color: transparent;
  border-color: #5d87c7;
}

.form-radio-outline.form-radio-next-button-hover .form-check-input:checked[type=radio] {
  color: #bdd6fa;
  background-color: transparent;
  border-color: #bdd6fa;
}

.form-radio-outline.form-radio-white .form-check-input:checked[type=radio] {
  color: #fff;
  background-color: transparent;
  border-color: #fff;
}

.form-radio-outline.form-radio-light-grey .form-check-input:checked[type=radio] {
  color: #ced4da;
  background-color: transparent;
  border-color: #ced4da;
}

.form-radio-outline .form-check-input {
  position: relative;
}
.form-radio-outline .form-check-input:checked[type=radio] {
  background-image: none;
}
.form-radio-outline .form-check-input:checked[type=radio]::before {
  content: "󰝥";
  font-family: "Material Design Icons";
  top: 0px;
  position: absolute;
  font-size: 8px;
  left: 2.2px;
}

.form-switch-md {
  padding-left: 2.5rem;
  min-height: 22px;
  line-height: 22px;
}
.form-switch-md .form-check-input {
  width: 40px;
  height: 20px;
  left: -0.5rem;
  position: relative;
}
.form-switch-md .form-check-label {
  vertical-align: middle;
}

.form-switch-lg {
  padding-left: 2.75rem;
  min-height: 28px;
  line-height: 28px;
}
.form-switch-lg .form-check-input {
  width: 48px;
  height: 24px;
  left: -0.75rem;
  position: relative;
}

.input-group-text {
  margin-bottom: 0px;
}

.form-switch-primary .form-check-input:checked {
  background-color: #b4d0f0;
  border-color: #b4d0f0;
}

.form-switch-custom.form-switch-primary .form-check-input:checked::before {
  color: #b4d0f0;
}

.form-switch-secondary .form-check-input:checked {
  background-color: #daecfb;
  border-color: #daecfb;
}

.form-switch-custom.form-switch-secondary .form-check-input:checked::before {
  color: #daecfb;
}

.form-switch-success .form-check-input:checked {
  background-color: #13c56b;
  border-color: #13c56b;
}

.form-switch-custom.form-switch-success .form-check-input:checked::before {
  color: #13c56b;
}

.form-switch-info .form-check-input:checked {
  background-color: #50c3e6;
  border-color: #50c3e6;
}

.form-switch-custom.form-switch-info .form-check-input:checked::before {
  color: #50c3e6;
}

.form-switch-warning .form-check-input:checked {
  background-color: #e8bc52;
  border-color: #e8bc52;
}

.form-switch-custom.form-switch-warning .form-check-input:checked::before {
  color: #e8bc52;
}

.form-switch-danger .form-check-input:checked {
  background-color: #ed5e5e;
  border-color: #ed5e5e;
}

.form-switch-custom.form-switch-danger .form-check-input:checked::before {
  color: #ed5e5e;
}

.form-switch-light .form-check-input:checked {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
}

.form-switch-custom.form-switch-light .form-check-input:checked::before {
  color: #f3f6f9;
}

.form-switch-dark .form-check-input:checked {
  background-color: #363d48;
  border-color: #363d48;
}

.form-switch-custom.form-switch-dark .form-check-input:checked::before {
  color: #363d48;
}

.form-switch-custom-primary .form-check-input:checked {
  background-color: #7eabe7;
  border-color: #7eabe7;
}

.form-switch-custom.form-switch-custom-primary .form-check-input:checked::before {
  color: #7eabe7;
}

.form-switch-custom-primary-hover .form-check-input:checked {
  background-color: #bcd4f8;
  border-color: #bcd4f8;
}

.form-switch-custom.form-switch-custom-primary-hover .form-check-input:checked::before {
  color: #bcd4f8;
}

.form-switch-new-primary .form-check-input:checked {
  background-color: #0A56AE;
  border-color: #0A56AE;
}

.form-switch-custom.form-switch-new-primary .form-check-input:checked::before {
  color: #0A56AE;
}

.form-switch-header .form-check-input:checked {
  background-color: #bdd6fb;
  border-color: #bdd6fb;
}

.form-switch-custom.form-switch-header .form-check-input:checked::before {
  color: #bdd6fb;
}

.form-switch-next-button .form-check-input:checked {
  background-color: #83a9e2;
  border-color: #83a9e2;
}

.form-switch-custom.form-switch-next-button .form-check-input:checked::before {
  color: #83a9e2;
}

.form-switch-next-button-border .form-check-input:checked {
  background-color: #5d87c7;
  border-color: #5d87c7;
}

.form-switch-custom.form-switch-next-button-border .form-check-input:checked::before {
  color: #5d87c7;
}

.form-switch-next-button-hover .form-check-input:checked {
  background-color: #bdd6fa;
  border-color: #bdd6fa;
}

.form-switch-custom.form-switch-next-button-hover .form-check-input:checked::before {
  color: #bdd6fa;
}

.form-switch-white .form-check-input:checked {
  background-color: #fff;
  border-color: #fff;
}

.form-switch-custom.form-switch-white .form-check-input:checked::before {
  color: #fff;
}

.form-switch-light-grey .form-check-input:checked {
  background-color: #ced4da;
  border-color: #ced4da;
}

.form-switch-custom.form-switch-light-grey .form-check-input:checked::before {
  color: #ced4da;
}

.form-switch-custom .form-check-input {
  position: relative;
  background-image: none;
}
.form-switch-custom .form-check-input::before {
  content: "󰝥";
  font-family: "Material Design Icons";
  top: -9px;
  position: absolute;
  font-size: 20px;
  left: -3px;
  color: var(--vz-secondary-color);
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch-custom .form-check-input::before {
    transition: none;
  }
}
.form-switch-custom .form-check-input:checked {
  background-image: none;
  background-color: var(--vz-input-bg-custom);
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch-custom .form-check-input:checked {
    transition: none;
  }
}
.form-switch-custom .form-check-input:checked::before {
  right: -3px;
  left: auto;
}
.form-switch-custom .form-check-input:focus {
  background-image: none;
}

.form-switch-right {
  display: inline-block;
  padding-right: calc(1.6em * .5);
  margin-bottom: 0;
  padding-left: 0 !important;
}
.form-switch-right .form-check-input {
  float: right;
  margin-left: 0;
  margin-right: calc(1.6em * -1);
  margin-top: 0.1em !important;
}
.form-switch-right label {
  margin-bottom: 0;
  margin-right: 1rem;
}

.card-radio {
  padding: 0;
}
.card-radio .form-check-label {
  background-color: var(--vz-secondary-bg);
  border: 1px solid var(--vz-border-color);
  border-radius: 0.25rem;
  padding: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  position: relative;
  padding-right: 32px;
}
.card-radio .form-check-label:hover {
  cursor: pointer;
}
.card-radio .form-check-input {
  display: none;
}
.card-radio .form-check-input:checked + .form-check-label {
  border-color: #b4d0f0 !important;
}
.card-radio .form-check-input:checked + .form-check-label:before {
  content: "";
  font-family: "remixicon";
  position: absolute;
  top: 2px;
  right: 6px;
  font-size: 16px;
  color: #b4d0f0;
}
.card-radio.dark .form-check-input:checked + .form-check-label:before {
  color: #fff;
}

.form-icon {
  position: relative;
}
.form-icon .form-control-icon {
  padding-left: calc(0.9rem * 3);
  position: relative;
}
.form-icon i {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 18px;
  display: flex;
  align-items: center;
}
.form-icon.right .form-control-icon {
  padding-right: calc(0.9rem * 3);
  padding-left: 0.9rem;
  position: relative;
}
.form-icon.right i {
  left: auto;
  right: 18px;
}

.list-group-fill-primary.list-group-item {
  color: #000;
  background-color: var(--vz-primary) !important;
  border-color: var(--vz-primary);
}

.list-group-fill-secondary.list-group-item {
  color: #000;
  background-color: var(--vz-secondary) !important;
  border-color: var(--vz-secondary);
}

.list-group-fill-success.list-group-item {
  color: #fff;
  background-color: var(--vz-success) !important;
  border-color: var(--vz-success);
}

.list-group-fill-info.list-group-item {
  color: #fff;
  background-color: var(--vz-info) !important;
  border-color: var(--vz-info);
}

.list-group-fill-warning.list-group-item {
  color: #fff;
  background-color: var(--vz-warning) !important;
  border-color: var(--vz-warning);
}

.list-group-fill-danger.list-group-item {
  color: #fff;
  background-color: var(--vz-danger) !important;
  border-color: var(--vz-danger);
}

.list-group-fill-light.list-group-item {
  color: #000;
  background-color: var(--vz-light) !important;
  border-color: var(--vz-light);
}

.list-group-fill-dark.list-group-item {
  color: #fff;
  background-color: var(--vz-dark) !important;
  border-color: var(--vz-dark);
}

.list-group-fill-custom-primary.list-group-item {
  color: #fff;
  background-color: var(--vz-custom-primary) !important;
  border-color: var(--vz-custom-primary);
}

.list-group-fill-custom-primary-hover.list-group-item {
  color: #000;
  background-color: var(--vz-custom-primary-hover) !important;
  border-color: var(--vz-custom-primary-hover);
}

.list-group-fill-new-primary.list-group-item {
  color: #fff;
  background-color: var(--vz-new-primary) !important;
  border-color: var(--vz-new-primary);
}

.list-group-fill-header.list-group-item {
  color: #000;
  background-color: var(--vz-header) !important;
  border-color: var(--vz-header);
}

.list-group-fill-next-button.list-group-item {
  color: #fff;
  background-color: var(--vz-next-button) !important;
  border-color: var(--vz-next-button);
}

.list-group-fill-next-button-border.list-group-item {
  color: #fff;
  background-color: var(--vz-next-button-border) !important;
  border-color: var(--vz-next-button-border);
}

.list-group-fill-next-button-hover.list-group-item {
  color: #000;
  background-color: var(--vz-next-button-hover) !important;
  border-color: var(--vz-next-button-hover);
}

.list-group-fill-white.list-group-item {
  color: #000;
  background-color: var(--vz-white) !important;
  border-color: var(--vz-white);
}

.list-group-fill-light-grey.list-group-item {
  color: #000;
  background-color: var(--vz-light-grey) !important;
  border-color: var(--vz-light-grey);
}

.list-group-item {
  margin-bottom: 0px;
}
.list-group-item .list-text {
  color: var(--vz-secondary-color);
}
.list-group-item.active {
  box-shadow: none;
}
.list-group-item.active .list-title {
  color: #fff;
}
.list-group-item.active .list-text {
  color: rgba(255, 255, 255, 0.5);
}

[data-simplebar] {
  position: relative;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
}

.simplebar-wrapper {
  overflow: hidden;
  width: inherit;
  height: inherit;
  max-width: inherit;
  max-height: inherit;
}

.simplebar-mask {
  direction: inherit;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: auto !important;
  height: auto !important;
  z-index: 0;
}

.simplebar-offset {
  direction: inherit !important;
  box-sizing: inherit !important;
  resize: none !important;
  position: absolute;
  top: 0;
  left: 0 !important;
  bottom: 0;
  right: 0 !important;
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch;
}

.simplebar-content-wrapper {
  direction: inherit;
  box-sizing: border-box !important;
  position: relative;
  display: block;
  height: 100%;
  /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */
  width: auto;
  visibility: visible;
  overflow: auto;
  /* Scroll on this element otherwise element can't have a padding applied properly */
  max-width: 100%;
  /* Not required for horizontal scroll to trigger */
  max-height: 100%;
  /* Needed for vertical scroll to trigger */
  scrollbar-width: none;
  padding: 0px !important;
}

.simplebar-content-wrapper::-webkit-scrollbar,
.simplebar-hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.simplebar-content:before,
.simplebar-content:after {
  content: " ";
  display: table;
}

.simplebar-placeholder {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  pointer-events: none;
}

.simplebar-height-auto-observer-wrapper {
  box-sizing: inherit !important;
  height: 100%;
  width: 100%;
  max-width: 1px;
  position: relative;
  float: left;
  max-height: 1px;
  overflow: hidden;
  z-index: -1;
  padding: 0;
  margin: 0;
  pointer-events: none;
  flex-grow: inherit;
  flex-shrink: 0;
  flex-basis: 0;
}

.simplebar-height-auto-observer {
  box-sizing: inherit;
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 1000%;
  width: 1000%;
  min-height: 1px;
  min-width: 1px;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}

.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

[data-simplebar].simplebar-dragging .simplebar-content {
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
}

[data-simplebar].simplebar-dragging .simplebar-track {
  pointer-events: all;
}

.simplebar-scrollbar {
  position: absolute;
  right: 2px;
  width: 6px;
  min-height: 10px;
}

.simplebar-scrollbar:before {
  position: absolute;
  content: "";
  background: #a2adb7;
  border-radius: 7px;
  left: 0;
  right: 0;
  opacity: 0;
  transition: opacity 0.2s linear;
}

.simplebar-scrollbar.simplebar-visible:before {
  /* When hovered, remove all transitions from drag handle */
  opacity: 0.5;
  transition: opacity 0s linear;
}

.simplebar-track.simplebar-vertical {
  top: 0;
  width: 11px;
}

.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
  top: 2px;
  bottom: 2px;
}

.simplebar-track.simplebar-horizontal {
  left: 0;
  height: 11px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {
  height: 100%;
  left: 2px;
  right: 2px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar {
  right: auto;
  left: 0;
  top: 2px;
  height: 7px;
  min-height: 0;
  min-width: 10px;
  width: auto;
}

/* Rtl support */
[data-simplebar-direction=rtl] .simplebar-track.simplebar-vertical {
  right: auto;
  left: 0;
}

.hs-dummy-scrollbar-size {
  direction: rtl;
  position: fixed;
  opacity: 0;
  visibility: hidden;
  height: 500px;
  width: 500px;
  overflow-y: hidden;
  overflow-x: scroll;
}

.simplebar-hide-scrollbar {
  position: fixed;
  left: 0;
  visibility: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
}

.custom-scroll {
  height: 100%;
}

[data-simplebar-track=primary] .simplebar-scrollbar:before {
  background: #b4d0f0;
}

[data-simplebar-track=secondary] .simplebar-scrollbar:before {
  background: #daecfb;
}

[data-simplebar-track=success] .simplebar-scrollbar:before {
  background: #13c56b;
}

[data-simplebar-track=info] .simplebar-scrollbar:before {
  background: #50c3e6;
}

[data-simplebar-track=warning] .simplebar-scrollbar:before {
  background: #e8bc52;
}

[data-simplebar-track=danger] .simplebar-scrollbar:before {
  background: #ed5e5e;
}

[data-simplebar-track=light] .simplebar-scrollbar:before {
  background: #f3f6f9;
}

[data-simplebar-track=dark] .simplebar-scrollbar:before {
  background: #363d48;
}

[data-simplebar-track=custom-primary] .simplebar-scrollbar:before {
  background: #7eabe7;
}

[data-simplebar-track=custom-primary-hover] .simplebar-scrollbar:before {
  background: #bcd4f8;
}

[data-simplebar-track=new-primary] .simplebar-scrollbar:before {
  background: #0A56AE;
}

[data-simplebar-track=header] .simplebar-scrollbar:before {
  background: #bdd6fb;
}

[data-simplebar-track=next-button] .simplebar-scrollbar:before {
  background: #83a9e2;
}

[data-simplebar-track=next-button-border] .simplebar-scrollbar:before {
  background: #5d87c7;
}

[data-simplebar-track=next-button-hover] .simplebar-scrollbar:before {
  background: #bdd6fa;
}

[data-simplebar-track=white] .simplebar-scrollbar:before {
  background: #fff;
}

[data-simplebar-track=light-grey] .simplebar-scrollbar:before {
  background: #ced4da;
}

/**
 * prism.js default theme for JavaScript, CSS and HTML
 * Based on dabblet (http://dabblet.com)
 * @author Lea Verou
 */
code[class*=language-],
pre[class*=language-] {
  color: black;
  background: none;
  text-shadow: 0 1px white;
  font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
  font-size: 1em;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  line-height: 1.5;
  tab-size: 4;
  hyphens: none;
}

pre[class*=language-]::selection,
pre[class*=language-] ::selection,
code[class*=language-]::selection,
code[class*=language-] ::selection {
  text-shadow: none;
  background: #b3d4fc;
}

@media print {
  code[class*=language-],
pre[class*=language-] {
    text-shadow: none;
  }
}
/* Code blocks */
pre[class*=language-] {
  padding: 1em;
  margin: 0;
  overflow: auto;
}

:not(pre) > code[class*=language-],
pre[class*=language-] {
  background: var(--vz-light) !important;
}

/* Inline code */
:not(pre) > code[class*=language-] {
  padding: 0.1em;
  border-radius: 0.3em;
  white-space: normal;
}

.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
  color: slategray;
}

.token.punctuation {
  color: #999;
}

.token.namespace {
  opacity: 0.7;
}

.token.property,
.token.tag,
.token.boolean,
.token.number,
.token.constant,
.token.symbol,
.token.deleted {
  color: #ed5e5e;
}

.token.selector,
.token.attr-name,
.token.string,
.token.char,
.token.builtin,
.token.inserted {
  color: #690;
}

.token.operator,
.token.entity,
.token.url,
.language-css .token.string,
.style .token.string {
  color: #9a6e3a;
  /* This background color was intended by the author of this theme. */
  background: rgba(255, 255, 255, 0.5);
}

.token.atrule,
.token.attr-value,
.token.keyword {
  color: #07a;
}

.token.function,
.token.class-name {
  color: #dd4a68;
}

.token.regex,
.token.important,
.token.variable {
  color: #e90;
}

.token.important,
.token.bold {
  font-weight: bold;
}

.token.italic {
  font-style: italic;
}

.token.entity {
  cursor: help;
}

/* Prism editor */
:not(pre) > code[class*=language-],
pre[class*=language-] {
  background: #eff2f7;
}

code[class*=language-],
pre[class*=language-] {
  color: #878a99;
  text-shadow: none;
}

.language-markup::-webkit-scrollbar {
  -webkit-appearance: none;
}
.language-markup::-webkit-scrollbar:vertical {
  width: 10px;
}
.language-markup::-webkit-scrollbar:horizontal {
  height: 10px;
}
.language-markup::-webkit-scrollbar-thumb {
  background-color: rgba(var(--vz-body-color-rgb), 0.1);
  border-radius: 10px;
  border: 2px solid var(--vz-light);
}
.language-markup::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: var(--vz-light);
}

#scroll-top {
  width: 30px;
  height: 30px;
  position: fixed;
  bottom: 65px;
  right: 30px;
  background: #343a40;
  border-color: transparent;
  border-radius: 3px;
  color: #ffffff;
  transition: all 0.5s ease;
}

.btn-clipboard {
  position: absolute !important;
  right: 15px !important;
  z-index: 1 !important;
}

div.code-toolbar > .toolbar {
  opacity: 1 !important;
}
div.code-toolbar > .toolbar button {
  display: inline-block !important;
  margin: 0.375rem 0.5rem !important;
  padding: 0.25rem 0.75rem !important;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
  border-radius: 0.2rem !important;
  border: 1px solid rgba(180, 208, 240, 0.35) !important;
  background-color: transparent;
  color: #b4d0f0 !important;
  box-shadow: none !important;
}
div.code-toolbar > .toolbar button:focus {
  outline: none !important;
  box-shadow: none !important;
}
div.code-toolbar > .toolbar button:hover {
  background-color: #b4d0f0 !important;
  color: #fff !important;
}

.swal2-container .swal2-title {
  padding: 24px 24px 0;
  font-size: 20px;
  font-weight: 400;
}

.swal2-popup {
  padding-bottom: 24px;
  border-radius: var(--vz-border-radius-lg);
  background-color: var(--vz-secondary-bg);
  color: var(--vz-body-color);
}
.swal2-popup .swal2-title {
  color: var(--vz-heading-color);
}
.swal2-popup .swal2-html-container {
  color: var(--vz-body-color);
}

.swal2-footer {
  border-top: 1px solid var(--vz-border-color);
  color: var(--vz-body-color);
}

.swal2-html-container {
  font-size: 16px;
}

.swal2-icon.swal2-question {
  border-color: #50c3e6;
  color: #50c3e6;
}
.swal2-icon.swal2-success [class^=swal2-success-line] {
  background-color: #13c56b;
}
.swal2-icon.swal2-success .swal2-success-ring {
  border-color: rgba(19, 197, 107, 0.3);
}
.swal2-icon.swal2-warning {
  border-color: #e8bc52;
  color: #e8bc52;
}

.swal2-styled:focus {
  box-shadow: none;
}

.swal2-loader {
  border-color: #b4d0f0 transparent #b4d0f0 transparent;
}

.swal2-timer-progress-bar {
  background-color: rgba(19, 197, 107, 0.4);
}

.swal2-progress-steps .swal2-progress-step {
  background: #b4d0f0;
}
.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {
  background: #b4d0f0;
}
.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step, .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step-line {
  background: rgba(180, 208, 240, 0.3);
}
.swal2-progress-steps .swal2-progress-step-line {
  background: #b4d0f0;
}

.swal2-actions.swal2-loading .swal2-styled.swal2-confirm {
  border-left-color: #b4d0f0 !important;
  border-right-color: #b4d0f0 !important;
}

.swal2-file, .swal2-input, .swal2-textarea {
  border: 1px solid var(--vz-input-border-custom);
}
.swal2-file:focus, .swal2-input:focus, .swal2-textarea:focus {
  box-shadow: none;
  border-color: var(--vz-primary-border-subtle);
}

.swal2-input {
  height: auto;
  display: block;
  padding: 0.5rem 0.9rem;
  font-size: 0.825rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  background-color: var(--vz-input-bg-custom);
  background-clip: padding-box;
  border: var(--vz-border-width) solid var(--vz-input-border-custom);
}

.swal2-close {
  font-family: var(--vz-font-sans-serif);
  font-weight: 300;
  font-size: 28px;
}
.swal2-close:focus {
  box-shadow: none;
}
.swal2-close:hover {
  color: #b4d0f0;
}

.swal2-validation-message {
  background-color: transparent;
}

.dropzone {
  min-height: 230px;
  border: 2px dashed var(--vz-border-color);
  background: var(--vz-secondary-bg);
  border-radius: 6px;
}
.dropzone .dz-message {
  font-size: 24px;
  width: 100%;
  margin: 1em 0;
}

.noUi-connect {
  background: #13c56b;
}

.noUi-handle {
  background: #13c56b;
  border: 2px solid var(--vz-card-bg);
  box-shadow: none;
}

.noUi-horizontal {
  height: 4px;
}
.noUi-horizontal .noUi-handle {
  height: 16px;
  width: 16px;
  border-radius: 50%;
  right: -10px !important;
  top: -7px;
}
.noUi-horizontal .noUi-handle::before, .noUi-horizontal .noUi-handle::after {
  display: none;
}
.noUi-horizontal .noUi-handle:focus {
  outline: 0;
}

.noUi-pips-horizontal {
  height: 50px;
}

.noUi-tooltip {
  padding: 0.4rem 0.7rem;
  border-color: var(--vz-border-color);
  border-radius: var(--vz-border-radius);
  background-color: var(--vz-secondary-bg);
  color: var(--vz-body-color);
}

.noUi-vertical {
  width: 4px;
}
.noUi-vertical .noUi-handle {
  height: 16px;
  width: 16px;
  right: -8px;
  top: -12px;
  left: auto;
  border-radius: 50%;
}
.noUi-vertical .noUi-handle::before, .noUi-vertical .noUi-handle::after {
  display: none;
}
.noUi-vertical .noUi-handle:focus {
  outline: 0;
}
.noUi-vertical .noUi-origin {
  top: 0;
}

.noUi-value {
  font-size: 12px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 12px;
}

.noUi-value-horizontal {
  padding-top: 4px;
}

.noUi-target {
  box-shadow: none;
  background-color: var(--vz-light);
  border-color: var(--vz-light);
}

.noUi-touch-area:focus {
  outline: 0;
}

#red, #green, #blue {
  margin: 10px;
  display: inline-block;
  height: 200px;
}

#colorpicker {
  height: 240px;
  width: 310px;
  margin: 0 auto;
  padding: 10px;
  border: 1px solid var(--vz-border-color);
}

#result {
  margin: 60px 26px;
  height: 100px;
  width: 100px;
  display: inline-block;
  vertical-align: top;
  border: 1px solid var(--vz-border-color);
  box-shadow: 0 0 3px;
  border-radius: 7px;
}

#red .noUi-connect {
  background: #ed5e5e;
}

#green .noUi-connect {
  background: #13c56b;
}

#blue .noUi-connect {
  background: #b4d0f0;
}

.form-control.keyboard {
  max-width: 340px !important;
}

.example-val {
  font-size: 12px;
  color: var(--vz-secondary-color);
  display: block;
  margin: 15px 0;
}
.example-val:before {
  content: "Value: ";
  font-size: 12px;
  font-weight: 600;
}

.noUi-tooltip {
  display: none;
}

.noUi-active .noUi-tooltip {
  display: block;
}

.c-1-color {
  background: #ed5e5e;
}

.c-2-color {
  background: #e8bc52;
}

.c-3-color {
  background: #13c56b;
}

.c-4-color {
  background: #b4d0f0;
}

.c-5-color {
  background: #865ce2;
}

#slider-toggle {
  height: 50px;
}
#slider-toggle.off .noUi-handle {
  border-color: #ed5e5e;
}

.noUi-marker {
  background-color: var(--vz-border-color);
}

.noUi-pips {
  color: var(--vz-body-color);
}

[data-slider-color=primary] .noUi-connect {
  background: #b4d0f0;
}
[data-slider-color=primary] .noUi-handle {
  background: #b4d0f0;
}
[data-slider-color=primary][data-slider-style=border] .noUi-handle, [data-slider-color=primary][data-slider-style=square] .noUi-handle {
  border-color: #b4d0f0;
}

[data-slider-color=secondary] .noUi-connect {
  background: #daecfb;
}
[data-slider-color=secondary] .noUi-handle {
  background: #daecfb;
}
[data-slider-color=secondary][data-slider-style=border] .noUi-handle, [data-slider-color=secondary][data-slider-style=square] .noUi-handle {
  border-color: #daecfb;
}

[data-slider-color=success] .noUi-connect {
  background: #13c56b;
}
[data-slider-color=success] .noUi-handle {
  background: #13c56b;
}
[data-slider-color=success][data-slider-style=border] .noUi-handle, [data-slider-color=success][data-slider-style=square] .noUi-handle {
  border-color: #13c56b;
}

[data-slider-color=info] .noUi-connect {
  background: #50c3e6;
}
[data-slider-color=info] .noUi-handle {
  background: #50c3e6;
}
[data-slider-color=info][data-slider-style=border] .noUi-handle, [data-slider-color=info][data-slider-style=square] .noUi-handle {
  border-color: #50c3e6;
}

[data-slider-color=warning] .noUi-connect {
  background: #e8bc52;
}
[data-slider-color=warning] .noUi-handle {
  background: #e8bc52;
}
[data-slider-color=warning][data-slider-style=border] .noUi-handle, [data-slider-color=warning][data-slider-style=square] .noUi-handle {
  border-color: #e8bc52;
}

[data-slider-color=danger] .noUi-connect {
  background: #ed5e5e;
}
[data-slider-color=danger] .noUi-handle {
  background: #ed5e5e;
}
[data-slider-color=danger][data-slider-style=border] .noUi-handle, [data-slider-color=danger][data-slider-style=square] .noUi-handle {
  border-color: #ed5e5e;
}

[data-slider-color=light] .noUi-connect {
  background: #f3f6f9;
}
[data-slider-color=light] .noUi-handle {
  background: #f3f6f9;
}
[data-slider-color=light][data-slider-style=border] .noUi-handle, [data-slider-color=light][data-slider-style=square] .noUi-handle {
  border-color: #f3f6f9;
}

[data-slider-color=dark] .noUi-connect {
  background: #363d48;
}
[data-slider-color=dark] .noUi-handle {
  background: #363d48;
}
[data-slider-color=dark][data-slider-style=border] .noUi-handle, [data-slider-color=dark][data-slider-style=square] .noUi-handle {
  border-color: #363d48;
}

[data-slider-color=custom-primary] .noUi-connect {
  background: #7eabe7;
}
[data-slider-color=custom-primary] .noUi-handle {
  background: #7eabe7;
}
[data-slider-color=custom-primary][data-slider-style=border] .noUi-handle, [data-slider-color=custom-primary][data-slider-style=square] .noUi-handle {
  border-color: #7eabe7;
}

[data-slider-color=custom-primary-hover] .noUi-connect {
  background: #bcd4f8;
}
[data-slider-color=custom-primary-hover] .noUi-handle {
  background: #bcd4f8;
}
[data-slider-color=custom-primary-hover][data-slider-style=border] .noUi-handle, [data-slider-color=custom-primary-hover][data-slider-style=square] .noUi-handle {
  border-color: #bcd4f8;
}

[data-slider-color=new-primary] .noUi-connect {
  background: #0A56AE;
}
[data-slider-color=new-primary] .noUi-handle {
  background: #0A56AE;
}
[data-slider-color=new-primary][data-slider-style=border] .noUi-handle, [data-slider-color=new-primary][data-slider-style=square] .noUi-handle {
  border-color: #0A56AE;
}

[data-slider-color=header] .noUi-connect {
  background: #bdd6fb;
}
[data-slider-color=header] .noUi-handle {
  background: #bdd6fb;
}
[data-slider-color=header][data-slider-style=border] .noUi-handle, [data-slider-color=header][data-slider-style=square] .noUi-handle {
  border-color: #bdd6fb;
}

[data-slider-color=next-button] .noUi-connect {
  background: #83a9e2;
}
[data-slider-color=next-button] .noUi-handle {
  background: #83a9e2;
}
[data-slider-color=next-button][data-slider-style=border] .noUi-handle, [data-slider-color=next-button][data-slider-style=square] .noUi-handle {
  border-color: #83a9e2;
}

[data-slider-color=next-button-border] .noUi-connect {
  background: #5d87c7;
}
[data-slider-color=next-button-border] .noUi-handle {
  background: #5d87c7;
}
[data-slider-color=next-button-border][data-slider-style=border] .noUi-handle, [data-slider-color=next-button-border][data-slider-style=square] .noUi-handle {
  border-color: #5d87c7;
}

[data-slider-color=next-button-hover] .noUi-connect {
  background: #bdd6fa;
}
[data-slider-color=next-button-hover] .noUi-handle {
  background: #bdd6fa;
}
[data-slider-color=next-button-hover][data-slider-style=border] .noUi-handle, [data-slider-color=next-button-hover][data-slider-style=square] .noUi-handle {
  border-color: #bdd6fa;
}

[data-slider-color=white] .noUi-connect {
  background: #fff;
}
[data-slider-color=white] .noUi-handle {
  background: #fff;
}
[data-slider-color=white][data-slider-style=border] .noUi-handle, [data-slider-color=white][data-slider-style=square] .noUi-handle {
  border-color: #fff;
}

[data-slider-color=light-grey] .noUi-connect {
  background: #ced4da;
}
[data-slider-color=light-grey] .noUi-handle {
  background: #ced4da;
}
[data-slider-color=light-grey][data-slider-style=border] .noUi-handle, [data-slider-color=light-grey][data-slider-style=square] .noUi-handle {
  border-color: #ced4da;
}

[data-slider-size=lg].noUi-horizontal {
  height: 12px;
}
[data-slider-size=lg].noUi-horizontal .noUi-handle {
  width: 24px;
  height: 24px;
}

[data-slider-size=md].noUi-horizontal {
  height: 8px;
}
[data-slider-size=md].noUi-horizontal .noUi-handle {
  width: 20px;
  height: 20px;
}

[data-slider-size=sm].noUi-horizontal {
  height: 4px;
}
[data-slider-size=sm].noUi-horizontal .noUi-handle {
  width: 16px;
  height: 16px;
}

[data-slider-style=line].noUi-horizontal .noUi-handle {
  width: 8px;
  border-radius: 4px;
  right: -8px;
}
[data-slider-style=line].noUi-vertical .noUi-handle {
  height: 8px;
  border-radius: 4px;
  top: -3px;
}

[data-slider-style=border] .noUi-handle {
  border-color: #13c56b;
  background-color: var(--vz-secondary-bg);
}

[data-slider-style=square] .noUi-handle {
  border-radius: 0px;
  transform: rotate(45deg);
  height: 10px;
  width: 10px;
  top: -4px;
  border-color: #13c56b;
  background-color: var(--vz-secondary-bg);
}

.nested-list .list-group-item {
  background-color: rgba(180, 208, 240, 0.05);
  border-color: rgba(180, 208, 240, 0.05);
}

.nested-list, .nested-1, .nested-2, .nested-3 {
  margin-top: 5px;
}

.nested-sortable-handle .handle {
  position: absolute;
  left: 0;
  top: 0;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
}
.nested-sortable-handle .list-group-item {
  padding-left: 42px;
}

.shepherd-element {
  background: var(--vz-secondary-bg);
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
}

.shepherd-has-title .shepherd-content .shepherd-header {
  background-color: var(--vz-light);
  padding: 0.5rem 0.75rem;
}
.shepherd-has-title .shepherd-content .shepherd-cancel-icon {
  color: rgba(var(--vz-body-color-rgb), 0.75);
}
.shepherd-has-title .shepherd-content .shepherd-cancel-icon:hover {
  color: rgba(var(--vz-body-color-rgb), 1);
}

.shepherd-element.shepherd-has-title[data-popper-placement^=bottom] > .shepherd-arrow:before {
  background-color: var(--vz-light);
}

.shepherd-title {
  font-size: 15px;
  font-weight: 400;
  color: var(--vz-body-color);
}

.shepherd-text {
  padding: 0.75rem;
  font-size: 0.825rem;
  color: var(--vz-body-color);
}

.shepherd-button.btn-success:not(:disabled):hover {
  background: #12b965;
  color: #fff;
}
.shepherd-button.btn-light:not(:disabled):hover {
  background: rgba(var(--vz-light-rgb), 0.75);
  color: var(--vz-body-color);
}
.shepherd-button.btn-primary:not(:disabled):hover {
  background: #a9c9ee;
  color: #fff;
}

.shepherd-footer {
  padding: 0 0.75rem 0.75rem;
}

.shepherd-arrow,
.shepherd-arrow:before {
  content: "";
  font-family: "remixicon";
  font-size: 24px;
  z-index: 1;
  background-color: transparent !important;
  transform: rotate(0deg);
  color: var(--vz-primary);
}

.shepherd-element[data-popper-placement^=bottom] > .shepherd-arrow {
  top: -18px;
}

.shepherd-button {
  margin-right: 0.5rem;
}

.swiper-button-next,
.swiper-button-prev {
  height: 32px !important;
  width: 32px !important;
  background-color: rgba(180, 208, 240, 0.2);
  backdrop-filter: blur(2px);
  border-radius: 8px;
}
.swiper-button-next::after,
.swiper-button-prev::after {
  font-family: remixicon !important;
  font-size: 28px !important;
  color: #b4d0f0;
  transition: all 0.3s ease;
}

.swiper-button-prev::after {
  content: "" !important;
}

.swiper-button-next::after {
  content: "" !important;
}

.swiper-pagination-bullet {
  width: 22px !important;
  height: 5px !important;
  background-color: #fff !important;
  border-radius: 50px !important;
  box-shadow: none !important;
}
.swiper-pagination-bullet .swiper-pagination-bullet-active {
  opacity: 1 !important;
}

.dynamic-pagination .swiper-pagination-bullet {
  width: 8px !important;
  height: 8px !important;
  background-color: #fff;
  opacity: 0.5;
  transition: all 0.5s ease;
}
.dynamic-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  opacity: 1;
  width: 20px;
}

.swiper-pagination-fraction {
  color: #fff;
  font-size: 16px;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(2px);
}

.pagination-custom .swiper-pagination-bullet {
  height: 25px;
  width: 25px;
  line-height: 25px;
  border-radius: 8px;
  background-color: #fff;
  opacity: 0.5;
  transition: all 0.5s ease;
}
.pagination-custom .swiper-pagination-bullet.swiper-pagination-bullet-active {
  color: #daecfb;
  opacity: 1;
}

.swiper-pagination-progressbar {
  height: 6px !important;
  background-color: rgba(19, 197, 107, 0.25);
}
.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  background-color: #13c56b;
}

.swiper-scrollbar {
  background-color: rgba(255, 255, 255, 0.35);
  backdrop-filter: blur(2px);
  padding: 1.2px;
  height: 6px !important;
}
.swiper-scrollbar .swiper-scrollbar-drag {
  background-color: #fff;
}

.swiper-pagination-dark .swiper-pagination-bullet {
  background-color: #daecfb !important;
}
.swiper-pagination-dark .dynamic-pagination .swiper-pagination-bullet {
  background-color: #daecfb !important;
}
.swiper-pagination-dark.pagination-custom .swiper-pagination-bullet {
  color: #fff;
}
.swiper-pagination-dark.pagination-custom .swiper-pagination-bullet.swiper-pagination-bullet-active {
  opacity: 1;
}
.swiper-pagination-dark.swiper-scrollbar {
  background-color: rgba(54, 61, 72, 0.35);
}

.multi-wrapper {
  border: none;
  position: relative;
}
.multi-wrapper::before {
  content: "";
  position: absolute;
  font-family: "remixicon";
  left: 50%;
  transform: translateX(-50%);
  bottom: 86px;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  border-radius: 50%;
  color: var(--vz-secondary-color);
  background-color: var(--vz-light);
  z-index: 1;
}
.multi-wrapper .non-selected-wrapper {
  border: 1px solid var(--vz-input-border-custom);
  background-color: var(--vz-input-bg-custom);
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.multi-wrapper .selected-wrapper::-webkit-scrollbar, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar {
  -webkit-appearance: none;
}
.multi-wrapper .selected-wrapper::-webkit-scrollbar:vertical, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar:vertical {
  width: 10px;
}
.multi-wrapper .selected-wrapper::-webkit-scrollbar:horizontal, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar:horizontal {
  height: 9px;
}
.multi-wrapper .selected-wrapper::-webkit-scrollbar-thumb, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(var(--vz-dark-rgb), 0.2);
  border-radius: 10px;
  border: 2px solid var(--vz-input-bg-custom);
}
.multi-wrapper .selected-wrapper::-webkit-scrollbar-track, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: var(--vz-input-bg-custom);
}
.multi-wrapper .item-group .group-label {
  font-size: 12px;
}
.multi-wrapper .item {
  color: var(--vz-body-color);
}
.multi-wrapper .item:hover {
  background-color: rgba(180, 208, 240, 0.1);
}
.multi-wrapper .selected-wrapper {
  border: 1px solid var(--vz-input-border-custom);
  background: var(--vz-input-bg-custom);
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.multi-wrapper .search-input {
  flex: 0 0 auto;
  padding: 0.5rem 0.9rem;
  font-size: 0.825rem;
  color: var(--vz-body-color);
  background-color: var(--vz-input-bg-custom);
  border: var(--vz-border-width) solid var(--vz-input-border-custom);
  border-radius: var(--vz-border-radius);
  margin-bottom: 16px;
}
.multi-wrapper .search-input::placeholder {
  color: var(--vz-secondary-color);
}
.multi-wrapper .header {
  font-weight: 500;
  color: var(--vz-gray-600);
}

.pcr-app {
  background: var(--vz-secondary-bg);
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  border-radius: 4px;
  border: 1px solid var(--vz-border-color);
}

.pickr .pcr-button {
  border: 4px solid var(--vz-secondary-bg);
  box-shadow: 0px 0px 0 2px var(--vz-border-color);
  border-radius: 50%;
  box-shadow: none;
}
.pickr .pcr-button::after, .pickr .pcr-button::before {
  border-radius: 50%;
}

.pcr-app[data-theme=classic] .pcr-selection .pcr-color-preview {
  margin-right: 0.75em;
  margin-left: 0;
}
.pcr-app[data-theme=classic] .pcr-selection .pcr-color-chooser, .pcr-app[data-theme=classic] .pcr-selection .pcr-color-opacity {
  margin-left: 0.75em;
  margin-right: 0;
}
.pcr-app[data-theme=monolith] .pcr-result {
  min-width: 100%;
}
.pcr-app .pcr-interaction .pcr-type.active {
  background: #b4d0f0;
}
.pcr-app .pcr-interaction .pcr-result {
  background-color: var(--vz-input-bg-custom);
  color: var(--vz-body-color);
  border: 1px solid var(--vz-input-border-custom);
  border-radius: var(--vz-border-radius);
}
.pcr-app .pcr-interaction input {
  border-radius: var(--vz-border-radius) !important;
}
.pcr-app .pcr-interaction input:focus {
  box-shadow: none;
  background-color: var(--vz-input-bg-custom);
  border-color: var(--vz-primary-border-subtle);
}
.pcr-app .pcr-interaction .pcr-save {
  background: #13c56b !important;
}
.pcr-app .pcr-interaction .pcr-clear, .pcr-app .pcr-interaction .pcr-cancel {
  background: #ed5e5e !important;
}

.filepond--root {
  margin-bottom: 0;
}
.filepond--root[data-style-panel-layout~=circle] .filepond--drop-label label {
  font-size: 14px;
}

.filepond--panel-root {
  border: 2px dashed var(--vz-border-color);
  background: var(--vz-light-bg);
}

.filepond--drop-label {
  color: var(--vz-body-color);
}
.filepond--drop-label label {
  font-weight: 400;
}

.filepond--credits {
  display: none;
}

.filepond--item-panel {
  background-color: #b4d0f0 !important;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  height: auto;
}

.input-step {
  border: 1px solid var(--vz-input-border-custom);
  display: inline-flex;
  overflow: visible;
  height: 37.5px;
  border-radius: var(--vz-border-radius);
  background: var(--vz-input-bg-custom);
  padding: 4px;
}
.input-step input {
  width: 4em;
  height: 100%;
  text-align: center;
  border: 0;
  background: transparent;
  color: var(--vz-body-color);
  border-radius: var(--vz-border-radius);
}
.input-step input:focus-visible {
  outline: 0;
}
.input-step button {
  width: 1.4em;
  font-weight: 300;
  height: 100%;
  line-height: 0.1em;
  font-size: 1.4em;
  padding: 0.2em !important;
  background: var(--vz-light);
  color: var(--vz-body-color);
  border: none;
  border-radius: var(--vz-border-radius);
}
.input-step.light {
  background: var(--vz-light);
}
.input-step.light button {
  background-color: var(--vz-input-bg-custom);
}
.input-step.light-input {
  background: var(--vz-light);
}
.input-step.light-input input {
  background-color: var(--vz-input-bg-custom);
}
.input-step.full-width {
  display: flex;
  width: 100%;
}
.input-step.full-width button {
  flex-shrink: 0;
}
.input-step.full-width input {
  flex-grow: 1;
}

.input-step.step-primary button {
  background-color: #b4d0f0;
  color: #fff;
}

.input-step.step-secondary button {
  background-color: #daecfb;
  color: #fff;
}

.input-step.step-success button {
  background-color: #13c56b;
  color: #fff;
}

.input-step.step-info button {
  background-color: #50c3e6;
  color: #fff;
}

.input-step.step-warning button {
  background-color: #e8bc52;
  color: #fff;
}

.input-step.step-danger button {
  background-color: #ed5e5e;
  color: #fff;
}

.input-step.step-light button {
  background-color: #f3f6f9;
  color: #fff;
}

.input-step.step-dark button {
  background-color: #363d48;
  color: #fff;
}

.input-step.step-custom-primary button {
  background-color: #7eabe7;
  color: #fff;
}

.input-step.step-custom-primary-hover button {
  background-color: #bcd4f8;
  color: #fff;
}

.input-step.step-new-primary button {
  background-color: #0A56AE;
  color: #fff;
}

.input-step.step-header button {
  background-color: #bdd6fb;
  color: #fff;
}

.input-step.step-next-button button {
  background-color: #83a9e2;
  color: #fff;
}

.input-step.step-next-button-border button {
  background-color: #5d87c7;
  color: #fff;
}

.input-step.step-next-button-hover button {
  background-color: #bdd6fa;
  color: #fff;
}

.input-step.step-white button {
  background-color: #fff;
  color: #fff;
}

.input-step.step-light-grey button {
  background-color: #ced4da;
  color: #fff;
}

.ck {
  font-family: var(--vz-font-sans-serif) !important;
}
.ck.ck-reset_all, .ck.ck-reset_all * {
  color: var(--vz-body-color) !important;
}
.ck.ck-toolbar {
  background: rgba(var(--vz-light-rgb), 0.75) !important;
}
.ck p {
  margin-bottom: 0;
}
.ck.ck-toolbar {
  border: 1px solid var(--vz-input-border-custom) !important;
}
.ck.ck-toolbar.ck-toolbar_grouping > .ck-toolbar__items {
  flex-wrap: wrap !important;
}
.ck.ck-toolbar .ck.ck-toolbar__separator {
  background: transparent !important;
}
.ck.ck-editor__main > .ck-editor__editable {
  border-top: 0 !important;
  background-color: var(--vz-secondary-bg) !important;
  border-color: var(--vz-input-border-custom) !important;
  box-shadow: none !important;
}
.ck.ck-dropdown__panel {
  background: var(--vz-secondary-bg) !important;
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  border-radius: var(--vz-border-radius-lg);
}
.ck.ck-list {
  background: var(--vz-secondary-bg) !important;
}
.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne, .ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se {
  left: 0;
  right: auto !important;
}
.ck.ck-editor__editable_inline[dir=ltr] {
  text-align: left !important;
}
.ck.ck-dropdown__panel {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12) !important;
  border-radius: var(--vz-border-radius-lg) !important;
  border: 1px solid var(--vz-border-color) !important;
}

.ck.ck-button:focus, .ck.ck-button:active,
a.ck.ck-button:focus,
a.ck.ck-button:active {
  box-shadow: none !important;
  border: 1px solid var(--vz-light) !important;
}
.ck.ck-button:not(.ck-disabled):hover,
a.ck.ck-button:not(.ck-disabled):hover {
  background: var(--vz-light) !important;
}
.ck.ck-button.ck-on,
a.ck.ck-button.ck-on {
  background: var(--vz-light) !important;
}

.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.ck-editor__editable {
  min-height: 245px !important;
}

.ck[class*=ck-heading_heading] {
  font-weight: 400 !important;
}

.ck.ck-button.ck-on:not(.ck-disabled):hover, .ck.ck-button.ck-on:not(.ck-disabled):active,
a.ck.ck-button.ck-on:not(.ck-disabled):hover,
a.ck.ck-button.ck-on:not(.ck-disabled):active {
  box-shadow: none !important;
}

.ck.ck-tooltip .ck-tooltip__text {
  background: #363d48 !important;
  color: #f3f6f9 !important;
}
.ck.ck-input-text {
  background: var(--vz-input-bg-custom) !important;
  border: 1px solid var(--vz-input-border-custom) !important;
}
.ck.ck-input-text:focus {
  border: 1px solid var(--vz-primary-border-subtle) !important;
  box-shadow: none !important;
}
.ck.ck-balloon-panel {
  background: var(--vz-secondary-bg) !important;
  border: 1px solid var(--vz-border-color) !important;
}
.ck.ck-balloon-panel[class*=arrow_n]:after {
  border-bottom-color: var(--vz-secondary-bg) !important;
}
.ck.ck-balloon-panel[class*=arrow_n]::before {
  border-bottom-color: var(--vz-border-color) !important;
}

.ck.ck-labeled-field-view > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {
  background: var(--vz-secondary-bg) !important;
}

.ck-editor-reverse .ck-editor {
  display: flex;
  flex-direction: column-reverse;
}
.ck-editor-reverse .ck.ck-editor__main > .ck-editor__editable {
  border: 1px solid var(--vz-input-border-custom) !important;
  border-bottom: 0 !important;
}
.ck-editor-reverse .ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck-editor-reverse .ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.ck-editor-reverse .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck-editor-reverse .ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

[dir=rtl] .ck.ck-toolbar > .ck-toolbar__items {
  flex-direction: row-reverse;
}

.ql-editor {
  text-align: left;
}
.ql-editor ol,
.ql-editor ul {
  padding-left: 1.5em;
  padding-right: 0;
}
.ql-editor li:not(.ql-direction-rtl)::before {
  margin-left: -1.5em;
  margin-right: 0.3em;
  text-align: right;
}

.ql-container {
  font-family: var(--vz-font-sans-serif);
}
.ql-container.ql-snow {
  border-color: var(--vz-input-border-custom);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.ql-bubble {
  border: var(--vz-border-width) solid var(--vz-input-border-custom);
  border-radius: var(--vz-border-radius);
}

.ql-toolbar {
  font-family: var(--vz-font-sans-serif) !important;
}
.ql-toolbar span {
  outline: none !important;
  color: var(--vz-body-color);
}
.ql-toolbar span:hover {
  color: #b4d0f0 !important;
}
.ql-toolbar.ql-snow {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-color: var(--vz-input-border-custom);
}
.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  border-color: transparent;
}
.ql-toolbar.ql-snow .ql-picker-options {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  border-radius: var(--vz-border-radius-lg);
}

.ql-snow .ql-stroke,
.ql-snow .ql-script,
.ql-snow .ql-strike svg {
  stroke: var(--vz-body-color);
}
.ql-snow .ql-fill {
  fill: var(--vz-body-color);
}
.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
  right: 0;
  left: auto;
}
.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  color: var(--vz-secondary-color);
}

.ql-snow .ql-picker-options {
  background-color: var(--vz-secondary-bg);
  border-color: var(--vz-border-color) !important;
}

.gridjs-container {
  color: var(--vz-body-color);
  padding: 0;
  display: block;
}

.gridjs-wrapper {
  box-shadow: none;
  border: 1px solid var(--vz-border-color);
  border-radius: 0px;
}
.gridjs-wrapper::-webkit-scrollbar {
  -webkit-appearance: none;
}
.gridjs-wrapper::-webkit-scrollbar:vertical {
  width: 12px;
}
.gridjs-wrapper::-webkit-scrollbar:horizontal {
  height: 12px;
}
.gridjs-wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(var(--vz-dark-rgb), 0.075);
  border-radius: 10px;
  border: 2px solid var(--vz-secondary-bg);
}
.gridjs-wrapper::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: var(--vz-secondary-bg);
}

.gridjs-footer {
  border: none !important;
  padding: 12px 0 0;
}

.gridjs-table {
  width: 100%;
}

.gridjs-tbody, td.gridjs-td {
  background-color: transparent;
}

th.gridjs-th,
td.gridjs-td {
  border: 1px solid var(--vz-border-color);
  padding: 0.75rem 0.6rem;
}

th.gridjs-th {
  border-top: 0;
  color: var(--vz-body-color);
  background-color: rgba(var(--vz-light-rgb), 0.75);
}
th.gridjs-th-sort:focus, th.gridjs-th-sort:hover {
  background-color: rgba(var(--vz-light-rgb), 0.85);
}

.gridjs-head {
  padding-top: 0;
}

.gridjs-footer {
  box-shadow: none;
  border: 1px solid var(--vz-border-color);
  border-top: 0;
  background-color: transparent;
}

.gridjs-summary {
  color: var(--vz-secondary-color);
  margin-top: 8px !important;
}

.gridjs-pagination .gridjs-pages button {
  margin-left: 0.3rem;
  border-radius: 0.25rem !important;
  border: 1px solid var(--vz-border-color);
  background-color: var(--vz-secondary-bg);
  color: var(--vz-link-color);
}
.gridjs-pagination .gridjs-pages button:last-child {
  border-right: 1px solid var(--vz-border-color);
}
.gridjs-pagination .gridjs-pages button:disabled, .gridjs-pagination .gridjs-pages button:hover:disabled, .gridjs-pagination .gridjs-pages button[disabled] {
  color: var(--vz-secondary-color);
  background-color: var(--vz-secondary-bg);
}
.gridjs-pagination .gridjs-pages button:hover {
  background-color: var(--vz-tertiary-bg);
  color: var(--vz-link-hover-color);
}
.gridjs-pagination .gridjs-pages button:focus {
  box-shadow: none;
}
.gridjs-pagination .gridjs-pages button:last-child:hover, .gridjs-pagination .gridjs-pages button:first-child:hover {
  background-color: transparent;
}
.gridjs-pagination .gridjs-pages button.gridjs-currentPage {
  background-color: #8aaed6;
  color: #fff;
  border-color: #8aaed6;
  font-weight: 400;
}

.gridjs-search {
  position: relative;
  float: left;
}
.gridjs-search::before {
  content: "";
  font-family: "remixicon";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
  font-size: 14px;
  color: var(--vz-secondary-color);
}

input.gridjs-input {
  border-color: var(--vz-input-border-custom);
  background-color: var(--vz-input-bg-custom);
  color: var(--vz-body-color);
  line-height: 1.5;
  padding: 0.5rem 0.9rem 0.5rem 2.025rem;
  border-radius: var(--vz-border-radius);
  font-size: 0.825rem;
}
input.gridjs-input:focus {
  box-shadow: none;
  border-color: var(--vz-primary-border-subtle);
  background-color: var(--vz-input-bg-custom);
}
input.gridjs-input::placeholder {
  color: var(--vz-secondary-color);
}

th.gridjs-th .gridjs-th-content {
  float: none;
  display: inline-block;
  vertical-align: middle;
  font-weight: 500;
}

button.gridjs-sort {
  float: none;
  display: inline-block;
  vertical-align: middle;
  width: 10px;
  height: 20px;
}

th.gridjs-th-sort .gridjs-th-content {
  width: calc(100% - 10px);
}

button.gridjs-sort-asc, button.gridjs-sort-desc {
  background-size: 7px;
}

.table-card .gridjs-head {
  padding: 16px 16px 5px;
}
.table-card .gridjs-wrapper {
  border-top: 0;
  border-radius: 0;
  border-width: 1px 0;
}
.table-card .gridjs-footer {
  padding: 8px 16px;
}

.gridjs-tr-selected td {
  background-color: rgba(var(--vz-body-color-rgb), 0.04);
}
.gridjs-tr-selected .gridjs-td .gridjs-checkbox[type=checkbox] {
  background-color: #8aaed6;
  border-color: #8aaed6;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
}

.gridjs-td .gridjs-checkbox {
  width: 1.1em;
  height: 1.1em;
  vertical-align: top;
  background-color: var(--vz-input-bg-custom);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--vz-border-width) solid var(--vz-border-color-translucent);
  appearance: none;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.gridjs-td .gridjs-checkbox[type=checkbox] {
  border-radius: 0.25em;
}

.gridjs-border-none td.gridjs-td, .gridjs-border-none th.gridjs-th {
  border-right-width: 0;
  border-left-width: 0;
}

.gridjs-loading-bar {
  background-color: var(--vz-secondary-bg);
}

[data-bs-theme=dark] button:is(.gridjs-sort-neutral, .gridjs-sort-asc, .gridjs-sort-desc) {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.listjs-pagination {
  margin-bottom: 0;
  justify-content: flex-end;
  gap: 8px;
}
.listjs-pagination li .page {
  display: block;
  padding: 0.375rem 0.75rem;
  color: var(--vz-link-color);
  background-color: var(--vz-secondary-bg);
  border: var(--vz-border-width) solid var(--vz-border-color);
  border-radius: 0.25rem;
}
.listjs-pagination li.active .page {
  color: #fff;
  background-color: #8aaed6;
  border-color: #8aaed6;
}

.pagination-wrap {
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  align-items: center;
}
.pagination-wrap a {
  text-decoration: none;
  display: inline-block;
}

.pagination-next,
.pagination-prev {
  color: #b4d0f0;
  font-weight: 400;
  padding: 0.375rem 0.75rem;
  background-color: var(--vz-secondary-bg);
  border: var(--vz-border-width) solid var(--vz-border-color);
  border-radius: 0.25rem;
}
.pagination-next:hover,
.pagination-prev:hover {
  color: white;
}
.pagination-next.disabled,
.pagination-prev.disabled {
  color: var(--vz-secondary-color);
  cursor: default;
}
.pagination-next.disabled:hover,
.pagination-prev.disabled:hover {
  color: var(--vz-secondary-color);
}

.apex-charts {
  min-height: 10px !important;
}
.apex-charts text {
  font-family: var(--vz-font-sans-serif) !important;
}
.apex-charts .apexcharts-canvas {
  margin: 0 auto;
}

@keyframes opaque {
  0% {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes resizeanim {
  0%, to {
    opacity: 0;
  }
}
.apexcharts-canvas {
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}
.apexcharts-canvas ::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 6px;
}
.apexcharts-canvas ::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
.apexcharts-canvas :is(.apexcharts-reset-zoom-icon, .apexcharts-selection-icon, .apexcharts-zoom-icon).apexcharts-selected svg {
  fill: var(--vz-primary);
}
@media screen and (min-width: 768px) {
  .apexcharts-canvas:hover .apexcharts-toolbar {
    opacity: 1;
  }
}

.apexcharts-inner {
  position: relative;
}

.apexcharts-gridline {
  pointer-events: none;
  stroke: rgba(var(--vz-light-rgb), 1);
}

.apexcharts-text tspan {
  font-family: inherit;
}

.apexcharts-yaxis text,
.apexcharts-xaxis text {
  font-family: var(--vz-font-sans-serif) !important;
  fill: #878a99;
}

.apexcharts-title-text,
.apexcharts-subtitle-text {
  fill: #adb5bd;
}

.legend-mouseover-inactive {
  transition: 0.15s ease all;
  opacity: 0.2;
}

.apexcharts-legend-text {
  color: #878a99 !important;
  font-family: var(--vz-font-sans-serif) !important;
  font-size: 13px !important;
  padding-left: 15px;
  margin-left: -15px;
}

.apexcharts-series-collapsed {
  opacity: 0;
}

.apexcharts-xaxis-tick {
  stroke: var(--vz-border-color);
}

.apexcharts-marker {
  stroke: var(--vz-secondary-bg);
}

.apexcharts-tooltip {
  border-radius: 5px;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15) !important;
  cursor: default;
  font-size: 14px;
  left: 62px;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  white-space: nowrap;
  z-index: 12;
  transition: 0.15s ease all;
}
.apexcharts-tooltip.apexcharts-active {
  opacity: 1;
  transition: 0.15s ease all;
}
.apexcharts-tooltip.apexcharts-theme-light {
  border: 1px solid var(--vz-border-color) !important;
  background: rgba(var(--vz-secondary-bg-rgb), 0.96) !important;
}
.apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {
  background: var(--vz-secondary-bg) !important;
  border-bottom: 1px solid var(--vz-border-color) !important;
}
.apexcharts-tooltip.apexcharts-theme-dark {
  color: #fff;
  background: rgba(30, 30, 30, 0.8);
}
.apexcharts-tooltip.apexcharts-theme-dark .apexcharts-tooltip-title {
  background: rgba(0, 0, 0, 0.7);
  border-bottom: 1px solid #333;
}
.apexcharts-tooltip * {
  font-family: inherit;
}
.apexcharts-tooltip .apexcharts-tooltip-title {
  padding: 6px;
  font-size: 15px;
  margin-bottom: 4px;
}

.apexcharts-tooltip-text-goals-value,
.apexcharts-tooltip-text-y-value,
.apexcharts-tooltip-text-z-value {
  display: inline-block;
  margin-left: 5px;
  font-weight: 600;
}

.apexcharts-tooltip-text-goals-label:empty,
.apexcharts-tooltip-text-goals-value:empty,
.apexcharts-tooltip-text-y-label:empty,
.apexcharts-tooltip-text-y-value:empty,
.apexcharts-tooltip-text-z-value:empty,
.apexcharts-tooltip-title:empty {
  display: none;
}

.apexcharts-tooltip-text-goals-label,
.apexcharts-tooltip-text-goals-value {
  padding: 6px 0 5px;
}

.apexcharts-tooltip-goals-group,
.apexcharts-tooltip-text-goals-label,
.apexcharts-tooltip-text-goals-value {
  display: flex;
}

.apexcharts-tooltip-text-goals-label:not(:empty),
.apexcharts-tooltip-text-goals-value:not(:empty) {
  margin-top: -6px;
}

.apexcharts-tooltip-marker {
  width: 12px;
  height: 12px;
  position: relative;
  top: 0;
  margin-right: 10px;
  border-radius: 50%;
}

.apexcharts-tooltip-series-group {
  padding: 0 10px;
  display: none;
  text-align: left;
  justify-content: left;
  align-items: center;
}
.apexcharts-tooltip-series-group.apexcharts-active .apexcharts-tooltip-marker {
  opacity: 1;
}
.apexcharts-tooltip-series-group.apexcharts-active, .apexcharts-tooltip-series-group:last-child {
  padding-bottom: 4px;
}

.apexcharts-tooltip-series-group-hidden {
  opacity: 0;
  height: 0;
  line-height: 0;
  padding: 0 !important;
}

.apexcharts-tooltip-y-group {
  padding: 6px 0 5px;
}

.apexcharts-custom-tooltip,
.apexcharts-tooltip-box {
  padding: 4px 8px;
}

.apexcharts-tooltip-boxPlot {
  display: flex;
  flex-direction: column-reverse;
}

.apexcharts-tooltip-box > div {
  margin: 4px 0;
}
.apexcharts-tooltip-box span.value {
  font-weight: 700;
}

.apexcharts-tooltip-rangebar {
  padding: 5px 8px;
}
.apexcharts-tooltip-rangebar .category {
  font-weight: 600;
  color: #777;
}
.apexcharts-tooltip-rangebar .series-name {
  font-weight: 700;
  display: block;
  margin-bottom: 5px;
}

.apexcharts-xaxistooltip,
.apexcharts-yaxistooltip {
  opacity: 0;
  pointer-events: none;
  color: #373d3f;
  font-size: 13px;
  text-align: center;
  border-radius: 2px;
  position: absolute;
  z-index: 10;
  background: #eceff1;
  border: 1px solid #90a4ae;
}

.apexcharts-xaxistooltip {
  padding: 9px 10px;
  transition: 0.15s ease all;
}
.apexcharts-xaxistooltip.apexcharts-theme-dark {
  background: rgba(0, 0, 0, 0.7);
  border: 1px solid rgba(0, 0, 0, 0.5);
  color: #fff;
}
.apexcharts-xaxistooltip::after, .apexcharts-xaxistooltip::before {
  left: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.apexcharts-xaxistooltip::after {
  border-color: transparent;
  border-width: 6px;
  margin-left: -6px;
}
.apexcharts-xaxistooltip::before {
  border-color: transparent;
  border-width: 7px;
  margin-left: -7px;
}
.apexcharts-xaxistooltip.apexcharts-active {
  opacity: 1;
  transition: 0.15s ease all;
}

.apexcharts-xaxistooltip-bottom::before, .apexcharts-xaxistooltip-bottom::after {
  bottom: 100%;
}
.apexcharts-xaxistooltip-bottom::after {
  border-bottom-color: #eceff1;
}
.apexcharts-xaxistooltip-bottom::before {
  border-bottom-color: #90a4ae;
}
.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark::before, .apexcharts-xaxistooltip-bottom.apexcharts-theme-dark::after {
  border-bottom-color: rgba(0, 0, 0, 0.5);
}

.apexcharts-xaxistooltip-top::before, .apexcharts-xaxistooltip-top::after {
  top: 100%;
}
.apexcharts-xaxistooltip-top::after {
  border-top-color: #eceff1;
}
.apexcharts-xaxistooltip-top::before {
  border-top-color: #90a4ae;
}
.apexcharts-xaxistooltip-top.apexcharts-theme-dark::before, .apexcharts-xaxistooltip-top.apexcharts-theme-dark::after {
  border-top-color: rgba(0, 0, 0, 0.5);
}

.apexcharts-yaxistooltip {
  padding: 4px 10px;
}
.apexcharts-yaxistooltip .apexcharts-theme-dark {
  background: rgba(0, 0, 0, 0.7);
  border: 1px solid rgba(0, 0, 0, 0.5);
  color: #fff;
}
.apexcharts-yaxistooltip::before, .apexcharts-yaxistooltip::after {
  top: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.apexcharts-yaxistooltip::after {
  border-color: transparent;
  border-width: 6px;
  margin-top: -6px;
}
.apexcharts-yaxistooltip::before {
  border-color: transparent;
  border-width: 7px;
  margin-top: -7px;
}
.apexcharts-yaxistooltip.apexcharts-active {
  opacity: 1;
}

.apexcharts-yaxistooltip-left::before, .apexcharts-yaxistooltip-left::after {
  left: 100%;
}
.apexcharts-yaxistooltip-left::after {
  border-left-color: #eceff1;
}
.apexcharts-yaxistooltip-left::before {
  border-left-color: #90a4ae;
}
.apexcharts-yaxistooltip-left.apexcharts-theme-dark::before, .apexcharts-yaxistooltip-left.apexcharts-theme-dark::after {
  border-left-color: rgba(0, 0, 0, 0.5);
}

.apexcharts-yaxistooltip-right::before, .apexcharts-yaxistooltip-right::after {
  right: 100%;
}
.apexcharts-yaxistooltip-right::after {
  border-right-color: #eceff1;
}
.apexcharts-yaxistooltip-right::before {
  border-right-color: #90a4ae;
}
.apexcharts-yaxistooltip-right.apexcharts-theme-dark::before, .apexcharts-yaxistooltip-right.apexcharts-theme-dark::after {
  border-right-color: rgba(0, 0, 0, 0.5);
}

.apexcharts-yaxistooltip-hidden {
  display: none;
}

.apexcharts-xcrosshairs,
.apexcharts-ycrosshairs {
  pointer-events: none;
  opacity: 0;
  transition: 0.15s ease all;
}
.apexcharts-xcrosshairs.apexcharts-active,
.apexcharts-ycrosshairs.apexcharts-active {
  opacity: 1;
  transition: 0.15s ease all;
}

.apexcharts-ycrosshairs-hidden {
  opacity: 0;
}

.apexcharts-selection-rect {
  cursor: move;
}

.svg_select_boundingRect,
.svg_select_points_rot {
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
}

.apexcharts-selection-rect + g .svg_select_boundingRect,
.apexcharts-selection-rect + g .svg_select_points_rot {
  opacity: 0;
  visibility: hidden;
}
.apexcharts-selection-rect + g .svg_select_points_l,
.apexcharts-selection-rect + g .svg_select_points_r {
  cursor: ew-resize;
  opacity: 1;
  visibility: visible;
}

.svg_select_points {
  fill: #efefef;
  stroke: #333;
  rx: 2;
}

.apexcharts-svg.apexcharts-zoomable.hovering-zoom {
  cursor: crosshair;
}
.apexcharts-svg.apexcharts-zoomable.hovering-pan {
  cursor: move;
}

.apexcharts-menu-icon,
.apexcharts-pan-icon,
.apexcharts-reset-icon,
.apexcharts-selection-icon,
.apexcharts-toolbar-custom-icon,
.apexcharts-zoom-icon,
.apexcharts-zoomin-icon,
.apexcharts-zoomout-icon {
  cursor: pointer;
  width: 20px;
  height: 20px;
  line-height: 24px;
  color: #6e8192;
  text-align: center;
}

:is(.apexcharts-menu-icon, .apexcharts-reset-icon, .apexcharts-zoom-icon, .apexcharts-zoomin-icon, .apexcharts-zoomout-icon) svg {
  fill: #6e8192;
}

.apexcharts-selection-icon svg {
  fill: #444;
  transform: scale(0.76);
}

.apexcharts-theme-dark :is(.apexcharts-menu-icon, .apexcharts-pan-icon, .apexcharts-reset-icon, .apexcharts-selection-icon, .apexcharts-toolbar-custom-icon, .apexcharts-zoom-icon, .apexcharts-zoomin-icon, .apexcharts-zoomout-icon) svg {
  fill: #f3f4f5;
}
.apexcharts-theme-dark .apexcharts-menu {
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
}

.apexcharts-theme-light .apexcharts-menu-icon:hover svg,
.apexcharts-theme-light .apexcharts-reset-icon:hover svg,
.apexcharts-theme-light .apexcharts-selection-icon:not(.apexcharts-selected):hover svg,
.apexcharts-theme-light .apexcharts-zoom-icon:not(.apexcharts-selected):hover svg,
.apexcharts-theme-light .apexcharts-zoomout-icon:hover svg {
  fill: #333;
}
.apexcharts-theme-light .apexcharts-menu-item:hover {
  background: #eee;
}

.apexcharts-menu-icon,
.apexcharts-selection-icon {
  position: relative;
}

.apexcharts-reset-icon {
  margin-left: 5px;
}

.apexcharts-menu-icon,
.apexcharts-reset-icon,
.apexcharts-zoom-icon {
  transform: scale(0.85);
}

.apexcharts-zoomin-icon,
.apexcharts-zoomout-icon {
  transform: scale(0.7);
}

.apexcharts-zoomout-icon {
  margin-right: 3px;
}

.apexcharts-pan-icon {
  transform: scale(0.62);
  position: relative;
  left: 1px;
  top: 0;
}
.apexcharts-pan-icon svg {
  fill: #fff;
  stroke: #6e8192;
  stroke-width: 2;
}
.apexcharts-pan-icon:not(.apexcharts-selected):hover svg {
  stroke: #333;
}

.apexcharts-toolbar {
  position: absolute;
  z-index: 11;
  max-width: 176px;
  text-align: right;
  border-radius: 3px;
  padding: 0 6px 2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.apexcharts-menu {
  background: #fff;
  position: absolute;
  top: 100%;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 3px;
  right: 10px;
  opacity: 0;
  min-width: 110px;
  transition: 0.15s ease all;
  pointer-events: none;
}
.apexcharts-menu .apexcharts-menu-open {
  opacity: 1;
  pointer-events: all;
  transition: 0.15s ease all;
}

.apexcharts-menu-item {
  padding: 6px 7px;
  font-size: 12px;
  cursor: pointer;
}

.apexcharts-canvas .apexcharts-element-hidden,
.apexcharts-datalabel.apexcharts-element-hidden,
.apexcharts-hide .apexcharts-series-points {
  opacity: 0;
}

.apexcharts-datalabel,
.apexcharts-datalabel-label,
.apexcharts-datalabel-value,
.apexcharts-datalabels,
.apexcharts-pie-label {
  cursor: default;
  pointer-events: none;
}

.apexcharts-pie-label-delay {
  opacity: 0;
  animation-name: opaque;
  animation-duration: 0.3s;
  animation-fill-mode: forwards;
  animation-timing-function: ease;
}

.apexcharts-annotation-rect,
.apexcharts-area-series .apexcharts-area,
.apexcharts-area-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,
.apexcharts-gridline,
.apexcharts-line,
.apexcharts-line-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,
.apexcharts-point-annotation-label,
.apexcharts-radar-series path,
.apexcharts-radar-series polygon,
.apexcharts-toolbar svg,
.apexcharts-tooltip .apexcharts-marker,
.apexcharts-xaxis-annotation-label,
.apexcharts-yaxis-annotation-label,
.apexcharts-zoom-rect {
  pointer-events: none;
}

.apexcharts-marker {
  transition: 0.15s ease all;
}

.resize-triggers {
  animation: 1ms resizeanim;
  visibility: hidden;
  opacity: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.contract-trigger:before,
.resize-triggers,
.resize-triggers > div {
  content: " ";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.resize-triggers > div {
  height: 100%;
  width: 100%;
  background: #eee;
  overflow: auto;
}
.resize-triggers::before {
  overflow: hidden;
  width: 200%;
  height: 200%;
}

#chart-year,
#chart-quarter {
  width: 96%;
  max-width: 48%;
  box-shadow: none;
  padding-left: 0;
  padding-top: 20px;
  background: var(--vz-secondary-bg);
  border: 1px solid var(--vz-border-color);
}

#chart-year {
  float: left;
  position: relative;
  transition: 1s ease transform;
  z-index: 3;
}
#chart-year.chart-quarter-activated {
  transform: translateX(0);
  transition: 1s ease transform;
}

#chart-quarter {
  float: left;
  position: relative;
  z-index: -2;
  transition: 1s ease transform;
}
#chart-quarter.active {
  transition: 1.1s ease-in-out transform;
  transform: translateX(0);
  z-index: 1;
}

@media screen and (min-width: 480px) {
  #chart-year {
    transform: translateX(50%);
  }

  #chart-quarter {
    transform: translateX(-50%);
  }
}
.apexcharts-treemap rect,
.apexcharts-heatmap-series rect {
  stroke: var(--vz-secondary-bg);
}

.apexcharts-pie-series path,
.apexcharts-bar-series path {
  stroke: var(--vz-secondary-bg);
}

.apexcharts-radialbar .apexcharts-datalabels-group text {
  fill: var(--vz-body-color);
}

.apexcharts-radialbar-track path {
  stroke: var(--vz-border-color);
}

.apexcharts-radar-series polygon,
.apexcharts-radar-series line {
  stroke: var(--vz-border-color);
}

.apexcharts-pie circle,
.apexcharts-pie line {
  stroke: var(--vz-border-color);
}
.apexcharts-pie text {
  fill: var(--vz-white);
}

.apexcharts-xaxistooltip.apexcharts-theme-light {
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  color: var(--vz-secondary-color);
  background: var(--vz-secondary-bg);
  border: 1px solid var(--vz-border-color);
  font-family: var(--vz-font-sans-serif);
}
.apexcharts-xaxistooltip.apexcharts-theme-light::before {
  border-bottom-color: var(--vz-border-color);
}

.effect-chart :is(.apexcharts-pie-series, .apexcharts-bar-series) path {
  clip-path: polygon(50% 2%, 100% 0, 100% 100%, 0 100%, 0 0);
}

.apexcharts-grid-borders line {
  stroke: var(--vz-border-color);
}

.chartjs-chart {
  max-height: 320px;
}

.e-charts {
  height: 350px;
}

.e-charts-height {
  height: 300px;
}

.gmaps, .gmaps-panaroma {
  height: 300px;
  background: #f3f6f9;
  border-radius: 3px;
}

.gmaps-overlay {
  display: block;
  text-align: center;
  color: #fff;
  font-size: 16px;
  line-height: 40px;
  background: #b4d0f0;
  border-radius: 4px;
  padding: 10px 20px;
}

.gmaps-overlay_arrow {
  left: 50%;
  margin-left: -16px;
  width: 0;
  height: 0;
  position: absolute;
}
.gmaps-overlay_arrow.above {
  bottom: -15px;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-top: 16px solid #b4d0f0;
}
.gmaps-overlay_arrow.below {
  top: -15px;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-bottom: 16px solid #b4d0f0;
}

.autoComplete_wrapper {
  display: block;
}
.autoComplete_wrapper > input {
  display: block;
  width: 100%;
  height: auto;
  padding: 0.5rem 0.9rem;
  font-size: 0.825rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  background-color: var(--vz-input-bg-custom);
  background-clip: padding-box;
  border: var(--vz-border-width) solid var(--vz-input-border-custom);
  border-radius: var(--vz-border-radius);
  background-image: none;
}
.autoComplete_wrapper > input::placeholder {
  padding: 0 !important;
  color: var(--vz-secondary-color) !important;
  font-size: 0.825rem !important;
}
.autoComplete_wrapper > input:focus {
  border: var(--vz-border-width) solid var(--vz-primary-border-subtle);
  color: var(--vz-body-color);
}
.autoComplete_wrapper > input:hover {
  color: var(--vz-body-color);
}
.autoComplete_wrapper > ul {
  border-radius: 0.25rem;
  border-color: var(--vz-border-color);
  background-color: var(--vz-secondary-bg);
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  padding: 0;
  overflow: auto;
  max-height: 160px;
  margin: 0;
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
}
.autoComplete_wrapper > ul > li {
  font-size: 0.825rem;
  margin: 0;
  padding: 0.35rem 1.2rem;
  border-radius: 0;
  background-color: var(--vz-secondary-bg);
  color: var(--vz-body-color);
}
.autoComplete_wrapper > ul > li mark, .autoComplete_wrapper > ul > li .mark {
  color: #ed5e5e;
  font-weight: 500;
  padding: 1px;
}
.autoComplete_wrapper > ul > li[aria-selected=true], .autoComplete_wrapper > ul > li:hover {
  color: var(--vz-body-color);
  background-color: var(--vz-tertiary-bg);
}
.autoComplete_wrapper > ul .no_result {
  padding: 0.7rem 1.2rem;
  font-style: italic;
  font-weight: 400;
}

.jvm-tooltip {
  border-radius: 3px;
  background-color: var(--vz-primary);
  font-family: var(--vz-font-sans-serif);
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  padding: 5px 9px;
}

.jvm-container text {
  font-family: var(--vz-font-sans-serif);
  font-size: 0.825rem;
  fill: var(--vz-body-color);
}

.jvm-zoom-btn {
  background-color: var(--vz-primary);
}

.leaflet-map {
  height: 300px;
}
.leaflet-map.leaflet-container {
  z-index: 0;
  font-family: "Rubik", sans-serif;
}

.fc td,
.fc th {
  border: var(--vz-border-width) solid var(--vz-border-color);
}

.fc .fc-toolbar h2, .fc .fc-toolbar .h2 {
  font-size: 16px;
  line-height: 30px;
  text-transform: uppercase;
}
@media (max-width: 767.98px) {
  .fc .fc-toolbar .fc-left,
.fc .fc-toolbar .fc-right,
.fc .fc-toolbar .fc-center {
    float: none;
    display: block;
    text-align: center;
    clear: both;
    margin: 10px 0;
  }
  .fc .fc-toolbar > * > * {
    float: none;
  }
  .fc .fc-toolbar .fc-today-button {
    display: none;
  }
}
.fc .fc-toolbar .btn {
  text-transform: capitalize;
}
.fc .fc-col-header-cell {
  background-color: var(--vz-light);
}
.fc .fc-col-header-cell-cushion {
  display: block;
  padding: 8px 4px;
  color: var(--vz-body-color);
}
.fc .fc-daygrid-day-number {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 400;
  margin: 2px;
  color: var(--vz-body-color);
}
.fc .fc-daygrid-day.fc-day-today {
  background-color: rgba(180, 208, 240, 0.1);
}
.fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-number {
  background-color: #b4d0f0;
  color: #fff;
}
.fc .fc-daygrid-day.fc-day-today {
  background-color: rgba(180, 208, 240, 0.1);
}
.fc .fc-timegrid-col.fc-day-today {
  background-color: rgba(180, 208, 240, 0.1);
}
.fc .fc-list-event:hover td {
  background: transparent;
}
.fc .fc-list-event-title a {
  color: #fff !important;
}
.fc .fc-col-header,
.fc .fc-daygrid-body,
.fc .fc-scrollgrid-sync-table {
  width: 100% !important;
}
.fc .fc-scrollgrid-section > * {
  border-left: var(--vz-border-width) solid var(--vz-border-color);
  border-top: var(--vz-border-width) solid var(--vz-border-color);
}
.fc .fc-scrollgrid {
  border: 0;
}
.fc .fc-scrollgrid-section-liquid > td {
  border-top: 0;
}

.fc-theme-bootstrap a:not([href]) {
  color: var(--vz-body-color);
}

.fc-event {
  color: #fff;
}

.fc th.fc-widget-header {
  background: #e9ebec;
  line-height: 20px;
  padding: 10px 0;
  text-transform: uppercase;
  font-weight: 700;
}

.fc-unthemed .fc-content,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-list-heading td,
.fc-unthemed .fc-list-view,
.fc-unthemed .fc-popover,
.fc-unthemed .fc-row,
.fc-unthemed tbody,
.fc-unthemed td,
.fc-unthemed th,
.fc-unthemed thead {
  border-color: #e9ebec;
}
.fc-unthemed td.fc-today {
  background: #f6f8fa;
}

.fc-button {
  background: var(--vz-secondary-bg);
  border-color: var(--vz-border-color);
  color: #495057;
  text-transform: capitalize;
  box-shadow: none;
  padding: 6px 12px !important;
  height: auto !important;
}

.fc-state-down,
.fc-state-active,
.fc-state-disabled {
  background-color: #b4d0f0;
  color: #fff;
  text-shadow: none;
}

.fc-event {
  border-radius: 2px;
  border: none;
  cursor: move;
  font-size: 0.8125rem;
  margin: 5px 7px;
  padding: 5px 5px;
  text-align: center;
}

.fc-event,
.fc-event-dot {
  background-color: #b4d0f0;
}

.fc-daygrid-dot-event.fc-event-mirror,
.fc-daygrid-dot-event:hover {
  background-color: #b4d0f0;
}

.fc-event-title,
.fc-sticky {
  font-weight: 500 !important;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fc-daygrid-event-dot {
  border-color: #fff !important;
  display: none;
}

.fc-event-time {
  display: none;
}

.fc-event .fc-content {
  color: #fff;
}

#external-events .external-event {
  text-align: left;
  padding: 8px 16px;
  margin: 6px 0;
}

.fc-day-grid-event.fc-h-event.fc-event.fc-start.fc-end.bg-dark .fc-content {
  color: #f3f6f9;
}

.fc-prev-button,
.fc-next-button {
  position: relative;
  height: 37.5px;
  width: 37.5px;
}
.fc-prev-button::before,
.fc-next-button::before {
  position: absolute;
  font-family: remixicon !important;
  font-size: 20px;
  top: 0;
  bottom: 0px;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fc-prev-button::before {
  content: "";
}

.fc-next-button::before {
  content: "";
}

.fc-toolbar-chunk .btn-group {
  box-shadow: none;
}
.fc-toolbar-chunk .btn-group .btn {
  color: #daecfb;
  background-color: rgba(218, 236, 251, 0.15);
  border: none;
  box-shadow: none;
}
.fc-toolbar-chunk .btn-group .btn:hover, .fc-toolbar-chunk .btn-group .btn.active {
  color: #fff;
  background-color: #daecfb;
}
.fc-toolbar-chunk .fc-today-button {
  background-color: #daecfb !important;
  border: #daecfb;
}

.fc .fc-button-primary:not(:disabled).fc-button-active,
.fc .fc-button-primary:not(:disabled):active {
  background-color: #daecfb !important;
  border-color: #daecfb !important;
  color: #fff !important;
}
.fc .fc-button-primary {
  text-transform: capitalize;
}

@media (max-width: 575.98px) {
  .fc-toolbar {
    flex-direction: column;
    gap: 16px;
  }
}

#upcoming-event-list .card:last-child {
  margin-bottom: 6px !important;
}

#event-modal .event-details {
  display: none;
}
#event-modal .view-event .event-form {
  display: none;
}
#event-modal .view-event #event-category-tag {
  display: none;
}
#event-modal .view-event .event-details {
  display: block;
}

.fc-daygrid-event-harness .fc-daygrid-event {
  backdrop-filter: blur(4px);
}

.fc-timegrid-event-harness .fc-timegrid-event {
  backdrop-filter: blur(4px);
}

.fc-timegrid-slots table tr {
  border-color: var(--vz-border-color) !important;
}

.fc-list-table {
  border-color: var(--vz-border-color);
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-primary-subtle .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-primary-subtle .fc-event-main {
  color: #b4d0f0 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-primary-subtle .fc-event-title {
  color: #b4d0f0 !important;
}

.fc-list-table .fc-list-event.bg-primary-subtle {
  color: #b4d0f0 !important;
}
.fc-list-table .fc-list-event.bg-primary-subtle .fc-list-event-title > a {
  color: #b4d0f0 !important;
}
.fc-list-table .fc-list-event.bg-primary-subtle .fc-list-event-dot {
  border-color: #b4d0f0;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-secondary-subtle .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-secondary-subtle .fc-event-main {
  color: #daecfb !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-secondary-subtle .fc-event-title {
  color: #daecfb !important;
}

.fc-list-table .fc-list-event.bg-secondary-subtle {
  color: #daecfb !important;
}
.fc-list-table .fc-list-event.bg-secondary-subtle .fc-list-event-title > a {
  color: #daecfb !important;
}
.fc-list-table .fc-list-event.bg-secondary-subtle .fc-list-event-dot {
  border-color: #daecfb;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-success-subtle .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-success-subtle .fc-event-main {
  color: #13c56b !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-success-subtle .fc-event-title {
  color: #13c56b !important;
}

.fc-list-table .fc-list-event.bg-success-subtle {
  color: #13c56b !important;
}
.fc-list-table .fc-list-event.bg-success-subtle .fc-list-event-title > a {
  color: #13c56b !important;
}
.fc-list-table .fc-list-event.bg-success-subtle .fc-list-event-dot {
  border-color: #13c56b;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-info-subtle .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-info-subtle .fc-event-main {
  color: #50c3e6 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-info-subtle .fc-event-title {
  color: #50c3e6 !important;
}

.fc-list-table .fc-list-event.bg-info-subtle {
  color: #50c3e6 !important;
}
.fc-list-table .fc-list-event.bg-info-subtle .fc-list-event-title > a {
  color: #50c3e6 !important;
}
.fc-list-table .fc-list-event.bg-info-subtle .fc-list-event-dot {
  border-color: #50c3e6;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-warning-subtle .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-warning-subtle .fc-event-main {
  color: #e8bc52 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-warning-subtle .fc-event-title {
  color: #e8bc52 !important;
}

.fc-list-table .fc-list-event.bg-warning-subtle {
  color: #e8bc52 !important;
}
.fc-list-table .fc-list-event.bg-warning-subtle .fc-list-event-title > a {
  color: #e8bc52 !important;
}
.fc-list-table .fc-list-event.bg-warning-subtle .fc-list-event-dot {
  border-color: #e8bc52;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-danger-subtle .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-danger-subtle .fc-event-main {
  color: #ed5e5e !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-danger-subtle .fc-event-title {
  color: #ed5e5e !important;
}

.fc-list-table .fc-list-event.bg-danger-subtle {
  color: #ed5e5e !important;
}
.fc-list-table .fc-list-event.bg-danger-subtle .fc-list-event-title > a {
  color: #ed5e5e !important;
}
.fc-list-table .fc-list-event.bg-danger-subtle .fc-list-event-dot {
  border-color: #ed5e5e;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-light-subtle .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-light-subtle .fc-event-main {
  color: #f3f6f9 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-light-subtle .fc-event-title {
  color: #f3f6f9 !important;
}

.fc-list-table .fc-list-event.bg-light-subtle {
  color: #f3f6f9 !important;
}
.fc-list-table .fc-list-event.bg-light-subtle .fc-list-event-title > a {
  color: #f3f6f9 !important;
}
.fc-list-table .fc-list-event.bg-light-subtle .fc-list-event-dot {
  border-color: #f3f6f9;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-dark-subtle .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-dark-subtle .fc-event-main {
  color: #363d48 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-dark-subtle .fc-event-title {
  color: #363d48 !important;
}

.fc-list-table .fc-list-event.bg-dark-subtle {
  color: #363d48 !important;
}
.fc-list-table .fc-list-event.bg-dark-subtle .fc-list-event-title > a {
  color: #363d48 !important;
}
.fc-list-table .fc-list-event.bg-dark-subtle .fc-list-event-dot {
  border-color: #363d48;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-custom-primary-subtle .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-custom-primary-subtle .fc-event-main {
  color: #7eabe7 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-custom-primary-subtle .fc-event-title {
  color: #7eabe7 !important;
}

.fc-list-table .fc-list-event.bg-custom-primary-subtle {
  color: #7eabe7 !important;
}
.fc-list-table .fc-list-event.bg-custom-primary-subtle .fc-list-event-title > a {
  color: #7eabe7 !important;
}
.fc-list-table .fc-list-event.bg-custom-primary-subtle .fc-list-event-dot {
  border-color: #7eabe7;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-custom-primary-hover-subtle .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-custom-primary-hover-subtle .fc-event-main {
  color: #bcd4f8 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-custom-primary-hover-subtle .fc-event-title {
  color: #bcd4f8 !important;
}

.fc-list-table .fc-list-event.bg-custom-primary-hover-subtle {
  color: #bcd4f8 !important;
}
.fc-list-table .fc-list-event.bg-custom-primary-hover-subtle .fc-list-event-title > a {
  color: #bcd4f8 !important;
}
.fc-list-table .fc-list-event.bg-custom-primary-hover-subtle .fc-list-event-dot {
  border-color: #bcd4f8;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-new-primary-subtle .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-new-primary-subtle .fc-event-main {
  color: #0A56AE !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-new-primary-subtle .fc-event-title {
  color: #0A56AE !important;
}

.fc-list-table .fc-list-event.bg-new-primary-subtle {
  color: #0A56AE !important;
}
.fc-list-table .fc-list-event.bg-new-primary-subtle .fc-list-event-title > a {
  color: #0A56AE !important;
}
.fc-list-table .fc-list-event.bg-new-primary-subtle .fc-list-event-dot {
  border-color: #0A56AE;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-header-subtle .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-header-subtle .fc-event-main {
  color: #bdd6fb !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-header-subtle .fc-event-title {
  color: #bdd6fb !important;
}

.fc-list-table .fc-list-event.bg-header-subtle {
  color: #bdd6fb !important;
}
.fc-list-table .fc-list-event.bg-header-subtle .fc-list-event-title > a {
  color: #bdd6fb !important;
}
.fc-list-table .fc-list-event.bg-header-subtle .fc-list-event-dot {
  border-color: #bdd6fb;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-next-button-subtle .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-next-button-subtle .fc-event-main {
  color: #83a9e2 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-next-button-subtle .fc-event-title {
  color: #83a9e2 !important;
}

.fc-list-table .fc-list-event.bg-next-button-subtle {
  color: #83a9e2 !important;
}
.fc-list-table .fc-list-event.bg-next-button-subtle .fc-list-event-title > a {
  color: #83a9e2 !important;
}
.fc-list-table .fc-list-event.bg-next-button-subtle .fc-list-event-dot {
  border-color: #83a9e2;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-next-button-border-subtle .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-next-button-border-subtle .fc-event-main {
  color: #5d87c7 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-next-button-border-subtle .fc-event-title {
  color: #5d87c7 !important;
}

.fc-list-table .fc-list-event.bg-next-button-border-subtle {
  color: #5d87c7 !important;
}
.fc-list-table .fc-list-event.bg-next-button-border-subtle .fc-list-event-title > a {
  color: #5d87c7 !important;
}
.fc-list-table .fc-list-event.bg-next-button-border-subtle .fc-list-event-dot {
  border-color: #5d87c7;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-next-button-hover-subtle .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-next-button-hover-subtle .fc-event-main {
  color: #bdd6fa !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-next-button-hover-subtle .fc-event-title {
  color: #bdd6fa !important;
}

.fc-list-table .fc-list-event.bg-next-button-hover-subtle {
  color: #bdd6fa !important;
}
.fc-list-table .fc-list-event.bg-next-button-hover-subtle .fc-list-event-title > a {
  color: #bdd6fa !important;
}
.fc-list-table .fc-list-event.bg-next-button-hover-subtle .fc-list-event-dot {
  border-color: #bdd6fa;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-white-subtle .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-white-subtle .fc-event-main {
  color: #fff !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-white-subtle .fc-event-title {
  color: #fff !important;
}

.fc-list-table .fc-list-event.bg-white-subtle {
  color: #fff !important;
}
.fc-list-table .fc-list-event.bg-white-subtle .fc-list-event-title > a {
  color: #fff !important;
}
.fc-list-table .fc-list-event.bg-white-subtle .fc-list-event-dot {
  border-color: #fff;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-light-grey-subtle .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-light-grey-subtle .fc-event-main {
  color: #ced4da !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-light-grey-subtle .fc-event-title {
  color: #ced4da !important;
}

.fc-list-table .fc-list-event.bg-light-grey-subtle {
  color: #ced4da !important;
}
.fc-list-table .fc-list-event.bg-light-grey-subtle .fc-list-event-title > a {
  color: #ced4da !important;
}
.fc-list-table .fc-list-event.bg-light-grey-subtle .fc-list-event-dot {
  border-color: #ced4da;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-dark-subtle .fc-event-main, .fc-daygrid-event-harness .fc-daygrid-event.bg-dark-subtle .fc-event-title {
  color: var(--vz-dark-text-emphasis) !important;
}

.fc-direction-ltr {
  direction: ltr;
}
.fc-direction-ltr .fc-toolbar > * > :not(:first-child) {
  margin-left: 0.75em;
}

.fg-emoji-picker {
  width: 250px !important;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15) !important;
  top: auto !important;
  bottom: 130px;
}
.fg-emoji-picker * {
  font-family: var(--vz-font-sans-serif) !important;
  color: var(--vz-body-color) !important;
}
@media (max-width: 991.98px) {
  .fg-emoji-picker {
    left: 14px !important;
    top: auto !important;
    bottom: 118px;
  }
}
.fg-emoji-picker .fg-emoji-picker-container-title {
  color: #363d48 !important;
}
.fg-emoji-picker .fg-emoji-picker-search {
  height: 40px !important;
}
.fg-emoji-picker .fg-emoji-picker-search input {
  background-color: var(--vz-input-bg-custom) !important;
  color: var(--vz-body-color) !important;
  padding: 0.5rem 0.9rem !important;
  font-size: 0.825rem !important;
}
.fg-emoji-picker .fg-emoji-picker-search input::placeholder {
  color: var(--vz-secondary-color) !important;
}
.fg-emoji-picker .fg-emoji-picker-search svg {
  fill: var(--vz-body-color) !important;
  right: 11px;
  top: 12px;
}
.fg-emoji-picker .fg-emoji-picker-categories {
  background-color: #f3f6f9 !important;
}
.fg-emoji-picker .fg-emoji-picker-categories li.active {
  background-color: rgba(var(--bs-primary-rgb), 0.2);
}
.fg-emoji-picker .fg-emoji-picker-categories a:hover {
  background-color: rgba(var(--bs-primary-rgb), 0.2);
}

.fg-emoji-picker-grid > li:hover {
  background-color: rgba(var(--bs-primary-rgb), 0.2) !important;
}

a.fg-emoji-picker-close-button {
  background-color: #e5ecf2 !important;
}

table.dataTable td.dataTables_empty,
table.dataTable th.dataTables_empty {
  text-align: center;
  padding: 50px;
  font-weight: 500;
  --vz-table-accent-bg: var(--vz-secondary-bg);
}

table.dataTable > thead .sorting:before,
table.dataTable > thead .sorting_asc:before,
table.dataTable > thead .sorting_desc:before,
table.dataTable > thead .sorting_asc_disabled:before,
table.dataTable > thead .sorting_desc_disabled:before {
  content: "󰍠";
  position: absolute;
  right: 0.5rem;
  top: 12px;
  font-size: 0.8rem;
  font-family: "Material Design Icons";
}

table.dataTable > thead .sorting:after,
table.dataTable > thead .sorting_asc:after,
table.dataTable > thead .sorting_desc:after,
table.dataTable > thead .sorting_asc_disabled:after,
table.dataTable > thead .sorting_desc_disabled:after {
  content: "󰍝";
  position: absolute;
  right: 0.5rem;
  top: 18px;
  font-size: 0.8rem;
  font-family: "Material Design Icons";
}

table.dataTable > tbody > tr.child span.dtr-title {
  font-weight: 500;
  min-width: 150px;
}

table.dataTable.dtr-inline.collapsed > tbody > tr > th.dtr-control::before,
table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control::before {
  background-color: #b4d0f0;
  border-color: var(--vz-secondary-bg);
}
table.dataTable.dtr-inline.collapsed > tbody > tr.parent.parent > th.dtr-control::before {
  background-color: #ed5e5e;
}
table.dataTable.dtr-inline.collapsed > tbody > tr.parent > td.dtr-control::before {
  background-color: #ed5e5e;
}
table.dataTable > tbody > tr.child span.dtr-title {
  min-width: 135px;
}

.table-card .dataTables_length,
.table-card .dataTables_filter {
  padding: 1rem 1rem;
  padding-bottom: 0px;
}
.table-card .dataTables_info,
.table-card .dataTables_paginate {
  padding: 1rem 1rem;
}
.table-card div.dataTables_wrapper .col-md-6 {
  width: 100%;
}
.table-card div.dataTables_wrapper div.dataTables_filter input {
  width: calc(100% - 52px);
}
.table-card div.dataTables_wrapper div.dataTables_filter label {
  display: block;
}

div.dtr-modal div.dtr-modal-display {
  background-color: var(--vz-secondary-bg);
  border-color: var(--vz-border-color);
  box-shadow: none;
  height: 70%;
}
div.dtr-modal div.dtr-modal-content {
  padding: 1.25rem;
}
div.dtr-modal div.dtr-modal-content h2, div.dtr-modal div.dtr-modal-content .h2 {
  font-size: 1.03125rem;
  font-weight: 500;
  margin-bottom: 15px;
}
div.dtr-modal div.dtr-modal-content .dtr-details tr td {
  padding: 0.75rem 0.6rem;
}
div.dtr-modal div.dtr-modal-close {
  font-size: 24px;
  top: 9px;
  right: 11px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  background-color: var(--vz-secondary-bg);
  border-color: var(--vz-border-color);
}
div.dtr-modal div.dtr-modal-close:hover {
  background-color: var(--vz-light);
}

.dt-buttons :is(button.dt-button, div.dt-button, a.dt-button, input.dt-button) {
  border-color: var(--vz-border-color);
  background: var(--vz-light);
  color: var(--vz-body-color);
}

:is(button, div, a, input):is(.dt-button:hover:not(.disabled)) {
  border-color: var(--vz-border-color);
  background: var(--vz-light);
  color: var(--vz-body-color);
}

:is(button, div, a, input):is(.dt-button:active:not(.disabled)),
:is(button, div, a, input):is(.dt-button.active:not(.disabled)) {
  border-color: var(--vz-border-color);
  background: var(--vz-light);
  color: var(--vz-body-color);
  box-shadow: none;
}

:is(button, div, a, input):is(.dt-button:focus:not(.disabled)) {
  border-color: var(--vz-border-color);
  background: var(--vz-light);
  color: var(--vz-body-color);
  text-shadow: none;
  box-shadow: none;
}

:is(button, div, a, input):is(.dt-button:active:not(.disabled):hover:not(.disabled)),
:is(button, div, a, input):is(.dt-button.active:not(.disabled):hover:not(.disabled)) {
  border-color: var(--vz-border-color);
  background: var(--vz-light);
  color: var(--vz-body-color);
  text-shadow: none;
  box-shadow: none;
}

.select2.select2-container {
  width: 100% !important;
}

.select2-container .select2-selection--single {
  border: var(--vz-border-width) solid var(--vz-input-border-custom);
  height: calc(1.5em + 1rem + calc( var(--vz-border-width) * 2 ));
  background-color: var(--vz-input-bg-custom);
  outline: none;
}
.select2-container .select2-selection--single .select2-selection__rendered {
  line-height: 36px;
  padding-left: 12px;
  color: var(--vz-body-color);
}
.select2-container .select2-selection--single .select2-selection__arrow {
  height: 34px;
  width: 34px;
  /*rtl:ignore*/
  right: 3px;
}
.select2-container .select2-selection--single .select2-selection__arrow b {
  border-color: var(--vz-input-border-custom) transparent transparent transparent;
  border-width: 6px 6px 0 6px;
}

.select2-container--open .select2-selection--single .select2-selection__arrow b {
  border-color: transparent transparent var(--vz-input-border-custom) transparent !important;
  border-width: 0 6px 6px 6px !important;
}

.select2-results__option {
  padding: 6px 12px;
}

.select2-dropdown {
  border: var(--vz-dropdown-border-width) solid var(--vz-border-color);
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  background-color: var(--vz-secondary-bg);
  z-index: 1056;
}

.select2-container--default .select2-results__option--selected {
  background-color: var(--vz-tertiary-bg);
}
.select2-container--default .select2-search--dropdown {
  padding: 10px;
  background-color: var(--vz-secondary-bg);
}
.select2-container--default .select2-search--dropdown .select2-search__field {
  outline: none;
  border: 1px solid var(--vz-input-border-custom);
  background-color: var(--vz-input-bg-custom);
  color: var(--vz-body-color);
  border-radius: var(--vz-border-radius);
}
.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #b4d0f0;
}
.select2-container--default .select2-results__option[aria-selected=true] {
  background-color: var(--vz-secondary-bg);
  color: var(--vz-dropdown-link-active-color);
}
.select2-container--default .select2-results__option[aria-selected=true]:hover {
  background-color: #b4d0f0;
  color: #fff;
}
.select2-container--default .select2-selection--multiple .select2-selection__choice__display {
  padding-left: 36px;
  padding-right: 5px;
}
.select2-container--default .select2-selection--single .select2-selection__arrow {
  /*rtl:ignore*/
  right: 1px;
  /*rtl:ignore*/
  left: auto;
}

.select2-container .select2-selection--multiple {
  min-height: calc(1.5em + 1rem + calc( var(--vz-border-width) * 2 ));
  border: var(--vz-border-width) solid var(--vz-input-border-custom) !important;
  background-color: var(--vz-input-bg-custom);
}
.select2-container .select2-selection--multiple .select2-selection__rendered {
  padding: 1px 4px;
}
.select2-container .select2-selection--multiple .select2-search__field {
  border: 0;
  color: var(--vz-body-color);
}
.select2-container .select2-selection--multiple .select2-selection__choice {
  background-color: #b4d0f0;
  border: none;
  color: #fff;
  border-radius: 3px;
  padding: 3px;
  margin-top: 6px;
}
.select2-container .select2-selection--multiple .select2-selection__choice__remove {
  color: #fff;
  margin-right: 7px;
  border-color: #bcd5f2;
  padding: 0 8px;
  top: 3px;
}
.select2-container .select2-selection--multiple .select2-selection__choice__remove:hover {
  color: #fff;
  background-color: #b4d0f0;
}
.select2-container .select2-search--inline .select2-search__field {
  margin-top: 7px;
  height: 22px;
  font-family: var(--vz-font-sans-serif);
}
.select2-container .select2-search textarea::placeholder {
  color: var(--vz-secondary-color);
}

.select2-container--default.select2-container--disabled .select2-selection--single, .select2-container--default.select2-container--disabled .select2-selection--multiple {
  background-color: var(--vz-tertiary-bg);
  cursor: default;
}

.toastify {
  padding: 12px 16px;
  color: #fff;
  display: inline-block;
  box-shadow: 0 3px 6px -1px rgba(0, 0, 0, 0.12), 0 10px 36px -4px rgba(77, 96, 232, 0.3);
  background: var(--vz-success);
  position: fixed;
  opacity: 0;
  transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
  border-radius: 2px;
  cursor: pointer;
  text-decoration: none;
  max-width: calc(50% - 20px);
  z-index: 2147483647;
}
.toastify.on {
  opacity: 1;
}

.toast-close {
  opacity: 0.4;
  padding: 0 5px;
  position: relative;
  left: 4px;
  margin-left: 4px;
  border: none;
  background: none;
  color: #fff;
}

.toastify-right {
  right: 15px;
}

.toastify-left {
  left: 15px;
}
.toastify-left .toast-close {
  left: -4px;
  margin-left: 0;
  margin-right: 4px;
}

.toastify-top {
  top: -150px;
}

.toastify-bottom {
  bottom: -150px;
}

.toastify-rounded {
  border-radius: 25px;
}

.toastify-avatar {
  width: 1.5em;
  height: 1.5em;
  margin: -7px 5px;
  border-radius: 2px;
}

.toastify-center {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  max-width: fit-content;
  max-width: -moz-fit-content;
}

@media only screen and (max-width: 360px) {
  .toastify-right, .toastify-left {
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    max-width: fit-content;
  }
}
.choices {
  position: relative;
  margin-bottom: 24px;
  font-size: 16px;
}
.choices:focus {
  outline: none;
}
.choices:last-child {
  margin-bottom: 0;
}
.choices.is-disabled .choices__inner,
.choices.is-disabled .choices__input {
  background-color: rgba(var(--vz-light-rgb), 0.75);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
.choices.is-disabled .choices__item {
  cursor: not-allowed;
}
.choices [hidden] {
  display: none !important;
}
.choices[data-type*=select-one] {
  cursor: pointer;
}
.choices[data-type*=select-one] .choices__inner {
  padding-bottom: 0.25rem;
}
.choices[data-type*=select-one] .choices__input {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem;
  background-color: var(--vz-input-bg-custom);
  border: 1px solid var(--vz-input-border-custom);
  font-size: 0.825rem;
  border-radius: var(--vz-border-radius);
  color: var(--vz-body-color);
  margin-bottom: 10px;
}
.choices[data-type*=select-one] .choices__button {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
  padding: 0;
  background-size: 8px;
  position: absolute;
  top: 50%;
  right: 0;
  left: auto;
  margin-top: -10px;
  margin-right: 25px;
  margin-left: 0;
  height: 20px;
  width: 20px;
  border-radius: 10em;
  opacity: 0.5;
}
.choices[data-type*=select-one] .choices__button:hover, .choices[data-type*=select-one] .choices__button:focus {
  opacity: 1;
}
.choices[data-type*=select-one] .choices__button:focus {
  box-shadow: 0px 0px 0px 2px #00bcd4;
}
.choices[data-type*=select-one] .choices__item[data-value=""] .choices__button {
  display: none;
}
.choices[data-type*=select-one]:after {
  content: "󰅀";
  position: absolute;
  border: 0;
  border-color: #363d48 transparent transparent;
  right: 11.5px;
  left: auto;
  font-family: "Material Design Icons";
  width: auto;
  height: auto;
  margin-top: 0;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}
.choices[data-type*=select-one].is-open:after {
  margin-top: 0;
  transform: translateY(-50%) rotate(-180deg);
}
.choices[data-type*=select-multiple] .choices__inner, .choices[data-type*=text] .choices__inner {
  cursor: text;
  padding-right: 0.9rem;
}
.choices[data-type*=select-multiple] .choices__button, .choices[data-type*=text] .choices__button {
  position: relative;
  display: inline-block;
  margin-top: 0;
  margin-right: -4px;
  margin-bottom: 0;
  margin-left: 8px;
  padding-left: 16px;
  border-left: 1px solid rgba(255, 255, 255, 0.5);
  border-right: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
  background-size: 8px;
  width: 8px;
  line-height: 1;
  opacity: 0.75;
  border-radius: 0;
}
.choices[data-type*=select-multiple] .choices__button:hover, .choices[data-type*=select-multiple] .choices__button:focus, .choices[data-type*=text] .choices__button:hover, .choices[data-type*=text] .choices__button:focus {
  opacity: 1;
}
.choices[data-type*=select-multiple] .choices__list--dropdown, .choices[data-type*=text] .choices__list--dropdown {
  padding-bottom: 10px;
}
.choices[data-type*=select-multiple] .choices__list--dropdown .choices__list, .choices[data-type*=text] .choices__list--dropdown .choices__list {
  margin-bottom: 0;
}
.choices[data-type*=select-multiple] .choices__input {
  padding-top: 3px;
}

.input-light .choices__inner {
  background-color: var(--vz-light);
  border: none;
}

.choices__inner {
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  background-color: var(--vz-input-bg-custom);
  padding: 0.25rem calc(0.9rem + 2.25rem) 0.1rem 0.5rem;
  border: var(--vz-border-width) solid var(--vz-input-border-custom);
  border-radius: var(--vz-border-radius) !important;
  font-size: 0.825rem;
  min-height: 37.5px;
  overflow: hidden;
}

.is-focused .choices__inner,
.is-open .choices__inner {
  border-color: var(--vz-primary-border-subtle);
}

.choices__list {
  margin: 0;
  padding-left: 0;
  list-style: none;
}

.choices__list--single {
  display: inline-block;
  padding: 4px 16px 4px 4px;
  width: 100%;
}
.choices__list--single .choices__item {
  width: 100%;
}

.choices__list--multiple {
  display: inline;
}
.choices__list--multiple .choices__item {
  display: inline-block;
  vertical-align: initial;
  border-radius: 7px;
  padding: 2px 7px;
  font-size: 11px;
  font-weight: 400;
  margin-right: 3.75px;
  margin-bottom: 3.75px;
  margin-top: 2px;
  background-color: #b4d0f0;
  border: 1px solid #b4d0f0;
  word-break: break-all;
  box-sizing: border-box;
  color: #fff;
  box-shadow: none;
}
.choices__list--multiple .choices__item[data-deletable] {
  padding-right: 5px;
}
.choices__list--multiple .choices__item.is-highlighted {
  background-color: #b4d0f0;
  border: 1px solid #b4d0f0;
}

.is-disabled .choices__list--multiple .choices__item {
  background-color: #daecfb;
  border: 1px solid #daecfb;
}

.choices__list--dropdown {
  visibility: hidden;
  z-index: 1;
  position: absolute;
  width: 100%;
  background-color: var(--vz-secondary-bg);
  border: 1px solid var(--vz-border-color);
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  top: 100%;
  margin-top: 0;
  padding: 10px 10px 20px 10px;
  border-bottom-left-radius: 2.5px;
  border-bottom-right-radius: 2.5px;
  overflow: hidden;
  word-break: break-all;
  will-change: visibility;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  transform: translateY(1px);
}
.choices__list--dropdown.is-active {
  visibility: visible;
  animation-name: DropDownSlide;
}
.choices__list--dropdown .choices__item--selectable.is-highlighted {
  background-color: var(--vz-tertiary-bg);
}
.choices__list--dropdown .choices__list {
  margin: 0 -16px -16px;
}
.choices__list--dropdown .has-no-results {
  font-style: italic;
  font-weight: 400;
}
.choices__list--dropdown .choices__item--selectable:after {
  display: none;
}

.is-open .choices__list--dropdown {
  border-color: var(--vz-border-color);
}

.is-flipped .choices__list--dropdown {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: -1px;
  border-radius: 0.25rem 0.25rem 0 0;
}
.is-flipped .choices__list--dropdown.is-active {
  animation-name: DropDownSlideDown;
  transform: translateY(-1px);
}

.choices__list--dropdown .choices__list {
  position: relative;
  max-height: 300px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  will-change: scroll-position;
}
.choices__list--dropdown .choices__item {
  position: relative;
  font-size: 0.825rem;
  padding: 0.35rem 1.2rem 0.35rem 16px;
}

@media (min-width: 640px) {
  .choices__list--dropdown .choices__item--selectable:after {
    content: attr(data-select-text);
    font-size: 12px;
    opacity: 0;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
  .choices__list--dropdown .choices__item--selectable.is-highlighted:after {
    opacity: 0.5;
  }
}
.choices__item {
  cursor: default;
}

.choices__item--selectable {
  cursor: pointer;
}

.choices__item--disabled {
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
  opacity: 0.5;
}

.choices__heading {
  font-weight: 500;
  font-size: 12px;
  padding: 10px 16px;
  border-bottom: 1px solid var(--vz-border-color);
  color: var(--vz-secondary-color);
}

.choices__button {
  text-indent: -9999px;
  appearance: none;
  border: 0;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
}
.choices__button:focus {
  outline: none;
}

.choices__input {
  display: inline-block;
  vertical-align: baseline;
  background-color: var(--vz-input-bg-custom);
  color: var(--vz-body-color);
  font-size: 0.825rem;
  margin-bottom: 0;
  border: 0;
  border-radius: 0;
  max-width: 100%;
  padding: 2px 0 2px 2px;
}
.choices__input:focus {
  outline: 0;
}
.choices__input::placeholder {
  color: var(--vz-secondary-color);
}

.choices__placeholder {
  color: var(--vz-secondary-color);
  opacity: 1;
}

[data-bs-theme=dark] .choices[data-type*=select-one] .choices__button {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.flatpickr-calendar {
  background: transparent;
  opacity: 0;
  display: none;
  text-align: center;
  visibility: hidden;
  padding: 0;
  animation: none;
  direction: ltr;
  border: 0;
  font-size: 14px;
  line-height: 24px;
  border-radius: 5px;
  position: absolute;
  width: 307.875px;
  box-sizing: border-box;
  touch-action: manipulation;
  background: var(--vz-secondary-bg);
  box-shadow: 1px 0 0 var(--vz-border-color), -1px 0 0 var(--vz-border-color), 0 1px 0 var(--vz-border-color), 0 -1px 0 var(--vz-border-color), 0 3px 13px rgba(0, 0, 0, 0.08);
}
.flatpickr-calendar.open, .flatpickr-calendar.inline {
  opacity: 1;
  max-height: 640px;
  visibility: visible;
}
.flatpickr-calendar.open {
  display: inline-block;
  z-index: 1056;
}
.flatpickr-calendar.animate.open {
  animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);
}
.flatpickr-calendar.inline {
  display: block;
  position: relative;
  top: 2px;
  width: 100%;
  box-shadow: none;
}
.flatpickr-calendar.inline .flatpickr-rContainer {
  display: block;
  width: 100%;
}
.flatpickr-calendar.inline .flatpickr-rContainer .flatpickr-days {
  width: 100%;
  border: var(--vz-border-width) solid var(--vz-input-border-custom);
  border-top: none;
  border-radius: 0 0 5px 5px;
}
.flatpickr-calendar.inline .flatpickr-rContainer .flatpickr-days .dayContainer {
  width: 100%;
  min-width: 100%;
  max-width: 100%;
}
.flatpickr-calendar.inline .flatpickr-rContainer .flatpickr-days .dayContainer .flatpickr-day {
  max-width: 100%;
  border-radius: 4px;
}
.flatpickr-calendar.inline .flatpickr-time {
  border: var(--vz-border-width) solid var(--vz-input-border-custom) !important;
  border-radius: var(--vz-border-radius);
}
.flatpickr-calendar.static {
  position: absolute;
  top: calc(100% + 2px);
}
.flatpickr-calendar.static.open {
  z-index: 999;
  display: block;
}
.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7) {
  box-shadow: none !important;
}
.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1) {
  box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;
}
.flatpickr-calendar .hasWeeks .dayContainer,
.flatpickr-calendar .hasTime .dayContainer {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.flatpickr-calendar .hasWeeks .dayContainer {
  border-left: 0;
}
.flatpickr-calendar.hasTime .flatpickr-time {
  height: 40px;
  border-top: 1px solid var(--vz-border-color);
}
.flatpickr-calendar.noCalendar.hasTime .flatpickr-time {
  height: auto;
}
.flatpickr-calendar::before, .flatpickr-calendar::after {
  position: absolute;
  display: block;
  pointer-events: none;
  border: solid transparent;
  content: "";
  height: 0;
  width: 0;
  left: 22px;
}
.flatpickr-calendar.rightMost::before, .flatpickr-calendar.arrowRight::before, .flatpickr-calendar.rightMost::after, .flatpickr-calendar.arrowRight::after {
  left: auto;
  right: 22px;
}
.flatpickr-calendar.arrowCenter::before, .flatpickr-calendar.arrowCenter::after {
  left: 50%;
  right: 50%;
}
.flatpickr-calendar::before {
  border-width: 5px;
  margin: 0 -5px;
}
.flatpickr-calendar::after {
  border-width: 4px;
  margin: 0 -4px;
}
.flatpickr-calendar.arrowTop::before, .flatpickr-calendar.arrowTop::after {
  bottom: 100%;
}
.flatpickr-calendar.arrowTop::before {
  border-bottom-color: #b4d0f0;
}
.flatpickr-calendar.arrowTop::after {
  border-bottom-color: #b4d0f0;
}
.flatpickr-calendar.arrowBottom::before, .flatpickr-calendar.arrowBottom::after {
  top: 100%;
}
.flatpickr-calendar.arrowBottom::before {
  border-top-color: #b4d0f0;
}
.flatpickr-calendar.arrowBottom::after {
  border-top-color: #b4d0f0;
}
.flatpickr-calendar:focus {
  outline: 0;
}

.flatpickr-wrapper {
  position: relative;
  display: inline-block;
}

.flatpickr-months {
  display: flex;
  background-color: #b4d0f0;
  border-radius: 5px 5px 0px 0px;
}
.flatpickr-months .flatpickr-month {
  background: transparent;
  color: rgba(255, 255, 255, 0.9);
  fill: rgba(255, 255, 255, 0.9);
  height: 34px;
  line-height: 1;
  text-align: center;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
  overflow: hidden;
  flex: 1 1;
}
.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  text-decoration: none;
  cursor: pointer;
  position: absolute;
  top: 0;
  height: 34px;
  padding: 10px;
  z-index: 3;
  color: rgba(255, 255, 255, 0.9);
  fill: rgba(255, 255, 255, 0.9);
  /*
  /*rtl:begin:ignore*/
  /*
  /*rtl:end:ignore*/
  /*
  /*rtl:begin:ignore*/
  /*
  /*rtl:end:ignore*/
}
.flatpickr-months .flatpickr-prev-month.flatpickr-disabled,
.flatpickr-months .flatpickr-next-month.flatpickr-disabled {
  display: none;
}
.flatpickr-months .flatpickr-prev-month i,
.flatpickr-months .flatpickr-next-month i {
  position: relative;
}
.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month.flatpickr-prev-month {
  /*
        /*rtl:begin:ignore*/
  /*
        */
  left: 0;
  /*
        /*rtl:end:ignore*/
  /*
        */
}
.flatpickr-months .flatpickr-prev-month.flatpickr-next-month,
.flatpickr-months .flatpickr-next-month.flatpickr-next-month {
  /*
        /*rtl:begin:ignore*/
  /*
        */
  right: 0;
  /*
        /*rtl:end:ignore*/
  /*
        */
}
.flatpickr-months .flatpickr-prev-month:hover,
.flatpickr-months .flatpickr-next-month:hover {
  color: #959ea9;
}
.flatpickr-months .flatpickr-prev-month:hover svg,
.flatpickr-months .flatpickr-next-month:hover svg {
  fill: rgba(255, 255, 255, 0.9);
}
.flatpickr-months .flatpickr-prev-month svg,
.flatpickr-months .flatpickr-next-month svg {
  width: 14px;
  height: 14px;
}
.flatpickr-months .flatpickr-prev-month svg path,
.flatpickr-months .flatpickr-next-month svg path {
  transition: fill 0.1s;
  fill: inherit;
}

.numInputWrapper {
  position: relative;
  height: auto;
}
.numInputWrapper input,
.numInputWrapper span {
  display: inline-block;
}
.numInputWrapper input {
  width: 100%;
}
.numInputWrapper input::-ms-clear {
  display: none;
}
.numInputWrapper input::-webkit-outer-spin-button, .numInputWrapper input::-webkit-inner-spin-button {
  margin: 0;
  -webkit-appearance: none;
}
.numInputWrapper span {
  position: absolute;
  right: 0;
  width: 14px;
  padding: 0 4px 0 2px;
  height: 50%;
  line-height: 50%;
  opacity: 0;
  cursor: pointer;
  border: 1px solid rgba(var(--vz-dark-rgb), 0.15);
  box-sizing: border-box;
}
.numInputWrapper span:hover {
  background: rgba(0, 0, 0, 0.1);
}
.numInputWrapper span:active {
  background: rgba(0, 0, 0, 0.2);
}
.numInputWrapper span:after {
  display: block;
  content: "";
  position: absolute;
}
.numInputWrapper span.arrowUp {
  top: 0;
  border-bottom: 0;
}
.numInputWrapper span.arrowUp:after {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid rgba(57, 57, 57, 0.6);
  top: 26%;
}
.numInputWrapper span.arrowDown {
  top: 50%;
}
.numInputWrapper span.arrowDown:after {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid rgba(57, 57, 57, 0.6);
  top: 40%;
}
.numInputWrapper span svg {
  width: inherit;
  height: auto;
}
.numInputWrapper span svg path {
  fill: rgba(0, 0, 0, 0.5);
}
.numInputWrapper:hover {
  background: rgba(0, 0, 0, 0.05);
}
.numInputWrapper:hover span {
  opacity: 1;
}

.flatpickr-current-month {
  font-size: 100%;
  line-height: inherit;
  font-weight: 300;
  color: inherit;
  position: absolute;
  width: 75%;
  left: 12.5%;
  padding: 7.48px 0 0 0;
  line-height: 1;
  height: 34px;
  display: inline-block;
  text-align: center;
  transform: translate3d(0px, 0px, 0px);
}
.flatpickr-current-month span.cur-month {
  font-family: inherit;
  font-weight: 700;
  color: inherit;
  display: inline-block;
  margin-left: 0.5ch;
  padding: 0;
}
.flatpickr-current-month span.cur-month:hover {
  background: rgba(0, 0, 0, 0.05);
}
.flatpickr-current-month .numInputWrapper {
  width: 6ch;
  width: 7ch\\0 ;
  display: inline-block;
}
.flatpickr-current-month span.arrowUp::after {
  border-bottom-color: rgba(0, 0, 0, 0.9);
}
.flatpickr-current-month span.arrowDown:after {
  border-top-color: rgba(0, 0, 0, 0.9);
}
.flatpickr-current-month input.cur-year {
  background: transparent;
  box-sizing: border-box;
  color: inherit;
  cursor: text;
  padding: 0 0 0 0.5ch;
  margin: 0;
  display: inline-block;
  font-size: inherit;
  font-family: inherit;
  font-weight: 500;
  line-height: inherit;
  height: auto;
  border: 0;
  border-radius: 0;
  vertical-align: initial;
  appearance: textfield;
}
.flatpickr-current-month input.cur-year:focus {
  outline: 0;
}
.flatpickr-current-month input.cur-year[disabled], .flatpickr-current-month input.cur-year[disabled]:hover {
  font-size: 100%;
  color: rgba(255, 255, 255, 0.9);
  background: transparent;
  pointer-events: none;
}
.flatpickr-current-month .flatpickr-monthDropdown-months {
  appearance: menulist;
  background: transparent;
  border: none;
  border-radius: 0;
  box-sizing: border-box;
  color: inherit;
  cursor: pointer;
  font-size: inherit;
  font-family: inherit;
  font-weight: 500;
  height: auto;
  line-height: inherit;
  margin: -1px 0 0 0;
  outline: none;
  padding: 0 0 0 0.5ch;
  position: relative;
  vertical-align: initial;
  width: auto;
}
.flatpickr-current-month .flatpickr-monthDropdown-months:focus, .flatpickr-current-month .flatpickr-monthDropdown-months:active {
  outline: none;
}
.flatpickr-current-month .flatpickr-monthDropdown-months:hover {
  background-color: transparent;
}
.flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {
  background-color: transparent;
  outline: none;
  padding: 0;
  color: rgba(0, 0, 0, 0.8);
}

.flatpickr-weekdays {
  background-color: #b4d0f0;
  text-align: center;
  overflow: hidden;
  width: 100%;
  display: flex;
  align-items: center;
  height: 36px;
  border-bottom: 1px solid var(--vz-border-color);
}
.flatpickr-weekdays .flatpickr-weekdaycontainer {
  display: flex;
  flex: 1 1;
}

span.flatpickr-weekday {
  cursor: default;
  font-size: 90%;
  background: #b4d0f0;
  color: #fff;
  line-height: 1;
  margin: 0;
  text-align: center;
  display: block;
  flex: 1 1;
  font-weight: 400;
}

.dayContainer,
.flatpickr-weeks {
  padding: 1px 0 0 0;
}

.flatpickr-days {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  width: 307.875px;
}
.flatpickr-days:focus {
  outline: 0;
}

.dayContainer {
  padding: 0;
  outline: 0;
  text-align: left;
  width: 307.875px;
  min-width: 307.875px;
  max-width: 307.875px;
  box-sizing: border-box;
  display: inline-block;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  transform: translate3d(0px, 0px, 0px);
  opacity: 1;
}
.dayContainer + .dayContainer {
  box-shadow: -1px 0 0 #e6e6e6;
}

.flatpickr-day {
  background: none;
  border: 1px solid transparent;
  border-radius: 150px;
  box-sizing: border-box;
  color: var(--vz-body-color);
  cursor: pointer;
  font-weight: 400;
  width: 14.2857143%;
  flex-basis: 14.2857143%;
  max-width: 39px;
  height: 39px;
  line-height: 39px;
  margin: 0;
  display: inline-block;
  position: relative;
  justify-content: center;
  text-align: center;
}
.flatpickr-day:hover, .flatpickr-day:focus {
  background-color: rgba(var(--vz-light-rgb), 0.7);
}
.flatpickr-day.inRange, .flatpickr-day.prevMonthDay.inRange, .flatpickr-day.nextMonthDay.inRange, .flatpickr-day.today.inRange, .flatpickr-day.prevMonthDay.today.inRange, .flatpickr-day.nextMonthDay.today.inRange, .flatpickr-day:hover, .flatpickr-day.prevMonthDay:hover, .flatpickr-day.nextMonthDay:hover, .flatpickr-day:focus, .flatpickr-day.prevMonthDay:focus, .flatpickr-day.nextMonthDay:focus {
  cursor: pointer;
  outline: 0;
  background-color: var(--vz-light);
  border-color: var(--vz-light);
}
.flatpickr-day.today {
  border-color: #b4d0f0;
  background-color: rgba(180, 208, 240, 0.1);
  box-shadow: none;
}
.flatpickr-day.today:hover, .flatpickr-day.today:focus {
  border-color: #b4d0f0;
  background-color: rgba(180, 208, 240, 0.15);
  color: var(--vz-body-color);
}
.flatpickr-day.selected, .flatpickr-day.startRange, .flatpickr-day.endRange, .flatpickr-day.selected.inRange, .flatpickr-day.startRange.inRange, .flatpickr-day.endRange.inRange, .flatpickr-day.selected:focus, .flatpickr-day.startRange:focus, .flatpickr-day.endRange:focus, .flatpickr-day.selected:hover, .flatpickr-day.startRange:hover, .flatpickr-day.endRange:hover, .flatpickr-day.selected.prevMonthDay, .flatpickr-day.startRange.prevMonthDay, .flatpickr-day.endRange.prevMonthDay, .flatpickr-day.selected.nextMonthDay, .flatpickr-day.startRange.nextMonthDay, .flatpickr-day.endRange.nextMonthDay {
  background: #b4d0f0;
  box-shadow: none;
  color: #fff;
  border-color: #b4d0f0;
}
.flatpickr-day.selected.startRange, .flatpickr-day.startRange.startRange, .flatpickr-day.endRange.startRange {
  border-radius: 50px 0 0 50px;
}
.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
  box-shadow: -10px 0 0 #b4d0f0;
}
.flatpickr-day.selected.startRange .endRange, .flatpickr-day.startRange.startRange .endRange, .flatpickr-day.endRange.startRange .endRange {
  border-radius: 50px;
}
.flatpickr-day.selected.endRange, .flatpickr-day.startRange.endRange, .flatpickr-day.endRange.endRange {
  border-radius: 0 50px 50px 0;
}
.flatpickr-day.inRange {
  border-radius: 0;
  box-shadow: -5px 0 0 var(--vz-light), 5px 0 0 var(--vz-light);
}
.flatpickr-day.flatpickr-disabled, .flatpickr-day.flatpickr-disabled:hover, .flatpickr-day.prevMonthDay, .flatpickr-day.nextMonthDay, .flatpickr-day.notAllowed, .flatpickr-day.notAllowed.prevMonthDay, .flatpickr-day.notAllowed.nextMonthDay {
  color: rgba(var(--vz-body-color-rgb), 0.3);
  background: transparent;
  border-color: transparent;
  cursor: default;
}
.flatpickr-day.flatpickr-disabled, .flatpickr-day.flatpickr-disabled:hover {
  cursor: not-allowed;
  color: rgba(var(--vz-body-color-rgb), 0.3);
}
.flatpickr-day.week.selected {
  border-radius: 0;
  box-shadow: -5px 0 0 #b4d0f0, 5px 0 0 #b4d0f0;
}
.flatpickr-day.hidden {
  visibility: hidden;
}

.rangeMode .flatpickr-day {
  margin-top: 1px;
}

.flatpickr-weekwrapper {
  float: left;
}
.flatpickr-weekwrapper .flatpickr-weeks {
  padding: 0 12px;
  box-shadow: 1px 0 0 var(--vz-border-color);
}
.flatpickr-weekwrapper .flatpickr-weekday {
  float: none;
  width: 100%;
  line-height: 35px;
}
.flatpickr-weekwrapper span.flatpickr-day, .flatpickr-weekwrapper span.flatpickr-day:hover {
  display: block;
  width: 100%;
  max-width: none;
  color: rgba(var(--vz-body-rgb), 0.3);
  background: transparent;
  cursor: default;
  border: none;
}

.flatpickr-innerContainer {
  display: block;
  display: flex;
  box-sizing: border-box;
  overflow: hidden;
}

.flatpickr-rContainer {
  display: inline-block;
  padding: 0;
  box-sizing: border-box;
}

.flatpickr-time {
  text-align: center;
  outline: 0;
  display: block;
  height: 0;
  line-height: 40px;
  max-height: 40px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
}
.flatpickr-time:after {
  content: "";
  display: table;
  clear: both;
}
.flatpickr-time .numInputWrapper {
  flex: 1 1;
  width: 40%;
  height: 40px;
  float: left;
}
.flatpickr-time .numInputWrapper span.arrowUp:after, .flatpickr-time .numInputWrapper span.arrowDown:after {
  border-bottom-color: var(--vz-border-color);
}
.flatpickr-time.hasSeconds .numInputWrapper {
  width: 26%;
}
.flatpickr-time.time24hr .numInputWrapper {
  width: 49%;
}
.flatpickr-time input {
  background: transparent;
  box-shadow: none;
  border: 0;
  border-radius: 0;
  text-align: center;
  margin: 0;
  padding: 0;
  height: inherit;
  line-height: inherit;
  color: var(--vz-body-color);
  font-size: 14px;
  position: relative;
  box-sizing: border-box;
  appearance: textfield;
}
.flatpickr-time input.flatpickr-hour {
  font-weight: bold;
}
.flatpickr-time input.flatpickr-minute, .flatpickr-time input.flatpickr-second {
  font-weight: 400;
}
.flatpickr-time input:focus {
  outline: 0;
  border: 0;
}
.flatpickr-time .flatpickr-time-separator,
.flatpickr-time .flatpickr-am-pm {
  height: inherit;
  float: left;
  line-height: inherit;
  color: var(--vz-body-color);
  font-weight: bold;
  width: 2%;
  -webkit-user-select: none;
          user-select: none;
  align-self: center;
}
.flatpickr-time .flatpickr-am-pm {
  outline: 0;
  width: 18%;
  cursor: pointer;
  text-align: center;
  font-weight: 400;
}
.flatpickr-time input:hover, .flatpickr-time input:focus, .flatpickr-time .flatpickr-am-pm:hover, .flatpickr-time .flatpickr-am-pm:focus {
  background: rgba(180, 208, 240, 0.04);
}

.flatpickr-am-pm:focus, .flatpickr-am-pm:hover,
.numInput:focus,
.numInput:hover,
.numInputWrapper:focus,
.numInputWrapper:hover {
  background-color: transparent;
}

.flatpickr-input[readonly] {
  cursor: pointer;
  background-color: var(--vz-input-bg-custom);
}

[data-inline-date=true], [data-time-inline] {
  display: none;
}

@keyframes fpFadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -20px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
[datepicker-inline],
[timepicker-inline] {
  display: none;
}

[data-input-flag] {
  position: relative;
}
[data-input-flag] .dropdown-menu .dropdown-menu-list {
  max-height: 158px;
  overflow-y: auto;
}
[data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar {
  -webkit-appearance: none;
}
[data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar:vertical {
  width: 8px;
}
[data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar:horizontal {
  height: 10px;
}
[data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar-thumb {
  background-color: rgba(var(--vz-dark-rgb), 0.075);
  border-radius: 8px;
}
[data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar-track {
  border-radius: 8px;
}

[data-option-flag-img-name] .flag-input {
  padding-left: 45px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_69___});
  background-repeat: no-repeat;
  background-position: 14px 8px;
  background-size: 18px;
}

[data-option-flag-name]::before,
[data-option-flag-img-name]::before {
  content: "󰅀";
  font-family: "Material Design Icons";
  position: absolute;
  right: 0.9rem;
  top: 0.5rem;
  font-size: 16px;
}

[data-option-countrycode=false] .country-codeno {
  display: none;
}

[data-search-input=false] .searchlist-input {
  display: none;
}

.auth-page-wrapper .auth-page-content {
  padding-bottom: 60px;
  position: relative;
  z-index: 2;
  width: 100%;
}
.auth-page-wrapper .footer {
  left: 0;
  background-color: transparent;
  color: var(--vz-body-color);
}

.auth-one-bg-position {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 380px;
}
@media (max-width: 575.98px) {
  .auth-one-bg-position {
    height: 280px;
  }
}

.auth-one-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_70___});
  background-position: center;
  background-size: cover;
}
.auth-one-bg .bg-overlay {
  background: linear-gradient(to right, #364574, #405189);
  opacity: 0.9;
}

.shape {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1;
  pointer-events: none;
}
.shape > svg {
  width: 100%;
  height: auto;
  fill: var(--vz-body-bg);
}

.auth-pass-inputgroup input[type=text] + .btn .ri-eye-fill:before {
  content: "";
}

.particles-js-canvas-el {
  position: relative;
}

.signin-other-title {
  position: relative;
}
.signin-other-title:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  right: 0;
  border-top: 1px dashed var(--vz-border-color);
  top: 10px;
}
.signin-other-title .title {
  display: inline-block;
  position: relative;
  z-index: 9;
  background-color: var(--vz-secondary-bg);
  padding: 2px 16px;
}

.auth-bg-cover {
  background: linear-gradient(-45deg, #b4d0f0 50%, #13c56b);
}
.auth-bg-cover > .bg-overlay {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_71___});
  background-position: center;
  background-size: cover;
  opacity: 1;
  background-color: transparent;
}
.auth-bg-cover .footer {
  color: rgba(255, 255, 255, 0.5);
}

#password-contain {
  display: none;
}
#password-contain p {
  padding-left: 13px;
}
#password-contain p.valid {
  color: #13c56b;
}
#password-contain p.valid::before {
  position: relative;
  left: -8px;
  content: "✔";
}
#password-contain p.invalid {
  color: #ed5e5e;
}
#password-contain p.invalid::before {
  position: relative;
  left: -8px;
  content: "✖";
}

.dash-filter-picker {
  min-width: 210px !important;
}

.upcoming-scheduled {
  position: relative;
}
@media (max-width: 575.98px) {
  .upcoming-scheduled {
    top: 35px !important;
  }
}
.upcoming-scheduled .flatpickr-months {
  position: absolute !important;
  top: -45px !important;
  left: auto !important;
  right: 0px !important;
  width: 200px;
  background-color: transparent;
}
.upcoming-scheduled .flatpickr-months .flatpickr-month {
  color: #878a99 !important;
  fill: #878a99 !important;
}
.upcoming-scheduled .flatpickr-months .flatpickr-prev-month, .upcoming-scheduled .flatpickr-months .flatpickr-next-month {
  display: none;
}
.upcoming-scheduled .flatpickr-calendar {
  box-shadow: none !important;
}
.upcoming-scheduled .flatpickr-calendar .flatpickr-current-month {
  font-size: 13px;
  width: 100%;
  left: 0;
}
.upcoming-scheduled .flatpickr-calendar .flatpickr-monthDropdown-months {
  border: 1px solid var(--vz-border-color);
  border-radius: 4px;
  height: 26px;
}
.upcoming-scheduled .flatpickr-calendar .flatpickr-weekdays {
  background-color: var(--vz-light);
  border: none;
}
.upcoming-scheduled .flatpickr-calendar .flatpickr-weekdays span.flatpickr-weekday {
  color: var(--vz-body-color);
  background-color: var(--vz-light);
}
.upcoming-scheduled .flatpickr-calendar .flatpickr-day.today {
  color: #fff !important;
  background-color: #13c56b;
  border-color: #13c56b !important;
}
.upcoming-scheduled .flatpickr-calendar .flatpickr-day.today:hover {
  color: #13c56b !important;
  background-color: rgba(19, 197, 107, 0.2) !important;
}
.upcoming-scheduled .flatpickr-calendar .flatpickr-day.selected {
  background-color: #13c56b !important;
  border-color: #13c56b !important;
  color: #fff;
}
.upcoming-scheduled .flatpickr-calendar .numInputWrapper {
  width: 7.5ch;
  margin-left: 10px;
}
.upcoming-scheduled .flatpickr-days {
  border: none !important;
}

.crm-widget .col {
  border-right: 1px solid var(--vz-border-color);
}
.crm-widget .col:last-child {
  border: 0px;
}
@media (min-width: 768px) and (max-width: 1399.98px) {
  .crm-widget .col:nth-child(3) {
    border-right: 0px;
  }
  .crm-widget .col:last-child {
    border-right: 1px solid var(--vz-border-color);
  }
}
@media (max-width: 767.98px) {
  .crm-widget .col {
    border-right: 0px;
    border-bottom: 1px solid var(--vz-border-color);
  }
}

@media (min-width: 1400px) and (max-width: 1599.98px) {
  .project-wrapper > .col-xxl-8, .project-wrapper .col-xxl-4 {
    width: 100%;
  }
}
.crypto-widget {
  max-width: 130px !important;
}

.bg-marketplace {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_72___});
  background-size: cover;
}

.dash-countdown .countdownlist .count-num {
  background-color: var(--vz-secondary-bg);
  padding: 16px 8px;
  font-size: 22px;
}
@media (max-width: 575.98px) {
  .dash-countdown .countdownlist .count-num {
    font-size: 16px;
    padding: 8px 6px;
  }
}
@media (max-width: 575.98px) {
  .dash-countdown .countdownlist .count-title {
    font-size: 10px;
  }
}

[data-layout-width=boxed] .dash-countdown .countdownlist {
  flex-wrap: wrap;
}

.marketplace-icon {
  position: absolute;
  float: right;
  top: 30px;
  left: 30px;
}

.marketplace-swiper .swiper-button-next,
.marketplace-swiper .swiper-button-prev {
  top: 34px;
  width: 28px;
  height: 28px;
  background-color: rgba(180, 208, 240, 0.1);
  color: #b4d0f0;
  border-radius: 0.3rem;
  right: 16px !important;
}
.marketplace-swiper .swiper-button-prev {
  right: 58px !important;
  left: auto !important;
}

.dash-collection .content {
  background-color: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(5px);
}

@media (max-width: 1441.98px) {
  .dash-nft .col-xxl-9, .dash-nft .col-xxl-3 {
    width: 100% !important;
    max-width: 100% !important;
  }
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {
  width: 32px;
  height: 32px;
  display: inline-block;
  vertical-align: middle;
}

#portfolio_donut_charts .apexcharts-pie text {
  fill: var(--vz-body-color);
}

.timeline {
  position: relative;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}
.timeline::after {
  content: "";
  position: absolute;
  width: 2px;
  background: var(--vz-secondary-bg);
  top: 57px;
  bottom: 166px;
  left: 50%;
  margin-left: -1.5px;
}

.timeline-item {
  padding: 30px 60px;
  position: relative;
  background: inherit;
  width: 50%;
}
.timeline-item .icon {
  position: absolute;
  display: inline-flex;
  width: 60px;
  height: 60px;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  top: 30px;
  right: -30px;
  padding: 9px 0;
  background: var(--vz-secondary-bg);
  border: 1px solid var(--vz-border-color);
  border-radius: 50px;
  color: #13c56b;
  z-index: 1;
}
.timeline-item .date {
  position: absolute;
  display: inline-block;
  width: calc(100% - 48px);
  top: 50px;
  font-size: 14px;
  font-weight: 500;
  font-style: italic;
}
.timeline-item .content {
  padding: 20px;
  background: var(--vz-secondary-bg);
  position: relative;
  border: 1px solid var(--vz-border-color);
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}
.timeline-item.left {
  left: 0;
}
.timeline-item.left .date {
  left: calc(100% + 48px);
  text-align: start;
}
.timeline-item.right {
  left: 50%;
}
.timeline-item.right .icon {
  left: -30px;
}
.timeline-item.right .date {
  right: calc(100% + 48px);
  text-align: end;
}
.timeline-item.right::before {
  left: 28px;
  border-color: transparent transparent transparent #fff;
}

@media (max-width: 991.98px) {
  .timeline::after {
    left: 24px;
    bottom: 180px;
  }

  .timeline-item {
    width: 100%;
    padding-left: 48px;
    padding-right: 0px;
  }
  .timeline-item.right, .timeline-item.left {
    left: 0%;
  }
  .timeline-item.right .icon, .timeline-item.left .icon {
    width: 45px;
    height: 45px;
    top: 0;
    font-size: 18px;
    left: 0;
  }
  .timeline-item.right::before, .timeline-item.left::before {
    left: 110px;
    border-color: transparent transparent transparent var(--vz-border-color);
  }
  .timeline-item.right .date, .timeline-item.left .date {
    right: auto;
    left: 48px;
    width: 79px;
    top: 8px;
    text-align: left;
  }
}
.timeline-2 {
  position: relative;
}
.timeline-2::after {
  position: absolute;
  content: "";
  width: 2px;
  height: 83%;
  top: 50px;
  left: 40px;
  margin-left: -1px;
  background: var(--vz-secondary-bg);
}
.timeline-2 .timeline-year {
  position: relative;
  width: 100%;
  text-align: left;
  z-index: 1;
}
.timeline-2 .timeline-year p {
  display: inline-flex;
  width: 80px;
  height: 80px;
  margin: 0;
  padding: 23px 10px;
  background: var(--vz-secondary-bg);
  border-radius: 50px;
  text-transform: uppercase;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.timeline-2 .timeline-year p span {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.timeline-2 .timeline-date {
  font-size: 14px;
  font-weight: 400;
  margin: 24px 0 0 0;
  margin-left: 55px;
}
.timeline-2 .timeline-date::after {
  content: "";
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  top: 26px;
  left: 45px;
  align-items: left;
  background: #13c56b;
  border: 3px solid var(--vz-secondary-bg);
  border-radius: 50px;
  z-index: 1;
}
.timeline-2 .timeline-box {
  position: relative;
  display: inline-block;
  margin: 23px 62px;
  padding: 20px;
  border: 1px solid var(--vz-border-color);
  border-radius: 6px;
  background: var(--vz-secondary-bg);
  max-width: 695px;
}
@media (max-width: 991.98px) {
  .timeline-2 .timeline-box {
    margin-right: 0;
  }
}
.timeline-2 .timeline-box::after {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  top: 26px;
  right: 100%;
  border-color: transparent var(--vz-secondary-bg) transparent transparent;
  border-width: 10px;
}
.timeline-2 .timeline-box::before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  right: 100%;
  top: 24px;
  border-color: transparent var(--vz-border-color) transparent transparent;
  border-width: 12px;
}
.timeline-2 .timeline-box .timeline-text {
  position: relative;
  float: left;
}
.timeline-2 .timeline-launch {
  position: relative;
  display: inline-block;
  border: 1px solid var(--vz-border-color);
  border-radius: 6px;
  background: #fff;
  width: 100%;
  margin-top: 15px;
  padding: 0;
  border: none;
  text-align: left;
  background: transparent;
}
.timeline-2 .timeline-launch .timeline-box {
  margin-left: 0;
}
.timeline-2 .timeline-launch .timeline-box::after {
  left: 30px;
  margin-left: 0px;
  top: -20px;
  border-color: transparent transparent var(--vz-border-color) transparent;
}
.timeline-2 .timeline-launch .timeline-box::before {
  left: 30px;
  margin-left: 0px;
  top: -19px;
  border-color: transparent transparent var(--vz-secondary-bg) transparent;
  border-width: 10px;
  z-index: 1;
}

.horizontal-timeline {
  position: relative;
  width: 100%;
  margin: 0 auto;
}
.horizontal-timeline::before {
  content: "";
  position: absolute;
  width: 100%;
  top: 174px;
  left: 0;
  height: 2px;
  background-color: var(--vz-secondary-bg);
}
.horizontal-timeline .swiper-slide .item-box {
  margin: 227px 0px 0px;
  background-color: transparent;
  box-shadow: none;
}
.horizontal-timeline .swiper-slide .item-box::after {
  content: "";
  position: absolute;
  left: 0px;
  right: 0px;
  margin: 0px auto;
  background: #b4d0f0;
  width: 13px;
  height: 13px;
  top: -59px;
  border-radius: 50px;
  border: 3px solid var(--vz-secondary-bg);
}
.horizontal-timeline .swiper-slide .timeline-content {
  min-height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: var(--vz-secondary-bg);
}
.horizontal-timeline .swiper-slide .timeline-content::before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  left: 0px;
  top: -23px;
  border-color: transparent transparent var(--vz-secondary-bg) transparent;
  border-width: 12px;
  right: 0;
  margin: 0 auto;
}
.horizontal-timeline .swiper-slide .time {
  position: absolute;
  top: -86px;
  right: 0px;
  left: 0px;
  margin: 0px auto;
}
.horizontal-timeline .swiper-slide:nth-child(even) {
  margin-top: 5px;
  transform: rotate(-180deg);
}
.horizontal-timeline .swiper-slide:nth-child(even) .timeline-content {
  transform: rotate(180deg);
}
.horizontal-timeline .swiper-slide:nth-child(even) .timeline-content::before {
  bottom: -23px;
  top: auto;
  border-color: var(--vz-secondary-bg) transparent transparent transparent;
}
.horizontal-timeline .swiper-slide:nth-child(even) .time {
  transform: rotate(180deg);
}
.horizontal-timeline .swiper-button-next,
.horizontal-timeline .swiper-button-prev {
  height: 40px;
  width: 40px;
  line-height: 40px;
  border-radius: 50%;
  background-color: #bfd7f2;
}
.horizontal-timeline .swiper-button-next::after,
.horizontal-timeline .swiper-button-prev::after {
  font-size: 24px;
  color: #fff;
}
.horizontal-timeline .swiper-button-next.swiper-button-disabled,
.horizontal-timeline .swiper-button-prev.swiper-button-disabled {
  background-color: rgba(180, 208, 240, 0.5);
  opacity: 1;
  cursor: auto;
  backdrop-filter: blur(25px);
  pointer-events: none;
}
.horizontal-timeline .swiper-button-next {
  right: 0;
}
.horizontal-timeline .swiper-button-next::after {
  content: "";
  font-family: remixicon;
}
.horizontal-timeline .swiper-button-prev {
  left: 0;
}
.horizontal-timeline .swiper-button-prev::after {
  content: "";
  font-family: remixicon;
}

.acitivity-timeline {
  position: relative;
  overflow: hidden;
}
.acitivity-timeline .acitivity-item {
  position: relative;
}
.acitivity-timeline .acitivity-item .flex-shrink-0 {
  z-index: 2;
}
.acitivity-timeline .acitivity-item .acitivity-avatar {
  background-color: var(--vz-secondary-bg);
  border: 3px solid var(--vz-secondary-bg);
  height: 32px;
  width: 32px;
}
.acitivity-timeline .acitivity-item:before {
  content: "";
  position: absolute;
  border-left: 1px dashed var(--vz-border-color);
  left: 16px;
  height: 100%;
  top: 5px;
  z-index: 0;
}
.acitivity-timeline .acitivity-item:last-child::before {
  border-color: transparent;
}

.categories-filter .list-inline-item {
  position: relative;
  margin-right: 0;
}
.categories-filter .list-inline-item a {
  display: block;
  color: var(--vz-body-color);
  font-weight: 500;
  padding: 8px 15px;
  margin: 5px;
  cursor: pointer;
}

.gallery-box {
  position: relative;
  overflow: hidden;
  border: 1px solid transparent;
  margin-bottom: 10px;
  box-shadow: none;
  background-color: transparent;
  padding: 8px;
}
.gallery-box::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  height: 0;
  background-color: var(--vz-secondary-bg);
  transition: all 0.4s;
}
.gallery-box .gallery-container {
  position: relative;
  overflow: hidden;
  border-radius: 4px;
}
.gallery-box .gallery-container a {
  display: block;
}
.gallery-box .gallery-container .gallery-overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  opacity: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 10%, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.5) 100%);
  visibility: hidden;
  overflow: hidden;
  transition: all 0.4s ease-in-out 0s;
  display: flex;
  width: 100%;
  align-items: flex-end;
  padding: 16px;
}
.gallery-box .gallery-container .gallery-overlay .overlay-caption {
  color: #fff;
  margin: 0;
  font-size: 16px;
}
.gallery-box .gallery-img {
  transition: all 0.2s ease-in-out;
}
.gallery-box .box-content {
  position: relative;
}
.gallery-box .box-content .title {
  font-size: 14px;
  margin-bottom: 4px;
  display: none;
}
.gallery-box .box-content .post {
  margin: 0;
  transition: all 0.2s;
  color: var(--vz-secondary-color);
}
.gallery-box:hover::before {
  height: 100%;
}
.gallery-box:hover .box-content {
  bottom: 0;
}
.gallery-box:hover .box-content .post {
  opacity: 1;
}
.gallery-box:hover .gallery-overlay {
  opacity: 1;
  visibility: visible;
}

.gallery-light .gallery-box::before {
  background-color: var(--vz-light);
}

.error-basic-img {
  max-width: 450px;
}

.error-500 .title {
  font-size: 250px;
}
.error-500 .error-500-img {
  position: absolute;
  top: 57px;
  left: 0;
  right: 0;
  margin: 0 auto;
}
@media (min-width: 768px) and (max-width: 991.98px) {
  .error-500 .title {
    font-size: 150px;
  }
  .error-500 .error-500-img {
    width: 20% !important;
    top: 43px;
  }
}
@media (max-width: 767.98px) {
  .error-500 .title {
    font-size: 68px;
    margin-top: 35px;
  }
  .error-500 .error-500-img {
    position: relative;
    top: 0px;
  }
}

@keyframes errorAnimation {
  0% {
    transform: translateX(0%);
  }
  15% {
    transform: translateX(-25%) rotate(-5deg);
  }
  30% {
    transform: translateX(20%) rotate(3deg);
  }
  45% {
    transform: translateX(-15%) rotate(-3deg);
  }
  60% {
    transform: translateX(10%) rotate(2deg);
  }
  75% {
    transform: translateX(-5%) rotate(-1deg);
  }
  100% {
    transform: translateX(0%);
  }
}
.error-img {
  animation: errorAnimation 20s infinite;
}

.error-text {
  text-shadow: 4px 4px rgba(19, 197, 107, 0.4);
}
@media (min-width: 1200px) {
  .error-text {
    font-size: 10rem;
  }
}

.profile-wid-bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 320px;
}
@media (max-width: 575.98px) {
  .profile-wid-bg {
    height: 445px;
  }
}
.profile-wid-bg::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0.9;
  background: #b4d0f0;
  background: linear-gradient(to top, #4a8ddb, #b4d0f0);
}
.profile-wid-bg .profile-wid-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.profile-nav.nav-pills .nav-link {
  color: rgba(255, 255, 255, 0.8);
}
.profile-nav.nav-pills .nav-link::before {
  background-color: rgba(255, 255, 255, 0.1);
}

.profile-project-card {
  border: 1px solid var(--vz-border-color);
  border-left: 3px solid var(--vz-border-color);
}

.profile-project-card.profile-project-primary {
  border-left-color: #b4d0f0;
}

.profile-project-card.profile-project-secondary {
  border-left-color: #daecfb;
}

.profile-project-card.profile-project-success {
  border-left-color: #13c56b;
}

.profile-project-card.profile-project-info {
  border-left-color: #50c3e6;
}

.profile-project-card.profile-project-warning {
  border-left-color: #e8bc52;
}

.profile-project-card.profile-project-danger {
  border-left-color: #ed5e5e;
}

.profile-project-card.profile-project-light {
  border-left-color: #f3f6f9;
}

.profile-project-card.profile-project-dark {
  border-left-color: #363d48;
}

.profile-project-card.profile-project-custom-primary {
  border-left-color: #7eabe7;
}

.profile-project-card.profile-project-custom-primary-hover {
  border-left-color: #bcd4f8;
}

.profile-project-card.profile-project-new-primary {
  border-left-color: #0A56AE;
}

.profile-project-card.profile-project-header {
  border-left-color: #bdd6fb;
}

.profile-project-card.profile-project-next-button {
  border-left-color: #83a9e2;
}

.profile-project-card.profile-project-next-button-border {
  border-left-color: #5d87c7;
}

.profile-project-card.profile-project-next-button-hover {
  border-left-color: #bdd6fa;
}

.profile-project-card.profile-project-white {
  border-left-color: #fff;
}

.profile-project-card.profile-project-light-grey {
  border-left-color: #ced4da;
}

.user-profile-img {
  position: relative;
}
.user-profile-img .profile-img {
  width: 100%;
  height: 250px;
  object-fit: cover;
}
@media (max-width: 991px) {
  .user-profile-img .profile-img {
    height: 160px;
  }
}
.user-profile-img .profile-foreground-img-file-input {
  display: none;
}
.user-profile-img .profile-photo-edit {
  cursor: pointer;
}

.profile-user {
  position: relative;
  display: inline-block;
}
.profile-user .profile-photo-edit {
  position: absolute;
  right: 0;
  left: auto;
  bottom: 0;
  cursor: pointer;
}
.profile-user .user-profile-image {
  object-fit: cover;
}
.profile-user .profile-img-file-input {
  display: none;
}

.profile-timeline .accordion-item {
  position: relative;
}
.profile-timeline .accordion-item .accordion-button {
  background-color: transparent;
}
.profile-timeline .accordion-item .accordion-button::after {
  background: none;
}
.profile-timeline .accordion-item::before {
  content: "";
  border-left: 2px dashed var(--vz-border-color);
  position: absolute;
  height: 100%;
  left: 23px;
}
.profile-timeline .accordion-item:first-child::before {
  top: 8px;
}
.profile-timeline .accordion-item:last-child::before {
  height: 20px;
  top: 3px;
}

.profile-setting-img {
  position: relative;
  height: 260px;
}
.profile-setting-img .overlay-content {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
}
.profile-setting-img .profile-img {
  width: 100%;
  height: 250px;
  object-fit: cover;
}
@media (max-width: 991.98px) {
  .profile-setting-img .profile-img {
    height: 160px;
  }
}
.profile-setting-img .profile-foreground-img-file-input {
  display: none;
}
.profile-setting-img .profile-photo-edit {
  cursor: pointer;
}

@media (max-width: 575.98px) {
  [data-layout=horizontal] .profile-foreground {
    margin-top: 0 !important;
  }
}
[data-layout=semibox] .profile-wrapper {
  padding: 0 1rem;
}

.sitemap-content {
  width: 100%;
  max-width: 1142px;
  margin: 0 auto;
  padding: 0 20px;
}
.sitemap-content * {
  position: relative;
}

.sitemap-horizontal {
  position: relative;
}
.sitemap-horizontal ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
.sitemap-horizontal ul a {
  display: block;
  background: var(--vz-light);
  border: 2px solid var(--vz-secondary-bg);
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  font-size: 0.825rem;
  height: 60px;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sitemap-horizontal ul a span {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.administration .director > li > a {
  width: 50%;
  margin: 0 auto 0px auto;
  border-radius: 4px;
}
.administration .subdirector {
  position: absolute;
  width: 100%;
}
.administration .subdirector::after {
  content: "";
  display: block;
  width: 0;
  height: 130px;
  border-left: 2px dashed var(--vz-border-color);
  left: 45.45%;
  position: relative;
}
.administration .subdirector > li:first-child {
  width: 18.59%;
  height: 64px;
  margin: 0 auto 92px auto;
  padding-top: 25px;
  border-bottom: 2px dashed var(--vz-border-color);
  z-index: 1;
  float: right;
  right: 27.2%;
  border-left: 2px dashed var(--vz-border-color);
}
.administration .subdirector > li:first-child a {
  width: 100%;
  left: 25px;
}
@media screen and (max-width: 767px) {
  .administration .subdirector > li:first-child {
    width: 40%;
    right: 10%;
    margin-right: 2px;
  }
  .administration .subdirector::after {
    left: 49.8%;
  }
}

.departments {
  width: 100%;
}
.departments > li:first-child {
  width: 18.59%;
  height: 64px;
  margin: 0 auto 92px auto;
  padding-top: 25px;
  border-bottom: 2px dashed var(--vz-border-color);
  z-index: 1;
  float: left;
  left: 27%;
}
.departments > li:first-child a {
  width: 100%;
  right: 25px;
}
.departments > li:nth-child(2) {
  margin-left: 0;
  clear: left;
}
.departments > li:nth-child(2).department:before {
  border: none;
}
.departments::after {
  content: "";
  display: block;
  position: absolute;
  width: 81.1%;
  height: 22px;
  border-top: 2px dashed var(--vz-border-color);
  border-right: 2px dashed var(--vz-border-color);
  border-left: 2px dashed var(--vz-border-color);
  margin: 0 auto;
  top: 130px;
  left: 9.1%;
}
@media screen and (max-width: 767px) {
  .departments > li:first-child {
    width: 40%;
    left: 10%;
    margin-left: 2px;
  }
  .departments::after {
    border-right: none;
    left: 0;
    width: 50%;
  }
}

.department {
  border-left: 2px dashed var(--vz-border-color);
  float: left;
  margin-left: 1.75%;
  margin-bottom: 60px;
  width: 18.25%;
}
.department::before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 22px;
  border-left: 2px dashed var(--vz-border-color);
  z-index: 1;
  top: -22px;
  left: 50%;
  margin-left: -4px;
}
.department > a {
  margin: 0 0 -26px -4px;
  z-index: 1;
}
.department ul {
  margin-top: 0px;
  margin-bottom: 0px;
}
.department ul li {
  padding-left: 25px;
  border-bottom: 2px dashed var(--vz-border-color);
  height: 80px;
}
.department ul li a {
  background: var(--vz-secondary-bg);
  margin-top: 48px;
  position: absolute;
  z-index: 1;
  width: 90%;
  height: 60px;
  vertical-align: middle;
  right: -1px;
  text-align: center;
}
.department:first-child {
  margin-left: 0;
  clear: left;
}
@media screen and (min-width: 768px) {
  .department:last-child:before {
    border: none;
  }
}
@media screen and (max-width: 767px) {
  .department {
    float: none;
    width: 100%;
    margin-left: 0;
  }
  .department::before {
    content: "";
    display: block;
    position: absolute;
    width: 0;
    height: 60px;
    border-left: 2px dashed #fff;
    z-index: 1;
    top: -60px;
    left: 0%;
    margin-left: -4px;
  }
  .department:nth-child(2)::before {
    display: none;
  }
}

.hori-sitemap ul {
  padding: 0;
  padding-top: 10px;
  text-align: center;
}
.hori-sitemap ul li {
  position: relative;
}
@media (max-width: 575.98px) {
  .hori-sitemap ul {
    text-align: left;
  }
  .hori-sitemap ul .parent-title a {
    padding-left: 0;
  }
  .hori-sitemap ul .parent-title a:after {
    display: none;
  }
  .hori-sitemap ul .parent-title:before {
    display: none;
  }
}
@media (max-width: 575.98px) {
  .hori-sitemap > ul {
    position: relative;
  }
  .hori-sitemap > ul li {
    padding-top: 10px;
  }
  .hori-sitemap > ul li .second-list,
.hori-sitemap > ul li .sub-list {
    position: relative;
  }
  .hori-sitemap > ul li .second-list:before,
.hori-sitemap > ul li .sub-list:before {
    content: "";
    height: calc(100% - 14px);
    border-right: 2px dashed var(--vz-border-color);
    position: absolute;
    top: 0px;
    left: 0px;
  }
  .hori-sitemap > ul li .sub-list:before {
    height: 38%;
  }
  .hori-sitemap > ul li a {
    position: relative;
    padding: 4px 16px 4px 36px;
  }
  .hori-sitemap > ul li a:after {
    content: "";
    width: 24px;
    border-top: 2px dashed var(--vz-border-color);
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
  }
  .hori-sitemap > ul li ul {
    margin-left: 36px;
  }
}
@media (min-width: 576px) {
  .hori-sitemap ul {
    padding-top: 20px;
  }
  .hori-sitemap ul li {
    padding-top: 30px;
  }
  .hori-sitemap ul li:before {
    content: "";
    height: 24px;
    width: 0;
    border-right: 2px dashed var(--vz-border-color);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: 0px auto;
  }
  .hori-sitemap ul li:after {
    content: "";
    width: 100%;
    border-top: 2px dashed var(--vz-border-color);
    position: absolute;
    top: 0;
    left: 50%;
  }
  .hori-sitemap ul li:last-of-type:after {
    display: none;
  }
  .hori-sitemap ul li.parent-title::before {
    content: "";
    height: 23px;
    border-right: 2px dashed var(--vz-border-color);
    position: absolute;
    top: 28px;
    left: 0;
  }
  .hori-sitemap ul li.parent-title::after {
    border: none;
  }
  .hori-sitemap ul li .sub-title {
    position: relative;
  }
  .hori-sitemap ul li .sub-title::before {
    content: "";
    height: 21px;
    border-right: 2px dashed var(--vz-border-color);
    position: absolute;
    top: 27px;
    left: 49%;
    margin: 0 auto;
  }
}
.hori-sitemap a {
  color: var(--vz-body-color);
  padding: 4px 0px;
  display: block;
}

.verti-sitemap a {
  color: var(--vz-body-color);
  display: block;
}
.verti-sitemap .parent-title a {
  padding-left: 0;
}
.verti-sitemap .parent-title a:before {
  display: none;
}
.verti-sitemap .parent-title:before {
  display: none;
}
.verti-sitemap .first-list {
  position: relative;
  padding-top: 10px;
}
.verti-sitemap .first-list:before {
  content: "";
  border-left: 2px dashed var(--vz-border-color);
  position: absolute;
  top: 0;
  height: 100%;
  bottom: 0;
  left: 0;
}
.verti-sitemap .first-list .list-wrap a, .verti-sitemap .first-list li a {
  position: relative;
  padding: 10px 16px 4px 36px;
}
.verti-sitemap .first-list .list-wrap a::before, .verti-sitemap .first-list li a::before {
  content: "";
  width: 24px;
  border-top: 2px dashed var(--vz-border-color);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
}
.verti-sitemap .first-list .second-list, .verti-sitemap .first-list .third-list {
  margin-left: 42px;
}
.verti-sitemap .first-list .third-list, .verti-sitemap .first-list .second-list {
  position: relative;
}
.verti-sitemap .first-list .third-list li, .verti-sitemap .first-list .second-list li {
  position: relative;
}
.verti-sitemap .first-list .third-list li:before, .verti-sitemap .first-list .second-list li:before {
  content: "";
  height: 100%;
  border-left: 2px dashed var(--vz-border-color);
  position: absolute;
  top: 0;
  left: 0;
  margin: 0px auto;
}
.verti-sitemap .first-list .third-list li:last-child::before, .verti-sitemap .first-list .second-list li:last-child::before {
  height: 13px;
}
.verti-sitemap .first-list:last-child::before {
  height: 25px;
}

.team-box .team-cover, .profile-offcanvas .team-cover, .modal-team-cover {
  display: none;
  position: relative;
  margin-bottom: -140px;
}
.team-box .team-cover img, .profile-offcanvas .team-cover img, .modal-team-cover img {
  height: 140px;
  width: 100%;
  object-fit: cover;
}
.team-box .team-cover::before, .profile-offcanvas .team-cover::before, .modal-team-cover::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(to top, #4a8ddb, #b4d0f0);
  opacity: 0.6;
}

.team-list.grid-view-filter {
  flex-flow: row wrap;
}
.team-list.grid-view-filter .col {
  flex: 0 0 auto;
  width: 25%;
}
.team-list.grid-view-filter .team-box {
  overflow: hidden;
}
.team-list.grid-view-filter .team-box .team-row {
  align-items: start;
}
.team-list.grid-view-filter .team-box .team-row .col {
  width: 100%;
}
.team-list.grid-view-filter .team-box .team-cover {
  display: block;
}
.team-list.grid-view-filter .team-box .team-settings .col {
  width: 50% !important;
  flex: 0 0 auto;
}
.team-list.grid-view-filter .team-box .team-settings .btn-star {
  color: #fff;
}
.team-list.grid-view-filter .team-box .team-settings .dropdown > a {
  color: #fff;
}
.team-list.grid-view-filter .team-box .team-profile-img {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 25px;
  margin-top: 36px;
}
.team-list.grid-view-filter .team-box .team-profile-img .avatar-lg {
  font-size: 22px;
}
.team-list.grid-view-filter .team-box .team-profile-img .team-content {
  margin-left: 0px;
  margin-top: 25px;
  text-align: center;
}
.team-list.grid-view-filter .team-box .view-btn {
  width: 100%;
  margin-top: 25px;
}
@media (min-width: 1200px) and (max-width: 1399.98px) {
  .team-list.grid-view-filter .col {
    flex: 0 0 auto;
    width: 33.33%;
  }
}
@media (max-width: 1199.98px) {
  .team-list.grid-view-filter .col {
    flex: 0 0 auto;
    width: 50%;
  }
}
@media (max-width: 767.98px) {
  .team-list.grid-view-filter .col {
    flex: 0 0 auto;
    width: 100%;
  }
}
.team-list.list-view-filter {
  flex-direction: column;
}
.team-list.list-view-filter .team-box {
  margin-bottom: 10px;
}
.team-list.list-view-filter .team-box .team-row {
  align-items: center;
  justify-content: space-between;
}
.team-list.list-view-filter .team-box .team-profile-img {
  display: flex;
  align-items: center;
}
.team-list.list-view-filter .team-box .team-profile-img .avatar-lg {
  height: 4rem;
  width: 4rem;
  font-size: 16px;
}
.team-list.list-view-filter .team-box .team-profile-img .team-content {
  margin-left: 15px;
}
.team-list.list-view-filter .team-box .team-settings {
  width: auto;
  flex: 0 0 auto;
  order: 6;
}
.team-list.list-view-filter .team-box .btn-star {
  color: #b4d0f0;
}
@media (max-width: 767.98px) {
  .team-list.list-view-filter {
    flex-direction: row;
  }
  .team-list.list-view-filter .col {
    flex: 0 0 auto;
    width: 100%;
  }
  .team-list.list-view-filter .team-box .team-settings {
    width: 100%;
    flex: 0 0 auto;
    order: -1;
    margin-bottom: 10px;
  }
  .team-list.list-view-filter .team-box .team-settings .col {
    width: 50%;
  }
  .team-list.list-view-filter .team-box .team-profile-img {
    margin-bottom: 25px;
  }
  .team-list.list-view-filter .team-box .view-btn {
    width: 100%;
    margin-top: 25px;
  }
}

.modal-team-cover {
  display: block;
}

.list-grid-nav .nav-link.active {
  background-color: #50c3e6;
  color: #fff;
}

.profile-offcanvas .team-cover {
  margin-bottom: -132px;
  display: block;
  z-index: -1;
}
.profile-offcanvas .btn-star {
  color: #fff;
}
.profile-offcanvas .dropdown > a {
  color: #fff;
}

.countdownlist {
  text-align: center;
  display: flex;
  gap: 24px;
}
.countdownlist .countdownlist-item {
  width: 25%;
}
.countdownlist .countdownlist-item:last-of-type .count-num::after {
  display: none;
}
.countdownlist .count-title {
  font-size: 13px;
  font-weight: 400;
  display: block;
  margin-bottom: 8px;
  color: rgba(var(--vz-body-color-rgb), 0.5);
  text-transform: uppercase;
}
.countdownlist .count-num {
  background-color: var(--vz-secondary-bg);
  padding: 16px 8px;
  position: relative;
  border-radius: var(--vz-border-radius);
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  font-weight: 500;
  font-size: 32px;
}
@media (max-width: 575.98px) {
  .countdownlist .count-num {
    font-size: 18px;
  }
}
.countdownlist .count-num::after {
  content: ":";
  font-size: 20px;
  position: absolute;
  right: -16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--vz-body-color);
}

.move-animation {
  animation: mover 1s infinite alternate;
}

@keyframes mover {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-16px);
  }
}
.coming-soon-text {
  font-weight: 500;
  text-transform: uppercase;
  color: #fff;
  text-shadow: 3px 4px #13c56b;
}

.countdown-input-group {
  max-width: 400px;
}

.search-more-results {
  position: relative;
  overflow: hidden;
}
.search-more-results .nav-icon {
  font-size: 14px;
  color: #fff;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  left: 0;
  right: 0;
}
.search-more-results .nav-icon i {
  font-size: 20px;
}
@media (max-width: 767.98px) {
  .search-more-results .nav-icon {
    font-size: 14px;
  }
  .search-more-results .nav-icon i {
    font-size: 18px;
  }
}

.video-list .list-element {
  display: none;
}
.video-list .list-element:nth-child(1) {
  display: block;
}
.video-list .list-element:nth-child(2) {
  display: block;
}
.video-list .list-element:nth-child(3) {
  display: block;
}

.search-voice {
  height: 120px;
  width: 120px;
  line-height: 120px;
  margin: 0px auto;
  text-align: center;
  border-radius: 50%;
  z-index: 1;
  position: relative;
}
.search-voice i {
  line-height: 56px;
  font-size: 30px;
}
.search-voice .voice-wave {
  position: absolute;
  width: 120px;
  height: 120px;
  z-index: -1;
  left: 0px;
  right: 0px;
  margin: 0px auto;
  opacity: 0;
  border-radius: 100px;
  animation: voice-wave 1.8s infinite;
  background-color: var(--vz-light);
}
.search-voice .voice-wave:nth-child(2) {
  animation-delay: 0.3s;
}
.search-voice .voice-wave:nth-child(3) {
  animation-delay: 0.6s;
}

@keyframes voice-wave {
  0% {
    opacity: 1;
    transform: scale(0);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}
.images-menu .swiper-slide {
  width: auto;
  display: inline-block;
}

#selection-element {
  display: none;
}

.filter-choices-input .choices__inner {
  padding: 0;
  border: none;
  background-color: var(--vz-secondary-bg);
}
.filter-choices-input .choices__input {
  background-color: var(--vz-secondary-bg);
}

@media (min-width: 992px) {
  .sticky-side-div {
    position: sticky;
    top: calc(70px + 1.5rem);
  }
}

.product-img-slider .product-nav-slider .nav-slide-item {
  border: 1px solid var(--vz-border-color);
  border-radius: 0.25rem;
  padding: 0.5rem;
  cursor: pointer;
}
.product-img-slider .product-nav-slider .swiper-slide-thumb-active .nav-slide-item {
  background-color: var(--vz-light);
}

.filter-list a.active .listname {
  color: var(--vz-success);
}

#remove-actions {
  display: none;
}

.invoice-table tbody:last-child {
  border: none;
}

.currency-select .choices__inner {
  padding: 0px;
  padding-right: 15px;
  min-height: 0px;
}
.currency-select .choices__list--single {
  padding: 0px 16px 0 4px;
}
.currency-select .choices[data-type*=select-one] {
  bottom: 0px;
}
.currency-select .choices[data-type*=select-one] :after {
  top: 4px;
}
.currency-select .choices[data-type*=select-one] .choices__inner {
  padding-bottom: 0px;
}

.chat-wrapper {
  position: relative;
  overflow-x: hidden;
}

.chat-leftsidebar {
  height: calc(100vh - 137px);
  position: relative;
  background-color: var(--vz-secondary-bg);
}
@media (min-width: 992px) {
  .chat-leftsidebar {
    min-width: 300px;
    max-width: 300px;
    height: calc(100vh - 70px - 60px - 8px);
  }
}

.chat-list {
  margin: 0;
}
.chat-list > li.active a {
  background-color: rgba(var(--vz-primary-rgb), 0.15);
  color: var(--vz-primary);
}
.chat-list > li.active a .badge {
  background-color: rgba(var(--vz-success-rgb), 0.15) !important;
  color: #13c56b !important;
}
.chat-list > li a {
  display: block;
  padding: 7px 24px;
  color: var(--vz-body-color);
  transition: all 0.4s;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 0.825rem;
}
.chat-list > li .chat-user-message {
  font-size: 14px;
}
.chat-list > li .unread-msg-user {
  font-weight: 500;
}
.chat-list > li .unread-message {
  position: absolute;
  display: inline-block;
  right: 24px;
  left: auto;
  top: 33px;
}
.chat-list > li .unread-message .badge {
  line-height: 16px;
  font-weight: 500;
  font-size: 10px;
}

.chat-user-img {
  position: relative;
}
.chat-user-img .user-status {
  width: 10px;
  height: 10px;
  background-color: #adb5bd;
  border-radius: 50%;
  border: 2px solid var(--vz-secondary-bg);
  position: absolute;
  right: 0;
  left: auto;
  bottom: 0;
}
.chat-user-img.online .user-status {
  background-color: #13c56b;
}
.chat-user-img.away .user-status {
  background-color: #e8bc52;
}

.chat-room-list {
  max-height: calc(100vh - 296px);
}
@media (max-width: 991.98px) {
  .chat-room-list {
    height: calc(100vh - 296px);
  }
}

.contact-list li {
  cursor: pointer;
  padding: 8px 24px;
  transition: all 0.4s;
  color: var(--vz-body-color);
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 0.825rem;
}

.contact-list-title {
  padding: 6px 24px;
  color: #b4d0f0;
  font-weight: 400;
  position: relative;
  font-size: 12px;
}
.contact-list-title:after {
  content: "";
  height: 1px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 50px;
  right: 0;
  background-color: var(--vz-light);
}

.user-chat {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_73___});
  transition: all 0.4s;
  position: relative;
  background-color: var(--vz-body-bg);
}
@media (max-width: 991.98px) {
  .user-chat {
    position: absolute;
    left: 0;
    top: 3px;
    width: 100%;
    height: calc(100% - 3px);
    visibility: hidden;
    transform: translateX(100%);
    z-index: 99;
    padding-top: 70px;
  }
  .user-chat.user-chat-show {
    visibility: visible;
    transform: translateX(0);
  }
}
.user-chat .chat-content {
  position: relative;
}
.user-chat.user-chat-show .chat-welcome-section {
  display: none;
}
@media (min-width: 992px) {
  .user-chat.user-chat-show .chat-content {
    display: flex !important;
  }
}

.user-chat-topbar {
  border-bottom: 1px solid transparent;
  background-color: var(--vz-secondary-bg);
}
@media (max-width: 991.98px) {
  .user-chat-topbar {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 1;
  }
}

.user-chat-nav .nav-btn {
  height: 40px;
  width: 40px;
  line-height: 40px;
  box-shadow: none;
  padding: 0;
  font-size: 20px;
  color: #363d48;
}
@media (max-width: 575.98px) {
  .user-chat-nav {
    display: flex;
    justify-content: flex-end;
  }
}

.chat-conversation {
  height: calc(100vh - 299px);
}
@media (max-width: 991.98px) {
  .chat-conversation {
    height: calc(100vh - 275px);
  }
}
.chat-conversation .simplebar-content-wrapper {
  display: flex;
  flex-direction: column;
}
.chat-conversation .simplebar-content-wrapper .simplebar-content {
  margin-top: auto;
}
.chat-conversation .chat-conversation-list {
  padding-top: 10px;
  margin-bottom: 0;
}
.chat-conversation .chat-conversation-list > li {
  display: flex;
}
.chat-conversation li:last-of-type .conversation-list {
  margin-bottom: 0;
}
.chat-conversation .chat-list.left .check-message-icon {
  display: none;
}
.chat-conversation .chat-list .message-box-drop {
  visibility: hidden;
}
.chat-conversation .chat-list:hover .message-box-drop {
  visibility: visible;
}
.chat-conversation .chat-avatar {
  margin: 0 16px 0 0;
}
.chat-conversation .chat-avatar img {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}
.chat-conversation .chat-day-title {
  position: relative;
  text-align: center;
  margin-bottom: 24px;
  margin-top: 12px;
  width: 100%;
}
.chat-conversation .chat-day-title .title {
  background-color: #fff;
  position: relative;
  font-size: 13px;
  z-index: 1;
  padding: 6px 12px;
  border-radius: 5px;
}
.chat-conversation .chat-day-title:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  right: 0;
  background-color: rgba(180, 208, 240, 0.2);
  top: 10px;
}
.chat-conversation .chat-day-title .badge {
  font-size: 12px;
}
.chat-conversation .conversation-list {
  margin-bottom: 24px;
  display: inline-flex;
  position: relative;
  align-items: flex-end;
  max-width: 80%;
}
@media (max-width: 575.98px) {
  .chat-conversation .conversation-list {
    max-width: 90%;
  }
}
.chat-conversation .conversation-list .ctext-wrap {
  display: flex;
  margin-bottom: 10px;
}
.chat-conversation .conversation-list .ctext-content {
  word-wrap: break-word;
  word-break: break-word;
}
.chat-conversation .conversation-list .ctext-wrap-content {
  padding: 12px 20px;
  background-color: var(--vz-light);
  position: relative;
  border-radius: 3px;
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
}
@media (max-width: 575.98px) {
  .chat-conversation .conversation-list .ctext-wrap-content .attached-file .attached-file-avatar {
    display: none;
  }
  .chat-conversation .conversation-list .ctext-wrap-content .attached-file .dropdown .dropdown-toggle {
    display: block;
  }
}
.chat-conversation .conversation-list .conversation-name {
  font-weight: 400;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.chat-conversation .conversation-list .dropdown .dropdown-toggle {
  font-size: 18px;
  padding: 4px;
  color: #878a99;
}
.chat-conversation .conversation-list .dropdown .dropdown-toggle::after {
  display: none;
}
@media (max-width: 575.98px) {
  .chat-conversation .conversation-list .dropdown .dropdown-toggle {
    display: none;
  }
}
.chat-conversation .conversation-list .chat-time {
  font-size: 12px;
  margin-top: 4px;
  text-align: right;
}
.chat-conversation .conversation-list .message-img {
  border-radius: 0.2rem;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.chat-conversation .conversation-list .message-img .message-img-list {
  position: relative;
}
.chat-conversation .conversation-list .message-img img {
  max-width: 150px;
}
.chat-conversation .conversation-list .message-img .message-img-link {
  position: absolute;
  right: 10px;
  left: auto;
  bottom: 10px;
}
.chat-conversation .conversation-list .message-img .message-img-link li > a {
  font-size: 18px;
  color: #fff;
  display: inline-block;
  line-height: 20px;
  width: 26px;
  height: 24px;
  border-radius: 3px;
  background-color: rgba(54, 61, 72, 0.7);
  text-align: center;
}
.chat-conversation .right {
  justify-content: flex-end;
}
.chat-conversation .right .chat-avatar {
  order: 3;
  margin-right: 0px;
  margin-left: 16px;
}
.chat-conversation .right .chat-time {
  text-align: left;
  color: #878a99;
}
.chat-conversation .right .conversation-list {
  text-align: right;
}
.chat-conversation .right .conversation-list .ctext-wrap {
  justify-content: flex-end;
}
.chat-conversation .right .conversation-list .ctext-wrap .ctext-wrap-content {
  order: 2;
  background-color: rgba(var(--vz-primary-rgb), 0.15);
  color: var(--vz-primary);
  text-align: right;
  box-shadow: none;
}
.chat-conversation .right .conversation-list .ctext-wrap .ctext-wrap-content .replymessage-block {
  background-color: rgba(255, 255, 255, 0.5);
  border-color: rgba(var(--vz-success-rgb), 1);
  color: #212529;
}
.chat-conversation .right .conversation-list .ctext-wrap .ctext-wrap-content .replymessage-block .conversation-name {
  color: rgba(var(--vz-success-rgb), 1);
}
.chat-conversation .right .conversation-list .conversation-name {
  justify-content: flex-end;
}
.chat-conversation .right .conversation-list .conversation-name .check-message-icon {
  order: 1;
}
.chat-conversation .right .conversation-list .conversation-name .time {
  order: 2;
}
.chat-conversation .right .conversation-list .conversation-name .name {
  order: 3;
}
.chat-conversation .right .conversation-list .dropdown {
  order: 1;
}
.chat-conversation .right .dot {
  background-color: #363d48;
}

.chat-input-section {
  border-top: 1px solid transparent;
  background-color: var(--vz-secondary-bg);
  position: relative;
  z-index: 1;
}
.chat-input-section .chat-input-feedback {
  display: none;
  position: absolute;
  top: -20px;
  left: 4px;
  font-size: 12px;
  color: #ed5e5e;
}
.chat-input-section .show {
  display: block;
}

.chat-input-links {
  display: flex;
}
.chat-input-links .links-list-item > .btn {
  box-shadow: none;
  padding: 0;
  font-size: 20px;
  width: 37.5px;
  height: 37.5px;
}
.chat-input-links .links-list-item > .btn.btn-link {
  color: #878a99;
}

.copyclipboard-alert {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: none;
}

.replyCard {
  position: absolute;
  left: 0;
  right: 0;
  border-top: 1px solid var(--vz-border-color);
  overflow: hidden;
  opacity: 0;
  bottom: 0;
  border-radius: 0;
  transition: all 0.4s;
}
@media (max-width: 991.98px) {
  .replyCard {
    bottom: -12px;
  }
}
.replyCard.show {
  transform: translateY(-88px);
  opacity: 1;
}
@media (max-width: 991.98px) {
  .replyCard.show {
    transform: translateY(-83px);
  }
}

.replymessage-block {
  padding: 12px 20px;
  margin-bottom: 8px;
  text-align: left;
  border-radius: 4px;
  background-color: rgba(var(--vz-success-rgb), 0.1);
  border-left: 2px solid rgba(var(--vz-success-rgb), 1);
}
.replymessage-block .conversation-name {
  color: rgba(var(--vz-success-rgb), 1);
  font-size: 14px;
}

.chat-sm .ctext-wrap-content {
  box-shadow: none !important;
}
.chat-sm .message-img img {
  max-width: 90px !important;
}
.chat-sm .message-img-link {
  bottom: 0 !important;
  right: 5px !important;
}

@media (min-width: 1025px) {
  [data-layout=horizontal] .chat-wrapper {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .chat-wrapper {
    margin-top: 0 !important;
  }
}
[data-layout=horizontal] .chat-leftsidebar {
  height: calc(100vh - 70px - 60px - 54px);
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .chat-leftsidebar {
    height: calc(100vh - 70px - 60px - 8px);
  }
}
[data-layout=horizontal] .chat-room-list {
  height: calc(100vh - 352px);
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .chat-room-list {
    height: calc(100vh - 265px);
  }
}
[data-layout=horizontal] .chat-conversation {
  height: calc(100vh - 343px);
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .chat-conversation {
    height: calc(100vh - 275px);
  }
}

.email-wrapper {
  position: relative;
  overflow-x: hidden;
}

.email-menu-sidebar {
  height: calc(100vh - 137px);
  position: relative;
  background-color: var(--vz-secondary-bg);
  transition: all 0.2s;
}
@media (min-width: 992px) {
  .email-menu-sidebar {
    min-width: 250px;
    max-width: 250px;
    height: calc(100vh - 70px - 60px - 8px);
  }
}
@media (max-width: 991.98px) {
  .email-menu-sidebar {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 200px;
    max-width: 100%;
    z-index: 1003;
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    transform: translateX(-100%);
    visibility: hidden;
    height: 100vh;
  }
  .email-menu-sidebar.menubar-show {
    visibility: visible;
    transform: none;
  }
}
.email-menu-sidebar .email-menu-sidebar-scroll {
  height: calc(100vh - 295px);
}
@media (max-width: 991.98px) {
  .email-menu-sidebar .email-menu-sidebar-scroll {
    height: calc(100vh - 150px);
  }
}

.mail-list a {
  display: flex;
  align-items: center;
  color: #878a99;
  padding: 5px 0;
  font-weight: 400;
}
.mail-list a:hover {
  color: #b4d0f0;
}
.mail-list a i {
  font-size: 14px;
}
.mail-list a.active {
  color: #13c56b;
  font-weight: 500;
}
.mail-list a.active i {
  color: #13c56b;
}

.email-chat-list a {
  padding: 6px 24px;
}
.email-chat-list a.active {
  background-color: rgba(var(--vz-light-rgb), 0.7);
}

.email-topbar-link .btn-ghost-secondary {
  color: var(--vz-secondary-color);
}
.email-topbar-link .btn-ghost-secondary:hover {
  color: #daecfb;
}

.email-content {
  width: 100%;
  background-color: var(--vz-secondary-bg);
  transition: all 0.2s;
}

.unreadConversations-alert {
  position: fixed;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}

.email-detail-content {
  position: relative;
  top: 0;
  bottom: 0;
  left: -2px;
  width: 0;
  background-color: var(--vz-secondary-bg);
  transform: translateX(200%);
  transition: all 0.2s;
  display: none;
  border-left: 2px solid var(--vz-body-bg);
}

.email-detail-show .email-detail-content {
  transform: none;
  display: block;
  width: 60%;
}
.email-detail-show .email-content {
  margin-right: 0;
}

.email-detail-content-scroll {
  height: calc(100vh - 400px);
}
@media (max-width: 1349.98px) {
  .email-detail-content-scroll {
    height: calc(100vh - 257px);
  }
}

.message-list-content {
  height: calc(100vh - 242px);
}
@media (max-width: 575.98px) {
  .message-list-content {
    height: calc(100vh - 230px);
  }
}

.message-list {
  display: block;
  padding-left: 0;
  margin: 0;
}
.message-list li {
  position: relative;
  display: block;
  height: 50px;
  line-height: 50px;
  cursor: default;
  transition-duration: 0.3s;
  clear: both;
}
.message-list li a {
  color: var(--vz-heading-color);
}
.message-list li:hover {
  background: var(--vz-light);
  transition-duration: 0.05s;
}
.message-list li .col-mail {
  float: left;
  position: relative;
}
.message-list li .col-mail-1 {
  width: 280px;
}
.message-list li .col-mail-1 .star-toggle,
.message-list li .col-mail-1 .checkbox-wrapper-mail,
.message-list li .col-mail-1 .dot {
  display: block;
  float: left;
}
.message-list li .col-mail-1 .dot {
  border: 4px solid transparent;
  border-radius: 100px;
  margin: 22px 26px 0;
  height: 0;
  width: 0;
  line-height: 0;
  font-size: 0;
}
.message-list li .col-mail-1 .checkbox-wrapper-mail {
  margin: 15px 0 0 20px;
  line-height: normal;
}
.message-list li .col-mail-1 .star-toggle {
  margin-top: 18px;
  margin-left: 5px;
}
.message-list li .col-mail-1 .title {
  position: absolute;
  top: 0;
  left: 95px;
  right: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 0;
}
@media (max-width: 575.98px) {
  .message-list li .col-mail-1 .title {
    left: 95px;
  }
}
.message-list li .col-mail-2 {
  position: absolute;
  top: 0;
  left: 280px;
  right: 0;
  bottom: 0;
}
.message-list li .col-mail-2 .subject,
.message-list li .col-mail-2 .date {
  position: absolute;
  top: 0;
}
.message-list li .col-mail-2 .subject {
  left: 0;
  right: 110px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.message-list li .col-mail-2 .subject .teaser {
  color: var(--vz-secondary-color);
}
.message-list li .col-mail-2 .date {
  right: 0;
  width: 100px;
  padding-left: 20px;
}
.message-list li.active, .message-list li.active:hover {
  box-shadow: inset 3px 0 0 #b4d0f0;
  background-color: var(--vz-light);
}
.message-list li.unread {
  color: var(--vz-body-color);
}
.message-list li.unread a {
  color: var(--vz-body-color);
  font-weight: 500;
}

#unreadConversations, #email-topbar-actions {
  display: none;
}

#elmLoader {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
}

.email-compose-input {
  padding-right: 80px;
}

@media (max-width: 1349.98px) {
  .email-detail-content {
    display: block;
    position: fixed;
    top: 0;
    bottom: 0;
    left: auto;
    right: 0;
    width: 400px;
    max-width: 100%;
    z-index: 1003;
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    transform: translateX(100%);
    visibility: hidden;
  }

  .email-detail-show .email-detail-content {
    width: 400px;
    transform: none;
    visibility: visible;
  }
}
@media (max-width: 575.98px) {
  .message-list li .col-mail-1 {
    width: 180px;
  }
}
.email-editor .ck-editor__editable_inline {
  min-height: 200px !important;
}

.email-chat-detail {
  width: 350px;
  position: fixed;
  max-width: 100%;
  bottom: 60px;
  right: 60px;
  z-index: 9;
  display: none;
}
.email-chat-detail .card {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
}
@media (max-width: 515.98px) {
  .email-chat-detail {
    left: 16px;
    right: 16px;
  }
}

.message-list-scroll {
  position: relative;
  overflow-y: auto;
}
.message-list-scroll::-webkit-scrollbar {
  -webkit-appearance: none;
}
.message-list-scroll::-webkit-scrollbar:vertical {
  width: 12px;
}
.message-list-scroll::-webkit-scrollbar:horizontal {
  height: 12px;
}
.message-list-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(var(--vz-body-color-rgb), 0.075);
  border-radius: 10px;
  border: 2px solid var(--vz-secondary-bg);
}
.message-list-scroll::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: var(--vz-secondary-bg);
}

@media (min-width: 1025px) {
  [data-layout=horizontal] .email-wrapper {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .email-wrapper {
    margin-top: 0 !important;
  }
}
[data-layout=horizontal] .email-menu-sidebar {
  height: calc(100vh - 70px - 60px - 54px);
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .email-menu-sidebar {
    height: 100vh;
  }
}
[data-layout=horizontal] .email-menu-sidebar .email-menu-sidebar-scroll {
  height: calc(100vh - 330px);
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .email-menu-sidebar .email-menu-sidebar-scroll {
    height: calc(100vh - 150px);
  }
}
[data-layout=horizontal] .message-list-content {
  height: calc(100vh - 289px);
}
[data-layout=horizontal] .email-detail-content-scroll {
  height: calc(100vh - 435px);
}
@media (max-width: 1349.98px) {
  [data-layout=horizontal] .email-detail-content-scroll {
    height: calc(100vh - 252px);
  }
}

.tasks-board {
  display: flex;
  overflow-x: auto;
  align-items: stretch;
}
.tasks-board .tasks-list {
  min-width: 300px;
  margin-right: 24px;
}
.tasks-board::-webkit-scrollbar {
  -webkit-appearance: none;
}
.tasks-board::-webkit-scrollbar:vertical {
  width: 10px;
}
.tasks-board::-webkit-scrollbar:horizontal {
  height: 8px;
}
.tasks-board::-webkit-scrollbar-thumb {
  background-color: rgba(var(--vz-dark-rgb), 0.075);
  border-radius: 8px;
}
.tasks-board::-webkit-scrollbar-track {
  border-radius: 8px;
}

.tasks-box .progress {
  border-radius: 0px 0px var(--vz-border-radius) var(--vz-border-radius);
}
.tasks-box .tasks-img {
  height: 135px;
  width: 100%;
  object-fit: cover;
  object-position: center;
  margin: 12px 0px;
}
.tasks-box:last-child {
  margin-bottom: 0px;
}

.tasks-wrapper {
  max-height: calc(100vh - 418px);
}

.tasks {
  min-height: 180px;
  position: relative;
}
.tasks.noTask::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 180px;
  width: 270px;
  margin: 0 auto;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_74___});
  background-size: cover;
  background-position: center;
}

#tasksList tr .tasks-list-menu {
  opacity: 0;
}
#tasksList tr:hover .tasks-list-menu {
  opacity: 1;
}

.layout-wrapper.landing {
  background-color: var(--vz-secondary-bg);
  font-size: 15px;
}

.navbar-show .vertical-overlay {
  display: block;
}

.section {
  padding: 90px 0;
  position: relative;
}
@media (max-width: 767.98px) {
  .section {
    padding: 50px 0;
  }
}

.icon-effect {
  position: relative;
}
.icon-effect::before {
  content: "";
  position: absolute;
  width: 24px;
  height: 24px;
  background-color: rgba(19, 197, 107, 0.2);
  border-radius: 50%;
  bottom: 0;
  left: 0 !important;
}

.navbar-landing {
  padding: 10px 0px;
  transition: all 0.5s ease;
}
@media (max-width: 991.98px) {
  .navbar-landing {
    background-color: var(--vz-secondary-bg);
    box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);
    padding: 10px 8px;
  }
}
.navbar-landing .navbar-nav .nav-item .nav-link {
  font-size: 16px;
  font-weight: 400;
  transition: all 0.4s;
  font-family: "Montserrat", sans-serif;
  color: var(--vz-body-color);
  padding: 14px;
}
@media (max-width: 991.98px) {
  .navbar-landing .navbar-nav .nav-item .nav-link {
    padding: 8px 0px;
  }
}
.navbar-landing .navbar-nav .nav-item .nav-link:hover, .navbar-landing .navbar-nav .nav-item .nav-link.active, .navbar-landing .navbar-nav .nav-item .nav-link:focus {
  color: #13c56b !important;
}
.navbar-landing.is-sticky {
  background-color: var(--vz-secondary-bg);
  box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);
}

.navbar-light .navbar-brand .card-logo-dark {
  display: none;
}
.navbar-light .navbar-brand .card-logo-light {
  display: block;
}
.navbar-light .navbar-nav .nav-item .nav-link {
  color: rgba(var(--vz-white-rgb), 0.75);
}
.navbar-light.is-sticky .navbar-nav .nav-item .nav-link {
  color: var(--vz-body-color);
}
.navbar-light.is-sticky .navbar-brand .card-logo-dark {
  display: block;
}
.navbar-light.is-sticky .navbar-brand .card-logo-light {
  display: none;
}

.hero-section {
  background-color: rgba(var(--vz-light-rgb), 0.5);
}
.hero-section .hero-shape-svg svg path {
  fill: var(--vz-secondary-bg);
}

.bg-overlay-pattern {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_75___});
  background-color: transparent;
  background-position: center;
  background-size: cover;
  opacity: 0.2;
}

.demo-carousel {
  position: relative;
  z-index: 1;
}
.demo-carousel .carousel-item .demo-item {
  background-color: var(--vz-secondary-bg);
  padding: 8px;
  border-radius: 7px;
}
.demo-carousel .demo-img-patten-top {
  position: absolute;
  right: -50px;
  top: -16px;
  max-width: 230px;
}
.demo-carousel .demo-img-patten-bottom {
  position: absolute;
  left: -70px;
  bottom: -50px;
  max-width: 230px;
}

.client-images img {
  max-height: 45px;
  width: auto;
  margin: 12px auto;
  transition: all 0.4s;
}

.plan-box {
  max-width: 356px;
  margin-left: auto;
  margin-right: auto;
}

.process-card {
  position: relative;
}
.process-card .process-arrow-img {
  position: absolute;
  left: 75%;
  top: 7%;
  width: 50%;
  opacity: 0.1;
}

.custom-footer {
  color: #9ba7b3;
}

.footer-list li a {
  color: #9ba7b3;
  padding: 7px 0;
  display: block;
  transition: all 0.3s ease-in-out;
}
.footer-list li a:hover {
  color: rgba(255, 255, 255, 0.9);
}

.footer-social-link .avatar-title {
  color: #778089;
  background-color: rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
}
.footer-social-link .avatar-title:hover {
  color: #fff;
  background-color: #b4d0f0;
}

#back-to-top.landing-back-top {
  bottom: 35px;
}

[data-bs-theme=dark] .layout-wrapper.landing .demo-img-patten-top,
[data-bs-theme=dark] .layout-wrapper.landing .demo-img-patten-bottom {
  opacity: 0.2;
}
[data-bs-theme=dark] .layout-wrapper.landing footer.bg-dark {
  background-color: var(--vz-secondary-bg) !important;
}
[data-bs-theme=dark] .navbar-light.is-sticky .navbar-brand .card-logo-dark {
  display: none;
}
[data-bs-theme=dark] .navbar-light.is-sticky .navbar-brand .card-logo-light {
  display: block;
}

.bookmark-icon .btn {
  color: var(--vz-secondary-color);
  background-color: var(--vz-light) !important;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  font-size: 0.825rem;
}
.bookmark-icon .btn:hover, .bookmark-icon .btn.active {
  border-color: transparent;
  color: #ed5e5e;
}

.explore-box {
  border-radius: 9px;
  overflow: hidden;
}
.explore-box .explore-img {
  height: 280px;
  object-fit: cover;
}
.explore-box .explore-place-bid-img {
  position: relative;
  overflow: hidden;
  z-index: 0;
}
.explore-box .explore-place-bid-img .bg-overlay {
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(54, 61, 72, 0.4);
  opacity: 0;
  transition: all 0.5s ease;
}
.explore-box .explore-place-bid-img .place-bid-btn {
  top: 50%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
}
.explore-box .explore-place-bid-img .place-bid-btn .btn {
  opacity: 0;
  bottom: -25px;
  transition: 0.5s ease;
}
.explore-box:hover .explore-place-bid-img .place-bid-btn .btn {
  opacity: 1;
  bottom: 0;
}
.explore-box:hover .explore-place-bid-img .bg-overlay {
  opacity: 1;
}
.explore-box .discount-time {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(5px);
  padding: 8px;
}

.nft-hero {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_76___});
  background-size: cover;
  background-position: bottom;
  padding: 222px 0 150px 0;
}
.nft-hero .bg-overlay {
  background-color: #05175f;
  opacity: 0.85;
}

#explorecard-list .list-element {
  display: none;
}
#explorecard-list .list-element:nth-child(-n+10) {
  display: block;
}

.file-manager-menu {
  max-height: calc(100vh - 296px);
}
@media (max-width: 991.98px) {
  .file-manager-menu {
    height: calc(100vh - 296px);
  }
}
.file-manager-menu li {
  padding: 5px 0px;
}
.file-manager-menu li a {
  color: var(--vz-body-color);
  font-weight: 400;
  transition: all 0.5s ease;
}
.file-manager-menu li a.active, .file-manager-menu li a:hover, .file-manager-menu li a[aria-expanded=true] {
  color: #13c56b;
}
.file-manager-menu li .sub-menu li {
  padding-left: 25px;
  position: relative;
}
.file-manager-menu li .sub-menu li::before {
  content: "󰍴";
  position: absolute;
  left: 0px;
  font-family: Material Design Icons;
  color: rgba(var(--vz-dark-rgb), 0.4);
}

.file-manager-sidebar {
  position: relative;
  background-color: var(--vz-secondary-bg);
}
@media (min-width: 992px) {
  .file-manager-sidebar {
    min-width: 300px;
    max-width: 300px;
    height: calc(100vh - 70px - 60px - 8px);
  }
}
@media (max-width: 991.98px) {
  .file-manager-sidebar {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 200px;
    max-width: 100%;
    z-index: 1003;
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    transform: translateX(-100%);
    visibility: hidden;
    height: 100vh;
  }
  .file-manager-sidebar.menubar-show {
    visibility: visible;
    transform: none;
  }
}

.file-menu-sidebar-scroll {
  height: calc(100vh - 375px);
}
@media (max-width: 991.98px) {
  .file-menu-sidebar-scroll {
    height: calc(100vh - 190px);
  }
}

.file-manager-content {
  background-color: var(--vz-secondary-bg);
}

.file-manager-content-scroll {
  height: calc(100vh - 185px);
}
@media (max-width: 991.98px) {
  .file-manager-content-scroll {
    height: calc(100vh - 144px);
  }
}
.file-manager-content-scroll .simplebar-content {
  height: 100%;
}

.file-detail-content-scroll {
  height: calc(100vh - 180px);
}
@media (max-width: 991.98px) {
  .file-detail-content-scroll {
    height: 100vh;
  }
}
.file-detail-content-scroll .simplebar-content {
  height: 100%;
}

.file-manager-detail-content {
  width: 32%;
  max-width: 100%;
  background-color: var(--vz-secondary-bg);
  display: none;
}

.file-detail-show .file-manager-detail-content {
  display: block;
}

#file-overview {
  display: none;
}

@media (max-width: 1399.98px) {
  .file-manager-detail-content {
    position: fixed;
    top: 0;
    bottom: 0;
    left: auto;
    right: 0;
    width: 400px;
    max-width: 100%;
    z-index: 1003;
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    transform: translateX(100%);
  }

  .file-detail-show .file-manager-detail-content {
    transform: none;
  }
}
.file-details-box {
  height: 195px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.to-do-menu li .nav-link {
  color: var(--vz-body-color);
  padding-left: 0;
  font-weight: 400;
  background-color: var(--vz-light);
  padding: 10px 12px;
  border-radius: 4px;
  display: block;
  margin-bottom: 8px;
}
.to-do-menu li .nav-link:hover, .to-do-menu li .nav-link.active {
  color: #13c56b;
}

.todo-content {
  height: calc(100vh - 362px);
  overflow-y: auto;
}
.todo-content::-webkit-scrollbar {
  -webkit-appearance: none;
}
.todo-content::-webkit-scrollbar:vertical {
  width: 8px;
}
.todo-content::-webkit-scrollbar:horizontal {
  height: 10px;
}
.todo-content::-webkit-scrollbar-thumb {
  background-color: rgba(var(--vz-body-color-rgb), 0.075);
  border-radius: 8px;
}
.todo-content::-webkit-scrollbar-track {
  border-radius: 8px;
}

.todo-task table .form-check .form-check-input:checked + .form-check-label {
  text-decoration: line-through;
}

.task-handle {
  cursor: move;
}

#task-error-msg {
  display: none;
}

.bg-job {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_77___});
  background-size: cover;
  background-position: center;
}

.job-list-view-card .background {
  height: 130px;
}

@media (min-width: 1400px) and (max-width: 1499.98px) {
  .job-list-row.row .col-xxl-3 {
    width: 33%;
  }
}

.custom-container {
  width: 90%;
}

.job-navbar .dropdown-menu .dropdown-item .avatar-sm {
  height: 2.5rem;
  width: 2.5rem;
}
@media (max-width: 991.98px) {
  .job-navbar {
    background-color: var(--vz-secondary-bg);
    padding: 16px 0;
  }
}

.job-hero-section {
  position: relative;
  padding: 165px 0;
  overflow-x: hidden;
}

.job-panel-filter {
  background-color: var(--vz-secondary-bg);
  border-radius: 0.25rem;
  overflow: hidden;
}
.job-panel-filter .form-control {
  height: 45px;
  border: none;
  border-radius: 0;
  background-color: transparent;
}
.job-panel-filter .btn {
  border-radius: 0;
}
.job-panel-filter input.form-control {
  border-right: 1px solid var(--vz-border-color);
}
@media (max-width: 767.98px) {
  .job-panel-filter {
    background-color: transparent;
  }
  .job-panel-filter .form-control {
    background-color: #fff;
    border-radius: var(--vz-border-radius);
  }
  .job-panel-filter input.form-control {
    border: 0;
  }
  .job-panel-filter .btn {
    border-radius: var(--vz-border-radius);
  }
}

.circle-effect {
  position: absolute;
  top: 0;
  z-index: 0;
  right: -55px;
  margin: 0 auto;
}
.circle-effect .circle {
  border: 1px solid var(--vz-border-color);
  height: 240px;
  width: 240px;
  margin: 0 auto;
  border-radius: 50%;
}
.circle-effect .circle2 {
  position: absolute;
  top: -20px;
  right: -20px;
  border: 1px solid var(--vz-border-color);
  height: 280px;
  width: 280px;
  margin: 0 auto;
  border-radius: 50%;
}
.circle-effect .circle3 {
  position: absolute;
  top: -40px;
  right: -40px;
  border: 1px solid var(--vz-border-color);
  height: 320px;
  width: 320px;
  margin: 0 auto;
  border-radius: 50%;
}
.circle-effect .circle4 {
  position: absolute;
  top: -60px;
  right: -60px;
  border: 1px solid var(--vz-border-color);
  height: 360px;
  width: 360px;
  margin: 0 auto;
  border-radius: 50%;
}
@media (max-width: 991.98px) {
  .circle-effect {
    display: none;
  }
}

.home-img .user-img {
  position: relative;
  z-index: 1;
}

.application-box,
.feedback-box,
.inquiry-box {
  max-width: 240px;
  position: absolute;
  z-index: 2;
  transition: all 0.5s ease;
}
.application-box:hover,
.feedback-box:hover,
.inquiry-box:hover {
  transform: translateY(-5px);
}

.inquiry-box {
  left: -134px;
  top: 90px;
}
@media (max-width: 991.98px) {
  .inquiry-box {
    left: 0;
  }
}

.application-box {
  bottom: 50px;
  right: -160px;
}
@media (max-width: 991.98px) {
  .application-box {
    right: 0;
  }
}

.feedback-box {
  right: -50px;
  bottom: -54px;
}
@media (max-width: 576.98px) {
  .feedback-box {
    right: 0;
    bottom: 0;
  }
}

.job-icon-effect {
  height: 30px;
  width: 30px;
  position: absolute;
  top: 0px;
  left: -2%;
  border-radius: 50%;
  background: repeating-linear-gradient(-55deg, rgba(255, 255, 255, 0) 0.8px, #13c56b 1.6px, #13c56b 2px, rgba(255, 255, 255, 0) 3.8px, rgba(255, 255, 255, 0) 5px);
  z-index: 0;
  opacity: 0.2;
}
.job-icon-effect span {
  position: relative;
  z-index: 1;
}

.about-img-section {
  position: relative;
}
.about-img-section::before {
  content: "";
  position: absolute;
  left: 20px;
  right: -20px;
  top: -20px;
  bottom: 20px;
  border: 1px solid #50c3e6;
  z-index: 0;
  border-radius: 0.25rem;
}
@media (max-width: 576.98px) {
  .about-img-section::before {
    right: 20px;
    top: 20px;
  }
}

.features-company-widgets {
  position: absolute;
  bottom: -18px;
  right: -35px;
}

/*
Template Name: Velzon - Admin & Dashboard Template
Author: Themesbrand
Website: https://themesbrand.com/
Contact: support@themesbrand.com
File: Custom Css File
*/
.offcanvas-header-dark .btn-close {
  filter: invert(1) grayscale(100%) brightness(200%);
}

body * {
  outline: none;
}

.noUi-horizontal .noUi-handle {
  height: 16px !important;
  width: 16px !important;
  border-radius: 50% !important;
  right: -10px !important;
  top: -7px !important;
}

.noUi-connect,
.noUi-horizontal {
  height: 2px !important;
  background: #13c56b !important;
}

.noUi-handle {
  background: #13c56b !important;
  border: 2px solid var(--vz-card-bg) !important;
  box-shadow: none !important;
}

.noUi-target {
  background: #fafafa !important;
  border-radius: 4px !important;
  border: 1px solid #d3d3d3 !important;
  background-color: var(--vz-light) !important;
  border-color: var(--vz-light) !important;
  box-shadow: none !important;
  height: 4px !important;
}

.dropzone .dz-message {
  text-align: center;
}

.fc-direction-ltr .fc-daygrid-event.fc-event-end,
.fc-direction-rtl .fc-daygrid-event.fc-event-start {
  padding: 5px !important;
  font-size: 12px !important;
  margin-right: 2px;
}

.fc-event {
  border: none !important;
}

@media (max-width: 575.98px) {
  .fc-toolbar {
    display: block !important;
    text-align: center;
  }
  .fc-toolbar .fc-left,
.fc-toolbar .fc-right,
.fc-toolbar .fc-center {
    float: none;
    display: block;
    clear: both;
    margin: 10px 0;
  }

  .fc .fc-toolbar > * > * {
    float: none;
  }

  .fc-today-button {
    display: none;
  }
}
.flatpickr-calendar.open {
  z-index: 1090 !important;
}

.upcoming-scheduled .flatpickr-input[readonly] {
  display: none;
}

.ql-container.ql-snow {
  height: 250px;
}

.rangeslider-horizontal .rangeslider__fill {
  background-color: #6691e7 !important;
}

.simplebar-track-primary .simplebar-scrollbar:before {
  background: #b4d0f0 !important;
}

.simplebar-track-secondary .simplebar-scrollbar:before {
  background: #daecfb !important;
}

.simplebar-track-success .simplebar-scrollbar:before {
  background: #13c56b !important;
}

.simplebar-track-info .simplebar-scrollbar:before {
  background: #50c3e6 !important;
}

.simplebar-track-warning .simplebar-scrollbar:before {
  background: #e8bc52 !important;
}

.simplebar-track-danger .simplebar-scrollbar:before {
  background: #ed5e5e !important;
}

.simplebar-track-light .simplebar-scrollbar:before {
  background: #f3f6f9 !important;
}

.simplebar-track-dark .simplebar-scrollbar:before {
  background: #363d48 !important;
}

.simplebar-track-custom-primary .simplebar-scrollbar:before {
  background: #7eabe7 !important;
}

.simplebar-track-custom-primary-hover .simplebar-scrollbar:before {
  background: #bcd4f8 !important;
}

.simplebar-track-new-primary .simplebar-scrollbar:before {
  background: #0A56AE !important;
}

.simplebar-track-header .simplebar-scrollbar:before {
  background: #bdd6fb !important;
}

.simplebar-track-next-button .simplebar-scrollbar:before {
  background: #83a9e2 !important;
}

.simplebar-track-next-button-border .simplebar-scrollbar:before {
  background: #5d87c7 !important;
}

.simplebar-track-next-button-hover .simplebar-scrollbar:before {
  background: #bdd6fa !important;
}

.simplebar-track-white .simplebar-scrollbar:before {
  background: #fff !important;
}

.simplebar-track-light-grey .simplebar-scrollbar:before {
  background: #ced4da !important;
}

.chat-conversation .chat-list .message-box-drop .nav-btn {
  font-size: 18px;
  padding: 4px;
  color: #878a99;
}

.chatwidgets {
  height: 250px !important;
}

[data-layout=horizontal] .chat-conversation.chatwidgets {
  height: 250px !important;
}

#tsparticles canvas {
  position: absolute !important;
}

.process-card .process-arrow-img {
  left: auto;
  right: 75%;
  transform: scaleX(-1);
}

.icon-effect::before {
  left: auto;
  right: 0;
}

.marketplace-swiper .swiper-button-next,
.marketplace-swiper .swiper-button-prev {
  top: 22px;
}

.alert-msg-show {
  right: 24px;
  top: 40px;
  z-index: 1005;
}

.pickerEmoji {
  position: absolute;
  bottom: -50px;
  left: 10%;
  transform: translateX(-50%);
}

.Toastify .Toastify__toast {
  min-height: 43px;
}
.Toastify .Toastify__close-button {
  top: 6px;
}
.Toastify .Toastify__close-button--light {
  color: #f3f6f9;
}

.rdl-filter,
.rdl-control {
  background-color: var(--vz-input-bg-custom);
  border: 1px solid var(--vz-input-border-custom) !important;
  color: var(--vz-body-color) !important;
}

.rdl-move {
  background: var(--vz-header) !important;
  border: 1px solid var(--vz-header) !important;
  color: var(--vz---vz-body-color) !important;
}

.react-dual-listbox input:disabled,
.react-dual-listbox select:disabled {
  background-color: var(--vz-tertiary-bg) !important;
  border: 1px solid var(--vz-input-border-custom) !important;
}

.css-26l3qy-menu {
  background-color: var(--vz-gray-200) !important;
  border-color: var(--vz-border-color) !important;
}

.css-1n7v3ny-option {
  background-color: var(--vz-gray-300) !important;
  border-color: var(--vz-border-color) !important;
}

/* Change the white to any color */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px var(--vz-input-bg) inset !important;
  background-color: var(--vz-input-bg) !important;
  color: var(--vz-body-color) !important;
  -webkit-text-fill-color: var(--vz-body-color) !important;
}

.css-b62m3t-container .css-13cymwt-control {
  background-color: var(--vz-secondary-bg);
  color: var(--vz-body-color);
  border-color: var(--vz-border-color);
}
.css-b62m3t-container .css-13cymwt-control:hover, .css-b62m3t-container .css-13cymwt-control:focus {
  border-color: var(--vz-primary);
}
.css-b62m3t-container .css-13cymwt-control .css-1p3m7a8-multiValue {
  color: var(--vz-white);
  background-color: var(--vz-primary);
}
.css-b62m3t-container .css-13cymwt-control .css-1p3m7a8-multiValue .css-wsp0cs-MultiValueGeneric {
  color: var(--vz-white);
}
.css-b62m3t-container .css-13cymwt-control .css-1p3m7a8-multiValue .css-1u9des2-indicatorSeparator {
  border-color: var(--vz-border-color);
}
.css-b62m3t-container :is(.css-qbdosj-Input, .css-1dimb5e-singleValue) {
  color: var(--vz-body-color);
}
.css-b62m3t-container .css-t3ipsp-control {
  background-color: var(--vz-secondary-bg);
  color: var(--vz-body-color);
  border-color: var(--vz-border-color);
}
.css-b62m3t-container .css-t3ipsp-control .css-1p3m7a8-multiValue {
  color: var(--vz-white);
  background-color: var(--vz-primary);
}
.css-b62m3t-container .css-t3ipsp-control .css-1p3m7a8-multiValue .css-wsp0cs-MultiValueGeneric {
  color: var(--vz-white);
}
.css-b62m3t-container .css-t3ipsp-control .css-1p3m7a8-multiValue .css-1u9des2-indicatorSeparator {
  border-color: var(--vz-border-color);
}
.css-b62m3t-container .css-1nmdiq5-menu {
  background-color: var(--vz-secondary-bg);
  color: var(--vz-body-color);
  border-color: var(--vz-border-color);
}
.css-b62m3t-container .css-1nmdiq5-menu .css-d7l1ni-option {
  color: #fff;
  background-color: var(--vz-primary);
}
.css-b62m3t-container .css-1nmdiq5-menu .css-d7l1ni-option:hover, .css-b62m3t-container .css-1nmdiq5-menu .css-d7l1ni-option:active, .css-b62m3t-container .css-1nmdiq5-menu .css-d7l1ni-option:focus {
  background-color: var(--vz-primary);
}`, "",{"version":3,"sources":["webpack://./../common/src/assets/scss/themes.scss","webpack://./../common/src/assets/scss/icons.scss","webpack://./../common/src/assets/scss/plugins/icons/_materialdesignicons.scss","webpack://./../common/src/assets/scss/plugins/icons/_boxicons.scss","webpack://./../common/src/assets/scss/plugins/icons/_line-awesome.scss","webpack://./../common/src/assets/scss/plugins/icons/_remixicon.scss","webpack://./../common/src/assets/scss/config/saas/bootstrap.scss","webpack://./../common/src/assets/scss/config/saas/_variables.scss","webpack://./../common/src/assets/scss/config/saas/_variables-dark.scss","webpack://./../node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./../node_modules/bootstrap/scss/_root.scss","webpack://./../node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./../node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./../node_modules/bootstrap/scss/_reboot.scss","webpack://./../node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./../node_modules/bootstrap/scss/_type.scss","webpack://./../node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./../node_modules/bootstrap/scss/_images.scss","webpack://./../node_modules/bootstrap/scss/mixins/_image.scss","webpack://./../node_modules/bootstrap/scss/_containers.scss","webpack://./../node_modules/bootstrap/scss/mixins/_container.scss","webpack://./../node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./../node_modules/bootstrap/scss/_grid.scss","webpack://./../node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./../node_modules/bootstrap/scss/_tables.scss","webpack://./../node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./../node_modules/bootstrap/scss/forms/_labels.scss","webpack://./../node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./../node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./../node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./../node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./../node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./../node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./../node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./../node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./../node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./../node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./../node_modules/bootstrap/scss/_variables.scss","webpack://./../node_modules/bootstrap/scss/_buttons.scss","webpack://./../node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./../node_modules/bootstrap/scss/_transitions.scss","webpack://./../node_modules/bootstrap/scss/_dropdown.scss","webpack://./../node_modules/bootstrap/scss/_button-group.scss","webpack://./../node_modules/bootstrap/scss/_nav.scss","webpack://./../node_modules/bootstrap/scss/_navbar.scss","webpack://./../node_modules/bootstrap/scss/_card.scss","webpack://./../node_modules/bootstrap/scss/_accordion.scss","webpack://./../node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./../node_modules/bootstrap/scss/_pagination.scss","webpack://./../node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./../node_modules/bootstrap/scss/_badge.scss","webpack://./../node_modules/bootstrap/scss/_alert.scss","webpack://./../node_modules/bootstrap/scss/_progress.scss","webpack://./../node_modules/bootstrap/scss/_list-group.scss","webpack://./../node_modules/bootstrap/scss/_close.scss","webpack://./../node_modules/bootstrap/scss/_toasts.scss","webpack://./../node_modules/bootstrap/scss/_modal.scss","webpack://./../node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./../node_modules/bootstrap/scss/_tooltip.scss","webpack://./../node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./../node_modules/bootstrap/scss/_popover.scss","webpack://./../node_modules/bootstrap/scss/_carousel.scss","webpack://./../node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./../node_modules/bootstrap/scss/_spinners.scss","webpack://./../node_modules/bootstrap/scss/_offcanvas.scss","webpack://./../node_modules/bootstrap/scss/_placeholders.scss","webpack://./../node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./../node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./../node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./../node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./../node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./../node_modules/bootstrap/scss/helpers/_position.scss","webpack://./../node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./../node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./../node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./../node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./../node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./../node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./../node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./../node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./../node_modules/bootstrap/scss/utilities/_api.scss","webpack://./../common/src/assets/scss/config/saas/app.scss","webpack://./../common/src/assets/scss/fonts/_fonts.scss","webpack://./../common/src/assets/scss/config/saas/custom.scss","webpack://./../common/src/assets/scss/structure/_topbar.scss","webpack://./../common/src/assets/scss/config/saas/_variables-custom.scss","webpack://./../common/src/assets/scss/structure/_page-head.scss","webpack://./../common/src/assets/scss/structure/_footer.scss","webpack://./../common/src/assets/scss/structure/_vertical.scss","webpack://./../common/src/assets/scss/structure/_horizontal.scss","webpack://./../common/src/assets/scss/structure/_two-column.scss","webpack://./../common/src/assets/scss/structure/_layouts.scss","webpack://./../common/src/assets/scss/components/_waves.scss","webpack://./../common/src/assets/scss/components/_avatar.scss","webpack://./../common/src/assets/scss/components/_accordion.scss","webpack://./../common/src/assets/scss/components/_helper.scss","webpack://./../common/src/assets/scss/components/_preloader.scss","webpack://./../common/src/assets/scss/components/_forms.scss","webpack://./../common/src/assets/scss/components/_widgets.scss","webpack://./../common/src/assets/scss/components/_demos.scss","webpack://./../common/src/assets/scss/components/_print.scss","webpack://./../common/src/assets/scss/components/_ribbons.scss","webpack://./../common/src/assets/scss/components/_toast.scss","webpack://./../common/src/assets/scss/components/_scrollspy.scss","webpack://./../common/src/assets/scss/components/_root.scss","webpack://./../common/src/assets/scss/components/_reboot.scss","webpack://./../common/src/assets/scss/components/_alerts.scss","webpack://./../common/src/assets/scss/components/_badge.scss","webpack://./../common/src/assets/scss/components/_buttons.scss","webpack://./../common/src/assets/scss/components/_breadcrumb.scss","webpack://./../common/src/assets/scss/components/_card.scss","webpack://./../common/src/assets/scss/components/_dropdown.scss","webpack://./../common/src/assets/scss/components/_nav.scss","webpack://./../common/src/assets/scss/components/_table.scss","webpack://./../common/src/assets/scss/components/_modal.scss","webpack://./../common/src/assets/scss/components/_pagination.scss","webpack://./../common/src/assets/scss/components/_progress.scss","webpack://./../common/src/assets/scss/components/_popover.scss","webpack://./../common/src/assets/scss/components/_type.scss","webpack://./../common/src/assets/scss/components/_form-check.scss","webpack://./../common/src/assets/scss/components/_form-control.scss","webpack://./../common/src/assets/scss/components/_list-group.scss","webpack://./../common/src/assets/scss/plugins/_custom-scrollbar.scss","webpack://./../common/src/assets/scss/plugins/_prismjs.scss","webpack://./../common/src/assets/scss/plugins/_sweetalert2.scss","webpack://./../common/src/assets/scss/plugins/_dropzone.scss","webpack://./../common/src/assets/scss/plugins/_range-slider.scss","webpack://./../common/src/assets/scss/plugins/_sortablejs.scss","webpack://./../common/src/assets/scss/plugins/_tour.scss","webpack://./../common/src/assets/scss/plugins/_swiper.scss","webpack://./../common/src/assets/scss/plugins/_multijs.scss","webpack://./../common/src/assets/scss/plugins/_colorpicker.scss","webpack://./../common/src/assets/scss/plugins/_filepond.scss","webpack://./../common/src/assets/scss/plugins/_form-input-spin.scss","webpack://./../common/src/assets/scss/plugins/_ckeditor.scss","webpack://./../common/src/assets/scss/plugins/_quilljs.scss","webpack://./../common/src/assets/scss/plugins/_gridjs.scss","webpack://./../common/src/assets/scss/plugins/_listjs.scss","webpack://./../common/src/assets/scss/plugins/_apexcharts.scss","webpack://./../common/src/assets/scss/plugins/_chartjs.scss","webpack://./../common/src/assets/scss/plugins/_echarts.scss","webpack://./../common/src/assets/scss/plugins/_google-map.scss","webpack://./../common/src/assets/scss/plugins/_autocomplete.scss","webpack://./../common/src/assets/scss/plugins/_vector-maps.scss","webpack://./../common/src/assets/scss/plugins/_leaflet-maps.scss","webpack://./../common/src/assets/scss/plugins/_fullcalendar.scss","webpack://./../common/src/assets/scss/plugins/_emoji-picker.scss","webpack://./../common/src/assets/scss/plugins/_datatables.scss","webpack://./../common/src/assets/scss/plugins/_select2.scss","webpack://./../common/src/assets/scss/plugins/_toastify.scss","webpack://./../common/src/assets/scss/plugins/_choices.scss","webpack://./../common/src/assets/scss/plugins/_flatpicker.scss","webpack://./../common/src/assets/scss/plugins/_flag-input.scss","webpack://./../common/src/assets/scss/pages/_authentication.scss","webpack://./../common/src/assets/scss/pages/_dashboard.scss","webpack://./../common/src/assets/scss/pages/_timeline.scss","webpack://./../common/src/assets/scss/pages/_gallery.scss","webpack://./../common/src/assets/scss/pages/_errors.scss","webpack://./../common/src/assets/scss/pages/_profile.scss","webpack://./../common/src/assets/scss/pages/_sitemap.scss","webpack://./../common/src/assets/scss/pages/_team.scss","webpack://./../common/src/assets/scss/pages/_coming-soon.scss","webpack://./../common/src/assets/scss/pages/_search-results.scss","webpack://./../common/src/assets/scss/pages/_ecommerce.scss","webpack://./../common/src/assets/scss/pages/_invoice.scss","webpack://./../common/src/assets/scss/pages/_chat.scss","webpack://./../common/src/assets/scss/pages/_email.scss","webpack://./../common/src/assets/scss/pages/_kanban.scss","webpack://./../common/src/assets/scss/pages/_landing.scss","webpack://./../common/src/assets/scss/pages/_nft-landing.scss","webpack://./../common/src/assets/scss/pages/_file-manager.scss","webpack://./../common/src/assets/scss/pages/_to-do.scss","webpack://./../common/src/assets/scss/pages/_jobs.scss","webpack://./../common/src/assets/scss/pages/_job-landing.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;;;CAAA;ACAA,4BAAA;AACA;EACE,oCAAA;EACA,4CAAA;EACA,qPAAA;EACA,mBAAA;EACA,kBAAA;AFeF;AEZA;;EAEE,qBAAA;EACA,yDAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,aAAA;AFcF;;AEXA;EACE,YAAA;EACA,kBAAA;AFcF;;AEXA;EACE,eAAA;AFcF;;AEXA;EACE,eAAA;AFcF;;AEXA;EACE,eAAA;AFcF;;AEXA;EACE,eAAA;AFcF;;AEXA;EACE,0BAAA;AFcF;;AEXA;EACE,0BAAA;AFcF;;AEXA;EACE,YAAA;AFcF;;AEXA;EACE,+BAAA;AFcF;;AEXA;EACE;;;;;;;;;;;;;;;SAAA;AF6BF;;AEXA;EAGE,wBAAA;AFcF;;AEXA;EACE;;;;;;;;;;;;;;;SAAA;AF6BF;;AEXA;EAGE,wBAAA;AFcF;;AEXA;EACE;;;;;;;;;;;;;;;SAAA;AF6BF;;AEXA;EAGE,yBAAA;AFcF;;AEXA;EACE;;;;;;;;;;;;;;;SAAA;AF6BF;;AEXA;EAGE,yBAAA;AFcF;;AEXA;EACE;;;;;;;;;;;;;;;SAAA;AF6BF;;AEXA;EAGE,yBAAA;AFcF;;AEXA;EACE;;;;;;;;;;;;;;;SAAA;AF6BF;;AEXA;EAGE,yBAAA;AFcF;;AEXA;EACE;;;;;;;;;;;;;;;SAAA;AF6BF;;AEXA;EAGE,yBAAA;AFcF;;AEXA;EAEE,qBAAA;EACA,aAAA;EACA,mBAAA;AFcF;;AEXA;EAEE,qBAAA;EACA,aAAA;EACA,mBAAA;AFcF;;AEXA;EAEE,sCAAA;AFcF;AEAA;EACE;IAEE,uBAAA;EFaF;EEXA;IAEE,yBAAA;EFaF;AACF;AEVA,kDAAA;AC3h0BA;EAEI,uBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,4CAAA;EACA,4SAAA;AHsi0BJ;AGhi0BA;EAEI,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;EACA,qBAAA;EAEA,oBAAA;EAEA,WAAA;EACA,mCAAA;EACA,kCAAA;AH+h0BJ;;AG7h0BA;EAEI,gBAAA;EACA,eAAA;EAEA,gBAAA;AH8h0BJ;;AG5h0BA;EAEI,kBAAA;AH8h0BJ;;AG5h0BA;EAEI,kBAAA;EACA,oBAAA;EAEA,kBAAA;EACA,UAAA;EAEA,UAAA;EAEA,kBAAA;AH2h0BJ;AG5g0BA;EAEI;IAGY,oBAAA;EHuh0Bd;EGrh0BE;IAGY,yBAAA;EHsh0Bd;AACF;AGng0BA;EAEI;IAGY,mBAAA;IAER,UAAA;EH8g0BN;EG5g0BE;IAGY,qBAAA;IAER,UAAA;EH4g0BN;AACF;AG3/zBA;EAEI;IAEI,UAAA;EHsg0BN;EGpg0BE;IAEI,UAAA;EHqg0BN;EGng0BE;IAEI,UAAA;EHog0BN;AACF;AGj/zBA;EAEI;IAGY,wBAAA;IAER,UAAA;EH4/zBN;EG1/zBE;IAGY,4BAAA;IAER,UAAA;EH0/zBN;AACF;AGv+zBA;EAEI;IAGY,wBAAA;IAER,UAAA;EHk/zBN;EGh/zBE;IAGY,2BAAA;IAER,UAAA;EHg/zBN;AACF;AG79zBA;EAEI;IAGY,wBAAA;IAER,UAAA;EHw+zBN;EGt+zBE;IAGY,4BAAA;IAER,UAAA;EHs+zBN;AACF;AGn9zBA;EAEI;IAGY,wBAAA;IAER,UAAA;EH89zBN;EG59zBE;IAGY,2BAAA;IAER,UAAA;EH49zBN;AACF;AGn7zBA;EAEI;IAGY,2BAAA;EHy8zBd;EGt8zBE;IAIY,8DAAA;EHs8zBd;EGn8zBE;IAMY,oDAAA;EHi8zBd;EG97zBE;IAKY,oCAAA;EH67zBd;EG17zBE;IAGY,2BAAA;EH27zBd;AACF;AGz7zBA;EAGY,kCAAA;AH07zBZ;;AGx7zBA;EAGY,kCAAA;AH07zBZ;;AGv7zBA;EAGY,kCAAA;AHy7zBZ;;AGv7zBA;EAGY,kCAAA;AHy7zBZ;;AGt7zBA;EAGY,wCAAA;AHw7zBZ;;AGt7zBA;EAGY,wCAAA;AHw7zBZ;;AGr7zBA;EAGY,qCAAA;AHu7zBZ;;AGr7zBA;EAGY,qCAAA;AHu7zBZ;;AGr7zBA;EAGY,uCAAA;AHu7zBZ;;AGr7zBA;EAGY,uCAAA;AHu7zBZ;;AGr7zBA;EAGY,yCAAA;AHu7zBZ;;AGr7zBA;EAGY,yCAAA;AHu7zBZ;;AGr7zBA;EAGY,yCAAA;AHu7zBZ;;AGr7zBA;EAGY,yCAAA;AHu7zBZ;;AGr7zBA;EAGY,0CAAA;AHu7zBZ;;AGr7zBA;EAGY,0CAAA;AHu7zBZ;;AGr7zBA;EAEI,0BAAA;AHu7zBJ;;AGr7zBA;EAEI,6BAAA;AHu7zBJ;;AGr7zBA;EAEI,6BAAA;AHu7zBJ;;AGr7zBA;EAEI,0BAAA;AHu7zBJ;;AGr7zBA;EAEI,yBAAA;EACA,kBAAA;EAEA,qBAAA;EACA,aAAA;EACA,6BAAA;EAEA,sBAAA;AHq7zBJ;;AGn7zBA;EAEI,WAAA;EAEA,8BAAA;AHo7zBJ;;AGl7zBA;EAEI,YAAA;EAEA,6BAAA;AHm7zBJ;;AGj7zBA;EAEI,wBAAA;EAEA,sEAAA;AHk7zBJ;;AGh7zBA;EAEI,yBAAA;EAEA,sEAAA;AHi7zBJ;;AG/6zBA;EAEI,yBAAA;EAEA,sEAAA;AHg7zBJ;;AG96zBA;EAEI,qBAAA;EAEA,gFAAA;AH+6zBJ;;AG76zBA;EAEI,qBAAA;EAEA,gFAAA;AH86zBJ;;AG56zBA;EAEI,eAAA;EAEA,uCAAA;EACA,qBAAA;AH66zBJ;;AG36zBA;EAEI,eAAA;EAEA,uCAAA;EACA,kBAAA;AH46zBJ;;AGx6zBE;EACE,YAAA;AH26zBJ;;AGz6zBE;EACE,YAAA;AH46zBJ;;AG16zBE;EACE,YAAA;AH66zBJ;;AG36zBE;EACE,YAAA;AH86zBJ;;AG56zBE;EACE,YAAA;AH+6zBJ;;AG76zBE;EACE,YAAA;AHg7zBJ;;AG96zBE;EACE,YAAA;AHi7zBJ;;AG/6zBE;EACE,YAAA;AHk7zBJ;;AGh7zBE;EACE,YAAA;AHm7zBJ;;AGj7zBE;EACE,YAAA;AHo7zBJ;;AGl7zBE;EACE,YAAA;AHq7zBJ;;AGn7zBE;EACE,YAAA;AHs7zBJ;;AGp7zBE;EACE,YAAA;AHu7zBJ;;AGr7zBE;EACE,YAAA;AHw7zBJ;;AGt7zBE;EACE,YAAA;AHy7zBJ;;AGv7zBE;EACE,YAAA;AH07zBJ;;AGx7zBE;EACE,YAAA;AH27zBJ;;AGz7zBE;EACE,YAAA;AH47zBJ;;AG17zBE;EACE,YAAA;AH67zBJ;;AG37zBE;EACE,YAAA;AH87zBJ;;AG57zBE;EACE,YAAA;AH+7zBJ;;AG77zBE;EACE,YAAA;AHg8zBJ;;AG97zBE;EACE,YAAA;AHi8zBJ;;AG/7zBE;EACE,YAAA;AHk8zBJ;;AGh8zBE;EACE,YAAA;AHm8zBJ;;AGj8zBE;EACE,YAAA;AHo8zBJ;;AGl8zBE;EACE,YAAA;AHq8zBJ;;AGn8zBE;EACE,YAAA;AHs8zBJ;;AGp8zBE;EACE,YAAA;AHu8zBJ;;AGr8zBE;EACE,YAAA;AHw8zBJ;;AGt8zBE;EACE,YAAA;AHy8zBJ;;AGv8zBE;EACE,YAAA;AH08zBJ;;AGx8zBE;EACE,YAAA;AH28zBJ;;AGz8zBE;EACE,YAAA;AH48zBJ;;AG18zBE;EACE,YAAA;AH68zBJ;;AG38zBE;EACE,YAAA;AH88zBJ;;AG58zBE;EACE,YAAA;AH+8zBJ;;AG78zBE;EACE,YAAA;AHg9zBJ;;AG98zBE;EACE,YAAA;AHi9zBJ;;AG/8zBE;EACE,YAAA;AHk9zBJ;;AGh9zBE;EACE,YAAA;AHm9zBJ;;AGj9zBE;EACE,YAAA;AHo9zBJ;;AGl9zBE;EACE,YAAA;AHq9zBJ;;AGn9zBE;EACE,YAAA;AHs9zBJ;;AGp9zBE;EACE,YAAA;AHu9zBJ;;AGr9zBE;EACE,YAAA;AHw9zBJ;;AGt9zBE;EACE,YAAA;AHy9zBJ;;AGv9zBE;EACE,YAAA;AH09zBJ;;AGx9zBE;EACE,YAAA;AH29zBJ;;AGz9zBE;EACE,YAAA;AH49zBJ;;AG19zBE;EACE,YAAA;AH69zBJ;;AG39zBE;EACE,YAAA;AH89zBJ;;AG59zBE;EACE,YAAA;AH+9zBJ;;AG79zBE;EACE,YAAA;AHg+zBJ;;AG99zBE;EACE,YAAA;AHi+zBJ;;AG/9zBE;EACE,YAAA;AHk+zBJ;;AGh+zBE;EACE,YAAA;AHm+zBJ;;AGj+zBE;EACE,YAAA;AHo+zBJ;;AGl+zBE;EACE,YAAA;AHq+zBJ;;AGn+zBE;EACE,YAAA;AHs+zBJ;;AGp+zBE;EACE,YAAA;AHu+zBJ;;AGr+zBE;EACE,YAAA;AHw+zBJ;;AGt+zBE;EACE,YAAA;AHy+zBJ;;AGv+zBE;EACE,YAAA;AH0+zBJ;;AGx+zBE;EACE,YAAA;AH2+zBJ;;AGz+zBE;EACE,YAAA;AH4+zBJ;;AG1+zBE;EACE,YAAA;AH6+zBJ;;AG3+zBE;EACE,YAAA;AH8+zBJ;;AG5+zBE;EACE,YAAA;AH++zBJ;;AG7+zBE;EACE,YAAA;AHg/zBJ;;AG9+zBE;EACE,YAAA;AHi/zBJ;;AG/+zBE;EACE,YAAA;AHk/zBJ;;AGh/zBE;EACE,YAAA;AHm/zBJ;;AGj/zBE;EACE,YAAA;AHo/zBJ;;AGl/zBE;EACE,YAAA;AHq/zBJ;;AGn/zBE;EACE,YAAA;AHs/zBJ;;AGp/zBE;EACE,YAAA;AHu/zBJ;;AGr/zBE;EACE,YAAA;AHw/zBJ;;AGt/zBE;EACE,YAAA;AHy/zBJ;;AGv/zBE;EACE,YAAA;AH0/zBJ;;AGx/zBE;EACE,YAAA;AH2/zBJ;;AGz/zBE;EACE,YAAA;AH4/zBJ;;AG1/zBE;EACE,YAAA;AH6/zBJ;;AG3/zBE;EACE,YAAA;AH8/zBJ;;AG5/zBE;EACE,YAAA;AH+/zBJ;;AG7/zBE;EACE,YAAA;AHgg0BJ;;AG9/zBE;EACE,YAAA;AHig0BJ;;AG//zBE;EACE,YAAA;AHkg0BJ;;AGhg0BE;EACE,YAAA;AHmg0BJ;;AGjg0BE;EACE,YAAA;AHog0BJ;;AGlg0BE;EACE,YAAA;AHqg0BJ;;AGng0BE;EACE,YAAA;AHsg0BJ;;AGpg0BE;EACE,YAAA;AHug0BJ;;AGrg0BE;EACE,YAAA;AHwg0BJ;;AGtg0BE;EACE,YAAA;AHyg0BJ;;AGvg0BE;EACE,YAAA;AH0g0BJ;;AGxg0BE;EACE,YAAA;AH2g0BJ;;AGzg0BE;EACE,YAAA;AH4g0BJ;;AG1g0BE;EACE,YAAA;AH6g0BJ;;AG3g0BE;EACE,YAAA;AH8g0BJ;;AG5g0BE;EACE,YAAA;AH+g0BJ;;AG7g0BE;EACE,YAAA;AHgh0BJ;;AG9g0BE;EACE,YAAA;AHih0BJ;;AG/g0BE;EACE,YAAA;AHkh0BJ;;AGhh0BE;EACE,YAAA;AHmh0BJ;;AGjh0BE;EACE,YAAA;AHoh0BJ;;AGlh0BE;EACE,YAAA;AHqh0BJ;;AGnh0BE;EACE,YAAA;AHsh0BJ;;AGph0BE;EACE,YAAA;AHuh0BJ;;AGrh0BE;EACE,YAAA;AHwh0BJ;;AGth0BE;EACE,YAAA;AHyh0BJ;;AGvh0BE;EACE,YAAA;AH0h0BJ;;AGxh0BE;EACE,YAAA;AH2h0BJ;;AGzh0BE;EACE,YAAA;AH4h0BJ;;AG1h0BE;EACE,YAAA;AH6h0BJ;;AG3h0BE;EACE,YAAA;AH8h0BJ;;AG5h0BE;EACE,YAAA;AH+h0BJ;;AG7h0BE;EACE,YAAA;AHgi0BJ;;AG9h0BE;EACE,YAAA;AHii0BJ;;AG/h0BE;EACE,YAAA;AHki0BJ;;AGhi0BE;EACE,YAAA;AHmi0BJ;;AGji0BE;EACE,YAAA;AHoi0BJ;;AGli0BE;EACE,YAAA;AHqi0BJ;;AGni0BE;EACE,YAAA;AHsi0BJ;;AGpi0BE;EACE,YAAA;AHui0BJ;;AGri0BE;EACE,YAAA;AHwi0BJ;;AGti0BE;EACE,YAAA;AHyi0BJ;;AGvi0BE;EACE,YAAA;AH0i0BJ;;AGxi0BE;EACE,YAAA;AH2i0BJ;;AGzi0BE;EACE,YAAA;AH4i0BJ;;AG1i0BE;EACE,YAAA;AH6i0BJ;;AG3i0BE;EACE,YAAA;AH8i0BJ;;AG5i0BE;EACE,YAAA;AH+i0BJ;;AG7i0BE;EACE,YAAA;AHgj0BJ;;AG9i0BE;EACE,YAAA;AHij0BJ;;AG/i0BE;EACE,YAAA;AHkj0BJ;;AGhj0BE;EACE,YAAA;AHmj0BJ;;AGjj0BE;EACE,YAAA;AHoj0BJ;;AGlj0BE;EACE,YAAA;AHqj0BJ;;AGnj0BE;EACE,YAAA;AHsj0BJ;;AGpj0BE;EACE,YAAA;AHuj0BJ;;AGrj0BE;EACE,YAAA;AHwj0BJ;;AGtj0BE;EACE,YAAA;AHyj0BJ;;AGvj0BE;EACE,YAAA;AH0j0BJ;;AGxj0BE;EACE,YAAA;AH2j0BJ;;AGzj0BE;EACE,YAAA;AH4j0BJ;;AG1j0BE;EACE,YAAA;AH6j0BJ;;AG3j0BE;EACE,YAAA;AH8j0BJ;;AG5j0BE;EACE,YAAA;AH+j0BJ;;AG7j0BE;EACE,YAAA;AHgk0BJ;;AG9j0BE;EACE,YAAA;AHik0BJ;;AG/j0BE;EACE,YAAA;AHkk0BJ;;AGhk0BE;EACE,YAAA;AHmk0BJ;;AGjk0BE;EACE,YAAA;AHok0BJ;;AGlk0BE;EACE,YAAA;AHqk0BJ;;AGnk0BE;EACE,YAAA;AHsk0BJ;;AGpk0BE;EACE,YAAA;AHuk0BJ;;AGrk0BE;EACE,YAAA;AHwk0BJ;;AGtk0BE;EACE,YAAA;AHyk0BJ;;AGvk0BE;EACE,YAAA;AH0k0BJ;;AGxk0BE;EACE,YAAA;AH2k0BJ;;AGzk0BE;EACE,YAAA;AH4k0BJ;;AG1k0BE;EACE,YAAA;AH6k0BJ;;AG3k0BE;EACE,YAAA;AH8k0BJ;;AG5k0BE;EACE,YAAA;AH+k0BJ;;AG7k0BE;EACE,YAAA;AHgl0BJ;;AG9k0BE;EACE,YAAA;AHil0BJ;;AG/k0BE;EACE,YAAA;AHkl0BJ;;AGhl0BE;EACE,YAAA;AHml0BJ;;AGjl0BE;EACE,YAAA;AHol0BJ;;AGll0BE;EACE,YAAA;AHql0BJ;;AGnl0BE;EACE,YAAA;AHsl0BJ;;AGpl0BE;EACE,YAAA;AHul0BJ;;AGrl0BE;EACE,YAAA;AHwl0BJ;;AGtl0BE;EACE,YAAA;AHyl0BJ;;AGvl0BE;EACE,YAAA;AH0l0BJ;;AGxl0BE;EACE,YAAA;AH2l0BJ;;AGzl0BE;EACE,YAAA;AH4l0BJ;;AG1l0BE;EACE,YAAA;AH6l0BJ;;AG3l0BE;EACE,YAAA;AH8l0BJ;;AG5l0BE;EACE,YAAA;AH+l0BJ;;AG7l0BE;EACE,YAAA;AHgm0BJ;;AG9l0BE;EACE,YAAA;AHim0BJ;;AG/l0BE;EACE,YAAA;AHkm0BJ;;AGhm0BE;EACE,YAAA;AHmm0BJ;;AGjm0BE;EACE,YAAA;AHom0BJ;;AGlm0BE;EACE,YAAA;AHqm0BJ;;AGnm0BE;EACE,YAAA;AHsm0BJ;;AGpm0BE;EACE,YAAA;AHum0BJ;;AGrm0BE;EACE,YAAA;AHwm0BJ;;AGtm0BE;EACE,YAAA;AHym0BJ;;AGvm0BE;EACE,YAAA;AH0m0BJ;;AGxm0BE;EACE,YAAA;AH2m0BJ;;AGzm0BE;EACE,YAAA;AH4m0BJ;;AG1m0BE;EACE,YAAA;AH6m0BJ;;AG3m0BE;EACE,YAAA;AH8m0BJ;;AG5m0BE;EACE,YAAA;AH+m0BJ;;AG7m0BE;EACE,YAAA;AHgn0BJ;;AG9m0BE;EACE,YAAA;AHin0BJ;;AG/m0BE;EACE,YAAA;AHkn0BJ;;AGhn0BE;EACE,YAAA;AHmn0BJ;;AGjn0BE;EACE,YAAA;AHon0BJ;;AGln0BE;EACE,YAAA;AHqn0BJ;;AGnn0BE;EACE,YAAA;AHsn0BJ;;AGpn0BE;EACE,YAAA;AHun0BJ;;AGrn0BE;EACE,YAAA;AHwn0BJ;;AGtn0BE;EACE,YAAA;AHyn0BJ;;AGvn0BE;EACE,YAAA;AH0n0BJ;;AGxn0BE;EACE,YAAA;AH2n0BJ;;AGzn0BE;EACE,YAAA;AH4n0BJ;;AG1n0BE;EACE,YAAA;AH6n0BJ;;AG3n0BE;EACE,YAAA;AH8n0BJ;;AG5n0BE;EACE,YAAA;AH+n0BJ;;AG7n0BE;EACE,YAAA;AHgo0BJ;;AG9n0BE;EACE,YAAA;AHio0BJ;;AG/n0BE;EACE,YAAA;AHko0BJ;;AGho0BE;EACE,YAAA;AHmo0BJ;;AGjo0BE;EACE,YAAA;AHoo0BJ;;AGlo0BE;EACE,YAAA;AHqo0BJ;;AGno0BE;EACE,YAAA;AHso0BJ;;AGpo0BE;EACE,YAAA;AHuo0BJ;;AGro0BE;EACE,YAAA;AHwo0BJ;;AGto0BE;EACE,YAAA;AHyo0BJ;;AGvo0BE;EACE,YAAA;AH0o0BJ;;AGxo0BE;EACE,YAAA;AH2o0BJ;;AGzo0BE;EACE,YAAA;AH4o0BJ;;AG1o0BE;EACE,YAAA;AH6o0BJ;;AG3o0BE;EACE,YAAA;AH8o0BJ;;AG5o0BE;EACE,YAAA;AH+o0BJ;;AG7o0BE;EACE,YAAA;AHgp0BJ;;AG9o0BE;EACE,YAAA;AHip0BJ;;AG/o0BE;EACE,YAAA;AHkp0BJ;;AGhp0BE;EACE,YAAA;AHmp0BJ;;AGjp0BE;EACE,YAAA;AHop0BJ;;AGlp0BE;EACE,YAAA;AHqp0BJ;;AGnp0BE;EACE,YAAA;AHsp0BJ;;AGpp0BE;EACE,YAAA;AHup0BJ;;AGrp0BE;EACE,YAAA;AHwp0BJ;;AGtp0BE;EACE,YAAA;AHyp0BJ;;AGvp0BE;EACE,YAAA;AH0p0BJ;;AGxp0BE;EACE,YAAA;AH2p0BJ;;AGzp0BE;EACE,YAAA;AH4p0BJ;;AG1p0BE;EACE,YAAA;AH6p0BJ;;AG3p0BE;EACE,YAAA;AH8p0BJ;;AG5p0BE;EACE,YAAA;AH+p0BJ;;AG7p0BE;EACE,YAAA;AHgq0BJ;;AG9p0BE;EACE,YAAA;AHiq0BJ;;AG/p0BE;EACE,YAAA;AHkq0BJ;;AGhq0BE;EACE,YAAA;AHmq0BJ;;AGjq0BE;EACE,YAAA;AHoq0BJ;;AGlq0BE;EACE,YAAA;AHqq0BJ;;AGnq0BE;EACE,YAAA;AHsq0BJ;;AGpq0BE;EACE,YAAA;AHuq0BJ;;AGrq0BE;EACE,YAAA;AHwq0BJ;;AGtq0BE;EACE,YAAA;AHyq0BJ;;AGvq0BE;EACE,YAAA;AH0q0BJ;;AGxq0BE;EACE,YAAA;AH2q0BJ;;AGzq0BE;EACE,YAAA;AH4q0BJ;;AG1q0BE;EACE,YAAA;AH6q0BJ;;AG3q0BE;EACE,YAAA;AH8q0BJ;;AG5q0BE;EACE,YAAA;AH+q0BJ;;AG7q0BE;EACE,YAAA;AHgr0BJ;;AG9q0BE;EACE,YAAA;AHir0BJ;;AG/q0BE;EACE,YAAA;AHkr0BJ;;AGhr0BE;EACE,YAAA;AHmr0BJ;;AGjr0BE;EACE,YAAA;AHor0BJ;;AGlr0BE;EACE,YAAA;AHqr0BJ;;AGnr0BE;EACE,YAAA;AHsr0BJ;;AGpr0BE;EACE,YAAA;AHur0BJ;;AGrr0BE;EACE,YAAA;AHwr0BJ;;AGtr0BE;EACE,YAAA;AHyr0BJ;;AGvr0BE;EACE,YAAA;AH0r0BJ;;AGxr0BE;EACE,YAAA;AH2r0BJ;;AGzr0BE;EACE,YAAA;AH4r0BJ;;AG1r0BE;EACE,YAAA;AH6r0BJ;;AG3r0BE;EACE,YAAA;AH8r0BJ;;AG5r0BE;EACE,YAAA;AH+r0BJ;;AG7r0BE;EACE,YAAA;AHgs0BJ;;AG9r0BE;EACE,YAAA;AHis0BJ;;AG/r0BE;EACE,YAAA;AHks0BJ;;AGhs0BE;EACE,YAAA;AHms0BJ;;AGjs0BE;EACE,YAAA;AHos0BJ;;AGls0BE;EACE,YAAA;AHqs0BJ;;AGns0BE;EACE,YAAA;AHss0BJ;;AGps0BE;EACE,YAAA;AHus0BJ;;AGrs0BE;EACE,YAAA;AHws0BJ;;AGts0BE;EACE,YAAA;AHys0BJ;;AGvs0BE;EACE,YAAA;AH0s0BJ;;AGxs0BE;EACE,YAAA;AH2s0BJ;;AGzs0BE;EACE,YAAA;AH4s0BJ;;AG1s0BE;EACE,YAAA;AH6s0BJ;;AG3s0BE;EACE,YAAA;AH8s0BJ;;AG5s0BE;EACE,YAAA;AH+s0BJ;;AG7s0BE;EACE,YAAA;AHgt0BJ;;AG9s0BE;EACE,YAAA;AHit0BJ;;AG/s0BE;EACE,YAAA;AHkt0BJ;;AGht0BE;EACE,YAAA;AHmt0BJ;;AGjt0BE;EACE,YAAA;AHot0BJ;;AGlt0BE;EACE,YAAA;AHqt0BJ;;AGnt0BE;EACE,YAAA;AHst0BJ;;AGpt0BE;EACE,YAAA;AHut0BJ;;AGrt0BE;EACE,YAAA;AHwt0BJ;;AGtt0BE;EACE,YAAA;AHyt0BJ;;AGvt0BE;EACE,YAAA;AH0t0BJ;;AGxt0BE;EACE,YAAA;AH2t0BJ;;AGzt0BE;EACE,YAAA;AH4t0BJ;;AG1t0BE;EACE,YAAA;AH6t0BJ;;AG3t0BE;EACE,YAAA;AH8t0BJ;;AG5t0BE;EACE,YAAA;AH+t0BJ;;AG7t0BE;EACE,YAAA;AHgu0BJ;;AG9t0BE;EACE,YAAA;AHiu0BJ;;AG/t0BE;EACE,YAAA;AHku0BJ;;AGhu0BE;EACE,YAAA;AHmu0BJ;;AGju0BE;EACE,YAAA;AHou0BJ;;AGlu0BE;EACE,YAAA;AHqu0BJ;;AGnu0BE;EACE,YAAA;AHsu0BJ;;AGpu0BE;EACE,YAAA;AHuu0BJ;;AGru0BE;EACE,YAAA;AHwu0BJ;;AGtu0BE;EACE,YAAA;AHyu0BJ;;AGvu0BE;EACE,YAAA;AH0u0BJ;;AGxu0BE;EACE,YAAA;AH2u0BJ;;AGzu0BE;EACE,YAAA;AH4u0BJ;;AG1u0BE;EACE,YAAA;AH6u0BJ;;AG3u0BE;EACE,YAAA;AH8u0BJ;;AG5u0BE;EACE,YAAA;AH+u0BJ;;AG7u0BE;EACE,YAAA;AHgv0BJ;;AG9u0BE;EACE,YAAA;AHiv0BJ;;AG/u0BE;EACE,YAAA;AHkv0BJ;;AGhv0BE;EACE,YAAA;AHmv0BJ;;AGjv0BE;EACE,YAAA;AHov0BJ;;AGlv0BE;EACE,YAAA;AHqv0BJ;;AGnv0BE;EACE,YAAA;AHsv0BJ;;AGpv0BE;EACE,YAAA;AHuv0BJ;;AGrv0BE;EACE,YAAA;AHwv0BJ;;AGtv0BE;EACE,YAAA;AHyv0BJ;;AGvv0BE;EACE,YAAA;AH0v0BJ;;AGxv0BE;EACE,YAAA;AH2v0BJ;;AGzv0BE;EACE,YAAA;AH4v0BJ;;AG1v0BE;EACE,YAAA;AH6v0BJ;;AG3v0BE;EACE,YAAA;AH8v0BJ;;AG5v0BE;EACE,YAAA;AH+v0BJ;;AG7v0BE;EACE,YAAA;AHgw0BJ;;AG9v0BE;EACE,YAAA;AHiw0BJ;;AG/v0BE;EACE,YAAA;AHkw0BJ;;AGhw0BE;EACE,YAAA;AHmw0BJ;;AGjw0BE;EACE,YAAA;AHow0BJ;;AGlw0BE;EACE,YAAA;AHqw0BJ;;AGnw0BE;EACE,YAAA;AHsw0BJ;;AGpw0BE;EACE,YAAA;AHuw0BJ;;AGrw0BE;EACE,YAAA;AHww0BJ;;AGtw0BE;EACE,YAAA;AHyw0BJ;;AGvw0BE;EACE,YAAA;AH0w0BJ;;AGxw0BE;EACE,YAAA;AH2w0BJ;;AGzw0BE;EACE,YAAA;AH4w0BJ;;AG1w0BE;EACE,YAAA;AH6w0BJ;;AG3w0BE;EACE,YAAA;AH8w0BJ;;AG5w0BE;EACE,YAAA;AH+w0BJ;;AG7w0BE;EACE,YAAA;AHgx0BJ;;AG9w0BE;EACE,YAAA;AHix0BJ;;AG/w0BE;EACE,YAAA;AHkx0BJ;;AGhx0BE;EACE,YAAA;AHmx0BJ;;AGjx0BE;EACE,YAAA;AHox0BJ;;AGlx0BE;EACE,YAAA;AHqx0BJ;;AGnx0BE;EACE,YAAA;AHsx0BJ;;AGpx0BE;EACE,YAAA;AHux0BJ;;AGrx0BE;EACE,YAAA;AHwx0BJ;;AGtx0BE;EACE,YAAA;AHyx0BJ;;AGvx0BE;EACE,YAAA;AH0x0BJ;;AGxx0BE;EACE,YAAA;AH2x0BJ;;AGzx0BE;EACE,YAAA;AH4x0BJ;;AG1x0BE;EACE,YAAA;AH6x0BJ;;AG3x0BE;EACE,YAAA;AH8x0BJ;;AG5x0BE;EACE,YAAA;AH+x0BJ;;AG7x0BE;EACE,YAAA;AHgy0BJ;;AG9x0BE;EACE,YAAA;AHiy0BJ;;AG/x0BE;EACE,YAAA;AHky0BJ;;AGhy0BE;EACE,YAAA;AHmy0BJ;;AGjy0BE;EACE,YAAA;AHoy0BJ;;AGly0BE;EACE,YAAA;AHqy0BJ;;AGny0BE;EACE,YAAA;AHsy0BJ;;AGpy0BE;EACE,YAAA;AHuy0BJ;;AGry0BE;EACE,YAAA;AHwy0BJ;;AGty0BE;EACE,YAAA;AHyy0BJ;;AGvy0BE;EACE,YAAA;AH0y0BJ;;AGxy0BE;EACE,YAAA;AH2y0BJ;;AGzy0BE;EACE,YAAA;AH4y0BJ;;AG1y0BE;EACE,YAAA;AH6y0BJ;;AG3y0BE;EACE,YAAA;AH8y0BJ;;AG5y0BE;EACE,YAAA;AH+y0BJ;;AG7y0BE;EACE,YAAA;AHgz0BJ;;AG9y0BE;EACE,YAAA;AHiz0BJ;;AG/y0BE;EACE,YAAA;AHkz0BJ;;AGhz0BE;EACE,YAAA;AHmz0BJ;;AGjz0BE;EACE,YAAA;AHoz0BJ;;AGlz0BE;EACE,YAAA;AHqz0BJ;;AGnz0BE;EACE,YAAA;AHsz0BJ;;AGpz0BE;EACE,YAAA;AHuz0BJ;;AGrz0BE;EACE,YAAA;AHwz0BJ;;AGtz0BE;EACE,YAAA;AHyz0BJ;;AGvz0BE;EACE,YAAA;AH0z0BJ;;AGxz0BE;EACE,YAAA;AH2z0BJ;;AGzz0BE;EACE,YAAA;AH4z0BJ;;AG1z0BE;EACE,YAAA;AH6z0BJ;;AG3z0BE;EACE,YAAA;AH8z0BJ;;AG5z0BE;EACE,YAAA;AH+z0BJ;;AG7z0BE;EACE,YAAA;AHg00BJ;;AG9z0BE;EACE,YAAA;AHi00BJ;;AG/z0BE;EACE,YAAA;AHk00BJ;;AGh00BE;EACE,YAAA;AHm00BJ;;AGj00BE;EACE,YAAA;AHo00BJ;;AGl00BE;EACE,YAAA;AHq00BJ;;AGn00BE;EACE,YAAA;AHs00BJ;;AGp00BE;EACE,YAAA;AHu00BJ;;AGr00BE;EACE,YAAA;AHw00BJ;;AGt00BE;EACE,YAAA;AHy00BJ;;AGv00BE;EACE,YAAA;AH000BJ;;AGx00BE;EACE,YAAA;AH200BJ;;AGz00BE;EACE,YAAA;AH400BJ;;AG100BE;EACE,YAAA;AH600BJ;;AG300BE;EACE,YAAA;AH800BJ;;AG500BE;EACE,YAAA;AH+00BJ;;AG700BE;EACE,YAAA;AHg10BJ;;AG900BE;EACE,YAAA;AHi10BJ;;AG/00BE;EACE,YAAA;AHk10BJ;;AGh10BE;EACE,YAAA;AHm10BJ;;AGj10BE;EACE,YAAA;AHo10BJ;;AGl10BE;EACE,YAAA;AHq10BJ;;AGn10BE;EACE,YAAA;AHs10BJ;;AGp10BE;EACE,YAAA;AHu10BJ;;AGr10BE;EACE,YAAA;AHw10BJ;;AGt10BE;EACE,YAAA;AHy10BJ;;AGv10BE;EACE,YAAA;AH010BJ;;AGx10BE;EACE,YAAA;AH210BJ;;AGz10BE;EACE,YAAA;AH410BJ;;AG110BE;EACE,YAAA;AH610BJ;;AG310BE;EACE,YAAA;AH810BJ;;AG510BE;EACE,YAAA;AH+10BJ;;AG710BE;EACE,YAAA;AHg20BJ;;AG910BE;EACE,YAAA;AHi20BJ;;AG/10BE;EACE,YAAA;AHk20BJ;;AGh20BE;EACE,YAAA;AHm20BJ;;AGj20BE;EACE,YAAA;AHo20BJ;;AGl20BE;EACE,YAAA;AHq20BJ;;AGn20BE;EACE,YAAA;AHs20BJ;;AGp20BE;EACE,YAAA;AHu20BJ;;AGr20BE;EACE,YAAA;AHw20BJ;;AGt20BE;EACE,YAAA;AHy20BJ;;AGv20BE;EACE,YAAA;AH020BJ;;AGx20BE;EACE,YAAA;AH220BJ;;AGz20BE;EACE,YAAA;AH420BJ;;AG120BE;EACE,YAAA;AH620BJ;;AG320BE;EACE,YAAA;AH820BJ;;AG520BE;EACE,YAAA;AH+20BJ;;AG720BE;EACE,YAAA;AHg30BJ;;AG920BE;EACE,YAAA;AHi30BJ;;AG/20BE;EACE,YAAA;AHk30BJ;;AGh30BE;EACE,YAAA;AHm30BJ;;AGj30BE;EACE,YAAA;AHo30BJ;;AGl30BE;EACE,YAAA;AHq30BJ;;AGn30BE;EACE,YAAA;AHs30BJ;;AGp30BE;EACE,YAAA;AHu30BJ;;AGr30BE;EACE,YAAA;AHw30BJ;;AGt30BE;EACE,YAAA;AHy30BJ;;AGv30BE;EACE,YAAA;AH030BJ;;AGx30BE;EACE,YAAA;AH230BJ;;AGz30BE;EACE,YAAA;AH430BJ;;AG130BE;EACE,YAAA;AH630BJ;;AG330BE;EACE,YAAA;AH830BJ;;AG530BE;EACE,YAAA;AH+30BJ;;AG730BE;EACE,YAAA;AHg40BJ;;AG930BE;EACE,YAAA;AHi40BJ;;AG/30BE;EACE,YAAA;AHk40BJ;;AGh40BE;EACE,YAAA;AHm40BJ;;AGj40BE;EACE,YAAA;AHo40BJ;;AGl40BE;EACE,YAAA;AHq40BJ;;AGn40BE;EACE,YAAA;AHs40BJ;;AGp40BE;EACE,YAAA;AHu40BJ;;AGr40BE;EACE,YAAA;AHw40BJ;;AGt40BE;EACE,YAAA;AHy40BJ;;AGv40BE;EACE,YAAA;AH040BJ;;AGx40BE;EACE,YAAA;AH240BJ;;AGz40BE;EACE,YAAA;AH440BJ;;AG140BE;EACE,YAAA;AH640BJ;;AG340BE;EACE,YAAA;AH840BJ;;AG540BE;EACE,YAAA;AH+40BJ;;AG740BE;EACE,YAAA;AHg50BJ;;AG940BE;EACE,YAAA;AHi50BJ;;AG/40BE;EACE,YAAA;AHk50BJ;;AGh50BE;EACE,YAAA;AHm50BJ;;AGj50BE;EACE,YAAA;AHo50BJ;;AGl50BE;EACE,YAAA;AHq50BJ;;AGn50BE;EACE,YAAA;AHs50BJ;;AGp50BE;EACE,YAAA;AHu50BJ;;AGr50BE;EACE,YAAA;AHw50BJ;;AGt50BE;EACE,YAAA;AHy50BJ;;AGv50BE;EACE,YAAA;AH050BJ;;AGx50BE;EACE,YAAA;AH250BJ;;AGz50BE;EACE,YAAA;AH450BJ;;AG150BE;EACE,YAAA;AH650BJ;;AG350BE;EACE,YAAA;AH850BJ;;AG550BE;EACE,YAAA;AH+50BJ;;AG750BE;EACE,YAAA;AHg60BJ;;AG950BE;EACE,YAAA;AHi60BJ;;AG/50BE;EACE,YAAA;AHk60BJ;;AGh60BE;EACE,YAAA;AHm60BJ;;AGj60BE;EACE,YAAA;AHo60BJ;;AGl60BE;EACE,YAAA;AHq60BJ;;AGn60BE;EACE,YAAA;AHs60BJ;;AGp60BE;EACE,YAAA;AHu60BJ;;AGr60BE;EACE,YAAA;AHw60BJ;;AGt60BE;EACE,YAAA;AHy60BJ;;AGv60BE;EACE,YAAA;AH060BJ;;AGx60BE;EACE,YAAA;AH260BJ;;AGz60BE;EACE,YAAA;AH460BJ;;AG160BE;EACE,YAAA;AH660BJ;;AG360BE;EACE,YAAA;AH860BJ;;AG560BE;EACE,YAAA;AH+60BJ;;AG760BE;EACE,YAAA;AHg70BJ;;AG960BE;EACE,YAAA;AHi70BJ;;AG/60BE;EACE,YAAA;AHk70BJ;;AGh70BE;EACE,YAAA;AHm70BJ;;AGj70BE;EACE,YAAA;AHo70BJ;;AGl70BE;EACE,YAAA;AHq70BJ;;AGn70BE;EACE,YAAA;AHs70BJ;;AGp70BE;EACE,YAAA;AHu70BJ;;AGr70BE;EACE,YAAA;AHw70BJ;;AGt70BE;EACE,YAAA;AHy70BJ;;AGv70BE;EACE,YAAA;AH070BJ;;AGx70BE;EACE,YAAA;AH270BJ;;AGz70BE;EACE,YAAA;AH470BJ;;AG170BE;EACE,YAAA;AH670BJ;;AG370BE;EACE,YAAA;AH870BJ;;AG570BE;EACE,YAAA;AH+70BJ;;AG770BE;EACE,YAAA;AHg80BJ;;AG970BE;EACE,YAAA;AHi80BJ;;AG/70BE;EACE,YAAA;AHk80BJ;;AGh80BE;EACE,YAAA;AHm80BJ;;AGj80BE;EACE,YAAA;AHo80BJ;;AGl80BE;EACE,YAAA;AHq80BJ;;AGn80BE;EACE,YAAA;AHs80BJ;;AGp80BE;EACE,YAAA;AHu80BJ;;AGr80BE;EACE,YAAA;AHw80BJ;;AGt80BE;EACE,YAAA;AHy80BJ;;AGv80BE;EACE,YAAA;AH080BJ;;AGx80BE;EACE,YAAA;AH280BJ;;AGz80BE;EACE,YAAA;AH480BJ;;AG180BE;EACE,YAAA;AH680BJ;;AG380BE;EACE,YAAA;AH880BJ;;AG580BE;EACE,YAAA;AH+80BJ;;AG780BE;EACE,YAAA;AHg90BJ;;AG980BE;EACE,YAAA;AHi90BJ;;AG/80BE;EACE,YAAA;AHk90BJ;;AGh90BE;EACE,YAAA;AHm90BJ;;AGj90BE;EACE,YAAA;AHo90BJ;;AGl90BE;EACE,YAAA;AHq90BJ;;AGn90BE;EACE,YAAA;AHs90BJ;;AGp90BE;EACE,YAAA;AHu90BJ;;AGr90BE;EACE,YAAA;AHw90BJ;;AGt90BE;EACE,YAAA;AHy90BJ;;AGv90BE;EACE,YAAA;AH090BJ;;AGx90BE;EACE,YAAA;AH290BJ;;AGz90BE;EACE,YAAA;AH490BJ;;AG190BE;EACE,YAAA;AH690BJ;;AG390BE;EACE,YAAA;AH890BJ;;AG590BE;EACE,YAAA;AH+90BJ;;AG790BE;EACE,YAAA;AHg+0BJ;;AG990BE;EACE,YAAA;AHi+0BJ;;AG/90BE;EACE,YAAA;AHk+0BJ;;AGh+0BE;EACE,YAAA;AHm+0BJ;;AGj+0BE;EACE,YAAA;AHo+0BJ;;AGl+0BE;EACE,YAAA;AHq+0BJ;;AGn+0BE;EACE,YAAA;AHs+0BJ;;AGp+0BE;EACE,YAAA;AHu+0BJ;;AGr+0BE;EACE,YAAA;AHw+0BJ;;AGt+0BE;EACE,YAAA;AHy+0BJ;;AGv+0BE;EACE,YAAA;AH0+0BJ;;AGx+0BE;EACE,YAAA;AH2+0BJ;;AGz+0BE;EACE,YAAA;AH4+0BJ;;AG1+0BE;EACE,YAAA;AH6+0BJ;;AG3+0BE;EACE,YAAA;AH8+0BJ;;AG5+0BE;EACE,YAAA;AH++0BJ;;AG7+0BE;EACE,YAAA;AHg/0BJ;;AG9+0BE;EACE,YAAA;AHi/0BJ;;AG/+0BE;EACE,YAAA;AHk/0BJ;;AGh/0BE;EACE,YAAA;AHm/0BJ;;AGj/0BE;EACE,YAAA;AHo/0BJ;;AGl/0BE;EACE,YAAA;AHq/0BJ;;AGn/0BE;EACE,YAAA;AHs/0BJ;;AGp/0BE;EACE,YAAA;AHu/0BJ;;AGr/0BE;EACE,YAAA;AHw/0BJ;;AGt/0BE;EACE,YAAA;AHy/0BJ;;AGv/0BE;EACE,YAAA;AH0/0BJ;;AGx/0BE;EACE,YAAA;AH2/0BJ;;AGz/0BE;EACE,YAAA;AH4/0BJ;;AG1/0BE;EACE,YAAA;AH6/0BJ;;AG3/0BE;EACE,YAAA;AH8/0BJ;;AG5/0BE;EACE,YAAA;AH+/0BJ;;AG7/0BE;EACE,YAAA;AHgg1BJ;;AG9/0BE;EACE,YAAA;AHig1BJ;;AG//0BE;EACE,YAAA;AHkg1BJ;;AGhg1BE;EACE,YAAA;AHmg1BJ;;AGjg1BE;EACE,YAAA;AHog1BJ;;AGlg1BE;EACE,YAAA;AHqg1BJ;;AGng1BE;EACE,YAAA;AHsg1BJ;;AGpg1BE;EACE,YAAA;AHug1BJ;;AGrg1BE;EACE,YAAA;AHwg1BJ;;AGtg1BE;EACE,YAAA;AHyg1BJ;;AGvg1BE;EACE,YAAA;AH0g1BJ;;AGxg1BE;EACE,YAAA;AH2g1BJ;;AGzg1BE;EACE,YAAA;AH4g1BJ;;AG1g1BE;EACE,YAAA;AH6g1BJ;;AG3g1BE;EACE,YAAA;AH8g1BJ;;AG5g1BE;EACE,YAAA;AH+g1BJ;;AG7g1BE;EACE,YAAA;AHgh1BJ;;AG9g1BE;EACE,YAAA;AHih1BJ;;AG/g1BE;EACE,YAAA;AHkh1BJ;;AGhh1BE;EACE,YAAA;AHmh1BJ;;AGjh1BE;EACE,YAAA;AHoh1BJ;;AGlh1BE;EACE,YAAA;AHqh1BJ;;AGnh1BE;EACE,YAAA;AHsh1BJ;;AGph1BE;EACE,YAAA;AHuh1BJ;;AGrh1BE;EACE,YAAA;AHwh1BJ;;AGth1BE;EACE,YAAA;AHyh1BJ;;AGvh1BE;EACE,YAAA;AH0h1BJ;;AGxh1BE;EACE,YAAA;AH2h1BJ;;AGzh1BE;EACE,YAAA;AH4h1BJ;;AG1h1BE;EACE,YAAA;AH6h1BJ;;AG3h1BE;EACE,YAAA;AH8h1BJ;;AG5h1BE;EACE,YAAA;AH+h1BJ;;AG7h1BE;EACE,YAAA;AHgi1BJ;;AG9h1BE;EACE,YAAA;AHii1BJ;;AG/h1BE;EACE,YAAA;AHki1BJ;;AGhi1BE;EACE,YAAA;AHmi1BJ;;AGji1BE;EACE,YAAA;AHoi1BJ;;AGli1BE;EACE,YAAA;AHqi1BJ;;AGni1BE;EACE,YAAA;AHsi1BJ;;AGpi1BE;EACE,YAAA;AHui1BJ;;AGri1BE;EACE,YAAA;AHwi1BJ;;AGti1BE;EACE,YAAA;AHyi1BJ;;AGvi1BE;EACE,YAAA;AH0i1BJ;;AGxi1BE;EACE,YAAA;AH2i1BJ;;AGzi1BE;EACE,YAAA;AH4i1BJ;;AG1i1BE;EACE,YAAA;AH6i1BJ;;AG3i1BE;EACE,YAAA;AH8i1BJ;;AG5i1BE;EACE,YAAA;AH+i1BJ;;AG7i1BE;EACE,YAAA;AHgj1BJ;;AG9i1BE;EACE,YAAA;AHij1BJ;;AG/i1BE;EACE,YAAA;AHkj1BJ;;AGhj1BE;EACE,YAAA;AHmj1BJ;;AGjj1BE;EACE,YAAA;AHoj1BJ;;AGlj1BE;EACE,YAAA;AHqj1BJ;;AGnj1BE;EACE,YAAA;AHsj1BJ;;AGpj1BE;EACE,YAAA;AHuj1BJ;;AGrj1BE;EACE,YAAA;AHwj1BJ;;AGtj1BE;EACE,YAAA;AHyj1BJ;;AGvj1BE;EACE,YAAA;AH0j1BJ;;AGxj1BE;EACE,YAAA;AH2j1BJ;;AGzj1BE;EACE,YAAA;AH4j1BJ;;AG1j1BE;EACE,YAAA;AH6j1BJ;;AG3j1BE;EACE,YAAA;AH8j1BJ;;AG5j1BE;EACE,YAAA;AH+j1BJ;;AG7j1BE;EACE,YAAA;AHgk1BJ;;AG9j1BE;EACE,YAAA;AHik1BJ;;AG/j1BE;EACE,YAAA;AHkk1BJ;;AGhk1BE;EACE,YAAA;AHmk1BJ;;AGjk1BE;EACE,YAAA;AHok1BJ;;AGlk1BE;EACE,YAAA;AHqk1BJ;;AGnk1BE;EACE,YAAA;AHsk1BJ;;AGpk1BE;EACE,YAAA;AHuk1BJ;;AGrk1BE;EACE,YAAA;AHwk1BJ;;AGtk1BE;EACE,YAAA;AHyk1BJ;;AGvk1BE;EACE,YAAA;AH0k1BJ;;AGxk1BE;EACE,YAAA;AH2k1BJ;;AGzk1BE;EACE,YAAA;AH4k1BJ;;AG1k1BE;EACE,YAAA;AH6k1BJ;;AG3k1BE;EACE,YAAA;AH8k1BJ;;AG5k1BE;EACE,YAAA;AH+k1BJ;;AG7k1BE;EACE,YAAA;AHgl1BJ;;AG9k1BE;EACE,YAAA;AHil1BJ;;AG/k1BE;EACE,YAAA;AHkl1BJ;;AGhl1BE;EACE,YAAA;AHml1BJ;;AGjl1BE;EACE,YAAA;AHol1BJ;;AGll1BE;EACE,YAAA;AHql1BJ;;AGnl1BE;EACE,YAAA;AHsl1BJ;;AGpl1BE;EACE,YAAA;AHul1BJ;;AGrl1BE;EACE,YAAA;AHwl1BJ;;AGtl1BE;EACE,YAAA;AHyl1BJ;;AGvl1BE;EACE,YAAA;AH0l1BJ;;AGxl1BE;EACE,YAAA;AH2l1BJ;;AGzl1BE;EACE,YAAA;AH4l1BJ;;AG1l1BE;EACE,YAAA;AH6l1BJ;;AG3l1BE;EACE,YAAA;AH8l1BJ;;AG5l1BE;EACE,YAAA;AH+l1BJ;;AG7l1BE;EACE,YAAA;AHgm1BJ;;AG9l1BE;EACE,YAAA;AHim1BJ;;AG/l1BE;EACE,YAAA;AHkm1BJ;;AGhm1BE;EACE,YAAA;AHmm1BJ;;AGjm1BE;EACE,YAAA;AHom1BJ;;AGlm1BE;EACE,YAAA;AHqm1BJ;;AGnm1BE;EACE,YAAA;AHsm1BJ;;AGpm1BE;EACE,YAAA;AHum1BJ;;AGrm1BE;EACE,YAAA;AHwm1BJ;;AGtm1BE;EACE,YAAA;AHym1BJ;;AGvm1BE;EACE,YAAA;AH0m1BJ;;AGxm1BE;EACE,YAAA;AH2m1BJ;;AGzm1BE;EACE,YAAA;AH4m1BJ;;AG1m1BE;EACE,YAAA;AH6m1BJ;;AG3m1BE;EACE,YAAA;AH8m1BJ;;AG5m1BE;EACE,YAAA;AH+m1BJ;;AG7m1BE;EACE,YAAA;AHgn1BJ;;AG9m1BE;EACE,YAAA;AHin1BJ;;AG/m1BE;EACE,YAAA;AHkn1BJ;;AGhn1BE;EACE,YAAA;AHmn1BJ;;AGjn1BE;EACE,YAAA;AHon1BJ;;AGln1BE;EACE,YAAA;AHqn1BJ;;AGnn1BE;EACE,YAAA;AHsn1BJ;;AGpn1BE;EACE,YAAA;AHun1BJ;;AGrn1BE;EACE,YAAA;AHwn1BJ;;AGtn1BE;EACE,YAAA;AHyn1BJ;;AGvn1BE;EACE,YAAA;AH0n1BJ;;AGxn1BE;EACE,YAAA;AH2n1BJ;;AGzn1BE;EACE,YAAA;AH4n1BJ;;AG1n1BE;EACE,YAAA;AH6n1BJ;;AG3n1BE;EACE,YAAA;AH8n1BJ;;AG5n1BE;EACE,YAAA;AH+n1BJ;;AG7n1BE;EACE,YAAA;AHgo1BJ;;AG9n1BE;EACE,YAAA;AHio1BJ;;AG/n1BE;EACE,YAAA;AHko1BJ;;AGho1BE;EACE,YAAA;AHmo1BJ;;AGjo1BE;EACE,YAAA;AHoo1BJ;;AGlo1BE;EACE,YAAA;AHqo1BJ;;AGno1BE;EACE,YAAA;AHso1BJ;;AGpo1BE;EACE,YAAA;AHuo1BJ;;AGro1BE;EACE,YAAA;AHwo1BJ;;AGto1BE;EACE,YAAA;AHyo1BJ;;AGvo1BE;EACE,YAAA;AH0o1BJ;;AGxo1BE;EACE,YAAA;AH2o1BJ;;AGzo1BE;EACE,YAAA;AH4o1BJ;;AG1o1BE;EACE,YAAA;AH6o1BJ;;AG3o1BE;EACE,YAAA;AH8o1BJ;;AG5o1BE;EACE,YAAA;AH+o1BJ;;AG7o1BE;EACE,YAAA;AHgp1BJ;;AG9o1BE;EACE,YAAA;AHip1BJ;;AG/o1BE;EACE,YAAA;AHkp1BJ;;AGhp1BE;EACE,YAAA;AHmp1BJ;;AGjp1BE;EACE,YAAA;AHop1BJ;;AGlp1BE;EACE,YAAA;AHqp1BJ;;AGnp1BE;EACE,YAAA;AHsp1BJ;;AGpp1BE;EACE,YAAA;AHup1BJ;;AGrp1BE;EACE,YAAA;AHwp1BJ;;AGtp1BE;EACE,YAAA;AHyp1BJ;;AGvp1BE;EACE,YAAA;AH0p1BJ;;AGxp1BE;EACE,YAAA;AH2p1BJ;;AGzp1BE;EACE,YAAA;AH4p1BJ;;AG1p1BE;EACE,YAAA;AH6p1BJ;;AG3p1BE;EACE,YAAA;AH8p1BJ;;AG5p1BE;EACE,YAAA;AH+p1BJ;;AG7p1BE;EACE,YAAA;AHgq1BJ;;AG9p1BE;EACE,YAAA;AHiq1BJ;;AG/p1BE;EACE,YAAA;AHkq1BJ;;AGhq1BE;EACE,YAAA;AHmq1BJ;;AGjq1BE;EACE,YAAA;AHoq1BJ;;AGlq1BE;EACE,YAAA;AHqq1BJ;;AGnq1BE;EACE,YAAA;AHsq1BJ;;AGpq1BE;EACE,YAAA;AHuq1BJ;;AGrq1BE;EACE,YAAA;AHwq1BJ;;AGtq1BE;EACE,YAAA;AHyq1BJ;;AGvq1BE;EACE,YAAA;AH0q1BJ;;AGxq1BE;EACE,YAAA;AH2q1BJ;;AGzq1BE;EACE,YAAA;AH4q1BJ;;AG1q1BE;EACE,YAAA;AH6q1BJ;;AG3q1BE;EACE,YAAA;AH8q1BJ;;AG5q1BE;EACE,YAAA;AH+q1BJ;;AG7q1BE;EACE,YAAA;AHgr1BJ;;AG9q1BE;EACE,YAAA;AHir1BJ;;AG/q1BE;EACE,YAAA;AHkr1BJ;;AGhr1BE;EACE,YAAA;AHmr1BJ;;AGjr1BE;EACE,YAAA;AHor1BJ;;AGlr1BE;EACE,YAAA;AHqr1BJ;;AGnr1BE;EACE,YAAA;AHsr1BJ;;AGpr1BE;EACE,YAAA;AHur1BJ;;AGrr1BE;EACE,YAAA;AHwr1BJ;;AGtr1BE;EACE,YAAA;AHyr1BJ;;AGvr1BE;EACE,YAAA;AH0r1BJ;;AGxr1BE;EACE,YAAA;AH2r1BJ;;AGzr1BE;EACE,YAAA;AH4r1BJ;;AG1r1BE;EACE,YAAA;AH6r1BJ;;AG3r1BE;EACE,YAAA;AH8r1BJ;;AG5r1BE;EACE,YAAA;AH+r1BJ;;AG7r1BE;EACE,YAAA;AHgs1BJ;;AG9r1BE;EACE,YAAA;AHis1BJ;;AG/r1BE;EACE,YAAA;AHks1BJ;;AGhs1BE;EACE,YAAA;AHms1BJ;;AGjs1BE;EACE,YAAA;AHos1BJ;;AGls1BE;EACE,YAAA;AHqs1BJ;;AGns1BE;EACE,YAAA;AHss1BJ;;AGps1BE;EACE,YAAA;AHus1BJ;;AGrs1BE;EACE,YAAA;AHws1BJ;;AGts1BE;EACE,YAAA;AHys1BJ;;AGvs1BE;EACE,YAAA;AH0s1BJ;;AGxs1BE;EACE,YAAA;AH2s1BJ;;AGzs1BE;EACE,YAAA;AH4s1BJ;;AG1s1BE;EACE,YAAA;AH6s1BJ;;AG3s1BE;EACE,YAAA;AH8s1BJ;;AG5s1BE;EACE,YAAA;AH+s1BJ;;AG7s1BE;EACE,YAAA;AHgt1BJ;;AG9s1BE;EACE,YAAA;AHit1BJ;;AG/s1BE;EACE,YAAA;AHkt1BJ;;AGht1BE;EACE,YAAA;AHmt1BJ;;AGjt1BE;EACE,YAAA;AHot1BJ;;AGlt1BE;EACE,YAAA;AHqt1BJ;;AGnt1BE;EACE,YAAA;AHst1BJ;;AGpt1BE;EACE,YAAA;AHut1BJ;;AGrt1BE;EACE,YAAA;AHwt1BJ;;AGtt1BE;EACE,YAAA;AHyt1BJ;;AGvt1BE;EACE,YAAA;AH0t1BJ;;AGxt1BE;EACE,YAAA;AH2t1BJ;;AGzt1BE;EACE,YAAA;AH4t1BJ;;AG1t1BE;EACE,YAAA;AH6t1BJ;;AG3t1BE;EACE,YAAA;AH8t1BJ;;AG5t1BE;EACE,YAAA;AH+t1BJ;;AG7t1BE;EACE,YAAA;AHgu1BJ;;AG9t1BE;EACE,YAAA;AHiu1BJ;;AG/t1BE;EACE,YAAA;AHku1BJ;;AGhu1BE;EACE,YAAA;AHmu1BJ;;AGju1BE;EACE,YAAA;AHou1BJ;;AGlu1BE;EACE,YAAA;AHqu1BJ;;AGnu1BE;EACE,YAAA;AHsu1BJ;;AGpu1BE;EACE,YAAA;AHuu1BJ;;AGru1BE;EACE,YAAA;AHwu1BJ;;AGtu1BE;EACE,YAAA;AHyu1BJ;;AGvu1BE;EACE,YAAA;AH0u1BJ;;AGxu1BE;EACE,YAAA;AH2u1BJ;;AGzu1BE;EACE,YAAA;AH4u1BJ;;AG1u1BE;EACE,YAAA;AH6u1BJ;;AG3u1BE;EACE,YAAA;AH8u1BJ;;AG5u1BE;EACE,YAAA;AH+u1BJ;;AG7u1BE;EACE,YAAA;AHgv1BJ;;AG9u1BE;EACE,YAAA;AHiv1BJ;;AG/u1BE;EACE,YAAA;AHkv1BJ;;AGhv1BE;EACE,YAAA;AHmv1BJ;;AGjv1BE;EACE,YAAA;AHov1BJ;;AGlv1BE;EACE,YAAA;AHqv1BJ;;AGnv1BE;EACE,YAAA;AHsv1BJ;;AGpv1BE;EACE,YAAA;AHuv1BJ;;AGrv1BE;EACE,YAAA;AHwv1BJ;;AGtv1BE;EACE,YAAA;AHyv1BJ;;AGvv1BE;EACE,YAAA;AH0v1BJ;;AGxv1BE;EACE,YAAA;AH2v1BJ;;AGzv1BE;EACE,YAAA;AH4v1BJ;;AG1v1BE;EACE,YAAA;AH6v1BJ;;AG3v1BE;EACE,YAAA;AH8v1BJ;;AG5v1BE;EACE,YAAA;AH+v1BJ;;AG7v1BE;EACE,YAAA;AHgw1BJ;;AG9v1BE;EACE,YAAA;AHiw1BJ;;AG/v1BE;EACE,YAAA;AHkw1BJ;;AGhw1BE;EACE,YAAA;AHmw1BJ;;AGjw1BE;EACE,YAAA;AHow1BJ;;AGlw1BE;EACE,YAAA;AHqw1BJ;;AGnw1BE;EACE,YAAA;AHsw1BJ;;AGpw1BE;EACE,YAAA;AHuw1BJ;;AGrw1BE;EACE,YAAA;AHww1BJ;;AGtw1BE;EACE,YAAA;AHyw1BJ;;AGvw1BE;EACE,YAAA;AH0w1BJ;;AGxw1BE;EACE,YAAA;AH2w1BJ;;AGzw1BE;EACE,YAAA;AH4w1BJ;;AG1w1BE;EACE,YAAA;AH6w1BJ;;AG3w1BE;EACE,YAAA;AH8w1BJ;;AG5w1BE;EACE,YAAA;AH+w1BJ;;AG7w1BE;EACE,YAAA;AHgx1BJ;;AG9w1BE;EACE,YAAA;AHix1BJ;;AG/w1BE;EACE,YAAA;AHkx1BJ;;AGhx1BE;EACE,YAAA;AHmx1BJ;;AGjx1BE;EACE,YAAA;AHox1BJ;;AGlx1BE;EACE,YAAA;AHqx1BJ;;AGnx1BE;EACE,YAAA;AHsx1BJ;;AGpx1BE;EACE,YAAA;AHux1BJ;;AGrx1BE;EACE,YAAA;AHwx1BJ;;AGtx1BE;EACE,YAAA;AHyx1BJ;;AGvx1BE;EACE,YAAA;AH0x1BJ;;AGxx1BE;EACE,YAAA;AH2x1BJ;;AGzx1BE;EACE,YAAA;AH4x1BJ;;AG1x1BE;EACE,YAAA;AH6x1BJ;;AG3x1BE;EACE,YAAA;AH8x1BJ;;AG5x1BE;EACE,YAAA;AH+x1BJ;;AG7x1BE;EACE,YAAA;AHgy1BJ;;AG9x1BE;EACE,YAAA;AHiy1BJ;;AG/x1BE;EACE,YAAA;AHky1BJ;;AGhy1BE;EACE,YAAA;AHmy1BJ;;AGjy1BE;EACE,YAAA;AHoy1BJ;;AGly1BE;EACE,YAAA;AHqy1BJ;;AGny1BE;EACE,YAAA;AHsy1BJ;;AGpy1BE;EACE,YAAA;AHuy1BJ;;AGry1BE;EACE,YAAA;AHwy1BJ;;AGty1BE;EACE,YAAA;AHyy1BJ;;AGvy1BE;EACE,YAAA;AH0y1BJ;;AGxy1BE;EACE,YAAA;AH2y1BJ;;AGzy1BE;EACE,YAAA;AH4y1BJ;;AG1y1BE;EACE,YAAA;AH6y1BJ;;AG3y1BE;EACE,YAAA;AH8y1BJ;;AG5y1BE;EACE,YAAA;AH+y1BJ;;AG7y1BE;EACE,YAAA;AHgz1BJ;;AG9y1BE;EACE,YAAA;AHiz1BJ;;AG/y1BE;EACE,YAAA;AHkz1BJ;;AGhz1BE;EACE,YAAA;AHmz1BJ;;AGjz1BE;EACE,YAAA;AHoz1BJ;;AGlz1BE;EACE,YAAA;AHqz1BJ;;AGnz1BE;EACE,YAAA;AHsz1BJ;;AGpz1BE;EACE,YAAA;AHuz1BJ;;AGrz1BE;EACE,YAAA;AHwz1BJ;;AGtz1BE;EACE,YAAA;AHyz1BJ;;AGvz1BE;EACE,YAAA;AH0z1BJ;;AGxz1BE;EACE,YAAA;AH2z1BJ;;AGzz1BE;EACE,YAAA;AH4z1BJ;;AG1z1BE;EACE,YAAA;AH6z1BJ;;AG3z1BE;EACE,YAAA;AH8z1BJ;;AG5z1BE;EACE,YAAA;AH+z1BJ;;AG7z1BE;EACE,YAAA;AHg01BJ;;AG9z1BE;EACE,YAAA;AHi01BJ;;AG/z1BE;EACE,YAAA;AHk01BJ;;AGh01BE;EACE,YAAA;AHm01BJ;;AGj01BE;EACE,YAAA;AHo01BJ;;AGl01BE;EACE,YAAA;AHq01BJ;;AGn01BE;EACE,YAAA;AHs01BJ;;AGp01BE;EACE,YAAA;AHu01BJ;;AGr01BE;EACE,YAAA;AHw01BJ;;AGt01BE;EACE,YAAA;AHy01BJ;;AGv01BE;EACE,YAAA;AH001BJ;;AGx01BE;EACE,YAAA;AH201BJ;;AGz01BE;EACE,YAAA;AH401BJ;;AG101BE;EACE,YAAA;AH601BJ;;AG301BE;EACE,YAAA;AH801BJ;;AG501BE;EACE,YAAA;AH+01BJ;;AG701BE;EACE,YAAA;AHg11BJ;;AG901BE;EACE,YAAA;AHi11BJ;;AG/01BE;EACE,YAAA;AHk11BJ;;AGh11BE;EACE,YAAA;AHm11BJ;;AGj11BE;EACE,YAAA;AHo11BJ;;AGl11BE;EACE,YAAA;AHq11BJ;;AGn11BE;EACE,YAAA;AHs11BJ;;AGp11BE;EACE,YAAA;AHu11BJ;;AGr11BE;EACE,YAAA;AHw11BJ;;AGt11BE;EACE,YAAA;AHy11BJ;;AGv11BE;EACE,YAAA;AH011BJ;;AGx11BE;EACE,YAAA;AH211BJ;;AGz11BE;EACE,YAAA;AH411BJ;;AG111BE;EACE,YAAA;AH611BJ;;AG311BE;EACE,YAAA;AH811BJ;;AG511BE;EACE,YAAA;AH+11BJ;;AG711BE;EACE,YAAA;AHg21BJ;;AG911BE;EACE,YAAA;AHi21BJ;;AG/11BE;EACE,YAAA;AHk21BJ;;AGh21BE;EACE,YAAA;AHm21BJ;;AGj21BE;EACE,YAAA;AHo21BJ;;AGl21BE;EACE,YAAA;AHq21BJ;;AGn21BE;EACE,YAAA;AHs21BJ;;AGp21BE;EACE,YAAA;AHu21BJ;;AGr21BE;EACE,YAAA;AHw21BJ;;AGt21BE;EACE,YAAA;AHy21BJ;;AGv21BE;EACE,YAAA;AH021BJ;;AGx21BE;EACE,YAAA;AH221BJ;;AGz21BE;EACE,YAAA;AH421BJ;;AG121BE;EACE,YAAA;AH621BJ;;AG321BE;EACE,YAAA;AH821BJ;;AG521BE;EACE,YAAA;AH+21BJ;;AG721BE;EACE,YAAA;AHg31BJ;;AG921BE;EACE,YAAA;AHi31BJ;;AG/21BE;EACE,YAAA;AHk31BJ;;AGh31BE;EACE,YAAA;AHm31BJ;;AGj31BE;EACE,YAAA;AHo31BJ;;AGl31BE;EACE,YAAA;AHq31BJ;;AGn31BE;EACE,YAAA;AHs31BJ;;AGp31BE;EACE,YAAA;AHu31BJ;;AGr31BE;EACE,YAAA;AHw31BJ;;AGt31BE;EACE,YAAA;AHy31BJ;;AGv31BE;EACE,YAAA;AH031BJ;;AGx31BE;EACE,YAAA;AH231BJ;;AGz31BE;EACE,YAAA;AH431BJ;;AG131BE;EACE,YAAA;AH631BJ;;AG331BE;EACE,YAAA;AH831BJ;;AG531BE;EACE,YAAA;AH+31BJ;;AG731BE;EACE,YAAA;AHg41BJ;;AG931BE;EACE,YAAA;AHi41BJ;;AG/31BE;EACE,YAAA;AHk41BJ;;AGh41BE;EACE,YAAA;AHm41BJ;;AGj41BE;EACE,YAAA;AHo41BJ;;AGl41BE;EACE,YAAA;AHq41BJ;;AGn41BE;EACE,YAAA;AHs41BJ;;AGp41BE;EACE,YAAA;AHu41BJ;;AGr41BE;EACE,YAAA;AHw41BJ;;AGt41BE;EACE,YAAA;AHy41BJ;;AGv41BE;EACE,YAAA;AH041BJ;;AGx41BE;EACE,YAAA;AH241BJ;;AGz41BE;EACE,YAAA;AH441BJ;;AG141BE;EACE,YAAA;AH641BJ;;AG341BE;EACE,YAAA;AH841BJ;;AG541BE;EACE,YAAA;AH+41BJ;;AG741BE;EACE,YAAA;AHg51BJ;;AG941BE;EACE,YAAA;AHi51BJ;;AG/41BE;EACE,YAAA;AHk51BJ;;AGh51BE;EACE,YAAA;AHm51BJ;;AGj51BE;EACE,YAAA;AHo51BJ;;AGl51BE;EACE,YAAA;AHq51BJ;;AGn51BE;EACE,YAAA;AHs51BJ;;AGp51BE;EACE,YAAA;AHu51BJ;;AGr51BE;EACE,YAAA;AHw51BJ;;AGt51BE;EACE,YAAA;AHy51BJ;;AGv51BE;EACE,YAAA;AH051BJ;;AGx51BE;EACE,YAAA;AH251BJ;;AGz51BE;EACE,YAAA;AH451BJ;;AG151BE;EACE,YAAA;AH651BJ;;AG351BE;EACE,YAAA;AH851BJ;;AG551BE;EACE,YAAA;AH+51BJ;;AG751BE;EACE,YAAA;AHg61BJ;;AG951BE;EACE,YAAA;AHi61BJ;;AG/51BE;EACE,YAAA;AHk61BJ;;AGh61BE;EACE,YAAA;AHm61BJ;;AGj61BE;EACE,YAAA;AHo61BJ;;AGl61BE;EACE,YAAA;AHq61BJ;;AGn61BE;EACE,YAAA;AHs61BJ;;AGp61BE;EACE,YAAA;AHu61BJ;;AGr61BE;EACE,YAAA;AHw61BJ;;AGt61BE;EACE,YAAA;AHy61BJ;;AGv61BE;EACE,YAAA;AH061BJ;;AGx61BE;EACE,YAAA;AH261BJ;;AGz61BE;EACE,YAAA;AH461BJ;;AG161BE;EACE,YAAA;AH661BJ;;AG361BE;EACE,YAAA;AH861BJ;;AG561BE;EACE,YAAA;AH+61BJ;;AG761BE;EACE,YAAA;AHg71BJ;;AG961BE;EACE,YAAA;AHi71BJ;;AG/61BE;EACE,YAAA;AHk71BJ;;AGh71BE;EACE,YAAA;AHm71BJ;;AGj71BE;EACE,YAAA;AHo71BJ;;AGl71BE;EACE,YAAA;AHq71BJ;;AGn71BE;EACE,YAAA;AHs71BJ;;AGp71BE;EACE,YAAA;AHu71BJ;;AGr71BE;EACE,YAAA;AHw71BJ;;AGt71BE;EACE,YAAA;AHy71BJ;;AGv71BE;EACE,YAAA;AH071BJ;;AGx71BE;EACE,YAAA;AH271BJ;;AGz71BE;EACE,YAAA;AH471BJ;;AG171BE;EACE,YAAA;AH671BJ;;AG371BE;EACE,YAAA;AH871BJ;;AG571BE;EACE,YAAA;AH+71BJ;;AG771BE;EACE,YAAA;AHg81BJ;;AG971BE;EACE,YAAA;AHi81BJ;;AG/71BE;EACE,YAAA;AHk81BJ;;AGh81BE;EACE,YAAA;AHm81BJ;;AGj81BE;EACE,YAAA;AHo81BJ;;AGl81BE;EACE,YAAA;AHq81BJ;;AGn81BE;EACE,YAAA;AHs81BJ;;AGp81BE;EACE,YAAA;AHu81BJ;;AGr81BE;EACE,YAAA;AHw81BJ;;AGt81BE;EACE,YAAA;AHy81BJ;;AGv81BE;EACE,YAAA;AH081BJ;;AGx81BE;EACE,YAAA;AH281BJ;;AGz81BE;EACE,YAAA;AH481BJ;;AG181BE;EACE,YAAA;AH681BJ;;AG381BE;EACE,YAAA;AH881BJ;;AG581BE;EACE,YAAA;AH+81BJ;;AG781BE;EACE,YAAA;AHg91BJ;;AG981BE;EACE,YAAA;AHi91BJ;;AG/81BE;EACE,YAAA;AHk91BJ;;AGh91BE;EACE,YAAA;AHm91BJ;;AGj91BE;EACE,YAAA;AHo91BJ;;AGl91BE;EACE,YAAA;AHq91BJ;;AGn91BE;EACE,YAAA;AHs91BJ;;AGp91BE;EACE,YAAA;AHu91BJ;;AGr91BE;EACE,YAAA;AHw91BJ;;AGt91BE;EACE,YAAA;AHy91BJ;;AGv91BE;EACE,YAAA;AH091BJ;;AGx91BE;EACE,YAAA;AH291BJ;;AGz91BE;EACE,YAAA;AH491BJ;;AG191BE;EACE,YAAA;AH691BJ;;AG391BE;EACE,YAAA;AH891BJ;;AG591BE;EACE,YAAA;AH+91BJ;;AG791BE;EACE,YAAA;AHg+1BJ;;AG991BE;EACE,YAAA;AHi+1BJ;;AG/91BE;EACE,YAAA;AHk+1BJ;;AGh+1BE;EACE,YAAA;AHm+1BJ;;AGj+1BE;EACE,YAAA;AHo+1BJ;;AGl+1BE;EACE,YAAA;AHq+1BJ;;AGn+1BE;EACE,YAAA;AHs+1BJ;;AGp+1BE;EACE,YAAA;AHu+1BJ;;AGr+1BE;EACE,YAAA;AHw+1BJ;;AGt+1BE;EACE,YAAA;AHy+1BJ;;AGv+1BE;EACE,YAAA;AH0+1BJ;;AGx+1BE;EACE,YAAA;AH2+1BJ;;AGz+1BE;EACE,YAAA;AH4+1BJ;;AG1+1BE;EACE,YAAA;AH6+1BJ;;AG3+1BE;EACE,YAAA;AH8+1BJ;;AG5+1BE;EACE,YAAA;AH++1BJ;;AG7+1BE;EACE,YAAA;AHg/1BJ;;AG9+1BE;EACE,YAAA;AHi/1BJ;;AG/+1BE;EACE,YAAA;AHk/1BJ;;AGh/1BE;EACE,YAAA;AHm/1BJ;;AGj/1BE;EACE,YAAA;AHo/1BJ;;AGl/1BE;EACE,YAAA;AHq/1BJ;;AGn/1BE;EACE,YAAA;AHs/1BJ;;AGp/1BE;EACE,YAAA;AHu/1BJ;;AGr/1BE;EACE,YAAA;AHw/1BJ;;AGt/1BE;EACE,YAAA;AHy/1BJ;;AGv/1BE;EACE,YAAA;AH0/1BJ;;AGx/1BE;EACE,YAAA;AH2/1BJ;;AGz/1BE;EACE,YAAA;AH4/1BJ;;AG1/1BE;EACE,YAAA;AH6/1BJ;;AG3/1BE;EACE,YAAA;AH8/1BJ;;AG5/1BE;EACE,YAAA;AH+/1BJ;;AG7/1BE;EACE,YAAA;AHgg2BJ;;AG9/1BE;EACE,YAAA;AHig2BJ;;AG//1BE;EACE,YAAA;AHkg2BJ;;AGhg2BE;EACE,YAAA;AHmg2BJ;;AGjg2BE;EACE,YAAA;AHog2BJ;;AGlg2BE;EACE,YAAA;AHqg2BJ;;AGng2BE;EACE,YAAA;AHsg2BJ;;AGpg2BE;EACE,YAAA;AHug2BJ;;AGrg2BE;EACE,YAAA;AHwg2BJ;;AGtg2BE;EACE,YAAA;AHyg2BJ;;AGvg2BE;EACE,YAAA;AH0g2BJ;;AGxg2BE;EACE,YAAA;AH2g2BJ;;AGzg2BE;EACE,YAAA;AH4g2BJ;;AG1g2BE;EACE,YAAA;AH6g2BJ;;AG3g2BE;EACE,YAAA;AH8g2BJ;;AG5g2BE;EACE,YAAA;AH+g2BJ;;AG7g2BE;EACE,YAAA;AHgh2BJ;;AG9g2BE;EACE,YAAA;AHih2BJ;;AG/g2BE;EACE,YAAA;AHkh2BJ;;AGhh2BE;EACE,YAAA;AHmh2BJ;;AGjh2BE;EACE,YAAA;AHoh2BJ;;AGlh2BE;EACE,YAAA;AHqh2BJ;;AGnh2BE;EACE,YAAA;AHsh2BJ;;AGph2BE;EACE,YAAA;AHuh2BJ;;AGrh2BE;EACE,YAAA;AHwh2BJ;;AGth2BE;EACE,YAAA;AHyh2BJ;;AGvh2BE;EACE,YAAA;AH0h2BJ;;AGxh2BE;EACE,YAAA;AH2h2BJ;;AGzh2BE;EACE,YAAA;AH4h2BJ;;AG1h2BE;EACE,YAAA;AH6h2BJ;;AG3h2BE;EACE,YAAA;AH8h2BJ;;AG5h2BE;EACE,YAAA;AH+h2BJ;;AG7h2BE;EACE,YAAA;AHgi2BJ;;AG9h2BE;EACE,YAAA;AHii2BJ;;AG/h2BE;EACE,YAAA;AHki2BJ;;AGhi2BE;EACE,YAAA;AHmi2BJ;;AGji2BE;EACE,YAAA;AHoi2BJ;;AGli2BE;EACE,YAAA;AHqi2BJ;;AGni2BE;EACE,YAAA;AHsi2BJ;;AGpi2BE;EACE,YAAA;AHui2BJ;;AGri2BE;EACE,YAAA;AHwi2BJ;;AGti2BE;EACE,YAAA;AHyi2BJ;;AGvi2BE;EACE,YAAA;AH0i2BJ;;AGxi2BE;EACE,YAAA;AH2i2BJ;;AGzi2BE;EACE,YAAA;AH4i2BJ;;AG1i2BE;EACE,YAAA;AH6i2BJ;;AG3i2BE;EACE,YAAA;AH8i2BJ;;AG5i2BE;EACE,YAAA;AH+i2BJ;;AG7i2BE;EACE,YAAA;AHgj2BJ;;AG9i2BE;EACE,YAAA;AHij2BJ;;AG/i2BE;EACE,YAAA;AHkj2BJ;;AGhj2BE;EACE,YAAA;AHmj2BJ;;AGjj2BE;EACE,YAAA;AHoj2BJ;;AGlj2BE;EACE,YAAA;AHqj2BJ;;AGnj2BE;EACE,YAAA;AHsj2BJ;;AGpj2BE;EACE,YAAA;AHuj2BJ;;AGrj2BE;EACE,YAAA;AHwj2BJ;;AGtj2BE;EACE,YAAA;AHyj2BJ;;AGvj2BE;EACE,YAAA;AH0j2BJ;;AGxj2BE;EACE,YAAA;AH2j2BJ;;AGzj2BE;EACE,YAAA;AH4j2BJ;;AG1j2BE;EACE,YAAA;AH6j2BJ;;AG3j2BE;EACE,YAAA;AH8j2BJ;;AG5j2BE;EACE,YAAA;AH+j2BJ;;AG7j2BE;EACE,YAAA;AHgk2BJ;;AG9j2BE;EACE,YAAA;AHik2BJ;;AG/j2BE;EACE,YAAA;AHkk2BJ;;AGhk2BE;EACE,YAAA;AHmk2BJ;;AGjk2BE;EACE,YAAA;AHok2BJ;;AGlk2BE;EACE,YAAA;AHqk2BJ;;AGnk2BE;EACE,YAAA;AHsk2BJ;;AGpk2BE;EACE,YAAA;AHuk2BJ;;AGrk2BE;EACE,YAAA;AHwk2BJ;;AGtk2BE;EACE,YAAA;AHyk2BJ;;AGvk2BE;EACE,YAAA;AH0k2BJ;;AGxk2BE;EACE,YAAA;AH2k2BJ;;AGzk2BE;EACE,YAAA;AH4k2BJ;;AG1k2BE;EACE,YAAA;AH6k2BJ;;AG3k2BE;EACE,YAAA;AH8k2BJ;;AG5k2BE;EACE,YAAA;AH+k2BJ;;AG7k2BE;EACE,YAAA;AHgl2BJ;;AG9k2BE;EACE,YAAA;AHil2BJ;;AG/k2BE;EACE,YAAA;AHkl2BJ;;AGhl2BE;EACE,YAAA;AHml2BJ;;AGjl2BE;EACE,YAAA;AHol2BJ;;AGll2BE;EACE,YAAA;AHql2BJ;;AGnl2BE;EACE,YAAA;AHsl2BJ;;AGpl2BE;EACE,YAAA;AHul2BJ;;AGrl2BE;EACE,YAAA;AHwl2BJ;;AGtl2BE;EACE,YAAA;AHyl2BJ;;AGvl2BE;EACE,YAAA;AH0l2BJ;;AGxl2BE;EACE,YAAA;AH2l2BJ;;AGzl2BE;EACE,YAAA;AH4l2BJ;;AG1l2BE;EACE,YAAA;AH6l2BJ;;AG3l2BE;EACE,YAAA;AH8l2BJ;;AG5l2BE;EACE,YAAA;AH+l2BJ;;AG7l2BE;EACE,YAAA;AHgm2BJ;;AG9l2BE;EACE,YAAA;AHim2BJ;;AG/l2BE;EACE,YAAA;AHkm2BJ;;AGhm2BE;EACE,YAAA;AHmm2BJ;;AGjm2BE;EACE,YAAA;AHom2BJ;;AGlm2BE;EACE,YAAA;AHqm2BJ;;AGnm2BE;EACE,YAAA;AHsm2BJ;;AGpm2BE;EACE,YAAA;AHum2BJ;;AGrm2BE;EACE,YAAA;AHwm2BJ;;AGtm2BE;EACE,YAAA;AHym2BJ;;AGvm2BE;EACE,YAAA;AH0m2BJ;;AGxm2BE;EACE,YAAA;AH2m2BJ;;AGzm2BE;EACE,YAAA;AH4m2BJ;;AG1m2BE;EACE,YAAA;AH6m2BJ;;AG3m2BE;EACE,YAAA;AH8m2BJ;;AG5m2BE;EACE,YAAA;AH+m2BJ;;AG7m2BE;EACE,YAAA;AHgn2BJ;;AG9m2BE;EACE,YAAA;AHin2BJ;;AG/m2BE;EACE,YAAA;AHkn2BJ;;AGhn2BE;EACE,YAAA;AHmn2BJ;;AGjn2BE;EACE,YAAA;AHon2BJ;;AGln2BE;EACE,YAAA;AHqn2BJ;;AGnn2BE;EACE,YAAA;AHsn2BJ;;AGpn2BE;EACE,YAAA;AHun2BJ;;AGrn2BE;EACE,YAAA;AHwn2BJ;;AGtn2BE;EACE,YAAA;AHyn2BJ;;AGvn2BE;EACE,YAAA;AH0n2BJ;;AGxn2BE;EACE,YAAA;AH2n2BJ;;AGzn2BE;EACE,YAAA;AH4n2BJ;;AG1n2BE;EACE,YAAA;AH6n2BJ;;AG3n2BE;EACE,YAAA;AH8n2BJ;;AG5n2BE;EACE,YAAA;AH+n2BJ;;AG7n2BE;EACE,YAAA;AHgo2BJ;;AG9n2BE;EACE,YAAA;AHio2BJ;;AG/n2BE;EACE,YAAA;AHko2BJ;;AGho2BE;EACE,YAAA;AHmo2BJ;;AGjo2BE;EACE,YAAA;AHoo2BJ;;AGlo2BE;EACE,YAAA;AHqo2BJ;;AGno2BE;EACE,YAAA;AHso2BJ;;AGpo2BE;EACE,YAAA;AHuo2BJ;;AGro2BE;EACE,YAAA;AHwo2BJ;;AGto2BE;EACE,YAAA;AHyo2BJ;;AGvo2BE;EACE,YAAA;AH0o2BJ;;AGxo2BE;EACE,YAAA;AH2o2BJ;;AGzo2BE;EACE,YAAA;AH4o2BJ;;AG1o2BE;EACE,YAAA;AH6o2BJ;;AG3o2BE;EACE,YAAA;AH8o2BJ;;AG5o2BE;EACE,YAAA;AH+o2BJ;;AG7o2BE;EACE,YAAA;AHgp2BJ;;AG9o2BE;EACE,YAAA;AHip2BJ;;AG/o2BE;EACE,YAAA;AHkp2BJ;;AGhp2BE;EACE,YAAA;AHmp2BJ;;AGjp2BE;EACE,YAAA;AHop2BJ;;AGlp2BE;EACE,YAAA;AHqp2BJ;;AGnp2BE;EACE,YAAA;AHsp2BJ;;AGpp2BE;EACE,YAAA;AHup2BJ;;AGrp2BE;EACE,YAAA;AHwp2BJ;;AGtp2BE;EACE,YAAA;AHyp2BJ;;AGvp2BE;EACE,YAAA;AH0p2BJ;;AGxp2BE;EACE,YAAA;AH2p2BJ;;AGzp2BE;EACE,YAAA;AH4p2BJ;;AG1p2BE;EACE,YAAA;AH6p2BJ;;AG3p2BE;EACE,YAAA;AH8p2BJ;;AG5p2BE;EACE,YAAA;AH+p2BJ;;AG7p2BE;EACE,YAAA;AHgq2BJ;;AG9p2BE;EACE,YAAA;AHiq2BJ;;AG/p2BE;EACE,YAAA;AHkq2BJ;;AGhq2BE;EACE,YAAA;AHmq2BJ;;AGjq2BE;EACE,YAAA;AHoq2BJ;;AGlq2BE;EACE,YAAA;AHqq2BJ;;AGnq2BE;EACE,YAAA;AHsq2BJ;;AGpq2BE;EACE,YAAA;AHuq2BJ;;AGrq2BE;EACE,YAAA;AHwq2BJ;;AGtq2BE;EACE,YAAA;AHyq2BJ;;AGvq2BE;EACE,YAAA;AH0q2BJ;;AGxq2BE;EACE,YAAA;AH2q2BJ;;AGzq2BE;EACE,YAAA;AH4q2BJ;;AG1q2BE;EACE,YAAA;AH6q2BJ;;AG3q2BE;EACE,YAAA;AH8q2BJ;;AG5q2BE;EACE,YAAA;AH+q2BJ;;AG7q2BE;EACE,YAAA;AHgr2BJ;;AG9q2BE;EACE,YAAA;AHir2BJ;;AG/q2BE;EACE,YAAA;AHkr2BJ;;AGhr2BE;EACE,YAAA;AHmr2BJ;;AGjr2BE;EACE,YAAA;AHor2BJ;;AGlr2BE;EACE,YAAA;AHqr2BJ;;AGnr2BE;EACE,YAAA;AHsr2BJ;;AGpr2BE;EACE,YAAA;AHur2BJ;;AGrr2BE;EACE,YAAA;AHwr2BJ;;AGtr2BE;EACE,YAAA;AHyr2BJ;;AGvr2BE;EACE,YAAA;AH0r2BJ;;AGxr2BE;EACE,YAAA;AH2r2BJ;;AGzr2BE;EACE,YAAA;AH4r2BJ;;AG1r2BE;EACE,YAAA;AH6r2BJ;;AG3r2BE;EACE,YAAA;AH8r2BJ;;AG5r2BE;EACE,YAAA;AH+r2BJ;;AG7r2BE;EACE,YAAA;AHgs2BJ;;AG9r2BE;EACE,YAAA;AHis2BJ;;AG/r2BE;EACE,YAAA;AHks2BJ;;AGhs2BE;EACE,YAAA;AHms2BJ;;AGjs2BE;EACE,YAAA;AHos2BJ;;AGls2BE;EACE,YAAA;AHqs2BJ;;AGns2BE;EACE,YAAA;AHss2BJ;;AGps2BE;EACE,YAAA;AHus2BJ;;AGrs2BE;EACE,YAAA;AHws2BJ;;AGts2BE;EACE,YAAA;AHys2BJ;;AGvs2BE;EACE,YAAA;AH0s2BJ;;AGxs2BE;EACE,YAAA;AH2s2BJ;;AGzs2BE;EACE,YAAA;AH4s2BJ;;AG1s2BE;EACE,YAAA;AH6s2BJ;;AG3s2BE;EACE,YAAA;AH8s2BJ;;AG5s2BE;EACE,YAAA;AH+s2BJ;;AG7s2BE;EACE,YAAA;AHgt2BJ;;AG9s2BE;EACE,YAAA;AHit2BJ;;AG/s2BE;EACE,YAAA;AHkt2BJ;;AGht2BE;EACE,YAAA;AHmt2BJ;;AGjt2BE;EACE,YAAA;AHot2BJ;;AGlt2BE;EACE,YAAA;AHqt2BJ;;AGnt2BE;EACE,YAAA;AHst2BJ;;AGpt2BE;EACE,YAAA;AHut2BJ;;AGrt2BE;EACE,YAAA;AHwt2BJ;;AGtt2BE;EACE,YAAA;AHyt2BJ;;AGvt2BE;EACE,YAAA;AH0t2BJ;;AGxt2BE;EACE,YAAA;AH2t2BJ;;AGzt2BE;EACE,YAAA;AH4t2BJ;;AG1t2BE;EACE,YAAA;AH6t2BJ;;AG3t2BE;EACE,YAAA;AH8t2BJ;;AG5t2BE;EACE,YAAA;AH+t2BJ;;AG7t2BE;EACE,YAAA;AHgu2BJ;;AG9t2BE;EACE,YAAA;AHiu2BJ;;AG/t2BE;EACE,YAAA;AHku2BJ;;AGhu2BE;EACE,YAAA;AHmu2BJ;;AGju2BE;EACE,YAAA;AHou2BJ;;AGlu2BE;EACE,YAAA;AHqu2BJ;;AGnu2BE;EACE,YAAA;AHsu2BJ;;AGpu2BE;EACE,YAAA;AHuu2BJ;;AGru2BE;EACE,YAAA;AHwu2BJ;;AGtu2BE;EACE,YAAA;AHyu2BJ;;AGvu2BE;EACE,YAAA;AH0u2BJ;;AGxu2BE;EACE,YAAA;AH2u2BJ;;AGzu2BE;EACE,YAAA;AH4u2BJ;;AG1u2BE;EACE,YAAA;AH6u2BJ;;AG3u2BE;EACE,YAAA;AH8u2BJ;;AG5u2BE;EACE,YAAA;AH+u2BJ;;AG7u2BE;EACE,YAAA;AHgv2BJ;;AG9u2BE;EACE,YAAA;AHiv2BJ;;AG/u2BE;EACE,YAAA;AHkv2BJ;;AGhv2BE;EACE,YAAA;AHmv2BJ;;AGjv2BE;EACE,YAAA;AHov2BJ;;AGlv2BE;EACE,YAAA;AHqv2BJ;;AGnv2BE;EACE,YAAA;AHsv2BJ;;AGpv2BE;EACE,YAAA;AHuv2BJ;;AGrv2BE;EACE,YAAA;AHwv2BJ;;AGtv2BE;EACE,YAAA;AHyv2BJ;;AGvv2BE;EACE,YAAA;AH0v2BJ;;AGxv2BE;EACE,YAAA;AH2v2BJ;;AGzv2BE;EACE,YAAA;AH4v2BJ;;AG1v2BE;EACE,YAAA;AH6v2BJ;;AG3v2BE;EACE,YAAA;AH8v2BJ;;AG5v2BE;EACE,YAAA;AH+v2BJ;;AG7v2BE;EACE,YAAA;AHgw2BJ;;AG9v2BE;EACE,YAAA;AHiw2BJ;;AG/v2BE;EACE,YAAA;AHkw2BJ;;AGhw2BE;EACE,YAAA;AHmw2BJ;;AGjw2BE;EACE,YAAA;AHow2BJ;;AGlw2BE;EACE,YAAA;AHqw2BJ;;AGnw2BE;EACE,YAAA;AHsw2BJ;;AGpw2BE;EACE,YAAA;AHuw2BJ;;AGrw2BE;EACE,YAAA;AHww2BJ;;AGtw2BE;EACE,YAAA;AHyw2BJ;;AGvw2BE;EACE,YAAA;AH0w2BJ;;AGxw2BE;EACE,YAAA;AH2w2BJ;;AGzw2BE;EACE,YAAA;AH4w2BJ;;AG1w2BE;EACE,YAAA;AH6w2BJ;;AG3w2BE;EACE,YAAA;AH8w2BJ;;AG5w2BE;EACE,YAAA;AH+w2BJ;;AG7w2BE;EACE,YAAA;AHgx2BJ;;AG9w2BE;EACE,YAAA;AHix2BJ;;AG/w2BE;EACE,YAAA;AHkx2BJ;;AGhx2BE;EACE,YAAA;AHmx2BJ;;AGjx2BE;EACE,YAAA;AHox2BJ;;AGlx2BE;EACE,YAAA;AHqx2BJ;;AGnx2BE;EACE,YAAA;AHsx2BJ;;AGpx2BE;EACE,YAAA;AHux2BJ;;AGrx2BE;EACE,YAAA;AHwx2BJ;;AGtx2BE;EACE,YAAA;AHyx2BJ;;AGvx2BE;EACE,YAAA;AH0x2BJ;;AGxx2BE;EACE,YAAA;AH2x2BJ;;AGzx2BE;EACE,YAAA;AH4x2BJ;;AG1x2BE;EACE,YAAA;AH6x2BJ;;AG3x2BE;EACE,YAAA;AH8x2BJ;;AG5x2BE;EACE,YAAA;AH+x2BJ;;AG7x2BE;EACE,YAAA;AHgy2BJ;;AG9x2BE;EACE,YAAA;AHiy2BJ;;AG/x2BE;EACE,YAAA;AHky2BJ;;AGhy2BE;EACE,YAAA;AHmy2BJ;;AGjy2BE;EACE,YAAA;AHoy2BJ;;AGly2BE;EACE,YAAA;AHqy2BJ;;AGny2BE;EACE,YAAA;AHsy2BJ;;AGpy2BE;EACE,YAAA;AHuy2BJ;;AGry2BE;EACE,YAAA;AHwy2BJ;;AGty2BE;EACE,YAAA;AHyy2BJ;;AGvy2BE;EACE,YAAA;AH0y2BJ;;AGxy2BE;EACE,YAAA;AH2y2BJ;;AGzy2BE;EACE,YAAA;AH4y2BJ;;AG1y2BE;EACE,YAAA;AH6y2BJ;;AG3y2BE;EACE,YAAA;AH8y2BJ;;AG5y2BE;EACE,YAAA;AH+y2BJ;;AG7y2BE;EACE,YAAA;AHgz2BJ;;AG9y2BE;EACE,YAAA;AHiz2BJ;;AG/y2BE;EACE,YAAA;AHkz2BJ;;AGhz2BE;EACE,YAAA;AHmz2BJ;;AGjz2BE;EACE,YAAA;AHoz2BJ;;AGlz2BE;EACE,YAAA;AHqz2BJ;;AGnz2BE;EACE,YAAA;AHsz2BJ;;AGpz2BE;EACE,YAAA;AHuz2BJ;;AGrz2BE;EACE,YAAA;AHwz2BJ;;AGtz2BE;EACE,YAAA;AHyz2BJ;;AGvz2BE;EACE,YAAA;AH0z2BJ;;AGxz2BE;EACE,YAAA;AH2z2BJ;;AGzz2BE;EACE,YAAA;AH4z2BJ;;AG1z2BE;EACE,YAAA;AH6z2BJ;;AG3z2BE;EACE,YAAA;AH8z2BJ;;AG5z2BE;EACE,YAAA;AH+z2BJ;;AG7z2BE;EACE,YAAA;AHg02BJ;;AG9z2BE;EACE,YAAA;AHi02BJ;;AG/z2BE;EACE,YAAA;AHk02BJ;;AGh02BE;EACE,YAAA;AHm02BJ;;AGj02BE;EACE,YAAA;AHo02BJ;;AGl02BE;EACE,YAAA;AHq02BJ;;AGn02BE;EACE,YAAA;AHs02BJ;;AGp02BE;EACE,YAAA;AHu02BJ;;AGr02BE;EACE,YAAA;AHw02BJ;;AGt02BE;EACE,YAAA;AHy02BJ;;AGv02BE;EACE,YAAA;AH002BJ;;AGx02BE;EACE,YAAA;AH202BJ;;AGz02BE;EACE,YAAA;AH402BJ;;AG102BE;EACE,YAAA;AH602BJ;;AG302BE;EACE,YAAA;AH802BJ;;AG502BE;EACE,YAAA;AH+02BJ;;AG702BE;EACE,YAAA;AHg12BJ;;AG902BE;EACE,YAAA;AHi12BJ;;AG/02BE;EACE,YAAA;AHk12BJ;;AGh12BE;EACE,YAAA;AHm12BJ;;AGj12BE;EACE,YAAA;AHo12BJ;;AGl12BE;EACE,YAAA;AHq12BJ;;AGn12BE;EACE,YAAA;AHs12BJ;;AGp12BE;EACE,YAAA;AHu12BJ;;AGr12BE;EACE,YAAA;AHw12BJ;;AGt12BE;EACE,YAAA;AHy12BJ;;AGv12BE;EACE,YAAA;AH012BJ;;AGx12BE;EACE,YAAA;AH212BJ;;AGz12BE;EACE,YAAA;AH412BJ;;AG112BE;EACE,YAAA;AH612BJ;;AG312BE;EACE,YAAA;AH812BJ;;AG512BE;EACE,YAAA;AH+12BJ;;AG712BE;EACE,YAAA;AHg22BJ;;AG912BE;EACE,YAAA;AHi22BJ;;AG/12BE;EACE,YAAA;AHk22BJ;;AGh22BE;EACE,YAAA;AHm22BJ;;AGj22BE;EACE,YAAA;AHo22BJ;;AGl22BE;EACE,YAAA;AHq22BJ;;AGn22BE;EACE,YAAA;AHs22BJ;;AGp22BE;EACE,YAAA;AHu22BJ;;AGr22BE;EACE,YAAA;AHw22BJ;;AGt22BE;EACE,YAAA;AHy22BJ;;AGv22BE;EACE,YAAA;AH022BJ;;AGx22BE;EACE,YAAA;AH222BJ;;AGz22BE;EACE,YAAA;AH422BJ;;AG122BE;EACE,YAAA;AH622BJ;;AG322BE;EACE,YAAA;AH822BJ;;AG522BE;EACE,YAAA;AH+22BJ;;AG722BE;EACE,YAAA;AHg32BJ;;AG922BE;EACE,YAAA;AHi32BJ;;AG/22BE;EACE,YAAA;AHk32BJ;;AGh32BE;EACE,YAAA;AHm32BJ;;AGj32BE;EACE,YAAA;AHo32BJ;;AGl32BE;EACE,YAAA;AHq32BJ;;AGn32BE;EACE,YAAA;AHs32BJ;;AGp32BE;EACE,YAAA;AHu32BJ;;AGr32BE;EACE,YAAA;AHw32BJ;;AGt32BE;EACE,YAAA;AHy32BJ;;AGv32BE;EACE,YAAA;AH032BJ;;AGx32BE;EACE,YAAA;AH232BJ;;AGz32BE;EACE,YAAA;AH432BJ;;AG132BE;EACE,YAAA;AH632BJ;;AG332BE;EACE,YAAA;AH832BJ;;AG532BE;EACE,YAAA;AH+32BJ;;AG732BE;EACE,YAAA;AHg42BJ;;AG932BE;EACE,YAAA;AHi42BJ;;AG/32BE;EACE,YAAA;AHk42BJ;;AGh42BE;EACE,YAAA;AHm42BJ;;AGj42BE;EACE,YAAA;AHo42BJ;;AGl42BE;EACE,YAAA;AHq42BJ;;AGn42BE;EACE,YAAA;AHs42BJ;;AGp42BE;EACE,YAAA;AHu42BJ;;AGr42BE;EACE,YAAA;AHw42BJ;;AGt42BE;EACE,YAAA;AHy42BJ;;AGv42BE;EACE,YAAA;AH042BJ;;AGx42BE;EACE,YAAA;AH242BJ;;AGz42BE;EACE,YAAA;AH442BJ;;AG142BE;EACE,YAAA;AH642BJ;;AG342BE;EACE,YAAA;AH842BJ;;AG542BE;EACE,YAAA;AH+42BJ;;AG742BE;EACE,YAAA;AHg52BJ;;AG942BE;EACE,YAAA;AHi52BJ;;AG/42BE;EACE,YAAA;AHk52BJ;;AGh52BE;EACE,YAAA;AHm52BJ;;AGj52BE;EACE,YAAA;AHo52BJ;;AGl52BE;EACE,YAAA;AHq52BJ;;AGn52BE;EACE,YAAA;AHs52BJ;;AGp52BE;EACE,YAAA;AHu52BJ;;AGr52BE;EACE,YAAA;AHw52BJ;;AGt52BE;EACE,YAAA;AHy52BJ;;AGv52BE;EACE,YAAA;AH052BJ;;AGx52BE;EACE,YAAA;AH252BJ;;AGz52BE;EACE,YAAA;AH452BJ;;AG152BE;EACE,YAAA;AH652BJ;;AG352BE;EACE,YAAA;AH852BJ;;AG552BE;EACE,YAAA;AH+52BJ;;AG752BE;EACE,YAAA;AHg62BJ;;AG952BE;EACE,YAAA;AHi62BJ;;AG/52BE;EACE,YAAA;AHk62BJ;;AGh62BE;EACE,YAAA;AHm62BJ;;AGj62BE;EACE,YAAA;AHo62BJ;;AGl62BE;EACE,YAAA;AHq62BJ;;AGn62BE;EACE,YAAA;AHs62BJ;;AGp62BE;EACE,YAAA;AHu62BJ;;AGr62BE;EACE,YAAA;AHw62BJ;;AGt62BE;EACE,YAAA;AHy62BJ;;AGv62BE;EACE,YAAA;AH062BJ;;AGx62BE;EACE,YAAA;AH262BJ;;AGz62BE;EACE,YAAA;AH462BJ;;AG162BE;EACE,YAAA;AH662BJ;;AG362BE;EACE,YAAA;AH862BJ;;AG562BE;EACE,YAAA;AH+62BJ;;AG762BE;EACE,YAAA;AHg72BJ;;AG962BE;EACE,YAAA;AHi72BJ;;AG/62BE;EACE,YAAA;AHk72BJ;;AGh72BE;EACE,YAAA;AHm72BJ;;AGj72BE;EACE,YAAA;AHo72BJ;;AGl72BE;EACE,YAAA;AHq72BJ;;AGn72BE;EACE,YAAA;AHs72BJ;;AGp72BE;EACE,YAAA;AHu72BJ;;AGr72BE;EACE,YAAA;AHw72BJ;;AGt72BE;EACE,YAAA;AHy72BJ;;AGv72BE;EACE,YAAA;AH072BJ;;AGx72BE;EACE,YAAA;AH272BJ;;AGz72BE;EACE,YAAA;AH472BJ;;AG172BE;EACE,YAAA;AH672BJ;;AG372BE;EACE,YAAA;AH872BJ;;AG572BE;EACE,YAAA;AH+72BJ;;AG772BE;EACE,YAAA;AHg82BJ;;AG972BE;EACE,YAAA;AHi82BJ;;AG/72BE;EACE,YAAA;AHk82BJ;;AGh82BE;EACE,YAAA;AHm82BJ;;AGj82BE;EACE,YAAA;AHo82BJ;;AGl82BE;EACE,YAAA;AHq82BJ;;AGn82BE;EACE,YAAA;AHs82BJ;;AGp82BE;EACE,YAAA;AHu82BJ;;AGr82BE;EACE,YAAA;AHw82BJ;;AGt82BE;EACE,YAAA;AHy82BJ;;AGv82BE;EACE,YAAA;AH082BJ;;AGx82BE;EACE,YAAA;AH282BJ;;AGz82BE;EACE,YAAA;AH482BJ;;AG182BE;EACE,YAAA;AH682BJ;;AG382BE;EACE,YAAA;AH882BJ;;AG582BE;EACE,YAAA;AH+82BJ;;AG782BE;EACE,YAAA;AHg92BJ;;AG982BE;EACE,YAAA;AHi92BJ;;AG/82BE;EACE,YAAA;AHk92BJ;;AGh92BE;EACE,YAAA;AHm92BJ;;AGj92BE;EACE,YAAA;AHo92BJ;;AI7lhCA;;;;;;EAME,kCAAA;EACA,mCAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;AJgmhCF;;AI9lhCA;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;AJimhCF;;AI/lhCA;EACE,iBAAA;AJkmhCF;;AIhmhCA;EACE,kBAAA;AJmmhCF;;AIjmhCA;EACE,cAAA;AJomhCF;;AIlmhCA;EACE,cAAA;AJqmhCF;;AInmhCA;EACE,cAAA;AJsmhCF;;AIpmhCA;EACE,cAAA;AJumhCF;;AIrmhCA;EACE,cAAA;AJwmhCF;;AItmhCA;EACE,cAAA;AJymhCF;;AIvmhCA;EACE,cAAA;AJ0mhCF;;AIxmhCA;EACE,cAAA;AJ2mhCF;;AIzmhCA;EACE,cAAA;AJ4mhCF;;AI1mhCA;EACE,eAAA;AJ6mhCF;;AI3mhCA;EACE,kBAAA;EACA,aAAA;AJ8mhCF;;AI5mhCA;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;AJ+mhCF;;AI9mhCE;EACE,kBAAA;AJinhCJ;;AI/mhCA;EACE,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;AJknhCF;;AIhnhCA;EACE,yBAAA;EACA,oBAAA;EACA,4BAAA;AJmnhCF;;AIjnhCA;EACE,WAAA;AJonhCF;;AIlnhCA;EACE,YAAA;AJqnhCF;;AInnhCA;;;;;EAKE,mBAAA;AJsnhCF;;AIpnhCA;;;;;EAKE,kBAAA;AJunhCF;;AIrnhCA;EAEU,qCAAA;AJwnhCV;;AItnhCA;EAEU,uCAAA;AJynhCV;AI/mhCA;EACE;IAEU,uBAAA;EJ4nhCV;EI3nhCA;IAEU,yBAAA;EJ6nhCV;AACF;AI5nhCA;EACE,sEAAA;EAEQ,wBAAA;AJ8nhCV;;AI5nhCA;EACE,sEAAA;EAEQ,yBAAA;AJ+nhCV;;AI7nhCA;EACE,sEAAA;EAEQ,yBAAA;AJgohCV;;AI9nhCA;EACE,gFAAA;EAEQ,uBAAA;AJiohCV;;AI/nhCA;EACE,gFAAA;EAEQ,uBAAA;AJkohCV;;AIhohCA;EACE,gFAAA;EAEQ,wBAAA;AJmohCV;;AIjohCA;;;;;;EAOU,YAAA;AJoohCV;;AIlohCA;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;AJqohCF;;AInohCA;;EAEE,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AJsohCF;;AIpohCA;EACE,oBAAA;AJuohCF;;AIrohCA;EACE,cAAA;AJwohCF;;AItohCA;EACE,WAAA;AJyohCF;;AIvohCA;gEAAA;AAEA;EACE,YAAA;AJ0ohCF;;AIxohCA;EACE,YAAA;AJ2ohCF;;AIzohCA;EACE,YAAA;AJ4ohCF;;AI1ohCA;EACE,YAAA;AJ6ohCF;;AI3ohCA;EACE,YAAA;AJ8ohCF;;AI5ohCA;EACE,YAAA;AJ+ohCF;;AI7ohCA;EACE,YAAA;AJgphCF;;AI9ohCA;EACE,YAAA;AJiphCF;;AI/ohCA;EACE,YAAA;AJkphCF;;AIhphCA;EACE,YAAA;AJmphCF;;AIjphCA;EACE,YAAA;AJophCF;;AIlphCA;EACE,YAAA;AJqphCF;;AInphCA;EACE,YAAA;AJsphCF;;AIpphCA;EACE,YAAA;AJuphCF;;AIrphCA;EACE,YAAA;AJwphCF;;AItphCA;EACE,YAAA;AJyphCF;;AIvphCA;EACE,YAAA;AJ0phCF;;AIxphCA;EACE,YAAA;AJ2phCF;;AIzphCA;EACE,YAAA;AJ4phCF;;AI1phCA;EACE,YAAA;AJ6phCF;;AI3phCA;EACE,YAAA;AJ8phCF;;AI5phCA;EACE,YAAA;AJ+phCF;;AI7phCA;EACE,YAAA;AJgqhCF;;AI9phCA;EACE,YAAA;AJiqhCF;;AI/phCA;EACE,YAAA;AJkqhCF;;AIhqhCA;EACE,YAAA;AJmqhCF;;AIjqhCA;EACE,YAAA;AJoqhCF;;AIlqhCA;EACE,YAAA;AJqqhCF;;AInqhCA;EACE,YAAA;AJsqhCF;;AIpqhCA;EACE,YAAA;AJuqhCF;;AIrqhCA;EACE,YAAA;AJwqhCF;;AItqhCA;EACE,YAAA;AJyqhCF;;AIvqhCA;EACE,YAAA;AJ0qhCF;;AIxqhCA;EACE,YAAA;AJ2qhCF;;AIzqhCA;EACE,YAAA;AJ4qhCF;;AI1qhCA;EACE,YAAA;AJ6qhCF;;AI3qhCA;EACE,YAAA;AJ8qhCF;;AI5qhCA;EACE,YAAA;AJ+qhCF;;AI7qhCA;EACE,YAAA;AJgrhCF;;AI9qhCA;EACE,YAAA;AJirhCF;;AI/qhCA;EACE,YAAA;AJkrhCF;;AIhrhCA;EACE,YAAA;AJmrhCF;;AIjrhCA;EACE,YAAA;AJorhCF;;AIlrhCA;EACE,YAAA;AJqrhCF;;AInrhCA;EACE,YAAA;AJsrhCF;;AIprhCA;EACE,YAAA;AJurhCF;;AIrrhCA;EACE,YAAA;AJwrhCF;;AItrhCA;EACE,YAAA;AJyrhCF;;AIvrhCA;EACE,YAAA;AJ0rhCF;;AIxrhCA;EACE,YAAA;AJ2rhCF;;AIzrhCA;EACE,YAAA;AJ4rhCF;;AI1rhCA;EACE,YAAA;AJ6rhCF;;AI3rhCA;EACE,YAAA;AJ8rhCF;;AI5rhCA;EACE,YAAA;AJ+rhCF;;AI7rhCA;EACE,YAAA;AJgshCF;;AI9rhCA;EACE,YAAA;AJishCF;;AI/rhCA;EACE,YAAA;AJkshCF;;AIhshCA;EACE,YAAA;AJmshCF;;AIjshCA;EACE,YAAA;AJoshCF;;AIlshCA;EACE,YAAA;AJqshCF;;AInshCA;EACE,YAAA;AJsshCF;;AIpshCA;EACE,YAAA;AJushCF;;AIrshCA;EACE,YAAA;AJwshCF;;AItshCA;EACE,YAAA;AJyshCF;;AIvshCA;EACE,YAAA;AJ0shCF;;AIxshCA;EACE,YAAA;AJ2shCF;;AIzshCA;EACE,YAAA;AJ4shCF;;AI1shCA;EACE,YAAA;AJ6shCF;;AI3shCA;EACE,YAAA;AJ8shCF;;AI5shCA;EACE,YAAA;AJ+shCF;;AI7shCA;EACE,YAAA;AJgthCF;;AI9shCA;EACE,YAAA;AJithCF;;AI/shCA;EACE,YAAA;AJkthCF;;AIhthCA;EACE,YAAA;AJmthCF;;AIjthCA;EACE,YAAA;AJothCF;;AIlthCA;EACE,YAAA;AJqthCF;;AInthCA;EACE,YAAA;AJsthCF;;AIpthCA;EACE,YAAA;AJuthCF;;AIrthCA;EACE,YAAA;AJwthCF;;AItthCA;EACE,YAAA;AJythCF;;AIvthCA;EACE,YAAA;AJ0thCF;;AIxthCA;EACE,YAAA;AJ2thCF;;AIzthCA;EACE,YAAA;AJ4thCF;;AI1thCA;EACE,YAAA;AJ6thCF;;AI3thCA;EACE,YAAA;AJ8thCF;;AI5thCA;EACE,YAAA;AJ+thCF;;AI7thCA;EACE,YAAA;AJguhCF;;AI9thCA;EACE,YAAA;AJiuhCF;;AI/thCA;EACE,YAAA;AJkuhCF;;AIhuhCA;EACE,YAAA;AJmuhCF;;AIjuhCA;EACE,YAAA;AJouhCF;;AIluhCA;EACE,YAAA;AJquhCF;;AInuhCA;EACE,YAAA;AJsuhCF;;AIpuhCA;EACE,YAAA;AJuuhCF;;AIruhCA;EACE,YAAA;AJwuhCF;;AItuhCA;EACE,YAAA;AJyuhCF;;AIvuhCA;EACE,YAAA;AJ0uhCF;;AIxuhCA;EACE,YAAA;AJ2uhCF;;AIzuhCA;EACE,YAAA;AJ4uhCF;;AI1uhCA;EACE,YAAA;AJ6uhCF;;AI3uhCA;EACE,YAAA;AJ8uhCF;;AI5uhCA;EACE,YAAA;AJ+uhCF;;AI7uhCA;EACE,YAAA;AJgvhCF;;AI9uhCA;EACE,YAAA;AJivhCF;;AI/uhCA;EACE,YAAA;AJkvhCF;;AIhvhCA;EACE,YAAA;AJmvhCF;;AIjvhCA;EACE,YAAA;AJovhCF;;AIlvhCA;EACE,YAAA;AJqvhCF;;AInvhCA;EACE,YAAA;AJsvhCF;;AIpvhCA;EACE,YAAA;AJuvhCF;;AIrvhCA;EACE,YAAA;AJwvhCF;;AItvhCA;EACE,YAAA;AJyvhCF;;AIvvhCA;EACE,YAAA;AJ0vhCF;;AIxvhCA;EACE,YAAA;AJ2vhCF;;AIzvhCA;EACE,YAAA;AJ4vhCF;;AI1vhCA;EACE,YAAA;AJ6vhCF;;AI3vhCA;EACE,YAAA;AJ8vhCF;;AI5vhCA;EACE,YAAA;AJ+vhCF;;AI7vhCA;EACE,YAAA;AJgwhCF;;AI9vhCA;EACE,YAAA;AJiwhCF;;AI/vhCA;EACE,YAAA;AJkwhCF;;AIhwhCA;EACE,YAAA;AJmwhCF;;AIjwhCA;EACE,YAAA;AJowhCF;;AIlwhCA;EACE,YAAA;AJqwhCF;;AInwhCA;EACE,YAAA;AJswhCF;;AIpwhCA;EACE,YAAA;AJuwhCF;;AIrwhCA;EACE,YAAA;AJwwhCF;;AItwhCA;EACE,YAAA;AJywhCF;;AIvwhCA;EACE,YAAA;AJ0whCF;;AIxwhCA;EACE,YAAA;AJ2whCF;;AIzwhCA;EACE,YAAA;AJ4whCF;;AI1whCA;EACE,YAAA;AJ6whCF;;AI3whCA;EACE,YAAA;AJ8whCF;;AI5whCA;EACE,YAAA;AJ+whCF;;AI7whCA;EACE,YAAA;AJgxhCF;;AI9whCA;EACE,YAAA;AJixhCF;;AI/whCA;EACE,YAAA;AJkxhCF;;AIhxhCA;EACE,YAAA;AJmxhCF;;AIjxhCA;EACE,YAAA;AJoxhCF;;AIlxhCA;EACE,YAAA;AJqxhCF;;AInxhCA;EACE,YAAA;AJsxhCF;;AIpxhCA;EACE,YAAA;AJuxhCF;;AIrxhCA;EACE,YAAA;AJwxhCF;;AItxhCA;EACE,YAAA;AJyxhCF;;AIvxhCA;EACE,YAAA;AJ0xhCF;;AIxxhCA;EACE,YAAA;AJ2xhCF;;AIzxhCA;EACE,YAAA;AJ4xhCF;;AI1xhCA;EACE,YAAA;AJ6xhCF;;AI3xhCA;EACE,YAAA;AJ8xhCF;;AI5xhCA;EACE,YAAA;AJ+xhCF;;AI7xhCA;EACE,YAAA;AJgyhCF;;AI9xhCA;EACE,YAAA;AJiyhCF;;AI/xhCA;EACE,YAAA;AJkyhCF;;AIhyhCA;EACE,YAAA;AJmyhCF;;AIjyhCA;EACE,YAAA;AJoyhCF;;AIlyhCA;EACE,YAAA;AJqyhCF;;AInyhCA;EACE,YAAA;AJsyhCF;;AIpyhCA;EACE,YAAA;AJuyhCF;;AIryhCA;EACE,YAAA;AJwyhCF;;AItyhCA;EACE,YAAA;AJyyhCF;;AIvyhCA;EACE,YAAA;AJ0yhCF;;AIxyhCA;EACE,YAAA;AJ2yhCF;;AIzyhCA;EACE,YAAA;AJ4yhCF;;AI1yhCA;EACE,YAAA;AJ6yhCF;;AI3yhCA;EACE,YAAA;AJ8yhCF;;AI5yhCA;EACE,YAAA;AJ+yhCF;;AI7yhCA;EACE,YAAA;AJgzhCF;;AI9yhCA;EACE,YAAA;AJizhCF;;AI/yhCA;EACE,YAAA;AJkzhCF;;AIhzhCA;EACE,YAAA;AJmzhCF;;AIjzhCA;EACE,YAAA;AJozhCF;;AIlzhCA;EACE,YAAA;AJqzhCF;;AInzhCA;EACE,YAAA;AJszhCF;;AIpzhCA;EACE,YAAA;AJuzhCF;;AIrzhCA;EACE,YAAA;AJwzhCF;;AItzhCA;EACE,YAAA;AJyzhCF;;AIvzhCA;EACE,YAAA;AJ0zhCF;;AIxzhCA;EACE,YAAA;AJ2zhCF;;AIzzhCA;EACE,YAAA;AJ4zhCF;;AI1zhCA;EACE,YAAA;AJ6zhCF;;AI3zhCA;EACE,YAAA;AJ8zhCF;;AI5zhCA;EACE,YAAA;AJ+zhCF;;AI7zhCA;EACE,YAAA;AJg0hCF;;AI9zhCA;EACE,YAAA;AJi0hCF;;AI/zhCA;EACE,YAAA;AJk0hCF;;AIh0hCA;EACE,YAAA;AJm0hCF;;AIj0hCA;EACE,YAAA;AJo0hCF;;AIl0hCA;EACE,YAAA;AJq0hCF;;AIn0hCA;EACE,YAAA;AJs0hCF;;AIp0hCA;EACE,YAAA;AJu0hCF;;AIr0hCA;EACE,YAAA;AJw0hCF;;AIt0hCA;EACE,YAAA;AJy0hCF;;AIv0hCA;EACE,YAAA;AJ00hCF;;AIx0hCA;EACE,YAAA;AJ20hCF;;AIz0hCA;EACE,YAAA;AJ40hCF;;AI10hCA;EACE,YAAA;AJ60hCF;;AI30hCA;EACE,YAAA;AJ80hCF;;AI50hCA;EACE,YAAA;AJ+0hCF;;AI70hCA;EACE,YAAA;AJg1hCF;;AI90hCA;EACE,YAAA;AJi1hCF;;AI/0hCA;EACE,YAAA;AJk1hCF;;AIh1hCA;EACE,YAAA;AJm1hCF;;AIj1hCA;EACE,YAAA;AJo1hCF;;AIl1hCA;EACE,YAAA;AJq1hCF;;AIn1hCA;EACE,YAAA;AJs1hCF;;AIp1hCA;EACE,YAAA;AJu1hCF;;AIr1hCA;EACE,YAAA;AJw1hCF;;AIt1hCA;EACE,YAAA;AJy1hCF;;AIv1hCA;EACE,YAAA;AJ01hCF;;AIx1hCA;EACE,YAAA;AJ21hCF;;AIz1hCA;EACE,YAAA;AJ41hCF;;AI11hCA;EACE,YAAA;AJ61hCF;;AI31hCA;EACE,YAAA;AJ81hCF;;AI51hCA;EACE,YAAA;AJ+1hCF;;AI71hCA;EACE,YAAA;AJg2hCF;;AI91hCA;EACE,YAAA;AJi2hCF;;AI/1hCA;EACE,YAAA;AJk2hCF;;AIh2hCA;EACE,YAAA;AJm2hCF;;AIj2hCA;EACE,YAAA;AJo2hCF;;AIl2hCA;EACE,YAAA;AJq2hCF;;AIn2hCA;EACE,YAAA;AJs2hCF;;AIp2hCA;EACE,YAAA;AJu2hCF;;AIr2hCA;EACE,YAAA;AJw2hCF;;AIt2hCA;EACE,YAAA;AJy2hCF;;AIv2hCA;EACE,YAAA;AJ02hCF;;AIx2hCA;EACE,YAAA;AJ22hCF;;AIz2hCA;EACE,YAAA;AJ42hCF;;AI12hCA;EACE,YAAA;AJ62hCF;;AI32hCA;EACE,YAAA;AJ82hCF;;AI52hCA;EACE,YAAA;AJ+2hCF;;AI72hCA;EACE,YAAA;AJg3hCF;;AI92hCA;EACE,YAAA;AJi3hCF;;AI/2hCA;EACE,YAAA;AJk3hCF;;AIh3hCA;EACE,YAAA;AJm3hCF;;AIj3hCA;EACE,YAAA;AJo3hCF;;AIl3hCA;EACE,YAAA;AJq3hCF;;AIn3hCA;EACE,YAAA;AJs3hCF;;AIp3hCA;EACE,YAAA;AJu3hCF;;AIr3hCA;EACE,YAAA;AJw3hCF;;AIt3hCA;EACE,YAAA;AJy3hCF;;AIv3hCA;EACE,YAAA;AJ03hCF;;AIx3hCA;EACE,YAAA;AJ23hCF;;AIz3hCA;EACE,YAAA;AJ43hCF;;AI13hCA;EACE,YAAA;AJ63hCF;;AI33hCA;EACE,YAAA;AJ83hCF;;AI53hCA;EACE,YAAA;AJ+3hCF;;AI73hCA;EACE,YAAA;AJg4hCF;;AI93hCA;EACE,YAAA;AJi4hCF;;AI/3hCA;EACE,YAAA;AJk4hCF;;AIh4hCA;EACE,YAAA;AJm4hCF;;AIj4hCA;EACE,YAAA;AJo4hCF;;AIl4hCA;EACE,YAAA;AJq4hCF;;AIn4hCA;EACE,YAAA;AJs4hCF;;AIp4hCA;EACE,YAAA;AJu4hCF;;AIr4hCA;EACE,YAAA;AJw4hCF;;AIt4hCA;EACE,YAAA;AJy4hCF;;AIv4hCA;EACE,YAAA;AJ04hCF;;AIx4hCA;EACE,YAAA;AJ24hCF;;AIz4hCA;EACE,YAAA;AJ44hCF;;AI14hCA;EACE,YAAA;AJ64hCF;;AI34hCA;EACE,YAAA;AJ84hCF;;AI54hCA;EACE,YAAA;AJ+4hCF;;AI74hCA;EACE,YAAA;AJg5hCF;;AI94hCA;EACE,YAAA;AJi5hCF;;AI/4hCA;EACE,YAAA;AJk5hCF;;AIh5hCA;EACE,YAAA;AJm5hCF;;AIj5hCA;EACE,YAAA;AJo5hCF;;AIl5hCA;EACE,YAAA;AJq5hCF;;AIn5hCA;EACE,YAAA;AJs5hCF;;AIp5hCA;EACE,YAAA;AJu5hCF;;AIr5hCA;EACE,YAAA;AJw5hCF;;AIt5hCA;EACE,YAAA;AJy5hCF;;AIv5hCA;EACE,YAAA;AJ05hCF;;AIx5hCA;EACE,YAAA;AJ25hCF;;AIz5hCA;EACE,YAAA;AJ45hCF;;AI15hCA;EACE,YAAA;AJ65hCF;;AI35hCA;EACE,YAAA;AJ85hCF;;AI55hCA;EACE,YAAA;AJ+5hCF;;AI75hCA;EACE,YAAA;AJg6hCF;;AI95hCA;EACE,YAAA;AJi6hCF;;AI/5hCA;EACE,YAAA;AJk6hCF;;AIh6hCA;EACE,YAAA;AJm6hCF;;AIj6hCA;EACE,YAAA;AJo6hCF;;AIl6hCA;EACE,YAAA;AJq6hCF;;AIn6hCA;EACE,YAAA;AJs6hCF;;AIp6hCA;EACE,YAAA;AJu6hCF;;AIr6hCA;EACE,YAAA;AJw6hCF;;AIt6hCA;EACE,YAAA;AJy6hCF;;AIv6hCA;EACE,YAAA;AJ06hCF;;AIx6hCA;EACE,YAAA;AJ26hCF;;AIz6hCA;EACE,YAAA;AJ46hCF;;AI16hCA;EACE,YAAA;AJ66hCF;;AI36hCA;EACE,YAAA;AJ86hCF;;AI56hCA;EACE,YAAA;AJ+6hCF;;AI76hCA;EACE,YAAA;AJg7hCF;;AI96hCA;EACE,YAAA;AJi7hCF;;AI/6hCA;EACE,YAAA;AJk7hCF;;AIh7hCA;EACE,YAAA;AJm7hCF;;AIj7hCA;EACE,YAAA;AJo7hCF;;AIl7hCA;EACE,YAAA;AJq7hCF;;AIn7hCA;EACE,YAAA;AJs7hCF;;AIp7hCA;EACE,YAAA;AJu7hCF;;AIr7hCA;EACE,YAAA;AJw7hCF;;AIt7hCA;EACE,YAAA;AJy7hCF;;AIv7hCA;EACE,YAAA;AJ07hCF;;AIx7hCA;EACE,YAAA;AJ27hCF;;AIz7hCA;EACE,YAAA;AJ47hCF;;AI17hCA;EACE,YAAA;AJ67hCF;;AI37hCA;EACE,YAAA;AJ87hCF;;AI57hCA;EACE,YAAA;AJ+7hCF;;AI77hCA;EACE,YAAA;AJg8hCF;;AI97hCA;EACE,YAAA;AJi8hCF;;AI/7hCA;EACE,YAAA;AJk8hCF;;AIh8hCA;EACE,YAAA;AJm8hCF;;AIj8hCA;EACE,YAAA;AJo8hCF;;AIl8hCA;EACE,YAAA;AJq8hCF;;AIn8hCA;EACE,YAAA;AJs8hCF;;AIp8hCA;EACE,YAAA;AJu8hCF;;AIr8hCA;EACE,YAAA;AJw8hCF;;AIt8hCA;EACE,YAAA;AJy8hCF;;AIv8hCA;EACE,YAAA;AJ08hCF;;AIx8hCA;EACE,YAAA;AJ28hCF;;AIz8hCA;EACE,YAAA;AJ48hCF;;AI18hCA;EACE,YAAA;AJ68hCF;;AI38hCA;EACE,YAAA;AJ88hCF;;AI58hCA;EACE,YAAA;AJ+8hCF;;AI78hCA;EACE,YAAA;AJg9hCF;;AI98hCA;EACE,YAAA;AJi9hCF;;AI/8hCA;EACE,YAAA;AJk9hCF;;AIh9hCA;EACE,YAAA;AJm9hCF;;AIj9hCA;EACE,YAAA;AJo9hCF;;AIl9hCA;EACE,YAAA;AJq9hCF;;AIn9hCA;EACE,YAAA;AJs9hCF;;AIp9hCA;EACE,YAAA;AJu9hCF;;AIr9hCA;EACE,YAAA;AJw9hCF;;AIt9hCA;EACE,YAAA;AJy9hCF;;AIv9hCA;EACE,YAAA;AJ09hCF;;AIx9hCA;EACE,YAAA;AJ29hCF;;AIz9hCA;EACE,YAAA;AJ49hCF;;AI19hCA;EACE,YAAA;AJ69hCF;;AI39hCA;EACE,YAAA;AJ89hCF;;AI59hCA;EACE,YAAA;AJ+9hCF;;AI79hCA;EACE,YAAA;AJg+hCF;;AI99hCA;EACE,YAAA;AJi+hCF;;AI/9hCA;EACE,YAAA;AJk+hCF;;AIh+hCA;EACE,YAAA;AJm+hCF;;AIj+hCA;EACE,YAAA;AJo+hCF;;AIl+hCA;EACE,YAAA;AJq+hCF;;AIn+hCA;EACE,YAAA;AJs+hCF;;AIp+hCA;EACE,YAAA;AJu+hCF;;AIr+hCA;EACE,YAAA;AJw+hCF;;AIt+hCA;EACE,YAAA;AJy+hCF;;AIv+hCA;EACE,YAAA;AJ0+hCF;;AIx+hCA;EACE,YAAA;AJ2+hCF;;AIz+hCA;EACE,YAAA;AJ4+hCF;;AI1+hCA;EACE,YAAA;AJ6+hCF;;AI3+hCA;EACE,YAAA;AJ8+hCF;;AI5+hCA;EACE,YAAA;AJ++hCF;;AI7+hCA;EACE,YAAA;AJg/hCF;;AI9+hCA;EACE,YAAA;AJi/hCF;;AI/+hCA;EACE,YAAA;AJk/hCF;;AIh/hCA;EACE,YAAA;AJm/hCF;;AIj/hCA;EACE,YAAA;AJo/hCF;;AIl/hCA;EACE,YAAA;AJq/hCF;;AIn/hCA;EACE,YAAA;AJs/hCF;;AIp/hCA;EACE,YAAA;AJu/hCF;;AIr/hCA;EACE,YAAA;AJw/hCF;;AIt/hCA;EACE,YAAA;AJy/hCF;;AIv/hCA;EACE,YAAA;AJ0/hCF;;AIx/hCA;EACE,YAAA;AJ2/hCF;;AIz/hCA;EACE,YAAA;AJ4/hCF;;AI1/hCA;EACE,YAAA;AJ6/hCF;;AI3/hCA;EACE,YAAA;AJ8/hCF;;AI5/hCA;EACE,YAAA;AJ+/hCF;;AI7/hCA;EACE,YAAA;AJggiCF;;AI9/hCA;EACE,YAAA;AJigiCF;;AI//hCA;EACE,YAAA;AJkgiCF;;AIhgiCA;EACE,YAAA;AJmgiCF;;AIjgiCA;EACE,YAAA;AJogiCF;;AIlgiCA;EACE,YAAA;AJqgiCF;;AIngiCA;EACE,YAAA;AJsgiCF;;AIpgiCA;EACE,YAAA;AJugiCF;;AIrgiCA;EACE,YAAA;AJwgiCF;;AItgiCA;EACE,YAAA;AJygiCF;;AIvgiCA;EACE,YAAA;AJ0giCF;;AIxgiCA;EACE,YAAA;AJ2giCF;;AIzgiCA;EACE,YAAA;AJ4giCF;;AI1giCA;EACE,YAAA;AJ6giCF;;AI3giCA;EACE,YAAA;AJ8giCF;;AI5giCA;EACE,YAAA;AJ+giCF;;AI7giCA;EACE,YAAA;AJghiCF;;AI9giCA;EACE,YAAA;AJihiCF;;AI/giCA;EACE,YAAA;AJkhiCF;;AIhhiCA;EACE,YAAA;AJmhiCF;;AIjhiCA;EACE,YAAA;AJohiCF;;AIlhiCA;EACE,YAAA;AJqhiCF;;AInhiCA;EACE,YAAA;AJshiCF;;AIphiCA;EACE,YAAA;AJuhiCF;;AIrhiCA;EACE,YAAA;AJwhiCF;;AIthiCA;EACE,YAAA;AJyhiCF;;AIvhiCA;EACE,YAAA;AJ0hiCF;;AIxhiCA;EACE,YAAA;AJ2hiCF;;AIzhiCA;EACE,YAAA;AJ4hiCF;;AI1hiCA;EACE,YAAA;AJ6hiCF;;AI3hiCA;EACE,YAAA;AJ8hiCF;;AI5hiCA;EACE,YAAA;AJ+hiCF;;AI7hiCA;EACE,YAAA;AJgiiCF;;AI9hiCA;EACE,YAAA;AJiiiCF;;AI/hiCA;EACE,YAAA;AJkiiCF;;AIhiiCA;EACE,YAAA;AJmiiCF;;AIjiiCA;EACE,YAAA;AJoiiCF;;AIliiCA;EACE,YAAA;AJqiiCF;;AIniiCA;EACE,YAAA;AJsiiCF;;AIpiiCA;EACE,YAAA;AJuiiCF;;AIriiCA;EACE,YAAA;AJwiiCF;;AItiiCA;EACE,YAAA;AJyiiCF;;AIviiCA;EACE,YAAA;AJ0iiCF;;AIxiiCA;EACE,YAAA;AJ2iiCF;;AIziiCA;EACE,YAAA;AJ4iiCF;;AI1iiCA;EACE,YAAA;AJ6iiCF;;AI3iiCA;EACE,YAAA;AJ8iiCF;;AI5iiCA;EACE,YAAA;AJ+iiCF;;AI7iiCA;EACE,YAAA;AJgjiCF;;AI9iiCA;EACE,YAAA;AJijiCF;;AI/iiCA;EACE,YAAA;AJkjiCF;;AIhjiCA;EACE,YAAA;AJmjiCF;;AIjjiCA;EACE,YAAA;AJojiCF;;AIljiCA;EACE,YAAA;AJqjiCF;;AInjiCA;EACE,YAAA;AJsjiCF;;AIpjiCA;EACE,YAAA;AJujiCF;;AIrjiCA;EACE,YAAA;AJwjiCF;;AItjiCA;EACE,YAAA;AJyjiCF;;AIvjiCA;EACE,YAAA;AJ0jiCF;;AIxjiCA;EACE,YAAA;AJ2jiCF;;AIzjiCA;EACE,YAAA;AJ4jiCF;;AI1jiCA;EACE,YAAA;AJ6jiCF;;AI3jiCA;EACE,YAAA;AJ8jiCF;;AI5jiCA;EACE,YAAA;AJ+jiCF;;AI7jiCA;EACE,YAAA;AJgkiCF;;AI9jiCA;EACE,YAAA;AJikiCF;;AI/jiCA;EACE,YAAA;AJkkiCF;;AIhkiCA;EACE,YAAA;AJmkiCF;;AIjkiCA;EACE,YAAA;AJokiCF;;AIlkiCA;EACE,YAAA;AJqkiCF;;AInkiCA;EACE,YAAA;AJskiCF;;AIpkiCA;EACE,YAAA;AJukiCF;;AIrkiCA;EACE,YAAA;AJwkiCF;;AItkiCA;EACE,YAAA;AJykiCF;;AIvkiCA;EACE,YAAA;AJ0kiCF;;AIxkiCA;EACE,YAAA;AJ2kiCF;;AIzkiCA;EACE,YAAA;AJ4kiCF;;AI1kiCA;EACE,YAAA;AJ6kiCF;;AI3kiCA;EACE,YAAA;AJ8kiCF;;AI5kiCA;EACE,YAAA;AJ+kiCF;;AI7kiCA;EACE,YAAA;AJgliCF;;AI9kiCA;EACE,YAAA;AJiliCF;;AI/kiCA;EACE,YAAA;AJkliCF;;AIhliCA;EACE,YAAA;AJmliCF;;AIjliCA;EACE,YAAA;AJoliCF;;AIlliCA;EACE,YAAA;AJqliCF;;AInliCA;EACE,YAAA;AJsliCF;;AIpliCA;EACE,YAAA;AJuliCF;;AIrliCA;EACE,YAAA;AJwliCF;;AItliCA;EACE,YAAA;AJyliCF;;AIvliCA;EACE,YAAA;AJ0liCF;;AIxliCA;EACE,YAAA;AJ2liCF;;AIzliCA;EACE,YAAA;AJ4liCF;;AI1liCA;EACE,YAAA;AJ6liCF;;AI3liCA;EACE,YAAA;AJ8liCF;;AI5liCA;EACE,YAAA;AJ+liCF;;AI7liCA;EACE,YAAA;AJgmiCF;;AI9liCA;EACE,YAAA;AJimiCF;;AI/liCA;EACE,YAAA;AJkmiCF;;AIhmiCA;EACE,YAAA;AJmmiCF;;AIjmiCA;EACE,YAAA;AJomiCF;;AIlmiCA;EACE,YAAA;AJqmiCF;;AInmiCA;EACE,YAAA;AJsmiCF;;AIpmiCA;EACE,YAAA;AJumiCF;;AIrmiCA;EACE,YAAA;AJwmiCF;;AItmiCA;EACE,YAAA;AJymiCF;;AIvmiCA;EACE,YAAA;AJ0miCF;;AIxmiCA;EACE,YAAA;AJ2miCF;;AIzmiCA;EACE,YAAA;AJ4miCF;;AI1miCA;EACE,YAAA;AJ6miCF;;AI3miCA;EACE,YAAA;AJ8miCF;;AI5miCA;EACE,YAAA;AJ+miCF;;AI7miCA;EACE,YAAA;AJgniCF;;AI9miCA;EACE,YAAA;AJiniCF;;AI/miCA;EACE,YAAA;AJkniCF;;AIhniCA;EACE,YAAA;AJmniCF;;AIjniCA;EACE,YAAA;AJoniCF;;AIlniCA;EACE,YAAA;AJqniCF;;AInniCA;EACE,YAAA;AJsniCF;;AIpniCA;EACE,YAAA;AJuniCF;;AIrniCA;EACE,YAAA;AJwniCF;;AItniCA;EACE,YAAA;AJyniCF;;AIvniCA;EACE,YAAA;AJ0niCF;;AIxniCA;EACE,YAAA;AJ2niCF;;AIzniCA;EACE,YAAA;AJ4niCF;;AI1niCA;EACE,YAAA;AJ6niCF;;AI3niCA;EACE,YAAA;AJ8niCF;;AI5niCA;EACE,YAAA;AJ+niCF;;AI7niCA;EACE,YAAA;AJgoiCF;;AI9niCA;EACE,YAAA;AJioiCF;;AI/niCA;EACE,YAAA;AJkoiCF;;AIhoiCA;EACE,YAAA;AJmoiCF;;AIjoiCA;EACE,YAAA;AJooiCF;;AIloiCA;EACE,YAAA;AJqoiCF;;AInoiCA;EACE,YAAA;AJsoiCF;;AIpoiCA;EACE,YAAA;AJuoiCF;;AIroiCA;EACE,YAAA;AJwoiCF;;AItoiCA;EACE,YAAA;AJyoiCF;;AIvoiCA;EACE,YAAA;AJ0oiCF;;AIxoiCA;EACE,YAAA;AJ2oiCF;;AIzoiCA;EACE,YAAA;AJ4oiCF;;AI1oiCA;EACE,YAAA;AJ6oiCF;;AI3oiCA;EACE,YAAA;AJ8oiCF;;AI5oiCA;EACE,YAAA;AJ+oiCF;;AI7oiCA;EACE,YAAA;AJgpiCF;;AI9oiCA;EACE,YAAA;AJipiCF;;AI/oiCA;EACE,YAAA;AJkpiCF;;AIhpiCA;EACE,YAAA;AJmpiCF;;AIjpiCA;EACE,YAAA;AJopiCF;;AIlpiCA;EACE,YAAA;AJqpiCF;;AInpiCA;EACE,YAAA;AJspiCF;;AIppiCA;EACE,YAAA;AJupiCF;;AIrpiCA;EACE,YAAA;AJwpiCF;;AItpiCA;EACE,YAAA;AJypiCF;;AIvpiCA;EACE,YAAA;AJ0piCF;;AIxpiCA;EACE,YAAA;AJ2piCF;;AIzpiCA;EACE,YAAA;AJ4piCF;;AI1piCA;EACE,YAAA;AJ6piCF;;AI3piCA;EACE,YAAA;AJ8piCF;;AI5piCA;EACE,YAAA;AJ+piCF;;AI7piCA;EACE,YAAA;AJgqiCF;;AI9piCA;EACE,YAAA;AJiqiCF;;AI/piCA;EACE,YAAA;AJkqiCF;;AIhqiCA;EACE,YAAA;AJmqiCF;;AIjqiCA;EACE,YAAA;AJoqiCF;;AIlqiCA;EACE,YAAA;AJqqiCF;;AInqiCA;EACE,YAAA;AJsqiCF;;AIpqiCA;EACE,YAAA;AJuqiCF;;AIrqiCA;EACE,YAAA;AJwqiCF;;AItqiCA;EACE,YAAA;AJyqiCF;;AIvqiCA;EACE,YAAA;AJ0qiCF;;AIxqiCA;EACE,YAAA;AJ2qiCF;;AIzqiCA;EACE,YAAA;AJ4qiCF;;AI1qiCA;EACE,YAAA;AJ6qiCF;;AI3qiCA;EACE,YAAA;AJ8qiCF;;AI5qiCA;EACE,YAAA;AJ+qiCF;;AI7qiCA;EACE,YAAA;AJgriCF;;AI9qiCA;EACE,YAAA;AJiriCF;;AI/qiCA;EACE,YAAA;AJkriCF;;AIhriCA;EACE,YAAA;AJmriCF;;AIjriCA;EACE,YAAA;AJoriCF;;AIlriCA;EACE,YAAA;AJqriCF;;AInriCA;EACE,YAAA;AJsriCF;;AIpriCA;EACE,YAAA;AJuriCF;;AIrriCA;EACE,YAAA;AJwriCF;;AItriCA;EACE,YAAA;AJyriCF;;AIvriCA;EACE,YAAA;AJ0riCF;;AIxriCA;EACE,YAAA;AJ2riCF;;AIzriCA;EACE,YAAA;AJ4riCF;;AI1riCA;EACE,YAAA;AJ6riCF;;AI3riCA;EACE,YAAA;AJ8riCF;;AI5riCA;EACE,YAAA;AJ+riCF;;AI7riCA;EACE,YAAA;AJgsiCF;;AI9riCA;EACE,YAAA;AJisiCF;;AI/riCA;EACE,YAAA;AJksiCF;;AIhsiCA;EACE,YAAA;AJmsiCF;;AIjsiCA;EACE,YAAA;AJosiCF;;AIlsiCA;EACE,YAAA;AJqsiCF;;AInsiCA;EACE,YAAA;AJssiCF;;AIpsiCA;EACE,YAAA;AJusiCF;;AIrsiCA;EACE,YAAA;AJwsiCF;;AItsiCA;EACE,YAAA;AJysiCF;;AIvsiCA;EACE,YAAA;AJ0siCF;;AIxsiCA;EACE,YAAA;AJ2siCF;;AIzsiCA;EACE,YAAA;AJ4siCF;;AI1siCA;EACE,YAAA;AJ6siCF;;AI3siCA;EACE,YAAA;AJ8siCF;;AI5siCA;EACE,YAAA;AJ+siCF;;AI7siCA;EACE,YAAA;AJgtiCF;;AI9siCA;EACE,YAAA;AJitiCF;;AI/siCA;EACE,YAAA;AJktiCF;;AIhtiCA;EACE,YAAA;AJmtiCF;;AIjtiCA;EACE,YAAA;AJotiCF;;AIltiCA;EACE,YAAA;AJqtiCF;;AIntiCA;EACE,YAAA;AJstiCF;;AIptiCA;EACE,YAAA;AJutiCF;;AIrtiCA;EACE,YAAA;AJwtiCF;;AIttiCA;EACE,YAAA;AJytiCF;;AIvtiCA;EACE,YAAA;AJ0tiCF;;AIxtiCA;EACE,YAAA;AJ2tiCF;;AIztiCA;EACE,YAAA;AJ4tiCF;;AI1tiCA;EACE,YAAA;AJ6tiCF;;AI3tiCA;EACE,YAAA;AJ8tiCF;;AI5tiCA;EACE,YAAA;AJ+tiCF;;AI7tiCA;EACE,YAAA;AJguiCF;;AI9tiCA;EACE,YAAA;AJiuiCF;;AI/tiCA;EACE,YAAA;AJkuiCF;;AIhuiCA;EACE,YAAA;AJmuiCF;;AIjuiCA;EACE,YAAA;AJouiCF;;AIluiCA;EACE,YAAA;AJquiCF;;AInuiCA;EACE,YAAA;AJsuiCF;;AIpuiCA;EACE,YAAA;AJuuiCF;;AIruiCA;EACE,YAAA;AJwuiCF;;AItuiCA;EACE,YAAA;AJyuiCF;;AIvuiCA;EACE,YAAA;AJ0uiCF;;AIxuiCA;EACE,YAAA;AJ2uiCF;;AIzuiCA;EACE,YAAA;AJ4uiCF;;AI1uiCA;EACE,YAAA;AJ6uiCF;;AI3uiCA;EACE,YAAA;AJ8uiCF;;AI5uiCA;EACE,YAAA;AJ+uiCF;;AI7uiCA;EACE,YAAA;AJgviCF;;AI9uiCA;EACE,YAAA;AJiviCF;;AI/uiCA;EACE,YAAA;AJkviCF;;AIhviCA;EACE,YAAA;AJmviCF;;AIjviCA;EACE,YAAA;AJoviCF;;AIlviCA;EACE,YAAA;AJqviCF;;AInviCA;EACE,YAAA;AJsviCF;;AIpviCA;EACE,YAAA;AJuviCF;;AIrviCA;EACE,YAAA;AJwviCF;;AItviCA;EACE,YAAA;AJyviCF;;AIvviCA;EACE,YAAA;AJ0viCF;;AIxviCA;EACE,YAAA;AJ2viCF;;AIzviCA;EACE,YAAA;AJ4viCF;;AI1viCA;EACE,YAAA;AJ6viCF;;AI3viCA;EACE,YAAA;AJ8viCF;;AI5viCA;EACE,YAAA;AJ+viCF;;AI7viCA;EACE,YAAA;AJgwiCF;;AI9viCA;EACE,YAAA;AJiwiCF;;AI/viCA;EACE,YAAA;AJkwiCF;;AIhwiCA;EACE,YAAA;AJmwiCF;;AIjwiCA;EACE,YAAA;AJowiCF;;AIlwiCA;EACE,YAAA;AJqwiCF;;AInwiCA;EACE,YAAA;AJswiCF;;AIpwiCA;EACE,YAAA;AJuwiCF;;AIrwiCA;EACE,YAAA;AJwwiCF;;AItwiCA;EACE,YAAA;AJywiCF;;AIvwiCA;EACE,YAAA;AJ0wiCF;;AIxwiCA;EACE,YAAA;AJ2wiCF;;AIzwiCA;EACE,YAAA;AJ4wiCF;;AI1wiCA;EACE,YAAA;AJ6wiCF;;AI3wiCA;EACE,YAAA;AJ8wiCF;;AI5wiCA;EACE,YAAA;AJ+wiCF;;AI7wiCA;EACE,YAAA;AJgxiCF;;AI9wiCA;EACE,YAAA;AJixiCF;;AI/wiCA;EACE,YAAA;AJkxiCF;;AIhxiCA;EACE,YAAA;AJmxiCF;;AIjxiCA;EACE,YAAA;AJoxiCF;;AIlxiCA;EACE,YAAA;AJqxiCF;;AInxiCA;EACE,YAAA;AJsxiCF;;AIpxiCA;EACE,YAAA;AJuxiCF;;AIrxiCA;EACE,YAAA;AJwxiCF;;AItxiCA;EACE,YAAA;AJyxiCF;;AIvxiCA;EACE,YAAA;AJ0xiCF;;AIxxiCA;EACE,YAAA;AJ2xiCF;;AIzxiCA;EACE,YAAA;AJ4xiCF;;AI1xiCA;EACE,YAAA;AJ6xiCF;;AI3xiCA;EACE,YAAA;AJ8xiCF;;AI5xiCA;EACE,YAAA;AJ+xiCF;;AI7xiCA;EACE,YAAA;AJgyiCF;;AI9xiCA;EACE,YAAA;AJiyiCF;;AI/xiCA;EACE,YAAA;AJkyiCF;;AIhyiCA;EACE,YAAA;AJmyiCF;;AIjyiCA;EACE,YAAA;AJoyiCF;;AIlyiCA;EACE,YAAA;AJqyiCF;;AInyiCA;EACE,YAAA;AJsyiCF;;AIpyiCA;EACE,YAAA;AJuyiCF;;AIryiCA;EACE,YAAA;AJwyiCF;;AItyiCA;EACE,YAAA;AJyyiCF;;AIvyiCA;EACE,YAAA;AJ0yiCF;;AIxyiCA;EACE,YAAA;AJ2yiCF;;AIzyiCA;EACE,YAAA;AJ4yiCF;;AI1yiCA;EACE,YAAA;AJ6yiCF;;AI3yiCA;EACE,YAAA;AJ8yiCF;;AI5yiCA;EACE,YAAA;AJ+yiCF;;AI7yiCA;EACE,YAAA;AJgziCF;;AI9yiCA;EACE,YAAA;AJiziCF;;AI/yiCA;EACE,YAAA;AJkziCF;;AIhziCA;EACE,YAAA;AJmziCF;;AIjziCA;EACE,YAAA;AJoziCF;;AIlziCA;EACE,YAAA;AJqziCF;;AInziCA;EACE,YAAA;AJsziCF;;AIpziCA;EACE,YAAA;AJuziCF;;AIrziCA;EACE,YAAA;AJwziCF;;AItziCA;EACE,YAAA;AJyziCF;;AIvziCA;EACE,YAAA;AJ0ziCF;;AIxziCA;EACE,YAAA;AJ2ziCF;;AIzziCA;EACE,YAAA;AJ4ziCF;;AI1ziCA;EACE,YAAA;AJ6ziCF;;AI3ziCA;EACE,YAAA;AJ8ziCF;;AI5ziCA;EACE,YAAA;AJ+ziCF;;AI7ziCA;EACE,YAAA;AJg0iCF;;AI9ziCA;EACE,YAAA;AJi0iCF;;AI/ziCA;EACE,YAAA;AJk0iCF;;AIh0iCA;EACE,YAAA;AJm0iCF;;AIj0iCA;EACE,YAAA;AJo0iCF;;AIl0iCA;EACE,YAAA;AJq0iCF;;AIn0iCA;EACE,YAAA;AJs0iCF;;AIp0iCA;EACE,YAAA;AJu0iCF;;AIr0iCA;EACE,YAAA;AJw0iCF;;AIt0iCA;EACE,YAAA;AJy0iCF;;AIv0iCA;EACE,YAAA;AJ00iCF;;AIx0iCA;EACE,YAAA;AJ20iCF;;AIz0iCA;EACE,YAAA;AJ40iCF;;AI10iCA;EACE,YAAA;AJ60iCF;;AI30iCA;EACE,YAAA;AJ80iCF;;AI50iCA;EACE,YAAA;AJ+0iCF;;AI70iCA;EACE,YAAA;AJg1iCF;;AI90iCA;EACE,YAAA;AJi1iCF;;AI/0iCA;EACE,YAAA;AJk1iCF;;AIh1iCA;EACE,YAAA;AJm1iCF;;AIj1iCA;EACE,YAAA;AJo1iCF;;AIl1iCA;EACE,YAAA;AJq1iCF;;AIn1iCA;EACE,YAAA;AJs1iCF;;AIp1iCA;EACE,YAAA;AJu1iCF;;AIr1iCA;EACE,YAAA;AJw1iCF;;AIt1iCA;EACE,YAAA;AJy1iCF;;AIv1iCA;EACE,YAAA;AJ01iCF;;AIx1iCA;EACE,YAAA;AJ21iCF;;AIz1iCA;EACE,YAAA;AJ41iCF;;AI11iCA;EACE,YAAA;AJ61iCF;;AI31iCA;EACE,YAAA;AJ81iCF;;AI51iCA;EACE,YAAA;AJ+1iCF;;AI71iCA;EACE,YAAA;AJg2iCF;;AI91iCA;EACE,YAAA;AJi2iCF;;AI/1iCA;EACE,YAAA;AJk2iCF;;AIh2iCA;EACE,YAAA;AJm2iCF;;AIj2iCA;EACE,YAAA;AJo2iCF;;AIl2iCA;EACE,YAAA;AJq2iCF;;AIn2iCA;EACE,YAAA;AJs2iCF;;AIp2iCA;EACE,YAAA;AJu2iCF;;AIr2iCA;EACE,YAAA;AJw2iCF;;AIt2iCA;EACE,YAAA;AJy2iCF;;AIv2iCA;EACE,YAAA;AJ02iCF;;AIx2iCA;EACE,YAAA;AJ22iCF;;AIz2iCA;EACE,YAAA;AJ42iCF;;AI12iCA;EACE,YAAA;AJ62iCF;;AI32iCA;EACE,YAAA;AJ82iCF;;AI52iCA;EACE,YAAA;AJ+2iCF;;AI72iCA;EACE,YAAA;AJg3iCF;;AI92iCA;EACE,YAAA;AJi3iCF;;AI/2iCA;EACE,YAAA;AJk3iCF;;AIh3iCA;EACE,YAAA;AJm3iCF;;AIj3iCA;EACE,YAAA;AJo3iCF;;AIl3iCA;EACE,YAAA;AJq3iCF;;AIn3iCA;EACE,YAAA;AJs3iCF;;AIp3iCA;EACE,YAAA;AJu3iCF;;AIr3iCA;EACE,YAAA;AJw3iCF;;AIt3iCA;EACE,YAAA;AJy3iCF;;AIv3iCA;EACE,YAAA;AJ03iCF;;AIx3iCA;EACE,YAAA;AJ23iCF;;AIz3iCA;EACE,YAAA;AJ43iCF;;AI13iCA;EACE,YAAA;AJ63iCF;;AI33iCA;EACE,YAAA;AJ83iCF;;AI53iCA;EACE,YAAA;AJ+3iCF;;AI73iCA;EACE,YAAA;AJg4iCF;;AI93iCA;EACE,YAAA;AJi4iCF;;AI/3iCA;EACE,YAAA;AJk4iCF;;AIh4iCA;EACE,YAAA;AJm4iCF;;AIj4iCA;EACE,YAAA;AJo4iCF;;AIl4iCA;EACE,YAAA;AJq4iCF;;AIn4iCA;EACE,YAAA;AJs4iCF;;AIp4iCA;EACE,YAAA;AJu4iCF;;AIr4iCA;EACE,YAAA;AJw4iCF;;AIt4iCA;EACE,YAAA;AJy4iCF;;AIv4iCA;EACE,YAAA;AJ04iCF;;AIx4iCA;EACE,YAAA;AJ24iCF;;AIz4iCA;EACE,YAAA;AJ44iCF;;AI14iCA;EACE,YAAA;AJ64iCF;;AI34iCA;EACE,YAAA;AJ84iCF;;AI54iCA;EACE,YAAA;AJ+4iCF;;AI74iCA;EACE,YAAA;AJg5iCF;;AI94iCA;EACE,YAAA;AJi5iCF;;AI/4iCA;EACE,YAAA;AJk5iCF;;AIh5iCA;EACE,YAAA;AJm5iCF;;AIj5iCA;EACE,YAAA;AJo5iCF;;AIl5iCA;EACE,YAAA;AJq5iCF;;AIn5iCA;EACE,YAAA;AJs5iCF;;AIp5iCA;EACE,YAAA;AJu5iCF;;AIr5iCA;EACE,YAAA;AJw5iCF;;AIt5iCA;EACE,YAAA;AJy5iCF;;AIv5iCA;EACE,YAAA;AJ05iCF;;AIx5iCA;EACE,YAAA;AJ25iCF;;AIz5iCA;EACE,YAAA;AJ45iCF;;AI15iCA;EACE,YAAA;AJ65iCF;;AI35iCA;EACE,YAAA;AJ85iCF;;AI55iCA;EACE,YAAA;AJ+5iCF;;AI75iCA;EACE,YAAA;AJg6iCF;;AI95iCA;EACE,YAAA;AJi6iCF;;AI/5iCA;EACE,YAAA;AJk6iCF;;AIh6iCA;EACE,YAAA;AJm6iCF;;AIj6iCA;EACE,YAAA;AJo6iCF;;AIl6iCA;EACE,YAAA;AJq6iCF;;AIn6iCA;EACE,YAAA;AJs6iCF;;AIp6iCA;EACE,YAAA;AJu6iCF;;AIr6iCA;EACE,YAAA;AJw6iCF;;AIt6iCA;EACE,YAAA;AJy6iCF;;AIv6iCA;EACE,YAAA;AJ06iCF;;AIx6iCA;EACE,YAAA;AJ26iCF;;AIz6iCA;EACE,YAAA;AJ46iCF;;AI16iCA;EACE,YAAA;AJ66iCF;;AI36iCA;EACE,YAAA;AJ86iCF;;AI56iCA;EACE,YAAA;AJ+6iCF;;AI76iCA;EACE,YAAA;AJg7iCF;;AI96iCA;EACE,YAAA;AJi7iCF;;AI/6iCA;EACE,YAAA;AJk7iCF;;AIh7iCA;EACE,YAAA;AJm7iCF;;AIj7iCA;EACE,YAAA;AJo7iCF;;AIl7iCA;EACE,YAAA;AJq7iCF;;AIn7iCA;EACE,YAAA;AJs7iCF;;AIp7iCA;EACE,YAAA;AJu7iCF;;AIr7iCA;EACE,YAAA;AJw7iCF;;AIt7iCA;EACE,YAAA;AJy7iCF;;AIv7iCA;EACE,YAAA;AJ07iCF;;AIx7iCA;EACE,YAAA;AJ27iCF;;AIz7iCA;EACE,YAAA;AJ47iCF;;AI17iCA;EACE,YAAA;AJ67iCF;;AI37iCA;EACE,YAAA;AJ87iCF;;AI57iCA;EACE,YAAA;AJ+7iCF;;AI77iCA;EACE,YAAA;AJg8iCF;;AI97iCA;EACE,YAAA;AJi8iCF;;AI/7iCA;EACE,YAAA;AJk8iCF;;AIh8iCA;EACE,YAAA;AJm8iCF;;AIj8iCA;EACE,YAAA;AJo8iCF;;AIl8iCA;EACE,YAAA;AJq8iCF;;AIn8iCA;EACE,YAAA;AJs8iCF;;AIp8iCA;EACE,YAAA;AJu8iCF;;AIr8iCA;EACE,YAAA;AJw8iCF;;AIt8iCA;EACE,YAAA;AJy8iCF;;AIv8iCA;EACE,YAAA;AJ08iCF;;AIx8iCA;EACE,YAAA;AJ28iCF;;AIz8iCA;EACE,YAAA;AJ48iCF;;AI18iCA;EACE,YAAA;AJ68iCF;;AI38iCA;EACE,YAAA;AJ88iCF;;AI58iCA;EACE,YAAA;AJ+8iCF;;AI78iCA;EACE,YAAA;AJg9iCF;;AI98iCA;EACE,YAAA;AJi9iCF;;AI/8iCA;EACE,YAAA;AJk9iCF;;AIh9iCA;EACE,YAAA;AJm9iCF;;AIj9iCA;EACE,YAAA;AJo9iCF;;AIl9iCA;EACE,YAAA;AJq9iCF;;AIn9iCA;EACE,YAAA;AJs9iCF;;AIp9iCA;EACE,YAAA;AJu9iCF;;AIr9iCA;EACE,YAAA;AJw9iCF;;AIt9iCA;EACE,YAAA;AJy9iCF;;AIv9iCA;EACE,YAAA;AJ09iCF;;AIx9iCA;EACE,YAAA;AJ29iCF;;AIz9iCA;EACE,YAAA;AJ49iCF;;AI19iCA;EACE,YAAA;AJ69iCF;;AI39iCA;EACE,YAAA;AJ89iCF;;AI59iCA;EACE,YAAA;AJ+9iCF;;AI79iCA;EACE,YAAA;AJg+iCF;;AI99iCA;EACE,YAAA;AJi+iCF;;AI/9iCA;EACE,YAAA;AJk+iCF;;AIh+iCA;EACE,YAAA;AJm+iCF;;AIj+iCA;EACE,YAAA;AJo+iCF;;AIl+iCA;EACE,YAAA;AJq+iCF;;AIn+iCA;EACE,YAAA;AJs+iCF;;AIp+iCA;EACE,YAAA;AJu+iCF;;AIr+iCA;EACE,YAAA;AJw+iCF;;AIt+iCA;EACE,YAAA;AJy+iCF;;AIv+iCA;EACE,YAAA;AJ0+iCF;;AIx+iCA;EACE,YAAA;AJ2+iCF;;AIz+iCA;EACE,YAAA;AJ4+iCF;;AI1+iCA;EACE,YAAA;AJ6+iCF;;AI3+iCA;EACE,YAAA;AJ8+iCF;;AI5+iCA;EACE,YAAA;AJ++iCF;;AI7+iCA;EACE,YAAA;AJg/iCF;;AI9+iCA;EACE,YAAA;AJi/iCF;;AI/+iCA;EACE,YAAA;AJk/iCF;;AIh/iCA;EACE,YAAA;AJm/iCF;;AIj/iCA;EACE,YAAA;AJo/iCF;;AIl/iCA;EACE,YAAA;AJq/iCF;;AIn/iCA;EACE,YAAA;AJs/iCF;;AIp/iCA;EACE,YAAA;AJu/iCF;;AIr/iCA;EACE,YAAA;AJw/iCF;;AIt/iCA;EACE,YAAA;AJy/iCF;;AIv/iCA;EACE,YAAA;AJ0/iCF;;AIx/iCA;EACE,YAAA;AJ2/iCF;;AIz/iCA;EACE,YAAA;AJ4/iCF;;AI1/iCA;EACE,YAAA;AJ6/iCF;;AI3/iCA;EACE,YAAA;AJ8/iCF;;AI5/iCA;EACE,YAAA;AJ+/iCF;;AI7/iCA;EACE,YAAA;AJggjCF;;AI9/iCA;EACE,YAAA;AJigjCF;;AI//iCA;EACE,YAAA;AJkgjCF;;AIhgjCA;EACE,YAAA;AJmgjCF;;AIjgjCA;EACE,YAAA;AJogjCF;;AIlgjCA;EACE,YAAA;AJqgjCF;;AIngjCA;EACE,YAAA;AJsgjCF;;AIpgjCA;EACE,YAAA;AJugjCF;;AIrgjCA;EACE,YAAA;AJwgjCF;;AItgjCA;EACE,YAAA;AJygjCF;;AIvgjCA;EACE,YAAA;AJ0gjCF;;AIxgjCA;EACE,YAAA;AJ2gjCF;;AIzgjCA;EACE,YAAA;AJ4gjCF;;AI1gjCA;EACE,YAAA;AJ6gjCF;;AI3gjCA;EACE,YAAA;AJ8gjCF;;AI5gjCA;EACE,YAAA;AJ+gjCF;;AI7gjCA;EACE,YAAA;AJghjCF;;AI9gjCA;EACE,YAAA;AJihjCF;;AI/gjCA;EACE,YAAA;AJkhjCF;;AIhhjCA;EACE,YAAA;AJmhjCF;;AIjhjCA;EACE,YAAA;AJohjCF;;AIlhjCA;EACE,YAAA;AJqhjCF;;AInhjCA;EACE,YAAA;AJshjCF;;AIphjCA;EACE,YAAA;AJuhjCF;;AIrhjCA;EACE,YAAA;AJwhjCF;;AIthjCA;EACE,YAAA;AJyhjCF;;AIvhjCA;EACE,YAAA;AJ0hjCF;;AIxhjCA;EACE,YAAA;AJ2hjCF;;AIzhjCA;EACE,YAAA;AJ4hjCF;;AI1hjCA;EACE,YAAA;AJ6hjCF;;AI3hjCA;EACE,YAAA;AJ8hjCF;;AI5hjCA;EACE,YAAA;AJ+hjCF;;AI7hjCA;EACE,YAAA;AJgijCF;;AI9hjCA;EACE,YAAA;AJiijCF;;AI/hjCA;EACE,YAAA;AJkijCF;;AIhijCA;EACE,YAAA;AJmijCF;;AIjijCA;EACE,YAAA;AJoijCF;;AIlijCA;EACE,YAAA;AJqijCF;;AInijCA;EACE,YAAA;AJsijCF;;AIpijCA;EACE,YAAA;AJuijCF;;AIrijCA;EACE,YAAA;AJwijCF;;AItijCA;EACE,YAAA;AJyijCF;;AIvijCA;EACE,YAAA;AJ0ijCF;;AIxijCA;EACE,YAAA;AJ2ijCF;;AIzijCA;EACE,YAAA;AJ4ijCF;;AI1ijCA;EACE,YAAA;AJ6ijCF;;AI3ijCA;EACE,YAAA;AJ8ijCF;;AI5ijCA;EACE,YAAA;AJ+ijCF;;AI7ijCA;EACE,YAAA;AJgjjCF;;AI9ijCA;EACE,YAAA;AJijjCF;;AI/ijCA;EACE,YAAA;AJkjjCF;;AIhjjCA;EACE,YAAA;AJmjjCF;;AIjjjCA;EACE,YAAA;AJojjCF;;AIljjCA;EACE,YAAA;AJqjjCF;;AInjjCA;EACE,YAAA;AJsjjCF;;AIpjjCA;EACE,YAAA;AJujjCF;;AIrjjCA;EACE,YAAA;AJwjjCF;;AItjjCA;EACE,YAAA;AJyjjCF;;AIvjjCA;EACE,YAAA;AJ0jjCF;;AIxjjCA;EACE,YAAA;AJ2jjCF;;AIzjjCA;EACE,YAAA;AJ4jjCF;;AI1jjCA;EACE,YAAA;AJ6jjCF;;AI3jjCA;EACE,YAAA;AJ8jjCF;;AI5jjCA;EACE,YAAA;AJ+jjCF;;AI7jjCA;EACE,YAAA;AJgkjCF;;AI9jjCA;EACE,YAAA;AJikjCF;;AI/jjCA;EACE,YAAA;AJkkjCF;;AIhkjCA;EACE,YAAA;AJmkjCF;;AIjkjCA;EACE,YAAA;AJokjCF;;AIlkjCA;EACE,YAAA;AJqkjCF;;AInkjCA;EACE,YAAA;AJskjCF;;AIpkjCA;EACE,YAAA;AJukjCF;;AIrkjCA;EACE,YAAA;AJwkjCF;;AItkjCA;EACE,YAAA;AJykjCF;;AIvkjCA;EACE,YAAA;AJ0kjCF;;AIxkjCA;EACE,YAAA;AJ2kjCF;;AIzkjCA;EACE,YAAA;AJ4kjCF;;AI1kjCA;EACE,YAAA;AJ6kjCF;;AI3kjCA;EACE,YAAA;AJ8kjCF;;AI5kjCA;EACE,YAAA;AJ+kjCF;;AI7kjCA;EACE,YAAA;AJgljCF;;AI9kjCA;EACE,YAAA;AJiljCF;;AI/kjCA;EACE,YAAA;AJkljCF;;AIhljCA;EACE,YAAA;AJmljCF;;AIjljCA;EACE,YAAA;AJoljCF;;AIlljCA;EACE,YAAA;AJqljCF;;AInljCA;EACE,YAAA;AJsljCF;;AIpljCA;EACE,YAAA;AJuljCF;;AIrljCA;EACE,YAAA;AJwljCF;;AItljCA;EACE,YAAA;AJyljCF;;AIvljCA;EACE,YAAA;AJ0ljCF;;AIxljCA;EACE,YAAA;AJ2ljCF;;AIzljCA;EACE,YAAA;AJ4ljCF;;AI1ljCA;EACE,YAAA;AJ6ljCF;;AI3ljCA;EACE,YAAA;AJ8ljCF;;AI5ljCA;EACE,YAAA;AJ+ljCF;;AI7ljCA;EACE,YAAA;AJgmjCF;;AI9ljCA;EACE,YAAA;AJimjCF;;AI/ljCA;EACE,YAAA;AJkmjCF;;AIhmjCA;EACE,YAAA;AJmmjCF;;AIjmjCA;EACE,YAAA;AJomjCF;;AIlmjCA;EACE,YAAA;AJqmjCF;;AInmjCA;EACE,YAAA;AJsmjCF;;AIpmjCA;EACE,YAAA;AJumjCF;;AIrmjCA;EACE,YAAA;AJwmjCF;;AItmjCA;EACE,YAAA;AJymjCF;;AIvmjCA;EACE,YAAA;AJ0mjCF;;AIxmjCA;EACE,YAAA;AJ2mjCF;;AIzmjCA;EACE,YAAA;AJ4mjCF;;AI1mjCA;EACE,YAAA;AJ6mjCF;;AI3mjCA;EACE,YAAA;AJ8mjCF;;AI5mjCA;EACE,YAAA;AJ+mjCF;;AI7mjCA;EACE,YAAA;AJgnjCF;;AI9mjCA;EACE,YAAA;AJinjCF;;AI/mjCA;EACE,YAAA;AJknjCF;;AIhnjCA;EACE,YAAA;AJmnjCF;;AIjnjCA;EACE,YAAA;AJonjCF;;AIlnjCA;EACE,YAAA;AJqnjCF;;AInnjCA;EACE,YAAA;AJsnjCF;;AIpnjCA;EACE,YAAA;AJunjCF;;AIrnjCA;EACE,YAAA;AJwnjCF;;AItnjCA;EACE,YAAA;AJynjCF;;AIvnjCA;EACE,YAAA;AJ0njCF;;AIxnjCA;EACE,YAAA;AJ2njCF;;AIznjCA;EACE,YAAA;AJ4njCF;;AI1njCA;EACE,YAAA;AJ6njCF;;AI3njCA;EACE,YAAA;AJ8njCF;;AI5njCA;EACE,YAAA;AJ+njCF;;AI7njCA;EACE,YAAA;AJgojCF;;AI9njCA;EACE,YAAA;AJiojCF;;AI/njCA;EACE,YAAA;AJkojCF;;AIhojCA;EACE,YAAA;AJmojCF;;AIjojCA;EACE,YAAA;AJoojCF;;AIlojCA;EACE,YAAA;AJqojCF;;AInojCA;EACE,YAAA;AJsojCF;;AIpojCA;EACE,YAAA;AJuojCF;;AIrojCA;EACE,YAAA;AJwojCF;;AItojCA;EACE,YAAA;AJyojCF;;AIvojCA;EACE,YAAA;AJ0ojCF;;AIxojCA;EACE,YAAA;AJ2ojCF;;AIzojCA;EACE,YAAA;AJ4ojCF;;AI1ojCA;EACE,YAAA;AJ6ojCF;;AI3ojCA;EACE,YAAA;AJ8ojCF;;AI5ojCA;EACE,YAAA;AJ+ojCF;;AI7ojCA;EACE,YAAA;AJgpjCF;;AI9ojCA;EACE,YAAA;AJipjCF;;AI/ojCA;EACE,YAAA;AJkpjCF;;AIhpjCA;EACE,YAAA;AJmpjCF;;AIjpjCA;EACE,YAAA;AJopjCF;;AIlpjCA;EACE,YAAA;AJqpjCF;;AInpjCA;EACE,YAAA;AJspjCF;;AIppjCA;EACE,YAAA;AJupjCF;;AIrpjCA;EACE,YAAA;AJwpjCF;;AItpjCA;EACE,YAAA;AJypjCF;;AIvpjCA;EACE,YAAA;AJ0pjCF;;AIxpjCA;EACE,YAAA;AJ2pjCF;;AIzpjCA;EACE,YAAA;AJ4pjCF;;AI1pjCA;EACE,YAAA;AJ6pjCF;;AI3pjCA;EACE,YAAA;AJ8pjCF;;AI5pjCA;EACE,YAAA;AJ+pjCF;;AI7pjCA;EACE,YAAA;AJgqjCF;;AI9pjCA;EACE,YAAA;AJiqjCF;;AI/pjCA;EACE,YAAA;AJkqjCF;;AIhqjCA;EACE,YAAA;AJmqjCF;;AIjqjCA;EACE,YAAA;AJoqjCF;;AIlqjCA;EACE,YAAA;AJqqjCF;;AInqjCA;EACE,YAAA;AJsqjCF;;AIpqjCA;EACE,YAAA;AJuqjCF;;AIrqjCA;EACE,YAAA;AJwqjCF;;AItqjCA;EACE,YAAA;AJyqjCF;;AIvqjCA;EACE,YAAA;AJ0qjCF;;AIxqjCA;EACE,YAAA;AJ2qjCF;;AIzqjCA;EACE,YAAA;AJ4qjCF;;AI1qjCA;EACE,YAAA;AJ6qjCF;;AI3qjCA;EACE,YAAA;AJ8qjCF;;AI5qjCA;EACE,YAAA;AJ+qjCF;;AI7qjCA;EACE,YAAA;AJgrjCF;;AI9qjCA;EACE,YAAA;AJirjCF;;AI/qjCA;EACE,YAAA;AJkrjCF;;AIhrjCA;EACE,YAAA;AJmrjCF;;AIjrjCA;EACE,YAAA;AJorjCF;;AIlrjCA;EACE,YAAA;AJqrjCF;;AInrjCA;EACE,YAAA;AJsrjCF;;AIprjCA;EACE,YAAA;AJurjCF;;AIrrjCA;EACE,YAAA;AJwrjCF;;AItrjCA;EACE,YAAA;AJyrjCF;;AIvrjCA;EACE,YAAA;AJ0rjCF;;AIxrjCA;EACE,YAAA;AJ2rjCF;;AIzrjCA;EACE,YAAA;AJ4rjCF;;AI1rjCA;EACE,YAAA;AJ6rjCF;;AI3rjCA;EACE,YAAA;AJ8rjCF;;AI5rjCA;EACE,YAAA;AJ+rjCF;;AI7rjCA;EACE,YAAA;AJgsjCF;;AI9rjCA;EACE,YAAA;AJisjCF;;AI/rjCA;EACE,YAAA;AJksjCF;;AIhsjCA;EACE,YAAA;AJmsjCF;;AIjsjCA;EACE,YAAA;AJosjCF;;AIlsjCA;EACE,YAAA;AJqsjCF;;AInsjCA;EACE,YAAA;AJssjCF;;AIpsjCA;EACE,YAAA;AJusjCF;;AIrsjCA;EACE,YAAA;AJwsjCF;;AItsjCA;EACE,YAAA;AJysjCF;;AIvsjCA;EACE,YAAA;AJ0sjCF;;AIxsjCA;EACE,YAAA;AJ2sjCF;;AIzsjCA;EACE,YAAA;AJ4sjCF;;AI1sjCA;EACE,YAAA;AJ6sjCF;;AI3sjCA;EACE,YAAA;AJ8sjCF;;AI5sjCA;EACE,YAAA;AJ+sjCF;;AI7sjCA;EACE,YAAA;AJgtjCF;;AI9sjCA;EACE,YAAA;AJitjCF;;AI/sjCA;EACE,YAAA;AJktjCF;;AIhtjCA;EACE,YAAA;AJmtjCF;;AIjtjCA;EACE,YAAA;AJotjCF;;AIltjCA;EACE,YAAA;AJqtjCF;;AIntjCA;EACE,YAAA;AJstjCF;;AIptjCA;EACE,YAAA;AJutjCF;;AIrtjCA;EACE,YAAA;AJwtjCF;;AIttjCA;EACE,YAAA;AJytjCF;;AIvtjCA;EACE,YAAA;AJ0tjCF;;AIxtjCA;EACE,YAAA;AJ2tjCF;;AIztjCA;EACE,YAAA;AJ4tjCF;;AI1tjCA;EACE,YAAA;AJ6tjCF;;AI3tjCA;EACE,YAAA;AJ8tjCF;;AI5tjCA;EACE,YAAA;AJ+tjCF;;AI7tjCA;EACE,YAAA;AJgujCF;;AI9tjCA;EACE,YAAA;AJiujCF;;AI/tjCA;EACE,YAAA;AJkujCF;;AIhujCA;EACE,YAAA;AJmujCF;;AIjujCA;EACE,YAAA;AJoujCF;;AIlujCA;EACE,YAAA;AJqujCF;;AInujCA;EACE,YAAA;AJsujCF;;AIpujCA;EACE,YAAA;AJuujCF;;AIrujCA;EACE,YAAA;AJwujCF;;AItujCA;EACE,YAAA;AJyujCF;;AIvujCA;EACE,YAAA;AJ0ujCF;;AIxujCA;EACE,YAAA;AJ2ujCF;;AIzujCA;EACE,YAAA;AJ4ujCF;;AI1ujCA;EACE,YAAA;AJ6ujCF;;AI3ujCA;EACE,YAAA;AJ8ujCF;;AI5ujCA;EACE,YAAA;AJ+ujCF;;AI7ujCA;EACE,YAAA;AJgvjCF;;AI9ujCA;EACE,YAAA;AJivjCF;;AI/ujCA;EACE,YAAA;AJkvjCF;;AIhvjCA;EACE,YAAA;AJmvjCF;;AIjvjCA;EACE,YAAA;AJovjCF;;AIlvjCA;EACE,YAAA;AJqvjCF;;AInvjCA;EACE,YAAA;AJsvjCF;;AIpvjCA;EACE,YAAA;AJuvjCF;;AIrvjCA;EACE,YAAA;AJwvjCF;;AItvjCA;EACE,YAAA;AJyvjCF;;AIvvjCA;EACE,YAAA;AJ0vjCF;;AIxvjCA;EACE,YAAA;AJ2vjCF;;AIzvjCA;EACE,YAAA;AJ4vjCF;;AI1vjCA;EACE,YAAA;AJ6vjCF;;AI3vjCA;EACE,YAAA;AJ8vjCF;;AI5vjCA;EACE,YAAA;AJ+vjCF;;AI7vjCA;EACE,YAAA;AJgwjCF;;AI9vjCA;EACE,YAAA;AJiwjCF;;AI/vjCA;EACE,YAAA;AJkwjCF;;AIhwjCA;EACE,YAAA;AJmwjCF;;AIjwjCA;EACE,YAAA;AJowjCF;;AIlwjCA;EACE,YAAA;AJqwjCF;;AInwjCA;EACE,YAAA;AJswjCF;;AIpwjCA;EACE,YAAA;AJuwjCF;;AIrwjCA;EACE,YAAA;AJwwjCF;;AItwjCA;EACE,YAAA;AJywjCF;;AIvwjCA;EACE,YAAA;AJ0wjCF;;AIxwjCA;EACE,YAAA;AJ2wjCF;;AIzwjCA;EACE,YAAA;AJ4wjCF;;AI1wjCA;EACE,YAAA;AJ6wjCF;;AI3wjCA;EACE,YAAA;AJ8wjCF;;AI5wjCA;EACE,YAAA;AJ+wjCF;;AI7wjCA;EACE,YAAA;AJgxjCF;;AI9wjCA;EACE,YAAA;AJixjCF;;AI/wjCA;EACE,YAAA;AJkxjCF;;AIhxjCA;EACE,YAAA;AJmxjCF;;AIjxjCA;EACE,YAAA;AJoxjCF;;AIlxjCA;EACE,YAAA;AJqxjCF;;AInxjCA;EACE,YAAA;AJsxjCF;;AIpxjCA;EACE,YAAA;AJuxjCF;;AIrxjCA;EACE,YAAA;AJwxjCF;;AItxjCA;EACE,YAAA;AJyxjCF;;AIvxjCA;EACE,YAAA;AJ0xjCF;;AIxxjCA;EACE,YAAA;AJ2xjCF;;AIzxjCA;EACE,YAAA;AJ4xjCF;;AI1xjCA;EACE,YAAA;AJ6xjCF;;AI3xjCA;EACE,YAAA;AJ8xjCF;;AI5xjCA;EACE,YAAA;AJ+xjCF;;AI7xjCA;EACE,YAAA;AJgyjCF;;AI9xjCA;EACE,YAAA;AJiyjCF;;AI/xjCA;EACE,YAAA;AJkyjCF;;AIhyjCA;EACE,YAAA;AJmyjCF;;AIjyjCA;EACE,YAAA;AJoyjCF;;AIlyjCA;EACE,YAAA;AJqyjCF;;AInyjCA;EACE,YAAA;AJsyjCF;;AIpyjCA;EACE,YAAA;AJuyjCF;;AIryjCA;EACE,YAAA;AJwyjCF;;AItyjCA;EACE,YAAA;AJyyjCF;;AIvyjCA;EACE,YAAA;AJ0yjCF;;AIxyjCA;EACE,YAAA;AJ2yjCF;;AIzyjCA;EACE,YAAA;AJ4yjCF;;AI1yjCA;EACE,YAAA;AJ6yjCF;;AI3yjCA;EACE,YAAA;AJ8yjCF;;AI5yjCA;EACE,YAAA;AJ+yjCF;;AI7yjCA;EACE,YAAA;AJgzjCF;;AI9yjCA;EACE,YAAA;AJizjCF;;AI/yjCA;EACE,YAAA;AJkzjCF;;AIhzjCA;EACE,YAAA;AJmzjCF;;AIjzjCA;EACE,YAAA;AJozjCF;;AIlzjCA;EACE,YAAA;AJqzjCF;;AInzjCA;EACE,YAAA;AJszjCF;;AIpzjCA;EACE,YAAA;AJuzjCF;;AIrzjCA;EACE,YAAA;AJwzjCF;;AItzjCA;EACE,YAAA;AJyzjCF;;AIvzjCA;EACE,YAAA;AJ0zjCF;;AIxzjCA;EACE,YAAA;AJ2zjCF;;AIzzjCA;EACE,YAAA;AJ4zjCF;;AI1zjCA;EACE,YAAA;AJ6zjCF;;AI3zjCA;EACE,YAAA;AJ8zjCF;;AI5zjCA;EACE,YAAA;AJ+zjCF;;AI7zjCA;EACE,YAAA;AJg0jCF;;AI9zjCA;EACE,YAAA;AJi0jCF;;AI/zjCA;EACE,YAAA;AJk0jCF;;AIh0jCA;EACE,YAAA;AJm0jCF;;AIj0jCA;EACE,YAAA;AJo0jCF;;AIl0jCA;EACE,YAAA;AJq0jCF;;AIn0jCA;EACE,YAAA;AJs0jCF;;AIp0jCA;EACE,YAAA;AJu0jCF;;AIr0jCA;EACE,YAAA;AJw0jCF;;AIt0jCA;EACE,YAAA;AJy0jCF;;AIv0jCA;EACE,YAAA;AJ00jCF;;AIx0jCA;EACE,YAAA;AJ20jCF;;AIz0jCA;EACE,YAAA;AJ40jCF;;AI10jCA;EACE,YAAA;AJ60jCF;;AI30jCA;EACE,YAAA;AJ80jCF;;AI50jCA;EACE,YAAA;AJ+0jCF;;AI70jCA;EACE,YAAA;AJg1jCF;;AI90jCA;EACE,YAAA;AJi1jCF;;AI/0jCA;EACE,YAAA;AJk1jCF;;AIh1jCA;EACE,YAAA;AJm1jCF;;AIj1jCA;EACE,YAAA;AJo1jCF;;AIl1jCA;EACE,YAAA;AJq1jCF;;AIn1jCA;EACE,YAAA;AJs1jCF;;AIp1jCA;EACE,YAAA;AJu1jCF;;AIr1jCA;EACE,YAAA;AJw1jCF;;AIt1jCA;EACE,YAAA;AJy1jCF;;AIv1jCA;EACE,YAAA;AJ01jCF;;AIx1jCA;EACE,YAAA;AJ21jCF;;AIz1jCA;EACE,YAAA;AJ41jCF;;AI11jCA;EACE,YAAA;AJ61jCF;;AI31jCA;EACE,YAAA;AJ81jCF;;AI51jCA;EACE,YAAA;AJ+1jCF;;AI71jCA;EACE,YAAA;AJg2jCF;;AI91jCA;EACE,YAAA;AJi2jCF;;AI/1jCA;EACE,YAAA;AJk2jCF;;AIh2jCA;EACE,YAAA;AJm2jCF;;AIj2jCA;EACE,YAAA;AJo2jCF;;AIl2jCA;EACE,YAAA;AJq2jCF;;AIn2jCA;EACE,YAAA;AJs2jCF;;AIp2jCA;EACE,YAAA;AJu2jCF;;AIr2jCA;EACE,YAAA;AJw2jCF;;AIt2jCA;EACE,YAAA;AJy2jCF;;AIv2jCA;EACE,YAAA;AJ02jCF;;AIx2jCA;EACE,YAAA;AJ22jCF;;AIz2jCA;EACE,YAAA;AJ42jCF;;AI12jCA;EACE,YAAA;AJ62jCF;;AI32jCA;EACE,YAAA;AJ82jCF;;AI52jCA;EACE,YAAA;AJ+2jCF;;AI72jCA;EACE,YAAA;AJg3jCF;;AI92jCA;EACE,YAAA;AJi3jCF;;AI/2jCA;EACE,YAAA;AJk3jCF;;AIh3jCA;EACE,YAAA;AJm3jCF;;AIj3jCA;EACE,YAAA;AJo3jCF;;AIl3jCA;EACE,YAAA;AJq3jCF;;AIn3jCA;EACE,YAAA;AJs3jCF;;AIp3jCA;EACE,YAAA;AJu3jCF;;AIr3jCA;EACE,YAAA;AJw3jCF;;AIt3jCA;EACE,YAAA;AJy3jCF;;AIv3jCA;EACE,YAAA;AJ03jCF;;AIx3jCA;EACE,YAAA;AJ23jCF;;AIz3jCA;EACE,YAAA;AJ43jCF;;AI13jCA;EACE,YAAA;AJ63jCF;;AI33jCA;EACE,YAAA;AJ83jCF;;AI53jCA;EACE,YAAA;AJ+3jCF;;AI73jCA;EACE,YAAA;AJg4jCF;;AI93jCA;EACE,YAAA;AJi4jCF;;AI/3jCA;EACE,YAAA;AJk4jCF;;AIh4jCA;EACE,YAAA;AJm4jCF;;AIj4jCA;EACE,YAAA;AJo4jCF;;AIl4jCA;EACE,YAAA;AJq4jCF;;AIn4jCA;EACE,YAAA;AJs4jCF;;AIp4jCA;EACE,YAAA;AJu4jCF;;AIr4jCA;EACE,YAAA;AJw4jCF;;AIt4jCA;EACE,YAAA;AJy4jCF;;AIv4jCA;EACE,YAAA;AJ04jCF;;AIx4jCA;EACE,YAAA;AJ24jCF;;AIz4jCA;EACE,YAAA;AJ44jCF;;AI14jCA;EACE,YAAA;AJ64jCF;;AI34jCA;EACE,YAAA;AJ84jCF;;AI54jCA;EACE,YAAA;AJ+4jCF;;AI74jCA;EACE,YAAA;AJg5jCF;;AI94jCA;EACE,YAAA;AJi5jCF;;AI/4jCA;EACE,YAAA;AJk5jCF;;AIh5jCA;EACE,YAAA;AJm5jCF;;AIj5jCA;EACE,YAAA;AJo5jCF;;AIl5jCA;EACE,YAAA;AJq5jCF;;AIn5jCA;EACE,YAAA;AJs5jCF;;AIp5jCA;EACE,YAAA;AJu5jCF;;AIr5jCA;EACE,YAAA;AJw5jCF;;AIt5jCA;EACE,YAAA;AJy5jCF;;AIv5jCA;EACE,YAAA;AJ05jCF;;AIx5jCA;EACE,YAAA;AJ25jCF;;AIz5jCA;EACE,YAAA;AJ45jCF;;AI15jCA;EACE,YAAA;AJ65jCF;;AI35jCA;EACE,YAAA;AJ85jCF;;AI55jCA;EACE,YAAA;AJ+5jCF;;AI75jCA;EACE,YAAA;AJg6jCF;;AI95jCA;EACE,YAAA;AJi6jCF;;AI/5jCA;EACE,YAAA;AJk6jCF;;AIh6jCA;EACE,YAAA;AJm6jCF;;AIj6jCA;EACE,YAAA;AJo6jCF;;AIl6jCA;EACE,YAAA;AJq6jCF;;AIn6jCA;EACE,YAAA;AJs6jCF;;AIp6jCA;EACE,YAAA;AJu6jCF;;AIr6jCA;EACE,YAAA;AJw6jCF;;AIt6jCA;EACE,YAAA;AJy6jCF;;AIv6jCA;EACE,YAAA;AJ06jCF;;AIx6jCA;EACE,YAAA;AJ26jCF;;AIz6jCA;EACE,YAAA;AJ46jCF;;AI16jCA;EACE,YAAA;AJ66jCF;;AI36jCA;EACE,YAAA;AJ86jCF;;AI56jCA;EACE,YAAA;AJ+6jCF;;AI76jCA;EACE,YAAA;AJg7jCF;;AI96jCA;EACE,YAAA;AJi7jCF;;AI/6jCA;EACE,YAAA;AJk7jCF;;AIh7jCA;EACE,YAAA;AJm7jCF;;AIj7jCA;EACE,YAAA;AJo7jCF;;AIl7jCA;EACE,YAAA;AJq7jCF;;AIn7jCA;EACE,YAAA;AJs7jCF;;AIp7jCA;EACE,YAAA;AJu7jCF;;AIr7jCA;EACE,YAAA;AJw7jCF;;AIt7jCA;EACE,YAAA;AJy7jCF;;AIv7jCA;EACE,YAAA;AJ07jCF;;AIx7jCA;EACE,YAAA;AJ27jCF;;AIz7jCA;EACE,YAAA;AJ47jCF;;AI17jCA;EACE,YAAA;AJ67jCF;;AI37jCA;EACE,YAAA;AJ87jCF;;AI57jCA;EACE,YAAA;AJ+7jCF;;AI77jCA;EACE,YAAA;AJg8jCF;;AI97jCA;EACE,YAAA;AJi8jCF;;AI/7jCA;EACE,YAAA;AJk8jCF;;AIh8jCA;EACE,YAAA;AJm8jCF;;AIj8jCA;EACE,YAAA;AJo8jCF;;AIl8jCA;EACE,YAAA;AJq8jCF;;AIn8jCA;EACE,YAAA;AJs8jCF;;AIp8jCA;EACE,YAAA;AJu8jCF;;AIr8jCA;EACE,YAAA;AJw8jCF;;AIt8jCA;EACE,YAAA;AJy8jCF;;AIv8jCA;EACE,YAAA;AJ08jCF;;AIx8jCA;EACE,YAAA;AJ28jCF;;AIz8jCA;EACE,YAAA;AJ48jCF;;AI18jCA;EACE,YAAA;AJ68jCF;;AI38jCA;EACE,YAAA;AJ88jCF;;AI58jCA;EACE,YAAA;AJ+8jCF;;AI78jCA;EACE,YAAA;AJg9jCF;;AI98jCA;EACE,YAAA;AJi9jCF;;AI/8jCA;EACE,YAAA;AJk9jCF;;AIh9jCA;EACE,YAAA;AJm9jCF;;AIj9jCA;EACE,YAAA;AJo9jCF;;AIl9jCA;EACE,YAAA;AJq9jCF;;AIn9jCA;EACE,YAAA;AJs9jCF;;AIp9jCA;EACE,YAAA;AJu9jCF;;AIr9jCA;EACE,YAAA;AJw9jCF;;AIt9jCA;EACE,YAAA;AJy9jCF;;AIv9jCA;EACE,YAAA;AJ09jCF;;AIx9jCA;EACE,YAAA;AJ29jCF;;AIz9jCA;EACE,YAAA;AJ49jCF;;AI19jCA;EACE,YAAA;AJ69jCF;;AI39jCA;EACE,YAAA;AJ89jCF;;AI59jCA;EACE,YAAA;AJ+9jCF;;AI79jCA;EACE,YAAA;AJg+jCF;;AI99jCA;EACE,YAAA;AJi+jCF;;AI/9jCA;EACE,YAAA;AJk+jCF;;AIh+jCA;EACE,YAAA;AJm+jCF;;AIj+jCA;EACE,YAAA;AJo+jCF;;AIl+jCA;EACE,YAAA;AJq+jCF;;AIn+jCA;EACE,YAAA;AJs+jCF;;AIp+jCA;EACE,YAAA;AJu+jCF;;AIr+jCA;EACE,YAAA;AJw+jCF;;AIt+jCA;EACE,YAAA;AJy+jCF;;AIv+jCA;EACE,YAAA;AJ0+jCF;;AIx+jCA;EACE,YAAA;AJ2+jCF;;AIz+jCA;EACE,YAAA;AJ4+jCF;;AI1+jCA;EACE,YAAA;AJ6+jCF;;AI3+jCA;EACE,YAAA;AJ8+jCF;;AI5+jCA;EACE,YAAA;AJ++jCF;;AI7+jCA;EACE,YAAA;AJg/jCF;;AI9+jCA;EACE,YAAA;AJi/jCF;;AI/+jCA;EACE,YAAA;AJk/jCF;;AIh/jCA;EACE,YAAA;AJm/jCF;;AIj/jCA;EACE,YAAA;AJo/jCF;;AIl/jCA;EACE,YAAA;AJq/jCF;;AIn/jCA;EACE,YAAA;AJs/jCF;;AIp/jCA;EACE,YAAA;AJu/jCF;;AIr/jCA;EACE,YAAA;AJw/jCF;;AIt/jCA;EACE,YAAA;AJy/jCF;;AIv/jCA;EACE,YAAA;AJ0/jCF;;AIx/jCA;EACE,YAAA;AJ2/jCF;;AIz/jCA;EACE,SAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AJ4/jCF;;AI1/jCA;EACE,UAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AJ6/jCF;;AI5/jCA;EACE,kCAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6CAAA;EACA,iTAAA;AJ+/jCF;AI7/jCA;EACE,kCAAA;AJ+/jCF;;AI9/jCA;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6CAAA;EACA,iTAAA;AJigkCF;AI//jCA;EACE,gCAAA;EACA,gBAAA;AJigkCF;;AIhgkCA;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6CAAA;EACA,iTAAA;AJmgkCF;AIjgkCA;;EAEE,gCAAA;EACA,gBAAA;AJmgkCF;;AIjgkCA;EACE,YAAA;AJogkCF;;AIlgkCA;EACE,kCAAA;EACA,gBAAA;AJqgkCF;;AIngkCA;EACE,gCAAA;EACA,gBAAA;AJsgkCF;;AIpgkCA;EACE,YAAA;AJugkCF;;AIrgkCA;EACE,YAAA;AJwgkCF;;AItgkCA;EACE,YAAA;AJygkCF;;AIvgkCA;EACE,YAAA;AJ0gkCF;;AIxgkCA;EACE,gCAAA;EACA,gBAAA;AJ2gkCF;;AIzgkCA;EACE,YAAA;AJ4gkCF;;AI1gkCA;EACE,gCAAA;EACA,gBAAA;AJ6gkCF;;AI3gkCA;EACE,YAAA;AJ8gkCF;;AI5gkCA;EACE,gCAAA;EACA,gBAAA;AJ+gkCF;;AI7gkCA;EACE,YAAA;AJghkCF;;AI9gkCA;EACE,gCAAA;EACA,gBAAA;AJihkCF;;AI/gkCA;EACE,YAAA;AJkhkCF;;AIhhkCA;EACE,gCAAA;EACA,gBAAA;AJmhkCF;;AIjhkCA;EACE,YAAA;AJohkCF;;AIlhkCA;EACE,gCAAA;EACA,gBAAA;AJqhkCF;;AInhkCA;EACE,YAAA;AJshkCF;;AIphkCA;EACE,YAAA;AJuhkCF;;AIrhkCA;EACE,YAAA;AJwhkCF;;AIthkCA;EACE,YAAA;AJyhkCF;;AIvhkCA;EACE,gCAAA;EACA,gBAAA;AJ0hkCF;;AIxhkCA;EACE,YAAA;AJ2hkCF;;AIzhkCA;EACE,YAAA;AJ4hkCF;;AI1hkCA;EACE,gCAAA;EACA,gBAAA;AJ6hkCF;;AI3hkCA;EACE,YAAA;AJ8hkCF;;AI5hkCA;EACE,gCAAA;EACA,gBAAA;AJ+hkCF;;AI7hkCA;EACE,YAAA;AJgikCF;;AI9hkCA;EACE,gCAAA;EACA,gBAAA;AJiikCF;;AI/hkCA;EACE,YAAA;AJkikCF;;AIhikCA;EACE,YAAA;AJmikCF;;AIjikCA;EACE,YAAA;AJoikCF;;AIlikCA;EACE,gCAAA;EACA,gBAAA;AJqikCF;;AInikCA;EACE,YAAA;AJsikCF;;AIpikCA;EACE,gCAAA;EACA,gBAAA;AJuikCF;;AIrikCA;EACE,YAAA;AJwikCF;;AItikCA;EACE,gCAAA;EACA,gBAAA;AJyikCF;;AIvikCA;EACE,YAAA;AJ0ikCF;;AIxikCA;EACE,YAAA;AJ2ikCF;;AIzikCA;EACE,gCAAA;EACA,gBAAA;AJ4ikCF;;AI1ikCA;EACE,YAAA;AJ6ikCF;;AI3ikCA;EACE,gCAAA;EACA,gBAAA;AJ8ikCF;;AI5ikCA;EACE,YAAA;AJ+ikCF;;AI7ikCA;EACE,YAAA;AJgjkCF;;AI9ikCA;EACE,gCAAA;EACA,gBAAA;AJijkCF;;AI/ikCA;EACE,gCAAA;EACA,gBAAA;AJkjkCF;;AIhjkCA;EACE,YAAA;AJmjkCF;;AIjjkCA;EACE,YAAA;AJojkCF;;AIljkCA;EACE,YAAA;AJqjkCF;;AInjkCA;EACE,YAAA;AJsjkCF;;AIpjkCA;EACE,gCAAA;EACA,gBAAA;AJujkCF;;AIrjkCA;EACE,YAAA;AJwjkCF;;AItjkCA;EACE,gCAAA;EACA,gBAAA;AJyjkCF;;AIvjkCA;EACE,YAAA;AJ0jkCF;;AIxjkCA;EACE,kCAAA;EACA,gBAAA;AJ2jkCF;;AIzjkCA;EACE,kCAAA;EACA,gBAAA;AJ4jkCF;;AI1jkCA;EACE,YAAA;AJ6jkCF;;AI3jkCA;EACE,gCAAA;EACA,gBAAA;AJ8jkCF;;AI5jkCA;EACE,YAAA;AJ+jkCF;;AI7jkCA;EACE,gCAAA;EACA,gBAAA;AJgkkCF;;AI9jkCA;EACE,YAAA;AJikkCF;;AI/jkCA;EACE,gCAAA;EACA,gBAAA;AJkkkCF;;AIhkkCA;EACE,YAAA;AJmkkCF;;AIjkkCA;EACE,YAAA;AJokkCF;;AIlkkCA;EACE,kCAAA;EACA,gBAAA;AJqkkCF;;AInkkCA;EACE,YAAA;AJskkCF;;AIpkkCA;EACE,YAAA;AJukkCF;;AIrkkCA;EACE,YAAA;AJwkkCF;;AItkkCA;EACE,YAAA;AJykkCF;;AIvkkCA;EACE,kCAAA;EACA,gBAAA;AJ0kkCF;;AIxkkCA;EACE,gCAAA;EACA,gBAAA;AJ2kkCF;;AIzkkCA;EACE,YAAA;AJ4kkCF;;AI1kkCA;EACE,gCAAA;EACA,gBAAA;AJ6kkCF;;AI3kkCA;EACE,YAAA;AJ8kkCF;;AI5kkCA;EACE,gCAAA;EACA,gBAAA;AJ+kkCF;;AI7kkCA;EACE,YAAA;AJglkCF;;AI9kkCA;EACE,kCAAA;EACA,gBAAA;AJilkCF;;AI/kkCA;EACE,kCAAA;EACA,gBAAA;AJklkCF;;AIhlkCA;EACE,YAAA;AJmlkCF;;AIjlkCA;EACE,kCAAA;EACA,gBAAA;AJolkCF;;AIllkCA;EACE,YAAA;AJqlkCF;;AInlkCA;EACE,kCAAA;EACA,gBAAA;AJslkCF;;AIplkCA;EACE,gCAAA;EACA,gBAAA;AJulkCF;;AIrlkCA;EACE,YAAA;AJwlkCF;;AItlkCA;EACE,gCAAA;EACA,gBAAA;AJylkCF;;AIvlkCA;EACE,YAAA;AJ0lkCF;;AIxlkCA;EACE,gCAAA;EACA,gBAAA;AJ2lkCF;;AIzlkCA;EACE,YAAA;AJ4lkCF;;AI1lkCA;EACE,gCAAA;EACA,gBAAA;AJ6lkCF;;AI3lkCA;EACE,YAAA;AJ8lkCF;;AI5lkCA;EACE,gCAAA;EACA,gBAAA;AJ+lkCF;;AI7lkCA;EACE,YAAA;AJgmkCF;;AI9lkCA;EACE,gCAAA;EACA,gBAAA;AJimkCF;;AI/lkCA;EACE,YAAA;AJkmkCF;;AIhmkCA;EACE,YAAA;AJmmkCF;;AIjmkCA;EACE,YAAA;AJomkCF;;AIlmkCA;EACE,YAAA;AJqmkCF;;AInmkCA;EACE,YAAA;AJsmkCF;;AIpmkCA;EACE,gCAAA;EACA,gBAAA;AJumkCF;;AIrmkCA;EACE,YAAA;AJwmkCF;;AItmkCA;EACE,gCAAA;EACA,gBAAA;AJymkCF;;AIvmkCA;EACE,YAAA;AJ0mkCF;;AIxmkCA;EACE,YAAA;AJ2mkCF;;AIzmkCA;EACE,YAAA;AJ4mkCF;;AI1mkCA;EACE,kCAAA;EACA,gBAAA;AJ6mkCF;;AI3mkCA;EACE,kCAAA;EACA,gBAAA;AJ8mkCF;;AI5mkCA;EACE,kCAAA;EACA,gBAAA;AJ+mkCF;;AI7mkCA;EACE,kCAAA;EACA,gBAAA;AJgnkCF;;AI9mkCA;EACE,YAAA;AJinkCF;;AI/mkCA;EACE,gCAAA;EACA,gBAAA;AJknkCF;;AIhnkCA;EACE,YAAA;AJmnkCF;;AIjnkCA;EACE,YAAA;AJonkCF;;AIlnkCA;EACE,YAAA;AJqnkCF;;AInnkCA;EACE,YAAA;AJsnkCF;;AIpnkCA;EACE,kCAAA;EACA,gBAAA;AJunkCF;;AIrnkCA;EACE,YAAA;AJwnkCF;;AItnkCA;EACE,YAAA;AJynkCF;;AIvnkCA;EACE,YAAA;AJ0nkCF;;AIxnkCA;EACE,YAAA;AJ2nkCF;;AIznkCA;EACE,YAAA;AJ4nkCF;;AI1nkCA;EACE,gCAAA;EACA,gBAAA;AJ6nkCF;;AI3nkCA;EACE,YAAA;AJ8nkCF;;AI5nkCA;EACE,gCAAA;EACA,gBAAA;AJ+nkCF;;AI7nkCA;EACE,YAAA;AJgokCF;;AI9nkCA;EACE,YAAA;AJiokCF;;AI/nkCA;EACE,gCAAA;EACA,gBAAA;AJkokCF;;AIhokCA;EACE,gCAAA;EACA,gBAAA;AJmokCF;;AIjokCA;EACE,YAAA;AJookCF;;AIlokCA;EACE,gCAAA;EACA,gBAAA;AJqokCF;;AInokCA;EACE,YAAA;AJsokCF;;AIpokCA;EACE,YAAA;AJuokCF;;AIrokCA;EACE,YAAA;AJwokCF;;AItokCA;EACE,YAAA;AJyokCF;;AIvokCA;EACE,gCAAA;EACA,gBAAA;AJ0okCF;;AIxokCA;EACE,YAAA;AJ2okCF;;AIzokCA;EACE,YAAA;AJ4okCF;;AI1okCA;EACE,gCAAA;EACA,gBAAA;AJ6okCF;;AI3okCA;EACE,YAAA;AJ8okCF;;AI5okCA;EACE,gCAAA;EACA,gBAAA;AJ+okCF;;AI7okCA;EACE,YAAA;AJgpkCF;;AI9okCA;EACE,gCAAA;EACA,gBAAA;AJipkCF;;AI/okCA;EACE,YAAA;AJkpkCF;;AIhpkCA;EACE,YAAA;AJmpkCF;;AIjpkCA;EACE,YAAA;AJopkCF;;AIlpkCA;EACE,YAAA;AJqpkCF;;AInpkCA;EACE,gCAAA;EACA,gBAAA;AJspkCF;;AIppkCA;EACE,YAAA;AJupkCF;;AIrpkCA;EACE,YAAA;AJwpkCF;;AItpkCA;EACE,kCAAA;EACA,gBAAA;AJypkCF;;AIvpkCA;EACE,gCAAA;EACA,gBAAA;AJ0pkCF;;AIxpkCA;EACE,YAAA;AJ2pkCF;;AIzpkCA;EACE,gCAAA;EACA,gBAAA;AJ4pkCF;;AI1pkCA;EACE,YAAA;AJ6pkCF;;AI3pkCA;EACE,gCAAA;EACA,gBAAA;AJ8pkCF;;AI5pkCA;EACE,YAAA;AJ+pkCF;;AI7pkCA;EACE,gCAAA;EACA,gBAAA;AJgqkCF;;AI9pkCA;EACE,YAAA;AJiqkCF;;AI/pkCA;EACE,gCAAA;EACA,gBAAA;AJkqkCF;;AIhqkCA;EACE,YAAA;AJmqkCF;;AIjqkCA;EACE,gCAAA;EACA,gBAAA;AJoqkCF;;AIlqkCA;EACE,YAAA;AJqqkCF;;AInqkCA;EACE,gCAAA;EACA,gBAAA;AJsqkCF;;AIpqkCA;EACE,YAAA;AJuqkCF;;AIrqkCA;EACE,YAAA;AJwqkCF;;AItqkCA;EACE,gCAAA;EACA,gBAAA;AJyqkCF;;AIvqkCA;EACE,YAAA;AJ0qkCF;;AIxqkCA;EACE,gCAAA;EACA,gBAAA;AJ2qkCF;;AIzqkCA;EACE,YAAA;AJ4qkCF;;AI1qkCA;EACE,gCAAA;EACA,gBAAA;AJ6qkCF;;AI3qkCA;EACE,YAAA;AJ8qkCF;;AI5qkCA;EACE,YAAA;AJ+qkCF;;AI7qkCA;EACE,YAAA;AJgrkCF;;AI9qkCA;EACE,YAAA;AJirkCF;;AI/qkCA;EACE,gCAAA;EACA,gBAAA;AJkrkCF;;AIhrkCA;EACE,YAAA;AJmrkCF;;AIjrkCA;EACE,kCAAA;EACA,gBAAA;AJorkCF;;AIlrkCA;EACE,kCAAA;EACA,gBAAA;AJqrkCF;;AInrkCA;EACE,kCAAA;EACA,gBAAA;AJsrkCF;;AIprkCA;EACE,YAAA;AJurkCF;;AIrrkCA;EACE,gCAAA;EACA,gBAAA;AJwrkCF;;AItrkCA;EACE,YAAA;AJyrkCF;;AIvrkCA;EACE,YAAA;AJ0rkCF;;AIxrkCA;EACE,YAAA;AJ2rkCF;;AIzrkCA;EACE,YAAA;AJ4rkCF;;AI1rkCA;EACE,YAAA;AJ6rkCF;;AI3rkCA;EACE,gCAAA;EACA,gBAAA;AJ8rkCF;;AI5rkCA;EACE,gCAAA;EACA,gBAAA;AJ+rkCF;;AI7rkCA;EACE,YAAA;AJgskCF;;AI9rkCA;EACE,gCAAA;EACA,gBAAA;AJiskCF;;AI/rkCA;EACE,YAAA;AJkskCF;;AIhskCA;EACE,gCAAA;EACA,gBAAA;AJmskCF;;AIjskCA;EACE,YAAA;AJoskCF;;AIlskCA;EACE,gCAAA;EACA,gBAAA;AJqskCF;;AInskCA;EACE,YAAA;AJsskCF;;AIpskCA;EACE,gCAAA;EACA,gBAAA;AJuskCF;;AIrskCA;EACE,YAAA;AJwskCF;;AItskCA;EACE,gCAAA;EACA,gBAAA;AJyskCF;;AIvskCA;EACE,YAAA;AJ0skCF;;AIxskCA;EACE,YAAA;AJ2skCF;;AIzskCA;EACE,YAAA;AJ4skCF;;AI1skCA;EACE,YAAA;AJ6skCF;;AI3skCA;EACE,YAAA;AJ8skCF;;AI5skCA;EACE,YAAA;AJ+skCF;;AI7skCA;EACE,YAAA;AJgtkCF;;AI9skCA;EACE,YAAA;AJitkCF;;AI/skCA;EACE,YAAA;AJktkCF;;AIhtkCA;EACE,YAAA;AJmtkCF;;AIjtkCA;EACE,YAAA;AJotkCF;;AIltkCA;EACE,YAAA;AJqtkCF;;AIntkCA;EACE,YAAA;AJstkCF;;AIptkCA;EACE,YAAA;AJutkCF;;AIrtkCA;EACE,YAAA;AJwtkCF;;AIttkCA;EACE,YAAA;AJytkCF;;AIvtkCA;EACE,YAAA;AJ0tkCF;;AIxtkCA;EACE,kCAAA;EACA,gBAAA;AJ2tkCF;;AIztkCA;EACE,kCAAA;EACA,gBAAA;AJ4tkCF;;AI1tkCA;EACE,YAAA;AJ6tkCF;;AI3tkCA;EACE,YAAA;AJ8tkCF;;AI5tkCA;EACE,YAAA;AJ+tkCF;;AI7tkCA;EACE,YAAA;AJgukCF;;AI9tkCA;EACE,YAAA;AJiukCF;;AI/tkCA;EACE,YAAA;AJkukCF;;AIhukCA;EACE,YAAA;AJmukCF;;AIjukCA;EACE,YAAA;AJoukCF;;AIlukCA;EACE,kCAAA;EACA,gBAAA;AJqukCF;;AInukCA;EACE,kCAAA;EACA,gBAAA;AJsukCF;;AIpukCA;EACE,kCAAA;EACA,gBAAA;AJuukCF;;AIrukCA;EACE,kCAAA;EACA,gBAAA;AJwukCF;;AItukCA;EACE,kCAAA;EACA,gBAAA;AJyukCF;;AIvukCA;EACE,YAAA;AJ0ukCF;;AIxukCA;EACE,kCAAA;EACA,gBAAA;AJ2ukCF;;AIzukCA;EACE,kCAAA;EACA,gBAAA;AJ4ukCF;;AI1ukCA;EACE,kCAAA;EACA,gBAAA;AJ6ukCF;;AI3ukCA;EACE,kCAAA;EACA,gBAAA;AJ8ukCF;;AI5ukCA;EACE,kCAAA;EACA,gBAAA;AJ+ukCF;;AI7ukCA;EACE,kCAAA;EACA,gBAAA;AJgvkCF;;AI9ukCA;EACE,kCAAA;EACA,gBAAA;AJivkCF;;AI/ukCA;EACE,YAAA;AJkvkCF;;AIhvkCA;EACE,kCAAA;EACA,gBAAA;AJmvkCF;;AIjvkCA;EACE,kCAAA;EACA,gBAAA;AJovkCF;;AIlvkCA;EACE,YAAA;AJqvkCF;;AInvkCA;EACE,YAAA;AJsvkCF;;AIpvkCA;EACE,YAAA;AJuvkCF;;AIrvkCA;EACE,YAAA;AJwvkCF;;AItvkCA;EACE,kCAAA;EACA,gBAAA;AJyvkCF;;AIvvkCA;EACE,kCAAA;EACA,gBAAA;AJ0vkCF;;AIxvkCA;EACE,kCAAA;EACA,gBAAA;AJ2vkCF;;AIzvkCA;EACE,kCAAA;EACA,gBAAA;AJ4vkCF;;AI1vkCA;EACE,kCAAA;EACA,gBAAA;AJ6vkCF;;AI3vkCA;EACE,kCAAA;EACA,gBAAA;AJ8vkCF;;AI5vkCA;EACE,kCAAA;EACA,gBAAA;AJ+vkCF;;AI7vkCA;EACE,kCAAA;EACA,gBAAA;AJgwkCF;;AI9vkCA;EACE,kCAAA;EACA,gBAAA;AJiwkCF;;AI/vkCA;EACE,kCAAA;EACA,gBAAA;AJkwkCF;;AIhwkCA;EACE,YAAA;AJmwkCF;;AIjwkCA;EACE,gCAAA;EACA,gBAAA;AJowkCF;;AIlwkCA;EACE,YAAA;AJqwkCF;;AInwkCA;EACE,gCAAA;EACA,gBAAA;AJswkCF;;AIpwkCA;EACE,YAAA;AJuwkCF;;AIrwkCA;EACE,kCAAA;EACA,gBAAA;AJwwkCF;;AItwkCA;EACE,kCAAA;EACA,gBAAA;AJywkCF;;AIvwkCA;EACE,kCAAA;EACA,gBAAA;AJ0wkCF;;AIxwkCA;EACE,kCAAA;EACA,gBAAA;AJ2wkCF;;AIzwkCA;EACE,kCAAA;EACA,gBAAA;AJ4wkCF;;AI1wkCA;EACE,gCAAA;EACA,gBAAA;AJ6wkCF;;AI3wkCA;EACE,YAAA;AJ8wkCF;;AI5wkCA;EACE,gCAAA;EACA,gBAAA;AJ+wkCF;;AI7wkCA;EACE,YAAA;AJgxkCF;;AI9wkCA;EACE,gCAAA;EACA,gBAAA;AJixkCF;;AI/wkCA;EACE,YAAA;AJkxkCF;;AIhxkCA;EACE,gCAAA;EACA,gBAAA;AJmxkCF;;AIjxkCA;EACE,YAAA;AJoxkCF;;AIlxkCA;EACE,gCAAA;EACA,gBAAA;AJqxkCF;;AInxkCA;EACE,YAAA;AJsxkCF;;AIpxkCA;EACE,kCAAA;EACA,gBAAA;AJuxkCF;;AIrxkCA;EACE,YAAA;AJwxkCF;;AItxkCA;EACE,YAAA;AJyxkCF;;AIvxkCA;EACE,gCAAA;EACA,gBAAA;AJ0xkCF;;AIxxkCA;EACE,YAAA;AJ2xkCF;;AIzxkCA;EACE,kCAAA;EACA,gBAAA;AJ4xkCF;;AI1xkCA;EACE,kCAAA;EACA,gBAAA;AJ6xkCF;;AI3xkCA;EACE,kCAAA;EACA,gBAAA;AJ8xkCF;;AI5xkCA;EACE,YAAA;AJ+xkCF;;AI7xkCA;EACE,YAAA;AJgykCF;;AI9xkCA;EACE,YAAA;AJiykCF;;AI/xkCA;EACE,kCAAA;EACA,gBAAA;AJkykCF;;AIhykCA;EACE,kCAAA;EACA,gBAAA;AJmykCF;;AIjykCA;EACE,kCAAA;EACA,gBAAA;AJoykCF;;AIlykCA;EACE,kCAAA;EACA,gBAAA;AJqykCF;;AInykCA;EACE,kCAAA;EACA,gBAAA;AJsykCF;;AIpykCA;EACE,kCAAA;EACA,gBAAA;AJuykCF;;AIrykCA;EACE,kCAAA;EACA,gBAAA;AJwykCF;;AItykCA;EACE,kCAAA;EACA,gBAAA;AJyykCF;;AIvykCA;EACE,kCAAA;EACA,gBAAA;AJ0ykCF;;AIxykCA;EACE,kCAAA;EACA,gBAAA;AJ2ykCF;;AIzykCA;EACE,kCAAA;EACA,gBAAA;AJ4ykCF;;AI1ykCA;EACE,kCAAA;EACA,gBAAA;AJ6ykCF;;AI3ykCA;EACE,YAAA;AJ8ykCF;;AI5ykCA;EACE,kCAAA;EACA,gBAAA;AJ+ykCF;;AI7ykCA;EACE,kCAAA;EACA,gBAAA;AJgzkCF;;AI9ykCA;EACE,kCAAA;EACA,gBAAA;AJizkCF;;AI/ykCA;EACE,kCAAA;EACA,gBAAA;AJkzkCF;;AIhzkCA;EACE,YAAA;AJmzkCF;;AIjzkCA;EACE,YAAA;AJozkCF;;AIlzkCA;EACE,gCAAA;EACA,gBAAA;AJqzkCF;;AInzkCA;EACE,YAAA;AJszkCF;;AIpzkCA;EACE,kCAAA;EACA,gBAAA;AJuzkCF;;AIrzkCA;EACE,kCAAA;EACA,gBAAA;AJwzkCF;;AItzkCA;EACE,gCAAA;EACA,gBAAA;AJyzkCF;;AIvzkCA;EACE,YAAA;AJ0zkCF;;AIxzkCA;EACE,gCAAA;EACA,gBAAA;AJ2zkCF;;AIzzkCA;EACE,YAAA;AJ4zkCF;;AI1zkCA;EACE,gCAAA;EACA,gBAAA;AJ6zkCF;;AI3zkCA;EACE,YAAA;AJ8zkCF;;AI5zkCA;EACE,gCAAA;EACA,gBAAA;AJ+zkCF;;AI7zkCA;EACE,YAAA;AJg0kCF;;AI9zkCA;EACE,gCAAA;EACA,gBAAA;AJi0kCF;;AI/zkCA;EACE,YAAA;AJk0kCF;;AIh0kCA;EACE,gCAAA;EACA,gBAAA;AJm0kCF;;AIj0kCA;EACE,YAAA;AJo0kCF;;AIl0kCA;EACE,gCAAA;EACA,gBAAA;AJq0kCF;;AIn0kCA;EACE,YAAA;AJs0kCF;;AIp0kCA;EACE,gCAAA;EACA,gBAAA;AJu0kCF;;AIr0kCA;EACE,YAAA;AJw0kCF;;AIt0kCA;EACE,gCAAA;EACA,gBAAA;AJy0kCF;;AIv0kCA;EACE,YAAA;AJ00kCF;;AIx0kCA;EACE,gCAAA;EACA,gBAAA;AJ20kCF;;AIz0kCA;EACE,YAAA;AJ40kCF;;AI10kCA;EACE,gCAAA;EACA,gBAAA;AJ60kCF;;AI30kCA;EACE,YAAA;AJ80kCF;;AI50kCA;EACE,gCAAA;EACA,gBAAA;AJ+0kCF;;AI70kCA;EACE,YAAA;AJg1kCF;;AI90kCA;EACE,gCAAA;EACA,gBAAA;AJi1kCF;;AI/0kCA;EACE,YAAA;AJk1kCF;;AIh1kCA;EACE,gCAAA;EACA,gBAAA;AJm1kCF;;AIj1kCA;EACE,YAAA;AJo1kCF;;AIl1kCA;EACE,kCAAA;EACA,gBAAA;AJq1kCF;;AIn1kCA;EACE,kCAAA;EACA,gBAAA;AJs1kCF;;AIp1kCA;EACE,kCAAA;EACA,gBAAA;AJu1kCF;;AIr1kCA;EACE,gCAAA;EACA,gBAAA;AJw1kCF;;AIt1kCA;EACE,gCAAA;EACA,gBAAA;AJy1kCF;;AIv1kCA;EACE,YAAA;AJ01kCF;;AIx1kCA;EACE,gCAAA;EACA,gBAAA;AJ21kCF;;AIz1kCA;EACE,YAAA;AJ41kCF;;AI11kCA;EACE,gCAAA;EACA,gBAAA;AJ61kCF;;AI31kCA;EACE,YAAA;AJ81kCF;;AI51kCA;EACE,gCAAA;EACA,gBAAA;AJ+1kCF;;AI71kCA;EACE,YAAA;AJg2kCF;;AI91kCA;EACE,YAAA;AJi2kCF;;AI/1kCA;EACE,kCAAA;EACA,gBAAA;AJk2kCF;;AIh2kCA;EACE,kCAAA;EACA,gBAAA;AJm2kCF;;AIj2kCA;EACE,YAAA;AJo2kCF;;AIl2kCA;EACE,kCAAA;EACA,gBAAA;AJq2kCF;;AIn2kCA;EACE,YAAA;AJs2kCF;;AIp2kCA;EACE,kCAAA;EACA,gBAAA;AJu2kCF;;AIr2kCA;EACE,kCAAA;EACA,gBAAA;AJw2kCF;;AIt2kCA;EACE,YAAA;AJy2kCF;;AIv2kCA;EACE,kCAAA;EACA,gBAAA;AJ02kCF;;AIx2kCA;EACE,kCAAA;EACA,gBAAA;AJ22kCF;;AIz2kCA;EACE,kCAAA;EACA,gBAAA;AJ42kCF;;AI12kCA;EACE,kCAAA;EACA,gBAAA;AJ62kCF;;AI32kCA;EACE,YAAA;AJ82kCF;;AI52kCA;EACE,kCAAA;EACA,gBAAA;AJ+2kCF;;AI72kCA;EACE,YAAA;AJg3kCF;;AI92kCA;EACE,kCAAA;EACA,gBAAA;AJi3kCF;;AI/2kCA;EACE,kCAAA;EACA,gBAAA;AJk3kCF;;AIh3kCA;EACE,kCAAA;EACA,gBAAA;AJm3kCF;;AIj3kCA;EACE,kCAAA;EACA,gBAAA;AJo3kCF;;AIl3kCA;EACE,YAAA;AJq3kCF;;AIn3kCA;EACE,YAAA;AJs3kCF;;AIp3kCA;EACE,gCAAA;EACA,gBAAA;AJu3kCF;;AIr3kCA;EACE,YAAA;AJw3kCF;;AIt3kCA;EACE,gCAAA;EACA,gBAAA;AJy3kCF;;AIv3kCA;EACE,YAAA;AJ03kCF;;AIx3kCA;EACE,gCAAA;EACA,gBAAA;AJ23kCF;;AIz3kCA;EACE,YAAA;AJ43kCF;;AI13kCA;EACE,YAAA;AJ63kCF;;AI33kCA;EACE,YAAA;AJ83kCF;;AI53kCA;EACE,gCAAA;EACA,gBAAA;AJ+3kCF;;AI73kCA;EACE,YAAA;AJg4kCF;;AI93kCA;EACE,gCAAA;EACA,gBAAA;AJi4kCF;;AI/3kCA;EACE,YAAA;AJk4kCF;;AIh4kCA;EACE,kCAAA;EACA,gBAAA;AJm4kCF;;AIj4kCA;EACE,kCAAA;EACA,gBAAA;AJo4kCF;;AIl4kCA;EACE,kCAAA;EACA,gBAAA;AJq4kCF;;AIn4kCA;EACE,gCAAA;EACA,gBAAA;AJs4kCF;;AIp4kCA;EACE,YAAA;AJu4kCF;;AIr4kCA;EACE,kCAAA;EACA,gBAAA;AJw4kCF;;AIt4kCA;EACE,kCAAA;EACA,gBAAA;AJy4kCF;;AIv4kCA;EACE,kCAAA;EACA,gBAAA;AJ04kCF;;AIx4kCA;EACE,kCAAA;EACA,gBAAA;AJ24kCF;;AIz4kCA;EACE,kCAAA;EACA,gBAAA;AJ44kCF;;AI14kCA;EACE,kCAAA;EACA,gBAAA;AJ64kCF;;AI34kCA;EACE,kCAAA;EACA,gBAAA;AJ84kCF;;AI54kCA;EACE,kCAAA;EACA,gBAAA;AJ+4kCF;;AI74kCA;EACE,gCAAA;EACA,gBAAA;AJg5kCF;;AI94kCA;EACE,YAAA;AJi5kCF;;AI/4kCA;EACE,YAAA;AJk5kCF;;AIh5kCA;EACE,gCAAA;EACA,gBAAA;AJm5kCF;;AIj5kCA;EACE,YAAA;AJo5kCF;;AIl5kCA;EACE,YAAA;AJq5kCF;;AIn5kCA;EACE,YAAA;AJs5kCF;;AIp5kCA;EACE,YAAA;AJu5kCF;;AIr5kCA;EACE,kCAAA;EACA,gBAAA;AJw5kCF;;AIt5kCA;EACE,kCAAA;EACA,gBAAA;AJy5kCF;;AIv5kCA;EACE,kCAAA;EACA,gBAAA;AJ05kCF;;AIx5kCA;EACE,kCAAA;EACA,gBAAA;AJ25kCF;;AIz5kCA;EACE,gCAAA;EACA,gBAAA;AJ45kCF;;AI15kCA;EACE,YAAA;AJ65kCF;;AI35kCA;EACE,YAAA;AJ85kCF;;AI55kCA;EACE,YAAA;AJ+5kCF;;AI75kCA;EACE,YAAA;AJg6kCF;;AI95kCA;EACE,kCAAA;EACA,gBAAA;AJi6kCF;;AI/5kCA;EACE,YAAA;AJk6kCF;;AIh6kCA;EACE,kCAAA;EACA,gBAAA;AJm6kCF;;AIj6kCA;EACE,kCAAA;EACA,gBAAA;AJo6kCF;;AIl6kCA;EACE,kCAAA;EACA,gBAAA;AJq6kCF;;AIn6kCA;EACE,kCAAA;EACA,gBAAA;AJs6kCF;;AIp6kCA;EACE,kCAAA;EACA,gBAAA;AJu6kCF;;AIr6kCA;EACE,kCAAA;EACA,gBAAA;AJw6kCF;;AIt6kCA;EACE,kCAAA;EACA,gBAAA;AJy6kCF;;AIv6kCA;EACE,kCAAA;EACA,gBAAA;AJ06kCF;;AIx6kCA;EACE,kCAAA;EACA,gBAAA;AJ26kCF;;AIz6kCA;EACE,gCAAA;EACA,gBAAA;AJ46kCF;;AI16kCA;EACE,YAAA;AJ66kCF;;AI36kCA;EACE,YAAA;AJ86kCF;;AI56kCA;EACE,kCAAA;EACA,gBAAA;AJ+6kCF;;AI76kCA;EACE,YAAA;AJg7kCF;;AI96kCA;EACE,kCAAA;EACA,gBAAA;AJi7kCF;;AI/6kCA;EACE,kCAAA;EACA,gBAAA;AJk7kCF;;AIh7kCA;EACE,YAAA;AJm7kCF;;AIj7kCA;EACE,kCAAA;EACA,gBAAA;AJo7kCF;;AIl7kCA;EACE,kCAAA;EACA,gBAAA;AJq7kCF;;AIn7kCA;EACE,kCAAA;EACA,gBAAA;AJs7kCF;;AIp7kCA;EACE,kCAAA;EACA,gBAAA;AJu7kCF;;AIr7kCA;EACE,YAAA;AJw7kCF;;AIt7kCA;EACE,kCAAA;EACA,gBAAA;AJy7kCF;;AIv7kCA;EACE,kCAAA;EACA,gBAAA;AJ07kCF;;AIx7kCA;EACE,kCAAA;EACA,gBAAA;AJ27kCF;;AIz7kCA;EACE,YAAA;AJ47kCF;;AI17kCA;EACE,YAAA;AJ67kCF;;AI37kCA;EACE,YAAA;AJ87kCF;;AI57kCA;EACE,YAAA;AJ+7kCF;;AI77kCA;EACE,YAAA;AJg8kCF;;AI97kCA;EACE,YAAA;AJi8kCF;;AI/7kCA;EACE,gCAAA;EACA,gBAAA;AJk8kCF;;AIh8kCA;EACE,gCAAA;EACA,gBAAA;AJm8kCF;;AIj8kCA;EACE,gCAAA;EACA,gBAAA;AJo8kCF;;AIl8kCA;EACE,YAAA;AJq8kCF;;AIn8kCA;EACE,kCAAA;EACA,gBAAA;AJs8kCF;;AIp8kCA;EACE,kCAAA;EACA,gBAAA;AJu8kCF;;AIr8kCA;EACE,gCAAA;EACA,gBAAA;AJw8kCF;;AIt8kCA;EACE,gCAAA;EACA,gBAAA;AJy8kCF;;AIv8kCA;EACE,YAAA;AJ08kCF;;AIx8kCA;EACE,YAAA;AJ28kCF;;AIz8kCA;EACE,YAAA;AJ48kCF;;AI18kCA;EACE,YAAA;AJ68kCF;;AI38kCA;EACE,gCAAA;EACA,gBAAA;AJ88kCF;;AI58kCA;EACE,YAAA;AJ+8kCF;;AI78kCA;EACE,gCAAA;EACA,gBAAA;AJg9kCF;;AI98kCA;EACE,YAAA;AJi9kCF;;AI/8kCA;EACE,gCAAA;EACA,gBAAA;AJk9kCF;;AIh9kCA;EACE,YAAA;AJm9kCF;;AIj9kCA;EACE,gCAAA;EACA,gBAAA;AJo9kCF;;AIl9kCA;EACE,YAAA;AJq9kCF;;AIn9kCA;EACE,gCAAA;EACA,gBAAA;AJs9kCF;;AIp9kCA;EACE,YAAA;AJu9kCF;;AIr9kCA;EACE,gCAAA;EACA,gBAAA;AJw9kCF;;AIt9kCA;EACE,YAAA;AJy9kCF;;AIv9kCA;EACE,gCAAA;EACA,gBAAA;AJ09kCF;;AIx9kCA;EACE,YAAA;AJ29kCF;;AIz9kCA;EACE,gCAAA;EACA,gBAAA;AJ49kCF;;AI19kCA;EACE,YAAA;AJ69kCF;;AI39kCA;EACE,gCAAA;EACA,gBAAA;AJ89kCF;;AI59kCA;EACE,YAAA;AJ+9kCF;;AI79kCA;EACE,gCAAA;EACA,gBAAA;AJg+kCF;;AI99kCA;EACE,kCAAA;EACA,gBAAA;AJi+kCF;;AI/9kCA;EACE,kCAAA;EACA,gBAAA;AJk+kCF;;AIh+kCA;EACE,kCAAA;EACA,gBAAA;AJm+kCF;;AIj+kCA;EACE,kCAAA;EACA,gBAAA;AJo+kCF;;AIl+kCA;EACE,kCAAA;EACA,gBAAA;AJq+kCF;;AIn+kCA;EACE,kCAAA;EACA,gBAAA;AJs+kCF;;AIp+kCA;EACE,kCAAA;EACA,gBAAA;AJu+kCF;;AIr+kCA;EACE,kCAAA;EACA,gBAAA;AJw+kCF;;AIt+kCA;EACE,kCAAA;EACA,gBAAA;AJy+kCF;;AIv+kCA;EACE,kCAAA;EACA,gBAAA;AJ0+kCF;;AIx+kCA;EACE,kCAAA;EACA,gBAAA;AJ2+kCF;;AIz+kCA;EACE,kCAAA;EACA,gBAAA;AJ4+kCF;;AI1+kCA;EACE,kCAAA;EACA,gBAAA;AJ6+kCF;;AI3+kCA;EACE,YAAA;AJ8+kCF;;AI5+kCA;EACE,kCAAA;EACA,gBAAA;AJ++kCF;;AI7+kCA;EACE,kCAAA;EACA,gBAAA;AJg/kCF;;AI9+kCA;EACE,kCAAA;EACA,gBAAA;AJi/kCF;;AI/+kCA;EACE,gCAAA;EACA,gBAAA;AJk/kCF;;AIh/kCA;EACE,YAAA;AJm/kCF;;AIj/kCA;EACE,gCAAA;EACA,gBAAA;AJo/kCF;;AIl/kCA;EACE,YAAA;AJq/kCF;;AIn/kCA;EACE,gCAAA;EACA,gBAAA;AJs/kCF;;AIp/kCA;EACE,YAAA;AJu/kCF;;AIr/kCA;EACE,gCAAA;EACA,gBAAA;AJw/kCF;;AIt/kCA;EACE,YAAA;AJy/kCF;;AIv/kCA;EACE,gCAAA;EACA,gBAAA;AJ0/kCF;;AIx/kCA;EACE,YAAA;AJ2/kCF;;AIz/kCA;EACE,YAAA;AJ4/kCF;;AI1/kCA;EACE,gCAAA;EACA,gBAAA;AJ6/kCF;;AI3/kCA;EACE,YAAA;AJ8/kCF;;AI5/kCA;EACE,kCAAA;EACA,gBAAA;AJ+/kCF;;AI7/kCA;EACE,kCAAA;EACA,gBAAA;AJgglCF;;AI9/kCA;EACE,YAAA;AJiglCF;;AI//kCA;EACE,kCAAA;EACA,gBAAA;AJkglCF;;AIhglCA;EACE,kCAAA;EACA,gBAAA;AJmglCF;;AIjglCA;EACE,kCAAA;EACA,gBAAA;AJoglCF;;AIlglCA;EACE,kCAAA;EACA,gBAAA;AJqglCF;;AInglCA;EACE,YAAA;AJsglCF;;AIpglCA;EACE,kCAAA;EACA,gBAAA;AJuglCF;;AIrglCA;EACE,kCAAA;EACA,gBAAA;AJwglCF;;AItglCA;EACE,kCAAA;EACA,gBAAA;AJyglCF;;AIvglCA;EACE,kCAAA;EACA,gBAAA;AJ0glCF;;AIxglCA;EACE,kCAAA;EACA,gBAAA;AJ2glCF;;AIzglCA;EACE,kCAAA;EACA,gBAAA;AJ4glCF;;AI1glCA;EACE,kCAAA;EACA,gBAAA;AJ6glCF;;AI3glCA;EACE,gCAAA;EACA,gBAAA;AJ8glCF;;AI5glCA;EACE,YAAA;AJ+glCF;;AI7glCA;EACE,gCAAA;EACA,gBAAA;AJghlCF;;AI9glCA;EACE,YAAA;AJihlCF;;AI/glCA;EACE,kCAAA;EACA,gBAAA;AJkhlCF;;AIhhlCA;EACE,kCAAA;EACA,gBAAA;AJmhlCF;;AIjhlCA;EACE,kCAAA;EACA,gBAAA;AJohlCF;;AIlhlCA;EACE,kCAAA;EACA,gBAAA;AJqhlCF;;AInhlCA;EACE,kCAAA;EACA,gBAAA;AJshlCF;;AIphlCA;EACE,kCAAA;EACA,gBAAA;AJuhlCF;;AIrhlCA;EACE,kCAAA;EACA,gBAAA;AJwhlCF;;AIthlCA;EACE,YAAA;AJyhlCF;;AIvhlCA;EACE,gCAAA;EACA,gBAAA;AJ0hlCF;;AIxhlCA;EACE,YAAA;AJ2hlCF;;AIzhlCA;EACE,YAAA;AJ4hlCF;;AI1hlCA;EACE,YAAA;AJ6hlCF;;AI3hlCA;EACE,YAAA;AJ8hlCF;;AI5hlCA;EACE,YAAA;AJ+hlCF;;AI7hlCA;EACE,kCAAA;EACA,gBAAA;AJgilCF;;AI9hlCA;EACE,kCAAA;EACA,gBAAA;AJiilCF;;AI/hlCA;EACE,YAAA;AJkilCF;;AIhilCA;EACE,kCAAA;EACA,gBAAA;AJmilCF;;AIjilCA;EACE,kCAAA;EACA,gBAAA;AJoilCF;;AIlilCA;EACE,kCAAA;EACA,gBAAA;AJqilCF;;AInilCA;EACE,kCAAA;EACA,gBAAA;AJsilCF;;AIpilCA;EACE,kCAAA;EACA,gBAAA;AJuilCF;;AIrilCA;EACE,kCAAA;EACA,gBAAA;AJwilCF;;AItilCA;EACE,kCAAA;EACA,gBAAA;AJyilCF;;AIvilCA;EACE,kCAAA;EACA,gBAAA;AJ0ilCF;;AIxilCA;EACE,kCAAA;EACA,gBAAA;AJ2ilCF;;AIzilCA;EACE,kCAAA;EACA,gBAAA;AJ4ilCF;;AI1ilCA;EACE,YAAA;AJ6ilCF;;AI3ilCA;EACE,kCAAA;EACA,gBAAA;AJ8ilCF;;AI5ilCA;EACE,YAAA;AJ+ilCF;;AI7ilCA;EACE,kCAAA;EACA,gBAAA;AJgjlCF;;AI9ilCA;EACE,kCAAA;EACA,gBAAA;AJijlCF;;AI/ilCA;EACE,YAAA;AJkjlCF;;AIhjlCA;EACE,gCAAA;EACA,gBAAA;AJmjlCF;;AIjjlCA;EACE,YAAA;AJojlCF;;AIljlCA;EACE,gCAAA;EACA,gBAAA;AJqjlCF;;AInjlCA;EACE,YAAA;AJsjlCF;;AIpjlCA;EACE,kCAAA;EACA,gBAAA;AJujlCF;;AIrjlCA;EACE,gCAAA;EACA,gBAAA;AJwjlCF;;AItjlCA;EACE,YAAA;AJyjlCF;;AIvjlCA;EACE,YAAA;AJ0jlCF;;AIxjlCA;EACE,gCAAA;EACA,gBAAA;AJ2jlCF;;AIzjlCA;EACE,YAAA;AJ4jlCF;;AI1jlCA;EACE,gCAAA;EACA,gBAAA;AJ6jlCF;;AI3jlCA;EACE,YAAA;AJ8jlCF;;AI5jlCA;EACE,gCAAA;EACA,gBAAA;AJ+jlCF;;AI7jlCA;EACE,YAAA;AJgklCF;;AI9jlCA;EACE,gCAAA;EACA,gBAAA;AJiklCF;;AI/jlCA;EACE,YAAA;AJkklCF;;AIhklCA;EACE,gCAAA;EACA,gBAAA;AJmklCF;;AIjklCA;EACE,YAAA;AJoklCF;;AIlklCA;EACE,gCAAA;EACA,gBAAA;AJqklCF;;AInklCA;EACE,YAAA;AJsklCF;;AIpklCA;EACE,gCAAA;EACA,gBAAA;AJuklCF;;AIrklCA;EACE,YAAA;AJwklCF;;AItklCA;EACE,kCAAA;EACA,gBAAA;AJyklCF;;AIvklCA;EACE,kCAAA;EACA,gBAAA;AJ0klCF;;AIxklCA;EACE,kCAAA;EACA,gBAAA;AJ2klCF;;AIzklCA;EACE,YAAA;AJ4klCF;;AI1klCA;EACE,YAAA;AJ6klCF;;AI3klCA;EACE,YAAA;AJ8klCF;;AI5klCA;EACE,YAAA;AJ+klCF;;AI7klCA;EACE,YAAA;AJgllCF;;AI9klCA;EACE,YAAA;AJillCF;;AI/klCA;EACE,YAAA;AJkllCF;;AIhllCA;EACE,YAAA;AJmllCF;;AIjllCA;EACE,gCAAA;EACA,gBAAA;AJollCF;;AIlllCA;EACE,gCAAA;EACA,gBAAA;AJqllCF;;AInllCA;EACE,YAAA;AJsllCF;;AIpllCA;EACE,gCAAA;EACA,gBAAA;AJullCF;;AIrllCA;EACE,YAAA;AJwllCF;;AItllCA;EACE,gCAAA;EACA,gBAAA;AJyllCF;;AIvllCA;EACE,YAAA;AJ0llCF;;AIxllCA;EACE,kCAAA;EACA,gBAAA;AJ2llCF;;AIzllCA;EACE,kCAAA;EACA,gBAAA;AJ4llCF;;AI1llCA;EACE,kCAAA;EACA,gBAAA;AJ6llCF;;AI3llCA;EACE,kCAAA;EACA,gBAAA;AJ8llCF;;AI5llCA;EACE,kCAAA;EACA,gBAAA;AJ+llCF;;AI7llCA;EACE,kCAAA;EACA,gBAAA;AJgmlCF;;AI9llCA;EACE,YAAA;AJimlCF;;AI/llCA;EACE,gCAAA;EACA,gBAAA;AJkmlCF;;AIhmlCA;EACE,YAAA;AJmmlCF;;AIjmlCA;EACE,kCAAA;EACA,gBAAA;AJomlCF;;AIlmlCA;EACE,kCAAA;EACA,gBAAA;AJqmlCF;;AInmlCA;EACE,kCAAA;EACA,gBAAA;AJsmlCF;;AK3hyCA;;;;;;;;;CAAA;AAUA;EACE,wBAAA;EACA,6CAAA;EAA0D,OAAA;EAC1D,iTAAA;EAI6E,aAAA;EAC7E,kBAAA;AL4hyCF;AKzhyCA;EACE,mCAAA;EACA,kBAAA;EACA,mCAAA;EACA,kCAAA;AL2hyCF;;AKxhyCA;EAAS,mBAAA;EAAqB,mBAAA;EAAqB,yBAAA;AL8hyCnD;;AK7hyCA;EAAS,gBAAA;EAAkB,qBAAA;EAAuB,wBAAA;ALmiyClD;;AKliyCA;EAAU,gBAAA;ALsiyCV;;AKriyCA;EAAS,iBAAA;ALyiyCT;;AKxiyCA;EAAS,kBAAA;AL4iyCT;;AK3iyCA;EAAS,cAAA;AL+iyCT;;AK9iyCA;EAAS,cAAA;ALkjyCT;;AKjjyCA;EAAS,cAAA;ALqjyCT;;AKpjyCA;EAAS,cAAA;ALwjyCT;;AKvjyCA;EAAS,cAAA;AL2jyCT;;AK1jyCA;EAAS,cAAA;AL8jyCT;;AK7jyCA;EAAS,cAAA;ALikyCT;;AKhkyCA;EAAS,cAAA;ALokyCT;;AKnkyCA;EAAS,cAAA;ALukyCT;;AKtkyCA;EAAU,eAAA;AL0kyCV;;AKzkyCA;EAAS,kBAAA;EAAoB,aAAA;AL8kyC7B;;AK5kyCA;EAA2B,YAAA;ALglyC3B;;AK/kyCA;EAA2B,YAAA;ALmlyC3B;;AKllyCA;EAAqB,YAAA;ALslyCrB;;AKrlyCA;EAAqB,YAAA;ALylyCrB;;AKxlyCA;EAAiB,YAAA;AL4lyCjB;;AK3lyCA;EAA8B,YAAA;AL+lyC9B;;AK9lyCA;EAA8B,YAAA;ALkmyC9B;;AKjmyCA;EAAiC,YAAA;ALqmyCjC;;AKpmyCA;EAAiC,YAAA;ALwmyCjC;;AKvmyCA;EAAkC,YAAA;AL2myClC;;AK1myCA;EAAkC,YAAA;AL8myClC;;AK7myCA;EAAqC,YAAA;ALinyCrC;;AKhnyCA;EAAqC,YAAA;ALonyCrC;;AKnnyCA;EAA0B,YAAA;ALunyC1B;;AKtnyCA;EAA0B,YAAA;AL0nyC1B;;AKznyCA;EAA6B,YAAA;AL6nyC7B;;AK5nyCA;EAA6B,YAAA;ALgoyC7B;;AK/nyCA;EAAsB,YAAA;ALmoyCtB;;AKloyCA;EAAsB,YAAA;ALsoyCtB;;AKroyCA;EAAwB,YAAA;ALyoyCxB;;AKxoyCA;EAAwB,YAAA;AL4oyCxB;;AK3oyCA;EAAgC,YAAA;AL+oyChC;;AK9oyCA;EAAgC,YAAA;ALkpyChC;;AKjpyCA;EAA0B,YAAA;ALqpyC1B;;AKppyCA;EAA0B,YAAA;ALwpyC1B;;AKvpyCA;EAAwB,YAAA;AL2pyCxB;;AK1pyCA;EAAwB,YAAA;AL8pyCxB;;AK7pyCA;EAAgC,YAAA;ALiqyChC;;AKhqyCA;EAAgC,YAAA;ALoqyChC;;AKnqyCA;EAAwB,YAAA;ALuqyCxB;;AKtqyCA;EAAwB,YAAA;AL0qyCxB;;AKzqyCA;EAAwB,YAAA;AL6qyCxB;;AK5qyCA;EAAwB,YAAA;ALgryCxB;;AK/qyCA;EAAyB,YAAA;ALmryCzB;;AKlryCA;EAAyB,YAAA;ALsryCzB;;AKrryCA;EAA0B,YAAA;ALyryC1B;;AKxryCA;EAA0B,YAAA;AL4ryC1B;;AK3ryCA;EAA2B,YAAA;AL+ryC3B;;AK9ryCA;EAAwB,YAAA;ALksyCxB;;AKjsyCA;EAAyB,YAAA;ALqsyCzB;;AKpsyCA;EAAuB,YAAA;ALwsyCvB;;AKvsyCA;EAA8B,YAAA;AL2syC9B;;AK1syCA;EAAyB,YAAA;AL8syCzB;;AK7syCA;EAAyB,YAAA;ALityCzB;;AKhtyCA;EAAyB,YAAA;ALotyCzB;;AKntyCA;EAAyB,YAAA;ALutyCzB;;AKttyCA;EAAyB,YAAA;AL0tyCzB;;AKztyCA;EAAyB,YAAA;AL6tyCzB;;AK5tyCA;EAA+B,YAAA;ALguyC/B;;AK/tyCA;EAA+B,YAAA;ALmuyC/B;;AKluyCA;EAAmC,YAAA;ALsuyCnC;;AKruyCA;EAAmC,YAAA;ALyuyCnC;;AKxuyCA;EAA0B,YAAA;AL4uyC1B;;AK3uyCA;EAA0B,YAAA;AL+uyC1B;;AK9uyCA;EAA4B,YAAA;ALkvyC5B;;AKjvyCA;EAA4B,YAAA;ALqvyC5B;;AKpvyCA;EAAkC,YAAA;ALwvyClC;;AKvvyCA;EAAkC,YAAA;AL2vyClC;;AK1vyCA;EAAgC,YAAA;AL8vyChC;;AK7vyCA;EAAgC,YAAA;ALiwyChC;;AKhwyCA;EAA4B,YAAA;ALowyC5B;;AKnwyCA;EAA4B,YAAA;ALuwyC5B;;AKtwyCA;EAAwB,YAAA;AL0wyCxB;;AKzwyCA;EAAwB,YAAA;AL6wyCxB;;AK5wyCA;EAAyB,YAAA;ALgxyCzB;;AK/wyCA;EAAyB,YAAA;ALmxyCzB;;AKlxyCA;EAAuB,YAAA;ALsxyCvB;;AKrxyCA;EAAuB,YAAA;ALyxyCvB;;AKxxyCA;EAAiC,YAAA;AL4xyCjC;;AK3xyCA;EAAiC,YAAA;AL+xyCjC;;AK9xyCA;EAA0B,YAAA;ALkyyC1B;;AKjyyCA;EAA0B,YAAA;ALqyyC1B;;AKpyyCA;EAAoC,YAAA;ALwyyCpC;;AKvyyCA;EAAoC,YAAA;AL2yyCpC;;AK1yyCA;EAA6B,YAAA;AL8yyC7B;;AK7yyCA;EAA6B,YAAA;ALizyC7B;;AKhzyCA;EAA+B,YAAA;ALozyC/B;;AKnzyCA;EAA+B,YAAA;ALuzyC/B;;AKtzyCA;EAAkC,YAAA;AL0zyClC;;AKzzyCA;EAAkC,YAAA;AL6zyClC;;AK5zyCA;EAAkC,YAAA;ALg0yClC;;AK/zyCA;EAAkC,YAAA;ALm0yClC;;AKl0yCA;EAAmC,YAAA;ALs0yCnC;;AKr0yCA;EAAmC,YAAA;ALy0yCnC;;AKx0yCA;EAAgC,YAAA;AL40yChC;;AK30yCA;EAAgC,YAAA;AL+0yChC;;AK90yCA;EAAgC,YAAA;ALk1yChC;;AKj1yCA;EAAgC,YAAA;ALq1yChC;;AKp1yCA;EAAmC,YAAA;ALw1yCnC;;AKv1yCA;EAAmC,YAAA;AL21yCnC;;AK11yCA;EAAoC,YAAA;AL81yCpC;;AK71yCA;EAAoC,YAAA;ALi2yCpC;;AKh2yCA;EAAkC,YAAA;ALo2yClC;;AKn2yCA;EAAkC,YAAA;ALu2yClC;;AKt2yCA;EAA6B,YAAA;AL02yC7B;;AKz2yCA;EAA6B,YAAA;AL62yC7B;;AK52yCA;EAAmC,YAAA;ALg3yCnC;;AK/2yCA;EAAmC,YAAA;ALm3yCnC;;AKl3yCA;EAA+B,YAAA;ALs3yC/B;;AKr3yCA;EAA+B,YAAA;ALy3yC/B;;AKx3yCA;EAAgC,YAAA;AL43yChC;;AK33yCA;EAAgC,YAAA;AL+3yChC;;AK93yCA;EAAqC,YAAA;ALk4yCrC;;AKj4yCA;EAAqC,YAAA;ALq4yCrC;;AKp4yCA;EAAmC,YAAA;ALw4yCnC;;AKv4yCA;EAAmC,YAAA;AL24yCnC;;AK14yCA;EAA8B,YAAA;AL84yC9B;;AK74yCA;EAA8B,YAAA;ALi5yC9B;;AKh5yCA;EAAgC,YAAA;ALo5yChC;;AKn5yCA;EAAgC,YAAA;ALu5yChC;;AKt5yCA;EAAiC,YAAA;AL05yCjC;;AKz5yCA;EAAiC,YAAA;AL65yCjC;;AK55yCA;EAAkC,YAAA;ALg6yClC;;AK/5yCA;EAAkC,YAAA;ALm6yClC;;AKl6yCA;EAAgC,YAAA;ALs6yChC;;AKr6yCA;EAAgC,YAAA;ALy6yChC;;AKx6yCA;EAA2B,YAAA;AL46yC3B;;AK36yCA;EAA2B,YAAA;AL+6yC3B;;AK96yCA;EAA6B,YAAA;ALk7yC7B;;AKj7yCA;EAA6B,YAAA;ALq7yC7B;;AKp7yCA;EAA6B,YAAA;ALw7yC7B;;AKv7yCA;EAA6B,YAAA;AL27yC7B;;AK17yCA;EAA2B,YAAA;AL87yC3B;;AK77yCA;EAA2B,YAAA;ALi8yC3B;;AKh8yCA;EAA0B,YAAA;ALo8yC1B;;AKn8yCA;EAA0B,YAAA;ALu8yC1B;;AKt8yCA;EAA+B,YAAA;AL08yC/B;;AKz8yCA;EAA+B,YAAA;AL68yC/B;;AK58yCA;EAAsB,YAAA;ALg9yCtB;;AK/8yCA;EAAqB,YAAA;ALm9yCrB;;AKl9yCA;EAAqB,YAAA;ALs9yCrB;;AKr9yCA;EAA0B,YAAA;ALy9yC1B;;AKx9yCA;EAA6B,YAAA;AL49yC7B;;AK39yCA;EAA6B,YAAA;AL+9yC7B;;AK99yCA;EAA0B,YAAA;ALk+yC1B;;AKj+yCA;EAA0B,YAAA;ALq+yC1B;;AKp+yCA;EAAwB,YAAA;ALw+yCxB;;AKv+yCA;EAAwB,YAAA;AL2+yCxB;;AK1+yCA;EAAwB,YAAA;AL8+yCxB;;AK7+yCA;EAAwB,YAAA;ALi/yCxB;;AKh/yCA;EAA2B,YAAA;ALo/yC3B;;AKn/yCA;EAA2B,YAAA;ALu/yC3B;;AKt/yCA;EAA8B,YAAA;AL0/yC9B;;AKz/yCA;EAA8B,YAAA;AL6/yC9B;;AK5/yCA;EAA4B,YAAA;ALggzC5B;;AK//yCA;EAA4B,YAAA;ALmgzC5B;;AKlgzCA;EAAuB,YAAA;ALsgzCvB;;AKrgzCA;EAAuB,YAAA;ALygzCvB;;AKxgzCA;EAA8B,YAAA;AL4gzC9B;;AK3gzCA;EAA8B,YAAA;AL+gzC9B;;AK9gzCA;EAAgC,YAAA;ALkhzChC;;AKjhzCA;EAAgC,YAAA;ALqhzChC;;AKphzCA;EAA4B,YAAA;ALwhzC5B;;AKvhzCA;EAAoC,YAAA;AL2hzCpC;;AK1hzCA;EAAoC,YAAA;AL8hzCpC;;AK7hzCA;EAAuC,YAAA;ALiizCvC;;AKhizCA;EAAuC,YAAA;ALoizCvC;;AKnizCA;EAA4B,YAAA;ALuizC5B;;AKtizCA;EAA8B,YAAA;AL0izC9B;;AKzizCA;EAA8B,YAAA;AL6izC9B;;AK5izCA;EAA0B,YAAA;ALgjzC1B;;AK/izCA;EAA0B,YAAA;ALmjzC1B;;AKljzCA;EAA4B,YAAA;ALsjzC5B;;AKrjzCA;EAA4B,YAAA;ALyjzC5B;;AKxjzCA;EAA+B,YAAA;AL4jzC/B;;AK3jzCA;EAA+B,YAAA;AL+jzC/B;;AK9jzCA;EAA6B,YAAA;ALkkzC7B;;AKjkzCA;EAA6B,YAAA;ALqkzC7B;;AKpkzCA;EAAmC,YAAA;ALwkzCnC;;AKvkzCA;EAAmC,YAAA;AL2kzCnC;;AK1kzCA;EAA4B,YAAA;AL8kzC5B;;AK7kzCA;EAA4B,YAAA;ALilzC5B;;AKhlzCA;EAAiC,YAAA;ALolzCjC;;AKnlzCA;EAAiC,YAAA;ALulzCjC;;AKtlzCA;EAA0B,YAAA;AL0lzC1B;;AKzlzCA;EAA0B,YAAA;AL6lzC1B;;AK5lzCA;EAA8B,YAAA;ALgmzC9B;;AK/lzCA;EAA8B,YAAA;ALmmzC9B;;AKlmzCA;EAAgC,YAAA;ALsmzChC;;AKrmzCA;EAAgC,YAAA;ALymzChC;;AKxmzCA;EAAgC,YAAA;AL4mzChC;;AK3mzCA;EAAgC,YAAA;AL+mzChC;;AK9mzCA;EAA6B,YAAA;ALknzC7B;;AKjnzCA;EAA6B,YAAA;ALqnzC7B;;AKpnzCA;EAA0B,YAAA;ALwnzC1B;;AKvnzCA;EAA0B,YAAA;AL2nzC1B;;AK1nzCA;EAAuB,YAAA;AL8nzCvB;;AK7nzCA;EAAuB,YAAA;ALiozCvB;;AKhozCA;EAAuB,YAAA;ALoozCvB;;AKnozCA;EAAuB,YAAA;ALuozCvB;;AKtozCA;EAA2B,YAAA;AL0ozC3B;;AKzozCA;EAA2B,YAAA;AL6ozC3B;;AK5ozCA;EAAuB,YAAA;ALgpzCvB;;AK/ozCA;EAAuB,YAAA;ALmpzCvB;;AKlpzCA;EAA4B,YAAA;ALspzC5B;;AKrpzCA;EAA4B,YAAA;ALypzC5B;;AKxpzCA;EAA2B,YAAA;AL4pzC3B;;AK3pzCA;EAA2B,YAAA;AL+pzC3B;;AK9pzCA;EAAwB,YAAA;ALkqzCxB;;AKjqzCA;EAAwB,YAAA;ALqqzCxB;;AKpqzCA;EAAoC,YAAA;ALwqzCpC;;AKvqzCA;EAAoC,YAAA;AL2qzCpC;;AK1qzCA;EAA4B,YAAA;AL8qzC5B;;AK7qzCA;EAA4B,YAAA;ALirzC5B;;AKhrzCA;EAA2B,YAAA;ALorzC3B;;AKnrzCA;EAA2B,YAAA;ALurzC3B;;AKtrzCA;EAA4B,YAAA;AL0rzC5B;;AKzrzCA;EAA4B,YAAA;AL6rzC5B;;AK5rzCA;EAAkB,YAAA;ALgszClB;;AK/rzCA;EAAyB,YAAA;ALmszCzB;;AKlszCA;EAAyB,YAAA;ALsszCzB;;AKrszCA;EAAyB,YAAA;ALyszCzB;;AKxszCA;EAAyB,YAAA;AL4szCzB;;AK3szCA;EAAuB,YAAA;AL+szCvB;;AK9szCA;EAAuB,YAAA;ALktzCvB;;AKjtzCA;EAA4B,YAAA;ALqtzC5B;;AKptzCA;EAA4B,YAAA;ALwtzC5B;;AKvtzCA;EAA4B,YAAA;AL2tzC5B;;AK1tzCA;EAA4B,YAAA;AL8tzC5B;;AK7tzCA;EAA4B,YAAA;ALiuzC5B;;AKhuzCA;EAA4B,YAAA;ALouzC5B;;AKnuzCA;EAA0B,YAAA;ALuuzC1B;;AKtuzCA;EAA0B,YAAA;AL0uzC1B;;AKzuzCA;EAA6B,YAAA;AL6uzC7B;;AK5uzCA;EAA6B,YAAA;ALgvzC7B;;AK/uzCA;EAA6B,YAAA;ALmvzC7B;;AKlvzCA;EAA6B,YAAA;ALsvzC7B;;AKrvzCA;EAA2B,YAAA;ALyvzC3B;;AKxvzCA;EAA2B,YAAA;AL4vzC3B;;AK3vzCA;EAAyB,YAAA;AL+vzCzB;;AK9vzCA;EAAyB,YAAA;ALkwzCzB;;AKjwzCA;EAAyB,YAAA;ALqwzCzB;;AKpwzCA;EAAyB,YAAA;ALwwzCzB;;AKvwzCA;EAA2B,YAAA;AL2wzC3B;;AK1wzCA;EAA2B,YAAA;AL8wzC3B;;AK7wzCA;EAA8B,YAAA;ALixzC9B;;AKhxzCA;EAA8B,YAAA;ALoxzC9B;;AKnxzCA;EAA8B,YAAA;ALuxzC9B;;AKtxzCA;EAA8B,YAAA;AL0xzC9B;;AKzxzCA;EAA8B,YAAA;AL6xzC9B;;AK5xzCA;EAA8B,YAAA;ALgyzC9B;;AK/xzCA;EAA8B,YAAA;ALmyzC9B;;AKlyzCA;EAA8B,YAAA;ALsyzC9B;;AKryzCA;EAA4B,YAAA;ALyyzC5B;;AKxyzCA;EAA4B,YAAA;AL4yzC5B;;AK3yzCA;EAA2B,YAAA;AL+yzC3B;;AK9yzCA;EAA4B,YAAA;ALkzzC5B;;AKjzzCA;EAA4B,YAAA;ALqzzC5B;;AKpzzCA;EAA4B,YAAA;ALwzzC5B;;AKvzzCA;EAA0B,YAAA;AL2zzC1B;;AK1zzCA;EAA0B,YAAA;AL8zzC1B;;AK7zzCA;EAA0B,YAAA;ALi0zC1B;;AKh0zCA;EAA0B,YAAA;ALo0zC1B;;AKn0zCA;EAA0B,YAAA;ALu0zC1B;;AKt0zCA;EAA0B,YAAA;AL00zC1B;;AKz0zCA;EAAwB,YAAA;AL60zCxB;;AK50zCA;EAAwB,YAAA;ALg1zCxB;;AK/0zCA;EAA+B,YAAA;ALm1zC/B;;AKl1zCA;EAA+B,YAAA;ALs1zC/B;;AKr1zCA;EAAwB,YAAA;ALy1zCxB;;AKx1zCA;EAAwB,YAAA;AL41zCxB;;AK31zCA;EAAsB,YAAA;AL+1zCtB;;AK91zCA;EAAsB,YAAA;ALk2zCtB;;AKj2zCA;EAA6B,YAAA;ALq2zC7B;;AKp2zCA;EAA6B,YAAA;ALw2zC7B;;AKv2zCA;EAA6B,YAAA;AL22zC7B;;AK12zCA;EAA6B,YAAA;AL82zC7B;;AK72zCA;EAA6B,YAAA;ALi3zC7B;;AKh3zCA;EAA6B,YAAA;ALo3zC7B;;AKn3zCA;EAA2B,YAAA;ALu3zC3B;;AKt3zCA;EAA2B,YAAA;AL03zC3B;;AKz3zCA;EAAwB,YAAA;AL63zCxB;;AK53zCA;EAAwB,YAAA;ALg4zCxB;;AK/3zCA;EAAsB,YAAA;ALm4zCtB;;AKl4zCA;EAAsB,YAAA;ALs4zCtB;;AKr4zCA;EAA2B,YAAA;ALy4zC3B;;AKx4zCA;EAA2B,YAAA;AL44zC3B;;AK34zCA;EAAyB,YAAA;AL+4zCzB;;AK94zCA;EAAyB,YAAA;ALk5zCzB;;AKj5zCA;EAAyB,YAAA;ALq5zCzB;;AKp5zCA;EAAyB,YAAA;ALw5zCzB;;AKv5zCA;EAAyB,YAAA;AL25zCzB;;AK15zCA;EAAyB,YAAA;AL85zCzB;;AK75zCA;EAAuB,YAAA;ALi6zCvB;;AKh6zCA;EAAuB,YAAA;ALo6zCvB;;AKn6zCA;EAA6B,YAAA;ALu6zC7B;;AKt6zCA;EAA6B,YAAA;AL06zC7B;;AKz6zCA;EAA6B,YAAA;AL66zC7B;;AK56zCA;EAA6B,YAAA;ALg7zC7B;;AK/6zCA;EAAiC,YAAA;ALm7zCjC;;AKl7zCA;EAAiC,YAAA;ALs7zCjC;;AKr7zCA;EAAiC,YAAA;ALy7zCjC;;AKx7zCA;EAAiC,YAAA;AL47zCjC;;AK37zCA;EAA2B,YAAA;AL+7zC3B;;AK97zCA;EAA2B,YAAA;ALk8zC3B;;AKj8zCA;EAAgC,YAAA;ALq8zChC;;AKp8zCA;EAAgC,YAAA;ALw8zChC;;AKv8zCA;EAA2B,YAAA;AL28zC3B;;AK18zCA;EAA2B,YAAA;AL88zC3B;;AK78zCA;EAA2B,YAAA;ALi9zC3B;;AKh9zCA;EAA2B,YAAA;ALo9zC3B;;AKn9zCA;EAAyB,YAAA;ALu9zCzB;;AKt9zCA;EAA8B,YAAA;AL09zC9B;;AKz9zCA;EAA8B,YAAA;AL69zC9B;;AK59zCA;EAAyB,YAAA;ALg+zCzB;;AK/9zCA;EAA6B,YAAA;ALm+zC7B;;AKl+zCA;EAA6B,YAAA;ALs+zC7B;;AKr+zCA;EAAgC,YAAA;ALy+zChC;;AKx+zCA;EAAgC,YAAA;AL4+zChC;;AK3+zCA;EAA0B,YAAA;AL++zC1B;;AK9+zCA;EAA0B,YAAA;ALk/zC1B;;AKj/zCA;EAAsB,YAAA;ALq/zCtB;;AKp/zCA;EAAsB,YAAA;ALw/zCtB;;AKv/zCA;EAA8B,YAAA;AL2/zC9B;;AK1/zCA;EAA8B,YAAA;AL8/zC9B;;AK7/zCA;EAA0B,YAAA;ALig0C1B;;AKhg0CA;EAA0B,YAAA;ALog0C1B;;AKng0CA;EAAuB,YAAA;ALug0CvB;;AKtg0CA;EAAuB,YAAA;AL0g0CvB;;AKzg0CA;EAA4B,YAAA;AL6g0C5B;;AK5g0CA;EAA4B,YAAA;ALgh0C5B;;AK/g0CA;EAA0B,YAAA;ALmh0C1B;;AKlh0CA;EAA0B,YAAA;ALsh0C1B;;AKrh0CA;EAAyB,YAAA;ALyh0CzB;;AKxh0CA;EAAyB,YAAA;AL4h0CzB;;AK3h0CA;EAAwC,YAAA;AL+h0CxC;;AK9h0CA;EAAwC,YAAA;ALki0CxC;;AKji0CA;EAAkC,YAAA;ALqi0ClC;;AKpi0CA;EAAkC,YAAA;ALwi0ClC;;AKvi0CA;EAAgC,YAAA;AL2i0ChC;;AK1i0CA;EAAgC,YAAA;AL8i0ChC;;AK7i0CA;EAAyB,YAAA;ALij0CzB;;AKhj0CA;EAAyB,YAAA;ALoj0CzB;;AKnj0CA;EAAyB,YAAA;ALuj0CzB;;AKtj0CA;EAAyB,YAAA;AL0j0CzB;;AKzj0CA;EAAyB,YAAA;AL6j0CzB;;AK5j0CA;EAAyB,YAAA;ALgk0CzB;;AK/j0CA;EAAyB,YAAA;ALmk0CzB;;AKlk0CA;EAAyB,YAAA;ALsk0CzB;;AKrk0CA;EAA6B,YAAA;ALyk0C7B;;AKxk0CA;EAA6B,YAAA;AL4k0C7B;;AK3k0CA;EAA8B,YAAA;AL+k0C9B;;AK9k0CA;EAA8B,YAAA;ALkl0C9B;;AKjl0CA;EAAgC,YAAA;ALql0ChC;;AKpl0CA;EAAgC,YAAA;ALwl0ChC;;AKvl0CA;EAAiC,YAAA;AL2l0CjC;;AK1l0CA;EAAiC,YAAA;AL8l0CjC;;AK7l0CA;EAA+B,YAAA;ALim0C/B;;AKhm0CA;EAA+B,YAAA;ALom0C/B;;AKnm0CA;EAA6B,YAAA;ALum0C7B;;AKtm0CA;EAA6B,YAAA;AL0m0C7B;;AKzm0CA;EAA+B,YAAA;AL6m0C/B;;AK5m0CA;EAA+B,YAAA;ALgn0C/B;;AK/m0CA;EAA2B,YAAA;ALmn0C3B;;AKln0CA;EAA2B,YAAA;ALsn0C3B;;AKrn0CA;EAA2B,YAAA;ALyn0C3B;;AKxn0CA;EAA2B,YAAA;AL4n0C3B;;AK3n0CA;EAA4B,YAAA;AL+n0C5B;;AK9n0CA;EAA4B,YAAA;ALko0C5B;;AKjo0CA;EAA+B,YAAA;ALqo0C/B;;AKpo0CA;EAA+B,YAAA;ALwo0C/B;;AKvo0CA;EAA6B,YAAA;AL2o0C7B;;AK1o0CA;EAA6B,YAAA;AL8o0C7B;;AK7o0CA;EAAgC,YAAA;ALip0ChC;;AKhp0CA;EAAgC,YAAA;ALop0ChC;;AKnp0CA;EAA+B,YAAA;ALup0C/B;;AKtp0CA;EAA+B,YAAA;AL0p0C/B;;AKzp0CA;EAA+B,YAAA;AL6p0C/B;;AK5p0CA;EAA+B,YAAA;ALgq0C/B;;AK/p0CA;EAA6B,YAAA;ALmq0C7B;;AKlq0CA;EAA6B,YAAA;ALsq0C7B;;AKrq0CA;EAA8B,YAAA;ALyq0C9B;;AKxq0CA;EAA8B,YAAA;AL4q0C9B;;AK3q0CA;EAA6B,YAAA;AL+q0C7B;;AK9q0CA;EAA6B,YAAA;ALkr0C7B;;AKjr0CA;EAA+B,YAAA;ALqr0C/B;;AKpr0CA;EAA+B,YAAA;ALwr0C/B;;AKvr0CA;EAAwB,YAAA;AL2r0CxB;;AK1r0CA;EAAwB,YAAA;AL8r0CxB;;AK7r0CA;EAAwC,YAAA;ALis0CxC;;AKhs0CA;EAAwC,YAAA;ALos0CxC;;AKns0CA;EAAiC,YAAA;ALus0CjC;;AKts0CA;EAAiC,YAAA;AL0s0CjC;;AKzs0CA;EAAkC,YAAA;AL6s0ClC;;AK5s0CA;EAAkC,YAAA;ALgt0ClC;;AK/s0CA;EAA2B,YAAA;ALmt0C3B;;AKlt0CA;EAAyC,YAAA;ALst0CzC;;AKrt0CA;EAAyC,YAAA;ALyt0CzC;;AKxt0CA;EAA2B,YAAA;AL4t0C3B;;AK3t0CA;EAA0C,YAAA;AL+t0C1C;;AK9t0CA;EAA0C,YAAA;ALku0C1C;;AKju0CA;EAAoC,YAAA;ALqu0CpC;;AKpu0CA;EAAoC,YAAA;ALwu0CpC;;AKvu0CA;EAAgC,YAAA;AL2u0ChC;;AK1u0CA;EAAgC,YAAA;AL8u0ChC;;AK7u0CA;EAAyB,YAAA;ALiv0CzB;;AKhv0CA;EAAyB,YAAA;ALov0CzB;;AKnv0CA;EAA+B,YAAA;ALuv0C/B;;AKtv0CA;EAA+B,YAAA;AL0v0C/B;;AKzv0CA;EAA4B,YAAA;AL6v0C5B;;AK5v0CA;EAA4B,YAAA;ALgw0C5B;;AK/v0CA;EAA8B,YAAA;ALmw0C9B;;AKlw0CA;EAA8B,YAAA;ALsw0C9B;;AKrw0CA;EAA4B,YAAA;ALyw0C5B;;AKxw0CA;EAA4B,YAAA;AL4w0C5B;;AK3w0CA;EAA+B,YAAA;AL+w0C/B;;AK9w0CA;EAA+B,YAAA;ALkx0C/B;;AKjx0CA;EAAwB,YAAA;ALqx0CxB;;AKpx0CA;EAAwB,YAAA;ALwx0CxB;;AKvx0CA;EAAoC,YAAA;AL2x0CpC;;AK1x0CA;EAAoC,YAAA;AL8x0CpC;;AK7x0CA;EAAwB,YAAA;ALiy0CxB;;AKhy0CA;EAAwB,YAAA;ALoy0CxB;;AKny0CA;EAA4B,YAAA;ALuy0C5B;;AKty0CA;EAA4B,YAAA;AL0y0C5B;;AKzy0CA;EAA8B,YAAA;AL6y0C9B;;AK5y0CA;EAA8B,YAAA;ALgz0C9B;;AK/y0CA;EAA2B,YAAA;ALmz0C3B;;AKlz0CA;EAA2B,YAAA;ALsz0C3B;;AKrz0CA;EAAyB,YAAA;ALyz0CzB;;AKxz0CA;EAAyB,YAAA;AL4z0CzB;;AK3z0CA;EAA2B,YAAA;AL+z0C3B;;AK9z0CA;EAA2B,YAAA;ALk00C3B;;AKj00CA;EAAuB,YAAA;ALq00CvB;;AKp00CA;EAAuB,YAAA;ALw00CvB;;AKv00CA;EAAyB,YAAA;AL200CzB;;AK100CA;EAAyB,YAAA;AL800CzB;;AK700CA;EAA+B,YAAA;ALi10C/B;;AKh10CA;EAA+B,YAAA;ALo10C/B;;AKn10CA;EAAuB,YAAA;ALu10CvB;;AKt10CA;EAA0B,YAAA;AL010C1B;;AKz10CA;EAA0B,YAAA;AL610C1B;;AK510CA;EAAuB,YAAA;ALg20CvB;;AK/10CA;EAAuB,YAAA;ALm20CvB;;AKl20CA;EAAwB,YAAA;ALs20CxB;;AKr20CA;EAAwB,YAAA;ALy20CxB;;AKx20CA;EAA0B,YAAA;AL420C1B;;AK320CA;EAA0B,YAAA;AL+20C1B;;AK920CA;EAA0B,YAAA;ALk30C1B;;AKj30CA;EAA0B,YAAA;ALq30C1B;;AKp30CA;EAA4B,YAAA;ALw30C5B;;AKv30CA;EAA4B,YAAA;AL230C5B;;AK130CA;EAA4B,YAAA;AL830C5B;;AK730CA;EAA4B,YAAA;ALi40C5B;;AKh40CA;EAA4B,YAAA;ALo40C5B;;AKn40CA;EAA4B,YAAA;ALu40C5B;;AKt40CA;EAA4B,YAAA;AL040C5B;;AKz40CA;EAA4B,YAAA;AL640C5B;;AK540CA;EAAmC,YAAA;ALg50CnC;;AK/40CA;EAAmC,YAAA;ALm50CnC;;AKl50CA;EAA0B,YAAA;ALs50C1B;;AKr50CA;EAA0B,YAAA;ALy50C1B;;AKx50CA;EAA8B,YAAA;AL450C9B;;AK350CA;EAA8B,YAAA;AL+50C9B;;AK950CA;EAA4B,YAAA;ALk60C5B;;AKj60CA;EAA4B,YAAA;ALq60C5B;;AKp60CA;EAA2B,YAAA;ALw60C3B;;AKv60CA;EAA2B,YAAA;AL260C3B;;AK160CA;EAAkC,YAAA;AL860ClC;;AK760CA;EAAkC,YAAA;ALi70ClC;;AKh70CA;EAAgC,YAAA;ALo70ChC;;AKn70CA;EAAgC,YAAA;ALu70ChC;;AKt70CA;EAAuC,YAAA;AL070CvC;;AKz70CA;EAAuC,YAAA;AL670CvC;;AK570CA;EAA2B,YAAA;ALg80C3B;;AK/70CA;EAA2B,YAAA;ALm80C3B;;AKl80CA;EAA6B,YAAA;ALs80C7B;;AKr80CA;EAA6B,YAAA;ALy80C7B;;AKx80CA;EAAkC,YAAA;AL480ClC;;AK380CA;EAAkC,YAAA;AL+80ClC;;AK980CA;EAAgC,YAAA;ALk90ChC;;AKj90CA;EAAgC,YAAA;ALq90ChC;;AKp90CA;EAA2B,YAAA;ALw90C3B;;AKv90CA;EAA2B,YAAA;AL290C3B;;AK190CA;EAA8B,YAAA;AL890C9B;;AK790CA;EAA8B,YAAA;ALi+0C9B;;AKh+0CA;EAAiC,YAAA;ALo+0CjC;;AKn+0CA;EAAiC,YAAA;ALu+0CjC;;AKt+0CA;EAA2B,YAAA;AL0+0C3B;;AKz+0CA;EAA2B,YAAA;AL6+0C3B;;AK5+0CA;EAA4B,YAAA;ALg/0C5B;;AK/+0CA;EAA4B,YAAA;ALm/0C5B;;AKl/0CA;EAAyB,YAAA;ALs/0CzB;;AKr/0CA;EAAyB,YAAA;ALy/0CzB;;AKx/0CA;EAA2B,YAAA;AL4/0C3B;;AK3/0CA;EAA2B,YAAA;AL+/0C3B;;AK9/0CA;EAA2B,YAAA;ALkg1C3B;;AKjg1CA;EAA2B,YAAA;ALqg1C3B;;AKpg1CA;EAA2B,YAAA;ALwg1C3B;;AKvg1CA;EAA2B,YAAA;AL2g1C3B;;AK1g1CA;EAA2B,YAAA;AL8g1C3B;;AK7g1CA;EAA2B,YAAA;ALih1C3B;;AKhh1CA;EAAyB,YAAA;ALoh1CzB;;AKnh1CA;EAAyB,YAAA;ALuh1CzB;;AKth1CA;EAAsB,YAAA;AL0h1CtB;;AKzh1CA;EAAsB,YAAA;AL6h1CtB;;AK5h1CA;EAAsC,YAAA;ALgi1CtC;;AK/h1CA;EAAsC,YAAA;ALmi1CtC;;AKli1CA;EAAmC,YAAA;ALsi1CnC;;AKri1CA;EAAmC,YAAA;ALyi1CnC;;AKxi1CA;EAAsC,YAAA;AL4i1CtC;;AK3i1CA;EAAsC,YAAA;AL+i1CtC;;AK9i1CA;EAAsC,YAAA;ALkj1CtC;;AKjj1CA;EAAsC,YAAA;ALqj1CtC;;AKpj1CA;EAAsC,YAAA;ALwj1CtC;;AKvj1CA;EAAsC,YAAA;AL2j1CtC;;AK1j1CA;EAAwC,YAAA;AL8j1CxC;;AK7j1CA;EAAwC,YAAA;ALik1CxC;;AKhk1CA;EAA2B,YAAA;ALok1C3B;;AKnk1CA;EAA2B,YAAA;ALuk1C3B;;AKtk1CA;EAAyB,YAAA;AL0k1CzB;;AKzk1CA;EAAyB,YAAA;AL6k1CzB;;AK5k1CA;EAAuB,YAAA;ALgl1CvB;;AK/k1CA;EAAuB,YAAA;ALml1CvB;;AKll1CA;EAAuB,YAAA;ALsl1CvB;;AKrl1CA;EAAuB,YAAA;ALyl1CvB;;AKxl1CA;EAAsB,YAAA;AL4l1CtB;;AK3l1CA;EAAsB,YAAA;AL+l1CtB;;AK9l1CA;EAA2B,YAAA;ALkm1C3B;;AKjm1CA;EAA2B,YAAA;ALqm1C3B;;AKpm1CA;EAAyB,YAAA;ALwm1CzB;;AKvm1CA;EAAyB,YAAA;AL2m1CzB;;AK1m1CA;EAAqC,YAAA;AL8m1CrC;;AK7m1CA;EAAqC,YAAA;ALin1CrC;;AKhn1CA;EAAmC,YAAA;ALon1CnC;;AKnn1CA;EAAmC,YAAA;ALun1CnC;;AKtn1CA;EAA8B,YAAA;AL0n1C9B;;AKzn1CA;EAA8B,YAAA;AL6n1C9B;;AK5n1CA;EAA8B,YAAA;ALgo1C9B;;AK/n1CA;EAA8B,YAAA;ALmo1C9B;;AKlo1CA;EAA4B,YAAA;ALso1C5B;;AKro1CA;EAA4B,YAAA;ALyo1C5B;;AKxo1CA;EAA6B,YAAA;AL4o1C7B;;AK3o1CA;EAA6B,YAAA;AL+o1C7B;;AK9o1CA;EAA2B,YAAA;ALkp1C3B;;AKjp1CA;EAA2B,YAAA;ALqp1C3B;;AKpp1CA;EAAgC,YAAA;ALwp1ChC;;AKvp1CA;EAAgC,YAAA;AL2p1ChC;;AK1p1CA;EAA8B,YAAA;AL8p1C9B;;AK7p1CA;EAA8B,YAAA;ALiq1C9B;;AKhq1CA;EAA+B,YAAA;ALoq1C/B;;AKnq1CA;EAA+B,YAAA;ALuq1C/B;;AKtq1CA;EAA+B,YAAA;AL0q1C/B;;AKzq1CA;EAA+B,YAAA;AL6q1C/B;;AK5q1CA;EAA+B,YAAA;ALgr1C/B;;AK/q1CA;EAA+B,YAAA;ALmr1C/B;;AKlr1CA;EAA+B,YAAA;ALsr1C/B;;AKrr1CA;EAA+B,YAAA;ALyr1C/B;;AKxr1CA;EAA+B,YAAA;AL4r1C/B;;AK3r1CA;EAA+B,YAAA;AL+r1C/B;;AK9r1CA;EAA+B,YAAA;ALks1C/B;;AKjs1CA;EAA+B,YAAA;ALqs1C/B;;AKps1CA;EAA6B,YAAA;ALws1C7B;;AKvs1CA;EAA6B,YAAA;AL2s1C7B;;AK1s1CA;EAA2B,YAAA;AL8s1C3B;;AK7s1CA;EAAwB,YAAA;ALit1CxB;;AKht1CA;EAAyB,YAAA;ALot1CzB;;AKnt1CA;EAAyB,YAAA;ALut1CzB;;AKtt1CA;EAAiC,YAAA;AL0t1CjC;;AKzt1CA;EAAiC,YAAA;AL6t1CjC;;AK5t1CA;EAA2B,YAAA;ALgu1C3B;;AK/t1CA;EAA2B,YAAA;ALmu1C3B;;AKlu1CA;EAA4B,YAAA;ALsu1C5B;;AKru1CA;EAA4B,YAAA;ALyu1C5B;;AKxu1CA;EAAuB,YAAA;AL4u1CvB;;AK3u1CA;EAAuB,YAAA;AL+u1CvB;;AK9u1CA;EAA0B,YAAA;ALkv1C1B;;AKjv1CA;EAA0B,YAAA;ALqv1C1B;;AKpv1CA;EAA0B,YAAA;ALwv1C1B;;AKvv1CA;EAA0B,YAAA;AL2v1C1B;;AK1v1CA;EAA0B,YAAA;AL8v1C1B;;AK7v1CA;EAA0B,YAAA;ALiw1C1B;;AKhw1CA;EAAyB,YAAA;ALow1CzB;;AKnw1CA;EAAyB,YAAA;ALuw1CzB;;AKtw1CA;EAAyB,YAAA;AL0w1CzB;;AKzw1CA;EAAyB,YAAA;AL6w1CzB;;AK5w1CA;EAA8B,YAAA;ALgx1C9B;;AK/w1CA;EAA8B,YAAA;ALmx1C9B;;AKlx1CA;EAA8B,YAAA;ALsx1C9B;;AKrx1CA;EAA8B,YAAA;ALyx1C9B;;AKxx1CA;EAAuB,YAAA;AL4x1CvB;;AK3x1CA;EAAuB,YAAA;AL+x1CvB;;AK9x1CA;EAAgC,YAAA;ALky1ChC;;AKjy1CA;EAAgC,YAAA;ALqy1ChC;;AKpy1CA;EAA4B,YAAA;ALwy1C5B;;AKvy1CA;EAA4B,YAAA;AL2y1C5B;;AK1y1CA;EAA4B,YAAA;AL8y1C5B;;AK7y1CA;EAA4B,YAAA;ALiz1C5B;;AKhz1CA;EAA0B,YAAA;ALoz1C1B;;AKnz1CA;EAA0B,YAAA;ALuz1C1B;;AKtz1CA;EAAyB,YAAA;AL0z1CzB;;AKzz1CA;EAAyB,YAAA;AL6z1CzB;;AK5z1CA;EAA6B,YAAA;ALg01C7B;;AK/z1CA;EAA6B,YAAA;ALm01C7B;;AKl01CA;EAA6B,YAAA;ALs01C7B;;AKr01CA;EAA6B,YAAA;ALy01C7B;;AKx01CA;EAAmC,YAAA;AL401CnC;;AK301CA;EAAmC,YAAA;AL+01CnC;;AK901CA;EAAiC,YAAA;ALk11CjC;;AKj11CA;EAAiC,YAAA;ALq11CjC;;AKp11CA;EAA2B,YAAA;ALw11C3B;;AKv11CA;EAA2B,YAAA;AL211C3B;;AK111CA;EAAwB,YAAA;AL811CxB;;AK711CA;EAAwB,YAAA;ALi21CxB;;AKh21CA;EAA4B,YAAA;ALo21C5B;;AKn21CA;EAA4B,YAAA;ALu21C5B;;AKt21CA;EAA8B,YAAA;AL021C9B;;AKz21CA;EAA8B,YAAA;AL621C9B;;AK521CA;EAA4B,YAAA;ALg31C5B;;AK/21CA;EAA4B,YAAA;ALm31C5B;;AKl31CA;EAA2B,YAAA;ALs31C3B;;AKr31CA;EAA2B,YAAA;ALy31C3B;;AKx31CA;EAAwB,YAAA;AL431CxB;;AK331CA;EAAwB,YAAA;AL+31CxB;;AK931CA;EAA0B,YAAA;ALk41C1B;;AKj41CA;EAA0B,YAAA;ALq41C1B;;AKp41CA;EAAuB,YAAA;ALw41CvB;;AKv41CA;EAAuB,YAAA;AL241CvB;;AK141CA;EAA0B,YAAA;AL841C1B;;AK741CA;EAA0B,YAAA;ALi51C1B;;AKh51CA;EAA6B,YAAA;ALo51C7B;;AKn51CA;EAA6B,YAAA;ALu51C7B;;AKt51CA;EAA6B,YAAA;AL051C7B;;AKz51CA;EAA6B,YAAA;AL651C7B;;AK551CA;EAAqB,YAAA;ALg61CrB;;AK/51CA;EAAqB,YAAA;ALm61CrB;;AKl61CA;EAAsB,YAAA;ALs61CtB;;AKr61CA;EAAsB,YAAA;ALy61CtB;;AKx61CA;EAA2B,YAAA;AL461C3B;;AK361CA;EAA2B,YAAA;AL+61C3B;;AK961CA;EAAyB,YAAA;ALk71CzB;;AKj71CA;EAAyB,YAAA;ALq71CzB;;AKp71CA;EAAwB,YAAA;ALw71CxB;;AKv71CA;EAAwB,YAAA;AL271CxB;;AK171CA;EAA6B,YAAA;AL871C7B;;AK771CA;EAA6B,YAAA;ALi81C7B;;AKh81CA;EAAuB,YAAA;ALo81CvB;;AKn81CA;EAAuB,YAAA;ALu81CvB;;AKt81CA;EAAyB,YAAA;AL081CzB;;AKz81CA;EAAyB,YAAA;AL681CzB;;AK581CA;EAA2B,YAAA;ALg91C3B;;AK/81CA;EAA2B,YAAA;ALm91C3B;;AKl91CA;EAA8B,YAAA;ALs91C9B;;AKr91CA;EAA8B,YAAA;ALy91C9B;;AKx91CA;EAAuB,YAAA;AL491CvB;;AK391CA;EAAuB,YAAA;AL+91CvB;;AK991CA;EAAwB,YAAA;ALk+1CxB;;AKj+1CA;EAAwB,YAAA;ALq+1CxB;;AKp+1CA;EAA4B,YAAA;ALw+1C5B;;AKv+1CA;EAA4B,YAAA;AL2+1C5B;;AK1+1CA;EAA0B,YAAA;AL8+1C1B;;AK7+1CA;EAAgC,YAAA;ALi/1ChC;;AKh/1CA;EAAgC,YAAA;ALo/1ChC;;AKn/1CA;EAAgC,YAAA;ALu/1ChC;;AKt/1CA;EAAgC,YAAA;AL0/1ChC;;AKz/1CA;EAA0B,YAAA;AL6/1C1B;;AK5/1CA;EAAiC,YAAA;ALgg2CjC;;AK//1CA;EAAiC,YAAA;ALmg2CjC;;AKlg2CA;EAA8B,YAAA;ALsg2C9B;;AKrg2CA;EAA8B,YAAA;ALyg2C9B;;AKxg2CA;EAAkC,YAAA;AL4g2ClC;;AK3g2CA;EAAkC,YAAA;AL+g2ClC;;AK9g2CA;EAA4B,YAAA;ALkh2C5B;;AKjh2CA;EAA4B,YAAA;ALqh2C5B;;AKph2CA;EAAyB,YAAA;ALwh2CzB;;AKvh2CA;EAAsB,YAAA;AL2h2CtB;;AK1h2CA;EAA2B,YAAA;AL8h2C3B;;AK7h2CA;EAA4B,YAAA;ALii2C5B;;AKhi2CA;EAA4B,YAAA;ALoi2C5B;;AKni2CA;EAAyB,YAAA;ALui2CzB;;AKti2CA;EAAyB,YAAA;AL0i2CzB;;AKzi2CA;EAAgC,YAAA;AL6i2ChC;;AK5i2CA;EAAgC,YAAA;ALgj2ChC;;AK/i2CA;EAA2B,YAAA;ALmj2C3B;;AKlj2CA;EAA2B,YAAA;ALsj2C3B;;AKrj2CA;EAA+B,YAAA;ALyj2C/B;;AKxj2CA;EAA+B,YAAA;AL4j2C/B;;AK3j2CA;EAA+B,YAAA;AL+j2C/B;;AK9j2CA;EAA+B,YAAA;ALkk2C/B;;AKjk2CA;EAAkC,YAAA;ALqk2ClC;;AKpk2CA;EAAkC,YAAA;ALwk2ClC;;AKvk2CA;EAA2B,YAAA;AL2k2C3B;;AK1k2CA;EAAiC,YAAA;AL8k2CjC;;AK7k2CA;EAAiC,YAAA;ALil2CjC;;AKhl2CA;EAA2B,YAAA;ALol2C3B;;AKnl2CA;EAAgC,YAAA;ALul2ChC;;AKtl2CA;EAAgC,YAAA;AL0l2ChC;;AKzl2CA;EAAwB,YAAA;AL6l2CxB;;AK5l2CA;EAAwB,YAAA;ALgm2CxB;;AK/l2CA;EAA4B,YAAA;ALmm2C5B;;AKlm2CA;EAA4B,YAAA;ALsm2C5B;;AKrm2CA;EAAsB,YAAA;ALym2CtB;;AKxm2CA;EAAsB,YAAA;AL4m2CtB;;AK3m2CA;EAA0B,YAAA;AL+m2C1B;;AK9m2CA;EAA0B,YAAA;ALkn2C1B;;AKjn2CA;EAA+B,YAAA;ALqn2C/B;;AKpn2CA;EAA+B,YAAA;ALwn2C/B;;AKvn2CA;EAAkC,YAAA;AL2n2ClC;;AK1n2CA;EAAkC,YAAA;AL8n2ClC;;AK7n2CA;EAA2B,YAAA;ALio2C3B;;AKho2CA;EAA2B,YAAA;ALoo2C3B;;AKno2CA;EAA6B,YAAA;ALuo2C7B;;AKto2CA;EAA6B,YAAA;AL0o2C7B;;AKzo2CA;EAA2B,YAAA;AL6o2C3B;;AK5o2CA;EAA2B,YAAA;ALgp2C3B;;AK/o2CA;EAAyB,YAAA;ALmp2CzB;;AKlp2CA;EAAyB,YAAA;ALsp2CzB;;AKrp2CA;EAAyB,YAAA;ALyp2CzB;;AKxp2CA;EAAyB,YAAA;AL4p2CzB;;AK3p2CA;EAAyB,YAAA;AL+p2CzB;;AK9p2CA;EAAyB,YAAA;ALkq2CzB;;AKjq2CA;EAA2B,YAAA;ALqq2C3B;;AKpq2CA;EAA2B,YAAA;ALwq2C3B;;AKvq2CA;EAA+B,YAAA;AL2q2C/B;;AK1q2CA;EAA+B,YAAA;AL8q2C/B;;AK7q2CA;EAA6B,YAAA;ALir2C7B;;AKhr2CA;EAA6B,YAAA;ALor2C7B;;AKnr2CA;EAA6B,YAAA;ALur2C7B;;AKtr2CA;EAA6B,YAAA;AL0r2C7B;;AKzr2CA;EAA4B,YAAA;AL6r2C5B;;AK5r2CA;EAA4B,YAAA;ALgs2C5B;;AK/r2CA;EAA8B,YAAA;ALms2C9B;;AKls2CA;EAA8B,YAAA;ALss2C9B;;AKrs2CA;EAA4B,YAAA;ALys2C5B;;AKxs2CA;EAA4B,YAAA;AL4s2C5B;;AK3s2CA;EAA8B,YAAA;AL+s2C9B;;AK9s2CA;EAA8B,YAAA;ALkt2C9B;;AKjt2CA;EAAgC,YAAA;ALqt2ChC;;AKpt2CA;EAAgC,YAAA;ALwt2ChC;;AKvt2CA;EAA4B,YAAA;AL2t2C5B;;AK1t2CA;EAA4B,YAAA;AL8t2C5B;;AK7t2CA;EAA+B,YAAA;ALiu2C/B;;AKhu2CA;EAA+B,YAAA;ALou2C/B;;AKnu2CA;EAA6B,YAAA;ALuu2C7B;;AKtu2CA;EAA6B,YAAA;AL0u2C7B;;AKzu2CA;EAAuB,YAAA;AL6u2CvB;;AK5u2CA;EAA8B,YAAA;ALgv2C9B;;AK/u2CA;EAA8B,YAAA;ALmv2C9B;;AKlv2CA;EAA2B,YAAA;ALsv2C3B;;AKrv2CA;EAA2B,YAAA;ALyv2C3B;;AKxv2CA;EAA+B,YAAA;AL4v2C/B;;AK3v2CA;EAA+B,YAAA;AL+v2C/B;;AK9v2CA;EAA2B,YAAA;ALkw2C3B;;AKjw2CA;EAA2B,YAAA;ALqw2C3B;;AKpw2CA;EAA4B,YAAA;ALww2C5B;;AKvw2CA;EAA4B,YAAA;AL2w2C5B;;AK1w2CA;EAAuB,YAAA;AL8w2CvB;;AK7w2CA;EAA8B,YAAA;ALix2C9B;;AKhx2CA;EAA8B,YAAA;ALox2C9B;;AKnx2CA;EAA8B,YAAA;ALux2C9B;;AKtx2CA;EAA8B,YAAA;AL0x2C9B;;AKzx2CA;EAA4B,YAAA;AL6x2C5B;;AK5x2CA;EAA4B,YAAA;ALgy2C5B;;AK/x2CA;EAA4B,YAAA;ALmy2C5B;;AKly2CA;EAA4B,YAAA;ALsy2C5B;;AKry2CA;EAA4B,YAAA;ALyy2C5B;;AKxy2CA;EAA4B,YAAA;AL4y2C5B;;AK3y2CA;EAA6B,YAAA;AL+y2C7B;;AK9y2CA;EAA6B,YAAA;ALkz2C7B;;AKjz2CA;EAA+B,YAAA;ALqz2C/B;;AKpz2CA;EAA+B,YAAA;ALwz2C/B;;AKvz2CA;EAA6B,YAAA;AL2z2C7B;;AK1z2CA;EAA6B,YAAA;AL8z2C7B;;AK7z2CA;EAA2B,YAAA;ALi02C3B;;AKh02CA;EAA2B,YAAA;ALo02C3B;;AKn02CA;EAA6B,YAAA;ALu02C7B;;AKt02CA;EAA6B,YAAA;AL002C7B;;AKz02CA;EAA2B,YAAA;AL602C3B;;AK502CA;EAA2B,YAAA;ALg12C3B;;AK/02CA;EAA8B,YAAA;ALm12C9B;;AKl12CA;EAA8B,YAAA;ALs12C9B;;AKr12CA;EAA8B,YAAA;ALy12C9B;;AKx12CA;EAA8B,YAAA;AL412C9B;;AK312CA;EAAgC,YAAA;AL+12ChC;;AK912CA;EAAgC,YAAA;ALk22ChC;;AKj22CA;EAAgC,YAAA;ALq22ChC;;AKp22CA;EAAgC,YAAA;ALw22ChC;;AKv22CA;EAA8B,YAAA;AL222C9B;;AK122CA;EAA8B,YAAA;AL822C9B;;AK722CA;EAA6B,YAAA;ALi32C7B;;AKh32CA;EAA6B,YAAA;ALo32C7B;;AKn32CA;EAA4B,YAAA;ALu32C5B;;AKt32CA;EAA4B,YAAA;AL032C5B;;AKz32CA;EAAgC,YAAA;AL632ChC;;AK532CA;EAAgC,YAAA;ALg42ChC;;AK/32CA;EAA8B,YAAA;ALm42C9B;;AKl42CA;EAA8B,YAAA;ALs42C9B;;AKr42CA;EAA8B,YAAA;ALy42C9B;;AKx42CA;EAA8B,YAAA;AL442C9B;;AK342CA;EAA4B,YAAA;AL+42C5B;;AK942CA;EAA4B,YAAA;ALk52C5B;;AKj52CA;EAA+B,YAAA;ALq52C/B;;AKp52CA;EAA+B,YAAA;ALw52C/B;;AKv52CA;EAA8B,YAAA;AL252C9B;;AK152CA;EAA8B,YAAA;AL852C9B;;AK752CA;EAA4B,YAAA;ALi62C5B;;AKh62CA;EAA4B,YAAA;ALo62C5B;;AKn62CA;EAA2B,YAAA;ALu62C3B;;AKt62CA;EAA2B,YAAA;AL062C3B;;AKz62CA;EAAuB,YAAA;AL662CvB;;AK562CA;EAAuB,YAAA;ALg72CvB;;AK/62CA;EAA2B,YAAA;ALm72C3B;;AKl72CA;EAA2B,YAAA;ALs72C3B;;AKr72CA;EAA2B,YAAA;ALy72C3B;;AKx72CA;EAA2B,YAAA;AL472C3B;;AK372CA;EAAyB,YAAA;AL+72CzB;;AK972CA;EAAyB,YAAA;ALk82CzB;;AKj82CA;EAA6B,YAAA;ALq82C7B;;AKp82CA;EAA6B,YAAA;ALw82C7B;;AKv82CA;EAA+B,YAAA;AL282C/B;;AK182CA;EAA+B,YAAA;AL882C/B;;AK782CA;EAAyB,YAAA;ALi92CzB;;AKh92CA;EAAyB,YAAA;ALo92CzB;;AKn92CA;EAAgC,YAAA;ALu92ChC;;AKt92CA;EAAgC,YAAA;AL092ChC;;AKz92CA;EAA8B,YAAA;AL692C9B;;AK592CA;EAA8B,YAAA;ALg+2C9B;;AK/92CA;EAAuB,YAAA;ALm+2CvB;;AKl+2CA;EAAuB,YAAA;ALs+2CvB;;AKr+2CA;EAA0B,YAAA;ALy+2C1B;;AKx+2CA;EAA0B,YAAA;AL4+2C1B;;AK3+2CA;EAAgC,YAAA;AL++2ChC;;AK9+2CA;EAAgC,YAAA;ALk/2ChC;;AKj/2CA;EAAyB,YAAA;ALq/2CzB;;AKp/2CA;EAAyB,YAAA;ALw/2CzB;;AKv/2CA;EAAuB,YAAA;AL2/2CvB;;AK1/2CA;EAAuB,YAAA;AL8/2CvB;;AK7/2CA;EAA6B,YAAA;ALig3C7B;;AKhg3CA;EAA6B,YAAA;ALog3C7B;;AKng3CA;EAAwB,YAAA;ALug3CxB;;AKtg3CA;EAAwB,YAAA;AL0g3CxB;;AKzg3CA;EAA8B,YAAA;AL6g3C9B;;AK5g3CA;EAA8B,YAAA;ALgh3C9B;;AK/g3CA;EAAiC,YAAA;ALmh3CjC;;AKlh3CA;EAAiC,YAAA;ALsh3CjC;;AKrh3CA;EAAwB,YAAA;ALyh3CxB;;AKxh3CA;EAAwB,YAAA;AL4h3CxB;;AK3h3CA;EAAwB,YAAA;AL+h3CxB;;AK9h3CA;EAA0B,YAAA;ALki3C1B;;AKji3CA;EAA0B,YAAA;ALqi3C1B;;AKpi3CA;EAA0B,YAAA;ALwi3C1B;;AKvi3CA;EAA0B,YAAA;AL2i3C1B;;AK1i3CA;EAA0B,YAAA;AL8i3C1B;;AK7i3CA;EAA0B,YAAA;ALij3C1B;;AKhj3CA;EAAwB,YAAA;ALoj3CxB;;AKnj3CA;EAAwB,YAAA;ALuj3CxB;;AKtj3CA;EAAwB,YAAA;AL0j3CxB;;AKzj3CA;EAAwB,YAAA;AL6j3CxB;;AK5j3CA;EAA2B,YAAA;ALgk3C3B;;AK/j3CA;EAA2B,YAAA;ALmk3C3B;;AKlk3CA;EAA2B,YAAA;ALsk3C3B;;AKrk3CA;EAA2B,YAAA;ALyk3C3B;;AKxk3CA;EAA2B,YAAA;AL4k3C3B;;AK3k3CA;EAA2B,YAAA;AL+k3C3B;;AK9k3CA;EAA2B,YAAA;ALkl3C3B;;AKjl3CA;EAA2B,YAAA;ALql3C3B;;AKpl3CA;EAA6B,YAAA;ALwl3C7B;;AKvl3CA;EAA6B,YAAA;AL2l3C7B;;AK1l3CA;EAAiC,YAAA;AL8l3CjC;;AK7l3CA;EAAiC,YAAA;ALim3CjC;;AKhm3CA;EAA+B,YAAA;ALom3C/B;;AKnm3CA;EAA+B,YAAA;ALum3C/B;;AKtm3CA;EAAkC,YAAA;AL0m3ClC;;AKzm3CA;EAAkC,YAAA;AL6m3ClC;;AK5m3CA;EAAyB,YAAA;ALgn3CzB;;AK/m3CA;EAAgC,YAAA;ALmn3ChC;;AKln3CA;EAAgC,YAAA;ALsn3ChC;;AKrn3CA;EAAiC,YAAA;ALyn3CjC;;AKxn3CA;EAAiC,YAAA;AL4n3CjC;;AK3n3CA;EAA8B,YAAA;AL+n3C9B;;AK9n3CA;EAA8B,YAAA;ALko3C9B;;AKjo3CA;EAAiC,YAAA;ALqo3CjC;;AKpo3CA;EAAiC,YAAA;ALwo3CjC;;AKvo3CA;EAAyB,YAAA;AL2o3CzB;;AK1o3CA;EAA8B,YAAA;AL8o3C9B;;AK7o3CA;EAA8B,YAAA;ALip3C9B;;AKhp3CA;EAA+B,YAAA;ALop3C/B;;AKnp3CA;EAA+B,YAAA;ALup3C/B;;AKtp3CA;EAA8B,YAAA;AL0p3C9B;;AKzp3CA;EAA8B,YAAA;AL6p3C9B;;AK5p3CA;EAAkC,YAAA;ALgq3ClC;;AK/p3CA;EAAkC,YAAA;ALmq3ClC;;AKlq3CA;EAAgC,YAAA;ALsq3ChC;;AKrq3CA;EAAgC,YAAA;ALyq3ChC;;AKxq3CA;EAAkC,YAAA;AL4q3ClC;;AK3q3CA;EAAkC,YAAA;AL+q3ClC;;AK9q3CA;EAAgC,YAAA;ALkr3ChC;;AKjr3CA;EAAgC,YAAA;ALqr3ChC;;AKpr3CA;EAAkC,YAAA;ALwr3ClC;;AKvr3CA;EAAkC,YAAA;AL2r3ClC;;AK1r3CA;EAAgC,YAAA;AL8r3ChC;;AK7r3CA;EAAgC,YAAA;ALis3ChC;;AKhs3CA;EAAkC,YAAA;ALos3ClC;;AKns3CA;EAAkC,YAAA;ALus3ClC;;AKts3CA;EAAgC,YAAA;AL0s3ChC;;AKzs3CA;EAAgC,YAAA;AL6s3ChC;;AK5s3CA;EAAgC,YAAA;ALgt3ChC;;AK/s3CA;EAAgC,YAAA;ALmt3ChC;;AKlt3CA;EAA8B,YAAA;ALst3C9B;;AKrt3CA;EAA8B,YAAA;ALyt3C9B;;AKxt3CA;EAAiC,YAAA;AL4t3CjC;;AK3t3CA;EAAiC,YAAA;AL+t3CjC;;AK9t3CA;EAA6B,YAAA;ALku3C7B;;AKju3CA;EAA6B,YAAA;ALqu3C7B;;AKpu3CA;EAA0B,YAAA;ALwu3C1B;;AKvu3CA;EAA0B,YAAA;AL2u3C1B;;AK1u3CA;EAAwB,YAAA;AL8u3CxB;;AK7u3CA;EAAyB,YAAA;ALiv3CzB;;AKhv3CA;EAAuB,YAAA;ALov3CvB;;AKnv3CA;EAA2B,YAAA;ALuv3C3B;;AKtv3CA;EAA2B,YAAA;AL0v3C3B;;AKzv3CA;EAA4B,YAAA;AL6v3C5B;;AK5v3CA;EAA4B,YAAA;ALgw3C5B;;AK/v3CA;EAA2B,YAAA;ALmw3C3B;;AKlw3CA;EAA2B,YAAA;ALsw3C3B;;AKrw3CA;EAAyB,YAAA;ALyw3CzB;;AKxw3CA;EAAyB,YAAA;AL4w3CzB;;AK3w3CA;EAA0B,YAAA;AL+w3C1B;;AK9w3CA;EAAyB,YAAA;ALkx3CzB;;AKjx3CA;EAAyB,YAAA;ALqx3CzB;;AKpx3CA;EAAkC,YAAA;ALwx3ClC;;AKvx3CA;EAAkC,YAAA;AL2x3ClC;;AK1x3CA;EAA6B,YAAA;AL8x3C7B;;AK7x3CA;EAA6B,YAAA;ALiy3C7B;;AKhy3CA;EAA2B,YAAA;ALoy3C3B;;AKny3CA;EAA2B,YAAA;ALuy3C3B;;AKty3CA;EAAuB,YAAA;AL0y3CvB;;AKzy3CA;EAA4B,YAAA;AL6y3C5B;;AK5y3CA;EAA4B,YAAA;ALgz3C5B;;AK/y3CA;EAAwB,YAAA;ALmz3CxB;;AKlz3CA;EAAwB,YAAA;ALsz3CxB;;AKrz3CA;EAA0B,YAAA;ALyz3C1B;;AKxz3CA;EAA0B,YAAA;AL4z3C1B;;AK3z3CA;EAAiC,YAAA;AL+z3CjC;;AK9z3CA;EAAiC,YAAA;ALk03CjC;;AKj03CA;EAAuB,YAAA;ALq03CvB;;AKp03CA;EAAuB,YAAA;ALw03CvB;;AKv03CA;EAA0B,YAAA;AL203C1B;;AK103CA;EAA0B,YAAA;AL803C1B;;AK703CA;EAA8B,YAAA;ALi13C9B;;AKh13CA;EAA8B,YAAA;ALo13C9B;;AKn13CA;EAAyB,YAAA;ALu13CzB;;AKt13CA;EAAyB,YAAA;AL013CzB;;AKz13CA;EAA6B,YAAA;AL613C7B;;AK513CA;EAA6B,YAAA;ALg23C7B;;AK/13CA;EAA0B,YAAA;ALm23C1B;;AKl23CA;EAA0B,YAAA;ALs23C1B;;AKr23CA;EAAwB,YAAA;ALy23CxB;;AKx23CA;EAAwB,YAAA;AL423CxB;;AK323CA;EAA8B,YAAA;AL+23C9B;;AK923CA;EAA8B,YAAA;ALk33C9B;;AKj33CA;EAAyB,YAAA;ALq33CzB;;AKp33CA;EAAyB,YAAA;ALw33CzB;;AKv33CA;EAAuB,YAAA;AL233CvB;;AK133CA;EAAuB,YAAA;AL833CvB;;AK733CA;EAA6B,YAAA;ALi43C7B;;AKh43CA;EAA6B,YAAA;ALo43C7B;;AKn43CA;EAA6B,YAAA;ALu43C7B;;AKt43CA;EAA6B,YAAA;AL043C7B;;AKz43CA;EAA4B,YAAA;AL643C5B;;AK543CA;EAA4B,YAAA;ALg53C5B;;AK/43CA;EAAmC,YAAA;ALm53CnC;;AKl53CA;EAAmC,YAAA;ALs53CnC;;AKr53CA;EAAyC,YAAA;ALy53CzC;;AKx53CA;EAAyC,YAAA;AL453CzC;;AK353CA;EAAiC,YAAA;AL+53CjC;;AK953CA;EAAiC,YAAA;ALk63CjC;;AKj63CA;EAAyC,YAAA;ALq63CzC;;AKp63CA;EAAyC,YAAA;ALw63CzC;;AKv63CA;EAAyB,YAAA;AL263CzB;;AK163CA;EAAyB,YAAA;AL863CzB;;AK763CA;EAAyB,YAAA;ALi73CzB;;AKh73CA;EAAyB,YAAA;ALo73CzB;;AKn73CA;EAAyB,YAAA;ALu73CzB;;AKt73CA;EAAyB,YAAA;AL073CzB;;AKz73CA;EAAwB,YAAA;AL673CxB;;AK573CA;EAAwB,YAAA;ALg83CxB;;AK/73CA;EAAyB,YAAA;ALm83CzB;;AKl83CA;EAAyB,YAAA;ALs83CzB;;AKr83CA;EAAyB,YAAA;ALy83CzB;;AKx83CA;EAAyB,YAAA;AL483CzB;;AK383CA;EAA8B,YAAA;AL+83C9B;;AK983CA;EAA8B,YAAA;ALk93C9B;;AKj93CA;EAA6B,YAAA;ALq93C7B;;AKp93CA;EAA6B,YAAA;ALw93C7B;;AKv93CA;EAAsB,YAAA;AL293CtB;;AK193CA;EAAsB,YAAA;AL893CtB;;AK793CA;EAA6B,YAAA;ALi+3C7B;;AKh+3CA;EAA6B,YAAA;ALo+3C7B;;AKn+3CA;EAAuB,YAAA;ALu+3CvB;;AKt+3CA;EAAuB,YAAA;AL0+3CvB;;AKz+3CA;EAA0B,YAAA;AL6+3C1B;;AK5+3CA;EAA0B,YAAA;ALg/3C1B;;AK/+3CA;EAAwB,YAAA;ALm/3CxB;;AKl/3CA;EAAwB,YAAA;ALs/3CxB;;AKr/3CA;EAAwB,YAAA;ALy/3CxB;;AKx/3CA;EAAwB,YAAA;AL4/3CxB;;AK3/3CA;EAAiB,YAAA;AL+/3CjB;;AK9/3CA;EAAiB,YAAA;ALkg4CjB;;AKjg4CA;EAAiB,YAAA;ALqg4CjB;;AKpg4CA;EAAiB,YAAA;ALwg4CjB;;AKvg4CA;EAAiB,YAAA;AL2g4CjB;;AK1g4CA;EAAiB,YAAA;AL8g4CjB;;AK7g4CA;EAAuB,YAAA;ALih4CvB;;AKhh4CA;EAAuB,YAAA;ALoh4CvB;;AKnh4CA;EAAyB,YAAA;ALuh4CzB;;AKth4CA;EAAyB,YAAA;AL0h4CzB;;AKzh4CA;EAA4B,YAAA;AL6h4C5B;;AK5h4CA;EAA4B,YAAA;ALgi4C5B;;AK/h4CA;EAA6B,YAAA;ALmi4C7B;;AKli4CA;EAA6B,YAAA;ALsi4C7B;;AKri4CA;EAAiC,YAAA;ALyi4CjC;;AKxi4CA;EAAiC,YAAA;AL4i4CjC;;AK3i4CA;EAA0B,YAAA;AL+i4C1B;;AK9i4CA;EAA0B,YAAA;ALkj4C1B;;AKjj4CA;EAA+B,YAAA;ALqj4C/B;;AKpj4CA;EAA+B,YAAA;ALwj4C/B;;AKvj4CA;EAA6B,YAAA;AL2j4C7B;;AK1j4CA;EAA6B,YAAA;AL8j4C7B;;AK7j4CA;EAAqB,YAAA;ALik4CrB;;AKhk4CA;EAAyB,YAAA;ALok4CzB;;AKnk4CA;EAAyB,YAAA;ALuk4CzB;;AKtk4CA;EAAuB,YAAA;AL0k4CvB;;AKzk4CA;EAAuB,YAAA;AL6k4CvB;;AK5k4CA;EAAqB,YAAA;ALgl4CrB;;AK/k4CA;EAAqB,YAAA;ALml4CrB;;AKll4CA;EAAqB,YAAA;ALsl4CrB;;AKrl4CA;EAA4B,YAAA;ALyl4C5B;;AKxl4CA;EAA4B,YAAA;AL4l4C5B;;AK3l4CA;EAA8B,YAAA;AL+l4C9B;;AK9l4CA;EAA8B,YAAA;ALkm4C9B;;AKjm4CA;EAA0B,YAAA;ALqm4C1B;;AKpm4CA;EAA0B,YAAA;ALwm4C1B;;AKvm4CA;EAA0B,YAAA;AL2m4C1B;;AK1m4CA;EAA0B,YAAA;AL8m4C1B;;AK7m4CA;EAA4B,YAAA;ALin4C5B;;AKhn4CA;EAA4B,YAAA;ALon4C5B;;AKnn4CA;EAAwB,YAAA;ALun4CxB;;AKtn4CA;EAAwB,YAAA;AL0n4CxB;;AKzn4CA;EAA8B,YAAA;AL6n4C9B;;AK5n4CA;EAA8B,YAAA;ALgo4C9B;;AK/n4CA;EAAyB,YAAA;ALmo4CzB;;AKlo4CA;EAAyB,YAAA;ALso4CzB;;AKro4CA;EAAgC,YAAA;ALyo4ChC;;AKxo4CA;EAAgC,YAAA;AL4o4ChC;;AK3o4CA;EAA0B,YAAA;AL+o4C1B;;AK9o4CA;EAA0B,YAAA;ALkp4C1B;;AKjp4CA;EAAyB,YAAA;ALqp4CzB;;AKpp4CA;EAAyB,YAAA;ALwp4CzB;;AKvp4CA;EAAyB,YAAA;AL2p4CzB;;AK1p4CA;EAAyB,YAAA;AL8p4CzB;;AK7p4CA;EAAyB,YAAA;ALiq4CzB;;AKhq4CA;EAAyB,YAAA;ALoq4CzB;;AKnq4CA;EAAyB,YAAA;ALuq4CzB;;AKtq4CA;EAAyB,YAAA;AL0q4CzB;;AKzq4CA;EAAyB,YAAA;AL6q4CzB;;AK5q4CA;EAAyB,YAAA;ALgr4CzB;;AK/q4CA;EAAyB,YAAA;ALmr4CzB;;AKlr4CA;EAAyB,YAAA;ALsr4CzB;;AKrr4CA;EAAyB,YAAA;ALyr4CzB;;AKxr4CA;EAAyB,YAAA;AL4r4CzB;;AK3r4CA;EAAuB,YAAA;AL+r4CvB;;AK9r4CA;EAA4B,YAAA;ALks4C5B;;AKjs4CA;EAA4B,YAAA;ALqs4C5B;;AKps4CA;EAA6B,YAAA;ALws4C7B;;AKvs4CA;EAA6B,YAAA;AL2s4C7B;;AK1s4CA;EAAuB,YAAA;AL8s4CvB;;AK7s4CA;EAA+B,YAAA;ALit4C/B;;AKht4CA;EAA+B,YAAA;ALot4C/B;;AKnt4CA;EAA6B,YAAA;ALut4C7B;;AKtt4CA;EAA6B,YAAA;AL0t4C7B;;AKzt4CA;EAA4B,YAAA;AL6t4C5B;;AK5t4CA;EAA4B,YAAA;ALgu4C5B;;AK/t4CA;EAAiC,YAAA;ALmu4CjC;;AKlu4CA;EAAiC,YAAA;ALsu4CjC;;AKru4CA;EAAyB,YAAA;ALyu4CzB;;AKxu4CA;EAAyB,YAAA;AL4u4CzB;;AK3u4CA;EAA2B,YAAA;AL+u4C3B;;AK9u4CA;EAA2B,YAAA;ALkv4C3B;;AKjv4CA;EAA4B,YAAA;ALqv4C5B;;AKpv4CA;EAA4B,YAAA;ALwv4C5B;;AKvv4CA;EAAwB,YAAA;AL2v4CxB;;AK1v4CA;EAAwB,YAAA;AL8v4CxB;;AK7v4CA;EAA0B,YAAA;ALiw4C1B;;AKhw4CA;EAA0B,YAAA;ALow4C1B;;AKnw4CA;EAAqB,YAAA;ALuw4CrB;;AKtw4CA;EAAqB,YAAA;AL0w4CrB;;AKzw4CA;EAAwB,YAAA;AL6w4CxB;;AK5w4CA;EAAwB,YAAA;ALgx4CxB;;AK/w4CA;EAAqB,YAAA;ALmx4CrB;;AKlx4CA;EAAqB,YAAA;ALsx4CrB;;AKrx4CA;EAA0B,YAAA;ALyx4C1B;;AKxx4CA;EAA0B,YAAA;AL4x4C1B;;AK3x4CA;EAA4B,YAAA;AL+x4C5B;;AK9x4CA;EAA4B,YAAA;ALky4C5B;;AKjy4CA;EAA6B,YAAA;ALqy4C7B;;AKpy4CA;EAA6B,YAAA;ALwy4C7B;;AKvy4CA;EAAwB,YAAA;AL2y4CxB;;AK1y4CA;EAAwB,YAAA;AL8y4CxB;;AK7y4CA;EAAgC,YAAA;ALiz4ChC;;AKhz4CA;EAAgC,YAAA;ALoz4ChC;;AKnz4CA;EAAwB,YAAA;ALuz4CxB;;AKtz4CA;EAAwB,YAAA;AL0z4CxB;;AKzz4CA;EAAkC,YAAA;AL6z4ClC;;AK5z4CA;EAAkC,YAAA;ALg04ClC;;AK/z4CA;EAAoC,YAAA;ALm04CpC;;AKl04CA;EAAoC,YAAA;ALs04CpC;;AKr04CA;EAA6B,YAAA;ALy04C7B;;AKx04CA;EAA6B,YAAA;AL404C7B;;AK304CA;EAAuC,YAAA;AL+04CvC;;AK904CA;EAAuC,YAAA;ALk14CvC;;AKj14CA;EAA8B,YAAA;ALq14C9B;;AKp14CA;EAA8B,YAAA;ALw14C9B;;AKv14CA;EAAuC,YAAA;AL214CvC;;AK114CA;EAAuC,YAAA;AL814CvC;;AK714CA;EAA6B,YAAA;ALi24C7B;;AKh24CA;EAA6B,YAAA;ALo24C7B;;AKn24CA;EAA+B,YAAA;ALu24C/B;;AKt24CA;EAA+B,YAAA;AL024C/B;;AKz24CA;EAA+B,YAAA;AL624C/B;;AK524CA;EAAgC,YAAA;ALg34ChC;;AK/24CA;EAAiC,YAAA;ALm34CjC;;AKl34CA;EAA+B,YAAA;ALs34C/B;;AKr34CA;EAA4B,YAAA;ALy34C5B;;AKx34CA;EAA4B,YAAA;AL434C5B;;AK334CA;EAA4B,YAAA;AL+34C5B;;AK934CA;EAA0B,YAAA;ALk44C1B;;AKj44CA;EAA0B,YAAA;ALq44C1B;;AKp44CA;EAA2B,YAAA;ALw44C3B;;AKv44CA;EAA2B,YAAA;AL244C3B;;AK144CA;EAAoB,YAAA;AL844CpB;;AK744CA;EAA6B,YAAA;ALi54C7B;;AKh54CA;EAA6B,YAAA;ALo54C7B;;AKn54CA;EAAwB,YAAA;ALu54CxB;;AKt54CA;EAAwB,YAAA;AL054CxB;;AKz54CA;EAAsB,YAAA;AL654CtB;;AK554CA;EAAsB,YAAA;ALg64CtB;;AK/54CA;EAA+B,YAAA;ALm64C/B;;AKl64CA;EAA+B,YAAA;ALs64C/B;;AKr64CA;EAA2B,YAAA;ALy64C3B;;AKx64CA;EAA2B,YAAA;AL464C3B;;AK364CA;EAA0B,YAAA;AL+64C1B;;AK964CA;EAA0B,YAAA;ALk74C1B;;AKj74CA;EAA8B,YAAA;ALq74C9B;;AKp74CA;EAA8B,YAAA;ALw74C9B;;AKv74CA;EAAwB,YAAA;AL274CxB;;AK174CA;EAAwB,YAAA;AL874CxB;;AK774CA;EAA4B,YAAA;ALi84C5B;;AKh84CA;EAA4B,YAAA;ALo84C5B;;AKn84CA;EAA2B,YAAA;ALu84C3B;;AKt84CA;EAA2B,YAAA;AL084C3B;;AKz84CA;EAA2B,YAAA;AL684C3B;;AK584CA;EAA2B,YAAA;ALg94C3B;;AK/84CA;EAA2B,YAAA;ALm94C3B;;AKl94CA;EAA2B,YAAA;ALs94C3B;;AKr94CA;EAA2B,YAAA;ALy94C3B;;AKx94CA;EAA2B,YAAA;AL494C3B;;AK394CA;EAA2B,YAAA;AL+94C3B;;AK994CA;EAA2B,YAAA;ALk+4C3B;;AKj+4CA;EAAkC,YAAA;ALq+4ClC;;AKp+4CA;EAAkC,YAAA;ALw+4ClC;;AKv+4CA;EAAgC,YAAA;AL2+4ChC;;AK1+4CA;EAAgC,YAAA;AL8+4ChC;;AK7+4CA;EAAgC,YAAA;ALi/4ChC;;AKh/4CA;EAAgC,YAAA;ALo/4ChC;;AKn/4CA;EAAyB,YAAA;ALu/4CzB;;AKt/4CA;EAA8B,YAAA;AL0/4C9B;;AKz/4CA;EAA8B,YAAA;AL6/4C9B;;AK5/4CA;EAAgC,YAAA;ALgg5ChC;;AK//4CA;EAAgC,YAAA;ALmg5ChC;;AKlg5CA;EAA8B,YAAA;ALsg5C9B;;AKrg5CA;EAA8B,YAAA;ALyg5C9B;;AKxg5CA;EAAyB,YAAA;AL4g5CzB;;AK3g5CA;EAAiC,YAAA;AL+g5CjC;;AK9g5CA;EAAiC,YAAA;ALkh5CjC;;AKjh5CA;EAAiC,YAAA;ALqh5CjC;;AKph5CA;EAAiC,YAAA;ALwh5CjC;;AKvh5CA;EAA+B,YAAA;AL2h5C/B;;AK1h5CA;EAA+B,YAAA;AL8h5C/B;;AK7h5CA;EAA6B,YAAA;ALii5C7B;;AKhi5CA;EAA6B,YAAA;ALoi5C7B;;AKni5CA;EAA+B,YAAA;ALui5C/B;;AKti5CA;EAA+B,YAAA;AL0i5C/B;;AKzi5CA;EAA6B,YAAA;AL6i5C7B;;AK5i5CA;EAA6B,YAAA;ALgj5C7B;;AK/i5CA;EAAuB,YAAA;ALmj5CvB;;AKlj5CA;EAAuB,YAAA;ALsj5CvB;;AKrj5CA;EAA2B,YAAA;ALyj5C3B;;AKxj5CA;EAA2B,YAAA;AL4j5C3B;;AK3j5CA;EAA4B,YAAA;AL+j5C5B;;AK9j5CA;EAAkC,YAAA;ALkk5ClC;;AKjk5CA;EAAkC,YAAA;ALqk5ClC;;AKpk5CA;EAA4B,YAAA;ALwk5C5B;;AKvk5CA;EAA6B,YAAA;AL2k5C7B;;AK1k5CA;EAA6B,YAAA;AL8k5C7B;;AK7k5CA;EAAuB,YAAA;ALil5CvB;;AKhl5CA;EAAyB,YAAA;ALol5CzB;;AKnl5CA;EAAuB,YAAA;ALul5CvB;;AKtl5CA;EAAoB,YAAA;AL0l5CpB;;AKzl5CA;EAA2B,YAAA;AL6l5C3B;;AK5l5CA;EAAyB,YAAA;ALgm5CzB;;AK/l5CA;EAAkB,YAAA;ALmm5ClB;;AKlm5CA;EAA+B,YAAA;ALsm5C/B;;AKrm5CA;EAA+B,YAAA;ALym5C/B;;AKxm5CA;EAA2B,YAAA;AL4m5C3B;;AK3m5CA;EAA2B,YAAA;AL+m5C3B;;AK9m5CA;EAAwB,YAAA;ALkn5CxB;;AKjn5CA;EAAwB,YAAA;ALqn5CxB;;AKpn5CA;EAA0B,YAAA;ALwn5C1B;;AKvn5CA;EAAwB,YAAA;AL2n5CxB;;AK1n5CA;EAA0B,YAAA;AL8n5C1B;;AK7n5CA;EAAgC,YAAA;ALio5ChC;;AKho5CA;EAAgC,YAAA;ALoo5ChC;;AKno5CA;EAA4B,YAAA;ALuo5C5B;;AKto5CA;EAAuB,YAAA;AL0o5CvB;;AKzo5CA;EAAuB,YAAA;AL6o5CvB;;AK5o5CA;EAA2B,YAAA;ALgp5C3B;;AK/o5CA;EAA2B,YAAA;ALmp5C3B;;AKlp5CA;EAA2B,YAAA;ALsp5C3B;;AKrp5CA;EAA2B,YAAA;ALyp5C3B;;AKxp5CA;EAA2B,YAAA;AL4p5C3B;;AK3p5CA;EAA2B,YAAA;AL+p5C3B;;AK9p5CA;EAA2B,YAAA;ALkq5C3B;;AKjq5CA;EAA2B,YAAA;ALqq5C3B;;AKpq5CA;EAAyB,YAAA;ALwq5CzB;;AKvq5CA;EAAyB,YAAA;AL2q5CzB;;AK1q5CA;EAAyB,YAAA;AL8q5CzB;;AK7q5CA;EAAyB,YAAA;ALir5CzB;;AKhr5CA;EAAuB,YAAA;ALor5CvB;;AKnr5CA;EAAuB,YAAA;ALur5CvB;;AKtr5CA;EAAgC,YAAA;AL0r5ChC;;AKzr5CA;EAAgC,YAAA;AL6r5ChC;;AK5r5CA;EAA8B,YAAA;ALgs5C9B;;AK/r5CA;EAA8B,YAAA;ALms5C9B;;AKls5CA;EAA4B,YAAA;ALss5C5B;;AKrs5CA;EAA4B,YAAA;ALys5C5B;;AKxs5CA;EAA+B,YAAA;AL4s5C/B;;AK3s5CA;EAA+B,YAAA;AL+s5C/B;;AK9s5CA;EAA6B,YAAA;ALkt5C7B;;AKjt5CA;EAA6B,YAAA;ALqt5C7B;;AKpt5CA;EAA+B,YAAA;ALwt5C/B;;AKvt5CA;EAA+B,YAAA;AL2t5C/B;;AK1t5CA;EAAgC,YAAA;AL8t5ChC;;AK7t5CA;EAAgC,YAAA;ALiu5ChC;;AKhu5CA;EAAkC,YAAA;ALou5ClC;;AKnu5CA;EAAkC,YAAA;ALuu5ClC;;AKtu5CA;EAA+B,YAAA;AL0u5C/B;;AKzu5CA;EAA+B,YAAA;AL6u5C/B;;AK5u5CA;EAAkC,YAAA;ALgv5ClC;;AK/u5CA;EAAkC,YAAA;ALmv5ClC;;AKlv5CA;EAAwB,YAAA;ALsv5CxB;;AKrv5CA;EAAwB,YAAA;ALyv5CxB;;AKxv5CA;EAAsB,YAAA;AL4v5CtB;;AK3v5CA;EAAsB,YAAA;AL+v5CtB;;AK9v5CA;EAA0B,YAAA;ALkw5C1B;;AKjw5CA;EAA0B,YAAA;ALqw5C1B;;AKpw5CA;EAAwB,YAAA;ALww5CxB;;AKvw5CA;EAAwB,YAAA;AL2w5CxB;;AK1w5CA;EAA2B,YAAA;AL8w5C3B;;AK7w5CA;EAA2B,YAAA;ALix5C3B;;AKhx5CA;EAA6B,YAAA;ALox5C7B;;AKnx5CA;EAA6B,YAAA;ALux5C7B;;AKtx5CA;EAA6B,YAAA;AL0x5C7B;;AKzx5CA;EAA6B,YAAA;AL6x5C7B;;AK5x5CA;EAAgC,YAAA;ALgy5ChC;;AK/x5CA;EAAgC,YAAA;ALmy5ChC;;AKly5CA;EAAuB,YAAA;ALsy5CvB;;AKry5CA;EAA8B,YAAA;ALyy5C9B;;AKxy5CA;EAA8B,YAAA;AL4y5C9B;;AK3y5CA;EAAuB,YAAA;AL+y5CvB;;AK9y5CA;EAA4B,YAAA;ALkz5C5B;;AKjz5CA;EAA4B,YAAA;ALqz5C5B;;AKpz5CA;EAA4B,YAAA;ALwz5C5B;;AKvz5CA;EAA4B,YAAA;AL2z5C5B;;AK1z5CA;EAA4B,YAAA;AL8z5C5B;;AK7z5CA;EAA4B,YAAA;ALi05C5B;;AKh05CA;EAAgC,YAAA;ALo05ChC;;AKn05CA;EAAgC,YAAA;ALu05ChC;;AKt05CA;EAA4B,YAAA;AL005C5B;;AKz05CA;EAA4B,YAAA;AL605C5B;;AK505CA;EAA8B,YAAA;ALg15C9B;;AK/05CA;EAA8B,YAAA;ALm15C9B;;AKl15CA;EAA8B,YAAA;ALs15C9B;;AKr15CA;EAA8B,YAAA;ALy15C9B;;AKx15CA;EAAwB,YAAA;AL415CxB;;AK315CA;EAAwB,YAAA;AL+15CxB;;AK915CA;EAAsB,YAAA;ALk25CtB;;AKj25CA;EAAsB,YAAA;ALq25CtB;;AKp25CA;EAA4B,YAAA;ALw25C5B;;AKv25CA;EAA4B,YAAA;AL225C5B;;AK125CA;EAA4B,YAAA;AL825C5B;;AK725CA;EAA4B,YAAA;ALi35C5B;;AKh35CA;EAA4B,YAAA;ALo35C5B;;AKn35CA;EAA4B,YAAA;ALu35C5B;;AKt35CA;EAA4B,YAAA;AL035C5B;;AKz35CA;EAA4B,YAAA;AL635C5B;;AK535CA;EAA8B,YAAA;ALg45C9B;;AK/35CA;EAA8B,YAAA;ALm45C9B;;AKl45CA;EAA0B,YAAA;ALs45C1B;;AKr45CA;EAA0B,YAAA;ALy45C1B;;AKx45CA;EAAgC,YAAA;AL445ChC;;AK345CA;EAAgC,YAAA;AL+45ChC;;AK945CA;EAA+B,YAAA;ALk55C/B;;AKj55CA;EAA+B,YAAA;ALq55C/B;;AKp55CA;EAA+B,YAAA;ALw55C/B;;AKv55CA;EAA+B,YAAA;AL255C/B;;AK155CA;EAA2B,YAAA;AL855C3B;;AK755CA;EAA2B,YAAA;ALi65C3B;;AKh65CA;EAA2B,YAAA;ALo65C3B;;AKn65CA;EAA2B,YAAA;ALu65C3B;;AKt65CA;EAAyB,YAAA;AL065CzB;;AKz65CA;EAAyB,YAAA;AL665CzB;;AK565CA;EAA6B,YAAA;ALg75C7B;;AK/65CA;EAA6B,YAAA;ALm75C7B;;AKl75CA;EAA2B,YAAA;ALs75C3B;;AKr75CA;EAA2B,YAAA;ALy75C3B;;AKx75CA;EAA0B,YAAA;AL475C1B;;AK375CA;EAA0B,YAAA;AL+75C1B;;AK975CA;EAAwB,YAAA;ALk85CxB;;AKj85CA;EAAwB,YAAA;ALq85CxB;;AKp85CA;EAAkC,YAAA;ALw85ClC;;AKv85CA;EAAkC,YAAA;AL285ClC;;AK185CA;EAAyB,YAAA;AL885CzB;;AK785CA;EAAyB,YAAA;ALi95CzB;;AKh95CA;EAAsB,YAAA;ALo95CtB;;AKn95CA;EAAsB,YAAA;ALu95CtB;;AKt95CA;EAAgC,YAAA;AL095ChC;;AKz95CA;EAAgC,YAAA;AL695ChC;;AK595CA;EAAyB,YAAA;ALg+5CzB;;AK/95CA;EAAyB,YAAA;ALm+5CzB;;AKl+5CA;EAAyB,YAAA;ALs+5CzB;;AKr+5CA;EAAyB,YAAA;ALy+5CzB;;AKx+5CA;EAAyB,YAAA;AL4+5CzB;;AK3+5CA;EAAyB,YAAA;AL++5CzB;;AK9+5CA;EAAyB,YAAA;ALk/5CzB;;AKj/5CA;EAAyB,YAAA;ALq/5CzB;;AKp/5CA;EAA2B,YAAA;ALw/5C3B;;AKv/5CA;EAA2B,YAAA;AL2/5C3B;;AK1/5CA;EAAuB,YAAA;AL8/5CvB;;AK7/5CA;EAA4B,YAAA;ALig6C5B;;AKhg6CA;EAA4B,YAAA;ALog6C5B;;AKng6CA;EAAuB,YAAA;ALug6CvB;;AKtg6CA;EAA8B,YAAA;AL0g6C9B;;AKzg6CA;EAA8B,YAAA;AL6g6C9B;;AK5g6CA;EAAoC,YAAA;ALgh6CpC;;AK/g6CA;EAAkC,YAAA;ALmh6ClC;;AKlh6CA;EAA4B,YAAA;ALsh6C5B;;AKrh6CA;EAA4B,YAAA;ALyh6C5B;;AKxh6CA;EAA4B,YAAA;AL4h6C5B;;AK3h6CA;EAA4B,YAAA;AL+h6C5B;;AK9h6CA;EAA0B,YAAA;ALki6C1B;;AKji6CA;EAA0B,YAAA;ALqi6C1B;;AKpi6CA;EAA4B,YAAA;ALwi6C5B;;AKvi6CA;EAA4B,YAAA;AL2i6C5B;;AK1i6CA;EAAyB,YAAA;AL8i6CzB;;AK7i6CA;EAAyB,YAAA;ALij6CzB;;AKhj6CA;EAAwB,YAAA;ALoj6CxB;;AKnj6CA;EAAwB,YAAA;ALuj6CxB;;AKtj6CA;EAAsB,YAAA;AL0j6CtB;;AKzj6CA;EAAsB,YAAA;AL6j6CtB;;AK5j6CA;EAA0B,YAAA;ALgk6C1B;;AK/j6CA;EAA0B,YAAA;ALmk6C1B;;AKlk6CA;EAAyB,YAAA;ALsk6CzB;;AKrk6CA;EAAyB,YAAA;ALyk6CzB;;AKxk6CA;EAA6B,YAAA;AL4k6C7B;;AK3k6CA;EAA6B,YAAA;AL+k6C7B;;AK9k6CA;EAA4B,YAAA;ALkl6C5B;;AKjl6CA;EAA4B,YAAA;ALql6C5B;;AKpl6CA;EAAsB,YAAA;ALwl6CtB;;AKvl6CA;EAA+B,YAAA;AL2l6C/B;;AK1l6CA;EAA+B,YAAA;AL8l6C/B;;AK7l6CA;EAAuB,YAAA;ALim6CvB;;AKhm6CA;EAAuB,YAAA;ALom6CvB;;AKnm6CA;EAAgC,YAAA;ALum6ChC;;AKtm6CA;EAAgC,YAAA;AL0m6ChC;;AKzm6CA;EAAmC,YAAA;AL6m6CnC;;AK5m6CA;EAAmC,YAAA;ALgn6CnC;;AK/m6CA;EAAmC,YAAA;ALmn6CnC;;AKln6CA;EAAmC,YAAA;ALsn6CnC;;AKrn6CA;EAAsC,YAAA;ALyn6CtC;;AKxn6CA;EAAsC,YAAA;AL4n6CtC;;AK3n6CA;EAAiC,YAAA;AL+n6CjC;;AK9n6CA;EAAiC,YAAA;ALko6CjC;;AKjo6CA;EAAoC,YAAA;ALqo6CpC;;AKpo6CA;EAAoC,YAAA;ALwo6CpC;;AKvo6CA;EAAkC,YAAA;AL2o6ClC;;AK1o6CA;EAAkC,YAAA;AL8o6ClC;;AK7o6CA;EAAqC,YAAA;ALip6CrC;;AKhp6CA;EAAqC,YAAA;ALop6CrC;;AKnp6CA;EAA6B,YAAA;ALup6C7B;;AKtp6CA;EAA6B,YAAA;AL0p6C7B;;AKzp6CA;EAA8B,YAAA;AL6p6C9B;;AK5p6CA;EAA8B,YAAA;ALgq6C9B;;AK/p6CA;EAAuB,YAAA;ALmq6CvB;;AKlq6CA;EAA6B,YAAA;ALsq6C7B;;AKrq6CA;EAA6B,YAAA;ALyq6C7B;;AKxq6CA;EAAuB,YAAA;AL4q6CvB;;AK3q6CA;EAAyB,YAAA;AL+q6CzB;;AK9q6CA;EAAyB,YAAA;ALkr6CzB;;AKjr6CA;EAAuB,YAAA;ALqr6CvB;;AKpr6CA;EAAuB,YAAA;ALwr6CvB;;AKvr6CA;EAA4B,YAAA;AL2r6C5B;;AK1r6CA;EAA4B,YAAA;AL8r6C5B;;AK7r6CA;EAAwB,YAAA;ALis6CxB;;AKhs6CA;EAAwB,YAAA;ALos6CxB;;AKns6CA;EAA0B,YAAA;ALus6C1B;;AKts6CA;EAA0B,YAAA;AL0s6C1B;;AKzs6CA;EAAwB,YAAA;AL6s6CxB;;AK5s6CA;EAAwB,YAAA;ALgt6CxB;;AK/s6CA;EAA0B,YAAA;ALmt6C1B;;AKlt6CA;EAA0B,YAAA;ALst6C1B;;AKrt6CA;EAAwB,YAAA;ALyt6CxB;;AKxt6CA;EAAwB,YAAA;AL4t6CxB;;AK3t6CA;EAAqB,YAAA;AL+t6CrB;;AK9t6CA;EAAqB,YAAA;ALku6CrB;;AKju6CA;EAA6B,YAAA;ALqu6C7B;;AKpu6CA;EAA6B,YAAA;ALwu6C7B;;AKvu6CA;EAAsC,YAAA;AL2u6CtC;;AK1u6CA;EAAsC,YAAA;AL8u6CtC;;AK7u6CA;EAA0B,YAAA;ALiv6C1B;;AKhv6CA;EAA0B,YAAA;ALov6C1B;;AKnv6CA;EAA4B,YAAA;ALuv6C5B;;AKtv6CA;EAA4B,YAAA;AL0v6C5B;;AKzv6CA;EAAuB,YAAA;AL6v6CvB;;AK5v6CA;EAAiC,YAAA;ALgw6CjC;;AK/v6CA;EAAiC,YAAA;ALmw6CjC;;AKlw6CA;EAAiC,YAAA;ALsw6CjC;;AKrw6CA;EAAiC,YAAA;ALyw6CjC;;AKxw6CA;EAAiC,YAAA;AL4w6CjC;;AK3w6CA;EAAiC,YAAA;AL+w6CjC;;AK9w6CA;EAAqC,YAAA;ALkx6CrC;;AKjx6CA;EAAqC,YAAA;ALqx6CrC;;AKpx6CA;EAA+B,YAAA;ALwx6C/B;;AKvx6CA;EAA+B,YAAA;AL2x6C/B;;AK1x6CA;EAAmC,YAAA;AL8x6CnC;;AK7x6CA;EAAmC,YAAA;ALiy6CnC;;AKhy6CA;EAAwB,YAAA;ALoy6CxB;;AKny6CA;EAAwB,YAAA;ALuy6CxB;;AKty6CA;EAAsB,YAAA;AL0y6CtB;;AKzy6CA;EAAsB,YAAA;AL6y6CtB;;AK5y6CA;EAAsB,YAAA;ALgz6CtB;;AK/y6CA;EAAsB,YAAA;ALmz6CtB;;AKlz6CA;EAAsB,YAAA;ALsz6CtB;;AKrz6CA;EAAsB,YAAA;ALyz6CtB;;AKxz6CA;EAAsB,YAAA;AL4z6CtB;;AK3z6CA;EAAsB,YAAA;AL+z6CtB;;AK9z6CA;EAAsB,YAAA;ALk06CtB;;AKj06CA;EAAsB,YAAA;ALq06CtB;;AKp06CA;EAA0B,YAAA;ALw06C1B;;AKv06CA;EAA0B,YAAA;AL206C1B;;AK106CA;EAAwB,YAAA;AL806CxB;;AK706CA;EAAwB,YAAA;ALi16CxB;;AKh16CA;EAAsB,YAAA;ALo16CtB;;AKn16CA;EAAsB,YAAA;ALu16CtB;;AKt16CA;EAAmB,YAAA;AL016CnB;;AKz16CA;EAA2B,YAAA;AL616C3B;;AK516CA;EAA2B,YAAA;ALg26C3B;;AK/16CA;EAA8B,YAAA;ALm26C9B;;AKl26CA;EAA8B,YAAA;ALs26C9B;;AKr26CA;EAAwB,YAAA;ALy26CxB;;AKx26CA;EAAwB,YAAA;AL426CxB;;AK326CA;EAA6B,YAAA;AL+26C7B;;AK926CA;EAA6B,YAAA;ALk36C7B;;AKj36CA;EAAgC,YAAA;ALq36ChC;;AKp36CA;EAA2B,YAAA;ALw36C3B;;AKv36CA;EAA2B,YAAA;AL236C3B;;AK136CA;EAAyB,YAAA;AL836CzB;;AK736CA;EAAyB,YAAA;ALi46CzB;;AKh46CA;EAA4B,YAAA;ALo46C5B;;AKn46CA;EAAwB,YAAA;ALu46CxB;;AKt46CA;EAAwB,YAAA;AL046CxB;;AKz46CA;EAA8B,YAAA;AL646C9B;;AK546CA;EAA8B,YAAA;ALg56C9B;;AK/46CA;EAAwB,YAAA;ALm56CxB;;AKl56CA;EAAwB,YAAA;ALs56CxB;;AKr56CA;EAA0B,YAAA;ALy56C1B;;AKx56CA;EAA0B,YAAA;AL456C1B;;AK356CA;EAA0B,YAAA;AL+56C1B;;AK956CA;EAA0B,YAAA;ALk66C1B;;AKj66CA;EAAuB,YAAA;ALq66CvB;;AKp66CA;EAAyB,YAAA;ALw66CzB;;AKv66CA;EAAyB,YAAA;AL266CzB;;AK166CA;EAA8B,YAAA;AL866C9B;;AK766CA;EAA8B,YAAA;ALi76C9B;;AKh76CA;EAA8B,YAAA;ALo76C9B;;AKn76CA;EAA8B,YAAA;ALu76C9B;;AKt76CA;EAA0B,YAAA;AL076C1B;;AKz76CA;EAA0B,YAAA;AL676C1B;;AK576CA;EAA2B,YAAA;ALg86C3B;;AK/76CA;EAA2B,YAAA;ALm86C3B;;AKl86CA;EAA0B,YAAA;ALs86C1B;;AKr86CA;EAA0B,YAAA;ALy86C1B;;AKx86CA;EAA+B,YAAA;AL486C/B;;AK386CA;EAA+B,YAAA;AL+86C/B;;AK986CA;EAAwB,YAAA;ALk96CxB;;AKj96CA;EAAwB,YAAA;ALq96CxB;;AKp96CA;EAA6B,YAAA;ALw96C7B;;AKv96CA;EAA6B,YAAA;AL296C7B;;AK196CA;EAAyB,YAAA;AL896CzB;;AK796CA;EAAyB,YAAA;ALi+6CzB;;AKh+6CA;EAA0B,YAAA;ALo+6C1B;;AKn+6CA;EAA0B,YAAA;ALu+6C1B;;AKt+6CA;EAAyB,YAAA;AL0+6CzB;;AKz+6CA;EAAyB,YAAA;AL6+6CzB;;AK5+6CA;EAAiC,YAAA;ALg/6CjC;;AK/+6CA;EAAiC,YAAA;ALm/6CjC;;AKl/6CA;EAA+B,YAAA;ALs/6C/B;;AKr/6CA;EAA+B,YAAA;ALy/6C/B;;AKx/6CA;EAA0B,YAAA;AL4/6C1B;;AK3/6CA;EAA0B,YAAA;AL+/6C1B;;AK9/6CA;EAA+B,YAAA;ALkg7C/B;;AKjg7CA;EAA+B,YAAA;ALqg7C/B;;AKpg7CA;EAAwB,YAAA;ALwg7CxB;;AKvg7CA;EAA6B,YAAA;AL2g7C7B;;AK1g7CA;EAA6B,YAAA;AL8g7C7B;;AK7g7CA;EAAwB,YAAA;ALih7CxB;;AKhh7CA;EAA6B,YAAA;ALoh7C7B;;AKnh7CA;EAA6B,YAAA;ALuh7C7B;;AKth7CA;EAAuC,YAAA;AL0h7CvC;;AKzh7CA;EAAuC,YAAA;AL6h7CvC;;AK5h7CA;EAA0C,YAAA;ALgi7C1C;;AK/h7CA;EAA0C,YAAA;ALmi7C1C;;AKli7CA;EAAqC,YAAA;ALsi7CrC;;AKri7CA;EAAqC,YAAA;ALyi7CrC;;AKxi7CA;EAA8B,YAAA;AL4i7C9B;;AK3i7CA;EAA8B,YAAA;AL+i7C9B;;AK9i7CA;EAAgC,YAAA;ALkj7ChC;;AKjj7CA;EAAgC,YAAA;ALqj7ChC;;AKpj7CA;EAA4B,YAAA;ALwj7C5B;;AKvj7CA;EAA4B,YAAA;AL2j7C5B;;AK1j7CA;EAA+B,YAAA;AL8j7C/B;;AK7j7CA;EAA+B,YAAA;ALik7C/B;;AKhk7CA;EAA4B,YAAA;ALok7C5B;;AKnk7CA;EAA4B,YAAA;ALuk7C5B;;AKtk7CA;EAA4B,YAAA;AL0k7C5B;;AKzk7CA;EAA4B,YAAA;AL6k7C5B;;AK5k7CA;EAA0B,YAAA;ALgl7C1B;;AK/k7CA;EAA2B,YAAA;ALml7C3B;;AKll7CA;EAA2B,YAAA;ALsl7C3B;;AKrl7CA;EAAwB,YAAA;ALyl7CxB;;AKxl7CA;EAAwB,YAAA;AL4l7CxB;;AK3l7CA;EAAwB,YAAA;AL+l7CxB;;AK9l7CA;EAAwB,YAAA;ALkm7CxB;;AKjm7CA;EAA8B,YAAA;ALqm7C9B;;AKpm7CA;EAA8B,YAAA;ALwm7C9B;;AKvm7CA;EAAuB,YAAA;AL2m7CvB;;AK1m7CA;EAAuB,YAAA;AL8m7CvB;;AK7m7CA;EAA8B,YAAA;ALin7C9B;;AKhn7CA;EAA8B,YAAA;ALon7C9B;;AKnn7CA;EAAgC,YAAA;ALun7ChC;;AKtn7CA;EAAgC,YAAA;AL0n7ChC;;AKzn7CA;EAA4B,YAAA;AL6n7C5B;;AK5n7CA;EAA4B,YAAA;ALgo7C5B;;AK/n7CA;EAA4B,YAAA;ALmo7C5B;;AKlo7CA;EAA4B,YAAA;ALso7C5B;;AKro7CA;EAA8B,YAAA;ALyo7C9B;;AKxo7CA;EAA8B,YAAA;AL4o7C9B;;AK3o7CA;EAAyB,YAAA;AL+o7CzB;;AK9o7CA;EAAyB,YAAA;ALkp7CzB;;AKjp7CA;EAAuB,YAAA;ALqp7CvB;;AKpp7CA;EAAuB,YAAA;ALwp7CvB;;AKvp7CA;EAA6B,YAAA;AL2p7C7B;;AK1p7CA;EAA6B,YAAA;AL8p7C7B;;AK7p7CA;EAA2B,YAAA;ALiq7C3B;;AKhq7CA;EAA2B,YAAA;ALoq7C3B;;AKnq7CA;EAA6B,YAAA;ALuq7C7B;;AKtq7CA;EAA6B,YAAA;AL0q7C7B;;AKzq7CA;EAA8B,YAAA;AL6q7C9B;;AK5q7CA;EAA8B,YAAA;ALgr7C9B;;AK/q7CA;EAA8B,YAAA;ALmr7C9B;;AKlr7CA;EAA8B,YAAA;ALsr7C9B;;AKrr7CA;EAA4B,YAAA;ALyr7C5B;;AKxr7CA;EAA4B,YAAA;AL4r7C5B;;AK3r7CA;EAAgC,YAAA;AL+r7ChC;;AK9r7CA;EAAgC,YAAA;ALks7ChC;;AKjs7CA;EAA0B,YAAA;ALqs7C1B;;AKps7CA;EAA0B,YAAA;ALws7C1B;;AKvs7CA;EAA+B,YAAA;AL2s7C/B;;AK1s7CA;EAA+B,YAAA;AL8s7C/B;;AK7s7CA;EAA0B,YAAA;ALit7C1B;;AKht7CA;EAA0B,YAAA;ALot7C1B;;AKnt7CA;EAA8B,YAAA;ALut7C9B;;AKtt7CA;EAA8B,YAAA;AL0t7C9B;;AKzt7CA;EAA4B,YAAA;AL6t7C5B;;AK5t7CA;EAA4B,YAAA;ALgu7C5B;;AK/t7CA;EAAgC,YAAA;ALmu7ChC;;AKlu7CA;EAAgC,YAAA;ALsu7ChC;;AKru7CA;EAAwB,YAAA;ALyu7CxB;;AKxu7CA;EAAwB,YAAA;AL4u7CxB;;AK3u7CA;EAA4B,YAAA;AL+u7C5B;;AK9u7CA;EAA4B,YAAA;ALkv7C5B;;AKjv7CA;EAA0B,YAAA;ALqv7C1B;;AKpv7CA;EAA0B,YAAA;ALwv7C1B;;AKvv7CA;EAAqB,YAAA;AL2v7CrB;;AK1v7CA;EAAqB,YAAA;AL8v7CrB;;AK7v7CA;EAA0B,YAAA;ALiw7C1B;;AKhw7CA;EAA0B,YAAA;ALow7C1B;;AKnw7CA;EAA4B,YAAA;ALuw7C5B;;AKtw7CA;EAA4B,YAAA;AL0w7C5B;;AKzw7CA;EAA0B,YAAA;AL6w7C1B;;AK5w7CA;EAA0B,YAAA;ALgx7C1B;;AK/w7CA;EAAkC,YAAA;ALmx7ClC;;AKlx7CA;EAAkC,YAAA;ALsx7ClC;;AKrx7CA;EAA2B,YAAA;ALyx7C3B;;AKxx7CA;EAA2B,YAAA;AL4x7C3B;;AK3x7CA;EAA2B,YAAA;AL+x7C3B;;AK9x7CA;EAAgC,YAAA;ALky7ChC;;AKjy7CA;EAAgC,YAAA;ALqy7ChC;;AKpy7CA;EAA4B,YAAA;ALwy7C5B;;AKvy7CA;EAA4B,YAAA;AL2y7C5B;;AK1y7CA;EAAwB,YAAA;AL8y7CxB;;AK7y7CA;EAAwB,YAAA;ALiz7CxB;;AKhz7CA;EAA0B,YAAA;ALoz7C1B;;AKnz7CA;EAA0B,YAAA;ALuz7C1B;;AKtz7CA;EAA+B,YAAA;AL0z7C/B;;AKzz7CA;EAA+B,YAAA;AL6z7C/B;;AK5z7CA;EAAwB,YAAA;ALg07CxB;;AK/z7CA;EAAwB,YAAA;ALm07CxB;;AKl07CA;EAA0B,YAAA;ALs07C1B;;AKr07CA;EAA0B,YAAA;ALy07C1B;;AKx07CA;EAAwB,YAAA;AL407CxB;;AK307CA;EAAwB,YAAA;AL+07CxB;;AK907CA;EAA0B,YAAA;ALk17C1B;;AKj17CA;EAA0B,YAAA;ALq17C1B;;AKp17CA;EAAgC,YAAA;ALw17ChC;;AKv17CA;EAAgC,YAAA;AL217ChC;;AK117CA;EAA8B,YAAA;AL817C9B;;AK717CA;EAA8B,YAAA;ALi27C9B;;AKh27CA;EAA0B,YAAA;ALo27C1B;;AKn27CA;EAA0B,YAAA;ALu27C1B;;AKt27CA;EAA6B,YAAA;AL027C7B;;AKz27CA;EAA6B,YAAA;AL627C7B;;AK527CA;EAAyB,YAAA;ALg37CzB;;AK/27CA;EAAyB,YAAA;ALm37CzB;;AKl37CA;EAA0B,YAAA;ALs37C1B;;AKr37CA;EAA0B,YAAA;ALy37C1B;;AKx37CA;EAA2B,YAAA;AL437C3B;;AK337CA;EAA2B,YAAA;AL+37C3B;;AK937CA;EAAyB,YAAA;ALk47CzB;;AKj47CA;EAAyB,YAAA;ALq47CzB;;AKp47CA;EAA6B,YAAA;ALw47C7B;;AKv47CA;EAA6B,YAAA;AL247C7B;;AK147CA;EAA4B,YAAA;AL847C5B;;AK747CA;EAA4B,YAAA;ALi57C5B;;AKh57CA;EAAmC,YAAA;ALo57CnC;;AKn57CA;EAAmC,YAAA;ALu57CnC;;AKt57CA;EAAiC,YAAA;AL057CjC;;AKz57CA;EAAiC,YAAA;AL657CjC;;AK557CA;EAA2B,YAAA;ALg67C3B;;AK/57CA;EAA2B,YAAA;ALm67C3B;;AKl67CA;EAAyB,YAAA;ALs67CzB;;AKr67CA;EAAyB,YAAA;ALy67CzB;;AKx67CA;EAA6B,YAAA;AL467C7B;;AK367CA;EAA6B,YAAA;AL+67C7B;;AK967CA;EAA4B,YAAA;ALk77C5B;;AKj77CA;EAA4B,YAAA;ALq77C5B;;AKp77CA;EAAwB,YAAA;ALw77CxB;;AKv77CA;EAAwB,YAAA;AL277CxB;;AK177CA;EAA2B,YAAA;AL877C3B;;AK777CA;EAA2B,YAAA;ALi87C3B;;AKh87CA;EAA4B,YAAA;ALo87C5B;;AKn87CA;EAA4B,YAAA;ALu87C5B;;AKt87CA;EAA0B,YAAA;AL087C1B;;AKz87CA;EAA0B,YAAA;AL687C1B;;AK587CA;EAA+B,YAAA;ALg97C/B;;AK/87CA;EAA+B,YAAA;ALm97C/B;;AKl97CA;EAA6B,YAAA;ALs97C7B;;AKr97CA;EAA6B,YAAA;ALy97C7B;;AKx97CA;EAAyB,YAAA;AL497CzB;;AK397CA;EAAyB,YAAA;AL+97CzB;;AK997CA;EAA8B,YAAA;ALk+7C9B;;AKj+7CA;EAA8B,YAAA;ALq+7C9B;;AKp+7CA;EAAyB,YAAA;ALw+7CzB;;AKv+7CA;EAAyB,YAAA;AL2+7CzB;;AK1+7CA;EAAyB,YAAA;AL8+7CzB;;AK7+7CA;EAAyB,YAAA;ALi/7CzB;;AKh/7CA;EAA2B,YAAA;ALo/7C3B;;AKn/7CA;EAA2B,YAAA;ALu/7C3B;;AKt/7CA;EAA2B,YAAA;AL0/7C3B;;AKz/7CA;EAA2B,YAAA;AL6/7C3B;;AK5/7CA;EAAwB,YAAA;ALgg8CxB;;AK//7CA;EAAwB,YAAA;ALmg8CxB;;AKlg8CA;EAA2B,YAAA;ALsg8C3B;;AKrg8CA;EAA2B,YAAA;ALyg8C3B;;AKxg8CA;EAAyB,YAAA;AL4g8CzB;;AK3g8CA;EAAyB,YAAA;AL+g8CzB;;AK9g8CA;EAA8B,YAAA;ALkh8C9B;;AKjh8CA;EAA8B,YAAA;ALqh8C9B;;AKph8CA;EAA4B,YAAA;ALwh8C5B;;AKvh8CA;EAAwB,YAAA;AL2h8CxB;;AK1h8CA;EAAwB,YAAA;AL8h8CxB;;AK7h8CA;EAAyB,YAAA;ALii8CzB;;AKhi8CA;EAAyB,YAAA;ALoi8CzB;;AKni8CA;EAAsB,YAAA;ALui8CtB;;AKti8CA;EAAsB,YAAA;AL0i8CtB;;AKzi8CA;EAA0B,YAAA;AL6i8C1B;;AK5i8CA;EAA0B,YAAA;ALgj8C1B;;AK/i8CA;EAAwB,YAAA;ALmj8CxB;;AKlj8CA;EAAwB,YAAA;ALsj8CxB;;AKrj8CA;EAAsB,YAAA;ALyj8CtB;;AKxj8CA;EAAsB,YAAA;AL4j8CtB;;AK3j8CA;EAAyB,YAAA;AL+j8CzB;;AK9j8CA;EAAyB,YAAA;ALkk8CzB;;AKjk8CA;EAAyB,YAAA;ALqk8CzB;;AKpk8CA;EAAyB,YAAA;ALwk8CzB;;AKvk8CA;EAAuB,YAAA;AL2k8CvB;;AK1k8CA;EAAuB,YAAA;AL8k8CvB;;AK7k8CA;EAA2B,YAAA;ALil8C3B;;AKhl8CA;EAA2B,YAAA;ALol8C3B;;AKnl8CA;EAAyB,YAAA;ALul8CzB;;AKtl8CA;EAAyB,YAAA;AL0l8CzB;;AKzl8CA;EAAyB,YAAA;AL6l8CzB;;AK5l8CA;EAAyB,YAAA;ALgm8CzB;;AK/l8CA;EAAuB,YAAA;ALmm8CvB;;AKlm8CA;EAAuB,YAAA;ALsm8CvB;;AKrm8CA;EAA2B,YAAA;ALym8C3B;;AKxm8CA;EAA2B,YAAA;AL4m8C3B;;AK3m8CA;EAA2B,YAAA;AL+m8C3B;;AK9m8CA;EAA2B,YAAA;ALkn8C3B;;AKjn8CA;EAAyB,YAAA;ALqn8CzB;;AKpn8CA;EAAyB,YAAA;ALwn8CzB;;AKvn8CA;EAAyB,YAAA;AL2n8CzB;;AK1n8CA;EAAyB,YAAA;AL8n8CzB;;AK7n8CA;EAAuB,YAAA;ALio8CvB;;AKho8CA;EAAuB,YAAA;ALoo8CvB;;AKno8CA;EAA6B,YAAA;ALuo8C7B;;AKto8CA;EAA6B,YAAA;AL0o8C7B;;AKzo8CA;EAA+B,YAAA;AL6o8C/B;;AK5o8CA;EAA+B,YAAA;ALgp8C/B;;AK/o8CA;EAA2B,YAAA;ALmp8C3B;;AKlp8CA;EAA2B,YAAA;ALsp8C3B;;AKrp8CA;EAA+B,YAAA;ALyp8C/B;;AKxp8CA;EAA+B,YAAA;AL4p8C/B;;AK3p8CA;EAA6B,YAAA;AL+p8C7B;;AK9p8CA;EAA6B,YAAA;ALkq8C7B;;AKjq8CA;EAA0B,YAAA;ALqq8C1B;;AKpq8CA;EAA0B,YAAA;ALwq8C1B;;AKvq8CA;EAA+B,YAAA;AL2q8C/B;;AK1q8CA;EAA+B,YAAA;AL8q8C/B;;AK7q8CA;EAA2B,YAAA;ALir8C3B;;AKhr8CA;EAA2B,YAAA;ALor8C3B;;AKnr8CA;EAA6B,YAAA;ALur8C7B;;AKtr8CA;EAA6B,YAAA;AL0r8C7B;;AKzr8CA;EAAyB,YAAA;AL6r8CzB;;AK5r8CA;EAAyB,YAAA;ALgs8CzB;;AK/r8CA;EAAiC,YAAA;ALms8CjC;;AKls8CA;EAAiC,YAAA;ALss8CjC;;AKrs8CA;EAA2B,YAAA;ALys8C3B;;AKxs8CA;EAA2B,YAAA;AL4s8C3B;;AK3s8CA;EAA2B,YAAA;AL+s8C3B;;AK9s8CA;EAA+B,YAAA;ALkt8C/B;;AKjt8CA;EAA+B,YAAA;ALqt8C/B;;AKpt8CA;EAA6B,YAAA;ALwt8C7B;;AKvt8CA;EAA6B,YAAA;AL2t8C7B;;AK1t8CA;EAA0B,YAAA;AL8t8C1B;;AK7t8CA;EAAyB,YAAA;ALiu8CzB;;AKhu8CA;EAAyB,YAAA;ALou8CzB;;AKnu8CA;EAAuB,YAAA;ALuu8CvB;;AKtu8CA;EAAyB,YAAA;AL0u8CzB;;AKzu8CA;EAAyB,YAAA;AL6u8CzB;;AK5u8CA;EAA0B,YAAA;ALgv8C1B;;AK/u8CA;EAA0B,YAAA;ALmv8C1B;;AKlv8CA;EAA6B,YAAA;ALsv8C7B;;AKrv8CA;EAA6B,YAAA;ALyv8C7B;;AKxv8CA;EAA6B,YAAA;AL4v8C7B;;AK3v8CA;EAA6B,YAAA;AL+v8C7B;;AK9v8CA;EAA6B,YAAA;ALkw8C7B;;AKjw8CA;EAA6B,YAAA;ALqw8C7B;;AKpw8CA;EAA6B,YAAA;ALww8C7B;;AKvw8CA;EAA6B,YAAA;AL2w8C7B;;AK1w8CA;EAA6B,YAAA;AL8w8C7B;;AK7w8CA;EAA6B,YAAA;ALix8C7B;;AKhx8CA;EAA2B,YAAA;ALox8C3B;;AKnx8CA;EAA2B,YAAA;ALux8C3B;;AKtx8CA;EAA0B,YAAA;AL0x8C1B;;AKzx8CA;EAA0B,YAAA;AL6x8C1B;;AK5x8CA;EAAwB,YAAA;ALgy8CxB;;AK/x8CA;EAAwB,YAAA;ALmy8CxB;;AKly8CA;EAA4B,YAAA;ALsy8C5B;;AKry8CA;EAA4B,YAAA;ALyy8C5B;;AKxy8CA;EAA+B,YAAA;AL4y8C/B;;AK3y8CA;EAA+B,YAAA;AL+y8C/B;;AK9y8CA;EAAwB,YAAA;ALkz8CxB;;AKjz8CA;EAAkC,YAAA;ALqz8ClC;;AKpz8CA;EAAkC,YAAA;ALwz8ClC;;AKvz8CA;EAAoC,YAAA;AL2z8CpC;;AK1z8CA;EAAoC,YAAA;AL8z8CpC;;AK7z8CA;EAAgC,YAAA;ALi08ChC;;AKh08CA;EAAgC,YAAA;ALo08ChC;;AKn08CA;EAAwB,YAAA;ALu08CxB;;AKt08CA;EAA+B,YAAA;AL008C/B;;AKz08CA;EAA+B,YAAA;AL608C/B;;AK508CA;EAA+B,YAAA;ALg18C/B;;AK/08CA;EAA+B,YAAA;ALm18C/B;;AKl18CA;EAAyB,YAAA;ALs18CzB;;AKr18CA;EAA+B,YAAA;ALy18C/B;;AKx18CA;EAA+B,YAAA;AL418C/B;;AK318CA;EAAiC,YAAA;AL+18CjC;;AK918CA;EAAiC,YAAA;ALk28CjC;;AKj28CA;EAAyB,YAAA;ALq28CzB;;AKp28CA;EAA8B,YAAA;ALw28C9B;;AKv28CA;EAA8B,YAAA;AL228C9B;;AK128CA;EAA8B,YAAA;AL828C9B;;AK728CA;EAA8B,YAAA;ALi38C9B;;AKh38CA;EAAyB,YAAA;ALo38CzB;;AKn38CA;EAAyB,YAAA;ALu38CzB;;AKt38CA;EAAuB,YAAA;AL038CvB;;AKz38CA;EAAuB,YAAA;AL638CvB;;AK538CA;EAAwB,YAAA;ALg48CxB;;AK/38CA;EAAwB,YAAA;ALm48CxB;;AKl48CA;EAAiC,YAAA;ALs48CjC;;AKr48CA;EAAiC,YAAA;ALy48CjC;;AKx48CA;EAAiC,YAAA;AL448CjC;;AK348CA;EAAiC,YAAA;AL+48CjC;;AK948CA;EAA+B,YAAA;ALk58C/B;;AKj58CA;EAA+B,YAAA;ALq58C/B;;AKp58CA;EAAoC,YAAA;ALw58CpC;;AKv58CA;EAAoC,YAAA;AL258CpC;;AK158CA;EAAkC,YAAA;AL858ClC;;AK758CA;EAAkC,YAAA;ALi68ClC;;AKh68CA;EAAkC,YAAA;ALo68ClC;;AKn68CA;EAAkC,YAAA;ALu68ClC;;AKt68CA;EAAgC,YAAA;AL068ChC;;AKz68CA;EAAgC,YAAA;AL668ChC;;AK568CA;EAA0B,YAAA;ALg78C1B;;AK/68CA;EAA0B,YAAA;ALm78C1B;;AKl78CA;EAA0B,YAAA;ALs78C1B;;AKr78CA;EAA0B,YAAA;ALy78C1B;;AKx78CA;EAA4B,YAAA;AL478C5B;;AK378CA;EAA4B,YAAA;AL+78C5B;;AK978CA;EAA2B,YAAA;ALk88C3B;;AKj88CA;EAA2B,YAAA;ALq88C3B;;AKp88CA;EAA+B,YAAA;ALw88C/B;;AKv88CA;EAA+B,YAAA;AL288C/B;;AK188CA;EAAgC,YAAA;AL888ChC;;AK788CA;EAAgC,YAAA;ALi98ChC;;AKh98CA;EAAgC,YAAA;ALo98ChC;;AKn98CA;EAAgC,YAAA;ALu98ChC;;AKt98CA;EAAgC,YAAA;AL098ChC;;AKz98CA;EAAgC,YAAA;AL698ChC;;AK598CA;EAAoC,YAAA;ALg+8CpC;;AK/98CA;EAAoC,YAAA;ALm+8CpC;;AKl+8CA;EAA8B,YAAA;ALs+8C9B;;AKr+8CA;EAA8B,YAAA;ALy+8C9B;;AKx+8CA;EAAkC,YAAA;AL4+8ClC;;AK3+8CA;EAAkC,YAAA;AL++8ClC;;AK9+8CA;EAA6B,YAAA;ALk/8C7B;;AKj/8CA;EAA6B,YAAA;ALq/8C7B;;AKp/8CA;EAA2B,YAAA;ALw/8C3B;;AKv/8CA;EAA2B,YAAA;AL2/8C3B;;AK1/8CA;EAA6B,YAAA;AL8/8C7B;;AK7/8CA;EAA6B,YAAA;ALig9C7B;;AKhg9CA;EAAsB,YAAA;ALog9CtB;;AKng9CA;EAAsB,YAAA;ALug9CtB;;AKtg9CA;EAA4B,YAAA;AL0g9C5B;;AKzg9CA;EAA4B,YAAA;AL6g9C5B;;AK5g9CA;EAAiC,YAAA;ALgh9CjC;;AK/g9CA;EAAiC,YAAA;ALmh9CjC;;AKlh9CA;EAA+B,YAAA;ALsh9C/B;;AKrh9CA;EAA+B,YAAA;ALyh9C/B;;AKxh9CA;EAAoC,YAAA;AL4h9CpC;;AK3h9CA;EAAoC,YAAA;AL+h9CpC;;AK9h9CA;EAA0B,YAAA;ALki9C1B;;AKji9CA;EAA0B,YAAA;ALqi9C1B;;AKpi9CA;EAAwB,YAAA;ALwi9CxB;;AKvi9CA;EAAwB,YAAA;AL2i9CxB;;AK1i9CA;EAAwB,YAAA;AL8i9CxB;;AK7i9CA;EAAwB,YAAA;ALij9CxB;;AKhj9CA;EAAwB,YAAA;ALoj9CxB;;AKnj9CA;EAAwB,YAAA;ALuj9CxB;;AKtj9CA;EAAwB,YAAA;AL0j9CxB;;AKzj9CA;EAAwB,YAAA;AL6j9CxB;;AK5j9CA;EAA8B,YAAA;ALgk9C9B;;AK/j9CA;EAA8B,YAAA;ALmk9C9B;;AKlk9CA;EAA8B,YAAA;ALsk9C9B;;AKrk9CA;EAA8B,YAAA;ALyk9C9B;;AKxk9CA;EAA8B,YAAA;AL4k9C9B;;AK3k9CA;EAA8B,YAAA;AL+k9C9B;;AK9k9CA;EAA4B,YAAA;ALkl9C5B;;AKjl9CA;EAA4B,YAAA;ALql9C5B;;AKpl9CA;EAA6B,YAAA;ALwl9C7B;;AKvl9CA;EAA6B,YAAA;AL2l9C7B;;AK1l9CA;EAA2B,YAAA;AL8l9C3B;;AK7l9CA;EAA2B,YAAA;ALim9C3B;;AKhm9CA;EAAwB,YAAA;ALom9CxB;;AKnm9CA;EAAwB,YAAA;ALum9CxB;;AKtm9CA;EAAsB,YAAA;AL0m9CtB;;AKzm9CA;EAAuB,YAAA;AL6m9CvB;;AK5m9CA;EAA+B,YAAA;ALgn9C/B;;AK/m9CA;EAA+B,YAAA;ALmn9C/B;;AKln9CA;EAA6B,YAAA;ALsn9C7B;;AKrn9CA;EAA6B,YAAA;ALyn9C7B;;AKxn9CA;EAA6B,YAAA;AL4n9C7B;;AK3n9CA;EAA6B,YAAA;AL+n9C7B;;AK9n9CA;EAAmB,YAAA;ALko9CnB;;AKjo9CA;EAAyB,YAAA;ALqo9CzB;;AKpo9CA;EAAyB,YAAA;ALwo9CzB;;AKvo9CA;EAAyB,YAAA;AL2o9CzB;;AK1o9CA;EAAyB,YAAA;AL8o9CzB;;AK7o9CA;EAAuB,YAAA;ALip9CvB;;AKhp9CA;EAAuB,YAAA;ALop9CvB;;AKnp9CA;EAA4B,YAAA;ALup9C5B;;AKtp9CA;EAA4B,YAAA;AL0p9C5B;;AKzp9CA;EAA4B,YAAA;AL6p9C5B;;AK5p9CA;EAA4B,YAAA;ALgq9C5B;;AK/p9CA;EAA0B,YAAA;ALmq9C1B;;AKlq9CA;EAA0B,YAAA;ALsq9C1B;;AKrq9CA;EAA2B,YAAA;ALyq9C3B;;AKxq9CA;EAA2B,YAAA;AL4q9C3B;;AK3q9CA;EAAwB,YAAA;AL+q9CxB;;AK9q9CA;EAAwB,YAAA;ALkr9CxB;;AKjr9CA;EAA6B,YAAA;ALqr9C7B;;AKpr9CA;EAA6B,YAAA;ALwr9C7B;;AKvr9CA;EAAoC,YAAA;AL2r9CpC;;AK1r9CA;EAAkC,YAAA;AL8r9ClC;;AK7r9CA;EAA0B,YAAA;ALis9C1B;;AKhs9CA;EAA0B,YAAA;ALos9C1B;;AKns9CA;EAAsB,YAAA;ALus9CtB;;AKts9CA;EAAsB,YAAA;AL0s9CtB;;AKzs9CA;EAAwB,YAAA;AL6s9CxB;;AK5s9CA;EAAwB,YAAA;ALgt9CxB;;AK/s9CA;EAAiC,YAAA;ALmt9CjC;;AKlt9CA;EAAiC,YAAA;ALst9CjC;;AKrt9CA;EAA6B,YAAA;ALyt9C7B;;AKxt9CA;EAA6B,YAAA;AL4t9C7B;;AK3t9CA;EAAuB,YAAA;AL+t9CvB;;AK9t9CA;EAA4B,YAAA;ALku9C5B;;AKju9CA;EAA4B,YAAA;ALqu9C5B;;AKpu9CA;EAA8B,YAAA;ALwu9C9B;;AKvu9CA;EAA8B,YAAA;AL2u9C9B;;AK1u9CA;EAAuB,YAAA;AL8u9CvB;;AK7u9CA;EAAyB,YAAA;ALiv9CzB;;AKhv9CA;EAAyB,YAAA;ALov9CzB;;AKnv9CA;EAA6B,YAAA;ALuv9C7B;;AKtv9CA;EAA6B,YAAA;AL0v9C7B;;AKzv9CA;EAAwB,YAAA;AL6v9CxB;;AK5v9CA;EAAwB,YAAA;ALgw9CxB;;AK/v9CA;EAA6B,YAAA;ALmw9C7B;;AKlw9CA;EAA6B,YAAA;ALsw9C7B;;AKrw9CA;EAA2B,YAAA;ALyw9C3B;;AKxw9CA;EAA2B,YAAA;AL4w9C3B;;AK3w9CA;EAA8B,YAAA;AL+w9C9B;;AK9w9CA;EAA8B,YAAA;ALkx9C9B;;AKjx9CA;EAAgC,YAAA;ALqx9ChC;;AKpx9CA;EAAgC,YAAA;ALwx9ChC;;AKvx9CA;EAA8B,YAAA;AL2x9C9B;;AK1x9CA;EAA8B,YAAA;AL8x9C9B;;AK7x9CA;EAAwB,YAAA;ALiy9CxB;;AKhy9CA;EAAwB,YAAA;ALoy9CxB;;AKny9CA;EAA8B,YAAA;ALuy9C9B;;AKty9CA;EAA8B,YAAA;AL0y9C9B;;AKzy9CA;EAAuB,YAAA;AL6y9CvB;;AK5y9CA;EAAuB,YAAA;ALgz9CvB;;AK/y9CA;EAA4B,YAAA;ALmz9C5B;;AKlz9CA;EAA4B,YAAA;ALsz9C5B;;AKrz9CA;EAA0B,YAAA;ALyz9C1B;;AKxz9CA;EAA0B,YAAA;AL4z9C1B;;AK3z9CA;EAA0B,YAAA;AL+z9C1B;;AK9z9CA;EAA0B,YAAA;ALk09C1B;;AKj09CA;EAAwB,YAAA;ALq09CxB;;AKp09CA;EAAwB,YAAA;ALw09CxB;;AKv09CA;EAA6B,YAAA;AL209C7B;;AK109CA;EAA2B,YAAA;AL809C3B;;AK709CA;EAAyB,YAAA;ALi19CzB;;AKh19CA;EAAuB,YAAA;ALo19CvB;;AKn19CA;EAA2B,YAAA;ALu19C3B;;AKt19CA;EAA2B,YAAA;AL019C3B;;AKz19CA;EAAyB,YAAA;AL619CzB;;AK519CA;EAAyB,YAAA;ALg29CzB;;AK/19CA;EAA8B,YAAA;ALm29C9B;;AKl29CA;EAA8B,YAAA;ALs29C9B;;AKr29CA;EAA6B,YAAA;ALy29C7B;;AKx29CA;EAA6B,YAAA;AL429C7B;;AK329CA;EAA6B,YAAA;AL+29C7B;;AK929CA;EAA6B,YAAA;ALk39C7B;;AKj39CA;EAA2B,YAAA;ALq39C3B;;AKp39CA;EAA2B,YAAA;ALw39C3B;;AKv39CA;EAA6B,YAAA;AL239C7B;;AK139CA;EAA6B,YAAA;AL839C7B;;AK739CA;EAAsB,YAAA;ALi49CtB;;AKh49CA;EAA4B,YAAA;ALo49C5B;;AKn49CA;EAA4B,YAAA;ALu49C5B;;AKt49CA;EAAsB,YAAA;AL049CtB;;AKz49CA;EAA2B,YAAA;AL649C3B;;AK549CA;EAAyB,YAAA;ALg59CzB;;AK/49CA;EAAgC,YAAA;ALm59ChC;;AKl59CA;EAAgC,YAAA;ALs59ChC;;AKr59CA;EAAiC,YAAA;ALy59CjC;;AKx59CA;EAAiC,YAAA;AL459CjC;;AK359CA;EAAyB,YAAA;AL+59CzB;;AK959CA;EAAyB,YAAA;ALk69CzB;;AKj69CA;EAA2B,YAAA;ALq69C3B;;AKp69CA;EAA2B,YAAA;ALw69C3B;;AKv69CA;EAAuB,YAAA;AL269CvB;;AK169CA;EAAuB,YAAA;AL869CvB;;AK769CA;EAAyB,YAAA;ALi79CzB;;AKh79CA;EAAyB,YAAA;ALo79CzB;;AKn79CA;EAAwB,YAAA;ALu79CxB;;AKt79CA;EAAwB,YAAA;AL079CxB;;AKz79CA;EAA0B,YAAA;AL679C1B;;AK579CA;EAA0B,YAAA;ALg89C1B;;AK/79CA;EAAwB,YAAA;ALm89CxB;;AKl89CA;EAAwB,YAAA;ALs89CxB;;AKr89CA;EAA4B,YAAA;ALy89C5B;;AKx89CA;EAA4B,YAAA;AL489C5B;;AK389CA;EAA8B,YAAA;AL+89C9B;;AK989CA;EAA8B,YAAA;ALk99C9B;;AKj99CA;EAA0B,YAAA;ALq99C1B;;AKp99CA;EAA0B,YAAA;ALw99C1B;;AKv99CA;EAAqB,YAAA;AL299CrB;;AK199CA;EAA4B,YAAA;AL899C5B;;AK799CA;EAA4B,YAAA;ALi+9C5B;;AKh+9CA;EAAwB,YAAA;ALo+9CxB;;AKn+9CA;EAAwB,YAAA;ALu+9CxB;;AKt+9CA;EAAyB,YAAA;AL0+9CzB;;AKz+9CA;EAAyB,YAAA;AL6+9CzB;;AK5+9CA;EAA2B,YAAA;ALg/9C3B;;AK/+9CA;EAA2B,YAAA;ALm/9C3B;;AKl/9CA;EAAyB,YAAA;ALs/9CzB;;AKr/9CA;EAAyB,YAAA;ALy/9CzB;;AKx/9CA;EAAuB,YAAA;AL4/9CvB;;AK3/9CA;EAAuB,YAAA;AL+/9CvB;;AK9/9CA;EAAuB,YAAA;ALkg+CvB;;AKjg+CA;EAAuB,YAAA;ALqg+CvB;;AKpg+CA;EAAuB,YAAA;ALwg+CvB;;AKvg+CA;EAAuB,YAAA;AL2g+CvB;;AK1g+CA;EAA4B,YAAA;AL8g+C5B;;AK7g+CA;EAA4B,YAAA;ALih+C5B;;AKhh+CA;EAAuB,YAAA;ALoh+CvB;;AKnh+CA;EAAuB,YAAA;ALuh+CvB;;AKth+CA;EAA2B,YAAA;AL0h+C3B;;AKzh+CA;EAA2B,YAAA;AL6h+C3B;;AK5h+CA;EAA4B,YAAA;ALgi+C5B;;AK/h+CA;EAA4B,YAAA;ALmi+C5B;;AKli+CA;EAA2B,YAAA;ALsi+C3B;;AKri+CA;EAA2B,YAAA;ALyi+C3B;;AKxi+CA;EAA+B,YAAA;AL4i+C/B;;AK3i+CA;EAA+B,YAAA;AL+i+C/B;;AK9i+CA;EAA2B,YAAA;ALkj+C3B;;AKjj+CA;EAA2B,YAAA;ALqj+C3B;;AKpj+CA;EAAkC,YAAA;ALwj+ClC;;AKvj+CA;EAAkC,YAAA;AL2j+ClC;;AK1j+CA;EAA4B,YAAA;AL8j+C5B;;AK7j+CA;EAA4B,YAAA;ALik+C5B;;AKhk+CA;EAA8B,YAAA;ALok+C9B;;AKnk+CA;EAA8B,YAAA;ALuk+C9B;;AKtk+CA;EAA0B,YAAA;AL0k+C1B;;AKzk+CA;EAAuB,YAAA;AL6k+CvB;;AK5k+CA;EAAkB,YAAA;ALgl+ClB;;AK/k+CA;EAA8B,YAAA;ALml+C9B;;AKll+CA;EAA8B,YAAA;ALsl+C9B;;AKrl+CA;EAA6B,YAAA;ALyl+C7B;;AKxl+CA;EAA6B,YAAA;AL4l+C7B;;AK3l+CA;EAA2B,YAAA;AL+l+C3B;;AK9l+CA;EAA2B,YAAA;ALkm+C3B;;AKjm+CA;EAAgC,YAAA;ALqm+ChC;;AKpm+CA;EAAgC,YAAA;ALwm+ChC;;AKvm+CA;EAA2B,YAAA;AL2m+C3B;;AK1m+CA;EAA2B,YAAA;AL8m+C3B;;AK7m+CA;EAAyB,YAAA;ALin+CzB;;AKhn+CA;EAAyB,YAAA;ALon+CzB;;AKnn+CA;EAAuB,YAAA;ALun+CvB;;AKtn+CA;EAAuB,YAAA;AL0n+CvB;;AKzn+CA;EAA0B,YAAA;AL6n+C1B;;AK5n+CA;EAA0B,YAAA;ALgo+C1B;;AK/n+CA;EAAwB,YAAA;ALmo+CxB;;AKlo+CA;EAA8B,YAAA;ALso+C9B;;AKro+CA;EAA8B,YAAA;ALyo+C9B;;AKxo+CA;EAAwB,YAAA;AL4o+CxB;;AK3o+CA;EAAuB,YAAA;AL+o+CvB;;AK9o+CA;EAAuB,YAAA;ALkp+CvB;;AKjp+CA;EAAyB,YAAA;ALqp+CzB;;AKpp+CA;EAAyB,YAAA;ALwp+CzB;;AKvp+CA;EAAwB,YAAA;AL2p+CxB;;AK1p+CA;EAAwB,YAAA;AL8p+CxB;;AK7p+CA;EAA0B,YAAA;ALiq+C1B;;AKhq+CA;EAA0B,YAAA;ALoq+C1B;;AKnq+CA;EAA4B,YAAA;ALuq+C5B;;AKtq+CA;EAA4B,YAAA;AL0q+C5B;;AKzq+CA;EAAgC,YAAA;AL6q+ChC;;AK5q+CA;EAAgC,YAAA;ALgr+ChC;;AK/q+CA;EAAwB,YAAA;ALmr+CxB;;AKlr+CA;EAAwB,YAAA;ALsr+CxB;;AKrr+CA;EAA6B,YAAA;ALyr+C7B;;AKxr+CA;EAA6B,YAAA;AL4r+C7B;;AK3r+CA;EAAyB,YAAA;AL+r+CzB;;AK9r+CA;EAAuB,YAAA;ALks+CvB;;AKjs+CA;EAA2B,YAAA;ALqs+C3B;;AKps+CA;EAA2B,YAAA;ALws+C3B;;AKvs+CA;EAA+B,YAAA;AL2s+C/B;;AK1s+CA;EAA+B,YAAA;AL8s+C/B;;AK7s+CA;EAAyB,YAAA;ALit+CzB;;AKht+CA;EAAyB,YAAA;ALot+CzB;;AKnt+CA;EAAyB,YAAA;ALut+CzB;;AKtt+CA;EAAyB,YAAA;AL0t+CzB;;AKzt+CA;EAAwB,YAAA;AL6t+CxB;;AK5t+CA;EAAwB,YAAA;ALgu+CxB;;AK/t+CA;EAAyB,YAAA;ALmu+CzB;;AKlu+CA;EAAyB,YAAA;ALsu+CzB;;AKru+CA;EAAuB,YAAA;ALyu+CvB;;AKxu+CA;EAAuB,YAAA;AL4u+CvB;;AK3u+CA;EAAqB,YAAA;AL+u+CrB;;AK9u+CA;EAAqB,YAAA;ALkv+CrB;;AKjv+CA;EAAyB,YAAA;ALqv+CzB;;AKpv+CA;EAAyB,YAAA;ALwv+CzB;;AKvv+CA;EAA0B,YAAA;AL2v+C1B;;AK1v+CA;EAA0B,YAAA;AL8v+C1B;;AK7v+CA;EAA0B,YAAA;ALiw+C1B;;AKhw+CA;EAA0B,YAAA;ALow+C1B;;AKnw+CA;EAAyB,YAAA;ALuw+CzB;;AKtw+CA;EAAyB,YAAA;AL0w+CzB;;AKzw+CA;EAAyB,YAAA;AL6w+CzB;;AK5w+CA;EAAyB,YAAA;ALgx+CzB;;AK/w+CA;EAA2B,YAAA;ALmx+C3B;;AKlx+CA;EAA2B,YAAA;ALsx+C3B;;AKrx+CA;EAAuB,YAAA;ALyx+CvB;;AKxx+CA;EAA4B,YAAA;AL4x+C5B;;AK3x+CA;EAA4B,YAAA;AL+x+C5B;;AK9x+CA;EAA2B,YAAA;ALky+C3B;;AKjy+CA;EAA2B,YAAA;ALqy+C3B;;AKpy+CA;EAA2B,YAAA;ALwy+C3B;;AKvy+CA;EAA2B,YAAA;AL2y+C3B;;AK1y+CA;EAAiC,YAAA;AL8y+CjC;;AK7y+CA;EAAiC,YAAA;ALiz+CjC;;AKhz+CA;EAA+B,YAAA;ALoz+C/B;;AKnz+CA;EAA+B,YAAA;ALuz+C/B;;AKtz+CA;EAAyB,YAAA;AL0z+CzB;;AKzz+CA;EAAyB,YAAA;AL6z+CzB;;AK5z+CA;EAAsB,YAAA;ALg0+CtB;;AK/z+CA;EAAsB,YAAA;ALm0+CtB;;AKl0+CA;EAAyB,YAAA;ALs0+CzB;;AKr0+CA;EAAyB,YAAA;ALy0+CzB;;AKx0+CA;EAAyB,YAAA;AL40+CzB;;AK30+CA;EAAyB,YAAA;AL+0+CzB;;AK90+CA;EAAyB,YAAA;ALk1+CzB;;AKj1+CA;EAAyB,YAAA;ALq1+CzB;;AKp1+CA;EAAyB,YAAA;ALw1+CzB;;AKv1+CA;EAAyB,YAAA;AL21+CzB;;AK11+CA;EAAyB,YAAA;AL81+CzB;;AK71+CA;EAAyB,YAAA;ALi2+CzB;;AKh2+CA;EAA2B,YAAA;ALo2+C3B;;AKn2+CA;EAA2B,YAAA;ALu2+C3B;;AKt2+CA;EAAuB,YAAA;AL02+CvB;;AKz2+CA;EAA8B,YAAA;AL62+C9B;;AK52+CA;EAA8B,YAAA;ALg3+C9B;;AK/2+CA;EAA6B,YAAA;ALm3+C7B;;AKl3+CA;EAA6B,YAAA;ALs3+C7B;;AKr3+CA;EAAuB,YAAA;ALy3+CvB;;AKx3+CA;EAAgC,YAAA;AL43+ChC;;AK33+CA;EAAgC,YAAA;AL+3+ChC;;AK93+CA;EAAkC,YAAA;ALk4+ClC;;AKj4+CA;EAAkC,YAAA;ALq4+ClC;;AKp4+CA;EAAgC,YAAA;ALw4+ChC;;AKv4+CA;EAAgC,YAAA;AL24+ChC;;AK14+CA;EAA8B,YAAA;AL84+C9B;;AK74+CA;EAA8B,YAAA;ALi5+C9B;;AKh5+CA;EAAgC,YAAA;ALo5+ChC;;AKn5+CA;EAAgC,YAAA;ALu5+ChC;;AKt5+CA;EAAgC,YAAA;AL05+ChC;;AKz5+CA;EAAgC,YAAA;AL65+ChC;;AK55+CA;EAA8B,YAAA;ALg6+C9B;;AK/5+CA;EAA8B,YAAA;ALm6+C9B;;AKl6+CA;EAA6B,YAAA;ALs6+C7B;;AKr6+CA;EAA6B,YAAA;ALy6+C7B;;AKx6+CA;EAA4B,YAAA;AL46+C5B;;AK36+CA;EAA4B,YAAA;AL+6+C5B;;AK96+CA;EAAgC,YAAA;ALk7+ChC;;AKj7+CA;EAAgC,YAAA;ALq7+ChC;;AKp7+CA;EAA6B,YAAA;ALw7+C7B;;AKv7+CA;EAA6B,YAAA;AL27+C7B;;AK17+CA;EAA4B,YAAA;AL87+C5B;;AK77+CA;EAA4B,YAAA;ALi8+C5B;;AKh8+CA;EAA6B,YAAA;ALo8+C7B;;AKn8+CA;EAA6B,YAAA;ALu8+C7B;;AKt8+CA;EAAiC,YAAA;AL08+CjC;;AKz8+CA;EAAiC,YAAA;AL68+CjC;;AK58+CA;EAAwB,YAAA;ALg9+CxB;;AK/8+CA;EAAwB,YAAA;ALm9+CxB;;AKl9+CA;EAA+B,YAAA;ALs9+C/B;;AKr9+CA;EAA+B,YAAA;ALy9+C/B;;AKx9+CA;EAA4B,YAAA;AL49+C5B;;AK39+CA;EAA4B,YAAA;AL+9+C5B;;AK99+CA;EAA0B,YAAA;ALk++C1B;;AKj++CA;EAA0B,YAAA;ALq++C1B;;AKp++CA;EAAwB,YAAA;ALw++CxB;;AKv++CA;EAAwB,YAAA;AL2++CxB;;AK1++CA;EAA8B,YAAA;AL8++C9B;;AK7++CA;EAA8B,YAAA;ALi/+C9B;;AKh/+CA;EAA4B,YAAA;ALo/+C5B;;AKn/+CA;EAA4B,YAAA;ALu/+C5B;;AKt/+CA;EAA8B,YAAA;AL0/+C9B;;AKz/+CA;EAA8B,YAAA;AL6/+C9B;;AK5/+CA;EAAsB,YAAA;ALgg/CtB;;AK//+CA;EAAsB,YAAA;ALmg/CtB;;AKlg/CA;EAAwB,YAAA;ALsg/CxB;;AKrg/CA;EAAwB,YAAA;ALyg/CxB;;AKxg/CA;EAAuB,YAAA;AL4g/CvB;;AK3g/CA;EAAuB,YAAA;AL+g/CvB;;AK9g/CA;EAAoC,YAAA;ALkh/CpC;;AKjh/CA;EAAoC,YAAA;ALqh/CpC;;AKph/CA;EAA6B,YAAA;ALwh/C7B;;AKvh/CA;EAA6B,YAAA;AL2h/C7B;;AK1h/CA;EAA8B,YAAA;AL8h/C9B;;AK7h/CA;EAA8B,YAAA;ALii/C9B;;AKhi/CA;EAA8B,YAAA;ALoi/C9B;;AKni/CA;EAA8B,YAAA;ALui/C9B;;AKti/CA;EAAqC,YAAA;AL0i/CrC;;AKzi/CA;EAAqC,YAAA;AL6i/CrC;;AK5i/CA;EAA4B,YAAA;ALgj/C5B;;AK/i/CA;EAA4B,YAAA;ALmj/C5B;;AKlj/CA;EAAiC,YAAA;ALsj/CjC;;AKrj/CA;EAAiC,YAAA;ALyj/CjC;;AKxj/CA;EAAwB,YAAA;AL4j/CxB;;AK3j/CA;EAAwB,YAAA;AL+j/CxB;;AK9j/CA;EAAuB,YAAA;ALkk/CvB;;AKjk/CA;EAAuB,YAAA;ALqk/CvB;;AKpk/CA;EAA2B,YAAA;ALwk/C3B;;AKvk/CA;EAA2B,YAAA;AL2k/C3B;;AK1k/CA;EAA2B,YAAA;AL8k/C3B;;AK7k/CA;EAA2B,YAAA;ALil/C3B;;AKhl/CA;EAAyB,YAAA;ALol/CzB;;AKnl/CA;EAAyB,YAAA;ALul/CzB;;AKtl/CA;EAA8B,YAAA;AL0l/C9B;;AKzl/CA;EAA8B,YAAA;AL6l/C9B;;AK5l/CA;EAAyB,YAAA;ALgm/CzB;;AK/l/CA;EAAyB,YAAA;ALmm/CzB;;AKlm/CA;EAA2B,YAAA;ALsm/C3B;;AKrm/CA;EAA2B,YAAA;ALym/C3B;;AKxm/CA;EAAyB,YAAA;AL4m/CzB;;AK3m/CA;EAAyB,YAAA;AL+m/CzB;;AK9m/CA;EAA6B,YAAA;ALkn/C7B;;AKjn/CA;EAA6B,YAAA;ALqn/C7B;;AKpn/CA;EAAwB,YAAA;ALwn/CxB;;AKvn/CA;EAAwB,YAAA;AL2n/CxB;;AK1n/CA;EAA2B,YAAA;AL8n/C3B;;AK7n/CA;EAA2B,YAAA;ALio/C3B;;AKho/CA;EAA6B,YAAA;ALoo/C7B;;AKno/CA;EAA6B,YAAA;ALuo/C7B;;AKto/CA;EAAuB,YAAA;AL0o/CvB;;AKzo/CA;EAAuB,YAAA;AL6o/CvB;;AK5o/CA;EAA2B,YAAA;ALgp/C3B;;AK/o/CA;EAA2B,YAAA;ALmp/C3B;;AKlp/CA;EAA2B,YAAA;ALsp/C3B;;AKrp/CA;EAA2B,YAAA;ALyp/C3B;;AKxp/CA;EAAyB,YAAA;AL4p/CzB;;AK3p/CA;EAAyB,YAAA;AL+p/CzB;;AK9p/CA;EAA0B,YAAA;ALkq/C1B;;AKjq/CA;EAA0B,YAAA;ALqq/C1B;;AKpq/CA;EAAwB,YAAA;ALwq/CxB;;AKvq/CA;EAAwB,YAAA;AL2q/CxB;;AK1q/CA;EAAoC,YAAA;AL8q/CpC;;AK7q/CA;EAAoC,YAAA;ALir/CpC;;AKhr/CA;EAAwB,YAAA;ALor/CxB;;AKnr/CA;EAAwB,YAAA;ALur/CxB;;AKtr/CA;EAAwB,YAAA;AL0r/CxB;;AKzr/CA;EAAuB,YAAA;AL6r/CvB;;AK5r/CA;EAAuB,YAAA;ALgs/CvB;;AK/r/CA;EAAuB,YAAA;ALms/CvB;;AKls/CA;EAAuB,YAAA;ALss/CvB;;AKrs/CA;EAA0B,YAAA;ALys/C1B;;AKxs/CA;EAA0B,YAAA;AL4s/C1B;;AK3s/CA;EAAwB,YAAA;AL+s/CxB;;AK9s/CA;EAAwB,YAAA;ALkt/CxB;;AKjt/CA;EAAwB,YAAA;ALqt/CxB;;AKpt/CA;EAAwB,YAAA;ALwt/CxB;;AKvt/CA;EAA0B,YAAA;AL2t/C1B;;AK1t/CA;EAA0B,YAAA;AL8t/C1B;;AK7t/CA;EAA2B,YAAA;ALiu/C3B;;AKhu/CA;EAA2B,YAAA;ALou/C3B;;AKnu/CA;EAAsB,YAAA;ALuu/CtB;;AKtu/CA;EAAsB,YAAA;AL0u/CtB;;AMr/jDA;;;;;;;CAAA;ACkmBE;EACE,mBANW;APo6iDf;;AQ15jDA,2EAAA;ACtGE;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,4BAAA;EAAA,kCAAA;EAAA,yBAAA;EAAA,oBAAA;EAAA,yBAAA;EAAA,gCAAA;EAAA,+BAAA;EAAA,gBAAA;EAAA,wBAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAAA,sCAAA;EAAA,4CAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,mCAAA;EAAA,yCAAA;EAAA,yCAAA;EAAA,6BAAA;EAAA,kCAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,yCAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,6BALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,qBAAA;EACA,+BAAA;EAEA,4BAAA;EACA,mCAAA;EAEA,6BAAA;EACA,uCAAA;EACA,uBAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,kCAAA;EACA,0BAAA;EAEA,8BAAA;EACA,wCAAA;EAMA,wBAAA;EACA,6BAAA;EACA,0BAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,sCAAA;EAEA,2BAAA;EACA,6BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,iDAAA;EACA,2DAAA;EACA,qDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,wDAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AVkhkDF;;AYlokDI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,6BAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,8CAAA;EACA,sCAAA;EACA,yBAAA;EACA,gCAAA;EAGE,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,iDAAA;EAAA,mDAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,gDAAA;EAAA,8CAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,wCAAA;EAEA,wBAAA;EACA,6BAAA;EACA,0BAAA;EAEA,0BAAA;EACA,sCAAA;EAEA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AVkhkDJ;;Aa1rkDA;;;EAGE,sBAAA;Ab6rkDF;;Aa9qkDI;EANJ;IAOM,uBAAA;EbkrkDJ;AACF;;AarqkDA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AbwqkDF;;Aa/pkDA;EACE,cAAA;EACA,cNosBS;EMnsBT,SAAA;EACA,wCAAA;EACA,aNysBW;APy9iDb;;AaxpkDA;EACE,aAAA;EACA,qBNonBuB;EMnnBvB,qCNrEsB;EMuEtB,gBNonBqB;EMnnBrB,gBNonBqB;EMnnBrB,8BAAA;Ab0pkDF;;AavpkDA;EFuMQ,qCAAA;AXo9jDR;AWhnkDI;EE3CJ;IF8MQ,oBAAA;EXi9jDN;AACF;;Aa3pkDA;EFkMQ,iCAAA;AX69jDR;AWznkDI;EEtCJ;IFyMQ,kBAAA;EX09jDN;AACF;;Aa/pkDA;EF6LQ,uCAAA;AXs+jDR;AWlokDI;EEjCJ;IFoMQ,qBAAA;EXm+jDN;AACF;;AanqkDA;EFoLM,oBALI;AXw/jDV;;AalqkDA;EF+KM,qBALI;AX4/jDV;;AajqkDA;EF0KM,mBALI;AXggkDV;;Aa1pkDA;EACE,aAAA;EACA,mBN4YwB;APixjD1B;;AanpkDA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;AbspkDF;;AahpkDA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AbmpkDF;;Aa7okDA;;EAEE,kBAAA;AbgpkDF;;Aa7okDA;;;EAGE,aAAA;EACA,mBAAA;AbgpkDF;;Aa7okDA;;;;EAIE,gBAAA;AbgpkDF;;Aa7okDA;EACE,gBNwfqB;APwpjDvB;;Aa3okDA;EACE,qBAAA;EACA,cAAA;Ab8okDF;;AaxokDA;EACE,gBAAA;Ab2okDF;;AanokDA;;EAEE,mBNkemB;APoqjDrB;;Aa9nkDA;EF6EM,kBALI;AX0jkDV;;Aa3nkDA;EACE,cNikBa;EMhkBb,gCAAA;EACA,wCAAA;Ab8nkDF;;AarnkDA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;AbwnkDF;;AarnkDA;EAAM,eAAA;AbynkDN;;AaxnkDA;EAAM,WAAA;Ab4nkDN;;AavnkDA;EACE,gEAAA;EACA,qBNoQgB;APs3jDlB;AaxnkDE;EACE,mDAAA;Ab0nkDJ;;Aa/mkDE;EAEE,cAAA;EACA,qBAAA;AbinkDJ;;Aa1mkDA;;;;EAIE,qCN4YiB;EI9Xb,cALI;AXqmkDV;;AatmkDA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;AX6mkDV;AarmkDE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;AbumkDJ;;AanmkDA;EFVM,kBALI;EEiBR,2BAAA;EACA,qBAAA;AbsmkDF;AanmkDE;EACE,cAAA;AbqmkDJ;;AajmkDA;EACE,sBAAA;EFtBI,kBALI;EE6BR,wBN+/CU;EM9/CV,sCN+/CO;EOpyDL,qBAAA;Ad04kDJ;AalmkDE;EACE,UAAA;EF7BE,cALI;AXuokDV;;Aa1lkDA;EACE,gBAAA;Ab6lkDF;;AavlkDA;;EAEE,sBAAA;Ab0lkDF;;AallkDA;EACE,oBAAA;EACA,yBAAA;AbqlkDF;;AallkDA;EACE,oBNscqB;EMrcrB,uBNqcqB;EMpcrB,gCN4eoB;EM3epB,gBAAA;AbqlkDF;;Aa9kkDA;EACE,gBNiUqB;EMhUrB,mBAAA;EACA,gCAAA;AbilkDF;;Aa9kkDA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AbilkDF;;AazkkDA;EACE,qBAAA;Ab4kkDF;;AatkkDA;EAEE,gBAAA;AbwkkDF;;AahkkDA;EACE,UAAA;AbmkkDF;;Aa9jkDA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;AbikkDF;;Aa7jkDA;;EAEE,oBAAA;AbgkkDF;;Aa3jkDA;EACE,eAAA;Ab8jkDF;;Aa3jkDA;EAGE,iBAAA;Ab4jkDF;AazjkDE;EACE,UAAA;Ab2jkDJ;;AapjkDA;EACE,wBAAA;AbujkDF;;Aa/ikDA;;;;EAIE,0BAAA;AbkjkDF;Aa/ikDI;;;;EACE,eAAA;AbojkDN;;Aa7ikDA;EACE,UAAA;EACA,kBAAA;AbgjkDF;;Aa3ikDA;EACE,gBAAA;Ab8ikDF;;AapikDA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AbuikDF;;Aa/hkDA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBN+RqB;EIhff,iCAAA;EEoNN,oBAAA;AbiikDF;AWj5kDI;EEyWJ;IFtMQ,iBAAA;EXkvkDN;AACF;AapikDE;EACE,WAAA;AbsikDJ;;Aa/hkDA;;;;;;;EAOE,UAAA;AbkikDF;;Aa/hkDA;EACE,YAAA;AbkikDF;;AazhkDA;EACE,6BAAA;EACA,oBAAA;Ab4hkDF;;AaphkDA;;;;;;;CAAA;AAWA;EACE,wBAAA;AbohkDF;;Aa/gkDA;EACE,UAAA;AbkhkDF;;Aa3gkDA;EACE,aAAA;EACA,0BAAA;Ab8gkDF;;AazgkDA;EACE,qBAAA;Ab4gkDF;;AavgkDA;EACE,SAAA;Ab0gkDF;;AangkDA;EACE,kBAAA;EACA,eAAA;AbsgkDF;;Aa9/jDA;EACE,wBAAA;AbigkDF;;Aaz/jDA;EACE,wBAAA;Ab4/jDF;;AejklDA;EJmQM,qBALI;EI5PR,gBRytBiB;AP22jDnB;;Ae/jlDE;EJgQM,iCAAA;EI5PJ,gBRqrBkB;EQprBlB,gBRoqBmB;AP45jDvB;AWj+kDI;EIpGF;IJuQM,eAAA;EXk0kDN;AACF;;Ae1klDE;EJgQM,iCAAA;EI5PJ,gBRqrBkB;EQprBlB,gBRoqBmB;APu6jDvB;AW5+kDI;EIpGF;IJuQM,iBAAA;EX60kDN;AACF;;AerllDE;EJgQM,iCAAA;EI5PJ,gBRqrBkB;EQprBlB,gBRoqBmB;APk7jDvB;AWv/kDI;EIpGF;IJuQM,eAAA;EXw1kDN;AACF;;AehmlDE;EJgQM,iCAAA;EI5PJ,gBRqrBkB;EQprBlB,gBRoqBmB;AP67jDvB;AWlglDI;EIpGF;IJuQM,iBAAA;EXm2kDN;AACF;;Ae3mlDE;EJgQM,iCAAA;EI5PJ,gBRqrBkB;EQprBlB,gBRoqBmB;APw8jDvB;AW7glDI;EIpGF;IJuQM,eAAA;EX82kDN;AACF;;AetnlDE;EJgQM,iCAAA;EI5PJ,gBRqrBkB;EQprBlB,gBRoqBmB;APm9jDvB;AWxhlDI;EIpGF;IJuQM,iBAAA;EXy3kDN;AACF;;AezmlDA;ECvDE,eAAA;EACA,gBAAA;AhBoqlDF;;AezmlDA;EC5DE,eAAA;EACA,gBAAA;AhByqlDF;;Ae3mlDA;EACE,qBAAA;Af8mlDF;Ae5mlDE;EACE,oBRktBkB;AP45jDtB;;AepmlDA;EJ8MM,kBALI;EIvMR,yBAAA;AfumlDF;;AenmlDA;EACE,mBRmXO;EI5KH,oBALI;AXq6kDV;AepmlDE;EACE,gBAAA;AfsmlDJ;;AelmlDA;EACE,iBAAA;EACA,mBRyWO;EI5KH,kBALI;EItLR,cRzDS;AP8plDX;AenmlDE;EACE,aAAA;AfqmlDJ;;AiBrslDA;ECIE,eAAA;EAGA,YAAA;AlBmslDF;;AiBpslDA;EACE,gBV0qDkB;EUzqDlB,mCV0qDa;EUzqDb,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;AlB4slDF;;AiB9rlDA;EAEE,qBAAA;AjBgslDF;;AiB7rlDA;EACE,qBAAA;EACA,cAAA;AjBgslDF;;AiB7rlDA;ENyPM,kBALI;EMlPR,gCV4pDqB;APoiiDvB;;AmBlulDE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,4CAAA;EACA,2CAAA;EACA,kBAAA;EACA,iBAAA;ApB+ulDF;;AqBzrlDI;EF5CE;IACE,gBZohBe;EPqtkDrB;AACF;AqB/rlDI;EF5CE;IACE,gBZohBe;EP0tkDrB;AACF;AqBpslDI;EF5CE;IACE,gBZohBe;EP+tkDrB;AACF;AqBzslDI;EF5CE;IACE,iBZohBe;EPoukDrB;AACF;AqB9slDI;EF5CE;IACE,iBZohBe;EPyukDrB;AACF;AsB9wlDA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AtBoxlDJ;;AsB/wlDE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,4CAAA;EACA,2CAAA;AvBwxlDF;AsBtxlDI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,4CAAA;EACA,2CAAA;EACA,8BAAA;AvBkxlDF;;AuBnulDM;EACE,SAAA;AvBsulDR;;AuBnulDM;EApCJ,cAAA;EACA,WAAA;AvB2wlDF;;AuB7vlDE;EACE,cAAA;EACA,WAAA;AvBgwlDJ;;AuBlwlDE;EACE,cAAA;EACA,UAAA;AvBqwlDJ;;AuBvwlDE;EACE,cAAA;EACA,mBAAA;AvB0wlDJ;;AuB5wlDE;EACE,cAAA;EACA,UAAA;AvB+wlDJ;;AuBjxlDE;EACE,cAAA;EACA,UAAA;AvBoxlDJ;;AuBtxlDE;EACE,cAAA;EACA,mBAAA;AvByxlDJ;;AuB1vlDM;EAhDJ,cAAA;EACA,WAAA;AvB8ylDF;;AuBzvlDU;EAhEN,cAAA;EACA,kBAAA;AvB6zlDJ;;AuB9vlDU;EAhEN,cAAA;EACA,mBAAA;AvBk0lDJ;;AuBnwlDU;EAhEN,cAAA;EACA,UAAA;AvBu0lDJ;;AuBxwlDU;EAhEN,cAAA;EACA,mBAAA;AvB40lDJ;;AuB7wlDU;EAhEN,cAAA;EACA,mBAAA;AvBi1lDJ;;AuBlxlDU;EAhEN,cAAA;EACA,UAAA;AvBs1lDJ;;AuBvxlDU;EAhEN,cAAA;EACA,mBAAA;AvB21lDJ;;AuB5xlDU;EAhEN,cAAA;EACA,mBAAA;AvBg2lDJ;;AuBjylDU;EAhEN,cAAA;EACA,UAAA;AvBq2lDJ;;AuBtylDU;EAhEN,cAAA;EACA,mBAAA;AvB02lDJ;;AuB3ylDU;EAhEN,cAAA;EACA,mBAAA;AvB+2lDJ;;AuBhzlDU;EAhEN,cAAA;EACA,WAAA;AvBo3lDJ;;AuB7ylDY;EAxDV,wBAAA;AvBy2lDF;;AuBjzlDY;EAxDV,yBAAA;AvB62lDF;;AuBrzlDY;EAxDV,gBAAA;AvBi3lDF;;AuBzzlDY;EAxDV,yBAAA;AvBq3lDF;;AuB7zlDY;EAxDV,yBAAA;AvBy3lDF;;AuBj0lDY;EAxDV,gBAAA;AvB63lDF;;AuBr0lDY;EAxDV,yBAAA;AvBi4lDF;;AuBz0lDY;EAxDV,yBAAA;AvBq4lDF;;AuB70lDY;EAxDV,gBAAA;AvBy4lDF;;AuBj1lDY;EAxDV,yBAAA;AvB64lDF;;AuBr1lDY;EAxDV,yBAAA;AvBi5lDF;;AuB90lDQ;;EAEE,gBAAA;AvBi1lDV;;AuB90lDQ;;EAEE,gBAAA;AvBi1lDV;;AuBx1lDQ;;EAEE,sBAAA;AvB21lDV;;AuBx1lDQ;;EAEE,sBAAA;AvB21lDV;;AuBl2lDQ;;EAEE,qBAAA;AvBq2lDV;;AuBl2lDQ;;EAEE,qBAAA;AvBq2lDV;;AuB52lDQ;;EAEE,mBAAA;AvB+2lDV;;AuB52lDQ;;EAEE,mBAAA;AvB+2lDV;;AuBt3lDQ;;EAEE,qBAAA;AvBy3lDV;;AuBt3lDQ;;EAEE,qBAAA;AvBy3lDV;;AuBh4lDQ;;EAEE,mBAAA;AvBm4lDV;;AuBh4lDQ;;EAEE,mBAAA;AvBm4lDV;;AqB77lDI;EEUE;IACE,SAAA;EvBu7lDN;;EuBp7lDI;IApCJ,cAAA;IACA,WAAA;EvB49lDA;;EuB98lDA;IACE,cAAA;IACA,WAAA;EvBi9lDF;;EuBn9lDA;IACE,cAAA;IACA,UAAA;EvBs9lDF;;EuBx9lDA;IACE,cAAA;IACA,mBAAA;EvB29lDF;;EuB79lDA;IACE,cAAA;IACA,UAAA;EvBg+lDF;;EuBl+lDA;IACE,cAAA;IACA,UAAA;EvBq+lDF;;EuBv+lDA;IACE,cAAA;IACA,mBAAA;EvB0+lDF;;EuB38lDI;IAhDJ,cAAA;IACA,WAAA;EvB+/lDA;;EuB18lDQ;IAhEN,cAAA;IACA,kBAAA;EvB8gmDF;;EuB/8lDQ;IAhEN,cAAA;IACA,mBAAA;EvBmhmDF;;EuBp9lDQ;IAhEN,cAAA;IACA,UAAA;EvBwhmDF;;EuBz9lDQ;IAhEN,cAAA;IACA,mBAAA;EvB6hmDF;;EuB99lDQ;IAhEN,cAAA;IACA,mBAAA;EvBkimDF;;EuBn+lDQ;IAhEN,cAAA;IACA,UAAA;EvBuimDF;;EuBx+lDQ;IAhEN,cAAA;IACA,mBAAA;EvB4imDF;;EuB7+lDQ;IAhEN,cAAA;IACA,mBAAA;EvBijmDF;;EuBl/lDQ;IAhEN,cAAA;IACA,UAAA;EvBsjmDF;;EuBv/lDQ;IAhEN,cAAA;IACA,mBAAA;EvB2jmDF;;EuB5/lDQ;IAhEN,cAAA;IACA,mBAAA;EvBgkmDF;;EuBjgmDQ;IAhEN,cAAA;IACA,WAAA;EvBqkmDF;;EuB9/lDU;IAxDV,cAAA;EvB0jmDA;;EuBlgmDU;IAxDV,wBAAA;EvB8jmDA;;EuBtgmDU;IAxDV,yBAAA;EvBkkmDA;;EuB1gmDU;IAxDV,gBAAA;EvBskmDA;;EuB9gmDU;IAxDV,yBAAA;EvB0kmDA;;EuBlhmDU;IAxDV,yBAAA;EvB8kmDA;;EuBthmDU;IAxDV,gBAAA;EvBklmDA;;EuB1hmDU;IAxDV,yBAAA;EvBslmDA;;EuB9hmDU;IAxDV,yBAAA;EvB0lmDA;;EuBlimDU;IAxDV,gBAAA;EvB8lmDA;;EuBtimDU;IAxDV,yBAAA;EvBkmmDA;;EuB1imDU;IAxDV,yBAAA;EvBsmmDA;;EuBnimDM;;IAEE,gBAAA;EvBsimDR;;EuBnimDM;;IAEE,gBAAA;EvBsimDR;;EuB7imDM;;IAEE,sBAAA;EvBgjmDR;;EuB7imDM;;IAEE,sBAAA;EvBgjmDR;;EuBvjmDM;;IAEE,qBAAA;EvB0jmDR;;EuBvjmDM;;IAEE,qBAAA;EvB0jmDR;;EuBjkmDM;;IAEE,mBAAA;EvBokmDR;;EuBjkmDM;;IAEE,mBAAA;EvBokmDR;;EuB3kmDM;;IAEE,qBAAA;EvB8kmDR;;EuB3kmDM;;IAEE,qBAAA;EvB8kmDR;;EuBrlmDM;;IAEE,mBAAA;EvBwlmDR;;EuBrlmDM;;IAEE,mBAAA;EvBwlmDR;AACF;AqBnpmDI;EEUE;IACE,SAAA;EvB4omDN;;EuBzomDI;IApCJ,cAAA;IACA,WAAA;EvBirmDA;;EuBnqmDA;IACE,cAAA;IACA,WAAA;EvBsqmDF;;EuBxqmDA;IACE,cAAA;IACA,UAAA;EvB2qmDF;;EuB7qmDA;IACE,cAAA;IACA,mBAAA;EvBgrmDF;;EuBlrmDA;IACE,cAAA;IACA,UAAA;EvBqrmDF;;EuBvrmDA;IACE,cAAA;IACA,UAAA;EvB0rmDF;;EuB5rmDA;IACE,cAAA;IACA,mBAAA;EvB+rmDF;;EuBhqmDI;IAhDJ,cAAA;IACA,WAAA;EvBotmDA;;EuB/pmDQ;IAhEN,cAAA;IACA,kBAAA;EvBmumDF;;EuBpqmDQ;IAhEN,cAAA;IACA,mBAAA;EvBwumDF;;EuBzqmDQ;IAhEN,cAAA;IACA,UAAA;EvB6umDF;;EuB9qmDQ;IAhEN,cAAA;IACA,mBAAA;EvBkvmDF;;EuBnrmDQ;IAhEN,cAAA;IACA,mBAAA;EvBuvmDF;;EuBxrmDQ;IAhEN,cAAA;IACA,UAAA;EvB4vmDF;;EuB7rmDQ;IAhEN,cAAA;IACA,mBAAA;EvBiwmDF;;EuBlsmDQ;IAhEN,cAAA;IACA,mBAAA;EvBswmDF;;EuBvsmDQ;IAhEN,cAAA;IACA,UAAA;EvB2wmDF;;EuB5smDQ;IAhEN,cAAA;IACA,mBAAA;EvBgxmDF;;EuBjtmDQ;IAhEN,cAAA;IACA,mBAAA;EvBqxmDF;;EuBttmDQ;IAhEN,cAAA;IACA,WAAA;EvB0xmDF;;EuBntmDU;IAxDV,cAAA;EvB+wmDA;;EuBvtmDU;IAxDV,wBAAA;EvBmxmDA;;EuB3tmDU;IAxDV,yBAAA;EvBuxmDA;;EuB/tmDU;IAxDV,gBAAA;EvB2xmDA;;EuBnumDU;IAxDV,yBAAA;EvB+xmDA;;EuBvumDU;IAxDV,yBAAA;EvBmymDA;;EuB3umDU;IAxDV,gBAAA;EvBuymDA;;EuB/umDU;IAxDV,yBAAA;EvB2ymDA;;EuBnvmDU;IAxDV,yBAAA;EvB+ymDA;;EuBvvmDU;IAxDV,gBAAA;EvBmzmDA;;EuB3vmDU;IAxDV,yBAAA;EvBuzmDA;;EuB/vmDU;IAxDV,yBAAA;EvB2zmDA;;EuBxvmDM;;IAEE,gBAAA;EvB2vmDR;;EuBxvmDM;;IAEE,gBAAA;EvB2vmDR;;EuBlwmDM;;IAEE,sBAAA;EvBqwmDR;;EuBlwmDM;;IAEE,sBAAA;EvBqwmDR;;EuB5wmDM;;IAEE,qBAAA;EvB+wmDR;;EuB5wmDM;;IAEE,qBAAA;EvB+wmDR;;EuBtxmDM;;IAEE,mBAAA;EvByxmDR;;EuBtxmDM;;IAEE,mBAAA;EvByxmDR;;EuBhymDM;;IAEE,qBAAA;EvBmymDR;;EuBhymDM;;IAEE,qBAAA;EvBmymDR;;EuB1ymDM;;IAEE,mBAAA;EvB6ymDR;;EuB1ymDM;;IAEE,mBAAA;EvB6ymDR;AACF;AqBx2mDI;EEUE;IACE,SAAA;EvBi2mDN;;EuB91mDI;IApCJ,cAAA;IACA,WAAA;EvBs4mDA;;EuBx3mDA;IACE,cAAA;IACA,WAAA;EvB23mDF;;EuB73mDA;IACE,cAAA;IACA,UAAA;EvBg4mDF;;EuBl4mDA;IACE,cAAA;IACA,mBAAA;EvBq4mDF;;EuBv4mDA;IACE,cAAA;IACA,UAAA;EvB04mDF;;EuB54mDA;IACE,cAAA;IACA,UAAA;EvB+4mDF;;EuBj5mDA;IACE,cAAA;IACA,mBAAA;EvBo5mDF;;EuBr3mDI;IAhDJ,cAAA;IACA,WAAA;EvBy6mDA;;EuBp3mDQ;IAhEN,cAAA;IACA,kBAAA;EvBw7mDF;;EuBz3mDQ;IAhEN,cAAA;IACA,mBAAA;EvB67mDF;;EuB93mDQ;IAhEN,cAAA;IACA,UAAA;EvBk8mDF;;EuBn4mDQ;IAhEN,cAAA;IACA,mBAAA;EvBu8mDF;;EuBx4mDQ;IAhEN,cAAA;IACA,mBAAA;EvB48mDF;;EuB74mDQ;IAhEN,cAAA;IACA,UAAA;EvBi9mDF;;EuBl5mDQ;IAhEN,cAAA;IACA,mBAAA;EvBs9mDF;;EuBv5mDQ;IAhEN,cAAA;IACA,mBAAA;EvB29mDF;;EuB55mDQ;IAhEN,cAAA;IACA,UAAA;EvBg+mDF;;EuBj6mDQ;IAhEN,cAAA;IACA,mBAAA;EvBq+mDF;;EuBt6mDQ;IAhEN,cAAA;IACA,mBAAA;EvB0+mDF;;EuB36mDQ;IAhEN,cAAA;IACA,WAAA;EvB++mDF;;EuBx6mDU;IAxDV,cAAA;EvBo+mDA;;EuB56mDU;IAxDV,wBAAA;EvBw+mDA;;EuBh7mDU;IAxDV,yBAAA;EvB4+mDA;;EuBp7mDU;IAxDV,gBAAA;EvBg/mDA;;EuBx7mDU;IAxDV,yBAAA;EvBo/mDA;;EuB57mDU;IAxDV,yBAAA;EvBw/mDA;;EuBh8mDU;IAxDV,gBAAA;EvB4/mDA;;EuBp8mDU;IAxDV,yBAAA;EvBggnDA;;EuBx8mDU;IAxDV,yBAAA;EvBognDA;;EuB58mDU;IAxDV,gBAAA;EvBwgnDA;;EuBh9mDU;IAxDV,yBAAA;EvB4gnDA;;EuBp9mDU;IAxDV,yBAAA;EvBghnDA;;EuB78mDM;;IAEE,gBAAA;EvBg9mDR;;EuB78mDM;;IAEE,gBAAA;EvBg9mDR;;EuBv9mDM;;IAEE,sBAAA;EvB09mDR;;EuBv9mDM;;IAEE,sBAAA;EvB09mDR;;EuBj+mDM;;IAEE,qBAAA;EvBo+mDR;;EuBj+mDM;;IAEE,qBAAA;EvBo+mDR;;EuB3+mDM;;IAEE,mBAAA;EvB8+mDR;;EuB3+mDM;;IAEE,mBAAA;EvB8+mDR;;EuBr/mDM;;IAEE,qBAAA;EvBw/mDR;;EuBr/mDM;;IAEE,qBAAA;EvBw/mDR;;EuB//mDM;;IAEE,mBAAA;EvBkgnDR;;EuB//mDM;;IAEE,mBAAA;EvBkgnDR;AACF;AqB7jnDI;EEUE;IACE,SAAA;EvBsjnDN;;EuBnjnDI;IApCJ,cAAA;IACA,WAAA;EvB2lnDA;;EuB7knDA;IACE,cAAA;IACA,WAAA;EvBglnDF;;EuBllnDA;IACE,cAAA;IACA,UAAA;EvBqlnDF;;EuBvlnDA;IACE,cAAA;IACA,mBAAA;EvB0lnDF;;EuB5lnDA;IACE,cAAA;IACA,UAAA;EvB+lnDF;;EuBjmnDA;IACE,cAAA;IACA,UAAA;EvBomnDF;;EuBtmnDA;IACE,cAAA;IACA,mBAAA;EvBymnDF;;EuB1knDI;IAhDJ,cAAA;IACA,WAAA;EvB8nnDA;;EuBzknDQ;IAhEN,cAAA;IACA,kBAAA;EvB6onDF;;EuB9knDQ;IAhEN,cAAA;IACA,mBAAA;EvBkpnDF;;EuBnlnDQ;IAhEN,cAAA;IACA,UAAA;EvBupnDF;;EuBxlnDQ;IAhEN,cAAA;IACA,mBAAA;EvB4pnDF;;EuB7lnDQ;IAhEN,cAAA;IACA,mBAAA;EvBiqnDF;;EuBlmnDQ;IAhEN,cAAA;IACA,UAAA;EvBsqnDF;;EuBvmnDQ;IAhEN,cAAA;IACA,mBAAA;EvB2qnDF;;EuB5mnDQ;IAhEN,cAAA;IACA,mBAAA;EvBgrnDF;;EuBjnnDQ;IAhEN,cAAA;IACA,UAAA;EvBqrnDF;;EuBtnnDQ;IAhEN,cAAA;IACA,mBAAA;EvB0rnDF;;EuB3nnDQ;IAhEN,cAAA;IACA,mBAAA;EvB+rnDF;;EuBhonDQ;IAhEN,cAAA;IACA,WAAA;EvBosnDF;;EuB7nnDU;IAxDV,cAAA;EvByrnDA;;EuBjonDU;IAxDV,wBAAA;EvB6rnDA;;EuBronDU;IAxDV,yBAAA;EvBisnDA;;EuBzonDU;IAxDV,gBAAA;EvBqsnDA;;EuB7onDU;IAxDV,yBAAA;EvBysnDA;;EuBjpnDU;IAxDV,yBAAA;EvB6snDA;;EuBrpnDU;IAxDV,gBAAA;EvBitnDA;;EuBzpnDU;IAxDV,yBAAA;EvBqtnDA;;EuB7pnDU;IAxDV,yBAAA;EvBytnDA;;EuBjqnDU;IAxDV,gBAAA;EvB6tnDA;;EuBrqnDU;IAxDV,yBAAA;EvBiunDA;;EuBzqnDU;IAxDV,yBAAA;EvBqunDA;;EuBlqnDM;;IAEE,gBAAA;EvBqqnDR;;EuBlqnDM;;IAEE,gBAAA;EvBqqnDR;;EuB5qnDM;;IAEE,sBAAA;EvB+qnDR;;EuB5qnDM;;IAEE,sBAAA;EvB+qnDR;;EuBtrnDM;;IAEE,qBAAA;EvByrnDR;;EuBtrnDM;;IAEE,qBAAA;EvByrnDR;;EuBhsnDM;;IAEE,mBAAA;EvBmsnDR;;EuBhsnDM;;IAEE,mBAAA;EvBmsnDR;;EuB1snDM;;IAEE,qBAAA;EvB6snDR;;EuB1snDM;;IAEE,qBAAA;EvB6snDR;;EuBptnDM;;IAEE,mBAAA;EvButnDR;;EuBptnDM;;IAEE,mBAAA;EvButnDR;AACF;AqBlxnDI;EEUE;IACE,SAAA;EvB2wnDN;;EuBxwnDI;IApCJ,cAAA;IACA,WAAA;EvBgznDA;;EuBlynDA;IACE,cAAA;IACA,WAAA;EvBqynDF;;EuBvynDA;IACE,cAAA;IACA,UAAA;EvB0ynDF;;EuB5ynDA;IACE,cAAA;IACA,mBAAA;EvB+ynDF;;EuBjznDA;IACE,cAAA;IACA,UAAA;EvBoznDF;;EuBtznDA;IACE,cAAA;IACA,UAAA;EvByznDF;;EuB3znDA;IACE,cAAA;IACA,mBAAA;EvB8znDF;;EuB/xnDI;IAhDJ,cAAA;IACA,WAAA;EvBm1nDA;;EuB9xnDQ;IAhEN,cAAA;IACA,kBAAA;EvBk2nDF;;EuBnynDQ;IAhEN,cAAA;IACA,mBAAA;EvBu2nDF;;EuBxynDQ;IAhEN,cAAA;IACA,UAAA;EvB42nDF;;EuB7ynDQ;IAhEN,cAAA;IACA,mBAAA;EvBi3nDF;;EuBlznDQ;IAhEN,cAAA;IACA,mBAAA;EvBs3nDF;;EuBvznDQ;IAhEN,cAAA;IACA,UAAA;EvB23nDF;;EuB5znDQ;IAhEN,cAAA;IACA,mBAAA;EvBg4nDF;;EuBj0nDQ;IAhEN,cAAA;IACA,mBAAA;EvBq4nDF;;EuBt0nDQ;IAhEN,cAAA;IACA,UAAA;EvB04nDF;;EuB30nDQ;IAhEN,cAAA;IACA,mBAAA;EvB+4nDF;;EuBh1nDQ;IAhEN,cAAA;IACA,mBAAA;EvBo5nDF;;EuBr1nDQ;IAhEN,cAAA;IACA,WAAA;EvBy5nDF;;EuBl1nDU;IAxDV,cAAA;EvB84nDA;;EuBt1nDU;IAxDV,wBAAA;EvBk5nDA;;EuB11nDU;IAxDV,yBAAA;EvBs5nDA;;EuB91nDU;IAxDV,gBAAA;EvB05nDA;;EuBl2nDU;IAxDV,yBAAA;EvB85nDA;;EuBt2nDU;IAxDV,yBAAA;EvBk6nDA;;EuB12nDU;IAxDV,gBAAA;EvBs6nDA;;EuB92nDU;IAxDV,yBAAA;EvB06nDA;;EuBl3nDU;IAxDV,yBAAA;EvB86nDA;;EuBt3nDU;IAxDV,gBAAA;EvBk7nDA;;EuB13nDU;IAxDV,yBAAA;EvBs7nDA;;EuB93nDU;IAxDV,yBAAA;EvB07nDA;;EuBv3nDM;;IAEE,gBAAA;EvB03nDR;;EuBv3nDM;;IAEE,gBAAA;EvB03nDR;;EuBj4nDM;;IAEE,sBAAA;EvBo4nDR;;EuBj4nDM;;IAEE,sBAAA;EvBo4nDR;;EuB34nDM;;IAEE,qBAAA;EvB84nDR;;EuB34nDM;;IAEE,qBAAA;EvB84nDR;;EuBr5nDM;;IAEE,mBAAA;EvBw5nDR;;EuBr5nDM;;IAEE,mBAAA;EvBw5nDR;;EuB/5nDM;;IAEE,qBAAA;EvBk6nDR;;EuB/5nDM;;IAEE,qBAAA;EvBk6nDR;;EuBz6nDM;;IAEE,mBAAA;EvB46nDR;;EuBz6nDM;;IAEE,mBAAA;EvB46nDR;AACF;AwBlioDA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,sCAAA;EACA,0BAAA;EACA,+CAAA;EACA,iCAAA;EACA,8CAAA;EACA,2DAAA;EACA,6CAAA;EACA,0DAAA;EACA,4CAAA;EACA,yDAAA;EAEA,WAAA;EACA,mBjBobO;EiBnbP,mBjBixB0B;EiBhxB1B,0CAAA;AxBiioDF;AwB1hoDE;EACE,uBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2CjB+xBiB;EiB9xBjB,2GAAA;AxB2hoDJ;AwBxhoDE;EACE,uBAAA;AxB0hoDJ;AwBvhoDE;EACE,sBAAA;AxByhoDJ;;AwBrhoDA;EACE,+DAAA;AxBwhoDF;;AwBjhoDA;EACE,iBAAA;AxBohoDF;;AwB1goDE;EACE,uBAAA;AxB6goDJ;;AwB9/nDE;EACE,sCAAA;AxBigoDJ;AwB9/nDI;EACE,sCAAA;AxBggoDN;;AwBz/nDE;EACE,sBAAA;AxB4/nDJ;AwBz/nDE;EACE,mBAAA;AxB2/nDJ;;AwBj/nDE;EACE,oDAAA;EACA,8CAAA;AxBo/nDJ;;AwB9+nDE;EACE,oDAAA;EACA,8CAAA;AxBi/nDJ;;AwBz+nDA;EACE,oDAAA;EACA,8CAAA;AxB4+nDF;;AwBp+nDE;EACE,mDAAA;EACA,6CAAA;AxBu+nDJ;;AyBnnoDE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AzB+moDJ;;AyBjooDE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AzB6noDJ;;AyB/ooDE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AzB2ooDJ;;AyB7poDE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AzBypoDJ;;AyB3qoDE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AzBuqoDJ;;AyBzroDE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AzBqroDJ;;AyBvsoDE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AzBmsoDJ;;AyBrtoDE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AzBitoDJ;;AwBhkoDI;EACE,gBAAA;EACA,iCAAA;AxBmkoDN;;AqB9poDI;EGyFA;IACE,gBAAA;IACA,iCAAA;ExBykoDJ;AACF;AqBrqoDI;EGyFA;IACE,gBAAA;IACA,iCAAA;ExB+koDJ;AACF;AqB3qoDI;EGyFA;IACE,gBAAA;IACA,iCAAA;ExBqloDJ;AACF;AqBjroDI;EGyFA;IACE,gBAAA;IACA,iCAAA;ExB2loDJ;AACF;AqBvroDI;EGyFA;IACE,gBAAA;IACA,iCAAA;ExBimoDJ;AACF;A0BrwoDA;EACE,qBnBo7ByB;APm1mD3B;;A0B9voDA;EACE,kDAAA;EACA,qDAAA;EACA,gBAAA;Ef8QI,kBALI;EerQR,gBnB2pBiB;APomnDnB;;A0B3voDA;EACE,kDAAA;EACA,qDAAA;EfoQI,qBALI;AXggoDV;;A0B3voDA;EACE,mDAAA;EACA,sDAAA;Ef8PI,sBALI;AXsgoDV;;A2B5xoDA;EACE,mBpB46BqB;EIlpBjB,kBALI;EgBjRR,gCpB46BgB;APi3mDlB;;A4BlyoDA;EACE,cAAA;EACA,WAAA;EACA,sBAAA;EjBwRI,mBALI;EiBhRR,gBrB8pBmB;EqB7pBnB,gBrBqqBiB;EqBpqBjB,2BrBy8BY;EqBx8BZ,gBAAA;EACA,2CrBk8BS;EqBj8BT,4BAAA;EACA,kEAAA;EdGE,sCAAA;EeHE,wEDMJ;A5BgyoDF;A6BlyoDM;EDhBN;ICiBQ,gBAAA;E7BqyoDN;AACF;A4BnyoDE;EACE,gBAAA;A5BqyoDJ;A4BnyoDI;EACE,eAAA;A5BqyoDN;A4BhyoDE;EACE,2BrBm7BU;EqBl7BV,2CrB66BO;EqB56BP,6CrB27BuB;EqB17BvB,UAAA;EAKE,2DrB6kBkB;APitnDxB;A4B1xoDE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;A5B8woDJ;A4BzwoDE;EACE,cAAA;EACA,UAAA;A5B2woDJ;A4BvwoDE;EACE,gCrBy5BsB;EqBv5BtB,UAAA;A5BwwoDJ;A4BhwoDE;EAEE,uCrB23BgB;EqBx3BhB,UAAA;A5B+voDJ;A4B3voDE;EACE,sBAAA;EACA,uBAAA;EACA,yBrBmwBkB;EqBlwBlB,2BrBm3BU;EuBj9BZ,yBvBkUc;EqBlOZ,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CrB+wBqB;EqB9wBrB,gBAAA;ECzFE,qID0FF;A5B6voDJ;A6Bn1oDM;ED0EJ;ICzEM,gBAAA;E7Bs1oDN;AACF;A4B/voDE;EACE,wCrB0hCwB;APuumD5B;;A4BxvoDA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBrBojBiB;EqBnjBjB,2BrBw2BsB;EqBv2BtB,6BAAA;EACA,yBAAA;EACA,sCAAA;A5B2voDF;A4BzvoDE;EACE,UAAA;A5B2voDJ;A4BxvoDE;EAEE,gBAAA;EACA,eAAA;A5ByvoDJ;;A4B9uoDA;EACE,qErBi2BgB;EqBh2BhB,uBAAA;EjByII,sBALI;EGvQN,yCAAA;Ads3oDJ;A4B/uoDE;EACE,uBAAA;EACA,wBAAA;EACA,yBrBmtBqB;AP8hnDzB;;A4B7uoDA;EACE,qErBw1BgB;EqBv1BhB,sBAAA;EjB4HI,qBALI;EGvQN,yCAAA;Adk4oDJ;A4B9uoDE;EACE,sBAAA;EACA,uBAAA;EACA,yBrB0sBqB;APsinDzB;;A4BxuoDE;EACE,mErB+zBW;AP46mDf;A4BxuoDE;EACE,qErB+zBc;AP26mDlB;A4BvuoDE;EACE,qErB+zBc;AP06mDlB;;A4BpuoDA;EACE,WrB+zBiB;EqB9zBjB,+DrBgzBa;EqB/yBb,erBgqBoB;APuknDtB;A4BruoDE;EACE,eAAA;A5BuuoDJ;A4BpuoDE;EACE,oBAAA;EdvLA,sCAAA;Ad85oDJ;A4BnuoDE;EACE,oBAAA;Ed5LA,sCAAA;Adk6oDJ;A4BluoDE;EAAoB,iErBmyBJ;APk8mDlB;A4BpuoDE;EAAoB,iErBsyBJ;APi8mDlB;;A+Bt7oDA;EACE,iEAAA;EAEA,cAAA;EACA,WAAA;EACA,qCAAA;EpBqRI,mBALI;EoB7QR,gBxB2pBmB;EwB1pBnB,gBxBkqBiB;EwBjqBjB,2BxBs8BY;EwBr8BZ,gBAAA;EACA,2CxB+7BS;EwB97BT,mFAAA;EACA,4BAAA;EACA,wCxB0jCwB;EwBzjCxB,0BxB0jCoB;EwBzjCpB,kEAAA;EjBHE,sCAAA;EeHE,wEESJ;A/Bs7oDF;A6B37oDM;EEfN;IFgBQ,gBAAA;E7B87oDN;AACF;A+Bz7oDE;EACE,6CxBm8BuB;EwBl8BvB,UAAA;EAKE,2DxB6jCyB;AP03mD/B;A+Bn7oDE;EAEE,qBxB4zBkB;EwB3zBlB,sBAAA;A/Bo7oDJ;A+Bj7oDE;EAEE,uCxBo6BgB;AP8gnDpB;A+B76oDE;EACE,kBAAA;EACA,uCAAA;A/B+6oDJ;;A+B36oDA;EACE,oBxBqzBuB;EwBpzBvB,uBxBozBuB;EwBnzBvB,oBxBozBuB;EIjlBnB,sBALI;EGvQN,yCAAA;Ady9oDJ;;A+B36oDA;EACE,mBxBizBuB;EwBhzBvB,sBxBgzBuB;EwB/yBvB,oBxBgzBuB;EIrlBnB,qBALI;EGvQN,yCAAA;Adi+oDJ;;A+Bz6oDI;EACE,iEAAA;A/B46oDN;;AgCp/oDA;EACE,cAAA;EACA,qBzB+/BsB;EyB9/BtB,mBzB+/ByB;EyB9/BzB,uBzB+/ByB;APw/mD3B;AgCr/oDE;EACE,WAAA;EACA,mBAAA;AhCu/oDJ;;AgCn/oDA;EACE,oBzBq/ByB;EyBp/BzB,eAAA;EACA,iBAAA;AhCs/oDF;AgCp/oDE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;AhCs/oDJ;;AgCl/oDA;EACE,6CAAA;EAEA,cAAA;EACA,YzBo+BuB;EyBn+BvB,azBm+BuB;EyBl+BvB,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,uEzBq+BwB;EyBp+BxB,iCAAA;UAAA,yBAAA;AhCo/oDF;AgCj/oDE;ElB3BE,qBAAA;Ad+gpDJ;AgCh/oDE;EAEE,kBzB89B6B;APmhnDjC;AgC9+oDE;EACE,uBzBo9B6B;AP4hnDjC;AgC7+oDE;EACE,6CzBm6BuB;EyBl6BvB,UAAA;EACA,2DzByjBoB;APs7nDxB;AgC5+oDE;EACE,yBzBqQmB;EyBpQnB,qBzBoQmB;AP0uoDvB;AgC5+oDI;EAII,kEAAA;AhC2+oDR;AgCv+oDI;EAII,kEAAA;AhCs+oDR;AgCj+oDE;EACE,yBzBgPmB;EyB/OnB,qBzB+OmB;EyB1OjB,kEAAA;AhC+9oDN;AgC39oDE;EACE,oBAAA;EACA,YAAA;EACA,YzB67BgC;APginDpC;AgCt9oDI;EACE,eAAA;EACA,YzBo7B8B;APoinDpC;;AgC18oDA;EACE,mBzB+6B0B;AP8hnD5B;AgC38oDE;EACE,6DAAA;EAEA,UzBy6BgB;EyBx6BhB,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBjHA,kBAAA;EeHE,iDGsHF;AhC48oDJ;A6B9jpDM;EG0GJ;IHzGM,gBAAA;E7BikpDN;AACF;AgC/8oDI;EACE,6DAAA;AhCi9oDN;AgC98oDI;EACE,iCzBw6B4B;EyBn6B1B,6DAAA;AhC48oDR;AgCv8oDE;EACE,oBzBm5BwB;EyBl5BxB,eAAA;AhCy8oDJ;AgCv8oDI;EACE,oBAAA;EACA,cAAA;AhCy8oDN;;AgCp8oDA;EACE,qBAAA;EACA,kBzBi4B6B;APsknD/B;;AgCp8oDA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AhCu8oDF;AgCn8oDI;EACE,oBAAA;EACA,YAAA;EACA,azBouBiB;APiunDvB;;AgC97oDI;EACE,6DAAA;AhCi8oDN;;AiCpnpDA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;AjCunpDF;AiCrnpDE;EACE,UAAA;AjCunpDJ;AiCnnpDI;EAA0B,8E1B2mCM;AP2gnDpC;AiCrnpDI;EAA0B,8E1B0mCM;AP8gnDpC;AiCrnpDE;EACE,SAAA;AjCunpDJ;AiCpnpDE;EACE,W1B4lCqB;E0B3lCrB,Y1B2lCqB;E0B1lCrB,oBAAA;EACA,gBAAA;EH1BF,yBvBmUqB;E0BvSnB,S1B0lCsB;EOvmCtB,mBAAA;EeHE,oHImBF;EJnBE,4GImBF;AjCqnpDJ;A6BpopDM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;E7BuopDN;AACF;AiCxnpDI;EHjCF,yBvB2nC2B;APiinD7B;AiCtnpDE;EACE,W1BqkCqB;E0BpkCrB,c1BqkCsB;E0BpkCtB,kBAAA;EACA,e1BokCsB;E0BnkCtB,uC1BokCkB;E0BnkClB,yBAAA;EnB7BA,mBAAA;AdsppDJ;AiCpnpDE;EACE,W1BikCqB;E0BhkCrB,Y1BgkCqB;E0B/jCrB,gBAAA;EHpDF,yBvBmUqB;E0B7QnB,S1BgkCsB;EOvmCtB,mBAAA;EeHE,iHI6CF;EJ7CE,4GI6CF;AjCqnpDJ;A6B9ppDM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;E7BiqpDN;AACF;AiCxnpDI;EH3DF,yBvB2nC2B;AP2jnD7B;AiCtnpDE;EACE,W1B2iCqB;E0B1iCrB,c1B2iCsB;E0B1iCtB,kBAAA;EACA,e1B0iCsB;E0BziCtB,uC1B0iCkB;E0BziClB,yBAAA;EnBvDA,mBAAA;AdgrpDJ;AiCpnpDE;EACE,oBAAA;AjCsnpDJ;AiCpnpDI;EACE,2C1B6iCyB;APyknD/B;AiCnnpDI;EACE,2C1ByiCyB;AP4knD/B;;AkC5spDA;EACE,kBAAA;AlC+spDF;AkC7spDE;;;EAGE,yD3BsoCmB;E2BroCnB,6D3BqoCmB;E2BpoCnB,iB3BqoCwB;AP0knD5B;AkC5spDE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;ELRE,gEKSF;AlC8spDJ;A6BntpDM;EKTJ;ILUM,gBAAA;E7BstpDN;AACF;AkChtpDE;;EAEE,oBAAA;AlCktpDJ;AkChtpDI;;EACE,kBAAA;AlCmtpDN;AkChtpDI;;;EAEE,qB3B0mC0B;E2BzmC1B,wB3B0mC0B;APymnDhC;AkChtpDI;;EACE,qB3BqmC0B;E2BpmC1B,wB3BqmC0B;AP8mnDhC;AkC/spDE;EACE,qB3B+lC4B;E2B9lC5B,wB3B+lC4B;APknnDhC;AkC1spDI;;;;EACE,2CAAA;EACA,8D3BylC0B;APsnnDhC;AkC7spDM;;;;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,a3BilCqB;E2BhlCrB,WAAA;EACA,2C3B64BG;EO77BP,sCAAA;AdmwpDJ;AkC5spDI;EACE,2CAAA;EACA,8D3BwkC0B;APsonDhC;AkCzspDI;EACE,sCAAA;AlC2spDN;AkCvspDE;;EAEE,gC3B8jCiC;AP2onDrC;AkCvspDI;;EACE,uC3Bu3Bc;APm1nDpB;;AmCjypDA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AnCoypDF;AmClypDE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;AnCoypDJ;AmChypDE;;;EAGE,UAAA;AnCkypDJ;AmC5xpDE;EACE,kBAAA;EACA,UAAA;AnC8xpDJ;AmC5xpDI;EACE,UAAA;AnC8xpDN;;AmCnxpDA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;ExB8OI,mBALI;EwBvOR,gB5BqnBmB;E4BpnBnB,gB5B4nBiB;E4B3nBjB,2B5Bg6BY;E4B/5BZ,kBAAA;EACA,mBAAA;EACA,uC5BqgCqB;E4BpgCrB,kEAAA;ErBtCE,sCAAA;Ad6zpDJ;;AmC7wpDA;;;;EAIE,sBAAA;ExBwNI,qBALI;EGvQN,yCAAA;Ads0pDJ;;AmC7wpDA;;;;EAIE,uBAAA;ExB+MI,sBALI;EGvQN,yCAAA;Ad+0pDJ;;AmC7wpDA;;EAEE,sBAAA;AnCgxpDF;;AmCnwpDI;;;;ErBjEA,0BAAA;EACA,6BAAA;Ad20pDJ;AmClwpDI;;;;ErB1EA,0BAAA;EACA,6BAAA;Adk1pDJ;AmC5vpDE;EACE,8CAAA;ErB1EA,yBAAA;EACA,4BAAA;Ady0pDJ;AmC5vpDE;;ErB9EE,yBAAA;EACA,4BAAA;Ad80pDJ;;AoCt2pDE;EACE,aAAA;EACA,WAAA;EACA,mB7Bo5BmB;EIlpBjB,kBALI;EyB1PN,iC7BipCqB;APutnDzB;;AoCr2pDE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EzBqPE,sBALI;EyB7ON,W7BooCqB;E6BnoCrB,mC7BmoCqB;EO9pCrB,sCAAA;Adm4pDJ;;AoCn2pDI;;;;EAEE,cAAA;ApCw2pDN;;AoCv5pDI;EAqDE,+C7BsnCmB;E6BnnCjB,iC7B66Ba;E6B56Bb,0DAAA;EACA,4BAAA;EACA,yDAAA;EACA,4DAAA;ApCo2pDR;AoCj2pDM;EACE,+C7B2mCiB;E6BtmCf,2D7BsmCe;APyvnDzB;;AoCp6pDI;EA+EI,iC7Bs5Ba;E6Br5Bb,8EAAA;ApCy1pDR;;AoCz6pDI;EAuFE,+C7BolCmB;APkwnDzB;AoCn1pDQ;EAEE,kEAAA;EACA,uBCq5B8B;EDp5B9B,8DAAA;EACA,uEAAA;ApCo1pDV;AoCh1pDM;EACE,+C7BukCiB;E6BlkCf,2D7BkkCe;AP4wnDzB;;AoCv7pDI;EAkHI,sCAAA;ApCy0pDR;;AoC37pDI;EAyHE,+C7BkjCmB;APoxnDzB;AoCp0pDM;EACE,4C7B+iCiB;APuxnDzB;AoCn0pDM;EACE,2D7B2iCiB;AP0xnDzB;AoCl0pDM;EACE,iC7BuiCiB;AP6xnDzB;;AoC/zpDI;EACE,kBAAA;ApCk0pDN;;AoC58pDI;;;;;EAoJM,UAAA;ApCg0pDV;;AoCh8pDE;EACE,aAAA;EACA,WAAA;EACA,mB7Bo5BmB;EIlpBjB,kBALI;EyB1PN,mC7BipCqB;APiznDzB;;AoC/7pDE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EzBqPE,sBALI;EyB7ON,W7BooCqB;E6BnoCrB,kC7BmoCqB;EO9pCrB,sCAAA;Ad69pDJ;;AoC77pDI;;;;EAEE,cAAA;ApCk8pDN;;AoCj/pDI;EAqDE,iD7BsnCmB;E6BnnCjB,iC7B66Ba;E6B56Bb,0DAAA;EACA,4BAAA;EACA,yDAAA;EACA,4DAAA;ApC87pDR;AoC37pDM;EACE,iD7B2mCiB;E6BtmCf,0D7BsmCe;APm1nDzB;;AoC9/pDI;EA+EI,iC7Bs5Ba;E6Br5Bb,8EAAA;ApCm7pDR;;AoCngqDI;EAuFE,iD7BolCmB;AP41nDzB;AoC76pDQ;EAEE,kEAAA;EACA,uBCq5B8B;EDp5B9B,8DAAA;EACA,uEAAA;ApC86pDV;AoC16pDM;EACE,iD7BukCiB;E6BlkCf,0D7BkkCe;APs2nDzB;;AoCjhqDI;EAkHI,sCAAA;ApCm6pDR;;AoCrhqDI;EAyHE,iD7BkjCmB;AP82nDzB;AoC95pDM;EACE,8C7B+iCiB;APi3nDzB;AoC75pDM;EACE,0D7B2iCiB;APo3nDzB;AoC55pDM;EACE,mC7BuiCiB;APu3nDzB;;AoCz5pDI;EACE,kBAAA;ApC45pDN;;AoCtiqDI;;;;;EAsJM,UAAA;ApCw5pDV;;AsChjqDA;EAEE,0BAAA;EACA,0BAAA;EACA,sBAAA;E3BuRI,4BALI;E2BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E3BsQI,kCALI;E2B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EAGA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;ExBjBE,0CAAA;EgBfF,kCQkCqB;ETtBjB,qISwBJ;AtC6iqDF;A6BjkqDM;EShBN;ITiBQ,gBAAA;E7BokqDN;AACF;AsChjqDE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;AtCijqDJ;AsC9iqDE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;AtC+iqDJ;AsC5iqDE;EACE,gCAAA;ERrDF,wCQsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;AtC0iqDN;AsCtiqDE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;AtCoiqDN;AsChiqDE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;AtC4hqDJ;AsCzhqDI;EAKI,0CAAA;AtCuhqDR;AsClhqDE;EAKI,0CAAA;AtCghqDN;AsC5gqDE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;AtC2gqDJ;;AsC//pDE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AvCknqDF;;AsChhqDE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AvCmoqDF;;AsCjiqDE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AvCopqDF;;AsCljqDE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AvCqqqDF;;AsCnkqDE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AvCsrqDF;;AsCplqDE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AvCusqDF;;AsCrmqDE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AvCwtqDF;;AsCtnqDE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AvCyuqDF;;AsCvoqDE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AvC0vqDF;;AsCxpqDE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AvC2wqDF;;AsCzqqDE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AvC4xqDF;;AsC1rqDE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AvC6yqDF;;AsC3sqDE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AvC8zqDF;;AsC5tqDE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AvC+0qDF;;AsC7uqDE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AvCg2qDF;;AsC9vqDE;EC/GA,oBAAA;EACA,iBAAA;EACA,2BAAA;EACA,0BAAA;EACA,wBAAA;EACA,kCAAA;EACA,wCAAA;EACA,2BAAA;EACA,yBAAA;EACA,mCAAA;EACA,4DAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;AvCi3qDF;;AsC/wqDE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AvCk4qDF;;AsCtwqDE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AvC03qDF;;AsCvxqDE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AvC24qDF;;AsCxyqDE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AvC45qDF;;AsCzzqDE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AvC66qDF;;AsC10qDE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AvC87qDF;;AsC31qDE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AvC+8qDF;;AsC52qDE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AvCg+qDF;;AsC73qDE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AvCi/qDF;;AsC94qDE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AvCkgrDF;;AsC/5qDE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AvCmhrDF;;AsCh7qDE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AvCoirDF;;AsCj8qDE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AvCqjrDF;;AsCl9qDE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AvCskrDF;;AsCn+qDE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AvCulrDF;;AsCp/qDE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AvCwmrDF;;AsCrgrDE;EChHA,oBAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,wCAAA;EACA,2BAAA;EACA,wBAAA;EACA,kCAAA;EACA,4DAAA;EACA,6BAAA;EACA,iCAAA;EACA,oCAAA;EACA,mBAAA;AvCynrDF;;AsCthrDE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AvC0orDF;;AsC3hrDA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,qB/BkUgB;AP2tqDlB;AsCnhrDE;EACE,0BAAA;AtCqhrDJ;AsClhrDE;EACE,gCAAA;AtCohrDJ;;AsCzgrDA;ECjJE,0BAAA;EACA,0BAAA;E5B8NI,8BALI;E4BvNR,kDAAA;AvC8prDF;;AsC5grDA;ECrJE,2BAAA;EACA,0BAAA;E5B8NI,+BALI;E4BvNR,kDAAA;AvCqqrDF;;AwCxurDA;EXgBM,gCWfJ;AxC2urDF;A6BxtrDM;EWpBN;IXqBQ,gBAAA;E7B2trDN;AACF;AwC9urDE;EACE,UAAA;AxCgvrDJ;;AwC1urDE;EACE,aAAA;AxC6urDJ;;AwCzurDA;EACE,SAAA;EACA,gBAAA;EXDI,6BWEJ;AxC4urDF;A6B1urDM;EWLN;IXMQ,gBAAA;E7B6urDN;AACF;AwC/urDE;EACE,QAAA;EACA,YAAA;EXNE,4BWOF;AxCivrDJ;A6BpvrDM;EWAJ;IXCM,gBAAA;E7BuvrDN;AACF;;AyC5wrDA;;;;;;EAME,kBAAA;AzC+wrDF;;AyC5wrDA;EACE,mBAAA;AzC+wrDF;;AyCxwrDA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E9BuQI,iCALI;E8BhQR,yCAAA;EACA,wCAAA;EACA,kDAAA;EACA,uDAAA;EACA,6BAAA;EACA;;GAAA;EACA,gDAAA;EACA,sCAAA;EACA,2DAAA;EACA,8CAAA;EACA,oDAAA;EACA,kDAAA;EACA,qDAAA;EACA,mDAAA;EACA,2DAAA;EACA,oCAAA;EACA,qCAAA;EACA,mCAAA;EACA,sCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E9B0OI,uCALI;E8BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E3BzCE,+CAAA;AdozrDJ;AyCvwrDE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AzCywrDJ;;AyCjvrDI;EACE,oBAAA;AzCovrDN;AyClvrDM;EACE,WAAA;EACA,OAAA;AzCovrDR;;AyChvrDI;EACE,kBAAA;AzCmvrDN;AyCjvrDM;EACE,QAAA;EACA,UAAA;AzCmvrDR;;AqB7xrDI;EoB4BA;IACE,oBAAA;EzCqwrDJ;EyCnwrDI;IACE,WAAA;IACA,OAAA;EzCqwrDN;;EyCjwrDE;IACE,kBAAA;EzCowrDJ;EyClwrDI;IACE,QAAA;IACA,UAAA;EzCowrDN;AACF;AqB/yrDI;EoB4BA;IACE,oBAAA;EzCsxrDJ;EyCpxrDI;IACE,WAAA;IACA,OAAA;EzCsxrDN;;EyClxrDE;IACE,kBAAA;EzCqxrDJ;EyCnxrDI;IACE,QAAA;IACA,UAAA;EzCqxrDN;AACF;AqBh0rDI;EoB4BA;IACE,oBAAA;EzCuyrDJ;EyCryrDI;IACE,WAAA;IACA,OAAA;EzCuyrDN;;EyCnyrDE;IACE,kBAAA;EzCsyrDJ;EyCpyrDI;IACE,QAAA;IACA,UAAA;EzCsyrDN;AACF;AqBj1rDI;EoB4BA;IACE,oBAAA;EzCwzrDJ;EyCtzrDI;IACE,WAAA;IACA,OAAA;EzCwzrDN;;EyCpzrDE;IACE,kBAAA;EzCuzrDJ;EyCrzrDI;IACE,QAAA;IACA,UAAA;EzCuzrDN;AACF;AqBl2rDI;EoB4BA;IACE,oBAAA;EzCy0rDJ;EyCv0rDI;IACE,WAAA;IACA,OAAA;EzCy0rDN;;EyCr0rDE;IACE,kBAAA;EzCw0rDJ;EyCt0rDI;IACE,QAAA;IACA,UAAA;EzCw0rDN;AACF;AyC/zrDE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AzCi0rDJ;AyCxzrDE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AzC0zrDJ;AyCrzrDI;EACE,iBAAA;AzCuzrDN;;AyCjzrDE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AzCozrDJ;AyC/yrDI;EACE,iBAAA;AzCizrDN;;AyC1yrDA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AzC6yrDF;;AyCvyrDA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gBlCqfmB;EkCpfnB,oCAAA;EACA,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;E3BtKE,uDAAA;Adg9rDJ;AyCvyrDE;EAEE,0CAAA;EX1LF,kDW4LuB;AzCuyrDzB;AyCpyrDE;EAEE,2CAAA;EACA,qBAAA;EXlMF,mDWmMuB;AzCqyrDzB;AyClyrDE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AzCmyrDJ;;AyC7xrDA;EACE,cAAA;AzCgyrDF;;AyC5xrDA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E9BmEI,sBALI;E8B5DR,sCAAA;EACA,mBAAA;AzC+xrDF;;AyC3xrDA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AzC8xrDF;;AyC1xrDA;EAEE,4BAAA;EACA,yBAAA;EACA,kDAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,gDAAA;EACA,sDAAA;EACA,qDAAA;EACA,mDAAA;EACA,0CAAA;EACA,mCAAA;AzC4xrDF;;A0ClhsDA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;A1CqhsDF;A0CnhsDE;;EACE,kBAAA;EACA,cAAA;A1CshsDJ;A0CjhsDE;;;;;;;;;;;;EAME,UAAA;A1CyhsDJ;;A0CphsDA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;A1CuhsDF;A0CrhsDE;EACE,WAAA;A1CuhsDJ;;A0CnhsDA;E5BhBI,sCAAA;AduisDJ;A0CnhsDE;;EAEE,8CAAA;A1CqhsDJ;A0CjhsDE;;;E5BVE,0BAAA;EACA,6BAAA;AdgisDJ;A0C7gsDE;;;E5BNE,yBAAA;EACA,4BAAA;AdwhsDJ;;A0ChgsDA;EACE,uBAAA;EACA,sBAAA;A1CmgsDF;A0CjgsDE;EAGE,cAAA;A1CigsDJ;A0C9/rDE;EACE,eAAA;A1CggsDJ;;A0C5/rDA;EACE,uBAAA;EACA,sBAAA;A1C+/rDF;;A0C5/rDA;EACE,qBAAA;EACA,oBAAA;A1C+/rDF;;A0C3+rDA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;A1C8+rDF;A0C5+rDE;;EAEE,WAAA;A1C8+rDJ;A0C3+rDE;;EAEE,6CAAA;A1C6+rDJ;A0Cz+rDE;;E5B1FE,6BAAA;EACA,4BAAA;AduksDJ;A0Cz+rDE;;E5B7GE,yBAAA;EACA,0BAAA;Ad0lsDJ;;A2ClnsDA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,mCAAA;EACA,gDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;A3CinsDF;;A2C9msDA;EACE,cAAA;EACA,kEAAA;EhCsQI,uCALI;EgC/PR,2CAAA;EACA,+BAAA;EAEA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;A3CgnsDF;A6B5nsDM;EcGN;IdFQ,gBAAA;E7B+nsDN;AACF;A2CnnsDE;EAEE,qCAAA;A3ConsDJ;A2ChnsDE;EACE,UAAA;EACA,2DpC6kBoB;APqirDxB;A2C9msDE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;A3C+msDJ;;A2CvmsDA;EAEE,kDAAA;EACA,iDAAA;EACA,oDAAA;EACA,mGAAA;EACA,gDAAA;EACA,mDAAA;EACA,0GAAA;EAGA,oFAAA;A3CumsDF;A2CrmsDE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;AdqpsDJ;A2CtmsDI;EAGE,kBAAA;EACA,wDAAA;A3CsmsDN;A2ClmsDE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;A3ComsDJ;A2CjmsDE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;AdoqsDJ;;A2CzlsDA;EAEE,qDAAA;EACA,iDAAA;EACA,uDAAA;A3C2lsDF;A2CxlsDE;E7B5FE,gDAAA;AdursDJ;A2CvlsDE;;EAEE,4CAAA;EbjHF,oDakHuB;A3CylsDzB;;A2ChlsDA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;A3CglsDF;A2C9ksDE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;A3CglsDJ;A2C9ksDI;EAEE,iCAAA;A3C+ksDN;A2C3ksDE;;EAEE,gBpCshBe;EoCrhBf,gDAAA;EACA,iCAAA;A3C6ksDJ;;A2CnksDE;;EAEE,cAAA;EACA,kBAAA;A3CsksDJ;;A2CjksDE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;A3CoksDJ;;A2C9jsDE;;EACE,WAAA;A3CkksDJ;;A2CxjsDE;EACE,aAAA;A3C2jsDJ;A2CzjsDE;EACE,cAAA;A3C2jsDJ;;A4CxvsDA;EAEE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,yCAAA;EACA,kCAAA;EACA,uCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,yCAAA;EACA,qEAAA;EACA,0EAAA;EACA,0DAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;A5CwvsDF;A4ClvsDE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;A5C0vsDJ;A4CtusDA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;EjC4NI,2CALI;EiCrNR,mCAAA;EAEA,mBAAA;A5CuusDF;A4CrusDE;EAEE,yCAAA;A5CsusDJ;;A4C5tsDA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;A5C2tsDF;A4CxtsDI;EAEE,oCAAA;A5CytsDN;A4CrtsDE;EACE,gBAAA;A5CutsDJ;;A4C9ssDA;EACE,mBrC8mCmB;EqC7mCnB,sBrC6mCmB;EqC5mCnB,6BAAA;A5CitsDF;A4C/ssDE;;;EAGE,oCAAA;A5CitsDJ;;A4CpssDA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;A5CqssDF;;A4CjssDA;EACE,8EAAA;EjCyII,6CALI;EiClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;A5CossDF;A6B70sDM;EeiIN;IfhIQ,gBAAA;E7Bg1sDN;AACF;A4CvssDE;EACE,qBAAA;A5CyssDJ;A4CtssDE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;A5CwssDJ;;A4ClssDA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;A5CqssDF;;A4ClssDA;EACE,yCAAA;EACA,gBAAA;A5CqssDF;;AqB/zsDI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;E5C4rsDN;E4C1rsDM;IACE,mBAAA;E5C4rsDR;E4C1rsDQ;IACE,kBAAA;E5C4rsDV;E4CzrsDQ;IACE,kDAAA;IACA,iDAAA;E5C2rsDV;E4CvrsDM;IACE,iBAAA;E5CyrsDR;E4CtrsDM;IACE,wBAAA;IACA,gBAAA;E5CwrsDR;E4CrrsDM;IACE,aAAA;E5CursDR;E4CprsDM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;E5CorsDR;E4CjrsDQ;IACE,aAAA;E5CmrsDV;E4ChrsDQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E5CkrsDV;AACF;AqB/2sDI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;E5C2usDN;E4CzusDM;IACE,mBAAA;E5C2usDR;E4CzusDQ;IACE,kBAAA;E5C2usDV;E4CxusDQ;IACE,kDAAA;IACA,iDAAA;E5C0usDV;E4CtusDM;IACE,iBAAA;E5CwusDR;E4CrusDM;IACE,wBAAA;IACA,gBAAA;E5CuusDR;E4CpusDM;IACE,aAAA;E5CsusDR;E4CnusDM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;E5CmusDR;E4ChusDQ;IACE,aAAA;E5CkusDV;E4C/tsDQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E5CiusDV;AACF;AqB95sDI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;E5C0xsDN;E4CxxsDM;IACE,mBAAA;E5C0xsDR;E4CxxsDQ;IACE,kBAAA;E5C0xsDV;E4CvxsDQ;IACE,kDAAA;IACA,iDAAA;E5CyxsDV;E4CrxsDM;IACE,iBAAA;E5CuxsDR;E4CpxsDM;IACE,wBAAA;IACA,gBAAA;E5CsxsDR;E4CnxsDM;IACE,aAAA;E5CqxsDR;E4ClxsDM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;E5CkxsDR;E4C/wsDQ;IACE,aAAA;E5CixsDV;E4C9wsDQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E5CgxsDV;AACF;AqB78sDI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;E5Cy0sDN;E4Cv0sDM;IACE,mBAAA;E5Cy0sDR;E4Cv0sDQ;IACE,kBAAA;E5Cy0sDV;E4Ct0sDQ;IACE,kDAAA;IACA,iDAAA;E5Cw0sDV;E4Cp0sDM;IACE,iBAAA;E5Cs0sDR;E4Cn0sDM;IACE,wBAAA;IACA,gBAAA;E5Cq0sDR;E4Cl0sDM;IACE,aAAA;E5Co0sDR;E4Cj0sDM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;E5Ci0sDR;E4C9zsDQ;IACE,aAAA;E5Cg0sDV;E4C7zsDQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E5C+zsDV;AACF;AqB5/sDI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;E5Cw3sDN;E4Ct3sDM;IACE,mBAAA;E5Cw3sDR;E4Ct3sDQ;IACE,kBAAA;E5Cw3sDV;E4Cr3sDQ;IACE,kDAAA;IACA,iDAAA;E5Cu3sDV;E4Cn3sDM;IACE,iBAAA;E5Cq3sDR;E4Cl3sDM;IACE,wBAAA;IACA,gBAAA;E5Co3sDR;E4Cj3sDM;IACE,aAAA;E5Cm3sDR;E4Ch3sDM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;E5Cg3sDR;E4C72sDQ;IACE,aAAA;E5C+2sDV;E4C52sDQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E5C82sDV;AACF;A4Cr6sDI;EAEI,iBAAA;EACA,2BAAA;A5Cs6sDR;A4Cp6sDQ;EACE,mBAAA;A5Cs6sDV;A4Cp6sDU;EACE,kBAAA;A5Cs6sDZ;A4Cn6sDU;EACE,kDAAA;EACA,iDAAA;A5Cq6sDZ;A4Cj6sDQ;EACE,iBAAA;A5Cm6sDV;A4Ch6sDQ;EACE,wBAAA;EACA,gBAAA;A5Ck6sDV;A4C/5sDQ;EACE,aAAA;A5Ci6sDV;A4C95sDQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;A5C85sDV;A4C35sDU;EACE,aAAA;A5C65sDZ;A4C15sDU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;A5C45sDZ;;A4C34sDA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;A5C64sDF;;A4Cv4sDI;EACE,qEAAA;A5C04sDN;;A6CnqtDA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,8CAAA;EACA,0BAAA;EACA,yBAAA;EACA,8CAAA;EACA,gDAAA;EACA,sDAAA;EACA,sDAAA;EACA,6BAAA;EACA,6BAAA;EACA,wCAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oCAAA;EACA,mCAAA;EACA,0CAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;AdqrtDJ;A6ChqtDE;EACE,eAAA;EACA,cAAA;A7CkqtDJ;A6C/ptDE;EACE,mBAAA;EACA,sBAAA;A7CiqtDJ;A6C/ptDI;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;AdwrtDJ;A6C/ptDI;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;Ad+qtDJ;A6C5ptDE;;EAEE,aAAA;A7C8ptDJ;;A6C1ptDA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;A7C2ptDF;;A6CxptDA;EACE,4CAAA;EACA,iCAAA;A7C2ptDF;;A6CxptDA;EACE,qDAAA;EACA,gBAAA;EACA,oCAAA;A7C2ptDF;;A6CxptDA;EACE,gBAAA;A7C2ptDF;;A6CnptDE;EACE,oCAAA;A7CsptDJ;;A6C9otDA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;A7CiptDF;A6C/otDE;E/B7FE,wFAAA;Ad+utDJ;;A6C7otDA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;A7CgptDF;A6C9otDE;E/BxGE,wFAAA;AdyvtDJ;;A6CvotDA;EACE,sDAAA;EACA,sDAAA;EACA,qDAAA;EACA,gBAAA;A7C0otDF;A6CxotDE;EACE,mCAAA;EACA,sCAAA;A7C0otDJ;;A6CtotDA;EACE,sDAAA;EACA,qDAAA;A7CyotDF;;A6CrotDA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;AdmxtDJ;;A6CrotDA;;;EAGE,WAAA;A7CwotDF;;A6CrotDA;;E/B3II,0DAAA;EACA,2DAAA;AdqxtDJ;;A6CtotDA;;E/BlII,8DAAA;EACA,6DAAA;Ad6wtDJ;;A6C/ntDE;EACE,0CAAA;A7CkotDJ;AqB7vtDI;EwBuHJ;IAQI,aAAA;IACA,mBAAA;E7CkotDF;E6C/ntDE;IAEE,SAAA;IACA,gBAAA;E7CgotDJ;E6C9ntDI;IACE,cAAA;IACA,cAAA;E7CgotDN;E6C3ntDM;I/B3KJ,0BAAA;IACA,6BAAA;EdyytDF;E6C5ntDQ;;IAGE,0BAAA;E7C6ntDV;E6C3ntDQ;;IAGE,6BAAA;E7C4ntDV;E6CxntDM;I/B5KJ,yBAAA;IACA,4BAAA;EduytDF;E6CzntDQ;;IAGE,yBAAA;E7C0ntDV;E6CxntDQ;;IAGE,4BAAA;E7CyntDV;AACF;;A8C91tDA;EAEE,0CAAA;EACA,yCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,oFAAA;EACA,sCAAA;EACA,mCAAA;EACA,4DAAA;EACA,2DAAA;A9Cg2tDF;;A8C51tDA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EnC4PI,mBALI;EmCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCrBE,gBAAA;EgCuBF,qBAAA;EjB1BI,0CiB2BJ;A9C+1tDF;A6Bt3tDM;EiBUN;IjBTQ,gBAAA;E7By3tDN;AACF;A8Cl2tDE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;A9Co2tDJ;A8Cl2tDI;EACE,qDAAA;EACA,iDAAA;A9Co2tDN;A8C/1tDE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBjDE,mDiBkDF;A9Ci2tDJ;A6B/4tDM;EiBqCJ;IjBpCM,gBAAA;E7Bk5tDN;AACF;A8Cn2tDE;EACE,UAAA;A9Cq2tDJ;A8Cl2tDE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;A9Co2tDJ;;A8Ch2tDA;EACE,gBAAA;A9Cm2tDF;;A8Ch2tDA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;A9Cm2tDF;A8Cj2tDE;EhC7DE,yDAAA;EACA,0DAAA;Adi6tDJ;A8Cl2tDI;EhChEA,+DAAA;EACA,gEAAA;Adq6tDJ;A8Cj2tDE;EACE,aAAA;A9Cm2tDJ;A8C/1tDE;EhC5DE,6DAAA;EACA,4DAAA;Ad85tDJ;A8C/1tDM;EhChEF,mEAAA;EACA,kEAAA;Adk6tDJ;A8C91tDI;EhCrEA,6DAAA;EACA,4DAAA;Ads6tDJ;;A8C51tDA;EACE,8EAAA;A9C+1tDF;;A8Ct1tDE;EACE,eAAA;EACA,cAAA;EhC9GA,gBAAA;Adw8tDJ;A8Cv1tDI;EAAgB,aAAA;A9C01tDpB;A8Cz1tDI;EAAe,gBAAA;A9C41tDnB;A8Cx1tDM;EhCtHF,gBAAA;Adi9tDJ;A8Cp1tDI;EhC7HA,gBAAA;Ado9tDJ;;A8C/0tDI;EACE,iEAAA;EACA,wEAAA;A9Ck1tDN;;A+C5+tDA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;EpC+QI,yCALI;EoCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;Ad4+tDJ;;A+Ct+tDE;EACE,iDAAA;A/Cy+tDJ;A+Cv+tDI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,yFAAA;A/Cy+tDN;A+Cr+tDE;EACE,6CAAA;A/Cu+tDJ;;AgD5guDA;EAEE,kCAAA;EACA,mCAAA;ErC4RI,mCALI;EqCrRR,2CAAA;EACA,0CAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,+CAAA;EACA,iFAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;AhBiiuDF;;AgD1guDA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;ErCgQI,yCALI;EqCzPR,iCAAA;EAEA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;AhD4guDF;A6B7huDM;EmBQN;InBPQ,gBAAA;E7BgiuDN;AACF;AgD/guDE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;AhDghuDJ;AgD7guDE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UzCi1CuB;EyCh1CvB,iDAAA;AhD+guDJ;AgD5guDE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;AhD6guDJ;AgD1guDE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;AhD2guDJ;;AgDtguDE;EACE,gDzCkzCsB;APutrD1B;AgDx/tDI;ElCxEA,iDAAA;AdmkuDJ;;AgDh/tDA;EClGE,iCAAA;EACA,iCAAA;EtC0RI,qCALI;EsCnRR,yDAAA;AjDsluDF;;AgDn/tDA;ECtGE,iCAAA;EACA,kCAAA;EtC0RI,sCALI;EsCnRR,yDAAA;AjD6luDF;;AkD/luDA;EAEE,4BAAA;EACA,4BAAA;EvCuRI,4BALI;EuChRR,2BAAA;EACA,sBAAA;EACA,iCAAA;EAGA,qBAAA;EACA,4DAAA;EvC+QI,oCALI;EuCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;AdomuDJ;AkD3luDE;EACE,aAAA;AlD6luDJ;;AkDxluDA;EACE,kBAAA;EACA,SAAA;AlD2luDF;;AmD3nuDA;EAEE,0BAAA;EACA,0BAAA;EACA,4BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;Ad+nuDJ;;AmDvnuDA;EAEE,cAAA;AnDynuDF;;AmDrnuDA;EACE,gB5CwoBqB;E4CvoBrB,iCAAA;AnDwnuDF;;AmDhnuDA;EACE,mB5CmlD4B;APgirD9B;AmDhnuDE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;AnDknuDJ;;AmD1muDE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AnD6muDJ;;AmDjnuDE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;AnDonuDJ;;AmDxnuDE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AnD2nuDJ;;AmD/nuDE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;AnDkouDJ;;AmDtouDE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AnDyouDJ;;AmD7ouDE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;AnDgpuDJ;;AmDppuDE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;AnDupuDJ;;AmD3puDE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;AnD8puDJ;;AmDlquDE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,6DAAA;AnDqquDJ;;AmDzquDE;EACE,8DAAA;EACA,uDAAA;EACA,qEAAA;EACA,mEAAA;AnD4quDJ;;AmDhruDE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,0DAAA;AnDmruDJ;;AmDvruDE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;AnD0ruDJ;;AmD9ruDE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,0DAAA;AnDisuDJ;;AmDrsuDE;EACE,4DAAA;EACA,qDAAA;EACA,mEAAA;EACA,iEAAA;AnDwsuDJ;;AmD5suDE;EACE,2DAAA;EACA,oDAAA;EACA,kEAAA;EACA,gEAAA;AnD+suDJ;;AmDntuDE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;AnDstuDJ;;AmD1tuDE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,yDAAA;AnD6tuDJ;;AoDzxuDE;EACE;IAAK,+B7CsoDS;EPuprDhB;AACF;AoDzxuDA;;EAGE,8BAAA;EzCkRI,mCALI;EyC3QR,uCAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,uCAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;EzCsQI,uCALI;EyC/PR,uCAAA;EtCRE,+CAAA;AdiyuDJ;;AoDpxuDA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;ApDuxuDF;A6B5yuDM;EuBYN;IvBXQ,gBAAA;E7B+yuDN;AACF;;AoDzxuDA;EtBAE,qMAAA;EsBEA,oEAAA;ApD4xuDF;;AoDzxuDA;EACE,iBAAA;ApD4xuDF;;AoDzxuDA;EACE,WAAA;ApD4xuDF;;AoDxxuDE;EACE,kDAAA;ApD2xuDJ;AoDxxuDM;EAJJ;IAKM,eAAA;EpD2xuDN;AACF;;AqDv1uDA;EAEE,2CAAA;EACA,0CAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,mDAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;Adi2uDJ;;AqDl1uDA;EACE,qBAAA;EACA,sBAAA;ArDq1uDF;AqDn1uDE;EAEE,oCAAA;EACA,0BAAA;ArDo1uDJ;;AqD30uDA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;ArD80uDF;AqD30uDE;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;ArD40uDJ;AqDz0uDE;EACE,+CAAA;EACA,uDAAA;ArD20uDJ;;AqDn0uDA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EAEA,yCAAA;EACA,iFAAA;ArDq0uDF;AqDn0uDE;EvCvDE,+BAAA;EACA,gCAAA;Ad63uDJ;AqDn0uDE;EvC7CE,mCAAA;EACA,kCAAA;Adm3uDJ;AqDn0uDE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;ArDo0uDJ;AqDh0uDE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;ArDk0uDJ;AqD9zuDE;EACE,mBAAA;ArDg0uDJ;AqD9zuDI;EACE,wDAAA;EACA,mDAAA;ArDg0uDN;;AqDnzuDI;EACE,mBAAA;ArDszuDN;AqDnzuDQ;EvCvDJ,6DAAA;EAZA,0BAAA;Ad03uDJ;AqDlzuDQ;EvCxEJ,2DAAA;EAYA,4BAAA;Adk3uDJ;AqDjzuDQ;EACE,aAAA;ArDmzuDV;AqDhzuDQ;EACE,mDAAA;EACA,oBAAA;ArDkzuDV;AqDhzuDU;EACE,yDAAA;EACA,oDAAA;ArDkzuDZ;;AqBx4uDI;EgC8DA;IACE,mBAAA;ErD80uDJ;EqD30uDM;IvCvDJ,6DAAA;IAZA,0BAAA;Edk5uDF;EqD10uDM;IvCxEJ,2DAAA;IAYA,4BAAA;Ed04uDF;EqDz0uDM;IACE,aAAA;ErD20uDR;EqDx0uDM;IACE,mDAAA;IACA,oBAAA;ErD00uDR;EqDx0uDQ;IACE,yDAAA;IACA,oDAAA;ErD00uDV;AACF;AqBj6uDI;EgC8DA;IACE,mBAAA;ErDs2uDJ;EqDn2uDM;IvCvDJ,6DAAA;IAZA,0BAAA;Ed06uDF;EqDl2uDM;IvCxEJ,2DAAA;IAYA,4BAAA;Edk6uDF;EqDj2uDM;IACE,aAAA;ErDm2uDR;EqDh2uDM;IACE,mDAAA;IACA,oBAAA;ErDk2uDR;EqDh2uDQ;IACE,yDAAA;IACA,oDAAA;ErDk2uDV;AACF;AqBz7uDI;EgC8DA;IACE,mBAAA;ErD83uDJ;EqD33uDM;IvCvDJ,6DAAA;IAZA,0BAAA;Edk8uDF;EqD13uDM;IvCxEJ,2DAAA;IAYA,4BAAA;Ed07uDF;EqDz3uDM;IACE,aAAA;ErD23uDR;EqDx3uDM;IACE,mDAAA;IACA,oBAAA;ErD03uDR;EqDx3uDQ;IACE,yDAAA;IACA,oDAAA;ErD03uDV;AACF;AqBj9uDI;EgC8DA;IACE,mBAAA;ErDs5uDJ;EqDn5uDM;IvCvDJ,6DAAA;IAZA,0BAAA;Ed09uDF;EqDl5uDM;IvCxEJ,2DAAA;IAYA,4BAAA;Edk9uDF;EqDj5uDM;IACE,aAAA;ErDm5uDR;EqDh5uDM;IACE,mDAAA;IACA,oBAAA;ErDk5uDR;EqDh5uDQ;IACE,yDAAA;IACA,oDAAA;ErDk5uDV;AACF;AqBz+uDI;EgC8DA;IACE,mBAAA;ErD86uDJ;EqD36uDM;IvCvDJ,6DAAA;IAZA,0BAAA;Edk/uDF;EqD16uDM;IvCxEJ,2DAAA;IAYA,4BAAA;Ed0+uDF;EqDz6uDM;IACE,aAAA;ErD26uDR;EqDx6uDM;IACE,mDAAA;IACA,oBAAA;ErD06uDR;EqDx6uDQ;IACE,yDAAA;IACA,oDAAA;ErD06uDV;AACF;AqD75uDA;EvChJI,gBAAA;AdgjvDJ;AqD75uDE;EACE,mDAAA;ArD+5uDJ;AqD75uDI;EACE,sBAAA;ArD+5uDN;;AqDl5uDE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;ArDq5uDJ;;AqD/5uDE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;ArDk6uDJ;;AqD56uDE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;ArD+6uDJ;;AqDz7uDE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;ArD47uDJ;;AqDt8uDE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;ArDy8uDJ;;AqDn9uDE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;ArDs9uDJ;;AqDh+uDE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;ArDm+uDJ;;AqD7+uDE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;ArDg/uDJ;;AqD1/uDE;EACE,6DAAA;EACA,sDAAA;EACA,oEAAA;EACA,4DAAA;EACA,uEAAA;EACA,6DAAA;EACA,wEAAA;EACA,gEAAA;EACA,iEAAA;EACA,2EAAA;ArD6/uDJ;;AqDvgvDE;EACE,mEAAA;EACA,4DAAA;EACA,0EAAA;EACA,4DAAA;EACA,6EAAA;EACA,6DAAA;EACA,8EAAA;EACA,sEAAA;EACA,uEAAA;EACA,iFAAA;ArD0gvDJ;;AqDphvDE;EACE,0DAAA;EACA,mDAAA;EACA,iEAAA;EACA,4DAAA;EACA,oEAAA;EACA,6DAAA;EACA,qEAAA;EACA,6DAAA;EACA,8DAAA;EACA,wEAAA;ArDuhvDJ;;AqDjivDE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;ArDoivDJ;;AqD9ivDE;EACE,0DAAA;EACA,mDAAA;EACA,iEAAA;EACA,4DAAA;EACA,oEAAA;EACA,6DAAA;EACA,qEAAA;EACA,6DAAA;EACA,8DAAA;EACA,wEAAA;ArDijvDJ;;AqD3jvDE;EACE,iEAAA;EACA,0DAAA;EACA,wEAAA;EACA,4DAAA;EACA,2EAAA;EACA,6DAAA;EACA,4EAAA;EACA,oEAAA;EACA,qEAAA;EACA,+EAAA;ArD8jvDJ;;AqDxkvDE;EACE,gEAAA;EACA,yDAAA;EACA,uEAAA;EACA,4DAAA;EACA,0EAAA;EACA,6DAAA;EACA,2EAAA;EACA,mEAAA;EACA,oEAAA;EACA,8EAAA;ArD2kvDJ;;AqDrlvDE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;ArDwlvDJ;;AqDlmvDE;EACE,yDAAA;EACA,kDAAA;EACA,gEAAA;EACA,4DAAA;EACA,mEAAA;EACA,6DAAA;EACA,oEAAA;EACA,4DAAA;EACA,6DAAA;EACA,uEAAA;ArDqmvDJ;;AsDjyvDA;EAEE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,4EAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EAGA,uBAAA;EACA,U/C4vDgB;E+C3vDhB,W/C2vDgB;E+C1vDhB,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,SAAA;ExCJE,sBAAA;EwCMF,oCAAA;AtDiyvDF;AsD9xvDE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;AtDgyvDJ;AsD7xvDE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;AtD+xvDJ;AsD5xvDE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;AtD6xvDJ;;AsDrxvDA;EAHE,wCAAA;AtD4xvDF;;AsDnxvDI;EATF,wCAAA;AtDgyvDF;;AuDj1vDA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;E5CyRI,8BALI;E4ClRR,kBAAA;EACA,qCAAA;EACA,+CAAA;EACA,+CAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,4CAAA;EACA,sDAAA;EAGA,gCAAA;EACA,eAAA;E5C2QI,oCALI;E4CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;Ad01vDJ;AuD/0vDE;EACE,UAAA;AvDi1vDJ;AuD90vDE;EACE,aAAA;AvDg1vDJ;;AuD50vDA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AvD80vDF;AuD50vDE;EACE,sCAAA;AvD80vDJ;;AuD10vDA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;Ad82vDJ;AuD50vDE;EACE,mDAAA;EACA,sCAAA;AvD80vDJ;;AuD10vDA;EACE,kCAAA;EACA,qBAAA;AvD60vDF;;AwD34vDA;EAEE,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,yBAAA;EACA,kBAAA;EACA,qCAAA;EACA,+CAAA;EACA,+CAAA;EACA,oDAAA;EACA,8DAAA;EACA,2FAAA;EACA,oCAAA;EACA,oCAAA;EACA,0CAAA;EACA,sDAAA;EACA,iCAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,iCAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AxDy4vDF;;AwDl4vDA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AxDo4vDF;AwDj4vDE;E3B5CI,mC2B6CF;EACA,8BjD6iDmB;APs1sDvB;A6B76vDM;E2BwCJ;I3BvCM,gBAAA;E7Bg7vDN;AACF;AwDt4vDE;EACE,ejD2iDmB;AP61sDvB;AwDp4vDE;EACE,sBjDwiDoB;AP81sDxB;;AwDl4vDA;EACE,+CAAA;AxDq4vDF;AwDn4vDE;EACE,gBAAA;EACA,gBAAA;AxDq4vDJ;AwDl4vDE;EACE,gBAAA;AxDo4vDJ;;AwDh4vDA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AxDm4vDF;;AwD/3vDA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;AxD+3vDF;;AwD33vDA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AxDi4vD9D;AyD7+vDE;EAAS,UAAA;AzDg/vDX;AyD/+vDE;EAAS,mCD2GiF;AxDu4vD5F;;AwDl4vDA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E1CrGE,2DAAA;EACA,4DAAA;Ad2+vDJ;AwDp4vDE;EACE,gGAAA;EACA,mJAAA;AxDs4vDJ;;AwDj4vDA;EACE,gBAAA;EACA,8CAAA;AxDo4vDF;;AwD/3vDA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AxDg4vDF;;AwD53vDA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,wEAAA;EACA,2CAAA;EACA,yFAAA;E1CzHE,+DAAA;EACA,8DAAA;Ady/vDJ;AwD33vDE;EACE,6CAAA;AxD63vDJ;;AqBx+vDI;EmCiHF;IACE,0BAAA;IACA,uDAAA;ExD23vDF;;EwDv3vDA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;ExD03vDF;;EwDv3vDA;IACE,uBAAA;ExD03vDF;AACF;AqBz/vDI;EmCmIF;;IAEE,uBAAA;ExDy3vDF;AACF;AqB//vDI;EmC0IF;IACE,wBAAA;ExDw3vDF;AACF;AwD/2vDI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AxDi3vDN;AwD/2vDM;EACE,YAAA;EACA,SAAA;E1CzMJ,gBAAA;Ad2jwDJ;AwD92vDM;;E1C7MF,gBAAA;Ad+jwDJ;AwD72vDM;EACE,gBAAA;AxD+2vDR;;AqBzgwDI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ExDq4vDJ;EwDn4vDI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;Ed+kwDF;EwDl4vDI;;I1C7MF,gBAAA;EdmlwDF;EwDj4vDI;IACE,gBAAA;ExDm4vDN;AACF;AqB9hwDI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ExDy5vDJ;EwDv5vDI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EdmmwDF;EwDt5vDI;;I1C7MF,gBAAA;EdumwDF;EwDr5vDI;IACE,gBAAA;ExDu5vDN;AACF;AqBljwDI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ExD66vDJ;EwD36vDI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EdunwDF;EwD16vDI;;I1C7MF,gBAAA;Ed2nwDF;EwDz6vDI;IACE,gBAAA;ExD26vDN;AACF;AqBtkwDI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ExDi8vDJ;EwD/7vDI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;Ed2owDF;EwD97vDI;;I1C7MF,gBAAA;Ed+owDF;EwD77vDI;IACE,gBAAA;ExD+7vDN;AACF;AqB1lwDI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ExDq9vDJ;EwDn9vDI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;Ed+pwDF;EwDl9vDI;;I1C7MF,gBAAA;EdmqwDF;EwDj9vDI;IACE,gBAAA;ExDm9vDN;AACF;A0DzrwDA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,qBAAA;E/CwRI,mCALI;E+CjRR,qCAAA;EACA,yCAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sCpD2pBiB;EoDzpBjB,kBAAA;EACA,gBpDoqBmB;EoDnqBnB,gBpD2qBiB;EoD1qBjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EhDgRI,sCALI;E+ChQR,qBAAA;EACA,UAAA;A1DiswDF;A0D/rwDE;EAAS,kCAAA;A1DkswDX;A0DhswDE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;A1DkswDJ;A0DhswDI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;A1DkswDN;;A0D7rwDA;EACE,iDAAA;A1DgswDF;A0D9rwDE;EACE,SAAA;EACA,uFAAA;EACA,sCAAA;A1DgswDJ;;A0D5rwDA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;A1D+rwDF;A0D7rwDE;EACE,WAAA;EACA,gIAAA;EACA,wCAAA;A1D+rwDJ;;A0D3rwDA,mBAAA;AAEA;EACE,8CAAA;A1D6rwDF;A0D3rwDE;EACE,YAAA;EACA,uFAAA;EACA,yCAAA;A1D6rwDJ;;A0DzrwDA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;A1D4rwDF;A0D1rwDE;EACE,UAAA;EACA,gIAAA;EACA,uCAAA;A1D4rwDJ;;A0DxrwDA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;Ad4wwDJ;;A4D/xwDA;EAEE,yBAAA;EACA,6BAAA;EjD4RI,gCALI;EiDrRR,uCAAA;EACA,iDAAA;EACA,iDAAA;EACA,mDAAA;EACA;;GAAA;EACA,0DAAA;EACA,mCAAA;EACA,qCAAA;EjDmRI,uCALI;EiD5QR,+CAAA;EACA,8CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sCpD2pBiB;EoDzpBjB,kBAAA;EACA,gBpDoqBmB;EoDnqBnB,gBpD2qBiB;EoD1qBjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EhDgRI,sCALI;EiD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;Ad4zwDJ;A4DxywDE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;A5D0ywDJ;A4DxywDI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;A5DyywDN;;A4DnywDE;EACE,oFAAA;A5DsywDJ;A4DpywDI;EAEE,uFAAA;A5DqywDN;A4DlywDI;EACE,SAAA;EACA,gDAAA;A5DoywDN;A4DjywDI;EACE,sCAAA;EACA,sCAAA;A5DmywDN;;A4D9xwDA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;A5DgywDJ;A4D9xwDI;EAEE,gIAAA;A5D+xwDN;A4D5xwDI;EACE,OAAA;EACA,kDAAA;A5D8xwDN;A4D3xwDI;EACE,oCAAA;EACA,wCAAA;A5D6xwDN;;A4DxxwDA,mBAAA;AAGE;EACE,iFAAA;A5DyxwDJ;A4DvxwDI;EAEE,uFAAA;A5DwxwDN;A4DrxwDI;EACE,MAAA;EACA,mDAAA;A5DuxwDN;A4DpxwDI;EACE,mCAAA;EACA,yCAAA;A5DsxwDN;A4DjxwDE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,sDAAA;EACA,WAAA;EACA,+EAAA;A5DmxwDJ;;A4D/wwDA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;A5DixwDJ;A4D/wwDI;EAEE,gIAAA;A5DgxwDN;A4D7wwDI;EACE,QAAA;EACA,iDAAA;A5D+wwDN;A4D5wwDI;EACE,qCAAA;EACA,uCAAA;A5D8wwDN;;A4DzwwDA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;EjD2GI,6CALI;EiDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;Adw5wDJ;A4D1vwDE;EACE,aAAA;A5D4vwDJ;;A4DxvwDA;EACE,0EAAA;EACA,mCAAA;A5D2vwDF;;A6Dh7wDA;EACE,kBAAA;A7Dm7wDF;;A6Dh7wDA;EACE,mBAAA;A7Dm7wDF;;A6Dh7wDA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;A7Dm7wDF;A8Dz8wDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A9D28wDJ;;A6Dp7wDA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;A7Du7wDF;A6Bt8wDM;EgCQN;IhCPQ,gBAAA;E7By8wDN;AACF;;A6Dz7wDA;;;EAGE,cAAA;A7D47wDF;;A6Dz7wDA;;EAEE,2BAAA;A7D47wDF;;A6Dz7wDA;;EAEE,4BAAA;A7D47wDF;;A6Dn7wDE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;A7Ds7wDJ;A6Dn7wDE;;;EAGE,UAAA;EACA,UAAA;A7Dq7wDJ;A6Dl7wDE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;A7Do7wDJ;A6B7+wDM;EgCqDJ;;IhCpDM,gBAAA;E7Bi/wDN;AACF;;A6Dj7wDA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UtD2nDuB;EsD1nDvB,UAAA;EACA,WtD7DM;EsD8DN,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YtDsnDyB;EsB5sDrB,8BgCuFJ;A7Dm7wDF;A6BtgxDM;EgCkEN;;IhCjEQ,gBAAA;E7B0gxDN;AACF;A6Dt7wDE;;;EAEE,WtDvEI;EsDwEJ,qBAAA;EACA,UAAA;EACA,YtD8mD6B;AP20tDjC;;A6Dt7wDA;EACE,OAAA;A7Dy7wDF;;A6Dt7wDA;EACE,QAAA;A7Dy7wDF;;A6Dp7wDA;;EAEE,qBAAA;EACA,WtD+mD4B;EsD9mD5B,YtD8mD4B;EsD7mD5B,4BAAA;EACA,wBAAA;EACA,0BAAA;A7Du7wDF;;A6Dp7wDA;EACE,2TAAA;A7Du7wDF;;A6Dr7wDA;EACE,0TAAA;A7Dw7wDF;;A6Dh7wDA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBtD+jDuB;EsD9jDvB,mBAAA;EACA,gBtD6jDuB;APq3tDzB;A6Dh7wDE;EACE,uBAAA;EACA,cAAA;EACA,WtD6jDuB;EsD5jDvB,WtD6jDwB;EsD5jDxB,UAAA;EACA,iBtD6jDwB;EsD5jDxB,gBtD4jDwB;EsD3jDxB,mBAAA;EACA,eAAA;EACA,sBtDrII;EsDsIJ,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YtDojDyB;EsBptDvB,6BgCiKF;A7Di7wDJ;A6B9kxDM;EgC4IJ;IhC3IM,gBAAA;E7BilxDN;AACF;A6Dn7wDE;EACE,UtDijDgC;APo4tDpC;;A6D56wDA;EACE,kBAAA;EACA,UAAA;EACA,etD2iDwB;EsD1iDxB,SAAA;EACA,oBtDwiD2B;EsDviD3B,uBtDuiD2B;EsDtiD3B,WtDhKM;EsDiKN,kBAAA;A7D+6wDF;;A6Dz6wDE;;EAEE,gCtD4iDgC;APg4tDpC;A6Dz6wDE;EACE,sBtDnKI;AP8kxDR;A6Dx6wDE;EACE,WtDvKI;APilxDR;;A6Dp7wDE;;;EAEE,gCtD4iDgC;AP44tDpC;A6Dr7wDE;EACE,sBtDnKI;AP0lxDR;A6Dp7wDE;EACE,WtDvKI;AP6lxDR;;A+DxoxDA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;A/D0oxDF;;A+DtoxDA;EACE;IAAK,0CAAA;E/D0oxDL;AACF;A+DvoxDA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;A/DsoxDF;;A+DnoxDA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;A/DqoxDF;;A+D5nxDA;EACE;IACE,mBAAA;E/D+nxDF;E+D7nxDA;IACE,UAAA;IACA,eAAA;E/D+nxDF;AACF;A+D3nxDA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;A/D0nxDF;;A+DvnxDA;EACE,wBAAA;EACA,yBAAA;A/D0nxDF;;A+DtnxDE;EACE;;IAEE,kCAAA;E/DynxDJ;AACF;AgEzsxDA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,iCAAA;EACA,iCAAA;EACA,0CAAA;EACA,yCAAA;EACA,mDAAA;EACA,mDAAA;EACA,kEAAA;EACA,qDAAA;EACA,qCAAA;AhE0sxDF;;AqB7oxDI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EhE2rxDJ;AACF;A6BttxDM;EmCYJ;InCXM,gBAAA;E7BytxDN;AACF;AqBnqxDI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EhEksxDN;AACF;AqB5qxDI;E2CpBE;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EhEmsxDN;AACF;AqBrrxDI;E2CZE;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EhEosxDN;AACF;AqBhsxDI;E2CFE;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EhEqsxDN;AACF;AqB1sxDI;E2COE;IAEE,eAAA;EhEqsxDN;AACF;AqB/sxDI;E2CYE;IAGE,mBAAA;EhEosxDN;AACF;AqBjuxDI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EhEmsxDN;EgEjsxDM;IACE,aAAA;EhEmsxDR;EgEhsxDM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EhEisxDR;AACF;;AqBruxDI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EhEmxxDJ;AACF;A6B9yxDM;EmCYJ;InCXM,gBAAA;E7BizxDN;AACF;AqB3vxDI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EhE0xxDN;AACF;AqBpwxDI;E2CpBE;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EhE2xxDN;AACF;AqB7wxDI;E2CZE;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EhE4xxDN;AACF;AqBxxxDI;E2CFE;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EhE6xxDN;AACF;AqBlyxDI;E2COE;IAEE,eAAA;EhE6xxDN;AACF;AqBvyxDI;E2CYE;IAGE,mBAAA;EhE4xxDN;AACF;AqBzzxDI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EhE2xxDN;EgEzxxDM;IACE,aAAA;EhE2xxDR;EgExxxDM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EhEyxxDR;AACF;;AqB7zxDI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EhE22xDJ;AACF;A6Bt4xDM;EmCYJ;InCXM,gBAAA;E7By4xDN;AACF;AqBn1xDI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EhEk3xDN;AACF;AqB51xDI;E2CpBE;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EhEm3xDN;AACF;AqBr2xDI;E2CZE;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EhEo3xDN;AACF;AqBh3xDI;E2CFE;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EhEq3xDN;AACF;AqB13xDI;E2COE;IAEE,eAAA;EhEq3xDN;AACF;AqB/3xDI;E2CYE;IAGE,mBAAA;EhEo3xDN;AACF;AqBj5xDI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EhEm3xDN;EgEj3xDM;IACE,aAAA;EhEm3xDR;EgEh3xDM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EhEi3xDR;AACF;;AqBr5xDI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EhEm8xDJ;AACF;A6B99xDM;EmCYJ;InCXM,gBAAA;E7Bi+xDN;AACF;AqB36xDI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EhE08xDN;AACF;AqBp7xDI;E2CpBE;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EhE28xDN;AACF;AqB77xDI;E2CZE;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EhE48xDN;AACF;AqBx8xDI;E2CFE;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EhE68xDN;AACF;AqBl9xDI;E2COE;IAEE,eAAA;EhE68xDN;AACF;AqBv9xDI;E2CYE;IAGE,mBAAA;EhE48xDN;AACF;AqBz+xDI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EhE28xDN;EgEz8xDM;IACE,aAAA;EhE28xDR;EgEx8xDM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EhEy8xDR;AACF;;AqB7+xDI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EhE2hyDJ;AACF;A6BtjyDM;EmCYJ;InCXM,gBAAA;E7ByjyDN;AACF;AqBngyDI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EhEkiyDN;AACF;AqB5gyDI;E2CpBE;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EhEmiyDN;AACF;AqBrhyDI;E2CZE;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EhEoiyDN;AACF;AqBhiyDI;E2CFE;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EhEqiyDN;AACF;AqB1iyDI;E2COE;IAEE,eAAA;EhEqiyDN;AACF;AqB/iyDI;E2CYE;IAGE,mBAAA;EhEoiyDN;AACF;AqBjkyDI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EhEmiyDN;EgEjiyDM;IACE,aAAA;EhEmiyDR;EgEhiyDM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EhEiiyDR;AACF;;AgEjnyDE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EnC5BA,0CmC8BA;AhEknyDN;A6B5oyDM;EmCYJ;InCXM,gBAAA;E7B+oyDN;AACF;AgErnyDM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;AhEunyDR;AgEpnyDM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;AhEsnyDR;AgEnnyDM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;AhEqnyDR;AgElnyDM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;AhEonyDR;AgEjnyDM;EAEE,eAAA;AhEknyDR;AgE/myDM;EAGE,mBAAA;AhE+myDR;;AgEplyDA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,alD2sC0B;EkD1sC1B,YAAA;EACA,aAAA;EACA,sBlDuCM;APqqyDR;AyDzsyDE;EAAS,UAAA;AzD4syDX;AyD3syDE;EAAS,YlD8kDc;APgovDzB;;AgEhmyDA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;AhEmmyDF;AgEjmyDE;EACE,0FAAA;EACA,0IAAA;AhEmmyDJ;;AgE/lyDA;EACE,gBAAA;EACA,kDAAA;AhEkmyDF;;AgE/lyDA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;AhEkmyDF;;AiE/uyDA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,Y1Dy5CwB;APy1vD1B;AiEhvyDE;EACE,qBAAA;EACA,WAAA;AjEkvyDJ;;AiE7uyDA;EACE,iBAAA;AjEgvyDF;;AiE7uyDA;EACE,iBAAA;AjEgvyDF;;AiE7uyDA;EACE,iBAAA;AjEgvyDF;;AiE3uyDE;EACE,mDAAA;AjE8uyDJ;;AiE1uyDA;EACE;IACE,Y1D43CsB;EPi3vDxB;AACF;AiE1uyDA;EACE,+EAAA;EACA,oBAAA;EACA,8CAAA;AjE4uyDF;;AiEzuyDA;EACE;IACE,uBAAA;EjE4uyDF;AACF;A8D3xyDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A9D6xyDJ;;AkEhyyDE;EACE,sBAAA;EACA,iFAAA;AlEmyyDJ;;AkEryyDE;EACE,sBAAA;EACA,mFAAA;AlEwyyDJ;;AkE1yyDE;EACE,sBAAA;EACA,iFAAA;AlE6yyDJ;;AkE/yyDE;EACE,sBAAA;EACA,8EAAA;AlEkzyDJ;;AkEpzyDE;EACE,sBAAA;EACA,iFAAA;AlEuzyDJ;;AkEzzyDE;EACE,sBAAA;EACA,gFAAA;AlE4zyDJ;;AkE9zyDE;EACE,sBAAA;EACA,+EAAA;AlEi0yDJ;;AkEn0yDE;EACE,sBAAA;EACA,8EAAA;AlEs0yDJ;;AkEx0yDE;EACE,sBAAA;EACA,wFAAA;AlE20yDJ;;AkE70yDE;EACE,sBAAA;EACA,8FAAA;AlEg1yDJ;;AkEl1yDE;EACE,sBAAA;EACA,qFAAA;AlEq1yDJ;;AkEv1yDE;EACE,sBAAA;EACA,gFAAA;AlE01yDJ;;AkE51yDE;EACE,sBAAA;EACA,qFAAA;AlE+1yDJ;;AkEj2yDE;EACE,sBAAA;EACA,4FAAA;AlEo2yDJ;;AkEt2yDE;EACE,sBAAA;EACA,2FAAA;AlEy2yDJ;;AkE32yDE;EACE,sBAAA;EACA,+EAAA;AlE82yDJ;;AkEh3yDE;EACE,sBAAA;EACA,oFAAA;AlEm3yDJ;;AmEr3yDE;EACE,wEAAA;EACA,kGAAA;AnEw3yDJ;AmEr3yDM;EAGE,gEAAA;EACA,0FAAA;AnEq3yDR;;AmE93yDE;EACE,0EAAA;EACA,oGAAA;AnEi4yDJ;AmE93yDM;EAGE,gEAAA;EACA,0FAAA;AnE83yDR;;AmEv4yDE;EACE,wEAAA;EACA,kGAAA;AnE04yDJ;AmEv4yDM;EAGE,8DAAA;EACA,wFAAA;AnEu4yDR;;AmEh5yDE;EACE,qEAAA;EACA,+FAAA;AnEm5yDJ;AmEh5yDM;EAGE,+DAAA;EACA,yFAAA;AnEg5yDR;;AmEz5yDE;EACE,wEAAA;EACA,kGAAA;AnE45yDJ;AmEz5yDM;EAGE,+DAAA;EACA,yFAAA;AnEy5yDR;;AmEl6yDE;EACE,uEAAA;EACA,iGAAA;AnEq6yDJ;AmEl6yDM;EAGE,8DAAA;EACA,wFAAA;AnEk6yDR;;AmE36yDE;EACE,sEAAA;EACA,gGAAA;AnE86yDJ;AmE36yDM;EAGE,gEAAA;EACA,0FAAA;AnE26yDR;;AmEp7yDE;EACE,qEAAA;EACA,+FAAA;AnEu7yDJ;AmEp7yDM;EAGE,6DAAA;EACA,uFAAA;AnEo7yDR;;AmE77yDE;EACE,+EAAA;EACA,yGAAA;AnEg8yDJ;AmE77yDM;EAGE,gEAAA;EACA,0FAAA;AnE67yDR;;AmEt8yDE;EACE,qFAAA;EACA,+GAAA;AnEy8yDJ;AmEt8yDM;EAGE,gEAAA;EACA,0FAAA;AnEs8yDR;;AmE/8yDE;EACE,4EAAA;EACA,sGAAA;AnEk9yDJ;AmE/8yDM;EAGE,6DAAA;EACA,uFAAA;AnE+8yDR;;AmEx9yDE;EACE,uEAAA;EACA,iGAAA;AnE29yDJ;AmEx9yDM;EAGE,gEAAA;EACA,0FAAA;AnEw9yDR;;AmEj+yDE;EACE,4EAAA;EACA,sGAAA;AnEo+yDJ;AmEj+yDM;EAGE,gEAAA;EACA,0FAAA;AnEi+yDR;;AmE1+yDE;EACE,mFAAA;EACA,6GAAA;AnE6+yDJ;AmE1+yDM;EAGE,+DAAA;EACA,yFAAA;AnE0+yDR;;AmEn/yDE;EACE,kFAAA;EACA,4GAAA;AnEs/yDJ;AmEn/yDM;EAGE,gEAAA;EACA,0FAAA;AnEm/yDR;;AmE5/yDE;EACE,sEAAA;EACA,gGAAA;AnE+/yDJ;AmE5/yDM;EAGE,gEAAA;EACA,0FAAA;AnE4/yDR;;AmErgzDE;EACE,2EAAA;EACA,qGAAA;AnEwgzDJ;AmErgzDM;EAGE,gEAAA;EACA,0FAAA;AnEqgzDR;;AmE9/yDA;EACE,+EAAA;EACA,yGAAA;AnEigzDF;AmE9/yDI;EAEE,kFAAA;EACA,4GAAA;AnE+/yDN;;AoEzhzDA;EACE,UAAA;EAEA,kJAAA;ApE2hzDF;;AqE9hzDA;EACE,oBAAA;EACA,a9DigBc;E8DhgBd,mBAAA;EACA,kFAAA;EACA,6B9D+f2B;E8D9f3B,2BAAA;ArEiizDF;AqE/hzDE;EACE,cAAA;EACA,U9D2fkB;E8D1flB,W9D0fkB;E8DzflB,kBAAA;ExCIE,sCwCHF;ArEiizDJ;A6B1hzDM;EwCZJ;IxCaM,gBAAA;E7B6hzDN;AACF;;AqE/hzDI;EACE,mEAAA;ArEkizDN;;AsErjzDA;EACE,kBAAA;EACA,WAAA;AtEwjzDF;AsEtjzDE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AtEwjzDJ;AsErjzDE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AtEujzDJ;;AsEljzDE;EACE,uBAAA;AtEqjzDJ;;AsEtjzDE;EACE,qCAAA;AtEyjzDJ;;AsE1jzDE;EACE,sCAAA;AtE6jzDJ;;AsE9jzDE;EACE,sCAAA;AtEikzDJ;;AuEtlzDA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,ahEwsCa;APi5wDf;;AuEtlzDA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,ahEgsCa;APy5wDf;;AuEjlzDI;EACE,gBAAA;EACA,MAAA;EACA,ahEorCU;APg6wDhB;;AuEjlzDI;EACE,gBAAA;EACA,SAAA;EACA,ahE8qCU;APs6wDhB;;AqBrjzDI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,ahEorCU;EP66wDd;;EuE9lzDE;IACE,gBAAA;IACA,SAAA;IACA,ahE8qCU;EPm7wDd;AACF;AqBnkzDI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,ahEorCU;EP07wDd;;EuE3mzDE;IACE,gBAAA;IACA,SAAA;IACA,ahE8qCU;EPg8wDd;AACF;AqBhlzDI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,ahEorCU;EPu8wDd;;EuExnzDE;IACE,gBAAA;IACA,SAAA;IACA,ahE8qCU;EP68wDd;AACF;AqB7lzDI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,ahEorCU;EPo9wDd;;EuErozDE;IACE,gBAAA;IACA,SAAA;IACA,ahE8qCU;EP09wDd;AACF;AqB1mzDI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,ahEorCU;EPi+wDd;;EuElpzDE;IACE,gBAAA;IACA,SAAA;IACA,ahE8qCU;EPu+wDd;AACF;AwErrzDA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AxEurzDF;;AwEprzDA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AxEurzDF;;AyE/rzDA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;A1EgszDF;A0E7rzDE;;EACE,6BAAA;A1EgszDJ;;A2E9szDE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UpEofqB;EoEnfrB,WAAA;A3EitzDJ;;A4EztzDA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;A7E6tzDF;;A8EnuzDA;EACE,qBAAA;EACA,mBAAA;EACA,6BzCisB4B;EyChsB5B,eAAA;EACA,8BAAA;EACA,avE2wBW;AP29xDb;;A+E1qzDQ;EAOI,mCAAA;A/EuqzDZ;;A+E9qzDQ;EAOI,8BAAA;A/E2qzDZ;;A+ElrzDQ;EAOI,iCAAA;A/E+qzDZ;;A+EtrzDQ;EAOI,iCAAA;A/EmrzDZ;;A+E1rzDQ;EAOI,sCAAA;A/EurzDZ;;A+E9rzDQ;EAOI,mCAAA;A/E2rzDZ;;A+ElszDQ;EAOI,sBAAA;A/E+rzDZ;;A+EtszDQ;EAOI,uBAAA;A/EmszDZ;;A+E1szDQ;EAOI,sBAAA;A/EuszDZ;;A+E9szDQ;EAOI,8BAAA;A/E2szDZ;;A+EltzDQ;EAOI,4BAAA;A/E+szDZ;;A+EttzDQ;EAOI,2BAAA;A/EmtzDZ;;A+E1tzDQ;EAOI,iCAAA;A/EutzDZ;;A+E9tzDQ;EAOI,2BAAA;A/E2tzDZ;;A+EluzDQ;EAOI,qBAAA;A/E+tzDZ;;A+EtuzDQ;EAOI,wBAAA;A/EmuzDZ;;A+E1uzDQ;EAOI,uBAAA;A/EuuzDZ;;A+E9uzDQ;EAOI,wBAAA;A/E2uzDZ;;A+ElvzDQ;EAOI,qBAAA;A/E+uzDZ;;A+EtvzDQ;EAOI,yBAAA;A/EmvzDZ;;A+E1vzDQ;EAOI,2BAAA;A/EuvzDZ;;A+E9vzDQ;EAOI,4BAAA;A/E2vzDZ;;A+ElwzDQ;EAOI,2BAAA;A/E+vzDZ;;A+EtwzDQ;EAOI,2BAAA;A/EmwzDZ;;A+E1wzDQ;EAOI,6BAAA;A/EuwzDZ;;A+E9wzDQ;EAOI,8BAAA;A/E2wzDZ;;A+ElxzDQ;EAOI,6BAAA;A/E+wzDZ;;A+EtxzDQ;EAOI,2BAAA;A/EmxzDZ;;A+E1xzDQ;EAOI,6BAAA;A/EuxzDZ;;A+E9xzDQ;EAOI,8BAAA;A/E2xzDZ;;A+ElyzDQ;EAOI,6BAAA;A/E+xzDZ;;A+EtyzDQ;EAOI,0BAAA;A/EmyzDZ;;A+E1yzDQ;EAOI,gCAAA;A/EuyzDZ;;A+E9yzDQ;EAOI,yBAAA;A/E2yzDZ;;A+ElzzDQ;EAOI,wBAAA;A/E+yzDZ;;A+EtzzDQ;EAOI,+BAAA;A/EmzzDZ;;A+E1zzDQ;EAOI,yBAAA;A/EuzzDZ;;A+E9zzDQ;EAOI,6BAAA;A/E2zzDZ;;A+El0zDQ;EAOI,8BAAA;A/E+zzDZ;;A+Et0zDQ;EAOI,wBAAA;A/Em0zDZ;;A+E10zDQ;EAOI,+BAAA;A/Eu0zDZ;;A+E90zDQ;EAOI,wBAAA;A/E20zDZ;;A+El1zDQ;EAOI,2CAAA;A/E+0zDZ;;A+Et1zDQ;EAOI,8CAAA;A/Em1zDZ;;A+E11zDQ;EAOI,8CAAA;A/Eu1zDZ;;A+E91zDQ;EAOI,2BAAA;A/E21zDZ;;A+E52zDQ;EACE,gFAAA;A/E+2zDV;;A+Eh3zDQ;EACE,kFAAA;A/Em3zDV;;A+Ep3zDQ;EACE,gFAAA;A/Eu3zDV;;A+Ex3zDQ;EACE,6EAAA;A/E23zDV;;A+E53zDQ;EACE,gFAAA;A/E+3zDV;;A+Eh4zDQ;EACE,+EAAA;A/Em4zDV;;A+Ep4zDQ;EACE,8EAAA;A/Eu4zDV;;A+Ex4zDQ;EACE,6EAAA;A/E24zDV;;A+E54zDQ;EACE,uFAAA;A/E+4zDV;;A+Eh5zDQ;EACE,6FAAA;A/Em5zDV;;A+Ep5zDQ;EACE,oFAAA;A/Eu5zDV;;A+Ex5zDQ;EACE,+EAAA;A/E25zDV;;A+E55zDQ;EACE,oFAAA;A/E+5zDV;;A+Eh6zDQ;EACE,2FAAA;A/Em6zDV;;A+Ep6zDQ;EACE,0FAAA;A/Eu6zDV;;A+Ex6zDQ;EACE,8EAAA;A/E26zDV;;A+E56zDQ;EACE,mFAAA;A/E+6zDV;;A+Et6zDQ;EAOI,2BAAA;A/Em6zDZ;;A+E16zDQ;EAOI,6BAAA;A/Eu6zDZ;;A+E96zDQ;EAOI,6BAAA;A/E26zDZ;;A+El7zDQ;EAOI,0BAAA;A/E+6zDZ;;A+Et7zDQ;EAOI,2BAAA;A/Em7zDZ;;A+E17zDQ;EAOI,iBAAA;A/Eu7zDZ;;A+E97zDQ;EAOI,mBAAA;A/E27zDZ;;A+El8zDQ;EAOI,oBAAA;A/E+7zDZ;;A+Et8zDQ;EAOI,oBAAA;A/Em8zDZ;;A+E18zDQ;EAOI,sBAAA;A/Eu8zDZ;;A+E98zDQ;EAOI,uBAAA;A/E28zDZ;;A+El9zDQ;EAOI,kBAAA;A/E+8zDZ;;A+Et9zDQ;EAOI,oBAAA;A/Em9zDZ;;A+E19zDQ;EAOI,qBAAA;A/Eu9zDZ;;A+E99zDQ;EAOI,mBAAA;A/E29zDZ;;A+El+zDQ;EAOI,qBAAA;A/E+9zDZ;;A+Et+zDQ;EAOI,sBAAA;A/Em+zDZ;;A+E1+zDQ;EAOI,2CAAA;A/Eu+zDZ;;A+E9+zDQ;EAOI,sCAAA;A/E2+zDZ;;A+El/zDQ;EAOI,sCAAA;A/E++zDZ;;A+Et/zDQ;EAOI,uFAAA;A/Em/zDZ;;A+E1/zDQ;EAOI,oBAAA;A/Eu/zDZ;;A+E9/zDQ;EAOI,2FAAA;A/E2/zDZ;;A+Elg0DQ;EAOI,wBAAA;A/E+/zDZ;;A+Etg0DQ;EAOI,6FAAA;A/Emg0DZ;;A+E1g0DQ;EAOI,0BAAA;A/Eug0DZ;;A+E9g0DQ;EAOI,8FAAA;A/E2g0DZ;;A+Elh0DQ;EAOI,2BAAA;A/E+g0DZ;;A+Eth0DQ;EAOI,4FAAA;A/Emh0DZ;;A+E1h0DQ;EAOI,yBAAA;A/Euh0DZ;;A+E9h0DQ;EAIQ,sBAAA;EAGJ,8EAAA;A/E4h0DZ;;A+Eni0DQ;EAIQ,sBAAA;EAGJ,gFAAA;A/Eii0DZ;;A+Exi0DQ;EAIQ,sBAAA;EAGJ,8EAAA;A/Esi0DZ;;A+E7i0DQ;EAIQ,sBAAA;EAGJ,2EAAA;A/E2i0DZ;;A+Elj0DQ;EAIQ,sBAAA;EAGJ,8EAAA;A/Egj0DZ;;A+Evj0DQ;EAIQ,sBAAA;EAGJ,6EAAA;A/Eqj0DZ;;A+E5j0DQ;EAIQ,sBAAA;EAGJ,4EAAA;A/E0j0DZ;;A+Ejk0DQ;EAIQ,sBAAA;EAGJ,2EAAA;A/E+j0DZ;;A+Etk0DQ;EAIQ,sBAAA;EAGJ,qFAAA;A/Eok0DZ;;A+E3k0DQ;EAIQ,sBAAA;EAGJ,2FAAA;A/Eyk0DZ;;A+Ehl0DQ;EAIQ,sBAAA;EAGJ,kFAAA;A/E8k0DZ;;A+Erl0DQ;EAIQ,sBAAA;EAGJ,6EAAA;A/Eml0DZ;;A+E1l0DQ;EAIQ,sBAAA;EAGJ,kFAAA;A/Ewl0DZ;;A+E/l0DQ;EAIQ,sBAAA;EAGJ,yFAAA;A/E6l0DZ;;A+Epm0DQ;EAIQ,sBAAA;EAGJ,wFAAA;A/Ekm0DZ;;A+Ezm0DQ;EAIQ,sBAAA;EAGJ,4EAAA;A/Eum0DZ;;A+E9m0DQ;EAIQ,sBAAA;EAGJ,iFAAA;A/E4m0DZ;;A+Enn0DQ;EAIQ,sBAAA;EAGJ,4EAAA;A/Ein0DZ;;A+Exn0DQ;EAOI,wDAAA;A/Eqn0DZ;;A+E5n0DQ;EAOI,0DAAA;A/Eyn0DZ;;A+Eho0DQ;EAOI,wDAAA;A/E6n0DZ;;A+Epo0DQ;EAOI,qDAAA;A/Eio0DZ;;A+Exo0DQ;EAOI,wDAAA;A/Eqo0DZ;;A+E5o0DQ;EAOI,uDAAA;A/Eyo0DZ;;A+Ehp0DQ;EAOI,sDAAA;A/E6o0DZ;;A+Epp0DQ;EAOI,qDAAA;A/Eip0DZ;;A+Exp0DQ;EAOI,4BAAA;A/Eqp0DZ;;A+E5p0DQ;EAOI,4BAAA;A/Eyp0DZ;;A+Ehq0DQ;EAOI,4BAAA;A/E6p0DZ;;A+Epq0DQ;EAOI,4BAAA;A/Eiq0DZ;;A+Exq0DQ;EAOI,4BAAA;A/Eqq0DZ;;A+Etr0DQ;EACE,wBAAA;A/Eyr0DV;;A+E1r0DQ;EACE,yBAAA;A/E6r0DV;;A+E9r0DQ;EACE,wBAAA;A/Eis0DV;;A+Els0DQ;EACE,yBAAA;A/Eqs0DV;;A+Ets0DQ;EACE,sBAAA;A/Eys0DV;;A+Ehs0DQ;EAOI,qBAAA;A/E6r0DZ;;A+Eps0DQ;EAOI,qBAAA;A/Eis0DZ;;A+Exs0DQ;EAOI,qBAAA;A/Eqs0DZ;;A+E5s0DQ;EAOI,sBAAA;A/Eys0DZ;;A+Eht0DQ;EAOI,sBAAA;A/E6s0DZ;;A+Ept0DQ;EAOI,0BAAA;A/Eit0DZ;;A+Ext0DQ;EAOI,uBAAA;A/Eqt0DZ;;A+E5t0DQ;EAOI,2BAAA;A/Eyt0DZ;;A+Ehu0DQ;EAOI,sBAAA;A/E6t0DZ;;A+Epu0DQ;EAOI,sBAAA;A/Eiu0DZ;;A+Exu0DQ;EAOI,sBAAA;A/Equ0DZ;;A+E5u0DQ;EAOI,uBAAA;A/Eyu0DZ;;A+Ehv0DQ;EAOI,uBAAA;A/E6u0DZ;;A+Epv0DQ;EAOI,2BAAA;A/Eiv0DZ;;A+Exv0DQ;EAOI,wBAAA;A/Eqv0DZ;;A+E5v0DQ;EAOI,4BAAA;A/Eyv0DZ;;A+Ehw0DQ;EAOI,yBAAA;A/E6v0DZ;;A+Epw0DQ;EAOI,8BAAA;A/Eiw0DZ;;A+Exw0DQ;EAOI,iCAAA;A/Eqw0DZ;;A+E5w0DQ;EAOI,sCAAA;A/Eyw0DZ;;A+Ehx0DQ;EAOI,yCAAA;A/E6w0DZ;;A+Epx0DQ;EAOI,uBAAA;A/Eix0DZ;;A+Exx0DQ;EAOI,uBAAA;A/Eqx0DZ;;A+E5x0DQ;EAOI,yBAAA;A/Eyx0DZ;;A+Ehy0DQ;EAOI,yBAAA;A/E6x0DZ;;A+Epy0DQ;EAOI,0BAAA;A/Eiy0DZ;;A+Exy0DQ;EAOI,4BAAA;A/Eqy0DZ;;A+E5y0DQ;EAOI,kCAAA;A/Eyy0DZ;;A+Ehz0DQ;EAOI,sCAAA;A/E6y0DZ;;A+Epz0DQ;EAOI,oCAAA;A/Eiz0DZ;;A+Exz0DQ;EAOI,kCAAA;A/Eqz0DZ;;A+E5z0DQ;EAOI,yCAAA;A/Eyz0DZ;;A+Eh00DQ;EAOI,wCAAA;A/E6z0DZ;;A+Ep00DQ;EAOI,wCAAA;A/Ei00DZ;;A+Ex00DQ;EAOI,kCAAA;A/Eq00DZ;;A+E500DQ;EAOI,gCAAA;A/Ey00DZ;;A+Eh10DQ;EAOI,8BAAA;A/E600DZ;;A+Ep10DQ;EAOI,gCAAA;A/Ei10DZ;;A+Ex10DQ;EAOI,+BAAA;A/Eq10DZ;;A+E510DQ;EAOI,oCAAA;A/Ey10DZ;;A+Eh20DQ;EAOI,kCAAA;A/E610DZ;;A+Ep20DQ;EAOI,gCAAA;A/Ei20DZ;;A+Ex20DQ;EAOI,uCAAA;A/Eq20DZ;;A+E520DQ;EAOI,sCAAA;A/Ey20DZ;;A+Eh30DQ;EAOI,iCAAA;A/E620DZ;;A+Ep30DQ;EAOI,2BAAA;A/Ei30DZ;;A+Ex30DQ;EAOI,iCAAA;A/Eq30DZ;;A+E530DQ;EAOI,+BAAA;A/Ey30DZ;;A+Eh40DQ;EAOI,6BAAA;A/E630DZ;;A+Ep40DQ;EAOI,+BAAA;A/Ei40DZ;;A+Ex40DQ;EAOI,8BAAA;A/Eq40DZ;;A+E540DQ;EAOI,oBAAA;A/Ey40DZ;;A+Eh50DQ;EAOI,mBAAA;A/E640DZ;;A+Ep50DQ;EAOI,mBAAA;A/Ei50DZ;;A+Ex50DQ;EAOI,mBAAA;A/Eq50DZ;;A+E550DQ;EAOI,mBAAA;A/Ey50DZ;;A+Eh60DQ;EAOI,mBAAA;A/E650DZ;;A+Ep60DQ;EAOI,mBAAA;A/Ei60DZ;;A+Ex60DQ;EAOI,mBAAA;A/Eq60DZ;;A+E560DQ;EAOI,oBAAA;A/Ey60DZ;;A+Eh70DQ;EAOI,0BAAA;A/E660DZ;;A+Ep70DQ;EAOI,yBAAA;A/Ei70DZ;;A+Ex70DQ;EAOI,uBAAA;A/Eq70DZ;;A+E570DQ;EAOI,yBAAA;A/Ey70DZ;;A+Eh80DQ;EAOI,uBAAA;A/E670DZ;;A+Ep80DQ;EAOI,uBAAA;A/Ei80DZ;;A+Ex80DQ;EAOI,0BAAA;EAAA,yBAAA;A/Es80DZ;;A+E780DQ;EAOI,gCAAA;EAAA,+BAAA;A/E280DZ;;A+El90DQ;EAOI,+BAAA;EAAA,8BAAA;A/Eg90DZ;;A+Ev90DQ;EAOI,6BAAA;EAAA,4BAAA;A/Eq90DZ;;A+E590DQ;EAOI,+BAAA;EAAA,8BAAA;A/E090DZ;;A+Ej+0DQ;EAOI,6BAAA;EAAA,4BAAA;A/E+90DZ;;A+Et+0DQ;EAOI,6BAAA;EAAA,4BAAA;A/Eo+0DZ;;A+E3+0DQ;EAOI,wBAAA;EAAA,2BAAA;A/Ey+0DZ;;A+Eh/0DQ;EAOI,8BAAA;EAAA,iCAAA;A/E8+0DZ;;A+Er/0DQ;EAOI,6BAAA;EAAA,gCAAA;A/Em/0DZ;;A+E1/0DQ;EAOI,2BAAA;EAAA,8BAAA;A/Ew/0DZ;;A+E//0DQ;EAOI,6BAAA;EAAA,gCAAA;A/E6/0DZ;;A+Epg1DQ;EAOI,2BAAA;EAAA,8BAAA;A/Ekg1DZ;;A+Ezg1DQ;EAOI,2BAAA;EAAA,8BAAA;A/Eug1DZ;;A+E9g1DQ;EAOI,wBAAA;A/E2g1DZ;;A+Elh1DQ;EAOI,8BAAA;A/E+g1DZ;;A+Eth1DQ;EAOI,6BAAA;A/Emh1DZ;;A+E1h1DQ;EAOI,2BAAA;A/Euh1DZ;;A+E9h1DQ;EAOI,6BAAA;A/E2h1DZ;;A+Eli1DQ;EAOI,2BAAA;A/E+h1DZ;;A+Eti1DQ;EAOI,2BAAA;A/Emi1DZ;;A+E1i1DQ;EAOI,0BAAA;A/Eui1DZ;;A+E9i1DQ;EAOI,gCAAA;A/E2i1DZ;;A+Elj1DQ;EAOI,+BAAA;A/E+i1DZ;;A+Etj1DQ;EAOI,6BAAA;A/Emj1DZ;;A+E1j1DQ;EAOI,+BAAA;A/Euj1DZ;;A+E9j1DQ;EAOI,6BAAA;A/E2j1DZ;;A+Elk1DQ;EAOI,6BAAA;A/E+j1DZ;;A+Etk1DQ;EAOI,2BAAA;A/Emk1DZ;;A+E1k1DQ;EAOI,iCAAA;A/Euk1DZ;;A+E9k1DQ;EAOI,gCAAA;A/E2k1DZ;;A+Ell1DQ;EAOI,8BAAA;A/E+k1DZ;;A+Etl1DQ;EAOI,gCAAA;A/Eml1DZ;;A+E1l1DQ;EAOI,8BAAA;A/Eul1DZ;;A+E9l1DQ;EAOI,8BAAA;A/E2l1DZ;;A+Elm1DQ;EAOI,yBAAA;A/E+l1DZ;;A+Etm1DQ;EAOI,+BAAA;A/Emm1DZ;;A+E1m1DQ;EAOI,8BAAA;A/Eum1DZ;;A+E9m1DQ;EAOI,4BAAA;A/E2m1DZ;;A+Eln1DQ;EAOI,8BAAA;A/E+m1DZ;;A+Etn1DQ;EAOI,4BAAA;A/Emn1DZ;;A+E1n1DQ;EAOI,4BAAA;A/Eun1DZ;;A+E9n1DQ;EAOI,2BAAA;A/E2n1DZ;;A+Elo1DQ;EAOI,0BAAA;A/E+n1DZ;;A+Eto1DQ;EAOI,wBAAA;A/Emo1DZ;;A+E1o1DQ;EAOI,0BAAA;A/Euo1DZ;;A+E9o1DQ;EAOI,wBAAA;A/E2o1DZ;;A+Elp1DQ;EAOI,iCAAA;EAAA,gCAAA;A/Egp1DZ;;A+Evp1DQ;EAOI,gCAAA;EAAA,+BAAA;A/Eqp1DZ;;A+E5p1DQ;EAOI,8BAAA;EAAA,6BAAA;A/E0p1DZ;;A+Ejq1DQ;EAOI,gCAAA;EAAA,+BAAA;A/E+p1DZ;;A+Etq1DQ;EAOI,8BAAA;EAAA,6BAAA;A/Eoq1DZ;;A+E3q1DQ;EAOI,+BAAA;EAAA,kCAAA;A/Eyq1DZ;;A+Ehr1DQ;EAOI,8BAAA;EAAA,iCAAA;A/E8q1DZ;;A+Err1DQ;EAOI,4BAAA;EAAA,+BAAA;A/Emr1DZ;;A+E1r1DQ;EAOI,8BAAA;EAAA,iCAAA;A/Ewr1DZ;;A+E/r1DQ;EAOI,4BAAA;EAAA,+BAAA;A/E6r1DZ;;A+Eps1DQ;EAOI,+BAAA;A/Eis1DZ;;A+Exs1DQ;EAOI,8BAAA;A/Eqs1DZ;;A+E5s1DQ;EAOI,4BAAA;A/Eys1DZ;;A+Eht1DQ;EAOI,8BAAA;A/E6s1DZ;;A+Ept1DQ;EAOI,4BAAA;A/Eit1DZ;;A+Ext1DQ;EAOI,iCAAA;A/Eqt1DZ;;A+E5t1DQ;EAOI,gCAAA;A/Eyt1DZ;;A+Ehu1DQ;EAOI,8BAAA;A/E6t1DZ;;A+Epu1DQ;EAOI,gCAAA;A/Eiu1DZ;;A+Exu1DQ;EAOI,8BAAA;A/Equ1DZ;;A+E5u1DQ;EAOI,kCAAA;A/Eyu1DZ;;A+Ehv1DQ;EAOI,iCAAA;A/E6u1DZ;;A+Epv1DQ;EAOI,+BAAA;A/Eiv1DZ;;A+Exv1DQ;EAOI,iCAAA;A/Eqv1DZ;;A+E5v1DQ;EAOI,+BAAA;A/Eyv1DZ;;A+Ehw1DQ;EAOI,gCAAA;A/E6v1DZ;;A+Epw1DQ;EAOI,+BAAA;A/Eiw1DZ;;A+Exw1DQ;EAOI,6BAAA;A/Eqw1DZ;;A+E5w1DQ;EAOI,+BAAA;A/Eyw1DZ;;A+Ehx1DQ;EAOI,6BAAA;A/E6w1DZ;;A+Epx1DQ;EAOI,qBAAA;A/Eix1DZ;;A+Exx1DQ;EAOI,2BAAA;A/Eqx1DZ;;A+E5x1DQ;EAOI,0BAAA;A/Eyx1DZ;;A+Ehy1DQ;EAOI,wBAAA;A/E6x1DZ;;A+Epy1DQ;EAOI,0BAAA;A/Eiy1DZ;;A+Exy1DQ;EAOI,wBAAA;A/Eqy1DZ;;A+E5y1DQ;EAOI,2BAAA;EAAA,0BAAA;A/E0y1DZ;;A+Ejz1DQ;EAOI,iCAAA;EAAA,gCAAA;A/E+y1DZ;;A+Etz1DQ;EAOI,gCAAA;EAAA,+BAAA;A/Eoz1DZ;;A+E3z1DQ;EAOI,8BAAA;EAAA,6BAAA;A/Eyz1DZ;;A+Eh01DQ;EAOI,gCAAA;EAAA,+BAAA;A/E8z1DZ;;A+Er01DQ;EAOI,8BAAA;EAAA,6BAAA;A/Em01DZ;;A+E101DQ;EAOI,yBAAA;EAAA,4BAAA;A/Ew01DZ;;A+E/01DQ;EAOI,+BAAA;EAAA,kCAAA;A/E601DZ;;A+Ep11DQ;EAOI,8BAAA;EAAA,iCAAA;A/Ek11DZ;;A+Ez11DQ;EAOI,4BAAA;EAAA,+BAAA;A/Eu11DZ;;A+E911DQ;EAOI,8BAAA;EAAA,iCAAA;A/E411DZ;;A+En21DQ;EAOI,4BAAA;EAAA,+BAAA;A/Ei21DZ;;A+Ex21DQ;EAOI,yBAAA;A/Eq21DZ;;A+E521DQ;EAOI,+BAAA;A/Ey21DZ;;A+Eh31DQ;EAOI,8BAAA;A/E621DZ;;A+Ep31DQ;EAOI,4BAAA;A/Ei31DZ;;A+Ex31DQ;EAOI,8BAAA;A/Eq31DZ;;A+E531DQ;EAOI,4BAAA;A/Ey31DZ;;A+Eh41DQ;EAOI,2BAAA;A/E631DZ;;A+Ep41DQ;EAOI,iCAAA;A/Ei41DZ;;A+Ex41DQ;EAOI,gCAAA;A/Eq41DZ;;A+E541DQ;EAOI,8BAAA;A/Ey41DZ;;A+Eh51DQ;EAOI,gCAAA;A/E641DZ;;A+Ep51DQ;EAOI,8BAAA;A/Ei51DZ;;A+Ex51DQ;EAOI,4BAAA;A/Eq51DZ;;A+E551DQ;EAOI,kCAAA;A/Ey51DZ;;A+Eh61DQ;EAOI,iCAAA;A/E651DZ;;A+Ep61DQ;EAOI,+BAAA;A/Ei61DZ;;A+Ex61DQ;EAOI,iCAAA;A/Eq61DZ;;A+E561DQ;EAOI,+BAAA;A/Ey61DZ;;A+Eh71DQ;EAOI,0BAAA;A/E661DZ;;A+Ep71DQ;EAOI,gCAAA;A/Ei71DZ;;A+Ex71DQ;EAOI,+BAAA;A/Eq71DZ;;A+E571DQ;EAOI,6BAAA;A/Ey71DZ;;A+Eh81DQ;EAOI,+BAAA;A/E671DZ;;A+Ep81DQ;EAOI,6BAAA;A/Ei81DZ;;A+Ex81DQ;EAOI,iBAAA;A/Eq81DZ;;A+E581DQ;EAOI,uBAAA;A/Ey81DZ;;A+Eh91DQ;EAOI,sBAAA;A/E681DZ;;A+Ep91DQ;EAOI,oBAAA;A/Ei91DZ;;A+Ex91DQ;EAOI,sBAAA;A/Eq91DZ;;A+E591DQ;EAOI,oBAAA;A/Ey91DZ;;A+Eh+1DQ;EAOI,qBAAA;A/E691DZ;;A+Ep+1DQ;EAOI,2BAAA;A/Ei+1DZ;;A+Ex+1DQ;EAOI,0BAAA;A/Eq+1DZ;;A+E5+1DQ;EAOI,wBAAA;A/Ey+1DZ;;A+Eh/1DQ;EAOI,0BAAA;A/E6+1DZ;;A+Ep/1DQ;EAOI,wBAAA;A/Ei/1DZ;;A+Ex/1DQ;EAOI,wBAAA;A/Eq/1DZ;;A+E5/1DQ;EAOI,8BAAA;A/Ey/1DZ;;A+Ehg2DQ;EAOI,6BAAA;A/E6/1DZ;;A+Epg2DQ;EAOI,2BAAA;A/Eig2DZ;;A+Exg2DQ;EAOI,6BAAA;A/Eqg2DZ;;A+E5g2DQ;EAOI,2BAAA;A/Eyg2DZ;;A+Ehh2DQ;EAOI,gDAAA;A/E6g2DZ;;A+Eph2DQ;EAOI,gDAAA;A/Eih2DZ;;A+Exh2DQ;EAOI,4CAAA;A/Eqh2DZ;;A+E5h2DQ;EAOI,kDAAA;A/Eyh2DZ;;A+Ehi2DQ;EAOI,+BAAA;A/E6h2DZ;;A+Epi2DQ;EAOI,gCAAA;A/Eii2DZ;;A+Exi2DQ;EAOI,8BAAA;A/Eqi2DZ;;A+E5i2DQ;EAOI,6BAAA;A/Eyi2DZ;;A+Ehj2DQ;EAOI,6BAAA;A/E6i2DZ;;A+Epj2DQ;EAOI,+BAAA;A/Eij2DZ;;A+Exj2DQ;EAOI,2BAAA;A/Eqj2DZ;;A+E5j2DQ;EAOI,2BAAA;A/Eyj2DZ;;A+Ehk2DQ;EAOI,2BAAA;A/E6j2DZ;;A+Epk2DQ;EAOI,2BAAA;A/Eik2DZ;;A+Exk2DQ;EAOI,2BAAA;A/Eqk2DZ;;A+E5k2DQ;EAOI,8BAAA;A/Eyk2DZ;;A+Ehl2DQ;EAOI,yBAAA;A/E6k2DZ;;A+Epl2DQ;EAOI,4BAAA;A/Eil2DZ;;A+Exl2DQ;EAOI,2BAAA;A/Eql2DZ;;A+E5l2DQ;EAOI,yBAAA;A/Eyl2DZ;;A+Ehm2DQ;EAOI,2BAAA;A/E6l2DZ;;A+Epm2DQ;EAOI,4BAAA;A/Eim2DZ;;A+Exm2DQ;EAOI,6BAAA;A/Eqm2DZ;;A+E5m2DQ;EAOI,gCAAA;A/Eym2DZ;;A+Ehn2DQ;EAOI,qCAAA;A/E6m2DZ;;A+Epn2DQ;EAOI,wCAAA;A/Ein2DZ;;A+Exn2DQ;EAOI,oCAAA;A/Eqn2DZ;;A+E5n2DQ;EAOI,oCAAA;A/Eyn2DZ;;A+Eho2DQ;EAOI,qCAAA;A/E6n2DZ;;A+Epo2DQ;EAOI,8BAAA;A/Eio2DZ;;A+Exo2DQ;EAOI,8BAAA;A/Eqo2DZ;;A+E1p2DQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;A/E2o2DZ;;A+Exn2DQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;A/Eip2DZ;;A+Exp2DQ;EAIQ,oBAAA;EAGJ,uEAAA;A/Esp2DZ;;A+E7p2DQ;EAIQ,oBAAA;EAGJ,qEAAA;A/E2p2DZ;;A+Elq2DQ;EAIQ,oBAAA;EAGJ,kEAAA;A/Egq2DZ;;A+Evq2DQ;EAIQ,oBAAA;EAGJ,qEAAA;A/Eqq2DZ;;A+E5q2DQ;EAIQ,oBAAA;EAGJ,oEAAA;A/E0q2DZ;;A+Ejr2DQ;EAIQ,oBAAA;EAGJ,mEAAA;A/E+q2DZ;;A+Etr2DQ;EAIQ,oBAAA;EAGJ,kEAAA;A/Eor2DZ;;A+E3r2DQ;EAIQ,oBAAA;EAGJ,4EAAA;A/Eyr2DZ;;A+Ehs2DQ;EAIQ,oBAAA;EAGJ,kFAAA;A/E8r2DZ;;A+Ers2DQ;EAIQ,oBAAA;EAGJ,yEAAA;A/Ems2DZ;;A+E1s2DQ;EAIQ,oBAAA;EAGJ,oEAAA;A/Ews2DZ;;A+E/s2DQ;EAIQ,oBAAA;EAGJ,yEAAA;A/E6s2DZ;;A+Ept2DQ;EAIQ,oBAAA;EAGJ,gFAAA;A/Ekt2DZ;;A+Ezt2DQ;EAIQ,oBAAA;EAGJ,+EAAA;A/Eut2DZ;;A+E9t2DQ;EAIQ,oBAAA;EAGJ,mEAAA;A/E4t2DZ;;A+Enu2DQ;EAIQ,oBAAA;EAGJ,wEAAA;A/Eiu2DZ;;A+Exu2DQ;EAIQ,oBAAA;EAGJ,mEAAA;A/Esu2DZ;;A+E7u2DQ;EAIQ,oBAAA;EAGJ,wEAAA;A/E2u2DZ;;A+Elv2DQ;EAIQ,oBAAA;EAGJ,2CAAA;A/Egv2DZ;;A+Evv2DQ;EAIQ,oBAAA;EAGJ,oCAAA;A/Eqv2DZ;;A+E5v2DQ;EAIQ,oBAAA;EAGJ,0CAAA;A/E0v2DZ;;A+Ejw2DQ;EAIQ,oBAAA;EAGJ,2CAAA;A/E+v2DZ;;A+Etw2DQ;EAIQ,oBAAA;EAGJ,0CAAA;A/Eow2DZ;;A+E3w2DQ;EAIQ,oBAAA;EAGJ,0CAAA;A/Eyw2DZ;;A+Ehx2DQ;EAIQ,oBAAA;EAGJ,yBAAA;A/E8w2DZ;;A+E/x2DQ;EACE,uBAAA;A/Eky2DV;;A+Eny2DQ;EACE,sBAAA;A/Esy2DV;;A+Evy2DQ;EACE,uBAAA;A/E0y2DV;;A+E3y2DQ;EACE,oBAAA;A/E8y2DV;;A+Ery2DQ;EAOI,iDAAA;A/Eky2DZ;;A+Ezy2DQ;EAOI,mDAAA;A/Esy2DZ;;A+E7y2DQ;EAOI,iDAAA;A/E0y2DZ;;A+Ejz2DQ;EAOI,8CAAA;A/E8y2DZ;;A+Erz2DQ;EAOI,iDAAA;A/Ekz2DZ;;A+Ezz2DQ;EAOI,gDAAA;A/Esz2DZ;;A+E7z2DQ;EAOI,+CAAA;A/E0z2DZ;;A+Ej02DQ;EAOI,8CAAA;A/E8z2DZ;;A+E/02DQ;EACE,sBAAA;A/Ek12DV;;A+E902DU;EACE,sBAAA;A/Ei12DZ;;A+Ev12DQ;EACE,uBAAA;A/E012DV;;A+Et12DU;EACE,uBAAA;A/Ey12DZ;;A+E/12DQ;EACE,sBAAA;A/Ek22DV;;A+E912DU;EACE,sBAAA;A/Ei22DZ;;A+Ev22DQ;EACE,uBAAA;A/E022DV;;A+Et22DU;EACE,uBAAA;A/Ey22DZ;;A+E/22DQ;EACE,oBAAA;A/Ek32DV;;A+E922DU;EACE,oBAAA;A/Ei32DZ;;A+E722DQ;EAOI,yCAAA;A/E022DZ;;A+Er22DU;EAOI,yCAAA;A/Ek22Dd;;A+Er32DQ;EAOI,wCAAA;A/Ek32DZ;;A+E722DU;EAOI,wCAAA;A/E022Dd;;A+E732DQ;EAOI,yCAAA;A/E032DZ;;A+Er32DU;EAOI,yCAAA;A/Ek32Dd;;A+Er42DQ;EAIQ,8BAAA;EAGJ,+FAAA;A/Em42DZ;;A+E142DQ;EAIQ,8BAAA;EAGJ,iGAAA;A/Ew42DZ;;A+E/42DQ;EAIQ,8BAAA;EAGJ,+FAAA;A/E642DZ;;A+Ep52DQ;EAIQ,8BAAA;EAGJ,4FAAA;A/Ek52DZ;;A+Ez52DQ;EAIQ,8BAAA;EAGJ,+FAAA;A/Eu52DZ;;A+E952DQ;EAIQ,8BAAA;EAGJ,8FAAA;A/E452DZ;;A+En62DQ;EAIQ,8BAAA;EAGJ,6FAAA;A/Ei62DZ;;A+Ex62DQ;EAIQ,8BAAA;EAGJ,4FAAA;A/Es62DZ;;A+E762DQ;EAIQ,8BAAA;EAGJ,sGAAA;A/E262DZ;;A+El72DQ;EAIQ,8BAAA;EAGJ,4GAAA;A/Eg72DZ;;A+Ev72DQ;EAIQ,8BAAA;EAGJ,mGAAA;A/Eq72DZ;;A+E572DQ;EAIQ,8BAAA;EAGJ,8FAAA;A/E072DZ;;A+Ej82DQ;EAIQ,8BAAA;EAGJ,mGAAA;A/E+72DZ;;A+Et82DQ;EAIQ,8BAAA;EAGJ,0GAAA;A/Eo82DZ;;A+E382DQ;EAIQ,8BAAA;EAGJ,yGAAA;A/Ey82DZ;;A+Eh92DQ;EAIQ,8BAAA;EAGJ,6FAAA;A/E882DZ;;A+Er92DQ;EAIQ,8BAAA;EAGJ,kGAAA;A/Em92DZ;;A+E192DQ;EAIQ,8BAAA;EAGJ,qGAAA;A/Ew92DZ;;A+Ez+2DQ;EACE,8BAAA;A/E4+2DV;;A+Ex+2DU;EACE,8BAAA;A/E2+2DZ;;A+Ej/2DQ;EACE,gCAAA;A/Eo/2DV;;A+Eh/2DU;EACE,gCAAA;A/Em/2DZ;;A+Ez/2DQ;EACE,iCAAA;A/E4/2DV;;A+Ex/2DU;EACE,iCAAA;A/E2/2DZ;;A+Ejg3DQ;EACE,gCAAA;A/Eog3DV;;A+Ehg3DU;EACE,gCAAA;A/Emg3DZ;;A+Ezg3DQ;EACE,iCAAA;A/E4g3DV;;A+Exg3DU;EACE,iCAAA;A/E2g3DZ;;A+Ejh3DQ;EACE,8BAAA;A/Eoh3DV;;A+Ehh3DU;EACE,8BAAA;A/Emh3DZ;;A+E/g3DQ;EAIQ,kBAAA;EAGJ,8EAAA;A/E6g3DZ;;A+Eph3DQ;EAIQ,kBAAA;EAGJ,gFAAA;A/Ekh3DZ;;A+Ezh3DQ;EAIQ,kBAAA;EAGJ,8EAAA;A/Euh3DZ;;A+E9h3DQ;EAIQ,kBAAA;EAGJ,2EAAA;A/E4h3DZ;;A+Eni3DQ;EAIQ,kBAAA;EAGJ,8EAAA;A/Eii3DZ;;A+Exi3DQ;EAIQ,kBAAA;EAGJ,6EAAA;A/Esi3DZ;;A+E7i3DQ;EAIQ,kBAAA;EAGJ,4EAAA;A/E2i3DZ;;A+Elj3DQ;EAIQ,kBAAA;EAGJ,2EAAA;A/Egj3DZ;;A+Evj3DQ;EAIQ,kBAAA;EAGJ,qFAAA;A/Eqj3DZ;;A+E5j3DQ;EAIQ,kBAAA;EAGJ,2FAAA;A/E0j3DZ;;A+Ejk3DQ;EAIQ,kBAAA;EAGJ,kFAAA;A/E+j3DZ;;A+Etk3DQ;EAIQ,kBAAA;EAGJ,6EAAA;A/Eok3DZ;;A+E3k3DQ;EAIQ,kBAAA;EAGJ,kFAAA;A/Eyk3DZ;;A+Ehl3DQ;EAIQ,kBAAA;EAGJ,yFAAA;A/E8k3DZ;;A+Erl3DQ;EAIQ,kBAAA;EAGJ,wFAAA;A/Eml3DZ;;A+E1l3DQ;EAIQ,kBAAA;EAGJ,4EAAA;A/Ewl3DZ;;A+E/l3DQ;EAIQ,kBAAA;EAGJ,iFAAA;A/E6l3DZ;;A+Epm3DQ;EAIQ,kBAAA;EAGJ,4EAAA;A/Ekm3DZ;;A+Ezm3DQ;EAIQ,kBAAA;EAGJ,8EAAA;A/Eum3DZ;;A+E9m3DQ;EAIQ,kBAAA;EAGJ,wCAAA;A/E4m3DZ;;A+Enn3DQ;EAIQ,kBAAA;EAGJ,mFAAA;A/Ein3DZ;;A+Exn3DQ;EAIQ,kBAAA;EAGJ,kFAAA;A/Esn3DZ;;A+Evo3DQ;EACE,oBAAA;A/E0o3DV;;A+E3o3DQ;EACE,qBAAA;A/E8o3DV;;A+E/o3DQ;EACE,oBAAA;A/Ekp3DV;;A+Enp3DQ;EACE,qBAAA;A/Esp3DV;;A+Evp3DQ;EACE,kBAAA;A/E0p3DV;;A+Ejp3DQ;EAOI,wDAAA;A/E8o3DZ;;A+Erp3DQ;EAOI,0DAAA;A/Ekp3DZ;;A+Ezp3DQ;EAOI,wDAAA;A/Esp3DZ;;A+E7p3DQ;EAOI,qDAAA;A/E0p3DZ;;A+Ejq3DQ;EAOI,wDAAA;A/E8p3DZ;;A+Erq3DQ;EAOI,uDAAA;A/Ekq3DZ;;A+Ezq3DQ;EAOI,sDAAA;A/Esq3DZ;;A+E7q3DQ;EAOI,qDAAA;A/E0q3DZ;;A+Ejr3DQ;EAOI,+CAAA;A/E8q3DZ;;A+Err3DQ;EAOI,mCAAA;UAAA,2BAAA;A/Ekr3DZ;;A+Ezr3DQ;EAOI,oCAAA;UAAA,4BAAA;A/Esr3DZ;;A+E7r3DQ;EAOI,oCAAA;UAAA,4BAAA;A/E0r3DZ;;A+Ejs3DQ;EAOI,+BAAA;A/E8r3DZ;;A+Ers3DQ;EAOI,+BAAA;A/Eks3DZ;;A+Ezs3DQ;EAOI,iDAAA;A/Ess3DZ;;A+E7s3DQ;EAOI,2BAAA;A/E0s3DZ;;A+Ejt3DQ;EAOI,oDAAA;A/E8s3DZ;;A+Ert3DQ;EAOI,iDAAA;A/Ekt3DZ;;A+Ezt3DQ;EAOI,oDAAA;A/Est3DZ;;A+E7t3DQ;EAOI,oDAAA;A/E0t3DZ;;A+Eju3DQ;EAOI,qDAAA;A/E8t3DZ;;A+Eru3DQ;EAOI,6BAAA;A/Eku3DZ;;A+Ezu3DQ;EAOI,sDAAA;A/Esu3DZ;;A+E7u3DQ;EAOI,0DAAA;EAAA,2DAAA;A/E2u3DZ;;A+Elv3DQ;EAOI,oCAAA;EAAA,qCAAA;A/Egv3DZ;;A+Evv3DQ;EAOI,6DAAA;EAAA,8DAAA;A/Eqv3DZ;;A+E5v3DQ;EAOI,0DAAA;EAAA,2DAAA;A/E0v3DZ;;A+Ejw3DQ;EAOI,6DAAA;EAAA,8DAAA;A/E+v3DZ;;A+Etw3DQ;EAOI,6DAAA;EAAA,8DAAA;A/Eow3DZ;;A+E3w3DQ;EAOI,8DAAA;EAAA,+DAAA;A/Eyw3DZ;;A+Ehx3DQ;EAOI,sCAAA;EAAA,uCAAA;A/E8w3DZ;;A+Erx3DQ;EAOI,+DAAA;EAAA,gEAAA;A/Emx3DZ;;A+E1x3DQ;EAOI,2DAAA;EAAA,8DAAA;A/Ewx3DZ;;A+E/x3DQ;EAOI,qCAAA;EAAA,wCAAA;A/E6x3DZ;;A+Epy3DQ;EAOI,8DAAA;EAAA,iEAAA;A/Eky3DZ;;A+Ezy3DQ;EAOI,2DAAA;EAAA,8DAAA;A/Euy3DZ;;A+E9y3DQ;EAOI,8DAAA;EAAA,iEAAA;A/E4y3DZ;;A+Enz3DQ;EAOI,8DAAA;EAAA,iEAAA;A/Eiz3DZ;;A+Exz3DQ;EAOI,+DAAA;EAAA,kEAAA;A/Esz3DZ;;A+E7z3DQ;EAOI,uCAAA;EAAA,0CAAA;A/E2z3DZ;;A+El03DQ;EAOI,gEAAA;EAAA,mEAAA;A/Eg03DZ;;A+Ev03DQ;EAOI,8DAAA;EAAA,6DAAA;A/Eq03DZ;;A+E503DQ;EAOI,wCAAA;EAAA,uCAAA;A/E003DZ;;A+Ej13DQ;EAOI,iEAAA;EAAA,gEAAA;A/E+03DZ;;A+Et13DQ;EAOI,8DAAA;EAAA,6DAAA;A/Eo13DZ;;A+E313DQ;EAOI,iEAAA;EAAA,gEAAA;A/Ey13DZ;;A+Eh23DQ;EAOI,iEAAA;EAAA,gEAAA;A/E813DZ;;A+Er23DQ;EAOI,kEAAA;EAAA,iEAAA;A/Em23DZ;;A+E123DQ;EAOI,0CAAA;EAAA,yCAAA;A/Ew23DZ;;A+E/23DQ;EAOI,mEAAA;EAAA,kEAAA;A/E623DZ;;A+Ep33DQ;EAOI,6DAAA;EAAA,0DAAA;A/Ek33DZ;;A+Ez33DQ;EAOI,uCAAA;EAAA,oCAAA;A/Eu33DZ;;A+E933DQ;EAOI,gEAAA;EAAA,6DAAA;A/E433DZ;;A+En43DQ;EAOI,6DAAA;EAAA,0DAAA;A/Ei43DZ;;A+Ex43DQ;EAOI,gEAAA;EAAA,6DAAA;A/Es43DZ;;A+E743DQ;EAOI,gEAAA;EAAA,6DAAA;A/E243DZ;;A+El53DQ;EAOI,iEAAA;EAAA,8DAAA;A/Eg53DZ;;A+Ev53DQ;EAOI,yCAAA;EAAA,sCAAA;A/Eq53DZ;;A+E553DQ;EAOI,kEAAA;EAAA,+DAAA;A/E053DZ;;A+Ej63DQ;EAOI,8BAAA;A/E853DZ;;A+Er63DQ;EAOI,6BAAA;A/Ek63DZ;;A+Ez63DQ;EAOI,sBAAA;A/Es63DZ;;A+E763DQ;EAOI,qBAAA;A/E063DZ;;A+Ej73DQ;EAOI,qBAAA;A/E863DZ;;A+Er73DQ;EAOI,qBAAA;A/Ek73DZ;;A+Ez73DQ;EAOI,qBAAA;A/Es73DZ;;A+E773DQ;EAOI,0BAAA;A/E073DZ;;A+Ej83DQ;EAOI,0BAAA;A/E873DZ;;A+Er83DQ;EAOI,0BAAA;A/Ek83DZ;;A+Ez83DQ;EAOI,0BAAA;A/Es83DZ;;A+E783DQ;EAOI,0BAAA;A/E083DZ;;A+Ej93DQ;EAOI,0BAAA;A/E883DZ;;A+Er93DQ;EAOI,0BAAA;A/Ek93DZ;;A+Ez93DQ;EAOI,0BAAA;A/Es93DZ;;A+E793DQ;EAOI,0BAAA;A/E093DZ;;A+Ej+3DQ;EAOI,0BAAA;A/E893DZ;;A+Er+3DQ;EAOI,0BAAA;A/Ek+3DZ;;A+Ez+3DQ;EAOI,0BAAA;A/Es+3DZ;;A+E7+3DQ;EAOI,0BAAA;A/E0+3DZ;;A+Ej/3DQ;EAOI,0BAAA;A/E8+3DZ;;A+Er/3DQ;EAOI,0BAAA;A/Ek/3DZ;;A+Ez/3DQ;EAOI,0BAAA;A/Es/3DZ;;A+E7/3DQ;EAOI,0BAAA;A/E0/3DZ;;A+Ejg4DQ;EAOI,uBAAA;A/E8/3DZ;;A+Erg4DQ;EAOI,0BAAA;A/Ekg4DZ;;A+Ezg4DQ;EAOI,uBAAA;A/Esg4DZ;;AqBhh4DI;E0DGI;IAOI,sBAAA;E/E2g4DV;;E+Elh4DM;IAOI,uBAAA;E/E+g4DV;;E+Eth4DM;IAOI,sBAAA;E/Emh4DV;;E+E1h4DM;IAOI,8BAAA;E/Euh4DV;;E+E9h4DM;IAOI,4BAAA;E/E2h4DV;;E+Eli4DM;IAOI,2BAAA;E/E+h4DV;;E+Eti4DM;IAOI,iCAAA;E/Emi4DV;;E+E1i4DM;IAOI,2BAAA;E/Eui4DV;;E+E9i4DM;IAOI,0BAAA;E/E2i4DV;;E+Elj4DM;IAOI,gCAAA;E/E+i4DV;;E+Etj4DM;IAOI,yBAAA;E/Emj4DV;;E+E1j4DM;IAOI,wBAAA;E/Euj4DV;;E+E9j4DM;IAOI,+BAAA;E/E2j4DV;;E+Elk4DM;IAOI,yBAAA;E/E+j4DV;;E+Etk4DM;IAOI,6BAAA;E/Emk4DV;;E+E1k4DM;IAOI,8BAAA;E/Euk4DV;;E+E9k4DM;IAOI,wBAAA;E/E2k4DV;;E+Ell4DM;IAOI,+BAAA;E/E+k4DV;;E+Etl4DM;IAOI,wBAAA;E/Eml4DV;;E+E1l4DM;IAOI,yBAAA;E/Eul4DV;;E+E9l4DM;IAOI,8BAAA;E/E2l4DV;;E+Elm4DM;IAOI,iCAAA;E/E+l4DV;;E+Etm4DM;IAOI,sCAAA;E/Emm4DV;;E+E1m4DM;IAOI,yCAAA;E/Eum4DV;;E+E9m4DM;IAOI,uBAAA;E/E2m4DV;;E+Eln4DM;IAOI,uBAAA;E/E+m4DV;;E+Etn4DM;IAOI,yBAAA;E/Emn4DV;;E+E1n4DM;IAOI,yBAAA;E/Eun4DV;;E+E9n4DM;IAOI,0BAAA;E/E2n4DV;;E+Elo4DM;IAOI,4BAAA;E/E+n4DV;;E+Eto4DM;IAOI,kCAAA;E/Emo4DV;;E+E1o4DM;IAOI,sCAAA;E/Euo4DV;;E+E9o4DM;IAOI,oCAAA;E/E2o4DV;;E+Elp4DM;IAOI,kCAAA;E/E+o4DV;;E+Etp4DM;IAOI,yCAAA;E/Emp4DV;;E+E1p4DM;IAOI,wCAAA;E/Eup4DV;;E+E9p4DM;IAOI,wCAAA;E/E2p4DV;;E+Elq4DM;IAOI,kCAAA;E/E+p4DV;;E+Etq4DM;IAOI,gCAAA;E/Emq4DV;;E+E1q4DM;IAOI,8BAAA;E/Euq4DV;;E+E9q4DM;IAOI,gCAAA;E/E2q4DV;;E+Elr4DM;IAOI,+BAAA;E/E+q4DV;;E+Etr4DM;IAOI,oCAAA;E/Emr4DV;;E+E1r4DM;IAOI,kCAAA;E/Eur4DV;;E+E9r4DM;IAOI,gCAAA;E/E2r4DV;;E+Els4DM;IAOI,uCAAA;E/E+r4DV;;E+Ets4DM;IAOI,sCAAA;E/Ems4DV;;E+E1s4DM;IAOI,iCAAA;E/Eus4DV;;E+E9s4DM;IAOI,2BAAA;E/E2s4DV;;E+Elt4DM;IAOI,iCAAA;E/E+s4DV;;E+Ett4DM;IAOI,+BAAA;E/Emt4DV;;E+E1t4DM;IAOI,6BAAA;E/Eut4DV;;E+E9t4DM;IAOI,+BAAA;E/E2t4DV;;E+Elu4DM;IAOI,8BAAA;E/E+t4DV;;E+Etu4DM;IAOI,oBAAA;E/Emu4DV;;E+E1u4DM;IAOI,mBAAA;E/Euu4DV;;E+E9u4DM;IAOI,mBAAA;E/E2u4DV;;E+Elv4DM;IAOI,mBAAA;E/E+u4DV;;E+Etv4DM;IAOI,mBAAA;E/Emv4DV;;E+E1v4DM;IAOI,mBAAA;E/Euv4DV;;E+E9v4DM;IAOI,mBAAA;E/E2v4DV;;E+Elw4DM;IAOI,mBAAA;E/E+v4DV;;E+Etw4DM;IAOI,oBAAA;E/Emw4DV;;E+E1w4DM;IAOI,0BAAA;E/Euw4DV;;E+E9w4DM;IAOI,yBAAA;E/E2w4DV;;E+Elx4DM;IAOI,uBAAA;E/E+w4DV;;E+Etx4DM;IAOI,yBAAA;E/Emx4DV;;E+E1x4DM;IAOI,uBAAA;E/Eux4DV;;E+E9x4DM;IAOI,uBAAA;E/E2x4DV;;E+Ely4DM;IAOI,0BAAA;IAAA,yBAAA;E/Egy4DV;;E+Evy4DM;IAOI,gCAAA;IAAA,+BAAA;E/Eqy4DV;;E+E5y4DM;IAOI,+BAAA;IAAA,8BAAA;E/E0y4DV;;E+Ejz4DM;IAOI,6BAAA;IAAA,4BAAA;E/E+y4DV;;E+Etz4DM;IAOI,+BAAA;IAAA,8BAAA;E/Eoz4DV;;E+E3z4DM;IAOI,6BAAA;IAAA,4BAAA;E/Eyz4DV;;E+Eh04DM;IAOI,6BAAA;IAAA,4BAAA;E/E8z4DV;;E+Er04DM;IAOI,wBAAA;IAAA,2BAAA;E/Em04DV;;E+E104DM;IAOI,8BAAA;IAAA,iCAAA;E/Ew04DV;;E+E/04DM;IAOI,6BAAA;IAAA,gCAAA;E/E604DV;;E+Ep14DM;IAOI,2BAAA;IAAA,8BAAA;E/Ek14DV;;E+Ez14DM;IAOI,6BAAA;IAAA,gCAAA;E/Eu14DV;;E+E914DM;IAOI,2BAAA;IAAA,8BAAA;E/E414DV;;E+En24DM;IAOI,2BAAA;IAAA,8BAAA;E/Ei24DV;;E+Ex24DM;IAOI,wBAAA;E/Eq24DV;;E+E524DM;IAOI,8BAAA;E/Ey24DV;;E+Eh34DM;IAOI,6BAAA;E/E624DV;;E+Ep34DM;IAOI,2BAAA;E/Ei34DV;;E+Ex34DM;IAOI,6BAAA;E/Eq34DV;;E+E534DM;IAOI,2BAAA;E/Ey34DV;;E+Eh44DM;IAOI,2BAAA;E/E634DV;;E+Ep44DM;IAOI,0BAAA;E/Ei44DV;;E+Ex44DM;IAOI,gCAAA;E/Eq44DV;;E+E544DM;IAOI,+BAAA;E/Ey44DV;;E+Eh54DM;IAOI,6BAAA;E/E644DV;;E+Ep54DM;IAOI,+BAAA;E/Ei54DV;;E+Ex54DM;IAOI,6BAAA;E/Eq54DV;;E+E554DM;IAOI,6BAAA;E/Ey54DV;;E+Eh64DM;IAOI,2BAAA;E/E654DV;;E+Ep64DM;IAOI,iCAAA;E/Ei64DV;;E+Ex64DM;IAOI,gCAAA;E/Eq64DV;;E+E564DM;IAOI,8BAAA;E/Ey64DV;;E+Eh74DM;IAOI,gCAAA;E/E664DV;;E+Ep74DM;IAOI,8BAAA;E/Ei74DV;;E+Ex74DM;IAOI,8BAAA;E/Eq74DV;;E+E574DM;IAOI,yBAAA;E/Ey74DV;;E+Eh84DM;IAOI,+BAAA;E/E674DV;;E+Ep84DM;IAOI,8BAAA;E/Ei84DV;;E+Ex84DM;IAOI,4BAAA;E/Eq84DV;;E+E584DM;IAOI,8BAAA;E/Ey84DV;;E+Eh94DM;IAOI,4BAAA;E/E684DV;;E+Ep94DM;IAOI,4BAAA;E/Ei94DV;;E+Ex94DM;IAOI,2BAAA;E/Eq94DV;;E+E594DM;IAOI,0BAAA;E/Ey94DV;;E+Eh+4DM;IAOI,wBAAA;E/E694DV;;E+Ep+4DM;IAOI,0BAAA;E/Ei+4DV;;E+Ex+4DM;IAOI,wBAAA;E/Eq+4DV;;E+E5+4DM;IAOI,iCAAA;IAAA,gCAAA;E/E0+4DV;;E+Ej/4DM;IAOI,gCAAA;IAAA,+BAAA;E/E++4DV;;E+Et/4DM;IAOI,8BAAA;IAAA,6BAAA;E/Eo/4DV;;E+E3/4DM;IAOI,gCAAA;IAAA,+BAAA;E/Ey/4DV;;E+Ehg5DM;IAOI,8BAAA;IAAA,6BAAA;E/E8/4DV;;E+Erg5DM;IAOI,+BAAA;IAAA,kCAAA;E/Emg5DV;;E+E1g5DM;IAOI,8BAAA;IAAA,iCAAA;E/Ewg5DV;;E+E/g5DM;IAOI,4BAAA;IAAA,+BAAA;E/E6g5DV;;E+Eph5DM;IAOI,8BAAA;IAAA,iCAAA;E/Ekh5DV;;E+Ezh5DM;IAOI,4BAAA;IAAA,+BAAA;E/Euh5DV;;E+E9h5DM;IAOI,+BAAA;E/E2h5DV;;E+Eli5DM;IAOI,8BAAA;E/E+h5DV;;E+Eti5DM;IAOI,4BAAA;E/Emi5DV;;E+E1i5DM;IAOI,8BAAA;E/Eui5DV;;E+E9i5DM;IAOI,4BAAA;E/E2i5DV;;E+Elj5DM;IAOI,iCAAA;E/E+i5DV;;E+Etj5DM;IAOI,gCAAA;E/Emj5DV;;E+E1j5DM;IAOI,8BAAA;E/Euj5DV;;E+E9j5DM;IAOI,gCAAA;E/E2j5DV;;E+Elk5DM;IAOI,8BAAA;E/E+j5DV;;E+Etk5DM;IAOI,kCAAA;E/Emk5DV;;E+E1k5DM;IAOI,iCAAA;E/Euk5DV;;E+E9k5DM;IAOI,+BAAA;E/E2k5DV;;E+Ell5DM;IAOI,iCAAA;E/E+k5DV;;E+Etl5DM;IAOI,+BAAA;E/Eml5DV;;E+E1l5DM;IAOI,gCAAA;E/Eul5DV;;E+E9l5DM;IAOI,+BAAA;E/E2l5DV;;E+Elm5DM;IAOI,6BAAA;E/E+l5DV;;E+Etm5DM;IAOI,+BAAA;E/Emm5DV;;E+E1m5DM;IAOI,6BAAA;E/Eum5DV;;E+E9m5DM;IAOI,qBAAA;E/E2m5DV;;E+Eln5DM;IAOI,2BAAA;E/E+m5DV;;E+Etn5DM;IAOI,0BAAA;E/Emn5DV;;E+E1n5DM;IAOI,wBAAA;E/Eun5DV;;E+E9n5DM;IAOI,0BAAA;E/E2n5DV;;E+Elo5DM;IAOI,wBAAA;E/E+n5DV;;E+Eto5DM;IAOI,2BAAA;IAAA,0BAAA;E/Eoo5DV;;E+E3o5DM;IAOI,iCAAA;IAAA,gCAAA;E/Eyo5DV;;E+Ehp5DM;IAOI,gCAAA;IAAA,+BAAA;E/E8o5DV;;E+Erp5DM;IAOI,8BAAA;IAAA,6BAAA;E/Emp5DV;;E+E1p5DM;IAOI,gCAAA;IAAA,+BAAA;E/Ewp5DV;;E+E/p5DM;IAOI,8BAAA;IAAA,6BAAA;E/E6p5DV;;E+Epq5DM;IAOI,yBAAA;IAAA,4BAAA;E/Ekq5DV;;E+Ezq5DM;IAOI,+BAAA;IAAA,kCAAA;E/Euq5DV;;E+E9q5DM;IAOI,8BAAA;IAAA,iCAAA;E/E4q5DV;;E+Enr5DM;IAOI,4BAAA;IAAA,+BAAA;E/Eir5DV;;E+Exr5DM;IAOI,8BAAA;IAAA,iCAAA;E/Esr5DV;;E+E7r5DM;IAOI,4BAAA;IAAA,+BAAA;E/E2r5DV;;E+Els5DM;IAOI,yBAAA;E/E+r5DV;;E+Ets5DM;IAOI,+BAAA;E/Ems5DV;;E+E1s5DM;IAOI,8BAAA;E/Eus5DV;;E+E9s5DM;IAOI,4BAAA;E/E2s5DV;;E+Elt5DM;IAOI,8BAAA;E/E+s5DV;;E+Ett5DM;IAOI,4BAAA;E/Emt5DV;;E+E1t5DM;IAOI,2BAAA;E/Eut5DV;;E+E9t5DM;IAOI,iCAAA;E/E2t5DV;;E+Elu5DM;IAOI,gCAAA;E/E+t5DV;;E+Etu5DM;IAOI,8BAAA;E/Emu5DV;;E+E1u5DM;IAOI,gCAAA;E/Euu5DV;;E+E9u5DM;IAOI,8BAAA;E/E2u5DV;;E+Elv5DM;IAOI,4BAAA;E/E+u5DV;;E+Etv5DM;IAOI,kCAAA;E/Emv5DV;;E+E1v5DM;IAOI,iCAAA;E/Euv5DV;;E+E9v5DM;IAOI,+BAAA;E/E2v5DV;;E+Elw5DM;IAOI,iCAAA;E/E+v5DV;;E+Etw5DM;IAOI,+BAAA;E/Emw5DV;;E+E1w5DM;IAOI,0BAAA;E/Euw5DV;;E+E9w5DM;IAOI,gCAAA;E/E2w5DV;;E+Elx5DM;IAOI,+BAAA;E/E+w5DV;;E+Etx5DM;IAOI,6BAAA;E/Emx5DV;;E+E1x5DM;IAOI,+BAAA;E/Eux5DV;;E+E9x5DM;IAOI,6BAAA;E/E2x5DV;;E+Ely5DM;IAOI,iBAAA;E/E+x5DV;;E+Ety5DM;IAOI,uBAAA;E/Emy5DV;;E+E1y5DM;IAOI,sBAAA;E/Euy5DV;;E+E9y5DM;IAOI,oBAAA;E/E2y5DV;;E+Elz5DM;IAOI,sBAAA;E/E+y5DV;;E+Etz5DM;IAOI,oBAAA;E/Emz5DV;;E+E1z5DM;IAOI,qBAAA;E/Euz5DV;;E+E9z5DM;IAOI,2BAAA;E/E2z5DV;;E+El05DM;IAOI,0BAAA;E/E+z5DV;;E+Et05DM;IAOI,wBAAA;E/Em05DV;;E+E105DM;IAOI,0BAAA;E/Eu05DV;;E+E905DM;IAOI,wBAAA;E/E205DV;;E+El15DM;IAOI,wBAAA;E/E+05DV;;E+Et15DM;IAOI,8BAAA;E/Em15DV;;E+E115DM;IAOI,6BAAA;E/Eu15DV;;E+E915DM;IAOI,2BAAA;E/E215DV;;E+El25DM;IAOI,6BAAA;E/E+15DV;;E+Et25DM;IAOI,2BAAA;E/Em25DV;;E+E125DM;IAOI,2BAAA;E/Eu25DV;;E+E925DM;IAOI,4BAAA;E/E225DV;;E+El35DM;IAOI,6BAAA;E/E+25DV;;E+Et35DM;IAOI,uBAAA;E/Em35DV;;E+E135DM;IAOI,0BAAA;E/Eu35DV;;E+E935DM;IAOI,uBAAA;E/E235DV;AACF;AqBt45DI;E0DGI;IAOI,sBAAA;E/Eg45DV;;E+Ev45DM;IAOI,uBAAA;E/Eo45DV;;E+E345DM;IAOI,sBAAA;E/Ew45DV;;E+E/45DM;IAOI,8BAAA;E/E445DV;;E+En55DM;IAOI,4BAAA;E/Eg55DV;;E+Ev55DM;IAOI,2BAAA;E/Eo55DV;;E+E355DM;IAOI,iCAAA;E/Ew55DV;;E+E/55DM;IAOI,2BAAA;E/E455DV;;E+En65DM;IAOI,0BAAA;E/Eg65DV;;E+Ev65DM;IAOI,gCAAA;E/Eo65DV;;E+E365DM;IAOI,yBAAA;E/Ew65DV;;E+E/65DM;IAOI,wBAAA;E/E465DV;;E+En75DM;IAOI,+BAAA;E/Eg75DV;;E+Ev75DM;IAOI,yBAAA;E/Eo75DV;;E+E375DM;IAOI,6BAAA;E/Ew75DV;;E+E/75DM;IAOI,8BAAA;E/E475DV;;E+En85DM;IAOI,wBAAA;E/Eg85DV;;E+Ev85DM;IAOI,+BAAA;E/Eo85DV;;E+E385DM;IAOI,wBAAA;E/Ew85DV;;E+E/85DM;IAOI,yBAAA;E/E485DV;;E+En95DM;IAOI,8BAAA;E/Eg95DV;;E+Ev95DM;IAOI,iCAAA;E/Eo95DV;;E+E395DM;IAOI,sCAAA;E/Ew95DV;;E+E/95DM;IAOI,yCAAA;E/E495DV;;E+En+5DM;IAOI,uBAAA;E/Eg+5DV;;E+Ev+5DM;IAOI,uBAAA;E/Eo+5DV;;E+E3+5DM;IAOI,yBAAA;E/Ew+5DV;;E+E/+5DM;IAOI,yBAAA;E/E4+5DV;;E+En/5DM;IAOI,0BAAA;E/Eg/5DV;;E+Ev/5DM;IAOI,4BAAA;E/Eo/5DV;;E+E3/5DM;IAOI,kCAAA;E/Ew/5DV;;E+E//5DM;IAOI,sCAAA;E/E4/5DV;;E+Eng6DM;IAOI,oCAAA;E/Egg6DV;;E+Evg6DM;IAOI,kCAAA;E/Eog6DV;;E+E3g6DM;IAOI,yCAAA;E/Ewg6DV;;E+E/g6DM;IAOI,wCAAA;E/E4g6DV;;E+Enh6DM;IAOI,wCAAA;E/Egh6DV;;E+Evh6DM;IAOI,kCAAA;E/Eoh6DV;;E+E3h6DM;IAOI,gCAAA;E/Ewh6DV;;E+E/h6DM;IAOI,8BAAA;E/E4h6DV;;E+Eni6DM;IAOI,gCAAA;E/Egi6DV;;E+Evi6DM;IAOI,+BAAA;E/Eoi6DV;;E+E3i6DM;IAOI,oCAAA;E/Ewi6DV;;E+E/i6DM;IAOI,kCAAA;E/E4i6DV;;E+Enj6DM;IAOI,gCAAA;E/Egj6DV;;E+Evj6DM;IAOI,uCAAA;E/Eoj6DV;;E+E3j6DM;IAOI,sCAAA;E/Ewj6DV;;E+E/j6DM;IAOI,iCAAA;E/E4j6DV;;E+Enk6DM;IAOI,2BAAA;E/Egk6DV;;E+Evk6DM;IAOI,iCAAA;E/Eok6DV;;E+E3k6DM;IAOI,+BAAA;E/Ewk6DV;;E+E/k6DM;IAOI,6BAAA;E/E4k6DV;;E+Enl6DM;IAOI,+BAAA;E/Egl6DV;;E+Evl6DM;IAOI,8BAAA;E/Eol6DV;;E+E3l6DM;IAOI,oBAAA;E/Ewl6DV;;E+E/l6DM;IAOI,mBAAA;E/E4l6DV;;E+Enm6DM;IAOI,mBAAA;E/Egm6DV;;E+Evm6DM;IAOI,mBAAA;E/Eom6DV;;E+E3m6DM;IAOI,mBAAA;E/Ewm6DV;;E+E/m6DM;IAOI,mBAAA;E/E4m6DV;;E+Enn6DM;IAOI,mBAAA;E/Egn6DV;;E+Evn6DM;IAOI,mBAAA;E/Eon6DV;;E+E3n6DM;IAOI,oBAAA;E/Ewn6DV;;E+E/n6DM;IAOI,0BAAA;E/E4n6DV;;E+Eno6DM;IAOI,yBAAA;E/Ego6DV;;E+Evo6DM;IAOI,uBAAA;E/Eoo6DV;;E+E3o6DM;IAOI,yBAAA;E/Ewo6DV;;E+E/o6DM;IAOI,uBAAA;E/E4o6DV;;E+Enp6DM;IAOI,uBAAA;E/Egp6DV;;E+Evp6DM;IAOI,0BAAA;IAAA,yBAAA;E/Eqp6DV;;E+E5p6DM;IAOI,gCAAA;IAAA,+BAAA;E/E0p6DV;;E+Ejq6DM;IAOI,+BAAA;IAAA,8BAAA;E/E+p6DV;;E+Etq6DM;IAOI,6BAAA;IAAA,4BAAA;E/Eoq6DV;;E+E3q6DM;IAOI,+BAAA;IAAA,8BAAA;E/Eyq6DV;;E+Ehr6DM;IAOI,6BAAA;IAAA,4BAAA;E/E8q6DV;;E+Err6DM;IAOI,6BAAA;IAAA,4BAAA;E/Emr6DV;;E+E1r6DM;IAOI,wBAAA;IAAA,2BAAA;E/Ewr6DV;;E+E/r6DM;IAOI,8BAAA;IAAA,iCAAA;E/E6r6DV;;E+Eps6DM;IAOI,6BAAA;IAAA,gCAAA;E/Eks6DV;;E+Ezs6DM;IAOI,2BAAA;IAAA,8BAAA;E/Eus6DV;;E+E9s6DM;IAOI,6BAAA;IAAA,gCAAA;E/E4s6DV;;E+Ent6DM;IAOI,2BAAA;IAAA,8BAAA;E/Eit6DV;;E+Ext6DM;IAOI,2BAAA;IAAA,8BAAA;E/Est6DV;;E+E7t6DM;IAOI,wBAAA;E/E0t6DV;;E+Eju6DM;IAOI,8BAAA;E/E8t6DV;;E+Eru6DM;IAOI,6BAAA;E/Eku6DV;;E+Ezu6DM;IAOI,2BAAA;E/Esu6DV;;E+E7u6DM;IAOI,6BAAA;E/E0u6DV;;E+Ejv6DM;IAOI,2BAAA;E/E8u6DV;;E+Erv6DM;IAOI,2BAAA;E/Ekv6DV;;E+Ezv6DM;IAOI,0BAAA;E/Esv6DV;;E+E7v6DM;IAOI,gCAAA;E/E0v6DV;;E+Ejw6DM;IAOI,+BAAA;E/E8v6DV;;E+Erw6DM;IAOI,6BAAA;E/Ekw6DV;;E+Ezw6DM;IAOI,+BAAA;E/Esw6DV;;E+E7w6DM;IAOI,6BAAA;E/E0w6DV;;E+Ejx6DM;IAOI,6BAAA;E/E8w6DV;;E+Erx6DM;IAOI,2BAAA;E/Ekx6DV;;E+Ezx6DM;IAOI,iCAAA;E/Esx6DV;;E+E7x6DM;IAOI,gCAAA;E/E0x6DV;;E+Ejy6DM;IAOI,8BAAA;E/E8x6DV;;E+Ery6DM;IAOI,gCAAA;E/Eky6DV;;E+Ezy6DM;IAOI,8BAAA;E/Esy6DV;;E+E7y6DM;IAOI,8BAAA;E/E0y6DV;;E+Ejz6DM;IAOI,yBAAA;E/E8y6DV;;E+Erz6DM;IAOI,+BAAA;E/Ekz6DV;;E+Ezz6DM;IAOI,8BAAA;E/Esz6DV;;E+E7z6DM;IAOI,4BAAA;E/E0z6DV;;E+Ej06DM;IAOI,8BAAA;E/E8z6DV;;E+Er06DM;IAOI,4BAAA;E/Ek06DV;;E+Ez06DM;IAOI,4BAAA;E/Es06DV;;E+E706DM;IAOI,2BAAA;E/E006DV;;E+Ej16DM;IAOI,0BAAA;E/E806DV;;E+Er16DM;IAOI,wBAAA;E/Ek16DV;;E+Ez16DM;IAOI,0BAAA;E/Es16DV;;E+E716DM;IAOI,wBAAA;E/E016DV;;E+Ej26DM;IAOI,iCAAA;IAAA,gCAAA;E/E+16DV;;E+Et26DM;IAOI,gCAAA;IAAA,+BAAA;E/Eo26DV;;E+E326DM;IAOI,8BAAA;IAAA,6BAAA;E/Ey26DV;;E+Eh36DM;IAOI,gCAAA;IAAA,+BAAA;E/E826DV;;E+Er36DM;IAOI,8BAAA;IAAA,6BAAA;E/Em36DV;;E+E136DM;IAOI,+BAAA;IAAA,kCAAA;E/Ew36DV;;E+E/36DM;IAOI,8BAAA;IAAA,iCAAA;E/E636DV;;E+Ep46DM;IAOI,4BAAA;IAAA,+BAAA;E/Ek46DV;;E+Ez46DM;IAOI,8BAAA;IAAA,iCAAA;E/Eu46DV;;E+E946DM;IAOI,4BAAA;IAAA,+BAAA;E/E446DV;;E+En56DM;IAOI,+BAAA;E/Eg56DV;;E+Ev56DM;IAOI,8BAAA;E/Eo56DV;;E+E356DM;IAOI,4BAAA;E/Ew56DV;;E+E/56DM;IAOI,8BAAA;E/E456DV;;E+En66DM;IAOI,4BAAA;E/Eg66DV;;E+Ev66DM;IAOI,iCAAA;E/Eo66DV;;E+E366DM;IAOI,gCAAA;E/Ew66DV;;E+E/66DM;IAOI,8BAAA;E/E466DV;;E+En76DM;IAOI,gCAAA;E/Eg76DV;;E+Ev76DM;IAOI,8BAAA;E/Eo76DV;;E+E376DM;IAOI,kCAAA;E/Ew76DV;;E+E/76DM;IAOI,iCAAA;E/E476DV;;E+En86DM;IAOI,+BAAA;E/Eg86DV;;E+Ev86DM;IAOI,iCAAA;E/Eo86DV;;E+E386DM;IAOI,+BAAA;E/Ew86DV;;E+E/86DM;IAOI,gCAAA;E/E486DV;;E+En96DM;IAOI,+BAAA;E/Eg96DV;;E+Ev96DM;IAOI,6BAAA;E/Eo96DV;;E+E396DM;IAOI,+BAAA;E/Ew96DV;;E+E/96DM;IAOI,6BAAA;E/E496DV;;E+En+6DM;IAOI,qBAAA;E/Eg+6DV;;E+Ev+6DM;IAOI,2BAAA;E/Eo+6DV;;E+E3+6DM;IAOI,0BAAA;E/Ew+6DV;;E+E/+6DM;IAOI,wBAAA;E/E4+6DV;;E+En/6DM;IAOI,0BAAA;E/Eg/6DV;;E+Ev/6DM;IAOI,wBAAA;E/Eo/6DV;;E+E3/6DM;IAOI,2BAAA;IAAA,0BAAA;E/Ey/6DV;;E+Ehg7DM;IAOI,iCAAA;IAAA,gCAAA;E/E8/6DV;;E+Erg7DM;IAOI,gCAAA;IAAA,+BAAA;E/Emg7DV;;E+E1g7DM;IAOI,8BAAA;IAAA,6BAAA;E/Ewg7DV;;E+E/g7DM;IAOI,gCAAA;IAAA,+BAAA;E/E6g7DV;;E+Eph7DM;IAOI,8BAAA;IAAA,6BAAA;E/Ekh7DV;;E+Ezh7DM;IAOI,yBAAA;IAAA,4BAAA;E/Euh7DV;;E+E9h7DM;IAOI,+BAAA;IAAA,kCAAA;E/E4h7DV;;E+Eni7DM;IAOI,8BAAA;IAAA,iCAAA;E/Eii7DV;;E+Exi7DM;IAOI,4BAAA;IAAA,+BAAA;E/Esi7DV;;E+E7i7DM;IAOI,8BAAA;IAAA,iCAAA;E/E2i7DV;;E+Elj7DM;IAOI,4BAAA;IAAA,+BAAA;E/Egj7DV;;E+Evj7DM;IAOI,yBAAA;E/Eoj7DV;;E+E3j7DM;IAOI,+BAAA;E/Ewj7DV;;E+E/j7DM;IAOI,8BAAA;E/E4j7DV;;E+Enk7DM;IAOI,4BAAA;E/Egk7DV;;E+Evk7DM;IAOI,8BAAA;E/Eok7DV;;E+E3k7DM;IAOI,4BAAA;E/Ewk7DV;;E+E/k7DM;IAOI,2BAAA;E/E4k7DV;;E+Enl7DM;IAOI,iCAAA;E/Egl7DV;;E+Evl7DM;IAOI,gCAAA;E/Eol7DV;;E+E3l7DM;IAOI,8BAAA;E/Ewl7DV;;E+E/l7DM;IAOI,gCAAA;E/E4l7DV;;E+Enm7DM;IAOI,8BAAA;E/Egm7DV;;E+Evm7DM;IAOI,4BAAA;E/Eom7DV;;E+E3m7DM;IAOI,kCAAA;E/Ewm7DV;;E+E/m7DM;IAOI,iCAAA;E/E4m7DV;;E+Enn7DM;IAOI,+BAAA;E/Egn7DV;;E+Evn7DM;IAOI,iCAAA;E/Eon7DV;;E+E3n7DM;IAOI,+BAAA;E/Ewn7DV;;E+E/n7DM;IAOI,0BAAA;E/E4n7DV;;E+Eno7DM;IAOI,gCAAA;E/Ego7DV;;E+Evo7DM;IAOI,+BAAA;E/Eoo7DV;;E+E3o7DM;IAOI,6BAAA;E/Ewo7DV;;E+E/o7DM;IAOI,+BAAA;E/E4o7DV;;E+Enp7DM;IAOI,6BAAA;E/Egp7DV;;E+Evp7DM;IAOI,iBAAA;E/Eop7DV;;E+E3p7DM;IAOI,uBAAA;E/Ewp7DV;;E+E/p7DM;IAOI,sBAAA;E/E4p7DV;;E+Enq7DM;IAOI,oBAAA;E/Egq7DV;;E+Evq7DM;IAOI,sBAAA;E/Eoq7DV;;E+E3q7DM;IAOI,oBAAA;E/Ewq7DV;;E+E/q7DM;IAOI,qBAAA;E/E4q7DV;;E+Enr7DM;IAOI,2BAAA;E/Egr7DV;;E+Evr7DM;IAOI,0BAAA;E/Eor7DV;;E+E3r7DM;IAOI,wBAAA;E/Ewr7DV;;E+E/r7DM;IAOI,0BAAA;E/E4r7DV;;E+Ens7DM;IAOI,wBAAA;E/Egs7DV;;E+Evs7DM;IAOI,wBAAA;E/Eos7DV;;E+E3s7DM;IAOI,8BAAA;E/Ews7DV;;E+E/s7DM;IAOI,6BAAA;E/E4s7DV;;E+Ent7DM;IAOI,2BAAA;E/Egt7DV;;E+Evt7DM;IAOI,6BAAA;E/Eot7DV;;E+E3t7DM;IAOI,2BAAA;E/Ewt7DV;;E+E/t7DM;IAOI,2BAAA;E/E4t7DV;;E+Enu7DM;IAOI,4BAAA;E/Egu7DV;;E+Evu7DM;IAOI,6BAAA;E/Eou7DV;;E+E3u7DM;IAOI,uBAAA;E/Ewu7DV;;E+E/u7DM;IAOI,0BAAA;E/E4u7DV;;E+Env7DM;IAOI,uBAAA;E/Egv7DV;AACF;AqB3v7DI;E0DGI;IAOI,sBAAA;E/Eqv7DV;;E+E5v7DM;IAOI,uBAAA;E/Eyv7DV;;E+Ehw7DM;IAOI,sBAAA;E/E6v7DV;;E+Epw7DM;IAOI,8BAAA;E/Eiw7DV;;E+Exw7DM;IAOI,4BAAA;E/Eqw7DV;;E+E5w7DM;IAOI,2BAAA;E/Eyw7DV;;E+Ehx7DM;IAOI,iCAAA;E/E6w7DV;;E+Epx7DM;IAOI,2BAAA;E/Eix7DV;;E+Exx7DM;IAOI,0BAAA;E/Eqx7DV;;E+E5x7DM;IAOI,gCAAA;E/Eyx7DV;;E+Ehy7DM;IAOI,yBAAA;E/E6x7DV;;E+Epy7DM;IAOI,wBAAA;E/Eiy7DV;;E+Exy7DM;IAOI,+BAAA;E/Eqy7DV;;E+E5y7DM;IAOI,yBAAA;E/Eyy7DV;;E+Ehz7DM;IAOI,6BAAA;E/E6y7DV;;E+Epz7DM;IAOI,8BAAA;E/Eiz7DV;;E+Exz7DM;IAOI,wBAAA;E/Eqz7DV;;E+E5z7DM;IAOI,+BAAA;E/Eyz7DV;;E+Eh07DM;IAOI,wBAAA;E/E6z7DV;;E+Ep07DM;IAOI,yBAAA;E/Ei07DV;;E+Ex07DM;IAOI,8BAAA;E/Eq07DV;;E+E507DM;IAOI,iCAAA;E/Ey07DV;;E+Eh17DM;IAOI,sCAAA;E/E607DV;;E+Ep17DM;IAOI,yCAAA;E/Ei17DV;;E+Ex17DM;IAOI,uBAAA;E/Eq17DV;;E+E517DM;IAOI,uBAAA;E/Ey17DV;;E+Eh27DM;IAOI,yBAAA;E/E617DV;;E+Ep27DM;IAOI,yBAAA;E/Ei27DV;;E+Ex27DM;IAOI,0BAAA;E/Eq27DV;;E+E527DM;IAOI,4BAAA;E/Ey27DV;;E+Eh37DM;IAOI,kCAAA;E/E627DV;;E+Ep37DM;IAOI,sCAAA;E/Ei37DV;;E+Ex37DM;IAOI,oCAAA;E/Eq37DV;;E+E537DM;IAOI,kCAAA;E/Ey37DV;;E+Eh47DM;IAOI,yCAAA;E/E637DV;;E+Ep47DM;IAOI,wCAAA;E/Ei47DV;;E+Ex47DM;IAOI,wCAAA;E/Eq47DV;;E+E547DM;IAOI,kCAAA;E/Ey47DV;;E+Eh57DM;IAOI,gCAAA;E/E647DV;;E+Ep57DM;IAOI,8BAAA;E/Ei57DV;;E+Ex57DM;IAOI,gCAAA;E/Eq57DV;;E+E557DM;IAOI,+BAAA;E/Ey57DV;;E+Eh67DM;IAOI,oCAAA;E/E657DV;;E+Ep67DM;IAOI,kCAAA;E/Ei67DV;;E+Ex67DM;IAOI,gCAAA;E/Eq67DV;;E+E567DM;IAOI,uCAAA;E/Ey67DV;;E+Eh77DM;IAOI,sCAAA;E/E667DV;;E+Ep77DM;IAOI,iCAAA;E/Ei77DV;;E+Ex77DM;IAOI,2BAAA;E/Eq77DV;;E+E577DM;IAOI,iCAAA;E/Ey77DV;;E+Eh87DM;IAOI,+BAAA;E/E677DV;;E+Ep87DM;IAOI,6BAAA;E/Ei87DV;;E+Ex87DM;IAOI,+BAAA;E/Eq87DV;;E+E587DM;IAOI,8BAAA;E/Ey87DV;;E+Eh97DM;IAOI,oBAAA;E/E687DV;;E+Ep97DM;IAOI,mBAAA;E/Ei97DV;;E+Ex97DM;IAOI,mBAAA;E/Eq97DV;;E+E597DM;IAOI,mBAAA;E/Ey97DV;;E+Eh+7DM;IAOI,mBAAA;E/E697DV;;E+Ep+7DM;IAOI,mBAAA;E/Ei+7DV;;E+Ex+7DM;IAOI,mBAAA;E/Eq+7DV;;E+E5+7DM;IAOI,mBAAA;E/Ey+7DV;;E+Eh/7DM;IAOI,oBAAA;E/E6+7DV;;E+Ep/7DM;IAOI,0BAAA;E/Ei/7DV;;E+Ex/7DM;IAOI,yBAAA;E/Eq/7DV;;E+E5/7DM;IAOI,uBAAA;E/Ey/7DV;;E+Ehg8DM;IAOI,yBAAA;E/E6/7DV;;E+Epg8DM;IAOI,uBAAA;E/Eig8DV;;E+Exg8DM;IAOI,uBAAA;E/Eqg8DV;;E+E5g8DM;IAOI,0BAAA;IAAA,yBAAA;E/E0g8DV;;E+Ejh8DM;IAOI,gCAAA;IAAA,+BAAA;E/E+g8DV;;E+Eth8DM;IAOI,+BAAA;IAAA,8BAAA;E/Eoh8DV;;E+E3h8DM;IAOI,6BAAA;IAAA,4BAAA;E/Eyh8DV;;E+Ehi8DM;IAOI,+BAAA;IAAA,8BAAA;E/E8h8DV;;E+Eri8DM;IAOI,6BAAA;IAAA,4BAAA;E/Emi8DV;;E+E1i8DM;IAOI,6BAAA;IAAA,4BAAA;E/Ewi8DV;;E+E/i8DM;IAOI,wBAAA;IAAA,2BAAA;E/E6i8DV;;E+Epj8DM;IAOI,8BAAA;IAAA,iCAAA;E/Ekj8DV;;E+Ezj8DM;IAOI,6BAAA;IAAA,gCAAA;E/Euj8DV;;E+E9j8DM;IAOI,2BAAA;IAAA,8BAAA;E/E4j8DV;;E+Enk8DM;IAOI,6BAAA;IAAA,gCAAA;E/Eik8DV;;E+Exk8DM;IAOI,2BAAA;IAAA,8BAAA;E/Esk8DV;;E+E7k8DM;IAOI,2BAAA;IAAA,8BAAA;E/E2k8DV;;E+Ell8DM;IAOI,wBAAA;E/E+k8DV;;E+Etl8DM;IAOI,8BAAA;E/Eml8DV;;E+E1l8DM;IAOI,6BAAA;E/Eul8DV;;E+E9l8DM;IAOI,2BAAA;E/E2l8DV;;E+Elm8DM;IAOI,6BAAA;E/E+l8DV;;E+Etm8DM;IAOI,2BAAA;E/Emm8DV;;E+E1m8DM;IAOI,2BAAA;E/Eum8DV;;E+E9m8DM;IAOI,0BAAA;E/E2m8DV;;E+Eln8DM;IAOI,gCAAA;E/E+m8DV;;E+Etn8DM;IAOI,+BAAA;E/Emn8DV;;E+E1n8DM;IAOI,6BAAA;E/Eun8DV;;E+E9n8DM;IAOI,+BAAA;E/E2n8DV;;E+Elo8DM;IAOI,6BAAA;E/E+n8DV;;E+Eto8DM;IAOI,6BAAA;E/Emo8DV;;E+E1o8DM;IAOI,2BAAA;E/Euo8DV;;E+E9o8DM;IAOI,iCAAA;E/E2o8DV;;E+Elp8DM;IAOI,gCAAA;E/E+o8DV;;E+Etp8DM;IAOI,8BAAA;E/Emp8DV;;E+E1p8DM;IAOI,gCAAA;E/Eup8DV;;E+E9p8DM;IAOI,8BAAA;E/E2p8DV;;E+Elq8DM;IAOI,8BAAA;E/E+p8DV;;E+Etq8DM;IAOI,yBAAA;E/Emq8DV;;E+E1q8DM;IAOI,+BAAA;E/Euq8DV;;E+E9q8DM;IAOI,8BAAA;E/E2q8DV;;E+Elr8DM;IAOI,4BAAA;E/E+q8DV;;E+Etr8DM;IAOI,8BAAA;E/Emr8DV;;E+E1r8DM;IAOI,4BAAA;E/Eur8DV;;E+E9r8DM;IAOI,4BAAA;E/E2r8DV;;E+Els8DM;IAOI,2BAAA;E/E+r8DV;;E+Ets8DM;IAOI,0BAAA;E/Ems8DV;;E+E1s8DM;IAOI,wBAAA;E/Eus8DV;;E+E9s8DM;IAOI,0BAAA;E/E2s8DV;;E+Elt8DM;IAOI,wBAAA;E/E+s8DV;;E+Ett8DM;IAOI,iCAAA;IAAA,gCAAA;E/Eot8DV;;E+E3t8DM;IAOI,gCAAA;IAAA,+BAAA;E/Eyt8DV;;E+Ehu8DM;IAOI,8BAAA;IAAA,6BAAA;E/E8t8DV;;E+Eru8DM;IAOI,gCAAA;IAAA,+BAAA;E/Emu8DV;;E+E1u8DM;IAOI,8BAAA;IAAA,6BAAA;E/Ewu8DV;;E+E/u8DM;IAOI,+BAAA;IAAA,kCAAA;E/E6u8DV;;E+Epv8DM;IAOI,8BAAA;IAAA,iCAAA;E/Ekv8DV;;E+Ezv8DM;IAOI,4BAAA;IAAA,+BAAA;E/Euv8DV;;E+E9v8DM;IAOI,8BAAA;IAAA,iCAAA;E/E4v8DV;;E+Enw8DM;IAOI,4BAAA;IAAA,+BAAA;E/Eiw8DV;;E+Exw8DM;IAOI,+BAAA;E/Eqw8DV;;E+E5w8DM;IAOI,8BAAA;E/Eyw8DV;;E+Ehx8DM;IAOI,4BAAA;E/E6w8DV;;E+Epx8DM;IAOI,8BAAA;E/Eix8DV;;E+Exx8DM;IAOI,4BAAA;E/Eqx8DV;;E+E5x8DM;IAOI,iCAAA;E/Eyx8DV;;E+Ehy8DM;IAOI,gCAAA;E/E6x8DV;;E+Epy8DM;IAOI,8BAAA;E/Eiy8DV;;E+Exy8DM;IAOI,gCAAA;E/Eqy8DV;;E+E5y8DM;IAOI,8BAAA;E/Eyy8DV;;E+Ehz8DM;IAOI,kCAAA;E/E6y8DV;;E+Epz8DM;IAOI,iCAAA;E/Eiz8DV;;E+Exz8DM;IAOI,+BAAA;E/Eqz8DV;;E+E5z8DM;IAOI,iCAAA;E/Eyz8DV;;E+Eh08DM;IAOI,+BAAA;E/E6z8DV;;E+Ep08DM;IAOI,gCAAA;E/Ei08DV;;E+Ex08DM;IAOI,+BAAA;E/Eq08DV;;E+E508DM;IAOI,6BAAA;E/Ey08DV;;E+Eh18DM;IAOI,+BAAA;E/E608DV;;E+Ep18DM;IAOI,6BAAA;E/Ei18DV;;E+Ex18DM;IAOI,qBAAA;E/Eq18DV;;E+E518DM;IAOI,2BAAA;E/Ey18DV;;E+Eh28DM;IAOI,0BAAA;E/E618DV;;E+Ep28DM;IAOI,wBAAA;E/Ei28DV;;E+Ex28DM;IAOI,0BAAA;E/Eq28DV;;E+E528DM;IAOI,wBAAA;E/Ey28DV;;E+Eh38DM;IAOI,2BAAA;IAAA,0BAAA;E/E828DV;;E+Er38DM;IAOI,iCAAA;IAAA,gCAAA;E/Em38DV;;E+E138DM;IAOI,gCAAA;IAAA,+BAAA;E/Ew38DV;;E+E/38DM;IAOI,8BAAA;IAAA,6BAAA;E/E638DV;;E+Ep48DM;IAOI,gCAAA;IAAA,+BAAA;E/Ek48DV;;E+Ez48DM;IAOI,8BAAA;IAAA,6BAAA;E/Eu48DV;;E+E948DM;IAOI,yBAAA;IAAA,4BAAA;E/E448DV;;E+En58DM;IAOI,+BAAA;IAAA,kCAAA;E/Ei58DV;;E+Ex58DM;IAOI,8BAAA;IAAA,iCAAA;E/Es58DV;;E+E758DM;IAOI,4BAAA;IAAA,+BAAA;E/E258DV;;E+El68DM;IAOI,8BAAA;IAAA,iCAAA;E/Eg68DV;;E+Ev68DM;IAOI,4BAAA;IAAA,+BAAA;E/Eq68DV;;E+E568DM;IAOI,yBAAA;E/Ey68DV;;E+Eh78DM;IAOI,+BAAA;E/E668DV;;E+Ep78DM;IAOI,8BAAA;E/Ei78DV;;E+Ex78DM;IAOI,4BAAA;E/Eq78DV;;E+E578DM;IAOI,8BAAA;E/Ey78DV;;E+Eh88DM;IAOI,4BAAA;E/E678DV;;E+Ep88DM;IAOI,2BAAA;E/Ei88DV;;E+Ex88DM;IAOI,iCAAA;E/Eq88DV;;E+E588DM;IAOI,gCAAA;E/Ey88DV;;E+Eh98DM;IAOI,8BAAA;E/E688DV;;E+Ep98DM;IAOI,gCAAA;E/Ei98DV;;E+Ex98DM;IAOI,8BAAA;E/Eq98DV;;E+E598DM;IAOI,4BAAA;E/Ey98DV;;E+Eh+8DM;IAOI,kCAAA;E/E698DV;;E+Ep+8DM;IAOI,iCAAA;E/Ei+8DV;;E+Ex+8DM;IAOI,+BAAA;E/Eq+8DV;;E+E5+8DM;IAOI,iCAAA;E/Ey+8DV;;E+Eh/8DM;IAOI,+BAAA;E/E6+8DV;;E+Ep/8DM;IAOI,0BAAA;E/Ei/8DV;;E+Ex/8DM;IAOI,gCAAA;E/Eq/8DV;;E+E5/8DM;IAOI,+BAAA;E/Ey/8DV;;E+Ehg9DM;IAOI,6BAAA;E/E6/8DV;;E+Epg9DM;IAOI,+BAAA;E/Eig9DV;;E+Exg9DM;IAOI,6BAAA;E/Eqg9DV;;E+E5g9DM;IAOI,iBAAA;E/Eyg9DV;;E+Ehh9DM;IAOI,uBAAA;E/E6g9DV;;E+Eph9DM;IAOI,sBAAA;E/Eih9DV;;E+Exh9DM;IAOI,oBAAA;E/Eqh9DV;;E+E5h9DM;IAOI,sBAAA;E/Eyh9DV;;E+Ehi9DM;IAOI,oBAAA;E/E6h9DV;;E+Epi9DM;IAOI,qBAAA;E/Eii9DV;;E+Exi9DM;IAOI,2BAAA;E/Eqi9DV;;E+E5i9DM;IAOI,0BAAA;E/Eyi9DV;;E+Ehj9DM;IAOI,wBAAA;E/E6i9DV;;E+Epj9DM;IAOI,0BAAA;E/Eij9DV;;E+Exj9DM;IAOI,wBAAA;E/Eqj9DV;;E+E5j9DM;IAOI,wBAAA;E/Eyj9DV;;E+Ehk9DM;IAOI,8BAAA;E/E6j9DV;;E+Epk9DM;IAOI,6BAAA;E/Eik9DV;;E+Exk9DM;IAOI,2BAAA;E/Eqk9DV;;E+E5k9DM;IAOI,6BAAA;E/Eyk9DV;;E+Ehl9DM;IAOI,2BAAA;E/E6k9DV;;E+Epl9DM;IAOI,2BAAA;E/Eil9DV;;E+Exl9DM;IAOI,4BAAA;E/Eql9DV;;E+E5l9DM;IAOI,6BAAA;E/Eyl9DV;;E+Ehm9DM;IAOI,uBAAA;E/E6l9DV;;E+Epm9DM;IAOI,0BAAA;E/Eim9DV;;E+Exm9DM;IAOI,uBAAA;E/Eqm9DV;AACF;AqBhn9DI;E0DGI;IAOI,sBAAA;E/E0m9DV;;E+Ejn9DM;IAOI,uBAAA;E/E8m9DV;;E+Ern9DM;IAOI,sBAAA;E/Ekn9DV;;E+Ezn9DM;IAOI,8BAAA;E/Esn9DV;;E+E7n9DM;IAOI,4BAAA;E/E0n9DV;;E+Ejo9DM;IAOI,2BAAA;E/E8n9DV;;E+Ero9DM;IAOI,iCAAA;E/Eko9DV;;E+Ezo9DM;IAOI,2BAAA;E/Eso9DV;;E+E7o9DM;IAOI,0BAAA;E/E0o9DV;;E+Ejp9DM;IAOI,gCAAA;E/E8o9DV;;E+Erp9DM;IAOI,yBAAA;E/Ekp9DV;;E+Ezp9DM;IAOI,wBAAA;E/Esp9DV;;E+E7p9DM;IAOI,+BAAA;E/E0p9DV;;E+Ejq9DM;IAOI,yBAAA;E/E8p9DV;;E+Erq9DM;IAOI,6BAAA;E/Ekq9DV;;E+Ezq9DM;IAOI,8BAAA;E/Esq9DV;;E+E7q9DM;IAOI,wBAAA;E/E0q9DV;;E+Ejr9DM;IAOI,+BAAA;E/E8q9DV;;E+Err9DM;IAOI,wBAAA;E/Ekr9DV;;E+Ezr9DM;IAOI,yBAAA;E/Esr9DV;;E+E7r9DM;IAOI,8BAAA;E/E0r9DV;;E+Ejs9DM;IAOI,iCAAA;E/E8r9DV;;E+Ers9DM;IAOI,sCAAA;E/Eks9DV;;E+Ezs9DM;IAOI,yCAAA;E/Ess9DV;;E+E7s9DM;IAOI,uBAAA;E/E0s9DV;;E+Ejt9DM;IAOI,uBAAA;E/E8s9DV;;E+Ert9DM;IAOI,yBAAA;E/Ekt9DV;;E+Ezt9DM;IAOI,yBAAA;E/Est9DV;;E+E7t9DM;IAOI,0BAAA;E/E0t9DV;;E+Eju9DM;IAOI,4BAAA;E/E8t9DV;;E+Eru9DM;IAOI,kCAAA;E/Eku9DV;;E+Ezu9DM;IAOI,sCAAA;E/Esu9DV;;E+E7u9DM;IAOI,oCAAA;E/E0u9DV;;E+Ejv9DM;IAOI,kCAAA;E/E8u9DV;;E+Erv9DM;IAOI,yCAAA;E/Ekv9DV;;E+Ezv9DM;IAOI,wCAAA;E/Esv9DV;;E+E7v9DM;IAOI,wCAAA;E/E0v9DV;;E+Ejw9DM;IAOI,kCAAA;E/E8v9DV;;E+Erw9DM;IAOI,gCAAA;E/Ekw9DV;;E+Ezw9DM;IAOI,8BAAA;E/Esw9DV;;E+E7w9DM;IAOI,gCAAA;E/E0w9DV;;E+Ejx9DM;IAOI,+BAAA;E/E8w9DV;;E+Erx9DM;IAOI,oCAAA;E/Ekx9DV;;E+Ezx9DM;IAOI,kCAAA;E/Esx9DV;;E+E7x9DM;IAOI,gCAAA;E/E0x9DV;;E+Ejy9DM;IAOI,uCAAA;E/E8x9DV;;E+Ery9DM;IAOI,sCAAA;E/Eky9DV;;E+Ezy9DM;IAOI,iCAAA;E/Esy9DV;;E+E7y9DM;IAOI,2BAAA;E/E0y9DV;;E+Ejz9DM;IAOI,iCAAA;E/E8y9DV;;E+Erz9DM;IAOI,+BAAA;E/Ekz9DV;;E+Ezz9DM;IAOI,6BAAA;E/Esz9DV;;E+E7z9DM;IAOI,+BAAA;E/E0z9DV;;E+Ej09DM;IAOI,8BAAA;E/E8z9DV;;E+Er09DM;IAOI,oBAAA;E/Ek09DV;;E+Ez09DM;IAOI,mBAAA;E/Es09DV;;E+E709DM;IAOI,mBAAA;E/E009DV;;E+Ej19DM;IAOI,mBAAA;E/E809DV;;E+Er19DM;IAOI,mBAAA;E/Ek19DV;;E+Ez19DM;IAOI,mBAAA;E/Es19DV;;E+E719DM;IAOI,mBAAA;E/E019DV;;E+Ej29DM;IAOI,mBAAA;E/E819DV;;E+Er29DM;IAOI,oBAAA;E/Ek29DV;;E+Ez29DM;IAOI,0BAAA;E/Es29DV;;E+E729DM;IAOI,yBAAA;E/E029DV;;E+Ej39DM;IAOI,uBAAA;E/E829DV;;E+Er39DM;IAOI,yBAAA;E/Ek39DV;;E+Ez39DM;IAOI,uBAAA;E/Es39DV;;E+E739DM;IAOI,uBAAA;E/E039DV;;E+Ej49DM;IAOI,0BAAA;IAAA,yBAAA;E/E+39DV;;E+Et49DM;IAOI,gCAAA;IAAA,+BAAA;E/Eo49DV;;E+E349DM;IAOI,+BAAA;IAAA,8BAAA;E/Ey49DV;;E+Eh59DM;IAOI,6BAAA;IAAA,4BAAA;E/E849DV;;E+Er59DM;IAOI,+BAAA;IAAA,8BAAA;E/Em59DV;;E+E159DM;IAOI,6BAAA;IAAA,4BAAA;E/Ew59DV;;E+E/59DM;IAOI,6BAAA;IAAA,4BAAA;E/E659DV;;E+Ep69DM;IAOI,wBAAA;IAAA,2BAAA;E/Ek69DV;;E+Ez69DM;IAOI,8BAAA;IAAA,iCAAA;E/Eu69DV;;E+E969DM;IAOI,6BAAA;IAAA,gCAAA;E/E469DV;;E+En79DM;IAOI,2BAAA;IAAA,8BAAA;E/Ei79DV;;E+Ex79DM;IAOI,6BAAA;IAAA,gCAAA;E/Es79DV;;E+E779DM;IAOI,2BAAA;IAAA,8BAAA;E/E279DV;;E+El89DM;IAOI,2BAAA;IAAA,8BAAA;E/Eg89DV;;E+Ev89DM;IAOI,wBAAA;E/Eo89DV;;E+E389DM;IAOI,8BAAA;E/Ew89DV;;E+E/89DM;IAOI,6BAAA;E/E489DV;;E+En99DM;IAOI,2BAAA;E/Eg99DV;;E+Ev99DM;IAOI,6BAAA;E/Eo99DV;;E+E399DM;IAOI,2BAAA;E/Ew99DV;;E+E/99DM;IAOI,2BAAA;E/E499DV;;E+En+9DM;IAOI,0BAAA;E/Eg+9DV;;E+Ev+9DM;IAOI,gCAAA;E/Eo+9DV;;E+E3+9DM;IAOI,+BAAA;E/Ew+9DV;;E+E/+9DM;IAOI,6BAAA;E/E4+9DV;;E+En/9DM;IAOI,+BAAA;E/Eg/9DV;;E+Ev/9DM;IAOI,6BAAA;E/Eo/9DV;;E+E3/9DM;IAOI,6BAAA;E/Ew/9DV;;E+E//9DM;IAOI,2BAAA;E/E4/9DV;;E+Eng+DM;IAOI,iCAAA;E/Egg+DV;;E+Evg+DM;IAOI,gCAAA;E/Eog+DV;;E+E3g+DM;IAOI,8BAAA;E/Ewg+DV;;E+E/g+DM;IAOI,gCAAA;E/E4g+DV;;E+Enh+DM;IAOI,8BAAA;E/Egh+DV;;E+Evh+DM;IAOI,8BAAA;E/Eoh+DV;;E+E3h+DM;IAOI,yBAAA;E/Ewh+DV;;E+E/h+DM;IAOI,+BAAA;E/E4h+DV;;E+Eni+DM;IAOI,8BAAA;E/Egi+DV;;E+Evi+DM;IAOI,4BAAA;E/Eoi+DV;;E+E3i+DM;IAOI,8BAAA;E/Ewi+DV;;E+E/i+DM;IAOI,4BAAA;E/E4i+DV;;E+Enj+DM;IAOI,4BAAA;E/Egj+DV;;E+Evj+DM;IAOI,2BAAA;E/Eoj+DV;;E+E3j+DM;IAOI,0BAAA;E/Ewj+DV;;E+E/j+DM;IAOI,wBAAA;E/E4j+DV;;E+Enk+DM;IAOI,0BAAA;E/Egk+DV;;E+Evk+DM;IAOI,wBAAA;E/Eok+DV;;E+E3k+DM;IAOI,iCAAA;IAAA,gCAAA;E/Eyk+DV;;E+Ehl+DM;IAOI,gCAAA;IAAA,+BAAA;E/E8k+DV;;E+Erl+DM;IAOI,8BAAA;IAAA,6BAAA;E/Eml+DV;;E+E1l+DM;IAOI,gCAAA;IAAA,+BAAA;E/Ewl+DV;;E+E/l+DM;IAOI,8BAAA;IAAA,6BAAA;E/E6l+DV;;E+Epm+DM;IAOI,+BAAA;IAAA,kCAAA;E/Ekm+DV;;E+Ezm+DM;IAOI,8BAAA;IAAA,iCAAA;E/Eum+DV;;E+E9m+DM;IAOI,4BAAA;IAAA,+BAAA;E/E4m+DV;;E+Enn+DM;IAOI,8BAAA;IAAA,iCAAA;E/Ein+DV;;E+Exn+DM;IAOI,4BAAA;IAAA,+BAAA;E/Esn+DV;;E+E7n+DM;IAOI,+BAAA;E/E0n+DV;;E+Ejo+DM;IAOI,8BAAA;E/E8n+DV;;E+Ero+DM;IAOI,4BAAA;E/Eko+DV;;E+Ezo+DM;IAOI,8BAAA;E/Eso+DV;;E+E7o+DM;IAOI,4BAAA;E/E0o+DV;;E+Ejp+DM;IAOI,iCAAA;E/E8o+DV;;E+Erp+DM;IAOI,gCAAA;E/Ekp+DV;;E+Ezp+DM;IAOI,8BAAA;E/Esp+DV;;E+E7p+DM;IAOI,gCAAA;E/E0p+DV;;E+Ejq+DM;IAOI,8BAAA;E/E8p+DV;;E+Erq+DM;IAOI,kCAAA;E/Ekq+DV;;E+Ezq+DM;IAOI,iCAAA;E/Esq+DV;;E+E7q+DM;IAOI,+BAAA;E/E0q+DV;;E+Ejr+DM;IAOI,iCAAA;E/E8q+DV;;E+Err+DM;IAOI,+BAAA;E/Ekr+DV;;E+Ezr+DM;IAOI,gCAAA;E/Esr+DV;;E+E7r+DM;IAOI,+BAAA;E/E0r+DV;;E+Ejs+DM;IAOI,6BAAA;E/E8r+DV;;E+Ers+DM;IAOI,+BAAA;E/Eks+DV;;E+Ezs+DM;IAOI,6BAAA;E/Ess+DV;;E+E7s+DM;IAOI,qBAAA;E/E0s+DV;;E+Ejt+DM;IAOI,2BAAA;E/E8s+DV;;E+Ert+DM;IAOI,0BAAA;E/Ekt+DV;;E+Ezt+DM;IAOI,wBAAA;E/Est+DV;;E+E7t+DM;IAOI,0BAAA;E/E0t+DV;;E+Eju+DM;IAOI,wBAAA;E/E8t+DV;;E+Eru+DM;IAOI,2BAAA;IAAA,0BAAA;E/Emu+DV;;E+E1u+DM;IAOI,iCAAA;IAAA,gCAAA;E/Ewu+DV;;E+E/u+DM;IAOI,gCAAA;IAAA,+BAAA;E/E6u+DV;;E+Epv+DM;IAOI,8BAAA;IAAA,6BAAA;E/Ekv+DV;;E+Ezv+DM;IAOI,gCAAA;IAAA,+BAAA;E/Euv+DV;;E+E9v+DM;IAOI,8BAAA;IAAA,6BAAA;E/E4v+DV;;E+Enw+DM;IAOI,yBAAA;IAAA,4BAAA;E/Eiw+DV;;E+Exw+DM;IAOI,+BAAA;IAAA,kCAAA;E/Esw+DV;;E+E7w+DM;IAOI,8BAAA;IAAA,iCAAA;E/E2w+DV;;E+Elx+DM;IAOI,4BAAA;IAAA,+BAAA;E/Egx+DV;;E+Evx+DM;IAOI,8BAAA;IAAA,iCAAA;E/Eqx+DV;;E+E5x+DM;IAOI,4BAAA;IAAA,+BAAA;E/E0x+DV;;E+Ejy+DM;IAOI,yBAAA;E/E8x+DV;;E+Ery+DM;IAOI,+BAAA;E/Eky+DV;;E+Ezy+DM;IAOI,8BAAA;E/Esy+DV;;E+E7y+DM;IAOI,4BAAA;E/E0y+DV;;E+Ejz+DM;IAOI,8BAAA;E/E8y+DV;;E+Erz+DM;IAOI,4BAAA;E/Ekz+DV;;E+Ezz+DM;IAOI,2BAAA;E/Esz+DV;;E+E7z+DM;IAOI,iCAAA;E/E0z+DV;;E+Ej0+DM;IAOI,gCAAA;E/E8z+DV;;E+Er0+DM;IAOI,8BAAA;E/Ek0+DV;;E+Ez0+DM;IAOI,gCAAA;E/Es0+DV;;E+E70+DM;IAOI,8BAAA;E/E00+DV;;E+Ej1+DM;IAOI,4BAAA;E/E80+DV;;E+Er1+DM;IAOI,kCAAA;E/Ek1+DV;;E+Ez1+DM;IAOI,iCAAA;E/Es1+DV;;E+E71+DM;IAOI,+BAAA;E/E01+DV;;E+Ej2+DM;IAOI,iCAAA;E/E81+DV;;E+Er2+DM;IAOI,+BAAA;E/Ek2+DV;;E+Ez2+DM;IAOI,0BAAA;E/Es2+DV;;E+E72+DM;IAOI,gCAAA;E/E02+DV;;E+Ej3+DM;IAOI,+BAAA;E/E82+DV;;E+Er3+DM;IAOI,6BAAA;E/Ek3+DV;;E+Ez3+DM;IAOI,+BAAA;E/Es3+DV;;E+E73+DM;IAOI,6BAAA;E/E03+DV;;E+Ej4+DM;IAOI,iBAAA;E/E83+DV;;E+Er4+DM;IAOI,uBAAA;E/Ek4+DV;;E+Ez4+DM;IAOI,sBAAA;E/Es4+DV;;E+E74+DM;IAOI,oBAAA;E/E04+DV;;E+Ej5+DM;IAOI,sBAAA;E/E84+DV;;E+Er5+DM;IAOI,oBAAA;E/Ek5+DV;;E+Ez5+DM;IAOI,qBAAA;E/Es5+DV;;E+E75+DM;IAOI,2BAAA;E/E05+DV;;E+Ej6+DM;IAOI,0BAAA;E/E85+DV;;E+Er6+DM;IAOI,wBAAA;E/Ek6+DV;;E+Ez6+DM;IAOI,0BAAA;E/Es6+DV;;E+E76+DM;IAOI,wBAAA;E/E06+DV;;E+Ej7+DM;IAOI,wBAAA;E/E86+DV;;E+Er7+DM;IAOI,8BAAA;E/Ek7+DV;;E+Ez7+DM;IAOI,6BAAA;E/Es7+DV;;E+E77+DM;IAOI,2BAAA;E/E07+DV;;E+Ej8+DM;IAOI,6BAAA;E/E87+DV;;E+Er8+DM;IAOI,2BAAA;E/Ek8+DV;;E+Ez8+DM;IAOI,2BAAA;E/Es8+DV;;E+E78+DM;IAOI,4BAAA;E/E08+DV;;E+Ej9+DM;IAOI,6BAAA;E/E88+DV;;E+Er9+DM;IAOI,uBAAA;E/Ek9+DV;;E+Ez9+DM;IAOI,0BAAA;E/Es9+DV;;E+E79+DM;IAOI,uBAAA;E/E09+DV;AACF;AqBr++DI;E0DGI;IAOI,sBAAA;E/E+9+DV;;E+Et++DM;IAOI,uBAAA;E/Em++DV;;E+E1++DM;IAOI,sBAAA;E/Eu++DV;;E+E9++DM;IAOI,8BAAA;E/E2++DV;;E+El/+DM;IAOI,4BAAA;E/E+++DV;;E+Et/+DM;IAOI,2BAAA;E/Em/+DV;;E+E1/+DM;IAOI,iCAAA;E/Eu/+DV;;E+E9/+DM;IAOI,2BAAA;E/E2/+DV;;E+Elg/DM;IAOI,0BAAA;E/E+/+DV;;E+Etg/DM;IAOI,gCAAA;E/Emg/DV;;E+E1g/DM;IAOI,yBAAA;E/Eug/DV;;E+E9g/DM;IAOI,wBAAA;E/E2g/DV;;E+Elh/DM;IAOI,+BAAA;E/E+g/DV;;E+Eth/DM;IAOI,yBAAA;E/Emh/DV;;E+E1h/DM;IAOI,6BAAA;E/Euh/DV;;E+E9h/DM;IAOI,8BAAA;E/E2h/DV;;E+Eli/DM;IAOI,wBAAA;E/E+h/DV;;E+Eti/DM;IAOI,+BAAA;E/Emi/DV;;E+E1i/DM;IAOI,wBAAA;E/Eui/DV;;E+E9i/DM;IAOI,yBAAA;E/E2i/DV;;E+Elj/DM;IAOI,8BAAA;E/E+i/DV;;E+Etj/DM;IAOI,iCAAA;E/Emj/DV;;E+E1j/DM;IAOI,sCAAA;E/Euj/DV;;E+E9j/DM;IAOI,yCAAA;E/E2j/DV;;E+Elk/DM;IAOI,uBAAA;E/E+j/DV;;E+Etk/DM;IAOI,uBAAA;E/Emk/DV;;E+E1k/DM;IAOI,yBAAA;E/Euk/DV;;E+E9k/DM;IAOI,yBAAA;E/E2k/DV;;E+Ell/DM;IAOI,0BAAA;E/E+k/DV;;E+Etl/DM;IAOI,4BAAA;E/Eml/DV;;E+E1l/DM;IAOI,kCAAA;E/Eul/DV;;E+E9l/DM;IAOI,sCAAA;E/E2l/DV;;E+Elm/DM;IAOI,oCAAA;E/E+l/DV;;E+Etm/DM;IAOI,kCAAA;E/Emm/DV;;E+E1m/DM;IAOI,yCAAA;E/Eum/DV;;E+E9m/DM;IAOI,wCAAA;E/E2m/DV;;E+Eln/DM;IAOI,wCAAA;E/E+m/DV;;E+Etn/DM;IAOI,kCAAA;E/Emn/DV;;E+E1n/DM;IAOI,gCAAA;E/Eun/DV;;E+E9n/DM;IAOI,8BAAA;E/E2n/DV;;E+Elo/DM;IAOI,gCAAA;E/E+n/DV;;E+Eto/DM;IAOI,+BAAA;E/Emo/DV;;E+E1o/DM;IAOI,oCAAA;E/Euo/DV;;E+E9o/DM;IAOI,kCAAA;E/E2o/DV;;E+Elp/DM;IAOI,gCAAA;E/E+o/DV;;E+Etp/DM;IAOI,uCAAA;E/Emp/DV;;E+E1p/DM;IAOI,sCAAA;E/Eup/DV;;E+E9p/DM;IAOI,iCAAA;E/E2p/DV;;E+Elq/DM;IAOI,2BAAA;E/E+p/DV;;E+Etq/DM;IAOI,iCAAA;E/Emq/DV;;E+E1q/DM;IAOI,+BAAA;E/Euq/DV;;E+E9q/DM;IAOI,6BAAA;E/E2q/DV;;E+Elr/DM;IAOI,+BAAA;E/E+q/DV;;E+Etr/DM;IAOI,8BAAA;E/Emr/DV;;E+E1r/DM;IAOI,oBAAA;E/Eur/DV;;E+E9r/DM;IAOI,mBAAA;E/E2r/DV;;E+Els/DM;IAOI,mBAAA;E/E+r/DV;;E+Ets/DM;IAOI,mBAAA;E/Ems/DV;;E+E1s/DM;IAOI,mBAAA;E/Eus/DV;;E+E9s/DM;IAOI,mBAAA;E/E2s/DV;;E+Elt/DM;IAOI,mBAAA;E/E+s/DV;;E+Ett/DM;IAOI,mBAAA;E/Emt/DV;;E+E1t/DM;IAOI,oBAAA;E/Eut/DV;;E+E9t/DM;IAOI,0BAAA;E/E2t/DV;;E+Elu/DM;IAOI,yBAAA;E/E+t/DV;;E+Etu/DM;IAOI,uBAAA;E/Emu/DV;;E+E1u/DM;IAOI,yBAAA;E/Euu/DV;;E+E9u/DM;IAOI,uBAAA;E/E2u/DV;;E+Elv/DM;IAOI,uBAAA;E/E+u/DV;;E+Etv/DM;IAOI,0BAAA;IAAA,yBAAA;E/Eov/DV;;E+E3v/DM;IAOI,gCAAA;IAAA,+BAAA;E/Eyv/DV;;E+Ehw/DM;IAOI,+BAAA;IAAA,8BAAA;E/E8v/DV;;E+Erw/DM;IAOI,6BAAA;IAAA,4BAAA;E/Emw/DV;;E+E1w/DM;IAOI,+BAAA;IAAA,8BAAA;E/Eww/DV;;E+E/w/DM;IAOI,6BAAA;IAAA,4BAAA;E/E6w/DV;;E+Epx/DM;IAOI,6BAAA;IAAA,4BAAA;E/Ekx/DV;;E+Ezx/DM;IAOI,wBAAA;IAAA,2BAAA;E/Eux/DV;;E+E9x/DM;IAOI,8BAAA;IAAA,iCAAA;E/E4x/DV;;E+Eny/DM;IAOI,6BAAA;IAAA,gCAAA;E/Eiy/DV;;E+Exy/DM;IAOI,2BAAA;IAAA,8BAAA;E/Esy/DV;;E+E7y/DM;IAOI,6BAAA;IAAA,gCAAA;E/E2y/DV;;E+Elz/DM;IAOI,2BAAA;IAAA,8BAAA;E/Egz/DV;;E+Evz/DM;IAOI,2BAAA;IAAA,8BAAA;E/Eqz/DV;;E+E5z/DM;IAOI,wBAAA;E/Eyz/DV;;E+Eh0/DM;IAOI,8BAAA;E/E6z/DV;;E+Ep0/DM;IAOI,6BAAA;E/Ei0/DV;;E+Ex0/DM;IAOI,2BAAA;E/Eq0/DV;;E+E50/DM;IAOI,6BAAA;E/Ey0/DV;;E+Eh1/DM;IAOI,2BAAA;E/E60/DV;;E+Ep1/DM;IAOI,2BAAA;E/Ei1/DV;;E+Ex1/DM;IAOI,0BAAA;E/Eq1/DV;;E+E51/DM;IAOI,gCAAA;E/Ey1/DV;;E+Eh2/DM;IAOI,+BAAA;E/E61/DV;;E+Ep2/DM;IAOI,6BAAA;E/Ei2/DV;;E+Ex2/DM;IAOI,+BAAA;E/Eq2/DV;;E+E52/DM;IAOI,6BAAA;E/Ey2/DV;;E+Eh3/DM;IAOI,6BAAA;E/E62/DV;;E+Ep3/DM;IAOI,2BAAA;E/Ei3/DV;;E+Ex3/DM;IAOI,iCAAA;E/Eq3/DV;;E+E53/DM;IAOI,gCAAA;E/Ey3/DV;;E+Eh4/DM;IAOI,8BAAA;E/E63/DV;;E+Ep4/DM;IAOI,gCAAA;E/Ei4/DV;;E+Ex4/DM;IAOI,8BAAA;E/Eq4/DV;;E+E54/DM;IAOI,8BAAA;E/Ey4/DV;;E+Eh5/DM;IAOI,yBAAA;E/E64/DV;;E+Ep5/DM;IAOI,+BAAA;E/Ei5/DV;;E+Ex5/DM;IAOI,8BAAA;E/Eq5/DV;;E+E55/DM;IAOI,4BAAA;E/Ey5/DV;;E+Eh6/DM;IAOI,8BAAA;E/E65/DV;;E+Ep6/DM;IAOI,4BAAA;E/Ei6/DV;;E+Ex6/DM;IAOI,4BAAA;E/Eq6/DV;;E+E56/DM;IAOI,2BAAA;E/Ey6/DV;;E+Eh7/DM;IAOI,0BAAA;E/E66/DV;;E+Ep7/DM;IAOI,wBAAA;E/Ei7/DV;;E+Ex7/DM;IAOI,0BAAA;E/Eq7/DV;;E+E57/DM;IAOI,wBAAA;E/Ey7/DV;;E+Eh8/DM;IAOI,iCAAA;IAAA,gCAAA;E/E87/DV;;E+Er8/DM;IAOI,gCAAA;IAAA,+BAAA;E/Em8/DV;;E+E18/DM;IAOI,8BAAA;IAAA,6BAAA;E/Ew8/DV;;E+E/8/DM;IAOI,gCAAA;IAAA,+BAAA;E/E68/DV;;E+Ep9/DM;IAOI,8BAAA;IAAA,6BAAA;E/Ek9/DV;;E+Ez9/DM;IAOI,+BAAA;IAAA,kCAAA;E/Eu9/DV;;E+E99/DM;IAOI,8BAAA;IAAA,iCAAA;E/E49/DV;;E+En+/DM;IAOI,4BAAA;IAAA,+BAAA;E/Ei+/DV;;E+Ex+/DM;IAOI,8BAAA;IAAA,iCAAA;E/Es+/DV;;E+E7+/DM;IAOI,4BAAA;IAAA,+BAAA;E/E2+/DV;;E+El//DM;IAOI,+BAAA;E/E++/DV;;E+Et//DM;IAOI,8BAAA;E/Em//DV;;E+E1//DM;IAOI,4BAAA;E/Eu//DV;;E+E9//DM;IAOI,8BAAA;E/E2//DV;;E+ElggEM;IAOI,4BAAA;E/E+//DV;;E+EtggEM;IAOI,iCAAA;E/EmggEV;;E+E1ggEM;IAOI,gCAAA;E/EuggEV;;E+E9ggEM;IAOI,8BAAA;E/E2ggEV;;E+ElhgEM;IAOI,gCAAA;E/E+ggEV;;E+EthgEM;IAOI,8BAAA;E/EmhgEV;;E+E1hgEM;IAOI,kCAAA;E/EuhgEV;;E+E9hgEM;IAOI,iCAAA;E/E2hgEV;;E+EligEM;IAOI,+BAAA;E/E+hgEV;;E+EtigEM;IAOI,iCAAA;E/EmigEV;;E+E1igEM;IAOI,+BAAA;E/EuigEV;;E+E9igEM;IAOI,gCAAA;E/E2igEV;;E+EljgEM;IAOI,+BAAA;E/E+igEV;;E+EtjgEM;IAOI,6BAAA;E/EmjgEV;;E+E1jgEM;IAOI,+BAAA;E/EujgEV;;E+E9jgEM;IAOI,6BAAA;E/E2jgEV;;E+ElkgEM;IAOI,qBAAA;E/E+jgEV;;E+EtkgEM;IAOI,2BAAA;E/EmkgEV;;E+E1kgEM;IAOI,0BAAA;E/EukgEV;;E+E9kgEM;IAOI,wBAAA;E/E2kgEV;;E+EllgEM;IAOI,0BAAA;E/E+kgEV;;E+EtlgEM;IAOI,wBAAA;E/EmlgEV;;E+E1lgEM;IAOI,2BAAA;IAAA,0BAAA;E/EwlgEV;;E+E/lgEM;IAOI,iCAAA;IAAA,gCAAA;E/E6lgEV;;E+EpmgEM;IAOI,gCAAA;IAAA,+BAAA;E/EkmgEV;;E+EzmgEM;IAOI,8BAAA;IAAA,6BAAA;E/EumgEV;;E+E9mgEM;IAOI,gCAAA;IAAA,+BAAA;E/E4mgEV;;E+EnngEM;IAOI,8BAAA;IAAA,6BAAA;E/EingEV;;E+ExngEM;IAOI,yBAAA;IAAA,4BAAA;E/EsngEV;;E+E7ngEM;IAOI,+BAAA;IAAA,kCAAA;E/E2ngEV;;E+ElogEM;IAOI,8BAAA;IAAA,iCAAA;E/EgogEV;;E+EvogEM;IAOI,4BAAA;IAAA,+BAAA;E/EqogEV;;E+E5ogEM;IAOI,8BAAA;IAAA,iCAAA;E/E0ogEV;;E+EjpgEM;IAOI,4BAAA;IAAA,+BAAA;E/E+ogEV;;E+EtpgEM;IAOI,yBAAA;E/EmpgEV;;E+E1pgEM;IAOI,+BAAA;E/EupgEV;;E+E9pgEM;IAOI,8BAAA;E/E2pgEV;;E+ElqgEM;IAOI,4BAAA;E/E+pgEV;;E+EtqgEM;IAOI,8BAAA;E/EmqgEV;;E+E1qgEM;IAOI,4BAAA;E/EuqgEV;;E+E9qgEM;IAOI,2BAAA;E/E2qgEV;;E+ElrgEM;IAOI,iCAAA;E/E+qgEV;;E+EtrgEM;IAOI,gCAAA;E/EmrgEV;;E+E1rgEM;IAOI,8BAAA;E/EurgEV;;E+E9rgEM;IAOI,gCAAA;E/E2rgEV;;E+ElsgEM;IAOI,8BAAA;E/E+rgEV;;E+EtsgEM;IAOI,4BAAA;E/EmsgEV;;E+E1sgEM;IAOI,kCAAA;E/EusgEV;;E+E9sgEM;IAOI,iCAAA;E/E2sgEV;;E+EltgEM;IAOI,+BAAA;E/E+sgEV;;E+EttgEM;IAOI,iCAAA;E/EmtgEV;;E+E1tgEM;IAOI,+BAAA;E/EutgEV;;E+E9tgEM;IAOI,0BAAA;E/E2tgEV;;E+ElugEM;IAOI,gCAAA;E/E+tgEV;;E+EtugEM;IAOI,+BAAA;E/EmugEV;;E+E1ugEM;IAOI,6BAAA;E/EuugEV;;E+E9ugEM;IAOI,+BAAA;E/E2ugEV;;E+ElvgEM;IAOI,6BAAA;E/E+ugEV;;E+EtvgEM;IAOI,iBAAA;E/EmvgEV;;E+E1vgEM;IAOI,uBAAA;E/EuvgEV;;E+E9vgEM;IAOI,sBAAA;E/E2vgEV;;E+ElwgEM;IAOI,oBAAA;E/E+vgEV;;E+EtwgEM;IAOI,sBAAA;E/EmwgEV;;E+E1wgEM;IAOI,oBAAA;E/EuwgEV;;E+E9wgEM;IAOI,qBAAA;E/E2wgEV;;E+ElxgEM;IAOI,2BAAA;E/E+wgEV;;E+EtxgEM;IAOI,0BAAA;E/EmxgEV;;E+E1xgEM;IAOI,wBAAA;E/EuxgEV;;E+E9xgEM;IAOI,0BAAA;E/E2xgEV;;E+ElygEM;IAOI,wBAAA;E/E+xgEV;;E+EtygEM;IAOI,wBAAA;E/EmygEV;;E+E1ygEM;IAOI,8BAAA;E/EuygEV;;E+E9ygEM;IAOI,6BAAA;E/E2ygEV;;E+ElzgEM;IAOI,2BAAA;E/E+ygEV;;E+EtzgEM;IAOI,6BAAA;E/EmzgEV;;E+E1zgEM;IAOI,2BAAA;E/EuzgEV;;E+E9zgEM;IAOI,2BAAA;E/E2zgEV;;E+El0gEM;IAOI,4BAAA;E/E+zgEV;;E+Et0gEM;IAOI,6BAAA;E/Em0gEV;;E+E10gEM;IAOI,uBAAA;E/Eu0gEV;;E+E90gEM;IAOI,0BAAA;E/E20gEV;;E+El1gEM;IAOI,uBAAA;E/E+0gEV;AACF;AgFt4gEA;ED+CQ;IAOI,+BAAA;E/Eo1gEV;;E+E31gEM;IAOI,6BAAA;E/Ew1gEV;;E+E/1gEM;IAOI,gCAAA;E/E41gEV;AACF;AgFh4gEA;ED4BQ;IAOI,0BAAA;E/Ei2gEV;;E+Ex2gEM;IAOI,gCAAA;E/Eq2gEV;;E+E52gEM;IAOI,yBAAA;E/Ey2gEV;;E+Eh3gEM;IAOI,wBAAA;E/E62gEV;;E+Ep3gEM;IAOI,+BAAA;E/Ei3gEV;;E+Ex3gEM;IAOI,yBAAA;E/Eq3gEV;;E+E53gEM;IAOI,6BAAA;E/Ey3gEV;;E+Eh4gEM;IAOI,8BAAA;E/E63gEV;;E+Ep4gEM;IAOI,wBAAA;E/Ei4gEV;;E+Ex4gEM;IAOI,+BAAA;E/Eq4gEV;;E+E54gEM;IAOI,wBAAA;E/Ey4gEV;AACF;AiFn9gEA;;;;;;;CAAA;ACUA;EACI,wBAAA;EAEA,6CAAA;EACA,sFAAA;EACA,gBAAA;AlFk9gEJ;AkF/8gEA;EACI,wBAAA;EACA,6CAAA;EACA,wFAAA;EACA,gBAAA;AlFi9gEJ;AkF/8gEA;EACI,wBAAA;EACA,6CAAA;EACA,uFAAA;EACA,gBAAA;AlFi9gEJ;AkF/8gEA;EACI,wBAAA;EACA,6CAAA;EACA,yFAAA;EACA,gBAAA;AlFi9gEJ;AkF/8gEA;EACI,wBAAA;EAGA,qFAAA;EACA,gBAAA;AlF+8gEJ;AOt5/DE;EACE,mBANW;AP85/Df;;AQp5gEA,2EAAA;A2EvGA;;;;;;CAAA;ACIA;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,aAAA;EACA,qCAAA;EACA,6BAAA;EACA,gDAAA;ApFkghEJ;AoFhghEI;EACI,4C7EylBK;APy6/Db;AoF//gEI;EAdJ;IAeQ,mCAAA;EpFkghEN;AACF;;AoF//gEA;EACI,aAAA;EAEA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,YCwD8C;EDvD9C,sCAAA;ApFkghEJ;AoF9/gEI;EAXJ;IAYQ,kDAAA;EpFighEN;AACF;AoF9/gEQ;EACI,oBAAA;ApFgghEZ;AoF7/gEQ;EACI,aAAA;EACA,kBAAA;EACA,wC7EgxCE;E6E/wCF,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,4CAAA;ApF+/gEZ;AoF3/gEI;EACI,YAAA;EACA,WAAA;EACA,sCAAA;EACA,yBAAA;ApF6/gER;AoF3/gEQ;EACI,0CAAA;ApF6/gEZ;AoF1/gEQ;EAVJ;IAWQ,YAAA;IACA,WAAA;EpF6/gEV;AACF;AoFz/gEI;EACI,sCAAA;ApF2/gER;AoFx/gEI;EACI,kCAAA;ApF0/gER;;AoFt/gEA,WAAA;AAEA;EACI,2BAAA;ApFw/gEJ;AoFt/gEI;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;EACA,oCAAA;EACA,gBAAA;ApFw/gER;AoFr/gEI;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,MAAA;EACA,sCAAA;ApFu/gER;AoFp/gEI;EACI,UAAA;EACA,qBAAA;ApFs/gER;AoFn/gEI;EA5BJ;IA6BQ,gCAAA;EpFs/gEN;AACF;AoF1+gEI;EACI,sCAAA;ApFo/gER;;AoF7+gEI;EACI,kBAAA;EACA,gBAAA;ApFg/gER;AoF9+gEQ;EACI,2B7EmrCK;AP6z+DjB;;AoF3+gEA;EAEQ;IACI,aAAA;EpF6+gEV;EoF1+gEM;IACI,qBAAA;EpF4+gEV;AACF;AoFx+gEA;EACI,YCvE8C;EDwE9C,aAAA;EACA,mBAAA;ApF0+gEJ;;AoFv+gEA;EACI,YAAA;EACA,WAAA;ApF0+gEJ;;AoFv+gEA;EACI,QAAA;EACA,mBAAA;ApF0+gEJ;;AoFv+gEA;EACI,WAAA;EACA,mBAAA;ApF0+gEJ;;AoFt+gEI;EADJ;IAEQ,0CAAA;EpF0+gEN;AACF;AoFx+gEI;EACI,mBAAA;ApF0+gER;;AoFt+gEA;EACI,qBAAA;EACA,oBAAA;EACA,kBAAA;ApFy+gEJ;AoFv+gEI;EACI,kBAAA;EACA,UAAA;ApFy+gER;;AoFp+gEA;EACI,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,oCAAA;ApFu+gEJ;AoFr+gEI;EACI,YAAA;ApFu+gER;AoFp+gEI;EACI,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ApFs+gER;AoFn+gEI;EACI,kDAAA;ApFq+gER;;AoF99gEQ;EACI,YAAA;ApFi+gEZ;;AoFz9gEQ;EACI,YAAA;ApF49gEZ;;AoFt9gEI;EACI,aAAA;ApFy9gER;AoFt9gEI;EACI,qBAAA;ApFw9gER;;AoFl9gEQ;EACI,aAAA;ApFq9gEZ;AoFl9gEQ;EACI,qBAAA;ApFo9gEZ;;AoF/8gEA;EAEQ;IACI,gBAAA;EpFi9gEV;EoF/8gEU;IACI,WAAA;EpFi9gEd;AACF;AoF58gEA;EACI;IACI,oBAAA;EpF88gEN;AACF;AoFz8gEQ;EACI;IACI,kBAAA;IACA,4C7E0UH;EPiogEX;EoFx8gEU;IACI,qBAAA;IACA,eAAA;EpF08gEd;EoFv8gEU;IACI,kBAAA;EpFy8gEd;EoFt8gEU;IACI,cAAA;IACA,cAAA;EpFw8gEd;EoFp8gEc;IACI,wCAAA;IACA,kBAAA;IACA,WAAA;IACA,gBAAA;EpFs8gElB;EoFp8gEkB;IACI,aAAA;EpFs8gEtB;EoFn8gEkB;IACI,cAAA;EpFq8gEtB;AACF;AoF97gEgB;EACI,aAAA;ApFg8gEpB;AoF77gEgB;EACI,cAAA;ApF+7gEpB;;AoFv7gEI;EACI,OAAA;EACA,gDAAA;ApF07gER;AoFx7gEQ;EACI;IACI,gBAAA;EpF07gEd;AACF;AoFt7gEI;EASI,uEAAA;ApFg7gER;AoFx7gEQ;EADJ;IAEQ,gBCxQsC;ErFmshEhD;AACF;AoFz7gEQ;EALJ;IAMQ,6EAAA;EpF47gEV;AACF;AoFr7gEY;EADJ;IAEQ,+BAAA;EpFw7gEd;AACF;;AoF/6gEY;EADJ;IAEQ,sCAAA;EpFm7gEd;AACF;AoF76gEY;EADJ;IAEQ,sCAAA;EpFg7gEd;AACF;;AoFz6gEQ;EADJ;IAEQ,wBAAA;EpF66gEV;AACF;AoF16gEI;EACI,aAAA;ApF46gER;;AsFnzhEA;EACI,oBAAA;EACA,wCAAA;EACA,2CAAA;EACA,oDAAA;EACA,oCAAA;AtFszhEJ;AsFpzhEI;EACI,6BAAA;EACA,UAAA;AtFszhER;AsFnzhEI;EACI,gBAAA;EACA,0BAAA;EACA,yBAAA;AtFqzhER;;AsFhzhEI;EACI,iBAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AtFmzhER;AsFjzhEQ;EARJ;IASQ,mBAAA;EtFozhEV;AACF;;AsF9yhEQ;EACI,iBAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AtFizhEZ;AsF/yhEY;EARJ;IASQ,mBAAA;EtFkzhEd;AACF;;AuFh2hEA;EACI,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,QAAA;EACA,6BAAA;EACA,mCAAA;EACA,YF8H8C;EE7H9C,qCAAA;AvFm2hEJ;AuFj2hEI;EAVJ;IAWQ,OAAA;EvFo2hEN;AACF;;AuF91hEQ;EACI,sCAAA;AvFi2hEZ;AuF/1hEY;EAHJ;IAIQ,OAAA;EvFk2hEd;AACF;AuF91hEQ;EACI,sCAAA;AvFg2hEZ;AuF91hEY;EAHJ;IAIQ,OAAA;EvFi2hEd;AACF;;AuF11hEI;EACI,kBAAA;AvF61hER;;AuFv1hEI;EACI;IACI,kBAAA;IACA,6BAAA;EvF01hEV;AACF;;AuFp1hEQ;EADJ;IAEQ,wBAAA;EvFw1hEV;AACF;;AwFl5hEA;EACE,0CAAA;EACA,gBAAA;AxFq5hEF;AwFn5hEE;EACE,yBAAA;EACA,gBH2E8C;ArF00hElD;;AwFj5hEA;EACE,6BAAA;EAMA,4BAAA;AxF+4hEF;AwFn5hEE;EAHF;IAII,0CAAA;ExFs5hEF;AACF;AwFn5hEE;EACE,WAAA;EAAa,mCAAA;AxFs5hEjB;AwFn5hEE;EACE,yBAAA;EAA2B,+BAAA;EAC3B,kBAAA;EAAoB,iDAAA;AxFu5hExB;AwFp5hEE;EACE,sBAAA;EAAwB,+BAAA;AxFu5hE5B;;AwFn5hEA;EACE,uEAAA;AxFs5hEF;;AwFj5hEA;EACE,oCAAA;EACA,aHnCgD;EGoChD,sCAAA;EACA,sDAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,8CAAA;EACA,gCAAA;EACA,6BAAA;AxFo5hEF;AwFj5hEI;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,yCAAA;EACA,mBHnD4C;EGoD5C,gCjF/CgB;APk8hEtB;AwFj5hEM;EACE,gDAAA;AxFm5hER;AwFh5hEM;EACE,+CAAA;AxFk5hER;AwF/4hEM;EACE,qBAAA;EACA,kBH1D0C;EG2D1C,eAAA;EACA,oBAAA;AxFi5hER;AwF94hEM;EACE,WAAA;EACA,sBAAA;EACA,yCAAA;AxFg5hER;AwF74hEM;EACE,iBAAA;EACA,kBAAA;EACA,UAAA;AxF+4hER;AwF54hEM;EACE,+CAAA;AxF84hER;AwF54hEQ;EACE,+CAAA;EACA,+BAAA;AxF84hEV;AwFz4hEQ;EACE,cAAA;EACA,aAAA;EACA,oCAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;AxF24hEV;AwFx4hEQ;EACE,gDAAA;AxF04hEV;AwFx4hEU;EACE,+CAAA;EACA,+BAAA;AxF04hEZ;AwFv4hEU;EACE,wBAAA;EACA,gDAAA;AxFy4hEZ;AwFt4hEU;EACE,UAAA;EACA,2DAAA;AxFw4hEZ;AwFj4hEU;EACE,wBAAA;AxFm4hEZ;AwF73hEI;EACE,qBH/H4C;ArF8/hElD;AwF73hEM;EACE,kCAAA;EAEA,6CAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBHxI0C;EGyI1C,gCjFzIc;APugiEtB;AwF53hEQ;EACE,WAAA;EACA,UAAA;EACA,aAAA;EACA,wDAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gCAAA;EACA,YAAA;AxF83hEV;AwF33hEQ;EACE,mDAAA;AxF63hEV;AwF33hEU;EACE,yEAAA;EAGA,UAAA;AxF23hEZ;AwFv3hEQ;EACE,gDAAA;AxFy3hEV;AwFv3hEU;EACE,2DAAA;AxFy3hEZ;AwFp3hEM;EACE,kBAAA;AxFs3hER;AwFn3hEU;EACE,WAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,iBAAA;EACA,SAAA;AxFq3hEZ;AwF92hEE;EACE,gCAAA;EACA,aAAA;AxFg3hEJ;;AwF52hEA;EACE,iBAAA;EACA,kBAAA;EACA,6BAAA;AxF+2hEF;AwF72hEE;EALF;IAMI,aAAA;ExFg3hEF;AACF;;AwF72hEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AxFg3hEF;AwF92hEE;EACE,iDAAA;EACA,kBAAA;EACA,kBAAA;EACA,iDAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;AxFg3hEJ;AwF92hEI;EACE,MAAA;EACA,UAAA;AxFg3hEN;AwF72hEI;EACE,QAAA;AxF+2hEN;AwF52hEI;EACE,SAAA;EACA,UAAA;AxF82hEN;AwFx2hEM;EACE,SAAA;AxF02hER;AwFv2hEM;EACE,YAAA;AxFy2hER;AwFp2hEE;EACE,yBAAA;AxFs2hEJ;AwFn2hEM;EACE,SAAA;EACA,QAAA;EACA,WAAA;EACA,wBAAA;EACA,uBAAA;AxFq2hER;AwFl2hEM;EACE,SAAA;EACA,SAAA;EACA,WAAA;EACA,wBAAA;EACA,sBAAA;AxFo2hER;AwFj2hEM;EACE,SAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;AxFm2hER;;AwF71hEA;EACE,iBHnNgD;ArFmjiElD;AwF91hEE;EACE,aAAA;AxFg2hEJ;;AwF51hEA;EACE,aAAA;AxF+1hEF;;AwF11hEI;EACE,SAAA;AxF61hEN;AwF31hEM;EACE,WAAA;EACA,UAAA;AxF61hER;AwFz1hEI;EAVF;IAWI,kBAAA;IACA,sBAAA;ExF41hEJ;AACF;AwFx1hEI;EACE,UAAA;AxF01hEN;AwFr1hEI;EADF;IAEI,aAAA;ExFw1hEJ;AACF;AwFr1hEE;EACE,aAAA;AxFu1hEJ;AwFn1hEI;EACE,6CAAA;AxFq1hEN;AwFn1hEM;EAHF;IAII,cAAA;ExFs1hEN;AACF;AwFl1hEM;EACE,aAAA;AxFo1hER;AwFj1hEM;EACE,qBAAA;AxFm1hER;AwF/0hEI;EACE,qBAAA;AxFi1hEN;AwF90hEI;EACE;IACE,aAAA;ExFg1hEN;AACF;AwF50hEI;EACE,uCAAA;AxF80hEN;AwF50hEM;EACE,aAAA;AxF80hER;AwF30hEU;EACE,YAAA;AxF60hEZ;AwFt0hEQ;EACE,aAAA;AxFw0hEV;AwFr0hEQ;EACE,kBAAA;AxFu0hEV;AwFr0hEU;EACE,aAAA;AxFu0hEZ;AwFp0hEU;EACE,yCAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AxFs0hEZ;AwFj0hEU;EACE,aAAA;AxFm0hEZ;AwFh0hEU;EACE,eAAA;AxFk0hEZ;AwFh0hEY;EAGE,eAAA;AxFg0hEd;AwF5zhEU;EACE,iBAAA;AxF8zhEZ;AwF3zhEU;EAEE,aAAA;AxF4zhEZ;AwFxzhEQ;EACE,aAAA;AxF0zhEV;AwFtzhEM;EACE,+CAAA;AxFwzhER;AwFtzhEQ;EACE;IACE,qBAAA;ExFwzhEV;EwFrzhEQ;IACE,gBAAA;ExFuzhEV;AACF;AwFnzhEU;EACE,cAAA;AxFqzhEZ;AwFhzhEU;EACE,eAAA;AxFkzhEZ;AwFhzhEY;EAGE,eAAA;AxFgzhEd;AwF5yhEU;EACE,sBAAA;AxF8yhEZ;AwF3yhEU;EAGE,qBAAA;AxF2yhEZ;AwFtyhEU;EACE,qBAAA;AxFwyhEZ;AwFryhEU;EACE,aAAA;AxFuyhEZ;AwFnyhEQ;EACE,gBAAA;AxFqyhEV;AwFnyhEU;EACE,qBAAA;AxFqyhEZ;AwFlyhEU;EACE,aAAA;AxFoyhEZ;AwF3xhEM;EADF;IAEI,oBjFiEY;EP6thElB;AACF;AwFzxhEI;EACE,gBAAA;AxF2xhEN;AwFxxhEI;EACE,aAAA;AxF0xhEN;AwFvxhEI;EACE,qBAAA;AxFyxhEN;AwFpxhEI;EADF;IAEI,iBAAA;ExFuxhEJ;EwFrxhEI;IACE,6CAAA;ExFuxhEN;AACF;AwFpxhEI;EATF;IAUI,iBAAA;ExFuxhEJ;EwFrxhEI;IACE,6CAAA;ExFuxhEN;AACF;AwFpxhEI;EACE,uBAAA;AxFsxhEN;AwFnxhEI;EACE,eAAA;EACA,UAAA;EACA,uCAAA;EACA,UAAA;EACA,MAAA;EACA,4CAAA;AxFqxhEN;AwFjxhEM;EACE,aAAA;AxFmxhER;AwFhxhEM;EACE,qBAAA;AxFkxhER;AwF7whEI;EACE,eAAA;EACA,kDAAA;EACA,iBHje4C;ArFgviElD;AwF7whEM;;EAEE,4BAAA;AxF+whER;AwF5whEM;;EAEE,wBAAA;AxF8whER;AwF3whEM;EACE,oBAAA;AxF6whER;AwFxwhEQ;EACE,wBAAA;AxF0whEV;AwFvwhEQ;EACE,kBAAA;EACA,eAAA;AxFywhEV;AwFvwhEU;EACE,aAAA;AxFywhEZ;AwFtwhEU;EACE,cAAA;EACA,iBAAA;AxFwwhEZ;AwFnwhEU;EACE,aAAA;AxFqwhEZ;AwFlwhEU;EACE,eAAA;AxFowhEZ;AwFjwhEU;EACE,iBAAA;AxFmwhEZ;AwFhwhEU;EAEE,aAAA;AxFiwhEZ;AwF7vhEQ;EACE,aAAA;EACA,uBAAA;AxF+vhEV;AwF5vhEQ;EACE,kBAAA;AxF8vhEV;AwF3vhEY;EACE,kBAAA;EACA,qDAAA;EACA,gBAAA;EACA,sCAAA;AxF6vhEd;AwF3vhEc;EACE,+BAAA;AxF6vhEhB;AwF1vhEc;EACE,qBAAA;EACA,kBAAA;AxF4vhEhB;AwFzvhEc;EACE,cAAA;EACA,wBAAA;EACA,WjFnmBR;AP81iER;AwFtvhEc;EACE,qBAAA;AxFwvhEhB;AwFpvhEY;EACE,cAAA;EACA,sCAAA;EACA,kBAAA;EACA,YAAA;EACA,sCAAA;EACA,uBAAA;EACA,iBAAA;EACA,0BAAA;EACA,4CH1nBoC;ArFg3iElD;AwFjvhEQ;EACE,UAAA;AxFmvhEV;AwF/uhEc;EACE,+CAAA;AxFivhEhB;AwF/uhEgB;EACE,cAAA;AxFivhElB;AwF1uhEY;EACE,yBAAA;EACA,kCAAA;AxF4uhEd;AwFxuhEU;EACE,qBAAA;EACA,MAAA;EACA,6BAAA;AxF0uhEZ;AwFluhEI;EACE;IACE,6CAAA;ExFouhEN;AACF;AwFjuhEI;EACE,uCAAA;AxFmuhEN;AwF/thEI;EACE,kDAAA;AxFiuhEN;AwF7thEQ;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;AxF+thEV;AwF5thEU;EACE,cAAA;AxF8thEZ;AwF3thEU;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;AxF6thEZ;AwF1thEU;EACE,wBAAA;AxF4thEZ;AwFzthEU;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,QAAA;AxF2thEZ;AwFvthEY;EACE,aAAA;AxFythEd;AwFpthEQ;EACE,wBAAA;AxFsthEV;AwFnthEQ;EACE,eAAA;AxFqthEV;AwFjthEM;EACE,kBAAA;AxFmthER;AwFjthEQ;EACE,0BAAA;AxFmthEV;AwF5shEI;EACE,aAAA;AxF8shEN;AwF3shEI;EACE,qBAAA;AxF6shEN;AwFxshEI;EACE,qBAAA;AxF0shEN;AwFvshEI;EACE,aAAA;AxFyshEN;AwFpshEI;;EAEE,iBAAA;AxFsshEN;AwFnshEI;EACE;IACE,kBAAA;ExFqshEN;EwFlshEI;IACE,cAAA;IACA,cAAA;IACA,oBjFhPY;EPo7hElB;EwFjshEI;IACE,oBjFpPY;EPu7hElB;EwFhshEI;IACE,wBAAA;IACA,cjFzPY;IiF0PZ,UAAA;IACA,wCAAA;IACA,kBAAA;IACA,eAAA;IACA,UAAA;ExFkshEN;EwFhshEM;IACE,aAAA;ExFkshER;EwFvrhEM;;;;;IACE,qBAAA;ExF6rhER;EwF1rhEM;;;;;IACE,aAAA;ExFgshER;AACF;AwF5rhEI;EACE,6CAAA;AxF8rhEN;AwF1rhEM;EACE,gBAAA;AxF4rhER;AwFvrhEM;EACE;;IAEE,kBAAA;ExFyrhER;AACF;AwF7qhEM;;;;EACE,aAAA;AxFkrhER;AwF/qhEM;;;;EACE,qBAAA;AxForhER;;AwF5qhEI;EASI;;;;;;IACE,aAAA;ExF4qhER;EwFzqhEM;;;;;;IACE,qBAAA;ExFgrhER;AACF;;AwF1qhEA;EACE,sBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,0CAAA;EACA,gBjFvOqB;APo5hEvB;AwF3qhEE;EACE,kBAAA;EACA,qBAAA;AxF6qhEJ;AwF1qhEE;EACE,aAAA;AxF4qhEJ;;AwFxqhEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;EACA,aAAA;EACA,aAAA;AxF2qhEF;;AwFtqhEE;EACE,cAAA;AxFyqhEJ;AwFtqhEE;EACE,yBAAA;EACA,aAAA;AxFwqhEJ;;AwF/phEQ;EACE,yBAAA;AxFkqhEV;AwF/phEQ;EACE,yBAAA;AxFiqhEV;;AwFzphEE;EACE,2EHt4B8C;ArFkijElD;;AwFzphEE;EACE,0EHr4B8C;ArFiijElD;;AwFzphEE;EACE,wEHp4B8C;ArFgijElD;;AwFzphEE;EACE,iEHn4B8C;ArF+hjElD;;AwFtphEE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,wBAAA;EACA,aAAA;AxFyphEJ;;AwFrphEI;EACE,0DAAA;AxFwphEN;;AwFnphEI;EACE,0DAAA;AxFsphEN;;AwFjphEI;EACE,0DAAA;AxFophEN;;AwF/ohEI;EACE,0DAAA;AxFkphEN;;AwF5ohEE;EACE,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,wBAAA;AxF+ohEJ;AwF5ohEE;EAGI;IACE,6CAAA;ExF4ohEN;EwFzohEI;IACE,sCAAA;ExF2ohEN;EwFxohEI;IACE,sCAAA;ExF0ohEN;EwFrohEI;IACE,sCAAA;ExFuohEN;EwFpohEI;IACE,sCAAA;ExFsohEN;AACF;AwFlohEE;EACE;IACE,2EAAA;ExFoohEJ;EwF/nhEE;IACE,YAAA;IACA,sCAAA;ExFiohEJ;EwF9nhEE;IACE,uDAAA;IACA,kCAAA;ExFgohEJ;EwF7nhEE;IACE,qFAAA;IAIA,6CAAA;ExF4nhEJ;EwFznhEE;IACE,qFAAA;IAIA,6CAAA;IACA,SAAA;IACA,sBjFhfU;IiFifV,yBAAA;IACA,yCAAA;ExFwnhEJ;EwFtnhEI;IACE,QAAA;ExFwnhEN;EwFnnhEI;IACE,0DAAA;ExFqnhEN;EwFlnhEI;IACE,wFAAA;ExFonhEN;EwF9mhEI;IACE,wFAAA;ExFgnhEN;EwFxmhEI;IACE,0DAAA;ExF0mhEN;EwFvmhEI;IACE,SAAA;ExFymhEN;EwFtmhEI;IACE,wFAAA;ExFwmhEN;EwFlmhEI;IACE,wFAAA;ExFomhEN;EwF5lhEI;IACE,0DAAA;ExF8lhEN;EwF3lhEI;IACE,wFAAA;ExF6lhEN;EwFvlhEI;IACE,wFAAA;ExFylhEN;AACF;AwFllhEE;EACE,2BAAA;EACA,4BAAA;AxFolhEJ;AwFllhEI;EACE,4BAAA;EACA,6BAAA;AxFolhEN;;AyFhujEI;EACI,cAAA;AzFmujER;AyFhujEI;EAEI;;;;;;;IAEI,cAAA;IACA,cAAA;EzFsujEV;EyFnujEM;IACI,kBAAA;EzFqujEV;AACF;AyFlujEI;EACI,gCAAA;AzFoujER;AyFlujEQ;EAHJ;IAIQ,oBlF6hBQ;EPwsiElB;AACF;AyFlujEI;EACI,+BAAA;EACA,+BAAA;EACA,6BAAA;EACA,4CJ2E0C;EI1E1C,gBJiD0C;EIhD1C,eAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AzFoujER;AyFlujEQ;EACI;IACI,UAAA;EzFoujEd;AACF;AyFjujEQ;EACI,mBAAA;AzFmujEZ;AyFjujEY;EACI,eAAA;AzFmujEhB;AyFhujEoB;EACI,qBAAA;AzFkujExB;AyF/tjEoB;EAEI,yCAAA;AzFgujExB;AyF3tjEY;EACI,kCAAA;EACA,uBAAA;AzF6tjEhB;AyF3tjEgB;EACI,cAAA;AzF6tjEpB;AyF1tjEgB;EACI,yCAAA;AzF4tjEpB;AyF3tjEoB;EACI,yCAAA;AzF6tjExB;AyF3tjEoB;EACI,yCAAA;EACA,8BAAA;AzF6tjExB;AyFztjEgB;EACI,yCAAA;AzF2tjEpB;AyFztjEoB;EACI,yCAAA;EACA,8BAAA;AzF2tjExB;AyFxtjEoB;EACI,yCAAA;AzF0tjExB;AyFrtjEoB;EACI,yCAAA;EACA,8BAAA;AzFutjExB;AyFjtjEgB;EACI,UAAA;EACA,mCAAA;AzFmtjEpB;AyF9sjEgB;EACI,eAAA;AzFgtjEpB;AyF3sjEQ;EACI,aAAA;AzF6sjEZ;AyFxsjEQ;EACI,kBAAA;AzF0sjEZ;AyFxsjEY;EACI,WAAA;EACA,kCAAA;AzF0sjEhB;AyFtsjEgB;EACI,aAAA;AzFwsjEpB;AyFnsjEgB;EACI,yCAAA;AzFqsjEpB;AyFnsjEoB;EACI,yCAAA;EACA,8BAAA;AzFqsjExB;AyFlsjEoB;EACI,yCAAA;AzFosjExB;AyFhsjEgB;EACI;IACI,cAAA;IACA,uBAAA;EzFksjEtB;AACF;AyF9rjEY;EACI,yCAAA;AzFgsjEhB;AyF3rjEI;EACI,kBAAA;EACA,gBJ5D0C;EI6D1C,iBAAA;EACA,4CJ/D0C;EIgE1C,6BAAA;EACA,wBAAA;EACA,yBAAA;EACA,SAAA;EACA,alF0hCU;EkFzhCV,qCAAA;EACA,4BAAA;EACA,sCAAA;EACA,yClFyoCiB;EkFxoCjB,aAAA;AzF6rjER;AyF3rjEQ;EACI,MAAA;EACA,UAAA;AzF6rjEZ;AyFzrjEI;EACI,YAAA;AzF2rjER;AyFxrjEI;EACI,aAAA;AzF0rjER;AyFvrjEI;EACI,sBAAA;EACA,WAAA;AzFyrjER;AyFtrjEI;EACI;IACI,aAAA;EzFwrjEV;AACF;;AyFlrjEQ;EACI;IACI,cAAA;IACA,iBAAA;IACA,gBAAA;IACA,eAAA;EzFqrjEd;EyFnrjEc;IACI,sBAAA;EzFqrjElB;EyFnrjEkB;IACI,oBJpN0B;ErFy4jEhD;EyFlrjEkB;IACI,qBAAA;EzForjEtB;EyF/qjEU;IACI,kBAAA;IACA,eAAA;IACA,gBAAA;IACA,kBAAA;IACA,OAAA;IACA,eAAA;IACA,cAAA;EzFirjEd;EyF/qjEc;IACI,cAAA;EzFirjElB;EyF7qjEU;IACI,kBAAA;EzF+qjEd;EyF5qjEU;IACI,UAAA;EzF8qjEd;EyF3qjEU;IACI,WAAA;EzF6qjEd;AACF;;AyFnqjEgB;EACI,oCAAA;AzFsqjEpB;AyF9pjEoB;EACI,qCAAA;AzFgqjExB;;A0Fj7jEI;EACI,iBAAA;EACA,YLkH0C;EKjH1C,ULgH0C;ArFo0jElD;A0Fl7jEQ;EACI,sBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,gBnF2pBW;APyxiEvB;A0Fl7jEY;EACI,wBAAA;A1Fo7jEhB;A0Fj7jEY;EACI,aAAA;A1Fm7jEhB;A0F/6jEQ;EACI,0BAAA;A1Fi7jEZ;A0F/6jEY;EAHJ;IAIQ,iBAAA;E1Fk7jEd;AACF;A0Fh7jEY;EACI,aAAA;A1Fk7jEhB;A0F96jEgB;EACI,yBAAA;EACA,uBAAA;A1Fg7jEpB;A0F36jEgB;EACI,yBAAA;EACA,uBAAA;A1F66jEpB;A0Fv6jEoB;EACI,SAAA;A1Fy6jExB;A0Fv6jEwB;EACI,WAAA;EACA,UAAA;A1Fy6jE5B;A0Fl6jEQ;EACI,UAAA;A1Fo6jEZ;A0Fh6jEI;EACI,+BAAA;A1Fk6jER;A0Fh6jEQ;EAHJ;IAIQ,iBL8CsC;ErFq3jEhD;AACF;A0F75jEgB;EACI,cAAA;A1F+5jEpB;A0F55jEgB;EACI,aAAA;A1F85jEpB;A0Fx5jEI;EACI,WL2B0C;EK1B1C,sDAAA;EACA,YAAA;EACA,WAAA;EACA,4CLyB0C;EKxB1C,MAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;A1F05jER;A0Fx5jEQ;EACI,kBAAA;EACA,gBAAA;A1F05jEZ;A0Fx5jEgB;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;A1F05jEpB;A0Fr5jEQ;EACI,WAAA;EACA,YAAA;EACA,yCAAA;EACA,iBAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;A1Fu5jEZ;A0Fr5jEY;EACI,WAAA;EACA,yCAAA;EACA,qCAAA;A1Fu5jEhB;A0Fp5jEY;EACI,wDAAA;EACA,gDAAA;A1Fs5jEhB;A0Fp5jEgB;EACI,gDAAA;EACA,4CAAA;A1Fs5jEpB;A0Fh5jEI;EACI,aAAA;A1Fk5jER;A0F/4jEI;EAGQ;IACI,cAAA;E1F+4jEd;E0F54jEU;IACI,aAAA;E1F84jEd;AACF;A0Fv4jEgB;EACI,aAAA;A1Fy4jEpB;A0Ft4jEgB;EACI,cAAA;A1Fw4jEpB;A0F93jEgB;EACI,cAAA;A1Fg4jEpB;A0F73jEgB;EACI,aAAA;A1F+3jEpB;A0Fx3jEQ;EACI,QAAA;EACA,eAAA;A1F03jEZ;A0Fx3jEY;EAJJ;IAKQ,aAAA;E1F23jEd;AACF;A0Fx3jEQ;;EAEI,aAAA;A1F03jEZ;A0Fv3jEQ;EACI,iBL5FsC;ArFq9jElD;A0Ft3jEQ;;EAEI,ULjGsC;ArFy9jElD;A0Fr3jEQ;EACI;IACI,cAAA;E1Fu3jEd;E0Fp3jEU;;IAEI,OAAA;E1Fs3jEd;AACF;A0F/2jEQ;EAFJ;;IAGQ,ULpHsC;ErFu+jEhD;AACF;A0Fh3jEI;EACI;IACI,cAAA;E1Fk3jEV;E0F/2jEM;;IAEI,OAAA;E1Fi3jEV;AACF;;A0F52jEI;EACI;IACI,OAAA;IACA,iBAAA;E1F+2jEV;E0F52jEM;IACI,yBAAA;E1F82jEV;E0F32jEM;;IAEI,kBAAA;E1F62jEV;AACF;;A2FlnkEI;EACI,yCAAA;A3FqnkER;A2FlnkEI;EACI,uCAAA;EACA,cAAA;EACA,4CpF4lBK;EoF3lBL,mCAAA;A3FonkER;A2FhnkEQ;EACI,iBAAA;A3FknkEZ;A2F9mkEI;;EAEI,uCAAA;EACA,cAAA;EACA,kBAAA;A3FgnkER;A2F1mkEY;EACI;IACI,kBAAA;E3F4mkElB;AACF;A2FxmkEgB;EADJ;IAEQ,cAAA;E3F2mkElB;AACF;A2FvmkEQ;;;EAEI,kBAAA;EACA,gFAAA;A3F0mkEZ;A2FxmkEY;EALJ;;;IAMQ,iDAAA;E3F6mkEd;AACF;A2FtmkEQ;;;EAEI,6EAAA;A3FymkEZ;A2FvmkEY;EAJJ;;;IAKQ,8CAAA;E3F4mkEd;AACF;A2FtmkEQ;;EAEI,gFAAA;A3FwmkEZ;A2FtmkEY;EAJJ;;IAKQ,iDAAA;E3F0mkEd;AACF;A2FnmkEQ;EACI,mCAAA;A3FqmkEZ;A2FlmkEQ;EACI;IACI,iBAAA;IACA,gBAAA;E3FomkEd;E2FjmkEU;IACI,iBAAA;E3FmmkEd;AACF;A2F3lkEY;;;;;EAEI,eAAA;EACA,kBAAA;A3FgmkEhB;;A2FtlkEI;;;EAGI,eAAA;A3FylkER;A2FtlkEI;;EAEI,uCAAA;A3FwlkER;A2FrlkEI;EACI,iCAAA;A3FulkER;A2FhlkEQ;;;;EAEI,kBAAA;A3FolkEZ;;A2F5kkEI;EAEI;;IAEI,kBAAA;E3F8kkEV;AACF;A2F1kkEQ;EAEI;;IAEI,kBAAA;E3F2kkEd;AACF;;A2FlkkEI;EACI;IACI,aAAA;E3FqkkEV;E2FlkkEM;IACI,qBAAA;IACA,WAAA;E3FokkEV;E2FjkkEM;IACI,OAAA;E3FmkkEV;E2FhkkEM;IACI,OAAA;E3FkkkEV;E2F/jkEM;IACI,gBAAA;E3FikkEV;E2F5jkEU;IACI,gBAAA;IACA,iBAAA;E3F8jkEd;E2F1jkEc;IACI,qBAAA;E3F4jkElB;E2FzjkEc;IACI,aAAA;E3F2jkElB;AACF;A2FpjkEQ;EACI,aAAA;A3FsjkEZ;A2FnjkEQ;EACI,qBAAA;A3FqjkEZ;A2FjjkEI;EACI;IACI,aAAA;E3FmjkEV;E2FhjkEM;IACI,qBAAA;IACA,WAAA;E3FkjkEV;E2F/ikEM;IACI,4CAAA;E3FijkEV;E2F9ikEM;IACI,4CAAA;E3FgjkEV;E2F7ikEM;IACI,gBAAA;E3F+ikEV;E2FzikEU;IACI,gBAAA;IACA,iBAAA;E3F2ikEd;E2FvikEc;IACI,qBAAA;E3FyikElB;E2FtikEc;IACI,aAAA;E3FwikElB;AACF;;A4FzykEA;;;;;;uDAAA;AAOC;EACG,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,wCAAA;A5F4ykEJ;;A4F1ykEE;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,8BAAA;EAIA,qJAAA;EAIA,6BAAA;EAIA,uCAAA;EAKA,mCAAA;EACA,oBAAA;A5F6ykEJ;;A4F3ykEE;EACE,oCAAA;EAIA,6KAAA;A5F8ykEJ;;A4F5ykEE;EACE,8BAAA;A5F+ykEJ;;A4F7ykEE;EACE,oCAAA;A5FgzkEJ;;A4F9ykEE;EAIE,2BAAA;A5FizkEJ;;A4F/ykEE;;EAME,wBAAA;EACA,2EAAA;A5FkzkEJ;;A4FhzkEE;;;;EAIE,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,kCAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;A5FmzkEJ;;A4FjzkEE;EACE,qBAAA;EACA,oBAAA;A5FozkEJ;;A4FlzkEE;EACE,SAAA;EACA,qBAAA;A5FqzkEJ;;A4FnzkEE;EACE,oBAAA;EACA,sBAAA;A5FszkEJ;;A4FpzkEE;EACE,UAAA;A5FuzkEJ;;A4FrzkEE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;A5FwzkEJ;;A4FtzkEE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;A5FyzkEJ;;A4FvzkEE;EACE,wBAAA;EAEA,iDAAA;EAIA,qBAAA;A5F0zkEJ;;A4FxzkEE;EAEE,+CAAA;A5F2zkEJ;;A4FzzkEE;EACE,cAAA;A5F4zkEJ;;A4FxzkEI;EACI,0CAAA;A5F2zkER;;A4FtzkEI;EACI,0CAAA;A5FyzkER;;A4FrzkEI;EACI,yCAAA;A5FwzkER;;A4FpzkEI;EACI,yCAAA;A5FuzkER;;A4FnzkEI;EACI,yCAAA;A5FszkER;;A4FlzkEI;EACI,wCAAA;A5FqzkER;;A6Ft9kEA;EACI,cAAA;EACA,aAAA;A7Fy9kEJ;;A6Ft9kEA;EACI,YAAA;EACA,WAAA;A7Fy9kEJ;;A6Ft9kEA;EACI,YAAA;EACA,WAAA;A7Fy9kEJ;;A6Ft9kEA;EACI,cAAA;EACA,aAAA;A7Fy9kEJ;;A6Ft9kEA;EACI,YAAA;EACA,WAAA;A7Fy9kEJ;;A6Ft9kEA;EACI,cAAA;EACA,aAAA;A7Fy9kEJ;;A6Ft9kEA;EACI,mBAAA;EACA,yBtFkSY;EsFjSZ,WAAA;EACA,aAAA;EACA,gBtFkoBiB;EsFjoBjB,YAAA;EACA,uBAAA;EACA,WAAA;A7Fy9kEJ;;A6Fr9kEA;EACI,kBAAA;EACA,aAAA;EACA,eAAA;A7Fw9kEJ;A6Ft9kEI;EACI,kBAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;A7Fw9kER;A6Ft9kEQ;EACI,kBAAA;EACA,2BAAA;EACA,UAAA;A7Fw9kEZ;;A8F/glEI;EACI,gBvFmqBa;AP+2jErB;A8F/glEI;EACI,gCAAA;A9FihlER;A8F5glEY;EACI,WAAA;EACA,iCAAA;A9F8glEhB;A8F1glEgB;EACI,WAAA;A9F4glEpB;;A8FjglEQ;EACI,iCAAA;EACA,oCAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;A9FoglEZ;A8FhglEY;EACI,iCAAA;EACA,aAAA;EACA,kBAAA;A9FkglEhB;;A8Fx/kEQ;EACI,iCAAA;EACA,oCAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;A9F2/kEZ;A8Fv/kEY;EACI,iCAAA;EACA,aAAA;EACA,kBAAA;A9Fy/kEhB;;A8F/+kEI;EACI,qBAAA;A9Fk/kER;A8Fh/kEQ;EACI,kBAAA;EACA,avF22CU;EuF12CV,SAAA;A9Fk/kEZ;A8F9+kEY;EACI,SAAA;A9Fg/kEhB;;A8Fv+kEI;EACI,+DAAA;EACA,sCvF+1CkB;AP2oiE1B;A8Fx+kEQ;EACI,eAAA;A9F0+kEZ;A8Fv+kEQ;EACI,sCvFw1Cc;APipiE1B;A8Fv+kEY;EACI,4BAAA;EACA,6BAAA;A9Fy+kEhB;;A8Fl+kEI;EACI,6CAAA;A9Fq+kER;;A8F59kEQ;EACI,sCAAA;A9F+9kEZ;A8F79kEY;EACI,gBAAA;A9F+9kEhB;A8F79kEgB;EACI,cvF8NL;EuF7NK,qDAAA;A9F+9kEpB;A8F59kEgB;EACI,cvFyNL;APqwkEf;;A8Ft9kEY;EACI,gBAAA;A9Fy9kEhB;A8Fv9kEgB;EACI,WvFpHZ;EuFqHY,oCAAA;A9Fy9kEpB;;A8Fl/kEQ;EACI,sCAAA;A9Fq/kEZ;A8Fn/kEY;EACI,gBAAA;A9Fq/kEhB;A8Fn/kEgB;EACI,cvF8NL;EuF7NK,qDAAA;A9Fq/kEpB;A8Fl/kEgB;EACI,cvFyNL;AP2xkEf;;A8F5+kEY;EACI,gBAAA;A9F++kEhB;A8F7+kEgB;EACI,WvFpHZ;EuFqHY,oCAAA;A9F++kEpB;;A8FxglEQ;EACI,qCAAA;A9F2glEZ;A8FzglEY;EACI,gBAAA;A9F2glEhB;A8FzglEgB;EACI,cvF8NL;EuF7NK,oDAAA;A9F2glEpB;A8FxglEgB;EACI,cvFyNL;APizkEf;;A8FlglEY;EACI,gBAAA;A9FqglEhB;A8FnglEgB;EACI,WvFpHZ;EuFqHY,oCAAA;A9FqglEpB;;A8F9hlEQ;EACI,qCAAA;A9FiilEZ;A8F/hlEY;EACI,gBAAA;A9FiilEhB;A8F/hlEgB;EACI,cvF8NL;EuF7NK,oDAAA;A9FiilEpB;A8F9hlEgB;EACI,cvFyNL;APu0kEf;;A8FxhlEY;EACI,gBAAA;A9F2hlEhB;A8FzhlEgB;EACI,WvFpHZ;EuFqHY,oCAAA;A9F2hlEpB;;A8FpjlEQ;EACI,qCAAA;A9FujlEZ;A8FrjlEY;EACI,gBAAA;A9FujlEhB;A8FrjlEgB;EACI,cvF8NL;EuF7NK,oDAAA;A9FujlEpB;A8FpjlEgB;EACI,cvFyNL;AP61kEf;;A8F9ilEY;EACI,gBAAA;A9FijlEhB;A8F/ilEgB;EACI,WvFpHZ;EuFqHY,oCAAA;A9FijlEpB;;A8F1klEQ;EACI,oCAAA;A9F6klEZ;A8F3klEY;EACI,gBAAA;A9F6klEhB;A8F3klEgB;EACI,cvF8NL;EuF7NK,mDAAA;A9F6klEpB;A8F1klEgB;EACI,cvFyNL;APm3kEf;;A8FpklEY;EACI,gBAAA;A9FuklEhB;A8FrklEgB;EACI,WvFpHZ;EuFqHY,oCAAA;A9FuklEpB;;A8FhmlEQ;EACI,sCAAA;A9FmmlEZ;A8FjmlEY;EACI,gBAAA;A9FmmlEhB;A8FjmlEgB;EACI,cvF8NL;EuF7NK,qDAAA;A9FmmlEpB;A8FhmlEgB;EACI,cvFyNL;APy4kEf;;A8F1llEY;EACI,gBAAA;A9F6llEhB;A8F3llEgB;EACI,WvFpHZ;EuFqHY,oCAAA;A9F6llEpB;;A8FtnlEQ;EACI,mCAAA;A9FynlEZ;A8FvnlEY;EACI,gBAAA;A9FynlEhB;A8FvnlEgB;EACI,cvF8NL;EuF7NK,kDAAA;A9FynlEpB;A8FtnlEgB;EACI,cvFyNL;AP+5kEf;;A8FhnlEY;EACI,gBAAA;A9FmnlEhB;A8FjnlEgB;EACI,WvFpHZ;EuFqHY,oCAAA;A9FmnlEpB;;A8F5olEQ;EACI,sCAAA;A9F+olEZ;A8F7olEY;EACI,gBAAA;A9F+olEhB;A8F7olEgB;EACI,cvF8NL;EuF7NK,qDAAA;A9F+olEpB;A8F5olEgB;EACI,cvFyNL;APq7kEf;;A8FtolEY;EACI,gBAAA;A9FyolEhB;A8FvolEgB;EACI,WvFpHZ;EuFqHY,oCAAA;A9FyolEpB;;A8FlqlEQ;EACI,sCAAA;A9FqqlEZ;A8FnqlEY;EACI,gBAAA;A9FqqlEhB;A8FnqlEgB;EACI,cvF8NL;EuF7NK,qDAAA;A9FqqlEpB;A8FlqlEgB;EACI,cvFyNL;AP28kEf;;A8F5plEY;EACI,gBAAA;A9F+plEhB;A8F7plEgB;EACI,WvFpHZ;EuFqHY,oCAAA;A9F+plEpB;;A8FxrlEQ;EACI,oCAAA;A9F2rlEZ;A8FzrlEY;EACI,gBAAA;A9F2rlEhB;A8FzrlEgB;EACI,cvF8NL;EuF7NK,mDAAA;A9F2rlEpB;A8FxrlEgB;EACI,cvFyNL;APi+kEf;;A8FlrlEY;EACI,gBAAA;A9FqrlEhB;A8FnrlEgB;EACI,WvFpHZ;EuFqHY,oCAAA;A9FqrlEpB;;A8F9slEQ;EACI,sCAAA;A9FitlEZ;A8F/slEY;EACI,gBAAA;A9FitlEhB;A8F/slEgB;EACI,cvF8NL;EuF7NK,qDAAA;A9FitlEpB;A8F9slEgB;EACI,cvFyNL;APu/kEf;;A8FxslEY;EACI,gBAAA;A9F2slEhB;A8FzslEgB;EACI,WvFpHZ;EuFqHY,oCAAA;A9F2slEpB;;A8FpulEQ;EACI,sCAAA;A9FuulEZ;A8FrulEY;EACI,gBAAA;A9FuulEhB;A8FrulEgB;EACI,cvF8NL;EuF7NK,qDAAA;A9FuulEpB;A8FpulEgB;EACI,cvFyNL;AP6glEf;;A8F9tlEY;EACI,gBAAA;A9FiulEhB;A8F/tlEgB;EACI,WvFpHZ;EuFqHY,oCAAA;A9FiulEpB;;A8F1vlEQ;EACI,qCAAA;A9F6vlEZ;A8F3vlEY;EACI,gBAAA;A9F6vlEhB;A8F3vlEgB;EACI,cvF8NL;EuF7NK,oDAAA;A9F6vlEpB;A8F1vlEgB;EACI,cvFyNL;APmilEf;;A8FpvlEY;EACI,gBAAA;A9FuvlEhB;A8FrvlEgB;EACI,WvFpHZ;EuFqHY,oCAAA;A9FuvlEpB;;A8FhxlEQ;EACI,sCAAA;A9FmxlEZ;A8FjxlEY;EACI,gBAAA;A9FmxlEhB;A8FjxlEgB;EACI,cvF8NL;EuF7NK,qDAAA;A9FmxlEpB;A8FhxlEgB;EACI,cvFyNL;APyjlEf;;A8F1wlEY;EACI,gBAAA;A9F6wlEhB;A8F3wlEgB;EACI,WvFpHZ;EuFqHY,oCAAA;A9F6wlEpB;;A8FtylEQ;EACI,sCAAA;A9FyylEZ;A8FvylEY;EACI,gBAAA;A9FyylEhB;A8FvylEgB;EACI,WvF8NL;EuF7NK,qDAAA;A9FyylEpB;A8FtylEgB;EACI,WvFyNL;AP+klEf;;A8FhylEY;EACI,gBAAA;A9FmylEhB;A8FjylEgB;EACI,WvFpHZ;EuFqHY,iCAAA;A9FmylEpB;;A8F5zlEQ;EACI,sCAAA;A9F+zlEZ;A8F7zlEY;EACI,gBAAA;A9F+zlEhB;A8F7zlEgB;EACI,cvF8NL;EuF7NK,qDAAA;A9F+zlEpB;A8F5zlEgB;EACI,cvFyNL;APqmlEf;;A8FtzlEY;EACI,gBAAA;A9FyzlEhB;A8FvzlEgB;EACI,WvFpHZ;EuFqHY,oCAAA;A9FyzlEpB;;A8F/ylEQ;EACI,yBAAA;A9FkzlEZ;;A+Fh9lEI;EACI,+BAAA;A/Fm9lER;;A+Fj9lEI;EACI,mCAAA;A/Fo9lER;;A+Fl9lEI;EACI,sCAAA;A/Fq9lER;;A+Fn9lEI;EACI,qCAAA;A/Fs9lER;;A+Fp9lEI;EACI,oCAAA;A/Fu9lER;;A+Fl9lEQ;EACI,uBAAA;A/Fq9lEZ;A+Fp9lEY;EACI,+BAAA;A/Fs9lEhB;;A+F3+lEI;EACI,+BAAA;A/F8+lER;;A+F5+lEI;EACI,mCAAA;A/F++lER;;A+F7+lEI;EACI,sCAAA;A/Fg/lER;;A+F9+lEI;EACI,qCAAA;A/Fi/lER;;A+F/+lEI;EACI,oCAAA;A/Fk/lER;;A+F7+lEQ;EACI,uBAAA;A/Fg/lEZ;A+F/+lEY;EACI,+BAAA;A/Fi/lEhB;;A+FtgmEI;EACI,+BAAA;A/FygmER;;A+FvgmEI;EACI,mCAAA;A/F0gmER;;A+FxgmEI;EACI,sCAAA;A/F2gmER;;A+FzgmEI;EACI,qCAAA;A/F4gmER;;A+F1gmEI;EACI,oCAAA;A/F6gmER;;A+FxgmEQ;EACI,uBAAA;A/F2gmEZ;A+F1gmEY;EACI,+BAAA;A/F4gmEhB;;A+FjimEI;EACI,+BAAA;A/FoimER;;A+FlimEI;EACI,mCAAA;A/FqimER;;A+FnimEI;EACI,sCAAA;A/FsimER;;A+FpimEI;EACI,qCAAA;A/FuimER;;A+FrimEI;EACI,oCAAA;A/FwimER;;A+FnimEQ;EACI,uBAAA;A/FsimEZ;A+FrimEY;EACI,+BAAA;A/FuimEhB;;A+F5jmEI;EACI,8BAAA;A/F+jmER;;A+F7jmEI;EACI,kCAAA;A/FgkmER;;A+F9jmEI;EACI,qCAAA;A/FikmER;;A+F/jmEI;EACI,oCAAA;A/FkkmER;;A+FhkmEI;EACI,mCAAA;A/FmkmER;;A+F9jmEQ;EACI,uBAAA;A/FikmEZ;A+FhkmEY;EACI,8BAAA;A/FkkmEhB;;A+FvlmEI;EACI,+BAAA;A/F0lmER;;A+FxlmEI;EACI,mCAAA;A/F2lmER;;A+FzlmEI;EACI,sCAAA;A/F4lmER;;A+F1lmEI;EACI,qCAAA;A/F6lmER;;A+F3lmEI;EACI,oCAAA;A/F8lmER;;A+FzlmEQ;EACI,uBAAA;A/F4lmEZ;A+F3lmEY;EACI,+BAAA;A/F6lmEhB;;A+FlnmEI;EACI,8BAAA;A/FqnmER;;A+FnnmEI;EACI,kCAAA;A/FsnmER;;A+FpnmEI;EACI,qCAAA;A/FunmER;;A+FrnmEI;EACI,oCAAA;A/FwnmER;;A+FtnmEI;EACI,mCAAA;A/FynmER;;A+FpnmEQ;EACI,uBAAA;A/FunmEZ;A+FtnmEY;EACI,8BAAA;A/FwnmEhB;;A+FhnmEA;EACI,sCxFunBe;AP4/kEnB;;A+FhnmEA;EACI,qCxFzBoB;AP4omExB;;A+F/mmEA;EACI,2EAAA;A/FknmEJ;;A+F9mmEA;EACI,eAAA;A/FinmEJ;;A+F9mmEA;EACI,eAAA;A/FinmEJ;;A+F9mmEA;EACI,gBAAA;A/FinmEJ;;A+F9mmEA;EACI,gBAAA;A/FinmEJ;;A+F9mmEA;EACI,gBAAA;A/FinmEJ;;A+F7mmEA;EACI,YAAA;EACA,WAAA;A/FgnmEJ;;A+F7mmEA;EACI,YAAA;EACA,WAAA;A/FgnmEJ;;A+F7mmEA;EACI,YAAA;EACA,WAAA;A/FgnmEJ;;A+F7mmEA;EACI,YAAA;EACA,WAAA;A/FgnmEJ;;A+F7mmEA;EACI,YAAA;EACA,WAAA;A/FgnmEJ;;A+F7mmEA;EACI,YAAA;EACA,WAAA;A/FgnmEJ;;A+F5mmEA;EACI,cxF7DO;EwF8DP,+BAAA;A/F+mmEJ;;A+F1mmEI;EACI,cxFwPO;EwFvPP,+BAAA;A/F6mmER;;A+F/mmEI;EACI,cxFwPO;EwFvPP,+BAAA;A/FknmER;;A+FpnmEI;EACI,cxFwPO;EwFvPP,8BAAA;A/FunmER;;A+FznmEI;EACI,cxFwPO;EwFvPP,8BAAA;A/F4nmER;;A+F9nmEI;EACI,cxFwPO;EwFvPP,8BAAA;A/FiomER;;A+FnomEI;EACI,cxFwPO;EwFvPP,6BAAA;A/FsomER;;A+FxomEI;EACI,cxFwPO;EwFvPP,+BAAA;A/F2omER;;A+F7omEI;EACI,cxFwPO;EwFvPP,4BAAA;A/FgpmER;;A+FlpmEI;EACI,cxFwPO;EwFvPP,+BAAA;A/FqpmER;;A+FvpmEI;EACI,cxFwPO;EwFvPP,+BAAA;A/F0pmER;;A+F5pmEI;EACI,cxFwPO;EwFvPP,6BAAA;A/F+pmER;;A+FjqmEI;EACI,cxFwPO;EwFvPP,+BAAA;A/FoqmER;;A+FtqmEI;EACI,cxFwPO;EwFvPP,+BAAA;A/FyqmER;;A+F3qmEI;EACI,cxFwPO;EwFvPP,8BAAA;A/F8qmER;;A+FhrmEI;EACI,cxFwPO;EwFvPP,+BAAA;A/FmrmER;;A+FrrmEI;EACI,WxFwPO;EwFvPP,+BAAA;A/FwrmER;;A+F1rmEI;EACI,cxFwPO;EwFvPP,+BAAA;A/F6rmER;;A+FxrmEA;EACI,kBAAA;A/F2rmEJ;A+F1rmEI;EACI,kBAAA;A/F4rmER;A+F1rmEI;EACI,eAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;A/F4rmER;;A+FrrmEA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,sBxFlGI;AP0xmER;;A+FnrmEA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;A/FsrmEJ;;A+FlrmEA;EACI,wBAAA;UAAA,gBAAA;A/FqrmEJ;;A+FlrmEA;EACI,YAAA;EACA,+BAAA;EACA,oCAAA;EACA,iCAAA;A/FqrmEJ;;A+FhrmEI;EAFJ;IAGQ,aAAA;IACA,0BAAA;IACA,aAAA;IACA,UAAA;IACA,QAAA;IACA,WAAA;IACA,aAAA;E/FormEN;E+FnrmEM;IACI,eAAA;IACA,MAAA;IACA,UAAA;IACA,WAAA;IACA,SAAA;IACA,uCAAA;E/FqrmEV;E+FlrmEM;IACI,eAAA;IACA,YAAA;IACA,iBAAA;E/FormEV;E+FlrmEM;IACI,gBAAA;IACA,+BAAA;E/FormEV;AACF;;A+F/qmEI;EACI;IACI,+BAAA;IACA,eAAA;IACA,uCAAA;E/FkrmEV;AACF;;A+F7qmEI;EACI,iBAAA;A/FgrmER;;A+F3qmEA;EACI,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EACA,mBAAA;A/F8qmEJ;;A+F1qmEA;EACI,yBAAA;A/F6qmEJ;A+F5qmEI;EACI,gCAAA;A/F8qmER;A+F5qmEI;EACI,yBAAA;A/F8qmER;A+F7qmEQ;EACI,cxFnKH;APk1mET;A+F7qmEY;EACI,YAAA;A/F+qmEhB;;A+FzqmEA;EACI,kCAAA;A/F4qmEJ;;A+FzqmEA;EACI,iCAAA;A/F4qmEJ;;A+FzqmEA;EACI,eAAA;EACA,aAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;A/F4qmEJ;A+F3qmEI;EACI,uCAAA;A/F6qmER;;A+FzqmEA;EACE;IACE,wBAAA;IACA,UAAA;E/F4qmEF;E+FzqmEA;IACE,4BAAA;IACA,UAAA;E/F2qmEF;AACF;AgGx7mEA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,wCAAA;EACA,aAAA;AhG07mEJ;;AgGv7mEA;EACI,UAAA;EACA,kBAAA;AhG07mEJ;;AgGv7mEA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;AhG07mEJ;;AiG98mEI;EACI,gBAAA;AjGi9mER;;AkGl9mEI;EACI,+CAAA;EACA,iBAAA;AlGq9mER;AkGn9mEQ;EACI,iBAAA;AlGq9mEZ;;AkG98mEA,aAAA;AAEA;EACI,gBAAA;AlGg9mEJ;AkG98mEI;EACI,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,6CAAA;AlGg9mER;AkG98mEQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,wCAAA;AlGg9mEZ;AkG78mEQ;EACI,yBAAA;AlG+8mEZ;;AkGz8mEA;EACI,kBAAA;AlG48mEJ;AkG18mEI;EACI,gBAAA;EACA,kBAAA;AlG48mER;AkG18mEQ;EAEI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,yCAAA;EACA,SAAA;EACA,wBAAA;EACA,SAAA;EACA,oBAAA;AlG28mEZ;AkGx8mEQ;EACI,UAAA;EACA,UAAA;EACA,oBAAA;AlG08mEZ;AkGp8mEY;EACI,UAAA;AlGs8mEhB;AkGn8mEY;EACI,UAAA;AlGq8mEhB;;AkG37mEQ;EACI,yB3FpBJ;APk9mER;;AkGz7mEA;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,wCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;AlG47mEJ;;AkGt7mEQ;EACI,aAAA;AlGy7mEZ;AkGt7mEQ;EACI,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,wCAAA;EACA,oBAAA;EACA,iBAAA;EACA,c3FwMI;APgvmEhB;AkGr7mEQ;EACI,yB3FoMI;E2FnMJ,qB3FmMI;E2FlMJ,W3F/FJ;APshnER;;AmGtjnEA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;AnGyjnEJ;;AmGrjnEI;EACI,4BAAA;AnGwjnER;;AmGnjnEA;EACI,yBAAA;AnGsjnEJ;AmGpjnEI;EACI,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,sBAAA;AnGsjnER;AmGnjnEI;EACI,kBAAA;EACA,oBAAA;EACA,YAAA;AnGqjnER;AmGljnEI;EACI,gBAAA;AnGojnER;AmGjjnEY;EACI,c5F0RA;E4FzRA,qBAAA;AnGmjnEhB;;AmG1inEQ;EACI,aAAA;AnG6inEZ;AmG1inEgB;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,0CAAA;AnG4inEpB;AmG1inEgB;EACI,YAAA;EACA,wBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;EACA,eAAA;EACA,W5FtCZ;APklnER;;AmGpinEI;EACI,gCAAA;AnGuinER;AmGtinEQ;EACI,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,c5F0OI;AP8zmEhB;;AoG/nnEA;EACI;;;;;;;IAOI,wBAAA;EpGkonEN;;EoGhonEE;;;;;IAKI,UAAA;IACA,SAAA;EpGmonEN;;EoGhonEE;IACI,SAAA;IACA,2BAAA;EpGmonEN;;EoG/nnEM;IACI,wBAAA;EpGkonEV;;EoG9nnEM;IACI,yBAAA;IACA,qBAAA;IACA,0BAAA;EpGionEV;AACF;AqGpqnEA;EACI,kBAAA;EAkMA,eAAA;ArGq+mEJ;AqGrqnEI;EACI,iBAAA;EACA,+CAAA;EACA,W9F2BA;E8F1BA,mB9FupBS;E8FtpBT,gB9F8pBe;E8F7pBf,kBAAA;EACA,UAAA;EACA,QAAA;ArGuqnER;AqGrqnEQ;EACI,4BAAA;ArGuqnEZ;AqGpqnEQ;EACI,qBAAA;ArGsqnEZ;AqGpqnEY;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;EACA,8BAAA;ArGsqnEhB;AqGnqnEY;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,8BAAA;ArGqqnEhB;AqG7pnEQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;ArG+pnEZ;AqGzpnEI;EACI,gBAAA;ArG2pnER;AqGzpnEQ;EACI,yBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;ArG2pnEZ;AqGxpnEY;EACI,iBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;ArG0pnEhB;AqGnpnEQ;EACI,kBAAA;EACA,UAAA;EACA,QAAA;ArGqpnEZ;AqGnpnEY;EACI,4BAAA;ArGqpnEhB;AqGlpnEY;EACI,iBAAA;ArGopnEhB;AqGlpnEgB;EAEI,WAAA;EACA,WAAA;EACA,8BAAA;ArGmpnEpB;AqG7onEY;EACI,UAAA;EACA,WAAA;ArG+onEhB;AqG3onEQ;EACI,WAAA;EACA,UAAA;ArG6onEZ;AqGzonEY;EACI,wBAAA;EACA,YAAA;EACA,UAAA;ArG2onEhB;AqGtonEY;EACI,UAAA;EACA,WAAA;ArGwonEhB;AqGtonEgB;EACI,UAAA;EACA,YAAA;EACA,wBAAA;ArGwonEpB;AqGjonEI;EACI,WAAA;ArGmonER;AqG9nnEQ;EACI,mBAAA;ArGgonEZ;AqG9nnEY;EACI,6CAAA;ArGgonEhB;AqG5nnEgB;EACI,0BAAA;EACA,yBAAA;ArG8nnEpB;AqG3nnEgB;EACI,0BAAA;EACA,4BAAA;ArG6nnEpB;AqGvnnEY;EACI,mBAAA;ArGynnEhB;AqGtnnEoB;EACI,2BAAA;EACA,yBAAA;ArGwnnExB;AqGrnnEoB;EACI,2BAAA;EACA,4BAAA;ArGunnExB;AqGvpnEQ;EACI,mBAAA;ArGypnEZ;AqGvpnEY;EACI,6CAAA;ArGypnEhB;AqGrpnEgB;EACI,0BAAA;EACA,yBAAA;ArGupnEpB;AqGppnEgB;EACI,0BAAA;EACA,4BAAA;ArGspnEpB;AqGhpnEY;EACI,mBAAA;ArGkpnEhB;AqG/onEoB;EACI,2BAAA;EACA,yBAAA;ArGipnExB;AqG9onEoB;EACI,2BAAA;EACA,4BAAA;ArGgpnExB;AqGhrnEQ;EACI,mBAAA;ArGkrnEZ;AqGhrnEY;EACI,6CAAA;ArGkrnEhB;AqG9qnEgB;EACI,0BAAA;EACA,yBAAA;ArGgrnEpB;AqG7qnEgB;EACI,0BAAA;EACA,4BAAA;ArG+qnEpB;AqGzqnEY;EACI,mBAAA;ArG2qnEhB;AqGxqnEoB;EACI,2BAAA;EACA,yBAAA;ArG0qnExB;AqGvqnEoB;EACI,2BAAA;EACA,4BAAA;ArGyqnExB;AqGzsnEQ;EACI,mBAAA;ArG2snEZ;AqGzsnEY;EACI,6CAAA;ArG2snEhB;AqGvsnEgB;EACI,0BAAA;EACA,yBAAA;ArGysnEpB;AqGtsnEgB;EACI,0BAAA;EACA,4BAAA;ArGwsnEpB;AqGlsnEY;EACI,mBAAA;ArGosnEhB;AqGjsnEoB;EACI,2BAAA;EACA,yBAAA;ArGmsnExB;AqGhsnEoB;EACI,2BAAA;EACA,4BAAA;ArGksnExB;AqGlunEQ;EACI,mBAAA;ArGounEZ;AqGlunEY;EACI,6CAAA;ArGounEhB;AqGhunEgB;EACI,0BAAA;EACA,yBAAA;ArGkunEpB;AqG/tnEgB;EACI,0BAAA;EACA,4BAAA;ArGiunEpB;AqG3tnEY;EACI,mBAAA;ArG6tnEhB;AqG1tnEoB;EACI,2BAAA;EACA,yBAAA;ArG4tnExB;AqGztnEoB;EACI,2BAAA;EACA,4BAAA;ArG2tnExB;AqG3vnEQ;EACI,mBAAA;ArG6vnEZ;AqG3vnEY;EACI,6CAAA;ArG6vnEhB;AqGzvnEgB;EACI,0BAAA;EACA,yBAAA;ArG2vnEpB;AqGxvnEgB;EACI,0BAAA;EACA,4BAAA;ArG0vnEpB;AqGpvnEY;EACI,mBAAA;ArGsvnEhB;AqGnvnEoB;EACI,2BAAA;EACA,yBAAA;ArGqvnExB;AqGlvnEoB;EACI,2BAAA;EACA,4BAAA;ArGovnExB;AqGpxnEQ;EACI,mBAAA;ArGsxnEZ;AqGpxnEY;EACI,6CAAA;ArGsxnEhB;AqGlxnEgB;EACI,0BAAA;EACA,yBAAA;ArGoxnEpB;AqGjxnEgB;EACI,0BAAA;EACA,4BAAA;ArGmxnEpB;AqG7wnEY;EACI,mBAAA;ArG+wnEhB;AqG5wnEoB;EACI,2BAAA;EACA,yBAAA;ArG8wnExB;AqG3wnEoB;EACI,2BAAA;EACA,4BAAA;ArG6wnExB;AqG7ynEQ;EACI,mBAAA;ArG+ynEZ;AqG7ynEY;EACI,6CAAA;ArG+ynEhB;AqG3ynEgB;EACI,0BAAA;EACA,yBAAA;ArG6ynEpB;AqG1ynEgB;EACI,0BAAA;EACA,4BAAA;ArG4ynEpB;AqGtynEY;EACI,mBAAA;ArGwynEhB;AqGrynEoB;EACI,2BAAA;EACA,yBAAA;ArGuynExB;AqGpynEoB;EACI,2BAAA;EACA,4BAAA;ArGsynExB;AqGt0nEQ;EACI,mBAAA;ArGw0nEZ;AqGt0nEY;EACI,6CAAA;ArGw0nEhB;AqGp0nEgB;EACI,0BAAA;EACA,yBAAA;ArGs0nEpB;AqGn0nEgB;EACI,0BAAA;EACA,4BAAA;ArGq0nEpB;AqG/znEY;EACI,mBAAA;ArGi0nEhB;AqG9znEoB;EACI,2BAAA;EACA,yBAAA;ArGg0nExB;AqG7znEoB;EACI,2BAAA;EACA,4BAAA;ArG+znExB;AqG/1nEQ;EACI,mBAAA;ArGi2nEZ;AqG/1nEY;EACI,6CAAA;ArGi2nEhB;AqG71nEgB;EACI,0BAAA;EACA,yBAAA;ArG+1nEpB;AqG51nEgB;EACI,0BAAA;EACA,4BAAA;ArG81nEpB;AqGx1nEY;EACI,mBAAA;ArG01nEhB;AqGv1nEoB;EACI,2BAAA;EACA,yBAAA;ArGy1nExB;AqGt1nEoB;EACI,2BAAA;EACA,4BAAA;ArGw1nExB;AqGx3nEQ;EACI,mBAAA;ArG03nEZ;AqGx3nEY;EACI,6CAAA;ArG03nEhB;AqGt3nEgB;EACI,0BAAA;EACA,yBAAA;ArGw3nEpB;AqGr3nEgB;EACI,0BAAA;EACA,4BAAA;ArGu3nEpB;AqGj3nEY;EACI,mBAAA;ArGm3nEhB;AqGh3nEoB;EACI,2BAAA;EACA,yBAAA;ArGk3nExB;AqG/2nEoB;EACI,2BAAA;EACA,4BAAA;ArGi3nExB;AqGj5nEQ;EACI,mBAAA;ArGm5nEZ;AqGj5nEY;EACI,6CAAA;ArGm5nEhB;AqG/4nEgB;EACI,0BAAA;EACA,yBAAA;ArGi5nEpB;AqG94nEgB;EACI,0BAAA;EACA,4BAAA;ArGg5nEpB;AqG14nEY;EACI,mBAAA;ArG44nEhB;AqGz4nEoB;EACI,2BAAA;EACA,yBAAA;ArG24nExB;AqGx4nEoB;EACI,2BAAA;EACA,4BAAA;ArG04nExB;AqG16nEQ;EACI,mBAAA;ArG46nEZ;AqG16nEY;EACI,6CAAA;ArG46nEhB;AqGx6nEgB;EACI,0BAAA;EACA,yBAAA;ArG06nEpB;AqGv6nEgB;EACI,0BAAA;EACA,4BAAA;ArGy6nEpB;AqGn6nEY;EACI,mBAAA;ArGq6nEhB;AqGl6nEoB;EACI,2BAAA;EACA,yBAAA;ArGo6nExB;AqGj6nEoB;EACI,2BAAA;EACA,4BAAA;ArGm6nExB;AqGn8nEQ;EACI,mBAAA;ArGq8nEZ;AqGn8nEY;EACI,6CAAA;ArGq8nEhB;AqGj8nEgB;EACI,0BAAA;EACA,yBAAA;ArGm8nEpB;AqGh8nEgB;EACI,0BAAA;EACA,4BAAA;ArGk8nEpB;AqG57nEY;EACI,mBAAA;ArG87nEhB;AqG37nEoB;EACI,2BAAA;EACA,yBAAA;ArG67nExB;AqG17nEoB;EACI,2BAAA;EACA,4BAAA;ArG47nExB;AqG59nEQ;EACI,mBAAA;ArG89nEZ;AqG59nEY;EACI,6CAAA;ArG89nEhB;AqG19nEgB;EACI,0BAAA;EACA,yBAAA;ArG49nEpB;AqGz9nEgB;EACI,0BAAA;EACA,4BAAA;ArG29nEpB;AqGr9nEY;EACI,mBAAA;ArGu9nEhB;AqGp9nEoB;EACI,2BAAA;EACA,yBAAA;ArGs9nExB;AqGn9nEoB;EACI,2BAAA;EACA,4BAAA;ArGq9nExB;AqGr/nEQ;EACI,gBAAA;ArGu/nEZ;AqGr/nEY;EACI,6CAAA;ArGu/nEhB;AqGn/nEgB;EACI,uBAAA;EACA,sBAAA;ArGq/nEpB;AqGl/nEgB;EACI,uBAAA;EACA,yBAAA;ArGo/nEpB;AqG9+nEY;EACI,gBAAA;ArGg/nEhB;AqG7+nEoB;EACI,wBAAA;EACA,sBAAA;ArG++nExB;AqG5+nEoB;EACI,wBAAA;EACA,yBAAA;ArG8+nExB;AqG9goEQ;EACI,mBAAA;ArGghoEZ;AqG9goEY;EACI,6CAAA;ArGghoEhB;AqG5goEgB;EACI,0BAAA;EACA,yBAAA;ArG8goEpB;AqG3goEgB;EACI,0BAAA;EACA,4BAAA;ArG6goEpB;AqGvgoEY;EACI,mBAAA;ArGygoEhB;AqGtgoEoB;EACI,2BAAA;EACA,yBAAA;ArGwgoExB;AqGrgoEoB;EACI,2BAAA;EACA,4BAAA;ArGugoExB;AqG7/nEI;EACI,gBAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;ArG+/nER;AqG1/nEI;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;ArG4/nER;AqG1/nEQ;EACI,eAAA;EACA,W9F/KJ;E8FgLI,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,wEAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gB9F4cW;APgjnEvB;AqG1/nEY;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,mCAAA;EACA,oCAAA;ArG4/nEhB;AqGz/nEY;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,kCAAA;EACA,oCAAA;ArG2/nEhB;AqGl/nEY;EACI,mBAAA;ArGo/nEhB;AqGl/nEgB;EACI,8BAAA;EACA,6BAAA;ArGo/nEpB;AqGj/nEgB;EACI,+BAAA;EACA,6BAAA;ArGm/nEpB;AqG7/nEY;EACI,mBAAA;ArG+/nEhB;AqG7/nEgB;EACI,8BAAA;EACA,6BAAA;ArG+/nEpB;AqG5/nEgB;EACI,+BAAA;EACA,6BAAA;ArG8/nEpB;AqGxgoEY;EACI,mBAAA;ArG0goEhB;AqGxgoEgB;EACI,8BAAA;EACA,6BAAA;ArG0goEpB;AqGvgoEgB;EACI,+BAAA;EACA,6BAAA;ArGygoEpB;AqGnhoEY;EACI,mBAAA;ArGqhoEhB;AqGnhoEgB;EACI,8BAAA;EACA,6BAAA;ArGqhoEpB;AqGlhoEgB;EACI,+BAAA;EACA,6BAAA;ArGohoEpB;AqG9hoEY;EACI,mBAAA;ArGgioEhB;AqG9hoEgB;EACI,8BAAA;EACA,6BAAA;ArGgioEpB;AqG7hoEgB;EACI,+BAAA;EACA,6BAAA;ArG+hoEpB;AqGzioEY;EACI,mBAAA;ArG2ioEhB;AqGzioEgB;EACI,8BAAA;EACA,6BAAA;ArG2ioEpB;AqGxioEgB;EACI,+BAAA;EACA,6BAAA;ArG0ioEpB;AqGpjoEY;EACI,mBAAA;ArGsjoEhB;AqGpjoEgB;EACI,8BAAA;EACA,6BAAA;ArGsjoEpB;AqGnjoEgB;EACI,+BAAA;EACA,6BAAA;ArGqjoEpB;AqG/joEY;EACI,mBAAA;ArGikoEhB;AqG/joEgB;EACI,8BAAA;EACA,6BAAA;ArGikoEpB;AqG9joEgB;EACI,+BAAA;EACA,6BAAA;ArGgkoEpB;AqG1koEY;EACI,mBAAA;ArG4koEhB;AqG1koEgB;EACI,8BAAA;EACA,6BAAA;ArG4koEpB;AqGzkoEgB;EACI,+BAAA;EACA,6BAAA;ArG2koEpB;AqGrloEY;EACI,mBAAA;ArGuloEhB;AqGrloEgB;EACI,8BAAA;EACA,6BAAA;ArGuloEpB;AqGploEgB;EACI,+BAAA;EACA,6BAAA;ArGsloEpB;AqGhmoEY;EACI,mBAAA;ArGkmoEhB;AqGhmoEgB;EACI,8BAAA;EACA,6BAAA;ArGkmoEpB;AqG/loEgB;EACI,+BAAA;EACA,6BAAA;ArGimoEpB;AqG3moEY;EACI,mBAAA;ArG6moEhB;AqG3moEgB;EACI,8BAAA;EACA,6BAAA;ArG6moEpB;AqG1moEgB;EACI,+BAAA;EACA,6BAAA;ArG4moEpB;AqGtnoEY;EACI,mBAAA;ArGwnoEhB;AqGtnoEgB;EACI,8BAAA;EACA,6BAAA;ArGwnoEpB;AqGrnoEgB;EACI,+BAAA;EACA,6BAAA;ArGunoEpB;AqGjooEY;EACI,mBAAA;ArGmooEhB;AqGjooEgB;EACI,8BAAA;EACA,6BAAA;ArGmooEpB;AqGhooEgB;EACI,+BAAA;EACA,6BAAA;ArGkooEpB;AqG5ooEY;EACI,mBAAA;ArG8ooEhB;AqG5ooEgB;EACI,8BAAA;EACA,6BAAA;ArG8ooEpB;AqG3ooEgB;EACI,+BAAA;EACA,6BAAA;ArG6ooEpB;AqGvpoEY;EACI,gBAAA;ArGypoEhB;AqGvpoEgB;EACI,8BAAA;EACA,6BAAA;ArGypoEpB;AqGtpoEgB;EACI,+BAAA;EACA,6BAAA;ArGwpoEpB;AqGlqoEY;EACI,mBAAA;ArGoqoEhB;AqGlqoEgB;EACI,8BAAA;EACA,6BAAA;ArGoqoEpB;AqGjqoEgB;EACI,+BAAA;EACA,6BAAA;ArGmqoEpB;;AqGxpoEQ;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;ArG2poEZ;;AqGtpoEA;EACI,kBAAA;EACA,WAAA;EACA,UAAA;ArGypoEJ;AqGvpoEI;EACI,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,W9F5PA;E8F6PA,eAAA;EACA,cAAA;EACA,sBAAA;EACA,4BAAA;EACA,WAAA;ArGypoER;AqGvpoEQ;EAEI,kBAAA;EACA,WAAA;ArGwpoEZ;AqGrpoEQ;EACI,WAAA;EACA,UAAA;EACA,UAAA;EACA,MAAA;ArGupoEZ;AqGppoEQ;EACI,WAAA;EACA,UAAA;EACA,UAAA;EACA,MAAA;EACA,0BAAA;ArGspoEZ;AqGlpoEI;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,sBAAA;ArGopoER;;AqG5ooEQ;EACI,mBAAA;ArG+ooEZ;AqG7ooEY;EACI,mBAAA;ArG+ooEhB;AqG5ooEY;EACI,mBAAA;ArG8ooEhB;AqG1ooEQ;EACI,yBAAA;ArG4ooEZ;;AqGzpoEQ;EACI,mBAAA;ArG4poEZ;AqG1poEY;EACI,mBAAA;ArG4poEhB;AqGzpoEY;EACI,mBAAA;ArG2poEhB;AqGvpoEQ;EACI,yBAAA;ArGypoEZ;;AqGtqoEQ;EACI,mBAAA;ArGyqoEZ;AqGvqoEY;EACI,mBAAA;ArGyqoEhB;AqGtqoEY;EACI,mBAAA;ArGwqoEhB;AqGpqoEQ;EACI,yBAAA;ArGsqoEZ;;AqGnroEQ;EACI,mBAAA;ArGsroEZ;AqGproEY;EACI,mBAAA;ArGsroEhB;AqGnroEY;EACI,mBAAA;ArGqroEhB;AqGjroEQ;EACI,yBAAA;ArGmroEZ;;AqGhsoEQ;EACI,mBAAA;ArGmsoEZ;AqGjsoEY;EACI,mBAAA;ArGmsoEhB;AqGhsoEY;EACI,mBAAA;ArGksoEhB;AqG9roEQ;EACI,yBAAA;ArGgsoEZ;;AqG7soEQ;EACI,mBAAA;ArGgtoEZ;AqG9soEY;EACI,mBAAA;ArGgtoEhB;AqG7soEY;EACI,mBAAA;ArG+soEhB;AqG3soEQ;EACI,yBAAA;ArG6soEZ;;AqG1toEQ;EACI,mBAAA;ArG6toEZ;AqG3toEY;EACI,mBAAA;ArG6toEhB;AqG1toEY;EACI,mBAAA;ArG4toEhB;AqGxtoEQ;EACI,yBAAA;ArG0toEZ;;AqGvuoEQ;EACI,mBAAA;ArG0uoEZ;AqGxuoEY;EACI,mBAAA;ArG0uoEhB;AqGvuoEY;EACI,mBAAA;ArGyuoEhB;AqGruoEQ;EACI,yBAAA;ArGuuoEZ;;AqGpvoEQ;EACI,mBAAA;ArGuvoEZ;AqGrvoEY;EACI,mBAAA;ArGuvoEhB;AqGpvoEY;EACI,mBAAA;ArGsvoEhB;AqGlvoEQ;EACI,yBAAA;ArGovoEZ;;AqGjwoEQ;EACI,mBAAA;ArGowoEZ;AqGlwoEY;EACI,mBAAA;ArGowoEhB;AqGjwoEY;EACI,mBAAA;ArGmwoEhB;AqG/voEQ;EACI,yBAAA;ArGiwoEZ;;AqG9woEQ;EACI,mBAAA;ArGixoEZ;AqG/woEY;EACI,mBAAA;ArGixoEhB;AqG9woEY;EACI,mBAAA;ArGgxoEhB;AqG5woEQ;EACI,yBAAA;ArG8woEZ;;AqG3xoEQ;EACI,mBAAA;ArG8xoEZ;AqG5xoEY;EACI,mBAAA;ArG8xoEhB;AqG3xoEY;EACI,mBAAA;ArG6xoEhB;AqGzxoEQ;EACI,yBAAA;ArG2xoEZ;;AqGxyoEQ;EACI,mBAAA;ArG2yoEZ;AqGzyoEY;EACI,mBAAA;ArG2yoEhB;AqGxyoEY;EACI,mBAAA;ArG0yoEhB;AqGtyoEQ;EACI,yBAAA;ArGwyoEZ;;AqGrzoEQ;EACI,mBAAA;ArGwzoEZ;AqGtzoEY;EACI,mBAAA;ArGwzoEhB;AqGrzoEY;EACI,mBAAA;ArGuzoEhB;AqGnzoEQ;EACI,yBAAA;ArGqzoEZ;;AqGl0oEQ;EACI,mBAAA;ArGq0oEZ;AqGn0oEY;EACI,mBAAA;ArGq0oEhB;AqGl0oEY;EACI,mBAAA;ArGo0oEhB;AqGh0oEQ;EACI,yBAAA;ArGk0oEZ;;AqG/0oEQ;EACI,gBAAA;ArGk1oEZ;AqGh1oEY;EACI,gBAAA;ArGk1oEhB;AqG/0oEY;EACI,mBAAA;ArGi1oEhB;AqG70oEQ;EACI,sBAAA;ArG+0oEZ;;AqG51oEQ;EACI,mBAAA;ArG+1oEZ;AqG71oEY;EACI,mBAAA;ArG+1oEhB;AqG51oEY;EACI,mBAAA;ArG81oEhB;AqG11oEQ;EACI,yBAAA;ArG41oEZ;;AqGr1oEI;EACI,4BAAA;EACA,yBAAA;ArGw1oER;AqGt1oEQ;EACI,yBAAA;EACA,UAAA;ArGw1oEZ;AqGn1oEQ;EACI,wBAAA;ArGq1oEZ;AqGn1oEY;EACI,UAAA;ArGq1oEhB;AqGh1oEQ;EACI,2BAAA;EACA,yBAAA;ArGk1oEZ;AqGh1oEY;EACI,yBAAA;EACA,UAAA;ArGk1oEhB;AqG70oEY;EACI,wBAAA;ArG+0oEhB;AqG70oEgB;EACI,UAAA;ArG+0oEpB;;AsG5spEI;EACE,sB/F8hDY;APirmElB;;AsG1spEI;EACI,c/FwVO;E+FvVP,gCAAA;AtG6spER;;AsG/spEI;EACI,c/FwVO;E+FvVP,gCAAA;AtGktpER;;AsGptpEI;EACI,c/FwVO;E+FvVP,gCAAA;AtGutpER;;AsGztpEI;EACI,c/FwVO;E+FvVP,gCAAA;AtG4tpER;;AsG9tpEI;EACI,c/FwVO;E+FvVP,gCAAA;AtGiupER;;AsGnupEI;EACI,c/FwVO;E+FvVP,gCAAA;AtGsupER;;AsGxupEI;EACI,c/FwVO;E+FvVP,gCAAA;AtG2upER;;AsG7upEI;EACI,c/FwVO;E+FvVP,gCAAA;AtGgvpER;;AsGlvpEI;EACI,c/FwVO;E+FvVP,gCAAA;AtGqvpER;;AsGvvpEI;EACI,c/FwVO;E+FvVP,gCAAA;AtG0vpER;;AsG5vpEI;EACI,c/FwVO;E+FvVP,gCAAA;AtG+vpER;;AsGjwpEI;EACI,c/FwVO;E+FvVP,gCAAA;AtGowpER;;AsGtwpEI;EACI,c/FwVO;E+FvVP,gCAAA;AtGywpER;;AsG3wpEI;EACI,c/FwVO;E+FvVP,gCAAA;AtG8wpER;;AsGhxpEI;EACI,c/FwVO;E+FvVP,gCAAA;AtGmxpER;;AsGrxpEI;EACI,W/FwVO;E+FvVP,6BAAA;AtGwxpER;;AsG1xpEI;EACI,c/FwVO;E+FvVP,gCAAA;AtG6xpER;;AuGvypEA;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AvG0ypEF;;AuGvypEA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;AvG0ypEF;;AwGzzpEA;EAGI,0BAAA;EACA,0BAAA;EAGA,+BAAA;EACA,kCAAA;EACA,iCAAA;EAGA,oBAAA;EACA,2BAAA;EACA,+BAAA;EACA,8CAAA;EACA,mCAAA;EACA,8BAAA;EACA,iCAAA;EACA,4BAAA;EAGA,4DAAA;EACA,mCAAA;EAeA,oBAAA;EACA,+BAAA;EACA,sCAAA;EAGA,qCAAA;EACA,gEAAA;EAGA,+BAAA;EACA,2BAAA;EAGA,yBAAA;EAGA,oBAAA;EACA,0BAAA;EAGI,0BAAA;EACA,iCAAA;AxG4xpER;AwG7zpEI;EACI,uBAAA;EACA,iDAAA;EACA,4BAAA;EACA,mCAAA;EACA,4BAAA;EACA,gDAAA;EACA,8BAAA;EACA,2BAAA;AxG+zpER;;AwGjypEI;EACI,2BAAA;EACA,+BAAA;EACA,sCAAA;EACA,qDAAA;EACA,4CAAA;EACA,6CAAA;EACA,4DAAA;EACA,0CAAA;EACA,gDAAA;EACA,iDAAA;EACA,uCAAA;EACA,+DAAA;EACA,wEAAA;AxGoypER;AwGlypEQ;EAEI,8BAAA;EACA,kCAAA;EACA,sCAAA;EACA,qDAAA;EACA,yCAAA;EACA,0CAAA;EACA,4DAAA;EACA,0CAAA;EACA,6CAAA;EACA,8CAAA;EACA,uCAAA;EACA,wCAAA;EACA,+DAAA;EACA,wEAAA;AxGmypEZ;;AwG3xpEQ;EACI,uDAAA;EACA,qDAAA;EACA,yCAAA;EACA,0CAAA;EACA,4DAAA;EACA,2DAAA;EACA,6CAAA;EACA,8CAAA;EACA,wDAAA;EACA,+DAAA;EACA,wEAAA;AxG8xpEZ;AwG1xpEQ;EACI,sFAAA;EACA,4CAAA;EACA,kDAAA;AxG4xpEZ;AwGzxpEQ;EACI,qFAAA;EACA,8CAAA;EACA,+CAAA;AxG2xpEZ;AwGxxpEQ;EACI,mFAAA;EACA,4CAAA;EACA,+CAAA;AxG0xpEZ;AwGtxpEQ;EACI,4EAAA;EACA,4CAAA;EACA,wCAAA;AxGwxpEZ;;AYp5pEI;E4FoII,mBAAA;EACA,0BAAA;EACA,iCAAA;EACA,6BAAA;EACA,iCAAA;EAEA,kBAAA;EACA,yBAAA;EACA,gCAAA;EACA,4BAAA;EACA,gCAAA;EAGA,yBAAA;EACA,2BAAA;EAGA,uBAAA;EACA,0BAAA;EAGA,uBAAA;EACA,+BAAA;EACA,mCAAA;EAEA,4DAAA;EACA,4BAAA;EAGA,gEAAA;EAGA,2BAAA;EA0CA,6BAAA;EACA,iCAAA;AxG+tpER;AwGxwpEQ;EACI,uBAAA;EACA,8BAAA;EACA,+CAAA;EACA,sCAAA;EACA,+BAAA;EACA,qCAAA;EACA,8BAAA;EACA,oCAAA;EACA,6BAAA;AxG0wpEZ;AwGvwpEQ;;EAEI,uBAAA;EACA,2BAAA;EACA,0BAAA;AxGywpEZ;AwGtwpEQ;;EAEI,oBAAA;AxGwwpEZ;AwGrwpEQ;EACI,2BAAA;EACA,0BAAA;AxGuwpEZ;AwGpwpEQ;EACI,yBAAA;EACA,iCAAA;EACA,uCAAA;EACA,oCAAA;EACA,+BAAA;EACA,wCAAA;EACA,qCAAA;AxGswpEZ;;AYh9pEI;E4FuNI,uBAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EACA,mCAAA;EACA,4BAAA;EACA,8BAAA;EACA,8BAAA;AxG6vpER;AwG1vpEQ;EACI,uBAAA;EACA,2BAAA;EACA,iDAAA;EACA,4BAAA;EACA,oDAAA;EACA,4BAAA;EACA,gDAAA;EACA,8BAAA;AxG4vpEZ;;AYr+pEI;E4FmPI,2BAAA;EACA,+BAAA;EACA,sCAAA;EACA,qDAAA;EACA,4CAAA;EACA,6CAAA;EACA,4DAAA;EACA,0CAAA;EACA,gDAAA;EACA,iDAAA;EACA,uCAAA;AxGsvpER;AwGpvpEQ;EAEI,8BAAA;EACA,kCAAA;EACA,sCAAA;EACA,qDAAA;EACA,yCAAA;EACA,0CAAA;EACA,4DAAA;EACA,0CAAA;EACA,6CAAA;EACA,8CAAA;EACA,uCAAA;EACA,wCAAA;AxGqvpEZ;;AyG5gqEA;EACI,kBAAA;EACA,gBAAA;AzG+gqEJ;;AyG5gqEA;;;;;;;;;;;;EAYI,qClGLoB;APohqExB;;AyG5gqEA;EACI,gBlGgpBiB;EkG/oBjB,qBlG+5BuB;APgnoE3B;;AyG7gqEA;;EAEE,gBlG4oBqB;APo4oEvB;;AyG3gqEA;EACI,kBAAA;EACA,6CAAA;AzG8gqEJ;;AyG3gqEA;EACI,cAAA;EACA,8CAAA;EACA,iBAAA;AzG8gqEJ;;AyGngqEI;EANJ;;;;;;IAOQ,iBAAA;EzG4gqEN;AACF;;AyGxgqEA;EACI,kBAAA;AzG2gqEJ;;A0GlkqEA;EACI,kBAAA;EACA,kBAAA;EACA,SAAA;A1GqkqEJ;A0GnkqEI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,2CAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A1GqkqER;A0GjkqEI;EACI,gBAAA;A1GmkqER;A0GjkqEY;EACI,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,0BnGsSA;EmGrSA,YAAA;A1GmkqEhB;;A0G1jqEA;EACI,sBAAA;A1G6jqEJ;;A0GxjqEA;EACI,wCAAA;EACA,oCAAA;EACA,qBAAA;EACA,2BAAA;A1G2jqEJ;;A0GtjqEA;EACI,UAAA;A1GyjqEJ;A0GvjqEI;EACI,oBAAA;A1GyjqER;A0GvjqEI;EACI,oBAAA;EACA,kDnGwjDc;EmGvjDd,mDnGujDc;EmGtjDd,iFAAA;A1GyjqER;;A0GljqEI;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,4BAAA;A1GqjqER;;A0G3iqEQ;EACI,oCAAA;A1G8iqEZ;;A0GxiqEQ;EACI,mCAAA;A1G2iqEZ;;A0GliqEY;EACI,mCAAA;EACA,WAAA;A1GqiqEhB;;A0G5hqEY;EACI,WAAA;EACA,mCAAA;A1G+hqEhB;A0G9hqEgB;EACI,+CAAA;A1GgiqEpB;;A0GxhqEY;EACI,wBAAA;A1G2hqEhB;;A0GlhqEY;EACI,mCAAA;EACA,WAAA;A1GqhqEhB;;A0GzkqEQ;EACI,sCAAA;A1G4kqEZ;;A0GtkqEQ;EACI,qCAAA;A1GykqEZ;;A0GhkqEY;EACI,qCAAA;EACA,WAAA;A1GmkqEhB;;A0G1jqEY;EACI,WAAA;EACA,qCAAA;A1G6jqEhB;A0G5jqEgB;EACI,iDAAA;A1G8jqEpB;;A0GtjqEY;EACI,0BAAA;A1GyjqEhB;;A0GhjqEY;EACI,qCAAA;EACA,WAAA;A1GmjqEhB;;A0GvmqEQ;EACI,oCAAA;A1G0mqEZ;;A0GpmqEQ;EACI,mCAAA;A1GumqEZ;;A0G9lqEY;EACI,mCAAA;EACA,WAAA;A1GimqEhB;;A0GxlqEY;EACI,WAAA;EACA,mCAAA;A1G2lqEhB;A0G1lqEgB;EACI,+CAAA;A1G4lqEpB;;A0GplqEY;EACI,wBAAA;A1GulqEhB;;A0G9kqEY;EACI,mCAAA;EACA,WAAA;A1GilqEhB;;A0GroqEQ;EACI,iCAAA;A1GwoqEZ;;A0GloqEQ;EACI,gCAAA;A1GqoqEZ;;A0G5nqEY;EACI,gCAAA;EACA,WAAA;A1G+nqEhB;;A0GtnqEY;EACI,WAAA;EACA,gCAAA;A1GynqEhB;A0GxnqEgB;EACI,4CAAA;A1G0nqEpB;;A0GlnqEY;EACI,qBAAA;A1GqnqEhB;;A0G5mqEY;EACI,gCAAA;EACA,WAAA;A1G+mqEhB;;A0GnqqEQ;EACI,oCAAA;A1GsqqEZ;;A0GhqqEQ;EACI,mCAAA;A1GmqqEZ;;A0G1pqEY;EACI,mCAAA;EACA,WAAA;A1G6pqEhB;;A0GppqEY;EACI,WAAA;EACA,mCAAA;A1GupqEhB;A0GtpqEgB;EACI,+CAAA;A1GwpqEpB;;A0GhpqEY;EACI,wBAAA;A1GmpqEhB;;A0G1oqEY;EACI,mCAAA;EACA,WAAA;A1G6oqEhB;;A0GjsqEQ;EACI,mCAAA;A1GosqEZ;;A0G9rqEQ;EACI,kCAAA;A1GisqEZ;;A0GxrqEY;EACI,kCAAA;EACA,WAAA;A1G2rqEhB;;A0GlrqEY;EACI,WAAA;EACA,kCAAA;A1GqrqEhB;A0GprqEgB;EACI,8CAAA;A1GsrqEpB;;A0G9qqEY;EACI,uBAAA;A1GirqEhB;;A0GxqqEY;EACI,kCAAA;EACA,WAAA;A1G2qqEhB;;A0G/tqEQ;EACI,kCAAA;A1GkuqEZ;;A0G5tqEQ;EACI,iCAAA;A1G+tqEZ;;A0GttqEY;EACI,iCAAA;EACA,WAAA;A1GytqEhB;;A0GhtqEY;EACI,WAAA;EACA,iCAAA;A1GmtqEhB;A0GltqEgB;EACI,6CAAA;A1GotqEpB;;A0G5sqEY;EACI,sBAAA;A1G+sqEhB;;A0GtsqEY;EACI,iCAAA;EACA,WAAA;A1GysqEhB;;A0G7vqEQ;EACI,iCAAA;A1GgwqEZ;;A0G1vqEQ;EACI,gCAAA;A1G6vqEZ;;A0GpvqEY;EACI,gCAAA;EACA,WAAA;A1GuvqEhB;;A0G9uqEY;EACI,WAAA;EACA,gCAAA;A1GivqEhB;A0GhvqEgB;EACI,4CAAA;A1GkvqEpB;;A0G1uqEY;EACI,qBAAA;A1G6uqEhB;;A0GpuqEY;EACI,gCAAA;EACA,WAAA;A1GuuqEhB;;A0G3xqEQ;EACI,2CAAA;A1G8xqEZ;;A0GxxqEQ;EACI,0CAAA;A1G2xqEZ;;A0GlxqEY;EACI,0CAAA;EACA,WAAA;A1GqxqEhB;;A0G5wqEY;EACI,WAAA;EACA,0CAAA;A1G+wqEhB;A0G9wqEgB;EACI,sDAAA;A1GgxqEpB;;A0GxwqEY;EACI,+BAAA;A1G2wqEhB;;A0GlwqEY;EACI,0CAAA;EACA,WAAA;A1GqwqEhB;;A0GzzqEQ;EACI,iDAAA;A1G4zqEZ;;A0GtzqEQ;EACI,gDAAA;A1GyzqEZ;;A0GhzqEY;EACI,gDAAA;EACA,WAAA;A1GmzqEhB;;A0G1yqEY;EACI,WAAA;EACA,gDAAA;A1G6yqEhB;A0G5yqEgB;EACI,4DAAA;A1G8yqEpB;;A0GtyqEY;EACI,qCAAA;A1GyyqEhB;;A0GhyqEY;EACI,gDAAA;EACA,WAAA;A1GmyqEhB;;A0Gv1qEQ;EACI,wCAAA;A1G01qEZ;;A0Gp1qEQ;EACI,uCAAA;A1Gu1qEZ;;A0G90qEY;EACI,uCAAA;EACA,WAAA;A1Gi1qEhB;;A0Gx0qEY;EACI,WAAA;EACA,uCAAA;A1G20qEhB;A0G10qEgB;EACI,mDAAA;A1G40qEpB;;A0Gp0qEY;EACI,4BAAA;A1Gu0qEhB;;A0G9zqEY;EACI,uCAAA;EACA,WAAA;A1Gi0qEhB;;A0Gr3qEQ;EACI,mCAAA;A1Gw3qEZ;;A0Gl3qEQ;EACI,kCAAA;A1Gq3qEZ;;A0G52qEY;EACI,kCAAA;EACA,WAAA;A1G+2qEhB;;A0Gt2qEY;EACI,WAAA;EACA,kCAAA;A1Gy2qEhB;A0Gx2qEgB;EACI,8CAAA;A1G02qEpB;;A0Gl2qEY;EACI,uBAAA;A1Gq2qEhB;;A0G51qEY;EACI,kCAAA;EACA,WAAA;A1G+1qEhB;;A0Gn5qEQ;EACI,wCAAA;A1Gs5qEZ;;A0Gh5qEQ;EACI,uCAAA;A1Gm5qEZ;;A0G14qEY;EACI,uCAAA;EACA,WAAA;A1G64qEhB;;A0Gp4qEY;EACI,WAAA;EACA,uCAAA;A1Gu4qEhB;A0Gt4qEgB;EACI,mDAAA;A1Gw4qEpB;;A0Gh4qEY;EACI,4BAAA;A1Gm4qEhB;;A0G13qEY;EACI,uCAAA;EACA,WAAA;A1G63qEhB;;A0Gj7qEQ;EACI,+CAAA;A1Go7qEZ;;A0G96qEQ;EACI,8CAAA;A1Gi7qEZ;;A0Gx6qEY;EACI,8CAAA;EACA,WAAA;A1G26qEhB;;A0Gl6qEY;EACI,WAAA;EACA,8CAAA;A1Gq6qEhB;A0Gp6qEgB;EACI,0DAAA;A1Gs6qEpB;;A0G95qEY;EACI,mCAAA;A1Gi6qEhB;;A0Gx5qEY;EACI,8CAAA;EACA,WAAA;A1G25qEhB;;A0G/8qEQ;EACI,8CAAA;A1Gk9qEZ;;A0G58qEQ;EACI,6CAAA;A1G+8qEZ;;A0Gt8qEY;EACI,6CAAA;EACA,WAAA;A1Gy8qEhB;;A0Gh8qEY;EACI,WAAA;EACA,6CAAA;A1Gm8qEhB;A0Gl8qEgB;EACI,yDAAA;A1Go8qEpB;;A0G57qEY;EACI,kCAAA;A1G+7qEhB;;A0Gt7qEY;EACI,6CAAA;EACA,WAAA;A1Gy7qEhB;;A0G7+qEQ;EACI,kCAAA;A1Gg/qEZ;;A0G1+qEQ;EACI,iCAAA;A1G6+qEZ;;A0Gp+qEY;EACI,iCAAA;EACA,WAAA;A1Gu+qEhB;;A0G99qEY;EACI,WAAA;EACA,iCAAA;A1Gi+qEhB;A0Gh+qEgB;EACI,6CAAA;A1Gk+qEpB;;A0G19qEY;EACI,sBAAA;A1G69qEhB;;A0Gp9qEY;EACI,iCAAA;EACA,WAAA;A1Gu9qEhB;;A0G3grEQ;EACI,uCAAA;A1G8grEZ;;A0GxgrEQ;EACI,sCAAA;A1G2grEZ;;A0GlgrEY;EACI,sCAAA;EACA,WAAA;A1GqgrEhB;;A0G5/qEY;EACI,WAAA;EACA,sCAAA;A1G+/qEhB;A0G9/qEgB;EACI,kDAAA;A1GggrEpB;;A0Gx/qEY;EACI,2BAAA;A1G2/qEhB;;A0Gl/qEY;EACI,sCAAA;EACA,WAAA;A1Gq/qEhB;;A0G/+qEI;EACI,kCAAA;A1Gk/qER;A0Gj/qEQ;EACI,kCAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,+CAAA;A1Gm/qEZ;;A2G1orEA;EACI,iBAAA;A3G6orEJ;;A2GtorEY;EACI,2BpGyVD;APgzqEf;;A2G1orEY;EACI,2BpGyVD;APozqEf;;A2G9orEY;EACI,2BpGyVD;APwzqEf;;A2GlprEY;EACI,2BpGyVD;AP4zqEf;;A2GtprEY;EACI,2BpGyVD;APg0qEf;;A2G1prEY;EACI,2BpGyVD;APo0qEf;;A2G9prEY;EACI,2BpGyVD;APw0qEf;;A2GlqrEY;EACI,2BpGyVD;AP40qEf;;A2GtqrEY;EACI,2BpGyVD;APg1qEf;;A2G1qrEY;EACI,2BpGyVD;APo1qEf;;A2G9qrEY;EACI,2BpGyVD;APw1qEf;;A2GlrrEY;EACI,2BpGyVD;AP41qEf;;A2GtrrEY;EACI,2BpGyVD;APg2qEf;;A2G1rrEY;EACI,2BpGyVD;APo2qEf;;A2G9rrEY;EACI,2BpGyVD;APw2qEf;;A2GlsrEY;EACI,wBpGyVD;AP42qEf;;A2GtsrEY;EACI,2BpGyVD;APg3qEf;;A2GlsrEA;EACI,sBAAA;A3GqsrEJ;;A2GjsrEA;EACI,gBAAA;EACA,kBAAA;A3GosrEJ;A2GnsrEI;EACI,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,2BpGsSQ;EoGrSR,WAAA;EACA,MAAA;A3GqsrER;;A2GrrrEI;EACI,6DAXI;A3GmsrEZ;;A2GzrrEI;EACI,6DAXI;A3GusrEZ;;A2G7rrEI;EACI,6DAXI;A3G2srEZ;;A2GjsrEI;EACI,6DAXI;A3G+srEZ;;A2GrsrEI;EACI,6DAXI;A3GmtrEZ;;A2GzsrEI;EACI,6DAXI;A3GutrEZ;;A2G7srEI;EACI,6DAXI;A3G2trEZ;;A4G/vrEA;;EAEI,wBAAA;EACA,kBAAA;A5GkwrEJ;;A4G/vrEA;EACI,gBrGimBa;APiqqEjB;;A4G/vrEA;EACI,yBAAA;A5GkwrEJ;;A4G/vrEA;EACI,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gCAAA;EACA,+BAAA;EACA,UAAA;A5GkwrEJ;A4GhwrEI;EACI,sBAAA;A5GkwrER;A4G/vrEI;EACI,kCAAA;EACA,iCAAA;A5GiwrER;A4G9vrEI;EACI,kCAAA;EACA,iCAAA;A5GgwrER;;A4GtvrEI;EACI,8BAAA;EACA,wCAAA;EACA,kDAAA;EACA,4DAAA;EACA,gDAAA;EACA,mDAAA;EACA,6DAAA;A5GyvrER;;A4GnurEI;EACI,iCAAA;EACA,wBAAA;EACA,wCAAA;EACA,oCAAA;EACA,8CAAA;EACA,gDAAA;EACA,qCAAA;EACA,+CAAA;A5GsurER;;A4GlurEI;EACI,iCAAA;EACA,wCAAA;EACA,kCAAA;EACA,oCAAA;EACA,wCAAA;EACA,gDAAA;EACA,qCAAA;EACA,yCAAA;A5GqurER;;A4GjurEI;EACI,iCAAA;EACA,wBAAA;EACA,kCAAA;EACA,uCAAA;EACA,8CAAA;EACA,wCAAA;EACA,gDAAA;EACA,wCAAA;EACA,+CAAA;EACA,yCAAA;A5GourER;;A4GnyrEI;EACI,gCAAA;EACA,0CAAA;EACA,oDAAA;EACA,8DAAA;EACA,kDAAA;EACA,qDAAA;EACA,+DAAA;A5GsyrER;;A4GhxrEI;EACI,mCAAA;EACA,wBAAA;EACA,0CAAA;EACA,sCAAA;EACA,gDAAA;EACA,kDAAA;EACA,uCAAA;EACA,iDAAA;A5GmxrER;;A4G/wrEI;EACI,mCAAA;EACA,0CAAA;EACA,kCAAA;EACA,sCAAA;EACA,wCAAA;EACA,kDAAA;EACA,uCAAA;EACA,yCAAA;A5GkxrER;;A4G9wrEI;EACI,mCAAA;EACA,wBAAA;EACA,kCAAA;EACA,yCAAA;EACA,gDAAA;EACA,wCAAA;EACA,kDAAA;EACA,0CAAA;EACA,iDAAA;EACA,yCAAA;A5GixrER;;A4Gh1rEI;EACI,8BAAA;EACA,wCAAA;EACA,kDAAA;EACA,4DAAA;EACA,gDAAA;EACA,mDAAA;EACA,6DAAA;A5Gm1rER;;A4G7zrEI;EACI,iCAAA;EACA,wBAAA;EACA,wCAAA;EACA,oCAAA;EACA,8CAAA;EACA,gDAAA;EACA,qCAAA;EACA,+CAAA;A5Gg0rER;;A4G5zrEI;EACI,iCAAA;EACA,wCAAA;EACA,kCAAA;EACA,oCAAA;EACA,wCAAA;EACA,gDAAA;EACA,qCAAA;EACA,yCAAA;A5G+zrER;;A4G3zrEI;EACI,iCAAA;EACA,wBAAA;EACA,kCAAA;EACA,uCAAA;EACA,8CAAA;EACA,wCAAA;EACA,gDAAA;EACA,wCAAA;EACA,+CAAA;EACA,yCAAA;A5G8zrER;;A4G73rEI;EACI,2BAAA;EACA,qCAAA;EACA,+CAAA;EACA,yDAAA;EACA,6CAAA;EACA,gDAAA;EACA,0DAAA;A5Gg4rER;;A4G12rEI;EACI,8BAAA;EACA,wBAAA;EACA,qCAAA;EACA,iCAAA;EACA,2CAAA;EACA,6CAAA;EACA,kCAAA;EACA,4CAAA;A5G62rER;;A4Gz2rEI;EACI,8BAAA;EACA,qCAAA;EACA,kCAAA;EACA,iCAAA;EACA,wCAAA;EACA,6CAAA;EACA,kCAAA;EACA,yCAAA;A5G42rER;;A4Gx2rEI;EACI,8BAAA;EACA,wBAAA;EACA,kCAAA;EACA,oCAAA;EACA,2CAAA;EACA,wCAAA;EACA,6CAAA;EACA,qCAAA;EACA,4CAAA;EACA,yCAAA;A5G22rER;;A4G16rEI;EACI,8BAAA;EACA,wCAAA;EACA,kDAAA;EACA,4DAAA;EACA,gDAAA;EACA,mDAAA;EACA,6DAAA;A5G66rER;;A4Gv5rEI;EACI,iCAAA;EACA,wBAAA;EACA,wCAAA;EACA,oCAAA;EACA,8CAAA;EACA,gDAAA;EACA,qCAAA;EACA,+CAAA;A5G05rER;;A4Gt5rEI;EACI,iCAAA;EACA,wCAAA;EACA,kCAAA;EACA,oCAAA;EACA,wCAAA;EACA,gDAAA;EACA,qCAAA;EACA,yCAAA;A5Gy5rER;;A4Gr5rEI;EACI,iCAAA;EACA,wBAAA;EACA,kCAAA;EACA,uCAAA;EACA,8CAAA;EACA,wCAAA;EACA,gDAAA;EACA,wCAAA;EACA,+CAAA;EACA,yCAAA;A5Gw5rER;;A4Gv9rEI;EACI,6BAAA;EACA,uCAAA;EACA,iDAAA;EACA,2DAAA;EACA,+CAAA;EACA,kDAAA;EACA,4DAAA;A5G09rER;;A4Gp8rEI;EACI,gCAAA;EACA,wBAAA;EACA,uCAAA;EACA,mCAAA;EACA,6CAAA;EACA,+CAAA;EACA,oCAAA;EACA,8CAAA;A5Gu8rER;;A4Gn8rEI;EACI,gCAAA;EACA,uCAAA;EACA,kCAAA;EACA,mCAAA;EACA,wCAAA;EACA,+CAAA;EACA,oCAAA;EACA,yCAAA;A5Gs8rER;;A4Gl8rEI;EACI,gCAAA;EACA,wBAAA;EACA,kCAAA;EACA,sCAAA;EACA,6CAAA;EACA,wCAAA;EACA,+CAAA;EACA,uCAAA;EACA,8CAAA;EACA,yCAAA;A5Gq8rER;;A4GpgsEI;EACI,4BAAA;EACA,sCAAA;EACA,gDAAA;EACA,0DAAA;EACA,8CAAA;EACA,iDAAA;EACA,2DAAA;A5GugsER;;A4Gj/rEI;EACI,+BAAA;EACA,wBAAA;EACA,sCAAA;EACA,kCAAA;EACA,4CAAA;EACA,8CAAA;EACA,mCAAA;EACA,6CAAA;A5Go/rER;;A4Gh/rEI;EACI,+BAAA;EACA,sCAAA;EACA,kCAAA;EACA,kCAAA;EACA,wCAAA;EACA,8CAAA;EACA,mCAAA;EACA,yCAAA;A5Gm/rER;;A4G/+rEI;EACI,+BAAA;EACA,wBAAA;EACA,kCAAA;EACA,qCAAA;EACA,4CAAA;EACA,wCAAA;EACA,8CAAA;EACA,sCAAA;EACA,6CAAA;EACA,yCAAA;A5Gk/rER;;A4GjjsEI;EACI,2BAAA;EACA,qCAAA;EACA,+CAAA;EACA,yDAAA;EACA,6CAAA;EACA,gDAAA;EACA,0DAAA;A5GojsER;;A4G9hsEI;EACI,8BAAA;EACA,wBAAA;EACA,qCAAA;EACA,iCAAA;EACA,2CAAA;EACA,6CAAA;EACA,kCAAA;EACA,4CAAA;A5GiisER;;A4G7hsEI;EACI,8BAAA;EACA,qCAAA;EACA,kCAAA;EACA,iCAAA;EACA,wCAAA;EACA,6CAAA;EACA,kCAAA;EACA,yCAAA;A5GgisER;;A4G5hsEI;EACI,8BAAA;EACA,wBAAA;EACA,kCAAA;EACA,oCAAA;EACA,2CAAA;EACA,wCAAA;EACA,6CAAA;EACA,qCAAA;EACA,4CAAA;EACA,yCAAA;A5G+hsER;;A4G9lsEI;EACI,qCAAA;EACA,+CAAA;EACA,yDAAA;EACA,mEAAA;EACA,uDAAA;EACA,0DAAA;EACA,oEAAA;A5GimsER;;A4G7lsEQ;EACE,iDAAA;EACA,2DAAA;EACA,oCAAA;EACA,kDAAA;EACA,sDAAA;A5GgmsEV;;A4GnlsEI;EACI,wCAAA;EACA,wBAAA;EACA,+CAAA;EACA,2CAAA;EACA,qDAAA;EACA,uDAAA;EACA,4CAAA;EACA,sDAAA;A5GslsER;;A4GllsEI;EACI,wCAAA;EACA,+CAAA;EACA,kCAAA;EACA,2CAAA;EACA,wCAAA;EACA,uDAAA;EACA,4CAAA;EACA,yCAAA;A5GqlsER;;A4GjlsEI;EACI,wCAAA;EACA,wBAAA;EACA,kCAAA;EACA,8CAAA;EACA,qDAAA;EACA,wCAAA;EACA,uDAAA;EACA,+CAAA;EACA,sDAAA;EACA,yCAAA;A5GolsER;;A4GnpsEI;EACI,2CAAA;EACA,qDAAA;EACA,+DAAA;EACA,yEAAA;EACA,6DAAA;EACA,gEAAA;EACA,0EAAA;A5GspsER;;A4GhosEI;EACI,8CAAA;EACA,wBAAA;EACA,qDAAA;EACA,iDAAA;EACA,2DAAA;EACA,6DAAA;EACA,kDAAA;EACA,4DAAA;A5GmosER;;A4G/nsEI;EACI,8CAAA;EACA,qDAAA;EACA,kCAAA;EACA,iDAAA;EACA,wCAAA;EACA,6DAAA;EACA,kDAAA;EACA,yCAAA;A5GkosER;;A4G9nsEI;EACI,8CAAA;EACA,wBAAA;EACA,kCAAA;EACA,oDAAA;EACA,2DAAA;EACA,wCAAA;EACA,6DAAA;EACA,qDAAA;EACA,4DAAA;EACA,yCAAA;A5GiosER;;A4GhssEI;EACI,kCAAA;EACA,4CAAA;EACA,sDAAA;EACA,gEAAA;EACA,oDAAA;EACA,uDAAA;EACA,iEAAA;A5GmssER;;A4G7qsEI;EACI,qCAAA;EACA,wBAAA;EACA,4CAAA;EACA,wCAAA;EACA,kDAAA;EACA,oDAAA;EACA,yCAAA;EACA,mDAAA;A5GgrsER;;A4G5qsEI;EACI,qCAAA;EACA,4CAAA;EACA,kCAAA;EACA,wCAAA;EACA,wCAAA;EACA,oDAAA;EACA,yCAAA;EACA,yCAAA;A5G+qsER;;A4G3qsEI;EACI,qCAAA;EACA,wBAAA;EACA,kCAAA;EACA,2CAAA;EACA,kDAAA;EACA,wCAAA;EACA,oDAAA;EACA,4CAAA;EACA,mDAAA;EACA,yCAAA;A5G8qsER;;A4G7usEI;EACI,6BAAA;EACA,uCAAA;EACA,iDAAA;EACA,2DAAA;EACA,+CAAA;EACA,kDAAA;EACA,4DAAA;A5GgvsER;;A4G1tsEI;EACI,gCAAA;EACA,wBAAA;EACA,uCAAA;EACA,mCAAA;EACA,6CAAA;EACA,+CAAA;EACA,oCAAA;EACA,8CAAA;A5G6tsER;;A4GztsEI;EACI,gCAAA;EACA,uCAAA;EACA,kCAAA;EACA,mCAAA;EACA,wCAAA;EACA,+CAAA;EACA,oCAAA;EACA,yCAAA;A5G4tsER;;A4GxtsEI;EACI,gCAAA;EACA,wBAAA;EACA,kCAAA;EACA,sCAAA;EACA,6CAAA;EACA,wCAAA;EACA,+CAAA;EACA,uCAAA;EACA,8CAAA;EACA,yCAAA;A5G2tsER;;A4G1xsEI;EACI,kCAAA;EACA,4CAAA;EACA,sDAAA;EACA,gEAAA;EACA,oDAAA;EACA,uDAAA;EACA,iEAAA;A5G6xsER;;A4G9wsEQ;EACE,8CAAA;EACA,0DAAA;EACA,oCAAA;A5GixsEV;;A4G7wsEI;EACI,qCAAA;EACA,wBAAA;EACA,4CAAA;EACA,wCAAA;EACA,kDAAA;EACA,oDAAA;EACA,yCAAA;EACA,mDAAA;A5GgxsER;;A4G5wsEI;EACI,qCAAA;EACA,4CAAA;EACA,kCAAA;EACA,wCAAA;EACA,wCAAA;EACA,oDAAA;EACA,yCAAA;EACA,yCAAA;A5G+wsER;;A4G3wsEI;EACI,qCAAA;EACA,wBAAA;EACA,kCAAA;EACA,2CAAA;EACA,kDAAA;EACA,wCAAA;EACA,oDAAA;EACA,4CAAA;EACA,mDAAA;EACA,yCAAA;A5G8wsER;;A4G70sEI;EACI,yCAAA;EACA,mDAAA;EACA,6DAAA;EACA,uEAAA;EACA,2DAAA;EACA,8DAAA;EACA,wEAAA;A5Gg1sER;;A4G1zsEI;EACI,4CAAA;EACA,wBAAA;EACA,mDAAA;EACA,+CAAA;EACA,yDAAA;EACA,2DAAA;EACA,gDAAA;EACA,0DAAA;A5G6zsER;;A4GzzsEI;EACI,4CAAA;EACA,mDAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,2DAAA;EACA,gDAAA;EACA,yCAAA;A5G4zsER;;A4GxzsEI;EACI,4CAAA;EACA,wBAAA;EACA,kCAAA;EACA,kDAAA;EACA,yDAAA;EACA,wCAAA;EACA,2DAAA;EACA,mDAAA;EACA,0DAAA;EACA,yCAAA;A5G2zsER;;A4G13sEI;EACI,wCAAA;EACA,kDAAA;EACA,4DAAA;EACA,sEAAA;EACA,0DAAA;EACA,6DAAA;EACA,uEAAA;A5G63sER;;A4Gv2sEI;EACI,2CAAA;EACA,wBAAA;EACA,kDAAA;EACA,8CAAA;EACA,wDAAA;EACA,0DAAA;EACA,+CAAA;EACA,yDAAA;A5G02sER;;A4Gt2sEI;EACI,2CAAA;EACA,kDAAA;EACA,kCAAA;EACA,8CAAA;EACA,wCAAA;EACA,0DAAA;EACA,+CAAA;EACA,yCAAA;A5Gy2sER;;A4Gr2sEI;EACI,2CAAA;EACA,wBAAA;EACA,kCAAA;EACA,iDAAA;EACA,wDAAA;EACA,wCAAA;EACA,0DAAA;EACA,kDAAA;EACA,yDAAA;EACA,yCAAA;A5Gw2sER;;A4Gv6sEI;EACI,4BAAA;EACA,sCAAA;EACA,gDAAA;EACA,0DAAA;EACA,8CAAA;EACA,iDAAA;EACA,2DAAA;A5G06sER;;A4Gp5sEI;EACI,+BAAA;EACA,wBAAA;EACA,sCAAA;EACA,kCAAA;EACA,4CAAA;EACA,8CAAA;EACA,mCAAA;EACA,6CAAA;A5Gu5sER;;A4Gn5sEI;EACI,+BAAA;EACA,sCAAA;EACA,kCAAA;EACA,kCAAA;EACA,wCAAA;EACA,8CAAA;EACA,mCAAA;EACA,yCAAA;A5Gs5sER;;A4Gl5sEI;EACI,+BAAA;EACA,wBAAA;EACA,kCAAA;EACA,qCAAA;EACA,4CAAA;EACA,wCAAA;EACA,8CAAA;EACA,sCAAA;EACA,6CAAA;EACA,yCAAA;A5Gq5sER;;A4Gp9sEI;EACI,iCAAA;EACA,2CAAA;EACA,qDAAA;EACA,+DAAA;EACA,mDAAA;EACA,sDAAA;EACA,gEAAA;A5Gu9sER;;A4Gj8sEI;EACI,oCAAA;EACA,wBAAA;EACA,2CAAA;EACA,uCAAA;EACA,iDAAA;EACA,mDAAA;EACA,wCAAA;EACA,kDAAA;A5Go8sER;;A4Gh8sEI;EACI,oCAAA;EACA,2CAAA;EACA,kCAAA;EACA,uCAAA;EACA,wCAAA;EACA,mDAAA;EACA,wCAAA;EACA,yCAAA;A5Gm8sER;;A4G/7sEI;EACI,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,0CAAA;EACA,iDAAA;EACA,wCAAA;EACA,mDAAA;EACA,2CAAA;EACA,kDAAA;EACA,yCAAA;A5Gk8sER;;A4G77sEA;EACI,kBAAA;EACA,kBAAA;A5Gg8sEJ;A4G97sEI;EACI,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,sCAAA;EACA,yCAAA;EACA,0CAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A5Gg8sER;A4G57sEQ;EACI,wCAAA;A5G87sEZ;A4G17sEI;EACI,oBrGytBc;EqGxtBd,mBAAA;A5G47sER;A4G17sEQ;EACI,wCAAA;EACA,UAAA;A5G47sEZ;;A4Gr7sEA;EACI,gBAAA;EACA,oDAAA;EACA,wDAAA;A5Gw7sEJ;A4Gt7sEI;EACI,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,iCAAA;EACA,sBAAA;EACA,wCAAA;EACA,wDAAA;A5Gw7sER;A4Gr7sEI;EACI,cAAA;EACA,wCAAA;EACA,wDAAA;A5Gu7sER;A4Gn7sEQ;EACI,UAAA;EACA,+BAAA;A5Gq7sEZ;A4Gl7sEQ;EACI,UAAA;EACA,kCAAA;A5Go7sEZ;;A4G76sEI;EACI,yBrGsKO;EqGrKP,gCAAA;A5Gg7sER;A4G96sEQ;EACI,crGkKG;EqGjKH,0CAAA;A5Gg7sEZ;;A4Gt7sEI;EACI,yBrGsKO;EqGrKP,gCAAA;A5Gy7sER;A4Gv7sEQ;EACI,crGkKG;EqGjKH,0CAAA;A5Gy7sEZ;;A4G/7sEI;EACI,yBrGsKO;EqGrKP,gCAAA;A5Gk8sER;A4Gh8sEQ;EACI,crGkKG;EqGjKH,yCAAA;A5Gk8sEZ;;A4Gx8sEI;EACI,yBrGsKO;EqGrKP,gCAAA;A5G28sER;A4Gz8sEQ;EACI,crGkKG;EqGjKH,yCAAA;A5G28sEZ;;A4Gj9sEI;EACI,yBrGsKO;EqGrKP,gCAAA;A5Go9sER;A4Gl9sEQ;EACI,crGkKG;EqGjKH,yCAAA;A5Go9sEZ;;A4G19sEI;EACI,yBrGsKO;EqGrKP,gCAAA;A5G69sER;A4G39sEQ;EACI,crGkKG;EqGjKH,wCAAA;A5G69sEZ;;A4Gn+sEI;EACI,yBrGsKO;EqGrKP,gCAAA;A5Gs+sER;A4Gp+sEQ;EACI,crGkKG;EqGjKH,0CAAA;A5Gs+sEZ;;A4G5+sEI;EACI,yBrGsKO;EqGrKP,gCAAA;A5G++sER;A4G7+sEQ;EACI,crGkKG;EqGjKH,uCAAA;A5G++sEZ;;A4Gr/sEI;EACI,yBrGsKO;EqGrKP,gCAAA;A5Gw/sER;A4Gt/sEQ;EACI,crGkKG;EqGjKH,0CAAA;A5Gw/sEZ;;A4G9/sEI;EACI,yBrGsKO;EqGrKP,gCAAA;A5GigtER;A4G//sEQ;EACI,crGkKG;EqGjKH,0CAAA;A5GigtEZ;;A4GvgtEI;EACI,yBrGsKO;EqGrKP,gCAAA;A5G0gtER;A4GxgtEQ;EACI,crGkKG;EqGjKH,wCAAA;A5G0gtEZ;;A4GhhtEI;EACI,yBrGsKO;EqGrKP,gCAAA;A5GmhtER;A4GjhtEQ;EACI,crGkKG;EqGjKH,0CAAA;A5GmhtEZ;;A4GzhtEI;EACI,yBrGsKO;EqGrKP,gCAAA;A5G4htER;A4G1htEQ;EACI,crGkKG;EqGjKH,0CAAA;A5G4htEZ;;A4GlitEI;EACI,yBrGsKO;EqGrKP,gCAAA;A5GqitER;A4GnitEQ;EACI,crGkKG;EqGjKH,yCAAA;A5GqitEZ;;A4G3itEI;EACI,yBrGsKO;EqGrKP,gCAAA;A5G8itER;A4G5itEQ;EACI,crGkKG;EqGjKH,0CAAA;A5G8itEZ;;A4GpjtEI;EACI,sBrGsKO;EqGrKP,6BAAA;A5GujtER;A4GrjtEQ;EACI,WrGkKG;EqGjKH,0CAAA;A5GujtEZ;;A4G7jtEI;EACI,yBrGsKO;EqGrKP,gCAAA;A5GgktER;A4G9jtEQ;EACI,crGkKG;EqGjKH,0CAAA;A5GgktEZ;;A4GljtEI;EACI,gBAAA;A5GqjtER;;A4G/itEI;EACI,YAAA;A5GkjtER;A4G/itEI;;;;;EAKI,yCAAA;EACA,crGzJD;AP0stEP;;A4G3itEI;;EAEI,YAAA;EACA,WAAA;A5G8itER;;A4GritEQ;EACI,gCAAA;A5GwitEZ;;A4GpitEI;EACI,2BAAA;EACA,0BAAA;A5GuitER;;A4G9itEQ;EACI,gCAAA;A5GijtEZ;;A4G7itEI;EACI,2BAAA;EACA,0BAAA;A5GgjtER;;A4GvjtEQ;EACI,gCAAA;A5G0jtEZ;;A4GtjtEI;EACI,2BAAA;EACA,0BAAA;A5GyjtER;;A4GhktEQ;EACI,gCAAA;A5GmktEZ;;A4G/jtEI;EACI,2BAAA;EACA,0BAAA;A5GkktER;;A4GzktEQ;EACI,gCAAA;A5G4ktEZ;;A4GxktEI;EACI,2BAAA;EACA,0BAAA;A5G2ktER;;A4GlltEQ;EACI,gCAAA;A5GqltEZ;;A4GjltEI;EACI,2BAAA;EACA,0BAAA;A5GoltER;;A4G3ltEQ;EACI,gCAAA;A5G8ltEZ;;A4G1ltEI;EACI,2BAAA;EACA,0BAAA;A5G6ltER;;A4GpmtEQ;EACI,gCAAA;A5GumtEZ;;A4GnmtEI;EACI,2BAAA;EACA,0BAAA;A5GsmtER;;A4G7mtEQ;EACI,gCAAA;A5GgntEZ;;A4G5mtEI;EACI,2BAAA;EACA,0BAAA;A5G+mtER;;A4GtntEQ;EACI,gCAAA;A5GyntEZ;;A4GrntEI;EACI,2BAAA;EACA,0BAAA;A5GwntER;;A4G/ntEQ;EACI,gCAAA;A5GkotEZ;;A4G9ntEI;EACI,2BAAA;EACA,0BAAA;A5GiotER;;A4GxotEQ;EACI,gCAAA;A5G2otEZ;;A4GvotEI;EACI,2BAAA;EACA,0BAAA;A5G0otER;;A4GjptEQ;EACI,gCAAA;A5GoptEZ;;A4GhptEI;EACI,2BAAA;EACA,0BAAA;A5GmptER;;A4G1ptEQ;EACI,gCAAA;A5G6ptEZ;;A4GzptEI;EACI,2BAAA;EACA,0BAAA;A5G4ptER;;A4GnqtEQ;EACI,gCAAA;A5GsqtEZ;;A4GlqtEI;EACI,2BAAA;EACA,0BAAA;A5GqqtER;;A4G5qtEQ;EACI,gCAAA;A5G+qtEZ;;A4G3qtEI;EACI,2BAAA;EACA,0BAAA;A5G8qtER;;A4GrrtEQ;EACI,gCAAA;A5GwrtEZ;;A4GprtEI;EACI,2BAAA;EACA,0BAAA;A5GurtER;;A4GjrtEI;EACI,aAAA;A5GortER;A4GhrtEQ;EACI,aAAA;A5GkrtEZ;A4G/qtEQ;EACI,cAAA;A5GirtEZ;;A6Gv7tEI;EACI,2BAAA;A7G07tER;A6Gv7tEQ;EACI,oCAAA;EACA,eAAA;EACA,iBAAA;A7Gy7tEZ;;A8Gn8tEA;EACI,qBvGmjBgB;EuGljBhB,4CvGkmBS;APo2sEb;;A8Gn8tEA;EACI,+CAAA;A9Gs8tEJ;;A8Gj8tEI;EACI,eAAA;A9Go8tER;;A8Gh8tEA;EACI,4CAAA;A9Gm8tEJ;;A8Gh8tEA;EACI,eAAA;EACA,iBAAA;A9Gm8tEJ;;A8Gh8tEA;EACI,2BAAA;A9Gm8tEJ;;A8Gh8tEA;EACI,oBAAA;A9Gm8tEJ;A8Gj8tEI;EACI,wCAAA;EACA,6CvGokBQ;AP+3sEhB;;A8G17tEI;EACI,yBvGsTO;EuGrTP,WAAA;A9G67tER;A8G37tEQ;EACI,0CAAA;EACA,WAAA;EACA,yBAAA;A9G67tEZ;A8G17tEQ;EACI,WAAA;A9G47tEZ;;A8Gv8tEI;EACI,yBvGsTO;EuGrTP,WAAA;A9G08tER;A8Gx8tEQ;EACI,0CAAA;EACA,WAAA;EACA,yBAAA;A9G08tEZ;A8Gv8tEQ;EACI,WAAA;A9Gy8tEZ;;A8Gp9tEI;EACI,yBvGsTO;EuGrTP,WAAA;A9Gu9tER;A8Gr9tEQ;EACI,0CAAA;EACA,WAAA;EACA,yBAAA;A9Gu9tEZ;A8Gp9tEQ;EACI,WAAA;A9Gs9tEZ;;A8Gj+tEI;EACI,yBvGsTO;EuGrTP,WAAA;A9Go+tER;A8Gl+tEQ;EACI,0CAAA;EACA,WAAA;EACA,yBAAA;A9Go+tEZ;A8Gj+tEQ;EACI,WAAA;A9Gm+tEZ;;A8G9+tEI;EACI,yBvGsTO;EuGrTP,WAAA;A9Gi/tER;A8G/+tEQ;EACI,0CAAA;EACA,WAAA;EACA,yBAAA;A9Gi/tEZ;A8G9+tEQ;EACI,WAAA;A9Gg/tEZ;;A8G3/tEI;EACI,yBvGsTO;EuGrTP,WAAA;A9G8/tER;A8G5/tEQ;EACI,0CAAA;EACA,WAAA;EACA,yBAAA;A9G8/tEZ;A8G3/tEQ;EACI,WAAA;A9G6/tEZ;;A8GxguEI;EACI,yBvGsTO;EuGrTP,WAAA;A9G2guER;A8GzguEQ;EACI,0CAAA;EACA,WAAA;EACA,yBAAA;A9G2guEZ;A8GxguEQ;EACI,WAAA;A9G0guEZ;;A8GrhuEI;EACI,yBvGsTO;EuGrTP,WAAA;A9GwhuER;A8GthuEQ;EACI,0CAAA;EACA,WAAA;EACA,yBAAA;A9GwhuEZ;A8GrhuEQ;EACI,WAAA;A9GuhuEZ;;A8GliuEI;EACI,yBvGsTO;EuGrTP,WAAA;A9GqiuER;A8GniuEQ;EACI,0CAAA;EACA,WAAA;EACA,yBAAA;A9GqiuEZ;A8GliuEQ;EACI,WAAA;A9GoiuEZ;;A8G/iuEI;EACI,yBvGsTO;EuGrTP,WAAA;A9GkjuER;A8GhjuEQ;EACI,0CAAA;EACA,WAAA;EACA,yBAAA;A9GkjuEZ;A8G/iuEQ;EACI,WAAA;A9GijuEZ;;A8G5juEI;EACI,yBvGsTO;EuGrTP,WAAA;A9G+juER;A8G7juEQ;EACI,0CAAA;EACA,WAAA;EACA,yBAAA;A9G+juEZ;A8G5juEQ;EACI,WAAA;A9G8juEZ;;A8GzkuEI;EACI,yBvGsTO;EuGrTP,WAAA;A9G4kuER;A8G1kuEQ;EACI,0CAAA;EACA,WAAA;EACA,yBAAA;A9G4kuEZ;A8GzkuEQ;EACI,WAAA;A9G2kuEZ;;A8GtluEI;EACI,yBvGsTO;EuGrTP,WAAA;A9GyluER;A8GvluEQ;EACI,0CAAA;EACA,WAAA;EACA,yBAAA;A9GyluEZ;A8GtluEQ;EACI,WAAA;A9GwluEZ;;A8GnmuEI;EACI,yBvGsTO;EuGrTP,WAAA;A9GsmuER;A8GpmuEQ;EACI,0CAAA;EACA,WAAA;EACA,yBAAA;A9GsmuEZ;A8GnmuEQ;EACI,WAAA;A9GqmuEZ;;A8GhnuEI;EACI,yBvGsTO;EuGrTP,WAAA;A9GmnuER;A8GjnuEQ;EACI,0CAAA;EACA,WAAA;EACA,yBAAA;A9GmnuEZ;A8GhnuEQ;EACI,WAAA;A9GknuEZ;;A8G7nuEI;EACI,sBvGsTO;EuGrTP,WAAA;A9GgouER;A8G9nuEQ;EACI,0CAAA;EACA,WAAA;EACA,yBAAA;A9GgouEZ;A8G7nuEQ;EACI,WAAA;A9G+nuEZ;;A8G1ouEI;EACI,yBvGsTO;EuGrTP,WAAA;A9G6ouER;A8G3ouEQ;EACI,0CAAA;EACA,WAAA;EACA,yBAAA;A9G6ouEZ;A8G1ouEQ;EACI,WAAA;A9G4ouEZ;;A8GrouEI;EACI,gCAAA;A9GwouER;A8GvouEQ;EACI,qBvGkSG;APu2tEf;;A8G5ouEI;EACI,gCAAA;A9G+ouER;A8G9ouEQ;EACI,qBvGkSG;AP82tEf;;A8GnpuEI;EACI,gCAAA;A9GspuER;A8GrpuEQ;EACI,qBvGkSG;APq3tEf;;A8G1puEI;EACI,gCAAA;A9G6puER;A8G5puEQ;EACI,qBvGkSG;AP43tEf;;A8GjquEI;EACI,gCAAA;A9GoquER;A8GnquEQ;EACI,qBvGkSG;APm4tEf;;A8GxquEI;EACI,gCAAA;A9G2quER;A8G1quEQ;EACI,qBvGkSG;AP04tEf;;A8G/quEI;EACI,gCAAA;A9GkruER;A8GjruEQ;EACI,qBvGkSG;APi5tEf;;A8GtruEI;EACI,gCAAA;A9GyruER;A8GxruEQ;EACI,qBvGkSG;APw5tEf;;A8G7ruEI;EACI,gCAAA;A9GgsuER;A8G/ruEQ;EACI,qBvGkSG;AP+5tEf;;A8GpsuEI;EACI,gCAAA;A9GusuER;A8GtsuEQ;EACI,qBvGkSG;APs6tEf;;A8G3suEI;EACI,gCAAA;A9G8suER;A8G7suEQ;EACI,qBvGkSG;AP66tEf;;A8GltuEI;EACI,gCAAA;A9GqtuER;A8GptuEQ;EACI,qBvGkSG;APo7tEf;;A8GztuEI;EACI,gCAAA;A9G4tuER;A8G3tuEQ;EACI,qBvGkSG;AP27tEf;;A8GhuuEI;EACI,gCAAA;A9GmuuER;A8GluuEQ;EACI,qBvGkSG;APk8tEf;;A8GvuuEI;EACI,gCAAA;A9G0uuER;A8GzuuEQ;EACI,qBvGkSG;APy8tEf;;A8G9uuEI;EACI,6BAAA;A9GivuER;A8GhvuEQ;EACI,kBvGkSG;APg9tEf;;A8GrvuEI;EACI,gCAAA;A9GwvuER;A8GvvuEQ;EACI,qBvGkSG;APu9tEf;;A8GnvuEA;EACI,iCAAA;A9GsvuEJ;A8GrvuEI;EACI,sCAAA;EACA,+CAAA;A9GuvuER;A8GrvuEI;EACI,sCAAA;A9GuvuER;;A8GjvuEA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gDAAA;EACA,aAAA;A9GovuEJ;;A8GjvuEA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2CAAA;A9GovuEJ;;A8GjvuEA;EACI,kCAAA;A9GovuEJ;;A8GjvuEA;EACC;IAAK,yBAAA;E9GqvuEJ;AACF;A8GnvuEA;EACI,kBAAA;EACA,gBAAA;A9GqvuEJ;A8GpvuEI;EACI,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;A9GsvuER;A8GpvuEI;EACI,kDAAA;A9GsvuER;;A8GlvuEA;EACI,gBAAA;A9GqvuEJ;A8GpvuEI;EACI,eAAA;A9GsvuER;A8GnvuEQ;EACI,aAAA;A9GqvuEZ;A8GnvuEQ;EACI,cAAA;A9GqvuEZ;A8GlvuEY;EACI,cAAA;A9GovuEhB;A8GlvuEY;EACI,aAAA;A9GovuEhB;;A+Gp4uEA;EACI,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,oCAAA;A/Gu4uEJ;;A+Gp4uEA;EACI,6CxG4lBY;EwG3lBZ,6BAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;A/Gu4uEJ;A+Gr4uEI;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;A/Gu4uER;A+Gp4uEI;EACI,iCAAA;A/Gs4uER;;A+Gl4uEA;EACI;IACI,gBAAA;E/Gq4uEN;E+Gl4uEE;IACI,eAAA;E/Go4uEN;AACF;A+Gj4uEA;EACI;IACI,gBAAA;E/Gm4uEN;E+Gh4uEE;IACI,kBAAA;E/Gk4uEN;AACF;A+G/3uEA;EACI;IACI,YAAA;E/Gi4uEN;;E+G93uEE;IACI,YAAA;E/Gi4uEN;;E+G93uEE;IACI,YAAA;E/Gi4uEN;AACF;A+G93uEA;EACI,iBAAA;A/Gg4uEJ;A+G/3uEI;EACI,gBAAA;A/Gi4uER;A+G93uEI;EACI,WAAA;EACA,kBAAA;EACA,2CAAA;EACA,sCAAA;EACA,yCAAA;EACA,wCAAA;EACA,OAAA;EACA,kEAAA;A/Gg4uER;;A+G13uEA;EACI,2BAAA;A/G63uEJ;;A+Gt3uEA;EACI,YAAA;A/Gy3uEJ;;A+Gt3uEA;EACI,YAAA;A/Gy3uEJ;;A+Gr3uEI;EACI,kBAAA;A/Gw3uER;A+Gr3uEI;EACI,oBAAA;A/Gu3uER;;A+Gl3uEI;EACI,SAAA;A/Gq3uER;A+Gp3uEQ;EACI,+BAAA;A/Gs3uEZ;A+Gr3uEY;EACI,uCAAA;A/Gu3uEhB;A+Gr3uEY;EACI,WxGpFR;AP28uER;;A+G72uEQ;EACE,2CAAA;EACA,cxGiOK;AP+ouEf;;A+Gl3uEQ;EACE,2CAAA;EACA,cxGiOK;APopuEf;;A+Gv3uEQ;EACE,0CAAA;EACA,cxGiOK;APypuEf;;A+G53uEQ;EACE,0CAAA;EACA,cxGiOK;AP8puEf;;A+Gj4uEQ;EACE,0CAAA;EACA,cxGiOK;APmquEf;;A+Gt4uEQ;EACE,yCAAA;EACA,cxGiOK;APwquEf;;A+G34uEQ;EACE,2CAAA;EACA,cxGiOK;AP6quEf;;A+Gh5uEQ;EACE,wCAAA;EACA,cxGiOK;APkruEf;;A+Gr5uEQ;EACE,2CAAA;EACA,cxGiOK;APuruEf;;A+G15uEQ;EACE,2CAAA;EACA,cxGiOK;AP4ruEf;;A+G/5uEQ;EACE,yCAAA;EACA,cxGiOK;APisuEf;;A+Gp6uEQ;EACE,2CAAA;EACA,cxGiOK;APssuEf;;A+Gz6uEQ;EACE,2CAAA;EACA,cxGiOK;AP2suEf;;A+G96uEQ;EACE,0CAAA;EACA,cxGiOK;APgtuEf;;A+Gn7uEQ;EACE,2CAAA;EACA,cxGiOK;APqtuEf;;A+Gx7uEQ;EACE,2CAAA;EACA,WxGiOK;AP0tuEf;;A+G77uEQ;EACE,2CAAA;EACA,cxGiOK;AP+tuEf;;AgH/jvEQ;EACI,2BAAA;EACA,gBzGiqBS;APi6tErB;;AgH5jvEI;EACI,2BAAA;EACA,gBzGypBa;APs6tErB;;AgHzjvEI;EACI,gBzGqlBS;APu+tEjB;;AgHxjvEA;EACI,+CAAA;AhH2jvEJ;AgHzjvEI;EACI,kBAAA;AhH2jvER;AgHzjvEQ;EACI,YAAA;EACA,gBzGsoBS;APq7tErB;AgHzjvEY;EACI,WAAA;EACA,mBzG+RA;EyG9RA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,6BAAA;EACA,mBAAA;AhH2jvEhB;AgHxjvEY;EACI,czGoRA;APsyuEhB;AgHxjvEgB;EACI,mBAAA;AhH0jvEpB;AgHpjvEI;EACI,iBAAA;AhHsjvER;AgHpjvEQ;EACI,kBAAA;AhHsjvEZ;;AgH7ivEQ;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;AhHgjvEZ;AgH9ivEY;EACI,eAAA;AhHgjvEhB;;AgHvivEQ;EACI,yBzGhDD;EyGiDC,aAAA;AhH0ivEZ;;AgHjivEQ;EACI,kBAAA;EACA,kBAAA;AhHoivEZ;AgHlivEY;EACI,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EnF5FV,uGmF6FU;AhHoivEhB;A6B7nvEM;EmFkFM;InFjFJ,gBAAA;E7BgovEN;AACF;AgHrivEgB;EACI,yBzGoNJ;APm1uEhB;;AgH9hvEI;EACI,kBAAA;EACA,gBAAA;AhHiivER;AgH/hvEQ;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AhHiivEZ;AgH/hvEY;EACI,eAAA;AhHiivEhB;AgH9hvEY;EACI,eAAA;AhHgivEhB;AgH5hvEgB;EACI,WzG1GZ;APwovER;AgH1hvEY;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,oBAAA;AhH4hvEhB;AgH1hvEgB;EACI,QAAA;EACA,2BAAA;AhH4hvEpB;AgHzhvEgB;EACI,aAAA;AhH2hvEpB;AgHthvEgB;EACI,WAAA;EACA,0BAAA;AhHwhvEpB;AgHrhvEgB;EACI,UAAA;AhHuhvEpB;;AgH7gvEI;EACI,iCAAA;EACA,eAAA;EACA,kBAAA;AhHghvER;AgH9gvEQ;EACI;IACI,WAAA;IACA,kBAAA;IACA,YAAA;IACA,QAAA;IACA,2BAAA;IACA,8BAAA;IACA,8BAAA;IACA,uCAAA;EhHghvEd;EgH5gvEc;IACI,0BzG+HJ;EP+4uEd;AACF;;AgHtgvEI;EACI,kBAAA;AhHygvER;AgHvgvEQ;EACI,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,UAAA;AhHygvEZ;AgHvgvEY;EACI,kBAAA;AhHygvEhB;AgHtgvEY;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,QAAA;EACA,YAAA;EACA,6DAAA;EACA,yBzG+FA;EyG9FA,WAAA;AhHwgvEhB;AgHrgvEY;EAEI,WzGxMR;EyGyMQ,wCAAA;AhHsgvEhB;AgHpgvEgB;EACI,WAAA;EACA,OAAA;AhHsgvEpB;;AgH9/uEI;EACI,iCAAA;AhHigvER;AgH//uEQ;EACI,yBzGwEI;APy7uEhB;;AgHx/uEY;EACI,czG8FD;EyG7FC,yBzG6FD;AP85uEf;;AgH7/uEY;EACI,czG8FD;EyG7FC,yBzG6FD;APm6uEf;;AgHlgvEY;EACI,czG8FD;EyG7FC,yBzG6FD;APw6uEf;;AgHvgvEY;EACI,czG8FD;EyG7FC,yBzG6FD;AP66uEf;;AgH5gvEY;EACI,czG8FD;EyG7FC,yBzG6FD;APk7uEf;;AgHjhvEY;EACI,czG8FD;EyG7FC,yBzG6FD;APu7uEf;;AgHthvEY;EACI,czG8FD;EyG7FC,yBzG6FD;AP47uEf;;AgH3hvEY;EACI,czG8FD;EyG7FC,yBzG6FD;APi8uEf;;AgHhivEY;EACI,czG8FD;EyG7FC,yBzG6FD;APs8uEf;;AgHrivEY;EACI,czG8FD;EyG7FC,yBzG6FD;AP28uEf;;AgH1ivEY;EACI,czG8FD;EyG7FC,yBzG6FD;APg9uEf;;AgH/ivEY;EACI,czG8FD;EyG7FC,yBzG6FD;APq9uEf;;AgHpjvEY;EACI,czG8FD;EyG7FC,yBzG6FD;AP09uEf;;AgHzjvEY;EACI,czG8FD;EyG7FC,yBzG6FD;AP+9uEf;;AgH9jvEY;EACI,czG8FD;EyG7FC,yBzG6FD;APo+uEf;;AgHnkvEY;EACI,WzG8FD;EyG7FC,sBzG6FD;APy+uEf;;AgHxkvEY;EACI,czG8FD;EyG7FC,yBzG6FD;AP8+uEf;;AgHrkvEA;EACI,yBzGsDY;EyGrDZ,sCzG4pCiB;AP46sErB;AgHrkvEQ;EACI,gCAAA;AhHukvEZ;AgHrkvEY;EACI,WzGnPR;EyGoPQ,0CAAA;AhHukvEhB;AgHhkvEY;EACI,qCAAA;AhHkkvEhB;AgHhkvEgB;EACI,czG9PT;EyG+PS,yBzGiCJ;APiivEhB;;AgHzjvEI;EACI,yBzGuDO;APqgvEf;;AgH7jvEI;EACI,yBzGuDO;APygvEf;;AgHjkvEI;EACI,yBzGuDO;AP6gvEf;;AgHrkvEI;EACI,yBzGuDO;APihvEf;;AgHzkvEI;EACI,yBzGuDO;APqhvEf;;AgH7kvEI;EACI,yBzGuDO;APyhvEf;;AgHjlvEI;EACI,yBzGuDO;AP6hvEf;;AgHrlvEI;EACI,yBzGuDO;APiivEf;;AgHzlvEI;EACI,yBzGuDO;APqivEf;;AgH7lvEI;EACI,yBzGuDO;APyivEf;;AgHjmvEI;EACI,yBzGuDO;AP6ivEf;;AgHrmvEI;EACI,yBzGuDO;APijvEf;;AgHzmvEI;EACI,yBzGuDO;APqjvEf;;AgH7mvEI;EACI,yBzGuDO;APyjvEf;;AgHjnvEI;EACI,yBzGuDO;AP6jvEf;;AgHrnvEI;EACI,sBzGuDO;APikvEf;;AgHznvEI;EACI,yBzGuDO;APqkvEf;;AgHxnvEA;EACI,iCAAA;AhH2nvEJ;;AgHpnvEY;EACI,WzGvRR;EyGwRQ,yBzGyCD;AP8kvEf;AgHjnvEgB;EACI,czGkCL;EyGjCK,wCAAA;AhHmnvEpB;AgH5mvEgB;EACI,czGyBL;EyGxBK,wCAAA;AhH8mvEpB;AgH5mvEoB;EACI,yBzGqBT;APylvEf;AgHrmvEoB;EACI,yBzGWT;AP4lvEf;AgH9lvEoB;EACI,0BzGCT;AP+lvEf;;AgH1ovEY;EACI,WzGvRR;EyGwRQ,yBzGyCD;APomvEf;AgHvovEgB;EACI,czGkCL;EyGjCK,wCAAA;AhHyovEpB;AgHlovEgB;EACI,czGyBL;EyGxBK,wCAAA;AhHoovEpB;AgHlovEoB;EACI,yBzGqBT;AP+mvEf;AgH3nvEoB;EACI,yBzGWT;APknvEf;AgHpnvEoB;EACI,0BzGCT;APqnvEf;;AgHhqvEY;EACI,WzGvRR;EyGwRQ,yBzGyCD;AP0nvEf;AgH7pvEgB;EACI,czGkCL;EyGjCK,wCAAA;AhH+pvEpB;AgHxpvEgB;EACI,czGyBL;EyGxBK,wCAAA;AhH0pvEpB;AgHxpvEoB;EACI,yBzGqBT;APqovEf;AgHjpvEoB;EACI,yBzGWT;APwovEf;AgH1ovEoB;EACI,0BzGCT;AP2ovEf;;AgHtrvEY;EACI,WzGvRR;EyGwRQ,yBzGyCD;APgpvEf;AgHnrvEgB;EACI,czGkCL;EyGjCK,wCAAA;AhHqrvEpB;AgH9qvEgB;EACI,czGyBL;EyGxBK,wCAAA;AhHgrvEpB;AgH9qvEoB;EACI,yBzGqBT;AP2pvEf;AgHvqvEoB;EACI,yBzGWT;AP8pvEf;AgHhqvEoB;EACI,0BzGCT;APiqvEf;;AgH5svEY;EACI,WzGvRR;EyGwRQ,yBzGyCD;APsqvEf;AgHzsvEgB;EACI,czGkCL;EyGjCK,wCAAA;AhH2svEpB;AgHpsvEgB;EACI,czGyBL;EyGxBK,wCAAA;AhHssvEpB;AgHpsvEoB;EACI,yBzGqBT;APirvEf;AgH7rvEoB;EACI,yBzGWT;APorvEf;AgHtrvEoB;EACI,0BzGCT;APurvEf;;AgHluvEY;EACI,WzGvRR;EyGwRQ,yBzGyCD;AP4rvEf;AgH/tvEgB;EACI,czGkCL;EyGjCK,wCAAA;AhHiuvEpB;AgH1tvEgB;EACI,czGyBL;EyGxBK,wCAAA;AhH4tvEpB;AgH1tvEoB;EACI,yBzGqBT;APusvEf;AgHntvEoB;EACI,yBzGWT;AP0svEf;AgH5svEoB;EACI,0BzGCT;AP6svEf;;AgHxvvEY;EACI,WzGvRR;EyGwRQ,yBzGyCD;APktvEf;AgHrvvEgB;EACI,czGkCL;EyGjCK,wCAAA;AhHuvvEpB;AgHhvvEgB;EACI,czGyBL;EyGxBK,wCAAA;AhHkvvEpB;AgHhvvEoB;EACI,yBzGqBT;AP6tvEf;AgHzuvEoB;EACI,yBzGWT;APguvEf;AgHluvEoB;EACI,0BzGCT;APmuvEf;;AgH9wvEY;EACI,WzGvRR;EyGwRQ,yBzGyCD;APwuvEf;AgH3wvEgB;EACI,czGkCL;EyGjCK,wCAAA;AhH6wvEpB;AgHtwvEgB;EACI,czGyBL;EyGxBK,wCAAA;AhHwwvEpB;AgHtwvEoB;EACI,yBzGqBT;APmvvEf;AgH/vvEoB;EACI,yBzGWT;APsvvEf;AgHxvvEoB;EACI,0BzGCT;APyvvEf;;AgHpyvEY;EACI,WzGvRR;EyGwRQ,yBzGyCD;AP8vvEf;AgHjyvEgB;EACI,czGkCL;EyGjCK,wCAAA;AhHmyvEpB;AgH5xvEgB;EACI,czGyBL;EyGxBK,wCAAA;AhH8xvEpB;AgH5xvEoB;EACI,yBzGqBT;APywvEf;AgHrxvEoB;EACI,yBzGWT;AP4wvEf;AgH9wvEoB;EACI,0BzGCT;AP+wvEf;;AgH1zvEY;EACI,WzGvRR;EyGwRQ,yBzGyCD;APoxvEf;AgHvzvEgB;EACI,czGkCL;EyGjCK,wCAAA;AhHyzvEpB;AgHlzvEgB;EACI,czGyBL;EyGxBK,wCAAA;AhHozvEpB;AgHlzvEoB;EACI,yBzGqBT;AP+xvEf;AgH3yvEoB;EACI,yBzGWT;APkyvEf;AgHpyvEoB;EACI,0BzGCT;APqyvEf;;AgHh1vEY;EACI,WzGvRR;EyGwRQ,yBzGyCD;AP0yvEf;AgH70vEgB;EACI,czGkCL;EyGjCK,wCAAA;AhH+0vEpB;AgHx0vEgB;EACI,czGyBL;EyGxBK,wCAAA;AhH00vEpB;AgHx0vEoB;EACI,yBzGqBT;APqzvEf;AgHj0vEoB;EACI,yBzGWT;APwzvEf;AgH1zvEoB;EACI,0BzGCT;AP2zvEf;;AgHt2vEY;EACI,WzGvRR;EyGwRQ,yBzGyCD;APg0vEf;AgHn2vEgB;EACI,czGkCL;EyGjCK,wCAAA;AhHq2vEpB;AgH91vEgB;EACI,czGyBL;EyGxBK,wCAAA;AhHg2vEpB;AgH91vEoB;EACI,yBzGqBT;AP20vEf;AgHv1vEoB;EACI,yBzGWT;AP80vEf;AgHh1vEoB;EACI,0BzGCT;APi1vEf;;AgH53vEY;EACI,WzGvRR;EyGwRQ,yBzGyCD;APs1vEf;AgHz3vEgB;EACI,czGkCL;EyGjCK,wCAAA;AhH23vEpB;AgHp3vEgB;EACI,czGyBL;EyGxBK,wCAAA;AhHs3vEpB;AgHp3vEoB;EACI,yBzGqBT;APi2vEf;AgH72vEoB;EACI,yBzGWT;APo2vEf;AgHt2vEoB;EACI,0BzGCT;APu2vEf;;AgHl5vEY;EACI,WzGvRR;EyGwRQ,yBzGyCD;AP42vEf;AgH/4vEgB;EACI,czGkCL;EyGjCK,wCAAA;AhHi5vEpB;AgH14vEgB;EACI,czGyBL;EyGxBK,wCAAA;AhH44vEpB;AgH14vEoB;EACI,yBzGqBT;APu3vEf;AgHn4vEoB;EACI,yBzGWT;AP03vEf;AgH53vEoB;EACI,0BzGCT;AP63vEf;;AgHx6vEY;EACI,WzGvRR;EyGwRQ,yBzGyCD;APk4vEf;AgHr6vEgB;EACI,czGkCL;EyGjCK,wCAAA;AhHu6vEpB;AgHh6vEgB;EACI,czGyBL;EyGxBK,wCAAA;AhHk6vEpB;AgHh6vEoB;EACI,yBzGqBT;AP64vEf;AgHz5vEoB;EACI,yBzGWT;APg5vEf;AgHl5vEoB;EACI,0BzGCT;APm5vEf;;AgH97vEY;EACI,WzGvRR;EyGwRQ,sBzGyCD;APw5vEf;AgH37vEgB;EACI,WzGkCL;EyGjCK,wCAAA;AhH67vEpB;AgHt7vEgB;EACI,WzGyBL;EyGxBK,wCAAA;AhHw7vEpB;AgHt7vEoB;EACI,sBzGqBT;APm6vEf;AgH/6vEoB;EACI,sBzGWT;APs6vEf;AgHx6vEoB;EACI,uBzGCT;APy6vEf;;AgHp9vEY;EACI,WzGvRR;EyGwRQ,yBzGyCD;AP86vEf;AgHj9vEgB;EACI,czGkCL;EyGjCK,wCAAA;AhHm9vEpB;AgH58vEgB;EACI,czGyBL;EyGxBK,wCAAA;AhH88vEpB;AgH58vEoB;EACI,yBzGqBT;APy7vEf;AgHr8vEoB;EACI,yBzGWT;AP47vEf;AgH97vEoB;EACI,0BzGCT;AP+7vEf;;AgHv7vEA;EACI,kBAAA;EACA,kBAAA;EACA,iBAAA;AhH07vEJ;AgHx7vEI;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;AhH07vER;AgHv7vEI;EACI,mBAAA;EACA,kBAAA;EACA,8BAAA;AhHy7vER;AgHv7vEQ;EACI,WAAA;EACA,YAAA;EACA,iCAAA;EACA,UAAA;EACA,2BAAA;EACA,gBzGmSS;APspvErB;AgHv7vEY;EAEI,yBzGpEA;EyGqEA,WzGtWR;AP8xwER;;AgHh7vEI;EACI,iCAAA;AhHm7vER;AgHj7vEQ;EACI,gBAAA;EACA,kBAAA;EACA,gBzGgRS;EyG/QT,2BAAA;AhHm7vEZ;AgHj7vEY;EACI,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;AhHm7vEhB;AgHh7vEY;EACI,2CAAA;EACA,czGjGA;APmhwEhB;AgHh7vEgB;EACI,8BAAA;AhHk7vEpB;AgH96vEY;EACI,0CAAA;EACA,czG1GA;EyG2GA,gBAAA;AhHg7vEhB;AgH96vEgB;EACI,2CAAA;AhHg7vEpB;AgHx6vEoB;EACI,aAAA;AhH06vExB;;AgHh6vEI;EACI,SAAA;AhHm6vER;AgHj6vEQ;EACI,gBAAA;EACA,gDAAA;EACA,wCAAA;EACA,2BAAA;AhHm6vEZ;AgHj6vEY;EACI,gBzGyNO;AP0svEvB;AgHh6vEY;EACI,czG/YV;EyGgZU,sBAAA;EACA,gBzGkNK;EyGjNL,WAAA;AhHk6vEhB;AgH75vEgB;EACI,czGrZZ;APozwER;AgH75vEoB;EACI,YAAA;AhH+5vExB;AgH15vEY;EACI,qBzGjKA;AP6jwEhB;AgHz5vEY;EACI,qBzGlaR;AP6zwER;;AgHl5vEQ;EACI,6BAAA;EACA,oCAAA;AhHq5vEZ;AgHn5vEY;EACI,qBzGnLA;EyGoLA,6BAAA;EACA,czGrLA;AP0kwEhB;;AgH14vEgB;EACI,czGjKL;EyGkKK,qBzGlKL;AP+iwEf;;AgH/4vEgB;EACI,czGjKL;EyGkKK,qBzGlKL;APojwEf;;AgHp5vEgB;EACI,czGjKL;EyGkKK,qBzGlKL;APyjwEf;;AgHz5vEgB;EACI,czGjKL;EyGkKK,qBzGlKL;AP8jwEf;;AgH95vEgB;EACI,czGjKL;EyGkKK,qBzGlKL;APmkwEf;;AgHn6vEgB;EACI,czGjKL;EyGkKK,qBzGlKL;APwkwEf;;AgHx6vEgB;EACI,czGjKL;EyGkKK,qBzGlKL;AP6kwEf;;AgH76vEgB;EACI,czGjKL;EyGkKK,qBzGlKL;APklwEf;;AgHl7vEgB;EACI,czGjKL;EyGkKK,qBzGlKL;APulwEf;;AgHv7vEgB;EACI,czGjKL;EyGkKK,qBzGlKL;AP4lwEf;;AgH57vEgB;EACI,czGjKL;EyGkKK,qBzGlKL;APimwEf;;AgHj8vEgB;EACI,czGjKL;EyGkKK,qBzGlKL;APsmwEf;;AgHt8vEgB;EACI,czGjKL;EyGkKK,qBzGlKL;AP2mwEf;;AgH38vEgB;EACI,czGjKL;EyGkKK,qBzGlKL;APgnwEf;;AgHh9vEgB;EACI,czGjKL;EyGkKK,qBzGlKL;APqnwEf;;AgHr9vEgB;EACI,WzGjKL;EyGkKK,kBzGlKL;AP0nwEf;;AgH19vEgB;EACI,czGjKL;EyGkKK,qBzGlKL;AP+nwEf;;AgHp9vEI;EACI,kBAAA;EACA,gBAAA;AhHu9vER;AgHr9vEQ;EACI,kBAAA;EACA,cAAA;EACA,YAAA;EACA,uCAAA;EACA,kBAAA;EACA,yBAAA;AhHu9vEZ;AgHr9vEY;EAEI,cAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,uCAAA;EACA,yBAAA;AhHs9vEhB;AgHn9vEY;EACI,wBAAA;EACA,YAAA;EACA,4BAAA;AhHq9vEhB;AgHl9vEY;EACI,wBAAA;EACA,WAAA;EACA,6BAAA;AhHo9vEhB;AgHj9vEY;EAGI,yBzGlPA;EyGmPA,WzGphBR;APq+wER;AgH98vEY;EACI,UAAA;AhHg9vEhB;;AiHxgxEI;EACI,oC1G+zBa;AP4svErB;AiHzgxEI;EACI,wC1G2zBa;APgtvErB;;AiHpgxEI;;EAEI,mBAAA;AjHugxER;;AiHjgxEA;EACI,mBAAA;AjHogxEJ;AiH//wEQ;;EACI,kBAAA;AjHkgxEZ;AiH//wEQ;;EACI,mBAAA;AjHkgxEZ;AiH9/wEI;EACI,wC1G4xBa;APouvErB;;AiHx/wEY;EACI,gCAAA;AjH2/wEhB;;AiHr/wEY;EACI,uCAAA;AjHw/wEhB;;AiHhgxEY;EACI,gCAAA;AjHmgxEhB;;AiH7/wEY;EACI,qCAAA;AjHggxEhB;;AiHxgxEY;EACI,gCAAA;AjH2gxEhB;;AiHrgxEY;EACI,uCAAA;AjHwgxEhB;;AiHhhxEY;EACI,gCAAA;AjHmhxEhB;;AiH7gxEY;EACI,uCAAA;AjHghxEhB;;AiHxhxEY;EACI,gCAAA;AjH2hxEhB;;AiHrhxEY;EACI,uCAAA;AjHwhxEhB;;AiHhixEY;EACI,gCAAA;AjHmixEhB;;AiH7hxEY;EACI,uCAAA;AjHgixEhB;;AiHxixEY;EACI,gCAAA;AjH2ixEhB;;AiHrixEY;EACI,qCAAA;AjHwixEhB;;AiHhjxEY;EACI,gCAAA;AjHmjxEhB;;AiH7ixEY;EACI,uCAAA;AjHgjxEhB;;AiHxjxEY;EACI,gCAAA;AjH2jxEhB;;AiHrjxEY;EACI,uCAAA;AjHwjxEhB;;AiHhkxEY;EACI,gCAAA;AjHmkxEhB;;AiH7jxEY;EACI,uCAAA;AjHgkxEhB;;AiHxkxEY;EACI,gCAAA;AjH2kxEhB;;AiHrkxEY;EACI,uCAAA;AjHwkxEhB;;AiHhlxEY;EACI,gCAAA;AjHmlxEhB;;AiH7kxEY;EACI,uCAAA;AjHglxEhB;;AiHxlxEY;EACI,gCAAA;AjH2lxEhB;;AiHrlxEY;EACI,uCAAA;AjHwlxEhB;;AiHhmxEY;EACI,gCAAA;AjHmmxEhB;;AiH7lxEY;EACI,uCAAA;AjHgmxEhB;;AiHxmxEY;EACI,gCAAA;AjH2mxEhB;;AiHrmxEY;EACI,uCAAA;AjHwmxEhB;;AiHhnxEY;EACI,6BAAA;AjHmnxEhB;;AiH7mxEY;EACI,qCAAA;AjHgnxEhB;;AiHxnxEY;EACI,gCAAA;AjH2nxEhB;;AiHrnxEY;EACI,uCAAA;AjHwnxEhB;;AiHlnxEA;EACI,qFAAA;AjHqnxEJ;;AiHjnxEI;EACI,iBAAA;EACA,kBAAA;AjHonxER;AiHnnxEQ;EACI,gBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;AjHqnxEZ;AiHlnxEI;EACI,kBAAA;AjHonxER;AiHnnxEQ;EACI,aAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,iBAAA;EACA,oCAAA;AjHqnxEZ;AiHnnxEQ;EACI,kBAAA;EACA,aAAA;EACA,aAAA;EACA,oCAAA;EACA,iBAAA;EACA,SAAA;AjHqnxEZ;;AkH9sxEA;EACI,gB3GqqBmB;AP4iwEvB;;AkH7sxEI;EACI,iBAAA;AlHgtxER;AkH9sxEQ;EACI,4BAAA;AlHgtxEZ;AkH5sxEI;EACI,cAAA;AlH8sxER;;AkHxsxEE;EACC,UAAA;EACA,0BAAA;EACA,gCAAA;AlH2sxEH;AkHvsxEG;EACC,UAAA;EACA,wBAAA;AlHysxEJ;AkHnsxEE;EACC,sCAAA;EACA,6BAAA;AlHqsxEH;AkHjsxEG;EACC,eAAA;AlHmsxEJ;AkH7rxEE;EACC,oCAAA;EACA,4BAAA;AlH+rxEH;AkH3rxEG;EACC,eAAA;AlH6rxEJ;AkHxrxEC;EACC,mBAAA;AlH0rxEF;AkHxrxEE;EACC,UAAA;EACA,0BAAA;EACA,oBAAA;AlH0rxEH;AkHtrxEG;EACC,UAAA;EACA,wBAAA;AlHwrxEJ;AkHlrxEE;EACC,UAAA;EACA,qBAAA;EACA,yBAAA;AlHorxEH;AkHhrxEG;EACC,UAAA;EACA,mBAAA;AlHkrxEJ;;AkH3qxEA;EACC,qB3Gs+C6B;APwsuE9B;;AkH1qxEA;EACC,aAAA;EACA,qBAAA;EACA,gCAAA;AlH6qxED;AkH3qxEC;EALD;IAME,+BAAA;ElH8qxEA;AACF;;AkH3qxEA;EACC,aAAA;EACA,qBAAA;EACA,gCAAA;EACA,qB3Go9C6B;AP0tuE9B;AkH5qxEC;EAND;IAOE,+BAAA;ElH+qxEA;AACF;;AkH5qxEA;EACC;IACC,UAAA;IACA,kCAAA;ElH+qxEA;EkH5qxED;IACC,UAAA;IACA,wBAAA;ElH8qxEA;AACF;AkH1qxEA;EACC;IACC,UAAA;IACA,iCAAA;ElH4qxEA;EkHzqxED;IACC,UAAA;IACA,wBAAA;ElH2qxEA;AACF;AkHxqxEA;EACC;IACC,UAAA;IACA,iCAAA;ElH0qxEA;EkHvqxED;IACC,UAAA;ElHyqxEA;AACF;AkHtqxEA;EACC,0DAAA;EACA,sBAAA;EACA,2BAAA;AlHwqxED;;AmHp0xEQ;EACI,oBAAA;EACA,sCAAA;AnHu0xEZ;;AmHl0xEA;EACI,cAAA;EACA,0CAAA;EACA,8EAAA;AnHq0xEJ;;AmHl0xEA;EACI,8BAAA;EACA,4CAAA;EACA,oDAAA;EACA,sDAAA;EACA,sDAAA;EAEA,2CAAA;EACA,wDAAA;EACA,kEAAA;EAEA,2CAAA;EACA,wDAAA;EACA,iFAAA;EAEA,kCAAA;EACA,yDAAA;EACA,6DAAA;EAEA,yCAAA;EACA,kDAAA;EACA,4DAAA;AnHi0xEJ;;AmH5zxEI;EACI,8BAAA;EACA,wBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AnH+zxER;AmH3zxEQ;EACI,eAAA;EACA,gBAAA;AnH6zxEZ;;AmHvzxEI;EACI,gB5G2iBS;AP+wwEjB;;AoHt3xEA;EACI,WAAA;ApHy3xEJ;;AoHr3xEA;EACI,YAAA;ApHw3xEJ;;AoHp3xEA;EACI,YAAA;ApHu3xEJ;;AoHp3xEA;EACI,kBAAA;ApHu3xEJ;AoHr3xEI;EACI,kBAAA;EACA,UAAA;ApHu3xER;AoHr3xEQ;EACI,kCAAA;ApHu3xEZ;;AoHh3xEA;EACI,kBAAA;ApHm3xEJ;AoHj3xEI;EACI,kBAAA;EACA,kBAAA;EACA,8BAAA;ApHm3xER;;AoH/2xEA;EACI;IACI,QAAA;EpHk3xEN;AACF;AoH72xEA;EACI,YAAA;EACA,YAAA;EACA,mBAAA;ApH+2xEJ;AoH72xEI;EACI,kBAAA;EACA,mBAAA;ApH+2xER;AoH72xEQ;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,sB7G7BJ;E6G8BI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;ApH+2xEZ;;AoHx2xEA;EACI,iBAAA;ApH22xEJ;AoHz2xEI;EACI,kBAAA;EACA,iBAAA;ApH22xER;AoHz2xEQ;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yB7G8OI;E6G7OJ,W7GpDJ;E6GqDI,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;ApH22xEZ;AoHz2xEY;EACI,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,yB7GmOA;E6GlOA,YAAA;EACA,SAAA;EACA,2BAAA;ApH22xEhB;;AoHp2xEA;EACI,eAAA;ApHu2xEJ;AoHr2xEI;EACI,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,W7G/EA;APs7xER;AoHt2xEQ;EACI,WAAA;EACA,kBAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;ApHw2xEZ;;AoHj2xEI;EACI,yB7GmOO;APioxEf;AoHn2xEQ;EACI,0B7GiOG;APooxEf;AoHn2xEQ;EACI,qDAAA;EACA,yBAAA;ApHq2xEZ;AoHp2xEY;EACI,2CAAA;ApHs2xEhB;;AoH/2xEI;EACI,yB7GmOO;AP+oxEf;AoHj3xEQ;EACI,0B7GiOG;APkpxEf;AoHj3xEQ;EACI,qDAAA;EACA,yBAAA;ApHm3xEZ;AoHl3xEY;EACI,2CAAA;ApHo3xEhB;;AoH73xEI;EACI,yB7GmOO;AP6pxEf;AoH/3xEQ;EACI,0B7GiOG;APgqxEf;AoH/3xEQ;EACI,oDAAA;EACA,yBAAA;ApHi4xEZ;AoHh4xEY;EACI,0CAAA;ApHk4xEhB;;AoH34xEI;EACI,yB7GmOO;AP2qxEf;AoH74xEQ;EACI,0B7GiOG;AP8qxEf;AoH74xEQ;EACI,oDAAA;EACA,yBAAA;ApH+4xEZ;AoH94xEY;EACI,0CAAA;ApHg5xEhB;;AoHz5xEI;EACI,yB7GmOO;APyrxEf;AoH35xEQ;EACI,0B7GiOG;AP4rxEf;AoH35xEQ;EACI,oDAAA;EACA,yBAAA;ApH65xEZ;AoH55xEY;EACI,0CAAA;ApH85xEhB;;AoHv6xEI;EACI,yB7GmOO;APusxEf;AoHz6xEQ;EACI,0B7GiOG;AP0sxEf;AoHz6xEQ;EACI,mDAAA;EACA,yBAAA;ApH26xEZ;AoH16xEY;EACI,yCAAA;ApH46xEhB;;AoHr7xEI;EACI,yB7GmOO;APqtxEf;AoHv7xEQ;EACI,0B7GiOG;APwtxEf;AoHv7xEQ;EACI,qDAAA;EACA,yBAAA;ApHy7xEZ;AoHx7xEY;EACI,2CAAA;ApH07xEhB;;AoHn8xEI;EACI,yB7GmOO;APmuxEf;AoHr8xEQ;EACI,0B7GiOG;APsuxEf;AoHr8xEQ;EACI,kDAAA;EACA,yBAAA;ApHu8xEZ;AoHt8xEY;EACI,wCAAA;ApHw8xEhB;;AoHj9xEI;EACI,yB7GmOO;APivxEf;AoHn9xEQ;EACI,0B7GiOG;APovxEf;AoHn9xEQ;EACI,qDAAA;EACA,yBAAA;ApHq9xEZ;AoHp9xEY;EACI,2CAAA;ApHs9xEhB;;AoH/9xEI;EACI,yB7GmOO;AP+vxEf;AoHj+xEQ;EACI,0B7GiOG;APkwxEf;AoHj+xEQ;EACI,qDAAA;EACA,yBAAA;ApHm+xEZ;AoHl+xEY;EACI,2CAAA;ApHo+xEhB;;AoH7+xEI;EACI,yB7GmOO;AP6wxEf;AoH/+xEQ;EACI,0B7GiOG;APgxxEf;AoH/+xEQ;EACI,mDAAA;EACA,yBAAA;ApHi/xEZ;AoHh/xEY;EACI,yCAAA;ApHk/xEhB;;AoH3/xEI;EACI,yB7GmOO;AP2xxEf;AoH7/xEQ;EACI,0B7GiOG;AP8xxEf;AoH7/xEQ;EACI,qDAAA;EACA,yBAAA;ApH+/xEZ;AoH9/xEY;EACI,2CAAA;ApHggyEhB;;AoHzgyEI;EACI,yB7GmOO;APyyxEf;AoH3gyEQ;EACI,0B7GiOG;AP4yxEf;AoH3gyEQ;EACI,qDAAA;EACA,yBAAA;ApH6gyEZ;AoH5gyEY;EACI,2CAAA;ApH8gyEhB;;AoHvhyEI;EACI,yB7GmOO;APuzxEf;AoHzhyEQ;EACI,0B7GiOG;AP0zxEf;AoHzhyEQ;EACI,oDAAA;EACA,yBAAA;ApH2hyEZ;AoH1hyEY;EACI,0CAAA;ApH4hyEhB;;AoHriyEI;EACI,yB7GmOO;APq0xEf;AoHviyEQ;EACI,0B7GiOG;APw0xEf;AoHviyEQ;EACI,qDAAA;EACA,yBAAA;ApHyiyEZ;AoHxiyEY;EACI,2CAAA;ApH0iyEhB;;AoHnjyEI;EACI,sB7GmOO;APm1xEf;AoHrjyEQ;EACI,uB7GiOG;APs1xEf;AoHrjyEQ;EACI,qDAAA;EACA,sBAAA;ApHujyEZ;AoHtjyEY;EACI,2CAAA;ApHwjyEhB;;AoHjkyEI;EACI,yB7GmOO;APi2xEf;AoHnkyEQ;EACI,0B7GiOG;APo2xEf;AoHnkyEQ;EACI,qDAAA;EACA,yBAAA;ApHqkyEZ;AoHpkyEY;EACI,2CAAA;ApHskyEhB;;AqH7syEA;EACI,6C9GqmBY;AP2mxEhB;;AsH/syEI;EACI,aAAA;EACA,sBAAA;AtHktyER;AsHhtyEQ;EACI,mDAAA;EACA,iBAAA;EACA,sBAAA;AtHktyEZ;;AsHzsyEY;EACI,+BAAA;EACA,6CAAA;AtH4syEhB;AsH1syEgB;EACI,sCAAA;AtH4syEpB;AsHvsyEgB;EACI,+BAAA;AtHysyEpB;AsHvsyEoB;EACI,sCAAA;AtHysyExB;;AsHvtyEY;EACI,iCAAA;EACA,+CAAA;AtH0tyEhB;AsHxtyEgB;EACI,wCAAA;AtH0tyEpB;AsHrtyEgB;EACI,iCAAA;AtHutyEpB;AsHrtyEoB;EACI,wCAAA;AtHutyExB;;AsHruyEY;EACI,+BAAA;EACA,6CAAA;AtHwuyEhB;AsHtuyEgB;EACI,sCAAA;AtHwuyEpB;AsHnuyEgB;EACI,+BAAA;AtHquyEpB;AsHnuyEoB;EACI,sCAAA;AtHquyExB;;AsHnvyEY;EACI,4BAAA;EACA,0CAAA;AtHsvyEhB;AsHpvyEgB;EACI,mCAAA;AtHsvyEpB;AsHjvyEgB;EACI,4BAAA;AtHmvyEpB;AsHjvyEoB;EACI,mCAAA;AtHmvyExB;;AsHjwyEY;EACI,+BAAA;EACA,6CAAA;AtHowyEhB;AsHlwyEgB;EACI,sCAAA;AtHowyEpB;AsH/vyEgB;EACI,+BAAA;AtHiwyEpB;AsH/vyEoB;EACI,sCAAA;AtHiwyExB;;AsH/wyEY;EACI,8BAAA;EACA,4CAAA;AtHkxyEhB;AsHhxyEgB;EACI,qCAAA;AtHkxyEpB;AsH7wyEgB;EACI,8BAAA;AtH+wyEpB;AsH7wyEoB;EACI,qCAAA;AtH+wyExB;;AsH7xyEY;EACI,6BAAA;EACA,2CAAA;AtHgyyEhB;AsH9xyEgB;EACI,oCAAA;AtHgyyEpB;AsH3xyEgB;EACI,6BAAA;AtH6xyEpB;AsH3xyEoB;EACI,oCAAA;AtH6xyExB;;AsH3yyEY;EACI,4BAAA;EACA,0CAAA;AtH8yyEhB;AsH5yyEgB;EACI,mCAAA;AtH8yyEpB;AsHzyyEgB;EACI,4BAAA;AtH2yyEpB;AsHzyyEoB;EACI,mCAAA;AtH2yyExB;;AsHzzyEY;EACI,sCAAA;EACA,oDAAA;AtH4zyEhB;AsH1zyEgB;EACI,6CAAA;AtH4zyEpB;AsHvzyEgB;EACI,sCAAA;AtHyzyEpB;AsHvzyEoB;EACI,6CAAA;AtHyzyExB;;AsHv0yEY;EACI,4CAAA;EACA,0DAAA;AtH00yEhB;AsHx0yEgB;EACI,mDAAA;AtH00yEpB;AsHr0yEgB;EACI,4CAAA;AtHu0yEpB;AsHr0yEoB;EACI,mDAAA;AtHu0yExB;;AsHr1yEY;EACI,mCAAA;EACA,iDAAA;AtHw1yEhB;AsHt1yEgB;EACI,0CAAA;AtHw1yEpB;AsHn1yEgB;EACI,mCAAA;AtHq1yEpB;AsHn1yEoB;EACI,0CAAA;AtHq1yExB;;AsHn2yEY;EACI,8BAAA;EACA,4CAAA;AtHs2yEhB;AsHp2yEgB;EACI,qCAAA;AtHs2yEpB;AsHj2yEgB;EACI,8BAAA;AtHm2yEpB;AsHj2yEoB;EACI,qCAAA;AtHm2yExB;;AsHj3yEY;EACI,mCAAA;EACA,iDAAA;AtHo3yEhB;AsHl3yEgB;EACI,0CAAA;AtHo3yEpB;AsH/2yEgB;EACI,mCAAA;AtHi3yEpB;AsH/2yEoB;EACI,0CAAA;AtHi3yExB;;AsH/3yEY;EACI,0CAAA;EACA,wDAAA;AtHk4yEhB;AsHh4yEgB;EACI,iDAAA;AtHk4yEpB;AsH73yEgB;EACI,0CAAA;AtH+3yEpB;AsH73yEoB;EACI,iDAAA;AtH+3yExB;;AsH74yEY;EACI,yCAAA;EACA,uDAAA;AtHg5yEhB;AsH94yEgB;EACI,gDAAA;AtHg5yEpB;AsH34yEgB;EACI,yCAAA;AtH64yEpB;AsH34yEoB;EACI,gDAAA;AtH64yExB;;AsH35yEY;EACI,6BAAA;EACA,2CAAA;AtH85yEhB;AsH55yEgB;EACI,oCAAA;AtH85yEpB;AsHz5yEgB;EACI,6BAAA;AtH25yEpB;AsHz5yEoB;EACI,oCAAA;AtH25yExB;;AsHz6yEY;EACI,kCAAA;EACA,gDAAA;AtH46yEhB;AsH16yEgB;EACI,yCAAA;AtH46yEpB;AsHv6yEgB;EACI,kCAAA;AtHy6yEpB;AsHv6yEoB;EACI,yCAAA;AtHy6yExB;;AuHz8yEA;EACI,kBAAA;EACA,gBAAA;AvH48yEJ;AuHz8yEI;EACI,eAAA;AvH28yER;AuHx8yEI;EACI,eAAA;AvH08yER;;AuH/7yEY;EACI,yBhH4UD;EgH3UC,qBhH2UD;APunyEf;;AuH37yEY;EACI,qBhHmUD;EgHlUC,yBhHkUD;AP4nyEf;AuH57yEgB;EACI,yBhH+TL;AP+nyEf;;AuH58yEY;EACI,yBhH4UD;EgH3UC,qBhH2UD;APooyEf;;AuHx8yEY;EACI,qBhHmUD;EgHlUC,yBhHkUD;APyoyEf;AuHz8yEgB;EACI,yBhH+TL;AP4oyEf;;AuHz9yEY;EACI,yBhH4UD;EgH3UC,qBhH2UD;APipyEf;;AuHr9yEY;EACI,qBhHmUD;EgHlUC,yBhHkUD;APspyEf;AuHt9yEgB;EACI,yBhH+TL;APypyEf;;AuHt+yEY;EACI,yBhH4UD;EgH3UC,qBhH2UD;AP8pyEf;;AuHl+yEY;EACI,qBhHmUD;EgHlUC,yBhHkUD;APmqyEf;AuHn+yEgB;EACI,yBhH+TL;APsqyEf;;AuHn/yEY;EACI,yBhH4UD;EgH3UC,qBhH2UD;AP2qyEf;;AuH/+yEY;EACI,qBhHmUD;EgHlUC,yBhHkUD;APgryEf;AuHh/yEgB;EACI,yBhH+TL;APmryEf;;AuHhgzEY;EACI,yBhH4UD;EgH3UC,qBhH2UD;APwryEf;;AuH5/yEY;EACI,qBhHmUD;EgHlUC,yBhHkUD;AP6ryEf;AuH7/yEgB;EACI,yBhH+TL;APgsyEf;;AuH7gzEY;EACI,yBhH4UD;EgH3UC,qBhH2UD;APqsyEf;;AuHzgzEY;EACI,qBhHmUD;EgHlUC,yBhHkUD;AP0syEf;AuH1gzEgB;EACI,yBhH+TL;AP6syEf;;AuH1hzEY;EACI,yBhH4UD;EgH3UC,qBhH2UD;APktyEf;;AuHthzEY;EACI,qBhHmUD;EgHlUC,yBhHkUD;APutyEf;AuHvhzEgB;EACI,yBhH+TL;AP0tyEf;;AuHvizEY;EACI,yBhH4UD;EgH3UC,qBhH2UD;AP+tyEf;;AuHnizEY;EACI,qBhHmUD;EgHlUC,yBhHkUD;APouyEf;AuHpizEgB;EACI,yBhH+TL;APuuyEf;;AuHpjzEY;EACI,yBhH4UD;EgH3UC,qBhH2UD;AP4uyEf;;AuHhjzEY;EACI,qBhHmUD;EgHlUC,yBhHkUD;APivyEf;AuHjjzEgB;EACI,yBhH+TL;APovyEf;;AuHjkzEY;EACI,yBhH4UD;EgH3UC,qBhH2UD;APyvyEf;;AuH7jzEY;EACI,qBhHmUD;EgHlUC,yBhHkUD;AP8vyEf;AuH9jzEgB;EACI,yBhH+TL;APiwyEf;;AuH9kzEY;EACI,yBhH4UD;EgH3UC,qBhH2UD;APswyEf;;AuH1kzEY;EACI,qBhHmUD;EgHlUC,yBhHkUD;AP2wyEf;AuH3kzEgB;EACI,yBhH+TL;AP8wyEf;;AuH3lzEY;EACI,yBhH4UD;EgH3UC,qBhH2UD;APmxyEf;;AuHvlzEY;EACI,qBhHmUD;EgHlUC,yBhHkUD;APwxyEf;AuHxlzEgB;EACI,yBhH+TL;AP2xyEf;;AuHxmzEY;EACI,yBhH4UD;EgH3UC,qBhH2UD;APgyyEf;;AuHpmzEY;EACI,qBhHmUD;EgHlUC,yBhHkUD;APqyyEf;AuHrmzEgB;EACI,yBhH+TL;APwyyEf;;AuHrnzEY;EACI,yBhH4UD;EgH3UC,qBhH2UD;AP6yyEf;;AuHjnzEY;EACI,qBhHmUD;EgHlUC,yBhHkUD;APkzyEf;AuHlnzEgB;EACI,yBhH+TL;APqzyEf;;AuHlozEY;EACI,sBhH4UD;EgH3UC,kBhH2UD;AP0zyEf;;AuH9nzEY;EACI,kBhHmUD;EgHlUC,sBhHkUD;AP+zyEf;AuH/nzEgB;EACI,sBhH+TL;APk0yEf;;AuH/ozEY;EACI,yBhH4UD;EgH3UC,qBhH2UD;APu0yEf;;AuH3ozEY;EACI,qBhHmUD;EgHlUC,yBhHkUD;AP40yEf;AuH5ozEgB;EACI,yBhH+TL;AP+0yEf;;AuHvozEA;EACI,eAAA;EACA,gBAAA;AvH0ozEJ;;AuHtozEA;EACI,eAAA;EACA,qBAAA;AvHyozEJ;AuHvozEI;EACI,YAAA;EACA,cAAA;EACA,8BAAA;AvHyozER;AuHtozEI;EACI,cAAA;AvHwozER;AuHpozEQ;EACI,gCAAA;AvHsozEZ;;AuHznzEgB;EACI,chHoRL;EgHnRK,6BAAA;EACA,qBhHkRL;AP02yEf;;AuH/nzEgB;EACI,chHoRL;EgHnRK,6BAAA;EACA,qBhHkRL;APg3yEf;;AuHrozEgB;EACI,chHoRL;EgHnRK,6BAAA;EACA,qBhHkRL;APs3yEf;;AuH3ozEgB;EACI,chHoRL;EgHnRK,6BAAA;EACA,qBhHkRL;AP43yEf;;AuHjpzEgB;EACI,chHoRL;EgHnRK,6BAAA;EACA,qBhHkRL;APk4yEf;;AuHvpzEgB;EACI,chHoRL;EgHnRK,6BAAA;EACA,qBhHkRL;APw4yEf;;AuH7pzEgB;EACI,chHoRL;EgHnRK,6BAAA;EACA,qBhHkRL;AP84yEf;;AuHnqzEgB;EACI,chHoRL;EgHnRK,6BAAA;EACA,qBhHkRL;APo5yEf;;AuHzqzEgB;EACI,chHoRL;EgHnRK,6BAAA;EACA,qBhHkRL;AP05yEf;;AuH/qzEgB;EACI,chHoRL;EgHnRK,6BAAA;EACA,qBhHkRL;APg6yEf;;AuHrrzEgB;EACI,chHoRL;EgHnRK,6BAAA;EACA,qBhHkRL;APs6yEf;;AuH3rzEgB;EACI,chHoRL;EgHnRK,6BAAA;EACA,qBhHkRL;AP46yEf;;AuHjszEgB;EACI,chHoRL;EgHnRK,6BAAA;EACA,qBhHkRL;APk7yEf;;AuHvszEgB;EACI,chHoRL;EgHnRK,6BAAA;EACA,qBhHkRL;APw7yEf;;AuH7szEgB;EACI,chHoRL;EgHnRK,6BAAA;EACA,qBhHkRL;AP87yEf;;AuHntzEgB;EACI,WhHoRL;EgHnRK,6BAAA;EACA,kBhHkRL;APo8yEf;;AuHztzEgB;EACI,chHoRL;EgHnRK,6BAAA;EACA,qBhHkRL;AP08yEf;;AuHptzEI;EACI,kBAAA;AvHutzER;AuHrtzEQ;EACI,sBAAA;AvHutzEZ;AuHrtzEY;EACI,aAAA;EACA,oCAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;AvHutzEhB;;AuHzszEgB;EACI,chH8OL;EgH7OK,6BAAA;EACA,qBhH4OL;APg+yEf;;AuH/szEgB;EACI,chH8OL;EgH7OK,6BAAA;EACA,qBhH4OL;APs+yEf;;AuHrtzEgB;EACI,chH8OL;EgH7OK,6BAAA;EACA,qBhH4OL;AP4+yEf;;AuH3tzEgB;EACI,chH8OL;EgH7OK,6BAAA;EACA,qBhH4OL;APk/yEf;;AuHjuzEgB;EACI,chH8OL;EgH7OK,6BAAA;EACA,qBhH4OL;APw/yEf;;AuHvuzEgB;EACI,chH8OL;EgH7OK,6BAAA;EACA,qBhH4OL;AP8/yEf;;AuH7uzEgB;EACI,chH8OL;EgH7OK,6BAAA;EACA,qBhH4OL;APogzEf;;AuHnvzEgB;EACI,chH8OL;EgH7OK,6BAAA;EACA,qBhH4OL;AP0gzEf;;AuHzvzEgB;EACI,chH8OL;EgH7OK,6BAAA;EACA,qBhH4OL;APghzEf;;AuH/vzEgB;EACI,chH8OL;EgH7OK,6BAAA;EACA,qBhH4OL;APshzEf;;AuHrwzEgB;EACI,chH8OL;EgH7OK,6BAAA;EACA,qBhH4OL;AP4hzEf;;AuH3wzEgB;EACI,chH8OL;EgH7OK,6BAAA;EACA,qBhH4OL;APkizEf;;AuHjxzEgB;EACI,chH8OL;EgH7OK,6BAAA;EACA,qBhH4OL;APwizEf;;AuHvxzEgB;EACI,chH8OL;EgH7OK,6BAAA;EACA,qBhH4OL;AP8izEf;;AuH7xzEgB;EACI,chH8OL;EgH7OK,6BAAA;EACA,qBhH4OL;APojzEf;;AuHnyzEgB;EACI,WhH8OL;EgH7OK,6BAAA;EACA,kBhH4OL;AP0jzEf;;AuHzyzEgB;EACI,chH8OL;EgH7OK,6BAAA;EACA,qBhH4OL;APgkzEf;;AuHpyzEI;EACI,kBAAA;AvHuyzER;AuHryzEQ;EACI,sBAAA;AvHuyzEZ;AuHryzEY;EACI,aAAA;EACA,oCAAA;EACA,QAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;AvHuyzEhB;;AuH9xzEA;EACI,oBAAA;EACA,gBAAA;EACA,iBAAA;AvHiyzEJ;AuH/xzEI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AvHiyzER;AuH9xzEI;EACI,sBAAA;AvHgyzER;;AuH5xzEA;EACI,qBAAA;EACA,gBAAA;EACA,iBAAA;AvH+xzEJ;AuH7xzEI;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AvH+xzER;;AuH3xzEA;EACI,kBAAA;AvH8xzEJ;;AuHrxzEY;EACI,yBhHsKD;EgHrKC,qBhHqKD;APmnzEf;;AuH/wzEoB;EACI,chH2JT;APunzEf;;AuH9xzEY;EACI,yBhHsKD;EgHrKC,qBhHqKD;AP4nzEf;;AuHxxzEoB;EACI,chH2JT;APgozEf;;AuHvyzEY;EACI,yBhHsKD;EgHrKC,qBhHqKD;APqozEf;;AuHjyzEoB;EACI,chH2JT;APyozEf;;AuHhzzEY;EACI,yBhHsKD;EgHrKC,qBhHqKD;AP8ozEf;;AuH1yzEoB;EACI,chH2JT;APkpzEf;;AuHzzzEY;EACI,yBhHsKD;EgHrKC,qBhHqKD;APupzEf;;AuHnzzEoB;EACI,chH2JT;AP2pzEf;;AuHl0zEY;EACI,yBhHsKD;EgHrKC,qBhHqKD;APgqzEf;;AuH5zzEoB;EACI,chH2JT;APoqzEf;;AuH30zEY;EACI,yBhHsKD;EgHrKC,qBhHqKD;APyqzEf;;AuHr0zEoB;EACI,chH2JT;AP6qzEf;;AuHp1zEY;EACI,yBhHsKD;EgHrKC,qBhHqKD;APkrzEf;;AuH90zEoB;EACI,chH2JT;APsrzEf;;AuH71zEY;EACI,yBhHsKD;EgHrKC,qBhHqKD;AP2rzEf;;AuHv1zEoB;EACI,chH2JT;AP+rzEf;;AuHt2zEY;EACI,yBhHsKD;EgHrKC,qBhHqKD;APoszEf;;AuHh2zEoB;EACI,chH2JT;APwszEf;;AuH/2zEY;EACI,yBhHsKD;EgHrKC,qBhHqKD;AP6szEf;;AuHz2zEoB;EACI,chH2JT;APitzEf;;AuHx3zEY;EACI,yBhHsKD;EgHrKC,qBhHqKD;APstzEf;;AuHl3zEoB;EACI,chH2JT;AP0tzEf;;AuHj4zEY;EACI,yBhHsKD;EgHrKC,qBhHqKD;AP+tzEf;;AuH33zEoB;EACI,chH2JT;APmuzEf;;AuH14zEY;EACI,yBhHsKD;EgHrKC,qBhHqKD;APwuzEf;;AuHp4zEoB;EACI,chH2JT;AP4uzEf;;AuHn5zEY;EACI,yBhHsKD;EgHrKC,qBhHqKD;APivzEf;;AuH74zEoB;EACI,chH2JT;APqvzEf;;AuH55zEY;EACI,sBhHsKD;EgHrKC,kBhHqKD;AP0vzEf;;AuHt5zEoB;EACI,WhH2JT;AP8vzEf;;AuHr6zEY;EACI,yBhHsKD;EgHrKC,qBhHqKD;APmwzEf;;AuH/5zEoB;EACI,chH2JT;APuwzEf;;AuHt5zEI;EACI,kBAAA;EACA,sBAAA;AvHy5zER;AuHv5zEQ;EACI,aAAA;EACA,oCAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,gCAAA;E1FlNN,iD0FmNM;AvHy5zEZ;A6Bxm0EM;E0FuME;I1FtMA,gBAAA;E7B2m0EN;AACF;AuH35zEQ;EACI,sBAAA;EACA,2ChHwuBD;EsBh8BL,iD0FyNM;AvH65zEZ;A6Bln0EM;E0FkNE;I1FjNA,gBAAA;E7Bqn0EN;AACF;AuHh6zEY;EACI,WAAA;EACA,UAAA;AvHk6zEhB;AuH95zEQ;EACI,sBAAA;AvHg6zEZ;;AuHz5zEA;EACI,qBAAA;EACA,+BAAA;EACA,gBAAA;EACA,0BAAA;AvH45zEJ;AuH15zEI;EACI,YAAA;EACA,cAAA;EACA,8BAAA;EACA,4BAAA;AvH45zER;AuHz5zEI;EACI,gBAAA;EACA,kBAAA;AvH25zER;;AuHt5zEA;EACI,UAAA;AvHy5zEJ;AuHv5zEI;EACI,wCAAA;EACA,wCAAA;EACA,sBhH+TQ;EgH9TR,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AvHy5zER;AuHv5zEQ;EACI,eAAA;AvHy5zEZ;AuHr5zEI;EACI,aAAA;AvHu5zER;AuHr5zEQ;EACI,gCAAA;AvHu5zEZ;AuHr5zEY;EACI,YAAA;EACA,wBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,chHwBA;AP+3zEhB;AuH/4zEgB;EACI,WhHlRZ;APmq0ER;;AwHns0EA;EACI,kBAAA;AxHss0EJ;AwHrs0EI;EACI,8BAAA;EACA,kBAAA;AxHus0ER;AwHrs0EI;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AxHus0ER;AwHps0EQ;EACI,+BAAA;EACA,oBjH80BU;EiH70BV,kBAAA;AxHss0EZ;AwHps0EQ;EACI,UAAA;EACA,WAAA;AxHss0EZ;;AyHzt0EQ;EACI,WAAA;EACA,8CAAA;EACA,+BAAA;AzH4t0EZ;;AyH/t0EQ;EACI,WAAA;EACA,gDAAA;EACA,iCAAA;AzHku0EZ;;AyHru0EQ;EACI,WAAA;EACA,8CAAA;EACA,+BAAA;AzHwu0EZ;;AyH3u0EQ;EACI,WAAA;EACA,2CAAA;EACA,4BAAA;AzH8u0EZ;;AyHjv0EQ;EACI,WAAA;EACA,8CAAA;EACA,+BAAA;AzHov0EZ;;AyHvv0EQ;EACI,WAAA;EACA,6CAAA;EACA,8BAAA;AzH0v0EZ;;AyH7v0EQ;EACI,WAAA;EACA,4CAAA;EACA,6BAAA;AzHgw0EZ;;AyHnw0EQ;EACI,WAAA;EACA,2CAAA;EACA,4BAAA;AzHsw0EZ;;AyHzw0EQ;EACI,WAAA;EACA,qDAAA;EACA,sCAAA;AzH4w0EZ;;AyH/w0EQ;EACI,WAAA;EACA,2DAAA;EACA,4CAAA;AzHkx0EZ;;AyHrx0EQ;EACI,WAAA;EACA,kDAAA;EACA,mCAAA;AzHwx0EZ;;AyH3x0EQ;EACI,WAAA;EACA,6CAAA;EACA,8BAAA;AzH8x0EZ;;AyHjy0EQ;EACI,WAAA;EACA,kDAAA;EACA,mCAAA;AzHoy0EZ;;AyHvy0EQ;EACI,WAAA;EACA,yDAAA;EACA,0CAAA;AzH0y0EZ;;AyH7y0EQ;EACI,WAAA;EACA,wDAAA;EACA,yCAAA;AzHgz0EZ;;AyHnz0EQ;EACI,WAAA;EACA,4CAAA;EACA,6BAAA;AzHsz0EZ;;AyHzz0EQ;EACI,WAAA;EACA,iDAAA;EACA,kCAAA;AzH4z0EZ;;AyHvz0EA;EACI,kBAAA;AzH0z0EJ;AyHzz0EI;EACI,gCAAA;AzH2z0ER;AyHzz0EI;EACI,gBlHslBS;APquzEjB;AyH1z0EQ;EACI,WlHaJ;AP+y0ER;AyH1z0EQ;EACI,+BAAA;AzH4z0EZ;;A0Hn10EA;EACE,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,uBAAA;A1Hs10EF;;A0Hn10EA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;A1Hs10EF;;A0Hn10EA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;A1Hs10EF;;A0Hn10EA;EACE,6BAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,iCAAA;A1Hs10EF;;A0Hn10EA;EACE,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EAAc,mGAAA;EACd,WAAA;EACA,mBAAA;EACA,cAAA;EAAgB,mFAAA;EAChB,eAAA;EAAiB,kDAAA;EACjB,gBAAA;EAAkB,0CAAA;EAClB,qBAAA;EACA,uBAAA;A1H010EF;;A0Hv10EA;;EAEE,aAAA;A1H010EF;;A0Hv10EA;;EAEE,YAAA;EACA,cAAA;A1H010EF;;A0Hv10EA;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;A1H010EF;;A0Hv10EA;EACE,8BAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;A1H010EF;;A0Hv10EA;EACE,mBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;A1H010EF;;A0Hv10EA;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;A1H010EF;;A0Hv10EA;EACE,oBAAA;EACA,iBAAA;EACA,yBAAA;A1H010EF;;A0Hv10EA;EACE,mBAAA;A1H010EF;;A0Hv10EA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;A1H010EF;;A0Hv10EA;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,+BAAA;A1H010EF;;A0Hv10EA;EACE,0DAAA;EACA,YAAA;EACA,6BAAA;A1H010EF;;A0Hv10EA;EACE,MAAA;EACA,WAAA;A1H010EF;;A0Hv10EA;EACE,QAAA;EACA,WAAA;A1H010EF;;A0Hv10EA;EACE,OAAA;EACA,YAAA;A1H010EF;;A0Hv10EA;EACE,YAAA;EACA,SAAA;EACA,UAAA;A1H010EF;;A0Hv10EA;EACE,WAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;A1H010EF;;A0Hv10EA,gBAAA;AACA;EACE,WAAA;EACA,OAAA;A1H010EF;;A0Hv10EA;EACE,cAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A1H010EF;;A0Hv10EA;EACE,eAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;A1H010EF;;A0Hv10EA;EACE,YAAA;A1H010EF;;A0Hr10EI;EACE,mBnHuIS;APit0Ef;;A0Hz10EI;EACE,mBnHuIS;APqt0Ef;;A0H710EI;EACE,mBnHuIS;APyt0Ef;;A0Hj20EI;EACE,mBnHuIS;AP6t0Ef;;A0Hr20EI;EACE,mBnHuIS;APiu0Ef;;A0Hz20EI;EACE,mBnHuIS;APqu0Ef;;A0H720EI;EACE,mBnHuIS;APyu0Ef;;A0Hj30EI;EACE,mBnHuIS;AP6u0Ef;;A0Hr30EI;EACE,mBnHuIS;APiv0Ef;;A0Hz30EI;EACE,mBnHuIS;APqv0Ef;;A0H730EI;EACE,mBnHuIS;APyv0Ef;;A0Hj40EI;EACE,mBnHuIS;AP6v0Ef;;A0Hr40EI;EACE,mBnHuIS;APiw0Ef;;A0Hz40EI;EACE,mBnHuIS;APqw0Ef;;A0H740EI;EACE,mBnHuIS;APyw0Ef;;A0Hj50EI;EACE,gBnHuIS;AP6w0Ef;;A0Hr50EI;EACE,mBnHuIS;APix0Ef;;A2Hvn1EA;;;;EAAA;AAMA;;EAEI,YAAA;EACA,gBAAA;EACA,wBAAA;EACA,sEAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EAIA,WAAA;EAKA,aAAA;A3Hun1EJ;;A2H5m1EA;;;;EAII,iBAAA;EACA,mBAAA;A3Hun1EJ;;A2Hpn1EA;EACI;;IAEI,iBAAA;E3Hun1EN;AACF;A2Hpn1EA,gBAAA;AACA;EACI,YAAA;EACA,SAAA;EACA,cAAA;A3Hsn1EJ;;A2Hnn1EA;;EAEI,sCAAA;A3Hsn1EJ;;A2Hnn1EA,gBAAA;AACA;EACI,cAAA;EACA,oBAAA;EACA,mBAAA;A3Hsn1EJ;;A2Hnn1EA;;;;EAII,gBAAA;A3Hsn1EJ;;A2Hnn1EA;EACI,WAAA;A3Hsn1EJ;;A2Hnn1EA;EACI,YAAA;A3Hsn1EJ;;A2Hnn1EA;;;;;;;EAOI,cpHxBE;AP8o1EN;;A2Hnn1EA;;;;;;EAMI,WAAA;A3Hsn1EJ;;A2Hnn1EA;;;;;EAKI,cAAA;EACA,oEAAA;EACA,oCAAA;A3Hsn1EJ;;A2Hnn1EA;;;EAGI,WAAA;A3Hsn1EJ;;A2Hnn1EA;;EAEI,cAAA;A3Hsn1EJ;;A2Hnn1EA;;;EAGI,WAAA;A3Hsn1EJ;;A2Hnn1EA;;EAEI,iBAAA;A3Hsn1EJ;;A2Hpn1EA;EACI,kBAAA;A3Hun1EJ;;A2Hpn1EA;EACI,YAAA;A3Hun1EJ;;A2Hpn1EA,iBAAA;AACA;;EAEI,mBpH7GO;APou1EX;;A2Hpn1EA;;EAEI,cpH9GO;EoH+GP,iBAAA;A3Hun1EJ;;A2H/m1EI;EACI,wBAAA;A3Hkn1ER;A2H/m1EI;EACI,WAAA;A3Hin1ER;A2H9m1EI;EACI,YAAA;A3Hgn1ER;A2H7m1EI;EACI,qDAAA;EACA,mBAAA;EACA,iCAAA;A3H+m1ER;A2H5m1EI;EACI,mBAAA;EACA,iCAAA;A3H8m1ER;;A2Hvm1EA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;A3H0m1EJ;;A2Hrm1EA;EACI,6BAAA;EACA,sBAAA;EACA,qBAAA;A3Hwm1EJ;;A2Hrm1EA;EACI,qBAAA;A3Hwm1EJ;A2Hvm1EI;EACI,gCAAA;EACA,kCAAA;EACA,mCAAA;EACA,gJAAA;EACA,gCAAA;EACA,sDAAA;EACA,6BAAA;EACA,yBAAA;EACA,2BAAA;A3Hym1ER;A2Hxm1EQ;EACI,wBAAA;EACA,2BAAA;A3H0m1EZ;A2Hxm1EQ;EACI,oCAAA;EACA,sBAAA;A3H0m1EZ;;A4Hx01EE;EACE,oBAAA;EACA,eAAA;EACA,gBrHgqBiB;AP2q0ErB;;A4Hv01EA;EACE,oBAAA;EACA,yCrHkkD4B;EqHjkD5B,wCAAA;EACA,2BAAA;A5H001EF;A4Hx01EE;EACE,8BAAA;A5H001EJ;A4Hv01EE;EACE,2BAAA;A5Hy01EJ;;A4Hr01EA;EACE,4CAAA;EACA,2BAAA;A5Hw01EF;;A4Hr01EA;EACE,eAAA;A5Hw01EF;;A4Hp01EE;EACE,qBrHoCG;EqHnCH,crHmCG;APoy1EP;A4Hp01EI;EACE,yBrH6BE;APyy1ER;A4Hn01EI;EACE,qCAAA;A5Hq01EN;A4Hl01EE;EACE,qBrHoBK;EqHnBL,crHmBK;APiz1ET;;A4H/z1EE;EACE,gBAAA;A5Hk01EJ;;A4H9z1EA;EACE,qDAAA;A5Hi01EF;;A4H9z1EA;EACE,yCAAA;A5Hi01EF;;A4H7z1EE;EACE,mBrH6PY;APmk1EhB;A4H/z1EI;EACE,mBrH2PU;APsk1EhB;A4Hh01EM;EACE,oCAAA;A5Hk01ER;A4H9z1EE;EACE,mBrHoPY;AP4k1EhB;;A4H3z1EE;EACE,qCAAA;EACA,sCAAA;A5H8z1EJ;;A4H1z1EA;EACE,+CAAA;A5H6z1EF;A4H5z1EE;EACE,gBAAA;EACA,6CrH83BuB;APg8zE3B;;A4H1z1EA;EACE,YAAA;EACA,cAAA;EACA,sBAAA;EjHuLI,mBALI;EiH/KR,gBrH6jBmB;EqH5jBnB,gBrHokBiB;EqHnkBjB,2BrHw2BY;EqHv2BZ,2CrHk2BS;EqHj2BT,4BAAA;EACA,kEAAA;A5H4z1EF;;A4Hzz1EA;EACE,sCrHwiBiB;EqHviBjB,gBrHkjBkB;EqHjjBlB,eAAA;A5H4z1EF;A4H3z1EE;EACE,gBAAA;A5H6z1EJ;A4H1z1EE;EACE,crH0MY;APkn1EhB;;A4Hxz1EA;EACE,6BAAA;A5H2z1EF;;A6Hv71EA;EACE,iBAAA;EACA,yCAAA;EACA,kCAAA;EACA,kBAAA;A7H071EF;A6Hx71EE;EACE,eAAA;EACA,WAAA;EACA,aAAA;A7H071EJ;;A8Hn81EA;EACE,mBvHmEM;APm41ER;;A8Hn81EA;EACE,mBvH+DM;EuH9DN,mCAAA;EACA,gBAAA;A9Hs81EF;;A8Hn81EA;EACE,WAAA;A9Hs81EF;A8Hr81EE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,SAAA;A9Hu81EJ;A8Hr81EI;EACE,aAAA;A9Hu81EN;A8Hr81EI;EACE,UAAA;A9Hu81EN;;A8Hl81EA;EACE,YAAA;A9Hq81EF;;A8Hh81EA;EACE,sBAAA;EACA,oCAAA;EACA,sCvH+7CsB;EuH97CtB,wCAAA;EACA,2BAAA;A9Hm81EF;;A8H971EA;EACE,UAAA;A9Hi81EF;A8Hh81EE;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;A9Hk81EJ;A8Hj81EI;EACE,aAAA;A9Hm81EN;A8Hj81EI;EACE,UAAA;A9Hm81EN;A8H/71EE;EACE,MAAA;A9Hi81EJ;;A8H771EA;EACE,eAAA;A9Hg81EF;;A8H571EE;EACE,YAAA;A9H+71EJ;;A8H371EA;EACE,gBAAA;A9H871EF;;A8H371EA;EACE,gBAAA;EACA,iCAAA;EACA,6BAAA;A9H871EF;;A8H171EE;EACE,UAAA;A9H671EJ;;A8Hv71EA;EACC,YAAA;EACA,qBAAA;EACA,aAAA;A9H071ED;;A8Hv71EA;EACC,aAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,wCAAA;A9H071ED;;A8Hv71EA;EACC,iBAAA;EACA,aAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,wCAAA;EACG,mBAAA;EACA,kBAAA;A9H071EJ;;A8Ht71EI;EACI,mBvHxDF;APi/1EN;;A8Hp71EI;EACI,mBvH3DA;APk/1ER;;A8Hl71EI;EACI,mBvH4LQ;APyv1EhB;;A8H961EI;EACI,2BAAA;A9Hi71ER;;A8H161EA;EACI,eAAA;EACA,gCAAA;EACA,cAAA;EACA,cAAA;A9H661EJ;A8H561EI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;A9H861ER;;A8Hx61EA;EACI,aAAA;A9H261EJ;;A8Hz61EA;EACI,cAAA;A9H461EJ;;A8Hv61EA;EAAa,mBvH1GP;APqh2EN;;A8H161EA;EAAa,mBvHzGJ;APuh2ET;;A8H761EA;EAAa,mBvHzGL;AP0h2ER;;A8Hh71EA;EAAa,mBvHmJG;APiy1EhB;;A8Hn71EA;EAAa,mBvHhHJ;APui2ET;;A8Hn71EA;EACI,YAAA;A9Hs71EJ;A8Hp71EQ;EACI,qBvHtHN;AP4i2EN;;A8Hj71EA;EACE,wCAAA;A9Ho71EF;;A8Hj71EA;EACE,2BAAA;A9Ho71EF;;A8H761EI;EACE,mBvHwJS;APwx1Ef;A8H761EI;EACE,mBvHoJS;AP2x1Ef;A8H361EM;EACE,qBvH+IO;AP8x1Ef;;A8Hv71EI;EACE,mBvHwJS;APky1Ef;A8Hv71EI;EACE,mBvHoJS;APqy1Ef;A8Hr71EM;EACE,qBvH+IO;APwy1Ef;;A8Hj81EI;EACE,mBvHwJS;AP4y1Ef;A8Hj81EI;EACE,mBvHoJS;AP+y1Ef;A8H/71EM;EACE,qBvH+IO;APkz1Ef;;A8H381EI;EACE,mBvHwJS;APsz1Ef;A8H381EI;EACE,mBvHoJS;APyz1Ef;A8Hz81EM;EACE,qBvH+IO;AP4z1Ef;;A8Hr91EI;EACE,mBvHwJS;APg01Ef;A8Hr91EI;EACE,mBvHoJS;APm01Ef;A8Hn91EM;EACE,qBvH+IO;APs01Ef;;A8H/91EI;EACE,mBvHwJS;AP001Ef;A8H/91EI;EACE,mBvHoJS;AP601Ef;A8H791EM;EACE,qBvH+IO;APg11Ef;;A8Hz+1EI;EACE,mBvHwJS;APo11Ef;A8Hz+1EI;EACE,mBvHoJS;APu11Ef;A8Hv+1EM;EACE,qBvH+IO;AP011Ef;;A8Hn/1EI;EACE,mBvHwJS;AP811Ef;A8Hn/1EI;EACE,mBvHoJS;APi21Ef;A8Hj/1EM;EACE,qBvH+IO;APo21Ef;;A8H7/1EI;EACE,mBvHwJS;APw21Ef;A8H7/1EI;EACE,mBvHoJS;AP221Ef;A8H3/1EM;EACE,qBvH+IO;AP821Ef;;A8Hvg2EI;EACE,mBvHwJS;APk31Ef;A8Hvg2EI;EACE,mBvHoJS;APq31Ef;A8Hrg2EM;EACE,qBvH+IO;APw31Ef;;A8Hjh2EI;EACE,mBvHwJS;AP431Ef;A8Hjh2EI;EACE,mBvHoJS;AP+31Ef;A8H/g2EM;EACE,qBvH+IO;APk41Ef;;A8H3h2EI;EACE,mBvHwJS;APs41Ef;A8H3h2EI;EACE,mBvHoJS;APy41Ef;A8Hzh2EM;EACE,qBvH+IO;AP441Ef;;A8Hri2EI;EACE,mBvHwJS;APg51Ef;A8Hri2EI;EACE,mBvHoJS;APm51Ef;A8Hni2EM;EACE,qBvH+IO;APs51Ef;;A8H/i2EI;EACE,mBvHwJS;AP051Ef;A8H/i2EI;EACE,mBvHoJS;AP651Ef;A8H7i2EM;EACE,qBvH+IO;APg61Ef;;A8Hzj2EI;EACE,mBvHwJS;APo61Ef;A8Hzj2EI;EACE,mBvHoJS;APu61Ef;A8Hvj2EM;EACE,qBvH+IO;AP061Ef;;A8Hnk2EI;EACE,gBvHwJS;AP861Ef;A8Hnk2EI;EACE,gBvHoJS;APi71Ef;A8Hjk2EM;EACE,kBvH+IO;APo71Ef;;A8H7k2EI;EACE,mBvHwJS;APw71Ef;A8H7k2EI;EACE,mBvHoJS;AP271Ef;A8H3k2EM;EACE,qBvH+IO;AP871Ef;;A8Hpk2EE;EACE,YAAA;A9Huk2EJ;A8Hrk2EI;EACE,WAAA;EACA,YAAA;A9Huk2EN;;A8Hjk2EE;EACE,WAAA;A9Hok2EJ;A8Hlk2EI;EACE,WAAA;EACA,YAAA;A9Hok2EN;;A8H9j2EE;EACE,WAAA;A9Hik2EJ;A8H/j2EI;EACE,WAAA;EACA,YAAA;A9Hik2EN;;A8Hzj2EE;EACE,UAAA;EACA,kBAAA;EACA,WAAA;A9H4j2EJ;A8H1j2EE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;A9H4j2EJ;;A8Hvj2EE;EACE,qBvHxMI;EuHyMJ,wCvHoqCM;APs5zEV;;A8Hrj2EE;EACE,kBAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,qBvHpNI;EuHqNJ,wCvHwpCM;APg6zEV;;A+Hh12EI;EACI,2CAAA;EACA,uCAAA;A/Hm12ER;;A+H/02EA;EACI,eAAA;A/Hk12EJ;;A+H702EI;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;A/Hg12ER;A+H902EI;EACI,kBAAA;A/Hg12ER;;AgI122EA;EACI,kCAAA;EACA,4CzHkmBS;AP2w1Eb;;AgIx22EQ;EACI,iCAAA;EACA,uBAAA;AhI222EZ;AgIx22EQ;EACI,2CAAA;AhI022EZ;AgIz22EY;EACI,wCAAA;AhI222EhB;;AgIr22EA;EACI,iCAAA;AhIw22EJ;;AgIr22EA;EACI,eAAA;EACA,gBzH0oBiB;EyHzoBjB,2BAAA;AhIw22EJ;;AgIr22EA;EACI,gBzHkgDc;EyHjgDd,mBzH6nBa;EyH5nBb,2BAAA;AhIw22EJ;;AgIp22EI;EACI,mBAAA;EACA,WzHPA;AP822ER;AgIp22EI;EACI,2CAAA;EACA,2BAAA;AhIs22ER;AgIn22EI;EACI,mBAAA;EACA,WzHjBA;APs32ER;;AgIj22EA;EACI,0BAAA;AhIo22EJ;;AgIl22EA;;EAEI,YAAA;EACA,wBAAA;EACA,eAAA;EACA,UAAA;EACA,wCAAA;EACA,uBAAA;EACA,wBAAA;AhIq22EJ;;AgIl22EA;EACI,UAAA;AhIq22EJ;;AgIl22EA;EACI,oBAAA;AhIq22EJ;;AiI962EA;;EAEI,uBAAA;EACA,sBAAA;EACA,0CAAA;EACA,0BAAA;EACA,kBAAA;AjIi72EJ;AiI/62EI;;EACI,iCAAA;EACA,0BAAA;EACA,cAAA;EACA,yBAAA;AjIk72ER;;AiI762EI;EACI,uBAAA;AjIg72ER;;AiI362EI;EACI,uBAAA;AjI862ER;;AiI162EA;EACI,sBAAA;EACA,sBAAA;EACA,iCAAA;EACA,8BAAA;EACA,2BAAA;AjI662EJ;AiI362EI;EACI,qBAAA;AjI662ER;;AiIx62EI;EACI,qBAAA;EACA,sBAAA;EACA,sB1HXA;E0HYA,YAAA;EACA,yBAAA;AjI262ER;AiIz62EQ;EACI,UAAA;EACA,WAAA;AjI262EZ;;AiIt62EA;EACI,W1HvBI;E0HwBJ,eAAA;EACA,oCAAA;EACA,0BAAA;AjIy62EJ;;AiIp62EI;EACI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,sB1HpCA;E0HqCA,YAAA;EACA,yBAAA;AjIu62ER;AiIr62EQ;EACI,c1H2PM;E0H1PN,UAAA;AjIu62EZ;;AiIl62EA;EACI,sBAAA;EACA,0CAAA;AjIq62EJ;AiIn62EI;EACI,yB1HhBA;APq72ER;;AiIh62EA;EACI,2CAAA;EACA,0BAAA;EACA,cAAA;EACA,sBAAA;AjIm62EJ;AiIj62EI;EACI,sB1HhEA;APm+2ER;;AiI952EI;EACI,oCAAA;AjIi62ER;AiI752EQ;EACI,oCAAA;AjI+52EZ;AiI152EQ;EACI,W1HjFJ;AP6+2ER;AiI152EY;EACI,UAAA;AjI452EhB;AiIv52EI;EACI,wCAAA;AjIy52ER;;AkInh3EA;EACE,YAAA;EACA,kBAAA;AlIsh3EF;AkIph3EE;EACE,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gCAAA;EACA,iCAAA;EACA,UAAA;AlIsh3EJ;AkInh3EE;EACE,+CAAA;EACA,2C3Hk7BO;E2Hj7BP,+B3HmjBY;E2HljBZ,kC3HkjBY;APm+1EhB;AkIjh3EI;EACE,wBAAA;AlImh3EN;AkIhh3EI;EACE,WAAA;AlIkh3EN;AkI/g3EI;EACE,WAAA;AlIih3EN;AkI9g3EI;EACE,+CAAA;EACA,mBAAA;EACA,2CAAA;AlIgh3EN;AkI7g3EI;EACE,mBAAA;EACA,2C3Hw5BK;APun1EX;AkI3g3EE;EACE,eAAA;AlI6g3EJ;AkI1g3EE;EACE,2B3Ho5BU;APwn1Ed;AkI3g3EI;EACE,0CAAA;AlI6g3EN;AkIzg3EE;EACE,+CAAA;EACA,qC3Hu4BO;E2Ht4BP,gC3HwgBY;E2HvgBZ,mC3HugBY;APog2EhB;AkIxg3EE;EACE,cAAA;EACA,sBAAA;EAEA,mB3HglBa;E2H/kBb,2B3Hk4BU;E2Hj4BV,2C3H43BO;E2H33BP,kEAAA;EACA,sC3Ho4BkB;E2Hn4BlB,mBAAA;AlIyg3EJ;AkIxg3EI;EACE,gC3H24BoB;AP+n1E1B;AkItg3EE;EACE,gB3H4kBmB;E2H3kBnB,yBAAA;AlIwg3EJ;;AmInm3EA;EACE,kCAAA;EACA,6C5HomBc;E4HnmBd,kBAAA;EACA,wCAAA;AnIsm3EF;;AmIlm3EE;EACE,wCAAA;EACA,gDAAA;EACA,kBAAA;EACA,gB5H4lBa;APyg2EjB;AmIpm3EI;EACE,kBAAA;AnIsm3EN;;AmI9l3EM;EACE,oBAAA;EACA,cAAA;AnIim3ER;AmI9l3EM;EACE,mBAAA;EACA,eAAA;AnIgm3ER;AmI1l3EI;EACE,eAAA;AnI4l3EN;AmIvl3EI;EACE,mB5HwRU;APi02EhB;AmItl3EI;EACE,2C5H85BK;E4H75BL,2B5Hk6BQ;E4Hj6BR,+CAAA;EACA,sC5Hq6BgB;APmr1EtB;AmIrl3EI;EACE,iDAAA;AnIul3EN;AmItl3EM;EACE,gBAAA;EACA,2C5Ho5BG;E4Hn5BH,6C5Hk6BmB;APsr1E3B;AmIpl3EI;EACE,8BAAA;AnIsl3EN;AmInl3EI;EACE,8BAAA;AnIql3EN;;AoIvp3EA;EACE,gBAAA;ApI0p3EF;AoIvp3EI;EACE,eAAA;ApIyp3EN;;AoIpp3EA;EACE,yCAAA;EACA,8BAAA;ApIup3EF;;AoIpp3EA;EACE,2BAAA;ApIup3EF;AoItp3EE;EACE,gB7HmpBiB;APqg2ErB;;AoIpp3EA;EACE,aAAA;ApIup3EF;;AoIpp3EA;EACE,oCAAA;ApIup3EF;;AqIjr3EA;;EAEI,wBAAA;EACA,YAAA;ArIor3EJ;;AqIjr3EA;EACI,+CAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;EvHIA,sCAAA;EuHFA,qC9H+7BO;E8H97BP,YAAA;ArIor3EJ;AqIlr3EI;EACI,UAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,2B9H27BM;E8H17BN,sC9H+7Bc;APqv1EtB;AqIlr3EQ;EACI,UAAA;ArIor3EZ;AqIhr3EI;EACI,YAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,2BAAA;EACA,2BAAA;EACA,YAAA;EACA,sC9Hi3BY;APi01EpB;AqI/q3EI;EACI,2BAAA;ArIir3ER;AqI/q3EQ;EACI,2C9H65BD;APox1EX;AqI7q3EI;EACI,2BAAA;ArI+q3ER;AqI7q3EQ;EACI,2C9Hq5BD;AP0x1EX;AqI3q3EI;EACI,aAAA;EACA,WAAA;ArI6q3ER;AqI3q3EQ;EACI,cAAA;ArI6q3EZ;AqI1q3EQ;EACI,YAAA;ArI4q3EZ;;AqInq3EY;EACI,yB9HoRD;E8HnRC,W9H9CR;APot3ER;;AqIxq3EY;EACI,yB9HoRD;E8HnRC,W9H9CR;APyt3ER;;AqI7q3EY;EACI,yB9HoRD;E8HnRC,W9H9CR;AP8t3ER;;AqIlr3EY;EACI,yB9HoRD;E8HnRC,W9H9CR;APmu3ER;;AqIvr3EY;EACI,yB9HoRD;E8HnRC,W9H9CR;APwu3ER;;AqI5r3EY;EACI,yB9HoRD;E8HnRC,W9H9CR;AP6u3ER;;AqIjs3EY;EACI,yB9HoRD;E8HnRC,W9H9CR;APkv3ER;;AqIts3EY;EACI,yB9HoRD;E8HnRC,W9H9CR;APuv3ER;;AqI3s3EY;EACI,yB9HoRD;E8HnRC,W9H9CR;AP4v3ER;;AqIht3EY;EACI,yB9HoRD;E8HnRC,W9H9CR;APiw3ER;;AqIrt3EY;EACI,yB9HoRD;E8HnRC,W9H9CR;APsw3ER;;AqI1t3EY;EACI,yB9HoRD;E8HnRC,W9H9CR;AP2w3ER;;AqI/t3EY;EACI,yB9HoRD;E8HnRC,W9H9CR;APgx3ER;;AqIpu3EY;EACI,yB9HoRD;E8HnRC,W9H9CR;APqx3ER;;AqIzu3EY;EACI,yB9HoRD;E8HnRC,W9H9CR;AP0x3ER;;AqI9u3EY;EACI,sB9HoRD;E8HnRC,W9H9CR;AP+x3ER;;AqInv3EY;EACI,yB9HoRD;E8HnRC,W9H9CR;APoy3ER;;AsIr03EA;EACI,iDAAA;AtIw03EJ;AsIt03EI;EACI,sCAAA;AtIw03ER;AsIt03EI;EACI,sDAAA;AtIw03ER;AsIr03EI;EACI,gBAAA;AtIu03ER;AsIp03EI;EACI,0DAAA;AtIs03ER;AsIp03EQ;EACI,0BAAA;AtIs03EZ;AsIn03EQ;EACI,kCAAA;AtIq03EZ;AsIj03EI;EACI,wBAAA;EACA,mDAAA;EACA,sDAAA;EACA,2BAAA;AtIm03ER;AsIh03EI;EACI,6CAAA;EACA,6C/HmkBQ;E+HlkBR,6BAAA;EACA,wBAAA;EACA,yBAAA;EACA,yC/HqxCiB;AP6i1EzB;AsI/z3EI;EACI,6CAAA;AtIi03ER;AsI5z3EY;EAEI,OAAA;EACA,sBAAA;AtI6z3EhB;AsIvz3EQ;EACI,2BAAA;AtIyz3EZ;AsIrz3EI;EACI,wDAAA;EACA,oDAAA;EACA,mDAAA;AtIuz3ER;;AsIhz3EI;;;EACI,2BAAA;EACA,4CAAA;AtIqz3ER;AsIjz3EQ;;EACI,sCAAA;AtIoz3EZ;AsIhz3EI;;EACI,sCAAA;AtImz3ER;;AsI/y3EA;;EAEI,iCAAA;EACA,uCAAA;EACA,wCAAA;AtIkz3EJ;;AsI/y3EA;;EAEI,iCAAA;EACA,oCAAA;EACA,qCAAA;AtIkz3EJ;;AsI/y3EA;EACI,4BAAA;AtIkz3EJ;;AsI/y3EA;EACI,2BAAA;AtIkz3EJ;;AsI3y3EY;;;EAEI,2BAAA;AtI+y3EhB;;AsIvy3EQ;EACI,8BAAA;EACA,yBAAA;AtI0y3EZ;AsIty3EI;EACI,gDAAA;EACA,0DAAA;AtIwy3ER;AsIvy3EQ;EACI,4DAAA;EACA,2BAAA;AtIyy3EZ;AsIry3EI;EACI,6CAAA;EACA,mDAAA;AtIuy3ER;AsIpy3EY;EACI,sDAAA;AtIsy3EhB;AsIny3EY;EACI,sDAAA;AtIqy3EhB;;AsI7x3EA;EACI,6CAAA;AtIgy3EJ;;AsI1x3EI;EACE,aAAA;EACA,8BAAA;AtI6x3EN;AsIzx3EM;EACE,0DAAA;EACA,2BAAA;AtI2x3ER;AsIvx3EI;;EAEE,iCAAA;EACA,uCAAA;EACA,wCAAA;AtIyx3EN;AsItx3EI;;EAEE,iCAAA;EACA,oCAAA;EACA,qCAAA;AtIwx3EN;;AsInx3EI;EACI,2BAAA;AtIsx3ER;;AuIv93EA;EACI,gBAAA;AvI093EJ;AuIx93EI;;EAEI,mBAAA;EACA,gBAAA;AvI093ER;AuIv93EI;EACI,mBAAA;EACA,mBAAA;EACA,iBAAA;AvIy93ER;;AuIr93EA;EACI,sChIuoBe;APi12EnB;AuIt93EI;EACI,2ChI87Ba;EgI77Bb,8BAAA;EACA,+BAAA;AvIw93ER;;AuIp93EA;EACI,kEAAA;EACA,sChI07BkB;AP6h2EtB;;AuIp93EA;EACI,iDAAA;AvIu93EJ;AuIr93EI;EACI,wBAAA;EACA,2BAAA;AvIu93ER;AuIr93EQ;EACI,yBAAA;AvIu93EZ;AuIn93EI;EACI,2BAAA;EACA,4BAAA;EACA,2ChIo6Ba;APij2ErB;AuIl93EY;EACI,yBAAA;AvIo93EhB;AuIh93EQ;EACI,6ChI+iBI;EgI9iBJ,yChIowCa;AP8s1EzB;;AuI383EI;;;EAGI,4BAAA;AvI883ER;AuI383EI;EACI,0BAAA;AvI683ER;AuIz83EQ;EACI,QAAA;EACA,UAAA;AvI283EZ;AuIt83EQ;EACI,gCAAA;AvIw83EZ;;AuIl83EI;EACI,wCAAA;EACA,+CAAA;AvIq83ER;;AwI/h4EA;EACI,2BjIsyBU;EiIryBV,UAAA;EACA,cAAA;AxIki4EJ;;AwI/h4EA;EACI,gBAAA;EACA,wCAAA;EACA,kBAAA;AxIki4EJ;AwIhi4EI;EACI,wBAAA;AxIki4ER;AwI/h4EI;EACI,WAAA;AxIii4ER;AwI9h4EI;EACI,YAAA;AxIgi4ER;AwI7h4EI;EACI,iDAAA;EACA,mBAAA;EACA,wCAAA;AxI+h4ER;AwI5h4EI;EACI,mBAAA;EACA,wCAAA;AxI8h4ER;;AwI1h4EA;EACI,uBAAA;EACA,iBAAA;AxI6h4EJ;;AwI1h4EA;EACI,WAAA;AxI6h4EJ;;AwI1h4EA;EACI,6BjI2vBO;APky2EX;;AwI1h4EA;;EAEI,wCAAA;EACA,uBAAA;AxI6h4EJ;;AwIzh4EI;EACI,aAAA;EACA,2BjI8uBM;EiI7uBN,iDAAA;AxI4h4ER;AwIth4EQ;EAEI,iDAAA;AxIuh4EZ;;AwIlh4EA;EACI,cAAA;AxIqh4EJ;;AwIlh4EA;EACI,gBAAA;EACA,wCAAA;EACA,aAAA;EACA,6BjIytBO;AP4z2EX;;AwIlh4EA;EACI,gCAAA;EACA,0BAAA;AxIqh4EJ;;AwIhh4EI;EACI,mBAAA;EACA,iCAAA;EACA,wCAAA;EACA,wCjIwxCQ;EiIvxCR,2BjIsxCW;AP6v1EnB;AwIjh4EQ;EACI,8CAAA;AxImh4EZ;AwIhh4EQ;EAGI,gCjIqyCgB;EiIpyChB,wCjI6wCI;APmw1EhB;AwI7g4EQ;EACI,uCjIuxCU;EiItxCV,iCjIqxCa;AP0v1EzB;AwI5g4EQ;EACI,gBAAA;AxI8g4EZ;AwIzg4EY;EACI,6BAAA;AxI2g4EhB;AwIvg4EQ;EACI,yBjIuMW;EiItMX,WjI5FJ;EiI6FI,qBjIqMW;EiIpMX,gBjIsiBS;APm+2ErB;;AwIpg4EA;EACI,kBAAA;EACA,WAAA;AxIug4EJ;AwIrg4EI;EACI,YAAA;EACA,wBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,eAAA;EACA,gCAAA;AxIug4ER;;AwIng4EA;EACI,2CjI6zBiB;EiI5zBjB,2CjIszBO;EiIrzBP,2BjI0zBU;EiIzzBV,gBjIohBe;EiInhBf,sCAAA;EACA,sCjI4zBkB;EI3rBhB,mBALI;AX243EV;AwIpg4EI;EACI,gBAAA;EACA,6CjI4zBmB;EiI3zBnB,2CjI4yBG;AP0t2EX;AwIng4EI;EACI,gCjI4zBkB;APys2E1B;;AwIhg4EI;EACI,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,gBjIyfe;AP0g3EvB;;AwI//3EA;EACI,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AxIkg4EJ;;AwI//3EA;EACI,wBAAA;AxIkg4EJ;;AwI9/3EI;EACI,oBAAA;AxIig4ER;;AwIx/3EI;EACI,sBAAA;AxI2/3ER;AwIx/3EI;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;AxI0/3ER;AwIv/3EI;EACI,iBAAA;AxIy/3ER;;AwIn/3EI;EACI,sDjI4lBU;AP052ElB;AwIp/3EI;EACI,yBjIsGe;EiIrGf,qBjIqGe;EiIjGX,0DAAA;AxIm/3EZ;;AwI9+3EI;EACI,YjIwxBiB;EiIvxBjB,ajIuxBiB;EiItxBjB,mBAAA;EACA,2CjIiuBG;EiIhuBH,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,uEjI4xBkB;EiI3xBlB,gBAAA;EACA,iCAAA;UAAA,yBAAA;AxIi/3ER;AwI/+3EQ;E1HpOJ,qBAAA;Adst4EJ;;AwI3+3EI;EACI,qBAAA;EACA,oBAAA;AxI8+3ER;;AwI1+3EA;EACI,wCAAA;AxI6+3EJ;;AwIx+3EQ;EACI,kDjI8gDa;AP690EzB;;AyIlv4EA;EACI,gBAAA;EACA,yBAAA;EACA,QAAA;AzIqv4EJ;AyInv4EQ;EACI,cAAA;EACA,yBAAA;EACA,2BlI42CO;EkI32CP,wClI42CI;EkI32CJ,2DAAA;EACA,sBlImkBI;APkr3EhB;AyIjv4EY;EACI,WlIiBR;EuBjCN,yBvBmUqB;EkIjTP,qBlIiTO;APk83EvB;;AyI7u4EA;EACI,yBAAA;UAAA,iBAAA;EACA,aAAA;EACA,mBAAA;AzIgv4EJ;AyI/u4EI;EACI,qBAAA;EACA,qBAAA;AzIiv4ER;;AyI7u4EA;;EAEI,clI8RY;EkI7RZ,gBlIgoBiB;EkI/nBjB,yBAAA;EACA,wClI80CY;EkI70CZ,2DAAA;EACA,sBlIqiBY;AP2s3EhB;AyI/u4EI;;EACI,YAAA;AzIkv4ER;AyI/u4EI;;EACI,gCAAA;EACA,eAAA;AzIkv4ER;AyIhv4EQ;;EACI,gCAAA;AzImv4EZ;;A0Ity4EA;EACI,2BAAA;A1Iyy4EJ;A0Ivy4EI;EACI,iDAAA;A1Iyy4ER;A0Ity4EI;EACI,cAAA;A1Iwy4ER;;A0Iny4EA;EACI;IACI,UAAA;E1Isy4EN;E0Iny4EE;IACI,UAAA;E1Iqy4EN;AACF;A0Ily4EA;EAEI;IAEI,UAAA;E1Iky4EN;AACF;A0I/x4EA;EACI,kBAAA;EACA,yBAAA;UAAA,iBAAA;A1Iiy4EJ;A0I/x4EI;EACI,wBAAA;EACA,UAAA;A1Iiy4ER;A0I9x4EI;EACI,kBAAA;EACA,oCAAA;EACA,4CAAA;A1Igy4ER;A0I3x4EY;EACI,uBAAA;A1I6x4EhB;A0Ixx4EI;EAEQ;IACI,UAAA;E1Iyx4Ed;AACF;;A0Ipx4EA;EACI,kBAAA;A1Iux4EJ;;A0Ipx4EA;EACI,oBAAA;EACA,oCAAA;A1Iux4EJ;;A0Ipx4EA;EACI,oBAAA;A1Iux4EJ;;A0Ilx4EI;;EACI,iDAAA;EACA,anIzCG;AP+z4EX;;A0Ilx4EA;;EAEI,anIhDO;APq04EX;;A0Ilx4EA;EACI,0BAAA;EACA,YAAA;A1Iqx4EJ;;A0Ilx4EA;EACI,yBAAA;EACA,iDAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBAAA;A1Iqx4EJ;;A0Ijx4EA;EACI,UAAA;A1Iox4EJ;;A0Ijx4EA;EACI,8BAAA;A1Iox4EJ;;A0Ijx4EA;EACI,8BAAA;A1Iox4EJ;;A0Ijx4EA;EACI,kBAAA;EACA,uDAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,0BAAA;A1Iox4EJ;A0Ilx4EI;EACI,UAAA;EACA,0BAAA;A1Iox4ER;A0Ijx4EI;EACI,mDAAA;EACA,6DAAA;A1Imx4ER;A0Ijx4EQ;EACI,6CAAA;EACA,0DAAA;A1Imx4EZ;A0I/w4EI;EACI,WAAA;EACA,iCAAA;A1Iix4ER;A0I/w4EQ;EACI,8BAAA;EACA,6BAAA;A1Iix4EZ;A0I7w4EI;EACI,oBAAA;A1I+w4ER;A0I5w4EI;EACI,YAAA;EACA,eAAA;EACA,kBAAA;A1I8w4ER;;A0I1w4EA;;;EAGI,qBAAA;EACA,gBAAA;EACA,gBAAA;A1I6w4EJ;;A0Ipw4EI;;;;;;EACI,aAAA;A1I4w4ER;;A0Ixw4EA;;EAEI,kBAAA;A1I2w4EJ;;A0Ixw4EA;;;EAGI,aAAA;A1I2w4EJ;;A0Itw4EI;;EACI,gBAAA;A1I0w4ER;;A0Itw4EA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,kBAAA;EACA,kBAAA;A1Iyw4EJ;;A0Itw4EA;EACI,eAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;A1Iyw4EJ;A0Itw4EQ;EACI,UAAA;A1Iww4EZ;A0Ipw4EI;EAEI,mBAAA;A1Iqw4ER;;A0Ijw4EA;EACI,UAAA;EACA,SAAA;EACA,cAAA;EACA,qBAAA;A1Iow4EJ;;A0Ijw4EA;EACI,kBAAA;A1Iow4EJ;;A0Ijw4EA;;EAEI,gBAAA;A1Iow4EJ;;A0Ijw4EA;EACI,aAAA;EACA,8BAAA;A1Iow4EJ;;A0Ihw4EI;EACI,aAAA;A1Imw4ER;A0Ihw4EI;EACI,gBAAA;A1Ikw4ER;;A0I9v4EA;EACI,gBAAA;A1Iiw4EJ;A0I/v4EI;EACI,gBAAA;EACA,WAAA;A1Iiw4ER;A0I9v4EI;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;A1Igw4ER;;A0I5v4EA;;EAEI,UAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;A1I+v4EJ;;A0I5v4EA;EACI,iBAAA;EACA,0BAAA;A1I+v4EJ;A0I7v4EI;EACI,8BAAA;EACA,oCAAA;EACA,WAAA;A1I+v4ER;A0I5v4EI;EAEI,SAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;A1I6v4ER;A0I1v4EI;EACI,yBAAA;EACA,iBAAA;EACA,iBAAA;A1I4v4ER;A0Izv4EI;EACI,yBAAA;EACA,iBAAA;EACA,iBAAA;A1I2v4ER;A0Ixv4EI;EACI,UAAA;EACA,0BAAA;A1I0v4ER;;A0Ipv4EI;EAEI,YAAA;A1Isv4ER;A0Inv4EI;EACI,4BAAA;A1Iqv4ER;A0Ilv4EI;EACI,4BAAA;A1Iov4ER;A0I/u4EQ;EAEI,uCAAA;A1Igv4EZ;;A0Izu4EI;EAEI,SAAA;A1I2u4ER;A0Ixu4EI;EACI,yBAAA;A1I0u4ER;A0Ivu4EI;EACI,yBAAA;A1Iyu4ER;A0Ipu4EQ;EAEI,oCAAA;A1Iqu4EZ;;A0Ihu4EA;EACI,iBAAA;A1Imu4EJ;A0Iju4EI;EACI,8BAAA;EACA,oCAAA;EACA,WAAA;A1Imu4ER;A0Ihu4EI;EAEI,QAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;A1Iiu4ER;A0I9t4EI;EACI,yBAAA;EACA,iBAAA;EACA,gBAAA;A1Igu4ER;A0I7t4EI;EACI,yBAAA;EACA,iBAAA;EACA,gBAAA;A1I+t4ER;A0I5t4EI;EACI,UAAA;A1I8t4ER;;A0Ixt4EI;EAEI,UAAA;A1I0t4ER;A0Ivt4EI;EACI,0BAAA;A1Iyt4ER;A0Itt4EI;EACI,0BAAA;A1Iwt4ER;A0Int4EQ;EAEI,qCAAA;A1Iot4EZ;;A0I7s4EI;EAEI,WAAA;A1I+s4ER;A0I5s4EI;EACI,2BAAA;A1I8s4ER;A0I3s4EI;EACI,2BAAA;A1I6s4ER;A0Ixs4EQ;EAEI,sCAAA;A1Iys4EZ;;A0Ips4EA;EACI,aAAA;A1Ius4EJ;;A0Ips4EA;;EAEI,oBAAA;EACA,UAAA;EACA,0BAAA;A1Ius4EJ;A0Irs4EI;;EACI,UAAA;EACA,0BAAA;A1Iws4ER;;A0Ips4EA;EACI,UAAA;A1Ius4EJ;;A0Ips4EA;EACI,YAAA;A1Ius4EJ;;A0Ips4EA;;EAEI,oBAAA;EACA,UAAA;EACA,kBAAA;A1Ius4EJ;;A0Ils4EI;;EAEI,UAAA;EACA,kBAAA;A1Iqs4ER;A0Ils4EI;;EAEI,iBAAA;EACA,UAAA;EACA,mBAAA;A1Ios4ER;;A0Ihs4EA;EACI,aAAA;EACA,YAAA;EACA,KAAA;A1Ims4EJ;;A0I9r4EQ;EACI,iBAAA;A1Iis4EZ;A0I9r4EQ;EACI,YAAA;A1Igs4EZ;;A0I3r4EA;;;;;;;;EAQI,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;A1I8r4EJ;;A0I1r4EI;EACI,aAAA;A1I6r4ER;;A0Ixr4EI;EACI,UAAA;EACA,sBAAA;A1I2r4ER;;A0Ipr4EQ;EACI,aAAA;A1Iur4EZ;A0Inr4EI;EACI,8BAAA;EACA,WAAA;A1Iqr4ER;;A0Izq4EY;;;;;EACI,UAAA;A1Igr4EhB;A0I1q4EQ;EACI,gBAAA;A1I4q4EZ;;A0Ivq4EA;;EAEI,kBAAA;A1I0q4EJ;;A0Ivq4EA;EACI,gBAAA;A1I0q4EJ;;A0Ivq4EA;;;EAGI,sBAAA;A1I0q4EJ;;A0Ivq4EA;;EAEI,qBAAA;A1I0q4EJ;;A0Ivq4EA;EACI,iBAAA;A1I0q4EJ;;A0Ivq4EA;EACI,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,MAAA;A1I0q4EJ;A0Ixq4EI;EACI,UAAA;EACA,eAAA;EACA,eAAA;A1I0q4ER;A0Itq4EQ;EACI,YAAA;A1Iwq4EZ;;A0Inq4EA;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;A1Isq4EJ;;A0Inq4EA;EACI,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,0BAAA;EACA,oBAAA;A1Isq4EJ;A0Ipq4EI;EACI,UAAA;EACA,mBAAA;EACA,0BAAA;A1Isq4ER;;A0Ilq4EA;EACI,gBAAA;EACA,eAAA;EACA,eAAA;A1Iqq4EJ;;A0Ilq4EA;;;EAGI,UAAA;A1Iqq4EJ;;A0Ilq4EA;;;;;EAKI,eAAA;EACA,oBAAA;A1Iqq4EJ;;A0Ilq4EA;EACI,UAAA;EACA,sBAAA;EACA,wBAAA;EACA,6BAAA;EACA,+BAAA;A1Iqq4EJ;;A0Ilq4EA;;;;;;;;;;;;;;EAcI,oBAAA;A1Iqq4EJ;;A0Ilq4EA;EACI,0BAAA;A1Iqq4EJ;;A0Ilq4EA;EACI,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;A1Iqq4EJ;;A0Ilq4EA;;;EAGI,YAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A1Iqq4EJ;;A0Ijq4EI;EACI,YAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;A1Ioq4ER;A0Ijq4EI;EACI,gBAAA;EACA,WAAA;EACA,YAAA;A1Imq4ER;;A0I/p4EA;;EAEI,UAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,wCAAA;A1Ikq4EJ;;A0I/p4EA;EACI,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,UAAA;A1Ikq4EJ;A0Ihq4EI;EACI,wBAAA;EACA,6BAAA;A1Ikq4ER;;A0I9p4EA;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,6BAAA;A1Iiq4EJ;A0I/p4EI;EACI,sCAAA;EACA,wBAAA;EACA,UAAA;A1Iiq4ER;;A0I7p4EA;EACI;IACI,0BAAA;E1Igq4EN;;E0I7p4EE;IACI,2BAAA;E1Igq4EN;AACF;A0I1p4EI;;EACI,8BAAA;A1I6p4ER;;A0Ivp4EI;;EACI,8BAAA;A1I2p4ER;;A0Itp4EI;EACI,0BAAA;A1Iyp4ER;;A0Ipp4EI;EACI,8BAAA;A1Iup4ER;;A0I/o4EI;;EAEI,8BAAA;A1Ikp4ER;;A0I5o4EI;;EAEI,8BAAA;A1I+o4ER;A0I5o4EI;EACI,qBAAA;A1I8o4ER;;A0Izo4EI;EACI,4CnI9OK;EmI+OL,gCAAA;EACA,kCAAA;EACA,wCAAA;EACA,sCnI9LW;AP004EnB;A0I1o4EQ;EACI,2CAAA;A1I4o4EZ;;A0Iro4EQ;EACI,0DAAA;A1Iwo4EZ;;A0Ilo4EI;EACI,8BAAA;A1Iqo4ER;;A2I5+5EA;EACE,iBAAA;A3I++5EF;;A4Ij/5EA;EACI,aAAA;A5Io/5EJ;;A4Ij/5EA;EACI,aAAA;A5Io/5EJ;;A6Ix/5EA;EACE,aAAA;EACA,mBtI+BS;EsI9BT,kBAAA;A7I2/5EF;;A6Ix/5EA;EACE,cAAA;EACA,kBAAA;EACA,WtIuBM;EsItBN,eAAA;EACA,iBAAA;EACA,mBtIqTc;EsIpTd,kBAAA;EACA,kBAAA;A7I2/5EF;;A6Ix/5EA;EACE,SAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;A7I2/5EF;A6I1/5EE;EACE,aAAA;EACA,mCAAA;EACA,oCAAA;EACA,8BAAA;A7I4/5EJ;A6I1/5EE;EACE,UAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;A7I4/5EJ;;A8I9h6EA;EACI,cAAA;A9Iii6EJ;A8I/h6EI;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EAEA,mBvIqpBS;EuIppBT,gBvI0pBa;EuIzpBb,gBvIiqBW;EuIhqBX,2BvIq8BM;EuIp8BN,2CvI+7BG;EuI97BH,4BAAA;EACA,kEAAA;EACA,sCvIs8Bc;EuIr8Bd,sBAAA;A9Igi6ER;A8I9h6EQ;EACI,qBAAA;EACA,2CAAA;EACA,8BAAA;A9Igi6EZ;A8I7h6EQ;EACI,oEAAA;EACA,2BvIs7BE;APym4Ed;A8I5h6EQ;EACI,2BvIk7BE;AP4m4Ed;A8I1h6EI;EACI,sBvI0iBQ;EuIziBR,oCvIsxCgB;EuIrxChB,wCvIoxCM;EuInxCN,6CvI+jBQ;EuI9jBR,UAAA;EACA,cAAA;EACA,iBAAA;EACA,SAAA;EACA,6BAAA;EACA,wBAAA;EACA,yBAAA;A9I4h6ER;A8I1h6EQ;EACI,mBvI6mBK;EuI5mBL,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,wCvIqwCE;EuIpwCF,2BvImwCK;APyx3EjB;A8I1h6EY;EACI,cvISV;EuIRU,gBvI4mBO;EuI3mBP,YAAA;A9I4h6EhB;A8Izh6EY;EAEI,2BvIqwCM;EuBr0CpB,uCvBu0CuB;APox3EzB;A8Ith6EQ;EACI,sBAAA;EACA,kBAAA;EACA,gBvI6lBS;AP274ErB;;A+Ihm6EA;EACI,kBAAA;EACA,mCAAA;EACA,sCxIqpBe;EwIppBf,6CxIkmBY;EwIjmBZ,gBAAA;A/Imm6EJ;;A+I/l6EI;EACI,sCxI8oBW;EwI7oBX,mBxImpBS;EwIlpBT,0BAAA;A/Ikm6ER;;A+I9l6EA;EACI,mCAAA;A/Iim6EJ;;AgJln6EA;EACI,aAAA;AhJqn6EJ;AgJpn6EI;EACI,UAAA;EACA,gCzIOc;AP+m6EtB;;AiJzn6EA;;EAEI,2DAAA;AjJ4n6EJ;;AiJvn6EQ;EACI,eAAA;EACA,iBAAA;EACA,yBAAA;AjJ0n6EZ;AiJvn6EQ;EAEI;;;IAGI,WAAA;IACA,cAAA;IACA,kBAAA;IACA,WAAA;IACA,cAAA;EjJwn6Ed;EiJrn6EU;IACI,WAAA;EjJun6Ed;EiJpn6EU;IACI,aAAA;EjJsn6Ed;AACF;AiJnn6EQ;EACI,0BAAA;AjJqn6EZ;AiJjn6EI;EACI,iCAAA;AjJmn6ER;AiJhn6EI;EACI,cAAA;EACA,gBAAA;EACA,2BAAA;AjJkn6ER;AiJ/m6EI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gB1I0mBa;E0IzmBb,WAAA;EACA,2BAAA;AjJin6ER;AiJ7m6EQ;EACI,0CAAA;AjJ+m6EZ;AiJ7m6EY;EACI,yB1I6PA;E0I5PA,W1IrCR;APop6ER;AiJzm6EQ;EACI,0CAAA;AjJ2m6EZ;AiJtm6EQ;EACI,0CAAA;AjJwm6EZ;AiJpm6EI;EACI,uBAAA;AjJsm6ER;AiJlm6EQ;EACI,sBAAA;AjJom6EZ;AiJhm6EI;;;EAGI,sBAAA;AjJkm6ER;AiJ/l6EI;EACI,gEAAA;EACA,+DAAA;AjJim6ER;AiJ9l6EI;EACI,SAAA;AjJgm6ER;AiJ7l6EI;EACI,aAAA;AjJ+l6ER;;AiJ3l6EA;EACI,2BAAA;AjJ8l6EJ;;AiJ3l6EA;EACI,W1IzFI;APur6ER;;AiJ1l6EI;EACI,mB1I3FG;E0I4FH,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,gB1IoiBW;APyj5EnB;;AiJvl6EI;;;;;;;;;;EAUI,qB1I/GG;APys6EX;AiJvl6EI;EACI,mBAAA;AjJyl6ER;;AiJrl6EA;EACI,kCAAA;EACA,oCAAA;EACA,c1ItHO;E0IuHP,0BAAA;EACA,gBAAA;EACA,4BAAA;EACA,uBAAA;AjJwl6EJ;;AiJrl6EA;;;EAGI,yB1I0JY;E0IzJZ,W1IxII;E0IyIJ,iBAAA;AjJwl6EJ;;AiJrl6EA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AjJwl6EJ;;AiJrl6EA;;EAEI,yB1IyIY;AP+85EhB;;AiJrl6EA;;EAEI,yB1IoIY;APo95EhB;;AiJrl6EA;;EAEI,2BAAA;EACA,uBAAA;EACA,mBAAA;AjJwl6EJ;;AiJrl6EA;EACI,6BAAA;EACA,aAAA;AjJwl6EJ;;AiJrl6EA;EACI,aAAA;AjJwl6EJ;;AiJrl6EA;EACI,W1IjLI;APyw6ER;;AiJpl6EI;EACI,gBAAA;EACA,iBAAA;EACA,aAAA;AjJul6ER;;AiJjl6EI;EACI,c1I9LG;APkx6EX;;AiJhl6EA;;EAEI,kBAAA;EACA,cAAA;EACA,aAAA;AjJml6EJ;AiJll6EI;;EACI,kBAAA;EACA,iCAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AjJql6ER;;AiJjl6EI;EACI,YAAA;AjJol6ER;;AiJhl6EI;EACI,YAAA;AjJml6ER;;AiJ9k6EI;EACI,gB1IqWS;AP4u5EjB;AiJhl6EQ;EACI,c1IgEM;E0I/DN,2CAAA;EACA,YAAA;EACA,gBAAA;AjJkl6EZ;AiJhl6EY;EAEI,W1I3OR;E0I4OQ,yB1IwDE;APyh6ElB;AiJ5k6EI;EACI,oCAAA;EACA,e1IiDU;AP6h6ElB;;AiJzk6EI;;EAEI,oCAAA;EACA,gCAAA;EACA,sBAAA;AjJ4k6ER;AiJ1k6EI;EACI,0BAAA;AjJ4k6ER;;AiJtk6EI;EADJ;IAEQ,sBAAA;IACA,SAAA;EjJ0k6EN;AACF;;AiJrk6EQ;EACI,6BAAA;AjJwk6EZ;;AiJlk6EI;EACI,aAAA;AjJqk6ER;AiJjk6EQ;EACI,aAAA;AjJmk6EZ;AiJhk6EQ;EACI,aAAA;AjJkk6EZ;AiJ/j6EQ;EACI,cAAA;AjJik6EZ;;AiJ3j6EI;EACI,0BAAA;AjJ8j6ER;;AiJzj6EI;EACI,0BAAA;AjJ4j6ER;;AiJrj6EQ;EACI,+CAAA;AjJwj6EZ;;AiJnj6EA;EACI,oCAAA;AjJsj6EJ;;AiJ7i6EgB;;EAEI,yBAAA;AjJgj6EpB;;AiJvi6EgB;EACI,yBAAA;AjJ0i6EpB;;AiJli6EY;EACI,yBAAA;AjJqi6EhB;AiJli6EoB;EACI,yBAAA;AjJoi6ExB;AiJhi6EgB;EACI,qB1InCL;APqk6Ef;;AiJhk6EgB;;EAEI,yBAAA;AjJmk6EpB;;AiJ1j6EgB;EACI,yBAAA;AjJ6j6EpB;;AiJrj6EY;EACI,yBAAA;AjJwj6EhB;AiJrj6EoB;EACI,yBAAA;AjJuj6ExB;AiJnj6EgB;EACI,qB1InCL;APwl6Ef;;AiJnl6EgB;;EAEI,yBAAA;AjJsl6EpB;;AiJ7k6EgB;EACI,yBAAA;AjJgl6EpB;;AiJxk6EY;EACI,yBAAA;AjJ2k6EhB;AiJxk6EoB;EACI,yBAAA;AjJ0k6ExB;AiJtk6EgB;EACI,qB1InCL;AP2m6Ef;;AiJtm6EgB;;EAEI,yBAAA;AjJym6EpB;;AiJhm6EgB;EACI,yBAAA;AjJmm6EpB;;AiJ3l6EY;EACI,yBAAA;AjJ8l6EhB;AiJ3l6EoB;EACI,yBAAA;AjJ6l6ExB;AiJzl6EgB;EACI,qB1InCL;AP8n6Ef;;AiJzn6EgB;;EAEI,yBAAA;AjJ4n6EpB;;AiJnn6EgB;EACI,yBAAA;AjJsn6EpB;;AiJ9m6EY;EACI,yBAAA;AjJin6EhB;AiJ9m6EoB;EACI,yBAAA;AjJgn6ExB;AiJ5m6EgB;EACI,qB1InCL;APip6Ef;;AiJ5o6EgB;;EAEI,yBAAA;AjJ+o6EpB;;AiJto6EgB;EACI,yBAAA;AjJyo6EpB;;AiJjo6EY;EACI,yBAAA;AjJoo6EhB;AiJjo6EoB;EACI,yBAAA;AjJmo6ExB;AiJ/n6EgB;EACI,qB1InCL;APoq6Ef;;AiJ/p6EgB;;EAEI,yBAAA;AjJkq6EpB;;AiJzp6EgB;EACI,yBAAA;AjJ4p6EpB;;AiJpp6EY;EACI,yBAAA;AjJup6EhB;AiJpp6EoB;EACI,yBAAA;AjJsp6ExB;AiJlp6EgB;EACI,qB1InCL;APur6Ef;;AiJlr6EgB;;EAEI,yBAAA;AjJqr6EpB;;AiJ5q6EgB;EACI,yBAAA;AjJ+q6EpB;;AiJvq6EY;EACI,yBAAA;AjJ0q6EhB;AiJvq6EoB;EACI,yBAAA;AjJyq6ExB;AiJrq6EgB;EACI,qB1InCL;AP0s6Ef;;AiJrs6EgB;;EAEI,yBAAA;AjJws6EpB;;AiJ/r6EgB;EACI,yBAAA;AjJks6EpB;;AiJ1r6EY;EACI,yBAAA;AjJ6r6EhB;AiJ1r6EoB;EACI,yBAAA;AjJ4r6ExB;AiJxr6EgB;EACI,qB1InCL;AP6t6Ef;;AiJxt6EgB;;EAEI,yBAAA;AjJ2t6EpB;;AiJlt6EgB;EACI,yBAAA;AjJqt6EpB;;AiJ7s6EY;EACI,yBAAA;AjJgt6EhB;AiJ7s6EoB;EACI,yBAAA;AjJ+s6ExB;AiJ3s6EgB;EACI,qB1InCL;APgv6Ef;;AiJ3u6EgB;;EAEI,yBAAA;AjJ8u6EpB;;AiJru6EgB;EACI,yBAAA;AjJwu6EpB;;AiJhu6EY;EACI,yBAAA;AjJmu6EhB;AiJhu6EoB;EACI,yBAAA;AjJku6ExB;AiJ9t6EgB;EACI,qB1InCL;APmw6Ef;;AiJ9v6EgB;;EAEI,yBAAA;AjJiw6EpB;;AiJxv6EgB;EACI,yBAAA;AjJ2v6EpB;;AiJnv6EY;EACI,yBAAA;AjJsv6EhB;AiJnv6EoB;EACI,yBAAA;AjJqv6ExB;AiJjv6EgB;EACI,qB1InCL;APsx6Ef;;AiJjx6EgB;;EAEI,yBAAA;AjJox6EpB;;AiJ3w6EgB;EACI,yBAAA;AjJ8w6EpB;;AiJtw6EY;EACI,yBAAA;AjJyw6EhB;AiJtw6EoB;EACI,yBAAA;AjJww6ExB;AiJpw6EgB;EACI,qB1InCL;APyy6Ef;;AiJpy6EgB;;EAEI,yBAAA;AjJuy6EpB;;AiJ9x6EgB;EACI,yBAAA;AjJiy6EpB;;AiJzx6EY;EACI,yBAAA;AjJ4x6EhB;AiJzx6EoB;EACI,yBAAA;AjJ2x6ExB;AiJvx6EgB;EACI,qB1InCL;AP4z6Ef;;AiJvz6EgB;;EAEI,yBAAA;AjJ0z6EpB;;AiJjz6EgB;EACI,yBAAA;AjJoz6EpB;;AiJ5y6EY;EACI,yBAAA;AjJ+y6EhB;AiJ5y6EoB;EACI,yBAAA;AjJ8y6ExB;AiJ1y6EgB;EACI,qB1InCL;AP+06Ef;;AiJ106EgB;;EAEI,sBAAA;AjJ606EpB;;AiJp06EgB;EACI,sBAAA;AjJu06EpB;;AiJ/z6EY;EACI,sBAAA;AjJk06EhB;AiJ/z6EoB;EACI,sBAAA;AjJi06ExB;AiJ7z6EgB;EACI,kB1InCL;APk26Ef;;AiJ716EgB;;EAEI,yBAAA;AjJg26EpB;;AiJv16EgB;EACI,yBAAA;AjJ016EpB;;AiJl16EY;EACI,yBAAA;AjJq16EhB;AiJl16EoB;EACI,yBAAA;AjJo16ExB;AiJh16EgB;EACI,qB1InCL;APq36Ef;;AiJ106EI;EACI,8CAAA;AjJ606ER;;AiJz06EA;EACI,cAAA;AjJ406EJ;AiJ306EI;EACI,mBAAA;AjJ606ER;;AkJlu7EA;EACI,uBAAA;EACA,uDAAA;EACA,oBAAA;EACA,aAAA;AlJqu7EJ;AkJnu7EI;EACI,iDAAA;EACA,sCAAA;AlJqu7ER;AkJnu7EI;EAVJ;IAWQ,qBAAA;IACA,oBAAA;IACA,aAAA;ElJsu7EN;AACF;AkJpu7EI;EACI,yBAAA;AlJsu7ER;AkJnu7EI;EACI,uBAAA;AlJqu7ER;AkJpu7EQ;EACI,sDAAA;EACA,sCAAA;EACA,iCAAA;EACA,8BAAA;AlJsu7EZ;AkJru7EY;EACI,2CAAA;AlJuu7EhB;AkJnu7EQ;EACI,qCAAA;EACA,WAAA;EACA,SAAA;AlJqu7EZ;AkJju7EI;EACI,oCAAA;AlJmu7ER;AkJlu7EQ;EACI,kDAAA;AlJou7EZ;AkJju7EY;EACI,kDAAA;AlJmu7EhB;;AkJ5t7EA;EACI,6DAAA;AlJ+t7EJ;;AkJ5t7EA;EACI,oCAAA;AlJ+t7EJ;;AmJzx7EA;;EAEI,kBAAA;EACA,aAAA;EACA,gB5IkqBmB;E4IjqBnB,4CAAA;AnJ4x7EJ;;AmJzx7EA;;;;;EAKI,aAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,iBAAA;EACA,oCAAA;AnJ4x7EJ;;AmJzx7EA;;;;;EAKI,aAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,iBAAA;EACA,oCAAA;AnJ4x7EJ;;AmJzx7EA;EACI,gB5ImoBmB;E4IloBnB,gBAAA;AnJ4x7EJ;;AmJ7w7EgC;;EACI,yB5I8QpB;E4I7QoB,oCAAA;AnJix7EpC;AmJxw7EwC;EACI,yB5IGtC;APuw7EN;AmJlw7EoC;EACI,yB5INlC;AP0w7EN;AmJtv7EwB;EACI,gBAAA;AnJwv7E5B;;AmJ5u7EI;;EAEI,kBAAA;EACA,mBAAA;AnJ+u7ER;AmJ5u7EI;;EAEI,kBAAA;AnJ8u7ER;AmJ1u7EQ;EACI,WAAA;AnJ4u7EZ;AmJvu7EgB;EACI,wBAAA;AnJyu7EpB;AmJtu7EgB;EACI,cAAA;AnJwu7EpB;;AmJ7t7EY;EACI,wC5Io8CG;E4In8CH,oCAAA;EACA,gBAAA;EACA,WAAA;AnJgu7EhB;AmJ9t7EY;EACI,gB5Io7CM;AP4y4EtB;AmJ/t7EgB;EACI,qB5IkhBL;E4IjhBK,gB5IuhBG;E4IthBH,mBAAA;AnJiu7EpB;AmJ7t7EwB;EACI,uBAAA;AnJ+t7E5B;AmJ1t7EY;EACI,eAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,wCAAA;EACA,oCAAA;AnJ4t7EhB;AmJ3t7EgB;EACI,iCAAA;AnJ6t7EpB;;AmJpt7EI;EACI,oCAAA;EACA,2BAAA;EACA,2BAAA;AnJut7ER;;AmJnt7EA;EACI,oCAAA;EACA,2BAAA;EACA,2BAAA;AnJst7EJ;;AmJnt7EA;;EAEI,oCAAA;EACA,2BAAA;EACA,2BAAA;EACA,gBAAA;AnJst7EJ;;AmJnt7EA;EACI,oCAAA;EACA,2BAAA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;AnJst7EJ;;AmJnt7EA;;EAEI,oCAAA;EACA,2BAAA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;AnJst7EJ;;AoJt67EA;EACI,sBAAA;ApJy67EJ;;AoJt67EI;EACI,kEAAA;EACA,+D7Iw+BO;E6Iv+BP,2C7Iq8BG;E6Ip8BH,aAAA;ApJy67ER;AoJx67EQ;EACI,iBAAA;EACA,kBAAA;EACA,2B7Iq8BE;APq+5Ed;AoJx67EQ;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;ApJ067EZ;AoJz67EY;EACI,+EAAA;EACA,2BAAA;ApJ267EhB;;AoJl67EY;EACI,0FAAA;EACA,sCAAA;ApJq67EhB;;AoJ/57EA;EACI,iBAAA;ApJk67EJ;;AoJ/57EA;EACI,oEAAA;EACA,4C7IwjBS;E6IvjBT,wCAAA;EACA,aAAA;ApJk67EJ;;AoJ957EI;EACI,uC7I25BY;APsg6EpB;AoJ/57EI;EACI,aAAA;EACA,wCAAA;ApJi67ER;AoJh67EQ;EACI,aAAA;EACA,+CAAA;EACA,2C7Ii5BD;E6Ih5BC,2B7Iq5BE;E6Ip5BF,sC7Iy5BU;APyg6EtB;AoJ/57EI;EACI,yB7IiQQ;APgq7EhB;AoJ/57EI;EACI,wCAAA;EACA,2CAAA;ApJi67ER;AoJh67EQ;EACI,yB7I2PI;E6I1PJ,W7IvCJ;APy87ER;AoJ957EQ;EACI,kBAAA;EACA,kBAAA;ApJg67EZ;AoJ557EQ;EACI,aAAA;EACA,UAAA;EACA,aAAA;EACA,UAAA;ApJ857EZ;;AoJv57EI;EACI,mE7Ig5BO;E6I/4BP,6EAAA;EACA,2C7I42BG;AP8i6EX;AoJx57EQ;EACI,gBAAA;ApJ057EZ;AoJx57EQ;EACI,SAAA;EACA,2B7I02BE;APgj6Ed;AoJx57EQ;EACI,yB7IwNI;E6IvNJ,YAAA;EACA,W7I3EJ;E6I4EI,kBAAA;EACA,YAAA;EACA,eAAA;ApJ057EZ;AoJx57EQ;EACI,W7IjFJ;E6IkFI,iBAAA;EACA,qBAAA;EACA,cAAA;EACA,QAAA;ApJ057EZ;AoJz57EY;EACI,W7IvFR;E6IwFQ,yB7IyMA;APkt7EhB;AoJt57EQ;EACI,eAAA;EACA,YAAA;EACA,sC7IuhBO;APi46EnB;AoJn57EY;EACI,gC7Iy1BU;AP4j6E1B;;AoJ747EQ;EACI,uC7I8zBQ;E6I7zBR,eAAA;ApJg57EZ;;AqJhi8EA;EACI,kBAAA;EACA,W9I8BI;E8I7BJ,qBAAA;EACA,uFAAA;EACA,6BAAA;EACA,eAAA;EACA,UAAA;EACA,wDAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,2BAAA;EACA,mBAAA;ArJmi8EJ;AqJli8EI;EACI,UAAA;ArJoi8ER;;AqJ/h8EA;EACI,YAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,W9III;AP8h8ER;;AqJ/h8EA;EACI,WAAA;ArJki8EJ;;AqJ/h8EA;EACI,UAAA;ArJki8EJ;AqJji8EI;EACI,UAAA;EACA,cAAA;EACA,iBAAA;ArJmi8ER;;AqJ/h8EA;EACI,WAAA;ArJki8EJ;;AqJ/h8EA;EACI,cAAA;ArJki8EJ;;AqJ/h8EA;EACI,mBAAA;ArJki8EJ;;AqJ/h8EA;EACI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;ArJki8EJ;;AqJ/h8EA;EACI,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,sBAAA;EACA,2BAAA;ArJki8EJ;;AqJ/h8EA;EACI;IACI,iBAAA;IACA,kBAAA;IACA,OAAA;IACA,QAAA;IACA,sBAAA;ErJki8EN;AACF;AsJln8EA;EACI,kBAAA;EACA,mBAAA;EACA,eAAA;AtJon8EJ;AsJln8EI;EACI,aAAA;AtJon8ER;AsJjn8EI;EACI,gBAAA;AtJmn8ER;AsJ/m8EQ;;EAEI,iDAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;AtJin8EZ;AsJ9m8EQ;EACI,mBAAA;AtJgn8EZ;AsJ5m8EI;EACI,wBAAA;AtJ8m8ER;AsJ1m8EI;EACI,eAAA;AtJ4m8ER;AsJ3m8EQ;EACI,uBAAA;AtJ6m8EZ;AsJ1m8EQ;EACI,cAAA;EACA,WAAA;EACA,sBAAA;EACA,2C/Im6BD;E+Il6BC,+CAAA;EACA,mB/ImnBK;E+IlnBL,sC/I06BU;E+Iz6BV,2B/Io6BE;E+In6BF,mBAAA;AtJ4m8EZ;AsJzm8EQ;EACI,0DAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;AtJ2m8EZ;AsJzm8EY;EACI,UAAA;AtJ2m8EhB;AsJxm8EY;EACI,mCAAA;AtJ0m8EhB;AsJtm8EQ;EACI,aAAA;AtJwm8EZ;AsJrm8EQ;EACI,aAAA;EACA,kBAAA;EACA,SAAA;EACA,6CAAA;EACA,aAAA;EACA,UAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;AtJum8EZ;AsJpm8EQ;EACI,aAAA;EACA,2CAAA;AtJsm8EZ;AsJ5l8EQ;EACI,YAAA;EACA,qBAAA;AtJ8l8EZ;AsJ3l8EQ;EACI,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+CAAA;EACA,eAAA;EACA,0DAAA;EACA,oBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;AtJ6l8EZ;AsJ5l8EY;EACI,UAAA;AtJ8l8EhB;AsJ3l8EQ;EACI,oBAAA;AtJ6l8EZ;AsJ5l8EY;EACI,gBAAA;AtJ8l8EhB;AsJxl8EQ;EACI,gBAAA;AtJ0l8EZ;;AsJnl8EI;EACI,iCAAA;EACA,YAAA;AtJsl8ER;;AsJll8EA;EACI,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,2C/I8yBO;E+I7yBP,qDAAA;EACA,kEAAA;EACA,iDAAA;EACA,mB/I4fa;E+I3fb,kBAAA;EACA,gBAAA;AtJql8EJ;;AsJ/k8EI;;EACI,6C/IgzBmB;APmy6E3B;;AsJ/k8EA;EACI,SAAA;EACA,eAAA;EACA,gBAAA;AtJkl8EJ;;AsJ/k8EA;EACI,qBAAA;EACA,yBAAA;EACA,WAAA;AtJkl8EJ;AsJhl8EI;EACI,WAAA;AtJkl8ER;;AsJ9k8EA;EACI,eAAA;AtJil8EJ;AsJhl8EI;EACI,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gB/I6da;E+I5db,oBAAA;EACA,qBAAA;EACA,eAAA;EACA,yB/IuHQ;E+ItHR,yBAAA;EACA,qBAAA;EACA,sBAAA;EACA,W/I9KA;E+I+KA,gB/IwZS;AP0r7EjB;AsJjl8EQ;EACI,kBAAA;AtJml8EZ;AsJhl8EQ;EACI,yB/I4GI;E+I3GJ,yBAAA;AtJkl8EZ;;AsJ1k8EQ;EACI,yB/IqGM;E+IpGN,yBAAA;AtJ6k8EZ;;AsJxk8EA;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,wCAAA;EACA,wCAAA;EACA,6C/IyXY;E+IxXZ,SAAA;EACA,aAAA;EACA,4BAAA;EACA,gCAAA;EACA,iCAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,0BAAA;AtJ2k8EJ;AsJ1k8EI;EACI,mBAAA;EACA,6BAAA;AtJ4k8ER;AsJzk8EI;EACI,uCAAA;AtJ2k8ER;AsJxk8EI;EACI,qBAAA;AtJ0k8ER;AsJvk8EI;EACI,kBAAA;EACA,gB/I6Za;AP4q7ErB;AsJtk8EI;EACI,aAAA;AtJwk8ER;;AsJnk8EI;EACI,oC/IyiCgB;AP6h6ExB;;AsJjk8EI;EACI,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kCAAA;AtJok8ER;AsJnk8EQ;EACI,iCAAA;EACA,2BAAA;AtJqk8EZ;;AsJ/j8EI;EACI,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,iCAAA;EACA,4BAAA;AtJkk8ER;AsJ/j8EI;EACI,kBAAA;EACA,mB/I+WS;E+I9WT,oCAAA;AtJik8ER;;AsJ3j8EA;EAIY;IACI,+BAAA;IACA,eAAA;IACA,UAAA;IACA,kBAAA;IACA,WAAA;IACA,QAAA;IACA,2BAAA;EtJ2j8Ed;EsJvj8Ec;IACI,YAAA;EtJyj8ElB;AACF;AsJjj8EA;EACI,eAAA;AtJmj8EJ;;AsJhj8EA;EACI,eAAA;AtJmj8EJ;;AsJhj8EA;EACI,mBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,YAAA;AtJmj8EJ;;AsJhj8EA;EACI,gB/IwUmB;E+IvUnB,eAAA;EACA,kBAAA;EACA,+CAAA;EACA,gCAAA;AtJmj8EJ;;AsJhj8EA;EACI,oBAAA;EACA,gBAAA;EACA,SAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,eAAA;AtJmj8EJ;AsJlj8EI;EACI,aAAA;AtJoj8ER;;AsJhj8EA;EACI,qBAAA;EACA,wBAAA;EACA,2C/IulBO;E+ItlBP,2B/I2lBU;E+I1lBV,mB/IuSa;E+ItSb,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AtJmj8EJ;AsJlj8EI;EACI,UAAA;AtJoj8ER;AsJlj8EI;EACI,gC/I+lBkB;APq96E1B;;AsJhj8EA;EACI,gC/I0lBsB;E+IzlBtB,UAAA;AtJmj8EJ;;AsJ7i8EQ;EACI,kD/Iu4Ca;APyq5EzB;;AuJ978EA;EACI,uBAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,0BAAA;EACA,kCAAA;EACA,4KAAA;AvJi88EJ;AuJ/78EI;EAEI,UAAA;EACA,iBAAA;EACA,mBAAA;AvJg88ER;AuJ778EI;EACI,qBAAA;EACA,aAAA;AvJ+78ER;AuJ578EI;EACQ,4DAAA;AvJ878EZ;AuJ378EI;EACI,cAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;AvJ678ER;AuJ378EQ;EACI,cAAA;EACA,WAAA;AvJ678EZ;AuJ378EY;EACI,WAAA;EACA,kEAAA;EACA,gBAAA;EACA,0BAAA;AvJ678EhB;AuJ178EgB;EACI,WAAA;EACA,eAAA;EACA,eAAA;AvJ478EpB;AuJ178EoB;EACI,eAAA;EACA,kBAAA;AvJ478ExB;AuJt78EQ;EACI,6EAAA;EACA,sChJi5BU;APui7EtB;AuJp78EI;EACI,kBAAA;EACA,qBAAA;AvJs78ER;AuJr78EQ;EACI,YAAA;EACA,cAAA;AvJu78EZ;AuJn78EI;EACI,2BAAA;AvJq78ER;AuJl78EI;EACI,6CAAA;AvJo78ER;AuJj78EI;;EAEI,gBAAA;EACA,6BAAA;EACA,4BAAA;AvJm78ER;AuJh78EI;EACI,cAAA;AvJk78ER;AuJ/68EI;EACI,YAAA;EACA,4CAAA;AvJi78ER;AuJ968EI;EACI,YAAA;AvJg78ER;AuJ768EI;EAEI,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;AvJ868ER;AuJ368EI;EAIE,UAAA;EACA,WAAA;AvJ068EN;AuJv68EI;EAEE,SAAA;EACA,UAAA;AvJw68EN;AuJr68EI;EACI,iBAAA;EACA,cAAA;AvJu68ER;AuJr68EI;EACI,iBAAA;EACA,cAAA;AvJu68ER;AuJp68EI;EAEI,YAAA;AvJq68ER;AuJn68EI;EACI,4BhJ4KQ;APyv8EhB;AuJn68EI;EACI,4BhJyKQ;AP4v8EhB;AuJl68EI;EAEI,SAAA;AvJm68ER;AuJj68EI;EACI,yBhJiKQ;APkw8EhB;AuJj68EI;EACI,yBhJ8JQ;APqw8EhB;AuJj68EI;EACI,UAAA;AvJm68ER;;AuJ/58EA;EACI,kBAAA;EACA,qBAAA;AvJk68EJ;;AuJ/58EA;EACI,aAAA;EACA,yBhJgJY;EgJ/IZ,8BAAA;AvJk68EJ;AuJh68EI;EACI,uBAAA;EACA,+BAAA;EACA,8BAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,gBAAA;EACA,SAAA;AvJk68ER;AuJ/58EI;;EAEI,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,+BAAA;EACA,8BAAA;EAqBE;qBAAA;EAEF;mBAAA;EAcE;qBAAA;EAEF;mBAAA;AvJk48ER;AuJv68EQ;;EACE,aAAA;AvJ068EV;AuJv68EQ;;EACI,kBAAA;AvJ068EZ;AuJv68EQ;;EACI;2BAAA;EAEA;SAAA;EAEE,OAAA;EACF;yBAAA;EAEA;SAAA;AvJ268EZ;AuJn68EQ;;EACI;2BAAA;EAEA;SAAA;EAEE,QAAA;EACF;yBAAA;EAEA;SAAA;AvJu68EZ;AuJ/58EQ;;EACI,cAAA;AvJk68EZ;AuJh68EY;;EACI,8BAAA;AvJm68EhB;AuJ/58EQ;;EACI,WAAA;EACA,YAAA;AvJk68EZ;AuJh68EY;;EACI,qBAAA;EACA,aAAA;AvJm68EhB;;AuJ758EA;EACI,kBAAA;EACA,YAAA;AvJg68EJ;AuJ958EI;;EAEI,qBAAA;AvJg68ER;AuJ758EI;EACI,WAAA;AvJ+58ER;AuJ758EQ;EACI,aAAA;AvJ+58EZ;AuJ558EQ;EAEI,SAAA;EACA,wBAAA;AvJ658EZ;AuJz58EI;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,gDAAA;EACA,sBAAA;AvJ258ER;AuJz58EQ;EACI,8BAAA;AvJ258EZ;AuJx58EQ;EACI,8BAAA;AvJ058EZ;AuJv58EQ;EACI,cAAA;EACA,WAAA;EACA,kBAAA;AvJy58EZ;AuJt58EQ;EACI,MAAA;EACA,gBAAA;AvJw58EZ;AuJt58EY;EACI,kCAAA;EACA,mCAAA;EACA,8CAAA;EACA,QAAA;AvJw58EhB;AuJp58EQ;EACI,QAAA;AvJs58EZ;AuJp58EY;EACI,kCAAA;EACA,mCAAA;EACA,2CAAA;EACA,QAAA;AvJs58EhB;AuJl58EQ;EACI,cAAA;EACA,YAAA;AvJo58EZ;AuJl58EY;EACI,wBAAA;AvJo58EhB;AuJ948EI;EACI,+BAAA;AvJg58ER;AuJ/48EQ;EACI,UAAA;AvJi58EZ;;AuJ548EA;EACI,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,qCAAA;AvJ+48EJ;AuJ748EI;EACI,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;AvJ+48ER;AuJ748EQ;EACI,+BAAA;AvJ+48EZ;AuJ348EI;EACI,UAAA;EACA,aAAA;EACA,qBAAA;AvJ648ER;AuJz48EQ;EACI,uCAAA;AvJ248EZ;AuJz48EQ;EACI,oCAAA;AvJ248EZ;AuJv48EI;EACI,uBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,oBAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBhJ4Qe;EgJ3Qf,oBAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;AvJy48ER;AuJv48EQ;EACI,UAAA;AvJy48EZ;AuJt48EQ;EAEI,eAAA;EACA,+BAAA;EACA,uBAAA;EACA,oBAAA;AvJu48EZ;AuJn48EI;EACI,oBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBhJ6Oe;EgJ5Of,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;AvJq48ER;AuJn48EQ;EAEI,aAAA;AvJo48EZ;AuJj48EQ;EACI,6BAAA;AvJm48EZ;AuJh48EQ;EACI,6BAAA;EACA,aAAA;EACA,UAAA;EACA,yBAAA;AvJk48EZ;;AuJ538EA;EACI,yBhJrJY;EgJsJZ,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,+CAAA;AvJ+38EJ;AuJ938EI;EACI,aAAA;EACA,SAAA;AvJg48ER;;AuJ538EA;EACI,eAAA;EACA,cAAA;EACA,mBhJtKY;EgJuKZ,WhJxcI;EgJycJ,cAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,gBhJsLiB;APys8ErB;;AuJ538EA;;EAEI,kBAAA;AvJ+38EJ;;AuJ738EA;EACI,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AvJg48EJ;AuJ/38EI;EACI,UAAA;AvJi48ER;;AuJ738EA;EACI,UAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,qCAAA;EACA,UAAA;AvJg48EJ;AuJ/38EI;EACI,4BAAA;AvJi48ER;;AuJ738EA;EACI,gBAAA;EACA,6BAAA;EACA,oBAAA;EACA,sBAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;AvJg48EJ;AuJ938EI;EAEI,gDAAA;AvJ+38ER;AuJ538EI;EAYI,eAAA;EACA,UAAA;EACA,iCAAA;EACA,6BAAA;AvJm38ER;AuJh38EI;EACI,qBhJ7PQ;EgJ8PR,0CAAA;EACA,gBhJuCS;AP208EjB;AuJh38EQ;EAEI,qBhJnQI;EgJoQJ,2CAAA;EACA,2BAAA;AvJi38EZ;AuJ728EI;EAkBI,mBhJ3RQ;EgJ4RR,gBhJUS;EgJTT,WhJ9jBA;EgJ+jBA,qBhJ9RQ;AP4n9EhB;AuJx18EQ;EACI,4BAAA;AvJ018EZ;AuJz18EY;EACI,6BAAA;AvJ218EhB;AuJx18EY;EACI,mBAAA;AvJ018EhB;AuJl18EQ;EACI,4BAAA;AvJo18EZ;AuJh18EI;EACI,gBAAA;EACA,6DAAA;AvJk18ER;AuJ/08EI;EAOI,0CAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;AvJ208ER;AuJx08EI;EAEI,mBAAA;EACA,0CAAA;AvJy08ER;AuJt08EI;EACI,gBAAA;EACA,6CAAA;AvJw08ER;AuJr08EI;EACI,kBAAA;AvJu08ER;;AuJn08EA;EACI,eAAA;AvJs08EJ;;AuJn08EA;EACI,WAAA;AvJs08EJ;AuJr08EI;EACI,eAAA;EACA,0CAAA;AvJu08ER;AuJp08EI;EACI,WAAA;EACA,WAAA;EACA,iBAAA;AvJs08ER;AuJl08EQ;EAEI,cAAA;EACA,WAAA;EACA,eAAA;EACA,oCAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;AvJm08EZ;;AuJ7z8EA;EACI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AvJg08EJ;;AuJ7z8EA;EACI,qBAAA;EACA,UAAA;EACA,sBAAA;AvJg08EJ;;AuJ7z8EA;EACI,kBAAA;EACA,UAAA;EACA,cAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;AvJg08EJ;AuJ9z8EI;EACI,WAAA;EACA,cAAA;EACA,WAAA;AvJg08ER;AuJ9z8EI;EACI,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AvJg08ER;AuJ7z8EgB;EACI,2CAAA;AvJ+z8EpB;AuJzz8EI;EACI,UAAA;AvJ2z8ER;AuJxz8EI;EACI,UAAA;AvJ0z8ER;AuJtz8EI;EACI,uBAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,oBAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,qBAAA;AvJwz8ER;AuJtz8EQ;EACI,iBAAA;AvJwz8EZ;AuJrz8EQ;EAEE,gBAAA;AvJsz8EV;AuJnz8EQ;EACI,UAAA;EACA,SAAA;AvJqz8EZ;AuJhz8EI;;EAEI,eAAA;EACA,WAAA;EACA,oBAAA;EACA,2BAAA;EACA,iBAAA;EACA,SAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;AvJkz8ER;AuJ/y8EI;EACI,UAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AvJiz8ER;AuJ7y8EQ;EACI,qCAAA;AvJ+y8EZ;;AuJvy8EI;;;;;EAEI,6BAAA;AvJ6y8ER;;AuJzy8EA;EACI,eAAA;EACA,2ChJsJO;APsp8EX;;AuJzy8EA;EACI,aAAA;AvJ4y8EJ;;AuJzy8EA;EACI;IACI,UAAA;IACA,mCAAA;EvJ4y8EN;EuJ1y8EE;IACI,UAAA;IACA,+BAAA;EvJ4y8EN;AACF;AuJzy8EA;;EAEI,aAAA;AvJ2y8EJ;;AwJvn+EA;EACI,kBAAA;AxJ0n+EJ;AwJvn+EQ;EACI,iBAAA;EACA,gBAAA;AxJyn+EZ;AwJvn+EY;EACI,wBAAA;AxJyn+EhB;AwJtn+EY;EACI,UAAA;AxJwn+EhB;AwJrn+EY;EACI,YAAA;AxJun+EhB;AwJpn+EY;EACI,iDAAA;EACA,kBAAA;AxJsn+EhB;AwJnn+EY;EACI,kBAAA;AxJqn+EhB;;AwJ9m+EI;EACI,kBAAA;EACA,0DAAA;EACA,4BAAA;EACA,6BAAA;EACA,qBAAA;AxJin+ER;;AwJ3m+EI;;EACI,aAAA;EACA,oCAAA;EACA,kBAAA;EACA,ajJkzBc;EiJjzBd,WjJgzBc;EiJ/yBd,eAAA;AxJ+m+ER;;AwJ1m+EI;EACI,aAAA;AxJ6m+ER;;AwJxm+EI;EACI,aAAA;AxJ2m+ER;;AyJrq+EI;EACI,oBpEkI0C;EoEjI1C,kBAAA;EACA,UAAA;EACA,WAAA;AzJwq+ER;AyJtq+EI;EACI,OAAA;EACA,6BAAA;EACA,2BAAA;AzJwq+ER;;AyJpq+EA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;AzJuq+EJ;AyJrq+EI;EARJ;IASQ,aAAA;EzJwq+EN;AACF;;AyJrq+EA;EACI,0DAAA;EACA,2BAAA;EACA,sBAAA;AzJwq+EJ;AyJtq+EI;EACI,uDAAA;EACA,YAAA;AzJwq+ER;;AyJpq+EA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,oBAAA;AzJuq+EJ;AyJtq+EI;EACI,WAAA;EACA,YAAA;EACA,uBAAA;AzJwq+ER;;AyJhq+EQ;EACI,YAAA;AzJmq+EZ;;AyJ9p+EA;EACI,kBAAA;AzJiq+EJ;;AyJ5p+EA;EACI,kBAAA;AzJ+p+EJ;AyJ9p+EI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,6CAAA;EACA,SAAA;AzJgq+ER;AyJ7p+EI;EACI,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,wCAAA;EACA,iBAAA;AzJ+p+ER;;AyJzp+EA;EACI,yDpEoD8C;ArFwm+ElD;AyJ1p+EI;EACI,0DAAA;EACA,2BAAA;EACA,sBAAA;EACA,UAAA;EACA,6BAAA;AzJ4p+ER;AyJzp+EI;EACI,+BAAA;AzJ2p+ER;;AyJtp+EA;EACI,aAAA;AzJyp+EJ;AyJvp+EI;EACI,kBAAA;AzJyp+ER;AyJvp+EQ;EACI,clJhDJ;APys+ER;AyJvp+EY;EACI,kBAAA;EACA,UAAA;EACA,YAAA;AzJyp+EhB;AyJrp+EQ;EACI,clJ7DN;APot+EN;AyJrp+EY;EACI,kBAAA;EACA,UAAA;EACA,YAAA;AzJup+EhB;;A0J3x+EA;EACI,2BAAA;A1J8x+EJ;;A0Jxx+EA;EACI,kBAAA;A1J2x+EJ;A0J1x+EI;EAFJ;IAGQ,oBAAA;E1J6x+EN;AACF;A0J5x+EI;EACI,6BAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,6BAAA;A1J8x+ER;A0J5x+EQ;EACI,yBAAA;EACA,wBAAA;A1J8x+EZ;A0J5x+EQ;EACI,aAAA;A1J8x+EZ;A0J3x+EI;EACI,2BAAA;A1J6x+ER;A0J5x+EQ;EACI,eAAA;EACA,WAAA;EACA,OAAA;A1J8x+EZ;A0J5x+EQ;EACI,wCAAA;EACA,kBAAA;EACA,YAAA;A1J8x+EZ;A0J5x+EQ;EACI,iCAAA;EACA,YAAA;A1J8x+EZ;A0J7x+EY;EACI,2BAAA;EACA,iCAAA;A1J+x+EhB;A0J3x+EY;EACI,sBAAA;EACA,yBnJkBR;EmJjBQ,gCAAA;A1J6x+EhB;A0J5x+EgB;EACI,yBAAA;EACA,oDAAA;A1J8x+EpB;A0J3x+EY;EACI,oCAAA;EACA,gCAAA;EACA,WnJ5BR;APyz+ER;A0J1x+EQ;EACI,YAAA;EACA,iBAAA;A1J4x+EZ;A0Jxx+EI;EACI,uBAAA;A1J0x+ER;;A0Jrx+EI;EACI,8CAAA;A1Jwx+ER;A0Jvx+EQ;EACI,WAAA;A1Jyx+EZ;A0Jvx+EQ;EACI;IACI,iBAAA;E1Jyx+Ed;E0Jvx+EU;IACI,8CAAA;E1Jyx+Ed;AACF;A0Jvx+EQ;EAbJ;IAcQ,iBAAA;IACA,+CAAA;E1J0x+EV;AACF;;A0Jrx+EA;EAEQ;IACI,WAAA;E1Jux+EV;AACF;A0Jnx+EA;EACI,2BAAA;A1Jqx+EJ;;A0Jhx+EA;EACI,0DAAA;EACA,sBAAA;A1Jmx+EJ;;A0J9w+EQ;EACI,wCAAA;EACA,iBAAA;EACA,eAAA;A1Jix+EZ;A0J/w+EY;EALJ;IAMQ,eAAA;IACA,gBAAA;E1Jkx+Ed;AACF;A0J9w+EY;EADJ;IAEQ,eAAA;E1Jix+Ed;AACF;;A0J1w+EQ;EACI,eAAA;A1J6w+EZ;;A0Jxw+EA;EACI,kBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;A1J2w+EJ;;A0Jvw+EI;;EAEI,SAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,cnJmKQ;EmJlKR,qBAAA;EACA,sBAAA;A1J0w+ER;A0Jxw+EI;EACI,sBAAA;EACA,qBAAA;A1J0w+ER;;A0Jrw+EI;EACI,2CAAA;EACA,0BAAA;A1Jww+ER;;A0Jnw+EI;EACI;IACI,sBAAA;IACA,0BAAA;E1Jsw+EV;AACF;;A0Jlw+EA;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;A1Jqw+EJ;;A0Jhw+EQ;EACI,0BAAA;A1Jmw+EZ;;A2Jt8+EA;EACI,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;A3Jy8+EJ;A2Jv8+EI;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,kCtEqI0C;EsEpI1C,SAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;A3Jy8+ER;;A2Jr8+EA;EACI,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;A3Jw8+EJ;A2Jt8+EI;EACI,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,kCAAA;EACA,wCAAA;EACA,mBAAA;EACA,cpJ+BA;EoJ9BA,UAAA;A3Jw8+ER;A2Jr8+EI;EACI,kBAAA;EACA,qBAAA;EACA,wBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;A3Ju8+ER;A2Jp8+EI;EACI,aAAA;EACA,kCAAA;EACA,kBAAA;EACA,wCAAA;EACA,sBpJqhBQ;EoJphBR,mDpJ2iBQ;AP259EhB;A2Jn8+EI;EACI,OAAA;A3Jq8+ER;A2Jn8+EQ;EACI,uBAAA;EACA,iBAAA;A3Jq8+EZ;A2Jj8+EI;EACI,SAAA;A3Jm8+ER;A2Jj8+EQ;EACI,WAAA;A3Jm8+EZ;A2Jh8+EQ;EACI,wBAAA;EACA,eAAA;A3Jk8+EZ;A2J/7+EQ;EACI,UAAA;EACA,sDAAA;A3Ji8+EZ;;A2J57+EA;EAEQ;IACI,UAAA;IACA,aAAA;E3J87+EV;;E2J17+EE;IACI,WAAA;IACA,kBAAA;IACA,kBAAA;E3J67+EN;E2J37+EM;IACI,QAAA;E3J67+EV;E2J37+EU;IACI,WAAA;IACA,YAAA;IACA,MAAA;IACA,eAAA;IACA,OAAA;E3J67+Ed;E2J17+EU;IACI,WAAA;IACA,wEAAA;E3J47+Ed;E2Jz7+EU;IACI,WAAA;IACA,UAAA;IACA,WAAA;IACA,QAAA;IACA,gBAAA;E3J27+Ed;AACF;A2Jt7+EA;EACI,kBAAA;A3Jw7+EJ;A2Jt7+EI;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,kCtEG0C;ArFq7+ElD;A2Jr7+EI;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;A3Ju7+ER;A2Jr7+EQ;EACI,oBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,kCtEZsC;EsEatC,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;A3Ju7+EZ;A2Jt7+EY;EACI,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;A3Jw7+EhB;A2Jn7+EI;EACI,eAAA;EACA,gBpJwfa;EoJvfb,kBAAA;EACA,iBAAA;A3Jq7+ER;A2Jn7+EQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,mBpJrHJ;EoJsHI,wCAAA;EACA,mBAAA;EACA,UAAA;A3Jq7+EZ;A2Jj7+EI;EACI,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,aAAA;EACA,wCAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;A3Jm7+ER;A2Jl7+EQ;EATJ;IAUQ,eAAA;E3Jq7+EV;AACF;A2Jn7+EQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,wEAAA;EACA,kBAAA;A3Jq7+EZ;A2Jl7+EQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,wEAAA;EACA,kBAAA;A3Jo7+EZ;A2Jj7+EQ;EACI,kBAAA;EACA,WAAA;A3Jm7+EZ;A2J/6+EI;EACI,kBAAA;EACA,qBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBpJlNA;EoJmNA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;A3Ji7+ER;A2J/6+EQ;EACI,cAAA;A3Ji7+EZ;A2J/6+EY;EACI,UAAA;EACA,gBAAA;EACA,UAAA;EACA,wEAAA;A3Ji7+EhB;A2J96+EY;EACI,UAAA;EACA,gBAAA;EACA,UAAA;EACA,wEAAA;EACA,kBAAA;EACA,UAAA;A3Jg7+EhB;;A2Jx6+EA;EACI,kBAAA;EACA,WAAA;EACA,cAAA;A3J26+EJ;A2Jz6+EI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,OAAA;EACA,WAAA;EACA,wCtEhJ0C;ArF2j/ElD;A2Jv6+EQ;EACI,qBAAA;EACA,6BAAA;EACA,gBAAA;A3Jy6+EZ;A2Jv6+EY;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,mBpJoBA;EoJnBA,WAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,wCAAA;A3Jy6+EhB;A2Jr6+EQ;EACI,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wCtE9KsC;ArFql/ElD;A2Jr6+EY;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,wEAAA;EACA,kBAAA;EACA,QAAA;EACA,cAAA;A3Ju6+EhB;A2Jn6+EQ;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;A3Jq6+EZ;A2Jl6+EQ;EACI,eAAA;EACA,0BAAA;A3Jo6+EZ;A2Jl6+EY;EACI,yBAAA;A3Jo6+EhB;A2Jl6+EgB;EACI,aAAA;EACA,SAAA;EACA,wEAAA;A3Jo6+EpB;A2Jh6+EY;EACI,yBAAA;A3Jk6+EhB;A2J75+EI;;EAEI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;A3J+5+ER;A2J75+EQ;;EACI,eAAA;EACA,WpJpVJ;APov/ER;A2J95+EQ;;EACI,0CAAA;EACA,UAAA;EACA,YAAA;EACA,2BAAA;EACA,oBAAA;A3Ji6+EZ;A2J75+EI;EACI,QAAA;A3J+5+ER;A2J75+EQ;EACI,YAAA;EACA,sBAAA;A3J+5+EZ;A2J35+EI;EACI,OAAA;A3J65+ER;A2J35+EQ;EACI,YAAA;EACA,sBAAA;A3J65+EZ;;A2Jt5+EA;EACI,kBAAA;EACA,gBAAA;A3Jy5+EJ;A2Jv5+EI;EACI,kBAAA;A3Jy5+ER;A2Jv5+EQ;EACI,UAAA;A3Jy5+EZ;A2Jt5+EQ;EACI,wCAAA;EACA,wCAAA;EACA,YAAA;EACA,WAAA;A3Jw5+EZ;A2Jr5+EQ;EACI,WAAA;EACA,kBAAA;EACA,8CAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;A3Ju5+EZ;A2Jp5+EW;EACI,yBAAA;A3Js5+Ef;;A4Jv0/EI;EACI,kBAAA;EACA,eAAA;A5J00/ER;A4Jx0/EQ;EACI,cAAA;EACA,2BAAA;EACA,gBrJ8pBW;EqJ7pBX,iBAAA;EACA,WAAA;EACA,eAAA;A5J00/EZ;;A4Jr0/EA;EACI,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;A5Jw0/EJ;A4Jt0/EI;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;EACA,wCAAA;EACA,oBAAA;A5Jw0/ER;A4Jr0/EI;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;A5Ju0/ER;A4Jr0/EQ;EACI,cAAA;A5Ju0/EZ;A4Jp0/EQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,wGAAA;EACA,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,aAAA;EACA,WAAA;EACA,qBAAA;EACA,aAAA;A5Js0/EZ;A4Jp0/EY;EACI,WrJ9BR;EqJ+BQ,SAAA;EACA,eAAA;A5Js0/EhB;A4Jj0/EI;EACI,gCAAA;A5Jm0/ER;A4Jh0/EI;EACI,kBAAA;A5Jk0/ER;A4Jh0/EQ;EACI,eAAA;EACA,kBAAA;EACA,aAAA;A5Jk0/EZ;A4J/z/EQ;EACI,SAAA;EACA,oBAAA;EACA,gCAAA;A5Ji0/EZ;A4J5z/EQ;EACI,YAAA;A5J8z/EZ;A4J3z/EQ;EACI,SAAA;A5J6z/EZ;A4J3z/EY;EACI,UAAA;A5J6z/EhB;A4Jzz/EQ;EACI,UAAA;EACA,mBAAA;A5J2z/EZ;;A4Jpz/EQ;EACI,iCAAA;A5Juz/EZ;;A6Jx6/EA;EACI,gBAAA;A7J26/EJ;;A6Jv6/EI;EACI,gBAAA;A7J06/ER;A6Jv6/EI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;A7Jy6/ER;A6Jt6/EI;EACI;IACI,gBAAA;E7Jw6/EV;E6Jr6/EM;IACI,qBAAA;IACA,SAAA;E7Ju6/EV;AACF;A6Jp6/EI;EACI;IACI,eAAA;IACA,gBAAA;E7Js6/EV;E6Jn6/EM;IACI,kBAAA;IACA,QAAA;E7Jq6/EV;AACF;;A6Jh6/EA;EACI;IACI,yBAAA;E7Jm6/EN;E6Jh6/EE;IACI,yCAAA;E7Jk6/EN;E6J/5/EE;IACI,uCAAA;E7Ji6/EN;E6J95/EE;IACI,yCAAA;E7Jg6/EN;E6J75/EE;IACI,uCAAA;E7J+5/EN;E6J55/EE;IACI,wCAAA;E7J85/EN;E6J35/EE;IACI,yBAAA;E7J65/EN;AACF;A6J15/EA;EACI,sCAAA;A7J45/EJ;;A8Jr+/EA;EACI,4CAAA;A9Jw+/EJ;A8Jt+/EI;EAHJ;IAIQ,gBAAA;E9Jy+/EN;AACF;;A8Jn+/EA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,aAAA;A9Js+/EJ;A8Jr+/EI;EANJ;IAOQ,aAAA;E9Jw+/EN;AACF;A8Jt+/EI;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,mBvJqSQ;EuJpSR,qDAAA;A9Jw+/ER;A8Jp+/EI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;A9Js+/ER;;A8Jh+/EQ;EACI,+BAAA;A9Jm+/EZ;A8Jj+/EY;EACI,0CAAA;A9Jm+/EhB;;A8J79/EA;EACI,wCAAA;EACA,6CAAA;A9Jg+/EJ;;A8J19/EQ;EACI,0BvJoSG;APyr/Ef;;A8J99/EQ;EACI,0BvJoSG;AP6r/Ef;;A8Jl+/EQ;EACI,0BvJoSG;APis/Ef;;A8Jt+/EQ;EACI,0BvJoSG;APqs/Ef;;A8J1+/EQ;EACI,0BvJoSG;APys/Ef;;A8J9+/EQ;EACI,0BvJoSG;AP6s/Ef;;A8Jl//EQ;EACI,0BvJoSG;APit/Ef;;A8Jt//EQ;EACI,0BvJoSG;APqt/Ef;;A8J1//EQ;EACI,0BvJoSG;APyt/Ef;;A8J9//EQ;EACI,0BvJoSG;AP6t/Ef;;A8JlggFQ;EACI,0BvJoSG;APiu/Ef;;A8JtggFQ;EACI,0BvJoSG;APqu/Ef;;A8J1ggFQ;EACI,0BvJoSG;APyu/Ef;;A8J9ggFQ;EACI,0BvJoSG;AP6u/Ef;;A8JlhgFQ;EACI,0BvJoSG;APiv/Ef;;A8JthgFQ;EACI,uBvJoSG;APqv/Ef;;A8J1hgFQ;EACI,0BvJoSG;APyv/Ef;;A8JxhgFA;EACI,kBAAA;A9J2hgFJ;A8JzhgFI;EACI,WAAA;EACA,aAAA;EACA,iBAAA;A9J2hgFR;A8JzhgFQ;EALJ;IAMQ,aAAA;E9J4hgFV;AACF;A8JzhgFI;EACI,aAAA;A9J2hgFR;A8JxhgFI;EACI,eAAA;A9J0hgFR;;A8JthgFA;EACI,kBAAA;EACA,qBAAA;A9JyhgFJ;A8JvhgFI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;A9JyhgFR;A8JthgFI;EACI,iBAAA;A9JwhgFR;A8JrhgFI;EACI,aAAA;A9JuhgFR;;A8JlhgFI;EACI,kBAAA;A9JqhgFR;A8JnhgFQ;EACI,6BAAA;A9JqhgFZ;A8JnhgFY;EACI,gBAAA;A9JqhgFhB;A8JjhgFQ;EACI,WAAA;EACA,8CAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;A9JmhgFZ;A8J/ggFY;EACI,QAAA;A9JihgFhB;A8J5ggFY;EACI,YAAA;EACA,QAAA;A9J8ggFhB;;A8JxggFA;EACI,kBAAA;EACA,aAAA;A9J2ggFJ;A8JzggFI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;A9J2ggFR;A8JxggFI;EACI,WAAA;EACA,aAAA;EACA,iBAAA;A9J0ggFR;A8JxggFQ;EALJ;IAMQ,aAAA;E9J2ggFV;AACF;A8JxggFI;EACI,aAAA;A9J0ggFR;A8JvggFI;EACI,eAAA;A9JyggFR;;A8JrggFA;EAGQ;IACI,wBAAA;E9JsggFV;AACF;A8JjggFI;EACI,eAAA;A9JmggFR;;A+J7rgFA;EACI,WAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;A/JgsgFJ;A+J9rgFI;EACI,kBAAA;A/JgsgFR;;A+J5rgFA;EACI,kBAAA;A/J+rgFJ;A+J7rgFI;EACI,UAAA;EACA,SAAA;EACA,gBAAA;A/J+rgFR;A+J7rgFQ;EACI,cAAA;EACA,2BAAA;EACA,wCAAA;EACA,4CxJ6kBC;EwJ5kBD,mBxJsoBK;EwJroBL,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A/J+rgFZ;A+J7rgFY;EACI,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;A/J+rgFhB;;A+JtrgFY;EACI,UAAA;EACA,uBAAA;EACA,kBAAA;A/JyrgFhB;A+JprgFI;EACI,kBAAA;EACA,WAAA;A/JsrgFR;A+JprgFQ;EACI,WAAA;EACA,cAAA;EACA,QAAA;EACA,aAAA;EACA,8CAAA;EACA,YAAA;EACA,kBAAA;A/JsrgFZ;A+JlrgFY;EACI,aAAA;EACA,YAAA;EACA,wBAAA;EACA,iBAAA;EACA,gDAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,8CAAA;A/JorgFhB;A+JlrgFgB;EACI,WAAA;EACA,UAAA;A/JorgFpB;A+J9qgFI;EAGY;IACI,UAAA;IACA,UAAA;IACA,iBAAA;E/J8qgFlB;E+J1qgFU;IACI,WAAA;E/J4qgFd;AACF;;A+JvqgFA;EACI,WAAA;A/J0qgFJ;A+JvqgFQ;EACI,aAAA;EACA,YAAA;EACA,wBAAA;EACA,iBAAA;EACA,gDAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;A/JyqgFZ;A+JvqgFY;EACI,WAAA;EACA,WAAA;A/JyqgFhB;A+JrqgFQ;EACI,cAAA;EACA,WAAA;A/JuqgFZ;A+JpqgFgB;EACI,YAAA;A/JsqgFpB;A+JhqgFI;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,6CAAA;EACA,+CAAA;EACA,8CAAA;EACA,cAAA;EACA,UAAA;EACA,UAAA;A/JkqgFR;A+J/pgFI;EAEQ;IACI,UAAA;IACA,SAAA;IACA,gBAAA;E/JgqgFd;E+J5pgFM;IACI,kBAAA;IACA,OAAA;IACA,UAAA;E/J8pgFV;AACF;;A+J1pgFA;EACI,8CAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;A/J6pgFJ;A+J3pgFI;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,8CAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;A/J6pgFR;A+J1pgFI;EACI,sBAAA;EACA,UAAA;A/J4pgFR;A+JzpgFI;EACI,eAAA;EACA,kBAAA;A/J2pgFR;A+JzpgFQ;EACI,kBAAA;EACA,gDAAA;EACA,YAAA;A/J2pgFZ;A+JzpgFY;EACI,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;A/J2pgFhB;A+JtpgFI;EACI,cAAA;EACA,WAAA;A/JwpgFR;A+JrpgFI;EACI;IACI,YAAA;E/JupgFV;AACF;A+JppgFI;EA3DJ;IA4DQ,WAAA;IACA,WAAA;IACA,cAAA;E/JupgFN;E+JrpgFM;IACI,WAAA;IACA,cAAA;IACA,kBAAA;IACA,QAAA;IACA,YAAA;IACA,4BAAA;IACA,UAAA;IACA,UAAA;IACA,QAAA;IACA,iBAAA;E/JupgFV;E+JnpgFU;IACI,aAAA;E/JqpgFd;AACF;;A+J3ogFI;EACI,UAAA;EACA,iBAAA;EACA,kBAAA;A/J8ogFR;A+J7ogFQ;EACI,kBAAA;A/J+ogFZ;A+J7ogFQ;EAPJ;IAQQ,gBAAA;E/JgpgFV;E+J9ogFc;IACI,eAAA;E/JgpgFlB;E+J/ogFkB;IACI,aAAA;E/JipgFtB;E+J7ogFc;IACI,aAAA;E/J+ogFlB;AACF;A+J1ogFI;EACI;IACI,kBAAA;E/J4ogFV;E+J3ogFU;IACI,iBAAA;E/J6ogFd;E+J5ogFc;;IAEI,kBAAA;E/J8ogFlB;E+J5ogFkB;;IACI,WAAA;IACA,yBAAA;IACA,+CAAA;IACA,kBAAA;IACA,QAAA;IACA,SAAA;E/J+ogFtB;E+J3ogFkB;IACI,WAAA;E/J6ogFtB;E+J1ogFc;IACI,kBAAA;IACA,0BAAA;E/J4ogFlB;E+J1ogFkB;IACI,WAAA;IACA,WAAA;IACA,6CAAA;IACA,kBAAA;IACA,QAAA;IACA,2BAAA;IACA,OAAA;E/J4ogFtB;E+JxogFc;IACI,iBAAA;E/J0ogFlB;AACF;A+JtogFI;EACI;IACI,iBAAA;E/JwogFV;E+JvogFU;IACI,iBAAA;E/JyogFd;E+JvogFc;IACI,WAAA;IACA,YAAA;IACA,QAAA;IACA,+CAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;IACA,gBAAA;E/JyogFlB;E+JtogFc;IACI,WAAA;IACA,WAAA;IACA,6CAAA;IACA,kBAAA;IACA,MAAA;IACA,SAAA;E/JwogFlB;E+JpogFkB;IACI,aAAA;E/JsogFtB;E+JjogFkB;IACI,WAAA;IACA,YAAA;IACA,+CAAA;IACA,kBAAA;IACA,SAAA;IACA,OAAA;E/JmogFtB;E+JjogFkB;IACI,YAAA;E/JmogFtB;E+J/ngFc;IACI,kBAAA;E/JiogFlB;E+J/ngFkB;IACI,WAAA;IACA,YAAA;IACA,+CAAA;IACA,kBAAA;IACA,SAAA;IACA,SAAA;IACA,cAAA;E/JiogFtB;AACF;A+J3ngFI;EACI,2BAAA;EACA,gBAAA;EACA,cAAA;A/J6ngFR;;A+JrngFI;EACI,2BAAA;EACA,cAAA;A/JwngFR;A+JrngFQ;EACI,eAAA;A/JungFZ;A+JrngFY;EACI,aAAA;A/JungFhB;A+JnngFQ;EACI,aAAA;A/JqngFZ;A+JlngFI;EACI,kBAAA;EACA,iBAAA;A/JongFR;A+JnngFQ;EACI,WAAA;EACA,8CAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;A/JqngFZ;A+JlngFY;EACI,kBAAA;EACA,2BAAA;A/JongFhB;A+JnngFgB;EACI,WAAA;EACA,WAAA;EACA,6CAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,OAAA;A/JqngFpB;A+JjngFQ;EACI,iBAAA;A/JmngFZ;A+J/mgFQ;EACI,kBAAA;A/JingFZ;A+JhngFY;EACI,kBAAA;A/JkngFhB;A+JjngFgB;EACI,WAAA;EACA,YAAA;EACA,8CAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,gBAAA;A/JmngFpB;A+JhngFoB;EACI,YAAA;A/JkngFxB;A+J3mgFY;EACI,YAAA;A/J6mgFhB;;AgKrkhFA;EACI,aAAA;EACA,kBAAA;EACA,qBAAA;AhKwkhFJ;AgKtkhFI;EACI,aAAA;EACA,WAAA;EACA,iBAAA;AhKwkhFR;AgKrkhFI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qDAAA;EACA,YAAA;AhKukhFR;;AgKlkhFI;EACI,mBAAA;AhKqkhFR;AgKnkhFQ;EACI,cAAA;EACA,UAAA;AhKqkhFZ;AgKlkhFQ;EACI,gBAAA;AhKokhFZ;AgKlkhFY;EACI,kBAAA;AhKokhFhB;AgKlkhFgB;EACI,WAAA;AhKokhFpB;AgKhkhFY;EACI,cAAA;AhKkkhFhB;AgK9jhFgB;EACI,qBAAA;EACA,cAAA;AhKgkhFpB;AgK7jhFgB;EACI,WzJnBZ;APklhFR;AgK3jhFoB;EACI,WzJxBhB;APqlhFR;AgKxjhFY;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AhK0jhFhB;AgKxjhFgB;EACI,eAAA;AhK0jhFpB;AgKvjhFgB;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;AhKyjhFpB;AgKrjhFY;EACI,WAAA;EACA,gBAAA;AhKujhFhB;AgKnjhFQ;EACI;IACI,cAAA;IACA,aAAA;EhKqjhFd;AACF;AgKljhFQ;EACI;IACI,cAAA;IACA,UAAA;EhKojhFd;AACF;AgKjjhFQ;EACI;IACI,cAAA;IACA,WAAA;EhKmjhFd;AACF;AgK/ihFI;EACI,sBAAA;AhKijhFR;AgK/ihFQ;EACI,mBAAA;AhKijhFZ;AgK/ihFY;EACI,mBAAA;EACA,8BAAA;AhKijhFhB;AgK9ihFY;EACI,aAAA;EACA,mBAAA;AhKgjhFhB;AgK9ihFgB;EACI,YAAA;EACA,WAAA;EACA,eAAA;AhKgjhFpB;AgK7ihFgB;EACI,iBAAA;AhK+ihFpB;AgK3ihFY;EACI,WAAA;EACA,cAAA;EAEA,QAAA;AhK6ihFhB;AgK1ihFY;EACI,czJoLA;APw3gFhB;AgKxihFQ;EAtCJ;IAuCQ,mBAAA;EhK2ihFV;EgK1ihFU;IAGI,cAAA;IACA,WAAA;EhK4ihFd;EgKxihFc;IACI,WAAA;IACA,cAAA;IACA,SAAA;IACA,mBAAA;EhK0ihFlB;EgKxihFkB;IACI,UAAA;EhK0ihFtB;EgKtihFc;IACI,mBAAA;EhKwihFlB;EgKrihFc;IACI,WAAA;IACA,gBAAA;EhKuihFlB;AACF;;AgKjihFA;EACI,cAAA;AhKoihFJ;;AgK/hhFQ;EACI,yBzJpHL;EyJqHK,WzJ3JJ;AP6rhFR;;AgK5hhFI;EACI,qBAAA;EACA,cAAA;EACA,WAAA;AhK+hhFR;AgK7hhFI;EACI,WzJvKA;APsshFR;AgK3hhFQ;EACI,WzJ5KJ;APyshFR;;AiKxuhFA;EACI,kBAAA;EACA,aAAA;EACA,SAAA;AjK2uhFJ;AiKxuhFI;EACI,UAAA;AjK0uhFR;AiKvuhFgB;EACI,aAAA;AjKyuhFpB;AiKpuhFI;EACI,eAAA;EACA,gB1JipBa;E0JhpBb,cAAA;EACA,kBAAA;EACA,0CAAA;EACA,yBAAA;AjKsuhFR;AiKnuhFI;EACI,wCAAA;EACA,iBAAA;EACA,kBAAA;EACA,sC1J04Ca;E0Jz4Cb,4C1JokBK;E0JnkBL,gB1JqoBe;E0JpoBf,eAAA;AjKquhFR;AiKpuhFQ;EARJ;IASQ,eAAA;EjKuuhFV;AACF;AiKruhFQ;EACI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,2BAAA;AjKuuhFZ;;AiKjuhFA;EACI,sCAAA;AjKouhFJ;;AiKjuhFA;EACI;IAAK,wBAAA;EjKquhFP;EiKpuhFE;IAAO,4BAAA;EjKuuhFT;AACF;AiKruhFA;EACI,gB1JwmBmB;E0JvmBnB,yBAAA;EACA,W1J/BI;E0JgCJ,4BAAA;AjKuuhFJ;;AiKpuhFA;EACI,gBAAA;AjKuuhFJ;;AkK5yhFA;EACI,kBAAA;EACA,gBAAA;AlK+yhFJ;AkK7yhFI;EACI,eAAA;EACA,W3J2BA;E2J1BA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;AlK+yhFR;AkK7yhFQ;EACI,eAAA;AlK+yhFZ;AkK5yhFQ;EAdJ;IAeQ,eAAA;ElK+yhFV;EkK7yhFU;IACI,eAAA;ElK+yhFd;AACF;;AkKzyhFI;EACI,aAAA;AlK4yhFR;AkK3yhFQ;EACI,cAAA;AlK6yhFZ;AkK3yhFQ;EACI,cAAA;AlK6yhFZ;AkK3yhFQ;EACI,cAAA;AlK6yhFZ;;AkKxyhFA;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AlK2yhFJ;AkKzyhFI;EACI,iBAAA;EACA,eAAA;AlK2yhFR;AkKxyhFI;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,UAAA;EACA,oBAAA;EACA,mCAAA;EACA,iCAAA;AlK0yhFR;AkKxyhFQ;EACI,qBAAA;AlK0yhFZ;AkKvyhFQ;EACI,qBAAA;AlKyyhFZ;;AkKpyhFA;EACI;IACI,UAAA;IACA,mBAAA;ElKuyhFN;EkKpyhFE;IACI,UAAA;IACA,mBAAA;ElKsyhFN;AACF;AkKlyhFI;EACI,WAAA;EACA,qBAAA;AlKoyhFR;;AmKl4hFA;EACI,aAAA;AnKq4hFJ;;AmKj4hFI;EACI,UAAA;EACA,YAAA;EACA,wCAAA;AnKo4hFR;AmKj4hFI;EACI,wCAAA;AnKm4hFR;;AmK53hFI;EADJ;IAEQ,gBAAA;IACA,wBAAA;EnKg4hFN;AACF;;AmK33hFQ;EACI,wCAAA;EACA,sB5J+iBI;E4J9iBJ,eAAA;EACA,eAAA;AnK83hFZ;AmK13hFY;EACI,iCAAA;AnK43hFhB;;AmKn3hFY;EACI,wBAAA;AnKs3hFhB;;AmKh3hFA;EACI,aAAA;AnKm3hFJ;;AoKx6hFQ;EACI,YAAA;ApK26hFZ;;AoKr6hFI;EACI,YAAA;EACA,mBAAA;EACA,eAAA;ApKw6hFR;AoKt6hFI;EACI,uBAAA;ApKw6hFR;AoKt6hFI;EACI,WAAA;ApKw6hFR;AoKv6hFQ;EACI,QAAA;ApKy6hFZ;AoKv6hFQ;EACI,mBAAA;ApKy6hFZ;;AqKh8hFA;EACI,kBAAA;EACA,kBAAA;ArKm8hFJ;;AqK97hFA;EACI,2BAAA;EACA,kBAAA;EACA,wCAAA;ArKi8hFJ;AqK/7hFI;EALJ;IAMQ,gBAAA;IACA,gBAAA;IACA,uCAAA;ErKk8hFN;AACF;;AqK97hFA;EACI,SAAA;ArKi8hFJ;AqK77hFY;EACI,mDhFiHkC;EgFhHlC,wBhFiHkC;ArF80hFlD;AqK77hFgB;EACI,8DAAA;EACA,yBAAA;ArK+7hFpB;AqK17hFQ;EACI,cAAA;EACA,iBAAA;EACA,2BAAA;EACA,oBAAA;EACA,qC9J7BY;E8J8BZ,gB9J2nBS;E8J1nBT,mB9JmnBK;APy0gFjB;AqKz7hFQ;EACI,eAAA;ArK27hFZ;AqKx7hFQ;EACI,gB9JmnBW;APu0gFvB;AqKv7hFQ;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;ArKy7hFZ;AqKv7hFY;EACI,iBAAA;EACA,gB9JumBO;E8JtmBP,eAAA;ArKy7hFhB;;AqKn7hFA;EACI,kBAAA;ArKs7hFJ;AqKp7hFI;EACI,WAAA;EACA,YAAA;EACA,yB9JtCG;E8JuCH,kBAAA;EACA,wCAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;ArKs7hFR;AqKl7hFQ;EACI,yB9JlBJ;APs8hFR;AqK/6hFQ;EACI,yB9JzBH;AP08hFT;;AqK56hFA;EACI,+BAAA;ArK+6hFJ;AqK76hFI;EAHJ;IAIQ,2BAAA;ErKg7hFN;AACF;;AqK16hFI;EACI,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,2BAAA;EACA,qC9JtGgB;E8JuGhB,gB9JkjBa;E8JjjBb,mB9J0iBS;APm4gFjB;;AqKz6hFA;EACI,iBAAA;EACA,c9JwMY;E8JvMZ,gB9J0iBiB;E8JziBjB,kBAAA;EACA,eAAA;ArK46hFJ;AqK36hFI;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,QAAA;EACA,iCAAA;ArK66hFR;;AqKt6hFA;EACI,oDAAA;EACA,oBAAA;EACA,kBAAA;EACA,mCAAA;ArKy6hFJ;AqKv6hFI;EANJ;IAOQ,kBAAA;IACA,OAAA;IACA,QAAA;IACA,WAAA;IACA,wBAAA;IACA,kBAAA;IACA,2BAAA;IACA,WAAA;IACA,iBAAA;ErK06hFN;EqKx6hFM;IACI,mBAAA;IACA,wBAAA;ErK06hFV;AACF;AqKv6hFI;EACI,kBAAA;ArKy6hFR;AqKr6hFQ;EACI,aAAA;ArKu6hFZ;AqKp6hFY;EADJ;IAEQ,wBAAA;ErKu6hFd;AACF;;AqKl6hFA;EACI,oCAAA;EACA,wCAAA;ArKq6hFJ;AqKp6hFI;EAHJ;IAIQ,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;IACA,UAAA;ErKu6hFN;AACF;;AqKl6hFI;EACI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,c9JhKG;APqkiFX;AqKn6hFI;EAVJ;IAWQ,aAAA;IACA,yBAAA;ErKs6hFN;AACF;;AqKl6hFA;EACI,2BAAA;ArKq6hFJ;AqKp6hFI;EAFJ;IAGQ,2BAAA;ErKu6hFN;AACF;AqKr6hFI;EACI,aAAA;EACA,sBAAA;ArKu6hFR;AqKr6hFQ;EACI,gBAAA;ArKu6hFZ;AqKn6hFI;EACI,iBAAA;EACA,gBAAA;ArKq6hFR;AqKp6hFQ;EACI,aAAA;ArKs6hFZ;AqKh6hFY;EACI,gBAAA;ArKk6hFhB;AqK15hFY;EACI,aAAA;ArK45hFhB;AqKz5hFQ;EACI,kBAAA;ArK25hFZ;AqKv5hFY;EACI,mBAAA;ArKy5hFhB;AqKp5hFI;EACI,kBAAA;ArKs5hFR;AqKp5hFQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;ArKs5hFZ;AqKl5hFI;EACI,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;ArKo5hFR;AqKl5hFQ;EACI,sB9JpPJ;E8JqPI,kBAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;ArKo5hFZ;AqKj5hFQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,0CAAA;EACA,SAAA;ArKm5hFZ;AqKh5hFQ;EACI,eAAA;ArKk5hFZ;AqK94hFI;EACI,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;ArKg5hFR;AqK94hFQ;EAPJ;IAQQ,cAAA;ErKi5hFV;AACF;AqK/4hFQ;EACI,aAAA;EACA,mBAAA;ArKi5hFZ;AqK94hFQ;EACI,qBAAA;EACA,sBAAA;ArKg5hFZ;AqK74hFQ;EACI,kBAAA;EACA,iChF1LsC;EgF2LtC,kBAAA;EACA,kBAAA;EACA,6C9J+RI;APgnhFhB;AqK54hFgB;EACI;IACI,aAAA;ErK84hFtB;EqK34hFkB;IACI,cAAA;ErK64hFtB;AACF;AqKx4hFQ;EACI,gB9J8US;E8J7UT,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;ArK04hFZ;AqKt4hFY;EACI,eAAA;EACA,YAAA;EACA,c9J3TL;APmsiFX;AqKv4hFgB;EACI,aAAA;ArKy4hFpB;AqKt4hFgB;EARJ;IASQ,aAAA;ErKy4hFlB;AACF;AqKp4hFQ;EACI,eAAA;EACA,eAAA;EACA,iBAAA;ArKs4hFZ;AqKn4hFQ;EACI,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;ArKq4hFZ;AqKn4hFY;EACI,kBAAA;ArKq4hFhB;AqKl4hFY;EACI,gBAAA;ArKo4hFhB;AqKj4hFY;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;ArKm4hFhB;AqKh4hFoB;EACI,eAAA;EACA,W9J3WhB;E8J4WgB,qBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;ArKk4hFxB;AqK33hFI;EACI,yBAAA;ArK63hFR;AqK33hFQ;EACI,QAAA;EACA,iBAAA;EACA,iBAAA;ArK63hFZ;AqK13hFQ;EACI,gBAAA;EACA,c9J9XD;AP0viFX;AqKz3hFQ;EACI,iBAAA;ArK23hFZ;AqKz3hFY;EACI,yBAAA;ArK23hFhB;AqKz3hFgB;EACI,QAAA;EACA,mDhFrS8B;EgFsS9B,wBhFrS8B;EgFsS9B,iBAAA;EACA,gB9JqLH;APsshFjB;AqKz3hFoB;EACI,0CAAA;EACA,4CAAA;EACA,c9J9Yb;APywiFX;AqKz3hFwB;EACI,qCAAA;ArK23hF5B;AqKr3hFY;EACI,yBAAA;ArKu3hFhB;AqKr3hFgB;EACI,QAAA;ArKu3hFpB;AqKp3hFgB;EACI,QAAA;ArKs3hFpB;AqKn3hFgB;EACI,QAAA;ArKq3hFpB;AqKj3hFY;EACI,QAAA;ArKm3hFhB;AqK/2hFQ;EACI,yB9J9aD;AP+xiFX;;AqK52hFA;EACI,iCAAA;EACA,wCAAA;EACA,kBAAA;EACA,UAAA;ArK+2hFJ;AqK72hFI;EACI,aAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,c9JtaF;APqxiFN;AqK72hFI;EACI,cAAA;ArK+2hFR;;AqK32hFA;EACI,aAAA;ArK82hFJ;AqK52hFQ;EACI,gBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;ArK82hFZ;AqK72hFY;EACI,c9JldL;APi0iFX;;AqKv2hFA;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;ArK02hFJ;;AqKv2hFA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,4CAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;ArK02hFJ;AqKx2hFI;EAXJ;IAYQ,aAAA;ErK22hFN;AACF;AqKz2hFI;EACI,4BAAA;EACA,UAAA;ArK22hFR;AqKz2hFQ;EAJJ;IAKQ,4BAAA;ErK42hFV;AACF;;AqKx2hFA;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kDAAA;EACA,qDAAA;ArK22hFJ;AqKz2hFI;EACI,qCAAA;EACA,eAAA;ArK22hFR;;AqKp2hFI;EACI,2BAAA;ArKu2hFR;AqKn2hFQ;EACI,0BAAA;ArKq2hFZ;AqKj2hFI;EACI,oBAAA;EACA,qBAAA;ArKm2hFR;;AqK51hFQ;EADJ;IAEQ,yBAAA;IACA,0BAAA;ErKg2hFV;AACF;AqK/1hFQ;EALJ;IAMQ,wBAAA;ErKk2hFV;AACF;AqK/1hFI;EACI,wCAAA;ArKi2hFR;AqKh2hFQ;EAFJ;IAGQ,uCAAA;ErKm2hFV;AACF;AqKh2hFI;EACI,2BAAA;ArKk2hFR;AqKj2hFQ;EAFJ;IAGQ,2BAAA;ErKo2hFV;AACF;AqKj2hFI;EACI,2BAAA;ArKm2hFR;AqKl2hFQ;EAFJ;IAGQ,2BAAA;ErKq2hFV;AACF;;AsKt8iFA;EACI,kBAAA;EACA,kBAAA;AtKy8iFJ;;AsKp8iFA;EACI,2BAAA;EACA,kBAAA;EACA,wCAAA;EACA,oBAAA;AtKu8iFJ;AsKr8iFI;EANJ;IAOQ,gBAAA;IACA,gBAAA;IACA,uCAAA;EtKw8iFN;AACF;AsKt8iFI;EAZJ;IAaQ,eAAA;IACA,MAAA;IACA,SAAA;IACA,OAAA;IACA,YAAA;IACA,eAAA;IACA,aAAA;IACA,6C/J2kBQ;I+J1kBR,4BAAA;IACA,kBAAA;IACA,aAAA;EtKy8iFN;EsKv8iFM;IACI,mBAAA;IACA,eAAA;EtKy8iFV;AACF;AsKt8iFI;EACI,2BAAA;AtKw8iFR;AsKt8iFQ;EAHJ;IAIQ,2BAAA;EtKy8iFV;AACF;;AsKp8iFI;EACI,aAAA;EACA,mBAAA;EACA,c/JZG;E+JaH,cAAA;EACA,gB/JgnBa;APu1hFrB;AsKr8iFQ;EACI,c/J0QI;AP6riFhB;AsKp8iFQ;EACI,eAAA;AtKs8iFZ;AsKn8iFQ;EACI,c/JKJ;E+JJI,gB/JqmBW;APg2hFvB;AsKn8iFY;EACI,c/JCR;APo8iFR;;AsK97iFI;EACI,iBAAA;AtKi8iFR;AsKh8iFQ;EACI,gDAAA;AtKk8iFZ;;AsK77iFI;EACI,gCAAA;AtKg8iFR;AsK97iFQ;EACI,c/J8OM;APktiFlB;;AsK37iFA;EACI,WAAA;EACA,wCAAA;EACA,oBAAA;AtK87iFJ;;AsK37iFA;EACI,eAAA;EACA,YjFiC8C;EiFhC9C,SAAA;EACA,2BAAA;EACA,UAAA;AtK87iFJ;;AsK37iFA;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,wCAAA;EACA,2BAAA;EACA,oBAAA;EACA,aAAA;EACA,wCAAA;AtK87iFJ;;AsK17iFI;EACI,eAAA;EACA,cAAA;EACA,UAAA;AtK67iFR;AsK17iFI;EACQ,eAAA;AtK47iFZ;;AsKx7iFA;EACI,2BAAA;AtK27iFJ;AsKz7iFI;EAHJ;IAIQ,2BAAA;EtK47iFN;AACF;;AsKz7iFA;EACI,2BAAA;AtK47iFJ;AsK17iFI;EAHJ;IAIQ,2BAAA;EtK67iFN;AACF;;AsK17iFA;EACI,cAAA;EACA,eAAA;EACA,SAAA;AtK67iFJ;AsK37iFI;EACI,kBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;AtK67iFR;AsK37iFQ;EACI,8BAAA;AtK67iFZ;AsK17iFQ;EACI,2BAAA;EACA,0BAAA;AtK47iFZ;AsKz7iFQ;EACI,WAAA;EACA,kBAAA;AtK27iFZ;AsKx7iFQ;EACI,YAAA;AtK07iFZ;AsKx7iFY;;;EAGI,cAAA;EACA,WAAA;AtK07iFhB;AsKv7iFY;EACI,6BAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;AtKy7iFhB;AsKt7iFY;EACI,qBAAA;EACA,mBAAA;AtKw7iFhB;AsKr7iFY;EACI,gBAAA;EACA,gBAAA;AtKu7iFhB;AsKp7iFY;EACI,kBAAA;EACA,MAAA;EACA,UAAA;EACA,QAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AtKs7iFhB;AsKp7iFgB;EAVJ;IAWQ,UAAA;EtKu7iFlB;AACF;AsKn7iFQ;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;AtKq7iFZ;AsKn7iFY;;EAEI,kBAAA;EACA,MAAA;AtKq7iFhB;AsKl7iFY;EACI,OAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AtKo7iFhB;AsKl7iFgB;EACI,gCAAA;AtKo7iFpB;AsKh7iFY;EACI,QAAA;EACA,YAAA;EACA,kBAAA;AtKk7iFhB;AsK96iFQ;EAEI,iCAAA;EACA,iCAAA;AtK+6iFZ;AsK36iFQ;EACI,2BAAA;AtK66iFZ;AsK36iFY;EACI,2BAAA;EACA,gB/J6ZO;APghiFvB;;AsKv6iFA;EACI,aAAA;AtK06iFJ;;AsKv6iFA;EACI,aAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;AtK06iFJ;;AsKv6iFA;EACI,mBAAA;AtK06iFJ;;AsKv6iFA;EACI;IACI,cAAA;IACA,eAAA;IACA,MAAA;IACA,SAAA;IACA,UAAA;IACA,QAAA;IACA,YAAA;IACA,eAAA;IACA,aAAA;IACA,6C/JyTQ;I+JxTR,2BAAA;IACA,kBAAA;EtK06iFN;;EsKt6iFM;IACI,YAAA;IACA,eAAA;IACA,mBAAA;EtKy6iFV;AACF;AsKp6iFA;EACI;IACI,YAAA;EtKs6iFN;AACF;AsKl6iFI;EACI,4BAAA;AtKo6iFR;;AsKh6iFA;EACI,YAAA;EACA,eAAA;EACA,eAAA;EACA,YjFvM8C;EiFwM9C,WjFxM8C;EiFyM9C,UAAA;EACA,aAAA;AtKm6iFJ;AsKl6iFI;EACI,6C/JqRQ;AP+oiFhB;AsKj6iFI;EAZJ;IAaQ,UAAA;IACA,WAAA;EtKo6iFN;AACF;;AsKj6iFA;EACI,kBAAA;EACA,gBAAA;AtKo6iFJ;AsKn6iFI;EACI,wBAAA;AtKq6iFR;AsKl6iFI;EACI,WAAA;AtKo6iFR;AsKj6iFI;EACI,YAAA;AtKm6iFR;AsKh6iFI;EACI,uDAAA;EACA,mBAAA;EACA,wCAAA;AtKk6iFR;AsK/5iFI;EACI,mBAAA;EACA,wCAAA;AtKi6iFR;;AsK15iFQ;EADJ;IAEQ,yBAAA;IACA,0BAAA;EtK85iFV;AACF;AsK75iFQ;EALJ;IAMQ,wBAAA;EtKg6iFV;AACF;AsK75iFI;EACI,wCAAA;AtK+5iFR;AsK95iFQ;EAFJ;IAGQ,aAAA;EtKi6iFV;AACF;AsKh6iFQ;EACI,2BAAA;AtKk6iFZ;AsKj6iFY;EAFJ;IAGQ,2BAAA;EtKo6iFd;AACF;AsKh6iFI;EACI,2BAAA;AtKk6iFR;AsK95iFI;EACI,2BAAA;AtKg6iFR;AsK/5iFQ;EAFJ;IAGQ,2BAAA;EtKk6iFV;AACF;;AuKzzjFA;EACI,aAAA;EACA,gBAAA;EACA,oBAAA;AvK4zjFJ;AuK1zjFI;EACI,gBAAA;EACA,kBAAA;AvK4zjFR;AuKzzjFI;EACI,wBAAA;AvK2zjFR;AuKxzjFI;EACI,WAAA;AvK0zjFR;AuKvzjFI;EACI,WAAA;AvKyzjFR;AuKtzjFI;EACI,iDAAA;EACA,kBAAA;AvKwzjFR;AuKrzjFI;EACI,kBAAA;AvKuzjFR;;AuKlzjFI;EACI,sEAAA;AvKqzjFR;AuKlzjFI;EACI,aAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AvKozjFR;AuKjzjFI;EACI,kBAAA;AvKmzjFR;;AuK/yjFA;EACI,+BAAA;AvKkzjFJ;;AuK9yjFA;EACI,iBAAA;EACA,kBAAA;AvKizjFJ;AuK9yjFQ;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,0DAAA;EACA,sBAAA;EACA,2BAAA;AvKgzjFR;;AuKzyjFQ;EACI,UAAA;AvK4yjFZ;AuKxyjFY;EACI,UAAA;AvK0yjFhB;;AwK93jFI;EACI,wCAAA;EACA,eAAA;AxKi4jFR;;AwK53jFI;EACI,cAAA;AxK+3jFR;;AwKz3jFA;EACI,eAAA;EACA,kBAAA;AxK43jFJ;AwK13jFI;EAJJ;IAKQ,eAAA;ExK63jFN;AACF;;AwK13jFA;EACI,kBAAA;AxK63jFJ;AwK33jFI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yCAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;AxK63jFR;;AwKv3jFA;EACI,iBAAA;EACA,yBAAA;AxK03jFJ;AwKz3jFI;EAHJ;IAIQ,wCAAA;IACA,kDAAA;IACA,iBAAA;ExK43jFN;AACF;AwKx3jFY;EACI,eAAA;EACA,gBjK+mBK;EiK9mBL,oBAAA;EACA,qCjK5CQ;EiK6CR,2BAAA;EACA,aAAA;AxK03jFhB;AwKx3jFgB;EARJ;IASQ,gBAAA;ExK23jFlB;AACF;AwKz3jFgB;EAGI,yBAAA;AxKy3jFpB;AwKn3jFI;EACI,wCAAA;EACA,kDAAA;AxKq3jFR;;AwK92jFQ;EACI,aAAA;AxKi3jFZ;AwK92jFQ;EACI,cAAA;AxKg3jFZ;AwK32jFY;EACI,sCAAA;AxK62jFhB;AwKt2jFgB;EACI,2BAAA;AxKw2jFpB;AwKn2jFY;EACI,cAAA;AxKq2jFhB;AwKl2jFY;EACI,aAAA;AxKo2jFhB;;AwK51jFA;EACI,gDAAA;AxK+1jFJ;AwK31jFY;EACI,4BAAA;AxK61jFhB;;AwKv1jFA;EACI,0DAAA;EACA,6BAAA;EACA,2BAAA;EACA,sBAAA;EACA,YAAA;AxK01jFJ;;AwKv1jFA;EACI,kBAAA;EACA,UAAA;AxK01jFJ;AwKv1jFQ;EACI,wCAAA;EACA,YAAA;EACA,kBAAA;AxKy1jFZ;AwKr1jFI;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;AxKu1jFR;AwKp1jFI;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;AxKs1jFR;;AwKj1jFA;EACI,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;AxKo1jFJ;;AwK/0jFA;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;AxKk1jFJ;;AwK90jFA;EACI,kBAAA;AxKi1jFJ;AwK/0jFI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;AxKi1jFR;;AwK70jFA;EACI,cAAA;AxKg1jFJ;;AwK30jFQ;EACI,cAAA;EACA,cAAA;EACA,cAAA;EACA,gCAAA;AxK80jFZ;AwK50jFY;EACI,+BAAA;AxK80jFhB;;AwKv0jFI;EACI,cAAA;EACA,2CAAA;EACA,yBAAA;AxK00jFR;AwKx0jFQ;EACI,WjK5LJ;EiK6LI,yBjKoGI;APsujFhB;;AwKp0jFI;EACI,YAAA;AxKu0jFR;;AwK9zjFQ;;EAEI,YAAA;AxKi0jFZ;AwK9zjFQ;EACI,mDAAA;AxKg0jFZ;AwKxzjFgB;EACI,aAAA;AxK0zjFpB;AwKvzjFgB;EACI,cAAA;AxKyzjFpB;;AyKzjkFI;EACI,gCAAA;EACA,4CAAA;EACA,4ClKgmBK;EkK/lBL,mBlKypBS;APm6iFjB;AyK3jkFQ;EAEI,yBAAA;EACA,clKyDN;APmgkFN;;AyKvjkFA;EACI,kBAAA;EACA,gBAAA;AzK0jkFJ;AyKzjkFI;EACI,aAAA;EACA,iBAAA;AzK2jkFR;AyKzjkFI;EACI,kBAAA;EACA,gBAAA;EACA,UAAA;AzK2jkFR;AyK1jkFQ;EACI,kBAAA;EACA,QAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,uCAAA;EACA,UAAA;EACA,yBAAA;AzK4jkFZ;AyKzjkFQ;EACI,QAAA;EACA,kBAAA;EACA,SAAA;EACA,gCAAA;AzK2jkFZ;AyKzjkFY;EACI,UAAA;EACA,aAAA;EACA,qBAAA;AzK2jkFhB;AyKnjkFgB;EACI,UAAA;EACA,SAAA;AzKqjkFpB;AyKjjkFY;EACI,UAAA;AzKmjkFhB;AyK/ikFI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,0CAAA;EACA,0BAAA;EACA,YAAA;AzKijkFR;;AyK5ikFA;EACI,0DAAA;EACA,sBAAA;EACA,2BAAA;EACA,wBAAA;AzK+ikFJ;AyK9ikFI;EACI,yBAAA;EACA,aAAA;AzKgjkFR;;AyK3ikFI;EACI,aAAA;AzK8ikFR;AyK5ikFQ;EACI,cAAA;AzK8ikFZ;;A0K3okFA;EACI,+BAAA;A1K8okFJ;A0K5okFI;EAHJ;IAIQ,2BAAA;E1K+okFN;AACF;A0K7okFI;EACI,gBAAA;A1K+okFR;A0K7okFQ;EACI,2BAAA;EACA,gBnKypBS;EmKxpBT,yBAAA;A1K+okFZ;A0K7okFY;EAGI,cnKmDR;AP0lkFR;A0KxokFY;EACI,kBAAA;EACA,kBAAA;A1K0okFhB;A0KxokFgB;EACI,aAAA;EACA,kBAAA;EACA,SAAA;EACA,kCAAA;EACA,oCAAA;A1K0okFpB;;A0KnokFA;EACI,kBAAA;EACA,wCAAA;A1KsokFJ;A0KpokFI;EAJJ;IAKQ,gBAAA;IACA,gBAAA;IACA,uCAAA;E1KuokFN;AACF;A0KrokFI;EAVJ;IAWQ,eAAA;IACA,MAAA;IACA,SAAA;IACA,OAAA;IACA,YAAA;IACA,eAAA;IACA,aAAA;IACA,6CnK6iBQ;ImK5iBR,4BAAA;IACA,kBAAA;IACA,aAAA;E1KwokFN;E0KtokFM;IACI,mBAAA;IACA,eAAA;E1KwokFV;AACF;;A0KpokFA;EACI,2BAAA;A1KuokFJ;A0KtokFI;EAFJ;IAGQ,2BAAA;E1KyokFN;AACF;;A0KtokFA;EACI,wCAAA;A1KyokFJ;;A0KtokFA;EACI,2BAAA;A1KyokFJ;A0KxokFI;EAFJ;IAGQ,2BAAA;E1K2okFN;AACF;A0KzokFI;EACI,YAAA;A1K2okFR;;A0KvokFA;EACI,2BAAA;A1K0okFJ;A0KzokFI;EAFJ;IAGQ,aAAA;E1K4okFN;AACF;A0K1okFI;EACI,YAAA;A1K4okFR;;A0KxokFA;EACI,UAAA;EACA,eAAA;EACA,wCAAA;EACA,aAAA;A1K2okFJ;;A0KvokFI;EACI,cAAA;A1K0okFR;;A0KtokFA;EACI,aAAA;A1KyokFJ;;A0KtokFA;EACI;IACI,eAAA;IACA,MAAA;IACA,SAAA;IACA,UAAA;IACA,QAAA;IACA,YAAA;IACA,eAAA;IACA,aAAA;IACA,6CnKqeQ;ImKpeR,2BAAA;E1KyokFN;;E0KrokFM;IACI,eAAA;E1KwokFV;AACF;A0KpokFA;EACI,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A1KsokFJ;;A2KpxkFQ;EACI,2BAAA;EACA,eAAA;EACA,gBpKgqBS;EoK/pBT,iCAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;A3KuxkFZ;A2KtxkFY;EACI,cpKyDR;AP+tkFR;;A2KlxkFA;EACI,2BAAA;EACA,gBAAA;A3KqxkFJ;A2KpxkFI;EACI,wBAAA;A3KsxkFR;A2KnxkFI;EACI,UAAA;A3KqxkFR;A2KlxkFI;EACI,YAAA;A3KoxkFR;A2KjxkFI;EACI,uDAAA;EACA,kBAAA;A3KmxkFR;A2KhxkFI;EACI,kBAAA;A3KkxkFR;;A2K1wkFgB;EACI,6BAAA;A3K6wkFpB;;A2KtwkFA;EACI,YAAA;A3KywkFJ;;A2KtwkFA;EACI,aAAA;A3KywkFJ;;A4Kr0kFA;EACI,0DAAA;EACA,sBAAA;EACA,2BAAA;A5Kw0kFJ;;A4Kp0kFI;EACI,aAAA;A5Ku0kFR;;A4Kh0kFY;EADJ;IAEQ,UAAA;E5Ko0kFd;AACF;;A6Kz1kFA;EACI,UAAA;A7K41kFJ;;A6Kr1kFY;EACI,cAAA;EACA,aAAA;A7Kw1kFhB;A6Kn1kFI;EAVJ;IAWQ,wCAAA;IACA,eAAA;E7Ks1kFN;AACF;;A6Kl1kFA;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;A7Kq1kFJ;;A6Kl1kFA;EACI,wCAAA;EACA,sBtKojBY;EsKnjBZ,gBAAA;A7Kq1kFJ;A6Kn1kFI;EACI,YAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;A7Kq1kFR;A6Kl1kFI;EACI,gBAAA;A7Ko1kFR;A6Kj1kFI;EACI,8CAAA;A7Km1kFR;A6Kh1kFI;EApBJ;IAqBQ,6BAAA;E7Km1kFN;E6Kj1kFM;IACI,sBtKfJ;IsKgBI,sCtKq6BU;EP86iFpB;E6Kh1kFM;IACI,SAAA;E7Kk1kFV;E6K/0kFM;IACI,sCtKg2BQ;EPi/iFlB;AACF;;A6K70kFA;EACI,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;A7Kg1kFJ;A6K90kFI;EACI,wCAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;A7Kg1kFR;A6K70kFI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,wCAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;A7K+0kFR;A6K50kFI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,wCAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;A7K80kFR;A6K30kFI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,wCAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;A7K60kFR;A6K10kFI;EAhDJ;IAiDQ,aAAA;E7K60kFN;AACF;;A6Kz0kFI;EACI,kBAAA;EACA,UAAA;A7K40kFR;;A6Kv0kFA;;;EAGI,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;A7K00kFJ;A6Kx0kFI;;;EACI,2BAAA;A7K40kFR;;A6Kx0kFA;EACI,YAAA;EACA,SAAA;A7K20kFJ;A6Kz0kFI;EAJJ;IAKQ,OAAA;E7K40kFN;AACF;;A6Kz0kFA;EACI,YAAA;EACA,aAAA;A7K40kFJ;A6K10kFI;EAJJ;IAKQ,QAAA;E7K60kFN;AACF;;A6K10kFA;EACI,YAAA;EACA,aAAA;A7K60kFJ;A6K30kFI;EAJJ;IAKQ,QAAA;IACA,SAAA;E7K80kFN;AACF;;A6K30kFA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,iKAAA;EACA,UAAA;EACA,YAAA;A7K80kFJ;A6K50kFI;EACI,kBAAA;EACA,UAAA;A7K80kFR;;A6K10kFA;EACI,kBAAA;A7K60kFJ;A6K30kFI;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;EACA,sBtK6YQ;APg8jFhB;A6K30kFQ;EAXJ;IAYQ,WAAA;IACA,SAAA;E7K80kFV;AACF;;A6Kz0kFA;EACI,kBAAA;EACA,aAAA;EACA,YAAA;A7K40kFJ;;AmF9hlFA;;;;;;CAAA;AnFeE;EACE,kDAAA;AAyhlFJ;;AAphlFE;EACE,aAAA;AAuhlFJ;;AAnhlFA;EACE,uBAAA;EACA,sBAAA;EACA,6BAAA;EACA,uBAAA;EACA,oBAAA;AAshlFF;;AAnhlFA;;EAEE,sBAAA;EACA,8BAAA;AAshlFF;;AAnhlFA;EACE,8BAAA;EACA,8CAAA;EAEA,2BAAA;AAshlFF;;AAnhlFA;EACE,8BAAA;EACA,6BAAA;EACA,oCAAA;EACA,4CAAA;EACA,wCAAA;EACA,2BAAA;EACA,sBAAA;AAshlFF;;AAnhlFA;EACE,kBAAA;AAshlFF;;AAlhlFA;;EAEE,uBAAA;EACA,0BAAA;EACA,iBAAA;AAqhlFF;;AAlhlFA;EACE,uBAAA;AAqhlFF;;AqB/glFI;ErBFF;IACE,yBAAA;IACA,kBAAA;EAqhlFF;EAnhlFE;;;IAGE,WAAA;IACA,cAAA;IACA,WAAA;IACA,cAAA;EAqhlFJ;;EA9glFM;IACE,WAAA;EAihlFR;;EA3glFA;IACE,aAAA;EA8glFF;AACF;AA3glFA;EACE,wBAAA;AA6glFF;;AA1glFA;EACE,aAAA;AA6glFF;;AA1glFA;EACE,aAAA;AA6glFF;;AA1glFA;EACE,oCAAA;AA6glFF;;AAlglFI;EACE,8BAAA;AAqglFN;;AAtglFI;EACE,8BAAA;AAyglFN;;AA1glFI;EACE,8BAAA;AA6glFN;;AA9glFI;EACE,8BAAA;AAihlFN;;AAlhlFI;EACE,8BAAA;AAqhlFN;;AAthlFI;EACE,8BAAA;AAyhlFN;;AA1hlFI;EACE,8BAAA;AA6hlFN;;AA9hlFI;EACE,8BAAA;AAiilFN;;AAlilFI;EACE,8BAAA;AAqilFN;;AAtilFI;EACE,8BAAA;AAyilFN;;AA1ilFI;EACE,8BAAA;AA6ilFN;;AA9ilFI;EACE,8BAAA;AAijlFN;;AAljlFI;EACE,8BAAA;AAqjlFN;;AAtjlFI;EACE,8BAAA;AAyjlFN;;AA1jlFI;EACE,8BAAA;AA6jlFN;;AA9jlFI;EACE,2BAAA;AAiklFN;;AAlklFI;EACE,8BAAA;AAqklFN;;AA9jlFE;EACE,eAAA;EACA,YAAA;EACA,cO/FO;APgqlFX;;AA7jlFA;EACE,wBAAA;AAgklFF;;AA5jlFE;EACE,wBAAA;AA+jlFJ;;AAzjlFE;EACE,6BAAA;AA4jlFJ;;AAtjlFE;EACE,UAAA;EACA,UAAA;EACA,qBAAA;AAyjlFJ;;AApjlFE;EACE,UAAA;EACA,QAAA;AAujlFJ;;AAjjlFE;;EAEE,SAAA;AAojlFJ;;AAhjlFA;EACE,WAAA;EACA,SAAA;EACA,aAAA;AAmjlFF;;AA9ilFA;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;AAijlFF;;AA5ilFE;EACE,gBAAA;AA+ilFJ;AA5ilFE;EACE,QAAA;AA8ilFJ;AA3ilFE;EACE,cO3KO;APwtlFX;;AAvilFA;;EAEE,2COuvBS;EPtvBT,0DAAA;EACA,sCAAA;AA0ilFF;;AAvilFA;EACE,uCAAA;EACA,6CAAA;EACA,2CAAA;AA0ilFF;;AArilFE;;EAEE,kDAAA;EACA,0DAAA;AAwilFJ;;AApilFA;EACE,+CAAA;EACA,+CAAA;AAuilFF;;AApilFA;EACE,+CAAA;EACA,+CAAA;AAuilFF;;AApilFA,kCAAA;AACA;;;;EAIE,kEAAA;EACA,+CAAA;EACA,sCAAA;EACA,wDAAA;AAuilFF;;AA/hlFE;EACE,wCAAA;EACA,2BAAA;EACA,oCAAA;AAkilFJ;AAhilFI;EAEE,+BAAA;AAiilFN;AA9hlFI;EACE,sBAAA;EACA,mCAAA;AAgilFN;AA9hlFM;EACE,sBAAA;AAgilFR;AA7hlFM;EACE,oCAAA;AA+hlFR;AA1hlFE;EACE,2BAAA;AA4hlFJ;AAzhlFE;EACE,wCAAA;EACA,2BAAA;EACA,oCAAA;AA2hlFJ;AAzhlFI;EACE,sBAAA;EACA,mCAAA;AA2hlFN;AAzhlFM;EACE,sBAAA;AA2hlFR;AAxhlFM;EACE,oCAAA;AA0hlFR;AArhlFE;EACE,wCAAA;EACA,2BAAA;EACA,oCAAA;AAuhlFJ;AArhlFI;EACE,WOvRE;EPwRF,mCAAA;AAuhlFN;AArhlFM;EAGE,mCAAA;AAqhlFR","sourcesContent":["@import \"../scss/icons.scss\";\n@import \"../scss/config/saas/bootstrap.scss\";\n@import \"../scss/config/saas/app.scss\";\n@import \"../scss/config/saas/custom.scss\";\n@import\"./shepherd.css\";\n@import \"./mermaid.min.css\";\n\n//RTL \n// @import \"../scss/rtl/components-rtl\";\n// @import \"../scss/rtl/layouts-rtl\";\n// @import \"../scss/rtl/plugins-rtl\";\n// @import \"../scss/rtl/pages-rtl\";\n\n//Rigthsidebar offcanvas\n.offcanvas-header-dark {\n  .btn-close {\n    filter: invert(1) grayscale(100%) brightness(200%);\n  }\n}\n\nbody {\n  * {\n    outline: none;\n  }\n}\n\n.noUi-horizontal .noUi-handle {\n  height: 16px !important;\n  width: 16px !important;\n  border-radius: 50% !important;\n  right: -10px !important;\n  top: -7px !important;\n}\n\n.noUi-connect,\n.noUi-horizontal {\n  height: 2px !important;\n  background: #13c56b !important;\n}\n\n.noUi-handle {\n  background: #13c56b !important;\n  border: 2px solid var(--vz-card-bg) !important;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.noUi-target {\n  background: #fafafa !important;\n  border-radius: 4px !important;\n  border: 1px solid #d3d3d3 !important;\n  background-color: var(--vz-light) !important;\n  border-color: var(--vz-light) !important;\n  box-shadow: none !important;\n  height: 4px !important;\n}\n\n.dropzone .dz-message {\n  text-align: center;\n}\n\n// //Calendar\n.fc-direction-ltr .fc-daygrid-event.fc-event-end,\n.fc-direction-rtl .fc-daygrid-event.fc-event-start {\n  padding: 5px !important;\n  font-size: 12px !important;\n  margin-right: 2px;\n}\n\n.fc-event {\n  border: none !important;\n}\n\n@include media-breakpoint-down(sm) {\n  .fc-toolbar {\n    display: block !important;\n    text-align: center;\n\n    .fc-left,\n    .fc-right,\n    .fc-center {\n      float: none;\n      display: block;\n      clear: both;\n      margin: 10px 0;\n    }\n  }\n\n  .fc {\n    .fc-toolbar {\n      >* {\n        >* {\n          float: none;\n        }\n      }\n    }\n  }\n\n  .fc-today-button {\n    display: none;\n  }\n}\n\n.flatpickr-calendar.open {\n  z-index: 1090 !important;\n}\n\n.upcoming-scheduled .flatpickr-input[readonly] {\n  display: none;\n}\n\n.ql-container.ql-snow {\n  height: 250px;\n}\n\n.rangeslider-horizontal .rangeslider__fill {\n  background-color: #6691e7 !important;\n}\n\n// .Toastify__toast{\n//   min-height: 43px !important;\n//   max-height: 43px !important;\n// }\n\n@each $color,\n$value in $theme-colors {\n  .simplebar-track-#{$color} {\n    .simplebar-scrollbar:before {\n      background: $value !important;\n    }\n  }\n}\n\n// chat\n.chat-conversation .chat-list .message-box-drop {\n  .nav-btn {\n    font-size: 18px;\n    padding: 4px;\n    color: $gray-600;\n  }\n}\n\n.chatwidgets {\n  height: 250px !important;\n}\n\n[data-layout=\"horizontal\"] .chat-conversation {\n  &.chatwidgets {\n    height: 250px !important;\n  }\n}\n\n// Authentication pages \n#tsparticles {\n  canvas {\n    position: absolute !important;\n  }\n}\n\n// landing page\n.process-card {\n  .process-arrow-img {\n    left: auto;\n    right: 75%;\n    transform: scaleX(-1);\n  }\n}\n\n.icon-effect {\n  &::before {\n    left: auto;\n    right: 0;\n  }\n}\n\n.marketplace-swiper {\n\n  .swiper-button-next,\n  .swiper-button-prev {\n    top: 22px;\n  }\n}\n\n.alert-msg-show {\n  right: 24px;\n  top: 40px;\n  z-index: 1005;\n}\n\n// Emoji Picker\n\n.pickerEmoji {\n  position: absolute;\n  bottom: -50px;\n  left: 10%;\n  transform: translateX(-50%);\n}\n\n// Toast\n.Toastify {\n  .Toastify__toast {\n    min-height: 43px;\n  }\n\n  .Toastify__close-button {\n    top: 6px;\n  }\n\n  .Toastify__close-button--light {\n    color: $light;\n  }\n}\n\n// Tranfer List\n\n.rdl-filter,\n.rdl-control {\n  background-color: $input-bg;\n  border: 1px solid $input-border-color !important;\n  color: $input-color !important;\n}\n\n.rdl-move {\n  background: var(--#{$prefix}header) !important;\n  border: 1px solid var(--#{$prefix}header) !important;\n  color: var(--#{$prefix}--#{$prefix}body-color) !important;\n}\n\n.react-dual-listbox {\n\n  input:disabled,\n  select:disabled {\n    background-color: $input-disabled-bg !important;\n    border: 1px solid $input-border-color !important;\n  }\n}\n\n.css-26l3qy-menu {\n  background-color: var(--#{$prefix}gray-200) !important;\n  border-color: var(--#{$prefix}border-color) !important;\n}\n\n.css-1n7v3ny-option {\n  background-color: var(--#{$prefix}gray-300) !important;\n  border-color: var(--#{$prefix}border-color) !important;\n}\n\n/* Change the white to any color */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px var(--#{$prefix}input-bg) inset !important;\n  background-color: var(--#{$prefix}input-bg) !important;\n  color: var(--#{$prefix}body-color) !important;\n  -webkit-text-fill-color: var(--#{$prefix}body-color) !important;\n}\n\n\n\n\n//react select\n.css-b62m3t-container {\n  .css-13cymwt-control {\n    background-color: var(--#{$prefix}secondary-bg);\n    color: var(--#{$prefix}body-color);\n    border-color: var(--#{$prefix}border-color);\n\n    &:hover,\n    &:focus {\n      border-color: var(--#{$prefix}primary);\n    }\n\n    .css-1p3m7a8-multiValue {\n      color: var(--#{$prefix}white);\n      background-color: var(--#{$prefix}primary);\n\n      .css-wsp0cs-MultiValueGeneric {\n        color: var(--#{$prefix}white);\n      }\n\n      .css-1u9des2-indicatorSeparator {\n        border-color: var(--#{$prefix}border-color);\n      }\n    }\n  }\n\n  :is(.css-qbdosj-Input, .css-1dimb5e-singleValue) {\n    color: var(--#{$prefix}body-color);\n  }\n\n  .css-t3ipsp-control {\n    background-color: var(--#{$prefix}secondary-bg);\n    color: var(--#{$prefix}body-color);\n    border-color: var(--#{$prefix}border-color);\n\n    .css-1p3m7a8-multiValue {\n      color: var(--#{$prefix}white);\n      background-color: var(--#{$prefix}primary);\n\n      .css-wsp0cs-MultiValueGeneric {\n        color: var(--#{$prefix}white);\n      }\n\n      .css-1u9des2-indicatorSeparator {\n        border-color: var(--#{$prefix}border-color);\n      }\n    }\n  }\n\n  .css-1nmdiq5-menu {\n    background-color: var(--#{$prefix}secondary-bg);\n    color: var(--#{$prefix}body-color);\n    border-color: var(--#{$prefix}border-color);\n\n    .css-d7l1ni-option {\n      color: $white;\n      background-color: var(--#{$prefix}primary);\n\n      &:hover,\n      &:active,\n      &:focus {\n        background-color: var(--#{$prefix}primary);\n      }\n    }\n  }\n}","/*\nTemplate Name: Velzon - Admin & Dashboard Template\nAuthor: Themesbrand\nVersion: 3.0.0\nWebsite: https://Themesbrand.com/\nContact: Themesbrand@gmail.com\nFile: Icons Css File\n*/\n\n// Icons Scss\n@import \"plugins/icons/materialdesignicons\";\n@import \"plugins/icons/boxicons\";\n@import \"plugins/icons/line-awesome\";\n@import \"plugins/icons/remixicon\";","/* MaterialDesignIcons.com */\n@font-face {\n  font-family: \"Material Design Icons\";\n  src: url(\"../../../fonts/materialdesignicons-webfont.eot?v=6.5.95\");\n  src: url(\"../../../fonts/materialdesignicons-webfont.eot?#iefix&v=6.5.95\") format(\"embedded-opentype\"), url(\"../../../fonts/materialdesignicons-webfont.woff2?v=6.5.95\") format(\"woff2\"), url(\"../../../fonts/materialdesignicons-webfont.woff?v=6.5.95\") format(\"woff\"), url(\"../../../fonts/materialdesignicons-webfont.ttf?v=6.5.95\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n.mdi:before,\n.mdi-set {\n  display: inline-block;\n  font: normal normal normal 24px/1 \"Material Design Icons\";\n  font-size: inherit;\n  text-rendering: auto;\n  line-height: inherit;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.mdi-ab-testing::before {\n  content: \"\\F01C9\";\n}\n\n.mdi-abacus::before {\n  content: \"\\F16E0\";\n}\n\n.mdi-abjad-arabic::before {\n  content: \"\\F1328\";\n}\n\n.mdi-abjad-hebrew::before {\n  content: \"\\F1329\";\n}\n\n.mdi-abugida-devanagari::before {\n  content: \"\\F132A\";\n}\n\n.mdi-abugida-thai::before {\n  content: \"\\F132B\";\n}\n\n.mdi-access-point::before {\n  content: \"\\F0003\";\n}\n\n.mdi-access-point-check::before {\n  content: \"\\F1538\";\n}\n\n.mdi-access-point-minus::before {\n  content: \"\\F1539\";\n}\n\n.mdi-access-point-network::before {\n  content: \"\\F0002\";\n}\n\n.mdi-access-point-network-off::before {\n  content: \"\\F0BE1\";\n}\n\n.mdi-access-point-off::before {\n  content: \"\\F1511\";\n}\n\n.mdi-access-point-plus::before {\n  content: \"\\F153A\";\n}\n\n.mdi-access-point-remove::before {\n  content: \"\\F153B\";\n}\n\n.mdi-account::before {\n  content: \"\\F0004\";\n}\n\n.mdi-account-alert::before {\n  content: \"\\F0005\";\n}\n\n.mdi-account-alert-outline::before {\n  content: \"\\F0B50\";\n}\n\n.mdi-account-arrow-down::before {\n  content: \"\\F1868\";\n}\n\n.mdi-account-arrow-down-outline::before {\n  content: \"\\F1869\";\n}\n\n.mdi-account-arrow-left::before {\n  content: \"\\F0B51\";\n}\n\n.mdi-account-arrow-left-outline::before {\n  content: \"\\F0B52\";\n}\n\n.mdi-account-arrow-right::before {\n  content: \"\\F0B53\";\n}\n\n.mdi-account-arrow-right-outline::before {\n  content: \"\\F0B54\";\n}\n\n.mdi-account-arrow-up::before {\n  content: \"\\F1867\";\n}\n\n.mdi-account-arrow-up-outline::before {\n  content: \"\\F186A\";\n}\n\n.mdi-account-box::before {\n  content: \"\\F0006\";\n}\n\n.mdi-account-box-multiple::before {\n  content: \"\\F0934\";\n}\n\n.mdi-account-box-multiple-outline::before {\n  content: \"\\F100A\";\n}\n\n.mdi-account-box-outline::before {\n  content: \"\\F0007\";\n}\n\n.mdi-account-cancel::before {\n  content: \"\\F12DF\";\n}\n\n.mdi-account-cancel-outline::before {\n  content: \"\\F12E0\";\n}\n\n.mdi-account-cash::before {\n  content: \"\\F1097\";\n}\n\n.mdi-account-cash-outline::before {\n  content: \"\\F1098\";\n}\n\n.mdi-account-check::before {\n  content: \"\\F0008\";\n}\n\n.mdi-account-check-outline::before {\n  content: \"\\F0BE2\";\n}\n\n.mdi-account-child::before {\n  content: \"\\F0A89\";\n}\n\n.mdi-account-child-circle::before {\n  content: \"\\F0A8A\";\n}\n\n.mdi-account-child-outline::before {\n  content: \"\\F10C8\";\n}\n\n.mdi-account-circle::before {\n  content: \"\\F0009\";\n}\n\n.mdi-account-circle-outline::before {\n  content: \"\\F0B55\";\n}\n\n.mdi-account-clock::before {\n  content: \"\\F0B56\";\n}\n\n.mdi-account-clock-outline::before {\n  content: \"\\F0B57\";\n}\n\n.mdi-account-cog::before {\n  content: \"\\F1370\";\n}\n\n.mdi-account-cog-outline::before {\n  content: \"\\F1371\";\n}\n\n.mdi-account-convert::before {\n  content: \"\\F000A\";\n}\n\n.mdi-account-convert-outline::before {\n  content: \"\\F1301\";\n}\n\n.mdi-account-cowboy-hat::before {\n  content: \"\\F0E9B\";\n}\n\n.mdi-account-cowboy-hat-outline::before {\n  content: \"\\F17F3\";\n}\n\n.mdi-account-details::before {\n  content: \"\\F0631\";\n}\n\n.mdi-account-details-outline::before {\n  content: \"\\F1372\";\n}\n\n.mdi-account-edit::before {\n  content: \"\\F06BC\";\n}\n\n.mdi-account-edit-outline::before {\n  content: \"\\F0FFB\";\n}\n\n.mdi-account-eye::before {\n  content: \"\\F0420\";\n}\n\n.mdi-account-eye-outline::before {\n  content: \"\\F127B\";\n}\n\n.mdi-account-filter::before {\n  content: \"\\F0936\";\n}\n\n.mdi-account-filter-outline::before {\n  content: \"\\F0F9D\";\n}\n\n.mdi-account-group::before {\n  content: \"\\F0849\";\n}\n\n.mdi-account-group-outline::before {\n  content: \"\\F0B58\";\n}\n\n.mdi-account-hard-hat::before {\n  content: \"\\F05B5\";\n}\n\n.mdi-account-heart::before {\n  content: \"\\F0899\";\n}\n\n.mdi-account-heart-outline::before {\n  content: \"\\F0BE3\";\n}\n\n.mdi-account-injury::before {\n  content: \"\\F1815\";\n}\n\n.mdi-account-injury-outline::before {\n  content: \"\\F1816\";\n}\n\n.mdi-account-key::before {\n  content: \"\\F000B\";\n}\n\n.mdi-account-key-outline::before {\n  content: \"\\F0BE4\";\n}\n\n.mdi-account-lock::before {\n  content: \"\\F115E\";\n}\n\n.mdi-account-lock-open::before {\n  content: \"\\F1960\";\n}\n\n.mdi-account-lock-open-outline::before {\n  content: \"\\F1961\";\n}\n\n.mdi-account-lock-outline::before {\n  content: \"\\F115F\";\n}\n\n.mdi-account-minus::before {\n  content: \"\\F000D\";\n}\n\n.mdi-account-minus-outline::before {\n  content: \"\\F0AEC\";\n}\n\n.mdi-account-multiple::before {\n  content: \"\\F000E\";\n}\n\n.mdi-account-multiple-check::before {\n  content: \"\\F08C5\";\n}\n\n.mdi-account-multiple-check-outline::before {\n  content: \"\\F11FE\";\n}\n\n.mdi-account-multiple-minus::before {\n  content: \"\\F05D3\";\n}\n\n.mdi-account-multiple-minus-outline::before {\n  content: \"\\F0BE5\";\n}\n\n.mdi-account-multiple-outline::before {\n  content: \"\\F000F\";\n}\n\n.mdi-account-multiple-plus::before {\n  content: \"\\F0010\";\n}\n\n.mdi-account-multiple-plus-outline::before {\n  content: \"\\F0800\";\n}\n\n.mdi-account-multiple-remove::before {\n  content: \"\\F120A\";\n}\n\n.mdi-account-multiple-remove-outline::before {\n  content: \"\\F120B\";\n}\n\n.mdi-account-music::before {\n  content: \"\\F0803\";\n}\n\n.mdi-account-music-outline::before {\n  content: \"\\F0CE9\";\n}\n\n.mdi-account-network::before {\n  content: \"\\F0011\";\n}\n\n.mdi-account-network-outline::before {\n  content: \"\\F0BE6\";\n}\n\n.mdi-account-off::before {\n  content: \"\\F0012\";\n}\n\n.mdi-account-off-outline::before {\n  content: \"\\F0BE7\";\n}\n\n.mdi-account-outline::before {\n  content: \"\\F0013\";\n}\n\n.mdi-account-plus::before {\n  content: \"\\F0014\";\n}\n\n.mdi-account-plus-outline::before {\n  content: \"\\F0801\";\n}\n\n.mdi-account-question::before {\n  content: \"\\F0B59\";\n}\n\n.mdi-account-question-outline::before {\n  content: \"\\F0B5A\";\n}\n\n.mdi-account-reactivate::before {\n  content: \"\\F152B\";\n}\n\n.mdi-account-reactivate-outline::before {\n  content: \"\\F152C\";\n}\n\n.mdi-account-remove::before {\n  content: \"\\F0015\";\n}\n\n.mdi-account-remove-outline::before {\n  content: \"\\F0AED\";\n}\n\n.mdi-account-search::before {\n  content: \"\\F0016\";\n}\n\n.mdi-account-search-outline::before {\n  content: \"\\F0935\";\n}\n\n.mdi-account-settings::before {\n  content: \"\\F0630\";\n}\n\n.mdi-account-settings-outline::before {\n  content: \"\\F10C9\";\n}\n\n.mdi-account-star::before {\n  content: \"\\F0017\";\n}\n\n.mdi-account-star-outline::before {\n  content: \"\\F0BE8\";\n}\n\n.mdi-account-supervisor::before {\n  content: \"\\F0A8B\";\n}\n\n.mdi-account-supervisor-circle::before {\n  content: \"\\F0A8C\";\n}\n\n.mdi-account-supervisor-circle-outline::before {\n  content: \"\\F14EC\";\n}\n\n.mdi-account-supervisor-outline::before {\n  content: \"\\F112D\";\n}\n\n.mdi-account-switch::before {\n  content: \"\\F0019\";\n}\n\n.mdi-account-switch-outline::before {\n  content: \"\\F04CB\";\n}\n\n.mdi-account-sync::before {\n  content: \"\\F191B\";\n}\n\n.mdi-account-sync-outline::before {\n  content: \"\\F191C\";\n}\n\n.mdi-account-tie::before {\n  content: \"\\F0CE3\";\n}\n\n.mdi-account-tie-hat::before {\n  content: \"\\F1898\";\n}\n\n.mdi-account-tie-hat-outline::before {\n  content: \"\\F1899\";\n}\n\n.mdi-account-tie-outline::before {\n  content: \"\\F10CA\";\n}\n\n.mdi-account-tie-voice::before {\n  content: \"\\F1308\";\n}\n\n.mdi-account-tie-voice-off::before {\n  content: \"\\F130A\";\n}\n\n.mdi-account-tie-voice-off-outline::before {\n  content: \"\\F130B\";\n}\n\n.mdi-account-tie-voice-outline::before {\n  content: \"\\F1309\";\n}\n\n.mdi-account-voice::before {\n  content: \"\\F05CB\";\n}\n\n.mdi-account-voice-off::before {\n  content: \"\\F0ED4\";\n}\n\n.mdi-account-wrench::before {\n  content: \"\\F189A\";\n}\n\n.mdi-account-wrench-outline::before {\n  content: \"\\F189B\";\n}\n\n.mdi-adjust::before {\n  content: \"\\F001A\";\n}\n\n.mdi-advertisements::before {\n  content: \"\\F192A\";\n}\n\n.mdi-advertisements-off::before {\n  content: \"\\F192B\";\n}\n\n.mdi-air-conditioner::before {\n  content: \"\\F001B\";\n}\n\n.mdi-air-filter::before {\n  content: \"\\F0D43\";\n}\n\n.mdi-air-horn::before {\n  content: \"\\F0DAC\";\n}\n\n.mdi-air-humidifier::before {\n  content: \"\\F1099\";\n}\n\n.mdi-air-humidifier-off::before {\n  content: \"\\F1466\";\n}\n\n.mdi-air-purifier::before {\n  content: \"\\F0D44\";\n}\n\n.mdi-airbag::before {\n  content: \"\\F0BE9\";\n}\n\n.mdi-airballoon::before {\n  content: \"\\F001C\";\n}\n\n.mdi-airballoon-outline::before {\n  content: \"\\F100B\";\n}\n\n.mdi-airplane::before {\n  content: \"\\F001D\";\n}\n\n.mdi-airplane-alert::before {\n  content: \"\\F187A\";\n}\n\n.mdi-airplane-check::before {\n  content: \"\\F187B\";\n}\n\n.mdi-airplane-clock::before {\n  content: \"\\F187C\";\n}\n\n.mdi-airplane-cog::before {\n  content: \"\\F187D\";\n}\n\n.mdi-airplane-edit::before {\n  content: \"\\F187E\";\n}\n\n.mdi-airplane-landing::before {\n  content: \"\\F05D4\";\n}\n\n.mdi-airplane-marker::before {\n  content: \"\\F187F\";\n}\n\n.mdi-airplane-minus::before {\n  content: \"\\F1880\";\n}\n\n.mdi-airplane-off::before {\n  content: \"\\F001E\";\n}\n\n.mdi-airplane-plus::before {\n  content: \"\\F1881\";\n}\n\n.mdi-airplane-remove::before {\n  content: \"\\F1882\";\n}\n\n.mdi-airplane-search::before {\n  content: \"\\F1883\";\n}\n\n.mdi-airplane-settings::before {\n  content: \"\\F1884\";\n}\n\n.mdi-airplane-takeoff::before {\n  content: \"\\F05D5\";\n}\n\n.mdi-airport::before {\n  content: \"\\F084B\";\n}\n\n.mdi-alarm::before {\n  content: \"\\F0020\";\n}\n\n.mdi-alarm-bell::before {\n  content: \"\\F078E\";\n}\n\n.mdi-alarm-check::before {\n  content: \"\\F0021\";\n}\n\n.mdi-alarm-light::before {\n  content: \"\\F078F\";\n}\n\n.mdi-alarm-light-off::before {\n  content: \"\\F171E\";\n}\n\n.mdi-alarm-light-off-outline::before {\n  content: \"\\F171F\";\n}\n\n.mdi-alarm-light-outline::before {\n  content: \"\\F0BEA\";\n}\n\n.mdi-alarm-multiple::before {\n  content: \"\\F0022\";\n}\n\n.mdi-alarm-note::before {\n  content: \"\\F0E71\";\n}\n\n.mdi-alarm-note-off::before {\n  content: \"\\F0E72\";\n}\n\n.mdi-alarm-off::before {\n  content: \"\\F0023\";\n}\n\n.mdi-alarm-panel::before {\n  content: \"\\F15C4\";\n}\n\n.mdi-alarm-panel-outline::before {\n  content: \"\\F15C5\";\n}\n\n.mdi-alarm-plus::before {\n  content: \"\\F0024\";\n}\n\n.mdi-alarm-snooze::before {\n  content: \"\\F068E\";\n}\n\n.mdi-album::before {\n  content: \"\\F0025\";\n}\n\n.mdi-alert::before {\n  content: \"\\F0026\";\n}\n\n.mdi-alert-box::before {\n  content: \"\\F0027\";\n}\n\n.mdi-alert-box-outline::before {\n  content: \"\\F0CE4\";\n}\n\n.mdi-alert-circle::before {\n  content: \"\\F0028\";\n}\n\n.mdi-alert-circle-check::before {\n  content: \"\\F11ED\";\n}\n\n.mdi-alert-circle-check-outline::before {\n  content: \"\\F11EE\";\n}\n\n.mdi-alert-circle-outline::before {\n  content: \"\\F05D6\";\n}\n\n.mdi-alert-decagram::before {\n  content: \"\\F06BD\";\n}\n\n.mdi-alert-decagram-outline::before {\n  content: \"\\F0CE5\";\n}\n\n.mdi-alert-minus::before {\n  content: \"\\F14BB\";\n}\n\n.mdi-alert-minus-outline::before {\n  content: \"\\F14BE\";\n}\n\n.mdi-alert-octagon::before {\n  content: \"\\F0029\";\n}\n\n.mdi-alert-octagon-outline::before {\n  content: \"\\F0CE6\";\n}\n\n.mdi-alert-octagram::before {\n  content: \"\\F0767\";\n}\n\n.mdi-alert-octagram-outline::before {\n  content: \"\\F0CE7\";\n}\n\n.mdi-alert-outline::before {\n  content: \"\\F002A\";\n}\n\n.mdi-alert-plus::before {\n  content: \"\\F14BA\";\n}\n\n.mdi-alert-plus-outline::before {\n  content: \"\\F14BD\";\n}\n\n.mdi-alert-remove::before {\n  content: \"\\F14BC\";\n}\n\n.mdi-alert-remove-outline::before {\n  content: \"\\F14BF\";\n}\n\n.mdi-alert-rhombus::before {\n  content: \"\\F11CE\";\n}\n\n.mdi-alert-rhombus-outline::before {\n  content: \"\\F11CF\";\n}\n\n.mdi-alien::before {\n  content: \"\\F089A\";\n}\n\n.mdi-alien-outline::before {\n  content: \"\\F10CB\";\n}\n\n.mdi-align-horizontal-center::before {\n  content: \"\\F11C3\";\n}\n\n.mdi-align-horizontal-distribute::before {\n  content: \"\\F1962\";\n}\n\n.mdi-align-horizontal-left::before {\n  content: \"\\F11C2\";\n}\n\n.mdi-align-horizontal-right::before {\n  content: \"\\F11C4\";\n}\n\n.mdi-align-vertical-bottom::before {\n  content: \"\\F11C5\";\n}\n\n.mdi-align-vertical-center::before {\n  content: \"\\F11C6\";\n}\n\n.mdi-align-vertical-distribute::before {\n  content: \"\\F1963\";\n}\n\n.mdi-align-vertical-top::before {\n  content: \"\\F11C7\";\n}\n\n.mdi-all-inclusive::before {\n  content: \"\\F06BE\";\n}\n\n.mdi-all-inclusive-box::before {\n  content: \"\\F188D\";\n}\n\n.mdi-all-inclusive-box-outline::before {\n  content: \"\\F188E\";\n}\n\n.mdi-allergy::before {\n  content: \"\\F1258\";\n}\n\n.mdi-alpha::before {\n  content: \"\\F002B\";\n}\n\n.mdi-alpha-a::before {\n  content: \"\\F0AEE\";\n}\n\n.mdi-alpha-a-box::before {\n  content: \"\\F0B08\";\n}\n\n.mdi-alpha-a-box-outline::before {\n  content: \"\\F0BEB\";\n}\n\n.mdi-alpha-a-circle::before {\n  content: \"\\F0BEC\";\n}\n\n.mdi-alpha-a-circle-outline::before {\n  content: \"\\F0BED\";\n}\n\n.mdi-alpha-b::before {\n  content: \"\\F0AEF\";\n}\n\n.mdi-alpha-b-box::before {\n  content: \"\\F0B09\";\n}\n\n.mdi-alpha-b-box-outline::before {\n  content: \"\\F0BEE\";\n}\n\n.mdi-alpha-b-circle::before {\n  content: \"\\F0BEF\";\n}\n\n.mdi-alpha-b-circle-outline::before {\n  content: \"\\F0BF0\";\n}\n\n.mdi-alpha-c::before {\n  content: \"\\F0AF0\";\n}\n\n.mdi-alpha-c-box::before {\n  content: \"\\F0B0A\";\n}\n\n.mdi-alpha-c-box-outline::before {\n  content: \"\\F0BF1\";\n}\n\n.mdi-alpha-c-circle::before {\n  content: \"\\F0BF2\";\n}\n\n.mdi-alpha-c-circle-outline::before {\n  content: \"\\F0BF3\";\n}\n\n.mdi-alpha-d::before {\n  content: \"\\F0AF1\";\n}\n\n.mdi-alpha-d-box::before {\n  content: \"\\F0B0B\";\n}\n\n.mdi-alpha-d-box-outline::before {\n  content: \"\\F0BF4\";\n}\n\n.mdi-alpha-d-circle::before {\n  content: \"\\F0BF5\";\n}\n\n.mdi-alpha-d-circle-outline::before {\n  content: \"\\F0BF6\";\n}\n\n.mdi-alpha-e::before {\n  content: \"\\F0AF2\";\n}\n\n.mdi-alpha-e-box::before {\n  content: \"\\F0B0C\";\n}\n\n.mdi-alpha-e-box-outline::before {\n  content: \"\\F0BF7\";\n}\n\n.mdi-alpha-e-circle::before {\n  content: \"\\F0BF8\";\n}\n\n.mdi-alpha-e-circle-outline::before {\n  content: \"\\F0BF9\";\n}\n\n.mdi-alpha-f::before {\n  content: \"\\F0AF3\";\n}\n\n.mdi-alpha-f-box::before {\n  content: \"\\F0B0D\";\n}\n\n.mdi-alpha-f-box-outline::before {\n  content: \"\\F0BFA\";\n}\n\n.mdi-alpha-f-circle::before {\n  content: \"\\F0BFB\";\n}\n\n.mdi-alpha-f-circle-outline::before {\n  content: \"\\F0BFC\";\n}\n\n.mdi-alpha-g::before {\n  content: \"\\F0AF4\";\n}\n\n.mdi-alpha-g-box::before {\n  content: \"\\F0B0E\";\n}\n\n.mdi-alpha-g-box-outline::before {\n  content: \"\\F0BFD\";\n}\n\n.mdi-alpha-g-circle::before {\n  content: \"\\F0BFE\";\n}\n\n.mdi-alpha-g-circle-outline::before {\n  content: \"\\F0BFF\";\n}\n\n.mdi-alpha-h::before {\n  content: \"\\F0AF5\";\n}\n\n.mdi-alpha-h-box::before {\n  content: \"\\F0B0F\";\n}\n\n.mdi-alpha-h-box-outline::before {\n  content: \"\\F0C00\";\n}\n\n.mdi-alpha-h-circle::before {\n  content: \"\\F0C01\";\n}\n\n.mdi-alpha-h-circle-outline::before {\n  content: \"\\F0C02\";\n}\n\n.mdi-alpha-i::before {\n  content: \"\\F0AF6\";\n}\n\n.mdi-alpha-i-box::before {\n  content: \"\\F0B10\";\n}\n\n.mdi-alpha-i-box-outline::before {\n  content: \"\\F0C03\";\n}\n\n.mdi-alpha-i-circle::before {\n  content: \"\\F0C04\";\n}\n\n.mdi-alpha-i-circle-outline::before {\n  content: \"\\F0C05\";\n}\n\n.mdi-alpha-j::before {\n  content: \"\\F0AF7\";\n}\n\n.mdi-alpha-j-box::before {\n  content: \"\\F0B11\";\n}\n\n.mdi-alpha-j-box-outline::before {\n  content: \"\\F0C06\";\n}\n\n.mdi-alpha-j-circle::before {\n  content: \"\\F0C07\";\n}\n\n.mdi-alpha-j-circle-outline::before {\n  content: \"\\F0C08\";\n}\n\n.mdi-alpha-k::before {\n  content: \"\\F0AF8\";\n}\n\n.mdi-alpha-k-box::before {\n  content: \"\\F0B12\";\n}\n\n.mdi-alpha-k-box-outline::before {\n  content: \"\\F0C09\";\n}\n\n.mdi-alpha-k-circle::before {\n  content: \"\\F0C0A\";\n}\n\n.mdi-alpha-k-circle-outline::before {\n  content: \"\\F0C0B\";\n}\n\n.mdi-alpha-l::before {\n  content: \"\\F0AF9\";\n}\n\n.mdi-alpha-l-box::before {\n  content: \"\\F0B13\";\n}\n\n.mdi-alpha-l-box-outline::before {\n  content: \"\\F0C0C\";\n}\n\n.mdi-alpha-l-circle::before {\n  content: \"\\F0C0D\";\n}\n\n.mdi-alpha-l-circle-outline::before {\n  content: \"\\F0C0E\";\n}\n\n.mdi-alpha-m::before {\n  content: \"\\F0AFA\";\n}\n\n.mdi-alpha-m-box::before {\n  content: \"\\F0B14\";\n}\n\n.mdi-alpha-m-box-outline::before {\n  content: \"\\F0C0F\";\n}\n\n.mdi-alpha-m-circle::before {\n  content: \"\\F0C10\";\n}\n\n.mdi-alpha-m-circle-outline::before {\n  content: \"\\F0C11\";\n}\n\n.mdi-alpha-n::before {\n  content: \"\\F0AFB\";\n}\n\n.mdi-alpha-n-box::before {\n  content: \"\\F0B15\";\n}\n\n.mdi-alpha-n-box-outline::before {\n  content: \"\\F0C12\";\n}\n\n.mdi-alpha-n-circle::before {\n  content: \"\\F0C13\";\n}\n\n.mdi-alpha-n-circle-outline::before {\n  content: \"\\F0C14\";\n}\n\n.mdi-alpha-o::before {\n  content: \"\\F0AFC\";\n}\n\n.mdi-alpha-o-box::before {\n  content: \"\\F0B16\";\n}\n\n.mdi-alpha-o-box-outline::before {\n  content: \"\\F0C15\";\n}\n\n.mdi-alpha-o-circle::before {\n  content: \"\\F0C16\";\n}\n\n.mdi-alpha-o-circle-outline::before {\n  content: \"\\F0C17\";\n}\n\n.mdi-alpha-p::before {\n  content: \"\\F0AFD\";\n}\n\n.mdi-alpha-p-box::before {\n  content: \"\\F0B17\";\n}\n\n.mdi-alpha-p-box-outline::before {\n  content: \"\\F0C18\";\n}\n\n.mdi-alpha-p-circle::before {\n  content: \"\\F0C19\";\n}\n\n.mdi-alpha-p-circle-outline::before {\n  content: \"\\F0C1A\";\n}\n\n.mdi-alpha-q::before {\n  content: \"\\F0AFE\";\n}\n\n.mdi-alpha-q-box::before {\n  content: \"\\F0B18\";\n}\n\n.mdi-alpha-q-box-outline::before {\n  content: \"\\F0C1B\";\n}\n\n.mdi-alpha-q-circle::before {\n  content: \"\\F0C1C\";\n}\n\n.mdi-alpha-q-circle-outline::before {\n  content: \"\\F0C1D\";\n}\n\n.mdi-alpha-r::before {\n  content: \"\\F0AFF\";\n}\n\n.mdi-alpha-r-box::before {\n  content: \"\\F0B19\";\n}\n\n.mdi-alpha-r-box-outline::before {\n  content: \"\\F0C1E\";\n}\n\n.mdi-alpha-r-circle::before {\n  content: \"\\F0C1F\";\n}\n\n.mdi-alpha-r-circle-outline::before {\n  content: \"\\F0C20\";\n}\n\n.mdi-alpha-s::before {\n  content: \"\\F0B00\";\n}\n\n.mdi-alpha-s-box::before {\n  content: \"\\F0B1A\";\n}\n\n.mdi-alpha-s-box-outline::before {\n  content: \"\\F0C21\";\n}\n\n.mdi-alpha-s-circle::before {\n  content: \"\\F0C22\";\n}\n\n.mdi-alpha-s-circle-outline::before {\n  content: \"\\F0C23\";\n}\n\n.mdi-alpha-t::before {\n  content: \"\\F0B01\";\n}\n\n.mdi-alpha-t-box::before {\n  content: \"\\F0B1B\";\n}\n\n.mdi-alpha-t-box-outline::before {\n  content: \"\\F0C24\";\n}\n\n.mdi-alpha-t-circle::before {\n  content: \"\\F0C25\";\n}\n\n.mdi-alpha-t-circle-outline::before {\n  content: \"\\F0C26\";\n}\n\n.mdi-alpha-u::before {\n  content: \"\\F0B02\";\n}\n\n.mdi-alpha-u-box::before {\n  content: \"\\F0B1C\";\n}\n\n.mdi-alpha-u-box-outline::before {\n  content: \"\\F0C27\";\n}\n\n.mdi-alpha-u-circle::before {\n  content: \"\\F0C28\";\n}\n\n.mdi-alpha-u-circle-outline::before {\n  content: \"\\F0C29\";\n}\n\n.mdi-alpha-v::before {\n  content: \"\\F0B03\";\n}\n\n.mdi-alpha-v-box::before {\n  content: \"\\F0B1D\";\n}\n\n.mdi-alpha-v-box-outline::before {\n  content: \"\\F0C2A\";\n}\n\n.mdi-alpha-v-circle::before {\n  content: \"\\F0C2B\";\n}\n\n.mdi-alpha-v-circle-outline::before {\n  content: \"\\F0C2C\";\n}\n\n.mdi-alpha-w::before {\n  content: \"\\F0B04\";\n}\n\n.mdi-alpha-w-box::before {\n  content: \"\\F0B1E\";\n}\n\n.mdi-alpha-w-box-outline::before {\n  content: \"\\F0C2D\";\n}\n\n.mdi-alpha-w-circle::before {\n  content: \"\\F0C2E\";\n}\n\n.mdi-alpha-w-circle-outline::before {\n  content: \"\\F0C2F\";\n}\n\n.mdi-alpha-x::before {\n  content: \"\\F0B05\";\n}\n\n.mdi-alpha-x-box::before {\n  content: \"\\F0B1F\";\n}\n\n.mdi-alpha-x-box-outline::before {\n  content: \"\\F0C30\";\n}\n\n.mdi-alpha-x-circle::before {\n  content: \"\\F0C31\";\n}\n\n.mdi-alpha-x-circle-outline::before {\n  content: \"\\F0C32\";\n}\n\n.mdi-alpha-y::before {\n  content: \"\\F0B06\";\n}\n\n.mdi-alpha-y-box::before {\n  content: \"\\F0B20\";\n}\n\n.mdi-alpha-y-box-outline::before {\n  content: \"\\F0C33\";\n}\n\n.mdi-alpha-y-circle::before {\n  content: \"\\F0C34\";\n}\n\n.mdi-alpha-y-circle-outline::before {\n  content: \"\\F0C35\";\n}\n\n.mdi-alpha-z::before {\n  content: \"\\F0B07\";\n}\n\n.mdi-alpha-z-box::before {\n  content: \"\\F0B21\";\n}\n\n.mdi-alpha-z-box-outline::before {\n  content: \"\\F0C36\";\n}\n\n.mdi-alpha-z-circle::before {\n  content: \"\\F0C37\";\n}\n\n.mdi-alpha-z-circle-outline::before {\n  content: \"\\F0C38\";\n}\n\n.mdi-alphabet-aurebesh::before {\n  content: \"\\F132C\";\n}\n\n.mdi-alphabet-cyrillic::before {\n  content: \"\\F132D\";\n}\n\n.mdi-alphabet-greek::before {\n  content: \"\\F132E\";\n}\n\n.mdi-alphabet-latin::before {\n  content: \"\\F132F\";\n}\n\n.mdi-alphabet-piqad::before {\n  content: \"\\F1330\";\n}\n\n.mdi-alphabet-tengwar::before {\n  content: \"\\F1337\";\n}\n\n.mdi-alphabetical::before {\n  content: \"\\F002C\";\n}\n\n.mdi-alphabetical-off::before {\n  content: \"\\F100C\";\n}\n\n.mdi-alphabetical-variant::before {\n  content: \"\\F100D\";\n}\n\n.mdi-alphabetical-variant-off::before {\n  content: \"\\F100E\";\n}\n\n.mdi-altimeter::before {\n  content: \"\\F05D7\";\n}\n\n.mdi-ambulance::before {\n  content: \"\\F002F\";\n}\n\n.mdi-ammunition::before {\n  content: \"\\F0CE8\";\n}\n\n.mdi-ampersand::before {\n  content: \"\\F0A8D\";\n}\n\n.mdi-amplifier::before {\n  content: \"\\F0030\";\n}\n\n.mdi-amplifier-off::before {\n  content: \"\\F11B5\";\n}\n\n.mdi-anchor::before {\n  content: \"\\F0031\";\n}\n\n.mdi-android::before {\n  content: \"\\F0032\";\n}\n\n.mdi-android-messages::before {\n  content: \"\\F0D45\";\n}\n\n.mdi-android-studio::before {\n  content: \"\\F0034\";\n}\n\n.mdi-angle-acute::before {\n  content: \"\\F0937\";\n}\n\n.mdi-angle-obtuse::before {\n  content: \"\\F0938\";\n}\n\n.mdi-angle-right::before {\n  content: \"\\F0939\";\n}\n\n.mdi-angular::before {\n  content: \"\\F06B2\";\n}\n\n.mdi-angularjs::before {\n  content: \"\\F06BF\";\n}\n\n.mdi-animation::before {\n  content: \"\\F05D8\";\n}\n\n.mdi-animation-outline::before {\n  content: \"\\F0A8F\";\n}\n\n.mdi-animation-play::before {\n  content: \"\\F093A\";\n}\n\n.mdi-animation-play-outline::before {\n  content: \"\\F0A90\";\n}\n\n.mdi-ansible::before {\n  content: \"\\F109A\";\n}\n\n.mdi-antenna::before {\n  content: \"\\F1119\";\n}\n\n.mdi-anvil::before {\n  content: \"\\F089B\";\n}\n\n.mdi-apache-kafka::before {\n  content: \"\\F100F\";\n}\n\n.mdi-api::before {\n  content: \"\\F109B\";\n}\n\n.mdi-api-off::before {\n  content: \"\\F1257\";\n}\n\n.mdi-apple::before {\n  content: \"\\F0035\";\n}\n\n.mdi-apple-finder::before {\n  content: \"\\F0036\";\n}\n\n.mdi-apple-icloud::before {\n  content: \"\\F0038\";\n}\n\n.mdi-apple-ios::before {\n  content: \"\\F0037\";\n}\n\n.mdi-apple-keyboard-caps::before {\n  content: \"\\F0632\";\n}\n\n.mdi-apple-keyboard-command::before {\n  content: \"\\F0633\";\n}\n\n.mdi-apple-keyboard-control::before {\n  content: \"\\F0634\";\n}\n\n.mdi-apple-keyboard-option::before {\n  content: \"\\F0635\";\n}\n\n.mdi-apple-keyboard-shift::before {\n  content: \"\\F0636\";\n}\n\n.mdi-apple-safari::before {\n  content: \"\\F0039\";\n}\n\n.mdi-application::before {\n  content: \"\\F08C6\";\n}\n\n.mdi-application-array::before {\n  content: \"\\F10F5\";\n}\n\n.mdi-application-array-outline::before {\n  content: \"\\F10F6\";\n}\n\n.mdi-application-braces::before {\n  content: \"\\F10F7\";\n}\n\n.mdi-application-braces-outline::before {\n  content: \"\\F10F8\";\n}\n\n.mdi-application-brackets::before {\n  content: \"\\F0C8B\";\n}\n\n.mdi-application-brackets-outline::before {\n  content: \"\\F0C8C\";\n}\n\n.mdi-application-cog::before {\n  content: \"\\F0675\";\n}\n\n.mdi-application-cog-outline::before {\n  content: \"\\F1577\";\n}\n\n.mdi-application-edit::before {\n  content: \"\\F00AE\";\n}\n\n.mdi-application-edit-outline::before {\n  content: \"\\F0619\";\n}\n\n.mdi-application-export::before {\n  content: \"\\F0DAD\";\n}\n\n.mdi-application-import::before {\n  content: \"\\F0DAE\";\n}\n\n.mdi-application-outline::before {\n  content: \"\\F0614\";\n}\n\n.mdi-application-parentheses::before {\n  content: \"\\F10F9\";\n}\n\n.mdi-application-parentheses-outline::before {\n  content: \"\\F10FA\";\n}\n\n.mdi-application-settings::before {\n  content: \"\\F0B60\";\n}\n\n.mdi-application-settings-outline::before {\n  content: \"\\F1555\";\n}\n\n.mdi-application-variable::before {\n  content: \"\\F10FB\";\n}\n\n.mdi-application-variable-outline::before {\n  content: \"\\F10FC\";\n}\n\n.mdi-approximately-equal::before {\n  content: \"\\F0F9E\";\n}\n\n.mdi-approximately-equal-box::before {\n  content: \"\\F0F9F\";\n}\n\n.mdi-apps::before {\n  content: \"\\F003B\";\n}\n\n.mdi-apps-box::before {\n  content: \"\\F0D46\";\n}\n\n.mdi-arch::before {\n  content: \"\\F08C7\";\n}\n\n.mdi-archive::before {\n  content: \"\\F003C\";\n}\n\n.mdi-archive-alert::before {\n  content: \"\\F14FD\";\n}\n\n.mdi-archive-alert-outline::before {\n  content: \"\\F14FE\";\n}\n\n.mdi-archive-arrow-down::before {\n  content: \"\\F1259\";\n}\n\n.mdi-archive-arrow-down-outline::before {\n  content: \"\\F125A\";\n}\n\n.mdi-archive-arrow-up::before {\n  content: \"\\F125B\";\n}\n\n.mdi-archive-arrow-up-outline::before {\n  content: \"\\F125C\";\n}\n\n.mdi-archive-cancel::before {\n  content: \"\\F174B\";\n}\n\n.mdi-archive-cancel-outline::before {\n  content: \"\\F174C\";\n}\n\n.mdi-archive-check::before {\n  content: \"\\F174D\";\n}\n\n.mdi-archive-check-outline::before {\n  content: \"\\F174E\";\n}\n\n.mdi-archive-clock::before {\n  content: \"\\F174F\";\n}\n\n.mdi-archive-clock-outline::before {\n  content: \"\\F1750\";\n}\n\n.mdi-archive-cog::before {\n  content: \"\\F1751\";\n}\n\n.mdi-archive-cog-outline::before {\n  content: \"\\F1752\";\n}\n\n.mdi-archive-edit::before {\n  content: \"\\F1753\";\n}\n\n.mdi-archive-edit-outline::before {\n  content: \"\\F1754\";\n}\n\n.mdi-archive-eye::before {\n  content: \"\\F1755\";\n}\n\n.mdi-archive-eye-outline::before {\n  content: \"\\F1756\";\n}\n\n.mdi-archive-lock::before {\n  content: \"\\F1757\";\n}\n\n.mdi-archive-lock-open::before {\n  content: \"\\F1758\";\n}\n\n.mdi-archive-lock-open-outline::before {\n  content: \"\\F1759\";\n}\n\n.mdi-archive-lock-outline::before {\n  content: \"\\F175A\";\n}\n\n.mdi-archive-marker::before {\n  content: \"\\F175B\";\n}\n\n.mdi-archive-marker-outline::before {\n  content: \"\\F175C\";\n}\n\n.mdi-archive-minus::before {\n  content: \"\\F175D\";\n}\n\n.mdi-archive-minus-outline::before {\n  content: \"\\F175E\";\n}\n\n.mdi-archive-music::before {\n  content: \"\\F175F\";\n}\n\n.mdi-archive-music-outline::before {\n  content: \"\\F1760\";\n}\n\n.mdi-archive-off::before {\n  content: \"\\F1761\";\n}\n\n.mdi-archive-off-outline::before {\n  content: \"\\F1762\";\n}\n\n.mdi-archive-outline::before {\n  content: \"\\F120E\";\n}\n\n.mdi-archive-plus::before {\n  content: \"\\F1763\";\n}\n\n.mdi-archive-plus-outline::before {\n  content: \"\\F1764\";\n}\n\n.mdi-archive-refresh::before {\n  content: \"\\F1765\";\n}\n\n.mdi-archive-refresh-outline::before {\n  content: \"\\F1766\";\n}\n\n.mdi-archive-remove::before {\n  content: \"\\F1767\";\n}\n\n.mdi-archive-remove-outline::before {\n  content: \"\\F1768\";\n}\n\n.mdi-archive-search::before {\n  content: \"\\F1769\";\n}\n\n.mdi-archive-search-outline::before {\n  content: \"\\F176A\";\n}\n\n.mdi-archive-settings::before {\n  content: \"\\F176B\";\n}\n\n.mdi-archive-settings-outline::before {\n  content: \"\\F176C\";\n}\n\n.mdi-archive-star::before {\n  content: \"\\F176D\";\n}\n\n.mdi-archive-star-outline::before {\n  content: \"\\F176E\";\n}\n\n.mdi-archive-sync::before {\n  content: \"\\F176F\";\n}\n\n.mdi-archive-sync-outline::before {\n  content: \"\\F1770\";\n}\n\n.mdi-arm-flex::before {\n  content: \"\\F0FD7\";\n}\n\n.mdi-arm-flex-outline::before {\n  content: \"\\F0FD6\";\n}\n\n.mdi-arrange-bring-forward::before {\n  content: \"\\F003D\";\n}\n\n.mdi-arrange-bring-to-front::before {\n  content: \"\\F003E\";\n}\n\n.mdi-arrange-send-backward::before {\n  content: \"\\F003F\";\n}\n\n.mdi-arrange-send-to-back::before {\n  content: \"\\F0040\";\n}\n\n.mdi-arrow-all::before {\n  content: \"\\F0041\";\n}\n\n.mdi-arrow-bottom-left::before {\n  content: \"\\F0042\";\n}\n\n.mdi-arrow-bottom-left-bold-box::before {\n  content: \"\\F1964\";\n}\n\n.mdi-arrow-bottom-left-bold-box-outline::before {\n  content: \"\\F1965\";\n}\n\n.mdi-arrow-bottom-left-bold-outline::before {\n  content: \"\\F09B7\";\n}\n\n.mdi-arrow-bottom-left-thick::before {\n  content: \"\\F09B8\";\n}\n\n.mdi-arrow-bottom-left-thin::before {\n  content: \"\\F19B6\";\n}\n\n.mdi-arrow-bottom-left-thin-circle-outline::before {\n  content: \"\\F1596\";\n}\n\n.mdi-arrow-bottom-right::before {\n  content: \"\\F0043\";\n}\n\n.mdi-arrow-bottom-right-bold-box::before {\n  content: \"\\F1966\";\n}\n\n.mdi-arrow-bottom-right-bold-box-outline::before {\n  content: \"\\F1967\";\n}\n\n.mdi-arrow-bottom-right-bold-outline::before {\n  content: \"\\F09B9\";\n}\n\n.mdi-arrow-bottom-right-thick::before {\n  content: \"\\F09BA\";\n}\n\n.mdi-arrow-bottom-right-thin::before {\n  content: \"\\F19B7\";\n}\n\n.mdi-arrow-bottom-right-thin-circle-outline::before {\n  content: \"\\F1595\";\n}\n\n.mdi-arrow-collapse::before {\n  content: \"\\F0615\";\n}\n\n.mdi-arrow-collapse-all::before {\n  content: \"\\F0044\";\n}\n\n.mdi-arrow-collapse-down::before {\n  content: \"\\F0792\";\n}\n\n.mdi-arrow-collapse-horizontal::before {\n  content: \"\\F084C\";\n}\n\n.mdi-arrow-collapse-left::before {\n  content: \"\\F0793\";\n}\n\n.mdi-arrow-collapse-right::before {\n  content: \"\\F0794\";\n}\n\n.mdi-arrow-collapse-up::before {\n  content: \"\\F0795\";\n}\n\n.mdi-arrow-collapse-vertical::before {\n  content: \"\\F084D\";\n}\n\n.mdi-arrow-decision::before {\n  content: \"\\F09BB\";\n}\n\n.mdi-arrow-decision-auto::before {\n  content: \"\\F09BC\";\n}\n\n.mdi-arrow-decision-auto-outline::before {\n  content: \"\\F09BD\";\n}\n\n.mdi-arrow-decision-outline::before {\n  content: \"\\F09BE\";\n}\n\n.mdi-arrow-down::before {\n  content: \"\\F0045\";\n}\n\n.mdi-arrow-down-bold::before {\n  content: \"\\F072E\";\n}\n\n.mdi-arrow-down-bold-box::before {\n  content: \"\\F072F\";\n}\n\n.mdi-arrow-down-bold-box-outline::before {\n  content: \"\\F0730\";\n}\n\n.mdi-arrow-down-bold-circle::before {\n  content: \"\\F0047\";\n}\n\n.mdi-arrow-down-bold-circle-outline::before {\n  content: \"\\F0048\";\n}\n\n.mdi-arrow-down-bold-hexagon-outline::before {\n  content: \"\\F0049\";\n}\n\n.mdi-arrow-down-bold-outline::before {\n  content: \"\\F09BF\";\n}\n\n.mdi-arrow-down-box::before {\n  content: \"\\F06C0\";\n}\n\n.mdi-arrow-down-circle::before {\n  content: \"\\F0CDB\";\n}\n\n.mdi-arrow-down-circle-outline::before {\n  content: \"\\F0CDC\";\n}\n\n.mdi-arrow-down-drop-circle::before {\n  content: \"\\F004A\";\n}\n\n.mdi-arrow-down-drop-circle-outline::before {\n  content: \"\\F004B\";\n}\n\n.mdi-arrow-down-left::before {\n  content: \"\\F17A1\";\n}\n\n.mdi-arrow-down-left-bold::before {\n  content: \"\\F17A2\";\n}\n\n.mdi-arrow-down-right::before {\n  content: \"\\F17A3\";\n}\n\n.mdi-arrow-down-right-bold::before {\n  content: \"\\F17A4\";\n}\n\n.mdi-arrow-down-thick::before {\n  content: \"\\F0046\";\n}\n\n.mdi-arrow-down-thin::before {\n  content: \"\\F19B3\";\n}\n\n.mdi-arrow-down-thin-circle-outline::before {\n  content: \"\\F1599\";\n}\n\n.mdi-arrow-expand::before {\n  content: \"\\F0616\";\n}\n\n.mdi-arrow-expand-all::before {\n  content: \"\\F004C\";\n}\n\n.mdi-arrow-expand-down::before {\n  content: \"\\F0796\";\n}\n\n.mdi-arrow-expand-horizontal::before {\n  content: \"\\F084E\";\n}\n\n.mdi-arrow-expand-left::before {\n  content: \"\\F0797\";\n}\n\n.mdi-arrow-expand-right::before {\n  content: \"\\F0798\";\n}\n\n.mdi-arrow-expand-up::before {\n  content: \"\\F0799\";\n}\n\n.mdi-arrow-expand-vertical::before {\n  content: \"\\F084F\";\n}\n\n.mdi-arrow-horizontal-lock::before {\n  content: \"\\F115B\";\n}\n\n.mdi-arrow-left::before {\n  content: \"\\F004D\";\n}\n\n.mdi-arrow-left-bold::before {\n  content: \"\\F0731\";\n}\n\n.mdi-arrow-left-bold-box::before {\n  content: \"\\F0732\";\n}\n\n.mdi-arrow-left-bold-box-outline::before {\n  content: \"\\F0733\";\n}\n\n.mdi-arrow-left-bold-circle::before {\n  content: \"\\F004F\";\n}\n\n.mdi-arrow-left-bold-circle-outline::before {\n  content: \"\\F0050\";\n}\n\n.mdi-arrow-left-bold-hexagon-outline::before {\n  content: \"\\F0051\";\n}\n\n.mdi-arrow-left-bold-outline::before {\n  content: \"\\F09C0\";\n}\n\n.mdi-arrow-left-bottom::before {\n  content: \"\\F17A5\";\n}\n\n.mdi-arrow-left-bottom-bold::before {\n  content: \"\\F17A6\";\n}\n\n.mdi-arrow-left-box::before {\n  content: \"\\F06C1\";\n}\n\n.mdi-arrow-left-circle::before {\n  content: \"\\F0CDD\";\n}\n\n.mdi-arrow-left-circle-outline::before {\n  content: \"\\F0CDE\";\n}\n\n.mdi-arrow-left-drop-circle::before {\n  content: \"\\F0052\";\n}\n\n.mdi-arrow-left-drop-circle-outline::before {\n  content: \"\\F0053\";\n}\n\n.mdi-arrow-left-right::before {\n  content: \"\\F0E73\";\n}\n\n.mdi-arrow-left-right-bold::before {\n  content: \"\\F0E74\";\n}\n\n.mdi-arrow-left-right-bold-outline::before {\n  content: \"\\F09C1\";\n}\n\n.mdi-arrow-left-thick::before {\n  content: \"\\F004E\";\n}\n\n.mdi-arrow-left-thin::before {\n  content: \"\\F19B1\";\n}\n\n.mdi-arrow-left-thin-circle-outline::before {\n  content: \"\\F159A\";\n}\n\n.mdi-arrow-left-top::before {\n  content: \"\\F17A7\";\n}\n\n.mdi-arrow-left-top-bold::before {\n  content: \"\\F17A8\";\n}\n\n.mdi-arrow-projectile::before {\n  content: \"\\F1840\";\n}\n\n.mdi-arrow-projectile-multiple::before {\n  content: \"\\F183F\";\n}\n\n.mdi-arrow-right::before {\n  content: \"\\F0054\";\n}\n\n.mdi-arrow-right-bold::before {\n  content: \"\\F0734\";\n}\n\n.mdi-arrow-right-bold-box::before {\n  content: \"\\F0735\";\n}\n\n.mdi-arrow-right-bold-box-outline::before {\n  content: \"\\F0736\";\n}\n\n.mdi-arrow-right-bold-circle::before {\n  content: \"\\F0056\";\n}\n\n.mdi-arrow-right-bold-circle-outline::before {\n  content: \"\\F0057\";\n}\n\n.mdi-arrow-right-bold-hexagon-outline::before {\n  content: \"\\F0058\";\n}\n\n.mdi-arrow-right-bold-outline::before {\n  content: \"\\F09C2\";\n}\n\n.mdi-arrow-right-bottom::before {\n  content: \"\\F17A9\";\n}\n\n.mdi-arrow-right-bottom-bold::before {\n  content: \"\\F17AA\";\n}\n\n.mdi-arrow-right-box::before {\n  content: \"\\F06C2\";\n}\n\n.mdi-arrow-right-circle::before {\n  content: \"\\F0CDF\";\n}\n\n.mdi-arrow-right-circle-outline::before {\n  content: \"\\F0CE0\";\n}\n\n.mdi-arrow-right-drop-circle::before {\n  content: \"\\F0059\";\n}\n\n.mdi-arrow-right-drop-circle-outline::before {\n  content: \"\\F005A\";\n}\n\n.mdi-arrow-right-thick::before {\n  content: \"\\F0055\";\n}\n\n.mdi-arrow-right-thin::before {\n  content: \"\\F19B0\";\n}\n\n.mdi-arrow-right-thin-circle-outline::before {\n  content: \"\\F1598\";\n}\n\n.mdi-arrow-right-top::before {\n  content: \"\\F17AB\";\n}\n\n.mdi-arrow-right-top-bold::before {\n  content: \"\\F17AC\";\n}\n\n.mdi-arrow-split-horizontal::before {\n  content: \"\\F093B\";\n}\n\n.mdi-arrow-split-vertical::before {\n  content: \"\\F093C\";\n}\n\n.mdi-arrow-top-left::before {\n  content: \"\\F005B\";\n}\n\n.mdi-arrow-top-left-bold-box::before {\n  content: \"\\F1968\";\n}\n\n.mdi-arrow-top-left-bold-box-outline::before {\n  content: \"\\F1969\";\n}\n\n.mdi-arrow-top-left-bold-outline::before {\n  content: \"\\F09C3\";\n}\n\n.mdi-arrow-top-left-bottom-right::before {\n  content: \"\\F0E75\";\n}\n\n.mdi-arrow-top-left-bottom-right-bold::before {\n  content: \"\\F0E76\";\n}\n\n.mdi-arrow-top-left-thick::before {\n  content: \"\\F09C4\";\n}\n\n.mdi-arrow-top-left-thin::before {\n  content: \"\\F19B5\";\n}\n\n.mdi-arrow-top-left-thin-circle-outline::before {\n  content: \"\\F1593\";\n}\n\n.mdi-arrow-top-right::before {\n  content: \"\\F005C\";\n}\n\n.mdi-arrow-top-right-bold-box::before {\n  content: \"\\F196A\";\n}\n\n.mdi-arrow-top-right-bold-box-outline::before {\n  content: \"\\F196B\";\n}\n\n.mdi-arrow-top-right-bold-outline::before {\n  content: \"\\F09C5\";\n}\n\n.mdi-arrow-top-right-bottom-left::before {\n  content: \"\\F0E77\";\n}\n\n.mdi-arrow-top-right-bottom-left-bold::before {\n  content: \"\\F0E78\";\n}\n\n.mdi-arrow-top-right-thick::before {\n  content: \"\\F09C6\";\n}\n\n.mdi-arrow-top-right-thin::before {\n  content: \"\\F19B4\";\n}\n\n.mdi-arrow-top-right-thin-circle-outline::before {\n  content: \"\\F1594\";\n}\n\n.mdi-arrow-u-down-left::before {\n  content: \"\\F17AD\";\n}\n\n.mdi-arrow-u-down-left-bold::before {\n  content: \"\\F17AE\";\n}\n\n.mdi-arrow-u-down-right::before {\n  content: \"\\F17AF\";\n}\n\n.mdi-arrow-u-down-right-bold::before {\n  content: \"\\F17B0\";\n}\n\n.mdi-arrow-u-left-bottom::before {\n  content: \"\\F17B1\";\n}\n\n.mdi-arrow-u-left-bottom-bold::before {\n  content: \"\\F17B2\";\n}\n\n.mdi-arrow-u-left-top::before {\n  content: \"\\F17B3\";\n}\n\n.mdi-arrow-u-left-top-bold::before {\n  content: \"\\F17B4\";\n}\n\n.mdi-arrow-u-right-bottom::before {\n  content: \"\\F17B5\";\n}\n\n.mdi-arrow-u-right-bottom-bold::before {\n  content: \"\\F17B6\";\n}\n\n.mdi-arrow-u-right-top::before {\n  content: \"\\F17B7\";\n}\n\n.mdi-arrow-u-right-top-bold::before {\n  content: \"\\F17B8\";\n}\n\n.mdi-arrow-u-up-left::before {\n  content: \"\\F17B9\";\n}\n\n.mdi-arrow-u-up-left-bold::before {\n  content: \"\\F17BA\";\n}\n\n.mdi-arrow-u-up-right::before {\n  content: \"\\F17BB\";\n}\n\n.mdi-arrow-u-up-right-bold::before {\n  content: \"\\F17BC\";\n}\n\n.mdi-arrow-up::before {\n  content: \"\\F005D\";\n}\n\n.mdi-arrow-up-bold::before {\n  content: \"\\F0737\";\n}\n\n.mdi-arrow-up-bold-box::before {\n  content: \"\\F0738\";\n}\n\n.mdi-arrow-up-bold-box-outline::before {\n  content: \"\\F0739\";\n}\n\n.mdi-arrow-up-bold-circle::before {\n  content: \"\\F005F\";\n}\n\n.mdi-arrow-up-bold-circle-outline::before {\n  content: \"\\F0060\";\n}\n\n.mdi-arrow-up-bold-hexagon-outline::before {\n  content: \"\\F0061\";\n}\n\n.mdi-arrow-up-bold-outline::before {\n  content: \"\\F09C7\";\n}\n\n.mdi-arrow-up-box::before {\n  content: \"\\F06C3\";\n}\n\n.mdi-arrow-up-circle::before {\n  content: \"\\F0CE1\";\n}\n\n.mdi-arrow-up-circle-outline::before {\n  content: \"\\F0CE2\";\n}\n\n.mdi-arrow-up-down::before {\n  content: \"\\F0E79\";\n}\n\n.mdi-arrow-up-down-bold::before {\n  content: \"\\F0E7A\";\n}\n\n.mdi-arrow-up-down-bold-outline::before {\n  content: \"\\F09C8\";\n}\n\n.mdi-arrow-up-drop-circle::before {\n  content: \"\\F0062\";\n}\n\n.mdi-arrow-up-drop-circle-outline::before {\n  content: \"\\F0063\";\n}\n\n.mdi-arrow-up-left::before {\n  content: \"\\F17BD\";\n}\n\n.mdi-arrow-up-left-bold::before {\n  content: \"\\F17BE\";\n}\n\n.mdi-arrow-up-right::before {\n  content: \"\\F17BF\";\n}\n\n.mdi-arrow-up-right-bold::before {\n  content: \"\\F17C0\";\n}\n\n.mdi-arrow-up-thick::before {\n  content: \"\\F005E\";\n}\n\n.mdi-arrow-up-thin::before {\n  content: \"\\F19B2\";\n}\n\n.mdi-arrow-up-thin-circle-outline::before {\n  content: \"\\F1597\";\n}\n\n.mdi-arrow-vertical-lock::before {\n  content: \"\\F115C\";\n}\n\n.mdi-artstation::before {\n  content: \"\\F0B5B\";\n}\n\n.mdi-aspect-ratio::before {\n  content: \"\\F0A24\";\n}\n\n.mdi-assistant::before {\n  content: \"\\F0064\";\n}\n\n.mdi-asterisk::before {\n  content: \"\\F06C4\";\n}\n\n.mdi-at::before {\n  content: \"\\F0065\";\n}\n\n.mdi-atlassian::before {\n  content: \"\\F0804\";\n}\n\n.mdi-atm::before {\n  content: \"\\F0D47\";\n}\n\n.mdi-atom::before {\n  content: \"\\F0768\";\n}\n\n.mdi-atom-variant::before {\n  content: \"\\F0E7B\";\n}\n\n.mdi-attachment::before {\n  content: \"\\F0066\";\n}\n\n.mdi-audio-input-rca::before {\n  content: \"\\F186B\";\n}\n\n.mdi-audio-input-stereo-minijack::before {\n  content: \"\\F186C\";\n}\n\n.mdi-audio-input-xlr::before {\n  content: \"\\F186D\";\n}\n\n.mdi-audio-video::before {\n  content: \"\\F093D\";\n}\n\n.mdi-audio-video-off::before {\n  content: \"\\F11B6\";\n}\n\n.mdi-augmented-reality::before {\n  content: \"\\F0850\";\n}\n\n.mdi-auto-download::before {\n  content: \"\\F137E\";\n}\n\n.mdi-auto-fix::before {\n  content: \"\\F0068\";\n}\n\n.mdi-auto-upload::before {\n  content: \"\\F0069\";\n}\n\n.mdi-autorenew::before {\n  content: \"\\F006A\";\n}\n\n.mdi-av-timer::before {\n  content: \"\\F006B\";\n}\n\n.mdi-aws::before {\n  content: \"\\F0E0F\";\n}\n\n.mdi-axe::before {\n  content: \"\\F08C8\";\n}\n\n.mdi-axe-battle::before {\n  content: \"\\F1842\";\n}\n\n.mdi-axis::before {\n  content: \"\\F0D48\";\n}\n\n.mdi-axis-arrow::before {\n  content: \"\\F0D49\";\n}\n\n.mdi-axis-arrow-info::before {\n  content: \"\\F140E\";\n}\n\n.mdi-axis-arrow-lock::before {\n  content: \"\\F0D4A\";\n}\n\n.mdi-axis-lock::before {\n  content: \"\\F0D4B\";\n}\n\n.mdi-axis-x-arrow::before {\n  content: \"\\F0D4C\";\n}\n\n.mdi-axis-x-arrow-lock::before {\n  content: \"\\F0D4D\";\n}\n\n.mdi-axis-x-rotate-clockwise::before {\n  content: \"\\F0D4E\";\n}\n\n.mdi-axis-x-rotate-counterclockwise::before {\n  content: \"\\F0D4F\";\n}\n\n.mdi-axis-x-y-arrow-lock::before {\n  content: \"\\F0D50\";\n}\n\n.mdi-axis-y-arrow::before {\n  content: \"\\F0D51\";\n}\n\n.mdi-axis-y-arrow-lock::before {\n  content: \"\\F0D52\";\n}\n\n.mdi-axis-y-rotate-clockwise::before {\n  content: \"\\F0D53\";\n}\n\n.mdi-axis-y-rotate-counterclockwise::before {\n  content: \"\\F0D54\";\n}\n\n.mdi-axis-z-arrow::before {\n  content: \"\\F0D55\";\n}\n\n.mdi-axis-z-arrow-lock::before {\n  content: \"\\F0D56\";\n}\n\n.mdi-axis-z-rotate-clockwise::before {\n  content: \"\\F0D57\";\n}\n\n.mdi-axis-z-rotate-counterclockwise::before {\n  content: \"\\F0D58\";\n}\n\n.mdi-babel::before {\n  content: \"\\F0A25\";\n}\n\n.mdi-baby::before {\n  content: \"\\F006C\";\n}\n\n.mdi-baby-bottle::before {\n  content: \"\\F0F39\";\n}\n\n.mdi-baby-bottle-outline::before {\n  content: \"\\F0F3A\";\n}\n\n.mdi-baby-buggy::before {\n  content: \"\\F13E0\";\n}\n\n.mdi-baby-carriage::before {\n  content: \"\\F068F\";\n}\n\n.mdi-baby-carriage-off::before {\n  content: \"\\F0FA0\";\n}\n\n.mdi-baby-face::before {\n  content: \"\\F0E7C\";\n}\n\n.mdi-baby-face-outline::before {\n  content: \"\\F0E7D\";\n}\n\n.mdi-backburger::before {\n  content: \"\\F006D\";\n}\n\n.mdi-backspace::before {\n  content: \"\\F006E\";\n}\n\n.mdi-backspace-outline::before {\n  content: \"\\F0B5C\";\n}\n\n.mdi-backspace-reverse::before {\n  content: \"\\F0E7E\";\n}\n\n.mdi-backspace-reverse-outline::before {\n  content: \"\\F0E7F\";\n}\n\n.mdi-backup-restore::before {\n  content: \"\\F006F\";\n}\n\n.mdi-bacteria::before {\n  content: \"\\F0ED5\";\n}\n\n.mdi-bacteria-outline::before {\n  content: \"\\F0ED6\";\n}\n\n.mdi-badge-account::before {\n  content: \"\\F0DA7\";\n}\n\n.mdi-badge-account-alert::before {\n  content: \"\\F0DA8\";\n}\n\n.mdi-badge-account-alert-outline::before {\n  content: \"\\F0DA9\";\n}\n\n.mdi-badge-account-horizontal::before {\n  content: \"\\F0E0D\";\n}\n\n.mdi-badge-account-horizontal-outline::before {\n  content: \"\\F0E0E\";\n}\n\n.mdi-badge-account-outline::before {\n  content: \"\\F0DAA\";\n}\n\n.mdi-badminton::before {\n  content: \"\\F0851\";\n}\n\n.mdi-bag-carry-on::before {\n  content: \"\\F0F3B\";\n}\n\n.mdi-bag-carry-on-check::before {\n  content: \"\\F0D65\";\n}\n\n.mdi-bag-carry-on-off::before {\n  content: \"\\F0F3C\";\n}\n\n.mdi-bag-checked::before {\n  content: \"\\F0F3D\";\n}\n\n.mdi-bag-personal::before {\n  content: \"\\F0E10\";\n}\n\n.mdi-bag-personal-off::before {\n  content: \"\\F0E11\";\n}\n\n.mdi-bag-personal-off-outline::before {\n  content: \"\\F0E12\";\n}\n\n.mdi-bag-personal-outline::before {\n  content: \"\\F0E13\";\n}\n\n.mdi-bag-suitcase::before {\n  content: \"\\F158B\";\n}\n\n.mdi-bag-suitcase-off::before {\n  content: \"\\F158D\";\n}\n\n.mdi-bag-suitcase-off-outline::before {\n  content: \"\\F158E\";\n}\n\n.mdi-bag-suitcase-outline::before {\n  content: \"\\F158C\";\n}\n\n.mdi-baguette::before {\n  content: \"\\F0F3E\";\n}\n\n.mdi-balcony::before {\n  content: \"\\F1817\";\n}\n\n.mdi-balloon::before {\n  content: \"\\F0A26\";\n}\n\n.mdi-ballot::before {\n  content: \"\\F09C9\";\n}\n\n.mdi-ballot-outline::before {\n  content: \"\\F09CA\";\n}\n\n.mdi-ballot-recount::before {\n  content: \"\\F0C39\";\n}\n\n.mdi-ballot-recount-outline::before {\n  content: \"\\F0C3A\";\n}\n\n.mdi-bandage::before {\n  content: \"\\F0DAF\";\n}\n\n.mdi-bank::before {\n  content: \"\\F0070\";\n}\n\n.mdi-bank-check::before {\n  content: \"\\F1655\";\n}\n\n.mdi-bank-minus::before {\n  content: \"\\F0DB0\";\n}\n\n.mdi-bank-off::before {\n  content: \"\\F1656\";\n}\n\n.mdi-bank-off-outline::before {\n  content: \"\\F1657\";\n}\n\n.mdi-bank-outline::before {\n  content: \"\\F0E80\";\n}\n\n.mdi-bank-plus::before {\n  content: \"\\F0DB1\";\n}\n\n.mdi-bank-remove::before {\n  content: \"\\F0DB2\";\n}\n\n.mdi-bank-transfer::before {\n  content: \"\\F0A27\";\n}\n\n.mdi-bank-transfer-in::before {\n  content: \"\\F0A28\";\n}\n\n.mdi-bank-transfer-out::before {\n  content: \"\\F0A29\";\n}\n\n.mdi-barcode::before {\n  content: \"\\F0071\";\n}\n\n.mdi-barcode-off::before {\n  content: \"\\F1236\";\n}\n\n.mdi-barcode-scan::before {\n  content: \"\\F0072\";\n}\n\n.mdi-barley::before {\n  content: \"\\F0073\";\n}\n\n.mdi-barley-off::before {\n  content: \"\\F0B5D\";\n}\n\n.mdi-barn::before {\n  content: \"\\F0B5E\";\n}\n\n.mdi-barrel::before {\n  content: \"\\F0074\";\n}\n\n.mdi-baseball::before {\n  content: \"\\F0852\";\n}\n\n.mdi-baseball-bat::before {\n  content: \"\\F0853\";\n}\n\n.mdi-baseball-diamond::before {\n  content: \"\\F15EC\";\n}\n\n.mdi-baseball-diamond-outline::before {\n  content: \"\\F15ED\";\n}\n\n.mdi-bash::before {\n  content: \"\\F1183\";\n}\n\n.mdi-basket::before {\n  content: \"\\F0076\";\n}\n\n.mdi-basket-check::before {\n  content: \"\\F18E5\";\n}\n\n.mdi-basket-check-outline::before {\n  content: \"\\F18E6\";\n}\n\n.mdi-basket-fill::before {\n  content: \"\\F0077\";\n}\n\n.mdi-basket-minus::before {\n  content: \"\\F1523\";\n}\n\n.mdi-basket-minus-outline::before {\n  content: \"\\F1524\";\n}\n\n.mdi-basket-off::before {\n  content: \"\\F1525\";\n}\n\n.mdi-basket-off-outline::before {\n  content: \"\\F1526\";\n}\n\n.mdi-basket-outline::before {\n  content: \"\\F1181\";\n}\n\n.mdi-basket-plus::before {\n  content: \"\\F1527\";\n}\n\n.mdi-basket-plus-outline::before {\n  content: \"\\F1528\";\n}\n\n.mdi-basket-remove::before {\n  content: \"\\F1529\";\n}\n\n.mdi-basket-remove-outline::before {\n  content: \"\\F152A\";\n}\n\n.mdi-basket-unfill::before {\n  content: \"\\F0078\";\n}\n\n.mdi-basketball::before {\n  content: \"\\F0806\";\n}\n\n.mdi-basketball-hoop::before {\n  content: \"\\F0C3B\";\n}\n\n.mdi-basketball-hoop-outline::before {\n  content: \"\\F0C3C\";\n}\n\n.mdi-bat::before {\n  content: \"\\F0B5F\";\n}\n\n.mdi-bathtub::before {\n  content: \"\\F1818\";\n}\n\n.mdi-bathtub-outline::before {\n  content: \"\\F1819\";\n}\n\n.mdi-battery::before {\n  content: \"\\F0079\";\n}\n\n.mdi-battery-10::before {\n  content: \"\\F007A\";\n}\n\n.mdi-battery-10-bluetooth::before {\n  content: \"\\F093E\";\n}\n\n.mdi-battery-20::before {\n  content: \"\\F007B\";\n}\n\n.mdi-battery-20-bluetooth::before {\n  content: \"\\F093F\";\n}\n\n.mdi-battery-30::before {\n  content: \"\\F007C\";\n}\n\n.mdi-battery-30-bluetooth::before {\n  content: \"\\F0940\";\n}\n\n.mdi-battery-40::before {\n  content: \"\\F007D\";\n}\n\n.mdi-battery-40-bluetooth::before {\n  content: \"\\F0941\";\n}\n\n.mdi-battery-50::before {\n  content: \"\\F007E\";\n}\n\n.mdi-battery-50-bluetooth::before {\n  content: \"\\F0942\";\n}\n\n.mdi-battery-60::before {\n  content: \"\\F007F\";\n}\n\n.mdi-battery-60-bluetooth::before {\n  content: \"\\F0943\";\n}\n\n.mdi-battery-70::before {\n  content: \"\\F0080\";\n}\n\n.mdi-battery-70-bluetooth::before {\n  content: \"\\F0944\";\n}\n\n.mdi-battery-80::before {\n  content: \"\\F0081\";\n}\n\n.mdi-battery-80-bluetooth::before {\n  content: \"\\F0945\";\n}\n\n.mdi-battery-90::before {\n  content: \"\\F0082\";\n}\n\n.mdi-battery-90-bluetooth::before {\n  content: \"\\F0946\";\n}\n\n.mdi-battery-alert::before {\n  content: \"\\F0083\";\n}\n\n.mdi-battery-alert-bluetooth::before {\n  content: \"\\F0947\";\n}\n\n.mdi-battery-alert-variant::before {\n  content: \"\\F10CC\";\n}\n\n.mdi-battery-alert-variant-outline::before {\n  content: \"\\F10CD\";\n}\n\n.mdi-battery-arrow-down::before {\n  content: \"\\F17DE\";\n}\n\n.mdi-battery-arrow-down-outline::before {\n  content: \"\\F17DF\";\n}\n\n.mdi-battery-arrow-up::before {\n  content: \"\\F17E0\";\n}\n\n.mdi-battery-arrow-up-outline::before {\n  content: \"\\F17E1\";\n}\n\n.mdi-battery-bluetooth::before {\n  content: \"\\F0948\";\n}\n\n.mdi-battery-bluetooth-variant::before {\n  content: \"\\F0949\";\n}\n\n.mdi-battery-charging::before {\n  content: \"\\F0084\";\n}\n\n.mdi-battery-charging-10::before {\n  content: \"\\F089C\";\n}\n\n.mdi-battery-charging-100::before {\n  content: \"\\F0085\";\n}\n\n.mdi-battery-charging-20::before {\n  content: \"\\F0086\";\n}\n\n.mdi-battery-charging-30::before {\n  content: \"\\F0087\";\n}\n\n.mdi-battery-charging-40::before {\n  content: \"\\F0088\";\n}\n\n.mdi-battery-charging-50::before {\n  content: \"\\F089D\";\n}\n\n.mdi-battery-charging-60::before {\n  content: \"\\F0089\";\n}\n\n.mdi-battery-charging-70::before {\n  content: \"\\F089E\";\n}\n\n.mdi-battery-charging-80::before {\n  content: \"\\F008A\";\n}\n\n.mdi-battery-charging-90::before {\n  content: \"\\F008B\";\n}\n\n.mdi-battery-charging-high::before {\n  content: \"\\F12A6\";\n}\n\n.mdi-battery-charging-low::before {\n  content: \"\\F12A4\";\n}\n\n.mdi-battery-charging-medium::before {\n  content: \"\\F12A5\";\n}\n\n.mdi-battery-charging-outline::before {\n  content: \"\\F089F\";\n}\n\n.mdi-battery-charging-wireless::before {\n  content: \"\\F0807\";\n}\n\n.mdi-battery-charging-wireless-10::before {\n  content: \"\\F0808\";\n}\n\n.mdi-battery-charging-wireless-20::before {\n  content: \"\\F0809\";\n}\n\n.mdi-battery-charging-wireless-30::before {\n  content: \"\\F080A\";\n}\n\n.mdi-battery-charging-wireless-40::before {\n  content: \"\\F080B\";\n}\n\n.mdi-battery-charging-wireless-50::before {\n  content: \"\\F080C\";\n}\n\n.mdi-battery-charging-wireless-60::before {\n  content: \"\\F080D\";\n}\n\n.mdi-battery-charging-wireless-70::before {\n  content: \"\\F080E\";\n}\n\n.mdi-battery-charging-wireless-80::before {\n  content: \"\\F080F\";\n}\n\n.mdi-battery-charging-wireless-90::before {\n  content: \"\\F0810\";\n}\n\n.mdi-battery-charging-wireless-alert::before {\n  content: \"\\F0811\";\n}\n\n.mdi-battery-charging-wireless-outline::before {\n  content: \"\\F0812\";\n}\n\n.mdi-battery-check::before {\n  content: \"\\F17E2\";\n}\n\n.mdi-battery-check-outline::before {\n  content: \"\\F17E3\";\n}\n\n.mdi-battery-heart::before {\n  content: \"\\F120F\";\n}\n\n.mdi-battery-heart-outline::before {\n  content: \"\\F1210\";\n}\n\n.mdi-battery-heart-variant::before {\n  content: \"\\F1211\";\n}\n\n.mdi-battery-high::before {\n  content: \"\\F12A3\";\n}\n\n.mdi-battery-lock::before {\n  content: \"\\F179C\";\n}\n\n.mdi-battery-lock-open::before {\n  content: \"\\F179D\";\n}\n\n.mdi-battery-low::before {\n  content: \"\\F12A1\";\n}\n\n.mdi-battery-medium::before {\n  content: \"\\F12A2\";\n}\n\n.mdi-battery-minus::before {\n  content: \"\\F17E4\";\n}\n\n.mdi-battery-minus-outline::before {\n  content: \"\\F17E5\";\n}\n\n.mdi-battery-minus-variant::before {\n  content: \"\\F008C\";\n}\n\n.mdi-battery-negative::before {\n  content: \"\\F008D\";\n}\n\n.mdi-battery-off::before {\n  content: \"\\F125D\";\n}\n\n.mdi-battery-off-outline::before {\n  content: \"\\F125E\";\n}\n\n.mdi-battery-outline::before {\n  content: \"\\F008E\";\n}\n\n.mdi-battery-plus::before {\n  content: \"\\F17E6\";\n}\n\n.mdi-battery-plus-outline::before {\n  content: \"\\F17E7\";\n}\n\n.mdi-battery-plus-variant::before {\n  content: \"\\F008F\";\n}\n\n.mdi-battery-positive::before {\n  content: \"\\F0090\";\n}\n\n.mdi-battery-remove::before {\n  content: \"\\F17E8\";\n}\n\n.mdi-battery-remove-outline::before {\n  content: \"\\F17E9\";\n}\n\n.mdi-battery-sync::before {\n  content: \"\\F1834\";\n}\n\n.mdi-battery-sync-outline::before {\n  content: \"\\F1835\";\n}\n\n.mdi-battery-unknown::before {\n  content: \"\\F0091\";\n}\n\n.mdi-battery-unknown-bluetooth::before {\n  content: \"\\F094A\";\n}\n\n.mdi-beach::before {\n  content: \"\\F0092\";\n}\n\n.mdi-beaker::before {\n  content: \"\\F0CEA\";\n}\n\n.mdi-beaker-alert::before {\n  content: \"\\F1229\";\n}\n\n.mdi-beaker-alert-outline::before {\n  content: \"\\F122A\";\n}\n\n.mdi-beaker-check::before {\n  content: \"\\F122B\";\n}\n\n.mdi-beaker-check-outline::before {\n  content: \"\\F122C\";\n}\n\n.mdi-beaker-minus::before {\n  content: \"\\F122D\";\n}\n\n.mdi-beaker-minus-outline::before {\n  content: \"\\F122E\";\n}\n\n.mdi-beaker-outline::before {\n  content: \"\\F0690\";\n}\n\n.mdi-beaker-plus::before {\n  content: \"\\F122F\";\n}\n\n.mdi-beaker-plus-outline::before {\n  content: \"\\F1230\";\n}\n\n.mdi-beaker-question::before {\n  content: \"\\F1231\";\n}\n\n.mdi-beaker-question-outline::before {\n  content: \"\\F1232\";\n}\n\n.mdi-beaker-remove::before {\n  content: \"\\F1233\";\n}\n\n.mdi-beaker-remove-outline::before {\n  content: \"\\F1234\";\n}\n\n.mdi-bed::before {\n  content: \"\\F02E3\";\n}\n\n.mdi-bed-double::before {\n  content: \"\\F0FD4\";\n}\n\n.mdi-bed-double-outline::before {\n  content: \"\\F0FD3\";\n}\n\n.mdi-bed-empty::before {\n  content: \"\\F08A0\";\n}\n\n.mdi-bed-king::before {\n  content: \"\\F0FD2\";\n}\n\n.mdi-bed-king-outline::before {\n  content: \"\\F0FD1\";\n}\n\n.mdi-bed-outline::before {\n  content: \"\\F0099\";\n}\n\n.mdi-bed-queen::before {\n  content: \"\\F0FD0\";\n}\n\n.mdi-bed-queen-outline::before {\n  content: \"\\F0FDB\";\n}\n\n.mdi-bed-single::before {\n  content: \"\\F106D\";\n}\n\n.mdi-bed-single-outline::before {\n  content: \"\\F106E\";\n}\n\n.mdi-bee::before {\n  content: \"\\F0FA1\";\n}\n\n.mdi-bee-flower::before {\n  content: \"\\F0FA2\";\n}\n\n.mdi-beehive-off-outline::before {\n  content: \"\\F13ED\";\n}\n\n.mdi-beehive-outline::before {\n  content: \"\\F10CE\";\n}\n\n.mdi-beekeeper::before {\n  content: \"\\F14E2\";\n}\n\n.mdi-beer::before {\n  content: \"\\F0098\";\n}\n\n.mdi-beer-outline::before {\n  content: \"\\F130C\";\n}\n\n.mdi-bell::before {\n  content: \"\\F009A\";\n}\n\n.mdi-bell-alert::before {\n  content: \"\\F0D59\";\n}\n\n.mdi-bell-alert-outline::before {\n  content: \"\\F0E81\";\n}\n\n.mdi-bell-badge::before {\n  content: \"\\F116B\";\n}\n\n.mdi-bell-badge-outline::before {\n  content: \"\\F0178\";\n}\n\n.mdi-bell-cancel::before {\n  content: \"\\F13E7\";\n}\n\n.mdi-bell-cancel-outline::before {\n  content: \"\\F13E8\";\n}\n\n.mdi-bell-check::before {\n  content: \"\\F11E5\";\n}\n\n.mdi-bell-check-outline::before {\n  content: \"\\F11E6\";\n}\n\n.mdi-bell-circle::before {\n  content: \"\\F0D5A\";\n}\n\n.mdi-bell-circle-outline::before {\n  content: \"\\F0D5B\";\n}\n\n.mdi-bell-minus::before {\n  content: \"\\F13E9\";\n}\n\n.mdi-bell-minus-outline::before {\n  content: \"\\F13EA\";\n}\n\n.mdi-bell-off::before {\n  content: \"\\F009B\";\n}\n\n.mdi-bell-off-outline::before {\n  content: \"\\F0A91\";\n}\n\n.mdi-bell-outline::before {\n  content: \"\\F009C\";\n}\n\n.mdi-bell-plus::before {\n  content: \"\\F009D\";\n}\n\n.mdi-bell-plus-outline::before {\n  content: \"\\F0A92\";\n}\n\n.mdi-bell-remove::before {\n  content: \"\\F13EB\";\n}\n\n.mdi-bell-remove-outline::before {\n  content: \"\\F13EC\";\n}\n\n.mdi-bell-ring::before {\n  content: \"\\F009E\";\n}\n\n.mdi-bell-ring-outline::before {\n  content: \"\\F009F\";\n}\n\n.mdi-bell-sleep::before {\n  content: \"\\F00A0\";\n}\n\n.mdi-bell-sleep-outline::before {\n  content: \"\\F0A93\";\n}\n\n.mdi-beta::before {\n  content: \"\\F00A1\";\n}\n\n.mdi-betamax::before {\n  content: \"\\F09CB\";\n}\n\n.mdi-biathlon::before {\n  content: \"\\F0E14\";\n}\n\n.mdi-bicycle::before {\n  content: \"\\F109C\";\n}\n\n.mdi-bicycle-basket::before {\n  content: \"\\F1235\";\n}\n\n.mdi-bicycle-cargo::before {\n  content: \"\\F189C\";\n}\n\n.mdi-bicycle-electric::before {\n  content: \"\\F15B4\";\n}\n\n.mdi-bicycle-penny-farthing::before {\n  content: \"\\F15E9\";\n}\n\n.mdi-bike::before {\n  content: \"\\F00A3\";\n}\n\n.mdi-bike-fast::before {\n  content: \"\\F111F\";\n}\n\n.mdi-billboard::before {\n  content: \"\\F1010\";\n}\n\n.mdi-billiards::before {\n  content: \"\\F0B61\";\n}\n\n.mdi-billiards-rack::before {\n  content: \"\\F0B62\";\n}\n\n.mdi-binoculars::before {\n  content: \"\\F00A5\";\n}\n\n.mdi-bio::before {\n  content: \"\\F00A6\";\n}\n\n.mdi-biohazard::before {\n  content: \"\\F00A7\";\n}\n\n.mdi-bird::before {\n  content: \"\\F15C6\";\n}\n\n.mdi-bitbucket::before {\n  content: \"\\F00A8\";\n}\n\n.mdi-bitcoin::before {\n  content: \"\\F0813\";\n}\n\n.mdi-black-mesa::before {\n  content: \"\\F00A9\";\n}\n\n.mdi-blender::before {\n  content: \"\\F0CEB\";\n}\n\n.mdi-blender-outline::before {\n  content: \"\\F181A\";\n}\n\n.mdi-blender-software::before {\n  content: \"\\F00AB\";\n}\n\n.mdi-blinds::before {\n  content: \"\\F00AC\";\n}\n\n.mdi-blinds-open::before {\n  content: \"\\F1011\";\n}\n\n.mdi-block-helper::before {\n  content: \"\\F00AD\";\n}\n\n.mdi-blood-bag::before {\n  content: \"\\F0CEC\";\n}\n\n.mdi-bluetooth::before {\n  content: \"\\F00AF\";\n}\n\n.mdi-bluetooth-audio::before {\n  content: \"\\F00B0\";\n}\n\n.mdi-bluetooth-connect::before {\n  content: \"\\F00B1\";\n}\n\n.mdi-bluetooth-off::before {\n  content: \"\\F00B2\";\n}\n\n.mdi-bluetooth-settings::before {\n  content: \"\\F00B3\";\n}\n\n.mdi-bluetooth-transfer::before {\n  content: \"\\F00B4\";\n}\n\n.mdi-blur::before {\n  content: \"\\F00B5\";\n}\n\n.mdi-blur-linear::before {\n  content: \"\\F00B6\";\n}\n\n.mdi-blur-off::before {\n  content: \"\\F00B7\";\n}\n\n.mdi-blur-radial::before {\n  content: \"\\F00B8\";\n}\n\n.mdi-bolt::before {\n  content: \"\\F0DB3\";\n}\n\n.mdi-bomb::before {\n  content: \"\\F0691\";\n}\n\n.mdi-bomb-off::before {\n  content: \"\\F06C5\";\n}\n\n.mdi-bone::before {\n  content: \"\\F00B9\";\n}\n\n.mdi-book::before {\n  content: \"\\F00BA\";\n}\n\n.mdi-book-account::before {\n  content: \"\\F13AD\";\n}\n\n.mdi-book-account-outline::before {\n  content: \"\\F13AE\";\n}\n\n.mdi-book-alert::before {\n  content: \"\\F167C\";\n}\n\n.mdi-book-alert-outline::before {\n  content: \"\\F167D\";\n}\n\n.mdi-book-alphabet::before {\n  content: \"\\F061D\";\n}\n\n.mdi-book-arrow-down::before {\n  content: \"\\F167E\";\n}\n\n.mdi-book-arrow-down-outline::before {\n  content: \"\\F167F\";\n}\n\n.mdi-book-arrow-left::before {\n  content: \"\\F1680\";\n}\n\n.mdi-book-arrow-left-outline::before {\n  content: \"\\F1681\";\n}\n\n.mdi-book-arrow-right::before {\n  content: \"\\F1682\";\n}\n\n.mdi-book-arrow-right-outline::before {\n  content: \"\\F1683\";\n}\n\n.mdi-book-arrow-up::before {\n  content: \"\\F1684\";\n}\n\n.mdi-book-arrow-up-outline::before {\n  content: \"\\F1685\";\n}\n\n.mdi-book-cancel::before {\n  content: \"\\F1686\";\n}\n\n.mdi-book-cancel-outline::before {\n  content: \"\\F1687\";\n}\n\n.mdi-book-check::before {\n  content: \"\\F14F3\";\n}\n\n.mdi-book-check-outline::before {\n  content: \"\\F14F4\";\n}\n\n.mdi-book-clock::before {\n  content: \"\\F1688\";\n}\n\n.mdi-book-clock-outline::before {\n  content: \"\\F1689\";\n}\n\n.mdi-book-cog::before {\n  content: \"\\F168A\";\n}\n\n.mdi-book-cog-outline::before {\n  content: \"\\F168B\";\n}\n\n.mdi-book-cross::before {\n  content: \"\\F00A2\";\n}\n\n.mdi-book-edit::before {\n  content: \"\\F168C\";\n}\n\n.mdi-book-edit-outline::before {\n  content: \"\\F168D\";\n}\n\n.mdi-book-education::before {\n  content: \"\\F16C9\";\n}\n\n.mdi-book-education-outline::before {\n  content: \"\\F16CA\";\n}\n\n.mdi-book-information-variant::before {\n  content: \"\\F106F\";\n}\n\n.mdi-book-lock::before {\n  content: \"\\F079A\";\n}\n\n.mdi-book-lock-open::before {\n  content: \"\\F079B\";\n}\n\n.mdi-book-lock-open-outline::before {\n  content: \"\\F168E\";\n}\n\n.mdi-book-lock-outline::before {\n  content: \"\\F168F\";\n}\n\n.mdi-book-marker::before {\n  content: \"\\F1690\";\n}\n\n.mdi-book-marker-outline::before {\n  content: \"\\F1691\";\n}\n\n.mdi-book-minus::before {\n  content: \"\\F05D9\";\n}\n\n.mdi-book-minus-multiple::before {\n  content: \"\\F0A94\";\n}\n\n.mdi-book-minus-multiple-outline::before {\n  content: \"\\F090B\";\n}\n\n.mdi-book-minus-outline::before {\n  content: \"\\F1692\";\n}\n\n.mdi-book-multiple::before {\n  content: \"\\F00BB\";\n}\n\n.mdi-book-multiple-outline::before {\n  content: \"\\F0436\";\n}\n\n.mdi-book-music::before {\n  content: \"\\F0067\";\n}\n\n.mdi-book-music-outline::before {\n  content: \"\\F1693\";\n}\n\n.mdi-book-off::before {\n  content: \"\\F1694\";\n}\n\n.mdi-book-off-outline::before {\n  content: \"\\F1695\";\n}\n\n.mdi-book-open::before {\n  content: \"\\F00BD\";\n}\n\n.mdi-book-open-blank-variant::before {\n  content: \"\\F00BE\";\n}\n\n.mdi-book-open-outline::before {\n  content: \"\\F0B63\";\n}\n\n.mdi-book-open-page-variant::before {\n  content: \"\\F05DA\";\n}\n\n.mdi-book-open-page-variant-outline::before {\n  content: \"\\F15D6\";\n}\n\n.mdi-book-open-variant::before {\n  content: \"\\F14F7\";\n}\n\n.mdi-book-outline::before {\n  content: \"\\F0B64\";\n}\n\n.mdi-book-play::before {\n  content: \"\\F0E82\";\n}\n\n.mdi-book-play-outline::before {\n  content: \"\\F0E83\";\n}\n\n.mdi-book-plus::before {\n  content: \"\\F05DB\";\n}\n\n.mdi-book-plus-multiple::before {\n  content: \"\\F0A95\";\n}\n\n.mdi-book-plus-multiple-outline::before {\n  content: \"\\F0ADE\";\n}\n\n.mdi-book-plus-outline::before {\n  content: \"\\F1696\";\n}\n\n.mdi-book-refresh::before {\n  content: \"\\F1697\";\n}\n\n.mdi-book-refresh-outline::before {\n  content: \"\\F1698\";\n}\n\n.mdi-book-remove::before {\n  content: \"\\F0A97\";\n}\n\n.mdi-book-remove-multiple::before {\n  content: \"\\F0A96\";\n}\n\n.mdi-book-remove-multiple-outline::before {\n  content: \"\\F04CA\";\n}\n\n.mdi-book-remove-outline::before {\n  content: \"\\F1699\";\n}\n\n.mdi-book-search::before {\n  content: \"\\F0E84\";\n}\n\n.mdi-book-search-outline::before {\n  content: \"\\F0E85\";\n}\n\n.mdi-book-settings::before {\n  content: \"\\F169A\";\n}\n\n.mdi-book-settings-outline::before {\n  content: \"\\F169B\";\n}\n\n.mdi-book-sync::before {\n  content: \"\\F169C\";\n}\n\n.mdi-book-sync-outline::before {\n  content: \"\\F16C8\";\n}\n\n.mdi-book-variant::before {\n  content: \"\\F00BF\";\n}\n\n.mdi-book-variant-multiple::before {\n  content: \"\\F00BC\";\n}\n\n.mdi-bookmark::before {\n  content: \"\\F00C0\";\n}\n\n.mdi-bookmark-box-multiple::before {\n  content: \"\\F196C\";\n}\n\n.mdi-bookmark-box-multiple-outline::before {\n  content: \"\\F196D\";\n}\n\n.mdi-bookmark-check::before {\n  content: \"\\F00C1\";\n}\n\n.mdi-bookmark-check-outline::before {\n  content: \"\\F137B\";\n}\n\n.mdi-bookmark-minus::before {\n  content: \"\\F09CC\";\n}\n\n.mdi-bookmark-minus-outline::before {\n  content: \"\\F09CD\";\n}\n\n.mdi-bookmark-multiple::before {\n  content: \"\\F0E15\";\n}\n\n.mdi-bookmark-multiple-outline::before {\n  content: \"\\F0E16\";\n}\n\n.mdi-bookmark-music::before {\n  content: \"\\F00C2\";\n}\n\n.mdi-bookmark-music-outline::before {\n  content: \"\\F1379\";\n}\n\n.mdi-bookmark-off::before {\n  content: \"\\F09CE\";\n}\n\n.mdi-bookmark-off-outline::before {\n  content: \"\\F09CF\";\n}\n\n.mdi-bookmark-outline::before {\n  content: \"\\F00C3\";\n}\n\n.mdi-bookmark-plus::before {\n  content: \"\\F00C5\";\n}\n\n.mdi-bookmark-plus-outline::before {\n  content: \"\\F00C4\";\n}\n\n.mdi-bookmark-remove::before {\n  content: \"\\F00C6\";\n}\n\n.mdi-bookmark-remove-outline::before {\n  content: \"\\F137A\";\n}\n\n.mdi-bookshelf::before {\n  content: \"\\F125F\";\n}\n\n.mdi-boom-gate::before {\n  content: \"\\F0E86\";\n}\n\n.mdi-boom-gate-alert::before {\n  content: \"\\F0E87\";\n}\n\n.mdi-boom-gate-alert-outline::before {\n  content: \"\\F0E88\";\n}\n\n.mdi-boom-gate-arrow-down::before {\n  content: \"\\F0E89\";\n}\n\n.mdi-boom-gate-arrow-down-outline::before {\n  content: \"\\F0E8A\";\n}\n\n.mdi-boom-gate-arrow-up::before {\n  content: \"\\F0E8C\";\n}\n\n.mdi-boom-gate-arrow-up-outline::before {\n  content: \"\\F0E8D\";\n}\n\n.mdi-boom-gate-outline::before {\n  content: \"\\F0E8B\";\n}\n\n.mdi-boom-gate-up::before {\n  content: \"\\F17F9\";\n}\n\n.mdi-boom-gate-up-outline::before {\n  content: \"\\F17FA\";\n}\n\n.mdi-boombox::before {\n  content: \"\\F05DC\";\n}\n\n.mdi-boomerang::before {\n  content: \"\\F10CF\";\n}\n\n.mdi-bootstrap::before {\n  content: \"\\F06C6\";\n}\n\n.mdi-border-all::before {\n  content: \"\\F00C7\";\n}\n\n.mdi-border-all-variant::before {\n  content: \"\\F08A1\";\n}\n\n.mdi-border-bottom::before {\n  content: \"\\F00C8\";\n}\n\n.mdi-border-bottom-variant::before {\n  content: \"\\F08A2\";\n}\n\n.mdi-border-color::before {\n  content: \"\\F00C9\";\n}\n\n.mdi-border-horizontal::before {\n  content: \"\\F00CA\";\n}\n\n.mdi-border-inside::before {\n  content: \"\\F00CB\";\n}\n\n.mdi-border-left::before {\n  content: \"\\F00CC\";\n}\n\n.mdi-border-left-variant::before {\n  content: \"\\F08A3\";\n}\n\n.mdi-border-none::before {\n  content: \"\\F00CD\";\n}\n\n.mdi-border-none-variant::before {\n  content: \"\\F08A4\";\n}\n\n.mdi-border-outside::before {\n  content: \"\\F00CE\";\n}\n\n.mdi-border-right::before {\n  content: \"\\F00CF\";\n}\n\n.mdi-border-right-variant::before {\n  content: \"\\F08A5\";\n}\n\n.mdi-border-style::before {\n  content: \"\\F00D0\";\n}\n\n.mdi-border-top::before {\n  content: \"\\F00D1\";\n}\n\n.mdi-border-top-variant::before {\n  content: \"\\F08A6\";\n}\n\n.mdi-border-vertical::before {\n  content: \"\\F00D2\";\n}\n\n.mdi-bottle-soda::before {\n  content: \"\\F1070\";\n}\n\n.mdi-bottle-soda-classic::before {\n  content: \"\\F1071\";\n}\n\n.mdi-bottle-soda-classic-outline::before {\n  content: \"\\F1363\";\n}\n\n.mdi-bottle-soda-outline::before {\n  content: \"\\F1072\";\n}\n\n.mdi-bottle-tonic::before {\n  content: \"\\F112E\";\n}\n\n.mdi-bottle-tonic-outline::before {\n  content: \"\\F112F\";\n}\n\n.mdi-bottle-tonic-plus::before {\n  content: \"\\F1130\";\n}\n\n.mdi-bottle-tonic-plus-outline::before {\n  content: \"\\F1131\";\n}\n\n.mdi-bottle-tonic-skull::before {\n  content: \"\\F1132\";\n}\n\n.mdi-bottle-tonic-skull-outline::before {\n  content: \"\\F1133\";\n}\n\n.mdi-bottle-wine::before {\n  content: \"\\F0854\";\n}\n\n.mdi-bottle-wine-outline::before {\n  content: \"\\F1310\";\n}\n\n.mdi-bow-arrow::before {\n  content: \"\\F1841\";\n}\n\n.mdi-bow-tie::before {\n  content: \"\\F0678\";\n}\n\n.mdi-bowl::before {\n  content: \"\\F028E\";\n}\n\n.mdi-bowl-mix::before {\n  content: \"\\F0617\";\n}\n\n.mdi-bowl-mix-outline::before {\n  content: \"\\F02E4\";\n}\n\n.mdi-bowl-outline::before {\n  content: \"\\F02A9\";\n}\n\n.mdi-bowling::before {\n  content: \"\\F00D3\";\n}\n\n.mdi-box::before {\n  content: \"\\F00D4\";\n}\n\n.mdi-box-cutter::before {\n  content: \"\\F00D5\";\n}\n\n.mdi-box-cutter-off::before {\n  content: \"\\F0B4A\";\n}\n\n.mdi-box-shadow::before {\n  content: \"\\F0637\";\n}\n\n.mdi-boxing-glove::before {\n  content: \"\\F0B65\";\n}\n\n.mdi-braille::before {\n  content: \"\\F09D0\";\n}\n\n.mdi-brain::before {\n  content: \"\\F09D1\";\n}\n\n.mdi-bread-slice::before {\n  content: \"\\F0CEE\";\n}\n\n.mdi-bread-slice-outline::before {\n  content: \"\\F0CEF\";\n}\n\n.mdi-bridge::before {\n  content: \"\\F0618\";\n}\n\n.mdi-briefcase::before {\n  content: \"\\F00D6\";\n}\n\n.mdi-briefcase-account::before {\n  content: \"\\F0CF0\";\n}\n\n.mdi-briefcase-account-outline::before {\n  content: \"\\F0CF1\";\n}\n\n.mdi-briefcase-check::before {\n  content: \"\\F00D7\";\n}\n\n.mdi-briefcase-check-outline::before {\n  content: \"\\F131E\";\n}\n\n.mdi-briefcase-clock::before {\n  content: \"\\F10D0\";\n}\n\n.mdi-briefcase-clock-outline::before {\n  content: \"\\F10D1\";\n}\n\n.mdi-briefcase-download::before {\n  content: \"\\F00D8\";\n}\n\n.mdi-briefcase-download-outline::before {\n  content: \"\\F0C3D\";\n}\n\n.mdi-briefcase-edit::before {\n  content: \"\\F0A98\";\n}\n\n.mdi-briefcase-edit-outline::before {\n  content: \"\\F0C3E\";\n}\n\n.mdi-briefcase-eye::before {\n  content: \"\\F17D9\";\n}\n\n.mdi-briefcase-eye-outline::before {\n  content: \"\\F17DA\";\n}\n\n.mdi-briefcase-minus::before {\n  content: \"\\F0A2A\";\n}\n\n.mdi-briefcase-minus-outline::before {\n  content: \"\\F0C3F\";\n}\n\n.mdi-briefcase-off::before {\n  content: \"\\F1658\";\n}\n\n.mdi-briefcase-off-outline::before {\n  content: \"\\F1659\";\n}\n\n.mdi-briefcase-outline::before {\n  content: \"\\F0814\";\n}\n\n.mdi-briefcase-plus::before {\n  content: \"\\F0A2B\";\n}\n\n.mdi-briefcase-plus-outline::before {\n  content: \"\\F0C40\";\n}\n\n.mdi-briefcase-remove::before {\n  content: \"\\F0A2C\";\n}\n\n.mdi-briefcase-remove-outline::before {\n  content: \"\\F0C41\";\n}\n\n.mdi-briefcase-search::before {\n  content: \"\\F0A2D\";\n}\n\n.mdi-briefcase-search-outline::before {\n  content: \"\\F0C42\";\n}\n\n.mdi-briefcase-upload::before {\n  content: \"\\F00D9\";\n}\n\n.mdi-briefcase-upload-outline::before {\n  content: \"\\F0C43\";\n}\n\n.mdi-briefcase-variant::before {\n  content: \"\\F1494\";\n}\n\n.mdi-briefcase-variant-off::before {\n  content: \"\\F165A\";\n}\n\n.mdi-briefcase-variant-off-outline::before {\n  content: \"\\F165B\";\n}\n\n.mdi-briefcase-variant-outline::before {\n  content: \"\\F1495\";\n}\n\n.mdi-brightness-1::before {\n  content: \"\\F00DA\";\n}\n\n.mdi-brightness-2::before {\n  content: \"\\F00DB\";\n}\n\n.mdi-brightness-3::before {\n  content: \"\\F00DC\";\n}\n\n.mdi-brightness-4::before {\n  content: \"\\F00DD\";\n}\n\n.mdi-brightness-5::before {\n  content: \"\\F00DE\";\n}\n\n.mdi-brightness-6::before {\n  content: \"\\F00DF\";\n}\n\n.mdi-brightness-7::before {\n  content: \"\\F00E0\";\n}\n\n.mdi-brightness-auto::before {\n  content: \"\\F00E1\";\n}\n\n.mdi-brightness-percent::before {\n  content: \"\\F0CF2\";\n}\n\n.mdi-broadcast::before {\n  content: \"\\F1720\";\n}\n\n.mdi-broadcast-off::before {\n  content: \"\\F1721\";\n}\n\n.mdi-broom::before {\n  content: \"\\F00E2\";\n}\n\n.mdi-brush::before {\n  content: \"\\F00E3\";\n}\n\n.mdi-brush-off::before {\n  content: \"\\F1771\";\n}\n\n.mdi-brush-variant::before {\n  content: \"\\F1813\";\n}\n\n.mdi-bucket::before {\n  content: \"\\F1415\";\n}\n\n.mdi-bucket-outline::before {\n  content: \"\\F1416\";\n}\n\n.mdi-buffet::before {\n  content: \"\\F0578\";\n}\n\n.mdi-bug::before {\n  content: \"\\F00E4\";\n}\n\n.mdi-bug-check::before {\n  content: \"\\F0A2E\";\n}\n\n.mdi-bug-check-outline::before {\n  content: \"\\F0A2F\";\n}\n\n.mdi-bug-outline::before {\n  content: \"\\F0A30\";\n}\n\n.mdi-bugle::before {\n  content: \"\\F0DB4\";\n}\n\n.mdi-bulldozer::before {\n  content: \"\\F0B22\";\n}\n\n.mdi-bullet::before {\n  content: \"\\F0CF3\";\n}\n\n.mdi-bulletin-board::before {\n  content: \"\\F00E5\";\n}\n\n.mdi-bullhorn::before {\n  content: \"\\F00E6\";\n}\n\n.mdi-bullhorn-outline::before {\n  content: \"\\F0B23\";\n}\n\n.mdi-bullhorn-variant::before {\n  content: \"\\F196E\";\n}\n\n.mdi-bullhorn-variant-outline::before {\n  content: \"\\F196F\";\n}\n\n.mdi-bullseye::before {\n  content: \"\\F05DD\";\n}\n\n.mdi-bullseye-arrow::before {\n  content: \"\\F08C9\";\n}\n\n.mdi-bulma::before {\n  content: \"\\F12E7\";\n}\n\n.mdi-bunk-bed::before {\n  content: \"\\F1302\";\n}\n\n.mdi-bunk-bed-outline::before {\n  content: \"\\F0097\";\n}\n\n.mdi-bus::before {\n  content: \"\\F00E7\";\n}\n\n.mdi-bus-alert::before {\n  content: \"\\F0A99\";\n}\n\n.mdi-bus-articulated-end::before {\n  content: \"\\F079C\";\n}\n\n.mdi-bus-articulated-front::before {\n  content: \"\\F079D\";\n}\n\n.mdi-bus-clock::before {\n  content: \"\\F08CA\";\n}\n\n.mdi-bus-double-decker::before {\n  content: \"\\F079E\";\n}\n\n.mdi-bus-electric::before {\n  content: \"\\F191D\";\n}\n\n.mdi-bus-marker::before {\n  content: \"\\F1212\";\n}\n\n.mdi-bus-multiple::before {\n  content: \"\\F0F3F\";\n}\n\n.mdi-bus-school::before {\n  content: \"\\F079F\";\n}\n\n.mdi-bus-side::before {\n  content: \"\\F07A0\";\n}\n\n.mdi-bus-stop::before {\n  content: \"\\F1012\";\n}\n\n.mdi-bus-stop-covered::before {\n  content: \"\\F1013\";\n}\n\n.mdi-bus-stop-uncovered::before {\n  content: \"\\F1014\";\n}\n\n.mdi-butterfly::before {\n  content: \"\\F1589\";\n}\n\n.mdi-butterfly-outline::before {\n  content: \"\\F158A\";\n}\n\n.mdi-cabin-a-frame::before {\n  content: \"\\F188C\";\n}\n\n.mdi-cable-data::before {\n  content: \"\\F1394\";\n}\n\n.mdi-cached::before {\n  content: \"\\F00E8\";\n}\n\n.mdi-cactus::before {\n  content: \"\\F0DB5\";\n}\n\n.mdi-cake::before {\n  content: \"\\F00E9\";\n}\n\n.mdi-cake-layered::before {\n  content: \"\\F00EA\";\n}\n\n.mdi-cake-variant::before {\n  content: \"\\F00EB\";\n}\n\n.mdi-cake-variant-outline::before {\n  content: \"\\F17F0\";\n}\n\n.mdi-calculator::before {\n  content: \"\\F00EC\";\n}\n\n.mdi-calculator-variant::before {\n  content: \"\\F0A9A\";\n}\n\n.mdi-calculator-variant-outline::before {\n  content: \"\\F15A6\";\n}\n\n.mdi-calendar::before {\n  content: \"\\F00ED\";\n}\n\n.mdi-calendar-account::before {\n  content: \"\\F0ED7\";\n}\n\n.mdi-calendar-account-outline::before {\n  content: \"\\F0ED8\";\n}\n\n.mdi-calendar-alert::before {\n  content: \"\\F0A31\";\n}\n\n.mdi-calendar-arrow-left::before {\n  content: \"\\F1134\";\n}\n\n.mdi-calendar-arrow-right::before {\n  content: \"\\F1135\";\n}\n\n.mdi-calendar-blank::before {\n  content: \"\\F00EE\";\n}\n\n.mdi-calendar-blank-multiple::before {\n  content: \"\\F1073\";\n}\n\n.mdi-calendar-blank-outline::before {\n  content: \"\\F0B66\";\n}\n\n.mdi-calendar-check::before {\n  content: \"\\F00EF\";\n}\n\n.mdi-calendar-check-outline::before {\n  content: \"\\F0C44\";\n}\n\n.mdi-calendar-clock::before {\n  content: \"\\F00F0\";\n}\n\n.mdi-calendar-clock-outline::before {\n  content: \"\\F16E1\";\n}\n\n.mdi-calendar-collapse-horizontal::before {\n  content: \"\\F189D\";\n}\n\n.mdi-calendar-cursor::before {\n  content: \"\\F157B\";\n}\n\n.mdi-calendar-edit::before {\n  content: \"\\F08A7\";\n}\n\n.mdi-calendar-end::before {\n  content: \"\\F166C\";\n}\n\n.mdi-calendar-expand-horizontal::before {\n  content: \"\\F189E\";\n}\n\n.mdi-calendar-export::before {\n  content: \"\\F0B24\";\n}\n\n.mdi-calendar-heart::before {\n  content: \"\\F09D2\";\n}\n\n.mdi-calendar-import::before {\n  content: \"\\F0B25\";\n}\n\n.mdi-calendar-lock::before {\n  content: \"\\F1641\";\n}\n\n.mdi-calendar-lock-outline::before {\n  content: \"\\F1642\";\n}\n\n.mdi-calendar-minus::before {\n  content: \"\\F0D5C\";\n}\n\n.mdi-calendar-month::before {\n  content: \"\\F0E17\";\n}\n\n.mdi-calendar-month-outline::before {\n  content: \"\\F0E18\";\n}\n\n.mdi-calendar-multiple::before {\n  content: \"\\F00F1\";\n}\n\n.mdi-calendar-multiple-check::before {\n  content: \"\\F00F2\";\n}\n\n.mdi-calendar-multiselect::before {\n  content: \"\\F0A32\";\n}\n\n.mdi-calendar-outline::before {\n  content: \"\\F0B67\";\n}\n\n.mdi-calendar-plus::before {\n  content: \"\\F00F3\";\n}\n\n.mdi-calendar-question::before {\n  content: \"\\F0692\";\n}\n\n.mdi-calendar-range::before {\n  content: \"\\F0679\";\n}\n\n.mdi-calendar-range-outline::before {\n  content: \"\\F0B68\";\n}\n\n.mdi-calendar-refresh::before {\n  content: \"\\F01E1\";\n}\n\n.mdi-calendar-refresh-outline::before {\n  content: \"\\F0203\";\n}\n\n.mdi-calendar-remove::before {\n  content: \"\\F00F4\";\n}\n\n.mdi-calendar-remove-outline::before {\n  content: \"\\F0C45\";\n}\n\n.mdi-calendar-search::before {\n  content: \"\\F094C\";\n}\n\n.mdi-calendar-star::before {\n  content: \"\\F09D3\";\n}\n\n.mdi-calendar-start::before {\n  content: \"\\F166D\";\n}\n\n.mdi-calendar-sync::before {\n  content: \"\\F0E8E\";\n}\n\n.mdi-calendar-sync-outline::before {\n  content: \"\\F0E8F\";\n}\n\n.mdi-calendar-text::before {\n  content: \"\\F00F5\";\n}\n\n.mdi-calendar-text-outline::before {\n  content: \"\\F0C46\";\n}\n\n.mdi-calendar-today::before {\n  content: \"\\F00F6\";\n}\n\n.mdi-calendar-week::before {\n  content: \"\\F0A33\";\n}\n\n.mdi-calendar-week-begin::before {\n  content: \"\\F0A34\";\n}\n\n.mdi-calendar-weekend::before {\n  content: \"\\F0ED9\";\n}\n\n.mdi-calendar-weekend-outline::before {\n  content: \"\\F0EDA\";\n}\n\n.mdi-call-made::before {\n  content: \"\\F00F7\";\n}\n\n.mdi-call-merge::before {\n  content: \"\\F00F8\";\n}\n\n.mdi-call-missed::before {\n  content: \"\\F00F9\";\n}\n\n.mdi-call-received::before {\n  content: \"\\F00FA\";\n}\n\n.mdi-call-split::before {\n  content: \"\\F00FB\";\n}\n\n.mdi-camcorder::before {\n  content: \"\\F00FC\";\n}\n\n.mdi-camcorder-off::before {\n  content: \"\\F00FF\";\n}\n\n.mdi-camera::before {\n  content: \"\\F0100\";\n}\n\n.mdi-camera-account::before {\n  content: \"\\F08CB\";\n}\n\n.mdi-camera-burst::before {\n  content: \"\\F0693\";\n}\n\n.mdi-camera-control::before {\n  content: \"\\F0B69\";\n}\n\n.mdi-camera-document::before {\n  content: \"\\F1871\";\n}\n\n.mdi-camera-document-off::before {\n  content: \"\\F1872\";\n}\n\n.mdi-camera-enhance::before {\n  content: \"\\F0101\";\n}\n\n.mdi-camera-enhance-outline::before {\n  content: \"\\F0B6A\";\n}\n\n.mdi-camera-flip::before {\n  content: \"\\F15D9\";\n}\n\n.mdi-camera-flip-outline::before {\n  content: \"\\F15DA\";\n}\n\n.mdi-camera-front::before {\n  content: \"\\F0102\";\n}\n\n.mdi-camera-front-variant::before {\n  content: \"\\F0103\";\n}\n\n.mdi-camera-gopro::before {\n  content: \"\\F07A1\";\n}\n\n.mdi-camera-image::before {\n  content: \"\\F08CC\";\n}\n\n.mdi-camera-iris::before {\n  content: \"\\F0104\";\n}\n\n.mdi-camera-marker::before {\n  content: \"\\F19A7\";\n}\n\n.mdi-camera-marker-outline::before {\n  content: \"\\F19A8\";\n}\n\n.mdi-camera-metering-center::before {\n  content: \"\\F07A2\";\n}\n\n.mdi-camera-metering-matrix::before {\n  content: \"\\F07A3\";\n}\n\n.mdi-camera-metering-partial::before {\n  content: \"\\F07A4\";\n}\n\n.mdi-camera-metering-spot::before {\n  content: \"\\F07A5\";\n}\n\n.mdi-camera-off::before {\n  content: \"\\F05DF\";\n}\n\n.mdi-camera-off-outline::before {\n  content: \"\\F19BF\";\n}\n\n.mdi-camera-outline::before {\n  content: \"\\F0D5D\";\n}\n\n.mdi-camera-party-mode::before {\n  content: \"\\F0105\";\n}\n\n.mdi-camera-plus::before {\n  content: \"\\F0EDB\";\n}\n\n.mdi-camera-plus-outline::before {\n  content: \"\\F0EDC\";\n}\n\n.mdi-camera-rear::before {\n  content: \"\\F0106\";\n}\n\n.mdi-camera-rear-variant::before {\n  content: \"\\F0107\";\n}\n\n.mdi-camera-retake::before {\n  content: \"\\F0E19\";\n}\n\n.mdi-camera-retake-outline::before {\n  content: \"\\F0E1A\";\n}\n\n.mdi-camera-switch::before {\n  content: \"\\F0108\";\n}\n\n.mdi-camera-switch-outline::before {\n  content: \"\\F084A\";\n}\n\n.mdi-camera-timer::before {\n  content: \"\\F0109\";\n}\n\n.mdi-camera-wireless::before {\n  content: \"\\F0DB6\";\n}\n\n.mdi-camera-wireless-outline::before {\n  content: \"\\F0DB7\";\n}\n\n.mdi-campfire::before {\n  content: \"\\F0EDD\";\n}\n\n.mdi-cancel::before {\n  content: \"\\F073A\";\n}\n\n.mdi-candelabra::before {\n  content: \"\\F17D2\";\n}\n\n.mdi-candelabra-fire::before {\n  content: \"\\F17D3\";\n}\n\n.mdi-candle::before {\n  content: \"\\F05E2\";\n}\n\n.mdi-candy::before {\n  content: \"\\F1970\";\n}\n\n.mdi-candy-off::before {\n  content: \"\\F1971\";\n}\n\n.mdi-candy-off-outline::before {\n  content: \"\\F1972\";\n}\n\n.mdi-candy-outline::before {\n  content: \"\\F1973\";\n}\n\n.mdi-candycane::before {\n  content: \"\\F010A\";\n}\n\n.mdi-cannabis::before {\n  content: \"\\F07A6\";\n}\n\n.mdi-cannabis-off::before {\n  content: \"\\F166E\";\n}\n\n.mdi-caps-lock::before {\n  content: \"\\F0A9B\";\n}\n\n.mdi-car::before {\n  content: \"\\F010B\";\n}\n\n.mdi-car-2-plus::before {\n  content: \"\\F1015\";\n}\n\n.mdi-car-3-plus::before {\n  content: \"\\F1016\";\n}\n\n.mdi-car-arrow-left::before {\n  content: \"\\F13B2\";\n}\n\n.mdi-car-arrow-right::before {\n  content: \"\\F13B3\";\n}\n\n.mdi-car-back::before {\n  content: \"\\F0E1B\";\n}\n\n.mdi-car-battery::before {\n  content: \"\\F010C\";\n}\n\n.mdi-car-brake-abs::before {\n  content: \"\\F0C47\";\n}\n\n.mdi-car-brake-alert::before {\n  content: \"\\F0C48\";\n}\n\n.mdi-car-brake-fluid-level::before {\n  content: \"\\F1909\";\n}\n\n.mdi-car-brake-hold::before {\n  content: \"\\F0D5E\";\n}\n\n.mdi-car-brake-low-pressure::before {\n  content: \"\\F190A\";\n}\n\n.mdi-car-brake-parking::before {\n  content: \"\\F0D5F\";\n}\n\n.mdi-car-brake-retarder::before {\n  content: \"\\F1017\";\n}\n\n.mdi-car-brake-temperature::before {\n  content: \"\\F190B\";\n}\n\n.mdi-car-brake-worn-linings::before {\n  content: \"\\F190C\";\n}\n\n.mdi-car-child-seat::before {\n  content: \"\\F0FA3\";\n}\n\n.mdi-car-clock::before {\n  content: \"\\F1974\";\n}\n\n.mdi-car-clutch::before {\n  content: \"\\F1018\";\n}\n\n.mdi-car-cog::before {\n  content: \"\\F13CC\";\n}\n\n.mdi-car-connected::before {\n  content: \"\\F010D\";\n}\n\n.mdi-car-convertible::before {\n  content: \"\\F07A7\";\n}\n\n.mdi-car-coolant-level::before {\n  content: \"\\F1019\";\n}\n\n.mdi-car-cruise-control::before {\n  content: \"\\F0D60\";\n}\n\n.mdi-car-defrost-front::before {\n  content: \"\\F0D61\";\n}\n\n.mdi-car-defrost-rear::before {\n  content: \"\\F0D62\";\n}\n\n.mdi-car-door::before {\n  content: \"\\F0B6B\";\n}\n\n.mdi-car-door-lock::before {\n  content: \"\\F109D\";\n}\n\n.mdi-car-electric::before {\n  content: \"\\F0B6C\";\n}\n\n.mdi-car-electric-outline::before {\n  content: \"\\F15B5\";\n}\n\n.mdi-car-emergency::before {\n  content: \"\\F160F\";\n}\n\n.mdi-car-esp::before {\n  content: \"\\F0C49\";\n}\n\n.mdi-car-estate::before {\n  content: \"\\F07A8\";\n}\n\n.mdi-car-hatchback::before {\n  content: \"\\F07A9\";\n}\n\n.mdi-car-info::before {\n  content: \"\\F11BE\";\n}\n\n.mdi-car-key::before {\n  content: \"\\F0B6D\";\n}\n\n.mdi-car-lifted-pickup::before {\n  content: \"\\F152D\";\n}\n\n.mdi-car-light-alert::before {\n  content: \"\\F190D\";\n}\n\n.mdi-car-light-dimmed::before {\n  content: \"\\F0C4A\";\n}\n\n.mdi-car-light-fog::before {\n  content: \"\\F0C4B\";\n}\n\n.mdi-car-light-high::before {\n  content: \"\\F0C4C\";\n}\n\n.mdi-car-limousine::before {\n  content: \"\\F08CD\";\n}\n\n.mdi-car-multiple::before {\n  content: \"\\F0B6E\";\n}\n\n.mdi-car-off::before {\n  content: \"\\F0E1C\";\n}\n\n.mdi-car-outline::before {\n  content: \"\\F14ED\";\n}\n\n.mdi-car-parking-lights::before {\n  content: \"\\F0D63\";\n}\n\n.mdi-car-pickup::before {\n  content: \"\\F07AA\";\n}\n\n.mdi-car-seat::before {\n  content: \"\\F0FA4\";\n}\n\n.mdi-car-seat-cooler::before {\n  content: \"\\F0FA5\";\n}\n\n.mdi-car-seat-heater::before {\n  content: \"\\F0FA6\";\n}\n\n.mdi-car-select::before {\n  content: \"\\F1879\";\n}\n\n.mdi-car-settings::before {\n  content: \"\\F13CD\";\n}\n\n.mdi-car-shift-pattern::before {\n  content: \"\\F0F40\";\n}\n\n.mdi-car-side::before {\n  content: \"\\F07AB\";\n}\n\n.mdi-car-speed-limiter::before {\n  content: \"\\F190E\";\n}\n\n.mdi-car-sports::before {\n  content: \"\\F07AC\";\n}\n\n.mdi-car-tire-alert::before {\n  content: \"\\F0C4D\";\n}\n\n.mdi-car-traction-control::before {\n  content: \"\\F0D64\";\n}\n\n.mdi-car-turbocharger::before {\n  content: \"\\F101A\";\n}\n\n.mdi-car-wash::before {\n  content: \"\\F010E\";\n}\n\n.mdi-car-windshield::before {\n  content: \"\\F101B\";\n}\n\n.mdi-car-windshield-outline::before {\n  content: \"\\F101C\";\n}\n\n.mdi-car-wireless::before {\n  content: \"\\F1878\";\n}\n\n.mdi-car-wrench::before {\n  content: \"\\F1814\";\n}\n\n.mdi-carabiner::before {\n  content: \"\\F14C0\";\n}\n\n.mdi-caravan::before {\n  content: \"\\F07AD\";\n}\n\n.mdi-card::before {\n  content: \"\\F0B6F\";\n}\n\n.mdi-card-account-details::before {\n  content: \"\\F05D2\";\n}\n\n.mdi-card-account-details-outline::before {\n  content: \"\\F0DAB\";\n}\n\n.mdi-card-account-details-star::before {\n  content: \"\\F02A3\";\n}\n\n.mdi-card-account-details-star-outline::before {\n  content: \"\\F06DB\";\n}\n\n.mdi-card-account-mail::before {\n  content: \"\\F018E\";\n}\n\n.mdi-card-account-mail-outline::before {\n  content: \"\\F0E98\";\n}\n\n.mdi-card-account-phone::before {\n  content: \"\\F0E99\";\n}\n\n.mdi-card-account-phone-outline::before {\n  content: \"\\F0E9A\";\n}\n\n.mdi-card-bulleted::before {\n  content: \"\\F0B70\";\n}\n\n.mdi-card-bulleted-off::before {\n  content: \"\\F0B71\";\n}\n\n.mdi-card-bulleted-off-outline::before {\n  content: \"\\F0B72\";\n}\n\n.mdi-card-bulleted-outline::before {\n  content: \"\\F0B73\";\n}\n\n.mdi-card-bulleted-settings::before {\n  content: \"\\F0B74\";\n}\n\n.mdi-card-bulleted-settings-outline::before {\n  content: \"\\F0B75\";\n}\n\n.mdi-card-minus::before {\n  content: \"\\F1600\";\n}\n\n.mdi-card-minus-outline::before {\n  content: \"\\F1601\";\n}\n\n.mdi-card-multiple::before {\n  content: \"\\F17F1\";\n}\n\n.mdi-card-multiple-outline::before {\n  content: \"\\F17F2\";\n}\n\n.mdi-card-off::before {\n  content: \"\\F1602\";\n}\n\n.mdi-card-off-outline::before {\n  content: \"\\F1603\";\n}\n\n.mdi-card-outline::before {\n  content: \"\\F0B76\";\n}\n\n.mdi-card-plus::before {\n  content: \"\\F11FF\";\n}\n\n.mdi-card-plus-outline::before {\n  content: \"\\F1200\";\n}\n\n.mdi-card-remove::before {\n  content: \"\\F1604\";\n}\n\n.mdi-card-remove-outline::before {\n  content: \"\\F1605\";\n}\n\n.mdi-card-search::before {\n  content: \"\\F1074\";\n}\n\n.mdi-card-search-outline::before {\n  content: \"\\F1075\";\n}\n\n.mdi-card-text::before {\n  content: \"\\F0B77\";\n}\n\n.mdi-card-text-outline::before {\n  content: \"\\F0B78\";\n}\n\n.mdi-cards::before {\n  content: \"\\F0638\";\n}\n\n.mdi-cards-club::before {\n  content: \"\\F08CE\";\n}\n\n.mdi-cards-club-outline::before {\n  content: \"\\F189F\";\n}\n\n.mdi-cards-diamond::before {\n  content: \"\\F08CF\";\n}\n\n.mdi-cards-diamond-outline::before {\n  content: \"\\F101D\";\n}\n\n.mdi-cards-heart::before {\n  content: \"\\F08D0\";\n}\n\n.mdi-cards-heart-outline::before {\n  content: \"\\F18A0\";\n}\n\n.mdi-cards-outline::before {\n  content: \"\\F0639\";\n}\n\n.mdi-cards-playing::before {\n  content: \"\\F18A1\";\n}\n\n.mdi-cards-playing-club::before {\n  content: \"\\F18A2\";\n}\n\n.mdi-cards-playing-club-multiple::before {\n  content: \"\\F18A3\";\n}\n\n.mdi-cards-playing-club-multiple-outline::before {\n  content: \"\\F18A4\";\n}\n\n.mdi-cards-playing-club-outline::before {\n  content: \"\\F18A5\";\n}\n\n.mdi-cards-playing-diamond::before {\n  content: \"\\F18A6\";\n}\n\n.mdi-cards-playing-diamond-multiple::before {\n  content: \"\\F18A7\";\n}\n\n.mdi-cards-playing-diamond-multiple-outline::before {\n  content: \"\\F18A8\";\n}\n\n.mdi-cards-playing-diamond-outline::before {\n  content: \"\\F18A9\";\n}\n\n.mdi-cards-playing-heart::before {\n  content: \"\\F18AA\";\n}\n\n.mdi-cards-playing-heart-multiple::before {\n  content: \"\\F18AB\";\n}\n\n.mdi-cards-playing-heart-multiple-outline::before {\n  content: \"\\F18AC\";\n}\n\n.mdi-cards-playing-heart-outline::before {\n  content: \"\\F18AD\";\n}\n\n.mdi-cards-playing-outline::before {\n  content: \"\\F063A\";\n}\n\n.mdi-cards-playing-spade::before {\n  content: \"\\F18AE\";\n}\n\n.mdi-cards-playing-spade-multiple::before {\n  content: \"\\F18AF\";\n}\n\n.mdi-cards-playing-spade-multiple-outline::before {\n  content: \"\\F18B0\";\n}\n\n.mdi-cards-playing-spade-outline::before {\n  content: \"\\F18B1\";\n}\n\n.mdi-cards-spade::before {\n  content: \"\\F08D1\";\n}\n\n.mdi-cards-spade-outline::before {\n  content: \"\\F18B2\";\n}\n\n.mdi-cards-variant::before {\n  content: \"\\F06C7\";\n}\n\n.mdi-carrot::before {\n  content: \"\\F010F\";\n}\n\n.mdi-cart::before {\n  content: \"\\F0110\";\n}\n\n.mdi-cart-arrow-down::before {\n  content: \"\\F0D66\";\n}\n\n.mdi-cart-arrow-right::before {\n  content: \"\\F0C4E\";\n}\n\n.mdi-cart-arrow-up::before {\n  content: \"\\F0D67\";\n}\n\n.mdi-cart-check::before {\n  content: \"\\F15EA\";\n}\n\n.mdi-cart-heart::before {\n  content: \"\\F18E0\";\n}\n\n.mdi-cart-minus::before {\n  content: \"\\F0D68\";\n}\n\n.mdi-cart-off::before {\n  content: \"\\F066B\";\n}\n\n.mdi-cart-outline::before {\n  content: \"\\F0111\";\n}\n\n.mdi-cart-plus::before {\n  content: \"\\F0112\";\n}\n\n.mdi-cart-remove::before {\n  content: \"\\F0D69\";\n}\n\n.mdi-cart-variant::before {\n  content: \"\\F15EB\";\n}\n\n.mdi-case-sensitive-alt::before {\n  content: \"\\F0113\";\n}\n\n.mdi-cash::before {\n  content: \"\\F0114\";\n}\n\n.mdi-cash-100::before {\n  content: \"\\F0115\";\n}\n\n.mdi-cash-check::before {\n  content: \"\\F14EE\";\n}\n\n.mdi-cash-fast::before {\n  content: \"\\F185C\";\n}\n\n.mdi-cash-lock::before {\n  content: \"\\F14EA\";\n}\n\n.mdi-cash-lock-open::before {\n  content: \"\\F14EB\";\n}\n\n.mdi-cash-marker::before {\n  content: \"\\F0DB8\";\n}\n\n.mdi-cash-minus::before {\n  content: \"\\F1260\";\n}\n\n.mdi-cash-multiple::before {\n  content: \"\\F0116\";\n}\n\n.mdi-cash-plus::before {\n  content: \"\\F1261\";\n}\n\n.mdi-cash-refund::before {\n  content: \"\\F0A9C\";\n}\n\n.mdi-cash-register::before {\n  content: \"\\F0CF4\";\n}\n\n.mdi-cash-remove::before {\n  content: \"\\F1262\";\n}\n\n.mdi-cassette::before {\n  content: \"\\F09D4\";\n}\n\n.mdi-cast::before {\n  content: \"\\F0118\";\n}\n\n.mdi-cast-audio::before {\n  content: \"\\F101E\";\n}\n\n.mdi-cast-audio-variant::before {\n  content: \"\\F1749\";\n}\n\n.mdi-cast-connected::before {\n  content: \"\\F0119\";\n}\n\n.mdi-cast-education::before {\n  content: \"\\F0E1D\";\n}\n\n.mdi-cast-off::before {\n  content: \"\\F078A\";\n}\n\n.mdi-cast-variant::before {\n  content: \"\\F001F\";\n}\n\n.mdi-castle::before {\n  content: \"\\F011A\";\n}\n\n.mdi-cat::before {\n  content: \"\\F011B\";\n}\n\n.mdi-cctv::before {\n  content: \"\\F07AE\";\n}\n\n.mdi-cctv-off::before {\n  content: \"\\F185F\";\n}\n\n.mdi-ceiling-fan::before {\n  content: \"\\F1797\";\n}\n\n.mdi-ceiling-fan-light::before {\n  content: \"\\F1798\";\n}\n\n.mdi-ceiling-light::before {\n  content: \"\\F0769\";\n}\n\n.mdi-ceiling-light-multiple::before {\n  content: \"\\F18DD\";\n}\n\n.mdi-ceiling-light-multiple-outline::before {\n  content: \"\\F18DE\";\n}\n\n.mdi-ceiling-light-outline::before {\n  content: \"\\F17C7\";\n}\n\n.mdi-cellphone::before {\n  content: \"\\F011C\";\n}\n\n.mdi-cellphone-arrow-down::before {\n  content: \"\\F09D5\";\n}\n\n.mdi-cellphone-basic::before {\n  content: \"\\F011E\";\n}\n\n.mdi-cellphone-charging::before {\n  content: \"\\F1397\";\n}\n\n.mdi-cellphone-check::before {\n  content: \"\\F17FD\";\n}\n\n.mdi-cellphone-cog::before {\n  content: \"\\F0951\";\n}\n\n.mdi-cellphone-dock::before {\n  content: \"\\F011F\";\n}\n\n.mdi-cellphone-information::before {\n  content: \"\\F0F41\";\n}\n\n.mdi-cellphone-key::before {\n  content: \"\\F094E\";\n}\n\n.mdi-cellphone-link::before {\n  content: \"\\F0121\";\n}\n\n.mdi-cellphone-link-off::before {\n  content: \"\\F0122\";\n}\n\n.mdi-cellphone-lock::before {\n  content: \"\\F094F\";\n}\n\n.mdi-cellphone-marker::before {\n  content: \"\\F183A\";\n}\n\n.mdi-cellphone-message::before {\n  content: \"\\F08D3\";\n}\n\n.mdi-cellphone-message-off::before {\n  content: \"\\F10D2\";\n}\n\n.mdi-cellphone-nfc::before {\n  content: \"\\F0E90\";\n}\n\n.mdi-cellphone-nfc-off::before {\n  content: \"\\F12D8\";\n}\n\n.mdi-cellphone-off::before {\n  content: \"\\F0950\";\n}\n\n.mdi-cellphone-play::before {\n  content: \"\\F101F\";\n}\n\n.mdi-cellphone-remove::before {\n  content: \"\\F094D\";\n}\n\n.mdi-cellphone-screenshot::before {\n  content: \"\\F0A35\";\n}\n\n.mdi-cellphone-settings::before {\n  content: \"\\F0123\";\n}\n\n.mdi-cellphone-sound::before {\n  content: \"\\F0952\";\n}\n\n.mdi-cellphone-text::before {\n  content: \"\\F08D2\";\n}\n\n.mdi-cellphone-wireless::before {\n  content: \"\\F0815\";\n}\n\n.mdi-centos::before {\n  content: \"\\F111A\";\n}\n\n.mdi-certificate::before {\n  content: \"\\F0124\";\n}\n\n.mdi-certificate-outline::before {\n  content: \"\\F1188\";\n}\n\n.mdi-chair-rolling::before {\n  content: \"\\F0F48\";\n}\n\n.mdi-chair-school::before {\n  content: \"\\F0125\";\n}\n\n.mdi-chandelier::before {\n  content: \"\\F1793\";\n}\n\n.mdi-charity::before {\n  content: \"\\F0C4F\";\n}\n\n.mdi-chart-arc::before {\n  content: \"\\F0126\";\n}\n\n.mdi-chart-areaspline::before {\n  content: \"\\F0127\";\n}\n\n.mdi-chart-areaspline-variant::before {\n  content: \"\\F0E91\";\n}\n\n.mdi-chart-bar::before {\n  content: \"\\F0128\";\n}\n\n.mdi-chart-bar-stacked::before {\n  content: \"\\F076A\";\n}\n\n.mdi-chart-bell-curve::before {\n  content: \"\\F0C50\";\n}\n\n.mdi-chart-bell-curve-cumulative::before {\n  content: \"\\F0FA7\";\n}\n\n.mdi-chart-box::before {\n  content: \"\\F154D\";\n}\n\n.mdi-chart-box-outline::before {\n  content: \"\\F154E\";\n}\n\n.mdi-chart-box-plus-outline::before {\n  content: \"\\F154F\";\n}\n\n.mdi-chart-bubble::before {\n  content: \"\\F05E3\";\n}\n\n.mdi-chart-donut::before {\n  content: \"\\F07AF\";\n}\n\n.mdi-chart-donut-variant::before {\n  content: \"\\F07B0\";\n}\n\n.mdi-chart-gantt::before {\n  content: \"\\F066C\";\n}\n\n.mdi-chart-histogram::before {\n  content: \"\\F0129\";\n}\n\n.mdi-chart-line::before {\n  content: \"\\F012A\";\n}\n\n.mdi-chart-line-stacked::before {\n  content: \"\\F076B\";\n}\n\n.mdi-chart-line-variant::before {\n  content: \"\\F07B1\";\n}\n\n.mdi-chart-multiline::before {\n  content: \"\\F08D4\";\n}\n\n.mdi-chart-multiple::before {\n  content: \"\\F1213\";\n}\n\n.mdi-chart-pie::before {\n  content: \"\\F012B\";\n}\n\n.mdi-chart-ppf::before {\n  content: \"\\F1380\";\n}\n\n.mdi-chart-sankey::before {\n  content: \"\\F11DF\";\n}\n\n.mdi-chart-sankey-variant::before {\n  content: \"\\F11E0\";\n}\n\n.mdi-chart-scatter-plot::before {\n  content: \"\\F0E92\";\n}\n\n.mdi-chart-scatter-plot-hexbin::before {\n  content: \"\\F066D\";\n}\n\n.mdi-chart-timeline::before {\n  content: \"\\F066E\";\n}\n\n.mdi-chart-timeline-variant::before {\n  content: \"\\F0E93\";\n}\n\n.mdi-chart-timeline-variant-shimmer::before {\n  content: \"\\F15B6\";\n}\n\n.mdi-chart-tree::before {\n  content: \"\\F0E94\";\n}\n\n.mdi-chart-waterfall::before {\n  content: \"\\F1918\";\n}\n\n.mdi-chat::before {\n  content: \"\\F0B79\";\n}\n\n.mdi-chat-alert::before {\n  content: \"\\F0B7A\";\n}\n\n.mdi-chat-alert-outline::before {\n  content: \"\\F12C9\";\n}\n\n.mdi-chat-minus::before {\n  content: \"\\F1410\";\n}\n\n.mdi-chat-minus-outline::before {\n  content: \"\\F1413\";\n}\n\n.mdi-chat-outline::before {\n  content: \"\\F0EDE\";\n}\n\n.mdi-chat-plus::before {\n  content: \"\\F140F\";\n}\n\n.mdi-chat-plus-outline::before {\n  content: \"\\F1412\";\n}\n\n.mdi-chat-processing::before {\n  content: \"\\F0B7B\";\n}\n\n.mdi-chat-processing-outline::before {\n  content: \"\\F12CA\";\n}\n\n.mdi-chat-question::before {\n  content: \"\\F1738\";\n}\n\n.mdi-chat-question-outline::before {\n  content: \"\\F1739\";\n}\n\n.mdi-chat-remove::before {\n  content: \"\\F1411\";\n}\n\n.mdi-chat-remove-outline::before {\n  content: \"\\F1414\";\n}\n\n.mdi-chat-sleep::before {\n  content: \"\\F12D1\";\n}\n\n.mdi-chat-sleep-outline::before {\n  content: \"\\F12D2\";\n}\n\n.mdi-check::before {\n  content: \"\\F012C\";\n}\n\n.mdi-check-all::before {\n  content: \"\\F012D\";\n}\n\n.mdi-check-bold::before {\n  content: \"\\F0E1E\";\n}\n\n.mdi-check-circle::before {\n  content: \"\\F05E0\";\n}\n\n.mdi-check-circle-outline::before {\n  content: \"\\F05E1\";\n}\n\n.mdi-check-decagram::before {\n  content: \"\\F0791\";\n}\n\n.mdi-check-decagram-outline::before {\n  content: \"\\F1740\";\n}\n\n.mdi-check-network::before {\n  content: \"\\F0C53\";\n}\n\n.mdi-check-network-outline::before {\n  content: \"\\F0C54\";\n}\n\n.mdi-check-outline::before {\n  content: \"\\F0855\";\n}\n\n.mdi-check-underline::before {\n  content: \"\\F0E1F\";\n}\n\n.mdi-check-underline-circle::before {\n  content: \"\\F0E20\";\n}\n\n.mdi-check-underline-circle-outline::before {\n  content: \"\\F0E21\";\n}\n\n.mdi-checkbook::before {\n  content: \"\\F0A9D\";\n}\n\n.mdi-checkbox-blank::before {\n  content: \"\\F012E\";\n}\n\n.mdi-checkbox-blank-badge::before {\n  content: \"\\F1176\";\n}\n\n.mdi-checkbox-blank-badge-outline::before {\n  content: \"\\F0117\";\n}\n\n.mdi-checkbox-blank-circle::before {\n  content: \"\\F012F\";\n}\n\n.mdi-checkbox-blank-circle-outline::before {\n  content: \"\\F0130\";\n}\n\n.mdi-checkbox-blank-off::before {\n  content: \"\\F12EC\";\n}\n\n.mdi-checkbox-blank-off-outline::before {\n  content: \"\\F12ED\";\n}\n\n.mdi-checkbox-blank-outline::before {\n  content: \"\\F0131\";\n}\n\n.mdi-checkbox-intermediate::before {\n  content: \"\\F0856\";\n}\n\n.mdi-checkbox-marked::before {\n  content: \"\\F0132\";\n}\n\n.mdi-checkbox-marked-circle::before {\n  content: \"\\F0133\";\n}\n\n.mdi-checkbox-marked-circle-outline::before {\n  content: \"\\F0134\";\n}\n\n.mdi-checkbox-marked-circle-plus-outline::before {\n  content: \"\\F1927\";\n}\n\n.mdi-checkbox-marked-outline::before {\n  content: \"\\F0135\";\n}\n\n.mdi-checkbox-multiple-blank::before {\n  content: \"\\F0136\";\n}\n\n.mdi-checkbox-multiple-blank-circle::before {\n  content: \"\\F063B\";\n}\n\n.mdi-checkbox-multiple-blank-circle-outline::before {\n  content: \"\\F063C\";\n}\n\n.mdi-checkbox-multiple-blank-outline::before {\n  content: \"\\F0137\";\n}\n\n.mdi-checkbox-multiple-marked::before {\n  content: \"\\F0138\";\n}\n\n.mdi-checkbox-multiple-marked-circle::before {\n  content: \"\\F063D\";\n}\n\n.mdi-checkbox-multiple-marked-circle-outline::before {\n  content: \"\\F063E\";\n}\n\n.mdi-checkbox-multiple-marked-outline::before {\n  content: \"\\F0139\";\n}\n\n.mdi-checkbox-multiple-outline::before {\n  content: \"\\F0C51\";\n}\n\n.mdi-checkbox-outline::before {\n  content: \"\\F0C52\";\n}\n\n.mdi-checkerboard::before {\n  content: \"\\F013A\";\n}\n\n.mdi-checkerboard-minus::before {\n  content: \"\\F1202\";\n}\n\n.mdi-checkerboard-plus::before {\n  content: \"\\F1201\";\n}\n\n.mdi-checkerboard-remove::before {\n  content: \"\\F1203\";\n}\n\n.mdi-cheese::before {\n  content: \"\\F12B9\";\n}\n\n.mdi-cheese-off::before {\n  content: \"\\F13EE\";\n}\n\n.mdi-chef-hat::before {\n  content: \"\\F0B7C\";\n}\n\n.mdi-chemical-weapon::before {\n  content: \"\\F013B\";\n}\n\n.mdi-chess-bishop::before {\n  content: \"\\F085C\";\n}\n\n.mdi-chess-king::before {\n  content: \"\\F0857\";\n}\n\n.mdi-chess-knight::before {\n  content: \"\\F0858\";\n}\n\n.mdi-chess-pawn::before {\n  content: \"\\F0859\";\n}\n\n.mdi-chess-queen::before {\n  content: \"\\F085A\";\n}\n\n.mdi-chess-rook::before {\n  content: \"\\F085B\";\n}\n\n.mdi-chevron-double-down::before {\n  content: \"\\F013C\";\n}\n\n.mdi-chevron-double-left::before {\n  content: \"\\F013D\";\n}\n\n.mdi-chevron-double-right::before {\n  content: \"\\F013E\";\n}\n\n.mdi-chevron-double-up::before {\n  content: \"\\F013F\";\n}\n\n.mdi-chevron-down::before {\n  content: \"\\F0140\";\n}\n\n.mdi-chevron-down-box::before {\n  content: \"\\F09D6\";\n}\n\n.mdi-chevron-down-box-outline::before {\n  content: \"\\F09D7\";\n}\n\n.mdi-chevron-down-circle::before {\n  content: \"\\F0B26\";\n}\n\n.mdi-chevron-down-circle-outline::before {\n  content: \"\\F0B27\";\n}\n\n.mdi-chevron-left::before {\n  content: \"\\F0141\";\n}\n\n.mdi-chevron-left-box::before {\n  content: \"\\F09D8\";\n}\n\n.mdi-chevron-left-box-outline::before {\n  content: \"\\F09D9\";\n}\n\n.mdi-chevron-left-circle::before {\n  content: \"\\F0B28\";\n}\n\n.mdi-chevron-left-circle-outline::before {\n  content: \"\\F0B29\";\n}\n\n.mdi-chevron-right::before {\n  content: \"\\F0142\";\n}\n\n.mdi-chevron-right-box::before {\n  content: \"\\F09DA\";\n}\n\n.mdi-chevron-right-box-outline::before {\n  content: \"\\F09DB\";\n}\n\n.mdi-chevron-right-circle::before {\n  content: \"\\F0B2A\";\n}\n\n.mdi-chevron-right-circle-outline::before {\n  content: \"\\F0B2B\";\n}\n\n.mdi-chevron-triple-down::before {\n  content: \"\\F0DB9\";\n}\n\n.mdi-chevron-triple-left::before {\n  content: \"\\F0DBA\";\n}\n\n.mdi-chevron-triple-right::before {\n  content: \"\\F0DBB\";\n}\n\n.mdi-chevron-triple-up::before {\n  content: \"\\F0DBC\";\n}\n\n.mdi-chevron-up::before {\n  content: \"\\F0143\";\n}\n\n.mdi-chevron-up-box::before {\n  content: \"\\F09DC\";\n}\n\n.mdi-chevron-up-box-outline::before {\n  content: \"\\F09DD\";\n}\n\n.mdi-chevron-up-circle::before {\n  content: \"\\F0B2C\";\n}\n\n.mdi-chevron-up-circle-outline::before {\n  content: \"\\F0B2D\";\n}\n\n.mdi-chili-alert::before {\n  content: \"\\F17EA\";\n}\n\n.mdi-chili-alert-outline::before {\n  content: \"\\F17EB\";\n}\n\n.mdi-chili-hot::before {\n  content: \"\\F07B2\";\n}\n\n.mdi-chili-hot-outline::before {\n  content: \"\\F17EC\";\n}\n\n.mdi-chili-medium::before {\n  content: \"\\F07B3\";\n}\n\n.mdi-chili-medium-outline::before {\n  content: \"\\F17ED\";\n}\n\n.mdi-chili-mild::before {\n  content: \"\\F07B4\";\n}\n\n.mdi-chili-mild-outline::before {\n  content: \"\\F17EE\";\n}\n\n.mdi-chili-off::before {\n  content: \"\\F1467\";\n}\n\n.mdi-chili-off-outline::before {\n  content: \"\\F17EF\";\n}\n\n.mdi-chip::before {\n  content: \"\\F061A\";\n}\n\n.mdi-church::before {\n  content: \"\\F0144\";\n}\n\n.mdi-cigar::before {\n  content: \"\\F1189\";\n}\n\n.mdi-cigar-off::before {\n  content: \"\\F141B\";\n}\n\n.mdi-circle::before {\n  content: \"\\F0765\";\n}\n\n.mdi-circle-box::before {\n  content: \"\\F15DC\";\n}\n\n.mdi-circle-box-outline::before {\n  content: \"\\F15DD\";\n}\n\n.mdi-circle-double::before {\n  content: \"\\F0E95\";\n}\n\n.mdi-circle-edit-outline::before {\n  content: \"\\F08D5\";\n}\n\n.mdi-circle-expand::before {\n  content: \"\\F0E96\";\n}\n\n.mdi-circle-half::before {\n  content: \"\\F1395\";\n}\n\n.mdi-circle-half-full::before {\n  content: \"\\F1396\";\n}\n\n.mdi-circle-medium::before {\n  content: \"\\F09DE\";\n}\n\n.mdi-circle-multiple::before {\n  content: \"\\F0B38\";\n}\n\n.mdi-circle-multiple-outline::before {\n  content: \"\\F0695\";\n}\n\n.mdi-circle-off-outline::before {\n  content: \"\\F10D3\";\n}\n\n.mdi-circle-opacity::before {\n  content: \"\\F1853\";\n}\n\n.mdi-circle-outline::before {\n  content: \"\\F0766\";\n}\n\n.mdi-circle-slice-1::before {\n  content: \"\\F0A9E\";\n}\n\n.mdi-circle-slice-2::before {\n  content: \"\\F0A9F\";\n}\n\n.mdi-circle-slice-3::before {\n  content: \"\\F0AA0\";\n}\n\n.mdi-circle-slice-4::before {\n  content: \"\\F0AA1\";\n}\n\n.mdi-circle-slice-5::before {\n  content: \"\\F0AA2\";\n}\n\n.mdi-circle-slice-6::before {\n  content: \"\\F0AA3\";\n}\n\n.mdi-circle-slice-7::before {\n  content: \"\\F0AA4\";\n}\n\n.mdi-circle-slice-8::before {\n  content: \"\\F0AA5\";\n}\n\n.mdi-circle-small::before {\n  content: \"\\F09DF\";\n}\n\n.mdi-circular-saw::before {\n  content: \"\\F0E22\";\n}\n\n.mdi-city::before {\n  content: \"\\F0146\";\n}\n\n.mdi-city-variant::before {\n  content: \"\\F0A36\";\n}\n\n.mdi-city-variant-outline::before {\n  content: \"\\F0A37\";\n}\n\n.mdi-clipboard::before {\n  content: \"\\F0147\";\n}\n\n.mdi-clipboard-account::before {\n  content: \"\\F0148\";\n}\n\n.mdi-clipboard-account-outline::before {\n  content: \"\\F0C55\";\n}\n\n.mdi-clipboard-alert::before {\n  content: \"\\F0149\";\n}\n\n.mdi-clipboard-alert-outline::before {\n  content: \"\\F0CF7\";\n}\n\n.mdi-clipboard-arrow-down::before {\n  content: \"\\F014A\";\n}\n\n.mdi-clipboard-arrow-down-outline::before {\n  content: \"\\F0C56\";\n}\n\n.mdi-clipboard-arrow-left::before {\n  content: \"\\F014B\";\n}\n\n.mdi-clipboard-arrow-left-outline::before {\n  content: \"\\F0CF8\";\n}\n\n.mdi-clipboard-arrow-right::before {\n  content: \"\\F0CF9\";\n}\n\n.mdi-clipboard-arrow-right-outline::before {\n  content: \"\\F0CFA\";\n}\n\n.mdi-clipboard-arrow-up::before {\n  content: \"\\F0C57\";\n}\n\n.mdi-clipboard-arrow-up-outline::before {\n  content: \"\\F0C58\";\n}\n\n.mdi-clipboard-check::before {\n  content: \"\\F014E\";\n}\n\n.mdi-clipboard-check-multiple::before {\n  content: \"\\F1263\";\n}\n\n.mdi-clipboard-check-multiple-outline::before {\n  content: \"\\F1264\";\n}\n\n.mdi-clipboard-check-outline::before {\n  content: \"\\F08A8\";\n}\n\n.mdi-clipboard-clock::before {\n  content: \"\\F16E2\";\n}\n\n.mdi-clipboard-clock-outline::before {\n  content: \"\\F16E3\";\n}\n\n.mdi-clipboard-edit::before {\n  content: \"\\F14E5\";\n}\n\n.mdi-clipboard-edit-outline::before {\n  content: \"\\F14E6\";\n}\n\n.mdi-clipboard-file::before {\n  content: \"\\F1265\";\n}\n\n.mdi-clipboard-file-outline::before {\n  content: \"\\F1266\";\n}\n\n.mdi-clipboard-flow::before {\n  content: \"\\F06C8\";\n}\n\n.mdi-clipboard-flow-outline::before {\n  content: \"\\F1117\";\n}\n\n.mdi-clipboard-list::before {\n  content: \"\\F10D4\";\n}\n\n.mdi-clipboard-list-outline::before {\n  content: \"\\F10D5\";\n}\n\n.mdi-clipboard-minus::before {\n  content: \"\\F1618\";\n}\n\n.mdi-clipboard-minus-outline::before {\n  content: \"\\F1619\";\n}\n\n.mdi-clipboard-multiple::before {\n  content: \"\\F1267\";\n}\n\n.mdi-clipboard-multiple-outline::before {\n  content: \"\\F1268\";\n}\n\n.mdi-clipboard-off::before {\n  content: \"\\F161A\";\n}\n\n.mdi-clipboard-off-outline::before {\n  content: \"\\F161B\";\n}\n\n.mdi-clipboard-outline::before {\n  content: \"\\F014C\";\n}\n\n.mdi-clipboard-play::before {\n  content: \"\\F0C59\";\n}\n\n.mdi-clipboard-play-multiple::before {\n  content: \"\\F1269\";\n}\n\n.mdi-clipboard-play-multiple-outline::before {\n  content: \"\\F126A\";\n}\n\n.mdi-clipboard-play-outline::before {\n  content: \"\\F0C5A\";\n}\n\n.mdi-clipboard-plus::before {\n  content: \"\\F0751\";\n}\n\n.mdi-clipboard-plus-outline::before {\n  content: \"\\F131F\";\n}\n\n.mdi-clipboard-pulse::before {\n  content: \"\\F085D\";\n}\n\n.mdi-clipboard-pulse-outline::before {\n  content: \"\\F085E\";\n}\n\n.mdi-clipboard-remove::before {\n  content: \"\\F161C\";\n}\n\n.mdi-clipboard-remove-outline::before {\n  content: \"\\F161D\";\n}\n\n.mdi-clipboard-search::before {\n  content: \"\\F161E\";\n}\n\n.mdi-clipboard-search-outline::before {\n  content: \"\\F161F\";\n}\n\n.mdi-clipboard-text::before {\n  content: \"\\F014D\";\n}\n\n.mdi-clipboard-text-clock::before {\n  content: \"\\F18F9\";\n}\n\n.mdi-clipboard-text-clock-outline::before {\n  content: \"\\F18FA\";\n}\n\n.mdi-clipboard-text-multiple::before {\n  content: \"\\F126B\";\n}\n\n.mdi-clipboard-text-multiple-outline::before {\n  content: \"\\F126C\";\n}\n\n.mdi-clipboard-text-off::before {\n  content: \"\\F1620\";\n}\n\n.mdi-clipboard-text-off-outline::before {\n  content: \"\\F1621\";\n}\n\n.mdi-clipboard-text-outline::before {\n  content: \"\\F0A38\";\n}\n\n.mdi-clipboard-text-play::before {\n  content: \"\\F0C5B\";\n}\n\n.mdi-clipboard-text-play-outline::before {\n  content: \"\\F0C5C\";\n}\n\n.mdi-clipboard-text-search::before {\n  content: \"\\F1622\";\n}\n\n.mdi-clipboard-text-search-outline::before {\n  content: \"\\F1623\";\n}\n\n.mdi-clippy::before {\n  content: \"\\F014F\";\n}\n\n.mdi-clock::before {\n  content: \"\\F0954\";\n}\n\n.mdi-clock-alert::before {\n  content: \"\\F0955\";\n}\n\n.mdi-clock-alert-outline::before {\n  content: \"\\F05CE\";\n}\n\n.mdi-clock-check::before {\n  content: \"\\F0FA8\";\n}\n\n.mdi-clock-check-outline::before {\n  content: \"\\F0FA9\";\n}\n\n.mdi-clock-digital::before {\n  content: \"\\F0E97\";\n}\n\n.mdi-clock-edit::before {\n  content: \"\\F19BA\";\n}\n\n.mdi-clock-edit-outline::before {\n  content: \"\\F19BB\";\n}\n\n.mdi-clock-end::before {\n  content: \"\\F0151\";\n}\n\n.mdi-clock-fast::before {\n  content: \"\\F0152\";\n}\n\n.mdi-clock-in::before {\n  content: \"\\F0153\";\n}\n\n.mdi-clock-minus::before {\n  content: \"\\F1863\";\n}\n\n.mdi-clock-minus-outline::before {\n  content: \"\\F1864\";\n}\n\n.mdi-clock-out::before {\n  content: \"\\F0154\";\n}\n\n.mdi-clock-outline::before {\n  content: \"\\F0150\";\n}\n\n.mdi-clock-plus::before {\n  content: \"\\F1861\";\n}\n\n.mdi-clock-plus-outline::before {\n  content: \"\\F1862\";\n}\n\n.mdi-clock-remove::before {\n  content: \"\\F1865\";\n}\n\n.mdi-clock-remove-outline::before {\n  content: \"\\F1866\";\n}\n\n.mdi-clock-start::before {\n  content: \"\\F0155\";\n}\n\n.mdi-clock-time-eight::before {\n  content: \"\\F1446\";\n}\n\n.mdi-clock-time-eight-outline::before {\n  content: \"\\F1452\";\n}\n\n.mdi-clock-time-eleven::before {\n  content: \"\\F1449\";\n}\n\n.mdi-clock-time-eleven-outline::before {\n  content: \"\\F1455\";\n}\n\n.mdi-clock-time-five::before {\n  content: \"\\F1443\";\n}\n\n.mdi-clock-time-five-outline::before {\n  content: \"\\F144F\";\n}\n\n.mdi-clock-time-four::before {\n  content: \"\\F1442\";\n}\n\n.mdi-clock-time-four-outline::before {\n  content: \"\\F144E\";\n}\n\n.mdi-clock-time-nine::before {\n  content: \"\\F1447\";\n}\n\n.mdi-clock-time-nine-outline::before {\n  content: \"\\F1453\";\n}\n\n.mdi-clock-time-one::before {\n  content: \"\\F143F\";\n}\n\n.mdi-clock-time-one-outline::before {\n  content: \"\\F144B\";\n}\n\n.mdi-clock-time-seven::before {\n  content: \"\\F1445\";\n}\n\n.mdi-clock-time-seven-outline::before {\n  content: \"\\F1451\";\n}\n\n.mdi-clock-time-six::before {\n  content: \"\\F1444\";\n}\n\n.mdi-clock-time-six-outline::before {\n  content: \"\\F1450\";\n}\n\n.mdi-clock-time-ten::before {\n  content: \"\\F1448\";\n}\n\n.mdi-clock-time-ten-outline::before {\n  content: \"\\F1454\";\n}\n\n.mdi-clock-time-three::before {\n  content: \"\\F1441\";\n}\n\n.mdi-clock-time-three-outline::before {\n  content: \"\\F144D\";\n}\n\n.mdi-clock-time-twelve::before {\n  content: \"\\F144A\";\n}\n\n.mdi-clock-time-twelve-outline::before {\n  content: \"\\F1456\";\n}\n\n.mdi-clock-time-two::before {\n  content: \"\\F1440\";\n}\n\n.mdi-clock-time-two-outline::before {\n  content: \"\\F144C\";\n}\n\n.mdi-close::before {\n  content: \"\\F0156\";\n}\n\n.mdi-close-box::before {\n  content: \"\\F0157\";\n}\n\n.mdi-close-box-multiple::before {\n  content: \"\\F0C5D\";\n}\n\n.mdi-close-box-multiple-outline::before {\n  content: \"\\F0C5E\";\n}\n\n.mdi-close-box-outline::before {\n  content: \"\\F0158\";\n}\n\n.mdi-close-circle::before {\n  content: \"\\F0159\";\n}\n\n.mdi-close-circle-multiple::before {\n  content: \"\\F062A\";\n}\n\n.mdi-close-circle-multiple-outline::before {\n  content: \"\\F0883\";\n}\n\n.mdi-close-circle-outline::before {\n  content: \"\\F015A\";\n}\n\n.mdi-close-network::before {\n  content: \"\\F015B\";\n}\n\n.mdi-close-network-outline::before {\n  content: \"\\F0C5F\";\n}\n\n.mdi-close-octagon::before {\n  content: \"\\F015C\";\n}\n\n.mdi-close-octagon-outline::before {\n  content: \"\\F015D\";\n}\n\n.mdi-close-outline::before {\n  content: \"\\F06C9\";\n}\n\n.mdi-close-thick::before {\n  content: \"\\F1398\";\n}\n\n.mdi-closed-caption::before {\n  content: \"\\F015E\";\n}\n\n.mdi-closed-caption-outline::before {\n  content: \"\\F0DBD\";\n}\n\n.mdi-cloud::before {\n  content: \"\\F015F\";\n}\n\n.mdi-cloud-alert::before {\n  content: \"\\F09E0\";\n}\n\n.mdi-cloud-braces::before {\n  content: \"\\F07B5\";\n}\n\n.mdi-cloud-check::before {\n  content: \"\\F0160\";\n}\n\n.mdi-cloud-check-outline::before {\n  content: \"\\F12CC\";\n}\n\n.mdi-cloud-circle::before {\n  content: \"\\F0161\";\n}\n\n.mdi-cloud-download::before {\n  content: \"\\F0162\";\n}\n\n.mdi-cloud-download-outline::before {\n  content: \"\\F0B7D\";\n}\n\n.mdi-cloud-lock::before {\n  content: \"\\F11F1\";\n}\n\n.mdi-cloud-lock-outline::before {\n  content: \"\\F11F2\";\n}\n\n.mdi-cloud-off-outline::before {\n  content: \"\\F0164\";\n}\n\n.mdi-cloud-outline::before {\n  content: \"\\F0163\";\n}\n\n.mdi-cloud-print::before {\n  content: \"\\F0165\";\n}\n\n.mdi-cloud-print-outline::before {\n  content: \"\\F0166\";\n}\n\n.mdi-cloud-question::before {\n  content: \"\\F0A39\";\n}\n\n.mdi-cloud-refresh::before {\n  content: \"\\F052A\";\n}\n\n.mdi-cloud-search::before {\n  content: \"\\F0956\";\n}\n\n.mdi-cloud-search-outline::before {\n  content: \"\\F0957\";\n}\n\n.mdi-cloud-sync::before {\n  content: \"\\F063F\";\n}\n\n.mdi-cloud-sync-outline::before {\n  content: \"\\F12D6\";\n}\n\n.mdi-cloud-tags::before {\n  content: \"\\F07B6\";\n}\n\n.mdi-cloud-upload::before {\n  content: \"\\F0167\";\n}\n\n.mdi-cloud-upload-outline::before {\n  content: \"\\F0B7E\";\n}\n\n.mdi-clover::before {\n  content: \"\\F0816\";\n}\n\n.mdi-coach-lamp::before {\n  content: \"\\F1020\";\n}\n\n.mdi-coat-rack::before {\n  content: \"\\F109E\";\n}\n\n.mdi-code-array::before {\n  content: \"\\F0168\";\n}\n\n.mdi-code-braces::before {\n  content: \"\\F0169\";\n}\n\n.mdi-code-braces-box::before {\n  content: \"\\F10D6\";\n}\n\n.mdi-code-brackets::before {\n  content: \"\\F016A\";\n}\n\n.mdi-code-equal::before {\n  content: \"\\F016B\";\n}\n\n.mdi-code-greater-than::before {\n  content: \"\\F016C\";\n}\n\n.mdi-code-greater-than-or-equal::before {\n  content: \"\\F016D\";\n}\n\n.mdi-code-json::before {\n  content: \"\\F0626\";\n}\n\n.mdi-code-less-than::before {\n  content: \"\\F016E\";\n}\n\n.mdi-code-less-than-or-equal::before {\n  content: \"\\F016F\";\n}\n\n.mdi-code-not-equal::before {\n  content: \"\\F0170\";\n}\n\n.mdi-code-not-equal-variant::before {\n  content: \"\\F0171\";\n}\n\n.mdi-code-parentheses::before {\n  content: \"\\F0172\";\n}\n\n.mdi-code-parentheses-box::before {\n  content: \"\\F10D7\";\n}\n\n.mdi-code-string::before {\n  content: \"\\F0173\";\n}\n\n.mdi-code-tags::before {\n  content: \"\\F0174\";\n}\n\n.mdi-code-tags-check::before {\n  content: \"\\F0694\";\n}\n\n.mdi-codepen::before {\n  content: \"\\F0175\";\n}\n\n.mdi-coffee::before {\n  content: \"\\F0176\";\n}\n\n.mdi-coffee-maker::before {\n  content: \"\\F109F\";\n}\n\n.mdi-coffee-maker-check::before {\n  content: \"\\F1931\";\n}\n\n.mdi-coffee-maker-check-outline::before {\n  content: \"\\F1932\";\n}\n\n.mdi-coffee-maker-outline::before {\n  content: \"\\F181B\";\n}\n\n.mdi-coffee-off::before {\n  content: \"\\F0FAA\";\n}\n\n.mdi-coffee-off-outline::before {\n  content: \"\\F0FAB\";\n}\n\n.mdi-coffee-outline::before {\n  content: \"\\F06CA\";\n}\n\n.mdi-coffee-to-go::before {\n  content: \"\\F0177\";\n}\n\n.mdi-coffee-to-go-outline::before {\n  content: \"\\F130E\";\n}\n\n.mdi-coffin::before {\n  content: \"\\F0B7F\";\n}\n\n.mdi-cog::before {\n  content: \"\\F0493\";\n}\n\n.mdi-cog-box::before {\n  content: \"\\F0494\";\n}\n\n.mdi-cog-clockwise::before {\n  content: \"\\F11DD\";\n}\n\n.mdi-cog-counterclockwise::before {\n  content: \"\\F11DE\";\n}\n\n.mdi-cog-off::before {\n  content: \"\\F13CE\";\n}\n\n.mdi-cog-off-outline::before {\n  content: \"\\F13CF\";\n}\n\n.mdi-cog-outline::before {\n  content: \"\\F08BB\";\n}\n\n.mdi-cog-pause::before {\n  content: \"\\F1933\";\n}\n\n.mdi-cog-pause-outline::before {\n  content: \"\\F1934\";\n}\n\n.mdi-cog-play::before {\n  content: \"\\F1935\";\n}\n\n.mdi-cog-play-outline::before {\n  content: \"\\F1936\";\n}\n\n.mdi-cog-refresh::before {\n  content: \"\\F145E\";\n}\n\n.mdi-cog-refresh-outline::before {\n  content: \"\\F145F\";\n}\n\n.mdi-cog-stop::before {\n  content: \"\\F1937\";\n}\n\n.mdi-cog-stop-outline::before {\n  content: \"\\F1938\";\n}\n\n.mdi-cog-sync::before {\n  content: \"\\F1460\";\n}\n\n.mdi-cog-sync-outline::before {\n  content: \"\\F1461\";\n}\n\n.mdi-cog-transfer::before {\n  content: \"\\F105B\";\n}\n\n.mdi-cog-transfer-outline::before {\n  content: \"\\F105C\";\n}\n\n.mdi-cogs::before {\n  content: \"\\F08D6\";\n}\n\n.mdi-collage::before {\n  content: \"\\F0640\";\n}\n\n.mdi-collapse-all::before {\n  content: \"\\F0AA6\";\n}\n\n.mdi-collapse-all-outline::before {\n  content: \"\\F0AA7\";\n}\n\n.mdi-color-helper::before {\n  content: \"\\F0179\";\n}\n\n.mdi-comma::before {\n  content: \"\\F0E23\";\n}\n\n.mdi-comma-box::before {\n  content: \"\\F0E2B\";\n}\n\n.mdi-comma-box-outline::before {\n  content: \"\\F0E24\";\n}\n\n.mdi-comma-circle::before {\n  content: \"\\F0E25\";\n}\n\n.mdi-comma-circle-outline::before {\n  content: \"\\F0E26\";\n}\n\n.mdi-comment::before {\n  content: \"\\F017A\";\n}\n\n.mdi-comment-account::before {\n  content: \"\\F017B\";\n}\n\n.mdi-comment-account-outline::before {\n  content: \"\\F017C\";\n}\n\n.mdi-comment-alert::before {\n  content: \"\\F017D\";\n}\n\n.mdi-comment-alert-outline::before {\n  content: \"\\F017E\";\n}\n\n.mdi-comment-arrow-left::before {\n  content: \"\\F09E1\";\n}\n\n.mdi-comment-arrow-left-outline::before {\n  content: \"\\F09E2\";\n}\n\n.mdi-comment-arrow-right::before {\n  content: \"\\F09E3\";\n}\n\n.mdi-comment-arrow-right-outline::before {\n  content: \"\\F09E4\";\n}\n\n.mdi-comment-bookmark::before {\n  content: \"\\F15AE\";\n}\n\n.mdi-comment-bookmark-outline::before {\n  content: \"\\F15AF\";\n}\n\n.mdi-comment-check::before {\n  content: \"\\F017F\";\n}\n\n.mdi-comment-check-outline::before {\n  content: \"\\F0180\";\n}\n\n.mdi-comment-edit::before {\n  content: \"\\F11BF\";\n}\n\n.mdi-comment-edit-outline::before {\n  content: \"\\F12C4\";\n}\n\n.mdi-comment-eye::before {\n  content: \"\\F0A3A\";\n}\n\n.mdi-comment-eye-outline::before {\n  content: \"\\F0A3B\";\n}\n\n.mdi-comment-flash::before {\n  content: \"\\F15B0\";\n}\n\n.mdi-comment-flash-outline::before {\n  content: \"\\F15B1\";\n}\n\n.mdi-comment-minus::before {\n  content: \"\\F15DF\";\n}\n\n.mdi-comment-minus-outline::before {\n  content: \"\\F15E0\";\n}\n\n.mdi-comment-multiple::before {\n  content: \"\\F085F\";\n}\n\n.mdi-comment-multiple-outline::before {\n  content: \"\\F0181\";\n}\n\n.mdi-comment-off::before {\n  content: \"\\F15E1\";\n}\n\n.mdi-comment-off-outline::before {\n  content: \"\\F15E2\";\n}\n\n.mdi-comment-outline::before {\n  content: \"\\F0182\";\n}\n\n.mdi-comment-plus::before {\n  content: \"\\F09E5\";\n}\n\n.mdi-comment-plus-outline::before {\n  content: \"\\F0183\";\n}\n\n.mdi-comment-processing::before {\n  content: \"\\F0184\";\n}\n\n.mdi-comment-processing-outline::before {\n  content: \"\\F0185\";\n}\n\n.mdi-comment-question::before {\n  content: \"\\F0817\";\n}\n\n.mdi-comment-question-outline::before {\n  content: \"\\F0186\";\n}\n\n.mdi-comment-quote::before {\n  content: \"\\F1021\";\n}\n\n.mdi-comment-quote-outline::before {\n  content: \"\\F1022\";\n}\n\n.mdi-comment-remove::before {\n  content: \"\\F05DE\";\n}\n\n.mdi-comment-remove-outline::before {\n  content: \"\\F0187\";\n}\n\n.mdi-comment-search::before {\n  content: \"\\F0A3C\";\n}\n\n.mdi-comment-search-outline::before {\n  content: \"\\F0A3D\";\n}\n\n.mdi-comment-text::before {\n  content: \"\\F0188\";\n}\n\n.mdi-comment-text-multiple::before {\n  content: \"\\F0860\";\n}\n\n.mdi-comment-text-multiple-outline::before {\n  content: \"\\F0861\";\n}\n\n.mdi-comment-text-outline::before {\n  content: \"\\F0189\";\n}\n\n.mdi-compare::before {\n  content: \"\\F018A\";\n}\n\n.mdi-compare-horizontal::before {\n  content: \"\\F1492\";\n}\n\n.mdi-compare-remove::before {\n  content: \"\\F18B3\";\n}\n\n.mdi-compare-vertical::before {\n  content: \"\\F1493\";\n}\n\n.mdi-compass::before {\n  content: \"\\F018B\";\n}\n\n.mdi-compass-off::before {\n  content: \"\\F0B80\";\n}\n\n.mdi-compass-off-outline::before {\n  content: \"\\F0B81\";\n}\n\n.mdi-compass-outline::before {\n  content: \"\\F018C\";\n}\n\n.mdi-compass-rose::before {\n  content: \"\\F1382\";\n}\n\n.mdi-cone::before {\n  content: \"\\F194C\";\n}\n\n.mdi-cone-off::before {\n  content: \"\\F194D\";\n}\n\n.mdi-connection::before {\n  content: \"\\F1616\";\n}\n\n.mdi-console::before {\n  content: \"\\F018D\";\n}\n\n.mdi-console-line::before {\n  content: \"\\F07B7\";\n}\n\n.mdi-console-network::before {\n  content: \"\\F08A9\";\n}\n\n.mdi-console-network-outline::before {\n  content: \"\\F0C60\";\n}\n\n.mdi-consolidate::before {\n  content: \"\\F10D8\";\n}\n\n.mdi-contactless-payment::before {\n  content: \"\\F0D6A\";\n}\n\n.mdi-contactless-payment-circle::before {\n  content: \"\\F0321\";\n}\n\n.mdi-contactless-payment-circle-outline::before {\n  content: \"\\F0408\";\n}\n\n.mdi-contacts::before {\n  content: \"\\F06CB\";\n}\n\n.mdi-contacts-outline::before {\n  content: \"\\F05B8\";\n}\n\n.mdi-contain::before {\n  content: \"\\F0A3E\";\n}\n\n.mdi-contain-end::before {\n  content: \"\\F0A3F\";\n}\n\n.mdi-contain-start::before {\n  content: \"\\F0A40\";\n}\n\n.mdi-content-copy::before {\n  content: \"\\F018F\";\n}\n\n.mdi-content-cut::before {\n  content: \"\\F0190\";\n}\n\n.mdi-content-duplicate::before {\n  content: \"\\F0191\";\n}\n\n.mdi-content-paste::before {\n  content: \"\\F0192\";\n}\n\n.mdi-content-save::before {\n  content: \"\\F0193\";\n}\n\n.mdi-content-save-alert::before {\n  content: \"\\F0F42\";\n}\n\n.mdi-content-save-alert-outline::before {\n  content: \"\\F0F43\";\n}\n\n.mdi-content-save-all::before {\n  content: \"\\F0194\";\n}\n\n.mdi-content-save-all-outline::before {\n  content: \"\\F0F44\";\n}\n\n.mdi-content-save-check::before {\n  content: \"\\F18EA\";\n}\n\n.mdi-content-save-check-outline::before {\n  content: \"\\F18EB\";\n}\n\n.mdi-content-save-cog::before {\n  content: \"\\F145B\";\n}\n\n.mdi-content-save-cog-outline::before {\n  content: \"\\F145C\";\n}\n\n.mdi-content-save-edit::before {\n  content: \"\\F0CFB\";\n}\n\n.mdi-content-save-edit-outline::before {\n  content: \"\\F0CFC\";\n}\n\n.mdi-content-save-move::before {\n  content: \"\\F0E27\";\n}\n\n.mdi-content-save-move-outline::before {\n  content: \"\\F0E28\";\n}\n\n.mdi-content-save-off::before {\n  content: \"\\F1643\";\n}\n\n.mdi-content-save-off-outline::before {\n  content: \"\\F1644\";\n}\n\n.mdi-content-save-outline::before {\n  content: \"\\F0818\";\n}\n\n.mdi-content-save-settings::before {\n  content: \"\\F061B\";\n}\n\n.mdi-content-save-settings-outline::before {\n  content: \"\\F0B2E\";\n}\n\n.mdi-contrast::before {\n  content: \"\\F0195\";\n}\n\n.mdi-contrast-box::before {\n  content: \"\\F0196\";\n}\n\n.mdi-contrast-circle::before {\n  content: \"\\F0197\";\n}\n\n.mdi-controller-classic::before {\n  content: \"\\F0B82\";\n}\n\n.mdi-controller-classic-outline::before {\n  content: \"\\F0B83\";\n}\n\n.mdi-cookie::before {\n  content: \"\\F0198\";\n}\n\n.mdi-cookie-alert::before {\n  content: \"\\F16D0\";\n}\n\n.mdi-cookie-alert-outline::before {\n  content: \"\\F16D1\";\n}\n\n.mdi-cookie-check::before {\n  content: \"\\F16D2\";\n}\n\n.mdi-cookie-check-outline::before {\n  content: \"\\F16D3\";\n}\n\n.mdi-cookie-clock::before {\n  content: \"\\F16E4\";\n}\n\n.mdi-cookie-clock-outline::before {\n  content: \"\\F16E5\";\n}\n\n.mdi-cookie-cog::before {\n  content: \"\\F16D4\";\n}\n\n.mdi-cookie-cog-outline::before {\n  content: \"\\F16D5\";\n}\n\n.mdi-cookie-edit::before {\n  content: \"\\F16E6\";\n}\n\n.mdi-cookie-edit-outline::before {\n  content: \"\\F16E7\";\n}\n\n.mdi-cookie-lock::before {\n  content: \"\\F16E8\";\n}\n\n.mdi-cookie-lock-outline::before {\n  content: \"\\F16E9\";\n}\n\n.mdi-cookie-minus::before {\n  content: \"\\F16DA\";\n}\n\n.mdi-cookie-minus-outline::before {\n  content: \"\\F16DB\";\n}\n\n.mdi-cookie-off::before {\n  content: \"\\F16EA\";\n}\n\n.mdi-cookie-off-outline::before {\n  content: \"\\F16EB\";\n}\n\n.mdi-cookie-outline::before {\n  content: \"\\F16DE\";\n}\n\n.mdi-cookie-plus::before {\n  content: \"\\F16D6\";\n}\n\n.mdi-cookie-plus-outline::before {\n  content: \"\\F16D7\";\n}\n\n.mdi-cookie-refresh::before {\n  content: \"\\F16EC\";\n}\n\n.mdi-cookie-refresh-outline::before {\n  content: \"\\F16ED\";\n}\n\n.mdi-cookie-remove::before {\n  content: \"\\F16D8\";\n}\n\n.mdi-cookie-remove-outline::before {\n  content: \"\\F16D9\";\n}\n\n.mdi-cookie-settings::before {\n  content: \"\\F16DC\";\n}\n\n.mdi-cookie-settings-outline::before {\n  content: \"\\F16DD\";\n}\n\n.mdi-coolant-temperature::before {\n  content: \"\\F03C8\";\n}\n\n.mdi-copyleft::before {\n  content: \"\\F1939\";\n}\n\n.mdi-copyright::before {\n  content: \"\\F05E6\";\n}\n\n.mdi-cordova::before {\n  content: \"\\F0958\";\n}\n\n.mdi-corn::before {\n  content: \"\\F07B8\";\n}\n\n.mdi-corn-off::before {\n  content: \"\\F13EF\";\n}\n\n.mdi-cosine-wave::before {\n  content: \"\\F1479\";\n}\n\n.mdi-counter::before {\n  content: \"\\F0199\";\n}\n\n.mdi-countertop::before {\n  content: \"\\F181C\";\n}\n\n.mdi-countertop-outline::before {\n  content: \"\\F181D\";\n}\n\n.mdi-cow::before {\n  content: \"\\F019A\";\n}\n\n.mdi-cow-off::before {\n  content: \"\\F18FC\";\n}\n\n.mdi-cpu-32-bit::before {\n  content: \"\\F0EDF\";\n}\n\n.mdi-cpu-64-bit::before {\n  content: \"\\F0EE0\";\n}\n\n.mdi-cradle::before {\n  content: \"\\F198B\";\n}\n\n.mdi-cradle-outline::before {\n  content: \"\\F1991\";\n}\n\n.mdi-crane::before {\n  content: \"\\F0862\";\n}\n\n.mdi-creation::before {\n  content: \"\\F0674\";\n}\n\n.mdi-creative-commons::before {\n  content: \"\\F0D6B\";\n}\n\n.mdi-credit-card::before {\n  content: \"\\F0FEF\";\n}\n\n.mdi-credit-card-check::before {\n  content: \"\\F13D0\";\n}\n\n.mdi-credit-card-check-outline::before {\n  content: \"\\F13D1\";\n}\n\n.mdi-credit-card-chip::before {\n  content: \"\\F190F\";\n}\n\n.mdi-credit-card-chip-outline::before {\n  content: \"\\F1910\";\n}\n\n.mdi-credit-card-clock::before {\n  content: \"\\F0EE1\";\n}\n\n.mdi-credit-card-clock-outline::before {\n  content: \"\\F0EE2\";\n}\n\n.mdi-credit-card-edit::before {\n  content: \"\\F17D7\";\n}\n\n.mdi-credit-card-edit-outline::before {\n  content: \"\\F17D8\";\n}\n\n.mdi-credit-card-fast::before {\n  content: \"\\F1911\";\n}\n\n.mdi-credit-card-fast-outline::before {\n  content: \"\\F1912\";\n}\n\n.mdi-credit-card-lock::before {\n  content: \"\\F18E7\";\n}\n\n.mdi-credit-card-lock-outline::before {\n  content: \"\\F18E8\";\n}\n\n.mdi-credit-card-marker::before {\n  content: \"\\F06A8\";\n}\n\n.mdi-credit-card-marker-outline::before {\n  content: \"\\F0DBE\";\n}\n\n.mdi-credit-card-minus::before {\n  content: \"\\F0FAC\";\n}\n\n.mdi-credit-card-minus-outline::before {\n  content: \"\\F0FAD\";\n}\n\n.mdi-credit-card-multiple::before {\n  content: \"\\F0FF0\";\n}\n\n.mdi-credit-card-multiple-outline::before {\n  content: \"\\F019C\";\n}\n\n.mdi-credit-card-off::before {\n  content: \"\\F0FF1\";\n}\n\n.mdi-credit-card-off-outline::before {\n  content: \"\\F05E4\";\n}\n\n.mdi-credit-card-outline::before {\n  content: \"\\F019B\";\n}\n\n.mdi-credit-card-plus::before {\n  content: \"\\F0FF2\";\n}\n\n.mdi-credit-card-plus-outline::before {\n  content: \"\\F0676\";\n}\n\n.mdi-credit-card-refresh::before {\n  content: \"\\F1645\";\n}\n\n.mdi-credit-card-refresh-outline::before {\n  content: \"\\F1646\";\n}\n\n.mdi-credit-card-refund::before {\n  content: \"\\F0FF3\";\n}\n\n.mdi-credit-card-refund-outline::before {\n  content: \"\\F0AA8\";\n}\n\n.mdi-credit-card-remove::before {\n  content: \"\\F0FAE\";\n}\n\n.mdi-credit-card-remove-outline::before {\n  content: \"\\F0FAF\";\n}\n\n.mdi-credit-card-scan::before {\n  content: \"\\F0FF4\";\n}\n\n.mdi-credit-card-scan-outline::before {\n  content: \"\\F019D\";\n}\n\n.mdi-credit-card-search::before {\n  content: \"\\F1647\";\n}\n\n.mdi-credit-card-search-outline::before {\n  content: \"\\F1648\";\n}\n\n.mdi-credit-card-settings::before {\n  content: \"\\F0FF5\";\n}\n\n.mdi-credit-card-settings-outline::before {\n  content: \"\\F08D7\";\n}\n\n.mdi-credit-card-sync::before {\n  content: \"\\F1649\";\n}\n\n.mdi-credit-card-sync-outline::before {\n  content: \"\\F164A\";\n}\n\n.mdi-credit-card-wireless::before {\n  content: \"\\F0802\";\n}\n\n.mdi-credit-card-wireless-off::before {\n  content: \"\\F057A\";\n}\n\n.mdi-credit-card-wireless-off-outline::before {\n  content: \"\\F057B\";\n}\n\n.mdi-credit-card-wireless-outline::before {\n  content: \"\\F0D6C\";\n}\n\n.mdi-cricket::before {\n  content: \"\\F0D6D\";\n}\n\n.mdi-crop::before {\n  content: \"\\F019E\";\n}\n\n.mdi-crop-free::before {\n  content: \"\\F019F\";\n}\n\n.mdi-crop-landscape::before {\n  content: \"\\F01A0\";\n}\n\n.mdi-crop-portrait::before {\n  content: \"\\F01A1\";\n}\n\n.mdi-crop-rotate::before {\n  content: \"\\F0696\";\n}\n\n.mdi-crop-square::before {\n  content: \"\\F01A2\";\n}\n\n.mdi-cross::before {\n  content: \"\\F0953\";\n}\n\n.mdi-cross-bolnisi::before {\n  content: \"\\F0CED\";\n}\n\n.mdi-cross-celtic::before {\n  content: \"\\F0CF5\";\n}\n\n.mdi-cross-outline::before {\n  content: \"\\F0CF6\";\n}\n\n.mdi-crosshairs::before {\n  content: \"\\F01A3\";\n}\n\n.mdi-crosshairs-gps::before {\n  content: \"\\F01A4\";\n}\n\n.mdi-crosshairs-off::before {\n  content: \"\\F0F45\";\n}\n\n.mdi-crosshairs-question::before {\n  content: \"\\F1136\";\n}\n\n.mdi-crowd::before {\n  content: \"\\F1975\";\n}\n\n.mdi-crown::before {\n  content: \"\\F01A5\";\n}\n\n.mdi-crown-circle::before {\n  content: \"\\F17DC\";\n}\n\n.mdi-crown-circle-outline::before {\n  content: \"\\F17DD\";\n}\n\n.mdi-crown-outline::before {\n  content: \"\\F11D0\";\n}\n\n.mdi-cryengine::before {\n  content: \"\\F0959\";\n}\n\n.mdi-crystal-ball::before {\n  content: \"\\F0B2F\";\n}\n\n.mdi-cube::before {\n  content: \"\\F01A6\";\n}\n\n.mdi-cube-off::before {\n  content: \"\\F141C\";\n}\n\n.mdi-cube-off-outline::before {\n  content: \"\\F141D\";\n}\n\n.mdi-cube-outline::before {\n  content: \"\\F01A7\";\n}\n\n.mdi-cube-scan::before {\n  content: \"\\F0B84\";\n}\n\n.mdi-cube-send::before {\n  content: \"\\F01A8\";\n}\n\n.mdi-cube-unfolded::before {\n  content: \"\\F01A9\";\n}\n\n.mdi-cup::before {\n  content: \"\\F01AA\";\n}\n\n.mdi-cup-off::before {\n  content: \"\\F05E5\";\n}\n\n.mdi-cup-off-outline::before {\n  content: \"\\F137D\";\n}\n\n.mdi-cup-outline::before {\n  content: \"\\F130F\";\n}\n\n.mdi-cup-water::before {\n  content: \"\\F01AB\";\n}\n\n.mdi-cupboard::before {\n  content: \"\\F0F46\";\n}\n\n.mdi-cupboard-outline::before {\n  content: \"\\F0F47\";\n}\n\n.mdi-cupcake::before {\n  content: \"\\F095A\";\n}\n\n.mdi-curling::before {\n  content: \"\\F0863\";\n}\n\n.mdi-currency-bdt::before {\n  content: \"\\F0864\";\n}\n\n.mdi-currency-brl::before {\n  content: \"\\F0B85\";\n}\n\n.mdi-currency-btc::before {\n  content: \"\\F01AC\";\n}\n\n.mdi-currency-cny::before {\n  content: \"\\F07BA\";\n}\n\n.mdi-currency-eth::before {\n  content: \"\\F07BB\";\n}\n\n.mdi-currency-eur::before {\n  content: \"\\F01AD\";\n}\n\n.mdi-currency-eur-off::before {\n  content: \"\\F1315\";\n}\n\n.mdi-currency-gbp::before {\n  content: \"\\F01AE\";\n}\n\n.mdi-currency-ils::before {\n  content: \"\\F0C61\";\n}\n\n.mdi-currency-inr::before {\n  content: \"\\F01AF\";\n}\n\n.mdi-currency-jpy::before {\n  content: \"\\F07BC\";\n}\n\n.mdi-currency-krw::before {\n  content: \"\\F07BD\";\n}\n\n.mdi-currency-kzt::before {\n  content: \"\\F0865\";\n}\n\n.mdi-currency-mnt::before {\n  content: \"\\F1512\";\n}\n\n.mdi-currency-ngn::before {\n  content: \"\\F01B0\";\n}\n\n.mdi-currency-php::before {\n  content: \"\\F09E6\";\n}\n\n.mdi-currency-rial::before {\n  content: \"\\F0E9C\";\n}\n\n.mdi-currency-rub::before {\n  content: \"\\F01B1\";\n}\n\n.mdi-currency-rupee::before {\n  content: \"\\F1976\";\n}\n\n.mdi-currency-sign::before {\n  content: \"\\F07BE\";\n}\n\n.mdi-currency-try::before {\n  content: \"\\F01B2\";\n}\n\n.mdi-currency-twd::before {\n  content: \"\\F07BF\";\n}\n\n.mdi-currency-usd::before {\n  content: \"\\F01C1\";\n}\n\n.mdi-currency-usd-off::before {\n  content: \"\\F067A\";\n}\n\n.mdi-current-ac::before {\n  content: \"\\F1480\";\n}\n\n.mdi-current-dc::before {\n  content: \"\\F095C\";\n}\n\n.mdi-cursor-default::before {\n  content: \"\\F01C0\";\n}\n\n.mdi-cursor-default-click::before {\n  content: \"\\F0CFD\";\n}\n\n.mdi-cursor-default-click-outline::before {\n  content: \"\\F0CFE\";\n}\n\n.mdi-cursor-default-gesture::before {\n  content: \"\\F1127\";\n}\n\n.mdi-cursor-default-gesture-outline::before {\n  content: \"\\F1128\";\n}\n\n.mdi-cursor-default-outline::before {\n  content: \"\\F01BF\";\n}\n\n.mdi-cursor-move::before {\n  content: \"\\F01BE\";\n}\n\n.mdi-cursor-pointer::before {\n  content: \"\\F01BD\";\n}\n\n.mdi-cursor-text::before {\n  content: \"\\F05E7\";\n}\n\n.mdi-curtains::before {\n  content: \"\\F1846\";\n}\n\n.mdi-curtains-closed::before {\n  content: \"\\F1847\";\n}\n\n.mdi-cylinder::before {\n  content: \"\\F194E\";\n}\n\n.mdi-cylinder-off::before {\n  content: \"\\F194F\";\n}\n\n.mdi-dance-ballroom::before {\n  content: \"\\F15FB\";\n}\n\n.mdi-dance-pole::before {\n  content: \"\\F1578\";\n}\n\n.mdi-data-matrix::before {\n  content: \"\\F153C\";\n}\n\n.mdi-data-matrix-edit::before {\n  content: \"\\F153D\";\n}\n\n.mdi-data-matrix-minus::before {\n  content: \"\\F153E\";\n}\n\n.mdi-data-matrix-plus::before {\n  content: \"\\F153F\";\n}\n\n.mdi-data-matrix-remove::before {\n  content: \"\\F1540\";\n}\n\n.mdi-data-matrix-scan::before {\n  content: \"\\F1541\";\n}\n\n.mdi-database::before {\n  content: \"\\F01BC\";\n}\n\n.mdi-database-alert::before {\n  content: \"\\F163A\";\n}\n\n.mdi-database-alert-outline::before {\n  content: \"\\F1624\";\n}\n\n.mdi-database-arrow-down::before {\n  content: \"\\F163B\";\n}\n\n.mdi-database-arrow-down-outline::before {\n  content: \"\\F1625\";\n}\n\n.mdi-database-arrow-left::before {\n  content: \"\\F163C\";\n}\n\n.mdi-database-arrow-left-outline::before {\n  content: \"\\F1626\";\n}\n\n.mdi-database-arrow-right::before {\n  content: \"\\F163D\";\n}\n\n.mdi-database-arrow-right-outline::before {\n  content: \"\\F1627\";\n}\n\n.mdi-database-arrow-up::before {\n  content: \"\\F163E\";\n}\n\n.mdi-database-arrow-up-outline::before {\n  content: \"\\F1628\";\n}\n\n.mdi-database-check::before {\n  content: \"\\F0AA9\";\n}\n\n.mdi-database-check-outline::before {\n  content: \"\\F1629\";\n}\n\n.mdi-database-clock::before {\n  content: \"\\F163F\";\n}\n\n.mdi-database-clock-outline::before {\n  content: \"\\F162A\";\n}\n\n.mdi-database-cog::before {\n  content: \"\\F164B\";\n}\n\n.mdi-database-cog-outline::before {\n  content: \"\\F164C\";\n}\n\n.mdi-database-edit::before {\n  content: \"\\F0B86\";\n}\n\n.mdi-database-edit-outline::before {\n  content: \"\\F162B\";\n}\n\n.mdi-database-export::before {\n  content: \"\\F095E\";\n}\n\n.mdi-database-export-outline::before {\n  content: \"\\F162C\";\n}\n\n.mdi-database-eye::before {\n  content: \"\\F191F\";\n}\n\n.mdi-database-eye-off::before {\n  content: \"\\F1920\";\n}\n\n.mdi-database-eye-off-outline::before {\n  content: \"\\F1921\";\n}\n\n.mdi-database-eye-outline::before {\n  content: \"\\F1922\";\n}\n\n.mdi-database-import::before {\n  content: \"\\F095D\";\n}\n\n.mdi-database-import-outline::before {\n  content: \"\\F162D\";\n}\n\n.mdi-database-lock::before {\n  content: \"\\F0AAA\";\n}\n\n.mdi-database-lock-outline::before {\n  content: \"\\F162E\";\n}\n\n.mdi-database-marker::before {\n  content: \"\\F12F6\";\n}\n\n.mdi-database-marker-outline::before {\n  content: \"\\F162F\";\n}\n\n.mdi-database-minus::before {\n  content: \"\\F01BB\";\n}\n\n.mdi-database-minus-outline::before {\n  content: \"\\F1630\";\n}\n\n.mdi-database-off::before {\n  content: \"\\F1640\";\n}\n\n.mdi-database-off-outline::before {\n  content: \"\\F1631\";\n}\n\n.mdi-database-outline::before {\n  content: \"\\F1632\";\n}\n\n.mdi-database-plus::before {\n  content: \"\\F01BA\";\n}\n\n.mdi-database-plus-outline::before {\n  content: \"\\F1633\";\n}\n\n.mdi-database-refresh::before {\n  content: \"\\F05C2\";\n}\n\n.mdi-database-refresh-outline::before {\n  content: \"\\F1634\";\n}\n\n.mdi-database-remove::before {\n  content: \"\\F0D00\";\n}\n\n.mdi-database-remove-outline::before {\n  content: \"\\F1635\";\n}\n\n.mdi-database-search::before {\n  content: \"\\F0866\";\n}\n\n.mdi-database-search-outline::before {\n  content: \"\\F1636\";\n}\n\n.mdi-database-settings::before {\n  content: \"\\F0D01\";\n}\n\n.mdi-database-settings-outline::before {\n  content: \"\\F1637\";\n}\n\n.mdi-database-sync::before {\n  content: \"\\F0CFF\";\n}\n\n.mdi-database-sync-outline::before {\n  content: \"\\F1638\";\n}\n\n.mdi-death-star::before {\n  content: \"\\F08D8\";\n}\n\n.mdi-death-star-variant::before {\n  content: \"\\F08D9\";\n}\n\n.mdi-deathly-hallows::before {\n  content: \"\\F0B87\";\n}\n\n.mdi-debian::before {\n  content: \"\\F08DA\";\n}\n\n.mdi-debug-step-into::before {\n  content: \"\\F01B9\";\n}\n\n.mdi-debug-step-out::before {\n  content: \"\\F01B8\";\n}\n\n.mdi-debug-step-over::before {\n  content: \"\\F01B7\";\n}\n\n.mdi-decagram::before {\n  content: \"\\F076C\";\n}\n\n.mdi-decagram-outline::before {\n  content: \"\\F076D\";\n}\n\n.mdi-decimal::before {\n  content: \"\\F10A1\";\n}\n\n.mdi-decimal-comma::before {\n  content: \"\\F10A2\";\n}\n\n.mdi-decimal-comma-decrease::before {\n  content: \"\\F10A3\";\n}\n\n.mdi-decimal-comma-increase::before {\n  content: \"\\F10A4\";\n}\n\n.mdi-decimal-decrease::before {\n  content: \"\\F01B6\";\n}\n\n.mdi-decimal-increase::before {\n  content: \"\\F01B5\";\n}\n\n.mdi-delete::before {\n  content: \"\\F01B4\";\n}\n\n.mdi-delete-alert::before {\n  content: \"\\F10A5\";\n}\n\n.mdi-delete-alert-outline::before {\n  content: \"\\F10A6\";\n}\n\n.mdi-delete-circle::before {\n  content: \"\\F0683\";\n}\n\n.mdi-delete-circle-outline::before {\n  content: \"\\F0B88\";\n}\n\n.mdi-delete-clock::before {\n  content: \"\\F1556\";\n}\n\n.mdi-delete-clock-outline::before {\n  content: \"\\F1557\";\n}\n\n.mdi-delete-empty::before {\n  content: \"\\F06CC\";\n}\n\n.mdi-delete-empty-outline::before {\n  content: \"\\F0E9D\";\n}\n\n.mdi-delete-forever::before {\n  content: \"\\F05E8\";\n}\n\n.mdi-delete-forever-outline::before {\n  content: \"\\F0B89\";\n}\n\n.mdi-delete-off::before {\n  content: \"\\F10A7\";\n}\n\n.mdi-delete-off-outline::before {\n  content: \"\\F10A8\";\n}\n\n.mdi-delete-outline::before {\n  content: \"\\F09E7\";\n}\n\n.mdi-delete-restore::before {\n  content: \"\\F0819\";\n}\n\n.mdi-delete-sweep::before {\n  content: \"\\F05E9\";\n}\n\n.mdi-delete-sweep-outline::before {\n  content: \"\\F0C62\";\n}\n\n.mdi-delete-variant::before {\n  content: \"\\F01B3\";\n}\n\n.mdi-delta::before {\n  content: \"\\F01C2\";\n}\n\n.mdi-desk::before {\n  content: \"\\F1239\";\n}\n\n.mdi-desk-lamp::before {\n  content: \"\\F095F\";\n}\n\n.mdi-deskphone::before {\n  content: \"\\F01C3\";\n}\n\n.mdi-desktop-classic::before {\n  content: \"\\F07C0\";\n}\n\n.mdi-desktop-mac::before {\n  content: \"\\F01C4\";\n}\n\n.mdi-desktop-mac-dashboard::before {\n  content: \"\\F09E8\";\n}\n\n.mdi-desktop-tower::before {\n  content: \"\\F01C5\";\n}\n\n.mdi-desktop-tower-monitor::before {\n  content: \"\\F0AAB\";\n}\n\n.mdi-details::before {\n  content: \"\\F01C6\";\n}\n\n.mdi-dev-to::before {\n  content: \"\\F0D6E\";\n}\n\n.mdi-developer-board::before {\n  content: \"\\F0697\";\n}\n\n.mdi-deviantart::before {\n  content: \"\\F01C7\";\n}\n\n.mdi-devices::before {\n  content: \"\\F0FB0\";\n}\n\n.mdi-dharmachakra::before {\n  content: \"\\F094B\";\n}\n\n.mdi-diabetes::before {\n  content: \"\\F1126\";\n}\n\n.mdi-dialpad::before {\n  content: \"\\F061C\";\n}\n\n.mdi-diameter::before {\n  content: \"\\F0C63\";\n}\n\n.mdi-diameter-outline::before {\n  content: \"\\F0C64\";\n}\n\n.mdi-diameter-variant::before {\n  content: \"\\F0C65\";\n}\n\n.mdi-diamond::before {\n  content: \"\\F0B8A\";\n}\n\n.mdi-diamond-outline::before {\n  content: \"\\F0B8B\";\n}\n\n.mdi-diamond-stone::before {\n  content: \"\\F01C8\";\n}\n\n.mdi-dice-1::before {\n  content: \"\\F01CA\";\n}\n\n.mdi-dice-1-outline::before {\n  content: \"\\F114A\";\n}\n\n.mdi-dice-2::before {\n  content: \"\\F01CB\";\n}\n\n.mdi-dice-2-outline::before {\n  content: \"\\F114B\";\n}\n\n.mdi-dice-3::before {\n  content: \"\\F01CC\";\n}\n\n.mdi-dice-3-outline::before {\n  content: \"\\F114C\";\n}\n\n.mdi-dice-4::before {\n  content: \"\\F01CD\";\n}\n\n.mdi-dice-4-outline::before {\n  content: \"\\F114D\";\n}\n\n.mdi-dice-5::before {\n  content: \"\\F01CE\";\n}\n\n.mdi-dice-5-outline::before {\n  content: \"\\F114E\";\n}\n\n.mdi-dice-6::before {\n  content: \"\\F01CF\";\n}\n\n.mdi-dice-6-outline::before {\n  content: \"\\F114F\";\n}\n\n.mdi-dice-d10::before {\n  content: \"\\F1153\";\n}\n\n.mdi-dice-d10-outline::before {\n  content: \"\\F076F\";\n}\n\n.mdi-dice-d12::before {\n  content: \"\\F1154\";\n}\n\n.mdi-dice-d12-outline::before {\n  content: \"\\F0867\";\n}\n\n.mdi-dice-d20::before {\n  content: \"\\F1155\";\n}\n\n.mdi-dice-d20-outline::before {\n  content: \"\\F05EA\";\n}\n\n.mdi-dice-d4::before {\n  content: \"\\F1150\";\n}\n\n.mdi-dice-d4-outline::before {\n  content: \"\\F05EB\";\n}\n\n.mdi-dice-d6::before {\n  content: \"\\F1151\";\n}\n\n.mdi-dice-d6-outline::before {\n  content: \"\\F05ED\";\n}\n\n.mdi-dice-d8::before {\n  content: \"\\F1152\";\n}\n\n.mdi-dice-d8-outline::before {\n  content: \"\\F05EC\";\n}\n\n.mdi-dice-multiple::before {\n  content: \"\\F076E\";\n}\n\n.mdi-dice-multiple-outline::before {\n  content: \"\\F1156\";\n}\n\n.mdi-digital-ocean::before {\n  content: \"\\F1237\";\n}\n\n.mdi-dip-switch::before {\n  content: \"\\F07C1\";\n}\n\n.mdi-directions::before {\n  content: \"\\F01D0\";\n}\n\n.mdi-directions-fork::before {\n  content: \"\\F0641\";\n}\n\n.mdi-disc::before {\n  content: \"\\F05EE\";\n}\n\n.mdi-disc-alert::before {\n  content: \"\\F01D1\";\n}\n\n.mdi-disc-player::before {\n  content: \"\\F0960\";\n}\n\n.mdi-discord::before {\n  content: \"\\F066F\";\n}\n\n.mdi-dishwasher::before {\n  content: \"\\F0AAC\";\n}\n\n.mdi-dishwasher-alert::before {\n  content: \"\\F11B8\";\n}\n\n.mdi-dishwasher-off::before {\n  content: \"\\F11B9\";\n}\n\n.mdi-disqus::before {\n  content: \"\\F01D2\";\n}\n\n.mdi-distribute-horizontal-center::before {\n  content: \"\\F11C9\";\n}\n\n.mdi-distribute-horizontal-left::before {\n  content: \"\\F11C8\";\n}\n\n.mdi-distribute-horizontal-right::before {\n  content: \"\\F11CA\";\n}\n\n.mdi-distribute-vertical-bottom::before {\n  content: \"\\F11CB\";\n}\n\n.mdi-distribute-vertical-center::before {\n  content: \"\\F11CC\";\n}\n\n.mdi-distribute-vertical-top::before {\n  content: \"\\F11CD\";\n}\n\n.mdi-diversify::before {\n  content: \"\\F1877\";\n}\n\n.mdi-diving::before {\n  content: \"\\F1977\";\n}\n\n.mdi-diving-flippers::before {\n  content: \"\\F0DBF\";\n}\n\n.mdi-diving-helmet::before {\n  content: \"\\F0DC0\";\n}\n\n.mdi-diving-scuba::before {\n  content: \"\\F0DC1\";\n}\n\n.mdi-diving-scuba-flag::before {\n  content: \"\\F0DC2\";\n}\n\n.mdi-diving-scuba-tank::before {\n  content: \"\\F0DC3\";\n}\n\n.mdi-diving-scuba-tank-multiple::before {\n  content: \"\\F0DC4\";\n}\n\n.mdi-diving-snorkel::before {\n  content: \"\\F0DC5\";\n}\n\n.mdi-division::before {\n  content: \"\\F01D4\";\n}\n\n.mdi-division-box::before {\n  content: \"\\F01D5\";\n}\n\n.mdi-dlna::before {\n  content: \"\\F0A41\";\n}\n\n.mdi-dna::before {\n  content: \"\\F0684\";\n}\n\n.mdi-dns::before {\n  content: \"\\F01D6\";\n}\n\n.mdi-dns-outline::before {\n  content: \"\\F0B8C\";\n}\n\n.mdi-dock-bottom::before {\n  content: \"\\F10A9\";\n}\n\n.mdi-dock-left::before {\n  content: \"\\F10AA\";\n}\n\n.mdi-dock-right::before {\n  content: \"\\F10AB\";\n}\n\n.mdi-dock-top::before {\n  content: \"\\F1513\";\n}\n\n.mdi-dock-window::before {\n  content: \"\\F10AC\";\n}\n\n.mdi-docker::before {\n  content: \"\\F0868\";\n}\n\n.mdi-doctor::before {\n  content: \"\\F0A42\";\n}\n\n.mdi-dog::before {\n  content: \"\\F0A43\";\n}\n\n.mdi-dog-service::before {\n  content: \"\\F0AAD\";\n}\n\n.mdi-dog-side::before {\n  content: \"\\F0A44\";\n}\n\n.mdi-dog-side-off::before {\n  content: \"\\F16EE\";\n}\n\n.mdi-dolby::before {\n  content: \"\\F06B3\";\n}\n\n.mdi-dolly::before {\n  content: \"\\F0E9E\";\n}\n\n.mdi-dolphin::before {\n  content: \"\\F18B4\";\n}\n\n.mdi-domain::before {\n  content: \"\\F01D7\";\n}\n\n.mdi-domain-off::before {\n  content: \"\\F0D6F\";\n}\n\n.mdi-domain-plus::before {\n  content: \"\\F10AD\";\n}\n\n.mdi-domain-remove::before {\n  content: \"\\F10AE\";\n}\n\n.mdi-dome-light::before {\n  content: \"\\F141E\";\n}\n\n.mdi-domino-mask::before {\n  content: \"\\F1023\";\n}\n\n.mdi-donkey::before {\n  content: \"\\F07C2\";\n}\n\n.mdi-door::before {\n  content: \"\\F081A\";\n}\n\n.mdi-door-closed::before {\n  content: \"\\F081B\";\n}\n\n.mdi-door-closed-lock::before {\n  content: \"\\F10AF\";\n}\n\n.mdi-door-open::before {\n  content: \"\\F081C\";\n}\n\n.mdi-door-sliding::before {\n  content: \"\\F181E\";\n}\n\n.mdi-door-sliding-lock::before {\n  content: \"\\F181F\";\n}\n\n.mdi-door-sliding-open::before {\n  content: \"\\F1820\";\n}\n\n.mdi-doorbell::before {\n  content: \"\\F12E6\";\n}\n\n.mdi-doorbell-video::before {\n  content: \"\\F0869\";\n}\n\n.mdi-dot-net::before {\n  content: \"\\F0AAE\";\n}\n\n.mdi-dots-circle::before {\n  content: \"\\F1978\";\n}\n\n.mdi-dots-grid::before {\n  content: \"\\F15FC\";\n}\n\n.mdi-dots-hexagon::before {\n  content: \"\\F15FF\";\n}\n\n.mdi-dots-horizontal::before {\n  content: \"\\F01D8\";\n}\n\n.mdi-dots-horizontal-circle::before {\n  content: \"\\F07C3\";\n}\n\n.mdi-dots-horizontal-circle-outline::before {\n  content: \"\\F0B8D\";\n}\n\n.mdi-dots-square::before {\n  content: \"\\F15FD\";\n}\n\n.mdi-dots-triangle::before {\n  content: \"\\F15FE\";\n}\n\n.mdi-dots-vertical::before {\n  content: \"\\F01D9\";\n}\n\n.mdi-dots-vertical-circle::before {\n  content: \"\\F07C4\";\n}\n\n.mdi-dots-vertical-circle-outline::before {\n  content: \"\\F0B8E\";\n}\n\n.mdi-download::before {\n  content: \"\\F01DA\";\n}\n\n.mdi-download-box::before {\n  content: \"\\F1462\";\n}\n\n.mdi-download-box-outline::before {\n  content: \"\\F1463\";\n}\n\n.mdi-download-circle::before {\n  content: \"\\F1464\";\n}\n\n.mdi-download-circle-outline::before {\n  content: \"\\F1465\";\n}\n\n.mdi-download-lock::before {\n  content: \"\\F1320\";\n}\n\n.mdi-download-lock-outline::before {\n  content: \"\\F1321\";\n}\n\n.mdi-download-multiple::before {\n  content: \"\\F09E9\";\n}\n\n.mdi-download-network::before {\n  content: \"\\F06F4\";\n}\n\n.mdi-download-network-outline::before {\n  content: \"\\F0C66\";\n}\n\n.mdi-download-off::before {\n  content: \"\\F10B0\";\n}\n\n.mdi-download-off-outline::before {\n  content: \"\\F10B1\";\n}\n\n.mdi-download-outline::before {\n  content: \"\\F0B8F\";\n}\n\n.mdi-drag::before {\n  content: \"\\F01DB\";\n}\n\n.mdi-drag-horizontal::before {\n  content: \"\\F01DC\";\n}\n\n.mdi-drag-horizontal-variant::before {\n  content: \"\\F12F0\";\n}\n\n.mdi-drag-variant::before {\n  content: \"\\F0B90\";\n}\n\n.mdi-drag-vertical::before {\n  content: \"\\F01DD\";\n}\n\n.mdi-drag-vertical-variant::before {\n  content: \"\\F12F1\";\n}\n\n.mdi-drama-masks::before {\n  content: \"\\F0D02\";\n}\n\n.mdi-draw::before {\n  content: \"\\F0F49\";\n}\n\n.mdi-draw-pen::before {\n  content: \"\\F19B9\";\n}\n\n.mdi-drawing::before {\n  content: \"\\F01DE\";\n}\n\n.mdi-drawing-box::before {\n  content: \"\\F01DF\";\n}\n\n.mdi-dresser::before {\n  content: \"\\F0F4A\";\n}\n\n.mdi-dresser-outline::before {\n  content: \"\\F0F4B\";\n}\n\n.mdi-drone::before {\n  content: \"\\F01E2\";\n}\n\n.mdi-dropbox::before {\n  content: \"\\F01E3\";\n}\n\n.mdi-drupal::before {\n  content: \"\\F01E4\";\n}\n\n.mdi-duck::before {\n  content: \"\\F01E5\";\n}\n\n.mdi-dumbbell::before {\n  content: \"\\F01E6\";\n}\n\n.mdi-dump-truck::before {\n  content: \"\\F0C67\";\n}\n\n.mdi-ear-hearing::before {\n  content: \"\\F07C5\";\n}\n\n.mdi-ear-hearing-off::before {\n  content: \"\\F0A45\";\n}\n\n.mdi-earbuds::before {\n  content: \"\\F184F\";\n}\n\n.mdi-earbuds-off::before {\n  content: \"\\F1850\";\n}\n\n.mdi-earbuds-off-outline::before {\n  content: \"\\F1851\";\n}\n\n.mdi-earbuds-outline::before {\n  content: \"\\F1852\";\n}\n\n.mdi-earth::before {\n  content: \"\\F01E7\";\n}\n\n.mdi-earth-arrow-right::before {\n  content: \"\\F1311\";\n}\n\n.mdi-earth-box::before {\n  content: \"\\F06CD\";\n}\n\n.mdi-earth-box-minus::before {\n  content: \"\\F1407\";\n}\n\n.mdi-earth-box-off::before {\n  content: \"\\F06CE\";\n}\n\n.mdi-earth-box-plus::before {\n  content: \"\\F1406\";\n}\n\n.mdi-earth-box-remove::before {\n  content: \"\\F1408\";\n}\n\n.mdi-earth-minus::before {\n  content: \"\\F1404\";\n}\n\n.mdi-earth-off::before {\n  content: \"\\F01E8\";\n}\n\n.mdi-earth-plus::before {\n  content: \"\\F1403\";\n}\n\n.mdi-earth-remove::before {\n  content: \"\\F1405\";\n}\n\n.mdi-egg::before {\n  content: \"\\F0AAF\";\n}\n\n.mdi-egg-easter::before {\n  content: \"\\F0AB0\";\n}\n\n.mdi-egg-fried::before {\n  content: \"\\F184A\";\n}\n\n.mdi-egg-off::before {\n  content: \"\\F13F0\";\n}\n\n.mdi-egg-off-outline::before {\n  content: \"\\F13F1\";\n}\n\n.mdi-egg-outline::before {\n  content: \"\\F13F2\";\n}\n\n.mdi-eiffel-tower::before {\n  content: \"\\F156B\";\n}\n\n.mdi-eight-track::before {\n  content: \"\\F09EA\";\n}\n\n.mdi-eject::before {\n  content: \"\\F01EA\";\n}\n\n.mdi-eject-outline::before {\n  content: \"\\F0B91\";\n}\n\n.mdi-electric-switch::before {\n  content: \"\\F0E9F\";\n}\n\n.mdi-electric-switch-closed::before {\n  content: \"\\F10D9\";\n}\n\n.mdi-electron-framework::before {\n  content: \"\\F1024\";\n}\n\n.mdi-elephant::before {\n  content: \"\\F07C6\";\n}\n\n.mdi-elevation-decline::before {\n  content: \"\\F01EB\";\n}\n\n.mdi-elevation-rise::before {\n  content: \"\\F01EC\";\n}\n\n.mdi-elevator::before {\n  content: \"\\F01ED\";\n}\n\n.mdi-elevator-down::before {\n  content: \"\\F12C2\";\n}\n\n.mdi-elevator-passenger::before {\n  content: \"\\F1381\";\n}\n\n.mdi-elevator-passenger-off::before {\n  content: \"\\F1979\";\n}\n\n.mdi-elevator-passenger-off-outline::before {\n  content: \"\\F197A\";\n}\n\n.mdi-elevator-passenger-outline::before {\n  content: \"\\F197B\";\n}\n\n.mdi-elevator-up::before {\n  content: \"\\F12C1\";\n}\n\n.mdi-ellipse::before {\n  content: \"\\F0EA0\";\n}\n\n.mdi-ellipse-outline::before {\n  content: \"\\F0EA1\";\n}\n\n.mdi-email::before {\n  content: \"\\F01EE\";\n}\n\n.mdi-email-alert::before {\n  content: \"\\F06CF\";\n}\n\n.mdi-email-alert-outline::before {\n  content: \"\\F0D42\";\n}\n\n.mdi-email-box::before {\n  content: \"\\F0D03\";\n}\n\n.mdi-email-check::before {\n  content: \"\\F0AB1\";\n}\n\n.mdi-email-check-outline::before {\n  content: \"\\F0AB2\";\n}\n\n.mdi-email-edit::before {\n  content: \"\\F0EE3\";\n}\n\n.mdi-email-edit-outline::before {\n  content: \"\\F0EE4\";\n}\n\n.mdi-email-fast::before {\n  content: \"\\F186F\";\n}\n\n.mdi-email-fast-outline::before {\n  content: \"\\F1870\";\n}\n\n.mdi-email-lock::before {\n  content: \"\\F01F1\";\n}\n\n.mdi-email-mark-as-unread::before {\n  content: \"\\F0B92\";\n}\n\n.mdi-email-minus::before {\n  content: \"\\F0EE5\";\n}\n\n.mdi-email-minus-outline::before {\n  content: \"\\F0EE6\";\n}\n\n.mdi-email-multiple::before {\n  content: \"\\F0EE7\";\n}\n\n.mdi-email-multiple-outline::before {\n  content: \"\\F0EE8\";\n}\n\n.mdi-email-newsletter::before {\n  content: \"\\F0FB1\";\n}\n\n.mdi-email-off::before {\n  content: \"\\F13E3\";\n}\n\n.mdi-email-off-outline::before {\n  content: \"\\F13E4\";\n}\n\n.mdi-email-open::before {\n  content: \"\\F01EF\";\n}\n\n.mdi-email-open-multiple::before {\n  content: \"\\F0EE9\";\n}\n\n.mdi-email-open-multiple-outline::before {\n  content: \"\\F0EEA\";\n}\n\n.mdi-email-open-outline::before {\n  content: \"\\F05EF\";\n}\n\n.mdi-email-outline::before {\n  content: \"\\F01F0\";\n}\n\n.mdi-email-plus::before {\n  content: \"\\F09EB\";\n}\n\n.mdi-email-plus-outline::before {\n  content: \"\\F09EC\";\n}\n\n.mdi-email-receive::before {\n  content: \"\\F10DA\";\n}\n\n.mdi-email-receive-outline::before {\n  content: \"\\F10DB\";\n}\n\n.mdi-email-remove::before {\n  content: \"\\F1661\";\n}\n\n.mdi-email-remove-outline::before {\n  content: \"\\F1662\";\n}\n\n.mdi-email-seal::before {\n  content: \"\\F195B\";\n}\n\n.mdi-email-seal-outline::before {\n  content: \"\\F195C\";\n}\n\n.mdi-email-search::before {\n  content: \"\\F0961\";\n}\n\n.mdi-email-search-outline::before {\n  content: \"\\F0962\";\n}\n\n.mdi-email-send::before {\n  content: \"\\F10DC\";\n}\n\n.mdi-email-send-outline::before {\n  content: \"\\F10DD\";\n}\n\n.mdi-email-sync::before {\n  content: \"\\F12C7\";\n}\n\n.mdi-email-sync-outline::before {\n  content: \"\\F12C8\";\n}\n\n.mdi-email-variant::before {\n  content: \"\\F05F0\";\n}\n\n.mdi-ember::before {\n  content: \"\\F0B30\";\n}\n\n.mdi-emby::before {\n  content: \"\\F06B4\";\n}\n\n.mdi-emoticon::before {\n  content: \"\\F0C68\";\n}\n\n.mdi-emoticon-angry::before {\n  content: \"\\F0C69\";\n}\n\n.mdi-emoticon-angry-outline::before {\n  content: \"\\F0C6A\";\n}\n\n.mdi-emoticon-confused::before {\n  content: \"\\F10DE\";\n}\n\n.mdi-emoticon-confused-outline::before {\n  content: \"\\F10DF\";\n}\n\n.mdi-emoticon-cool::before {\n  content: \"\\F0C6B\";\n}\n\n.mdi-emoticon-cool-outline::before {\n  content: \"\\F01F3\";\n}\n\n.mdi-emoticon-cry::before {\n  content: \"\\F0C6C\";\n}\n\n.mdi-emoticon-cry-outline::before {\n  content: \"\\F0C6D\";\n}\n\n.mdi-emoticon-dead::before {\n  content: \"\\F0C6E\";\n}\n\n.mdi-emoticon-dead-outline::before {\n  content: \"\\F069B\";\n}\n\n.mdi-emoticon-devil::before {\n  content: \"\\F0C6F\";\n}\n\n.mdi-emoticon-devil-outline::before {\n  content: \"\\F01F4\";\n}\n\n.mdi-emoticon-excited::before {\n  content: \"\\F0C70\";\n}\n\n.mdi-emoticon-excited-outline::before {\n  content: \"\\F069C\";\n}\n\n.mdi-emoticon-frown::before {\n  content: \"\\F0F4C\";\n}\n\n.mdi-emoticon-frown-outline::before {\n  content: \"\\F0F4D\";\n}\n\n.mdi-emoticon-happy::before {\n  content: \"\\F0C71\";\n}\n\n.mdi-emoticon-happy-outline::before {\n  content: \"\\F01F5\";\n}\n\n.mdi-emoticon-kiss::before {\n  content: \"\\F0C72\";\n}\n\n.mdi-emoticon-kiss-outline::before {\n  content: \"\\F0C73\";\n}\n\n.mdi-emoticon-lol::before {\n  content: \"\\F1214\";\n}\n\n.mdi-emoticon-lol-outline::before {\n  content: \"\\F1215\";\n}\n\n.mdi-emoticon-neutral::before {\n  content: \"\\F0C74\";\n}\n\n.mdi-emoticon-neutral-outline::before {\n  content: \"\\F01F6\";\n}\n\n.mdi-emoticon-outline::before {\n  content: \"\\F01F2\";\n}\n\n.mdi-emoticon-poop::before {\n  content: \"\\F01F7\";\n}\n\n.mdi-emoticon-poop-outline::before {\n  content: \"\\F0C75\";\n}\n\n.mdi-emoticon-sad::before {\n  content: \"\\F0C76\";\n}\n\n.mdi-emoticon-sad-outline::before {\n  content: \"\\F01F8\";\n}\n\n.mdi-emoticon-sick::before {\n  content: \"\\F157C\";\n}\n\n.mdi-emoticon-sick-outline::before {\n  content: \"\\F157D\";\n}\n\n.mdi-emoticon-tongue::before {\n  content: \"\\F01F9\";\n}\n\n.mdi-emoticon-tongue-outline::before {\n  content: \"\\F0C77\";\n}\n\n.mdi-emoticon-wink::before {\n  content: \"\\F0C78\";\n}\n\n.mdi-emoticon-wink-outline::before {\n  content: \"\\F0C79\";\n}\n\n.mdi-engine::before {\n  content: \"\\F01FA\";\n}\n\n.mdi-engine-off::before {\n  content: \"\\F0A46\";\n}\n\n.mdi-engine-off-outline::before {\n  content: \"\\F0A47\";\n}\n\n.mdi-engine-outline::before {\n  content: \"\\F01FB\";\n}\n\n.mdi-epsilon::before {\n  content: \"\\F10E0\";\n}\n\n.mdi-equal::before {\n  content: \"\\F01FC\";\n}\n\n.mdi-equal-box::before {\n  content: \"\\F01FD\";\n}\n\n.mdi-equalizer::before {\n  content: \"\\F0EA2\";\n}\n\n.mdi-equalizer-outline::before {\n  content: \"\\F0EA3\";\n}\n\n.mdi-eraser::before {\n  content: \"\\F01FE\";\n}\n\n.mdi-eraser-variant::before {\n  content: \"\\F0642\";\n}\n\n.mdi-escalator::before {\n  content: \"\\F01FF\";\n}\n\n.mdi-escalator-box::before {\n  content: \"\\F1399\";\n}\n\n.mdi-escalator-down::before {\n  content: \"\\F12C0\";\n}\n\n.mdi-escalator-up::before {\n  content: \"\\F12BF\";\n}\n\n.mdi-eslint::before {\n  content: \"\\F0C7A\";\n}\n\n.mdi-et::before {\n  content: \"\\F0AB3\";\n}\n\n.mdi-ethereum::before {\n  content: \"\\F086A\";\n}\n\n.mdi-ethernet::before {\n  content: \"\\F0200\";\n}\n\n.mdi-ethernet-cable::before {\n  content: \"\\F0201\";\n}\n\n.mdi-ethernet-cable-off::before {\n  content: \"\\F0202\";\n}\n\n.mdi-ev-plug-ccs1::before {\n  content: \"\\F1519\";\n}\n\n.mdi-ev-plug-ccs2::before {\n  content: \"\\F151A\";\n}\n\n.mdi-ev-plug-chademo::before {\n  content: \"\\F151B\";\n}\n\n.mdi-ev-plug-tesla::before {\n  content: \"\\F151C\";\n}\n\n.mdi-ev-plug-type1::before {\n  content: \"\\F151D\";\n}\n\n.mdi-ev-plug-type2::before {\n  content: \"\\F151E\";\n}\n\n.mdi-ev-station::before {\n  content: \"\\F05F1\";\n}\n\n.mdi-evernote::before {\n  content: \"\\F0204\";\n}\n\n.mdi-excavator::before {\n  content: \"\\F1025\";\n}\n\n.mdi-exclamation::before {\n  content: \"\\F0205\";\n}\n\n.mdi-exclamation-thick::before {\n  content: \"\\F1238\";\n}\n\n.mdi-exit-run::before {\n  content: \"\\F0A48\";\n}\n\n.mdi-exit-to-app::before {\n  content: \"\\F0206\";\n}\n\n.mdi-expand-all::before {\n  content: \"\\F0AB4\";\n}\n\n.mdi-expand-all-outline::before {\n  content: \"\\F0AB5\";\n}\n\n.mdi-expansion-card::before {\n  content: \"\\F08AE\";\n}\n\n.mdi-expansion-card-variant::before {\n  content: \"\\F0FB2\";\n}\n\n.mdi-exponent::before {\n  content: \"\\F0963\";\n}\n\n.mdi-exponent-box::before {\n  content: \"\\F0964\";\n}\n\n.mdi-export::before {\n  content: \"\\F0207\";\n}\n\n.mdi-export-variant::before {\n  content: \"\\F0B93\";\n}\n\n.mdi-eye::before {\n  content: \"\\F0208\";\n}\n\n.mdi-eye-arrow-left::before {\n  content: \"\\F18FD\";\n}\n\n.mdi-eye-arrow-left-outline::before {\n  content: \"\\F18FE\";\n}\n\n.mdi-eye-arrow-right::before {\n  content: \"\\F18FF\";\n}\n\n.mdi-eye-arrow-right-outline::before {\n  content: \"\\F1900\";\n}\n\n.mdi-eye-check::before {\n  content: \"\\F0D04\";\n}\n\n.mdi-eye-check-outline::before {\n  content: \"\\F0D05\";\n}\n\n.mdi-eye-circle::before {\n  content: \"\\F0B94\";\n}\n\n.mdi-eye-circle-outline::before {\n  content: \"\\F0B95\";\n}\n\n.mdi-eye-minus::before {\n  content: \"\\F1026\";\n}\n\n.mdi-eye-minus-outline::before {\n  content: \"\\F1027\";\n}\n\n.mdi-eye-off::before {\n  content: \"\\F0209\";\n}\n\n.mdi-eye-off-outline::before {\n  content: \"\\F06D1\";\n}\n\n.mdi-eye-outline::before {\n  content: \"\\F06D0\";\n}\n\n.mdi-eye-plus::before {\n  content: \"\\F086B\";\n}\n\n.mdi-eye-plus-outline::before {\n  content: \"\\F086C\";\n}\n\n.mdi-eye-refresh::before {\n  content: \"\\F197C\";\n}\n\n.mdi-eye-refresh-outline::before {\n  content: \"\\F197D\";\n}\n\n.mdi-eye-remove::before {\n  content: \"\\F15E3\";\n}\n\n.mdi-eye-remove-outline::before {\n  content: \"\\F15E4\";\n}\n\n.mdi-eye-settings::before {\n  content: \"\\F086D\";\n}\n\n.mdi-eye-settings-outline::before {\n  content: \"\\F086E\";\n}\n\n.mdi-eyedropper::before {\n  content: \"\\F020A\";\n}\n\n.mdi-eyedropper-minus::before {\n  content: \"\\F13DD\";\n}\n\n.mdi-eyedropper-off::before {\n  content: \"\\F13DF\";\n}\n\n.mdi-eyedropper-plus::before {\n  content: \"\\F13DC\";\n}\n\n.mdi-eyedropper-remove::before {\n  content: \"\\F13DE\";\n}\n\n.mdi-eyedropper-variant::before {\n  content: \"\\F020B\";\n}\n\n.mdi-face-agent::before {\n  content: \"\\F0D70\";\n}\n\n.mdi-face-man::before {\n  content: \"\\F0643\";\n}\n\n.mdi-face-man-outline::before {\n  content: \"\\F0B96\";\n}\n\n.mdi-face-man-profile::before {\n  content: \"\\F0644\";\n}\n\n.mdi-face-man-shimmer::before {\n  content: \"\\F15CC\";\n}\n\n.mdi-face-man-shimmer-outline::before {\n  content: \"\\F15CD\";\n}\n\n.mdi-face-mask::before {\n  content: \"\\F1586\";\n}\n\n.mdi-face-mask-outline::before {\n  content: \"\\F1587\";\n}\n\n.mdi-face-recognition::before {\n  content: \"\\F0C7B\";\n}\n\n.mdi-face-woman::before {\n  content: \"\\F1077\";\n}\n\n.mdi-face-woman-outline::before {\n  content: \"\\F1078\";\n}\n\n.mdi-face-woman-profile::before {\n  content: \"\\F1076\";\n}\n\n.mdi-face-woman-shimmer::before {\n  content: \"\\F15CE\";\n}\n\n.mdi-face-woman-shimmer-outline::before {\n  content: \"\\F15CF\";\n}\n\n.mdi-facebook::before {\n  content: \"\\F020C\";\n}\n\n.mdi-facebook-gaming::before {\n  content: \"\\F07DD\";\n}\n\n.mdi-facebook-messenger::before {\n  content: \"\\F020E\";\n}\n\n.mdi-facebook-workplace::before {\n  content: \"\\F0B31\";\n}\n\n.mdi-factory::before {\n  content: \"\\F020F\";\n}\n\n.mdi-family-tree::before {\n  content: \"\\F160E\";\n}\n\n.mdi-fan::before {\n  content: \"\\F0210\";\n}\n\n.mdi-fan-alert::before {\n  content: \"\\F146C\";\n}\n\n.mdi-fan-auto::before {\n  content: \"\\F171D\";\n}\n\n.mdi-fan-chevron-down::before {\n  content: \"\\F146D\";\n}\n\n.mdi-fan-chevron-up::before {\n  content: \"\\F146E\";\n}\n\n.mdi-fan-minus::before {\n  content: \"\\F1470\";\n}\n\n.mdi-fan-off::before {\n  content: \"\\F081D\";\n}\n\n.mdi-fan-plus::before {\n  content: \"\\F146F\";\n}\n\n.mdi-fan-remove::before {\n  content: \"\\F1471\";\n}\n\n.mdi-fan-speed-1::before {\n  content: \"\\F1472\";\n}\n\n.mdi-fan-speed-2::before {\n  content: \"\\F1473\";\n}\n\n.mdi-fan-speed-3::before {\n  content: \"\\F1474\";\n}\n\n.mdi-fast-forward::before {\n  content: \"\\F0211\";\n}\n\n.mdi-fast-forward-10::before {\n  content: \"\\F0D71\";\n}\n\n.mdi-fast-forward-15::before {\n  content: \"\\F193A\";\n}\n\n.mdi-fast-forward-30::before {\n  content: \"\\F0D06\";\n}\n\n.mdi-fast-forward-5::before {\n  content: \"\\F11F8\";\n}\n\n.mdi-fast-forward-60::before {\n  content: \"\\F160B\";\n}\n\n.mdi-fast-forward-outline::before {\n  content: \"\\F06D2\";\n}\n\n.mdi-fax::before {\n  content: \"\\F0212\";\n}\n\n.mdi-feather::before {\n  content: \"\\F06D3\";\n}\n\n.mdi-feature-search::before {\n  content: \"\\F0A49\";\n}\n\n.mdi-feature-search-outline::before {\n  content: \"\\F0A4A\";\n}\n\n.mdi-fedora::before {\n  content: \"\\F08DB\";\n}\n\n.mdi-fence::before {\n  content: \"\\F179A\";\n}\n\n.mdi-fence-electric::before {\n  content: \"\\F17F6\";\n}\n\n.mdi-fencing::before {\n  content: \"\\F14C1\";\n}\n\n.mdi-ferris-wheel::before {\n  content: \"\\F0EA4\";\n}\n\n.mdi-ferry::before {\n  content: \"\\F0213\";\n}\n\n.mdi-file::before {\n  content: \"\\F0214\";\n}\n\n.mdi-file-account::before {\n  content: \"\\F073B\";\n}\n\n.mdi-file-account-outline::before {\n  content: \"\\F1028\";\n}\n\n.mdi-file-alert::before {\n  content: \"\\F0A4B\";\n}\n\n.mdi-file-alert-outline::before {\n  content: \"\\F0A4C\";\n}\n\n.mdi-file-cabinet::before {\n  content: \"\\F0AB6\";\n}\n\n.mdi-file-cad::before {\n  content: \"\\F0EEB\";\n}\n\n.mdi-file-cad-box::before {\n  content: \"\\F0EEC\";\n}\n\n.mdi-file-cancel::before {\n  content: \"\\F0DC6\";\n}\n\n.mdi-file-cancel-outline::before {\n  content: \"\\F0DC7\";\n}\n\n.mdi-file-certificate::before {\n  content: \"\\F1186\";\n}\n\n.mdi-file-certificate-outline::before {\n  content: \"\\F1187\";\n}\n\n.mdi-file-chart::before {\n  content: \"\\F0215\";\n}\n\n.mdi-file-chart-outline::before {\n  content: \"\\F1029\";\n}\n\n.mdi-file-check::before {\n  content: \"\\F0216\";\n}\n\n.mdi-file-check-outline::before {\n  content: \"\\F0E29\";\n}\n\n.mdi-file-clock::before {\n  content: \"\\F12E1\";\n}\n\n.mdi-file-clock-outline::before {\n  content: \"\\F12E2\";\n}\n\n.mdi-file-cloud::before {\n  content: \"\\F0217\";\n}\n\n.mdi-file-cloud-outline::before {\n  content: \"\\F102A\";\n}\n\n.mdi-file-code::before {\n  content: \"\\F022E\";\n}\n\n.mdi-file-code-outline::before {\n  content: \"\\F102B\";\n}\n\n.mdi-file-cog::before {\n  content: \"\\F107B\";\n}\n\n.mdi-file-cog-outline::before {\n  content: \"\\F107C\";\n}\n\n.mdi-file-compare::before {\n  content: \"\\F08AA\";\n}\n\n.mdi-file-delimited::before {\n  content: \"\\F0218\";\n}\n\n.mdi-file-delimited-outline::before {\n  content: \"\\F0EA5\";\n}\n\n.mdi-file-document::before {\n  content: \"\\F0219\";\n}\n\n.mdi-file-document-edit::before {\n  content: \"\\F0DC8\";\n}\n\n.mdi-file-document-edit-outline::before {\n  content: \"\\F0DC9\";\n}\n\n.mdi-file-document-multiple::before {\n  content: \"\\F1517\";\n}\n\n.mdi-file-document-multiple-outline::before {\n  content: \"\\F1518\";\n}\n\n.mdi-file-document-outline::before {\n  content: \"\\F09EE\";\n}\n\n.mdi-file-download::before {\n  content: \"\\F0965\";\n}\n\n.mdi-file-download-outline::before {\n  content: \"\\F0966\";\n}\n\n.mdi-file-edit::before {\n  content: \"\\F11E7\";\n}\n\n.mdi-file-edit-outline::before {\n  content: \"\\F11E8\";\n}\n\n.mdi-file-excel::before {\n  content: \"\\F021B\";\n}\n\n.mdi-file-excel-box::before {\n  content: \"\\F021C\";\n}\n\n.mdi-file-excel-box-outline::before {\n  content: \"\\F102C\";\n}\n\n.mdi-file-excel-outline::before {\n  content: \"\\F102D\";\n}\n\n.mdi-file-export::before {\n  content: \"\\F021D\";\n}\n\n.mdi-file-export-outline::before {\n  content: \"\\F102E\";\n}\n\n.mdi-file-eye::before {\n  content: \"\\F0DCA\";\n}\n\n.mdi-file-eye-outline::before {\n  content: \"\\F0DCB\";\n}\n\n.mdi-file-find::before {\n  content: \"\\F021E\";\n}\n\n.mdi-file-find-outline::before {\n  content: \"\\F0B97\";\n}\n\n.mdi-file-gif-box::before {\n  content: \"\\F0D78\";\n}\n\n.mdi-file-hidden::before {\n  content: \"\\F0613\";\n}\n\n.mdi-file-image::before {\n  content: \"\\F021F\";\n}\n\n.mdi-file-image-marker::before {\n  content: \"\\F1772\";\n}\n\n.mdi-file-image-marker-outline::before {\n  content: \"\\F1773\";\n}\n\n.mdi-file-image-minus::before {\n  content: \"\\F193B\";\n}\n\n.mdi-file-image-minus-outline::before {\n  content: \"\\F193C\";\n}\n\n.mdi-file-image-outline::before {\n  content: \"\\F0EB0\";\n}\n\n.mdi-file-image-plus::before {\n  content: \"\\F193D\";\n}\n\n.mdi-file-image-plus-outline::before {\n  content: \"\\F193E\";\n}\n\n.mdi-file-image-remove::before {\n  content: \"\\F193F\";\n}\n\n.mdi-file-image-remove-outline::before {\n  content: \"\\F1940\";\n}\n\n.mdi-file-import::before {\n  content: \"\\F0220\";\n}\n\n.mdi-file-import-outline::before {\n  content: \"\\F102F\";\n}\n\n.mdi-file-jpg-box::before {\n  content: \"\\F0225\";\n}\n\n.mdi-file-key::before {\n  content: \"\\F1184\";\n}\n\n.mdi-file-key-outline::before {\n  content: \"\\F1185\";\n}\n\n.mdi-file-link::before {\n  content: \"\\F1177\";\n}\n\n.mdi-file-link-outline::before {\n  content: \"\\F1178\";\n}\n\n.mdi-file-lock::before {\n  content: \"\\F0221\";\n}\n\n.mdi-file-lock-outline::before {\n  content: \"\\F1030\";\n}\n\n.mdi-file-marker::before {\n  content: \"\\F1774\";\n}\n\n.mdi-file-marker-outline::before {\n  content: \"\\F1775\";\n}\n\n.mdi-file-move::before {\n  content: \"\\F0AB9\";\n}\n\n.mdi-file-move-outline::before {\n  content: \"\\F1031\";\n}\n\n.mdi-file-multiple::before {\n  content: \"\\F0222\";\n}\n\n.mdi-file-multiple-outline::before {\n  content: \"\\F1032\";\n}\n\n.mdi-file-music::before {\n  content: \"\\F0223\";\n}\n\n.mdi-file-music-outline::before {\n  content: \"\\F0E2A\";\n}\n\n.mdi-file-outline::before {\n  content: \"\\F0224\";\n}\n\n.mdi-file-pdf-box::before {\n  content: \"\\F0226\";\n}\n\n.mdi-file-percent::before {\n  content: \"\\F081E\";\n}\n\n.mdi-file-percent-outline::before {\n  content: \"\\F1033\";\n}\n\n.mdi-file-phone::before {\n  content: \"\\F1179\";\n}\n\n.mdi-file-phone-outline::before {\n  content: \"\\F117A\";\n}\n\n.mdi-file-plus::before {\n  content: \"\\F0752\";\n}\n\n.mdi-file-plus-outline::before {\n  content: \"\\F0EED\";\n}\n\n.mdi-file-png-box::before {\n  content: \"\\F0E2D\";\n}\n\n.mdi-file-powerpoint::before {\n  content: \"\\F0227\";\n}\n\n.mdi-file-powerpoint-box::before {\n  content: \"\\F0228\";\n}\n\n.mdi-file-powerpoint-box-outline::before {\n  content: \"\\F1034\";\n}\n\n.mdi-file-powerpoint-outline::before {\n  content: \"\\F1035\";\n}\n\n.mdi-file-presentation-box::before {\n  content: \"\\F0229\";\n}\n\n.mdi-file-question::before {\n  content: \"\\F086F\";\n}\n\n.mdi-file-question-outline::before {\n  content: \"\\F1036\";\n}\n\n.mdi-file-refresh::before {\n  content: \"\\F0918\";\n}\n\n.mdi-file-refresh-outline::before {\n  content: \"\\F0541\";\n}\n\n.mdi-file-remove::before {\n  content: \"\\F0B98\";\n}\n\n.mdi-file-remove-outline::before {\n  content: \"\\F1037\";\n}\n\n.mdi-file-replace::before {\n  content: \"\\F0B32\";\n}\n\n.mdi-file-replace-outline::before {\n  content: \"\\F0B33\";\n}\n\n.mdi-file-restore::before {\n  content: \"\\F0670\";\n}\n\n.mdi-file-restore-outline::before {\n  content: \"\\F1038\";\n}\n\n.mdi-file-search::before {\n  content: \"\\F0C7C\";\n}\n\n.mdi-file-search-outline::before {\n  content: \"\\F0C7D\";\n}\n\n.mdi-file-send::before {\n  content: \"\\F022A\";\n}\n\n.mdi-file-send-outline::before {\n  content: \"\\F1039\";\n}\n\n.mdi-file-settings::before {\n  content: \"\\F1079\";\n}\n\n.mdi-file-settings-outline::before {\n  content: \"\\F107A\";\n}\n\n.mdi-file-sign::before {\n  content: \"\\F19C3\";\n}\n\n.mdi-file-star::before {\n  content: \"\\F103A\";\n}\n\n.mdi-file-star-outline::before {\n  content: \"\\F103B\";\n}\n\n.mdi-file-swap::before {\n  content: \"\\F0FB4\";\n}\n\n.mdi-file-swap-outline::before {\n  content: \"\\F0FB5\";\n}\n\n.mdi-file-sync::before {\n  content: \"\\F1216\";\n}\n\n.mdi-file-sync-outline::before {\n  content: \"\\F1217\";\n}\n\n.mdi-file-table::before {\n  content: \"\\F0C7E\";\n}\n\n.mdi-file-table-box::before {\n  content: \"\\F10E1\";\n}\n\n.mdi-file-table-box-multiple::before {\n  content: \"\\F10E2\";\n}\n\n.mdi-file-table-box-multiple-outline::before {\n  content: \"\\F10E3\";\n}\n\n.mdi-file-table-box-outline::before {\n  content: \"\\F10E4\";\n}\n\n.mdi-file-table-outline::before {\n  content: \"\\F0C7F\";\n}\n\n.mdi-file-tree::before {\n  content: \"\\F0645\";\n}\n\n.mdi-file-tree-outline::before {\n  content: \"\\F13D2\";\n}\n\n.mdi-file-undo::before {\n  content: \"\\F08DC\";\n}\n\n.mdi-file-undo-outline::before {\n  content: \"\\F103C\";\n}\n\n.mdi-file-upload::before {\n  content: \"\\F0A4D\";\n}\n\n.mdi-file-upload-outline::before {\n  content: \"\\F0A4E\";\n}\n\n.mdi-file-video::before {\n  content: \"\\F022B\";\n}\n\n.mdi-file-video-outline::before {\n  content: \"\\F0E2C\";\n}\n\n.mdi-file-word::before {\n  content: \"\\F022C\";\n}\n\n.mdi-file-word-box::before {\n  content: \"\\F022D\";\n}\n\n.mdi-file-word-box-outline::before {\n  content: \"\\F103D\";\n}\n\n.mdi-file-word-outline::before {\n  content: \"\\F103E\";\n}\n\n.mdi-film::before {\n  content: \"\\F022F\";\n}\n\n.mdi-filmstrip::before {\n  content: \"\\F0230\";\n}\n\n.mdi-filmstrip-box::before {\n  content: \"\\F0332\";\n}\n\n.mdi-filmstrip-box-multiple::before {\n  content: \"\\F0D18\";\n}\n\n.mdi-filmstrip-off::before {\n  content: \"\\F0231\";\n}\n\n.mdi-filter::before {\n  content: \"\\F0232\";\n}\n\n.mdi-filter-check::before {\n  content: \"\\F18EC\";\n}\n\n.mdi-filter-check-outline::before {\n  content: \"\\F18ED\";\n}\n\n.mdi-filter-menu::before {\n  content: \"\\F10E5\";\n}\n\n.mdi-filter-menu-outline::before {\n  content: \"\\F10E6\";\n}\n\n.mdi-filter-minus::before {\n  content: \"\\F0EEE\";\n}\n\n.mdi-filter-minus-outline::before {\n  content: \"\\F0EEF\";\n}\n\n.mdi-filter-off::before {\n  content: \"\\F14EF\";\n}\n\n.mdi-filter-off-outline::before {\n  content: \"\\F14F0\";\n}\n\n.mdi-filter-outline::before {\n  content: \"\\F0233\";\n}\n\n.mdi-filter-plus::before {\n  content: \"\\F0EF0\";\n}\n\n.mdi-filter-plus-outline::before {\n  content: \"\\F0EF1\";\n}\n\n.mdi-filter-remove::before {\n  content: \"\\F0234\";\n}\n\n.mdi-filter-remove-outline::before {\n  content: \"\\F0235\";\n}\n\n.mdi-filter-variant::before {\n  content: \"\\F0236\";\n}\n\n.mdi-filter-variant-minus::before {\n  content: \"\\F1112\";\n}\n\n.mdi-filter-variant-plus::before {\n  content: \"\\F1113\";\n}\n\n.mdi-filter-variant-remove::before {\n  content: \"\\F103F\";\n}\n\n.mdi-finance::before {\n  content: \"\\F081F\";\n}\n\n.mdi-find-replace::before {\n  content: \"\\F06D4\";\n}\n\n.mdi-fingerprint::before {\n  content: \"\\F0237\";\n}\n\n.mdi-fingerprint-off::before {\n  content: \"\\F0EB1\";\n}\n\n.mdi-fire::before {\n  content: \"\\F0238\";\n}\n\n.mdi-fire-alert::before {\n  content: \"\\F15D7\";\n}\n\n.mdi-fire-circle::before {\n  content: \"\\F1807\";\n}\n\n.mdi-fire-extinguisher::before {\n  content: \"\\F0EF2\";\n}\n\n.mdi-fire-hydrant::before {\n  content: \"\\F1137\";\n}\n\n.mdi-fire-hydrant-alert::before {\n  content: \"\\F1138\";\n}\n\n.mdi-fire-hydrant-off::before {\n  content: \"\\F1139\";\n}\n\n.mdi-fire-off::before {\n  content: \"\\F1722\";\n}\n\n.mdi-fire-truck::before {\n  content: \"\\F08AB\";\n}\n\n.mdi-firebase::before {\n  content: \"\\F0967\";\n}\n\n.mdi-firefox::before {\n  content: \"\\F0239\";\n}\n\n.mdi-fireplace::before {\n  content: \"\\F0E2E\";\n}\n\n.mdi-fireplace-off::before {\n  content: \"\\F0E2F\";\n}\n\n.mdi-firewire::before {\n  content: \"\\F05BE\";\n}\n\n.mdi-firework::before {\n  content: \"\\F0E30\";\n}\n\n.mdi-firework-off::before {\n  content: \"\\F1723\";\n}\n\n.mdi-fish::before {\n  content: \"\\F023A\";\n}\n\n.mdi-fish-off::before {\n  content: \"\\F13F3\";\n}\n\n.mdi-fishbowl::before {\n  content: \"\\F0EF3\";\n}\n\n.mdi-fishbowl-outline::before {\n  content: \"\\F0EF4\";\n}\n\n.mdi-fit-to-page::before {\n  content: \"\\F0EF5\";\n}\n\n.mdi-fit-to-page-outline::before {\n  content: \"\\F0EF6\";\n}\n\n.mdi-fit-to-screen::before {\n  content: \"\\F18F4\";\n}\n\n.mdi-fit-to-screen-outline::before {\n  content: \"\\F18F5\";\n}\n\n.mdi-flag::before {\n  content: \"\\F023B\";\n}\n\n.mdi-flag-checkered::before {\n  content: \"\\F023C\";\n}\n\n.mdi-flag-minus::before {\n  content: \"\\F0B99\";\n}\n\n.mdi-flag-minus-outline::before {\n  content: \"\\F10B2\";\n}\n\n.mdi-flag-off::before {\n  content: \"\\F18EE\";\n}\n\n.mdi-flag-off-outline::before {\n  content: \"\\F18EF\";\n}\n\n.mdi-flag-outline::before {\n  content: \"\\F023D\";\n}\n\n.mdi-flag-plus::before {\n  content: \"\\F0B9A\";\n}\n\n.mdi-flag-plus-outline::before {\n  content: \"\\F10B3\";\n}\n\n.mdi-flag-remove::before {\n  content: \"\\F0B9B\";\n}\n\n.mdi-flag-remove-outline::before {\n  content: \"\\F10B4\";\n}\n\n.mdi-flag-triangle::before {\n  content: \"\\F023F\";\n}\n\n.mdi-flag-variant::before {\n  content: \"\\F0240\";\n}\n\n.mdi-flag-variant-outline::before {\n  content: \"\\F023E\";\n}\n\n.mdi-flare::before {\n  content: \"\\F0D72\";\n}\n\n.mdi-flash::before {\n  content: \"\\F0241\";\n}\n\n.mdi-flash-alert::before {\n  content: \"\\F0EF7\";\n}\n\n.mdi-flash-alert-outline::before {\n  content: \"\\F0EF8\";\n}\n\n.mdi-flash-auto::before {\n  content: \"\\F0242\";\n}\n\n.mdi-flash-off::before {\n  content: \"\\F0243\";\n}\n\n.mdi-flash-outline::before {\n  content: \"\\F06D5\";\n}\n\n.mdi-flash-red-eye::before {\n  content: \"\\F067B\";\n}\n\n.mdi-flashlight::before {\n  content: \"\\F0244\";\n}\n\n.mdi-flashlight-off::before {\n  content: \"\\F0245\";\n}\n\n.mdi-flask::before {\n  content: \"\\F0093\";\n}\n\n.mdi-flask-empty::before {\n  content: \"\\F0094\";\n}\n\n.mdi-flask-empty-minus::before {\n  content: \"\\F123A\";\n}\n\n.mdi-flask-empty-minus-outline::before {\n  content: \"\\F123B\";\n}\n\n.mdi-flask-empty-off::before {\n  content: \"\\F13F4\";\n}\n\n.mdi-flask-empty-off-outline::before {\n  content: \"\\F13F5\";\n}\n\n.mdi-flask-empty-outline::before {\n  content: \"\\F0095\";\n}\n\n.mdi-flask-empty-plus::before {\n  content: \"\\F123C\";\n}\n\n.mdi-flask-empty-plus-outline::before {\n  content: \"\\F123D\";\n}\n\n.mdi-flask-empty-remove::before {\n  content: \"\\F123E\";\n}\n\n.mdi-flask-empty-remove-outline::before {\n  content: \"\\F123F\";\n}\n\n.mdi-flask-minus::before {\n  content: \"\\F1240\";\n}\n\n.mdi-flask-minus-outline::before {\n  content: \"\\F1241\";\n}\n\n.mdi-flask-off::before {\n  content: \"\\F13F6\";\n}\n\n.mdi-flask-off-outline::before {\n  content: \"\\F13F7\";\n}\n\n.mdi-flask-outline::before {\n  content: \"\\F0096\";\n}\n\n.mdi-flask-plus::before {\n  content: \"\\F1242\";\n}\n\n.mdi-flask-plus-outline::before {\n  content: \"\\F1243\";\n}\n\n.mdi-flask-remove::before {\n  content: \"\\F1244\";\n}\n\n.mdi-flask-remove-outline::before {\n  content: \"\\F1245\";\n}\n\n.mdi-flask-round-bottom::before {\n  content: \"\\F124B\";\n}\n\n.mdi-flask-round-bottom-empty::before {\n  content: \"\\F124C\";\n}\n\n.mdi-flask-round-bottom-empty-outline::before {\n  content: \"\\F124D\";\n}\n\n.mdi-flask-round-bottom-outline::before {\n  content: \"\\F124E\";\n}\n\n.mdi-fleur-de-lis::before {\n  content: \"\\F1303\";\n}\n\n.mdi-flip-horizontal::before {\n  content: \"\\F10E7\";\n}\n\n.mdi-flip-to-back::before {\n  content: \"\\F0247\";\n}\n\n.mdi-flip-to-front::before {\n  content: \"\\F0248\";\n}\n\n.mdi-flip-vertical::before {\n  content: \"\\F10E8\";\n}\n\n.mdi-floor-lamp::before {\n  content: \"\\F08DD\";\n}\n\n.mdi-floor-lamp-dual::before {\n  content: \"\\F1040\";\n}\n\n.mdi-floor-lamp-dual-outline::before {\n  content: \"\\F17CE\";\n}\n\n.mdi-floor-lamp-outline::before {\n  content: \"\\F17C8\";\n}\n\n.mdi-floor-lamp-torchiere::before {\n  content: \"\\F1747\";\n}\n\n.mdi-floor-lamp-torchiere-outline::before {\n  content: \"\\F17D6\";\n}\n\n.mdi-floor-lamp-torchiere-variant::before {\n  content: \"\\F1041\";\n}\n\n.mdi-floor-lamp-torchiere-variant-outline::before {\n  content: \"\\F17CF\";\n}\n\n.mdi-floor-plan::before {\n  content: \"\\F0821\";\n}\n\n.mdi-floppy::before {\n  content: \"\\F0249\";\n}\n\n.mdi-floppy-variant::before {\n  content: \"\\F09EF\";\n}\n\n.mdi-flower::before {\n  content: \"\\F024A\";\n}\n\n.mdi-flower-outline::before {\n  content: \"\\F09F0\";\n}\n\n.mdi-flower-pollen::before {\n  content: \"\\F1885\";\n}\n\n.mdi-flower-pollen-outline::before {\n  content: \"\\F1886\";\n}\n\n.mdi-flower-poppy::before {\n  content: \"\\F0D08\";\n}\n\n.mdi-flower-tulip::before {\n  content: \"\\F09F1\";\n}\n\n.mdi-flower-tulip-outline::before {\n  content: \"\\F09F2\";\n}\n\n.mdi-focus-auto::before {\n  content: \"\\F0F4E\";\n}\n\n.mdi-focus-field::before {\n  content: \"\\F0F4F\";\n}\n\n.mdi-focus-field-horizontal::before {\n  content: \"\\F0F50\";\n}\n\n.mdi-focus-field-vertical::before {\n  content: \"\\F0F51\";\n}\n\n.mdi-folder::before {\n  content: \"\\F024B\";\n}\n\n.mdi-folder-account::before {\n  content: \"\\F024C\";\n}\n\n.mdi-folder-account-outline::before {\n  content: \"\\F0B9C\";\n}\n\n.mdi-folder-alert::before {\n  content: \"\\F0DCC\";\n}\n\n.mdi-folder-alert-outline::before {\n  content: \"\\F0DCD\";\n}\n\n.mdi-folder-check::before {\n  content: \"\\F197E\";\n}\n\n.mdi-folder-check-outline::before {\n  content: \"\\F197F\";\n}\n\n.mdi-folder-clock::before {\n  content: \"\\F0ABA\";\n}\n\n.mdi-folder-clock-outline::before {\n  content: \"\\F0ABB\";\n}\n\n.mdi-folder-cog::before {\n  content: \"\\F107F\";\n}\n\n.mdi-folder-cog-outline::before {\n  content: \"\\F1080\";\n}\n\n.mdi-folder-download::before {\n  content: \"\\F024D\";\n}\n\n.mdi-folder-download-outline::before {\n  content: \"\\F10E9\";\n}\n\n.mdi-folder-edit::before {\n  content: \"\\F08DE\";\n}\n\n.mdi-folder-edit-outline::before {\n  content: \"\\F0DCE\";\n}\n\n.mdi-folder-eye::before {\n  content: \"\\F178A\";\n}\n\n.mdi-folder-eye-outline::before {\n  content: \"\\F178B\";\n}\n\n.mdi-folder-google-drive::before {\n  content: \"\\F024E\";\n}\n\n.mdi-folder-heart::before {\n  content: \"\\F10EA\";\n}\n\n.mdi-folder-heart-outline::before {\n  content: \"\\F10EB\";\n}\n\n.mdi-folder-hidden::before {\n  content: \"\\F179E\";\n}\n\n.mdi-folder-home::before {\n  content: \"\\F10B5\";\n}\n\n.mdi-folder-home-outline::before {\n  content: \"\\F10B6\";\n}\n\n.mdi-folder-image::before {\n  content: \"\\F024F\";\n}\n\n.mdi-folder-information::before {\n  content: \"\\F10B7\";\n}\n\n.mdi-folder-information-outline::before {\n  content: \"\\F10B8\";\n}\n\n.mdi-folder-key::before {\n  content: \"\\F08AC\";\n}\n\n.mdi-folder-key-network::before {\n  content: \"\\F08AD\";\n}\n\n.mdi-folder-key-network-outline::before {\n  content: \"\\F0C80\";\n}\n\n.mdi-folder-key-outline::before {\n  content: \"\\F10EC\";\n}\n\n.mdi-folder-lock::before {\n  content: \"\\F0250\";\n}\n\n.mdi-folder-lock-open::before {\n  content: \"\\F0251\";\n}\n\n.mdi-folder-marker::before {\n  content: \"\\F126D\";\n}\n\n.mdi-folder-marker-outline::before {\n  content: \"\\F126E\";\n}\n\n.mdi-folder-move::before {\n  content: \"\\F0252\";\n}\n\n.mdi-folder-move-outline::before {\n  content: \"\\F1246\";\n}\n\n.mdi-folder-multiple::before {\n  content: \"\\F0253\";\n}\n\n.mdi-folder-multiple-image::before {\n  content: \"\\F0254\";\n}\n\n.mdi-folder-multiple-outline::before {\n  content: \"\\F0255\";\n}\n\n.mdi-folder-multiple-plus::before {\n  content: \"\\F147E\";\n}\n\n.mdi-folder-multiple-plus-outline::before {\n  content: \"\\F147F\";\n}\n\n.mdi-folder-music::before {\n  content: \"\\F1359\";\n}\n\n.mdi-folder-music-outline::before {\n  content: \"\\F135A\";\n}\n\n.mdi-folder-network::before {\n  content: \"\\F0870\";\n}\n\n.mdi-folder-network-outline::before {\n  content: \"\\F0C81\";\n}\n\n.mdi-folder-open::before {\n  content: \"\\F0770\";\n}\n\n.mdi-folder-open-outline::before {\n  content: \"\\F0DCF\";\n}\n\n.mdi-folder-outline::before {\n  content: \"\\F0256\";\n}\n\n.mdi-folder-plus::before {\n  content: \"\\F0257\";\n}\n\n.mdi-folder-plus-outline::before {\n  content: \"\\F0B9D\";\n}\n\n.mdi-folder-pound::before {\n  content: \"\\F0D09\";\n}\n\n.mdi-folder-pound-outline::before {\n  content: \"\\F0D0A\";\n}\n\n.mdi-folder-refresh::before {\n  content: \"\\F0749\";\n}\n\n.mdi-folder-refresh-outline::before {\n  content: \"\\F0542\";\n}\n\n.mdi-folder-remove::before {\n  content: \"\\F0258\";\n}\n\n.mdi-folder-remove-outline::before {\n  content: \"\\F0B9E\";\n}\n\n.mdi-folder-search::before {\n  content: \"\\F0968\";\n}\n\n.mdi-folder-search-outline::before {\n  content: \"\\F0969\";\n}\n\n.mdi-folder-settings::before {\n  content: \"\\F107D\";\n}\n\n.mdi-folder-settings-outline::before {\n  content: \"\\F107E\";\n}\n\n.mdi-folder-star::before {\n  content: \"\\F069D\";\n}\n\n.mdi-folder-star-multiple::before {\n  content: \"\\F13D3\";\n}\n\n.mdi-folder-star-multiple-outline::before {\n  content: \"\\F13D4\";\n}\n\n.mdi-folder-star-outline::before {\n  content: \"\\F0B9F\";\n}\n\n.mdi-folder-swap::before {\n  content: \"\\F0FB6\";\n}\n\n.mdi-folder-swap-outline::before {\n  content: \"\\F0FB7\";\n}\n\n.mdi-folder-sync::before {\n  content: \"\\F0D0B\";\n}\n\n.mdi-folder-sync-outline::before {\n  content: \"\\F0D0C\";\n}\n\n.mdi-folder-table::before {\n  content: \"\\F12E3\";\n}\n\n.mdi-folder-table-outline::before {\n  content: \"\\F12E4\";\n}\n\n.mdi-folder-text::before {\n  content: \"\\F0C82\";\n}\n\n.mdi-folder-text-outline::before {\n  content: \"\\F0C83\";\n}\n\n.mdi-folder-upload::before {\n  content: \"\\F0259\";\n}\n\n.mdi-folder-upload-outline::before {\n  content: \"\\F10ED\";\n}\n\n.mdi-folder-zip::before {\n  content: \"\\F06EB\";\n}\n\n.mdi-folder-zip-outline::before {\n  content: \"\\F07B9\";\n}\n\n.mdi-font-awesome::before {\n  content: \"\\F003A\";\n}\n\n.mdi-food::before {\n  content: \"\\F025A\";\n}\n\n.mdi-food-apple::before {\n  content: \"\\F025B\";\n}\n\n.mdi-food-apple-outline::before {\n  content: \"\\F0C84\";\n}\n\n.mdi-food-croissant::before {\n  content: \"\\F07C8\";\n}\n\n.mdi-food-drumstick::before {\n  content: \"\\F141F\";\n}\n\n.mdi-food-drumstick-off::before {\n  content: \"\\F1468\";\n}\n\n.mdi-food-drumstick-off-outline::before {\n  content: \"\\F1469\";\n}\n\n.mdi-food-drumstick-outline::before {\n  content: \"\\F1420\";\n}\n\n.mdi-food-fork-drink::before {\n  content: \"\\F05F2\";\n}\n\n.mdi-food-halal::before {\n  content: \"\\F1572\";\n}\n\n.mdi-food-hot-dog::before {\n  content: \"\\F184B\";\n}\n\n.mdi-food-kosher::before {\n  content: \"\\F1573\";\n}\n\n.mdi-food-off::before {\n  content: \"\\F05F3\";\n}\n\n.mdi-food-off-outline::before {\n  content: \"\\F1915\";\n}\n\n.mdi-food-outline::before {\n  content: \"\\F1916\";\n}\n\n.mdi-food-steak::before {\n  content: \"\\F146A\";\n}\n\n.mdi-food-steak-off::before {\n  content: \"\\F146B\";\n}\n\n.mdi-food-takeout-box::before {\n  content: \"\\F1836\";\n}\n\n.mdi-food-takeout-box-outline::before {\n  content: \"\\F1837\";\n}\n\n.mdi-food-turkey::before {\n  content: \"\\F171C\";\n}\n\n.mdi-food-variant::before {\n  content: \"\\F025C\";\n}\n\n.mdi-food-variant-off::before {\n  content: \"\\F13E5\";\n}\n\n.mdi-foot-print::before {\n  content: \"\\F0F52\";\n}\n\n.mdi-football::before {\n  content: \"\\F025D\";\n}\n\n.mdi-football-australian::before {\n  content: \"\\F025E\";\n}\n\n.mdi-football-helmet::before {\n  content: \"\\F025F\";\n}\n\n.mdi-forest::before {\n  content: \"\\F1897\";\n}\n\n.mdi-forklift::before {\n  content: \"\\F07C9\";\n}\n\n.mdi-form-dropdown::before {\n  content: \"\\F1400\";\n}\n\n.mdi-form-select::before {\n  content: \"\\F1401\";\n}\n\n.mdi-form-textarea::before {\n  content: \"\\F1095\";\n}\n\n.mdi-form-textbox::before {\n  content: \"\\F060E\";\n}\n\n.mdi-form-textbox-lock::before {\n  content: \"\\F135D\";\n}\n\n.mdi-form-textbox-password::before {\n  content: \"\\F07F5\";\n}\n\n.mdi-format-align-bottom::before {\n  content: \"\\F0753\";\n}\n\n.mdi-format-align-center::before {\n  content: \"\\F0260\";\n}\n\n.mdi-format-align-justify::before {\n  content: \"\\F0261\";\n}\n\n.mdi-format-align-left::before {\n  content: \"\\F0262\";\n}\n\n.mdi-format-align-middle::before {\n  content: \"\\F0754\";\n}\n\n.mdi-format-align-right::before {\n  content: \"\\F0263\";\n}\n\n.mdi-format-align-top::before {\n  content: \"\\F0755\";\n}\n\n.mdi-format-annotation-minus::before {\n  content: \"\\F0ABC\";\n}\n\n.mdi-format-annotation-plus::before {\n  content: \"\\F0646\";\n}\n\n.mdi-format-bold::before {\n  content: \"\\F0264\";\n}\n\n.mdi-format-clear::before {\n  content: \"\\F0265\";\n}\n\n.mdi-format-color-fill::before {\n  content: \"\\F0266\";\n}\n\n.mdi-format-color-highlight::before {\n  content: \"\\F0E31\";\n}\n\n.mdi-format-color-marker-cancel::before {\n  content: \"\\F1313\";\n}\n\n.mdi-format-color-text::before {\n  content: \"\\F069E\";\n}\n\n.mdi-format-columns::before {\n  content: \"\\F08DF\";\n}\n\n.mdi-format-float-center::before {\n  content: \"\\F0267\";\n}\n\n.mdi-format-float-left::before {\n  content: \"\\F0268\";\n}\n\n.mdi-format-float-none::before {\n  content: \"\\F0269\";\n}\n\n.mdi-format-float-right::before {\n  content: \"\\F026A\";\n}\n\n.mdi-format-font::before {\n  content: \"\\F06D6\";\n}\n\n.mdi-format-font-size-decrease::before {\n  content: \"\\F09F3\";\n}\n\n.mdi-format-font-size-increase::before {\n  content: \"\\F09F4\";\n}\n\n.mdi-format-header-1::before {\n  content: \"\\F026B\";\n}\n\n.mdi-format-header-2::before {\n  content: \"\\F026C\";\n}\n\n.mdi-format-header-3::before {\n  content: \"\\F026D\";\n}\n\n.mdi-format-header-4::before {\n  content: \"\\F026E\";\n}\n\n.mdi-format-header-5::before {\n  content: \"\\F026F\";\n}\n\n.mdi-format-header-6::before {\n  content: \"\\F0270\";\n}\n\n.mdi-format-header-decrease::before {\n  content: \"\\F0271\";\n}\n\n.mdi-format-header-equal::before {\n  content: \"\\F0272\";\n}\n\n.mdi-format-header-increase::before {\n  content: \"\\F0273\";\n}\n\n.mdi-format-header-pound::before {\n  content: \"\\F0274\";\n}\n\n.mdi-format-horizontal-align-center::before {\n  content: \"\\F061E\";\n}\n\n.mdi-format-horizontal-align-left::before {\n  content: \"\\F061F\";\n}\n\n.mdi-format-horizontal-align-right::before {\n  content: \"\\F0620\";\n}\n\n.mdi-format-indent-decrease::before {\n  content: \"\\F0275\";\n}\n\n.mdi-format-indent-increase::before {\n  content: \"\\F0276\";\n}\n\n.mdi-format-italic::before {\n  content: \"\\F0277\";\n}\n\n.mdi-format-letter-case::before {\n  content: \"\\F0B34\";\n}\n\n.mdi-format-letter-case-lower::before {\n  content: \"\\F0B35\";\n}\n\n.mdi-format-letter-case-upper::before {\n  content: \"\\F0B36\";\n}\n\n.mdi-format-letter-ends-with::before {\n  content: \"\\F0FB8\";\n}\n\n.mdi-format-letter-matches::before {\n  content: \"\\F0FB9\";\n}\n\n.mdi-format-letter-spacing::before {\n  content: \"\\F1956\";\n}\n\n.mdi-format-letter-starts-with::before {\n  content: \"\\F0FBA\";\n}\n\n.mdi-format-line-spacing::before {\n  content: \"\\F0278\";\n}\n\n.mdi-format-line-style::before {\n  content: \"\\F05C8\";\n}\n\n.mdi-format-line-weight::before {\n  content: \"\\F05C9\";\n}\n\n.mdi-format-list-bulleted::before {\n  content: \"\\F0279\";\n}\n\n.mdi-format-list-bulleted-square::before {\n  content: \"\\F0DD0\";\n}\n\n.mdi-format-list-bulleted-triangle::before {\n  content: \"\\F0EB2\";\n}\n\n.mdi-format-list-bulleted-type::before {\n  content: \"\\F027A\";\n}\n\n.mdi-format-list-checkbox::before {\n  content: \"\\F096A\";\n}\n\n.mdi-format-list-checks::before {\n  content: \"\\F0756\";\n}\n\n.mdi-format-list-group::before {\n  content: \"\\F1860\";\n}\n\n.mdi-format-list-numbered::before {\n  content: \"\\F027B\";\n}\n\n.mdi-format-list-numbered-rtl::before {\n  content: \"\\F0D0D\";\n}\n\n.mdi-format-list-text::before {\n  content: \"\\F126F\";\n}\n\n.mdi-format-overline::before {\n  content: \"\\F0EB3\";\n}\n\n.mdi-format-page-break::before {\n  content: \"\\F06D7\";\n}\n\n.mdi-format-page-split::before {\n  content: \"\\F1917\";\n}\n\n.mdi-format-paint::before {\n  content: \"\\F027C\";\n}\n\n.mdi-format-paragraph::before {\n  content: \"\\F027D\";\n}\n\n.mdi-format-pilcrow::before {\n  content: \"\\F06D8\";\n}\n\n.mdi-format-quote-close::before {\n  content: \"\\F027E\";\n}\n\n.mdi-format-quote-close-outline::before {\n  content: \"\\F11A8\";\n}\n\n.mdi-format-quote-open::before {\n  content: \"\\F0757\";\n}\n\n.mdi-format-quote-open-outline::before {\n  content: \"\\F11A7\";\n}\n\n.mdi-format-rotate-90::before {\n  content: \"\\F06AA\";\n}\n\n.mdi-format-section::before {\n  content: \"\\F069F\";\n}\n\n.mdi-format-size::before {\n  content: \"\\F027F\";\n}\n\n.mdi-format-strikethrough::before {\n  content: \"\\F0280\";\n}\n\n.mdi-format-strikethrough-variant::before {\n  content: \"\\F0281\";\n}\n\n.mdi-format-subscript::before {\n  content: \"\\F0282\";\n}\n\n.mdi-format-superscript::before {\n  content: \"\\F0283\";\n}\n\n.mdi-format-text::before {\n  content: \"\\F0284\";\n}\n\n.mdi-format-text-rotation-angle-down::before {\n  content: \"\\F0FBB\";\n}\n\n.mdi-format-text-rotation-angle-up::before {\n  content: \"\\F0FBC\";\n}\n\n.mdi-format-text-rotation-down::before {\n  content: \"\\F0D73\";\n}\n\n.mdi-format-text-rotation-down-vertical::before {\n  content: \"\\F0FBD\";\n}\n\n.mdi-format-text-rotation-none::before {\n  content: \"\\F0D74\";\n}\n\n.mdi-format-text-rotation-up::before {\n  content: \"\\F0FBE\";\n}\n\n.mdi-format-text-rotation-vertical::before {\n  content: \"\\F0FBF\";\n}\n\n.mdi-format-text-variant::before {\n  content: \"\\F0E32\";\n}\n\n.mdi-format-text-variant-outline::before {\n  content: \"\\F150F\";\n}\n\n.mdi-format-text-wrapping-clip::before {\n  content: \"\\F0D0E\";\n}\n\n.mdi-format-text-wrapping-overflow::before {\n  content: \"\\F0D0F\";\n}\n\n.mdi-format-text-wrapping-wrap::before {\n  content: \"\\F0D10\";\n}\n\n.mdi-format-textbox::before {\n  content: \"\\F0D11\";\n}\n\n.mdi-format-textdirection-l-to-r::before {\n  content: \"\\F0285\";\n}\n\n.mdi-format-textdirection-r-to-l::before {\n  content: \"\\F0286\";\n}\n\n.mdi-format-title::before {\n  content: \"\\F05F4\";\n}\n\n.mdi-format-underline::before {\n  content: \"\\F0287\";\n}\n\n.mdi-format-underline-wavy::before {\n  content: \"\\F18E9\";\n}\n\n.mdi-format-vertical-align-bottom::before {\n  content: \"\\F0621\";\n}\n\n.mdi-format-vertical-align-center::before {\n  content: \"\\F0622\";\n}\n\n.mdi-format-vertical-align-top::before {\n  content: \"\\F0623\";\n}\n\n.mdi-format-wrap-inline::before {\n  content: \"\\F0288\";\n}\n\n.mdi-format-wrap-square::before {\n  content: \"\\F0289\";\n}\n\n.mdi-format-wrap-tight::before {\n  content: \"\\F028A\";\n}\n\n.mdi-format-wrap-top-bottom::before {\n  content: \"\\F028B\";\n}\n\n.mdi-forum::before {\n  content: \"\\F028C\";\n}\n\n.mdi-forum-outline::before {\n  content: \"\\F0822\";\n}\n\n.mdi-forward::before {\n  content: \"\\F028D\";\n}\n\n.mdi-forwardburger::before {\n  content: \"\\F0D75\";\n}\n\n.mdi-fountain::before {\n  content: \"\\F096B\";\n}\n\n.mdi-fountain-pen::before {\n  content: \"\\F0D12\";\n}\n\n.mdi-fountain-pen-tip::before {\n  content: \"\\F0D13\";\n}\n\n.mdi-fraction-one-half::before {\n  content: \"\\F1992\";\n}\n\n.mdi-freebsd::before {\n  content: \"\\F08E0\";\n}\n\n.mdi-french-fries::before {\n  content: \"\\F1957\";\n}\n\n.mdi-frequently-asked-questions::before {\n  content: \"\\F0EB4\";\n}\n\n.mdi-fridge::before {\n  content: \"\\F0290\";\n}\n\n.mdi-fridge-alert::before {\n  content: \"\\F11B1\";\n}\n\n.mdi-fridge-alert-outline::before {\n  content: \"\\F11B2\";\n}\n\n.mdi-fridge-bottom::before {\n  content: \"\\F0292\";\n}\n\n.mdi-fridge-industrial::before {\n  content: \"\\F15EE\";\n}\n\n.mdi-fridge-industrial-alert::before {\n  content: \"\\F15EF\";\n}\n\n.mdi-fridge-industrial-alert-outline::before {\n  content: \"\\F15F0\";\n}\n\n.mdi-fridge-industrial-off::before {\n  content: \"\\F15F1\";\n}\n\n.mdi-fridge-industrial-off-outline::before {\n  content: \"\\F15F2\";\n}\n\n.mdi-fridge-industrial-outline::before {\n  content: \"\\F15F3\";\n}\n\n.mdi-fridge-off::before {\n  content: \"\\F11AF\";\n}\n\n.mdi-fridge-off-outline::before {\n  content: \"\\F11B0\";\n}\n\n.mdi-fridge-outline::before {\n  content: \"\\F028F\";\n}\n\n.mdi-fridge-top::before {\n  content: \"\\F0291\";\n}\n\n.mdi-fridge-variant::before {\n  content: \"\\F15F4\";\n}\n\n.mdi-fridge-variant-alert::before {\n  content: \"\\F15F5\";\n}\n\n.mdi-fridge-variant-alert-outline::before {\n  content: \"\\F15F6\";\n}\n\n.mdi-fridge-variant-off::before {\n  content: \"\\F15F7\";\n}\n\n.mdi-fridge-variant-off-outline::before {\n  content: \"\\F15F8\";\n}\n\n.mdi-fridge-variant-outline::before {\n  content: \"\\F15F9\";\n}\n\n.mdi-fruit-cherries::before {\n  content: \"\\F1042\";\n}\n\n.mdi-fruit-cherries-off::before {\n  content: \"\\F13F8\";\n}\n\n.mdi-fruit-citrus::before {\n  content: \"\\F1043\";\n}\n\n.mdi-fruit-citrus-off::before {\n  content: \"\\F13F9\";\n}\n\n.mdi-fruit-grapes::before {\n  content: \"\\F1044\";\n}\n\n.mdi-fruit-grapes-outline::before {\n  content: \"\\F1045\";\n}\n\n.mdi-fruit-pineapple::before {\n  content: \"\\F1046\";\n}\n\n.mdi-fruit-watermelon::before {\n  content: \"\\F1047\";\n}\n\n.mdi-fuel::before {\n  content: \"\\F07CA\";\n}\n\n.mdi-fuel-cell::before {\n  content: \"\\F18B5\";\n}\n\n.mdi-fullscreen::before {\n  content: \"\\F0293\";\n}\n\n.mdi-fullscreen-exit::before {\n  content: \"\\F0294\";\n}\n\n.mdi-function::before {\n  content: \"\\F0295\";\n}\n\n.mdi-function-variant::before {\n  content: \"\\F0871\";\n}\n\n.mdi-furigana-horizontal::before {\n  content: \"\\F1081\";\n}\n\n.mdi-furigana-vertical::before {\n  content: \"\\F1082\";\n}\n\n.mdi-fuse::before {\n  content: \"\\F0C85\";\n}\n\n.mdi-fuse-alert::before {\n  content: \"\\F142D\";\n}\n\n.mdi-fuse-blade::before {\n  content: \"\\F0C86\";\n}\n\n.mdi-fuse-off::before {\n  content: \"\\F142C\";\n}\n\n.mdi-gamepad::before {\n  content: \"\\F0296\";\n}\n\n.mdi-gamepad-circle::before {\n  content: \"\\F0E33\";\n}\n\n.mdi-gamepad-circle-down::before {\n  content: \"\\F0E34\";\n}\n\n.mdi-gamepad-circle-left::before {\n  content: \"\\F0E35\";\n}\n\n.mdi-gamepad-circle-outline::before {\n  content: \"\\F0E36\";\n}\n\n.mdi-gamepad-circle-right::before {\n  content: \"\\F0E37\";\n}\n\n.mdi-gamepad-circle-up::before {\n  content: \"\\F0E38\";\n}\n\n.mdi-gamepad-down::before {\n  content: \"\\F0E39\";\n}\n\n.mdi-gamepad-left::before {\n  content: \"\\F0E3A\";\n}\n\n.mdi-gamepad-outline::before {\n  content: \"\\F1919\";\n}\n\n.mdi-gamepad-right::before {\n  content: \"\\F0E3B\";\n}\n\n.mdi-gamepad-round::before {\n  content: \"\\F0E3C\";\n}\n\n.mdi-gamepad-round-down::before {\n  content: \"\\F0E3D\";\n}\n\n.mdi-gamepad-round-left::before {\n  content: \"\\F0E3E\";\n}\n\n.mdi-gamepad-round-outline::before {\n  content: \"\\F0E3F\";\n}\n\n.mdi-gamepad-round-right::before {\n  content: \"\\F0E40\";\n}\n\n.mdi-gamepad-round-up::before {\n  content: \"\\F0E41\";\n}\n\n.mdi-gamepad-square::before {\n  content: \"\\F0EB5\";\n}\n\n.mdi-gamepad-square-outline::before {\n  content: \"\\F0EB6\";\n}\n\n.mdi-gamepad-up::before {\n  content: \"\\F0E42\";\n}\n\n.mdi-gamepad-variant::before {\n  content: \"\\F0297\";\n}\n\n.mdi-gamepad-variant-outline::before {\n  content: \"\\F0EB7\";\n}\n\n.mdi-gamma::before {\n  content: \"\\F10EE\";\n}\n\n.mdi-gantry-crane::before {\n  content: \"\\F0DD1\";\n}\n\n.mdi-garage::before {\n  content: \"\\F06D9\";\n}\n\n.mdi-garage-alert::before {\n  content: \"\\F0872\";\n}\n\n.mdi-garage-alert-variant::before {\n  content: \"\\F12D5\";\n}\n\n.mdi-garage-lock::before {\n  content: \"\\F17FB\";\n}\n\n.mdi-garage-open::before {\n  content: \"\\F06DA\";\n}\n\n.mdi-garage-open-variant::before {\n  content: \"\\F12D4\";\n}\n\n.mdi-garage-variant::before {\n  content: \"\\F12D3\";\n}\n\n.mdi-garage-variant-lock::before {\n  content: \"\\F17FC\";\n}\n\n.mdi-gas-cylinder::before {\n  content: \"\\F0647\";\n}\n\n.mdi-gas-station::before {\n  content: \"\\F0298\";\n}\n\n.mdi-gas-station-off::before {\n  content: \"\\F1409\";\n}\n\n.mdi-gas-station-off-outline::before {\n  content: \"\\F140A\";\n}\n\n.mdi-gas-station-outline::before {\n  content: \"\\F0EB8\";\n}\n\n.mdi-gate::before {\n  content: \"\\F0299\";\n}\n\n.mdi-gate-alert::before {\n  content: \"\\F17F8\";\n}\n\n.mdi-gate-and::before {\n  content: \"\\F08E1\";\n}\n\n.mdi-gate-arrow-left::before {\n  content: \"\\F17F7\";\n}\n\n.mdi-gate-arrow-right::before {\n  content: \"\\F1169\";\n}\n\n.mdi-gate-nand::before {\n  content: \"\\F08E2\";\n}\n\n.mdi-gate-nor::before {\n  content: \"\\F08E3\";\n}\n\n.mdi-gate-not::before {\n  content: \"\\F08E4\";\n}\n\n.mdi-gate-open::before {\n  content: \"\\F116A\";\n}\n\n.mdi-gate-or::before {\n  content: \"\\F08E5\";\n}\n\n.mdi-gate-xnor::before {\n  content: \"\\F08E6\";\n}\n\n.mdi-gate-xor::before {\n  content: \"\\F08E7\";\n}\n\n.mdi-gatsby::before {\n  content: \"\\F0E43\";\n}\n\n.mdi-gauge::before {\n  content: \"\\F029A\";\n}\n\n.mdi-gauge-empty::before {\n  content: \"\\F0873\";\n}\n\n.mdi-gauge-full::before {\n  content: \"\\F0874\";\n}\n\n.mdi-gauge-low::before {\n  content: \"\\F0875\";\n}\n\n.mdi-gavel::before {\n  content: \"\\F029B\";\n}\n\n.mdi-gender-female::before {\n  content: \"\\F029C\";\n}\n\n.mdi-gender-male::before {\n  content: \"\\F029D\";\n}\n\n.mdi-gender-male-female::before {\n  content: \"\\F029E\";\n}\n\n.mdi-gender-male-female-variant::before {\n  content: \"\\F113F\";\n}\n\n.mdi-gender-non-binary::before {\n  content: \"\\F1140\";\n}\n\n.mdi-gender-transgender::before {\n  content: \"\\F029F\";\n}\n\n.mdi-gentoo::before {\n  content: \"\\F08E8\";\n}\n\n.mdi-gesture::before {\n  content: \"\\F07CB\";\n}\n\n.mdi-gesture-double-tap::before {\n  content: \"\\F073C\";\n}\n\n.mdi-gesture-pinch::before {\n  content: \"\\F0ABD\";\n}\n\n.mdi-gesture-spread::before {\n  content: \"\\F0ABE\";\n}\n\n.mdi-gesture-swipe::before {\n  content: \"\\F0D76\";\n}\n\n.mdi-gesture-swipe-down::before {\n  content: \"\\F073D\";\n}\n\n.mdi-gesture-swipe-horizontal::before {\n  content: \"\\F0ABF\";\n}\n\n.mdi-gesture-swipe-left::before {\n  content: \"\\F073E\";\n}\n\n.mdi-gesture-swipe-right::before {\n  content: \"\\F073F\";\n}\n\n.mdi-gesture-swipe-up::before {\n  content: \"\\F0740\";\n}\n\n.mdi-gesture-swipe-vertical::before {\n  content: \"\\F0AC0\";\n}\n\n.mdi-gesture-tap::before {\n  content: \"\\F0741\";\n}\n\n.mdi-gesture-tap-box::before {\n  content: \"\\F12A9\";\n}\n\n.mdi-gesture-tap-button::before {\n  content: \"\\F12A8\";\n}\n\n.mdi-gesture-tap-hold::before {\n  content: \"\\F0D77\";\n}\n\n.mdi-gesture-two-double-tap::before {\n  content: \"\\F0742\";\n}\n\n.mdi-gesture-two-tap::before {\n  content: \"\\F0743\";\n}\n\n.mdi-ghost::before {\n  content: \"\\F02A0\";\n}\n\n.mdi-ghost-off::before {\n  content: \"\\F09F5\";\n}\n\n.mdi-ghost-off-outline::before {\n  content: \"\\F165C\";\n}\n\n.mdi-ghost-outline::before {\n  content: \"\\F165D\";\n}\n\n.mdi-gift::before {\n  content: \"\\F0E44\";\n}\n\n.mdi-gift-off::before {\n  content: \"\\F16EF\";\n}\n\n.mdi-gift-off-outline::before {\n  content: \"\\F16F0\";\n}\n\n.mdi-gift-open::before {\n  content: \"\\F16F1\";\n}\n\n.mdi-gift-open-outline::before {\n  content: \"\\F16F2\";\n}\n\n.mdi-gift-outline::before {\n  content: \"\\F02A1\";\n}\n\n.mdi-git::before {\n  content: \"\\F02A2\";\n}\n\n.mdi-github::before {\n  content: \"\\F02A4\";\n}\n\n.mdi-gitlab::before {\n  content: \"\\F0BA0\";\n}\n\n.mdi-glass-cocktail::before {\n  content: \"\\F0356\";\n}\n\n.mdi-glass-cocktail-off::before {\n  content: \"\\F15E6\";\n}\n\n.mdi-glass-flute::before {\n  content: \"\\F02A5\";\n}\n\n.mdi-glass-fragile::before {\n  content: \"\\F1873\";\n}\n\n.mdi-glass-mug::before {\n  content: \"\\F02A6\";\n}\n\n.mdi-glass-mug-off::before {\n  content: \"\\F15E7\";\n}\n\n.mdi-glass-mug-variant::before {\n  content: \"\\F1116\";\n}\n\n.mdi-glass-mug-variant-off::before {\n  content: \"\\F15E8\";\n}\n\n.mdi-glass-pint-outline::before {\n  content: \"\\F130D\";\n}\n\n.mdi-glass-stange::before {\n  content: \"\\F02A7\";\n}\n\n.mdi-glass-tulip::before {\n  content: \"\\F02A8\";\n}\n\n.mdi-glass-wine::before {\n  content: \"\\F0876\";\n}\n\n.mdi-glasses::before {\n  content: \"\\F02AA\";\n}\n\n.mdi-globe-light::before {\n  content: \"\\F12D7\";\n}\n\n.mdi-globe-model::before {\n  content: \"\\F08E9\";\n}\n\n.mdi-gmail::before {\n  content: \"\\F02AB\";\n}\n\n.mdi-gnome::before {\n  content: \"\\F02AC\";\n}\n\n.mdi-go-kart::before {\n  content: \"\\F0D79\";\n}\n\n.mdi-go-kart-track::before {\n  content: \"\\F0D7A\";\n}\n\n.mdi-gog::before {\n  content: \"\\F0BA1\";\n}\n\n.mdi-gold::before {\n  content: \"\\F124F\";\n}\n\n.mdi-golf::before {\n  content: \"\\F0823\";\n}\n\n.mdi-golf-cart::before {\n  content: \"\\F11A4\";\n}\n\n.mdi-golf-tee::before {\n  content: \"\\F1083\";\n}\n\n.mdi-gondola::before {\n  content: \"\\F0686\";\n}\n\n.mdi-goodreads::before {\n  content: \"\\F0D7B\";\n}\n\n.mdi-google::before {\n  content: \"\\F02AD\";\n}\n\n.mdi-google-ads::before {\n  content: \"\\F0C87\";\n}\n\n.mdi-google-analytics::before {\n  content: \"\\F07CC\";\n}\n\n.mdi-google-assistant::before {\n  content: \"\\F07CD\";\n}\n\n.mdi-google-cardboard::before {\n  content: \"\\F02AE\";\n}\n\n.mdi-google-chrome::before {\n  content: \"\\F02AF\";\n}\n\n.mdi-google-circles::before {\n  content: \"\\F02B0\";\n}\n\n.mdi-google-circles-communities::before {\n  content: \"\\F02B1\";\n}\n\n.mdi-google-circles-extended::before {\n  content: \"\\F02B2\";\n}\n\n.mdi-google-circles-group::before {\n  content: \"\\F02B3\";\n}\n\n.mdi-google-classroom::before {\n  content: \"\\F02C0\";\n}\n\n.mdi-google-cloud::before {\n  content: \"\\F11F6\";\n}\n\n.mdi-google-controller::before {\n  content: \"\\F02B4\";\n}\n\n.mdi-google-controller-off::before {\n  content: \"\\F02B5\";\n}\n\n.mdi-google-downasaur::before {\n  content: \"\\F1362\";\n}\n\n.mdi-google-drive::before {\n  content: \"\\F02B6\";\n}\n\n.mdi-google-earth::before {\n  content: \"\\F02B7\";\n}\n\n.mdi-google-fit::before {\n  content: \"\\F096C\";\n}\n\n.mdi-google-glass::before {\n  content: \"\\F02B8\";\n}\n\n.mdi-google-hangouts::before {\n  content: \"\\F02C9\";\n}\n\n.mdi-google-home::before {\n  content: \"\\F0824\";\n}\n\n.mdi-google-keep::before {\n  content: \"\\F06DC\";\n}\n\n.mdi-google-lens::before {\n  content: \"\\F09F6\";\n}\n\n.mdi-google-maps::before {\n  content: \"\\F05F5\";\n}\n\n.mdi-google-my-business::before {\n  content: \"\\F1048\";\n}\n\n.mdi-google-nearby::before {\n  content: \"\\F02B9\";\n}\n\n.mdi-google-play::before {\n  content: \"\\F02BC\";\n}\n\n.mdi-google-plus::before {\n  content: \"\\F02BD\";\n}\n\n.mdi-google-podcast::before {\n  content: \"\\F0EB9\";\n}\n\n.mdi-google-spreadsheet::before {\n  content: \"\\F09F7\";\n}\n\n.mdi-google-street-view::before {\n  content: \"\\F0C88\";\n}\n\n.mdi-google-translate::before {\n  content: \"\\F02BF\";\n}\n\n.mdi-gradient-horizontal::before {\n  content: \"\\F174A\";\n}\n\n.mdi-gradient-vertical::before {\n  content: \"\\F06A0\";\n}\n\n.mdi-grain::before {\n  content: \"\\F0D7C\";\n}\n\n.mdi-graph::before {\n  content: \"\\F1049\";\n}\n\n.mdi-graph-outline::before {\n  content: \"\\F104A\";\n}\n\n.mdi-graphql::before {\n  content: \"\\F0877\";\n}\n\n.mdi-grass::before {\n  content: \"\\F1510\";\n}\n\n.mdi-grave-stone::before {\n  content: \"\\F0BA2\";\n}\n\n.mdi-grease-pencil::before {\n  content: \"\\F0648\";\n}\n\n.mdi-greater-than::before {\n  content: \"\\F096D\";\n}\n\n.mdi-greater-than-or-equal::before {\n  content: \"\\F096E\";\n}\n\n.mdi-greenhouse::before {\n  content: \"\\F002D\";\n}\n\n.mdi-grid::before {\n  content: \"\\F02C1\";\n}\n\n.mdi-grid-large::before {\n  content: \"\\F0758\";\n}\n\n.mdi-grid-off::before {\n  content: \"\\F02C2\";\n}\n\n.mdi-grill::before {\n  content: \"\\F0E45\";\n}\n\n.mdi-grill-outline::before {\n  content: \"\\F118A\";\n}\n\n.mdi-group::before {\n  content: \"\\F02C3\";\n}\n\n.mdi-guitar-acoustic::before {\n  content: \"\\F0771\";\n}\n\n.mdi-guitar-electric::before {\n  content: \"\\F02C4\";\n}\n\n.mdi-guitar-pick::before {\n  content: \"\\F02C5\";\n}\n\n.mdi-guitar-pick-outline::before {\n  content: \"\\F02C6\";\n}\n\n.mdi-guy-fawkes-mask::before {\n  content: \"\\F0825\";\n}\n\n.mdi-hail::before {\n  content: \"\\F0AC1\";\n}\n\n.mdi-hair-dryer::before {\n  content: \"\\F10EF\";\n}\n\n.mdi-hair-dryer-outline::before {\n  content: \"\\F10F0\";\n}\n\n.mdi-halloween::before {\n  content: \"\\F0BA3\";\n}\n\n.mdi-hamburger::before {\n  content: \"\\F0685\";\n}\n\n.mdi-hamburger-check::before {\n  content: \"\\F1776\";\n}\n\n.mdi-hamburger-minus::before {\n  content: \"\\F1777\";\n}\n\n.mdi-hamburger-off::before {\n  content: \"\\F1778\";\n}\n\n.mdi-hamburger-plus::before {\n  content: \"\\F1779\";\n}\n\n.mdi-hamburger-remove::before {\n  content: \"\\F177A\";\n}\n\n.mdi-hammer::before {\n  content: \"\\F08EA\";\n}\n\n.mdi-hammer-screwdriver::before {\n  content: \"\\F1322\";\n}\n\n.mdi-hammer-sickle::before {\n  content: \"\\F1887\";\n}\n\n.mdi-hammer-wrench::before {\n  content: \"\\F1323\";\n}\n\n.mdi-hand-back-left::before {\n  content: \"\\F0E46\";\n}\n\n.mdi-hand-back-left-off::before {\n  content: \"\\F1830\";\n}\n\n.mdi-hand-back-left-off-outline::before {\n  content: \"\\F1832\";\n}\n\n.mdi-hand-back-left-outline::before {\n  content: \"\\F182C\";\n}\n\n.mdi-hand-back-right::before {\n  content: \"\\F0E47\";\n}\n\n.mdi-hand-back-right-off::before {\n  content: \"\\F1831\";\n}\n\n.mdi-hand-back-right-off-outline::before {\n  content: \"\\F1833\";\n}\n\n.mdi-hand-back-right-outline::before {\n  content: \"\\F182D\";\n}\n\n.mdi-hand-clap::before {\n  content: \"\\F194B\";\n}\n\n.mdi-hand-coin::before {\n  content: \"\\F188F\";\n}\n\n.mdi-hand-coin-outline::before {\n  content: \"\\F1890\";\n}\n\n.mdi-hand-extended::before {\n  content: \"\\F18B6\";\n}\n\n.mdi-hand-extended-outline::before {\n  content: \"\\F18B7\";\n}\n\n.mdi-hand-front-left::before {\n  content: \"\\F182B\";\n}\n\n.mdi-hand-front-left-outline::before {\n  content: \"\\F182E\";\n}\n\n.mdi-hand-front-right::before {\n  content: \"\\F0A4F\";\n}\n\n.mdi-hand-front-right-outline::before {\n  content: \"\\F182F\";\n}\n\n.mdi-hand-heart::before {\n  content: \"\\F10F1\";\n}\n\n.mdi-hand-heart-outline::before {\n  content: \"\\F157E\";\n}\n\n.mdi-hand-okay::before {\n  content: \"\\F0A50\";\n}\n\n.mdi-hand-peace::before {\n  content: \"\\F0A51\";\n}\n\n.mdi-hand-peace-variant::before {\n  content: \"\\F0A52\";\n}\n\n.mdi-hand-pointing-down::before {\n  content: \"\\F0A53\";\n}\n\n.mdi-hand-pointing-left::before {\n  content: \"\\F0A54\";\n}\n\n.mdi-hand-pointing-right::before {\n  content: \"\\F02C7\";\n}\n\n.mdi-hand-pointing-up::before {\n  content: \"\\F0A55\";\n}\n\n.mdi-hand-saw::before {\n  content: \"\\F0E48\";\n}\n\n.mdi-hand-wash::before {\n  content: \"\\F157F\";\n}\n\n.mdi-hand-wash-outline::before {\n  content: \"\\F1580\";\n}\n\n.mdi-hand-water::before {\n  content: \"\\F139F\";\n}\n\n.mdi-hand-wave::before {\n  content: \"\\F1821\";\n}\n\n.mdi-hand-wave-outline::before {\n  content: \"\\F1822\";\n}\n\n.mdi-handball::before {\n  content: \"\\F0F53\";\n}\n\n.mdi-handcuffs::before {\n  content: \"\\F113E\";\n}\n\n.mdi-hands-pray::before {\n  content: \"\\F0579\";\n}\n\n.mdi-handshake::before {\n  content: \"\\F1218\";\n}\n\n.mdi-handshake-outline::before {\n  content: \"\\F15A1\";\n}\n\n.mdi-hanger::before {\n  content: \"\\F02C8\";\n}\n\n.mdi-hard-hat::before {\n  content: \"\\F096F\";\n}\n\n.mdi-harddisk::before {\n  content: \"\\F02CA\";\n}\n\n.mdi-harddisk-plus::before {\n  content: \"\\F104B\";\n}\n\n.mdi-harddisk-remove::before {\n  content: \"\\F104C\";\n}\n\n.mdi-hat-fedora::before {\n  content: \"\\F0BA4\";\n}\n\n.mdi-hazard-lights::before {\n  content: \"\\F0C89\";\n}\n\n.mdi-hdr::before {\n  content: \"\\F0D7D\";\n}\n\n.mdi-hdr-off::before {\n  content: \"\\F0D7E\";\n}\n\n.mdi-head::before {\n  content: \"\\F135E\";\n}\n\n.mdi-head-alert::before {\n  content: \"\\F1338\";\n}\n\n.mdi-head-alert-outline::before {\n  content: \"\\F1339\";\n}\n\n.mdi-head-check::before {\n  content: \"\\F133A\";\n}\n\n.mdi-head-check-outline::before {\n  content: \"\\F133B\";\n}\n\n.mdi-head-cog::before {\n  content: \"\\F133C\";\n}\n\n.mdi-head-cog-outline::before {\n  content: \"\\F133D\";\n}\n\n.mdi-head-dots-horizontal::before {\n  content: \"\\F133E\";\n}\n\n.mdi-head-dots-horizontal-outline::before {\n  content: \"\\F133F\";\n}\n\n.mdi-head-flash::before {\n  content: \"\\F1340\";\n}\n\n.mdi-head-flash-outline::before {\n  content: \"\\F1341\";\n}\n\n.mdi-head-heart::before {\n  content: \"\\F1342\";\n}\n\n.mdi-head-heart-outline::before {\n  content: \"\\F1343\";\n}\n\n.mdi-head-lightbulb::before {\n  content: \"\\F1344\";\n}\n\n.mdi-head-lightbulb-outline::before {\n  content: \"\\F1345\";\n}\n\n.mdi-head-minus::before {\n  content: \"\\F1346\";\n}\n\n.mdi-head-minus-outline::before {\n  content: \"\\F1347\";\n}\n\n.mdi-head-outline::before {\n  content: \"\\F135F\";\n}\n\n.mdi-head-plus::before {\n  content: \"\\F1348\";\n}\n\n.mdi-head-plus-outline::before {\n  content: \"\\F1349\";\n}\n\n.mdi-head-question::before {\n  content: \"\\F134A\";\n}\n\n.mdi-head-question-outline::before {\n  content: \"\\F134B\";\n}\n\n.mdi-head-remove::before {\n  content: \"\\F134C\";\n}\n\n.mdi-head-remove-outline::before {\n  content: \"\\F134D\";\n}\n\n.mdi-head-snowflake::before {\n  content: \"\\F134E\";\n}\n\n.mdi-head-snowflake-outline::before {\n  content: \"\\F134F\";\n}\n\n.mdi-head-sync::before {\n  content: \"\\F1350\";\n}\n\n.mdi-head-sync-outline::before {\n  content: \"\\F1351\";\n}\n\n.mdi-headphones::before {\n  content: \"\\F02CB\";\n}\n\n.mdi-headphones-bluetooth::before {\n  content: \"\\F0970\";\n}\n\n.mdi-headphones-box::before {\n  content: \"\\F02CC\";\n}\n\n.mdi-headphones-off::before {\n  content: \"\\F07CE\";\n}\n\n.mdi-headphones-settings::before {\n  content: \"\\F02CD\";\n}\n\n.mdi-headset::before {\n  content: \"\\F02CE\";\n}\n\n.mdi-headset-dock::before {\n  content: \"\\F02CF\";\n}\n\n.mdi-headset-off::before {\n  content: \"\\F02D0\";\n}\n\n.mdi-heart::before {\n  content: \"\\F02D1\";\n}\n\n.mdi-heart-box::before {\n  content: \"\\F02D2\";\n}\n\n.mdi-heart-box-outline::before {\n  content: \"\\F02D3\";\n}\n\n.mdi-heart-broken::before {\n  content: \"\\F02D4\";\n}\n\n.mdi-heart-broken-outline::before {\n  content: \"\\F0D14\";\n}\n\n.mdi-heart-circle::before {\n  content: \"\\F0971\";\n}\n\n.mdi-heart-circle-outline::before {\n  content: \"\\F0972\";\n}\n\n.mdi-heart-cog::before {\n  content: \"\\F1663\";\n}\n\n.mdi-heart-cog-outline::before {\n  content: \"\\F1664\";\n}\n\n.mdi-heart-flash::before {\n  content: \"\\F0EF9\";\n}\n\n.mdi-heart-half::before {\n  content: \"\\F06DF\";\n}\n\n.mdi-heart-half-full::before {\n  content: \"\\F06DE\";\n}\n\n.mdi-heart-half-outline::before {\n  content: \"\\F06E0\";\n}\n\n.mdi-heart-minus::before {\n  content: \"\\F142F\";\n}\n\n.mdi-heart-minus-outline::before {\n  content: \"\\F1432\";\n}\n\n.mdi-heart-multiple::before {\n  content: \"\\F0A56\";\n}\n\n.mdi-heart-multiple-outline::before {\n  content: \"\\F0A57\";\n}\n\n.mdi-heart-off::before {\n  content: \"\\F0759\";\n}\n\n.mdi-heart-off-outline::before {\n  content: \"\\F1434\";\n}\n\n.mdi-heart-outline::before {\n  content: \"\\F02D5\";\n}\n\n.mdi-heart-plus::before {\n  content: \"\\F142E\";\n}\n\n.mdi-heart-plus-outline::before {\n  content: \"\\F1431\";\n}\n\n.mdi-heart-pulse::before {\n  content: \"\\F05F6\";\n}\n\n.mdi-heart-remove::before {\n  content: \"\\F1430\";\n}\n\n.mdi-heart-remove-outline::before {\n  content: \"\\F1433\";\n}\n\n.mdi-heart-settings::before {\n  content: \"\\F1665\";\n}\n\n.mdi-heart-settings-outline::before {\n  content: \"\\F1666\";\n}\n\n.mdi-helicopter::before {\n  content: \"\\F0AC2\";\n}\n\n.mdi-help::before {\n  content: \"\\F02D6\";\n}\n\n.mdi-help-box::before {\n  content: \"\\F078B\";\n}\n\n.mdi-help-circle::before {\n  content: \"\\F02D7\";\n}\n\n.mdi-help-circle-outline::before {\n  content: \"\\F0625\";\n}\n\n.mdi-help-network::before {\n  content: \"\\F06F5\";\n}\n\n.mdi-help-network-outline::before {\n  content: \"\\F0C8A\";\n}\n\n.mdi-help-rhombus::before {\n  content: \"\\F0BA5\";\n}\n\n.mdi-help-rhombus-outline::before {\n  content: \"\\F0BA6\";\n}\n\n.mdi-hexadecimal::before {\n  content: \"\\F12A7\";\n}\n\n.mdi-hexagon::before {\n  content: \"\\F02D8\";\n}\n\n.mdi-hexagon-multiple::before {\n  content: \"\\F06E1\";\n}\n\n.mdi-hexagon-multiple-outline::before {\n  content: \"\\F10F2\";\n}\n\n.mdi-hexagon-outline::before {\n  content: \"\\F02D9\";\n}\n\n.mdi-hexagon-slice-1::before {\n  content: \"\\F0AC3\";\n}\n\n.mdi-hexagon-slice-2::before {\n  content: \"\\F0AC4\";\n}\n\n.mdi-hexagon-slice-3::before {\n  content: \"\\F0AC5\";\n}\n\n.mdi-hexagon-slice-4::before {\n  content: \"\\F0AC6\";\n}\n\n.mdi-hexagon-slice-5::before {\n  content: \"\\F0AC7\";\n}\n\n.mdi-hexagon-slice-6::before {\n  content: \"\\F0AC8\";\n}\n\n.mdi-hexagram::before {\n  content: \"\\F0AC9\";\n}\n\n.mdi-hexagram-outline::before {\n  content: \"\\F0ACA\";\n}\n\n.mdi-high-definition::before {\n  content: \"\\F07CF\";\n}\n\n.mdi-high-definition-box::before {\n  content: \"\\F0878\";\n}\n\n.mdi-highway::before {\n  content: \"\\F05F7\";\n}\n\n.mdi-hiking::before {\n  content: \"\\F0D7F\";\n}\n\n.mdi-history::before {\n  content: \"\\F02DA\";\n}\n\n.mdi-hockey-puck::before {\n  content: \"\\F0879\";\n}\n\n.mdi-hockey-sticks::before {\n  content: \"\\F087A\";\n}\n\n.mdi-hololens::before {\n  content: \"\\F02DB\";\n}\n\n.mdi-home::before {\n  content: \"\\F02DC\";\n}\n\n.mdi-home-account::before {\n  content: \"\\F0826\";\n}\n\n.mdi-home-alert::before {\n  content: \"\\F087B\";\n}\n\n.mdi-home-alert-outline::before {\n  content: \"\\F15D0\";\n}\n\n.mdi-home-analytics::before {\n  content: \"\\F0EBA\";\n}\n\n.mdi-home-assistant::before {\n  content: \"\\F07D0\";\n}\n\n.mdi-home-automation::before {\n  content: \"\\F07D1\";\n}\n\n.mdi-home-battery::before {\n  content: \"\\F1901\";\n}\n\n.mdi-home-battery-outline::before {\n  content: \"\\F1902\";\n}\n\n.mdi-home-circle::before {\n  content: \"\\F07D2\";\n}\n\n.mdi-home-circle-outline::before {\n  content: \"\\F104D\";\n}\n\n.mdi-home-city::before {\n  content: \"\\F0D15\";\n}\n\n.mdi-home-city-outline::before {\n  content: \"\\F0D16\";\n}\n\n.mdi-home-edit::before {\n  content: \"\\F1159\";\n}\n\n.mdi-home-edit-outline::before {\n  content: \"\\F115A\";\n}\n\n.mdi-home-export-outline::before {\n  content: \"\\F0F9B\";\n}\n\n.mdi-home-flood::before {\n  content: \"\\F0EFA\";\n}\n\n.mdi-home-floor-0::before {\n  content: \"\\F0DD2\";\n}\n\n.mdi-home-floor-1::before {\n  content: \"\\F0D80\";\n}\n\n.mdi-home-floor-2::before {\n  content: \"\\F0D81\";\n}\n\n.mdi-home-floor-3::before {\n  content: \"\\F0D82\";\n}\n\n.mdi-home-floor-a::before {\n  content: \"\\F0D83\";\n}\n\n.mdi-home-floor-b::before {\n  content: \"\\F0D84\";\n}\n\n.mdi-home-floor-g::before {\n  content: \"\\F0D85\";\n}\n\n.mdi-home-floor-l::before {\n  content: \"\\F0D86\";\n}\n\n.mdi-home-floor-negative-1::before {\n  content: \"\\F0DD3\";\n}\n\n.mdi-home-group::before {\n  content: \"\\F0DD4\";\n}\n\n.mdi-home-group-minus::before {\n  content: \"\\F19C1\";\n}\n\n.mdi-home-group-plus::before {\n  content: \"\\F19C0\";\n}\n\n.mdi-home-group-remove::before {\n  content: \"\\F19C2\";\n}\n\n.mdi-home-heart::before {\n  content: \"\\F0827\";\n}\n\n.mdi-home-import-outline::before {\n  content: \"\\F0F9C\";\n}\n\n.mdi-home-lightbulb::before {\n  content: \"\\F1251\";\n}\n\n.mdi-home-lightbulb-outline::before {\n  content: \"\\F1252\";\n}\n\n.mdi-home-lightning-bolt::before {\n  content: \"\\F1903\";\n}\n\n.mdi-home-lightning-bolt-outline::before {\n  content: \"\\F1904\";\n}\n\n.mdi-home-lock::before {\n  content: \"\\F08EB\";\n}\n\n.mdi-home-lock-open::before {\n  content: \"\\F08EC\";\n}\n\n.mdi-home-map-marker::before {\n  content: \"\\F05F8\";\n}\n\n.mdi-home-minus::before {\n  content: \"\\F0974\";\n}\n\n.mdi-home-minus-outline::before {\n  content: \"\\F13D5\";\n}\n\n.mdi-home-modern::before {\n  content: \"\\F02DD\";\n}\n\n.mdi-home-outline::before {\n  content: \"\\F06A1\";\n}\n\n.mdi-home-plus::before {\n  content: \"\\F0975\";\n}\n\n.mdi-home-plus-outline::before {\n  content: \"\\F13D6\";\n}\n\n.mdi-home-remove::before {\n  content: \"\\F1247\";\n}\n\n.mdi-home-remove-outline::before {\n  content: \"\\F13D7\";\n}\n\n.mdi-home-roof::before {\n  content: \"\\F112B\";\n}\n\n.mdi-home-search::before {\n  content: \"\\F13B0\";\n}\n\n.mdi-home-search-outline::before {\n  content: \"\\F13B1\";\n}\n\n.mdi-home-switch::before {\n  content: \"\\F1794\";\n}\n\n.mdi-home-switch-outline::before {\n  content: \"\\F1795\";\n}\n\n.mdi-home-thermometer::before {\n  content: \"\\F0F54\";\n}\n\n.mdi-home-thermometer-outline::before {\n  content: \"\\F0F55\";\n}\n\n.mdi-home-variant::before {\n  content: \"\\F02DE\";\n}\n\n.mdi-home-variant-outline::before {\n  content: \"\\F0BA7\";\n}\n\n.mdi-hook::before {\n  content: \"\\F06E2\";\n}\n\n.mdi-hook-off::before {\n  content: \"\\F06E3\";\n}\n\n.mdi-hoop-house::before {\n  content: \"\\F0E56\";\n}\n\n.mdi-hops::before {\n  content: \"\\F02DF\";\n}\n\n.mdi-horizontal-rotate-clockwise::before {\n  content: \"\\F10F3\";\n}\n\n.mdi-horizontal-rotate-counterclockwise::before {\n  content: \"\\F10F4\";\n}\n\n.mdi-horse::before {\n  content: \"\\F15BF\";\n}\n\n.mdi-horse-human::before {\n  content: \"\\F15C0\";\n}\n\n.mdi-horse-variant::before {\n  content: \"\\F15C1\";\n}\n\n.mdi-horse-variant-fast::before {\n  content: \"\\F186E\";\n}\n\n.mdi-horseshoe::before {\n  content: \"\\F0A58\";\n}\n\n.mdi-hospital::before {\n  content: \"\\F0FF6\";\n}\n\n.mdi-hospital-box::before {\n  content: \"\\F02E0\";\n}\n\n.mdi-hospital-box-outline::before {\n  content: \"\\F0FF7\";\n}\n\n.mdi-hospital-building::before {\n  content: \"\\F02E1\";\n}\n\n.mdi-hospital-marker::before {\n  content: \"\\F02E2\";\n}\n\n.mdi-hot-tub::before {\n  content: \"\\F0828\";\n}\n\n.mdi-hours-24::before {\n  content: \"\\F1478\";\n}\n\n.mdi-hubspot::before {\n  content: \"\\F0D17\";\n}\n\n.mdi-hulu::before {\n  content: \"\\F0829\";\n}\n\n.mdi-human::before {\n  content: \"\\F02E6\";\n}\n\n.mdi-human-baby-changing-table::before {\n  content: \"\\F138B\";\n}\n\n.mdi-human-cane::before {\n  content: \"\\F1581\";\n}\n\n.mdi-human-capacity-decrease::before {\n  content: \"\\F159B\";\n}\n\n.mdi-human-capacity-increase::before {\n  content: \"\\F159C\";\n}\n\n.mdi-human-child::before {\n  content: \"\\F02E7\";\n}\n\n.mdi-human-dolly::before {\n  content: \"\\F1980\";\n}\n\n.mdi-human-edit::before {\n  content: \"\\F14E8\";\n}\n\n.mdi-human-female::before {\n  content: \"\\F0649\";\n}\n\n.mdi-human-female-boy::before {\n  content: \"\\F0A59\";\n}\n\n.mdi-human-female-dance::before {\n  content: \"\\F15C9\";\n}\n\n.mdi-human-female-female::before {\n  content: \"\\F0A5A\";\n}\n\n.mdi-human-female-girl::before {\n  content: \"\\F0A5B\";\n}\n\n.mdi-human-greeting::before {\n  content: \"\\F17C4\";\n}\n\n.mdi-human-greeting-proximity::before {\n  content: \"\\F159D\";\n}\n\n.mdi-human-greeting-variant::before {\n  content: \"\\F064A\";\n}\n\n.mdi-human-handsdown::before {\n  content: \"\\F064B\";\n}\n\n.mdi-human-handsup::before {\n  content: \"\\F064C\";\n}\n\n.mdi-human-male::before {\n  content: \"\\F064D\";\n}\n\n.mdi-human-male-board::before {\n  content: \"\\F0890\";\n}\n\n.mdi-human-male-board-poll::before {\n  content: \"\\F0846\";\n}\n\n.mdi-human-male-boy::before {\n  content: \"\\F0A5C\";\n}\n\n.mdi-human-male-child::before {\n  content: \"\\F138C\";\n}\n\n.mdi-human-male-female::before {\n  content: \"\\F02E8\";\n}\n\n.mdi-human-male-female-child::before {\n  content: \"\\F1823\";\n}\n\n.mdi-human-male-girl::before {\n  content: \"\\F0A5D\";\n}\n\n.mdi-human-male-height::before {\n  content: \"\\F0EFB\";\n}\n\n.mdi-human-male-height-variant::before {\n  content: \"\\F0EFC\";\n}\n\n.mdi-human-male-male::before {\n  content: \"\\F0A5E\";\n}\n\n.mdi-human-non-binary::before {\n  content: \"\\F1848\";\n}\n\n.mdi-human-pregnant::before {\n  content: \"\\F05CF\";\n}\n\n.mdi-human-queue::before {\n  content: \"\\F1571\";\n}\n\n.mdi-human-scooter::before {\n  content: \"\\F11E9\";\n}\n\n.mdi-human-wheelchair::before {\n  content: \"\\F138D\";\n}\n\n.mdi-human-white-cane::before {\n  content: \"\\F1981\";\n}\n\n.mdi-humble-bundle::before {\n  content: \"\\F0744\";\n}\n\n.mdi-hvac::before {\n  content: \"\\F1352\";\n}\n\n.mdi-hvac-off::before {\n  content: \"\\F159E\";\n}\n\n.mdi-hydraulic-oil-level::before {\n  content: \"\\F1324\";\n}\n\n.mdi-hydraulic-oil-temperature::before {\n  content: \"\\F1325\";\n}\n\n.mdi-hydro-power::before {\n  content: \"\\F12E5\";\n}\n\n.mdi-hydrogen-station::before {\n  content: \"\\F1894\";\n}\n\n.mdi-ice-cream::before {\n  content: \"\\F082A\";\n}\n\n.mdi-ice-cream-off::before {\n  content: \"\\F0E52\";\n}\n\n.mdi-ice-pop::before {\n  content: \"\\F0EFD\";\n}\n\n.mdi-id-card::before {\n  content: \"\\F0FC0\";\n}\n\n.mdi-identifier::before {\n  content: \"\\F0EFE\";\n}\n\n.mdi-ideogram-cjk::before {\n  content: \"\\F1331\";\n}\n\n.mdi-ideogram-cjk-variant::before {\n  content: \"\\F1332\";\n}\n\n.mdi-image::before {\n  content: \"\\F02E9\";\n}\n\n.mdi-image-album::before {\n  content: \"\\F02EA\";\n}\n\n.mdi-image-area::before {\n  content: \"\\F02EB\";\n}\n\n.mdi-image-area-close::before {\n  content: \"\\F02EC\";\n}\n\n.mdi-image-auto-adjust::before {\n  content: \"\\F0FC1\";\n}\n\n.mdi-image-broken::before {\n  content: \"\\F02ED\";\n}\n\n.mdi-image-broken-variant::before {\n  content: \"\\F02EE\";\n}\n\n.mdi-image-edit::before {\n  content: \"\\F11E3\";\n}\n\n.mdi-image-edit-outline::before {\n  content: \"\\F11E4\";\n}\n\n.mdi-image-filter-black-white::before {\n  content: \"\\F02F0\";\n}\n\n.mdi-image-filter-center-focus::before {\n  content: \"\\F02F1\";\n}\n\n.mdi-image-filter-center-focus-strong::before {\n  content: \"\\F0EFF\";\n}\n\n.mdi-image-filter-center-focus-strong-outline::before {\n  content: \"\\F0F00\";\n}\n\n.mdi-image-filter-center-focus-weak::before {\n  content: \"\\F02F2\";\n}\n\n.mdi-image-filter-drama::before {\n  content: \"\\F02F3\";\n}\n\n.mdi-image-filter-frames::before {\n  content: \"\\F02F4\";\n}\n\n.mdi-image-filter-hdr::before {\n  content: \"\\F02F5\";\n}\n\n.mdi-image-filter-none::before {\n  content: \"\\F02F6\";\n}\n\n.mdi-image-filter-tilt-shift::before {\n  content: \"\\F02F7\";\n}\n\n.mdi-image-filter-vintage::before {\n  content: \"\\F02F8\";\n}\n\n.mdi-image-frame::before {\n  content: \"\\F0E49\";\n}\n\n.mdi-image-marker::before {\n  content: \"\\F177B\";\n}\n\n.mdi-image-marker-outline::before {\n  content: \"\\F177C\";\n}\n\n.mdi-image-minus::before {\n  content: \"\\F1419\";\n}\n\n.mdi-image-move::before {\n  content: \"\\F09F8\";\n}\n\n.mdi-image-multiple::before {\n  content: \"\\F02F9\";\n}\n\n.mdi-image-multiple-outline::before {\n  content: \"\\F02EF\";\n}\n\n.mdi-image-off::before {\n  content: \"\\F082B\";\n}\n\n.mdi-image-off-outline::before {\n  content: \"\\F11D1\";\n}\n\n.mdi-image-outline::before {\n  content: \"\\F0976\";\n}\n\n.mdi-image-plus::before {\n  content: \"\\F087C\";\n}\n\n.mdi-image-remove::before {\n  content: \"\\F1418\";\n}\n\n.mdi-image-search::before {\n  content: \"\\F0977\";\n}\n\n.mdi-image-search-outline::before {\n  content: \"\\F0978\";\n}\n\n.mdi-image-size-select-actual::before {\n  content: \"\\F0C8D\";\n}\n\n.mdi-image-size-select-large::before {\n  content: \"\\F0C8E\";\n}\n\n.mdi-image-size-select-small::before {\n  content: \"\\F0C8F\";\n}\n\n.mdi-image-text::before {\n  content: \"\\F160D\";\n}\n\n.mdi-import::before {\n  content: \"\\F02FA\";\n}\n\n.mdi-inbox::before {\n  content: \"\\F0687\";\n}\n\n.mdi-inbox-arrow-down::before {\n  content: \"\\F02FB\";\n}\n\n.mdi-inbox-arrow-down-outline::before {\n  content: \"\\F1270\";\n}\n\n.mdi-inbox-arrow-up::before {\n  content: \"\\F03D1\";\n}\n\n.mdi-inbox-arrow-up-outline::before {\n  content: \"\\F1271\";\n}\n\n.mdi-inbox-full::before {\n  content: \"\\F1272\";\n}\n\n.mdi-inbox-full-outline::before {\n  content: \"\\F1273\";\n}\n\n.mdi-inbox-multiple::before {\n  content: \"\\F08B0\";\n}\n\n.mdi-inbox-multiple-outline::before {\n  content: \"\\F0BA8\";\n}\n\n.mdi-inbox-outline::before {\n  content: \"\\F1274\";\n}\n\n.mdi-inbox-remove::before {\n  content: \"\\F159F\";\n}\n\n.mdi-inbox-remove-outline::before {\n  content: \"\\F15A0\";\n}\n\n.mdi-incognito::before {\n  content: \"\\F05F9\";\n}\n\n.mdi-incognito-circle::before {\n  content: \"\\F1421\";\n}\n\n.mdi-incognito-circle-off::before {\n  content: \"\\F1422\";\n}\n\n.mdi-incognito-off::before {\n  content: \"\\F0075\";\n}\n\n.mdi-induction::before {\n  content: \"\\F184C\";\n}\n\n.mdi-infinity::before {\n  content: \"\\F06E4\";\n}\n\n.mdi-information::before {\n  content: \"\\F02FC\";\n}\n\n.mdi-information-off::before {\n  content: \"\\F178C\";\n}\n\n.mdi-information-off-outline::before {\n  content: \"\\F178D\";\n}\n\n.mdi-information-outline::before {\n  content: \"\\F02FD\";\n}\n\n.mdi-information-variant::before {\n  content: \"\\F064E\";\n}\n\n.mdi-instagram::before {\n  content: \"\\F02FE\";\n}\n\n.mdi-instrument-triangle::before {\n  content: \"\\F104E\";\n}\n\n.mdi-integrated-circuit-chip::before {\n  content: \"\\F1913\";\n}\n\n.mdi-invert-colors::before {\n  content: \"\\F0301\";\n}\n\n.mdi-invert-colors-off::before {\n  content: \"\\F0E4A\";\n}\n\n.mdi-iobroker::before {\n  content: \"\\F12E8\";\n}\n\n.mdi-ip::before {\n  content: \"\\F0A5F\";\n}\n\n.mdi-ip-network::before {\n  content: \"\\F0A60\";\n}\n\n.mdi-ip-network-outline::before {\n  content: \"\\F0C90\";\n}\n\n.mdi-ip-outline::before {\n  content: \"\\F1982\";\n}\n\n.mdi-ipod::before {\n  content: \"\\F0C91\";\n}\n\n.mdi-iron::before {\n  content: \"\\F1824\";\n}\n\n.mdi-iron-board::before {\n  content: \"\\F1838\";\n}\n\n.mdi-iron-outline::before {\n  content: \"\\F1825\";\n}\n\n.mdi-island::before {\n  content: \"\\F104F\";\n}\n\n.mdi-iv-bag::before {\n  content: \"\\F10B9\";\n}\n\n.mdi-jabber::before {\n  content: \"\\F0DD5\";\n}\n\n.mdi-jeepney::before {\n  content: \"\\F0302\";\n}\n\n.mdi-jellyfish::before {\n  content: \"\\F0F01\";\n}\n\n.mdi-jellyfish-outline::before {\n  content: \"\\F0F02\";\n}\n\n.mdi-jira::before {\n  content: \"\\F0303\";\n}\n\n.mdi-jquery::before {\n  content: \"\\F087D\";\n}\n\n.mdi-jsfiddle::before {\n  content: \"\\F0304\";\n}\n\n.mdi-jump-rope::before {\n  content: \"\\F12FF\";\n}\n\n.mdi-kabaddi::before {\n  content: \"\\F0D87\";\n}\n\n.mdi-kangaroo::before {\n  content: \"\\F1558\";\n}\n\n.mdi-karate::before {\n  content: \"\\F082C\";\n}\n\n.mdi-kayaking::before {\n  content: \"\\F08AF\";\n}\n\n.mdi-keg::before {\n  content: \"\\F0305\";\n}\n\n.mdi-kettle::before {\n  content: \"\\F05FA\";\n}\n\n.mdi-kettle-alert::before {\n  content: \"\\F1317\";\n}\n\n.mdi-kettle-alert-outline::before {\n  content: \"\\F1318\";\n}\n\n.mdi-kettle-off::before {\n  content: \"\\F131B\";\n}\n\n.mdi-kettle-off-outline::before {\n  content: \"\\F131C\";\n}\n\n.mdi-kettle-outline::before {\n  content: \"\\F0F56\";\n}\n\n.mdi-kettle-pour-over::before {\n  content: \"\\F173C\";\n}\n\n.mdi-kettle-steam::before {\n  content: \"\\F1319\";\n}\n\n.mdi-kettle-steam-outline::before {\n  content: \"\\F131A\";\n}\n\n.mdi-kettlebell::before {\n  content: \"\\F1300\";\n}\n\n.mdi-key::before {\n  content: \"\\F0306\";\n}\n\n.mdi-key-alert::before {\n  content: \"\\F1983\";\n}\n\n.mdi-key-alert-outline::before {\n  content: \"\\F1984\";\n}\n\n.mdi-key-arrow-right::before {\n  content: \"\\F1312\";\n}\n\n.mdi-key-chain::before {\n  content: \"\\F1574\";\n}\n\n.mdi-key-chain-variant::before {\n  content: \"\\F1575\";\n}\n\n.mdi-key-change::before {\n  content: \"\\F0307\";\n}\n\n.mdi-key-link::before {\n  content: \"\\F119F\";\n}\n\n.mdi-key-minus::before {\n  content: \"\\F0308\";\n}\n\n.mdi-key-outline::before {\n  content: \"\\F0DD6\";\n}\n\n.mdi-key-plus::before {\n  content: \"\\F0309\";\n}\n\n.mdi-key-remove::before {\n  content: \"\\F030A\";\n}\n\n.mdi-key-star::before {\n  content: \"\\F119E\";\n}\n\n.mdi-key-variant::before {\n  content: \"\\F030B\";\n}\n\n.mdi-key-wireless::before {\n  content: \"\\F0FC2\";\n}\n\n.mdi-keyboard::before {\n  content: \"\\F030C\";\n}\n\n.mdi-keyboard-backspace::before {\n  content: \"\\F030D\";\n}\n\n.mdi-keyboard-caps::before {\n  content: \"\\F030E\";\n}\n\n.mdi-keyboard-close::before {\n  content: \"\\F030F\";\n}\n\n.mdi-keyboard-esc::before {\n  content: \"\\F12B7\";\n}\n\n.mdi-keyboard-f1::before {\n  content: \"\\F12AB\";\n}\n\n.mdi-keyboard-f10::before {\n  content: \"\\F12B4\";\n}\n\n.mdi-keyboard-f11::before {\n  content: \"\\F12B5\";\n}\n\n.mdi-keyboard-f12::before {\n  content: \"\\F12B6\";\n}\n\n.mdi-keyboard-f2::before {\n  content: \"\\F12AC\";\n}\n\n.mdi-keyboard-f3::before {\n  content: \"\\F12AD\";\n}\n\n.mdi-keyboard-f4::before {\n  content: \"\\F12AE\";\n}\n\n.mdi-keyboard-f5::before {\n  content: \"\\F12AF\";\n}\n\n.mdi-keyboard-f6::before {\n  content: \"\\F12B0\";\n}\n\n.mdi-keyboard-f7::before {\n  content: \"\\F12B1\";\n}\n\n.mdi-keyboard-f8::before {\n  content: \"\\F12B2\";\n}\n\n.mdi-keyboard-f9::before {\n  content: \"\\F12B3\";\n}\n\n.mdi-keyboard-off::before {\n  content: \"\\F0310\";\n}\n\n.mdi-keyboard-off-outline::before {\n  content: \"\\F0E4B\";\n}\n\n.mdi-keyboard-outline::before {\n  content: \"\\F097B\";\n}\n\n.mdi-keyboard-return::before {\n  content: \"\\F0311\";\n}\n\n.mdi-keyboard-settings::before {\n  content: \"\\F09F9\";\n}\n\n.mdi-keyboard-settings-outline::before {\n  content: \"\\F09FA\";\n}\n\n.mdi-keyboard-space::before {\n  content: \"\\F1050\";\n}\n\n.mdi-keyboard-tab::before {\n  content: \"\\F0312\";\n}\n\n.mdi-keyboard-tab-reverse::before {\n  content: \"\\F0325\";\n}\n\n.mdi-keyboard-variant::before {\n  content: \"\\F0313\";\n}\n\n.mdi-khanda::before {\n  content: \"\\F10FD\";\n}\n\n.mdi-kickstarter::before {\n  content: \"\\F0745\";\n}\n\n.mdi-kite::before {\n  content: \"\\F1985\";\n}\n\n.mdi-kite-outline::before {\n  content: \"\\F1986\";\n}\n\n.mdi-kitesurfing::before {\n  content: \"\\F1744\";\n}\n\n.mdi-klingon::before {\n  content: \"\\F135B\";\n}\n\n.mdi-knife::before {\n  content: \"\\F09FB\";\n}\n\n.mdi-knife-military::before {\n  content: \"\\F09FC\";\n}\n\n.mdi-koala::before {\n  content: \"\\F173F\";\n}\n\n.mdi-kodi::before {\n  content: \"\\F0314\";\n}\n\n.mdi-kubernetes::before {\n  content: \"\\F10FE\";\n}\n\n.mdi-label::before {\n  content: \"\\F0315\";\n}\n\n.mdi-label-multiple::before {\n  content: \"\\F1375\";\n}\n\n.mdi-label-multiple-outline::before {\n  content: \"\\F1376\";\n}\n\n.mdi-label-off::before {\n  content: \"\\F0ACB\";\n}\n\n.mdi-label-off-outline::before {\n  content: \"\\F0ACC\";\n}\n\n.mdi-label-outline::before {\n  content: \"\\F0316\";\n}\n\n.mdi-label-percent::before {\n  content: \"\\F12EA\";\n}\n\n.mdi-label-percent-outline::before {\n  content: \"\\F12EB\";\n}\n\n.mdi-label-variant::before {\n  content: \"\\F0ACD\";\n}\n\n.mdi-label-variant-outline::before {\n  content: \"\\F0ACE\";\n}\n\n.mdi-ladder::before {\n  content: \"\\F15A2\";\n}\n\n.mdi-ladybug::before {\n  content: \"\\F082D\";\n}\n\n.mdi-lambda::before {\n  content: \"\\F0627\";\n}\n\n.mdi-lamp::before {\n  content: \"\\F06B5\";\n}\n\n.mdi-lamp-outline::before {\n  content: \"\\F17D0\";\n}\n\n.mdi-lamps::before {\n  content: \"\\F1576\";\n}\n\n.mdi-lamps-outline::before {\n  content: \"\\F17D1\";\n}\n\n.mdi-lan::before {\n  content: \"\\F0317\";\n}\n\n.mdi-lan-check::before {\n  content: \"\\F12AA\";\n}\n\n.mdi-lan-connect::before {\n  content: \"\\F0318\";\n}\n\n.mdi-lan-disconnect::before {\n  content: \"\\F0319\";\n}\n\n.mdi-lan-pending::before {\n  content: \"\\F031A\";\n}\n\n.mdi-language-c::before {\n  content: \"\\F0671\";\n}\n\n.mdi-language-cpp::before {\n  content: \"\\F0672\";\n}\n\n.mdi-language-csharp::before {\n  content: \"\\F031B\";\n}\n\n.mdi-language-css3::before {\n  content: \"\\F031C\";\n}\n\n.mdi-language-fortran::before {\n  content: \"\\F121A\";\n}\n\n.mdi-language-go::before {\n  content: \"\\F07D3\";\n}\n\n.mdi-language-haskell::before {\n  content: \"\\F0C92\";\n}\n\n.mdi-language-html5::before {\n  content: \"\\F031D\";\n}\n\n.mdi-language-java::before {\n  content: \"\\F0B37\";\n}\n\n.mdi-language-javascript::before {\n  content: \"\\F031E\";\n}\n\n.mdi-language-kotlin::before {\n  content: \"\\F1219\";\n}\n\n.mdi-language-lua::before {\n  content: \"\\F08B1\";\n}\n\n.mdi-language-markdown::before {\n  content: \"\\F0354\";\n}\n\n.mdi-language-markdown-outline::before {\n  content: \"\\F0F5B\";\n}\n\n.mdi-language-php::before {\n  content: \"\\F031F\";\n}\n\n.mdi-language-python::before {\n  content: \"\\F0320\";\n}\n\n.mdi-language-r::before {\n  content: \"\\F07D4\";\n}\n\n.mdi-language-ruby::before {\n  content: \"\\F0D2D\";\n}\n\n.mdi-language-ruby-on-rails::before {\n  content: \"\\F0ACF\";\n}\n\n.mdi-language-rust::before {\n  content: \"\\F1617\";\n}\n\n.mdi-language-swift::before {\n  content: \"\\F06E5\";\n}\n\n.mdi-language-typescript::before {\n  content: \"\\F06E6\";\n}\n\n.mdi-language-xaml::before {\n  content: \"\\F0673\";\n}\n\n.mdi-laptop::before {\n  content: \"\\F0322\";\n}\n\n.mdi-laptop-off::before {\n  content: \"\\F06E7\";\n}\n\n.mdi-laravel::before {\n  content: \"\\F0AD0\";\n}\n\n.mdi-laser-pointer::before {\n  content: \"\\F1484\";\n}\n\n.mdi-lasso::before {\n  content: \"\\F0F03\";\n}\n\n.mdi-lastpass::before {\n  content: \"\\F0446\";\n}\n\n.mdi-latitude::before {\n  content: \"\\F0F57\";\n}\n\n.mdi-launch::before {\n  content: \"\\F0327\";\n}\n\n.mdi-lava-lamp::before {\n  content: \"\\F07D5\";\n}\n\n.mdi-layers::before {\n  content: \"\\F0328\";\n}\n\n.mdi-layers-edit::before {\n  content: \"\\F1892\";\n}\n\n.mdi-layers-minus::before {\n  content: \"\\F0E4C\";\n}\n\n.mdi-layers-off::before {\n  content: \"\\F0329\";\n}\n\n.mdi-layers-off-outline::before {\n  content: \"\\F09FD\";\n}\n\n.mdi-layers-outline::before {\n  content: \"\\F09FE\";\n}\n\n.mdi-layers-plus::before {\n  content: \"\\F0E4D\";\n}\n\n.mdi-layers-remove::before {\n  content: \"\\F0E4E\";\n}\n\n.mdi-layers-search::before {\n  content: \"\\F1206\";\n}\n\n.mdi-layers-search-outline::before {\n  content: \"\\F1207\";\n}\n\n.mdi-layers-triple::before {\n  content: \"\\F0F58\";\n}\n\n.mdi-layers-triple-outline::before {\n  content: \"\\F0F59\";\n}\n\n.mdi-lead-pencil::before {\n  content: \"\\F064F\";\n}\n\n.mdi-leaf::before {\n  content: \"\\F032A\";\n}\n\n.mdi-leaf-circle::before {\n  content: \"\\F1905\";\n}\n\n.mdi-leaf-circle-outline::before {\n  content: \"\\F1906\";\n}\n\n.mdi-leaf-maple::before {\n  content: \"\\F0C93\";\n}\n\n.mdi-leaf-maple-off::before {\n  content: \"\\F12DA\";\n}\n\n.mdi-leaf-off::before {\n  content: \"\\F12D9\";\n}\n\n.mdi-leak::before {\n  content: \"\\F0DD7\";\n}\n\n.mdi-leak-off::before {\n  content: \"\\F0DD8\";\n}\n\n.mdi-led-off::before {\n  content: \"\\F032B\";\n}\n\n.mdi-led-on::before {\n  content: \"\\F032C\";\n}\n\n.mdi-led-outline::before {\n  content: \"\\F032D\";\n}\n\n.mdi-led-strip::before {\n  content: \"\\F07D6\";\n}\n\n.mdi-led-strip-variant::before {\n  content: \"\\F1051\";\n}\n\n.mdi-led-variant-off::before {\n  content: \"\\F032E\";\n}\n\n.mdi-led-variant-on::before {\n  content: \"\\F032F\";\n}\n\n.mdi-led-variant-outline::before {\n  content: \"\\F0330\";\n}\n\n.mdi-leek::before {\n  content: \"\\F117D\";\n}\n\n.mdi-less-than::before {\n  content: \"\\F097C\";\n}\n\n.mdi-less-than-or-equal::before {\n  content: \"\\F097D\";\n}\n\n.mdi-library::before {\n  content: \"\\F0331\";\n}\n\n.mdi-library-shelves::before {\n  content: \"\\F0BA9\";\n}\n\n.mdi-license::before {\n  content: \"\\F0FC3\";\n}\n\n.mdi-lifebuoy::before {\n  content: \"\\F087E\";\n}\n\n.mdi-light-flood-down::before {\n  content: \"\\F1987\";\n}\n\n.mdi-light-flood-up::before {\n  content: \"\\F1988\";\n}\n\n.mdi-light-recessed::before {\n  content: \"\\F179B\";\n}\n\n.mdi-light-switch::before {\n  content: \"\\F097E\";\n}\n\n.mdi-lightbulb::before {\n  content: \"\\F0335\";\n}\n\n.mdi-lightbulb-auto::before {\n  content: \"\\F1800\";\n}\n\n.mdi-lightbulb-auto-outline::before {\n  content: \"\\F1801\";\n}\n\n.mdi-lightbulb-cfl::before {\n  content: \"\\F1208\";\n}\n\n.mdi-lightbulb-cfl-off::before {\n  content: \"\\F1209\";\n}\n\n.mdi-lightbulb-cfl-spiral::before {\n  content: \"\\F1275\";\n}\n\n.mdi-lightbulb-cfl-spiral-off::before {\n  content: \"\\F12C3\";\n}\n\n.mdi-lightbulb-fluorescent-tube::before {\n  content: \"\\F1804\";\n}\n\n.mdi-lightbulb-fluorescent-tube-outline::before {\n  content: \"\\F1805\";\n}\n\n.mdi-lightbulb-group::before {\n  content: \"\\F1253\";\n}\n\n.mdi-lightbulb-group-off::before {\n  content: \"\\F12CD\";\n}\n\n.mdi-lightbulb-group-off-outline::before {\n  content: \"\\F12CE\";\n}\n\n.mdi-lightbulb-group-outline::before {\n  content: \"\\F1254\";\n}\n\n.mdi-lightbulb-multiple::before {\n  content: \"\\F1255\";\n}\n\n.mdi-lightbulb-multiple-off::before {\n  content: \"\\F12CF\";\n}\n\n.mdi-lightbulb-multiple-off-outline::before {\n  content: \"\\F12D0\";\n}\n\n.mdi-lightbulb-multiple-outline::before {\n  content: \"\\F1256\";\n}\n\n.mdi-lightbulb-off::before {\n  content: \"\\F0E4F\";\n}\n\n.mdi-lightbulb-off-outline::before {\n  content: \"\\F0E50\";\n}\n\n.mdi-lightbulb-on::before {\n  content: \"\\F06E8\";\n}\n\n.mdi-lightbulb-on-outline::before {\n  content: \"\\F06E9\";\n}\n\n.mdi-lightbulb-outline::before {\n  content: \"\\F0336\";\n}\n\n.mdi-lightbulb-spot::before {\n  content: \"\\F17F4\";\n}\n\n.mdi-lightbulb-spot-off::before {\n  content: \"\\F17F5\";\n}\n\n.mdi-lightbulb-variant::before {\n  content: \"\\F1802\";\n}\n\n.mdi-lightbulb-variant-outline::before {\n  content: \"\\F1803\";\n}\n\n.mdi-lighthouse::before {\n  content: \"\\F09FF\";\n}\n\n.mdi-lighthouse-on::before {\n  content: \"\\F0A00\";\n}\n\n.mdi-lightning-bolt::before {\n  content: \"\\F140B\";\n}\n\n.mdi-lightning-bolt-circle::before {\n  content: \"\\F0820\";\n}\n\n.mdi-lightning-bolt-outline::before {\n  content: \"\\F140C\";\n}\n\n.mdi-line-scan::before {\n  content: \"\\F0624\";\n}\n\n.mdi-lingerie::before {\n  content: \"\\F1476\";\n}\n\n.mdi-link::before {\n  content: \"\\F0337\";\n}\n\n.mdi-link-box::before {\n  content: \"\\F0D1A\";\n}\n\n.mdi-link-box-outline::before {\n  content: \"\\F0D1B\";\n}\n\n.mdi-link-box-variant::before {\n  content: \"\\F0D1C\";\n}\n\n.mdi-link-box-variant-outline::before {\n  content: \"\\F0D1D\";\n}\n\n.mdi-link-lock::before {\n  content: \"\\F10BA\";\n}\n\n.mdi-link-off::before {\n  content: \"\\F0338\";\n}\n\n.mdi-link-plus::before {\n  content: \"\\F0C94\";\n}\n\n.mdi-link-variant::before {\n  content: \"\\F0339\";\n}\n\n.mdi-link-variant-minus::before {\n  content: \"\\F10FF\";\n}\n\n.mdi-link-variant-off::before {\n  content: \"\\F033A\";\n}\n\n.mdi-link-variant-plus::before {\n  content: \"\\F1100\";\n}\n\n.mdi-link-variant-remove::before {\n  content: \"\\F1101\";\n}\n\n.mdi-linkedin::before {\n  content: \"\\F033B\";\n}\n\n.mdi-linux::before {\n  content: \"\\F033D\";\n}\n\n.mdi-linux-mint::before {\n  content: \"\\F08ED\";\n}\n\n.mdi-lipstick::before {\n  content: \"\\F13B5\";\n}\n\n.mdi-liquid-spot::before {\n  content: \"\\F1826\";\n}\n\n.mdi-liquor::before {\n  content: \"\\F191E\";\n}\n\n.mdi-list-status::before {\n  content: \"\\F15AB\";\n}\n\n.mdi-litecoin::before {\n  content: \"\\F0A61\";\n}\n\n.mdi-loading::before {\n  content: \"\\F0772\";\n}\n\n.mdi-location-enter::before {\n  content: \"\\F0FC4\";\n}\n\n.mdi-location-exit::before {\n  content: \"\\F0FC5\";\n}\n\n.mdi-lock::before {\n  content: \"\\F033E\";\n}\n\n.mdi-lock-alert::before {\n  content: \"\\F08EE\";\n}\n\n.mdi-lock-alert-outline::before {\n  content: \"\\F15D1\";\n}\n\n.mdi-lock-check::before {\n  content: \"\\F139A\";\n}\n\n.mdi-lock-check-outline::before {\n  content: \"\\F16A8\";\n}\n\n.mdi-lock-clock::before {\n  content: \"\\F097F\";\n}\n\n.mdi-lock-minus::before {\n  content: \"\\F16A9\";\n}\n\n.mdi-lock-minus-outline::before {\n  content: \"\\F16AA\";\n}\n\n.mdi-lock-off::before {\n  content: \"\\F1671\";\n}\n\n.mdi-lock-off-outline::before {\n  content: \"\\F1672\";\n}\n\n.mdi-lock-open::before {\n  content: \"\\F033F\";\n}\n\n.mdi-lock-open-alert::before {\n  content: \"\\F139B\";\n}\n\n.mdi-lock-open-alert-outline::before {\n  content: \"\\F15D2\";\n}\n\n.mdi-lock-open-check::before {\n  content: \"\\F139C\";\n}\n\n.mdi-lock-open-check-outline::before {\n  content: \"\\F16AB\";\n}\n\n.mdi-lock-open-minus::before {\n  content: \"\\F16AC\";\n}\n\n.mdi-lock-open-minus-outline::before {\n  content: \"\\F16AD\";\n}\n\n.mdi-lock-open-outline::before {\n  content: \"\\F0340\";\n}\n\n.mdi-lock-open-plus::before {\n  content: \"\\F16AE\";\n}\n\n.mdi-lock-open-plus-outline::before {\n  content: \"\\F16AF\";\n}\n\n.mdi-lock-open-remove::before {\n  content: \"\\F16B0\";\n}\n\n.mdi-lock-open-remove-outline::before {\n  content: \"\\F16B1\";\n}\n\n.mdi-lock-open-variant::before {\n  content: \"\\F0FC6\";\n}\n\n.mdi-lock-open-variant-outline::before {\n  content: \"\\F0FC7\";\n}\n\n.mdi-lock-outline::before {\n  content: \"\\F0341\";\n}\n\n.mdi-lock-pattern::before {\n  content: \"\\F06EA\";\n}\n\n.mdi-lock-plus::before {\n  content: \"\\F05FB\";\n}\n\n.mdi-lock-plus-outline::before {\n  content: \"\\F16B2\";\n}\n\n.mdi-lock-question::before {\n  content: \"\\F08EF\";\n}\n\n.mdi-lock-remove::before {\n  content: \"\\F16B3\";\n}\n\n.mdi-lock-remove-outline::before {\n  content: \"\\F16B4\";\n}\n\n.mdi-lock-reset::before {\n  content: \"\\F0773\";\n}\n\n.mdi-lock-smart::before {\n  content: \"\\F08B2\";\n}\n\n.mdi-locker::before {\n  content: \"\\F07D7\";\n}\n\n.mdi-locker-multiple::before {\n  content: \"\\F07D8\";\n}\n\n.mdi-login::before {\n  content: \"\\F0342\";\n}\n\n.mdi-login-variant::before {\n  content: \"\\F05FC\";\n}\n\n.mdi-logout::before {\n  content: \"\\F0343\";\n}\n\n.mdi-logout-variant::before {\n  content: \"\\F05FD\";\n}\n\n.mdi-longitude::before {\n  content: \"\\F0F5A\";\n}\n\n.mdi-looks::before {\n  content: \"\\F0344\";\n}\n\n.mdi-lotion::before {\n  content: \"\\F1582\";\n}\n\n.mdi-lotion-outline::before {\n  content: \"\\F1583\";\n}\n\n.mdi-lotion-plus::before {\n  content: \"\\F1584\";\n}\n\n.mdi-lotion-plus-outline::before {\n  content: \"\\F1585\";\n}\n\n.mdi-loupe::before {\n  content: \"\\F0345\";\n}\n\n.mdi-lumx::before {\n  content: \"\\F0346\";\n}\n\n.mdi-lungs::before {\n  content: \"\\F1084\";\n}\n\n.mdi-mace::before {\n  content: \"\\F1843\";\n}\n\n.mdi-magazine-pistol::before {\n  content: \"\\F0324\";\n}\n\n.mdi-magazine-rifle::before {\n  content: \"\\F0323\";\n}\n\n.mdi-magic-staff::before {\n  content: \"\\F1844\";\n}\n\n.mdi-magnet::before {\n  content: \"\\F0347\";\n}\n\n.mdi-magnet-on::before {\n  content: \"\\F0348\";\n}\n\n.mdi-magnify::before {\n  content: \"\\F0349\";\n}\n\n.mdi-magnify-close::before {\n  content: \"\\F0980\";\n}\n\n.mdi-magnify-expand::before {\n  content: \"\\F1874\";\n}\n\n.mdi-magnify-minus::before {\n  content: \"\\F034A\";\n}\n\n.mdi-magnify-minus-cursor::before {\n  content: \"\\F0A62\";\n}\n\n.mdi-magnify-minus-outline::before {\n  content: \"\\F06EC\";\n}\n\n.mdi-magnify-plus::before {\n  content: \"\\F034B\";\n}\n\n.mdi-magnify-plus-cursor::before {\n  content: \"\\F0A63\";\n}\n\n.mdi-magnify-plus-outline::before {\n  content: \"\\F06ED\";\n}\n\n.mdi-magnify-remove-cursor::before {\n  content: \"\\F120C\";\n}\n\n.mdi-magnify-remove-outline::before {\n  content: \"\\F120D\";\n}\n\n.mdi-magnify-scan::before {\n  content: \"\\F1276\";\n}\n\n.mdi-mail::before {\n  content: \"\\F0EBB\";\n}\n\n.mdi-mailbox::before {\n  content: \"\\F06EE\";\n}\n\n.mdi-mailbox-open::before {\n  content: \"\\F0D88\";\n}\n\n.mdi-mailbox-open-outline::before {\n  content: \"\\F0D89\";\n}\n\n.mdi-mailbox-open-up::before {\n  content: \"\\F0D8A\";\n}\n\n.mdi-mailbox-open-up-outline::before {\n  content: \"\\F0D8B\";\n}\n\n.mdi-mailbox-outline::before {\n  content: \"\\F0D8C\";\n}\n\n.mdi-mailbox-up::before {\n  content: \"\\F0D8D\";\n}\n\n.mdi-mailbox-up-outline::before {\n  content: \"\\F0D8E\";\n}\n\n.mdi-manjaro::before {\n  content: \"\\F160A\";\n}\n\n.mdi-map::before {\n  content: \"\\F034D\";\n}\n\n.mdi-map-check::before {\n  content: \"\\F0EBC\";\n}\n\n.mdi-map-check-outline::before {\n  content: \"\\F0EBD\";\n}\n\n.mdi-map-clock::before {\n  content: \"\\F0D1E\";\n}\n\n.mdi-map-clock-outline::before {\n  content: \"\\F0D1F\";\n}\n\n.mdi-map-legend::before {\n  content: \"\\F0A01\";\n}\n\n.mdi-map-marker::before {\n  content: \"\\F034E\";\n}\n\n.mdi-map-marker-account::before {\n  content: \"\\F18E3\";\n}\n\n.mdi-map-marker-account-outline::before {\n  content: \"\\F18E4\";\n}\n\n.mdi-map-marker-alert::before {\n  content: \"\\F0F05\";\n}\n\n.mdi-map-marker-alert-outline::before {\n  content: \"\\F0F06\";\n}\n\n.mdi-map-marker-check::before {\n  content: \"\\F0C95\";\n}\n\n.mdi-map-marker-check-outline::before {\n  content: \"\\F12FB\";\n}\n\n.mdi-map-marker-circle::before {\n  content: \"\\F034F\";\n}\n\n.mdi-map-marker-distance::before {\n  content: \"\\F08F0\";\n}\n\n.mdi-map-marker-down::before {\n  content: \"\\F1102\";\n}\n\n.mdi-map-marker-left::before {\n  content: \"\\F12DB\";\n}\n\n.mdi-map-marker-left-outline::before {\n  content: \"\\F12DD\";\n}\n\n.mdi-map-marker-minus::before {\n  content: \"\\F0650\";\n}\n\n.mdi-map-marker-minus-outline::before {\n  content: \"\\F12F9\";\n}\n\n.mdi-map-marker-multiple::before {\n  content: \"\\F0350\";\n}\n\n.mdi-map-marker-multiple-outline::before {\n  content: \"\\F1277\";\n}\n\n.mdi-map-marker-off::before {\n  content: \"\\F0351\";\n}\n\n.mdi-map-marker-off-outline::before {\n  content: \"\\F12FD\";\n}\n\n.mdi-map-marker-outline::before {\n  content: \"\\F07D9\";\n}\n\n.mdi-map-marker-path::before {\n  content: \"\\F0D20\";\n}\n\n.mdi-map-marker-plus::before {\n  content: \"\\F0651\";\n}\n\n.mdi-map-marker-plus-outline::before {\n  content: \"\\F12F8\";\n}\n\n.mdi-map-marker-question::before {\n  content: \"\\F0F07\";\n}\n\n.mdi-map-marker-question-outline::before {\n  content: \"\\F0F08\";\n}\n\n.mdi-map-marker-radius::before {\n  content: \"\\F0352\";\n}\n\n.mdi-map-marker-radius-outline::before {\n  content: \"\\F12FC\";\n}\n\n.mdi-map-marker-remove::before {\n  content: \"\\F0F09\";\n}\n\n.mdi-map-marker-remove-outline::before {\n  content: \"\\F12FA\";\n}\n\n.mdi-map-marker-remove-variant::before {\n  content: \"\\F0F0A\";\n}\n\n.mdi-map-marker-right::before {\n  content: \"\\F12DC\";\n}\n\n.mdi-map-marker-right-outline::before {\n  content: \"\\F12DE\";\n}\n\n.mdi-map-marker-star::before {\n  content: \"\\F1608\";\n}\n\n.mdi-map-marker-star-outline::before {\n  content: \"\\F1609\";\n}\n\n.mdi-map-marker-up::before {\n  content: \"\\F1103\";\n}\n\n.mdi-map-minus::before {\n  content: \"\\F0981\";\n}\n\n.mdi-map-outline::before {\n  content: \"\\F0982\";\n}\n\n.mdi-map-plus::before {\n  content: \"\\F0983\";\n}\n\n.mdi-map-search::before {\n  content: \"\\F0984\";\n}\n\n.mdi-map-search-outline::before {\n  content: \"\\F0985\";\n}\n\n.mdi-mapbox::before {\n  content: \"\\F0BAA\";\n}\n\n.mdi-margin::before {\n  content: \"\\F0353\";\n}\n\n.mdi-marker::before {\n  content: \"\\F0652\";\n}\n\n.mdi-marker-cancel::before {\n  content: \"\\F0DD9\";\n}\n\n.mdi-marker-check::before {\n  content: \"\\F0355\";\n}\n\n.mdi-mastodon::before {\n  content: \"\\F0AD1\";\n}\n\n.mdi-material-design::before {\n  content: \"\\F0986\";\n}\n\n.mdi-material-ui::before {\n  content: \"\\F0357\";\n}\n\n.mdi-math-compass::before {\n  content: \"\\F0358\";\n}\n\n.mdi-math-cos::before {\n  content: \"\\F0C96\";\n}\n\n.mdi-math-integral::before {\n  content: \"\\F0FC8\";\n}\n\n.mdi-math-integral-box::before {\n  content: \"\\F0FC9\";\n}\n\n.mdi-math-log::before {\n  content: \"\\F1085\";\n}\n\n.mdi-math-norm::before {\n  content: \"\\F0FCA\";\n}\n\n.mdi-math-norm-box::before {\n  content: \"\\F0FCB\";\n}\n\n.mdi-math-sin::before {\n  content: \"\\F0C97\";\n}\n\n.mdi-math-tan::before {\n  content: \"\\F0C98\";\n}\n\n.mdi-matrix::before {\n  content: \"\\F0628\";\n}\n\n.mdi-medal::before {\n  content: \"\\F0987\";\n}\n\n.mdi-medal-outline::before {\n  content: \"\\F1326\";\n}\n\n.mdi-medical-bag::before {\n  content: \"\\F06EF\";\n}\n\n.mdi-meditation::before {\n  content: \"\\F117B\";\n}\n\n.mdi-memory::before {\n  content: \"\\F035B\";\n}\n\n.mdi-menorah::before {\n  content: \"\\F17D4\";\n}\n\n.mdi-menorah-fire::before {\n  content: \"\\F17D5\";\n}\n\n.mdi-menu::before {\n  content: \"\\F035C\";\n}\n\n.mdi-menu-down::before {\n  content: \"\\F035D\";\n}\n\n.mdi-menu-down-outline::before {\n  content: \"\\F06B6\";\n}\n\n.mdi-menu-left::before {\n  content: \"\\F035E\";\n}\n\n.mdi-menu-left-outline::before {\n  content: \"\\F0A02\";\n}\n\n.mdi-menu-open::before {\n  content: \"\\F0BAB\";\n}\n\n.mdi-menu-right::before {\n  content: \"\\F035F\";\n}\n\n.mdi-menu-right-outline::before {\n  content: \"\\F0A03\";\n}\n\n.mdi-menu-swap::before {\n  content: \"\\F0A64\";\n}\n\n.mdi-menu-swap-outline::before {\n  content: \"\\F0A65\";\n}\n\n.mdi-menu-up::before {\n  content: \"\\F0360\";\n}\n\n.mdi-menu-up-outline::before {\n  content: \"\\F06B7\";\n}\n\n.mdi-merge::before {\n  content: \"\\F0F5C\";\n}\n\n.mdi-message::before {\n  content: \"\\F0361\";\n}\n\n.mdi-message-alert::before {\n  content: \"\\F0362\";\n}\n\n.mdi-message-alert-outline::before {\n  content: \"\\F0A04\";\n}\n\n.mdi-message-arrow-left::before {\n  content: \"\\F12F2\";\n}\n\n.mdi-message-arrow-left-outline::before {\n  content: \"\\F12F3\";\n}\n\n.mdi-message-arrow-right::before {\n  content: \"\\F12F4\";\n}\n\n.mdi-message-arrow-right-outline::before {\n  content: \"\\F12F5\";\n}\n\n.mdi-message-badge::before {\n  content: \"\\F1941\";\n}\n\n.mdi-message-badge-outline::before {\n  content: \"\\F1942\";\n}\n\n.mdi-message-bookmark::before {\n  content: \"\\F15AC\";\n}\n\n.mdi-message-bookmark-outline::before {\n  content: \"\\F15AD\";\n}\n\n.mdi-message-bulleted::before {\n  content: \"\\F06A2\";\n}\n\n.mdi-message-bulleted-off::before {\n  content: \"\\F06A3\";\n}\n\n.mdi-message-cog::before {\n  content: \"\\F06F1\";\n}\n\n.mdi-message-cog-outline::before {\n  content: \"\\F1172\";\n}\n\n.mdi-message-draw::before {\n  content: \"\\F0363\";\n}\n\n.mdi-message-flash::before {\n  content: \"\\F15A9\";\n}\n\n.mdi-message-flash-outline::before {\n  content: \"\\F15AA\";\n}\n\n.mdi-message-image::before {\n  content: \"\\F0364\";\n}\n\n.mdi-message-image-outline::before {\n  content: \"\\F116C\";\n}\n\n.mdi-message-lock::before {\n  content: \"\\F0FCC\";\n}\n\n.mdi-message-lock-outline::before {\n  content: \"\\F116D\";\n}\n\n.mdi-message-minus::before {\n  content: \"\\F116E\";\n}\n\n.mdi-message-minus-outline::before {\n  content: \"\\F116F\";\n}\n\n.mdi-message-off::before {\n  content: \"\\F164D\";\n}\n\n.mdi-message-off-outline::before {\n  content: \"\\F164E\";\n}\n\n.mdi-message-outline::before {\n  content: \"\\F0365\";\n}\n\n.mdi-message-plus::before {\n  content: \"\\F0653\";\n}\n\n.mdi-message-plus-outline::before {\n  content: \"\\F10BB\";\n}\n\n.mdi-message-processing::before {\n  content: \"\\F0366\";\n}\n\n.mdi-message-processing-outline::before {\n  content: \"\\F1170\";\n}\n\n.mdi-message-question::before {\n  content: \"\\F173A\";\n}\n\n.mdi-message-question-outline::before {\n  content: \"\\F173B\";\n}\n\n.mdi-message-reply::before {\n  content: \"\\F0367\";\n}\n\n.mdi-message-reply-outline::before {\n  content: \"\\F173D\";\n}\n\n.mdi-message-reply-text::before {\n  content: \"\\F0368\";\n}\n\n.mdi-message-reply-text-outline::before {\n  content: \"\\F173E\";\n}\n\n.mdi-message-settings::before {\n  content: \"\\F06F0\";\n}\n\n.mdi-message-settings-outline::before {\n  content: \"\\F1171\";\n}\n\n.mdi-message-star::before {\n  content: \"\\F069A\";\n}\n\n.mdi-message-star-outline::before {\n  content: \"\\F1250\";\n}\n\n.mdi-message-text::before {\n  content: \"\\F0369\";\n}\n\n.mdi-message-text-clock::before {\n  content: \"\\F1173\";\n}\n\n.mdi-message-text-clock-outline::before {\n  content: \"\\F1174\";\n}\n\n.mdi-message-text-lock::before {\n  content: \"\\F0FCD\";\n}\n\n.mdi-message-text-lock-outline::before {\n  content: \"\\F1175\";\n}\n\n.mdi-message-text-outline::before {\n  content: \"\\F036A\";\n}\n\n.mdi-message-video::before {\n  content: \"\\F036B\";\n}\n\n.mdi-meteor::before {\n  content: \"\\F0629\";\n}\n\n.mdi-metronome::before {\n  content: \"\\F07DA\";\n}\n\n.mdi-metronome-tick::before {\n  content: \"\\F07DB\";\n}\n\n.mdi-micro-sd::before {\n  content: \"\\F07DC\";\n}\n\n.mdi-microphone::before {\n  content: \"\\F036C\";\n}\n\n.mdi-microphone-minus::before {\n  content: \"\\F08B3\";\n}\n\n.mdi-microphone-off::before {\n  content: \"\\F036D\";\n}\n\n.mdi-microphone-outline::before {\n  content: \"\\F036E\";\n}\n\n.mdi-microphone-plus::before {\n  content: \"\\F08B4\";\n}\n\n.mdi-microphone-question::before {\n  content: \"\\F1989\";\n}\n\n.mdi-microphone-question-outline::before {\n  content: \"\\F198A\";\n}\n\n.mdi-microphone-settings::before {\n  content: \"\\F036F\";\n}\n\n.mdi-microphone-variant::before {\n  content: \"\\F0370\";\n}\n\n.mdi-microphone-variant-off::before {\n  content: \"\\F0371\";\n}\n\n.mdi-microscope::before {\n  content: \"\\F0654\";\n}\n\n.mdi-microsoft::before {\n  content: \"\\F0372\";\n}\n\n.mdi-microsoft-access::before {\n  content: \"\\F138E\";\n}\n\n.mdi-microsoft-azure::before {\n  content: \"\\F0805\";\n}\n\n.mdi-microsoft-azure-devops::before {\n  content: \"\\F0FD5\";\n}\n\n.mdi-microsoft-bing::before {\n  content: \"\\F00A4\";\n}\n\n.mdi-microsoft-dynamics-365::before {\n  content: \"\\F0988\";\n}\n\n.mdi-microsoft-edge::before {\n  content: \"\\F01E9\";\n}\n\n.mdi-microsoft-excel::before {\n  content: \"\\F138F\";\n}\n\n.mdi-microsoft-internet-explorer::before {\n  content: \"\\F0300\";\n}\n\n.mdi-microsoft-office::before {\n  content: \"\\F03C6\";\n}\n\n.mdi-microsoft-onedrive::before {\n  content: \"\\F03CA\";\n}\n\n.mdi-microsoft-onenote::before {\n  content: \"\\F0747\";\n}\n\n.mdi-microsoft-outlook::before {\n  content: \"\\F0D22\";\n}\n\n.mdi-microsoft-powerpoint::before {\n  content: \"\\F1390\";\n}\n\n.mdi-microsoft-sharepoint::before {\n  content: \"\\F1391\";\n}\n\n.mdi-microsoft-teams::before {\n  content: \"\\F02BB\";\n}\n\n.mdi-microsoft-visual-studio::before {\n  content: \"\\F0610\";\n}\n\n.mdi-microsoft-visual-studio-code::before {\n  content: \"\\F0A1E\";\n}\n\n.mdi-microsoft-windows::before {\n  content: \"\\F05B3\";\n}\n\n.mdi-microsoft-windows-classic::before {\n  content: \"\\F0A21\";\n}\n\n.mdi-microsoft-word::before {\n  content: \"\\F1392\";\n}\n\n.mdi-microsoft-xbox::before {\n  content: \"\\F05B9\";\n}\n\n.mdi-microsoft-xbox-controller::before {\n  content: \"\\F05BA\";\n}\n\n.mdi-microsoft-xbox-controller-battery-alert::before {\n  content: \"\\F074B\";\n}\n\n.mdi-microsoft-xbox-controller-battery-charging::before {\n  content: \"\\F0A22\";\n}\n\n.mdi-microsoft-xbox-controller-battery-empty::before {\n  content: \"\\F074C\";\n}\n\n.mdi-microsoft-xbox-controller-battery-full::before {\n  content: \"\\F074D\";\n}\n\n.mdi-microsoft-xbox-controller-battery-low::before {\n  content: \"\\F074E\";\n}\n\n.mdi-microsoft-xbox-controller-battery-medium::before {\n  content: \"\\F074F\";\n}\n\n.mdi-microsoft-xbox-controller-battery-unknown::before {\n  content: \"\\F0750\";\n}\n\n.mdi-microsoft-xbox-controller-menu::before {\n  content: \"\\F0E6F\";\n}\n\n.mdi-microsoft-xbox-controller-off::before {\n  content: \"\\F05BB\";\n}\n\n.mdi-microsoft-xbox-controller-view::before {\n  content: \"\\F0E70\";\n}\n\n.mdi-microwave::before {\n  content: \"\\F0C99\";\n}\n\n.mdi-microwave-off::before {\n  content: \"\\F1423\";\n}\n\n.mdi-middleware::before {\n  content: \"\\F0F5D\";\n}\n\n.mdi-middleware-outline::before {\n  content: \"\\F0F5E\";\n}\n\n.mdi-midi::before {\n  content: \"\\F08F1\";\n}\n\n.mdi-midi-port::before {\n  content: \"\\F08F2\";\n}\n\n.mdi-mine::before {\n  content: \"\\F0DDA\";\n}\n\n.mdi-minecraft::before {\n  content: \"\\F0373\";\n}\n\n.mdi-mini-sd::before {\n  content: \"\\F0A05\";\n}\n\n.mdi-minidisc::before {\n  content: \"\\F0A06\";\n}\n\n.mdi-minus::before {\n  content: \"\\F0374\";\n}\n\n.mdi-minus-box::before {\n  content: \"\\F0375\";\n}\n\n.mdi-minus-box-multiple::before {\n  content: \"\\F1141\";\n}\n\n.mdi-minus-box-multiple-outline::before {\n  content: \"\\F1142\";\n}\n\n.mdi-minus-box-outline::before {\n  content: \"\\F06F2\";\n}\n\n.mdi-minus-circle::before {\n  content: \"\\F0376\";\n}\n\n.mdi-minus-circle-multiple::before {\n  content: \"\\F035A\";\n}\n\n.mdi-minus-circle-multiple-outline::before {\n  content: \"\\F0AD3\";\n}\n\n.mdi-minus-circle-off::before {\n  content: \"\\F1459\";\n}\n\n.mdi-minus-circle-off-outline::before {\n  content: \"\\F145A\";\n}\n\n.mdi-minus-circle-outline::before {\n  content: \"\\F0377\";\n}\n\n.mdi-minus-network::before {\n  content: \"\\F0378\";\n}\n\n.mdi-minus-network-outline::before {\n  content: \"\\F0C9A\";\n}\n\n.mdi-minus-thick::before {\n  content: \"\\F1639\";\n}\n\n.mdi-mirror::before {\n  content: \"\\F11FD\";\n}\n\n.mdi-mirror-rectangle::before {\n  content: \"\\F179F\";\n}\n\n.mdi-mirror-variant::before {\n  content: \"\\F17A0\";\n}\n\n.mdi-mixed-martial-arts::before {\n  content: \"\\F0D8F\";\n}\n\n.mdi-mixed-reality::before {\n  content: \"\\F087F\";\n}\n\n.mdi-molecule::before {\n  content: \"\\F0BAC\";\n}\n\n.mdi-molecule-co::before {\n  content: \"\\F12FE\";\n}\n\n.mdi-molecule-co2::before {\n  content: \"\\F07E4\";\n}\n\n.mdi-monitor::before {\n  content: \"\\F0379\";\n}\n\n.mdi-monitor-cellphone::before {\n  content: \"\\F0989\";\n}\n\n.mdi-monitor-cellphone-star::before {\n  content: \"\\F098A\";\n}\n\n.mdi-monitor-dashboard::before {\n  content: \"\\F0A07\";\n}\n\n.mdi-monitor-edit::before {\n  content: \"\\F12C6\";\n}\n\n.mdi-monitor-eye::before {\n  content: \"\\F13B4\";\n}\n\n.mdi-monitor-lock::before {\n  content: \"\\F0DDB\";\n}\n\n.mdi-monitor-multiple::before {\n  content: \"\\F037A\";\n}\n\n.mdi-monitor-off::before {\n  content: \"\\F0D90\";\n}\n\n.mdi-monitor-screenshot::before {\n  content: \"\\F0E51\";\n}\n\n.mdi-monitor-share::before {\n  content: \"\\F1483\";\n}\n\n.mdi-monitor-shimmer::before {\n  content: \"\\F1104\";\n}\n\n.mdi-monitor-small::before {\n  content: \"\\F1876\";\n}\n\n.mdi-monitor-speaker::before {\n  content: \"\\F0F5F\";\n}\n\n.mdi-monitor-speaker-off::before {\n  content: \"\\F0F60\";\n}\n\n.mdi-monitor-star::before {\n  content: \"\\F0DDC\";\n}\n\n.mdi-moon-first-quarter::before {\n  content: \"\\F0F61\";\n}\n\n.mdi-moon-full::before {\n  content: \"\\F0F62\";\n}\n\n.mdi-moon-last-quarter::before {\n  content: \"\\F0F63\";\n}\n\n.mdi-moon-new::before {\n  content: \"\\F0F64\";\n}\n\n.mdi-moon-waning-crescent::before {\n  content: \"\\F0F65\";\n}\n\n.mdi-moon-waning-gibbous::before {\n  content: \"\\F0F66\";\n}\n\n.mdi-moon-waxing-crescent::before {\n  content: \"\\F0F67\";\n}\n\n.mdi-moon-waxing-gibbous::before {\n  content: \"\\F0F68\";\n}\n\n.mdi-moped::before {\n  content: \"\\F1086\";\n}\n\n.mdi-moped-electric::before {\n  content: \"\\F15B7\";\n}\n\n.mdi-moped-electric-outline::before {\n  content: \"\\F15B8\";\n}\n\n.mdi-moped-outline::before {\n  content: \"\\F15B9\";\n}\n\n.mdi-more::before {\n  content: \"\\F037B\";\n}\n\n.mdi-mortar-pestle::before {\n  content: \"\\F1748\";\n}\n\n.mdi-mortar-pestle-plus::before {\n  content: \"\\F03F1\";\n}\n\n.mdi-mosque::before {\n  content: \"\\F1827\";\n}\n\n.mdi-mother-heart::before {\n  content: \"\\F1314\";\n}\n\n.mdi-mother-nurse::before {\n  content: \"\\F0D21\";\n}\n\n.mdi-motion::before {\n  content: \"\\F15B2\";\n}\n\n.mdi-motion-outline::before {\n  content: \"\\F15B3\";\n}\n\n.mdi-motion-pause::before {\n  content: \"\\F1590\";\n}\n\n.mdi-motion-pause-outline::before {\n  content: \"\\F1592\";\n}\n\n.mdi-motion-play::before {\n  content: \"\\F158F\";\n}\n\n.mdi-motion-play-outline::before {\n  content: \"\\F1591\";\n}\n\n.mdi-motion-sensor::before {\n  content: \"\\F0D91\";\n}\n\n.mdi-motion-sensor-off::before {\n  content: \"\\F1435\";\n}\n\n.mdi-motorbike::before {\n  content: \"\\F037C\";\n}\n\n.mdi-motorbike-electric::before {\n  content: \"\\F15BA\";\n}\n\n.mdi-mouse::before {\n  content: \"\\F037D\";\n}\n\n.mdi-mouse-bluetooth::before {\n  content: \"\\F098B\";\n}\n\n.mdi-mouse-move-down::before {\n  content: \"\\F1550\";\n}\n\n.mdi-mouse-move-up::before {\n  content: \"\\F1551\";\n}\n\n.mdi-mouse-move-vertical::before {\n  content: \"\\F1552\";\n}\n\n.mdi-mouse-off::before {\n  content: \"\\F037E\";\n}\n\n.mdi-mouse-variant::before {\n  content: \"\\F037F\";\n}\n\n.mdi-mouse-variant-off::before {\n  content: \"\\F0380\";\n}\n\n.mdi-move-resize::before {\n  content: \"\\F0655\";\n}\n\n.mdi-move-resize-variant::before {\n  content: \"\\F0656\";\n}\n\n.mdi-movie::before {\n  content: \"\\F0381\";\n}\n\n.mdi-movie-check::before {\n  content: \"\\F16F3\";\n}\n\n.mdi-movie-check-outline::before {\n  content: \"\\F16F4\";\n}\n\n.mdi-movie-cog::before {\n  content: \"\\F16F5\";\n}\n\n.mdi-movie-cog-outline::before {\n  content: \"\\F16F6\";\n}\n\n.mdi-movie-edit::before {\n  content: \"\\F1122\";\n}\n\n.mdi-movie-edit-outline::before {\n  content: \"\\F1123\";\n}\n\n.mdi-movie-filter::before {\n  content: \"\\F1124\";\n}\n\n.mdi-movie-filter-outline::before {\n  content: \"\\F1125\";\n}\n\n.mdi-movie-minus::before {\n  content: \"\\F16F7\";\n}\n\n.mdi-movie-minus-outline::before {\n  content: \"\\F16F8\";\n}\n\n.mdi-movie-off::before {\n  content: \"\\F16F9\";\n}\n\n.mdi-movie-off-outline::before {\n  content: \"\\F16FA\";\n}\n\n.mdi-movie-open::before {\n  content: \"\\F0FCE\";\n}\n\n.mdi-movie-open-check::before {\n  content: \"\\F16FB\";\n}\n\n.mdi-movie-open-check-outline::before {\n  content: \"\\F16FC\";\n}\n\n.mdi-movie-open-cog::before {\n  content: \"\\F16FD\";\n}\n\n.mdi-movie-open-cog-outline::before {\n  content: \"\\F16FE\";\n}\n\n.mdi-movie-open-edit::before {\n  content: \"\\F16FF\";\n}\n\n.mdi-movie-open-edit-outline::before {\n  content: \"\\F1700\";\n}\n\n.mdi-movie-open-minus::before {\n  content: \"\\F1701\";\n}\n\n.mdi-movie-open-minus-outline::before {\n  content: \"\\F1702\";\n}\n\n.mdi-movie-open-off::before {\n  content: \"\\F1703\";\n}\n\n.mdi-movie-open-off-outline::before {\n  content: \"\\F1704\";\n}\n\n.mdi-movie-open-outline::before {\n  content: \"\\F0FCF\";\n}\n\n.mdi-movie-open-play::before {\n  content: \"\\F1705\";\n}\n\n.mdi-movie-open-play-outline::before {\n  content: \"\\F1706\";\n}\n\n.mdi-movie-open-plus::before {\n  content: \"\\F1707\";\n}\n\n.mdi-movie-open-plus-outline::before {\n  content: \"\\F1708\";\n}\n\n.mdi-movie-open-remove::before {\n  content: \"\\F1709\";\n}\n\n.mdi-movie-open-remove-outline::before {\n  content: \"\\F170A\";\n}\n\n.mdi-movie-open-settings::before {\n  content: \"\\F170B\";\n}\n\n.mdi-movie-open-settings-outline::before {\n  content: \"\\F170C\";\n}\n\n.mdi-movie-open-star::before {\n  content: \"\\F170D\";\n}\n\n.mdi-movie-open-star-outline::before {\n  content: \"\\F170E\";\n}\n\n.mdi-movie-outline::before {\n  content: \"\\F0DDD\";\n}\n\n.mdi-movie-play::before {\n  content: \"\\F170F\";\n}\n\n.mdi-movie-play-outline::before {\n  content: \"\\F1710\";\n}\n\n.mdi-movie-plus::before {\n  content: \"\\F1711\";\n}\n\n.mdi-movie-plus-outline::before {\n  content: \"\\F1712\";\n}\n\n.mdi-movie-remove::before {\n  content: \"\\F1713\";\n}\n\n.mdi-movie-remove-outline::before {\n  content: \"\\F1714\";\n}\n\n.mdi-movie-roll::before {\n  content: \"\\F07DE\";\n}\n\n.mdi-movie-search::before {\n  content: \"\\F11D2\";\n}\n\n.mdi-movie-search-outline::before {\n  content: \"\\F11D3\";\n}\n\n.mdi-movie-settings::before {\n  content: \"\\F1715\";\n}\n\n.mdi-movie-settings-outline::before {\n  content: \"\\F1716\";\n}\n\n.mdi-movie-star::before {\n  content: \"\\F1717\";\n}\n\n.mdi-movie-star-outline::before {\n  content: \"\\F1718\";\n}\n\n.mdi-mower::before {\n  content: \"\\F166F\";\n}\n\n.mdi-mower-bag::before {\n  content: \"\\F1670\";\n}\n\n.mdi-muffin::before {\n  content: \"\\F098C\";\n}\n\n.mdi-multicast::before {\n  content: \"\\F1893\";\n}\n\n.mdi-multiplication::before {\n  content: \"\\F0382\";\n}\n\n.mdi-multiplication-box::before {\n  content: \"\\F0383\";\n}\n\n.mdi-mushroom::before {\n  content: \"\\F07DF\";\n}\n\n.mdi-mushroom-off::before {\n  content: \"\\F13FA\";\n}\n\n.mdi-mushroom-off-outline::before {\n  content: \"\\F13FB\";\n}\n\n.mdi-mushroom-outline::before {\n  content: \"\\F07E0\";\n}\n\n.mdi-music::before {\n  content: \"\\F075A\";\n}\n\n.mdi-music-accidental-double-flat::before {\n  content: \"\\F0F69\";\n}\n\n.mdi-music-accidental-double-sharp::before {\n  content: \"\\F0F6A\";\n}\n\n.mdi-music-accidental-flat::before {\n  content: \"\\F0F6B\";\n}\n\n.mdi-music-accidental-natural::before {\n  content: \"\\F0F6C\";\n}\n\n.mdi-music-accidental-sharp::before {\n  content: \"\\F0F6D\";\n}\n\n.mdi-music-box::before {\n  content: \"\\F0384\";\n}\n\n.mdi-music-box-multiple::before {\n  content: \"\\F0333\";\n}\n\n.mdi-music-box-multiple-outline::before {\n  content: \"\\F0F04\";\n}\n\n.mdi-music-box-outline::before {\n  content: \"\\F0385\";\n}\n\n.mdi-music-circle::before {\n  content: \"\\F0386\";\n}\n\n.mdi-music-circle-outline::before {\n  content: \"\\F0AD4\";\n}\n\n.mdi-music-clef-alto::before {\n  content: \"\\F0F6E\";\n}\n\n.mdi-music-clef-bass::before {\n  content: \"\\F0F6F\";\n}\n\n.mdi-music-clef-treble::before {\n  content: \"\\F0F70\";\n}\n\n.mdi-music-note::before {\n  content: \"\\F0387\";\n}\n\n.mdi-music-note-bluetooth::before {\n  content: \"\\F05FE\";\n}\n\n.mdi-music-note-bluetooth-off::before {\n  content: \"\\F05FF\";\n}\n\n.mdi-music-note-eighth::before {\n  content: \"\\F0388\";\n}\n\n.mdi-music-note-eighth-dotted::before {\n  content: \"\\F0F71\";\n}\n\n.mdi-music-note-half::before {\n  content: \"\\F0389\";\n}\n\n.mdi-music-note-half-dotted::before {\n  content: \"\\F0F72\";\n}\n\n.mdi-music-note-off::before {\n  content: \"\\F038A\";\n}\n\n.mdi-music-note-off-outline::before {\n  content: \"\\F0F73\";\n}\n\n.mdi-music-note-outline::before {\n  content: \"\\F0F74\";\n}\n\n.mdi-music-note-plus::before {\n  content: \"\\F0DDE\";\n}\n\n.mdi-music-note-quarter::before {\n  content: \"\\F038B\";\n}\n\n.mdi-music-note-quarter-dotted::before {\n  content: \"\\F0F75\";\n}\n\n.mdi-music-note-sixteenth::before {\n  content: \"\\F038C\";\n}\n\n.mdi-music-note-sixteenth-dotted::before {\n  content: \"\\F0F76\";\n}\n\n.mdi-music-note-whole::before {\n  content: \"\\F038D\";\n}\n\n.mdi-music-note-whole-dotted::before {\n  content: \"\\F0F77\";\n}\n\n.mdi-music-off::before {\n  content: \"\\F075B\";\n}\n\n.mdi-music-rest-eighth::before {\n  content: \"\\F0F78\";\n}\n\n.mdi-music-rest-half::before {\n  content: \"\\F0F79\";\n}\n\n.mdi-music-rest-quarter::before {\n  content: \"\\F0F7A\";\n}\n\n.mdi-music-rest-sixteenth::before {\n  content: \"\\F0F7B\";\n}\n\n.mdi-music-rest-whole::before {\n  content: \"\\F0F7C\";\n}\n\n.mdi-mustache::before {\n  content: \"\\F15DE\";\n}\n\n.mdi-nail::before {\n  content: \"\\F0DDF\";\n}\n\n.mdi-nas::before {\n  content: \"\\F08F3\";\n}\n\n.mdi-nativescript::before {\n  content: \"\\F0880\";\n}\n\n.mdi-nature::before {\n  content: \"\\F038E\";\n}\n\n.mdi-nature-people::before {\n  content: \"\\F038F\";\n}\n\n.mdi-navigation::before {\n  content: \"\\F0390\";\n}\n\n.mdi-navigation-outline::before {\n  content: \"\\F1607\";\n}\n\n.mdi-navigation-variant::before {\n  content: \"\\F18F0\";\n}\n\n.mdi-navigation-variant-outline::before {\n  content: \"\\F18F1\";\n}\n\n.mdi-near-me::before {\n  content: \"\\F05CD\";\n}\n\n.mdi-necklace::before {\n  content: \"\\F0F0B\";\n}\n\n.mdi-needle::before {\n  content: \"\\F0391\";\n}\n\n.mdi-netflix::before {\n  content: \"\\F0746\";\n}\n\n.mdi-network::before {\n  content: \"\\F06F3\";\n}\n\n.mdi-network-off::before {\n  content: \"\\F0C9B\";\n}\n\n.mdi-network-off-outline::before {\n  content: \"\\F0C9C\";\n}\n\n.mdi-network-outline::before {\n  content: \"\\F0C9D\";\n}\n\n.mdi-network-strength-1::before {\n  content: \"\\F08F4\";\n}\n\n.mdi-network-strength-1-alert::before {\n  content: \"\\F08F5\";\n}\n\n.mdi-network-strength-2::before {\n  content: \"\\F08F6\";\n}\n\n.mdi-network-strength-2-alert::before {\n  content: \"\\F08F7\";\n}\n\n.mdi-network-strength-3::before {\n  content: \"\\F08F8\";\n}\n\n.mdi-network-strength-3-alert::before {\n  content: \"\\F08F9\";\n}\n\n.mdi-network-strength-4::before {\n  content: \"\\F08FA\";\n}\n\n.mdi-network-strength-4-alert::before {\n  content: \"\\F08FB\";\n}\n\n.mdi-network-strength-4-cog::before {\n  content: \"\\F191A\";\n}\n\n.mdi-network-strength-off::before {\n  content: \"\\F08FC\";\n}\n\n.mdi-network-strength-off-outline::before {\n  content: \"\\F08FD\";\n}\n\n.mdi-network-strength-outline::before {\n  content: \"\\F08FE\";\n}\n\n.mdi-new-box::before {\n  content: \"\\F0394\";\n}\n\n.mdi-newspaper::before {\n  content: \"\\F0395\";\n}\n\n.mdi-newspaper-check::before {\n  content: \"\\F1943\";\n}\n\n.mdi-newspaper-minus::before {\n  content: \"\\F0F0C\";\n}\n\n.mdi-newspaper-plus::before {\n  content: \"\\F0F0D\";\n}\n\n.mdi-newspaper-remove::before {\n  content: \"\\F1944\";\n}\n\n.mdi-newspaper-variant::before {\n  content: \"\\F1001\";\n}\n\n.mdi-newspaper-variant-multiple::before {\n  content: \"\\F1002\";\n}\n\n.mdi-newspaper-variant-multiple-outline::before {\n  content: \"\\F1003\";\n}\n\n.mdi-newspaper-variant-outline::before {\n  content: \"\\F1004\";\n}\n\n.mdi-nfc::before {\n  content: \"\\F0396\";\n}\n\n.mdi-nfc-search-variant::before {\n  content: \"\\F0E53\";\n}\n\n.mdi-nfc-tap::before {\n  content: \"\\F0397\";\n}\n\n.mdi-nfc-variant::before {\n  content: \"\\F0398\";\n}\n\n.mdi-nfc-variant-off::before {\n  content: \"\\F0E54\";\n}\n\n.mdi-ninja::before {\n  content: \"\\F0774\";\n}\n\n.mdi-nintendo-game-boy::before {\n  content: \"\\F1393\";\n}\n\n.mdi-nintendo-switch::before {\n  content: \"\\F07E1\";\n}\n\n.mdi-nintendo-wii::before {\n  content: \"\\F05AB\";\n}\n\n.mdi-nintendo-wiiu::before {\n  content: \"\\F072D\";\n}\n\n.mdi-nix::before {\n  content: \"\\F1105\";\n}\n\n.mdi-nodejs::before {\n  content: \"\\F0399\";\n}\n\n.mdi-noodles::before {\n  content: \"\\F117E\";\n}\n\n.mdi-not-equal::before {\n  content: \"\\F098D\";\n}\n\n.mdi-not-equal-variant::before {\n  content: \"\\F098E\";\n}\n\n.mdi-note::before {\n  content: \"\\F039A\";\n}\n\n.mdi-note-alert::before {\n  content: \"\\F177D\";\n}\n\n.mdi-note-alert-outline::before {\n  content: \"\\F177E\";\n}\n\n.mdi-note-check::before {\n  content: \"\\F177F\";\n}\n\n.mdi-note-check-outline::before {\n  content: \"\\F1780\";\n}\n\n.mdi-note-edit::before {\n  content: \"\\F1781\";\n}\n\n.mdi-note-edit-outline::before {\n  content: \"\\F1782\";\n}\n\n.mdi-note-minus::before {\n  content: \"\\F164F\";\n}\n\n.mdi-note-minus-outline::before {\n  content: \"\\F1650\";\n}\n\n.mdi-note-multiple::before {\n  content: \"\\F06B8\";\n}\n\n.mdi-note-multiple-outline::before {\n  content: \"\\F06B9\";\n}\n\n.mdi-note-off::before {\n  content: \"\\F1783\";\n}\n\n.mdi-note-off-outline::before {\n  content: \"\\F1784\";\n}\n\n.mdi-note-outline::before {\n  content: \"\\F039B\";\n}\n\n.mdi-note-plus::before {\n  content: \"\\F039C\";\n}\n\n.mdi-note-plus-outline::before {\n  content: \"\\F039D\";\n}\n\n.mdi-note-remove::before {\n  content: \"\\F1651\";\n}\n\n.mdi-note-remove-outline::before {\n  content: \"\\F1652\";\n}\n\n.mdi-note-search::before {\n  content: \"\\F1653\";\n}\n\n.mdi-note-search-outline::before {\n  content: \"\\F1654\";\n}\n\n.mdi-note-text::before {\n  content: \"\\F039E\";\n}\n\n.mdi-note-text-outline::before {\n  content: \"\\F11D7\";\n}\n\n.mdi-notebook::before {\n  content: \"\\F082E\";\n}\n\n.mdi-notebook-check::before {\n  content: \"\\F14F5\";\n}\n\n.mdi-notebook-check-outline::before {\n  content: \"\\F14F6\";\n}\n\n.mdi-notebook-edit::before {\n  content: \"\\F14E7\";\n}\n\n.mdi-notebook-edit-outline::before {\n  content: \"\\F14E9\";\n}\n\n.mdi-notebook-minus::before {\n  content: \"\\F1610\";\n}\n\n.mdi-notebook-minus-outline::before {\n  content: \"\\F1611\";\n}\n\n.mdi-notebook-multiple::before {\n  content: \"\\F0E55\";\n}\n\n.mdi-notebook-outline::before {\n  content: \"\\F0EBF\";\n}\n\n.mdi-notebook-plus::before {\n  content: \"\\F1612\";\n}\n\n.mdi-notebook-plus-outline::before {\n  content: \"\\F1613\";\n}\n\n.mdi-notebook-remove::before {\n  content: \"\\F1614\";\n}\n\n.mdi-notebook-remove-outline::before {\n  content: \"\\F1615\";\n}\n\n.mdi-notification-clear-all::before {\n  content: \"\\F039F\";\n}\n\n.mdi-npm::before {\n  content: \"\\F06F7\";\n}\n\n.mdi-nuke::before {\n  content: \"\\F06A4\";\n}\n\n.mdi-null::before {\n  content: \"\\F07E2\";\n}\n\n.mdi-numeric::before {\n  content: \"\\F03A0\";\n}\n\n.mdi-numeric-0::before {\n  content: \"\\F0B39\";\n}\n\n.mdi-numeric-0-box::before {\n  content: \"\\F03A1\";\n}\n\n.mdi-numeric-0-box-multiple::before {\n  content: \"\\F0F0E\";\n}\n\n.mdi-numeric-0-box-multiple-outline::before {\n  content: \"\\F03A2\";\n}\n\n.mdi-numeric-0-box-outline::before {\n  content: \"\\F03A3\";\n}\n\n.mdi-numeric-0-circle::before {\n  content: \"\\F0C9E\";\n}\n\n.mdi-numeric-0-circle-outline::before {\n  content: \"\\F0C9F\";\n}\n\n.mdi-numeric-1::before {\n  content: \"\\F0B3A\";\n}\n\n.mdi-numeric-1-box::before {\n  content: \"\\F03A4\";\n}\n\n.mdi-numeric-1-box-multiple::before {\n  content: \"\\F0F0F\";\n}\n\n.mdi-numeric-1-box-multiple-outline::before {\n  content: \"\\F03A5\";\n}\n\n.mdi-numeric-1-box-outline::before {\n  content: \"\\F03A6\";\n}\n\n.mdi-numeric-1-circle::before {\n  content: \"\\F0CA0\";\n}\n\n.mdi-numeric-1-circle-outline::before {\n  content: \"\\F0CA1\";\n}\n\n.mdi-numeric-10::before {\n  content: \"\\F0FE9\";\n}\n\n.mdi-numeric-10-box::before {\n  content: \"\\F0F7D\";\n}\n\n.mdi-numeric-10-box-multiple::before {\n  content: \"\\F0FEA\";\n}\n\n.mdi-numeric-10-box-multiple-outline::before {\n  content: \"\\F0FEB\";\n}\n\n.mdi-numeric-10-box-outline::before {\n  content: \"\\F0F7E\";\n}\n\n.mdi-numeric-10-circle::before {\n  content: \"\\F0FEC\";\n}\n\n.mdi-numeric-10-circle-outline::before {\n  content: \"\\F0FED\";\n}\n\n.mdi-numeric-2::before {\n  content: \"\\F0B3B\";\n}\n\n.mdi-numeric-2-box::before {\n  content: \"\\F03A7\";\n}\n\n.mdi-numeric-2-box-multiple::before {\n  content: \"\\F0F10\";\n}\n\n.mdi-numeric-2-box-multiple-outline::before {\n  content: \"\\F03A8\";\n}\n\n.mdi-numeric-2-box-outline::before {\n  content: \"\\F03A9\";\n}\n\n.mdi-numeric-2-circle::before {\n  content: \"\\F0CA2\";\n}\n\n.mdi-numeric-2-circle-outline::before {\n  content: \"\\F0CA3\";\n}\n\n.mdi-numeric-3::before {\n  content: \"\\F0B3C\";\n}\n\n.mdi-numeric-3-box::before {\n  content: \"\\F03AA\";\n}\n\n.mdi-numeric-3-box-multiple::before {\n  content: \"\\F0F11\";\n}\n\n.mdi-numeric-3-box-multiple-outline::before {\n  content: \"\\F03AB\";\n}\n\n.mdi-numeric-3-box-outline::before {\n  content: \"\\F03AC\";\n}\n\n.mdi-numeric-3-circle::before {\n  content: \"\\F0CA4\";\n}\n\n.mdi-numeric-3-circle-outline::before {\n  content: \"\\F0CA5\";\n}\n\n.mdi-numeric-4::before {\n  content: \"\\F0B3D\";\n}\n\n.mdi-numeric-4-box::before {\n  content: \"\\F03AD\";\n}\n\n.mdi-numeric-4-box-multiple::before {\n  content: \"\\F0F12\";\n}\n\n.mdi-numeric-4-box-multiple-outline::before {\n  content: \"\\F03B2\";\n}\n\n.mdi-numeric-4-box-outline::before {\n  content: \"\\F03AE\";\n}\n\n.mdi-numeric-4-circle::before {\n  content: \"\\F0CA6\";\n}\n\n.mdi-numeric-4-circle-outline::before {\n  content: \"\\F0CA7\";\n}\n\n.mdi-numeric-5::before {\n  content: \"\\F0B3E\";\n}\n\n.mdi-numeric-5-box::before {\n  content: \"\\F03B1\";\n}\n\n.mdi-numeric-5-box-multiple::before {\n  content: \"\\F0F13\";\n}\n\n.mdi-numeric-5-box-multiple-outline::before {\n  content: \"\\F03AF\";\n}\n\n.mdi-numeric-5-box-outline::before {\n  content: \"\\F03B0\";\n}\n\n.mdi-numeric-5-circle::before {\n  content: \"\\F0CA8\";\n}\n\n.mdi-numeric-5-circle-outline::before {\n  content: \"\\F0CA9\";\n}\n\n.mdi-numeric-6::before {\n  content: \"\\F0B3F\";\n}\n\n.mdi-numeric-6-box::before {\n  content: \"\\F03B3\";\n}\n\n.mdi-numeric-6-box-multiple::before {\n  content: \"\\F0F14\";\n}\n\n.mdi-numeric-6-box-multiple-outline::before {\n  content: \"\\F03B4\";\n}\n\n.mdi-numeric-6-box-outline::before {\n  content: \"\\F03B5\";\n}\n\n.mdi-numeric-6-circle::before {\n  content: \"\\F0CAA\";\n}\n\n.mdi-numeric-6-circle-outline::before {\n  content: \"\\F0CAB\";\n}\n\n.mdi-numeric-7::before {\n  content: \"\\F0B40\";\n}\n\n.mdi-numeric-7-box::before {\n  content: \"\\F03B6\";\n}\n\n.mdi-numeric-7-box-multiple::before {\n  content: \"\\F0F15\";\n}\n\n.mdi-numeric-7-box-multiple-outline::before {\n  content: \"\\F03B7\";\n}\n\n.mdi-numeric-7-box-outline::before {\n  content: \"\\F03B8\";\n}\n\n.mdi-numeric-7-circle::before {\n  content: \"\\F0CAC\";\n}\n\n.mdi-numeric-7-circle-outline::before {\n  content: \"\\F0CAD\";\n}\n\n.mdi-numeric-8::before {\n  content: \"\\F0B41\";\n}\n\n.mdi-numeric-8-box::before {\n  content: \"\\F03B9\";\n}\n\n.mdi-numeric-8-box-multiple::before {\n  content: \"\\F0F16\";\n}\n\n.mdi-numeric-8-box-multiple-outline::before {\n  content: \"\\F03BA\";\n}\n\n.mdi-numeric-8-box-outline::before {\n  content: \"\\F03BB\";\n}\n\n.mdi-numeric-8-circle::before {\n  content: \"\\F0CAE\";\n}\n\n.mdi-numeric-8-circle-outline::before {\n  content: \"\\F0CAF\";\n}\n\n.mdi-numeric-9::before {\n  content: \"\\F0B42\";\n}\n\n.mdi-numeric-9-box::before {\n  content: \"\\F03BC\";\n}\n\n.mdi-numeric-9-box-multiple::before {\n  content: \"\\F0F17\";\n}\n\n.mdi-numeric-9-box-multiple-outline::before {\n  content: \"\\F03BD\";\n}\n\n.mdi-numeric-9-box-outline::before {\n  content: \"\\F03BE\";\n}\n\n.mdi-numeric-9-circle::before {\n  content: \"\\F0CB0\";\n}\n\n.mdi-numeric-9-circle-outline::before {\n  content: \"\\F0CB1\";\n}\n\n.mdi-numeric-9-plus::before {\n  content: \"\\F0FEE\";\n}\n\n.mdi-numeric-9-plus-box::before {\n  content: \"\\F03BF\";\n}\n\n.mdi-numeric-9-plus-box-multiple::before {\n  content: \"\\F0F18\";\n}\n\n.mdi-numeric-9-plus-box-multiple-outline::before {\n  content: \"\\F03C0\";\n}\n\n.mdi-numeric-9-plus-box-outline::before {\n  content: \"\\F03C1\";\n}\n\n.mdi-numeric-9-plus-circle::before {\n  content: \"\\F0CB2\";\n}\n\n.mdi-numeric-9-plus-circle-outline::before {\n  content: \"\\F0CB3\";\n}\n\n.mdi-numeric-negative-1::before {\n  content: \"\\F1052\";\n}\n\n.mdi-numeric-positive-1::before {\n  content: \"\\F15CB\";\n}\n\n.mdi-nut::before {\n  content: \"\\F06F8\";\n}\n\n.mdi-nutrition::before {\n  content: \"\\F03C2\";\n}\n\n.mdi-nuxt::before {\n  content: \"\\F1106\";\n}\n\n.mdi-oar::before {\n  content: \"\\F067C\";\n}\n\n.mdi-ocarina::before {\n  content: \"\\F0DE0\";\n}\n\n.mdi-oci::before {\n  content: \"\\F12E9\";\n}\n\n.mdi-ocr::before {\n  content: \"\\F113A\";\n}\n\n.mdi-octagon::before {\n  content: \"\\F03C3\";\n}\n\n.mdi-octagon-outline::before {\n  content: \"\\F03C4\";\n}\n\n.mdi-octagram::before {\n  content: \"\\F06F9\";\n}\n\n.mdi-octagram-outline::before {\n  content: \"\\F0775\";\n}\n\n.mdi-octahedron::before {\n  content: \"\\F1950\";\n}\n\n.mdi-octahedron-off::before {\n  content: \"\\F1951\";\n}\n\n.mdi-odnoklassniki::before {\n  content: \"\\F03C5\";\n}\n\n.mdi-offer::before {\n  content: \"\\F121B\";\n}\n\n.mdi-office-building::before {\n  content: \"\\F0991\";\n}\n\n.mdi-office-building-cog::before {\n  content: \"\\F1949\";\n}\n\n.mdi-office-building-cog-outline::before {\n  content: \"\\F194A\";\n}\n\n.mdi-office-building-marker::before {\n  content: \"\\F1520\";\n}\n\n.mdi-office-building-marker-outline::before {\n  content: \"\\F1521\";\n}\n\n.mdi-office-building-outline::before {\n  content: \"\\F151F\";\n}\n\n.mdi-oil::before {\n  content: \"\\F03C7\";\n}\n\n.mdi-oil-lamp::before {\n  content: \"\\F0F19\";\n}\n\n.mdi-oil-level::before {\n  content: \"\\F1053\";\n}\n\n.mdi-oil-temperature::before {\n  content: \"\\F0FF8\";\n}\n\n.mdi-om::before {\n  content: \"\\F0973\";\n}\n\n.mdi-omega::before {\n  content: \"\\F03C9\";\n}\n\n.mdi-one-up::before {\n  content: \"\\F0BAD\";\n}\n\n.mdi-onepassword::before {\n  content: \"\\F0881\";\n}\n\n.mdi-opacity::before {\n  content: \"\\F05CC\";\n}\n\n.mdi-open-in-app::before {\n  content: \"\\F03CB\";\n}\n\n.mdi-open-in-new::before {\n  content: \"\\F03CC\";\n}\n\n.mdi-open-source-initiative::before {\n  content: \"\\F0BAE\";\n}\n\n.mdi-openid::before {\n  content: \"\\F03CD\";\n}\n\n.mdi-opera::before {\n  content: \"\\F03CE\";\n}\n\n.mdi-orbit::before {\n  content: \"\\F0018\";\n}\n\n.mdi-orbit-variant::before {\n  content: \"\\F15DB\";\n}\n\n.mdi-order-alphabetical-ascending::before {\n  content: \"\\F020D\";\n}\n\n.mdi-order-alphabetical-descending::before {\n  content: \"\\F0D07\";\n}\n\n.mdi-order-bool-ascending::before {\n  content: \"\\F02BE\";\n}\n\n.mdi-order-bool-ascending-variant::before {\n  content: \"\\F098F\";\n}\n\n.mdi-order-bool-descending::before {\n  content: \"\\F1384\";\n}\n\n.mdi-order-bool-descending-variant::before {\n  content: \"\\F0990\";\n}\n\n.mdi-order-numeric-ascending::before {\n  content: \"\\F0545\";\n}\n\n.mdi-order-numeric-descending::before {\n  content: \"\\F0546\";\n}\n\n.mdi-origin::before {\n  content: \"\\F0B43\";\n}\n\n.mdi-ornament::before {\n  content: \"\\F03CF\";\n}\n\n.mdi-ornament-variant::before {\n  content: \"\\F03D0\";\n}\n\n.mdi-outdoor-lamp::before {\n  content: \"\\F1054\";\n}\n\n.mdi-overscan::before {\n  content: \"\\F1005\";\n}\n\n.mdi-owl::before {\n  content: \"\\F03D2\";\n}\n\n.mdi-pac-man::before {\n  content: \"\\F0BAF\";\n}\n\n.mdi-package::before {\n  content: \"\\F03D3\";\n}\n\n.mdi-package-down::before {\n  content: \"\\F03D4\";\n}\n\n.mdi-package-up::before {\n  content: \"\\F03D5\";\n}\n\n.mdi-package-variant::before {\n  content: \"\\F03D6\";\n}\n\n.mdi-package-variant-closed::before {\n  content: \"\\F03D7\";\n}\n\n.mdi-page-first::before {\n  content: \"\\F0600\";\n}\n\n.mdi-page-last::before {\n  content: \"\\F0601\";\n}\n\n.mdi-page-layout-body::before {\n  content: \"\\F06FA\";\n}\n\n.mdi-page-layout-footer::before {\n  content: \"\\F06FB\";\n}\n\n.mdi-page-layout-header::before {\n  content: \"\\F06FC\";\n}\n\n.mdi-page-layout-header-footer::before {\n  content: \"\\F0F7F\";\n}\n\n.mdi-page-layout-sidebar-left::before {\n  content: \"\\F06FD\";\n}\n\n.mdi-page-layout-sidebar-right::before {\n  content: \"\\F06FE\";\n}\n\n.mdi-page-next::before {\n  content: \"\\F0BB0\";\n}\n\n.mdi-page-next-outline::before {\n  content: \"\\F0BB1\";\n}\n\n.mdi-page-previous::before {\n  content: \"\\F0BB2\";\n}\n\n.mdi-page-previous-outline::before {\n  content: \"\\F0BB3\";\n}\n\n.mdi-pail::before {\n  content: \"\\F1417\";\n}\n\n.mdi-pail-minus::before {\n  content: \"\\F1437\";\n}\n\n.mdi-pail-minus-outline::before {\n  content: \"\\F143C\";\n}\n\n.mdi-pail-off::before {\n  content: \"\\F1439\";\n}\n\n.mdi-pail-off-outline::before {\n  content: \"\\F143E\";\n}\n\n.mdi-pail-outline::before {\n  content: \"\\F143A\";\n}\n\n.mdi-pail-plus::before {\n  content: \"\\F1436\";\n}\n\n.mdi-pail-plus-outline::before {\n  content: \"\\F143B\";\n}\n\n.mdi-pail-remove::before {\n  content: \"\\F1438\";\n}\n\n.mdi-pail-remove-outline::before {\n  content: \"\\F143D\";\n}\n\n.mdi-palette::before {\n  content: \"\\F03D8\";\n}\n\n.mdi-palette-advanced::before {\n  content: \"\\F03D9\";\n}\n\n.mdi-palette-outline::before {\n  content: \"\\F0E0C\";\n}\n\n.mdi-palette-swatch::before {\n  content: \"\\F08B5\";\n}\n\n.mdi-palette-swatch-outline::before {\n  content: \"\\F135C\";\n}\n\n.mdi-palette-swatch-variant::before {\n  content: \"\\F195A\";\n}\n\n.mdi-palm-tree::before {\n  content: \"\\F1055\";\n}\n\n.mdi-pan::before {\n  content: \"\\F0BB4\";\n}\n\n.mdi-pan-bottom-left::before {\n  content: \"\\F0BB5\";\n}\n\n.mdi-pan-bottom-right::before {\n  content: \"\\F0BB6\";\n}\n\n.mdi-pan-down::before {\n  content: \"\\F0BB7\";\n}\n\n.mdi-pan-horizontal::before {\n  content: \"\\F0BB8\";\n}\n\n.mdi-pan-left::before {\n  content: \"\\F0BB9\";\n}\n\n.mdi-pan-right::before {\n  content: \"\\F0BBA\";\n}\n\n.mdi-pan-top-left::before {\n  content: \"\\F0BBB\";\n}\n\n.mdi-pan-top-right::before {\n  content: \"\\F0BBC\";\n}\n\n.mdi-pan-up::before {\n  content: \"\\F0BBD\";\n}\n\n.mdi-pan-vertical::before {\n  content: \"\\F0BBE\";\n}\n\n.mdi-panda::before {\n  content: \"\\F03DA\";\n}\n\n.mdi-pandora::before {\n  content: \"\\F03DB\";\n}\n\n.mdi-panorama::before {\n  content: \"\\F03DC\";\n}\n\n.mdi-panorama-fisheye::before {\n  content: \"\\F03DD\";\n}\n\n.mdi-panorama-horizontal::before {\n  content: \"\\F1928\";\n}\n\n.mdi-panorama-horizontal-outline::before {\n  content: \"\\F03DE\";\n}\n\n.mdi-panorama-outline::before {\n  content: \"\\F198C\";\n}\n\n.mdi-panorama-sphere::before {\n  content: \"\\F198D\";\n}\n\n.mdi-panorama-sphere-outline::before {\n  content: \"\\F198E\";\n}\n\n.mdi-panorama-variant::before {\n  content: \"\\F198F\";\n}\n\n.mdi-panorama-variant-outline::before {\n  content: \"\\F1990\";\n}\n\n.mdi-panorama-vertical::before {\n  content: \"\\F1929\";\n}\n\n.mdi-panorama-vertical-outline::before {\n  content: \"\\F03DF\";\n}\n\n.mdi-panorama-wide-angle::before {\n  content: \"\\F195F\";\n}\n\n.mdi-panorama-wide-angle-outline::before {\n  content: \"\\F03E0\";\n}\n\n.mdi-paper-cut-vertical::before {\n  content: \"\\F03E1\";\n}\n\n.mdi-paper-roll::before {\n  content: \"\\F1157\";\n}\n\n.mdi-paper-roll-outline::before {\n  content: \"\\F1158\";\n}\n\n.mdi-paperclip::before {\n  content: \"\\F03E2\";\n}\n\n.mdi-parachute::before {\n  content: \"\\F0CB4\";\n}\n\n.mdi-parachute-outline::before {\n  content: \"\\F0CB5\";\n}\n\n.mdi-paragliding::before {\n  content: \"\\F1745\";\n}\n\n.mdi-parking::before {\n  content: \"\\F03E3\";\n}\n\n.mdi-party-popper::before {\n  content: \"\\F1056\";\n}\n\n.mdi-passport::before {\n  content: \"\\F07E3\";\n}\n\n.mdi-passport-biometric::before {\n  content: \"\\F0DE1\";\n}\n\n.mdi-pasta::before {\n  content: \"\\F1160\";\n}\n\n.mdi-patio-heater::before {\n  content: \"\\F0F80\";\n}\n\n.mdi-patreon::before {\n  content: \"\\F0882\";\n}\n\n.mdi-pause::before {\n  content: \"\\F03E4\";\n}\n\n.mdi-pause-circle::before {\n  content: \"\\F03E5\";\n}\n\n.mdi-pause-circle-outline::before {\n  content: \"\\F03E6\";\n}\n\n.mdi-pause-octagon::before {\n  content: \"\\F03E7\";\n}\n\n.mdi-pause-octagon-outline::before {\n  content: \"\\F03E8\";\n}\n\n.mdi-paw::before {\n  content: \"\\F03E9\";\n}\n\n.mdi-paw-off::before {\n  content: \"\\F0657\";\n}\n\n.mdi-paw-off-outline::before {\n  content: \"\\F1676\";\n}\n\n.mdi-paw-outline::before {\n  content: \"\\F1675\";\n}\n\n.mdi-peace::before {\n  content: \"\\F0884\";\n}\n\n.mdi-peanut::before {\n  content: \"\\F0FFC\";\n}\n\n.mdi-peanut-off::before {\n  content: \"\\F0FFD\";\n}\n\n.mdi-peanut-off-outline::before {\n  content: \"\\F0FFF\";\n}\n\n.mdi-peanut-outline::before {\n  content: \"\\F0FFE\";\n}\n\n.mdi-pen::before {\n  content: \"\\F03EA\";\n}\n\n.mdi-pen-lock::before {\n  content: \"\\F0DE2\";\n}\n\n.mdi-pen-minus::before {\n  content: \"\\F0DE3\";\n}\n\n.mdi-pen-off::before {\n  content: \"\\F0DE4\";\n}\n\n.mdi-pen-plus::before {\n  content: \"\\F0DE5\";\n}\n\n.mdi-pen-remove::before {\n  content: \"\\F0DE6\";\n}\n\n.mdi-pencil::before {\n  content: \"\\F03EB\";\n}\n\n.mdi-pencil-box::before {\n  content: \"\\F03EC\";\n}\n\n.mdi-pencil-box-multiple::before {\n  content: \"\\F1144\";\n}\n\n.mdi-pencil-box-multiple-outline::before {\n  content: \"\\F1145\";\n}\n\n.mdi-pencil-box-outline::before {\n  content: \"\\F03ED\";\n}\n\n.mdi-pencil-circle::before {\n  content: \"\\F06FF\";\n}\n\n.mdi-pencil-circle-outline::before {\n  content: \"\\F0776\";\n}\n\n.mdi-pencil-lock::before {\n  content: \"\\F03EE\";\n}\n\n.mdi-pencil-lock-outline::before {\n  content: \"\\F0DE7\";\n}\n\n.mdi-pencil-minus::before {\n  content: \"\\F0DE8\";\n}\n\n.mdi-pencil-minus-outline::before {\n  content: \"\\F0DE9\";\n}\n\n.mdi-pencil-off::before {\n  content: \"\\F03EF\";\n}\n\n.mdi-pencil-off-outline::before {\n  content: \"\\F0DEA\";\n}\n\n.mdi-pencil-outline::before {\n  content: \"\\F0CB6\";\n}\n\n.mdi-pencil-plus::before {\n  content: \"\\F0DEB\";\n}\n\n.mdi-pencil-plus-outline::before {\n  content: \"\\F0DEC\";\n}\n\n.mdi-pencil-remove::before {\n  content: \"\\F0DED\";\n}\n\n.mdi-pencil-remove-outline::before {\n  content: \"\\F0DEE\";\n}\n\n.mdi-pencil-ruler::before {\n  content: \"\\F1353\";\n}\n\n.mdi-penguin::before {\n  content: \"\\F0EC0\";\n}\n\n.mdi-pentagon::before {\n  content: \"\\F0701\";\n}\n\n.mdi-pentagon-outline::before {\n  content: \"\\F0700\";\n}\n\n.mdi-pentagram::before {\n  content: \"\\F1667\";\n}\n\n.mdi-percent::before {\n  content: \"\\F03F0\";\n}\n\n.mdi-percent-outline::before {\n  content: \"\\F1278\";\n}\n\n.mdi-periodic-table::before {\n  content: \"\\F08B6\";\n}\n\n.mdi-perspective-less::before {\n  content: \"\\F0D23\";\n}\n\n.mdi-perspective-more::before {\n  content: \"\\F0D24\";\n}\n\n.mdi-ph::before {\n  content: \"\\F17C5\";\n}\n\n.mdi-phone::before {\n  content: \"\\F03F2\";\n}\n\n.mdi-phone-alert::before {\n  content: \"\\F0F1A\";\n}\n\n.mdi-phone-alert-outline::before {\n  content: \"\\F118E\";\n}\n\n.mdi-phone-bluetooth::before {\n  content: \"\\F03F3\";\n}\n\n.mdi-phone-bluetooth-outline::before {\n  content: \"\\F118F\";\n}\n\n.mdi-phone-cancel::before {\n  content: \"\\F10BC\";\n}\n\n.mdi-phone-cancel-outline::before {\n  content: \"\\F1190\";\n}\n\n.mdi-phone-check::before {\n  content: \"\\F11A9\";\n}\n\n.mdi-phone-check-outline::before {\n  content: \"\\F11AA\";\n}\n\n.mdi-phone-classic::before {\n  content: \"\\F0602\";\n}\n\n.mdi-phone-classic-off::before {\n  content: \"\\F1279\";\n}\n\n.mdi-phone-dial::before {\n  content: \"\\F1559\";\n}\n\n.mdi-phone-dial-outline::before {\n  content: \"\\F155A\";\n}\n\n.mdi-phone-forward::before {\n  content: \"\\F03F4\";\n}\n\n.mdi-phone-forward-outline::before {\n  content: \"\\F1191\";\n}\n\n.mdi-phone-hangup::before {\n  content: \"\\F03F5\";\n}\n\n.mdi-phone-hangup-outline::before {\n  content: \"\\F1192\";\n}\n\n.mdi-phone-in-talk::before {\n  content: \"\\F03F6\";\n}\n\n.mdi-phone-in-talk-outline::before {\n  content: \"\\F1182\";\n}\n\n.mdi-phone-incoming::before {\n  content: \"\\F03F7\";\n}\n\n.mdi-phone-incoming-outline::before {\n  content: \"\\F1193\";\n}\n\n.mdi-phone-lock::before {\n  content: \"\\F03F8\";\n}\n\n.mdi-phone-lock-outline::before {\n  content: \"\\F1194\";\n}\n\n.mdi-phone-log::before {\n  content: \"\\F03F9\";\n}\n\n.mdi-phone-log-outline::before {\n  content: \"\\F1195\";\n}\n\n.mdi-phone-message::before {\n  content: \"\\F1196\";\n}\n\n.mdi-phone-message-outline::before {\n  content: \"\\F1197\";\n}\n\n.mdi-phone-minus::before {\n  content: \"\\F0658\";\n}\n\n.mdi-phone-minus-outline::before {\n  content: \"\\F1198\";\n}\n\n.mdi-phone-missed::before {\n  content: \"\\F03FA\";\n}\n\n.mdi-phone-missed-outline::before {\n  content: \"\\F11A5\";\n}\n\n.mdi-phone-off::before {\n  content: \"\\F0DEF\";\n}\n\n.mdi-phone-off-outline::before {\n  content: \"\\F11A6\";\n}\n\n.mdi-phone-outgoing::before {\n  content: \"\\F03FB\";\n}\n\n.mdi-phone-outgoing-outline::before {\n  content: \"\\F1199\";\n}\n\n.mdi-phone-outline::before {\n  content: \"\\F0DF0\";\n}\n\n.mdi-phone-paused::before {\n  content: \"\\F03FC\";\n}\n\n.mdi-phone-paused-outline::before {\n  content: \"\\F119A\";\n}\n\n.mdi-phone-plus::before {\n  content: \"\\F0659\";\n}\n\n.mdi-phone-plus-outline::before {\n  content: \"\\F119B\";\n}\n\n.mdi-phone-refresh::before {\n  content: \"\\F1993\";\n}\n\n.mdi-phone-refresh-outline::before {\n  content: \"\\F1994\";\n}\n\n.mdi-phone-remove::before {\n  content: \"\\F152F\";\n}\n\n.mdi-phone-remove-outline::before {\n  content: \"\\F1530\";\n}\n\n.mdi-phone-return::before {\n  content: \"\\F082F\";\n}\n\n.mdi-phone-return-outline::before {\n  content: \"\\F119C\";\n}\n\n.mdi-phone-ring::before {\n  content: \"\\F11AB\";\n}\n\n.mdi-phone-ring-outline::before {\n  content: \"\\F11AC\";\n}\n\n.mdi-phone-rotate-landscape::before {\n  content: \"\\F0885\";\n}\n\n.mdi-phone-rotate-portrait::before {\n  content: \"\\F0886\";\n}\n\n.mdi-phone-settings::before {\n  content: \"\\F03FD\";\n}\n\n.mdi-phone-settings-outline::before {\n  content: \"\\F119D\";\n}\n\n.mdi-phone-sync::before {\n  content: \"\\F1995\";\n}\n\n.mdi-phone-sync-outline::before {\n  content: \"\\F1996\";\n}\n\n.mdi-phone-voip::before {\n  content: \"\\F03FE\";\n}\n\n.mdi-pi::before {\n  content: \"\\F03FF\";\n}\n\n.mdi-pi-box::before {\n  content: \"\\F0400\";\n}\n\n.mdi-pi-hole::before {\n  content: \"\\F0DF1\";\n}\n\n.mdi-piano::before {\n  content: \"\\F067D\";\n}\n\n.mdi-piano-off::before {\n  content: \"\\F0698\";\n}\n\n.mdi-pickaxe::before {\n  content: \"\\F08B7\";\n}\n\n.mdi-picture-in-picture-bottom-right::before {\n  content: \"\\F0E57\";\n}\n\n.mdi-picture-in-picture-bottom-right-outline::before {\n  content: \"\\F0E58\";\n}\n\n.mdi-picture-in-picture-top-right::before {\n  content: \"\\F0E59\";\n}\n\n.mdi-picture-in-picture-top-right-outline::before {\n  content: \"\\F0E5A\";\n}\n\n.mdi-pier::before {\n  content: \"\\F0887\";\n}\n\n.mdi-pier-crane::before {\n  content: \"\\F0888\";\n}\n\n.mdi-pig::before {\n  content: \"\\F0401\";\n}\n\n.mdi-pig-variant::before {\n  content: \"\\F1006\";\n}\n\n.mdi-pig-variant-outline::before {\n  content: \"\\F1678\";\n}\n\n.mdi-piggy-bank::before {\n  content: \"\\F1007\";\n}\n\n.mdi-piggy-bank-outline::before {\n  content: \"\\F1679\";\n}\n\n.mdi-pill::before {\n  content: \"\\F0402\";\n}\n\n.mdi-pillar::before {\n  content: \"\\F0702\";\n}\n\n.mdi-pin::before {\n  content: \"\\F0403\";\n}\n\n.mdi-pin-off::before {\n  content: \"\\F0404\";\n}\n\n.mdi-pin-off-outline::before {\n  content: \"\\F0930\";\n}\n\n.mdi-pin-outline::before {\n  content: \"\\F0931\";\n}\n\n.mdi-pine-tree::before {\n  content: \"\\F0405\";\n}\n\n.mdi-pine-tree-box::before {\n  content: \"\\F0406\";\n}\n\n.mdi-pine-tree-fire::before {\n  content: \"\\F141A\";\n}\n\n.mdi-pinterest::before {\n  content: \"\\F0407\";\n}\n\n.mdi-pinwheel::before {\n  content: \"\\F0AD5\";\n}\n\n.mdi-pinwheel-outline::before {\n  content: \"\\F0AD6\";\n}\n\n.mdi-pipe::before {\n  content: \"\\F07E5\";\n}\n\n.mdi-pipe-disconnected::before {\n  content: \"\\F07E6\";\n}\n\n.mdi-pipe-leak::before {\n  content: \"\\F0889\";\n}\n\n.mdi-pipe-valve::before {\n  content: \"\\F184D\";\n}\n\n.mdi-pipe-wrench::before {\n  content: \"\\F1354\";\n}\n\n.mdi-pirate::before {\n  content: \"\\F0A08\";\n}\n\n.mdi-pistol::before {\n  content: \"\\F0703\";\n}\n\n.mdi-piston::before {\n  content: \"\\F088A\";\n}\n\n.mdi-pitchfork::before {\n  content: \"\\F1553\";\n}\n\n.mdi-pizza::before {\n  content: \"\\F0409\";\n}\n\n.mdi-play::before {\n  content: \"\\F040A\";\n}\n\n.mdi-play-box::before {\n  content: \"\\F127A\";\n}\n\n.mdi-play-box-multiple::before {\n  content: \"\\F0D19\";\n}\n\n.mdi-play-box-multiple-outline::before {\n  content: \"\\F13E6\";\n}\n\n.mdi-play-box-outline::before {\n  content: \"\\F040B\";\n}\n\n.mdi-play-circle::before {\n  content: \"\\F040C\";\n}\n\n.mdi-play-circle-outline::before {\n  content: \"\\F040D\";\n}\n\n.mdi-play-network::before {\n  content: \"\\F088B\";\n}\n\n.mdi-play-network-outline::before {\n  content: \"\\F0CB7\";\n}\n\n.mdi-play-outline::before {\n  content: \"\\F0F1B\";\n}\n\n.mdi-play-pause::before {\n  content: \"\\F040E\";\n}\n\n.mdi-play-protected-content::before {\n  content: \"\\F040F\";\n}\n\n.mdi-play-speed::before {\n  content: \"\\F08FF\";\n}\n\n.mdi-playlist-check::before {\n  content: \"\\F05C7\";\n}\n\n.mdi-playlist-edit::before {\n  content: \"\\F0900\";\n}\n\n.mdi-playlist-minus::before {\n  content: \"\\F0410\";\n}\n\n.mdi-playlist-music::before {\n  content: \"\\F0CB8\";\n}\n\n.mdi-playlist-music-outline::before {\n  content: \"\\F0CB9\";\n}\n\n.mdi-playlist-play::before {\n  content: \"\\F0411\";\n}\n\n.mdi-playlist-plus::before {\n  content: \"\\F0412\";\n}\n\n.mdi-playlist-remove::before {\n  content: \"\\F0413\";\n}\n\n.mdi-playlist-star::before {\n  content: \"\\F0DF2\";\n}\n\n.mdi-plex::before {\n  content: \"\\F06BA\";\n}\n\n.mdi-pliers::before {\n  content: \"\\F19A4\";\n}\n\n.mdi-plus::before {\n  content: \"\\F0415\";\n}\n\n.mdi-plus-box::before {\n  content: \"\\F0416\";\n}\n\n.mdi-plus-box-multiple::before {\n  content: \"\\F0334\";\n}\n\n.mdi-plus-box-multiple-outline::before {\n  content: \"\\F1143\";\n}\n\n.mdi-plus-box-outline::before {\n  content: \"\\F0704\";\n}\n\n.mdi-plus-circle::before {\n  content: \"\\F0417\";\n}\n\n.mdi-plus-circle-multiple::before {\n  content: \"\\F034C\";\n}\n\n.mdi-plus-circle-multiple-outline::before {\n  content: \"\\F0418\";\n}\n\n.mdi-plus-circle-outline::before {\n  content: \"\\F0419\";\n}\n\n.mdi-plus-minus::before {\n  content: \"\\F0992\";\n}\n\n.mdi-plus-minus-box::before {\n  content: \"\\F0993\";\n}\n\n.mdi-plus-minus-variant::before {\n  content: \"\\F14C9\";\n}\n\n.mdi-plus-network::before {\n  content: \"\\F041A\";\n}\n\n.mdi-plus-network-outline::before {\n  content: \"\\F0CBA\";\n}\n\n.mdi-plus-outline::before {\n  content: \"\\F0705\";\n}\n\n.mdi-plus-thick::before {\n  content: \"\\F11EC\";\n}\n\n.mdi-podcast::before {\n  content: \"\\F0994\";\n}\n\n.mdi-podium::before {\n  content: \"\\F0D25\";\n}\n\n.mdi-podium-bronze::before {\n  content: \"\\F0D26\";\n}\n\n.mdi-podium-gold::before {\n  content: \"\\F0D27\";\n}\n\n.mdi-podium-silver::before {\n  content: \"\\F0D28\";\n}\n\n.mdi-point-of-sale::before {\n  content: \"\\F0D92\";\n}\n\n.mdi-pokeball::before {\n  content: \"\\F041D\";\n}\n\n.mdi-pokemon-go::before {\n  content: \"\\F0A09\";\n}\n\n.mdi-poker-chip::before {\n  content: \"\\F0830\";\n}\n\n.mdi-polaroid::before {\n  content: \"\\F041E\";\n}\n\n.mdi-police-badge::before {\n  content: \"\\F1167\";\n}\n\n.mdi-police-badge-outline::before {\n  content: \"\\F1168\";\n}\n\n.mdi-police-station::before {\n  content: \"\\F1839\";\n}\n\n.mdi-poll::before {\n  content: \"\\F041F\";\n}\n\n.mdi-polo::before {\n  content: \"\\F14C3\";\n}\n\n.mdi-polymer::before {\n  content: \"\\F0421\";\n}\n\n.mdi-pool::before {\n  content: \"\\F0606\";\n}\n\n.mdi-popcorn::before {\n  content: \"\\F0422\";\n}\n\n.mdi-post::before {\n  content: \"\\F1008\";\n}\n\n.mdi-post-outline::before {\n  content: \"\\F1009\";\n}\n\n.mdi-postage-stamp::before {\n  content: \"\\F0CBB\";\n}\n\n.mdi-pot::before {\n  content: \"\\F02E5\";\n}\n\n.mdi-pot-mix::before {\n  content: \"\\F065B\";\n}\n\n.mdi-pot-mix-outline::before {\n  content: \"\\F0677\";\n}\n\n.mdi-pot-outline::before {\n  content: \"\\F02FF\";\n}\n\n.mdi-pot-steam::before {\n  content: \"\\F065A\";\n}\n\n.mdi-pot-steam-outline::before {\n  content: \"\\F0326\";\n}\n\n.mdi-pound::before {\n  content: \"\\F0423\";\n}\n\n.mdi-pound-box::before {\n  content: \"\\F0424\";\n}\n\n.mdi-pound-box-outline::before {\n  content: \"\\F117F\";\n}\n\n.mdi-power::before {\n  content: \"\\F0425\";\n}\n\n.mdi-power-cycle::before {\n  content: \"\\F0901\";\n}\n\n.mdi-power-off::before {\n  content: \"\\F0902\";\n}\n\n.mdi-power-on::before {\n  content: \"\\F0903\";\n}\n\n.mdi-power-plug::before {\n  content: \"\\F06A5\";\n}\n\n.mdi-power-plug-off::before {\n  content: \"\\F06A6\";\n}\n\n.mdi-power-plug-off-outline::before {\n  content: \"\\F1424\";\n}\n\n.mdi-power-plug-outline::before {\n  content: \"\\F1425\";\n}\n\n.mdi-power-settings::before {\n  content: \"\\F0426\";\n}\n\n.mdi-power-sleep::before {\n  content: \"\\F0904\";\n}\n\n.mdi-power-socket::before {\n  content: \"\\F0427\";\n}\n\n.mdi-power-socket-au::before {\n  content: \"\\F0905\";\n}\n\n.mdi-power-socket-ch::before {\n  content: \"\\F0FB3\";\n}\n\n.mdi-power-socket-de::before {\n  content: \"\\F1107\";\n}\n\n.mdi-power-socket-eu::before {\n  content: \"\\F07E7\";\n}\n\n.mdi-power-socket-fr::before {\n  content: \"\\F1108\";\n}\n\n.mdi-power-socket-it::before {\n  content: \"\\F14FF\";\n}\n\n.mdi-power-socket-jp::before {\n  content: \"\\F1109\";\n}\n\n.mdi-power-socket-uk::before {\n  content: \"\\F07E8\";\n}\n\n.mdi-power-socket-us::before {\n  content: \"\\F07E9\";\n}\n\n.mdi-power-standby::before {\n  content: \"\\F0906\";\n}\n\n.mdi-powershell::before {\n  content: \"\\F0A0A\";\n}\n\n.mdi-prescription::before {\n  content: \"\\F0706\";\n}\n\n.mdi-presentation::before {\n  content: \"\\F0428\";\n}\n\n.mdi-presentation-play::before {\n  content: \"\\F0429\";\n}\n\n.mdi-pretzel::before {\n  content: \"\\F1562\";\n}\n\n.mdi-printer::before {\n  content: \"\\F042A\";\n}\n\n.mdi-printer-3d::before {\n  content: \"\\F042B\";\n}\n\n.mdi-printer-3d-nozzle::before {\n  content: \"\\F0E5B\";\n}\n\n.mdi-printer-3d-nozzle-alert::before {\n  content: \"\\F11C0\";\n}\n\n.mdi-printer-3d-nozzle-alert-outline::before {\n  content: \"\\F11C1\";\n}\n\n.mdi-printer-3d-nozzle-heat::before {\n  content: \"\\F18B8\";\n}\n\n.mdi-printer-3d-nozzle-heat-outline::before {\n  content: \"\\F18B9\";\n}\n\n.mdi-printer-3d-nozzle-outline::before {\n  content: \"\\F0E5C\";\n}\n\n.mdi-printer-alert::before {\n  content: \"\\F042C\";\n}\n\n.mdi-printer-check::before {\n  content: \"\\F1146\";\n}\n\n.mdi-printer-eye::before {\n  content: \"\\F1458\";\n}\n\n.mdi-printer-off::before {\n  content: \"\\F0E5D\";\n}\n\n.mdi-printer-off-outline::before {\n  content: \"\\F1785\";\n}\n\n.mdi-printer-outline::before {\n  content: \"\\F1786\";\n}\n\n.mdi-printer-pos::before {\n  content: \"\\F1057\";\n}\n\n.mdi-printer-search::before {\n  content: \"\\F1457\";\n}\n\n.mdi-printer-settings::before {\n  content: \"\\F0707\";\n}\n\n.mdi-printer-wireless::before {\n  content: \"\\F0A0B\";\n}\n\n.mdi-priority-high::before {\n  content: \"\\F0603\";\n}\n\n.mdi-priority-low::before {\n  content: \"\\F0604\";\n}\n\n.mdi-professional-hexagon::before {\n  content: \"\\F042D\";\n}\n\n.mdi-progress-alert::before {\n  content: \"\\F0CBC\";\n}\n\n.mdi-progress-check::before {\n  content: \"\\F0995\";\n}\n\n.mdi-progress-clock::before {\n  content: \"\\F0996\";\n}\n\n.mdi-progress-close::before {\n  content: \"\\F110A\";\n}\n\n.mdi-progress-download::before {\n  content: \"\\F0997\";\n}\n\n.mdi-progress-pencil::before {\n  content: \"\\F1787\";\n}\n\n.mdi-progress-question::before {\n  content: \"\\F1522\";\n}\n\n.mdi-progress-star::before {\n  content: \"\\F1788\";\n}\n\n.mdi-progress-upload::before {\n  content: \"\\F0998\";\n}\n\n.mdi-progress-wrench::before {\n  content: \"\\F0CBD\";\n}\n\n.mdi-projector::before {\n  content: \"\\F042E\";\n}\n\n.mdi-projector-screen::before {\n  content: \"\\F042F\";\n}\n\n.mdi-projector-screen-off::before {\n  content: \"\\F180D\";\n}\n\n.mdi-projector-screen-off-outline::before {\n  content: \"\\F180E\";\n}\n\n.mdi-projector-screen-outline::before {\n  content: \"\\F1724\";\n}\n\n.mdi-projector-screen-variant::before {\n  content: \"\\F180F\";\n}\n\n.mdi-projector-screen-variant-off::before {\n  content: \"\\F1810\";\n}\n\n.mdi-projector-screen-variant-off-outline::before {\n  content: \"\\F1811\";\n}\n\n.mdi-projector-screen-variant-outline::before {\n  content: \"\\F1812\";\n}\n\n.mdi-propane-tank::before {\n  content: \"\\F1357\";\n}\n\n.mdi-propane-tank-outline::before {\n  content: \"\\F1358\";\n}\n\n.mdi-protocol::before {\n  content: \"\\F0FD8\";\n}\n\n.mdi-publish::before {\n  content: \"\\F06A7\";\n}\n\n.mdi-publish-off::before {\n  content: \"\\F1945\";\n}\n\n.mdi-pulse::before {\n  content: \"\\F0430\";\n}\n\n.mdi-pump::before {\n  content: \"\\F1402\";\n}\n\n.mdi-pumpkin::before {\n  content: \"\\F0BBF\";\n}\n\n.mdi-purse::before {\n  content: \"\\F0F1C\";\n}\n\n.mdi-purse-outline::before {\n  content: \"\\F0F1D\";\n}\n\n.mdi-puzzle::before {\n  content: \"\\F0431\";\n}\n\n.mdi-puzzle-check::before {\n  content: \"\\F1426\";\n}\n\n.mdi-puzzle-check-outline::before {\n  content: \"\\F1427\";\n}\n\n.mdi-puzzle-edit::before {\n  content: \"\\F14D3\";\n}\n\n.mdi-puzzle-edit-outline::before {\n  content: \"\\F14D9\";\n}\n\n.mdi-puzzle-heart::before {\n  content: \"\\F14D4\";\n}\n\n.mdi-puzzle-heart-outline::before {\n  content: \"\\F14DA\";\n}\n\n.mdi-puzzle-minus::before {\n  content: \"\\F14D1\";\n}\n\n.mdi-puzzle-minus-outline::before {\n  content: \"\\F14D7\";\n}\n\n.mdi-puzzle-outline::before {\n  content: \"\\F0A66\";\n}\n\n.mdi-puzzle-plus::before {\n  content: \"\\F14D0\";\n}\n\n.mdi-puzzle-plus-outline::before {\n  content: \"\\F14D6\";\n}\n\n.mdi-puzzle-remove::before {\n  content: \"\\F14D2\";\n}\n\n.mdi-puzzle-remove-outline::before {\n  content: \"\\F14D8\";\n}\n\n.mdi-puzzle-star::before {\n  content: \"\\F14D5\";\n}\n\n.mdi-puzzle-star-outline::before {\n  content: \"\\F14DB\";\n}\n\n.mdi-pyramid::before {\n  content: \"\\F1952\";\n}\n\n.mdi-pyramid-off::before {\n  content: \"\\F1953\";\n}\n\n.mdi-qi::before {\n  content: \"\\F0999\";\n}\n\n.mdi-qqchat::before {\n  content: \"\\F0605\";\n}\n\n.mdi-qrcode::before {\n  content: \"\\F0432\";\n}\n\n.mdi-qrcode-edit::before {\n  content: \"\\F08B8\";\n}\n\n.mdi-qrcode-minus::before {\n  content: \"\\F118C\";\n}\n\n.mdi-qrcode-plus::before {\n  content: \"\\F118B\";\n}\n\n.mdi-qrcode-remove::before {\n  content: \"\\F118D\";\n}\n\n.mdi-qrcode-scan::before {\n  content: \"\\F0433\";\n}\n\n.mdi-quadcopter::before {\n  content: \"\\F0434\";\n}\n\n.mdi-quality-high::before {\n  content: \"\\F0435\";\n}\n\n.mdi-quality-low::before {\n  content: \"\\F0A0C\";\n}\n\n.mdi-quality-medium::before {\n  content: \"\\F0A0D\";\n}\n\n.mdi-quora::before {\n  content: \"\\F0D29\";\n}\n\n.mdi-rabbit::before {\n  content: \"\\F0907\";\n}\n\n.mdi-racing-helmet::before {\n  content: \"\\F0D93\";\n}\n\n.mdi-racquetball::before {\n  content: \"\\F0D94\";\n}\n\n.mdi-radar::before {\n  content: \"\\F0437\";\n}\n\n.mdi-radiator::before {\n  content: \"\\F0438\";\n}\n\n.mdi-radiator-disabled::before {\n  content: \"\\F0AD7\";\n}\n\n.mdi-radiator-off::before {\n  content: \"\\F0AD8\";\n}\n\n.mdi-radio::before {\n  content: \"\\F0439\";\n}\n\n.mdi-radio-am::before {\n  content: \"\\F0CBE\";\n}\n\n.mdi-radio-fm::before {\n  content: \"\\F0CBF\";\n}\n\n.mdi-radio-handheld::before {\n  content: \"\\F043A\";\n}\n\n.mdi-radio-off::before {\n  content: \"\\F121C\";\n}\n\n.mdi-radio-tower::before {\n  content: \"\\F043B\";\n}\n\n.mdi-radioactive::before {\n  content: \"\\F043C\";\n}\n\n.mdi-radioactive-circle::before {\n  content: \"\\F185D\";\n}\n\n.mdi-radioactive-circle-outline::before {\n  content: \"\\F185E\";\n}\n\n.mdi-radioactive-off::before {\n  content: \"\\F0EC1\";\n}\n\n.mdi-radiobox-blank::before {\n  content: \"\\F043D\";\n}\n\n.mdi-radiobox-marked::before {\n  content: \"\\F043E\";\n}\n\n.mdi-radiology-box::before {\n  content: \"\\F14C5\";\n}\n\n.mdi-radiology-box-outline::before {\n  content: \"\\F14C6\";\n}\n\n.mdi-radius::before {\n  content: \"\\F0CC0\";\n}\n\n.mdi-radius-outline::before {\n  content: \"\\F0CC1\";\n}\n\n.mdi-railroad-light::before {\n  content: \"\\F0F1E\";\n}\n\n.mdi-rake::before {\n  content: \"\\F1544\";\n}\n\n.mdi-raspberry-pi::before {\n  content: \"\\F043F\";\n}\n\n.mdi-ray-end::before {\n  content: \"\\F0440\";\n}\n\n.mdi-ray-end-arrow::before {\n  content: \"\\F0441\";\n}\n\n.mdi-ray-start::before {\n  content: \"\\F0442\";\n}\n\n.mdi-ray-start-arrow::before {\n  content: \"\\F0443\";\n}\n\n.mdi-ray-start-end::before {\n  content: \"\\F0444\";\n}\n\n.mdi-ray-start-vertex-end::before {\n  content: \"\\F15D8\";\n}\n\n.mdi-ray-vertex::before {\n  content: \"\\F0445\";\n}\n\n.mdi-razor-double-edge::before {\n  content: \"\\F1997\";\n}\n\n.mdi-razor-single-edge::before {\n  content: \"\\F1998\";\n}\n\n.mdi-react::before {\n  content: \"\\F0708\";\n}\n\n.mdi-read::before {\n  content: \"\\F0447\";\n}\n\n.mdi-receipt::before {\n  content: \"\\F0449\";\n}\n\n.mdi-record::before {\n  content: \"\\F044A\";\n}\n\n.mdi-record-circle::before {\n  content: \"\\F0EC2\";\n}\n\n.mdi-record-circle-outline::before {\n  content: \"\\F0EC3\";\n}\n\n.mdi-record-player::before {\n  content: \"\\F099A\";\n}\n\n.mdi-record-rec::before {\n  content: \"\\F044B\";\n}\n\n.mdi-rectangle::before {\n  content: \"\\F0E5E\";\n}\n\n.mdi-rectangle-outline::before {\n  content: \"\\F0E5F\";\n}\n\n.mdi-recycle::before {\n  content: \"\\F044C\";\n}\n\n.mdi-recycle-variant::before {\n  content: \"\\F139D\";\n}\n\n.mdi-reddit::before {\n  content: \"\\F044D\";\n}\n\n.mdi-redhat::before {\n  content: \"\\F111B\";\n}\n\n.mdi-redo::before {\n  content: \"\\F044E\";\n}\n\n.mdi-redo-variant::before {\n  content: \"\\F044F\";\n}\n\n.mdi-reflect-horizontal::before {\n  content: \"\\F0A0E\";\n}\n\n.mdi-reflect-vertical::before {\n  content: \"\\F0A0F\";\n}\n\n.mdi-refresh::before {\n  content: \"\\F0450\";\n}\n\n.mdi-refresh-auto::before {\n  content: \"\\F18F2\";\n}\n\n.mdi-refresh-circle::before {\n  content: \"\\F1377\";\n}\n\n.mdi-regex::before {\n  content: \"\\F0451\";\n}\n\n.mdi-registered-trademark::before {\n  content: \"\\F0A67\";\n}\n\n.mdi-reiterate::before {\n  content: \"\\F1588\";\n}\n\n.mdi-relation-many-to-many::before {\n  content: \"\\F1496\";\n}\n\n.mdi-relation-many-to-one::before {\n  content: \"\\F1497\";\n}\n\n.mdi-relation-many-to-one-or-many::before {\n  content: \"\\F1498\";\n}\n\n.mdi-relation-many-to-only-one::before {\n  content: \"\\F1499\";\n}\n\n.mdi-relation-many-to-zero-or-many::before {\n  content: \"\\F149A\";\n}\n\n.mdi-relation-many-to-zero-or-one::before {\n  content: \"\\F149B\";\n}\n\n.mdi-relation-one-or-many-to-many::before {\n  content: \"\\F149C\";\n}\n\n.mdi-relation-one-or-many-to-one::before {\n  content: \"\\F149D\";\n}\n\n.mdi-relation-one-or-many-to-one-or-many::before {\n  content: \"\\F149E\";\n}\n\n.mdi-relation-one-or-many-to-only-one::before {\n  content: \"\\F149F\";\n}\n\n.mdi-relation-one-or-many-to-zero-or-many::before {\n  content: \"\\F14A0\";\n}\n\n.mdi-relation-one-or-many-to-zero-or-one::before {\n  content: \"\\F14A1\";\n}\n\n.mdi-relation-one-to-many::before {\n  content: \"\\F14A2\";\n}\n\n.mdi-relation-one-to-one::before {\n  content: \"\\F14A3\";\n}\n\n.mdi-relation-one-to-one-or-many::before {\n  content: \"\\F14A4\";\n}\n\n.mdi-relation-one-to-only-one::before {\n  content: \"\\F14A5\";\n}\n\n.mdi-relation-one-to-zero-or-many::before {\n  content: \"\\F14A6\";\n}\n\n.mdi-relation-one-to-zero-or-one::before {\n  content: \"\\F14A7\";\n}\n\n.mdi-relation-only-one-to-many::before {\n  content: \"\\F14A8\";\n}\n\n.mdi-relation-only-one-to-one::before {\n  content: \"\\F14A9\";\n}\n\n.mdi-relation-only-one-to-one-or-many::before {\n  content: \"\\F14AA\";\n}\n\n.mdi-relation-only-one-to-only-one::before {\n  content: \"\\F14AB\";\n}\n\n.mdi-relation-only-one-to-zero-or-many::before {\n  content: \"\\F14AC\";\n}\n\n.mdi-relation-only-one-to-zero-or-one::before {\n  content: \"\\F14AD\";\n}\n\n.mdi-relation-zero-or-many-to-many::before {\n  content: \"\\F14AE\";\n}\n\n.mdi-relation-zero-or-many-to-one::before {\n  content: \"\\F14AF\";\n}\n\n.mdi-relation-zero-or-many-to-one-or-many::before {\n  content: \"\\F14B0\";\n}\n\n.mdi-relation-zero-or-many-to-only-one::before {\n  content: \"\\F14B1\";\n}\n\n.mdi-relation-zero-or-many-to-zero-or-many::before {\n  content: \"\\F14B2\";\n}\n\n.mdi-relation-zero-or-many-to-zero-or-one::before {\n  content: \"\\F14B3\";\n}\n\n.mdi-relation-zero-or-one-to-many::before {\n  content: \"\\F14B4\";\n}\n\n.mdi-relation-zero-or-one-to-one::before {\n  content: \"\\F14B5\";\n}\n\n.mdi-relation-zero-or-one-to-one-or-many::before {\n  content: \"\\F14B6\";\n}\n\n.mdi-relation-zero-or-one-to-only-one::before {\n  content: \"\\F14B7\";\n}\n\n.mdi-relation-zero-or-one-to-zero-or-many::before {\n  content: \"\\F14B8\";\n}\n\n.mdi-relation-zero-or-one-to-zero-or-one::before {\n  content: \"\\F14B9\";\n}\n\n.mdi-relative-scale::before {\n  content: \"\\F0452\";\n}\n\n.mdi-reload::before {\n  content: \"\\F0453\";\n}\n\n.mdi-reload-alert::before {\n  content: \"\\F110B\";\n}\n\n.mdi-reminder::before {\n  content: \"\\F088C\";\n}\n\n.mdi-remote::before {\n  content: \"\\F0454\";\n}\n\n.mdi-remote-desktop::before {\n  content: \"\\F08B9\";\n}\n\n.mdi-remote-off::before {\n  content: \"\\F0EC4\";\n}\n\n.mdi-remote-tv::before {\n  content: \"\\F0EC5\";\n}\n\n.mdi-remote-tv-off::before {\n  content: \"\\F0EC6\";\n}\n\n.mdi-rename-box::before {\n  content: \"\\F0455\";\n}\n\n.mdi-reorder-horizontal::before {\n  content: \"\\F0688\";\n}\n\n.mdi-reorder-vertical::before {\n  content: \"\\F0689\";\n}\n\n.mdi-repeat::before {\n  content: \"\\F0456\";\n}\n\n.mdi-repeat-off::before {\n  content: \"\\F0457\";\n}\n\n.mdi-repeat-once::before {\n  content: \"\\F0458\";\n}\n\n.mdi-repeat-variant::before {\n  content: \"\\F0547\";\n}\n\n.mdi-replay::before {\n  content: \"\\F0459\";\n}\n\n.mdi-reply::before {\n  content: \"\\F045A\";\n}\n\n.mdi-reply-all::before {\n  content: \"\\F045B\";\n}\n\n.mdi-reply-all-outline::before {\n  content: \"\\F0F1F\";\n}\n\n.mdi-reply-circle::before {\n  content: \"\\F11AE\";\n}\n\n.mdi-reply-outline::before {\n  content: \"\\F0F20\";\n}\n\n.mdi-reproduction::before {\n  content: \"\\F045C\";\n}\n\n.mdi-resistor::before {\n  content: \"\\F0B44\";\n}\n\n.mdi-resistor-nodes::before {\n  content: \"\\F0B45\";\n}\n\n.mdi-resize::before {\n  content: \"\\F0A68\";\n}\n\n.mdi-resize-bottom-right::before {\n  content: \"\\F045D\";\n}\n\n.mdi-responsive::before {\n  content: \"\\F045E\";\n}\n\n.mdi-restart::before {\n  content: \"\\F0709\";\n}\n\n.mdi-restart-alert::before {\n  content: \"\\F110C\";\n}\n\n.mdi-restart-off::before {\n  content: \"\\F0D95\";\n}\n\n.mdi-restore::before {\n  content: \"\\F099B\";\n}\n\n.mdi-restore-alert::before {\n  content: \"\\F110D\";\n}\n\n.mdi-rewind::before {\n  content: \"\\F045F\";\n}\n\n.mdi-rewind-10::before {\n  content: \"\\F0D2A\";\n}\n\n.mdi-rewind-15::before {\n  content: \"\\F1946\";\n}\n\n.mdi-rewind-30::before {\n  content: \"\\F0D96\";\n}\n\n.mdi-rewind-5::before {\n  content: \"\\F11F9\";\n}\n\n.mdi-rewind-60::before {\n  content: \"\\F160C\";\n}\n\n.mdi-rewind-outline::before {\n  content: \"\\F070A\";\n}\n\n.mdi-rhombus::before {\n  content: \"\\F070B\";\n}\n\n.mdi-rhombus-medium::before {\n  content: \"\\F0A10\";\n}\n\n.mdi-rhombus-medium-outline::before {\n  content: \"\\F14DC\";\n}\n\n.mdi-rhombus-outline::before {\n  content: \"\\F070C\";\n}\n\n.mdi-rhombus-split::before {\n  content: \"\\F0A11\";\n}\n\n.mdi-rhombus-split-outline::before {\n  content: \"\\F14DD\";\n}\n\n.mdi-ribbon::before {\n  content: \"\\F0460\";\n}\n\n.mdi-rice::before {\n  content: \"\\F07EA\";\n}\n\n.mdi-rickshaw::before {\n  content: \"\\F15BB\";\n}\n\n.mdi-rickshaw-electric::before {\n  content: \"\\F15BC\";\n}\n\n.mdi-ring::before {\n  content: \"\\F07EB\";\n}\n\n.mdi-rivet::before {\n  content: \"\\F0E60\";\n}\n\n.mdi-road::before {\n  content: \"\\F0461\";\n}\n\n.mdi-road-variant::before {\n  content: \"\\F0462\";\n}\n\n.mdi-robber::before {\n  content: \"\\F1058\";\n}\n\n.mdi-robot::before {\n  content: \"\\F06A9\";\n}\n\n.mdi-robot-angry::before {\n  content: \"\\F169D\";\n}\n\n.mdi-robot-angry-outline::before {\n  content: \"\\F169E\";\n}\n\n.mdi-robot-confused::before {\n  content: \"\\F169F\";\n}\n\n.mdi-robot-confused-outline::before {\n  content: \"\\F16A0\";\n}\n\n.mdi-robot-dead::before {\n  content: \"\\F16A1\";\n}\n\n.mdi-robot-dead-outline::before {\n  content: \"\\F16A2\";\n}\n\n.mdi-robot-excited::before {\n  content: \"\\F16A3\";\n}\n\n.mdi-robot-excited-outline::before {\n  content: \"\\F16A4\";\n}\n\n.mdi-robot-happy::before {\n  content: \"\\F1719\";\n}\n\n.mdi-robot-happy-outline::before {\n  content: \"\\F171A\";\n}\n\n.mdi-robot-industrial::before {\n  content: \"\\F0B46\";\n}\n\n.mdi-robot-love::before {\n  content: \"\\F16A5\";\n}\n\n.mdi-robot-love-outline::before {\n  content: \"\\F16A6\";\n}\n\n.mdi-robot-mower::before {\n  content: \"\\F11F7\";\n}\n\n.mdi-robot-mower-outline::before {\n  content: \"\\F11F3\";\n}\n\n.mdi-robot-off::before {\n  content: \"\\F16A7\";\n}\n\n.mdi-robot-off-outline::before {\n  content: \"\\F167B\";\n}\n\n.mdi-robot-outline::before {\n  content: \"\\F167A\";\n}\n\n.mdi-robot-vacuum::before {\n  content: \"\\F070D\";\n}\n\n.mdi-robot-vacuum-variant::before {\n  content: \"\\F0908\";\n}\n\n.mdi-rocket::before {\n  content: \"\\F0463\";\n}\n\n.mdi-rocket-launch::before {\n  content: \"\\F14DE\";\n}\n\n.mdi-rocket-launch-outline::before {\n  content: \"\\F14DF\";\n}\n\n.mdi-rocket-outline::before {\n  content: \"\\F13AF\";\n}\n\n.mdi-rodent::before {\n  content: \"\\F1327\";\n}\n\n.mdi-roller-skate::before {\n  content: \"\\F0D2B\";\n}\n\n.mdi-roller-skate-off::before {\n  content: \"\\F0145\";\n}\n\n.mdi-rollerblade::before {\n  content: \"\\F0D2C\";\n}\n\n.mdi-rollerblade-off::before {\n  content: \"\\F002E\";\n}\n\n.mdi-rollupjs::before {\n  content: \"\\F0BC0\";\n}\n\n.mdi-roman-numeral-1::before {\n  content: \"\\F1088\";\n}\n\n.mdi-roman-numeral-10::before {\n  content: \"\\F1091\";\n}\n\n.mdi-roman-numeral-2::before {\n  content: \"\\F1089\";\n}\n\n.mdi-roman-numeral-3::before {\n  content: \"\\F108A\";\n}\n\n.mdi-roman-numeral-4::before {\n  content: \"\\F108B\";\n}\n\n.mdi-roman-numeral-5::before {\n  content: \"\\F108C\";\n}\n\n.mdi-roman-numeral-6::before {\n  content: \"\\F108D\";\n}\n\n.mdi-roman-numeral-7::before {\n  content: \"\\F108E\";\n}\n\n.mdi-roman-numeral-8::before {\n  content: \"\\F108F\";\n}\n\n.mdi-roman-numeral-9::before {\n  content: \"\\F1090\";\n}\n\n.mdi-room-service::before {\n  content: \"\\F088D\";\n}\n\n.mdi-room-service-outline::before {\n  content: \"\\F0D97\";\n}\n\n.mdi-rotate-360::before {\n  content: \"\\F1999\";\n}\n\n.mdi-rotate-3d::before {\n  content: \"\\F0EC7\";\n}\n\n.mdi-rotate-3d-variant::before {\n  content: \"\\F0464\";\n}\n\n.mdi-rotate-left::before {\n  content: \"\\F0465\";\n}\n\n.mdi-rotate-left-variant::before {\n  content: \"\\F0466\";\n}\n\n.mdi-rotate-orbit::before {\n  content: \"\\F0D98\";\n}\n\n.mdi-rotate-right::before {\n  content: \"\\F0467\";\n}\n\n.mdi-rotate-right-variant::before {\n  content: \"\\F0468\";\n}\n\n.mdi-rounded-corner::before {\n  content: \"\\F0607\";\n}\n\n.mdi-router::before {\n  content: \"\\F11E2\";\n}\n\n.mdi-router-network::before {\n  content: \"\\F1087\";\n}\n\n.mdi-router-wireless::before {\n  content: \"\\F0469\";\n}\n\n.mdi-router-wireless-off::before {\n  content: \"\\F15A3\";\n}\n\n.mdi-router-wireless-settings::before {\n  content: \"\\F0A69\";\n}\n\n.mdi-routes::before {\n  content: \"\\F046A\";\n}\n\n.mdi-routes-clock::before {\n  content: \"\\F1059\";\n}\n\n.mdi-rowing::before {\n  content: \"\\F0608\";\n}\n\n.mdi-rss::before {\n  content: \"\\F046B\";\n}\n\n.mdi-rss-box::before {\n  content: \"\\F046C\";\n}\n\n.mdi-rss-off::before {\n  content: \"\\F0F21\";\n}\n\n.mdi-rug::before {\n  content: \"\\F1475\";\n}\n\n.mdi-rugby::before {\n  content: \"\\F0D99\";\n}\n\n.mdi-ruler::before {\n  content: \"\\F046D\";\n}\n\n.mdi-ruler-square::before {\n  content: \"\\F0CC2\";\n}\n\n.mdi-ruler-square-compass::before {\n  content: \"\\F0EBE\";\n}\n\n.mdi-run::before {\n  content: \"\\F070E\";\n}\n\n.mdi-run-fast::before {\n  content: \"\\F046E\";\n}\n\n.mdi-rv-truck::before {\n  content: \"\\F11D4\";\n}\n\n.mdi-sack::before {\n  content: \"\\F0D2E\";\n}\n\n.mdi-sack-percent::before {\n  content: \"\\F0D2F\";\n}\n\n.mdi-safe::before {\n  content: \"\\F0A6A\";\n}\n\n.mdi-safe-square::before {\n  content: \"\\F127C\";\n}\n\n.mdi-safe-square-outline::before {\n  content: \"\\F127D\";\n}\n\n.mdi-safety-goggles::before {\n  content: \"\\F0D30\";\n}\n\n.mdi-sail-boat::before {\n  content: \"\\F0EC8\";\n}\n\n.mdi-sale::before {\n  content: \"\\F046F\";\n}\n\n.mdi-salesforce::before {\n  content: \"\\F088E\";\n}\n\n.mdi-sass::before {\n  content: \"\\F07EC\";\n}\n\n.mdi-satellite::before {\n  content: \"\\F0470\";\n}\n\n.mdi-satellite-uplink::before {\n  content: \"\\F0909\";\n}\n\n.mdi-satellite-variant::before {\n  content: \"\\F0471\";\n}\n\n.mdi-sausage::before {\n  content: \"\\F08BA\";\n}\n\n.mdi-sausage-off::before {\n  content: \"\\F1789\";\n}\n\n.mdi-saw-blade::before {\n  content: \"\\F0E61\";\n}\n\n.mdi-sawtooth-wave::before {\n  content: \"\\F147A\";\n}\n\n.mdi-saxophone::before {\n  content: \"\\F0609\";\n}\n\n.mdi-scale::before {\n  content: \"\\F0472\";\n}\n\n.mdi-scale-balance::before {\n  content: \"\\F05D1\";\n}\n\n.mdi-scale-bathroom::before {\n  content: \"\\F0473\";\n}\n\n.mdi-scale-off::before {\n  content: \"\\F105A\";\n}\n\n.mdi-scale-unbalanced::before {\n  content: \"\\F19B8\";\n}\n\n.mdi-scan-helper::before {\n  content: \"\\F13D8\";\n}\n\n.mdi-scanner::before {\n  content: \"\\F06AB\";\n}\n\n.mdi-scanner-off::before {\n  content: \"\\F090A\";\n}\n\n.mdi-scatter-plot::before {\n  content: \"\\F0EC9\";\n}\n\n.mdi-scatter-plot-outline::before {\n  content: \"\\F0ECA\";\n}\n\n.mdi-scent::before {\n  content: \"\\F1958\";\n}\n\n.mdi-scent-off::before {\n  content: \"\\F1959\";\n}\n\n.mdi-school::before {\n  content: \"\\F0474\";\n}\n\n.mdi-school-outline::before {\n  content: \"\\F1180\";\n}\n\n.mdi-scissors-cutting::before {\n  content: \"\\F0A6B\";\n}\n\n.mdi-scooter::before {\n  content: \"\\F15BD\";\n}\n\n.mdi-scooter-electric::before {\n  content: \"\\F15BE\";\n}\n\n.mdi-scoreboard::before {\n  content: \"\\F127E\";\n}\n\n.mdi-scoreboard-outline::before {\n  content: \"\\F127F\";\n}\n\n.mdi-screen-rotation::before {\n  content: \"\\F0475\";\n}\n\n.mdi-screen-rotation-lock::before {\n  content: \"\\F0478\";\n}\n\n.mdi-screw-flat-top::before {\n  content: \"\\F0DF3\";\n}\n\n.mdi-screw-lag::before {\n  content: \"\\F0DF4\";\n}\n\n.mdi-screw-machine-flat-top::before {\n  content: \"\\F0DF5\";\n}\n\n.mdi-screw-machine-round-top::before {\n  content: \"\\F0DF6\";\n}\n\n.mdi-screw-round-top::before {\n  content: \"\\F0DF7\";\n}\n\n.mdi-screwdriver::before {\n  content: \"\\F0476\";\n}\n\n.mdi-script::before {\n  content: \"\\F0BC1\";\n}\n\n.mdi-script-outline::before {\n  content: \"\\F0477\";\n}\n\n.mdi-script-text::before {\n  content: \"\\F0BC2\";\n}\n\n.mdi-script-text-key::before {\n  content: \"\\F1725\";\n}\n\n.mdi-script-text-key-outline::before {\n  content: \"\\F1726\";\n}\n\n.mdi-script-text-outline::before {\n  content: \"\\F0BC3\";\n}\n\n.mdi-script-text-play::before {\n  content: \"\\F1727\";\n}\n\n.mdi-script-text-play-outline::before {\n  content: \"\\F1728\";\n}\n\n.mdi-sd::before {\n  content: \"\\F0479\";\n}\n\n.mdi-seal::before {\n  content: \"\\F047A\";\n}\n\n.mdi-seal-variant::before {\n  content: \"\\F0FD9\";\n}\n\n.mdi-search-web::before {\n  content: \"\\F070F\";\n}\n\n.mdi-seat::before {\n  content: \"\\F0CC3\";\n}\n\n.mdi-seat-flat::before {\n  content: \"\\F047B\";\n}\n\n.mdi-seat-flat-angled::before {\n  content: \"\\F047C\";\n}\n\n.mdi-seat-individual-suite::before {\n  content: \"\\F047D\";\n}\n\n.mdi-seat-legroom-extra::before {\n  content: \"\\F047E\";\n}\n\n.mdi-seat-legroom-normal::before {\n  content: \"\\F047F\";\n}\n\n.mdi-seat-legroom-reduced::before {\n  content: \"\\F0480\";\n}\n\n.mdi-seat-outline::before {\n  content: \"\\F0CC4\";\n}\n\n.mdi-seat-passenger::before {\n  content: \"\\F1249\";\n}\n\n.mdi-seat-recline-extra::before {\n  content: \"\\F0481\";\n}\n\n.mdi-seat-recline-normal::before {\n  content: \"\\F0482\";\n}\n\n.mdi-seatbelt::before {\n  content: \"\\F0CC5\";\n}\n\n.mdi-security::before {\n  content: \"\\F0483\";\n}\n\n.mdi-security-network::before {\n  content: \"\\F0484\";\n}\n\n.mdi-seed::before {\n  content: \"\\F0E62\";\n}\n\n.mdi-seed-off::before {\n  content: \"\\F13FD\";\n}\n\n.mdi-seed-off-outline::before {\n  content: \"\\F13FE\";\n}\n\n.mdi-seed-outline::before {\n  content: \"\\F0E63\";\n}\n\n.mdi-seesaw::before {\n  content: \"\\F15A4\";\n}\n\n.mdi-segment::before {\n  content: \"\\F0ECB\";\n}\n\n.mdi-select::before {\n  content: \"\\F0485\";\n}\n\n.mdi-select-all::before {\n  content: \"\\F0486\";\n}\n\n.mdi-select-color::before {\n  content: \"\\F0D31\";\n}\n\n.mdi-select-compare::before {\n  content: \"\\F0AD9\";\n}\n\n.mdi-select-drag::before {\n  content: \"\\F0A6C\";\n}\n\n.mdi-select-group::before {\n  content: \"\\F0F82\";\n}\n\n.mdi-select-inverse::before {\n  content: \"\\F0487\";\n}\n\n.mdi-select-marker::before {\n  content: \"\\F1280\";\n}\n\n.mdi-select-multiple::before {\n  content: \"\\F1281\";\n}\n\n.mdi-select-multiple-marker::before {\n  content: \"\\F1282\";\n}\n\n.mdi-select-off::before {\n  content: \"\\F0488\";\n}\n\n.mdi-select-place::before {\n  content: \"\\F0FDA\";\n}\n\n.mdi-select-remove::before {\n  content: \"\\F17C1\";\n}\n\n.mdi-select-search::before {\n  content: \"\\F1204\";\n}\n\n.mdi-selection::before {\n  content: \"\\F0489\";\n}\n\n.mdi-selection-drag::before {\n  content: \"\\F0A6D\";\n}\n\n.mdi-selection-ellipse::before {\n  content: \"\\F0D32\";\n}\n\n.mdi-selection-ellipse-arrow-inside::before {\n  content: \"\\F0F22\";\n}\n\n.mdi-selection-ellipse-remove::before {\n  content: \"\\F17C2\";\n}\n\n.mdi-selection-marker::before {\n  content: \"\\F1283\";\n}\n\n.mdi-selection-multiple::before {\n  content: \"\\F1285\";\n}\n\n.mdi-selection-multiple-marker::before {\n  content: \"\\F1284\";\n}\n\n.mdi-selection-off::before {\n  content: \"\\F0777\";\n}\n\n.mdi-selection-remove::before {\n  content: \"\\F17C3\";\n}\n\n.mdi-selection-search::before {\n  content: \"\\F1205\";\n}\n\n.mdi-semantic-web::before {\n  content: \"\\F1316\";\n}\n\n.mdi-send::before {\n  content: \"\\F048A\";\n}\n\n.mdi-send-check::before {\n  content: \"\\F1161\";\n}\n\n.mdi-send-check-outline::before {\n  content: \"\\F1162\";\n}\n\n.mdi-send-circle::before {\n  content: \"\\F0DF8\";\n}\n\n.mdi-send-circle-outline::before {\n  content: \"\\F0DF9\";\n}\n\n.mdi-send-clock::before {\n  content: \"\\F1163\";\n}\n\n.mdi-send-clock-outline::before {\n  content: \"\\F1164\";\n}\n\n.mdi-send-lock::before {\n  content: \"\\F07ED\";\n}\n\n.mdi-send-lock-outline::before {\n  content: \"\\F1166\";\n}\n\n.mdi-send-outline::before {\n  content: \"\\F1165\";\n}\n\n.mdi-serial-port::before {\n  content: \"\\F065C\";\n}\n\n.mdi-server::before {\n  content: \"\\F048B\";\n}\n\n.mdi-server-minus::before {\n  content: \"\\F048C\";\n}\n\n.mdi-server-network::before {\n  content: \"\\F048D\";\n}\n\n.mdi-server-network-off::before {\n  content: \"\\F048E\";\n}\n\n.mdi-server-off::before {\n  content: \"\\F048F\";\n}\n\n.mdi-server-plus::before {\n  content: \"\\F0490\";\n}\n\n.mdi-server-remove::before {\n  content: \"\\F0491\";\n}\n\n.mdi-server-security::before {\n  content: \"\\F0492\";\n}\n\n.mdi-set-all::before {\n  content: \"\\F0778\";\n}\n\n.mdi-set-center::before {\n  content: \"\\F0779\";\n}\n\n.mdi-set-center-right::before {\n  content: \"\\F077A\";\n}\n\n.mdi-set-left::before {\n  content: \"\\F077B\";\n}\n\n.mdi-set-left-center::before {\n  content: \"\\F077C\";\n}\n\n.mdi-set-left-right::before {\n  content: \"\\F077D\";\n}\n\n.mdi-set-merge::before {\n  content: \"\\F14E0\";\n}\n\n.mdi-set-none::before {\n  content: \"\\F077E\";\n}\n\n.mdi-set-right::before {\n  content: \"\\F077F\";\n}\n\n.mdi-set-split::before {\n  content: \"\\F14E1\";\n}\n\n.mdi-set-square::before {\n  content: \"\\F145D\";\n}\n\n.mdi-set-top-box::before {\n  content: \"\\F099F\";\n}\n\n.mdi-settings-helper::before {\n  content: \"\\F0A6E\";\n}\n\n.mdi-shaker::before {\n  content: \"\\F110E\";\n}\n\n.mdi-shaker-outline::before {\n  content: \"\\F110F\";\n}\n\n.mdi-shape::before {\n  content: \"\\F0831\";\n}\n\n.mdi-shape-circle-plus::before {\n  content: \"\\F065D\";\n}\n\n.mdi-shape-outline::before {\n  content: \"\\F0832\";\n}\n\n.mdi-shape-oval-plus::before {\n  content: \"\\F11FA\";\n}\n\n.mdi-shape-plus::before {\n  content: \"\\F0495\";\n}\n\n.mdi-shape-polygon-plus::before {\n  content: \"\\F065E\";\n}\n\n.mdi-shape-rectangle-plus::before {\n  content: \"\\F065F\";\n}\n\n.mdi-shape-square-plus::before {\n  content: \"\\F0660\";\n}\n\n.mdi-shape-square-rounded-plus::before {\n  content: \"\\F14FA\";\n}\n\n.mdi-share::before {\n  content: \"\\F0496\";\n}\n\n.mdi-share-all::before {\n  content: \"\\F11F4\";\n}\n\n.mdi-share-all-outline::before {\n  content: \"\\F11F5\";\n}\n\n.mdi-share-circle::before {\n  content: \"\\F11AD\";\n}\n\n.mdi-share-off::before {\n  content: \"\\F0F23\";\n}\n\n.mdi-share-off-outline::before {\n  content: \"\\F0F24\";\n}\n\n.mdi-share-outline::before {\n  content: \"\\F0932\";\n}\n\n.mdi-share-variant::before {\n  content: \"\\F0497\";\n}\n\n.mdi-share-variant-outline::before {\n  content: \"\\F1514\";\n}\n\n.mdi-shark::before {\n  content: \"\\F18BA\";\n}\n\n.mdi-shark-fin::before {\n  content: \"\\F1673\";\n}\n\n.mdi-shark-fin-outline::before {\n  content: \"\\F1674\";\n}\n\n.mdi-shark-off::before {\n  content: \"\\F18BB\";\n}\n\n.mdi-sheep::before {\n  content: \"\\F0CC6\";\n}\n\n.mdi-shield::before {\n  content: \"\\F0498\";\n}\n\n.mdi-shield-account::before {\n  content: \"\\F088F\";\n}\n\n.mdi-shield-account-outline::before {\n  content: \"\\F0A12\";\n}\n\n.mdi-shield-account-variant::before {\n  content: \"\\F15A7\";\n}\n\n.mdi-shield-account-variant-outline::before {\n  content: \"\\F15A8\";\n}\n\n.mdi-shield-airplane::before {\n  content: \"\\F06BB\";\n}\n\n.mdi-shield-airplane-outline::before {\n  content: \"\\F0CC7\";\n}\n\n.mdi-shield-alert::before {\n  content: \"\\F0ECC\";\n}\n\n.mdi-shield-alert-outline::before {\n  content: \"\\F0ECD\";\n}\n\n.mdi-shield-bug::before {\n  content: \"\\F13DA\";\n}\n\n.mdi-shield-bug-outline::before {\n  content: \"\\F13DB\";\n}\n\n.mdi-shield-car::before {\n  content: \"\\F0F83\";\n}\n\n.mdi-shield-check::before {\n  content: \"\\F0565\";\n}\n\n.mdi-shield-check-outline::before {\n  content: \"\\F0CC8\";\n}\n\n.mdi-shield-cross::before {\n  content: \"\\F0CC9\";\n}\n\n.mdi-shield-cross-outline::before {\n  content: \"\\F0CCA\";\n}\n\n.mdi-shield-crown::before {\n  content: \"\\F18BC\";\n}\n\n.mdi-shield-crown-outline::before {\n  content: \"\\F18BD\";\n}\n\n.mdi-shield-edit::before {\n  content: \"\\F11A0\";\n}\n\n.mdi-shield-edit-outline::before {\n  content: \"\\F11A1\";\n}\n\n.mdi-shield-half::before {\n  content: \"\\F1360\";\n}\n\n.mdi-shield-half-full::before {\n  content: \"\\F0780\";\n}\n\n.mdi-shield-home::before {\n  content: \"\\F068A\";\n}\n\n.mdi-shield-home-outline::before {\n  content: \"\\F0CCB\";\n}\n\n.mdi-shield-key::before {\n  content: \"\\F0BC4\";\n}\n\n.mdi-shield-key-outline::before {\n  content: \"\\F0BC5\";\n}\n\n.mdi-shield-link-variant::before {\n  content: \"\\F0D33\";\n}\n\n.mdi-shield-link-variant-outline::before {\n  content: \"\\F0D34\";\n}\n\n.mdi-shield-lock::before {\n  content: \"\\F099D\";\n}\n\n.mdi-shield-lock-open::before {\n  content: \"\\F199A\";\n}\n\n.mdi-shield-lock-open-outline::before {\n  content: \"\\F199B\";\n}\n\n.mdi-shield-lock-outline::before {\n  content: \"\\F0CCC\";\n}\n\n.mdi-shield-moon::before {\n  content: \"\\F1828\";\n}\n\n.mdi-shield-moon-outline::before {\n  content: \"\\F1829\";\n}\n\n.mdi-shield-off::before {\n  content: \"\\F099E\";\n}\n\n.mdi-shield-off-outline::before {\n  content: \"\\F099C\";\n}\n\n.mdi-shield-outline::before {\n  content: \"\\F0499\";\n}\n\n.mdi-shield-plus::before {\n  content: \"\\F0ADA\";\n}\n\n.mdi-shield-plus-outline::before {\n  content: \"\\F0ADB\";\n}\n\n.mdi-shield-refresh::before {\n  content: \"\\F00AA\";\n}\n\n.mdi-shield-refresh-outline::before {\n  content: \"\\F01E0\";\n}\n\n.mdi-shield-remove::before {\n  content: \"\\F0ADC\";\n}\n\n.mdi-shield-remove-outline::before {\n  content: \"\\F0ADD\";\n}\n\n.mdi-shield-search::before {\n  content: \"\\F0D9A\";\n}\n\n.mdi-shield-star::before {\n  content: \"\\F113B\";\n}\n\n.mdi-shield-star-outline::before {\n  content: \"\\F113C\";\n}\n\n.mdi-shield-sun::before {\n  content: \"\\F105D\";\n}\n\n.mdi-shield-sun-outline::before {\n  content: \"\\F105E\";\n}\n\n.mdi-shield-sword::before {\n  content: \"\\F18BE\";\n}\n\n.mdi-shield-sword-outline::before {\n  content: \"\\F18BF\";\n}\n\n.mdi-shield-sync::before {\n  content: \"\\F11A2\";\n}\n\n.mdi-shield-sync-outline::before {\n  content: \"\\F11A3\";\n}\n\n.mdi-shimmer::before {\n  content: \"\\F1545\";\n}\n\n.mdi-ship-wheel::before {\n  content: \"\\F0833\";\n}\n\n.mdi-shipping-pallet::before {\n  content: \"\\F184E\";\n}\n\n.mdi-shoe-ballet::before {\n  content: \"\\F15CA\";\n}\n\n.mdi-shoe-cleat::before {\n  content: \"\\F15C7\";\n}\n\n.mdi-shoe-formal::before {\n  content: \"\\F0B47\";\n}\n\n.mdi-shoe-heel::before {\n  content: \"\\F0B48\";\n}\n\n.mdi-shoe-print::before {\n  content: \"\\F0DFA\";\n}\n\n.mdi-shoe-sneaker::before {\n  content: \"\\F15C8\";\n}\n\n.mdi-shopping::before {\n  content: \"\\F049A\";\n}\n\n.mdi-shopping-music::before {\n  content: \"\\F049B\";\n}\n\n.mdi-shopping-outline::before {\n  content: \"\\F11D5\";\n}\n\n.mdi-shopping-search::before {\n  content: \"\\F0F84\";\n}\n\n.mdi-shore::before {\n  content: \"\\F14F9\";\n}\n\n.mdi-shovel::before {\n  content: \"\\F0710\";\n}\n\n.mdi-shovel-off::before {\n  content: \"\\F0711\";\n}\n\n.mdi-shower::before {\n  content: \"\\F09A0\";\n}\n\n.mdi-shower-head::before {\n  content: \"\\F09A1\";\n}\n\n.mdi-shredder::before {\n  content: \"\\F049C\";\n}\n\n.mdi-shuffle::before {\n  content: \"\\F049D\";\n}\n\n.mdi-shuffle-disabled::before {\n  content: \"\\F049E\";\n}\n\n.mdi-shuffle-variant::before {\n  content: \"\\F049F\";\n}\n\n.mdi-shuriken::before {\n  content: \"\\F137F\";\n}\n\n.mdi-sickle::before {\n  content: \"\\F18C0\";\n}\n\n.mdi-sigma::before {\n  content: \"\\F04A0\";\n}\n\n.mdi-sigma-lower::before {\n  content: \"\\F062B\";\n}\n\n.mdi-sign-caution::before {\n  content: \"\\F04A1\";\n}\n\n.mdi-sign-direction::before {\n  content: \"\\F0781\";\n}\n\n.mdi-sign-direction-minus::before {\n  content: \"\\F1000\";\n}\n\n.mdi-sign-direction-plus::before {\n  content: \"\\F0FDC\";\n}\n\n.mdi-sign-direction-remove::before {\n  content: \"\\F0FDD\";\n}\n\n.mdi-sign-pole::before {\n  content: \"\\F14F8\";\n}\n\n.mdi-sign-real-estate::before {\n  content: \"\\F1118\";\n}\n\n.mdi-sign-text::before {\n  content: \"\\F0782\";\n}\n\n.mdi-signal::before {\n  content: \"\\F04A2\";\n}\n\n.mdi-signal-2g::before {\n  content: \"\\F0712\";\n}\n\n.mdi-signal-3g::before {\n  content: \"\\F0713\";\n}\n\n.mdi-signal-4g::before {\n  content: \"\\F0714\";\n}\n\n.mdi-signal-5g::before {\n  content: \"\\F0A6F\";\n}\n\n.mdi-signal-cellular-1::before {\n  content: \"\\F08BC\";\n}\n\n.mdi-signal-cellular-2::before {\n  content: \"\\F08BD\";\n}\n\n.mdi-signal-cellular-3::before {\n  content: \"\\F08BE\";\n}\n\n.mdi-signal-cellular-outline::before {\n  content: \"\\F08BF\";\n}\n\n.mdi-signal-distance-variant::before {\n  content: \"\\F0E64\";\n}\n\n.mdi-signal-hspa::before {\n  content: \"\\F0715\";\n}\n\n.mdi-signal-hspa-plus::before {\n  content: \"\\F0716\";\n}\n\n.mdi-signal-off::before {\n  content: \"\\F0783\";\n}\n\n.mdi-signal-variant::before {\n  content: \"\\F060A\";\n}\n\n.mdi-signature::before {\n  content: \"\\F0DFB\";\n}\n\n.mdi-signature-freehand::before {\n  content: \"\\F0DFC\";\n}\n\n.mdi-signature-image::before {\n  content: \"\\F0DFD\";\n}\n\n.mdi-signature-text::before {\n  content: \"\\F0DFE\";\n}\n\n.mdi-silo::before {\n  content: \"\\F0B49\";\n}\n\n.mdi-silverware::before {\n  content: \"\\F04A3\";\n}\n\n.mdi-silverware-clean::before {\n  content: \"\\F0FDE\";\n}\n\n.mdi-silverware-fork::before {\n  content: \"\\F04A4\";\n}\n\n.mdi-silverware-fork-knife::before {\n  content: \"\\F0A70\";\n}\n\n.mdi-silverware-spoon::before {\n  content: \"\\F04A5\";\n}\n\n.mdi-silverware-variant::before {\n  content: \"\\F04A6\";\n}\n\n.mdi-sim::before {\n  content: \"\\F04A7\";\n}\n\n.mdi-sim-alert::before {\n  content: \"\\F04A8\";\n}\n\n.mdi-sim-alert-outline::before {\n  content: \"\\F15D3\";\n}\n\n.mdi-sim-off::before {\n  content: \"\\F04A9\";\n}\n\n.mdi-sim-off-outline::before {\n  content: \"\\F15D4\";\n}\n\n.mdi-sim-outline::before {\n  content: \"\\F15D5\";\n}\n\n.mdi-simple-icons::before {\n  content: \"\\F131D\";\n}\n\n.mdi-sina-weibo::before {\n  content: \"\\F0ADF\";\n}\n\n.mdi-sine-wave::before {\n  content: \"\\F095B\";\n}\n\n.mdi-sitemap::before {\n  content: \"\\F04AA\";\n}\n\n.mdi-sitemap-outline::before {\n  content: \"\\F199C\";\n}\n\n.mdi-size-l::before {\n  content: \"\\F13A6\";\n}\n\n.mdi-size-m::before {\n  content: \"\\F13A5\";\n}\n\n.mdi-size-s::before {\n  content: \"\\F13A4\";\n}\n\n.mdi-size-xl::before {\n  content: \"\\F13A7\";\n}\n\n.mdi-size-xs::before {\n  content: \"\\F13A3\";\n}\n\n.mdi-size-xxl::before {\n  content: \"\\F13A8\";\n}\n\n.mdi-size-xxs::before {\n  content: \"\\F13A2\";\n}\n\n.mdi-size-xxxl::before {\n  content: \"\\F13A9\";\n}\n\n.mdi-skate::before {\n  content: \"\\F0D35\";\n}\n\n.mdi-skate-off::before {\n  content: \"\\F0699\";\n}\n\n.mdi-skateboard::before {\n  content: \"\\F14C2\";\n}\n\n.mdi-skateboarding::before {\n  content: \"\\F0501\";\n}\n\n.mdi-skew-less::before {\n  content: \"\\F0D36\";\n}\n\n.mdi-skew-more::before {\n  content: \"\\F0D37\";\n}\n\n.mdi-ski::before {\n  content: \"\\F1304\";\n}\n\n.mdi-ski-cross-country::before {\n  content: \"\\F1305\";\n}\n\n.mdi-ski-water::before {\n  content: \"\\F1306\";\n}\n\n.mdi-skip-backward::before {\n  content: \"\\F04AB\";\n}\n\n.mdi-skip-backward-outline::before {\n  content: \"\\F0F25\";\n}\n\n.mdi-skip-forward::before {\n  content: \"\\F04AC\";\n}\n\n.mdi-skip-forward-outline::before {\n  content: \"\\F0F26\";\n}\n\n.mdi-skip-next::before {\n  content: \"\\F04AD\";\n}\n\n.mdi-skip-next-circle::before {\n  content: \"\\F0661\";\n}\n\n.mdi-skip-next-circle-outline::before {\n  content: \"\\F0662\";\n}\n\n.mdi-skip-next-outline::before {\n  content: \"\\F0F27\";\n}\n\n.mdi-skip-previous::before {\n  content: \"\\F04AE\";\n}\n\n.mdi-skip-previous-circle::before {\n  content: \"\\F0663\";\n}\n\n.mdi-skip-previous-circle-outline::before {\n  content: \"\\F0664\";\n}\n\n.mdi-skip-previous-outline::before {\n  content: \"\\F0F28\";\n}\n\n.mdi-skull::before {\n  content: \"\\F068C\";\n}\n\n.mdi-skull-crossbones::before {\n  content: \"\\F0BC6\";\n}\n\n.mdi-skull-crossbones-outline::before {\n  content: \"\\F0BC7\";\n}\n\n.mdi-skull-outline::before {\n  content: \"\\F0BC8\";\n}\n\n.mdi-skull-scan::before {\n  content: \"\\F14C7\";\n}\n\n.mdi-skull-scan-outline::before {\n  content: \"\\F14C8\";\n}\n\n.mdi-skype::before {\n  content: \"\\F04AF\";\n}\n\n.mdi-skype-business::before {\n  content: \"\\F04B0\";\n}\n\n.mdi-slack::before {\n  content: \"\\F04B1\";\n}\n\n.mdi-slash-forward::before {\n  content: \"\\F0FDF\";\n}\n\n.mdi-slash-forward-box::before {\n  content: \"\\F0FE0\";\n}\n\n.mdi-sledding::before {\n  content: \"\\F041B\";\n}\n\n.mdi-sleep::before {\n  content: \"\\F04B2\";\n}\n\n.mdi-sleep-off::before {\n  content: \"\\F04B3\";\n}\n\n.mdi-slide::before {\n  content: \"\\F15A5\";\n}\n\n.mdi-slope-downhill::before {\n  content: \"\\F0DFF\";\n}\n\n.mdi-slope-uphill::before {\n  content: \"\\F0E00\";\n}\n\n.mdi-slot-machine::before {\n  content: \"\\F1114\";\n}\n\n.mdi-slot-machine-outline::before {\n  content: \"\\F1115\";\n}\n\n.mdi-smart-card::before {\n  content: \"\\F10BD\";\n}\n\n.mdi-smart-card-off::before {\n  content: \"\\F18F7\";\n}\n\n.mdi-smart-card-off-outline::before {\n  content: \"\\F18F8\";\n}\n\n.mdi-smart-card-outline::before {\n  content: \"\\F10BE\";\n}\n\n.mdi-smart-card-reader::before {\n  content: \"\\F10BF\";\n}\n\n.mdi-smart-card-reader-outline::before {\n  content: \"\\F10C0\";\n}\n\n.mdi-smog::before {\n  content: \"\\F0A71\";\n}\n\n.mdi-smoke::before {\n  content: \"\\F1799\";\n}\n\n.mdi-smoke-detector::before {\n  content: \"\\F0392\";\n}\n\n.mdi-smoke-detector-alert::before {\n  content: \"\\F192E\";\n}\n\n.mdi-smoke-detector-alert-outline::before {\n  content: \"\\F192F\";\n}\n\n.mdi-smoke-detector-off::before {\n  content: \"\\F1809\";\n}\n\n.mdi-smoke-detector-off-outline::before {\n  content: \"\\F180A\";\n}\n\n.mdi-smoke-detector-outline::before {\n  content: \"\\F1808\";\n}\n\n.mdi-smoke-detector-variant::before {\n  content: \"\\F180B\";\n}\n\n.mdi-smoke-detector-variant-alert::before {\n  content: \"\\F1930\";\n}\n\n.mdi-smoke-detector-variant-off::before {\n  content: \"\\F180C\";\n}\n\n.mdi-smoking::before {\n  content: \"\\F04B4\";\n}\n\n.mdi-smoking-off::before {\n  content: \"\\F04B5\";\n}\n\n.mdi-smoking-pipe::before {\n  content: \"\\F140D\";\n}\n\n.mdi-smoking-pipe-off::before {\n  content: \"\\F1428\";\n}\n\n.mdi-snail::before {\n  content: \"\\F1677\";\n}\n\n.mdi-snake::before {\n  content: \"\\F150E\";\n}\n\n.mdi-snapchat::before {\n  content: \"\\F04B6\";\n}\n\n.mdi-snowboard::before {\n  content: \"\\F1307\";\n}\n\n.mdi-snowflake::before {\n  content: \"\\F0717\";\n}\n\n.mdi-snowflake-alert::before {\n  content: \"\\F0F29\";\n}\n\n.mdi-snowflake-melt::before {\n  content: \"\\F12CB\";\n}\n\n.mdi-snowflake-off::before {\n  content: \"\\F14E3\";\n}\n\n.mdi-snowflake-variant::before {\n  content: \"\\F0F2A\";\n}\n\n.mdi-snowman::before {\n  content: \"\\F04B7\";\n}\n\n.mdi-snowmobile::before {\n  content: \"\\F06DD\";\n}\n\n.mdi-soccer::before {\n  content: \"\\F04B8\";\n}\n\n.mdi-soccer-field::before {\n  content: \"\\F0834\";\n}\n\n.mdi-social-distance-2-meters::before {\n  content: \"\\F1579\";\n}\n\n.mdi-social-distance-6-feet::before {\n  content: \"\\F157A\";\n}\n\n.mdi-sofa::before {\n  content: \"\\F04B9\";\n}\n\n.mdi-sofa-outline::before {\n  content: \"\\F156D\";\n}\n\n.mdi-sofa-single::before {\n  content: \"\\F156E\";\n}\n\n.mdi-sofa-single-outline::before {\n  content: \"\\F156F\";\n}\n\n.mdi-solar-panel::before {\n  content: \"\\F0D9B\";\n}\n\n.mdi-solar-panel-large::before {\n  content: \"\\F0D9C\";\n}\n\n.mdi-solar-power::before {\n  content: \"\\F0A72\";\n}\n\n.mdi-soldering-iron::before {\n  content: \"\\F1092\";\n}\n\n.mdi-solid::before {\n  content: \"\\F068D\";\n}\n\n.mdi-sony-playstation::before {\n  content: \"\\F0414\";\n}\n\n.mdi-sort::before {\n  content: \"\\F04BA\";\n}\n\n.mdi-sort-alphabetical-ascending::before {\n  content: \"\\F05BD\";\n}\n\n.mdi-sort-alphabetical-ascending-variant::before {\n  content: \"\\F1148\";\n}\n\n.mdi-sort-alphabetical-descending::before {\n  content: \"\\F05BF\";\n}\n\n.mdi-sort-alphabetical-descending-variant::before {\n  content: \"\\F1149\";\n}\n\n.mdi-sort-alphabetical-variant::before {\n  content: \"\\F04BB\";\n}\n\n.mdi-sort-ascending::before {\n  content: \"\\F04BC\";\n}\n\n.mdi-sort-bool-ascending::before {\n  content: \"\\F1385\";\n}\n\n.mdi-sort-bool-ascending-variant::before {\n  content: \"\\F1386\";\n}\n\n.mdi-sort-bool-descending::before {\n  content: \"\\F1387\";\n}\n\n.mdi-sort-bool-descending-variant::before {\n  content: \"\\F1388\";\n}\n\n.mdi-sort-calendar-ascending::before {\n  content: \"\\F1547\";\n}\n\n.mdi-sort-calendar-descending::before {\n  content: \"\\F1548\";\n}\n\n.mdi-sort-clock-ascending::before {\n  content: \"\\F1549\";\n}\n\n.mdi-sort-clock-ascending-outline::before {\n  content: \"\\F154A\";\n}\n\n.mdi-sort-clock-descending::before {\n  content: \"\\F154B\";\n}\n\n.mdi-sort-clock-descending-outline::before {\n  content: \"\\F154C\";\n}\n\n.mdi-sort-descending::before {\n  content: \"\\F04BD\";\n}\n\n.mdi-sort-numeric-ascending::before {\n  content: \"\\F1389\";\n}\n\n.mdi-sort-numeric-ascending-variant::before {\n  content: \"\\F090D\";\n}\n\n.mdi-sort-numeric-descending::before {\n  content: \"\\F138A\";\n}\n\n.mdi-sort-numeric-descending-variant::before {\n  content: \"\\F0AD2\";\n}\n\n.mdi-sort-numeric-variant::before {\n  content: \"\\F04BE\";\n}\n\n.mdi-sort-reverse-variant::before {\n  content: \"\\F033C\";\n}\n\n.mdi-sort-variant::before {\n  content: \"\\F04BF\";\n}\n\n.mdi-sort-variant-lock::before {\n  content: \"\\F0CCD\";\n}\n\n.mdi-sort-variant-lock-open::before {\n  content: \"\\F0CCE\";\n}\n\n.mdi-sort-variant-remove::before {\n  content: \"\\F1147\";\n}\n\n.mdi-soundbar::before {\n  content: \"\\F17DB\";\n}\n\n.mdi-soundcloud::before {\n  content: \"\\F04C0\";\n}\n\n.mdi-source-branch::before {\n  content: \"\\F062C\";\n}\n\n.mdi-source-branch-check::before {\n  content: \"\\F14CF\";\n}\n\n.mdi-source-branch-minus::before {\n  content: \"\\F14CB\";\n}\n\n.mdi-source-branch-plus::before {\n  content: \"\\F14CA\";\n}\n\n.mdi-source-branch-refresh::before {\n  content: \"\\F14CD\";\n}\n\n.mdi-source-branch-remove::before {\n  content: \"\\F14CC\";\n}\n\n.mdi-source-branch-sync::before {\n  content: \"\\F14CE\";\n}\n\n.mdi-source-commit::before {\n  content: \"\\F0718\";\n}\n\n.mdi-source-commit-end::before {\n  content: \"\\F0719\";\n}\n\n.mdi-source-commit-end-local::before {\n  content: \"\\F071A\";\n}\n\n.mdi-source-commit-local::before {\n  content: \"\\F071B\";\n}\n\n.mdi-source-commit-next-local::before {\n  content: \"\\F071C\";\n}\n\n.mdi-source-commit-start::before {\n  content: \"\\F071D\";\n}\n\n.mdi-source-commit-start-next-local::before {\n  content: \"\\F071E\";\n}\n\n.mdi-source-fork::before {\n  content: \"\\F04C1\";\n}\n\n.mdi-source-merge::before {\n  content: \"\\F062D\";\n}\n\n.mdi-source-pull::before {\n  content: \"\\F04C2\";\n}\n\n.mdi-source-repository::before {\n  content: \"\\F0CCF\";\n}\n\n.mdi-source-repository-multiple::before {\n  content: \"\\F0CD0\";\n}\n\n.mdi-soy-sauce::before {\n  content: \"\\F07EE\";\n}\n\n.mdi-soy-sauce-off::before {\n  content: \"\\F13FC\";\n}\n\n.mdi-spa::before {\n  content: \"\\F0CD1\";\n}\n\n.mdi-spa-outline::before {\n  content: \"\\F0CD2\";\n}\n\n.mdi-space-invaders::before {\n  content: \"\\F0BC9\";\n}\n\n.mdi-space-station::before {\n  content: \"\\F1383\";\n}\n\n.mdi-spade::before {\n  content: \"\\F0E65\";\n}\n\n.mdi-speaker::before {\n  content: \"\\F04C3\";\n}\n\n.mdi-speaker-bluetooth::before {\n  content: \"\\F09A2\";\n}\n\n.mdi-speaker-multiple::before {\n  content: \"\\F0D38\";\n}\n\n.mdi-speaker-off::before {\n  content: \"\\F04C4\";\n}\n\n.mdi-speaker-wireless::before {\n  content: \"\\F071F\";\n}\n\n.mdi-spear::before {\n  content: \"\\F1845\";\n}\n\n.mdi-speedometer::before {\n  content: \"\\F04C5\";\n}\n\n.mdi-speedometer-medium::before {\n  content: \"\\F0F85\";\n}\n\n.mdi-speedometer-slow::before {\n  content: \"\\F0F86\";\n}\n\n.mdi-spellcheck::before {\n  content: \"\\F04C6\";\n}\n\n.mdi-sphere::before {\n  content: \"\\F1954\";\n}\n\n.mdi-sphere-off::before {\n  content: \"\\F1955\";\n}\n\n.mdi-spider::before {\n  content: \"\\F11EA\";\n}\n\n.mdi-spider-thread::before {\n  content: \"\\F11EB\";\n}\n\n.mdi-spider-web::before {\n  content: \"\\F0BCA\";\n}\n\n.mdi-spirit-level::before {\n  content: \"\\F14F1\";\n}\n\n.mdi-spoon-sugar::before {\n  content: \"\\F1429\";\n}\n\n.mdi-spotify::before {\n  content: \"\\F04C7\";\n}\n\n.mdi-spotlight::before {\n  content: \"\\F04C8\";\n}\n\n.mdi-spotlight-beam::before {\n  content: \"\\F04C9\";\n}\n\n.mdi-spray::before {\n  content: \"\\F0665\";\n}\n\n.mdi-spray-bottle::before {\n  content: \"\\F0AE0\";\n}\n\n.mdi-sprinkler::before {\n  content: \"\\F105F\";\n}\n\n.mdi-sprinkler-fire::before {\n  content: \"\\F199D\";\n}\n\n.mdi-sprinkler-variant::before {\n  content: \"\\F1060\";\n}\n\n.mdi-sprout::before {\n  content: \"\\F0E66\";\n}\n\n.mdi-sprout-outline::before {\n  content: \"\\F0E67\";\n}\n\n.mdi-square::before {\n  content: \"\\F0764\";\n}\n\n.mdi-square-circle::before {\n  content: \"\\F1500\";\n}\n\n.mdi-square-edit-outline::before {\n  content: \"\\F090C\";\n}\n\n.mdi-square-medium::before {\n  content: \"\\F0A13\";\n}\n\n.mdi-square-medium-outline::before {\n  content: \"\\F0A14\";\n}\n\n.mdi-square-off::before {\n  content: \"\\F12EE\";\n}\n\n.mdi-square-off-outline::before {\n  content: \"\\F12EF\";\n}\n\n.mdi-square-opacity::before {\n  content: \"\\F1854\";\n}\n\n.mdi-square-outline::before {\n  content: \"\\F0763\";\n}\n\n.mdi-square-root::before {\n  content: \"\\F0784\";\n}\n\n.mdi-square-root-box::before {\n  content: \"\\F09A3\";\n}\n\n.mdi-square-rounded::before {\n  content: \"\\F14FB\";\n}\n\n.mdi-square-rounded-outline::before {\n  content: \"\\F14FC\";\n}\n\n.mdi-square-small::before {\n  content: \"\\F0A15\";\n}\n\n.mdi-square-wave::before {\n  content: \"\\F147B\";\n}\n\n.mdi-squeegee::before {\n  content: \"\\F0AE1\";\n}\n\n.mdi-ssh::before {\n  content: \"\\F08C0\";\n}\n\n.mdi-stack-exchange::before {\n  content: \"\\F060B\";\n}\n\n.mdi-stack-overflow::before {\n  content: \"\\F04CC\";\n}\n\n.mdi-stackpath::before {\n  content: \"\\F0359\";\n}\n\n.mdi-stadium::before {\n  content: \"\\F0FF9\";\n}\n\n.mdi-stadium-variant::before {\n  content: \"\\F0720\";\n}\n\n.mdi-stairs::before {\n  content: \"\\F04CD\";\n}\n\n.mdi-stairs-box::before {\n  content: \"\\F139E\";\n}\n\n.mdi-stairs-down::before {\n  content: \"\\F12BE\";\n}\n\n.mdi-stairs-up::before {\n  content: \"\\F12BD\";\n}\n\n.mdi-stamper::before {\n  content: \"\\F0D39\";\n}\n\n.mdi-standard-definition::before {\n  content: \"\\F07EF\";\n}\n\n.mdi-star::before {\n  content: \"\\F04CE\";\n}\n\n.mdi-star-box::before {\n  content: \"\\F0A73\";\n}\n\n.mdi-star-box-multiple::before {\n  content: \"\\F1286\";\n}\n\n.mdi-star-box-multiple-outline::before {\n  content: \"\\F1287\";\n}\n\n.mdi-star-box-outline::before {\n  content: \"\\F0A74\";\n}\n\n.mdi-star-check::before {\n  content: \"\\F1566\";\n}\n\n.mdi-star-check-outline::before {\n  content: \"\\F156A\";\n}\n\n.mdi-star-circle::before {\n  content: \"\\F04CF\";\n}\n\n.mdi-star-circle-outline::before {\n  content: \"\\F09A4\";\n}\n\n.mdi-star-cog::before {\n  content: \"\\F1668\";\n}\n\n.mdi-star-cog-outline::before {\n  content: \"\\F1669\";\n}\n\n.mdi-star-crescent::before {\n  content: \"\\F0979\";\n}\n\n.mdi-star-david::before {\n  content: \"\\F097A\";\n}\n\n.mdi-star-face::before {\n  content: \"\\F09A5\";\n}\n\n.mdi-star-four-points::before {\n  content: \"\\F0AE2\";\n}\n\n.mdi-star-four-points-outline::before {\n  content: \"\\F0AE3\";\n}\n\n.mdi-star-half::before {\n  content: \"\\F0246\";\n}\n\n.mdi-star-half-full::before {\n  content: \"\\F04D0\";\n}\n\n.mdi-star-minus::before {\n  content: \"\\F1564\";\n}\n\n.mdi-star-minus-outline::before {\n  content: \"\\F1568\";\n}\n\n.mdi-star-off::before {\n  content: \"\\F04D1\";\n}\n\n.mdi-star-off-outline::before {\n  content: \"\\F155B\";\n}\n\n.mdi-star-outline::before {\n  content: \"\\F04D2\";\n}\n\n.mdi-star-plus::before {\n  content: \"\\F1563\";\n}\n\n.mdi-star-plus-outline::before {\n  content: \"\\F1567\";\n}\n\n.mdi-star-remove::before {\n  content: \"\\F1565\";\n}\n\n.mdi-star-remove-outline::before {\n  content: \"\\F1569\";\n}\n\n.mdi-star-settings::before {\n  content: \"\\F166A\";\n}\n\n.mdi-star-settings-outline::before {\n  content: \"\\F166B\";\n}\n\n.mdi-star-shooting::before {\n  content: \"\\F1741\";\n}\n\n.mdi-star-shooting-outline::before {\n  content: \"\\F1742\";\n}\n\n.mdi-star-three-points::before {\n  content: \"\\F0AE4\";\n}\n\n.mdi-star-three-points-outline::before {\n  content: \"\\F0AE5\";\n}\n\n.mdi-state-machine::before {\n  content: \"\\F11EF\";\n}\n\n.mdi-steam::before {\n  content: \"\\F04D3\";\n}\n\n.mdi-steering::before {\n  content: \"\\F04D4\";\n}\n\n.mdi-steering-off::before {\n  content: \"\\F090E\";\n}\n\n.mdi-step-backward::before {\n  content: \"\\F04D5\";\n}\n\n.mdi-step-backward-2::before {\n  content: \"\\F04D6\";\n}\n\n.mdi-step-forward::before {\n  content: \"\\F04D7\";\n}\n\n.mdi-step-forward-2::before {\n  content: \"\\F04D8\";\n}\n\n.mdi-stethoscope::before {\n  content: \"\\F04D9\";\n}\n\n.mdi-sticker::before {\n  content: \"\\F1364\";\n}\n\n.mdi-sticker-alert::before {\n  content: \"\\F1365\";\n}\n\n.mdi-sticker-alert-outline::before {\n  content: \"\\F1366\";\n}\n\n.mdi-sticker-check::before {\n  content: \"\\F1367\";\n}\n\n.mdi-sticker-check-outline::before {\n  content: \"\\F1368\";\n}\n\n.mdi-sticker-circle-outline::before {\n  content: \"\\F05D0\";\n}\n\n.mdi-sticker-emoji::before {\n  content: \"\\F0785\";\n}\n\n.mdi-sticker-minus::before {\n  content: \"\\F1369\";\n}\n\n.mdi-sticker-minus-outline::before {\n  content: \"\\F136A\";\n}\n\n.mdi-sticker-outline::before {\n  content: \"\\F136B\";\n}\n\n.mdi-sticker-plus::before {\n  content: \"\\F136C\";\n}\n\n.mdi-sticker-plus-outline::before {\n  content: \"\\F136D\";\n}\n\n.mdi-sticker-remove::before {\n  content: \"\\F136E\";\n}\n\n.mdi-sticker-remove-outline::before {\n  content: \"\\F136F\";\n}\n\n.mdi-sticker-text::before {\n  content: \"\\F178E\";\n}\n\n.mdi-sticker-text-outline::before {\n  content: \"\\F178F\";\n}\n\n.mdi-stocking::before {\n  content: \"\\F04DA\";\n}\n\n.mdi-stomach::before {\n  content: \"\\F1093\";\n}\n\n.mdi-stool::before {\n  content: \"\\F195D\";\n}\n\n.mdi-stool-outline::before {\n  content: \"\\F195E\";\n}\n\n.mdi-stop::before {\n  content: \"\\F04DB\";\n}\n\n.mdi-stop-circle::before {\n  content: \"\\F0666\";\n}\n\n.mdi-stop-circle-outline::before {\n  content: \"\\F0667\";\n}\n\n.mdi-store::before {\n  content: \"\\F04DC\";\n}\n\n.mdi-store-24-hour::before {\n  content: \"\\F04DD\";\n}\n\n.mdi-store-alert::before {\n  content: \"\\F18C1\";\n}\n\n.mdi-store-alert-outline::before {\n  content: \"\\F18C2\";\n}\n\n.mdi-store-check::before {\n  content: \"\\F18C3\";\n}\n\n.mdi-store-check-outline::before {\n  content: \"\\F18C4\";\n}\n\n.mdi-store-clock::before {\n  content: \"\\F18C5\";\n}\n\n.mdi-store-clock-outline::before {\n  content: \"\\F18C6\";\n}\n\n.mdi-store-cog::before {\n  content: \"\\F18C7\";\n}\n\n.mdi-store-cog-outline::before {\n  content: \"\\F18C8\";\n}\n\n.mdi-store-edit::before {\n  content: \"\\F18C9\";\n}\n\n.mdi-store-edit-outline::before {\n  content: \"\\F18CA\";\n}\n\n.mdi-store-marker::before {\n  content: \"\\F18CB\";\n}\n\n.mdi-store-marker-outline::before {\n  content: \"\\F18CC\";\n}\n\n.mdi-store-minus::before {\n  content: \"\\F165E\";\n}\n\n.mdi-store-minus-outline::before {\n  content: \"\\F18CD\";\n}\n\n.mdi-store-off::before {\n  content: \"\\F18CE\";\n}\n\n.mdi-store-off-outline::before {\n  content: \"\\F18CF\";\n}\n\n.mdi-store-outline::before {\n  content: \"\\F1361\";\n}\n\n.mdi-store-plus::before {\n  content: \"\\F165F\";\n}\n\n.mdi-store-plus-outline::before {\n  content: \"\\F18D0\";\n}\n\n.mdi-store-remove::before {\n  content: \"\\F1660\";\n}\n\n.mdi-store-remove-outline::before {\n  content: \"\\F18D1\";\n}\n\n.mdi-store-search::before {\n  content: \"\\F18D2\";\n}\n\n.mdi-store-search-outline::before {\n  content: \"\\F18D3\";\n}\n\n.mdi-store-settings::before {\n  content: \"\\F18D4\";\n}\n\n.mdi-store-settings-outline::before {\n  content: \"\\F18D5\";\n}\n\n.mdi-storefront::before {\n  content: \"\\F07C7\";\n}\n\n.mdi-storefront-outline::before {\n  content: \"\\F10C1\";\n}\n\n.mdi-stove::before {\n  content: \"\\F04DE\";\n}\n\n.mdi-strategy::before {\n  content: \"\\F11D6\";\n}\n\n.mdi-stretch-to-page::before {\n  content: \"\\F0F2B\";\n}\n\n.mdi-stretch-to-page-outline::before {\n  content: \"\\F0F2C\";\n}\n\n.mdi-string-lights::before {\n  content: \"\\F12BA\";\n}\n\n.mdi-string-lights-off::before {\n  content: \"\\F12BB\";\n}\n\n.mdi-subdirectory-arrow-left::before {\n  content: \"\\F060C\";\n}\n\n.mdi-subdirectory-arrow-right::before {\n  content: \"\\F060D\";\n}\n\n.mdi-submarine::before {\n  content: \"\\F156C\";\n}\n\n.mdi-subtitles::before {\n  content: \"\\F0A16\";\n}\n\n.mdi-subtitles-outline::before {\n  content: \"\\F0A17\";\n}\n\n.mdi-subway::before {\n  content: \"\\F06AC\";\n}\n\n.mdi-subway-alert-variant::before {\n  content: \"\\F0D9D\";\n}\n\n.mdi-subway-variant::before {\n  content: \"\\F04DF\";\n}\n\n.mdi-summit::before {\n  content: \"\\F0786\";\n}\n\n.mdi-sun-compass::before {\n  content: \"\\F19A5\";\n}\n\n.mdi-sun-snowflake::before {\n  content: \"\\F1796\";\n}\n\n.mdi-sun-thermometer::before {\n  content: \"\\F18D6\";\n}\n\n.mdi-sun-thermometer-outline::before {\n  content: \"\\F18D7\";\n}\n\n.mdi-sun-wireless::before {\n  content: \"\\F17FE\";\n}\n\n.mdi-sun-wireless-outline::before {\n  content: \"\\F17FF\";\n}\n\n.mdi-sunglasses::before {\n  content: \"\\F04E0\";\n}\n\n.mdi-surfing::before {\n  content: \"\\F1746\";\n}\n\n.mdi-surround-sound::before {\n  content: \"\\F05C5\";\n}\n\n.mdi-surround-sound-2-0::before {\n  content: \"\\F07F0\";\n}\n\n.mdi-surround-sound-2-1::before {\n  content: \"\\F1729\";\n}\n\n.mdi-surround-sound-3-1::before {\n  content: \"\\F07F1\";\n}\n\n.mdi-surround-sound-5-1::before {\n  content: \"\\F07F2\";\n}\n\n.mdi-surround-sound-5-1-2::before {\n  content: \"\\F172A\";\n}\n\n.mdi-surround-sound-7-1::before {\n  content: \"\\F07F3\";\n}\n\n.mdi-svg::before {\n  content: \"\\F0721\";\n}\n\n.mdi-swap-horizontal::before {\n  content: \"\\F04E1\";\n}\n\n.mdi-swap-horizontal-bold::before {\n  content: \"\\F0BCD\";\n}\n\n.mdi-swap-horizontal-circle::before {\n  content: \"\\F0FE1\";\n}\n\n.mdi-swap-horizontal-circle-outline::before {\n  content: \"\\F0FE2\";\n}\n\n.mdi-swap-horizontal-variant::before {\n  content: \"\\F08C1\";\n}\n\n.mdi-swap-vertical::before {\n  content: \"\\F04E2\";\n}\n\n.mdi-swap-vertical-bold::before {\n  content: \"\\F0BCE\";\n}\n\n.mdi-swap-vertical-circle::before {\n  content: \"\\F0FE3\";\n}\n\n.mdi-swap-vertical-circle-outline::before {\n  content: \"\\F0FE4\";\n}\n\n.mdi-swap-vertical-variant::before {\n  content: \"\\F08C2\";\n}\n\n.mdi-swim::before {\n  content: \"\\F04E3\";\n}\n\n.mdi-switch::before {\n  content: \"\\F04E4\";\n}\n\n.mdi-sword::before {\n  content: \"\\F04E5\";\n}\n\n.mdi-sword-cross::before {\n  content: \"\\F0787\";\n}\n\n.mdi-syllabary-hangul::before {\n  content: \"\\F1333\";\n}\n\n.mdi-syllabary-hiragana::before {\n  content: \"\\F1334\";\n}\n\n.mdi-syllabary-katakana::before {\n  content: \"\\F1335\";\n}\n\n.mdi-syllabary-katakana-halfwidth::before {\n  content: \"\\F1336\";\n}\n\n.mdi-symbol::before {\n  content: \"\\F1501\";\n}\n\n.mdi-symfony::before {\n  content: \"\\F0AE6\";\n}\n\n.mdi-sync::before {\n  content: \"\\F04E6\";\n}\n\n.mdi-sync-alert::before {\n  content: \"\\F04E7\";\n}\n\n.mdi-sync-circle::before {\n  content: \"\\F1378\";\n}\n\n.mdi-sync-off::before {\n  content: \"\\F04E8\";\n}\n\n.mdi-tab::before {\n  content: \"\\F04E9\";\n}\n\n.mdi-tab-minus::before {\n  content: \"\\F0B4B\";\n}\n\n.mdi-tab-plus::before {\n  content: \"\\F075C\";\n}\n\n.mdi-tab-remove::before {\n  content: \"\\F0B4C\";\n}\n\n.mdi-tab-search::before {\n  content: \"\\F199E\";\n}\n\n.mdi-tab-unselected::before {\n  content: \"\\F04EA\";\n}\n\n.mdi-table::before {\n  content: \"\\F04EB\";\n}\n\n.mdi-table-account::before {\n  content: \"\\F13B9\";\n}\n\n.mdi-table-alert::before {\n  content: \"\\F13BA\";\n}\n\n.mdi-table-arrow-down::before {\n  content: \"\\F13BB\";\n}\n\n.mdi-table-arrow-left::before {\n  content: \"\\F13BC\";\n}\n\n.mdi-table-arrow-right::before {\n  content: \"\\F13BD\";\n}\n\n.mdi-table-arrow-up::before {\n  content: \"\\F13BE\";\n}\n\n.mdi-table-border::before {\n  content: \"\\F0A18\";\n}\n\n.mdi-table-cancel::before {\n  content: \"\\F13BF\";\n}\n\n.mdi-table-chair::before {\n  content: \"\\F1061\";\n}\n\n.mdi-table-check::before {\n  content: \"\\F13C0\";\n}\n\n.mdi-table-clock::before {\n  content: \"\\F13C1\";\n}\n\n.mdi-table-cog::before {\n  content: \"\\F13C2\";\n}\n\n.mdi-table-column::before {\n  content: \"\\F0835\";\n}\n\n.mdi-table-column-plus-after::before {\n  content: \"\\F04EC\";\n}\n\n.mdi-table-column-plus-before::before {\n  content: \"\\F04ED\";\n}\n\n.mdi-table-column-remove::before {\n  content: \"\\F04EE\";\n}\n\n.mdi-table-column-width::before {\n  content: \"\\F04EF\";\n}\n\n.mdi-table-edit::before {\n  content: \"\\F04F0\";\n}\n\n.mdi-table-eye::before {\n  content: \"\\F1094\";\n}\n\n.mdi-table-eye-off::before {\n  content: \"\\F13C3\";\n}\n\n.mdi-table-furniture::before {\n  content: \"\\F05BC\";\n}\n\n.mdi-table-headers-eye::before {\n  content: \"\\F121D\";\n}\n\n.mdi-table-headers-eye-off::before {\n  content: \"\\F121E\";\n}\n\n.mdi-table-heart::before {\n  content: \"\\F13C4\";\n}\n\n.mdi-table-key::before {\n  content: \"\\F13C5\";\n}\n\n.mdi-table-large::before {\n  content: \"\\F04F1\";\n}\n\n.mdi-table-large-plus::before {\n  content: \"\\F0F87\";\n}\n\n.mdi-table-large-remove::before {\n  content: \"\\F0F88\";\n}\n\n.mdi-table-lock::before {\n  content: \"\\F13C6\";\n}\n\n.mdi-table-merge-cells::before {\n  content: \"\\F09A6\";\n}\n\n.mdi-table-minus::before {\n  content: \"\\F13C7\";\n}\n\n.mdi-table-multiple::before {\n  content: \"\\F13C8\";\n}\n\n.mdi-table-network::before {\n  content: \"\\F13C9\";\n}\n\n.mdi-table-of-contents::before {\n  content: \"\\F0836\";\n}\n\n.mdi-table-off::before {\n  content: \"\\F13CA\";\n}\n\n.mdi-table-picnic::before {\n  content: \"\\F1743\";\n}\n\n.mdi-table-pivot::before {\n  content: \"\\F183C\";\n}\n\n.mdi-table-plus::before {\n  content: \"\\F0A75\";\n}\n\n.mdi-table-refresh::before {\n  content: \"\\F13A0\";\n}\n\n.mdi-table-remove::before {\n  content: \"\\F0A76\";\n}\n\n.mdi-table-row::before {\n  content: \"\\F0837\";\n}\n\n.mdi-table-row-height::before {\n  content: \"\\F04F2\";\n}\n\n.mdi-table-row-plus-after::before {\n  content: \"\\F04F3\";\n}\n\n.mdi-table-row-plus-before::before {\n  content: \"\\F04F4\";\n}\n\n.mdi-table-row-remove::before {\n  content: \"\\F04F5\";\n}\n\n.mdi-table-search::before {\n  content: \"\\F090F\";\n}\n\n.mdi-table-settings::before {\n  content: \"\\F0838\";\n}\n\n.mdi-table-split-cell::before {\n  content: \"\\F142A\";\n}\n\n.mdi-table-star::before {\n  content: \"\\F13CB\";\n}\n\n.mdi-table-sync::before {\n  content: \"\\F13A1\";\n}\n\n.mdi-table-tennis::before {\n  content: \"\\F0E68\";\n}\n\n.mdi-tablet::before {\n  content: \"\\F04F6\";\n}\n\n.mdi-tablet-android::before {\n  content: \"\\F04F7\";\n}\n\n.mdi-tablet-cellphone::before {\n  content: \"\\F09A7\";\n}\n\n.mdi-tablet-dashboard::before {\n  content: \"\\F0ECE\";\n}\n\n.mdi-taco::before {\n  content: \"\\F0762\";\n}\n\n.mdi-tag::before {\n  content: \"\\F04F9\";\n}\n\n.mdi-tag-arrow-down::before {\n  content: \"\\F172B\";\n}\n\n.mdi-tag-arrow-down-outline::before {\n  content: \"\\F172C\";\n}\n\n.mdi-tag-arrow-left::before {\n  content: \"\\F172D\";\n}\n\n.mdi-tag-arrow-left-outline::before {\n  content: \"\\F172E\";\n}\n\n.mdi-tag-arrow-right::before {\n  content: \"\\F172F\";\n}\n\n.mdi-tag-arrow-right-outline::before {\n  content: \"\\F1730\";\n}\n\n.mdi-tag-arrow-up::before {\n  content: \"\\F1731\";\n}\n\n.mdi-tag-arrow-up-outline::before {\n  content: \"\\F1732\";\n}\n\n.mdi-tag-faces::before {\n  content: \"\\F04FA\";\n}\n\n.mdi-tag-heart::before {\n  content: \"\\F068B\";\n}\n\n.mdi-tag-heart-outline::before {\n  content: \"\\F0BCF\";\n}\n\n.mdi-tag-minus::before {\n  content: \"\\F0910\";\n}\n\n.mdi-tag-minus-outline::before {\n  content: \"\\F121F\";\n}\n\n.mdi-tag-multiple::before {\n  content: \"\\F04FB\";\n}\n\n.mdi-tag-multiple-outline::before {\n  content: \"\\F12F7\";\n}\n\n.mdi-tag-off::before {\n  content: \"\\F1220\";\n}\n\n.mdi-tag-off-outline::before {\n  content: \"\\F1221\";\n}\n\n.mdi-tag-outline::before {\n  content: \"\\F04FC\";\n}\n\n.mdi-tag-plus::before {\n  content: \"\\F0722\";\n}\n\n.mdi-tag-plus-outline::before {\n  content: \"\\F1222\";\n}\n\n.mdi-tag-remove::before {\n  content: \"\\F0723\";\n}\n\n.mdi-tag-remove-outline::before {\n  content: \"\\F1223\";\n}\n\n.mdi-tag-search::before {\n  content: \"\\F1907\";\n}\n\n.mdi-tag-search-outline::before {\n  content: \"\\F1908\";\n}\n\n.mdi-tag-text::before {\n  content: \"\\F1224\";\n}\n\n.mdi-tag-text-outline::before {\n  content: \"\\F04FD\";\n}\n\n.mdi-tailwind::before {\n  content: \"\\F13FF\";\n}\n\n.mdi-tangram::before {\n  content: \"\\F04F8\";\n}\n\n.mdi-tank::before {\n  content: \"\\F0D3A\";\n}\n\n.mdi-tanker-truck::before {\n  content: \"\\F0FE5\";\n}\n\n.mdi-tape-drive::before {\n  content: \"\\F16DF\";\n}\n\n.mdi-tape-measure::before {\n  content: \"\\F0B4D\";\n}\n\n.mdi-target::before {\n  content: \"\\F04FE\";\n}\n\n.mdi-target-account::before {\n  content: \"\\F0BD0\";\n}\n\n.mdi-target-variant::before {\n  content: \"\\F0A77\";\n}\n\n.mdi-taxi::before {\n  content: \"\\F04FF\";\n}\n\n.mdi-tea::before {\n  content: \"\\F0D9E\";\n}\n\n.mdi-tea-outline::before {\n  content: \"\\F0D9F\";\n}\n\n.mdi-teamviewer::before {\n  content: \"\\F0500\";\n}\n\n.mdi-teddy-bear::before {\n  content: \"\\F18FB\";\n}\n\n.mdi-telescope::before {\n  content: \"\\F0B4E\";\n}\n\n.mdi-television::before {\n  content: \"\\F0502\";\n}\n\n.mdi-television-ambient-light::before {\n  content: \"\\F1356\";\n}\n\n.mdi-television-box::before {\n  content: \"\\F0839\";\n}\n\n.mdi-television-classic::before {\n  content: \"\\F07F4\";\n}\n\n.mdi-television-classic-off::before {\n  content: \"\\F083A\";\n}\n\n.mdi-television-guide::before {\n  content: \"\\F0503\";\n}\n\n.mdi-television-off::before {\n  content: \"\\F083B\";\n}\n\n.mdi-television-pause::before {\n  content: \"\\F0F89\";\n}\n\n.mdi-television-play::before {\n  content: \"\\F0ECF\";\n}\n\n.mdi-television-shimmer::before {\n  content: \"\\F1110\";\n}\n\n.mdi-television-stop::before {\n  content: \"\\F0F8A\";\n}\n\n.mdi-temperature-celsius::before {\n  content: \"\\F0504\";\n}\n\n.mdi-temperature-fahrenheit::before {\n  content: \"\\F0505\";\n}\n\n.mdi-temperature-kelvin::before {\n  content: \"\\F0506\";\n}\n\n.mdi-tennis::before {\n  content: \"\\F0DA0\";\n}\n\n.mdi-tennis-ball::before {\n  content: \"\\F0507\";\n}\n\n.mdi-tent::before {\n  content: \"\\F0508\";\n}\n\n.mdi-terraform::before {\n  content: \"\\F1062\";\n}\n\n.mdi-terrain::before {\n  content: \"\\F0509\";\n}\n\n.mdi-test-tube::before {\n  content: \"\\F0668\";\n}\n\n.mdi-test-tube-empty::before {\n  content: \"\\F0911\";\n}\n\n.mdi-test-tube-off::before {\n  content: \"\\F0912\";\n}\n\n.mdi-text::before {\n  content: \"\\F09A8\";\n}\n\n.mdi-text-account::before {\n  content: \"\\F1570\";\n}\n\n.mdi-text-box::before {\n  content: \"\\F021A\";\n}\n\n.mdi-text-box-check::before {\n  content: \"\\F0EA6\";\n}\n\n.mdi-text-box-check-outline::before {\n  content: \"\\F0EA7\";\n}\n\n.mdi-text-box-minus::before {\n  content: \"\\F0EA8\";\n}\n\n.mdi-text-box-minus-outline::before {\n  content: \"\\F0EA9\";\n}\n\n.mdi-text-box-multiple::before {\n  content: \"\\F0AB7\";\n}\n\n.mdi-text-box-multiple-outline::before {\n  content: \"\\F0AB8\";\n}\n\n.mdi-text-box-outline::before {\n  content: \"\\F09ED\";\n}\n\n.mdi-text-box-plus::before {\n  content: \"\\F0EAA\";\n}\n\n.mdi-text-box-plus-outline::before {\n  content: \"\\F0EAB\";\n}\n\n.mdi-text-box-remove::before {\n  content: \"\\F0EAC\";\n}\n\n.mdi-text-box-remove-outline::before {\n  content: \"\\F0EAD\";\n}\n\n.mdi-text-box-search::before {\n  content: \"\\F0EAE\";\n}\n\n.mdi-text-box-search-outline::before {\n  content: \"\\F0EAF\";\n}\n\n.mdi-text-long::before {\n  content: \"\\F09AA\";\n}\n\n.mdi-text-recognition::before {\n  content: \"\\F113D\";\n}\n\n.mdi-text-search::before {\n  content: \"\\F13B8\";\n}\n\n.mdi-text-shadow::before {\n  content: \"\\F0669\";\n}\n\n.mdi-text-short::before {\n  content: \"\\F09A9\";\n}\n\n.mdi-text-to-speech::before {\n  content: \"\\F050A\";\n}\n\n.mdi-text-to-speech-off::before {\n  content: \"\\F050B\";\n}\n\n.mdi-texture::before {\n  content: \"\\F050C\";\n}\n\n.mdi-texture-box::before {\n  content: \"\\F0FE6\";\n}\n\n.mdi-theater::before {\n  content: \"\\F050D\";\n}\n\n.mdi-theme-light-dark::before {\n  content: \"\\F050E\";\n}\n\n.mdi-thermometer::before {\n  content: \"\\F050F\";\n}\n\n.mdi-thermometer-alert::before {\n  content: \"\\F0E01\";\n}\n\n.mdi-thermometer-bluetooth::before {\n  content: \"\\F1895\";\n}\n\n.mdi-thermometer-chevron-down::before {\n  content: \"\\F0E02\";\n}\n\n.mdi-thermometer-chevron-up::before {\n  content: \"\\F0E03\";\n}\n\n.mdi-thermometer-high::before {\n  content: \"\\F10C2\";\n}\n\n.mdi-thermometer-lines::before {\n  content: \"\\F0510\";\n}\n\n.mdi-thermometer-low::before {\n  content: \"\\F10C3\";\n}\n\n.mdi-thermometer-minus::before {\n  content: \"\\F0E04\";\n}\n\n.mdi-thermometer-off::before {\n  content: \"\\F1531\";\n}\n\n.mdi-thermometer-plus::before {\n  content: \"\\F0E05\";\n}\n\n.mdi-thermostat::before {\n  content: \"\\F0393\";\n}\n\n.mdi-thermostat-box::before {\n  content: \"\\F0891\";\n}\n\n.mdi-thought-bubble::before {\n  content: \"\\F07F6\";\n}\n\n.mdi-thought-bubble-outline::before {\n  content: \"\\F07F7\";\n}\n\n.mdi-thumb-down::before {\n  content: \"\\F0511\";\n}\n\n.mdi-thumb-down-outline::before {\n  content: \"\\F0512\";\n}\n\n.mdi-thumb-up::before {\n  content: \"\\F0513\";\n}\n\n.mdi-thumb-up-outline::before {\n  content: \"\\F0514\";\n}\n\n.mdi-thumbs-up-down::before {\n  content: \"\\F0515\";\n}\n\n.mdi-thumbs-up-down-outline::before {\n  content: \"\\F1914\";\n}\n\n.mdi-ticket::before {\n  content: \"\\F0516\";\n}\n\n.mdi-ticket-account::before {\n  content: \"\\F0517\";\n}\n\n.mdi-ticket-confirmation::before {\n  content: \"\\F0518\";\n}\n\n.mdi-ticket-confirmation-outline::before {\n  content: \"\\F13AA\";\n}\n\n.mdi-ticket-outline::before {\n  content: \"\\F0913\";\n}\n\n.mdi-ticket-percent::before {\n  content: \"\\F0724\";\n}\n\n.mdi-ticket-percent-outline::before {\n  content: \"\\F142B\";\n}\n\n.mdi-tie::before {\n  content: \"\\F0519\";\n}\n\n.mdi-tilde::before {\n  content: \"\\F0725\";\n}\n\n.mdi-tilde-off::before {\n  content: \"\\F18F3\";\n}\n\n.mdi-timelapse::before {\n  content: \"\\F051A\";\n}\n\n.mdi-timeline::before {\n  content: \"\\F0BD1\";\n}\n\n.mdi-timeline-alert::before {\n  content: \"\\F0F95\";\n}\n\n.mdi-timeline-alert-outline::before {\n  content: \"\\F0F98\";\n}\n\n.mdi-timeline-check::before {\n  content: \"\\F1532\";\n}\n\n.mdi-timeline-check-outline::before {\n  content: \"\\F1533\";\n}\n\n.mdi-timeline-clock::before {\n  content: \"\\F11FB\";\n}\n\n.mdi-timeline-clock-outline::before {\n  content: \"\\F11FC\";\n}\n\n.mdi-timeline-help::before {\n  content: \"\\F0F99\";\n}\n\n.mdi-timeline-help-outline::before {\n  content: \"\\F0F9A\";\n}\n\n.mdi-timeline-minus::before {\n  content: \"\\F1534\";\n}\n\n.mdi-timeline-minus-outline::before {\n  content: \"\\F1535\";\n}\n\n.mdi-timeline-outline::before {\n  content: \"\\F0BD2\";\n}\n\n.mdi-timeline-plus::before {\n  content: \"\\F0F96\";\n}\n\n.mdi-timeline-plus-outline::before {\n  content: \"\\F0F97\";\n}\n\n.mdi-timeline-remove::before {\n  content: \"\\F1536\";\n}\n\n.mdi-timeline-remove-outline::before {\n  content: \"\\F1537\";\n}\n\n.mdi-timeline-text::before {\n  content: \"\\F0BD3\";\n}\n\n.mdi-timeline-text-outline::before {\n  content: \"\\F0BD4\";\n}\n\n.mdi-timer::before {\n  content: \"\\F13AB\";\n}\n\n.mdi-timer-10::before {\n  content: \"\\F051C\";\n}\n\n.mdi-timer-3::before {\n  content: \"\\F051D\";\n}\n\n.mdi-timer-cog::before {\n  content: \"\\F1925\";\n}\n\n.mdi-timer-cog-outline::before {\n  content: \"\\F1926\";\n}\n\n.mdi-timer-off::before {\n  content: \"\\F13AC\";\n}\n\n.mdi-timer-off-outline::before {\n  content: \"\\F051E\";\n}\n\n.mdi-timer-outline::before {\n  content: \"\\F051B\";\n}\n\n.mdi-timer-sand::before {\n  content: \"\\F051F\";\n}\n\n.mdi-timer-sand-complete::before {\n  content: \"\\F199F\";\n}\n\n.mdi-timer-sand-empty::before {\n  content: \"\\F06AD\";\n}\n\n.mdi-timer-sand-full::before {\n  content: \"\\F078C\";\n}\n\n.mdi-timer-sand-paused::before {\n  content: \"\\F19A0\";\n}\n\n.mdi-timer-settings::before {\n  content: \"\\F1923\";\n}\n\n.mdi-timer-settings-outline::before {\n  content: \"\\F1924\";\n}\n\n.mdi-timetable::before {\n  content: \"\\F0520\";\n}\n\n.mdi-tire::before {\n  content: \"\\F1896\";\n}\n\n.mdi-toaster::before {\n  content: \"\\F1063\";\n}\n\n.mdi-toaster-off::before {\n  content: \"\\F11B7\";\n}\n\n.mdi-toaster-oven::before {\n  content: \"\\F0CD3\";\n}\n\n.mdi-toggle-switch::before {\n  content: \"\\F0521\";\n}\n\n.mdi-toggle-switch-off::before {\n  content: \"\\F0522\";\n}\n\n.mdi-toggle-switch-off-outline::before {\n  content: \"\\F0A19\";\n}\n\n.mdi-toggle-switch-outline::before {\n  content: \"\\F0A1A\";\n}\n\n.mdi-toilet::before {\n  content: \"\\F09AB\";\n}\n\n.mdi-toolbox::before {\n  content: \"\\F09AC\";\n}\n\n.mdi-toolbox-outline::before {\n  content: \"\\F09AD\";\n}\n\n.mdi-tools::before {\n  content: \"\\F1064\";\n}\n\n.mdi-tooltip::before {\n  content: \"\\F0523\";\n}\n\n.mdi-tooltip-account::before {\n  content: \"\\F000C\";\n}\n\n.mdi-tooltip-cellphone::before {\n  content: \"\\F183B\";\n}\n\n.mdi-tooltip-check::before {\n  content: \"\\F155C\";\n}\n\n.mdi-tooltip-check-outline::before {\n  content: \"\\F155D\";\n}\n\n.mdi-tooltip-edit::before {\n  content: \"\\F0524\";\n}\n\n.mdi-tooltip-edit-outline::before {\n  content: \"\\F12C5\";\n}\n\n.mdi-tooltip-image::before {\n  content: \"\\F0525\";\n}\n\n.mdi-tooltip-image-outline::before {\n  content: \"\\F0BD5\";\n}\n\n.mdi-tooltip-minus::before {\n  content: \"\\F155E\";\n}\n\n.mdi-tooltip-minus-outline::before {\n  content: \"\\F155F\";\n}\n\n.mdi-tooltip-outline::before {\n  content: \"\\F0526\";\n}\n\n.mdi-tooltip-plus::before {\n  content: \"\\F0BD6\";\n}\n\n.mdi-tooltip-plus-outline::before {\n  content: \"\\F0527\";\n}\n\n.mdi-tooltip-remove::before {\n  content: \"\\F1560\";\n}\n\n.mdi-tooltip-remove-outline::before {\n  content: \"\\F1561\";\n}\n\n.mdi-tooltip-text::before {\n  content: \"\\F0528\";\n}\n\n.mdi-tooltip-text-outline::before {\n  content: \"\\F0BD7\";\n}\n\n.mdi-tooth::before {\n  content: \"\\F08C3\";\n}\n\n.mdi-tooth-outline::before {\n  content: \"\\F0529\";\n}\n\n.mdi-toothbrush::before {\n  content: \"\\F1129\";\n}\n\n.mdi-toothbrush-electric::before {\n  content: \"\\F112C\";\n}\n\n.mdi-toothbrush-paste::before {\n  content: \"\\F112A\";\n}\n\n.mdi-torch::before {\n  content: \"\\F1606\";\n}\n\n.mdi-tortoise::before {\n  content: \"\\F0D3B\";\n}\n\n.mdi-toslink::before {\n  content: \"\\F12B8\";\n}\n\n.mdi-tournament::before {\n  content: \"\\F09AE\";\n}\n\n.mdi-tow-truck::before {\n  content: \"\\F083C\";\n}\n\n.mdi-tower-beach::before {\n  content: \"\\F0681\";\n}\n\n.mdi-tower-fire::before {\n  content: \"\\F0682\";\n}\n\n.mdi-town-hall::before {\n  content: \"\\F1875\";\n}\n\n.mdi-toy-brick::before {\n  content: \"\\F1288\";\n}\n\n.mdi-toy-brick-marker::before {\n  content: \"\\F1289\";\n}\n\n.mdi-toy-brick-marker-outline::before {\n  content: \"\\F128A\";\n}\n\n.mdi-toy-brick-minus::before {\n  content: \"\\F128B\";\n}\n\n.mdi-toy-brick-minus-outline::before {\n  content: \"\\F128C\";\n}\n\n.mdi-toy-brick-outline::before {\n  content: \"\\F128D\";\n}\n\n.mdi-toy-brick-plus::before {\n  content: \"\\F128E\";\n}\n\n.mdi-toy-brick-plus-outline::before {\n  content: \"\\F128F\";\n}\n\n.mdi-toy-brick-remove::before {\n  content: \"\\F1290\";\n}\n\n.mdi-toy-brick-remove-outline::before {\n  content: \"\\F1291\";\n}\n\n.mdi-toy-brick-search::before {\n  content: \"\\F1292\";\n}\n\n.mdi-toy-brick-search-outline::before {\n  content: \"\\F1293\";\n}\n\n.mdi-track-light::before {\n  content: \"\\F0914\";\n}\n\n.mdi-trackpad::before {\n  content: \"\\F07F8\";\n}\n\n.mdi-trackpad-lock::before {\n  content: \"\\F0933\";\n}\n\n.mdi-tractor::before {\n  content: \"\\F0892\";\n}\n\n.mdi-tractor-variant::before {\n  content: \"\\F14C4\";\n}\n\n.mdi-trademark::before {\n  content: \"\\F0A78\";\n}\n\n.mdi-traffic-cone::before {\n  content: \"\\F137C\";\n}\n\n.mdi-traffic-light::before {\n  content: \"\\F052B\";\n}\n\n.mdi-traffic-light-outline::before {\n  content: \"\\F182A\";\n}\n\n.mdi-train::before {\n  content: \"\\F052C\";\n}\n\n.mdi-train-car::before {\n  content: \"\\F0BD8\";\n}\n\n.mdi-train-car-passenger::before {\n  content: \"\\F1733\";\n}\n\n.mdi-train-car-passenger-door::before {\n  content: \"\\F1734\";\n}\n\n.mdi-train-car-passenger-door-open::before {\n  content: \"\\F1735\";\n}\n\n.mdi-train-car-passenger-variant::before {\n  content: \"\\F1736\";\n}\n\n.mdi-train-variant::before {\n  content: \"\\F08C4\";\n}\n\n.mdi-tram::before {\n  content: \"\\F052D\";\n}\n\n.mdi-tram-side::before {\n  content: \"\\F0FE7\";\n}\n\n.mdi-transcribe::before {\n  content: \"\\F052E\";\n}\n\n.mdi-transcribe-close::before {\n  content: \"\\F052F\";\n}\n\n.mdi-transfer::before {\n  content: \"\\F1065\";\n}\n\n.mdi-transfer-down::before {\n  content: \"\\F0DA1\";\n}\n\n.mdi-transfer-left::before {\n  content: \"\\F0DA2\";\n}\n\n.mdi-transfer-right::before {\n  content: \"\\F0530\";\n}\n\n.mdi-transfer-up::before {\n  content: \"\\F0DA3\";\n}\n\n.mdi-transit-connection::before {\n  content: \"\\F0D3C\";\n}\n\n.mdi-transit-connection-horizontal::before {\n  content: \"\\F1546\";\n}\n\n.mdi-transit-connection-variant::before {\n  content: \"\\F0D3D\";\n}\n\n.mdi-transit-detour::before {\n  content: \"\\F0F8B\";\n}\n\n.mdi-transit-skip::before {\n  content: \"\\F1515\";\n}\n\n.mdi-transit-transfer::before {\n  content: \"\\F06AE\";\n}\n\n.mdi-transition::before {\n  content: \"\\F0915\";\n}\n\n.mdi-transition-masked::before {\n  content: \"\\F0916\";\n}\n\n.mdi-translate::before {\n  content: \"\\F05CA\";\n}\n\n.mdi-translate-off::before {\n  content: \"\\F0E06\";\n}\n\n.mdi-transmission-tower::before {\n  content: \"\\F0D3E\";\n}\n\n.mdi-transmission-tower-export::before {\n  content: \"\\F192C\";\n}\n\n.mdi-transmission-tower-import::before {\n  content: \"\\F192D\";\n}\n\n.mdi-trash-can::before {\n  content: \"\\F0A79\";\n}\n\n.mdi-trash-can-outline::before {\n  content: \"\\F0A7A\";\n}\n\n.mdi-tray::before {\n  content: \"\\F1294\";\n}\n\n.mdi-tray-alert::before {\n  content: \"\\F1295\";\n}\n\n.mdi-tray-arrow-down::before {\n  content: \"\\F0120\";\n}\n\n.mdi-tray-arrow-up::before {\n  content: \"\\F011D\";\n}\n\n.mdi-tray-full::before {\n  content: \"\\F1296\";\n}\n\n.mdi-tray-minus::before {\n  content: \"\\F1297\";\n}\n\n.mdi-tray-plus::before {\n  content: \"\\F1298\";\n}\n\n.mdi-tray-remove::before {\n  content: \"\\F1299\";\n}\n\n.mdi-treasure-chest::before {\n  content: \"\\F0726\";\n}\n\n.mdi-tree::before {\n  content: \"\\F0531\";\n}\n\n.mdi-tree-outline::before {\n  content: \"\\F0E69\";\n}\n\n.mdi-trello::before {\n  content: \"\\F0532\";\n}\n\n.mdi-trending-down::before {\n  content: \"\\F0533\";\n}\n\n.mdi-trending-neutral::before {\n  content: \"\\F0534\";\n}\n\n.mdi-trending-up::before {\n  content: \"\\F0535\";\n}\n\n.mdi-triangle::before {\n  content: \"\\F0536\";\n}\n\n.mdi-triangle-outline::before {\n  content: \"\\F0537\";\n}\n\n.mdi-triangle-wave::before {\n  content: \"\\F147C\";\n}\n\n.mdi-triforce::before {\n  content: \"\\F0BD9\";\n}\n\n.mdi-trophy::before {\n  content: \"\\F0538\";\n}\n\n.mdi-trophy-award::before {\n  content: \"\\F0539\";\n}\n\n.mdi-trophy-broken::before {\n  content: \"\\F0DA4\";\n}\n\n.mdi-trophy-outline::before {\n  content: \"\\F053A\";\n}\n\n.mdi-trophy-variant::before {\n  content: \"\\F053B\";\n}\n\n.mdi-trophy-variant-outline::before {\n  content: \"\\F053C\";\n}\n\n.mdi-truck::before {\n  content: \"\\F053D\";\n}\n\n.mdi-truck-cargo-container::before {\n  content: \"\\F18D8\";\n}\n\n.mdi-truck-check::before {\n  content: \"\\F0CD4\";\n}\n\n.mdi-truck-check-outline::before {\n  content: \"\\F129A\";\n}\n\n.mdi-truck-delivery::before {\n  content: \"\\F053E\";\n}\n\n.mdi-truck-delivery-outline::before {\n  content: \"\\F129B\";\n}\n\n.mdi-truck-fast::before {\n  content: \"\\F0788\";\n}\n\n.mdi-truck-fast-outline::before {\n  content: \"\\F129C\";\n}\n\n.mdi-truck-flatbed::before {\n  content: \"\\F1891\";\n}\n\n.mdi-truck-minus::before {\n  content: \"\\F19AE\";\n}\n\n.mdi-truck-minus-outline::before {\n  content: \"\\F19BD\";\n}\n\n.mdi-truck-outline::before {\n  content: \"\\F129D\";\n}\n\n.mdi-truck-plus::before {\n  content: \"\\F19AD\";\n}\n\n.mdi-truck-plus-outline::before {\n  content: \"\\F19BC\";\n}\n\n.mdi-truck-remove::before {\n  content: \"\\F19AF\";\n}\n\n.mdi-truck-remove-outline::before {\n  content: \"\\F19BE\";\n}\n\n.mdi-truck-snowflake::before {\n  content: \"\\F19A6\";\n}\n\n.mdi-truck-trailer::before {\n  content: \"\\F0727\";\n}\n\n.mdi-trumpet::before {\n  content: \"\\F1096\";\n}\n\n.mdi-tshirt-crew::before {\n  content: \"\\F0A7B\";\n}\n\n.mdi-tshirt-crew-outline::before {\n  content: \"\\F053F\";\n}\n\n.mdi-tshirt-v::before {\n  content: \"\\F0A7C\";\n}\n\n.mdi-tshirt-v-outline::before {\n  content: \"\\F0540\";\n}\n\n.mdi-tumble-dryer::before {\n  content: \"\\F0917\";\n}\n\n.mdi-tumble-dryer-alert::before {\n  content: \"\\F11BA\";\n}\n\n.mdi-tumble-dryer-off::before {\n  content: \"\\F11BB\";\n}\n\n.mdi-tune::before {\n  content: \"\\F062E\";\n}\n\n.mdi-tune-variant::before {\n  content: \"\\F1542\";\n}\n\n.mdi-tune-vertical::before {\n  content: \"\\F066A\";\n}\n\n.mdi-tune-vertical-variant::before {\n  content: \"\\F1543\";\n}\n\n.mdi-tunnel::before {\n  content: \"\\F183D\";\n}\n\n.mdi-tunnel-outline::before {\n  content: \"\\F183E\";\n}\n\n.mdi-turkey::before {\n  content: \"\\F171B\";\n}\n\n.mdi-turnstile::before {\n  content: \"\\F0CD5\";\n}\n\n.mdi-turnstile-outline::before {\n  content: \"\\F0CD6\";\n}\n\n.mdi-turtle::before {\n  content: \"\\F0CD7\";\n}\n\n.mdi-twitch::before {\n  content: \"\\F0543\";\n}\n\n.mdi-twitter::before {\n  content: \"\\F0544\";\n}\n\n.mdi-two-factor-authentication::before {\n  content: \"\\F09AF\";\n}\n\n.mdi-typewriter::before {\n  content: \"\\F0F2D\";\n}\n\n.mdi-ubisoft::before {\n  content: \"\\F0BDA\";\n}\n\n.mdi-ubuntu::before {\n  content: \"\\F0548\";\n}\n\n.mdi-ufo::before {\n  content: \"\\F10C4\";\n}\n\n.mdi-ufo-outline::before {\n  content: \"\\F10C5\";\n}\n\n.mdi-ultra-high-definition::before {\n  content: \"\\F07F9\";\n}\n\n.mdi-umbraco::before {\n  content: \"\\F0549\";\n}\n\n.mdi-umbrella::before {\n  content: \"\\F054A\";\n}\n\n.mdi-umbrella-beach::before {\n  content: \"\\F188A\";\n}\n\n.mdi-umbrella-beach-outline::before {\n  content: \"\\F188B\";\n}\n\n.mdi-umbrella-closed::before {\n  content: \"\\F09B0\";\n}\n\n.mdi-umbrella-closed-outline::before {\n  content: \"\\F13E2\";\n}\n\n.mdi-umbrella-closed-variant::before {\n  content: \"\\F13E1\";\n}\n\n.mdi-umbrella-outline::before {\n  content: \"\\F054B\";\n}\n\n.mdi-undo::before {\n  content: \"\\F054C\";\n}\n\n.mdi-undo-variant::before {\n  content: \"\\F054D\";\n}\n\n.mdi-unfold-less-horizontal::before {\n  content: \"\\F054E\";\n}\n\n.mdi-unfold-less-vertical::before {\n  content: \"\\F0760\";\n}\n\n.mdi-unfold-more-horizontal::before {\n  content: \"\\F054F\";\n}\n\n.mdi-unfold-more-vertical::before {\n  content: \"\\F0761\";\n}\n\n.mdi-ungroup::before {\n  content: \"\\F0550\";\n}\n\n.mdi-unicode::before {\n  content: \"\\F0ED0\";\n}\n\n.mdi-unicorn::before {\n  content: \"\\F15C2\";\n}\n\n.mdi-unicorn-variant::before {\n  content: \"\\F15C3\";\n}\n\n.mdi-unicycle::before {\n  content: \"\\F15E5\";\n}\n\n.mdi-unity::before {\n  content: \"\\F06AF\";\n}\n\n.mdi-unreal::before {\n  content: \"\\F09B1\";\n}\n\n.mdi-update::before {\n  content: \"\\F06B0\";\n}\n\n.mdi-upload::before {\n  content: \"\\F0552\";\n}\n\n.mdi-upload-lock::before {\n  content: \"\\F1373\";\n}\n\n.mdi-upload-lock-outline::before {\n  content: \"\\F1374\";\n}\n\n.mdi-upload-multiple::before {\n  content: \"\\F083D\";\n}\n\n.mdi-upload-network::before {\n  content: \"\\F06F6\";\n}\n\n.mdi-upload-network-outline::before {\n  content: \"\\F0CD8\";\n}\n\n.mdi-upload-off::before {\n  content: \"\\F10C6\";\n}\n\n.mdi-upload-off-outline::before {\n  content: \"\\F10C7\";\n}\n\n.mdi-upload-outline::before {\n  content: \"\\F0E07\";\n}\n\n.mdi-usb::before {\n  content: \"\\F0553\";\n}\n\n.mdi-usb-flash-drive::before {\n  content: \"\\F129E\";\n}\n\n.mdi-usb-flash-drive-outline::before {\n  content: \"\\F129F\";\n}\n\n.mdi-usb-port::before {\n  content: \"\\F11F0\";\n}\n\n.mdi-vacuum::before {\n  content: \"\\F19A1\";\n}\n\n.mdi-vacuum-outline::before {\n  content: \"\\F19A2\";\n}\n\n.mdi-valve::before {\n  content: \"\\F1066\";\n}\n\n.mdi-valve-closed::before {\n  content: \"\\F1067\";\n}\n\n.mdi-valve-open::before {\n  content: \"\\F1068\";\n}\n\n.mdi-van-passenger::before {\n  content: \"\\F07FA\";\n}\n\n.mdi-van-utility::before {\n  content: \"\\F07FB\";\n}\n\n.mdi-vanish::before {\n  content: \"\\F07FC\";\n}\n\n.mdi-vanish-quarter::before {\n  content: \"\\F1554\";\n}\n\n.mdi-vanity-light::before {\n  content: \"\\F11E1\";\n}\n\n.mdi-variable::before {\n  content: \"\\F0AE7\";\n}\n\n.mdi-variable-box::before {\n  content: \"\\F1111\";\n}\n\n.mdi-vector-arrange-above::before {\n  content: \"\\F0554\";\n}\n\n.mdi-vector-arrange-below::before {\n  content: \"\\F0555\";\n}\n\n.mdi-vector-bezier::before {\n  content: \"\\F0AE8\";\n}\n\n.mdi-vector-circle::before {\n  content: \"\\F0556\";\n}\n\n.mdi-vector-circle-variant::before {\n  content: \"\\F0557\";\n}\n\n.mdi-vector-combine::before {\n  content: \"\\F0558\";\n}\n\n.mdi-vector-curve::before {\n  content: \"\\F0559\";\n}\n\n.mdi-vector-difference::before {\n  content: \"\\F055A\";\n}\n\n.mdi-vector-difference-ab::before {\n  content: \"\\F055B\";\n}\n\n.mdi-vector-difference-ba::before {\n  content: \"\\F055C\";\n}\n\n.mdi-vector-ellipse::before {\n  content: \"\\F0893\";\n}\n\n.mdi-vector-intersection::before {\n  content: \"\\F055D\";\n}\n\n.mdi-vector-line::before {\n  content: \"\\F055E\";\n}\n\n.mdi-vector-link::before {\n  content: \"\\F0FE8\";\n}\n\n.mdi-vector-point::before {\n  content: \"\\F055F\";\n}\n\n.mdi-vector-polygon::before {\n  content: \"\\F0560\";\n}\n\n.mdi-vector-polygon-variant::before {\n  content: \"\\F1856\";\n}\n\n.mdi-vector-polyline::before {\n  content: \"\\F0561\";\n}\n\n.mdi-vector-polyline-edit::before {\n  content: \"\\F1225\";\n}\n\n.mdi-vector-polyline-minus::before {\n  content: \"\\F1226\";\n}\n\n.mdi-vector-polyline-plus::before {\n  content: \"\\F1227\";\n}\n\n.mdi-vector-polyline-remove::before {\n  content: \"\\F1228\";\n}\n\n.mdi-vector-radius::before {\n  content: \"\\F074A\";\n}\n\n.mdi-vector-rectangle::before {\n  content: \"\\F05C6\";\n}\n\n.mdi-vector-selection::before {\n  content: \"\\F0562\";\n}\n\n.mdi-vector-square::before {\n  content: \"\\F0001\";\n}\n\n.mdi-vector-square-close::before {\n  content: \"\\F1857\";\n}\n\n.mdi-vector-square-edit::before {\n  content: \"\\F18D9\";\n}\n\n.mdi-vector-square-minus::before {\n  content: \"\\F18DA\";\n}\n\n.mdi-vector-square-open::before {\n  content: \"\\F1858\";\n}\n\n.mdi-vector-square-plus::before {\n  content: \"\\F18DB\";\n}\n\n.mdi-vector-square-remove::before {\n  content: \"\\F18DC\";\n}\n\n.mdi-vector-triangle::before {\n  content: \"\\F0563\";\n}\n\n.mdi-vector-union::before {\n  content: \"\\F0564\";\n}\n\n.mdi-vhs::before {\n  content: \"\\F0A1B\";\n}\n\n.mdi-vibrate::before {\n  content: \"\\F0566\";\n}\n\n.mdi-vibrate-off::before {\n  content: \"\\F0CD9\";\n}\n\n.mdi-video::before {\n  content: \"\\F0567\";\n}\n\n.mdi-video-3d::before {\n  content: \"\\F07FD\";\n}\n\n.mdi-video-3d-off::before {\n  content: \"\\F13D9\";\n}\n\n.mdi-video-3d-variant::before {\n  content: \"\\F0ED1\";\n}\n\n.mdi-video-4k-box::before {\n  content: \"\\F083E\";\n}\n\n.mdi-video-account::before {\n  content: \"\\F0919\";\n}\n\n.mdi-video-box::before {\n  content: \"\\F00FD\";\n}\n\n.mdi-video-box-off::before {\n  content: \"\\F00FE\";\n}\n\n.mdi-video-check::before {\n  content: \"\\F1069\";\n}\n\n.mdi-video-check-outline::before {\n  content: \"\\F106A\";\n}\n\n.mdi-video-high-definition::before {\n  content: \"\\F152E\";\n}\n\n.mdi-video-image::before {\n  content: \"\\F091A\";\n}\n\n.mdi-video-input-antenna::before {\n  content: \"\\F083F\";\n}\n\n.mdi-video-input-component::before {\n  content: \"\\F0840\";\n}\n\n.mdi-video-input-hdmi::before {\n  content: \"\\F0841\";\n}\n\n.mdi-video-input-scart::before {\n  content: \"\\F0F8C\";\n}\n\n.mdi-video-input-svideo::before {\n  content: \"\\F0842\";\n}\n\n.mdi-video-marker::before {\n  content: \"\\F19A9\";\n}\n\n.mdi-video-marker-outline::before {\n  content: \"\\F19AA\";\n}\n\n.mdi-video-minus::before {\n  content: \"\\F09B2\";\n}\n\n.mdi-video-minus-outline::before {\n  content: \"\\F02BA\";\n}\n\n.mdi-video-off::before {\n  content: \"\\F0568\";\n}\n\n.mdi-video-off-outline::before {\n  content: \"\\F0BDB\";\n}\n\n.mdi-video-outline::before {\n  content: \"\\F0BDC\";\n}\n\n.mdi-video-plus::before {\n  content: \"\\F09B3\";\n}\n\n.mdi-video-plus-outline::before {\n  content: \"\\F01D3\";\n}\n\n.mdi-video-stabilization::before {\n  content: \"\\F091B\";\n}\n\n.mdi-video-switch::before {\n  content: \"\\F0569\";\n}\n\n.mdi-video-switch-outline::before {\n  content: \"\\F0790\";\n}\n\n.mdi-video-vintage::before {\n  content: \"\\F0A1C\";\n}\n\n.mdi-video-wireless::before {\n  content: \"\\F0ED2\";\n}\n\n.mdi-video-wireless-outline::before {\n  content: \"\\F0ED3\";\n}\n\n.mdi-view-agenda::before {\n  content: \"\\F056A\";\n}\n\n.mdi-view-agenda-outline::before {\n  content: \"\\F11D8\";\n}\n\n.mdi-view-array::before {\n  content: \"\\F056B\";\n}\n\n.mdi-view-array-outline::before {\n  content: \"\\F1485\";\n}\n\n.mdi-view-carousel::before {\n  content: \"\\F056C\";\n}\n\n.mdi-view-carousel-outline::before {\n  content: \"\\F1486\";\n}\n\n.mdi-view-column::before {\n  content: \"\\F056D\";\n}\n\n.mdi-view-column-outline::before {\n  content: \"\\F1487\";\n}\n\n.mdi-view-comfy::before {\n  content: \"\\F0E6A\";\n}\n\n.mdi-view-comfy-outline::before {\n  content: \"\\F1488\";\n}\n\n.mdi-view-compact::before {\n  content: \"\\F0E6B\";\n}\n\n.mdi-view-compact-outline::before {\n  content: \"\\F0E6C\";\n}\n\n.mdi-view-dashboard::before {\n  content: \"\\F056E\";\n}\n\n.mdi-view-dashboard-edit::before {\n  content: \"\\F1947\";\n}\n\n.mdi-view-dashboard-edit-outline::before {\n  content: \"\\F1948\";\n}\n\n.mdi-view-dashboard-outline::before {\n  content: \"\\F0A1D\";\n}\n\n.mdi-view-dashboard-variant::before {\n  content: \"\\F0843\";\n}\n\n.mdi-view-dashboard-variant-outline::before {\n  content: \"\\F1489\";\n}\n\n.mdi-view-day::before {\n  content: \"\\F056F\";\n}\n\n.mdi-view-day-outline::before {\n  content: \"\\F148A\";\n}\n\n.mdi-view-gallery::before {\n  content: \"\\F1888\";\n}\n\n.mdi-view-gallery-outline::before {\n  content: \"\\F1889\";\n}\n\n.mdi-view-grid::before {\n  content: \"\\F0570\";\n}\n\n.mdi-view-grid-outline::before {\n  content: \"\\F11D9\";\n}\n\n.mdi-view-grid-plus::before {\n  content: \"\\F0F8D\";\n}\n\n.mdi-view-grid-plus-outline::before {\n  content: \"\\F11DA\";\n}\n\n.mdi-view-headline::before {\n  content: \"\\F0571\";\n}\n\n.mdi-view-list::before {\n  content: \"\\F0572\";\n}\n\n.mdi-view-list-outline::before {\n  content: \"\\F148B\";\n}\n\n.mdi-view-module::before {\n  content: \"\\F0573\";\n}\n\n.mdi-view-module-outline::before {\n  content: \"\\F148C\";\n}\n\n.mdi-view-parallel::before {\n  content: \"\\F0728\";\n}\n\n.mdi-view-parallel-outline::before {\n  content: \"\\F148D\";\n}\n\n.mdi-view-quilt::before {\n  content: \"\\F0574\";\n}\n\n.mdi-view-quilt-outline::before {\n  content: \"\\F148E\";\n}\n\n.mdi-view-sequential::before {\n  content: \"\\F0729\";\n}\n\n.mdi-view-sequential-outline::before {\n  content: \"\\F148F\";\n}\n\n.mdi-view-split-horizontal::before {\n  content: \"\\F0BCB\";\n}\n\n.mdi-view-split-vertical::before {\n  content: \"\\F0BCC\";\n}\n\n.mdi-view-stream::before {\n  content: \"\\F0575\";\n}\n\n.mdi-view-stream-outline::before {\n  content: \"\\F1490\";\n}\n\n.mdi-view-week::before {\n  content: \"\\F0576\";\n}\n\n.mdi-view-week-outline::before {\n  content: \"\\F1491\";\n}\n\n.mdi-vimeo::before {\n  content: \"\\F0577\";\n}\n\n.mdi-violin::before {\n  content: \"\\F060F\";\n}\n\n.mdi-virtual-reality::before {\n  content: \"\\F0894\";\n}\n\n.mdi-virus::before {\n  content: \"\\F13B6\";\n}\n\n.mdi-virus-off::before {\n  content: \"\\F18E1\";\n}\n\n.mdi-virus-off-outline::before {\n  content: \"\\F18E2\";\n}\n\n.mdi-virus-outline::before {\n  content: \"\\F13B7\";\n}\n\n.mdi-vlc::before {\n  content: \"\\F057C\";\n}\n\n.mdi-voicemail::before {\n  content: \"\\F057D\";\n}\n\n.mdi-volleyball::before {\n  content: \"\\F09B4\";\n}\n\n.mdi-volume-high::before {\n  content: \"\\F057E\";\n}\n\n.mdi-volume-low::before {\n  content: \"\\F057F\";\n}\n\n.mdi-volume-medium::before {\n  content: \"\\F0580\";\n}\n\n.mdi-volume-minus::before {\n  content: \"\\F075E\";\n}\n\n.mdi-volume-mute::before {\n  content: \"\\F075F\";\n}\n\n.mdi-volume-off::before {\n  content: \"\\F0581\";\n}\n\n.mdi-volume-plus::before {\n  content: \"\\F075D\";\n}\n\n.mdi-volume-source::before {\n  content: \"\\F1120\";\n}\n\n.mdi-volume-variant-off::before {\n  content: \"\\F0E08\";\n}\n\n.mdi-volume-vibrate::before {\n  content: \"\\F1121\";\n}\n\n.mdi-vote::before {\n  content: \"\\F0A1F\";\n}\n\n.mdi-vote-outline::before {\n  content: \"\\F0A20\";\n}\n\n.mdi-vpn::before {\n  content: \"\\F0582\";\n}\n\n.mdi-vuejs::before {\n  content: \"\\F0844\";\n}\n\n.mdi-vuetify::before {\n  content: \"\\F0E6D\";\n}\n\n.mdi-walk::before {\n  content: \"\\F0583\";\n}\n\n.mdi-wall::before {\n  content: \"\\F07FE\";\n}\n\n.mdi-wall-sconce::before {\n  content: \"\\F091C\";\n}\n\n.mdi-wall-sconce-flat::before {\n  content: \"\\F091D\";\n}\n\n.mdi-wall-sconce-flat-outline::before {\n  content: \"\\F17C9\";\n}\n\n.mdi-wall-sconce-flat-variant::before {\n  content: \"\\F041C\";\n}\n\n.mdi-wall-sconce-flat-variant-outline::before {\n  content: \"\\F17CA\";\n}\n\n.mdi-wall-sconce-outline::before {\n  content: \"\\F17CB\";\n}\n\n.mdi-wall-sconce-round::before {\n  content: \"\\F0748\";\n}\n\n.mdi-wall-sconce-round-outline::before {\n  content: \"\\F17CC\";\n}\n\n.mdi-wall-sconce-round-variant::before {\n  content: \"\\F091E\";\n}\n\n.mdi-wall-sconce-round-variant-outline::before {\n  content: \"\\F17CD\";\n}\n\n.mdi-wallet::before {\n  content: \"\\F0584\";\n}\n\n.mdi-wallet-giftcard::before {\n  content: \"\\F0585\";\n}\n\n.mdi-wallet-membership::before {\n  content: \"\\F0586\";\n}\n\n.mdi-wallet-outline::before {\n  content: \"\\F0BDD\";\n}\n\n.mdi-wallet-plus::before {\n  content: \"\\F0F8E\";\n}\n\n.mdi-wallet-plus-outline::before {\n  content: \"\\F0F8F\";\n}\n\n.mdi-wallet-travel::before {\n  content: \"\\F0587\";\n}\n\n.mdi-wallpaper::before {\n  content: \"\\F0E09\";\n}\n\n.mdi-wan::before {\n  content: \"\\F0588\";\n}\n\n.mdi-wardrobe::before {\n  content: \"\\F0F90\";\n}\n\n.mdi-wardrobe-outline::before {\n  content: \"\\F0F91\";\n}\n\n.mdi-warehouse::before {\n  content: \"\\F0F81\";\n}\n\n.mdi-washing-machine::before {\n  content: \"\\F072A\";\n}\n\n.mdi-washing-machine-alert::before {\n  content: \"\\F11BC\";\n}\n\n.mdi-washing-machine-off::before {\n  content: \"\\F11BD\";\n}\n\n.mdi-watch::before {\n  content: \"\\F0589\";\n}\n\n.mdi-watch-export::before {\n  content: \"\\F058A\";\n}\n\n.mdi-watch-export-variant::before {\n  content: \"\\F0895\";\n}\n\n.mdi-watch-import::before {\n  content: \"\\F058B\";\n}\n\n.mdi-watch-import-variant::before {\n  content: \"\\F0896\";\n}\n\n.mdi-watch-variant::before {\n  content: \"\\F0897\";\n}\n\n.mdi-watch-vibrate::before {\n  content: \"\\F06B1\";\n}\n\n.mdi-watch-vibrate-off::before {\n  content: \"\\F0CDA\";\n}\n\n.mdi-water::before {\n  content: \"\\F058C\";\n}\n\n.mdi-water-alert::before {\n  content: \"\\F1502\";\n}\n\n.mdi-water-alert-outline::before {\n  content: \"\\F1503\";\n}\n\n.mdi-water-boiler::before {\n  content: \"\\F0F92\";\n}\n\n.mdi-water-boiler-alert::before {\n  content: \"\\F11B3\";\n}\n\n.mdi-water-boiler-off::before {\n  content: \"\\F11B4\";\n}\n\n.mdi-water-check::before {\n  content: \"\\F1504\";\n}\n\n.mdi-water-check-outline::before {\n  content: \"\\F1505\";\n}\n\n.mdi-water-circle::before {\n  content: \"\\F1806\";\n}\n\n.mdi-water-minus::before {\n  content: \"\\F1506\";\n}\n\n.mdi-water-minus-outline::before {\n  content: \"\\F1507\";\n}\n\n.mdi-water-off::before {\n  content: \"\\F058D\";\n}\n\n.mdi-water-off-outline::before {\n  content: \"\\F1508\";\n}\n\n.mdi-water-opacity::before {\n  content: \"\\F1855\";\n}\n\n.mdi-water-outline::before {\n  content: \"\\F0E0A\";\n}\n\n.mdi-water-percent::before {\n  content: \"\\F058E\";\n}\n\n.mdi-water-percent-alert::before {\n  content: \"\\F1509\";\n}\n\n.mdi-water-plus::before {\n  content: \"\\F150A\";\n}\n\n.mdi-water-plus-outline::before {\n  content: \"\\F150B\";\n}\n\n.mdi-water-polo::before {\n  content: \"\\F12A0\";\n}\n\n.mdi-water-pump::before {\n  content: \"\\F058F\";\n}\n\n.mdi-water-pump-off::before {\n  content: \"\\F0F93\";\n}\n\n.mdi-water-remove::before {\n  content: \"\\F150C\";\n}\n\n.mdi-water-remove-outline::before {\n  content: \"\\F150D\";\n}\n\n.mdi-water-sync::before {\n  content: \"\\F17C6\";\n}\n\n.mdi-water-well::before {\n  content: \"\\F106B\";\n}\n\n.mdi-water-well-outline::before {\n  content: \"\\F106C\";\n}\n\n.mdi-waterfall::before {\n  content: \"\\F1849\";\n}\n\n.mdi-watering-can::before {\n  content: \"\\F1481\";\n}\n\n.mdi-watering-can-outline::before {\n  content: \"\\F1482\";\n}\n\n.mdi-watermark::before {\n  content: \"\\F0612\";\n}\n\n.mdi-wave::before {\n  content: \"\\F0F2E\";\n}\n\n.mdi-waveform::before {\n  content: \"\\F147D\";\n}\n\n.mdi-waves::before {\n  content: \"\\F078D\";\n}\n\n.mdi-waves-arrow-left::before {\n  content: \"\\F1859\";\n}\n\n.mdi-waves-arrow-right::before {\n  content: \"\\F185A\";\n}\n\n.mdi-waves-arrow-up::before {\n  content: \"\\F185B\";\n}\n\n.mdi-waze::before {\n  content: \"\\F0BDE\";\n}\n\n.mdi-weather-cloudy::before {\n  content: \"\\F0590\";\n}\n\n.mdi-weather-cloudy-alert::before {\n  content: \"\\F0F2F\";\n}\n\n.mdi-weather-cloudy-arrow-right::before {\n  content: \"\\F0E6E\";\n}\n\n.mdi-weather-cloudy-clock::before {\n  content: \"\\F18F6\";\n}\n\n.mdi-weather-fog::before {\n  content: \"\\F0591\";\n}\n\n.mdi-weather-hail::before {\n  content: \"\\F0592\";\n}\n\n.mdi-weather-hazy::before {\n  content: \"\\F0F30\";\n}\n\n.mdi-weather-hurricane::before {\n  content: \"\\F0898\";\n}\n\n.mdi-weather-lightning::before {\n  content: \"\\F0593\";\n}\n\n.mdi-weather-lightning-rainy::before {\n  content: \"\\F067E\";\n}\n\n.mdi-weather-night::before {\n  content: \"\\F0594\";\n}\n\n.mdi-weather-night-partly-cloudy::before {\n  content: \"\\F0F31\";\n}\n\n.mdi-weather-partly-cloudy::before {\n  content: \"\\F0595\";\n}\n\n.mdi-weather-partly-lightning::before {\n  content: \"\\F0F32\";\n}\n\n.mdi-weather-partly-rainy::before {\n  content: \"\\F0F33\";\n}\n\n.mdi-weather-partly-snowy::before {\n  content: \"\\F0F34\";\n}\n\n.mdi-weather-partly-snowy-rainy::before {\n  content: \"\\F0F35\";\n}\n\n.mdi-weather-pouring::before {\n  content: \"\\F0596\";\n}\n\n.mdi-weather-rainy::before {\n  content: \"\\F0597\";\n}\n\n.mdi-weather-snowy::before {\n  content: \"\\F0598\";\n}\n\n.mdi-weather-snowy-heavy::before {\n  content: \"\\F0F36\";\n}\n\n.mdi-weather-snowy-rainy::before {\n  content: \"\\F067F\";\n}\n\n.mdi-weather-sunny::before {\n  content: \"\\F0599\";\n}\n\n.mdi-weather-sunny-alert::before {\n  content: \"\\F0F37\";\n}\n\n.mdi-weather-sunny-off::before {\n  content: \"\\F14E4\";\n}\n\n.mdi-weather-sunset::before {\n  content: \"\\F059A\";\n}\n\n.mdi-weather-sunset-down::before {\n  content: \"\\F059B\";\n}\n\n.mdi-weather-sunset-up::before {\n  content: \"\\F059C\";\n}\n\n.mdi-weather-tornado::before {\n  content: \"\\F0F38\";\n}\n\n.mdi-weather-windy::before {\n  content: \"\\F059D\";\n}\n\n.mdi-weather-windy-variant::before {\n  content: \"\\F059E\";\n}\n\n.mdi-web::before {\n  content: \"\\F059F\";\n}\n\n.mdi-web-box::before {\n  content: \"\\F0F94\";\n}\n\n.mdi-web-cancel::before {\n  content: \"\\F1790\";\n}\n\n.mdi-web-check::before {\n  content: \"\\F0789\";\n}\n\n.mdi-web-clock::before {\n  content: \"\\F124A\";\n}\n\n.mdi-web-minus::before {\n  content: \"\\F10A0\";\n}\n\n.mdi-web-off::before {\n  content: \"\\F0A8E\";\n}\n\n.mdi-web-plus::before {\n  content: \"\\F0033\";\n}\n\n.mdi-web-refresh::before {\n  content: \"\\F1791\";\n}\n\n.mdi-web-remove::before {\n  content: \"\\F0551\";\n}\n\n.mdi-web-sync::before {\n  content: \"\\F1792\";\n}\n\n.mdi-webcam::before {\n  content: \"\\F05A0\";\n}\n\n.mdi-webcam-off::before {\n  content: \"\\F1737\";\n}\n\n.mdi-webhook::before {\n  content: \"\\F062F\";\n}\n\n.mdi-webpack::before {\n  content: \"\\F072B\";\n}\n\n.mdi-webrtc::before {\n  content: \"\\F1248\";\n}\n\n.mdi-wechat::before {\n  content: \"\\F0611\";\n}\n\n.mdi-weight::before {\n  content: \"\\F05A1\";\n}\n\n.mdi-weight-gram::before {\n  content: \"\\F0D3F\";\n}\n\n.mdi-weight-kilogram::before {\n  content: \"\\F05A2\";\n}\n\n.mdi-weight-lifter::before {\n  content: \"\\F115D\";\n}\n\n.mdi-weight-pound::before {\n  content: \"\\F09B5\";\n}\n\n.mdi-whatsapp::before {\n  content: \"\\F05A3\";\n}\n\n.mdi-wheel-barrow::before {\n  content: \"\\F14F2\";\n}\n\n.mdi-wheelchair-accessibility::before {\n  content: \"\\F05A4\";\n}\n\n.mdi-whistle::before {\n  content: \"\\F09B6\";\n}\n\n.mdi-whistle-outline::before {\n  content: \"\\F12BC\";\n}\n\n.mdi-white-balance-auto::before {\n  content: \"\\F05A5\";\n}\n\n.mdi-white-balance-incandescent::before {\n  content: \"\\F05A6\";\n}\n\n.mdi-white-balance-iridescent::before {\n  content: \"\\F05A7\";\n}\n\n.mdi-white-balance-sunny::before {\n  content: \"\\F05A8\";\n}\n\n.mdi-widgets::before {\n  content: \"\\F072C\";\n}\n\n.mdi-widgets-outline::before {\n  content: \"\\F1355\";\n}\n\n.mdi-wifi::before {\n  content: \"\\F05A9\";\n}\n\n.mdi-wifi-alert::before {\n  content: \"\\F16B5\";\n}\n\n.mdi-wifi-arrow-down::before {\n  content: \"\\F16B6\";\n}\n\n.mdi-wifi-arrow-left::before {\n  content: \"\\F16B7\";\n}\n\n.mdi-wifi-arrow-left-right::before {\n  content: \"\\F16B8\";\n}\n\n.mdi-wifi-arrow-right::before {\n  content: \"\\F16B9\";\n}\n\n.mdi-wifi-arrow-up::before {\n  content: \"\\F16BA\";\n}\n\n.mdi-wifi-arrow-up-down::before {\n  content: \"\\F16BB\";\n}\n\n.mdi-wifi-cancel::before {\n  content: \"\\F16BC\";\n}\n\n.mdi-wifi-check::before {\n  content: \"\\F16BD\";\n}\n\n.mdi-wifi-cog::before {\n  content: \"\\F16BE\";\n}\n\n.mdi-wifi-lock::before {\n  content: \"\\F16BF\";\n}\n\n.mdi-wifi-lock-open::before {\n  content: \"\\F16C0\";\n}\n\n.mdi-wifi-marker::before {\n  content: \"\\F16C1\";\n}\n\n.mdi-wifi-minus::before {\n  content: \"\\F16C2\";\n}\n\n.mdi-wifi-off::before {\n  content: \"\\F05AA\";\n}\n\n.mdi-wifi-plus::before {\n  content: \"\\F16C3\";\n}\n\n.mdi-wifi-refresh::before {\n  content: \"\\F16C4\";\n}\n\n.mdi-wifi-remove::before {\n  content: \"\\F16C5\";\n}\n\n.mdi-wifi-settings::before {\n  content: \"\\F16C6\";\n}\n\n.mdi-wifi-star::before {\n  content: \"\\F0E0B\";\n}\n\n.mdi-wifi-strength-1::before {\n  content: \"\\F091F\";\n}\n\n.mdi-wifi-strength-1-alert::before {\n  content: \"\\F0920\";\n}\n\n.mdi-wifi-strength-1-lock::before {\n  content: \"\\F0921\";\n}\n\n.mdi-wifi-strength-1-lock-open::before {\n  content: \"\\F16CB\";\n}\n\n.mdi-wifi-strength-2::before {\n  content: \"\\F0922\";\n}\n\n.mdi-wifi-strength-2-alert::before {\n  content: \"\\F0923\";\n}\n\n.mdi-wifi-strength-2-lock::before {\n  content: \"\\F0924\";\n}\n\n.mdi-wifi-strength-2-lock-open::before {\n  content: \"\\F16CC\";\n}\n\n.mdi-wifi-strength-3::before {\n  content: \"\\F0925\";\n}\n\n.mdi-wifi-strength-3-alert::before {\n  content: \"\\F0926\";\n}\n\n.mdi-wifi-strength-3-lock::before {\n  content: \"\\F0927\";\n}\n\n.mdi-wifi-strength-3-lock-open::before {\n  content: \"\\F16CD\";\n}\n\n.mdi-wifi-strength-4::before {\n  content: \"\\F0928\";\n}\n\n.mdi-wifi-strength-4-alert::before {\n  content: \"\\F0929\";\n}\n\n.mdi-wifi-strength-4-lock::before {\n  content: \"\\F092A\";\n}\n\n.mdi-wifi-strength-4-lock-open::before {\n  content: \"\\F16CE\";\n}\n\n.mdi-wifi-strength-alert-outline::before {\n  content: \"\\F092B\";\n}\n\n.mdi-wifi-strength-lock-open-outline::before {\n  content: \"\\F16CF\";\n}\n\n.mdi-wifi-strength-lock-outline::before {\n  content: \"\\F092C\";\n}\n\n.mdi-wifi-strength-off::before {\n  content: \"\\F092D\";\n}\n\n.mdi-wifi-strength-off-outline::before {\n  content: \"\\F092E\";\n}\n\n.mdi-wifi-strength-outline::before {\n  content: \"\\F092F\";\n}\n\n.mdi-wifi-sync::before {\n  content: \"\\F16C7\";\n}\n\n.mdi-wikipedia::before {\n  content: \"\\F05AC\";\n}\n\n.mdi-wind-turbine::before {\n  content: \"\\F0DA5\";\n}\n\n.mdi-wind-turbine-alert::before {\n  content: \"\\F19AB\";\n}\n\n.mdi-wind-turbine-check::before {\n  content: \"\\F19AC\";\n}\n\n.mdi-window-close::before {\n  content: \"\\F05AD\";\n}\n\n.mdi-window-closed::before {\n  content: \"\\F05AE\";\n}\n\n.mdi-window-closed-variant::before {\n  content: \"\\F11DB\";\n}\n\n.mdi-window-maximize::before {\n  content: \"\\F05AF\";\n}\n\n.mdi-window-minimize::before {\n  content: \"\\F05B0\";\n}\n\n.mdi-window-open::before {\n  content: \"\\F05B1\";\n}\n\n.mdi-window-open-variant::before {\n  content: \"\\F11DC\";\n}\n\n.mdi-window-restore::before {\n  content: \"\\F05B2\";\n}\n\n.mdi-window-shutter::before {\n  content: \"\\F111C\";\n}\n\n.mdi-window-shutter-alert::before {\n  content: \"\\F111D\";\n}\n\n.mdi-window-shutter-open::before {\n  content: \"\\F111E\";\n}\n\n.mdi-windsock::before {\n  content: \"\\F15FA\";\n}\n\n.mdi-wiper::before {\n  content: \"\\F0AE9\";\n}\n\n.mdi-wiper-wash::before {\n  content: \"\\F0DA6\";\n}\n\n.mdi-wiper-wash-alert::before {\n  content: \"\\F18DF\";\n}\n\n.mdi-wizard-hat::before {\n  content: \"\\F1477\";\n}\n\n.mdi-wordpress::before {\n  content: \"\\F05B4\";\n}\n\n.mdi-wrap::before {\n  content: \"\\F05B6\";\n}\n\n.mdi-wrap-disabled::before {\n  content: \"\\F0BDF\";\n}\n\n.mdi-wrench::before {\n  content: \"\\F05B7\";\n}\n\n.mdi-wrench-clock::before {\n  content: \"\\F19A3\";\n}\n\n.mdi-wrench-outline::before {\n  content: \"\\F0BE0\";\n}\n\n.mdi-xamarin::before {\n  content: \"\\F0845\";\n}\n\n.mdi-xml::before {\n  content: \"\\F05C0\";\n}\n\n.mdi-xmpp::before {\n  content: \"\\F07FF\";\n}\n\n.mdi-yahoo::before {\n  content: \"\\F0B4F\";\n}\n\n.mdi-yeast::before {\n  content: \"\\F05C1\";\n}\n\n.mdi-yin-yang::before {\n  content: \"\\F0680\";\n}\n\n.mdi-yoga::before {\n  content: \"\\F117C\";\n}\n\n.mdi-youtube::before {\n  content: \"\\F05C3\";\n}\n\n.mdi-youtube-gaming::before {\n  content: \"\\F0848\";\n}\n\n.mdi-youtube-studio::before {\n  content: \"\\F0847\";\n}\n\n.mdi-youtube-subscription::before {\n  content: \"\\F0D40\";\n}\n\n.mdi-youtube-tv::before {\n  content: \"\\F0448\";\n}\n\n.mdi-yurt::before {\n  content: \"\\F1516\";\n}\n\n.mdi-z-wave::before {\n  content: \"\\F0AEA\";\n}\n\n.mdi-zend::before {\n  content: \"\\F0AEB\";\n}\n\n.mdi-zigbee::before {\n  content: \"\\F0D41\";\n}\n\n.mdi-zip-box::before {\n  content: \"\\F05C4\";\n}\n\n.mdi-zip-box-outline::before {\n  content: \"\\F0FFA\";\n}\n\n.mdi-zip-disk::before {\n  content: \"\\F0A23\";\n}\n\n.mdi-zodiac-aquarius::before {\n  content: \"\\F0A7D\";\n}\n\n.mdi-zodiac-aries::before {\n  content: \"\\F0A7E\";\n}\n\n.mdi-zodiac-cancer::before {\n  content: \"\\F0A7F\";\n}\n\n.mdi-zodiac-capricorn::before {\n  content: \"\\F0A80\";\n}\n\n.mdi-zodiac-gemini::before {\n  content: \"\\F0A81\";\n}\n\n.mdi-zodiac-leo::before {\n  content: \"\\F0A82\";\n}\n\n.mdi-zodiac-libra::before {\n  content: \"\\F0A83\";\n}\n\n.mdi-zodiac-pisces::before {\n  content: \"\\F0A84\";\n}\n\n.mdi-zodiac-sagittarius::before {\n  content: \"\\F0A85\";\n}\n\n.mdi-zodiac-scorpio::before {\n  content: \"\\F0A86\";\n}\n\n.mdi-zodiac-taurus::before {\n  content: \"\\F0A87\";\n}\n\n.mdi-zodiac-virgo::before {\n  content: \"\\F0A88\";\n}\n\n.mdi-blank::before {\n  content: \"\\F68C\";\n  visibility: hidden;\n}\n\n.mdi-18px.mdi-set, .mdi-18px.mdi:before {\n  font-size: 18px;\n}\n\n.mdi-24px.mdi-set, .mdi-24px.mdi:before {\n  font-size: 24px;\n}\n\n.mdi-36px.mdi-set, .mdi-36px.mdi:before {\n  font-size: 36px;\n}\n\n.mdi-48px.mdi-set, .mdi-48px.mdi:before {\n  font-size: 48px;\n}\n\n.mdi-dark:before {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.mdi-dark.mdi-inactive:before {\n  color: rgba(0, 0, 0, 0.26);\n}\n\n.mdi-light:before {\n  color: white;\n}\n\n.mdi-light.mdi-inactive:before {\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.mdi-rotate-45 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(45deg);\n            transform: scaleX(-1) rotate(45deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(45deg);\n            -ms-transform: rotate(45deg);\n            transform: scaleY(-1) rotate(45deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-45:before {\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.mdi-rotate-90 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(90deg);\n            transform: scaleX(-1) rotate(90deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(90deg);\n            -ms-transform: rotate(90deg);\n            transform: scaleY(-1) rotate(90deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-90:before {\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.mdi-rotate-135 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(135deg);\n            transform: scaleX(-1) rotate(135deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(135deg);\n            -ms-transform: rotate(135deg);\n            transform: scaleY(-1) rotate(135deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-135:before {\n  -webkit-transform: rotate(135deg);\n  -ms-transform: rotate(135deg);\n  transform: rotate(135deg);\n}\n\n.mdi-rotate-180 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(180deg);\n            transform: scaleX(-1) rotate(180deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(180deg);\n            -ms-transform: rotate(180deg);\n            transform: scaleY(-1) rotate(180deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-180:before {\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.mdi-rotate-225 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(225deg);\n            transform: scaleX(-1) rotate(225deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(225deg);\n            -ms-transform: rotate(225deg);\n            transform: scaleY(-1) rotate(225deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-225:before {\n  -webkit-transform: rotate(225deg);\n  -ms-transform: rotate(225deg);\n  transform: rotate(225deg);\n}\n\n.mdi-rotate-270 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(270deg);\n            transform: scaleX(-1) rotate(270deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(270deg);\n            -ms-transform: rotate(270deg);\n            transform: scaleY(-1) rotate(270deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-270:before {\n  -webkit-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n.mdi-rotate-315 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(315deg);\n            transform: scaleX(-1) rotate(315deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(315deg);\n            -ms-transform: rotate(315deg);\n            transform: scaleY(-1) rotate(315deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-315:before {\n  -webkit-transform: rotate(315deg);\n  -ms-transform: rotate(315deg);\n  transform: rotate(315deg);\n}\n\n.mdi-flip-h:before {\n  -webkit-transform: scaleX(-1);\n  transform: scaleX(-1);\n  filter: FlipH;\n  -ms-filter: \"FlipH\";\n}\n\n.mdi-flip-v:before {\n  -webkit-transform: scaleY(-1);\n  transform: scaleY(-1);\n  filter: FlipV;\n  -ms-filter: \"FlipV\";\n}\n\n.mdi-spin:before {\n  -webkit-animation: mdi-spin 2s infinite linear;\n  animation: mdi-spin 2s infinite linear;\n}\n\n@-webkit-keyframes mdi-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n@keyframes mdi-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n/*# sourceMappingURL=materialdesignicons.css.map */","// boxicons 2.1.1\n\n@font-face\n{\n    font-family: 'boxicons';\n    font-weight: normal;\n    font-style: normal;\n\n    src: url('../../../fonts/boxicons.eot');\n    src: url('../../../fonts/boxicons.eot') format('embedded-opentype'),\n    url('../../../fonts/boxicons.woff2') format('woff2'),\n    url('../../../fonts/boxicons.woff') format('woff'),\n    url('../../../fonts/boxicons.ttf') format('truetype'),\n    url('../../../fonts/boxicons.svg?#boxicons') format('svg');\n}\n.bx\n{\n    font-family: 'boxicons' !important;\n    font-weight: normal;\n    font-style: normal;\n    font-variant: normal;\n    line-height: 1;\n    text-rendering: auto;\n    display: inline-block;\n\n    text-transform: none;\n\n    speak: none;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n.bx-ul\n{\n    margin-left: 2em;\n    padding-left: 0;\n\n    list-style: none;\n}\n.bx-ul > li\n{\n    position: relative;\n}\n.bx-ul .bx\n{\n    font-size: inherit;\n    line-height: inherit;\n\n    position: absolute;\n    left: -2em;\n\n    width: 2em;\n\n    text-align: center;\n}\n@-webkit-keyframes spin\n{\n    0%\n    {\n        -webkit-transform: rotate(0);\n                transform: rotate(0);\n    }\n    100%\n    {\n        -webkit-transform: rotate(359deg);\n                transform: rotate(359deg);\n    }\n}\n@keyframes spin\n{\n    0%\n    {\n        -webkit-transform: rotate(0);\n                transform: rotate(0);\n    }\n    100%\n    {\n        -webkit-transform: rotate(359deg);\n                transform: rotate(359deg);\n    }\n}\n@-webkit-keyframes burst\n{\n    0%\n    {\n        -webkit-transform: scale(1);\n                transform: scale(1);\n\n        opacity: 1;\n    }\n    90%\n    {\n        -webkit-transform: scale(1.5);\n                transform: scale(1.5);\n\n        opacity: 0;\n    }\n}\n@keyframes burst\n{\n    0%\n    {\n        -webkit-transform: scale(1);\n                transform: scale(1);\n\n        opacity: 1;\n    }\n    90%\n    {\n        -webkit-transform: scale(1.5);\n                transform: scale(1.5);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes flashing\n{\n    0%\n    {\n        opacity: 1;\n    }\n    45%\n    {\n        opacity: 0;\n    }\n    90%\n    {\n        opacity: 1;\n    }\n}\n@keyframes flashing\n{\n    0%\n    {\n        opacity: 1;\n    }\n    45%\n    {\n        opacity: 0;\n    }\n    90%\n    {\n        opacity: 1;\n    }\n}\n@-webkit-keyframes fade-left\n{\n    0%\n    {\n        -webkit-transform: translateX(0);\n                transform: translateX(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateX(-20px);\n                transform: translateX(-20px);\n\n        opacity: 0;\n    }\n}\n@keyframes fade-left\n{\n    0%\n    {\n        -webkit-transform: translateX(0);\n                transform: translateX(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateX(-20px);\n                transform: translateX(-20px);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes fade-right\n{\n    0%\n    {\n        -webkit-transform: translateX(0);\n                transform: translateX(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateX(20px);\n                transform: translateX(20px);\n\n        opacity: 0;\n    }\n}\n@keyframes fade-right\n{\n    0%\n    {\n        -webkit-transform: translateX(0);\n                transform: translateX(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateX(20px);\n                transform: translateX(20px);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes fade-up\n{\n    0%\n    {\n        -webkit-transform: translateY(0);\n                transform: translateY(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateY(-20px);\n                transform: translateY(-20px);\n\n        opacity: 0;\n    }\n}\n@keyframes fade-up\n{\n    0%\n    {\n        -webkit-transform: translateY(0);\n                transform: translateY(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateY(-20px);\n                transform: translateY(-20px);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes fade-down\n{\n    0%\n    {\n        -webkit-transform: translateY(0);\n                transform: translateY(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateY(20px);\n                transform: translateY(20px);\n\n        opacity: 0;\n    }\n}\n@keyframes fade-down\n{\n    0%\n    {\n        -webkit-transform: translateY(0);\n                transform: translateY(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateY(20px);\n                transform: translateY(20px);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes tada\n{\n    from\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n\n    10%,\n    20%\n    {\n        -webkit-transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\n                transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\n    }\n\n    30%,\n    50%,\n    70%,\n    90%\n    {\n        -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\n                transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\n    }\n\n    40%,\n    60%,\n    80%\n    {\n        -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, -10deg);\n                transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, -10deg);\n    }\n\n    to\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n}\n\n@keyframes tada\n{\n    from\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n\n    10%,\n    20%\n    {\n        -webkit-transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\n                transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\n    }\n\n    30%,\n    50%,\n    70%,\n    90%\n    {\n        -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\n                transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\n    }\n\n    40%,\n    60%,\n    80%\n    {\n        -webkit-transform: rotate3d(0, 0, 1, -10deg);\n                transform: rotate3d(0, 0, 1, -10deg);\n    }\n\n    to\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n}\n.bx-spin\n{\n    -webkit-animation: spin 2s linear infinite;\n            animation: spin 2s linear infinite;\n}\n.bx-spin-hover:hover\n{\n    -webkit-animation: spin 2s linear infinite;\n            animation: spin 2s linear infinite;\n}\n\n.bx-tada\n{\n    -webkit-animation: tada 1.5s ease infinite;\n            animation: tada 1.5s ease infinite;\n}\n.bx-tada-hover:hover\n{\n    -webkit-animation: tada 1.5s ease infinite;\n            animation: tada 1.5s ease infinite;\n}\n\n.bx-flashing\n{\n    -webkit-animation: flashing 1.5s infinite linear;\n            animation: flashing 1.5s infinite linear;\n}\n.bx-flashing-hover:hover\n{\n    -webkit-animation: flashing 1.5s infinite linear;\n            animation: flashing 1.5s infinite linear;\n}\n\n.bx-burst\n{\n    -webkit-animation: burst 1.5s infinite linear;\n            animation: burst 1.5s infinite linear;\n}\n.bx-burst-hover:hover\n{\n    -webkit-animation: burst 1.5s infinite linear;\n            animation: burst 1.5s infinite linear;\n}\n.bx-fade-up\n{\n    -webkit-animation: fade-up 1.5s infinite linear;\n            animation: fade-up 1.5s infinite linear;\n}\n.bx-fade-up-hover:hover\n{\n    -webkit-animation: fade-up 1.5s infinite linear;\n            animation: fade-up 1.5s infinite linear;\n}\n.bx-fade-down\n{\n    -webkit-animation: fade-down 1.5s infinite linear;\n            animation: fade-down 1.5s infinite linear;\n}\n.bx-fade-down-hover:hover\n{\n    -webkit-animation: fade-down 1.5s infinite linear;\n            animation: fade-down 1.5s infinite linear;\n}\n.bx-fade-left\n{\n    -webkit-animation: fade-left 1.5s infinite linear;\n            animation: fade-left 1.5s infinite linear;\n}\n.bx-fade-left-hover:hover\n{\n    -webkit-animation: fade-left 1.5s infinite linear;\n            animation: fade-left 1.5s infinite linear;\n}\n.bx-fade-right\n{\n    -webkit-animation: fade-right 1.5s infinite linear;\n            animation: fade-right 1.5s infinite linear;\n}\n.bx-fade-right-hover:hover\n{\n    -webkit-animation: fade-right 1.5s infinite linear;\n            animation: fade-right 1.5s infinite linear;\n}\n.bx-xs\n{\n    font-size: 1rem!important;\n}\n.bx-sm\n{\n    font-size: 1.55rem!important;\n}\n.bx-md\n{\n    font-size: 2.25rem!important;\n}\n.bx-lg\n{\n    font-size: 3.0rem!important;\n}\n.bx-fw\n{\n    font-size: 1.2857142857em;\n    line-height: .8em;\n\n    width: 1.2857142857em;\n    height: .8em;\n    margin-top: -.2em!important;\n\n    vertical-align: middle;\n}\n.bx-pull-left\n{\n    float: left;\n\n    margin-right: .3em!important;\n}\n.bx-pull-right\n{\n    float: right;\n\n    margin-left: .3em!important;\n}\n.bx-rotate-90\n{\n    transform: rotate(90deg);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=1)';\n}\n.bx-rotate-180\n{\n    transform: rotate(180deg);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2)';\n}\n.bx-rotate-270\n{\n    transform: rotate(270deg);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=3)';\n}\n.bx-flip-horizontal\n{\n    transform: scaleX(-1);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)';\n}\n.bx-flip-vertical\n{\n    transform: scaleY(-1);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)';\n}\n.bx-border\n{\n    padding: .25em;\n\n    border: .07em solid rgba(0,0,0,.1);\n    border-radius: .25em;\n}\n.bx-border-circle\n{\n    padding: .25em;\n\n    border: .07em solid rgba(0,0,0,.1);\n    border-radius: 50%;\n}\n\n  \n  .bxl-meta:before {\n    content: \"\\ef27\";\n  }\n  .bx-lemon:before {\n    content: \"\\ef28\";\n  }\n  .bxs-lemon:before {\n    content: \"\\ef29\";\n  }\n  .bx-cricket-ball:before {\n    content: \"\\ef0c\";\n  }\n  .bx-baguette:before {\n    content: \"\\ef0d\";\n  }\n  .bx-bowl-hot:before {\n    content: \"\\ef0e\";\n  }\n  .bx-bowl-rice:before {\n    content: \"\\ef0f\";\n  }\n  .bx-cable-car:before {\n    content: \"\\ef10\";\n  }\n  .bx-candles:before {\n    content: \"\\ef11\";\n  }\n  .bx-circle-half:before {\n    content: \"\\ef12\";\n  }\n  .bx-circle-quarter:before {\n    content: \"\\ef13\";\n  }\n  .bx-circle-three-quarter:before {\n    content: \"\\ef14\";\n  }\n  .bx-cross:before {\n    content: \"\\ef15\";\n  }\n  .bx-fork:before {\n    content: \"\\ef16\";\n  }\n  .bx-knife:before {\n    content: \"\\ef17\";\n  }\n  .bx-money-withdraw:before {\n    content: \"\\ef18\";\n  }\n  .bx-popsicle:before {\n    content: \"\\ef19\";\n  }\n  .bx-scatter-chart:before {\n    content: \"\\ef1a\";\n  }\n  .bxs-baguette:before {\n    content: \"\\ef1b\";\n  }\n  .bxs-bowl-hot:before {\n    content: \"\\ef1c\";\n  }\n  .bxs-bowl-rice:before {\n    content: \"\\ef1d\";\n  }\n  .bxs-cable-car:before {\n    content: \"\\ef1e\";\n  }\n  .bxs-circle-half:before {\n    content: \"\\ef1f\";\n  }\n  .bxs-circle-quarter:before {\n    content: \"\\ef20\";\n  }\n  .bxs-circle-three-quarter:before {\n    content: \"\\ef21\";\n  }\n  .bxs-cricket-ball:before {\n    content: \"\\ef22\";\n  }\n  .bxs-invader:before {\n    content: \"\\ef23\";\n  }\n  .bx-male-female:before {\n    content: \"\\ef24\";\n  }\n  .bxs-popsicle:before {\n    content: \"\\ef25\";\n  }\n  .bxs-tree-alt:before {\n    content: \"\\ef26\";\n  }\n  .bxl-venmo:before {\n    content: \"\\e900\";\n  }\n  .bxl-upwork:before {\n    content: \"\\e901\";\n  }\n  .bxl-netlify:before {\n    content: \"\\e902\";\n  }\n  .bxl-java:before {\n    content: \"\\e903\";\n  }\n  .bxl-heroku:before {\n    content: \"\\e904\";\n  }\n  .bxl-go-lang:before {\n    content: \"\\e905\";\n  }\n  .bxl-gmail:before {\n    content: \"\\e906\";\n  }\n  .bxl-flask:before {\n    content: \"\\e907\";\n  }\n  .bxl-99designs:before {\n    content: \"\\e908\";\n  }\n  .bxl-500px:before {\n    content: \"\\e909\";\n  }\n  .bxl-adobe:before {\n    content: \"\\e90a\";\n  }\n  .bxl-airbnb:before {\n    content: \"\\e90b\";\n  }\n  .bxl-algolia:before {\n    content: \"\\e90c\";\n  }\n  .bxl-amazon:before {\n    content: \"\\e90d\";\n  }\n  .bxl-android:before {\n    content: \"\\e90e\";\n  }\n  .bxl-angular:before {\n    content: \"\\e90f\";\n  }\n  .bxl-apple:before {\n    content: \"\\e910\";\n  }\n  .bxl-audible:before {\n    content: \"\\e911\";\n  }\n  .bxl-aws:before {\n    content: \"\\e912\";\n  }\n  .bxl-baidu:before {\n    content: \"\\e913\";\n  }\n  .bxl-behance:before {\n    content: \"\\e914\";\n  }\n  .bxl-bing:before {\n    content: \"\\e915\";\n  }\n  .bxl-bitcoin:before {\n    content: \"\\e916\";\n  }\n  .bxl-blender:before {\n    content: \"\\e917\";\n  }\n  .bxl-blogger:before {\n    content: \"\\e918\";\n  }\n  .bxl-bootstrap:before {\n    content: \"\\e919\";\n  }\n  .bxl-chrome:before {\n    content: \"\\e91a\";\n  }\n  .bxl-codepen:before {\n    content: \"\\e91b\";\n  }\n  .bxl-c-plus-plus:before {\n    content: \"\\e91c\";\n  }\n  .bxl-creative-commons:before {\n    content: \"\\e91d\";\n  }\n  .bxl-css3:before {\n    content: \"\\e91e\";\n  }\n  .bxl-dailymotion:before {\n    content: \"\\e91f\";\n  }\n  .bxl-deviantart:before {\n    content: \"\\e920\";\n  }\n  .bxl-dev-to:before {\n    content: \"\\e921\";\n  }\n  .bxl-digg:before {\n    content: \"\\e922\";\n  }\n  .bxl-digitalocean:before {\n    content: \"\\e923\";\n  }\n  .bxl-discord:before {\n    content: \"\\e924\";\n  }\n  .bxl-discord-alt:before {\n    content: \"\\e925\";\n  }\n  .bxl-discourse:before {\n    content: \"\\e926\";\n  }\n  .bxl-django:before {\n    content: \"\\e927\";\n  }\n  .bxl-docker:before {\n    content: \"\\e928\";\n  }\n  .bxl-dribbble:before {\n    content: \"\\e929\";\n  }\n  .bxl-dropbox:before {\n    content: \"\\e92a\";\n  }\n  .bxl-drupal:before {\n    content: \"\\e92b\";\n  }\n  .bxl-ebay:before {\n    content: \"\\e92c\";\n  }\n  .bxl-edge:before {\n    content: \"\\e92d\";\n  }\n  .bxl-etsy:before {\n    content: \"\\e92e\";\n  }\n  .bxl-facebook:before {\n    content: \"\\e92f\";\n  }\n  .bxl-facebook-circle:before {\n    content: \"\\e930\";\n  }\n  .bxl-facebook-square:before {\n    content: \"\\e931\";\n  }\n  .bxl-figma:before {\n    content: \"\\e932\";\n  }\n  .bxl-firebase:before {\n    content: \"\\e933\";\n  }\n  .bxl-firefox:before {\n    content: \"\\e934\";\n  }\n  .bxl-flickr:before {\n    content: \"\\e935\";\n  }\n  .bxl-flickr-square:before {\n    content: \"\\e936\";\n  }\n  .bxl-flutter:before {\n    content: \"\\e937\";\n  }\n  .bxl-foursquare:before {\n    content: \"\\e938\";\n  }\n  .bxl-git:before {\n    content: \"\\e939\";\n  }\n  .bxl-github:before {\n    content: \"\\e93a\";\n  }\n  .bxl-gitlab:before {\n    content: \"\\e93b\";\n  }\n  .bxl-google:before {\n    content: \"\\e93c\";\n  }\n  .bxl-google-cloud:before {\n    content: \"\\e93d\";\n  }\n  .bxl-google-plus:before {\n    content: \"\\e93e\";\n  }\n  .bxl-google-plus-circle:before {\n    content: \"\\e93f\";\n  }\n  .bxl-html5:before {\n    content: \"\\e940\";\n  }\n  .bxl-imdb:before {\n    content: \"\\e941\";\n  }\n  .bxl-instagram:before {\n    content: \"\\e942\";\n  }\n  .bxl-instagram-alt:before {\n    content: \"\\e943\";\n  }\n  .bxl-internet-explorer:before {\n    content: \"\\e944\";\n  }\n  .bxl-invision:before {\n    content: \"\\e945\";\n  }\n  .bxl-javascript:before {\n    content: \"\\e946\";\n  }\n  .bxl-joomla:before {\n    content: \"\\e947\";\n  }\n  .bxl-jquery:before {\n    content: \"\\e948\";\n  }\n  .bxl-jsfiddle:before {\n    content: \"\\e949\";\n  }\n  .bxl-kickstarter:before {\n    content: \"\\e94a\";\n  }\n  .bxl-kubernetes:before {\n    content: \"\\e94b\";\n  }\n  .bxl-less:before {\n    content: \"\\e94c\";\n  }\n  .bxl-linkedin:before {\n    content: \"\\e94d\";\n  }\n  .bxl-linkedin-square:before {\n    content: \"\\e94e\";\n  }\n  .bxl-magento:before {\n    content: \"\\e94f\";\n  }\n  .bxl-mailchimp:before {\n    content: \"\\e950\";\n  }\n  .bxl-markdown:before {\n    content: \"\\e951\";\n  }\n  .bxl-mastercard:before {\n    content: \"\\e952\";\n  }\n  .bxl-mastodon:before {\n    content: \"\\e953\";\n  }\n  .bxl-medium:before {\n    content: \"\\e954\";\n  }\n  .bxl-medium-old:before {\n    content: \"\\e955\";\n  }\n  .bxl-medium-square:before {\n    content: \"\\e956\";\n  }\n  .bxl-messenger:before {\n    content: \"\\e957\";\n  }\n  .bxl-microsoft:before {\n    content: \"\\e958\";\n  }\n  .bxl-microsoft-teams:before {\n    content: \"\\e959\";\n  }\n  .bxl-nodejs:before {\n    content: \"\\e95a\";\n  }\n  .bxl-ok-ru:before {\n    content: \"\\e95b\";\n  }\n  .bxl-opera:before {\n    content: \"\\e95c\";\n  }\n  .bxl-patreon:before {\n    content: \"\\e95d\";\n  }\n  .bxl-paypal:before {\n    content: \"\\e95e\";\n  }\n  .bxl-periscope:before {\n    content: \"\\e95f\";\n  }\n  .bxl-php:before {\n    content: \"\\e960\";\n  }\n  .bxl-pinterest:before {\n    content: \"\\e961\";\n  }\n  .bxl-pinterest-alt:before {\n    content: \"\\e962\";\n  }\n  .bxl-play-store:before {\n    content: \"\\e963\";\n  }\n  .bxl-pocket:before {\n    content: \"\\e964\";\n  }\n  .bxl-product-hunt:before {\n    content: \"\\e965\";\n  }\n  .bxl-python:before {\n    content: \"\\e966\";\n  }\n  .bxl-quora:before {\n    content: \"\\e967\";\n  }\n  .bxl-react:before {\n    content: \"\\e968\";\n  }\n  .bxl-redbubble:before {\n    content: \"\\e969\";\n  }\n  .bxl-reddit:before {\n    content: \"\\e96a\";\n  }\n  .bxl-redux:before {\n    content: \"\\e96b\";\n  }\n  .bxl-sass:before {\n    content: \"\\e96c\";\n  }\n  .bxl-shopify:before {\n    content: \"\\e96d\";\n  }\n  .bxl-sketch:before {\n    content: \"\\e96e\";\n  }\n  .bxl-skype:before {\n    content: \"\\e96f\";\n  }\n  .bxl-slack:before {\n    content: \"\\e970\";\n  }\n  .bxl-slack-old:before {\n    content: \"\\e971\";\n  }\n  .bxl-snapchat:before {\n    content: \"\\e972\";\n  }\n  .bxl-soundcloud:before {\n    content: \"\\e973\";\n  }\n  .bxl-spotify:before {\n    content: \"\\e974\";\n  }\n  .bxl-spring-boot:before {\n    content: \"\\e975\";\n  }\n  .bxl-squarespace:before {\n    content: \"\\e976\";\n  }\n  .bxl-stack-overflow:before {\n    content: \"\\e977\";\n  }\n  .bxl-steam:before {\n    content: \"\\e978\";\n  }\n  .bxl-stripe:before {\n    content: \"\\e979\";\n  }\n  .bxl-tailwind-css:before {\n    content: \"\\e97a\";\n  }\n  .bxl-telegram:before {\n    content: \"\\e97b\";\n  }\n  .bxl-tiktok:before {\n    content: \"\\e97c\";\n  }\n  .bxl-trello:before {\n    content: \"\\e97d\";\n  }\n  .bxl-trip-advisor:before {\n    content: \"\\e97e\";\n  }\n  .bxl-tumblr:before {\n    content: \"\\e97f\";\n  }\n  .bxl-tux:before {\n    content: \"\\e980\";\n  }\n  .bxl-twitch:before {\n    content: \"\\e981\";\n  }\n  .bxl-twitter:before {\n    content: \"\\e982\";\n  }\n  .bxl-unity:before {\n    content: \"\\e983\";\n  }\n  .bxl-unsplash:before {\n    content: \"\\e984\";\n  }\n  .bxl-vimeo:before {\n    content: \"\\e985\";\n  }\n  .bxl-visa:before {\n    content: \"\\e986\";\n  }\n  .bxl-visual-studio:before {\n    content: \"\\e987\";\n  }\n  .bxl-vk:before {\n    content: \"\\e988\";\n  }\n  .bxl-vuejs:before {\n    content: \"\\e989\";\n  }\n  .bxl-whatsapp:before {\n    content: \"\\e98a\";\n  }\n  .bxl-whatsapp-square:before {\n    content: \"\\e98b\";\n  }\n  .bxl-wikipedia:before {\n    content: \"\\e98c\";\n  }\n  .bxl-windows:before {\n    content: \"\\e98d\";\n  }\n  .bxl-wix:before {\n    content: \"\\e98e\";\n  }\n  .bxl-wordpress:before {\n    content: \"\\e98f\";\n  }\n  .bxl-yahoo:before {\n    content: \"\\e990\";\n  }\n  .bxl-yelp:before {\n    content: \"\\e991\";\n  }\n  .bxl-youtube:before {\n    content: \"\\e992\";\n  }\n  .bxl-zoom:before {\n    content: \"\\e993\";\n  }\n  .bx-collapse-alt:before {\n    content: \"\\e994\";\n  }\n  .bx-collapse-horizontal:before {\n    content: \"\\e995\";\n  }\n  .bx-collapse-vertical:before {\n    content: \"\\e996\";\n  }\n  .bx-expand-horizontal:before {\n    content: \"\\e997\";\n  }\n  .bx-expand-vertical:before {\n    content: \"\\e998\";\n  }\n  .bx-injection:before {\n    content: \"\\e999\";\n  }\n  .bx-leaf:before {\n    content: \"\\e99a\";\n  }\n  .bx-math:before {\n    content: \"\\e99b\";\n  }\n  .bx-party:before {\n    content: \"\\e99c\";\n  }\n  .bx-abacus:before {\n    content: \"\\e99d\";\n  }\n  .bx-accessibility:before {\n    content: \"\\e99e\";\n  }\n  .bx-add-to-queue:before {\n    content: \"\\e99f\";\n  }\n  .bx-adjust:before {\n    content: \"\\e9a0\";\n  }\n  .bx-alarm:before {\n    content: \"\\e9a1\";\n  }\n  .bx-alarm-add:before {\n    content: \"\\e9a2\";\n  }\n  .bx-alarm-exclamation:before {\n    content: \"\\e9a3\";\n  }\n  .bx-alarm-off:before {\n    content: \"\\e9a4\";\n  }\n  .bx-alarm-snooze:before {\n    content: \"\\e9a5\";\n  }\n  .bx-album:before {\n    content: \"\\e9a6\";\n  }\n  .bx-align-justify:before {\n    content: \"\\e9a7\";\n  }\n  .bx-align-left:before {\n    content: \"\\e9a8\";\n  }\n  .bx-align-middle:before {\n    content: \"\\e9a9\";\n  }\n  .bx-align-right:before {\n    content: \"\\e9aa\";\n  }\n  .bx-analyse:before {\n    content: \"\\e9ab\";\n  }\n  .bx-anchor:before {\n    content: \"\\e9ac\";\n  }\n  .bx-angry:before {\n    content: \"\\e9ad\";\n  }\n  .bx-aperture:before {\n    content: \"\\e9ae\";\n  }\n  .bx-arch:before {\n    content: \"\\e9af\";\n  }\n  .bx-archive:before {\n    content: \"\\e9b0\";\n  }\n  .bx-archive-in:before {\n    content: \"\\e9b1\";\n  }\n  .bx-archive-out:before {\n    content: \"\\e9b2\";\n  }\n  .bx-area:before {\n    content: \"\\e9b3\";\n  }\n  .bx-arrow-back:before {\n    content: \"\\e9b4\";\n  }\n  .bx-arrow-from-bottom:before {\n    content: \"\\e9b5\";\n  }\n  .bx-arrow-from-left:before {\n    content: \"\\e9b6\";\n  }\n  .bx-arrow-from-right:before {\n    content: \"\\e9b7\";\n  }\n  .bx-arrow-from-top:before {\n    content: \"\\e9b8\";\n  }\n  .bx-arrow-to-bottom:before {\n    content: \"\\e9b9\";\n  }\n  .bx-arrow-to-left:before {\n    content: \"\\e9ba\";\n  }\n  .bx-arrow-to-right:before {\n    content: \"\\e9bb\";\n  }\n  .bx-arrow-to-top:before {\n    content: \"\\e9bc\";\n  }\n  .bx-at:before {\n    content: \"\\e9bd\";\n  }\n  .bx-atom:before {\n    content: \"\\e9be\";\n  }\n  .bx-award:before {\n    content: \"\\e9bf\";\n  }\n  .bx-badge:before {\n    content: \"\\e9c0\";\n  }\n  .bx-badge-check:before {\n    content: \"\\e9c1\";\n  }\n  .bx-ball:before {\n    content: \"\\e9c2\";\n  }\n  .bx-band-aid:before {\n    content: \"\\e9c3\";\n  }\n  .bx-bar-chart:before {\n    content: \"\\e9c4\";\n  }\n  .bx-bar-chart-alt:before {\n    content: \"\\e9c5\";\n  }\n  .bx-bar-chart-alt-2:before {\n    content: \"\\e9c6\";\n  }\n  .bx-bar-chart-square:before {\n    content: \"\\e9c7\";\n  }\n  .bx-barcode:before {\n    content: \"\\e9c8\";\n  }\n  .bx-barcode-reader:before {\n    content: \"\\e9c9\";\n  }\n  .bx-baseball:before {\n    content: \"\\e9ca\";\n  }\n  .bx-basket:before {\n    content: \"\\e9cb\";\n  }\n  .bx-basketball:before {\n    content: \"\\e9cc\";\n  }\n  .bx-bath:before {\n    content: \"\\e9cd\";\n  }\n  .bx-battery:before {\n    content: \"\\e9ce\";\n  }\n  .bx-bed:before {\n    content: \"\\e9cf\";\n  }\n  .bx-been-here:before {\n    content: \"\\e9d0\";\n  }\n  .bx-beer:before {\n    content: \"\\e9d1\";\n  }\n  .bx-bell:before {\n    content: \"\\e9d2\";\n  }\n  .bx-bell-minus:before {\n    content: \"\\e9d3\";\n  }\n  .bx-bell-off:before {\n    content: \"\\e9d4\";\n  }\n  .bx-bell-plus:before {\n    content: \"\\e9d5\";\n  }\n  .bx-bible:before {\n    content: \"\\e9d6\";\n  }\n  .bx-bitcoin:before {\n    content: \"\\e9d7\";\n  }\n  .bx-blanket:before {\n    content: \"\\e9d8\";\n  }\n  .bx-block:before {\n    content: \"\\e9d9\";\n  }\n  .bx-bluetooth:before {\n    content: \"\\e9da\";\n  }\n  .bx-body:before {\n    content: \"\\e9db\";\n  }\n  .bx-bold:before {\n    content: \"\\e9dc\";\n  }\n  .bx-bolt-circle:before {\n    content: \"\\e9dd\";\n  }\n  .bx-bomb:before {\n    content: \"\\e9de\";\n  }\n  .bx-bone:before {\n    content: \"\\e9df\";\n  }\n  .bx-bong:before {\n    content: \"\\e9e0\";\n  }\n  .bx-book:before {\n    content: \"\\e9e1\";\n  }\n  .bx-book-add:before {\n    content: \"\\e9e2\";\n  }\n  .bx-book-alt:before {\n    content: \"\\e9e3\";\n  }\n  .bx-book-bookmark:before {\n    content: \"\\e9e4\";\n  }\n  .bx-book-content:before {\n    content: \"\\e9e5\";\n  }\n  .bx-book-heart:before {\n    content: \"\\e9e6\";\n  }\n  .bx-bookmark:before {\n    content: \"\\e9e7\";\n  }\n  .bx-bookmark-alt:before {\n    content: \"\\e9e8\";\n  }\n  .bx-bookmark-alt-minus:before {\n    content: \"\\e9e9\";\n  }\n  .bx-bookmark-alt-plus:before {\n    content: \"\\e9ea\";\n  }\n  .bx-bookmark-heart:before {\n    content: \"\\e9eb\";\n  }\n  .bx-bookmark-minus:before {\n    content: \"\\e9ec\";\n  }\n  .bx-bookmark-plus:before {\n    content: \"\\e9ed\";\n  }\n  .bx-bookmarks:before {\n    content: \"\\e9ee\";\n  }\n  .bx-book-open:before {\n    content: \"\\e9ef\";\n  }\n  .bx-book-reader:before {\n    content: \"\\e9f0\";\n  }\n  .bx-border-all:before {\n    content: \"\\e9f1\";\n  }\n  .bx-border-bottom:before {\n    content: \"\\e9f2\";\n  }\n  .bx-border-inner:before {\n    content: \"\\e9f3\";\n  }\n  .bx-border-left:before {\n    content: \"\\e9f4\";\n  }\n  .bx-border-none:before {\n    content: \"\\e9f5\";\n  }\n  .bx-border-outer:before {\n    content: \"\\e9f6\";\n  }\n  .bx-border-radius:before {\n    content: \"\\e9f7\";\n  }\n  .bx-border-right:before {\n    content: \"\\e9f8\";\n  }\n  .bx-border-top:before {\n    content: \"\\e9f9\";\n  }\n  .bx-bot:before {\n    content: \"\\e9fa\";\n  }\n  .bx-bowling-ball:before {\n    content: \"\\e9fb\";\n  }\n  .bx-box:before {\n    content: \"\\e9fc\";\n  }\n  .bx-bracket:before {\n    content: \"\\e9fd\";\n  }\n  .bx-braille:before {\n    content: \"\\e9fe\";\n  }\n  .bx-brain:before {\n    content: \"\\e9ff\";\n  }\n  .bx-briefcase:before {\n    content: \"\\ea00\";\n  }\n  .bx-briefcase-alt:before {\n    content: \"\\ea01\";\n  }\n  .bx-briefcase-alt-2:before {\n    content: \"\\ea02\";\n  }\n  .bx-brightness:before {\n    content: \"\\ea03\";\n  }\n  .bx-brightness-half:before {\n    content: \"\\ea04\";\n  }\n  .bx-broadcast:before {\n    content: \"\\ea05\";\n  }\n  .bx-brush:before {\n    content: \"\\ea06\";\n  }\n  .bx-brush-alt:before {\n    content: \"\\ea07\";\n  }\n  .bx-bug:before {\n    content: \"\\ea08\";\n  }\n  .bx-bug-alt:before {\n    content: \"\\ea09\";\n  }\n  .bx-building:before {\n    content: \"\\ea0a\";\n  }\n  .bx-building-house:before {\n    content: \"\\ea0b\";\n  }\n  .bx-buildings:before {\n    content: \"\\ea0c\";\n  }\n  .bx-bulb:before {\n    content: \"\\ea0d\";\n  }\n  .bx-bullseye:before {\n    content: \"\\ea0e\";\n  }\n  .bx-buoy:before {\n    content: \"\\ea0f\";\n  }\n  .bx-bus:before {\n    content: \"\\ea10\";\n  }\n  .bx-bus-school:before {\n    content: \"\\ea11\";\n  }\n  .bx-cabinet:before {\n    content: \"\\ea12\";\n  }\n  .bx-cake:before {\n    content: \"\\ea13\";\n  }\n  .bx-calculator:before {\n    content: \"\\ea14\";\n  }\n  .bx-calendar:before {\n    content: \"\\ea15\";\n  }\n  .bx-calendar-alt:before {\n    content: \"\\ea16\";\n  }\n  .bx-calendar-check:before {\n    content: \"\\ea17\";\n  }\n  .bx-calendar-edit:before {\n    content: \"\\ea18\";\n  }\n  .bx-calendar-event:before {\n    content: \"\\ea19\";\n  }\n  .bx-calendar-exclamation:before {\n    content: \"\\ea1a\";\n  }\n  .bx-calendar-heart:before {\n    content: \"\\ea1b\";\n  }\n  .bx-calendar-minus:before {\n    content: \"\\ea1c\";\n  }\n  .bx-calendar-plus:before {\n    content: \"\\ea1d\";\n  }\n  .bx-calendar-star:before {\n    content: \"\\ea1e\";\n  }\n  .bx-calendar-week:before {\n    content: \"\\ea1f\";\n  }\n  .bx-calendar-x:before {\n    content: \"\\ea20\";\n  }\n  .bx-camera:before {\n    content: \"\\ea21\";\n  }\n  .bx-camera-home:before {\n    content: \"\\ea22\";\n  }\n  .bx-camera-movie:before {\n    content: \"\\ea23\";\n  }\n  .bx-camera-off:before {\n    content: \"\\ea24\";\n  }\n  .bx-capsule:before {\n    content: \"\\ea25\";\n  }\n  .bx-captions:before {\n    content: \"\\ea26\";\n  }\n  .bx-car:before {\n    content: \"\\ea27\";\n  }\n  .bx-card:before {\n    content: \"\\ea28\";\n  }\n  .bx-caret-down:before {\n    content: \"\\ea29\";\n  }\n  .bx-caret-down-circle:before {\n    content: \"\\ea2a\";\n  }\n  .bx-caret-down-square:before {\n    content: \"\\ea2b\";\n  }\n  .bx-caret-left:before {\n    content: \"\\ea2c\";\n  }\n  .bx-caret-left-circle:before {\n    content: \"\\ea2d\";\n  }\n  .bx-caret-left-square:before {\n    content: \"\\ea2e\";\n  }\n  .bx-caret-right:before {\n    content: \"\\ea2f\";\n  }\n  .bx-caret-right-circle:before {\n    content: \"\\ea30\";\n  }\n  .bx-caret-right-square:before {\n    content: \"\\ea31\";\n  }\n  .bx-caret-up:before {\n    content: \"\\ea32\";\n  }\n  .bx-caret-up-circle:before {\n    content: \"\\ea33\";\n  }\n  .bx-caret-up-square:before {\n    content: \"\\ea34\";\n  }\n  .bx-carousel:before {\n    content: \"\\ea35\";\n  }\n  .bx-cart:before {\n    content: \"\\ea36\";\n  }\n  .bx-cart-alt:before {\n    content: \"\\ea37\";\n  }\n  .bx-cast:before {\n    content: \"\\ea38\";\n  }\n  .bx-category:before {\n    content: \"\\ea39\";\n  }\n  .bx-category-alt:before {\n    content: \"\\ea3a\";\n  }\n  .bx-cctv:before {\n    content: \"\\ea3b\";\n  }\n  .bx-certification:before {\n    content: \"\\ea3c\";\n  }\n  .bx-chair:before {\n    content: \"\\ea3d\";\n  }\n  .bx-chalkboard:before {\n    content: \"\\ea3e\";\n  }\n  .bx-chart:before {\n    content: \"\\ea3f\";\n  }\n  .bx-chat:before {\n    content: \"\\ea40\";\n  }\n  .bx-check:before {\n    content: \"\\ea41\";\n  }\n  .bx-checkbox:before {\n    content: \"\\ea42\";\n  }\n  .bx-checkbox-checked:before {\n    content: \"\\ea43\";\n  }\n  .bx-checkbox-minus:before {\n    content: \"\\ea44\";\n  }\n  .bx-checkbox-square:before {\n    content: \"\\ea45\";\n  }\n  .bx-check-circle:before {\n    content: \"\\ea46\";\n  }\n  .bx-check-double:before {\n    content: \"\\ea47\";\n  }\n  .bx-check-shield:before {\n    content: \"\\ea48\";\n  }\n  .bx-check-square:before {\n    content: \"\\ea49\";\n  }\n  .bx-chevron-down:before {\n    content: \"\\ea4a\";\n  }\n  .bx-chevron-down-circle:before {\n    content: \"\\ea4b\";\n  }\n  .bx-chevron-down-square:before {\n    content: \"\\ea4c\";\n  }\n  .bx-chevron-left:before {\n    content: \"\\ea4d\";\n  }\n  .bx-chevron-left-circle:before {\n    content: \"\\ea4e\";\n  }\n  .bx-chevron-left-square:before {\n    content: \"\\ea4f\";\n  }\n  .bx-chevron-right:before {\n    content: \"\\ea50\";\n  }\n  .bx-chevron-right-circle:before {\n    content: \"\\ea51\";\n  }\n  .bx-chevron-right-square:before {\n    content: \"\\ea52\";\n  }\n  .bx-chevrons-down:before {\n    content: \"\\ea53\";\n  }\n  .bx-chevrons-left:before {\n    content: \"\\ea54\";\n  }\n  .bx-chevrons-right:before {\n    content: \"\\ea55\";\n  }\n  .bx-chevrons-up:before {\n    content: \"\\ea56\";\n  }\n  .bx-chevron-up:before {\n    content: \"\\ea57\";\n  }\n  .bx-chevron-up-circle:before {\n    content: \"\\ea58\";\n  }\n  .bx-chevron-up-square:before {\n    content: \"\\ea59\";\n  }\n  .bx-chip:before {\n    content: \"\\ea5a\";\n  }\n  .bx-church:before {\n    content: \"\\ea5b\";\n  }\n  .bx-circle:before {\n    content: \"\\ea5c\";\n  }\n  .bx-clinic:before {\n    content: \"\\ea5d\";\n  }\n  .bx-clipboard:before {\n    content: \"\\ea5e\";\n  }\n  .bx-closet:before {\n    content: \"\\ea5f\";\n  }\n  .bx-cloud:before {\n    content: \"\\ea60\";\n  }\n  .bx-cloud-download:before {\n    content: \"\\ea61\";\n  }\n  .bx-cloud-drizzle:before {\n    content: \"\\ea62\";\n  }\n  .bx-cloud-lightning:before {\n    content: \"\\ea63\";\n  }\n  .bx-cloud-light-rain:before {\n    content: \"\\ea64\";\n  }\n  .bx-cloud-rain:before {\n    content: \"\\ea65\";\n  }\n  .bx-cloud-snow:before {\n    content: \"\\ea66\";\n  }\n  .bx-cloud-upload:before {\n    content: \"\\ea67\";\n  }\n  .bx-code:before {\n    content: \"\\ea68\";\n  }\n  .bx-code-alt:before {\n    content: \"\\ea69\";\n  }\n  .bx-code-block:before {\n    content: \"\\ea6a\";\n  }\n  .bx-code-curly:before {\n    content: \"\\ea6b\";\n  }\n  .bx-coffee:before {\n    content: \"\\ea6c\";\n  }\n  .bx-coffee-togo:before {\n    content: \"\\ea6d\";\n  }\n  .bx-cog:before {\n    content: \"\\ea6e\";\n  }\n  .bx-coin:before {\n    content: \"\\ea6f\";\n  }\n  .bx-coin-stack:before {\n    content: \"\\ea70\";\n  }\n  .bx-collapse:before {\n    content: \"\\ea71\";\n  }\n  .bx-collection:before {\n    content: \"\\ea72\";\n  }\n  .bx-color-fill:before {\n    content: \"\\ea73\";\n  }\n  .bx-columns:before {\n    content: \"\\ea74\";\n  }\n  .bx-command:before {\n    content: \"\\ea75\";\n  }\n  .bx-comment:before {\n    content: \"\\ea76\";\n  }\n  .bx-comment-add:before {\n    content: \"\\ea77\";\n  }\n  .bx-comment-check:before {\n    content: \"\\ea78\";\n  }\n  .bx-comment-detail:before {\n    content: \"\\ea79\";\n  }\n  .bx-comment-dots:before {\n    content: \"\\ea7a\";\n  }\n  .bx-comment-edit:before {\n    content: \"\\ea7b\";\n  }\n  .bx-comment-error:before {\n    content: \"\\ea7c\";\n  }\n  .bx-comment-minus:before {\n    content: \"\\ea7d\";\n  }\n  .bx-comment-x:before {\n    content: \"\\ea7e\";\n  }\n  .bx-compass:before {\n    content: \"\\ea7f\";\n  }\n  .bx-confused:before {\n    content: \"\\ea80\";\n  }\n  .bx-conversation:before {\n    content: \"\\ea81\";\n  }\n  .bx-cookie:before {\n    content: \"\\ea82\";\n  }\n  .bx-cool:before {\n    content: \"\\ea83\";\n  }\n  .bx-copy:before {\n    content: \"\\ea84\";\n  }\n  .bx-copy-alt:before {\n    content: \"\\ea85\";\n  }\n  .bx-copyright:before {\n    content: \"\\ea86\";\n  }\n  .bx-credit-card:before {\n    content: \"\\ea87\";\n  }\n  .bx-credit-card-alt:before {\n    content: \"\\ea88\";\n  }\n  .bx-credit-card-front:before {\n    content: \"\\ea89\";\n  }\n  .bx-crop:before {\n    content: \"\\ea8a\";\n  }\n  .bx-crosshair:before {\n    content: \"\\ea8b\";\n  }\n  .bx-crown:before {\n    content: \"\\ea8c\";\n  }\n  .bx-cube:before {\n    content: \"\\ea8d\";\n  }\n  .bx-cube-alt:before {\n    content: \"\\ea8e\";\n  }\n  .bx-cuboid:before {\n    content: \"\\ea8f\";\n  }\n  .bx-current-location:before {\n    content: \"\\ea90\";\n  }\n  .bx-customize:before {\n    content: \"\\ea91\";\n  }\n  .bx-cut:before {\n    content: \"\\ea92\";\n  }\n  .bx-cycling:before {\n    content: \"\\ea93\";\n  }\n  .bx-cylinder:before {\n    content: \"\\ea94\";\n  }\n  .bx-data:before {\n    content: \"\\ea95\";\n  }\n  .bx-desktop:before {\n    content: \"\\ea96\";\n  }\n  .bx-detail:before {\n    content: \"\\ea97\";\n  }\n  .bx-devices:before {\n    content: \"\\ea98\";\n  }\n  .bx-dialpad:before {\n    content: \"\\ea99\";\n  }\n  .bx-dialpad-alt:before {\n    content: \"\\ea9a\";\n  }\n  .bx-diamond:before {\n    content: \"\\ea9b\";\n  }\n  .bx-dice-1:before {\n    content: \"\\ea9c\";\n  }\n  .bx-dice-2:before {\n    content: \"\\ea9d\";\n  }\n  .bx-dice-3:before {\n    content: \"\\ea9e\";\n  }\n  .bx-dice-4:before {\n    content: \"\\ea9f\";\n  }\n  .bx-dice-5:before {\n    content: \"\\eaa0\";\n  }\n  .bx-dice-6:before {\n    content: \"\\eaa1\";\n  }\n  .bx-directions:before {\n    content: \"\\eaa2\";\n  }\n  .bx-disc:before {\n    content: \"\\eaa3\";\n  }\n  .bx-dish:before {\n    content: \"\\eaa4\";\n  }\n  .bx-dislike:before {\n    content: \"\\eaa5\";\n  }\n  .bx-dizzy:before {\n    content: \"\\eaa6\";\n  }\n  .bx-dna:before {\n    content: \"\\eaa7\";\n  }\n  .bx-dock-bottom:before {\n    content: \"\\eaa8\";\n  }\n  .bx-dock-left:before {\n    content: \"\\eaa9\";\n  }\n  .bx-dock-right:before {\n    content: \"\\eaaa\";\n  }\n  .bx-dock-top:before {\n    content: \"\\eaab\";\n  }\n  .bx-dollar:before {\n    content: \"\\eaac\";\n  }\n  .bx-dollar-circle:before {\n    content: \"\\eaad\";\n  }\n  .bx-donate-blood:before {\n    content: \"\\eaae\";\n  }\n  .bx-donate-heart:before {\n    content: \"\\eaaf\";\n  }\n  .bx-door-open:before {\n    content: \"\\eab0\";\n  }\n  .bx-dots-horizontal:before {\n    content: \"\\eab1\";\n  }\n  .bx-dots-horizontal-rounded:before {\n    content: \"\\eab2\";\n  }\n  .bx-dots-vertical:before {\n    content: \"\\eab3\";\n  }\n  .bx-dots-vertical-rounded:before {\n    content: \"\\eab4\";\n  }\n  .bx-doughnut-chart:before {\n    content: \"\\eab5\";\n  }\n  .bx-down-arrow:before {\n    content: \"\\eab6\";\n  }\n  .bx-down-arrow-alt:before {\n    content: \"\\eab7\";\n  }\n  .bx-down-arrow-circle:before {\n    content: \"\\eab8\";\n  }\n  .bx-download:before {\n    content: \"\\eab9\";\n  }\n  .bx-downvote:before {\n    content: \"\\eaba\";\n  }\n  .bx-drink:before {\n    content: \"\\eabb\";\n  }\n  .bx-droplet:before {\n    content: \"\\eabc\";\n  }\n  .bx-dumbbell:before {\n    content: \"\\eabd\";\n  }\n  .bx-duplicate:before {\n    content: \"\\eabe\";\n  }\n  .bx-edit:before {\n    content: \"\\eabf\";\n  }\n  .bx-edit-alt:before {\n    content: \"\\eac0\";\n  }\n  .bx-envelope:before {\n    content: \"\\eac1\";\n  }\n  .bx-envelope-open:before {\n    content: \"\\eac2\";\n  }\n  .bx-equalizer:before {\n    content: \"\\eac3\";\n  }\n  .bx-eraser:before {\n    content: \"\\eac4\";\n  }\n  .bx-error:before {\n    content: \"\\eac5\";\n  }\n  .bx-error-alt:before {\n    content: \"\\eac6\";\n  }\n  .bx-error-circle:before {\n    content: \"\\eac7\";\n  }\n  .bx-euro:before {\n    content: \"\\eac8\";\n  }\n  .bx-exclude:before {\n    content: \"\\eac9\";\n  }\n  .bx-exit:before {\n    content: \"\\eaca\";\n  }\n  .bx-exit-fullscreen:before {\n    content: \"\\eacb\";\n  }\n  .bx-expand:before {\n    content: \"\\eacc\";\n  }\n  .bx-expand-alt:before {\n    content: \"\\eacd\";\n  }\n  .bx-export:before {\n    content: \"\\eace\";\n  }\n  .bx-extension:before {\n    content: \"\\eacf\";\n  }\n  .bx-face:before {\n    content: \"\\ead0\";\n  }\n  .bx-fast-forward:before {\n    content: \"\\ead1\";\n  }\n  .bx-fast-forward-circle:before {\n    content: \"\\ead2\";\n  }\n  .bx-female:before {\n    content: \"\\ead3\";\n  }\n  .bx-female-sign:before {\n    content: \"\\ead4\";\n  }\n  .bx-file:before {\n    content: \"\\ead5\";\n  }\n  .bx-file-blank:before {\n    content: \"\\ead6\";\n  }\n  .bx-file-find:before {\n    content: \"\\ead7\";\n  }\n  .bx-film:before {\n    content: \"\\ead8\";\n  }\n  .bx-filter:before {\n    content: \"\\ead9\";\n  }\n  .bx-filter-alt:before {\n    content: \"\\eada\";\n  }\n  .bx-fingerprint:before {\n    content: \"\\eadb\";\n  }\n  .bx-first-aid:before {\n    content: \"\\eadc\";\n  }\n  .bx-first-page:before {\n    content: \"\\eadd\";\n  }\n  .bx-flag:before {\n    content: \"\\eade\";\n  }\n  .bx-folder:before {\n    content: \"\\eadf\";\n  }\n  .bx-folder-minus:before {\n    content: \"\\eae0\";\n  }\n  .bx-folder-open:before {\n    content: \"\\eae1\";\n  }\n  .bx-folder-plus:before {\n    content: \"\\eae2\";\n  }\n  .bx-font:before {\n    content: \"\\eae3\";\n  }\n  .bx-font-color:before {\n    content: \"\\eae4\";\n  }\n  .bx-font-family:before {\n    content: \"\\eae5\";\n  }\n  .bx-font-size:before {\n    content: \"\\eae6\";\n  }\n  .bx-food-menu:before {\n    content: \"\\eae7\";\n  }\n  .bx-food-tag:before {\n    content: \"\\eae8\";\n  }\n  .bx-football:before {\n    content: \"\\eae9\";\n  }\n  .bx-fridge:before {\n    content: \"\\eaea\";\n  }\n  .bx-fullscreen:before {\n    content: \"\\eaeb\";\n  }\n  .bx-game:before {\n    content: \"\\eaec\";\n  }\n  .bx-gas-pump:before {\n    content: \"\\eaed\";\n  }\n  .bx-ghost:before {\n    content: \"\\eaee\";\n  }\n  .bx-gift:before {\n    content: \"\\eaef\";\n  }\n  .bx-git-branch:before {\n    content: \"\\eaf0\";\n  }\n  .bx-git-commit:before {\n    content: \"\\eaf1\";\n  }\n  .bx-git-compare:before {\n    content: \"\\eaf2\";\n  }\n  .bx-git-merge:before {\n    content: \"\\eaf3\";\n  }\n  .bx-git-pull-request:before {\n    content: \"\\eaf4\";\n  }\n  .bx-git-repo-forked:before {\n    content: \"\\eaf5\";\n  }\n  .bx-glasses:before {\n    content: \"\\eaf6\";\n  }\n  .bx-glasses-alt:before {\n    content: \"\\eaf7\";\n  }\n  .bx-globe:before {\n    content: \"\\eaf8\";\n  }\n  .bx-globe-alt:before {\n    content: \"\\eaf9\";\n  }\n  .bx-grid:before {\n    content: \"\\eafa\";\n  }\n  .bx-grid-alt:before {\n    content: \"\\eafb\";\n  }\n  .bx-grid-horizontal:before {\n    content: \"\\eafc\";\n  }\n  .bx-grid-small:before {\n    content: \"\\eafd\";\n  }\n  .bx-grid-vertical:before {\n    content: \"\\eafe\";\n  }\n  .bx-group:before {\n    content: \"\\eaff\";\n  }\n  .bx-handicap:before {\n    content: \"\\eb00\";\n  }\n  .bx-happy:before {\n    content: \"\\eb01\";\n  }\n  .bx-happy-alt:before {\n    content: \"\\eb02\";\n  }\n  .bx-happy-beaming:before {\n    content: \"\\eb03\";\n  }\n  .bx-happy-heart-eyes:before {\n    content: \"\\eb04\";\n  }\n  .bx-hash:before {\n    content: \"\\eb05\";\n  }\n  .bx-hdd:before {\n    content: \"\\eb06\";\n  }\n  .bx-heading:before {\n    content: \"\\eb07\";\n  }\n  .bx-headphone:before {\n    content: \"\\eb08\";\n  }\n  .bx-health:before {\n    content: \"\\eb09\";\n  }\n  .bx-heart:before {\n    content: \"\\eb0a\";\n  }\n  .bx-heart-circle:before {\n    content: \"\\eb0b\";\n  }\n  .bx-heart-square:before {\n    content: \"\\eb0c\";\n  }\n  .bx-help-circle:before {\n    content: \"\\eb0d\";\n  }\n  .bx-hide:before {\n    content: \"\\eb0e\";\n  }\n  .bx-highlight:before {\n    content: \"\\eb0f\";\n  }\n  .bx-history:before {\n    content: \"\\eb10\";\n  }\n  .bx-hive:before {\n    content: \"\\eb11\";\n  }\n  .bx-home:before {\n    content: \"\\eb12\";\n  }\n  .bx-home-alt:before {\n    content: \"\\eb13\";\n  }\n  .bx-home-circle:before {\n    content: \"\\eb14\";\n  }\n  .bx-home-heart:before {\n    content: \"\\eb15\";\n  }\n  .bx-home-smile:before {\n    content: \"\\eb16\";\n  }\n  .bx-horizontal-center:before {\n    content: \"\\eb17\";\n  }\n  .bx-hotel:before {\n    content: \"\\eb18\";\n  }\n  .bx-hourglass:before {\n    content: \"\\eb19\";\n  }\n  .bx-id-card:before {\n    content: \"\\eb1a\";\n  }\n  .bx-image:before {\n    content: \"\\eb1b\";\n  }\n  .bx-image-add:before {\n    content: \"\\eb1c\";\n  }\n  .bx-image-alt:before {\n    content: \"\\eb1d\";\n  }\n  .bx-images:before {\n    content: \"\\eb1e\";\n  }\n  .bx-import:before {\n    content: \"\\eb1f\";\n  }\n  .bx-infinite:before {\n    content: \"\\eb20\";\n  }\n  .bx-info-circle:before {\n    content: \"\\eb21\";\n  }\n  .bx-info-square:before {\n    content: \"\\eb22\";\n  }\n  .bx-intersect:before {\n    content: \"\\eb23\";\n  }\n  .bx-italic:before {\n    content: \"\\eb24\";\n  }\n  .bx-joystick:before {\n    content: \"\\eb25\";\n  }\n  .bx-joystick-alt:before {\n    content: \"\\eb26\";\n  }\n  .bx-joystick-button:before {\n    content: \"\\eb27\";\n  }\n  .bx-key:before {\n    content: \"\\eb28\";\n  }\n  .bx-label:before {\n    content: \"\\eb29\";\n  }\n  .bx-landscape:before {\n    content: \"\\eb2a\";\n  }\n  .bx-laptop:before {\n    content: \"\\eb2b\";\n  }\n  .bx-last-page:before {\n    content: \"\\eb2c\";\n  }\n  .bx-laugh:before {\n    content: \"\\eb2d\";\n  }\n  .bx-layer:before {\n    content: \"\\eb2e\";\n  }\n  .bx-layer-minus:before {\n    content: \"\\eb2f\";\n  }\n  .bx-layer-plus:before {\n    content: \"\\eb30\";\n  }\n  .bx-layout:before {\n    content: \"\\eb31\";\n  }\n  .bx-left-arrow:before {\n    content: \"\\eb32\";\n  }\n  .bx-left-arrow-alt:before {\n    content: \"\\eb33\";\n  }\n  .bx-left-arrow-circle:before {\n    content: \"\\eb34\";\n  }\n  .bx-left-down-arrow-circle:before {\n    content: \"\\eb35\";\n  }\n  .bx-left-indent:before {\n    content: \"\\eb36\";\n  }\n  .bx-left-top-arrow-circle:before {\n    content: \"\\eb37\";\n  }\n  .bx-library:before {\n    content: \"\\eb38\";\n  }\n  .bx-like:before {\n    content: \"\\eb39\";\n  }\n  .bx-line-chart:before {\n    content: \"\\eb3a\";\n  }\n  .bx-line-chart-down:before {\n    content: \"\\eb3b\";\n  }\n  .bx-link:before {\n    content: \"\\eb3c\";\n  }\n  .bx-link-alt:before {\n    content: \"\\eb3d\";\n  }\n  .bx-link-external:before {\n    content: \"\\eb3e\";\n  }\n  .bx-lira:before {\n    content: \"\\eb3f\";\n  }\n  .bx-list-check:before {\n    content: \"\\eb40\";\n  }\n  .bx-list-minus:before {\n    content: \"\\eb41\";\n  }\n  .bx-list-ol:before {\n    content: \"\\eb42\";\n  }\n  .bx-list-plus:before {\n    content: \"\\eb43\";\n  }\n  .bx-list-ul:before {\n    content: \"\\eb44\";\n  }\n  .bx-loader:before {\n    content: \"\\eb45\";\n  }\n  .bx-loader-alt:before {\n    content: \"\\eb46\";\n  }\n  .bx-loader-circle:before {\n    content: \"\\eb47\";\n  }\n  .bx-location-plus:before {\n    content: \"\\eb48\";\n  }\n  .bx-lock:before {\n    content: \"\\eb49\";\n  }\n  .bx-lock-alt:before {\n    content: \"\\eb4a\";\n  }\n  .bx-lock-open:before {\n    content: \"\\eb4b\";\n  }\n  .bx-lock-open-alt:before {\n    content: \"\\eb4c\";\n  }\n  .bx-log-in:before {\n    content: \"\\eb4d\";\n  }\n  .bx-log-in-circle:before {\n    content: \"\\eb4e\";\n  }\n  .bx-log-out:before {\n    content: \"\\eb4f\";\n  }\n  .bx-log-out-circle:before {\n    content: \"\\eb50\";\n  }\n  .bx-low-vision:before {\n    content: \"\\eb51\";\n  }\n  .bx-magnet:before {\n    content: \"\\eb52\";\n  }\n  .bx-mail-send:before {\n    content: \"\\eb53\";\n  }\n  .bx-male:before {\n    content: \"\\eb54\";\n  }\n  .bx-male-sign:before {\n    content: \"\\eb55\";\n  }\n  .bx-map:before {\n    content: \"\\eb56\";\n  }\n  .bx-map-alt:before {\n    content: \"\\eb57\";\n  }\n  .bx-map-pin:before {\n    content: \"\\eb58\";\n  }\n  .bx-mask:before {\n    content: \"\\eb59\";\n  }\n  .bx-medal:before {\n    content: \"\\eb5a\";\n  }\n  .bx-meh:before {\n    content: \"\\eb5b\";\n  }\n  .bx-meh-alt:before {\n    content: \"\\eb5c\";\n  }\n  .bx-meh-blank:before {\n    content: \"\\eb5d\";\n  }\n  .bx-memory-card:before {\n    content: \"\\eb5e\";\n  }\n  .bx-menu:before {\n    content: \"\\eb5f\";\n  }\n  .bx-menu-alt-left:before {\n    content: \"\\eb60\";\n  }\n  .bx-menu-alt-right:before {\n    content: \"\\eb61\";\n  }\n  .bx-merge:before {\n    content: \"\\eb62\";\n  }\n  .bx-message:before {\n    content: \"\\eb63\";\n  }\n  .bx-message-add:before {\n    content: \"\\eb64\";\n  }\n  .bx-message-alt:before {\n    content: \"\\eb65\";\n  }\n  .bx-message-alt-add:before {\n    content: \"\\eb66\";\n  }\n  .bx-message-alt-check:before {\n    content: \"\\eb67\";\n  }\n  .bx-message-alt-detail:before {\n    content: \"\\eb68\";\n  }\n  .bx-message-alt-dots:before {\n    content: \"\\eb69\";\n  }\n  .bx-message-alt-edit:before {\n    content: \"\\eb6a\";\n  }\n  .bx-message-alt-error:before {\n    content: \"\\eb6b\";\n  }\n  .bx-message-alt-minus:before {\n    content: \"\\eb6c\";\n  }\n  .bx-message-alt-x:before {\n    content: \"\\eb6d\";\n  }\n  .bx-message-check:before {\n    content: \"\\eb6e\";\n  }\n  .bx-message-detail:before {\n    content: \"\\eb6f\";\n  }\n  .bx-message-dots:before {\n    content: \"\\eb70\";\n  }\n  .bx-message-edit:before {\n    content: \"\\eb71\";\n  }\n  .bx-message-error:before {\n    content: \"\\eb72\";\n  }\n  .bx-message-minus:before {\n    content: \"\\eb73\";\n  }\n  .bx-message-rounded:before {\n    content: \"\\eb74\";\n  }\n  .bx-message-rounded-add:before {\n    content: \"\\eb75\";\n  }\n  .bx-message-rounded-check:before {\n    content: \"\\eb76\";\n  }\n  .bx-message-rounded-detail:before {\n    content: \"\\eb77\";\n  }\n  .bx-message-rounded-dots:before {\n    content: \"\\eb78\";\n  }\n  .bx-message-rounded-edit:before {\n    content: \"\\eb79\";\n  }\n  .bx-message-rounded-error:before {\n    content: \"\\eb7a\";\n  }\n  .bx-message-rounded-minus:before {\n    content: \"\\eb7b\";\n  }\n  .bx-message-rounded-x:before {\n    content: \"\\eb7c\";\n  }\n  .bx-message-square:before {\n    content: \"\\eb7d\";\n  }\n  .bx-message-square-add:before {\n    content: \"\\eb7e\";\n  }\n  .bx-message-square-check:before {\n    content: \"\\eb7f\";\n  }\n  .bx-message-square-detail:before {\n    content: \"\\eb80\";\n  }\n  .bx-message-square-dots:before {\n    content: \"\\eb81\";\n  }\n  .bx-message-square-edit:before {\n    content: \"\\eb82\";\n  }\n  .bx-message-square-error:before {\n    content: \"\\eb83\";\n  }\n  .bx-message-square-minus:before {\n    content: \"\\eb84\";\n  }\n  .bx-message-square-x:before {\n    content: \"\\eb85\";\n  }\n  .bx-message-x:before {\n    content: \"\\eb86\";\n  }\n  .bx-meteor:before {\n    content: \"\\eb87\";\n  }\n  .bx-microchip:before {\n    content: \"\\eb88\";\n  }\n  .bx-microphone:before {\n    content: \"\\eb89\";\n  }\n  .bx-microphone-off:before {\n    content: \"\\eb8a\";\n  }\n  .bx-minus:before {\n    content: \"\\eb8b\";\n  }\n  .bx-minus-back:before {\n    content: \"\\eb8c\";\n  }\n  .bx-minus-circle:before {\n    content: \"\\eb8d\";\n  }\n  .bx-minus-front:before {\n    content: \"\\eb8e\";\n  }\n  .bx-mobile:before {\n    content: \"\\eb8f\";\n  }\n  .bx-mobile-alt:before {\n    content: \"\\eb90\";\n  }\n  .bx-mobile-landscape:before {\n    content: \"\\eb91\";\n  }\n  .bx-mobile-vibration:before {\n    content: \"\\eb92\";\n  }\n  .bx-money:before {\n    content: \"\\eb93\";\n  }\n  .bx-moon:before {\n    content: \"\\eb94\";\n  }\n  .bx-mouse:before {\n    content: \"\\eb95\";\n  }\n  .bx-mouse-alt:before {\n    content: \"\\eb96\";\n  }\n  .bx-move:before {\n    content: \"\\eb97\";\n  }\n  .bx-move-horizontal:before {\n    content: \"\\eb98\";\n  }\n  .bx-move-vertical:before {\n    content: \"\\eb99\";\n  }\n  .bx-movie:before {\n    content: \"\\eb9a\";\n  }\n  .bx-movie-play:before {\n    content: \"\\eb9b\";\n  }\n  .bx-music:before {\n    content: \"\\eb9c\";\n  }\n  .bx-navigation:before {\n    content: \"\\eb9d\";\n  }\n  .bx-network-chart:before {\n    content: \"\\eb9e\";\n  }\n  .bx-news:before {\n    content: \"\\eb9f\";\n  }\n  .bx-no-entry:before {\n    content: \"\\eba0\";\n  }\n  .bx-note:before {\n    content: \"\\eba1\";\n  }\n  .bx-notepad:before {\n    content: \"\\eba2\";\n  }\n  .bx-notification:before {\n    content: \"\\eba3\";\n  }\n  .bx-notification-off:before {\n    content: \"\\eba4\";\n  }\n  .bx-outline:before {\n    content: \"\\eba5\";\n  }\n  .bx-package:before {\n    content: \"\\eba6\";\n  }\n  .bx-paint:before {\n    content: \"\\eba7\";\n  }\n  .bx-paint-roll:before {\n    content: \"\\eba8\";\n  }\n  .bx-palette:before {\n    content: \"\\eba9\";\n  }\n  .bx-paperclip:before {\n    content: \"\\ebaa\";\n  }\n  .bx-paper-plane:before {\n    content: \"\\ebab\";\n  }\n  .bx-paragraph:before {\n    content: \"\\ebac\";\n  }\n  .bx-paste:before {\n    content: \"\\ebad\";\n  }\n  .bx-pause:before {\n    content: \"\\ebae\";\n  }\n  .bx-pause-circle:before {\n    content: \"\\ebaf\";\n  }\n  .bx-pen:before {\n    content: \"\\ebb0\";\n  }\n  .bx-pencil:before {\n    content: \"\\ebb1\";\n  }\n  .bx-phone:before {\n    content: \"\\ebb2\";\n  }\n  .bx-phone-call:before {\n    content: \"\\ebb3\";\n  }\n  .bx-phone-incoming:before {\n    content: \"\\ebb4\";\n  }\n  .bx-phone-off:before {\n    content: \"\\ebb5\";\n  }\n  .bx-phone-outgoing:before {\n    content: \"\\ebb6\";\n  }\n  .bx-photo-album:before {\n    content: \"\\ebb7\";\n  }\n  .bx-pie-chart:before {\n    content: \"\\ebb8\";\n  }\n  .bx-pie-chart-alt:before {\n    content: \"\\ebb9\";\n  }\n  .bx-pie-chart-alt-2:before {\n    content: \"\\ebba\";\n  }\n  .bx-pin:before {\n    content: \"\\ebbb\";\n  }\n  .bx-planet:before {\n    content: \"\\ebbc\";\n  }\n  .bx-play:before {\n    content: \"\\ebbd\";\n  }\n  .bx-play-circle:before {\n    content: \"\\ebbe\";\n  }\n  .bx-plug:before {\n    content: \"\\ebbf\";\n  }\n  .bx-plus:before {\n    content: \"\\ebc0\";\n  }\n  .bx-plus-circle:before {\n    content: \"\\ebc1\";\n  }\n  .bx-plus-medical:before {\n    content: \"\\ebc2\";\n  }\n  .bx-podcast:before {\n    content: \"\\ebc3\";\n  }\n  .bx-pointer:before {\n    content: \"\\ebc4\";\n  }\n  .bx-poll:before {\n    content: \"\\ebc5\";\n  }\n  .bx-polygon:before {\n    content: \"\\ebc6\";\n  }\n  .bx-pound:before {\n    content: \"\\ebc7\";\n  }\n  .bx-power-off:before {\n    content: \"\\ebc8\";\n  }\n  .bx-printer:before {\n    content: \"\\ebc9\";\n  }\n  .bx-pulse:before {\n    content: \"\\ebca\";\n  }\n  .bx-purchase-tag:before {\n    content: \"\\ebcb\";\n  }\n  .bx-purchase-tag-alt:before {\n    content: \"\\ebcc\";\n  }\n  .bx-pyramid:before {\n    content: \"\\ebcd\";\n  }\n  .bx-qr:before {\n    content: \"\\ebce\";\n  }\n  .bx-qr-scan:before {\n    content: \"\\ebcf\";\n  }\n  .bx-question-mark:before {\n    content: \"\\ebd0\";\n  }\n  .bx-radar:before {\n    content: \"\\ebd1\";\n  }\n  .bx-radio:before {\n    content: \"\\ebd2\";\n  }\n  .bx-radio-circle:before {\n    content: \"\\ebd3\";\n  }\n  .bx-radio-circle-marked:before {\n    content: \"\\ebd4\";\n  }\n  .bx-receipt:before {\n    content: \"\\ebd5\";\n  }\n  .bx-rectangle:before {\n    content: \"\\ebd6\";\n  }\n  .bx-recycle:before {\n    content: \"\\ebd7\";\n  }\n  .bx-redo:before {\n    content: \"\\ebd8\";\n  }\n  .bx-refresh:before {\n    content: \"\\ebd9\";\n  }\n  .bx-registered:before {\n    content: \"\\ebda\";\n  }\n  .bx-rename:before {\n    content: \"\\ebdb\";\n  }\n  .bx-repeat:before {\n    content: \"\\ebdc\";\n  }\n  .bx-reply:before {\n    content: \"\\ebdd\";\n  }\n  .bx-reply-all:before {\n    content: \"\\ebde\";\n  }\n  .bx-repost:before {\n    content: \"\\ebdf\";\n  }\n  .bx-reset:before {\n    content: \"\\ebe0\";\n  }\n  .bx-restaurant:before {\n    content: \"\\ebe1\";\n  }\n  .bx-revision:before {\n    content: \"\\ebe2\";\n  }\n  .bx-rewind:before {\n    content: \"\\ebe3\";\n  }\n  .bx-rewind-circle:before {\n    content: \"\\ebe4\";\n  }\n  .bx-right-arrow:before {\n    content: \"\\ebe5\";\n  }\n  .bx-right-arrow-alt:before {\n    content: \"\\ebe6\";\n  }\n  .bx-right-arrow-circle:before {\n    content: \"\\ebe7\";\n  }\n  .bx-right-down-arrow-circle:before {\n    content: \"\\ebe8\";\n  }\n  .bx-right-indent:before {\n    content: \"\\ebe9\";\n  }\n  .bx-right-top-arrow-circle:before {\n    content: \"\\ebea\";\n  }\n  .bx-rocket:before {\n    content: \"\\ebeb\";\n  }\n  .bx-rotate-left:before {\n    content: \"\\ebec\";\n  }\n  .bx-rotate-right:before {\n    content: \"\\ebed\";\n  }\n  .bx-rss:before {\n    content: \"\\ebee\";\n  }\n  .bx-ruble:before {\n    content: \"\\ebef\";\n  }\n  .bx-ruler:before {\n    content: \"\\ebf0\";\n  }\n  .bx-run:before {\n    content: \"\\ebf1\";\n  }\n  .bx-rupee:before {\n    content: \"\\ebf2\";\n  }\n  .bx-sad:before {\n    content: \"\\ebf3\";\n  }\n  .bx-save:before {\n    content: \"\\ebf4\";\n  }\n  .bx-scan:before {\n    content: \"\\ebf5\";\n  }\n  .bx-screenshot:before {\n    content: \"\\ebf6\";\n  }\n  .bx-search:before {\n    content: \"\\ebf7\";\n  }\n  .bx-search-alt:before {\n    content: \"\\ebf8\";\n  }\n  .bx-search-alt-2:before {\n    content: \"\\ebf9\";\n  }\n  .bx-selection:before {\n    content: \"\\ebfa\";\n  }\n  .bx-select-multiple:before {\n    content: \"\\ebfb\";\n  }\n  .bx-send:before {\n    content: \"\\ebfc\";\n  }\n  .bx-server:before {\n    content: \"\\ebfd\";\n  }\n  .bx-shape-circle:before {\n    content: \"\\ebfe\";\n  }\n  .bx-shape-polygon:before {\n    content: \"\\ebff\";\n  }\n  .bx-shape-square:before {\n    content: \"\\ec00\";\n  }\n  .bx-shape-triangle:before {\n    content: \"\\ec01\";\n  }\n  .bx-share:before {\n    content: \"\\ec02\";\n  }\n  .bx-share-alt:before {\n    content: \"\\ec03\";\n  }\n  .bx-shekel:before {\n    content: \"\\ec04\";\n  }\n  .bx-shield:before {\n    content: \"\\ec05\";\n  }\n  .bx-shield-alt:before {\n    content: \"\\ec06\";\n  }\n  .bx-shield-alt-2:before {\n    content: \"\\ec07\";\n  }\n  .bx-shield-quarter:before {\n    content: \"\\ec08\";\n  }\n  .bx-shield-x:before {\n    content: \"\\ec09\";\n  }\n  .bx-shocked:before {\n    content: \"\\ec0a\";\n  }\n  .bx-shopping-bag:before {\n    content: \"\\ec0b\";\n  }\n  .bx-show:before {\n    content: \"\\ec0c\";\n  }\n  .bx-show-alt:before {\n    content: \"\\ec0d\";\n  }\n  .bx-shuffle:before {\n    content: \"\\ec0e\";\n  }\n  .bx-sidebar:before {\n    content: \"\\ec0f\";\n  }\n  .bx-sitemap:before {\n    content: \"\\ec10\";\n  }\n  .bx-skip-next:before {\n    content: \"\\ec11\";\n  }\n  .bx-skip-next-circle:before {\n    content: \"\\ec12\";\n  }\n  .bx-skip-previous:before {\n    content: \"\\ec13\";\n  }\n  .bx-skip-previous-circle:before {\n    content: \"\\ec14\";\n  }\n  .bx-sleepy:before {\n    content: \"\\ec15\";\n  }\n  .bx-slider:before {\n    content: \"\\ec16\";\n  }\n  .bx-slider-alt:before {\n    content: \"\\ec17\";\n  }\n  .bx-slideshow:before {\n    content: \"\\ec18\";\n  }\n  .bx-smile:before {\n    content: \"\\ec19\";\n  }\n  .bx-sort:before {\n    content: \"\\ec1a\";\n  }\n  .bx-sort-alt-2:before {\n    content: \"\\ec1b\";\n  }\n  .bx-sort-a-z:before {\n    content: \"\\ec1c\";\n  }\n  .bx-sort-down:before {\n    content: \"\\ec1d\";\n  }\n  .bx-sort-up:before {\n    content: \"\\ec1e\";\n  }\n  .bx-sort-z-a:before {\n    content: \"\\ec1f\";\n  }\n  .bx-spa:before {\n    content: \"\\ec20\";\n  }\n  .bx-space-bar:before {\n    content: \"\\ec21\";\n  }\n  .bx-speaker:before {\n    content: \"\\ec22\";\n  }\n  .bx-spray-can:before {\n    content: \"\\ec23\";\n  }\n  .bx-spreadsheet:before {\n    content: \"\\ec24\";\n  }\n  .bx-square:before {\n    content: \"\\ec25\";\n  }\n  .bx-square-rounded:before {\n    content: \"\\ec26\";\n  }\n  .bx-star:before {\n    content: \"\\ec27\";\n  }\n  .bx-station:before {\n    content: \"\\ec28\";\n  }\n  .bx-stats:before {\n    content: \"\\ec29\";\n  }\n  .bx-sticker:before {\n    content: \"\\ec2a\";\n  }\n  .bx-stop:before {\n    content: \"\\ec2b\";\n  }\n  .bx-stop-circle:before {\n    content: \"\\ec2c\";\n  }\n  .bx-stopwatch:before {\n    content: \"\\ec2d\";\n  }\n  .bx-store:before {\n    content: \"\\ec2e\";\n  }\n  .bx-store-alt:before {\n    content: \"\\ec2f\";\n  }\n  .bx-street-view:before {\n    content: \"\\ec30\";\n  }\n  .bx-strikethrough:before {\n    content: \"\\ec31\";\n  }\n  .bx-subdirectory-left:before {\n    content: \"\\ec32\";\n  }\n  .bx-subdirectory-right:before {\n    content: \"\\ec33\";\n  }\n  .bx-sun:before {\n    content: \"\\ec34\";\n  }\n  .bx-support:before {\n    content: \"\\ec35\";\n  }\n  .bx-swim:before {\n    content: \"\\ec36\";\n  }\n  .bx-sync:before {\n    content: \"\\ec37\";\n  }\n  .bx-tab:before {\n    content: \"\\ec38\";\n  }\n  .bx-table:before {\n    content: \"\\ec39\";\n  }\n  .bx-tachometer:before {\n    content: \"\\ec3a\";\n  }\n  .bx-tag:before {\n    content: \"\\ec3b\";\n  }\n  .bx-tag-alt:before {\n    content: \"\\ec3c\";\n  }\n  .bx-target-lock:before {\n    content: \"\\ec3d\";\n  }\n  .bx-task:before {\n    content: \"\\ec3e\";\n  }\n  .bx-task-x:before {\n    content: \"\\ec3f\";\n  }\n  .bx-taxi:before {\n    content: \"\\ec40\";\n  }\n  .bx-tennis-ball:before {\n    content: \"\\ec41\";\n  }\n  .bx-terminal:before {\n    content: \"\\ec42\";\n  }\n  .bx-test-tube:before {\n    content: \"\\ec43\";\n  }\n  .bx-text:before {\n    content: \"\\ec44\";\n  }\n  .bx-time:before {\n    content: \"\\ec45\";\n  }\n  .bx-time-five:before {\n    content: \"\\ec46\";\n  }\n  .bx-timer:before {\n    content: \"\\ec47\";\n  }\n  .bx-tired:before {\n    content: \"\\ec48\";\n  }\n  .bx-toggle-left:before {\n    content: \"\\ec49\";\n  }\n  .bx-toggle-right:before {\n    content: \"\\ec4a\";\n  }\n  .bx-tone:before {\n    content: \"\\ec4b\";\n  }\n  .bx-traffic-cone:before {\n    content: \"\\ec4c\";\n  }\n  .bx-train:before {\n    content: \"\\ec4d\";\n  }\n  .bx-transfer:before {\n    content: \"\\ec4e\";\n  }\n  .bx-transfer-alt:before {\n    content: \"\\ec4f\";\n  }\n  .bx-trash:before {\n    content: \"\\ec50\";\n  }\n  .bx-trash-alt:before {\n    content: \"\\ec51\";\n  }\n  .bx-trending-down:before {\n    content: \"\\ec52\";\n  }\n  .bx-trending-up:before {\n    content: \"\\ec53\";\n  }\n  .bx-trim:before {\n    content: \"\\ec54\";\n  }\n  .bx-trip:before {\n    content: \"\\ec55\";\n  }\n  .bx-trophy:before {\n    content: \"\\ec56\";\n  }\n  .bx-tv:before {\n    content: \"\\ec57\";\n  }\n  .bx-underline:before {\n    content: \"\\ec58\";\n  }\n  .bx-undo:before {\n    content: \"\\ec59\";\n  }\n  .bx-unite:before {\n    content: \"\\ec5a\";\n  }\n  .bx-unlink:before {\n    content: \"\\ec5b\";\n  }\n  .bx-up-arrow:before {\n    content: \"\\ec5c\";\n  }\n  .bx-up-arrow-alt:before {\n    content: \"\\ec5d\";\n  }\n  .bx-up-arrow-circle:before {\n    content: \"\\ec5e\";\n  }\n  .bx-upload:before {\n    content: \"\\ec5f\";\n  }\n  .bx-upside-down:before {\n    content: \"\\ec60\";\n  }\n  .bx-upvote:before {\n    content: \"\\ec61\";\n  }\n  .bx-usb:before {\n    content: \"\\ec62\";\n  }\n  .bx-user:before {\n    content: \"\\ec63\";\n  }\n  .bx-user-check:before {\n    content: \"\\ec64\";\n  }\n  .bx-user-circle:before {\n    content: \"\\ec65\";\n  }\n  .bx-user-minus:before {\n    content: \"\\ec66\";\n  }\n  .bx-user-pin:before {\n    content: \"\\ec67\";\n  }\n  .bx-user-plus:before {\n    content: \"\\ec68\";\n  }\n  .bx-user-voice:before {\n    content: \"\\ec69\";\n  }\n  .bx-user-x:before {\n    content: \"\\ec6a\";\n  }\n  .bx-vector:before {\n    content: \"\\ec6b\";\n  }\n  .bx-vertical-center:before {\n    content: \"\\ec6c\";\n  }\n  .bx-vial:before {\n    content: \"\\ec6d\";\n  }\n  .bx-video:before {\n    content: \"\\ec6e\";\n  }\n  .bx-video-off:before {\n    content: \"\\ec6f\";\n  }\n  .bx-video-plus:before {\n    content: \"\\ec70\";\n  }\n  .bx-video-recording:before {\n    content: \"\\ec71\";\n  }\n  .bx-voicemail:before {\n    content: \"\\ec72\";\n  }\n  .bx-volume:before {\n    content: \"\\ec73\";\n  }\n  .bx-volume-full:before {\n    content: \"\\ec74\";\n  }\n  .bx-volume-low:before {\n    content: \"\\ec75\";\n  }\n  .bx-volume-mute:before {\n    content: \"\\ec76\";\n  }\n  .bx-walk:before {\n    content: \"\\ec77\";\n  }\n  .bx-wallet:before {\n    content: \"\\ec78\";\n  }\n  .bx-wallet-alt:before {\n    content: \"\\ec79\";\n  }\n  .bx-water:before {\n    content: \"\\ec7a\";\n  }\n  .bx-webcam:before {\n    content: \"\\ec7b\";\n  }\n  .bx-wifi:before {\n    content: \"\\ec7c\";\n  }\n  .bx-wifi-0:before {\n    content: \"\\ec7d\";\n  }\n  .bx-wifi-1:before {\n    content: \"\\ec7e\";\n  }\n  .bx-wifi-2:before {\n    content: \"\\ec7f\";\n  }\n  .bx-wifi-off:before {\n    content: \"\\ec80\";\n  }\n  .bx-wind:before {\n    content: \"\\ec81\";\n  }\n  .bx-window:before {\n    content: \"\\ec82\";\n  }\n  .bx-window-alt:before {\n    content: \"\\ec83\";\n  }\n  .bx-window-close:before {\n    content: \"\\ec84\";\n  }\n  .bx-window-open:before {\n    content: \"\\ec85\";\n  }\n  .bx-windows:before {\n    content: \"\\ec86\";\n  }\n  .bx-wine:before {\n    content: \"\\ec87\";\n  }\n  .bx-wink-smile:before {\n    content: \"\\ec88\";\n  }\n  .bx-wink-tongue:before {\n    content: \"\\ec89\";\n  }\n  .bx-won:before {\n    content: \"\\ec8a\";\n  }\n  .bx-world:before {\n    content: \"\\ec8b\";\n  }\n  .bx-wrench:before {\n    content: \"\\ec8c\";\n  }\n  .bx-x:before {\n    content: \"\\ec8d\";\n  }\n  .bx-x-circle:before {\n    content: \"\\ec8e\";\n  }\n  .bx-yen:before {\n    content: \"\\ec8f\";\n  }\n  .bx-zoom-in:before {\n    content: \"\\ec90\";\n  }\n  .bx-zoom-out:before {\n    content: \"\\ec91\";\n  }\n  .bxs-party:before {\n    content: \"\\ec92\";\n  }\n  .bxs-hot:before {\n    content: \"\\ec93\";\n  }\n  .bxs-droplet:before {\n    content: \"\\ec94\";\n  }\n  .bxs-cat:before {\n    content: \"\\ec95\";\n  }\n  .bxs-dog:before {\n    content: \"\\ec96\";\n  }\n  .bxs-injection:before {\n    content: \"\\ec97\";\n  }\n  .bxs-leaf:before {\n    content: \"\\ec98\";\n  }\n  .bxs-add-to-queue:before {\n    content: \"\\ec99\";\n  }\n  .bxs-adjust:before {\n    content: \"\\ec9a\";\n  }\n  .bxs-adjust-alt:before {\n    content: \"\\ec9b\";\n  }\n  .bxs-alarm:before {\n    content: \"\\ec9c\";\n  }\n  .bxs-alarm-add:before {\n    content: \"\\ec9d\";\n  }\n  .bxs-alarm-exclamation:before {\n    content: \"\\ec9e\";\n  }\n  .bxs-alarm-off:before {\n    content: \"\\ec9f\";\n  }\n  .bxs-alarm-snooze:before {\n    content: \"\\eca0\";\n  }\n  .bxs-album:before {\n    content: \"\\eca1\";\n  }\n  .bxs-ambulance:before {\n    content: \"\\eca2\";\n  }\n  .bxs-analyse:before {\n    content: \"\\eca3\";\n  }\n  .bxs-angry:before {\n    content: \"\\eca4\";\n  }\n  .bxs-arch:before {\n    content: \"\\eca5\";\n  }\n  .bxs-archive:before {\n    content: \"\\eca6\";\n  }\n  .bxs-archive-in:before {\n    content: \"\\eca7\";\n  }\n  .bxs-archive-out:before {\n    content: \"\\eca8\";\n  }\n  .bxs-area:before {\n    content: \"\\eca9\";\n  }\n  .bxs-arrow-from-bottom:before {\n    content: \"\\ecaa\";\n  }\n  .bxs-arrow-from-left:before {\n    content: \"\\ecab\";\n  }\n  .bxs-arrow-from-right:before {\n    content: \"\\ecac\";\n  }\n  .bxs-arrow-from-top:before {\n    content: \"\\ecad\";\n  }\n  .bxs-arrow-to-bottom:before {\n    content: \"\\ecae\";\n  }\n  .bxs-arrow-to-left:before {\n    content: \"\\ecaf\";\n  }\n  .bxs-arrow-to-right:before {\n    content: \"\\ecb0\";\n  }\n  .bxs-arrow-to-top:before {\n    content: \"\\ecb1\";\n  }\n  .bxs-award:before {\n    content: \"\\ecb2\";\n  }\n  .bxs-baby-carriage:before {\n    content: \"\\ecb3\";\n  }\n  .bxs-backpack:before {\n    content: \"\\ecb4\";\n  }\n  .bxs-badge:before {\n    content: \"\\ecb5\";\n  }\n  .bxs-badge-check:before {\n    content: \"\\ecb6\";\n  }\n  .bxs-badge-dollar:before {\n    content: \"\\ecb7\";\n  }\n  .bxs-ball:before {\n    content: \"\\ecb8\";\n  }\n  .bxs-band-aid:before {\n    content: \"\\ecb9\";\n  }\n  .bxs-bank:before {\n    content: \"\\ecba\";\n  }\n  .bxs-bar-chart-alt-2:before {\n    content: \"\\ecbb\";\n  }\n  .bxs-bar-chart-square:before {\n    content: \"\\ecbc\";\n  }\n  .bxs-barcode:before {\n    content: \"\\ecbd\";\n  }\n  .bxs-baseball:before {\n    content: \"\\ecbe\";\n  }\n  .bxs-basket:before {\n    content: \"\\ecbf\";\n  }\n  .bxs-basketball:before {\n    content: \"\\ecc0\";\n  }\n  .bxs-bath:before {\n    content: \"\\ecc1\";\n  }\n  .bxs-battery:before {\n    content: \"\\ecc2\";\n  }\n  .bxs-battery-charging:before {\n    content: \"\\ecc3\";\n  }\n  .bxs-battery-full:before {\n    content: \"\\ecc4\";\n  }\n  .bxs-battery-low:before {\n    content: \"\\ecc5\";\n  }\n  .bxs-bed:before {\n    content: \"\\ecc6\";\n  }\n  .bxs-been-here:before {\n    content: \"\\ecc7\";\n  }\n  .bxs-beer:before {\n    content: \"\\ecc8\";\n  }\n  .bxs-bell:before {\n    content: \"\\ecc9\";\n  }\n  .bxs-bell-minus:before {\n    content: \"\\ecca\";\n  }\n  .bxs-bell-off:before {\n    content: \"\\eccb\";\n  }\n  .bxs-bell-plus:before {\n    content: \"\\eccc\";\n  }\n  .bxs-bell-ring:before {\n    content: \"\\eccd\";\n  }\n  .bxs-bible:before {\n    content: \"\\ecce\";\n  }\n  .bxs-binoculars:before {\n    content: \"\\eccf\";\n  }\n  .bxs-blanket:before {\n    content: \"\\ecd0\";\n  }\n  .bxs-bolt:before {\n    content: \"\\ecd1\";\n  }\n  .bxs-bolt-circle:before {\n    content: \"\\ecd2\";\n  }\n  .bxs-bomb:before {\n    content: \"\\ecd3\";\n  }\n  .bxs-bone:before {\n    content: \"\\ecd4\";\n  }\n  .bxs-bong:before {\n    content: \"\\ecd5\";\n  }\n  .bxs-book:before {\n    content: \"\\ecd6\";\n  }\n  .bxs-book-add:before {\n    content: \"\\ecd7\";\n  }\n  .bxs-book-alt:before {\n    content: \"\\ecd8\";\n  }\n  .bxs-book-bookmark:before {\n    content: \"\\ecd9\";\n  }\n  .bxs-book-content:before {\n    content: \"\\ecda\";\n  }\n  .bxs-book-heart:before {\n    content: \"\\ecdb\";\n  }\n  .bxs-bookmark:before {\n    content: \"\\ecdc\";\n  }\n  .bxs-bookmark-alt:before {\n    content: \"\\ecdd\";\n  }\n  .bxs-bookmark-alt-minus:before {\n    content: \"\\ecde\";\n  }\n  .bxs-bookmark-alt-plus:before {\n    content: \"\\ecdf\";\n  }\n  .bxs-bookmark-heart:before {\n    content: \"\\ece0\";\n  }\n  .bxs-bookmark-minus:before {\n    content: \"\\ece1\";\n  }\n  .bxs-bookmark-plus:before {\n    content: \"\\ece2\";\n  }\n  .bxs-bookmarks:before {\n    content: \"\\ece3\";\n  }\n  .bxs-bookmark-star:before {\n    content: \"\\ece4\";\n  }\n  .bxs-book-open:before {\n    content: \"\\ece5\";\n  }\n  .bxs-book-reader:before {\n    content: \"\\ece6\";\n  }\n  .bxs-bot:before {\n    content: \"\\ece7\";\n  }\n  .bxs-bowling-ball:before {\n    content: \"\\ece8\";\n  }\n  .bxs-box:before {\n    content: \"\\ece9\";\n  }\n  .bxs-brain:before {\n    content: \"\\ecea\";\n  }\n  .bxs-briefcase:before {\n    content: \"\\eceb\";\n  }\n  .bxs-briefcase-alt:before {\n    content: \"\\ecec\";\n  }\n  .bxs-briefcase-alt-2:before {\n    content: \"\\eced\";\n  }\n  .bxs-brightness:before {\n    content: \"\\ecee\";\n  }\n  .bxs-brightness-half:before {\n    content: \"\\ecef\";\n  }\n  .bxs-brush:before {\n    content: \"\\ecf0\";\n  }\n  .bxs-brush-alt:before {\n    content: \"\\ecf1\";\n  }\n  .bxs-bug:before {\n    content: \"\\ecf2\";\n  }\n  .bxs-bug-alt:before {\n    content: \"\\ecf3\";\n  }\n  .bxs-building:before {\n    content: \"\\ecf4\";\n  }\n  .bxs-building-house:before {\n    content: \"\\ecf5\";\n  }\n  .bxs-buildings:before {\n    content: \"\\ecf6\";\n  }\n  .bxs-bulb:before {\n    content: \"\\ecf7\";\n  }\n  .bxs-bullseye:before {\n    content: \"\\ecf8\";\n  }\n  .bxs-buoy:before {\n    content: \"\\ecf9\";\n  }\n  .bxs-bus:before {\n    content: \"\\ecfa\";\n  }\n  .bxs-business:before {\n    content: \"\\ecfb\";\n  }\n  .bxs-bus-school:before {\n    content: \"\\ecfc\";\n  }\n  .bxs-cabinet:before {\n    content: \"\\ecfd\";\n  }\n  .bxs-cake:before {\n    content: \"\\ecfe\";\n  }\n  .bxs-calculator:before {\n    content: \"\\ecff\";\n  }\n  .bxs-calendar:before {\n    content: \"\\ed00\";\n  }\n  .bxs-calendar-alt:before {\n    content: \"\\ed01\";\n  }\n  .bxs-calendar-check:before {\n    content: \"\\ed02\";\n  }\n  .bxs-calendar-edit:before {\n    content: \"\\ed03\";\n  }\n  .bxs-calendar-event:before {\n    content: \"\\ed04\";\n  }\n  .bxs-calendar-exclamation:before {\n    content: \"\\ed05\";\n  }\n  .bxs-calendar-heart:before {\n    content: \"\\ed06\";\n  }\n  .bxs-calendar-minus:before {\n    content: \"\\ed07\";\n  }\n  .bxs-calendar-plus:before {\n    content: \"\\ed08\";\n  }\n  .bxs-calendar-star:before {\n    content: \"\\ed09\";\n  }\n  .bxs-calendar-week:before {\n    content: \"\\ed0a\";\n  }\n  .bxs-calendar-x:before {\n    content: \"\\ed0b\";\n  }\n  .bxs-camera:before {\n    content: \"\\ed0c\";\n  }\n  .bxs-camera-home:before {\n    content: \"\\ed0d\";\n  }\n  .bxs-camera-movie:before {\n    content: \"\\ed0e\";\n  }\n  .bxs-camera-off:before {\n    content: \"\\ed0f\";\n  }\n  .bxs-camera-plus:before {\n    content: \"\\ed10\";\n  }\n  .bxs-capsule:before {\n    content: \"\\ed11\";\n  }\n  .bxs-captions:before {\n    content: \"\\ed12\";\n  }\n  .bxs-car:before {\n    content: \"\\ed13\";\n  }\n  .bxs-car-battery:before {\n    content: \"\\ed14\";\n  }\n  .bxs-car-crash:before {\n    content: \"\\ed15\";\n  }\n  .bxs-card:before {\n    content: \"\\ed16\";\n  }\n  .bxs-caret-down-circle:before {\n    content: \"\\ed17\";\n  }\n  .bxs-caret-down-square:before {\n    content: \"\\ed18\";\n  }\n  .bxs-caret-left-circle:before {\n    content: \"\\ed19\";\n  }\n  .bxs-caret-left-square:before {\n    content: \"\\ed1a\";\n  }\n  .bxs-caret-right-circle:before {\n    content: \"\\ed1b\";\n  }\n  .bxs-caret-right-square:before {\n    content: \"\\ed1c\";\n  }\n  .bxs-caret-up-circle:before {\n    content: \"\\ed1d\";\n  }\n  .bxs-caret-up-square:before {\n    content: \"\\ed1e\";\n  }\n  .bxs-car-garage:before {\n    content: \"\\ed1f\";\n  }\n  .bxs-car-mechanic:before {\n    content: \"\\ed20\";\n  }\n  .bxs-carousel:before {\n    content: \"\\ed21\";\n  }\n  .bxs-cart:before {\n    content: \"\\ed22\";\n  }\n  .bxs-cart-add:before {\n    content: \"\\ed23\";\n  }\n  .bxs-cart-alt:before {\n    content: \"\\ed24\";\n  }\n  .bxs-cart-download:before {\n    content: \"\\ed25\";\n  }\n  .bxs-car-wash:before {\n    content: \"\\ed26\";\n  }\n  .bxs-category:before {\n    content: \"\\ed27\";\n  }\n  .bxs-category-alt:before {\n    content: \"\\ed28\";\n  }\n  .bxs-cctv:before {\n    content: \"\\ed29\";\n  }\n  .bxs-certification:before {\n    content: \"\\ed2a\";\n  }\n  .bxs-chalkboard:before {\n    content: \"\\ed2b\";\n  }\n  .bxs-chart:before {\n    content: \"\\ed2c\";\n  }\n  .bxs-chat:before {\n    content: \"\\ed2d\";\n  }\n  .bxs-checkbox:before {\n    content: \"\\ed2e\";\n  }\n  .bxs-checkbox-checked:before {\n    content: \"\\ed2f\";\n  }\n  .bxs-checkbox-minus:before {\n    content: \"\\ed30\";\n  }\n  .bxs-check-circle:before {\n    content: \"\\ed31\";\n  }\n  .bxs-check-shield:before {\n    content: \"\\ed32\";\n  }\n  .bxs-check-square:before {\n    content: \"\\ed33\";\n  }\n  .bxs-chess:before {\n    content: \"\\ed34\";\n  }\n  .bxs-chevron-down:before {\n    content: \"\\ed35\";\n  }\n  .bxs-chevron-down-circle:before {\n    content: \"\\ed36\";\n  }\n  .bxs-chevron-down-square:before {\n    content: \"\\ed37\";\n  }\n  .bxs-chevron-left:before {\n    content: \"\\ed38\";\n  }\n  .bxs-chevron-left-circle:before {\n    content: \"\\ed39\";\n  }\n  .bxs-chevron-left-square:before {\n    content: \"\\ed3a\";\n  }\n  .bxs-chevron-right:before {\n    content: \"\\ed3b\";\n  }\n  .bxs-chevron-right-circle:before {\n    content: \"\\ed3c\";\n  }\n  .bxs-chevron-right-square:before {\n    content: \"\\ed3d\";\n  }\n  .bxs-chevrons-down:before {\n    content: \"\\ed3e\";\n  }\n  .bxs-chevrons-left:before {\n    content: \"\\ed3f\";\n  }\n  .bxs-chevrons-right:before {\n    content: \"\\ed40\";\n  }\n  .bxs-chevrons-up:before {\n    content: \"\\ed41\";\n  }\n  .bxs-chevron-up:before {\n    content: \"\\ed42\";\n  }\n  .bxs-chevron-up-circle:before {\n    content: \"\\ed43\";\n  }\n  .bxs-chevron-up-square:before {\n    content: \"\\ed44\";\n  }\n  .bxs-chip:before {\n    content: \"\\ed45\";\n  }\n  .bxs-church:before {\n    content: \"\\ed46\";\n  }\n  .bxs-circle:before {\n    content: \"\\ed47\";\n  }\n  .bxs-city:before {\n    content: \"\\ed48\";\n  }\n  .bxs-clinic:before {\n    content: \"\\ed49\";\n  }\n  .bxs-cloud:before {\n    content: \"\\ed4a\";\n  }\n  .bxs-cloud-download:before {\n    content: \"\\ed4b\";\n  }\n  .bxs-cloud-lightning:before {\n    content: \"\\ed4c\";\n  }\n  .bxs-cloud-rain:before {\n    content: \"\\ed4d\";\n  }\n  .bxs-cloud-upload:before {\n    content: \"\\ed4e\";\n  }\n  .bxs-coffee:before {\n    content: \"\\ed4f\";\n  }\n  .bxs-coffee-alt:before {\n    content: \"\\ed50\";\n  }\n  .bxs-coffee-togo:before {\n    content: \"\\ed51\";\n  }\n  .bxs-cog:before {\n    content: \"\\ed52\";\n  }\n  .bxs-coin:before {\n    content: \"\\ed53\";\n  }\n  .bxs-coin-stack:before {\n    content: \"\\ed54\";\n  }\n  .bxs-collection:before {\n    content: \"\\ed55\";\n  }\n  .bxs-color-fill:before {\n    content: \"\\ed56\";\n  }\n  .bxs-comment:before {\n    content: \"\\ed57\";\n  }\n  .bxs-comment-add:before {\n    content: \"\\ed58\";\n  }\n  .bxs-comment-check:before {\n    content: \"\\ed59\";\n  }\n  .bxs-comment-detail:before {\n    content: \"\\ed5a\";\n  }\n  .bxs-comment-dots:before {\n    content: \"\\ed5b\";\n  }\n  .bxs-comment-edit:before {\n    content: \"\\ed5c\";\n  }\n  .bxs-comment-error:before {\n    content: \"\\ed5d\";\n  }\n  .bxs-comment-minus:before {\n    content: \"\\ed5e\";\n  }\n  .bxs-comment-x:before {\n    content: \"\\ed5f\";\n  }\n  .bxs-compass:before {\n    content: \"\\ed60\";\n  }\n  .bxs-component:before {\n    content: \"\\ed61\";\n  }\n  .bxs-confused:before {\n    content: \"\\ed62\";\n  }\n  .bxs-contact:before {\n    content: \"\\ed63\";\n  }\n  .bxs-conversation:before {\n    content: \"\\ed64\";\n  }\n  .bxs-cookie:before {\n    content: \"\\ed65\";\n  }\n  .bxs-cool:before {\n    content: \"\\ed66\";\n  }\n  .bxs-copy:before {\n    content: \"\\ed67\";\n  }\n  .bxs-copy-alt:before {\n    content: \"\\ed68\";\n  }\n  .bxs-copyright:before {\n    content: \"\\ed69\";\n  }\n  .bxs-coupon:before {\n    content: \"\\ed6a\";\n  }\n  .bxs-credit-card:before {\n    content: \"\\ed6b\";\n  }\n  .bxs-credit-card-alt:before {\n    content: \"\\ed6c\";\n  }\n  .bxs-credit-card-front:before {\n    content: \"\\ed6d\";\n  }\n  .bxs-crop:before {\n    content: \"\\ed6e\";\n  }\n  .bxs-crown:before {\n    content: \"\\ed6f\";\n  }\n  .bxs-cube:before {\n    content: \"\\ed70\";\n  }\n  .bxs-cube-alt:before {\n    content: \"\\ed71\";\n  }\n  .bxs-cuboid:before {\n    content: \"\\ed72\";\n  }\n  .bxs-customize:before {\n    content: \"\\ed73\";\n  }\n  .bxs-cylinder:before {\n    content: \"\\ed74\";\n  }\n  .bxs-dashboard:before {\n    content: \"\\ed75\";\n  }\n  .bxs-data:before {\n    content: \"\\ed76\";\n  }\n  .bxs-detail:before {\n    content: \"\\ed77\";\n  }\n  .bxs-devices:before {\n    content: \"\\ed78\";\n  }\n  .bxs-diamond:before {\n    content: \"\\ed79\";\n  }\n  .bxs-dice-1:before {\n    content: \"\\ed7a\";\n  }\n  .bxs-dice-2:before {\n    content: \"\\ed7b\";\n  }\n  .bxs-dice-3:before {\n    content: \"\\ed7c\";\n  }\n  .bxs-dice-4:before {\n    content: \"\\ed7d\";\n  }\n  .bxs-dice-5:before {\n    content: \"\\ed7e\";\n  }\n  .bxs-dice-6:before {\n    content: \"\\ed7f\";\n  }\n  .bxs-direction-left:before {\n    content: \"\\ed80\";\n  }\n  .bxs-direction-right:before {\n    content: \"\\ed81\";\n  }\n  .bxs-directions:before {\n    content: \"\\ed82\";\n  }\n  .bxs-disc:before {\n    content: \"\\ed83\";\n  }\n  .bxs-discount:before {\n    content: \"\\ed84\";\n  }\n  .bxs-dish:before {\n    content: \"\\ed85\";\n  }\n  .bxs-dislike:before {\n    content: \"\\ed86\";\n  }\n  .bxs-dizzy:before {\n    content: \"\\ed87\";\n  }\n  .bxs-dock-bottom:before {\n    content: \"\\ed88\";\n  }\n  .bxs-dock-left:before {\n    content: \"\\ed89\";\n  }\n  .bxs-dock-right:before {\n    content: \"\\ed8a\";\n  }\n  .bxs-dock-top:before {\n    content: \"\\ed8b\";\n  }\n  .bxs-dollar-circle:before {\n    content: \"\\ed8c\";\n  }\n  .bxs-donate-blood:before {\n    content: \"\\ed8d\";\n  }\n  .bxs-donate-heart:before {\n    content: \"\\ed8e\";\n  }\n  .bxs-door-open:before {\n    content: \"\\ed8f\";\n  }\n  .bxs-doughnut-chart:before {\n    content: \"\\ed90\";\n  }\n  .bxs-down-arrow:before {\n    content: \"\\ed91\";\n  }\n  .bxs-down-arrow-alt:before {\n    content: \"\\ed92\";\n  }\n  .bxs-down-arrow-circle:before {\n    content: \"\\ed93\";\n  }\n  .bxs-down-arrow-square:before {\n    content: \"\\ed94\";\n  }\n  .bxs-download:before {\n    content: \"\\ed95\";\n  }\n  .bxs-downvote:before {\n    content: \"\\ed96\";\n  }\n  .bxs-drink:before {\n    content: \"\\ed97\";\n  }\n  .bxs-droplet-half:before {\n    content: \"\\ed98\";\n  }\n  .bxs-dryer:before {\n    content: \"\\ed99\";\n  }\n  .bxs-duplicate:before {\n    content: \"\\ed9a\";\n  }\n  .bxs-edit:before {\n    content: \"\\ed9b\";\n  }\n  .bxs-edit-alt:before {\n    content: \"\\ed9c\";\n  }\n  .bxs-edit-location:before {\n    content: \"\\ed9d\";\n  }\n  .bxs-eject:before {\n    content: \"\\ed9e\";\n  }\n  .bxs-envelope:before {\n    content: \"\\ed9f\";\n  }\n  .bxs-envelope-open:before {\n    content: \"\\eda0\";\n  }\n  .bxs-eraser:before {\n    content: \"\\eda1\";\n  }\n  .bxs-error:before {\n    content: \"\\eda2\";\n  }\n  .bxs-error-alt:before {\n    content: \"\\eda3\";\n  }\n  .bxs-error-circle:before {\n    content: \"\\eda4\";\n  }\n  .bxs-ev-station:before {\n    content: \"\\eda5\";\n  }\n  .bxs-exit:before {\n    content: \"\\eda6\";\n  }\n  .bxs-extension:before {\n    content: \"\\eda7\";\n  }\n  .bxs-eyedropper:before {\n    content: \"\\eda8\";\n  }\n  .bxs-face:before {\n    content: \"\\eda9\";\n  }\n  .bxs-face-mask:before {\n    content: \"\\edaa\";\n  }\n  .bxs-factory:before {\n    content: \"\\edab\";\n  }\n  .bxs-fast-forward-circle:before {\n    content: \"\\edac\";\n  }\n  .bxs-file:before {\n    content: \"\\edad\";\n  }\n  .bxs-file-archive:before {\n    content: \"\\edae\";\n  }\n  .bxs-file-blank:before {\n    content: \"\\edaf\";\n  }\n  .bxs-file-css:before {\n    content: \"\\edb0\";\n  }\n  .bxs-file-doc:before {\n    content: \"\\edb1\";\n  }\n  .bxs-file-export:before {\n    content: \"\\edb2\";\n  }\n  .bxs-file-find:before {\n    content: \"\\edb3\";\n  }\n  .bxs-file-gif:before {\n    content: \"\\edb4\";\n  }\n  .bxs-file-html:before {\n    content: \"\\edb5\";\n  }\n  .bxs-file-image:before {\n    content: \"\\edb6\";\n  }\n  .bxs-file-import:before {\n    content: \"\\edb7\";\n  }\n  .bxs-file-jpg:before {\n    content: \"\\edb8\";\n  }\n  .bxs-file-js:before {\n    content: \"\\edb9\";\n  }\n  .bxs-file-json:before {\n    content: \"\\edba\";\n  }\n  .bxs-file-md:before {\n    content: \"\\edbb\";\n  }\n  .bxs-file-pdf:before {\n    content: \"\\edbc\";\n  }\n  .bxs-file-plus:before {\n    content: \"\\edbd\";\n  }\n  .bxs-file-png:before {\n    content: \"\\edbe\";\n  }\n  .bxs-file-txt:before {\n    content: \"\\edbf\";\n  }\n  .bxs-film:before {\n    content: \"\\edc0\";\n  }\n  .bxs-filter-alt:before {\n    content: \"\\edc1\";\n  }\n  .bxs-first-aid:before {\n    content: \"\\edc2\";\n  }\n  .bxs-flag:before {\n    content: \"\\edc3\";\n  }\n  .bxs-flag-alt:before {\n    content: \"\\edc4\";\n  }\n  .bxs-flag-checkered:before {\n    content: \"\\edc5\";\n  }\n  .bxs-flame:before {\n    content: \"\\edc6\";\n  }\n  .bxs-flask:before {\n    content: \"\\edc7\";\n  }\n  .bxs-florist:before {\n    content: \"\\edc8\";\n  }\n  .bxs-folder:before {\n    content: \"\\edc9\";\n  }\n  .bxs-folder-minus:before {\n    content: \"\\edca\";\n  }\n  .bxs-folder-open:before {\n    content: \"\\edcb\";\n  }\n  .bxs-folder-plus:before {\n    content: \"\\edcc\";\n  }\n  .bxs-food-menu:before {\n    content: \"\\edcd\";\n  }\n  .bxs-fridge:before {\n    content: \"\\edce\";\n  }\n  .bxs-game:before {\n    content: \"\\edcf\";\n  }\n  .bxs-gas-pump:before {\n    content: \"\\edd0\";\n  }\n  .bxs-ghost:before {\n    content: \"\\edd1\";\n  }\n  .bxs-gift:before {\n    content: \"\\edd2\";\n  }\n  .bxs-graduation:before {\n    content: \"\\edd3\";\n  }\n  .bxs-grid:before {\n    content: \"\\edd4\";\n  }\n  .bxs-grid-alt:before {\n    content: \"\\edd5\";\n  }\n  .bxs-group:before {\n    content: \"\\edd6\";\n  }\n  .bxs-guitar-amp:before {\n    content: \"\\edd7\";\n  }\n  .bxs-hand:before {\n    content: \"\\edd8\";\n  }\n  .bxs-hand-down:before {\n    content: \"\\edd9\";\n  }\n  .bxs-hand-left:before {\n    content: \"\\edda\";\n  }\n  .bxs-hand-right:before {\n    content: \"\\eddb\";\n  }\n  .bxs-hand-up:before {\n    content: \"\\eddc\";\n  }\n  .bxs-happy:before {\n    content: \"\\eddd\";\n  }\n  .bxs-happy-alt:before {\n    content: \"\\edde\";\n  }\n  .bxs-happy-beaming:before {\n    content: \"\\eddf\";\n  }\n  .bxs-happy-heart-eyes:before {\n    content: \"\\ede0\";\n  }\n  .bxs-hdd:before {\n    content: \"\\ede1\";\n  }\n  .bxs-heart:before {\n    content: \"\\ede2\";\n  }\n  .bxs-heart-circle:before {\n    content: \"\\ede3\";\n  }\n  .bxs-heart-square:before {\n    content: \"\\ede4\";\n  }\n  .bxs-help-circle:before {\n    content: \"\\ede5\";\n  }\n  .bxs-hide:before {\n    content: \"\\ede6\";\n  }\n  .bxs-home:before {\n    content: \"\\ede7\";\n  }\n  .bxs-home-circle:before {\n    content: \"\\ede8\";\n  }\n  .bxs-home-heart:before {\n    content: \"\\ede9\";\n  }\n  .bxs-home-smile:before {\n    content: \"\\edea\";\n  }\n  .bxs-hotel:before {\n    content: \"\\edeb\";\n  }\n  .bxs-hourglass:before {\n    content: \"\\edec\";\n  }\n  .bxs-hourglass-bottom:before {\n    content: \"\\eded\";\n  }\n  .bxs-hourglass-top:before {\n    content: \"\\edee\";\n  }\n  .bxs-id-card:before {\n    content: \"\\edef\";\n  }\n  .bxs-image:before {\n    content: \"\\edf0\";\n  }\n  .bxs-image-add:before {\n    content: \"\\edf1\";\n  }\n  .bxs-image-alt:before {\n    content: \"\\edf2\";\n  }\n  .bxs-inbox:before {\n    content: \"\\edf3\";\n  }\n  .bxs-info-circle:before {\n    content: \"\\edf4\";\n  }\n  .bxs-info-square:before {\n    content: \"\\edf5\";\n  }\n  .bxs-institution:before {\n    content: \"\\edf6\";\n  }\n  .bxs-joystick:before {\n    content: \"\\edf7\";\n  }\n  .bxs-joystick-alt:before {\n    content: \"\\edf8\";\n  }\n  .bxs-joystick-button:before {\n    content: \"\\edf9\";\n  }\n  .bxs-key:before {\n    content: \"\\edfa\";\n  }\n  .bxs-keyboard:before {\n    content: \"\\edfb\";\n  }\n  .bxs-label:before {\n    content: \"\\edfc\";\n  }\n  .bxs-landmark:before {\n    content: \"\\edfd\";\n  }\n  .bxs-landscape:before {\n    content: \"\\edfe\";\n  }\n  .bxs-laugh:before {\n    content: \"\\edff\";\n  }\n  .bxs-layer:before {\n    content: \"\\ee00\";\n  }\n  .bxs-layer-minus:before {\n    content: \"\\ee01\";\n  }\n  .bxs-layer-plus:before {\n    content: \"\\ee02\";\n  }\n  .bxs-layout:before {\n    content: \"\\ee03\";\n  }\n  .bxs-left-arrow:before {\n    content: \"\\ee04\";\n  }\n  .bxs-left-arrow-alt:before {\n    content: \"\\ee05\";\n  }\n  .bxs-left-arrow-circle:before {\n    content: \"\\ee06\";\n  }\n  .bxs-left-arrow-square:before {\n    content: \"\\ee07\";\n  }\n  .bxs-left-down-arrow-circle:before {\n    content: \"\\ee08\";\n  }\n  .bxs-left-top-arrow-circle:before {\n    content: \"\\ee09\";\n  }\n  .bxs-like:before {\n    content: \"\\ee0a\";\n  }\n  .bxs-location-plus:before {\n    content: \"\\ee0b\";\n  }\n  .bxs-lock:before {\n    content: \"\\ee0c\";\n  }\n  .bxs-lock-alt:before {\n    content: \"\\ee0d\";\n  }\n  .bxs-lock-open:before {\n    content: \"\\ee0e\";\n  }\n  .bxs-lock-open-alt:before {\n    content: \"\\ee0f\";\n  }\n  .bxs-log-in:before {\n    content: \"\\ee10\";\n  }\n  .bxs-log-in-circle:before {\n    content: \"\\ee11\";\n  }\n  .bxs-log-out:before {\n    content: \"\\ee12\";\n  }\n  .bxs-log-out-circle:before {\n    content: \"\\ee13\";\n  }\n  .bxs-low-vision:before {\n    content: \"\\ee14\";\n  }\n  .bxs-magic-wand:before {\n    content: \"\\ee15\";\n  }\n  .bxs-magnet:before {\n    content: \"\\ee16\";\n  }\n  .bxs-map:before {\n    content: \"\\ee17\";\n  }\n  .bxs-map-alt:before {\n    content: \"\\ee18\";\n  }\n  .bxs-map-pin:before {\n    content: \"\\ee19\";\n  }\n  .bxs-mask:before {\n    content: \"\\ee1a\";\n  }\n  .bxs-medal:before {\n    content: \"\\ee1b\";\n  }\n  .bxs-megaphone:before {\n    content: \"\\ee1c\";\n  }\n  .bxs-meh:before {\n    content: \"\\ee1d\";\n  }\n  .bxs-meh-alt:before {\n    content: \"\\ee1e\";\n  }\n  .bxs-meh-blank:before {\n    content: \"\\ee1f\";\n  }\n  .bxs-memory-card:before {\n    content: \"\\ee20\";\n  }\n  .bxs-message:before {\n    content: \"\\ee21\";\n  }\n  .bxs-message-add:before {\n    content: \"\\ee22\";\n  }\n  .bxs-message-alt:before {\n    content: \"\\ee23\";\n  }\n  .bxs-message-alt-add:before {\n    content: \"\\ee24\";\n  }\n  .bxs-message-alt-check:before {\n    content: \"\\ee25\";\n  }\n  .bxs-message-alt-detail:before {\n    content: \"\\ee26\";\n  }\n  .bxs-message-alt-dots:before {\n    content: \"\\ee27\";\n  }\n  .bxs-message-alt-edit:before {\n    content: \"\\ee28\";\n  }\n  .bxs-message-alt-error:before {\n    content: \"\\ee29\";\n  }\n  .bxs-message-alt-minus:before {\n    content: \"\\ee2a\";\n  }\n  .bxs-message-alt-x:before {\n    content: \"\\ee2b\";\n  }\n  .bxs-message-check:before {\n    content: \"\\ee2c\";\n  }\n  .bxs-message-detail:before {\n    content: \"\\ee2d\";\n  }\n  .bxs-message-dots:before {\n    content: \"\\ee2e\";\n  }\n  .bxs-message-edit:before {\n    content: \"\\ee2f\";\n  }\n  .bxs-message-error:before {\n    content: \"\\ee30\";\n  }\n  .bxs-message-minus:before {\n    content: \"\\ee31\";\n  }\n  .bxs-message-rounded:before {\n    content: \"\\ee32\";\n  }\n  .bxs-message-rounded-add:before {\n    content: \"\\ee33\";\n  }\n  .bxs-message-rounded-check:before {\n    content: \"\\ee34\";\n  }\n  .bxs-message-rounded-detail:before {\n    content: \"\\ee35\";\n  }\n  .bxs-message-rounded-dots:before {\n    content: \"\\ee36\";\n  }\n  .bxs-message-rounded-edit:before {\n    content: \"\\ee37\";\n  }\n  .bxs-message-rounded-error:before {\n    content: \"\\ee38\";\n  }\n  .bxs-message-rounded-minus:before {\n    content: \"\\ee39\";\n  }\n  .bxs-message-rounded-x:before {\n    content: \"\\ee3a\";\n  }\n  .bxs-message-square:before {\n    content: \"\\ee3b\";\n  }\n  .bxs-message-square-add:before {\n    content: \"\\ee3c\";\n  }\n  .bxs-message-square-check:before {\n    content: \"\\ee3d\";\n  }\n  .bxs-message-square-detail:before {\n    content: \"\\ee3e\";\n  }\n  .bxs-message-square-dots:before {\n    content: \"\\ee3f\";\n  }\n  .bxs-message-square-edit:before {\n    content: \"\\ee40\";\n  }\n  .bxs-message-square-error:before {\n    content: \"\\ee41\";\n  }\n  .bxs-message-square-minus:before {\n    content: \"\\ee42\";\n  }\n  .bxs-message-square-x:before {\n    content: \"\\ee43\";\n  }\n  .bxs-message-x:before {\n    content: \"\\ee44\";\n  }\n  .bxs-meteor:before {\n    content: \"\\ee45\";\n  }\n  .bxs-microchip:before {\n    content: \"\\ee46\";\n  }\n  .bxs-microphone:before {\n    content: \"\\ee47\";\n  }\n  .bxs-microphone-alt:before {\n    content: \"\\ee48\";\n  }\n  .bxs-microphone-off:before {\n    content: \"\\ee49\";\n  }\n  .bxs-minus-circle:before {\n    content: \"\\ee4a\";\n  }\n  .bxs-minus-square:before {\n    content: \"\\ee4b\";\n  }\n  .bxs-mobile:before {\n    content: \"\\ee4c\";\n  }\n  .bxs-mobile-vibration:before {\n    content: \"\\ee4d\";\n  }\n  .bxs-moon:before {\n    content: \"\\ee4e\";\n  }\n  .bxs-mouse:before {\n    content: \"\\ee4f\";\n  }\n  .bxs-mouse-alt:before {\n    content: \"\\ee50\";\n  }\n  .bxs-movie:before {\n    content: \"\\ee51\";\n  }\n  .bxs-movie-play:before {\n    content: \"\\ee52\";\n  }\n  .bxs-music:before {\n    content: \"\\ee53\";\n  }\n  .bxs-navigation:before {\n    content: \"\\ee54\";\n  }\n  .bxs-network-chart:before {\n    content: \"\\ee55\";\n  }\n  .bxs-news:before {\n    content: \"\\ee56\";\n  }\n  .bxs-no-entry:before {\n    content: \"\\ee57\";\n  }\n  .bxs-note:before {\n    content: \"\\ee58\";\n  }\n  .bxs-notepad:before {\n    content: \"\\ee59\";\n  }\n  .bxs-notification:before {\n    content: \"\\ee5a\";\n  }\n  .bxs-notification-off:before {\n    content: \"\\ee5b\";\n  }\n  .bxs-offer:before {\n    content: \"\\ee5c\";\n  }\n  .bxs-package:before {\n    content: \"\\ee5d\";\n  }\n  .bxs-paint:before {\n    content: \"\\ee5e\";\n  }\n  .bxs-paint-roll:before {\n    content: \"\\ee5f\";\n  }\n  .bxs-palette:before {\n    content: \"\\ee60\";\n  }\n  .bxs-paper-plane:before {\n    content: \"\\ee61\";\n  }\n  .bxs-parking:before {\n    content: \"\\ee62\";\n  }\n  .bxs-paste:before {\n    content: \"\\ee63\";\n  }\n  .bxs-pen:before {\n    content: \"\\ee64\";\n  }\n  .bxs-pencil:before {\n    content: \"\\ee65\";\n  }\n  .bxs-phone:before {\n    content: \"\\ee66\";\n  }\n  .bxs-phone-call:before {\n    content: \"\\ee67\";\n  }\n  .bxs-phone-incoming:before {\n    content: \"\\ee68\";\n  }\n  .bxs-phone-off:before {\n    content: \"\\ee69\";\n  }\n  .bxs-phone-outgoing:before {\n    content: \"\\ee6a\";\n  }\n  .bxs-photo-album:before {\n    content: \"\\ee6b\";\n  }\n  .bxs-piano:before {\n    content: \"\\ee6c\";\n  }\n  .bxs-pie-chart:before {\n    content: \"\\ee6d\";\n  }\n  .bxs-pie-chart-alt:before {\n    content: \"\\ee6e\";\n  }\n  .bxs-pie-chart-alt-2:before {\n    content: \"\\ee6f\";\n  }\n  .bxs-pin:before {\n    content: \"\\ee70\";\n  }\n  .bxs-pizza:before {\n    content: \"\\ee71\";\n  }\n  .bxs-plane:before {\n    content: \"\\ee72\";\n  }\n  .bxs-plane-alt:before {\n    content: \"\\ee73\";\n  }\n  .bxs-plane-land:before {\n    content: \"\\ee74\";\n  }\n  .bxs-planet:before {\n    content: \"\\ee75\";\n  }\n  .bxs-plane-take-off:before {\n    content: \"\\ee76\";\n  }\n  .bxs-playlist:before {\n    content: \"\\ee77\";\n  }\n  .bxs-plug:before {\n    content: \"\\ee78\";\n  }\n  .bxs-plus-circle:before {\n    content: \"\\ee79\";\n  }\n  .bxs-plus-square:before {\n    content: \"\\ee7a\";\n  }\n  .bxs-pointer:before {\n    content: \"\\ee7b\";\n  }\n  .bxs-polygon:before {\n    content: \"\\ee7c\";\n  }\n  .bxs-printer:before {\n    content: \"\\ee7d\";\n  }\n  .bxs-purchase-tag:before {\n    content: \"\\ee7e\";\n  }\n  .bxs-purchase-tag-alt:before {\n    content: \"\\ee7f\";\n  }\n  .bxs-pyramid:before {\n    content: \"\\ee80\";\n  }\n  .bxs-quote-alt-left:before {\n    content: \"\\ee81\";\n  }\n  .bxs-quote-alt-right:before {\n    content: \"\\ee82\";\n  }\n  .bxs-quote-left:before {\n    content: \"\\ee83\";\n  }\n  .bxs-quote-right:before {\n    content: \"\\ee84\";\n  }\n  .bxs-quote-single-left:before {\n    content: \"\\ee85\";\n  }\n  .bxs-quote-single-right:before {\n    content: \"\\ee86\";\n  }\n  .bxs-radiation:before {\n    content: \"\\ee87\";\n  }\n  .bxs-radio:before {\n    content: \"\\ee88\";\n  }\n  .bxs-receipt:before {\n    content: \"\\ee89\";\n  }\n  .bxs-rectangle:before {\n    content: \"\\ee8a\";\n  }\n  .bxs-registered:before {\n    content: \"\\ee8b\";\n  }\n  .bxs-rename:before {\n    content: \"\\ee8c\";\n  }\n  .bxs-report:before {\n    content: \"\\ee8d\";\n  }\n  .bxs-rewind-circle:before {\n    content: \"\\ee8e\";\n  }\n  .bxs-right-arrow:before {\n    content: \"\\ee8f\";\n  }\n  .bxs-right-arrow-alt:before {\n    content: \"\\ee90\";\n  }\n  .bxs-right-arrow-circle:before {\n    content: \"\\ee91\";\n  }\n  .bxs-right-arrow-square:before {\n    content: \"\\ee92\";\n  }\n  .bxs-right-down-arrow-circle:before {\n    content: \"\\ee93\";\n  }\n  .bxs-right-top-arrow-circle:before {\n    content: \"\\ee94\";\n  }\n  .bxs-rocket:before {\n    content: \"\\ee95\";\n  }\n  .bxs-ruler:before {\n    content: \"\\ee96\";\n  }\n  .bxs-sad:before {\n    content: \"\\ee97\";\n  }\n  .bxs-save:before {\n    content: \"\\ee98\";\n  }\n  .bxs-school:before {\n    content: \"\\ee99\";\n  }\n  .bxs-search:before {\n    content: \"\\ee9a\";\n  }\n  .bxs-search-alt-2:before {\n    content: \"\\ee9b\";\n  }\n  .bxs-select-multiple:before {\n    content: \"\\ee9c\";\n  }\n  .bxs-send:before {\n    content: \"\\ee9d\";\n  }\n  .bxs-server:before {\n    content: \"\\ee9e\";\n  }\n  .bxs-shapes:before {\n    content: \"\\ee9f\";\n  }\n  .bxs-share:before {\n    content: \"\\eea0\";\n  }\n  .bxs-share-alt:before {\n    content: \"\\eea1\";\n  }\n  .bxs-shield:before {\n    content: \"\\eea2\";\n  }\n  .bxs-shield-alt-2:before {\n    content: \"\\eea3\";\n  }\n  .bxs-shield-x:before {\n    content: \"\\eea4\";\n  }\n  .bxs-ship:before {\n    content: \"\\eea5\";\n  }\n  .bxs-shocked:before {\n    content: \"\\eea6\";\n  }\n  .bxs-shopping-bag:before {\n    content: \"\\eea7\";\n  }\n  .bxs-shopping-bag-alt:before {\n    content: \"\\eea8\";\n  }\n  .bxs-shopping-bags:before {\n    content: \"\\eea9\";\n  }\n  .bxs-show:before {\n    content: \"\\eeaa\";\n  }\n  .bxs-skip-next-circle:before {\n    content: \"\\eeab\";\n  }\n  .bxs-skip-previous-circle:before {\n    content: \"\\eeac\";\n  }\n  .bxs-skull:before {\n    content: \"\\eead\";\n  }\n  .bxs-sleepy:before {\n    content: \"\\eeae\";\n  }\n  .bxs-slideshow:before {\n    content: \"\\eeaf\";\n  }\n  .bxs-smile:before {\n    content: \"\\eeb0\";\n  }\n  .bxs-sort-alt:before {\n    content: \"\\eeb1\";\n  }\n  .bxs-spa:before {\n    content: \"\\eeb2\";\n  }\n  .bxs-speaker:before {\n    content: \"\\eeb3\";\n  }\n  .bxs-spray-can:before {\n    content: \"\\eeb4\";\n  }\n  .bxs-spreadsheet:before {\n    content: \"\\eeb5\";\n  }\n  .bxs-square:before {\n    content: \"\\eeb6\";\n  }\n  .bxs-square-rounded:before {\n    content: \"\\eeb7\";\n  }\n  .bxs-star:before {\n    content: \"\\eeb8\";\n  }\n  .bxs-star-half:before {\n    content: \"\\eeb9\";\n  }\n  .bxs-sticker:before {\n    content: \"\\eeba\";\n  }\n  .bxs-stopwatch:before {\n    content: \"\\eebb\";\n  }\n  .bxs-store:before {\n    content: \"\\eebc\";\n  }\n  .bxs-store-alt:before {\n    content: \"\\eebd\";\n  }\n  .bxs-sun:before {\n    content: \"\\eebe\";\n  }\n  .bxs-tachometer:before {\n    content: \"\\eebf\";\n  }\n  .bxs-tag:before {\n    content: \"\\eec0\";\n  }\n  .bxs-tag-alt:before {\n    content: \"\\eec1\";\n  }\n  .bxs-tag-x:before {\n    content: \"\\eec2\";\n  }\n  .bxs-taxi:before {\n    content: \"\\eec3\";\n  }\n  .bxs-tennis-ball:before {\n    content: \"\\eec4\";\n  }\n  .bxs-terminal:before {\n    content: \"\\eec5\";\n  }\n  .bxs-thermometer:before {\n    content: \"\\eec6\";\n  }\n  .bxs-time:before {\n    content: \"\\eec7\";\n  }\n  .bxs-time-five:before {\n    content: \"\\eec8\";\n  }\n  .bxs-timer:before {\n    content: \"\\eec9\";\n  }\n  .bxs-tired:before {\n    content: \"\\eeca\";\n  }\n  .bxs-toggle-left:before {\n    content: \"\\eecb\";\n  }\n  .bxs-toggle-right:before {\n    content: \"\\eecc\";\n  }\n  .bxs-tone:before {\n    content: \"\\eecd\";\n  }\n  .bxs-torch:before {\n    content: \"\\eece\";\n  }\n  .bxs-to-top:before {\n    content: \"\\eecf\";\n  }\n  .bxs-traffic:before {\n    content: \"\\eed0\";\n  }\n  .bxs-traffic-barrier:before {\n    content: \"\\eed1\";\n  }\n  .bxs-traffic-cone:before {\n    content: \"\\eed2\";\n  }\n  .bxs-train:before {\n    content: \"\\eed3\";\n  }\n  .bxs-trash:before {\n    content: \"\\eed4\";\n  }\n  .bxs-trash-alt:before {\n    content: \"\\eed5\";\n  }\n  .bxs-tree:before {\n    content: \"\\eed6\";\n  }\n  .bxs-trophy:before {\n    content: \"\\eed7\";\n  }\n  .bxs-truck:before {\n    content: \"\\eed8\";\n  }\n  .bxs-t-shirt:before {\n    content: \"\\eed9\";\n  }\n  .bxs-tv:before {\n    content: \"\\eeda\";\n  }\n  .bxs-up-arrow:before {\n    content: \"\\eedb\";\n  }\n  .bxs-up-arrow-alt:before {\n    content: \"\\eedc\";\n  }\n  .bxs-up-arrow-circle:before {\n    content: \"\\eedd\";\n  }\n  .bxs-up-arrow-square:before {\n    content: \"\\eede\";\n  }\n  .bxs-upside-down:before {\n    content: \"\\eedf\";\n  }\n  .bxs-upvote:before {\n    content: \"\\eee0\";\n  }\n  .bxs-user:before {\n    content: \"\\eee1\";\n  }\n  .bxs-user-account:before {\n    content: \"\\eee2\";\n  }\n  .bxs-user-badge:before {\n    content: \"\\eee3\";\n  }\n  .bxs-user-check:before {\n    content: \"\\eee4\";\n  }\n  .bxs-user-circle:before {\n    content: \"\\eee5\";\n  }\n  .bxs-user-detail:before {\n    content: \"\\eee6\";\n  }\n  .bxs-user-minus:before {\n    content: \"\\eee7\";\n  }\n  .bxs-user-pin:before {\n    content: \"\\eee8\";\n  }\n  .bxs-user-plus:before {\n    content: \"\\eee9\";\n  }\n  .bxs-user-rectangle:before {\n    content: \"\\eeea\";\n  }\n  .bxs-user-voice:before {\n    content: \"\\eeeb\";\n  }\n  .bxs-user-x:before {\n    content: \"\\eeec\";\n  }\n  .bxs-vector:before {\n    content: \"\\eeed\";\n  }\n  .bxs-vial:before {\n    content: \"\\eeee\";\n  }\n  .bxs-video:before {\n    content: \"\\eeef\";\n  }\n  .bxs-video-off:before {\n    content: \"\\eef0\";\n  }\n  .bxs-video-plus:before {\n    content: \"\\eef1\";\n  }\n  .bxs-video-recording:before {\n    content: \"\\eef2\";\n  }\n  .bxs-videos:before {\n    content: \"\\eef3\";\n  }\n  .bxs-virus:before {\n    content: \"\\eef4\";\n  }\n  .bxs-virus-block:before {\n    content: \"\\eef5\";\n  }\n  .bxs-volume:before {\n    content: \"\\eef6\";\n  }\n  .bxs-volume-full:before {\n    content: \"\\eef7\";\n  }\n  .bxs-volume-low:before {\n    content: \"\\eef8\";\n  }\n  .bxs-volume-mute:before {\n    content: \"\\eef9\";\n  }\n  .bxs-wallet:before {\n    content: \"\\eefa\";\n  }\n  .bxs-wallet-alt:before {\n    content: \"\\eefb\";\n  }\n  .bxs-washer:before {\n    content: \"\\eefc\";\n  }\n  .bxs-watch:before {\n    content: \"\\eefd\";\n  }\n  .bxs-watch-alt:before {\n    content: \"\\eefe\";\n  }\n  .bxs-webcam:before {\n    content: \"\\eeff\";\n  }\n  .bxs-widget:before {\n    content: \"\\ef00\";\n  }\n  .bxs-window-alt:before {\n    content: \"\\ef01\";\n  }\n  .bxs-wine:before {\n    content: \"\\ef02\";\n  }\n  .bxs-wink-smile:before {\n    content: \"\\ef03\";\n  }\n  .bxs-wink-tongue:before {\n    content: \"\\ef04\";\n  }\n  .bxs-wrench:before {\n    content: \"\\ef05\";\n  }\n  .bxs-x-circle:before {\n    content: \"\\ef06\";\n  }\n  .bxs-x-square:before {\n    content: \"\\ef07\";\n  }\n  .bxs-yin-yang:before {\n    content: \"\\ef08\";\n  }\n  .bxs-zap:before {\n    content: \"\\ef09\";\n  }\n  .bxs-zoom-in:before {\n    content: \"\\ef0a\";\n  }\n  .bxs-zoom-out:before {\n    content: \"\\ef0b\";\n  }\n  ",".la,\n.las,\n.lar,\n.lal,\n.lad,\n.lab {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n  line-height: 1; }\n\n.la-lg {\n  font-size: 1.33333em;\n  line-height: 0.75em;\n  vertical-align: -.0667em; }\n\n.la-xs {\n  font-size: .75em; }\n\n.la-sm {\n  font-size: .875em; }\n\n.la-1x {\n  font-size: 1em; }\n\n.la-2x {\n  font-size: 2em; }\n\n.la-3x {\n  font-size: 3em; }\n\n.la-4x {\n  font-size: 4em; }\n\n.la-5x {\n  font-size: 5em; }\n\n.la-6x {\n  font-size: 6em; }\n\n.la-7x {\n  font-size: 7em; }\n\n.la-8x {\n  font-size: 8em; }\n\n.la-9x {\n  font-size: 9em; }\n\n.la-10x {\n  font-size: 10em; }\n\n.la-fw {\n  text-align: center;\n  width: 1.25em; }\n\n.la-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0; }\n  .la-ul > li {\n    position: relative; }\n\n.la-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit; }\n\n.la-border {\n  border: solid 0.08em #eee;\n  border-radius: .1em;\n  padding: .2em .25em .15em; }\n\n.la-pull-left {\n  float: left; }\n\n.la-pull-right {\n  float: right; }\n\n.la.la-pull-left,\n.las.la-pull-left,\n.lar.la-pull-left,\n.lal.la-pull-left,\n.lab.la-pull-left {\n  margin-right: .3em; }\n\n.la.la-pull-right,\n.las.la-pull-right,\n.lar.la-pull-right,\n.lal.la-pull-right,\n.lab.la-pull-right {\n  margin-left: .3em; }\n\n.la-spin {\n  -webkit-animation: la-spin 2s infinite linear;\n          animation: la-spin 2s infinite linear; }\n\n.la-pulse {\n  -webkit-animation: la-spin 1s infinite steps(8);\n          animation: la-spin 1s infinite steps(8); }\n\n@-webkit-keyframes la-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n@keyframes la-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n.la-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg); }\n\n.la-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg); }\n\n.la-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg); }\n\n.la-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1); }\n\n.la-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1); }\n\n.la-flip-both, .la-flip-horizontal.la-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1); }\n\n:root .la-rotate-90,\n:root .la-rotate-180,\n:root .la-rotate-270,\n:root .la-flip-horizontal,\n:root .la-flip-vertical,\n:root .la-flip-both {\n  -webkit-filter: none;\n          filter: none; }\n\n.la-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: middle;\n  width: 2.5em; }\n\n.la-stack-1x,\n.la-stack-2x {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  width: 100%; }\n\n.la-stack-1x {\n  line-height: inherit; }\n\n.la-stack-2x {\n  font-size: 2em; }\n\n.la-inverse {\n  color: #fff; }\n\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\nreaders do not read off random characters that represent icons */\n.la-500px:before {\n  content: \"\\f26e\"; }\n\n.la-accessible-icon:before {\n  content: \"\\f368\"; }\n\n.la-accusoft:before {\n  content: \"\\f369\"; }\n\n.la-acquisitions-incorporated:before {\n  content: \"\\f6af\"; }\n\n.la-ad:before {\n  content: \"\\f641\"; }\n\n.la-address-book:before {\n  content: \"\\f2b9\"; }\n\n.la-address-card:before {\n  content: \"\\f2bb\"; }\n\n.la-adjust:before {\n  content: \"\\f042\"; }\n\n.la-adn:before {\n  content: \"\\f170\"; }\n\n.la-adobe:before {\n  content: \"\\f778\"; }\n\n.la-adversal:before {\n  content: \"\\f36a\"; }\n\n.la-affiliatetheme:before {\n  content: \"\\f36b\"; }\n\n.la-air-freshener:before {\n  content: \"\\f5d0\"; }\n\n.la-airbnb:before {\n  content: \"\\f834\"; }\n\n.la-algolia:before {\n  content: \"\\f36c\"; }\n\n.la-align-center:before {\n  content: \"\\f037\"; }\n\n.la-align-justify:before {\n  content: \"\\f039\"; }\n\n.la-align-left:before {\n  content: \"\\f036\"; }\n\n.la-align-right:before {\n  content: \"\\f038\"; }\n\n.la-alipay:before {\n  content: \"\\f642\"; }\n\n.la-allergies:before {\n  content: \"\\f461\"; }\n\n.la-amazon:before {\n  content: \"\\f270\"; }\n\n.la-amazon-pay:before {\n  content: \"\\f42c\"; }\n\n.la-ambulance:before {\n  content: \"\\f0f9\"; }\n\n.la-american-sign-language-interpreting:before {\n  content: \"\\f2a3\"; }\n\n.la-amilia:before {\n  content: \"\\f36d\"; }\n\n.la-anchor:before {\n  content: \"\\f13d\"; }\n\n.la-android:before {\n  content: \"\\f17b\"; }\n\n.la-angellist:before {\n  content: \"\\f209\"; }\n\n.la-angle-double-down:before {\n  content: \"\\f103\"; }\n\n.la-angle-double-left:before {\n  content: \"\\f100\"; }\n\n.la-angle-double-right:before {\n  content: \"\\f101\"; }\n\n.la-angle-double-up:before {\n  content: \"\\f102\"; }\n\n.la-angle-down:before {\n  content: \"\\f107\"; }\n\n.la-angle-left:before {\n  content: \"\\f104\"; }\n\n.la-angle-right:before {\n  content: \"\\f105\"; }\n\n.la-angle-up:before {\n  content: \"\\f106\"; }\n\n.la-angry:before {\n  content: \"\\f556\"; }\n\n.la-angrycreative:before {\n  content: \"\\f36e\"; }\n\n.la-angular:before {\n  content: \"\\f420\"; }\n\n.la-ankh:before {\n  content: \"\\f644\"; }\n\n.la-app-store:before {\n  content: \"\\f36f\"; }\n\n.la-app-store-ios:before {\n  content: \"\\f370\"; }\n\n.la-apper:before {\n  content: \"\\f371\"; }\n\n.la-apple:before {\n  content: \"\\f179\"; }\n\n.la-apple-alt:before {\n  content: \"\\f5d1\"; }\n\n.la-apple-pay:before {\n  content: \"\\f415\"; }\n\n.la-archive:before {\n  content: \"\\f187\"; }\n\n.la-archway:before {\n  content: \"\\f557\"; }\n\n.la-arrow-alt-circle-down:before {\n  content: \"\\f358\"; }\n\n.la-arrow-alt-circle-left:before {\n  content: \"\\f359\"; }\n\n.la-arrow-alt-circle-right:before {\n  content: \"\\f35a\"; }\n\n.la-arrow-alt-circle-up:before {\n  content: \"\\f35b\"; }\n\n.la-arrow-circle-down:before {\n  content: \"\\f0ab\"; }\n\n.la-arrow-circle-left:before {\n  content: \"\\f0a8\"; }\n\n.la-arrow-circle-right:before {\n  content: \"\\f0a9\"; }\n\n.la-arrow-circle-up:before {\n  content: \"\\f0aa\"; }\n\n.la-arrow-down:before {\n  content: \"\\f063\"; }\n\n.la-arrow-left:before {\n  content: \"\\f060\"; }\n\n.la-arrow-right:before {\n  content: \"\\f061\"; }\n\n.la-arrow-up:before {\n  content: \"\\f062\"; }\n\n.la-arrows-alt:before {\n  content: \"\\f0b2\"; }\n\n.la-arrows-alt-h:before {\n  content: \"\\f337\"; }\n\n.la-arrows-alt-v:before {\n  content: \"\\f338\"; }\n\n.la-artstation:before {\n  content: \"\\f77a\"; }\n\n.la-assistive-listening-systems:before {\n  content: \"\\f2a2\"; }\n\n.la-asterisk:before {\n  content: \"\\f069\"; }\n\n.la-asymmetrik:before {\n  content: \"\\f372\"; }\n\n.la-at:before {\n  content: \"\\f1fa\"; }\n\n.la-atlas:before {\n  content: \"\\f558\"; }\n\n.la-atlassian:before {\n  content: \"\\f77b\"; }\n\n.la-atom:before {\n  content: \"\\f5d2\"; }\n\n.la-audible:before {\n  content: \"\\f373\"; }\n\n.la-audio-description:before {\n  content: \"\\f29e\"; }\n\n.la-autoprefixer:before {\n  content: \"\\f41c\"; }\n\n.la-avianex:before {\n  content: \"\\f374\"; }\n\n.la-aviato:before {\n  content: \"\\f421\"; }\n\n.la-award:before {\n  content: \"\\f559\"; }\n\n.la-aws:before {\n  content: \"\\f375\"; }\n\n.la-baby:before {\n  content: \"\\f77c\"; }\n\n.la-baby-carriage:before {\n  content: \"\\f77d\"; }\n\n.la-backspace:before {\n  content: \"\\f55a\"; }\n\n.la-backward:before {\n  content: \"\\f04a\"; }\n\n.la-bacon:before {\n  content: \"\\f7e5\"; }\n\n.la-balance-scale:before {\n  content: \"\\f24e\"; }\n\n.la-balance-scale-left:before {\n  content: \"\\f515\"; }\n\n.la-balance-scale-right:before {\n  content: \"\\f516\"; }\n\n.la-ban:before {\n  content: \"\\f05e\"; }\n\n.la-band-aid:before {\n  content: \"\\f462\"; }\n\n.la-bandcamp:before {\n  content: \"\\f2d5\"; }\n\n.la-barcode:before {\n  content: \"\\f02a\"; }\n\n.la-bars:before {\n  content: \"\\f0c9\"; }\n\n.la-baseball-ball:before {\n  content: \"\\f433\"; }\n\n.la-basketball-ball:before {\n  content: \"\\f434\"; }\n\n.la-bath:before {\n  content: \"\\f2cd\"; }\n\n.la-battery-empty:before {\n  content: \"\\f244\"; }\n\n.la-battery-full:before {\n  content: \"\\f240\"; }\n\n.la-battery-half:before {\n  content: \"\\f242\"; }\n\n.la-battery-quarter:before {\n  content: \"\\f243\"; }\n\n.la-battery-three-quarters:before {\n  content: \"\\f241\"; }\n\n.la-battle-net:before {\n  content: \"\\f835\"; }\n\n.la-bed:before {\n  content: \"\\f236\"; }\n\n.la-beer:before {\n  content: \"\\f0fc\"; }\n\n.la-behance:before {\n  content: \"\\f1b4\"; }\n\n.la-behance-square:before {\n  content: \"\\f1b5\"; }\n\n.la-bell:before {\n  content: \"\\f0f3\"; }\n\n.la-bell-slash:before {\n  content: \"\\f1f6\"; }\n\n.la-bezier-curve:before {\n  content: \"\\f55b\"; }\n\n.la-bible:before {\n  content: \"\\f647\"; }\n\n.la-bicycle:before {\n  content: \"\\f206\"; }\n\n.la-biking:before {\n  content: \"\\f84a\"; }\n\n.la-bimobject:before {\n  content: \"\\f378\"; }\n\n.la-binoculars:before {\n  content: \"\\f1e5\"; }\n\n.la-biohazard:before {\n  content: \"\\f780\"; }\n\n.la-birthday-cake:before {\n  content: \"\\f1fd\"; }\n\n.la-bitbucket:before {\n  content: \"\\f171\"; }\n\n.la-bitcoin:before {\n  content: \"\\f379\"; }\n\n.la-bity:before {\n  content: \"\\f37a\"; }\n\n.la-black-tie:before {\n  content: \"\\f27e\"; }\n\n.la-blackberry:before {\n  content: \"\\f37b\"; }\n\n.la-blender:before {\n  content: \"\\f517\"; }\n\n.la-blender-phone:before {\n  content: \"\\f6b6\"; }\n\n.la-blind:before {\n  content: \"\\f29d\"; }\n\n.la-blog:before {\n  content: \"\\f781\"; }\n\n.la-blogger:before {\n  content: \"\\f37c\"; }\n\n.la-blogger-b:before {\n  content: \"\\f37d\"; }\n\n.la-bluetooth:before {\n  content: \"\\f293\"; }\n\n.la-bluetooth-b:before {\n  content: \"\\f294\"; }\n\n.la-bold:before {\n  content: \"\\f032\"; }\n\n.la-bolt:before {\n  content: \"\\f0e7\"; }\n\n.la-bomb:before {\n  content: \"\\f1e2\"; }\n\n.la-bone:before {\n  content: \"\\f5d7\"; }\n\n.la-bong:before {\n  content: \"\\f55c\"; }\n\n.la-book:before {\n  content: \"\\f02d\"; }\n\n.la-book-dead:before {\n  content: \"\\f6b7\"; }\n\n.la-book-medical:before {\n  content: \"\\f7e6\"; }\n\n.la-book-open:before {\n  content: \"\\f518\"; }\n\n.la-book-reader:before {\n  content: \"\\f5da\"; }\n\n.la-bookmark:before {\n  content: \"\\f02e\"; }\n\n.la-bootstrap:before {\n  content: \"\\f836\"; }\n\n.la-border-all:before {\n  content: \"\\f84c\"; }\n\n.la-border-none:before {\n  content: \"\\f850\"; }\n\n.la-border-style:before {\n  content: \"\\f853\"; }\n\n.la-bowling-ball:before {\n  content: \"\\f436\"; }\n\n.la-box:before {\n  content: \"\\f466\"; }\n\n.la-box-open:before {\n  content: \"\\f49e\"; }\n\n.la-boxes:before {\n  content: \"\\f468\"; }\n\n.la-braille:before {\n  content: \"\\f2a1\"; }\n\n.la-brain:before {\n  content: \"\\f5dc\"; }\n\n.la-bread-slice:before {\n  content: \"\\f7ec\"; }\n\n.la-briefcase:before {\n  content: \"\\f0b1\"; }\n\n.la-briefcase-medical:before {\n  content: \"\\f469\"; }\n\n.la-broadcast-tower:before {\n  content: \"\\f519\"; }\n\n.la-broom:before {\n  content: \"\\f51a\"; }\n\n.la-brush:before {\n  content: \"\\f55d\"; }\n\n.la-btc:before {\n  content: \"\\f15a\"; }\n\n.la-buffer:before {\n  content: \"\\f837\"; }\n\n.la-bug:before {\n  content: \"\\f188\"; }\n\n.la-building:before {\n  content: \"\\f1ad\"; }\n\n.la-bullhorn:before {\n  content: \"\\f0a1\"; }\n\n.la-bullseye:before {\n  content: \"\\f140\"; }\n\n.la-burn:before {\n  content: \"\\f46a\"; }\n\n.la-buromobelexperte:before {\n  content: \"\\f37f\"; }\n\n.la-bus:before {\n  content: \"\\f207\"; }\n\n.la-bus-alt:before {\n  content: \"\\f55e\"; }\n\n.la-business-time:before {\n  content: \"\\f64a\"; }\n\n.la-buy-n-large:before {\n  content: \"\\f8a6\"; }\n\n.la-buysellads:before {\n  content: \"\\f20d\"; }\n\n.la-calculator:before {\n  content: \"\\f1ec\"; }\n\n.la-calendar:before {\n  content: \"\\f133\"; }\n\n.la-calendar-alt:before {\n  content: \"\\f073\"; }\n\n.la-calendar-check:before {\n  content: \"\\f274\"; }\n\n.la-calendar-day:before {\n  content: \"\\f783\"; }\n\n.la-calendar-minus:before {\n  content: \"\\f272\"; }\n\n.la-calendar-plus:before {\n  content: \"\\f271\"; }\n\n.la-calendar-times:before {\n  content: \"\\f273\"; }\n\n.la-calendar-week:before {\n  content: \"\\f784\"; }\n\n.la-camera:before {\n  content: \"\\f030\"; }\n\n.la-camera-retro:before {\n  content: \"\\f083\"; }\n\n.la-campground:before {\n  content: \"\\f6bb\"; }\n\n.la-canadian-maple-leaf:before {\n  content: \"\\f785\"; }\n\n.la-candy-cane:before {\n  content: \"\\f786\"; }\n\n.la-cannabis:before {\n  content: \"\\f55f\"; }\n\n.la-capsules:before {\n  content: \"\\f46b\"; }\n\n.la-car:before {\n  content: \"\\f1b9\"; }\n\n.la-car-alt:before {\n  content: \"\\f5de\"; }\n\n.la-car-battery:before {\n  content: \"\\f5df\"; }\n\n.la-car-crash:before {\n  content: \"\\f5e1\"; }\n\n.la-car-side:before {\n  content: \"\\f5e4\"; }\n\n.la-caret-down:before {\n  content: \"\\f0d7\"; }\n\n.la-caret-left:before {\n  content: \"\\f0d9\"; }\n\n.la-caret-right:before {\n  content: \"\\f0da\"; }\n\n.la-caret-square-down:before {\n  content: \"\\f150\"; }\n\n.la-caret-square-left:before {\n  content: \"\\f191\"; }\n\n.la-caret-square-right:before {\n  content: \"\\f152\"; }\n\n.la-caret-square-up:before {\n  content: \"\\f151\"; }\n\n.la-caret-up:before {\n  content: \"\\f0d8\"; }\n\n.la-carrot:before {\n  content: \"\\f787\"; }\n\n.la-cart-arrow-down:before {\n  content: \"\\f218\"; }\n\n.la-cart-plus:before {\n  content: \"\\f217\"; }\n\n.la-cash-register:before {\n  content: \"\\f788\"; }\n\n.la-cat:before {\n  content: \"\\f6be\"; }\n\n.la-cc-amazon-pay:before {\n  content: \"\\f42d\"; }\n\n.la-cc-amex:before {\n  content: \"\\f1f3\"; }\n\n.la-cc-apple-pay:before {\n  content: \"\\f416\"; }\n\n.la-cc-diners-club:before {\n  content: \"\\f24c\"; }\n\n.la-cc-discover:before {\n  content: \"\\f1f2\"; }\n\n.la-cc-jcb:before {\n  content: \"\\f24b\"; }\n\n.la-cc-mastercard:before {\n  content: \"\\f1f1\"; }\n\n.la-cc-paypal:before {\n  content: \"\\f1f4\"; }\n\n.la-cc-stripe:before {\n  content: \"\\f1f5\"; }\n\n.la-cc-visa:before {\n  content: \"\\f1f0\"; }\n\n.la-centercode:before {\n  content: \"\\f380\"; }\n\n.la-centos:before {\n  content: \"\\f789\"; }\n\n.la-certificate:before {\n  content: \"\\f0a3\"; }\n\n.la-chair:before {\n  content: \"\\f6c0\"; }\n\n.la-chalkboard:before {\n  content: \"\\f51b\"; }\n\n.la-chalkboard-teacher:before {\n  content: \"\\f51c\"; }\n\n.la-charging-station:before {\n  content: \"\\f5e7\"; }\n\n.la-chart-area:before {\n  content: \"\\f1fe\"; }\n\n.la-chart-bar:before {\n  content: \"\\f080\"; }\n\n.la-chart-line:before {\n  content: \"\\f201\"; }\n\n.la-chart-pie:before {\n  content: \"\\f200\"; }\n\n.la-check:before {\n  content: \"\\f00c\"; }\n\n.la-check-circle:before {\n  content: \"\\f058\"; }\n\n.la-check-double:before {\n  content: \"\\f560\"; }\n\n.la-check-square:before {\n  content: \"\\f14a\"; }\n\n.la-cheese:before {\n  content: \"\\f7ef\"; }\n\n.la-chess:before {\n  content: \"\\f439\"; }\n\n.la-chess-bishop:before {\n  content: \"\\f43a\"; }\n\n.la-chess-board:before {\n  content: \"\\f43c\"; }\n\n.la-chess-king:before {\n  content: \"\\f43f\"; }\n\n.la-chess-knight:before {\n  content: \"\\f441\"; }\n\n.la-chess-pawn:before {\n  content: \"\\f443\"; }\n\n.la-chess-queen:before {\n  content: \"\\f445\"; }\n\n.la-chess-rook:before {\n  content: \"\\f447\"; }\n\n.la-chevron-circle-down:before {\n  content: \"\\f13a\"; }\n\n.la-chevron-circle-left:before {\n  content: \"\\f137\"; }\n\n.la-chevron-circle-right:before {\n  content: \"\\f138\"; }\n\n.la-chevron-circle-up:before {\n  content: \"\\f139\"; }\n\n.la-chevron-down:before {\n  content: \"\\f078\"; }\n\n.la-chevron-left:before {\n  content: \"\\f053\"; }\n\n.la-chevron-right:before {\n  content: \"\\f054\"; }\n\n.la-chevron-up:before {\n  content: \"\\f077\"; }\n\n.la-child:before {\n  content: \"\\f1ae\"; }\n\n.la-chrome:before {\n  content: \"\\f268\"; }\n\n.la-chromecast:before {\n  content: \"\\f838\"; }\n\n.la-church:before {\n  content: \"\\f51d\"; }\n\n.la-circle:before {\n  content: \"\\f111\"; }\n\n.la-circle-notch:before {\n  content: \"\\f1ce\"; }\n\n.la-city:before {\n  content: \"\\f64f\"; }\n\n.la-clinic-medical:before {\n  content: \"\\f7f2\"; }\n\n.la-clipboard:before {\n  content: \"\\f328\"; }\n\n.la-clipboard-check:before {\n  content: \"\\f46c\"; }\n\n.la-clipboard-list:before {\n  content: \"\\f46d\"; }\n\n.la-clock:before {\n  content: \"\\f017\"; }\n\n.la-clone:before {\n  content: \"\\f24d\"; }\n\n.la-closed-captioning:before {\n  content: \"\\f20a\"; }\n\n.la-cloud:before {\n  content: \"\\f0c2\"; }\n\n.la-cloud-download-alt:before {\n  content: \"\\f381\"; }\n\n.la-cloud-meatball:before {\n  content: \"\\f73b\"; }\n\n.la-cloud-moon:before {\n  content: \"\\f6c3\"; }\n\n.la-cloud-moon-rain:before {\n  content: \"\\f73c\"; }\n\n.la-cloud-rain:before {\n  content: \"\\f73d\"; }\n\n.la-cloud-showers-heavy:before {\n  content: \"\\f740\"; }\n\n.la-cloud-sun:before {\n  content: \"\\f6c4\"; }\n\n.la-cloud-sun-rain:before {\n  content: \"\\f743\"; }\n\n.la-cloud-upload-alt:before {\n  content: \"\\f382\"; }\n\n.la-cloudscale:before {\n  content: \"\\f383\"; }\n\n.la-cloudsmith:before {\n  content: \"\\f384\"; }\n\n.la-cloudversify:before {\n  content: \"\\f385\"; }\n\n.la-cocktail:before {\n  content: \"\\f561\"; }\n\n.la-code:before {\n  content: \"\\f121\"; }\n\n.la-code-branch:before {\n  content: \"\\f126\"; }\n\n.la-codepen:before {\n  content: \"\\f1cb\"; }\n\n.la-codiepie:before {\n  content: \"\\f284\"; }\n\n.la-coffee:before {\n  content: \"\\f0f4\"; }\n\n.la-cog:before {\n  content: \"\\f013\"; }\n\n.la-cogs:before {\n  content: \"\\f085\"; }\n\n.la-coins:before {\n  content: \"\\f51e\"; }\n\n.la-columns:before {\n  content: \"\\f0db\"; }\n\n.la-comment:before {\n  content: \"\\f075\"; }\n\n.la-comment-alt:before {\n  content: \"\\f27a\"; }\n\n.la-comment-dollar:before {\n  content: \"\\f651\"; }\n\n.la-comment-dots:before {\n  content: \"\\f4ad\"; }\n\n.la-comment-medical:before {\n  content: \"\\f7f5\"; }\n\n.la-comment-slash:before {\n  content: \"\\f4b3\"; }\n\n.la-comments:before {\n  content: \"\\f086\"; }\n\n.la-comments-dollar:before {\n  content: \"\\f653\"; }\n\n.la-compact-disc:before {\n  content: \"\\f51f\"; }\n\n.la-compass:before {\n  content: \"\\f14e\"; }\n\n.la-compress:before {\n  content: \"\\f066\"; }\n\n.la-compress-arrows-alt:before {\n  content: \"\\f78c\"; }\n\n.la-concierge-bell:before {\n  content: \"\\f562\"; }\n\n.la-confluence:before {\n  content: \"\\f78d\"; }\n\n.la-connectdevelop:before {\n  content: \"\\f20e\"; }\n\n.la-contao:before {\n  content: \"\\f26d\"; }\n\n.la-cookie:before {\n  content: \"\\f563\"; }\n\n.la-cookie-bite:before {\n  content: \"\\f564\"; }\n\n.la-copy:before {\n  content: \"\\f0c5\"; }\n\n.la-copyright:before {\n  content: \"\\f1f9\"; }\n\n.la-cotton-bureau:before {\n  content: \"\\f89e\"; }\n\n.la-couch:before {\n  content: \"\\f4b8\"; }\n\n.la-cpanel:before {\n  content: \"\\f388\"; }\n\n.la-creative-commons:before {\n  content: \"\\f25e\"; }\n\n.la-creative-commons-by:before {\n  content: \"\\f4e7\"; }\n\n.la-creative-commons-nc:before {\n  content: \"\\f4e8\"; }\n\n.la-creative-commons-nc-eu:before {\n  content: \"\\f4e9\"; }\n\n.la-creative-commons-nc-jp:before {\n  content: \"\\f4ea\"; }\n\n.la-creative-commons-nd:before {\n  content: \"\\f4eb\"; }\n\n.la-creative-commons-pd:before {\n  content: \"\\f4ec\"; }\n\n.la-creative-commons-pd-alt:before {\n  content: \"\\f4ed\"; }\n\n.la-creative-commons-remix:before {\n  content: \"\\f4ee\"; }\n\n.la-creative-commons-sa:before {\n  content: \"\\f4ef\"; }\n\n.la-creative-commons-sampling:before {\n  content: \"\\f4f0\"; }\n\n.la-creative-commons-sampling-plus:before {\n  content: \"\\f4f1\"; }\n\n.la-creative-commons-share:before {\n  content: \"\\f4f2\"; }\n\n.la-creative-commons-zero:before {\n  content: \"\\f4f3\"; }\n\n.la-credit-card:before {\n  content: \"\\f09d\"; }\n\n.la-critical-role:before {\n  content: \"\\f6c9\"; }\n\n.la-crop:before {\n  content: \"\\f125\"; }\n\n.la-crop-alt:before {\n  content: \"\\f565\"; }\n\n.la-cross:before {\n  content: \"\\f654\"; }\n\n.la-crosshairs:before {\n  content: \"\\f05b\"; }\n\n.la-crow:before {\n  content: \"\\f520\"; }\n\n.la-crown:before {\n  content: \"\\f521\"; }\n\n.la-crutch:before {\n  content: \"\\f7f7\"; }\n\n.la-css3:before {\n  content: \"\\f13c\"; }\n\n.la-css3-alt:before {\n  content: \"\\f38b\"; }\n\n.la-cube:before {\n  content: \"\\f1b2\"; }\n\n.la-cubes:before {\n  content: \"\\f1b3\"; }\n\n.la-cut:before {\n  content: \"\\f0c4\"; }\n\n.la-cuttlefish:before {\n  content: \"\\f38c\"; }\n\n.la-d-and-d:before {\n  content: \"\\f38d\"; }\n\n.la-d-and-d-beyond:before {\n  content: \"\\f6ca\"; }\n\n.la-dashcube:before {\n  content: \"\\f210\"; }\n\n.la-database:before {\n  content: \"\\f1c0\"; }\n\n.la-deaf:before {\n  content: \"\\f2a4\"; }\n\n.la-delicious:before {\n  content: \"\\f1a5\"; }\n\n.la-democrat:before {\n  content: \"\\f747\"; }\n\n.la-deploydog:before {\n  content: \"\\f38e\"; }\n\n.la-deskpro:before {\n  content: \"\\f38f\"; }\n\n.la-desktop:before {\n  content: \"\\f108\"; }\n\n.la-dev:before {\n  content: \"\\f6cc\"; }\n\n.la-deviantart:before {\n  content: \"\\f1bd\"; }\n\n.la-dharmachakra:before {\n  content: \"\\f655\"; }\n\n.la-dhl:before {\n  content: \"\\f790\"; }\n\n.la-diagnoses:before {\n  content: \"\\f470\"; }\n\n.la-diaspora:before {\n  content: \"\\f791\"; }\n\n.la-dice:before {\n  content: \"\\f522\"; }\n\n.la-dice-d20:before {\n  content: \"\\f6cf\"; }\n\n.la-dice-d6:before {\n  content: \"\\f6d1\"; }\n\n.la-dice-five:before {\n  content: \"\\f523\"; }\n\n.la-dice-four:before {\n  content: \"\\f524\"; }\n\n.la-dice-one:before {\n  content: \"\\f525\"; }\n\n.la-dice-six:before {\n  content: \"\\f526\"; }\n\n.la-dice-three:before {\n  content: \"\\f527\"; }\n\n.la-dice-two:before {\n  content: \"\\f528\"; }\n\n.la-digg:before {\n  content: \"\\f1a6\"; }\n\n.la-digital-ocean:before {\n  content: \"\\f391\"; }\n\n.la-digital-tachograph:before {\n  content: \"\\f566\"; }\n\n.la-directions:before {\n  content: \"\\f5eb\"; }\n\n.la-discord:before {\n  content: \"\\f392\"; }\n\n.la-discourse:before {\n  content: \"\\f393\"; }\n\n.la-divide:before {\n  content: \"\\f529\"; }\n\n.la-dizzy:before {\n  content: \"\\f567\"; }\n\n.la-dna:before {\n  content: \"\\f471\"; }\n\n.la-dochub:before {\n  content: \"\\f394\"; }\n\n.la-docker:before {\n  content: \"\\f395\"; }\n\n.la-dog:before {\n  content: \"\\f6d3\"; }\n\n.la-dollar-sign:before {\n  content: \"\\f155\"; }\n\n.la-dolly:before {\n  content: \"\\f472\"; }\n\n.la-dolly-flatbed:before {\n  content: \"\\f474\"; }\n\n.la-donate:before {\n  content: \"\\f4b9\"; }\n\n.la-door-closed:before {\n  content: \"\\f52a\"; }\n\n.la-door-open:before {\n  content: \"\\f52b\"; }\n\n.la-dot-circle:before {\n  content: \"\\f192\"; }\n\n.la-dove:before {\n  content: \"\\f4ba\"; }\n\n.la-download:before {\n  content: \"\\f019\"; }\n\n.la-draft2digital:before {\n  content: \"\\f396\"; }\n\n.la-drafting-compass:before {\n  content: \"\\f568\"; }\n\n.la-dragon:before {\n  content: \"\\f6d5\"; }\n\n.la-draw-polygon:before {\n  content: \"\\f5ee\"; }\n\n.la-dribbble:before {\n  content: \"\\f17d\"; }\n\n.la-dribbble-square:before {\n  content: \"\\f397\"; }\n\n.la-dropbox:before {\n  content: \"\\f16b\"; }\n\n.la-drum:before {\n  content: \"\\f569\"; }\n\n.la-drum-steelpan:before {\n  content: \"\\f56a\"; }\n\n.la-drumstick-bite:before {\n  content: \"\\f6d7\"; }\n\n.la-drupal:before {\n  content: \"\\f1a9\"; }\n\n.la-dumbbell:before {\n  content: \"\\f44b\"; }\n\n.la-dumpster:before {\n  content: \"\\f793\"; }\n\n.la-dumpster-fire:before {\n  content: \"\\f794\"; }\n\n.la-dungeon:before {\n  content: \"\\f6d9\"; }\n\n.la-dyalog:before {\n  content: \"\\f399\"; }\n\n.la-earlybirds:before {\n  content: \"\\f39a\"; }\n\n.la-ebay:before {\n  content: \"\\f4f4\"; }\n\n.la-edge:before {\n  content: \"\\f282\"; }\n\n.la-edit:before {\n  content: \"\\f044\"; }\n\n.la-egg:before {\n  content: \"\\f7fb\"; }\n\n.la-eject:before {\n  content: \"\\f052\"; }\n\n.la-elementor:before {\n  content: \"\\f430\"; }\n\n.la-ellipsis-h:before {\n  content: \"\\f141\"; }\n\n.la-ellipsis-v:before {\n  content: \"\\f142\"; }\n\n.la-ello:before {\n  content: \"\\f5f1\"; }\n\n.la-ember:before {\n  content: \"\\f423\"; }\n\n.la-empire:before {\n  content: \"\\f1d1\"; }\n\n.la-envelope:before {\n  content: \"\\f0e0\"; }\n\n.la-envelope-open:before {\n  content: \"\\f2b6\"; }\n\n.la-envelope-open-text:before {\n  content: \"\\f658\"; }\n\n.la-envelope-square:before {\n  content: \"\\f199\"; }\n\n.la-envira:before {\n  content: \"\\f299\"; }\n\n.la-equals:before {\n  content: \"\\f52c\"; }\n\n.la-eraser:before {\n  content: \"\\f12d\"; }\n\n.la-erlang:before {\n  content: \"\\f39d\"; }\n\n.la-ethereum:before {\n  content: \"\\f42e\"; }\n\n.la-ethernet:before {\n  content: \"\\f796\"; }\n\n.la-etsy:before {\n  content: \"\\f2d7\"; }\n\n.la-euro-sign:before {\n  content: \"\\f153\"; }\n\n.la-evernote:before {\n  content: \"\\f839\"; }\n\n.la-exchange-alt:before {\n  content: \"\\f362\"; }\n\n.la-exclamation:before {\n  content: \"\\f12a\"; }\n\n.la-exclamation-circle:before {\n  content: \"\\f06a\"; }\n\n.la-exclamation-triangle:before {\n  content: \"\\f071\"; }\n\n.la-expand:before {\n  content: \"\\f065\"; }\n\n.la-expand-arrows-alt:before {\n  content: \"\\f31e\"; }\n\n.la-expeditedssl:before {\n  content: \"\\f23e\"; }\n\n.la-external-link-alt:before {\n  content: \"\\f35d\"; }\n\n.la-external-link-square-alt:before {\n  content: \"\\f360\"; }\n\n.la-eye:before {\n  content: \"\\f06e\"; }\n\n.la-eye-dropper:before {\n  content: \"\\f1fb\"; }\n\n.la-eye-slash:before {\n  content: \"\\f070\"; }\n\n.la-facebook:before {\n  content: \"\\f09a\"; }\n\n.la-facebook-f:before {\n  content: \"\\f39e\"; }\n\n.la-facebook-messenger:before {\n  content: \"\\f39f\"; }\n\n.la-facebook-square:before {\n  content: \"\\f082\"; }\n\n.la-fan:before {\n  content: \"\\f863\"; }\n\n.la-fantasy-flight-games:before {\n  content: \"\\f6dc\"; }\n\n.la-fast-backward:before {\n  content: \"\\f049\"; }\n\n.la-fast-forward:before {\n  content: \"\\f050\"; }\n\n.la-fax:before {\n  content: \"\\f1ac\"; }\n\n.la-feather:before {\n  content: \"\\f52d\"; }\n\n.la-feather-alt:before {\n  content: \"\\f56b\"; }\n\n.la-fedex:before {\n  content: \"\\f797\"; }\n\n.la-fedora:before {\n  content: \"\\f798\"; }\n\n.la-female:before {\n  content: \"\\f182\"; }\n\n.la-fighter-jet:before {\n  content: \"\\f0fb\"; }\n\n.la-figma:before {\n  content: \"\\f799\"; }\n\n.la-file:before {\n  content: \"\\f15b\"; }\n\n.la-file-alt:before {\n  content: \"\\f15c\"; }\n\n.la-file-archive:before {\n  content: \"\\f1c6\"; }\n\n.la-file-audio:before {\n  content: \"\\f1c7\"; }\n\n.la-file-code:before {\n  content: \"\\f1c9\"; }\n\n.la-file-contract:before {\n  content: \"\\f56c\"; }\n\n.la-file-csv:before {\n  content: \"\\f6dd\"; }\n\n.la-file-download:before {\n  content: \"\\f56d\"; }\n\n.la-file-excel:before {\n  content: \"\\f1c3\"; }\n\n.la-file-export:before {\n  content: \"\\f56e\"; }\n\n.la-file-image:before {\n  content: \"\\f1c5\"; }\n\n.la-file-import:before {\n  content: \"\\f56f\"; }\n\n.la-file-invoice:before {\n  content: \"\\f570\"; }\n\n.la-file-invoice-dollar:before {\n  content: \"\\f571\"; }\n\n.la-file-medical:before {\n  content: \"\\f477\"; }\n\n.la-file-medical-alt:before {\n  content: \"\\f478\"; }\n\n.la-file-pdf:before {\n  content: \"\\f1c1\"; }\n\n.la-file-powerpoint:before {\n  content: \"\\f1c4\"; }\n\n.la-file-prescription:before {\n  content: \"\\f572\"; }\n\n.la-file-signature:before {\n  content: \"\\f573\"; }\n\n.la-file-upload:before {\n  content: \"\\f574\"; }\n\n.la-file-video:before {\n  content: \"\\f1c8\"; }\n\n.la-file-word:before {\n  content: \"\\f1c2\"; }\n\n.la-fill:before {\n  content: \"\\f575\"; }\n\n.la-fill-drip:before {\n  content: \"\\f576\"; }\n\n.la-film:before {\n  content: \"\\f008\"; }\n\n.la-filter:before {\n  content: \"\\f0b0\"; }\n\n.la-fingerprint:before {\n  content: \"\\f577\"; }\n\n.la-fire:before {\n  content: \"\\f06d\"; }\n\n.la-fire-alt:before {\n  content: \"\\f7e4\"; }\n\n.la-fire-extinguisher:before {\n  content: \"\\f134\"; }\n\n.la-firefox:before {\n  content: \"\\f269\"; }\n\n.la-first-aid:before {\n  content: \"\\f479\"; }\n\n.la-first-order:before {\n  content: \"\\f2b0\"; }\n\n.la-first-order-alt:before {\n  content: \"\\f50a\"; }\n\n.la-firstdraft:before {\n  content: \"\\f3a1\"; }\n\n.la-fish:before {\n  content: \"\\f578\"; }\n\n.la-fist-raised:before {\n  content: \"\\f6de\"; }\n\n.la-flag:before {\n  content: \"\\f024\"; }\n\n.la-flag-checkered:before {\n  content: \"\\f11e\"; }\n\n.la-flag-usa:before {\n  content: \"\\f74d\"; }\n\n.la-flask:before {\n  content: \"\\f0c3\"; }\n\n.la-flickr:before {\n  content: \"\\f16e\"; }\n\n.la-flipboard:before {\n  content: \"\\f44d\"; }\n\n.la-flushed:before {\n  content: \"\\f579\"; }\n\n.la-fly:before {\n  content: \"\\f417\"; }\n\n.la-folder:before {\n  content: \"\\f07b\"; }\n\n.la-folder-minus:before {\n  content: \"\\f65d\"; }\n\n.la-folder-open:before {\n  content: \"\\f07c\"; }\n\n.la-folder-plus:before {\n  content: \"\\f65e\"; }\n\n.la-font:before {\n  content: \"\\f031\"; }\n\n.la-font-awesome:before {\n  content: \"\\f2b4\"; }\n\n.la-font-awesome-alt:before {\n  content: \"\\f35c\"; }\n\n.la-font-awesome-flag:before {\n  content: \"\\f425\"; }\n\n.la-font-awesome-logo-full:before {\n  content: \"\\f4e6\"; }\n\n.la-fonticons:before {\n  content: \"\\f280\"; }\n\n.la-fonticons-fi:before {\n  content: \"\\f3a2\"; }\n\n.la-football-ball:before {\n  content: \"\\f44e\"; }\n\n.la-fort-awesome:before {\n  content: \"\\f286\"; }\n\n.la-fort-awesome-alt:before {\n  content: \"\\f3a3\"; }\n\n.la-forumbee:before {\n  content: \"\\f211\"; }\n\n.la-forward:before {\n  content: \"\\f04e\"; }\n\n.la-foursquare:before {\n  content: \"\\f180\"; }\n\n.la-free-code-camp:before {\n  content: \"\\f2c5\"; }\n\n.la-freebsd:before {\n  content: \"\\f3a4\"; }\n\n.la-frog:before {\n  content: \"\\f52e\"; }\n\n.la-frown:before {\n  content: \"\\f119\"; }\n\n.la-frown-open:before {\n  content: \"\\f57a\"; }\n\n.la-fulcrum:before {\n  content: \"\\f50b\"; }\n\n.la-funnel-dollar:before {\n  content: \"\\f662\"; }\n\n.la-futbol:before {\n  content: \"\\f1e3\"; }\n\n.la-galactic-republic:before {\n  content: \"\\f50c\"; }\n\n.la-galactic-senate:before {\n  content: \"\\f50d\"; }\n\n.la-gamepad:before {\n  content: \"\\f11b\"; }\n\n.la-gas-pump:before {\n  content: \"\\f52f\"; }\n\n.la-gavel:before {\n  content: \"\\f0e3\"; }\n\n.la-gem:before {\n  content: \"\\f3a5\"; }\n\n.la-genderless:before {\n  content: \"\\f22d\"; }\n\n.la-get-pocket:before {\n  content: \"\\f265\"; }\n\n.la-gg:before {\n  content: \"\\f260\"; }\n\n.la-gg-circle:before {\n  content: \"\\f261\"; }\n\n.la-ghost:before {\n  content: \"\\f6e2\"; }\n\n.la-gift:before {\n  content: \"\\f06b\"; }\n\n.la-gifts:before {\n  content: \"\\f79c\"; }\n\n.la-git:before {\n  content: \"\\f1d3\"; }\n\n.la-git-alt:before {\n  content: \"\\f841\"; }\n\n.la-git-square:before {\n  content: \"\\f1d2\"; }\n\n.la-github:before {\n  content: \"\\f09b\"; }\n\n.la-github-alt:before {\n  content: \"\\f113\"; }\n\n.la-github-square:before {\n  content: \"\\f092\"; }\n\n.la-gitkraken:before {\n  content: \"\\f3a6\"; }\n\n.la-gitlab:before {\n  content: \"\\f296\"; }\n\n.la-gitter:before {\n  content: \"\\f426\"; }\n\n.la-glass-cheers:before {\n  content: \"\\f79f\"; }\n\n.la-glass-martini:before {\n  content: \"\\f000\"; }\n\n.la-glass-martini-alt:before {\n  content: \"\\f57b\"; }\n\n.la-glass-whiskey:before {\n  content: \"\\f7a0\"; }\n\n.la-glasses:before {\n  content: \"\\f530\"; }\n\n.la-glide:before {\n  content: \"\\f2a5\"; }\n\n.la-glide-g:before {\n  content: \"\\f2a6\"; }\n\n.la-globe:before {\n  content: \"\\f0ac\"; }\n\n.la-globe-africa:before {\n  content: \"\\f57c\"; }\n\n.la-globe-americas:before {\n  content: \"\\f57d\"; }\n\n.la-globe-asia:before {\n  content: \"\\f57e\"; }\n\n.la-globe-europe:before {\n  content: \"\\f7a2\"; }\n\n.la-gofore:before {\n  content: \"\\f3a7\"; }\n\n.la-golf-ball:before {\n  content: \"\\f450\"; }\n\n.la-goodreads:before {\n  content: \"\\f3a8\"; }\n\n.la-goodreads-g:before {\n  content: \"\\f3a9\"; }\n\n.la-google:before {\n  content: \"\\f1a0\"; }\n\n.la-google-drive:before {\n  content: \"\\f3aa\"; }\n\n.la-google-play:before {\n  content: \"\\f3ab\"; }\n\n.la-google-plus:before {\n  content: \"\\f2b3\"; }\n\n.la-google-plus-g:before {\n  content: \"\\f0d5\"; }\n\n.la-google-plus-square:before {\n  content: \"\\f0d4\"; }\n\n.la-google-wallet:before {\n  content: \"\\f1ee\"; }\n\n.la-gopuram:before {\n  content: \"\\f664\"; }\n\n.la-graduation-cap:before {\n  content: \"\\f19d\"; }\n\n.la-gratipay:before {\n  content: \"\\f184\"; }\n\n.la-grav:before {\n  content: \"\\f2d6\"; }\n\n.la-greater-than:before {\n  content: \"\\f531\"; }\n\n.la-greater-than-equal:before {\n  content: \"\\f532\"; }\n\n.la-grimace:before {\n  content: \"\\f57f\"; }\n\n.la-grin:before {\n  content: \"\\f580\"; }\n\n.la-grin-alt:before {\n  content: \"\\f581\"; }\n\n.la-grin-beam:before {\n  content: \"\\f582\"; }\n\n.la-grin-beam-sweat:before {\n  content: \"\\f583\"; }\n\n.la-grin-hearts:before {\n  content: \"\\f584\"; }\n\n.la-grin-squint:before {\n  content: \"\\f585\"; }\n\n.la-grin-squint-tears:before {\n  content: \"\\f586\"; }\n\n.la-grin-stars:before {\n  content: \"\\f587\"; }\n\n.la-grin-tears:before {\n  content: \"\\f588\"; }\n\n.la-grin-tongue:before {\n  content: \"\\f589\"; }\n\n.la-grin-tongue-squint:before {\n  content: \"\\f58a\"; }\n\n.la-grin-tongue-wink:before {\n  content: \"\\f58b\"; }\n\n.la-grin-wink:before {\n  content: \"\\f58c\"; }\n\n.la-grip-horizontal:before {\n  content: \"\\f58d\"; }\n\n.la-grip-lines:before {\n  content: \"\\f7a4\"; }\n\n.la-grip-lines-vertical:before {\n  content: \"\\f7a5\"; }\n\n.la-grip-vertical:before {\n  content: \"\\f58e\"; }\n\n.la-gripfire:before {\n  content: \"\\f3ac\"; }\n\n.la-grunt:before {\n  content: \"\\f3ad\"; }\n\n.la-guitar:before {\n  content: \"\\f7a6\"; }\n\n.la-gulp:before {\n  content: \"\\f3ae\"; }\n\n.la-h-square:before {\n  content: \"\\f0fd\"; }\n\n.la-hacker-news:before {\n  content: \"\\f1d4\"; }\n\n.la-hacker-news-square:before {\n  content: \"\\f3af\"; }\n\n.la-hackerrank:before {\n  content: \"\\f5f7\"; }\n\n.la-hamburger:before {\n  content: \"\\f805\"; }\n\n.la-hammer:before {\n  content: \"\\f6e3\"; }\n\n.la-hamsa:before {\n  content: \"\\f665\"; }\n\n.la-hand-holding:before {\n  content: \"\\f4bd\"; }\n\n.la-hand-holding-heart:before {\n  content: \"\\f4be\"; }\n\n.la-hand-holding-usd:before {\n  content: \"\\f4c0\"; }\n\n.la-hand-lizard:before {\n  content: \"\\f258\"; }\n\n.la-hand-middle-finger:before {\n  content: \"\\f806\"; }\n\n.la-hand-paper:before {\n  content: \"\\f256\"; }\n\n.la-hand-peace:before {\n  content: \"\\f25b\"; }\n\n.la-hand-point-down:before {\n  content: \"\\f0a7\"; }\n\n.la-hand-point-left:before {\n  content: \"\\f0a5\"; }\n\n.la-hand-point-right:before {\n  content: \"\\f0a4\"; }\n\n.la-hand-point-up:before {\n  content: \"\\f0a6\"; }\n\n.la-hand-pointer:before {\n  content: \"\\f25a\"; }\n\n.la-hand-rock:before {\n  content: \"\\f255\"; }\n\n.la-hand-scissors:before {\n  content: \"\\f257\"; }\n\n.la-hand-spock:before {\n  content: \"\\f259\"; }\n\n.la-hands:before {\n  content: \"\\f4c2\"; }\n\n.la-hands-helping:before {\n  content: \"\\f4c4\"; }\n\n.la-handshake:before {\n  content: \"\\f2b5\"; }\n\n.la-hanukiah:before {\n  content: \"\\f6e6\"; }\n\n.la-hard-hat:before {\n  content: \"\\f807\"; }\n\n.la-hashtag:before {\n  content: \"\\f292\"; }\n\n.la-hat-cowboy:before {\n  content: \"\\f8c0\"; }\n\n.la-hat-cowboy-side:before {\n  content: \"\\f8c1\"; }\n\n.la-hat-wizard:before {\n  content: \"\\f6e8\"; }\n\n.la-haykal:before {\n  content: \"\\f666\"; }\n\n.la-hdd:before {\n  content: \"\\f0a0\"; }\n\n.la-heading:before {\n  content: \"\\f1dc\"; }\n\n.la-headphones:before {\n  content: \"\\f025\"; }\n\n.la-headphones-alt:before {\n  content: \"\\f58f\"; }\n\n.la-headset:before {\n  content: \"\\f590\"; }\n\n.la-heart:before {\n  content: \"\\f004\"; }\n\n.la-heart-broken:before {\n  content: \"\\f7a9\"; }\n\n.la-heartbeat:before {\n  content: \"\\f21e\"; }\n\n.la-helicopter:before {\n  content: \"\\f533\"; }\n\n.la-highlighter:before {\n  content: \"\\f591\"; }\n\n.la-hiking:before {\n  content: \"\\f6ec\"; }\n\n.la-hippo:before {\n  content: \"\\f6ed\"; }\n\n.la-hips:before {\n  content: \"\\f452\"; }\n\n.la-hire-a-helper:before {\n  content: \"\\f3b0\"; }\n\n.la-history:before {\n  content: \"\\f1da\"; }\n\n.la-hockey-puck:before {\n  content: \"\\f453\"; }\n\n.la-holly-berry:before {\n  content: \"\\f7aa\"; }\n\n.la-home:before {\n  content: \"\\f015\"; }\n\n.la-hooli:before {\n  content: \"\\f427\"; }\n\n.la-hornbill:before {\n  content: \"\\f592\"; }\n\n.la-horse:before {\n  content: \"\\f6f0\"; }\n\n.la-horse-head:before {\n  content: \"\\f7ab\"; }\n\n.la-hospital:before {\n  content: \"\\f0f8\"; }\n\n.la-hospital-alt:before {\n  content: \"\\f47d\"; }\n\n.la-hospital-symbol:before {\n  content: \"\\f47e\"; }\n\n.la-hot-tub:before {\n  content: \"\\f593\"; }\n\n.la-hotdog:before {\n  content: \"\\f80f\"; }\n\n.la-hotel:before {\n  content: \"\\f594\"; }\n\n.la-hotjar:before {\n  content: \"\\f3b1\"; }\n\n.la-hourglass:before {\n  content: \"\\f254\"; }\n\n.la-hourglass-end:before {\n  content: \"\\f253\"; }\n\n.la-hourglass-half:before {\n  content: \"\\f252\"; }\n\n.la-hourglass-start:before {\n  content: \"\\f251\"; }\n\n.la-house-damage:before {\n  content: \"\\f6f1\"; }\n\n.la-houzz:before {\n  content: \"\\f27c\"; }\n\n.la-hryvnia:before {\n  content: \"\\f6f2\"; }\n\n.la-html5:before {\n  content: \"\\f13b\"; }\n\n.la-hubspot:before {\n  content: \"\\f3b2\"; }\n\n.la-i-cursor:before {\n  content: \"\\f246\"; }\n\n.la-ice-cream:before {\n  content: \"\\f810\"; }\n\n.la-icicles:before {\n  content: \"\\f7ad\"; }\n\n.la-icons:before {\n  content: \"\\f86d\"; }\n\n.la-id-badge:before {\n  content: \"\\f2c1\"; }\n\n.la-id-card:before {\n  content: \"\\f2c2\"; }\n\n.la-id-card-alt:before {\n  content: \"\\f47f\"; }\n\n.la-igloo:before {\n  content: \"\\f7ae\"; }\n\n.la-image:before {\n  content: \"\\f03e\"; }\n\n.la-images:before {\n  content: \"\\f302\"; }\n\n.la-imdb:before {\n  content: \"\\f2d8\"; }\n\n.la-inbox:before {\n  content: \"\\f01c\"; }\n\n.la-indent:before {\n  content: \"\\f03c\"; }\n\n.la-industry:before {\n  content: \"\\f275\"; }\n\n.la-infinity:before {\n  content: \"\\f534\"; }\n\n.la-info:before {\n  content: \"\\f129\"; }\n\n.la-info-circle:before {\n  content: \"\\f05a\"; }\n\n.la-instagram:before {\n  content: \"\\f16d\"; }\n\n.la-intercom:before {\n  content: \"\\f7af\"; }\n\n.la-internet-explorer:before {\n  content: \"\\f26b\"; }\n\n.la-invision:before {\n  content: \"\\f7b0\"; }\n\n.la-ioxhost:before {\n  content: \"\\f208\"; }\n\n.la-italic:before {\n  content: \"\\f033\"; }\n\n.la-itch-io:before {\n  content: \"\\f83a\"; }\n\n.la-itunes:before {\n  content: \"\\f3b4\"; }\n\n.la-itunes-note:before {\n  content: \"\\f3b5\"; }\n\n.la-java:before {\n  content: \"\\f4e4\"; }\n\n.la-jedi:before {\n  content: \"\\f669\"; }\n\n.la-jedi-order:before {\n  content: \"\\f50e\"; }\n\n.la-jenkins:before {\n  content: \"\\f3b6\"; }\n\n.la-jira:before {\n  content: \"\\f7b1\"; }\n\n.la-joget:before {\n  content: \"\\f3b7\"; }\n\n.la-joint:before {\n  content: \"\\f595\"; }\n\n.la-joomla:before {\n  content: \"\\f1aa\"; }\n\n.la-journal-whills:before {\n  content: \"\\f66a\"; }\n\n.la-js:before {\n  content: \"\\f3b8\"; }\n\n.la-js-square:before {\n  content: \"\\f3b9\"; }\n\n.la-jsfiddle:before {\n  content: \"\\f1cc\"; }\n\n.la-kaaba:before {\n  content: \"\\f66b\"; }\n\n.la-kaggle:before {\n  content: \"\\f5fa\"; }\n\n.la-key:before {\n  content: \"\\f084\"; }\n\n.la-keybase:before {\n  content: \"\\f4f5\"; }\n\n.la-keyboard:before {\n  content: \"\\f11c\"; }\n\n.la-keycdn:before {\n  content: \"\\f3ba\"; }\n\n.la-khanda:before {\n  content: \"\\f66d\"; }\n\n.la-kickstarter:before {\n  content: \"\\f3bb\"; }\n\n.la-kickstarter-k:before {\n  content: \"\\f3bc\"; }\n\n.la-kiss:before {\n  content: \"\\f596\"; }\n\n.la-kiss-beam:before {\n  content: \"\\f597\"; }\n\n.la-kiss-wink-heart:before {\n  content: \"\\f598\"; }\n\n.la-kiwi-bird:before {\n  content: \"\\f535\"; }\n\n.la-korvue:before {\n  content: \"\\f42f\"; }\n\n.la-landmark:before {\n  content: \"\\f66f\"; }\n\n.la-language:before {\n  content: \"\\f1ab\"; }\n\n.la-laptop:before {\n  content: \"\\f109\"; }\n\n.la-laptop-code:before {\n  content: \"\\f5fc\"; }\n\n.la-laptop-medical:before {\n  content: \"\\f812\"; }\n\n.la-laravel:before {\n  content: \"\\f3bd\"; }\n\n.la-lastfm:before {\n  content: \"\\f202\"; }\n\n.la-lastfm-square:before {\n  content: \"\\f203\"; }\n\n.la-laugh:before {\n  content: \"\\f599\"; }\n\n.la-laugh-beam:before {\n  content: \"\\f59a\"; }\n\n.la-laugh-squint:before {\n  content: \"\\f59b\"; }\n\n.la-laugh-wink:before {\n  content: \"\\f59c\"; }\n\n.la-layer-group:before {\n  content: \"\\f5fd\"; }\n\n.la-leaf:before {\n  content: \"\\f06c\"; }\n\n.la-leanpub:before {\n  content: \"\\f212\"; }\n\n.la-lemon:before {\n  content: \"\\f094\"; }\n\n.la-less:before {\n  content: \"\\f41d\"; }\n\n.la-less-than:before {\n  content: \"\\f536\"; }\n\n.la-less-than-equal:before {\n  content: \"\\f537\"; }\n\n.la-level-down-alt:before {\n  content: \"\\f3be\"; }\n\n.la-level-up-alt:before {\n  content: \"\\f3bf\"; }\n\n.la-life-ring:before {\n  content: \"\\f1cd\"; }\n\n.la-lightbulb:before {\n  content: \"\\f0eb\"; }\n\n.la-line:before {\n  content: \"\\f3c0\"; }\n\n.la-link:before {\n  content: \"\\f0c1\"; }\n\n.la-linkedin:before {\n  content: \"\\f08c\"; }\n\n.la-linkedin-in:before {\n  content: \"\\f0e1\"; }\n\n.la-linode:before {\n  content: \"\\f2b8\"; }\n\n.la-linux:before {\n  content: \"\\f17c\"; }\n\n.la-lira-sign:before {\n  content: \"\\f195\"; }\n\n.la-list:before {\n  content: \"\\f03a\"; }\n\n.la-list-alt:before {\n  content: \"\\f022\"; }\n\n.la-list-ol:before {\n  content: \"\\f0cb\"; }\n\n.la-list-ul:before {\n  content: \"\\f0ca\"; }\n\n.la-location-arrow:before {\n  content: \"\\f124\"; }\n\n.la-lock:before {\n  content: \"\\f023\"; }\n\n.la-lock-open:before {\n  content: \"\\f3c1\"; }\n\n.la-long-arrow-alt-down:before {\n  content: \"\\f309\"; }\n\n.la-long-arrow-alt-left:before {\n  content: \"\\f30a\"; }\n\n.la-long-arrow-alt-right:before {\n  content: \"\\f30b\"; }\n\n.la-long-arrow-alt-up:before {\n  content: \"\\f30c\"; }\n\n.la-low-vision:before {\n  content: \"\\f2a8\"; }\n\n.la-luggage-cart:before {\n  content: \"\\f59d\"; }\n\n.la-lyft:before {\n  content: \"\\f3c3\"; }\n\n.la-magento:before {\n  content: \"\\f3c4\"; }\n\n.la-magic:before {\n  content: \"\\f0d0\"; }\n\n.la-magnet:before {\n  content: \"\\f076\"; }\n\n.la-mail-bulk:before {\n  content: \"\\f674\"; }\n\n.la-mailchimp:before {\n  content: \"\\f59e\"; }\n\n.la-male:before {\n  content: \"\\f183\"; }\n\n.la-mandalorian:before {\n  content: \"\\f50f\"; }\n\n.la-map:before {\n  content: \"\\f279\"; }\n\n.la-map-marked:before {\n  content: \"\\f59f\"; }\n\n.la-map-marked-alt:before {\n  content: \"\\f5a0\"; }\n\n.la-map-marker:before {\n  content: \"\\f041\"; }\n\n.la-map-marker-alt:before {\n  content: \"\\f3c5\"; }\n\n.la-map-pin:before {\n  content: \"\\f276\"; }\n\n.la-map-signs:before {\n  content: \"\\f277\"; }\n\n.la-markdown:before {\n  content: \"\\f60f\"; }\n\n.la-marker:before {\n  content: \"\\f5a1\"; }\n\n.la-mars:before {\n  content: \"\\f222\"; }\n\n.la-mars-double:before {\n  content: \"\\f227\"; }\n\n.la-mars-stroke:before {\n  content: \"\\f229\"; }\n\n.la-mars-stroke-h:before {\n  content: \"\\f22b\"; }\n\n.la-mars-stroke-v:before {\n  content: \"\\f22a\"; }\n\n.la-mask:before {\n  content: \"\\f6fa\"; }\n\n.la-mastodon:before {\n  content: \"\\f4f6\"; }\n\n.la-maxcdn:before {\n  content: \"\\f136\"; }\n\n.la-mdb:before {\n  content: \"\\f8ca\"; }\n\n.la-medal:before {\n  content: \"\\f5a2\"; }\n\n.la-medapps:before {\n  content: \"\\f3c6\"; }\n\n.la-medium:before {\n  content: \"\\f23a\"; }\n\n.la-medium-m:before {\n  content: \"\\f3c7\"; }\n\n.la-medkit:before {\n  content: \"\\f0fa\"; }\n\n.la-medrt:before {\n  content: \"\\f3c8\"; }\n\n.la-meetup:before {\n  content: \"\\f2e0\"; }\n\n.la-megaport:before {\n  content: \"\\f5a3\"; }\n\n.la-meh:before {\n  content: \"\\f11a\"; }\n\n.la-meh-blank:before {\n  content: \"\\f5a4\"; }\n\n.la-meh-rolling-eyes:before {\n  content: \"\\f5a5\"; }\n\n.la-memory:before {\n  content: \"\\f538\"; }\n\n.la-mendeley:before {\n  content: \"\\f7b3\"; }\n\n.la-menorah:before {\n  content: \"\\f676\"; }\n\n.la-mercury:before {\n  content: \"\\f223\"; }\n\n.la-meteor:before {\n  content: \"\\f753\"; }\n\n.la-microchip:before {\n  content: \"\\f2db\"; }\n\n.la-microphone:before {\n  content: \"\\f130\"; }\n\n.la-microphone-alt:before {\n  content: \"\\f3c9\"; }\n\n.la-microphone-alt-slash:before {\n  content: \"\\f539\"; }\n\n.la-microphone-slash:before {\n  content: \"\\f131\"; }\n\n.la-microscope:before {\n  content: \"\\f610\"; }\n\n.la-microsoft:before {\n  content: \"\\f3ca\"; }\n\n.la-minus:before {\n  content: \"\\f068\"; }\n\n.la-minus-circle:before {\n  content: \"\\f056\"; }\n\n.la-minus-square:before {\n  content: \"\\f146\"; }\n\n.la-mitten:before {\n  content: \"\\f7b5\"; }\n\n.la-mix:before {\n  content: \"\\f3cb\"; }\n\n.la-mixcloud:before {\n  content: \"\\f289\"; }\n\n.la-mizuni:before {\n  content: \"\\f3cc\"; }\n\n.la-mobile:before {\n  content: \"\\f10b\"; }\n\n.la-mobile-alt:before {\n  content: \"\\f3cd\"; }\n\n.la-modx:before {\n  content: \"\\f285\"; }\n\n.la-monero:before {\n  content: \"\\f3d0\"; }\n\n.la-money-bill:before {\n  content: \"\\f0d6\"; }\n\n.la-money-bill-alt:before {\n  content: \"\\f3d1\"; }\n\n.la-money-bill-wave:before {\n  content: \"\\f53a\"; }\n\n.la-money-bill-wave-alt:before {\n  content: \"\\f53b\"; }\n\n.la-money-check:before {\n  content: \"\\f53c\"; }\n\n.la-money-check-alt:before {\n  content: \"\\f53d\"; }\n\n.la-monument:before {\n  content: \"\\f5a6\"; }\n\n.la-moon:before {\n  content: \"\\f186\"; }\n\n.la-mortar-pestle:before {\n  content: \"\\f5a7\"; }\n\n.la-mosque:before {\n  content: \"\\f678\"; }\n\n.la-motorcycle:before {\n  content: \"\\f21c\"; }\n\n.la-mountain:before {\n  content: \"\\f6fc\"; }\n\n.la-mouse:before {\n  content: \"\\f8cc\"; }\n\n.la-mouse-pointer:before {\n  content: \"\\f245\"; }\n\n.la-mug-hot:before {\n  content: \"\\f7b6\"; }\n\n.la-music:before {\n  content: \"\\f001\"; }\n\n.la-napster:before {\n  content: \"\\f3d2\"; }\n\n.la-neos:before {\n  content: \"\\f612\"; }\n\n.la-network-wired:before {\n  content: \"\\f6ff\"; }\n\n.la-neuter:before {\n  content: \"\\f22c\"; }\n\n.la-newspaper:before {\n  content: \"\\f1ea\"; }\n\n.la-nimblr:before {\n  content: \"\\f5a8\"; }\n\n.la-node:before {\n  content: \"\\f419\"; }\n\n.la-node-js:before {\n  content: \"\\f3d3\"; }\n\n.la-not-equal:before {\n  content: \"\\f53e\"; }\n\n.la-notes-medical:before {\n  content: \"\\f481\"; }\n\n.la-npm:before {\n  content: \"\\f3d4\"; }\n\n.la-ns8:before {\n  content: \"\\f3d5\"; }\n\n.la-nutritionix:before {\n  content: \"\\f3d6\"; }\n\n.la-object-group:before {\n  content: \"\\f247\"; }\n\n.la-object-ungroup:before {\n  content: \"\\f248\"; }\n\n.la-odnoklassniki:before {\n  content: \"\\f263\"; }\n\n.la-odnoklassniki-square:before {\n  content: \"\\f264\"; }\n\n.la-oil-can:before {\n  content: \"\\f613\"; }\n\n.la-old-republic:before {\n  content: \"\\f510\"; }\n\n.la-om:before {\n  content: \"\\f679\"; }\n\n.la-opencart:before {\n  content: \"\\f23d\"; }\n\n.la-openid:before {\n  content: \"\\f19b\"; }\n\n.la-opera:before {\n  content: \"\\f26a\"; }\n\n.la-optin-monster:before {\n  content: \"\\f23c\"; }\n\n.la-orcid:before {\n  content: \"\\f8d2\"; }\n\n.la-osi:before {\n  content: \"\\f41a\"; }\n\n.la-otter:before {\n  content: \"\\f700\"; }\n\n.la-outdent:before {\n  content: \"\\f03b\"; }\n\n.la-page4:before {\n  content: \"\\f3d7\"; }\n\n.la-pagelines:before {\n  content: \"\\f18c\"; }\n\n.la-pager:before {\n  content: \"\\f815\"; }\n\n.la-paint-brush:before {\n  content: \"\\f1fc\"; }\n\n.la-paint-roller:before {\n  content: \"\\f5aa\"; }\n\n.la-palette:before {\n  content: \"\\f53f\"; }\n\n.la-palfed:before {\n  content: \"\\f3d8\"; }\n\n.la-pallet:before {\n  content: \"\\f482\"; }\n\n.la-paper-plane:before {\n  content: \"\\f1d8\"; }\n\n.la-paperclip:before {\n  content: \"\\f0c6\"; }\n\n.la-parachute-box:before {\n  content: \"\\f4cd\"; }\n\n.la-paragraph:before {\n  content: \"\\f1dd\"; }\n\n.la-parking:before {\n  content: \"\\f540\"; }\n\n.la-passport:before {\n  content: \"\\f5ab\"; }\n\n.la-pastafarianism:before {\n  content: \"\\f67b\"; }\n\n.la-paste:before {\n  content: \"\\f0ea\"; }\n\n.la-patreon:before {\n  content: \"\\f3d9\"; }\n\n.la-pause:before {\n  content: \"\\f04c\"; }\n\n.la-pause-circle:before {\n  content: \"\\f28b\"; }\n\n.la-paw:before {\n  content: \"\\f1b0\"; }\n\n.la-paypal:before {\n  content: \"\\f1ed\"; }\n\n.la-peace:before {\n  content: \"\\f67c\"; }\n\n.la-pen:before {\n  content: \"\\f304\"; }\n\n.la-pen-alt:before {\n  content: \"\\f305\"; }\n\n.la-pen-fancy:before {\n  content: \"\\f5ac\"; }\n\n.la-pen-nib:before {\n  content: \"\\f5ad\"; }\n\n.la-pen-square:before {\n  content: \"\\f14b\"; }\n\n.la-pencil-alt:before {\n  content: \"\\f303\"; }\n\n.la-pencil-ruler:before {\n  content: \"\\f5ae\"; }\n\n.la-penny-arcade:before {\n  content: \"\\f704\"; }\n\n.la-people-carry:before {\n  content: \"\\f4ce\"; }\n\n.la-pepper-hot:before {\n  content: \"\\f816\"; }\n\n.la-percent:before {\n  content: \"\\f295\"; }\n\n.la-percentage:before {\n  content: \"\\f541\"; }\n\n.la-periscope:before {\n  content: \"\\f3da\"; }\n\n.la-person-booth:before {\n  content: \"\\f756\"; }\n\n.la-phabricator:before {\n  content: \"\\f3db\"; }\n\n.la-phoenix-framework:before {\n  content: \"\\f3dc\"; }\n\n.la-phoenix-squadron:before {\n  content: \"\\f511\"; }\n\n.la-phone:before {\n  content: \"\\f095\"; }\n\n.la-phone-alt:before {\n  content: \"\\f879\"; }\n\n.la-phone-slash:before {\n  content: \"\\f3dd\"; }\n\n.la-phone-square:before {\n  content: \"\\f098\"; }\n\n.la-phone-square-alt:before {\n  content: \"\\f87b\"; }\n\n.la-phone-volume:before {\n  content: \"\\f2a0\"; }\n\n.la-photo-video:before {\n  content: \"\\f87c\"; }\n\n.la-php:before {\n  content: \"\\f457\"; }\n\n.la-pied-piper:before {\n  content: \"\\f2ae\"; }\n\n.la-pied-piper-alt:before {\n  content: \"\\f1a8\"; }\n\n.la-pied-piper-hat:before {\n  content: \"\\f4e5\"; }\n\n.la-pied-piper-pp:before {\n  content: \"\\f1a7\"; }\n\n.la-piggy-bank:before {\n  content: \"\\f4d3\"; }\n\n.la-pills:before {\n  content: \"\\f484\"; }\n\n.la-pinterest:before {\n  content: \"\\f0d2\"; }\n\n.la-pinterest-p:before {\n  content: \"\\f231\"; }\n\n.la-pinterest-square:before {\n  content: \"\\f0d3\"; }\n\n.la-pizza-slice:before {\n  content: \"\\f818\"; }\n\n.la-place-of-worship:before {\n  content: \"\\f67f\"; }\n\n.la-plane:before {\n  content: \"\\f072\"; }\n\n.la-plane-arrival:before {\n  content: \"\\f5af\"; }\n\n.la-plane-departure:before {\n  content: \"\\f5b0\"; }\n\n.la-play:before {\n  content: \"\\f04b\"; }\n\n.la-play-circle:before {\n  content: \"\\f144\"; }\n\n.la-playstation:before {\n  content: \"\\f3df\"; }\n\n.la-plug:before {\n  content: \"\\f1e6\"; }\n\n.la-plus:before {\n  content: \"\\f067\"; }\n\n.la-plus-circle:before {\n  content: \"\\f055\"; }\n\n.la-plus-square:before {\n  content: \"\\f0fe\"; }\n\n.la-podcast:before {\n  content: \"\\f2ce\"; }\n\n.la-poll:before {\n  content: \"\\f681\"; }\n\n.la-poll-h:before {\n  content: \"\\f682\"; }\n\n.la-poo:before {\n  content: \"\\f2fe\"; }\n\n.la-poo-storm:before {\n  content: \"\\f75a\"; }\n\n.la-poop:before {\n  content: \"\\f619\"; }\n\n.la-portrait:before {\n  content: \"\\f3e0\"; }\n\n.la-pound-sign:before {\n  content: \"\\f154\"; }\n\n.la-power-off:before {\n  content: \"\\f011\"; }\n\n.la-pray:before {\n  content: \"\\f683\"; }\n\n.la-praying-hands:before {\n  content: \"\\f684\"; }\n\n.la-prescription:before {\n  content: \"\\f5b1\"; }\n\n.la-prescription-bottle:before {\n  content: \"\\f485\"; }\n\n.la-prescription-bottle-alt:before {\n  content: \"\\f486\"; }\n\n.la-print:before {\n  content: \"\\f02f\"; }\n\n.la-procedures:before {\n  content: \"\\f487\"; }\n\n.la-product-hunt:before {\n  content: \"\\f288\"; }\n\n.la-project-diagram:before {\n  content: \"\\f542\"; }\n\n.la-pushed:before {\n  content: \"\\f3e1\"; }\n\n.la-puzzle-piece:before {\n  content: \"\\f12e\"; }\n\n.la-python:before {\n  content: \"\\f3e2\"; }\n\n.la-qq:before {\n  content: \"\\f1d6\"; }\n\n.la-qrcode:before {\n  content: \"\\f029\"; }\n\n.la-question:before {\n  content: \"\\f128\"; }\n\n.la-question-circle:before {\n  content: \"\\f059\"; }\n\n.la-quidditch:before {\n  content: \"\\f458\"; }\n\n.la-quinscape:before {\n  content: \"\\f459\"; }\n\n.la-quora:before {\n  content: \"\\f2c4\"; }\n\n.la-quote-left:before {\n  content: \"\\f10d\"; }\n\n.la-quote-right:before {\n  content: \"\\f10e\"; }\n\n.la-quran:before {\n  content: \"\\f687\"; }\n\n.la-r-project:before {\n  content: \"\\f4f7\"; }\n\n.la-radiation:before {\n  content: \"\\f7b9\"; }\n\n.la-radiation-alt:before {\n  content: \"\\f7ba\"; }\n\n.la-rainbow:before {\n  content: \"\\f75b\"; }\n\n.la-random:before {\n  content: \"\\f074\"; }\n\n.la-raspberry-pi:before {\n  content: \"\\f7bb\"; }\n\n.la-ravelry:before {\n  content: \"\\f2d9\"; }\n\n.la-react:before {\n  content: \"\\f41b\"; }\n\n.la-reacteurope:before {\n  content: \"\\f75d\"; }\n\n.la-readme:before {\n  content: \"\\f4d5\"; }\n\n.la-rebel:before {\n  content: \"\\f1d0\"; }\n\n.la-receipt:before {\n  content: \"\\f543\"; }\n\n.la-record-vinyl:before {\n  content: \"\\f8d9\"; }\n\n.la-recycle:before {\n  content: \"\\f1b8\"; }\n\n.la-red-river:before {\n  content: \"\\f3e3\"; }\n\n.la-reddit:before {\n  content: \"\\f1a1\"; }\n\n.la-reddit-alien:before {\n  content: \"\\f281\"; }\n\n.la-reddit-square:before {\n  content: \"\\f1a2\"; }\n\n.la-redhat:before {\n  content: \"\\f7bc\"; }\n\n.la-redo:before {\n  content: \"\\f01e\"; }\n\n.la-redo-alt:before {\n  content: \"\\f2f9\"; }\n\n.la-registered:before {\n  content: \"\\f25d\"; }\n\n.la-remove-format:before {\n  content: \"\\f87d\"; }\n\n.la-renren:before {\n  content: \"\\f18b\"; }\n\n.la-reply:before {\n  content: \"\\f3e5\"; }\n\n.la-reply-all:before {\n  content: \"\\f122\"; }\n\n.la-replyd:before {\n  content: \"\\f3e6\"; }\n\n.la-republican:before {\n  content: \"\\f75e\"; }\n\n.la-researchgate:before {\n  content: \"\\f4f8\"; }\n\n.la-resolving:before {\n  content: \"\\f3e7\"; }\n\n.la-restroom:before {\n  content: \"\\f7bd\"; }\n\n.la-retweet:before {\n  content: \"\\f079\"; }\n\n.la-rev:before {\n  content: \"\\f5b2\"; }\n\n.la-ribbon:before {\n  content: \"\\f4d6\"; }\n\n.la-ring:before {\n  content: \"\\f70b\"; }\n\n.la-road:before {\n  content: \"\\f018\"; }\n\n.la-robot:before {\n  content: \"\\f544\"; }\n\n.la-rocket:before {\n  content: \"\\f135\"; }\n\n.la-rocketchat:before {\n  content: \"\\f3e8\"; }\n\n.la-rockrms:before {\n  content: \"\\f3e9\"; }\n\n.la-route:before {\n  content: \"\\f4d7\"; }\n\n.la-rss:before {\n  content: \"\\f09e\"; }\n\n.la-rss-square:before {\n  content: \"\\f143\"; }\n\n.la-ruble-sign:before {\n  content: \"\\f158\"; }\n\n.la-ruler:before {\n  content: \"\\f545\"; }\n\n.la-ruler-combined:before {\n  content: \"\\f546\"; }\n\n.la-ruler-horizontal:before {\n  content: \"\\f547\"; }\n\n.la-ruler-vertical:before {\n  content: \"\\f548\"; }\n\n.la-running:before {\n  content: \"\\f70c\"; }\n\n.la-rupee-sign:before {\n  content: \"\\f156\"; }\n\n.la-sad-cry:before {\n  content: \"\\f5b3\"; }\n\n.la-sad-tear:before {\n  content: \"\\f5b4\"; }\n\n.la-safari:before {\n  content: \"\\f267\"; }\n\n.la-salesforce:before {\n  content: \"\\f83b\"; }\n\n.la-sass:before {\n  content: \"\\f41e\"; }\n\n.la-satellite:before {\n  content: \"\\f7bf\"; }\n\n.la-satellite-dish:before {\n  content: \"\\f7c0\"; }\n\n.la-save:before {\n  content: \"\\f0c7\"; }\n\n.la-schlix:before {\n  content: \"\\f3ea\"; }\n\n.la-school:before {\n  content: \"\\f549\"; }\n\n.la-screwdriver:before {\n  content: \"\\f54a\"; }\n\n.la-scribd:before {\n  content: \"\\f28a\"; }\n\n.la-scroll:before {\n  content: \"\\f70e\"; }\n\n.la-sd-card:before {\n  content: \"\\f7c2\"; }\n\n.la-search:before {\n  content: \"\\f002\"; }\n\n.la-search-dollar:before {\n  content: \"\\f688\"; }\n\n.la-search-location:before {\n  content: \"\\f689\"; }\n\n.la-search-minus:before {\n  content: \"\\f010\"; }\n\n.la-search-plus:before {\n  content: \"\\f00e\"; }\n\n.la-searchengin:before {\n  content: \"\\f3eb\"; }\n\n.la-seedling:before {\n  content: \"\\f4d8\"; }\n\n.la-sellcast:before {\n  content: \"\\f2da\"; }\n\n.la-sellsy:before {\n  content: \"\\f213\"; }\n\n.la-server:before {\n  content: \"\\f233\"; }\n\n.la-servicestack:before {\n  content: \"\\f3ec\"; }\n\n.la-shapes:before {\n  content: \"\\f61f\"; }\n\n.la-share:before {\n  content: \"\\f064\"; }\n\n.la-share-alt:before {\n  content: \"\\f1e0\"; }\n\n.la-share-alt-square:before {\n  content: \"\\f1e1\"; }\n\n.la-share-square:before {\n  content: \"\\f14d\"; }\n\n.la-shekel-sign:before {\n  content: \"\\f20b\"; }\n\n.la-shield-alt:before {\n  content: \"\\f3ed\"; }\n\n.la-ship:before {\n  content: \"\\f21a\"; }\n\n.la-shipping-fast:before {\n  content: \"\\f48b\"; }\n\n.la-shirtsinbulk:before {\n  content: \"\\f214\"; }\n\n.la-shoe-prints:before {\n  content: \"\\f54b\"; }\n\n.la-shopping-bag:before {\n  content: \"\\f290\"; }\n\n.la-shopping-basket:before {\n  content: \"\\f291\"; }\n\n.la-shopping-cart:before {\n  content: \"\\f07a\"; }\n\n.la-shopware:before {\n  content: \"\\f5b5\"; }\n\n.la-shower:before {\n  content: \"\\f2cc\"; }\n\n.la-shuttle-van:before {\n  content: \"\\f5b6\"; }\n\n.la-sign:before {\n  content: \"\\f4d9\"; }\n\n.la-sign-in-alt:before {\n  content: \"\\f2f6\"; }\n\n.la-sign-language:before {\n  content: \"\\f2a7\"; }\n\n.la-sign-out-alt:before {\n  content: \"\\f2f5\"; }\n\n.la-signal:before {\n  content: \"\\f012\"; }\n\n.la-signature:before {\n  content: \"\\f5b7\"; }\n\n.la-sim-card:before {\n  content: \"\\f7c4\"; }\n\n.la-simplybuilt:before {\n  content: \"\\f215\"; }\n\n.la-sistrix:before {\n  content: \"\\f3ee\"; }\n\n.la-sitemap:before {\n  content: \"\\f0e8\"; }\n\n.la-sith:before {\n  content: \"\\f512\"; }\n\n.la-skating:before {\n  content: \"\\f7c5\"; }\n\n.la-sketch:before {\n  content: \"\\f7c6\"; }\n\n.la-skiing:before {\n  content: \"\\f7c9\"; }\n\n.la-skiing-nordic:before {\n  content: \"\\f7ca\"; }\n\n.la-skull:before {\n  content: \"\\f54c\"; }\n\n.la-skull-crossbones:before {\n  content: \"\\f714\"; }\n\n.la-skyatlas:before {\n  content: \"\\f216\"; }\n\n.la-skype:before {\n  content: \"\\f17e\"; }\n\n.la-slack:before {\n  content: \"\\f198\"; }\n\n.la-slack-hash:before {\n  content: \"\\f3ef\"; }\n\n.la-slash:before {\n  content: \"\\f715\"; }\n\n.la-sleigh:before {\n  content: \"\\f7cc\"; }\n\n.la-sliders-h:before {\n  content: \"\\f1de\"; }\n\n.la-slideshare:before {\n  content: \"\\f1e7\"; }\n\n.la-smile:before {\n  content: \"\\f118\"; }\n\n.la-smile-beam:before {\n  content: \"\\f5b8\"; }\n\n.la-smile-wink:before {\n  content: \"\\f4da\"; }\n\n.la-smog:before {\n  content: \"\\f75f\"; }\n\n.la-smoking:before {\n  content: \"\\f48d\"; }\n\n.la-smoking-ban:before {\n  content: \"\\f54d\"; }\n\n.la-sms:before {\n  content: \"\\f7cd\"; }\n\n.la-snapchat:before {\n  content: \"\\f2ab\"; }\n\n.la-snapchat-ghost:before {\n  content: \"\\f2ac\"; }\n\n.la-snapchat-square:before {\n  content: \"\\f2ad\"; }\n\n.la-snowboarding:before {\n  content: \"\\f7ce\"; }\n\n.la-snowflake:before {\n  content: \"\\f2dc\"; }\n\n.la-snowman:before {\n  content: \"\\f7d0\"; }\n\n.la-snowplow:before {\n  content: \"\\f7d2\"; }\n\n.la-socks:before {\n  content: \"\\f696\"; }\n\n.la-solar-panel:before {\n  content: \"\\f5ba\"; }\n\n.la-sort:before {\n  content: \"\\f0dc\"; }\n\n.la-sort-alpha-down:before {\n  content: \"\\f15d\"; }\n\n.la-sort-alpha-down-alt:before {\n  content: \"\\f881\"; }\n\n.la-sort-alpha-up:before {\n  content: \"\\f15e\"; }\n\n.la-sort-alpha-up-alt:before {\n  content: \"\\f882\"; }\n\n.la-sort-amount-down:before {\n  content: \"\\f160\"; }\n\n.la-sort-amount-down-alt:before {\n  content: \"\\f884\"; }\n\n.la-sort-amount-up:before {\n  content: \"\\f161\"; }\n\n.la-sort-amount-up-alt:before {\n  content: \"\\f885\"; }\n\n.la-sort-down:before {\n  content: \"\\f0dd\"; }\n\n.la-sort-numeric-down:before {\n  content: \"\\f162\"; }\n\n.la-sort-numeric-down-alt:before {\n  content: \"\\f886\"; }\n\n.la-sort-numeric-up:before {\n  content: \"\\f163\"; }\n\n.la-sort-numeric-up-alt:before {\n  content: \"\\f887\"; }\n\n.la-sort-up:before {\n  content: \"\\f0de\"; }\n\n.la-soundcloud:before {\n  content: \"\\f1be\"; }\n\n.la-sourcetree:before {\n  content: \"\\f7d3\"; }\n\n.la-spa:before {\n  content: \"\\f5bb\"; }\n\n.la-space-shuttle:before {\n  content: \"\\f197\"; }\n\n.la-speakap:before {\n  content: \"\\f3f3\"; }\n\n.la-speaker-deck:before {\n  content: \"\\f83c\"; }\n\n.la-spell-check:before {\n  content: \"\\f891\"; }\n\n.la-spider:before {\n  content: \"\\f717\"; }\n\n.la-spinner:before {\n  content: \"\\f110\"; }\n\n.la-splotch:before {\n  content: \"\\f5bc\"; }\n\n.la-spotify:before {\n  content: \"\\f1bc\"; }\n\n.la-spray-can:before {\n  content: \"\\f5bd\"; }\n\n.la-square:before {\n  content: \"\\f0c8\"; }\n\n.la-square-full:before {\n  content: \"\\f45c\"; }\n\n.la-square-root-alt:before {\n  content: \"\\f698\"; }\n\n.la-squarespace:before {\n  content: \"\\f5be\"; }\n\n.la-stack-exchange:before {\n  content: \"\\f18d\"; }\n\n.la-stack-overflow:before {\n  content: \"\\f16c\"; }\n\n.la-stackpath:before {\n  content: \"\\f842\"; }\n\n.la-stamp:before {\n  content: \"\\f5bf\"; }\n\n.la-star:before {\n  content: \"\\f005\"; }\n\n.la-star-and-crescent:before {\n  content: \"\\f699\"; }\n\n.la-star-half:before {\n  content: \"\\f089\"; }\n\n.la-star-half-alt:before {\n  content: \"\\f5c0\"; }\n\n.la-star-of-david:before {\n  content: \"\\f69a\"; }\n\n.la-star-of-life:before {\n  content: \"\\f621\"; }\n\n.la-staylinked:before {\n  content: \"\\f3f5\"; }\n\n.la-steam:before {\n  content: \"\\f1b6\"; }\n\n.la-steam-square:before {\n  content: \"\\f1b7\"; }\n\n.la-steam-symbol:before {\n  content: \"\\f3f6\"; }\n\n.la-step-backward:before {\n  content: \"\\f048\"; }\n\n.la-step-forward:before {\n  content: \"\\f051\"; }\n\n.la-stethoscope:before {\n  content: \"\\f0f1\"; }\n\n.la-sticker-mule:before {\n  content: \"\\f3f7\"; }\n\n.la-sticky-note:before {\n  content: \"\\f249\"; }\n\n.la-stop:before {\n  content: \"\\f04d\"; }\n\n.la-stop-circle:before {\n  content: \"\\f28d\"; }\n\n.la-stopwatch:before {\n  content: \"\\f2f2\"; }\n\n.la-store:before {\n  content: \"\\f54e\"; }\n\n.la-store-alt:before {\n  content: \"\\f54f\"; }\n\n.la-strava:before {\n  content: \"\\f428\"; }\n\n.la-stream:before {\n  content: \"\\f550\"; }\n\n.la-street-view:before {\n  content: \"\\f21d\"; }\n\n.la-strikethrough:before {\n  content: \"\\f0cc\"; }\n\n.la-stripe:before {\n  content: \"\\f429\"; }\n\n.la-stripe-s:before {\n  content: \"\\f42a\"; }\n\n.la-stroopwafel:before {\n  content: \"\\f551\"; }\n\n.la-studiovinari:before {\n  content: \"\\f3f8\"; }\n\n.la-stumbleupon:before {\n  content: \"\\f1a4\"; }\n\n.la-stumbleupon-circle:before {\n  content: \"\\f1a3\"; }\n\n.la-subscript:before {\n  content: \"\\f12c\"; }\n\n.la-subway:before {\n  content: \"\\f239\"; }\n\n.la-suitcase:before {\n  content: \"\\f0f2\"; }\n\n.la-suitcase-rolling:before {\n  content: \"\\f5c1\"; }\n\n.la-sun:before {\n  content: \"\\f185\"; }\n\n.la-superpowers:before {\n  content: \"\\f2dd\"; }\n\n.la-superscript:before {\n  content: \"\\f12b\"; }\n\n.la-supple:before {\n  content: \"\\f3f9\"; }\n\n.la-surprise:before {\n  content: \"\\f5c2\"; }\n\n.la-suse:before {\n  content: \"\\f7d6\"; }\n\n.la-swatchbook:before {\n  content: \"\\f5c3\"; }\n\n.la-swift:before {\n  content: \"\\f8e1\"; }\n\n.la-swimmer:before {\n  content: \"\\f5c4\"; }\n\n.la-swimming-pool:before {\n  content: \"\\f5c5\"; }\n\n.la-symfony:before {\n  content: \"\\f83d\"; }\n\n.la-synagogue:before {\n  content: \"\\f69b\"; }\n\n.la-sync:before {\n  content: \"\\f021\"; }\n\n.la-sync-alt:before {\n  content: \"\\f2f1\"; }\n\n.la-syringe:before {\n  content: \"\\f48e\"; }\n\n.la-table:before {\n  content: \"\\f0ce\"; }\n\n.la-table-tennis:before {\n  content: \"\\f45d\"; }\n\n.la-tablet:before {\n  content: \"\\f10a\"; }\n\n.la-tablet-alt:before {\n  content: \"\\f3fa\"; }\n\n.la-tablets:before {\n  content: \"\\f490\"; }\n\n.la-tachometer-alt:before {\n  content: \"\\f3fd\"; }\n\n.la-tag:before {\n  content: \"\\f02b\"; }\n\n.la-tags:before {\n  content: \"\\f02c\"; }\n\n.la-tape:before {\n  content: \"\\f4db\"; }\n\n.la-tasks:before {\n  content: \"\\f0ae\"; }\n\n.la-taxi:before {\n  content: \"\\f1ba\"; }\n\n.la-teamspeak:before {\n  content: \"\\f4f9\"; }\n\n.la-teeth:before {\n  content: \"\\f62e\"; }\n\n.la-teeth-open:before {\n  content: \"\\f62f\"; }\n\n.la-telegram:before {\n  content: \"\\f2c6\"; }\n\n.la-telegram-plane:before {\n  content: \"\\f3fe\"; }\n\n.la-temperature-high:before {\n  content: \"\\f769\"; }\n\n.la-temperature-low:before {\n  content: \"\\f76b\"; }\n\n.la-tencent-weibo:before {\n  content: \"\\f1d5\"; }\n\n.la-tenge:before {\n  content: \"\\f7d7\"; }\n\n.la-terminal:before {\n  content: \"\\f120\"; }\n\n.la-text-height:before {\n  content: \"\\f034\"; }\n\n.la-text-width:before {\n  content: \"\\f035\"; }\n\n.la-th:before {\n  content: \"\\f00a\"; }\n\n.la-th-large:before {\n  content: \"\\f009\"; }\n\n.la-th-list:before {\n  content: \"\\f00b\"; }\n\n.la-the-red-yeti:before {\n  content: \"\\f69d\"; }\n\n.la-theater-masks:before {\n  content: \"\\f630\"; }\n\n.la-themeco:before {\n  content: \"\\f5c6\"; }\n\n.la-themeisle:before {\n  content: \"\\f2b2\"; }\n\n.la-thermometer:before {\n  content: \"\\f491\"; }\n\n.la-thermometer-empty:before {\n  content: \"\\f2cb\"; }\n\n.la-thermometer-full:before {\n  content: \"\\f2c7\"; }\n\n.la-thermometer-half:before {\n  content: \"\\f2c9\"; }\n\n.la-thermometer-quarter:before {\n  content: \"\\f2ca\"; }\n\n.la-thermometer-three-quarters:before {\n  content: \"\\f2c8\"; }\n\n.la-think-peaks:before {\n  content: \"\\f731\"; }\n\n.la-thumbs-down:before {\n  content: \"\\f165\"; }\n\n.la-thumbs-up:before {\n  content: \"\\f164\"; }\n\n.la-thumbtack:before {\n  content: \"\\f08d\"; }\n\n.la-ticket-alt:before {\n  content: \"\\f3ff\"; }\n\n.la-times:before {\n  content: \"\\f00d\"; }\n\n.la-times-circle:before {\n  content: \"\\f057\"; }\n\n.la-tint:before {\n  content: \"\\f043\"; }\n\n.la-tint-slash:before {\n  content: \"\\f5c7\"; }\n\n.la-tired:before {\n  content: \"\\f5c8\"; }\n\n.la-toggle-off:before {\n  content: \"\\f204\"; }\n\n.la-toggle-on:before {\n  content: \"\\f205\"; }\n\n.la-toilet:before {\n  content: \"\\f7d8\"; }\n\n.la-toilet-paper:before {\n  content: \"\\f71e\"; }\n\n.la-toolbox:before {\n  content: \"\\f552\"; }\n\n.la-tools:before {\n  content: \"\\f7d9\"; }\n\n.la-tooth:before {\n  content: \"\\f5c9\"; }\n\n.la-torah:before {\n  content: \"\\f6a0\"; }\n\n.la-torii-gate:before {\n  content: \"\\f6a1\"; }\n\n.la-tractor:before {\n  content: \"\\f722\"; }\n\n.la-trade-federation:before {\n  content: \"\\f513\"; }\n\n.la-trademark:before {\n  content: \"\\f25c\"; }\n\n.la-traffic-light:before {\n  content: \"\\f637\"; }\n\n.la-train:before {\n  content: \"\\f238\"; }\n\n.la-tram:before {\n  content: \"\\f7da\"; }\n\n.la-transgender:before {\n  content: \"\\f224\"; }\n\n.la-transgender-alt:before {\n  content: \"\\f225\"; }\n\n.la-trash:before {\n  content: \"\\f1f8\"; }\n\n.la-trash-alt:before {\n  content: \"\\f2ed\"; }\n\n.la-trash-restore:before {\n  content: \"\\f829\"; }\n\n.la-trash-restore-alt:before {\n  content: \"\\f82a\"; }\n\n.la-tree:before {\n  content: \"\\f1bb\"; }\n\n.la-trello:before {\n  content: \"\\f181\"; }\n\n.la-tripadvisor:before {\n  content: \"\\f262\"; }\n\n.la-trophy:before {\n  content: \"\\f091\"; }\n\n.la-truck:before {\n  content: \"\\f0d1\"; }\n\n.la-truck-loading:before {\n  content: \"\\f4de\"; }\n\n.la-truck-monster:before {\n  content: \"\\f63b\"; }\n\n.la-truck-moving:before {\n  content: \"\\f4df\"; }\n\n.la-truck-pickup:before {\n  content: \"\\f63c\"; }\n\n.la-tshirt:before {\n  content: \"\\f553\"; }\n\n.la-tty:before {\n  content: \"\\f1e4\"; }\n\n.la-tumblr:before {\n  content: \"\\f173\"; }\n\n.la-tumblr-square:before {\n  content: \"\\f174\"; }\n\n.la-tv:before {\n  content: \"\\f26c\"; }\n\n.la-twitch:before {\n  content: \"\\f1e8\"; }\n\n.la-twitter:before {\n  content: \"\\f099\"; }\n\n.la-twitter-square:before {\n  content: \"\\f081\"; }\n\n.la-typo3:before {\n  content: \"\\f42b\"; }\n\n.la-uber:before {\n  content: \"\\f402\"; }\n\n.la-ubuntu:before {\n  content: \"\\f7df\"; }\n\n.la-uikit:before {\n  content: \"\\f403\"; }\n\n.la-umbraco:before {\n  content: \"\\f8e8\"; }\n\n.la-umbrella:before {\n  content: \"\\f0e9\"; }\n\n.la-umbrella-beach:before {\n  content: \"\\f5ca\"; }\n\n.la-underline:before {\n  content: \"\\f0cd\"; }\n\n.la-undo:before {\n  content: \"\\f0e2\"; }\n\n.la-undo-alt:before {\n  content: \"\\f2ea\"; }\n\n.la-uniregistry:before {\n  content: \"\\f404\"; }\n\n.la-universal-access:before {\n  content: \"\\f29a\"; }\n\n.la-university:before {\n  content: \"\\f19c\"; }\n\n.la-unlink:before {\n  content: \"\\f127\"; }\n\n.la-unlock:before {\n  content: \"\\f09c\"; }\n\n.la-unlock-alt:before {\n  content: \"\\f13e\"; }\n\n.la-untappd:before {\n  content: \"\\f405\"; }\n\n.la-upload:before {\n  content: \"\\f093\"; }\n\n.la-ups:before {\n  content: \"\\f7e0\"; }\n\n.la-usb:before {\n  content: \"\\f287\"; }\n\n.la-user:before {\n  content: \"\\f007\"; }\n\n.la-user-alt:before {\n  content: \"\\f406\"; }\n\n.la-user-alt-slash:before {\n  content: \"\\f4fa\"; }\n\n.la-user-astronaut:before {\n  content: \"\\f4fb\"; }\n\n.la-user-check:before {\n  content: \"\\f4fc\"; }\n\n.la-user-circle:before {\n  content: \"\\f2bd\"; }\n\n.la-user-clock:before {\n  content: \"\\f4fd\"; }\n\n.la-user-cog:before {\n  content: \"\\f4fe\"; }\n\n.la-user-edit:before {\n  content: \"\\f4ff\"; }\n\n.la-user-friends:before {\n  content: \"\\f500\"; }\n\n.la-user-graduate:before {\n  content: \"\\f501\"; }\n\n.la-user-injured:before {\n  content: \"\\f728\"; }\n\n.la-user-lock:before {\n  content: \"\\f502\"; }\n\n.la-user-md:before {\n  content: \"\\f0f0\"; }\n\n.la-user-minus:before {\n  content: \"\\f503\"; }\n\n.la-user-ninja:before {\n  content: \"\\f504\"; }\n\n.la-user-nurse:before {\n  content: \"\\f82f\"; }\n\n.la-user-plus:before {\n  content: \"\\f234\"; }\n\n.la-user-secret:before {\n  content: \"\\f21b\"; }\n\n.la-user-shield:before {\n  content: \"\\f505\"; }\n\n.la-user-slash:before {\n  content: \"\\f506\"; }\n\n.la-user-tag:before {\n  content: \"\\f507\"; }\n\n.la-user-tie:before {\n  content: \"\\f508\"; }\n\n.la-user-times:before {\n  content: \"\\f235\"; }\n\n.la-users:before {\n  content: \"\\f0c0\"; }\n\n.la-users-cog:before {\n  content: \"\\f509\"; }\n\n.la-usps:before {\n  content: \"\\f7e1\"; }\n\n.la-ussunnah:before {\n  content: \"\\f407\"; }\n\n.la-utensil-spoon:before {\n  content: \"\\f2e5\"; }\n\n.la-utensils:before {\n  content: \"\\f2e7\"; }\n\n.la-vaadin:before {\n  content: \"\\f408\"; }\n\n.la-vector-square:before {\n  content: \"\\f5cb\"; }\n\n.la-venus:before {\n  content: \"\\f221\"; }\n\n.la-venus-double:before {\n  content: \"\\f226\"; }\n\n.la-venus-mars:before {\n  content: \"\\f228\"; }\n\n.la-viacoin:before {\n  content: \"\\f237\"; }\n\n.la-viadeo:before {\n  content: \"\\f2a9\"; }\n\n.la-viadeo-square:before {\n  content: \"\\f2aa\"; }\n\n.la-vial:before {\n  content: \"\\f492\"; }\n\n.la-vials:before {\n  content: \"\\f493\"; }\n\n.la-viber:before {\n  content: \"\\f409\"; }\n\n.la-video:before {\n  content: \"\\f03d\"; }\n\n.la-video-slash:before {\n  content: \"\\f4e2\"; }\n\n.la-vihara:before {\n  content: \"\\f6a7\"; }\n\n.la-vimeo:before {\n  content: \"\\f40a\"; }\n\n.la-vimeo-square:before {\n  content: \"\\f194\"; }\n\n.la-vimeo-v:before {\n  content: \"\\f27d\"; }\n\n.la-vine:before {\n  content: \"\\f1ca\"; }\n\n.la-vk:before {\n  content: \"\\f189\"; }\n\n.la-vnv:before {\n  content: \"\\f40b\"; }\n\n.la-voicemail:before {\n  content: \"\\f897\"; }\n\n.la-volleyball-ball:before {\n  content: \"\\f45f\"; }\n\n.la-volume-down:before {\n  content: \"\\f027\"; }\n\n.la-volume-mute:before {\n  content: \"\\f6a9\"; }\n\n.la-volume-off:before {\n  content: \"\\f026\"; }\n\n.la-volume-up:before {\n  content: \"\\f028\"; }\n\n.la-vote-yea:before {\n  content: \"\\f772\"; }\n\n.la-vr-cardboard:before {\n  content: \"\\f729\"; }\n\n.la-vuejs:before {\n  content: \"\\f41f\"; }\n\n.la-walking:before {\n  content: \"\\f554\"; }\n\n.la-wallet:before {\n  content: \"\\f555\"; }\n\n.la-warehouse:before {\n  content: \"\\f494\"; }\n\n.la-water:before {\n  content: \"\\f773\"; }\n\n.la-wave-square:before {\n  content: \"\\f83e\"; }\n\n.la-waze:before {\n  content: \"\\f83f\"; }\n\n.la-weebly:before {\n  content: \"\\f5cc\"; }\n\n.la-weibo:before {\n  content: \"\\f18a\"; }\n\n.la-weight:before {\n  content: \"\\f496\"; }\n\n.la-weight-hanging:before {\n  content: \"\\f5cd\"; }\n\n.la-weixin:before {\n  content: \"\\f1d7\"; }\n\n.la-whatsapp:before {\n  content: \"\\f232\"; }\n\n.la-whatsapp-square:before {\n  content: \"\\f40c\"; }\n\n.la-wheelchair:before {\n  content: \"\\f193\"; }\n\n.la-whmcs:before {\n  content: \"\\f40d\"; }\n\n.la-wifi:before {\n  content: \"\\f1eb\"; }\n\n.la-wikipedia-w:before {\n  content: \"\\f266\"; }\n\n.la-wind:before {\n  content: \"\\f72e\"; }\n\n.la-window-close:before {\n  content: \"\\f410\"; }\n\n.la-window-maximize:before {\n  content: \"\\f2d0\"; }\n\n.la-window-minimize:before {\n  content: \"\\f2d1\"; }\n\n.la-window-restore:before {\n  content: \"\\f2d2\"; }\n\n.la-windows:before {\n  content: \"\\f17a\"; }\n\n.la-wine-bottle:before {\n  content: \"\\f72f\"; }\n\n.la-wine-glass:before {\n  content: \"\\f4e3\"; }\n\n.la-wine-glass-alt:before {\n  content: \"\\f5ce\"; }\n\n.la-wix:before {\n  content: \"\\f5cf\"; }\n\n.la-wizards-of-the-coast:before {\n  content: \"\\f730\"; }\n\n.la-wolf-pack-battalion:before {\n  content: \"\\f514\"; }\n\n.la-won-sign:before {\n  content: \"\\f159\"; }\n\n.la-wordpress:before {\n  content: \"\\f19a\"; }\n\n.la-wordpress-simple:before {\n  content: \"\\f411\"; }\n\n.la-wpbeginner:before {\n  content: \"\\f297\"; }\n\n.la-wpexplorer:before {\n  content: \"\\f2de\"; }\n\n.la-wpforms:before {\n  content: \"\\f298\"; }\n\n.la-wpressr:before {\n  content: \"\\f3e4\"; }\n\n.la-wrench:before {\n  content: \"\\f0ad\"; }\n\n.la-x-ray:before {\n  content: \"\\f497\"; }\n\n.la-xbox:before {\n  content: \"\\f412\"; }\n\n.la-xing:before {\n  content: \"\\f168\"; }\n\n.la-xing-square:before {\n  content: \"\\f169\"; }\n\n.la-y-combinator:before {\n  content: \"\\f23b\"; }\n\n.la-yahoo:before {\n  content: \"\\f19e\"; }\n\n.la-yammer:before {\n  content: \"\\f840\"; }\n\n.la-yandex:before {\n  content: \"\\f413\"; }\n\n.la-yandex-international:before {\n  content: \"\\f414\"; }\n\n.la-yarn:before {\n  content: \"\\f7e3\"; }\n\n.la-yelp:before {\n  content: \"\\f1e9\"; }\n\n.la-yen-sign:before {\n  content: \"\\f157\"; }\n\n.la-yin-yang:before {\n  content: \"\\f6ad\"; }\n\n.la-yoast:before {\n  content: \"\\f2b1\"; }\n\n.la-youtube:before {\n  content: \"\\f167\"; }\n\n.la-youtube-square:before {\n  content: \"\\f431\"; }\n\n.la-zhihu:before {\n  content: \"\\f63f\"; }\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px; }\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto; }\n@font-face {\n  font-family: 'Line Awesome Brands';\n  font-style: normal;\n  font-weight: normal;\n  font-display: auto;\n  src: url(\"../../../fonts/la-brands-400.eot\");\n  src: url(\"../../../fonts/la-brands-400.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../fonts/la-brands-400.woff2\") format(\"woff2\"), url(\"../../../fonts/la-brands-400.woff\") format(\"woff\"), url(\"../../../fonts/la-brands-400.ttf\") format(\"truetype\"), url(\"../../../fonts/la-brands-400.svg#lineawesome\") format(\"svg\"); }\n\n.lab {\n  font-family: 'Line Awesome Brands'; }\n@font-face {\n  font-family: 'Line Awesome Free';\n  font-style: normal;\n  font-weight: 400;\n  font-display: auto;\n  src: url(\"../../../fonts/la-regular-400.eot\");\n  src: url(\"../../../fonts/la-regular-400.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../fonts/la-regular-400.woff2\") format(\"woff2\"), url(\"../../../fonts/la-regular-400.woff\") format(\"woff\"), url(\"../../../fonts/la-regular-400.ttf\") format(\"truetype\"), url(\"../../../fonts/la-regular-400.svg#lineawesome\") format(\"svg\"); }\n\n.lar {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n@font-face {\n  font-family: 'Line Awesome Free';\n  font-style: normal;\n  font-weight: 900;\n  font-display: auto;\n  src: url(\"../../../fonts/la-solid-900.eot\");\n  src: url(\"../../../fonts/la-solid-900.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../fonts/la-solid-900.woff2\") format(\"woff2\"), url(\"../../../fonts/la-solid-900.woff\") format(\"woff\"), url(\"../../../fonts/la-solid-900.ttf\") format(\"truetype\"), url(\"../../../fonts/la-solid-900.svg#lineawesome\") format(\"svg\"); }\n\n.la,\n.las {\n  font-family: 'Line Awesome Free';\n  font-weight: 900; }\n\n.la.la-glass:before {\n  content: \"\\f000\"; }\n\n.la.la-meetup {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-star-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-star-o:before {\n  content: \"\\f005\"; }\n\n.la.la-remove:before {\n  content: \"\\f00d\"; }\n\n.la.la-close:before {\n  content: \"\\f00d\"; }\n\n.la.la-gear:before {\n  content: \"\\f013\"; }\n\n.la.la-trash-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-trash-o:before {\n  content: \"\\f2ed\"; }\n\n.la.la-file-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-o:before {\n  content: \"\\f15b\"; }\n\n.la.la-clock-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-clock-o:before {\n  content: \"\\f017\"; }\n\n.la.la-arrow-circle-o-down {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-arrow-circle-o-down:before {\n  content: \"\\f358\"; }\n\n.la.la-arrow-circle-o-up {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-arrow-circle-o-up:before {\n  content: \"\\f35b\"; }\n\n.la.la-play-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-play-circle-o:before {\n  content: \"\\f144\"; }\n\n.la.la-repeat:before {\n  content: \"\\f01e\"; }\n\n.la.la-rotate-right:before {\n  content: \"\\f01e\"; }\n\n.la.la-refresh:before {\n  content: \"\\f021\"; }\n\n.la.la-list-alt {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-dedent:before {\n  content: \"\\f03b\"; }\n\n.la.la-video-camera:before {\n  content: \"\\f03d\"; }\n\n.la.la-picture-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-picture-o:before {\n  content: \"\\f03e\"; }\n\n.la.la-photo {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-photo:before {\n  content: \"\\f03e\"; }\n\n.la.la-image {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-image:before {\n  content: \"\\f03e\"; }\n\n.la.la-pencil:before {\n  content: \"\\f303\"; }\n\n.la.la-map-marker:before {\n  content: \"\\f3c5\"; }\n\n.la.la-pencil-square-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-pencil-square-o:before {\n  content: \"\\f044\"; }\n\n.la.la-share-square-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-share-square-o:before {\n  content: \"\\f14d\"; }\n\n.la.la-check-square-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-check-square-o:before {\n  content: \"\\f14a\"; }\n\n.la.la-arrows:before {\n  content: \"\\f0b2\"; }\n\n.la.la-times-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-times-circle-o:before {\n  content: \"\\f057\"; }\n\n.la.la-check-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-check-circle-o:before {\n  content: \"\\f058\"; }\n\n.la.la-mail-forward:before {\n  content: \"\\f064\"; }\n\n.la.la-eye {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-eye-slash {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-warning:before {\n  content: \"\\f071\"; }\n\n.la.la-calendar:before {\n  content: \"\\f073\"; }\n\n.la.la-arrows-v:before {\n  content: \"\\f338\"; }\n\n.la.la-arrows-h:before {\n  content: \"\\f337\"; }\n\n.la.la-bar-chart {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-bar-chart:before {\n  content: \"\\f080\"; }\n\n.la.la-bar-chart-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-bar-chart-o:before {\n  content: \"\\f080\"; }\n\n.la.la-twitter-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-facebook-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-gears:before {\n  content: \"\\f085\"; }\n\n.la.la-thumbs-o-up {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-thumbs-o-up:before {\n  content: \"\\f164\"; }\n\n.la.la-thumbs-o-down {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-thumbs-o-down:before {\n  content: \"\\f165\"; }\n\n.la.la-heart-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-heart-o:before {\n  content: \"\\f004\"; }\n\n.la.la-sign-out:before {\n  content: \"\\f2f5\"; }\n\n.la.la-linkedin-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-linkedin-square:before {\n  content: \"\\f08c\"; }\n\n.la.la-thumb-tack:before {\n  content: \"\\f08d\"; }\n\n.la.la-external-link:before {\n  content: \"\\f35d\"; }\n\n.la.la-sign-in:before {\n  content: \"\\f2f6\"; }\n\n.la.la-github-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-lemon-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-lemon-o:before {\n  content: \"\\f094\"; }\n\n.la.la-square-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-square-o:before {\n  content: \"\\f0c8\"; }\n\n.la.la-bookmark-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-bookmark-o:before {\n  content: \"\\f02e\"; }\n\n.la.la-twitter {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-facebook {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-facebook:before {\n  content: \"\\f39e\"; }\n\n.la.la-facebook-f {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-facebook-f:before {\n  content: \"\\f39e\"; }\n\n.la.la-github {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-credit-card {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-feed:before {\n  content: \"\\f09e\"; }\n\n.la.la-hdd-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hdd-o:before {\n  content: \"\\f0a0\"; }\n\n.la.la-hand-o-right {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-o-right:before {\n  content: \"\\f0a4\"; }\n\n.la.la-hand-o-left {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-o-left:before {\n  content: \"\\f0a5\"; }\n\n.la.la-hand-o-up {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-o-up:before {\n  content: \"\\f0a6\"; }\n\n.la.la-hand-o-down {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-o-down:before {\n  content: \"\\f0a7\"; }\n\n.la.la-arrows-alt:before {\n  content: \"\\f31e\"; }\n\n.la.la-group:before {\n  content: \"\\f0c0\"; }\n\n.la.la-chain:before {\n  content: \"\\f0c1\"; }\n\n.la.la-scissors:before {\n  content: \"\\f0c4\"; }\n\n.la.la-files-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-files-o:before {\n  content: \"\\f0c5\"; }\n\n.la.la-floppy-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-floppy-o:before {\n  content: \"\\f0c7\"; }\n\n.la.la-navicon:before {\n  content: \"\\f0c9\"; }\n\n.la.la-reorder:before {\n  content: \"\\f0c9\"; }\n\n.la.la-pinterest {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-pinterest-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google-plus-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google-plus {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google-plus:before {\n  content: \"\\f0d5\"; }\n\n.la.la-money {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-money:before {\n  content: \"\\f3d1\"; }\n\n.la.la-unsorted:before {\n  content: \"\\f0dc\"; }\n\n.la.la-sort-desc:before {\n  content: \"\\f0dd\"; }\n\n.la.la-sort-asc:before {\n  content: \"\\f0de\"; }\n\n.la.la-linkedin {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-linkedin:before {\n  content: \"\\f0e1\"; }\n\n.la.la-rotate-left:before {\n  content: \"\\f0e2\"; }\n\n.la.la-legal:before {\n  content: \"\\f0e3\"; }\n\n.la.la-tachometer:before {\n  content: \"\\f3fd\"; }\n\n.la.la-dashboard:before {\n  content: \"\\f3fd\"; }\n\n.la.la-comment-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-comment-o:before {\n  content: \"\\f075\"; }\n\n.la.la-comments-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-comments-o:before {\n  content: \"\\f086\"; }\n\n.la.la-flash:before {\n  content: \"\\f0e7\"; }\n\n.la.la-clipboard {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-paste {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-paste:before {\n  content: \"\\f328\"; }\n\n.la.la-lightbulb-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-lightbulb-o:before {\n  content: \"\\f0eb\"; }\n\n.la.la-exchange:before {\n  content: \"\\f362\"; }\n\n.la.la-cloud-download:before {\n  content: \"\\f381\"; }\n\n.la.la-cloud-upload:before {\n  content: \"\\f382\"; }\n\n.la.la-bell-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-bell-o:before {\n  content: \"\\f0f3\"; }\n\n.la.la-cutlery:before {\n  content: \"\\f2e7\"; }\n\n.la.la-file-text-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-text-o:before {\n  content: \"\\f15c\"; }\n\n.la.la-building-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-building-o:before {\n  content: \"\\f1ad\"; }\n\n.la.la-hospital-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hospital-o:before {\n  content: \"\\f0f8\"; }\n\n.la.la-tablet:before {\n  content: \"\\f3fa\"; }\n\n.la.la-mobile:before {\n  content: \"\\f3cd\"; }\n\n.la.la-mobile-phone:before {\n  content: \"\\f3cd\"; }\n\n.la.la-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-circle-o:before {\n  content: \"\\f111\"; }\n\n.la.la-mail-reply:before {\n  content: \"\\f3e5\"; }\n\n.la.la-github-alt {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-folder-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-folder-o:before {\n  content: \"\\f07b\"; }\n\n.la.la-folder-open-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-folder-open-o:before {\n  content: \"\\f07c\"; }\n\n.la.la-smile-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-smile-o:before {\n  content: \"\\f118\"; }\n\n.la.la-frown-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-frown-o:before {\n  content: \"\\f119\"; }\n\n.la.la-meh-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-meh-o:before {\n  content: \"\\f11a\"; }\n\n.la.la-keyboard-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-keyboard-o:before {\n  content: \"\\f11c\"; }\n\n.la.la-flag-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-flag-o:before {\n  content: \"\\f024\"; }\n\n.la.la-mail-reply-all:before {\n  content: \"\\f122\"; }\n\n.la.la-star-half-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-star-half-o:before {\n  content: \"\\f089\"; }\n\n.la.la-star-half-empty {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-star-half-empty:before {\n  content: \"\\f089\"; }\n\n.la.la-star-half-full {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-star-half-full:before {\n  content: \"\\f089\"; }\n\n.la.la-code-fork:before {\n  content: \"\\f126\"; }\n\n.la.la-chain-broken:before {\n  content: \"\\f127\"; }\n\n.la.la-shield:before {\n  content: \"\\f3ed\"; }\n\n.la.la-calendar-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-calendar-o:before {\n  content: \"\\f133\"; }\n\n.la.la-maxcdn {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-html5 {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-css3 {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-ticket:before {\n  content: \"\\f3ff\"; }\n\n.la.la-minus-square-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-minus-square-o:before {\n  content: \"\\f146\"; }\n\n.la.la-level-up:before {\n  content: \"\\f3bf\"; }\n\n.la.la-level-down:before {\n  content: \"\\f3be\"; }\n\n.la.la-pencil-square:before {\n  content: \"\\f14b\"; }\n\n.la.la-external-link-square:before {\n  content: \"\\f360\"; }\n\n.la.la-compass {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-caret-square-o-down {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-caret-square-o-down:before {\n  content: \"\\f150\"; }\n\n.la.la-toggle-down {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-toggle-down:before {\n  content: \"\\f150\"; }\n\n.la.la-caret-square-o-up {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-caret-square-o-up:before {\n  content: \"\\f151\"; }\n\n.la.la-toggle-up {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-toggle-up:before {\n  content: \"\\f151\"; }\n\n.la.la-caret-square-o-right {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-caret-square-o-right:before {\n  content: \"\\f152\"; }\n\n.la.la-toggle-right {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-toggle-right:before {\n  content: \"\\f152\"; }\n\n.la.la-eur:before {\n  content: \"\\f153\"; }\n\n.la.la-euro:before {\n  content: \"\\f153\"; }\n\n.la.la-gbp:before {\n  content: \"\\f154\"; }\n\n.la.la-usd:before {\n  content: \"\\f155\"; }\n\n.la.la-dollar:before {\n  content: \"\\f155\"; }\n\n.la.la-inr:before {\n  content: \"\\f156\"; }\n\n.la.la-rupee:before {\n  content: \"\\f156\"; }\n\n.la.la-jpy:before {\n  content: \"\\f157\"; }\n\n.la.la-cny:before {\n  content: \"\\f157\"; }\n\n.la.la-rmb:before {\n  content: \"\\f157\"; }\n\n.la.la-yen:before {\n  content: \"\\f157\"; }\n\n.la.la-rub:before {\n  content: \"\\f158\"; }\n\n.la.la-ruble:before {\n  content: \"\\f158\"; }\n\n.la.la-rouble:before {\n  content: \"\\f158\"; }\n\n.la.la-krw:before {\n  content: \"\\f159\"; }\n\n.la.la-won:before {\n  content: \"\\f159\"; }\n\n.la.la-btc {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-bitcoin {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-bitcoin:before {\n  content: \"\\f15a\"; }\n\n.la.la-file-text:before {\n  content: \"\\f15c\"; }\n\n.la.la-sort-alpha-asc:before {\n  content: \"\\f15d\"; }\n\n.la.la-sort-alpha-desc:before {\n  content: \"\\f881\"; }\n\n.la.la-sort-amount-asc:before {\n  content: \"\\f160\"; }\n\n.la.la-sort-amount-desc:before {\n  content: \"\\f884\"; }\n\n.la.la-sort-numeric-asc:before {\n  content: \"\\f162\"; }\n\n.la.la-sort-numeric-desc:before {\n  content: \"\\f886\"; }\n\n.la.la-youtube-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-youtube {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-xing {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-xing-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-youtube-play {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-youtube-play:before {\n  content: \"\\f167\"; }\n\n.la.la-dropbox {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-stack-overflow {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-instagram {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-flickr {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-adn {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-bitbucket {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-bitbucket-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-bitbucket-square:before {\n  content: \"\\f171\"; }\n\n.la.la-tumblr {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-tumblr-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-long-arrow-down:before {\n  content: \"\\f309\"; }\n\n.la.la-long-arrow-up:before {\n  content: \"\\f30c\"; }\n\n.la.la-long-arrow-left:before {\n  content: \"\\f30a\"; }\n\n.la.la-long-arrow-right:before {\n  content: \"\\f30b\"; }\n\n.la.la-apple {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-windows {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-android {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-linux {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-dribbble {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-skype {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-foursquare {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-trello {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-gratipay {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-gittip {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-gittip:before {\n  content: \"\\f184\"; }\n\n.la.la-sun-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-sun-o:before {\n  content: \"\\f185\"; }\n\n.la.la-moon-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-moon-o:before {\n  content: \"\\f186\"; }\n\n.la.la-vk {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-weibo {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-renren {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-pagelines {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-stack-exchange {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-arrow-circle-o-right {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-arrow-circle-o-right:before {\n  content: \"\\f35a\"; }\n\n.la.la-arrow-circle-o-left {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-arrow-circle-o-left:before {\n  content: \"\\f359\"; }\n\n.la.la-caret-square-o-left {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-caret-square-o-left:before {\n  content: \"\\f191\"; }\n\n.la.la-toggle-left {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-toggle-left:before {\n  content: \"\\f191\"; }\n\n.la.la-dot-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-dot-circle-o:before {\n  content: \"\\f192\"; }\n\n.la.la-vimeo-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-try:before {\n  content: \"\\f195\"; }\n\n.la.la-turkish-lira:before {\n  content: \"\\f195\"; }\n\n.la.la-plus-square-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-plus-square-o:before {\n  content: \"\\f0fe\"; }\n\n.la.la-slack {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wordpress {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-openid {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-institution:before {\n  content: \"\\f19c\"; }\n\n.la.la-bank:before {\n  content: \"\\f19c\"; }\n\n.la.la-mortar-board:before {\n  content: \"\\f19d\"; }\n\n.la.la-yahoo {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-reddit {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-reddit-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-stumbleupon-circle {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-stumbleupon {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-delicious {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-digg {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-pied-piper-pp {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-pied-piper-alt {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-drupal {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-joomla {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-spoon:before {\n  content: \"\\f2e5\"; }\n\n.la.la-behance {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-behance-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-steam {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-steam-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-automobile:before {\n  content: \"\\f1b9\"; }\n\n.la.la-cab:before {\n  content: \"\\f1ba\"; }\n\n.la.la-envelope-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-envelope-o:before {\n  content: \"\\f0e0\"; }\n\n.la.la-deviantart {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-soundcloud {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-file-pdf-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-pdf-o:before {\n  content: \"\\f1c1\"; }\n\n.la.la-file-word-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-word-o:before {\n  content: \"\\f1c2\"; }\n\n.la.la-file-excel-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-excel-o:before {\n  content: \"\\f1c3\"; }\n\n.la.la-file-powerpoint-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-powerpoint-o:before {\n  content: \"\\f1c4\"; }\n\n.la.la-file-image-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-image-o:before {\n  content: \"\\f1c5\"; }\n\n.la.la-file-photo-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-photo-o:before {\n  content: \"\\f1c5\"; }\n\n.la.la-file-picture-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-picture-o:before {\n  content: \"\\f1c5\"; }\n\n.la.la-file-archive-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-archive-o:before {\n  content: \"\\f1c6\"; }\n\n.la.la-file-zip-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-zip-o:before {\n  content: \"\\f1c6\"; }\n\n.la.la-file-audio-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-audio-o:before {\n  content: \"\\f1c7\"; }\n\n.la.la-file-sound-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-sound-o:before {\n  content: \"\\f1c7\"; }\n\n.la.la-file-video-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-video-o:before {\n  content: \"\\f1c8\"; }\n\n.la.la-file-movie-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-movie-o:before {\n  content: \"\\f1c8\"; }\n\n.la.la-file-code-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-code-o:before {\n  content: \"\\f1c9\"; }\n\n.la.la-vine {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-codepen {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-jsfiddle {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-life-ring {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-life-bouy {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-life-bouy:before {\n  content: \"\\f1cd\"; }\n\n.la.la-life-buoy {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-life-buoy:before {\n  content: \"\\f1cd\"; }\n\n.la.la-life-saver {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-life-saver:before {\n  content: \"\\f1cd\"; }\n\n.la.la-support {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-support:before {\n  content: \"\\f1cd\"; }\n\n.la.la-circle-o-notch:before {\n  content: \"\\f1ce\"; }\n\n.la.la-rebel {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-ra {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-ra:before {\n  content: \"\\f1d0\"; }\n\n.la.la-resistance {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-resistance:before {\n  content: \"\\f1d0\"; }\n\n.la.la-empire {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-ge {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-ge:before {\n  content: \"\\f1d1\"; }\n\n.la.la-git-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-git {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-hacker-news {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-y-combinator-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-y-combinator-square:before {\n  content: \"\\f1d4\"; }\n\n.la.la-yc-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-yc-square:before {\n  content: \"\\f1d4\"; }\n\n.la.la-tencent-weibo {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-qq {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-weixin {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wechat {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wechat:before {\n  content: \"\\f1d7\"; }\n\n.la.la-send:before {\n  content: \"\\f1d8\"; }\n\n.la.la-paper-plane-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-paper-plane-o:before {\n  content: \"\\f1d8\"; }\n\n.la.la-send-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-send-o:before {\n  content: \"\\f1d8\"; }\n\n.la.la-circle-thin {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-circle-thin:before {\n  content: \"\\f111\"; }\n\n.la.la-header:before {\n  content: \"\\f1dc\"; }\n\n.la.la-sliders:before {\n  content: \"\\f1de\"; }\n\n.la.la-futbol-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-futbol-o:before {\n  content: \"\\f1e3\"; }\n\n.la.la-soccer-ball-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-soccer-ball-o:before {\n  content: \"\\f1e3\"; }\n\n.la.la-slideshare {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-twitch {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-yelp {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-newspaper-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-newspaper-o:before {\n  content: \"\\f1ea\"; }\n\n.la.la-paypal {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google-wallet {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc-visa {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc-mastercard {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc-discover {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc-amex {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc-paypal {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc-stripe {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-bell-slash-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-bell-slash-o:before {\n  content: \"\\f1f6\"; }\n\n.la.la-trash:before {\n  content: \"\\f2ed\"; }\n\n.la.la-copyright {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-eyedropper:before {\n  content: \"\\f1fb\"; }\n\n.la.la-area-chart:before {\n  content: \"\\f1fe\"; }\n\n.la.la-pie-chart:before {\n  content: \"\\f200\"; }\n\n.la.la-line-chart:before {\n  content: \"\\f201\"; }\n\n.la.la-lastfm {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-lastfm-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-ioxhost {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-angellist {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-cc:before {\n  content: \"\\f20a\"; }\n\n.la.la-ils:before {\n  content: \"\\f20b\"; }\n\n.la.la-shekel:before {\n  content: \"\\f20b\"; }\n\n.la.la-sheqel:before {\n  content: \"\\f20b\"; }\n\n.la.la-meanpath {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-meanpath:before {\n  content: \"\\f2b4\"; }\n\n.la.la-buysellads {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-connectdevelop {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-dashcube {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-forumbee {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-leanpub {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-sellsy {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-shirtsinbulk {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-simplybuilt {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-skyatlas {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-diamond {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-diamond:before {\n  content: \"\\f3a5\"; }\n\n.la.la-intersex:before {\n  content: \"\\f224\"; }\n\n.la.la-facebook-official {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-facebook-official:before {\n  content: \"\\f09a\"; }\n\n.la.la-pinterest-p {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-whatsapp {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-hotel:before {\n  content: \"\\f236\"; }\n\n.la.la-viacoin {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-medium {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-y-combinator {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-yc {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-yc:before {\n  content: \"\\f23b\"; }\n\n.la.la-optin-monster {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-opencart {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-expeditedssl {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-battery-4:before {\n  content: \"\\f240\"; }\n\n.la.la-battery:before {\n  content: \"\\f240\"; }\n\n.la.la-battery-3:before {\n  content: \"\\f241\"; }\n\n.la.la-battery-2:before {\n  content: \"\\f242\"; }\n\n.la.la-battery-1:before {\n  content: \"\\f243\"; }\n\n.la.la-battery-0:before {\n  content: \"\\f244\"; }\n\n.la.la-object-group {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-object-ungroup {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-sticky-note-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-sticky-note-o:before {\n  content: \"\\f249\"; }\n\n.la.la-cc-jcb {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc-diners-club {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-clone {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hourglass-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hourglass-o:before {\n  content: \"\\f254\"; }\n\n.la.la-hourglass-1:before {\n  content: \"\\f251\"; }\n\n.la.la-hourglass-2:before {\n  content: \"\\f252\"; }\n\n.la.la-hourglass-3:before {\n  content: \"\\f253\"; }\n\n.la.la-hand-rock-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-rock-o:before {\n  content: \"\\f255\"; }\n\n.la.la-hand-grab-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-grab-o:before {\n  content: \"\\f255\"; }\n\n.la.la-hand-paper-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-paper-o:before {\n  content: \"\\f256\"; }\n\n.la.la-hand-stop-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-stop-o:before {\n  content: \"\\f256\"; }\n\n.la.la-hand-scissors-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-scissors-o:before {\n  content: \"\\f257\"; }\n\n.la.la-hand-lizard-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-lizard-o:before {\n  content: \"\\f258\"; }\n\n.la.la-hand-spock-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-spock-o:before {\n  content: \"\\f259\"; }\n\n.la.la-hand-pointer-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-pointer-o:before {\n  content: \"\\f25a\"; }\n\n.la.la-hand-peace-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-peace-o:before {\n  content: \"\\f25b\"; }\n\n.la.la-registered {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-creative-commons {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-gg {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-gg-circle {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-tripadvisor {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-odnoklassniki {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-odnoklassniki-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-get-pocket {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wikipedia-w {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-safari {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-chrome {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-firefox {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-opera {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-internet-explorer {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-television:before {\n  content: \"\\f26c\"; }\n\n.la.la-contao {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-500px {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-amazon {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-calendar-plus-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-calendar-plus-o:before {\n  content: \"\\f271\"; }\n\n.la.la-calendar-minus-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-calendar-minus-o:before {\n  content: \"\\f272\"; }\n\n.la.la-calendar-times-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-calendar-times-o:before {\n  content: \"\\f273\"; }\n\n.la.la-calendar-check-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-calendar-check-o:before {\n  content: \"\\f274\"; }\n\n.la.la-map-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-map-o:before {\n  content: \"\\f279\"; }\n\n.la.la-commenting:before {\n  content: \"\\f4ad\"; }\n\n.la.la-commenting-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-commenting-o:before {\n  content: \"\\f4ad\"; }\n\n.la.la-houzz {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-vimeo {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-vimeo:before {\n  content: \"\\f27d\"; }\n\n.la.la-black-tie {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-fonticons {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-reddit-alien {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-edge {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-credit-card-alt:before {\n  content: \"\\f09d\"; }\n\n.la.la-codiepie {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-modx {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-fort-awesome {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-usb {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-product-hunt {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-mixcloud {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-scribd {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-pause-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-pause-circle-o:before {\n  content: \"\\f28b\"; }\n\n.la.la-stop-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-stop-circle-o:before {\n  content: \"\\f28d\"; }\n\n.la.la-bluetooth {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-bluetooth-b {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-gitlab {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wpbeginner {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wpforms {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-envira {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wheelchair-alt {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wheelchair-alt:before {\n  content: \"\\f368\"; }\n\n.la.la-question-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-question-circle-o:before {\n  content: \"\\f059\"; }\n\n.la.la-volume-control-phone:before {\n  content: \"\\f2a0\"; }\n\n.la.la-asl-interpreting:before {\n  content: \"\\f2a3\"; }\n\n.la.la-deafness:before {\n  content: \"\\f2a4\"; }\n\n.la.la-hard-of-hearing:before {\n  content: \"\\f2a4\"; }\n\n.la.la-glide {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-glide-g {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-signing:before {\n  content: \"\\f2a7\"; }\n\n.la.la-viadeo {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-viadeo-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-snapchat {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-snapchat-ghost {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-snapchat-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-pied-piper {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-first-order {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-yoast {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-themeisle {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google-plus-official {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google-plus-official:before {\n  content: \"\\f2b3\"; }\n\n.la.la-google-plus-circle {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google-plus-circle:before {\n  content: \"\\f2b3\"; }\n\n.la.la-font-awesome {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-fa {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-fa:before {\n  content: \"\\f2b4\"; }\n\n.la.la-handshake-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-handshake-o:before {\n  content: \"\\f2b5\"; }\n\n.la.la-envelope-open-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-envelope-open-o:before {\n  content: \"\\f2b6\"; }\n\n.la.la-linode {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-address-book-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-address-book-o:before {\n  content: \"\\f2b9\"; }\n\n.la.la-vcard:before {\n  content: \"\\f2bb\"; }\n\n.la.la-address-card-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-address-card-o:before {\n  content: \"\\f2bb\"; }\n\n.la.la-vcard-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-vcard-o:before {\n  content: \"\\f2bb\"; }\n\n.la.la-user-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-user-circle-o:before {\n  content: \"\\f2bd\"; }\n\n.la.la-user-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-user-o:before {\n  content: \"\\f007\"; }\n\n.la.la-id-badge {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-drivers-license:before {\n  content: \"\\f2c2\"; }\n\n.la.la-id-card-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-id-card-o:before {\n  content: \"\\f2c2\"; }\n\n.la.la-drivers-license-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-drivers-license-o:before {\n  content: \"\\f2c2\"; }\n\n.la.la-quora {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-free-code-camp {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-telegram {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-thermometer-4:before {\n  content: \"\\f2c7\"; }\n\n.la.la-thermometer:before {\n  content: \"\\f2c7\"; }\n\n.la.la-thermometer-3:before {\n  content: \"\\f2c8\"; }\n\n.la.la-thermometer-2:before {\n  content: \"\\f2c9\"; }\n\n.la.la-thermometer-1:before {\n  content: \"\\f2ca\"; }\n\n.la.la-thermometer-0:before {\n  content: \"\\f2cb\"; }\n\n.la.la-bathtub:before {\n  content: \"\\f2cd\"; }\n\n.la.la-s15:before {\n  content: \"\\f2cd\"; }\n\n.la.la-window-maximize {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-window-restore {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-times-rectangle:before {\n  content: \"\\f410\"; }\n\n.la.la-window-close-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-window-close-o:before {\n  content: \"\\f410\"; }\n\n.la.la-times-rectangle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-times-rectangle-o:before {\n  content: \"\\f410\"; }\n\n.la.la-bandcamp {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-grav {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-etsy {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-imdb {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-ravelry {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-eercast {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-eercast:before {\n  content: \"\\f2da\"; }\n\n.la.la-snowflake-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-snowflake-o:before {\n  content: \"\\f2dc\"; }\n\n.la.la-superpowers {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wpexplorer {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-spotify {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n","/*\n* Remix Icon v2.5.0\n* https://remixicon.com\n* https://github.com/Remix-Design/RemixIcon\n*\n* Copyright RemixIcon.com\n* Released under the Apache License Version 2.0\n*\n* Date: 2020-05-23\n*/\n@font-face {\n  font-family: \"remixicon\";\n  src: url('../../../fonts/remixicon.eot?t=1590207869815'); /* IE9*/\n  src: url('../../../fonts/remixicon.eot?t=1590207869815#iefix') format('embedded-opentype'), /* IE6-IE8 */\n  url(\"../../../fonts/remixicon.woff2?t=1590207869815\") format(\"woff2\"),\n  url(\"../../../fonts/remixicon.woff?t=1590207869815\") format(\"woff\"),\n  url('../../../fonts/remixicon.ttf?t=1590207869815') format('truetype'), /* chrome, firefox, opera, Safari, Android, iOS 4.2+*/\n  url('../../../fonts/remixicon.svg?t=1590207869815#remixicon') format('svg'); /* iOS 4.1- */\n  font-display: swap;\n}\n\n[class^=\"ri-\"], [class*=\" ri-\"] {\n  font-family: 'remixicon' !important;\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.ri-lg { font-size: 1.3333em; line-height: 0.75em; vertical-align: -.0667em; }\n.ri-xl { font-size: 1.5em; line-height: 0.6666em; vertical-align: -.075em; }\n.ri-xxs { font-size: .5em; }\n.ri-xs { font-size: .75em; }\n.ri-sm { font-size: .875em }\n.ri-1x { font-size: 1em; }\n.ri-2x { font-size: 2em; }\n.ri-3x { font-size: 3em; }\n.ri-4x { font-size: 4em; }\n.ri-5x { font-size: 5em; }\n.ri-6x { font-size: 6em; }\n.ri-7x { font-size: 7em; }\n.ri-8x { font-size: 8em; }\n.ri-9x { font-size: 9em; }\n.ri-10x { font-size: 10em; }\n.ri-fw { text-align: center; width: 1.25em; }\n\n.ri-24-hours-fill:before { content: \"\\ea01\"; }\n.ri-24-hours-line:before { content: \"\\ea02\"; }\n.ri-4k-fill:before { content: \"\\ea03\"; }\n.ri-4k-line:before { content: \"\\ea04\"; }\n.ri-a-b:before { content: \"\\ea05\"; }\n.ri-account-box-fill:before { content: \"\\ea06\"; }\n.ri-account-box-line:before { content: \"\\ea07\"; }\n.ri-account-circle-fill:before { content: \"\\ea08\"; }\n.ri-account-circle-line:before { content: \"\\ea09\"; }\n.ri-account-pin-box-fill:before { content: \"\\ea0a\"; }\n.ri-account-pin-box-line:before { content: \"\\ea0b\"; }\n.ri-account-pin-circle-fill:before { content: \"\\ea0c\"; }\n.ri-account-pin-circle-line:before { content: \"\\ea0d\"; }\n.ri-add-box-fill:before { content: \"\\ea0e\"; }\n.ri-add-box-line:before { content: \"\\ea0f\"; }\n.ri-add-circle-fill:before { content: \"\\ea10\"; }\n.ri-add-circle-line:before { content: \"\\ea11\"; }\n.ri-add-fill:before { content: \"\\ea12\"; }\n.ri-add-line:before { content: \"\\ea13\"; }\n.ri-admin-fill:before { content: \"\\ea14\"; }\n.ri-admin-line:before { content: \"\\ea15\"; }\n.ri-advertisement-fill:before { content: \"\\ea16\"; }\n.ri-advertisement-line:before { content: \"\\ea17\"; }\n.ri-airplay-fill:before { content: \"\\ea18\"; }\n.ri-airplay-line:before { content: \"\\ea19\"; }\n.ri-alarm-fill:before { content: \"\\ea1a\"; }\n.ri-alarm-line:before { content: \"\\ea1b\"; }\n.ri-alarm-warning-fill:before { content: \"\\ea1c\"; }\n.ri-alarm-warning-line:before { content: \"\\ea1d\"; }\n.ri-album-fill:before { content: \"\\ea1e\"; }\n.ri-album-line:before { content: \"\\ea1f\"; }\n.ri-alert-fill:before { content: \"\\ea20\"; }\n.ri-alert-line:before { content: \"\\ea21\"; }\n.ri-aliens-fill:before { content: \"\\ea22\"; }\n.ri-aliens-line:before { content: \"\\ea23\"; }\n.ri-align-bottom:before { content: \"\\ea24\"; }\n.ri-align-center:before { content: \"\\ea25\"; }\n.ri-align-justify:before { content: \"\\ea26\"; }\n.ri-align-left:before { content: \"\\ea27\"; }\n.ri-align-right:before { content: \"\\ea28\"; }\n.ri-align-top:before { content: \"\\ea29\"; }\n.ri-align-vertically:before { content: \"\\ea2a\"; }\n.ri-alipay-fill:before { content: \"\\ea2b\"; }\n.ri-alipay-line:before { content: \"\\ea2c\"; }\n.ri-amazon-fill:before { content: \"\\ea2d\"; }\n.ri-amazon-line:before { content: \"\\ea2e\"; }\n.ri-anchor-fill:before { content: \"\\ea2f\"; }\n.ri-anchor-line:before { content: \"\\ea30\"; }\n.ri-ancient-gate-fill:before { content: \"\\ea31\"; }\n.ri-ancient-gate-line:before { content: \"\\ea32\"; }\n.ri-ancient-pavilion-fill:before { content: \"\\ea33\"; }\n.ri-ancient-pavilion-line:before { content: \"\\ea34\"; }\n.ri-android-fill:before { content: \"\\ea35\"; }\n.ri-android-line:before { content: \"\\ea36\"; }\n.ri-angularjs-fill:before { content: \"\\ea37\"; }\n.ri-angularjs-line:before { content: \"\\ea38\"; }\n.ri-anticlockwise-2-fill:before { content: \"\\ea39\"; }\n.ri-anticlockwise-2-line:before { content: \"\\ea3a\"; }\n.ri-anticlockwise-fill:before { content: \"\\ea3b\"; }\n.ri-anticlockwise-line:before { content: \"\\ea3c\"; }\n.ri-app-store-fill:before { content: \"\\ea3d\"; }\n.ri-app-store-line:before { content: \"\\ea3e\"; }\n.ri-apple-fill:before { content: \"\\ea3f\"; }\n.ri-apple-line:before { content: \"\\ea40\"; }\n.ri-apps-2-fill:before { content: \"\\ea41\"; }\n.ri-apps-2-line:before { content: \"\\ea42\"; }\n.ri-apps-fill:before { content: \"\\ea43\"; }\n.ri-apps-line:before { content: \"\\ea44\"; }\n.ri-archive-drawer-fill:before { content: \"\\ea45\"; }\n.ri-archive-drawer-line:before { content: \"\\ea46\"; }\n.ri-archive-fill:before { content: \"\\ea47\"; }\n.ri-archive-line:before { content: \"\\ea48\"; }\n.ri-arrow-down-circle-fill:before { content: \"\\ea49\"; }\n.ri-arrow-down-circle-line:before { content: \"\\ea4a\"; }\n.ri-arrow-down-fill:before { content: \"\\ea4b\"; }\n.ri-arrow-down-line:before { content: \"\\ea4c\"; }\n.ri-arrow-down-s-fill:before { content: \"\\ea4d\"; }\n.ri-arrow-down-s-line:before { content: \"\\ea4e\"; }\n.ri-arrow-drop-down-fill:before { content: \"\\ea4f\"; }\n.ri-arrow-drop-down-line:before { content: \"\\ea50\"; }\n.ri-arrow-drop-left-fill:before { content: \"\\ea51\"; }\n.ri-arrow-drop-left-line:before { content: \"\\ea52\"; }\n.ri-arrow-drop-right-fill:before { content: \"\\ea53\"; }\n.ri-arrow-drop-right-line:before { content: \"\\ea54\"; }\n.ri-arrow-drop-up-fill:before { content: \"\\ea55\"; }\n.ri-arrow-drop-up-line:before { content: \"\\ea56\"; }\n.ri-arrow-go-back-fill:before { content: \"\\ea57\"; }\n.ri-arrow-go-back-line:before { content: \"\\ea58\"; }\n.ri-arrow-go-forward-fill:before { content: \"\\ea59\"; }\n.ri-arrow-go-forward-line:before { content: \"\\ea5a\"; }\n.ri-arrow-left-circle-fill:before { content: \"\\ea5b\"; }\n.ri-arrow-left-circle-line:before { content: \"\\ea5c\"; }\n.ri-arrow-left-down-fill:before { content: \"\\ea5d\"; }\n.ri-arrow-left-down-line:before { content: \"\\ea5e\"; }\n.ri-arrow-left-fill:before { content: \"\\ea5f\"; }\n.ri-arrow-left-line:before { content: \"\\ea60\"; }\n.ri-arrow-left-right-fill:before { content: \"\\ea61\"; }\n.ri-arrow-left-right-line:before { content: \"\\ea62\"; }\n.ri-arrow-left-s-fill:before { content: \"\\ea63\"; }\n.ri-arrow-left-s-line:before { content: \"\\ea64\"; }\n.ri-arrow-left-up-fill:before { content: \"\\ea65\"; }\n.ri-arrow-left-up-line:before { content: \"\\ea66\"; }\n.ri-arrow-right-circle-fill:before { content: \"\\ea67\"; }\n.ri-arrow-right-circle-line:before { content: \"\\ea68\"; }\n.ri-arrow-right-down-fill:before { content: \"\\ea69\"; }\n.ri-arrow-right-down-line:before { content: \"\\ea6a\"; }\n.ri-arrow-right-fill:before { content: \"\\ea6b\"; }\n.ri-arrow-right-line:before { content: \"\\ea6c\"; }\n.ri-arrow-right-s-fill:before { content: \"\\ea6d\"; }\n.ri-arrow-right-s-line:before { content: \"\\ea6e\"; }\n.ri-arrow-right-up-fill:before { content: \"\\ea6f\"; }\n.ri-arrow-right-up-line:before { content: \"\\ea70\"; }\n.ri-arrow-up-circle-fill:before { content: \"\\ea71\"; }\n.ri-arrow-up-circle-line:before { content: \"\\ea72\"; }\n.ri-arrow-up-down-fill:before { content: \"\\ea73\"; }\n.ri-arrow-up-down-line:before { content: \"\\ea74\"; }\n.ri-arrow-up-fill:before { content: \"\\ea75\"; }\n.ri-arrow-up-line:before { content: \"\\ea76\"; }\n.ri-arrow-up-s-fill:before { content: \"\\ea77\"; }\n.ri-arrow-up-s-line:before { content: \"\\ea78\"; }\n.ri-artboard-2-fill:before { content: \"\\ea79\"; }\n.ri-artboard-2-line:before { content: \"\\ea7a\"; }\n.ri-artboard-fill:before { content: \"\\ea7b\"; }\n.ri-artboard-line:before { content: \"\\ea7c\"; }\n.ri-article-fill:before { content: \"\\ea7d\"; }\n.ri-article-line:before { content: \"\\ea7e\"; }\n.ri-aspect-ratio-fill:before { content: \"\\ea7f\"; }\n.ri-aspect-ratio-line:before { content: \"\\ea80\"; }\n.ri-asterisk:before { content: \"\\ea81\"; }\n.ri-at-fill:before { content: \"\\ea82\"; }\n.ri-at-line:before { content: \"\\ea83\"; }\n.ri-attachment-2:before { content: \"\\ea84\"; }\n.ri-attachment-fill:before { content: \"\\ea85\"; }\n.ri-attachment-line:before { content: \"\\ea86\"; }\n.ri-auction-fill:before { content: \"\\ea87\"; }\n.ri-auction-line:before { content: \"\\ea88\"; }\n.ri-award-fill:before { content: \"\\ea89\"; }\n.ri-award-line:before { content: \"\\ea8a\"; }\n.ri-baidu-fill:before { content: \"\\ea8b\"; }\n.ri-baidu-line:before { content: \"\\ea8c\"; }\n.ri-ball-pen-fill:before { content: \"\\ea8d\"; }\n.ri-ball-pen-line:before { content: \"\\ea8e\"; }\n.ri-bank-card-2-fill:before { content: \"\\ea8f\"; }\n.ri-bank-card-2-line:before { content: \"\\ea90\"; }\n.ri-bank-card-fill:before { content: \"\\ea91\"; }\n.ri-bank-card-line:before { content: \"\\ea92\"; }\n.ri-bank-fill:before { content: \"\\ea93\"; }\n.ri-bank-line:before { content: \"\\ea94\"; }\n.ri-bar-chart-2-fill:before { content: \"\\ea95\"; }\n.ri-bar-chart-2-line:before { content: \"\\ea96\"; }\n.ri-bar-chart-box-fill:before { content: \"\\ea97\"; }\n.ri-bar-chart-box-line:before { content: \"\\ea98\"; }\n.ri-bar-chart-fill:before { content: \"\\ea99\"; }\n.ri-bar-chart-grouped-fill:before { content: \"\\ea9a\"; }\n.ri-bar-chart-grouped-line:before { content: \"\\ea9b\"; }\n.ri-bar-chart-horizontal-fill:before { content: \"\\ea9c\"; }\n.ri-bar-chart-horizontal-line:before { content: \"\\ea9d\"; }\n.ri-bar-chart-line:before { content: \"\\ea9e\"; }\n.ri-barcode-box-fill:before { content: \"\\ea9f\"; }\n.ri-barcode-box-line:before { content: \"\\eaa0\"; }\n.ri-barcode-fill:before { content: \"\\eaa1\"; }\n.ri-barcode-line:before { content: \"\\eaa2\"; }\n.ri-barricade-fill:before { content: \"\\eaa3\"; }\n.ri-barricade-line:before { content: \"\\eaa4\"; }\n.ri-base-station-fill:before { content: \"\\eaa5\"; }\n.ri-base-station-line:before { content: \"\\eaa6\"; }\n.ri-basketball-fill:before { content: \"\\eaa7\"; }\n.ri-basketball-line:before { content: \"\\eaa8\"; }\n.ri-battery-2-charge-fill:before { content: \"\\eaa9\"; }\n.ri-battery-2-charge-line:before { content: \"\\eaaa\"; }\n.ri-battery-2-fill:before { content: \"\\eaab\"; }\n.ri-battery-2-line:before { content: \"\\eaac\"; }\n.ri-battery-charge-fill:before { content: \"\\eaad\"; }\n.ri-battery-charge-line:before { content: \"\\eaae\"; }\n.ri-battery-fill:before { content: \"\\eaaf\"; }\n.ri-battery-line:before { content: \"\\eab0\"; }\n.ri-battery-low-fill:before { content: \"\\eab1\"; }\n.ri-battery-low-line:before { content: \"\\eab2\"; }\n.ri-battery-saver-fill:before { content: \"\\eab3\"; }\n.ri-battery-saver-line:before { content: \"\\eab4\"; }\n.ri-battery-share-fill:before { content: \"\\eab5\"; }\n.ri-battery-share-line:before { content: \"\\eab6\"; }\n.ri-bear-smile-fill:before { content: \"\\eab7\"; }\n.ri-bear-smile-line:before { content: \"\\eab8\"; }\n.ri-behance-fill:before { content: \"\\eab9\"; }\n.ri-behance-line:before { content: \"\\eaba\"; }\n.ri-bell-fill:before { content: \"\\eabb\"; }\n.ri-bell-line:before { content: \"\\eabc\"; }\n.ri-bike-fill:before { content: \"\\eabd\"; }\n.ri-bike-line:before { content: \"\\eabe\"; }\n.ri-bilibili-fill:before { content: \"\\eabf\"; }\n.ri-bilibili-line:before { content: \"\\eac0\"; }\n.ri-bill-fill:before { content: \"\\eac1\"; }\n.ri-bill-line:before { content: \"\\eac2\"; }\n.ri-billiards-fill:before { content: \"\\eac3\"; }\n.ri-billiards-line:before { content: \"\\eac4\"; }\n.ri-bit-coin-fill:before { content: \"\\eac5\"; }\n.ri-bit-coin-line:before { content: \"\\eac6\"; }\n.ri-blaze-fill:before { content: \"\\eac7\"; }\n.ri-blaze-line:before { content: \"\\eac8\"; }\n.ri-bluetooth-connect-fill:before { content: \"\\eac9\"; }\n.ri-bluetooth-connect-line:before { content: \"\\eaca\"; }\n.ri-bluetooth-fill:before { content: \"\\eacb\"; }\n.ri-bluetooth-line:before { content: \"\\eacc\"; }\n.ri-blur-off-fill:before { content: \"\\eacd\"; }\n.ri-blur-off-line:before { content: \"\\eace\"; }\n.ri-body-scan-fill:before { content: \"\\eacf\"; }\n.ri-body-scan-line:before { content: \"\\ead0\"; }\n.ri-bold:before { content: \"\\ead1\"; }\n.ri-book-2-fill:before { content: \"\\ead2\"; }\n.ri-book-2-line:before { content: \"\\ead3\"; }\n.ri-book-3-fill:before { content: \"\\ead4\"; }\n.ri-book-3-line:before { content: \"\\ead5\"; }\n.ri-book-fill:before { content: \"\\ead6\"; }\n.ri-book-line:before { content: \"\\ead7\"; }\n.ri-book-mark-fill:before { content: \"\\ead8\"; }\n.ri-book-mark-line:before { content: \"\\ead9\"; }\n.ri-book-open-fill:before { content: \"\\eada\"; }\n.ri-book-open-line:before { content: \"\\eadb\"; }\n.ri-book-read-fill:before { content: \"\\eadc\"; }\n.ri-book-read-line:before { content: \"\\eadd\"; }\n.ri-booklet-fill:before { content: \"\\eade\"; }\n.ri-booklet-line:before { content: \"\\eadf\"; }\n.ri-bookmark-2-fill:before { content: \"\\eae0\"; }\n.ri-bookmark-2-line:before { content: \"\\eae1\"; }\n.ri-bookmark-3-fill:before { content: \"\\eae2\"; }\n.ri-bookmark-3-line:before { content: \"\\eae3\"; }\n.ri-bookmark-fill:before { content: \"\\eae4\"; }\n.ri-bookmark-line:before { content: \"\\eae5\"; }\n.ri-boxing-fill:before { content: \"\\eae6\"; }\n.ri-boxing-line:before { content: \"\\eae7\"; }\n.ri-braces-fill:before { content: \"\\eae8\"; }\n.ri-braces-line:before { content: \"\\eae9\"; }\n.ri-brackets-fill:before { content: \"\\eaea\"; }\n.ri-brackets-line:before { content: \"\\eaeb\"; }\n.ri-briefcase-2-fill:before { content: \"\\eaec\"; }\n.ri-briefcase-2-line:before { content: \"\\eaed\"; }\n.ri-briefcase-3-fill:before { content: \"\\eaee\"; }\n.ri-briefcase-3-line:before { content: \"\\eaef\"; }\n.ri-briefcase-4-fill:before { content: \"\\eaf0\"; }\n.ri-briefcase-4-line:before { content: \"\\eaf1\"; }\n.ri-briefcase-5-fill:before { content: \"\\eaf2\"; }\n.ri-briefcase-5-line:before { content: \"\\eaf3\"; }\n.ri-briefcase-fill:before { content: \"\\eaf4\"; }\n.ri-briefcase-line:before { content: \"\\eaf5\"; }\n.ri-bring-forward:before { content: \"\\eaf6\"; }\n.ri-bring-to-front:before { content: \"\\eaf7\"; }\n.ri-broadcast-fill:before { content: \"\\eaf8\"; }\n.ri-broadcast-line:before { content: \"\\eaf9\"; }\n.ri-brush-2-fill:before { content: \"\\eafa\"; }\n.ri-brush-2-line:before { content: \"\\eafb\"; }\n.ri-brush-3-fill:before { content: \"\\eafc\"; }\n.ri-brush-3-line:before { content: \"\\eafd\"; }\n.ri-brush-4-fill:before { content: \"\\eafe\"; }\n.ri-brush-4-line:before { content: \"\\eaff\"; }\n.ri-brush-fill:before { content: \"\\eb00\"; }\n.ri-brush-line:before { content: \"\\eb01\"; }\n.ri-bubble-chart-fill:before { content: \"\\eb02\"; }\n.ri-bubble-chart-line:before { content: \"\\eb03\"; }\n.ri-bug-2-fill:before { content: \"\\eb04\"; }\n.ri-bug-2-line:before { content: \"\\eb05\"; }\n.ri-bug-fill:before { content: \"\\eb06\"; }\n.ri-bug-line:before { content: \"\\eb07\"; }\n.ri-building-2-fill:before { content: \"\\eb08\"; }\n.ri-building-2-line:before { content: \"\\eb09\"; }\n.ri-building-3-fill:before { content: \"\\eb0a\"; }\n.ri-building-3-line:before { content: \"\\eb0b\"; }\n.ri-building-4-fill:before { content: \"\\eb0c\"; }\n.ri-building-4-line:before { content: \"\\eb0d\"; }\n.ri-building-fill:before { content: \"\\eb0e\"; }\n.ri-building-line:before { content: \"\\eb0f\"; }\n.ri-bus-2-fill:before { content: \"\\eb10\"; }\n.ri-bus-2-line:before { content: \"\\eb11\"; }\n.ri-bus-fill:before { content: \"\\eb12\"; }\n.ri-bus-line:before { content: \"\\eb13\"; }\n.ri-bus-wifi-fill:before { content: \"\\eb14\"; }\n.ri-bus-wifi-line:before { content: \"\\eb15\"; }\n.ri-cactus-fill:before { content: \"\\eb16\"; }\n.ri-cactus-line:before { content: \"\\eb17\"; }\n.ri-cake-2-fill:before { content: \"\\eb18\"; }\n.ri-cake-2-line:before { content: \"\\eb19\"; }\n.ri-cake-3-fill:before { content: \"\\eb1a\"; }\n.ri-cake-3-line:before { content: \"\\eb1b\"; }\n.ri-cake-fill:before { content: \"\\eb1c\"; }\n.ri-cake-line:before { content: \"\\eb1d\"; }\n.ri-calculator-fill:before { content: \"\\eb1e\"; }\n.ri-calculator-line:before { content: \"\\eb1f\"; }\n.ri-calendar-2-fill:before { content: \"\\eb20\"; }\n.ri-calendar-2-line:before { content: \"\\eb21\"; }\n.ri-calendar-check-fill:before { content: \"\\eb22\"; }\n.ri-calendar-check-line:before { content: \"\\eb23\"; }\n.ri-calendar-event-fill:before { content: \"\\eb24\"; }\n.ri-calendar-event-line:before { content: \"\\eb25\"; }\n.ri-calendar-fill:before { content: \"\\eb26\"; }\n.ri-calendar-line:before { content: \"\\eb27\"; }\n.ri-calendar-todo-fill:before { content: \"\\eb28\"; }\n.ri-calendar-todo-line:before { content: \"\\eb29\"; }\n.ri-camera-2-fill:before { content: \"\\eb2a\"; }\n.ri-camera-2-line:before { content: \"\\eb2b\"; }\n.ri-camera-3-fill:before { content: \"\\eb2c\"; }\n.ri-camera-3-line:before { content: \"\\eb2d\"; }\n.ri-camera-fill:before { content: \"\\eb2e\"; }\n.ri-camera-lens-fill:before { content: \"\\eb2f\"; }\n.ri-camera-lens-line:before { content: \"\\eb30\"; }\n.ri-camera-line:before { content: \"\\eb31\"; }\n.ri-camera-off-fill:before { content: \"\\eb32\"; }\n.ri-camera-off-line:before { content: \"\\eb33\"; }\n.ri-camera-switch-fill:before { content: \"\\eb34\"; }\n.ri-camera-switch-line:before { content: \"\\eb35\"; }\n.ri-capsule-fill:before { content: \"\\eb36\"; }\n.ri-capsule-line:before { content: \"\\eb37\"; }\n.ri-car-fill:before { content: \"\\eb38\"; }\n.ri-car-line:before { content: \"\\eb39\"; }\n.ri-car-washing-fill:before { content: \"\\eb3a\"; }\n.ri-car-washing-line:before { content: \"\\eb3b\"; }\n.ri-caravan-fill:before { content: \"\\eb3c\"; }\n.ri-caravan-line:before { content: \"\\eb3d\"; }\n.ri-cast-fill:before { content: \"\\eb3e\"; }\n.ri-cast-line:before { content: \"\\eb3f\"; }\n.ri-cellphone-fill:before { content: \"\\eb40\"; }\n.ri-cellphone-line:before { content: \"\\eb41\"; }\n.ri-celsius-fill:before { content: \"\\eb42\"; }\n.ri-celsius-line:before { content: \"\\eb43\"; }\n.ri-centos-fill:before { content: \"\\eb44\"; }\n.ri-centos-line:before { content: \"\\eb45\"; }\n.ri-character-recognition-fill:before { content: \"\\eb46\"; }\n.ri-character-recognition-line:before { content: \"\\eb47\"; }\n.ri-charging-pile-2-fill:before { content: \"\\eb48\"; }\n.ri-charging-pile-2-line:before { content: \"\\eb49\"; }\n.ri-charging-pile-fill:before { content: \"\\eb4a\"; }\n.ri-charging-pile-line:before { content: \"\\eb4b\"; }\n.ri-chat-1-fill:before { content: \"\\eb4c\"; }\n.ri-chat-1-line:before { content: \"\\eb4d\"; }\n.ri-chat-2-fill:before { content: \"\\eb4e\"; }\n.ri-chat-2-line:before { content: \"\\eb4f\"; }\n.ri-chat-3-fill:before { content: \"\\eb50\"; }\n.ri-chat-3-line:before { content: \"\\eb51\"; }\n.ri-chat-4-fill:before { content: \"\\eb52\"; }\n.ri-chat-4-line:before { content: \"\\eb53\"; }\n.ri-chat-check-fill:before { content: \"\\eb54\"; }\n.ri-chat-check-line:before { content: \"\\eb55\"; }\n.ri-chat-delete-fill:before { content: \"\\eb56\"; }\n.ri-chat-delete-line:before { content: \"\\eb57\"; }\n.ri-chat-download-fill:before { content: \"\\eb58\"; }\n.ri-chat-download-line:before { content: \"\\eb59\"; }\n.ri-chat-follow-up-fill:before { content: \"\\eb5a\"; }\n.ri-chat-follow-up-line:before { content: \"\\eb5b\"; }\n.ri-chat-forward-fill:before { content: \"\\eb5c\"; }\n.ri-chat-forward-line:before { content: \"\\eb5d\"; }\n.ri-chat-heart-fill:before { content: \"\\eb5e\"; }\n.ri-chat-heart-line:before { content: \"\\eb5f\"; }\n.ri-chat-history-fill:before { content: \"\\eb60\"; }\n.ri-chat-history-line:before { content: \"\\eb61\"; }\n.ri-chat-new-fill:before { content: \"\\eb62\"; }\n.ri-chat-new-line:before { content: \"\\eb63\"; }\n.ri-chat-off-fill:before { content: \"\\eb64\"; }\n.ri-chat-off-line:before { content: \"\\eb65\"; }\n.ri-chat-poll-fill:before { content: \"\\eb66\"; }\n.ri-chat-poll-line:before { content: \"\\eb67\"; }\n.ri-chat-private-fill:before { content: \"\\eb68\"; }\n.ri-chat-private-line:before { content: \"\\eb69\"; }\n.ri-chat-quote-fill:before { content: \"\\eb6a\"; }\n.ri-chat-quote-line:before { content: \"\\eb6b\"; }\n.ri-chat-settings-fill:before { content: \"\\eb6c\"; }\n.ri-chat-settings-line:before { content: \"\\eb6d\"; }\n.ri-chat-smile-2-fill:before { content: \"\\eb6e\"; }\n.ri-chat-smile-2-line:before { content: \"\\eb6f\"; }\n.ri-chat-smile-3-fill:before { content: \"\\eb70\"; }\n.ri-chat-smile-3-line:before { content: \"\\eb71\"; }\n.ri-chat-smile-fill:before { content: \"\\eb72\"; }\n.ri-chat-smile-line:before { content: \"\\eb73\"; }\n.ri-chat-upload-fill:before { content: \"\\eb74\"; }\n.ri-chat-upload-line:before { content: \"\\eb75\"; }\n.ri-chat-voice-fill:before { content: \"\\eb76\"; }\n.ri-chat-voice-line:before { content: \"\\eb77\"; }\n.ri-check-double-fill:before { content: \"\\eb78\"; }\n.ri-check-double-line:before { content: \"\\eb79\"; }\n.ri-check-fill:before { content: \"\\eb7a\"; }\n.ri-check-line:before { content: \"\\eb7b\"; }\n.ri-checkbox-blank-circle-fill:before { content: \"\\eb7c\"; }\n.ri-checkbox-blank-circle-line:before { content: \"\\eb7d\"; }\n.ri-checkbox-blank-fill:before { content: \"\\eb7e\"; }\n.ri-checkbox-blank-line:before { content: \"\\eb7f\"; }\n.ri-checkbox-circle-fill:before { content: \"\\eb80\"; }\n.ri-checkbox-circle-line:before { content: \"\\eb81\"; }\n.ri-checkbox-fill:before { content: \"\\eb82\"; }\n.ri-checkbox-indeterminate-fill:before { content: \"\\eb83\"; }\n.ri-checkbox-indeterminate-line:before { content: \"\\eb84\"; }\n.ri-checkbox-line:before { content: \"\\eb85\"; }\n.ri-checkbox-multiple-blank-fill:before { content: \"\\eb86\"; }\n.ri-checkbox-multiple-blank-line:before { content: \"\\eb87\"; }\n.ri-checkbox-multiple-fill:before { content: \"\\eb88\"; }\n.ri-checkbox-multiple-line:before { content: \"\\eb89\"; }\n.ri-china-railway-fill:before { content: \"\\eb8a\"; }\n.ri-china-railway-line:before { content: \"\\eb8b\"; }\n.ri-chrome-fill:before { content: \"\\eb8c\"; }\n.ri-chrome-line:before { content: \"\\eb8d\"; }\n.ri-clapperboard-fill:before { content: \"\\eb8e\"; }\n.ri-clapperboard-line:before { content: \"\\eb8f\"; }\n.ri-clipboard-fill:before { content: \"\\eb90\"; }\n.ri-clipboard-line:before { content: \"\\eb91\"; }\n.ri-clockwise-2-fill:before { content: \"\\eb92\"; }\n.ri-clockwise-2-line:before { content: \"\\eb93\"; }\n.ri-clockwise-fill:before { content: \"\\eb94\"; }\n.ri-clockwise-line:before { content: \"\\eb95\"; }\n.ri-close-circle-fill:before { content: \"\\eb96\"; }\n.ri-close-circle-line:before { content: \"\\eb97\"; }\n.ri-close-fill:before { content: \"\\eb98\"; }\n.ri-close-line:before { content: \"\\eb99\"; }\n.ri-closed-captioning-fill:before { content: \"\\eb9a\"; }\n.ri-closed-captioning-line:before { content: \"\\eb9b\"; }\n.ri-cloud-fill:before { content: \"\\eb9c\"; }\n.ri-cloud-line:before { content: \"\\eb9d\"; }\n.ri-cloud-off-fill:before { content: \"\\eb9e\"; }\n.ri-cloud-off-line:before { content: \"\\eb9f\"; }\n.ri-cloud-windy-fill:before { content: \"\\eba0\"; }\n.ri-cloud-windy-line:before { content: \"\\eba1\"; }\n.ri-cloudy-2-fill:before { content: \"\\eba2\"; }\n.ri-cloudy-2-line:before { content: \"\\eba3\"; }\n.ri-cloudy-fill:before { content: \"\\eba4\"; }\n.ri-cloudy-line:before { content: \"\\eba5\"; }\n.ri-code-box-fill:before { content: \"\\eba6\"; }\n.ri-code-box-line:before { content: \"\\eba7\"; }\n.ri-code-fill:before { content: \"\\eba8\"; }\n.ri-code-line:before { content: \"\\eba9\"; }\n.ri-code-s-fill:before { content: \"\\ebaa\"; }\n.ri-code-s-line:before { content: \"\\ebab\"; }\n.ri-code-s-slash-fill:before { content: \"\\ebac\"; }\n.ri-code-s-slash-line:before { content: \"\\ebad\"; }\n.ri-code-view:before { content: \"\\ebae\"; }\n.ri-codepen-fill:before { content: \"\\ebaf\"; }\n.ri-codepen-line:before { content: \"\\ebb0\"; }\n.ri-coin-fill:before { content: \"\\ebb1\"; }\n.ri-coin-line:before { content: \"\\ebb2\"; }\n.ri-coins-fill:before { content: \"\\ebb3\"; }\n.ri-coins-line:before { content: \"\\ebb4\"; }\n.ri-collage-fill:before { content: \"\\ebb5\"; }\n.ri-collage-line:before { content: \"\\ebb6\"; }\n.ri-command-fill:before { content: \"\\ebb7\"; }\n.ri-command-line:before { content: \"\\ebb8\"; }\n.ri-community-fill:before { content: \"\\ebb9\"; }\n.ri-community-line:before { content: \"\\ebba\"; }\n.ri-compass-2-fill:before { content: \"\\ebbb\"; }\n.ri-compass-2-line:before { content: \"\\ebbc\"; }\n.ri-compass-3-fill:before { content: \"\\ebbd\"; }\n.ri-compass-3-line:before { content: \"\\ebbe\"; }\n.ri-compass-4-fill:before { content: \"\\ebbf\"; }\n.ri-compass-4-line:before { content: \"\\ebc0\"; }\n.ri-compass-discover-fill:before { content: \"\\ebc1\"; }\n.ri-compass-discover-line:before { content: \"\\ebc2\"; }\n.ri-compass-fill:before { content: \"\\ebc3\"; }\n.ri-compass-line:before { content: \"\\ebc4\"; }\n.ri-compasses-2-fill:before { content: \"\\ebc5\"; }\n.ri-compasses-2-line:before { content: \"\\ebc6\"; }\n.ri-compasses-fill:before { content: \"\\ebc7\"; }\n.ri-compasses-line:before { content: \"\\ebc8\"; }\n.ri-computer-fill:before { content: \"\\ebc9\"; }\n.ri-computer-line:before { content: \"\\ebca\"; }\n.ri-contacts-book-2-fill:before { content: \"\\ebcb\"; }\n.ri-contacts-book-2-line:before { content: \"\\ebcc\"; }\n.ri-contacts-book-fill:before { content: \"\\ebcd\"; }\n.ri-contacts-book-line:before { content: \"\\ebce\"; }\n.ri-contacts-book-upload-fill:before { content: \"\\ebcf\"; }\n.ri-contacts-book-upload-line:before { content: \"\\ebd0\"; }\n.ri-contacts-fill:before { content: \"\\ebd1\"; }\n.ri-contacts-line:before { content: \"\\ebd2\"; }\n.ri-contrast-2-fill:before { content: \"\\ebd3\"; }\n.ri-contrast-2-line:before { content: \"\\ebd4\"; }\n.ri-contrast-drop-2-fill:before { content: \"\\ebd5\"; }\n.ri-contrast-drop-2-line:before { content: \"\\ebd6\"; }\n.ri-contrast-drop-fill:before { content: \"\\ebd7\"; }\n.ri-contrast-drop-line:before { content: \"\\ebd8\"; }\n.ri-contrast-fill:before { content: \"\\ebd9\"; }\n.ri-contrast-line:before { content: \"\\ebda\"; }\n.ri-copper-coin-fill:before { content: \"\\ebdb\"; }\n.ri-copper-coin-line:before { content: \"\\ebdc\"; }\n.ri-copper-diamond-fill:before { content: \"\\ebdd\"; }\n.ri-copper-diamond-line:before { content: \"\\ebde\"; }\n.ri-copyleft-fill:before { content: \"\\ebdf\"; }\n.ri-copyleft-line:before { content: \"\\ebe0\"; }\n.ri-copyright-fill:before { content: \"\\ebe1\"; }\n.ri-copyright-line:before { content: \"\\ebe2\"; }\n.ri-coreos-fill:before { content: \"\\ebe3\"; }\n.ri-coreos-line:before { content: \"\\ebe4\"; }\n.ri-coupon-2-fill:before { content: \"\\ebe5\"; }\n.ri-coupon-2-line:before { content: \"\\ebe6\"; }\n.ri-coupon-3-fill:before { content: \"\\ebe7\"; }\n.ri-coupon-3-line:before { content: \"\\ebe8\"; }\n.ri-coupon-4-fill:before { content: \"\\ebe9\"; }\n.ri-coupon-4-line:before { content: \"\\ebea\"; }\n.ri-coupon-5-fill:before { content: \"\\ebeb\"; }\n.ri-coupon-5-line:before { content: \"\\ebec\"; }\n.ri-coupon-fill:before { content: \"\\ebed\"; }\n.ri-coupon-line:before { content: \"\\ebee\"; }\n.ri-cpu-fill:before { content: \"\\ebef\"; }\n.ri-cpu-line:before { content: \"\\ebf0\"; }\n.ri-creative-commons-by-fill:before { content: \"\\ebf1\"; }\n.ri-creative-commons-by-line:before { content: \"\\ebf2\"; }\n.ri-creative-commons-fill:before { content: \"\\ebf3\"; }\n.ri-creative-commons-line:before { content: \"\\ebf4\"; }\n.ri-creative-commons-nc-fill:before { content: \"\\ebf5\"; }\n.ri-creative-commons-nc-line:before { content: \"\\ebf6\"; }\n.ri-creative-commons-nd-fill:before { content: \"\\ebf7\"; }\n.ri-creative-commons-nd-line:before { content: \"\\ebf8\"; }\n.ri-creative-commons-sa-fill:before { content: \"\\ebf9\"; }\n.ri-creative-commons-sa-line:before { content: \"\\ebfa\"; }\n.ri-creative-commons-zero-fill:before { content: \"\\ebfb\"; }\n.ri-creative-commons-zero-line:before { content: \"\\ebfc\"; }\n.ri-criminal-fill:before { content: \"\\ebfd\"; }\n.ri-criminal-line:before { content: \"\\ebfe\"; }\n.ri-crop-2-fill:before { content: \"\\ebff\"; }\n.ri-crop-2-line:before { content: \"\\ec00\"; }\n.ri-crop-fill:before { content: \"\\ec01\"; }\n.ri-crop-line:before { content: \"\\ec02\"; }\n.ri-css3-fill:before { content: \"\\ec03\"; }\n.ri-css3-line:before { content: \"\\ec04\"; }\n.ri-cup-fill:before { content: \"\\ec05\"; }\n.ri-cup-line:before { content: \"\\ec06\"; }\n.ri-currency-fill:before { content: \"\\ec07\"; }\n.ri-currency-line:before { content: \"\\ec08\"; }\n.ri-cursor-fill:before { content: \"\\ec09\"; }\n.ri-cursor-line:before { content: \"\\ec0a\"; }\n.ri-customer-service-2-fill:before { content: \"\\ec0b\"; }\n.ri-customer-service-2-line:before { content: \"\\ec0c\"; }\n.ri-customer-service-fill:before { content: \"\\ec0d\"; }\n.ri-customer-service-line:before { content: \"\\ec0e\"; }\n.ri-dashboard-2-fill:before { content: \"\\ec0f\"; }\n.ri-dashboard-2-line:before { content: \"\\ec10\"; }\n.ri-dashboard-3-fill:before { content: \"\\ec11\"; }\n.ri-dashboard-3-line:before { content: \"\\ec12\"; }\n.ri-dashboard-fill:before { content: \"\\ec13\"; }\n.ri-dashboard-line:before { content: \"\\ec14\"; }\n.ri-database-2-fill:before { content: \"\\ec15\"; }\n.ri-database-2-line:before { content: \"\\ec16\"; }\n.ri-database-fill:before { content: \"\\ec17\"; }\n.ri-database-line:before { content: \"\\ec18\"; }\n.ri-delete-back-2-fill:before { content: \"\\ec19\"; }\n.ri-delete-back-2-line:before { content: \"\\ec1a\"; }\n.ri-delete-back-fill:before { content: \"\\ec1b\"; }\n.ri-delete-back-line:before { content: \"\\ec1c\"; }\n.ri-delete-bin-2-fill:before { content: \"\\ec1d\"; }\n.ri-delete-bin-2-line:before { content: \"\\ec1e\"; }\n.ri-delete-bin-3-fill:before { content: \"\\ec1f\"; }\n.ri-delete-bin-3-line:before { content: \"\\ec20\"; }\n.ri-delete-bin-4-fill:before { content: \"\\ec21\"; }\n.ri-delete-bin-4-line:before { content: \"\\ec22\"; }\n.ri-delete-bin-5-fill:before { content: \"\\ec23\"; }\n.ri-delete-bin-5-line:before { content: \"\\ec24\"; }\n.ri-delete-bin-6-fill:before { content: \"\\ec25\"; }\n.ri-delete-bin-6-line:before { content: \"\\ec26\"; }\n.ri-delete-bin-7-fill:before { content: \"\\ec27\"; }\n.ri-delete-bin-7-line:before { content: \"\\ec28\"; }\n.ri-delete-bin-fill:before { content: \"\\ec29\"; }\n.ri-delete-bin-line:before { content: \"\\ec2a\"; }\n.ri-delete-column:before { content: \"\\ec2b\"; }\n.ri-delete-row:before { content: \"\\ec2c\"; }\n.ri-device-fill:before { content: \"\\ec2d\"; }\n.ri-device-line:before { content: \"\\ec2e\"; }\n.ri-device-recover-fill:before { content: \"\\ec2f\"; }\n.ri-device-recover-line:before { content: \"\\ec30\"; }\n.ri-dingding-fill:before { content: \"\\ec31\"; }\n.ri-dingding-line:before { content: \"\\ec32\"; }\n.ri-direction-fill:before { content: \"\\ec33\"; }\n.ri-direction-line:before { content: \"\\ec34\"; }\n.ri-disc-fill:before { content: \"\\ec35\"; }\n.ri-disc-line:before { content: \"\\ec36\"; }\n.ri-discord-fill:before { content: \"\\ec37\"; }\n.ri-discord-line:before { content: \"\\ec38\"; }\n.ri-discuss-fill:before { content: \"\\ec39\"; }\n.ri-discuss-line:before { content: \"\\ec3a\"; }\n.ri-dislike-fill:before { content: \"\\ec3b\"; }\n.ri-dislike-line:before { content: \"\\ec3c\"; }\n.ri-disqus-fill:before { content: \"\\ec3d\"; }\n.ri-disqus-line:before { content: \"\\ec3e\"; }\n.ri-divide-fill:before { content: \"\\ec3f\"; }\n.ri-divide-line:before { content: \"\\ec40\"; }\n.ri-donut-chart-fill:before { content: \"\\ec41\"; }\n.ri-donut-chart-line:before { content: \"\\ec42\"; }\n.ri-door-closed-fill:before { content: \"\\ec43\"; }\n.ri-door-closed-line:before { content: \"\\ec44\"; }\n.ri-door-fill:before { content: \"\\ec45\"; }\n.ri-door-line:before { content: \"\\ec46\"; }\n.ri-door-lock-box-fill:before { content: \"\\ec47\"; }\n.ri-door-lock-box-line:before { content: \"\\ec48\"; }\n.ri-door-lock-fill:before { content: \"\\ec49\"; }\n.ri-door-lock-line:before { content: \"\\ec4a\"; }\n.ri-door-open-fill:before { content: \"\\ec4b\"; }\n.ri-door-open-line:before { content: \"\\ec4c\"; }\n.ri-dossier-fill:before { content: \"\\ec4d\"; }\n.ri-dossier-line:before { content: \"\\ec4e\"; }\n.ri-douban-fill:before { content: \"\\ec4f\"; }\n.ri-douban-line:before { content: \"\\ec50\"; }\n.ri-double-quotes-l:before { content: \"\\ec51\"; }\n.ri-double-quotes-r:before { content: \"\\ec52\"; }\n.ri-download-2-fill:before { content: \"\\ec53\"; }\n.ri-download-2-line:before { content: \"\\ec54\"; }\n.ri-download-cloud-2-fill:before { content: \"\\ec55\"; }\n.ri-download-cloud-2-line:before { content: \"\\ec56\"; }\n.ri-download-cloud-fill:before { content: \"\\ec57\"; }\n.ri-download-cloud-line:before { content: \"\\ec58\"; }\n.ri-download-fill:before { content: \"\\ec59\"; }\n.ri-download-line:before { content: \"\\ec5a\"; }\n.ri-draft-fill:before { content: \"\\ec5b\"; }\n.ri-draft-line:before { content: \"\\ec5c\"; }\n.ri-drag-drop-fill:before { content: \"\\ec5d\"; }\n.ri-drag-drop-line:before { content: \"\\ec5e\"; }\n.ri-drag-move-2-fill:before { content: \"\\ec5f\"; }\n.ri-drag-move-2-line:before { content: \"\\ec60\"; }\n.ri-drag-move-fill:before { content: \"\\ec61\"; }\n.ri-drag-move-line:before { content: \"\\ec62\"; }\n.ri-dribbble-fill:before { content: \"\\ec63\"; }\n.ri-dribbble-line:before { content: \"\\ec64\"; }\n.ri-drive-fill:before { content: \"\\ec65\"; }\n.ri-drive-line:before { content: \"\\ec66\"; }\n.ri-drizzle-fill:before { content: \"\\ec67\"; }\n.ri-drizzle-line:before { content: \"\\ec68\"; }\n.ri-drop-fill:before { content: \"\\ec69\"; }\n.ri-drop-line:before { content: \"\\ec6a\"; }\n.ri-dropbox-fill:before { content: \"\\ec6b\"; }\n.ri-dropbox-line:before { content: \"\\ec6c\"; }\n.ri-dual-sim-1-fill:before { content: \"\\ec6d\"; }\n.ri-dual-sim-1-line:before { content: \"\\ec6e\"; }\n.ri-dual-sim-2-fill:before { content: \"\\ec6f\"; }\n.ri-dual-sim-2-line:before { content: \"\\ec70\"; }\n.ri-dv-fill:before { content: \"\\ec71\"; }\n.ri-dv-line:before { content: \"\\ec72\"; }\n.ri-dvd-fill:before { content: \"\\ec73\"; }\n.ri-dvd-line:before { content: \"\\ec74\"; }\n.ri-e-bike-2-fill:before { content: \"\\ec75\"; }\n.ri-e-bike-2-line:before { content: \"\\ec76\"; }\n.ri-e-bike-fill:before { content: \"\\ec77\"; }\n.ri-e-bike-line:before { content: \"\\ec78\"; }\n.ri-earth-fill:before { content: \"\\ec79\"; }\n.ri-earth-line:before { content: \"\\ec7a\"; }\n.ri-earthquake-fill:before { content: \"\\ec7b\"; }\n.ri-earthquake-line:before { content: \"\\ec7c\"; }\n.ri-edge-fill:before { content: \"\\ec7d\"; }\n.ri-edge-line:before { content: \"\\ec7e\"; }\n.ri-edit-2-fill:before { content: \"\\ec7f\"; }\n.ri-edit-2-line:before { content: \"\\ec80\"; }\n.ri-edit-box-fill:before { content: \"\\ec81\"; }\n.ri-edit-box-line:before { content: \"\\ec82\"; }\n.ri-edit-circle-fill:before { content: \"\\ec83\"; }\n.ri-edit-circle-line:before { content: \"\\ec84\"; }\n.ri-edit-fill:before { content: \"\\ec85\"; }\n.ri-edit-line:before { content: \"\\ec86\"; }\n.ri-eject-fill:before { content: \"\\ec87\"; }\n.ri-eject-line:before { content: \"\\ec88\"; }\n.ri-emotion-2-fill:before { content: \"\\ec89\"; }\n.ri-emotion-2-line:before { content: \"\\ec8a\"; }\n.ri-emotion-fill:before { content: \"\\ec8b\"; }\n.ri-emotion-happy-fill:before { content: \"\\ec8c\"; }\n.ri-emotion-happy-line:before { content: \"\\ec8d\"; }\n.ri-emotion-laugh-fill:before { content: \"\\ec8e\"; }\n.ri-emotion-laugh-line:before { content: \"\\ec8f\"; }\n.ri-emotion-line:before { content: \"\\ec90\"; }\n.ri-emotion-normal-fill:before { content: \"\\ec91\"; }\n.ri-emotion-normal-line:before { content: \"\\ec92\"; }\n.ri-emotion-sad-fill:before { content: \"\\ec93\"; }\n.ri-emotion-sad-line:before { content: \"\\ec94\"; }\n.ri-emotion-unhappy-fill:before { content: \"\\ec95\"; }\n.ri-emotion-unhappy-line:before { content: \"\\ec96\"; }\n.ri-empathize-fill:before { content: \"\\ec97\"; }\n.ri-empathize-line:before { content: \"\\ec98\"; }\n.ri-emphasis-cn:before { content: \"\\ec99\"; }\n.ri-emphasis:before { content: \"\\ec9a\"; }\n.ri-english-input:before { content: \"\\ec9b\"; }\n.ri-equalizer-fill:before { content: \"\\ec9c\"; }\n.ri-equalizer-line:before { content: \"\\ec9d\"; }\n.ri-eraser-fill:before { content: \"\\ec9e\"; }\n.ri-eraser-line:before { content: \"\\ec9f\"; }\n.ri-error-warning-fill:before { content: \"\\eca0\"; }\n.ri-error-warning-line:before { content: \"\\eca1\"; }\n.ri-evernote-fill:before { content: \"\\eca2\"; }\n.ri-evernote-line:before { content: \"\\eca3\"; }\n.ri-exchange-box-fill:before { content: \"\\eca4\"; }\n.ri-exchange-box-line:before { content: \"\\eca5\"; }\n.ri-exchange-cny-fill:before { content: \"\\eca6\"; }\n.ri-exchange-cny-line:before { content: \"\\eca7\"; }\n.ri-exchange-dollar-fill:before { content: \"\\eca8\"; }\n.ri-exchange-dollar-line:before { content: \"\\eca9\"; }\n.ri-exchange-fill:before { content: \"\\ecaa\"; }\n.ri-exchange-funds-fill:before { content: \"\\ecab\"; }\n.ri-exchange-funds-line:before { content: \"\\ecac\"; }\n.ri-exchange-line:before { content: \"\\ecad\"; }\n.ri-external-link-fill:before { content: \"\\ecae\"; }\n.ri-external-link-line:before { content: \"\\ecaf\"; }\n.ri-eye-2-fill:before { content: \"\\ecb0\"; }\n.ri-eye-2-line:before { content: \"\\ecb1\"; }\n.ri-eye-close-fill:before { content: \"\\ecb2\"; }\n.ri-eye-close-line:before { content: \"\\ecb3\"; }\n.ri-eye-fill:before { content: \"\\ecb4\"; }\n.ri-eye-line:before { content: \"\\ecb5\"; }\n.ri-eye-off-fill:before { content: \"\\ecb6\"; }\n.ri-eye-off-line:before { content: \"\\ecb7\"; }\n.ri-facebook-box-fill:before { content: \"\\ecb8\"; }\n.ri-facebook-box-line:before { content: \"\\ecb9\"; }\n.ri-facebook-circle-fill:before { content: \"\\ecba\"; }\n.ri-facebook-circle-line:before { content: \"\\ecbb\"; }\n.ri-facebook-fill:before { content: \"\\ecbc\"; }\n.ri-facebook-line:before { content: \"\\ecbd\"; }\n.ri-fahrenheit-fill:before { content: \"\\ecbe\"; }\n.ri-fahrenheit-line:before { content: \"\\ecbf\"; }\n.ri-feedback-fill:before { content: \"\\ecc0\"; }\n.ri-feedback-line:before { content: \"\\ecc1\"; }\n.ri-file-2-fill:before { content: \"\\ecc2\"; }\n.ri-file-2-line:before { content: \"\\ecc3\"; }\n.ri-file-3-fill:before { content: \"\\ecc4\"; }\n.ri-file-3-line:before { content: \"\\ecc5\"; }\n.ri-file-4-fill:before { content: \"\\ecc6\"; }\n.ri-file-4-line:before { content: \"\\ecc7\"; }\n.ri-file-add-fill:before { content: \"\\ecc8\"; }\n.ri-file-add-line:before { content: \"\\ecc9\"; }\n.ri-file-chart-2-fill:before { content: \"\\ecca\"; }\n.ri-file-chart-2-line:before { content: \"\\eccb\"; }\n.ri-file-chart-fill:before { content: \"\\eccc\"; }\n.ri-file-chart-line:before { content: \"\\eccd\"; }\n.ri-file-cloud-fill:before { content: \"\\ecce\"; }\n.ri-file-cloud-line:before { content: \"\\eccf\"; }\n.ri-file-code-fill:before { content: \"\\ecd0\"; }\n.ri-file-code-line:before { content: \"\\ecd1\"; }\n.ri-file-copy-2-fill:before { content: \"\\ecd2\"; }\n.ri-file-copy-2-line:before { content: \"\\ecd3\"; }\n.ri-file-copy-fill:before { content: \"\\ecd4\"; }\n.ri-file-copy-line:before { content: \"\\ecd5\"; }\n.ri-file-damage-fill:before { content: \"\\ecd6\"; }\n.ri-file-damage-line:before { content: \"\\ecd7\"; }\n.ri-file-download-fill:before { content: \"\\ecd8\"; }\n.ri-file-download-line:before { content: \"\\ecd9\"; }\n.ri-file-edit-fill:before { content: \"\\ecda\"; }\n.ri-file-edit-line:before { content: \"\\ecdb\"; }\n.ri-file-excel-2-fill:before { content: \"\\ecdc\"; }\n.ri-file-excel-2-line:before { content: \"\\ecdd\"; }\n.ri-file-excel-fill:before { content: \"\\ecde\"; }\n.ri-file-excel-line:before { content: \"\\ecdf\"; }\n.ri-file-fill:before { content: \"\\ece0\"; }\n.ri-file-forbid-fill:before { content: \"\\ece1\"; }\n.ri-file-forbid-line:before { content: \"\\ece2\"; }\n.ri-file-gif-fill:before { content: \"\\ece3\"; }\n.ri-file-gif-line:before { content: \"\\ece4\"; }\n.ri-file-history-fill:before { content: \"\\ece5\"; }\n.ri-file-history-line:before { content: \"\\ece6\"; }\n.ri-file-hwp-fill:before { content: \"\\ece7\"; }\n.ri-file-hwp-line:before { content: \"\\ece8\"; }\n.ri-file-info-fill:before { content: \"\\ece9\"; }\n.ri-file-info-line:before { content: \"\\ecea\"; }\n.ri-file-line:before { content: \"\\eceb\"; }\n.ri-file-list-2-fill:before { content: \"\\ecec\"; }\n.ri-file-list-2-line:before { content: \"\\eced\"; }\n.ri-file-list-3-fill:before { content: \"\\ecee\"; }\n.ri-file-list-3-line:before { content: \"\\ecef\"; }\n.ri-file-list-fill:before { content: \"\\ecf0\"; }\n.ri-file-list-line:before { content: \"\\ecf1\"; }\n.ri-file-lock-fill:before { content: \"\\ecf2\"; }\n.ri-file-lock-line:before { content: \"\\ecf3\"; }\n.ri-file-mark-fill:before { content: \"\\ecf4\"; }\n.ri-file-mark-line:before { content: \"\\ecf5\"; }\n.ri-file-music-fill:before { content: \"\\ecf6\"; }\n.ri-file-music-line:before { content: \"\\ecf7\"; }\n.ri-file-paper-2-fill:before { content: \"\\ecf8\"; }\n.ri-file-paper-2-line:before { content: \"\\ecf9\"; }\n.ri-file-paper-fill:before { content: \"\\ecfa\"; }\n.ri-file-paper-line:before { content: \"\\ecfb\"; }\n.ri-file-pdf-fill:before { content: \"\\ecfc\"; }\n.ri-file-pdf-line:before { content: \"\\ecfd\"; }\n.ri-file-ppt-2-fill:before { content: \"\\ecfe\"; }\n.ri-file-ppt-2-line:before { content: \"\\ecff\"; }\n.ri-file-ppt-fill:before { content: \"\\ed00\"; }\n.ri-file-ppt-line:before { content: \"\\ed01\"; }\n.ri-file-reduce-fill:before { content: \"\\ed02\"; }\n.ri-file-reduce-line:before { content: \"\\ed03\"; }\n.ri-file-search-fill:before { content: \"\\ed04\"; }\n.ri-file-search-line:before { content: \"\\ed05\"; }\n.ri-file-settings-fill:before { content: \"\\ed06\"; }\n.ri-file-settings-line:before { content: \"\\ed07\"; }\n.ri-file-shield-2-fill:before { content: \"\\ed08\"; }\n.ri-file-shield-2-line:before { content: \"\\ed09\"; }\n.ri-file-shield-fill:before { content: \"\\ed0a\"; }\n.ri-file-shield-line:before { content: \"\\ed0b\"; }\n.ri-file-shred-fill:before { content: \"\\ed0c\"; }\n.ri-file-shred-line:before { content: \"\\ed0d\"; }\n.ri-file-text-fill:before { content: \"\\ed0e\"; }\n.ri-file-text-line:before { content: \"\\ed0f\"; }\n.ri-file-transfer-fill:before { content: \"\\ed10\"; }\n.ri-file-transfer-line:before { content: \"\\ed11\"; }\n.ri-file-unknow-fill:before { content: \"\\ed12\"; }\n.ri-file-unknow-line:before { content: \"\\ed13\"; }\n.ri-file-upload-fill:before { content: \"\\ed14\"; }\n.ri-file-upload-line:before { content: \"\\ed15\"; }\n.ri-file-user-fill:before { content: \"\\ed16\"; }\n.ri-file-user-line:before { content: \"\\ed17\"; }\n.ri-file-warning-fill:before { content: \"\\ed18\"; }\n.ri-file-warning-line:before { content: \"\\ed19\"; }\n.ri-file-word-2-fill:before { content: \"\\ed1a\"; }\n.ri-file-word-2-line:before { content: \"\\ed1b\"; }\n.ri-file-word-fill:before { content: \"\\ed1c\"; }\n.ri-file-word-line:before { content: \"\\ed1d\"; }\n.ri-file-zip-fill:before { content: \"\\ed1e\"; }\n.ri-file-zip-line:before { content: \"\\ed1f\"; }\n.ri-film-fill:before { content: \"\\ed20\"; }\n.ri-film-line:before { content: \"\\ed21\"; }\n.ri-filter-2-fill:before { content: \"\\ed22\"; }\n.ri-filter-2-line:before { content: \"\\ed23\"; }\n.ri-filter-3-fill:before { content: \"\\ed24\"; }\n.ri-filter-3-line:before { content: \"\\ed25\"; }\n.ri-filter-fill:before { content: \"\\ed26\"; }\n.ri-filter-line:before { content: \"\\ed27\"; }\n.ri-filter-off-fill:before { content: \"\\ed28\"; }\n.ri-filter-off-line:before { content: \"\\ed29\"; }\n.ri-find-replace-fill:before { content: \"\\ed2a\"; }\n.ri-find-replace-line:before { content: \"\\ed2b\"; }\n.ri-finder-fill:before { content: \"\\ed2c\"; }\n.ri-finder-line:before { content: \"\\ed2d\"; }\n.ri-fingerprint-2-fill:before { content: \"\\ed2e\"; }\n.ri-fingerprint-2-line:before { content: \"\\ed2f\"; }\n.ri-fingerprint-fill:before { content: \"\\ed30\"; }\n.ri-fingerprint-line:before { content: \"\\ed31\"; }\n.ri-fire-fill:before { content: \"\\ed32\"; }\n.ri-fire-line:before { content: \"\\ed33\"; }\n.ri-firefox-fill:before { content: \"\\ed34\"; }\n.ri-firefox-line:before { content: \"\\ed35\"; }\n.ri-first-aid-kit-fill:before { content: \"\\ed36\"; }\n.ri-first-aid-kit-line:before { content: \"\\ed37\"; }\n.ri-flag-2-fill:before { content: \"\\ed38\"; }\n.ri-flag-2-line:before { content: \"\\ed39\"; }\n.ri-flag-fill:before { content: \"\\ed3a\"; }\n.ri-flag-line:before { content: \"\\ed3b\"; }\n.ri-flashlight-fill:before { content: \"\\ed3c\"; }\n.ri-flashlight-line:before { content: \"\\ed3d\"; }\n.ri-flask-fill:before { content: \"\\ed3e\"; }\n.ri-flask-line:before { content: \"\\ed3f\"; }\n.ri-flight-land-fill:before { content: \"\\ed40\"; }\n.ri-flight-land-line:before { content: \"\\ed41\"; }\n.ri-flight-takeoff-fill:before { content: \"\\ed42\"; }\n.ri-flight-takeoff-line:before { content: \"\\ed43\"; }\n.ri-flood-fill:before { content: \"\\ed44\"; }\n.ri-flood-line:before { content: \"\\ed45\"; }\n.ri-flow-chart:before { content: \"\\ed46\"; }\n.ri-flutter-fill:before { content: \"\\ed47\"; }\n.ri-flutter-line:before { content: \"\\ed48\"; }\n.ri-focus-2-fill:before { content: \"\\ed49\"; }\n.ri-focus-2-line:before { content: \"\\ed4a\"; }\n.ri-focus-3-fill:before { content: \"\\ed4b\"; }\n.ri-focus-3-line:before { content: \"\\ed4c\"; }\n.ri-focus-fill:before { content: \"\\ed4d\"; }\n.ri-focus-line:before { content: \"\\ed4e\"; }\n.ri-foggy-fill:before { content: \"\\ed4f\"; }\n.ri-foggy-line:before { content: \"\\ed50\"; }\n.ri-folder-2-fill:before { content: \"\\ed51\"; }\n.ri-folder-2-line:before { content: \"\\ed52\"; }\n.ri-folder-3-fill:before { content: \"\\ed53\"; }\n.ri-folder-3-line:before { content: \"\\ed54\"; }\n.ri-folder-4-fill:before { content: \"\\ed55\"; }\n.ri-folder-4-line:before { content: \"\\ed56\"; }\n.ri-folder-5-fill:before { content: \"\\ed57\"; }\n.ri-folder-5-line:before { content: \"\\ed58\"; }\n.ri-folder-add-fill:before { content: \"\\ed59\"; }\n.ri-folder-add-line:before { content: \"\\ed5a\"; }\n.ri-folder-chart-2-fill:before { content: \"\\ed5b\"; }\n.ri-folder-chart-2-line:before { content: \"\\ed5c\"; }\n.ri-folder-chart-fill:before { content: \"\\ed5d\"; }\n.ri-folder-chart-line:before { content: \"\\ed5e\"; }\n.ri-folder-download-fill:before { content: \"\\ed5f\"; }\n.ri-folder-download-line:before { content: \"\\ed60\"; }\n.ri-folder-fill:before { content: \"\\ed61\"; }\n.ri-folder-forbid-fill:before { content: \"\\ed62\"; }\n.ri-folder-forbid-line:before { content: \"\\ed63\"; }\n.ri-folder-history-fill:before { content: \"\\ed64\"; }\n.ri-folder-history-line:before { content: \"\\ed65\"; }\n.ri-folder-info-fill:before { content: \"\\ed66\"; }\n.ri-folder-info-line:before { content: \"\\ed67\"; }\n.ri-folder-keyhole-fill:before { content: \"\\ed68\"; }\n.ri-folder-keyhole-line:before { content: \"\\ed69\"; }\n.ri-folder-line:before { content: \"\\ed6a\"; }\n.ri-folder-lock-fill:before { content: \"\\ed6b\"; }\n.ri-folder-lock-line:before { content: \"\\ed6c\"; }\n.ri-folder-music-fill:before { content: \"\\ed6d\"; }\n.ri-folder-music-line:before { content: \"\\ed6e\"; }\n.ri-folder-open-fill:before { content: \"\\ed6f\"; }\n.ri-folder-open-line:before { content: \"\\ed70\"; }\n.ri-folder-received-fill:before { content: \"\\ed71\"; }\n.ri-folder-received-line:before { content: \"\\ed72\"; }\n.ri-folder-reduce-fill:before { content: \"\\ed73\"; }\n.ri-folder-reduce-line:before { content: \"\\ed74\"; }\n.ri-folder-settings-fill:before { content: \"\\ed75\"; }\n.ri-folder-settings-line:before { content: \"\\ed76\"; }\n.ri-folder-shared-fill:before { content: \"\\ed77\"; }\n.ri-folder-shared-line:before { content: \"\\ed78\"; }\n.ri-folder-shield-2-fill:before { content: \"\\ed79\"; }\n.ri-folder-shield-2-line:before { content: \"\\ed7a\"; }\n.ri-folder-shield-fill:before { content: \"\\ed7b\"; }\n.ri-folder-shield-line:before { content: \"\\ed7c\"; }\n.ri-folder-transfer-fill:before { content: \"\\ed7d\"; }\n.ri-folder-transfer-line:before { content: \"\\ed7e\"; }\n.ri-folder-unknow-fill:before { content: \"\\ed7f\"; }\n.ri-folder-unknow-line:before { content: \"\\ed80\"; }\n.ri-folder-upload-fill:before { content: \"\\ed81\"; }\n.ri-folder-upload-line:before { content: \"\\ed82\"; }\n.ri-folder-user-fill:before { content: \"\\ed83\"; }\n.ri-folder-user-line:before { content: \"\\ed84\"; }\n.ri-folder-warning-fill:before { content: \"\\ed85\"; }\n.ri-folder-warning-line:before { content: \"\\ed86\"; }\n.ri-folder-zip-fill:before { content: \"\\ed87\"; }\n.ri-folder-zip-line:before { content: \"\\ed88\"; }\n.ri-folders-fill:before { content: \"\\ed89\"; }\n.ri-folders-line:before { content: \"\\ed8a\"; }\n.ri-font-color:before { content: \"\\ed8b\"; }\n.ri-font-size-2:before { content: \"\\ed8c\"; }\n.ri-font-size:before { content: \"\\ed8d\"; }\n.ri-football-fill:before { content: \"\\ed8e\"; }\n.ri-football-line:before { content: \"\\ed8f\"; }\n.ri-footprint-fill:before { content: \"\\ed90\"; }\n.ri-footprint-line:before { content: \"\\ed91\"; }\n.ri-forbid-2-fill:before { content: \"\\ed92\"; }\n.ri-forbid-2-line:before { content: \"\\ed93\"; }\n.ri-forbid-fill:before { content: \"\\ed94\"; }\n.ri-forbid-line:before { content: \"\\ed95\"; }\n.ri-format-clear:before { content: \"\\ed96\"; }\n.ri-fridge-fill:before { content: \"\\ed97\"; }\n.ri-fridge-line:before { content: \"\\ed98\"; }\n.ri-fullscreen-exit-fill:before { content: \"\\ed99\"; }\n.ri-fullscreen-exit-line:before { content: \"\\ed9a\"; }\n.ri-fullscreen-fill:before { content: \"\\ed9b\"; }\n.ri-fullscreen-line:before { content: \"\\ed9c\"; }\n.ri-function-fill:before { content: \"\\ed9d\"; }\n.ri-function-line:before { content: \"\\ed9e\"; }\n.ri-functions:before { content: \"\\ed9f\"; }\n.ri-funds-box-fill:before { content: \"\\eda0\"; }\n.ri-funds-box-line:before { content: \"\\eda1\"; }\n.ri-funds-fill:before { content: \"\\eda2\"; }\n.ri-funds-line:before { content: \"\\eda3\"; }\n.ri-gallery-fill:before { content: \"\\eda4\"; }\n.ri-gallery-line:before { content: \"\\eda5\"; }\n.ri-gallery-upload-fill:before { content: \"\\eda6\"; }\n.ri-gallery-upload-line:before { content: \"\\eda7\"; }\n.ri-game-fill:before { content: \"\\eda8\"; }\n.ri-game-line:before { content: \"\\eda9\"; }\n.ri-gamepad-fill:before { content: \"\\edaa\"; }\n.ri-gamepad-line:before { content: \"\\edab\"; }\n.ri-gas-station-fill:before { content: \"\\edac\"; }\n.ri-gas-station-line:before { content: \"\\edad\"; }\n.ri-gatsby-fill:before { content: \"\\edae\"; }\n.ri-gatsby-line:before { content: \"\\edaf\"; }\n.ri-genderless-fill:before { content: \"\\edb0\"; }\n.ri-genderless-line:before { content: \"\\edb1\"; }\n.ri-ghost-2-fill:before { content: \"\\edb2\"; }\n.ri-ghost-2-line:before { content: \"\\edb3\"; }\n.ri-ghost-fill:before { content: \"\\edb4\"; }\n.ri-ghost-line:before { content: \"\\edb5\"; }\n.ri-ghost-smile-fill:before { content: \"\\edb6\"; }\n.ri-ghost-smile-line:before { content: \"\\edb7\"; }\n.ri-gift-2-fill:before { content: \"\\edb8\"; }\n.ri-gift-2-line:before { content: \"\\edb9\"; }\n.ri-gift-fill:before { content: \"\\edba\"; }\n.ri-gift-line:before { content: \"\\edbb\"; }\n.ri-git-branch-fill:before { content: \"\\edbc\"; }\n.ri-git-branch-line:before { content: \"\\edbd\"; }\n.ri-git-commit-fill:before { content: \"\\edbe\"; }\n.ri-git-commit-line:before { content: \"\\edbf\"; }\n.ri-git-merge-fill:before { content: \"\\edc0\"; }\n.ri-git-merge-line:before { content: \"\\edc1\"; }\n.ri-git-pull-request-fill:before { content: \"\\edc2\"; }\n.ri-git-pull-request-line:before { content: \"\\edc3\"; }\n.ri-git-repository-commits-fill:before { content: \"\\edc4\"; }\n.ri-git-repository-commits-line:before { content: \"\\edc5\"; }\n.ri-git-repository-fill:before { content: \"\\edc6\"; }\n.ri-git-repository-line:before { content: \"\\edc7\"; }\n.ri-git-repository-private-fill:before { content: \"\\edc8\"; }\n.ri-git-repository-private-line:before { content: \"\\edc9\"; }\n.ri-github-fill:before { content: \"\\edca\"; }\n.ri-github-line:before { content: \"\\edcb\"; }\n.ri-gitlab-fill:before { content: \"\\edcc\"; }\n.ri-gitlab-line:before { content: \"\\edcd\"; }\n.ri-global-fill:before { content: \"\\edce\"; }\n.ri-global-line:before { content: \"\\edcf\"; }\n.ri-globe-fill:before { content: \"\\edd0\"; }\n.ri-globe-line:before { content: \"\\edd1\"; }\n.ri-goblet-fill:before { content: \"\\edd2\"; }\n.ri-goblet-line:before { content: \"\\edd3\"; }\n.ri-google-fill:before { content: \"\\edd4\"; }\n.ri-google-line:before { content: \"\\edd5\"; }\n.ri-google-play-fill:before { content: \"\\edd6\"; }\n.ri-google-play-line:before { content: \"\\edd7\"; }\n.ri-government-fill:before { content: \"\\edd8\"; }\n.ri-government-line:before { content: \"\\edd9\"; }\n.ri-gps-fill:before { content: \"\\edda\"; }\n.ri-gps-line:before { content: \"\\eddb\"; }\n.ri-gradienter-fill:before { content: \"\\eddc\"; }\n.ri-gradienter-line:before { content: \"\\eddd\"; }\n.ri-grid-fill:before { content: \"\\edde\"; }\n.ri-grid-line:before { content: \"\\eddf\"; }\n.ri-group-2-fill:before { content: \"\\ede0\"; }\n.ri-group-2-line:before { content: \"\\ede1\"; }\n.ri-group-fill:before { content: \"\\ede2\"; }\n.ri-group-line:before { content: \"\\ede3\"; }\n.ri-guide-fill:before { content: \"\\ede4\"; }\n.ri-guide-line:before { content: \"\\ede5\"; }\n.ri-h-1:before { content: \"\\ede6\"; }\n.ri-h-2:before { content: \"\\ede7\"; }\n.ri-h-3:before { content: \"\\ede8\"; }\n.ri-h-4:before { content: \"\\ede9\"; }\n.ri-h-5:before { content: \"\\edea\"; }\n.ri-h-6:before { content: \"\\edeb\"; }\n.ri-hail-fill:before { content: \"\\edec\"; }\n.ri-hail-line:before { content: \"\\eded\"; }\n.ri-hammer-fill:before { content: \"\\edee\"; }\n.ri-hammer-line:before { content: \"\\edef\"; }\n.ri-hand-coin-fill:before { content: \"\\edf0\"; }\n.ri-hand-coin-line:before { content: \"\\edf1\"; }\n.ri-hand-heart-fill:before { content: \"\\edf2\"; }\n.ri-hand-heart-line:before { content: \"\\edf3\"; }\n.ri-hand-sanitizer-fill:before { content: \"\\edf4\"; }\n.ri-hand-sanitizer-line:before { content: \"\\edf5\"; }\n.ri-handbag-fill:before { content: \"\\edf6\"; }\n.ri-handbag-line:before { content: \"\\edf7\"; }\n.ri-hard-drive-2-fill:before { content: \"\\edf8\"; }\n.ri-hard-drive-2-line:before { content: \"\\edf9\"; }\n.ri-hard-drive-fill:before { content: \"\\edfa\"; }\n.ri-hard-drive-line:before { content: \"\\edfb\"; }\n.ri-hashtag:before { content: \"\\edfc\"; }\n.ri-haze-2-fill:before { content: \"\\edfd\"; }\n.ri-haze-2-line:before { content: \"\\edfe\"; }\n.ri-haze-fill:before { content: \"\\edff\"; }\n.ri-haze-line:before { content: \"\\ee00\"; }\n.ri-hd-fill:before { content: \"\\ee01\"; }\n.ri-hd-line:before { content: \"\\ee02\"; }\n.ri-heading:before { content: \"\\ee03\"; }\n.ri-headphone-fill:before { content: \"\\ee04\"; }\n.ri-headphone-line:before { content: \"\\ee05\"; }\n.ri-health-book-fill:before { content: \"\\ee06\"; }\n.ri-health-book-line:before { content: \"\\ee07\"; }\n.ri-heart-2-fill:before { content: \"\\ee08\"; }\n.ri-heart-2-line:before { content: \"\\ee09\"; }\n.ri-heart-3-fill:before { content: \"\\ee0a\"; }\n.ri-heart-3-line:before { content: \"\\ee0b\"; }\n.ri-heart-add-fill:before { content: \"\\ee0c\"; }\n.ri-heart-add-line:before { content: \"\\ee0d\"; }\n.ri-heart-fill:before { content: \"\\ee0e\"; }\n.ri-heart-line:before { content: \"\\ee0f\"; }\n.ri-heart-pulse-fill:before { content: \"\\ee10\"; }\n.ri-heart-pulse-line:before { content: \"\\ee11\"; }\n.ri-hearts-fill:before { content: \"\\ee12\"; }\n.ri-hearts-line:before { content: \"\\ee13\"; }\n.ri-heavy-showers-fill:before { content: \"\\ee14\"; }\n.ri-heavy-showers-line:before { content: \"\\ee15\"; }\n.ri-history-fill:before { content: \"\\ee16\"; }\n.ri-history-line:before { content: \"\\ee17\"; }\n.ri-home-2-fill:before { content: \"\\ee18\"; }\n.ri-home-2-line:before { content: \"\\ee19\"; }\n.ri-home-3-fill:before { content: \"\\ee1a\"; }\n.ri-home-3-line:before { content: \"\\ee1b\"; }\n.ri-home-4-fill:before { content: \"\\ee1c\"; }\n.ri-home-4-line:before { content: \"\\ee1d\"; }\n.ri-home-5-fill:before { content: \"\\ee1e\"; }\n.ri-home-5-line:before { content: \"\\ee1f\"; }\n.ri-home-6-fill:before { content: \"\\ee20\"; }\n.ri-home-6-line:before { content: \"\\ee21\"; }\n.ri-home-7-fill:before { content: \"\\ee22\"; }\n.ri-home-7-line:before { content: \"\\ee23\"; }\n.ri-home-8-fill:before { content: \"\\ee24\"; }\n.ri-home-8-line:before { content: \"\\ee25\"; }\n.ri-home-fill:before { content: \"\\ee26\"; }\n.ri-home-gear-fill:before { content: \"\\ee27\"; }\n.ri-home-gear-line:before { content: \"\\ee28\"; }\n.ri-home-heart-fill:before { content: \"\\ee29\"; }\n.ri-home-heart-line:before { content: \"\\ee2a\"; }\n.ri-home-line:before { content: \"\\ee2b\"; }\n.ri-home-smile-2-fill:before { content: \"\\ee2c\"; }\n.ri-home-smile-2-line:before { content: \"\\ee2d\"; }\n.ri-home-smile-fill:before { content: \"\\ee2e\"; }\n.ri-home-smile-line:before { content: \"\\ee2f\"; }\n.ri-home-wifi-fill:before { content: \"\\ee30\"; }\n.ri-home-wifi-line:before { content: \"\\ee31\"; }\n.ri-honor-of-kings-fill:before { content: \"\\ee32\"; }\n.ri-honor-of-kings-line:before { content: \"\\ee33\"; }\n.ri-honour-fill:before { content: \"\\ee34\"; }\n.ri-honour-line:before { content: \"\\ee35\"; }\n.ri-hospital-fill:before { content: \"\\ee36\"; }\n.ri-hospital-line:before { content: \"\\ee37\"; }\n.ri-hotel-bed-fill:before { content: \"\\ee38\"; }\n.ri-hotel-bed-line:before { content: \"\\ee39\"; }\n.ri-hotel-fill:before { content: \"\\ee3a\"; }\n.ri-hotel-line:before { content: \"\\ee3b\"; }\n.ri-hotspot-fill:before { content: \"\\ee3c\"; }\n.ri-hotspot-line:before { content: \"\\ee3d\"; }\n.ri-hq-fill:before { content: \"\\ee3e\"; }\n.ri-hq-line:before { content: \"\\ee3f\"; }\n.ri-html5-fill:before { content: \"\\ee40\"; }\n.ri-html5-line:before { content: \"\\ee41\"; }\n.ri-ie-fill:before { content: \"\\ee42\"; }\n.ri-ie-line:before { content: \"\\ee43\"; }\n.ri-image-2-fill:before { content: \"\\ee44\"; }\n.ri-image-2-line:before { content: \"\\ee45\"; }\n.ri-image-add-fill:before { content: \"\\ee46\"; }\n.ri-image-add-line:before { content: \"\\ee47\"; }\n.ri-image-edit-fill:before { content: \"\\ee48\"; }\n.ri-image-edit-line:before { content: \"\\ee49\"; }\n.ri-image-fill:before { content: \"\\ee4a\"; }\n.ri-image-line:before { content: \"\\ee4b\"; }\n.ri-inbox-archive-fill:before { content: \"\\ee4c\"; }\n.ri-inbox-archive-line:before { content: \"\\ee4d\"; }\n.ri-inbox-fill:before { content: \"\\ee4e\"; }\n.ri-inbox-line:before { content: \"\\ee4f\"; }\n.ri-inbox-unarchive-fill:before { content: \"\\ee50\"; }\n.ri-inbox-unarchive-line:before { content: \"\\ee51\"; }\n.ri-increase-decrease-fill:before { content: \"\\ee52\"; }\n.ri-increase-decrease-line:before { content: \"\\ee53\"; }\n.ri-indent-decrease:before { content: \"\\ee54\"; }\n.ri-indent-increase:before { content: \"\\ee55\"; }\n.ri-indeterminate-circle-fill:before { content: \"\\ee56\"; }\n.ri-indeterminate-circle-line:before { content: \"\\ee57\"; }\n.ri-information-fill:before { content: \"\\ee58\"; }\n.ri-information-line:before { content: \"\\ee59\"; }\n.ri-infrared-thermometer-fill:before { content: \"\\ee5a\"; }\n.ri-infrared-thermometer-line:before { content: \"\\ee5b\"; }\n.ri-ink-bottle-fill:before { content: \"\\ee5c\"; }\n.ri-ink-bottle-line:before { content: \"\\ee5d\"; }\n.ri-input-cursor-move:before { content: \"\\ee5e\"; }\n.ri-input-method-fill:before { content: \"\\ee5f\"; }\n.ri-input-method-line:before { content: \"\\ee60\"; }\n.ri-insert-column-left:before { content: \"\\ee61\"; }\n.ri-insert-column-right:before { content: \"\\ee62\"; }\n.ri-insert-row-bottom:before { content: \"\\ee63\"; }\n.ri-insert-row-top:before { content: \"\\ee64\"; }\n.ri-instagram-fill:before { content: \"\\ee65\"; }\n.ri-instagram-line:before { content: \"\\ee66\"; }\n.ri-install-fill:before { content: \"\\ee67\"; }\n.ri-install-line:before { content: \"\\ee68\"; }\n.ri-invision-fill:before { content: \"\\ee69\"; }\n.ri-invision-line:before { content: \"\\ee6a\"; }\n.ri-italic:before { content: \"\\ee6b\"; }\n.ri-kakao-talk-fill:before { content: \"\\ee6c\"; }\n.ri-kakao-talk-line:before { content: \"\\ee6d\"; }\n.ri-key-2-fill:before { content: \"\\ee6e\"; }\n.ri-key-2-line:before { content: \"\\ee6f\"; }\n.ri-key-fill:before { content: \"\\ee70\"; }\n.ri-key-line:before { content: \"\\ee71\"; }\n.ri-keyboard-box-fill:before { content: \"\\ee72\"; }\n.ri-keyboard-box-line:before { content: \"\\ee73\"; }\n.ri-keyboard-fill:before { content: \"\\ee74\"; }\n.ri-keyboard-line:before { content: \"\\ee75\"; }\n.ri-keynote-fill:before { content: \"\\ee76\"; }\n.ri-keynote-line:before { content: \"\\ee77\"; }\n.ri-knife-blood-fill:before { content: \"\\ee78\"; }\n.ri-knife-blood-line:before { content: \"\\ee79\"; }\n.ri-knife-fill:before { content: \"\\ee7a\"; }\n.ri-knife-line:before { content: \"\\ee7b\"; }\n.ri-landscape-fill:before { content: \"\\ee7c\"; }\n.ri-landscape-line:before { content: \"\\ee7d\"; }\n.ri-layout-2-fill:before { content: \"\\ee7e\"; }\n.ri-layout-2-line:before { content: \"\\ee7f\"; }\n.ri-layout-3-fill:before { content: \"\\ee80\"; }\n.ri-layout-3-line:before { content: \"\\ee81\"; }\n.ri-layout-4-fill:before { content: \"\\ee82\"; }\n.ri-layout-4-line:before { content: \"\\ee83\"; }\n.ri-layout-5-fill:before { content: \"\\ee84\"; }\n.ri-layout-5-line:before { content: \"\\ee85\"; }\n.ri-layout-6-fill:before { content: \"\\ee86\"; }\n.ri-layout-6-line:before { content: \"\\ee87\"; }\n.ri-layout-bottom-2-fill:before { content: \"\\ee88\"; }\n.ri-layout-bottom-2-line:before { content: \"\\ee89\"; }\n.ri-layout-bottom-fill:before { content: \"\\ee8a\"; }\n.ri-layout-bottom-line:before { content: \"\\ee8b\"; }\n.ri-layout-column-fill:before { content: \"\\ee8c\"; }\n.ri-layout-column-line:before { content: \"\\ee8d\"; }\n.ri-layout-fill:before { content: \"\\ee8e\"; }\n.ri-layout-grid-fill:before { content: \"\\ee8f\"; }\n.ri-layout-grid-line:before { content: \"\\ee90\"; }\n.ri-layout-left-2-fill:before { content: \"\\ee91\"; }\n.ri-layout-left-2-line:before { content: \"\\ee92\"; }\n.ri-layout-left-fill:before { content: \"\\ee93\"; }\n.ri-layout-left-line:before { content: \"\\ee94\"; }\n.ri-layout-line:before { content: \"\\ee95\"; }\n.ri-layout-masonry-fill:before { content: \"\\ee96\"; }\n.ri-layout-masonry-line:before { content: \"\\ee97\"; }\n.ri-layout-right-2-fill:before { content: \"\\ee98\"; }\n.ri-layout-right-2-line:before { content: \"\\ee99\"; }\n.ri-layout-right-fill:before { content: \"\\ee9a\"; }\n.ri-layout-right-line:before { content: \"\\ee9b\"; }\n.ri-layout-row-fill:before { content: \"\\ee9c\"; }\n.ri-layout-row-line:before { content: \"\\ee9d\"; }\n.ri-layout-top-2-fill:before { content: \"\\ee9e\"; }\n.ri-layout-top-2-line:before { content: \"\\ee9f\"; }\n.ri-layout-top-fill:before { content: \"\\eea0\"; }\n.ri-layout-top-line:before { content: \"\\eea1\"; }\n.ri-leaf-fill:before { content: \"\\eea2\"; }\n.ri-leaf-line:before { content: \"\\eea3\"; }\n.ri-lifebuoy-fill:before { content: \"\\eea4\"; }\n.ri-lifebuoy-line:before { content: \"\\eea5\"; }\n.ri-lightbulb-fill:before { content: \"\\eea6\"; }\n.ri-lightbulb-flash-fill:before { content: \"\\eea7\"; }\n.ri-lightbulb-flash-line:before { content: \"\\eea8\"; }\n.ri-lightbulb-line:before { content: \"\\eea9\"; }\n.ri-line-chart-fill:before { content: \"\\eeaa\"; }\n.ri-line-chart-line:before { content: \"\\eeab\"; }\n.ri-line-fill:before { content: \"\\eeac\"; }\n.ri-line-height:before { content: \"\\eead\"; }\n.ri-line-line:before { content: \"\\eeae\"; }\n.ri-link-m:before { content: \"\\eeaf\"; }\n.ri-link-unlink-m:before { content: \"\\eeb0\"; }\n.ri-link-unlink:before { content: \"\\eeb1\"; }\n.ri-link:before { content: \"\\eeb2\"; }\n.ri-linkedin-box-fill:before { content: \"\\eeb3\"; }\n.ri-linkedin-box-line:before { content: \"\\eeb4\"; }\n.ri-linkedin-fill:before { content: \"\\eeb5\"; }\n.ri-linkedin-line:before { content: \"\\eeb6\"; }\n.ri-links-fill:before { content: \"\\eeb7\"; }\n.ri-links-line:before { content: \"\\eeb8\"; }\n.ri-list-check-2:before { content: \"\\eeb9\"; }\n.ri-list-check:before { content: \"\\eeba\"; }\n.ri-list-ordered:before { content: \"\\eebb\"; }\n.ri-list-settings-fill:before { content: \"\\eebc\"; }\n.ri-list-settings-line:before { content: \"\\eebd\"; }\n.ri-list-unordered:before { content: \"\\eebe\"; }\n.ri-live-fill:before { content: \"\\eebf\"; }\n.ri-live-line:before { content: \"\\eec0\"; }\n.ri-loader-2-fill:before { content: \"\\eec1\"; }\n.ri-loader-2-line:before { content: \"\\eec2\"; }\n.ri-loader-3-fill:before { content: \"\\eec3\"; }\n.ri-loader-3-line:before { content: \"\\eec4\"; }\n.ri-loader-4-fill:before { content: \"\\eec5\"; }\n.ri-loader-4-line:before { content: \"\\eec6\"; }\n.ri-loader-5-fill:before { content: \"\\eec7\"; }\n.ri-loader-5-line:before { content: \"\\eec8\"; }\n.ri-loader-fill:before { content: \"\\eec9\"; }\n.ri-loader-line:before { content: \"\\eeca\"; }\n.ri-lock-2-fill:before { content: \"\\eecb\"; }\n.ri-lock-2-line:before { content: \"\\eecc\"; }\n.ri-lock-fill:before { content: \"\\eecd\"; }\n.ri-lock-line:before { content: \"\\eece\"; }\n.ri-lock-password-fill:before { content: \"\\eecf\"; }\n.ri-lock-password-line:before { content: \"\\eed0\"; }\n.ri-lock-unlock-fill:before { content: \"\\eed1\"; }\n.ri-lock-unlock-line:before { content: \"\\eed2\"; }\n.ri-login-box-fill:before { content: \"\\eed3\"; }\n.ri-login-box-line:before { content: \"\\eed4\"; }\n.ri-login-circle-fill:before { content: \"\\eed5\"; }\n.ri-login-circle-line:before { content: \"\\eed6\"; }\n.ri-logout-box-fill:before { content: \"\\eed7\"; }\n.ri-logout-box-line:before { content: \"\\eed8\"; }\n.ri-logout-box-r-fill:before { content: \"\\eed9\"; }\n.ri-logout-box-r-line:before { content: \"\\eeda\"; }\n.ri-logout-circle-fill:before { content: \"\\eedb\"; }\n.ri-logout-circle-line:before { content: \"\\eedc\"; }\n.ri-logout-circle-r-fill:before { content: \"\\eedd\"; }\n.ri-logout-circle-r-line:before { content: \"\\eede\"; }\n.ri-luggage-cart-fill:before { content: \"\\eedf\"; }\n.ri-luggage-cart-line:before { content: \"\\eee0\"; }\n.ri-luggage-deposit-fill:before { content: \"\\eee1\"; }\n.ri-luggage-deposit-line:before { content: \"\\eee2\"; }\n.ri-lungs-fill:before { content: \"\\eee3\"; }\n.ri-lungs-line:before { content: \"\\eee4\"; }\n.ri-mac-fill:before { content: \"\\eee5\"; }\n.ri-mac-line:before { content: \"\\eee6\"; }\n.ri-macbook-fill:before { content: \"\\eee7\"; }\n.ri-macbook-line:before { content: \"\\eee8\"; }\n.ri-magic-fill:before { content: \"\\eee9\"; }\n.ri-magic-line:before { content: \"\\eeea\"; }\n.ri-mail-add-fill:before { content: \"\\eeeb\"; }\n.ri-mail-add-line:before { content: \"\\eeec\"; }\n.ri-mail-check-fill:before { content: \"\\eeed\"; }\n.ri-mail-check-line:before { content: \"\\eeee\"; }\n.ri-mail-close-fill:before { content: \"\\eeef\"; }\n.ri-mail-close-line:before { content: \"\\eef0\"; }\n.ri-mail-download-fill:before { content: \"\\eef1\"; }\n.ri-mail-download-line:before { content: \"\\eef2\"; }\n.ri-mail-fill:before { content: \"\\eef3\"; }\n.ri-mail-forbid-fill:before { content: \"\\eef4\"; }\n.ri-mail-forbid-line:before { content: \"\\eef5\"; }\n.ri-mail-line:before { content: \"\\eef6\"; }\n.ri-mail-lock-fill:before { content: \"\\eef7\"; }\n.ri-mail-lock-line:before { content: \"\\eef8\"; }\n.ri-mail-open-fill:before { content: \"\\eef9\"; }\n.ri-mail-open-line:before { content: \"\\eefa\"; }\n.ri-mail-send-fill:before { content: \"\\eefb\"; }\n.ri-mail-send-line:before { content: \"\\eefc\"; }\n.ri-mail-settings-fill:before { content: \"\\eefd\"; }\n.ri-mail-settings-line:before { content: \"\\eefe\"; }\n.ri-mail-star-fill:before { content: \"\\eeff\"; }\n.ri-mail-star-line:before { content: \"\\ef00\"; }\n.ri-mail-unread-fill:before { content: \"\\ef01\"; }\n.ri-mail-unread-line:before { content: \"\\ef02\"; }\n.ri-mail-volume-fill:before { content: \"\\ef03\"; }\n.ri-mail-volume-line:before { content: \"\\ef04\"; }\n.ri-map-2-fill:before { content: \"\\ef05\"; }\n.ri-map-2-line:before { content: \"\\ef06\"; }\n.ri-map-fill:before { content: \"\\ef07\"; }\n.ri-map-line:before { content: \"\\ef08\"; }\n.ri-map-pin-2-fill:before { content: \"\\ef09\"; }\n.ri-map-pin-2-line:before { content: \"\\ef0a\"; }\n.ri-map-pin-3-fill:before { content: \"\\ef0b\"; }\n.ri-map-pin-3-line:before { content: \"\\ef0c\"; }\n.ri-map-pin-4-fill:before { content: \"\\ef0d\"; }\n.ri-map-pin-4-line:before { content: \"\\ef0e\"; }\n.ri-map-pin-5-fill:before { content: \"\\ef0f\"; }\n.ri-map-pin-5-line:before { content: \"\\ef10\"; }\n.ri-map-pin-add-fill:before { content: \"\\ef11\"; }\n.ri-map-pin-add-line:before { content: \"\\ef12\"; }\n.ri-map-pin-fill:before { content: \"\\ef13\"; }\n.ri-map-pin-line:before { content: \"\\ef14\"; }\n.ri-map-pin-range-fill:before { content: \"\\ef15\"; }\n.ri-map-pin-range-line:before { content: \"\\ef16\"; }\n.ri-map-pin-time-fill:before { content: \"\\ef17\"; }\n.ri-map-pin-time-line:before { content: \"\\ef18\"; }\n.ri-map-pin-user-fill:before { content: \"\\ef19\"; }\n.ri-map-pin-user-line:before { content: \"\\ef1a\"; }\n.ri-mark-pen-fill:before { content: \"\\ef1b\"; }\n.ri-mark-pen-line:before { content: \"\\ef1c\"; }\n.ri-markdown-fill:before { content: \"\\ef1d\"; }\n.ri-markdown-line:before { content: \"\\ef1e\"; }\n.ri-markup-fill:before { content: \"\\ef1f\"; }\n.ri-markup-line:before { content: \"\\ef20\"; }\n.ri-mastercard-fill:before { content: \"\\ef21\"; }\n.ri-mastercard-line:before { content: \"\\ef22\"; }\n.ri-mastodon-fill:before { content: \"\\ef23\"; }\n.ri-mastodon-line:before { content: \"\\ef24\"; }\n.ri-medal-2-fill:before { content: \"\\ef25\"; }\n.ri-medal-2-line:before { content: \"\\ef26\"; }\n.ri-medal-fill:before { content: \"\\ef27\"; }\n.ri-medal-line:before { content: \"\\ef28\"; }\n.ri-medicine-bottle-fill:before { content: \"\\ef29\"; }\n.ri-medicine-bottle-line:before { content: \"\\ef2a\"; }\n.ri-medium-fill:before { content: \"\\ef2b\"; }\n.ri-medium-line:before { content: \"\\ef2c\"; }\n.ri-men-fill:before { content: \"\\ef2d\"; }\n.ri-men-line:before { content: \"\\ef2e\"; }\n.ri-mental-health-fill:before { content: \"\\ef2f\"; }\n.ri-mental-health-line:before { content: \"\\ef30\"; }\n.ri-menu-2-fill:before { content: \"\\ef31\"; }\n.ri-menu-2-line:before { content: \"\\ef32\"; }\n.ri-menu-3-fill:before { content: \"\\ef33\"; }\n.ri-menu-3-line:before { content: \"\\ef34\"; }\n.ri-menu-4-fill:before { content: \"\\ef35\"; }\n.ri-menu-4-line:before { content: \"\\ef36\"; }\n.ri-menu-5-fill:before { content: \"\\ef37\"; }\n.ri-menu-5-line:before { content: \"\\ef38\"; }\n.ri-menu-add-fill:before { content: \"\\ef39\"; }\n.ri-menu-add-line:before { content: \"\\ef3a\"; }\n.ri-menu-fill:before { content: \"\\ef3b\"; }\n.ri-menu-fold-fill:before { content: \"\\ef3c\"; }\n.ri-menu-fold-line:before { content: \"\\ef3d\"; }\n.ri-menu-line:before { content: \"\\ef3e\"; }\n.ri-menu-unfold-fill:before { content: \"\\ef3f\"; }\n.ri-menu-unfold-line:before { content: \"\\ef40\"; }\n.ri-merge-cells-horizontal:before { content: \"\\ef41\"; }\n.ri-merge-cells-vertical:before { content: \"\\ef42\"; }\n.ri-message-2-fill:before { content: \"\\ef43\"; }\n.ri-message-2-line:before { content: \"\\ef44\"; }\n.ri-message-3-fill:before { content: \"\\ef45\"; }\n.ri-message-3-line:before { content: \"\\ef46\"; }\n.ri-message-fill:before { content: \"\\ef47\"; }\n.ri-message-line:before { content: \"\\ef48\"; }\n.ri-messenger-fill:before { content: \"\\ef49\"; }\n.ri-messenger-line:before { content: \"\\ef4a\"; }\n.ri-meteor-fill:before { content: \"\\ef4b\"; }\n.ri-meteor-line:before { content: \"\\ef4c\"; }\n.ri-mic-2-fill:before { content: \"\\ef4d\"; }\n.ri-mic-2-line:before { content: \"\\ef4e\"; }\n.ri-mic-fill:before { content: \"\\ef4f\"; }\n.ri-mic-line:before { content: \"\\ef50\"; }\n.ri-mic-off-fill:before { content: \"\\ef51\"; }\n.ri-mic-off-line:before { content: \"\\ef52\"; }\n.ri-mickey-fill:before { content: \"\\ef53\"; }\n.ri-mickey-line:before { content: \"\\ef54\"; }\n.ri-microscope-fill:before { content: \"\\ef55\"; }\n.ri-microscope-line:before { content: \"\\ef56\"; }\n.ri-microsoft-fill:before { content: \"\\ef57\"; }\n.ri-microsoft-line:before { content: \"\\ef58\"; }\n.ri-mind-map:before { content: \"\\ef59\"; }\n.ri-mini-program-fill:before { content: \"\\ef5a\"; }\n.ri-mini-program-line:before { content: \"\\ef5b\"; }\n.ri-mist-fill:before { content: \"\\ef5c\"; }\n.ri-mist-line:before { content: \"\\ef5d\"; }\n.ri-money-cny-box-fill:before { content: \"\\ef5e\"; }\n.ri-money-cny-box-line:before { content: \"\\ef5f\"; }\n.ri-money-cny-circle-fill:before { content: \"\\ef60\"; }\n.ri-money-cny-circle-line:before { content: \"\\ef61\"; }\n.ri-money-dollar-box-fill:before { content: \"\\ef62\"; }\n.ri-money-dollar-box-line:before { content: \"\\ef63\"; }\n.ri-money-dollar-circle-fill:before { content: \"\\ef64\"; }\n.ri-money-dollar-circle-line:before { content: \"\\ef65\"; }\n.ri-money-euro-box-fill:before { content: \"\\ef66\"; }\n.ri-money-euro-box-line:before { content: \"\\ef67\"; }\n.ri-money-euro-circle-fill:before { content: \"\\ef68\"; }\n.ri-money-euro-circle-line:before { content: \"\\ef69\"; }\n.ri-money-pound-box-fill:before { content: \"\\ef6a\"; }\n.ri-money-pound-box-line:before { content: \"\\ef6b\"; }\n.ri-money-pound-circle-fill:before { content: \"\\ef6c\"; }\n.ri-money-pound-circle-line:before { content: \"\\ef6d\"; }\n.ri-moon-clear-fill:before { content: \"\\ef6e\"; }\n.ri-moon-clear-line:before { content: \"\\ef6f\"; }\n.ri-moon-cloudy-fill:before { content: \"\\ef70\"; }\n.ri-moon-cloudy-line:before { content: \"\\ef71\"; }\n.ri-moon-fill:before { content: \"\\ef72\"; }\n.ri-moon-foggy-fill:before { content: \"\\ef73\"; }\n.ri-moon-foggy-line:before { content: \"\\ef74\"; }\n.ri-moon-line:before { content: \"\\ef75\"; }\n.ri-more-2-fill:before { content: \"\\ef76\"; }\n.ri-more-2-line:before { content: \"\\ef77\"; }\n.ri-more-fill:before { content: \"\\ef78\"; }\n.ri-more-line:before { content: \"\\ef79\"; }\n.ri-motorbike-fill:before { content: \"\\ef7a\"; }\n.ri-motorbike-line:before { content: \"\\ef7b\"; }\n.ri-mouse-fill:before { content: \"\\ef7c\"; }\n.ri-mouse-line:before { content: \"\\ef7d\"; }\n.ri-movie-2-fill:before { content: \"\\ef7e\"; }\n.ri-movie-2-line:before { content: \"\\ef7f\"; }\n.ri-movie-fill:before { content: \"\\ef80\"; }\n.ri-movie-line:before { content: \"\\ef81\"; }\n.ri-music-2-fill:before { content: \"\\ef82\"; }\n.ri-music-2-line:before { content: \"\\ef83\"; }\n.ri-music-fill:before { content: \"\\ef84\"; }\n.ri-music-line:before { content: \"\\ef85\"; }\n.ri-mv-fill:before { content: \"\\ef86\"; }\n.ri-mv-line:before { content: \"\\ef87\"; }\n.ri-navigation-fill:before { content: \"\\ef88\"; }\n.ri-navigation-line:before { content: \"\\ef89\"; }\n.ri-netease-cloud-music-fill:before { content: \"\\ef8a\"; }\n.ri-netease-cloud-music-line:before { content: \"\\ef8b\"; }\n.ri-netflix-fill:before { content: \"\\ef8c\"; }\n.ri-netflix-line:before { content: \"\\ef8d\"; }\n.ri-newspaper-fill:before { content: \"\\ef8e\"; }\n.ri-newspaper-line:before { content: \"\\ef8f\"; }\n.ri-node-tree:before { content: \"\\ef90\"; }\n.ri-notification-2-fill:before { content: \"\\ef91\"; }\n.ri-notification-2-line:before { content: \"\\ef92\"; }\n.ri-notification-3-fill:before { content: \"\\ef93\"; }\n.ri-notification-3-line:before { content: \"\\ef94\"; }\n.ri-notification-4-fill:before { content: \"\\ef95\"; }\n.ri-notification-4-line:before { content: \"\\ef96\"; }\n.ri-notification-badge-fill:before { content: \"\\ef97\"; }\n.ri-notification-badge-line:before { content: \"\\ef98\"; }\n.ri-notification-fill:before { content: \"\\ef99\"; }\n.ri-notification-line:before { content: \"\\ef9a\"; }\n.ri-notification-off-fill:before { content: \"\\ef9b\"; }\n.ri-notification-off-line:before { content: \"\\ef9c\"; }\n.ri-npmjs-fill:before { content: \"\\ef9d\"; }\n.ri-npmjs-line:before { content: \"\\ef9e\"; }\n.ri-number-0:before { content: \"\\ef9f\"; }\n.ri-number-1:before { content: \"\\efa0\"; }\n.ri-number-2:before { content: \"\\efa1\"; }\n.ri-number-3:before { content: \"\\efa2\"; }\n.ri-number-4:before { content: \"\\efa3\"; }\n.ri-number-5:before { content: \"\\efa4\"; }\n.ri-number-6:before { content: \"\\efa5\"; }\n.ri-number-7:before { content: \"\\efa6\"; }\n.ri-number-8:before { content: \"\\efa7\"; }\n.ri-number-9:before { content: \"\\efa8\"; }\n.ri-numbers-fill:before { content: \"\\efa9\"; }\n.ri-numbers-line:before { content: \"\\efaa\"; }\n.ri-nurse-fill:before { content: \"\\efab\"; }\n.ri-nurse-line:before { content: \"\\efac\"; }\n.ri-oil-fill:before { content: \"\\efad\"; }\n.ri-oil-line:before { content: \"\\efae\"; }\n.ri-omega:before { content: \"\\efaf\"; }\n.ri-open-arm-fill:before { content: \"\\efb0\"; }\n.ri-open-arm-line:before { content: \"\\efb1\"; }\n.ri-open-source-fill:before { content: \"\\efb2\"; }\n.ri-open-source-line:before { content: \"\\efb3\"; }\n.ri-opera-fill:before { content: \"\\efb4\"; }\n.ri-opera-line:before { content: \"\\efb5\"; }\n.ri-order-play-fill:before { content: \"\\efb6\"; }\n.ri-order-play-line:before { content: \"\\efb7\"; }\n.ri-organization-chart:before { content: \"\\efb8\"; }\n.ri-outlet-2-fill:before { content: \"\\efb9\"; }\n.ri-outlet-2-line:before { content: \"\\efba\"; }\n.ri-outlet-fill:before { content: \"\\efbb\"; }\n.ri-outlet-line:before { content: \"\\efbc\"; }\n.ri-page-separator:before { content: \"\\efbd\"; }\n.ri-pages-fill:before { content: \"\\efbe\"; }\n.ri-pages-line:before { content: \"\\efbf\"; }\n.ri-paint-brush-fill:before { content: \"\\efc0\"; }\n.ri-paint-brush-line:before { content: \"\\efc1\"; }\n.ri-paint-fill:before { content: \"\\efc2\"; }\n.ri-paint-line:before { content: \"\\efc3\"; }\n.ri-palette-fill:before { content: \"\\efc4\"; }\n.ri-palette-line:before { content: \"\\efc5\"; }\n.ri-pantone-fill:before { content: \"\\efc6\"; }\n.ri-pantone-line:before { content: \"\\efc7\"; }\n.ri-paragraph:before { content: \"\\efc8\"; }\n.ri-parent-fill:before { content: \"\\efc9\"; }\n.ri-parent-line:before { content: \"\\efca\"; }\n.ri-parentheses-fill:before { content: \"\\efcb\"; }\n.ri-parentheses-line:before { content: \"\\efcc\"; }\n.ri-parking-box-fill:before { content: \"\\efcd\"; }\n.ri-parking-box-line:before { content: \"\\efce\"; }\n.ri-parking-fill:before { content: \"\\efcf\"; }\n.ri-parking-line:before { content: \"\\efd0\"; }\n.ri-passport-fill:before { content: \"\\efd1\"; }\n.ri-passport-line:before { content: \"\\efd2\"; }\n.ri-patreon-fill:before { content: \"\\efd3\"; }\n.ri-patreon-line:before { content: \"\\efd4\"; }\n.ri-pause-circle-fill:before { content: \"\\efd5\"; }\n.ri-pause-circle-line:before { content: \"\\efd6\"; }\n.ri-pause-fill:before { content: \"\\efd7\"; }\n.ri-pause-line:before { content: \"\\efd8\"; }\n.ri-pause-mini-fill:before { content: \"\\efd9\"; }\n.ri-pause-mini-line:before { content: \"\\efda\"; }\n.ri-paypal-fill:before { content: \"\\efdb\"; }\n.ri-paypal-line:before { content: \"\\efdc\"; }\n.ri-pen-nib-fill:before { content: \"\\efdd\"; }\n.ri-pen-nib-line:before { content: \"\\efde\"; }\n.ri-pencil-fill:before { content: \"\\efdf\"; }\n.ri-pencil-line:before { content: \"\\efe0\"; }\n.ri-pencil-ruler-2-fill:before { content: \"\\efe1\"; }\n.ri-pencil-ruler-2-line:before { content: \"\\efe2\"; }\n.ri-pencil-ruler-fill:before { content: \"\\efe3\"; }\n.ri-pencil-ruler-line:before { content: \"\\efe4\"; }\n.ri-percent-fill:before { content: \"\\efe5\"; }\n.ri-percent-line:before { content: \"\\efe6\"; }\n.ri-phone-camera-fill:before { content: \"\\efe7\"; }\n.ri-phone-camera-line:before { content: \"\\efe8\"; }\n.ri-phone-fill:before { content: \"\\efe9\"; }\n.ri-phone-find-fill:before { content: \"\\efea\"; }\n.ri-phone-find-line:before { content: \"\\efeb\"; }\n.ri-phone-line:before { content: \"\\efec\"; }\n.ri-phone-lock-fill:before { content: \"\\efed\"; }\n.ri-phone-lock-line:before { content: \"\\efee\"; }\n.ri-picture-in-picture-2-fill:before { content: \"\\efef\"; }\n.ri-picture-in-picture-2-line:before { content: \"\\eff0\"; }\n.ri-picture-in-picture-exit-fill:before { content: \"\\eff1\"; }\n.ri-picture-in-picture-exit-line:before { content: \"\\eff2\"; }\n.ri-picture-in-picture-fill:before { content: \"\\eff3\"; }\n.ri-picture-in-picture-line:before { content: \"\\eff4\"; }\n.ri-pie-chart-2-fill:before { content: \"\\eff5\"; }\n.ri-pie-chart-2-line:before { content: \"\\eff6\"; }\n.ri-pie-chart-box-fill:before { content: \"\\eff7\"; }\n.ri-pie-chart-box-line:before { content: \"\\eff8\"; }\n.ri-pie-chart-fill:before { content: \"\\eff9\"; }\n.ri-pie-chart-line:before { content: \"\\effa\"; }\n.ri-pin-distance-fill:before { content: \"\\effb\"; }\n.ri-pin-distance-line:before { content: \"\\effc\"; }\n.ri-ping-pong-fill:before { content: \"\\effd\"; }\n.ri-ping-pong-line:before { content: \"\\effe\"; }\n.ri-pinterest-fill:before { content: \"\\efff\"; }\n.ri-pinterest-line:before { content: \"\\f000\"; }\n.ri-pinyin-input:before { content: \"\\f001\"; }\n.ri-pixelfed-fill:before { content: \"\\f002\"; }\n.ri-pixelfed-line:before { content: \"\\f003\"; }\n.ri-plane-fill:before { content: \"\\f004\"; }\n.ri-plane-line:before { content: \"\\f005\"; }\n.ri-plant-fill:before { content: \"\\f006\"; }\n.ri-plant-line:before { content: \"\\f007\"; }\n.ri-play-circle-fill:before { content: \"\\f008\"; }\n.ri-play-circle-line:before { content: \"\\f009\"; }\n.ri-play-fill:before { content: \"\\f00a\"; }\n.ri-play-line:before { content: \"\\f00b\"; }\n.ri-play-list-2-fill:before { content: \"\\f00c\"; }\n.ri-play-list-2-line:before { content: \"\\f00d\"; }\n.ri-play-list-add-fill:before { content: \"\\f00e\"; }\n.ri-play-list-add-line:before { content: \"\\f00f\"; }\n.ri-play-list-fill:before { content: \"\\f010\"; }\n.ri-play-list-line:before { content: \"\\f011\"; }\n.ri-play-mini-fill:before { content: \"\\f012\"; }\n.ri-play-mini-line:before { content: \"\\f013\"; }\n.ri-playstation-fill:before { content: \"\\f014\"; }\n.ri-playstation-line:before { content: \"\\f015\"; }\n.ri-plug-2-fill:before { content: \"\\f016\"; }\n.ri-plug-2-line:before { content: \"\\f017\"; }\n.ri-plug-fill:before { content: \"\\f018\"; }\n.ri-plug-line:before { content: \"\\f019\"; }\n.ri-polaroid-2-fill:before { content: \"\\f01a\"; }\n.ri-polaroid-2-line:before { content: \"\\f01b\"; }\n.ri-polaroid-fill:before { content: \"\\f01c\"; }\n.ri-polaroid-line:before { content: \"\\f01d\"; }\n.ri-police-car-fill:before { content: \"\\f01e\"; }\n.ri-police-car-line:before { content: \"\\f01f\"; }\n.ri-price-tag-2-fill:before { content: \"\\f020\"; }\n.ri-price-tag-2-line:before { content: \"\\f021\"; }\n.ri-price-tag-3-fill:before { content: \"\\f022\"; }\n.ri-price-tag-3-line:before { content: \"\\f023\"; }\n.ri-price-tag-fill:before { content: \"\\f024\"; }\n.ri-price-tag-line:before { content: \"\\f025\"; }\n.ri-printer-cloud-fill:before { content: \"\\f026\"; }\n.ri-printer-cloud-line:before { content: \"\\f027\"; }\n.ri-printer-fill:before { content: \"\\f028\"; }\n.ri-printer-line:before { content: \"\\f029\"; }\n.ri-product-hunt-fill:before { content: \"\\f02a\"; }\n.ri-product-hunt-line:before { content: \"\\f02b\"; }\n.ri-profile-fill:before { content: \"\\f02c\"; }\n.ri-profile-line:before { content: \"\\f02d\"; }\n.ri-projector-2-fill:before { content: \"\\f02e\"; }\n.ri-projector-2-line:before { content: \"\\f02f\"; }\n.ri-projector-fill:before { content: \"\\f030\"; }\n.ri-projector-line:before { content: \"\\f031\"; }\n.ri-psychotherapy-fill:before { content: \"\\f032\"; }\n.ri-psychotherapy-line:before { content: \"\\f033\"; }\n.ri-pulse-fill:before { content: \"\\f034\"; }\n.ri-pulse-line:before { content: \"\\f035\"; }\n.ri-pushpin-2-fill:before { content: \"\\f036\"; }\n.ri-pushpin-2-line:before { content: \"\\f037\"; }\n.ri-pushpin-fill:before { content: \"\\f038\"; }\n.ri-pushpin-line:before { content: \"\\f039\"; }\n.ri-qq-fill:before { content: \"\\f03a\"; }\n.ri-qq-line:before { content: \"\\f03b\"; }\n.ri-qr-code-fill:before { content: \"\\f03c\"; }\n.ri-qr-code-line:before { content: \"\\f03d\"; }\n.ri-qr-scan-2-fill:before { content: \"\\f03e\"; }\n.ri-qr-scan-2-line:before { content: \"\\f03f\"; }\n.ri-qr-scan-fill:before { content: \"\\f040\"; }\n.ri-qr-scan-line:before { content: \"\\f041\"; }\n.ri-question-answer-fill:before { content: \"\\f042\"; }\n.ri-question-answer-line:before { content: \"\\f043\"; }\n.ri-question-fill:before { content: \"\\f044\"; }\n.ri-question-line:before { content: \"\\f045\"; }\n.ri-question-mark:before { content: \"\\f046\"; }\n.ri-questionnaire-fill:before { content: \"\\f047\"; }\n.ri-questionnaire-line:before { content: \"\\f048\"; }\n.ri-quill-pen-fill:before { content: \"\\f049\"; }\n.ri-quill-pen-line:before { content: \"\\f04a\"; }\n.ri-radar-fill:before { content: \"\\f04b\"; }\n.ri-radar-line:before { content: \"\\f04c\"; }\n.ri-radio-2-fill:before { content: \"\\f04d\"; }\n.ri-radio-2-line:before { content: \"\\f04e\"; }\n.ri-radio-button-fill:before { content: \"\\f04f\"; }\n.ri-radio-button-line:before { content: \"\\f050\"; }\n.ri-radio-fill:before { content: \"\\f051\"; }\n.ri-radio-line:before { content: \"\\f052\"; }\n.ri-rainbow-fill:before { content: \"\\f053\"; }\n.ri-rainbow-line:before { content: \"\\f054\"; }\n.ri-rainy-fill:before { content: \"\\f055\"; }\n.ri-rainy-line:before { content: \"\\f056\"; }\n.ri-reactjs-fill:before { content: \"\\f057\"; }\n.ri-reactjs-line:before { content: \"\\f058\"; }\n.ri-record-circle-fill:before { content: \"\\f059\"; }\n.ri-record-circle-line:before { content: \"\\f05a\"; }\n.ri-record-mail-fill:before { content: \"\\f05b\"; }\n.ri-record-mail-line:before { content: \"\\f05c\"; }\n.ri-recycle-fill:before { content: \"\\f05d\"; }\n.ri-recycle-line:before { content: \"\\f05e\"; }\n.ri-red-packet-fill:before { content: \"\\f05f\"; }\n.ri-red-packet-line:before { content: \"\\f060\"; }\n.ri-reddit-fill:before { content: \"\\f061\"; }\n.ri-reddit-line:before { content: \"\\f062\"; }\n.ri-refresh-fill:before { content: \"\\f063\"; }\n.ri-refresh-line:before { content: \"\\f064\"; }\n.ri-refund-2-fill:before { content: \"\\f065\"; }\n.ri-refund-2-line:before { content: \"\\f066\"; }\n.ri-refund-fill:before { content: \"\\f067\"; }\n.ri-refund-line:before { content: \"\\f068\"; }\n.ri-registered-fill:before { content: \"\\f069\"; }\n.ri-registered-line:before { content: \"\\f06a\"; }\n.ri-remixicon-fill:before { content: \"\\f06b\"; }\n.ri-remixicon-line:before { content: \"\\f06c\"; }\n.ri-remote-control-2-fill:before { content: \"\\f06d\"; }\n.ri-remote-control-2-line:before { content: \"\\f06e\"; }\n.ri-remote-control-fill:before { content: \"\\f06f\"; }\n.ri-remote-control-line:before { content: \"\\f070\"; }\n.ri-repeat-2-fill:before { content: \"\\f071\"; }\n.ri-repeat-2-line:before { content: \"\\f072\"; }\n.ri-repeat-fill:before { content: \"\\f073\"; }\n.ri-repeat-line:before { content: \"\\f074\"; }\n.ri-repeat-one-fill:before { content: \"\\f075\"; }\n.ri-repeat-one-line:before { content: \"\\f076\"; }\n.ri-reply-all-fill:before { content: \"\\f077\"; }\n.ri-reply-all-line:before { content: \"\\f078\"; }\n.ri-reply-fill:before { content: \"\\f079\"; }\n.ri-reply-line:before { content: \"\\f07a\"; }\n.ri-reserved-fill:before { content: \"\\f07b\"; }\n.ri-reserved-line:before { content: \"\\f07c\"; }\n.ri-rest-time-fill:before { content: \"\\f07d\"; }\n.ri-rest-time-line:before { content: \"\\f07e\"; }\n.ri-restart-fill:before { content: \"\\f07f\"; }\n.ri-restart-line:before { content: \"\\f080\"; }\n.ri-restaurant-2-fill:before { content: \"\\f081\"; }\n.ri-restaurant-2-line:before { content: \"\\f082\"; }\n.ri-restaurant-fill:before { content: \"\\f083\"; }\n.ri-restaurant-line:before { content: \"\\f084\"; }\n.ri-rewind-fill:before { content: \"\\f085\"; }\n.ri-rewind-line:before { content: \"\\f086\"; }\n.ri-rewind-mini-fill:before { content: \"\\f087\"; }\n.ri-rewind-mini-line:before { content: \"\\f088\"; }\n.ri-rhythm-fill:before { content: \"\\f089\"; }\n.ri-rhythm-line:before { content: \"\\f08a\"; }\n.ri-riding-fill:before { content: \"\\f08b\"; }\n.ri-riding-line:before { content: \"\\f08c\"; }\n.ri-road-map-fill:before { content: \"\\f08d\"; }\n.ri-road-map-line:before { content: \"\\f08e\"; }\n.ri-roadster-fill:before { content: \"\\f08f\"; }\n.ri-roadster-line:before { content: \"\\f090\"; }\n.ri-robot-fill:before { content: \"\\f091\"; }\n.ri-robot-line:before { content: \"\\f092\"; }\n.ri-rocket-2-fill:before { content: \"\\f093\"; }\n.ri-rocket-2-line:before { content: \"\\f094\"; }\n.ri-rocket-fill:before { content: \"\\f095\"; }\n.ri-rocket-line:before { content: \"\\f096\"; }\n.ri-rotate-lock-fill:before { content: \"\\f097\"; }\n.ri-rotate-lock-line:before { content: \"\\f098\"; }\n.ri-rounded-corner:before { content: \"\\f099\"; }\n.ri-route-fill:before { content: \"\\f09a\"; }\n.ri-route-line:before { content: \"\\f09b\"; }\n.ri-router-fill:before { content: \"\\f09c\"; }\n.ri-router-line:before { content: \"\\f09d\"; }\n.ri-rss-fill:before { content: \"\\f09e\"; }\n.ri-rss-line:before { content: \"\\f09f\"; }\n.ri-ruler-2-fill:before { content: \"\\f0a0\"; }\n.ri-ruler-2-line:before { content: \"\\f0a1\"; }\n.ri-ruler-fill:before { content: \"\\f0a2\"; }\n.ri-ruler-line:before { content: \"\\f0a3\"; }\n.ri-run-fill:before { content: \"\\f0a4\"; }\n.ri-run-line:before { content: \"\\f0a5\"; }\n.ri-safari-fill:before { content: \"\\f0a6\"; }\n.ri-safari-line:before { content: \"\\f0a7\"; }\n.ri-safe-2-fill:before { content: \"\\f0a8\"; }\n.ri-safe-2-line:before { content: \"\\f0a9\"; }\n.ri-safe-fill:before { content: \"\\f0aa\"; }\n.ri-safe-line:before { content: \"\\f0ab\"; }\n.ri-sailboat-fill:before { content: \"\\f0ac\"; }\n.ri-sailboat-line:before { content: \"\\f0ad\"; }\n.ri-save-2-fill:before { content: \"\\f0ae\"; }\n.ri-save-2-line:before { content: \"\\f0af\"; }\n.ri-save-3-fill:before { content: \"\\f0b0\"; }\n.ri-save-3-line:before { content: \"\\f0b1\"; }\n.ri-save-fill:before { content: \"\\f0b2\"; }\n.ri-save-line:before { content: \"\\f0b3\"; }\n.ri-scales-2-fill:before { content: \"\\f0b4\"; }\n.ri-scales-2-line:before { content: \"\\f0b5\"; }\n.ri-scales-3-fill:before { content: \"\\f0b6\"; }\n.ri-scales-3-line:before { content: \"\\f0b7\"; }\n.ri-scales-fill:before { content: \"\\f0b8\"; }\n.ri-scales-line:before { content: \"\\f0b9\"; }\n.ri-scan-2-fill:before { content: \"\\f0ba\"; }\n.ri-scan-2-line:before { content: \"\\f0bb\"; }\n.ri-scan-fill:before { content: \"\\f0bc\"; }\n.ri-scan-line:before { content: \"\\f0bd\"; }\n.ri-scissors-2-fill:before { content: \"\\f0be\"; }\n.ri-scissors-2-line:before { content: \"\\f0bf\"; }\n.ri-scissors-cut-fill:before { content: \"\\f0c0\"; }\n.ri-scissors-cut-line:before { content: \"\\f0c1\"; }\n.ri-scissors-fill:before { content: \"\\f0c2\"; }\n.ri-scissors-line:before { content: \"\\f0c3\"; }\n.ri-screenshot-2-fill:before { content: \"\\f0c4\"; }\n.ri-screenshot-2-line:before { content: \"\\f0c5\"; }\n.ri-screenshot-fill:before { content: \"\\f0c6\"; }\n.ri-screenshot-line:before { content: \"\\f0c7\"; }\n.ri-sd-card-fill:before { content: \"\\f0c8\"; }\n.ri-sd-card-line:before { content: \"\\f0c9\"; }\n.ri-sd-card-mini-fill:before { content: \"\\f0ca\"; }\n.ri-sd-card-mini-line:before { content: \"\\f0cb\"; }\n.ri-search-2-fill:before { content: \"\\f0cc\"; }\n.ri-search-2-line:before { content: \"\\f0cd\"; }\n.ri-search-eye-fill:before { content: \"\\f0ce\"; }\n.ri-search-eye-line:before { content: \"\\f0cf\"; }\n.ri-search-fill:before { content: \"\\f0d0\"; }\n.ri-search-line:before { content: \"\\f0d1\"; }\n.ri-secure-payment-fill:before { content: \"\\f0d2\"; }\n.ri-secure-payment-line:before { content: \"\\f0d3\"; }\n.ri-seedling-fill:before { content: \"\\f0d4\"; }\n.ri-seedling-line:before { content: \"\\f0d5\"; }\n.ri-send-backward:before { content: \"\\f0d6\"; }\n.ri-send-plane-2-fill:before { content: \"\\f0d7\"; }\n.ri-send-plane-2-line:before { content: \"\\f0d8\"; }\n.ri-send-plane-fill:before { content: \"\\f0d9\"; }\n.ri-send-plane-line:before { content: \"\\f0da\"; }\n.ri-send-to-back:before { content: \"\\f0db\"; }\n.ri-sensor-fill:before { content: \"\\f0dc\"; }\n.ri-sensor-line:before { content: \"\\f0dd\"; }\n.ri-separator:before { content: \"\\f0de\"; }\n.ri-server-fill:before { content: \"\\f0df\"; }\n.ri-server-line:before { content: \"\\f0e0\"; }\n.ri-service-fill:before { content: \"\\f0e1\"; }\n.ri-service-line:before { content: \"\\f0e2\"; }\n.ri-settings-2-fill:before { content: \"\\f0e3\"; }\n.ri-settings-2-line:before { content: \"\\f0e4\"; }\n.ri-settings-3-fill:before { content: \"\\f0e5\"; }\n.ri-settings-3-line:before { content: \"\\f0e6\"; }\n.ri-settings-4-fill:before { content: \"\\f0e7\"; }\n.ri-settings-4-line:before { content: \"\\f0e8\"; }\n.ri-settings-5-fill:before { content: \"\\f0e9\"; }\n.ri-settings-5-line:before { content: \"\\f0ea\"; }\n.ri-settings-6-fill:before { content: \"\\f0eb\"; }\n.ri-settings-6-line:before { content: \"\\f0ec\"; }\n.ri-settings-fill:before { content: \"\\f0ed\"; }\n.ri-settings-line:before { content: \"\\f0ee\"; }\n.ri-shape-2-fill:before { content: \"\\f0ef\"; }\n.ri-shape-2-line:before { content: \"\\f0f0\"; }\n.ri-shape-fill:before { content: \"\\f0f1\"; }\n.ri-shape-line:before { content: \"\\f0f2\"; }\n.ri-share-box-fill:before { content: \"\\f0f3\"; }\n.ri-share-box-line:before { content: \"\\f0f4\"; }\n.ri-share-circle-fill:before { content: \"\\f0f5\"; }\n.ri-share-circle-line:before { content: \"\\f0f6\"; }\n.ri-share-fill:before { content: \"\\f0f7\"; }\n.ri-share-forward-2-fill:before { content: \"\\f0f8\"; }\n.ri-share-forward-2-line:before { content: \"\\f0f9\"; }\n.ri-share-forward-box-fill:before { content: \"\\f0fa\"; }\n.ri-share-forward-box-line:before { content: \"\\f0fb\"; }\n.ri-share-forward-fill:before { content: \"\\f0fc\"; }\n.ri-share-forward-line:before { content: \"\\f0fd\"; }\n.ri-share-line:before { content: \"\\f0fe\"; }\n.ri-shield-check-fill:before { content: \"\\f0ff\"; }\n.ri-shield-check-line:before { content: \"\\f100\"; }\n.ri-shield-cross-fill:before { content: \"\\f101\"; }\n.ri-shield-cross-line:before { content: \"\\f102\"; }\n.ri-shield-fill:before { content: \"\\f103\"; }\n.ri-shield-flash-fill:before { content: \"\\f104\"; }\n.ri-shield-flash-line:before { content: \"\\f105\"; }\n.ri-shield-keyhole-fill:before { content: \"\\f106\"; }\n.ri-shield-keyhole-line:before { content: \"\\f107\"; }\n.ri-shield-line:before { content: \"\\f108\"; }\n.ri-shield-star-fill:before { content: \"\\f109\"; }\n.ri-shield-star-line:before { content: \"\\f10a\"; }\n.ri-shield-user-fill:before { content: \"\\f10b\"; }\n.ri-shield-user-line:before { content: \"\\f10c\"; }\n.ri-ship-2-fill:before { content: \"\\f10d\"; }\n.ri-ship-2-line:before { content: \"\\f10e\"; }\n.ri-ship-fill:before { content: \"\\f10f\"; }\n.ri-ship-line:before { content: \"\\f110\"; }\n.ri-shirt-fill:before { content: \"\\f111\"; }\n.ri-shirt-line:before { content: \"\\f112\"; }\n.ri-shopping-bag-2-fill:before { content: \"\\f113\"; }\n.ri-shopping-bag-2-line:before { content: \"\\f114\"; }\n.ri-shopping-bag-3-fill:before { content: \"\\f115\"; }\n.ri-shopping-bag-3-line:before { content: \"\\f116\"; }\n.ri-shopping-bag-fill:before { content: \"\\f117\"; }\n.ri-shopping-bag-line:before { content: \"\\f118\"; }\n.ri-shopping-basket-2-fill:before { content: \"\\f119\"; }\n.ri-shopping-basket-2-line:before { content: \"\\f11a\"; }\n.ri-shopping-basket-fill:before { content: \"\\f11b\"; }\n.ri-shopping-basket-line:before { content: \"\\f11c\"; }\n.ri-shopping-cart-2-fill:before { content: \"\\f11d\"; }\n.ri-shopping-cart-2-line:before { content: \"\\f11e\"; }\n.ri-shopping-cart-fill:before { content: \"\\f11f\"; }\n.ri-shopping-cart-line:before { content: \"\\f120\"; }\n.ri-showers-fill:before { content: \"\\f121\"; }\n.ri-showers-line:before { content: \"\\f122\"; }\n.ri-shuffle-fill:before { content: \"\\f123\"; }\n.ri-shuffle-line:before { content: \"\\f124\"; }\n.ri-shut-down-fill:before { content: \"\\f125\"; }\n.ri-shut-down-line:before { content: \"\\f126\"; }\n.ri-side-bar-fill:before { content: \"\\f127\"; }\n.ri-side-bar-line:before { content: \"\\f128\"; }\n.ri-signal-tower-fill:before { content: \"\\f129\"; }\n.ri-signal-tower-line:before { content: \"\\f12a\"; }\n.ri-signal-wifi-1-fill:before { content: \"\\f12b\"; }\n.ri-signal-wifi-1-line:before { content: \"\\f12c\"; }\n.ri-signal-wifi-2-fill:before { content: \"\\f12d\"; }\n.ri-signal-wifi-2-line:before { content: \"\\f12e\"; }\n.ri-signal-wifi-3-fill:before { content: \"\\f12f\"; }\n.ri-signal-wifi-3-line:before { content: \"\\f130\"; }\n.ri-signal-wifi-error-fill:before { content: \"\\f131\"; }\n.ri-signal-wifi-error-line:before { content: \"\\f132\"; }\n.ri-signal-wifi-fill:before { content: \"\\f133\"; }\n.ri-signal-wifi-line:before { content: \"\\f134\"; }\n.ri-signal-wifi-off-fill:before { content: \"\\f135\"; }\n.ri-signal-wifi-off-line:before { content: \"\\f136\"; }\n.ri-sim-card-2-fill:before { content: \"\\f137\"; }\n.ri-sim-card-2-line:before { content: \"\\f138\"; }\n.ri-sim-card-fill:before { content: \"\\f139\"; }\n.ri-sim-card-line:before { content: \"\\f13a\"; }\n.ri-single-quotes-l:before { content: \"\\f13b\"; }\n.ri-single-quotes-r:before { content: \"\\f13c\"; }\n.ri-sip-fill:before { content: \"\\f13d\"; }\n.ri-sip-line:before { content: \"\\f13e\"; }\n.ri-skip-back-fill:before { content: \"\\f13f\"; }\n.ri-skip-back-line:before { content: \"\\f140\"; }\n.ri-skip-back-mini-fill:before { content: \"\\f141\"; }\n.ri-skip-back-mini-line:before { content: \"\\f142\"; }\n.ri-skip-forward-fill:before { content: \"\\f143\"; }\n.ri-skip-forward-line:before { content: \"\\f144\"; }\n.ri-skip-forward-mini-fill:before { content: \"\\f145\"; }\n.ri-skip-forward-mini-line:before { content: \"\\f146\"; }\n.ri-skull-2-fill:before { content: \"\\f147\"; }\n.ri-skull-2-line:before { content: \"\\f148\"; }\n.ri-skull-fill:before { content: \"\\f149\"; }\n.ri-skull-line:before { content: \"\\f14a\"; }\n.ri-skype-fill:before { content: \"\\f14b\"; }\n.ri-skype-line:before { content: \"\\f14c\"; }\n.ri-slack-fill:before { content: \"\\f14d\"; }\n.ri-slack-line:before { content: \"\\f14e\"; }\n.ri-slice-fill:before { content: \"\\f14f\"; }\n.ri-slice-line:before { content: \"\\f150\"; }\n.ri-slideshow-2-fill:before { content: \"\\f151\"; }\n.ri-slideshow-2-line:before { content: \"\\f152\"; }\n.ri-slideshow-3-fill:before { content: \"\\f153\"; }\n.ri-slideshow-3-line:before { content: \"\\f154\"; }\n.ri-slideshow-4-fill:before { content: \"\\f155\"; }\n.ri-slideshow-4-line:before { content: \"\\f156\"; }\n.ri-slideshow-fill:before { content: \"\\f157\"; }\n.ri-slideshow-line:before { content: \"\\f158\"; }\n.ri-smartphone-fill:before { content: \"\\f159\"; }\n.ri-smartphone-line:before { content: \"\\f15a\"; }\n.ri-snapchat-fill:before { content: \"\\f15b\"; }\n.ri-snapchat-line:before { content: \"\\f15c\"; }\n.ri-snowy-fill:before { content: \"\\f15d\"; }\n.ri-snowy-line:before { content: \"\\f15e\"; }\n.ri-sort-asc:before { content: \"\\f15f\"; }\n.ri-sort-desc:before { content: \"\\f160\"; }\n.ri-sound-module-fill:before { content: \"\\f161\"; }\n.ri-sound-module-line:before { content: \"\\f162\"; }\n.ri-soundcloud-fill:before { content: \"\\f163\"; }\n.ri-soundcloud-line:before { content: \"\\f164\"; }\n.ri-space-ship-fill:before { content: \"\\f165\"; }\n.ri-space-ship-line:before { content: \"\\f166\"; }\n.ri-space:before { content: \"\\f167\"; }\n.ri-spam-2-fill:before { content: \"\\f168\"; }\n.ri-spam-2-line:before { content: \"\\f169\"; }\n.ri-spam-3-fill:before { content: \"\\f16a\"; }\n.ri-spam-3-line:before { content: \"\\f16b\"; }\n.ri-spam-fill:before { content: \"\\f16c\"; }\n.ri-spam-line:before { content: \"\\f16d\"; }\n.ri-speaker-2-fill:before { content: \"\\f16e\"; }\n.ri-speaker-2-line:before { content: \"\\f16f\"; }\n.ri-speaker-3-fill:before { content: \"\\f170\"; }\n.ri-speaker-3-line:before { content: \"\\f171\"; }\n.ri-speaker-fill:before { content: \"\\f172\"; }\n.ri-speaker-line:before { content: \"\\f173\"; }\n.ri-spectrum-fill:before { content: \"\\f174\"; }\n.ri-spectrum-line:before { content: \"\\f175\"; }\n.ri-speed-fill:before { content: \"\\f176\"; }\n.ri-speed-line:before { content: \"\\f177\"; }\n.ri-speed-mini-fill:before { content: \"\\f178\"; }\n.ri-speed-mini-line:before { content: \"\\f179\"; }\n.ri-split-cells-horizontal:before { content: \"\\f17a\"; }\n.ri-split-cells-vertical:before { content: \"\\f17b\"; }\n.ri-spotify-fill:before { content: \"\\f17c\"; }\n.ri-spotify-line:before { content: \"\\f17d\"; }\n.ri-spy-fill:before { content: \"\\f17e\"; }\n.ri-spy-line:before { content: \"\\f17f\"; }\n.ri-stack-fill:before { content: \"\\f180\"; }\n.ri-stack-line:before { content: \"\\f181\"; }\n.ri-stack-overflow-fill:before { content: \"\\f182\"; }\n.ri-stack-overflow-line:before { content: \"\\f183\"; }\n.ri-stackshare-fill:before { content: \"\\f184\"; }\n.ri-stackshare-line:before { content: \"\\f185\"; }\n.ri-star-fill:before { content: \"\\f186\"; }\n.ri-star-half-fill:before { content: \"\\f187\"; }\n.ri-star-half-line:before { content: \"\\f188\"; }\n.ri-star-half-s-fill:before { content: \"\\f189\"; }\n.ri-star-half-s-line:before { content: \"\\f18a\"; }\n.ri-star-line:before { content: \"\\f18b\"; }\n.ri-star-s-fill:before { content: \"\\f18c\"; }\n.ri-star-s-line:before { content: \"\\f18d\"; }\n.ri-star-smile-fill:before { content: \"\\f18e\"; }\n.ri-star-smile-line:before { content: \"\\f18f\"; }\n.ri-steam-fill:before { content: \"\\f190\"; }\n.ri-steam-line:before { content: \"\\f191\"; }\n.ri-steering-2-fill:before { content: \"\\f192\"; }\n.ri-steering-2-line:before { content: \"\\f193\"; }\n.ri-steering-fill:before { content: \"\\f194\"; }\n.ri-steering-line:before { content: \"\\f195\"; }\n.ri-stethoscope-fill:before { content: \"\\f196\"; }\n.ri-stethoscope-line:before { content: \"\\f197\"; }\n.ri-sticky-note-2-fill:before { content: \"\\f198\"; }\n.ri-sticky-note-2-line:before { content: \"\\f199\"; }\n.ri-sticky-note-fill:before { content: \"\\f19a\"; }\n.ri-sticky-note-line:before { content: \"\\f19b\"; }\n.ri-stock-fill:before { content: \"\\f19c\"; }\n.ri-stock-line:before { content: \"\\f19d\"; }\n.ri-stop-circle-fill:before { content: \"\\f19e\"; }\n.ri-stop-circle-line:before { content: \"\\f19f\"; }\n.ri-stop-fill:before { content: \"\\f1a0\"; }\n.ri-stop-line:before { content: \"\\f1a1\"; }\n.ri-stop-mini-fill:before { content: \"\\f1a2\"; }\n.ri-stop-mini-line:before { content: \"\\f1a3\"; }\n.ri-store-2-fill:before { content: \"\\f1a4\"; }\n.ri-store-2-line:before { content: \"\\f1a5\"; }\n.ri-store-3-fill:before { content: \"\\f1a6\"; }\n.ri-store-3-line:before { content: \"\\f1a7\"; }\n.ri-store-fill:before { content: \"\\f1a8\"; }\n.ri-store-line:before { content: \"\\f1a9\"; }\n.ri-strikethrough-2:before { content: \"\\f1aa\"; }\n.ri-strikethrough:before { content: \"\\f1ab\"; }\n.ri-subscript-2:before { content: \"\\f1ac\"; }\n.ri-subscript:before { content: \"\\f1ad\"; }\n.ri-subtract-fill:before { content: \"\\f1ae\"; }\n.ri-subtract-line:before { content: \"\\f1af\"; }\n.ri-subway-fill:before { content: \"\\f1b0\"; }\n.ri-subway-line:before { content: \"\\f1b1\"; }\n.ri-subway-wifi-fill:before { content: \"\\f1b2\"; }\n.ri-subway-wifi-line:before { content: \"\\f1b3\"; }\n.ri-suitcase-2-fill:before { content: \"\\f1b4\"; }\n.ri-suitcase-2-line:before { content: \"\\f1b5\"; }\n.ri-suitcase-3-fill:before { content: \"\\f1b6\"; }\n.ri-suitcase-3-line:before { content: \"\\f1b7\"; }\n.ri-suitcase-fill:before { content: \"\\f1b8\"; }\n.ri-suitcase-line:before { content: \"\\f1b9\"; }\n.ri-sun-cloudy-fill:before { content: \"\\f1ba\"; }\n.ri-sun-cloudy-line:before { content: \"\\f1bb\"; }\n.ri-sun-fill:before { content: \"\\f1bc\"; }\n.ri-sun-foggy-fill:before { content: \"\\f1bd\"; }\n.ri-sun-foggy-line:before { content: \"\\f1be\"; }\n.ri-sun-line:before { content: \"\\f1bf\"; }\n.ri-superscript-2:before { content: \"\\f1c0\"; }\n.ri-superscript:before { content: \"\\f1c1\"; }\n.ri-surgical-mask-fill:before { content: \"\\f1c2\"; }\n.ri-surgical-mask-line:before { content: \"\\f1c3\"; }\n.ri-surround-sound-fill:before { content: \"\\f1c4\"; }\n.ri-surround-sound-line:before { content: \"\\f1c5\"; }\n.ri-survey-fill:before { content: \"\\f1c6\"; }\n.ri-survey-line:before { content: \"\\f1c7\"; }\n.ri-swap-box-fill:before { content: \"\\f1c8\"; }\n.ri-swap-box-line:before { content: \"\\f1c9\"; }\n.ri-swap-fill:before { content: \"\\f1ca\"; }\n.ri-swap-line:before { content: \"\\f1cb\"; }\n.ri-switch-fill:before { content: \"\\f1cc\"; }\n.ri-switch-line:before { content: \"\\f1cd\"; }\n.ri-sword-fill:before { content: \"\\f1ce\"; }\n.ri-sword-line:before { content: \"\\f1cf\"; }\n.ri-syringe-fill:before { content: \"\\f1d0\"; }\n.ri-syringe-line:before { content: \"\\f1d1\"; }\n.ri-t-box-fill:before { content: \"\\f1d2\"; }\n.ri-t-box-line:before { content: \"\\f1d3\"; }\n.ri-t-shirt-2-fill:before { content: \"\\f1d4\"; }\n.ri-t-shirt-2-line:before { content: \"\\f1d5\"; }\n.ri-t-shirt-air-fill:before { content: \"\\f1d6\"; }\n.ri-t-shirt-air-line:before { content: \"\\f1d7\"; }\n.ri-t-shirt-fill:before { content: \"\\f1d8\"; }\n.ri-t-shirt-line:before { content: \"\\f1d9\"; }\n.ri-table-2:before { content: \"\\f1da\"; }\n.ri-table-alt-fill:before { content: \"\\f1db\"; }\n.ri-table-alt-line:before { content: \"\\f1dc\"; }\n.ri-table-fill:before { content: \"\\f1dd\"; }\n.ri-table-line:before { content: \"\\f1de\"; }\n.ri-tablet-fill:before { content: \"\\f1df\"; }\n.ri-tablet-line:before { content: \"\\f1e0\"; }\n.ri-takeaway-fill:before { content: \"\\f1e1\"; }\n.ri-takeaway-line:before { content: \"\\f1e2\"; }\n.ri-taobao-fill:before { content: \"\\f1e3\"; }\n.ri-taobao-line:before { content: \"\\f1e4\"; }\n.ri-tape-fill:before { content: \"\\f1e5\"; }\n.ri-tape-line:before { content: \"\\f1e6\"; }\n.ri-task-fill:before { content: \"\\f1e7\"; }\n.ri-task-line:before { content: \"\\f1e8\"; }\n.ri-taxi-fill:before { content: \"\\f1e9\"; }\n.ri-taxi-line:before { content: \"\\f1ea\"; }\n.ri-taxi-wifi-fill:before { content: \"\\f1eb\"; }\n.ri-taxi-wifi-line:before { content: \"\\f1ec\"; }\n.ri-team-fill:before { content: \"\\f1ed\"; }\n.ri-team-line:before { content: \"\\f1ee\"; }\n.ri-telegram-fill:before { content: \"\\f1ef\"; }\n.ri-telegram-line:before { content: \"\\f1f0\"; }\n.ri-temp-cold-fill:before { content: \"\\f1f1\"; }\n.ri-temp-cold-line:before { content: \"\\f1f2\"; }\n.ri-temp-hot-fill:before { content: \"\\f1f3\"; }\n.ri-temp-hot-line:before { content: \"\\f1f4\"; }\n.ri-terminal-box-fill:before { content: \"\\f1f5\"; }\n.ri-terminal-box-line:before { content: \"\\f1f6\"; }\n.ri-terminal-fill:before { content: \"\\f1f7\"; }\n.ri-terminal-line:before { content: \"\\f1f8\"; }\n.ri-terminal-window-fill:before { content: \"\\f1f9\"; }\n.ri-terminal-window-line:before { content: \"\\f1fa\"; }\n.ri-test-tube-fill:before { content: \"\\f1fb\"; }\n.ri-test-tube-line:before { content: \"\\f1fc\"; }\n.ri-text-direction-l:before { content: \"\\f1fd\"; }\n.ri-text-direction-r:before { content: \"\\f1fe\"; }\n.ri-text-spacing:before { content: \"\\f1ff\"; }\n.ri-text-wrap:before { content: \"\\f200\"; }\n.ri-text:before { content: \"\\f201\"; }\n.ri-thermometer-fill:before { content: \"\\f202\"; }\n.ri-thermometer-line:before { content: \"\\f203\"; }\n.ri-thumb-down-fill:before { content: \"\\f204\"; }\n.ri-thumb-down-line:before { content: \"\\f205\"; }\n.ri-thumb-up-fill:before { content: \"\\f206\"; }\n.ri-thumb-up-line:before { content: \"\\f207\"; }\n.ri-thunderstorms-fill:before { content: \"\\f208\"; }\n.ri-thunderstorms-line:before { content: \"\\f209\"; }\n.ri-ticket-2-fill:before { content: \"\\f20a\"; }\n.ri-ticket-2-line:before { content: \"\\f20b\"; }\n.ri-ticket-fill:before { content: \"\\f20c\"; }\n.ri-ticket-line:before { content: \"\\f20d\"; }\n.ri-time-fill:before { content: \"\\f20e\"; }\n.ri-time-line:before { content: \"\\f20f\"; }\n.ri-timer-2-fill:before { content: \"\\f210\"; }\n.ri-timer-2-line:before { content: \"\\f211\"; }\n.ri-timer-fill:before { content: \"\\f212\"; }\n.ri-timer-flash-fill:before { content: \"\\f213\"; }\n.ri-timer-flash-line:before { content: \"\\f214\"; }\n.ri-timer-line:before { content: \"\\f215\"; }\n.ri-todo-fill:before { content: \"\\f216\"; }\n.ri-todo-line:before { content: \"\\f217\"; }\n.ri-toggle-fill:before { content: \"\\f218\"; }\n.ri-toggle-line:before { content: \"\\f219\"; }\n.ri-tools-fill:before { content: \"\\f21a\"; }\n.ri-tools-line:before { content: \"\\f21b\"; }\n.ri-tornado-fill:before { content: \"\\f21c\"; }\n.ri-tornado-line:before { content: \"\\f21d\"; }\n.ri-trademark-fill:before { content: \"\\f21e\"; }\n.ri-trademark-line:before { content: \"\\f21f\"; }\n.ri-traffic-light-fill:before { content: \"\\f220\"; }\n.ri-traffic-light-line:before { content: \"\\f221\"; }\n.ri-train-fill:before { content: \"\\f222\"; }\n.ri-train-line:before { content: \"\\f223\"; }\n.ri-train-wifi-fill:before { content: \"\\f224\"; }\n.ri-train-wifi-line:before { content: \"\\f225\"; }\n.ri-translate-2:before { content: \"\\f226\"; }\n.ri-translate:before { content: \"\\f227\"; }\n.ri-travesti-fill:before { content: \"\\f228\"; }\n.ri-travesti-line:before { content: \"\\f229\"; }\n.ri-treasure-map-fill:before { content: \"\\f22a\"; }\n.ri-treasure-map-line:before { content: \"\\f22b\"; }\n.ri-trello-fill:before { content: \"\\f22c\"; }\n.ri-trello-line:before { content: \"\\f22d\"; }\n.ri-trophy-fill:before { content: \"\\f22e\"; }\n.ri-trophy-line:before { content: \"\\f22f\"; }\n.ri-truck-fill:before { content: \"\\f230\"; }\n.ri-truck-line:before { content: \"\\f231\"; }\n.ri-tumblr-fill:before { content: \"\\f232\"; }\n.ri-tumblr-line:before { content: \"\\f233\"; }\n.ri-tv-2-fill:before { content: \"\\f234\"; }\n.ri-tv-2-line:before { content: \"\\f235\"; }\n.ri-tv-fill:before { content: \"\\f236\"; }\n.ri-tv-line:before { content: \"\\f237\"; }\n.ri-twitch-fill:before { content: \"\\f238\"; }\n.ri-twitch-line:before { content: \"\\f239\"; }\n.ri-twitter-fill:before { content: \"\\f23a\"; }\n.ri-twitter-line:before { content: \"\\f23b\"; }\n.ri-typhoon-fill:before { content: \"\\f23c\"; }\n.ri-typhoon-line:before { content: \"\\f23d\"; }\n.ri-u-disk-fill:before { content: \"\\f23e\"; }\n.ri-u-disk-line:before { content: \"\\f23f\"; }\n.ri-ubuntu-fill:before { content: \"\\f240\"; }\n.ri-ubuntu-line:before { content: \"\\f241\"; }\n.ri-umbrella-fill:before { content: \"\\f242\"; }\n.ri-umbrella-line:before { content: \"\\f243\"; }\n.ri-underline:before { content: \"\\f244\"; }\n.ri-uninstall-fill:before { content: \"\\f245\"; }\n.ri-uninstall-line:before { content: \"\\f246\"; }\n.ri-unsplash-fill:before { content: \"\\f247\"; }\n.ri-unsplash-line:before { content: \"\\f248\"; }\n.ri-upload-2-fill:before { content: \"\\f249\"; }\n.ri-upload-2-line:before { content: \"\\f24a\"; }\n.ri-upload-cloud-2-fill:before { content: \"\\f24b\"; }\n.ri-upload-cloud-2-line:before { content: \"\\f24c\"; }\n.ri-upload-cloud-fill:before { content: \"\\f24d\"; }\n.ri-upload-cloud-line:before { content: \"\\f24e\"; }\n.ri-upload-fill:before { content: \"\\f24f\"; }\n.ri-upload-line:before { content: \"\\f250\"; }\n.ri-usb-fill:before { content: \"\\f251\"; }\n.ri-usb-line:before { content: \"\\f252\"; }\n.ri-user-2-fill:before { content: \"\\f253\"; }\n.ri-user-2-line:before { content: \"\\f254\"; }\n.ri-user-3-fill:before { content: \"\\f255\"; }\n.ri-user-3-line:before { content: \"\\f256\"; }\n.ri-user-4-fill:before { content: \"\\f257\"; }\n.ri-user-4-line:before { content: \"\\f258\"; }\n.ri-user-5-fill:before { content: \"\\f259\"; }\n.ri-user-5-line:before { content: \"\\f25a\"; }\n.ri-user-6-fill:before { content: \"\\f25b\"; }\n.ri-user-6-line:before { content: \"\\f25c\"; }\n.ri-user-add-fill:before { content: \"\\f25d\"; }\n.ri-user-add-line:before { content: \"\\f25e\"; }\n.ri-user-fill:before { content: \"\\f25f\"; }\n.ri-user-follow-fill:before { content: \"\\f260\"; }\n.ri-user-follow-line:before { content: \"\\f261\"; }\n.ri-user-heart-fill:before { content: \"\\f262\"; }\n.ri-user-heart-line:before { content: \"\\f263\"; }\n.ri-user-line:before { content: \"\\f264\"; }\n.ri-user-location-fill:before { content: \"\\f265\"; }\n.ri-user-location-line:before { content: \"\\f266\"; }\n.ri-user-received-2-fill:before { content: \"\\f267\"; }\n.ri-user-received-2-line:before { content: \"\\f268\"; }\n.ri-user-received-fill:before { content: \"\\f269\"; }\n.ri-user-received-line:before { content: \"\\f26a\"; }\n.ri-user-search-fill:before { content: \"\\f26b\"; }\n.ri-user-search-line:before { content: \"\\f26c\"; }\n.ri-user-settings-fill:before { content: \"\\f26d\"; }\n.ri-user-settings-line:before { content: \"\\f26e\"; }\n.ri-user-shared-2-fill:before { content: \"\\f26f\"; }\n.ri-user-shared-2-line:before { content: \"\\f270\"; }\n.ri-user-shared-fill:before { content: \"\\f271\"; }\n.ri-user-shared-line:before { content: \"\\f272\"; }\n.ri-user-smile-fill:before { content: \"\\f273\"; }\n.ri-user-smile-line:before { content: \"\\f274\"; }\n.ri-user-star-fill:before { content: \"\\f275\"; }\n.ri-user-star-line:before { content: \"\\f276\"; }\n.ri-user-unfollow-fill:before { content: \"\\f277\"; }\n.ri-user-unfollow-line:before { content: \"\\f278\"; }\n.ri-user-voice-fill:before { content: \"\\f279\"; }\n.ri-user-voice-line:before { content: \"\\f27a\"; }\n.ri-video-add-fill:before { content: \"\\f27b\"; }\n.ri-video-add-line:before { content: \"\\f27c\"; }\n.ri-video-chat-fill:before { content: \"\\f27d\"; }\n.ri-video-chat-line:before { content: \"\\f27e\"; }\n.ri-video-download-fill:before { content: \"\\f27f\"; }\n.ri-video-download-line:before { content: \"\\f280\"; }\n.ri-video-fill:before { content: \"\\f281\"; }\n.ri-video-line:before { content: \"\\f282\"; }\n.ri-video-upload-fill:before { content: \"\\f283\"; }\n.ri-video-upload-line:before { content: \"\\f284\"; }\n.ri-vidicon-2-fill:before { content: \"\\f285\"; }\n.ri-vidicon-2-line:before { content: \"\\f286\"; }\n.ri-vidicon-fill:before { content: \"\\f287\"; }\n.ri-vidicon-line:before { content: \"\\f288\"; }\n.ri-vimeo-fill:before { content: \"\\f289\"; }\n.ri-vimeo-line:before { content: \"\\f28a\"; }\n.ri-vip-crown-2-fill:before { content: \"\\f28b\"; }\n.ri-vip-crown-2-line:before { content: \"\\f28c\"; }\n.ri-vip-crown-fill:before { content: \"\\f28d\"; }\n.ri-vip-crown-line:before { content: \"\\f28e\"; }\n.ri-vip-diamond-fill:before { content: \"\\f28f\"; }\n.ri-vip-diamond-line:before { content: \"\\f290\"; }\n.ri-vip-fill:before { content: \"\\f291\"; }\n.ri-vip-line:before { content: \"\\f292\"; }\n.ri-virus-fill:before { content: \"\\f293\"; }\n.ri-virus-line:before { content: \"\\f294\"; }\n.ri-visa-fill:before { content: \"\\f295\"; }\n.ri-visa-line:before { content: \"\\f296\"; }\n.ri-voice-recognition-fill:before { content: \"\\f297\"; }\n.ri-voice-recognition-line:before { content: \"\\f298\"; }\n.ri-voiceprint-fill:before { content: \"\\f299\"; }\n.ri-voiceprint-line:before { content: \"\\f29a\"; }\n.ri-volume-down-fill:before { content: \"\\f29b\"; }\n.ri-volume-down-line:before { content: \"\\f29c\"; }\n.ri-volume-mute-fill:before { content: \"\\f29d\"; }\n.ri-volume-mute-line:before { content: \"\\f29e\"; }\n.ri-volume-off-vibrate-fill:before { content: \"\\f29f\"; }\n.ri-volume-off-vibrate-line:before { content: \"\\f2a0\"; }\n.ri-volume-up-fill:before { content: \"\\f2a1\"; }\n.ri-volume-up-line:before { content: \"\\f2a2\"; }\n.ri-volume-vibrate-fill:before { content: \"\\f2a3\"; }\n.ri-volume-vibrate-line:before { content: \"\\f2a4\"; }\n.ri-vuejs-fill:before { content: \"\\f2a5\"; }\n.ri-vuejs-line:before { content: \"\\f2a6\"; }\n.ri-walk-fill:before { content: \"\\f2a7\"; }\n.ri-walk-line:before { content: \"\\f2a8\"; }\n.ri-wallet-2-fill:before { content: \"\\f2a9\"; }\n.ri-wallet-2-line:before { content: \"\\f2aa\"; }\n.ri-wallet-3-fill:before { content: \"\\f2ab\"; }\n.ri-wallet-3-line:before { content: \"\\f2ac\"; }\n.ri-wallet-fill:before { content: \"\\f2ad\"; }\n.ri-wallet-line:before { content: \"\\f2ae\"; }\n.ri-water-flash-fill:before { content: \"\\f2af\"; }\n.ri-water-flash-line:before { content: \"\\f2b0\"; }\n.ri-webcam-fill:before { content: \"\\f2b1\"; }\n.ri-webcam-line:before { content: \"\\f2b2\"; }\n.ri-wechat-2-fill:before { content: \"\\f2b3\"; }\n.ri-wechat-2-line:before { content: \"\\f2b4\"; }\n.ri-wechat-fill:before { content: \"\\f2b5\"; }\n.ri-wechat-line:before { content: \"\\f2b6\"; }\n.ri-wechat-pay-fill:before { content: \"\\f2b7\"; }\n.ri-wechat-pay-line:before { content: \"\\f2b8\"; }\n.ri-weibo-fill:before { content: \"\\f2b9\"; }\n.ri-weibo-line:before { content: \"\\f2ba\"; }\n.ri-whatsapp-fill:before { content: \"\\f2bb\"; }\n.ri-whatsapp-line:before { content: \"\\f2bc\"; }\n.ri-wheelchair-fill:before { content: \"\\f2bd\"; }\n.ri-wheelchair-line:before { content: \"\\f2be\"; }\n.ri-wifi-fill:before { content: \"\\f2bf\"; }\n.ri-wifi-line:before { content: \"\\f2c0\"; }\n.ri-wifi-off-fill:before { content: \"\\f2c1\"; }\n.ri-wifi-off-line:before { content: \"\\f2c2\"; }\n.ri-window-2-fill:before { content: \"\\f2c3\"; }\n.ri-window-2-line:before { content: \"\\f2c4\"; }\n.ri-window-fill:before { content: \"\\f2c5\"; }\n.ri-window-line:before { content: \"\\f2c6\"; }\n.ri-windows-fill:before { content: \"\\f2c7\"; }\n.ri-windows-line:before { content: \"\\f2c8\"; }\n.ri-windy-fill:before { content: \"\\f2c9\"; }\n.ri-windy-line:before { content: \"\\f2ca\"; }\n.ri-wireless-charging-fill:before { content: \"\\f2cb\"; }\n.ri-wireless-charging-line:before { content: \"\\f2cc\"; }\n.ri-women-fill:before { content: \"\\f2cd\"; }\n.ri-women-line:before { content: \"\\f2ce\"; }\n.ri-wubi-input:before { content: \"\\f2cf\"; }\n.ri-xbox-fill:before { content: \"\\f2d0\"; }\n.ri-xbox-line:before { content: \"\\f2d1\"; }\n.ri-xing-fill:before { content: \"\\f2d2\"; }\n.ri-xing-line:before { content: \"\\f2d3\"; }\n.ri-youtube-fill:before { content: \"\\f2d4\"; }\n.ri-youtube-line:before { content: \"\\f2d5\"; }\n.ri-zcool-fill:before { content: \"\\f2d6\"; }\n.ri-zcool-line:before { content: \"\\f2d7\"; }\n.ri-zhihu-fill:before { content: \"\\f2d8\"; }\n.ri-zhihu-line:before { content: \"\\f2d9\"; }\n.ri-zoom-in-fill:before { content: \"\\f2da\"; }\n.ri-zoom-in-line:before { content: \"\\f2db\"; }\n.ri-zoom-out-fill:before { content: \"\\f2dc\"; }\n.ri-zoom-out-line:before { content: \"\\f2dd\"; }\n.ri-zzz-fill:before { content: \"\\f2de\"; }\n.ri-zzz-line:before { content: \"\\f2df\"; }\n\n","/*\nTemplate Name: Velzon - Admin & Dashboard Template\nAuthor: Themesbrand\nVersion: 3.0.0\nWebsite: https://Themesbrand.com/\nContact: Themesbrand@gmail.com\nFile: Custom Bootstrap Css File\n*/\n\n\n//Core files\n@import \"../../../../../../node_modules/bootstrap/scss/functions\";\n@import \"../../../../../../node_modules/bootstrap/scss/variables\";\n@import \"variables\";\n@import \"variables-dark\";\n@import \"../../components/utilities\";\n@import \"../../../../../../node_modules/bootstrap/scss/bootstrap\";\n\n","// Variables\n\n//Google Font\n@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Rubik:wght@300;400;500;600;700&display=swap\");\n\n//\n// custom-variables\n//\n\n// Prefix for :root CSS variables\n\n$variable-prefix: vz-; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix: $variable-prefix;\n\n// Font Family\n$font-family-primary: \"Rubik\", sans-serif;\n$font-family-secondary: \"Montserrat\", sans-serif;\n\n//custom variables managed by\n//light mode\n$sidebar-mode: true;\n$sidebar-gradient-mode: true;\n$sidebar-img: true;\n\n//dark mode\n$topbar-dark-mode: true;\n$sidebar-dark-mode: true;\n$sidebar-gradient-dark-mode: false;\n\n// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white: #fff;\n$gray-100: #f3f6f9;\n$gray-200: #eff2f7;\n$gray-300: #e9ebec;\n$gray-400: #ced4da;\n$gray-500: #adb5bd;\n$gray-600: #878a99;\n$gray-700: #495057;\n$gray-800: #363d48;\n$gray-900: #212529;\n$black: #000;\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900,\n);\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue: #6691e7;\n$indigo: #405189;\n$purple: #865ce2;\n$pink: #f672a7;\n$red: #ed5e5e;\n$orange: #f1963b;\n$yellow: #e8bc52;\n$green: #13c56b;\n$teal: #02a8b5;\n$cyan: #50c3e6;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\": $blue,\n  \"indigo\": $indigo,\n  \"purple\": $purple,\n  \"pink\": $pink,\n  \"red\": $red,\n  \"orange\": $orange,\n  \"yellow\": $yellow,\n  \"green\": $green,\n  \"teal\": $teal,\n  \"cyan\": $cyan,\n  \"white\": $white,\n  \"gray\": $gray-600,\n  \"gray-dark\": $gray-800,\n);\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio: 1.75;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark: $black;\n$color-contrast-light: $white;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%);\n$blue-200: tint-color($blue, 60%);\n$blue-300: tint-color($blue, 40%);\n$blue-400: tint-color($blue, 20%);\n$blue-500: $blue;\n$blue-600: shade-color($blue, 20%);\n$blue-700: shade-color($blue, 40%);\n$blue-800: shade-color($blue, 60%);\n$blue-900: shade-color($blue, 80%);\n\n$indigo-100: tint-color($indigo, 80%);\n$indigo-200: tint-color($indigo, 60%);\n$indigo-300: tint-color($indigo, 40%);\n$indigo-400: tint-color($indigo, 20%);\n$indigo-500: $indigo;\n$indigo-600: shade-color($indigo, 20%);\n$indigo-700: shade-color($indigo, 40%);\n$indigo-800: shade-color($indigo, 60%);\n$indigo-900: shade-color($indigo, 80%);\n\n$purple-100: tint-color($purple, 80%);\n$purple-200: tint-color($purple, 60%);\n$purple-300: tint-color($purple, 40%);\n$purple-400: tint-color($purple, 20%);\n$purple-500: $purple;\n$purple-600: shade-color($purple, 20%);\n$purple-700: shade-color($purple, 40%);\n$purple-800: shade-color($purple, 60%);\n$purple-900: shade-color($purple, 80%);\n\n$pink-100: tint-color($pink, 80%);\n$pink-200: tint-color($pink, 60%);\n$pink-300: tint-color($pink, 40%);\n$pink-400: tint-color($pink, 20%);\n$pink-500: $pink;\n$pink-600: shade-color($pink, 20%);\n$pink-700: shade-color($pink, 40%);\n$pink-800: shade-color($pink, 60%);\n$pink-900: shade-color($pink, 80%);\n\n$red-100: tint-color($red, 80%);\n$red-200: tint-color($red, 60%);\n$red-300: tint-color($red, 40%);\n$red-400: tint-color($red, 20%);\n$red-500: $red;\n$red-600: shade-color($red, 20%);\n$red-700: shade-color($red, 40%);\n$red-800: shade-color($red, 60%);\n$red-900: shade-color($red, 80%);\n\n$orange-100: tint-color($orange, 80%);\n$orange-200: tint-color($orange, 60%);\n$orange-300: tint-color($orange, 40%);\n$orange-400: tint-color($orange, 20%);\n$orange-500: $orange;\n$orange-600: shade-color($orange, 20%);\n$orange-700: shade-color($orange, 40%);\n$orange-800: shade-color($orange, 60%);\n$orange-900: shade-color($orange, 80%);\n\n$yellow-100: tint-color($yellow, 80%);\n$yellow-200: tint-color($yellow, 60%);\n$yellow-300: tint-color($yellow, 40%);\n$yellow-400: tint-color($yellow, 20%);\n$yellow-500: $yellow;\n$yellow-600: shade-color($yellow, 20%);\n$yellow-700: shade-color($yellow, 40%);\n$yellow-800: shade-color($yellow, 60%);\n$yellow-900: shade-color($yellow, 80%);\n\n$green-100: tint-color($green, 80%);\n$green-200: tint-color($green, 60%);\n$green-300: tint-color($green, 40%);\n$green-400: tint-color($green, 20%);\n$green-500: $green;\n$green-600: shade-color($green, 20%);\n$green-700: shade-color($green, 40%);\n$green-800: shade-color($green, 60%);\n$green-900: shade-color($green, 80%);\n\n$teal-100: tint-color($teal, 80%);\n$teal-200: tint-color($teal, 60%);\n$teal-300: tint-color($teal, 40%);\n$teal-400: tint-color($teal, 20%);\n$teal-500: $teal;\n$teal-600: shade-color($teal, 20%);\n$teal-700: shade-color($teal, 40%);\n$teal-800: shade-color($teal, 60%);\n$teal-900: shade-color($teal, 80%);\n\n$cyan-100: tint-color($cyan, 80%);\n$cyan-200: tint-color($cyan, 60%);\n$cyan-300: tint-color($cyan, 40%);\n$cyan-400: tint-color($cyan, 20%);\n$cyan-500: $cyan;\n$cyan-600: shade-color($cyan, 20%);\n$cyan-700: shade-color($cyan, 40%);\n$cyan-800: shade-color($cyan, 60%);\n$cyan-900: shade-color($cyan, 80%);\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900,\n);\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900,\n);\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900,\n);\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900,\n);\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900,\n);\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900,\n);\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900,\n);\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900,\n);\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900,\n);\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900,\n);\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$theme-primary: #b4d0f0;\n$theme-primary-custom: #8aaed6;\n$theme-primary-custom-dark: #0a65cc;\n$theme-secondary: #daecfb;\n$theme-color-1: #d4e4fb;\n$theme-color-2: #f0f5fc;\n$theme-color-3: #cce0f4;\n$theme-color-4: #7eabe7;\n$theme-color-5: #bcd4f8;\n$theme-color-6: #bdd6fb;\n\n// Next Button\n$theme-color-7: #83a9e2;\n$theme-color-8: #5d87c7;\n$theme-color-9: #bdd6fa;\n$theme-color-10: #0A56AE;\n\n$primary: $theme-primary;\n$primary-custom: $theme-primary-custom;\n$new-primary: $theme-color-10;\n$secondary: $theme-secondary;\n$success: $green;\n$info: $cyan;\n$warning: $yellow;\n$danger: $red;\n$light: $gray-100;\n$dark: $gray-800;\n$white: $white;\n\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\": $theme-primary,\n  \"secondary\": $theme-secondary,\n  \"success\": $success,\n  \"info\": $info,\n  \"warning\": $warning,\n  \"danger\": $danger,\n  \"light\": $light,\n  \"dark\": $dark,\n  \"custom-primary\": $theme-color-4,\n  \"custom-primary-hover\": $theme-color-5,\n  \"new-primary\": $theme-color-10,\n  \"header\": $theme-color-6,\n  \"next-button\": $theme-color-7,\n  \"next-button-border\": $theme-color-8,\n  \"next-button-hover\": $theme-color-9,\n  \"white\": $white,\n  \"light-grey\": $gray-400,\n);\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis: shade-color($theme-primary, 15%);\n$secondary-text-emphasis: shade-color($theme-secondary, 15%);\n$success-text-emphasis: shade-color($success, 15%);\n$info-text-emphasis: shade-color($info, 15%);\n$warning-text-emphasis: shade-color($warning, 15%);\n$danger-text-emphasis: shade-color($danger, 15%);\n$light-text-emphasis: $gray-400;\n$dark-text-emphasis: $gray-800;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle: tint-color($theme-primary, 85%);\n$secondary-bg-subtle: tint-color($theme-secondary, 85%);\n$success-bg-subtle: tint-color($success, 85%);\n$info-bg-subtle: tint-color($info, 85%);\n$warning-bg-subtle: tint-color($warning, 85%);\n$danger-bg-subtle: tint-color($danger, 85%);\n$light-bg-subtle: mix($gray-100, $white);\n$dark-bg-subtle: $gray-300;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle: tint-color($theme-primary, 60%);\n$secondary-border-subtle: tint-color($theme-secondary, 60%);\n$success-border-subtle: tint-color($success, 60%);\n$info-border-subtle: tint-color($info, 60%);\n$warning-border-subtle: tint-color($warning, 60%);\n$danger-border-subtle: tint-color($danger, 60%);\n$light-border-subtle: $gray-200;\n$dark-border-subtle: $gray-500;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\")\n);\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret: false;\n$enable-rounded: true;\n$enable-shadows: false;\n$enable-gradients: false;\n$enable-transitions: true;\n$enable-reduced-motion: true;\n$enable-smooth-scroll: true;\n$enable-grid-classes: true;\n$enable-container-classes: true;\n$enable-cssgrid: false;\n$enable-button-pointers: true;\n$enable-rfs: true;\n$enable-validation-icons: true;\n$enable-negative-margins: true;\n$enable-deprecation-messages: true;\n$enable-important-utilities: true;\n\n$enable-dark-mode: true;\n$color-mode-type: data; // `data` or `media-query`\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, 0.15), rgba($white, 0));\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem;\n$spacers: (\n  0: 0,\n  1: $spacer * 0.25,\n  2: $spacer * 0.5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n);\n\n$negative-spacers: if($enable-negative-margins, negativify-map($spacers), null);\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%,\n);\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg: #f3f6f9;\n$body-color: $gray-900;\n$body-text-align: null;\n\n$body-secondary-color: $gray-600;\n$body-secondary-bg: $white;\n\n$body-tertiary-color: rgba($body-color, 0.5);\n$body-tertiary-bg: $gray-200;\n\n$body-emphasis-color: $gray-900;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color: $primary;\n$link-decoration: none;\n$link-shade-percentage: 20%;\n$link-hover-color: $primary;\n$link-hover-decoration: null;\n\n$stretched-link-pseudo-element: after;\n$stretched-link-z-index: 1;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap: 0.375rem;\n$icon-link-underline-offset: 0.25em;\n$icon-link-icon-size: 1em;\n$icon-link-icon-transition: 0.2s ease-in-out transform;\n$icon-link-icon-transform: translate3d(0.25em, 0, 0);\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom: 1rem;\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px,\n);\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px,\n);\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns: 12;\n$grid-gutter-width: 1.5rem;\n$grid-row-columns: 6;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width * 1;\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width: 1px;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px,\n);\n$border-style: solid;\n$border-color: $theme-primary;\n$border-color-translucent: $theme-primary-custom;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius: 0.25rem;\n$border-radius-sm: 0.2rem;\n$border-radius-lg: 0.3rem;\n$border-radius-xl: 1rem;\n$border-radius-xxl: 2rem;\n$border-radius-pill: 50rem;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl: $border-radius-xxl; // Deprecated in v5.3.0\n// fusv-enable\n\n$radius-sizes: (\n  \"custom-1\": 12px,\n);\n\n@each $name, $size in $radius-sizes {\n  .rounded-#{$name} {\n    border-radius: $size;\n  }\n}\n\n// scss-docs-start box-shadow-variables\n$box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);\n$box-shadow-sm: 0 0.125rem 0.25rem rgba($black, 0.075);\n$box-shadow-lg: 0 5px 10px rgba(30, 32, 37, 0.12);\n$box-shadow-inset: inset 0 1px 2px rgba($black, 0.075);\n$element-shadow: none;\n// scss-docs-end box-shadow-variables\n\n$component-active-color: $white;\n$component-active-bg: $theme-primary-custom;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width: 0.25rem;\n$focus-ring-opacity: 0.25;\n$focus-ring-color: rgba(var(--#{$prefix}primary-rgb), $focus-ring-opacity);\n$focus-ring-blur: 1;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width: 0.3em;\n$caret-vertical-align: $caret-width * 0.85;\n$caret-spacing: $caret-width * 0.85;\n// scss-docs-end caret-variables\n\n$transition-base: all 0.2s ease-in-out;\n$transition-fade: opacity 0.15s linear;\n// scss-docs-start collapse-transition\n$transition-collapse: height 0.35s ease;\n$transition-collapse-width: width 0.35s ease;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%),\n);\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif: $font-family-primary;\n$font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas,\n  \"Liberation Mono\", \"Courier New\", monospace;\n// stylelint-enable value-keyword-case\n$font-family-base: var(--#{$prefix}font-sans-serif);\n$font-family-code: var(--#{$prefix}font-monospace);\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root: null;\n$font-size-base: 0.825rem; // Assumes the browser default, typically `16px`\n$font-size-sm: $font-size-base * 0.875;\n$font-size-lg: $font-size-base * 1.25;\n\n$font-weight-lighter: lighter;\n$font-weight-light: 300;\n$font-weight-normal: 400;\n$font-weight-medium: 400;\n$font-weight-semibold: 500;\n$font-weight-bold: 700;\n$font-weight-bolder: bolder;\n\n$font-weight-base: $font-weight-normal;\n\n$line-height-base: 1.5;\n$line-height-sm: 1.25;\n$line-height-lg: 2;\n\n$h1-font-size: $font-size-base * 2.5;\n$h2-font-size: $font-size-base * 2;\n$h3-font-size: $font-size-base * 1.75;\n$h4-font-size: $font-size-base * 1.5;\n$h5-font-size: $font-size-base * 1.25;\n$h6-font-size: $font-size-base;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size,\n);\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom: $spacer * 0.5;\n$headings-font-family: $font-family-secondary;\n$headings-font-style: null;\n$headings-font-weight: 600;\n$headings-line-height: 1.2;\n$headings-color: $gray-700;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem,\n);\n\n$display-font-family: null;\n$display-font-style: null;\n$display-font-weight: 300;\n$display-line-height: $headings-line-height;\n// scss-docs-end display-headings\n\n//Font size custom\n$font-size-custom: (\n  10: 10px,\n  11: 11px,\n  12: 12px,\n  13: 13px,\n  14: 14px,\n  15: 15px,\n  16: 16px,\n  17: 17px,\n  18: 18px,\n  19: 19px,\n  20: 20px,\n  21: 21px,\n  22: 22px,\n  23: 23px,\n  24: 24px,\n  36: 36px,\n  48: 48px,\n);\n\n// scss-docs-start type-variables\n$lead-font-size: $font-size-base * 1.25;\n$lead-font-weight: 300;\n\n$small-font-size: 0.875em;\n\n$sub-sup-font-size: 0.75em;\n\n// fusv-disable\n$text-muted: var(--#{$prefix}secondary-color); // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size: $small-font-size;\n\n$blockquote-margin-y: $spacer;\n$blockquote-font-size: $font-size-base * 1.1;\n$blockquote-footer-color: $gray-600;\n$blockquote-footer-font-size: $small-font-size;\n\n$hr-margin-y: $spacer;\n$hr-color: inherit;\n// fusv-disable\n$hr-bg-color: null; // Deprecated in v5.2.0\n$hr-height: null; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color: null; // Allows for inherited colors\n$hr-border-width: var(--#{$prefix}border-width);\n$hr-opacity: 0.25;\n\n$legend-margin-bottom: 0.5rem;\n$legend-font-size: 1.5rem;\n$legend-font-weight: null;\n\n$dt-font-weight: $font-weight-semibold;\n\n$list-inline-padding: 0.5rem;\n\n$mark-padding: 0.2em;\n$mark-bg: #fcf8e3;\n// scss-docs-end type-variables\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y: 0.75rem;\n$table-cell-padding-x: 0.6rem;\n$table-cell-padding-y-sm: 0.3rem;\n$table-cell-padding-x-sm: 0.25rem;\n\n$table-cell-vertical-align: top;\n\n$table-color: var(--#{$prefix}body-color);\n$table-bg: transparent;\n$table-accent-bg: transparent;\n\n$table-th-font-weight: $font-weight-semibold;\n\n$table-striped-color: $table-color;\n$table-striped-bg-factor: 0.02;\n$table-striped-bg: rgba(\n  var(--#{$prefix}body-color-rgb),\n  $table-striped-bg-factor\n);\n\n$table-active-color: $table-color;\n$table-active-bg-factor: 0.04;\n$table-active-bg: rgba(\n  var(--#{$prefix}body-color-rgb),\n  $table-active-bg-factor\n);\n\n$table-hover-color: $table-color;\n$table-hover-bg-factor: 0.04;\n$table-hover-bg: rgba(var(--#{$prefix}body-color-rgb), $table-hover-bg-factor);\n\n$table-border-factor: 0.1;\n$table-border-width: var(--#{$prefix}border-width);\n$table-border-color: var(--#{$prefix}border-color);\n\n$table-striped-order: odd;\n$table-striped-columns-order: even;\n\n$table-group-separator-color: currentcolor;\n\n$table-caption-color: var(--#{$prefix}secondary-color);\n\n$table-bg-scale: -80%;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\": shift-color($primary, $table-bg-scale),\n  \"secondary\": shift-color($secondary, $table-bg-scale),\n  \"success\": shift-color($success, $table-bg-scale),\n  \"info\": shift-color($info, $table-bg-scale),\n  \"warning\": shift-color($warning, $table-bg-scale),\n  \"danger\": shift-color($danger, $table-bg-scale),\n  \"light\": $light,\n  \"dark\": $dark,\n);\n// scss-docs-end table-loop\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y: 0.5rem;\n$input-btn-padding-x: 0.9rem;\n$input-btn-font-family: null;\n$input-btn-font-size: $font-size-base;\n$input-btn-line-height: $line-height-base;\n\n$input-btn-focus-width: $focus-ring-width;\n$input-btn-focus-color-opacity: $focus-ring-opacity;\n$input-btn-focus-color: $focus-ring-color;\n$input-btn-focus-blur: $focus-ring-blur;\n$input-btn-focus-box-shadow: $focus-ring-box-shadow;\n\n$input-btn-padding-y-sm: 0.25rem;\n$input-btn-padding-x-sm: 0.5rem;\n$input-btn-font-size-sm: $font-size-sm;\n\n$input-btn-padding-y-lg: 0.7rem;\n$input-btn-padding-x-lg: 1.2rem;\n$input-btn-font-size-lg: $font-size-lg;\n\n$input-btn-border-width: var(--#{$prefix}border-width);\n// scss-docs-end input-btn-variables\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color: var(--#{$prefix}body-color);\n$btn-padding-y: $input-btn-padding-y;\n$btn-padding-x: $input-btn-padding-x;\n$btn-font-family: $input-btn-font-family;\n$btn-font-size: $input-btn-font-size;\n$btn-line-height: $input-btn-line-height;\n$btn-white-space: null; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm: $input-btn-padding-y-sm;\n$btn-padding-x-sm: $input-btn-padding-x-sm;\n$btn-font-size-sm: $input-btn-font-size-sm;\n\n$btn-padding-y-lg: $input-btn-padding-y-lg;\n$btn-padding-x-lg: $input-btn-padding-x-lg;\n$btn-font-size-lg: $input-btn-font-size-lg;\n\n$btn-border-width: $input-btn-border-width;\n\n$btn-font-weight: $font-weight-normal;\n$btn-box-shadow: inset 0 1px 0 rgba($white, 0.15), 0 1px 1px rgba($black, 0.075);\n$btn-focus-width: $input-btn-focus-width;\n$btn-focus-box-shadow: $input-btn-focus-box-shadow;\n$btn-disabled-opacity: 0.65;\n$btn-active-box-shadow: inset 0 3px 5px rgba($black, 0.125);\n\n$btn-link-color: var(--#{$prefix}link-color);\n$btn-link-hover-color: var(--#{$prefix}link-hover-color);\n$btn-link-disabled-color: $gray-600;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius: var(--#{$prefix}border-radius);\n$btn-border-radius-sm: var(--#{$prefix}border-radius-sm);\n$btn-border-radius-lg: var(--#{$prefix}border-radius-lg);\n\n$btn-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n  border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\n$btn-hover-bg-shade-amount: 15%;\n$btn-hover-bg-tint-amount: 15%;\n$btn-hover-border-shade-amount: 20%;\n$btn-hover-border-tint-amount: 10%;\n$btn-active-bg-shade-amount: 20%;\n$btn-active-bg-tint-amount: 20%;\n$btn-active-border-shade-amount: 25%;\n$btn-active-border-tint-amount: 10%;\n// scss-docs-end btn-variables\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top: 0.25rem;\n$form-text-font-size: $small-font-size;\n$form-text-font-style: null;\n$form-text-font-weight: null;\n$form-text-color: var(--#{$prefix}secondary-color);\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom: 0.5rem;\n$form-label-font-size: null;\n$form-label-font-style: null;\n$form-label-font-weight: null;\n$form-label-color: null;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y: $input-btn-padding-y;\n$input-padding-x: $input-btn-padding-x;\n$input-font-family: $input-btn-font-family;\n$input-font-size: $input-btn-font-size;\n$input-font-weight: $font-weight-base;\n$input-line-height: $input-btn-line-height;\n\n$input-padding-y-sm: $input-btn-padding-y-sm;\n$input-padding-x-sm: $input-btn-padding-x-sm;\n$input-font-size-sm: $input-btn-font-size-sm;\n\n$input-padding-y-lg: $input-btn-padding-y-lg;\n$input-padding-x-lg: $input-btn-padding-x-lg;\n$input-font-size-lg: $input-btn-font-size-lg;\n\n$input-bg: var(--#{$prefix}input-bg-custom);\n$input-disabled-color: null;\n$input-disabled-bg: var(--#{$prefix}tertiary-bg);\n$input-disabled-border-color: null;\n\n$input-color: var(--#{$prefix}body-color);\n$input-border-color: var(--#{$prefix}input-border-custom);\n$input-border-width: $input-btn-border-width;\n$input-box-shadow: $box-shadow-inset;\n\n$input-border-radius: var(--#{$prefix}border-radius);\n$input-border-radius-sm: var(--#{$prefix}border-radius-sm);\n$input-border-radius-lg: var(--#{$prefix}border-radius-lg);\n\n$input-focus-bg: $input-bg;\n$input-focus-border-color: var(--#{$prefix}primary-border-subtle);\n$input-focus-color: $input-color;\n$input-focus-width: $input-btn-focus-width;\n$input-focus-box-shadow: $input-btn-focus-box-shadow;\n\n$input-placeholder-color: var(--#{$prefix}secondary-color);\n$input-plaintext-color: var(--#{$prefix}body-color);\n\n$input-height-border: calc(\n  #{$input-border-width} * 2\n); // stylelint-disable-line function-disallowed-list\n\n$input-height-inner: add($input-line-height * 1em, $input-padding-y * 2);\n$input-height-inner-half: add($input-line-height * 0.5em, $input-padding-y);\n$input-height-inner-quarter: add(\n  $input-line-height * 0.25em,\n  $input-padding-y * 0.5\n);\n\n$input-height: add(\n  $input-line-height * 1em,\n  add($input-padding-y * 2, $input-height-border, false)\n);\n$input-height-sm: add(\n  $input-line-height * 1em,\n  add($input-padding-y-sm * 2, $input-height-border, false)\n);\n$input-height-lg: add(\n  $input-line-height * 1em,\n  add($input-padding-y-lg * 2, $input-height-border, false)\n);\n\n$input-transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n$form-color-width: 3rem;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width: 1.1em;\n$form-check-min-height: $font-size-base * $line-height-base;\n$form-check-padding-start: $form-check-input-width + 0.5em;\n$form-check-margin-bottom: 0.125rem;\n$form-check-label-color: null;\n$form-check-label-cursor: null;\n$form-check-transition: null;\n\n$form-check-input-active-filter: brightness(90%);\n\n$form-check-input-bg: $input-bg;\n$form-check-input-border: var(--#{$prefix}border-width) solid\n  var(--#{$prefix}border-color-translucent);\n$form-check-input-border-radius: 0.25em;\n$form-check-radio-border-radius: 50%;\n$form-check-input-focus-border: $input-focus-border-color;\n$form-check-input-focus-box-shadow: $focus-ring-box-shadow;\n\n$form-check-input-checked-color: $component-active-color;\n$form-check-input-checked-bg-color: $component-active-bg;\n$form-check-input-checked-border-color: $form-check-input-checked-bg-color;\n$form-check-input-checked-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/></svg>\");\n$form-check-radio-checked-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\");\n\n$form-check-input-indeterminate-color: $component-active-color;\n$form-check-input-indeterminate-bg-color: $component-active-bg;\n$form-check-input-indeterminate-border-color: $form-check-input-indeterminate-bg-color;\n$form-check-input-indeterminate-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\");\n\n$form-check-input-disabled-opacity: 0.5;\n$form-check-label-disabled-opacity: $form-check-input-disabled-opacity;\n$form-check-btn-check-disabled-opacity: $btn-disabled-opacity;\n\n$form-check-inline-margin-end: 1rem;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color: rgba($gray-600, 0.55);\n$form-switch-width: 2em;\n$form-switch-padding-start: $form-switch-width + 0.5em;\n$form-switch-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\");\n$form-switch-border-radius: $form-switch-width;\n$form-switch-transition: background-position 0.15s ease-in-out;\n\n$form-switch-focus-color: $form-switch-color;\n$form-switch-focus-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\");\n\n$form-switch-checked-color: $component-active-color;\n$form-switch-checked-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\");\n$form-switch-checked-bg-position: right center;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y: $input-padding-y;\n$input-group-addon-padding-x: $input-padding-x;\n$input-group-addon-font-weight: $input-font-weight;\n$input-group-addon-color: $input-color;\n$input-group-addon-bg: var(--#{$prefix}tertiary-bg);\n$input-group-addon-border-color: $input-border-color;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y: $input-padding-y;\n$form-select-padding-x: $input-padding-x;\n$form-select-font-family: $input-font-family;\n$form-select-font-size: $input-font-size;\n// $form-select-indicator-padding:     #{$form-select-padding-x} * 3; // Extra padding for background-image\n$form-select-font-weight: $input-font-weight;\n$form-select-line-height: $input-line-height;\n$form-select-color: $input-color;\n$form-select-bg: $input-bg;\n$form-select-disabled-color: null;\n$form-select-disabled-bg: $input-disabled-bg;\n$form-select-disabled-border-color: $input-disabled-border-color;\n$form-select-bg-position: right #{$form-select-padding-x} center;\n$form-select-bg-size: 16px 12px; // In pixels because image dimensions\n$form-select-indicator-color: $gray-800;\n$form-select-indicator: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\");\n\n// $form-select-feedback-icon-padding-end: #{$form-select-padding-x} * 2.5 + #{$form-select-indicator-padding};\n$form-select-feedback-icon-position: center right #{$form-select-indicator-padding};\n$form-select-feedback-icon-size: $input-height-inner-half\n  $input-height-inner-half;\n\n$form-select-border-width: $input-border-width;\n$form-select-border-color: $input-border-color;\n$form-select-border-radius: $input-border-radius;\n$form-select-box-shadow: $box-shadow-inset;\n\n$form-select-focus-border-color: $input-focus-border-color;\n$form-select-focus-width: $input-focus-width;\n$form-select-focus-box-shadow: 0 0 0 $form-select-focus-width\n  $input-btn-focus-color;\n\n$form-select-padding-y-sm: $input-padding-y-sm;\n$form-select-padding-x-sm: $input-padding-x-sm;\n$form-select-font-size-sm: $input-font-size-sm;\n$form-select-border-radius-sm: $input-border-radius-sm;\n\n$form-select-padding-y-lg: $input-padding-y-lg;\n$form-select-padding-x-lg: $input-padding-x-lg;\n$form-select-font-size-lg: $input-font-size-lg;\n$form-select-border-radius-lg: $input-border-radius-lg;\n\n$form-select-transition: $input-transition;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width: 100%;\n$form-range-track-height: 0.5rem;\n$form-range-track-cursor: pointer;\n$form-range-track-bg: var(--#{$prefix}tertiary-bg);\n$form-range-track-border-radius: 1rem;\n$form-range-track-box-shadow: $box-shadow-inset;\n\n$form-range-thumb-width: 1rem;\n$form-range-thumb-height: $form-range-thumb-width;\n$form-range-thumb-bg: $component-active-bg;\n$form-range-thumb-border: 0;\n$form-range-thumb-border-radius: 1rem;\n$form-range-thumb-box-shadow: 0 0.1rem 0.25rem rgba($black, 0.1);\n$form-range-thumb-focus-box-shadow: 0 0 0 1px $body-bg, $input-focus-box-shadow;\n$form-range-thumb-focus-box-shadow-width: $input-focus-width; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg: tint-color($component-active-bg, 70%);\n$form-range-thumb-disabled-bg: var(--#{$prefix}secondary-color);\n$form-range-thumb-transition: background-color 0.15s ease-in-out,\n  border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color: $input-color;\n$form-file-button-bg: $theme-primary;\n$form-file-button-hover-bg: var(--#{$prefix}secondary-bg);\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height: add(3.5rem, $input-height-border);\n$form-floating-line-height: 1.25;\n$form-floating-padding-x: $input-padding-x;\n$form-floating-padding-y: 1rem;\n$form-floating-input-padding-t: 1.625rem;\n$form-floating-input-padding-b: 0.625rem;\n$form-floating-label-height: 1.5em;\n$form-floating-label-opacity: 0.65;\n$form-floating-label-transform: scale(0.85) translateY(-0.5rem)\n  translateX(0.15rem);\n$form-floating-label-disabled-color: var(--#{$prefix}secondary-color);\n$form-floating-transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top: $form-text-margin-top;\n$form-feedback-font-size: $form-text-font-size;\n$form-feedback-font-style: $form-text-font-style;\n$form-feedback-valid-color: $success;\n$form-feedback-invalid-color: $danger;\n\n$form-feedback-icon-valid-color: $form-feedback-valid-color;\n$form-feedback-icon-valid: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\");\n$form-feedback-icon-invalid-color: $form-feedback-invalid-color;\n$form-feedback-icon-invalid: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\");\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color: $form-feedback-valid-color;\n$form-valid-border-color: $form-feedback-valid-color;\n$form-invalid-color: $form-feedback-invalid-color;\n$form-invalid-border-color: $form-feedback-invalid-color;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width\n      rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width\n      rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  ),\n);\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown: 1000;\n$zindex-sticky: 1020;\n$zindex-fixed: 1030;\n$zindex-offcanvas-backdrop: 1040;\n$zindex-offcanvas: 1045;\n$zindex-modal-backdrop: 1050;\n$zindex-modal: 1055;\n$zindex-popover: 1070;\n$zindex-tooltip: 1080;\n$zindex-toast: 1090;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3,\n);\n// scss-docs-end zindex-levels-map\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y: 0.5rem;\n$nav-link-padding-x: 1rem;\n$nav-link-font-size: null;\n$nav-link-font-weight: null;\n$nav-link-color: var(--#{$prefix}dark);\n$nav-link-hover-color: var(--#{$prefix}new-primary);\n$nav-link-transition: color 0.15s ease-in-out,\n  background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n$nav-link-disabled-color: var(--#{$prefix}secondary-color);\n$nav-link-focus-box-shadow: $focus-ring-box-shadow;\n\n$nav-tabs-border-color: var(--#{$prefix}new-primary);\n$nav-tabs-border-width: var(--#{$prefix}border-width);\n$nav-tabs-border-radius: var(--#{$prefix}border-radius);\n$nav-tabs-link-hover-border-color: var(--#{$prefix}light)\n  var(--#{$prefix}secondary-bg) $nav-tabs-border-color;\n$nav-tabs-link-active-color: var(--#{$prefix}light);\n$nav-tabs-link-active-bg: var(--#{$prefix}new-primary);\n$nav-tabs-link-active-border-color: var(--#{$prefix}new-primary)\n  var(--#{$prefix}border-color) $nav-tabs-link-active-bg;\n\n$nav-pills-border-radius: var(--#{$prefix}border-radius);\n$nav-pills-link-active-color: var(--#{$prefix}light);\n$nav-pills-link-active-bg: var(--#{$prefix}custom-primary);\n\n$nav-underline-gap: 1rem;\n$nav-underline-border-width: 0.125rem;\n$nav-underline-link-active-color: var(--#{$prefix}emphasis-color);\n// scss-docs-end nav-variables\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y: $spacer * 0.5;\n$navbar-padding-x: null;\n\n$navbar-nav-link-padding-x: 0.5rem;\n\n$navbar-brand-font-size: $font-size-lg;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height: $font-size-base * $line-height-base + $nav-link-padding-y * 2;\n$navbar-brand-height: $navbar-brand-font-size * $line-height-base;\n$navbar-brand-padding-y: ($nav-link-height - $navbar-brand-height) * 0.5;\n$navbar-brand-margin-end: 1rem;\n\n$navbar-toggler-padding-y: 0.25rem;\n$navbar-toggler-padding-x: 0.75rem;\n$navbar-toggler-font-size: $font-size-lg;\n$navbar-toggler-border-radius: $btn-border-radius;\n$navbar-toggler-focus-width: $btn-focus-width;\n$navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n\n$navbar-light-color: rgba(var(--#{$prefix}emphasis-color-rgb), 0.65);\n$navbar-light-hover-color: rgba(var(--#{$prefix}emphasis-color-rgb), 0.8);\n$navbar-light-active-color: rgba(var(--#{$prefix}emphasis-color-rgb), 1);\n$navbar-light-disabled-color: rgba(var(--#{$prefix}emphasis-color-rgb), 0.3);\n$navbar-light-icon-color: rgba($body-color, 0.75);\n$navbar-light-toggler-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n$navbar-light-toggler-border-color: rgba(\n  var(--#{$prefix}emphasis-color-rgb),\n  0.15\n);\n$navbar-light-brand-color: $navbar-light-active-color;\n$navbar-light-brand-hover-color: $navbar-light-active-color;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color: rgba($white, 0.55);\n$navbar-dark-hover-color: rgba($white, 0.75);\n$navbar-dark-active-color: $white;\n$navbar-dark-disabled-color: rgba($white, 0.25);\n$navbar-dark-toggler-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n$navbar-dark-toggler-border-color: rgba($white, 0.1);\n$navbar-dark-brand-color: $navbar-dark-active-color;\n$navbar-dark-brand-hover-color: $navbar-dark-active-color;\n// scss-docs-end navbar-dark-variables\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width: 10rem;\n$dropdown-padding-x: 0;\n$dropdown-padding-y: 0.5rem;\n$dropdown-spacer: 0.125rem;\n$dropdown-font-size: $font-size-base;\n$dropdown-color: var(--#{$prefix}body-color);\n$dropdown-bg: var(--#{$prefix}secondary-bg);\n$dropdown-border-color: var(--#{$prefix}border-color);\n$dropdown-border-radius: var(--#{$prefix}border-radius-lg);\n$dropdown-border-width: 0;\n$dropdown-inner-border-radius: calc(\n  #{$dropdown-border-radius} - #{$dropdown-border-width}\n); // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg: $dropdown-border-color;\n$dropdown-divider-margin-y: $spacer * 0.5;\n$dropdown-box-shadow: $box-shadow-lg;\n\n$dropdown-link-color: var(--#{$prefix}body-color);\n$dropdown-link-hover-color: $dropdown-link-color;\n$dropdown-link-hover-bg: var(--#{$prefix}tertiary-bg);\n\n$dropdown-link-active-color: var(--#{$prefix}body-color);\n$dropdown-link-active-bg: var(--#{$prefix}tertiary-bg);\n\n$dropdown-link-disabled-color: var(--#{$prefix}tertiary-color);\n\n$dropdown-item-padding-y: 0.35rem;\n$dropdown-item-padding-x: 1.2rem;\n\n$dropdown-header-color: $gray-600;\n$dropdown-header-padding-x: $dropdown-item-padding-x;\n$dropdown-header-padding-y: $dropdown-padding-y;\n// fusv-disable\n$dropdown-header-padding: $dropdown-header-padding-y $dropdown-header-padding-x; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color: $gray-300;\n$dropdown-dark-bg: $gray-800;\n$dropdown-dark-border-color: $dropdown-border-color;\n$dropdown-dark-divider-bg: $dropdown-divider-bg;\n$dropdown-dark-box-shadow: null;\n$dropdown-dark-link-color: $dropdown-dark-color;\n$dropdown-dark-link-hover-color: $white;\n$dropdown-dark-link-hover-bg: rgba($white, 0.15);\n$dropdown-dark-link-active-color: $dropdown-link-active-color;\n$dropdown-dark-link-active-bg: $dropdown-link-active-bg;\n$dropdown-dark-link-disabled-color: $gray-500;\n$dropdown-dark-header-color: $gray-500;\n// scss-docs-end dropdown-dark-variables\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y: 0.375rem;\n$pagination-padding-x: 0.75rem;\n$pagination-padding-y-sm: 0.25rem;\n$pagination-padding-x-sm: 0.5rem;\n$pagination-padding-y-lg: 0.6rem;\n$pagination-padding-x-lg: 1.2rem;\n\n$pagination-font-size: $font-size-base;\n\n$pagination-color: var(--#{$prefix}link-color);\n$pagination-bg: var(--#{$prefix}secondary-bg);\n$pagination-border-radius: var(--#{$prefix}border-radius);\n$pagination-border-width: var(--#{$prefix}border-width);\n$pagination-margin-start: calc(\n  #{$pagination-border-width} * -1\n); // stylelint-disable-line function-disallowed-list\n$pagination-border-color: var(--#{$prefix}border-color);\n\n$pagination-focus-color: var(--#{$prefix}link-hover-color);\n$pagination-focus-bg: var(--#{$prefix}tertiary-bg);\n$pagination-focus-box-shadow: $focus-ring-box-shadow;\n$pagination-focus-outline: 0;\n\n$pagination-hover-color: var(--#{$prefix}link-hover-color);\n$pagination-hover-bg: var(--#{$prefix}tertiary-bg);\n$pagination-hover-border-color: var(\n  --#{$prefix}border-color\n); // Todo in v6: remove this?\n\n$pagination-active-color: $component-active-color;\n$pagination-active-bg: $component-active-bg;\n$pagination-active-border-color: $component-active-bg;\n\n$pagination-disabled-color: var(--#{$prefix}secondary-color);\n$pagination-disabled-bg: var(--#{$prefix}secondary-bg);\n$pagination-disabled-border-color: var(--#{$prefix}border-color);\n\n$pagination-transition: color 0.15s ease-in-out,\n  background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,\n  box-shadow 0.15s ease-in-out;\n\n$pagination-border-radius-sm: var(--#{$prefix}border-radius-sm);\n$pagination-border-radius-lg: var(--#{$prefix}border-radius-lg);\n// scss-docs-end pagination-variables\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max: 0.5;\n$placeholder-opacity-min: 0.2;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y: $spacer;\n$card-spacer-x: $spacer;\n$card-title-spacer-y: $spacer * 0.5;\n$card-title-color: var(--#{$prefix}heading-color);\n$card-subtitle-color: null;\n$card-border-width: 0;\n$card-border-color: var(--#{$prefix}border-color);\n$card-border-radius: var(--#{$prefix}border-radius);\n$card-box-shadow: $box-shadow;\n$card-inner-border-radius: $card-border-radius;\n$card-cap-padding-y: $card-spacer-y;\n$card-cap-padding-x: $card-spacer-x;\n$card-cap-bg: var(--#{$prefix}secondary-bg);\n$card-cap-color: null;\n$card-height: null;\n$card-color: null;\n$card-bg: var(--#{$prefix}secondary-bg);\n$card-img-overlay-padding: $spacer;\n$card-group-margin: calc(#{$grid-gutter-width} * 0.5);\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y: 1rem;\n$accordion-padding-x: 1.25rem;\n$accordion-color: var(--#{$prefix}body-color);\n$accordion-bg: var(--#{$prefix}secondary-bg);\n$accordion-border-width: var(--#{$prefix}border-width);\n$accordion-border-color: var(--#{$prefix}border-color);\n$accordion-border-radius: var(--#{$prefix}border-radius);\n$accordion-inner-border-radius: subtract(\n  $accordion-border-radius,\n  $accordion-border-width\n);\n\n$accordion-body-padding-y: $accordion-padding-y;\n$accordion-body-padding-x: $accordion-padding-x;\n\n$accordion-button-padding-y: $accordion-padding-y;\n$accordion-button-padding-x: $accordion-padding-x;\n$accordion-button-color: var(--#{$prefix}body-color);\n$accordion-button-bg: var(--#{$prefix}accordion-bg);\n$accordion-transition: $btn-transition, border-radius 0.15s ease;\n$accordion-button-active-bg: rgba(var(--#{$prefix}primary-rgb), 0.05);\n$accordion-button-active-color: var(--#{$prefix}primary-text-emphasis);\n\n$accordion-button-focus-border-color: $input-focus-border-color;\n$accordion-button-focus-box-shadow: $btn-focus-box-shadow;\n\n$accordion-icon-width: 0.75rem;\n$accordion-icon-color: var(--#{$prefix}body-color);\n$accordion-icon-active-color: var(--#{$prefix}primary-text-emphasis);\n$accordion-icon-transition: transform 0.2s ease-in-out;\n$accordion-icon-transform: rotate(-180deg);\n\n$accordion-button-icon: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n$accordion-button-active-icon: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size: $font-size-sm;\n$tooltip-max-width: 200px;\n$tooltip-color: var(--#{$prefix}body-bg);\n$tooltip-bg: var(--#{$prefix}emphasis-color);\n$tooltip-border-radius: var(--#{$prefix}border-radius);\n$tooltip-opacity: 0.9;\n$tooltip-padding-y: $spacer * 0.4;\n$tooltip-padding-x: $spacer * 0.7;\n$tooltip-margin: null; // TODO: remove this in v6\n\n$tooltip-arrow-width: 0.8rem;\n$tooltip-arrow-height: 0.4rem;\n// fusv-disable\n$tooltip-arrow-color: null; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y: $tooltip-padding-y;\n$form-feedback-tooltip-padding-x: $tooltip-padding-x;\n$form-feedback-tooltip-font-size: $tooltip-font-size;\n$form-feedback-tooltip-line-height: null;\n$form-feedback-tooltip-opacity: $tooltip-opacity;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius;\n// scss-docs-end tooltip-feedback-variables\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size: $font-size-base;\n$popover-bg: var(--#{$prefix}secondary-bg);\n$popover-max-width: 276px;\n$popover-border-width: var(--#{$prefix}border-width);\n$popover-border-color: var(--#{$prefix}border-color);\n$popover-border-radius: var(--#{$prefix}border-radius);\n$popover-inner-border-radius: calc(\n  #{$popover-border-radius} - #{$popover-border-width}\n); // stylelint-disable-line function-disallowed-list\n$popover-box-shadow: $box-shadow-lg;\n\n$popover-header-font-size: $font-size-base;\n$popover-header-bg: var(--#{$prefix}secondary-bg);\n$popover-header-color: var(--#{$prefix}body-color);\n$popover-header-padding-y: 0.7rem;\n$popover-header-padding-x: $spacer;\n\n$popover-body-color: var(--#{$prefix}body-color);\n$popover-body-padding-y: $spacer;\n$popover-body-padding-x: $spacer;\n\n$popover-arrow-width: 1rem;\n$popover-arrow-height: 0.5rem;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color: $popover-bg;\n$popover-arrow-outer-color: var(--#{$prefix}border-color-translucent);\n// fusv-enable\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width: 350px;\n$toast-padding-x: 0.75rem;\n$toast-padding-y: 0.5rem;\n$toast-font-size: 0.875rem;\n$toast-color: null;\n$toast-background-color: var(--#{$prefix}secondary-bg);\n$toast-border-width: var(--#{$prefix}border-width);\n$toast-border-color: var(--#{$prefix}border-color);\n$toast-border-radius: var(--#{$prefix}border-radius);\n$toast-box-shadow: var(--#{$prefix}box-shadow);\n$toast-spacing: $container-padding-x;\n\n$toast-header-color: var(--#{$prefix}secondary-color);\n$toast-header-background-color: var(--#{$prefix}secondary-bg);\n$toast-header-border-color: $toast-border-color;\n// scss-docs-end toast-variables\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size: 0.75em;\n$badge-font-weight: $font-weight-semibold;\n$badge-color: $white;\n$badge-padding-y: 0.35em;\n$badge-padding-x: 0.65em;\n$badge-border-radius: $border-radius;\n// scss-docs-end badge-variables\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding: $spacer * 1.25;\n\n$modal-footer-margin-between: 0.5rem;\n\n$modal-dialog-margin: 0.5rem;\n$modal-dialog-margin-y-sm-up: 1.75rem;\n\n$modal-title-line-height: $line-height-base;\n\n$modal-content-color: null;\n$modal-content-bg: var(--#{$prefix}secondary-bg);\n$modal-content-border-color: var(--#{$prefix}border-color);\n$modal-content-border-width: var(--#{$prefix}border-width);\n$modal-content-border-radius: var(--#{$prefix}border-radius-lg);\n$modal-content-inner-border-radius: subtract(\n  $modal-content-border-radius,\n  $modal-content-border-width\n);\n$modal-content-box-shadow-xs: $box-shadow-sm;\n$modal-content-box-shadow-sm-up: $box-shadow;\n\n$modal-backdrop-bg: $black;\n$modal-backdrop-opacity: 0.5;\n\n$modal-header-border-color: var(--#{$prefix}border-color);\n$modal-header-border-width: 0;\n$modal-header-padding-y: $modal-inner-padding;\n$modal-header-padding-x: $modal-inner-padding;\n$modal-header-padding: $modal-header-padding-y $modal-header-padding-x; // Keep this for backwards compatibility\n\n$modal-footer-bg: null;\n$modal-footer-border-color: $modal-header-border-color;\n$modal-footer-border-width: $modal-header-border-width;\n\n$modal-sm: 300px;\n$modal-md: 500px;\n$modal-lg: 800px;\n$modal-xl: 1140px;\n\n$modal-fade-transform: translate(0, -50px);\n$modal-show-transform: none;\n$modal-transition: transform 0.3s ease-out;\n$modal-scale-transform: scale(1.02);\n// scss-docs-end modal-variables\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y: $spacer * 0.8;\n$alert-padding-x: $spacer;\n$alert-margin-bottom: 1rem;\n$alert-border-radius: var(--#{$prefix}border-radius);\n$alert-link-font-weight: $font-weight-semibold;\n$alert-border-width: var(--#{$prefix}border-width);\n$alert-bg-scale: -85%;\n$alert-border-scale: -70%;\n$alert-color-scale: 25%;\n$alert-dismissible-padding-r: $alert-padding-x * 3; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale: -80%; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale: -70%; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale: 25%; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height: 0.625rem;\n$progress-font-size: $font-size-base * 0.75;\n$progress-bg: var(--#{$prefix}tertiary-bg);\n$progress-border-radius: var(--#{$prefix}border-radius);\n$progress-box-shadow: var(--#{$prefix}box-shadow-inset);\n$progress-bar-color: $white;\n$progress-bar-bg: var(--#{$prefix}primary);\n$progress-bar-animation-timing: 1s linear infinite;\n$progress-bar-transition: width 0.6s ease;\n// scss-docs-end progress-variables\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color: var(--#{$prefix}body-color);\n$list-group-bg: var(--#{$prefix}secondary-bg);\n$list-group-border-color: var(--#{$prefix}border-color);\n$list-group-border-width: var(--#{$prefix}border-width);\n$list-group-border-radius: var(--#{$prefix}border-radius);\n\n$list-group-item-padding-y: $spacer * 0.7;\n$list-group-item-padding-x: $spacer;\n// fusv-disable\n$list-group-item-bg-scale: -80%; // Deprecated in v5.3.0\n$list-group-item-color-scale: 40%; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg: var(--#{$prefix}tertiary-bg);\n$list-group-active-color: $component-active-color;\n$list-group-active-bg: $component-active-bg;\n$list-group-active-border-color: $list-group-active-bg;\n\n$list-group-disabled-color: var(--#{$prefix}secondary-color);\n$list-group-disabled-bg: $list-group-bg;\n\n$list-group-action-color: var(--#{$prefix}secondary-color);\n$list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n\n$list-group-action-active-color: var(--#{$prefix}body-color);\n$list-group-action-active-bg: var(--#{$prefix}secondary-bg);\n// scss-docs-end list-group-variables\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding: 0.25rem;\n$thumbnail-bg: var(--#{$prefix}body-bg);\n$thumbnail-border-width: var(--#{$prefix}border-width);\n$thumbnail-border-color: var(--#{$prefix}border-color);\n$thumbnail-border-radius: var(--#{$prefix}border-radius);\n$thumbnail-box-shadow: var(--#{$prefix}box-shadow-sm);\n// scss-docs-end thumbnail-variables\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size: $small-font-size;\n$figure-caption-color: var(--#{$prefix}secondary-color);\n// scss-docs-end figure-variables\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size: null;\n$breadcrumb-padding-y: 0;\n$breadcrumb-padding-x: 0;\n$breadcrumb-item-padding-x: 0.5rem;\n$breadcrumb-margin-bottom: 1rem;\n$breadcrumb-bg: null;\n$breadcrumb-divider-color: var(--#{$prefix}secondary-color);\n$breadcrumb-active-color: var(--#{$prefix}secondary-color);\n$breadcrumb-divider: quote(\"\\F0142\");\n$breadcrumb-divider-flipped: $breadcrumb-divider;\n$breadcrumb-border-radius: null;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color: $white;\n$carousel-control-width: 15%;\n$carousel-control-opacity: 0.5;\n$carousel-control-hover-opacity: 0.9;\n$carousel-control-transition: opacity 0.15s ease;\n\n$carousel-indicator-width: 30px;\n$carousel-indicator-height: 3px;\n$carousel-indicator-hit-area-height: 10px;\n$carousel-indicator-spacer: 3px;\n$carousel-indicator-opacity: 0.5;\n$carousel-indicator-active-bg: $white;\n$carousel-indicator-active-opacity: 1;\n$carousel-indicator-transition: opacity 0.6s ease;\n\n$carousel-caption-width: 70%;\n$carousel-caption-color: $white;\n$carousel-caption-padding-y: 1.25rem;\n$carousel-caption-spacer: 1.25rem;\n\n$carousel-control-icon-width: 2rem;\n\n$carousel-control-prev-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\");\n$carousel-control-next-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\");\n\n$carousel-transition-duration: 0.6s;\n$carousel-transition: transform $carousel-transition-duration ease-in-out; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg: $black;\n$carousel-dark-caption-color: $black;\n$carousel-dark-control-icon-filter: invert(1) grayscale(100);\n// scss-docs-end carousel-dark-variables\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width: 2rem;\n$spinner-height: $spinner-width;\n$spinner-vertical-align: -0.125em;\n$spinner-border-width: 0.25em;\n$spinner-animation-speed: 0.75s;\n\n$spinner-width-sm: 1rem;\n$spinner-height-sm: $spinner-width-sm;\n$spinner-border-width-sm: 0.2em;\n// scss-docs-end spinner-variables\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width: 1em;\n$btn-close-height: $btn-close-width;\n$btn-close-padding-x: 0.25em;\n$btn-close-padding-y: $btn-close-padding-x;\n$btn-close-color: $black;\n$btn-close-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\");\n$btn-close-focus-shadow: $focus-ring-box-shadow;\n$btn-close-opacity: 0.5;\n$btn-close-hover-opacity: 0.75;\n$btn-close-focus-opacity: 1;\n$btn-close-disabled-opacity: 0.25;\n$btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);\n// scss-docs-end close-variables\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y: $modal-inner-padding;\n$offcanvas-padding-x: $modal-inner-padding;\n$offcanvas-horizontal-width: 400px;\n$offcanvas-vertical-height: 30vh;\n$offcanvas-transition-duration: 0.3s;\n$offcanvas-border-color: $modal-content-border-color;\n$offcanvas-border-width: $modal-content-border-width;\n$offcanvas-title-line-height: $modal-title-line-height;\n$offcanvas-bg-color: var(--#{$prefix}secondary-bg);\n$offcanvas-color: var(--#{$prefix}body-color);\n$offcanvas-box-shadow: $modal-content-box-shadow-xs;\n$offcanvas-backdrop-bg: $modal-backdrop-bg;\n$offcanvas-backdrop-opacity: $modal-backdrop-opacity;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size: $small-font-size;\n$code-color: $pink;\n\n$kbd-padding-y: 0.2rem;\n$kbd-padding-x: 0.4rem;\n$kbd-font-size: $code-font-size;\n$kbd-color: var(--#{$prefix}body-bg);\n$kbd-bg: var(--#{$prefix}body-color);\n$nested-kbd-font-weight: null; // Deprecated in v5.2.0, removing in v6\n\n$pre-color: null;\n","// Dark color mode variables\n//\n// Custom variables for the `[data-bs-theme=\"dark\"]` theme. Use this as a starting point for your own custom color modes by creating a new theme-specific file like `_variables-dark.scss` and adding the variables you need.\n\n//\n// Global colors\n//\n\n$body-bg-dark:                                                      #1a1d21;\n\n// scss-docs-start sass-dark-mode-vars\n// scss-docs-start theme-text-dark-variables\n$primary-text-emphasis-dark:                                        tint-color($primary, 20%);\n$secondary-text-emphasis-dark:                                      tint-color($secondary, 20%);\n$success-text-emphasis-dark:                                        tint-color($success, 20%);\n$info-text-emphasis-dark:                                           tint-color($info, 20%);\n$warning-text-emphasis-dark:                                        tint-color($warning, 20%);\n$danger-text-emphasis-dark:                                         tint-color($danger, 20%);\n$light-text-emphasis-dark:                                          tint-color($body-bg-dark, 25%);\n$dark-text-emphasis-dark:                                           tint-color($body-bg-dark, 30%);\n// scss-docs-end theme-text-dark-variables\n\n// scss-docs-start theme-bg-subtle-dark-variables\n$primary-bg-subtle-dark:                                            rgba($primary, 0.15);\n$secondary-bg-subtle-dark:                                          rgba($secondary, 0.15);\n$success-bg-subtle-dark:                                            rgba($success, 0.15);\n$info-bg-subtle-dark:                                               rgba($info, 0.15);\n$warning-bg-subtle-dark:                                            rgba($warning, 0.15);\n$danger-bg-subtle-dark:                                             rgba($danger, 0.15);\n$light-bg-subtle-dark:                                              tint-color($body-bg-dark, 5%);\n$dark-bg-subtle-dark:                                               tint-color($body-bg-dark, 10%);\n// scss-docs-end theme-bg-subtle-dark-variables\n\n// scss-docs-start theme-border-subtle-dark-variables\n$primary-border-subtle-dark:                                        shade-color($primary, 35%);\n$secondary-border-subtle-dark:                                      shade-color($secondary, 50%);\n$success-border-subtle-dark:                                        shade-color($success, 50%);\n$info-border-subtle-dark:                                           shade-color($info, 50%);\n$warning-border-subtle-dark:                                        shade-color($warning, 50%);\n$danger-border-subtle-dark:                                         shade-color($danger, 50%);\n$light-border-subtle-dark:                                          tint-color($body-bg-dark, 12%);\n$dark-border-subtle-dark:                                           tint-color($body-bg-dark, 15%);\n// scss-docs-end theme-border-subtle-dark-variables\n\n$body-color-dark:                                                   #ced4da;\n$body-secondary-color-dark:                                         #878a99;\n$body-secondary-bg-dark:                                            #212529;\n$body-tertiary-color-dark:                                          rgba($body-color-dark, .75);\n$body-tertiary-bg-dark:                                             tint-color($body-bg-dark, 7%);\n$body-emphasis-color-dark:                                          $white;\n$border-color-dark:                                                 #32383e;\n$border-color-translucent-dark:                                     #32383e;\n$headings-color-dark:                                               #ced4da;\n$link-color-dark:                                                   tint-color($primary, 80%);\n$link-hover-color-dark:                                             shift-color($link-color-dark, -$link-shade-percentage);\n$code-color-dark:                                                   $code-color;\n\n//custom only default themes colors\n$light-dark:                                                        tint-color($body-bg-dark, 6%);\n$dark-color:                                                        tint-color($body-bg-dark, 10%);\n\n$dropdown-bg-dark:                                                  #292e33;\n$dropdown-link-color-dark:                                          #adb5bd;\n$dropdown-link-hover-color-dark:                                    #b9bfc4;\n$dropdown-link-hover-bg-dark:                                       #2f343a;\n$dropdown-link-hover-bg-dark:                                       #2f343a;\n$dropdown-border-width-dark:                                        1px;\n$dropdown-link-active-color-dark:                                   #adb5bd;\n$dropdown-link-active-bg-dark:                                      #2f343a;\n\n$input-bg-custom-dark:                                              #262a2f;\n$input-border-custom-dark:                                          #2a2f34;\n\n//\n// Forms\n//\n\n$form-select-indicator-color-dark:                                  $body-color-dark;\n$form-select-indicator-dark:                                        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color-dark}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\");\n\n$form-switch-color-dark:                                            rgba($white, .25);\n$form-switch-bg-image-dark:                                         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color-dark}'/></svg>\");\n\n// scss-docs-start form-validation-colors-dark\n$form-valid-color-dark:                                             $green-400;\n$form-valid-border-color-dark:                                      $green-400;\n$form-invalid-color-dark:                                           $red-400;\n$form-invalid-border-color-dark:                                    $red-400;\n// scss-docs-end form-validation-colors-dark\n\n\n//\n// Accordion\n//\n\n$accordion-icon-color-dark:                                         $primary-text-emphasis-dark;\n$accordion-icon-active-color-dark:                                  $primary-text-emphasis-dark;\n\n$accordion-button-icon-dark:                                        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color-dark}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n$accordion-button-active-icon-dark:                                 url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color-dark}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n// scss-docs-end sass-dark-mode-vars\n\n\n/*********************variables-custom dark Mode***************************/\n\n// Horizontal Menu\n$topnav-bg-dark:                                                    #272b30;\n$topnav-item-color-dark:                                            #878a99;\n$topnav-item-active-color-dark:                                     $white;\n\n// Topbar\n$header-bg-dark:                                                    #292e32;\n$header-border-dark:                                                #2e3438;\n$header-item-color-dark:                                            #e9ecef;\n$header-item-bg-dark:                                               #31363c;\n$header-item-sub-color-dark:                                        #878a99;\n$topbar-user-bg-dark:                                               #31373c;\n$topbar-search-bg-dark:                                             #202328;\n$topbar-search-color-dark:                                          $white;\n\n//page-title\n$page-title-border-dark:                                            none;\n$page-title-box-shadow-dark:                                        0 1px 2px rgba(56,65,74,0.15);\n\n// Topbar - dark\n$dark-header-bg-dark:                                               $indigo;\n$dark-header-border-dark:                                           $indigo;\n$dark-header-item-color-dark:                                       rgba($white, .85);\n$dark-header-item-bg-dark:                                          #7399e5;\n$dark-header-item-sub-color-dark:                                   rgba($white, .6); \n$dark-topbar-user-bg-dark:                                          lighten($indigo, 3%);\n$dark-topbar-search-bg-dark:                                        rgba($white, .05);\n$dark-topbar-search-color-dark:                                     $white;\n\n//two column\n$twocolumn-menu-box-shadow-dark:                                    0 2px 4px rgba(15,34,58,0.12);\n\n// boxed \n$boxed-body-bg-dark:                                                darken($body-bg-dark, 4%);\n\n// Footer\n$footer-bg-dark:                                                    #212529;\n$footer-color-dark:                                                 #878a99;\n\n//sidebar light \n$vertical-menu-bg-dark:                                             $white;\n$vertical-menu-border-dark:                                         $white;\n$vertical-menu-item-color-dark:                                     darken($gray-600, 10%);\n$vertical-menu-item-bg-dark:                                        rgba($primary, .15);\n$vertical-menu-item-hover-color-dark:                               $primary;\n$vertical-menu-item-active-color-dark:                              $primary;\n$vertical-menu-item-active-bg-dark:                                 rgba($primary, .15);\n$vertical-menu-sub-item-color-dark:                                 darken($gray-600, 4%);\n$vertical-menu-sub-item-hover-color-dark:                           $primary;\n$vertical-menu-sub-item-active-color-dark:                          $primary;\n$vertical-menu-title-color-dark:                                    #919da9;\n\n//sidebar dark \n$dark-vertical-menu-bg-dark:                                        #212529;\n$dark-vertical-menu-border-dark:                                    #212529;\n$dark-vertical-menu-item-color-dark:                                #878a99;\n$dark-vertical-menu-item-bg-dark:                                   rgba($white, .15);\n$dark-vertical-menu-item-hover-color-dark:                          $white;\n$dark-vertical-menu-item-active-color-dark:                         $white;\n$dark-vertical-menu-item-active-bg-dark:                            rgba($white, .15);\n$dark-vertical-menu-sub-item-color-dark:                            #7c7f90;\n$dark-vertical-menu-sub-item-hover-color-dark:                      $white;\n$dark-vertical-menu-sub-item-active-color-dark:                     $white;\n$dark-vertical-menu-title-color-dark:                               #5f6270;\n$dark-twocolumn-menu-iconview-bg-dark:                              #292e32;\n\n//sidebar gradient\n$vertical-menu-item-color-gradient-dark:                            rgba($white, .5);\n$vertical-menu-item-bg-gradient-dark:                               rgba($white, .15);\n$vertical-menu-item-hover-color-gradient-dark:                      $white;\n$vertical-menu-item-active-color-gradient-dark:                     $white;\n$vertical-menu-item-active-bg-gradient-dark:                        rgba($white, .15);\n$vertical-menu-sub-item-color-gradient-dark:                        rgba($white, .5);\n$vertical-menu-sub-item-hover-color-gradient-dark:                  $white;\n$vertical-menu-sub-item-active-color-gradient-dark:                 $white;\n$vertical-menu-title-color-gradient-dark:                           rgba($white, .5);\n\n//gradient one\n$vertical-menu-bg-gradient-dark:                                    linear-gradient(to right, var(--#{$prefix}primary), var(--#{$prefix}success));\n$vertical-menu-border-gradient-dark:                                var(--#{$prefix}success);\n$twocolumn-menu-iconview-bg-gradient-dark:                          var(--#{$prefix}primary);\n\n//gradient-2\n$vertical-menu-bg-gradient-2-dark:                                  linear-gradient(to right, var(--#{$prefix}info), var(--#{$prefix}secondary));\n$vertical-menu-border-gradient-2-dark:                              var(--#{$prefix}secondary);\n$twocolumn-menu-iconview-bg-gradient-2-dark:                        var(--#{$prefix}info);\n\n//gradient-3\n$vertical-menu-bg-gradient-3-dark:                                  linear-gradient(to right, var(--#{$prefix}info), var(--#{$prefix}success));\n$vertical-menu-border-gradient-3-dark:                              var(--#{$prefix}success);\n$twocolumn-menu-iconview-bg-gradient-3-dark:                        var(--#{$prefix}info);\n\n//gradient-4\n$vertical-menu-bg-gradient-4-dark:                                  linear-gradient(to right, #1a1d21, var(--#{$prefix}primary));\n$vertical-menu-border-gradient-4-dark:                              var(--#{$prefix}primary);\n$twocolumn-menu-iconview-bg-gradient-4-dark:                        #1a1d21;","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.3 (https://getbootstrap.com/)\n   * Copyright 2011-2024 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(#{$input-border-width} * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-header .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n    // stylelint-enable selector-max-class\n\n    > .accordion-collapse {\n      @include border-radius(0);\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @if $color-mode-type == \"media-query\" {\n      .carousel {\n        @include carousel-dark();\n      }\n    } @else {\n      .carousel,\n      &.carousel {\n        @include carousel-dark();\n      }\n    }\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) calc(-.5 * var(--#{$prefix}offcanvas-padding-x)) calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","/*\nTemplate Name: Velzon - Admin & Dashboard Template\nAuthor: Themesbrand\nVersion: 3.0.0\nWebsite: https://themesbrand.com/\nContact: support@themesbrand.com\nFile: Main Css File\n*/\n\n\n//Fonts\n@import \"../../fonts/fonts\";\n\n//Core files\n@import \"../../../../../../node_modules/bootstrap/scss/functions\";\n@import \"../../../../../../node_modules/bootstrap/scss/variables\";\n@import \"variables\";\n@import \"variables-custom\";\n@import \"variables-dark\";\n@import \"custom\";\n@import \"../../../../../../node_modules/bootstrap/scss/mixins\";\n\n\n// Structure\n@import \"../../structure/topbar\";\n@import \"../../structure/page-head\";\n@import \"../../structure/footer\";\n@import \"../../structure/vertical\";\n@import \"../../structure/horizontal\";\n@import \"../../structure/two-column\";\n@import \"../../structure/layouts\";\n\n// Components\n@import \"../../components/waves\";\n@import \"../../components/avatar\";\n@import \"../../components/accordion\";\n@import \"../../components/helper\";\n@import \"../../components/preloader\";\n@import \"../../components/forms\";\n@import \"../../components/widgets\";\n@import \"../../components/demos\";\n@import \"../../components/print\";\n@import \"../../components/ribbons\";\n@import \"../../components/toast\";\n@import \"../../components/scrollspy\";\n\n// Bootstrap components\n@import \"../../components/root\";\n@import \"../../components/reboot\";\n@import \"../../components/alerts\";\n@import \"../../components/badge\";\n@import \"../../components/buttons\";\n@import \"../../components/breadcrumb\";\n@import \"../../components/card\";\n@import \"../../components/dropdown\";\n@import \"../../components/nav\";\n@import \"../../components/table\";\n@import \"../../components/modal\";\n@import \"../../components/pagination\";\n@import \"../../components/progress\";\n@import \"../../components/popover\";\n@import \"../../components/type\";\n@import \"../../components/form-check\";\n@import \"../../components/form-control\";\n@import \"../../components/list-group\";\n\n// Plugins\n@import \"../../plugins/custom-scrollbar\";\n@import \"../../plugins/prismjs\";\n@import \"../../plugins/sweetalert2\";\n@import \"../../plugins/dropzone\";\n@import \"../../plugins/range-slider\";\n@import \"../../plugins/sortablejs\";\n@import \"../../plugins/tour\";\n@import \"../../plugins/swiper\";\n@import \"../../plugins/multijs\";\n@import \"../../plugins/colorpicker\";\n@import \"../../plugins/filepond\";\n@import \"../../plugins/form-input-spin\";\n@import \"../../plugins/ckeditor\";\n@import \"../../plugins/quilljs\";\n@import \"../../plugins/gridjs\";\n@import \"../../plugins/listjs\";\n@import \"../../plugins/apexcharts\";\n@import \"../../plugins/chartjs\";\n@import \"../../plugins/echarts\";\n@import \"../../plugins/google-map\";\n@import \"../../plugins/autocomplete\";\n@import \"../../plugins/vector-maps\";\n@import \"../../plugins/leaflet-maps\";\n@import \"../../plugins/fullcalendar\";\n@import \"../../plugins/emoji-picker\";\n@import \"../../plugins/datatables\";\n@import \"../../plugins/select2\";\n\n// Plugins\n@import \"../../plugins/toastify\";\n@import \"../../plugins/choices\";\n@import \"../../plugins/flatpicker\";\n@import \"../../plugins/flag-input\";\n\n// Pages\n@import \"../../pages/authentication\";\n@import \"../../pages/dashboard\";\n@import \"../../pages/timeline\";\n@import \"../../pages/gallery\";\n@import \"../../pages/errors\";\n@import \"../../pages/profile\";\n@import \"../../pages/sitemap\";\n@import \"../../pages/team\";\n@import \"../../pages/coming-soon\";\n@import \"../../pages/search-results\";\n@import \"../../pages/ecommerce\";\n@import \"../../pages/invoice\";\n@import \"../../pages/chat\";\n@import \"../../pages/email\";\n@import \"../../pages/kanban\";\n@import \"../../pages/landing\";\n@import \"../../pages/nft-landing\";\n@import \"../../pages/file-manager\";\n@import \"../../pages/to-do\";\n@import \"../../pages/jobs\";\n@import \"../../pages/job-landing\";","//\n// Google font - Poppins\n//\n\n@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');\n\n//\n// Premium Font : HKGrotesk\n//\n\n@font-face {\n    font-family: \"hkgrotesk\";\n   \n    src: url(\"../../fonts/hkgrotesk-light.eot\");\n    src: local('hkgrotesk light'), url(\"../../fonts/hkgrotesk-light.woff\") format(\"woff\");\n    font-weight: 300;\n}\n\n@font-face {\n    font-family: \"hkgrotesk\";\n    src: url(\"../../fonts/hkgrotesk-regular.eot\");\n    src: local('hkgrotesk regular'), url(\"../../fonts/hkgrotesk-regular.woff\") format(\"woff\");\n    font-weight: 400;\n}\n@font-face {\n    font-family: \"hkgrotesk\";\n    src: url(\"../../fonts/hkgrotesk-medium.eot\");\n    src: local('hkgrotesk medium'), url(\"../../fonts/hkgrotesk-medium.woff\") format(\"woff\");\n    font-weight: 500;\n}\n@font-face {\n    font-family: \"hkgrotesk\";\n    src: url(\"../../fonts/hkgrotesk-semibold.eot\");\n    src: local('hkgrotesk semibold'), url(\"../../fonts/hkgrotesk-semibold.woff\") format(\"woff\");\n    font-weight: 600;\n}\n@font-face {\n    font-family: \"hkgrotesk\";\n    // src: url(\"../../fonts/hkgrotesk-bold.eot\");\n   \n    src: local('hkgrotesk bold'), url(\"../../fonts/hkgrotesk-bold.woff\") format(\"woff\");\n    font-weight: 700;\n}","/*\nTemplate Name: Velzon - Admin & Dashboard Template\nAuthor: Themesbrand\nWebsite: https://themesbrand.com/\nContact: support@themesbrand.com\nFile: Custom Css File\n*/\n\n\n","//\n// _topbar.scss\n//\n\n#page-topbar {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 1002;\n    background-color: var(--#{$prefix}header-bg);\n    transition: all 0.1s ease-out;\n    border-bottom: 1px solid var(--#{$prefix}header-border);\n\n    &.topbar-shadow {\n        box-shadow: $box-shadow;\n    }\n\n    @media (min-width: 768px) {\n        left: var(--#{$prefix}vertical-menu-width);\n    }\n}\n\n.navbar-header {\n    display: flex;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n    align-items: center;\n    margin: 0 auto;\n    height: $header-height;\n    padding: 0 $grid-gutter-width 0 calc(#{$grid-gutter-width} * 0.5)\n    /*rtl: 0 0 0 calc(#{$grid-gutter-width} * 0.5) */\n    ;\n\n    @media (max-width: 767.98px) {\n        padding: 0 calc(#{$grid-gutter-width} * 0.5) 0 calc(#{$grid-gutter-width} * 0.5);\n    }\n\n    .topbar-head-dropdown {\n        .dropdown-menu.show {\n            top: 13px !important;\n        }\n\n        .notification-actions {\n            display: none;\n            position: absolute;\n            background-color: $dropdown-bg;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            padding: 7px;\n            border-top: 1px solid var(--#{$prefix}border-color);\n        }\n    }\n\n    .btn-topbar {\n        height: 42px;\n        width: 42px;\n        color: var(--#{$prefix}header-item-sub-color);\n        transition: all 0.5s ease;\n\n        &:hover, &:focus, &:active, &.active {\n            background-color: var(--#{$prefix}header-item-bg);\n        }\n\n        @media (max-width: 360px) {\n            height: 36px;\n            width: 36px;\n        }\n    }\n\n\n    .user-name-sub-text {\n        color: var(--#{$prefix}header-item-sub-color);\n    }\n\n    .user-name-text {\n        color: var(--#{$prefix}header-item-color);\n    }\n}\n\n/* Search */\n\n.app-search {\n    padding: calc(#{$header-height - 38px} * 0.5) 0;\n\n    .form-control {\n        border: none;\n        height: 38px;\n        padding-left: 40px;\n        padding-right: 30px;\n        background-color: var(--#{$prefix}topbar-search-bg);\n        color: var(--#{$prefix}topbar-search-color);\n        box-shadow: none;\n    }\n\n    span.search-widget-icon {\n        position: absolute;\n        z-index: 10;\n        font-size: 18px;\n        line-height: 38px;\n        left: 13px;\n        top: 0;\n        color: var(--#{$prefix}header-item-sub-color);\n    }\n\n    .search-widget-icon-close {\n        right: 7px;\n        left: auto !important;\n    }\n\n    @media (max-width: 1023.99px) {\n        padding-left: calc(#{$grid-gutter-width} * 0.5);\n    }\n\n    ::-webkit-input-placeholder {\n        /* Edge */\n        color: var(--#{$prefix}header-item-sub-color);\n    }\n\n    :-ms-input-placeholder {\n        /* Internet Explorer 10-11 */\n        color: var(--#{$prefix}header-item-sub-color);\n    }\n\n    ::placeholder {\n        color: var(--#{$prefix}header-item-sub-color);\n    }\n}\n\n// Mega menu\n\n.megamenu-list {\n    li {\n        position: relative;\n        padding: 5px 0px;\n\n        a {\n            color: $dropdown-color;\n        }\n    }\n}\n\n@media (max-width: 767.98px) {\n    .logo {\n        span.logo-lg {\n            display: none;\n        }\n\n        span.logo-sm {\n            display: inline-block;\n        }\n    }\n}\n\n.header-item {\n    height: $header-height;\n    display: flex;\n    align-items: center;\n}\n\n.header-profile-user {\n    height: 32px;\n    width: 32px;\n}\n\n.topbar-badge-sm {\n    right: 0;\n    top: 7px !important;\n}\n\n.topbar-badge {\n    right: -9px;\n    top: 4px !important;\n}\n\n.topbar-user {\n    @media (min-width: 768px) {\n        background-color: var(--#{$prefix}topbar-user-bg);\n    }\n\n    .dropdown-menu {\n        top: 6px !important;\n    }\n}\n\n.notification-item {\n    padding: 0.75rem 1rem;\n    white-space: inherit;\n    position: relative;\n\n    .form-check-input {\n        position: relative;\n        z-index: 2;\n    }\n}\n\n// Dropdown with Icons\n.dropdown-icon-item {\n    display: block;\n    border-radius: 3px;\n    line-height: 34px;\n    text-align: center;\n    padding: 15px 0 9px;\n    border: 1px solid transparent;\n    color: var(--#{$prefix}dropdown-link-color);\n\n    img {\n        height: 24px;\n    }\n\n    span {\n        display: block;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n\n    &:hover {\n        background-color: var(--#{$prefix}dropdown-link-hover-bg);\n    }\n}\n\n// Full Screen\n.fullscreen-enable {\n    [data-toggle=\"fullscreen\"] {\n        .bx-fullscreen::before {\n            content: \"\\eacb\";\n        }\n    }\n}\n\n// Dark mode enable\n[data-bs-theme=\"dark\"] {\n    .light-dark-mode {\n        .bx-moon::before {\n            content: \"\\ec34\";\n        }\n    }\n}\n\n[data-topbar=\"dark\"] {\n    .logo-dark {\n        display: none;\n    }\n\n    .logo-light {\n        display: inline-block;\n    }\n}\n\n[data-bs-theme=\"dark\"] {\n    &[data-topbar=\"light\"] {\n        .logo-dark {\n            display: none;\n        }\n\n        .logo-light {\n            display: inline-block;\n        }\n    }\n}\n\n@media (max-width: 600px) {\n    .navbar-header {\n        .dropdown {\n            position: static;\n\n            .dropdown-menu {\n                width: 100%;\n            }\n        }\n    }\n}\n\n@media (max-width: 767.98px) {\n    #search-dropdown-reponsive {\n        top: 54px !important;\n    }\n}\n\n[data-layout=\"vertical\"] {\n    &[data-layout-style=\"detached\"] {\n        @media (min-width: 1024.1px) {\n            #page-topbar {\n                left: 0 !important;\n                box-shadow: $box-shadow;\n            }\n\n            .horizontal-logo {\n                display: inline-block;\n                padding-left: 0;\n            }\n\n            .topnav-hamburger {\n                visibility: hidden;\n            }\n\n            .layout-width {\n                max-width: 95%;\n                margin: 0 auto;\n            }\n\n            &:is([data-sidebar-size=\"sm\"], [data-sidebar-size=\"sm-hover\"]) {\n                .navbar-brand-box {\n                    background-color: transparent !important;\n                    position: relative;\n                    width: auto;\n                    text-align: left;\n\n                    .logo-sm {\n                        display: none;\n                    }\n\n                    .logo-lg {\n                        display: block;\n                    }\n                }\n            }\n        }\n\n        &[data-topbar=\"dark\"] {\n            .horizontal-logo {\n                .logo-dark {\n                    display: none;\n                }\n\n                .logo-light {\n                    display: block;\n                }\n            }\n        }\n    }\n}\n\n[data-layout=\"horizontal\"] {\n    #page-topbar {\n        left: 0;\n        border-bottom: 1px solid var(--#{$prefix}header-border);\n\n        @media (min-width: 1024.1px) {\n            &.topbar-shadow {\n                box-shadow: none;\n            }\n        }\n    }\n\n    .page-content {\n        @media (min-width: 1024.1px) {\n            margin-top: $header-height;\n        }\n\n        @media (max-width: 1024.1px) {\n            padding: calc(45px + #{$grid-gutter-width} * 1.8) calc(#{$grid-gutter-width} * 0.5) $footer-height calc(#{$grid-gutter-width} * 0.5);\n        }\n\n        padding: calc(45px + #{$grid-gutter-width}) calc(#{$grid-gutter-width} * 0.5) $footer-height calc(#{$grid-gutter-width} * 0.5);\n    }\n\n    &[data-layout-width=\"boxed\"] {\n        .page-content {\n            @media (min-width: 1024.1px) {\n                min-height: calc(100vh - #{$footer-height + $header-height});\n            }\n        }\n    }\n}\n\n[data-layout=\"vertical\"] {\n\n    &:is([data-sidebar-size=\"sm\"], [data-sidebar-size=\"sm-hover\"]) {\n        #page-topbar {\n            @media (min-width: 768px) {\n                left: var(--#{$prefix}vertical-menu-width-sm);\n            }\n        }\n    }\n\n    &[data-sidebar-size=\"md\"] {\n        #page-topbar {\n            @media (min-width: 768px) {\n                left: var(--#{$prefix}vertical-menu-width-md);\n            }\n        }\n    }\n}\n\n[data-layout=\"twocolumn\"] {\n    #page-topbar {\n        @media (min-width: 768px) {\n            left: calc(#{$twocolumn-menu-iconview-width} + #{$twocolumn-menu-width});\n        }\n    }\n\n    .horizontal-logo {\n        display: none;\n    }\n}","//\n// custom-variables\n//\n\n// Vertical menu\n$vertical-menu-width:                             250px;\n$vertical-menu-width-md:                          180px;\n$vertical-menu-width-sm:                          70px;\n\n$vertical-menu-z-index:                           1002;\n$vertical-menu-item-font-size:                    0.925rem;\n$vertical-menu-item-font-family:                  $font-family-primary;\n$vertical-menu-sub-item-font-family:              $font-family-primary;\n$vertical-menu-item-padding-x:                    1.5rem;\n$vertical-menu-item-padding-y:                    0.625rem;\n$vertical-menu-sub-item-font-size:                0.875rem;\n$vertical-menu-item-icon-width:                   1.75rem;\n$vertical-menu-sub-item-padding-x:                1.5rem;\n$vertical-menu-sub-item-padding-y:                0.55rem;\n\n// Light Menu\n$vertical-menu-bg:                                $white;\n$vertical-menu-border:                            $white;\n$vertical-menu-item-color:                        darken($gray-600, 10%);\n$vertical-menu-item-bg:                           rgba($primary, .15);\n$vertical-menu-item-hover-color:                  $primary;\n$vertical-menu-item-active-color:                 $primary;\n$vertical-menu-item-active-bg:                    rgba($primary, .15);\n$vertical-menu-sub-item-color:                    darken($gray-600, 4%);\n$vertical-menu-sub-item-hover-color:              $primary;\n$vertical-menu-sub-item-active-color:             $primary;\n$vertical-menu-title-color:                       #919da9;\n$vertical-menu-box-shadow:                        0 2px 4px rgba(15,34,58,0.12);\n$vertical-menu-dropdown-box-shadow:               0 2px 4px rgba(15, 34, 58, 0.12);\n\n//sidebar dark \n$dark-vertical-menu-bg:                           $indigo;\n$dark-vertical-menu-border:                       $indigo;\n$dark-vertical-menu-item-color:                   #abb9e8;\n$dark-vertical-menu-item-bg:                      rgba($white, .15);\n$dark-vertical-menu-item-hover-color:             $white;\n$dark-vertical-menu-item-active-color:            $white;\n$dark-vertical-menu-item-active-bg:               rgba($white, .15);\n$dark-vertical-menu-sub-item-color:               #abb9e8;\n$dark-vertical-menu-sub-item-hover-color:         $white;\n$dark-vertical-menu-sub-item-active-color:        $white;\n$dark-vertical-menu-title-color:                  #838fb9;\n$dark-vertical-menu-box-shadow:                   0 2px 4px rgba(15,34,58,0.12);\n$dark-vertical-menu-dropdown-box-shadow:          0 2px 4px rgba(15,34,58,0.12);\n$dark-twocolumn-menu-iconview-bg:                 lighten($indigo, 2%);\n\n//sidebar gradient\n$vertical-menu-item-color-gradient:               rgba($white, .5);\n$vertical-menu-item-bg-gradient:                  rgba($white, .15);\n$vertical-menu-item-hover-color-gradient:         $white;\n$vertical-menu-item-active-color-gradient:        $white;\n$vertical-menu-item-active-bg-gradient:           rgba($white, .15);\n$vertical-menu-sub-item-color-gradient:           rgba($white, .5);\n$vertical-menu-sub-item-hover-color-gradient:     $white;\n$vertical-menu-sub-item-active-color-gradient:    $white;\n$vertical-menu-title-color-gradient:              rgba($white, .5);\n$vertical-menu-box-shadow-gradient:               0 2px 4px rgba(15,34,58,0.12);\n$vertical-menu-dropdown-box-shadow-gradient:      0 2px 4px rgba(15,34,58,0.12);\n\n//gradient one\n$vertical-menu-bg-gradient:                       linear-gradient(to right, var(--#{$prefix}primary), var(--#{$prefix}success));\n$vertical-menu-border-gradient:                   var(--#{$prefix}success);\n$twocolumn-menu-iconview-bg-gradient:             var(--#{$prefix}primary);\n\n//gradient-2\n$vertical-menu-bg-gradient-2:                     linear-gradient(to right, var(--#{$prefix}info), var(--#{$prefix}secondary));\n$vertical-menu-border-gradient-2:                 var(--#{$prefix}secondary);\n$twocolumn-menu-iconview-bg-gradient-2:           var(--#{$prefix}info);\n\n//gradient-3\n$vertical-menu-bg-gradient-3:                     linear-gradient(to right, var(--#{$prefix}info), var(--#{$prefix}success));\n$vertical-menu-border-gradient-3:                 var(--#{$prefix}success);\n$twocolumn-menu-iconview-bg-gradient-3:           var(--#{$prefix}info);\n\n//gradient-4\n$vertical-menu-bg-gradient-4:                     linear-gradient(to right, #1a1d21, var(--#{$prefix}primary));\n$vertical-menu-border-gradient-4:                 var(--#{$prefix}primary);\n$twocolumn-menu-iconview-bg-gradient-4:           #1a1d21;\n\n// Topbar - (Default Light)\n$header-height:                                   70px;\n$header-bg:                                       $white;\n$header-border:                                   $border-color;\n$header-item-color:                               $gray-700;\n$header-item-bg:                                  rgba($secondary, .12);\n$header-item-sub-color:                           #878a99;  \n$topbar-user-bg:                                  #f3f3f9;\n$topbar-search-bg:                                #f3f3f9;\n$topbar-search-color:                             $gray-700;\n\n//page title \n$page-title-box-shadow:                           0 1px 2px rgba(56,65,74,0.15);\n$page-title-border:                               transparent;\n\n// Topbar - dark\n$dark-header-bg:                                  $indigo;\n$dark-header-border:                              $indigo;\n$dark-header-item-color:                          rgba($white, .85);\n$dark-header-item-bg:                             #495c99;\n$dark-header-item-sub-color:                      #b0c4d9; \n$dark-topbar-user-bg:                             #52639c;\n$dark-topbar-search-bg:                           rgba($white, .05);\n$dark-topbar-search-color:                        $white;\n\n// Horizontal Menu\n$horizontal-menu-box-shadow:                      0 2px 4px rgba(15,34,58,0.12);\n$horizontal-menu-dropdown-box-shadow:             0 0px 5px rgba(15,34,58,0.15);\n$horizontal-menu-dropdown-min-width:              12rem; \n$horizontal-menu-item-padding-x:                  1.5rem;\n$horizontal-menu-item-padding-y:                  0.75rem;\n$topnav-bg:                                       $white;\n$topnav-item-color:                               darken($gray-600, 10%);\n$topnav-item-active-color:                        $primary;\n\n// Two Column Menu (Default Light)\n$twocolumn-menu-iconview-width:                   70px;\n$twocolumn-menu-width:                            220px;\n$twocolumn-menu-box-shadow:                       0 2px 4px rgba(15,34,58,0.12);\n$twocolumn-menu-z-index:                          1002;\n$twocolumn-menu-iconview-bg:                      $white;\n\n//semibox layout\n$semibox-width:                                   110px;\n\n// Brand \n$navbar-brand-box-width:                          240px;\n\n// Boxed layout width\n$boxed-layout-width:                              1300px;\n$boxed-body-bg:                                   darken($body-bg, 4%);\n\n// Footer\n$footer-height:                                   60px;\n$footer-bg:                                       $white;\n$footer-color:                                    #98a6ad;\n\n// Chat\n$chat-primary-bg:                                 var(--#{$prefix}light);\n$chat-secondary-bg:                               rgba(var(--#{$prefix}primary-rgb), 0.15);\n$chat-secondary-color:                            var(--#{$prefix}primary);\n\n// Timeline\n$timeline-color:                                  var(--#{$prefix}secondary-bg);     \n\n//auth pages\n$auth-bg-cover:                                   linear-gradient(-45deg, $primary 50%, $success);\n\n$input-bg-custom:                                 $body-secondary-bg;\n$input-border-custom:                             $border-color-translucent;","// \n// _page-head.scss\n// \n\n.page-title-box {\n    padding: 10px $grid-gutter-width;\n    background-color: var(--#{$prefix}secondary-bg);\n    box-shadow: var(--#{$prefix}page-title-box-shadow);\n    border-bottom: 1px solid var(--#{$prefix}page-title-border);\n    margin: -23px (-$grid-gutter-width * 1) $grid-gutter-width (-$grid-gutter-width * 1);\n\n    .breadcrumb {\n        background-color: transparent;\n        padding: 0;\n    }\n\n    h4 {\n        font-weight: 700;\n        font-size: 15px!important;\n        text-transform: uppercase;\n    }\n}\n\n[data-layout=\"horizontal\"] {\n    .page-title-box {\n        padding: 1.2rem 0;\n        background-color: transparent !important;\n        border-bottom: none;\n        border-top: none;\n        box-shadow: none;\n        margin: 0;\n\n        @media (min-width: 1024.1px) {\n            margin: -19px 0 0 0;\n        }\n    }\n}\n\n[data-layout=\"vertical\"] {\n    &[data-layout-style=\"detached\"]{\n        .page-title-box {\n            padding: 1.2rem 0;\n            background-color: transparent !important;\n            border-bottom: none;\n            border-top: none;\n            box-shadow: none;\n            margin: 0;\n    \n            @media (min-width: 1024.1px) {\n                margin: -19px 0 0 0;\n            }\n        }\n    }\n}","// \n// _footer.scss\n// \n\n.footer {\n    bottom: 0;\n    padding: 20px calc(#{$grid-gutter-width} * 0.5);\n    position: absolute;\n    right: 0;\n    color: var(--#{$prefix}footer-color);\n    left: var(--#{$prefix}vertical-menu-width);\n    height: $footer-height;\n    background-color: var(--#{$prefix}footer-bg);\n\n    @media (max-width: 991.98px) {\n        left: 0;\n    }\n}\n\n[data-layout=\"vertical\"] {\n\n    &:is([data-sidebar-size=\"sm\"], [data-sidebar-size=\"sm-hover\"]) {\n        .footer {\n            left: var(--#{$prefix}vertical-menu-width-sm);\n\n            @media (max-width: 767.98px) {\n                left: 0;\n            }\n        }\n    }\n    &[data-sidebar-size=\"md\"] {\n        .footer {\n            left: var(--#{$prefix}vertical-menu-width-md);\n\n            @media (max-width: 991.98px) {\n                left: 0;\n            }\n        }\n    }\n\n}\n\n[data-layout=\"horizontal\"]{\n    .footer {\n        left: 0 !important;\n    } \n}\n\n[data-layout=\"vertical\"][data-layout-style=\"detached\"] {\n\n    @media (min-width: 1024.1px) {\n        .footer {\n            left: 0 !important;\n            background-color: transparent;\n        } \n    }\n}\n\n[data-layout=\"twocolumn\"] { \n    .footer {\n        @media (min-width: 768.1px) {\n            left: calc(#{$twocolumn-menu-iconview-width} + #{$twocolumn-menu-width});\n        }\n    }\n}","//\n// _vertical.scss\n//\n\n.app-content {\n  margin-left: var(--#{$prefix}vertical-menu-width);\n  overflow: hidden;\n\n  .content {\n    padding: 0 15px 10px 15px;\n    margin-top: $header-height;\n  }\n}\n\n.main-content {\n  transition: all 0.1s ease-out;\n\n  @media (min-width: 768px) {\n    margin-left: var(--#{$prefix}vertical-menu-width);\n  }\n\n  /* Customize the scrollbar */\n  &::-webkit-scrollbar {\n    width: 12px; /* Set the width of the scrollbar */\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #5b78da; /* Set the color of the thumb */\n    border-radius: 6px; /* Optional: Set the border radius of the thumb */\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: grey; /* Set the color of the track */\n  }\n}\n\n.page-content {\n  padding: calc(#{$header-height} + #{$grid-gutter-width})\n    calc(#{$grid-gutter-width} * 0.5) $footer-height\n    calc(#{$grid-gutter-width} * 0.5);\n}\n\n.navbar-menu {\n  width: var(--#{$prefix}vertical-menu-width);\n  z-index: $vertical-menu-z-index;\n  background: var(--#{$prefix}vertical-menu-bg);\n  border-right: 1px solid var(--#{$prefix}vertical-menu-border);\n  bottom: 0;\n  margin-top: 0;\n  position: fixed;\n  top: 0;\n  box-shadow: var(--#{$prefix}vertical-menu-box-shadow);\n  padding: 0 0 calc(#{$header-height} + 25px) 0;\n  transition: all 0.1s ease-out;\n\n  .navbar-nav {\n    .nav-link {\n      display: flex;\n      align-items: center;\n      padding: $vertical-menu-item-padding-y $vertical-menu-item-padding-x;\n      color: var(--#{$prefix}vertical-menu-item-color);\n      font-size: $vertical-menu-item-font-size;\n      font-family: $vertical-menu-item-font-family;\n\n      &.active {\n        color: var(--#{$prefix}vertical-menu-item-active-color);\n      }\n\n      &:hover {\n        color: var(--#{$prefix}vertical-menu-item-hover-color);\n      }\n\n      i {\n        display: inline-block;\n        min-width: $vertical-menu-item-icon-width;\n        font-size: 18px;\n        line-height: inherit;\n      }\n\n      svg {\n        width: 18px;\n        margin-right: 0.665rem;\n        color: var(--#{$prefix}vertical-menu-item-color);\n      }\n\n      .badge {\n        margin-left: auto;\n        margin-right: -2px;\n        z-index: 1;\n      }\n\n      &:hover {\n        color: var(--#{$prefix}vertical-menu-item-hover-color);\n\n        .icon-dual {\n          color: var(--#{$prefix}vertical-menu-item-hover-color);\n          fill: rgba($primary, 0.16);\n        }\n      }\n\n      &[data-bs-toggle=\"collapse\"] {\n        &:after {\n          display: block;\n          content: \"\\F0142\";\n          font-family: \"Material Design Icons\";\n          margin-left: auto;\n          transition: transform 0.2s;\n          font-size: 1.05rem;\n          position: absolute;\n          right: 18px;\n          color: inherit;\n        }\n\n        &[aria-expanded=\"true\"] {\n          color: var(--#{$prefix}vertical-menu-item-active-color);\n\n          .icon-dual {\n            color: var(--#{$prefix}vertical-menu-item-hover-color);\n            fill: rgba($primary, 0.16);\n          }\n\n          &:after {\n            transform: rotate(90deg);\n            color: var(--#{$prefix}vertical-menu-item-active-color);\n          }\n\n          &:before {\n            opacity: 1;\n            background-color: var(--#{$prefix}vertical-menu-item-active-color);\n          }\n        }\n      }\n\n      &.collapsed {\n        &.active {\n          &::after {\n            transform: rotate(90deg);\n          }\n        }\n      }\n    }\n\n    .nav-sm {\n      padding-left: $vertical-menu-item-icon-width;\n\n      .nav-link {\n        padding: $vertical-menu-sub-item-padding-y\n          $vertical-menu-sub-item-padding-x !important;\n        color: var(--#{$prefix}vertical-menu-sub-item-color);\n        white-space: none;\n        position: relative;\n        font-size: $vertical-menu-sub-item-font-size;\n        font-family: $vertical-menu-sub-item-font-family;\n\n        &:before {\n          content: \"\";\n          width: 6px;\n          height: 1.5px;\n          background-color: var(--#{$prefix}vertical-menu-sub-item-color);\n          position: absolute;\n          left: 2px;\n          top: 16.5px;\n          transition: all 0.4s ease-in-out;\n          opacity: 0.5;\n        }\n\n        &:hover {\n          color: var(--#{$prefix}vertical-menu-sub-item-hover-color);\n\n          &:before {\n            background-color: var(\n              --#{$prefix}vertical-menu-sub-item-hover-color\n            ) !important;\n            opacity: 1;\n          }\n        }\n\n        &.active {\n          color: var(--#{$prefix}vertical-menu-item-active-color);\n\n          &:before {\n            background-color: var(--#{$prefix}vertical-menu-item-active-color);\n          }\n        }\n      }\n\n      .nav-sm {\n        padding-left: 15px;\n\n        .nav-link {\n          &:before {\n            height: 5px;\n            width: 5px;\n            left: 5px;\n            border-radius: 50%;\n            background-color: transparent;\n            border: 1px solid;\n            top: 16px;\n          }\n        }\n      }\n    }\n  }\n\n  .btn-vertical-sm-hover {\n    color: var(--#{$prefix}secondary-color);\n    display: none;\n  }\n}\n\n.navbar-brand-box {\n  padding: 0 1.3rem;\n  text-align: center;\n  transition: all 0.1s ease-out;\n\n  @media (max-width: 767.98px) {\n    display: none;\n  }\n}\n\n.hamburger-icon {\n  width: 20px;\n  height: 14px;\n  position: relative;\n  cursor: pointer;\n  display: inline-block;\n\n  span {\n    background-color: var(--#{$prefix}header-item-sub-color);\n    position: absolute;\n    border-radius: 2px;\n    transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);\n    width: 100%;\n    height: 2px;\n    display: block;\n    left: 0px;\n\n    &:nth-child(1) {\n      top: 0;\n      width: 80%;\n    }\n\n    &:nth-child(2) {\n      top: 6px;\n    }\n\n    &:nth-child(3) {\n      bottom: 0;\n      width: 60%;\n    }\n  }\n\n  .vertical-menu-btn:hover &:not(.open) {\n    span {\n      &:nth-child(1) {\n        top: -1px;\n      }\n\n      &:nth-child(3) {\n        bottom: -1px;\n      }\n    }\n  }\n\n  &.open {\n    transform: rotate(-90deg);\n\n    span {\n      &:nth-child(1) {\n        left: 1px;\n        top: 5px;\n        width: 20px;\n        transform: rotate(90deg);\n        transition-delay: 150ms;\n      }\n\n      &:nth-child(2) {\n        left: 3px;\n        top: 13px;\n        width: 10px;\n        transform: rotate(45deg);\n        transition-delay: 50ms;\n      }\n\n      &:nth-child(3) {\n        left: 9px;\n        top: 13px;\n        width: 10px;\n        transform: rotate(-45deg);\n        transition-delay: 100ms;\n      }\n    }\n  }\n}\n\n.logo {\n  line-height: $header-height;\n\n  .logo-sm {\n    display: none;\n  }\n}\n\n.logo-light {\n  display: none;\n}\n\n:is([data-layout=\"vertical\"], [data-layout=\"semibox\"]) {\n  .app-menu {\n    .row {\n      margin: 0;\n\n      > * {\n        width: 100%;\n        padding: 0;\n      }\n    }\n\n    @media (max-width: 767.98px) {\n      margin-left: -100%;\n      padding: 10px 0 20px 0;\n    }\n  }\n\n  .navbar-menu {\n    .container-fluid {\n      padding: 0;\n    }\n  }\n\n  .navbar-brand-box {\n    @media (max-width: 767.98px) {\n      display: none;\n    }\n  }\n\n  .horizontal-logo {\n    display: none;\n  }\n\n  &[data-sidebar-size=\"sm-hover\"] {\n    .main-content {\n      margin-left: var(--#{$prefix}vertical-menu-width-sm);\n\n      @media (max-width: 767.98px) {\n        margin-left: 0;\n      }\n    }\n\n    .logo {\n      span.logo-lg {\n        display: none;\n      }\n\n      span.logo-sm {\n        display: inline-block;\n      }\n    }\n\n    .btn-vertical-sm-hover {\n      display: inline-block;\n    }\n\n    @media (min-width: 768px) {\n      .topnav-hamburger {\n        display: none;\n      }\n    }\n\n    // Side menu\n    .navbar-menu {\n      width: var(--#{$prefix}vertical-menu-width-sm);\n\n      .btn-vertical-sm-hover {\n        display: none;\n\n        i {\n          &.ri-record-circle-line:before {\n            content: \"\\EB7D\";\n          }\n        }\n      }\n\n      // Sidebar Menu\n      .navbar-nav {\n        .badge {\n          display: none;\n        }\n\n        .menu-title {\n          text-align: center;\n\n          span {\n            display: none;\n          }\n\n          i {\n            color: var(--#{$prefix}vertical-menu-item-color);\n            display: block;\n            line-height: 36px;\n            font-size: 1rem;\n          }\n        }\n\n        .nav-link {\n          span {\n            display: none;\n          }\n\n          i {\n            font-size: 22px;\n\n            &.las,\n            &.lar,\n            &.lab {\n              font-size: 24px;\n            }\n          }\n\n          svg {\n            margin-right: 0px;\n          }\n\n          &:after,\n          &:before {\n            display: none;\n          }\n        }\n\n        .menu-dropdown {\n          display: none;\n        }\n      }\n\n      &:hover {\n        width: var(--#{$prefix}vertical-menu-width) !important;\n\n        @media (min-width: 1024.99px) {\n          .btn-vertical-sm-hover {\n            display: inline-block;\n          }\n\n          .navbar-brand-box {\n            text-align: left;\n          }\n        }\n\n        .navbar-nav {\n          .menu-dropdown.show {\n            display: block;\n          }\n        }\n\n        .nav-link {\n          i {\n            font-size: 18px;\n\n            &.las,\n            &.lar,\n            &.lab {\n              font-size: 20px;\n            }\n          }\n\n          svg {\n            margin-right: 0.665rem;\n          }\n\n          span,\n          &:after,\n          &:before {\n            display: inline-block;\n          }\n        }\n\n        .logo {\n          span.logo-lg {\n            display: inline-block;\n          }\n\n          span.logo-sm {\n            display: none;\n          }\n        }\n\n        .menu-title {\n          text-align: left;\n\n          span {\n            display: inline-block;\n          }\n\n          i {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n\n  &:is([data-sidebar-size=\"sm-hover\"], [data-sidebar-size=\"sm-hover-active\"]) {\n    .navbar-header {\n      @media (min-width: 1025px) {\n        padding-left: $grid-gutter-width;\n      }\n    }\n  }\n\n  &[data-sidebar-size=\"sm-hover-active\"] {\n    .navbar-brand-box {\n      text-align: left;\n    }\n\n    .topnav-hamburger {\n      display: none;\n    }\n\n    .btn-vertical-sm-hover {\n      display: inline-block;\n    }\n  }\n\n  &[data-sidebar-size=\"sm\"] {\n    @media (min-width: 768px) {\n      min-height: 585px;\n\n      .main-content {\n        margin-left: var(--#{$prefix}vertical-menu-width-sm);\n      }\n    }\n\n    @media (min-width: 1366px) {\n      min-height: 945px;\n      \n      .main-content {\n        margin-left: var(--#{$prefix}vertical-menu-width-sm);\n      }\n    }\n\n    #page-topbar {\n      z-index: calc(#{$vertical-menu-z-index} + 1);\n    }\n\n    .navbar-brand-box {\n      position: fixed;\n      padding: 0;\n      width: var(--#{$prefix}vertical-menu-width-sm);\n      z-index: 1;\n      top: 0;\n      background-color: var(--#{$prefix}vertical-menu-bg);\n    }\n\n    .logo {\n      span.logo-lg {\n        display: none;\n      }\n\n      span.logo-sm {\n        display: inline-block;\n      }\n    }\n\n    // Side menu\n    .navbar-menu {\n      position: fixed;\n      width: var(--#{$prefix}vertical-menu-width-sm) !important;\n      padding-top: $header-height;\n\n      .simplebar-mask,\n      .simplebar-content-wrapper {\n        overflow: visible !important;\n      }\n\n      .simplebar-scrollbar,\n      .vertical-menu-btn {\n        display: none !important;\n      }\n\n      .simplebar-offset {\n        bottom: 0 !important;\n      }\n\n      // Sidebar Menu\n      .navbar-nav {\n        .badge {\n          display: none !important;\n        }\n\n        .menu-title {\n          text-align: center;\n          font-size: 1rem;\n\n          span {\n            display: none;\n          }\n\n          i {\n            display: block;\n            line-height: 36px;\n          }\n        }\n\n        .nav-link {\n          span {\n            display: none;\n          }\n\n          i {\n            font-size: 22px;\n          }\n\n          svg {\n            margin-right: 0px;\n          }\n\n          &:after,\n          &:before {\n            display: none;\n          }\n        }\n\n        .menu-dropdown {\n          display: none;\n          height: auto !important;\n        }\n\n        .nav-item {\n          position: relative;\n\n          &:hover {\n            > a.menu-link {\n              position: relative;\n              width: calc(200px + var(--#{$prefix}vertical-menu-width-sm));\n              transition: none;\n              background: var(--#{$prefix}vertical-menu-bg);\n\n              .icon-dual {\n                fill: rgba($white, 0.16);\n              }\n\n              span {\n                display: inline-block;\n                padding-left: 25px;\n              }\n\n              &:after {\n                display: block;\n                transform: rotate(90deg);\n                color: $white;\n              }\n            }\n\n            .nav-link {\n              span {\n                display: inline-block;\n              }\n            }\n\n            > .menu-dropdown {\n              display: block;\n              left: var(--#{$prefix}vertical-menu-width-sm);\n              position: absolute;\n              width: 200px;\n              background: var(--#{$prefix}vertical-menu-bg);\n              height: auto !important;\n              padding: 0.5rem 0;\n              border-radius: 0 0 3px 3px;\n              box-shadow: $vertical-menu-dropdown-box-shadow;\n            }\n          }\n        }\n\n        .nav-sm {\n          padding: 0;\n\n          .nav-item {\n            &:hover {\n              > .nav-link {\n                color: var(--#{$prefix}vertical-menu-item-hover-color);\n\n                &:after {\n                  color: inherit;\n                }\n              }\n            }\n          }\n\n          .nav-link {\n            &:after {\n              display: block !important;\n              transform: rotate(0deg) !important;\n            }\n          }\n\n          .menu-dropdown {\n            left: 100% !important;\n            top: 0;\n            border-radius: 3px !important;\n          }\n        }\n      }\n    }\n  }\n\n  &[data-sidebar-size=\"md\"] {\n    @media (min-width: 768px) {\n      .main-content {\n        margin-left: var(--#{$prefix}vertical-menu-width-md);\n      }\n    }\n\n    .navbar-brand-box {\n      width: var(--#{$prefix}vertical-menu-width-md);\n    }\n\n    // Side menu\n    .navbar-menu {\n      width: var(--#{$prefix}vertical-menu-width-md) !important;\n\n      // Sidebar Menu\n      .navbar-nav {\n        .nav-link {\n          display: block;\n          text-align: center;\n          padding: $vertical-menu-sub-item-padding-y\n            $vertical-menu-sub-item-padding-x * 0.35;\n\n          i {\n            display: block;\n          }\n\n          svg {\n            display: block;\n            margin-left: auto;\n            margin-right: auto;\n          }\n\n          &:before {\n            display: none !important;\n          }\n\n          &[data-bs-toggle=\"collapse\"]:after {\n            position: relative;\n            display: inline-block;\n            right: 0;\n            top: 3px;\n          }\n\n          &.menu-link {\n            &[data-bs-toggle=\"collapse\"]:after {\n              display: none;\n            }\n          }\n        }\n\n        .badge {\n          display: none !important;\n        }\n\n        .nav-sm {\n          padding-left: 0;\n        }\n      }\n\n      .menu-title {\n        text-align: center;\n\n        span {\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n\n  &[data-sidebar=\"dark\"] {\n    .logo-dark {\n      display: none;\n    }\n\n    .logo-light {\n      display: inline-block;\n    }\n  }\n\n  &[data-sidebar=\"light\"] {\n    .logo-dark {\n      display: inline-block;\n    }\n\n    .logo-light {\n      display: none;\n    }\n  }\n\n  &[data-layout-style=\"detached\"] {\n    #layout-wrapper,\n    .main-content {\n      min-height: 100vh;\n    }\n\n    @media (min-width: 1024.1px) {\n      .main-content {\n        position: relative;\n      }\n\n      #layout-wrapper {\n        max-width: 95%;\n        margin: 0 auto;\n        padding-left: $grid-gutter-width;\n      }\n\n      .navbar-header {\n        padding-left: $grid-gutter-width;\n      }\n\n      .navbar-menu {\n        top: calc(#{$header-height} + #{$grid-gutter-width});\n        bottom: $grid-gutter-width;\n        padding: 0;\n        border-right: var(--#{$prefix}vertical-menu-bg);\n        border-radius: 5px;\n        padding: 10px 0;\n        z-index: 1;\n\n        .navbar-brand-box {\n          display: none;\n        }\n      }\n\n      &:is(\n          [data-sidebar=\"dark\"],\n          [data-sidebar=\"gradient\"],\n          [data-sidebar=\"gradient-2\"],\n          [data-sidebar=\"gradient-3\"],\n          [data-sidebar=\"gradient-4\"]\n        ) {\n        .logo-dark {\n          display: inline-block;\n        }\n\n        .logo-light {\n          display: none;\n        }\n      }\n    }\n\n    .footer {\n      border-top: 1px dashed var(--#{$prefix}border-color);\n    }\n\n    .auth-page-wrapper {\n      .footer {\n        border-top: none;\n      }\n    }\n\n    &[data-sidebar-size=\"sm\"] {\n      @media (min-width: 768px) {\n        #layout-wrapper,\n        .main-content {\n          min-height: 1400px;\n        }\n      }\n    }\n  }\n\n  @if $sidebar-gradient-mode {\n    &:is(\n        [data-sidebar=\"gradient\"],\n        [data-sidebar=\"gradient-2\"],\n        [data-sidebar=\"gradient-3\"],\n        [data-sidebar=\"gradient-4\"]\n      ) {\n      .logo-dark {\n        display: none;\n      }\n\n      .logo-light {\n        display: inline-block;\n      }\n    }\n  }\n}\n\n[data-layout=\"vertical\"][data-bs-theme=\"dark\"] {\n  &[data-layout-style=\"detached\"] {\n    @media (min-width: 1024.1px) {\n      &:is(\n          [data-sidebar=\"light\"],\n          [data-sidebar=\"dark\"],\n          [data-sidebar=\"gradient\"],\n          [data-sidebar=\"gradient-2\"],\n          [data-sidebar=\"gradient-3\"],\n          [data-sidebar=\"gradient-4\"]\n        ) {\n        .logo-dark {\n          display: none;\n        }\n\n        .logo-light {\n          display: inline-block;\n        }\n      }\n    }\n  }\n}\n\n.menu-title {\n  letter-spacing: 0.05em;\n  cursor: default;\n  font-size: 11px;\n  text-transform: uppercase;\n  color: var(--#{$prefix}vertical-menu-title-color);\n  font-weight: $font-weight-semibold;\n\n  span {\n    padding: 12px 20px;\n    display: inline-block;\n  }\n\n  i {\n    display: none;\n  }\n}\n\n.vertical-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba($dark, 0.35);\n  z-index: 1003;\n  display: none;\n}\n\n// Mobile Menu\n.vertical-sidebar-enable {\n  .vertical-overlay {\n    display: block;\n  }\n\n  .app-menu {\n    margin-left: 0 !important;\n    z-index: 1004;\n  }\n}\n\n// rtl\n[dir=\"rtl\"] {\n  .navbar-menu {\n    .navbar-nav {\n      .nav-link[data-bs-toggle=\"collapse\"] {\n        &:after {\n          transform: rotate(180deg);\n        }\n\n        &[aria-expanded=\"true\"]:after {\n          transform: rotate(270deg);\n        }\n      }\n    }\n  }\n}\n\n@if $sidebar-gradient-mode {\n  .bg-vertical-gradient {\n    background: $vertical-menu-bg-gradient;\n  }\n\n  .bg-vertical-gradient-2 {\n    background: $vertical-menu-bg-gradient-2;\n  }\n\n  .bg-vertical-gradient-3 {\n    background: $vertical-menu-bg-gradient-3;\n  }\n\n  .bg-vertical-gradient-4 {\n    background: $vertical-menu-bg-gradient-4;\n  }\n}\n\n@if $sidebar-img {\n  //sidebar-images\n  .sidebar-background {\n    position: absolute;\n    z-index: -1;\n    height: 100%;\n    width: 100%;\n    display: block;\n    top: 0;\n    left: 0;\n    background-size: cover;\n    background-position: 50%;\n    opacity: 0.07;\n  }\n\n  [data-sidebar-image=\"img-1\"] {\n    .sidebar-background {\n      background-image: url(\"../../images/sidebar/img-1.jpg\");\n    }\n  }\n\n  [data-sidebar-image=\"img-2\"] {\n    .sidebar-background {\n      background-image: url(\"../../images/sidebar/img-2.jpg\");\n    }\n  }\n\n  [data-sidebar-image=\"img-3\"] {\n    .sidebar-background {\n      background-image: url(\"../../images/sidebar/img-3.jpg\");\n    }\n  }\n\n  [data-sidebar-image=\"img-4\"] {\n    .sidebar-background {\n      background-image: url(\"../../images/sidebar/img-4.jpg\");\n    }\n  }\n}\n\n[data-layout=\"semibox\"] {\n  .page-title-box {\n    padding: 10px 0;\n    background-color: transparent;\n    box-shadow: none;\n    margin: -15px 0 1.5rem 0;\n  }\n\n  @media (min-width: 768px) {\n    &[data-sidebar-size=\"sm\"],\n    &[data-sidebar-size=\"sm-hover\"] {\n      .main-content {\n        margin-left: var(--#{$prefix}vertical-menu-width-sm);\n      }\n\n      #page-topbar {\n        left: var(--#{$prefix}vertical-menu-width-sm);\n      }\n\n      .footer {\n        left: var(--#{$prefix}vertical-menu-width-sm);\n      }\n    }\n\n    &[data-sidebar-size=\"md\"] {\n      #page-topbar {\n        left: var(--#{$prefix}vertical-menu-width-md);\n      }\n\n      .footer {\n        left: var(--#{$prefix}vertical-menu-width-md);\n      }\n    }\n  }\n\n  @media (min-width: 1440px) {\n    .page-content {\n      padding: calc(#{$header-height} + #{$grid-gutter-width} * 2)\n        calc(#{$grid-gutter-width} * 0.5) $footer-height\n        calc(#{$grid-gutter-width} * 0.5);\n    }\n\n    .navbar-menu {\n      margin: 25px;\n      border-radius: var(--#{$prefix}border-radius);\n    }\n\n    .main-content {\n      margin-left: calc(var(--#{$prefix}vertical-menu-width) + 25px);\n      padding: 0 var(--#{$prefix}semibox-width);\n    }\n\n    .footer {\n      left: calc(\n        var(--#{$prefix}vertical-menu-width) + var(--#{$prefix}semibox-width) +\n          #{$grid-gutter-width} + 25px\n      );\n      right: calc(var(--#{$prefix}semibox-width) + #{$grid-gutter-width});\n    }\n\n    #page-topbar {\n      left: calc(\n        var(--#{$prefix}vertical-menu-width) + var(--#{$prefix}semibox-width) +\n          #{$grid-gutter-width} + 25px\n      );\n      right: calc(var(--#{$prefix}semibox-width) + #{$grid-gutter-width});\n      top: 25px;\n      border-radius: $border-radius;\n      transition: all 0.5s ease;\n      border: 1px solid var(--#{$prefix}header-border);\n\n      &.topbar-shadow {\n        top: 0px;\n      }\n    }\n\n    &[data-sidebar-size=\"md\"] {\n      .main-content {\n        margin-left: calc(var(--#{$prefix}vertical-menu-width-md) + 25px);\n      }\n\n      #page-topbar {\n        left: calc(\n          var(--#{$prefix}vertical-menu-width-md) +\n            var(--#{$prefix}semibox-width) + #{$grid-gutter-width} + 25px\n        );\n      }\n\n      .footer {\n        left: calc(\n          var(--#{$prefix}vertical-menu-width-md) +\n            var(--#{$prefix}semibox-width) + #{$grid-gutter-width} + 25px\n        );\n      }\n    }\n\n    &[data-sidebar-size=\"sm\"] {\n      .main-content {\n        margin-left: calc(var(--#{$prefix}vertical-menu-width-sm) + 25px);\n      }\n\n      .navbar-brand-box {\n        top: 25px;\n      }\n\n      #page-topbar {\n        left: calc(\n          var(--#{$prefix}vertical-menu-width-sm) +\n            var(--#{$prefix}semibox-width) + #{$grid-gutter-width} + 25px\n        );\n      }\n\n      .footer {\n        left: calc(\n          var(--#{$prefix}vertical-menu-width-sm) +\n            var(--#{$prefix}semibox-width) + #{$grid-gutter-width} + 25px\n        );\n      }\n    }\n\n    &[data-sidebar-size=\"sm-hover\"] {\n      .main-content {\n        margin-left: calc(var(--#{$prefix}vertical-menu-width-sm) + 25px);\n      }\n\n      #page-topbar {\n        left: calc(\n          var(--#{$prefix}vertical-menu-width-sm) +\n            var(--#{$prefix}semibox-width) + #{$grid-gutter-width} + 25px\n        );\n      }\n\n      .footer {\n        left: calc(\n          var(--#{$prefix}vertical-menu-width-sm) +\n            var(--#{$prefix}semibox-width) + #{$grid-gutter-width} + 25px\n        );\n      }\n    }\n  }\n\n  .mx-n4 {\n    margin-left: 0px !important;\n    margin-right: 0px !important;\n\n    &.p-1 {\n      padding-left: 0px !important;\n      padding-right: 0px !important;\n    }\n  }\n}\n","//\n// _horizontal.scss\n// \n\n[data-layout=\"horizontal\"] {\n\n    .main-content {\n        margin-left: 0;\n    }\n\n    @media (min-width: 1024.1px) {\n\n        .layout-width,\n        .container-fluid {\n            max-width: 90%;\n            margin: 0 auto;\n        }\n\n        .topnav-hamburger {\n            visibility: hidden;\n        }\n    }\n\n    .horizontal-logo {\n        padding-left: calc(#{$grid-gutter-width} * 0.5);\n\n        @media (max-width: 1024.98px) {\n            padding-left: $grid-gutter-width;\n        }\n    }\n\n    .navbar-menu {\n        background: var(--#{$prefix}topnav-bg);\n        border-right-color: transparent;\n        padding: 0 calc(#{$grid-gutter-width} * 0.5);\n        box-shadow: $horizontal-menu-box-shadow;\n        margin-top: $header-height;\n        position: fixed;\n        left: 0;\n        right: 0;\n        z-index: 100;\n        width: 100%;\n        bottom: auto;\n\n        @media (max-width:575.98px) {\n            .container-fluid {\n                padding: 0;\n            }\n        }\n\n        .navbar-nav {\n            flex-direction: row;\n\n            .nav-sm {\n                padding-left: 0;\n\n                .nav-link {\n                    &:before {\n                        opacity: 0 !important;\n                    }\n\n                    &:hover,\n                    &.active {\n                        color: var(--#{$prefix}topnav-item-active-color);\n                    }\n                }\n            }\n\n            .nav-link {\n                color: var(--#{$prefix}topnav-item-color);\n                padding: $horizontal-menu-item-padding-y $horizontal-menu-item-padding-x;\n\n                i {\n                    line-height: 1;\n                }\n\n                &.active {\n                    color: var(--#{$prefix}topnav-item-active-color);\n                    &:after {\n                        color: var(--#{$prefix}topnav-item-active-color);\n                    }   \n                    .icon-dual {\n                        color: var(--#{$prefix}topnav-item-active-color);\n                        fill: rgba($primary, 0.10);\n                    }\n                }\n\n                &[data-bs-toggle=collapse][aria-expanded=true] {\n                    color: var(--#{$prefix}topnav-item-active-color);\n\n                    .icon-dual {\n                        color: var(--#{$prefix}topnav-item-active-color);\n                        fill: rgba($primary, 0.10);\n                    }\n\n                    &:after {\n                        color: var(--#{$prefix}topnav-item-active-color);\n                    }\n                }\n\n                &:hover {\n                    .icon-dual {\n                        color: var(--#{$prefix}topnav-item-active-color);\n                        fill: rgba($primary, 0.10);\n                    }\n                }\n            }\n\n            >.nav-item {\n                >.nav-link[data-bs-toggle=collapse]:after {\n                    right: 0px;\n                    transform: rotate(90deg) !important;\n                }\n            }\n\n            >li:nth-of-type(2) {\n                >.nav-link.menu-link {\n                    padding-left: 0;\n                }\n            }\n        }\n\n        .navbar-brand-box {\n            display: none;\n        }\n    }\n\n    .navbar-nav {\n        .nav-item {\n            position: relative;\n\n            .nav-link[data-bs-toggle=collapse]:after {\n                right: 10px;\n                transform: rotate(0deg) !important;\n            }\n\n            >.nav-link {\n                >.badge {\n                    display: none;\n                }\n            }\n\n            &:hover {\n                >.nav-link {\n                    color: var(--#{$prefix}topnav-item-active-color);\n\n                    .icon-dual {\n                        color: var(--#{$prefix}topnav-item-active-color);\n                        fill: rgba($primary, 0.10);\n                    }\n\n                    &:after {\n                        color: var(--#{$prefix}topnav-item-active-color);\n                    }\n                }\n\n                @media (min-width: 1024.1px) {\n                    >.menu-dropdown {\n                        display: block;\n                        height: auto !important;\n                    }\n                }\n            }\n\n            &.active {\n                color: var(--#{$prefix}topnav-item-active-color);\n            }\n        }\n    }\n\n    .menu-dropdown {\n        position: absolute;\n        min-width: $horizontal-menu-dropdown-min-width;\n        padding: $dropdown-padding-y $dropdown-padding-x;\n        box-shadow: $horizontal-menu-dropdown-box-shadow;\n        animation-name: DropDownSlide;\n        animation-duration: .3s;\n        animation-fill-mode: both;\n        margin: 0;\n        z-index: $zindex-dropdown;\n        background-color: var(--#{$prefix}topnav-bg);\n        background-clip: padding-box;\n        border: $dropdown-border-width solid $dropdown-border-color;\n        border-radius: $dropdown-border-radius;\n        display: none;\n\n        .menu-dropdown {\n            top: 0;\n            left: 100%;\n        }\n    }\n\n    .mega-dropdown-menu {\n        width: 40rem;\n    }\n\n    .menu-title {\n        display: none;\n    }\n\n    .dropdown-custom-right {\n        left: -100% !important;\n        right: 100%;\n    }\n\n    @media (max-width: 1024px) {\n        .navbar-menu {\n            display: none;\n        }\n    }\n}\n\n[data-layout=\"horizontal\"] {\n    .menu {\n        @media (max-width: 1024px) {\n            .navbar-menu {\n                display: block;\n                max-height: 360px;\n                overflow-y: auto;\n                padding-left: 0;\n\n                .navbar-nav {\n                    flex-direction: column;\n\n                    >li:nth-of-type(2)>.nav-link.menu-link {\n                        padding-left: $vertical-menu-item-padding-x;\n                    }\n\n                    .nav-sm .nav-link:before {\n                        opacity: 1 !important;\n                    }\n                }\n            }\n\n            .menu-dropdown {\n                position: relative;\n                min-width: 100%;\n                box-shadow: none;\n                padding-left: 28px;\n                left: 0;\n                animation: none;\n                padding-top: 0;\n\n                &.show {\n                    display: block;\n                }\n            }\n\n            .dropdown-custom-right {\n                left: 0 !important;\n            }\n\n            .nav-item .nav-link[data-bs-toggle=collapse]:after {\n                right: 0px;\n            }\n\n            .mega-dropdown-menu {\n                width: 100%;\n            }\n        }\n    }\n}\n\n// rtl\n[dir=\"rtl\"]{\n    &[data-layout=horizontal] {\n        .navbar-menu {\n            .navbar-nav>.nav-item>.nav-link[data-bs-toggle=collapse]{\n                &:after{\n                    transform: rotate(-90deg) !important;\n                }\n            }\n        }\n\n        .navbar-nav{\n            .nav-item {\n                .nav-link[data-bs-toggle=collapse]{\n                    &:after{\n                        transform: rotate(-180deg)!important;\n                    }\n                }\n            }\n        }\n    }\n}","//\n// _two-column.scss\n// \n\n[data-layout=\"twocolumn\"] {\n    .app-menu {\n        padding-bottom: 0;\n        width: $twocolumn-menu-width;\n        left: $twocolumn-menu-iconview-width;\n\n        .menu-link {\n            letter-spacing: .05em;\n            cursor: default;\n            font-size: 11px;\n            text-transform: uppercase;\n            font-weight: $font-weight-semibold;\n\n            &:after {\n                display: none !important;\n            }\n\n            i {\n                display: none;\n            }\n        }\n\n        .navbar-nav {\n            height: calc(100vh - #{$header-height});\n\n            @media (max-width: 767.98px) {\n                padding-top: 16px;\n            }\n\n            >li:not(.twocolumn-item-show) {\n                display: none;\n            }\n\n            .twocolumn-item-show {\n                >div {\n                    display: block !important;\n                    height: auto !important;\n                }\n            }\n\n            >.nav-item {\n                >.menu-dropdown {\n                    display: block !important;\n                    height: auto !important;\n                }\n            }\n\n            .nav-item {\n                .menu-dropdown {\n                    .row {\n                        margin: 0;\n\n                        .col-lg-4 {\n                            width: 100%;\n                            padding: 0;\n                        }\n                    }\n                }\n            }\n        }\n\n        .container-fluid {\n            padding: 0;\n        }\n    }\n\n    .main-content {\n        margin-left: calc(#{$twocolumn-menu-width} + #{$twocolumn-menu-iconview-width});\n\n        @media (max-width:767.98px) {\n            margin-left: $twocolumn-menu-iconview-width;\n        }\n    }\n\n    &:is([data-sidebar=\"dark\"], [data-sidebar=\"gradient\"], [data-sidebar=\"gradient-2\"], [data-sidebar=\"gradient-3\"], [data-sidebar=\"gradient-4\"]) {   \n        .app-menu {\n            .navbar-brand-box {\n                .logo-light {\n                    display: block;\n                }\n\n                .logo-dark {\n                    display: none;\n                }\n            }\n        }\n    }\n\n    .twocolumn-iconview {\n        width: $twocolumn-menu-iconview-width;\n        background-color: var(--#{$prefix}twocolumn-menu-iconview-bg);\n        height: 100%;\n        left: -$twocolumn-menu-iconview-width;\n        box-shadow: $twocolumn-menu-box-shadow;\n        top: 0;\n        position: absolute;\n        padding: 0;\n        text-align: center;\n\n        li {\n            position: relative;\n            list-style: none;\n            .nav-icon {\n                &::after {\n                    content: \"\";\n                    position: absolute;\n                    top: 0;\n                    right: 0;\n                    bottom: 0;\n                    left: 0;\n                }\n            }\n        }\n\n        .nav-icon {\n            width: 42px;\n            height: 42px;\n            color: var(--#{$prefix}vertical-menu-item-color);\n            line-height: 42px;\n            z-index: 1;\n            font-size: 22px;\n            text-align: center;\n            border-radius: 3px;\n            margin: 5px 0;\n            display: inline-flex;\n            justify-content: center;\n            align-items: center;\n\n            .icon-dual {\n                width: 18px;\n                color: var(--#{$prefix}vertical-menu-item-color);\n                fill: var(--#{$prefix}vertical-menu-item-bg);\n            }\n\n            &.active {\n                background-color: var(--#{$prefix}vertical-menu-item-active-bg);\n                color: var(--#{$prefix}vertical-menu-item-active-color);\n\n                .icon-dual {\n                    color: var(--#{$prefix}vertical-menu-item-active-color);\n                    fill: var(--#{$prefix}vertical-menu-item-active-bg);\n                }\n            }\n        }\n    }\n\n    .menu-title {\n        display: none;\n    }\n\n    @media (max-width: 991.98px) {\n        .logo {\n\n            span.logo-lg {\n                display: block;\n            }\n\n            span.logo-sm {\n                display: none;\n            }\n        }\n    }\n\n    &[data-sidebar=\"light\"] {\n        .app-menu {\n            .navbar-brand-box {\n                .logo-light {\n                    display: none;\n                }\n\n                .logo-dark {\n                    display: block;\n                }\n            }\n        }\n    }\n\n    &[data-sidebar=\"dark\"] {\n        .app-menu {\n\n            .navbar-brand-box {\n                .logo-light {\n                    display: block;\n                }\n\n                .logo-dark {\n                    display: none;\n                }\n            }\n        }\n    }\n\n    .twocolumn-panel {\n        .app-menu {\n            width: 0;\n            border-right: 0;\n\n            @media (max-width: 575.98px) {\n                display: none;\n            }\n        }\n\n        .navbar-brand-box,\n        .navbar-nav {\n            display: none;\n        }\n\n        .main-content {\n            margin-left: $twocolumn-menu-iconview-width;\n        }\n\n        #page-topbar,\n        .footer {\n            left: $twocolumn-menu-iconview-width;\n        }\n\n        @media (max-width: 575.98px) {\n            .main-content {\n                margin-left: 0;\n            }\n\n            #page-topbar,\n            .footer {\n                left: 0;\n            }\n        }\n\n    }\n\n    #page-topbar,\n    .footer {\n        @media (max-width: 767.98px) {\n            left: $twocolumn-menu-iconview-width;\n        }\n    }\n\n    @media (max-width: 575.98px) {\n        .main-content {\n            margin-left: 0;\n        }\n\n        #page-topbar,\n        .footer {\n            left: 0;\n        }\n    }\n}\n\n[data-layout=\"twocolumn\"] {\n    @media (max-width: 767.98px) {\n        .app-menu {\n            left: 0;\n            margin-left: 100%;\n        }\n\n        .main-content {\n            margin-left: 0 !important;\n        }\n\n        #page-topbar,\n        .footer {\n            left: 0 !important;\n        }\n    }\n}","// \n// _layouts.scss\n// \n\n[data-layout-width=\"boxed\"] {\n    body {\n        background-color: var(--#{$prefix}boxed-body-bg);\n    }\n\n    #layout-wrapper {\n        max-width: var(--#{$prefix}boxed-layout-width);\n        margin: 0 auto;\n        box-shadow: $box-shadow;\n        background-color: var(--#{$prefix}body-bg);\n    }\n\n    &[data-layout=\"vertical\"] {\n        #layout-wrapper {\n            min-height: 100vh;\n        }\n    }\n\n    #page-topbar,\n    .footer {\n        max-width: var(--#{$prefix}boxed-layout-width);\n        margin: 0 auto;\n        left: 0 !important;\n    }\n\n    &[data-sidebar-size=\"sm-hover\"],\n    &[data-sidebar-size=\"sm\"] {\n        &[data-layout=\"vertical\"] {\n            @media (min-width: 768px) {\n                #layout-wrapper {\n                    min-height: 1400px;\n                }\n            }\n\n            .main-content {\n                @media (max-width: 767.98px) {\n                    margin-left: 0;\n                }\n            }\n        }\n\n        #page-topbar,\n        .footer {\n            left: 0 !important;\n            max-width: calc(var(--#{$prefix}boxed-layout-width) - var(--#{$prefix}vertical-menu-width-sm));\n\n            @media (min-width: 768px) {\n                left: var(--#{$prefix}vertical-menu-width-sm) !important;\n            }\n        }\n    }\n\n    &[data-sidebar-size=\"sm-hover-active\"],\n    &[data-sidebar-size=\"lg\"] {\n\n        #page-topbar,\n        .footer {\n            max-width: calc(var(--#{$prefix}boxed-layout-width) - var(--#{$prefix}vertical-menu-width));\n\n            @media (min-width: 768px) {\n                left: var(--#{$prefix}vertical-menu-width) !important;\n            }\n        }\n    }\n\n    &[data-sidebar-size=\"md\"] {\n\n        #page-topbar,\n        .footer {\n            max-width: calc(var(--#{$prefix}boxed-layout-width) - var(--#{$prefix}vertical-menu-width-md));\n\n            @media (min-width: 768px) {\n                left: var(--#{$prefix}vertical-menu-width-md) !important;\n            }\n        }\n    }\n\n    // deteched\n\n    &[data-layout=vertical][data-layout-style=detached] {\n        body {\n            background-color: var(--#{$prefix}body-bg);\n        }\n\n        @media (min-width: 1024.1px) {\n            #layout-wrapper {\n                max-width: 1300px;\n                box-shadow: none;\n            }\n\n            .layout-width {\n                max-width: 1300px;\n            }\n        }\n\n        &[data-sidebar-size=\"sm-hover\"],\n        &[data-sidebar-size=\"sm\"],\n        &[data-sidebar-size=\"md\"],\n        &[data-sidebar-size=\"lg\"] {\n\n            #page-topbar,\n            .footer {\n                max-width: 100%;\n                left: 0 !important;\n            }\n        }\n    }\n}\n\n// Horizontal Boxed Layout\n\n[data-layout=\"horizontal\"][data-layout-width=\"boxed\"] {\n\n    #page-topbar,\n    #layout-wrapper,\n    .footer {\n        max-width: 100%;\n    }\n\n    .container-fluid,\n    .navbar-header {\n        max-width: var(--#{$prefix}boxed-layout-width);\n    }\n\n    .navbar-header {\n        padding: 0 calc(#{$grid-gutter-width} * 0.5) 0 0;\n    }\n\n    &[data-sidebar-size=\"sm-hover\"],\n    &[data-sidebar-size=\"sm\"] &[data-sidebar-size=\"sm-hover-active\"],\n    &[data-sidebar-size=\"lg\"] {\n\n        #page-topbar,\n        .footer {\n            left: 0 !important;\n        }\n    }\n}\n\n// Scrollable layout\n\n[data-layout-position=\"scrollable\"] {\n    @media (min-width: 992px) {\n\n        #page-topbar,\n        .navbar-menu {\n            position: absolute;\n        }\n    }\n\n    &[data-layout=\"horizontal\"] {\n        @media (min-width: 992px) {\n\n            #page-topbar,\n            .topnav {\n                position: absolute;\n            }\n        }\n    }\n}\n\n//Semibox Sidebar Action \n\n[data-layout=\"semibox\"][data-sidebar-visibility=\"hidden\"] {\n\n    @media (min-width: 768px) {\n        .navbar-menu {\n            display: none;\n        }\n\n        .horizontal-logo {\n            display: inline-block;\n            width: auto;\n        }\n\n        .footer {\n            left: 0;\n        }\n\n        #page-topbar {\n            left: 0;\n        }\n\n        .main-content {\n            margin-left: 0px;\n        }\n\n        &[data-sidebar-size=\"sm\"],\n        &[data-sidebar-size=\"sm-hover\"] {\n            .navbar-brand-box {\n                position: static;\n                padding: 0 1.3rem\n            }\n\n            .logo {\n                span.logo-lg {\n                    display: inline-block;\n                }\n\n                span.logo-sm {\n                    display: none;\n                }\n            }\n        }\n    }\n\n\n    &:is([data-sidebar=\"dark\"], [data-sidebar=\"gradient\"], [data-sidebar=\"gradient-2\"], [data-sidebar=\"gradient-3\"], [data-sidebar=\"gradient-4\"]) {\n        .logo-dark {\n            display: none;\n        }\n\n        .logo-light {\n            display: inline-block;\n        }\n    }\n\n    @media (min-width: 1440px) {\n        .navbar-menu {\n            display: none;\n        }\n\n        .horizontal-logo {\n            display: inline-block;\n            width: auto;\n        }\n\n        .footer {\n            left: calc(var(--#{$prefix}semibox-width) + #{$grid-gutter-width});\n        }\n\n        #page-topbar {\n            left: calc(var(--#{$prefix}semibox-width) + #{$grid-gutter-width});\n        }\n\n        .main-content {\n            margin-left: 0px;\n        }\n\n\n        &[data-sidebar-size=\"sm\"],\n        &[data-sidebar-size=\"sm-hover\"] {\n            .navbar-brand-box {\n                position: static;\n                padding: 0 1.3rem\n            }\n\n            .logo {\n                span.logo-lg {\n                    display: inline-block;\n                }\n\n                span.logo-sm {\n                    display: none;\n                }\n            }\n        }\n    }\n}","\n/*!\n * Waves v0.7.6\n * http://fian.my.id/Waves \n * \n * Copyright 2014-2018 Alfiana E. Sibuea and other contributors \n * Released under the MIT license \n * https://github.com/fians/Waves/blob/master/LICENSE */\n .waves-effect {\n    position: relative;\n    cursor: pointer;\n    display: inline-block;\n    overflow: hidden;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n  }\n  .waves-effect .waves-ripple {\n    position: absolute;\n    border-radius: 50%;\n    width: 100px;\n    height: 100px;\n    margin-top: -50px;\n    margin-left: -50px;\n    opacity: 0;\n    background: rgba(0, 0, 0, 0.2);\n    background: -webkit-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -o-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -moz-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    -webkit-transition: all 0.5s ease-out;\n    -moz-transition: all 0.5s ease-out;\n    -o-transition: all 0.5s ease-out;\n    transition: all 0.5s ease-out;\n    -webkit-transition-property: -webkit-transform, opacity;\n    -moz-transition-property: -moz-transform, opacity;\n    -o-transition-property: -o-transform, opacity;\n    transition-property: transform, opacity;\n    -webkit-transform: scale(0) translate(0, 0);\n    -moz-transform: scale(0) translate(0, 0);\n    -ms-transform: scale(0) translate(0, 0);\n    -o-transform: scale(0) translate(0, 0);\n    transform: scale(0) translate(0, 0);\n    pointer-events: none;\n  }\n  .waves-effect.waves-light .waves-ripple {\n    background: rgba(255, 255, 255, 0.4);\n    background: -webkit-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -o-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -moz-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n  }\n  .waves-effect.waves-classic .waves-ripple {\n    background: rgba(0, 0, 0, 0.2);\n  }\n  .waves-effect.waves-classic.waves-light .waves-ripple {\n    background: rgba(255, 255, 255, 0.4);\n  }\n  .waves-notransition {\n    -webkit-transition: none !important;\n    -moz-transition: none !important;\n    -o-transition: none !important;\n    transition: none !important;\n  }\n  .waves-button,\n  .waves-circle {\n    -webkit-transform: translateZ(0);\n    -moz-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    -o-transform: translateZ(0);\n    transform: translateZ(0);\n    -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);\n  }\n  .waves-button,\n  .waves-button:hover,\n  .waves-button:visited,\n  .waves-button-input {\n    white-space: nowrap;\n    vertical-align: middle;\n    cursor: pointer;\n    border: none;\n    outline: none;\n    color: inherit;\n    background-color: rgba(0, 0, 0, 0);\n    font-size: 1em;\n    line-height: 1em;\n    text-align: center;\n    text-decoration: none;\n    z-index: 1;\n  }\n  .waves-button {\n    padding: 0.85em 1.1em;\n    border-radius: 0.2em;\n  }\n  .waves-button-input {\n    margin: 0;\n    padding: 0.85em 1.1em;\n  }\n  .waves-input-wrapper {\n    border-radius: 0.2em;\n    vertical-align: bottom;\n  }\n  .waves-input-wrapper.waves-button {\n    padding: 0;\n  }\n  .waves-input-wrapper .waves-button-input {\n    position: relative;\n    top: 0;\n    left: 0;\n    z-index: 1;\n  }\n  .waves-circle {\n    text-align: center;\n    width: 2.5em;\n    height: 2.5em;\n    line-height: 2.5em;\n    border-radius: 50%;\n  }\n  .waves-float {\n    -webkit-mask-image: none;\n    -webkit-box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\n    box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\n    -webkit-transition: all 300ms;\n    -moz-transition: all 300ms;\n    -o-transition: all 300ms;\n    transition: all 300ms;\n  }\n  .waves-float:active {\n    -webkit-box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\n    box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\n  }\n  .waves-block {\n    display: block;\n  }\n\n.waves-effect.waves-light {\n    .waves-ripple {\n        background-color: rgba($white, 0.4);\n    }\n}\n\n.waves-effect.waves-primary {\n    .waves-ripple {\n        background-color: rgba($primary, 0.4);\n    }\n}\n.waves-effect.waves-success {\n    .waves-ripple {\n        background-color: rgba($success, 0.4);\n    }\n}\n.waves-effect.waves-info {\n    .waves-ripple {\n        background-color: rgba($info, 0.4);\n    }\n}\n.waves-effect.waves-warning {\n    .waves-ripple {\n        background-color: rgba($warning, 0.4);\n    }\n}\n.waves-effect.waves-danger {\n    .waves-ripple {\n        background-color: rgba($danger, 0.4);\n    }\n}","//\n// avatar.scss\n//\n\n.avatar-xxs {\n    height: 1.5rem;\n    width: 1.5rem;\n}\n\n.avatar-xs {\n    height: 2rem;\n    width: 2rem;\n}\n\n.avatar-sm {\n    height: 3rem;\n    width: 3rem;\n}\n\n.avatar-md {\n    height: 4.5rem;\n    width: 4.5rem;\n}\n\n.avatar-lg {\n    height: 6rem;\n    width: 6rem;\n}\n\n.avatar-xl {\n    height: 7.5rem;\n    width: 7.5rem;\n}\n\n.avatar-title {\n    align-items: center;\n    background-color: $primary;\n    color: $white;\n    display: flex;\n    font-weight: $font-weight-medium;\n    height: 100%;\n    justify-content: center;\n    width: 100%;\n}\n\n// avatar group\n.avatar-group {\n    padding-left: 12px;\n    display: flex;\n    flex-wrap: wrap;\n\n    .avatar-group-item {\n        margin-left: -12px;\n        border: 2px solid var(--#{$prefix}secondary-bg);\n        border-radius: 50%;\n        transition: all 0.2s;\n\n        &:hover {\n            position: relative;\n            transform: translateY(-2px);\n            z-index: 1;\n        }\n    }\n}","//\n// accordion.scss\n//\n\n.accordion {\n    .accordion-button {\n        font-weight: $font-weight-medium;\n    }\n\n    .accordion-body {\n        color: var(--#{$prefix}secondary-color);\n    }\n\n    &.accordion-icon-none {\n        .accordion-button {\n            &::after {\n                content: \"\";\n                background-image: none !important;\n            }\n\n            &:not(.collapsed) {\n                &::after {\n                    content: \"\";\n                }\n            }\n        }\n    }\n}\n\n// Accordion with icon\n\n.custom-accordionwithicon {\n    .accordion-button {\n        &::after {\n            background-image: none !important;\n            font-family: \"Material Design Icons\";\n            content: \"\\F0142\";\n            font-size: 1.1rem;\n            vertical-align: middle;\n            line-height: 0.8;\n        }\n\n        &:not(.collapsed) {\n            &::after {\n                background-image: none !important;\n                content: \"\\F0140\";\n                margin-right: -3px;\n            }\n        }\n    }\n}\n\n// Accordion with plus icon\n\n.custom-accordionwithicon-plus {\n    .accordion-button {\n        &::after {\n            background-image: none !important;\n            font-family: \"Material Design Icons\";\n            content: \"\\F0415\";\n            font-size: 1.1rem;\n            vertical-align: middle;\n            line-height: 0.8;\n        }\n\n        &:not(.collapsed) {\n            &::after {\n                background-image: none !important;\n                content: \"\\F0374\";\n                margin-right: -3px;\n            }\n        }\n    }\n}\n\n\n// left Icon accordion\n\n.lefticon-accordion {\n    .accordion-button {\n        padding-left: 2.75rem;\n\n        &::after {\n            position: absolute;\n            left: $accordion-button-padding-x;\n            top: 14px;\n        }\n\n        &:not(.collapsed) {\n            &::after {\n                top: 20px;\n            }\n        }\n    }\n}\n\n// border accordion\n\n.accordion-border-box {\n    .accordion-item {\n        border-top: $accordion-border-width solid $accordion-border-color;\n        border-radius: $accordion-border-radius;\n\n        &:not(:first-of-type) {\n            margin-top: 8px;\n        }\n\n        .accordion-button {\n            border-radius: $accordion-border-radius;\n\n            &:not(.collapsed) {\n                border-bottom-left-radius: 0;\n                border-bottom-right-radius: 0;\n            }\n        }\n    }\n}\n\n.custom-accordion-border {\n    .accordion-item {\n        border-left: 3px solid $accordion-border-color;\n    }\n}\n\n//accordion Color \n\n@each $color,\n$value in $theme-colors {\n    .accordion-#{$color} {\n        .accordion-item {\n            border-color: rgba($value, 0.6);\n\n            .accordion-button {\n                box-shadow: none;\n\n                &:not(.collapsed) {\n                    color: $value;\n                    background-color: rgba($value, 0.1) !important;\n                }\n\n                &::after {\n                    color: $value;\n                }\n            }\n        }\n    }\n\n    .accordion-fill-#{$color} {\n        .accordion-item {\n            .accordion-button {\n                box-shadow: none;\n\n                &:not(.collapsed) {\n                    color: $white;\n                    background-color: $value !important;\n                }\n            }\n        }\n    }\n}\n\n// rtl\n[dir=\"rtl\"]{\n    .custom-accordionwithicon {\n        .accordion-button::after{\n            transform: rotate(180deg);\n        }\n    }\n}","//\n// _helper.scss\n//\n\n// Border Style\n$border-style-mixing: double, dashed, groove, outset, ridge, dotted, inset;\n@each $border-style-mixing in $border-style-mixing {\n    .border-#{$border-style-mixing} {\n        border-style: #{$border-style-mixing} !important;\n    }\n    .border-top-#{$border-style-mixing} {\n        border-top-style: #{$border-style-mixing} !important;\n    }\n    .border-bottom-#{$border-style-mixing} {\n        border-bottom-style: #{$border-style-mixing} !important;\n    }\n    .border-end-#{$border-style-mixing} {\n        border-right-style: #{$border-style-mixing} !important;\n    }\n    .border-start-#{$border-style-mixing} {\n        border-left-style: #{$border-style-mixing} !important;\n    }\n    \n    // List Group Flush Style\n    .list-group-flush {\n        &.border-#{$border-style-mixing} { \n            border: none !important;\n            .list-group-item {\n                border-style: #{$border-style-mixing} !important;\n            }\n        }\n    }\n}\n\n// Font Family\n\n.ff-base {\n    font-family: $font-family-base;\n}\n\n.ff-secondary {\n    font-family: $font-family-secondary;\n}\n\n// Background pattern\n.bg-pattern {\n    background: url(\"../../images/modal-bg.png\") $modal-content-bg;\n}\n\n// Fixed minimum width\n.w-xs {\n    min-width: 80px;\n}\n\n.w-sm {\n    min-width: 95px;\n}\n\n.w-md {\n    min-width: 110px;\n}\n\n.w-lg {\n    min-width: 140px;\n}\n\n.w-xl {\n    min-width: 160px;\n}\n\n// Icons Sizes\n.icon-xs {\n    height: 16px;\n    width: 16px;\n}\n\n.icon-sm {\n    height: 18px;\n    width: 18px;\n}\n\n.icon-md {\n    height: 22px;\n    width: 22px;\n}\n\n.icon-lg {\n    height: 24px;\n    width: 24px;\n}\n\n.icon-xl {\n    height: 28px;\n    width: 28px;\n}\n\n.icon-xxl {\n    height: 32px;\n    width: 32px;\n}\n\n// Dual Icons\n.icon-dual {\n    color: $gray-500;\n    fill: rgba($gray-500,0.16);\n}\n\n@each $color,\n$value in $theme-colors {\n    .icon-dual-#{$color} {\n        color: $value;\n        fill: rgba($value, 0.16);\n    }\n}\n\n// Search \n.search-box{\n    position: relative;\n    .form-control{\n        padding-left: 40px;\n    }\n    .search-icon{\n        font-size: 14px;\n        position: absolute;\n        left: 13px;\n        top: 0;\n        height: 100%;\n        display: flex;\n        align-items: center;\n        color: var(--#{$prefix}secondary-color);\n    }\n}\n\n\n// overlay\n\n.bg-overlay {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    top: 0;\n    opacity: 0.7;\n    background-color: $black;\n}\n\n// Btn Customizer\n\n.customizer-setting {\n    position: fixed;\n    bottom: 40px;\n    right: 20px;\n    z-index: 1000;\n}\n\n// \ncode {\n    user-select: all;\n}\n\n.layout-rightside {\n    width: 280px;\n    margin-right: calc(#{$grid-gutter-width} * -1);\n    margin-top: calc(1px - #{$grid-gutter-width} * 1.1);\n    height: calc(100% + #{$grid-gutter-width} * 1.1);\n}\n\n.layout-rightside-col {\n\n    @media (max-width: 1699.98px) { \n        display: none;\n        position: fixed !important;\n        height: 100vh;\n        right: 0px;\n        top: 0px;\n        bottom: 0px;\n        z-index: 1004;\n        .overlay{\n            position: fixed;\n            top: 0;\n            right: 0px;\n            bottom: 0px;\n            left: 0px;\n            background-color: rgba($dark, 0.2);\n           \n        }\n        .layout-rightside {\n            margin-top: 0px;\n            height: 100%;\n            margin-left: auto;\n        }\n        .card-body {\n            overflow-y: auto;\n            padding-bottom: 1rem !important;\n        }\n    }\n}\n\n:is([data-layout=\"horizontal\"], [data-layout-style=detached]) {\n    @media (min-width: 1700px) {\n        .layout-rightside{\n            margin-top: calc(28px - #{$grid-gutter-width});\n            margin-right: 0;\n            height: calc(100% - calc(#{$grid-gutter-width} * 0.5));\n        }\n    }\n}\n\n[data-layout=\"semibox\"] {\n    .layout-rightside {\n        margin-right: 0px;\n    }\n}\n\n// text-truncate-two-lines\n.text-truncate-two-lines{\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 2;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    white-space: normal;\n}\n\n// Favorite button \n.favourite-btn{\n    border-color: transparent;\n    .ri-star-fill{\n        color: var(--#{$prefix}secondary-color);\n    }\n    &.active{\n        border-color: transparent;\n        .ri-star-fill{\n            color: $warning;\n            \n            &:before{\n                content: \"\\f186\";\n            }\n        }\n    }\n}\n// card\n.card-logo-light{\n    display: var(--#{$prefix}card-logo-light);\n}\n\n.card-logo-dark{\n    display: var(--#{$prefix}card-logo-dark);\n}\n\n#back-to-top {\n    position: fixed;\n    bottom: 100px;\n    right: 28px;\n    transition: all 0.5s ease;\n    display: none;\n    z-index: 1000;\n    &:hover {\n        animation: fade-up 1.5s infinite linear;\n    }\n}\n\n@keyframes fade-up {\n  0% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n\n  75% {\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n}","// \n// preloader.scss\n//\n\n#preloader {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: var(--#{$prefix}secondary-bg);\n    z-index: 9999;\n}\n\n[data-preloader=\"disable\"] #preloader {\n    opacity: 0;\n    visibility: hidden;\n}\n\n#status {\n    width: 40px;\n    height: 40px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    margin: -20px 0 0 -20px;\n}","//\n// forms.scss\n//\n\n:is([type=\"tel\"], [type=\"url\"], [type=\"email\"], [type=\"number\"]){\n    &::placeholder {\n        text-align: left /*rtl: right*/;\n    }\n}\n","// \n// Widgets.scss\n// \n\n.main-chart {\n    .chart-border-left {\n        border-left: 1.4px solid var(--#{$prefix}border-color);\n        padding: 2px 20px;\n\n        &:last-child {\n            margin-right: 0px;\n        }\n    }\n}\n\n\n\n/* Activity */\n\n.activity-feed {\n    list-style: none;\n\n    .feed-item {\n        position: relative;\n        padding-bottom: 27px;\n        padding-left: 16px;\n        border-left: 2px solid var(--#{$prefix}border-color);\n\n        &:after {\n            content: \"\";\n            display: block;\n            position: absolute;\n            top: 4px;\n            left: -6px;\n            width: 10px;\n            height: 10px;\n            border-radius: 50%;\n            border: 2px solid $primary;\n            background-color: var(--#{$prefix}secondary-bg);\n        }\n\n        &:last-child {\n            border-color: transparent;\n        }\n    }\n}\n\n// mini-stats-wid\n.mini-stats-wid {\n    position: relative;\n\n    .mini-stat-icon {\n        overflow: hidden;\n        position: relative;\n\n        &:before,\n        &:after {\n            content: \"\";\n            position: absolute;\n            width: 8px;\n            height: 69px;\n            background-color: rgba($success, .1);\n            left: 3px;\n            transform: rotate(32deg);\n            top: -8px;\n            transition: all 0.4s;\n        }\n\n        &::after {\n            left: 27px;\n            width: 8px;\n            transition: all 0.2s;\n        }\n    }\n\n    &:hover {\n        .mini-stat-icon {\n            &::after {\n                left: 60px;\n            }\n\n            &::before {\n                left: 50px;\n            }\n        }\n    }\n}\n\n\n// credit card widget\n.card-wrapper{\n    .jp-card{\n        .jp-card-back, .jp-card-front{\n            background-color: $success;\n        }\n    }\n}\n\n.notification-elem{\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: var(--#{$prefix}secondary-bg);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    visibility: hidden;\n    opacity: 0;\n}\n\n//ecommerce widgets\n.clothes-size {\n    li {\n        input[type=\"radio\"] {\n            display: none;\n        }\n\n        label {\n            display: inline-block;\n            font-size: 14px;\n            border-radius: 5px;\n            border: 1px solid var(--#{$prefix}border-color);\n            text-transform: none;\n            letter-spacing: 0;\n            color: $primary;\n        }\n\n        input[type=\"radio\"]:checked+label {\n            background-color: $primary;\n            border-color: $primary;\n            color: $white;\n        }\n    }\n}","// \n// _demos.scss\n// \n\n// Modals\n.bs-example-modal {\n    position: relative;\n    top: auto;\n    right: auto;\n    bottom: auto;\n    left: auto;\n    z-index: 1;\n    display: block;\n}\n\n[dir=\"rtl\"] {\n    .modal-open {\n        padding-left: 0px !important;\n    }\n}\n\n// Icon demo ( Demo only )\n.icon-demo-content {\n    color: var(--#{$prefix}gray-500);\n\n    i {\n        font-size: 24px;\n        margin-right: 10px;\n        color: var(--#{$prefix}gray-600);\n        transition: all 0.4s;\n        vertical-align: middle;\n    }\n\n    svg {\n        margin-right: 10px;\n        transition: all 0.4s;\n        height: 20px;\n    }\n\n    .col-lg-4 {\n        margin-top: 24px;\n\n        &:hover {\n            i, svg {\n                color: $primary;\n                transform: scale(1.5);\n            }\n        }\n    }\n}\n\n// customizer switch\n.img-switch{\n    .card-radio{\n        .form-check-input {\n            display: none;\n    \n            &:checked+.form-check-label {\n                &::before{\n                    content: \"\";\n                    position: absolute;\n                    top: 0;\n                    right: 0;\n                    bottom: 0;\n                    left: 0;\n                    background-color: rgba($primary, 0.5);\n                }\n                &::after{\n                    content: '\\eb80';\n                    font-family: \"remixicon\";\n                    position: absolute;\n                    top: 50%;\n                    left: 50%;\n                    transform: translateY(-50%) translateX(-50%);\n                    font-size: 18px;\n                    color: $white;\n                }\n            }\n        }\n    }\n}\n\n[data-bs-target=\"#collapseBgGradient\"]{\n    &.active{\n        border-color: $primary !important;\n        &::before{\n            content: \"\\eb80\";\n            font-family: remixicon;\n            position: absolute;\n            top: 2px;\n            right: 6px;\n            font-size: 16px;\n            color: $primary;\n        }\n    }\n}","// \n// print.scss\n//\n\n// Used invoice page\n@media print {\n    .vertical-menu,\n    .right-bar,\n    .page-title-box,\n    .navbar-header,\n    .app-menu,\n    .footer,\n    #back-to-top {\n        display: none !important;\n    }\n    .card-body,\n    .main-content,\n    .right-bar,\n    .page-content,\n    body {\n        padding: 0;\n        margin: 0;\n    }\n\n    .card{\n        border: 0;\n        box-shadow: none !important;\n    }\n\n    .invoice-details{\n        .d-sm-flex{\n            display: flex !important;\n        }\n    }\n    .address{\n        &.col-sm-6 {\n            flex: 0 0 auto !important;\n            width: 50% !important;\n            max-width: 100% !important;\n        }\n    }\n}","// \n// ribbons.scss\n//\n\n.ribbon-box {\n    position: relative;\n\n    .ribbon {\n        padding: 5px 12px;\n        box-shadow: 2px 5px 10px rgba($dark, 0.15);\n        color: $white;\n        font-size: $font-size-base;\n        font-weight: $font-weight-semibold;\n        position: absolute;\n        left: -1px;\n        top: 5px;\n\n        &.round-shape {\n            border-radius: 0 30px 30px 0;\n        }\n\n        &.ribbon-shape {\n            display: inline-block;\n\n            &::before {\n                content: \"\";\n                position: absolute;\n                right: -17px;\n                top: 0;\n                border: 14px solid transparent;\n            }\n\n            &::after {\n                content: \"\";\n                position: absolute;\n                right: -17px;\n                bottom: 0;\n                border: 14px solid transparent;\n            }\n        }\n\n    }\n\n    // ribbon circle\n    &.ribbon-circle {\n        .ribbon {\n            width: 48px;\n            height: 48px;\n            border-radius: 50%;\n            padding: 0;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            left: 20px;\n            top: 20px;\n        }\n    }\n\n    // ribbon fill\n\n    &.ribbon-fill {\n        overflow: hidden;\n            \n        .ribbon {\n            transform: rotate(-45deg);\n            width: 93px;\n            height: 52px;\n            left: -36px;\n            top: -16px;\n            display: flex;\n            justify-content: center;\n            align-items: flex-end;\n        }\n        &.ribbon-sm {\n            .ribbon {\n                padding: 2px 12px;\n                width: 78px;\n                height: 42px;\n                font-size: 12px;\n                box-shadow: none;\n            }\n        }\n    }\n\n    // right\n    &.right {\n        .ribbon {\n            position: absolute;\n            left: auto;\n            right: 0;\n\n            &.round-shape {\n                border-radius: 30px 0 0 30px;\n            }\n\n            &.ribbon-shape {\n                text-align: right;\n\n                &::before,\n                &::after {\n                    right: auto;\n                    left: -17px;\n                    border-left-color: transparent;\n                }\n            }\n        }\n\n        &.ribbon-circle {\n            .ribbon {\n                left: auto;\n                right: 20px;\n            }\n        }\n\n        .icon-ribbon {\n            right: 24px;\n            left: auto;\n        }\n\n        &.ribbon-fill {\n            .ribbon {\n                transform: rotate(45deg);\n                right: -38px;\n                left: auto;\n            }\n        }\n\n        &.ribbon-box {\n            .ribbon-two {\n                left: auto;\n                right: -5px;\n\n                span {\n                    left: auto;\n                    right: -21px;\n                    transform: rotate(45deg);\n                }\n            }\n        }\n\n    }\n\n    .ribbon-content {\n        clear: both;\n    }\n\n    @each $color,\n    $value in $theme-colors {\n        .ribbon-#{$color} {\n            background: ($value);\n\n            &:before {\n                border-color: darken(($value), 10%) transparent transparent;\n            }\n\n            &.ribbon-shape {\n                &::before {\n                    border-left-color: ($value);\n                    border-top-color: ($value);\n                }\n\n                &::after {\n                    border-left-color: ($value);\n                    border-bottom-color: ($value);\n                }\n            }\n        }\n\n        &.right {\n            .ribbon-#{$color} {\n                background: ($value);\n\n                &.ribbon-shape {\n                    &::before {\n                        border-right-color: ($value);\n                        border-top-color: ($value);\n                    }\n\n                    &::after {\n                        border-right-color: ($value);\n                        border-bottom-color: ($value);\n                    }\n                }\n            }\n        }\n    }\n\n\n    // Icon ribbon\n\n    .icon-ribbon {\n        box-shadow: none;\n        left: 24px;\n        top: -12px;\n        font-size: 40px;\n        padding: 0;\n    }\n\n\n    /* Ribbon two */\n    .ribbon-two {\n        position: absolute;\n        left: -5px;\n        top: -5px;\n        z-index: 1;\n        overflow: hidden;\n        width: 75px;\n        height: 75px;\n        text-align: right;\n\n        span {\n            font-size: 13px;\n            color: $white;\n            text-align: center;\n            line-height: 20px;\n            transform: rotate(-45deg);\n            width: 100px;\n            display: block;\n            box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);\n            position: absolute;\n            top: 19px;\n            left: -21px;\n            font-weight: $font-weight-semibold;\n\n            &:before {\n                content: \"\";\n                position: absolute;\n                left: 0;\n                top: 100%;\n                z-index: -1;\n                border-right: 3px solid transparent;\n                border-bottom: 3px solid transparent;\n            }\n\n            &:after {\n                content: \"\";\n                position: absolute;\n                right: 0;\n                top: 100%;\n                z-index: -1;\n                border-left: 3px solid transparent;\n                border-bottom: 3px solid transparent;\n            }\n        }\n    }\n\n    @each $color,\n    $value in $theme-colors {\n        .ribbon-two-#{$color} {\n\n            span {\n                background: ($value);\n\n                &:before {\n                    border-left: 3px solid darken(($value), 15%);\n                    border-top: 3px solid darken(($value), 15%);\n                }\n\n                &:after {\n                    border-right: 3px solid darken(($value), 15%);\n                    border-top: 3px solid darken(($value), 15%);\n                }\n            }\n        }\n    }\n\n}\n\n\n.ribbon-box {\n    &.right {\n        .ribbon-three {\n            position: absolute;\n            top: -6.1px;\n            right: 10px;\n            left: auto;\n        }\n    }\n}\n\n.ribbon-three {\n    position: absolute;\n    top: -6.1px;\n    left: 10px;\n\n    span {\n        position: relative;\n        display: block;\n        text-align: center;\n        color: $white;\n        font-size: 14px;\n        line-height: 1;\n        padding: 12px 8px 10px;\n        border-top-right-radius: 8px;\n        width: 90px;\n\n        &::after,\n        &::before {\n            position: absolute;\n            content: \"\";\n        }\n\n        &::before {\n            height: 6px;\n            width: 6px;\n            left: -6px;\n            top: 0;\n        }\n\n        &::after {\n            height: 6px;\n            width: 8px;\n            left: -8px;\n            top: 0;\n            border-radius: 8px 8px 0 0;\n        }\n    }\n\n    &::after {\n        position: absolute;\n        content: \"\";\n        width: 0;\n        height: 0;\n        border-left: 44px solid transparent;\n        border-right: 44px solid transparent;\n        border-top: 10px solid;\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .ribbon-three-#{$color} {\n\n        span {\n            background: ($value);\n\n            &:before {\n                background: ($value);\n            }\n\n            &:after {\n                background: darken($value, 10%);\n            }\n        }\n\n        &::after {\n            border-top-color: ($value);\n        }\n    }\n}\n\n//Ribbon Hover\n.ribbon-box {\n    .trending-ribbon {\n        transform: translateX(-50px);\n        transition: all 0.5s ease;\n\n        .trending-ribbon-text {\n            transition: all 0.5s ease;\n            opacity: 0;\n        }\n    }\n\n    &:hover {\n        .trending-ribbon {\n            transform: translateX(0);\n\n            .trending-ribbon-text {\n                opacity: 1;\n            }\n        }\n    }\n    &.right {\n        .trending-ribbon {\n            transform: translateX(50px);\n            transition: all 0.5s ease;\n    \n            .trending-ribbon-text {\n                transition: all 0.5s ease;\n                opacity: 0;\n            }\n        }\n    \n        &:hover {\n            .trending-ribbon {\n                transform: translateX(0);\n    \n                .trending-ribbon-text {\n                    opacity: 1;\n                }\n            }\n        }\n    }\n}","//\n// toast.scss\n//\n\n\n// toast\n.toast { \n    &:not(:last-child) {\n      margin-bottom: $toast-padding-x;\n    }\n}\n\n@mixin toast-border-variant($bg) {\n    .toast-body{\n        color: $bg;\n        border-bottom: 3px solid $bg;\n    }\n}\n\n@each $color, $value in $theme-colors {\n    .toast-border-#{$color} {\n        @include toast-border-variant($value);\n    }\n}","//\n// scrollspy.scss\n//\n\n// Scrollspy\n.scrollspy-example {\n  position: relative;\n  height: 200px;\n  margin-top: .5rem;\n  overflow: auto;\n}\n\n.scrollspy-example-2 {\n  position: relative;\n  height: 370px;\n  overflow: auto;\n}",":root {\n\n    // card\n    --#{$prefix}card-logo-dark:                                     block;\n    --#{$prefix}card-logo-light:                                    none;\n\n    //vertical menu\n    --#{$prefix}vertical-menu-width:                                #{$vertical-menu-width};\n    --#{$prefix}vertical-menu-width-md:                             #{$vertical-menu-width-md};\n    --#{$prefix}vertical-menu-width-sm:                             #{$vertical-menu-width-sm};\n\n    // Topbar - (Default Light)\n    --#{$prefix}header-bg:                                          #{$header-bg};\n    --#{$prefix}header-border:                                      #{$header-border};\n    --#{$prefix}header-item-color:                                  #{$header-item-color};\n    --#{$prefix}header-item-bg:                                     #{$header-item-bg};\n    --#{$prefix}header-item-sub-color:                              #{$header-item-sub-color};\n    --#{$prefix}topbar-search-bg:                                   #{$topbar-search-bg};\n    --#{$prefix}topbar-search-color:                                #{$topbar-search-color};\n    --#{$prefix}topbar-user-bg:                                     #{$topbar-user-bg};\n    \n    //page title \n    --#{$prefix}page-title-box-shadow:                              #{$page-title-box-shadow};\n    --#{$prefix}page-title-border:                                  #{$page-title-border};\n    \n    // Topbar - Dark\n    &[data-topbar=\"dark\"] {\n        --#{$prefix}header-bg:                                      #{$dark-header-bg};\n        --#{$prefix}header-item-color:                              #{$dark-header-item-color};\n        --#{$prefix}header-item-bg:                                 #{$dark-header-item-bg};\n        --#{$prefix}header-item-sub-color:                          #{$dark-header-item-sub-color};\n        --#{$prefix}topbar-user-bg:                                 #{$dark-topbar-user-bg};\n        --#{$prefix}topbar-search-bg:                               #{$dark-topbar-search-bg};\n        --#{$prefix}topbar-search-color:                            #{$dark-topbar-search-color};\n        --#{$prefix}header-border:                                  #{$dark-header-border};\n    }\n    \n    // Horizontal nav\n    --#{$prefix}topnav-bg:                                          #{$twocolumn-menu-iconview-bg};\n    --#{$prefix}topnav-item-color:                                  #{$topnav-item-color};\n    --#{$prefix}topnav-item-active-color:                           #{$topnav-item-active-color};\n    \n    // twocolumn menu\n    --#{$prefix}twocolumn-menu-iconview-bg:                         #{$twocolumn-menu-iconview-bg};\n    --#{$prefix}twocolumn-menu-box-shadow:                          #{$twocolumn-menu-box-shadow};\n    \n    // boxed \n    --#{$prefix}boxed-layout-width:                                 #{$boxed-layout-width};\n    --#{$prefix}boxed-body-bg:                                      #{$boxed-body-bg};\n    \n    //semibox layout\n    --#{$prefix}semibox-width:                                      #{$semibox-width};\n    \n    //footer\n    --#{$prefix}footer-bg:                                          #{$footer-bg};\n    --#{$prefix}footer-color:                                       #{$footer-color};\n\n    //form\n        --#{$prefix}input-bg-custom:                                #{$input-bg-custom};\n        --#{$prefix}input-border-custom:                            #{$input-border-custom};\n}\n\n//sidebar light theme\n@if $sidebar-mode {\n    :root {\n        --#{$prefix}vertical-menu-bg:                                   #{$vertical-menu-bg};\n        --#{$prefix}vertical-menu-border:                               #{$vertical-menu-border};\n        --#{$prefix}vertical-menu-item-color:                           #{$vertical-menu-item-color};\n        --#{$prefix}vertical-menu-item-bg:                              #{$vertical-menu-item-bg};\n        --#{$prefix}vertical-menu-item-hover-color:                     #{$vertical-menu-item-hover-color};\n        --#{$prefix}vertical-menu-item-active-color:                    #{$vertical-menu-item-active-color};\n        --#{$prefix}vertical-menu-item-active-bg:                       #{$vertical-menu-item-active-bg};\n        --#{$prefix}vertical-menu-sub-item-color:                       #{$vertical-menu-sub-item-color};\n        --#{$prefix}vertical-menu-sub-item-hover-color:                 #{$vertical-menu-sub-item-hover-color};\n        --#{$prefix}vertical-menu-sub-item-active-color:                #{$vertical-menu-sub-item-active-color};\n        --#{$prefix}vertical-menu-title-color:                          #{$vertical-menu-title-color};\n        --#{$prefix}vertical-menu-box-shadow:                           #{$vertical-menu-box-shadow};\n        --#{$prefix}vertical-menu-dropdown-box-shadow:                  #{$vertical-menu-dropdown-box-shadow};\n        \n        &[data-sidebar=\"dark\"] {\n            //vertical dark\n            --#{$prefix}vertical-menu-bg:                               #{$dark-vertical-menu-bg};\n            --#{$prefix}vertical-menu-border:                           #{$dark-vertical-menu-border};\n            --#{$prefix}vertical-menu-item-color:                       #{$dark-vertical-menu-item-color};\n            --#{$prefix}vertical-menu-item-bg:                          #{$dark-vertical-menu-item-bg};\n            --#{$prefix}vertical-menu-item-hover-color:                 #{$dark-vertical-menu-item-hover-color};\n            --#{$prefix}vertical-menu-item-active-color:                #{$dark-vertical-menu-item-active-color};\n            --#{$prefix}vertical-menu-item-active-bg:                   #{$dark-vertical-menu-item-active-bg};\n            --#{$prefix}vertical-menu-sub-item-color:                   #{$dark-vertical-menu-sub-item-color};\n            --#{$prefix}vertical-menu-sub-item-hover-color:             #{$dark-vertical-menu-sub-item-hover-color};\n            --#{$prefix}vertical-menu-sub-item-active-color:            #{$dark-vertical-menu-sub-item-active-color};\n            --#{$prefix}vertical-menu-title-color:                      #{$dark-vertical-menu-title-color};\n            --#{$prefix}twocolumn-menu-iconview-bg:                     #{$dark-twocolumn-menu-iconview-bg};\n            --#{$prefix}vertical-menu-box-shadow:                       #{$dark-vertical-menu-box-shadow};\n            --#{$prefix}vertical-menu-dropdown-box-shadow:              #{$dark-vertical-menu-dropdown-box-shadow};\n        }\n    }\n}\n\n//sidebar gradient light theme\n@if $sidebar-gradient-mode {\n    :root { \n        &:is([data-sidebar=\"gradient\"], [data-sidebar=\"gradient-2\"], [data-sidebar=\"gradient-3\"], [data-sidebar=\"gradient-4\"]) {\n            --#{$prefix}vertical-menu-item-color:                       #{$vertical-menu-item-color-gradient};\n            --#{$prefix}vertical-menu-item-bg:                          #{$vertical-menu-item-bg-gradient};\n            --#{$prefix}vertical-menu-item-hover-color:                 #{$vertical-menu-item-hover-color-gradient};\n            --#{$prefix}vertical-menu-item-active-color:                #{$vertical-menu-item-active-color-gradient};\n            --#{$prefix}vertical-menu-item-active-bg:                   #{$vertical-menu-item-active-bg-gradient};\n            --#{$prefix}vertical-menu-sub-item-color:                   #{$vertical-menu-sub-item-color-gradient};\n            --#{$prefix}vertical-menu-sub-item-hover-color:             #{$vertical-menu-sub-item-hover-color-gradient};\n            --#{$prefix}vertical-menu-sub-item-active-color:            #{$vertical-menu-sub-item-active-color-gradient};\n            --#{$prefix}vertical-menu-title-color:                      #{$vertical-menu-title-color-gradient};\n            --#{$prefix}vertical-menu-box-shadow:                       #{$vertical-menu-box-shadow-gradient};\n            --#{$prefix}vertical-menu-dropdown-box-shadow:              #{$vertical-menu-dropdown-box-shadow-gradient};\n            \n        }\n        \n        &[data-sidebar=\"gradient\"] {\n            --#{$prefix}vertical-menu-bg:                               #{$vertical-menu-bg-gradient};\n            --#{$prefix}vertical-menu-border:                           #{$vertical-menu-border-gradient};\n            --#{$prefix}twocolumn-menu-iconview-bg:                     #{$twocolumn-menu-iconview-bg-gradient};\n        }\n        \n        &[data-sidebar=\"gradient-2\"] {\n            --#{$prefix}vertical-menu-bg:                               #{$vertical-menu-bg-gradient-2};\n            --#{$prefix}vertical-menu-border:                           #{$vertical-menu-border-gradient-2};\n            --#{$prefix}twocolumn-menu-iconview-bg:                     #{$twocolumn-menu-iconview-bg-gradient-2};\n        }\n        \n        &[data-sidebar=\"gradient-3\"] {\n            --#{$prefix}vertical-menu-bg:                               #{$vertical-menu-bg-gradient-3};\n            --#{$prefix}vertical-menu-border:                           #{$vertical-menu-border-gradient-3};\n            --#{$prefix}twocolumn-menu-iconview-bg:                     #{$twocolumn-menu-iconview-bg-gradient-3};\n            \n        }\n        \n        &[data-sidebar=\"gradient-4\"] {\n            --#{$prefix}vertical-menu-bg:                               #{$vertical-menu-bg-gradient-4};\n            --#{$prefix}vertical-menu-border:                           #{$vertical-menu-border-gradient-4};\n            --#{$prefix}twocolumn-menu-iconview-bg:                     #{$twocolumn-menu-iconview-bg-gradient-4};\n        }\n    }    \n}\n\n//theme dark\n@if $enable-dark-mode {\n    @include color-mode(dark, true) {\n        --#{$prefix}light:                                          #{$light-dark};\n        --#{$prefix}light-rgb:                                      #{to-rgb($light-dark)};\n        --#{$prefix}light-text-emphasis:                            #{$light-text-emphasis-dark};\n        --#{$prefix}light-bg-subtle:                                #{$light-bg-subtle-dark};\n        --#{$prefix}light-border-subtle:                            #{$light-border-subtle-dark};\n        \n        --#{$prefix}dark:                                           #{$dark-color};\n        --#{$prefix}dark-rgb:                                       #{to-rgb($dark-color)};\n        --#{$prefix}dark-text-emphasis:                             #{$dark-text-emphasis-dark};\n        --#{$prefix}dark-bg-subtle:                                 #{$dark-bg-subtle-dark};\n        --#{$prefix}dark-border-subtle:                             #{$dark-border-subtle-dark};\n        \n        // card\n        --#{$prefix}card-logo-dark:                                 none;\n        --#{$prefix}card-logo-light:                                block;\n        \n        //footer\n        --#{$prefix}footer-bg:                                      #{$footer-bg-dark};\n        --#{$prefix}footer-color:                                   #{$footer-color-dark};\n        \n        // Horizontal nav\n        --#{$prefix}topnav-bg:                                      #{$topnav-bg-dark};\n        --#{$prefix}topnav-item-color:                              #{$topnav-item-color-dark};\n        --#{$prefix}topnav-item-active-color:                       #{$topnav-item-active-color-dark};\n        //page title \n        --#{$prefix}page-title-box-shadow:                          #{$page-title-box-shadow-dark};\n        --#{$prefix}page-title-border:                              #{$page-title-border-dark};\n        \n        //two columns\n        --#{$prefix}twocolumn-menu-box-shadow:                      #{$twocolumn-menu-box-shadow-dark};\n        \n        // boxed \n        --#{$prefix}boxed-body-bg:                                  #{$boxed-body-bg-dark};\n        \n        .table-light {\n            --#{$prefix}table-color:                                #{lighten($light-dark, 100%)};\n            --#{$prefix}table-bg:                                   var(--#{$prefix}light);\n            --#{$prefix}table-border-color:                         var(--#{$prefix}border-color);\n            --#{$prefix}table-striped-bg:                           var(--#{$prefix}light);\n            --#{$prefix}table-striped-color:                        #{lighten($light-dark, 100%)};\n            --#{$prefix}table-active-bg:                            var(--#{$prefix}light);\n            --#{$prefix}table-active-color:                         #{lighten($light-dark, 100%)};\n            --#{$prefix}table-hover-bg:                             var(--#{$prefix}light);\n            --#{$prefix}table-hover-color:                          #{lighten($light-dark, 100%)};\n        }\n        \n        .btn-light,\n        .btn-outline-light {\n            --#{$prefix}btn-color:                                  #{tint-color($body-bg-dark, 50%)};\n            --#{$prefix}btn-active-color:                           #{$white};\n            --#{$prefix}btn-hover-color:                            #{$white};\n        }\n        \n        .btn-outline-dark,\n        .btn-soft-dark, .btn-ghost-dark {\n            --#{$prefix}btn-color:                                  #{$white};\n        }\n        \n        .btn-ghost-dark { \n            --#{$prefix}btn-active-color:                           #{$white};\n            --#{$prefix}btn-hover-color:                            #{$white};\n        }\n        \n        .dropdown-menu {\n            --#{$prefix}dropdown-bg:                                #{$dropdown-bg-dark};\n            --#{$prefix}dropdown-link-color:                        #{$dropdown-link-color-dark};\n            --#{$prefix}dropdown-link-hover-color:                  #{$dropdown-link-hover-color-dark};\n            --#{$prefix}dropdown-link-hover-bg:                     #{$dropdown-link-hover-bg-dark};\n            --#{$prefix}dropdown-border-width:                      #{$dropdown-border-width-dark};\n            --#{$prefix}dropdown-link-active-color:                 #{$dropdown-link-active-color-dark};\n            --#{$prefix}dropdown-link-active-bg:                    #{$dropdown-link-active-bg-dark};\n        }\n\n        //form\n        --#{$prefix}input-bg-custom:                                #{$input-bg-custom-dark};\n        --#{$prefix}input-border-custom:                            #{$input-border-custom-dark};\n    }\n}\n\n//topbar dark mode\n@if $topbar-dark-mode {\n    @include color-mode(dark, true) {\n        // Topbar\n        --#{$prefix}header-bg:                                      #{$header-bg-dark};\n        --#{$prefix}header-border:                                  #{$header-border-dark};\n        --#{$prefix}header-item-color:                              #{$header-item-color-dark};\n        --#{$prefix}header-item-bg:                                 #{$header-item-bg-dark};\n        --#{$prefix}header-item-sub-color:                          #{$header-item-sub-color-dark};\n        --#{$prefix}topbar-user-bg:                                 #{$topbar-user-bg-dark};\n        --#{$prefix}topbar-search-bg:                               #{$topbar-search-bg-dark};\n        --#{$prefix}topbar-search-color:                            #{$topbar-search-color-dark};\n        \n        // Topbar - Dark\n        &[data-topbar=\"dark\"] {\n            --#{$prefix}header-bg:                                  #{$dark-header-bg-dark};\n            --#{$prefix}header-border:                              #{$dark-header-border-dark};\n            --#{$prefix}header-item-color:                          #{$dark-header-item-color-dark};\n            --#{$prefix}header-item-bg:                             #{$dark-header-item-bg-dark};\n            --#{$prefix}header-item-sub-color:                      #{$dark-header-item-sub-color-dark};\n            --#{$prefix}topbar-user-bg:                             #{$dark-topbar-user-bg-dark};\n            --#{$prefix}topbar-search-bg:                           #{$dark-topbar-search-bg-dark};\n            --#{$prefix}topbar-search-color:                        #{$dark-topbar-search-color-dark};\n        }\n    }\n}\n\n//sidebar dark mode\n@if $sidebar-dark-mode {\n    @include color-mode(dark, true) { \n        \n        //sidebar light\n        --#{$prefix}vertical-menu-bg:                               #{$vertical-menu-bg-dark};\n        --#{$prefix}vertical-menu-border:                           #{$vertical-menu-border-dark};\n        --#{$prefix}vertical-menu-item-color:                       #{$vertical-menu-item-color-dark};\n        --#{$prefix}vertical-menu-item-bg:                          #{$vertical-menu-item-bg-dark};\n        --#{$prefix}vertical-menu-item-hover-color:                 #{$vertical-menu-item-hover-color-dark};\n        --#{$prefix}vertical-menu-item-active-color:                #{$vertical-menu-item-active-color-dark};\n        --#{$prefix}vertical-menu-item-active-bg:                   #{$vertical-menu-item-active-bg-dark};\n        --#{$prefix}vertical-menu-sub-item-color:                   #{$vertical-menu-sub-item-color-dark};\n        --#{$prefix}vertical-menu-sub-item-hover-color:             #{$vertical-menu-sub-item-hover-color-dark};\n        --#{$prefix}vertical-menu-sub-item-active-color:            #{$vertical-menu-sub-item-active-color-dark};\n        --#{$prefix}vertical-menu-title-color:                      #{$vertical-menu-title-color-dark};\n        \n        &[data-sidebar=\"dark\"] {\n            //vertical dark\n            --#{$prefix}vertical-menu-bg:                           #{$dark-vertical-menu-bg-dark};\n            --#{$prefix}vertical-menu-border:                       #{$dark-vertical-menu-border-dark};\n            --#{$prefix}vertical-menu-item-color:                   #{$dark-vertical-menu-item-color-dark};\n            --#{$prefix}vertical-menu-item-bg:                      #{$dark-vertical-menu-item-bg-dark};\n            --#{$prefix}vertical-menu-item-hover-color:             #{$dark-vertical-menu-item-hover-color-dark};\n            --#{$prefix}vertical-menu-item-active-color:            #{$dark-vertical-menu-item-active-color-dark};\n            --#{$prefix}vertical-menu-item-active-bg:               #{$dark-vertical-menu-item-active-bg-dark};\n            --#{$prefix}vertical-menu-sub-item-color:               #{$dark-vertical-menu-sub-item-color-dark};\n            --#{$prefix}vertical-menu-sub-item-hover-color:         #{$dark-vertical-menu-sub-item-hover-color-dark};\n            --#{$prefix}vertical-menu-sub-item-active-color:        #{$dark-vertical-menu-sub-item-active-color-dark};\n            --#{$prefix}vertical-menu-title-color:                  #{$dark-vertical-menu-title-color-dark};\n            --#{$prefix}twocolumn-menu-iconview-bg:                 #{$dark-twocolumn-menu-iconview-bg-dark};\n        }\n        \n    }\n}\n\n//sidebar gradient dark mode\n@if $sidebar-gradient-dark-mode {\n    @include color-mode(dark, true) { \n        &:is([data-sidebar=\"gradient\"], [data-sidebar=\"gradient-2\"], [data-sidebar=\"gradient-3\"], [data-sidebar=\"gradient-4\"]) {\n            --#{$prefix}vertical-menu-item-color:                   #{$vertical-menu-item-color-gradient-dark};\n            --#{$prefix}vertical-menu-item-bg:                      #{$vertical-menu-item-bg-gradient-dark};\n            --#{$prefix}vertical-menu-item-hover-color:             #{$vertical-menu-item-hover-color-gradient-dark};\n            --#{$prefix}vertical-menu-item-active-color:            #{$vertical-menu-item-active-color-gradient-dark};\n            --#{$prefix}vertical-menu-item-active-bg:               #{$vertical-menu-item-active-bg-gradient-dark};\n            --#{$prefix}vertical-menu-sub-item-color:               #{$vertical-menu-sub-item-color-gradient-dark};\n            --#{$prefix}vertical-menu-sub-item-hover-color:         #{$vertical-menu-sub-item-hover-color-gradient-dark};\n            --#{$prefix}vertical-menu-sub-item-active-color:        #{$vertical-menu-sub-item-active-color-gradient-dark};\n            --#{$prefix}vertical-menu-title-color:                  #{$vertical-menu-title-color-gradient-dark};\n        \n        }\n        \n        &[data-sidebar=\"gradient\"] {\n            --#{$prefix}vertical-menu-bg:                           #{$vertical-menu-bg-gradient-dark};\n            --#{$prefix}vertical-menu-border:                       #{$vertical-menu-border-gradient-dark};\n            --#{$prefix}twocolumn-menu-iconview-bg:                 #{$twocolumn-menu-iconview-bg-gradient-dark};\n        }\n        \n        &[data-sidebar=\"gradient-2\"] {\n            --#{$prefix}vertical-menu-bg:                           #{$vertical-menu-bg-gradient-2-dark};\n            --#{$prefix}vertical-menu-border:                       #{$vertical-menu-border-gradient-2-dark};\n            --#{$prefix}twocolumn-menu-iconview-bg:                 #{$twocolumn-menu-iconview-bg-gradient-2-dark};\n        }\n        \n        &[data-sidebar=\"gradient-3\"] {\n            --#{$prefix}vertical-menu-bg:                           #{$vertical-menu-bg-gradient-3-dark};\n            --#{$prefix}vertical-menu-border:                       #{$vertical-menu-border-gradient-3-dark};\n            --#{$prefix}twocolumn-menu-iconview-bg:                 #{$twocolumn-menu-iconview-bg-gradient-3-dark};\n        \n        }\n        \n        &[data-sidebar=\"gradient-4\"] {\n            --#{$prefix}vertical-menu-bg:                           #{$vertical-menu-bg-gradient-4-dark};\n            --#{$prefix}vertical-menu-border:                       #{$vertical-menu-border-gradient-4-dark};\n            --#{$prefix}twocolumn-menu-iconview-bg:                 #{$twocolumn-menu-iconview-bg-gradient-4-dark};\n        }\n    }\n}","// \n// reboot.scss\n//\n\nhtml {\n    position: relative;\n    min-height: 100%;\n}\n\n:is(.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6) {\n    font-family: $headings-font-family;\n}\n\nlabel {\n    font-weight: $font-weight-medium;\n    margin-bottom: $form-label-margin-bottom;\n}\nb,\nstrong {\n  font-weight: $font-weight-semibold;\n}\n\n// blockquote\n\n.blockquote {\n    padding: 10px 20px;\n    border-left: 4px solid var(--#{$prefix}border-color);\n}\n\n.blockquote-reverse {\n    border-left: 0;\n    border-right: 4px solid var(--#{$prefix}border-color);\n    text-align: right;\n}\n\n// container\n\n:is(.container,\n.container-lg,\n.container-md,\n.container-sm,\n.container-xl,\n.container-xxl) {\n    @media (min-width: 1200px) {\n        max-width: 1140px;\n    }\n}\n\n// row\n.row>*{\n    position: relative;\n}","//\n// alerts.scss\n//\n\n// alert-label-icon\n\n.alert-label-icon {\n    position: relative;\n    padding-left: 60px;\n    border: 0;\n\n    .label-icon {\n        position: absolute;\n        width: 45px;\n        height: 100%;\n        left: 0;\n        top: 0;\n        background-color: rgba($white, 0.15);\n        font-size: 16px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    // label arrow\n    &.label-arrow {\n        overflow: hidden;\n        .label-icon {\n            &:after {\n                content: \"\";\n                position: absolute;\n                border: 6px solid transparent;\n                border-left-color: $primary;\n                right: -12px;\n            }\n        }\n    }\n}\n\n\n// Alert border left example\n\n.alert-border-left {\n    border-left: 3px solid;\n}\n\n// alert top border example\n\n.alert-top-border {\n    background-color: var(--#{$prefix}secondary-bg);\n    border-color: var(--#{$prefix}border-color);\n    border-top: 2px solid;\n    color: var(--#{$prefix}body-color);\n}\n\n//alert additional example\n\n.alert-additional { \n    padding: 0;\n\n    .alert-body{\n        padding: $alert-padding-y $alert-padding-x;\n    }\n    .alert-content {\n        padding: $alert-padding-y $alert-padding-x;\n        border-bottom-left-radius: $alert-border-radius;\n        border-bottom-right-radius: $alert-border-radius;\n        margin: 0 (-$alert-border-width) (-$alert-border-width) (-$alert-border-width);\n    }\n}\n\n// rounded label example\n\n.rounded-label {\n    .label-icon {\n        width: 45px;\n        height: 26px;\n        left: 0px;\n        top: 50%;\n        transform: translateY(-50%);\n        border-radius: 0 30px 30px 0;\n    }\n}\n\n// Alert example loop\n\n@each $color, $value in $theme-colors {\n\n    // alert border left\n    .alert-border-left {\n        &.alert-#{$color} {\n            border-left-color: var(--#{$prefix}#{$color});\n        }\n    }\n\n    // alert top border\n    .alert-top-border {\n        &.alert-#{$color} {\n            border-top-color: var(--#{$prefix}#{$color});\n        }\n    }\n    \n\n    // rounded label\n\n    .rounded-label {\n        &.alert-#{$color} {\n            .label-icon {\n                background-color: var(--#{$prefix}#{$color});\n                color: color-contrast($value);\n            }\n        }\n    }\n\n    // label arrow\n\n    .label-arrow {\n        &.alert-#{$color} {\n            .label-icon {\n                color: color-contrast($value);\n                background-color: var(--#{$prefix}#{$color});\n                &:after {\n                    border-left-color: var(--#{$prefix}#{$color}) !important;\n                }\n            }\n        }\n    }\n\n    .alert{\n        &.alert-#{$color} {\n            .btn-close::after{\n                color: var(--#{$prefix}#{$color});\n            }\n        }\n        \n    }\n\n    //alert additional example\n    .alert-additional {\n        &.alert-#{$color} {\n            .alert-content {\n                background-color: var(--#{$prefix}#{$color});\n                color: color-contrast($value);\n            }\n        }\n    }   \n}\n.alert-dismissible {\n    .btn-close {\n        background: transparent !important;\n        &::after {\n            background: transparent !important;\n            content: \"\\F0156\" !important;\n            font-size: 18px;\n            line-height:15px;\n            font-family: \"Material Design Icons\" !important;\n        }\n    }\n}\n   ","// \n// badge.scss\n//\n\n.badge {\n    line-height: 0.95;\n}\n\n@each $color, $value in $theme-colors {\n   \n    .badge-label {\n        &.bg-#{$color} {\n            &:before {\n                border-right-color: $value;\n            }\n        }\n    }\n}\n\n// badge-border\n.badge-border {\n    border-left: 2px solid;\n}\n\n// badge-label\n.badge-label {\n    margin-left: 8px;\n    position: relative;\n    &:before {\n        content: \"\";\n        position: absolute;\n        border: 8px solid transparent;\n        border-right-color: $primary;\n        left: -14px;\n        top: 0;\n    }\n}\n\n//Badge Gradient Style\n$gradients: ();\n$gradients: map-merge((primary: linear-gradient(135deg, $primary 0%, $success 100%),\n        secondary: linear-gradient(135deg, $secondary 0%, $info 100%),\n        success: linear-gradient(135deg, $success 0%, $warning 100%),\n        danger: linear-gradient(135deg, $danger 0%, $secondary 100%),\n        warning: linear-gradient(135deg, $warning 0%, darken($warning, 15%) 100%),\n        info: linear-gradient(135deg, $info 0%, $success 100%),\n        dark: linear-gradient(135deg, $dark 0%, $primary 100%)),\n    $gradients);\n\n@mixin badge-gradient($parent, $gradient) {\n    #{$parent} {\n        background: $gradient;\n    }\n}\n\n@each $gradient,\n$value in $gradients {\n    @include badge-gradient(\".badge-gradient-#{$gradient}\", $value);\n}","// \n// _buttons.scss\n// \n\nbutton,\na {\n    outline: none !important;\n    position: relative;\n}\n\n.btn {\n    box-shadow: $element-shadow;\n}\n\n:is(.btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active) {\n    border-color: transparent;\n}\n\n.btn-icon {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    height: calc(#{$btn-padding-y * 2} + #{$btn-line-height}em + #{$border-width * 2});\n    width: calc(#{$btn-padding-y * 2} + #{$btn-line-height}em + #{$border-width * 2});\n    padding: 0;\n\n    :is(i, svg, img) {\n        vertical-align: middle;\n    }\n\n    &.btn-sm {\n        height: calc(#{$btn-padding-y-sm * 2} + #{$btn-line-height}em + #{$border-width * 2});\n        width: calc(#{$btn-padding-y-sm * 2} + #{$btn-line-height}em + #{$border-width * 2});\n    }\n\n    &.btn-lg {\n        height: calc(#{$btn-padding-y-lg * 2} + #{$btn-line-height}em + #{$border-width * 2});\n        width: calc(#{$btn-padding-y-lg * 2} + #{$btn-line-height}em + #{$border-width * 2});\n    }\n}\n\n//\n// Soft Buttons\n// \n\n@each $state in map-keys($theme-colors) {\n\n    .btn-#{$state} {\n        --#{$prefix}btn-bg: var(--#{$prefix}#{$state});\n        --#{$prefix}btn-border-color: var(--#{$prefix}#{$state});\n        --#{$prefix}btn-hover-bg: var(--#{$prefix}#{$state}-text-emphasis);\n        --#{$prefix}btn-hover-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n        --#{$prefix}btn-focus-shadow-rgb: var(--#{$prefix}#{$state}-rgb);\n        --#{$prefix}btn-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n        --#{$prefix}btn-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n    }\n\n    @if $state == custom-primary {\n        .btn-#{$state} {\n          --#{$prefix}btn-hover-bg: var(--#{$prefix}custom-primary-hover);\n          --#{$prefix}btn-hover-border-color: var(--#{$prefix}custom-primary-hover);\n          --#{$prefix}btn-hover-color: var(--#{$prefix}dark);\n          --#{$prefix}btn-active-bg: var(--#{$prefix}custom-primary-hover);\n          --#{$prefix}btn-active-border-color: var(--#{$prefix}custom-primary);\n\n        }\n      }\n\n    @if $state == next-button {\n        .btn-#{$state} {\n          --#{$prefix}btn-hover-bg: var(--#{$prefix}next-button-hover);\n          --#{$prefix}btn-hover-border-color: var(--#{$prefix}cnext-button-border);\n          --#{$prefix}btn-hover-color: var(--#{$prefix}dark);\n        }\n    }\n\n    .btn-outline-#{$state} {\n        --#{$prefix}btn-color: var(--#{$prefix}#{$state});\n        --#{$prefix}btn-bg: transparent;\n        --#{$prefix}btn-border-color: var(--#{$prefix}#{$state});\n        --#{$prefix}btn-hover-bg: var(--#{$prefix}#{$state});\n        --#{$prefix}btn-hover-border-color: var(--#{$prefix}#{$state});\n        --#{$prefix}btn-focus-shadow-rgb: var(--#{$prefix}#{$state}-rgb);\n        --#{$prefix}btn-active-bg: var(--#{$prefix}#{$state});\n        --#{$prefix}btn-active-border-color: var(--#{$prefix}#{$state});\n    }\n\n    // soft Buttons\n    .btn-soft-#{$state} {\n        --#{$prefix}btn-color: var(--#{$prefix}#{$state});\n        --#{$prefix}btn-bg: var(--#{$prefix}#{$state}-bg-subtle);\n        --#{$prefix}btn-border-color: transparent;\n        --#{$prefix}btn-hover-bg: var(--#{$prefix}#{$state});\n        --#{$prefix}btn-hover-border-color: transparent;\n        --#{$prefix}btn-focus-shadow-rgb: var(--#{$prefix}#{$state}-rgb);\n        --#{$prefix}btn-active-bg: var(--#{$prefix}#{$state});\n        --#{$prefix}btn-active-border-color: transparent;\n    }\n\n    // Ghost Buttons\n    .btn-ghost-#{$state} {\n        --#{$prefix}btn-color: var(--#{$prefix}#{$state});\n        --#{$prefix}btn-bg: transparent;\n        --#{$prefix}btn-border-color: transparent;\n        --#{$prefix}btn-hover-color: var(--#{$prefix}#{$state});\n        --#{$prefix}btn-hover-bg: var(--#{$prefix}#{$state}-bg-subtle);\n        --#{$prefix}btn-hover-border-color: transparent;\n        --#{$prefix}btn-focus-shadow-rgb: var(--#{$prefix}#{$state}-rgb);\n        --#{$prefix}btn-active-color: var(--#{$prefix}#{$state});\n        --#{$prefix}btn-active-bg: var(--#{$prefix}#{$state}-bg-subtle);\n        --#{$prefix}btn-active-border-color: transparent;\n    }\n}\n\n//button with icon\n.btn-label {\n    position: relative;\n    padding-left: 44px;\n\n    .label-icon {\n        position: absolute;\n        width: 35.5px;\n        left: calc(#{$btn-border-width} * -1);\n        top: calc(#{$btn-border-width} * -1);\n        bottom: calc(#{$btn-border-width} * -1);\n        background-color: rgba($white, 0.1);\n        font-size: 16px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    &.btn-light {\n        .label-icon {\n            background-color: rgba($dark, 0.05);\n        }\n    }\n\n    &.right {\n        padding-left: $btn-padding-x;\n        padding-right: 44px;\n\n        .label-icon {\n            right: calc(#{$btn-border-width} * -1);\n            left: auto;\n        }\n    }\n}\n\n// Animation Button\n\n.btn-animation {\n    overflow: hidden;\n    transition: border-color 0.3s, background-color 0.3s;\n    transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\n\n    &::after {\n        content: attr(data-text);\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n        opacity: 0;\n        transform: translate3d(0, 25%, 0);\n        padding: $btn-padding-y $btn-padding-x;\n        transition: transform 0.3s, opacity 0.3s;\n        transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\n    }\n\n    >span {\n        display: block;\n        transition: transform 0.3s, opacity 0.3s;\n        transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\n    }\n\n    &:hover {\n        &::after {\n            opacity: 1;\n            transform: translate3d(0, 0, 0);\n        }\n\n        >span {\n            opacity: 0;\n            transform: translate3d(0, -25%, 0);\n        }\n    }\n}\n\n\n@mixin button-variant($bg) {\n    &.btn-animation {\n        background-color: $bg;\n        border-color: $bg !important;\n\n        &:is(:hover, :focus, :active, :focus-visible) {\n            color: $bg;\n            background-color: rgba($bg, 0.1);\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .btn-#{$color} {\n        @include button-variant($value);\n    }\n}\n\n//btn group\n.btn-group-vertical {\n    label {\n        margin-bottom: 0;\n    }\n}\n\n// btn group radio\n.btn-group.radio {\n    .btn {\n        border: none;\n    }\n\n    .btn-check:active+.btn-light,\n    .btn-check:checked+.btn-light,\n    .btn-light.active,\n    .btn-light.dropdown-toggle.show,\n    .btn-light:active {\n        background-color: rgba($info, 0.2);\n        color: $info;\n    }\n}\n\n.btn-load {\n\n    .spinner-border,\n    .spinner-grow {\n        height: 19px;\n        width: 19px;\n    }\n}\n\n//Border Bottom Buttons Style\n@each $color,\n$value in $theme-colors {\n\n    :is(.btn-#{$color}, .btn-outline-#{$color}, .btn-soft-#{$color}) {\n        &.btn-border {\n            border-bottom: 2px solid darken($value, 8%);\n        }\n    }\n\n    :is(.btn-soft-#{$color}, .btn-outline-#{$color}) {\n        --#{$prefix}btn-active-color: #{color-contrast($value)};\n        --#{$prefix}btn-hover-color: #{color-contrast($value)};\n    }\n}\n\n//custom toggle\n.custom-toggle {\n    .icon-off {\n        display: none;\n    }\n\n    &.active {\n        .icon-on {\n            display: none;\n        }\n\n        .icon-off {\n            display: block;\n        }\n    }\n}","// \n// breadcrumb.scss\n//\n\n\n// Breadcrumb item arrow\n.breadcrumb-item {\n    > a {\n        color: var(--#{$prefix}body-color);\n    }\n    +.breadcrumb-item {\n        &::before {\n            font-family: \"Material Design Icons\";\n            font-size: 15px;\n            line-height: 20px;\n        }\n    }\n}\n  ","// \n// _card.scss\n// \n\n.card {\n    margin-bottom: $grid-gutter-width;\n    box-shadow: $card-box-shadow;\n}\n\n.card-header {\n    border-bottom: 1px solid var(--#{$prefix}border-color);\n}\n\n//Card Header Dropdown\n.card-header-dropdown {\n    .dropdown-btn {\n        padding: $card-cap-padding-y 0;\n    }\n}\n\n.card-footer {\n    border-top: 1px solid var(--#{$prefix}border-color);\n}\n\n.card-title {\n    font-size: 16px;\n    margin: 0 0 7px 0;\n}\n\n.card-height-100 {\n    height: calc(100% - #{$grid-gutter-width});\n}\n\n.card-animate{\n    transition: all 0.4s;\n\n    &:hover{\n        transform: translateY(calc(#{-$grid-gutter-width} / 5));\n        box-shadow: $box-shadow-lg;\n    }\n}\n\n\n// card color variant\n\n@each $color,\n$value in $theme-colors {\n    .card-#{$color} {\n        background-color: $value;\n        color: color-contrast($value);\n\n        .card-header, .card-footer {\n            background-color: rgba($white, 0.1);\n            color: color-contrast($value);\n            border-color: transparent;\n        }\n\n        .card-title {\n            color: color-contrast($value);\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .card-border-#{$color} {\n        border-color: $value !important;\n        .card-header, .card-footer {\n            border-color: $value;\n        }\n\n    }\n}\n\n.card-light{\n    background-color: var(--#{$prefix}light);\n    .card-header, .card-footer{\n        color: var(--#{$prefix}body-color) !important;\n        background-color: rgba(var(--#{$prefix}dark-rgb), 0.1);\n    }\n    .card-title, .card-text { \n        color: var(--#{$prefix}body-color) !important;\n    }\n}\n\n// Loader\n\n.card-preloader {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(var(--#{$prefix}light-rgb), 0.6);\n    z-index: 9999;\n}\n\n.card-status {\n    width: 40px;\n    height: 40px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%,-50%)!important;\n}\n\n.custom-loader {\n    animation: spin 2s linear infinite;\n}\n\n@keyframes spin {\n\tto { transform: rotate(360deg) }\n}\n\n.card-overlay{\n    position: relative;\n    overflow: hidden;\n    &:before {\n        content: \"\";\n        background-color: rgba($primary, 0.20);\n        position: absolute;\n        top: 0;\n        right: 0;\n        left: 0;\n        bottom: 0;\n    }\n    :is(.card-header, .card-footer) {\n        border-color: rgba($white, 0.15) !important;\n    }\n}\n\n.card-toolbar-menu {\n    line-height: 0.8;\n    a {\n        font-size: 17px;\n    }\n    .minimize-card {\n        .plus{\n            display: none;\n        }  \n        .minus {\n            display: block;\n        }\n        &.collapsed{\n            .plus{\n                display: block;\n            }  \n            .minus {\n                display: none;\n            }\n        }\n    }\n}","// \n// _dropdown.scss\n// \n\n.dropdown-toggle::after {\n    display: inline-block;\n    margin-left: .255em;\n    font-size: 15px;\n    line-height: 15px;\n    content: \"\\F0140\";\n    font-family: \"Material Design Icons\";\n}\n\n.dropdown-menu {\n    box-shadow: $box-shadow-lg;\n    animation-name: DropDownSlide;\n    animation-duration: .3s;\n    animation-fill-mode: both;\n    position: absolute;\n    z-index: 1000;\n\n    &.dropdown-megamenu {\n        padding: 20px;\n        left: 0 !important;\n        right: 0 !important;\n    }\n\n    &[data-popper-placement=\"top-start\"] {\n        animation-name: DropDownSlideDown;\n    }\n}\n\n@keyframes DropDownSlide {\n    100% {\n        margin-top: -1px;\n    }\n\n    0% {\n        margin-top: 8px;\n    }\n}\n\n@keyframes DropDownSlideDown {\n    100% {\n        margin-bottom: 0;\n    }\n\n    0% {\n        margin-bottom: 8px;\n    }\n}\n\n@media (min-width: 600px) {\n    .dropdown-menu-xl {\n        width: 420px;\n    }\n\n    .dropdown-menu-lg {\n        width: 320px;\n    }\n\n    .dropdown-menu-md {\n        width: 240px;\n    }\n}\n\n.dropdown-toggle-split {\n    border-left: none;\n    &::after {\n        margin-left: 0px;\n    }\n\n    &:before {\n        content: \"\";\n        position: absolute;\n        background-color: rgba($white,0.12);\n        top: calc(#{$btn-border-width} * -1);\n        bottom: calc(#{$btn-border-width} * -1);\n        right: calc(#{$btn-border-width} * -1);\n        left: 0;\n        border-radius: 0 $btn-border-radius $btn-border-radius 0;\n    }\n}\n\n// Dropdown Mega Menu\n\n.dropdown-mega {\n    position: static !important;\n}\n\n\n\n// Dropdown size\n\n.dropdown-mega-menu-xl {\n    width: 38rem;\n}\n\n.dropdown-mega-menu-lg {\n    width: 26rem;\n}\n\n[dir=\"ltr\"] {\n    .dropdown-menu-start {\n        --#{$prefix}position: end;\n    }\n\n    .dropdown-menu-end {\n        --#{$prefix}position: start;\n    }\n}\n// Custom Dropdown with Tabs\n.dropdown-head{\n    .nav-tabs-custom{\n        border: 0;\n        .nav-link  {\n            color: rgba($white, 0.6);\n            &.active {\n                background-color: var(--#{$prefix}dropdown-bg);\n            }\n            &:hover {\n                color: $white;\n            }\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .dropdownmenu-#{$color} {\n      .dropdown-item{\n        &:is(:focus, :hover, .active){\n          background-color: rgba(($value), 0.07);\n          color: $value;\n        }\n      }\n    }\n}","//\n// _nav.scss\n//\n\n:is(.nav-tabs, .nav-pills) {\n    >li {\n        >a {\n            color: var(--#{$prefix}body-color);\n            font-weight: $font-weight-medium;\n        }\n    }\n}\n\n.nav-pills {\n    >a {\n        color: var(--#{$prefix}body-color);\n        font-weight: $font-weight-medium;\n    }\n}\n\n.nav-pills {\n\n    :is(.nav-link.active, .show>.nav-link) {\n        box-shadow: $element-shadow;\n    }\n}\n\n.nav-tabs-custom {\n    border-bottom: 1px solid var(--#{$prefix}border-color);\n\n    .nav-item {\n        position: relative;\n\n        .nav-link {\n            border: none;\n            font-weight: $font-weight-medium;\n\n            &::after {\n                content: \"\";\n                background: $primary;\n                height: 1px;\n                position: absolute;\n                width: 100%;\n                left: 0;\n                bottom: 0;\n                transition: all 250ms ease 0s;\n                transform: scale(0);\n            }\n\n            &.active {\n                color: $primary;\n\n                &:after {\n                    transform: scale(1);\n                }\n            }\n        }\n    }\n\n    &.card-header-tabs {\n        margin-top: -1rem;\n\n        .nav-link {\n            padding: $card-cap-padding-y $card-cap-padding-x;\n        }\n    }\n}\n\n// vertical nav\n\n.vertical-nav {\n    .nav {\n        .nav-link {\n            padding: 24px 16px;\n            text-align: center;\n            margin-bottom: 8px;\n\n            .nav-icon {\n                font-size: 24px;\n            }\n        }\n    }\n}\n\n//Navtab custom\n.navtab-bg {\n    li {\n        >a {\n            background-color: $gray-300;\n            margin: 0 5px;\n        }\n    }\n}\n\n// arrow-navtabs\n\n.arrow-navtabs {\n    .nav-item {\n        .nav-link {\n            position: relative;\n            text-align: center;\n\n            &:before {\n                content: \"\";\n                position: absolute;\n                border: 6px solid transparent;\n                bottom: -12px;\n                left: 50%;\n                transform: translateX(-50%);\n                @include transition($nav-link-transition);\n            }\n\n            &.active {\n                &:before {\n                    border-top-color: $primary;\n                }\n            }\n        }\n    }\n}\n\n// custom hover tab\n.custom-hover-nav-tabs {\n    .nav-item {\n        text-align: center;\n        overflow: hidden;\n\n        .nav-link {\n            width: 120px;\n            height: 45px;\n            position: relative;\n            border-radius: 0px;\n\n            .nav-icon {\n                font-size: 22px;\n            }\n\n            .nav-titl {\n                font-size: 14px;\n            }\n\n            &.active {\n                .nav-tab-position {\n                    color: $white;\n                }\n            }\n\n            .nav-tab-position {\n                position: absolute;\n                left: 0;\n                right: 0;\n                transition: all 0.4s;\n\n                &.nav-icon {\n                    top: 50%;\n                    transform: translateY(-50%);\n                }\n\n                &.nav-titl {\n                    bottom: -20px;\n                }\n            }\n\n            &:hover {\n                .nav-titl {\n                    bottom: 50%;\n                    transform: translateY(50%);\n                }\n\n                .nav-icon {\n                    top: -20px;\n                }\n            }\n        }\n    }\n}\n\n// custom vertical tab\n\n.custom-verti-nav-pills {\n    .nav-link {\n        background-color: var(--#{$prefix}light);\n        margin-top: 7px;\n        position: relative;\n\n        @media (min-width: 992px) {\n            &::before {\n                content: \"\";\n                position: absolute;\n                right: -20px;\n                top: 50%;\n                transform: translateY(-50%);\n                border: 12px solid transparent;\n                border-left-color: transparent;\n                transition: border-left-color 0.04 ease;\n            }\n\n            &.active {\n                &::before {\n                    border-left-color: $primary;\n                }\n            }\n        }\n    }\n}\n\n// animation nav\n.animation-nav {\n    li {\n        position: relative;\n\n        a {\n            color: var(--#{$prefix}body-color);\n            border-radius: 4px;\n            position: relative;\n            overflow: hidden;\n            transition: all 0.4s;\n            z-index: 1;\n\n            span {\n                position: relative;\n            }\n\n            &::before {\n                content: \"\";\n                position: absolute;\n                top: 0;\n                width: 0;\n                right: 0;\n                height: 100%;\n                transition: width 0.4s cubic-bezier(0.51, 0.18, 0, 0.88) 0.1s;\n                background-color: $primary;\n                z-index: -1;\n            }\n\n            &:hover,\n            &.active {\n                color: $white;\n                background-color: transparent !important;\n\n                &::before {\n                    width: 100%;\n                    left: 0;\n                }\n            }\n        }\n    }\n}\n\n.nav-border-top {\n    .nav-link {\n        border-top: 3px solid transparent;\n\n        &.active {\n            border-top-color: $primary;\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .nav-border-top-#{$color} {\n        .nav-link {\n            &.active {\n                color: $value;\n                border-top-color: $value;\n            }\n        }\n    }\n}\n\n.nav-custom {\n    background-color: $primary;\n    border-radius: $card-border-radius;\n\n    .nav-item {\n        .nav-link {\n            color: rgba($white, 0.75);\n\n            &.active {\n                color: $white;\n                background-color: rgba($white, 0.1);\n            }\n        }\n    }\n\n    &.nav-custom-light {\n        .nav-item {\n            .nav-link {\n                color: rgba(var(--#{$prefix}body-rgb), 0.75);\n\n                &.active {\n                    color: $light;\n                    background-color: $primary;\n                }\n            }\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .nav-custom-#{$color} {\n        background-color: $value;\n    }\n}\n\n.nav-custom-light {\n    background-color: var(--#{$prefix}light);\n}\n\n@each $color,\n$value in $theme-colors {\n    .nav-#{$color} {\n        .nav-link {\n            &.active {\n                color: $white;\n                background-color: $value;\n            }\n        }\n\n        &.nav-tabs {\n            .nav-link {\n                &.active {\n                    color: $value;\n                    background-color: var(--#{$prefix}secondary-bg);\n                }\n            }\n        }\n\n        &.nav-tabs-custom {\n            .nav-link {\n                &.active {\n                    color: $value;\n                    background-color: var(--#{$prefix}secondary-bg);\n\n                    &::after {\n                        background-color: $value;\n                    }\n                }\n            }\n        }\n\n        &.arrow-navtabs {\n            .nav-link {\n                &.active {\n                    &::before {\n                        border-top-color: $value;\n                    }\n                }\n            }\n        }\n\n        &.custom-verti-nav-pills {\n            .nav-link {\n                &.active {\n                    &::before {\n                        border-left-color: $value;\n                    }\n                }\n            }\n        }\n    }\n}\n\n// progress nav\n.progress-nav {\n    position: relative;\n    margin-right: 1rem;\n    margin-left: 1rem;\n\n    .progress {\n        position: absolute;\n        left: 0;\n        top: 50%;\n        transform: translateY(-50%);\n        width: 100%;\n    }\n\n    .nav {\n        margin-right: -1rem;\n        margin-left: -1rem;\n        justify-content: space-between;\n\n        .nav-link {\n            width: 2rem;\n            height: 2rem;\n            background-color: var(--#{$prefix}light);\n            padding: 0;\n            color: var(--#{$prefix}body-color);\n            font-weight: $font-weight-medium;\n\n            &.active,\n            &.done {\n                background-color: $primary;\n                color: $white;\n            }\n        }\n    }\n}\n\n// Step arrow nav\n.step-arrow-nav {\n    .nav {\n        background-color: var(--#{$prefix}light);\n\n        .nav-link {\n            border-radius: 0;\n            position: relative;\n            font-weight: $font-weight-medium;\n            color: var(--#{$prefix}body-color);\n\n            &::before {\n                content: \"\";\n                position: absolute;\n                border: 7px solid transparent;\n                right: -14px;\n                top: 50%;\n                transform: translateY(-50%);\n            }\n\n            &.done {\n                background-color: rgba($primary, 0.05);\n                color: $primary;\n\n                &::before {\n                    border-left-color: transparent;\n                }\n            }\n\n            &.active {\n                background-color: rgba($primary, 0.1);\n                color: $primary;\n                box-shadow: none;\n\n                &::before {\n                    border-left-color: rgba($primary, 0.1);\n                }\n            }\n        }\n\n        .nav-item {\n            &:last-child {\n                .nav-link {\n                    &:before {\n                        display: none;\n                    }\n                }\n            }\n        }\n    }\n}\n\n// vertical nav step\n.vertical-navs-step {\n    .nav {\n        gap: 16px;\n\n        .nav-link {\n            text-align: left;\n            background-color: rgba(var(--#{$prefix}light-rgb), 0.4);\n            border: 1px solid var(--#{$prefix}border-color);\n            color: var(--#{$prefix}body-color);\n\n            .step-title {\n                font-weight: $font-weight-semibold;\n            }\n\n            .step-icon {\n                color: $danger;\n                vertical-align: middle;\n                font-weight: $font-weight-medium;\n                float: left;\n            }\n\n            &.active,\n            &.done {\n                .step-icon {\n                    color: $success;\n\n                    &:before {\n                        content: \"\\eb80\";\n                    }\n                }\n            }\n\n            &.active {\n                border-color: $primary;\n            }\n\n            &.done {\n                border-color: $success;\n            }\n        }\n    }\n}\n\n//Outline Border Nav\n.nav-custom-outline {\n    &.nav {\n        .nav-link {\n            border: 1px solid transparent;\n            border-bottom: 2px solid transparent;\n\n            &.active {\n                border-color: $primary;\n                background-color: transparent;\n                color: $primary;\n            }\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .nav-#{$color} {\n        &.nav-custom-outline {\n            .nav-link {\n                &.active {\n                    color: $value;\n                    border-color: $value;\n                }\n            }\n        }\n    }\n}\n\n//customs nav\n.nav-customs {\n    &.nav {\n        padding-left: 34px;\n        overflow: hidden;\n\n        .nav-link {\n            position: relative;\n            display: block;\n            float: right;\n            background-color: var(--#{$prefix}tertiary-bg);\n            margin-right: 46px;\n            transition: all 0.5s ease;\n\n            &::before,\n            &::after {\n                display: block;\n                content: \" \";\n                position: absolute;\n                top: -1px;\n                bottom: -1px;\n                width: 37px;\n                background-color: var(--#{$prefix}tertiary-bg);\n                transition: all 0.5s ease;\n            }\n\n            &::before {\n                border-radius: 0 8px 0 0;\n                right: -24px;\n                transform: skew(30deg, 0deg);\n            }\n\n            &::after {\n                border-radius: 8px 0 0 0;\n                left: -24px;\n                transform: skew(-30deg, 0deg);\n            }\n\n            &.active,\n            &.active:before,\n            &.active:after {\n                background-color: $primary;\n                color: $white;\n            }\n\n            &.active {\n                z-index: 1;\n            }\n        }\n    }\n}","// \n// _table.scss\n// \n\n.table {\n    >thead {\n        border-color: $table-border-color;\n    }\n    >:not(:first-child) {\n        border-top-width: $table-border-width;\n    }\n}\n\n\n.table-nowrap {\n\n    th,\n    td {\n        white-space: normal;\n    }\n}\n\n// card table\n\n.table-card{\n    margin: (-$card-spacer-y) (-$card-spacer-x);\n\n    th,\n    td {\n\n        &:first-child{\n            padding-left: 16px;\n        }\n\n        &:last-child{\n            padding-right: 16px;\n        }\n    }\n\n    .table > :not(:first-child) {\n        border-top-width: $table-border-width;\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .border-#{$color} {\n        &.table {\n            > thead {\n                border-color: $value !important;\n            }\n        }\n    }\n    .table-#{$color} {\n        &.table {\n            > thead {\n                border-bottom-color:lighten($value, 10%) !important;\n            }\n        }\n    }\n}\n\n.table>:not(caption)>*>* {\n    color: var(--vz-table-color-state), var(--vz-table-color-type, var(--vz-table-color));\n}\n\n.table {\n    .form-check {\n        padding-left: 0px;\n        margin-bottom: 0px;\n        .form-check-input {\n            margin-left: 0px;\n            margin-top: 0px;\n            float: none;\n            vertical-align: middle;\n        }\n    }\n    .sort {\n        position: relative;\n        &::before {\n            content: \"\\f035d\";\n            position: absolute;\n            right: 0.5rem;\n            top: 18px;\n            font-size: 0.8rem;\n            font-family: \"Material Design Icons\";\n        }\n        &::after {\n            position:absolute;\n            right: 0.5rem;\n            content: \"\\f0360\";\n            font-family: \"Material Design Icons\";\n            font-size: 0.8rem;\n            top: 12px;\n        }\n    }\n}","//\n// _modal.scss\n//\n\n.modal-title {\n    font-weight: $font-weight-semibold;\n}\n\n.modal-dialog:not(.modal-dialog-scrollable) {\n    .modal-header {\n        padding-bottom: 0;\n    \n        .btn-close {\n            margin-top: -$modal-header-padding;\n        }\n    }\n    \n    .modal-footer {\n        padding-top: 0;\n    }\n}\n\n.modal {\n\t&.fadeInRight {\n\t\t.modal-dialog {\n\t\t\topacity: 0;\n\t\t\ttransform: translateX(20%);\n\t\t\ttransition: all .3s ease-in-out;\n\t\t}\n\n\t\t&.show {\n\t\t\t.modal-dialog {\n\t\t\t\topacity: 1;\n\t\t\t\ttransform: translateX(0);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.fadeInLeft {\n\t\t.modal-dialog {\n\t\t\tanimation: fadeInLeft 0.3s ease-in-out;\n\t\t\ttransform: translate(-50%, 0);\n\t\t}\n\n\t\t&.show {\n\t\t\t.modal-dialog {\n\t\t\t\ttransform: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.fadeInUp {\n\t\t.modal-dialog {\n\t\t\tanimation: fadeInUp 0.3s ease-in-out;\n\t\t\ttransform: translate(0, 30%);\n\t\t}\n\n\t\t&.show {\n\t\t\t.modal-dialog {\n\t\t\t\ttransform: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.flip {\n\t\tperspective: 1300px;\n\n\t\t.modal-dialog {\n\t\t\topacity: 0;\n\t\t\ttransform: rotateY(-70deg);\n\t\t\ttransition: all .3s;\n\t\t}\n\n\t\t&.show {\n\t\t\t.modal-dialog {\n\t\t\t\topacity: 1;\n\t\t\t\ttransform: rotateY(0deg);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.zoomIn {\n\t\t.modal-dialog {\n\t\t\topacity: 0;\n\t\t\ttransform: scale(.7);\n\t\t\ttransition: all .3s ease;\n\t\t}\n\n\t\t&.show {\n\t\t\t.modal-dialog {\n\t\t\t\topacity: 1;\n\t\t\t\ttransform: scale(1)\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n.modal-dialog-right {\n\tmargin-right: $modal-dialog-margin-y-sm-up;\n}\n\n// modal-dialog-bottom\n.modal-dialog-bottom {\n\tdisplay: flex;\n\talign-items: flex-end;\n\tmin-height: calc(100% - #{$modal-dialog-margin-y-sm-up});\n\n\t@media (min-width: 576px) {\n\t\tmin-height: calc(100% - #{$modal-dialog-margin-y-sm-up* 2 });\n\t}\n}\n\n.modal-dialog-bottom-right {\n\tdisplay: flex;\n\talign-items: flex-end;\n\tmin-height: calc(100% - #{$modal-dialog-margin-y-sm-up});\n\tmargin-right: $modal-dialog-margin-y-sm-up;\n\n\t@media (min-width: 576px) {\n\t\tmin-height: calc(100% - #{$modal-dialog-margin-y-sm-up*2 });\n\t}\n}\n\n@keyframes fadeInLeft {\n\t0% {\n\t\topacity: 0;\n\t\ttransform: translate3d(-30%, 0, 0);\n\t}\n\n\tto {\n\t\topacity: 1;\n\t\ttransform: translateZ(0);\n\t}\n}\n\n\n@keyframes fadeInUp {\n\t0% {\n\t\topacity: 0;\n\t\ttransform: translate3d(0, 30%, 0);\n\t}\n\n\tto {\n\t\topacity: 1;\n\t\ttransform: translateZ(0);\n\t}\n}\n\n@keyframes zoomIn {\n\t0% {\n\t\topacity: 0;\n\t\ttransform: scale3d(.3, .3, .3);\n\t}\n\n\t50% {\n\t\topacity: 1\n\t}\n}\n\n.login-modal {\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1016%26quot%3b)' fill='none'%3e%3crect width='1440' height='560' x='0' y='0' fill='rgba(64%2c 81%2c 137%2c 1)'%3e%3c/rect%3e%3cpath d='M0%2c650.704C122.328%2c648.746%2c159.175%2c473.043%2c255.674%2c397.837C339.724%2c332.333%2c461.529%2c324.924%2c526.449%2c240.421C598.428%2c146.73%2c655.546%2c24.847%2c631.015%2c-90.726C606.666%2c-205.444%2c482.926%2c-263.497%2c401.565%2c-347.958C325.215%2c-427.217%2c275.543%2c-549.012%2c167.826%2c-571.563C60.344%2c-594.065%2c-27.703%2c-482.932%2c-135.163%2c-460.325C-256.336%2c-434.833%2c-401.929%2c-509.651%2c-497.972%2c-431.495C-592.807%2c-354.321%2c-579.865%2c-206.886%2c-595.603%2c-85.635C-611.133%2c34.016%2c-656.761%2c169.183%2c-588.884%2c268.934C-520.854%2c368.909%2c-362.458%2c340.324%2c-260.989%2c406.106C-158.875%2c472.306%2c-121.679%2c652.651%2c0%2c650.704' fill='%2333416e'%3e%3c/path%3e%3cpath d='M1440 995.672C1519.728 984.741 1563.12 899.779 1626.466 850.1469999999999 1682.6390000000001 806.135 1756.261 782.602 1791.2939999999999 720.431 1827.571 656.052 1835.537 577.6610000000001 1820.814 505.247 1806.518 434.933 1753.2640000000001 383.16999999999996 1710.941 325.228 1664.475 261.614 1634.992 175.16000000000003 1560.657 149.07999999999998 1485.96 122.87299999999999 1402.146 155.543 1332.03 192.289 1269.541 225.038 1232.754 287.251 1189.969 343.347 1149.925 395.849 1115.781 448.9 1089.96 509.672 1056 589.599 988.9680000000001 671.1659999999999 1015.557 753.837 1041.91 835.774 1142.714 863.61 1217.498 906.22 1288.388 946.611 1359.167 1006.755 1440 995.672' fill='%234d61a4'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1016'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e\");\n\tbackground-size: cover;\n\tbackground-position: center;\n}","// \n// _pagination.scss\n// \n\n// Pagination Separated\n.pagination-separated {\n    .page-item {\n        .page-link {\n            margin-left: 0.35rem;\n            border-radius: var(--#{$prefix}border-radius);\n        }\n    }\n}\n\n.page-link {\n    color: #ffffff;\n    background-color: var(--vz-custom-primary);\n    border: var(--vz-pagination-border-width) solid var(--vz-custom-primary-hover);\n}\n\n.pagination {\n    --vz-pagination-color: #ffffff;\n    --vz-pagination-bg: var(--vz-custom-primary);\n    --vz-pagination-border-width: var(--vz-border-width);\n    --vz-pagination-border-color: var(--vz-custom-primary);\n    --vz-pagination-border-radius: var(--vz-border-radius);\n\n    --vz-pagination-hover-color: var(--vz-dark);\n    --vz-pagination-hover-bg: var(--vz-custom-primary-hover);\n    --vz-pagination-hover-border-color: var(--vz-custom-primary-hover);\n\n    --vz-pagination-focus-color: var(--vz-dark);\n    --vz-pagination-focus-bg: var(--vz-custom-primary-hover);\n    --vz-pagination-focus-box-shadow: 0 0 1 0.25rem rgba(var(--vz-primary-rgb), 0.25);\n\n    --vz-pagination-active-color: #fff;\n    --vz-pagination-active-bg: var(--vz-custom-primary-hover);\n    --vz-pagination-active-border-color: var(--vz-custom-primary);\n\n    --vz-pagination-disabled-color: $gray-600;\n    --vz-pagination-disabled-bg: var(--#{$prefix}tertiary-bg);\n    --vz-pagination-disabled-border-color: var(--#{$prefix}tertiary-bg);\n}\n\n// Pagination rounded (Custom)\n.pagination-rounded {\n    .page-link {\n        border-radius: 30px !important;\n        margin: 0 3px !important;\n        border: none;\n        min-width: 32px;\n        min-height: 32px;\n        text-align: center;\n    }\n\n    &.pagination-sm {\n        .page-link {\n            min-width: 25px;\n            min-height: 25px;\n        }\n    }\n}\n\n.page-item.active {\n    .page-link {\n        box-shadow: $element-shadow;\n    }\n}","// \n// _progress.scss\n// \n\n// Progress height small\n.progress-sm {\n    height: 5px;\n}\n\n// Progress height large\n.progress-lg {\n    height: 12px;\n}\n\n// Progress height Extra large\n.progress-xl {\n    height: 16px;\n}\n\n.custom-progess {\n    position: relative;\n\n    .progress-icon {\n        position: absolute;\n        top: -12px;\n\n        .avatar-title {\n            background: var(--#{$prefix}secondary-bg);\n        }\n    }\n}\n\n// animated-progress\n\n.animated-progress {\n    position: relative;\n\n    .progress-bar {\n        position: relative;\n        border-radius: 6px;\n        animation: animate-positive 2s;\n    }\n}\n\n@keyframes animate-positive {\n    0% {\n        width: 0;\n    }\n}\n\n// custom-progress\n\n.custom-progress {\n    height: 15px;\n    padding: 4px;\n    border-radius: 30px;\n\n    .progress-bar {\n        position: relative;\n        border-radius: 30px;\n\n        &::before {\n            content: \"\";\n            position: absolute;\n            width: 4px;\n            height: 4px;\n            background-color: $white;\n            border-radius: 7px;\n            right: 2px;\n            top: 50%;\n            transform: translateY(-50%);\n\n        }\n    }\n}\n\n// progress withlabel\n.progress-label {\n    overflow: visible;\n\n    .progress-bar {\n        position: relative;\n        overflow: visible;\n\n        .label {\n            position: absolute;\n            top: -25px;\n            right: -9px;\n            background-color: $primary;\n            color: $white;\n            display: inline-block;\n            line-height: 18px;\n            padding: 0 4px;\n            border-radius: 4px;\n\n            &:after {\n                content: \"\";\n                position: absolute;\n                border: 4px solid transparent;\n                border-top-color: $primary;\n                bottom: -7px;\n                left: 50%;\n                transform: translateX(-50%);\n            }\n        }\n    }\n}\n\n\n.progress-step-arrow {\n    height: 3.25rem;\n\n    .progress-bar {\n        position: relative;\n        overflow: initial;\n        font-size: .875rem;\n        color: $white;\n        &::after {\n            content: \"\";\n            position: absolute;\n            border: 10px solid transparent;\n            bottom: 15px;\n            right: -20px;\n            z-index: 1;\n        }\n    }\n}\n\n\n@mixin progress-variant($bg) {\n    .progress-bar {\n        background-color: $bg;\n        &::after { \n            border-left-color: $bg;\n        }\n        &:nth-child(2) {\n            background-color: rgba($bg, 0.1) !important;\n            color: $bg !important;\n            &::after { \n                border-left-color: rgba($bg, 0.1);\n            }\n        }\n    }\n}\n\n@each $color, $value in $theme-colors {\n    .progress-#{$color} {\n        @include progress-variant($value);\n    }\n}\n\n","// \n// _popover.scss\n// \n\n.popover {\n    box-shadow: $popover-box-shadow;\n}","// \n// type.scss\n//\n\n// Blockquote\n.custom-blockquote {\n    &.blockquote {\n        padding: 16px;\n        border-left: 3px solid;\n        \n        &.blockquote-outline{\n            background-color: var(--#{$prefix}secondary-bg) !important;\n            border: 1px solid;\n            border-left: 3px solid;\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .custom-blockquote {\n        &.blockquote {\n            &.blockquote-#{$color} {\n                border-color: var(--#{$prefix}#{$color});\n                background-color: var(--#{$prefix}#{$color}-bg-subtle);\n\n                .blockquote-footer {\n                    color: var(--#{$prefix}#{$color}-text-emphasis);\n                }\n            }\n\n            &.blockquote-outline{\n                &.blockquote-#{$color} {\n                    border-color: var(--#{$prefix}#{$color});\n\n                    .blockquote-footer {\n                        color: var(--#{$prefix}#{$color}-text-emphasis);\n                    }\n                }\n            }\n        }\n    }\n}","//\n// _form-check.scss\n//\n\n.form-check {\n    position: relative;\n    text-align: left\n        /*rtl: right*/;\n\n    .form-check-input {\n        cursor: pointer;\n    }\n\n    label {\n        cursor: pointer;\n    }\n}\n\n\n// checkbox color\n\n@each $color,\n$value in $theme-colors {\n    .form-check-#{$color} {\n        .form-check-input {\n            &:checked {\n                background-color: $value;\n                border-color: $value;\n            }\n        }\n    }\n\n    .form-radio-#{$color} {\n        .form-check-input {\n            &:checked {\n                border-color: $value;\n                background-color: $value;\n\n                &:after {\n                    background-color: $value;\n                }\n            }\n        }\n    }\n}\n\n.form-check-label {\n    cursor: pointer;\n    margin-bottom: 0;\n}\n\n// checkbox input right\n.form-check-right {\n    padding-left: 0;\n    display: inline-block;\n\n    .form-check-input {\n        float: right;\n        margin-left: 0;\n        margin-right: calc(#{$form-check-padding-start} * -1);\n    }\n\n    .form-check-label {\n        display: block;\n    }\n\n    &.form-switch {\n        .form-check-input {\n            margin-right: calc(#{$form-check-padding-start} * -1.6);\n        }\n    }\n}\n\n\n// Checkbox outline\n\n@each $color,\n$value in $theme-colors {\n    .form-check-outline {\n        &.form-check-#{$color} {\n            .form-check-input {\n                &:checked[type=checkbox] {\n                    color: $value;\n                    background-color: transparent;\n                    border-color: $value;\n                }\n            }\n        }\n    }\n}\n\n.form-check-outline {\n    .form-check-input {\n        position: relative;\n\n        &:checked[type=checkbox] {\n            background-image: none;\n\n            &::before {\n                content: \"\\F012C\";\n                font-family: \"Material Design Icons\";\n                top: -2px;\n                position: absolute;\n                font-weight: 700;\n                font-size: 11px;\n                left: 1px;\n            }\n        }\n\n    }\n}\n\n// Radio\n\n@each $color,\n$value in $theme-colors {\n    .form-radio-outline {\n        &.form-radio-#{$color} {\n            .form-check-input {\n                &:checked[type=radio] {\n                    color: $value;\n                    background-color: transparent;\n                    border-color: $value;\n                }\n            }\n        }\n    }\n}\n\n.form-radio-outline {\n    .form-check-input {\n        position: relative;\n\n        &:checked[type=radio] {\n            background-image: none;\n\n            &::before {\n                content: \"\\F0765\";\n                font-family: \"Material Design Icons\";\n                top: 0px;\n                position: absolute;\n                font-size: 8px;\n                left: 2.2px;\n            }\n        }\n\n    }\n}\n\n// Switch sizes\n\n.form-switch-md {\n    padding-left: 2.5rem;\n    min-height: 22px;\n    line-height: 22px;\n\n    .form-check-input {\n        width: 40px;\n        height: 20px;\n        left: -0.5rem;\n        position: relative;\n    }\n\n    .form-check-label {\n        vertical-align: middle;\n    }\n}\n\n.form-switch-lg {\n    padding-left: 2.75rem;\n    min-height: 28px;\n    line-height: 28px;\n\n    .form-check-input {\n        width: 48px;\n        height: 24px;\n        left: -0.75rem;\n        position: relative;\n    }\n}\n\n.input-group-text {\n    margin-bottom: 0px;\n}\n\n\n@each $color,\n$value in $theme-colors {\n    .form-switch-#{$color} {\n        .form-check-input {\n\n            &:checked {\n                background-color: $value;\n                border-color: $value;\n            }\n        }\n    }\n\n    .form-switch-custom {\n        &.form-switch-#{$color} {\n            .form-check-input {\n                &:checked {\n                    &::before {\n                        color: $value;\n                    }\n\n                }\n            }\n        }\n    }\n}\n\n// Custom Switch style\n\n.form-switch-custom {\n    .form-check-input {\n        position: relative;\n        background-image: none;\n\n        &::before {\n            content: \"\\F0765\";\n            font-family: \"Material Design Icons\";\n            top: -9px;\n            position: absolute;\n            font-size: 20px;\n            left: -3px;\n            color: var(--#{$prefix}secondary-color);\n            @include transition($form-switch-transition);\n        }\n\n        &:checked {\n            background-image: none;\n            background-color: $form-check-input-bg;\n            @include transition($form-switch-transition);\n\n            &::before {\n                right: -3px;\n                left: auto;\n            }\n        }\n\n        &:focus {\n            background-image: none;\n        }\n    }\n}\n\n// Switch - Right\n\n.form-switch-right {\n    display: inline-block;\n    padding-right: calc(#{$form-check-padding-start} * .5);\n    margin-bottom: 0;\n    padding-left: 0 !important;\n\n    .form-check-input {\n        float: right;\n        margin-left: 0;\n        margin-right: calc(#{$form-check-padding-start} * -1);\n        margin-top: .1em !important;\n    }\n\n    label {\n        margin-bottom: 0;\n        margin-right: 1rem;\n    }\n}\n\n// card radio\n.card-radio {\n    padding: 0;\n\n    .form-check-label {\n        background-color: var(--#{$prefix}secondary-bg);\n        border: 1px solid var(--#{$prefix}border-color);\n        border-radius: $border-radius;\n        padding: 1rem;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        display: block;\n        position: relative;\n        padding-right: 32px;\n\n        &:hover {\n            cursor: pointer;\n        }\n    }\n\n    .form-check-input {\n        display: none;\n\n        &:checked+.form-check-label {\n            border-color: $primary !important;\n\n            &:before {\n                content: '\\eb80';\n                font-family: \"remixicon\";\n                position: absolute;\n                top: 2px;\n                right: 6px;\n                font-size: 16px;\n                color: $primary;\n            }\n        }\n    }\n\n    &.dark {\n        .form-check-input {\n            &:checked+.form-check-label {\n                &:before {\n                    color: $white;\n                }\n            }\n        }\n    }\n}","//\n// _form-control.scss\n//\n\n\n.form-icon{\n    position: relative;\n    .form-control-icon {\n        padding-left: calc(#{$input-padding-x} * 3);\n        position: relative;\n    }\n    i {\n        position: absolute;\n        top: 0px;\n        bottom: 0px;\n        left: 18px;\n        display: flex;\n        align-items: center;\n    }\n    &.right{\n        .form-control-icon {\n            padding-right: calc(#{$input-padding-x} * 3);\n            padding-left: $input-padding-x;\n            position: relative;\n        }\n        i {\n            left: auto;\n            right: 18px;\n        }\n    }\n}","//\n// _list-group.scss\n//\n\n\n@each $color,\n$value in $theme-colors {\n    .list-group-fill-#{$color} {\n        &.list-group-item {\n            color: color-contrast($value);\n            background-color: var(--#{$prefix}#{$color}) !important;\n            border-color: var(--#{$prefix}#{$color});\n        }\n    }\n}\n\n.list-group-item {\n    margin-bottom: 0px;\n    .list-text {\n        color: var(--#{$prefix}secondary-color);\n    }\n    &.active {\n        box-shadow: $element-shadow;\n        .list-title {\n            color: $white;\n        }\n        .list-text {\n            color: rgba($white, 0.50);\n        }\n    }\n}","//\n// _custom-scrollbar.scss\n//\n\n[data-simplebar] {\n  position: relative;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-content: flex-start;\n  align-items: flex-start;\n}\n\n.simplebar-wrapper {\n  overflow: hidden;\n  width: inherit;\n  height: inherit;\n  max-width: inherit;\n  max-height: inherit;\n}\n\n.simplebar-mask {\n  direction: inherit;\n  position: absolute;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: auto !important;\n  height: auto !important;\n  z-index: 0;\n}\n\n.simplebar-offset {\n  direction: inherit !important;\n  box-sizing: inherit !important;\n  resize: none !important;\n  position: absolute;\n  top: 0;\n  left: 0 !important;\n  bottom: 0;\n  right: 0 !important;\n  padding: 0;\n  margin: 0;\n  -webkit-overflow-scrolling: touch;\n}\n\n.simplebar-content-wrapper {\n  direction: inherit;\n  box-sizing: border-box !important;\n  position: relative;\n  display: block;\n  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */\n  width: auto;\n  visibility: visible;\n  overflow: auto; /* Scroll on this element otherwise element can't have a padding applied properly */\n  max-width: 100%; /* Not required for horizontal scroll to trigger */\n  max-height: 100%; /* Needed for vertical scroll to trigger */\n  scrollbar-width: none;\n  padding: 0px !important;\n}\n\n.simplebar-content-wrapper::-webkit-scrollbar,\n.simplebar-hide-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n.simplebar-content:before,\n.simplebar-content:after {\n  content: ' ';\n  display: table;\n}\n\n.simplebar-placeholder {\n  max-height: 100%;\n  max-width: 100%;\n  width: 100%;\n  pointer-events: none;\n}\n\n.simplebar-height-auto-observer-wrapper {\n  box-sizing: inherit !important;\n  height: 100%;\n  width: 100%;\n  max-width: 1px;\n  position: relative;\n  float: left;\n  max-height: 1px;\n  overflow: hidden;\n  z-index: -1;\n  padding: 0;\n  margin: 0;\n  pointer-events: none;\n  flex-grow: inherit;\n  flex-shrink: 0;\n  flex-basis: 0;\n}\n\n.simplebar-height-auto-observer {\n  box-sizing: inherit;\n  display: block;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 1000%;\n  width: 1000%;\n  min-height: 1px;\n  min-width: 1px;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: -1;\n}\n\n.simplebar-track {\n  z-index: 1;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-content {\n  pointer-events: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-track {\n  pointer-events: all;\n}\n\n.simplebar-scrollbar {\n  position: absolute;\n  right: 2px;\n  width: 6px;\n  min-height: 10px;\n}\n\n.simplebar-scrollbar:before {\n  position: absolute;\n  content: '';\n  background: #a2adb7;\n  border-radius: 7px;\n  left: 0;\n  right: 0;\n  opacity: 0;\n  transition: opacity 0.2s linear;\n}\n\n.simplebar-scrollbar.simplebar-visible:before {\n  /* When hovered, remove all transitions from drag handle */\n  opacity: 0.5;\n  transition: opacity 0s linear;\n}\n\n.simplebar-track.simplebar-vertical {\n  top: 0;\n  width: 11px;\n}\n\n.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {\n  top: 2px;\n  bottom: 2px;\n}\n\n.simplebar-track.simplebar-horizontal {\n  left: 0;\n  height: 11px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {\n  height: 100%;\n  left: 2px;\n  right: 2px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar {\n  right: auto;\n  left: 0;\n  top: 2px;\n  height: 7px;\n  min-height: 0;\n  min-width: 10px;\n  width: auto;\n}\n\n/* Rtl support */\n[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {\n  right: auto;\n  left: 0;\n}\n\n.hs-dummy-scrollbar-size {\n  direction: rtl;\n  position: fixed;\n  opacity: 0;\n  visibility: hidden;\n  height: 500px;\n  width: 500px;\n  overflow-y: hidden;\n  overflow-x: scroll;\n}\n\n.simplebar-hide-scrollbar {\n  position: fixed;\n  left: 0;\n  visibility: hidden;\n  overflow-y: scroll;\n  scrollbar-width: none;\n}\n\n.custom-scroll {\n  height: 100%;\n}\n\n@each $color, $value in $theme-colors {\n  [data-simplebar-track=\"#{$color}\"]{\n    .simplebar-scrollbar:before{\n      background: $value;\n    }\n  }\n}","/**\n * prism.js default theme for JavaScript, CSS and HTML\n * Based on dabblet (http://dabblet.com)\n * @author Lea Verou\n */\n\ncode[class*=\"language-\"],\npre[class*=\"language-\"] {\n    color: black;\n    background: none;\n    text-shadow: 0 1px white;\n    font-family: Consolas, Monaco, \"Andale Mono\", \"Ubuntu Mono\", monospace;\n    font-size: 1em;\n    text-align: left;\n    white-space: pre;\n    word-spacing: normal;\n    word-break: normal;\n    word-wrap: normal;\n    line-height: 1.5;\n\n    -moz-tab-size: 4;\n    -o-tab-size: 4;\n    tab-size: 4;\n\n    -webkit-hyphens: none;\n    -moz-hyphens: none;\n    -ms-hyphens: none;\n    hyphens: none;\n}\n\npre[class*=\"language-\"]::-moz-selection,\npre[class*=\"language-\"] ::-moz-selection,\ncode[class*=\"language-\"]::-moz-selection,\ncode[class*=\"language-\"] ::-moz-selection {\n    text-shadow: none;\n    background: #b3d4fc;\n}\n\npre[class*=\"language-\"]::selection,\npre[class*=\"language-\"] ::selection,\ncode[class*=\"language-\"]::selection,\ncode[class*=\"language-\"] ::selection {\n    text-shadow: none;\n    background: #b3d4fc;\n}\n\n@media print {\n    code[class*=\"language-\"],\n    pre[class*=\"language-\"] {\n        text-shadow: none;\n    }\n}\n\n/* Code blocks */\npre[class*=\"language-\"] {\n    padding: 1em;\n    margin: 0;\n    overflow: auto;\n}\n\n:not(pre) > code[class*=\"language-\"],\npre[class*=\"language-\"] {\n    background: var(--#{$prefix}light) !important;\n}\n\n/* Inline code */\n:not(pre) > code[class*=\"language-\"] {\n    padding: 0.1em;\n    border-radius: 0.3em;\n    white-space: normal;\n}\n\n.token.comment,\n.token.prolog,\n.token.doctype,\n.token.cdata {\n    color: slategray;\n}\n\n.token.punctuation {\n    color: #999;\n}\n\n.token.namespace {\n    opacity: 0.7;\n}\n\n.token.property,\n.token.tag,\n.token.boolean,\n.token.number,\n.token.constant,\n.token.symbol,\n.token.deleted {\n    color: $danger;\n}\n\n.token.selector,\n.token.attr-name,\n.token.string,\n.token.char,\n.token.builtin,\n.token.inserted {\n    color: #690;\n}\n\n.token.operator,\n.token.entity,\n.token.url,\n.language-css .token.string,\n.style .token.string {\n    color: #9a6e3a;\n    /* This background color was intended by the author of this theme. */\n    background: hsla(0, 0%, 100%, 0.5);\n}\n\n.token.atrule,\n.token.attr-value,\n.token.keyword {\n    color: #07a;\n}\n\n.token.function,\n.token.class-name {\n    color: #dd4a68;\n}\n\n.token.regex,\n.token.important,\n.token.variable {\n    color: #e90;\n}\n\n.token.important,\n.token.bold {\n    font-weight: bold;\n}\n.token.italic {\n    font-style: italic;\n}\n\n.token.entity {\n    cursor: help;\n}\n\n/* Prism editor */\n:not(pre) > code[class*=\"language-\"],\npre[class*=\"language-\"] {\n    background: $gray-200;\n}\n\ncode[class*=\"language-\"],\npre[class*=\"language-\"] {\n    color: $gray-600;\n    text-shadow: none;\n}\n\n\n\n// Scrollbar\n\n.language-markup {\n    &::-webkit-scrollbar {\n        -webkit-appearance: none;\n    }\n\n    &::-webkit-scrollbar:vertical {\n        width: 10px;\n    }\n\n    &::-webkit-scrollbar:horizontal {\n        height: 10px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: rgba(var(--#{$prefix}body-color-rgb), .1);\n        border-radius: 10px;\n        border: 2px solid var(--#{$prefix}light)\n    }\n\n    &::-webkit-scrollbar-track {\n        border-radius: 10px;\n        background-color: var(--#{$prefix}light)\n    }\n}\n\n\n// Scroll-top\n\n#scroll-top {\n    width: 30px;\n    height: 30px;\n    position: fixed;\n    bottom: 65px;\n    right: 30px;\n    background: #343a40;\n    border-color: transparent;\n    border-radius: 3px;\n    color: #ffffff;\n    transition: all 0.5s ease;\n}\n\n// Toolbar (Copy button)\n\n.btn-clipboard {\n    position: absolute !important;\n    right: 15px !important;\n    z-index: 1 !important;\n}\n\ndiv.code-toolbar > .toolbar {\n    opacity: 1 !important;\n    button {\n        display: inline-block !important;\n        margin: 0.375rem 0.5rem !important;\n        padding: 0.25rem 0.75rem !important;\n        transition: $btn-transition !important;\n        border-radius: $border-radius-sm !important;\n        border: $border-width solid rgba($primary, 0.35) !important;\n        background-color: transparent;\n        color: $primary !important;\n        box-shadow: none !important;\n        &:focus {\n            outline: none !important;\n            box-shadow: none !important;\n        }\n        &:hover {\n            background-color: $primary !important;\n            color: $white !important;\n        }\n    }\n}\n","\n//\n//  _sweetalert2.scss\n//\n\n.swal2-container {\n  .swal2-title{\n    padding: 24px 24px 0;\n    font-size: 20px;\n    font-weight: $font-weight-medium;\n  }  \n}\n\n.swal2-popup{\n  padding-bottom: 24px;\n  border-radius: $modal-content-border-radius;\n  background-color: var(--#{$prefix}secondary-bg);\n  color: var(--#{$prefix}body-color);\n\n  .swal2-title{\n    color: var(--#{$prefix}heading-color);\n  }\n\n  .swal2-html-container{\n    color: var(--#{$prefix}body-color);\n  }\n}\n\n.swal2-footer{\n  border-top: 1px solid var(--#{$prefix}border-color);\n  color: var(--#{$prefix}body-color);\n}\n\n.swal2-html-container{\n  font-size: 16px;\n}\n\n.swal2-icon{\n  &.swal2-question{\n    border-color: $info;\n    color: $info;\n  }\n  &.swal2-success {\n    [class^=swal2-success-line]{\n      background-color: $success;\n    }\n\n    .swal2-success-ring{\n      border-color: rgba($success, 0.3);\n    }\n  }\n  &.swal2-warning{\n    border-color: $warning;\n    color: $warning;\n  }\n}\n\n.swal2-styled{\n  &:focus{\n    box-shadow: none;\n  }\n}\n\n.swal2-loader{\n  border-color: $primary transparent $primary transparent;\n}\n\n.swal2-timer-progress-bar{\n  background-color: rgba($success, 0.4);\n}\n\n.swal2-progress-steps {\n  .swal2-progress-step{\n    background: $primary;\n    &.swal2-active-progress-step{\n      background: $primary;\n      &~.swal2-progress-step, &~.swal2-progress-step-line{\n        background: rgba($primary, 0.3);\n      }\n    }\n  }\n  .swal2-progress-step-line{\n    background: $primary;\n  }\n}\n\n.swal2-actions.swal2-loading{\n  .swal2-styled.swal2-confirm{\n    border-left-color: $primary !important;\n    border-right-color: $primary !important;\n  }\n}\n\n.swal2-file, .swal2-input, .swal2-textarea{\n  border: 1px solid $input-border-color;\n  &:focus{\n    box-shadow: none;\n    border-color: $input-focus-border-color;\n  }\n}\n\n.swal2-input{\n  height: auto;\n  display: block;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n}\n\n.swal2-close{\n  font-family: $font-family-base;\n  font-weight: $font-weight-light;\n  font-size: 28px;\n  &:focus{\n    box-shadow: none;\n  }\n\n  &:hover{\n    color: $primary;\n  }\n}\n\n.swal2-validation-message{\n  background-color: transparent;\n}","//\n// Dropzone\n//\n\n\n.dropzone {\n  min-height: 230px;\n  border: 2px dashed var(--#{$prefix}border-color);\n  background: var(--#{$prefix}secondary-bg);\n  border-radius: 6px;\n\n  .dz-message {\n    font-size: 24px;\n    width: 100%;\n    margin: 1em 0;\n  }\n}\n","\n//\n// _range-slider.scss\n//\n\n.noUi-connect{\n  background: $success;\n}\n\n.noUi-handle{\n  background: $success;\n  border: 2px solid var(--#{$prefix}card-bg);\n  box-shadow: none;\n}\n\n.noUi-horizontal{\n  height: 4px;\n  .noUi-handle{\n    height: 16px;\n    width: 16px;\n    border-radius: 50%;\n    right: -10px !important;\n    top: -7px;\n\n    &::before, &::after{\n      display: none;\n    }\n    &:focus{\n      outline: 0;\n    }\n  }\n}\n\n.noUi-pips-horizontal{\n  height: 50px;\n}\n\n// tooltip\n\n.noUi-tooltip{\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  border-color: var(--#{$prefix}border-color);\n  border-radius: $tooltip-border-radius;\n  background-color: var(--#{$prefix}secondary-bg);\n  color: var(--#{$prefix}body-color);\n}\n\n// Vertical Slider\n\n.noUi-vertical{\n  width: 4px;\n  .noUi-handle{\n    height: 16px;\n    width: 16px;\n    right: -8px;\n    top: -12px;\n    left: auto;\n    border-radius: 50%;\n    &::before, &::after{\n      display: none;\n    }\n    &:focus{\n      outline: 0;\n    }\n  }\n\n  .noUi-origin{\n    top: 0;\n  }\n}\n\n.noUi-value{\n  font-size: 12px;\n}\n\n.noUi-marker-horizontal{\n  &.noUi-marker-large{\n    height: 12px;\n  }\n}\n\n.noUi-value-horizontal{\n  padding-top: 4px;\n}\n\n.noUi-target{\n  box-shadow: none;\n  background-color: var(--#{$prefix}light);\n  border-color: var(--#{$prefix}light);\n}\n\n.noUi-touch-area{\n  &:focus{\n    outline: 0;\n  }\n}\n\n// Colorpicker\n\n#red, #green, #blue {\n\tmargin: 10px;\n\tdisplay: inline-block;\n\theight: 200px;\n}\n\n#colorpicker {\n\theight: 240px;\n\twidth: 310px;\n\tmargin: 0 auto;\n\tpadding: 10px;\n\tborder: 1px solid var(--#{$prefix}border-color);\n}\n\n#result {\n\tmargin: 60px 26px;\n\theight: 100px;\n\twidth: 100px;\n\tdisplay: inline-block;\n\tvertical-align: top;\n\tborder: 1px solid var(--#{$prefix}border-color);\n    box-shadow: 0 0 3px;\n    border-radius: 7px;\n}\n\n#red {\n    .noUi-connect {\n        background: $danger;\n    }\n}\n\n#green {\n    .noUi-connect {\n        background: $success;\n    }\n}\n\n#blue {\n    .noUi-connect {\n        background: $primary;\n    }\n}\n\n// Adding keyboard support\n\n.form-control{\n    &.keyboard{\n        max-width: 340px !important;\n    }\n}\n\n\n// Non linear slider\n\n.example-val{\n    font-size: 12px;\n    color: var(--#{$prefix}secondary-color);\n    display: block;\n    margin: 15px 0;\n    &:before{\n        content: \"Value: \";\n        font-size: 12px;\n        font-weight: 600;\n    }\n}\n\n// showing tooltips\n\n.noUi-tooltip {\n    display: none;\n}\n.noUi-active .noUi-tooltip {\n    display: block;\n}\n\n// Colored Connect Elements\n\n.c-1-color { background: $danger; }\n.c-2-color { background: $warning; }\n.c-3-color { background: $success; }\n.c-4-color { background: $primary; }\n.c-5-color { background: $purple; }\n\n//  slider togle\n\n#slider-toggle {\n    height: 50px;\n    &.off{\n        .noUi-handle{\n            border-color: $danger;\n        }\n    }\n}\n\n.noUi-marker {\n  background-color: var(--#{$prefix}border-color);\n}\n\n.noUi-pips {\n  color: var(--#{$prefix}body-color);\n}\n\n// rangeslider color\n\n@each $color, $value in $theme-colors {\n  [data-slider-color=\"#{$color}\"] {\n    .noUi-connect{\n      background: $value;\n    }\n\n    .noUi-handle{\n      background: $value;\n    }\n\n    &[data-slider-style=\"border\"], &[data-slider-style=\"square\"]{\n      .noUi-handle{\n        border-color: $value;\n      }\n    }\n  }\n}\n\n// rangeslider sizes\n\n[data-slider-size=\"lg\"]{\n  &.noUi-horizontal{\n    height: 12px;\n\n    .noUi-handle{\n      width: 24px;\n      height: 24px;\n    }\n  }\n}\n\n[data-slider-size=\"md\"]{\n  &.noUi-horizontal{\n    height: 8px;\n\n    .noUi-handle{\n      width: 20px;\n      height: 20px;\n    }\n  }\n}\n\n[data-slider-size=\"sm\"]{\n  &.noUi-horizontal{\n    height: 4px;\n\n    .noUi-handle{\n      width: 16px;\n      height: 16px;\n    }\n  }\n}\n\n// rangeslider style\n\n[data-slider-style=\"line\"]{\n  &.noUi-horizontal .noUi-handle{\n    width: 8px;\n    border-radius: 4px;\n    right: -8px;\n  }\n  &.noUi-vertical .noUi-handle{\n    height: 8px;\n    border-radius: 4px;\n    top: -3px;\n  }\n}\n\n[data-slider-style=\"border\"]{\n  .noUi-handle{\n    border-color: $success;\n    background-color: $card-bg;\n  }\n}\n\n[data-slider-style=\"square\"]{\n  .noUi-handle{\n    border-radius: 0px;\n    transform: rotate(45deg);\n    height: 10px;\n    width: 10px;\n    top: -4px;\n    border-color: $success;\n    background-color: $card-bg;\n  }\n}\n\n","// \n// _sortablejs.scss\n// \n\n\n.nested-list{\n    .list-group-item{\n        background-color: rgba($primary, 0.05);\n        border-color: rgba($primary, 0.05);\n    }\n}\n\n.nested-list, .nested-1, .nested-2, .nested-3{\n    margin-top: 5px;\n}\n\n\n.nested-sortable-handle{\n    .handle{\n        position: absolute;\n        left: 0;\n        top: 0;\n        width: 42px;\n        height: 42px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: grab;\n    }\n    .list-group-item{\n        padding-left: 42px;\n    }\n}","// \n// tour.scss\n// \n\n.shepherd-element{\n    background: var(--#{$prefix}secondary-bg);\n    box-shadow: $box-shadow;\n}\n\n.shepherd-has-title{\n    .shepherd-content{\n        .shepherd-header{\n            background-color: var(--#{$prefix}light);\n            padding: $toast-padding-y $toast-padding-x;\n        }\n\n        .shepherd-cancel-icon{\n            color: rgba(var(--#{$prefix}body-color-rgb), .75);\n            &:hover{\n                color: rgba(var(--#{$prefix}body-color-rgb), 1);\n            }\n        }\n    }\n}\n\n.shepherd-element.shepherd-has-title[data-popper-placement^=bottom]>.shepherd-arrow:before{\n    background-color: var(--#{$prefix}light);\n}\n\n.shepherd-title{\n    font-size: 15px;\n    font-weight: $font-weight-medium;\n    color: var(--#{$prefix}body-color);\n}\n\n.shepherd-text{\n    padding: $toast-padding-x;\n    font-size: $font-size-base;\n    color: var(--#{$prefix}body-color);\n}\n\n.shepherd-button{\n    &.btn-success:not(:disabled):hover{\n        background: darken($success, 2.5%);\n        color: $white;\n    }\n\n    &.btn-light:not(:disabled):hover{\n        background: rgba(var(--#{$prefix}light-rgb), .75);\n        color: var(--#{$prefix}body-color);\n    }\n\n    &.btn-primary:not(:disabled):hover{\n        background: darken($primary, 2.5%);\n        color: $white;\n    }\n}\n\n.shepherd-footer{\n    padding: 0 $toast-padding-x $toast-padding-x;\n}\n.shepherd-arrow,\n.shepherd-arrow:before{\n    content: \"\\ea75\";\n    font-family: 'remixicon';\n    font-size: 24px;\n    z-index: 1;\n    background-color: transparent !important;\n    transform: rotate(0deg);\n    color: var(--#{$prefix}primary);\n}\n\n.shepherd-element[data-popper-placement^=bottom]>.shepherd-arrow{\n    top: -18px;\n}\n\n.shepherd-button{\n    margin-right: 0.5rem;\n}","//\n// _swiper.scss\n//\n\n.swiper-button-next,\n.swiper-button-prev {\n    height: 32px !important;\n    width: 32px !important;\n    background-color: rgba($primary, 0.2);\n    backdrop-filter: blur(2px);\n    border-radius: 8px;\n\n    &::after {\n        font-family: remixicon !important;\n        font-size: 28px !important;\n        color: rgba($primary, 1);\n        transition: all 0.3s ease;\n    }\n}\n\n.swiper-button-prev {\n    &::after {\n        content: \"\\ea64\" !important;\n    }\n}\n\n.swiper-button-next {\n    &::after {\n        content: \"\\ea6e\" !important;\n    }\n}\n\n.swiper-pagination-bullet {\n    width: 22px !important;\n    height: 5px !important;\n    background-color: $white !important;\n    border-radius: 50px !important;\n    box-shadow: $element-shadow !important;\n\n    .swiper-pagination-bullet-active {\n        opacity: 1 !important;\n    }\n}\n\n.dynamic-pagination {\n    .swiper-pagination-bullet {\n        width: 8px !important;\n        height: 8px !important;\n        background-color: $white;\n        opacity: 0.5;\n        transition: all 0.5s ease;\n\n        &.swiper-pagination-bullet-active {\n            opacity: 1;\n            width: 20px;\n        }\n    }\n}\n\n.swiper-pagination-fraction {\n    color: $white;\n    font-size: 16px;\n    background-color: rgba($black, 0.3);\n    backdrop-filter: blur(2px);\n}\n\n\n.pagination-custom {\n    .swiper-pagination-bullet {\n        height: 25px;\n        width: 25px;\n        line-height: 25px;\n        border-radius: 8px;\n        background-color: $white;\n        opacity: 0.5;\n        transition: all 0.5s ease;\n\n        &.swiper-pagination-bullet-active {\n            color: $secondary;\n            opacity: 1;\n        }\n    }\n}\n\n.swiper-pagination-progressbar {\n    height: 6px !important;\n    background-color: rgba($success, 0.25);\n\n    .swiper-pagination-progressbar-fill {\n        background-color: $success;\n    }\n}\n\n\n.swiper-scrollbar {\n    background-color: rgba($white, 0.35);\n    backdrop-filter: blur(2px);\n    padding: 1.2px;\n    height: 6px !important;\n\n    .swiper-scrollbar-drag {\n        background-color: $white;\n    }\n}\n\n.swiper-pagination-dark {\n    .swiper-pagination-bullet {\n        background-color: $secondary !important;\n    }\n\n    .dynamic-pagination {\n        .swiper-pagination-bullet {\n            background-color: $secondary !important;\n        }\n    }\n\n    &.pagination-custom {\n        .swiper-pagination-bullet {\n            color: $white;\n\n            &.swiper-pagination-bullet-active {\n                opacity: 1;\n            }\n        }\n    }\n\n    &.swiper-scrollbar {\n        background-color: rgba($dark, 0.35);\n    }\n}","\n//\n// _multijs.scss\n//\n\n.multi-wrapper{\n  border: none;\n  position: relative;\n\n  &::before{\n    content: \"\\ea61\";\n    position: absolute;\n    font-family: \"remixicon\";\n    left: 50%;\n    transform: translateX(-50%);\n    bottom: 86px;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 16px;\n    border-radius: 50%;\n    color: var(--#{$prefix}secondary-color);\n    background-color: var(--#{$prefix}light);\n    z-index: 1;\n  }\n  \n  .non-selected-wrapper{\n    border: 1px solid $input-border-color;\n    background-color: $input-bg;\n    border-top-left-radius: $border-radius;\n    border-bottom-left-radius: $border-radius;\n  }\n\n  .selected-wrapper, .non-selected-wrapper{\n    &::-webkit-scrollbar {\n      -webkit-appearance: none;\n    }\n  \n    &::-webkit-scrollbar:vertical {\n      width: 10px;\n    }\n  \n    &::-webkit-scrollbar:horizontal {\n      height: 9px;\n    }\n  \n    &::-webkit-scrollbar-thumb {\n      background-color: rgba(var(--#{$prefix}dark-rgb), .2);\n      border-radius: 10px;\n      border: 2px solid $input-bg;\n    }\n  \n    &::-webkit-scrollbar-track {\n      border-radius: 10px;  \n      background-color: $input-bg; \n    }\n}\n\n  .item-group .group-label{\n    font-size: 12px;\n  }\n\n  .item{\n    color: $input-color;\n    &:hover{\n      background-color: rgba($primary, 0.1);\n    }\n  }\n\n  .selected-wrapper{\n    border: 1px solid $input-border-color;\n    background: $input-bg;\n    border-top-right-radius: $border-radius;\n    border-bottom-right-radius: $border-radius;\n  }\n\n  .search-input{\n    flex: 0 0 auto;\n    padding: $input-padding-y $input-padding-x;\n    font-family: $input-font-family;\n    font-size: $input-font-size;\n    color: $input-color;\n    background-color: $input-bg;\n    border: $input-border-width solid $input-border-color;\n    border-radius: $input-border-radius;\n    margin-bottom: 16px;\n    &::placeholder{\n      color: $input-placeholder-color;\n    }\n  }\n\n  .header{\n    font-weight: $font-weight-semibold;\n    color: var(--#{$prefix}gray-600);\n  }\n}","//\n// _colorpicker.scss\n//\n\n.pcr-app{\n  background: var(--#{$prefix}secondary-bg);\n  box-shadow: $box-shadow-lg;\n  border-radius: 4px;\n  border: 1px solid var(--#{$prefix}border-color);\n}\n\n.pickr{\n  .pcr-button{\n    border: 4px solid var(--#{$prefix}secondary-bg);\n    box-shadow: 0px 0px 0 2px var(--#{$prefix}border-color);\n    border-radius: 50%;\n    box-shadow: $element-shadow;\n    &::after, &::before{\n      border-radius: 50%;\n    }\n  }\n}\n\n.pcr-app{\n  &[data-theme=classic]{\n    .pcr-selection {\n      .pcr-color-preview{\n        margin-right: .75em;\n        margin-left: 0;\n      }\n  \n      .pcr-color-chooser, .pcr-color-opacity{\n        margin-left: .75em;\n        margin-right: 0;\n      }\n    }\n  }\n\n  &[data-theme=\"monolith\"]{\n    .pcr-result{\n      min-width: 100%;\n    }\n  }\n\n  .pcr-interaction{\n    .pcr-type.active{\n      background: $primary;\n    }\n\n    .pcr-result{\n      background-color: $input-bg;\n      color: $input-color;\n      border: 1px solid $input-border-color;\n      border-radius: $input-border-radius;\n    }\n\n    input{\n      border-radius: $input-border-radius !important;\n      &:focus{\n        box-shadow: none;\n        background-color: $input-focus-bg;\n        border-color: $input-focus-border-color;\n      }\n    }\n\n    .pcr-save{\n      background: $success !important;\n    }\n\n    .pcr-clear, .pcr-cancel{\n      background: $danger !important;\n    }\n  }\n}","//\n// filepond\n//\n\n.filepond--root{\n  margin-bottom: 0;\n\n  &[data-style-panel-layout~=circle]{\n    .filepond--drop-label label{\n      font-size: 14px;\n    }\n  }\n}\n\n.filepond--panel-root{\n  border: 2px dashed var(--#{$prefix}border-color);\n  background: var(--#{$prefix}light-bg);\n}\n\n.filepond--drop-label {\n  color: var(--#{$prefix}body-color);\n  label{\n    font-weight: $font-weight-medium;\n  }\n}\n\n.filepond--credits {\n  display: none;\n}\n\n.filepond--item-panel {\n  background-color: $primary !important;\n}","//\n// _form-input-spin.scss\n//\n\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    height: auto;\n}\n\n.input-step {\n    border: 1px solid $input-border-color;\n    display: inline-flex;\n    overflow: visible;\n    height: 37.5px;\n    @include border-radius($input-border-radius, 0);\n    background: $input-bg;\n    padding: 4px;\n\n    input {\n        width: 4em;\n        height: 100%;\n        text-align: center;\n        border: 0;\n        background: transparent;\n        color: $input-color;\n        border-radius: $input-border-radius;\n\n        &:focus-visible {\n            outline: 0;\n        }\n    }\n\n    button {\n        width: 1.4em;\n        font-weight: 300;\n        height: 100%;\n        line-height: 0.1em;\n        font-size: 1.4em;\n        padding: 0.2em !important;\n        background: var(--#{$prefix}light);\n        color: var(--#{$prefix}body-color);\n        border: none;\n        border-radius: $btn-border-radius;\n    }\n\n    &.light {\n        background: var(--#{$prefix}light);\n\n        button {\n            background-color: $input-bg;\n        }\n    }\n\n    &.light-input {\n        background: var(--#{$prefix}light);\n\n        input {\n            background-color: $input-bg;\n        }\n    }\n\n    &.full-width {\n        display: flex;\n        width: 100%;\n\n        button {\n            flex-shrink: 0;\n        }\n\n        input {\n            flex-grow: 1;\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .input-step {\n        &.step-#{$color} {\n            button {\n                background-color: $value;\n                color: $white;\n            }\n        }\n    }\n}","//\n// _ckeditor.scss\n//\n\n.ck {\n    font-family: $font-family-base !important;\n\n    &.ck-reset_all, &.ck-reset_all *{\n        color: var(--#{$prefix}body-color) !important;\n    }\n    &.ck-toolbar{\n        background: #{rgba(var(--#{$prefix}light-rgb), .75)} !important;\n    }\n\n    p {\n        margin-bottom: 0;\n    }\n\n    &.ck-toolbar {\n        border: 1px solid $input-border-color !important;\n\n        &.ck-toolbar_grouping>.ck-toolbar__items {\n            flex-wrap: wrap !important;\n        }\n\n        .ck.ck-toolbar__separator {\n            background: transparent !important;\n        }\n    }\n\n    &.ck-editor__main>.ck-editor__editable {\n        border-top: 0 !important;\n        background-color: var(--#{$prefix}secondary-bg) !important;\n        border-color: $input-border-color !important;\n        box-shadow: none !important;\n    }\n\n    &.ck-dropdown__panel{\n        background: var(--#{$prefix}secondary-bg) !important;\n        box-shadow: $box-shadow-lg;\n        animation-name: DropDownSlide;\n        animation-duration: .3s;\n        animation-fill-mode: both;\n        border-radius: $dropdown-border-radius;\n    }\n\n    &.ck-list {\n        background: var(--#{$prefix}secondary-bg) !important;\n    }\n\n    &.ck-dropdown {\n        .ck-dropdown__panel {\n            &.ck-dropdown__panel_ne,\n            &.ck-dropdown__panel_se {\n                left: 0;\n                right: auto !important;\n            }\n        }\n    }\n\n    &.ck-editor__editable_inline {\n        &[dir=ltr] {\n            text-align: left !important;\n        }\n    }\n\n    &.ck-dropdown__panel {\n        box-shadow: $dropdown-box-shadow !important;\n        border-radius: $dropdown-border-radius !important;\n        border: 1px solid $dropdown-border-color !important;\n    }\n}\n\n.ck.ck-button, \na.ck.ck-button{\n\n    &:focus, &:active{\n        box-shadow: none !important;\n        border: 1px solid var(--#{$prefix}light) !important;\n    }\n\n    &:not(.ck-disabled){\n        &:hover{\n            background: var(--#{$prefix}light) !important;\n        }\n    }\n\n    &.ck-on{\n        background: var(--#{$prefix}light) !important;\n    }\n}\n\n.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar, \n.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{\n    border-radius: $border-radius !important;\n    border-bottom-left-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n}\n\n.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable, \n.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{\n    border-radius: $border-radius !important;\n    border-top-left-radius: 0 !important;\n    border-top-right-radius: 0 !important;\n}\n\n.ck-editor__editable {\n    min-height: 245px !important;\n}\n\n.ck[class*=ck-heading_heading] {\n    font-weight: $font-weight-medium !important;\n}\n\n.ck,\na.ck {\n    &.ck-button {\n        &.ck-on:not(.ck-disabled) {\n            &:hover,\n            &:active {\n                box-shadow: none !important;\n            }\n        }\n    }\n}\n\n.ck{\n    &.ck-tooltip{\n        .ck-tooltip__text {\n            background: $dark !important;\n            color: $light !important;\n        }\n    }\n\n    &.ck-input-text{\n        background: $input-bg !important;\n        border: 1px solid $input-border-color !important;\n        &:focus{\n            border: 1px solid $input-focus-border-color !important;\n            box-shadow: none !important;\n        }\n    }\n\n    &.ck-balloon-panel{\n        background: $dropdown-bg !important;\n        border: 1px solid $dropdown-border-color !important;\n\n        &[class*=arrow_n]{\n            &:after{\n                border-bottom-color: $dropdown-bg !important;\n            }\n\n            &::before{\n                border-bottom-color: $dropdown-border-color !important;\n            }\n        }\n    }\n}\n\n\n\n.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{\n    background: $dropdown-bg !important;\n}\n\n// ck-editor-reverse\n\n.ck-editor-reverse{\n    .ck-editor{\n      display: flex;\n      flex-direction: column-reverse;\n    }\n  \n    .ck{\n      &.ck-editor__main>.ck-editor__editable{\n        border: 1px solid $input-border-color !important;\n        border-bottom: 0 !important;\n      }\n    }\n  \n    .ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable, \n    .ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{\n      border-radius: $border-radius !important;\n      border-bottom-left-radius: 0 !important;\n      border-bottom-right-radius: 0 !important;\n    }\n  \n    .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar, \n    .ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{\n      border-radius: $border-radius !important;\n      border-top-left-radius: 0 !important;\n      border-top-right-radius: 0 !important;\n    }\n}\n\n[dir=\"rtl\"] {\n    .ck.ck-toolbar>.ck-toolbar__items {\n        flex-direction: row-reverse;\n    }\n}","//\n// _quilljs.scss\n//\n\n.ql-editor {\n    text-align: left;\n\n    ol,\n    ul {\n        padding-left: 1.5em;\n        padding-right: 0;\n    }\n\n    li:not(.ql-direction-rtl)::before {\n        margin-left: -1.5em;\n        margin-right: 0.3em;\n        text-align: right;\n    }\n}\n\n.ql-container {\n    font-family: $font-family-base;\n\n    &.ql-snow {\n        border-color: $input-border-color;\n        border-bottom-left-radius: 4px;\n        border-bottom-right-radius: 4px;\n    }\n}\n\n.ql-bubble {\n    border: $input-border-width solid $input-border-color;\n    border-radius: $input-border-radius;\n}\n\n.ql-toolbar {\n    font-family: $font-family-base !important;\n\n    span {\n        outline: none !important;\n        color: var(--#{$prefix}body-color);\n\n        &:hover {\n            color: $primary !important;\n        }\n    }\n\n    &.ql-snow {\n        border-top-left-radius: 4px;\n        border-top-right-radius: 4px;\n        border-color: $input-border-color;\n\n        .ql-picker.ql-expanded {\n            .ql-picker-label {\n                border-color: transparent;\n            }\n        }\n\n        .ql-picker-options {\n            box-shadow: $dropdown-box-shadow;\n            border-radius: $dropdown-border-radius;\n        }\n    }\n}\n\n.ql-snow {\n\n    .ql-stroke,\n    .ql-script,\n    .ql-strike svg {\n        stroke: var(--#{$prefix}body-color);\n    }\n\n    .ql-fill {\n        fill: var(--#{$prefix}body-color);\n    }\n\n    .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) {\n        svg {\n            right: 0;\n            left: auto;\n        }\n    }\n\n    .ql-picker {\n        &.ql-expanded .ql-picker-label {\n            color: var(--#{$prefix}secondary-color);\n        }\n    }\n}\n\n.ql-snow {\n    .ql-picker-options {\n        background-color: var(--#{$prefix}secondary-bg);\n        border-color: var(--#{$prefix}border-color) !important;\n    }\n}","// \n// _gridjs.scss\n// \n\n.gridjs-container {\n    color: $table-color;\n    padding: 0;\n    display: block;\n}\n\n.gridjs-wrapper {\n    box-shadow: none;\n    border: 1px solid $table-border-color;\n    border-radius: 0px;\n\n    &::-webkit-scrollbar {\n        -webkit-appearance: none;\n    }\n\n    &::-webkit-scrollbar:vertical {\n        width: 12px;\n    }\n\n    &::-webkit-scrollbar:horizontal {\n        height: 12px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: rgba(var(--#{$prefix}dark-rgb), .075);\n        border-radius: 10px;\n        border: 2px solid var(--#{$prefix}secondary-bg);\n    }\n\n    &::-webkit-scrollbar-track {\n        border-radius: 10px;\n        background-color: var(--#{$prefix}secondary-bg);\n    }\n}\n\n.gridjs-footer {\n    border: none !important;\n    padding: 12px 0 0;\n}\n\n.gridjs-table {\n    width: 100%;\n}\n\n.gridjs-tbody, td.gridjs-td{\n    background-color: $table-bg;\n}\n\nth.gridjs-th,\ntd.gridjs-td {\n    border: 1px solid $table-border-color;\n    padding: $table-cell-padding-y $table-cell-padding-x;\n}\n\nth {\n    &.gridjs-th {\n        border-top: 0;\n        color: $table-color;\n        background-color: rgba(var(--#{$prefix}light-rgb), .75);\n\n    }\n\n    &.gridjs-th-sort {\n\n        &:focus,\n        &:hover {\n            background-color: rgba(var(--#{$prefix}light-rgb), .85);\n        }\n    }\n}\n\n.gridjs-head{\n    padding-top: 0;\n}\n\n.gridjs-footer {\n    box-shadow: none;\n    border: 1px solid $table-border-color;\n    border-top: 0;\n    background-color: $table-bg;\n}\n\n.gridjs-summary {\n    color: var(--#{$prefix}secondary-color);\n    margin-top: 8px !important;\n}\n\n.gridjs-pagination {\n\n    .gridjs-pages button {\n        margin-left: 0.3rem;\n        border-radius: $border-radius !important;\n        border: 1px solid $pagination-border-color;\n        background-color: $pagination-bg;\n        color: $pagination-color;\n\n        &:last-child{\n            border-right: 1px solid $pagination-border-color;\n        }\n\n        &:disabled,\n        &:hover:disabled,\n        &[disabled] {\n            color: $pagination-disabled-color;\n            background-color: $pagination-bg;\n        }\n\n        &:hover {\n            background-color: $pagination-hover-bg;\n            color: $pagination-hover-color;\n        }\n\n        &:focus {\n            box-shadow: none;\n        }\n\n        &:last-child,\n        &:first-child {\n            &:hover {\n                background-color: transparent;\n            }\n        }\n\n        &.gridjs-currentPage {\n            background-color: $pagination-active-bg;\n            color: $pagination-active-color;\n            border-color: $pagination-active-border-color;\n            font-weight: $font-weight-medium;\n        }\n    }\n}\n\n.gridjs-search {\n    position: relative;\n    float: left;\n\n    &::before {\n        content: \"\\f0d1\";\n        font-family: \"remixicon\";\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        left: 10px;\n        font-size: 14px;\n        color: var(--#{$prefix}secondary-color);\n    }\n}\n\ninput.gridjs-input {\n    border-color: $input-border-color;\n    background-color: $input-bg;\n    color: $input-color;\n    line-height: $input-line-height;\n    padding: $input-padding-y $input-padding-x $input-padding-y $input-padding-x*2.25;\n    border-radius: $input-border-radius;\n    @include font-size($input-font-size);\n\n    &:focus {\n        box-shadow: none;\n        border-color: $input-focus-border-color;\n        background-color: $input-focus-bg;\n    }\n\n    &::placeholder{\n        color: $input-placeholder-color;\n    }\n}\n\nth.gridjs-th {\n    .gridjs-th-content {\n        float: none;\n        display: inline-block;\n        vertical-align: middle;\n        font-weight: $font-weight-semibold;\n    }\n}\n\nbutton.gridjs-sort {\n    float: none;\n    display: inline-block;\n    vertical-align: middle;\n    width: 10px;\n    height: 20px;\n}\n\nth.gridjs-th-sort .gridjs-th-content {\n    width: calc(100% - 10px);\n}\n\nbutton{\n    &.gridjs-sort-asc, &.gridjs-sort-desc{\n        background-size: 7px;\n    }\n}\n\n\n// card table\n\n.table-card{\n\n    .gridjs-head{\n        padding: 16px 16px 5px;\n    }\n\n    .gridjs-wrapper{\n        border-top: 0;\n        border-radius: 0;\n        border-width: 1px 0;\n    }\n\n    .gridjs-footer{\n        padding: 8px 16px;\n    }\n}\n\n// gridjs selection\n.gridjs-tr-selected {\n    td{\n        background-color: $table-active-bg;\n    }\n    .gridjs-td .gridjs-checkbox[type=checkbox]{\n        background-color: $form-check-input-checked-bg-color;\n        border-color: $form-check-input-checked-border-color;\n        @if $enable-gradients {\n            background-image: escape-svg($form-check-input-checked-bg-image), var(--#{$prefix}gradient);\n          } @else {\n            background-image: escape-svg($form-check-input-checked-bg-image);\n          }\n    }\n}\n.gridjs-td{\n    .gridjs-checkbox{\n        width: $form-check-input-width;\n        height: $form-check-input-width;\n        vertical-align: top;\n        background-color: $form-check-input-bg;\n        background-repeat: no-repeat;\n        background-position: center;\n        background-size: contain;\n        border: $form-check-input-border;\n        appearance: none;\n        print-color-adjust: exact; // Keep themed appearance for print\n        @include transition($form-check-transition);\n        &[type=\"checkbox\"] {\n          @include border-radius($form-check-input-border-radius);\n        }\n    }\n}\n\n.gridjs-border-none{\n    td.gridjs-td, th.gridjs-th{\n        border-right-width: 0;\n        border-left-width: 0;\n    }\n}\n\n.gridjs-loading-bar {\n    background-color: var(--#{$prefix}secondary-bg);\n}\n\n[data-bs-theme=\"dark\"] {\n    button {\n        &:is(.gridjs-sort-neutral, .gridjs-sort-asc, .gridjs-sort-desc) {\n            filter: $btn-close-white-filter;\n        }\n    }\n}","// \n// _listjs.scss\n// \n\n.listjs-pagination{\n    margin-bottom: 0;\n    justify-content: flex-end;\n    gap: 8px;\n    li{\n        .page{\n            display: block;\n            padding: $pagination-padding-y $pagination-padding-x;\n            color: $pagination-color;\n            background-color: $pagination-bg;\n            border: $pagination-border-width solid $pagination-border-color;\n            border-radius: $border-radius;\n        }\n\n        &.active{\n            .page{\n                color: $pagination-active-color;\n                @include gradient-bg($pagination-active-bg);\n                border-color: $pagination-active-border-color;\n            }\n        }\n    }\n}\n\n.pagination-wrap {\n    user-select: none;\n    display: flex;\n    align-items: center;\n    a {\n        text-decoration: none;\n        display: inline-block;\n    }\n}\n\n.pagination-next,\n.pagination-prev {\n    color: $primary;\n    font-weight: $font-weight-medium;\n    padding: $pagination-padding-y $pagination-padding-x;\n    background-color: $pagination-bg;\n    border: $pagination-border-width solid $pagination-border-color;\n    border-radius: $border-radius; \n    &:hover {\n        color: lighten($primary, 20%);\n    }\n\n    &.disabled {\n        color: var(--#{$prefix}secondary-color);\n        cursor: default;\n\n        &:hover {\n            color: var(--#{$prefix}secondary-color);\n        }\n    }\n}","//\n// apexcharts.scss\n//\n\n.apex-charts {\n    min-height: 10px !important;\n\n    text {\n        font-family: $font-family-base !important;\n    }\n\n    .apexcharts-canvas {\n        margin: 0 auto;\n    }\n}\n\n\n@keyframes opaque {\n    0% {\n        opacity: 0\n    }\n\n    to {\n        opacity: 1\n    }\n}\n\n@keyframes resizeanim {\n\n    0%,\n    to {\n        opacity: 0\n    }\n}\n\n.apexcharts-canvas {\n    position: relative;\n    user-select: none;\n\n    ::-webkit-scrollbar {\n        -webkit-appearance: none;\n        width: 6px;\n    }\n\n    ::-webkit-scrollbar-thumb {\n        border-radius: 4px;\n        background-color: rgba(0, 0, 0, .5);\n        box-shadow: 0 0 1px rgba(255, 255, 255, .5);\n    }\n\n    :is(.apexcharts-reset-zoom-icon, .apexcharts-selection-icon, .apexcharts-zoom-icon) {\n        &.apexcharts-selected {\n            svg {\n                fill: var(--#{$prefix}primary);\n            }\n        }\n    }\n\n    @media screen and (min-width:768px) {\n        &:hover {\n            .apexcharts-toolbar {\n                opacity: 1\n            }\n        }\n    }\n}\n\n.apexcharts-inner {\n    position: relative;\n}\n\n.apexcharts-gridline {\n    pointer-events: none;\n    stroke: rgba(var(--#{$prefix}light-rgb), 1);\n}\n\n.apexcharts-text tspan {\n    font-family: inherit;\n}\n\n.apexcharts-yaxis,\n.apexcharts-xaxis {\n    text {\n        font-family: $font-family-base !important;\n        fill: $gray-600;\n    }\n}\n\n.apexcharts-title-text,\n.apexcharts-subtitle-text {\n    fill: $gray-500;\n}\n\n.legend-mouseover-inactive {\n    transition: .15s ease all;\n    opacity: .2;\n}\n\n.apexcharts-legend-text {\n    color: $gray-600 !important;\n    font-family: $font-family-base !important;\n    font-size: 13px !important;\n    padding-left: 15px;\n    margin-left: -15px;\n}\n\n\n.apexcharts-series-collapsed {\n    opacity: 0;\n}\n\n.apexcharts-xaxis-tick {\n    stroke: var(--#{$prefix}border-color);\n}\n\n.apexcharts-marker {\n    stroke: var(--#{$prefix}secondary-bg);\n}\n\n.apexcharts-tooltip {\n    border-radius: 5px;\n    box-shadow: $box-shadow !important;\n    cursor: default;\n    font-size: 14px;\n    left: 62px;\n    opacity: 0;\n    pointer-events: none;\n    position: absolute;\n    top: 20px;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    white-space: nowrap;\n    z-index: 12;\n    transition: .15s ease all;\n\n    &.apexcharts-active {\n        opacity: 1;\n        transition: .15s ease all;\n    }\n\n    &.apexcharts-theme-light {\n        border: 1px solid var(--#{$prefix}border-color) !important;\n        background: rgba(var(--#{$prefix}secondary-bg-rgb), .96) !important;\n\n        .apexcharts-tooltip-title {\n            background: var(--#{$prefix}secondary-bg) !important;\n            border-bottom: 1px solid var(--#{$prefix}border-color) !important;\n        }\n    }\n\n    &.apexcharts-theme-dark {\n        color: #fff;\n        background: rgba(30, 30, 30, .8);\n\n        .apexcharts-tooltip-title {\n            background: rgba(0, 0, 0, .7);\n            border-bottom: 1px solid #333;\n        }\n    }\n\n    * {\n        font-family: inherit;\n    }\n\n    .apexcharts-tooltip-title {\n        padding: 6px;\n        font-size: 15px;\n        margin-bottom: 4px;\n    }\n}\n\n.apexcharts-tooltip-text-goals-value,\n.apexcharts-tooltip-text-y-value,\n.apexcharts-tooltip-text-z-value {\n    display: inline-block;\n    margin-left: 5px;\n    font-weight: 600;\n}\n\n.apexcharts-tooltip-text-goals-label,\n.apexcharts-tooltip-text-goals-value,\n.apexcharts-tooltip-text-y-label,\n.apexcharts-tooltip-text-y-value,\n.apexcharts-tooltip-text-z-value,\n.apexcharts-tooltip-title {\n    &:empty {\n        display: none;\n    }\n}\n\n.apexcharts-tooltip-text-goals-label,\n.apexcharts-tooltip-text-goals-value {\n    padding: 6px 0 5px;\n}\n\n.apexcharts-tooltip-goals-group,\n.apexcharts-tooltip-text-goals-label,\n.apexcharts-tooltip-text-goals-value {\n    display: flex;\n}\n\n.apexcharts-tooltip-text-goals-label,\n.apexcharts-tooltip-text-goals-value {\n    &:not(:empty) {\n        margin-top: -6px;\n    }\n}\n\n.apexcharts-tooltip-marker {\n    width: 12px;\n    height: 12px;\n    position: relative;\n    top: 0;\n    margin-right: 10px;\n    border-radius: 50%;\n}\n\n.apexcharts-tooltip-series-group {\n    padding: 0 10px;\n    display: none;\n    text-align: left;\n    justify-content: left;\n    align-items: center;\n\n    &.apexcharts-active {\n        .apexcharts-tooltip-marker {\n            opacity: 1;\n        }\n    }\n\n    &.apexcharts-active,\n    &:last-child {\n        padding-bottom: 4px\n    }\n}\n\n.apexcharts-tooltip-series-group-hidden {\n    opacity: 0;\n    height: 0;\n    line-height: 0;\n    padding: 0 !important;\n}\n\n.apexcharts-tooltip-y-group {\n    padding: 6px 0 5px;\n}\n\n.apexcharts-custom-tooltip,\n.apexcharts-tooltip-box {\n    padding: 4px 8px;\n}\n\n.apexcharts-tooltip-boxPlot {\n    display: flex;\n    flex-direction: column-reverse;\n}\n\n.apexcharts-tooltip-box {\n    >div {\n        margin: 4px 0;\n    }\n\n    span.value {\n        font-weight: 700;\n    }\n}\n\n.apexcharts-tooltip-rangebar {\n    padding: 5px 8px;\n\n    .category {\n        font-weight: 600;\n        color: #777;\n    }\n\n    .series-name {\n        font-weight: 700;\n        display: block;\n        margin-bottom: 5px;\n    }\n}\n\n.apexcharts-xaxistooltip,\n.apexcharts-yaxistooltip {\n    opacity: 0;\n    pointer-events: none;\n    color: #373d3f;\n    font-size: 13px;\n    text-align: center;\n    border-radius: 2px;\n    position: absolute;\n    z-index: 10;\n    background: #eceff1;\n    border: 1px solid #90a4ae;\n}\n\n.apexcharts-xaxistooltip {\n    padding: 9px 10px;\n    transition: .15s ease all;\n\n    &.apexcharts-theme-dark {\n        background: rgba(0, 0, 0, .7);\n        border: 1px solid rgba(0, 0, 0, .5);\n        color: #fff;\n    }\n\n    &::after,\n    &::before {\n        left: 50%;\n        border: solid transparent;\n        content: \" \";\n        height: 0;\n        width: 0;\n        position: absolute;\n        pointer-events: none;\n    }\n\n    &::after {\n        border-color: transparent;\n        border-width: 6px;\n        margin-left: -6px;\n    }\n\n    &::before {\n        border-color: transparent;\n        border-width: 7px;\n        margin-left: -7px;\n    }\n\n    &.apexcharts-active {\n        opacity: 1;\n        transition: .15s ease all;\n    }\n}\n\n.apexcharts-xaxistooltip-bottom {\n\n    &::before,\n    &::after {\n        bottom: 100%;\n    }\n\n    &::after {\n        border-bottom-color: #eceff1;\n    }\n\n    &::before {\n        border-bottom-color: #90a4ae;\n    }\n\n    &.apexcharts-theme-dark {\n\n        &::before,\n        &::after {\n            border-bottom-color: rgba(0, 0, 0, .5);\n        }\n    }\n}\n\n.apexcharts-xaxistooltip-top {\n\n    &::before,\n    &::after {\n        top: 100%;\n    }\n\n    &::after {\n        border-top-color: #eceff1\n    }\n\n    &::before {\n        border-top-color: #90a4ae\n    }\n\n    &.apexcharts-theme-dark {\n\n        &::before,\n        &::after {\n            border-top-color: rgba(0, 0, 0, .5);\n        }\n    }\n}\n\n.apexcharts-yaxistooltip {\n    padding: 4px 10px;\n\n    .apexcharts-theme-dark {\n        background: rgba(0, 0, 0, .7);\n        border: 1px solid rgba(0, 0, 0, .5);\n        color: #fff;\n    }\n\n    &::before,\n    &::after {\n        top: 50%;\n        border: solid transparent;\n        content: \" \";\n        height: 0;\n        width: 0;\n        position: absolute;\n        pointer-events: none;\n    }\n\n    &::after {\n        border-color: transparent;\n        border-width: 6px;\n        margin-top: -6px;\n    }\n\n    &::before {\n        border-color: transparent;\n        border-width: 7px;\n        margin-top: -7px;\n    }\n\n    &.apexcharts-active {\n        opacity: 1;\n    }\n}\n\n.apexcharts-yaxistooltip-left {\n\n    &::before,\n    &::after {\n        left: 100%;\n    }\n\n    &::after {\n        border-left-color: #eceff1;\n    }\n\n    &::before {\n        border-left-color: #90a4ae;\n    }\n\n    &.apexcharts-theme-dark {\n\n        &::before,\n        &::after {\n            border-left-color: rgba(0, 0, 0, .5);\n        }\n    }\n}\n\n.apexcharts-yaxistooltip-right {\n\n    &::before,\n    &::after {\n        right: 100%;\n    }\n\n    &::after {\n        border-right-color: #eceff1;\n    }\n\n    &::before {\n        border-right-color: #90a4ae;\n    }\n\n    &.apexcharts-theme-dark {\n\n        &::before,\n        &::after {\n            border-right-color: rgba(0, 0, 0, .5);\n        }\n    }\n}\n\n.apexcharts-yaxistooltip-hidden {\n    display: none;\n}\n\n.apexcharts-xcrosshairs,\n.apexcharts-ycrosshairs {\n    pointer-events: none;\n    opacity: 0;\n    transition: .15s ease all;\n\n    &.apexcharts-active {\n        opacity: 1;\n        transition: .15s ease all;\n    }\n}\n\n.apexcharts-ycrosshairs-hidden {\n    opacity: 0;\n}\n\n.apexcharts-selection-rect {\n    cursor: move;\n}\n\n.svg_select_boundingRect,\n.svg_select_points_rot {\n    pointer-events: none;\n    opacity: 0;\n    visibility: hidden;\n}\n\n.apexcharts-selection-rect+g {\n\n    .svg_select_boundingRect,\n    .svg_select_points_rot {\n        opacity: 0;\n        visibility: hidden;\n    }\n\n    .svg_select_points_l,\n    .svg_select_points_r {\n        cursor: ew-resize;\n        opacity: 1;\n        visibility: visible;\n    }\n}\n\n.svg_select_points {\n    fill: #efefef;\n    stroke: #333;\n    rx: 2;\n}\n\n.apexcharts-svg {\n    &.apexcharts-zoomable {\n        &.hovering-zoom {\n            cursor: crosshair;\n        }\n\n        &.hovering-pan {\n            cursor: move;\n        }\n    }\n}\n\n.apexcharts-menu-icon,\n.apexcharts-pan-icon,\n.apexcharts-reset-icon,\n.apexcharts-selection-icon,\n.apexcharts-toolbar-custom-icon,\n.apexcharts-zoom-icon,\n.apexcharts-zoomin-icon,\n.apexcharts-zoomout-icon {\n    cursor: pointer;\n    width: 20px;\n    height: 20px;\n    line-height: 24px;\n    color: #6e8192;\n    text-align: center;\n}\n\n:is(.apexcharts-menu-icon, .apexcharts-reset-icon, .apexcharts-zoom-icon, .apexcharts-zoomin-icon, .apexcharts-zoomout-icon) {\n    svg {\n        fill: #6e8192;\n    }\n}\n\n.apexcharts-selection-icon {\n    svg {\n        fill: #444;\n        transform: scale(.76);\n    }\n}\n\n.apexcharts-theme-dark {\n\n    :is(.apexcharts-menu-icon, .apexcharts-pan-icon, .apexcharts-reset-icon, .apexcharts-selection-icon, .apexcharts-toolbar-custom-icon, .apexcharts-zoom-icon, .apexcharts-zoomin-icon, .apexcharts-zoomout-icon) {\n        svg {\n            fill: #f3f4f5;\n        }\n    }\n\n    .apexcharts-menu {\n        background: rgba(0, 0, 0, .7);\n        color: #fff;\n    }\n}\n\n.apexcharts-theme-light {\n\n    .apexcharts-menu-icon,\n    .apexcharts-reset-icon,\n    .apexcharts-selection-icon:not(.apexcharts-selected),\n    .apexcharts-zoom-icon:not(.apexcharts-selected),\n    .apexcharts-zoomout-icon {\n        &:hover {\n            svg {\n                fill: #333;\n            }\n        }\n    }\n\n    .apexcharts-menu-item {\n        &:hover {\n            background: #eee;\n        }\n    }\n}\n\n.apexcharts-menu-icon,\n.apexcharts-selection-icon {\n    position: relative;\n}\n\n.apexcharts-reset-icon {\n    margin-left: 5px;\n}\n\n.apexcharts-menu-icon,\n.apexcharts-reset-icon,\n.apexcharts-zoom-icon {\n    transform: scale(.85);\n}\n\n.apexcharts-zoomin-icon,\n.apexcharts-zoomout-icon {\n    transform: scale(.7);\n}\n\n.apexcharts-zoomout-icon {\n    margin-right: 3px;\n}\n\n.apexcharts-pan-icon {\n    transform: scale(.62);\n    position: relative;\n    left: 1px;\n    top: 0;\n\n    svg {\n        fill: #fff;\n        stroke: #6e8192;\n        stroke-width: 2;\n    }\n\n    &:not(.apexcharts-selected):hover {\n        svg {\n            stroke: #333;\n        }\n    }\n}\n\n.apexcharts-toolbar {\n    position: absolute;\n    z-index: 11;\n    max-width: 176px;\n    text-align: right;\n    border-radius: 3px;\n    padding: 0 6px 2px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.apexcharts-menu {\n    background: #fff;\n    position: absolute;\n    top: 100%;\n    border: 1px solid #ddd;\n    border-radius: 3px;\n    padding: 3px;\n    right: 10px;\n    opacity: 0;\n    min-width: 110px;\n    transition: .15s ease all;\n    pointer-events: none;\n\n    .apexcharts-menu-open {\n        opacity: 1;\n        pointer-events: all;\n        transition: .15s ease all;\n    }\n}\n\n.apexcharts-menu-item {\n    padding: 6px 7px;\n    font-size: 12px;\n    cursor: pointer;\n}\n\n.apexcharts-canvas .apexcharts-element-hidden,\n.apexcharts-datalabel.apexcharts-element-hidden,\n.apexcharts-hide .apexcharts-series-points {\n    opacity: 0;\n}\n\n.apexcharts-datalabel,\n.apexcharts-datalabel-label,\n.apexcharts-datalabel-value,\n.apexcharts-datalabels,\n.apexcharts-pie-label {\n    cursor: default;\n    pointer-events: none;\n}\n\n.apexcharts-pie-label-delay {\n    opacity: 0;\n    animation-name: opaque;\n    animation-duration: .3s;\n    animation-fill-mode: forwards;\n    animation-timing-function: ease;\n}\n\n.apexcharts-annotation-rect,\n.apexcharts-area-series .apexcharts-area,\n.apexcharts-area-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,\n.apexcharts-gridline,\n.apexcharts-line,\n.apexcharts-line-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,\n.apexcharts-point-annotation-label,\n.apexcharts-radar-series path,\n.apexcharts-radar-series polygon,\n.apexcharts-toolbar svg,\n.apexcharts-tooltip .apexcharts-marker,\n.apexcharts-xaxis-annotation-label,\n.apexcharts-yaxis-annotation-label,\n.apexcharts-zoom-rect {\n    pointer-events: none;\n}\n\n.apexcharts-marker {\n    transition: .15s ease all;\n}\n\n.resize-triggers {\n    animation: 1ms resizeanim;\n    visibility: hidden;\n    opacity: 0;\n    height: 100%;\n    width: 100%;\n    overflow: hidden;\n}\n\n.contract-trigger:before,\n.resize-triggers,\n.resize-triggers>div {\n    content: \" \";\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.resize-triggers {\n    >div {\n        height: 100%;\n        width: 100%;\n        background: #eee;\n        overflow: auto\n    }\n\n    &::before {\n        overflow: hidden;\n        width: 200%;\n        height: 200%\n    }\n}\n\n#chart-year,\n#chart-quarter {\n    width: 96%;\n    max-width: 48%;\n    box-shadow: none;\n    padding-left: 0;\n    padding-top: 20px;\n    background: var(--#{$prefix}secondary-bg);\n    border: 1px solid var(--#{$prefix}border-color);\n}\n\n#chart-year {\n    float: left;\n    position: relative;\n    transition: 1s ease transform;\n    z-index: 3;\n\n    &.chart-quarter-activated {\n        transform: translateX(0);\n        transition: 1s ease transform;\n    }\n}\n\n#chart-quarter {\n    float: left;\n    position: relative;\n    z-index: -2;\n    transition: 1s ease transform;\n\n    &.active {\n        transition: 1.1s ease-in-out transform;\n        transform: translateX(0);\n        z-index: 1;\n    }\n}\n\n@media screen and (min-width: 480px) {\n    #chart-year {\n        transform: translateX(50%);\n    }\n\n    #chart-quarter {\n        transform: translateX(-50%);\n    }\n}\n\n\n.apexcharts-treemap,\n.apexcharts-heatmap-series {\n    rect {\n        stroke: var(--#{$prefix}secondary-bg);\n    }\n}\n\n.apexcharts-pie-series,\n.apexcharts-bar-series {\n    path {\n        stroke: var(--#{$prefix}secondary-bg);\n    }\n}\n\n.apexcharts-radialbar {\n    .apexcharts-datalabels-group text {\n        fill: var(--#{$prefix}body-color);\n    }\n}\n\n.apexcharts-radialbar-track {\n    path {\n        stroke: var(--#{$prefix}border-color);\n    }\n}\n\n// radar chart\n\n.apexcharts-radar-series {\n\n    polygon,\n    line {\n        stroke: var(--#{$prefix}border-color);\n    }\n}\n\n.apexcharts-pie {\n\n    circle,\n    line {\n        stroke: var(--#{$prefix}border-color);\n    }\n\n    text {\n        fill: var(--#{$prefix}white);\n    }\n}\n\n.apexcharts-xaxistooltip {\n    &.apexcharts-theme-light {\n        box-shadow: $box-shadow;\n        color: var(--#{$prefix}secondary-color);\n        background: var(--#{$prefix}secondary-bg);\n        border: 1px solid var(--#{$prefix}border-color);\n        font-family: $font-family-base;\n\n        &::before {\n            border-bottom-color: var(--#{$prefix}border-color);\n        }\n    }\n}\n\n.effect-chart {\n    :is(.apexcharts-pie-series, .apexcharts-bar-series) {\n        path {\n            clip-path: polygon(50% 2%, 100% 0, 100% 100%, 0 100%, 0 0);\n        }\n    }\n}\n\n.apexcharts-grid-borders {\n    line {\n        stroke: var(--#{$prefix}border-color);\n    }\n}","\n//\n// _chartjs.scss\n//\n\n.chartjs-chart{\n  max-height: 320px;\n}\n  ","//\n// echarts.scss\n//\n\n.e-charts{\n    height: 350px;\n}\n\n.e-charts-height{\n    height: 300px;\n}","\n//\n// _google-map.scss\n//\n\n.gmaps, .gmaps-panaroma {\n  height: 300px;\n  background: $gray-100;\n  border-radius: 3px;\n}\n\n.gmaps-overlay {\n  display: block;\n  text-align: center;\n  color: $white;\n  font-size: 16px;\n  line-height: 40px;\n  background: $primary;\n  border-radius: 4px;\n  padding: 10px 20px;\n}\n\n.gmaps-overlay_arrow {\n  left: 50%;\n  margin-left: -16px;\n  width: 0;\n  height: 0;\n  position: absolute;\n  &.above {\n    bottom: -15px;\n    border-left: 16px solid transparent;\n    border-right: 16px solid transparent;\n    border-top: 16px solid $primary;\n  }\n  &.below {\n    top: -15px;\n    border-left: 16px solid transparent;\n    border-right: 16px solid transparent;\n    border-bottom: 16px solid $primary;\n  }\n  \n}","//\n// _autocomplete.scss\n//\n\n.autoComplete_wrapper {\n    display: block;\n\n    >input {\n        display: block;\n        width: 100%;\n        height: auto;\n        padding: $input-padding-y $input-padding-x;\n        font-family: $input-font-family;\n        font-size: $input-font-size;\n        font-weight: $input-font-weight;\n        line-height: $input-line-height;\n        color: $input-color;\n        background-color: $input-bg;\n        background-clip: padding-box;\n        border: $input-border-width solid $input-border-color;\n        border-radius: $input-border-radius;\n        background-image: none;\n\n        &::placeholder {\n            padding: 0 !important;\n            color: $input-placeholder-color !important;\n            font-size: $input-font-size !important;\n        }\n\n        &:focus {\n            border: $input-border-width solid $input-focus-border-color;\n            color: $input-focus-color;\n        }\n\n        &:hover {\n            color: $input-color;\n        }\n    }\n\n    >ul {\n        border-radius: $border-radius;\n        border-color: $dropdown-border-color;\n        background-color: $dropdown-bg;\n        box-shadow: $dropdown-box-shadow;\n        padding: 0;\n        overflow: auto;\n        max-height: 160px;\n        margin: 0;\n        animation-name: DropDownSlide;\n        animation-duration: .3s;\n        animation-fill-mode: both;\n\n        > li {\n            font-size: $dropdown-font-size;\n            margin: 0;\n            padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n            border-radius: 0;\n            background-color: $dropdown-bg;\n            color: $dropdown-color;\n\n            mark {\n                color: $danger;\n                font-weight: $font-weight-semibold;\n                padding: 1px;\n            }\n\n            &[aria-selected=true],\n            &:hover {\n                color: $dropdown-link-hover-color;\n                @include gradient-bg($dropdown-link-hover-bg);\n            }\n        }\n\n        .no_result {\n            padding: $dropdown-item-padding-y *2 $dropdown-item-padding-x;\n            font-style: italic;\n            font-weight: $font-weight-medium;\n        }\n    }\n}","//\n// vector-maps.scss\n//\n\n.jvm-tooltip {\n    border-radius: 3px;\n    background-color: var(--#{$prefix}primary);\n    font-family: $font-family-base;\n    box-shadow: $box-shadow-lg;\n    padding: 5px 9px;\n}\n\n.jvm-container {\n    text {\n        font-family: $font-family-base;\n        font-size: $font-size-base;\n        fill: var(--#{$prefix}body-color);\n    }\n}\n\n.jvm-zoom-btn {\n    background-color: var(--#{$prefix}primary);\n}","//\n// _leaflet-maps.scss\n//\n\n.leaflet-map {\n    height: 300px;\n    &.leaflet-container{\n        z-index: 0;\n        font-family: $font-family-primary;\n    }\n}","// \n// _fullcalendar.scss\n// \n\n\n.fc td,\n.fc th {\n    border: $table-border-width solid $table-border-color;\n}\n\n.fc {\n    .fc-toolbar {\n        h2 {\n            font-size: 16px;\n            line-height: 30px;\n            text-transform: uppercase;\n        }\n\n        @media (max-width: 767.98px) {\n\n            .fc-left,\n            .fc-right,\n            .fc-center {\n                float: none;\n                display: block;\n                text-align: center;\n                clear: both;\n                margin: 10px 0;\n            }\n\n            >*>* {\n                float: none;\n            }\n\n            .fc-today-button {\n                display: none;\n            }\n        }\n\n        .btn {\n            text-transform: capitalize;\n        }\n    }\n\n    .fc-col-header-cell {\n        background-color: var(--#{$prefix}light);\n    }\n\n    .fc-col-header-cell-cushion {\n        display: block;\n        padding: 8px 4px;\n        color: var(--#{$prefix}body-color);\n    }\n    \n    .fc-daygrid-day-number {\n        width: 24px;\n        height: 24px;\n        border-radius: 50%;\n        padding: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 12px;\n        font-weight: $font-weight-medium;\n        margin: 2px;\n        color: var(--#{$prefix}body-color);\n    }\n\n    .fc-daygrid-day {\n        &.fc-day-today {\n            background-color: rgba($primary, 0.1);\n    \n            .fc-daygrid-day-number {\n                background-color: $primary;\n                color: $white;\n            }\n        }\n    }\n\n    .fc-daygrid-day {\n        &.fc-day-today {\n            background-color: rgba($primary, 0.1);\n        }\n    }\n    \n    .fc-timegrid-col {\n        &.fc-day-today {\n            background-color: rgba($primary, 0.1);\n        }\n    }\n\n    .fc-list-event:hover td {\n        background: transparent;\n    }\n\n    .fc-list-event-title {\n        a {\n            color: $white !important;\n        }\n    }\n\n    .fc-col-header,\n    .fc-daygrid-body,\n    .fc-scrollgrid-sync-table {\n        width: 100% !important;\n    }\n\n    .fc-scrollgrid-section>*{\n        border-left: $table-border-width solid $table-border-color;\n        border-top: $table-border-width solid $table-border-color;\n    }\n\n    .fc-scrollgrid{\n        border: 0;\n    }\n\n    .fc-scrollgrid-section-liquid>td{\n        border-top: 0;\n    }\n}\n\n.fc-theme-bootstrap a:not([href]) {\n    color: var(--#{$prefix}body-color);\n}\n\n.fc-event {\n    color: $white;\n}\n\n.fc {\n    th.fc-widget-header {\n        background: $gray-300;\n        line-height: 20px;\n        padding: 10px 0;\n        text-transform: uppercase;\n        font-weight: $font-weight-bold;\n    }\n}\n\n.fc-unthemed {\n\n    .fc-content,\n    .fc-divider,\n    .fc-list-heading td,\n    .fc-list-view,\n    .fc-popover,\n    .fc-row,\n    tbody,\n    td,\n    th,\n    thead {\n        border-color: $gray-300;\n    }\n\n    td.fc-today {\n        background: lighten($gray-200, 2%);\n    }\n}\n\n.fc-button {\n    background: var(--#{$prefix}secondary-bg);\n    border-color: var(--#{$prefix}border-color);\n    color: $gray-700;\n    text-transform: capitalize;\n    box-shadow: none;\n    padding: 6px 12px !important;\n    height: auto !important;\n}\n\n.fc-state-down,\n.fc-state-active,\n.fc-state-disabled {\n    background-color: $primary;\n    color: $white;\n    text-shadow: none;\n}\n\n.fc-event {\n    border-radius: 2px;\n    border: none;\n    cursor: move;\n    font-size: 0.8125rem;\n    margin: 5px 7px;\n    padding: 5px 5px;\n    text-align: center;\n}\n\n.fc-event,\n.fc-event-dot {\n    background-color: $primary;\n}\n\n.fc-daygrid-dot-event.fc-event-mirror,\n.fc-daygrid-dot-event:hover {\n    background-color: $primary;\n}\n\n.fc-event-title,\n.fc-sticky {\n    font-weight: $font-weight-semibold !important;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.fc-daygrid-event-dot {\n    border-color: $white !important;\n    display: none;\n}\n\n.fc-event-time {\n    display: none;\n}\n\n.fc-event .fc-content {\n    color: $white;\n}\n\n#external-events {\n    .external-event {\n        text-align: left;\n        padding: 8px 16px;\n        margin: 6px 0;\n    }\n}\n\n\n.fc-day-grid-event.fc-h-event.fc-event.fc-start.fc-end.bg-dark {\n    .fc-content {\n        color: $light;\n    }\n}\n\n.fc-prev-button,\n.fc-next-button {\n    position: relative;\n    height: 37.5px;\n    width: 37.5px;\n    &::before {\n        position: absolute;\n        font-family: remixicon !important;\n        font-size: 20px;\n        top: 0;\n        bottom: 0px;\n        left: 0;\n        right: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n}\n.fc-prev-button {\n    &::before {\n        content: \"\\ea64\";\n    }\n}\n.fc-next-button {\n    &::before {\n        content: \"\\ea6e\";\n    }\n}\n\n.fc-toolbar-chunk {\n    .btn-group {\n        box-shadow: $element-shadow;\n        .btn {\n            color: $secondary;\n            background-color: rgba($secondary, 0.15);\n            border: none;\n            box-shadow: none;\n\n            &:hover,\n            &.active {\n                color: $white;\n                background-color: $secondary;\n            }\n        }\n    }\n\n    .fc-today-button {\n        background-color: $secondary !important;\n        border: $secondary;\n    }\n}\n\n.fc {\n    .fc-button-primary:not(:disabled).fc-button-active, \n    .fc-button-primary:not(:disabled):active{\n        background-color: $secondary !important;\n        border-color: $secondary !important;\n        color: $white !important;\n    }\n    .fc-button-primary {\n        text-transform: capitalize;\n    }\n}\n\n\n.fc-toolbar {\n    @media (max-width: 575.98px) {\n        flex-direction: column;\n        gap: 16px;\n    }\n}\n\n#upcoming-event-list {\n    .card {\n        &:last-child {\n            margin-bottom: 6px !important;\n        }\n    }\n}\n\n#event-modal {\n    .event-details {\n        display: none;\n    }\n\n    .view-event {\n        .event-form {\n            display: none;\n        }\n\n        #event-category-tag {\n            display: none;\n        }\n\n        .event-details {\n            display: block;\n        }\n    }\n}\n\n.fc-daygrid-event-harness {\n    .fc-daygrid-event {\n        backdrop-filter: blur(4px);\n    }\n}\n\n.fc-timegrid-event-harness {\n    .fc-timegrid-event {\n        backdrop-filter: blur(4px);\n    }\n}\n\n\n.fc-timegrid-slots {\n    table {\n        tr {\n            border-color: var(--#{$prefix}border-color) !important;\n        }\n    }\n}\n\n.fc-list-table {\n    border-color: var(--#{$prefix}border-color);\n}\n\n@each $color,\n$value in $theme-colors {\n    .fc-daygrid-event-harness {\n        .fc-daygrid-event {\n            &.bg-#{$color}-subtle {\n\n                .fc-event-title,\n                .fc-event-main {\n                    color: $value !important;\n                }\n            }\n        }\n    }\n\n    .fc-timegrid-event-harness {\n        .fc-timegrid-event {\n            &.bg-#{$color}-subtle {\n                .fc-event-title {\n                    color: $value !important;\n                }\n            }\n        }\n    }\n\n    .fc-list-table {\n        .fc-list-event {\n            &.bg-#{$color}-subtle {\n                color: $value !important;\n\n                .fc-list-event-title {\n                    >a {\n                        color: $value !important;\n                    }\n                }\n\n                .fc-list-event-dot {\n                    border-color: $value;\n                }\n            }\n        }\n    }\n}\n\n.fc-daygrid-event-harness .fc-daygrid-event.bg-dark-subtle{\n    .fc-event-main, .fc-event-title {\n        color:  var(--#{$prefix}dark-text-emphasis) !important;\n    }\n}\n\n.fc-direction-ltr{\n    direction: ltr;\n    .fc-toolbar>*>:not(:first-child){\n        margin-left: 0.75em;\n    }\n}","//\n// emoji-picker.scss\n//\n\n.fg-emoji-picker{\n    width: 250px !important;\n    box-shadow: $box-shadow !important;\n    top: auto !important;\n    bottom: 130px;\n\n    *{\n        font-family: $font-family-base !important;\n        color: var(--#{$prefix}body-color) !important;\n    }\n    @media (max-width:991.98px) {\n        left: 14px !important;\n        top: auto !important;\n        bottom: 118px;\n    }\n\n    .fg-emoji-picker-container-title{\n        color: $dark !important;\n    }\n\n    .fg-emoji-picker-search{\n        height: 40px !important;\n        input{\n            background-color: $input-bg !important;\n            color: $input-color !important;\n            padding: $input-btn-padding-y $input-btn-padding-x !important;\n            font-size: $font-size-base !important;\n            &::placeholder{\n                color: $input-placeholder-color !important;\n            }\n        }\n\n        svg{\n            fill: var(--#{$prefix}body-color) !important;\n            right: 11px;\n            top: 12px;\n        }\n    }\n\n    .fg-emoji-picker-categories{\n        background-color: $light !important;\n        li.active{\n            background-color: rgba(var(--bs-primary-rgb), 0.2);\n        }\n        a{\n            &:hover{\n                background-color: rgba(var(--bs-primary-rgb), 0.2);\n            }\n        }\n        \n    }\n}\n\n.fg-emoji-picker-grid > li:hover{\n    background-color: rgba(var(--bs-primary-rgb), 0.2) !important;\n}\n\na.fg-emoji-picker-close-button{\n    background-color: darken($light, 4%) !important;\n}","//\n// _datatables.scss\n//\n\ntable.dataTable td.dataTables_empty,\ntable.dataTable th.dataTables_empty {\n    text-align: center;\n    padding: 50px;\n    font-weight: $font-weight-semibold;\n    --vz-table-accent-bg: var(--#{$prefix}secondary-bg);\n}\n\ntable.dataTable>thead .sorting:before,\ntable.dataTable>thead .sorting_asc:before,\ntable.dataTable>thead .sorting_desc:before,\ntable.dataTable>thead .sorting_asc_disabled:before,\ntable.dataTable>thead .sorting_desc_disabled:before {\n    content:\"\\f0360\";\n    position: absolute;\n    right: 0.5rem;\n    top: 12px;\n    font-size: .8rem;\n    font-family: \"Material Design Icons\";\n}\n\ntable.dataTable>thead .sorting:after,\ntable.dataTable>thead .sorting_asc:after,\ntable.dataTable>thead .sorting_desc:after,\ntable.dataTable>thead .sorting_asc_disabled:after,\ntable.dataTable>thead .sorting_desc_disabled:after {\n    content: \"\\f035d\";\n    position: absolute;\n    right: 0.5rem;\n    top: 18px;\n    font-size: .8rem;\n    font-family: \"Material Design Icons\";\n}\n\ntable.dataTable>tbody>tr.child span.dtr-title {\n    font-weight: $font-weight-semibold;\n    min-width: 150px;\n}\n\n\n//responsive \ntable {\n    &.dataTable {\n        &.dtr-inline {\n            &.collapsed {\n                >tbody {\n                    >tr {\n\n                        >th,\n                        >td {\n                            &.dtr-control {\n                                &::before {\n                                    background-color: $primary;\n                                    border-color: var(--#{$prefix}secondary-bg);\n                                }\n                            }\n                        }\n\n                        &.parent {\n                            &.parent {\n                                >th {\n                                    &.dtr-control {\n                                        &::before {\n                                            background-color: $danger;\n                                        }\n                                    }\n                                }\n                            }\n\n                            >td {\n                                &.dtr-control {\n                                    &::before {\n                                        background-color: $danger;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n        >tbody {\n            >tr {\n                &.child {\n                    span {\n                        &.dtr-title {\n                            min-width: 135px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n\n.table-card {\n\n    .dataTables_length,\n    .dataTables_filter {\n        padding: $card-cap-padding-y $card-cap-padding-x;\n        padding-bottom: 0px;\n    }\n\n    .dataTables_info,\n    .dataTables_paginate {\n        padding: $card-cap-padding-y $card-cap-padding-x;\n    }\n\n    div.dataTables_wrapper {\n        .col-md-6 {\n            width: 100%;\n        }\n\n        div {\n            &.dataTables_filter {\n                input {\n                    width: calc(100% - 52px);\n                }\n\n                label {\n                    display: block;\n                }\n            }\n        }\n    }\n}\n\n\ndiv{\n    &.dtr-modal {\n        div {\n            &.dtr-modal-display {\n                background-color: $modal-content-bg;\n                border-color: var(--#{$prefix}border-color);\n                box-shadow: none;\n                height: 70%;\n            }\n            &.dtr-modal-content {\n                padding: $modal-inner-padding;\n                h2 {\n                    font-size: $font-size-lg;\n                    font-weight: $font-weight-semibold;\n                    margin-bottom: 15px;\n                }\n                .dtr-details{\n                    tr {\n                        td {\n                            padding: $table-cell-padding-y $table-cell-padding-x;\n                        }\n                    }\n                }\n            }\n            &.dtr-modal-close {\n                font-size: 24px;\n                top: 9px;\n                right: 11px;\n                width: 30px;\n                height: 30px;\n                line-height: 30px;\n                background-color: var(--#{$prefix}secondary-bg);\n                border-color: var(--#{$prefix}border-color);\n                &:hover {\n                    background-color: var(--#{$prefix}light);\n                }\n            }\n        }\n    }\n}\n\n\n.dt-buttons {\n    :is(button.dt-button, div.dt-button, a.dt-button, input.dt-button) {\n        border-color: var(--#{$prefix}border-color);\n        background: var(--#{$prefix}light);\n        color: var(--#{$prefix}body-color);\n    }\n}\n\n:is(button, div, a, input):is(.dt-button:hover:not(.disabled)) {\n    border-color: var(--#{$prefix}border-color);\n    background: var(--#{$prefix}light);\n    color: var(--#{$prefix}body-color);\n}\n\n:is(button, div, a, input):is(.dt-button:active:not(.disabled)),\n:is(button, div, a, input):is(.dt-button.active:not(.disabled)) {\n    border-color: var(--#{$prefix}border-color);\n    background: var(--#{$prefix}light);\n    color: var(--#{$prefix}body-color);\n    box-shadow: none;\n}\n\n:is(button, div, a, input):is(.dt-button:focus:not(.disabled)){\n    border-color: var(--#{$prefix}border-color);\n    background: var(--#{$prefix}light);\n    color: var(--#{$prefix}body-color);\n    text-shadow: none;\n    box-shadow: none;\n}\n\n:is(button, div, a, input):is(.dt-button:active:not(.disabled):hover:not(.disabled)),\n:is(button, div, a, input):is(.dt-button.active:not(.disabled):hover:not(.disabled)) {\n    border-color: var(--#{$prefix}border-color);\n    background: var(--#{$prefix}light);\n    color: var(--#{$prefix}body-color);\n    text-shadow: none;\n    box-shadow: none;\n}","//\n// Select 2\n//\n\n.select2.select2-container{\n    width: 100% !important;\n}\n.select2-container {\n    .select2-selection--single {\n        border: $input-border-width solid $input-border-color;\n        height: $input-height;\n        background-color: $input-bg;\n        outline: none;\n        .select2-selection__rendered {\n            line-height: 36px;\n            padding-left: 12px;\n            color: $input-color;\n        }\n        .select2-selection__arrow {\n            height: 34px;\n            width: 34px;\n            /*rtl:ignore*/\n            right: 3px;\n            b {\n                border-color: $input-border-color transparent transparent transparent;\n                border-width: 6px 6px 0 6px;\n            }\n        }\n    }\n}\n\n.select2-container--open {\n    .select2-selection--single {\n        .select2-selection__arrow {\n            b {\n                border-color: transparent transparent $input-border-color transparent !important;\n                border-width: 0 6px 6px 6px !important;\n            }\n        }\n    }\n}\n\n.select2-results__option {\n    padding: 6px 12px;\n}\n\n.select2-dropdown {\n    border: var(--#{$prefix}dropdown-border-width) solid $dropdown-border-color;\n    box-shadow: $box-shadow;\n    background-color: var(--#{$prefix}secondary-bg);\n    z-index: $zindex-modal + 1;\n}\n\n.select2-container--default {\n    .select2-results__option--selected {\n        background-color: $input-disabled-bg;\n    }\n    .select2-search--dropdown {\n        padding: 10px;\n        background-color: var(--#{$prefix}secondary-bg);\n        .select2-search__field {\n            outline: none;\n            border: 1px solid $input-border-color;\n            background-color: $input-bg;\n            color: $input-color;\n            border-radius: $input-border-radius;\n        }\n    }\n    .select2-results__option--highlighted[aria-selected] {\n        background-color: $primary;\n    }\n    .select2-results__option[aria-selected=true] {\n        background-color: var(--#{$prefix}secondary-bg);\n        color: var(--#{$prefix}dropdown-link-active-color);\n        &:hover {\n            background-color: $primary;\n            color: $white;\n        }\n    }\n    .select2-selection--multiple {\n        .select2-selection__choice__display {\n            padding-left: 36px;\n            padding-right: 5px;\n        }\n    }\n    .select2-selection--single {\n        .select2-selection__arrow {\n            /*rtl:ignore*/\n            right: 1px;\n            /*rtl:ignore*/\n            left: auto;\n        }\n    }\n    \n}\n\n.select2-container {\n    .select2-selection--multiple {\n        min-height: $input-height;\n        border: $input-border-width solid $input-border-color !important;\n        background-color: $input-bg;\n\n        .select2-selection__rendered {\n            padding: 1px 4px;\n        }\n        .select2-search__field {\n            border: 0;\n            color: $input-color;\n        }\n        .select2-selection__choice {\n            background-color: $primary;\n            border: none;\n            color: $white;\n            border-radius: 3px;\n            padding: 3px;\n            margin-top: 6px;\n        }\n        .select2-selection__choice__remove {\n            color: $white;\n            margin-right: 7px;\n            border-color: tint-color($primary, 10%);\n            padding: 0 8px;\n            top: 3px;\n            &:hover {\n                color: $white;\n                background-color: $primary;\n            }\n        }\n    }\n    .select2-search--inline {\n        .select2-search__field {\n            margin-top: 7px;\n            height: 22px;\n            font-family: $font-family-base;\n        }\n    }\n    .select2-search {\n        textarea {\n            &::placeholder {\n                color: $input-placeholder-color;\n            }\n        }\n    }\n}\n\n.select2-container--default{\n    &.select2-container--disabled {\n        .select2-selection--single, .select2-selection--multiple {\n            background-color: $input-disabled-bg;\n            cursor: default;\n        }\n    }\n}\n","// \n// toastify.scss\n// \n\n\n.toastify {\n    padding: 12px 16px;\n    color: $white;\n    display: inline-block;\n    box-shadow: 0 3px 6px -1px rgba(0, 0, 0, 0.12), 0 10px 36px -4px rgba(77, 96, 232, 0.3);\n    background: var(--#{$prefix}success);\n    position: fixed;\n    opacity: 0;\n    transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);\n    border-radius: 2px;\n    cursor: pointer;\n    text-decoration: none;\n    max-width: calc(50% - 20px);\n    z-index: 2147483647;\n    &.on {\n        opacity: 1;\n    }\n}\n\n\n.toast-close {\n    opacity: 0.4;\n    padding: 0 5px;\n    position: relative;\n    left: 4px;\n    margin-left: 4px;\n    border: none;\n    background: none;\n    color: $white;\n}\n\n.toastify-right {\n    right: 15px;\n}\n\n.toastify-left {\n    left: 15px;\n    .toast-close {\n        left: -4px;\n        margin-left: 0;\n        margin-right: 4px;\n    }\n}\n\n.toastify-top {\n    top: -150px;\n}\n\n.toastify-bottom {\n    bottom: -150px;\n}\n\n.toastify-rounded {\n    border-radius: 25px;\n}\n\n.toastify-avatar {\n    width: 1.5em;\n    height: 1.5em;\n    margin: -7px 5px;\n    border-radius: 2px;\n}\n\n.toastify-center {\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    right: 0;\n    max-width: fit-content;\n    max-width: -moz-fit-content;\n}\n\n@media only screen and (max-width: 360px) {\n    .toastify-right, .toastify-left {\n        margin-left: auto;\n        margin-right: auto;\n        left: 0;\n        right: 0;\n        max-width: fit-content;\n    }\n}","//\n// _choices.scss\n//\n\n.choices {\n    position: relative;\n    margin-bottom: 24px;\n    font-size: 16px;\n\n    &:focus {\n        outline: none;\n    }\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n\n    &.is-disabled{\n        .choices__inner,\n        .choices__input {\n            background-color: rgba(var(--#{$prefix}light-rgb), 0.75);\n            cursor: not-allowed;\n            user-select: none;\n        }\n\n        .choices__item {\n            cursor: not-allowed;\n        }\n    }\n\n    [hidden] {\n        display: none !important;\n    }\n    \n    // data-type = select-one\n    &[data-type*='select-one'] {\n        cursor: pointer;\n        .choices__inner{\n            padding-bottom: 0.25rem;\n        }\n\n        .choices__input{\n            display: block;\n            width: 100%;\n            padding: $input-padding-y $input-padding-x;\n            background-color: $input-bg;\n            border: 1px solid $input-border-color;\n            font-size: $input-font-size;\n            border-radius: $input-border-radius;\n            color: $input-color;\n            margin-bottom: 10px;\n        }\n\n        .choices__button{\n            background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==);\n            padding: 0;\n            background-size: 8px;\n            position: absolute;\n            top: 50%;\n            right: 0;\n            left: auto;\n            margin-top: -10px;\n            margin-right: 25px;\n            margin-left: 0;\n            height: 20px;\n            width: 20px;\n            border-radius: 10em;\n            opacity: 0.5;\n\n            &:hover, &:focus {\n                opacity: 1;\n            }\n\n            &:focus {\n                box-shadow: 0px 0px 0px 2px #00bcd4;\n            }\n        }\n\n        .choices__item[data-value=''] .choices__button {\n            display: none;\n        }\n\n        &:after {\n            content: \"\\F0140\";\n            position: absolute;\n            border: 0;\n            border-color: $dark transparent transparent;\n            right: 11.5px;\n            left: auto;\n            font-family: 'Material Design Icons';\n            width: auto;\n            height: auto;\n            margin-top: 0;\n            top: 50%;\n            transform: translateY(-50%);\n            pointer-events: none;\n        }\n\n        &.is-open:after {\n            margin-top: 0;\n            transform: translateY(-50%) rotate(-180deg);\n        }\n\n    }\n\n\n    // data-type = select- multiple & text\n\n    &[data-type*='select-multiple'],\n    &[data-type*='text'] {\n        .choices__inner {\n            cursor: text;\n            padding-right: #{$form-select-padding-x};\n        }\n\n        .choices__button {\n            position: relative;\n            display: inline-block;\n            margin-top: 0;\n            margin-right: -4px;\n            margin-bottom: 0;\n            margin-left: 8px;\n            padding-left: 16px;\n            border-left: 1px solid rgba($white, 0.5);\n            border-right: 0;\n            background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==);\n            background-size: 8px;\n            width: 8px;\n            line-height: 1;\n            opacity: 0.75;\n            border-radius: 0;\n            &:hover, &:focus {\n                opacity: 1;\n            }\n        }\n        .choices__list--dropdown{\n            padding-bottom: 10px;\n            .choices__list{\n                margin-bottom: 0;\n            }\n        }\n    }\n\n    &[data-type*=select-multiple] {\n        .choices__input {\n            padding-top: 3px;\n        }\n    }\n}\n\n//Select Light\n.input-light {\n    .choices__inner { \n        background-color: var(--#{$prefix}light);\n        border: none;\n    }\n}\n  \n.choices__inner {\n    display: inline-block;\n    vertical-align: middle;\n    width: 100%;\n    background-color: $form-select-bg;\n    padding: 0.25rem calc(#{$form-select-padding-x} + #{$form-select-indicator-padding}) 0.1rem 0.5rem;\n    border: $form-select-border-width solid $form-select-border-color;\n    border-radius: $form-select-border-radius !important;\n    font-size: $input-font-size;\n    min-height: 37.5px;\n    overflow: hidden;\n}\n\n  \n.is-focused,\n.is-open {\n    .choices__inner {\n        border-color: $input-focus-border-color;\n    }\n}\n  \n.choices__list {\n    margin: 0;\n    padding-left: 0;\n    list-style: none;\n}\n  \n.choices__list--single {\n    display: inline-block;\n    padding: 4px 16px 4px 4px;\n    width: 100%;\n\n    .choices__item {\n        width: 100%;\n    }\n}\n\n.choices__list--multiple {\n    display: inline;\n    .choices__item {\n        display: inline-block;\n        vertical-align: initial;\n        border-radius: 7px;\n        padding: 2px 7px;\n        font-size: 11px;\n        font-weight: $font-weight-normal;\n        margin-right: 3.75px;\n        margin-bottom: 3.75px;\n        margin-top: 2px;\n        background-color: $primary;\n        border: 1px solid $primary;\n        word-break: break-all;\n        box-sizing: border-box;\n        color: $white;\n        box-shadow: $element-shadow;\n        &[data-deletable] {\n            padding-right: 5px;\n        }\n\n        &.is-highlighted {\n            background-color: $primary;\n            border: 1px solid $primary;\n        }\n    }\n}\n\n  \n.is-disabled {\n    .choices__list--multiple {\n        .choices__item {\n            background-color: $secondary;\n            border: 1px solid $secondary\n        }\n    }\n}\n  \n.choices__list--dropdown {\n    visibility: hidden;\n    z-index: 1;\n    position: absolute;\n    width: 100%;\n    background-color: var(--#{$prefix}secondary-bg);\n    border: 1px solid var(--#{$prefix}border-color);\n    box-shadow: $dropdown-box-shadow;\n    top: 100%;\n    margin-top: 0;\n    padding: 10px 10px 20px 10px;\n    border-bottom-left-radius: 2.5px;\n    border-bottom-right-radius: 2.5px;\n    overflow: hidden;\n    word-break: break-all;\n    will-change: visibility;\n    animation-duration: .3s;\n    animation-fill-mode: both;\n    transform: translateY(1px);\n    &.is-active {\n        visibility: visible;\n        animation-name: DropDownSlide;\n    }\n\n    .choices__item--selectable.is-highlighted {\n        background-color: var(--#{$prefix}tertiary-bg);\n    }\n\n    .choices__list {\n        margin: 0 -16px -16px;\n    }\n\n    .has-no-results {\n        font-style: italic;\n        font-weight: $font-weight-medium;\n    }\n\n    .choices__item--selectable:after{\n        display: none;\n    }\n}\n  \n.is-open{\n    .choices__list--dropdown {\n        border-color: $dropdown-border-color;\n    }\n}\n  \n.is-flipped{\n    .choices__list--dropdown {\n        top: auto;\n        bottom: 100%;\n        margin-top: 0;\n        margin-bottom: -1px;\n        border-radius: 0.25rem 0.25rem 0 0;\n        &.is-active {\n            animation-name: DropDownSlideDown;\n            transform: translateY(-1px);\n        }\n    }\n}\n  \n.choices__list--dropdown{\n    .choices__list {\n        position: relative;\n        max-height: 300px;\n        overflow: auto;\n        -webkit-overflow-scrolling: touch;\n        will-change: scroll-position;\n    }\n\n    .choices__item {\n        position: relative;\n        font-size: $dropdown-font-size;\n        padding: $dropdown-item-padding-y $dropdown-item-padding-x $dropdown-item-padding-y 16px;\n    }\n}\n  \n\n  \n@media (min-width: 640px) {\n    .choices__list--dropdown {\n        .choices__item--selectable {\n\n            &:after {\n                content: attr(data-select-text);\n                font-size: 12px;\n                opacity: 0;\n                position: absolute;\n                right: 10px;\n                top: 50%;\n                transform: translateY(-50%);\n            }\n\n            &.is-highlighted {\n                &:after {\n                    opacity: 0.5;\n                }\n            }\n        }\n    }\n    \n\n}\n  \n.choices__item {\n    cursor: default;\n}\n  \n.choices__item--selectable {\n    cursor: pointer;\n}\n  \n.choices__item--disabled {\n    cursor: not-allowed;\n    user-select: none;\n    opacity: 0.5;\n}\n  \n.choices__heading {\n    font-weight: $font-weight-semibold;\n    font-size: 12px;\n    padding: 10px 16px;\n    border-bottom: 1px solid var(--#{$prefix}border-color);\n    color: var(--#{$prefix}secondary-color);\n}\n  \n.choices__button {\n    text-indent: -9999px;\n    appearance: none;\n    border: 0;\n    background-color: transparent;\n    background-repeat: no-repeat;\n    background-position: center;\n    cursor: pointer;\n    &:focus {\n        outline: none;\n    }\n}\n  \n.choices__input {\n    display: inline-block;\n    vertical-align: baseline;\n    background-color: $input-bg;\n    color: $input-color;\n    font-size: $input-font-size;\n    margin-bottom: 0;\n    border: 0;\n    border-radius: 0;\n    max-width: 100%;\n    padding: 2px 0 2px 2px;\n    &:focus {\n        outline: 0;\n    }\n    &::placeholder {\n        color: $input-placeholder-color;\n    }\n}\n  \n.choices__placeholder {\n    color: $input-placeholder-color;\n    opacity: 1;\n}\n\n\n[data-bs-theme=\"dark\"]{\n    .choices[data-type*=select-one]{\n        .choices__button{\n            filter: $btn-close-white-filter;\n        }\n    }\n}","//\n// _flatpicker.scss\n//\n\n.flatpickr-calendar {\n    background: transparent;\n    opacity: 0;\n    display: none;\n    text-align: center;\n    visibility: hidden;\n    padding: 0;\n    animation: none;\n    direction: ltr;\n    border: 0;\n    font-size: 14px;\n    line-height: 24px;\n    border-radius: 5px;\n    position: absolute;\n    width: 307.875px;\n    box-sizing: border-box;\n    touch-action: manipulation;\n    background: var(--#{$prefix}secondary-bg);\n    box-shadow: 1px 0 0 var(--#{$prefix}border-color), -1px 0 0 var(--#{$prefix}border-color), 0 1px 0 var(--#{$prefix}border-color), 0 -1px 0 var(--#{$prefix}border-color), 0 3px 13px rgba(0, 0, 0, 0.08);\n\n    &.open,\n    &.inline {\n        opacity: 1;\n        max-height: 640px;\n        visibility: visible;\n    }\n\n    &.open {\n        display: inline-block;\n        z-index: 1056;\n    }\n\n    &.animate.open {\n            animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);\n    }\n\n    &.inline {\n        display: block;\n        position: relative;\n        top: 2px;\n        width: 100%;\n        box-shadow: none;\n\n        .flatpickr-rContainer {\n            display: block;\n            width: 100%;\n\n            .flatpickr-days {\n                width: 100%;\n                border: $input-border-width solid $input-border-color;\n                border-top: none;\n                border-radius: 0 0 5px 5px;\n\n\n                .dayContainer {\n                    width: 100%;\n                    min-width: 100%;\n                    max-width: 100%;\n\n                    .flatpickr-day {\n                        max-width: 100%;\n                        border-radius: 4px;\n                    }\n                }\n            }\n        }\n\n        .flatpickr-time {\n            border: $input-border-width solid $input-border-color !important;\n            border-radius: $input-border-radius;\n        }\n    }\n\n    &.static {\n        position: absolute;\n        top: calc(100% + 2px);\n        &.open {\n            z-index: 999;\n            display: block;\n        }\n    }\n\n    &.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7) {\n        box-shadow: none !important;\n    }\n\n    &.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1) {\n        box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n    }\n\n    .hasWeeks .dayContainer,\n    .hasTime .dayContainer {\n        border-bottom: 0;\n        border-bottom-right-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n\n    .hasWeeks .dayContainer {\n        border-left: 0;\n    }\n\n    &.hasTime .flatpickr-time {\n        height: 40px;\n        border-top: 1px solid var(--#{$prefix}border-color);\n    }\n\n    &.noCalendar.hasTime .flatpickr-time {\n        height: auto;\n    }\n\n    &::before,\n    &::after {\n        position: absolute;\n        display: block;\n        pointer-events: none;\n        border: solid transparent;\n        content: '';\n        height: 0;\n        width: 0;\n        left: 22px;\n    }\n\n    &.rightMost::before,\n    &.arrowRight::before,\n    &.rightMost::after,\n    &.arrowRight::after {\n      left: auto;\n      right: 22px;\n    }\n\n    &.arrowCenter::before,\n    &.arrowCenter::after {\n      left: 50%;\n      right: 50%;\n    }\n\n    &::before {\n        border-width: 5px;\n        margin: 0 -5px;\n    }\n    &::after {\n        border-width: 4px;\n        margin: 0 -4px;\n    }\n\n    &.arrowTop::before,\n    &.arrowTop::after {\n        bottom: 100%;\n    }\n    &.arrowTop::before {\n        border-bottom-color: $primary;\n    }\n    &.arrowTop::after {\n        border-bottom-color: $primary;\n    }\n\n    &.arrowBottom::before,\n    &.arrowBottom::after {\n        top: 100%;\n    }\n    &.arrowBottom::before {\n        border-top-color: $primary;\n    }\n    &.arrowBottom::after {\n        border-top-color: $primary;\n    }\n    &:focus {\n        outline: 0;\n    }\n}\n\n.flatpickr-wrapper {\n    position: relative;\n    display: inline-block;\n}\n\n.flatpickr-months {\n    display: flex;\n    background-color: $primary;\n    border-radius: 5px 5px 0px 0px;\n\n    .flatpickr-month {\n        background: transparent;\n        color: rgba($white, 0.9);\n        fill: rgba($white, 0.9);\n        height: 34px;\n        line-height: 1;\n        text-align: center;\n        position: relative;\n        user-select: none;\n        overflow: hidden;\n        flex: 1;\n    }\n\n    .flatpickr-prev-month,\n    .flatpickr-next-month {\n        text-decoration: none;\n        cursor: pointer;\n        position: absolute;\n        top: 0;\n        height: 34px;\n        padding: 10px;\n        z-index: 3;\n        color: rgba($white, 0.9);\n        fill: rgba($white, 0.9);\n\n        &.flatpickr-disabled{\n          display: none;\n        }\n\n        i {\n            position: relative;\n        }\n\n        &.flatpickr-prev-month {\n            /*\n                  /*rtl:begin:ignore*/\n            /*\n                  */\n              left: 0;\n            /*\n                  /*rtl:end:ignore*/\n            /*\n                  */\n        }\n          /*\n        /*rtl:begin:ignore*/\n        /*\n        /*rtl:end:ignore*/\n\n        &.flatpickr-next-month {\n            /*\n                  /*rtl:begin:ignore*/\n            /*\n                  */\n              right: 0;\n            /*\n                  /*rtl:end:ignore*/\n            /*\n                  */\n        }\n          /*\n        /*rtl:begin:ignore*/\n        /*\n        /*rtl:end:ignore*/\n\n        &:hover {\n            color: #959ea9;\n\n            svg {\n                fill: rgba($white, 0.9);\n            }\n        }\n\n        svg {\n            width: 14px;\n            height: 14px;\n\n            path {\n                transition: fill 0.1s;\n                fill: inherit;\n            }\n        }\n    }\n}\n\n.numInputWrapper {\n    position: relative;\n    height: auto;\n\n    input,\n    span {\n        display: inline-block;\n    }\n\n    input {\n        width: 100%;\n\n        &::-ms-clear {\n            display: none;\n        }\n\n        &::-webkit-outer-spin-button,\n        &::-webkit-inner-spin-button {\n            margin: 0;\n            -webkit-appearance: none;\n        }\n    }\n\n    span {\n        position: absolute;\n        right: 0;\n        width: 14px;\n        padding: 0 4px 0 2px;\n        height: 50%;\n        line-height: 50%;\n        opacity: 0;\n        cursor: pointer;\n        border: 1px solid rgba(var(--#{$prefix}dark-rgb),0.15);\n        box-sizing: border-box;\n\n        &:hover {\n            background: rgba(0,0,0,0.1);\n        }\n\n        &:active {\n            background: rgba(0,0,0,0.2);\n        }\n\n        &:after {\n            display: block;\n            content: \"\";\n            position: absolute;\n        }\n\n        &.arrowUp {\n            top: 0;\n            border-bottom: 0;\n\n            &:after {\n                border-left: 4px solid transparent;\n                border-right: 4px solid transparent;\n                border-bottom: 4px solid rgba(57,57,57,0.6);\n                top: 26%;\n            }\n        }\n\n        &.arrowDown {\n            top: 50%;\n\n            &:after {\n                border-left: 4px solid transparent;\n                border-right: 4px solid transparent;\n                border-top: 4px solid rgba(57,57,57,0.6);\n                top: 40%;\n            }\n        }\n\n        svg {\n            width: inherit;\n            height: auto;\n\n            path {\n                fill: rgba(0,0,0,0.5);\n            }\n        }\n    }\n\n\n    &:hover {\n        background: rgba(0,0,0,0.05);\n        span {\n            opacity: 1;\n        }\n    }\n}\n\n.flatpickr-current-month {\n    font-size: 100%;\n    line-height: inherit;\n    font-weight: 300;\n    color: inherit;\n    position: absolute;\n    width: 75%;\n    left: 12.5%;\n    padding: 7.48px 0 0 0;\n    line-height: 1;\n    height: 34px;\n    display: inline-block;\n    text-align: center;\n    transform: translate3d(0px, 0px, 0px);\n\n    span.cur-month {\n        font-family: inherit;\n        font-weight: 700;\n        color: inherit;\n        display: inline-block;\n        margin-left: 0.5ch;\n        padding: 0;\n\n        &:hover {\n            background: rgba(0,0,0,0.05);\n        }\n    }\n\n    .numInputWrapper {\n        width: 6ch;\n        width: 7ch\\0;\n        display: inline-block;\n    }\n\n    span{\n        &.arrowUp::after {\n            border-bottom-color: rgba(0,0,0,0.9);\n        }\n        &.arrowDown:after {\n            border-top-color: rgba(0,0,0,0.9);\n        }\n    }\n\n    input.cur-year {\n        background: transparent;\n        box-sizing: border-box;\n        color: inherit;\n        cursor: text;\n        padding: 0 0 0 0.5ch;\n        margin: 0;\n        display: inline-block;\n        font-size: inherit;\n        font-family: inherit;\n        font-weight: $font-weight-semibold;\n        line-height: inherit;\n        height: auto;\n        border: 0;\n        border-radius: 0;\n        vertical-align: initial;\n        appearance: textfield;\n\n        &:focus {\n            outline: 0;\n        }\n\n        &[disabled],\n        &[disabled]:hover {\n            font-size: 100%;\n            color: rgba($white, 0.9);\n            background: transparent;\n            pointer-events: none;\n        }\n    }\n\n    .flatpickr-monthDropdown-months {\n        appearance: menulist;\n        background: transparent;\n        border: none;\n        border-radius: 0;\n        box-sizing: border-box;\n        color: inherit;\n        cursor: pointer;\n        font-size: inherit;\n        font-family: inherit;\n        font-weight: $font-weight-semibold;\n        height: auto;\n        line-height: inherit;\n        margin: -1px 0 0 0;\n        outline: none;\n        padding: 0 0 0 0.5ch;\n        position: relative;\n        vertical-align: initial;\n        width: auto;\n\n        &:focus,\n        &:active {\n            outline: none;\n        }\n\n        &:hover {\n            background-color: transparent;\n        }\n\n        .flatpickr-monthDropdown-month {\n            background-color: transparent;\n            outline: none;\n            padding: 0;\n            color: rgba($black, 0.8);\n        }\n    }\n}\n\n\n.flatpickr-weekdays {\n    background-color: $primary;\n    text-align: center;\n    overflow: hidden;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    height: 36px;\n    border-bottom: 1px solid var(--#{$prefix}border-color);\n    .flatpickr-weekdaycontainer {\n        display: flex;\n        flex: 1;\n    }\n}\n\nspan.flatpickr-weekday {\n    cursor: default;\n    font-size: 90%;\n    background: $primary;\n    color: $white;\n    line-height: 1;\n    margin: 0;\n    text-align: center;\n    display: block;\n    flex: 1;\n    font-weight: $font-weight-medium;\n}\n\n.dayContainer,\n.flatpickr-weeks {\n    padding: 1px 0 0 0;\n}\n.flatpickr-days {\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    align-items: flex-start;\n    width: 307.875px;\n    &:focus {\n        outline: 0;\n    }\n}\n\n.dayContainer {\n    padding: 0;\n    outline: 0;\n    text-align: left;\n    width: 307.875px;\n    min-width: 307.875px;\n    max-width: 307.875px;\n    box-sizing: border-box;\n    display: inline-block;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    transform: translate3d(0px, 0px, 0px);\n    opacity: 1;\n    + .dayContainer {\n        box-shadow: -1px 0 0 #e6e6e6;\n    }\n}\n\n.flatpickr-day {\n    background: none;\n    border: 1px solid transparent;\n    border-radius: 150px;\n    box-sizing: border-box;\n    color: var(--#{$prefix}body-color);\n    cursor: pointer;\n    font-weight: 400;\n    width: 14.2857143%;\n    flex-basis: 14.2857143%;\n    max-width: 39px;\n    height: 39px;\n    line-height: 39px;\n    margin: 0;\n    display: inline-block;\n    position: relative;\n    justify-content: center;\n    text-align: center;\n\n    &:hover,\n    &:focus {\n        background-color: rgba(var(--#{$prefix}light-rgb), 0.7);\n    }\n\n    &.inRange,\n    &.prevMonthDay.inRange,\n    &.nextMonthDay.inRange,\n    &.today.inRange,\n    &.prevMonthDay.today.inRange,\n    &.nextMonthDay.today.inRange,\n    &:hover,\n    &.prevMonthDay:hover,\n    &.nextMonthDay:hover,\n    &:focus,\n    &.prevMonthDay:focus,\n    &.nextMonthDay:focus {\n        cursor: pointer;\n        outline: 0;\n        background-color: var(--#{$prefix}light);\n        border-color: var(--#{$prefix}light);\n    }\n\n    &.today {\n        border-color: $primary;\n        background-color: rgba($primary, 0.1);\n        box-shadow: $element-shadow;\n\n        &:hover,\n        &:focus {\n            border-color: $primary;\n            background-color: rgba($primary, 0.15);\n            color: var(--#{$prefix}body-color);\n        }\n    }\n\n    &.selected,\n    &.startRange,\n    &.endRange,\n    &.selected.inRange,\n    &.startRange.inRange,\n    &.endRange.inRange,\n    &.selected:focus,\n    &.startRange:focus,\n    &.endRange:focus,\n    &.selected:hover,\n    &.startRange:hover,\n    &.endRange:hover,\n    &.selected.prevMonthDay,\n    &.startRange.prevMonthDay,\n    &.endRange.prevMonthDay,\n    &.selected.nextMonthDay,\n    &.startRange.nextMonthDay,\n    &.endRange.nextMonthDay {\n        background: $primary;\n        box-shadow: $element-shadow;\n        color: $white;\n        border-color: $primary;\n    }\n\n    &.selected,\n    &.startRange,\n    &.endRange{\n        &.startRange {\n            border-radius: 50px 0 0 50px;\n            + .endRange:not(:nth-child(7n+1)) {\n                box-shadow: -10px 0 0 $primary;\n            }\n\n            .endRange{\n                border-radius: 50px;\n            }\n        }\n    }\n\n    &.selected,\n    &.startRange,\n    &.endRange{\n        &.endRange {\n            border-radius: 0 50px 50px 0;\n        }\n    }\n\n    &.inRange {\n        border-radius: 0;\n        box-shadow: -5px 0 0 var(--#{$prefix}light), 5px 0 0 var(--#{$prefix}light);\n    }\n\n    &.flatpickr-disabled,\n    &.flatpickr-disabled:hover,\n    &.prevMonthDay,\n    &.nextMonthDay,\n    &.notAllowed,\n    &.notAllowed.prevMonthDay,\n    &.notAllowed.nextMonthDay {\n        color: rgba(var(--#{$prefix}body-color-rgb),0.3);\n        background: transparent;\n        border-color: transparent;\n        cursor: default;\n    }\n\n    &.flatpickr-disabled,\n    &.flatpickr-disabled:hover {\n        cursor: not-allowed;\n        color: rgba(var(--#{$prefix}body-color-rgb),0.3);\n    }\n\n    &.week.selected {\n        border-radius: 0;\n        box-shadow: -5px 0 0 $primary, 5px 0 0 $primary;\n    }\n\n    &.hidden {\n        visibility: hidden;\n    }\n}\n\n.rangeMode .flatpickr-day {\n    margin-top: 1px;\n}\n\n.flatpickr-weekwrapper {\n    float: left;\n    .flatpickr-weeks {\n        padding: 0 12px;\n        box-shadow: 1px 0 0 var(--#{$prefix}border-color);\n    }\n\n    .flatpickr-weekday {\n        float: none;\n        width: 100%;\n        line-height: 35px;\n    }\n\n    span{\n        &.flatpickr-day,\n        &.flatpickr-day:hover {\n            display: block;\n            width: 100%;\n            max-width: none;\n            color: rgba(var(--#{$prefix}body-rgb),0.3);\n            background: transparent;\n            cursor: default;\n            border: none;\n        }\n    }\n}\n\n\n.flatpickr-innerContainer {\n    display: block;\n    display: flex;\n    box-sizing: border-box;\n    overflow: hidden;\n}\n\n.flatpickr-rContainer {\n    display: inline-block;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n.flatpickr-time {\n    text-align: center;\n    outline: 0;\n    display: block;\n    height: 0;\n    line-height: 40px;\n    max-height: 40px;\n    box-sizing: border-box;\n    overflow: hidden;\n    display: flex;\n\n    &:after {\n        content: \"\";\n        display: table;\n        clear: both;\n    }\n    .numInputWrapper {\n        flex: 1;\n        width: 40%;\n        height: 40px;\n        float: left;\n        span{\n            &.arrowUp, &.arrowDown{\n                &:after {\n                    border-bottom-color: var(--#{$prefix}border-color);\n                }\n            }\n        }\n    }\n\n    &.hasSeconds .numInputWrapper {\n        width: 26%;\n    }\n\n    &.time24hr .numInputWrapper {\n        width: 49%;\n    }\n\n\n    input {\n        background: transparent;\n        box-shadow: none;\n        border: 0;\n        border-radius: 0;\n        text-align: center;\n        margin: 0;\n        padding: 0;\n        height: inherit;\n        line-height: inherit;\n        color: var(--#{$prefix}body-color);\n        font-size: 14px;\n        position: relative;\n        box-sizing: border-box;\n        appearance: textfield;\n\n        &.flatpickr-hour {\n            font-weight: bold;\n        }\n\n        &.flatpickr-minute,\n        &.flatpickr-second {\n          font-weight: 400;\n        }\n\n        &:focus {\n            outline: 0;\n            border: 0;\n        }\n    }\n\n\n    .flatpickr-time-separator,\n    .flatpickr-am-pm {\n        height: inherit;\n        float: left;\n        line-height: inherit;\n        color: var(--#{$prefix}body-color);\n        font-weight: bold;\n        width: 2%;\n        user-select: none;\n        align-self: center;\n    }\n\n    .flatpickr-am-pm {\n        outline: 0;\n        width: 18%;\n        cursor: pointer;\n        text-align: center;\n        font-weight: 400;\n    }\n\n    input, .flatpickr-am-pm{\n        &:hover, &:focus{\n            background: rgba($primary, 0.04);\n        }\n    }\n}\n\n.flatpickr-am-pm,\n.numInput,\n.numInputWrapper {\n    &:focus,\n    &:hover {\n        background-color: transparent;\n    }\n}\n\n.flatpickr-input[readonly] {\n    cursor: pointer;\n    background-color: $input-bg;\n}\n\n[data-inline-date=\"true\"],[data-time-inline] {\n    display: none;\n}\n\n@keyframes fpFadeInDown {\n    from {\n        opacity: 0;\n        transform: translate3d(0, -20px, 0);\n    }\n    to {\n        opacity: 1;\n        transform: translate3d(0, 0, 0);\n    }\n}\n  \n[datepicker-inline],\n[timepicker-inline] {\n    display: none;\n}","// flag input\n\n[data-input-flag] {\n    position: relative;\n\n    .dropdown-menu {\n        .dropdown-menu-list {\n            max-height: 158px;\n            overflow-y: auto;\n\n            &::-webkit-scrollbar {\n                -webkit-appearance: none;\n            }\n\n            &::-webkit-scrollbar:vertical {\n                width: 8px;\n            }\n\n            &::-webkit-scrollbar:horizontal {\n                height: 10px;\n            }\n\n            &::-webkit-scrollbar-thumb {\n                background-color: rgba(var(--#{$prefix}dark-rgb), .075);\n                border-radius: 8px;\n            }\n\n            &::-webkit-scrollbar-track {\n                border-radius: 8px;\n            }\n        }\n    }\n}\n\n[data-option-flag-img-name] {\n    .flag-input {\n        padding-left: 45px;\n        background-image: url(\"../../images/flags/us.svg\");\n        background-repeat: no-repeat;\n        background-position: 14px 8px;\n        background-size: 18px;\n    }\n}\n\n[data-option-flag-name],\n[data-option-flag-img-name] {\n    &::before {\n        content: \"\\f0140\";\n        font-family: \"Material Design Icons\";\n        position: absolute;\n        right: $input-padding-x;\n        top: $input-padding-y;\n        font-size: 16px;\n    }\n}\n\n[data-option-countrycode=\"false\"] {\n    .country-codeno {\n        display: none;\n    }\n}\n\n[data-search-input=\"false\"] {\n    .searchlist-input {\n        display: none;\n    }\n}","//\n// _authentication.scss\n//\n\n\n.auth-page-wrapper{\n    .auth-page-content{\n        padding-bottom: $footer-height;\n        position: relative;\n        z-index: 2;\n        width: 100%;\n    }\n    .footer{\n        left: 0;\n        background-color: transparent;\n        color: var(--#{$prefix}body-color);\n    }\n}\n\n.auth-one-bg-position{\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 380px;\n    \n    @media (max-width: 575.98px) {\n        height: 280px;\n    }\n}\n\n.auth-one-bg{\n    background-image: url(\"../../images/avensys-header.png  \");\n    background-position: center;\n    background-size: cover;\n\n    .bg-overlay{\n        background: linear-gradient(to right, darken($indigo, 6%), $indigo);\n        opacity: 0.9;\n    }\n}\n\n.shape{\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    z-index: 1;\n    pointer-events: none;\n    >svg {\n        width: 100%;\n        height: auto;\n        fill: var(--#{$prefix}body-bg);\n    }\n}\n\n// auth-pass-inputgroup\n\n.auth-pass-inputgroup{\n    input[type=\"text\"] + .btn .ri-eye-fill{\n        &:before{\n            content: \"\\ecb6\";\n        }\n    }\n}\n\n.particles-js-canvas-el{\n    position: relative;\n}\n\n// signin card title\n\n.signin-other-title{\n    position: relative;\n    &:after{\n        content: \"\";\n        position: absolute;\n        width: 100%;\n        height: 1px;\n        left: 0;\n        right: 0;\n        border-top: 1px dashed var(--#{$prefix}border-color);\n        top: 10px;\n    }\n\n    .title{\n        display: inline-block;\n        position: relative;\n        z-index: 9;\n        background-color: var(--#{$prefix}secondary-bg);\n        padding: 2px 16px;\n    }\n}\n\n// Auth cover\n\n.auth-bg-cover{\n    background: $auth-bg-cover;\n\n    > .bg-overlay{\n        background-image: url(\"../../images/cover-pattern.png\");\n        background-position: center;\n        background-size: cover;\n        opacity: 1;\n        background-color: transparent;\n    }\n\n    .footer{\n        color: rgba($white, .5);\n    }\n}\n\n//passowrd validations \n#password-contain {\n    display: none;\n\n    p {\n        padding-left: 13px;\n\n        &.valid {\n            color: $success;\n\n            &::before {\n                position: relative;\n                left: -8px;\n                content: \"✔\";\n            }\n        }\n\n        &.invalid {\n            color: $danger;\n\n            &::before {\n                position: relative;\n                left: -8px;\n                content: \"✖\";\n            }\n        }\n    }\n}","// \n// _dashboard.scss\n// \n\n.dash-filter-picker {\n    min-width: 210px !important;\n}\n\n\n// Flatpickr Calendar\n\n.upcoming-scheduled{\n    position: relative;\n    @media (max-width: 575.98px) {\n        top: 35px !important;\n    }\n    .flatpickr-months{\n        position: absolute !important;\n        top: -45px !important;\n        left: auto !important;\n        right: 0px !important;\n        width: 200px;\n        background-color: transparent;\n\n        .flatpickr-month{\n            color: $gray-600 !important;\n            fill: $gray-600 !important;\n        }\n        .flatpickr-prev-month, .flatpickr-next-month{\n            display: none;\n        }\n    }\n    .flatpickr-calendar{\n        box-shadow: none !important;\n        .flatpickr-current-month {\n            font-size: 13px;\n            width: 100%;\n            left: 0;\n        }\n        .flatpickr-monthDropdown-months {\n            border: 1px solid var(--#{$prefix}border-color);\n            border-radius: 4px;\n            height: 26px;\n        }\n        .flatpickr-weekdays{\n            background-color: var(--#{$prefix}light);\n            border: none;\n            span.flatpickr-weekday {\n                color: var(--#{$prefix}body-color);\n                background-color: var(--#{$prefix}light);\n            }\n        }\n        .flatpickr-day{\n            &.today{\n                color: $white !important;\n                background-color: $success;\n                border-color: $success !important;\n                &:hover{\n                    color: $success !important;\n                    background-color: rgba($success, 0.2) !important;\n                }\n            }\n            &.selected{\n                background-color: $success !important;\n                border-color: $success !important;\n                color: $white;\n            }\n        }\n        .numInputWrapper {\n            width: 7.5ch;\n            margin-left: 10px;\n        }\n    }\n\n    .flatpickr-days {\n        border: none !important;\n    }\n}\n\n.crm-widget {\n    .col {\n        border-right: 1px solid var(--#{$prefix}border-color);\n        &:last-child {\n            border: 0px;\n        }\n        @media (min-width: 768px) and (max-width: 1399.98px) { \n            &:nth-child(3) {\n                border-right: 0px;\n            }\n            &:last-child { \n                border-right: 1px solid var(--#{$prefix}border-color);\n            }\n         }\n        @media (max-width: 767.98px) {\n            border-right: 0px;\n            border-bottom: 1px solid var(--#{$prefix}border-color);\n        }\n    }\n}   \n\n\n@media (min-width: 1400px) and (max-width: 1599.98px) { \n    .project-wrapper {\n        >.col-xxl-8, .col-xxl-4{\n            width: 100%;\n        }\n    }\n}\n\n.crypto-widget {\n    max-width: 130px !important;\n}\n\n//nft dashboard\n\n.bg-marketplace {\n    background-image: url(../../images/nft/marketplace.png);\n    background-size: cover;\n}\n\n.dash-countdown {\n    .countdownlist {\n        .count-num {\n            background-color: var(--#{$prefix}secondary-bg);\n            padding: 16px 8px;\n            font-size: 22px;\n\n            @media (max-width: 575.98px) {\n                font-size: 16px;\n                padding: 8px 6px;\n            }\n        }\n\n        .count-title {\n            @media (max-width: 575.98px) {\n                font-size: 10px;\n            }\n        }\n    }\n}\n\n[data-layout-width=\"boxed\"] {\n    .dash-countdown {\n        .countdownlist {\n            flex-wrap: wrap;\n        }\n    }\n}\n\n.marketplace-icon {\n    position: absolute;\n    float: right;\n    top: 30px;\n    left: 30px;\n}\n\n.marketplace-swiper {\n    .swiper-button-next,\n    .swiper-button-prev {\n        top: 34px;\n        width: 28px;\n        height: 28px;\n        background-color: rgba($primary, 0.1);\n        color: $primary;\n        border-radius: .3rem;\n        right: 16px !important;\n    }\n    .swiper-button-prev {\n        right: 58px !important;\n        left: auto !important;\n    }\n}\n\n.dash-collection {\n    .content{\n        background-color: rgba($white, 0.25);\n        backdrop-filter: blur(5px);\n    }\n}\n\n.dash-nft{\n    @media (max-width: 1441.98px) {\n        .col-xxl-9, .col-xxl-3 {\n            width: 100% !important;\n            max-width: 100% !important;\n        }\n    }\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {\n    width: 32px;\n    height: 32px;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n#portfolio_donut_charts {\n    .apexcharts-pie {\n        text {\n            fill: var(--#{$prefix}body-color);\n        }\n    }\n}","//\n// _timeline.scss\n//\n\n.timeline {\n    position: relative;\n    width: 100%;\n    max-width: 1400px;\n    margin: 0 auto;\n\n    &::after {\n        content: '';\n        position: absolute;\n        width: 2px;\n        background: $timeline-color;\n        top: 57px;\n        bottom: 166px;\n        left: 50%;\n        margin-left: -1.5px;\n    }\n}\n\n.timeline-item {\n    padding: 30px 60px;\n    position: relative;\n    background: inherit;\n    width: 50%;\n\n    .icon {\n        position: absolute;\n        display: inline-flex;\n        width: 60px;\n        height: 60px;\n        align-items: center;\n        justify-content: center;\n        font-size: 25px;\n        top: 30px;\n        right: -30px;\n        padding: 9px 0;\n        background: var(--#{$prefix}secondary-bg);\n        border: 1px solid var(--#{$prefix}border-color);\n        border-radius: 50px;\n        color: $success;\n        z-index: 1;\n    }\n\n    .date {\n        position: absolute;\n        display: inline-block;\n        width: calc(100% - 48px);\n        top: 50px;\n        font-size: 14px;\n        font-weight: 500;\n        font-style: italic;\n    }\n\n    .content {\n        padding: 20px;\n        background: var(--#{$prefix}secondary-bg);\n        position: relative;\n        border: 1px solid var(--#{$prefix}border-color);\n        border-radius: $border-radius;\n        box-shadow: $box-shadow-sm;\n    }\n\n    &.left {\n        left: 0;\n\n        .date {\n            left: calc(100% + 48px);\n            text-align: start;\n        }\n    }\n\n    &.right {\n        left: 50%;\n\n        .icon {\n            left: -30px;\n        }\n\n        .date {\n            right: calc(100% + 48px);\n            text-align: end;\n        }\n\n        &::before {\n            left: 28px;\n            border-color: transparent transparent transparent $white;\n        }\n    }\n}\n\n@media (max-width: 991.98px) {\n    .timeline {\n        &::after {\n            left: 24px;\n            bottom: 180px;\n        }\n    }\n\n    .timeline-item {\n        width: 100%;\n        padding-left: 48px;\n        padding-right: 0px;\n\n        &.right,  &.left {\n            left: 0%;\n\n            .icon {\n                width: 45px;\n                height: 45px;\n                top: 0;\n                font-size: 18px;\n                left: 0;\n            }\n\n            &::before {\n                left: 110px;\n                border-color: transparent transparent transparent var(--#{$prefix}border-color);\n            }\n\n            .date {\n                right: auto;\n                left: 48px;\n                width: 79px;\n                top: 8px;\n                text-align: left;\n            }\n        }\n    }\n}\n\n.timeline-2 {\n    position: relative;\n\n    &::after {\n        position: absolute;\n        content: \"\";\n        width: 2px;\n        height: 83%;\n        top: 50px;\n        left: 40px;\n        margin-left: -1px;\n        background: $timeline-color;\n    }\n\n    .timeline-year {\n        position: relative;\n        width: 100%;\n        text-align: left;\n        z-index: 1;\n\n        p {\n            display: inline-flex;\n            width: 80px;\n            height: 80px;\n            margin: 0;\n            padding: 23px 10px;\n            background: $timeline-color;\n            border-radius: 50px;\n            text-transform: uppercase;\n            align-items: center;\n            justify-content: center;\n            text-align: center;\n            span {\n                display: -webkit-box;\n                -webkit-line-clamp: 2;\n                -webkit-box-orient: vertical;\n                overflow: hidden;\n                text-overflow: ellipsis;\n            }\n        }\n    }\n\n    .timeline-date {\n        font-size: 14px;\n        font-weight: $font-weight-medium;\n        margin: 24px 0 0 0;\n        margin-left: 55px;\n\n        &::after {\n            content: '';\n            display: block;\n            position: absolute;\n            width: 14px;\n            height: 14px;\n            top: 26px;\n            left: 45px;\n            align-items: left;\n            background: $success;\n            border: 3px solid $timeline-color;\n            border-radius: 50px;\n            z-index: 1;\n        }\n    }\n\n    .timeline-box {\n        position: relative;\n        display: inline-block;\n        margin: 23px 62px;\n        padding: 20px;\n        border: 1px solid var(--#{$prefix}border-color);\n        border-radius: 6px;\n        background: var(--#{$prefix}secondary-bg);\n        max-width: 695px;\n        @media (max-width: 991.98px){\n            margin-right: 0;\n        }\n\n        &::after {\n            content: '';\n            display: block;\n            position: absolute;\n            width: 0;\n            height: 0;\n            border-style: solid;\n            top: 26px;\n            right: 100%;\n            border-color: transparent var(--#{$prefix}secondary-bg) transparent transparent;\n            border-width: 10px;\n        }\n\n        &::before {\n            content: '';\n            display: block;\n            position: absolute;\n            width: 0;\n            height: 0;\n            border-style: solid;\n            right: 100%;\n            top: 24px;\n            border-color: transparent var(--#{$prefix}border-color) transparent transparent;\n            border-width: 12px;\n        }\n\n        .timeline-text {\n            position: relative;\n            float: left;\n        }\n    }\n\n    .timeline-launch {\n        position: relative;\n        display: inline-block;\n        border: 1px solid var(--#{$prefix}border-color);\n        border-radius: 6px;\n        background: $white;\n        width: 100%;\n        margin-top: 15px;\n        padding: 0;\n        border: none;\n        text-align: left;\n        background: transparent;\n\n        .timeline-box {\n            margin-left: 0;\n\n            &::after {\n                left: 30px;\n                margin-left: 0px;\n                top: -20px;\n                border-color: transparent transparent var(--#{$prefix}border-color) transparent;\n            }\n\n            &::before {\n                left: 30px;\n                margin-left: 0px;\n                top: -19px;\n                border-color: transparent transparent var(--#{$prefix}secondary-bg) transparent;\n                border-width: 10px;\n                z-index: 1;\n            }\n        }\n\n    }\n}\n\n// Horizontal Timeline\n.horizontal-timeline {\n    position: relative;\n    width: 100%;\n    margin: 0 auto;\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        width: 100%;\n        top: 174px;\n        left: 0;\n        height: 2px;\n        background-color: $timeline-color;\n    }\n\n    .swiper-slide {\n        .item-box {\n            margin: 227px 0px 0px;\n            background-color: transparent;\n            box-shadow: none;\n\n            &::after {\n                content: \"\";\n                position: absolute;\n                left: 0px;\n                right: 0px;\n                margin: 0px auto;\n                background: $primary;\n                width: 13px;\n                height: 13px;\n                top: -59px;\n                border-radius: 50px;\n                border: 3px solid $timeline-color;\n            }\n        }\n\n        .timeline-content {\n            min-height: 110px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            position: relative;\n            background-color: $timeline-color;\n\n            &::before {\n                content: '';\n                display: block;\n                position: absolute;\n                width: 0;\n                height: 0;\n                border-style: solid;\n                left: 0px;\n                top: -23px;\n                border-color: transparent transparent $timeline-color transparent;\n                border-width: 12px;\n                right: 0;\n                margin: 0 auto;\n            }\n        }\n\n        .time {\n            position: absolute;\n            top: -86px;\n            right: 0px;\n            left: 0px;\n            margin: 0px auto;\n        }\n\n        &:nth-child(even) {\n            margin-top: 5px;\n            transform: rotate(-180deg);\n\n            .timeline-content {\n                transform: rotate(180deg);\n\n                &::before {\n                    bottom: -23px;\n                    top: auto;\n                    border-color: $timeline-color transparent transparent transparent;\n                }\n            }\n\n            .time {\n                transform: rotate(180deg);\n            }\n        }\n    }\n\n    .swiper-button-next,\n    .swiper-button-prev {\n        height: 40px;\n        width: 40px;\n        line-height: 40px;\n        border-radius: 50%;\n        background-color: lighten($primary, 2.5%);\n\n        &::after {\n            font-size: 24px;\n            color: $white;\n        }\n        &.swiper-button-disabled {\n            background-color: rgba($primary, 0.5);\n            opacity: 1;\n            cursor: auto;\n            backdrop-filter: blur(25px);\n            pointer-events: none\n        }\n    }\n\n    .swiper-button-next {\n        right: 0;\n\n        &::after {\n            content: \"\\EA6E\";\n            font-family: remixicon;\n        }\n    }\n\n    .swiper-button-prev {\n        left: 0;\n\n        &::after {\n            content: \"\\EA64\";\n            font-family: remixicon;\n        }\n    }\n}\n\n//activity-timeline\n\n.acitivity-timeline {\n    position: relative;\n    overflow: hidden;\n\n    .acitivity-item {\n        position: relative;\n\n        .flex-shrink-0 {\n            z-index: 2;\n        }\n\n        .acitivity-avatar {\n            background-color: var(--#{$prefix}secondary-bg);\n            border: 3px solid var(--#{$prefix}secondary-bg);\n            height: 32px;\n            width: 32px;\n        }\n\n        &:before {\n            content: \"\";\n            position: absolute;\n            border-left: 1px dashed var(--#{$prefix}border-color);\n            left: 16px;\n            height: 100%;\n            top: 5px;\n            z-index: 0;\n        }\n        &:last-child {\n           &::before {\n               border-color: transparent;\n           }\n        }\n    }\n}","    //\n// _gallery.scss\n//\n\n.categories-filter {\n    .list-inline-item {\n        position: relative;\n        margin-right: 0;\n\n        a {\n            display: block;\n            color: var(--#{$prefix}body-color);\n            font-weight: $font-weight-semibold;\n            padding: 8px 15px;\n            margin: 5px;\n            cursor: pointer;\n        }\n    }\n}\n\n.gallery-box {\n    position: relative;\n    overflow: hidden;\n    border: 1px solid transparent;\n    margin-bottom: 10px;\n    box-shadow: none;\n    background-color: transparent;\n    padding: 8px;\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        width: 100%;\n        height: 0;\n        background-color: var(--#{$prefix}secondary-bg);\n        transition: all 0.4s;\n    }\n\n    .gallery-container {\n        position: relative;\n        overflow: hidden;\n        border-radius: 4px;\n\n        a {\n            display: block;\n        }\n\n        .gallery-overlay {\n            position: absolute;\n            top: 0px;\n            left: 0px;\n            bottom: 0px;\n            right: 0px;\n            opacity: 0;\n            background: linear-gradient(180deg, rgba(0, 0, 0, 0) 10%, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, .5) 100%);\n            visibility: hidden;\n            overflow: hidden;\n            transition: all 0.4s ease-in-out 0s;\n            display: flex;\n            width: 100%;\n            align-items: flex-end;\n            padding: 16px;\n\n            .overlay-caption {\n                color: $white;\n                margin: 0;\n                font-size: 16px;\n            }\n        }\n    }\n\n    .gallery-img {\n        transition: all 0.2s ease-in-out;\n    }\n\n    .box-content {\n        position: relative;\n\n        .title {\n            font-size: 14px;\n            margin-bottom: 4px;\n            display: none;\n        }\n\n        .post {\n            margin: 0;\n            transition: all 0.2s;\n            color: var(--#{$prefix}secondary-color);\n        }\n    }\n\n    &:hover {\n        &::before {\n            height: 100%;\n        }\n\n        .box-content {\n            bottom: 0;\n\n            .post {\n                opacity: 1;\n            }\n        }\n\n        .gallery-overlay {\n            opacity: 1;\n            visibility: visible;\n        }\n    }\n}\n\n.gallery-light {\n    .gallery-box {\n        &::before {\n            background-color: var(--#{$prefix}light);\n        }\n    }\n}","//\n// _errors.scss\n//\n\n.error-basic-img{\n    max-width: 450px;\n}\n\n.error-500 {\n    .title {\n        font-size: 250px;\n    }\n\n    .error-500-img {\n        position: absolute;\n        top: 57px;\n        left: 0;\n        right: 0;\n        margin: 0 auto;\n    }\n\n    @media (min-width: 768px) and (max-width: 991.98px) {\n        .title {\n            font-size: 150px;\n        }\n\n        .error-500-img {\n            width: 20% !important;\n            top: 43px;\n        }\n    }\n\n    @media (max-width: 767.98px) {\n        .title {\n            font-size: 68px;\n            margin-top: 35px;\n        }\n\n        .error-500-img {\n            position: relative;\n            top: 0px;\n        }\n    }\n}\n\n\n@keyframes errorAnimation {\n    0% {\n        transform: translateX(0%);\n    }\n\n    15% {\n        transform: translateX(-25%) rotate(-5deg);\n    }\n\n    30% {\n        transform: translateX(20%) rotate(3deg);\n    }\n\n    45% {\n        transform: translateX(-15%) rotate(-3deg);\n    }\n\n    60% {\n        transform: translateX(10%) rotate(2deg);\n    }\n\n    75% {\n        transform: translateX(-5%) rotate(-1deg);\n    }\n\n    100% {\n        transform: translateX(0%);\n    }\n}\n\n.error-img {\n    animation: errorAnimation 20s infinite;\n}","//\n// _profile.scss\n//\n\n.error-text {\n    text-shadow: 4px 4px rgba($success, 0.4);\n\n    @media (min-width: 1200px) {\n        font-size: 10rem;\n    }\n}\n\n\n// profile\n\n.profile-wid-bg {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    height: 320px;\n    @media (max-width: 575.98px) {\n        height: 445px;\n    }\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        opacity: 0.9;\n        background: $primary;\n        background: linear-gradient(to top, darken($primary, 25%), $primary);\n\n    }\n\n    .profile-wid-img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n}\n\n.profile-nav {\n    &.nav-pills {\n        .nav-link {\n            color: rgba($white, 0.8);\n\n            &::before {\n                background-color: rgba($white, 0.1);\n            }\n        }\n    }\n}\n\n.profile-project-card {\n    border: 1px solid var(--#{$prefix}border-color);\n    border-left: 3px solid var(--#{$prefix}border-color);\n}\n\n@each $color,\n$value in $theme-colors {\n    .profile-project-card {\n        &.profile-project-#{$color} {\n            border-left-color: $value;\n        }\n    }\n}\n\n.user-profile-img {\n    position: relative;\n\n    .profile-img {\n        width: 100%;\n        height: 250px;\n        object-fit: cover;\n\n        @media (max-width:991px) {\n            height: 160px;\n        }\n    }\n\n    .profile-foreground-img-file-input {\n        display: none;\n    }\n\n    .profile-photo-edit {\n        cursor: pointer;\n    }\n}\n\n.profile-user {\n    position: relative;\n    display: inline-block;\n\n    .profile-photo-edit {\n        position: absolute;\n        right: 0;\n        left: auto;\n        bottom: 0;\n        cursor: pointer;\n    }\n\n    .user-profile-image {\n        object-fit: cover;\n    }\n\n    .profile-img-file-input {\n        display: none;\n    }\n}\n\n.profile-timeline {\n    .accordion-item {\n        position: relative;\n\n        .accordion-button {\n            background-color: transparent;\n\n            &::after {\n                background: none;\n            }\n        }\n\n        &::before {\n            content: \"\";\n            border-left: 2px dashed var(--#{$prefix}border-color);\n            position: absolute;\n            height: 100%;\n            left: 23px;\n        }\n\n        &:first-child {\n            &::before {\n                top: 8px;\n            }\n        }\n\n        &:last-child {\n            &::before {\n                height: 20px;\n                top: 3px;\n            }\n        }\n    }\n}\n\n.profile-setting-img {\n    position: relative;\n    height: 260px;\n\n    .overlay-content {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        right: 0;\n    }\n\n    .profile-img {\n        width: 100%;\n        height: 250px;\n        object-fit: cover;\n\n        @media (max-width:991.98px) {\n            height: 160px;\n        }\n    }\n\n    .profile-foreground-img-file-input {\n        display: none;\n    }\n\n    .profile-photo-edit {\n        cursor: pointer;\n    }\n}\n\n@media (max-width:575.98px) {\n\n    [data-layout=\"horizontal\"]{\n        .profile-foreground{\n            margin-top: 0 !important;\n        }\n    }\n}\n\n[data-layout=\"semibox\"] {\n    .profile-wrapper {\n        padding: 0 $card-spacer-x;\n    }\n}","//\n// _sitemap.scss\n//\n\n.sitemap-content {\n    width: 100%;\n    max-width: 1142px;\n    margin: 0 auto;\n    padding: 0 20px;\n\n    * {\n        position: relative;\n    }\n}\n\n.sitemap-horizontal {\n    position: relative;\n\n    ul {\n        padding: 0;\n        margin: 0;\n        list-style: none;\n\n        a {\n            display: block;\n            background: var(--#{$prefix}light);\n            border: 2px solid var(--#{$prefix}secondary-bg);\n            box-shadow: $box-shadow;\n            font-size: $font-size-base;\n            height: 60px;\n            padding: 8px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            span {\n                display: -webkit-box;\n                -webkit-line-clamp: 2;\n                -webkit-box-orient: vertical;\n                overflow: hidden;\n                text-overflow: ellipsis;\n            }\n        }\n    }\n}\n\n.administration {\n    .director {\n        >li {\n            >a {\n                width: 50%;\n                margin: 0 auto 0px auto;\n                border-radius: 4px;\n            }\n        }\n    }\n\n    .subdirector {\n        position: absolute;\n        width: 100%;\n\n        &::after {\n            content: \"\";\n            display: block;\n            width: 0;\n            height: 130px;\n            border-left: 2px dashed var(--#{$prefix}border-color);\n            left: 45.45%;\n            position: relative;\n        }\n\n        >li {\n            &:first-child {\n                width: 18.59%;\n                height: 64px;\n                margin: 0 auto 92px auto;\n                padding-top: 25px;\n                border-bottom: 2px dashed var(--#{$prefix}border-color);\n                z-index: 1;\n                float: right;\n                right: 27.2%;\n                border-left: 2px dashed var(--#{$prefix}border-color);\n\n                a {\n                    width: 100%;\n                    left: 25px;\n                }\n            }\n        }\n    }\n\n    @media screen and (max-width: 767px) {\n        .subdirector {\n            >li {\n                &:first-child {\n                    width: 40%;\n                    right: 10%;\n                    margin-right: 2px;\n                }\n            }\n\n            &::after {\n                left: 49.8%;\n            }\n        }\n    }\n}\n\n.departments {\n    width: 100%;\n\n    >li {\n        &:first-child {\n            width: 18.59%;\n            height: 64px;\n            margin: 0 auto 92px auto;\n            padding-top: 25px;\n            border-bottom: 2px dashed var(--#{$prefix}border-color);\n            z-index: 1;\n            float: left;\n            left: 27%;\n\n            a {\n                width: 100%;\n                right: 25px;\n            }\n        }\n\n        &:nth-child(2) {\n            margin-left: 0;\n            clear: left;\n\n            &.department {\n                &:before {\n                    border: none;\n                }\n            }\n        }\n    }\n\n    &::after {\n        content: \"\";\n        display: block;\n        position: absolute;\n        width: 81.1%;\n        height: 22px;\n        border-top: 2px dashed var(--#{$prefix}border-color);\n        border-right: 2px dashed var(--#{$prefix}border-color);\n        border-left: 2px dashed var(--#{$prefix}border-color);\n        margin: 0 auto;\n        top: 130px;\n        left: 9.1%\n    }\n\n    @media screen and (max-width: 767px) {\n        >li {\n            &:first-child {\n                width: 40%;\n                left: 10%;\n                margin-left: 2px;\n            }\n        }\n\n        &::after {\n            border-right: none;\n            left: 0;\n            width: 50%;\n        }\n    }\n}\n\n.department {\n    border-left: 2px dashed var(--#{$prefix}border-color);\n    float: left;\n    margin-left: 1.75%;\n    margin-bottom: 60px;\n    width: 18.25%;\n\n    &::before {\n        content: \"\";\n        display: block;\n        position: absolute;\n        width: 0;\n        height: 22px;\n        border-left: 2px dashed var(--#{$prefix}border-color);\n        z-index: 1;\n        top: -22px;\n        left: 50%;\n        margin-left: -4px;\n    }\n\n    >a {\n        margin: 0 0 -26px -4px;\n        z-index: 1;\n    }\n\n    ul {\n        margin-top: 0px;\n        margin-bottom: 0px;\n\n        li {\n            padding-left: 25px;\n            border-bottom: 2px dashed var(--#{$prefix}border-color);\n            height: 80px;\n\n            a {\n                background: var(--#{$prefix}secondary-bg);\n                margin-top: 48px;\n                position: absolute;\n                z-index: 1;\n                width: 90%;\n                height: 60px;\n                vertical-align: middle;\n                right: -1px;\n                text-align: center;\n            }\n        }\n    }\n\n    &:first-child {\n        margin-left: 0;\n        clear: left;\n    }\n\n    @media screen and (min-width: 768px) {\n        &:last-child:before {\n            border: none;\n        }\n    }\n\n    @media screen and (max-width: 767px) {\n        float: none;\n        width: 100%;\n        margin-left: 0;\n\n        &::before {\n            content: \"\";\n            display: block;\n            position: absolute;\n            width: 0;\n            height: 60px;\n            border-left: 2px dashed $white;\n            z-index: 1;\n            top: -60px;\n            left: 0%;\n            margin-left: -4px;\n        }\n\n        &:nth-child(2) {\n            &::before {\n                display: none;\n            }\n        }\n    }\n}\n\n\n\n// sitemap\n\n.hori-sitemap {\n    ul {\n        padding: 0;\n        padding-top: 10px;\n        text-align: center;\n        li {\n            position: relative;\n        }\n        @media (max-width: 575.98px) {\n            text-align: left;\n            .parent-title {\n                a {\n                    padding-left: 0;\n                    &:after {\n                        display: none;\n                    }\n                }\n\n                &:before {\n                    display: none;\n                }\n            }\n        }\n    }\n\n    @media (max-width: 575.98px) {\n        >ul {\n            position: relative;\n            li {\n                padding-top: 10px;\n                .second-list,\n                .sub-list {\n                    position: relative;\n\n                    &:before {\n                        content: \"\";\n                        height: calc(100% - 14px);\n                        border-right: 2px dashed var(--#{$prefix}border-color);\n                        position: absolute;\n                        top: 0px;\n                        left: 0px;\n                    }\n                }\n                .sub-list {\n                    &:before {\n                        height: 38%;\n                    }\n                }\n                a {\n                    position: relative;\n                    padding: 4px 16px 4px 36px;\n\n                    &:after {\n                        content: \"\";\n                        width: 24px;\n                        border-top: 2px dashed var(--#{$prefix}border-color);\n                        position: absolute;\n                        top: 50%;\n                        transform: translateY(-50%);\n                        left: 0;\n                    }\n                }\n\n                ul {\n                    margin-left: 36px;\n                }\n            }\n        }\n    }\n    @media (min-width: 576px) {\n        ul {\n            padding-top: 20px;\n            li {\n                padding-top: 30px;\n\n                &:before {\n                    content: \"\";\n                    height: 24px;\n                    width: 0;\n                    border-right: 2px dashed var(--#{$prefix}border-color);\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    right: 0;\n                    margin: 0px auto;\n                }\n\n                &:after {\n                    content: \"\";\n                    width: 100%;\n                    border-top: 2px dashed var(--#{$prefix}border-color);\n                    position: absolute;\n                    top: 0;\n                    left: 50%;\n                }\n\n                &:last-of-type {\n                    &:after {\n                        display: none;\n                    }\n                }\n\n                &.parent-title {\n                    &::before {\n                        content: \"\";\n                        height: 23px;\n                        border-right: 2px dashed var(--#{$prefix}border-color);\n                        position: absolute;\n                        top: 28px;\n                        left: 0;\n                    }\n                    &::after {\n                        border: none;\n                    }\n                }\n\n                .sub-title {\n                    position: relative;\n\n                    &::before {\n                        content: \"\";\n                        height: 21px;\n                        border-right: 2px dashed var(--#{$prefix}border-color);\n                        position: absolute;\n                        top: 27px;\n                        left: 49%;\n                        margin: 0 auto;\n                    }\n                }\n            }\n        }\n    }\n\n    a {\n        color: var(--#{$prefix}body-color);\n        padding: 4px 0px;\n        display: block;\n\n    }\n}\n\n\n// vertical sitemap\n.verti-sitemap { \n    a {\n        color: var(--#{$prefix}body-color);\n        display: block;\n    }\n    .parent-title {\n        a {\n            padding-left: 0;\n\n            &:before {\n                display: none;\n            }\n        }\n\n        &:before {\n            display: none;\n        }\n    }\n    .first-list {\n        position: relative;\n        padding-top: 10px;\n        &:before {\n            content: \"\";\n            border-left: 2px dashed var(--#{$prefix}border-color);\n            position: absolute;\n            top: 0;\n            height: 100%;\n            bottom: 0;\n            left: 0;\n        }\n        .list-wrap, li {\n            a {\n                position: relative;\n                padding: 10px 16px 4px 36px;\n                &::before {\n                    content: \"\";\n                    width: 24px;\n                    border-top: 2px dashed var(--#{$prefix}border-color);\n                    position: absolute;\n                    top: 50%;\n                    transform: translateY(-50%);\n                    left: 0;\n                }\n            }\n        }\n        .second-list, .third-list {\n            margin-left: 42px;\n            \n        }\n\n        .third-list, .second-list {\n            position: relative;\n            li {\n                position: relative;\n                &:before {\n                    content: \"\";\n                    height: 100%;\n                    border-left: 2px dashed var(--#{$prefix}border-color);\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    margin: 0px auto;\n                }\n                &:last-child {\n                    &::before {\n                        height: 13px;\n                    }\n                }\n            }\n        }\n        \n        &:last-child {\n            &::before {\n                height: 25px;\n            }\n        }\n    }\n}\n\n","//\n// _team.scss\n//\n\n.team-box .team-cover, .profile-offcanvas .team-cover, .modal-team-cover{\n    display: none;\n    position: relative;\n    margin-bottom: -140px;\n\n    img {\n        height: 140px;\n        width: 100%;\n        object-fit: cover;\n    }\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        background: linear-gradient(to top, darken($primary, 25%), $primary);\n        opacity: 0.6;\n    }\n}\n\n.team-list {\n    &.grid-view-filter {\n        flex-flow: row wrap;\n\n        .col {\n            flex: 0 0 auto;\n            width: 25%;\n        }\n\n        .team-box {\n            overflow: hidden;\n\n            .team-row {\n                align-items: start;\n\n                .col {\n                    width: 100%;\n                }\n            }\n\n            .team-cover {\n                display: block;\n            }\n\n            .team-settings {\n                .col {\n                    width: 50% !important;\n                    flex: 0 0 auto;\n                }\n\n                .btn-star {\n                    color: $white;\n                }\n\n                .dropdown {\n                    >a {\n                        color: $white;\n                    }\n                }\n            }\n\n            .team-profile-img {\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                margin-bottom: 25px;\n                margin-top: 36px;\n\n                .avatar-lg {\n                    font-size: 22px;\n                }\n\n                .team-content {\n                    margin-left: 0px;\n                    margin-top: 25px;\n                    text-align: center;\n                }\n            }\n\n            .view-btn {\n                width: 100%;\n                margin-top: 25px;\n            }\n        }\n\n        @media (min-width: 1200px) and (max-width: 1399.98px) {\n            .col {\n                flex: 0 0 auto;\n                width: 33.33%;\n            }\n        }\n\n        @media (max-width: 1199.98px) {\n            .col {\n                flex: 0 0 auto;\n                width: 50%;\n            }\n        }\n\n        @media (max-width: 767.98px) {\n            .col {\n                flex: 0 0 auto;\n                width: 100%;\n            }\n        }\n    }\n\n    &.list-view-filter {\n        flex-direction: column;\n\n        .team-box {\n            margin-bottom: 10px;\n\n            .team-row {\n                align-items: center;\n                justify-content: space-between;\n            }\n\n            .team-profile-img {\n                display: flex;\n                align-items: center;\n\n                .avatar-lg {\n                    height: 4rem;\n                    width: 4rem;\n                    font-size: 16px;\n                }\n\n                .team-content {\n                    margin-left: 15px;\n                }\n            }\n\n            .team-settings {\n                width: auto;\n                flex: 0 0 auto;\n                -webkit-box-ordinal-group: 7;\n                order: 6;\n            }\n\n            .btn-star {\n                color: $primary;\n            }\n        }\n\n        @media (max-width: 767.98px) {\n            flex-direction: row;\n            .col {\n                -webkit-box-flex: 0;\n                -ms-flex: 0 0 auto;\n                flex: 0 0 auto;\n                width: 100%;\n            }\n            .team-box {\n\n                .team-settings {\n                    width: 100%;\n                    flex: 0 0 auto;\n                    order: -1;\n                    margin-bottom: 10px;\n\n                    .col {\n                        width: 50%;\n                    }\n                }\n\n                .team-profile-img {\n                    margin-bottom: 25px;\n                }\n\n                .view-btn {\n                    width: 100%;\n                    margin-top: 25px;\n                }\n            }\n        }\n    }\n}\n\n.modal-team-cover{\n    display: block;\n}\n\n.list-grid-nav {\n    .nav-link {\n        &.active {\n            background-color: $info;\n            color: $white;\n        }\n    }\n}\n\n.profile-offcanvas  {\n    .team-cover {\n        margin-bottom: -132px;\n        display: block;\n        z-index: -1;\n    }\n    .btn-star {\n        color: $white;\n    }\n\n    .dropdown {\n        >a {\n            color: $white;\n        }\n    }\n}","// \n// _coming-soon.scss\n//\n\n// countdownlist\n\n.countdownlist {\n    text-align: center;\n    display: flex;\n    gap: 24px;\n\n\n    .countdownlist-item{\n        width: 25%;\n        &:last-of-type{\n            .count-num{\n                &::after{\n                    display: none;\n                }\n            }\n        }\n    }\n    .count-title{\n        font-size: 13px;\n        font-weight: $font-weight-medium;\n        display: block;\n        margin-bottom: 8px;\n        color: rgba(var(--#{$prefix}body-color-rgb), 0.5);\n        text-transform: uppercase;\n    }\n\n    .count-num{\n        background-color: var(--#{$prefix}secondary-bg);\n        padding: 16px 8px;\n        position: relative;\n        border-radius: $card-border-radius;\n        box-shadow: $box-shadow;\n        font-weight: $font-weight-semibold;\n        font-size: 32px;\n        @media (max-width: 575.98px) {\n            font-size: 18px;\n        }\n    \n        &::after{\n            content: \":\";\n            font-size: 20px;\n            position: absolute;\n            right: -16px;\n            top: 50%;\n            transform: translateY(-50%);\n            color: var(--#{$prefix}body-color);\n        }\n    }\n}\n// coming soon \n\n.move-animation{\n    animation: mover 1s infinite  alternate;\n}\n\n@keyframes mover {\n    0% { transform: translateY(0); }\n    100% { transform: translateY(-16px); }\n}\n\n.coming-soon-text{\n    font-weight: $font-weight-semibold;\n    text-transform: uppercase;\n    color: $white;\n    text-shadow: 3px 4px $success;\n}\n\n.countdown-input-group{\n    max-width: 400px;\n}\n","//\n// _search-results.scss\n//\n\n.search-more-results {\n    position: relative;\n    overflow: hidden;\n\n    .nav-icon {\n        font-size: 14px;\n        color: $white;\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        text-align: center;\n        left: 0;\n        right: 0;\n\n        i {\n            font-size: 20px;\n        }\n\n        @media (max-width: 767.98px) {\n            font-size: 14px;\n\n            i {\n                font-size: 18px;\n            }\n        }\n    }\n}\n\n.video-list {\n    .list-element {\n        display: none;\n        &:nth-child(1) {\n            display: block;\n        }\n        &:nth-child(2) {\n            display: block;\n        }\n        &:nth-child(3) {\n            display: block;\n        }\n    }\n}\n\n.search-voice {\n    height: 120px;\n    width: 120px;\n    line-height: 120px;\n    margin: 0px auto;\n    text-align: center;\n    border-radius: 50%;\n    z-index: 1;\n    position: relative;\n\n    i {\n        line-height: 56px;\n        font-size: 30px;\n    }\n\n    .voice-wave {\n        position: absolute;\n        width: 120px;\n        height: 120px;\n        z-index: -1;\n        left: 0px;\n        right: 0px;\n        margin: 0px auto;\n        opacity: 0;\n        border-radius: 100px;\n        animation: voice-wave 1.8s infinite;\n        background-color: var(--#{$prefix}light);\n\n        &:nth-child(2) {\n            animation-delay: 0.3s;\n        }\n\n        &:nth-child(3) {\n            animation-delay: 0.6s;\n        }\n    }\n}\n\n@keyframes voice-wave {\n    0% {\n        opacity: 1;\n        transform: scale(0);\n    }\n\n    100% {\n        opacity: 0;\n        transform: scale(1);\n    }\n}\n\n.images-menu {\n    .swiper-slide {\n        width: auto;\n        display: inline-block;\n    }\n}","//\n// _ecommerce.scss\n//\n\n// product list\n\n#selection-element { \n    display: none;\n}\n\n.filter-choices-input{\n    .choices__inner{\n        padding: 0;\n        border: none;\n        background-color: var(--#{$prefix}secondary-bg);\n    }\n\n    .choices__input{\n        background-color: var(--#{$prefix}secondary-bg);\n    }\n}\n\n//  product detail\n\n.sticky-side-div{\n    @media (min-width: 992px){\n        position: sticky;\n        top: calc(#{$header-height} + #{$grid-gutter-width});\n    }\n}\n\n.product-img-slider{\n    .product-nav-slider{\n        .nav-slide-item{\n            border: 1px solid var(--#{$prefix}border-color);\n            border-radius: $border-radius;\n            padding: 0.5rem;\n            cursor: pointer;\n        }\n\n        .swiper-slide-thumb-active{\n            .nav-slide-item{\n                background-color: var(--#{$prefix}light);\n            }\n        }\n    }\n}\n\n.filter-list{\n    a {\n        &.active {\n            .listname {\n                color: var(--#{$prefix}success);\n            }\n        }   \n    }\n}\n\n#remove-actions{\n    display: none;\n}","//\n// _invoice.scss\n//\n\n.invoice-table {\n    tbody {\n        &:last-child {\n            border: none;\n        }\n    }\n}\n\n.currency-select {\n    .choices__inner {\n        padding:0px;\n        padding-right: 15px;\n        min-height: 0px;\n    }\n    .choices__list--single {\n        padding: 0px 16px 0 4px;\n    }\n    .choices[data-type*=select-one]{\n        bottom: 0px;\n        :after { \n            top: 4px;\n        }\n        .choices__inner {\n            padding-bottom: 0px;\n        }\n    }\n}","//\n// _chat.scss\n//\n\n.chat-wrapper{\n    position: relative;\n    overflow-x: hidden;\n}\n\n// chat left sidebar\n\n.chat-leftsidebar {\n    height: calc(100vh - 137px);\n    position: relative;\n    background-color: var(--#{$prefix}secondary-bg);\n\n    @media (min-width: 992px) {\n        min-width: 300px;\n        max-width: 300px;\n        height: calc(100vh - #{$header-height} - #{$footer-height} - 8px);\n    }\n}\n\n\n.chat-list {\n    margin: 0;\n\n    > li {\n        &.active {\n            a {\n                background-color: $chat-secondary-bg;\n                color: $chat-secondary-color;\n\n                .badge {\n                    background-color: rgba(var(--#{$prefix}success-rgb), 0.15) !important;\n                    color: $success !important;\n                }\n            }\n        }\n\n        a {\n            display: block;\n            padding: 7px 24px;\n            color: var(--#{$prefix}body-color);\n            transition: all 0.4s;\n            font-family: $font-family-secondary;\n            font-weight: $font-weight-medium;\n            font-size: $font-size-base;\n        }\n\n        .chat-user-message {\n            font-size: 14px;\n        }\n\n        .unread-msg-user {\n            font-weight: $font-weight-semibold;\n        }\n\n        .unread-message {\n            position: absolute;\n            display: inline-block;  \n            right: 24px/*rtl:auto*/;\n            left: auto/*rtl:0*/;\n            top: 33px;\n\n            .badge {\n                line-height: 16px;\n                font-weight: $font-weight-semibold;\n                font-size: 10px;\n            }\n        }\n    }\n}\n\n.chat-user-img {\n    position: relative;\n\n    .user-status {\n        width: 10px;\n        height: 10px;\n        background-color: $gray-500;\n        border-radius: 50%;\n        border: 2px solid var(--#{$prefix}secondary-bg);\n        position: absolute;\n        right: 0;\n        left: auto;\n        bottom: 0;\n    }\n\n    &.online {\n        .user-status {\n            background-color: $success;\n        }\n    }\n\n    &.away {\n        .user-status {\n            background-color: $warning;\n        }\n    }\n}\n\n.chat-room-list {\n    max-height: calc(100vh - 296px);\n\n    @media (max-width: 991.98px) {\n        height: calc(100vh - 296px);\n    }\n}\n\n// contact list\n\n.contact-list {\n    li {\n        cursor: pointer;\n        padding: 8px 24px;\n        transition: all 0.4s;\n        color: var(--#{$prefix}body-color);\n        font-family: $font-family-secondary;\n        font-weight: $font-weight-medium;\n        font-size: $font-size-base;\n    }\n}\n\n.contact-list-title{\n    padding: 6px 24px;\n    color: $primary;\n    font-weight: $font-weight-medium;\n    position: relative;\n    font-size: 12px;\n    &:after{\n        content: \"\";\n        height: 1px;\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        left: 50px;\n        right: 0;\n        background-color: var(--#{$prefix}light);\n    }\n}\n\n\n// user chat\n\n.user-chat {\n    background: url(\"../../images/chat-bg-pattern.png\");\n    transition: all 0.4s;\n    position: relative;\n    background-color: var(--#{$prefix}body-bg);\n\n    @media (max-width: 991.98px) {\n        position: absolute;\n        left: 0;\n        top: 3px;\n        width: 100%;\n        height: calc(100% - 3px);\n        visibility: hidden;\n        transform: translateX(100%);\n        z-index: 99;\n        padding-top: 70px;\n\n        &.user-chat-show{\n            visibility: visible;\n            transform: translateX(0);\n        }\n    }\n\n    .chat-content{\n        position: relative;\n    }\n\n    &.user-chat-show{\n        .chat-welcome-section{\n            display: none;\n        }\n        .chat-content{\n            @media (min-width: 992px) {\n                display: flex !important;\n            }\n        }\n    }\n}\n\n.user-chat-topbar{\n    border-bottom: 1px solid transparent;\n    background-color: var(--#{$prefix}secondary-bg);\n    @media (max-width: 991.98px) {\n        position: fixed;\n        left: 0;\n        right: 0;\n        top: 0;\n        z-index: 1;\n    }\n}\n\n\n.user-chat-nav {\n    .nav-btn {\n        height: 40px;\n        width: 40px;\n        line-height: 40px;\n        box-shadow: none;\n        padding: 0;\n        font-size: 20px;\n        color: $gray-800;\n    }\n    @media (max-width:575.98px) {\n        display: flex;\n        justify-content: flex-end;\n    }\n}\n\n\n.chat-conversation {\n    height: calc(100vh - 299px);\n    @media (max-width: 991.98px) {\n        height: calc(100vh - 275px);\n    }\n\n    .simplebar-content-wrapper{\n        display: flex;\n        flex-direction: column;\n\n        .simplebar-content{\n            margin-top: auto;\n        }\n    }\n\n    .chat-conversation-list{\n        padding-top: 10px;\n        margin-bottom: 0;\n        > li{\n            display: flex;\n        }\n    }\n\n    li {\n        &:last-of-type {\n            .conversation-list {\n                margin-bottom: 0;\n            }\n        }\n    }\n\n    .chat-list{\n\n        &.left{\n            .check-message-icon{\n                display: none;\n            }\n        }\n        .message-box-drop {\n            visibility: hidden;\n        }\n\n        &:hover {\n            .message-box-drop {\n                visibility: visible;\n            }\n        }\n    }\n\n    .chat-avatar {\n        margin: 0 16px 0 0/*rtl:0 0 0 16px*/;\n        \n        img {\n            width: 28px;\n            height: 28px;\n            border-radius: 50%;\n        }\n    }\n\n    .chat-day-title {\n        position: relative;\n        text-align: center;\n        margin-bottom: 24px;\n        margin-top: 12px;\n        width: 100%;\n\n        .title {\n            background-color: $white;\n            position: relative;\n            font-size: 13px;\n            z-index: 1;\n            padding: 6px 12px;\n            border-radius: 5px;\n        }\n\n        &:before {\n            content: \"\";\n            position: absolute;\n            width: 100%;\n            height: 1px;\n            left: 0;\n            right: 0;\n            background-color: rgba($primary, 0.2);\n            top: 10px;\n        }\n\n        .badge {\n            font-size: 12px;\n        }\n    }\n\n    .conversation-list {\n        margin-bottom: 24px;\n        display: inline-flex;\n        position: relative;\n        align-items: flex-end;\n        max-width: 80%;\n\n        @media (max-width: 575.98px) {\n            max-width: 90%;\n        }\n\n        .ctext-wrap {\n            display: flex;\n            margin-bottom: 10px;\n        }\n\n        .ctext-content{\n            word-wrap: break-word;\n            word-break: break-word;\n        }\n\n        .ctext-wrap-content {\n            padding: 12px 20px;\n            background-color: $chat-primary-bg;\n            position: relative;\n            border-radius: 3px;\n            box-shadow: $box-shadow-lg;\n\n            .attached-file{\n                @media (max-width: 575.98px) {\n                    .attached-file-avatar{\n                        display: none;\n                    }\n\n                    .dropdown .dropdown-toggle{\n                        display: block;\n                    }\n                }\n            }\n        }\n\n        .conversation-name {\n            font-weight: $font-weight-medium;\n            display: flex;\n            flex-wrap: wrap;\n            align-items: center;\n            gap: 8px;\n        }\n\n        .dropdown {\n            .dropdown-toggle {\n                font-size: 18px;\n                padding: 4px;\n                color: $gray-600;\n                &::after{\n                    display: none;\n                }\n\n                @media (max-width: 575.98px) {\n                    display: none;\n                }\n            }\n\n        }\n\n        .chat-time {\n            font-size: 12px;\n            margin-top: 4px;\n            text-align: right;\n        }\n\n        .message-img {\n            border-radius: .2rem;\n            position: relative;\n            display: flex;\n            flex-wrap: wrap;\n            gap: 8px;\n\n            .message-img-list {\n                position: relative;\n            }\n\n            img {\n                max-width: 150px;\n            }\n\n            .message-img-link {\n                position: absolute;\n                right: 10px/*rtl:auto*/;\n                left: auto/*rtl:0*/;\n                bottom: 10px;\n\n                li {\n                    >a {\n                        font-size: 18px;\n                        color: $white;\n                        display: inline-block;\n                        line-height: 20px;\n                        width: 26px;\n                        height: 24px;\n                        border-radius: 3px;\n                        background-color: rgba($dark,0.7);\n                        text-align: center;\n                    }\n                }\n            }\n        }\n    }\n\n    .right {\n        justify-content: flex-end;\n\n        .chat-avatar {\n            order: 3;\n            margin-right: 0px;\n            margin-left: 16px;\n        }\n\n        .chat-time {\n            text-align: left;\n            color: $gray-600;\n        }\n\n        .conversation-list {\n            text-align: right;\n\n            .ctext-wrap {\n                justify-content: flex-end;\n\n                .ctext-wrap-content {\n                    order: 2;\n                    background-color: $chat-secondary-bg;\n                    color: $chat-secondary-color;\n                    text-align: right;\n                    box-shadow: $element-shadow;\n\n                    .replymessage-block{\n                        background-color: rgba($white,0.5);\n                        border-color: rgba(var(--vz-success-rgb), 1);\n                        color: $body-color;\n        \n                        .conversation-name{\n                            color: rgba(var(--vz-success-rgb), 1);\n                        }\n                    }\n                }\n            }\n\n            .conversation-name {\n                justify-content: flex-end;\n\n                .check-message-icon{\n                    order: 1;\n                }\n\n                .time{\n                    order: 2;\n                }\n\n                .name{\n                    order: 3;\n                }\n            }\n\n            .dropdown {\n                order: 1;\n            }\n        }\n\n        .dot {\n            background-color: $dark;\n        }\n    }\n}\n\n.chat-input-section{\n    border-top: 1px solid transparent;\n    background-color: var(--#{$prefix}secondary-bg);\n    position: relative;\n    z-index: 1;\n\n    .chat-input-feedback {\n        display: none;\n        position: absolute;\n        top: -20px;\n        left: 4px;\n        font-size: 12px;\n        color: $danger;\n    }\n    .show{\n        display: block;\n    }\n}\n\n.chat-input-links{\n    display: flex;\n    .links-list-item{\n        > .btn{\n            box-shadow: none;\n            padding: 0;\n            font-size: 20px;\n            width: 37.5px;\n            height: 37.5px;\n            &.btn-link{\n                color: $gray-600;\n            }\n        }\n        \n    }\n}\n\n//Copy Message Alert\n.copyclipboard-alert{\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    transform:translateX(-50%);\n    display: none;\n}\n\n.replyCard{\n    position: absolute;\n    left: 0;\n    right: 0;\n    border-top: 1px solid var(--#{$prefix}border-color);\n    overflow: hidden;\n    opacity: 0;\n    bottom: 0;\n    border-radius: 0;\n    transition: all 0.4s;\n\n    @media (max-width: 991.98px) {\n        bottom: -12px;\n    }\n\n    &.show{\n        transform: translateY(-88px);\n        opacity: 1;\n\n        @media (max-width: 991.98px) {\n            transform: translateY(-83px);\n        }\n    }\n}\n\n.replymessage-block{\n    padding: 12px 20px;\n    margin-bottom: 8px;\n    text-align: left;\n    border-radius: 4px;\n    background-color: rgba(var(--#{$prefix}success-rgb), 0.1);\n    border-left: 2px solid rgba(var(--#{$prefix}success-rgb), 1);\n\n    .conversation-name{\n        color: rgba(var(--#{$prefix}success-rgb), 1);\n        font-size: 14px;\n    }\n}\n\n\n// Chat Small\n.chat-sm {\n    .ctext-wrap-content {\n        box-shadow: none !important;\n    }\n\n    .message-img {\n        img {\n            max-width: 90px !important;\n        }\n    }\n\n    .message-img-link {\n        bottom: 0 !important;\n        right: 5px !important;\n    }\n}\n\n// for horizontal layout\n[data-layout=\"horizontal\"]{\n    .chat-wrapper{\n        @media (min-width: 1025px) {\n            margin-left: 0 !important;\n            margin-right: 0 !important;\n        }\n        @media (max-width: 991.98px) {\n            margin-top: 0 !important;\n        }\n    }\n\n    .chat-leftsidebar{\n        height: calc(100vh - #{$header-height} - #{$footer-height} - 54px);\n        @media (max-width: 991.98px) {\n            height: calc(100vh - #{$header-height} - #{$footer-height} - 8px);\n        }\n    }\n\n    .chat-room-list{\n        height: calc(100vh - 352px);\n        @media (max-width: 991.98px) {\n            height: calc(100vh - 265px);\n        }\n    }\n\n    .chat-conversation{\n        height: calc(100vh - 343px);\n        @media (max-width: 991.98px) {\n            height: calc(100vh - 275px);\n        }\n    }\n}","//\n// _email.scss\n//\n\n.email-wrapper {\n    position: relative;\n    overflow-x: hidden;\n}\n\n// chat left sidebar\n\n.email-menu-sidebar {\n    height: calc(100vh - 137px);\n    position: relative;\n    background-color: var(--#{$prefix}secondary-bg);\n    transition: all 0.2s;\n\n    @media (min-width: 992px) {\n        min-width: 250px;\n        max-width: 250px;\n        height: calc(100vh - #{$header-height} - #{$footer-height} - 8px);\n    }\n\n    @media (max-width: 991.98px) {\n        position: fixed;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        width: 200px;\n        max-width: 100%;\n        z-index: 1003;\n        box-shadow: $box-shadow-lg;\n        transform: translateX(-100%);\n        visibility: hidden;\n        height: 100vh;\n\n        &.menubar-show {\n            visibility: visible;\n            transform: none;\n        }\n    }\n\n    .email-menu-sidebar-scroll {\n        height: calc(100vh - 295px);\n\n        @media (max-width: 991.98px) {\n            height: calc(100vh - 150px);\n        }\n    }\n}\n\n.mail-list {\n    a {\n        display: flex;\n        align-items: center;\n        color: $gray-600;\n        padding: 5px 0;\n        font-weight: $font-weight-medium;\n\n        &:hover {\n            color: $primary;\n        }\n\n        i {\n            font-size: 14px;\n        }\n\n        &.active {\n            color: $success;\n            font-weight: $font-weight-semibold;\n\n            i {\n                color: $success;\n            }\n        }\n    }\n}\n\n.email-chat-list{\n    a{\n        padding: 6px 24px;\n        &.active{\n            background-color: rgba(var(--#{$prefix}light-rgb), .7);\n        }\n    }\n}\n.email-topbar-link {\n    .btn-ghost-secondary {\n        color: var(--#{$prefix}secondary-color);\n\n        &:hover {\n            color: $secondary;\n        }\n    }\n}\n\n.email-content {\n    width: 100%;\n    background-color: var(--#{$prefix}secondary-bg);\n    transition: all 0.2s;\n}\n\n.unreadConversations-alert{\n    position: fixed;\n    bottom: $footer-height;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 1;\n}\n\n.email-detail-content {\n    position: relative;\n    top: 0;\n    bottom: 0;\n    left: -2px;\n    width: 0;\n    background-color: var(--#{$prefix}secondary-bg);\n    transform: translateX(200%);\n    transition: all 0.2s;\n    display: none;\n    border-left: 2px solid var(--#{$prefix}body-bg);\n}\n\n.email-detail-show {\n    .email-detail-content {\n        transform: none;\n        display: block;\n        width: 60%;\n    }\n\n    .email-content {\n            margin-right: 0;\n    }\n}\n\n.email-detail-content-scroll {\n    height: calc(100vh - 400px);\n\n    @media (max-width: 1349.98px) {\n        height: calc(100vh - 257px);\n    }\n}\n\n.message-list-content {\n    height: calc(100vh - 242px);\n\n    @media (max-width: 575.98px) {\n        height: calc(100vh - 230px);\n    }\n}\n\n.message-list {\n    display: block;\n    padding-left: 0;\n    margin: 0;\n\n    li {\n        position: relative;\n        display: block;\n        height: 50px;\n        line-height: 50px;\n        cursor: default;\n        transition-duration: .3s;\n        clear: both;\n\n        a {\n            color: var(--#{$prefix}heading-color);\n        }\n\n        &:hover {\n            background: var(--#{$prefix}light);\n            transition-duration: .05s;\n        }\n\n        .col-mail {\n            float: left;\n            position: relative;\n        }\n\n        .col-mail-1 {\n            width: 280px;\n\n            .star-toggle,\n            .checkbox-wrapper-mail,\n            .dot {\n                display: block;\n                float: left;\n            }\n\n            .dot {\n                border: 4px solid transparent;\n                border-radius: 100px;\n                margin: 22px 26px 0;\n                height: 0;\n                width: 0;\n                line-height: 0;\n                font-size: 0;\n            }\n\n            .checkbox-wrapper-mail {\n                margin: 15px 0 0 20px;\n                line-height: normal;\n            }\n\n            .star-toggle {\n                margin-top: 18px;\n                margin-left: 5px;\n            }\n\n            .title {\n                position: absolute;\n                top: 0;\n                left: 95px;\n                right: 0;\n                text-overflow: ellipsis;\n                overflow: hidden;\n                white-space: nowrap;\n                margin-bottom: 0;\n\n                @media (max-width: 575.98px) {\n                    left: 95px;\n                }\n            }\n        }\n\n        .col-mail-2 {\n            position: absolute;\n            top: 0;\n            left: 280px;\n            right: 0;\n            bottom: 0;\n\n            .subject,\n            .date {\n                position: absolute;\n                top: 0;\n            }\n\n            .subject {\n                left: 0;\n                right: 110px;\n                text-overflow: ellipsis;\n                overflow: hidden;\n                white-space: nowrap;\n\n                .teaser{\n                    color: var(--#{$prefix}secondary-color);\n                }\n            }\n\n            .date {\n                right: 0;\n                width: 100px;\n                padding-left: 20px;\n            }\n        }\n\n        &.active,\n        &.active:hover {\n            box-shadow: inset 3px 0 0 $primary;\n            background-color: var(--#{$prefix}light);\n        }\n\n\n        &.unread {\n            color: var(--#{$prefix}body-color);\n\n            a {\n                color: var(--#{$prefix}body-color);\n                font-weight: $font-weight-semibold;\n            }\n        }\n    }\n}\n\n#unreadConversations, #email-topbar-actions{\n    display: none;\n}\n\n#elmLoader{\n    display: flex;\n    width: 100%;\n    justify-content: center;\n    align-items: center; \n    position: absolute; \n    left: 0; \n    top: 0; \n    bottom: 0;\n}\n\n.email-compose-input {\n    padding-right: 80px;\n}\n\n@media (max-width: 1349.98px) {\n    .email-detail-content {\n        display: block;\n        position: fixed;\n        top: 0;\n        bottom: 0;\n        left: auto;\n        right: 0;\n        width: 400px;\n        max-width: 100%;\n        z-index: 1003;\n        box-shadow: $box-shadow-lg;\n        transform: translateX(100%);\n        visibility: hidden;\n    }\n\n    .email-detail-show {\n        .email-detail-content {\n            width: 400px;\n            transform: none;\n            visibility: visible;\n        }\n    }\n}\n\n\n@media (max-width: 575.98px) {\n    .message-list li .col-mail-1 {\n        width: 180px;\n    }\n}\n\n.email-editor {\n    .ck-editor__editable_inline {\n        min-height: 200px !important;\n    }\n}\n\n.email-chat-detail{\n    width: 350px;\n    position: fixed;\n    max-width: 100%;\n    bottom: $footer-height;\n    right: $footer-height;\n    z-index: 9;\n    display: none;\n    .card{\n        box-shadow: $box-shadow-lg;\n    }\n\n    @media (max-width: 515.98px) {\n        left: 16px;\n        right: 16px;\n    }\n}\n\n.message-list-scroll{\n    position: relative;\n    overflow-y: auto;\n    &::-webkit-scrollbar {\n        -webkit-appearance: none;\n    }\n\n    &::-webkit-scrollbar:vertical {\n        width: 12px;\n    }\n\n    &::-webkit-scrollbar:horizontal {\n        height: 12px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: rgba(var(--#{$prefix}body-color-rgb), .075);\n        border-radius: 10px;\n        border: 2px solid var(--#{$prefix}secondary-bg);\n    }\n\n    &::-webkit-scrollbar-track {\n        border-radius: 10px;\n        background-color: var(--#{$prefix}secondary-bg);\n    }\n}\n\n// for horizontal layout\n[data-layout=\"horizontal\"]{\n    .email-wrapper{\n        @media (min-width: 1025px) {\n            margin-left: 0 !important;\n            margin-right: 0 !important;\n        }\n        @media (max-width: 991.98px) {\n            margin-top: 0 !important;\n        }\n    }\n\n    .email-menu-sidebar{\n        height: calc(100vh - #{$header-height} - #{$footer-height} - 54px);\n        @media (max-width: 991.98px) {\n            height: 100vh\n        }\n        .email-menu-sidebar-scroll{\n            height: calc(100vh - 330px);\n            @media (max-width: 991.98px) {\n                height: calc(100vh - 150px)\n            }\n        }\n    }\n    \n    .message-list-content {\n        height: calc(100vh - 289px);\n        \n    }\n\n    .email-detail-content-scroll{\n        height: calc(100vh - 435px);\n        @media (max-width: 1349.98px){\n            height: calc(100vh - 252px);\n        }\n    }\n}\n","//\n// _kanban.scss\n//\n\n.tasks-board {\n    display: flex;\n    overflow-x: auto;\n    align-items: stretch;\n\n    .tasks-list {\n        min-width: 300px;\n        margin-right: 24px;\n    }\n\n    &::-webkit-scrollbar {\n        -webkit-appearance: none;\n    }\n\n    &::-webkit-scrollbar:vertical {\n        width: 10px;\n    }\n\n    &::-webkit-scrollbar:horizontal {\n        height: 8px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: rgba(var(--#{$prefix}dark-rgb), .075);\n        border-radius: 8px;\n    }\n\n    &::-webkit-scrollbar-track {\n        border-radius: 8px;\n    }\n}\n\n.tasks-box {\n    .progress {\n        border-radius: 0px 0px $card-border-radius $card-border-radius;\n    }\n\n    .tasks-img {\n        height: 135px;\n        width: 100%;\n        object-fit: cover;\n        object-position: center;\n        margin: 12px 0px;\n    }\n\n    &:last-child {\n        margin-bottom: 0px;\n    }\n}\n\n.tasks-wrapper {\n    max-height: calc(100vh - 418px);\n}\n\n\n.tasks {\n    min-height: 180px;\n    position: relative;\n\n    &.noTask{\n        &::before {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        height: 180px;\n        width: 270px;\n        margin: 0 auto;\n        background-image: url('../../images/file.png');\n        background-size: cover;\n        background-position: center;\n    }\n    }\n}\n\n#tasksList {\n    tr {\n        .tasks-list-menu {\n            opacity: 0;\n        }\n\n        &:hover {\n            .tasks-list-menu {\n                opacity: 1;\n            }\n        }\n    }\n}","//\n// _landing.scss\n//\n\n.layout-wrapper {\n    &.landing {\n        background-color: var(--#{$prefix}secondary-bg);\n        font-size: 15px;\n    }\n}\n\n.navbar-show{\n    .vertical-overlay{\n        display: block;\n    }\n}\n\n// helper\n\n.section {\n    padding: 90px 0;\n    position: relative;\n\n    @media (max-width:767.98px) {\n        padding: 50px 0;\n    }\n}\n\n.icon-effect {\n    position: relative;\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        width: 24px;\n        height: 24px;\n        background-color: rgba($success, 0.2);\n        border-radius: 50%;\n        bottom: 0;\n        left: 0 !important;\n    }\n}\n\n// navbar\n\n.navbar-landing {\n    padding: 10px 0px;\n    transition: all 0.5s ease;\n    @media (max-width: 991.98px) {\n        background-color: var(--#{$prefix}secondary-bg);\n        box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);\n        padding: 10px 8px;\n    }\n\n    .navbar-nav {\n        .nav-item {\n            .nav-link {\n                font-size: 16px;\n                font-weight: $font-weight-medium;\n                transition: all 0.4s;\n                font-family: $font-family-secondary;\n                color: var(--#{$prefix}body-color);\n                padding: 14px;\n\n                @media (max-width: 991.98px) {\n                    padding: 8px 0px;\n                }\n\n                &:hover,\n                &.active,\n                &:focus {\n                    color: $success !important;\n                }\n            }\n        }\n    }\n\n    &.is-sticky {\n        background-color: var(--#{$prefix}secondary-bg);\n        box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);\n    }\n}\n\n//navbar-light\n.navbar-light{\n    .navbar-brand {\n        .card-logo-dark {\n            display: none;\n        }\n    \n        .card-logo-light {\n            display: block;\n        }\n    }\n    .navbar-nav {\n        .nav-item {\n            .nav-link {\n                color: rgba(var(--#{$prefix}white-rgb), 0.75);\n            }\n        }\n    }\n    &.is-sticky {\n        .navbar-nav {\n            .nav-item {\n                .nav-link {\n                    color: var(--#{$prefix}body-color);\n                }\n            }\n        }\n        .navbar-brand {\n            .card-logo-dark {\n                display: block;\n            }\n        \n            .card-logo-light {\n                display: none;\n            }\n        }\n    }\n}\n\n// hero section\n\n.hero-section {\n    background-color: rgba(var(--#{$prefix}light-rgb), 0.5);\n\n    .hero-shape-svg {\n        svg {\n            path {\n                fill: var(--#{$prefix}secondary-bg);\n            }\n        }\n    }\n}\n\n.bg-overlay-pattern {\n    background-image: url(\"../../images/landing/bg-pattern.png\");\n    background-color: transparent;\n    background-position: center;\n    background-size: cover;\n    opacity: 0.2;\n}\n\n.demo-carousel {\n    position: relative;\n    z-index: 1;\n\n    .carousel-item {\n        .demo-item {\n            background-color: var(--#{$prefix}secondary-bg);\n            padding: 8px;\n            border-radius: 7px;\n        }\n    }\n\n    .demo-img-patten-top {\n        position: absolute;\n        right: -50px;\n        top: -16px;\n        max-width: 230px;\n    }\n\n    .demo-img-patten-bottom {\n        position: absolute;\n        left: -70px;\n        bottom: -50px;\n        max-width: 230px;\n    }\n}\n\n// client images\n.client-images img {\n    max-height: 45px;\n    width: auto;\n    margin: 12px auto;\n    transition: all .4s;\n}\n\n// plan\n\n.plan-box {\n    max-width: 356px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n// work process\n.process-card {\n    position: relative;\n\n    .process-arrow-img {\n        position: absolute;\n        left: 75%;\n        top: 7%;\n        width: 50%;\n        opacity: .1;\n    }\n}\n\n.custom-footer {\n    color: #9ba7b3;\n}\n\n.footer-list {\n    li {\n        a {\n            color: #9ba7b3;\n            padding: 7px 0;\n            display: block;\n            transition: all 0.3s ease-in-out;\n\n            &:hover {\n                color: rgba($white, 0.9);\n            }\n        }\n    }\n}\n\n.footer-social-link {\n    .avatar-title {\n        color: #778089;\n        background-color: rgba($white, 0.05);\n        transition: all 0.3s ease;\n\n        &:hover {\n            color: $white;\n            background-color: $primary;\n        }\n    }\n}\n\n#back-to-top {\n    &.landing-back-top {\n        bottom: 35px;\n    }\n}\n\n// dark\n\n[data-bs-theme=\"dark\"] {\n    .layout-wrapper.landing {\n\n        .demo-img-patten-top,\n        .demo-img-patten-bottom {\n            opacity: .2;\n        }\n\n        footer.bg-dark {\n            background-color: var(--#{$prefix}secondary-bg) !important;\n        }\n    }\n\n    //navbar-light\n    .navbar-light{\n        &.is-sticky { \n            .navbar-brand {\n                .card-logo-dark {\n                    display: none;\n                }\n        \n                .card-logo-light {\n                    display: block;\n                }\n            }\n        }\n    }\n}","//\n// _nft-landing.scss\n//\n\n.bookmark-icon {\n    .btn {\n        color: var(--#{$prefix}secondary-color);\n        background-color: var(--#{$prefix}light) !important;\n        box-shadow: $box-shadow;\n        font-size: $font-size-base;\n        &:hover,\n        &.active {\n            border-color: transparent;\n            color: $danger;\n        }\n    }\n}\n\n.explore-box {\n    border-radius: 9px;\n    overflow: hidden;\n    .explore-img {\n        height: 280px;\n        object-fit: cover;\n    }\n    .explore-place-bid-img {\n        position: relative;\n        overflow: hidden;\n        z-index: 0;\n        .bg-overlay {\n            position: absolute;\n            right: 0;\n            left: 0;\n            top: 0;\n            bottom: 0;\n            background-color: rgba($dark, 0.4);\n            opacity: 0;\n            transition: all 0.5s ease;\n        }\n    \n        .place-bid-btn {\n            top: 50%;\n            position: absolute;\n            left: 50%;\n            transform: translate(-50%, -50%);\n    \n            .btn {\n                opacity: 0;\n                bottom: -25px;\n                transition: 0.5s ease;\n            }\n        }\n    }\n    \n    &:hover {\n        .explore-place-bid-img {\n            .place-bid-btn {\n                .btn {\n                    opacity: 1;\n                    bottom: 0;\n                }\n            }\n    \n            .bg-overlay {\n                opacity: 1;\n            }\n        }\n    }\n    .discount-time {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        text-align: center;\n        background-color: rgba($white, 0.4);\n        backdrop-filter: blur(5px);\n        padding: 8px;\n    }\n}\n\n//\n.nft-hero {\n    background-image: url('../../images/nft/bg-home.jpg');\n    background-size: cover;\n    background-position: bottom;\n    padding: 222px 0 150px 0;\n    .bg-overlay {\n        background-color: #05175f;\n        opacity: 0.85;\n    }\n}\n\n#explorecard-list {\n    .list-element {\n        display: none;\n\n        &:nth-child(-n+10) {\n            display: block;\n        }\n    }\n}","//\n// _file-manager.scss\n//\n\n.file-manager-menu {\n    max-height: calc(100vh - 296px);\n\n    @media (max-width: 991.98px) {\n        height: calc(100vh - 296px);\n    }\n\n    li {\n        padding: 5px 0px;\n\n        a {\n            color: var(--#{$prefix}body-color);\n            font-weight: $font-weight-medium;\n            transition: all 0.5s ease;\n\n            &.active,\n            &:hover,\n            &[aria-expanded=\"true\"]{\n                color: $success;\n            }\n        }\n\n        .sub-menu {\n            li {\n                padding-left: 25px;\n                position: relative;\n\n                &::before {\n                    content: \"\\f0374\";\n                    position: absolute;\n                    left: 0px;\n                    font-family: Material Design Icons;\n                    color: rgba(var(--#{$prefix}dark-rgb), 0.4);\n                }\n            }\n        }\n    }\n}\n\n.file-manager-sidebar {\n    position: relative;\n    background-color: var(--#{$prefix}secondary-bg);\n\n    @media (min-width: 992px) {\n        min-width: 300px;\n        max-width: 300px;\n        height: calc(100vh - #{$header-height} - #{$footer-height} - 8px);\n    }\n\n    @media (max-width: 991.98px) {\n        position: fixed;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        width: 200px;\n        max-width: 100%;\n        z-index: 1003;\n        box-shadow: $box-shadow-lg;\n        transform: translateX(-100%);\n        visibility: hidden;\n        height: 100vh;\n\n        &.menubar-show {\n            visibility: visible;\n            transform: none;\n        }\n    }\n}\n\n.file-menu-sidebar-scroll{\n    height: calc(100vh - 375px);\n    @media (max-width: 991.98px) {\n        height: calc(100vh - 190px);\n    }\n}\n\n.file-manager-content {\n    background-color: var(--#{$prefix}secondary-bg);\n}\n\n.file-manager-content-scroll{\n    height: calc(100vh - 185px);\n    @media (max-width: 991.98px) {\n        height: calc(100vh - 144px);\n    }\n\n    .simplebar-content{\n        height: 100%;\n    }\n}\n\n.file-detail-content-scroll{\n    height: calc(100vh - 180px);\n    @media (max-width: 991.98px) {\n        height: 100vh;\n    }\n\n    .simplebar-content{\n        height: 100%;\n    }\n}\n\n.file-manager-detail-content {\n    width: 32%;\n    max-width: 100%;\n    background-color: var(--#{$prefix}secondary-bg);\n    display: none;\n}\n\n.file-detail-show{\n    .file-manager-detail-content{\n        display: block;\n    }\n}\n\n#file-overview{\n    display: none;\n}\n\n@media (max-width: 1399.98px) {\n    .file-manager-detail-content {\n        position: fixed;\n        top: 0;\n        bottom: 0;\n        left: auto;\n        right: 0;\n        width: 400px;\n        max-width: 100%;\n        z-index: 1003;\n        box-shadow: $box-shadow-lg;\n        transform: translateX(100%);\n    }\n\n    .file-detail-show {\n        .file-manager-detail-content {\n            transform: none;\n        }\n    }\n}\n\n.file-details-box {\n    height: 195px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}","//\n// _to-do.scss\n//\n\n.to-do-menu {\n    li {\n        .nav-link {\n            color: var(--#{$prefix}body-color);\n            padding-left: 0;\n            font-weight: $font-weight-medium;\n            background-color: var(--#{$prefix}light);\n            padding: 10px 12px;\n            border-radius: 4px;\n            display: block;\n            margin-bottom: 8px;\n            &:hover, &.active {\n                color: $success;\n            }\n        }\n    }\n}\n\n.todo-content {\n    height: calc(100vh - 362px);\n    overflow-y: auto;\n    &::-webkit-scrollbar {\n        -webkit-appearance: none;\n    }\n\n    &::-webkit-scrollbar:vertical {\n        width: 8px;\n    }\n\n    &::-webkit-scrollbar:horizontal {\n        height: 10px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: rgba(var(--#{$prefix}body-color-rgb), .075);\n        border-radius: 8px;\n    }\n\n    &::-webkit-scrollbar-track {\n        border-radius: 8px;\n    }\n}\n\n.todo-task {\n    table{\n        .form-check{\n            .form-check-input {\n                &:checked+.form-check-label {\n                    text-decoration: line-through;\n                }\n            }\n        }\n    }\n}\n\n.task-handle{\n    cursor: move;\n}\n\n#task-error-msg{\n    display: none;\n}","//\n// _invoice.scss\n//\n\n.bg-job {\n    background-image: url(../../images/new.png);\n    background-size: cover;\n    background-position: center;\n}\n\n.job-list-view-card{\n    .background {\n        height: 130px;\n    }\n}\n\n.job-list-row {\n    &.row {\n        .col-xxl-3 {\n            @media (min-width: 1400px) and (max-width: 1499.98px) {\n                width: 33%; \n            }\n        }\n    }\n}",".custom-container {\n    width: 90%;\n}\n\n//********** Navbar **********//\n.job-navbar {\n    .dropdown-menu {\n        .dropdown-item {\n            .avatar-sm {\n                height: 2.5rem;\n                width: 2.5rem;\n            }\n        }\n    }\n\n    @media (max-width: 991.98px) {\n        background-color: var(--#{$prefix}secondary-bg);\n        padding: 16px 0;\n    }\n}\n\n//********** Home **********//\n.job-hero-section {\n    position: relative;\n    padding: 165px 0;\n    overflow-x: hidden;\n}\n\n.job-panel-filter {\n    background-color: var(--#{$prefix}secondary-bg);\n    border-radius: $border-radius;\n    overflow: hidden;\n\n    .form-control {\n        height: 45px;\n        border: none;\n        border-radius: 0;\n        background-color: transparent;\n    }\n\n    .btn {\n        border-radius: 0;\n    }\n\n    input.form-control {\n        border-right: 1px solid var(--#{$prefix}border-color);\n    }\n\n    @media (max-width: 767.98px) {\n        background-color: transparent;\n\n        .form-control {\n            background-color: $white;\n            border-radius: $input-border-radius;\n        }\n\n        input.form-control {\n            border: 0;\n        }\n\n        .btn {\n            border-radius: $btn-border-radius;\n        }\n    }\n}\n\n.circle-effect {\n    position: absolute;\n    top: 0;\n    z-index: 0;\n    right: -55px;\n    margin: 0 auto;\n\n    .circle {\n        border: 1px solid var(--#{$prefix}border-color);\n        height: 240px;\n        width: 240px;\n        margin: 0 auto;\n        border-radius: 50%;\n    }\n\n    .circle2 {\n        position: absolute;\n        top: -20px;\n        right: -20px;\n        border: 1px solid var(--#{$prefix}border-color);\n        height: 280px;\n        width: 280px;\n        margin: 0 auto;\n        border-radius: 50%;\n    }\n\n    .circle3 {\n        position: absolute;\n        top: -40px;\n        right: -40px;\n        border: 1px solid var(--#{$prefix}border-color);\n        height: 320px;\n        width: 320px;\n        margin: 0 auto;\n        border-radius: 50%;\n    }\n\n    .circle4 {\n        position: absolute;\n        top: -60px;\n        right: -60px;\n        border: 1px solid var(--#{$prefix}border-color);\n        height: 360px;\n        width: 360px;\n        margin: 0 auto;\n        border-radius: 50%;\n    }\n\n    @media (max-width: 991.98px) {\n        display: none;\n    }\n}\n\n.home-img {\n    .user-img {\n        position: relative;\n        z-index: 1;\n    }\n}\n\n//********** About **********//\n.application-box,\n.feedback-box,\n.inquiry-box {\n    max-width: 240px;\n    position: absolute;\n    z-index: 2;\n    transition: all 0.5s ease;\n\n    &:hover {\n        transform: translateY(-5px);\n    }\n}\n\n.inquiry-box {\n    left: -134px;\n    top: 90px;\n\n    @media (max-width: 991.98px) {\n        left: 0;\n    }\n}\n\n.application-box {\n    bottom: 50px;\n    right: -160px;\n\n    @media (max-width: 991.98px) {\n        right: 0;\n    }\n}\n\n.feedback-box {\n    right: -50px;\n    bottom: -54px;\n\n    @media (max-width: 576.98px) {\n        right: 0;\n        bottom: 0;\n    }\n}\n\n.job-icon-effect {\n    height: 30px;\n    width: 30px;\n    position: absolute;\n    top: 0px;\n    left: -2%;\n    border-radius: 50%;\n    background: repeating-linear-gradient(-55deg, rgba($white, 0) 0.8px, $success 1.6px, $success 2px, rgba($white, 0) 3.8px, rgba($white, 0) 5px);\n    z-index: 0;\n    opacity: 0.20;\n\n    span {\n        position: relative;\n        z-index: 1;\n    }\n}\n\n.about-img-section {\n    position: relative;\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        left: 20px;\n        right: -20px;\n        top: -20px;\n        bottom: 20px;\n        border: 1px solid $info;\n        z-index: 0;\n        border-radius: $border-radius;\n\n        @media (max-width: 576.98px) {\n            right: 20px;\n            top: 20px;\n        }\n    }\n\n}\n\n.features-company-widgets {\n    position: absolute;\n    bottom: -18px;\n    right: -35px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
